// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3jPRK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _app = require("./src/App");
var _appDefault = parcelHelpers.interopDefault(_app);
(0, _reactDom.render)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {}), document.getElementById("app"));

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dom":"2ApDx","./src/App":"4sGPJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dlk8":[function(require,module,exports) {
"use strict";
module.exports = require("c4c10cbba9862d5f");

},{"c4c10cbba9862d5f":"a1JjK"}],"a1JjK":[function(require,module,exports) {
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    var React = require("593632ccebda0d3a");
    var _assign = require("810078e9315626ae");
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    exports.Fragment = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        exports.Fragment = symbolFor("react.fragment");
        REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
        REACT_PROFILER_TYPE = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        REACT_SCOPE_TYPE = symbolFor("react.scope");
        REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return "" + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || "Context";
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case exports.Fragment:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) key = "" + maybeKey;
        if (hasValidKey(config)) key = "" + config.key;
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentName(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentName(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (Array.isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (Array.isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === exports.Fragment) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    exports.jsx = jsx;
    exports.jsxs = jsxs;
})();

},{"593632ccebda0d3a":"9njXz","810078e9315626ae":"dudAz"}],"9njXz":[function(require,module,exports) {
"use strict";
module.exports = require("a569817e6ea559f6");

},{"a569817e6ea559f6":"k2cQT"}],"k2cQT":[function(require,module,exports) {
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    var _assign = require("de4e88f282317fde");
    // TODO: this is special because it gets imported during build.
    var ReactVersion = "17.0.2";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    exports.Fragment = 0xeacb;
    exports.StrictMode = 0xeacc;
    exports.Profiler = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    exports.Suspense = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        exports.Fragment = symbolFor("react.fragment");
        exports.StrictMode = symbolFor("react.strict_mode");
        exports.Profiler = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        exports.Suspense = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        REACT_SCOPE_TYPE = symbolFor("react.scope");
        REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: 0
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    /**
 * Used by act() to track whether you're inside an act() scope.
 */ var IsSomeRendererActing = {
        current: false
    };
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner,
        IsSomeRendererActing: IsSomeRendererActing,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: _assign
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return "" + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (!(typeof partialState === "object" || typeof partialState === "function" || partialState == null)) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    _assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || "Context";
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case exports.Fragment:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case exports.Profiler:
                return "Profiler";
            case exports.StrictMode:
                return "StrictMode";
            case exports.Suspense:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) key = "" + config.key;
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (!!(element === null || element === undefined)) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = _assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) key = "" + config.key;
             // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) // Explicit key
        return escape("" + element.key);
         // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (Array.isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                var childrenString = "" + children;
                throw Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). If you meant to render a collection of children, use an array instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue, calculateChangedBits) {
        if (calculateChangedBits === undefined) calculateChangedBits = null;
        else if (calculateChangedBits !== null && typeof calculateChangedBits !== "function") error("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context,
            _calculateChangedBits: context._calculateChangedBits
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            var pending = payload;
            pending._status = Pending;
            pending._result = thenable;
            thenable.then(function(moduleObject) {
                if (payload._status === Pending) {
                    var defaultExport = moduleObject.default;
                    if (defaultExport === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = defaultExport;
                }
            }, function(error) {
                if (payload._status === Pending) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
        }
        if (payload._status === Resolved) return payload._result;
        else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (render.displayName == null) render.displayName = name;
            }
        });
        return elementType;
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === exports.Fragment || type === exports.Profiler || type === REACT_DEBUG_TRACING_MODE_TYPE || type === exports.StrictMode || type === exports.Suspense || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (type.displayName == null) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (!(dispatcher !== null)) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function useContext(Context, unstable_observedBits) {
        var dispatcher = resolveDispatcher();
        if (unstable_observedBits !== undefined) error("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === "number" && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks" : "");
         // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context, unstable_observedBits);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case exports.Suspense:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentName(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (Array.isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === exports.Fragment) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    try {
        var frozenObject = Object.freeze({});
        /* eslint-disable no-new */ new Map([
            [
                frozenObject,
                null
            ]
        ]);
        new Set([
            frozenObject
        ]);
    /* eslint-enable no-new */ } catch (e) {}
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.PureComponent = PureComponent;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useEffect = useEffect;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.version = ReactVersion;
})();

},{"de4e88f282317fde":"dudAz"}],"dudAz":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"2ApDx":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}
module.exports = require("b0f0e6b9e8349dac");

},{"b0f0e6b9e8349dac":"4D1bT"}],"4D1bT":[function(require,module,exports) {
/** @license React v17.0.2
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    var React = require("6f0162e9ab224cd4");
    var _assign = require("be0a1114188e0222");
    var Scheduler = require("8ad4ca65319d28a7");
    var tracing = require("77001f729419a48");
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return "" + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    if (!React) throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var FundamentalComponent = 20;
    var ScopeComponent = 21;
    var Block = 22;
    var OffscreenComponent = 23;
    var LegacyHiddenComponent = 24;
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableFundamentalAPI = false; // Experimental Scope support.
    var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)
    var warnAboutStringRefs = false;
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var ROOT_ATTRIBUTE_NAME = "data-reactroot";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue;
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected) {
        if (!isAttributeNameSafe(name)) return;
         // If the object is an opaque reference ID, it's expected that
        // the next prop is different than the server value, so just return
        // expected
        if (isOpaqueHydratingObject(expected)) return expected;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
         // If the prop isn't in the special list, treat it as a simple attribute.
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else node.setAttribute(_attributeName, "" + value);
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
        REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
        REACT_PROFILER_TYPE = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        REACT_SCOPE_TYPE = symbolFor("react.scope");
        REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case Block:
                return describeFunctionComponentFrame(fiber.type._render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || "Context";
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentName(owner.type);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    function getIsRendering() {
        return isRendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "object":
            case "string":
            case "undefined":
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    function flattenChildren(children) {
        var content = ""; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child; // Note: we don't warn about invalid children here.
        // Instead, this is done separately below so that
        // it happens during the hydration code path too.
        });
        return content;
    }
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // This mirrors the code path above, but runs for hydration too.
        // Warn about invalid children here so that client and hydration are consistent.
        // TODO: this seems like it could cause a DEV-only throw for hydration
        // if children contains a non-element object. We should try to avoid that.
        if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
            if (child == null) return;
            if (typeof child === "string" || typeof child === "number") return;
            if (typeof child.type !== "string") return;
            if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error("Only strings and numbers are supported as <option> children.");
            }
        });
         // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    function getHostProps$1(element, props) {
        var hostProps = _assign({
            children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) hostProps.children = content;
        return hostProps;
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && isArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$2(element, props) {
        return _assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (!(defaultValue == null)) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (Array.isArray(children)) {
                    if (!(children.length <= 1)) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
    var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
    }; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === Namespaces.svg) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = _assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (!(typeof props.dangerouslySetInnerHTML === "object" && HTML in props.dangerouslySetInnerHTML)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (!(props.style == null || typeof props.style === "object")) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    function validateProperty(tagName, name) {
        if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    var IS_REPLAYED = 16;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (!(typeof restoreImpl === "function")) throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var discreteUpdatesImpl = function(fn, a, b, c, d) {
        return fn(a, b, c, d);
    };
    var flushDiscreteUpdatesImpl = function() {};
    var batchedEventUpdatesImpl = batchedUpdatesImpl;
    var isInsideEventHandler = false;
    var isBatchingEventUpdates = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(bookkeeping);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, bookkeeping);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    }
    function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isBatchingEventUpdates = true;
        try {
            return batchedEventUpdatesImpl(fn, a, b);
        } finally{
            isBatchingEventUpdates = false;
            finishEventHandler();
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
            return discreteUpdatesImpl(fn, a, b, c, d);
        } finally{
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) finishEventHandler();
        }
    }
    function flushDiscreteUpdatesIfNeeded(timeStamp) {
        if (!isInsideEventHandler) flushDiscreteUpdatesImpl();
    }
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (!(!listener || typeof listener === "function")) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== "undefined")) throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var PlacementAndUpdate = /*           */ 6;
    var Deletion = /*                     */ 8;
    var ContentReset = /*                 */ 16;
    var Callback = /*                     */ 32;
    var DidCapture = /*                   */ 64;
    var Ref = /*                          */ 128;
    var Snapshot = /*                     */ 256;
    var Passive = /*                      */ 512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.
    var PassiveUnmountPendingDev = /*     */ 8192;
    var Hydrating = /*                    */ 1024;
    var HydratingAndUpdate = /*           */ 1028; // Passive & Update & Callback & Ref & Snapshot
    var LifecycleEffectMask = /*          */ 932; // Union of all host effects
    var HostEffectMask = /*               */ 2047; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 2048;
    var ShouldCapture = /*                */ 4096;
    var ForceUpdateForLegacySuspense = /* */ 16384; // Static tags describe aspects of a fiber that are not specific to a render,
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) throw Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (!(a.alternate === b)) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (!(a.tag === HostRoot)) throw Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText) return node;
            else if (node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) return node;
            else if (node.child && node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function doesFiberContain(parentFiber, childFiber) {
        var node = childFiber;
        var parentFiberAlternate = parentFiber.alternate;
        while(node !== null){
            if (node === parentFiber || node === parentFiberAlternate) return true;
            node = node.return;
        }
        return false;
    }
    var attemptUserBlockingHydration;
    function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
    }
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
    } // Resets the replaying for this type of continuous event to no event.
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.lanePriority, function() {
                            Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                                attemptHydrationAtCurrentPriority(nearestMounted);
                            });
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn !== null) {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.
        while(queuedDiscreteEvents.length > 0){
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
                // We're still blocked.
                // Increase the priority of this boundary to unblock
                // the next discrete event.
                var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);
                if (_fiber4 !== null) attemptUserBlockingHydration(_fiber4);
                break;
            }
            var targetContainers = nextDiscreteEvent.targetContainers;
            while(targetContainers.length > 0){
                var targetContainer = targetContainers[0];
                var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);
                if (nextBlockedOn !== null) {
                    // We're still blocked. Try again later.
                    nextDiscreteEvent.blockedOn = nextBlockedOn;
                    break;
                } // This target container was successfully dispatched. Try the next.
                targetContainers.shift();
            }
            if (nextDiscreteEvent.blockedOn === null) // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
        } // Next replay any continuous events.
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var DiscreteEvent = 0;
    var UserBlockingEvent = 1;
    var ContinuousEvent = 2;
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map();
    var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
    // the code required to apply the same logic for event prioritization and that of the
    // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
    // duplication (for which there would be quite a bit). For the events that are not needed
    // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
    // array of top level events.
    // Lastly, we ignore prettier so we can keep the formatting sane.
    // prettier-ignore
    var discreteEventPairsForSimpleEventPlugin = [
        "cancel",
        "cancel",
        "click",
        "click",
        "close",
        "close",
        "contextmenu",
        "contextMenu",
        "copy",
        "copy",
        "cut",
        "cut",
        "auxclick",
        "auxClick",
        "dblclick",
        "doubleClick",
        "dragend",
        "dragEnd",
        "dragstart",
        "dragStart",
        "drop",
        "drop",
        "focusin",
        "focus",
        "focusout",
        "blur",
        "input",
        "input",
        "invalid",
        "invalid",
        "keydown",
        "keyDown",
        "keypress",
        "keyPress",
        "keyup",
        "keyUp",
        "mousedown",
        "mouseDown",
        "mouseup",
        "mouseUp",
        "paste",
        "paste",
        "pause",
        "pause",
        "play",
        "play",
        "pointercancel",
        "pointerCancel",
        "pointerdown",
        "pointerDown",
        "pointerup",
        "pointerUp",
        "ratechange",
        "rateChange",
        "reset",
        "reset",
        "seeked",
        "seeked",
        "submit",
        "submit",
        "touchcancel",
        "touchCancel",
        "touchend",
        "touchEnd",
        "touchstart",
        "touchStart",
        "volumechange",
        "volumeChange"
    ];
    var otherDiscreteEvents = [
        "change",
        "selectionchange",
        "textInput",
        "compositionstart",
        "compositionend",
        "compositionupdate"
    ];
    var userBlockingPairsForSimpleEventPlugin = [
        "drag",
        "drag",
        "dragenter",
        "dragEnter",
        "dragexit",
        "dragExit",
        "dragleave",
        "dragLeave",
        "dragover",
        "dragOver",
        "mousemove",
        "mouseMove",
        "mouseout",
        "mouseOut",
        "mouseover",
        "mouseOver",
        "pointermove",
        "pointerMove",
        "pointerout",
        "pointerOut",
        "pointerover",
        "pointerOver",
        "scroll",
        "scroll",
        "toggle",
        "toggle",
        "touchmove",
        "touchMove",
        "wheel",
        "wheel"
    ]; // prettier-ignore
    var continuousPairsForSimpleEventPlugin = [
        "abort",
        "abort",
        ANIMATION_END,
        "animationEnd",
        ANIMATION_ITERATION,
        "animationIteration",
        ANIMATION_START,
        "animationStart",
        "canplay",
        "canPlay",
        "canplaythrough",
        "canPlayThrough",
        "durationchange",
        "durationChange",
        "emptied",
        "emptied",
        "encrypted",
        "encrypted",
        "ended",
        "ended",
        "error",
        "error",
        "gotpointercapture",
        "gotPointerCapture",
        "load",
        "load",
        "loadeddata",
        "loadedData",
        "loadedmetadata",
        "loadedMetadata",
        "loadstart",
        "loadStart",
        "lostpointercapture",
        "lostPointerCapture",
        "playing",
        "playing",
        "progress",
        "progress",
        "seeking",
        "seeking",
        "stalled",
        "stalled",
        "suspend",
        "suspend",
        "timeupdate",
        "timeUpdate",
        TRANSITION_END,
        "transitionEnd",
        "waiting",
        "waiting"
    ];
    /**
 * Turns
 * ['abort', ...]
 *
 * into
 *
 * topLevelEventsToReactNames = new Map([
 *   ['abort', 'onAbort'],
 * ]);
 *
 * and registers them.
 */ function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for(var i = 0; i < eventTypes.length; i += 2){
            var topEvent = eventTypes[i];
            var event = eventTypes[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var reactName = "on" + capitalizedEvent;
            eventPriorities.set(topEvent, priority);
            topLevelEventsToReactNames.set(topEvent, reactName);
            registerTwoPhaseEvent(reactName, [
                topEvent
            ]);
        }
    }
    function setEventPriorities(eventTypes, priority) {
        for(var i = 0; i < eventTypes.length; i++)eventPriorities.set(eventTypes[i], priority);
    }
    function getEventPriorityForPluginSystem(domEventName) {
        var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.
        return priority === undefined ? ContinuousEvent : priority;
    }
    function registerSimpleEvents() {
        registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
        registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
        registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
        setEventPriorities(otherDiscreteEvents, DiscreteEvent);
    }
    var Scheduler_now = Scheduler.unstable_now;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority = 99;
    var UserBlockingPriority = 98;
    var NormalPriority = 97;
    var LowPriority = 96;
    var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority = 90;
    var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    var SyncLanePriority = 15;
    var SyncBatchedLanePriority = 14;
    var InputDiscreteHydrationLanePriority = 13;
    var InputDiscreteLanePriority = 12;
    var InputContinuousHydrationLanePriority = 11;
    var InputContinuousLanePriority = 10;
    var DefaultHydrationLanePriority = 9;
    var DefaultLanePriority = 8;
    var TransitionHydrationPriority = 7;
    var TransitionPriority = 6;
    var RetryLanePriority = 5;
    var SelectiveHydrationLanePriority = 4;
    var IdleHydrationLanePriority = 3;
    var IdleLanePriority = 2;
    var OffscreenLanePriority = 1;
    var NoLanePriority = 0;
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var SyncBatchedLane = /*                 */ 2;
    var InputDiscreteHydrationLane = /*      */ 4;
    var InputDiscreteLanes = /*                    */ 24;
    var InputContinuousHydrationLane = /*           */ 32;
    var InputContinuousLanes = /*                  */ 192;
    var DefaultHydrationLane = /*            */ 256;
    var DefaultLanes = /*                   */ 3584;
    var TransitionHydrationLane = /*                */ 4096;
    var TransitionLanes = /*                       */ 4186112;
    var RetryLanes = /*                            */ 62914560;
    var SomeRetryLane = /*                  */ 33554432;
    var SelectiveHydrationLane = /*          */ 67108864;
    var NonIdleLanes = /*                                 */ 134217727;
    var IdleHydrationLane = /*               */ 134217728;
    var IdleLanes = /*                             */ 805306368;
    var OffscreenLane = /*                   */ 1073741824;
    var NoTimestamp = -1;
    function setCurrentUpdateLanePriority(newLanePriority) {} // "Registers" used to "return" multiple values
    // Used by getHighestPriorityLanes and getNextLanes:
    var return_highestLanePriority = DefaultLanePriority;
    function getHighestPriorityLanes(lanes) {
        if ((SyncLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncLanePriority;
            return SyncLane;
        }
        if ((SyncBatchedLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncBatchedLanePriority;
            return SyncBatchedLane;
        }
        if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
            return_highestLanePriority = InputDiscreteHydrationLanePriority;
            return InputDiscreteHydrationLane;
        }
        var inputDiscreteLanes = InputDiscreteLanes & lanes;
        if (inputDiscreteLanes !== NoLanes) {
            return_highestLanePriority = InputDiscreteLanePriority;
            return inputDiscreteLanes;
        }
        if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
            return_highestLanePriority = InputContinuousHydrationLanePriority;
            return InputContinuousHydrationLane;
        }
        var inputContinuousLanes = InputContinuousLanes & lanes;
        if (inputContinuousLanes !== NoLanes) {
            return_highestLanePriority = InputContinuousLanePriority;
            return inputContinuousLanes;
        }
        if ((lanes & DefaultHydrationLane) !== NoLanes) {
            return_highestLanePriority = DefaultHydrationLanePriority;
            return DefaultHydrationLane;
        }
        var defaultLanes = DefaultLanes & lanes;
        if (defaultLanes !== NoLanes) {
            return_highestLanePriority = DefaultLanePriority;
            return defaultLanes;
        }
        if ((lanes & TransitionHydrationLane) !== NoLanes) {
            return_highestLanePriority = TransitionHydrationPriority;
            return TransitionHydrationLane;
        }
        var transitionLanes = TransitionLanes & lanes;
        if (transitionLanes !== NoLanes) {
            return_highestLanePriority = TransitionPriority;
            return transitionLanes;
        }
        var retryLanes = RetryLanes & lanes;
        if (retryLanes !== NoLanes) {
            return_highestLanePriority = RetryLanePriority;
            return retryLanes;
        }
        if (lanes & SelectiveHydrationLane) {
            return_highestLanePriority = SelectiveHydrationLanePriority;
            return SelectiveHydrationLane;
        }
        if ((lanes & IdleHydrationLane) !== NoLanes) {
            return_highestLanePriority = IdleHydrationLanePriority;
            return IdleHydrationLane;
        }
        var idleLanes = IdleLanes & lanes;
        if (idleLanes !== NoLanes) {
            return_highestLanePriority = IdleLanePriority;
            return idleLanes;
        }
        if ((OffscreenLane & lanes) !== NoLanes) {
            return_highestLanePriority = OffscreenLanePriority;
            return OffscreenLane;
        }
        error("Should have found matching lanes. This is a bug in React.");
        return_highestLanePriority = DefaultLanePriority;
        return lanes;
    }
    function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
        switch(schedulerPriorityLevel){
            case ImmediatePriority:
                return SyncLanePriority;
            case UserBlockingPriority:
                return InputContinuousLanePriority;
            case NormalPriority:
            case LowPriority:
                // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                return DefaultLanePriority;
            case IdlePriority:
                return IdleLanePriority;
            default:
                return NoLanePriority;
        }
    }
    function lanePriorityToSchedulerPriority(lanePriority) {
        switch(lanePriority){
            case SyncLanePriority:
            case SyncBatchedLanePriority:
                return ImmediatePriority;
            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
                return UserBlockingPriority;
            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
                return NormalPriority;
            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
                return IdlePriority;
            case NoLanePriority:
                return NoPriority;
            default:
                throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) {
            return_highestLanePriority = NoLanePriority;
            return NoLanes;
        }
        var nextLanes = NoLanes;
        var nextLanePriority = NoLanePriority;
        var expiredLanes = root.expiredLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Check if any work has expired.
        if (expiredLanes !== NoLanes) {
            nextLanes = expiredLanes;
            nextLanePriority = return_highestLanePriority = SyncLanePriority;
        } else {
            // Do not work on any idle work until all the non-idle work has finished,
            // even if the work is suspended.
            var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
            if (nonIdlePendingLanes !== NoLanes) {
                var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
                if (nonIdleUnblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else {
                    var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                    if (nonIdlePingedLanes !== NoLanes) {
                        nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                        nextLanePriority = return_highestLanePriority;
                    }
                }
            } else {
                // The only remaining work is Idle.
                var unblockedLanes = pendingLanes & ~suspendedLanes;
                if (unblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(unblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else if (pingedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(pingedLanes);
                    nextLanePriority = return_highestLanePriority;
                }
            }
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If there are higher priority lanes, we'll include them even if they
        // are suspended.
        nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            getHighestPriorityLanes(wipLanes);
            var wipLanePriority = return_highestLanePriority;
            if (nextLanePriority <= wipLanePriority) return wipLanes;
            else return_highestLanePriority = nextLanePriority;
        } // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        // TODO: Expiration heuristic is constant per lane, so could use a map.
        getHighestPriorityLanes(lane);
        var priority = return_highestLanePriority;
        if (priority >= InputContinuousLanePriority) // User interactions should expire slightly more quickly.
        //
        // NOTE: This is set to the corresponding constant as in Scheduler.js. When
        // we made it larger, a product metric in www regressed, suggesting there's
        // a user interaction that's being starved by a series of synchronous
        // updates. If that theory is correct, the proper solution is to fix the
        // starvation. However, this scenario supports the idea that expiration
        // times are an important safeguard when starvation does happen.
        //
        // Also note that, in the case of user input specifically, this will soon no
        // longer be an issue because we plan to make user input synchronous by
        // default (until you enter `startTransition`, of course.)
        //
        // If weren't planning to make these updates synchronous soon anyway, I
        // would probably make this number a configurable parameter.
        return currentTime + 250;
        else if (priority >= TransitionPriority) return currentTime + 5000;
        else // Anything idle priority or lower should never expire.
        return NoTimestamp;
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function returnNextLanesPriority() {
        return return_highestLanePriority;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    } // To ensure consistency across multiple updates in the same event, this should
    // be a pure function, so that it always returns the same lane for given inputs.
    function findUpdateLane(lanePriority, wipLanes) {
        switch(lanePriority){
            case NoLanePriority:
                break;
            case SyncLanePriority:
                return SyncLane;
            case SyncBatchedLanePriority:
                return SyncBatchedLane;
            case InputDiscreteLanePriority:
                var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);
                if (_lane === NoLane) // Shift to the next priority level
                return findUpdateLane(InputContinuousLanePriority, wipLanes);
                return _lane;
            case InputContinuousLanePriority:
                var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);
                if (_lane2 === NoLane) // Shift to the next priority level
                return findUpdateLane(DefaultLanePriority, wipLanes);
                return _lane2;
            case DefaultLanePriority:
                var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);
                if (_lane3 === NoLane) {
                    // If all the default lanes are already being worked on, look for a
                    // lane in the transition range.
                    _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);
                    if (_lane3 === NoLane) // All the transition lanes are taken, too. This should be very
                    // rare, but as a last resort, pick a default lane. This will have
                    // the effect of interrupting the current work-in-progress render.
                    _lane3 = pickArbitraryLane(DefaultLanes);
                }
                return _lane3;
            case TransitionPriority:
            case RetryLanePriority:
                break;
            case IdleLanePriority:
                var lane = pickArbitraryLane(IdleLanes & ~wipLanes);
                if (lane === NoLane) lane = pickArbitraryLane(IdleLanes);
                return lane;
        }
        throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findTransitionLane(wipLanes, pendingLanes) {
        // First look for lanes that are completely unclaimed, i.e. have no
        // pending work.
        var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);
        if (lane === NoLane) {
            // If all lanes have pending work, look for a lane that isn't currently
            // being worked on.
            lane = pickArbitraryLane(TransitionLanes & ~wipLanes);
            if (lane === NoLane) // If everything is being worked on, pick any lane. This has the
            // effect of interrupting the current work-in-progress.
            lane = pickArbitraryLane(TransitionLanes);
        }
        return lane;
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findRetryLane(wipLanes) {
        // This is a fork of `findUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        var lane = pickArbitraryLane(RetryLanes & ~wipLanes);
        if (lane === NoLane) lane = pickArbitraryLane(RetryLanes);
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function getLowestPriorityLane(lanes) {
        // This finds the most significant non-zero bit.
        var index = 31 - clz32(lanes);
        return index < 0 ? NoLanes : 1 << index;
    }
    function getEqualOrHigherPriorityLanes(lanes) {
        return (getLowestPriorityLane(lanes) << 1) - 1;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
        // it's not practical to try every single possible combination. We need a
        // heuristic to decide which lanes to attempt to render, and in which batches.
        // For now, we use the same heuristic as in the old ExpirationTimes model:
        // retry any lane at equal or lower priority, but don't try updates at higher
        // priority without also including the lower priority updates. This works well
        // when considering updates across different priority levels, but isn't
        // sufficient for updates within the same priority, since we want to treat
        // those updates as parallel.
        // Unsuspend any update at equal or lower priority.
        var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111
        root.suspendedLanes &= higherPriorityLanes;
        root.pingedLanes &= higherPriorityLanes;
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markDiscreteUpdatesExpired(root) {
        root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
    }
    function hasDiscreteLanes(lanes) {
        return (lanes & InputDiscreteLanes) !== NoLanes;
    }
    function markRootMutableRead(root, updateLane) {
        root.mutableReadLanes |= updateLane & root.pendingLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = entangledLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(lanes) {
        if (lanes === 0) return 32;
        return 31 - (log(lanes) / LN2 | 0) | 0;
    }
    // Intentionally not named imports because Rollup would use dynamic dispatch for
    var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriorityForPluginSystem(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEvent:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case UserBlockingEvent:
                listenerWrapper = dispatchUserBlockingUpdate;
                break;
            case ContinuousEvent:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
    }
    function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        var allowReplay = true;
        // TODO: replaying capture phase events is currently broken
        // because we used to do it during top-level native bubble handlers
        // but now we use different bubble and capture handlers.
        // In eager mode, we attach capture listeners early, so we need
        // to filter them out until we fix the logic to handle them correctly.
        // This could've been outside the flag but I put it inside to reduce risk.
        allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
        if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
            // If we already have a queue of discrete events, and this is another discrete
            // event, then we can't dispatch it regardless of its target, since they
            // need to dispatch in order.
            queueDiscreteEvent(null, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            return;
        }
        var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            // We successfully dispatched this event.
            if (allowReplay) clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (allowReplay) {
            if (isReplayableDiscreteEvent(domEventName)) {
                // This this to be replayed later once the target is available.
                queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
                return;
            }
            if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) return;
             // We need to clear only if we didn't queue because
            // queueing is accummulative.
            clearIfContinuousEvent(domEventName, nativeEvent);
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.
    function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.
        return null;
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        _assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = _assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = _assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = _assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = _assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = _assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = _assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = _assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = _assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = _assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = _assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = _assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = _assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't forsee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (rootContainerElement[listeningMarker]) // Performance optimization: don't iterate through events
        // for the same portal container or root node more than once.
        // TODO: once we remove the flag, we may be able to also
        // remove some of the bookkeeping maps used for laziness.
        return;
        rootContainerElement[listeningMarker] = true;
        allNativeEvents.forEach(function(domEventName) {
            if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement, null);
            listenToNativeEvent(domEventName, true, rootContainerElement, null);
        });
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
        var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var target = rootContainerElement; // selectionchange needs to be attached to the document
        // otherwise it won't capture incoming events that are only
        // triggered on the document directly.
        if (domEventName === "selectionchange" && rootContainerElement.nodeType !== DOCUMENT_NODE) target = rootContainerElement.ownerDocument;
         // If the event can be delegated (or is capture phase), we can
        // register it to the root container. Otherwise, we should
        // register the event to the target element and mark it as
        // a non-delegated event.
        if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
            // For all non-delegated events, apart from scroll, we attach
            // their event listeners to the respective elements that their
            // events fire on. That means we can skip this step, as event
            // listener has already been added previously. However, we
            // special case the scroll event because the reality is that any
            // element can scroll.
            // TODO: ideally, we'd eventually apply the same logic to all
            // events from the nonDelegatedEvents list. Then we can remove
            // this special case and use the same logic for all events.
            if (domEventName !== "scroll") return;
            eventSystemFlags |= IS_NON_DELEGATED;
            target = targetElement;
        }
        var listenerSet = getEventListenerSet(target);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
        // we need to trap an event listener onto the target.
        if (!listenerSet.has(listenerSetKey)) {
            if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
            addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedEventUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var HTML_NAMESPACE$1 = Namespaces.html;
    var warnedUnknownTags;
    var suppressHydrationWarning;
    var validatePropertiesInDevelopment;
    var warnForTextDifference;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeMarkupForTextOrAttribute;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    normalizeMarkupForTextOrAttribute = function(markup) {
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    };
    warnForTextDifference = function(serverText, clientText) {
        if (didWarnInvalidHydration) return;
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        didWarnInvalidHydration = true;
        error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
    };
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "option":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$3(domElement, lastRawProps);
                nextProps = getHostProps$3(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else if (typeof nextProp === "object" && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
            // In this case, call the opaque object's toString function which generates a new client
            // ID so client and server IDs match and throws to rerender.
            nextProp.toString();
            else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Built-in SSR attribute is allowed
                case "data-reactroot":
                    break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = getPropertyInfo(propKey);
                if (suppressHydrationWarning) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE$1) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE$1) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    if (nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        // $FlowFixMe - Should be inferred as not undefined.
        if (extraAttributeNames.size > 0 && !suppressHydrationWarning) // $FlowFixMe - Should be inferred as not undefined.
        warnForExtraAttributes(extraAttributeNames);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForUnmatchedText(textNode, text) {
        warnForTextDifference(textNode.nodeValue, text);
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1;
    SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function shouldAutoFocusHostComponent(type, props) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
        }
        return false;
    }
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "option" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1; // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) domElement.focus();
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            var body = container.body;
            if (body != null) body.textContent = "";
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        return diffHydratedProperties(instance, type, props, parentNamespace);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        warnForUnmatchedText(textInstance, text);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForUnmatchedText(textInstance, text);
    }
    function didNotHydrateContainerInstance(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        parentProps[SUPPRESS_HYDRATION_WARNING$1];
    }
    var clientId = 0;
    function makeClientIdInDEV(warnOnAccessInDEV) {
        var id = "r:" + (clientId++).toString(36);
        return {
            toString: function() {
                warnOnAccessInDEV();
                return id;
            },
            valueOf: function() {
                warnOnAccessInDEV();
                return id;
            }
        };
    }
    function isOpaqueHydratingObject(value) {
        return value !== null && typeof value === "object" && value.$$typeof === REACT_OPAQUE_ID_TYPE;
    }
    function makeOpaqueHydratingObject(attemptToReadValue) {
        return {
            $$typeof: REACT_OPAQUE_ID_TYPE,
            toString: attemptToReadValue,
            valueOf: attemptToReadValue
        };
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentName(type) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (!(contextStackCursor.current === emptyContextObject)) throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentName(type) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw Error((getComponentName(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentName(type) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return _assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var BlockingRoot = 1;
    var ConcurrentRoot = 2;
    var rendererID = null;
    var injectedHook = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        } // DevTools exists
        return true;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, priorityLevel) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
            else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now$1 = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority$1 = 99;
    var UserBlockingPriority$2 = 98;
    var NormalPriority$1 = 97;
    var LowPriority$1 = 96;
    var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority$1 = 90;
    var shouldYield = Scheduler_shouldYield;
    var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function() {};
    var syncQueue = null;
    var immediateQueueCallbackNode = null;
    var isFlushingSyncQueue = false;
    var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    // This will be the case for modern browsers that support `performance.now`. In
    // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
    // timestamp. In that case, subtract the module initialization time to simulate
    // the behavior of performance.now and keep our times small enough to fit
    // within 32 bits.
    // TODO: Consider lifting this into Scheduler.
    var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function() {
        return Scheduler_now$1() - initialTimeMs$1;
    };
    function getCurrentPriorityLevel() {
        switch(Scheduler_getCurrentPriorityLevel()){
            case Scheduler_ImmediatePriority:
                return ImmediatePriority$1;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority$2;
            case Scheduler_NormalPriority:
                return NormalPriority$1;
            case Scheduler_LowPriority:
                return LowPriority$1;
            case Scheduler_IdlePriority:
                return IdlePriority$1;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch(reactPriorityLevel){
            case ImmediatePriority$1:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority$2:
                return Scheduler_UserBlockingPriority;
            case NormalPriority$1:
                return Scheduler_NormalPriority;
            case LowPriority$1:
                return Scheduler_LowPriority;
            case IdlePriority$1:
                return Scheduler_IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
    }
    function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
    }
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
            syncQueue = [
                callback
            ]; // Flush the queue in the next tick, at the earliest.
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
        return fakeCallbackNode;
    }
    function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) Scheduler_cancelCallback(callbackNode);
    }
    function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
    }
    function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            try {
                var _isSync2 = true;
                var _queue = syncQueue;
                runWithPriority$1(ImmediatePriority$1, function() {
                    for(; i < _queue.length; i++){
                        var callback = _queue[i];
                        do callback = callback(_isSync2);
                        while (callback !== null);
                    }
                });
                syncQueue = null;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
            } finally{
                isFlushingSyncQueue = false;
            }
        }
    }
    // TODO: this is special because it gets imported during build.
    var ReactVersion = "17.0.2";
    var NoMode = 0;
    var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
    // tag instead
    var BlockingMode = 2;
    var ConcurrentMode = 4;
    var ProfileMode = 8;
    var DebugTracingMode = 16;
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = 0;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedup strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var MAX_SIGNED_31_BIT_INT = 1073741823;
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastContextWithAllBitsObserved = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        context._currentValue = currentValue;
    }
    function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) // No change
        return 0;
        else {
            var changedBits = typeof context._calculateChangedBits === "function" ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) error("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            return changedBits | 0;
        }
    }
    function scheduleWorkOnParentPath(parent, renderLanes) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            else break;
            node = node.return;
        }
    }
    function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            enqueueUpdate(fiber, update);
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context, observedBits) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        if (lastContextWithAllBitsObserved === context) ;
        else if (observedBits === false || observedBits === 0) ;
        else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.
            if (typeof observedBits !== "number" || observedBits === MAX_SIGNED_31_BIT_INT) {
                // Observe all updates.
                lastContextWithAllBitsObserved = context;
                resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else resolvedObservedBits = observedBits;
            var contextItem = {
                context: context,
                observedBits: resolvedObservedBits,
                next: null
            };
            if (lastContextDependency === null) {
                if (!(currentlyRenderingFiber !== null)) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem,
                    responders: null
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return context._currentValue;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        sharedQueue.pending = update;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return _assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (!(typeof callback === "function")) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {};
    var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentName(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                // Invoke the function an extra time to help detect side-effects.
                getDerivedStateFromProps(nextProps, prevState);
            } finally{
                reenableLogs();
            }
        }
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    reenableLogs();
                }
            }
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentName(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                new ctor(props, context); // eslint-disable-line no-new
            } finally{
                reenableLogs();
            }
        }
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentName(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress.type) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentName(workInProgress.type) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
             // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (!(typeof child._store === "object")) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentName(returnFiber.type) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    var isArray$1 = Array.isArray;
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (!(ownerFiber.tag === ClassComponent)) throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = inst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = inst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (!(typeof mixedRef === "string")) throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== "textarea") throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : newChild) + "). If you meant to render a collection of children, use an array instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentName(returnFiber.type) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    } // We avoid inlining this to avoid potential deopts from using try/catch.
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
             // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.
            var last = returnFiber.lastEffect;
            if (last !== null) {
                last.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            childToDelete.nextEffect = null;
            childToDelete.flags = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) // Noop.
            return lastPlacedIndex;
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags = Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags = Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags = Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            if (current !== null) {
                if (current.elementType === element.type || isCompatibleFamilyForHotReloading(current, element)) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) {
                            if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
                            return updateElement(returnFiber, oldFiber, newChild, lanes);
                        } else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === "function")) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) throw Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    switch(child.tag){
                        case Fragment:
                            if (element.type === REACT_FRAGMENT_TYPE) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var existing = useFiber(child, element.props.children);
                                existing.return = returnFiber;
                                existing._debugSource = element._source;
                                existing._debugOwner = element._owner;
                                return existing;
                            }
                            break;
                        case Block:
                        // We intentionally fallthrough here if enableBlocksAPI is not on.
                        // eslint-disable-next-lined no-fallthrough
                        default:
                            if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var _existing3 = useFiber(child, element.props);
                                _existing3.ref = coerceRef(returnFiber, child, element);
                                _existing3.return = returnFiber;
                                _existing3._debugSource = element._source;
                                _existing3._debugOwner = element._owner;
                                return _existing3;
                            }
                            break;
                    } // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            var isObject = typeof newChild === "object" && newChild !== null;
            if (isObject) switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                case REACT_PORTAL_TYPE:
                    return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
            }
            if (typeof newChild === "string" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (isArray$1(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            if (isObject) throwOnInvalidObjectType(returnFiber, newChild);
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            if (typeof newChild === "undefined" && !isUnkeyedTopLevelFragment) // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch(returnFiber.tag){
                case ClassComponent:
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) break;
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case Block:
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    throw Error((getComponentName(returnFiber.type) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
            }
             // Remaining cases are all treated as empty.
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) throw Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.
        if (props.fallback === undefined) return false;
         // Regular boundaries always capture.
        if (props.unstable_avoidThisFallback !== true) return true;
         // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.
        if (hasInvisibleParent) return false;
         // If the parent is not able to handle it, we must handle it.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*  */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Layout = /*    */ 2;
    var Passive$1 = /*   */ 4;
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false;
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
    }
    function deleteHydratableInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.
        if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
        } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableContainerInstance(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableContainerTextInstance(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableSuspenseInstance(parentType, parentProps);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    return true;
                }
                return false;
            case SuspenseComponent:
                return false;
            default:
                return false;
        }
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
            }
        }
        return shouldUpdate;
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.
        if (fiber.tag !== HostComponent || type !== "head" && type !== "body" && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while(nextInstance){
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
    }
    function getIsHydrating() {
        return isHydrating;
    }
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    var rendererSigil$1;
    // Used to detect multiple renderers using the same mutable source.
    rendererSigil$1 = {};
    function markSourceAsDirty(mutableSource) {
        workInProgressSources.push(mutableSource);
    }
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    function getWorkInProgressVersion(mutableSource) {
        return mutableSource._workInProgressVersionPrimary;
    }
    function setWorkInProgressVersion(mutableSource, version) {
        mutableSource._workInProgressVersionPrimary = version;
        workInProgressSources.push(mutableSource);
    }
    function warnAboutMultipleRenderersDEV(mutableSource) {
        if (mutableSource._currentPrimaryRenderer == null) mutableSource._currentPrimaryRenderer = rendererSigil$1;
        else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) error("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
    } // Eager reads the version of a mutable source and stores it on the root.
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnAboutUseOpaqueIdentifier;
    didWarnAboutUseOpaqueIdentifier = {};
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !Array.isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentName(currentlyRenderingFiber$1.type);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) throw Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        eagerReducer: update.eagerReducer,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            eagerReducer: update.eagerReducer,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.eagerReducer === reducer) // If this update was processed eagerly, and its reducer matches the
                    // current reducer, we can use the eagerly computed state.
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
        warnAboutMultipleRenderersDEV(source);
        var getVersion = source._getVersion;
        var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?
        var isSafeToReadFromSource = false; // Check the version first.
        // If this render has already been started with a specific version,
        // we can use it alone to determine if we can safely read from the source.
        var currentRenderVersion = getWorkInProgressVersion(source);
        if (currentRenderVersion !== null) // It's safe to read if the store hasn't been mutated since the last time
        // we read something.
        isSafeToReadFromSource = currentRenderVersion === version;
        else {
            // If there's no version, then this is the first time we've read from the
            // source during the current render pass, so we need to do a bit more work.
            // What we need to determine is if there are any hooks that already
            // subscribed to the source, and if so, whether there are any pending
            // mutations that haven't been synchronized yet.
            //
            // If there are no pending mutations, then `root.mutableReadLanes` will be
            // empty, and we know we can safely read.
            //
            // If there *are* pending mutations, we may still be able to safely read
            // if the currently rendering lanes are inclusive of the pending mutation
            // lanes, since that guarantees that the value we're about to read from
            // the source is consistent with the values that we read during the most
            // recent mutation.
            isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);
            if (isSafeToReadFromSource) // If it's safe to read from this source during the current render,
            // store the version in case other components read from it.
            // A changed version number will let those components know to throw and restart the render.
            setWorkInProgressVersion(source, version);
        }
        if (isSafeToReadFromSource) {
            var snapshot = getSnapshot(source._source);
            if (typeof snapshot === "function") error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
            return snapshot;
        } else {
            // This handles the special case of a mutable source being shared between renderers.
            // In that case, if the source is mutated between the first and second renderer,
            // The second renderer don't know that it needs to reset the WIP version during unwind,
            // (because the hook only marks sources as dirty if it's written to their WIP version).
            // That would cause this tear check to throw again and eventually be visible to the user.
            // We can avoid this infinite loop by explicitly marking the source as dirty.
            //
            // This can lead to tearing in the first renderer when it resumes,
            // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
            markSourceAsDirty(source);
            throw Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
        }
    }
    function useMutableSource(hook, source, getSnapshot, subscribe) {
        var root = getWorkInProgressRoot();
        if (!(root !== null)) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        var getVersion = source._getVersion;
        var version = getVersion(source._source);
        var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const
        var _dispatcher$useState = dispatcher.useState(function() {
            return readFromUnsubcribedMutableSource(root, source, getSnapshot);
        }), currentSnapshot = _dispatcher$useState[0], setSnapshot = _dispatcher$useState[1];
        var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
        // We use it to clear the pending update queue if we have a new source.
        var stateHook = workInProgressHook;
        var memoizedState = hook.memoizedState;
        var refs = memoizedState.refs;
        var prevGetSnapshot = refs.getSnapshot;
        var prevSource = memoizedState.source;
        var prevSubscribe = memoizedState.subscribe;
        var fiber = currentlyRenderingFiber$1;
        hook.memoizedState = {
            refs: refs,
            source: source,
            subscribe: subscribe
        }; // Sync the values needed by our subscription handler after each commit.
        dispatcher.useEffect(function() {
            refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
            // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
            // handleChange() below needs to reference the dispatch function without re-subscribing,
            // so we use a ref to ensure that it always has the latest version.
            refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.
            var maybeNewVersion = getVersion(source._source);
            if (!objectIs(version, maybeNewVersion)) {
                var maybeNewSnapshot = getSnapshot(source._source);
                if (typeof maybeNewSnapshot === "function") error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
                if (!objectIs(snapshot, maybeNewSnapshot)) {
                    setSnapshot(maybeNewSnapshot);
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } // If the source mutated between render and now,
                // there may be state updates already scheduled from the old source.
                // Entangle the updates so that they render in the same batch.
                markRootEntangled(root, root.mutableReadLanes);
            }
        }, [
            getSnapshot,
            source,
            subscribe
        ]); // If we got a new source or subscribe function, re-subscribe in a passive effect.
        dispatcher.useEffect(function() {
            var handleChange = function() {
                var latestGetSnapshot = refs.getSnapshot;
                var latestSetSnapshot = refs.setSnapshot;
                try {
                    latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } catch (error) {
                    // A selector might throw after a source mutation.
                    // e.g. it might try to read from a part of the store that no longer exists.
                    // In this case we should still schedule an update with React.
                    // Worst case the selector will throw again and then an error boundary will handle it.
                    latestSetSnapshot(function() {
                        throw error;
                    });
                }
            };
            var unsubscribe = subscribe(source._source, handleChange);
            if (typeof unsubscribe !== "function") error("Mutable source subscribe function must return an unsubscribe function.");
            return unsubscribe;
        }, [
            source,
            subscribe
        ]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
        //
        // If either the source or the subscription have changed we can't can't trust the update queue.
        // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
        //
        // If the getSnapshot function changed, we also shouldn't rely on the update queue.
        // It's possible that the underlying source was mutated between the when the last "change" event fired,
        // and when the current render (with the new getSnapshot function) is processed.
        //
        // In both cases, we need to throw away pending updates (since they are no longer relevant)
        // and treat reading from the source as we do in the mount case.
        if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
            // Create a new queue and setState method,
            // So if there are interleaved updates, they get pushed to the older queue.
            // When this becomes current, the previous queue and dispatch method will be discarded,
            // including any interleaving updates that occur.
            var newQueue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: snapshot
            };
            newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
            stateHook.queue = newQueue;
            stateHook.baseQueue = null;
            snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
            stateHook.memoizedState = stateHook.baseState = snapshot;
        }
        return snapshot;
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = {
            refs: {
                getSnapshot: getSnapshot,
                setSnapshot: null
            },
            source: source,
            subscribe: subscribe
        };
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        var hook = updateWorkInProgressHook();
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
            current: initialValue
        };
        Object.seal(ref);
        hook.memoizedState = ref;
        return ref;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
        mountEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function updateDeferredValue(value) {
        var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function rerenderDeferredValue(value) {
        var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function startTransition(setPending, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function() {
            setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setPending(false);
                callback();
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        });
    }
    function mountTransition() {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
        // never changes.
        var start = startTransition.bind(null, setPending);
        mountRef(start);
        return [
            start,
            isPending
        ];
    }
    function updateTransition() {
        var _updateState2 = updateState(), isPending = _updateState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    function rerenderTransition() {
        var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function warnOnOpaqueIdentifierAccessInDEV(fiber) {
        // TODO: Should warn in effects and callbacks, too
        var name = getComponentName(fiber.type) || "Unknown";
        if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
            error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            didWarnAboutUseOpaqueIdentifier[name] = true;
        }
    }
    function mountOpaqueIdentifier() {
        var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));
        if (getIsHydrating()) {
            var didUpgrade = false;
            var fiber = currentlyRenderingFiber$1;
            var readValue = function() {
                if (!didUpgrade) {
                    // Only upgrade once. This works even inside the render phase because
                    // the update is added to a shared queue, which outlasts the
                    // in-progress render.
                    didUpgrade = true;
                    isUpdatingOpaqueValueInRenderPhase = true;
                    setId(makeId());
                    isUpdatingOpaqueValueInRenderPhase = false;
                    warnOnOpaqueIdentifierAccessInDEV(fiber);
                }
                throw Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            };
            var id = makeOpaqueHydratingObject(readValue);
            var setId = mountState(id)[1];
            if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
                currentlyRenderingFiber$1.flags |= Update | Passive;
                pushEffect(HasEffect | Passive$1, function() {
                    setId(makeId());
                }, undefined, null);
            }
            return id;
        } else {
            var _id = makeId();
            mountState(_id);
            return _id;
        }
    }
    function updateOpaqueIdentifier() {
        var id = updateState()[0];
        return id;
    }
    function rerenderOpaqueIdentifier() {
        var id = rerenderState()[0];
        return id;
    }
    function dispatchAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            eagerReducer: null,
            eagerState: null,
            next: null
        }; // Append the update to the end of the list.
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        else {
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.eagerReducer = lastRenderedReducer;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) // Fast path. We can bail out without scheduling React to re-render.
                        // It's still possible that we'll need to rebase this update later,
                        // if the component re-renders for a different reason and by that
                        // time the reducer has changed.
                        return;
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ("undefined" !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useOpaqueIdentifier: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            updateHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var profilerStartTime = -1;
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentName(_type));
        var currentChild = current.child; // This is always exactly one child
        if (!includesSomeLane(updateLanes, renderLanes)) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentName(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false;
                if (!includesSomeLane(renderLanes, updateLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumlated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || nextProps.mode === "unstable-defer-without-hiding") {
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Figure out what we should do in Blocking mode.
                var nextState = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                markSpawnedWork(OffscreenLane);
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes
                };
                workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            var _subtreeRenderLanes;
            if (prevState !== null) {
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    // ourselves to this constraint, though. If the behavior diverges, we should
    // fork the function.
    var updateLegacyHiddenComponent = updateOffscreenComponent;
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) // Schedule a Ref effect
        workInProgress.flags |= Ref;
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            if (current !== null) {
                // A class component without an instance only mounts if it suspended
                // inside a non-concurrent tree, in an inconsistent state. We want to
                // treat it like a new mount, even though an empty version of it already
                // committed. Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            } // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress.type) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    instance.render();
                } finally{
                    reenableLogs();
                }
            }
            setIsRendering(false);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".
        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
            var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;
            if (mutableSourceEagerHydrationData != null) for(var i = 0; i < mutableSourceEagerHydrationData.length; i += 2){
                var mutableSource = mutableSourceEagerHydrationData[i];
                var version = mutableSourceEagerHydrationData[i + 1];
                setWorkInProgressVersion(mutableSource, version);
            }
            var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            workInProgress.child = child;
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.flags = node.flags & ~Placement | Hydrating;
                node = node.sibling;
            }
        } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            resetHydrationState();
        }
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
        if (_current !== null) {
            // A lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentName(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateLanes, renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        } // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentName(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentName(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === "function") applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                } finally{
                    reenableLogs();
                }
            }
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || workInProgress._debugID || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallack
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else {
            // Attempting the main content
            if (current === null || current.memoizedState !== null) // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            {
                if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconcilation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else if (typeof nextProps.unstable_expectedLoadTime === "number") {
                // This is a CPU-bound tree. Skip this tree and show a placeholder to
                // unblock the surrounding content. Then immediately retry after the
                // initial commit.
                var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment = workInProgress.child;
                _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
                // get it started back up to attempt the next item. While in terms of
                // priority this work has the same priority as this current render, it's
                // not part of the same transition once the transition has committed. If
                // it's sync, we still want to yield so that it can be painted.
                // Conceptually, this is really the same as pinging. We can use any
                // RetryLane even if it's the one currently rendering since we're leaving
                // it behind on this node.
                workInProgress.lanes = SomeRetryLane;
                markSpawnedWork(SomeRetryLane);
                return _fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
        } else {
            // This is an update.
            // If the current fiber has a SuspenseState, that means it's already showing
            // a fallback.
            var prevState = current.memoizedState;
            if (prevState !== null) {
                if (showFallback) {
                    var _nextFallbackChildren2 = nextProps.fallback;
                    var _nextPrimaryChildren2 = nextProps.children;
                    var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);
                    var _primaryChildFragment3 = workInProgress.child;
                    var prevOffscreenState = current.child.memoizedState;
                    _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                    _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    return _fallbackChildFragment;
                } else {
                    var _nextPrimaryChildren3 = nextProps.children;
                    var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);
                    workInProgress.memoizedState = null;
                    return _primaryChildFragment4;
                }
            } else // The current tree is not already showing a fallback.
            if (showFallback) {
                // Timed out.
                var _nextFallbackChildren3 = nextProps.fallback;
                var _nextPrimaryChildren4 = nextProps.children;
                var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);
                var _primaryChildFragment5 = workInProgress.child;
                var _prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
                _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
                // fallback children.
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment2;
            } else {
                // Still haven't timed out. Continue rendering the children, like we
                // normally do.
                var _nextPrimaryChildren5 = nextProps.children;
                var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment6;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function createWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & BlockingMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            currentFallbackChildFragment.nextEffect = null;
            currentFallbackChildFragment.flags = Deletion;
            workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion effect during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it. So we need to remove it from the list. Deletions are stored
            // on the same list as effects. We want to keep the effects from the primary
            // tree. So we copy the primary child fragment's effect list, which does not
            // include the fallback deletion effect.
            var progressedLastEffect = primaryChildFragment.lastEffect;
            if (progressedLastEffect !== null) {
                workInProgress.firstEffect = primaryChildFragment.firstEffect;
                workInProgress.lastEffect = progressedLastEffect;
                progressedLastEffect.nextEffect = null;
            } else // TODO: Reset this somewhere else? Lol legacy mode is so weird.
            workInProgress.firstEffect = workInProgress.lastEffect = null;
        } else primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function scheduleWorkOnFiber(fiber, renderLanes) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleWorkOnParentPath(fiber.return, renderLanes);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleWorkOnFiber(node, renderLanes);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderLanes);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isArray = Array.isArray(childSlot);
        var isIterable = !isArray && typeof getIteratorFn(childSlot) === "function";
        if (isArray || isIterable) {
            var type = isArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) // The children don't have any work either. We can skip them.
        // TODO: Once we add back resuming, we should check if the children are
        // a work-in-progress set. If so, we need to transfer their effects.
        return null;
        else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current, workInProgress);
            return workInProgress.child;
        }
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var last = returnFiber.lastEffect;
        if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
        } else returnFiber.firstEffect = returnFiber.lastEffect = current;
        current.nextEffect = null;
        current.flags = Deletion;
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function beginWork(current, workInProgress, renderLanes) {
        var updateLanes = workInProgress.lanes;
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else if (!includesSomeLane(renderLanes, updateLanes)) {
                didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
                // the begin phase. There's still some bookkeeping we that needs to be done
                // in this optimized path, mostly pushing stuff onto the stack.
                switch(workInProgress.tag){
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        break;
                    case ClassComponent:
                        var Component = workInProgress.type;
                        if (isContextProvider(Component)) pushContextProvider(workInProgress);
                        break;
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider:
                        var newValue = workInProgress.memoizedProps.value;
                        pushProvider(workInProgress, newValue);
                        break;
                    case Profiler:
                        // Profiler should only call onRender when one of its descendants actually rendered.
                        var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (hasChildWork) workInProgress.flags |= Update;
                         // Reset effect durations for the next eventual effect phase.
                        // These are reset during render to allow the DevTools commit hook a chance to read them,
                        var stateNode = workInProgress.stateNode;
                        stateNode.effectDuration = 0;
                        stateNode.passiveEffectDuration = 0;
                        break;
                    case SuspenseComponent:
                        var state = workInProgress.memoizedState;
                        if (state !== null) {
                            // whether to retry the primary children, or to skip over it and
                            // go straight to the fallback. Check the priority of the primary
                            // child fragment.
                            var primaryChildFragment = workInProgress.child;
                            var primaryChildLanes = primaryChildFragment.childLanes;
                            if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                            // to attempt to render the primary children again.
                            return updateSuspenseComponent(current, workInProgress, renderLanes);
                            else {
                                // The primary child fragment does not have pending work marked
                                // on it
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                                // priority. Bailout.
                                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                                if (child !== null) // The fallback children have pending work. Skip over the
                                // primary children and work on the fallback.
                                return child.sibling;
                                else return null;
                            }
                        } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                        break;
                    case SuspenseListComponent:
                        var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                        var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (didSuspendBefore) {
                            if (_hasChildWork) // If something was in fallback state last time, and we have all the
                            // same children then we're still in progressive loading state.
                            // Something might get unblocked by state updates or retries in the
                            // tree which will affect the tail. So we need to use the normal
                            // path to compute the correct tail.
                            return updateSuspenseListComponent(current, workInProgress, renderLanes);
                             // If none of the children had any work, that means that none of
                            // them got retried so they'll still be blocked in the same way
                            // as before. We can fast bail out.
                            workInProgress.flags |= DidCapture;
                        } // If nothing suspended before and we're rendering the same children,
                        // then the tail doesn't matter. Anything new that suspends will work
                        // in the "together" mode, so we can continue from the state we had.
                        var renderState = workInProgress.memoizedState;
                        if (renderState !== null) {
                            // Reset to the "together" mode in case we've started a different
                            // update in the past but didn't complete it.
                            renderState.rendering = null;
                            renderState.tail = null;
                            renderState.lastEffect = null;
                        }
                        pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                        if (_hasChildWork) break;
                        else // If none of the children had any work, that means that none of
                        // them got retried so they'll still be blocked in the same way
                        // as before. We can fast bail out.
                        return null;
                    case OffscreenComponent:
                    case LegacyHiddenComponent:
                        // Need to check if the tree still needs to be deferred. This is
                        // almost identical to the logic used in the normal update path,
                        // so we'll just enter that. The only difference is we'll bail out
                        // at the next level instead of this one, because the child props
                        // have not changed. Which is fine.
                        // TODO: Probably should refactor `beginWork` to split the bailout
                        // path from the normal path. I'm tempted to do a labeled break here
                        // but I won't :)
                        workInProgress.lanes = NoLanes;
                        return updateOffscreenComponent(current, workInProgress, renderLanes);
                }
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
            // See https://github.com/facebook/react/pull/19216.
            didReceiveUpdate = true;
            else // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
        } else didReceiveUpdate = false;
         // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
            case FunctionComponent:
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentName(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
            case IncompleteClassComponent:
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
            case LegacyHiddenComponent:
                return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var fiberRoot = workInProgress.stateNode;
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (!fiberRoot.hydrate) // Schedule an effect to clear this container at the start of the next commit.
                    // This handles the case of React rendering into a container with previous children.
                    // It's also safe to do for updates too, because current.child would only be null
                    // if the previous render was null (so the the container would already be empty).
                    workInProgress.flags |= Snapshot;
                }
                updateHostContainer(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;
                if (current === null) {
                    if (workInProgress.memoizedProps.fallback !== undefined) popHydrationState(workInProgress);
                } else {
                    var prevState = current.memoizedState;
                    prevDidTimeout = prevState !== null;
                }
                if (nextDidTimeout && !prevDidTimeout) // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                {
                    if ((workInProgress.mode & BlockingMode) !== NoMode) {
                        // TODO: Move this back to throwException because this is too late
                        // if this is a large tree which is common for initial loads. We
                        // don't know if we should restart a render or not until we get
                        // this marker, and this is too late.
                        // If this render already had a ping or lower pri updates,
                        // and this is the first time we know we're going to suspend we
                        // should be able to immediately restart from within throwException.
                        var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                        if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                        // this boundary is ok.
                        renderDidSuspend();
                        else // Otherwise, we're going to have to hide content so we should
                        // suspend for longer if possible.
                        renderDidSuspendDelayIfPossible();
                    }
                }
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                // retry listener to the promise. This flag is also used to hide the
                // primary children. In mutation mode, we also need the flag to
                // *unhide* children that were previously hidden, so check if this
                // is currently timed out, too.
                workInProgress.flags |= Update;
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                return null;
            case ContextProvider:
                // Pop provider fiber
                popProvider(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thennables. Instead, we'll transfer its thennables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThennables = suspended.updateQueue;
                                    if (newThennables !== null) {
                                        workInProgress.updateQueue = newThennables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect list before doing the second pass since that's now invalid.
                                    if (renderState.lastEffect === null) workInProgress.firstEffect = null;
                                    workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThennables = _suspended.updateQueue;
                            if (_newThennables !== null) {
                                workInProgress.updateQueue = _newThennables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We need to delete the row we just rendered.
                                // Reset the effect list to what it was before we rendered this
                                // child. The nested children have already appended themselves.
                                var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.
                                if (lastEffect !== null) lastEffect.nextEffect = null;
                                 // We're done.
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.lastEffect = workInProgress.lastEffect;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    return next;
                }
                return null;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                if (current !== null) {
                    var _nextState = workInProgress.memoizedState;
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    var nextIsHidden = _nextState !== null;
                    if (prevIsHidden !== nextIsHidden && newProps.mode !== "unstable-defer-without-hiding") workInProgress.flags |= Update;
                }
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if (!((_flags & DidCapture) === NoFlags)) throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                return workInProgress;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(interruptedWork) {
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentName(source.type) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            var errorBoundaryName = getComponentName(boundary.type);
            if (errorBoundaryName) errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            else errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                logCapturedError(fiber, errorInfo);
                return getDerivedStateFromError(error$1);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            if (typeof getDerivedStateFromError !== "function") {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined
                logCapturedError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || "Unknown");
            }
        };
        else update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a listener to the promise to "ping" the root and retry. But only if
        // one does not already exist for the lanes we're currently rendering (which
        // acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            wakeable.then(ping, ping);
        }
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.
        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable.
            var wakeable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
                // Reset the memoizedState to what it was before we attempted
                // to render it.
                var currentSource = sourceFiber.alternate;
                if (currentSource) {
                    sourceFiber.updateQueue = currentSource.updateQueue;
                    sourceFiber.memoizedState = currentSource.memoizedState;
                    sourceFiber.lanes = currentSource.lanes;
                } else {
                    sourceFiber.updateQueue = null;
                    sourceFiber.memoizedState = null;
                }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.
            var _workInProgress = returnFiber;
            do {
                if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                    // Found the nearest boundary.
                    // Stash the promise on the boundary fiber. If the boundary times out, we'll
                    // attach another listener to flip the boundary back to its normal state.
                    var wakeables = _workInProgress.updateQueue;
                    if (wakeables === null) {
                        var updateQueue = new Set();
                        updateQueue.add(wakeable);
                        _workInProgress.updateQueue = updateQueue;
                    } else wakeables.add(wakeable);
                     // If the boundary is outside of blocking mode, we should *not*
                    // suspend the commit. Pretend as if the suspended component rendered
                    // null and keep rendering. In the commit phase, we'll schedule a
                    // subsequent synchronous update to re-render the Suspense.
                    //
                    // Note: It doesn't matter whether the component that suspended was
                    // inside a blocking mode tree. If the Suspense is outside of it, we
                    // should *not* suspend the commit.
                    if ((_workInProgress.mode & BlockingMode) === NoMode) {
                        _workInProgress.flags |= DidCapture;
                        sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                        // But we shouldn't call any lifecycle methods or callbacks. Remove
                        // all lifecycle effect tags.
                        sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                        if (sourceFiber.tag === ClassComponent) {
                            var currentSourceFiber = sourceFiber.alternate;
                            if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                            // completed class component. For example, we should not call
                            // componentWillUnmount if it is deleted.
                            sourceFiber.tag = IncompleteClassComponent;
                            else {
                                // When we try rendering again, we should not reuse the current fiber,
                                // since it's known to be in an inconsistent state. Use a force update to
                                // prevent a bail out.
                                var update = createUpdate(NoTimestamp, SyncLane);
                                update.tag = ForceUpdate;
                                enqueueUpdate(sourceFiber, update);
                            }
                        } // The source fiber did not complete. Mark it with Sync priority to
                        // indicate that it still has pending work.
                        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.
                        return;
                    } // Confirmed that the boundary is in a concurrent mode tree. Continue
                    // with the normal suspend path.
                    //
                    // After this we'll use a set of heuristics to determine whether this
                    // render pass will run to completion or restart or "suspend" the commit.
                    // The actual logic for this is spread out in different places.
                    //
                    // This first principle is that if we're going to suspend when we complete
                    // a root, then we should also restart if we get an update or ping that
                    // might unsuspend it, and vice versa. The only reason to suspend is
                    // because you think you might want to restart before committing. However,
                    // it doesn't make sense to restart only while in the period we're suspended.
                    //
                    // Restarting too aggressively is also not good because it starves out any
                    // intermediate loading state. So we use heuristics to determine when.
                    // Suspense Heuristics
                    //
                    // If nothing threw a Promise or all the same fallbacks are already showing,
                    // then don't suspend/restart.
                    //
                    // If this is an initial render of a new tree of Suspense boundaries and
                    // those trigger a fallback, then don't suspend/restart. We want to ensure
                    // that we can show the initial loading state as quickly as possible.
                    //
                    // If we hit a "Delayed" case, such as when we'd switch from content back into
                    // a fallback, then we should always suspend/restart. Transitions apply
                    // to this case. If none is defined, JND is used instead.
                    //
                    // If we're already showing a fallback and it gets "retried", allowing us to show
                    // another level, but there's still an inner boundary that would show a fallback,
                    // then we suspend/restart for 500ms since the last time we showed a fallback
                    // anywhere in the tree. This effectively throttles progressive loading into a
                    // consistent train of commits. This also gives us an opportunity to restart to
                    // get to the completed state slightly earlier.
                    //
                    // If there's ambiguity due to batching it's resolved in preference of:
                    // 1) "delayed", 2) "initial render", 3) "retry".
                    //
                    // We want to ensure that a "busy" state doesn't get force committed. We want to
                    // ensure that new initial loading states can commit as soon as possible.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    _workInProgress.flags |= ShouldCapture;
                    _workInProgress.lanes = rootRenderLanes;
                    return;
                } // This boundary already captured during this render. Continue to the next
                // boundary.
                _workInProgress = _workInProgress.return;
            }while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?
            value = new Error((getComponentName(sourceFiber.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n" + "\n" + "Add a <Suspense fallback=...> component higher in the tree to " + "provide a loading indicator or placeholder to display.");
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, _update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, instance) {
        invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
        if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
        }
    }
    function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                    var refError = clearCaughtError();
                    captureCommitPhaseError(current, refError);
                }
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, destroy) {
        invokeGuardedCallback(null, destroy, null);
        if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
        }
    }
    function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                return;
            case ClassComponent:
                if (finishedWork.flags & Snapshot) {
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                }
                return;
            case HostRoot:
                if (finishedWork.flags & Snapshot) {
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                }
                return;
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                // Nothing to do for these component types
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) destroy();
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Mount
                    var create = effect.create;
                    effect.destroy = create();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("An effect function must not return anything besides a function, which is used for clean-up.%s", addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function schedulePassiveEffects(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                var _effect = effect, next = _effect.next, tag = _effect.tag;
                if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
                    enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
                    enqueuePendingPassiveHookEffectMount(finishedWork, effect);
                }
                effect = next;
            }while (effect !== firstEffect);
        }
    }
    function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
                schedulePassiveEffects(finishedWork);
                return;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (current === null) {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        instance.componentDidMount();
                    } else {
                        var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                        var prevState = current.memoizedState; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                return;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                return;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                return;
            case HostText:
                // We have no life-cycles associated with text.
                return;
            case HostPortal:
                // We have no life-cycles associated with portals.
                return;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, current === null ? "mount" : "update", finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
                return;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                var instance = node.stateNode;
                if (isHidden) hideInstance(instance);
                else unhideInstance(node.stateNode, node.memoizedProps);
            } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;
                if (isHidden) hideTextInstance(_instance3);
                else unhideTextInstance(_instance3, node.memoizedProps);
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") ref(instanceToUse);
            else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentName(finishedWork.type));
                ref.current = instanceToUse;
            }
        }
    }
    function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
            if (typeof currentRef === "function") currentRef(null);
            else currentRef.current = null;
        }
    } // User-originating errors (lifecycles and refs) should not interrupt
    // deletion, so don't let them throw. Host-originating errors should
    // interrupt deletion, so it's okay
    function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                var updateQueue = current.updateQueue;
                if (updateQueue !== null) {
                    var lastEffect = updateQueue.lastEffect;
                    if (lastEffect !== null) {
                        var firstEffect = lastEffect.next;
                        var effect = firstEffect;
                        do {
                            var _effect2 = effect, destroy = _effect2.destroy, tag = _effect2.tag;
                            if (destroy !== undefined) {
                                if ((tag & Passive$1) !== NoFlags$1) enqueuePendingPassiveHookEffectUnmount(current, effect);
                                else safelyCallDestroy(current, destroy);
                            }
                            effect = effect.next;
                        }while (effect !== firstEffect);
                    }
                }
                return;
            case ClassComponent:
                safelyDetachRef(current);
                var instance = current.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(current, instance);
                return;
            case HostComponent:
                safelyDetachRef(current);
                return;
            case HostPortal:
                unmountHostComponents(finishedRoot, current);
                return;
            case FundamentalComponent:
                return;
            case DehydratedFragment:
                return;
            case ScopeComponent:
                return;
        }
    }
    function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while(true){
            commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.
            if (node.child !== null && // If we don't use mutation we drill down into portals here instead.
            node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === root) return;
            while(node.sibling === null){
                if (node.return === null || node.return === root) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        // Note: we cannot null out sibling here, otherwise it can cause issues
        // with findDOMNode and how it requires the sibling field to carry out
        // traversal in a later effect. See PR #16820. We now clear the sibling
        // field after effects, see: detachFiberAfterEffects.
        //
        // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
        // It may be required if the current component is an error boundary,
        // and one of its descendants throws while unmounting a passive effect.
        fiber.alternate = null;
        fiber.child = null;
        fiber.dependencies = null;
        fiber.firstEffect = null;
        fiber.lastEffect = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.return = null;
        fiber.updateQueue = null;
        fiber._debugOwner = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch(parentFiber.tag){
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
            // eslint-disable-next-line-no-fallthrough
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (parentFiber.flags & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag
            parentFiber.flags &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        if (isContainer) insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        else insertOrAppendPlacementNode(finishedWork, before, parent);
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.
        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.
        var currentParent;
        var currentParentIsContainer;
        while(true){
            if (!currentParentIsValid) {
                var parent = node.return;
                findParent: while(true){
                    if (!(parent !== null)) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    var parentStateNode = parent.stateNode;
                    switch(parent.tag){
                        case HostComponent:
                            currentParent = parentStateNode;
                            currentParentIsContainer = false;
                            break findParent;
                        case HostRoot:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case HostPortal:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                    }
                    parent = parent.return;
                }
                currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
                commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, node.stateNode);
                else removeChild(currentParent, node.stateNode);
                 // Don't visit children because we already visited them.
            } else if (node.tag === HostPortal) {
                if (node.child !== null) {
                    // When we go into a portal, it becomes the parent to remove from.
                    // We will reassign it back when we pop the portal on the way up.
                    currentParent = node.stateNode.containerInfo;
                    currentParentIsContainer = true; // Visit children because portals might contain host components.
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            } else {
                commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.
                if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === current) return;
            while(node.sibling === null){
                if (node.return === null || node.return === current) return;
                node = node.return;
                if (node.tag === HostPortal) // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        // Recursively delete all host nodes from the parent.
        // Detach refs and call componentWillUnmount() on the whole subtree.
        unmountHostComponents(finishedRoot, current);
        var alternate = current.alternate;
        detachFiberMutation(current);
        if (alternate !== null) detachFiberMutation(alternate);
    }
    function commitWork(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                return;
            case HostComponent:
                var instance = finishedWork.stateNode;
                if (instance != null) {
                    // Commit the work prepared earlier.
                    var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;
                    if (updatePayload !== null) commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
                return;
            case HostText:
                if (!(finishedWork.stateNode !== null)) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.
                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
            case HostRoot:
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                    // We've just hydrated. No need to hydrate again.
                    _root.hydrate = false;
                    commitHydratedContainer(_root.containerInfo);
                }
                return;
            case Profiler:
                return;
            case SuspenseComponent:
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
            case SuspenseListComponent:
                attachSuspenseRetryListeners(finishedWork);
                return;
            case IncompleteClassComponent:
                return;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                var newState = finishedWork.memoizedState;
                var isHidden = newState !== null;
                hideOrUnhideAllChildren(finishedWork, isHidden);
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState !== null) {
            markCommitTimeOfFallback();
            // Hide the Offscreen component that contains the primary children. TODO:
            // Ideally, this effect would have been scheduled on the Offscreen fiber
            // itself. That's how unhiding works: the Offscreen component schedules an
            // effect on itself. However, in this case, the component didn't complete,
            // so the fiber was never added to the effect list in the normal path. We
            // could have appended it to the effect list in the Suspense component's
            // second pass, but doing it this way is less complicated. This would be
            // simpler if we got rid of the effect list and traversed the tree, like
            // we're planning to do.
            var primaryChildParent = finishedWork.child;
            hideOrUnhideAllChildren(primaryChildParent, true);
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    if (wakeable.__reactDoNotTraceInteractions !== true) retry = tracing.unstable_wrap(retry);
                    retryCache.add(wakeable);
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    // It returns false if the boundary is already hidden.
    // TODO: Use an effect tag.
    function isSuspenseBoundaryBeingHidden(current, finishedWork) {
        if (current !== null) {
            var oldState = current.memoizedState;
            if (oldState === null || oldState.dehydrated !== null) {
                var newState = finishedWork.memoizedState;
                return newState !== null && newState.dehydrated === null;
            }
        }
        return false;
    }
    function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor$1 = Symbol.for;
        COMPONENT_TYPE = symbolFor$1("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor$1("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor$1("selector.role");
        TEST_NAME_TYPE = symbolFor$1("selector.test_id");
        TEXT_TYPE = symbolFor$1("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var EventContext = /*                 */ 2;
    var DiscreteEventContext = /*         */ 4;
    var LegacyUnbatchedContext = /*       */ 8;
    var RenderContext = /*                */ 16;
    var CommitContext = /*                */ 32;
    var RetryAfterError = /*       */ 64;
    var RootIncomplete = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.
    var workInProgressRootPingedLanes = NoLanes;
    var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var nextEffect = null;
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsRenderPriority = NoPriority$1;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveHookEffectsMount = [];
    var pendingPassiveHookEffectsUnmount = [];
    var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
    // during the commit phase. This enables them to be traced across components
    // that spawn new work during render. E.g. hidden boundaries, suspended SSR
    // hydration or SuspenseList.
    // TODO: Can use a bitmask instead of an array
    var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventWipLanes = NoLanes;
    var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
    // We warn about state updates for unmounted components differently in this case.
    var isFlushingPassiveEffects = false;
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // The algorithm for assigning an update to a lane should be stable for all
        // updates at the same priority within the same event. To do this, the inputs
        // to the algorithm must be the same. For example, we use the `renderLanes`
        // to avoid choosing a lane that is already in the middle of rendering.
        //
        // However, the "included" lanes could be mutated in between updates in the
        // same event, like if you perform an update inside `flushSync`. Or any other
        // code path that might call `prepareFreshStack`.
        //
        // The trick we use is to cache the first of each of these inputs within an
        // event. Then reset the cached values once we can be sure the event is over.
        // Our heuristic for that is whenever we enter a concurrent work loop.
        //
        // We'll do the same for `currentEventPendingLanes` below.
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (currentEventPendingLanes !== NoLanes) currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
            return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
        } // TODO: Remove this dependency on the Scheduler priority.
        // To do that, we're replacing it with an update lane priority.
        var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
        // This couples React to the Scheduler internals, so we're replacing it
        // with the currentUpdateLanePriority above. As an example of how this
        // could be problematic, if we're not inside `Scheduler.runWithPriority`,
        // then we'll get the priority of the current running Scheduler task,
        // which is probably not what we want.
        var lane;
        if ((executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
        else {
            var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
            lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
        }
        return lane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // See `requestUpdateLane` for explanation of `currentEventWipLanes`
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        return findRetryLane(currentEventWipLanes);
    }
    function scheduleUpdateOnFiber(fiber, lane, eventTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateLaneFromFiberToRoot(fiber, lane);
        if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return null;
        } // Mark that the root has a pending update.
        markRootUpdated(root, lane, eventTime);
        if (root === workInProgressRoot) {
            workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
            // definitely won't finish. Since we have a new update, let's mark it as
            // suspended now, right before marking the incoming update. This has the
            // effect of interrupting the current render and switching to the update.
            // TODO: Make sure this doesn't override pings that happen while we've
            // already started rendering.
            markRootSuspended$1(root, workInProgressRootRenderLanes);
        } // TODO: requestUpdateLanePriority also reads the priority. Pass the
        // priority as an argument to that function and this one.
        var priorityLevel = getCurrentPriorityLevel();
        if (lane === SyncLane) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
                // Register pending interactions on the root to avoid losing traced interaction data.
                schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
                // root inside of batchedUpdates should be synchronous, but layout updates
                // should be deferred until the end of the batch.
                performSyncWorkOnRoot(root);
            } else {
                ensureRootIsScheduled(root, eventTime);
                schedulePendingInteractions(root, lane);
                if (executionContext === NoContext) {
                    // Flush the synchronous work now, unless we're already working or inside
                    // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                    // scheduleCallbackForFiber to preserve the ability to schedule a callback
                    // without immediately flushing it. We only do this for user-initiated
                    // updates, to preserve historical behavior of legacy mode.
                    resetRenderTimer();
                    flushSyncCallbackQueue();
                }
            }
        } else {
            // Schedule a discrete update but only if it's not Sync.
            if ((executionContext & DiscreteEventContext) !== NoContext && // discrete, even inside a discrete event.
            (priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
                // This is the result of a discrete event. Track the lowest priority
                // discrete update per root so we can flush them early, if needed.
                if (rootsWithPendingDiscreteUpdates === null) rootsWithPendingDiscreteUpdates = new Set([
                    root
                ]);
                else rootsWithPendingDiscreteUpdates.add(root);
            } // Schedule other updates after in case the callback is sync.
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, lane);
        } // We use this when assigning a lane for a transition inside
        // `requestUpdateLane`. We assume it's the same as the root being updated,
        // since in the common case of a single root app it probably is. If it's not
        // the same root, then it's not a huge deal, we just might batch more stuff
        // together more than necessary.
        mostRecentlyUpdatedRoot = root;
    } // This is split into a separate function so we can mark a fiber with pending
    // work without treating it as a typical update that originates from an event;
    // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
    // on a fiber.
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.
        var newCallbackPriority = returnNextLanesPriority();
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) {
                cancelCallback(existingCallbackNode);
                root.callbackNode = null;
                root.callbackPriority = NoLanePriority;
            }
            return;
        } // Check if there's an existing task. We may be able to reuse it.
        if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;
            if (existingCallbackPriority === newCallbackPriority) // The priority hasn't changed. We can reuse the existing task. Exit.
            return;
             // The priority changed. Cancel the existing callback. We'll schedule a new
            // one below.
            cancelCallback(existingCallbackNode);
        } // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLanePriority) // Special case: Sync React callbacks are scheduled on a special
        // internal queue
        newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        else if (newCallbackPriority === SyncBatchedLanePriority) newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
        else {
            var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
            newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventWipLanes = NoLanes;
        currentEventPendingLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
        var exitStatus = renderRootConcurrent(root, lanes);
        if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) // The render included lanes that were updated during the render phase.
        // For example, when unhiding a hidden tree, we include all the lanes
        // that were previously skipped when the tree was hidden. That set of
        // lanes is a superset of the lanes we started rendering with.
        //
        // So we'll throw out the current work and restart.
        prepareFreshStack(root, NoLanes);
        else if (exitStatus !== RootIncomplete) {
            if (exitStatus === RootErrored) {
                executionContext |= RetryAfterError; // If an error occurred during hydration,
                // discard server response and fall back to client side render.
                if (root.hydrate) {
                    root.hydrate = false;
                    clearContainer(root.containerInfo);
                } // If something threw an error, try rendering one more time. We'll render
                // synchronously to block concurrent data mutations, and we'll includes
                // all pending updates are included. If it still fails after the second
                // attempt, we'll give up and commit the resulting tree.
                lanes = getLanesToRetrySynchronouslyOnError(root);
                if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            } // We now have a consistent tree. The next step is either to commit it,
            // or, if something suspended, wait to commit it after a timeout.
            var finishedWork = root.current.alternate;
            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            finishConcurrentRender(root, exitStatus, lanes);
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootIncomplete:
            case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root);
                break;
            default:
                throw Error("Unknown root exit status.");
        }
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        flushPassiveEffects();
        var lanes;
        var exitStatus;
        if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
            // There's a partial tree, and at least one of its lanes has expired. Finish
            // rendering it before rendering the rest of the expired work.
            lanes = workInProgressRootRenderLanes;
            exitStatus = renderRootSync(root, lanes);
            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
                // The render included lanes that were updated during the render phase.
                // For example, when unhiding a hidden tree, we include all the lanes
                // that were previously skipped when the tree was hidden. That set of
                // lanes is a superset of the lanes we started rendering with.
                //
                // Note that this only happens when part of the tree is rendered
                // concurrently. If the whole tree is rendered synchronously, then there
                // are no interleaved events.
                lanes = getNextLanes(root, lanes);
                exitStatus = renderRootSync(root, lanes);
            }
        } else {
            lanes = getNextLanes(root, NoLanes);
            exitStatus = renderRootSync(root, lanes);
        }
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            executionContext |= RetryAfterError; // If an error occurred during hydration,
            // discard server response and fall back to client side render.
            if (root.hydrate) {
                root.hydrate = false;
                clearContainer(root.containerInfo);
            } // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            lanes = getLanesToRetrySynchronouslyOnError(root);
            if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        } // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            if ((executionContext & RenderContext) !== NoContext) error("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.
            return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.
        flushPassiveEffects();
    }
    function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(root) {
                markDiscreteUpdatesExpired(root);
                ensureRootIsScheduled(root, now());
            });
        } // Now flush the immediate queue.
        flushSyncCallbackQueue();
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
            return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function flushSync(fn, a) {
        var prevExecutionContext = executionContext;
        if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
            error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
            return fn(a);
        }
        executionContext |= BatchedContext;
        try {
            if (fn) return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
            else return undefined;
        } finally{
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            flushSyncCallbackQueue();
        }
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                unwindInterruptedWork(interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        spawnedWorkDuringRender = null;
        ReactStrictModeWarnings.discardPendingWarnings();
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function pushInteractions(root) {
        var prevInteractions = tracing.__interactionsRef.current;
        tracing.__interactionsRef.current = root.memoizedInteractions;
        return prevInteractions;
    }
    function popInteractions(prevInteractions) {
        tracing.__interactionsRef.current = prevInteractions;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) workInProgressRootExitStatus = RootErrored;
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            resetRenderTimer();
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) return RootIncomplete;
        else {
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
                resetChildLanes(completedWork);
                if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
                (returnFiber.flags & Incomplete) === NoFlags) {
                    // Append all the effects of the subtree and this fiber onto the effect
                    // list of the parent. The completion order of the children affects the
                    // side-effect order.
                    if (returnFiber.firstEffect === null) returnFiber.firstEffect = completedWork.firstEffect;
                    if (completedWork.lastEffect !== null) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                        returnFiber.lastEffect = completedWork.lastEffect;
                    } // If this fiber had side-effects, we append it AFTER the children's
                    // side-effects. We can perform certain side-effects earlier if needed,
                    // by doing multiple passes over the effect list. We don't want to
                    // schedule our own side-effect on our own list because if end up
                    // reusing children we'll schedule this effect onto itself since we're
                    // at the end.
                    var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
                    // list. PerformedWork effect is read by React DevTools but shouldn't be
                    // committed.
                    if (flags > PerformedWork) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork;
                        else returnFiber.firstEffect = completedWork;
                        returnFiber.lastEffect = completedWork;
                    }
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its effect list.
                    returnFiber.firstEffect = returnFiber.lastEffect = null;
                    returnFiber.flags |= Incomplete;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootCompleted;
    }
    function resetChildLanes(completedWork) {
        if (// to switch statement in `completeWork`.
        (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) // The children of this component are hidden. Don't bubble their
        // expiration times.
        return;
        var newChildLanes = NoLanes; // Bubble up the earliest expiration time.
        if ((completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while(child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                if (shouldBubbleActualDurations) actualDuration += child.actualDuration;
                treeBaseDuration += child.treeBaseDuration;
                child = child.sibling;
            }
            var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;
            if (isTimedOutSuspense) {
                // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                var primaryChildFragment = completedWork.child;
                if (primaryChildFragment !== null) treeBaseDuration -= primaryChildFragment.treeBaseDuration;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
        } else {
            var _child = completedWork.child;
            while(_child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                _child = _child.sibling;
            }
        }
        completedWork.childLanes = newChildLanes;
    }
    function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
    }
    function commitRootImpl(root, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        if (finishedWork === null) return null;
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (!(finishedWork !== root.current)) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
        // `flushDiscreteUpdates` starts a useless render pass which may cancels
        // a scheduled timeout.
        if (rootsWithPendingDiscreteUpdates !== null) {
            if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) rootsWithPendingDiscreteUpdates.delete(root);
        }
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // Get the list of effects.
        var firstEffect;
        if (finishedWork.flags > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
                finishedWork.lastEffect.nextEffect = finishedWork;
                firstEffect = finishedWork.firstEffect;
            } else firstEffect = finishedWork;
        } else // There is no effect on the root.
        firstEffect = finishedWork.firstEffect;
        if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            focusedInstanceHandle = prepareForCommit(root.containerInfo);
            shouldFireAfterActiveInstanceBlur = false;
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null); // We no longer need to track the active instance fiber
            focusedInstanceHandle = null;
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error2 = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error2);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.
            requestPaint();
            popInteractions(prevInteractions);
            executionContext = prevExecutionContext;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;
            while(nextEffect !== null){
                var nextNextEffect = nextEffect.nextEffect;
                nextEffect.nextEffect = null;
                if (nextEffect.flags & Deletion) detachFiberAfterEffects(nextEffect);
                nextEffect = nextNextEffect;
            }
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        if (remainingLanes !== NoLanes) {
            if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for(var i = 0; i < expirationTimes.length; i++)scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
            }
            schedulePendingInteractions(root, remainingLanes);
        } else // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) // If there are no passive effects, then we can complete the pending interactions.
        // Otherwise, we'll wait until after the passive effects are flushed.
        // Wait to do this until after remaining work has been scheduled,
        // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
        finishPendingInteractions(root, lanes);
        if (remainingLanes === SyncLane) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
        // synchronously, but layout updates should be deferred until the end
        // of the batch.
        return null;
         // If layout work was scheduled, flush it now.
        flushSyncCallbackQueue();
        return null;
    }
    function commitBeforeMutationEffects() {
        while(nextEffect !== null){
            var current = nextEffect.alternate;
            if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
                if ((nextEffect.flags & Deletion) !== NoFlags) {
                    if (doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
                } else // TODO: Move this out of the hot path using a dedicated effect tag.
                if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
            }
            var flags = nextEffect.flags;
            if ((flags & Snapshot) !== NoFlags) {
                setCurrentFiber(nextEffect);
                commitBeforeMutationLifeCycles(current, nextEffect);
                resetCurrentFiber();
            }
            if ((flags & Passive) !== NoFlags) // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            {
                if (!rootDoesHavePassiveEffects) {
                    rootDoesHavePassiveEffects = true;
                    scheduleCallback(NormalPriority$1, function() {
                        flushPassiveEffects();
                        return null;
                    });
                }
            }
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & ContentReset) commitResetTextContent(nextEffect);
            if (flags & Ref) {
                var current = nextEffect.alternate;
                if (current !== null) commitDetachRef(current);
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.
            var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);
            switch(primaryFlags){
                case Placement:
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    // TODO: findDOMNode doesn't rely on this any more but isMounted does
                    // and isMounted is deprecated anyway so we should be able to kill this.
                    nextEffect.flags &= ~Placement;
                    break;
                case PlacementAndUpdate:
                    // Placement
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    nextEffect.flags &= ~Placement; // Update
                    var _current = nextEffect.alternate;
                    commitWork(_current, nextEffect);
                    break;
                case Hydrating:
                    nextEffect.flags &= ~Hydrating;
                    break;
                case HydratingAndUpdate:
                    nextEffect.flags &= ~Hydrating; // Update
                    var _current2 = nextEffect.alternate;
                    commitWork(_current2, nextEffect);
                    break;
                case Update:
                    var _current3 = nextEffect.alternate;
                    commitWork(_current3, nextEffect);
                    break;
                case Deletion:
                    commitDeletion(root, nextEffect);
                    break;
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitLayoutEffects(root, committedLanes) {
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & (Update | Callback)) {
                var current = nextEffect.alternate;
                commitLifeCycles(root, current, nextEffect);
            }
            if (flags & Ref) commitAttachRef(nextEffect);
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority$1;
            return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
        return false;
    }
    function enqueuePendingPassiveHookEffectMount(fiber, effect) {
        pendingPassiveHookEffectsMount.push(effect, fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
        pendingPassiveHookEffectsUnmount.push(effect, fiber);
        fiber.flags |= PassiveUnmountPendingDev;
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.flags |= PassiveUnmountPendingDev;
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function invokePassiveEffectCreate(effect) {
        var create = effect.create;
        effect.destroy = create();
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
        // before ANY passive effect create functions are called.
        // Otherwise effects in sibling components might interfere with each other.
        // e.g. a destroy function in one component may unintentionally override a ref
        // value set by a create function in another component.
        // Layout effects have the same constraint.
        // First pass: Destroy stale passive effects.
        var unmountEffects = pendingPassiveHookEffectsUnmount;
        pendingPassiveHookEffectsUnmount = [];
        for(var i = 0; i < unmountEffects.length; i += 2){
            var _effect = unmountEffects[i];
            var fiber = unmountEffects[i + 1];
            var destroy = _effect.destroy;
            _effect.destroy = undefined;
            fiber.flags &= ~PassiveUnmountPendingDev;
            var alternate = fiber.alternate;
            if (alternate !== null) alternate.flags &= ~PassiveUnmountPendingDev;
            if (typeof destroy === "function") {
                setCurrentFiber(fiber);
                invokeGuardedCallback(null, destroy, null);
                if (hasCaughtError()) {
                    if (!(fiber !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(fiber, error);
                }
                resetCurrentFiber();
            }
        } // Second pass: Create new passive effects.
        var mountEffects = pendingPassiveHookEffectsMount;
        pendingPassiveHookEffectsMount = [];
        for(var _i = 0; _i < mountEffects.length; _i += 2){
            var _effect2 = mountEffects[_i];
            var _fiber = mountEffects[_i + 1];
            setCurrentFiber(_fiber);
            invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
            if (hasCaughtError()) {
                if (!(_fiber !== null)) throw Error("Should be working on an effect.");
                var _error4 = clearCaughtError();
                captureCommitPhaseError(_fiber, _error4);
            }
            resetCurrentFiber();
        } // Note: This currently assumes there are no passive effects on the root fiber
        // because the root is not part of its own effect list.
        // This could change in the future.
        var effect = root.current.firstEffect;
        while(effect !== null){
            var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC
            effect.nextEffect = null;
            if (effect.flags & Deletion) detachFiberAfterEffects(effect);
            effect = nextNextEffect;
        }
        popInteractions(prevInteractions);
        finishPendingInteractions(root, lanes);
        isFlushingPassiveEffects = false;
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        enqueueUpdate(rootFiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, SyncLane);
        }
    }
    function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
        }
        var fiber = sourceFiber.return;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValue(error, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    enqueueUpdate(fiber, update);
                    var eventTime = requestEventTime();
                    var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                        schedulePendingInteractions(root, SyncLane);
                    } else {
                        // This component has already been unmounted.
                        // We can't schedule any follow up work for the root because the fiber is already unmounted,
                        // but we can still call the log-only boundary so the error isn't swallowed.
                        //
                        // TODO This is only a temporary bandaid for the old reconciler fork.
                        // We can delete this special case once the new fork is merged.
                        if (typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) try {
                            instance.componentDidCatch(error, errorInfo);
                        } catch (errorToIgnore) {
                        // This is kind of an edge case.
                        }
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
        schedulePendingInteractions(root, pingedLanes);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryLane === NoLane) retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, retryLane);
        }
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        retryCache = boundaryFiber.stateNode;
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & (BlockingMode | ConcurrentMode))) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var didWarnStateUpdateForUnmountedComponent = null;
    function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        var tag = fiber.tag;
        if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // If there are pending passive effects unmounts for this Fiber,
        // we can assume that they would have prevented this update.
        if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || "ReactComponent";
        if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) return;
            didWarnStateUpdateForUnmountedComponent.add(componentName);
        } else didWarnStateUpdateForUnmountedComponent = new Set([
            componentName
        ]);
        if (isFlushingPassiveEffects) ;
        else {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", tag === ClassComponent ? "the componentWillUnmount method" : "a useEffect cleanup function");
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises. Treat everything else like an error.
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                // Rethrow this error instead of the original one.
                throw replayError;
            } else // This branch is reachable if the render phase is impure.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    } // a 'shared' variable that changes when act() opens/closes in tests.
    var IsThisRendererActing = {
        current: false
    };
    function warnIfNotScopedWithMatchingAct(fiber) {
        if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);");
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
    }
    function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.
    var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
    // scheduler is the actual recommendation. The alternative could be a testing build,
    // a new lib, or whatever; we dunno just yet. This message is for early adopters
    // to get their tests right.
    function warnIfUnmockedScheduler(fiber) {
        if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error("In Concurrent or Sync modes, the \"scheduler\" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://reactjs.org/link/mock-scheduler");
            }
        }
    }
    function computeThreadID(root, lane) {
        // Interaction threads are unique per root and expiration time.
        // NOTE: Intentionally unsound cast. All that matters is that it's a number
        // and it represents a batch of work. Could make a helper function instead,
        // but meh this is fine for now.
        return lane * 1000 + root.interactionThreadID;
    }
    function markSpawnedWork(lane) {
        if (spawnedWorkDuringRender === null) spawnedWorkDuringRender = [
            lane
        ];
        else spawnedWorkDuringRender.push(lane);
    }
    function scheduleInteractions(root, lane, interactions) {
        if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(lane);
            if (pendingInteractions != null) interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
                pendingInteractions.add(interaction);
            });
            else {
                pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.
                interactions.forEach(function(interaction) {
                    interaction.__count++;
                });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lane);
                subscriber.onWorkScheduled(interactions, threadID);
            }
        }
    }
    function schedulePendingInteractions(root, lane) {
        scheduleInteractions(root, lane, tracing.__interactionsRef.current);
    }
    function startWorkOnPendingInteractions(root, lanes) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.
        var interactions = new Set();
        root.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledLane) {
            if (includesSomeLane(lanes, scheduledLane)) scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
            });
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.
        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lanes);
                try {
                    subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority$1, function() {
                        throw error;
                    });
                }
            }
        }
    }
    function finishPendingInteractions(root, committedLanes) {
        var remainingLanesAfterCommit = root.pendingLanes;
        var subscriber;
        try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root.memoizedInteractions.size > 0) {
                // FIXME: More than one lane can finish in a single commit.
                var threadID = computeThreadID(root, committedLanes);
                subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
        } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority$1, function() {
                throw error;
            });
        } finally{
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, lane) {
                // Only decrement the pending interaction count if we're done.
                // If there's still work at the current priority,
                // That indicates that we are waiting for suspense data.
                if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                    pendingInteractionMap.delete(lane);
                    scheduledInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) try {
                            subscriber.onInteractionScheduledWorkCompleted(interaction);
                        } catch (error) {
                            // If the subscriber throws, rethrow it in a separate task
                            scheduleCallback(ImmediatePriority$1, function() {
                                throw error;
                            });
                        }
                    });
                }
            });
        }
    } // `act` testing API
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return actingUpdatesScopeDepth > 0;
    }
    // so we can tell if any async act() calls try to run in parallel.
    var actingUpdatesScopeDepth = 0;
    function detachFiberAfterEffects(fiber) {
        fiber.sibling = null;
        fiber.stateNode = null;
    }
    var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    var debugCounter = 1;
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugID = debugCounter++;
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effect list is no longer valid.
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        }
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= Placement; // The effect list is no longer valid.
        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) mode = ConcurrentMode | BlockingMode | StrictMode;
        else if (tag === BlockingRoot) mode = BlockingMode | StrictMode;
        else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_DEBUG_TRACING_MODE_TYPE:
                fiberTag = Mode;
                mode |= DebugTracingMode;
                break;
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
                return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                    case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner.type) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" as a prop');
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_LIST_TYPE;
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_OFFSCREEN_TYPE;
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
        var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_LEGACY_HIDDEN_TYPE;
        fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.
        fiber.elementType = "DELETED";
        fiber.type = "DELETED";
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoLanePriority;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.mutableSourceEagerHydrationData = null;
        this.interactionThreadID = tracing.unstable_getThreadID();
        this.memoizedInteractions = new Set();
        this.pendingInteractionMap = new Map();
        switch(tag){
            case BlockingRoot:
                this._debugRootType = "createBlockingRoot()";
                break;
            case ConcurrentRoot:
                this._debugRootType = "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = "createLegacyRoot()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
        }
        var lane = requestUpdateLane(current$1);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleUpdateOnFiber(current$1, lane, eventTime);
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thennables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = InputDiscreteHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = SelectiveHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function runWithPriority$2(priority, fn) {
        setCurrentUpdateLanePriority(priority);
        return fn();
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.tag === FundamentalComponent) return hostFiber.stateNode.instance;
        return hostFiber.stateNode;
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === path.length) {
            if (Array.isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (Array.isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools
        });
    }
    function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
    }
    function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
    }
    ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function() {
            unmarkContainerAsRoot(container);
        });
    };
    function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        var containerNodeType = container.nodeType;
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return root;
    }
    function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    var warnedAboutHydrateAPI = false;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
    }
    function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.
        if (!shouldHydrate) {
            var warned = false;
            var rootSibling;
            while(rootSibling = container.lastChild){
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                    warned = true;
                    error("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
                container.removeChild(rootSibling);
            }
        }
        if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v18. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
        }
        return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
        } : undefined);
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        // member of intersection type." Whyyyyyy.
        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root._internalRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    originalCallback.call(instance);
                };
            } // Initial mount should not be batched.
            unbatchedUpdates(function() {
                updateContainer(children, fiberRoot, parentComponent, callback);
            });
        } else {
            fiberRoot = root._internalRoot;
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    _originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) throw Error("Target container is not a DOM element.");
        if (!(parentComponent != null && has(parentComponent))) throw Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            unbatchedUpdates(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setAttemptHydrationAtPriority(runWithPriority$2);
    var didWarnAboutUnstableCreatePortal = false;
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 18+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
        }
        return createPortal$1(children, container, key);
    }
    var Internals = {
        // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            flushPassiveEffects,
            IsThisRendererActing
        ]
    };
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
    exports.createPortal = createPortal$1;
    exports.findDOMNode = findDOMNode;
    exports.flushSync = flushSync;
    exports.hydrate = hydrate;
    exports.render = render;
    exports.unmountComponentAtNode = unmountComponentAtNode;
    exports.unstable_batchedUpdates = batchedUpdates$1;
    exports.unstable_createPortal = unstable_createPortal;
    exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
    exports.version = ReactVersion;
})();

},{"6f0162e9ab224cd4":"9njXz","be0a1114188e0222":"dudAz","8ad4ca65319d28a7":"eTyLO","77001f729419a48":"7Wqq0"}],"eTyLO":[function(require,module,exports) {
"use strict";
module.exports = require("ef03b89c8fe2794e");

},{"ef03b89c8fe2794e":"3wlN0"}],"3wlN0":[function(require,module,exports) {
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var requestHostCallback;
    var requestHostTimeout;
    var cancelHostTimeout;
    var requestPaint;
    var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        exports.unstable_now = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        exports.unstable_now = function() {
            return localDate.now() - initialTime;
        };
    }
    if (// implementation using setTimeout.
    typeof window === "undefined" || // Check if MessageChannel is supported, too.
    typeof MessageChannel !== "function") {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function() {
            if (_callback !== null) try {
                var currentTime = exports.unstable_now();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
            } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
            }
        };
        requestHostCallback = function(cb) {
            if (_callback !== null) // Protect against re-entrancy.
            setTimeout(requestHostCallback, 0, cb);
            else {
                _callback = cb;
                setTimeout(_flushCallback, 0);
            }
        };
        requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
        };
        exports.unstable_shouldYield = function() {
            return false;
        };
        requestPaint = exports.unstable_forceFrameRate = function() {};
    } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== "undefined") {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame;
            if (typeof requestAnimationFrame !== "function") // Using console['error'] to evade Babel and ESLint
            console["error"]("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            if (typeof cancelAnimationFrame !== "function") // Using console['error'] to evade Babel and ESLint
            console["error"]("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.
        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable
        // `isInputPending` is not available. Since we have no way of knowing if
        // there's pending input, always yield at the end of the frame.
        exports.unstable_shouldYield = function() {
            return exports.unstable_now() >= deadline;
        }; // Since we yield every frame regardless, `requestPaint` has no effect.
        requestPaint = function() {};
        exports.unstable_forceFrameRate = function(fps) {
            if (fps < 0 || fps > 125) {
                // Using console['error'] to evade Babel and ESLint
                console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
                return;
            }
            if (fps > 0) yieldInterval = Math.floor(1000 / fps);
            else // reset the framerate
            yieldInterval = 5;
        };
        var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
                var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
                // cycle. This means there's always time remaining at the beginning of
                // the message event.
                deadline = currentTime + yieldInterval;
                var hasTimeRemaining = true;
                try {
                    var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                    if (!hasMoreWork) {
                        isMessageLoopRunning = false;
                        scheduledHostCallback = null;
                    } else // If there's more work, schedule the next message event at the end
                    // of the preceding one.
                    port.postMessage(null);
                } catch (error) {
                    // If a scheduler task throws, exit the current browser task so the
                    // error can be observed.
                    port.postMessage(null);
                    throw error;
                }
            } else isMessageLoopRunning = false;
             // Yielding to the browser will give it a chance to paint, so we can
        };
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
                isMessageLoopRunning = true;
                port.postMessage(null);
            }
        };
        requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
                callback(exports.unstable_now());
            }, ms);
        };
        cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
        };
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
    }
    function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
            var last = heap.pop();
            if (last !== first) {
                heap[0] = last;
                siftDown(heap, last, 0);
            }
            return first;
        } else return null;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(true){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (parent !== undefined && compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while(index < length){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (left !== undefined && compare(left, node) < 0) {
                if (right !== undefined && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (right !== undefined && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = exports.unstable_now();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports.unstable_shouldYield())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = exports.unstable_now();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = exports.unstable_now();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    exports.unstable_IdlePriority = IdlePriority;
    exports.unstable_ImmediatePriority = ImmediatePriority;
    exports.unstable_LowPriority = LowPriority;
    exports.unstable_NormalPriority = NormalPriority;
    exports.unstable_Profiling = unstable_Profiling;
    exports.unstable_UserBlockingPriority = UserBlockingPriority;
    exports.unstable_cancelCallback = unstable_cancelCallback;
    exports.unstable_continueExecution = unstable_continueExecution;
    exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
    exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
    exports.unstable_next = unstable_next;
    exports.unstable_pauseExecution = unstable_pauseExecution;
    exports.unstable_requestPaint = unstable_requestPaint;
    exports.unstable_runWithPriority = unstable_runWithPriority;
    exports.unstable_scheduleCallback = unstable_scheduleCallback;
    exports.unstable_wrapCallback = unstable_wrapCallback;
})();

},{}],"7Wqq0":[function(require,module,exports) {
"use strict";
module.exports = require("713910055b34250f");

},{"713910055b34250f":"fTkJK"}],"fTkJK":[function(require,module,exports) {
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.
    var interactionIDCounter = 0;
    var threadIDCounter = 0; // Set of currently traced interactions.
    // Interactions "stack"–
    // Meaning that newly traced interactions are appended to the previously active set.
    // When an interaction goes out of scope, the previous set (if any) is restored.
    exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.
    exports.__subscriberRef = null;
    exports.__interactionsRef = {
        current: new Set()
    };
    exports.__subscriberRef = {
        current: null
    };
    function unstable_clear(callback) {
        var prevInteractions = exports.__interactionsRef.current;
        exports.__interactionsRef.current = new Set();
        try {
            return callback();
        } finally{
            exports.__interactionsRef.current = prevInteractions;
        }
    }
    function unstable_getCurrent() {
        return exports.__interactionsRef.current;
    }
    function unstable_getThreadID() {
        return ++threadIDCounter;
    }
    function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
        };
        var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.
        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        exports.__interactionsRef.current = interactions;
        var subscriber = exports.__subscriberRef.current;
        var returnValue;
        try {
            if (subscriber !== null) subscriber.onInteractionTraced(interaction);
        } finally{
            try {
                if (subscriber !== null) subscriber.onWorkStarted(interactions, threadID);
            } finally{
                try {
                    returnValue = callback();
                } finally{
                    exports.__interactionsRef.current = prevInteractions;
                    try {
                        if (subscriber !== null) subscriber.onWorkStopped(interactions, threadID);
                    } finally{
                        interaction.__count--; // If no async work was scheduled for this interaction,
                        // Notify subscribers that it's completed.
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    }
                }
            }
        }
        return returnValue;
    }
    function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = exports.__interactionsRef.current;
        var subscriber = exports.__subscriberRef.current;
        if (subscriber !== null) subscriber.onWorkScheduled(wrappedInteractions, threadID);
         // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.
        wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
            var prevInteractions = exports.__interactionsRef.current;
            exports.__interactionsRef.current = wrappedInteractions;
            subscriber = exports.__subscriberRef.current;
            try {
                var returnValue;
                try {
                    if (subscriber !== null) subscriber.onWorkStarted(wrappedInteractions, threadID);
                } finally{
                    try {
                        returnValue = callback.apply(undefined, arguments);
                    } finally{
                        exports.__interactionsRef.current = prevInteractions;
                        if (subscriber !== null) subscriber.onWorkStopped(wrappedInteractions, threadID);
                    }
                }
                return returnValue;
            } finally{
                if (!hasRun) {
                    // We only expect a wrapped function to be executed once,
                    // But in the event that it's executed more than once–
                    // Only decrement the outstanding interaction counts once.
                    hasRun = true; // Update pending async counts for all wrapped interactions.
                    // If this was the last scheduled async work for any of them,
                    // Mark them as completed.
                    wrappedInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    });
                }
            }
        }
        wrapped.cancel = function cancel() {
            subscriber = exports.__subscriberRef.current;
            try {
                if (subscriber !== null) subscriber.onWorkCanceled(wrappedInteractions, threadID);
            } finally{
                // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.
                wrappedInteractions.forEach(function(interaction) {
                    interaction.__count--;
                    if (subscriber && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                });
            }
        };
        return wrapped;
    }
    var subscribers = null;
    subscribers = new Set();
    function unstable_subscribe(subscriber) {
        subscribers.add(subscriber);
        if (subscribers.size === 1) exports.__subscriberRef.current = {
            onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
            onInteractionTraced: onInteractionTraced,
            onWorkCanceled: onWorkCanceled,
            onWorkScheduled: onWorkScheduled,
            onWorkStarted: onWorkStarted,
            onWorkStopped: onWorkStopped
        };
    }
    function unstable_unsubscribe(subscriber) {
        subscribers.delete(subscriber);
        if (subscribers.size === 0) exports.__subscriberRef.current = null;
    }
    function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionTraced(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    exports.unstable_clear = unstable_clear;
    exports.unstable_getCurrent = unstable_getCurrent;
    exports.unstable_getThreadID = unstable_getThreadID;
    exports.unstable_subscribe = unstable_subscribe;
    exports.unstable_trace = unstable_trace;
    exports.unstable_unsubscribe = unstable_unsubscribe;
    exports.unstable_wrap = unstable_wrap;
})();

},{}],"4sGPJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactHotjar = require("react-hotjar");
var _providers = require("./Providers");
var _providersDefault = parcelHelpers.interopDefault(_providers);
var _bootstrapMinCss = require("bootstrap/dist/css/bootstrap.min.css");
var _appCss = require("./Styles/App.css");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
function App() {
    const [branding, setBranding] = (0, _react.useState)({});
    const fetchBranding = (0, _react.useCallback)(async ()=>{
        await setTheme();
        const brandingResponse = await window.fetch(getBlobPath()).then((res)=>res.json());
        const style = window.getComputedStyle(document.body);
        const primary_alert = style.getPropertyValue("--brand-primary-alert").trim();
        const brandBoolean = getBrandingBoolean();
        setBranding({
            ...brandingResponse,
            ...brandBoolean,
            primary_alert
        });
        const { apple_touch_icon_url, apple_touch_icon_57_url, apple_touch_icon_72_url, apple_touch_icon_76_url, apple_touch_icon_114_url, apple_touch_icon_120_url, apple_touch_icon_144_url, apple_touch_icon_152_url, apple_touch_icon_180_url, favicon_url, title } = brandingResponse || {};
        if (apple_touch_icon_url) {
            const touchIcon = getEl("appleTouchIcon");
            touchIcon.href = apple_touch_icon_url;
        }
        if (apple_touch_icon_57_url) {
            const touchIcon57 = getEl("appleTouchIcon57");
            touchIcon57.href = apple_touch_icon_57_url;
        }
        if (apple_touch_icon_72_url) {
            const touchIcon72 = getEl("appleTouchIcon72");
            touchIcon72.href = apple_touch_icon_72_url;
        }
        if (apple_touch_icon_76_url) {
            const touchIcon76 = getEl("appleTouchIcon76");
            touchIcon76.href = apple_touch_icon_76_url;
        }
        if (apple_touch_icon_114_url) {
            const touchIcon114 = getEl("appleTouchIcon114");
            touchIcon114.href = apple_touch_icon_114_url;
        }
        if (apple_touch_icon_114_url) {
            const touchIcon114 = getEl("appleTouchIcon114");
            touchIcon114.href = apple_touch_icon_114_url;
        }
        if (apple_touch_icon_120_url) {
            const touchIcon120 = getEl("appleTouchIcon120");
            touchIcon120.href = apple_touch_icon_120_url;
        }
        if (apple_touch_icon_144_url) {
            const touchIcon144 = getEl("appleTouchIcon144");
            touchIcon144.href = apple_touch_icon_144_url;
        }
        if (apple_touch_icon_152_url) {
            const touchIcon152 = getEl("appleTouchIcon152");
            touchIcon152.href = apple_touch_icon_152_url;
        }
        if (apple_touch_icon_180_url) {
            const touchIcon180 = getEl("appleTouchIcon180");
            touchIcon180.href = apple_touch_icon_180_url;
        }
        if (favicon_url) {
            const favicon = getEl("favicon");
            favicon.href = favicon_url;
        }
        if (title) document.title = title;
    }, []);
    (0, _react.useEffect)(()=>{
        fetchBranding();
    }, [
        fetchBranding
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.HashRouter), {
        children: branding ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _providersDefault.default), {
            branding: branding
        }) : null
    });
}
function getBlobPath() {
    let relativePath;
    switch(true){
        case window.location.host.toLowerCase().includes("branded") && window.location.host.toLowerCase().includes("experience"):
            relativePath = "/branded-experience/branded-experience.json";
            break;
        case window.location.host.toLowerCase().includes("customer") && window.location.host.toLowerCase().includes("demo"):
            relativePath = "/customer-demo/customer-demo.json";
            break;
        case window.location.host.toLowerCase().includes("enovation"):
            relativePath = "/enovation/enovation.json";
            break;
        case window.location.host.toLowerCase().includes?.("mysupra"):
            relativePath = "/supraboats/supraboats.json";
            break;
        case window.location.host.toLowerCase().includes("versatile"):
            relativePath = "/versatile/versatile.json";
            break;
        case window.location.host.toLowerCase().includes("barko"):
            relativePath = "/barko/barko.json";
            break;
        default:
            relativePath = "/elevat/elevat.json";
            break;
    }
    return `${"https://uibrandingdev.blob.core.windows.net"}${relativePath}`;
}
function getBrandingBoolean() {
    switch(true){
        case window.location.host.toLowerCase().includes("branded") && window.location.host.toLowerCase().includes("experience"):
            return {
                isBrandedExperienceUi: true
            };
        case window.location.host.toLowerCase().includes("customer") && window.location.host.toLowerCase().includes("demo"):
            return {
                isCustomerDemoUi: true
            };
        case window.location.host.toLowerCase().includes("enovation"):
            return {
                isEnovationUi: true
            };
        case window.location.host.toLowerCase().includes?.("mysupra"):
            return {
                isSupraUi: true
            };
        case window.location.host.toLowerCase().includes("versatile"):
            return {
                isVersatileUi: true
            };
        case window.location.host.toLowerCase().includes("barko"):
            return {
                isBarkoUi: true
            };
        default:
            return {
                isElevatUi: true
            };
    }
}
function getEl(id) {
    return document.getElementById(id);
}
async function setTheme() {
    switch(true){
        case window.location.host.toLowerCase().includes("branded") && window.location.host.toLowerCase().includes("experience"):
            return require("6751a45203ef9d9");
        case window.location.host.toLowerCase().includes("customer") && window.location.host.toLowerCase().includes("demo"):
            return require("981633301af75936");
        case window.location.host.toLowerCase().includes("enovation"):
            return require("5a128e3fbd6b9c6d");
        case window.location.host.toLowerCase().includes?.("mysupra"):
            return require("d2cc7b93641d575c");
        case window.location.host.toLowerCase().includes("versatile"):
            return require("a927e1966c89f3ae");
        case window.location.host.toLowerCase().includes("barko"):
            return require("898e0f909b667e2a");
        default:
            return require("483bd79a4653fa26");
    }
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","react-hotjar":"6NHt2","./Providers":"bgB04","bootstrap/dist/css/bootstrap.min.css":"1ZvQt","./Styles/App.css":"1NSLy","react-datepicker/dist/react-datepicker.css":"chsuV","6751a45203ef9d9":"lP6kO","981633301af75936":"Gf03C","5a128e3fbd6b9c6d":"ibQl8","d2cc7b93641d575c":"jxRrK","a927e1966c89f3ae":"5UihQ","898e0f909b667e2a":"jRKwH","483bd79a4653fa26":"1B2hk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3uzXR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
BrowserRouter.propTypes = {
    basename: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    forceRefresh: (0, _propTypesDefault.default).bool,
    getUserConfirmation: (0, _propTypesDefault.default).func,
    keyLength: (0, _propTypesDefault.default).number
};
BrowserRouter.prototype.componentDidMount = function() {
    (0, _tinyWarningDefault.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
};
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
HashRouter.propTypes = {
    basename: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    getUserConfirmation: (0, _propTypesDefault.default).func,
    hashType: (0, _propTypesDefault.default).oneOf([
        "hashbang",
        "noslash",
        "slash"
    ])
};
HashRouter.prototype.componentDidMount = function() {
    (0, _tinyWarningDefault.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
};
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
LinkAnchor.displayName = "LinkAnchor";
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false, "You should not use <Link> outside a <Router>");
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).object,
    (0, _propTypesDefault.default).func
]);
var refType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).shape({
        current: (0, _propTypesDefault.default).any
    })
]);
Link.displayName = "Link";
Link.propTypes = {
    innerRef: refType,
    onClick: (0, _propTypesDefault.default).func,
    replace: (0, _propTypesDefault.default).bool,
    target: (0, _propTypesDefault.default).string,
    to: toType.isRequired
};
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false, "You should not use <NavLink> outside a <Router>");
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
NavLink.displayName = "NavLink";
var ariaCurrentType = (0, _propTypesDefault.default).oneOf([
    "page",
    "step",
    "location",
    "date",
    "time",
    "true",
    "false"
]);
NavLink.propTypes = (0, _extendsDefault.default)({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: (0, _propTypesDefault.default).string,
    activeStyle: (0, _propTypesDefault.default).object,
    className: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    exact: (0, _propTypesDefault.default).bool,
    isActive: (0, _propTypesDefault.default).func,
    location: (0, _propTypesDefault.default).object,
    sensitive: (0, _propTypesDefault.default).bool,
    strict: (0, _propTypesDefault.default).bool,
    style: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func
    ])
});

},{"react-router":"hbNjF","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","history":"6go37","prop-types":"bnNSm","tiny-warning":"5e17w","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","tiny-invariant":"cKzLp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbNjF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    (0, _tinyWarningDefault.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, "calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: " + changedBits);
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
Router.propTypes = {
    children: (0, _propTypesDefault.default).node,
    history: (0, _propTypesDefault.default).object.isRequired,
    staticContext: (0, _propTypesDefault.default).object
};
Router.prototype.componentDidUpdate = function(prevProps) {
    (0, _tinyWarningDefault.default)(prevProps.history === this.props.history, "You cannot change <Router history>");
};
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
MemoryRouter.propTypes = {
    initialEntries: (0, _propTypesDefault.default).array,
    initialIndex: (0, _propTypesDefault.default).number,
    getUserConfirmation: (0, _propTypesDefault.default).func,
    keyLength: (0, _propTypesDefault.default).number,
    children: (0, _propTypesDefault.default).node
};
MemoryRouter.prototype.componentDidMount = function() {
    (0, _tinyWarningDefault.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { MemoryRouter as Router }`.");
};
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false, "You should not use <Prompt> outside a <Router>");
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).string
]);
Prompt.propTypes = {
    when: (0, _propTypesDefault.default).bool,
    message: messageType.isRequired
};
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false, "You should not use <Redirect> outside a <Router>");
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
Redirect.propTypes = {
    push: (0, _propTypesDefault.default).bool,
    from: (0, _propTypesDefault.default).string,
    to: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]).isRequired
};
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    (0, _tinyWarningDefault.default)(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? ' path="' + path + '"' : "") + ">, but you ") + "should have returned a React element or `null`");
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false, "You should not use <Route> outside a <Router>");
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? evalChildrenDev(children, props, _this.props.path) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? evalChildrenDev(children, props, _this.props.path) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
Route.propTypes = {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).node
    ]),
    component: function component(props, propName) {
        if (props[propName] && !(0, _reactIs.isValidElementType)(props[propName])) return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
    },
    exact: (0, _propTypesDefault.default).bool,
    location: (0, _propTypesDefault.default).object,
    path: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    ]),
    render: (0, _propTypesDefault.default).func,
    sensitive: (0, _propTypesDefault.default).bool,
    strict: (0, _propTypesDefault.default).bool
};
Route.prototype.componentDidMount = function() {
    (0, _tinyWarningDefault.default)(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored");
    (0, _tinyWarningDefault.default)(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored");
    (0, _tinyWarningDefault.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
};
Route.prototype.componentDidUpdate = function(prevProps) {
    (0, _tinyWarningDefault.default)(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    (0, _tinyWarningDefault.default)(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
};
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false, "You cannot %s with <StaticRouter>", methodName);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
StaticRouter.propTypes = {
    basename: (0, _propTypesDefault.default).string,
    context: (0, _propTypesDefault.default).object,
    location: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ])
};
StaticRouter.prototype.componentDidMount = function() {
    (0, _tinyWarningDefault.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { StaticRouter as Router }`.");
};
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false, "You should not use <Switch> outside a <Router>");
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
Switch.propTypes = {
    children: (0, _propTypesDefault.default).node,
    location: (0, _propTypesDefault.default).object
};
Switch.prototype.componentDidUpdate = function(prevProps) {
    (0, _tinyWarningDefault.default)(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    (0, _tinyWarningDefault.default)(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
};
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false, "You should not use <" + displayName + " /> outside a <Router>");
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).object
        ])
    };
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    !(typeof useContext === "function") && (0, _tinyInvariantDefault.default)(false, "You must use React >= 16.8 in order to use useHistory()");
    return useContext(historyContext);
}
function useLocation() {
    !(typeof useContext === "function") && (0, _tinyInvariantDefault.default)(false, "You must use React >= 16.8 in order to use useLocation()");
    return useContext(context).location;
}
function useParams() {
    !(typeof useContext === "function") && (0, _tinyInvariantDefault.default)(false, "You must use React >= 16.8 in order to use useParams()");
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    !(typeof useContext === "function") && (0, _tinyInvariantDefault.default)(false, "You must use React >= 16.8 in order to use useRouteMatch()");
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
if (typeof window !== "undefined") {
    var global$1 = window;
    var key = "__react_router_build__";
    var buildNames = {
        cjs: "CommonJS",
        esm: "ES modules",
        umd: "UMD"
    };
    if (global$1[key] && global$1[key] !== "esm") {
        var initialBuildName = buildNames[global$1[key]];
        var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
        // loading 2 different builds.
        throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }
    global$1[key] = "esm";
}

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","history":"6go37","tiny-warning":"5e17w","tiny-invariant":"cKzLp","@babel/runtime/helpers/esm/extends":"aAOJb","path-to-regexp":"8r1im","react-is":"8gz4q","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cnxy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UMxe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiucr":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"bnNSm":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs = require("96e34ae03f5a2631");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var throwOnDirectAccess = true;
module.exports = require("cb216452e2171041")(ReactIs.isElement, throwOnDirectAccess);

},{"96e34ae03f5a2631":"29Pm7","cb216452e2171041":"hXis1"}],"29Pm7":[function(require,module,exports) {
"use strict";
module.exports = require("ad47820528c6facb");

},{"ad47820528c6facb":"5QGHJ"}],"5QGHJ":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
})();

},{}],"hXis1":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactIs = require("c437388b089702c3");
var assign = require("c067a60101d8520c");
var ReactPropTypesSecret = require("74a0f89a70b9f3c2");
var has = require("18441b11647bc78");
var checkPropTypes = require("bec3f6ff89f0b072");
var printWarning = function() {};
printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!ReactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if (has(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                if (checkerResult == null) return null;
                if (checkerResult.data && has(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = assign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (has(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"c437388b089702c3":"29Pm7","c067a60101d8520c":"dudAz","74a0f89a70b9f3c2":"di8d9","18441b11647bc78":"iSnT6","bec3f6ff89f0b072":"ilyEo"}],"di8d9":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"iSnT6":[function(require,module,exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

},{}],"ilyEo":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var printWarning = function() {};
var ReactPropTypesSecret = require("24ba1e58d167a82c");
var loggedTypeFailures = {};
var has = require("898bc82f39d83f7c");
printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
    loggedTypeFailures = {};
};
module.exports = checkPropTypes;

},{"24ba1e58d167a82c":"di8d9","898bc82f39d83f7c":"iSnT6"}],"6go37":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        (0, _tinyWarningDefault.default)(prompt == null, "A history supports only one prompt at a time");
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else {
                    (0, _tinyWarningDefault.default)(false, "A history needs a getUserConfirmation function in order to use a prompt message");
                    callback(true);
                }
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var PopStateEvent = "popstate";
var HashChangeEvent = "hashchange";
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false, "Browser history needs a DOM");
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, _tinyWarningDefault.default)(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        (0, _tinyWarningDefault.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, _tinyWarningDefault.default)(state === undefined, "Browser history cannot push state in browsers that do not support HTML5 history");
                window.location.href = href;
            }
        });
    }
    function replace(path, state) {
        (0, _tinyWarningDefault.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, _tinyWarningDefault.default)(state === undefined, "Browser history cannot replace state in browsers that do not support HTML5 history");
                window.location.replace(href);
            }
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = "hashchange";
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + "#" + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false, "Hash history needs a DOM");
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        (0, _tinyWarningDefault.default)(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = stripHash(window.location.href);
        return href + "#" + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        (0, _tinyWarningDefault.default)(state === undefined, "Hash history cannot push state; it is ignored");
        var action = "PUSH";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else {
                (0, _tinyWarningDefault.default)(false, "Hash history cannot PUSH the same path; a new entry will not be added to the history stack");
                setState();
            }
        });
    }
    function replace(path, state) {
        (0, _tinyWarningDefault.default)(state === undefined, "Hash history cannot replace state; it is ignored");
        var action = "REPLACE";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        (0, _tinyWarningDefault.default)(canGoWithoutReload, "Hash history go(n) causes a full page reload in this browser");
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        (0, _tinyWarningDefault.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        (0, _tinyWarningDefault.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","resolve-pathname":"2gZcD","value-equal":"jH0rl","tiny-warning":"5e17w","tiny-invariant":"cKzLp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAOJb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2gZcD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") spliceOne(fromParts, i);
        else if (part === "..") {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jH0rl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5e17w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = false;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cKzLp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = false;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8r1im":[function(require,module,exports) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : "[^" + escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return attachKeys(new RegExp("^" + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"bARuY"}],"bARuY":[function(require,module,exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

},{}],"8gz4q":[function(require,module,exports) {
"use strict";
module.exports = require("6a6b812c083c62b7");

},{"6a6b812c083c62b7":"7vG50"}],"7vG50":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
})();

},{}],"jGdYV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Kh2":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"cPI6k"}],"cPI6k":[function(require,module,exports) {
"use strict";
module.exports = require("cffb0a4e8f761a01");

},{"cffb0a4e8f761a01":"3TZdT"}],"3TZdT":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
})();

},{}],"6NHt2":[function(require,module,exports) {
var hotjar = require("2edeecb549c2479f");
function hj() {
    var params = Array.prototype.slice.call(arguments);
    if (!window.hj) throw new Error("Hotjar is not initialized");
    window.hj.apply(undefined, params);
}
module.exports = {
    hotjar: {
        initialize: function initialize(id, sv) {
            hotjar(id, sv);
        },
        initialized: function initialized() {
            return typeof window !== "undefined" && typeof window?.hj === "function";
        },
        identify: function identify(userId, properties) {
            hj("identify", userId, properties);
        },
        event: function event(_event) {
            hj("event", _event);
        },
        stateChange: function stateChange(relativePath) {
            hj("stateChange", relativePath);
        }
    }
};

},{"2edeecb549c2479f":"6iyyk"}],"6iyyk":[function(require,module,exports) {
module.exports = function(id, sv, debug = false) {
    (function(h, o, t, j, a, r) {
        h.hj = h.hj || function() {
            (h.hj.q = h.hj.q || []).push(arguments);
        };
        h._hjSettings = {
            hjid: id,
            hjsv: sv,
            hjDebug: debug
        };
        h._scriptPath = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        if (!document.querySelector('script[src*="' + h._scriptPath + '"]')) {
            a = o.getElementsByTagName("head")[0];
            r = o.createElement("script");
            r.async = 1;
            r.src = h._scriptPath;
            a.appendChild(r);
        }
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
};

},{}],"bgB04":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Providers);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _api = require("@react-google-maps/api");
var _requests = require("./Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
var _authService = require("./Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _accountService = require("./Services/AccountService");
var _accountServiceDefault = parcelHelpers.interopDefault(_accountService);
var _localStorageService = require("./Services/LocalStorageService");
var _localStorageServiceDefault = parcelHelpers.interopDefault(_localStorageService);
var _organizationService = require("./Services/OrganizationService");
var _organizationServiceDefault = parcelHelpers.interopDefault(_organizationService);
var _errorBoundary = require("./Components/ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _loadingCircle = require("./Components/LoadingCircle");
var _routes = require("./Routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
var _brandingContext = require("./Context/BrandingContext");
var _breakpointContext = require("./Context/BreakpointContext");
var _currentOrgContext = require("./Context/CurrentOrgContext");
var _currentUserContext = require("./Context/CurrentUserContext");
var _exitSubOrgContext = require("./Context/ExitSubOrgContext");
var _handleSubOrgDeleteContext = require("./Context/HandleSubOrgDeleteContext");
var _iconsContext = require("./Context/IconsContext");
var _orgsMapContext = require("./Context/OrgsMapContext");
var _permissionsContext = require("./Context/PermissionsContext");
var _resetGlobalStateContext = require("./Context/ResetGlobalStateContext");
var _rootOrgContext = require("./Context/RootOrgContext");
var _setCurrentOrgContext = require("./Context/SetCurrentOrgContext");
var _toggleSidebarContext = require("./Context/ToggleSidebarContext");
var _updateCurrentOrgContext = require("./Context/UpdateCurrentOrgContext");
var _updateCurrentUserContext = require("./Context/UpdateCurrentUserContext");
var _userContext = require("./Context/UserContext");
var _widthContext = require("./Context/WidthContext");
var _alarmPng = require("./Static/map-pins/alarm.png");
var _alarmPngDefault = parcelHelpers.interopDefault(_alarmPng);
var _newAlertHeaderDesktopSvg = require("./Static/new_alert_header_desktop.svg");
var _newAlertHeaderDesktopSvgDefault = parcelHelpers.interopDefault(_newAlertHeaderDesktopSvg);
var _newAlertHeaderSvg = require("./Static/new_alert_header.svg");
var _newAlertHeaderSvgDefault = parcelHelpers.interopDefault(_newAlertHeaderSvg);
var _assetIconRedPng = require("./Static/AssetIconRed.png");
var _assetIconRedPngDefault = parcelHelpers.interopDefault(_assetIconRedPng);
var _assetIconWhitePng = require("./Static/Asset_Icon_White.png");
var _assetIconWhitePngDefault = parcelHelpers.interopDefault(_assetIconWhitePng);
var _assetModelIconPng = require("./Static/AssetModel_Icon.png");
var _assetModelIconPngDefault = parcelHelpers.interopDefault(_assetModelIconPng);
var _assetModelIconWhitePng = require("./Static/AssetModel_Icon_White.png");
var _assetModelIconWhitePngDefault = parcelHelpers.interopDefault(_assetModelIconWhitePng);
var _profileIconPng = require("./Static/Profile_Icon.png");
var _profileIconPngDefault = parcelHelpers.interopDefault(_profileIconPng);
var _certificateIconPng = require("./Static/Certificate_Icon.png");
var _certificateIconPngDefault = parcelHelpers.interopDefault(_certificateIconPng);
var _chartIconPng = require("./Static/Chart_Icon.png");
var _chartIconPngDefault = parcelHelpers.interopDefault(_chartIconPng);
var _commandControlIconPng = require("./Static/CommandControl_Icon.png");
var _commandControlIconPngDefault = parcelHelpers.interopDefault(_commandControlIconPng);
var _conditionsIconPng = require("./Static/Conditions_Icon.png");
var _conditionsIconPngDefault = parcelHelpers.interopDefault(_conditionsIconPng);
var _cumminsBannerDesktopSvg = require("./Static/cummins_banner_desktop.svg");
var _cumminsBannerDesktopSvgDefault = parcelHelpers.interopDefault(_cumminsBannerDesktopSvg);
var _cumminsBannerMobileSvg = require("./Static/cummins_banner_mobile.svg");
var _cumminsBannerMobileSvgDefault = parcelHelpers.interopDefault(_cumminsBannerMobileSvg);
var _cumminsLogoBlackPng = require("./Static/cummins_logo_black.png");
var _cumminsLogoBlackPngDefault = parcelHelpers.interopDefault(_cumminsLogoBlackPng);
var _cumminsLogoWhitePng = require("./Static/cummins_logo_white.png");
var _cumminsLogoWhitePngDefault = parcelHelpers.interopDefault(_cumminsLogoWhitePng);
var _iconEmptyStateSvg = require("./Static/Icon_EmptyState.svg");
var _iconEmptyStateSvgDefault = parcelHelpers.interopDefault(_iconEmptyStateSvg);
var _carEngineSvg = require("./Static/car-engine.svg");
var _carEngineSvgDefault = parcelHelpers.interopDefault(_carEngineSvg);
var _404IconPng = require("./Static/404_Icon.png");
var _404IconPngDefault = parcelHelpers.interopDefault(_404IconPng);
var _eventsIconWhitePng = require("./Static/Events_Icon_White.png");
var _eventsIconWhitePngDefault = parcelHelpers.interopDefault(_eventsIconWhitePng);
var _fleetOverviewIconPng = require("./Static/FleetOverview_Icon.png");
var _fleetOverviewIconPngDefault = parcelHelpers.interopDefault(_fleetOverviewIconPng);
var _geofencingBlueIconPng = require("./Static/GeofencingBlue_Icon.png");
var _geofencingBlueIconPngDefault = parcelHelpers.interopDefault(_geofencingBlueIconPng);
var _geofencingWhiteIconPng = require("./Static/GeofencingWhite_Icon.png");
var _geofencingWhiteIconPngDefault = parcelHelpers.interopDefault(_geofencingWhiteIconPng);
var _groupPng = require("./Static/map-pins/group.png");
var _groupPngDefault = parcelHelpers.interopDefault(_groupPng);
var _maintenanceScheduleEmptyIconPng = require("./Static/MaintenanceSchedule_EmptyIcon.png");
var _maintenanceScheduleEmptyIconPngDefault = parcelHelpers.interopDefault(_maintenanceScheduleEmptyIconPng);
var _maintenanceScheduleIconWhitePng = require("./Static/MaintenanceSchedule_Icon_White.png");
var _maintenanceScheduleIconWhitePngDefault = parcelHelpers.interopDefault(_maintenanceScheduleIconWhitePng);
var _smallPng = require("./Static/map-marker-clusters/small.png");
var _smallPngDefault = parcelHelpers.interopDefault(_smallPng);
var _missingPng = require("./Static/missing.png");
var _missingPngDefault = parcelHelpers.interopDefault(_missingPng);
var _modbusIconPng = require("./Static/Modbus_Icon.png");
var _modbusIconPngDefault = parcelHelpers.interopDefault(_modbusIconPng);
var _offlinePng = require("./Static/map-pins/offline.png");
var _offlinePngDefault = parcelHelpers.interopDefault(_offlinePng);
var _defaultPng = require("./Static/map-pins/default.png");
var _defaultPngDefault = parcelHelpers.interopDefault(_defaultPng);
var _organizationIconPng = require("./Static/Organization_Icon.png");
var _organizationIconPngDefault = parcelHelpers.interopDefault(_organizationIconPng);
var _organizationIconWhitePng = require("./Static/Organization_Icon_White.png");
var _organizationIconWhitePngDefault = parcelHelpers.interopDefault(_organizationIconWhitePng);
var _partsBlueIconPng = require("./Static/PartsBlue_Icon.png");
var _partsBlueIconPngDefault = parcelHelpers.interopDefault(_partsBlueIconPng);
var _partsGreyIconPng = require("./Static/PartsGrey_Icon.png");
var _partsGreyIconPngDefault = parcelHelpers.interopDefault(_partsGreyIconPng);
var _primaryLinkPng = require("./Static/primary_link.png");
var _primaryLinkPngDefault = parcelHelpers.interopDefault(_primaryLinkPng);
var _assetProvisioningIconPng = require("./Static/AssetProvisioningIcon.png");
var _assetProvisioningIconPngDefault = parcelHelpers.interopDefault(_assetProvisioningIconPng);
var _assetProvisioningIconWhitePng = require("./Static/AssetProvisioningIcon_White.png");
var _assetProvisioningIconWhitePngDefault = parcelHelpers.interopDefault(_assetProvisioningIconWhitePng);
var _pumpIconPng = require("./Static/pump-icon.png");
var _pumpIconPngDefault = parcelHelpers.interopDefault(_pumpIconPng);
var _reminderIconPng = require("./Static/Reminder_Icon.png");
var _reminderIconPngDefault = parcelHelpers.interopDefault(_reminderIconPng);
var _reportingIconPng = require("./Static/Reporting_Icon.png");
var _reportingIconPngDefault = parcelHelpers.interopDefault(_reportingIconPng);
var _searchIconPng = require("./Static/Search_Icon.png");
var _searchIconPngDefault = parcelHelpers.interopDefault(_searchIconPng);
var _searchIconLargePng = require("./Static/Search_Icon_Large.png");
var _searchIconLargePngDefault = parcelHelpers.interopDefault(_searchIconLargePng);
var _datapointPng = require("./Static/datapoint.png");
var _datapointPngDefault = parcelHelpers.interopDefault(_datapointPng);
var _signalIconWhitePng = require("./Static/Signal_Icon_White.png");
var _signalIconWhitePngDefault = parcelHelpers.interopDefault(_signalIconWhitePng);
var _usersIconPng = require("./Static/Users_Icon.png");
var _usersIconPngDefault = parcelHelpers.interopDefault(_usersIconPng);
var _usersIconWhitePng = require("./Static/Users_Icon_White.png");
var _usersIconWhitePngDefault = parcelHelpers.interopDefault(_usersIconWhitePng);
var _widgetIconPng = require("./Static/widget-icon.png");
var _widgetIconPngDefault = parcelHelpers.interopDefault(_widgetIconPng);
var _constants = require("./Styles/constants");
const images = {
    alarmPin: (0, _alarmPngDefault.default),
    alertHeaderDesktop: (0, _newAlertHeaderDesktopSvgDefault.default),
    alertHeaderMobile: (0, _newAlertHeaderSvgDefault.default),
    assetIconRed: (0, _assetIconRedPngDefault.default),
    assetIconWhite: (0, _assetIconWhitePngDefault.default),
    assetModelIcon: (0, _assetModelIconPngDefault.default),
    assetModelIconWhite: (0, _assetModelIconWhitePngDefault.default),
    avatar: (0, _profileIconPngDefault.default),
    certificateIcon: (0, _certificateIconPngDefault.default),
    chartIcon: (0, _chartIconPngDefault.default),
    commandControlIcon: (0, _commandControlIconPngDefault.default),
    conditionsIcon: (0, _conditionsIconPngDefault.default),
    cumminsBannerDesktop: (0, _cumminsBannerDesktopSvgDefault.default),
    cumminsBannerMobile: (0, _cumminsBannerMobileSvgDefault.default),
    cumminsIconBlack: (0, _cumminsLogoBlackPngDefault.default),
    cumminsIconWhite: (0, _cumminsLogoWhitePngDefault.default),
    emptyStateIcon: (0, _iconEmptyStateSvgDefault.default),
    engineIcon: (0, _carEngineSvgDefault.default),
    errorPageIcon: (0, _404IconPngDefault.default),
    eventsIcon: (0, _eventsIconWhitePngDefault.default),
    fleetIcon: (0, _fleetOverviewIconPngDefault.default),
    geofencingIconBlue: (0, _geofencingBlueIconPngDefault.default),
    geofencingIconWhite: (0, _geofencingWhiteIconPngDefault.default),
    groupPin: (0, _groupPngDefault.default),
    maintenanceIconEmpty: (0, _maintenanceScheduleEmptyIconPngDefault.default),
    maintenanceIconWhite: (0, _maintenanceScheduleIconWhitePngDefault.default),
    mapClusterIcon: (0, _smallPngDefault.default),
    missingImage: (0, _missingPngDefault.default),
    modbusIcon: (0, _modbusIconPngDefault.default),
    offlinePin: (0, _offlinePngDefault.default),
    onlinePin: (0, _defaultPngDefault.default),
    orgIcon: (0, _organizationIconPngDefault.default),
    orgIconWhite: (0, _organizationIconWhitePngDefault.default),
    partsIconBlue: (0, _partsBlueIconPngDefault.default),
    partsIconGrey: (0, _partsGreyIconPngDefault.default),
    primaryLinkIcon: (0, _primaryLinkPngDefault.default),
    profileIcon: (0, _profileIconPngDefault.default),
    provisionIcon: (0, _assetProvisioningIconPngDefault.default),
    provisionIconWhite: (0, _assetProvisioningIconWhitePngDefault.default),
    pumpIcon: (0, _pumpIconPngDefault.default),
    reminderIcon: (0, _reminderIconPngDefault.default),
    reportingIcon: (0, _reportingIconPngDefault.default),
    searchIcon: (0, _searchIconPngDefault.default),
    searchIconLg: (0, _searchIconLargePngDefault.default),
    signalIcon: (0, _datapointPngDefault.default),
    signalIconWhite: (0, _signalIconWhitePngDefault.default),
    usersIcon: (0, _usersIconPngDefault.default),
    usersIconWhite: (0, _usersIconWhitePngDefault.default),
    widgetIcon: (0, _widgetIconPngDefault.default)
};
const mapLibraries = [
    "drawing",
    "geometry"
];
const initState = {
    currentOrg: {},
    currentUser: {},
    error: "",
    nextOrgName: "",
    orgsMap: {},
    rootOrg: {},
    searchTerm: "",
    showOverlay: false,
    sidebarCollapsed: false,
    width: window.innerWidth
};
function Providers({ branding }) {
    const [state, updateState] = (0, _react.useState)(initState);
    const history = (0, _reactRouterDom.useHistory)(), location = (0, _reactRouterDom.useLocation)();
    const targetPath = (0, _react.useMemo)(()=>location.pathname === "/login" ? "" : `${location.pathname}${location.search}`, [
        location.pathname,
        location.search
    ]);
    const loginRedirect = (0, _react.useMemo)(()=>({
            pathname: "/login",
            state: {
                targetPath
            }
        }), [
        targetPath
    ]);
    const accountService = (0, _react.useMemo)(()=>new (0, _accountServiceDefault.default)(), []), api = (0, _react.useMemo)(()=>new (0, _requestsDefault.default)(), []), auth = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []), isDesktop = (0, _react.useMemo)(()=>state.width >= (0, _constants.LARGE_WIDTH_PX), [
        state.width
    ]), localStorageService = (0, _react.useMemo)(()=>new (0, _localStorageServiceDefault.default)(), []), orgService = (0, _react.useMemo)(()=>new (0, _organizationServiceDefault.default)(), []);
    let source = (0, _axios.CancelToken).source();
    const exitSubOrg = async (nextOrgID, nextOrgName)=>{
        updateState((prevState)=>({
                ...prevState,
                nextOrgName,
                showOverlay: true
            }));
        auth.setCurrentOrgID(nextOrgID);
        if (nextOrgID === state.rootOrg?._id) return updateState((prevState)=>({
                ...prevState,
                currentOrg: state.rootOrg,
                showOverlay: false
            }));
        try {
            const nextOrg = await orgService.fetchFullOrgDetails(nextOrgID, true, source.token);
            updateState((prevState)=>({
                    ...prevState,
                    currentOrg: nextOrg,
                    showOverlay: false
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    currentOrg: state.rootOrg,
                    showOverlay: false
                }));
        }
    };
    const handleSearchTerm = ({ target: { value: searchTerm } })=>{
        updateState((prevState)=>({
                ...prevState,
                searchTerm
            }));
    };
    const handleSubOrgDelete = async ()=>{
        try {
            const rootOrgID = auth.getUserRootOrgID();
            const currentOrgID = auth.getCurrentOrgID();
            const currentlyViewingRoot = rootOrgID === currentOrgID;
            const rootOrgRequest = orgService.fetchFullOrgDetails(rootOrgID, true, source.token);
            let currentOrgRequest;
            if (!currentlyViewingRoot) currentOrgRequest = orgService.fetchFullOrgDetails(currentOrgID, true, source.token);
            const [rootOrg, currentOrg] = await Promise.all([
                rootOrgRequest,
                currentOrgRequest
            ]);
            const orgsMap = generateOrgsMap(rootOrg);
            updateState((prevState)=>({
                    ...prevState,
                    orgsMap,
                    rootOrg,
                    currentOrg: currentlyViewingRoot ? rootOrg : currentOrg
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    };
    const resetStateOnLogout = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                rootOrg: {},
                currentOrg: {},
                currentUser: {},
                orgsMap: {}
            }));
    }, []);
    const setCurrentOrg = async (org)=>{
        if (Object.keys(org || {})?.length) return updateState((prevState)=>({
                ...prevState,
                currentOrg: org
            }));
        try {
            const currentOrg = await orgService.fetchFullOrgDetails(auth.getCurrentOrgID(), true, source.token);
            updateState((prevState)=>({
                    ...prevState,
                    currentOrg
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    };
    const toggleSidebarCollapsed = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                sidebarCollapsed: !prevState.sidebarCollapsed
            }));
    }, []);
    const updateCurrentOrg = (0, _react.useCallback)((orgUpdate, newOrg)=>{
        updateState((prevState)=>{
            const currentOrg = {
                ...prevState.currentOrg,
                ...orgUpdate
            };
            const orgsMap = newOrg ? {
                ...prevState.orgsMap,
                [newOrg._id]: {
                    logo: newOrg.logo,
                    name: newOrg.name,
                    path: newOrg.path
                }
            } : prevState.orgsMap;
            return {
                ...prevState,
                currentOrg,
                orgsMap
            };
        });
    }, []);
    const updateCurrentUser = (0, _react.useCallback)((userUpdate)=>{
        updateState((prevState)=>{
            const currentUser = {
                ...prevState.currentUser,
                ...userUpdate
            };
            return {
                ...prevState,
                currentUser
            };
        });
    }, []);
    const updateWindowDimensions = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                width: window.innerWidth
            }));
    }, []);
    const _componentCleanup = ()=>{
        window.removeEventListener("resize", updateWindowDimensions);
        source.cancel();
    };
    const _setInitState = async ()=>{
        const NO_SESSION_TOKEN_MSG = "session token not set";
        const ROOT_ORG_ID_NOT_SET_MSG = "rootOrgID not set";
        const CURRENT_ORG_ID_NOT_SET_MSG = "currentOrgID not set";
        try {
            const currentOrgID = auth.getCurrentOrgID();
            const rootOrgID = auth.getUserRootOrgID();
            const currentOrgIsRoot = currentOrgID === rootOrgID;
            const currentUserReq = Object.keys(state.currentUser || {})?.length ? state.currentUser : !auth.getToken() ? generatePromiseError(NO_SESSION_TOKEN_MSG) : accountService.fetchCurrentUserDetails(source.token);
            const rootOrgReq = Object.keys(state.rootOrg || {})?.length ? state.rootOrg : !rootOrgID ? generatePromiseError(ROOT_ORG_ID_NOT_SET_MSG) : orgService.fetchFullOrgDetails(rootOrgID, true, source.token);
            const currentOrgReq = Object.keys(state.currentOrg || {})?.length ? state.currentOrg : !currentOrgID ? generatePromiseError(CURRENT_ORG_ID_NOT_SET_MSG) : currentOrgIsRoot ? null : orgService.fetchFullOrgDetails(currentOrgID, true, source.token);
            const [currentUser, rootOrg, currentOrg] = await Promise.all([
                currentUserReq,
                rootOrgReq,
                currentOrgReq
            ]);
            const orgsMap = generateOrgsMap(rootOrg);
            const permissions = localStorageService.getObjectByKey("permissions");
            if (!permissions) {
                await api.request(auth.buildLogoutRequest());
                auth.logout();
                history.replace("/login");
            }
            updateState((prevState)=>({
                    ...prevState,
                    currentOrg: currentOrgIsRoot ? rootOrg : currentOrg,
                    currentUser,
                    orgsMap,
                    permissions,
                    rootOrg
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            if (err.response?.status === 401 || err.message === NO_SESSION_TOKEN_MSG) {
                auth.logout();
                history.replace(loginRedirect);
            } else {
                const error = err.response?.data?.message ?? err.message;
                updateState((prevState)=>({
                        ...prevState,
                        error
                    }));
            }
        }
    };
    (0, _react.useEffect)(()=>{
        window.addEventListener("resize", updateWindowDimensions);
        _setInitState();
        return _componentCleanup;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _brandingContext.BrandingProvider), {
            value: branding,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rootOrgContext.RootOrgProvider), {
                value: state.rootOrg,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orgsMapContext.OrgsMapProvider), {
                    value: state.orgsMap,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permissionsContext.PermissionsProvider), {
                        value: state.permissions,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _currentOrgContext.CurrentOrgProvider), {
                            value: state.currentOrg,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _currentUserContext.CurrentUserProvider), {
                                value: state.currentUser,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateCurrentOrgContext.UpdateCurrentOrgProvider), {
                                    value: updateCurrentOrg,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _setCurrentOrgContext.SetCurrentOrgProvider), {
                                        value: setCurrentOrg,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateCurrentUserContext.UpdateCurrentUserProvider), {
                                            value: updateCurrentUser,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exitSubOrgContext.ExitSubOrgProvider), {
                                                value: exitSubOrg,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _handleSubOrgDeleteContext.HandleSubOrgDeleteProvider), {
                                                    value: handleSubOrgDelete,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleSidebarContext.ToggleSidebarContextProvider), {
                                                        value: toggleSidebarCollapsed,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userContext.UserProvider), {
                                                            value: state.currentUser,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widthContext.WidthProvider), {
                                                                value: state.width,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breakpointContext.BreakpointProvider), {
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetGlobalStateContext.ResetGlobalStateProvider), {
                                                                        value: resetStateOnLogout,
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsContext.IconsProvider), {
                                                                            value: {
                                                                                ...images,
                                                                                assetIcon: branding?.asset_icon,
                                                                                eventsHeaderDesktop: branding?.events_banner_desktop_url,
                                                                                fleetHeaderDesktop: branding?.fleet_banner_desktop_url,
                                                                                inventoryHeaderDesktop: branding?.inventory_banner_desktop_url,
                                                                                inventoryHeaderMobile: branding?.inventory_banner_mobile_url,
                                                                                loginBackgroundImage: branding?.login_background_url,
                                                                                reportsHeaderDesktop: branding?.reports_banner_desktop_url,
                                                                                reportsHeaderMobile: branding?.reports_banner_mobile_url,
                                                                                tigeLoginBackgroundImage: branding?.tige_login_background_url
                                                                            },
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.LoadScript), {
                                                                                googleMapsApiKey: "AIzaSyAI-GoNhhM7LvAik30Q9td_EmNd0v3k8hM",
                                                                                libraries: mapLibraries,
                                                                                loadingElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "w-100 d-flex align-items-center justify-content-center",
                                                                                    style: {
                                                                                        height: isDesktop ? (0, _constants.MAIN_HEIGHT) : (0, _constants.MOBILE_MAIN_HEIGHT)
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                                                                                        size: "5x"
                                                                                    })
                                                                                }),
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routesDefault.default), {
                                                                                    ...state,
                                                                                    handleLoginSuccess: _setInitState,
                                                                                    handleSearchTerm: handleSearchTerm,
                                                                                    missingImage: (0, _missingPngDefault.default),
                                                                                    profileIcon: (0, _profileIconPngDefault.default),
                                                                                    setCurrentOrg: setCurrentOrg,
                                                                                    updateCurrentUser: updateCurrentUser
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
Providers.propTypes = {
    branding: (0, _propTypesDefault.default).object
};
function generateOrgsMap(rootOrg) {
    if (!Array.isArray(rootOrg?.children)) return {};
    return rootOrg.children.concat(rootOrg).reduce((map, { _id, features, gatewayCount, logo, name, path })=>{
        map[_id] = {
            features,
            gatewayCount,
            logo,
            name,
            path
        };
        return map;
    }, {});
}
function generatePromiseError(msg) {
    return new Promise((_, reject)=>reject(new Error(msg)));
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","@react-google-maps/api":"jDQ7N","./Lib/Requests":"j1WJQ","./Services/AuthService":"8Bjjn","./Services/AccountService":"3PgTR","./Services/LocalStorageService":"3Alt2","./Services/OrganizationService":"lm5wc","./Components/ErrorBoundary":"e71Au","./Components/LoadingCircle":"aIADA","./Routes":"jMWuK","./Context/BrandingContext":"bKKTd","./Context/BreakpointContext":"lh42t","./Context/CurrentOrgContext":"jQXcJ","./Context/CurrentUserContext":"4sVVe","./Context/ExitSubOrgContext":"cUD9x","./Context/HandleSubOrgDeleteContext":"i80mu","./Context/IconsContext":"lzIpe","./Context/OrgsMapContext":"asozp","./Context/PermissionsContext":"gHIjM","./Context/ResetGlobalStateContext":"4cXMv","./Context/RootOrgContext":"2o1kk","./Context/SetCurrentOrgContext":"bWsFg","./Context/ToggleSidebarContext":"g92ON","./Context/UpdateCurrentOrgContext":"eVyI1","./Context/UpdateCurrentUserContext":"LeTfk","./Context/UserContext":"8DVeH","./Context/WidthContext":"5c6Dv","./Static/map-pins/alarm.png":"b8beP","./Static/new_alert_header_desktop.svg":"chbnG","./Static/new_alert_header.svg":"kt4EW","./Static/AssetIconRed.png":"btpve","./Static/Asset_Icon_White.png":"3zu8Y","./Static/AssetModel_Icon.png":"giZVQ","./Static/AssetModel_Icon_White.png":"gq0Wu","./Static/Profile_Icon.png":"kcfSA","./Static/Certificate_Icon.png":"fIi51","./Static/Chart_Icon.png":"5xpAz","./Static/CommandControl_Icon.png":"aMouh","./Static/Conditions_Icon.png":"gA93y","./Static/cummins_banner_desktop.svg":"bYsT4","./Static/cummins_banner_mobile.svg":"2k9GL","./Static/cummins_logo_black.png":"kGXJp","./Static/cummins_logo_white.png":"e2hbR","./Static/Icon_EmptyState.svg":"65l6N","./Static/car-engine.svg":"k5dC7","./Static/404_Icon.png":"aWTS6","./Static/Events_Icon_White.png":"2VqkB","./Static/FleetOverview_Icon.png":"jS8L6","./Static/GeofencingBlue_Icon.png":"iihRO","./Static/GeofencingWhite_Icon.png":"lA2rM","./Static/map-pins/group.png":"6sQbK","./Static/MaintenanceSchedule_EmptyIcon.png":"6Baon","./Static/MaintenanceSchedule_Icon_White.png":"krJx6","./Static/map-marker-clusters/small.png":"gcu4R","./Static/missing.png":"d11iF","./Static/Modbus_Icon.png":"imG8w","./Static/map-pins/offline.png":"fb9TB","./Static/map-pins/default.png":"c1css","./Static/Organization_Icon.png":"eR8Lo","./Static/Organization_Icon_White.png":"icguo","./Static/PartsBlue_Icon.png":"eoIMD","./Static/PartsGrey_Icon.png":"dhkXR","./Static/primary_link.png":"7XIwm","./Static/AssetProvisioningIcon.png":"2w1dR","./Static/AssetProvisioningIcon_White.png":"6a8pG","./Static/pump-icon.png":"40L5P","./Static/Reminder_Icon.png":"fN24t","./Static/Reporting_Icon.png":"8jp9H","./Static/Search_Icon.png":"3Imuy","./Static/Search_Icon_Large.png":"4F5bQ","./Static/datapoint.png":"8dr9N","./Static/Signal_Icon_White.png":"1LC3N","./Static/Users_Icon.png":"cwdod","./Static/Users_Icon_White.png":"i5eGq","./Static/widget-icon.png":"ahTto","./Styles/constants":"gIVbf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffpgq":[function(require,module,exports) {
module.exports = require("9f37cef8b0e13afc");

},{"9f37cef8b0e13afc":"lHA81"}],"lHA81":[function(require,module,exports) {
"use strict";
var utils = require("1137fef34918bf53");
var bind = require("ce63a8247a300202");
var Axios = require("c14c66f4c3ec48a2");
var mergeConfig = require("345f9ec0ee8efc80");
var defaults = require("27bdb15d131780c5");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);
    // Copy axios.prototype to instance
    utils.extend(instance, Axios.prototype, context);
    // Copy context to instance
    utils.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var axios = createInstance(defaults);
// Expose Axios class to allow class inheritance
axios.Axios = Axios;
// Expose Cancel & CancelToken
axios.CanceledError = require("99821b4fc0ba2f69");
axios.CancelToken = require("853fec7db7d524b4");
axios.isCancel = require("322a636c3e2325e1");
axios.VERSION = require("3d6b2db6c802d85d").version;
axios.toFormData = require("ef33bb7abb9fa67d");
// Expose AxiosError class
axios.AxiosError = require("a5206ee4d751b44");
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = require("75c7c70e55d88256");
// Expose isAxiosError
axios.isAxiosError = require("543a1da09311ae9b");
module.exports = axios;
// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"1137fef34918bf53":"4uo9i","ce63a8247a300202":"gKyRf","c14c66f4c3ec48a2":"dXDNP","345f9ec0ee8efc80":"1xY8J","27bdb15d131780c5":"gguXD","99821b4fc0ba2f69":"lfAwZ","853fec7db7d524b4":"fa4h3","322a636c3e2325e1":"5w9uS","3d6b2db6c802d85d":"hl0B4","ef33bb7abb9fa67d":"kISIL","a5206ee4d751b44":"kinyp","75c7c70e55d88256":"kQZVl","543a1da09311ae9b":"98mQL"}],"4uo9i":[function(require,module,exports) {
"use strict";
var bind = require("a7c7b4094caa86ac");
// utils is a library of generic helper functions non-specific to axios
var toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var isArrayBuffer = kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function isPlainObject(val) {
    if (kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var isDate = kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var isFile = kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var isBlob = kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var isFileList = kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function isFunction(val) {
    return toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var isURLSearchParams = kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function merge() {
    var result = {};
    function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
        else if (isPlainObject(val)) result[key] = merge({}, val);
        else if (isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = bind(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if (isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM,
    inherits: inherits,
    toFlatObject: toFlatObject,
    kindOf: kindOf,
    kindOfTest: kindOfTest,
    endsWith: endsWith,
    toArray: toArray,
    isTypedArray: isTypedArray,
    isFileList: isFileList
};

},{"a7c7b4094caa86ac":"gKyRf"}],"gKyRf":[function(require,module,exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

},{}],"dXDNP":[function(require,module,exports) {
"use strict";
var utils = require("2cd2d0baba832579");
var buildURL = require("945ebba9256ed84f");
var InterceptorManager = require("fc2d71ae77ba798e");
var dispatchRequest = require("77b4f57f4d663a9b");
var mergeConfig = require("5db81a4f62f8927d");
var buildFullPath = require("bba783c05a4f93f7");
var validator = require("d0f5147a00cee7c5");
var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = mergeConfig(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            dispatchRequest,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = dispatchRequest(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
Axios.prototype.getUri = function getUri(config) {
    config = mergeConfig(this.defaults, config);
    var fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
utils.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
utils.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request(mergeConfig(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = Axios;

},{"2cd2d0baba832579":"4uo9i","945ebba9256ed84f":"2yc3i","fc2d71ae77ba798e":"gBR9v","77b4f57f4d663a9b":"9BYjJ","5db81a4f62f8927d":"1xY8J","bba783c05a4f93f7":"dqGPZ","d0f5147a00cee7c5":"jxy99"}],"2yc3i":[function(require,module,exports) {
"use strict";
var utils = require("d198994ea2a45305");
function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if (utils.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if (utils.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            utils.forEach(val, function parseValue(v) {
                if (utils.isDate(v)) v = v.toISOString();
                else if (utils.isObject(v)) v = JSON.stringify(v);
                parts.push(encode(key) + "=" + encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

},{"d198994ea2a45305":"4uo9i"}],"gBR9v":[function(require,module,exports) {
"use strict";
var utils = require("982be9ba543c1801");
function InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ InterceptorManager.prototype.forEach = function forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = InterceptorManager;

},{"982be9ba543c1801":"4uo9i"}],"9BYjJ":[function(require,module,exports) {
"use strict";
var utils = require("dccb83262660ba2a");
var transformData = require("670a836c9c5a1abe");
var isCancel = require("9b938a75c8452b2f");
var defaults = require("293260d2186f65fb");
var CanceledError = require("babe605ae6871369");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new CanceledError();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = transformData.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    utils.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || defaults.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

},{"dccb83262660ba2a":"4uo9i","670a836c9c5a1abe":"kzWBF","9b938a75c8452b2f":"5w9uS","293260d2186f65fb":"gguXD","babe605ae6871369":"lfAwZ"}],"kzWBF":[function(require,module,exports) {
"use strict";
var utils = require("506225f7f22ee5b3");
var defaults = require("933dc4966aff4cbe");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || defaults;
    /*eslint no-param-reassign:0*/ utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

},{"506225f7f22ee5b3":"4uo9i","933dc4966aff4cbe":"gguXD"}],"gguXD":[function(require,module,exports) {
var process = require("8191483f14ddb73c");
"use strict";
var utils = require("e81e3dbd1959aa01");
var normalizeHeaderName = require("753007ee6e6399c7");
var AxiosError = require("e9c38e32fac9e03e");
var transitionalDefaults = require("5a1b45724cbabfe9");
var toFormData = require("ce7605268fbf7e42");
var DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
    if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}
function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = require("96a55d646cd53040");
    else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") // For node use HTTP adapter
    adapter = require("3d0364fd0ce54db5");
    return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
    if (utils.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return utils.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var defaults = {
    transitional: transitionalDefaults,
    adapter: getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            normalizeHeaderName(headers, "Accept");
            normalizeHeaderName(headers, "Content-Type");
            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) return data;
            if (utils.isArrayBufferView(data)) return data.buffer;
            if (utils.isURLSearchParams(data)) {
                setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = utils.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = utils.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return toFormData(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                setContentTypeIfUnset(headers, "application/json");
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: require("2c6a31d8df55e92a")
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
utils.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    defaults.headers[method] = {};
});
utils.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
module.exports = defaults;

},{"8191483f14ddb73c":"5jT8D","e81e3dbd1959aa01":"4uo9i","753007ee6e6399c7":"jWVQJ","e9c38e32fac9e03e":"kinyp","5a1b45724cbabfe9":"fnl8o","ce7605268fbf7e42":"kISIL","96a55d646cd53040":"i0pe0","3d0364fd0ce54db5":"i0pe0","2c6a31d8df55e92a":"3nCRV"}],"5jT8D":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"jWVQJ":[function(require,module,exports) {
"use strict";
var utils = require("5f8afca0889a63e1");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

},{"5f8afca0889a63e1":"4uo9i"}],"kinyp":[function(require,module,exports) {
"use strict";
var utils = require("90d7c965e732ce33");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
utils.inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var prototype = AxiosError.prototype;
var descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create(prototype);
    utils.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = AxiosError;

},{"90d7c965e732ce33":"4uo9i"}],"fnl8o":[function(require,module,exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{}],"kISIL":[function(require,module,exports) {
var Buffer = require("adfd9b103875c2dd").Buffer;
"use strict";
var utils = require("3a99ebcd36a8733f");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if (utils.isDate(value)) return value.toISOString();
        if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if (utils.isPlainObject(data) || utils.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            utils.forEach(data, function each(value, key) {
                if (utils.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if (utils.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if (utils.endsWith(key, "[]") && (arr = utils.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = toFormData;

},{"adfd9b103875c2dd":"dB11O","3a99ebcd36a8733f":"4uo9i"}],"dB11O":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"9c62938f1dccc73c":"ettWx","aceacb6a4531a9d2":"6DXND"}],"ettWx":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6DXND":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"i0pe0":[function(require,module,exports) {
"use strict";
var utils = require("2bb8b5f6db10dd6d");
var settle = require("a7b983c12bb9f77f");
var cookies = require("19bdb320f45f036e");
var buildURL = require("568f70ee55491398");
var buildFullPath = require("a1fd5a6807469b6d");
var parseHeaders = require("f197d20bdfdcd5a4");
var isURLSameOrigin = require("32737c301de74bf5");
var transitionalDefaults = require("acf3ae0da9073396");
var AxiosError = require("5cdb5bed725b4b9d");
var CanceledError = require("4bb5ca1319af05c5");
var parseProtocol = require("edff7382320539d7");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            settle(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || transitionalDefaults;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if (utils.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!utils.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new CanceledError() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = parseProtocol(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

},{"2bb8b5f6db10dd6d":"4uo9i","a7b983c12bb9f77f":"bYbho","19bdb320f45f036e":"fq1CU","568f70ee55491398":"2yc3i","a1fd5a6807469b6d":"dqGPZ","f197d20bdfdcd5a4":"7iHXN","32737c301de74bf5":"3wNi6","acf3ae0da9073396":"fnl8o","5cdb5bed725b4b9d":"kinyp","4bb5ca1319af05c5":"lfAwZ","edff7382320539d7":"96o7u"}],"bYbho":[function(require,module,exports) {
"use strict";
var AxiosError = require("99b767d0f87e1d33");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new AxiosError("Request failed with status code " + response.status, [
        AxiosError.ERR_BAD_REQUEST,
        AxiosError.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

},{"99b767d0f87e1d33":"kinyp"}],"fq1CU":[function(require,module,exports) {
"use strict";
var utils = require("c987331427b8b2ad");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if (utils.isString(path)) cookie.push("path=" + path);
            if (utils.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

},{"c987331427b8b2ad":"4uo9i"}],"dqGPZ":[function(require,module,exports) {
"use strict";
var isAbsoluteURL = require("5ff0e8c05aa13380");
var combineURLs = require("e1ac36eef7d02fa4");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) return combineURLs(baseURL, requestedURL);
    return requestedURL;
};

},{"5ff0e8c05aa13380":"kKGFA","e1ac36eef7d02fa4":"aIa5z"}],"kKGFA":[function(require,module,exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

},{}],"aIa5z":[function(require,module,exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

},{}],"7iHXN":[function(require,module,exports) {
"use strict";
var utils = require("5802dc5113a634d0");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

},{"5802dc5113a634d0":"4uo9i"}],"3wNi6":[function(require,module,exports) {
"use strict";
var utils = require("c8f79893fd676b4c");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"c8f79893fd676b4c":"4uo9i"}],"lfAwZ":[function(require,module,exports) {
"use strict";
var AxiosError = require("d49629127e21c372");
var utils = require("a3a18563c2683e33");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED);
    this.name = "CanceledError";
}
utils.inherits(CanceledError, AxiosError, {
    __CANCEL__: true
});
module.exports = CanceledError;

},{"d49629127e21c372":"kinyp","a3a18563c2683e33":"4uo9i"}],"96o7u":[function(require,module,exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

},{}],"3nCRV":[function(require,module,exports) {
// eslint-disable-next-line strict
module.exports = null;

},{}],"5w9uS":[function(require,module,exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

},{}],"1xY8J":[function(require,module,exports) {
"use strict";
var utils = require("99adbff39af8f677");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) return utils.merge(target, source);
        else if (utils.isPlainObject(source)) return utils.merge({}, source);
        else if (utils.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!utils.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!utils.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

},{"99adbff39af8f677":"4uo9i"}],"jxy99":[function(require,module,exports) {
"use strict";
var VERSION = require("e9aa819e853e8a05").version;
var AxiosError = require("d650eba95d68de74");
var validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new AxiosError(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), AxiosError.ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: assertOptions,
    validators: validators
};

},{"e9aa819e853e8a05":"hl0B4","d650eba95d68de74":"kinyp"}],"hl0B4":[function(require,module,exports) {
module.exports = {
    "version": "0.27.2"
};

},{}],"fa4h3":[function(require,module,exports) {
"use strict";
var CanceledError = require("b6a43aee12b81881");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new CanceledError(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = CancelToken;

},{"b6a43aee12b81881":"lfAwZ"}],"kQZVl":[function(require,module,exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

},{}],"98mQL":[function(require,module,exports) {
"use strict";
var utils = require("231ee4a1ecb1dc47");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return utils.isObject(payload) && payload.isAxiosError === true;
};

},{"231ee4a1ecb1dc47":"4uo9i"}],"jDQ7N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Autocomplete", ()=>Autocomplete);
parcelHelpers.export(exports, "BicyclingLayer", ()=>BicyclingLayer);
parcelHelpers.export(exports, "BicyclingLayerF", ()=>BicyclingLayerF);
parcelHelpers.export(exports, "Circle", ()=>Circle);
parcelHelpers.export(exports, "CircleF", ()=>CircleF);
parcelHelpers.export(exports, "Data", ()=>Data);
parcelHelpers.export(exports, "DataF", ()=>DataF);
parcelHelpers.export(exports, "DirectionsRenderer", ()=>DirectionsRenderer);
parcelHelpers.export(exports, "DirectionsService", ()=>DirectionsService);
parcelHelpers.export(exports, "DistanceMatrixService", ()=>DistanceMatrixService);
parcelHelpers.export(exports, "DrawingManager", ()=>DrawingManager);
parcelHelpers.export(exports, "DrawingManagerF", ()=>DrawingManagerF);
parcelHelpers.export(exports, "FLOAT_PANE", ()=>FLOAT_PANE);
parcelHelpers.export(exports, "GoogleMap", ()=>GoogleMap);
parcelHelpers.export(exports, "GoogleMapsMarkerClusterer", ()=>index_esm);
parcelHelpers.export(exports, "GoogleMarkerClusterer", ()=>GoogleMarkerClusterer$1);
parcelHelpers.export(exports, "GroundOverlay", ()=>GroundOverlay);
parcelHelpers.export(exports, "GroundOverlayF", ()=>GroundOverlayF);
parcelHelpers.export(exports, "HeatmapLayer", ()=>HeatmapLayer);
parcelHelpers.export(exports, "HeatmapLayerF", ()=>HeatmapLayerF);
parcelHelpers.export(exports, "InfoBox", ()=>InfoBoxComponent);
parcelHelpers.export(exports, "InfoBoxF", ()=>InfoBoxF);
parcelHelpers.export(exports, "InfoWindow", ()=>InfoWindow);
parcelHelpers.export(exports, "InfoWindowF", ()=>InfoWindowF);
parcelHelpers.export(exports, "KmlLayer", ()=>KmlLayer);
parcelHelpers.export(exports, "LoadScript", ()=>LoadScript);
parcelHelpers.export(exports, "LoadScriptNext", ()=>LoadScriptNext$1);
parcelHelpers.export(exports, "MAP_PANE", ()=>MAP_PANE);
parcelHelpers.export(exports, "MARKER_LAYER", ()=>MARKER_LAYER);
parcelHelpers.export(exports, "MapContext", ()=>MapContext);
parcelHelpers.export(exports, "Marker", ()=>Marker);
parcelHelpers.export(exports, "MarkerClusterer", ()=>ClustererComponent);
parcelHelpers.export(exports, "MarkerClustererF", ()=>MarkerClustererF);
parcelHelpers.export(exports, "MarkerF", ()=>MarkerF);
parcelHelpers.export(exports, "OVERLAY_LAYER", ()=>OVERLAY_LAYER);
parcelHelpers.export(exports, "OVERLAY_MOUSE_TARGET", ()=>OVERLAY_MOUSE_TARGET);
parcelHelpers.export(exports, "OverlayView", ()=>OverlayView);
parcelHelpers.export(exports, "OverlayViewF", ()=>OverlayViewF);
parcelHelpers.export(exports, "Polygon", ()=>Polygon);
parcelHelpers.export(exports, "PolygonF", ()=>PolygonF);
parcelHelpers.export(exports, "Polyline", ()=>Polyline);
parcelHelpers.export(exports, "PolylineF", ()=>PolylineF);
parcelHelpers.export(exports, "Rectangle", ()=>Rectangle);
parcelHelpers.export(exports, "RectangleF", ()=>RectangleF);
parcelHelpers.export(exports, "StandaloneSearchBox", ()=>StandaloneSearchBox);
parcelHelpers.export(exports, "StreetViewPanorama", ()=>StreetViewPanorama);
parcelHelpers.export(exports, "StreetViewService", ()=>StreetViewService);
parcelHelpers.export(exports, "TrafficLayer", ()=>TrafficLayer);
parcelHelpers.export(exports, "TrafficLayerF", ()=>TrafficLayerF);
parcelHelpers.export(exports, "TransitLayer", ()=>TransitLayer);
parcelHelpers.export(exports, "TransitLayerF", ()=>TransitLayerF);
parcelHelpers.export(exports, "useGoogleMap", ()=>useGoogleMap);
parcelHelpers.export(exports, "useJsApiLoader", ()=>useJsApiLoader);
parcelHelpers.export(exports, "useLoadScript", ()=>useLoadScript);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDom = require("react-dom");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest$1(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var NODE_ENV = "development";
var invariant = function(condition, format, a, b, c, d, e, f) {
    if (NODE_ENV !== "production") {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
var invariant_1 = invariant;
var invariant$1 = /*@__PURE__*/ getDefaultExportFromCjs(invariant_1);
var MapContext = (0, _react.createContext)(null);
function useGoogleMap() {
    invariant$1(!!(0, _react.useContext), "useGoogleMap is React hook and requires React version 16.8+");
    var map = (0, _react.useContext)(MapContext);
    invariant$1(!!map, "useGoogleMap needs a GoogleMap available up in the tree");
    return map;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reduce(obj, fn, acc) {
    return Object.keys(obj).reduce(function reducer(newAcc, key) {
        return fn(newAcc, obj[key], key);
    }, acc);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forEach(obj, fn) {
    Object.keys(obj).forEach(function(key) {
        return fn(obj[key], key);
    });
}
/* global google */ function applyUpdaterToNextProps(// eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap, // eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var iter = function(fn, key) {
        var nextValue = nextProps[key];
        if (nextValue !== prevProps[key]) {
            map[key] = nextValue;
            fn(instance, nextValue);
        }
    };
    forEach(updaterMap, iter);
    return map;
}
function registerEvents(// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
    var registeredList = reduce(eventMap, function reducer(acc, googleEventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onEventName) {
        if (typeof props[onEventName] === "function") acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
        return acc;
    }, []);
    return registeredList;
}
function unregisterEvent(registered) {
    google.maps.event.removeListener(registered);
}
function unregisterEvents(events) {
    if (events === void 0) events = [];
    events.forEach(unregisterEvent);
}
function applyUpdatersToPropsAndRegisterEvents(_a) {
    var updaterMap = _a.updaterMap, eventMap = _a.eventMap, prevProps = _a.prevProps, nextProps = _a.nextProps, instance = _a.instance;
    var registeredEvents = registerEvents(nextProps, instance, eventMap);
    applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
    return registeredEvents;
}
var eventMap$i = {
    onDblClick: "dblclick",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMapTypeIdChanged: "maptypeid_changed",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseDown: "mousedown",
    onMouseUp: "mouseup",
    onRightClick: "rightclick",
    onTilesLoaded: "tilesloaded",
    onBoundsChanged: "bounds_changed",
    onCenterChanged: "center_changed",
    onClick: "click",
    onDrag: "drag",
    onHeadingChanged: "heading_changed",
    onIdle: "idle",
    onProjectionChanged: "projection_changed",
    onResize: "resize",
    onTiltChanged: "tilt_changed",
    onZoomChanged: "zoom_changed"
};
var updaterMap$i = {
    extraMapTypes: function(map, extra) {
        extra.forEach(function forEachExtra(it, i) {
            map.mapTypes.set(String(i), it);
        });
    },
    center: function(map, center) {
        map.setCenter(center);
    },
    clickableIcons: function(map, clickable) {
        map.setClickableIcons(clickable);
    },
    heading: function(map, heading) {
        map.setHeading(heading);
    },
    mapTypeId: function(map, mapTypeId) {
        map.setMapTypeId(mapTypeId);
    },
    options: function(map, options) {
        map.setOptions(options);
    },
    streetView: function(map, streetView) {
        map.setStreetView(streetView);
    },
    tilt: function(map, tilt) {
        map.setTilt(tilt);
    },
    zoom: function(map, zoom) {
        map.setZoom(zoom);
    }
};
// TODO: unfinished!
function GoogleMapFunctional(_a) {
    var children = _a.children, options = _a.options, id = _a.id, mapContainerStyle = _a.mapContainerStyle, mapContainerClassName = _a.mapContainerClassName, center = _a.center, // clickableIcons,
    // extraMapTypes,
    // heading,
    // mapTypeId,
    onClick = _a.onClick, onDblClick = _a.onDblClick, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, // onMapTypeIdChanged,
    // onTilesLoaded,
    // onBoundsChanged,
    onCenterChanged = _a.onCenterChanged, // onHeadingChanged,
    // onIdle,
    // onProjectionChanged,
    // onResize,
    // onTiltChanged,
    // onZoomChanged,
    onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var _b = (0, _react.useState)(null), map = _b[0], setMap = _b[1];
    var ref = (0, _react.useRef)(null);
    // const [extraMapTypesListener, setExtraMapTypesListener] = useState<google.maps.MapsEventListener | null>(null)
    var _c = (0, _react.useState)(null), centerChangedListener = _c[0], setCenterChangedListener = _c[1];
    var _d = (0, _react.useState)(null), dblclickListener = _d[0], setDblclickListener = _d[1];
    var _e = (0, _react.useState)(null), dragendListener = _e[0], setDragendListener = _e[1];
    var _f = (0, _react.useState)(null), dragstartListener = _f[0], setDragstartListener = _f[1];
    var _g = (0, _react.useState)(null), mousedownListener = _g[0], setMousedownListener = _g[1];
    var _h = (0, _react.useState)(null), mousemoveListener = _h[0], setMousemoveListener = _h[1];
    var _j = (0, _react.useState)(null), mouseoutListener = _j[0], setMouseoutListener = _j[1];
    var _k = (0, _react.useState)(null), mouseoverListener = _k[0], setMouseoverListener = _k[1];
    var _l = (0, _react.useState)(null), mouseupListener = _l[0], setMouseupListener = _l[1];
    var _m = (0, _react.useState)(null), rightclickListener = _m[0], setRightclickListener = _m[1];
    var _o = (0, _react.useState)(null), clickListener = _o[0], setClickListener = _o[1];
    var _p = (0, _react.useState)(null), dragListener = _p[0], setDragListener = _p[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (options && map !== null) map.setOptions(options);
    }, [
        map,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (map !== null && typeof center !== "undefined") map.setCenter(center);
    }, [
        map,
        center
    ]);
    (0, _react.useEffect)(function() {
        if (map && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(map, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, _react.useEffect)(function() {
        if (map && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(map, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, _react.useEffect)(function() {
        if (map && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(map, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, _react.useEffect)(function() {
        if (map && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(map, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, _react.useEffect)(function() {
        if (map && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(map, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, _react.useEffect)(function() {
        if (map && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(map, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (map && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(map, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (map && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(map, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, _react.useEffect)(function() {
        if (map && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(map, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, _react.useEffect)(function() {
        if (map && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(map, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (map && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(map, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, _react.useEffect)(function() {
        if (map && onCenterChanged) {
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            setCenterChangedListener(google.maps.event.addListener(map, "center_changed", onCenterChanged));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        var map = ref.current === null ? null : new google.maps.Map(ref.current, options);
        setMap(map);
        if (map !== null && onLoad) onLoad(map);
        return function() {
            if (map !== null) {
                if (onUnmount) onUnmount(map);
            }
        };
    }, []);
    return (0, _jsxRuntime.jsx)("div", {
        id: id,
        ref: ref,
        style: mapContainerStyle,
        className: mapContainerClassName,
        children: (0, _jsxRuntime.jsx)(MapContext.Provider, {
            value: map,
            children: map !== null ? children : (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
        })
    });
}
(0, _react.memo)(GoogleMapFunctional);
var GoogleMap = /** @class */ function(_super) {
    __extends(GoogleMap, _super);
    function GoogleMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            map: null
        };
        _this.registeredEvents = [];
        _this.mapRef = null;
        _this.getInstance = function() {
            if (_this.mapRef === null) return null;
            return new google.maps.Map(_this.mapRef, _this.props.options);
        };
        _this.panTo = function(latLng) {
            var map = _this.getInstance();
            if (map) map.panTo(latLng);
        };
        _this.setMapCallback = function() {
            if (_this.state.map !== null) {
                if (_this.props.onLoad) _this.props.onLoad(_this.state.map);
            }
        };
        _this.getRef = function(ref) {
            _this.mapRef = ref;
        };
        return _this;
    }
    GoogleMap.prototype.componentDidMount = function() {
        var map = this.getInstance();
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$i,
            eventMap: eventMap$i,
            prevProps: {},
            nextProps: this.props,
            instance: map
        });
        this.setState(function setMap() {
            return {
                map: map
            };
        }, this.setMapCallback);
    };
    GoogleMap.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.map !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$i,
                eventMap: eventMap$i,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.map
            });
        }
    };
    GoogleMap.prototype.componentWillUnmount = function() {
        if (this.state.map !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.map);
            unregisterEvents(this.registeredEvents);
        }
    };
    GoogleMap.prototype.render = function() {
        return (0, _jsxRuntime.jsx)("div", {
            id: this.props.id,
            ref: this.getRef,
            style: this.props.mapContainerStyle,
            className: this.props.mapContainerClassName,
            children: (0, _jsxRuntime.jsx)(MapContext.Provider, {
                value: this.state.map,
                children: this.state.map !== null ? this.props.children : (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
            })
        });
    };
    return GoogleMap;
}((0, _react.PureComponent));
var isBrowser = typeof document !== "undefined";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function injectScript(_a) {
    var url = _a.url, id = _a.id, nonce = _a.nonce;
    if (!isBrowser) return Promise.reject(new Error("document is undefined"));
    return new Promise(function injectScriptCallback(resolve, reject) {
        var existingScript = document.getElementById(id);
        var windowWithGoogleMap = window;
        if (existingScript) {
            // Same script id/url: keep same script
            var dataStateAttribute = existingScript.getAttribute("data-state");
            if (existingScript.src === url && dataStateAttribute !== "error") {
                if (dataStateAttribute === "ready") return resolve(id);
                else {
                    var originalInitMap_1 = windowWithGoogleMap.initMap;
                    var originalErrorCallback_1 = existingScript.onerror;
                    windowWithGoogleMap.initMap = function initMap() {
                        if (originalInitMap_1) originalInitMap_1();
                        resolve(id);
                    };
                    existingScript.onerror = function(err) {
                        if (originalErrorCallback_1) originalErrorCallback_1(err);
                        reject(err);
                    };
                    return;
                }
            } else existingScript.remove();
        }
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.async = true;
        script.nonce = nonce || "";
        script.onerror = function onerror(err) {
            script.setAttribute("data-state", "error");
            reject(err);
        };
        windowWithGoogleMap.initMap = function onload() {
            script.setAttribute("data-state", "ready");
            resolve(id);
        };
        document.head.appendChild(script);
    }).catch(function(err) {
        console.error("injectScript error: ", err);
        throw err;
    });
}
function isGoogleFontStyle(element) {
    // 'Roboto' or 'Google Sans Text' font download
    var href = element.href;
    if (href && (href.indexOf("https://fonts.googleapis.com/css?family=Roboto") === 0 || href.indexOf("https://fonts.googleapis.com/css?family=Google+Sans+Text") === 0)) return true;
    // font style elements
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.styleSheet.cssText.replace("\r\n", "").indexOf(".gm-style") === 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        element.styleSheet.cssText = "";
        return true;
    }
    // font style elements for other browsers
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.innerHTML.replace("\r\n", "").indexOf(".gm-style") === 0) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        element.innerHTML = "";
        return true;
    }
    // when google tries to add empty style
    if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    !element.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    !element.innerHTML) return true;
    return false;
}
// Preventing the Google Maps library from downloading an extra font
function preventGoogleFonts() {
    // we override these methods only for one particular head element
    // default methods for other elements are not affected
    var head = document.getElementsByTagName("head")[0];
    if (head) {
        var trueInsertBefore_1 = head.insertBefore.bind(head);
        // TODO: adding return before reflect solves the TS issue
        head.insertBefore = function insertBefore(newElement, referenceElement) {
            if (!isGoogleFontStyle(newElement)) Reflect.apply(trueInsertBefore_1, head, [
                newElement,
                referenceElement
            ]);
            return newElement;
        };
        var trueAppend_1 = head.appendChild.bind(head);
        // TODO: adding return before reflect solves the TS issue
        head.appendChild = function appendChild(textNode) {
            if (!isGoogleFontStyle(textNode)) Reflect.apply(trueAppend_1, head, [
                textNode
            ]);
            return textNode;
        };
    }
}
function makeLoadScriptUrl(_a) {
    var googleMapsApiKey = _a.googleMapsApiKey, googleMapsClientId = _a.googleMapsClientId, _b = _a.version, version = _b === void 0 ? "weekly" : _b, language = _a.language, region = _a.region, libraries = _a.libraries, channel = _a.channel, mapIds = _a.mapIds, authReferrerPolicy = _a.authReferrerPolicy;
    var params = [];
    invariant$1(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), "You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.");
    if (googleMapsApiKey) params.push("key=".concat(googleMapsApiKey));
    else if (googleMapsClientId) params.push("client=".concat(googleMapsClientId));
    if (version) params.push("v=".concat(version));
    if (language) params.push("language=".concat(language));
    if (region) params.push("region=".concat(region));
    if (libraries && libraries.length) params.push("libraries=".concat(libraries.sort().join(",")));
    if (channel) params.push("channel=".concat(channel));
    if (mapIds && mapIds.length) params.push("map_ids=".concat(mapIds.join(",")));
    if (authReferrerPolicy) params.push("auth_referrer_policy=".concat(authReferrerPolicy));
    params.push("callback=initMap");
    return "https://maps.googleapis.com/maps/api/js?".concat(params.join("&"));
}
var cleaningUp = false;
function DefaultLoadingElement() {
    return (0, _jsxRuntime.jsx)("div", {
        children: "Loading..."
    });
}
var defaultLoadScriptProps = {
    id: "script-loader",
    version: "weekly"
};
var LoadScript = /** @class */ function(_super) {
    __extends(LoadScript, _super);
    function LoadScript() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.check = (0, _react.createRef)();
        _this.state = {
            loaded: false
        };
        _this.cleanupCallback = function() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            delete window.google.maps;
            _this.injectScript();
        };
        _this.isCleaningUp = function() {
            return __awaiter$1(_this, void 0, void 0, function() {
                function promiseCallback(resolve) {
                    if (!cleaningUp) resolve();
                    else if (isBrowser) var timer_1 = window.setInterval(function interval() {
                        if (!cleaningUp) {
                            window.clearInterval(timer_1);
                            resolve();
                        }
                    }, 1);
                    return;
                }
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(promiseCallback)
                    ];
                });
            });
        };
        _this.cleanup = function() {
            cleaningUp = true;
            var script = document.getElementById(_this.props.id);
            if (script && script.parentNode) script.parentNode.removeChild(script);
            Array.prototype.slice.call(document.getElementsByTagName("script")).filter(function filter(script) {
                return typeof script.src === "string" && script.src.includes("maps.googleapis");
            }).forEach(function forEach(script) {
                if (script.parentNode) script.parentNode.removeChild(script);
            });
            Array.prototype.slice.call(document.getElementsByTagName("link")).filter(function filter(link) {
                return link.href === "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans";
            }).forEach(function forEach(link) {
                if (link.parentNode) link.parentNode.removeChild(link);
            });
            Array.prototype.slice.call(document.getElementsByTagName("style")).filter(function filter(style) {
                return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes(".gm-");
            }).forEach(function forEach(style) {
                if (style.parentNode) style.parentNode.removeChild(style);
            });
        };
        _this.injectScript = function() {
            if (_this.props.preventGoogleFontsLoading) preventGoogleFonts();
            invariant$1(!!_this.props.id, 'LoadScript requires "id" prop to be a string: %s', _this.props.id);
            var injectScriptOptions = {
                id: _this.props.id,
                nonce: _this.props.nonce,
                url: makeLoadScriptUrl(_this.props)
            };
            injectScript(injectScriptOptions).then(function() {
                if (_this.props.onLoad) _this.props.onLoad();
                _this.setState(function setLoaded() {
                    return {
                        loaded: true
                    };
                });
                return;
            }).catch(function(err) {
                if (_this.props.onError) _this.props.onError(err);
                console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(_this.props.googleMapsApiKey || "-", ") or Client ID (").concat(_this.props.googleMapsClientId || "-", ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
            });
        };
        return _this;
    }
    LoadScript.prototype.componentDidMount = function() {
        if (isBrowser) {
            if (window.google && window.google.maps && !cleaningUp) {
                console.error("google api is already presented");
                return;
            }
            this.isCleaningUp().then(this.injectScript).catch(function error(err) {
                console.error("Error at injecting script after cleaning up: ", err);
            });
        }
    };
    LoadScript.prototype.componentDidUpdate = function(prevProps) {
        if (this.props.libraries !== prevProps.libraries) console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables");
        if (isBrowser && prevProps.language !== this.props.language) {
            this.cleanup();
            // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
            this.setState(function setLoaded() {
                return {
                    loaded: false
                };
            }, this.cleanupCallback);
        }
    };
    LoadScript.prototype.componentWillUnmount = function() {
        var _this = this;
        if (isBrowser) {
            this.cleanup();
            var timeoutCallback = function() {
                if (!_this.check.current) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    delete window.google;
                    cleaningUp = false;
                }
            };
            window.setTimeout(timeoutCallback, 1);
            if (this.props.onUnmount) this.props.onUnmount();
        }
    };
    LoadScript.prototype.render = function() {
        return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                (0, _jsxRuntime.jsx)("div", {
                    ref: this.check
                }),
                this.state.loaded ? this.props.children : this.props.loadingElement || (0, _jsxRuntime.jsx)(DefaultLoadingElement, {})
            ]
        });
    };
    LoadScript.defaultProps = defaultLoadScriptProps;
    return LoadScript;
}((0, _react.PureComponent));
/* eslint-disable filenames/match-regex */ var previouslyLoadedUrl;
function useLoadScript(_a) {
    var _b = _a.id, id = _b === void 0 ? defaultLoadScriptProps.id : _b, _c = _a.version, version = _c === void 0 ? defaultLoadScriptProps.version : _c, nonce = _a.nonce, googleMapsApiKey = _a.googleMapsApiKey, googleMapsClientId = _a.googleMapsClientId, language = _a.language, region = _a.region, libraries = _a.libraries, preventGoogleFontsLoading = _a.preventGoogleFontsLoading, channel = _a.channel, mapIds = _a.mapIds, authReferrerPolicy = _a.authReferrerPolicy;
    var isMounted = (0, _react.useRef)(false);
    var _d = (0, _react.useState)(false), isLoaded = _d[0], setLoaded = _d[1];
    var _e = (0, _react.useState)(undefined), loadError = _e[0], setLoadError = _e[1];
    (0, _react.useEffect)(function trackMountedState() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    (0, _react.useEffect)(function applyPreventGoogleFonts() {
        if (isBrowser && preventGoogleFontsLoading) preventGoogleFonts();
    }, [
        preventGoogleFontsLoading
    ]);
    (0, _react.useEffect)(function validateLoadedState() {
        if (isLoaded) invariant$1(!!window.google, "useLoadScript was marked as loaded, but window.google is not present. Something went wrong.");
    }, [
        isLoaded
    ]);
    var url = makeLoadScriptUrl({
        version: version,
        googleMapsApiKey: googleMapsApiKey,
        googleMapsClientId: googleMapsClientId,
        language: language,
        region: region,
        libraries: libraries,
        channel: channel,
        mapIds: mapIds,
        authReferrerPolicy: authReferrerPolicy
    });
    (0, _react.useEffect)(function loadScriptAndModifyLoadedState() {
        if (!isBrowser) return;
        function setLoadedIfMounted() {
            if (isMounted.current) {
                setLoaded(true);
                previouslyLoadedUrl = url;
            }
        }
        if (window.google && window.google.maps && previouslyLoadedUrl === url) {
            setLoadedIfMounted();
            return;
        }
        injectScript({
            id: id,
            url: url,
            nonce: nonce
        }).then(setLoadedIfMounted).catch(function handleInjectError(err) {
            if (isMounted.current) setLoadError(err);
            console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(googleMapsApiKey || "-", ") or Client ID (").concat(googleMapsClientId || "-", ")\n        Otherwise it is a Network issue.\n      "));
            console.error(err);
        });
    }, [
        id,
        url,
        nonce
    ]);
    var prevLibraries = (0, _react.useRef)();
    (0, _react.useEffect)(function checkPerformance() {
        if (prevLibraries.current && libraries !== prevLibraries.current) console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables");
        prevLibraries.current = libraries;
    }, [
        libraries
    ]);
    return {
        isLoaded: isLoaded,
        loadError: loadError,
        url: url
    };
}
var defaultLoadingElement = (0, _jsxRuntime.jsx)(DefaultLoadingElement, {});
function LoadScriptNext(_a) {
    var loadingElement = _a.loadingElement, onLoad = _a.onLoad, onError = _a.onError, onUnmount = _a.onUnmount, children = _a.children, hookOptions = __rest$1(_a, [
        "loadingElement",
        "onLoad",
        "onError",
        "onUnmount",
        "children"
    ]);
    var _b = useLoadScript(hookOptions), isLoaded = _b.isLoaded, loadError = _b.loadError;
    (0, _react.useEffect)(function handleOnLoad() {
        if (isLoaded && typeof onLoad === "function") onLoad();
    }, [
        isLoaded,
        onLoad
    ]);
    (0, _react.useEffect)(function handleOnError() {
        if (loadError && typeof onError === "function") onError(loadError);
    }, [
        loadError,
        onError
    ]);
    (0, _react.useEffect)(function handleOnUnmount() {
        return function() {
            if (onUnmount) onUnmount();
        };
    }, [
        onUnmount
    ]);
    return isLoaded ? children : loadingElement || defaultLoadingElement;
}
var LoadScriptNext$1 = (0, _react.memo)(LoadScriptNext);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
// do not edit .js files directly - edit src/index.jst
var fastDeepEqual$1 = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var LoaderStatus;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class Loader {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!fastDeepEqual$1(this.options, Loader.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
            return Loader.instance;
        }
        Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return LoaderStatus.FAILURE;
        if (this.done) return LoaderStatus.SUCCESS;
        if (this.loading) return LoaderStatus.LOADING;
        return LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
}
var defaultLibraries = [
    "maps"
];
function useJsApiLoader(_a) {
    var _b = _a.id, id = _b === void 0 ? defaultLoadScriptProps.id : _b, _c = _a.version, version = _c === void 0 ? defaultLoadScriptProps.version : _c, nonce = _a.nonce, googleMapsApiKey = _a.googleMapsApiKey, // googleMapsClientId,
    language = _a.language, region = _a.region, _d = _a.libraries, libraries = _d === void 0 ? defaultLibraries : _d, preventGoogleFontsLoading = _a.preventGoogleFontsLoading, // channel,
    mapIds = _a.mapIds, authReferrerPolicy = _a.authReferrerPolicy;
    var isMounted = (0, _react.useRef)(false);
    var _e = (0, _react.useState)(false), isLoaded = _e[0], setLoaded = _e[1];
    var _f = (0, _react.useState)(undefined), loadError = _f[0], setLoadError = _f[1];
    (0, _react.useEffect)(function trackMountedState() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var loader = (0, _react.useMemo)(function() {
        return new Loader({
            id: id,
            apiKey: googleMapsApiKey,
            version: version,
            libraries: libraries,
            language: language || "en",
            region: region || "US",
            mapIds: mapIds || [],
            nonce: nonce || "",
            authReferrerPolicy: authReferrerPolicy || "origin"
        });
    }, [
        id,
        googleMapsApiKey,
        version,
        libraries,
        language,
        region,
        mapIds,
        nonce,
        authReferrerPolicy
    ]);
    (0, _react.useEffect)(function effect() {
        if (isLoaded) return;
        else loader.load().then(function() {
            if (isMounted.current) setLoaded(true);
            return;
        }).catch(function(error) {
            setLoadError(error);
        });
    }, []);
    (0, _react.useEffect)(function() {
        if (isBrowser && preventGoogleFontsLoading) preventGoogleFonts();
    }, [
        preventGoogleFontsLoading
    ]);
    var prevLibraries = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        if (prevLibraries.current && libraries !== prevLibraries.current) console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables");
        prevLibraries.current = libraries;
    }, [
        libraries
    ]);
    return {
        isLoaded: isLoaded,
        loadError: loadError
    };
}
var eventMap$h = {};
var updaterMap$h = {
    options: function(instance, options) {
        instance.setOptions(options);
    }
};
function TrafficLayerFunctional(_a) {
    var options = _a.options, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        var trafficLayer = new google.maps.TrafficLayer(__assign(__assign({}, options || {}), {
            map: map
        }));
        setInstance(trafficLayer);
        if (onLoad) onLoad(trafficLayer);
        return function() {
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var TrafficLayerF = (0, _react.memo)(TrafficLayerFunctional);
var TrafficLayer = /** @class */ function(_super) {
    __extends(TrafficLayer, _super);
    function TrafficLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            trafficLayer: null
        };
        _this.setTrafficLayerCallback = function() {
            if (_this.state.trafficLayer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.trafficLayer);
        };
        _this.registeredEvents = [];
        return _this;
    }
    TrafficLayer.prototype.componentDidMount = function() {
        var trafficLayer = new google.maps.TrafficLayer(__assign(__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$h,
            eventMap: eventMap$h,
            prevProps: {},
            nextProps: this.props,
            instance: trafficLayer
        });
        this.setState(function setTrafficLayer() {
            return {
                trafficLayer: trafficLayer
            };
        }, this.setTrafficLayerCallback);
    };
    TrafficLayer.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.trafficLayer !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$h,
                eventMap: eventMap$h,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.trafficLayer
            });
        }
    };
    TrafficLayer.prototype.componentWillUnmount = function() {
        if (this.state.trafficLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.trafficLayer);
            unregisterEvents(this.registeredEvents);
            this.state.trafficLayer.setMap(null);
        }
    };
    TrafficLayer.prototype.render = function() {
        return null;
    };
    TrafficLayer.contextType = MapContext;
    return TrafficLayer;
}((0, _react.PureComponent));
function BicyclingLayerFunctional(_a) {
    var onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        var bicyclingLayer = new google.maps.BicyclingLayer();
        setInstance(bicyclingLayer);
        bicyclingLayer.setMap(map);
        if (onLoad) onLoad(bicyclingLayer);
        return function() {
            if (bicyclingLayer !== null) {
                if (onUnmount) onUnmount(bicyclingLayer);
                bicyclingLayer.setMap(null);
            }
        };
    }, []);
    return null;
}
var BicyclingLayerF = (0, _react.memo)(BicyclingLayerFunctional);
var BicyclingLayer = /** @class */ function(_super) {
    __extends(BicyclingLayer, _super);
    function BicyclingLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            bicyclingLayer: null
        };
        _this.setBicyclingLayerCallback = function() {
            if (_this.state.bicyclingLayer !== null) {
                _this.state.bicyclingLayer.setMap(_this.context);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.bicyclingLayer);
            }
        };
        return _this;
    }
    BicyclingLayer.prototype.componentDidMount = function() {
        var bicyclingLayer = new google.maps.BicyclingLayer();
        this.setState(function() {
            return {
                bicyclingLayer: bicyclingLayer
            };
        }, this.setBicyclingLayerCallback);
    };
    BicyclingLayer.prototype.componentWillUnmount = function() {
        if (this.state.bicyclingLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.bicyclingLayer);
            this.state.bicyclingLayer.setMap(null);
        }
    };
    BicyclingLayer.prototype.render = function() {
        return null;
    };
    BicyclingLayer.contextType = MapContext;
    return BicyclingLayer;
}((0, _react.PureComponent));
function TransitLayerFunctional(_a) {
    var onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        var transitLayer = new google.maps.TransitLayer();
        setInstance(transitLayer);
        transitLayer.setMap(map);
        if (onLoad) onLoad(transitLayer);
        return function() {
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var TransitLayerF = (0, _react.memo)(TransitLayerFunctional);
var TransitLayer = /** @class */ function(_super) {
    __extends(TransitLayer, _super);
    function TransitLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            transitLayer: null
        };
        _this.setTransitLayerCallback = function() {
            if (_this.state.transitLayer !== null) {
                _this.state.transitLayer.setMap(_this.context);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.transitLayer);
            }
        };
        return _this;
    }
    TransitLayer.prototype.componentDidMount = function() {
        var transitLayer = new google.maps.TransitLayer();
        this.setState(function setTransitLayer() {
            return {
                transitLayer: transitLayer
            };
        }, this.setTransitLayerCallback);
    };
    TransitLayer.prototype.componentWillUnmount = function() {
        if (this.state.transitLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.transitLayer);
            this.state.transitLayer.setMap(null);
        }
    };
    TransitLayer.prototype.render = function() {
        return null;
    };
    TransitLayer.contextType = MapContext;
    return TransitLayer;
}((0, _react.PureComponent));
var eventMap$g = {
    onCircleComplete: "circlecomplete",
    onMarkerComplete: "markercomplete",
    onOverlayComplete: "overlaycomplete",
    onPolygonComplete: "polygoncomplete",
    onPolylineComplete: "polylinecomplete",
    onRectangleComplete: "rectanglecomplete"
};
var updaterMap$g = {
    drawingMode: function(instance, drawingMode) {
        instance.setDrawingMode(drawingMode);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    }
};
function DrawingManagerFunctional(_a) {
    var options = _a.options, drawingMode = _a.drawingMode, onCircleComplete = _a.onCircleComplete, onMarkerComplete = _a.onMarkerComplete, onOverlayComplete = _a.onOverlayComplete, onPolygonComplete = _a.onPolygonComplete, onPolylineComplete = _a.onPolylineComplete, onRectangleComplete = _a.onRectangleComplete, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), circlecompleteListener = _c[0], setCircleCompleteListener = _c[1];
    var _d = (0, _react.useState)(null), markercompleteListener = _d[0], setMarkerCompleteListener = _d[1];
    var _e = (0, _react.useState)(null), overlaycompleteListener = _e[0], setOverlayCompleteListener = _e[1];
    var _f = (0, _react.useState)(null), polygoncompleteListener = _f[0], setPolygonCompleteListener = _f[1];
    var _g = (0, _react.useState)(null), polylinecompleteListener = _g[0], setPolylineCompleteListener = _g[1];
    var _h = (0, _react.useState)(null), rectanglecompleteListener = _h[0], setRectangleCompleteListener = _h[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (drawingMode && instance !== null) instance.setDrawingMode(drawingMode);
    }, [
        instance,
        drawingMode
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onCircleComplete) {
            if (circlecompleteListener !== null) google.maps.event.removeListener(circlecompleteListener);
            setCircleCompleteListener(google.maps.event.addListener(instance, "circlecomplete", onCircleComplete));
        }
    }, [
        instance,
        onCircleComplete
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMarkerComplete) {
            if (markercompleteListener !== null) google.maps.event.removeListener(markercompleteListener);
            setMarkerCompleteListener(google.maps.event.addListener(instance, "markercomplete", onMarkerComplete));
        }
    }, [
        instance,
        onMarkerComplete
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onOverlayComplete) {
            if (overlaycompleteListener !== null) google.maps.event.removeListener(overlaycompleteListener);
            setOverlayCompleteListener(google.maps.event.addListener(instance, "overlaycomplete", onOverlayComplete));
        }
    }, [
        instance,
        onOverlayComplete
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onPolygonComplete) {
            if (polygoncompleteListener !== null) google.maps.event.removeListener(polygoncompleteListener);
            setPolygonCompleteListener(google.maps.event.addListener(instance, "polygoncomplete", onPolygonComplete));
        }
    }, [
        instance,
        onPolygonComplete
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onPolylineComplete) {
            if (polylinecompleteListener !== null) google.maps.event.removeListener(polylinecompleteListener);
            setPolylineCompleteListener(google.maps.event.addListener(instance, "polylinecomplete", onPolylineComplete));
        }
    }, [
        instance,
        onPolylineComplete
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRectangleComplete) {
            if (rectanglecompleteListener !== null) google.maps.event.removeListener(rectanglecompleteListener);
            setRectangleCompleteListener(google.maps.event.addListener(instance, "rectanglecomplete", onRectangleComplete));
        }
    }, [
        instance,
        onRectangleComplete
    ]);
    (0, _react.useEffect)(function() {
        invariant$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
        var drawingManager = new google.maps.drawing.DrawingManager(__assign(__assign({}, options || {}), {
            map: map
        }));
        if (drawingMode) drawingManager.setDrawingMode(drawingMode);
        if (onCircleComplete) setCircleCompleteListener(google.maps.event.addListener(drawingManager, "circlecomplete", onCircleComplete));
        if (onMarkerComplete) setMarkerCompleteListener(google.maps.event.addListener(drawingManager, "markercomplete", onMarkerComplete));
        if (onOverlayComplete) setOverlayCompleteListener(google.maps.event.addListener(drawingManager, "overlaycomplete", onOverlayComplete));
        if (onPolygonComplete) setPolygonCompleteListener(google.maps.event.addListener(drawingManager, "polygoncomplete", onPolygonComplete));
        if (onPolylineComplete) setPolylineCompleteListener(google.maps.event.addListener(drawingManager, "polylinecomplete", onPolylineComplete));
        if (onRectangleComplete) setRectangleCompleteListener(google.maps.event.addListener(drawingManager, "rectanglecomplete", onRectangleComplete));
        setInstance(drawingManager);
        if (onLoad) onLoad(drawingManager);
        return function() {
            if (instance !== null) {
                if (circlecompleteListener) google.maps.event.removeListener(circlecompleteListener);
                if (markercompleteListener) google.maps.event.removeListener(markercompleteListener);
                if (overlaycompleteListener) google.maps.event.removeListener(overlaycompleteListener);
                if (polygoncompleteListener) google.maps.event.removeListener(polygoncompleteListener);
                if (polylinecompleteListener) google.maps.event.removeListener(polylinecompleteListener);
                if (rectanglecompleteListener) google.maps.event.removeListener(rectanglecompleteListener);
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var DrawingManagerF = (0, _react.memo)(DrawingManagerFunctional);
var DrawingManager = /** @class */ function(_super) {
    __extends(DrawingManager, _super);
    function DrawingManager(props) {
        var _this = _super.call(this, props) || this;
        _this.registeredEvents = [];
        _this.state = {
            drawingManager: null
        };
        _this.setDrawingManagerCallback = function() {
            if (_this.state.drawingManager !== null && _this.props.onLoad) _this.props.onLoad(_this.state.drawingManager);
        };
        invariant$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
        return _this;
    }
    DrawingManager.prototype.componentDidMount = function() {
        var drawingManager = new google.maps.drawing.DrawingManager(__assign(__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$g,
            eventMap: eventMap$g,
            prevProps: {},
            nextProps: this.props,
            instance: drawingManager
        });
        this.setState(function setDrawingManager() {
            return {
                drawingManager: drawingManager
            };
        }, this.setDrawingManagerCallback);
    };
    DrawingManager.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.drawingManager !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$g,
                eventMap: eventMap$g,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.drawingManager
            });
        }
    };
    DrawingManager.prototype.componentWillUnmount = function() {
        if (this.state.drawingManager !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.drawingManager);
            unregisterEvents(this.registeredEvents);
            this.state.drawingManager.setMap(null);
        }
    };
    DrawingManager.prototype.render = function() {
        return null;
    };
    DrawingManager.contextType = MapContext;
    return DrawingManager;
}((0, _react.PureComponent));
var eventMap$f = {
    onAnimationChanged: "animation_changed",
    onClick: "click",
    onClickableChanged: "clickable_changed",
    onCursorChanged: "cursor_changed",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDraggableChanged: "draggable_changed",
    onDragStart: "dragstart",
    onFlatChanged: "flat_changed",
    onIconChanged: "icon_changed",
    onMouseDown: "mousedown",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onPositionChanged: "position_changed",
    onRightClick: "rightclick",
    onShapeChanged: "shape_changed",
    onTitleChanged: "title_changed",
    onVisibleChanged: "visible_changed",
    onZindexChanged: "zindex_changed"
};
var updaterMap$f = {
    animation: function(instance, animation) {
        instance.setAnimation(animation);
    },
    clickable: function(instance, clickable) {
        instance.setClickable(clickable);
    },
    cursor: function(instance, cursor) {
        instance.setCursor(cursor);
    },
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    icon: function(instance, icon) {
        instance.setIcon(icon);
    },
    label: function(instance, label) {
        instance.setLabel(label);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    opacity: function(instance, opacity) {
        instance.setOpacity(opacity);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    position: function(instance, position) {
        instance.setPosition(position);
    },
    shape: function(instance, shape) {
        instance.setShape(shape);
    },
    title: function(instance, title) {
        instance.setTitle(title);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var defaultOptions$5 = {};
function MarkerFunctional(_a) {
    var position = _a.position, options = _a.options, clusterer = _a.clusterer, noClustererRedraw = _a.noClustererRedraw, children = _a.children, draggable = _a.draggable, visible = _a.visible, animation = _a.animation, clickable = _a.clickable, cursor = _a.cursor, icon = _a.icon, label = _a.label, opacity = _a.opacity, shape = _a.shape, title = _a.title, zIndex = _a.zIndex, onClick = _a.onClick, onDblClick = _a.onDblClick, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onMouseDown = _a.onMouseDown, onRightClick = _a.onRightClick, onClickableChanged = _a.onClickableChanged, onCursorChanged = _a.onCursorChanged, onAnimationChanged = _a.onAnimationChanged, onDraggableChanged = _a.onDraggableChanged, onFlatChanged = _a.onFlatChanged, onIconChanged = _a.onIconChanged, onPositionChanged = _a.onPositionChanged, onShapeChanged = _a.onShapeChanged, onTitleChanged = _a.onTitleChanged, onVisibleChanged = _a.onVisibleChanged, onZindexChanged = _a.onZindexChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, _react.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, _react.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, _react.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, _react.useState)(null), mouseoutListener = _g[0], setMouseoutListener = _g[1];
    var _h = (0, _react.useState)(null), mouseoverListener = _h[0], setMouseoverListener = _h[1];
    var _j = (0, _react.useState)(null), mouseupListener = _j[0], setMouseupListener = _j[1];
    var _k = (0, _react.useState)(null), rightclickListener = _k[0], setRightclickListener = _k[1];
    var _l = (0, _react.useState)(null), clickListener = _l[0], setClickListener = _l[1];
    var _m = (0, _react.useState)(null), dragListener = _m[0], setDragListener = _m[1];
    var _o = (0, _react.useState)(null), clickableChangedListener = _o[0], setClickableChangedListener = _o[1];
    var _p = (0, _react.useState)(null), cursorChangedListener = _p[0], setCursorChangedListener = _p[1];
    var _q = (0, _react.useState)(null), animationChangedListener = _q[0], setAnimationChangedListener = _q[1];
    var _r = (0, _react.useState)(null), draggableChangedListener = _r[0], setDraggableChangedListener = _r[1];
    var _s = (0, _react.useState)(null), flatChangedListener = _s[0], setFlatChangedListener = _s[1];
    var _t = (0, _react.useState)(null), iconChangedListener = _t[0], setIconChangedListener = _t[1];
    var _u = (0, _react.useState)(null), positionChangedListener = _u[0], setPositionChangedListener = _u[1];
    var _v = (0, _react.useState)(null), shapeChangedListener = _v[0], setShapeChangedListener = _v[1];
    var _w = (0, _react.useState)(null), titleChangedListener = _w[0], setTitleChangedListener = _w[1];
    var _x = (0, _react.useState)(null), visibleChangedListener = _x[0], setVisibleChangedListener = _x[1];
    var _y = (0, _react.useState)(null), zIndexChangedListener = _y[0], setZindexChangedListener = _y[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, _react.useEffect)(function() {
        if (position && instance !== null) instance.setPosition(position);
    }, [
        instance,
        position
    ]);
    (0, _react.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, _react.useEffect)(function() {
        instance === null || instance === void 0 || instance.setAnimation(animation);
    }, [
        instance,
        animation
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClickableChanged) {
            if (clickableChangedListener !== null) google.maps.event.removeListener(clickableChangedListener);
            setClickableChangedListener(google.maps.event.addListener(instance, "clickable_changed", onClickableChanged));
        }
    }, [
        onClickableChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onCursorChanged) {
            if (cursorChangedListener !== null) google.maps.event.removeListener(cursorChangedListener);
            setCursorChangedListener(google.maps.event.addListener(instance, "cursor_changed", onCursorChanged));
        }
    }, [
        onCursorChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onAnimationChanged) {
            if (animationChangedListener !== null) google.maps.event.removeListener(animationChangedListener);
            setAnimationChangedListener(google.maps.event.addListener(instance, "animation_changed", onAnimationChanged));
        }
    }, [
        onAnimationChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDraggableChanged) {
            if (draggableChangedListener !== null) google.maps.event.removeListener(draggableChangedListener);
            setDraggableChangedListener(google.maps.event.addListener(instance, "draggable_changed", onDraggableChanged));
        }
    }, [
        onDraggableChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onFlatChanged) {
            if (flatChangedListener !== null) google.maps.event.removeListener(flatChangedListener);
            setFlatChangedListener(google.maps.event.addListener(instance, "flat_changed", onFlatChanged));
        }
    }, [
        onFlatChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onIconChanged) {
            if (iconChangedListener !== null) google.maps.event.removeListener(iconChangedListener);
            setIconChangedListener(google.maps.event.addListener(instance, "icon_changed", onIconChanged));
        }
    }, [
        onIconChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onPositionChanged) {
            if (positionChangedListener !== null) google.maps.event.removeListener(positionChangedListener);
            setPositionChangedListener(google.maps.event.addListener(instance, "position_changed", onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onShapeChanged) {
            if (shapeChangedListener !== null) google.maps.event.removeListener(shapeChangedListener);
            setShapeChangedListener(google.maps.event.addListener(instance, "shape_changed", onShapeChanged));
        }
    }, [
        onShapeChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onTitleChanged) {
            if (titleChangedListener !== null) google.maps.event.removeListener(titleChangedListener);
            setTitleChangedListener(google.maps.event.addListener(instance, "title_changed", onTitleChanged));
        }
    }, [
        onTitleChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onVisibleChanged) {
            if (visibleChangedListener !== null) google.maps.event.removeListener(visibleChangedListener);
            setVisibleChangedListener(google.maps.event.addListener(instance, "visible_changed", onVisibleChanged));
        }
    }, [
        onVisibleChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onZindexChanged) {
            if (zIndexChangedListener !== null) google.maps.event.removeListener(zIndexChangedListener);
            setZindexChangedListener(google.maps.event.addListener(instance, "zindex_changed", onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, _react.useEffect)(function() {
        var markerOptions = __assign(__assign(__assign({}, options || defaultOptions$5), clusterer ? defaultOptions$5 : {
            map: map
        }), {
            position: position
        });
        var marker = new google.maps.Marker(markerOptions);
        if (clusterer) clusterer.addMarker(marker, !!noClustererRedraw);
        else marker.setMap(map);
        if (position) marker.setPosition(position);
        if (typeof visible !== "undefined") marker.setVisible(visible);
        if (typeof draggable !== "undefined") marker.setDraggable(draggable);
        if (typeof clickable !== "undefined") marker.setClickable(clickable);
        if (typeof cursor === "string") marker.setCursor(cursor);
        if (icon) marker.setIcon(icon);
        if (typeof label !== "undefined") marker.setLabel(label);
        if (typeof opacity !== "undefined") marker.setOpacity(opacity);
        if (shape) marker.setShape(shape);
        if (typeof title === "string") marker.setTitle(title);
        if (typeof zIndex === "number") marker.setZIndex(zIndex);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(marker, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(marker, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(marker, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(marker, "mousedown", onMouseDown));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(marker, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(marker, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(marker, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(marker, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(marker, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(marker, "drag", onDrag));
        if (onClickableChanged) setClickableChangedListener(google.maps.event.addListener(marker, "clickable_changed", onClickableChanged));
        if (onCursorChanged) setCursorChangedListener(google.maps.event.addListener(marker, "cursor_changed", onCursorChanged));
        if (onAnimationChanged) setAnimationChangedListener(google.maps.event.addListener(marker, "animation_changed", onAnimationChanged));
        if (onDraggableChanged) setDraggableChangedListener(google.maps.event.addListener(marker, "draggable_changed", onDraggableChanged));
        if (onFlatChanged) setFlatChangedListener(google.maps.event.addListener(marker, "flat_changed", onFlatChanged));
        if (onIconChanged) setIconChangedListener(google.maps.event.addListener(marker, "icon_changed", onIconChanged));
        if (onPositionChanged) setPositionChangedListener(google.maps.event.addListener(marker, "position_changed", onPositionChanged));
        if (onShapeChanged) setShapeChangedListener(google.maps.event.addListener(marker, "shape_changed", onShapeChanged));
        if (onTitleChanged) setTitleChangedListener(google.maps.event.addListener(marker, "title_changed", onTitleChanged));
        if (onVisibleChanged) setVisibleChangedListener(google.maps.event.addListener(marker, "visible_changed", onVisibleChanged));
        if (onZindexChanged) setZindexChangedListener(google.maps.event.addListener(marker, "zindex_changed", onZindexChanged));
        setInstance(marker);
        if (onLoad) onLoad(marker);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (clickableChangedListener !== null) google.maps.event.removeListener(clickableChangedListener);
            if (cursorChangedListener !== null) google.maps.event.removeListener(cursorChangedListener);
            if (animationChangedListener !== null) google.maps.event.removeListener(animationChangedListener);
            if (draggableChangedListener !== null) google.maps.event.removeListener(draggableChangedListener);
            if (flatChangedListener !== null) google.maps.event.removeListener(flatChangedListener);
            if (iconChangedListener !== null) google.maps.event.removeListener(iconChangedListener);
            if (positionChangedListener !== null) google.maps.event.removeListener(positionChangedListener);
            if (titleChangedListener !== null) google.maps.event.removeListener(titleChangedListener);
            if (visibleChangedListener !== null) google.maps.event.removeListener(visibleChangedListener);
            if (zIndexChangedListener !== null) google.maps.event.removeListener(zIndexChangedListener);
            if (onUnmount) onUnmount(marker);
            if (clusterer) clusterer.removeMarker(marker, !!noClustererRedraw);
            else if (marker) marker.setMap(null);
        };
    }, []);
    var chx = (0, _react.useMemo)(function() {
        return children ? (0, _react.Children).map(children, function(child) {
            if (!(0, _react.isValidElement)(child)) return child;
            var elementChild = child;
            return (0, _react.cloneElement)(elementChild, {
                anchor: instance
            });
        }) : null;
    }, [
        children,
        instance
    ]);
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: chx
    }) || null;
}
var MarkerF = (0, _react.memo)(MarkerFunctional);
var Marker = /** @class */ function(_super) {
    __extends(Marker, _super);
    function Marker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        return _this;
    }
    Marker.prototype.componentDidMount = function() {
        var markerOptions = __assign(__assign(__assign({}, this.props.options || defaultOptions$5), this.props.clusterer ? defaultOptions$5 : {
            map: this.context
        }), {
            position: this.props.position
        });
        // Unfortunately we can't just do this in the contstructor, because the
        // `MapContext` might not be filled in yet.
        this.marker = new google.maps.Marker(markerOptions);
        if (this.props.clusterer) this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
        else this.marker.setMap(this.context);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$f,
            eventMap: eventMap$f,
            prevProps: {},
            nextProps: this.props,
            instance: this.marker
        });
        if (this.props.onLoad) this.props.onLoad(this.marker);
    };
    Marker.prototype.componentDidUpdate = function(prevProps) {
        if (this.marker) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$f,
                eventMap: eventMap$f,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.marker
            });
        }
    };
    Marker.prototype.componentWillUnmount = function() {
        if (this.marker) {
            if (this.props.onUnmount) this.props.onUnmount(this.marker);
            unregisterEvents(this.registeredEvents);
            if (this.props.clusterer) this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
            else this.marker && this.marker.setMap(null);
        }
    };
    Marker.prototype.render = function() {
        var _this = this;
        var children = null;
        if (this.props.children) children = (0, _react.Children).map(this.props.children, function(child) {
            if (!(0, _react.isValidElement)(child)) return child;
            var elementChild = child;
            return (0, _react.cloneElement)(elementChild, {
                anchor: _this.marker
            });
        });
        return children || null;
    };
    Marker.contextType = MapContext;
    return Marker;
}((0, _react.PureComponent));
var ClusterIcon = /** @class */ function() {
    function ClusterIcon(cluster, styles) {
        cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
        this.cluster = cluster;
        this.clusterClassName = this.cluster.getClusterer().getClusterClass();
        this.className = this.clusterClassName;
        this.styles = styles;
        this.center = undefined;
        this.div = null;
        this.sums = null;
        this.visible = false;
        this.boundsChangedListener = null;
        this.url = "";
        this.height = 0;
        this.width = 0;
        this.anchorText = [
            0,
            0
        ];
        this.anchorIcon = [
            0,
            0
        ];
        this.textColor = "black";
        this.textSize = 11;
        this.textDecoration = "none";
        this.fontWeight = "bold";
        this.fontStyle = "normal";
        this.fontFamily = "Arial,sans-serif";
        this.backgroundPosition = "0 0";
        this.cMouseDownInCluster = null;
        this.cDraggingMapByCluster = null;
        this.timeOut = null;
        this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
        this.onBoundsChanged = this.onBoundsChanged.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.draw = this.draw.bind(this);
        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
        this.useStyle = this.useStyle.bind(this);
        this.setCenter = this.setCenter.bind(this);
        this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
    }
    ClusterIcon.prototype.onBoundsChanged = function() {
        this.cDraggingMapByCluster = this.cMouseDownInCluster;
    };
    ClusterIcon.prototype.onMouseDown = function() {
        this.cMouseDownInCluster = true;
        this.cDraggingMapByCluster = false;
    };
    ClusterIcon.prototype.onClick = function(event) {
        this.cMouseDownInCluster = false;
        if (!this.cDraggingMapByCluster) {
            var markerClusterer_1 = this.cluster.getClusterer();
            /**
             * This event is fired when a cluster marker is clicked.
             * @name MarkerClusterer#click
             * @param {Cluster} c The cluster that was clicked.
             * @event
             */ google.maps.event.trigger(markerClusterer_1, "click", this.cluster);
            google.maps.event.trigger(markerClusterer_1, "clusterclick", this.cluster); // deprecated name
            // The default click handler follows. Disable it by setting
            // the zoomOnClick property to false.
            if (markerClusterer_1.getZoomOnClick()) {
                // Zoom into the cluster.
                var maxZoom_1 = markerClusterer_1.getMaxZoom();
                var bounds_1 = this.cluster.getBounds();
                var map = markerClusterer_1.getMap();
                if (map !== null && "fitBounds" in map) map.fitBounds(bounds_1);
                // There is a fix for Issue 170 here:
                this.timeOut = window.setTimeout(function() {
                    var map = markerClusterer_1.getMap();
                    if (map !== null) {
                        if ("fitBounds" in map) map.fitBounds(bounds_1);
                        var zoom = map.getZoom() || 0;
                        // Don't zoom beyond the max zoom level
                        if (maxZoom_1 !== null && zoom > maxZoom_1) map.setZoom(maxZoom_1 + 1);
                    }
                }, 100);
            }
            // Prevent event propagation to the map:
            event.cancelBubble = true;
            if (event.stopPropagation) event.stopPropagation();
        }
    };
    ClusterIcon.prototype.onMouseOver = function() {
        /**
         * This event is fired when the mouse moves over a cluster marker.
         * @name MarkerClusterer#mouseover
         * @param {Cluster} c The cluster that the mouse moved over.
         * @event
         */ google.maps.event.trigger(this.cluster.getClusterer(), "mouseover", this.cluster);
    };
    ClusterIcon.prototype.onMouseOut = function() {
        /**
         * This event is fired when the mouse moves out of a cluster marker.
         * @name MarkerClusterer#mouseout
         * @param {Cluster} c The cluster that the mouse moved out of.
         * @event
         */ google.maps.event.trigger(this.cluster.getClusterer(), "mouseout", this.cluster);
    };
    ClusterIcon.prototype.onAdd = function() {
        var _a;
        this.div = document.createElement("div");
        this.div.className = this.className;
        if (this.visible) this.show();
        (_a = this.getPanes()) === null || _a === void 0 || _a.overlayMouseTarget.appendChild(this.div);
        var map = this.getMap();
        if (map !== null) {
            // Fix for Issue 157
            this.boundsChangedListener = google.maps.event.addListener(map, "bounds_changed", this.onBoundsChanged);
            this.div.addEventListener("mousedown", this.onMouseDown);
            this.div.addEventListener("click", this.onClick);
            this.div.addEventListener("mouseover", this.onMouseOver);
            this.div.addEventListener("mouseout", this.onMouseOut);
        }
    };
    ClusterIcon.prototype.onRemove = function() {
        if (this.div && this.div.parentNode) {
            this.hide();
            if (this.boundsChangedListener !== null) google.maps.event.removeListener(this.boundsChangedListener);
            this.div.removeEventListener("mousedown", this.onMouseDown);
            this.div.removeEventListener("click", this.onClick);
            this.div.removeEventListener("mouseover", this.onMouseOver);
            this.div.removeEventListener("mouseout", this.onMouseOut);
            this.div.parentNode.removeChild(this.div);
            if (this.timeOut !== null) {
                window.clearTimeout(this.timeOut);
                this.timeOut = null;
            }
            this.div = null;
        }
    };
    ClusterIcon.prototype.draw = function() {
        if (this.visible && this.div !== null && this.center) {
            var pos = this.getPosFromLatLng(this.center);
            this.div.style.top = pos !== null ? "".concat(pos.y, "px") : "0";
            this.div.style.left = pos !== null ? "".concat(pos.x, "px") : "0";
        }
    };
    ClusterIcon.prototype.hide = function() {
        if (this.div) this.div.style.display = "none";
        this.visible = false;
    };
    ClusterIcon.prototype.show = function() {
        var _a, _b, _c, _d, _e, _f;
        if (this.div && this.center) {
            var divTitle = this.sums === null || typeof this.sums.title === "undefined" || this.sums.title === "" ? this.cluster.getClusterer().getTitle() : this.sums.title;
            // NOTE: values must be specified in px units
            var bp = this.backgroundPosition.split(" ");
            var spriteH = parseInt(((_a = bp[0]) === null || _a === void 0 ? void 0 : _a.replace(/^\s+|\s+$/g, "")) || "0", 10);
            var spriteV = parseInt(((_b = bp[1]) === null || _b === void 0 ? void 0 : _b.replace(/^\s+|\s+$/g, "")) || "0", 10);
            var pos = this.getPosFromLatLng(this.center);
            this.div.className = this.className;
            this.div.setAttribute("style", "cursor: pointer; position: absolute; top: ".concat(pos !== null ? "".concat(pos.y, "px") : "0", "; left: ").concat(pos !== null ? "".concat(pos.x, "px") : "0", "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
            var img = document.createElement("img");
            img.alt = divTitle;
            img.src = this.url;
            img.width = this.width;
            img.height = this.height;
            img.setAttribute("style", "position: absolute; top: ".concat(spriteV, "px; left: ").concat(spriteH, "px"));
            if (!this.cluster.getClusterer().enableRetinaIcons) img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
            var textElm = document.createElement("div");
            textElm.setAttribute("style", "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px"));
            if ((_c = this.sums) === null || _c === void 0 ? void 0 : _c.text) textElm.innerText = "".concat((_d = this.sums) === null || _d === void 0 ? void 0 : _d.text);
            if ((_e = this.sums) === null || _e === void 0 ? void 0 : _e.html) textElm.innerHTML = "".concat((_f = this.sums) === null || _f === void 0 ? void 0 : _f.html);
            this.div.innerHTML = "";
            this.div.appendChild(img);
            this.div.appendChild(textElm);
            this.div.title = divTitle;
            this.div.style.display = "";
        }
        this.visible = true;
    };
    ClusterIcon.prototype.useStyle = function(sums) {
        this.sums = sums;
        var styles = this.cluster.getClusterer().getStyles();
        var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
        if (style) {
            this.url = style.url;
            this.height = style.height;
            this.width = style.width;
            if (style.className) this.className = "".concat(this.clusterClassName, " ").concat(style.className);
            this.anchorText = style.anchorText || [
                0,
                0
            ];
            this.anchorIcon = style.anchorIcon || [
                this.height / 2,
                this.width / 2
            ];
            this.textColor = style.textColor || "black";
            this.textSize = style.textSize || 11;
            this.textDecoration = style.textDecoration || "none";
            this.fontWeight = style.fontWeight || "bold";
            this.fontStyle = style.fontStyle || "normal";
            this.fontFamily = style.fontFamily || "Arial,sans-serif";
            this.backgroundPosition = style.backgroundPosition || "0 0";
        }
    };
    ClusterIcon.prototype.setCenter = function(center) {
        this.center = center;
    };
    ClusterIcon.prototype.getPosFromLatLng = function(latlng) {
        var pos = this.getProjection().fromLatLngToDivPixel(latlng);
        if (pos !== null) {
            pos.x -= this.anchorIcon[1];
            pos.y -= this.anchorIcon[0];
        }
        return pos;
    };
    return ClusterIcon;
}();
/* global google */ var Cluster$1 = /** @class */ function() {
    function Cluster(markerClusterer) {
        this.markerClusterer = markerClusterer;
        this.map = this.markerClusterer.getMap();
        this.gridSize = this.markerClusterer.getGridSize();
        this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
        this.averageCenter = this.markerClusterer.getAverageCenter();
        this.markers = [];
        this.center = undefined;
        this.bounds = null;
        this.clusterIcon = new ClusterIcon(this, this.markerClusterer.getStyles());
        this.getSize = this.getSize.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
        this.getCenter = this.getCenter.bind(this);
        this.getMap = this.getMap.bind(this);
        this.getClusterer = this.getClusterer.bind(this);
        this.getBounds = this.getBounds.bind(this);
        this.remove = this.remove.bind(this);
        this.addMarker = this.addMarker.bind(this);
        this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this);
        this.calculateBounds = this.calculateBounds.bind(this);
        this.updateIcon = this.updateIcon.bind(this);
        this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
    }
    Cluster.prototype.getSize = function() {
        return this.markers.length;
    };
    Cluster.prototype.getMarkers = function() {
        return this.markers;
    };
    Cluster.prototype.getCenter = function() {
        return this.center;
    };
    Cluster.prototype.getMap = function() {
        return this.map;
    };
    Cluster.prototype.getClusterer = function() {
        return this.markerClusterer;
    };
    Cluster.prototype.getBounds = function() {
        var bounds = new google.maps.LatLngBounds(this.center, this.center);
        var markers = this.getMarkers();
        for(var _i = 0, markers_1 = markers; _i < markers_1.length; _i++){
            var marker = markers_1[_i];
            var position = marker.getPosition();
            if (position) bounds.extend(position);
        }
        return bounds;
    };
    Cluster.prototype.remove = function() {
        this.clusterIcon.setMap(null);
        this.markers = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete this.markers;
    };
    Cluster.prototype.addMarker = function(marker) {
        var _a;
        if (this.isMarkerAlreadyAdded(marker)) return false;
        if (!this.center) {
            var position = marker.getPosition();
            if (position) {
                this.center = position;
                this.calculateBounds();
            }
        } else if (this.averageCenter) {
            var position = marker.getPosition();
            if (position) {
                var length_1 = this.markers.length + 1;
                this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
                this.calculateBounds();
            }
        }
        marker.isAdded = true;
        this.markers.push(marker);
        var mCount = this.markers.length;
        var maxZoom = this.markerClusterer.getMaxZoom();
        var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
        if (maxZoom !== null && typeof zoom !== "undefined" && zoom > maxZoom) // Zoomed in past max zoom, so show the marker.
        {
            if (marker.getMap() !== this.map) marker.setMap(this.map);
        } else if (mCount < this.minClusterSize) // Min cluster size not reached so show the marker.
        {
            if (marker.getMap() !== this.map) marker.setMap(this.map);
        } else if (mCount === this.minClusterSize) // Hide the markers that were showing.
        for(var _i = 0, _b = this.markers; _i < _b.length; _i++){
            var markerElement = _b[_i];
            markerElement.setMap(null);
        }
        else marker.setMap(null);
        return true;
    };
    Cluster.prototype.isMarkerInClusterBounds = function(marker) {
        if (this.bounds !== null) {
            var position = marker.getPosition();
            if (position) return this.bounds.contains(position);
        }
        return false;
    };
    Cluster.prototype.calculateBounds = function() {
        this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
    };
    Cluster.prototype.updateIcon = function() {
        var _a;
        var mCount = this.markers.length;
        var maxZoom = this.markerClusterer.getMaxZoom();
        var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
        if (maxZoom !== null && typeof zoom !== "undefined" && zoom > maxZoom) {
            this.clusterIcon.hide();
            return;
        }
        if (mCount < this.minClusterSize) {
            // Min cluster size not yet reached.
            this.clusterIcon.hide();
            return;
        }
        if (this.center) this.clusterIcon.setCenter(this.center);
        this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
        this.clusterIcon.show();
    };
    Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
        if (this.markers.includes) return this.markers.includes(marker);
        for(var i = 0; i < this.markers.length; i++){
            if (marker === this.markers[i]) return true;
        }
        return false;
    };
    return Cluster;
}();
/* global google */ /**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */ function CALCULATOR(markers, numStyles) {
    var count = markers.length;
    var numberOfDigits = count.toString().length;
    var index = Math.min(numberOfDigits, numStyles);
    return {
        text: count.toString(),
        index: index,
        title: ""
    };
}
var BATCH_SIZE = 2000;
var BATCH_SIZE_IE = 500;
var IMAGE_PATH = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m";
var IMAGE_EXTENSION = "png";
var IMAGE_SIZES = [
    53,
    56,
    66,
    78,
    90
];
var CLUSTERER_CLASS = "cluster";
var Clusterer = /** @class */ function() {
    function Clusterer(map, optMarkers, optOptions) {
        if (optMarkers === void 0) optMarkers = [];
        if (optOptions === void 0) optOptions = {};
        this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this);
        this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this);
        this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this);
        this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this);
        this.addToClosestCluster = this.addToClosestCluster.bind(this);
        this.getImageExtension = this.getImageExtension.bind(this);
        this.setImageExtension = this.setImageExtension.bind(this);
        this.getExtendedBounds = this.getExtendedBounds.bind(this);
        this.getAverageCenter = this.getAverageCenter.bind(this);
        this.setAverageCenter = this.setAverageCenter.bind(this);
        this.getTotalClusters = this.getTotalClusters.bind(this);
        this.fitMapToMarkers = this.fitMapToMarkers.bind(this);
        this.getIgnoreHidden = this.getIgnoreHidden.bind(this);
        this.setIgnoreHidden = this.setIgnoreHidden.bind(this);
        this.getClusterClass = this.getClusterClass.bind(this);
        this.setClusterClass = this.setClusterClass.bind(this);
        this.getTotalMarkers = this.getTotalMarkers.bind(this);
        this.getZoomOnClick = this.getZoomOnClick.bind(this);
        this.setZoomOnClick = this.setZoomOnClick.bind(this);
        this.getBatchSizeIE = this.getBatchSizeIE.bind(this);
        this.setBatchSizeIE = this.setBatchSizeIE.bind(this);
        this.createClusters = this.createClusters.bind(this);
        this.onZoomChanged = this.onZoomChanged.bind(this);
        this.getImageSizes = this.getImageSizes.bind(this);
        this.setImageSizes = this.setImageSizes.bind(this);
        this.getCalculator = this.getCalculator.bind(this);
        this.setCalculator = this.setCalculator.bind(this);
        this.removeMarkers = this.removeMarkers.bind(this);
        this.resetViewport = this.resetViewport.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setImagePath = this.setImagePath.bind(this);
        this.pushMarkerTo = this.pushMarkerTo.bind(this);
        this.removeMarker = this.removeMarker.bind(this);
        this.clearMarkers = this.clearMarkers.bind(this);
        this.setupStyles = this.setupStyles.bind(this);
        this.getGridSize = this.getGridSize.bind(this);
        this.setGridSize = this.setGridSize.bind(this);
        this.getClusters = this.getClusters.bind(this);
        this.getMaxZoom = this.getMaxZoom.bind(this);
        this.setMaxZoom = this.setMaxZoom.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
        this.addMarkers = this.addMarkers.bind(this);
        this.getStyles = this.getStyles.bind(this);
        this.setStyles = this.setStyles.bind(this);
        this.addMarker = this.addMarker.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.setTitle = this.setTitle.bind(this);
        this.repaint = this.repaint.bind(this);
        this.onIdle = this.onIdle.bind(this);
        this.redraw = this.redraw.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.draw = this.draw.bind(this);
        this.extend = this.extend.bind(this);
        this.extend(Clusterer, google.maps.OverlayView);
        this.markers = [];
        this.clusters = [];
        this.listeners = [];
        this.activeMap = null;
        this.ready = false;
        this.gridSize = optOptions.gridSize || 60;
        this.minClusterSize = optOptions.minimumClusterSize || 2;
        this.maxZoom = optOptions.maxZoom || null;
        this.styles = optOptions.styles || [];
        this.title = optOptions.title || "";
        this.zoomOnClick = true;
        if (optOptions.zoomOnClick !== undefined) this.zoomOnClick = optOptions.zoomOnClick;
        this.averageCenter = false;
        if (optOptions.averageCenter !== undefined) this.averageCenter = optOptions.averageCenter;
        this.ignoreHidden = false;
        if (optOptions.ignoreHidden !== undefined) this.ignoreHidden = optOptions.ignoreHidden;
        this.enableRetinaIcons = false;
        if (optOptions.enableRetinaIcons !== undefined) this.enableRetinaIcons = optOptions.enableRetinaIcons;
        this.imagePath = optOptions.imagePath || IMAGE_PATH;
        this.imageExtension = optOptions.imageExtension || IMAGE_EXTENSION;
        this.imageSizes = optOptions.imageSizes || IMAGE_SIZES;
        this.calculator = optOptions.calculator || CALCULATOR;
        this.batchSize = optOptions.batchSize || BATCH_SIZE;
        this.batchSizeIE = optOptions.batchSizeIE || BATCH_SIZE_IE;
        this.clusterClass = optOptions.clusterClass || CLUSTERER_CLASS;
        if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) // Try to avoid IE timeout when processing a huge number of markers:
        this.batchSize = this.batchSizeIE;
        this.timerRefStatic = null;
        this.setupStyles();
        this.addMarkers(optMarkers, true);
        this.setMap(map); // Note: this causes onAdd to be called
    }
    Clusterer.prototype.onZoomChanged = function() {
        var _a, _b;
        this.resetViewport(false);
        // Workaround for this Google bug: when map is at level 0 and "-" of
        // zoom slider is clicked, a "zoom_changed" event is fired even though
        // the map doesn't zoom out any further. In this situation, no "idle"
        // event is triggered so the cluster markers that have been removed
        // do not get redrawn. Same goes for a zoom in at maxZoom.
        if (((_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getZoom()) === (this.get("minZoom") || 0) || ((_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getZoom()) === this.get("maxZoom")) google.maps.event.trigger(this, "idle");
    };
    Clusterer.prototype.onIdle = function() {
        this.redraw();
    };
    Clusterer.prototype.onAdd = function() {
        var map = this.getMap();
        this.activeMap = map;
        this.ready = true;
        this.repaint();
        if (map !== null) // Add the map event listeners
        this.listeners = [
            google.maps.event.addListener(map, "zoom_changed", this.onZoomChanged),
            google.maps.event.addListener(map, "idle", this.onIdle)
        ];
    };
    Clusterer.prototype.onRemove = function() {
        // Put all the managed markers back on the map:
        for(var _i = 0, _a = this.markers; _i < _a.length; _i++){
            var marker = _a[_i];
            if (marker.getMap() !== this.activeMap) marker.setMap(this.activeMap);
        }
        // Remove all clusters:
        for(var _b = 0, _c = this.clusters; _b < _c.length; _b++){
            var cluster = _c[_b];
            cluster.remove();
        }
        this.clusters = [];
        // Remove map event listeners:
        for(var _d = 0, _e = this.listeners; _d < _e.length; _d++){
            var listener = _e[_d];
            google.maps.event.removeListener(listener);
        }
        this.listeners = [];
        this.activeMap = null;
        this.ready = false;
    };
    Clusterer.prototype.draw = function() {
        return;
    };
    Clusterer.prototype.getMap = function() {
        return null;
    };
    Clusterer.prototype.getPanes = function() {
        return null;
    };
    Clusterer.prototype.getProjection = function() {
        return {
            fromContainerPixelToLatLng: function() {
                return null;
            },
            fromDivPixelToLatLng: function() {
                return null;
            },
            fromLatLngToContainerPixel: function() {
                return null;
            },
            fromLatLngToDivPixel: function() {
                return null;
            },
            getVisibleRegion: function() {
                return null;
            },
            getWorldWidth: function() {
                return 0;
            }
        };
    };
    Clusterer.prototype.setMap = function() {
        return;
    };
    Clusterer.prototype.addListener = function() {
        return {
            remove: function() {
                return;
            }
        };
    };
    Clusterer.prototype.bindTo = function() {
        return;
    };
    Clusterer.prototype.get = function() {
        return;
    };
    Clusterer.prototype.notify = function() {
        return;
    };
    Clusterer.prototype.set = function() {
        return;
    };
    Clusterer.prototype.setValues = function() {
        return;
    };
    Clusterer.prototype.unbind = function() {
        return;
    };
    Clusterer.prototype.unbindAll = function() {
        return;
    };
    Clusterer.prototype.setupStyles = function() {
        if (this.styles.length > 0) return;
        for(var i = 0; i < this.imageSizes.length; i++)this.styles.push({
            url: "".concat(this.imagePath + (i + 1), ".").concat(this.imageExtension),
            height: this.imageSizes[i] || 0,
            width: this.imageSizes[i] || 0
        });
    };
    Clusterer.prototype.fitMapToMarkers = function() {
        var markers = this.getMarkers();
        var bounds = new google.maps.LatLngBounds();
        for(var _i = 0, markers_1 = markers; _i < markers_1.length; _i++){
            var marker = markers_1[_i];
            var position = marker.getPosition();
            if (position) bounds.extend(position);
        }
        var map = this.getMap();
        if (map !== null && "fitBounds" in map) map.fitBounds(bounds);
    };
    Clusterer.prototype.getGridSize = function() {
        return this.gridSize;
    };
    Clusterer.prototype.setGridSize = function(gridSize) {
        this.gridSize = gridSize;
    };
    Clusterer.prototype.getMinimumClusterSize = function() {
        return this.minClusterSize;
    };
    Clusterer.prototype.setMinimumClusterSize = function(minimumClusterSize) {
        this.minClusterSize = minimumClusterSize;
    };
    Clusterer.prototype.getMaxZoom = function() {
        return this.maxZoom;
    };
    Clusterer.prototype.setMaxZoom = function(maxZoom) {
        this.maxZoom = maxZoom;
    };
    Clusterer.prototype.getStyles = function() {
        return this.styles;
    };
    Clusterer.prototype.setStyles = function(styles) {
        this.styles = styles;
    };
    Clusterer.prototype.getTitle = function() {
        return this.title;
    };
    Clusterer.prototype.setTitle = function(title) {
        this.title = title;
    };
    Clusterer.prototype.getZoomOnClick = function() {
        return this.zoomOnClick;
    };
    Clusterer.prototype.setZoomOnClick = function(zoomOnClick) {
        this.zoomOnClick = zoomOnClick;
    };
    Clusterer.prototype.getAverageCenter = function() {
        return this.averageCenter;
    };
    Clusterer.prototype.setAverageCenter = function(averageCenter) {
        this.averageCenter = averageCenter;
    };
    Clusterer.prototype.getIgnoreHidden = function() {
        return this.ignoreHidden;
    };
    Clusterer.prototype.setIgnoreHidden = function(ignoreHidden) {
        this.ignoreHidden = ignoreHidden;
    };
    Clusterer.prototype.getEnableRetinaIcons = function() {
        return this.enableRetinaIcons;
    };
    Clusterer.prototype.setEnableRetinaIcons = function(enableRetinaIcons) {
        this.enableRetinaIcons = enableRetinaIcons;
    };
    Clusterer.prototype.getImageExtension = function() {
        return this.imageExtension;
    };
    Clusterer.prototype.setImageExtension = function(imageExtension) {
        this.imageExtension = imageExtension;
    };
    Clusterer.prototype.getImagePath = function() {
        return this.imagePath;
    };
    Clusterer.prototype.setImagePath = function(imagePath) {
        this.imagePath = imagePath;
    };
    Clusterer.prototype.getImageSizes = function() {
        return this.imageSizes;
    };
    Clusterer.prototype.setImageSizes = function(imageSizes) {
        this.imageSizes = imageSizes;
    };
    Clusterer.prototype.getCalculator = function() {
        return this.calculator;
    };
    Clusterer.prototype.setCalculator = function(calculator) {
        this.calculator = calculator;
    };
    Clusterer.prototype.getBatchSizeIE = function() {
        return this.batchSizeIE;
    };
    Clusterer.prototype.setBatchSizeIE = function(batchSizeIE) {
        this.batchSizeIE = batchSizeIE;
    };
    Clusterer.prototype.getClusterClass = function() {
        return this.clusterClass;
    };
    Clusterer.prototype.setClusterClass = function(clusterClass) {
        this.clusterClass = clusterClass;
    };
    Clusterer.prototype.getMarkers = function() {
        return this.markers;
    };
    Clusterer.prototype.getTotalMarkers = function() {
        return this.markers.length;
    };
    Clusterer.prototype.getClusters = function() {
        return this.clusters;
    };
    Clusterer.prototype.getTotalClusters = function() {
        return this.clusters.length;
    };
    Clusterer.prototype.addMarker = function(marker, optNoDraw) {
        this.pushMarkerTo(marker);
        if (!optNoDraw) this.redraw();
    };
    Clusterer.prototype.addMarkers = function(markers, optNoDraw) {
        for(var key in markers)if (Object.prototype.hasOwnProperty.call(markers, key)) {
            var marker = markers[key];
            if (marker) this.pushMarkerTo(marker);
        }
        if (!optNoDraw) this.redraw();
    };
    Clusterer.prototype.pushMarkerTo = function(marker) {
        var _this = this;
        // If the marker is draggable add a listener so we can update the clusters on the dragend:
        if (marker.getDraggable()) google.maps.event.addListener(marker, "dragend", function() {
            if (_this.ready) {
                marker.isAdded = false;
                _this.repaint();
            }
        });
        marker.isAdded = false;
        this.markers.push(marker);
    };
    Clusterer.prototype.removeMarker_ = function(marker) {
        var index = -1;
        if (this.markers.indexOf) index = this.markers.indexOf(marker);
        else {
            for(var i = 0; i < this.markers.length; i++)if (marker === this.markers[i]) {
                index = i;
                break;
            }
        }
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        marker.setMap(null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        return true;
    };
    Clusterer.prototype.removeMarker = function(marker, optNoDraw) {
        var removed = this.removeMarker_(marker);
        if (!optNoDraw && removed) this.repaint();
        return removed;
    };
    Clusterer.prototype.removeMarkers = function(markers, optNoDraw) {
        var removed = false;
        for(var _i = 0, markers_2 = markers; _i < markers_2.length; _i++){
            var marker = markers_2[_i];
            removed = removed || this.removeMarker_(marker);
        }
        if (!optNoDraw && removed) this.repaint();
        return removed;
    };
    Clusterer.prototype.clearMarkers = function() {
        this.resetViewport(true);
        this.markers = [];
    };
    Clusterer.prototype.repaint = function() {
        var oldClusters = this.clusters.slice();
        this.clusters = [];
        this.resetViewport(false);
        this.redraw();
        // Remove the old clusters.
        // Do it in a timeout to prevent blinking effect.
        setTimeout(function timeout() {
            for(var _i = 0, oldClusters_1 = oldClusters; _i < oldClusters_1.length; _i++){
                var oldCluster = oldClusters_1[_i];
                oldCluster.remove();
            }
        }, 0);
    };
    Clusterer.prototype.getExtendedBounds = function(bounds) {
        var projection = this.getProjection();
        // Convert the points to pixels and the extend out by the grid size.
        var trPix = projection.fromLatLngToDivPixel(// Turn the bounds into latlng.
        new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
        if (trPix !== null) {
            trPix.x += this.gridSize;
            trPix.y -= this.gridSize;
        }
        var blPix = projection.fromLatLngToDivPixel(// Turn the bounds into latlng.
        new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
        if (blPix !== null) {
            blPix.x -= this.gridSize;
            blPix.y += this.gridSize;
        }
        // Extend the bounds to contain the new bounds.
        if (trPix !== null) {
            // Convert the pixel points back to LatLng nw
            var point1 = projection.fromDivPixelToLatLng(trPix);
            if (point1 !== null) bounds.extend(point1);
        }
        if (blPix !== null) {
            // Convert the pixel points back to LatLng sw
            var point2 = projection.fromDivPixelToLatLng(blPix);
            if (point2 !== null) bounds.extend(point2);
        }
        return bounds;
    };
    Clusterer.prototype.redraw = function() {
        // Redraws all the clusters.
        this.createClusters(0);
    };
    Clusterer.prototype.resetViewport = function(optHide) {
        // Remove all the clusters
        for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
            var cluster = _a[_i];
            cluster.remove();
        }
        this.clusters = [];
        // Reset the markers to not be added and to be removed from the map.
        for(var _b = 0, _c = this.markers; _b < _c.length; _b++){
            var marker = _c[_b];
            marker.isAdded = false;
            if (optHide) marker.setMap(null);
        }
    };
    Clusterer.prototype.distanceBetweenPoints = function(p1, p2) {
        var R = 6371; // Radius of the Earth in km
        var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
        var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    };
    Clusterer.prototype.isMarkerInBounds = function(marker, bounds) {
        var position = marker.getPosition();
        if (position) return bounds.contains(position);
        return false;
    };
    Clusterer.prototype.addToClosestCluster = function(marker) {
        var cluster;
        var distance = 40000; // Some large number
        var clusterToAddTo = null;
        for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
            var clusterElement = _a[_i];
            cluster = clusterElement;
            var center = cluster.getCenter();
            var position = marker.getPosition();
            if (center && position) {
                var d = this.distanceBetweenPoints(center, position);
                if (d < distance) {
                    distance = d;
                    clusterToAddTo = cluster;
                }
            }
        }
        if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) clusterToAddTo.addMarker(marker);
        else {
            cluster = new Cluster$1(this);
            cluster.addMarker(marker);
            this.clusters.push(cluster);
        }
    };
    Clusterer.prototype.createClusters = function(iFirst) {
        var _this = this;
        if (!this.ready) return;
        // Cancel previous batch processing if we're working on the first batch:
        if (iFirst === 0) {
            /**
             * This event is fired when the <code>Clusterer</code> begins
             *  clustering markers.
             * @name Clusterer#clusteringbegin
             * @param {Clusterer} mc The Clusterer whose markers are being clustered.
             * @event
             */ google.maps.event.trigger(this, "clusteringbegin", this);
            if (this.timerRefStatic !== null) {
                window.clearTimeout(this.timerRefStatic);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                delete this.timerRefStatic;
            }
        }
        var map = this.getMap();
        var bounds = map !== null && "getBounds" in map ? map.getBounds() : null;
        var zoom = (map === null || map === void 0 ? void 0 : map.getZoom()) || 0;
        // Get our current map view bounds.
        // Create a new bounds object so we don't affect the map.
        //
        // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
        var mapBounds = zoom > 3 ? new google.maps.LatLngBounds(bounds === null || bounds === void 0 ? void 0 : bounds.getSouthWest(), bounds === null || bounds === void 0 ? void 0 : bounds.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
        var extendedMapBounds = this.getExtendedBounds(mapBounds);
        var iLast = Math.min(iFirst + this.batchSize, this.markers.length);
        for(var i = iFirst; i < iLast; i++){
            var marker = this.markers[i];
            if (marker && !marker.isAdded && this.isMarkerInBounds(marker, extendedMapBounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) this.addToClosestCluster(marker);
        }
        if (iLast < this.markers.length) this.timerRefStatic = window.setTimeout(function() {
            _this.createClusters(iLast);
        }, 0);
        else {
            this.timerRefStatic = null;
            /**
             * This event is fired when the <code>Clusterer</code> stops
             *  clustering markers.
             * @name Clusterer#clusteringend
             * @param {Clusterer} mc The Clusterer whose markers are being clustered.
             * @event
             */ google.maps.event.trigger(this, "clusteringend", this);
            for(var _i = 0, _a = this.clusters; _i < _a.length; _i++){
                var cluster = _a[_i];
                cluster.updateIcon();
            }
        }
    };
    Clusterer.prototype.extend = function(obj1, obj2) {
        return (function applyExtend(object) {
            for(var property in object.prototype){
                // eslint-disable-next-line @typescript-eslint/ban-types
                var prop = property;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.prototype[prop] = object.prototype[prop];
            }
            return this;
        }).apply(obj1, [
            obj2
        ]);
    };
    return Clusterer;
}();
var eventMap$e = {
    onClick: "click",
    onClusteringBegin: "clusteringbegin",
    onClusteringEnd: "clusteringend",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover"
};
var updaterMap$e = {
    averageCenter: function(instance, averageCenter) {
        instance.setAverageCenter(averageCenter);
    },
    batchSizeIE: function(instance, batchSizeIE) {
        instance.setBatchSizeIE(batchSizeIE);
    },
    calculator: function(instance, calculator) {
        instance.setCalculator(calculator);
    },
    clusterClass: function(instance, clusterClass) {
        instance.setClusterClass(clusterClass);
    },
    enableRetinaIcons: function(instance, enableRetinaIcons) {
        instance.setEnableRetinaIcons(enableRetinaIcons);
    },
    gridSize: function(instance, gridSize) {
        instance.setGridSize(gridSize);
    },
    ignoreHidden: function(instance, ignoreHidden) {
        instance.setIgnoreHidden(ignoreHidden);
    },
    imageExtension: function(instance, imageExtension) {
        instance.setImageExtension(imageExtension);
    },
    imagePath: function(instance, imagePath) {
        instance.setImagePath(imagePath);
    },
    imageSizes: function(instance, imageSizes) {
        instance.setImageSizes(imageSizes);
    },
    maxZoom: function(instance, maxZoom) {
        instance.setMaxZoom(maxZoom);
    },
    minimumClusterSize: function(instance, minimumClusterSize) {
        instance.setMinimumClusterSize(minimumClusterSize);
    },
    styles: function(instance, styles) {
        instance.setStyles(styles);
    },
    title: function(instance, title) {
        instance.setTitle(title);
    },
    zoomOnClick: function(instance, zoomOnClick) {
        instance.setZoomOnClick(zoomOnClick);
    }
};
var defaultOptions$4 = {};
function MarkerClustererFunctional(props) {
    var children = props.children, options = props.options, averageCenter = props.averageCenter, batchSizeIE = props.batchSizeIE, calculator = props.calculator, clusterClass = props.clusterClass, enableRetinaIcons = props.enableRetinaIcons, gridSize = props.gridSize, ignoreHidden = props.ignoreHidden, imageExtension = props.imageExtension, imagePath = props.imagePath, imageSizes = props.imageSizes, maxZoom = props.maxZoom, minimumClusterSize = props.minimumClusterSize, styles = props.styles, title = props.title, zoomOnClick = props.zoomOnClick, onClick = props.onClick, onClusteringBegin = props.onClusteringBegin, onClusteringEnd = props.onClusteringEnd, onMouseOver = props.onMouseOver, onMouseOut = props.onMouseOut, onLoad = props.onLoad, onUnmount = props.onUnmount;
    var _a = (0, _react.useState)(null), instance = _a[0], setInstance = _a[1];
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), clickListener = _b[0], setClickListener = _b[1];
    var _c = (0, _react.useState)(null), clusteringBeginListener = _c[0], setClusteringBeginListener = _c[1];
    var _d = (0, _react.useState)(null), clusteringEndListener = _d[0], setClusteringEndListener = _d[1];
    var _e = (0, _react.useState)(null), mouseoutListener = _e[0], setMouseoutListener = _e[1];
    var _f = (0, _react.useState)(null), mouseoverListener = _f[0], setMouseoverListener = _f[1];
    (0, _react.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, eventMap$e.onMouseOut, onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, eventMap$e.onMouseOver, onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, eventMap$e.onClick, onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClusteringBegin) {
            if (clusteringBeginListener !== null) google.maps.event.removeListener(clusteringBeginListener);
            setClusteringBeginListener(google.maps.event.addListener(instance, eventMap$e.onClusteringBegin, onClusteringBegin));
        }
    }, [
        onClusteringBegin
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClusteringEnd) {
            if (clusteringEndListener !== null) google.maps.event.removeListener(clusteringEndListener);
            setClusteringBeginListener(google.maps.event.addListener(instance, eventMap$e.onClusteringEnd, onClusteringEnd));
        }
    }, [
        onClusteringEnd
    ]);
    (0, _react.useEffect)(function() {
        if (typeof averageCenter !== "undefined" && instance !== null) updaterMap$e.averageCenter(instance, averageCenter);
    }, [
        instance,
        averageCenter
    ]);
    (0, _react.useEffect)(function() {
        if (typeof batchSizeIE !== "undefined" && instance !== null) updaterMap$e.batchSizeIE(instance, batchSizeIE);
    }, [
        instance,
        batchSizeIE
    ]);
    (0, _react.useEffect)(function() {
        if (typeof calculator !== "undefined" && instance !== null) updaterMap$e.calculator(instance, calculator);
    }, [
        instance,
        calculator
    ]);
    (0, _react.useEffect)(function() {
        if (typeof clusterClass !== "undefined" && instance !== null) updaterMap$e.clusterClass(instance, clusterClass);
    }, [
        instance,
        clusterClass
    ]);
    (0, _react.useEffect)(function() {
        if (typeof enableRetinaIcons !== "undefined" && instance !== null) updaterMap$e.enableRetinaIcons(instance, enableRetinaIcons);
    }, [
        instance,
        enableRetinaIcons
    ]);
    (0, _react.useEffect)(function() {
        if (typeof gridSize !== "undefined" && instance !== null) updaterMap$e.gridSize(instance, gridSize);
    }, [
        instance,
        gridSize
    ]);
    (0, _react.useEffect)(function() {
        if (typeof ignoreHidden !== "undefined" && instance !== null) updaterMap$e.ignoreHidden(instance, ignoreHidden);
    }, [
        instance,
        ignoreHidden
    ]);
    (0, _react.useEffect)(function() {
        if (typeof imageExtension !== "undefined" && instance !== null) updaterMap$e.imageExtension(instance, imageExtension);
    }, [
        instance,
        imageExtension
    ]);
    (0, _react.useEffect)(function() {
        if (typeof imagePath !== "undefined" && instance !== null) updaterMap$e.imagePath(instance, imagePath);
    }, [
        instance,
        imagePath
    ]);
    (0, _react.useEffect)(function() {
        if (typeof imageSizes !== "undefined" && instance !== null) updaterMap$e.imageSizes(instance, imageSizes);
    }, [
        instance,
        imageSizes
    ]);
    (0, _react.useEffect)(function() {
        if (typeof maxZoom !== "undefined" && instance !== null) updaterMap$e.maxZoom(instance, maxZoom);
    }, [
        instance,
        maxZoom
    ]);
    (0, _react.useEffect)(function() {
        if (typeof minimumClusterSize !== "undefined" && instance !== null) updaterMap$e.minimumClusterSize(instance, minimumClusterSize);
    }, [
        instance,
        minimumClusterSize
    ]);
    (0, _react.useEffect)(function() {
        if (typeof styles !== "undefined" && instance !== null) updaterMap$e.styles(instance, styles);
    }, [
        instance,
        styles
    ]);
    (0, _react.useEffect)(function() {
        if (typeof title !== "undefined" && instance !== null) updaterMap$e.title(instance, title);
    }, [
        instance,
        title
    ]);
    (0, _react.useEffect)(function() {
        if (typeof zoomOnClick !== "undefined" && instance !== null) updaterMap$e.zoomOnClick(instance, zoomOnClick);
    }, [
        instance,
        zoomOnClick
    ]);
    (0, _react.useEffect)(function() {
        if (!map) return;
        var clustererOptions = __assign({}, options || defaultOptions$4);
        var clusterer = new Clusterer(map, [], clustererOptions);
        if (averageCenter) updaterMap$e.averageCenter(clusterer, averageCenter);
        if (batchSizeIE) updaterMap$e.batchSizeIE(clusterer, batchSizeIE);
        if (calculator) updaterMap$e.calculator(clusterer, calculator);
        if (clusterClass) updaterMap$e.clusterClass(clusterer, clusterClass);
        if (enableRetinaIcons) updaterMap$e.enableRetinaIcons(clusterer, enableRetinaIcons);
        if (gridSize) updaterMap$e.gridSize(clusterer, gridSize);
        if (ignoreHidden) updaterMap$e.ignoreHidden(clusterer, ignoreHidden);
        if (imageExtension) updaterMap$e.imageExtension(clusterer, imageExtension);
        if (imagePath) updaterMap$e.imagePath(clusterer, imagePath);
        if (imageSizes) updaterMap$e.imageSizes(clusterer, imageSizes);
        if (maxZoom) updaterMap$e.maxZoom(clusterer, maxZoom);
        if (minimumClusterSize) updaterMap$e.minimumClusterSize(clusterer, minimumClusterSize);
        if (styles) updaterMap$e.styles(clusterer, styles);
        if (title) updaterMap$e.title(clusterer, title);
        if (zoomOnClick) updaterMap$e.zoomOnClick(clusterer, zoomOnClick);
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(clusterer, eventMap$e.onMouseOut, onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(clusterer, eventMap$e.onMouseOver, onMouseOver));
        if (onClick) setClickListener(google.maps.event.addListener(clusterer, eventMap$e.onClick, onClick));
        if (onClusteringBegin) setClusteringBeginListener(google.maps.event.addListener(clusterer, eventMap$e.onClusteringBegin, onClusteringBegin));
        if (onClusteringEnd) setClusteringEndListener(google.maps.event.addListener(clusterer, eventMap$e.onClusteringEnd, onClusteringEnd));
        setInstance(clusterer);
        if (onLoad) onLoad(clusterer);
        return function() {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (clusteringBeginListener !== null) google.maps.event.removeListener(clusteringBeginListener);
            if (clusteringEndListener !== null) google.maps.event.removeListener(clusteringEndListener);
            if (onUnmount) onUnmount(clusterer);
        };
    }, []);
    return instance !== null ? children(instance) || null : null;
}
var MarkerClustererF = (0, _react.memo)(MarkerClustererFunctional);
var ClustererComponent = /** @class */ function(_super) {
    __extends(ClustererComponent, _super);
    function ClustererComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            markerClusterer: null
        };
        _this.setClustererCallback = function() {
            if (_this.state.markerClusterer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.markerClusterer);
        };
        return _this;
    }
    ClustererComponent.prototype.componentDidMount = function() {
        if (this.context) {
            var markerClusterer_1 = new Clusterer(this.context, [], this.props.options);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$e,
                eventMap: eventMap$e,
                prevProps: {},
                nextProps: this.props,
                instance: markerClusterer_1
            });
            this.setState(function() {
                return {
                    markerClusterer: markerClusterer_1
                };
            }, this.setClustererCallback);
        }
    };
    ClustererComponent.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.markerClusterer) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$e,
                eventMap: eventMap$e,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.markerClusterer
            });
        }
    };
    ClustererComponent.prototype.componentWillUnmount = function() {
        if (this.state.markerClusterer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.markerClusterer);
            unregisterEvents(this.registeredEvents);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.state.markerClusterer.setMap(null);
        }
    };
    ClustererComponent.prototype.render = function() {
        return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
    };
    ClustererComponent.contextType = MapContext;
    return ClustererComponent;
}((0, _react.PureComponent));
// This handler prevents an event in the InfoBox from being passed on to the map.
function cancelHandler(event) {
    event.cancelBubble = true;
    if (event.stopPropagation) event.stopPropagation();
}
var InfoBox = /** @class */ function() {
    function InfoBox(options) {
        if (options === void 0) options = {};
        this.getCloseClickHandler = this.getCloseClickHandler.bind(this);
        this.closeClickHandler = this.closeClickHandler.bind(this);
        this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this);
        this.addClickHandler = this.addClickHandler.bind(this);
        this.getCloseBoxImg = this.getCloseBoxImg.bind(this);
        this.getBoxWidths = this.getBoxWidths.bind(this);
        this.setBoxStyle = this.setBoxStyle.bind(this);
        this.setPosition = this.setPosition.bind(this);
        this.getPosition = this.getPosition.bind(this);
        this.setOptions = this.setOptions.bind(this);
        this.setContent = this.setContent.bind(this);
        this.setVisible = this.setVisible.bind(this);
        this.getContent = this.getContent.bind(this);
        this.getVisible = this.getVisible.bind(this);
        this.setZIndex = this.setZIndex.bind(this);
        this.getZIndex = this.getZIndex.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.panBox = this.panBox.bind(this);
        this.extend = this.extend.bind(this);
        this.close = this.close.bind(this);
        this.draw = this.draw.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.open = this.open.bind(this);
        this.extend(InfoBox, google.maps.OverlayView);
        // Standard options (in common with google.maps.InfoWindow):
        this.content = options.content || "";
        this.disableAutoPan = options.disableAutoPan || false;
        this.maxWidth = options.maxWidth || 0;
        this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
        this.position = options.position || new google.maps.LatLng(0, 0);
        this.zIndex = options.zIndex || null;
        // Additional options (unique to InfoBox):
        this.boxClass = options.boxClass || "infoBox";
        this.boxStyle = options.boxStyle || {};
        this.closeBoxMargin = options.closeBoxMargin || "2px";
        this.closeBoxURL = options.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
        if (options.closeBoxURL === "") this.closeBoxURL = "";
        this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);
        if (typeof options.visible === "undefined") {
            if (typeof options.isHidden === "undefined") options.visible = true;
            else options.visible = !options.isHidden;
        }
        this.isHidden = !options.visible;
        this.alignBottom = options.alignBottom || false;
        this.pane = options.pane || "floatPane";
        this.enableEventPropagation = options.enableEventPropagation || false;
        this.div = null;
        this.closeListener = null;
        this.moveListener = null;
        this.mapListener = null;
        this.contextListener = null;
        this.eventListeners = null;
        this.fixedWidthSet = null;
    }
    InfoBox.prototype.createInfoBoxDiv = function() {
        var _this = this;
        // This handler ignores the current event in the InfoBox and conditionally prevents
        // the event from being passed on to the map. It is used for the contextmenu event.
        var ignoreHandler = function(event) {
            event.returnValue = false;
            if (event.preventDefault) event.preventDefault();
            if (!_this.enableEventPropagation) cancelHandler(event);
        };
        if (!this.div) {
            this.div = document.createElement("div");
            this.setBoxStyle();
            if (typeof this.content === "string") this.div.innerHTML = this.getCloseBoxImg() + this.content;
            else {
                this.div.innerHTML = this.getCloseBoxImg();
                this.div.appendChild(this.content);
            }
            var panes = this.getPanes();
            if (panes !== null) panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM
            this.addClickHandler();
            if (this.div.style.width) this.fixedWidthSet = true;
            else if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
                this.div.style.width = this.maxWidth + "px";
                this.fixedWidthSet = true;
            } else {
                // The following code is needed to overcome problems with MSIE
                var bw = this.getBoxWidths();
                this.div.style.width = this.div.offsetWidth - bw.left - bw.right + "px";
                this.fixedWidthSet = false;
            }
            this.panBox(this.disableAutoPan);
            if (!this.enableEventPropagation) {
                this.eventListeners = [];
                // Cancel event propagation.
                // Note: mousemove not included (to resolve Issue 152)
                var events = [
                    "mousedown",
                    "mouseover",
                    "mouseout",
                    "mouseup",
                    "click",
                    "dblclick",
                    "touchstart",
                    "touchend",
                    "touchmove"
                ];
                for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
                    var event_1 = events_1[_i];
                    this.eventListeners.push(google.maps.event.addListener(this.div, event_1, cancelHandler));
                }
                // Workaround for Google bug that causes the cursor to change to a pointer
                // when the mouse moves over a marker underneath InfoBox.
                this.eventListeners.push(google.maps.event.addListener(this.div, "mouseover", function() {
                    if (_this.div) _this.div.style.cursor = "default";
                }));
            }
            this.contextListener = google.maps.event.addListener(this.div, "contextmenu", ignoreHandler);
            /**
             * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
             * @name InfoBox#domready
             * @event
             */ google.maps.event.trigger(this, "domready");
        }
    };
    InfoBox.prototype.getCloseBoxImg = function() {
        var img = "";
        if (this.closeBoxURL !== "") {
            img = '<img alt=""';
            img += ' aria-hidden="true"';
            img += " src='" + this.closeBoxURL + "'";
            img += " align=right"; // Do this because Opera chokes on style='float: right;'
            img += " style='";
            img += " position: relative;"; // Required by MSIE
            img += " cursor: pointer;";
            img += " margin: " + this.closeBoxMargin + ";";
            img += "'>";
        }
        return img;
    };
    InfoBox.prototype.addClickHandler = function() {
        this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== "" ? google.maps.event.addListener(this.div.firstChild, "click", this.getCloseClickHandler()) : null;
    };
    InfoBox.prototype.closeClickHandler = function(event) {
        // 1.0.3 fix: Always prevent propagation of a close box click to the map:
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
        /**
         * This event is fired when the InfoBox's close box is clicked.
         * @name InfoBox#closeclick
         * @event
         */ google.maps.event.trigger(this, "closeclick");
        this.close();
    };
    InfoBox.prototype.getCloseClickHandler = function() {
        return this.closeClickHandler;
    };
    InfoBox.prototype.panBox = function(disablePan) {
        if (this.div && !disablePan) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var map = this.getMap();
            // Only pan if attached to map, not panorama
            if (map instanceof google.maps.Map) {
                var xOffset = 0;
                var yOffset = 0;
                var bounds = map.getBounds();
                if (bounds && !bounds.contains(this.position)) // Marker not in visible area of map, so set center
                // of map to the marker position first.
                map.setCenter(this.position);
                var mapDiv = map.getDiv();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var mapWidth = mapDiv.offsetWidth;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var mapHeight = mapDiv.offsetHeight;
                var iwOffsetX = this.pixelOffset.width;
                var iwOffsetY = this.pixelOffset.height;
                var iwWidth = this.div.offsetWidth;
                var iwHeight = this.div.offsetHeight;
                var padX = this.infoBoxClearance.width;
                var padY = this.infoBoxClearance.height;
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var projection = this.getProjection();
                var pixPosition = projection.fromLatLngToContainerPixel(this.position);
                if (pixPosition !== null) {
                    if (pixPosition.x < -iwOffsetX + padX) xOffset = pixPosition.x + iwOffsetX - padX;
                    else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
                    if (this.alignBottom) {
                        if (pixPosition.y < -iwOffsetY + padY + iwHeight) yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
                        else if (pixPosition.y + iwOffsetY + padY > mapHeight) yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
                    } else {
                        if (pixPosition.y < -iwOffsetY + padY) yOffset = pixPosition.y + iwOffsetY - padY;
                        else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
                    }
                }
                if (!(xOffset === 0 && yOffset === 0)) // Move the map to the shifted center.
                map.panBy(xOffset, yOffset);
            }
        }
    };
    InfoBox.prototype.setBoxStyle = function() {
        if (this.div) {
            // Apply style values from the style sheet defined in the boxClass parameter:
            this.div.className = this.boxClass;
            // Clear existing inline style values:
            this.div.style.cssText = "";
            // Apply style values defined in the boxStyle parameter:
            var boxStyle = this.boxStyle;
            for(var i in boxStyle)if (Object.prototype.hasOwnProperty.call(boxStyle, i)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.div.style[i] = boxStyle[i];
            // Fix for iOS disappearing InfoBox problem
            // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
            this.div.style.webkitTransform = "translateZ(0)";
            // Fix up opacity style for benefit of MSIE
            if (typeof this.div.style.opacity !== "undefined" && this.div.style.opacity !== "") {
                // See http://www.quirksmode.org/css/opacity.html
                var opacity = parseFloat(this.div.style.opacity || "");
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
                this.div.style.filter = "alpha(opacity=" + opacity * 100 + ")";
            }
            // Apply required styles
            this.div.style.position = "absolute";
            this.div.style.visibility = "hidden";
            if (this.zIndex !== null) this.div.style.zIndex = this.zIndex + "";
            if (!this.div.style.overflow) this.div.style.overflow = "auto";
        }
    };
    InfoBox.prototype.getBoxWidths = function() {
        var bw = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        if (!this.div) return bw;
        if (document.defaultView) {
            var ownerDocument = this.div.ownerDocument;
            var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, "") : null;
            if (computedStyle) {
                // The computed styles are always in pixel units (good!)
                bw.top = parseInt(computedStyle.borderTopWidth || "", 10) || 0;
                bw.bottom = parseInt(computedStyle.borderBottomWidth || "", 10) || 0;
                bw.left = parseInt(computedStyle.borderLeftWidth || "", 10) || 0;
                bw.right = parseInt(computedStyle.borderRightWidth || "", 10) || 0;
            }
        } else if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.documentElement.currentStyle // MSIE
        ) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var currentStyle = this.div.currentStyle;
            if (currentStyle) {
                // The current styles may not be in pixel units, but assume they are (bad!)
                bw.top = parseInt(currentStyle.borderTopWidth || "", 10) || 0;
                bw.bottom = parseInt(currentStyle.borderBottomWidth || "", 10) || 0;
                bw.left = parseInt(currentStyle.borderLeftWidth || "", 10) || 0;
                bw.right = parseInt(currentStyle.borderRightWidth || "", 10) || 0;
            }
        }
        return bw;
    };
    InfoBox.prototype.onRemove = function() {
        if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    };
    InfoBox.prototype.draw = function() {
        this.createInfoBoxDiv();
        if (this.div) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var projection = this.getProjection();
            var pixPosition = projection.fromLatLngToDivPixel(this.position);
            if (pixPosition !== null) {
                this.div.style.left = pixPosition.x + this.pixelOffset.width + "px";
                if (this.alignBottom) this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + "px";
                else this.div.style.top = pixPosition.y + this.pixelOffset.height + "px";
            }
            if (this.isHidden) this.div.style.visibility = "hidden";
            else this.div.style.visibility = "visible";
        }
    };
    InfoBox.prototype.setOptions = function(options) {
        if (options === void 0) options = {};
        if (typeof options.boxClass !== "undefined") {
            // Must be first
            this.boxClass = options.boxClass;
            this.setBoxStyle();
        }
        if (typeof options.boxStyle !== "undefined") {
            // Must be second
            this.boxStyle = options.boxStyle;
            this.setBoxStyle();
        }
        if (typeof options.content !== "undefined") this.setContent(options.content);
        if (typeof options.disableAutoPan !== "undefined") this.disableAutoPan = options.disableAutoPan;
        if (typeof options.maxWidth !== "undefined") this.maxWidth = options.maxWidth;
        if (typeof options.pixelOffset !== "undefined") this.pixelOffset = options.pixelOffset;
        if (typeof options.alignBottom !== "undefined") this.alignBottom = options.alignBottom;
        if (typeof options.position !== "undefined") this.setPosition(options.position);
        if (typeof options.zIndex !== "undefined") this.setZIndex(options.zIndex);
        if (typeof options.closeBoxMargin !== "undefined") this.closeBoxMargin = options.closeBoxMargin;
        if (typeof options.closeBoxURL !== "undefined") this.closeBoxURL = options.closeBoxURL;
        if (typeof options.infoBoxClearance !== "undefined") this.infoBoxClearance = options.infoBoxClearance;
        if (typeof options.isHidden !== "undefined") this.isHidden = options.isHidden;
        if (typeof options.visible !== "undefined") this.isHidden = !options.visible;
        if (typeof options.enableEventPropagation !== "undefined") this.enableEventPropagation = options.enableEventPropagation;
        if (this.div) this.draw();
    };
    InfoBox.prototype.setContent = function(content) {
        this.content = content;
        if (this.div) {
            if (this.closeListener) {
                google.maps.event.removeListener(this.closeListener);
                this.closeListener = null;
            }
            // Odd code required to make things work with MSIE.
            if (!this.fixedWidthSet) this.div.style.width = "";
            if (typeof content === "string") this.div.innerHTML = this.getCloseBoxImg() + content;
            else {
                this.div.innerHTML = this.getCloseBoxImg();
                this.div.appendChild(content);
            }
            // Perverse code required to make things work with MSIE.
            // (Ensures the close box does, in fact, float to the right.)
            if (!this.fixedWidthSet) {
                this.div.style.width = this.div.offsetWidth + "px";
                if (typeof content === "string") this.div.innerHTML = this.getCloseBoxImg() + content;
                else {
                    this.div.innerHTML = this.getCloseBoxImg();
                    this.div.appendChild(content);
                }
            }
            this.addClickHandler();
        }
        /**
         * This event is fired when the content of the InfoBox changes.
         * @name InfoBox#content_changed
         * @event
         */ google.maps.event.trigger(this, "content_changed");
    };
    InfoBox.prototype.setPosition = function(latLng) {
        this.position = latLng;
        if (this.div) this.draw();
        /**
         * This event is fired when the position of the InfoBox changes.
         * @name InfoBox#position_changed
         * @event
         */ google.maps.event.trigger(this, "position_changed");
    };
    InfoBox.prototype.setVisible = function(isVisible) {
        this.isHidden = !isVisible;
        if (this.div) this.div.style.visibility = this.isHidden ? "hidden" : "visible";
    };
    InfoBox.prototype.setZIndex = function(index) {
        this.zIndex = index;
        if (this.div) this.div.style.zIndex = index + "";
        /**
         * This event is fired when the zIndex of the InfoBox changes.
         * @name InfoBox#zindex_changed
         * @event
         */ google.maps.event.trigger(this, "zindex_changed");
    };
    InfoBox.prototype.getContent = function() {
        return this.content;
    };
    InfoBox.prototype.getPosition = function() {
        return this.position;
    };
    InfoBox.prototype.getZIndex = function() {
        return this.zIndex;
    };
    InfoBox.prototype.getVisible = function() {
        var map = this.getMap();
        return typeof map === "undefined" || map === null ? false : !this.isHidden;
    };
    InfoBox.prototype.show = function() {
        this.isHidden = false;
        if (this.div) this.div.style.visibility = "visible";
    };
    InfoBox.prototype.hide = function() {
        this.isHidden = true;
        if (this.div) this.div.style.visibility = "hidden";
    };
    InfoBox.prototype.open = function(map, anchor) {
        var _this = this;
        if (anchor) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.position = anchor.getPosition();
            this.moveListener = google.maps.event.addListener(anchor, "position_changed", function() {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                var position = anchor.getPosition();
                _this.setPosition(position);
            });
            this.mapListener = google.maps.event.addListener(anchor, "map_changed", function() {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                _this.setMap(anchor.map);
            });
        }
        this.setMap(map);
        if (this.div) this.panBox();
    };
    InfoBox.prototype.close = function() {
        if (this.closeListener) {
            google.maps.event.removeListener(this.closeListener);
            this.closeListener = null;
        }
        if (this.eventListeners) {
            for(var _i = 0, _a = this.eventListeners; _i < _a.length; _i++){
                var eventListener = _a[_i];
                google.maps.event.removeListener(eventListener);
            }
            this.eventListeners = null;
        }
        if (this.moveListener) {
            google.maps.event.removeListener(this.moveListener);
            this.moveListener = null;
        }
        if (this.mapListener) {
            google.maps.event.removeListener(this.mapListener);
            this.mapListener = null;
        }
        if (this.contextListener) {
            google.maps.event.removeListener(this.contextListener);
            this.contextListener = null;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.setMap(null);
    };
    InfoBox.prototype.extend = function(obj1, obj2) {
        return (function applyExtend(object) {
            for(var property in object.prototype)if (!Object.prototype.hasOwnProperty.call(this, property)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.prototype[property] = object.prototype[property];
            return this;
        }).apply(obj1, [
            obj2
        ]);
    };
    return InfoBox;
}();
var eventMap$d = {
    onCloseClick: "closeclick",
    onContentChanged: "content_changed",
    onDomReady: "domready",
    onPositionChanged: "position_changed",
    onZindexChanged: "zindex_changed"
};
var updaterMap$d = {
    options: function(instance, options) {
        instance.setOptions(options);
    },
    position: function(instance, position) {
        if (position instanceof google.maps.LatLng) instance.setPosition(position);
        else instance.setPosition(new google.maps.LatLng(position.lat, position.lng));
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var defaultOptions$3 = {};
function InfoBoxFunctional(_a) {
    var children = _a.children, anchor = _a.anchor, options = _a.options, position = _a.position, zIndex = _a.zIndex, onCloseClick = _a.onCloseClick, onDomReady = _a.onDomReady, onContentChanged = _a.onContentChanged, onPositionChanged = _a.onPositionChanged, onZindexChanged = _a.onZindexChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), closeClickListener = _c[0], setCloseClickListener = _c[1];
    var _d = (0, _react.useState)(null), domReadyClickListener = _d[0], setDomReadyClickListener = _d[1];
    var _e = (0, _react.useState)(null), contentChangedClickListener = _e[0], setContentChangedClickListener = _e[1];
    var _f = (0, _react.useState)(null), positionChangedClickListener = _f[0], setPositionChangedClickListener = _f[1];
    var _g = (0, _react.useState)(null), zIndexChangedClickListener = _g[0], setZindexChangedClickListener = _g[1];
    var containerElementRef = (0, _react.useRef)(null);
    // Order does matter
    (0, _react.useEffect)(function() {
        if (map && instance !== null) {
            instance.close();
            if (anchor) instance.open(map, anchor);
            else if (instance.getPosition()) instance.open(map);
        }
    }, [
        map,
        instance,
        anchor
    ]);
    (0, _react.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (position && instance !== null) {
            var positionLatLng = position instanceof google.maps.LatLng ? position : new google.maps.LatLng(position.lat, position.lng);
            instance.setPosition(positionLatLng);
        }
    }, [
        position
    ]);
    (0, _react.useEffect)(function() {
        if (typeof zIndex === "number" && instance !== null) instance.setZIndex(zIndex);
    }, [
        zIndex
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onCloseClick) {
            if (closeClickListener !== null) google.maps.event.removeListener(closeClickListener);
            setCloseClickListener(google.maps.event.addListener(instance, "closeclick", onCloseClick));
        }
    }, [
        onCloseClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDomReady) {
            if (domReadyClickListener !== null) google.maps.event.removeListener(domReadyClickListener);
            setDomReadyClickListener(google.maps.event.addListener(instance, "domready", onDomReady));
        }
    }, [
        onDomReady
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onContentChanged) {
            if (contentChangedClickListener !== null) google.maps.event.removeListener(contentChangedClickListener);
            setContentChangedClickListener(google.maps.event.addListener(instance, "content_changed", onContentChanged));
        }
    }, [
        onContentChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onPositionChanged) {
            if (positionChangedClickListener !== null) google.maps.event.removeListener(positionChangedClickListener);
            setPositionChangedClickListener(google.maps.event.addListener(instance, "position_changed", onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onZindexChanged) {
            if (zIndexChangedClickListener !== null) google.maps.event.removeListener(zIndexChangedClickListener);
            setZindexChangedClickListener(google.maps.event.addListener(instance, "zindex_changed", onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, _react.useEffect)(function() {
        if (map) {
            var _a = options || defaultOptions$3, position_1 = _a.position, infoBoxOptions = __rest$1(_a, [
                "position"
            ]);
            var positionLatLng = void 0;
            if (position_1 && !(position_1 instanceof google.maps.LatLng)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            positionLatLng = new google.maps.LatLng(position_1.lat, position_1.lng);
            var infoBox = new InfoBox(__assign(__assign({}, infoBoxOptions), positionLatLng ? {
                position: positionLatLng
            } : {}));
            containerElementRef.current = document.createElement("div");
            setInstance(infoBox);
            if (onCloseClick) setCloseClickListener(google.maps.event.addListener(infoBox, "closeclick", onCloseClick));
            if (onDomReady) setDomReadyClickListener(google.maps.event.addListener(infoBox, "domready", onDomReady));
            if (onContentChanged) setContentChangedClickListener(google.maps.event.addListener(infoBox, "content_changed", onContentChanged));
            if (onPositionChanged) setPositionChangedClickListener(google.maps.event.addListener(infoBox, "position_changed", onPositionChanged));
            if (onZindexChanged) setZindexChangedClickListener(google.maps.event.addListener(infoBox, "zindex_changed", onZindexChanged));
            infoBox.setContent(containerElementRef.current);
            if (anchor) infoBox.open(map, anchor);
            else if (infoBox.getPosition()) infoBox.open(map);
            else invariant$1(false, "You must provide either an anchor or a position prop for <InfoBox>.");
            if (onLoad) onLoad(infoBox);
        }
        return function() {
            if (instance !== null) {
                if (closeClickListener) google.maps.event.removeListener(closeClickListener);
                if (contentChangedClickListener) google.maps.event.removeListener(contentChangedClickListener);
                if (domReadyClickListener) google.maps.event.removeListener(domReadyClickListener);
                if (positionChangedClickListener) google.maps.event.removeListener(positionChangedClickListener);
                if (zIndexChangedClickListener) google.maps.event.removeListener(zIndexChangedClickListener);
                if (onUnmount) onUnmount(instance);
                instance.close();
            }
        };
    }, []);
    return containerElementRef.current ? (0, _reactDom.createPortal)((0, _react.Children).only(children), containerElementRef.current) : null;
}
var InfoBoxF = (0, _react.memo)(InfoBoxFunctional);
var InfoBoxComponent = /** @class */ function(_super) {
    __extends(InfoBoxComponent, _super);
    function InfoBoxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = null;
        _this.state = {
            infoBox: null
        };
        _this.open = function(infoBox, anchor) {
            if (anchor) {
                if (_this.context !== null) infoBox.open(_this.context, anchor);
            } else if (infoBox.getPosition()) {
                if (_this.context !== null) infoBox.open(_this.context);
            } else invariant$1(false, "You must provide either an anchor or a position prop for <InfoBox>.");
        };
        _this.setInfoBoxCallback = function() {
            if (_this.state.infoBox !== null && _this.containerElement !== null) {
                _this.state.infoBox.setContent(_this.containerElement);
                _this.open(_this.state.infoBox, _this.props.anchor);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.infoBox);
            }
        };
        return _this;
    }
    InfoBoxComponent.prototype.componentDidMount = function() {
        var _a = this.props.options || {}, position = _a.position, infoBoxOptions = __rest$1(_a, [
            "position"
        ]);
        var positionLatLng;
        if (position && !(position instanceof google.maps.LatLng)) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(position.lat, position.lng);
        var infoBox = new InfoBox(__assign(__assign({}, infoBoxOptions), positionLatLng ? {
            position: positionLatLng
        } : {}));
        this.containerElement = document.createElement("div");
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$d,
            eventMap: eventMap$d,
            prevProps: {},
            nextProps: this.props,
            instance: infoBox
        });
        this.setState({
            infoBox: infoBox
        }, this.setInfoBoxCallback);
    };
    InfoBoxComponent.prototype.componentDidUpdate = function(prevProps) {
        var infoBox = this.state.infoBox;
        if (infoBox !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$d,
                eventMap: eventMap$d,
                prevProps: prevProps,
                nextProps: this.props,
                instance: infoBox
            });
        }
    };
    InfoBoxComponent.prototype.componentWillUnmount = function() {
        var onUnmount = this.props.onUnmount;
        var infoBox = this.state.infoBox;
        if (infoBox !== null) {
            if (onUnmount) onUnmount(infoBox);
            unregisterEvents(this.registeredEvents);
            infoBox.close();
        }
    };
    InfoBoxComponent.prototype.render = function() {
        return this.containerElement ? (0, _reactDom.createPortal)((0, _react.Children).only(this.props.children), this.containerElement) : null;
    };
    InfoBoxComponent.contextType = MapContext;
    return InfoBoxComponent;
}((0, _react.PureComponent));
// do not edit .js files directly - edit src/index.jst
var fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var equal = /*@__PURE__*/ getDefaultExportFromCjs(fastDeepEqual);
const ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const VERSION = 1; // serialized format version
const HEADER_SIZE = 8;
class KDBush {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error("Data does not appear to be in a KDBush format.");
        const version = versionAndType >> 4;
        if (version !== VERSION) throw new Error(`Got v${version} data when expected v${VERSION}.`);
        const ArrayType = ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error("Unrecognized array type.");
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new KDBush(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer(HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                (VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids, coords, nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids, coords, nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) swapItem(ids, coords, left, right);
        while(i < j){
            swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) swapItem(ids, coords, left, j);
        else {
            j++;
            swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
const defaultOptions$2 = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const OFFSET_ZOOM = 2;
const OFFSET_ID = 3;
const OFFSET_PARENT = 4;
const OFFSET_NUM = 5;
const OFFSET_PROP = 6;
class Supercluster {
    constructor(options){
        this.options = Object.assign(Object.create(defaultOptions$2), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        const { log, minZoom, maxZoom } = this.options;
        if (log) console.time("total time");
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = fround(lngX(lng));
            const y = fround(latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd("total time");
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = "No cluster with the specified id.";
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + OFFSET_PARENT] === clusterId) children.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent, radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new KDBush(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = lngX(lng);
                py = latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius, extent, reduce, minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + OFFSET_ZOOM] <= zoom) continue;
            data[i + OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + OFFSET_ZOOM] > zoom) numPoints += data[k + OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + OFFSET_ZOOM] <= zoom) continue;
                    data[k + OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + OFFSET_ZOOM] <= zoom) continue;
                    data[k + OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function getClusterJSON(data, i, clusterProps) {
    return {
        type: "Feature",
        id: data[i + OFFSET_ID],
        properties: getClusterProperties(data, i, clusterProps),
        geometry: {
            type: "Point",
            coordinates: [
                xLng(data[i]),
                yLat(data[i + 1])
            ]
        }
    };
}
function getClusterProperties(data, i, clusterProps) {
    const count = data[i + OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function lngX(lng) {
    return lng / 360 + 0.5;
}
function latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function xLng(x) {
    return (x - 0.5) * 360;
}
function yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MarkerUtils {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Cluster {
    constructor({ markers, position }){
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend(MarkerUtils.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>MarkerUtils.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            MarkerUtils.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const filterMarkersToPaddedViewport = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const extendedMapBounds = extendBoundsToPaddedViewport(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains(MarkerUtils.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ const extendBoundsToPaddedViewport = (bounds, projection, numPixels)=>{
    const { northEast, southWest } = latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = extendPixelBounds({
        northEast,
        southWest
    }, numPixels);
    return pixelBoundsToLatLngBounds(extendedPixelBounds, projection);
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const distanceBetweenPoints = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const extendPixelBounds = ({ northEast, southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast,
        southWest
    };
};
/**
 * @hidden
 */ const pixelBoundsToLatLngBounds = ({ northEast, southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class AbstractAlgorithm {
    constructor({ maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers }) {
        return noop$1(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class AbstractViewportAlgorithm extends AbstractAlgorithm {
    constructor(_a){
        var { viewportPadding = 60 } = _a, options = __rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers, map, mapCanvasProjection }) {
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map,
                mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ const noop$1 = (markers)=>{
    const clusters = markers.map((marker)=>new Cluster({
            position: MarkerUtils.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class GridAlgorithm extends AbstractViewportAlgorithm {
    constructor(_a){
        var { maxDistance = 40000, gridSize = 40 } = _a, options = __rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate({ markers, map, mapCanvasProjection }) {
        const state = {
            zoom: map.getZoom()
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !equal(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers
            }),
            changed
        };
        return {
            clusters: this.cluster({
                markers: filterMarkersToPaddedViewport(map, mapCanvasProjection, markers, this.viewportPadding),
                map,
                mapCanvasProjection
            })
        };
    }
    cluster({ markers, map, mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            const distance = distanceBetweenPoints(candidate.bounds.getCenter().toJSON(), MarkerUtils.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && extendBoundsToPaddedViewport(cluster.bounds, projection, this.gridSize).contains(MarkerUtils.getPosition(marker))) cluster.push(marker);
        else {
            const cluster = new Cluster({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class NoopAlgorithm extends AbstractAlgorithm {
    constructor(_a){
        var options = __rest(_a, []);
        super(options);
    }
    calculate({ markers, map, mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers,
                map,
                mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class SuperClusterAlgorithm extends AbstractAlgorithm {
    constructor(_a){
        var { maxZoom, radius = 60 } = _a, options = __rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new Supercluster(Object.assign({
            maxZoom: this.maxZoom,
            radius
        }, options));
    }
    calculate(input) {
        let changed = false;
        const state = {
            zoom: input.map.getZoom()
        };
        if (!equal(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = MarkerUtils.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates
                    },
                    properties: {
                        marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !equal(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed
        };
    }
    cluster({ map }) {
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties }) {
        if (properties.cluster) return new Cluster({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat,
                lng
            }
        });
        const marker = properties.marker;
        return new Cluster({
            markers: [
                marker
            ],
            position: MarkerUtils.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class ClusterStats {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class DefaultRenderer {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count, position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const div = document.createElement("div");
            div.innerHTML = svg;
            const svgEl = div.firstElementChild;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map,
                position,
                zIndex,
                title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position,
            zIndex,
            title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        extend(OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var MarkerClustererEvents;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));
const defaultOnClusterClickHandler = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class MarkerClusterer extends OverlayViewSafe {
    constructor({ map, markers = [], algorithmOptions = {}, algorithm = new SuperClusterAlgorithm(algorithmOptions), renderer = new DefaultRenderer(), onClusterClick = defaultOnClusterClickHandler }){
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        MarkerUtils.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);
            const { clusters, changed } = this.algorithm.calculate({
                markers: this.markers,
                map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        MarkerUtils.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>MarkerUtils.setMap(marker, null)));
            }
            google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>MarkerUtils.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new ClusterStats(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>MarkerUtils.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, MarkerClustererEvents.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            MarkerUtils.setMap(cluster.marker, map);
        });
    }
}
var index_esm = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractAlgorithm: AbstractAlgorithm,
    AbstractViewportAlgorithm: AbstractViewportAlgorithm,
    Cluster: Cluster,
    ClusterStats: ClusterStats,
    DefaultRenderer: DefaultRenderer,
    GridAlgorithm: GridAlgorithm,
    MarkerClusterer: MarkerClusterer,
    get MarkerClustererEvents () {
        return MarkerClustererEvents;
    },
    NoopAlgorithm: NoopAlgorithm,
    SuperClusterAlgorithm: SuperClusterAlgorithm,
    defaultOnClusterClickHandler: defaultOnClusterClickHandler,
    distanceBetweenPoints: distanceBetweenPoints,
    extendBoundsToPaddedViewport: extendBoundsToPaddedViewport,
    extendPixelBounds: extendPixelBounds,
    filterMarkersToPaddedViewport: filterMarkersToPaddedViewport,
    noop: noop$1,
    pixelBoundsToLatLngBounds: pixelBoundsToLatLngBounds
});
function useGoogleMarkerClusterer(options) {
    var map = useGoogleMap();
    var _a = (0, _react.useState)(null), markerClusterer = _a[0], setMarkerClusterer = _a[1];
    (0, _react.useEffect)(function() {
        if (map && markerClusterer === null) {
            var markerCluster = new MarkerClusterer(__assign(__assign({}, options), {
                map: map
            }));
            setMarkerClusterer(markerCluster);
        }
    }, [
        map
    ]);
    return markerClusterer;
}
/** Wrapper around [@googlemaps/markerclusterer](https://github.com/googlemaps/js-markerclusterer)
 *
 * Accepts {@link  MarkerClustererOptionsSubset} which is a subset of  {@link MarkerClustererOptions}
 */ function GoogleMarkerClusterer(_a) {
    var children = _a.children, options = _a.options;
    var markerClusterer = useGoogleMarkerClusterer(options);
    return markerClusterer !== null ? children(markerClusterer) : null;
}
var GoogleMarkerClusterer$1 = (0, _react.memo)(GoogleMarkerClusterer);
var eventMap$c = {
    onCloseClick: "closeclick",
    onContentChanged: "content_changed",
    onDomReady: "domready",
    onPositionChanged: "position_changed",
    onZindexChanged: "zindex_changed"
};
var updaterMap$c = {
    options: function(instance, options) {
        instance.setOptions(options);
    },
    position: function(instance, position) {
        instance.setPosition(position);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
function InfoWindowFunctional(_a) {
    var children = _a.children, anchor = _a.anchor, options = _a.options, position = _a.position, zIndex = _a.zIndex, onCloseClick = _a.onCloseClick, onDomReady = _a.onDomReady, onContentChanged = _a.onContentChanged, onPositionChanged = _a.onPositionChanged, onZindexChanged = _a.onZindexChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), closeclickListener = _c[0], setCloseClickListener = _c[1];
    var _d = (0, _react.useState)(null), domreadyclickListener = _d[0], setDomReadyClickListener = _d[1];
    var _e = (0, _react.useState)(null), contentchangedclickListener = _e[0], setContentChangedClickListener = _e[1];
    var _f = (0, _react.useState)(null), positionchangedclickListener = _f[0], setPositionChangedClickListener = _f[1];
    var _g = (0, _react.useState)(null), zindexchangedclickListener = _g[0], setZindexChangedClickListener = _g[1];
    var containerElementRef = (0, _react.useRef)(null);
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) {
            instance.close();
            if (anchor) instance.open(map, anchor);
            else if (instance.getPosition()) instance.open(map);
        }
    }, [
        map,
        instance,
        anchor
    ]);
    (0, _react.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (position && instance !== null) instance.setPosition(position);
    }, [
        position
    ]);
    (0, _react.useEffect)(function() {
        if (typeof zIndex === "number" && instance !== null) instance.setZIndex(zIndex);
    }, [
        zIndex
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onCloseClick) {
            if (closeclickListener !== null) google.maps.event.removeListener(closeclickListener);
            setCloseClickListener(google.maps.event.addListener(instance, "closeclick", onCloseClick));
        }
    }, [
        onCloseClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDomReady) {
            if (domreadyclickListener !== null) google.maps.event.removeListener(domreadyclickListener);
            setDomReadyClickListener(google.maps.event.addListener(instance, "domready", onDomReady));
        }
    }, [
        onDomReady
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onContentChanged) {
            if (contentchangedclickListener !== null) google.maps.event.removeListener(contentchangedclickListener);
            setContentChangedClickListener(google.maps.event.addListener(instance, "content_changed", onContentChanged));
        }
    }, [
        onContentChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onPositionChanged) {
            if (positionchangedclickListener !== null) google.maps.event.removeListener(positionchangedclickListener);
            setPositionChangedClickListener(google.maps.event.addListener(instance, "position_changed", onPositionChanged));
        }
    }, [
        onPositionChanged
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onZindexChanged) {
            if (zindexchangedclickListener !== null) google.maps.event.removeListener(zindexchangedclickListener);
            setZindexChangedClickListener(google.maps.event.addListener(instance, "zindex_changed", onZindexChanged));
        }
    }, [
        onZindexChanged
    ]);
    (0, _react.useEffect)(function() {
        var infoWindow = new google.maps.InfoWindow(__assign({}, options || {}));
        setInstance(infoWindow);
        containerElementRef.current = document.createElement("div");
        if (onCloseClick) setCloseClickListener(google.maps.event.addListener(infoWindow, "closeclick", onCloseClick));
        if (onDomReady) setDomReadyClickListener(google.maps.event.addListener(infoWindow, "domready", onDomReady));
        if (onContentChanged) setContentChangedClickListener(google.maps.event.addListener(infoWindow, "content_changed", onContentChanged));
        if (onPositionChanged) setPositionChangedClickListener(google.maps.event.addListener(infoWindow, "position_changed", onPositionChanged));
        if (onZindexChanged) setZindexChangedClickListener(google.maps.event.addListener(infoWindow, "zindex_changed", onZindexChanged));
        infoWindow.setContent(containerElementRef.current);
        if (position) infoWindow.setPosition(position);
        if (zIndex) infoWindow.setZIndex(zIndex);
        if (anchor) infoWindow.open(map, anchor);
        else if (infoWindow.getPosition()) infoWindow.open(map);
        else invariant$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
        if (onLoad) onLoad(infoWindow);
        return function() {
            if (closeclickListener) google.maps.event.removeListener(closeclickListener);
            if (contentchangedclickListener) google.maps.event.removeListener(contentchangedclickListener);
            if (domreadyclickListener) google.maps.event.removeListener(domreadyclickListener);
            if (positionchangedclickListener) google.maps.event.removeListener(positionchangedclickListener);
            if (zindexchangedclickListener) google.maps.event.removeListener(zindexchangedclickListener);
            if (onUnmount) onUnmount(infoWindow);
            infoWindow.close();
        };
    }, []);
    return containerElementRef.current ? (0, _reactDom.createPortal)((0, _react.Children).only(children), containerElementRef.current) : null;
}
var InfoWindowF = (0, _react.memo)(InfoWindowFunctional);
var InfoWindow = /** @class */ function(_super) {
    __extends(InfoWindow, _super);
    function InfoWindow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = null;
        _this.state = {
            infoWindow: null
        };
        _this.open = function(infoWindow, anchor) {
            if (anchor) infoWindow.open(_this.context, anchor);
            else if (infoWindow.getPosition()) infoWindow.open(_this.context);
            else invariant$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
        };
        _this.setInfoWindowCallback = function() {
            if (_this.state.infoWindow !== null && _this.containerElement !== null) {
                _this.state.infoWindow.setContent(_this.containerElement);
                _this.open(_this.state.infoWindow, _this.props.anchor);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.infoWindow);
            }
        };
        return _this;
    }
    InfoWindow.prototype.componentDidMount = function() {
        var infoWindow = new google.maps.InfoWindow(__assign({}, this.props.options || {}));
        this.containerElement = document.createElement("div");
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$c,
            eventMap: eventMap$c,
            prevProps: {},
            nextProps: this.props,
            instance: infoWindow
        });
        this.setState(function() {
            return {
                infoWindow: infoWindow
            };
        }, this.setInfoWindowCallback);
    };
    InfoWindow.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.infoWindow !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$c,
                eventMap: eventMap$c,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.infoWindow
            });
        }
    };
    InfoWindow.prototype.componentWillUnmount = function() {
        if (this.state.infoWindow !== null) {
            unregisterEvents(this.registeredEvents);
            if (this.props.onUnmount) this.props.onUnmount(this.state.infoWindow);
            this.state.infoWindow.close();
        }
    };
    InfoWindow.prototype.render = function() {
        return this.containerElement ? (0, _reactDom.createPortal)((0, _react.Children).only(this.props.children), this.containerElement) : null;
    };
    InfoWindow.contextType = MapContext;
    return InfoWindow;
}((0, _react.PureComponent));
var eventMap$b = {
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var updaterMap$b = {
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    path: function(instance, path) {
        instance.setPath(path);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
var defaultOptions$1 = {};
function PolylineFunctional(_a) {
    var options = _a.options, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, path = _a.path, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, _react.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, _react.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, _react.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, _react.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, _react.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, _react.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, _react.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, _react.useState)(null), rightclickListener = _l[0], setRightclickListener = _l[1];
    var _m = (0, _react.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, _react.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, _react.useEffect)(function() {
        if (typeof path !== "undefined" && instance !== null) instance.setPath(path);
    }, [
        instance,
        path
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, _react.useEffect)(function() {
        var polyline = new google.maps.Polyline(__assign(__assign({}, options || defaultOptions$1), {
            map: map
        }));
        if (path) polyline.setPath(path);
        if (typeof visible !== "undefined") polyline.setVisible(visible);
        if (typeof editable !== "undefined") polyline.setEditable(editable);
        if (typeof draggable !== "undefined") polyline.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(polyline, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(polyline, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(polyline, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(polyline, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(polyline, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(polyline, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(polyline, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(polyline, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(polyline, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(polyline, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(polyline, "drag", onDrag));
        setInstance(polyline);
        if (onLoad) onLoad(polyline);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (onUnmount) onUnmount(polyline);
            polyline.setMap(null);
        };
    }, []);
    return null;
}
var PolylineF = (0, _react.memo)(PolylineFunctional);
var Polyline = /** @class */ function(_super) {
    __extends(Polyline, _super);
    function Polyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            polyline: null
        };
        _this.setPolylineCallback = function() {
            if (_this.state.polyline !== null && _this.props.onLoad) _this.props.onLoad(_this.state.polyline);
        };
        return _this;
    }
    Polyline.prototype.componentDidMount = function() {
        var polyline = new google.maps.Polyline(__assign(__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$b,
            eventMap: eventMap$b,
            prevProps: {},
            nextProps: this.props,
            instance: polyline
        });
        this.setState(function setPolyline() {
            return {
                polyline: polyline
            };
        }, this.setPolylineCallback);
    };
    Polyline.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.polyline !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$b,
                eventMap: eventMap$b,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.polyline
            });
        }
    };
    Polyline.prototype.componentWillUnmount = function() {
        if (this.state.polyline !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.polyline);
            unregisterEvents(this.registeredEvents);
            this.state.polyline.setMap(null);
        }
    };
    Polyline.prototype.render = function() {
        return null;
    };
    Polyline.contextType = MapContext;
    return Polyline;
}((0, _react.PureComponent));
var eventMap$a = {
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var updaterMap$a = {
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    path: function(instance, path) {
        instance.setPath(path);
    },
    paths: function(instance, paths) {
        instance.setPaths(paths);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
function PolygonFunctional(_a) {
    var options = _a.options, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, path = _a.path, paths = _a.paths, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, _react.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, _react.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, _react.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, _react.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, _react.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, _react.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, _react.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, _react.useState)(null), rightclickListener = _l[0], setRightclickListener = _l[1];
    var _m = (0, _react.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, _react.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, _react.useEffect)(function() {
        if (typeof path !== "undefined" && instance !== null) instance.setPath(path);
    }, [
        instance,
        path
    ]);
    (0, _react.useEffect)(function() {
        if (typeof paths !== "undefined" && instance !== null) instance.setPaths(paths);
    }, [
        instance,
        paths
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, _react.useEffect)(function() {
        var polygon = new google.maps.Polygon(__assign(__assign({}, options || {}), {
            map: map
        }));
        if (path) polygon.setPath(path);
        if (paths) polygon.setPaths(paths);
        if (typeof visible !== "undefined") polygon.setVisible(visible);
        if (typeof editable !== "undefined") polygon.setEditable(editable);
        if (typeof draggable !== "undefined") polygon.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(polygon, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(polygon, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(polygon, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(polygon, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(polygon, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(polygon, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(polygon, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(polygon, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(polygon, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(polygon, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(polygon, "drag", onDrag));
        setInstance(polygon);
        if (onLoad) onLoad(polygon);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (onUnmount) onUnmount(polygon);
            polygon.setMap(null);
        };
    }, []);
    return null;
}
var PolygonF = (0, _react.memo)(PolygonFunctional);
var Polygon = /** @class */ function(_super) {
    __extends(Polygon, _super);
    function Polygon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            polygon: null
        };
        _this.setPolygonCallback = function() {
            if (_this.state.polygon !== null && _this.props.onLoad) _this.props.onLoad(_this.state.polygon);
        };
        return _this;
    }
    Polygon.prototype.componentDidMount = function() {
        var polygon = new google.maps.Polygon(__assign(__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$a,
            eventMap: eventMap$a,
            prevProps: {},
            nextProps: this.props,
            instance: polygon
        });
        this.setState(function setPolygon() {
            return {
                polygon: polygon
            };
        }, this.setPolygonCallback);
    };
    Polygon.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.polygon !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$a,
                eventMap: eventMap$a,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.polygon
            });
        }
    };
    Polygon.prototype.componentWillUnmount = function() {
        if (this.state.polygon !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.polygon);
            unregisterEvents(this.registeredEvents);
            this.state.polygon && this.state.polygon.setMap(null);
        }
    };
    Polygon.prototype.render = function() {
        return null;
    };
    Polygon.contextType = MapContext;
    return Polygon;
}((0, _react.PureComponent));
var eventMap$9 = {
    onBoundsChanged: "bounds_changed",
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var updaterMap$9 = {
    bounds: function(instance, bounds) {
        instance.setBounds(bounds);
    },
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
function RectangleFunctional(_a) {
    var options = _a.options, bounds = _a.bounds, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onBoundsChanged = _a.onBoundsChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, _react.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, _react.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, _react.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, _react.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, _react.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, _react.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, _react.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, _react.useState)(null), rightClickListener = _l[0], setRightClickListener = _l[1];
    var _m = (0, _react.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, _react.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    var _p = (0, _react.useState)(null), boundsChangedListener = _p[0], setBoundsChangedListener = _p[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, _react.useEffect)(function() {
        if (typeof bounds !== "undefined" && instance !== null) instance.setBounds(bounds);
    }, [
        instance,
        bounds
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightClickListener !== null) google.maps.event.removeListener(rightClickListener);
            setRightClickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onBoundsChanged) {
            if (boundsChangedListener !== null) google.maps.event.removeListener(boundsChangedListener);
            setBoundsChangedListener(google.maps.event.addListener(instance, "bounds_changed", onBoundsChanged));
        }
    }, [
        onBoundsChanged
    ]);
    (0, _react.useEffect)(function() {
        var rectangle = new google.maps.Rectangle(__assign(__assign({}, options || {}), {
            map: map
        }));
        if (typeof visible !== "undefined") rectangle.setVisible(visible);
        if (typeof editable !== "undefined") rectangle.setEditable(editable);
        if (typeof draggable !== "undefined") rectangle.setDraggable(draggable);
        if (typeof bounds !== "undefined") rectangle.setBounds(bounds);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(rectangle, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(rectangle, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(rectangle, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(rectangle, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(rectangle, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(rectangle, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(rectangle, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(rectangle, "mouseup", onMouseUp));
        if (onRightClick) setRightClickListener(google.maps.event.addListener(rectangle, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(rectangle, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(rectangle, "drag", onDrag));
        if (onBoundsChanged) setBoundsChangedListener(google.maps.event.addListener(rectangle, "bounds_changed", onBoundsChanged));
        setInstance(rectangle);
        if (onLoad) onLoad(rectangle);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightClickListener !== null) google.maps.event.removeListener(rightClickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            if (boundsChangedListener !== null) google.maps.event.removeListener(boundsChangedListener);
            if (onUnmount) onUnmount(rectangle);
            rectangle.setMap(null);
        };
    }, []);
    return null;
}
var RectangleF = (0, _react.memo)(RectangleFunctional);
var Rectangle = /** @class */ function(_super) {
    __extends(Rectangle, _super);
    function Rectangle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            rectangle: null
        };
        _this.setRectangleCallback = function() {
            if (_this.state.rectangle !== null && _this.props.onLoad) _this.props.onLoad(_this.state.rectangle);
        };
        return _this;
    }
    Rectangle.prototype.componentDidMount = function() {
        var rectangle = new google.maps.Rectangle(__assign(__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$9,
            eventMap: eventMap$9,
            prevProps: {},
            nextProps: this.props,
            instance: rectangle
        });
        this.setState(function setRectangle() {
            return {
                rectangle: rectangle
            };
        }, this.setRectangleCallback);
    };
    Rectangle.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.rectangle !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$9,
                eventMap: eventMap$9,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.rectangle
            });
        }
    };
    Rectangle.prototype.componentWillUnmount = function() {
        if (this.state.rectangle !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.rectangle);
            unregisterEvents(this.registeredEvents);
            this.state.rectangle.setMap(null);
        }
    };
    Rectangle.prototype.render = function() {
        return null;
    };
    Rectangle.contextType = MapContext;
    return Rectangle;
}((0, _react.PureComponent));
var eventMap$8 = {
    onCenterChanged: "center_changed",
    onRadiusChanged: "radius_changed",
    onClick: "click",
    onDblClick: "dblclick",
    onDrag: "drag",
    onDragEnd: "dragend",
    onDragStart: "dragstart",
    onMouseDown: "mousedown",
    onMouseMove: "mousemove",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick"
};
var updaterMap$8 = {
    center: function(instance, center) {
        instance.setCenter(center);
    },
    draggable: function(instance, draggable) {
        instance.setDraggable(draggable);
    },
    editable: function(instance, editable) {
        instance.setEditable(editable);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    radius: function(instance, radius) {
        instance.setRadius(radius);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    }
};
var defaultOptions = {};
function CircleFunctional(_a) {
    var options = _a.options, center = _a.center, radius = _a.radius, draggable = _a.draggable, editable = _a.editable, visible = _a.visible, onDblClick = _a.onDblClick, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onClick = _a.onClick, onDrag = _a.onDrag, onCenterChanged = _a.onCenterChanged, onRadiusChanged = _a.onRadiusChanged, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, _react.useState)(null), dragendListener = _d[0], setDragendListener = _d[1];
    var _e = (0, _react.useState)(null), dragstartListener = _e[0], setDragstartListener = _e[1];
    var _f = (0, _react.useState)(null), mousedownListener = _f[0], setMousedownListener = _f[1];
    var _g = (0, _react.useState)(null), mousemoveListener = _g[0], setMousemoveListener = _g[1];
    var _h = (0, _react.useState)(null), mouseoutListener = _h[0], setMouseoutListener = _h[1];
    var _j = (0, _react.useState)(null), mouseoverListener = _j[0], setMouseoverListener = _j[1];
    var _k = (0, _react.useState)(null), mouseupListener = _k[0], setMouseupListener = _k[1];
    var _l = (0, _react.useState)(null), rightclickListener = _l[0], setRightclickListener = _l[1];
    var _m = (0, _react.useState)(null), clickListener = _m[0], setClickListener = _m[1];
    var _o = (0, _react.useState)(null), dragListener = _o[0], setDragListener = _o[1];
    var _p = (0, _react.useState)(null), centerChangedListener = _p[0], setCenterChangedListener = _p[1];
    var _q = (0, _react.useState)(null), radiusChangedListener = _q[0], setRadiusChangedListener = _q[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (typeof options !== "undefined" && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        if (typeof draggable !== "undefined" && instance !== null) instance.setDraggable(draggable);
    }, [
        instance,
        draggable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof editable !== "undefined" && instance !== null) instance.setEditable(editable);
    }, [
        instance,
        editable
    ]);
    (0, _react.useEffect)(function() {
        if (typeof visible !== "undefined" && instance !== null) instance.setVisible(visible);
    }, [
        instance,
        visible
    ]);
    (0, _react.useEffect)(function() {
        if (typeof radius === "number" && instance !== null) instance.setRadius(radius);
    }, [
        instance,
        radius
    ]);
    (0, _react.useEffect)(function() {
        if (typeof center !== "undefined" && instance !== null) instance.setCenter(center);
    }, [
        instance,
        center
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragEnd) {
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            setDragendListener(google.maps.event.addListener(instance, "dragend", onDragEnd));
        }
    }, [
        onDragEnd
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDragStart) {
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            setDragstartListener(google.maps.event.addListener(instance, "dragstart", onDragStart));
        }
    }, [
        onDragStart
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDrag) {
            if (dragListener !== null) google.maps.event.removeListener(dragListener);
            setDragListener(google.maps.event.addListener(instance, "drag", onDrag));
        }
    }, [
        onDrag
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onCenterChanged) {
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            setCenterChangedListener(google.maps.event.addListener(instance, "center_changed", onCenterChanged));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRadiusChanged) {
            if (radiusChangedListener !== null) google.maps.event.removeListener(radiusChangedListener);
            setRadiusChangedListener(google.maps.event.addListener(instance, "radius_changed", onRadiusChanged));
        }
    }, [
        onRadiusChanged
    ]);
    (0, _react.useEffect)(function() {
        var circle = new google.maps.Circle(__assign(__assign({}, options || defaultOptions), {
            map: map
        }));
        if (typeof radius === "number") circle.setRadius(radius);
        if (typeof center !== "undefined") circle.setCenter(center);
        if (typeof radius === "number") circle.setRadius(radius);
        if (typeof visible !== "undefined") circle.setVisible(visible);
        if (typeof editable !== "undefined") circle.setEditable(editable);
        if (typeof draggable !== "undefined") circle.setDraggable(draggable);
        if (onDblClick) setDblclickListener(google.maps.event.addListener(circle, "dblclick", onDblClick));
        if (onDragEnd) setDragendListener(google.maps.event.addListener(circle, "dragend", onDragEnd));
        if (onDragStart) setDragstartListener(google.maps.event.addListener(circle, "dragstart", onDragStart));
        if (onMouseDown) setMousedownListener(google.maps.event.addListener(circle, "mousedown", onMouseDown));
        if (onMouseMove) setMousemoveListener(google.maps.event.addListener(circle, "mousemove", onMouseMove));
        if (onMouseOut) setMouseoutListener(google.maps.event.addListener(circle, "mouseout", onMouseOut));
        if (onMouseOver) setMouseoverListener(google.maps.event.addListener(circle, "mouseover", onMouseOver));
        if (onMouseUp) setMouseupListener(google.maps.event.addListener(circle, "mouseup", onMouseUp));
        if (onRightClick) setRightclickListener(google.maps.event.addListener(circle, "rightclick", onRightClick));
        if (onClick) setClickListener(google.maps.event.addListener(circle, "click", onClick));
        if (onDrag) setDragListener(google.maps.event.addListener(circle, "drag", onDrag));
        if (onCenterChanged) setCenterChangedListener(google.maps.event.addListener(circle, "center_changed", onCenterChanged));
        if (onRadiusChanged) setRadiusChangedListener(google.maps.event.addListener(circle, "radius_changed", onRadiusChanged));
        setInstance(circle);
        if (onLoad) onLoad(circle);
        return function() {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            if (dragendListener !== null) google.maps.event.removeListener(dragendListener);
            if (dragstartListener !== null) google.maps.event.removeListener(dragstartListener);
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            if (centerChangedListener !== null) google.maps.event.removeListener(centerChangedListener);
            if (radiusChangedListener !== null) google.maps.event.removeListener(radiusChangedListener);
            if (onUnmount) onUnmount(circle);
            circle.setMap(null);
        };
    }, []);
    return null;
}
var CircleF = (0, _react.memo)(CircleFunctional);
var Circle = /** @class */ function(_super) {
    __extends(Circle, _super);
    function Circle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            circle: null
        };
        _this.setCircleCallback = function() {
            if (_this.state.circle !== null && _this.props.onLoad) _this.props.onLoad(_this.state.circle);
        };
        return _this;
    }
    Circle.prototype.componentDidMount = function() {
        var circle = new google.maps.Circle(__assign(__assign({}, this.props.options || {}), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$8,
            eventMap: eventMap$8,
            prevProps: {},
            nextProps: this.props,
            instance: circle
        });
        this.setState(function setCircle() {
            return {
                circle: circle
            };
        }, this.setCircleCallback);
    };
    Circle.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.circle !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$8,
                eventMap: eventMap$8,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.circle
            });
        }
    };
    Circle.prototype.componentWillUnmount = function() {
        var _a;
        if (this.state.circle !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.circle);
            unregisterEvents(this.registeredEvents);
            (_a = this.state.circle) === null || _a === void 0 || _a.setMap(null);
        }
    };
    Circle.prototype.render = function() {
        return null;
    };
    Circle.contextType = MapContext;
    return Circle;
}((0, _react.PureComponent));
var eventMap$7 = {
    onClick: "click",
    onDblClick: "dblclick",
    onMouseDown: "mousedown",
    onMouseOut: "mouseout",
    onMouseOver: "mouseover",
    onMouseUp: "mouseup",
    onRightClick: "rightclick",
    onAddFeature: "addfeature",
    onRemoveFeature: "removefeature",
    onRemoveProperty: "removeproperty",
    onSetGeometry: "setgeometry",
    onSetProperty: "setproperty"
};
var updaterMap$7 = {
    add: function(instance, feature) {
        instance.add(feature);
    },
    addgeojson: function(instance, geojson, options) {
        instance.addGeoJson(geojson, options);
    },
    contains: function(instance, feature) {
        instance.contains(feature);
    },
    foreach: function(instance, callback) {
        instance.forEach(callback);
    },
    loadgeojson: function(instance, url, options, callback) {
        instance.loadGeoJson(url, options, callback);
    },
    overridestyle: function(instance, feature, style) {
        instance.overrideStyle(feature, style);
    },
    remove: function(instance, feature) {
        instance.remove(feature);
    },
    revertstyle: function(instance, feature) {
        instance.revertStyle(feature);
    },
    controlposition: function(instance, controlPosition) {
        instance.setControlPosition(controlPosition);
    },
    controls: function(instance, controls) {
        instance.setControls(controls);
    },
    drawingmode: function(instance, mode) {
        instance.setDrawingMode(mode);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    style: function(instance, style) {
        instance.setStyle(style);
    },
    togeojson: function(instance, callback) {
        instance.toGeoJson(callback);
    }
};
function DataFunctional(_a) {
    var options = _a.options, onClick = _a.onClick, onDblClick = _a.onDblClick, onMouseDown = _a.onMouseDown, onMouseMove = _a.onMouseMove, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onRightClick = _a.onRightClick, onAddFeature = _a.onAddFeature, onRemoveFeature = _a.onRemoveFeature, onRemoveProperty = _a.onRemoveProperty, onSetGeometry = _a.onSetGeometry, onSetProperty = _a.onSetProperty, onLoad = _a.onLoad, onUnmount = _a.onUnmount;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    var _c = (0, _react.useState)(null), dblclickListener = _c[0], setDblclickListener = _c[1];
    var _d = (0, _react.useState)(null), mousedownListener = _d[0], setMousedownListener = _d[1];
    var _e = (0, _react.useState)(null), mousemoveListener = _e[0], setMousemoveListener = _e[1];
    var _f = (0, _react.useState)(null), mouseoutListener = _f[0], setMouseoutListener = _f[1];
    var _g = (0, _react.useState)(null), mouseoverListener = _g[0], setMouseoverListener = _g[1];
    var _h = (0, _react.useState)(null), mouseupListener = _h[0], setMouseupListener = _h[1];
    var _j = (0, _react.useState)(null), rightclickListener = _j[0], setRightclickListener = _j[1];
    var _k = (0, _react.useState)(null), clickListener = _k[0], setClickListener = _k[1];
    var _l = (0, _react.useState)(null), addFeatureListener = _l[0], setAddFeatureListener = _l[1];
    var _m = (0, _react.useState)(null), removeFeatureListener = _m[0], setRemoveFeatureListener = _m[1];
    var _o = (0, _react.useState)(null), removePropertyListener = _o[0], setRemovePropertyListener = _o[1];
    var _p = (0, _react.useState)(null), setGeometryListener = _p[0], setSetGeometryListener = _p[1];
    var _q = (0, _react.useState)(null), setPropertyListener = _q[0], setSetPropertyListener = _q[1];
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onDblClick) {
            if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
            setDblclickListener(google.maps.event.addListener(instance, "dblclick", onDblClick));
        }
    }, [
        onDblClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseDown) {
            if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
            setMousedownListener(google.maps.event.addListener(instance, "mousedown", onMouseDown));
        }
    }, [
        onMouseDown
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseMove) {
            if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
            setMousemoveListener(google.maps.event.addListener(instance, "mousemove", onMouseMove));
        }
    }, [
        onMouseMove
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOut) {
            if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
            setMouseoutListener(google.maps.event.addListener(instance, "mouseout", onMouseOut));
        }
    }, [
        onMouseOut
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseOver) {
            if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
            setMouseoverListener(google.maps.event.addListener(instance, "mouseover", onMouseOver));
        }
    }, [
        onMouseOver
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onMouseUp) {
            if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
            setMouseupListener(google.maps.event.addListener(instance, "mouseup", onMouseUp));
        }
    }, [
        onMouseUp
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRightClick) {
            if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
            setRightclickListener(google.maps.event.addListener(instance, "rightclick", onRightClick));
        }
    }, [
        onRightClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onClick) {
            if (clickListener !== null) google.maps.event.removeListener(clickListener);
            setClickListener(google.maps.event.addListener(instance, "click", onClick));
        }
    }, [
        onClick
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onAddFeature) {
            if (addFeatureListener !== null) google.maps.event.removeListener(addFeatureListener);
            setAddFeatureListener(google.maps.event.addListener(instance, "addfeature", onAddFeature));
        }
    }, [
        onAddFeature
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRemoveFeature) {
            if (removeFeatureListener !== null) google.maps.event.removeListener(removeFeatureListener);
            setRemoveFeatureListener(google.maps.event.addListener(instance, "removefeature", onRemoveFeature));
        }
    }, [
        onRemoveFeature
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onRemoveProperty) {
            if (removePropertyListener !== null) google.maps.event.removeListener(removePropertyListener);
            setRemovePropertyListener(google.maps.event.addListener(instance, "removeproperty", onRemoveProperty));
        }
    }, [
        onRemoveProperty
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onSetGeometry) {
            if (setGeometryListener !== null) google.maps.event.removeListener(setGeometryListener);
            setSetGeometryListener(google.maps.event.addListener(instance, "setgeometry", onSetGeometry));
        }
    }, [
        onSetGeometry
    ]);
    (0, _react.useEffect)(function() {
        if (instance && onSetProperty) {
            if (setPropertyListener !== null) google.maps.event.removeListener(setPropertyListener);
            setSetPropertyListener(google.maps.event.addListener(instance, "setproperty", onSetProperty));
        }
    }, [
        onSetProperty
    ]);
    (0, _react.useEffect)(function() {
        if (map !== null) {
            var data = new google.maps.Data(__assign(__assign({}, options || {}), {
                map: map
            }));
            if (onDblClick) setDblclickListener(google.maps.event.addListener(data, "dblclick", onDblClick));
            if (onMouseDown) setMousedownListener(google.maps.event.addListener(data, "mousedown", onMouseDown));
            if (onMouseMove) setMousemoveListener(google.maps.event.addListener(data, "mousemove", onMouseMove));
            if (onMouseOut) setMouseoutListener(google.maps.event.addListener(data, "mouseout", onMouseOut));
            if (onMouseOver) setMouseoverListener(google.maps.event.addListener(data, "mouseover", onMouseOver));
            if (onMouseUp) setMouseupListener(google.maps.event.addListener(data, "mouseup", onMouseUp));
            if (onRightClick) setRightclickListener(google.maps.event.addListener(data, "rightclick", onRightClick));
            if (onClick) setClickListener(google.maps.event.addListener(data, "click", onClick));
            if (onAddFeature) setAddFeatureListener(google.maps.event.addListener(data, "addfeature", onAddFeature));
            if (onRemoveFeature) setRemoveFeatureListener(google.maps.event.addListener(data, "removefeature", onRemoveFeature));
            if (onRemoveProperty) setRemovePropertyListener(google.maps.event.addListener(data, "removeproperty", onRemoveProperty));
            if (onSetGeometry) setSetGeometryListener(google.maps.event.addListener(data, "setgeometry", onSetGeometry));
            if (onSetProperty) setSetPropertyListener(google.maps.event.addListener(data, "setproperty", onSetProperty));
            setInstance(data);
            if (onLoad) onLoad(data);
        }
        return function() {
            if (instance) {
                if (dblclickListener !== null) google.maps.event.removeListener(dblclickListener);
                if (mousedownListener !== null) google.maps.event.removeListener(mousedownListener);
                if (mousemoveListener !== null) google.maps.event.removeListener(mousemoveListener);
                if (mouseoutListener !== null) google.maps.event.removeListener(mouseoutListener);
                if (mouseoverListener !== null) google.maps.event.removeListener(mouseoverListener);
                if (mouseupListener !== null) google.maps.event.removeListener(mouseupListener);
                if (rightclickListener !== null) google.maps.event.removeListener(rightclickListener);
                if (clickListener !== null) google.maps.event.removeListener(clickListener);
                if (addFeatureListener !== null) google.maps.event.removeListener(addFeatureListener);
                if (removeFeatureListener !== null) google.maps.event.removeListener(removeFeatureListener);
                if (removePropertyListener !== null) google.maps.event.removeListener(removePropertyListener);
                if (setGeometryListener !== null) google.maps.event.removeListener(setGeometryListener);
                if (setPropertyListener !== null) google.maps.event.removeListener(setPropertyListener);
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var DataF = (0, _react.memo)(DataFunctional);
var Data = /** @class */ function(_super) {
    __extends(Data, _super);
    function Data() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            data: null
        };
        _this.setDataCallback = function() {
            if (_this.state.data !== null && _this.props.onLoad) _this.props.onLoad(_this.state.data);
        };
        return _this;
    }
    Data.prototype.componentDidMount = function() {
        if (this.context !== null) {
            var data_1 = new google.maps.Data(__assign(__assign({}, this.props.options || {}), {
                map: this.context
            }));
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$7,
                eventMap: eventMap$7,
                prevProps: {},
                nextProps: this.props,
                instance: data_1
            });
            this.setState(function() {
                return {
                    data: data_1
                };
            }, this.setDataCallback);
        }
    };
    Data.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.data !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$7,
                eventMap: eventMap$7,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.data
            });
        }
    };
    Data.prototype.componentWillUnmount = function() {
        if (this.state.data !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.data);
            unregisterEvents(this.registeredEvents);
            if (this.state.data) this.state.data.setMap(null);
        }
    };
    Data.prototype.render = function() {
        return null;
    };
    Data.contextType = MapContext;
    return Data;
}((0, _react.PureComponent));
var eventMap$6 = {
    onClick: "click",
    onDefaultViewportChanged: "defaultviewport_changed",
    onStatusChanged: "status_changed"
};
var updaterMap$6 = {
    options: function(instance, options) {
        instance.setOptions(options);
    },
    url: function(instance, url) {
        instance.setUrl(url);
    },
    zIndex: function(instance, zIndex) {
        instance.setZIndex(zIndex);
    }
};
var KmlLayer = /** @class */ function(_super) {
    __extends(KmlLayer, _super);
    function KmlLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            kmlLayer: null
        };
        _this.setKmlLayerCallback = function() {
            if (_this.state.kmlLayer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.kmlLayer);
        };
        return _this;
    }
    KmlLayer.prototype.componentDidMount = function() {
        var kmlLayer = new google.maps.KmlLayer(__assign(__assign({}, this.props.options), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$6,
            eventMap: eventMap$6,
            prevProps: {},
            nextProps: this.props,
            instance: kmlLayer
        });
        this.setState(function setLmlLayer() {
            return {
                kmlLayer: kmlLayer
            };
        }, this.setKmlLayerCallback);
    };
    KmlLayer.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.kmlLayer !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$6,
                eventMap: eventMap$6,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.kmlLayer
            });
        }
    };
    KmlLayer.prototype.componentWillUnmount = function() {
        if (this.state.kmlLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.kmlLayer);
            unregisterEvents(this.registeredEvents);
            this.state.kmlLayer.setMap(null);
        }
    };
    KmlLayer.prototype.render = function() {
        return null;
    };
    KmlLayer.contextType = MapContext;
    return KmlLayer;
}((0, _react.PureComponent));
function getOffsetOverride(containerElement, getPixelPositionOffset) {
    return typeof getPixelPositionOffset === "function" ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {
        x: 0,
        y: 0
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLng(inst, Type) {
    return new Type(inst.lat, inst.lng);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLngBounds(inst, Type) {
    return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ensureOfType(inst, // eslint-disable-next-line @typescript-eslint/no-explicit-any
type, // eslint-disable-next-line @typescript-eslint/no-explicit-any
factory) {
    return inst instanceof type ? inst : factory(inst, type);
}
function ensureOfTypeBounds(inst, // eslint-disable-next-line @typescript-eslint/no-explicit-any
type, // eslint-disable-next-line @typescript-eslint/no-explicit-any
factory) {
    return inst instanceof type ? inst : factory(inst, type);
}
function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
    var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
    var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
    if (ne && sw) return {
        left: "".concat(sw.x + offset.x, "px"),
        top: "".concat(ne.y + offset.y, "px"),
        width: "".concat(ne.x - sw.x - offset.x, "px"),
        height: "".concat(sw.y - ne.y - offset.y, "px")
    };
    return {
        left: "-9999px",
        top: "-9999px"
    };
}
function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
    var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);
    if (point) {
        var x = point.x, y = point.y;
        return {
            left: "".concat(x + offset.x, "px"),
            top: "".concat(y + offset.y, "px")
        };
    }
    return {
        left: "-9999px",
        top: "-9999px"
    };
}
function getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
    return bounds !== undefined ? getLayoutStylesByBounds(mapCanvasProjection, offset, ensureOfTypeBounds(bounds, google.maps.LatLngBounds, createLatLngBounds)) : getLayoutStylesByPosition(mapCanvasProjection, offset, ensureOfType(position, google.maps.LatLng, createLatLng));
}
function arePositionsEqual(currentPosition, previousPosition) {
    return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}
function createOverlay(container, pane, position, bounds, getPixelPositionOffset) {
    var Overlay = /** @class */ function(_super) {
        __extends(Overlay, _super);
        function Overlay(container, pane, position, bounds) {
            var _this = _super.call(this) || this;
            _this.container = container;
            _this.pane = pane;
            _this.position = position;
            _this.bounds = bounds;
            return _this;
        }
        Overlay.prototype.onAdd = function() {
            var _a;
            var pane = (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a[this.pane];
            pane === null || pane === void 0 || pane.appendChild(this.container);
        };
        Overlay.prototype.draw = function() {
            var projection = this.getProjection();
            var offset = __assign({}, this.container ? getOffsetOverride(this.container, getPixelPositionOffset) : {
                x: 0,
                y: 0
            });
            var layoutStyles = getLayoutStyles(projection, offset, this.bounds, this.position);
            for(var _i = 0, _a = Object.entries(layoutStyles); _i < _a.length; _i++){
                var _b = _a[_i], key = _b[0], value = _b[1];
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.container.style[key] = value;
            }
        };
        Overlay.prototype.onRemove = function() {
            if (this.container.parentNode !== null) this.container.parentNode.removeChild(this.container);
        };
        return Overlay;
    }(google.maps.OverlayView);
    return new Overlay(container, pane, position, bounds);
}
function convertToLatLngString(latLngLike) {
    if (!latLngLike) return "";
    var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
    return latLng + "";
}
function convertToLatLngBoundsString(latLngBoundsLike) {
    if (!latLngBoundsLike) return "";
    var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
    return latLngBounds + "";
}
var FLOAT_PANE = "floatPane";
var MAP_PANE = "mapPane";
var MARKER_LAYER = "markerLayer";
var OVERLAY_LAYER = "overlayLayer";
var OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
function OverlayViewFunctional(_a) {
    var position = _a.position, bounds = _a.bounds, mapPaneName = _a.mapPaneName, zIndex = _a.zIndex, onLoad = _a.onLoad, onUnmount = _a.onUnmount, getPixelPositionOffset = _a.getPixelPositionOffset, children = _a.children;
    var map = (0, _react.useContext)(MapContext);
    var container = (0, _react.useMemo)(function() {
        var div = document.createElement("div");
        div.style.position = "absolute";
        return div;
    }, []);
    var overlay = (0, _react.useMemo)(function() {
        return createOverlay(container, mapPaneName, position, bounds, getPixelPositionOffset);
    }, [
        container,
        mapPaneName,
        position,
        bounds
    ]);
    (0, _react.useEffect)(function() {
        onLoad === null || onLoad === void 0 || onLoad(overlay);
        overlay === null || overlay === void 0 || overlay.setMap(map);
        return function() {
            onUnmount === null || onUnmount === void 0 || onUnmount(overlay);
            overlay === null || overlay === void 0 || overlay.setMap(null);
        };
    }, [
        map,
        overlay
    ]);
    // to move the container to the foreground and background
    (0, _react.useEffect)(function() {
        container.style.zIndex = "".concat(zIndex);
    }, [
        zIndex,
        container
    ]);
    return _reactDom.createPortal(children, container);
}
var OverlayViewF = (0, _react.memo)(OverlayViewFunctional);
var OverlayView = /** @class */ function(_super) {
    __extends(OverlayView, _super);
    function OverlayView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            paneEl: null,
            containerStyle: {
                // set initial position
                position: "absolute"
            }
        };
        _this.updatePane = function() {
            var mapPaneName = _this.props.mapPaneName;
            // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
            var mapPanes = _this.overlayView.getPanes();
            invariant$1(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);
            if (mapPanes) _this.setState({
                paneEl: mapPanes[mapPaneName]
            });
            else _this.setState({
                paneEl: null
            });
        };
        _this.onAdd = function() {
            var _a, _b;
            _this.updatePane();
            (_b = (_a = _this.props).onLoad) === null || _b === void 0 || _b.call(_a, _this.overlayView);
        };
        _this.onPositionElement = function() {
            var _a;
            var mapCanvasProjection = _this.overlayView.getProjection();
            var offset = __assign({
                x: 0,
                y: 0
            }, _this.containerRef.current ? getOffsetOverride(_this.containerRef.current, _this.props.getPixelPositionOffset) : {});
            var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, _this.props.bounds, _this.props.position);
            var left = (_a = _this.state.containerStyle, _a.left), top = _a.top, width = _a.width, height = _a.height;
            if (!arePositionsEqual(layoutStyles, {
                left: left,
                top: top,
                width: width,
                height: height
            })) _this.setState({
                containerStyle: {
                    top: layoutStyles.top || 0,
                    left: layoutStyles.left || 0,
                    width: layoutStyles.width || 0,
                    height: layoutStyles.height || 0,
                    position: "absolute"
                }
            });
        };
        _this.draw = function() {
            _this.onPositionElement();
        };
        _this.onRemove = function() {
            var _a, _b;
            _this.setState(function() {
                return {
                    paneEl: null
                };
            });
            (_b = (_a = _this.props).onUnmount) === null || _b === void 0 || _b.call(_a, _this.overlayView);
        };
        _this.containerRef = (0, _react.createRef)();
        // You must implement three methods: onAdd(), draw(), and onRemove().
        var overlayView = new google.maps.OverlayView();
        overlayView.onAdd = _this.onAdd;
        overlayView.draw = _this.draw;
        overlayView.onRemove = _this.onRemove;
        _this.overlayView = overlayView;
        return _this;
    }
    OverlayView.prototype.componentDidMount = function() {
        this.overlayView.setMap(this.context);
    };
    OverlayView.prototype.componentDidUpdate = function(prevProps) {
        var prevPositionString = convertToLatLngString(prevProps.position);
        var positionString = convertToLatLngString(this.props.position);
        var prevBoundsString = convertToLatLngBoundsString(prevProps.bounds);
        var boundsString = convertToLatLngBoundsString(this.props.bounds);
        if (prevPositionString !== positionString || prevBoundsString !== boundsString) this.overlayView.draw();
        if (prevProps.mapPaneName !== this.props.mapPaneName) this.updatePane();
    };
    OverlayView.prototype.componentWillUnmount = function() {
        this.overlayView.setMap(null);
    };
    OverlayView.prototype.render = function() {
        var paneEl = this.state.paneEl;
        if (paneEl) return _reactDom.createPortal((0, _jsxRuntime.jsx)("div", {
            ref: this.containerRef,
            style: this.state.containerStyle,
            children: (0, _react.Children).only(this.props.children)
        }), paneEl);
        else return null;
    };
    OverlayView.FLOAT_PANE = "floatPane";
    OverlayView.MAP_PANE = "mapPane";
    OverlayView.MARKER_LAYER = "markerLayer";
    OverlayView.OVERLAY_LAYER = "overlayLayer";
    OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
    OverlayView.contextType = MapContext;
    return OverlayView;
}((0, _react.PureComponent));
function noop() {
    return;
}
var eventMap$5 = {
    onDblClick: "dblclick",
    onClick: "click"
};
var updaterMap$5 = {
    opacity: function(instance, opacity) {
        instance.setOpacity(opacity);
    }
};
function GroundOverlayFunctional(_a) {
    var url = _a.url, bounds = _a.bounds, options = _a.options, visible = _a.visible;
    var map = (0, _react.useContext)(MapContext);
    var imageBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
    var groundOverlay = (0, _react.useMemo)(function() {
        var overlay = new google.maps.GroundOverlay(url, imageBounds, __assign({}, options));
        return overlay;
    }, []);
    (0, _react.useEffect)(function() {
        if (groundOverlay !== null) groundOverlay.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (typeof url !== "undefined" && groundOverlay !== null) {
            groundOverlay.set("url", url);
            groundOverlay.setMap(map);
        }
    }, [
        groundOverlay,
        url
    ]);
    (0, _react.useEffect)(function() {
        if (typeof visible !== "undefined" && groundOverlay !== null) groundOverlay.setOpacity(visible ? 1 : 0);
    }, [
        groundOverlay,
        visible
    ]);
    (0, _react.useEffect)(function() {
        var newBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
        if (typeof bounds !== "undefined" && groundOverlay !== null) {
            groundOverlay.set("bounds", newBounds);
            groundOverlay.setMap(map);
        }
    }, [
        groundOverlay,
        bounds
    ]);
    return null;
}
var GroundOverlayF = (0, _react.memo)(GroundOverlayFunctional);
var GroundOverlay = /** @class */ function(_super) {
    __extends(GroundOverlay, _super);
    function GroundOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            groundOverlay: null
        };
        _this.setGroundOverlayCallback = function() {
            if (_this.state.groundOverlay !== null && _this.props.onLoad) _this.props.onLoad(_this.state.groundOverlay);
        };
        return _this;
    }
    GroundOverlay.prototype.componentDidMount = function() {
        invariant$1(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
        var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, __assign(__assign({}, this.props.options), {
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$5,
            eventMap: eventMap$5,
            prevProps: {},
            nextProps: this.props,
            instance: groundOverlay
        });
        this.setState(function setGroundOverlay() {
            return {
                groundOverlay: groundOverlay
            };
        }, this.setGroundOverlayCallback);
    };
    GroundOverlay.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.groundOverlay !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$5,
                eventMap: eventMap$5,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.groundOverlay
            });
        }
    };
    GroundOverlay.prototype.componentWillUnmount = function() {
        if (this.state.groundOverlay) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.groundOverlay);
            this.state.groundOverlay.setMap(null);
        }
    };
    GroundOverlay.prototype.render = function() {
        return null;
    };
    GroundOverlay.defaultProps = {
        onLoad: noop
    };
    GroundOverlay.contextType = MapContext;
    return GroundOverlay;
}((0, _react.PureComponent));
var eventMap$4 = {};
var updaterMap$4 = {
    data: function(instance, data) {
        instance.setData(data);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    }
};
function HeatmapLayerFunctional(_a) {
    var data = _a.data, onLoad = _a.onLoad, onUnmount = _a.onUnmount, options = _a.options;
    var map = (0, _react.useContext)(MapContext);
    var _b = (0, _react.useState)(null), instance = _b[0], setInstance = _b[1];
    (0, _react.useEffect)(function() {
        if (!google.maps.visualization) invariant$1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} in useJsApiScript? %s', google.maps.visualization);
    }, []);
    (0, _react.useEffect)(function() {
        invariant$1(!!data, "data property is required in HeatmapLayer %s", data);
    }, [
        data
    ]);
    // Order does matter
    (0, _react.useEffect)(function() {
        if (instance !== null) instance.setMap(map);
    }, [
        map
    ]);
    (0, _react.useEffect)(function() {
        if (options && instance !== null) instance.setOptions(options);
    }, [
        instance,
        options
    ]);
    (0, _react.useEffect)(function() {
        var heatmapLayer = new google.maps.visualization.HeatmapLayer(__assign(__assign({}, options || {}), {
            data: data,
            map: map
        }));
        setInstance(heatmapLayer);
        if (onLoad) onLoad(heatmapLayer);
        return function() {
            if (instance !== null) {
                if (onUnmount) onUnmount(instance);
                instance.setMap(null);
            }
        };
    }, []);
    return null;
}
var HeatmapLayerF = (0, _react.memo)(HeatmapLayerFunctional);
var HeatmapLayer = /** @class */ function(_super) {
    __extends(HeatmapLayer, _super);
    function HeatmapLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            heatmapLayer: null
        };
        _this.setHeatmapLayerCallback = function() {
            if (_this.state.heatmapLayer !== null && _this.props.onLoad) _this.props.onLoad(_this.state.heatmapLayer);
        };
        return _this;
    }
    HeatmapLayer.prototype.componentDidMount = function() {
        invariant$1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
        invariant$1(!!this.props.data, "data property is required in HeatmapLayer %s", this.props.data);
        var heatmapLayer = new google.maps.visualization.HeatmapLayer(__assign(__assign({}, this.props.options || {}), {
            data: this.props.data,
            map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$4,
            eventMap: eventMap$4,
            prevProps: {},
            nextProps: this.props,
            instance: heatmapLayer
        });
        this.setState(function setHeatmapLayer() {
            return {
                heatmapLayer: heatmapLayer
            };
        }, this.setHeatmapLayerCallback);
    };
    HeatmapLayer.prototype.componentDidUpdate = function(prevProps) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$4,
            eventMap: eventMap$4,
            prevProps: prevProps,
            nextProps: this.props,
            instance: this.state.heatmapLayer
        });
    };
    HeatmapLayer.prototype.componentWillUnmount = function() {
        if (this.state.heatmapLayer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.heatmapLayer);
            unregisterEvents(this.registeredEvents);
            this.state.heatmapLayer.setMap(null);
        }
    };
    HeatmapLayer.prototype.render = function() {
        return null;
    };
    HeatmapLayer.contextType = MapContext;
    return HeatmapLayer;
}((0, _react.PureComponent));
var eventMap$3 = {
    onCloseClick: "closeclick",
    onPanoChanged: "pano_changed",
    onPositionChanged: "position_changed",
    onPovChanged: "pov_changed",
    onResize: "resize",
    onStatusChanged: "status_changed",
    onVisibleChanged: "visible_changed",
    onZoomChanged: "zoom_changed"
};
var updaterMap$3 = {
    register: function(instance, provider, options) {
        instance.registerPanoProvider(provider, options);
    },
    links: function(instance, links) {
        instance.setLinks(links);
    },
    motionTracking: function(instance, motionTracking) {
        instance.setMotionTracking(motionTracking);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    pano: function(instance, pano) {
        instance.setPano(pano);
    },
    position: function(instance, position) {
        instance.setPosition(position);
    },
    pov: function(instance, pov) {
        instance.setPov(pov);
    },
    visible: function(instance, visible) {
        instance.setVisible(visible);
    },
    zoom: function(instance, zoom) {
        instance.setZoom(zoom);
    }
};
var StreetViewPanorama = /** @class */ function(_super) {
    __extends(StreetViewPanorama, _super);
    function StreetViewPanorama() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            streetViewPanorama: null
        };
        _this.setStreetViewPanoramaCallback = function() {
            if (_this.state.streetViewPanorama !== null && _this.props.onLoad) _this.props.onLoad(_this.state.streetViewPanorama);
        };
        return _this;
    }
    StreetViewPanorama.prototype.componentDidMount = function() {
        var _a, _b;
        var streetViewPanorama = (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.getStreetView()) !== null && _b !== void 0 ? _b : null;
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$3,
            eventMap: eventMap$3,
            prevProps: {},
            nextProps: this.props,
            instance: streetViewPanorama
        });
        this.setState(function() {
            return {
                streetViewPanorama: streetViewPanorama
            };
        }, this.setStreetViewPanoramaCallback);
    };
    StreetViewPanorama.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.streetViewPanorama !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$3,
                eventMap: eventMap$3,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.streetViewPanorama
            });
        }
    };
    StreetViewPanorama.prototype.componentWillUnmount = function() {
        if (this.state.streetViewPanorama !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.streetViewPanorama);
            unregisterEvents(this.registeredEvents);
            this.state.streetViewPanorama.setVisible(false);
        }
    };
    StreetViewPanorama.prototype.render = function() {
        return null;
    };
    StreetViewPanorama.contextType = MapContext;
    return StreetViewPanorama;
}((0, _react.PureComponent));
var StreetViewService = /** @class */ function(_super) {
    __extends(StreetViewService, _super);
    function StreetViewService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            streetViewService: null
        };
        _this.setStreetViewServiceCallback = function() {
            if (_this.state.streetViewService !== null && _this.props.onLoad) _this.props.onLoad(_this.state.streetViewService);
        };
        return _this;
    }
    StreetViewService.prototype.componentDidMount = function() {
        var streetViewService = new google.maps.StreetViewService();
        this.setState(function setStreetViewService() {
            return {
                streetViewService: streetViewService
            };
        }, this.setStreetViewServiceCallback);
    };
    StreetViewService.prototype.componentWillUnmount = function() {
        if (this.state.streetViewService !== null && this.props.onUnmount) this.props.onUnmount(this.state.streetViewService);
    };
    StreetViewService.prototype.render = function() {
        return null;
    };
    StreetViewService.contextType = MapContext;
    return StreetViewService;
}((0, _react.PureComponent));
var DirectionsService = /** @class */ function(_super) {
    __extends(DirectionsService, _super);
    function DirectionsService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            directionsService: null
        };
        _this.setDirectionsServiceCallback = function() {
            if (_this.state.directionsService !== null && _this.props.onLoad) _this.props.onLoad(_this.state.directionsService);
        };
        return _this;
    }
    DirectionsService.prototype.componentDidMount = function() {
        invariant$1(!!this.props.options, "DirectionsService expected options object as parameter, but got %s", this.props.options);
        var directionsService = new google.maps.DirectionsService();
        this.setState(function setDirectionsService() {
            return {
                directionsService: directionsService
            };
        }, this.setDirectionsServiceCallback);
    };
    DirectionsService.prototype.componentDidUpdate = function() {
        if (this.state.directionsService !== null) this.state.directionsService.route(this.props.options, this.props.callback);
    };
    DirectionsService.prototype.componentWillUnmount = function() {
        if (this.state.directionsService !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.directionsService);
        }
    };
    DirectionsService.prototype.render = function() {
        return null;
    };
    return DirectionsService;
}((0, _react.PureComponent));
var eventMap$2 = {
    onDirectionsChanged: "directions_changed"
};
var updaterMap$2 = {
    directions: function(instance, directions) {
        instance.setDirections(directions);
    },
    map: function(instance, map) {
        instance.setMap(map);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    panel: function(instance, panel) {
        instance.setPanel(panel);
    },
    routeIndex: function(instance, routeIndex) {
        instance.setRouteIndex(routeIndex);
    }
};
var DirectionsRenderer = /** @class */ function(_super) {
    __extends(DirectionsRenderer, _super);
    function DirectionsRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.state = {
            directionsRenderer: null
        };
        _this.setDirectionsRendererCallback = function() {
            if (_this.state.directionsRenderer !== null) {
                _this.state.directionsRenderer.setMap(_this.context);
                if (_this.props.onLoad) _this.props.onLoad(_this.state.directionsRenderer);
            }
        };
        return _this;
    }
    DirectionsRenderer.prototype.componentDidMount = function() {
        var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$2,
            eventMap: eventMap$2,
            prevProps: {},
            nextProps: this.props,
            instance: directionsRenderer
        });
        this.setState(function setDirectionsRenderer() {
            return {
                directionsRenderer: directionsRenderer
            };
        }, this.setDirectionsRendererCallback);
    };
    DirectionsRenderer.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.directionsRenderer !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$2,
                eventMap: eventMap$2,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.directionsRenderer
            });
        }
    };
    DirectionsRenderer.prototype.componentWillUnmount = function() {
        if (this.state.directionsRenderer !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.directionsRenderer);
            unregisterEvents(this.registeredEvents);
            if (this.state.directionsRenderer) this.state.directionsRenderer.setMap(null);
        }
    };
    DirectionsRenderer.prototype.render = function() {
        return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    };
    DirectionsRenderer.contextType = MapContext;
    return DirectionsRenderer;
}((0, _react.PureComponent));
var DistanceMatrixService = /** @class */ function(_super) {
    __extends(DistanceMatrixService, _super);
    function DistanceMatrixService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            distanceMatrixService: null
        };
        _this.setDistanceMatrixServiceCallback = function() {
            if (_this.state.distanceMatrixService !== null && _this.props.onLoad) _this.props.onLoad(_this.state.distanceMatrixService);
        };
        return _this;
    }
    DistanceMatrixService.prototype.componentDidMount = function() {
        invariant$1(!!this.props.options, "DistanceMatrixService expected options object as parameter, but go %s", this.props.options);
        var distanceMatrixService = new google.maps.DistanceMatrixService();
        this.setState(function setDistanceMatrixService() {
            return {
                distanceMatrixService: distanceMatrixService
            };
        }, this.setDistanceMatrixServiceCallback);
    };
    DistanceMatrixService.prototype.componentDidUpdate = function() {
        if (this.state.distanceMatrixService !== null) this.state.distanceMatrixService.getDistanceMatrix(this.props.options, this.props.callback);
    };
    DistanceMatrixService.prototype.componentWillUnmount = function() {
        if (this.state.distanceMatrixService !== null && this.props.onUnmount) this.props.onUnmount(this.state.distanceMatrixService);
    };
    DistanceMatrixService.prototype.render = function() {
        return null;
    };
    return DistanceMatrixService;
}((0, _react.PureComponent));
var eventMap$1 = {
    onPlacesChanged: "places_changed"
};
var updaterMap$1 = {
    bounds: function(instance, bounds) {
        instance.setBounds(bounds);
    }
};
var StandaloneSearchBox = /** @class */ function(_super) {
    __extends(StandaloneSearchBox, _super);
    function StandaloneSearchBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = (0, _react.createRef)();
        _this.state = {
            searchBox: null
        };
        _this.setSearchBoxCallback = function() {
            if (_this.state.searchBox !== null && _this.props.onLoad) _this.props.onLoad(_this.state.searchBox);
        };
        return _this;
    }
    StandaloneSearchBox.prototype.componentDidMount = function() {
        invariant$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
        if (this.containerElement !== null && this.containerElement.current !== null) {
            var input = this.containerElement.current.querySelector("input");
            if (input !== null) {
                var searchBox_1 = new google.maps.places.SearchBox(input, this.props.options);
                this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                    updaterMap: updaterMap$1,
                    eventMap: eventMap$1,
                    prevProps: {},
                    nextProps: this.props,
                    instance: searchBox_1
                });
                this.setState(function setSearchBox() {
                    return {
                        searchBox: searchBox_1
                    };
                }, this.setSearchBoxCallback);
            }
        }
    };
    StandaloneSearchBox.prototype.componentDidUpdate = function(prevProps) {
        if (this.state.searchBox !== null) {
            unregisterEvents(this.registeredEvents);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap$1,
                eventMap: eventMap$1,
                prevProps: prevProps,
                nextProps: this.props,
                instance: this.state.searchBox
            });
        }
    };
    StandaloneSearchBox.prototype.componentWillUnmount = function() {
        if (this.state.searchBox !== null) {
            if (this.props.onUnmount) this.props.onUnmount(this.state.searchBox);
            unregisterEvents(this.registeredEvents);
        }
    };
    StandaloneSearchBox.prototype.render = function() {
        return (0, _jsxRuntime.jsx)("div", {
            ref: this.containerElement,
            children: (0, _react.Children).only(this.props.children)
        });
    };
    StandaloneSearchBox.contextType = MapContext;
    return StandaloneSearchBox;
}((0, _react.PureComponent));
var eventMap = {
    onPlaceChanged: "place_changed"
};
var updaterMap = {
    bounds: function(instance, bounds) {
        instance.setBounds(bounds);
    },
    restrictions: function(instance, restrictions) {
        instance.setComponentRestrictions(restrictions);
    },
    fields: function(instance, fields) {
        instance.setFields(fields);
    },
    options: function(instance, options) {
        instance.setOptions(options);
    },
    types: function(instance, types) {
        instance.setTypes(types);
    }
};
var Autocomplete = /** @class */ function(_super) {
    __extends(Autocomplete, _super);
    function Autocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.registeredEvents = [];
        _this.containerElement = (0, _react.createRef)();
        _this.state = {
            autocomplete: null
        };
        _this.setAutocompleteCallback = function() {
            if (_this.state.autocomplete !== null && _this.props.onLoad) _this.props.onLoad(_this.state.autocomplete);
        };
        return _this;
    }
    Autocomplete.prototype.componentDidMount = function() {
        var _a;
        invariant$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
        // TODO: why current could be equal null?
        var input = (_a = this.containerElement.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
        if (input) {
            var autocomplete_1 = new google.maps.places.Autocomplete(input, this.props.options);
            this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
                updaterMap: updaterMap,
                eventMap: eventMap,
                prevProps: {},
                nextProps: this.props,
                instance: autocomplete_1
            });
            this.setState(function() {
                return {
                    autocomplete: autocomplete_1
                };
            }, this.setAutocompleteCallback);
        }
    };
    Autocomplete.prototype.componentDidUpdate = function(prevProps) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap,
            eventMap: eventMap,
            prevProps: prevProps,
            nextProps: this.props,
            instance: this.state.autocomplete
        });
    };
    Autocomplete.prototype.componentWillUnmount = function() {
        if (this.state.autocomplete !== null) unregisterEvents(this.registeredEvents);
    };
    Autocomplete.prototype.render = function() {
        return (0, _jsxRuntime.jsx)("div", {
            ref: this.containerElement,
            className: this.props.className,
            children: (0, _react.Children).only(this.props.children)
        });
    };
    Autocomplete.defaultProps = {
        className: ""
    };
    Autocomplete.contextType = MapContext;
    return Autocomplete;
}((0, _react.PureComponent));

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j1WJQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _authService = require("../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
class RequestBuilder {
    authProtocol = "https";
    authHost = "elevat-api-dev.elevat-iot.com";
    authPort = "443";
    accountProtocol = "https";
    accountHost = "elevat-api-dev.elevat-iot.com";
    accountPort = "443";
    dataProtocol = "https";
    dataHost = "elevat-api-dev.elevat-iot.com";
    dataPort = "443";
    gatewayProtocol = "https";
    gatewayHost = "elevat-api-dev.elevat-iot.com";
    gatewayPort = "443";
    j1939Protocol = "https";
    j1939Host = "elevat-api-dev.elevat-iot.com";
    j1939Port = "443";
    maintenanceProtocol = "https";
    maintenanceHost = "elevat-api-dev.elevat-iot.com";
    maintenancePort = "443";
    rulesProtocol = "https";
    rulesHost = "elevat-api-dev.elevat-iot.com";
    rulesPort = "443";
    utilizationProtocol = "https";
    utilizationHost = "elevat-api-dev.elevat-iot.com";
    utilizationPort = "443";
    auth = new (0, _authServiceDefault.default)();
    getURL(service, url) {
        const protocol = this[`${service}Protocol`];
        const host = this[`${service}Host`];
        const port = this[`${service}Port`];
        return `${protocol}://${host}:${port}${url}`;
    }
    createAxiosInstance(service, url, cancelToken) {
        return (0, _axiosDefault.default).create({
            baseURL: this.getURL(service, url),
            cancelToken
        });
    }
    getAuthHeader() {
        return {
            Authorization: this.auth.getToken()
        };
    }
    buildRequestConfig({ method, params, data }) {
        const config = {
            method,
            params,
            headers: this.getAuthHeader()
        };
        if ([
            "post",
            "put"
        ].includes(method)) config.data = data;
        return config;
    }
    createAdditionalRequestMap({ children, count, limit, order, orgID, search, sort, vendor }, paramsBuilder, cancelToken) {
        const additionalRequests = Math.ceil((count - limit) / limit);
        return new Array(additionalRequests).fill(1).map((x, i)=>{
            return this.request(paramsBuilder({
                children,
                includeAssetCount: false,
                order,
                orgID,
                page: i + 2,
                search,
                sort,
                vendor
            }, cancelToken));
        });
    }
    async request(requestParams) {
        const { service, endpoint, cancelToken } = requestParams;
        const instance = this.createAxiosInstance(service, endpoint, cancelToken);
        return instance.request(this.buildRequestConfig(requestParams));
    }
}
exports.default = RequestBuilder;

},{"axios":"ffpgq","../Services/AuthService":"8Bjjn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Bjjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
class AuthService {
    buildLoginRequest(data) {
        return {
            service: "auth",
            endpoint: "/login",
            method: "post",
            data
        };
    }
    buildTwoFactorRequest(data) {
        return {
            service: "auth",
            endpoint: "/login2fa",
            method: "post",
            data
        };
    }
    buildValidateRequest(cancelToken) {
        return {
            service: "auth",
            endpoint: "/validate",
            method: "get",
            cancelToken
        };
    }
    buildLogoutRequest() {
        return {
            endpoint: "/logout",
            method: "post",
            service: "auth"
        };
    }
    setToken(token) {
        (0, _jsCookieDefault.default).set("token", token, {
            expires: 1
        });
    }
    getToken() {
        return (0, _jsCookieDefault.default).get("token");
    }
    setUserRootOrgID(rootOrgID) {
        (0, _jsCookieDefault.default).set("rootOrgID", rootOrgID, {
            expires: 1
        });
    }
    getUserRootOrgID() {
        return (0, _jsCookieDefault.default).get("rootOrgID");
    }
    setCurrentOrgID(orgID) {
        (0, _jsCookieDefault.default).set("currentOrgID", orgID, {
            expires: 1
        });
    }
    getCurrentOrgID() {
        return (0, _jsCookieDefault.default).get("currentOrgID");
    }
    logout() {
        (0, _jsCookieDefault.default).remove("token");
        (0, _jsCookieDefault.default).remove("rootOrgID");
        (0, _jsCookieDefault.default).remove("currentOrgID");
        window.localStorage.clear();
    }
}
exports.default = AuthService;

},{"js-cookie":"f2dP7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f2dP7":[function(require,module,exports) {
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set,
            get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

},{}],"3PgTR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class AccountService {
    api = new (0, _requestsDefault.default)();
    buildCurrentAccountRequest(cancelToken) {
        return {
            service: "account",
            endpoint: "/account/current",
            method: "get",
            cancelToken
        };
    }
    async fetchCurrentUserDetails(cancelToken) {
        const { data = {} } = await this.api.request(this.buildCurrentAccountRequest(cancelToken));
        return data;
    }
    buildOrgUpdateRequest(orgID, data) {
        return {
            service: "account",
            endpoint: `/org/${orgID}`,
            method: "put",
            data
        };
    }
    updateOrgDetails = async (orgID, update)=>{
        const { data = {} } = await this.api.request(this.buildOrgUpdateRequest(orgID, update));
        return data;
    };
    buildNewUserRequest(orgID, params, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/org/${orgID}/user`,
            method: "post",
            params,
            service: "account"
        };
    }
    createNewUser = async (orgID, params, body, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildNewUserRequest(orgID, params, body, cancelToken));
        return data;
    };
    buildDeleteUserRequest(orgID, userID) {
        return {
            service: "account",
            endpoint: `/org/${orgID}/user/${userID}`,
            method: "delete"
        };
    }
    deleteUser = async (orgID, userID)=>{
        const { data = {} } = await this.api.request(this.buildDeleteUserRequest(orgID, userID));
        return data;
    };
    buildEditUserRequest({ orgID, userID, ...params }, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/org/${orgID}/user/${userID}`,
            method: "put",
            params,
            service: "account"
        };
    }
    editUser = async (params, body, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildEditUserRequest(params, body, cancelToken));
        return data;
    };
    buildResetPasswordRequest(orgID, userID, data) {
        return {
            service: "account",
            endpoint: `/org/${orgID}/user/${userID}/password`,
            method: "post",
            data
        };
    }
    resetPassword = async (orgID, userID, body)=>{
        const { data = {} } = await this.api.request(this.buildResetPasswordRequest(orgID, userID, body));
        return data;
    };
    buildFindUserRequest = (userID, cancelToken)=>{
        return {
            service: "account",
            endpoint: `/account/${userID}`,
            method: "get",
            cancelToken
        };
    };
    async findUser(userID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFindUserRequest(userID, cancelToken));
        return data;
    }
    buildUserSearchRequest(orgID, params, cancelToken) {
        return {
            service: "account",
            endpoint: `/org/${orgID}/users/search`,
            method: "get",
            params,
            cancelToken
        };
    }
    async searchUsers(orgID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUserSearchRequest(orgID, params, cancelToken));
        return data;
    }
    buildForgotPasswordRequest(data) {
        return {
            service: "account",
            endpoint: "/resetPassword",
            method: "post",
            data
        };
    }
    async forgotPassword(body) {
        const { data = {} } = await this.api.request(this.buildForgotPasswordRequest(body));
        return data;
    }
    buildFetchUserPermissionsRequest(orgID, userID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/org/${orgID}/user/${userID}/permissions`,
            method: "get",
            service: "account"
        };
    }
    async fetchUserPermissions(orgID, userID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchUserPermissionsRequest(orgID, userID, cancelToken));
        return data;
    }
    buildUpdateUserPermissionsRequest(orgID, userID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/org/${orgID}/user/${userID}/permissions`,
            method: "put",
            service: "account"
        };
    }
    async updateUserPermissions(orgID, userID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateUserPermissionsRequest(orgID, userID, body, cancelToken));
        return data;
    }
}
exports.default = AccountService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Alt2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class LocalStorageService {
    getCurrentOrgID() {
        const orgJSON = window.localStorage.getItem("currentOrg");
        if (!orgJSON) return "";
        const { _id = "" } = JSON.parse(orgJSON);
        return _id;
    }
    getObjectByKey(key) {
        const stringifiedItem = window?.localStorage?.getItem?.(key);
        if (!stringifiedItem) return;
        return JSON.parse(stringifiedItem);
    }
    setObject(key, obj) {
        window?.localStorage?.setItem?.(key, JSON.stringify(obj));
    }
}
exports.default = LocalStorageService;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lm5wc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uuid = require("uuid");
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
var _authService = require("./AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
class OrganizationService {
    api = new (0, _requestsDefault.default)();
    auth = new (0, _authServiceDefault.default)();
    buildFullOrgWithChildrenRequest(orgID, children, cancelToken) {
        return {
            service: "account",
            endpoint: `/org/${orgID}`,
            method: "get",
            params: {
                children
            },
            cancelToken
        };
    }
    fetchFullOrgDetails = async (orgID = this.auth.getCurrentOrgID(), children = false, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildFullOrgWithChildrenRequest(orgID, children, cancelToken));
        return data;
    };
    buildAllOrganizationUsersRequest(orgID, cancelToken) {
        return {
            service: "account",
            endpoint: `/org/${orgID}/users`,
            method: "get",
            cancelToken
        };
    }
    async fetchAllOrganizationUsers(orgID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAllOrganizationUsersRequest(orgID, cancelToken));
        return data;
    }
    buildCreateSubOrgRequest(data) {
        return {
            service: "account",
            endpoint: "/org",
            method: "post",
            data
        };
    }
    async createSubOrg(body) {
        const { data } = await this.api.request(this.buildCreateSubOrgRequest(body));
        return data;
    }
    buildDeleteOrgRequest(orgID, params, cancelToken) {
        return {
            service: "account",
            endpoint: `/org/${orgID}`,
            method: "delete",
            params,
            cancelToken
        };
    }
    deleteOrg(orgID, params, cancelToken) {
        return this.api.request(this.buildDeleteOrgRequest(orgID, params, cancelToken));
    }
    buildOrgSearchRequest(params, cancelToken) {
        return {
            service: "account",
            endpoint: "/org/search",
            method: "get",
            params,
            cancelToken
        };
    }
    async searchOrgs(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildOrgSearchRequest(params, cancelToken));
        return data;
    }
    buildRegenerateOrgSASRequest(orgID, cancelToken) {
        return {
            service: "account",
            endpoint: `/org/${orgID}/regenerateSas`,
            method: "put",
            data: {
                policyID: (0, _uuid.v4)()
            },
            cancelToken
        };
    }
    async regenerateOrgSAS(orgID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildRegenerateOrgSASRequest(orgID, cancelToken));
        return data;
    }
    buildMoveOrgRequest(orgID, data, cancelToken) {
        return {
            service: "account",
            endpoint: `/org/${orgID}/move`,
            method: "put",
            data,
            cancelToken
        };
    }
    async moveOrg(orgID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildMoveOrgRequest(orgID, params, cancelToken));
        return data;
    }
    buildAcceptOrgTermsRequest(orgID, userID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/org/${orgID}/user/${userID}/terms`,
            method: "put",
            service: "account"
        };
    }
    async acceptOrgTerms(orgID, userID, body, cancelToken) {
        const { data } = await this.api.request(this.buildAcceptOrgTermsRequest(orgID, userID, body, cancelToken));
        return data;
    }
}
exports.default = OrganizationService;

},{"uuid":"hIyym","../Lib/Requests":"j1WJQ","./AuthService":"8Bjjn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hIyym":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"h4z53","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":"eG5s0","./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4z53":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"agPy7","./rng.js":"fo5Bv","./stringify.js":"doA1n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agPy7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fo5Bv":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"doA1n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"eG5s0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eG5s0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"2jBiL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jBiL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e71Au":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
class ErrorBoundary extends (0, _react.Component) {
    state = {
        error: null,
        errorInfo: null
    };
    static propTypes = {
        children: (0, _propTypesDefault.default).node
    };
    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        });
    }
    render() {
        return this.state.errorInfo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "w-100 d-flex justify-content-center align-items-center p-5",
            children: "Something went wrong. Try to refresh this page. If the problem persists, please contact your administrator or us at support@elevat-iot.com."
        }) : this.props.children;
    }
}
exports.default = ErrorBoundary;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aIADA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LoadingCircle);
parcelHelpers.export(exports, "BrandPrimarySpinningCircle", ()=>BrandPrimarySpinningCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
LoadingCircle.propTypes = {
    size: (0, _propTypesDefault.default).string
};
LoadingCircle.defaultProps = {
    size: "lg"
};
function LoadingCircle({ size }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "position-absolute w-100 d-flex align-items-center justify-content-center",
        style: {
            top: "50%"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            color: "var(--brand-primary)",
            icon: (0, _freeSolidSvgIcons.faCircleNotch),
            size: size,
            spin: true
        })
    });
}
function BrandPrimarySpinningCircle({ size = "lg" }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        color: "var(--brand-primary)",
        icon: (0, _freeSolidSvgIcons.faCircleNotch),
        size: size,
        spin: true
    });
}
BrandPrimarySpinningCircle.propTypes = {
    size: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32SD5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FontAwesomeIcon", ()=>FontAwesomeIcon);
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        "fa-beat": beat,
        "fa-fade": fade,
        "fa-beat-fade": beatFade,
        "fa-bounce": bounce,
        "fa-shake": shake,
        "fa-flash": flash,
        "fa-spin": spin,
        "fa-spin-reverse": spinReverse,
        "fa-spin-pulse": spinPulse,
        "fa-pulse": pulse,
        "fa-fw": fixedWidth,
        "fa-inverse": inverse,
        "fa-border": border,
        "fa-li": listItem,
        "fa-flip": flip === true,
        "fa-flip-horizontal": flip === "horizontal" || flip === "both",
        "fa-flip-vertical": flip === "vertical" || flip === "both"
    }, _defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), _defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function camelize(string) {
    if (_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var _excluded = [
    "style"
];
function capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(":");
        var prop = camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith("webkit") ? acc[capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        return convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case "class":
                acc.attrs["className"] = val;
                delete element.attributes["class"];
                break;
            case "style":
                acc.attrs["style"] = styleToObject(val);
                break;
            default:
                if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = _objectWithoutProperties(extraProps, _excluded);
    mixins.attrs["style"] = _objectSpread2(_objectSpread2({}, mixins.attrs["style"]), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)
    ].concat(_toConsumableArray(children)));
}
var PRODUCTION = false;
try {
    PRODUCTION = false;
} catch (e) {}
function log() {
    if (!PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && _typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, _fontawesomeSvgCore.parse).icon) return (0, _fontawesomeSvgCore.parse).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && _typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}
var FontAwesomeIcon = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = normalizeIconArgs(iconArgs);
    var classes = objectWithKey("classes", [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(" "))));
    var transform = objectWithKey("transform", typeof props.transform === "string" ? (0, _fontawesomeSvgCore.parse).transform(props.transform) : props.transform);
    var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
    var renderedIcon = (0, _fontawesomeSvgCore.icon)(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        log("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
    beat: (0, _propTypesDefault.default).bool,
    border: (0, _propTypesDefault.default).bool,
    beatFade: (0, _propTypesDefault.default).bool,
    bounce: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    fade: (0, _propTypesDefault.default).bool,
    flash: (0, _propTypesDefault.default).bool,
    mask: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).string
    ]),
    maskId: (0, _propTypesDefault.default).string,
    fixedWidth: (0, _propTypesDefault.default).bool,
    inverse: (0, _propTypesDefault.default).bool,
    flip: (0, _propTypesDefault.default).oneOf([
        true,
        false,
        "horizontal",
        "vertical",
        "both"
    ]),
    icon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).string
    ]),
    listItem: (0, _propTypesDefault.default).bool,
    pull: (0, _propTypesDefault.default).oneOf([
        "right",
        "left"
    ]),
    pulse: (0, _propTypesDefault.default).bool,
    rotation: (0, _propTypesDefault.default).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, _propTypesDefault.default).bool,
    size: (0, _propTypesDefault.default).oneOf([
        "2xs",
        "xs",
        "sm",
        "lg",
        "xl",
        "2xl",
        "1x",
        "2x",
        "3x",
        "4x",
        "5x",
        "6x",
        "7x",
        "8x",
        "9x",
        "10x"
    ]),
    spin: (0, _propTypesDefault.default).bool,
    spinPulse: (0, _propTypesDefault.default).bool,
    spinReverse: (0, _propTypesDefault.default).bool,
    symbol: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    title: (0, _propTypesDefault.default).string,
    titleId: (0, _propTypesDefault.default).string,
    transform: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    swapOpacity: (0, _propTypesDefault.default).bool
};
FontAwesomeIcon.defaultProps = {
    border: false,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: false
};
var convertCurry = convert.bind(null, (0, _reactDefault.default).createElement);

},{"@fortawesome/fontawesome-svg-core":"hSo0b","prop-types":"bnNSm","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hSo0b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noAuto", ()=>noAuto$1);
parcelHelpers.export(exports, "config", ()=>config$1);
parcelHelpers.export(exports, "library", ()=>library$1);
parcelHelpers.export(exports, "dom", ()=>dom$1);
parcelHelpers.export(exports, "parse", ()=>parse$1);
parcelHelpers.export(exports, "findIconDefinition", ()=>findIconDefinition$1);
parcelHelpers.export(exports, "toHtml", ()=>toHtml$1);
parcelHelpers.export(exports, "icon", ()=>icon);
parcelHelpers.export(exports, "layer", ()=>layer);
parcelHelpers.export(exports, "text", ()=>text);
parcelHelpers.export(exports, "counter", ()=>counter);
parcelHelpers.export(exports, "api", ()=>api);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _wrapRegExp() {
    _wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, _wrapRegExp.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var noop = function noop() {};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
    mark: noop,
    measure: noop
};
try {
    if (typeof window !== "undefined") _WINDOW = window;
    if (typeof document !== "undefined") _DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") _MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") _PERFORMANCE = performance;
} catch (e) {}
var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5;
var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var UNITS_IN_GRID = 16;
var DEFAULT_CSS_PREFIX = "fa";
var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var DATA_FA_I2SVG = "data-fa-i2svg";
var DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var DATA_PREFIX = "data-prefix";
var DATA_ICON = "data-icon";
var HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var MUTATION_APPROACH_ASYNC = "async";
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var PRODUCTION = function() {
    try {
        return false;
    } catch (e) {
        return false;
    }
}();
var FAMILY_CLASSIC = "classic";
var FAMILY_SHARP = "sharp";
var FAMILIES = [
    FAMILY_CLASSIC,
    FAMILY_SHARP
];
function familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[FAMILY_CLASSIC];
        }
    });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fakd": "kit",
    "fa-kit": "kit",
    "fa-kit-duotone": "kit"
}), _defineProperty(_familyProxy, FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid",
    "fasr": "regular",
    "fa-regular": "regular",
    "fasl": "light",
    "fa-light": "light",
    "fast": "thin",
    "fa-thin": "thin"
}), _familyProxy));
var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
}), _defineProperty(_familyProxy2, FAMILY_SHARP, {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
}), _familyProxy2));
var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
}), _defineProperty(_familyProxy3, FAMILY_SHARP, {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
}), _familyProxy3));
var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), _defineProperty(_familyProxy4, FAMILY_SHARP, {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
}), _familyProxy4));
var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape
var LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
}), _defineProperty(_familyProxy5, FAMILY_SHARP, {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
}), _familyProxy5));
var oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var oneToTwenty = oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var prefixes = new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    DUOTONE_CLASSES.GROUP,
    DUOTONE_CLASSES.SWAP_OPACITY,
    DUOTONE_CLASSES.PRIMARY,
    DUOTONE_CLASSES.SECONDARY
]).concat(oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat(oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
    var element = DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
    var attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    attrs.forEach(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = coerce(getAttrConfig(attr));
        if (val !== undefined && val !== null) initial[key] = val;
    });
}
var _default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: DEFAULT_CSS_PREFIX,
    replacementClass: DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if (initial.familyPrefix) initial.cssPrefix = initial.familyPrefix;
var _config = _objectSpread2(_objectSpread2({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_default).forEach(function(key) {
    Object.defineProperty(config, key, {
        enumerable: true,
        set: function set(val) {
            _config[key] = val;
            _onChangeCb.forEach(function(cb) {
                return cb(config);
            });
        },
        get: function get() {
            return _config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty(config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        _config.cssPrefix = val;
        _onChangeCb.forEach(function(cb) {
            return cb(config);
        });
    },
    get: function get() {
        return _config.cssPrefix;
    }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
    _onChangeCb.push(cb);
    return function() {
        _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
    };
}
var d = UNITS_IN_GRID;
var meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function insertCss(css) {
    if (!css || !IS_DOM) return;
    var style = DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += idPool[Math.random() * 62 | 0];
    return id;
}
function toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function classArray(node) {
    if (node.classList) return toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function transformIsMeaningful(transform) {
    return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && IS_IE) val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
    else val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
    val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function css() {
    var dcp = DEFAULT_CSS_PREFIX;
    var drc = DEFAULT_REPLACEMENT_CLASS;
    var fp = config.cssPrefix;
    var rc = config.replacementClass;
    var s = baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var _cssInserted = false;
function ensureCss() {
    if (config.autoAddCss && !_cssInserted) {
        insertCss(css());
        _cssInserted = true;
    }
}
var InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: css,
                insertCss: ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                ensureCss();
            }
        };
    }
};
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener() {
    DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    loaded = 1;
    functions.map(function(fn) {
        return fn();
    });
};
var loaded = false;
if (IS_DOM) {
    loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
    if (!loaded) DOCUMENT.addEventListener("DOMContentLoaded", listener);
}
function domready(fn) {
    if (!IS_DOM) return;
    loaded ? setTimeout(fn, 0) : functions.push(fn);
}
function toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
}
function iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function toHex(unicode) {
    var decoded = ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = normalizeIcons(icons);
    if (typeof namespace.hooks.addPack === "function" && !skipHooks) namespace.hooks.addPack(prefix, normalizeIcons(icons));
    else namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") defineIcons("fa", icons);
}
var duotonePathRe = [
    /*#__PURE__*/ _wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ _wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ _wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var _LONG_STYLE, _PREFIXES, _PREFIXES_FOR_FAMILY;
var styles = namespace.styles, shims = namespace.shims;
var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = (_PREFIXES = {}, _defineProperty(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);
function isReserved(name) {
    return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !isReserved(iconName)) return iconName;
    else return null;
}
var build = function build() {
    var lookup = function lookup(reducer) {
        return reduce(styles, function(o, style, prefix) {
            o[prefix] = reduce(style, reducer, {});
            return o;
        }, {});
    };
    _byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    _byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    _byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in styles || config.autoFetchSvg;
    var shimLookups = reduce(shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    _byOldName = shimLookups.names;
    _byOldUnicode = shimLookups.unicodes;
    _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
        family: config.familyDefault
    });
};
onChange(function(c) {
    _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault, {
        family: config.familyDefault
    });
});
build();
function byUnicode(prefix, unicode) {
    return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
    return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
    return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
    return _byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function byOldUnicode(unicode) {
    var oldUnicode = _byOldUnicode[unicode];
    var newUnicode = byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function getDefaultUsablePrefix() {
    return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
    var style = PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, _defineProperty(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = FAMILY_CLASSIC;
    if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function(v) {
        return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v);
    })) family = FAMILY_CLASSIC;
    if (values.includes(famProps[FAMILY_SHARP]) || values.some(function(v) {
        return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v);
    })) family = FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = getIconName(config.cssPrefix, cls);
        if (styles[cls]) {
            cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if (PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? byOldName(acc.iconName) : {};
            var aliasIconName = byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !styles["far"] && styles["fas"] && !config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === FAMILY_SHARP && (styles["fass"] || config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || "fas";
    return canonical;
}
var Library = /*#__PURE__*/ function() {
    function Library() {
        _classCallCheck(this, Library);
        this.definitions = {};
    }
    _createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
                    if (longPrefix) defineIcons(longPrefix, additions[key]);
                    build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    _plugins = nextPlugins;
    _hooks = {};
    Object.keys(providers).forEach(function(k) {
        if (defaultProviderKeys.indexOf(k) === -1) delete providers[k];
    });
    _plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if (_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!_hooks[hook]) _hooks[hook] = [];
                _hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides(providers);
    });
    return obj;
}
function chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return providers[hook] ? providers[hook].apply(null, args) : undefined;
}
function findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = byAlias(prefix, iconName) || iconName;
    return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
    config.autoReplaceSvg = false;
    config.observeMutations = false;
    callHooks("noAuto");
};
var dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (IS_DOM) {
            callHooks("beforeI2svg", params);
            callProvided("pseudoElements2svg", params);
            return callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if (config.autoReplaceSvg === false) config.autoReplaceSvg = true;
        config.observeMutations = true;
        domready(function() {
            autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            callHooks("watch", params);
        });
    }
};
var parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if (_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
                iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var api = {
    noAuto: noAuto,
    config: config,
    dom: dom,
    parse: parse,
    library: library,
    findIconDefinition: findIconDefinition,
    toHtml: toHtml
};
var autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!IS_DOM) return;
            var container = DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if (transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        config.replacementClass,
        iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = _objectSpread2(_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return asSymbol(args);
    else return asIcon(args);
}
function makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[DATA_FA_I2SVG] = "";
    var styles = _objectSpread2({}, extra.styles);
    if (transformIsMeaningful(transform)) {
        styles["transform"] = transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var styles$1 = namespace.styles;
function asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = _slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function maybeNotifyMissing(iconName, prefix) {
    if (!PRODUCTION && !config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && config.styleDefault !== null) prefix = getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
            var icon = styles$1[prefix][iconName];
            return resolve(asFoundIcon(icon));
        }
        maybeNotifyMissing(iconName, prefix);
        resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
            icon: config.showMissingIcons && iconName ? callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var noop$1 = function noop() {};
var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
    mark: noop$1,
    measure: noop$1
};
var preamble = 'FA "6.5.1"';
var begin = function begin(name) {
    p.mark("".concat(preamble, " ").concat(name, " begins"));
    return function() {
        return end(name);
    };
};
var end = function end(name) {
    p.mark("".concat(preamble, " ").concat(name, " ends"));
    p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
    begin: begin,
    end: end
};
var noop$2 = function noop() {};
function isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
    return prefix && icon;
}
function hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
    if (config.autoReplaceSvg === true) return mutators.replace;
    var mutator = mutators[config.autoReplaceSvg];
    return mutator || mutators.replace;
}
function createElementNS(tag) {
    return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function createElement(tag) {
    return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? createElementNS : createElement : _params$ceFn;
    if (typeof abstractObj === "string") return DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild(convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore(convertSVG(_abstract), node);
            });
            if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
                var comment = DOCUMENT.createComment(nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~classArray(node).indexOf(config.replacementClass)) return mutators.replace(mutation);
        var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return toHtml(a);
        }).join("\n");
        node.setAttribute(DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function performOperationSync(op) {
    op();
}
function perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = performOperationSync;
        if (config.mutateApproach === MUTATION_APPROACH_ASYNC) frame = WINDOW.requestAnimationFrame || performOperationSync;
        frame(function() {
            var mutator = getMutator();
            var mark = perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var disabled = false;
function disableObservation() {
    disabled = true;
}
function enableObservation() {
    disabled = false;
}
var mo = null;
function observe(options) {
    if (!MUTATION_OBSERVER) return;
    if (!config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
    mo = new MUTATION_OBSERVER(function(objects) {
        if (disabled) return;
        var defaultPrefix = getDefaultUsablePrefix();
        toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
                if (config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
                } else if (hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!IS_DOM) return;
    mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function disconnect() {
    if (!mo) return;
    mo.disconnect();
}
function styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = getCanonicalIcon(classArray(node));
    if (!val.prefix) val.prefix = getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
    if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function attributesParser(node) {
    var extraAttributes = toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if (config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = attributesParser(node);
    var pluginMeta = chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? styleParser(node) : [];
    return _objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var styles$2 = namespace.styles;
function generateMutation(node) {
    var nodeMeta = config.autoReplaceSvg === "nest" ? parseMeta(node, {
        styleParser: false
    }) : parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) return callProvided("generateLayersText", node, nodeMeta);
    else return callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var knownPrefixes = new Set();
FAMILIES.map(function(family) {
    knownPrefixes.add("fa-".concat(family));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = _toConsumableArray(knownPrefixes);
function onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!IS_DOM) return Promise.resolve();
    var htmlClassList = DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys(styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    generateMutation(node).then(function(mutation) {
        if (mutation) perform([
            mutation
        ], callback);
    });
}
function resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
        return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return domVariants(_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if (config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return makeInlineSvgAbstract({
            icons: {
                main: asFoundIcon(icon),
                mask: mask ? asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: resolveIcons(render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = onTree;
                accumulator.nodeCallback = onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    findIcon(iconName, prefix),
                    mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if (transformIsMeaningful(transform)) nextChild = callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return domVariants({
                    type: "layer"
                }, function() {
                    callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat(config.cssPrefix, "-layers")
                                ].concat(_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat(config.cssPrefix, "-layers-counter")
                            ].concat(_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return domVariants({
                    type: "text",
                    content: content
                }, function() {
                    callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return makeLayersTextAbstract({
                        content: content,
                        transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat(config.cssPrefix, "-layers-text")
                            ].concat(_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if (IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if (config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function hexValueFromContent(content) {
    var cleaned = content.replace(CLEAN_CONTENT_PATTERN, "");
    var codePoint = codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function replaceForPosition(node, position) {
    var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = blankMeta();
                var extra = meta.extra;
                extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
                findIcon(iconName, prefix).then(function(main) {
                    var _abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function replace(node) {
    return Promise.all([
        replaceForPosition(node, "::before"),
        replaceForPosition(node, "::after")
    ]);
}
function processable(node) {
    return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function searchPseudoElements(root) {
    if (!IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = toArray(root.querySelectorAll("*")).filter(processable).map(replace);
        var end = perf.begin("searchPseudoElements");
        disableObservation();
        Promise.all(operations).then(function() {
            end();
            enableObservation();
            resolve();
        }).catch(function() {
            end();
            enableObservation();
            reject();
        });
    });
}
var PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node;
            if (config.searchPseudoElements) searchPseudoElements(node);
        };
    }
};
var _unwatched = false;
var MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    disableObservation();
                    _unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                observe(chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if (_unwatched) enableObservation();
                else observe(chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: _objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: _objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = "black";
    return _abstract;
}
function deGroup(_abstract2) {
    if (_abstract2.tag === "g") return _abstract2.children;
    else return [
        _abstract2
    ];
}
var Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map(fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: _objectSpread2({}, trans.inner),
                children: [
                    fillBlack(_objectSpread2({
                        tag: mainPath.tag,
                        attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: _objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: _objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if (WINDOW.matchMedia) reduceMotion = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var plugins = [
    InjectCSS,
    ReplaceElements,
    Layers,
    LayersCounter,
    LayersText,
    PseudoElements,
    MutationObserver$1,
    PowerTransforms,
    Masks,
    MissingIconIndicator,
    SvgSymbols
];
registerPlugins(plugins, {
    mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3TAw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fas", ()=>icons);
parcelHelpers.export(exports, "prefix", ()=>prefix);
parcelHelpers.export(exports, "fa0", ()=>fa0);
parcelHelpers.export(exports, "fa1", ()=>fa1);
parcelHelpers.export(exports, "fa2", ()=>fa2);
parcelHelpers.export(exports, "fa3", ()=>fa3);
parcelHelpers.export(exports, "fa4", ()=>fa4);
parcelHelpers.export(exports, "fa5", ()=>fa5);
parcelHelpers.export(exports, "fa6", ()=>fa6);
parcelHelpers.export(exports, "fa7", ()=>fa7);
parcelHelpers.export(exports, "fa8", ()=>fa8);
parcelHelpers.export(exports, "fa9", ()=>fa9);
parcelHelpers.export(exports, "faFillDrip", ()=>faFillDrip);
parcelHelpers.export(exports, "faArrowsToCircle", ()=>faArrowsToCircle);
parcelHelpers.export(exports, "faCircleChevronRight", ()=>faCircleChevronRight);
parcelHelpers.export(exports, "faChevronCircleRight", ()=>faChevronCircleRight);
parcelHelpers.export(exports, "faAt", ()=>faAt);
parcelHelpers.export(exports, "faTrashCan", ()=>faTrashCan);
parcelHelpers.export(exports, "faTrashAlt", ()=>faTrashAlt);
parcelHelpers.export(exports, "faTextHeight", ()=>faTextHeight);
parcelHelpers.export(exports, "faUserXmark", ()=>faUserXmark);
parcelHelpers.export(exports, "faUserTimes", ()=>faUserTimes);
parcelHelpers.export(exports, "faStethoscope", ()=>faStethoscope);
parcelHelpers.export(exports, "faMessage", ()=>faMessage);
parcelHelpers.export(exports, "faCommentAlt", ()=>faCommentAlt);
parcelHelpers.export(exports, "faInfo", ()=>faInfo);
parcelHelpers.export(exports, "faDownLeftAndUpRightToCenter", ()=>faDownLeftAndUpRightToCenter);
parcelHelpers.export(exports, "faCompressAlt", ()=>faCompressAlt);
parcelHelpers.export(exports, "faExplosion", ()=>faExplosion);
parcelHelpers.export(exports, "faFileLines", ()=>faFileLines);
parcelHelpers.export(exports, "faFileAlt", ()=>faFileAlt);
parcelHelpers.export(exports, "faFileText", ()=>faFileText);
parcelHelpers.export(exports, "faWaveSquare", ()=>faWaveSquare);
parcelHelpers.export(exports, "faRing", ()=>faRing);
parcelHelpers.export(exports, "faBuildingUn", ()=>faBuildingUn);
parcelHelpers.export(exports, "faDiceThree", ()=>faDiceThree);
parcelHelpers.export(exports, "faCalendarDays", ()=>faCalendarDays);
parcelHelpers.export(exports, "faCalendarAlt", ()=>faCalendarAlt);
parcelHelpers.export(exports, "faAnchorCircleCheck", ()=>faAnchorCircleCheck);
parcelHelpers.export(exports, "faBuildingCircleArrowRight", ()=>faBuildingCircleArrowRight);
parcelHelpers.export(exports, "faVolleyball", ()=>faVolleyball);
parcelHelpers.export(exports, "faVolleyballBall", ()=>faVolleyballBall);
parcelHelpers.export(exports, "faArrowsUpToLine", ()=>faArrowsUpToLine);
parcelHelpers.export(exports, "faSortDown", ()=>faSortDown);
parcelHelpers.export(exports, "faSortDesc", ()=>faSortDesc);
parcelHelpers.export(exports, "faCircleMinus", ()=>faCircleMinus);
parcelHelpers.export(exports, "faMinusCircle", ()=>faMinusCircle);
parcelHelpers.export(exports, "faDoorOpen", ()=>faDoorOpen);
parcelHelpers.export(exports, "faRightFromBracket", ()=>faRightFromBracket);
parcelHelpers.export(exports, "faSignOutAlt", ()=>faSignOutAlt);
parcelHelpers.export(exports, "faAtom", ()=>faAtom);
parcelHelpers.export(exports, "faSoap", ()=>faSoap);
parcelHelpers.export(exports, "faIcons", ()=>faIcons);
parcelHelpers.export(exports, "faHeartMusicCameraBolt", ()=>faHeartMusicCameraBolt);
parcelHelpers.export(exports, "faMicrophoneLinesSlash", ()=>faMicrophoneLinesSlash);
parcelHelpers.export(exports, "faMicrophoneAltSlash", ()=>faMicrophoneAltSlash);
parcelHelpers.export(exports, "faBridgeCircleCheck", ()=>faBridgeCircleCheck);
parcelHelpers.export(exports, "faPumpMedical", ()=>faPumpMedical);
parcelHelpers.export(exports, "faFingerprint", ()=>faFingerprint);
parcelHelpers.export(exports, "faHandPointRight", ()=>faHandPointRight);
parcelHelpers.export(exports, "faMagnifyingGlassLocation", ()=>faMagnifyingGlassLocation);
parcelHelpers.export(exports, "faSearchLocation", ()=>faSearchLocation);
parcelHelpers.export(exports, "faForwardStep", ()=>faForwardStep);
parcelHelpers.export(exports, "faStepForward", ()=>faStepForward);
parcelHelpers.export(exports, "faFaceSmileBeam", ()=>faFaceSmileBeam);
parcelHelpers.export(exports, "faSmileBeam", ()=>faSmileBeam);
parcelHelpers.export(exports, "faFlagCheckered", ()=>faFlagCheckered);
parcelHelpers.export(exports, "faFootball", ()=>faFootball);
parcelHelpers.export(exports, "faFootballBall", ()=>faFootballBall);
parcelHelpers.export(exports, "faSchoolCircleExclamation", ()=>faSchoolCircleExclamation);
parcelHelpers.export(exports, "faCrop", ()=>faCrop);
parcelHelpers.export(exports, "faAnglesDown", ()=>faAnglesDown);
parcelHelpers.export(exports, "faAngleDoubleDown", ()=>faAngleDoubleDown);
parcelHelpers.export(exports, "faUsersRectangle", ()=>faUsersRectangle);
parcelHelpers.export(exports, "faPeopleRoof", ()=>faPeopleRoof);
parcelHelpers.export(exports, "faPeopleLine", ()=>faPeopleLine);
parcelHelpers.export(exports, "faBeerMugEmpty", ()=>faBeerMugEmpty);
parcelHelpers.export(exports, "faBeer", ()=>faBeer);
parcelHelpers.export(exports, "faDiagramPredecessor", ()=>faDiagramPredecessor);
parcelHelpers.export(exports, "faArrowUpLong", ()=>faArrowUpLong);
parcelHelpers.export(exports, "faLongArrowUp", ()=>faLongArrowUp);
parcelHelpers.export(exports, "faFireFlameSimple", ()=>faFireFlameSimple);
parcelHelpers.export(exports, "faBurn", ()=>faBurn);
parcelHelpers.export(exports, "faPerson", ()=>faPerson);
parcelHelpers.export(exports, "faMale", ()=>faMale);
parcelHelpers.export(exports, "faLaptop", ()=>faLaptop);
parcelHelpers.export(exports, "faFileCsv", ()=>faFileCsv);
parcelHelpers.export(exports, "faMenorah", ()=>faMenorah);
parcelHelpers.export(exports, "faTruckPlane", ()=>faTruckPlane);
parcelHelpers.export(exports, "faRecordVinyl", ()=>faRecordVinyl);
parcelHelpers.export(exports, "faFaceGrinStars", ()=>faFaceGrinStars);
parcelHelpers.export(exports, "faGrinStars", ()=>faGrinStars);
parcelHelpers.export(exports, "faBong", ()=>faBong);
parcelHelpers.export(exports, "faSpaghettiMonsterFlying", ()=>faSpaghettiMonsterFlying);
parcelHelpers.export(exports, "faPastafarianism", ()=>faPastafarianism);
parcelHelpers.export(exports, "faArrowDownUpAcrossLine", ()=>faArrowDownUpAcrossLine);
parcelHelpers.export(exports, "faSpoon", ()=>faSpoon);
parcelHelpers.export(exports, "faUtensilSpoon", ()=>faUtensilSpoon);
parcelHelpers.export(exports, "faJarWheat", ()=>faJarWheat);
parcelHelpers.export(exports, "faEnvelopesBulk", ()=>faEnvelopesBulk);
parcelHelpers.export(exports, "faMailBulk", ()=>faMailBulk);
parcelHelpers.export(exports, "faFileCircleExclamation", ()=>faFileCircleExclamation);
parcelHelpers.export(exports, "faCircleH", ()=>faCircleH);
parcelHelpers.export(exports, "faHospitalSymbol", ()=>faHospitalSymbol);
parcelHelpers.export(exports, "faPager", ()=>faPager);
parcelHelpers.export(exports, "faAddressBook", ()=>faAddressBook);
parcelHelpers.export(exports, "faContactBook", ()=>faContactBook);
parcelHelpers.export(exports, "faStrikethrough", ()=>faStrikethrough);
parcelHelpers.export(exports, "faK", ()=>faK);
parcelHelpers.export(exports, "faLandmarkFlag", ()=>faLandmarkFlag);
parcelHelpers.export(exports, "faPencil", ()=>faPencil);
parcelHelpers.export(exports, "faPencilAlt", ()=>faPencilAlt);
parcelHelpers.export(exports, "faBackward", ()=>faBackward);
parcelHelpers.export(exports, "faCaretRight", ()=>faCaretRight);
parcelHelpers.export(exports, "faComments", ()=>faComments);
parcelHelpers.export(exports, "faPaste", ()=>faPaste);
parcelHelpers.export(exports, "faFileClipboard", ()=>faFileClipboard);
parcelHelpers.export(exports, "faCodePullRequest", ()=>faCodePullRequest);
parcelHelpers.export(exports, "faClipboardList", ()=>faClipboardList);
parcelHelpers.export(exports, "faTruckRampBox", ()=>faTruckRampBox);
parcelHelpers.export(exports, "faTruckLoading", ()=>faTruckLoading);
parcelHelpers.export(exports, "faUserCheck", ()=>faUserCheck);
parcelHelpers.export(exports, "faVialVirus", ()=>faVialVirus);
parcelHelpers.export(exports, "faSheetPlastic", ()=>faSheetPlastic);
parcelHelpers.export(exports, "faBlog", ()=>faBlog);
parcelHelpers.export(exports, "faUserNinja", ()=>faUserNinja);
parcelHelpers.export(exports, "faPersonArrowUpFromLine", ()=>faPersonArrowUpFromLine);
parcelHelpers.export(exports, "faScrollTorah", ()=>faScrollTorah);
parcelHelpers.export(exports, "faTorah", ()=>faTorah);
parcelHelpers.export(exports, "faBroomBall", ()=>faBroomBall);
parcelHelpers.export(exports, "faQuidditch", ()=>faQuidditch);
parcelHelpers.export(exports, "faQuidditchBroomBall", ()=>faQuidditchBroomBall);
parcelHelpers.export(exports, "faToggleOff", ()=>faToggleOff);
parcelHelpers.export(exports, "faBoxArchive", ()=>faBoxArchive);
parcelHelpers.export(exports, "faArchive", ()=>faArchive);
parcelHelpers.export(exports, "faPersonDrowning", ()=>faPersonDrowning);
parcelHelpers.export(exports, "faArrowDown91", ()=>faArrowDown91);
parcelHelpers.export(exports, "faSortNumericDesc", ()=>faSortNumericDesc);
parcelHelpers.export(exports, "faSortNumericDownAlt", ()=>faSortNumericDownAlt);
parcelHelpers.export(exports, "faFaceGrinTongueSquint", ()=>faFaceGrinTongueSquint);
parcelHelpers.export(exports, "faGrinTongueSquint", ()=>faGrinTongueSquint);
parcelHelpers.export(exports, "faSprayCan", ()=>faSprayCan);
parcelHelpers.export(exports, "faTruckMonster", ()=>faTruckMonster);
parcelHelpers.export(exports, "faW", ()=>faW);
parcelHelpers.export(exports, "faEarthAfrica", ()=>faEarthAfrica);
parcelHelpers.export(exports, "faGlobeAfrica", ()=>faGlobeAfrica);
parcelHelpers.export(exports, "faRainbow", ()=>faRainbow);
parcelHelpers.export(exports, "faCircleNotch", ()=>faCircleNotch);
parcelHelpers.export(exports, "faTabletScreenButton", ()=>faTabletScreenButton);
parcelHelpers.export(exports, "faTabletAlt", ()=>faTabletAlt);
parcelHelpers.export(exports, "faPaw", ()=>faPaw);
parcelHelpers.export(exports, "faCloud", ()=>faCloud);
parcelHelpers.export(exports, "faTrowelBricks", ()=>faTrowelBricks);
parcelHelpers.export(exports, "faFaceFlushed", ()=>faFaceFlushed);
parcelHelpers.export(exports, "faFlushed", ()=>faFlushed);
parcelHelpers.export(exports, "faHospitalUser", ()=>faHospitalUser);
parcelHelpers.export(exports, "faTentArrowLeftRight", ()=>faTentArrowLeftRight);
parcelHelpers.export(exports, "faGavel", ()=>faGavel);
parcelHelpers.export(exports, "faLegal", ()=>faLegal);
parcelHelpers.export(exports, "faBinoculars", ()=>faBinoculars);
parcelHelpers.export(exports, "faMicrophoneSlash", ()=>faMicrophoneSlash);
parcelHelpers.export(exports, "faBoxTissue", ()=>faBoxTissue);
parcelHelpers.export(exports, "faMotorcycle", ()=>faMotorcycle);
parcelHelpers.export(exports, "faBellConcierge", ()=>faBellConcierge);
parcelHelpers.export(exports, "faConciergeBell", ()=>faConciergeBell);
parcelHelpers.export(exports, "faPenRuler", ()=>faPenRuler);
parcelHelpers.export(exports, "faPencilRuler", ()=>faPencilRuler);
parcelHelpers.export(exports, "faPeopleArrows", ()=>faPeopleArrows);
parcelHelpers.export(exports, "faPeopleArrowsLeftRight", ()=>faPeopleArrowsLeftRight);
parcelHelpers.export(exports, "faMarsAndVenusBurst", ()=>faMarsAndVenusBurst);
parcelHelpers.export(exports, "faSquareCaretRight", ()=>faSquareCaretRight);
parcelHelpers.export(exports, "faCaretSquareRight", ()=>faCaretSquareRight);
parcelHelpers.export(exports, "faScissors", ()=>faScissors);
parcelHelpers.export(exports, "faCut", ()=>faCut);
parcelHelpers.export(exports, "faSunPlantWilt", ()=>faSunPlantWilt);
parcelHelpers.export(exports, "faToiletsPortable", ()=>faToiletsPortable);
parcelHelpers.export(exports, "faHockeyPuck", ()=>faHockeyPuck);
parcelHelpers.export(exports, "faTable", ()=>faTable);
parcelHelpers.export(exports, "faMagnifyingGlassArrowRight", ()=>faMagnifyingGlassArrowRight);
parcelHelpers.export(exports, "faTachographDigital", ()=>faTachographDigital);
parcelHelpers.export(exports, "faDigitalTachograph", ()=>faDigitalTachograph);
parcelHelpers.export(exports, "faUsersSlash", ()=>faUsersSlash);
parcelHelpers.export(exports, "faClover", ()=>faClover);
parcelHelpers.export(exports, "faReply", ()=>faReply);
parcelHelpers.export(exports, "faMailReply", ()=>faMailReply);
parcelHelpers.export(exports, "faStarAndCrescent", ()=>faStarAndCrescent);
parcelHelpers.export(exports, "faHouseFire", ()=>faHouseFire);
parcelHelpers.export(exports, "faSquareMinus", ()=>faSquareMinus);
parcelHelpers.export(exports, "faMinusSquare", ()=>faMinusSquare);
parcelHelpers.export(exports, "faHelicopter", ()=>faHelicopter);
parcelHelpers.export(exports, "faCompass", ()=>faCompass);
parcelHelpers.export(exports, "faSquareCaretDown", ()=>faSquareCaretDown);
parcelHelpers.export(exports, "faCaretSquareDown", ()=>faCaretSquareDown);
parcelHelpers.export(exports, "faFileCircleQuestion", ()=>faFileCircleQuestion);
parcelHelpers.export(exports, "faLaptopCode", ()=>faLaptopCode);
parcelHelpers.export(exports, "faSwatchbook", ()=>faSwatchbook);
parcelHelpers.export(exports, "faPrescriptionBottle", ()=>faPrescriptionBottle);
parcelHelpers.export(exports, "faBars", ()=>faBars);
parcelHelpers.export(exports, "faNavicon", ()=>faNavicon);
parcelHelpers.export(exports, "faPeopleGroup", ()=>faPeopleGroup);
parcelHelpers.export(exports, "faHourglassEnd", ()=>faHourglassEnd);
parcelHelpers.export(exports, "faHourglass3", ()=>faHourglass3);
parcelHelpers.export(exports, "faHeartCrack", ()=>faHeartCrack);
parcelHelpers.export(exports, "faHeartBroken", ()=>faHeartBroken);
parcelHelpers.export(exports, "faSquareUpRight", ()=>faSquareUpRight);
parcelHelpers.export(exports, "faExternalLinkSquareAlt", ()=>faExternalLinkSquareAlt);
parcelHelpers.export(exports, "faFaceKissBeam", ()=>faFaceKissBeam);
parcelHelpers.export(exports, "faKissBeam", ()=>faKissBeam);
parcelHelpers.export(exports, "faFilm", ()=>faFilm);
parcelHelpers.export(exports, "faRulerHorizontal", ()=>faRulerHorizontal);
parcelHelpers.export(exports, "faPeopleRobbery", ()=>faPeopleRobbery);
parcelHelpers.export(exports, "faLightbulb", ()=>faLightbulb);
parcelHelpers.export(exports, "faCaretLeft", ()=>faCaretLeft);
parcelHelpers.export(exports, "faCircleExclamation", ()=>faCircleExclamation);
parcelHelpers.export(exports, "faExclamationCircle", ()=>faExclamationCircle);
parcelHelpers.export(exports, "faSchoolCircleXmark", ()=>faSchoolCircleXmark);
parcelHelpers.export(exports, "faArrowRightFromBracket", ()=>faArrowRightFromBracket);
parcelHelpers.export(exports, "faSignOut", ()=>faSignOut);
parcelHelpers.export(exports, "faCircleChevronDown", ()=>faCircleChevronDown);
parcelHelpers.export(exports, "faChevronCircleDown", ()=>faChevronCircleDown);
parcelHelpers.export(exports, "faUnlockKeyhole", ()=>faUnlockKeyhole);
parcelHelpers.export(exports, "faUnlockAlt", ()=>faUnlockAlt);
parcelHelpers.export(exports, "faCloudShowersHeavy", ()=>faCloudShowersHeavy);
parcelHelpers.export(exports, "faHeadphonesSimple", ()=>faHeadphonesSimple);
parcelHelpers.export(exports, "faHeadphonesAlt", ()=>faHeadphonesAlt);
parcelHelpers.export(exports, "faSitemap", ()=>faSitemap);
parcelHelpers.export(exports, "faCircleDollarToSlot", ()=>faCircleDollarToSlot);
parcelHelpers.export(exports, "faDonate", ()=>faDonate);
parcelHelpers.export(exports, "faMemory", ()=>faMemory);
parcelHelpers.export(exports, "faRoadSpikes", ()=>faRoadSpikes);
parcelHelpers.export(exports, "faFireBurner", ()=>faFireBurner);
parcelHelpers.export(exports, "faFlag", ()=>faFlag);
parcelHelpers.export(exports, "faHanukiah", ()=>faHanukiah);
parcelHelpers.export(exports, "faFeather", ()=>faFeather);
parcelHelpers.export(exports, "faVolumeLow", ()=>faVolumeLow);
parcelHelpers.export(exports, "faVolumeDown", ()=>faVolumeDown);
parcelHelpers.export(exports, "faCommentSlash", ()=>faCommentSlash);
parcelHelpers.export(exports, "faCloudSunRain", ()=>faCloudSunRain);
parcelHelpers.export(exports, "faCompress", ()=>faCompress);
parcelHelpers.export(exports, "faWheatAwn", ()=>faWheatAwn);
parcelHelpers.export(exports, "faWheatAlt", ()=>faWheatAlt);
parcelHelpers.export(exports, "faAnkh", ()=>faAnkh);
parcelHelpers.export(exports, "faHandsHoldingChild", ()=>faHandsHoldingChild);
parcelHelpers.export(exports, "faAsterisk", ()=>faAsterisk);
parcelHelpers.export(exports, "faSquareCheck", ()=>faSquareCheck);
parcelHelpers.export(exports, "faCheckSquare", ()=>faCheckSquare);
parcelHelpers.export(exports, "faPesetaSign", ()=>faPesetaSign);
parcelHelpers.export(exports, "faHeading", ()=>faHeading);
parcelHelpers.export(exports, "faHeader", ()=>faHeader);
parcelHelpers.export(exports, "faGhost", ()=>faGhost);
parcelHelpers.export(exports, "faList", ()=>faList);
parcelHelpers.export(exports, "faListSquares", ()=>faListSquares);
parcelHelpers.export(exports, "faSquarePhoneFlip", ()=>faSquarePhoneFlip);
parcelHelpers.export(exports, "faPhoneSquareAlt", ()=>faPhoneSquareAlt);
parcelHelpers.export(exports, "faCartPlus", ()=>faCartPlus);
parcelHelpers.export(exports, "faGamepad", ()=>faGamepad);
parcelHelpers.export(exports, "faCircleDot", ()=>faCircleDot);
parcelHelpers.export(exports, "faDotCircle", ()=>faDotCircle);
parcelHelpers.export(exports, "faFaceDizzy", ()=>faFaceDizzy);
parcelHelpers.export(exports, "faDizzy", ()=>faDizzy);
parcelHelpers.export(exports, "faEgg", ()=>faEgg);
parcelHelpers.export(exports, "faHouseMedicalCircleXmark", ()=>faHouseMedicalCircleXmark);
parcelHelpers.export(exports, "faCampground", ()=>faCampground);
parcelHelpers.export(exports, "faFolderPlus", ()=>faFolderPlus);
parcelHelpers.export(exports, "faFutbol", ()=>faFutbol);
parcelHelpers.export(exports, "faFutbolBall", ()=>faFutbolBall);
parcelHelpers.export(exports, "faSoccerBall", ()=>faSoccerBall);
parcelHelpers.export(exports, "faPaintbrush", ()=>faPaintbrush);
parcelHelpers.export(exports, "faPaintBrush", ()=>faPaintBrush);
parcelHelpers.export(exports, "faLock", ()=>faLock);
parcelHelpers.export(exports, "faGasPump", ()=>faGasPump);
parcelHelpers.export(exports, "faHotTubPerson", ()=>faHotTubPerson);
parcelHelpers.export(exports, "faHotTub", ()=>faHotTub);
parcelHelpers.export(exports, "faMapLocation", ()=>faMapLocation);
parcelHelpers.export(exports, "faMapMarked", ()=>faMapMarked);
parcelHelpers.export(exports, "faHouseFloodWater", ()=>faHouseFloodWater);
parcelHelpers.export(exports, "faTree", ()=>faTree);
parcelHelpers.export(exports, "faBridgeLock", ()=>faBridgeLock);
parcelHelpers.export(exports, "faSackDollar", ()=>faSackDollar);
parcelHelpers.export(exports, "faPenToSquare", ()=>faPenToSquare);
parcelHelpers.export(exports, "faEdit", ()=>faEdit);
parcelHelpers.export(exports, "faCarSide", ()=>faCarSide);
parcelHelpers.export(exports, "faShareNodes", ()=>faShareNodes);
parcelHelpers.export(exports, "faShareAlt", ()=>faShareAlt);
parcelHelpers.export(exports, "faHeartCircleMinus", ()=>faHeartCircleMinus);
parcelHelpers.export(exports, "faHourglassHalf", ()=>faHourglassHalf);
parcelHelpers.export(exports, "faHourglass2", ()=>faHourglass2);
parcelHelpers.export(exports, "faMicroscope", ()=>faMicroscope);
parcelHelpers.export(exports, "faSink", ()=>faSink);
parcelHelpers.export(exports, "faBagShopping", ()=>faBagShopping);
parcelHelpers.export(exports, "faShoppingBag", ()=>faShoppingBag);
parcelHelpers.export(exports, "faArrowDownZA", ()=>faArrowDownZA);
parcelHelpers.export(exports, "faSortAlphaDesc", ()=>faSortAlphaDesc);
parcelHelpers.export(exports, "faSortAlphaDownAlt", ()=>faSortAlphaDownAlt);
parcelHelpers.export(exports, "faMitten", ()=>faMitten);
parcelHelpers.export(exports, "faPersonRays", ()=>faPersonRays);
parcelHelpers.export(exports, "faUsers", ()=>faUsers);
parcelHelpers.export(exports, "faEyeSlash", ()=>faEyeSlash);
parcelHelpers.export(exports, "faFlaskVial", ()=>faFlaskVial);
parcelHelpers.export(exports, "faHand", ()=>faHand);
parcelHelpers.export(exports, "faHandPaper", ()=>faHandPaper);
parcelHelpers.export(exports, "faOm", ()=>faOm);
parcelHelpers.export(exports, "faWorm", ()=>faWorm);
parcelHelpers.export(exports, "faHouseCircleXmark", ()=>faHouseCircleXmark);
parcelHelpers.export(exports, "faPlug", ()=>faPlug);
parcelHelpers.export(exports, "faChevronUp", ()=>faChevronUp);
parcelHelpers.export(exports, "faHandSpock", ()=>faHandSpock);
parcelHelpers.export(exports, "faStopwatch", ()=>faStopwatch);
parcelHelpers.export(exports, "faFaceKiss", ()=>faFaceKiss);
parcelHelpers.export(exports, "faKiss", ()=>faKiss);
parcelHelpers.export(exports, "faBridgeCircleXmark", ()=>faBridgeCircleXmark);
parcelHelpers.export(exports, "faFaceGrinTongue", ()=>faFaceGrinTongue);
parcelHelpers.export(exports, "faGrinTongue", ()=>faGrinTongue);
parcelHelpers.export(exports, "faChessBishop", ()=>faChessBishop);
parcelHelpers.export(exports, "faFaceGrinWink", ()=>faFaceGrinWink);
parcelHelpers.export(exports, "faGrinWink", ()=>faGrinWink);
parcelHelpers.export(exports, "faEarDeaf", ()=>faEarDeaf);
parcelHelpers.export(exports, "faDeaf", ()=>faDeaf);
parcelHelpers.export(exports, "faDeafness", ()=>faDeafness);
parcelHelpers.export(exports, "faHardOfHearing", ()=>faHardOfHearing);
parcelHelpers.export(exports, "faRoadCircleCheck", ()=>faRoadCircleCheck);
parcelHelpers.export(exports, "faDiceFive", ()=>faDiceFive);
parcelHelpers.export(exports, "faSquareRss", ()=>faSquareRss);
parcelHelpers.export(exports, "faRssSquare", ()=>faRssSquare);
parcelHelpers.export(exports, "faLandMineOn", ()=>faLandMineOn);
parcelHelpers.export(exports, "faICursor", ()=>faICursor);
parcelHelpers.export(exports, "faStamp", ()=>faStamp);
parcelHelpers.export(exports, "faStairs", ()=>faStairs);
parcelHelpers.export(exports, "faI", ()=>faI);
parcelHelpers.export(exports, "faHryvniaSign", ()=>faHryvniaSign);
parcelHelpers.export(exports, "faHryvnia", ()=>faHryvnia);
parcelHelpers.export(exports, "faPills", ()=>faPills);
parcelHelpers.export(exports, "faFaceGrinWide", ()=>faFaceGrinWide);
parcelHelpers.export(exports, "faGrinAlt", ()=>faGrinAlt);
parcelHelpers.export(exports, "faTooth", ()=>faTooth);
parcelHelpers.export(exports, "faV", ()=>faV);
parcelHelpers.export(exports, "faBangladeshiTakaSign", ()=>faBangladeshiTakaSign);
parcelHelpers.export(exports, "faBicycle", ()=>faBicycle);
parcelHelpers.export(exports, "faStaffSnake", ()=>faStaffSnake);
parcelHelpers.export(exports, "faRodAsclepius", ()=>faRodAsclepius);
parcelHelpers.export(exports, "faRodSnake", ()=>faRodSnake);
parcelHelpers.export(exports, "faStaffAesculapius", ()=>faStaffAesculapius);
parcelHelpers.export(exports, "faHeadSideCoughSlash", ()=>faHeadSideCoughSlash);
parcelHelpers.export(exports, "faTruckMedical", ()=>faTruckMedical);
parcelHelpers.export(exports, "faAmbulance", ()=>faAmbulance);
parcelHelpers.export(exports, "faWheatAwnCircleExclamation", ()=>faWheatAwnCircleExclamation);
parcelHelpers.export(exports, "faSnowman", ()=>faSnowman);
parcelHelpers.export(exports, "faMortarPestle", ()=>faMortarPestle);
parcelHelpers.export(exports, "faRoadBarrier", ()=>faRoadBarrier);
parcelHelpers.export(exports, "faSchool", ()=>faSchool);
parcelHelpers.export(exports, "faIgloo", ()=>faIgloo);
parcelHelpers.export(exports, "faJoint", ()=>faJoint);
parcelHelpers.export(exports, "faAngleRight", ()=>faAngleRight);
parcelHelpers.export(exports, "faHorse", ()=>faHorse);
parcelHelpers.export(exports, "faQ", ()=>faQ);
parcelHelpers.export(exports, "faG", ()=>faG);
parcelHelpers.export(exports, "faNotesMedical", ()=>faNotesMedical);
parcelHelpers.export(exports, "faTemperatureHalf", ()=>faTemperatureHalf);
parcelHelpers.export(exports, "faTemperature2", ()=>faTemperature2);
parcelHelpers.export(exports, "faThermometer2", ()=>faThermometer2);
parcelHelpers.export(exports, "faThermometerHalf", ()=>faThermometerHalf);
parcelHelpers.export(exports, "faDongSign", ()=>faDongSign);
parcelHelpers.export(exports, "faCapsules", ()=>faCapsules);
parcelHelpers.export(exports, "faPooStorm", ()=>faPooStorm);
parcelHelpers.export(exports, "faPooBolt", ()=>faPooBolt);
parcelHelpers.export(exports, "faFaceFrownOpen", ()=>faFaceFrownOpen);
parcelHelpers.export(exports, "faFrownOpen", ()=>faFrownOpen);
parcelHelpers.export(exports, "faHandPointUp", ()=>faHandPointUp);
parcelHelpers.export(exports, "faMoneyBill", ()=>faMoneyBill);
parcelHelpers.export(exports, "faBookmark", ()=>faBookmark);
parcelHelpers.export(exports, "faAlignJustify", ()=>faAlignJustify);
parcelHelpers.export(exports, "faUmbrellaBeach", ()=>faUmbrellaBeach);
parcelHelpers.export(exports, "faHelmetUn", ()=>faHelmetUn);
parcelHelpers.export(exports, "faBullseye", ()=>faBullseye);
parcelHelpers.export(exports, "faBacon", ()=>faBacon);
parcelHelpers.export(exports, "faHandPointDown", ()=>faHandPointDown);
parcelHelpers.export(exports, "faArrowUpFromBracket", ()=>faArrowUpFromBracket);
parcelHelpers.export(exports, "faFolder", ()=>faFolder);
parcelHelpers.export(exports, "faFolderBlank", ()=>faFolderBlank);
parcelHelpers.export(exports, "faFileWaveform", ()=>faFileWaveform);
parcelHelpers.export(exports, "faFileMedicalAlt", ()=>faFileMedicalAlt);
parcelHelpers.export(exports, "faRadiation", ()=>faRadiation);
parcelHelpers.export(exports, "faChartSimple", ()=>faChartSimple);
parcelHelpers.export(exports, "faMarsStroke", ()=>faMarsStroke);
parcelHelpers.export(exports, "faVial", ()=>faVial);
parcelHelpers.export(exports, "faGauge", ()=>faGauge);
parcelHelpers.export(exports, "faDashboard", ()=>faDashboard);
parcelHelpers.export(exports, "faGaugeMed", ()=>faGaugeMed);
parcelHelpers.export(exports, "faTachometerAltAverage", ()=>faTachometerAltAverage);
parcelHelpers.export(exports, "faWandMagicSparkles", ()=>faWandMagicSparkles);
parcelHelpers.export(exports, "faMagicWandSparkles", ()=>faMagicWandSparkles);
parcelHelpers.export(exports, "faE", ()=>faE);
parcelHelpers.export(exports, "faPenClip", ()=>faPenClip);
parcelHelpers.export(exports, "faPenAlt", ()=>faPenAlt);
parcelHelpers.export(exports, "faBridgeCircleExclamation", ()=>faBridgeCircleExclamation);
parcelHelpers.export(exports, "faUser", ()=>faUser);
parcelHelpers.export(exports, "faSchoolCircleCheck", ()=>faSchoolCircleCheck);
parcelHelpers.export(exports, "faDumpster", ()=>faDumpster);
parcelHelpers.export(exports, "faVanShuttle", ()=>faVanShuttle);
parcelHelpers.export(exports, "faShuttleVan", ()=>faShuttleVan);
parcelHelpers.export(exports, "faBuildingUser", ()=>faBuildingUser);
parcelHelpers.export(exports, "faSquareCaretLeft", ()=>faSquareCaretLeft);
parcelHelpers.export(exports, "faCaretSquareLeft", ()=>faCaretSquareLeft);
parcelHelpers.export(exports, "faHighlighter", ()=>faHighlighter);
parcelHelpers.export(exports, "faKey", ()=>faKey);
parcelHelpers.export(exports, "faBullhorn", ()=>faBullhorn);
parcelHelpers.export(exports, "faGlobe", ()=>faGlobe);
parcelHelpers.export(exports, "faSynagogue", ()=>faSynagogue);
parcelHelpers.export(exports, "faPersonHalfDress", ()=>faPersonHalfDress);
parcelHelpers.export(exports, "faRoadBridge", ()=>faRoadBridge);
parcelHelpers.export(exports, "faLocationArrow", ()=>faLocationArrow);
parcelHelpers.export(exports, "faC", ()=>faC);
parcelHelpers.export(exports, "faTabletButton", ()=>faTabletButton);
parcelHelpers.export(exports, "faBuildingLock", ()=>faBuildingLock);
parcelHelpers.export(exports, "faPizzaSlice", ()=>faPizzaSlice);
parcelHelpers.export(exports, "faMoneyBillWave", ()=>faMoneyBillWave);
parcelHelpers.export(exports, "faChartArea", ()=>faChartArea);
parcelHelpers.export(exports, "faAreaChart", ()=>faAreaChart);
parcelHelpers.export(exports, "faHouseFlag", ()=>faHouseFlag);
parcelHelpers.export(exports, "faPersonCircleMinus", ()=>faPersonCircleMinus);
parcelHelpers.export(exports, "faBan", ()=>faBan);
parcelHelpers.export(exports, "faCancel", ()=>faCancel);
parcelHelpers.export(exports, "faCameraRotate", ()=>faCameraRotate);
parcelHelpers.export(exports, "faSprayCanSparkles", ()=>faSprayCanSparkles);
parcelHelpers.export(exports, "faAirFreshener", ()=>faAirFreshener);
parcelHelpers.export(exports, "faStar", ()=>faStar);
parcelHelpers.export(exports, "faRepeat", ()=>faRepeat);
parcelHelpers.export(exports, "faCross", ()=>faCross);
parcelHelpers.export(exports, "faBox", ()=>faBox);
parcelHelpers.export(exports, "faVenusMars", ()=>faVenusMars);
parcelHelpers.export(exports, "faArrowPointer", ()=>faArrowPointer);
parcelHelpers.export(exports, "faMousePointer", ()=>faMousePointer);
parcelHelpers.export(exports, "faMaximize", ()=>faMaximize);
parcelHelpers.export(exports, "faExpandArrowsAlt", ()=>faExpandArrowsAlt);
parcelHelpers.export(exports, "faChargingStation", ()=>faChargingStation);
parcelHelpers.export(exports, "faShapes", ()=>faShapes);
parcelHelpers.export(exports, "faTriangleCircleSquare", ()=>faTriangleCircleSquare);
parcelHelpers.export(exports, "faShuffle", ()=>faShuffle);
parcelHelpers.export(exports, "faRandom", ()=>faRandom);
parcelHelpers.export(exports, "faPersonRunning", ()=>faPersonRunning);
parcelHelpers.export(exports, "faRunning", ()=>faRunning);
parcelHelpers.export(exports, "faMobileRetro", ()=>faMobileRetro);
parcelHelpers.export(exports, "faGripLinesVertical", ()=>faGripLinesVertical);
parcelHelpers.export(exports, "faSpider", ()=>faSpider);
parcelHelpers.export(exports, "faHandsBound", ()=>faHandsBound);
parcelHelpers.export(exports, "faFileInvoiceDollar", ()=>faFileInvoiceDollar);
parcelHelpers.export(exports, "faPlaneCircleExclamation", ()=>faPlaneCircleExclamation);
parcelHelpers.export(exports, "faXRay", ()=>faXRay);
parcelHelpers.export(exports, "faSpellCheck", ()=>faSpellCheck);
parcelHelpers.export(exports, "faSlash", ()=>faSlash);
parcelHelpers.export(exports, "faComputerMouse", ()=>faComputerMouse);
parcelHelpers.export(exports, "faMouse", ()=>faMouse);
parcelHelpers.export(exports, "faArrowRightToBracket", ()=>faArrowRightToBracket);
parcelHelpers.export(exports, "faSignIn", ()=>faSignIn);
parcelHelpers.export(exports, "faShopSlash", ()=>faShopSlash);
parcelHelpers.export(exports, "faStoreAltSlash", ()=>faStoreAltSlash);
parcelHelpers.export(exports, "faServer", ()=>faServer);
parcelHelpers.export(exports, "faVirusCovidSlash", ()=>faVirusCovidSlash);
parcelHelpers.export(exports, "faShopLock", ()=>faShopLock);
parcelHelpers.export(exports, "faHourglassStart", ()=>faHourglassStart);
parcelHelpers.export(exports, "faHourglass1", ()=>faHourglass1);
parcelHelpers.export(exports, "faBlenderPhone", ()=>faBlenderPhone);
parcelHelpers.export(exports, "faBuildingWheat", ()=>faBuildingWheat);
parcelHelpers.export(exports, "faPersonBreastfeeding", ()=>faPersonBreastfeeding);
parcelHelpers.export(exports, "faRightToBracket", ()=>faRightToBracket);
parcelHelpers.export(exports, "faSignInAlt", ()=>faSignInAlt);
parcelHelpers.export(exports, "faVenus", ()=>faVenus);
parcelHelpers.export(exports, "faPassport", ()=>faPassport);
parcelHelpers.export(exports, "faHeartPulse", ()=>faHeartPulse);
parcelHelpers.export(exports, "faHeartbeat", ()=>faHeartbeat);
parcelHelpers.export(exports, "faPeopleCarryBox", ()=>faPeopleCarryBox);
parcelHelpers.export(exports, "faPeopleCarry", ()=>faPeopleCarry);
parcelHelpers.export(exports, "faTemperatureHigh", ()=>faTemperatureHigh);
parcelHelpers.export(exports, "faMicrochip", ()=>faMicrochip);
parcelHelpers.export(exports, "faCrown", ()=>faCrown);
parcelHelpers.export(exports, "faWeightHanging", ()=>faWeightHanging);
parcelHelpers.export(exports, "faXmarksLines", ()=>faXmarksLines);
parcelHelpers.export(exports, "faFilePrescription", ()=>faFilePrescription);
parcelHelpers.export(exports, "faWeightScale", ()=>faWeightScale);
parcelHelpers.export(exports, "faWeight", ()=>faWeight);
parcelHelpers.export(exports, "faUserGroup", ()=>faUserGroup);
parcelHelpers.export(exports, "faUserFriends", ()=>faUserFriends);
parcelHelpers.export(exports, "faArrowUpAZ", ()=>faArrowUpAZ);
parcelHelpers.export(exports, "faSortAlphaUp", ()=>faSortAlphaUp);
parcelHelpers.export(exports, "faChessKnight", ()=>faChessKnight);
parcelHelpers.export(exports, "faFaceLaughSquint", ()=>faFaceLaughSquint);
parcelHelpers.export(exports, "faLaughSquint", ()=>faLaughSquint);
parcelHelpers.export(exports, "faWheelchair", ()=>faWheelchair);
parcelHelpers.export(exports, "faCircleArrowUp", ()=>faCircleArrowUp);
parcelHelpers.export(exports, "faArrowCircleUp", ()=>faArrowCircleUp);
parcelHelpers.export(exports, "faToggleOn", ()=>faToggleOn);
parcelHelpers.export(exports, "faPersonWalking", ()=>faPersonWalking);
parcelHelpers.export(exports, "faWalking", ()=>faWalking);
parcelHelpers.export(exports, "faL", ()=>faL);
parcelHelpers.export(exports, "faFire", ()=>faFire);
parcelHelpers.export(exports, "faBedPulse", ()=>faBedPulse);
parcelHelpers.export(exports, "faProcedures", ()=>faProcedures);
parcelHelpers.export(exports, "faShuttleSpace", ()=>faShuttleSpace);
parcelHelpers.export(exports, "faSpaceShuttle", ()=>faSpaceShuttle);
parcelHelpers.export(exports, "faFaceLaugh", ()=>faFaceLaugh);
parcelHelpers.export(exports, "faLaugh", ()=>faLaugh);
parcelHelpers.export(exports, "faFolderOpen", ()=>faFolderOpen);
parcelHelpers.export(exports, "faHeartCirclePlus", ()=>faHeartCirclePlus);
parcelHelpers.export(exports, "faCodeFork", ()=>faCodeFork);
parcelHelpers.export(exports, "faCity", ()=>faCity);
parcelHelpers.export(exports, "faMicrophoneLines", ()=>faMicrophoneLines);
parcelHelpers.export(exports, "faMicrophoneAlt", ()=>faMicrophoneAlt);
parcelHelpers.export(exports, "faPepperHot", ()=>faPepperHot);
parcelHelpers.export(exports, "faUnlock", ()=>faUnlock);
parcelHelpers.export(exports, "faColonSign", ()=>faColonSign);
parcelHelpers.export(exports, "faHeadset", ()=>faHeadset);
parcelHelpers.export(exports, "faStoreSlash", ()=>faStoreSlash);
parcelHelpers.export(exports, "faRoadCircleXmark", ()=>faRoadCircleXmark);
parcelHelpers.export(exports, "faUserMinus", ()=>faUserMinus);
parcelHelpers.export(exports, "faMarsStrokeUp", ()=>faMarsStrokeUp);
parcelHelpers.export(exports, "faMarsStrokeV", ()=>faMarsStrokeV);
parcelHelpers.export(exports, "faChampagneGlasses", ()=>faChampagneGlasses);
parcelHelpers.export(exports, "faGlassCheers", ()=>faGlassCheers);
parcelHelpers.export(exports, "faClipboard", ()=>faClipboard);
parcelHelpers.export(exports, "faHouseCircleExclamation", ()=>faHouseCircleExclamation);
parcelHelpers.export(exports, "faFileArrowUp", ()=>faFileArrowUp);
parcelHelpers.export(exports, "faFileUpload", ()=>faFileUpload);
parcelHelpers.export(exports, "faWifi", ()=>faWifi);
parcelHelpers.export(exports, "faWifi3", ()=>faWifi3);
parcelHelpers.export(exports, "faWifiStrong", ()=>faWifiStrong);
parcelHelpers.export(exports, "faBath", ()=>faBath);
parcelHelpers.export(exports, "faBathtub", ()=>faBathtub);
parcelHelpers.export(exports, "faUnderline", ()=>faUnderline);
parcelHelpers.export(exports, "faUserPen", ()=>faUserPen);
parcelHelpers.export(exports, "faUserEdit", ()=>faUserEdit);
parcelHelpers.export(exports, "faSignature", ()=>faSignature);
parcelHelpers.export(exports, "faStroopwafel", ()=>faStroopwafel);
parcelHelpers.export(exports, "faBold", ()=>faBold);
parcelHelpers.export(exports, "faAnchorLock", ()=>faAnchorLock);
parcelHelpers.export(exports, "faBuildingNgo", ()=>faBuildingNgo);
parcelHelpers.export(exports, "faManatSign", ()=>faManatSign);
parcelHelpers.export(exports, "faNotEqual", ()=>faNotEqual);
parcelHelpers.export(exports, "faBorderTopLeft", ()=>faBorderTopLeft);
parcelHelpers.export(exports, "faBorderStyle", ()=>faBorderStyle);
parcelHelpers.export(exports, "faMapLocationDot", ()=>faMapLocationDot);
parcelHelpers.export(exports, "faMapMarkedAlt", ()=>faMapMarkedAlt);
parcelHelpers.export(exports, "faJedi", ()=>faJedi);
parcelHelpers.export(exports, "faSquarePollVertical", ()=>faSquarePollVertical);
parcelHelpers.export(exports, "faPoll", ()=>faPoll);
parcelHelpers.export(exports, "faMugHot", ()=>faMugHot);
parcelHelpers.export(exports, "faCarBattery", ()=>faCarBattery);
parcelHelpers.export(exports, "faBatteryCar", ()=>faBatteryCar);
parcelHelpers.export(exports, "faGift", ()=>faGift);
parcelHelpers.export(exports, "faDiceTwo", ()=>faDiceTwo);
parcelHelpers.export(exports, "faChessQueen", ()=>faChessQueen);
parcelHelpers.export(exports, "faGlasses", ()=>faGlasses);
parcelHelpers.export(exports, "faChessBoard", ()=>faChessBoard);
parcelHelpers.export(exports, "faBuildingCircleCheck", ()=>faBuildingCircleCheck);
parcelHelpers.export(exports, "faPersonChalkboard", ()=>faPersonChalkboard);
parcelHelpers.export(exports, "faMarsStrokeRight", ()=>faMarsStrokeRight);
parcelHelpers.export(exports, "faMarsStrokeH", ()=>faMarsStrokeH);
parcelHelpers.export(exports, "faHandBackFist", ()=>faHandBackFist);
parcelHelpers.export(exports, "faHandRock", ()=>faHandRock);
parcelHelpers.export(exports, "faSquareCaretUp", ()=>faSquareCaretUp);
parcelHelpers.export(exports, "faCaretSquareUp", ()=>faCaretSquareUp);
parcelHelpers.export(exports, "faCloudShowersWater", ()=>faCloudShowersWater);
parcelHelpers.export(exports, "faChartBar", ()=>faChartBar);
parcelHelpers.export(exports, "faBarChart", ()=>faBarChart);
parcelHelpers.export(exports, "faHandsBubbles", ()=>faHandsBubbles);
parcelHelpers.export(exports, "faHandsWash", ()=>faHandsWash);
parcelHelpers.export(exports, "faLessThanEqual", ()=>faLessThanEqual);
parcelHelpers.export(exports, "faTrain", ()=>faTrain);
parcelHelpers.export(exports, "faEyeLowVision", ()=>faEyeLowVision);
parcelHelpers.export(exports, "faLowVision", ()=>faLowVision);
parcelHelpers.export(exports, "faCrow", ()=>faCrow);
parcelHelpers.export(exports, "faSailboat", ()=>faSailboat);
parcelHelpers.export(exports, "faWindowRestore", ()=>faWindowRestore);
parcelHelpers.export(exports, "faSquarePlus", ()=>faSquarePlus);
parcelHelpers.export(exports, "faPlusSquare", ()=>faPlusSquare);
parcelHelpers.export(exports, "faToriiGate", ()=>faToriiGate);
parcelHelpers.export(exports, "faFrog", ()=>faFrog);
parcelHelpers.export(exports, "faBucket", ()=>faBucket);
parcelHelpers.export(exports, "faImage", ()=>faImage);
parcelHelpers.export(exports, "faMicrophone", ()=>faMicrophone);
parcelHelpers.export(exports, "faCow", ()=>faCow);
parcelHelpers.export(exports, "faCaretUp", ()=>faCaretUp);
parcelHelpers.export(exports, "faScrewdriver", ()=>faScrewdriver);
parcelHelpers.export(exports, "faFolderClosed", ()=>faFolderClosed);
parcelHelpers.export(exports, "faHouseTsunami", ()=>faHouseTsunami);
parcelHelpers.export(exports, "faSquareNfi", ()=>faSquareNfi);
parcelHelpers.export(exports, "faArrowUpFromGroundWater", ()=>faArrowUpFromGroundWater);
parcelHelpers.export(exports, "faMartiniGlass", ()=>faMartiniGlass);
parcelHelpers.export(exports, "faGlassMartiniAlt", ()=>faGlassMartiniAlt);
parcelHelpers.export(exports, "faRotateLeft", ()=>faRotateLeft);
parcelHelpers.export(exports, "faRotateBack", ()=>faRotateBack);
parcelHelpers.export(exports, "faRotateBackward", ()=>faRotateBackward);
parcelHelpers.export(exports, "faUndoAlt", ()=>faUndoAlt);
parcelHelpers.export(exports, "faTableColumns", ()=>faTableColumns);
parcelHelpers.export(exports, "faColumns", ()=>faColumns);
parcelHelpers.export(exports, "faLemon", ()=>faLemon);
parcelHelpers.export(exports, "faHeadSideMask", ()=>faHeadSideMask);
parcelHelpers.export(exports, "faHandshake", ()=>faHandshake);
parcelHelpers.export(exports, "faGem", ()=>faGem);
parcelHelpers.export(exports, "faDolly", ()=>faDolly);
parcelHelpers.export(exports, "faDollyBox", ()=>faDollyBox);
parcelHelpers.export(exports, "faSmoking", ()=>faSmoking);
parcelHelpers.export(exports, "faMinimize", ()=>faMinimize);
parcelHelpers.export(exports, "faCompressArrowsAlt", ()=>faCompressArrowsAlt);
parcelHelpers.export(exports, "faMonument", ()=>faMonument);
parcelHelpers.export(exports, "faSnowplow", ()=>faSnowplow);
parcelHelpers.export(exports, "faAnglesRight", ()=>faAnglesRight);
parcelHelpers.export(exports, "faAngleDoubleRight", ()=>faAngleDoubleRight);
parcelHelpers.export(exports, "faCannabis", ()=>faCannabis);
parcelHelpers.export(exports, "faCirclePlay", ()=>faCirclePlay);
parcelHelpers.export(exports, "faPlayCircle", ()=>faPlayCircle);
parcelHelpers.export(exports, "faTablets", ()=>faTablets);
parcelHelpers.export(exports, "faEthernet", ()=>faEthernet);
parcelHelpers.export(exports, "faEuroSign", ()=>faEuroSign);
parcelHelpers.export(exports, "faEur", ()=>faEur);
parcelHelpers.export(exports, "faEuro", ()=>faEuro);
parcelHelpers.export(exports, "faChair", ()=>faChair);
parcelHelpers.export(exports, "faCircleCheck", ()=>faCircleCheck);
parcelHelpers.export(exports, "faCheckCircle", ()=>faCheckCircle);
parcelHelpers.export(exports, "faCircleStop", ()=>faCircleStop);
parcelHelpers.export(exports, "faStopCircle", ()=>faStopCircle);
parcelHelpers.export(exports, "faCompassDrafting", ()=>faCompassDrafting);
parcelHelpers.export(exports, "faDraftingCompass", ()=>faDraftingCompass);
parcelHelpers.export(exports, "faPlateWheat", ()=>faPlateWheat);
parcelHelpers.export(exports, "faIcicles", ()=>faIcicles);
parcelHelpers.export(exports, "faPersonShelter", ()=>faPersonShelter);
parcelHelpers.export(exports, "faNeuter", ()=>faNeuter);
parcelHelpers.export(exports, "faIdBadge", ()=>faIdBadge);
parcelHelpers.export(exports, "faMarker", ()=>faMarker);
parcelHelpers.export(exports, "faFaceLaughBeam", ()=>faFaceLaughBeam);
parcelHelpers.export(exports, "faLaughBeam", ()=>faLaughBeam);
parcelHelpers.export(exports, "faHelicopterSymbol", ()=>faHelicopterSymbol);
parcelHelpers.export(exports, "faUniversalAccess", ()=>faUniversalAccess);
parcelHelpers.export(exports, "faCircleChevronUp", ()=>faCircleChevronUp);
parcelHelpers.export(exports, "faChevronCircleUp", ()=>faChevronCircleUp);
parcelHelpers.export(exports, "faLariSign", ()=>faLariSign);
parcelHelpers.export(exports, "faVolcano", ()=>faVolcano);
parcelHelpers.export(exports, "faPersonWalkingDashedLineArrowRight", ()=>faPersonWalkingDashedLineArrowRight);
parcelHelpers.export(exports, "faSterlingSign", ()=>faSterlingSign);
parcelHelpers.export(exports, "faGbp", ()=>faGbp);
parcelHelpers.export(exports, "faPoundSign", ()=>faPoundSign);
parcelHelpers.export(exports, "faViruses", ()=>faViruses);
parcelHelpers.export(exports, "faSquarePersonConfined", ()=>faSquarePersonConfined);
parcelHelpers.export(exports, "faUserTie", ()=>faUserTie);
parcelHelpers.export(exports, "faArrowDownLong", ()=>faArrowDownLong);
parcelHelpers.export(exports, "faLongArrowDown", ()=>faLongArrowDown);
parcelHelpers.export(exports, "faTentArrowDownToLine", ()=>faTentArrowDownToLine);
parcelHelpers.export(exports, "faCertificate", ()=>faCertificate);
parcelHelpers.export(exports, "faReplyAll", ()=>faReplyAll);
parcelHelpers.export(exports, "faMailReplyAll", ()=>faMailReplyAll);
parcelHelpers.export(exports, "faSuitcase", ()=>faSuitcase);
parcelHelpers.export(exports, "faPersonSkating", ()=>faPersonSkating);
parcelHelpers.export(exports, "faSkating", ()=>faSkating);
parcelHelpers.export(exports, "faFilterCircleDollar", ()=>faFilterCircleDollar);
parcelHelpers.export(exports, "faFunnelDollar", ()=>faFunnelDollar);
parcelHelpers.export(exports, "faCameraRetro", ()=>faCameraRetro);
parcelHelpers.export(exports, "faCircleArrowDown", ()=>faCircleArrowDown);
parcelHelpers.export(exports, "faArrowCircleDown", ()=>faArrowCircleDown);
parcelHelpers.export(exports, "faFileImport", ()=>faFileImport);
parcelHelpers.export(exports, "faArrowRightToFile", ()=>faArrowRightToFile);
parcelHelpers.export(exports, "faSquareArrowUpRight", ()=>faSquareArrowUpRight);
parcelHelpers.export(exports, "faExternalLinkSquare", ()=>faExternalLinkSquare);
parcelHelpers.export(exports, "faBoxOpen", ()=>faBoxOpen);
parcelHelpers.export(exports, "faScroll", ()=>faScroll);
parcelHelpers.export(exports, "faSpa", ()=>faSpa);
parcelHelpers.export(exports, "faLocationPinLock", ()=>faLocationPinLock);
parcelHelpers.export(exports, "faPause", ()=>faPause);
parcelHelpers.export(exports, "faHillAvalanche", ()=>faHillAvalanche);
parcelHelpers.export(exports, "faTemperatureEmpty", ()=>faTemperatureEmpty);
parcelHelpers.export(exports, "faTemperature0", ()=>faTemperature0);
parcelHelpers.export(exports, "faThermometer0", ()=>faThermometer0);
parcelHelpers.export(exports, "faThermometerEmpty", ()=>faThermometerEmpty);
parcelHelpers.export(exports, "faBomb", ()=>faBomb);
parcelHelpers.export(exports, "faRegistered", ()=>faRegistered);
parcelHelpers.export(exports, "faAddressCard", ()=>faAddressCard);
parcelHelpers.export(exports, "faContactCard", ()=>faContactCard);
parcelHelpers.export(exports, "faVcard", ()=>faVcard);
parcelHelpers.export(exports, "faScaleUnbalancedFlip", ()=>faScaleUnbalancedFlip);
parcelHelpers.export(exports, "faBalanceScaleRight", ()=>faBalanceScaleRight);
parcelHelpers.export(exports, "faSubscript", ()=>faSubscript);
parcelHelpers.export(exports, "faDiamondTurnRight", ()=>faDiamondTurnRight);
parcelHelpers.export(exports, "faDirections", ()=>faDirections);
parcelHelpers.export(exports, "faBurst", ()=>faBurst);
parcelHelpers.export(exports, "faHouseLaptop", ()=>faHouseLaptop);
parcelHelpers.export(exports, "faLaptopHouse", ()=>faLaptopHouse);
parcelHelpers.export(exports, "faFaceTired", ()=>faFaceTired);
parcelHelpers.export(exports, "faTired", ()=>faTired);
parcelHelpers.export(exports, "faMoneyBills", ()=>faMoneyBills);
parcelHelpers.export(exports, "faSmog", ()=>faSmog);
parcelHelpers.export(exports, "faCrutch", ()=>faCrutch);
parcelHelpers.export(exports, "faFontAwesome", ()=>faFontAwesome);
parcelHelpers.export(exports, "faFontAwesomeFlag", ()=>faFontAwesomeFlag);
parcelHelpers.export(exports, "faFontAwesomeLogoFull", ()=>faFontAwesomeLogoFull);
parcelHelpers.export(exports, "faCloudArrowUp", ()=>faCloudArrowUp);
parcelHelpers.export(exports, "faCloudUpload", ()=>faCloudUpload);
parcelHelpers.export(exports, "faCloudUploadAlt", ()=>faCloudUploadAlt);
parcelHelpers.export(exports, "faPalette", ()=>faPalette);
parcelHelpers.export(exports, "faArrowsTurnRight", ()=>faArrowsTurnRight);
parcelHelpers.export(exports, "faVest", ()=>faVest);
parcelHelpers.export(exports, "faFerry", ()=>faFerry);
parcelHelpers.export(exports, "faArrowsDownToPeople", ()=>faArrowsDownToPeople);
parcelHelpers.export(exports, "faSeedling", ()=>faSeedling);
parcelHelpers.export(exports, "faSprout", ()=>faSprout);
parcelHelpers.export(exports, "faLeftRight", ()=>faLeftRight);
parcelHelpers.export(exports, "faArrowsAltH", ()=>faArrowsAltH);
parcelHelpers.export(exports, "faBoxesPacking", ()=>faBoxesPacking);
parcelHelpers.export(exports, "faCircleArrowLeft", ()=>faCircleArrowLeft);
parcelHelpers.export(exports, "faArrowCircleLeft", ()=>faArrowCircleLeft);
parcelHelpers.export(exports, "faGroupArrowsRotate", ()=>faGroupArrowsRotate);
parcelHelpers.export(exports, "faBowlFood", ()=>faBowlFood);
parcelHelpers.export(exports, "faCandyCane", ()=>faCandyCane);
parcelHelpers.export(exports, "faArrowDownWideShort", ()=>faArrowDownWideShort);
parcelHelpers.export(exports, "faSortAmountAsc", ()=>faSortAmountAsc);
parcelHelpers.export(exports, "faSortAmountDown", ()=>faSortAmountDown);
parcelHelpers.export(exports, "faCloudBolt", ()=>faCloudBolt);
parcelHelpers.export(exports, "faThunderstorm", ()=>faThunderstorm);
parcelHelpers.export(exports, "faTextSlash", ()=>faTextSlash);
parcelHelpers.export(exports, "faRemoveFormat", ()=>faRemoveFormat);
parcelHelpers.export(exports, "faFaceSmileWink", ()=>faFaceSmileWink);
parcelHelpers.export(exports, "faSmileWink", ()=>faSmileWink);
parcelHelpers.export(exports, "faFileWord", ()=>faFileWord);
parcelHelpers.export(exports, "faFilePowerpoint", ()=>faFilePowerpoint);
parcelHelpers.export(exports, "faArrowsLeftRight", ()=>faArrowsLeftRight);
parcelHelpers.export(exports, "faArrowsH", ()=>faArrowsH);
parcelHelpers.export(exports, "faHouseLock", ()=>faHouseLock);
parcelHelpers.export(exports, "faCloudArrowDown", ()=>faCloudArrowDown);
parcelHelpers.export(exports, "faCloudDownload", ()=>faCloudDownload);
parcelHelpers.export(exports, "faCloudDownloadAlt", ()=>faCloudDownloadAlt);
parcelHelpers.export(exports, "faChildren", ()=>faChildren);
parcelHelpers.export(exports, "faChalkboard", ()=>faChalkboard);
parcelHelpers.export(exports, "faBlackboard", ()=>faBlackboard);
parcelHelpers.export(exports, "faUserLargeSlash", ()=>faUserLargeSlash);
parcelHelpers.export(exports, "faUserAltSlash", ()=>faUserAltSlash);
parcelHelpers.export(exports, "faEnvelopeOpen", ()=>faEnvelopeOpen);
parcelHelpers.export(exports, "faHandshakeSimpleSlash", ()=>faHandshakeSimpleSlash);
parcelHelpers.export(exports, "faHandshakeAltSlash", ()=>faHandshakeAltSlash);
parcelHelpers.export(exports, "faMattressPillow", ()=>faMattressPillow);
parcelHelpers.export(exports, "faGuaraniSign", ()=>faGuaraniSign);
parcelHelpers.export(exports, "faArrowsRotate", ()=>faArrowsRotate);
parcelHelpers.export(exports, "faRefresh", ()=>faRefresh);
parcelHelpers.export(exports, "faSync", ()=>faSync);
parcelHelpers.export(exports, "faFireExtinguisher", ()=>faFireExtinguisher);
parcelHelpers.export(exports, "faCruzeiroSign", ()=>faCruzeiroSign);
parcelHelpers.export(exports, "faGreaterThanEqual", ()=>faGreaterThanEqual);
parcelHelpers.export(exports, "faShieldHalved", ()=>faShieldHalved);
parcelHelpers.export(exports, "faShieldAlt", ()=>faShieldAlt);
parcelHelpers.export(exports, "faBookAtlas", ()=>faBookAtlas);
parcelHelpers.export(exports, "faAtlas", ()=>faAtlas);
parcelHelpers.export(exports, "faVirus", ()=>faVirus);
parcelHelpers.export(exports, "faEnvelopeCircleCheck", ()=>faEnvelopeCircleCheck);
parcelHelpers.export(exports, "faLayerGroup", ()=>faLayerGroup);
parcelHelpers.export(exports, "faArrowsToDot", ()=>faArrowsToDot);
parcelHelpers.export(exports, "faArchway", ()=>faArchway);
parcelHelpers.export(exports, "faHeartCircleCheck", ()=>faHeartCircleCheck);
parcelHelpers.export(exports, "faHouseChimneyCrack", ()=>faHouseChimneyCrack);
parcelHelpers.export(exports, "faHouseDamage", ()=>faHouseDamage);
parcelHelpers.export(exports, "faFileZipper", ()=>faFileZipper);
parcelHelpers.export(exports, "faFileArchive", ()=>faFileArchive);
parcelHelpers.export(exports, "faSquare", ()=>faSquare);
parcelHelpers.export(exports, "faMartiniGlassEmpty", ()=>faMartiniGlassEmpty);
parcelHelpers.export(exports, "faGlassMartini", ()=>faGlassMartini);
parcelHelpers.export(exports, "faCouch", ()=>faCouch);
parcelHelpers.export(exports, "faCediSign", ()=>faCediSign);
parcelHelpers.export(exports, "faItalic", ()=>faItalic);
parcelHelpers.export(exports, "faChurch", ()=>faChurch);
parcelHelpers.export(exports, "faCommentsDollar", ()=>faCommentsDollar);
parcelHelpers.export(exports, "faDemocrat", ()=>faDemocrat);
parcelHelpers.export(exports, "faZ", ()=>faZ);
parcelHelpers.export(exports, "faPersonSkiing", ()=>faPersonSkiing);
parcelHelpers.export(exports, "faSkiing", ()=>faSkiing);
parcelHelpers.export(exports, "faRoadLock", ()=>faRoadLock);
parcelHelpers.export(exports, "faA", ()=>faA);
parcelHelpers.export(exports, "faTemperatureArrowDown", ()=>faTemperatureArrowDown);
parcelHelpers.export(exports, "faTemperatureDown", ()=>faTemperatureDown);
parcelHelpers.export(exports, "faFeatherPointed", ()=>faFeatherPointed);
parcelHelpers.export(exports, "faFeatherAlt", ()=>faFeatherAlt);
parcelHelpers.export(exports, "faP", ()=>faP);
parcelHelpers.export(exports, "faSnowflake", ()=>faSnowflake);
parcelHelpers.export(exports, "faNewspaper", ()=>faNewspaper);
parcelHelpers.export(exports, "faRectangleAd", ()=>faRectangleAd);
parcelHelpers.export(exports, "faAd", ()=>faAd);
parcelHelpers.export(exports, "faCircleArrowRight", ()=>faCircleArrowRight);
parcelHelpers.export(exports, "faArrowCircleRight", ()=>faArrowCircleRight);
parcelHelpers.export(exports, "faFilterCircleXmark", ()=>faFilterCircleXmark);
parcelHelpers.export(exports, "faLocust", ()=>faLocust);
parcelHelpers.export(exports, "faSort", ()=>faSort);
parcelHelpers.export(exports, "faUnsorted", ()=>faUnsorted);
parcelHelpers.export(exports, "faListOl", ()=>faListOl);
parcelHelpers.export(exports, "faList12", ()=>faList12);
parcelHelpers.export(exports, "faListNumeric", ()=>faListNumeric);
parcelHelpers.export(exports, "faPersonDressBurst", ()=>faPersonDressBurst);
parcelHelpers.export(exports, "faMoneyCheckDollar", ()=>faMoneyCheckDollar);
parcelHelpers.export(exports, "faMoneyCheckAlt", ()=>faMoneyCheckAlt);
parcelHelpers.export(exports, "faVectorSquare", ()=>faVectorSquare);
parcelHelpers.export(exports, "faBreadSlice", ()=>faBreadSlice);
parcelHelpers.export(exports, "faLanguage", ()=>faLanguage);
parcelHelpers.export(exports, "faFaceKissWinkHeart", ()=>faFaceKissWinkHeart);
parcelHelpers.export(exports, "faKissWinkHeart", ()=>faKissWinkHeart);
parcelHelpers.export(exports, "faFilter", ()=>faFilter);
parcelHelpers.export(exports, "faQuestion", ()=>faQuestion);
parcelHelpers.export(exports, "faFileSignature", ()=>faFileSignature);
parcelHelpers.export(exports, "faUpDownLeftRight", ()=>faUpDownLeftRight);
parcelHelpers.export(exports, "faArrowsAlt", ()=>faArrowsAlt);
parcelHelpers.export(exports, "faHouseChimneyUser", ()=>faHouseChimneyUser);
parcelHelpers.export(exports, "faHandHoldingHeart", ()=>faHandHoldingHeart);
parcelHelpers.export(exports, "faPuzzlePiece", ()=>faPuzzlePiece);
parcelHelpers.export(exports, "faMoneyCheck", ()=>faMoneyCheck);
parcelHelpers.export(exports, "faStarHalfStroke", ()=>faStarHalfStroke);
parcelHelpers.export(exports, "faStarHalfAlt", ()=>faStarHalfAlt);
parcelHelpers.export(exports, "faCode", ()=>faCode);
parcelHelpers.export(exports, "faWhiskeyGlass", ()=>faWhiskeyGlass);
parcelHelpers.export(exports, "faGlassWhiskey", ()=>faGlassWhiskey);
parcelHelpers.export(exports, "faBuildingCircleExclamation", ()=>faBuildingCircleExclamation);
parcelHelpers.export(exports, "faMagnifyingGlassChart", ()=>faMagnifyingGlassChart);
parcelHelpers.export(exports, "faArrowUpRightFromSquare", ()=>faArrowUpRightFromSquare);
parcelHelpers.export(exports, "faExternalLink", ()=>faExternalLink);
parcelHelpers.export(exports, "faCubesStacked", ()=>faCubesStacked);
parcelHelpers.export(exports, "faWonSign", ()=>faWonSign);
parcelHelpers.export(exports, "faKrw", ()=>faKrw);
parcelHelpers.export(exports, "faWon", ()=>faWon);
parcelHelpers.export(exports, "faVirusCovid", ()=>faVirusCovid);
parcelHelpers.export(exports, "faAustralSign", ()=>faAustralSign);
parcelHelpers.export(exports, "faF", ()=>faF);
parcelHelpers.export(exports, "faLeaf", ()=>faLeaf);
parcelHelpers.export(exports, "faRoad", ()=>faRoad);
parcelHelpers.export(exports, "faTaxi", ()=>faTaxi);
parcelHelpers.export(exports, "faCab", ()=>faCab);
parcelHelpers.export(exports, "faPersonCirclePlus", ()=>faPersonCirclePlus);
parcelHelpers.export(exports, "faChartPie", ()=>faChartPie);
parcelHelpers.export(exports, "faPieChart", ()=>faPieChart);
parcelHelpers.export(exports, "faBoltLightning", ()=>faBoltLightning);
parcelHelpers.export(exports, "faSackXmark", ()=>faSackXmark);
parcelHelpers.export(exports, "faFileExcel", ()=>faFileExcel);
parcelHelpers.export(exports, "faFileContract", ()=>faFileContract);
parcelHelpers.export(exports, "faFishFins", ()=>faFishFins);
parcelHelpers.export(exports, "faBuildingFlag", ()=>faBuildingFlag);
parcelHelpers.export(exports, "faFaceGrinBeam", ()=>faFaceGrinBeam);
parcelHelpers.export(exports, "faGrinBeam", ()=>faGrinBeam);
parcelHelpers.export(exports, "faObjectUngroup", ()=>faObjectUngroup);
parcelHelpers.export(exports, "faPoop", ()=>faPoop);
parcelHelpers.export(exports, "faLocationPin", ()=>faLocationPin);
parcelHelpers.export(exports, "faMapMarker", ()=>faMapMarker);
parcelHelpers.export(exports, "faKaaba", ()=>faKaaba);
parcelHelpers.export(exports, "faToiletPaper", ()=>faToiletPaper);
parcelHelpers.export(exports, "faHelmetSafety", ()=>faHelmetSafety);
parcelHelpers.export(exports, "faHardHat", ()=>faHardHat);
parcelHelpers.export(exports, "faHatHard", ()=>faHatHard);
parcelHelpers.export(exports, "faEject", ()=>faEject);
parcelHelpers.export(exports, "faCircleRight", ()=>faCircleRight);
parcelHelpers.export(exports, "faArrowAltCircleRight", ()=>faArrowAltCircleRight);
parcelHelpers.export(exports, "faPlaneCircleCheck", ()=>faPlaneCircleCheck);
parcelHelpers.export(exports, "faFaceRollingEyes", ()=>faFaceRollingEyes);
parcelHelpers.export(exports, "faMehRollingEyes", ()=>faMehRollingEyes);
parcelHelpers.export(exports, "faObjectGroup", ()=>faObjectGroup);
parcelHelpers.export(exports, "faChartLine", ()=>faChartLine);
parcelHelpers.export(exports, "faLineChart", ()=>faLineChart);
parcelHelpers.export(exports, "faMaskVentilator", ()=>faMaskVentilator);
parcelHelpers.export(exports, "faArrowRight", ()=>faArrowRight);
parcelHelpers.export(exports, "faSignsPost", ()=>faSignsPost);
parcelHelpers.export(exports, "faMapSigns", ()=>faMapSigns);
parcelHelpers.export(exports, "faCashRegister", ()=>faCashRegister);
parcelHelpers.export(exports, "faPersonCircleQuestion", ()=>faPersonCircleQuestion);
parcelHelpers.export(exports, "faH", ()=>faH);
parcelHelpers.export(exports, "faTarp", ()=>faTarp);
parcelHelpers.export(exports, "faScrewdriverWrench", ()=>faScrewdriverWrench);
parcelHelpers.export(exports, "faTools", ()=>faTools);
parcelHelpers.export(exports, "faArrowsToEye", ()=>faArrowsToEye);
parcelHelpers.export(exports, "faPlugCircleBolt", ()=>faPlugCircleBolt);
parcelHelpers.export(exports, "faHeart", ()=>faHeart);
parcelHelpers.export(exports, "faMarsAndVenus", ()=>faMarsAndVenus);
parcelHelpers.export(exports, "faHouseUser", ()=>faHouseUser);
parcelHelpers.export(exports, "faHomeUser", ()=>faHomeUser);
parcelHelpers.export(exports, "faDumpsterFire", ()=>faDumpsterFire);
parcelHelpers.export(exports, "faHouseCrack", ()=>faHouseCrack);
parcelHelpers.export(exports, "faMartiniGlassCitrus", ()=>faMartiniGlassCitrus);
parcelHelpers.export(exports, "faCocktail", ()=>faCocktail);
parcelHelpers.export(exports, "faFaceSurprise", ()=>faFaceSurprise);
parcelHelpers.export(exports, "faSurprise", ()=>faSurprise);
parcelHelpers.export(exports, "faBottleWater", ()=>faBottleWater);
parcelHelpers.export(exports, "faCirclePause", ()=>faCirclePause);
parcelHelpers.export(exports, "faPauseCircle", ()=>faPauseCircle);
parcelHelpers.export(exports, "faToiletPaperSlash", ()=>faToiletPaperSlash);
parcelHelpers.export(exports, "faAppleWhole", ()=>faAppleWhole);
parcelHelpers.export(exports, "faAppleAlt", ()=>faAppleAlt);
parcelHelpers.export(exports, "faKitchenSet", ()=>faKitchenSet);
parcelHelpers.export(exports, "faR", ()=>faR);
parcelHelpers.export(exports, "faTemperatureQuarter", ()=>faTemperatureQuarter);
parcelHelpers.export(exports, "faTemperature1", ()=>faTemperature1);
parcelHelpers.export(exports, "faThermometer1", ()=>faThermometer1);
parcelHelpers.export(exports, "faThermometerQuarter", ()=>faThermometerQuarter);
parcelHelpers.export(exports, "faCube", ()=>faCube);
parcelHelpers.export(exports, "faBitcoinSign", ()=>faBitcoinSign);
parcelHelpers.export(exports, "faShieldDog", ()=>faShieldDog);
parcelHelpers.export(exports, "faSolarPanel", ()=>faSolarPanel);
parcelHelpers.export(exports, "faLockOpen", ()=>faLockOpen);
parcelHelpers.export(exports, "faElevator", ()=>faElevator);
parcelHelpers.export(exports, "faMoneyBillTransfer", ()=>faMoneyBillTransfer);
parcelHelpers.export(exports, "faMoneyBillTrendUp", ()=>faMoneyBillTrendUp);
parcelHelpers.export(exports, "faHouseFloodWaterCircleArrowRight", ()=>faHouseFloodWaterCircleArrowRight);
parcelHelpers.export(exports, "faSquarePollHorizontal", ()=>faSquarePollHorizontal);
parcelHelpers.export(exports, "faPollH", ()=>faPollH);
parcelHelpers.export(exports, "faCircle", ()=>faCircle);
parcelHelpers.export(exports, "faBackwardFast", ()=>faBackwardFast);
parcelHelpers.export(exports, "faFastBackward", ()=>faFastBackward);
parcelHelpers.export(exports, "faRecycle", ()=>faRecycle);
parcelHelpers.export(exports, "faUserAstronaut", ()=>faUserAstronaut);
parcelHelpers.export(exports, "faPlaneSlash", ()=>faPlaneSlash);
parcelHelpers.export(exports, "faTrademark", ()=>faTrademark);
parcelHelpers.export(exports, "faBasketball", ()=>faBasketball);
parcelHelpers.export(exports, "faBasketballBall", ()=>faBasketballBall);
parcelHelpers.export(exports, "faSatelliteDish", ()=>faSatelliteDish);
parcelHelpers.export(exports, "faCircleUp", ()=>faCircleUp);
parcelHelpers.export(exports, "faArrowAltCircleUp", ()=>faArrowAltCircleUp);
parcelHelpers.export(exports, "faMobileScreenButton", ()=>faMobileScreenButton);
parcelHelpers.export(exports, "faMobileAlt", ()=>faMobileAlt);
parcelHelpers.export(exports, "faVolumeHigh", ()=>faVolumeHigh);
parcelHelpers.export(exports, "faVolumeUp", ()=>faVolumeUp);
parcelHelpers.export(exports, "faUsersRays", ()=>faUsersRays);
parcelHelpers.export(exports, "faWallet", ()=>faWallet);
parcelHelpers.export(exports, "faClipboardCheck", ()=>faClipboardCheck);
parcelHelpers.export(exports, "faFileAudio", ()=>faFileAudio);
parcelHelpers.export(exports, "faBurger", ()=>faBurger);
parcelHelpers.export(exports, "faHamburger", ()=>faHamburger);
parcelHelpers.export(exports, "faWrench", ()=>faWrench);
parcelHelpers.export(exports, "faBugs", ()=>faBugs);
parcelHelpers.export(exports, "faRupeeSign", ()=>faRupeeSign);
parcelHelpers.export(exports, "faRupee", ()=>faRupee);
parcelHelpers.export(exports, "faFileImage", ()=>faFileImage);
parcelHelpers.export(exports, "faCircleQuestion", ()=>faCircleQuestion);
parcelHelpers.export(exports, "faQuestionCircle", ()=>faQuestionCircle);
parcelHelpers.export(exports, "faPlaneDeparture", ()=>faPlaneDeparture);
parcelHelpers.export(exports, "faHandshakeSlash", ()=>faHandshakeSlash);
parcelHelpers.export(exports, "faBookBookmark", ()=>faBookBookmark);
parcelHelpers.export(exports, "faCodeBranch", ()=>faCodeBranch);
parcelHelpers.export(exports, "faHatCowboy", ()=>faHatCowboy);
parcelHelpers.export(exports, "faBridge", ()=>faBridge);
parcelHelpers.export(exports, "faPhoneFlip", ()=>faPhoneFlip);
parcelHelpers.export(exports, "faPhoneAlt", ()=>faPhoneAlt);
parcelHelpers.export(exports, "faTruckFront", ()=>faTruckFront);
parcelHelpers.export(exports, "faCat", ()=>faCat);
parcelHelpers.export(exports, "faAnchorCircleExclamation", ()=>faAnchorCircleExclamation);
parcelHelpers.export(exports, "faTruckField", ()=>faTruckField);
parcelHelpers.export(exports, "faRoute", ()=>faRoute);
parcelHelpers.export(exports, "faClipboardQuestion", ()=>faClipboardQuestion);
parcelHelpers.export(exports, "faPanorama", ()=>faPanorama);
parcelHelpers.export(exports, "faCommentMedical", ()=>faCommentMedical);
parcelHelpers.export(exports, "faTeethOpen", ()=>faTeethOpen);
parcelHelpers.export(exports, "faFileCircleMinus", ()=>faFileCircleMinus);
parcelHelpers.export(exports, "faTags", ()=>faTags);
parcelHelpers.export(exports, "faWineGlass", ()=>faWineGlass);
parcelHelpers.export(exports, "faForwardFast", ()=>faForwardFast);
parcelHelpers.export(exports, "faFastForward", ()=>faFastForward);
parcelHelpers.export(exports, "faFaceMehBlank", ()=>faFaceMehBlank);
parcelHelpers.export(exports, "faMehBlank", ()=>faMehBlank);
parcelHelpers.export(exports, "faSquareParking", ()=>faSquareParking);
parcelHelpers.export(exports, "faParking", ()=>faParking);
parcelHelpers.export(exports, "faHouseSignal", ()=>faHouseSignal);
parcelHelpers.export(exports, "faBarsProgress", ()=>faBarsProgress);
parcelHelpers.export(exports, "faTasksAlt", ()=>faTasksAlt);
parcelHelpers.export(exports, "faFaucetDrip", ()=>faFaucetDrip);
parcelHelpers.export(exports, "faCartFlatbed", ()=>faCartFlatbed);
parcelHelpers.export(exports, "faDollyFlatbed", ()=>faDollyFlatbed);
parcelHelpers.export(exports, "faBanSmoking", ()=>faBanSmoking);
parcelHelpers.export(exports, "faSmokingBan", ()=>faSmokingBan);
parcelHelpers.export(exports, "faTerminal", ()=>faTerminal);
parcelHelpers.export(exports, "faMobileButton", ()=>faMobileButton);
parcelHelpers.export(exports, "faHouseMedicalFlag", ()=>faHouseMedicalFlag);
parcelHelpers.export(exports, "faBasketShopping", ()=>faBasketShopping);
parcelHelpers.export(exports, "faShoppingBasket", ()=>faShoppingBasket);
parcelHelpers.export(exports, "faTape", ()=>faTape);
parcelHelpers.export(exports, "faBusSimple", ()=>faBusSimple);
parcelHelpers.export(exports, "faBusAlt", ()=>faBusAlt);
parcelHelpers.export(exports, "faEye", ()=>faEye);
parcelHelpers.export(exports, "faFaceSadCry", ()=>faFaceSadCry);
parcelHelpers.export(exports, "faSadCry", ()=>faSadCry);
parcelHelpers.export(exports, "faAudioDescription", ()=>faAudioDescription);
parcelHelpers.export(exports, "faPersonMilitaryToPerson", ()=>faPersonMilitaryToPerson);
parcelHelpers.export(exports, "faFileShield", ()=>faFileShield);
parcelHelpers.export(exports, "faUserSlash", ()=>faUserSlash);
parcelHelpers.export(exports, "faPen", ()=>faPen);
parcelHelpers.export(exports, "faTowerObservation", ()=>faTowerObservation);
parcelHelpers.export(exports, "faFileCode", ()=>faFileCode);
parcelHelpers.export(exports, "faSignal", ()=>faSignal);
parcelHelpers.export(exports, "faSignal5", ()=>faSignal5);
parcelHelpers.export(exports, "faSignalPerfect", ()=>faSignalPerfect);
parcelHelpers.export(exports, "faBus", ()=>faBus);
parcelHelpers.export(exports, "faHeartCircleXmark", ()=>faHeartCircleXmark);
parcelHelpers.export(exports, "faHouseChimney", ()=>faHouseChimney);
parcelHelpers.export(exports, "faHomeLg", ()=>faHomeLg);
parcelHelpers.export(exports, "faWindowMaximize", ()=>faWindowMaximize);
parcelHelpers.export(exports, "faFaceFrown", ()=>faFaceFrown);
parcelHelpers.export(exports, "faFrown", ()=>faFrown);
parcelHelpers.export(exports, "faPrescription", ()=>faPrescription);
parcelHelpers.export(exports, "faShop", ()=>faShop);
parcelHelpers.export(exports, "faStoreAlt", ()=>faStoreAlt);
parcelHelpers.export(exports, "faFloppyDisk", ()=>faFloppyDisk);
parcelHelpers.export(exports, "faSave", ()=>faSave);
parcelHelpers.export(exports, "faVihara", ()=>faVihara);
parcelHelpers.export(exports, "faScaleUnbalanced", ()=>faScaleUnbalanced);
parcelHelpers.export(exports, "faBalanceScaleLeft", ()=>faBalanceScaleLeft);
parcelHelpers.export(exports, "faSortUp", ()=>faSortUp);
parcelHelpers.export(exports, "faSortAsc", ()=>faSortAsc);
parcelHelpers.export(exports, "faCommentDots", ()=>faCommentDots);
parcelHelpers.export(exports, "faCommenting", ()=>faCommenting);
parcelHelpers.export(exports, "faPlantWilt", ()=>faPlantWilt);
parcelHelpers.export(exports, "faDiamond", ()=>faDiamond);
parcelHelpers.export(exports, "faFaceGrinSquint", ()=>faFaceGrinSquint);
parcelHelpers.export(exports, "faGrinSquint", ()=>faGrinSquint);
parcelHelpers.export(exports, "faHandHoldingDollar", ()=>faHandHoldingDollar);
parcelHelpers.export(exports, "faHandHoldingUsd", ()=>faHandHoldingUsd);
parcelHelpers.export(exports, "faBacterium", ()=>faBacterium);
parcelHelpers.export(exports, "faHandPointer", ()=>faHandPointer);
parcelHelpers.export(exports, "faDrumSteelpan", ()=>faDrumSteelpan);
parcelHelpers.export(exports, "faHandScissors", ()=>faHandScissors);
parcelHelpers.export(exports, "faHandsPraying", ()=>faHandsPraying);
parcelHelpers.export(exports, "faPrayingHands", ()=>faPrayingHands);
parcelHelpers.export(exports, "faArrowRotateRight", ()=>faArrowRotateRight);
parcelHelpers.export(exports, "faArrowRightRotate", ()=>faArrowRightRotate);
parcelHelpers.export(exports, "faArrowRotateForward", ()=>faArrowRotateForward);
parcelHelpers.export(exports, "faRedo", ()=>faRedo);
parcelHelpers.export(exports, "faBiohazard", ()=>faBiohazard);
parcelHelpers.export(exports, "faLocationCrosshairs", ()=>faLocationCrosshairs);
parcelHelpers.export(exports, "faLocation", ()=>faLocation);
parcelHelpers.export(exports, "faMarsDouble", ()=>faMarsDouble);
parcelHelpers.export(exports, "faChildDress", ()=>faChildDress);
parcelHelpers.export(exports, "faUsersBetweenLines", ()=>faUsersBetweenLines);
parcelHelpers.export(exports, "faLungsVirus", ()=>faLungsVirus);
parcelHelpers.export(exports, "faFaceGrinTears", ()=>faFaceGrinTears);
parcelHelpers.export(exports, "faGrinTears", ()=>faGrinTears);
parcelHelpers.export(exports, "faPhone", ()=>faPhone);
parcelHelpers.export(exports, "faCalendarXmark", ()=>faCalendarXmark);
parcelHelpers.export(exports, "faCalendarTimes", ()=>faCalendarTimes);
parcelHelpers.export(exports, "faChildReaching", ()=>faChildReaching);
parcelHelpers.export(exports, "faHeadSideVirus", ()=>faHeadSideVirus);
parcelHelpers.export(exports, "faUserGear", ()=>faUserGear);
parcelHelpers.export(exports, "faUserCog", ()=>faUserCog);
parcelHelpers.export(exports, "faArrowUp19", ()=>faArrowUp19);
parcelHelpers.export(exports, "faSortNumericUp", ()=>faSortNumericUp);
parcelHelpers.export(exports, "faDoorClosed", ()=>faDoorClosed);
parcelHelpers.export(exports, "faShieldVirus", ()=>faShieldVirus);
parcelHelpers.export(exports, "faDiceSix", ()=>faDiceSix);
parcelHelpers.export(exports, "faMosquitoNet", ()=>faMosquitoNet);
parcelHelpers.export(exports, "faBridgeWater", ()=>faBridgeWater);
parcelHelpers.export(exports, "faPersonBooth", ()=>faPersonBooth);
parcelHelpers.export(exports, "faTextWidth", ()=>faTextWidth);
parcelHelpers.export(exports, "faHatWizard", ()=>faHatWizard);
parcelHelpers.export(exports, "faPenFancy", ()=>faPenFancy);
parcelHelpers.export(exports, "faPersonDigging", ()=>faPersonDigging);
parcelHelpers.export(exports, "faDigging", ()=>faDigging);
parcelHelpers.export(exports, "faTrash", ()=>faTrash);
parcelHelpers.export(exports, "faGaugeSimple", ()=>faGaugeSimple);
parcelHelpers.export(exports, "faGaugeSimpleMed", ()=>faGaugeSimpleMed);
parcelHelpers.export(exports, "faTachometerAverage", ()=>faTachometerAverage);
parcelHelpers.export(exports, "faBookMedical", ()=>faBookMedical);
parcelHelpers.export(exports, "faPoo", ()=>faPoo);
parcelHelpers.export(exports, "faQuoteRight", ()=>faQuoteRight);
parcelHelpers.export(exports, "faQuoteRightAlt", ()=>faQuoteRightAlt);
parcelHelpers.export(exports, "faShirt", ()=>faShirt);
parcelHelpers.export(exports, "faTShirt", ()=>faTShirt);
parcelHelpers.export(exports, "faTshirt", ()=>faTshirt);
parcelHelpers.export(exports, "faCubes", ()=>faCubes);
parcelHelpers.export(exports, "faDivide", ()=>faDivide);
parcelHelpers.export(exports, "faTengeSign", ()=>faTengeSign);
parcelHelpers.export(exports, "faTenge", ()=>faTenge);
parcelHelpers.export(exports, "faHeadphones", ()=>faHeadphones);
parcelHelpers.export(exports, "faHandsHolding", ()=>faHandsHolding);
parcelHelpers.export(exports, "faHandsClapping", ()=>faHandsClapping);
parcelHelpers.export(exports, "faRepublican", ()=>faRepublican);
parcelHelpers.export(exports, "faArrowLeft", ()=>faArrowLeft);
parcelHelpers.export(exports, "faPersonCircleXmark", ()=>faPersonCircleXmark);
parcelHelpers.export(exports, "faRuler", ()=>faRuler);
parcelHelpers.export(exports, "faAlignLeft", ()=>faAlignLeft);
parcelHelpers.export(exports, "faDiceD6", ()=>faDiceD6);
parcelHelpers.export(exports, "faRestroom", ()=>faRestroom);
parcelHelpers.export(exports, "faJ", ()=>faJ);
parcelHelpers.export(exports, "faUsersViewfinder", ()=>faUsersViewfinder);
parcelHelpers.export(exports, "faFileVideo", ()=>faFileVideo);
parcelHelpers.export(exports, "faUpRightFromSquare", ()=>faUpRightFromSquare);
parcelHelpers.export(exports, "faExternalLinkAlt", ()=>faExternalLinkAlt);
parcelHelpers.export(exports, "faTableCells", ()=>faTableCells);
parcelHelpers.export(exports, "faTh", ()=>faTh);
parcelHelpers.export(exports, "faFilePdf", ()=>faFilePdf);
parcelHelpers.export(exports, "faBookBible", ()=>faBookBible);
parcelHelpers.export(exports, "faBible", ()=>faBible);
parcelHelpers.export(exports, "faO", ()=>faO);
parcelHelpers.export(exports, "faSuitcaseMedical", ()=>faSuitcaseMedical);
parcelHelpers.export(exports, "faMedkit", ()=>faMedkit);
parcelHelpers.export(exports, "faUserSecret", ()=>faUserSecret);
parcelHelpers.export(exports, "faOtter", ()=>faOtter);
parcelHelpers.export(exports, "faPersonDress", ()=>faPersonDress);
parcelHelpers.export(exports, "faFemale", ()=>faFemale);
parcelHelpers.export(exports, "faCommentDollar", ()=>faCommentDollar);
parcelHelpers.export(exports, "faBusinessTime", ()=>faBusinessTime);
parcelHelpers.export(exports, "faBriefcaseClock", ()=>faBriefcaseClock);
parcelHelpers.export(exports, "faTableCellsLarge", ()=>faTableCellsLarge);
parcelHelpers.export(exports, "faThLarge", ()=>faThLarge);
parcelHelpers.export(exports, "faBookTanakh", ()=>faBookTanakh);
parcelHelpers.export(exports, "faTanakh", ()=>faTanakh);
parcelHelpers.export(exports, "faPhoneVolume", ()=>faPhoneVolume);
parcelHelpers.export(exports, "faVolumeControlPhone", ()=>faVolumeControlPhone);
parcelHelpers.export(exports, "faHatCowboySide", ()=>faHatCowboySide);
parcelHelpers.export(exports, "faClipboardUser", ()=>faClipboardUser);
parcelHelpers.export(exports, "faChild", ()=>faChild);
parcelHelpers.export(exports, "faLiraSign", ()=>faLiraSign);
parcelHelpers.export(exports, "faSatellite", ()=>faSatellite);
parcelHelpers.export(exports, "faPlaneLock", ()=>faPlaneLock);
parcelHelpers.export(exports, "faTag", ()=>faTag);
parcelHelpers.export(exports, "faComment", ()=>faComment);
parcelHelpers.export(exports, "faCakeCandles", ()=>faCakeCandles);
parcelHelpers.export(exports, "faBirthdayCake", ()=>faBirthdayCake);
parcelHelpers.export(exports, "faCake", ()=>faCake);
parcelHelpers.export(exports, "faEnvelope", ()=>faEnvelope);
parcelHelpers.export(exports, "faAnglesUp", ()=>faAnglesUp);
parcelHelpers.export(exports, "faAngleDoubleUp", ()=>faAngleDoubleUp);
parcelHelpers.export(exports, "faPaperclip", ()=>faPaperclip);
parcelHelpers.export(exports, "faArrowRightToCity", ()=>faArrowRightToCity);
parcelHelpers.export(exports, "faRibbon", ()=>faRibbon);
parcelHelpers.export(exports, "faLungs", ()=>faLungs);
parcelHelpers.export(exports, "faArrowUp91", ()=>faArrowUp91);
parcelHelpers.export(exports, "faSortNumericUpAlt", ()=>faSortNumericUpAlt);
parcelHelpers.export(exports, "faLitecoinSign", ()=>faLitecoinSign);
parcelHelpers.export(exports, "faBorderNone", ()=>faBorderNone);
parcelHelpers.export(exports, "faCircleNodes", ()=>faCircleNodes);
parcelHelpers.export(exports, "faParachuteBox", ()=>faParachuteBox);
parcelHelpers.export(exports, "faIndent", ()=>faIndent);
parcelHelpers.export(exports, "faTruckFieldUn", ()=>faTruckFieldUn);
parcelHelpers.export(exports, "faHourglass", ()=>faHourglass);
parcelHelpers.export(exports, "faHourglassEmpty", ()=>faHourglassEmpty);
parcelHelpers.export(exports, "faMountain", ()=>faMountain);
parcelHelpers.export(exports, "faUserDoctor", ()=>faUserDoctor);
parcelHelpers.export(exports, "faUserMd", ()=>faUserMd);
parcelHelpers.export(exports, "faCircleInfo", ()=>faCircleInfo);
parcelHelpers.export(exports, "faInfoCircle", ()=>faInfoCircle);
parcelHelpers.export(exports, "faCloudMeatball", ()=>faCloudMeatball);
parcelHelpers.export(exports, "faCamera", ()=>faCamera);
parcelHelpers.export(exports, "faCameraAlt", ()=>faCameraAlt);
parcelHelpers.export(exports, "faSquareVirus", ()=>faSquareVirus);
parcelHelpers.export(exports, "faMeteor", ()=>faMeteor);
parcelHelpers.export(exports, "faCarOn", ()=>faCarOn);
parcelHelpers.export(exports, "faSleigh", ()=>faSleigh);
parcelHelpers.export(exports, "faArrowDown19", ()=>faArrowDown19);
parcelHelpers.export(exports, "faSortNumericAsc", ()=>faSortNumericAsc);
parcelHelpers.export(exports, "faSortNumericDown", ()=>faSortNumericDown);
parcelHelpers.export(exports, "faHandHoldingDroplet", ()=>faHandHoldingDroplet);
parcelHelpers.export(exports, "faHandHoldingWater", ()=>faHandHoldingWater);
parcelHelpers.export(exports, "faWater", ()=>faWater);
parcelHelpers.export(exports, "faCalendarCheck", ()=>faCalendarCheck);
parcelHelpers.export(exports, "faBraille", ()=>faBraille);
parcelHelpers.export(exports, "faPrescriptionBottleMedical", ()=>faPrescriptionBottleMedical);
parcelHelpers.export(exports, "faPrescriptionBottleAlt", ()=>faPrescriptionBottleAlt);
parcelHelpers.export(exports, "faLandmark", ()=>faLandmark);
parcelHelpers.export(exports, "faTruck", ()=>faTruck);
parcelHelpers.export(exports, "faCrosshairs", ()=>faCrosshairs);
parcelHelpers.export(exports, "faPersonCane", ()=>faPersonCane);
parcelHelpers.export(exports, "faTent", ()=>faTent);
parcelHelpers.export(exports, "faVestPatches", ()=>faVestPatches);
parcelHelpers.export(exports, "faCheckDouble", ()=>faCheckDouble);
parcelHelpers.export(exports, "faArrowDownAZ", ()=>faArrowDownAZ);
parcelHelpers.export(exports, "faSortAlphaAsc", ()=>faSortAlphaAsc);
parcelHelpers.export(exports, "faSortAlphaDown", ()=>faSortAlphaDown);
parcelHelpers.export(exports, "faMoneyBillWheat", ()=>faMoneyBillWheat);
parcelHelpers.export(exports, "faCookie", ()=>faCookie);
parcelHelpers.export(exports, "faArrowRotateLeft", ()=>faArrowRotateLeft);
parcelHelpers.export(exports, "faArrowLeftRotate", ()=>faArrowLeftRotate);
parcelHelpers.export(exports, "faArrowRotateBack", ()=>faArrowRotateBack);
parcelHelpers.export(exports, "faArrowRotateBackward", ()=>faArrowRotateBackward);
parcelHelpers.export(exports, "faUndo", ()=>faUndo);
parcelHelpers.export(exports, "faHardDrive", ()=>faHardDrive);
parcelHelpers.export(exports, "faHdd", ()=>faHdd);
parcelHelpers.export(exports, "faFaceGrinSquintTears", ()=>faFaceGrinSquintTears);
parcelHelpers.export(exports, "faGrinSquintTears", ()=>faGrinSquintTears);
parcelHelpers.export(exports, "faDumbbell", ()=>faDumbbell);
parcelHelpers.export(exports, "faRectangleList", ()=>faRectangleList);
parcelHelpers.export(exports, "faListAlt", ()=>faListAlt);
parcelHelpers.export(exports, "faTarpDroplet", ()=>faTarpDroplet);
parcelHelpers.export(exports, "faHouseMedicalCircleCheck", ()=>faHouseMedicalCircleCheck);
parcelHelpers.export(exports, "faPersonSkiingNordic", ()=>faPersonSkiingNordic);
parcelHelpers.export(exports, "faSkiingNordic", ()=>faSkiingNordic);
parcelHelpers.export(exports, "faCalendarPlus", ()=>faCalendarPlus);
parcelHelpers.export(exports, "faPlaneArrival", ()=>faPlaneArrival);
parcelHelpers.export(exports, "faCircleLeft", ()=>faCircleLeft);
parcelHelpers.export(exports, "faArrowAltCircleLeft", ()=>faArrowAltCircleLeft);
parcelHelpers.export(exports, "faTrainSubway", ()=>faTrainSubway);
parcelHelpers.export(exports, "faSubway", ()=>faSubway);
parcelHelpers.export(exports, "faChartGantt", ()=>faChartGantt);
parcelHelpers.export(exports, "faIndianRupeeSign", ()=>faIndianRupeeSign);
parcelHelpers.export(exports, "faIndianRupee", ()=>faIndianRupee);
parcelHelpers.export(exports, "faInr", ()=>faInr);
parcelHelpers.export(exports, "faCropSimple", ()=>faCropSimple);
parcelHelpers.export(exports, "faCropAlt", ()=>faCropAlt);
parcelHelpers.export(exports, "faMoneyBill1", ()=>faMoneyBill1);
parcelHelpers.export(exports, "faMoneyBillAlt", ()=>faMoneyBillAlt);
parcelHelpers.export(exports, "faLeftLong", ()=>faLeftLong);
parcelHelpers.export(exports, "faLongArrowAltLeft", ()=>faLongArrowAltLeft);
parcelHelpers.export(exports, "faDna", ()=>faDna);
parcelHelpers.export(exports, "faVirusSlash", ()=>faVirusSlash);
parcelHelpers.export(exports, "faMinus", ()=>faMinus);
parcelHelpers.export(exports, "faSubtract", ()=>faSubtract);
parcelHelpers.export(exports, "faChess", ()=>faChess);
parcelHelpers.export(exports, "faArrowLeftLong", ()=>faArrowLeftLong);
parcelHelpers.export(exports, "faLongArrowLeft", ()=>faLongArrowLeft);
parcelHelpers.export(exports, "faPlugCircleCheck", ()=>faPlugCircleCheck);
parcelHelpers.export(exports, "faStreetView", ()=>faStreetView);
parcelHelpers.export(exports, "faFrancSign", ()=>faFrancSign);
parcelHelpers.export(exports, "faVolumeOff", ()=>faVolumeOff);
parcelHelpers.export(exports, "faHandsAslInterpreting", ()=>faHandsAslInterpreting);
parcelHelpers.export(exports, "faAmericanSignLanguageInterpreting", ()=>faAmericanSignLanguageInterpreting);
parcelHelpers.export(exports, "faAslInterpreting", ()=>faAslInterpreting);
parcelHelpers.export(exports, "faHandsAmericanSignLanguageInterpreting", ()=>faHandsAmericanSignLanguageInterpreting);
parcelHelpers.export(exports, "faGear", ()=>faGear);
parcelHelpers.export(exports, "faCog", ()=>faCog);
parcelHelpers.export(exports, "faDropletSlash", ()=>faDropletSlash);
parcelHelpers.export(exports, "faTintSlash", ()=>faTintSlash);
parcelHelpers.export(exports, "faMosque", ()=>faMosque);
parcelHelpers.export(exports, "faMosquito", ()=>faMosquito);
parcelHelpers.export(exports, "faStarOfDavid", ()=>faStarOfDavid);
parcelHelpers.export(exports, "faPersonMilitaryRifle", ()=>faPersonMilitaryRifle);
parcelHelpers.export(exports, "faCartShopping", ()=>faCartShopping);
parcelHelpers.export(exports, "faShoppingCart", ()=>faShoppingCart);
parcelHelpers.export(exports, "faVials", ()=>faVials);
parcelHelpers.export(exports, "faPlugCirclePlus", ()=>faPlugCirclePlus);
parcelHelpers.export(exports, "faPlaceOfWorship", ()=>faPlaceOfWorship);
parcelHelpers.export(exports, "faGripVertical", ()=>faGripVertical);
parcelHelpers.export(exports, "faArrowTurnUp", ()=>faArrowTurnUp);
parcelHelpers.export(exports, "faLevelUp", ()=>faLevelUp);
parcelHelpers.export(exports, "faU", ()=>faU);
parcelHelpers.export(exports, "faSquareRootVariable", ()=>faSquareRootVariable);
parcelHelpers.export(exports, "faSquareRootAlt", ()=>faSquareRootAlt);
parcelHelpers.export(exports, "faClock", ()=>faClock);
parcelHelpers.export(exports, "faClockFour", ()=>faClockFour);
parcelHelpers.export(exports, "faBackwardStep", ()=>faBackwardStep);
parcelHelpers.export(exports, "faStepBackward", ()=>faStepBackward);
parcelHelpers.export(exports, "faPallet", ()=>faPallet);
parcelHelpers.export(exports, "faFaucet", ()=>faFaucet);
parcelHelpers.export(exports, "faBaseballBatBall", ()=>faBaseballBatBall);
parcelHelpers.export(exports, "faS", ()=>faS);
parcelHelpers.export(exports, "faTimeline", ()=>faTimeline);
parcelHelpers.export(exports, "faKeyboard", ()=>faKeyboard);
parcelHelpers.export(exports, "faCaretDown", ()=>faCaretDown);
parcelHelpers.export(exports, "faHouseChimneyMedical", ()=>faHouseChimneyMedical);
parcelHelpers.export(exports, "faClinicMedical", ()=>faClinicMedical);
parcelHelpers.export(exports, "faTemperatureThreeQuarters", ()=>faTemperatureThreeQuarters);
parcelHelpers.export(exports, "faTemperature3", ()=>faTemperature3);
parcelHelpers.export(exports, "faThermometer3", ()=>faThermometer3);
parcelHelpers.export(exports, "faThermometerThreeQuarters", ()=>faThermometerThreeQuarters);
parcelHelpers.export(exports, "faMobileScreen", ()=>faMobileScreen);
parcelHelpers.export(exports, "faMobileAndroidAlt", ()=>faMobileAndroidAlt);
parcelHelpers.export(exports, "faPlaneUp", ()=>faPlaneUp);
parcelHelpers.export(exports, "faPiggyBank", ()=>faPiggyBank);
parcelHelpers.export(exports, "faBatteryHalf", ()=>faBatteryHalf);
parcelHelpers.export(exports, "faBattery3", ()=>faBattery3);
parcelHelpers.export(exports, "faMountainCity", ()=>faMountainCity);
parcelHelpers.export(exports, "faCoins", ()=>faCoins);
parcelHelpers.export(exports, "faKhanda", ()=>faKhanda);
parcelHelpers.export(exports, "faSliders", ()=>faSliders);
parcelHelpers.export(exports, "faSlidersH", ()=>faSlidersH);
parcelHelpers.export(exports, "faFolderTree", ()=>faFolderTree);
parcelHelpers.export(exports, "faNetworkWired", ()=>faNetworkWired);
parcelHelpers.export(exports, "faMapPin", ()=>faMapPin);
parcelHelpers.export(exports, "faHamsa", ()=>faHamsa);
parcelHelpers.export(exports, "faCentSign", ()=>faCentSign);
parcelHelpers.export(exports, "faFlask", ()=>faFlask);
parcelHelpers.export(exports, "faPersonPregnant", ()=>faPersonPregnant);
parcelHelpers.export(exports, "faWandSparkles", ()=>faWandSparkles);
parcelHelpers.export(exports, "faEllipsisVertical", ()=>faEllipsisVertical);
parcelHelpers.export(exports, "faEllipsisV", ()=>faEllipsisV);
parcelHelpers.export(exports, "faTicket", ()=>faTicket);
parcelHelpers.export(exports, "faPowerOff", ()=>faPowerOff);
parcelHelpers.export(exports, "faRightLong", ()=>faRightLong);
parcelHelpers.export(exports, "faLongArrowAltRight", ()=>faLongArrowAltRight);
parcelHelpers.export(exports, "faFlagUsa", ()=>faFlagUsa);
parcelHelpers.export(exports, "faLaptopFile", ()=>faLaptopFile);
parcelHelpers.export(exports, "faTty", ()=>faTty);
parcelHelpers.export(exports, "faTeletype", ()=>faTeletype);
parcelHelpers.export(exports, "faDiagramNext", ()=>faDiagramNext);
parcelHelpers.export(exports, "faPersonRifle", ()=>faPersonRifle);
parcelHelpers.export(exports, "faHouseMedicalCircleExclamation", ()=>faHouseMedicalCircleExclamation);
parcelHelpers.export(exports, "faClosedCaptioning", ()=>faClosedCaptioning);
parcelHelpers.export(exports, "faPersonHiking", ()=>faPersonHiking);
parcelHelpers.export(exports, "faHiking", ()=>faHiking);
parcelHelpers.export(exports, "faVenusDouble", ()=>faVenusDouble);
parcelHelpers.export(exports, "faImages", ()=>faImages);
parcelHelpers.export(exports, "faCalculator", ()=>faCalculator);
parcelHelpers.export(exports, "faPeoplePulling", ()=>faPeoplePulling);
parcelHelpers.export(exports, "faN", ()=>faN);
parcelHelpers.export(exports, "faCableCar", ()=>faCableCar);
parcelHelpers.export(exports, "faTram", ()=>faTram);
parcelHelpers.export(exports, "faCloudRain", ()=>faCloudRain);
parcelHelpers.export(exports, "faBuildingCircleXmark", ()=>faBuildingCircleXmark);
parcelHelpers.export(exports, "faShip", ()=>faShip);
parcelHelpers.export(exports, "faArrowsDownToLine", ()=>faArrowsDownToLine);
parcelHelpers.export(exports, "faDownload", ()=>faDownload);
parcelHelpers.export(exports, "faFaceGrin", ()=>faFaceGrin);
parcelHelpers.export(exports, "faGrin", ()=>faGrin);
parcelHelpers.export(exports, "faDeleteLeft", ()=>faDeleteLeft);
parcelHelpers.export(exports, "faBackspace", ()=>faBackspace);
parcelHelpers.export(exports, "faEyeDropper", ()=>faEyeDropper);
parcelHelpers.export(exports, "faEyeDropperEmpty", ()=>faEyeDropperEmpty);
parcelHelpers.export(exports, "faEyedropper", ()=>faEyedropper);
parcelHelpers.export(exports, "faFileCircleCheck", ()=>faFileCircleCheck);
parcelHelpers.export(exports, "faForward", ()=>faForward);
parcelHelpers.export(exports, "faMobile", ()=>faMobile);
parcelHelpers.export(exports, "faMobileAndroid", ()=>faMobileAndroid);
parcelHelpers.export(exports, "faMobilePhone", ()=>faMobilePhone);
parcelHelpers.export(exports, "faFaceMeh", ()=>faFaceMeh);
parcelHelpers.export(exports, "faMeh", ()=>faMeh);
parcelHelpers.export(exports, "faAlignCenter", ()=>faAlignCenter);
parcelHelpers.export(exports, "faBookSkull", ()=>faBookSkull);
parcelHelpers.export(exports, "faBookDead", ()=>faBookDead);
parcelHelpers.export(exports, "faIdCard", ()=>faIdCard);
parcelHelpers.export(exports, "faDriversLicense", ()=>faDriversLicense);
parcelHelpers.export(exports, "faOutdent", ()=>faOutdent);
parcelHelpers.export(exports, "faDedent", ()=>faDedent);
parcelHelpers.export(exports, "faHeartCircleExclamation", ()=>faHeartCircleExclamation);
parcelHelpers.export(exports, "faHouse", ()=>faHouse);
parcelHelpers.export(exports, "faHome", ()=>faHome);
parcelHelpers.export(exports, "faHomeAlt", ()=>faHomeAlt);
parcelHelpers.export(exports, "faHomeLgAlt", ()=>faHomeLgAlt);
parcelHelpers.export(exports, "faCalendarWeek", ()=>faCalendarWeek);
parcelHelpers.export(exports, "faLaptopMedical", ()=>faLaptopMedical);
parcelHelpers.export(exports, "faB", ()=>faB);
parcelHelpers.export(exports, "faFileMedical", ()=>faFileMedical);
parcelHelpers.export(exports, "faDiceOne", ()=>faDiceOne);
parcelHelpers.export(exports, "faKiwiBird", ()=>faKiwiBird);
parcelHelpers.export(exports, "faArrowRightArrowLeft", ()=>faArrowRightArrowLeft);
parcelHelpers.export(exports, "faExchange", ()=>faExchange);
parcelHelpers.export(exports, "faRotateRight", ()=>faRotateRight);
parcelHelpers.export(exports, "faRedoAlt", ()=>faRedoAlt);
parcelHelpers.export(exports, "faRotateForward", ()=>faRotateForward);
parcelHelpers.export(exports, "faUtensils", ()=>faUtensils);
parcelHelpers.export(exports, "faCutlery", ()=>faCutlery);
parcelHelpers.export(exports, "faArrowUpWideShort", ()=>faArrowUpWideShort);
parcelHelpers.export(exports, "faSortAmountUp", ()=>faSortAmountUp);
parcelHelpers.export(exports, "faMillSign", ()=>faMillSign);
parcelHelpers.export(exports, "faBowlRice", ()=>faBowlRice);
parcelHelpers.export(exports, "faSkull", ()=>faSkull);
parcelHelpers.export(exports, "faTowerBroadcast", ()=>faTowerBroadcast);
parcelHelpers.export(exports, "faBroadcastTower", ()=>faBroadcastTower);
parcelHelpers.export(exports, "faTruckPickup", ()=>faTruckPickup);
parcelHelpers.export(exports, "faUpLong", ()=>faUpLong);
parcelHelpers.export(exports, "faLongArrowAltUp", ()=>faLongArrowAltUp);
parcelHelpers.export(exports, "faStop", ()=>faStop);
parcelHelpers.export(exports, "faCodeMerge", ()=>faCodeMerge);
parcelHelpers.export(exports, "faUpload", ()=>faUpload);
parcelHelpers.export(exports, "faHurricane", ()=>faHurricane);
parcelHelpers.export(exports, "faMound", ()=>faMound);
parcelHelpers.export(exports, "faToiletPortable", ()=>faToiletPortable);
parcelHelpers.export(exports, "faCompactDisc", ()=>faCompactDisc);
parcelHelpers.export(exports, "faFileArrowDown", ()=>faFileArrowDown);
parcelHelpers.export(exports, "faFileDownload", ()=>faFileDownload);
parcelHelpers.export(exports, "faCaravan", ()=>faCaravan);
parcelHelpers.export(exports, "faShieldCat", ()=>faShieldCat);
parcelHelpers.export(exports, "faBolt", ()=>faBolt);
parcelHelpers.export(exports, "faZap", ()=>faZap);
parcelHelpers.export(exports, "faGlassWater", ()=>faGlassWater);
parcelHelpers.export(exports, "faOilWell", ()=>faOilWell);
parcelHelpers.export(exports, "faVault", ()=>faVault);
parcelHelpers.export(exports, "faMars", ()=>faMars);
parcelHelpers.export(exports, "faToilet", ()=>faToilet);
parcelHelpers.export(exports, "faPlaneCircleXmark", ()=>faPlaneCircleXmark);
parcelHelpers.export(exports, "faYenSign", ()=>faYenSign);
parcelHelpers.export(exports, "faCny", ()=>faCny);
parcelHelpers.export(exports, "faJpy", ()=>faJpy);
parcelHelpers.export(exports, "faRmb", ()=>faRmb);
parcelHelpers.export(exports, "faYen", ()=>faYen);
parcelHelpers.export(exports, "faRubleSign", ()=>faRubleSign);
parcelHelpers.export(exports, "faRouble", ()=>faRouble);
parcelHelpers.export(exports, "faRub", ()=>faRub);
parcelHelpers.export(exports, "faRuble", ()=>faRuble);
parcelHelpers.export(exports, "faSun", ()=>faSun);
parcelHelpers.export(exports, "faGuitar", ()=>faGuitar);
parcelHelpers.export(exports, "faFaceLaughWink", ()=>faFaceLaughWink);
parcelHelpers.export(exports, "faLaughWink", ()=>faLaughWink);
parcelHelpers.export(exports, "faHorseHead", ()=>faHorseHead);
parcelHelpers.export(exports, "faBoreHole", ()=>faBoreHole);
parcelHelpers.export(exports, "faIndustry", ()=>faIndustry);
parcelHelpers.export(exports, "faCircleDown", ()=>faCircleDown);
parcelHelpers.export(exports, "faArrowAltCircleDown", ()=>faArrowAltCircleDown);
parcelHelpers.export(exports, "faArrowsTurnToDots", ()=>faArrowsTurnToDots);
parcelHelpers.export(exports, "faFlorinSign", ()=>faFlorinSign);
parcelHelpers.export(exports, "faArrowDownShortWide", ()=>faArrowDownShortWide);
parcelHelpers.export(exports, "faSortAmountDesc", ()=>faSortAmountDesc);
parcelHelpers.export(exports, "faSortAmountDownAlt", ()=>faSortAmountDownAlt);
parcelHelpers.export(exports, "faLessThan", ()=>faLessThan);
parcelHelpers.export(exports, "faAngleDown", ()=>faAngleDown);
parcelHelpers.export(exports, "faCarTunnel", ()=>faCarTunnel);
parcelHelpers.export(exports, "faHeadSideCough", ()=>faHeadSideCough);
parcelHelpers.export(exports, "faGripLines", ()=>faGripLines);
parcelHelpers.export(exports, "faThumbsDown", ()=>faThumbsDown);
parcelHelpers.export(exports, "faUserLock", ()=>faUserLock);
parcelHelpers.export(exports, "faArrowRightLong", ()=>faArrowRightLong);
parcelHelpers.export(exports, "faLongArrowRight", ()=>faLongArrowRight);
parcelHelpers.export(exports, "faAnchorCircleXmark", ()=>faAnchorCircleXmark);
parcelHelpers.export(exports, "faEllipsis", ()=>faEllipsis);
parcelHelpers.export(exports, "faEllipsisH", ()=>faEllipsisH);
parcelHelpers.export(exports, "faChessPawn", ()=>faChessPawn);
parcelHelpers.export(exports, "faKitMedical", ()=>faKitMedical);
parcelHelpers.export(exports, "faFirstAid", ()=>faFirstAid);
parcelHelpers.export(exports, "faPersonThroughWindow", ()=>faPersonThroughWindow);
parcelHelpers.export(exports, "faToolbox", ()=>faToolbox);
parcelHelpers.export(exports, "faHandsHoldingCircle", ()=>faHandsHoldingCircle);
parcelHelpers.export(exports, "faBug", ()=>faBug);
parcelHelpers.export(exports, "faCreditCard", ()=>faCreditCard);
parcelHelpers.export(exports, "faCreditCardAlt", ()=>faCreditCardAlt);
parcelHelpers.export(exports, "faCar", ()=>faCar);
parcelHelpers.export(exports, "faAutomobile", ()=>faAutomobile);
parcelHelpers.export(exports, "faHandHoldingHand", ()=>faHandHoldingHand);
parcelHelpers.export(exports, "faBookOpenReader", ()=>faBookOpenReader);
parcelHelpers.export(exports, "faBookReader", ()=>faBookReader);
parcelHelpers.export(exports, "faMountainSun", ()=>faMountainSun);
parcelHelpers.export(exports, "faArrowsLeftRightToLine", ()=>faArrowsLeftRightToLine);
parcelHelpers.export(exports, "faDiceD20", ()=>faDiceD20);
parcelHelpers.export(exports, "faTruckDroplet", ()=>faTruckDroplet);
parcelHelpers.export(exports, "faFileCircleXmark", ()=>faFileCircleXmark);
parcelHelpers.export(exports, "faTemperatureArrowUp", ()=>faTemperatureArrowUp);
parcelHelpers.export(exports, "faTemperatureUp", ()=>faTemperatureUp);
parcelHelpers.export(exports, "faMedal", ()=>faMedal);
parcelHelpers.export(exports, "faBed", ()=>faBed);
parcelHelpers.export(exports, "faSquareH", ()=>faSquareH);
parcelHelpers.export(exports, "faHSquare", ()=>faHSquare);
parcelHelpers.export(exports, "faPodcast", ()=>faPodcast);
parcelHelpers.export(exports, "faTemperatureFull", ()=>faTemperatureFull);
parcelHelpers.export(exports, "faTemperature4", ()=>faTemperature4);
parcelHelpers.export(exports, "faThermometer4", ()=>faThermometer4);
parcelHelpers.export(exports, "faThermometerFull", ()=>faThermometerFull);
parcelHelpers.export(exports, "faBell", ()=>faBell);
parcelHelpers.export(exports, "faSuperscript", ()=>faSuperscript);
parcelHelpers.export(exports, "faPlugCircleXmark", ()=>faPlugCircleXmark);
parcelHelpers.export(exports, "faStarOfLife", ()=>faStarOfLife);
parcelHelpers.export(exports, "faPhoneSlash", ()=>faPhoneSlash);
parcelHelpers.export(exports, "faPaintRoller", ()=>faPaintRoller);
parcelHelpers.export(exports, "faHandshakeAngle", ()=>faHandshakeAngle);
parcelHelpers.export(exports, "faHandsHelping", ()=>faHandsHelping);
parcelHelpers.export(exports, "faLocationDot", ()=>faLocationDot);
parcelHelpers.export(exports, "faMapMarkerAlt", ()=>faMapMarkerAlt);
parcelHelpers.export(exports, "faFile", ()=>faFile);
parcelHelpers.export(exports, "faGreaterThan", ()=>faGreaterThan);
parcelHelpers.export(exports, "faPersonSwimming", ()=>faPersonSwimming);
parcelHelpers.export(exports, "faSwimmer", ()=>faSwimmer);
parcelHelpers.export(exports, "faArrowDown", ()=>faArrowDown);
parcelHelpers.export(exports, "faDroplet", ()=>faDroplet);
parcelHelpers.export(exports, "faTint", ()=>faTint);
parcelHelpers.export(exports, "faEraser", ()=>faEraser);
parcelHelpers.export(exports, "faEarthAmericas", ()=>faEarthAmericas);
parcelHelpers.export(exports, "faEarth", ()=>faEarth);
parcelHelpers.export(exports, "faEarthAmerica", ()=>faEarthAmerica);
parcelHelpers.export(exports, "faGlobeAmericas", ()=>faGlobeAmericas);
parcelHelpers.export(exports, "faPersonBurst", ()=>faPersonBurst);
parcelHelpers.export(exports, "faDove", ()=>faDove);
parcelHelpers.export(exports, "faBatteryEmpty", ()=>faBatteryEmpty);
parcelHelpers.export(exports, "faBattery0", ()=>faBattery0);
parcelHelpers.export(exports, "faSocks", ()=>faSocks);
parcelHelpers.export(exports, "faInbox", ()=>faInbox);
parcelHelpers.export(exports, "faSection", ()=>faSection);
parcelHelpers.export(exports, "faGaugeHigh", ()=>faGaugeHigh);
parcelHelpers.export(exports, "faTachometerAlt", ()=>faTachometerAlt);
parcelHelpers.export(exports, "faTachometerAltFast", ()=>faTachometerAltFast);
parcelHelpers.export(exports, "faEnvelopeOpenText", ()=>faEnvelopeOpenText);
parcelHelpers.export(exports, "faHospital", ()=>faHospital);
parcelHelpers.export(exports, "faHospitalAlt", ()=>faHospitalAlt);
parcelHelpers.export(exports, "faHospitalWide", ()=>faHospitalWide);
parcelHelpers.export(exports, "faWineBottle", ()=>faWineBottle);
parcelHelpers.export(exports, "faChessRook", ()=>faChessRook);
parcelHelpers.export(exports, "faBarsStaggered", ()=>faBarsStaggered);
parcelHelpers.export(exports, "faReorder", ()=>faReorder);
parcelHelpers.export(exports, "faStream", ()=>faStream);
parcelHelpers.export(exports, "faDharmachakra", ()=>faDharmachakra);
parcelHelpers.export(exports, "faHotdog", ()=>faHotdog);
parcelHelpers.export(exports, "faPersonWalkingWithCane", ()=>faPersonWalkingWithCane);
parcelHelpers.export(exports, "faBlind", ()=>faBlind);
parcelHelpers.export(exports, "faDrum", ()=>faDrum);
parcelHelpers.export(exports, "faIceCream", ()=>faIceCream);
parcelHelpers.export(exports, "faHeartCircleBolt", ()=>faHeartCircleBolt);
parcelHelpers.export(exports, "faFax", ()=>faFax);
parcelHelpers.export(exports, "faParagraph", ()=>faParagraph);
parcelHelpers.export(exports, "faCheckToSlot", ()=>faCheckToSlot);
parcelHelpers.export(exports, "faVoteYea", ()=>faVoteYea);
parcelHelpers.export(exports, "faStarHalf", ()=>faStarHalf);
parcelHelpers.export(exports, "faBoxesStacked", ()=>faBoxesStacked);
parcelHelpers.export(exports, "faBoxes", ()=>faBoxes);
parcelHelpers.export(exports, "faBoxesAlt", ()=>faBoxesAlt);
parcelHelpers.export(exports, "faLink", ()=>faLink);
parcelHelpers.export(exports, "faChain", ()=>faChain);
parcelHelpers.export(exports, "faEarListen", ()=>faEarListen);
parcelHelpers.export(exports, "faAssistiveListeningSystems", ()=>faAssistiveListeningSystems);
parcelHelpers.export(exports, "faTreeCity", ()=>faTreeCity);
parcelHelpers.export(exports, "faPlay", ()=>faPlay);
parcelHelpers.export(exports, "faFont", ()=>faFont);
parcelHelpers.export(exports, "faRupiahSign", ()=>faRupiahSign);
parcelHelpers.export(exports, "faMagnifyingGlass", ()=>faMagnifyingGlass);
parcelHelpers.export(exports, "faSearch", ()=>faSearch);
parcelHelpers.export(exports, "faTableTennisPaddleBall", ()=>faTableTennisPaddleBall);
parcelHelpers.export(exports, "faPingPongPaddleBall", ()=>faPingPongPaddleBall);
parcelHelpers.export(exports, "faTableTennis", ()=>faTableTennis);
parcelHelpers.export(exports, "faPersonDotsFromLine", ()=>faPersonDotsFromLine);
parcelHelpers.export(exports, "faDiagnoses", ()=>faDiagnoses);
parcelHelpers.export(exports, "faTrashCanArrowUp", ()=>faTrashCanArrowUp);
parcelHelpers.export(exports, "faTrashRestoreAlt", ()=>faTrashRestoreAlt);
parcelHelpers.export(exports, "faNairaSign", ()=>faNairaSign);
parcelHelpers.export(exports, "faCartArrowDown", ()=>faCartArrowDown);
parcelHelpers.export(exports, "faWalkieTalkie", ()=>faWalkieTalkie);
parcelHelpers.export(exports, "faFilePen", ()=>faFilePen);
parcelHelpers.export(exports, "faFileEdit", ()=>faFileEdit);
parcelHelpers.export(exports, "faReceipt", ()=>faReceipt);
parcelHelpers.export(exports, "faSquarePen", ()=>faSquarePen);
parcelHelpers.export(exports, "faPenSquare", ()=>faPenSquare);
parcelHelpers.export(exports, "faPencilSquare", ()=>faPencilSquare);
parcelHelpers.export(exports, "faSuitcaseRolling", ()=>faSuitcaseRolling);
parcelHelpers.export(exports, "faPersonCircleExclamation", ()=>faPersonCircleExclamation);
parcelHelpers.export(exports, "faChevronDown", ()=>faChevronDown);
parcelHelpers.export(exports, "faBatteryFull", ()=>faBatteryFull);
parcelHelpers.export(exports, "faBattery", ()=>faBattery);
parcelHelpers.export(exports, "faBattery5", ()=>faBattery5);
parcelHelpers.export(exports, "faSkullCrossbones", ()=>faSkullCrossbones);
parcelHelpers.export(exports, "faCodeCompare", ()=>faCodeCompare);
parcelHelpers.export(exports, "faListUl", ()=>faListUl);
parcelHelpers.export(exports, "faListDots", ()=>faListDots);
parcelHelpers.export(exports, "faSchoolLock", ()=>faSchoolLock);
parcelHelpers.export(exports, "faTowerCell", ()=>faTowerCell);
parcelHelpers.export(exports, "faDownLong", ()=>faDownLong);
parcelHelpers.export(exports, "faLongArrowAltDown", ()=>faLongArrowAltDown);
parcelHelpers.export(exports, "faRankingStar", ()=>faRankingStar);
parcelHelpers.export(exports, "faChessKing", ()=>faChessKing);
parcelHelpers.export(exports, "faPersonHarassing", ()=>faPersonHarassing);
parcelHelpers.export(exports, "faBrazilianRealSign", ()=>faBrazilianRealSign);
parcelHelpers.export(exports, "faLandmarkDome", ()=>faLandmarkDome);
parcelHelpers.export(exports, "faLandmarkAlt", ()=>faLandmarkAlt);
parcelHelpers.export(exports, "faArrowUp", ()=>faArrowUp);
parcelHelpers.export(exports, "faTv", ()=>faTv);
parcelHelpers.export(exports, "faTelevision", ()=>faTelevision);
parcelHelpers.export(exports, "faTvAlt", ()=>faTvAlt);
parcelHelpers.export(exports, "faShrimp", ()=>faShrimp);
parcelHelpers.export(exports, "faListCheck", ()=>faListCheck);
parcelHelpers.export(exports, "faTasks", ()=>faTasks);
parcelHelpers.export(exports, "faJugDetergent", ()=>faJugDetergent);
parcelHelpers.export(exports, "faCircleUser", ()=>faCircleUser);
parcelHelpers.export(exports, "faUserCircle", ()=>faUserCircle);
parcelHelpers.export(exports, "faUserShield", ()=>faUserShield);
parcelHelpers.export(exports, "faWind", ()=>faWind);
parcelHelpers.export(exports, "faCarBurst", ()=>faCarBurst);
parcelHelpers.export(exports, "faCarCrash", ()=>faCarCrash);
parcelHelpers.export(exports, "faY", ()=>faY);
parcelHelpers.export(exports, "faPersonSnowboarding", ()=>faPersonSnowboarding);
parcelHelpers.export(exports, "faSnowboarding", ()=>faSnowboarding);
parcelHelpers.export(exports, "faTruckFast", ()=>faTruckFast);
parcelHelpers.export(exports, "faShippingFast", ()=>faShippingFast);
parcelHelpers.export(exports, "faFish", ()=>faFish);
parcelHelpers.export(exports, "faUserGraduate", ()=>faUserGraduate);
parcelHelpers.export(exports, "faCircleHalfStroke", ()=>faCircleHalfStroke);
parcelHelpers.export(exports, "faAdjust", ()=>faAdjust);
parcelHelpers.export(exports, "faClapperboard", ()=>faClapperboard);
parcelHelpers.export(exports, "faCircleRadiation", ()=>faCircleRadiation);
parcelHelpers.export(exports, "faRadiationAlt", ()=>faRadiationAlt);
parcelHelpers.export(exports, "faBaseball", ()=>faBaseball);
parcelHelpers.export(exports, "faBaseballBall", ()=>faBaseballBall);
parcelHelpers.export(exports, "faJetFighterUp", ()=>faJetFighterUp);
parcelHelpers.export(exports, "faDiagramProject", ()=>faDiagramProject);
parcelHelpers.export(exports, "faProjectDiagram", ()=>faProjectDiagram);
parcelHelpers.export(exports, "faCopy", ()=>faCopy);
parcelHelpers.export(exports, "faVolumeXmark", ()=>faVolumeXmark);
parcelHelpers.export(exports, "faVolumeMute", ()=>faVolumeMute);
parcelHelpers.export(exports, "faVolumeTimes", ()=>faVolumeTimes);
parcelHelpers.export(exports, "faHandSparkles", ()=>faHandSparkles);
parcelHelpers.export(exports, "faGrip", ()=>faGrip);
parcelHelpers.export(exports, "faGripHorizontal", ()=>faGripHorizontal);
parcelHelpers.export(exports, "faShareFromSquare", ()=>faShareFromSquare);
parcelHelpers.export(exports, "faShareSquare", ()=>faShareSquare);
parcelHelpers.export(exports, "faChildCombatant", ()=>faChildCombatant);
parcelHelpers.export(exports, "faChildRifle", ()=>faChildRifle);
parcelHelpers.export(exports, "faGun", ()=>faGun);
parcelHelpers.export(exports, "faSquarePhone", ()=>faSquarePhone);
parcelHelpers.export(exports, "faPhoneSquare", ()=>faPhoneSquare);
parcelHelpers.export(exports, "faPlus", ()=>faPlus);
parcelHelpers.export(exports, "faAdd", ()=>faAdd);
parcelHelpers.export(exports, "faExpand", ()=>faExpand);
parcelHelpers.export(exports, "faComputer", ()=>faComputer);
parcelHelpers.export(exports, "faXmark", ()=>faXmark);
parcelHelpers.export(exports, "faClose", ()=>faClose);
parcelHelpers.export(exports, "faMultiply", ()=>faMultiply);
parcelHelpers.export(exports, "faRemove", ()=>faRemove);
parcelHelpers.export(exports, "faTimes", ()=>faTimes);
parcelHelpers.export(exports, "faArrowsUpDownLeftRight", ()=>faArrowsUpDownLeftRight);
parcelHelpers.export(exports, "faArrows", ()=>faArrows);
parcelHelpers.export(exports, "faChalkboardUser", ()=>faChalkboardUser);
parcelHelpers.export(exports, "faChalkboardTeacher", ()=>faChalkboardTeacher);
parcelHelpers.export(exports, "faPesoSign", ()=>faPesoSign);
parcelHelpers.export(exports, "faBuildingShield", ()=>faBuildingShield);
parcelHelpers.export(exports, "faBaby", ()=>faBaby);
parcelHelpers.export(exports, "faUsersLine", ()=>faUsersLine);
parcelHelpers.export(exports, "faQuoteLeft", ()=>faQuoteLeft);
parcelHelpers.export(exports, "faQuoteLeftAlt", ()=>faQuoteLeftAlt);
parcelHelpers.export(exports, "faTractor", ()=>faTractor);
parcelHelpers.export(exports, "faTrashArrowUp", ()=>faTrashArrowUp);
parcelHelpers.export(exports, "faTrashRestore", ()=>faTrashRestore);
parcelHelpers.export(exports, "faArrowDownUpLock", ()=>faArrowDownUpLock);
parcelHelpers.export(exports, "faLinesLeaning", ()=>faLinesLeaning);
parcelHelpers.export(exports, "faRulerCombined", ()=>faRulerCombined);
parcelHelpers.export(exports, "faCopyright", ()=>faCopyright);
parcelHelpers.export(exports, "faEquals", ()=>faEquals);
parcelHelpers.export(exports, "faBlender", ()=>faBlender);
parcelHelpers.export(exports, "faTeeth", ()=>faTeeth);
parcelHelpers.export(exports, "faShekelSign", ()=>faShekelSign);
parcelHelpers.export(exports, "faIls", ()=>faIls);
parcelHelpers.export(exports, "faShekel", ()=>faShekel);
parcelHelpers.export(exports, "faSheqel", ()=>faSheqel);
parcelHelpers.export(exports, "faSheqelSign", ()=>faSheqelSign);
parcelHelpers.export(exports, "faMap", ()=>faMap);
parcelHelpers.export(exports, "faRocket", ()=>faRocket);
parcelHelpers.export(exports, "faPhotoFilm", ()=>faPhotoFilm);
parcelHelpers.export(exports, "faPhotoVideo", ()=>faPhotoVideo);
parcelHelpers.export(exports, "faFolderMinus", ()=>faFolderMinus);
parcelHelpers.export(exports, "faStore", ()=>faStore);
parcelHelpers.export(exports, "faArrowTrendUp", ()=>faArrowTrendUp);
parcelHelpers.export(exports, "faPlugCircleMinus", ()=>faPlugCircleMinus);
parcelHelpers.export(exports, "faSignHanging", ()=>faSignHanging);
parcelHelpers.export(exports, "faSign", ()=>faSign);
parcelHelpers.export(exports, "faBezierCurve", ()=>faBezierCurve);
parcelHelpers.export(exports, "faBellSlash", ()=>faBellSlash);
parcelHelpers.export(exports, "faTablet", ()=>faTablet);
parcelHelpers.export(exports, "faTabletAndroid", ()=>faTabletAndroid);
parcelHelpers.export(exports, "faSchoolFlag", ()=>faSchoolFlag);
parcelHelpers.export(exports, "faFill", ()=>faFill);
parcelHelpers.export(exports, "faAngleUp", ()=>faAngleUp);
parcelHelpers.export(exports, "faDrumstickBite", ()=>faDrumstickBite);
parcelHelpers.export(exports, "faHollyBerry", ()=>faHollyBerry);
parcelHelpers.export(exports, "faChevronLeft", ()=>faChevronLeft);
parcelHelpers.export(exports, "faBacteria", ()=>faBacteria);
parcelHelpers.export(exports, "faHandLizard", ()=>faHandLizard);
parcelHelpers.export(exports, "faNotdef", ()=>faNotdef);
parcelHelpers.export(exports, "faDisease", ()=>faDisease);
parcelHelpers.export(exports, "faBriefcaseMedical", ()=>faBriefcaseMedical);
parcelHelpers.export(exports, "faGenderless", ()=>faGenderless);
parcelHelpers.export(exports, "faChevronRight", ()=>faChevronRight);
parcelHelpers.export(exports, "faRetweet", ()=>faRetweet);
parcelHelpers.export(exports, "faCarRear", ()=>faCarRear);
parcelHelpers.export(exports, "faCarAlt", ()=>faCarAlt);
parcelHelpers.export(exports, "faPumpSoap", ()=>faPumpSoap);
parcelHelpers.export(exports, "faVideoSlash", ()=>faVideoSlash);
parcelHelpers.export(exports, "faBatteryQuarter", ()=>faBatteryQuarter);
parcelHelpers.export(exports, "faBattery2", ()=>faBattery2);
parcelHelpers.export(exports, "faRadio", ()=>faRadio);
parcelHelpers.export(exports, "faBabyCarriage", ()=>faBabyCarriage);
parcelHelpers.export(exports, "faCarriageBaby", ()=>faCarriageBaby);
parcelHelpers.export(exports, "faTrafficLight", ()=>faTrafficLight);
parcelHelpers.export(exports, "faThermometer", ()=>faThermometer);
parcelHelpers.export(exports, "faVrCardboard", ()=>faVrCardboard);
parcelHelpers.export(exports, "faHandMiddleFinger", ()=>faHandMiddleFinger);
parcelHelpers.export(exports, "faPercent", ()=>faPercent);
parcelHelpers.export(exports, "faPercentage", ()=>faPercentage);
parcelHelpers.export(exports, "faTruckMoving", ()=>faTruckMoving);
parcelHelpers.export(exports, "faGlassWaterDroplet", ()=>faGlassWaterDroplet);
parcelHelpers.export(exports, "faDisplay", ()=>faDisplay);
parcelHelpers.export(exports, "faFaceSmile", ()=>faFaceSmile);
parcelHelpers.export(exports, "faSmile", ()=>faSmile);
parcelHelpers.export(exports, "faThumbtack", ()=>faThumbtack);
parcelHelpers.export(exports, "faThumbTack", ()=>faThumbTack);
parcelHelpers.export(exports, "faTrophy", ()=>faTrophy);
parcelHelpers.export(exports, "faPersonPraying", ()=>faPersonPraying);
parcelHelpers.export(exports, "faPray", ()=>faPray);
parcelHelpers.export(exports, "faHammer", ()=>faHammer);
parcelHelpers.export(exports, "faHandPeace", ()=>faHandPeace);
parcelHelpers.export(exports, "faRotate", ()=>faRotate);
parcelHelpers.export(exports, "faSyncAlt", ()=>faSyncAlt);
parcelHelpers.export(exports, "faSpinner", ()=>faSpinner);
parcelHelpers.export(exports, "faRobot", ()=>faRobot);
parcelHelpers.export(exports, "faPeace", ()=>faPeace);
parcelHelpers.export(exports, "faGears", ()=>faGears);
parcelHelpers.export(exports, "faCogs", ()=>faCogs);
parcelHelpers.export(exports, "faWarehouse", ()=>faWarehouse);
parcelHelpers.export(exports, "faArrowUpRightDots", ()=>faArrowUpRightDots);
parcelHelpers.export(exports, "faSplotch", ()=>faSplotch);
parcelHelpers.export(exports, "faFaceGrinHearts", ()=>faFaceGrinHearts);
parcelHelpers.export(exports, "faGrinHearts", ()=>faGrinHearts);
parcelHelpers.export(exports, "faDiceFour", ()=>faDiceFour);
parcelHelpers.export(exports, "faSimCard", ()=>faSimCard);
parcelHelpers.export(exports, "faTransgender", ()=>faTransgender);
parcelHelpers.export(exports, "faTransgenderAlt", ()=>faTransgenderAlt);
parcelHelpers.export(exports, "faMercury", ()=>faMercury);
parcelHelpers.export(exports, "faArrowTurnDown", ()=>faArrowTurnDown);
parcelHelpers.export(exports, "faLevelDown", ()=>faLevelDown);
parcelHelpers.export(exports, "faPersonFallingBurst", ()=>faPersonFallingBurst);
parcelHelpers.export(exports, "faAward", ()=>faAward);
parcelHelpers.export(exports, "faTicketSimple", ()=>faTicketSimple);
parcelHelpers.export(exports, "faTicketAlt", ()=>faTicketAlt);
parcelHelpers.export(exports, "faBuilding", ()=>faBuilding);
parcelHelpers.export(exports, "faAnglesLeft", ()=>faAnglesLeft);
parcelHelpers.export(exports, "faAngleDoubleLeft", ()=>faAngleDoubleLeft);
parcelHelpers.export(exports, "faQrcode", ()=>faQrcode);
parcelHelpers.export(exports, "faClockRotateLeft", ()=>faClockRotateLeft);
parcelHelpers.export(exports, "faHistory", ()=>faHistory);
parcelHelpers.export(exports, "faFaceGrinBeamSweat", ()=>faFaceGrinBeamSweat);
parcelHelpers.export(exports, "faGrinBeamSweat", ()=>faGrinBeamSweat);
parcelHelpers.export(exports, "faFileExport", ()=>faFileExport);
parcelHelpers.export(exports, "faArrowRightFromFile", ()=>faArrowRightFromFile);
parcelHelpers.export(exports, "faShield", ()=>faShield);
parcelHelpers.export(exports, "faShieldBlank", ()=>faShieldBlank);
parcelHelpers.export(exports, "faArrowUpShortWide", ()=>faArrowUpShortWide);
parcelHelpers.export(exports, "faSortAmountUpAlt", ()=>faSortAmountUpAlt);
parcelHelpers.export(exports, "faHouseMedical", ()=>faHouseMedical);
parcelHelpers.export(exports, "faGolfBallTee", ()=>faGolfBallTee);
parcelHelpers.export(exports, "faGolfBall", ()=>faGolfBall);
parcelHelpers.export(exports, "faCircleChevronLeft", ()=>faCircleChevronLeft);
parcelHelpers.export(exports, "faChevronCircleLeft", ()=>faChevronCircleLeft);
parcelHelpers.export(exports, "faHouseChimneyWindow", ()=>faHouseChimneyWindow);
parcelHelpers.export(exports, "faPenNib", ()=>faPenNib);
parcelHelpers.export(exports, "faTentArrowTurnLeft", ()=>faTentArrowTurnLeft);
parcelHelpers.export(exports, "faTents", ()=>faTents);
parcelHelpers.export(exports, "faWandMagic", ()=>faWandMagic);
parcelHelpers.export(exports, "faMagic", ()=>faMagic);
parcelHelpers.export(exports, "faDog", ()=>faDog);
parcelHelpers.export(exports, "faCarrot", ()=>faCarrot);
parcelHelpers.export(exports, "faMoon", ()=>faMoon);
parcelHelpers.export(exports, "faWineGlassEmpty", ()=>faWineGlassEmpty);
parcelHelpers.export(exports, "faWineGlassAlt", ()=>faWineGlassAlt);
parcelHelpers.export(exports, "faCheese", ()=>faCheese);
parcelHelpers.export(exports, "faYinYang", ()=>faYinYang);
parcelHelpers.export(exports, "faMusic", ()=>faMusic);
parcelHelpers.export(exports, "faCodeCommit", ()=>faCodeCommit);
parcelHelpers.export(exports, "faTemperatureLow", ()=>faTemperatureLow);
parcelHelpers.export(exports, "faPersonBiking", ()=>faPersonBiking);
parcelHelpers.export(exports, "faBiking", ()=>faBiking);
parcelHelpers.export(exports, "faBroom", ()=>faBroom);
parcelHelpers.export(exports, "faShieldHeart", ()=>faShieldHeart);
parcelHelpers.export(exports, "faGopuram", ()=>faGopuram);
parcelHelpers.export(exports, "faEarthOceania", ()=>faEarthOceania);
parcelHelpers.export(exports, "faGlobeOceania", ()=>faGlobeOceania);
parcelHelpers.export(exports, "faSquareXmark", ()=>faSquareXmark);
parcelHelpers.export(exports, "faTimesSquare", ()=>faTimesSquare);
parcelHelpers.export(exports, "faXmarkSquare", ()=>faXmarkSquare);
parcelHelpers.export(exports, "faHashtag", ()=>faHashtag);
parcelHelpers.export(exports, "faUpRightAndDownLeftFromCenter", ()=>faUpRightAndDownLeftFromCenter);
parcelHelpers.export(exports, "faExpandAlt", ()=>faExpandAlt);
parcelHelpers.export(exports, "faOilCan", ()=>faOilCan);
parcelHelpers.export(exports, "faT", ()=>faT);
parcelHelpers.export(exports, "faHippo", ()=>faHippo);
parcelHelpers.export(exports, "faChartColumn", ()=>faChartColumn);
parcelHelpers.export(exports, "faInfinity", ()=>faInfinity);
parcelHelpers.export(exports, "faVialCircleCheck", ()=>faVialCircleCheck);
parcelHelpers.export(exports, "faPersonArrowDownToLine", ()=>faPersonArrowDownToLine);
parcelHelpers.export(exports, "faVoicemail", ()=>faVoicemail);
parcelHelpers.export(exports, "faFan", ()=>faFan);
parcelHelpers.export(exports, "faPersonWalkingLuggage", ()=>faPersonWalkingLuggage);
parcelHelpers.export(exports, "faUpDown", ()=>faUpDown);
parcelHelpers.export(exports, "faArrowsAltV", ()=>faArrowsAltV);
parcelHelpers.export(exports, "faCloudMoonRain", ()=>faCloudMoonRain);
parcelHelpers.export(exports, "faCalendar", ()=>faCalendar);
parcelHelpers.export(exports, "faTrailer", ()=>faTrailer);
parcelHelpers.export(exports, "faBahai", ()=>faBahai);
parcelHelpers.export(exports, "faHaykal", ()=>faHaykal);
parcelHelpers.export(exports, "faSdCard", ()=>faSdCard);
parcelHelpers.export(exports, "faDragon", ()=>faDragon);
parcelHelpers.export(exports, "faShoePrints", ()=>faShoePrints);
parcelHelpers.export(exports, "faCirclePlus", ()=>faCirclePlus);
parcelHelpers.export(exports, "faPlusCircle", ()=>faPlusCircle);
parcelHelpers.export(exports, "faFaceGrinTongueWink", ()=>faFaceGrinTongueWink);
parcelHelpers.export(exports, "faGrinTongueWink", ()=>faGrinTongueWink);
parcelHelpers.export(exports, "faHandHolding", ()=>faHandHolding);
parcelHelpers.export(exports, "faPlugCircleExclamation", ()=>faPlugCircleExclamation);
parcelHelpers.export(exports, "faLinkSlash", ()=>faLinkSlash);
parcelHelpers.export(exports, "faChainBroken", ()=>faChainBroken);
parcelHelpers.export(exports, "faChainSlash", ()=>faChainSlash);
parcelHelpers.export(exports, "faUnlink", ()=>faUnlink);
parcelHelpers.export(exports, "faClone", ()=>faClone);
parcelHelpers.export(exports, "faPersonWalkingArrowLoopLeft", ()=>faPersonWalkingArrowLoopLeft);
parcelHelpers.export(exports, "faArrowUpZA", ()=>faArrowUpZA);
parcelHelpers.export(exports, "faSortAlphaUpAlt", ()=>faSortAlphaUpAlt);
parcelHelpers.export(exports, "faFireFlameCurved", ()=>faFireFlameCurved);
parcelHelpers.export(exports, "faFireAlt", ()=>faFireAlt);
parcelHelpers.export(exports, "faTornado", ()=>faTornado);
parcelHelpers.export(exports, "faFileCirclePlus", ()=>faFileCirclePlus);
parcelHelpers.export(exports, "faBookQuran", ()=>faBookQuran);
parcelHelpers.export(exports, "faQuran", ()=>faQuran);
parcelHelpers.export(exports, "faAnchor", ()=>faAnchor);
parcelHelpers.export(exports, "faBorderAll", ()=>faBorderAll);
parcelHelpers.export(exports, "faFaceAngry", ()=>faFaceAngry);
parcelHelpers.export(exports, "faAngry", ()=>faAngry);
parcelHelpers.export(exports, "faCookieBite", ()=>faCookieBite);
parcelHelpers.export(exports, "faArrowTrendDown", ()=>faArrowTrendDown);
parcelHelpers.export(exports, "faRss", ()=>faRss);
parcelHelpers.export(exports, "faFeed", ()=>faFeed);
parcelHelpers.export(exports, "faDrawPolygon", ()=>faDrawPolygon);
parcelHelpers.export(exports, "faScaleBalanced", ()=>faScaleBalanced);
parcelHelpers.export(exports, "faBalanceScale", ()=>faBalanceScale);
parcelHelpers.export(exports, "faGaugeSimpleHigh", ()=>faGaugeSimpleHigh);
parcelHelpers.export(exports, "faTachometer", ()=>faTachometer);
parcelHelpers.export(exports, "faTachometerFast", ()=>faTachometerFast);
parcelHelpers.export(exports, "faShower", ()=>faShower);
parcelHelpers.export(exports, "faDesktop", ()=>faDesktop);
parcelHelpers.export(exports, "faDesktopAlt", ()=>faDesktopAlt);
parcelHelpers.export(exports, "faM", ()=>faM);
parcelHelpers.export(exports, "faTableList", ()=>faTableList);
parcelHelpers.export(exports, "faThList", ()=>faThList);
parcelHelpers.export(exports, "faCommentSms", ()=>faCommentSms);
parcelHelpers.export(exports, "faSms", ()=>faSms);
parcelHelpers.export(exports, "faBook", ()=>faBook);
parcelHelpers.export(exports, "faUserPlus", ()=>faUserPlus);
parcelHelpers.export(exports, "faCheck", ()=>faCheck);
parcelHelpers.export(exports, "faBatteryThreeQuarters", ()=>faBatteryThreeQuarters);
parcelHelpers.export(exports, "faBattery4", ()=>faBattery4);
parcelHelpers.export(exports, "faHouseCircleCheck", ()=>faHouseCircleCheck);
parcelHelpers.export(exports, "faAngleLeft", ()=>faAngleLeft);
parcelHelpers.export(exports, "faDiagramSuccessor", ()=>faDiagramSuccessor);
parcelHelpers.export(exports, "faTruckArrowRight", ()=>faTruckArrowRight);
parcelHelpers.export(exports, "faArrowsSplitUpAndLeft", ()=>faArrowsSplitUpAndLeft);
parcelHelpers.export(exports, "faHandFist", ()=>faHandFist);
parcelHelpers.export(exports, "faFistRaised", ()=>faFistRaised);
parcelHelpers.export(exports, "faCloudMoon", ()=>faCloudMoon);
parcelHelpers.export(exports, "faBriefcase", ()=>faBriefcase);
parcelHelpers.export(exports, "faPersonFalling", ()=>faPersonFalling);
parcelHelpers.export(exports, "faImagePortrait", ()=>faImagePortrait);
parcelHelpers.export(exports, "faPortrait", ()=>faPortrait);
parcelHelpers.export(exports, "faUserTag", ()=>faUserTag);
parcelHelpers.export(exports, "faRug", ()=>faRug);
parcelHelpers.export(exports, "faEarthEurope", ()=>faEarthEurope);
parcelHelpers.export(exports, "faGlobeEurope", ()=>faGlobeEurope);
parcelHelpers.export(exports, "faCartFlatbedSuitcase", ()=>faCartFlatbedSuitcase);
parcelHelpers.export(exports, "faLuggageCart", ()=>faLuggageCart);
parcelHelpers.export(exports, "faRectangleXmark", ()=>faRectangleXmark);
parcelHelpers.export(exports, "faRectangleTimes", ()=>faRectangleTimes);
parcelHelpers.export(exports, "faTimesRectangle", ()=>faTimesRectangle);
parcelHelpers.export(exports, "faWindowClose", ()=>faWindowClose);
parcelHelpers.export(exports, "faBahtSign", ()=>faBahtSign);
parcelHelpers.export(exports, "faBookOpen", ()=>faBookOpen);
parcelHelpers.export(exports, "faBookJournalWhills", ()=>faBookJournalWhills);
parcelHelpers.export(exports, "faJournalWhills", ()=>faJournalWhills);
parcelHelpers.export(exports, "faHandcuffs", ()=>faHandcuffs);
parcelHelpers.export(exports, "faTriangleExclamation", ()=>faTriangleExclamation);
parcelHelpers.export(exports, "faExclamationTriangle", ()=>faExclamationTriangle);
parcelHelpers.export(exports, "faWarning", ()=>faWarning);
parcelHelpers.export(exports, "faDatabase", ()=>faDatabase);
parcelHelpers.export(exports, "faShare", ()=>faShare);
parcelHelpers.export(exports, "faMailForward", ()=>faMailForward);
parcelHelpers.export(exports, "faBottleDroplet", ()=>faBottleDroplet);
parcelHelpers.export(exports, "faMaskFace", ()=>faMaskFace);
parcelHelpers.export(exports, "faHillRockslide", ()=>faHillRockslide);
parcelHelpers.export(exports, "faRightLeft", ()=>faRightLeft);
parcelHelpers.export(exports, "faExchangeAlt", ()=>faExchangeAlt);
parcelHelpers.export(exports, "faPaperPlane", ()=>faPaperPlane);
parcelHelpers.export(exports, "faRoadCircleExclamation", ()=>faRoadCircleExclamation);
parcelHelpers.export(exports, "faDungeon", ()=>faDungeon);
parcelHelpers.export(exports, "faAlignRight", ()=>faAlignRight);
parcelHelpers.export(exports, "faMoneyBill1Wave", ()=>faMoneyBill1Wave);
parcelHelpers.export(exports, "faMoneyBillWaveAlt", ()=>faMoneyBillWaveAlt);
parcelHelpers.export(exports, "faLifeRing", ()=>faLifeRing);
parcelHelpers.export(exports, "faHands", ()=>faHands);
parcelHelpers.export(exports, "faSignLanguage", ()=>faSignLanguage);
parcelHelpers.export(exports, "faSigning", ()=>faSigning);
parcelHelpers.export(exports, "faCalendarDay", ()=>faCalendarDay);
parcelHelpers.export(exports, "faWaterLadder", ()=>faWaterLadder);
parcelHelpers.export(exports, "faLadderWater", ()=>faLadderWater);
parcelHelpers.export(exports, "faSwimmingPool", ()=>faSwimmingPool);
parcelHelpers.export(exports, "faArrowsUpDown", ()=>faArrowsUpDown);
parcelHelpers.export(exports, "faArrowsV", ()=>faArrowsV);
parcelHelpers.export(exports, "faFaceGrimace", ()=>faFaceGrimace);
parcelHelpers.export(exports, "faGrimace", ()=>faGrimace);
parcelHelpers.export(exports, "faWheelchairMove", ()=>faWheelchairMove);
parcelHelpers.export(exports, "faWheelchairAlt", ()=>faWheelchairAlt);
parcelHelpers.export(exports, "faTurnDown", ()=>faTurnDown);
parcelHelpers.export(exports, "faLevelDownAlt", ()=>faLevelDownAlt);
parcelHelpers.export(exports, "faPersonWalkingArrowRight", ()=>faPersonWalkingArrowRight);
parcelHelpers.export(exports, "faSquareEnvelope", ()=>faSquareEnvelope);
parcelHelpers.export(exports, "faEnvelopeSquare", ()=>faEnvelopeSquare);
parcelHelpers.export(exports, "faDice", ()=>faDice);
parcelHelpers.export(exports, "faBowlingBall", ()=>faBowlingBall);
parcelHelpers.export(exports, "faBrain", ()=>faBrain);
parcelHelpers.export(exports, "faBandage", ()=>faBandage);
parcelHelpers.export(exports, "faBandAid", ()=>faBandAid);
parcelHelpers.export(exports, "faCalendarMinus", ()=>faCalendarMinus);
parcelHelpers.export(exports, "faCircleXmark", ()=>faCircleXmark);
parcelHelpers.export(exports, "faTimesCircle", ()=>faTimesCircle);
parcelHelpers.export(exports, "faXmarkCircle", ()=>faXmarkCircle);
parcelHelpers.export(exports, "faGifts", ()=>faGifts);
parcelHelpers.export(exports, "faHotel", ()=>faHotel);
parcelHelpers.export(exports, "faEarthAsia", ()=>faEarthAsia);
parcelHelpers.export(exports, "faGlobeAsia", ()=>faGlobeAsia);
parcelHelpers.export(exports, "faIdCardClip", ()=>faIdCardClip);
parcelHelpers.export(exports, "faIdCardAlt", ()=>faIdCardAlt);
parcelHelpers.export(exports, "faMagnifyingGlassPlus", ()=>faMagnifyingGlassPlus);
parcelHelpers.export(exports, "faSearchPlus", ()=>faSearchPlus);
parcelHelpers.export(exports, "faThumbsUp", ()=>faThumbsUp);
parcelHelpers.export(exports, "faUserClock", ()=>faUserClock);
parcelHelpers.export(exports, "faHandDots", ()=>faHandDots);
parcelHelpers.export(exports, "faAllergies", ()=>faAllergies);
parcelHelpers.export(exports, "faFileInvoice", ()=>faFileInvoice);
parcelHelpers.export(exports, "faWindowMinimize", ()=>faWindowMinimize);
parcelHelpers.export(exports, "faMugSaucer", ()=>faMugSaucer);
parcelHelpers.export(exports, "faCoffee", ()=>faCoffee);
parcelHelpers.export(exports, "faBrush", ()=>faBrush);
parcelHelpers.export(exports, "faMask", ()=>faMask);
parcelHelpers.export(exports, "faMagnifyingGlassMinus", ()=>faMagnifyingGlassMinus);
parcelHelpers.export(exports, "faSearchMinus", ()=>faSearchMinus);
parcelHelpers.export(exports, "faRulerVertical", ()=>faRulerVertical);
parcelHelpers.export(exports, "faUserLarge", ()=>faUserLarge);
parcelHelpers.export(exports, "faUserAlt", ()=>faUserAlt);
parcelHelpers.export(exports, "faTrainTram", ()=>faTrainTram);
parcelHelpers.export(exports, "faUserNurse", ()=>faUserNurse);
parcelHelpers.export(exports, "faSyringe", ()=>faSyringe);
parcelHelpers.export(exports, "faCloudSun", ()=>faCloudSun);
parcelHelpers.export(exports, "faStopwatch20", ()=>faStopwatch20);
parcelHelpers.export(exports, "faSquareFull", ()=>faSquareFull);
parcelHelpers.export(exports, "faMagnet", ()=>faMagnet);
parcelHelpers.export(exports, "faJar", ()=>faJar);
parcelHelpers.export(exports, "faNoteSticky", ()=>faNoteSticky);
parcelHelpers.export(exports, "faStickyNote", ()=>faStickyNote);
parcelHelpers.export(exports, "faBugSlash", ()=>faBugSlash);
parcelHelpers.export(exports, "faArrowUpFromWaterPump", ()=>faArrowUpFromWaterPump);
parcelHelpers.export(exports, "faBone", ()=>faBone);
parcelHelpers.export(exports, "faUserInjured", ()=>faUserInjured);
parcelHelpers.export(exports, "faFaceSadTear", ()=>faFaceSadTear);
parcelHelpers.export(exports, "faSadTear", ()=>faSadTear);
parcelHelpers.export(exports, "faPlane", ()=>faPlane);
parcelHelpers.export(exports, "faTentArrowsDown", ()=>faTentArrowsDown);
parcelHelpers.export(exports, "faExclamation", ()=>faExclamation);
parcelHelpers.export(exports, "faArrowsSpin", ()=>faArrowsSpin);
parcelHelpers.export(exports, "faPrint", ()=>faPrint);
parcelHelpers.export(exports, "faTurkishLiraSign", ()=>faTurkishLiraSign);
parcelHelpers.export(exports, "faTry", ()=>faTry);
parcelHelpers.export(exports, "faTurkishLira", ()=>faTurkishLira);
parcelHelpers.export(exports, "faDollarSign", ()=>faDollarSign);
parcelHelpers.export(exports, "faDollar", ()=>faDollar);
parcelHelpers.export(exports, "faUsd", ()=>faUsd);
parcelHelpers.export(exports, "faX", ()=>faX);
parcelHelpers.export(exports, "faMagnifyingGlassDollar", ()=>faMagnifyingGlassDollar);
parcelHelpers.export(exports, "faSearchDollar", ()=>faSearchDollar);
parcelHelpers.export(exports, "faUsersGear", ()=>faUsersGear);
parcelHelpers.export(exports, "faUsersCog", ()=>faUsersCog);
parcelHelpers.export(exports, "faPersonMilitaryPointing", ()=>faPersonMilitaryPointing);
parcelHelpers.export(exports, "faBuildingColumns", ()=>faBuildingColumns);
parcelHelpers.export(exports, "faBank", ()=>faBank);
parcelHelpers.export(exports, "faInstitution", ()=>faInstitution);
parcelHelpers.export(exports, "faMuseum", ()=>faMuseum);
parcelHelpers.export(exports, "faUniversity", ()=>faUniversity);
parcelHelpers.export(exports, "faUmbrella", ()=>faUmbrella);
parcelHelpers.export(exports, "faTrowel", ()=>faTrowel);
parcelHelpers.export(exports, "faD", ()=>faD);
parcelHelpers.export(exports, "faStapler", ()=>faStapler);
parcelHelpers.export(exports, "faMasksTheater", ()=>faMasksTheater);
parcelHelpers.export(exports, "faTheaterMasks", ()=>faTheaterMasks);
parcelHelpers.export(exports, "faKipSign", ()=>faKipSign);
parcelHelpers.export(exports, "faHandPointLeft", ()=>faHandPointLeft);
parcelHelpers.export(exports, "faHandshakeSimple", ()=>faHandshakeSimple);
parcelHelpers.export(exports, "faHandshakeAlt", ()=>faHandshakeAlt);
parcelHelpers.export(exports, "faJetFighter", ()=>faJetFighter);
parcelHelpers.export(exports, "faFighterJet", ()=>faFighterJet);
parcelHelpers.export(exports, "faSquareShareNodes", ()=>faSquareShareNodes);
parcelHelpers.export(exports, "faShareAltSquare", ()=>faShareAltSquare);
parcelHelpers.export(exports, "faBarcode", ()=>faBarcode);
parcelHelpers.export(exports, "faPlusMinus", ()=>faPlusMinus);
parcelHelpers.export(exports, "faVideo", ()=>faVideo);
parcelHelpers.export(exports, "faVideoCamera", ()=>faVideoCamera);
parcelHelpers.export(exports, "faGraduationCap", ()=>faGraduationCap);
parcelHelpers.export(exports, "faMortarBoard", ()=>faMortarBoard);
parcelHelpers.export(exports, "faHandHoldingMedical", ()=>faHandHoldingMedical);
parcelHelpers.export(exports, "faPersonCircleCheck", ()=>faPersonCircleCheck);
parcelHelpers.export(exports, "faTurnUp", ()=>faTurnUp);
parcelHelpers.export(exports, "faLevelUpAlt", ()=>faLevelUpAlt);
var prefix = "fas";
var fa0 = {
    prefix: "fas",
    iconName: "0",
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
    ]
};
var fa1 = {
    prefix: "fas",
    iconName: "1",
    icon: [
        256,
        512,
        [],
        "31",
        "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"
    ]
};
var fa2 = {
    prefix: "fas",
    iconName: "2",
    icon: [
        320,
        512,
        [],
        "32",
        "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
    ]
};
var fa3 = {
    prefix: "fas",
    iconName: "3",
    icon: [
        320,
        512,
        [],
        "33",
        "M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var fa4 = {
    prefix: "fas",
    iconName: "4",
    icon: [
        384,
        512,
        [],
        "34",
        "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"
    ]
};
var fa5 = {
    prefix: "fas",
    iconName: "5",
    icon: [
        320,
        512,
        [],
        "35",
        "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
    ]
};
var fa6 = {
    prefix: "fas",
    iconName: "6",
    icon: [
        320,
        512,
        [],
        "36",
        "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"
    ]
};
var fa7 = {
    prefix: "fas",
    iconName: "7",
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var fa8 = {
    prefix: "fas",
    iconName: "8",
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
    ]
};
var fa9 = {
    prefix: "fas",
    iconName: "9",
    icon: [
        320,
        512,
        [],
        "39",
        "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
    ]
};
var faFillDrip = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
    ]
};
var faArrowsToCircle = {
    prefix: "fas",
    iconName: "arrows-to-circle",
    icon: [
        640,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"
    ]
};
var faCircleChevronRight = {
    prefix: "fas",
    iconName: "circle-chevron-right",
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
var faChevronCircleRight = faCircleChevronRight;
var faAt = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var faTrashCan = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var faTrashAlt = faTrashCan;
var faTextHeight = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var faUserXmark = {
    prefix: "fas",
    iconName: "user-xmark",
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var faUserTimes = faUserXmark;
var faStethoscope = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faMessage = {
    prefix: "fas",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
    ]
};
var faCommentAlt = faMessage;
var faInfo = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var faDownLeftAndUpRightToCenter = {
    prefix: "fas",
    iconName: "down-left-and-up-right-to-center",
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"
    ]
};
var faCompressAlt = faDownLeftAndUpRightToCenter;
var faExplosion = {
    prefix: "fas",
    iconName: "explosion",
    icon: [
        576,
        512,
        [],
        "e4e9",
        "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
    ]
};
var faFileLines = {
    prefix: "fas",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faWaveSquare = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
    ]
};
var faRing = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"
    ]
};
var faBuildingUn = {
    prefix: "fas",
    iconName: "building-un",
    icon: [
        384,
        512,
        [],
        "e4d9",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faDiceThree = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faCalendarDays = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var faCalendarAlt = faCalendarDays;
var faAnchorCircleCheck = {
    prefix: "fas",
    iconName: "anchor-circle-check",
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faBuildingCircleArrowRight = {
    prefix: "fas",
    iconName: "building-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e4d1",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
var faVolleyball = {
    prefix: "fas",
    iconName: "volleyball",
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
    ]
};
var faVolleyballBall = faVolleyball;
var faArrowsUpToLine = {
    prefix: "fas",
    iconName: "arrows-up-to-line",
    icon: [
        576,
        512,
        [],
        "e4c2",
        "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
    ]
};
var faSortDown = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
    ]
};
var faSortDesc = faSortDown;
var faCircleMinus = {
    prefix: "fas",
    iconName: "circle-minus",
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faMinusCircle = faCircleMinus;
var faDoorOpen = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        576,
        512,
        [],
        "f52b",
        "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"
    ]
};
var faRightFromBracket = {
    prefix: "fas",
    iconName: "right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var faSignOutAlt = faRightFromBracket;
var faAtom = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        512,
        512,
        [
            9883
        ],
        "f5d2",
        "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faSoap = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"
    ]
};
var faIcons = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
    ]
};
var faHeartMusicCameraBolt = faIcons;
var faMicrophoneLinesSlash = {
    prefix: "fas",
    iconName: "microphone-lines-slash",
    icon: [
        640,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM358.2 378.2C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z"
    ]
};
var faMicrophoneAltSlash = faMicrophoneLinesSlash;
var faBridgeCircleCheck = {
    prefix: "fas",
    iconName: "bridge-circle-check",
    icon: [
        640,
        512,
        [],
        "e4c9",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faPumpMedical = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        448,
        512,
        [],
        "e06a",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var faFingerprint = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"
    ]
};
var faHandPointRight = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
    ]
};
var faMagnifyingGlassLocation = {
    prefix: "fas",
    iconName: "magnifying-glass-location",
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faSearchLocation = faMagnifyingGlassLocation;
var faForwardStep = {
    prefix: "fas",
    iconName: "forward-step",
    icon: [
        320,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
    ]
};
var faStepForward = faForwardStep;
var faFaceSmileBeam = {
    prefix: "fas",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faSmileBeam = faFaceSmileBeam;
var faFlagCheckered = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        448,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
    ]
};
var faFootball = {
    prefix: "fas",
    iconName: "football",
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var faFootballBall = faFootball;
var faSchoolCircleExclamation = {
    prefix: "fas",
    iconName: "school-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e56c",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faCrop = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"
    ]
};
var faAnglesDown = {
    prefix: "fas",
    iconName: "angles-down",
    icon: [
        448,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var faAngleDoubleDown = faAnglesDown;
var faUsersRectangle = {
    prefix: "fas",
    iconName: "users-rectangle",
    icon: [
        640,
        512,
        [],
        "e594",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var faPeopleRoof = {
    prefix: "fas",
    iconName: "people-roof",
    icon: [
        640,
        512,
        [],
        "e537",
        "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
    ]
};
var faPeopleLine = {
    prefix: "fas",
    iconName: "people-line",
    icon: [
        640,
        512,
        [],
        "e534",
        "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"
    ]
};
var faBeerMugEmpty = {
    prefix: "fas",
    iconName: "beer-mug-empty",
    icon: [
        512,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
    ]
};
var faBeer = faBeerMugEmpty;
var faDiagramPredecessor = {
    prefix: "fas",
    iconName: "diagram-predecessor",
    icon: [
        512,
        512,
        [],
        "e477",
        "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
    ]
};
var faArrowUpLong = {
    prefix: "fas",
    iconName: "arrow-up-long",
    icon: [
        384,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
var faLongArrowUp = faArrowUpLong;
var faFireFlameSimple = {
    prefix: "fas",
    iconName: "fire-flame-simple",
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
var faBurn = faFireFlameSimple;
var faPerson = {
    prefix: "fas",
    iconName: "person",
    icon: [
        320,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"
    ]
};
var faMale = faPerson;
var faLaptop = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
    ]
};
var faFileCsv = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        512,
        512,
        [],
        "f6dd",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
    ]
};
var faMenorah = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"
    ]
};
var faTruckPlane = {
    prefix: "fas",
    iconName: "truck-plane",
    icon: [
        640,
        512,
        [],
        "e58f",
        "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faRecordVinyl = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faFaceGrinStars = {
    prefix: "fas",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
    ]
};
var faGrinStars = faFaceGrinStars;
var faBong = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var faSpaghettiMonsterFlying = {
    prefix: "fas",
    iconName: "spaghetti-monster-flying",
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var faPastafarianism = faSpaghettiMonsterFlying;
var faArrowDownUpAcrossLine = {
    prefix: "fas",
    iconName: "arrow-down-up-across-line",
    icon: [
        576,
        512,
        [],
        "e4af",
        "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
    ]
};
var faSpoon = {
    prefix: "fas",
    iconName: "spoon",
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
var faUtensilSpoon = faSpoon;
var faJarWheat = {
    prefix: "fas",
    iconName: "jar-wheat",
    icon: [
        320,
        512,
        [],
        "e517",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
var faEnvelopesBulk = {
    prefix: "fas",
    iconName: "envelopes-bulk",
    icon: [
        640,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"
    ]
};
var faMailBulk = faEnvelopesBulk;
var faFileCircleExclamation = {
    prefix: "fas",
    iconName: "file-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var faCircleH = {
    prefix: "fas",
    iconName: "circle-h",
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var faHospitalSymbol = faCircleH;
var faPager = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
    ]
};
var faAddressBook = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var faContactBook = faAddressBook;
var faStrikethrough = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
    ]
};
var faK = {
    prefix: "fas",
    iconName: "k",
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
var faLandmarkFlag = {
    prefix: "fas",
    iconName: "landmark-flag",
    icon: [
        512,
        512,
        [],
        "e51c",
        "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var faPencil = {
    prefix: "fas",
    iconName: "pencil",
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faPencilAlt = faPencil;
var faBackward = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"
    ]
};
var faCaretRight = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
};
var faComments = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
    ]
};
var faPaste = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faFileClipboard = faPaste;
var faCodePullRequest = {
    prefix: "fas",
    iconName: "code-pull-request",
    icon: [
        512,
        512,
        [],
        "e13c",
        "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faClipboardList = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
    ]
};
var faTruckRampBox = {
    prefix: "fas",
    iconName: "truck-ramp-box",
    icon: [
        640,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
    ]
};
var faTruckLoading = faTruckRampBox;
var faUserCheck = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var faVialVirus = {
    prefix: "fas",
    iconName: "vial-virus",
    icon: [
        512,
        512,
        [],
        "e597",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faSheetPlastic = {
    prefix: "fas",
    iconName: "sheet-plastic",
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"
    ]
};
var faBlog = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"
    ]
};
var faUserNinja = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
    ]
};
var faPersonArrowUpFromLine = {
    prefix: "fas",
    iconName: "person-arrow-up-from-line",
    icon: [
        640,
        512,
        [],
        "e539",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var faScrollTorah = {
    prefix: "fas",
    iconName: "scroll-torah",
    icon: [
        640,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"
    ]
};
var faTorah = faScrollTorah;
var faBroomBall = {
    prefix: "fas",
    iconName: "broom-ball",
    icon: [
        576,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var faQuidditch = faBroomBall;
var faQuidditchBroomBall = faBroomBall;
var faToggleOff = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var faBoxArchive = {
    prefix: "fas",
    iconName: "box-archive",
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var faArchive = faBoxArchive;
var faPersonDrowning = {
    prefix: "fas",
    iconName: "person-drowning",
    icon: [
        576,
        512,
        [],
        "e545",
        "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var faArrowDown91 = {
    prefix: "fas",
    iconName: "arrow-down-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var faSortNumericDesc = faArrowDown91;
var faSortNumericDownAlt = faArrowDown91;
var faFaceGrinTongueSquint = {
    prefix: "fas",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faSprayCan = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faTruckMonster = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var faW = {
    prefix: "fas",
    iconName: "w",
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
var faEarthAfrica = {
    prefix: "fas",
    iconName: "earth-africa",
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var faGlobeAfrica = faEarthAfrica;
var faRainbow = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
    ]
};
var faCircleNotch = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
var faTabletScreenButton = {
    prefix: "fas",
    iconName: "tablet-screen-button",
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"
    ]
};
var faTabletAlt = faTabletScreenButton;
var faPaw = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    ]
};
var faCloud = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
    ]
};
var faTrowelBricks = {
    prefix: "fas",
    iconName: "trowel-bricks",
    icon: [
        512,
        512,
        [],
        "e58a",
        "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"
    ]
};
var faFaceFlushed = {
    prefix: "fas",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faFlushed = faFaceFlushed;
var faHospitalUser = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        576,
        512,
        [],
        "f80d",
        "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var faTentArrowLeftRight = {
    prefix: "fas",
    iconName: "tent-arrow-left-right",
    icon: [
        576,
        512,
        [],
        "e57f",
        "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var faGavel = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
    ]
};
var faLegal = faGavel;
var faBinoculars = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"
    ]
};
var faMicrophoneSlash = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var faBoxTissue = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"
    ]
};
var faMotorcycle = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faBellConcierge = {
    prefix: "fas",
    iconName: "bell-concierge",
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var faConciergeBell = faBellConcierge;
var faPenRuler = {
    prefix: "fas",
    iconName: "pen-ruler",
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
    ]
};
var faPencilRuler = faPenRuler;
var faPeopleArrows = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        640,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
    ]
};
var faPeopleArrowsLeftRight = faPeopleArrows;
var faMarsAndVenusBurst = {
    prefix: "fas",
    iconName: "mars-and-venus-burst",
    icon: [
        640,
        512,
        [],
        "e523",
        "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2V408H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v32c0 13.3 10.7 24 24 24s24-10.7 24-24V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424V382.2c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
    ]
};
var faSquareCaretRight = {
    prefix: "fas",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var faCaretSquareRight = faSquareCaretRight;
var faScissors = {
    prefix: "fas",
    iconName: "scissors",
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faCut = faScissors;
var faSunPlantWilt = {
    prefix: "fas",
    iconName: "sun-plant-wilt",
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"
    ]
};
var faToiletsPortable = {
    prefix: "fas",
    iconName: "toilets-portable",
    icon: [
        576,
        512,
        [],
        "e584",
        "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"
    ]
};
var faHockeyPuck = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
    ]
};
var faTable = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var faMagnifyingGlassArrowRight = {
    prefix: "fas",
    iconName: "magnifying-glass-arrow-right",
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
    ]
};
var faTachographDigital = {
    prefix: "fas",
    iconName: "tachograph-digital",
    icon: [
        640,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var faDigitalTachograph = faTachographDigital;
var faUsersSlash = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"
    ]
};
var faClover = {
    prefix: "fas",
    iconName: "clover",
    icon: [
        448,
        512,
        [],
        "e139",
        "M216.6 49.9C205.1 38.5 189.5 32 173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2z"
    ]
};
var faReply = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
    ]
};
var faMailReply = faReply;
var faStarAndCrescent = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [
            9770
        ],
        "f699",
        "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
var faHouseFire = {
    prefix: "fas",
    iconName: "house-fire",
    icon: [
        640,
        512,
        [],
        "e50c",
        "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM480 512c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var faSquareMinus = {
    prefix: "fas",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faMinusSquare = faSquareMinus;
var faHelicopter = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [
            128641
        ],
        "f533",
        "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var faCompass = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faSquareCaretDown = {
    prefix: "fas",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var faCaretSquareDown = faSquareCaretDown;
var faFileCircleQuestion = {
    prefix: "fas",
    iconName: "file-circle-question",
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var faLaptopCode = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var faSwatchbook = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faPrescriptionBottle = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"
    ]
};
var faBars = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var faNavicon = faBars;
var faPeopleGroup = {
    prefix: "fas",
    iconName: "people-group",
    icon: [
        640,
        512,
        [],
        "e533",
        "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
    ]
};
var faHourglassEnd = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
var faHourglass3 = faHourglassEnd;
var faHeartCrack = {
    prefix: "fas",
    iconName: "heart-crack",
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
    ]
};
var faHeartBroken = faHeartCrack;
var faSquareUpRight = {
    prefix: "fas",
    iconName: "square-up-right",
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"
    ]
};
var faExternalLinkSquareAlt = faSquareUpRight;
var faFaceKissBeam = {
    prefix: "fas",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faKissBeam = faFaceKissBeam;
var faFilm = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [
            127902
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"
    ]
};
var faRulerHorizontal = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        640,
        512,
        [],
        "f547",
        "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
    ]
};
var faPeopleRobbery = {
    prefix: "fas",
    iconName: "people-robbery",
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
    ]
};
var faLightbulb = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
};
var faCaretLeft = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
var faCircleExclamation = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faExclamationCircle = faCircleExclamation;
var faSchoolCircleXmark = {
    prefix: "fas",
    iconName: "school-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e56d",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
    ]
};
var faArrowRightFromBracket = {
    prefix: "fas",
    iconName: "arrow-right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
var faSignOut = faArrowRightFromBracket;
var faCircleChevronDown = {
    prefix: "fas",
    iconName: "circle-chevron-down",
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
var faChevronCircleDown = faCircleChevronDown;
var faUnlockKeyhole = {
    prefix: "fas",
    iconName: "unlock-keyhole",
    icon: [
        448,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
    ]
};
var faUnlockAlt = faUnlockKeyhole;
var faCloudShowersHeavy = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
    ]
};
var faHeadphonesSimple = {
    prefix: "fas",
    iconName: "headphones-simple",
    icon: [
        512,
        512,
        [
            "headphones-alt"
        ],
        "f58f",
        "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
    ]
};
var faHeadphonesAlt = faHeadphonesSimple;
var faSitemap = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        576,
        512,
        [],
        "f0e8",
        "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"
    ]
};
var faCircleDollarToSlot = {
    prefix: "fas",
    iconName: "circle-dollar-to-slot",
    icon: [
        512,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 84c-11 0-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104c0-11-9-20-20-20zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"
    ]
};
var faDonate = faCircleDollarToSlot;
var faMemory = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        576,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var faRoadSpikes = {
    prefix: "fas",
    iconName: "road-spikes",
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faFireBurner = {
    prefix: "fas",
    iconName: "fire-burner",
    icon: [
        640,
        512,
        [],
        "e4f1",
        "M320 352c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C464.5 108 480 160.2 480 192c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C293 167.1 256 203.6 256 240.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faFlag = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"
    ]
};
var faHanukiah = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
    ]
};
var faFeather = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var faVolumeLow = {
    prefix: "fas",
    iconName: "volume-low",
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
    ]
};
var faVolumeDown = faVolumeLow;
var faCommentSlash = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zm385.2 425L82.9 161.3C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9z"
    ]
};
var faCloudSunRain = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        640,
        512,
        [
            127782
        ],
        "f743",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var faCompress = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var faWheatAwn = {
    prefix: "fas",
    iconName: "wheat-awn",
    icon: [
        512,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
    ]
};
var faWheatAlt = faWheatAwn;
var faAnkh = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
    ]
};
var faHandsHoldingChild = {
    prefix: "fas",
    iconName: "hands-holding-child",
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var faAsterisk = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        384,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"
    ]
};
var faSquareCheck = {
    prefix: "fas",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var faCheckSquare = faSquareCheck;
var faPesetaSign = {
    prefix: "fas",
    iconName: "peseta-sign",
    icon: [
        384,
        512,
        [],
        "e221",
        "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"
    ]
};
var faHeading = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var faHeader = faHeading;
var faGhost = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faList = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
    ]
};
var faListSquares = faList;
var faSquarePhoneFlip = {
    prefix: "fas",
    iconName: "square-phone-flip",
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
    ]
};
var faPhoneSquareAlt = faSquarePhoneFlip;
var faCartPlus = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"
    ]
};
var faGamepad = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"
    ]
};
var faCircleDot = {
    prefix: "fas",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var faDotCircle = faCircleDot;
var faFaceDizzy = {
    prefix: "fas",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var faDizzy = faFaceDizzy;
var faEgg = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
    ]
};
var faHouseMedicalCircleXmark = {
    prefix: "fas",
    iconName: "house-medical-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e513",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var faCampground = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        576,
        512,
        [
            9978
        ],
        "f6bb",
        "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"
    ]
};
var faFolderPlus = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var faFutbol = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faPaintbrush = {
    prefix: "fas",
    iconName: "paintbrush",
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
    ]
};
var faPaintBrush = faPaintbrush;
var faLock = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [
            128274
        ],
        "f023",
        "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
    ]
};
var faGasPump = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
    ]
};
var faHotTubPerson = {
    prefix: "fas",
    iconName: "hot-tub-person",
    icon: [
        512,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
    ]
};
var faHotTub = faHotTubPerson;
var faMapLocation = {
    prefix: "fas",
    iconName: "map-location",
    icon: [
        576,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"
    ]
};
var faMapMarked = faMapLocation;
var faHouseFloodWater = {
    prefix: "fas",
    iconName: "house-flood-water",
    icon: [
        576,
        512,
        [],
        "e50e",
        "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var faTree = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
    ]
};
var faBridgeLock = {
    prefix: "fas",
    iconName: "bridge-lock",
    icon: [
        640,
        512,
        [],
        "e4cc",
        "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var faSackDollar = {
    prefix: "fas",
    iconName: "sack-dollar",
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"
    ]
};
var faPenToSquare = {
    prefix: "fas",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
    ]
};
var faEdit = faPenToSquare;
var faCarSide = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faShareNodes = {
    prefix: "fas",
    iconName: "share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
};
var faShareAlt = faShareNodes;
var faHeartCircleMinus = {
    prefix: "fas",
    iconName: "heart-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var faHourglassHalf = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"
    ]
};
var faHourglass2 = faHourglassHalf;
var faMicroscope = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faSink = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"
    ]
};
var faBagShopping = {
    prefix: "fas",
    iconName: "bag-shopping",
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faShoppingBag = faBagShopping;
var faArrowDownZA = {
    prefix: "fas",
    iconName: "arrow-down-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"
    ]
};
var faSortAlphaDesc = faArrowDownZA;
var faSortAlphaDownAlt = faArrowDownZA;
var faMitten = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"
    ]
};
var faPersonRays = {
    prefix: "fas",
    iconName: "person-rays",
    icon: [
        512,
        512,
        [],
        "e54d",
        "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var faUsers = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
    ]
};
var faEyeSlash = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
    ]
};
var faFlaskVial = {
    prefix: "fas",
    iconName: "flask-vial",
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
    ]
};
var faHand = {
    prefix: "fas",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
    ]
};
var faHandPaper = faHand;
var faOm = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [
            128329
        ],
        "f679",
        "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM281 66.7c-2.2-1.5-4.9-2.5-7.7-2.7c-.6 0-1.3-.1-1.9 0c-3.9 .2-7.4 1.7-10.1 4.2c-.9 .8-1.6 1.7-2.3 2.6c-1.7 2.4-2.7 5.3-2.9 8.5c0 .7 0 1.4 0 2.1c.2 2.2 .9 4.3 1.9 6.2l.3 .6c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .1-.1 .1-.1 0 0 0 0c5.9-5.8 9.5-13.9 9.5-22.8c0-17.7-14.3-32-32-32c-8.7 0-16.7 3.5-22.4 9.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5c-.3-.9-.7-1.8-1.1-2.6c-1.2-2.2-2.8-4-4.7-5.4c-1.9-1.4-4.1-2.3-6.5-2.8c-1.4-.3-2.9-.3-4.4-.2c-2.5 .2-4.8 1-6.8 2.3c-1.1 .7-2.2 1.5-3.1 2.5c-2.4 2.5-4.1 5.8-4.5 9.5c-.1 .6-.1 1.1-.1 1.7c0 0 0 0 0 0c0 .8 .1 1.7 .2 2.5l0 .1c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.2c-.3-1.3-.8-2.6-1.5-3.8c-1.1-2-2.6-3.8-4.4-5.1c-2.7-2-6-3.2-9.6-3.2l-.2 0c-8 .1-14.6 6.1-15.6 13.9l0 0c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4z"
    ]
};
var faWorm = {
    prefix: "fas",
    iconName: "worm",
    icon: [
        512,
        512,
        [],
        "e599",
        "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var faHouseCircleXmark = {
    prefix: "fas",
    iconName: "house-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e50b",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faPlug = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [
            128268
        ],
        "f1e6",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var faChevronUp = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
var faHandSpock = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
var faStopwatch = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var faFaceKiss = {
    prefix: "fas",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faKiss = faFaceKiss;
var faBridgeCircleXmark = {
    prefix: "fas",
    iconName: "bridge-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4cb",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faFaceGrinTongue = {
    prefix: "fas",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var faGrinTongue = faFaceGrinTongue;
var faChessBishop = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"
    ]
};
var faFaceGrinWink = {
    prefix: "fas",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faGrinWink = faFaceGrinWink;
var faEarDeaf = {
    prefix: "fas",
    iconName: "ear-deaf",
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var faDeaf = faEarDeaf;
var faDeafness = faEarDeaf;
var faHardOfHearing = faEarDeaf;
var faRoadCircleCheck = {
    prefix: "fas",
    iconName: "road-circle-check",
    icon: [
        640,
        512,
        [],
        "e564",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var faDiceFive = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faSquareRss = {
    prefix: "fas",
    iconName: "square-rss",
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faRssSquare = faSquareRss;
var faLandMineOn = {
    prefix: "fas",
    iconName: "land-mine-on",
    icon: [
        640,
        512,
        [],
        "e51b",
        "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
    ]
};
var faICursor = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
var faStamp = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"
    ]
};
var faStairs = {
    prefix: "fas",
    iconName: "stairs",
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"
    ]
};
var faI = {
    prefix: "fas",
    iconName: "i",
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"
    ]
};
var faHryvniaSign = {
    prefix: "fas",
    iconName: "hryvnia-sign",
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
    ]
};
var faHryvnia = faHryvniaSign;
var faPills = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
    ]
};
var faFaceGrinWide = {
    prefix: "fas",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var faGrinAlt = faFaceGrinWide;
var faTooth = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [
            129463
        ],
        "f5c9",
        "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
    ]
};
var faV = {
    prefix: "fas",
    iconName: "v",
    icon: [
        384,
        512,
        [
            118
        ],
        "56",
        "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
var faBangladeshiTakaSign = {
    prefix: "fas",
    iconName: "bangladeshi-taka-sign",
    icon: [
        384,
        512,
        [],
        "e2e6",
        "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
    ]
};
var faBicycle = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"
    ]
};
var faStaffSnake = {
    prefix: "fas",
    iconName: "staff-snake",
    icon: [
        384,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faRodAsclepius = faStaffSnake;
var faRodSnake = faStaffSnake;
var faStaffAesculapius = faStaffSnake;
var faHeadSideCoughSlash = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faTruckMedical = {
    prefix: "fas",
    iconName: "truck-medical",
    icon: [
        640,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"
    ]
};
var faAmbulance = faTruckMedical;
var faWheatAwnCircleExclamation = {
    prefix: "fas",
    iconName: "wheat-awn-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e598",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faSnowman = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var faMortarPestle = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var faRoadBarrier = {
    prefix: "fas",
    iconName: "road-barrier",
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
    ]
};
var faSchool = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [
            127979
        ],
        "f549",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H256V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"
    ]
};
var faIgloo = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"
    ]
};
var faJoint = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
    ]
};
var faAngleRight = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
var faHorse = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var faQ = {
    prefix: "fas",
    iconName: "q",
    icon: [
        448,
        512,
        [
            113
        ],
        "51",
        "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
var faG = {
    prefix: "fas",
    iconName: "g",
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
var faNotesMedical = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"
    ]
};
var faTemperatureHalf = {
    prefix: "fas",
    iconName: "temperature-half",
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var faTemperature2 = faTemperatureHalf;
var faThermometer2 = faTemperatureHalf;
var faThermometerHalf = faTemperatureHalf;
var faDongSign = {
    prefix: "fas",
    iconName: "dong-sign",
    icon: [
        384,
        512,
        [],
        "e169",
        "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var faCapsules = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
    ]
};
var faPooStorm = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 40.9 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
    ]
};
var faPooBolt = faPooStorm;
var faFaceFrownOpen = {
    prefix: "fas",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
var faFrownOpen = faFaceFrownOpen;
var faHandPointUp = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var faMoneyBill = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        576,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var faBookmark = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
    ]
};
var faAlignJustify = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"
    ]
};
var faUmbrellaBeach = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        576,
        512,
        [
            127958
        ],
        "f5ca",
        "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
    ]
};
var faHelmetUn = {
    prefix: "fas",
    iconName: "helmet-un",
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faBullseye = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faBacon = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
    ]
};
var faHandPointDown = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
    ]
};
var faArrowUpFromBracket = {
    prefix: "fas",
    iconName: "arrow-up-from-bracket",
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"
    ]
};
var faFolder = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
    ]
};
var faFolderBlank = faFolder;
var faFileWaveform = {
    prefix: "fas",
    iconName: "file-waveform",
    icon: [
        448,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"
    ]
};
var faFileMedicalAlt = faFileWaveform;
var faRadiation = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        512,
        512,
        [],
        "f7b9",
        "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faChartSimple = {
    prefix: "fas",
    iconName: "chart-simple",
    icon: [
        448,
        512,
        [],
        "e473",
        "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var faMarsStroke = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        512,
        512,
        [
            9894
        ],
        "f229",
        "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"
    ]
};
var faVial = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"
    ]
};
var faGauge = {
    prefix: "fas",
    iconName: "gauge",
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faDashboard = faGauge;
var faGaugeMed = faGauge;
var faTachometerAltAverage = faGauge;
var faWandMagicSparkles = {
    prefix: "fas",
    iconName: "wand-magic-sparkles",
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
    ]
};
var faMagicWandSparkles = faWandMagicSparkles;
var faE = {
    prefix: "fas",
    iconName: "e",
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var faPenClip = {
    prefix: "fas",
    iconName: "pen-clip",
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
    ]
};
var faPenAlt = faPenClip;
var faBridgeCircleExclamation = {
    prefix: "fas",
    iconName: "bridge-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ca",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faUser = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    ]
};
var faSchoolCircleCheck = {
    prefix: "fas",
    iconName: "school-circle-check",
    icon: [
        640,
        512,
        [],
        "e56b",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
    ]
};
var faDumpster = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
    ]
};
var faVanShuttle = {
    prefix: "fas",
    iconName: "van-shuttle",
    icon: [
        640,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faShuttleVan = faVanShuttle;
var faBuildingUser = {
    prefix: "fas",
    iconName: "building-user",
    icon: [
        640,
        512,
        [],
        "e4da",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var faSquareCaretLeft = {
    prefix: "fas",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faHighlighter = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        576,
        512,
        [],
        "f591",
        "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
var faKey = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var faBullhorn = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"
    ]
};
var faGlobe = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
    ]
};
var faSynagogue = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [
            128333
        ],
        "f69b",
        "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
    ]
};
var faPersonHalfDress = {
    prefix: "fas",
    iconName: "person-half-dress",
    icon: [
        320,
        512,
        [],
        "e548",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
    ]
};
var faRoadBridge = {
    prefix: "fas",
    iconName: "road-bridge",
    icon: [
        640,
        512,
        [],
        "e563",
        "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"
    ]
};
var faLocationArrow = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        448,
        512,
        [],
        "f124",
        "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
    ]
};
var faC = {
    prefix: "fas",
    iconName: "c",
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var faTabletButton = {
    prefix: "fas",
    iconName: "tablet-button",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faBuildingLock = {
    prefix: "fas",
    iconName: "building-lock",
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var faPizzaSlice = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faMoneyBillWave = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        576,
        512,
        [],
        "f53a",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
    ]
};
var faChartArea = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
    ]
};
var faAreaChart = faChartArea;
var faHouseFlag = {
    prefix: "fas",
    iconName: "house-flag",
    icon: [
        640,
        512,
        [],
        "e50d",
        "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"
    ]
};
var faPersonCircleMinus = {
    prefix: "fas",
    iconName: "person-circle-minus",
    icon: [
        576,
        512,
        [],
        "e540",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var faBan = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var faCancel = faBan;
var faCameraRotate = {
    prefix: "fas",
    iconName: "camera-rotate",
    icon: [
        640,
        512,
        [],
        "e0d8",
        "M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"
    ]
};
var faSprayCanSparkles = {
    prefix: "fas",
    iconName: "spray-can-sparkles",
    icon: [
        512,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
var faAirFreshener = faSprayCanSparkles;
var faStar = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
};
var faRepeat = {
    prefix: "fas",
    iconName: "repeat",
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"
    ]
};
var faCross = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"
    ]
};
var faBox = {
    prefix: "fas",
    iconName: "box",
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"
    ]
};
var faVenusMars = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
    ]
};
var faArrowPointer = {
    prefix: "fas",
    iconName: "arrow-pointer",
    icon: [
        320,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
    ]
};
var faMousePointer = faArrowPointer;
var faMaximize = {
    prefix: "fas",
    iconName: "maximize",
    icon: [
        512,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
    ]
};
var faExpandArrowsAlt = faMaximize;
var faChargingStation = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
    ]
};
var faShapes = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
    ]
};
var faTriangleCircleSquare = faShapes;
var faShuffle = {
    prefix: "fas",
    iconName: "shuffle",
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
var faRandom = faShuffle;
var faPersonRunning = {
    prefix: "fas",
    iconName: "person-running",
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"
    ]
};
var faRunning = faPersonRunning;
var faMobileRetro = {
    prefix: "fas",
    iconName: "mobile-retro",
    icon: [
        320,
        512,
        [],
        "e527",
        "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
    ]
};
var faGripLinesVertical = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
    ]
};
var faSpider = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        512,
        512,
        [
            128375
        ],
        "f717",
        "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
    ]
};
var faHandsBound = {
    prefix: "fas",
    iconName: "hands-bound",
    icon: [
        640,
        512,
        [],
        "e4f9",
        "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
    ]
};
var faFileInvoiceDollar = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0 0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
    ]
};
var faPlaneCircleExclamation = {
    prefix: "fas",
    iconName: "plane-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e556",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faXRay = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var faSpellCheck = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
    ]
};
var faSlash = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
    ]
};
var faComputerMouse = {
    prefix: "fas",
    iconName: "computer-mouse",
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"
    ]
};
var faMouse = faComputerMouse;
var faArrowRightToBracket = {
    prefix: "fas",
    iconName: "arrow-right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var faSignIn = faArrowRightToBracket;
var faShopSlash = {
    prefix: "fas",
    iconName: "shop-slash",
    icon: [
        640,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384zM544 512l-.3 0h.6l-.3 0z"
    ]
};
var faStoreAltSlash = faShopSlash;
var faServer = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faVirusCovidSlash = {
    prefix: "fas",
    iconName: "virus-covid-slash",
    icon: [
        640,
        512,
        [],
        "e4a9",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zm362.5 407L149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var faShopLock = {
    prefix: "fas",
    iconName: "shop-lock",
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var faHourglassStart = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
var faHourglass1 = faHourglassStart;
var faBlenderPhone = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
    ]
};
var faBuildingWheat = {
    prefix: "fas",
    iconName: "building-wheat",
    icon: [
        640,
        512,
        [],
        "e4db",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
    ]
};
var faPersonBreastfeeding = {
    prefix: "fas",
    iconName: "person-breastfeeding",
    icon: [
        448,
        512,
        [],
        "e53a",
        "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
    ]
};
var faRightToBracket = {
    prefix: "fas",
    iconName: "right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faSignInAlt = faRightToBracket;
var faVenus = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"
    ]
};
var faPassport = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var faHeartPulse = {
    prefix: "fas",
    iconName: "heart-pulse",
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
    ]
};
var faHeartbeat = faHeartPulse;
var faPeopleCarryBox = {
    prefix: "fas",
    iconName: "people-carry-box",
    icon: [
        640,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
    ]
};
var faPeopleCarry = faPeopleCarryBox;
var faTemperatureHigh = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
    ]
};
var faMicrochip = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"
    ]
};
var faCrown = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
    ]
};
var faWeightHanging = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"
    ]
};
var faXmarksLines = {
    prefix: "fas",
    iconName: "xmarks-lines",
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var faFilePrescription = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"
    ]
};
var faWeightScale = {
    prefix: "fas",
    iconName: "weight-scale",
    icon: [
        512,
        512,
        [
            "weight"
        ],
        "f496",
        "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
    ]
};
var faWeight = faWeightScale;
var faUserGroup = {
    prefix: "fas",
    iconName: "user-group",
    icon: [
        640,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
    ]
};
var faUserFriends = faUserGroup;
var faArrowUpAZ = {
    prefix: "fas",
    iconName: "arrow-up-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"
    ]
};
var faSortAlphaUp = faArrowUpAZ;
var faChessKnight = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"
    ]
};
var faFaceLaughSquint = {
    prefix: "fas",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var faLaughSquint = faFaceLaughSquint;
var faWheelchair = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"
    ]
};
var faCircleArrowUp = {
    prefix: "fas",
    iconName: "circle-arrow-up",
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"
    ]
};
var faArrowCircleUp = faCircleArrowUp;
var faToggleOn = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var faPersonWalking = {
    prefix: "fas",
    iconName: "person-walking",
    icon: [
        320,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
    ]
};
var faWalking = faPersonWalking;
var faL = {
    prefix: "fas",
    iconName: "l",
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
    ]
};
var faFire = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
    ]
};
var faBedPulse = {
    prefix: "fas",
    iconName: "bed-pulse",
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var faProcedures = faBedPulse;
var faShuttleSpace = {
    prefix: "fas",
    iconName: "shuttle-space",
    icon: [
        640,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
    ]
};
var faSpaceShuttle = faShuttleSpace;
var faFaceLaugh = {
    prefix: "fas",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
    ]
};
var faHeartCirclePlus = {
    prefix: "fas",
    iconName: "heart-circle-plus",
    icon: [
        576,
        512,
        [],
        "e500",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faCodeFork = {
    prefix: "fas",
    iconName: "code-fork",
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var faCity = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [
            127961
        ],
        "f64f",
        "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var faMicrophoneLines = {
    prefix: "fas",
    iconName: "microphone-lines",
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
    ]
};
var faMicrophoneAlt = faMicrophoneLines;
var faPepperHot = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [
            127798
        ],
        "f816",
        "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
    ]
};
var faUnlock = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [
            128275
        ],
        "f09c",
        "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"
    ]
};
var faColonSign = {
    prefix: "fas",
    iconName: "colon-sign",
    icon: [
        384,
        512,
        [],
        "e140",
        "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
    ]
};
var faHeadset = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
    ]
};
var faStoreSlash = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zM514.9 501.7L365.5 384H160V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3zM155.3 218.4L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6z"
    ]
};
var faRoadCircleXmark = {
    prefix: "fas",
    iconName: "road-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e566",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var faUserMinus = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faMarsStrokeUp = {
    prefix: "fas",
    iconName: "mars-stroke-up",
    icon: [
        320,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"
    ]
};
var faMarsStrokeV = faMarsStrokeUp;
var faChampagneGlasses = {
    prefix: "fas",
    iconName: "champagne-glasses",
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"
    ]
};
var faGlassCheers = faChampagneGlasses;
var faClipboard = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faHouseCircleExclamation = {
    prefix: "fas",
    iconName: "house-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e50a",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faFileArrowUp = {
    prefix: "fas",
    iconName: "file-arrow-up",
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
    ]
};
var faFileUpload = faFileArrowUp;
var faWifi = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var faWifi3 = faWifi;
var faWifiStrong = faWifi;
var faBath = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"
    ]
};
var faBathtub = faBath;
var faUnderline = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
    ]
};
var faUserPen = {
    prefix: "fas",
    iconName: "user-pen",
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
    ]
};
var faUserEdit = faUserPen;
var faSignature = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
    ]
};
var faStroopwafel = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"
    ]
};
var faBold = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
    ]
};
var faAnchorLock = {
    prefix: "fas",
    iconName: "anchor-lock",
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var faBuildingNgo = {
    prefix: "fas",
    iconName: "building-ngo",
    icon: [
        384,
        512,
        [],
        "e4d7",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
    ]
};
var faManatSign = {
    prefix: "fas",
    iconName: "manat-sign",
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
    ]
};
var faNotEqual = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
    ]
};
var faBorderTopLeft = {
    prefix: "fas",
    iconName: "border-top-left",
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faBorderStyle = faBorderTopLeft;
var faMapLocationDot = {
    prefix: "fas",
    iconName: "map-location-dot",
    icon: [
        576,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var faMapMarkedAlt = faMapLocationDot;
var faJedi = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
var faSquarePollVertical = {
    prefix: "fas",
    iconName: "square-poll-vertical",
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"
    ]
};
var faPoll = faSquarePollVertical;
var faMugHot = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [
            9749
        ],
        "f7b6",
        "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
    ]
};
var faCarBattery = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
    ]
};
var faBatteryCar = faCarBattery;
var faGift = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"
    ]
};
var faDiceTwo = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faChessQueen = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
    ]
};
var faGlasses = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
    ]
};
var faChessBoard = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"
    ]
};
var faBuildingCircleCheck = {
    prefix: "fas",
    iconName: "building-circle-check",
    icon: [
        640,
        512,
        [],
        "e4d2",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faPersonChalkboard = {
    prefix: "fas",
    iconName: "person-chalkboard",
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var faMarsStrokeRight = {
    prefix: "fas",
    iconName: "mars-stroke-right",
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"
    ]
};
var faMarsStrokeH = faMarsStrokeRight;
var faHandBackFist = {
    prefix: "fas",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
    ]
};
var faHandRock = faHandBackFist;
var faSquareCaretUp = {
    prefix: "fas",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var faCaretSquareUp = faSquareCaretUp;
var faCloudShowersWater = {
    prefix: "fas",
    iconName: "cloud-showers-water",
    icon: [
        576,
        512,
        [],
        "e4e4",
        "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var faChartBar = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faBarChart = faChartBar;
var faHandsBubbles = {
    prefix: "fas",
    iconName: "hands-bubbles",
    icon: [
        576,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.8 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"
    ]
};
var faHandsWash = faHandsBubbles;
var faLessThanEqual = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var faTrain = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [
            128646
        ],
        "f238",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faEyeLowVision = {
    prefix: "fas",
    iconName: "eye-low-vision",
    icon: [
        640,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm-139.9 12c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8L83.1 161.5zm-50 86.3c-1.8 6.8-1.3 14 1.4 20.5c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8z"
    ]
};
var faLowVision = faEyeLowVision;
var faCrow = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faSailboat = {
    prefix: "fas",
    iconName: "sailboat",
    icon: [
        576,
        512,
        [],
        "e445",
        "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
    ]
};
var faWindowRestore = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
    ]
};
var faSquarePlus = {
    prefix: "fas",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var faPlusSquare = faSquarePlus;
var faToriiGate = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"
    ]
};
var faFrog = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faBucket = {
    prefix: "fas",
    iconName: "bucket",
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var faImage = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faMicrophone = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
    ]
};
var faCow = {
    prefix: "fas",
    iconName: "cow",
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
var faCaretUp = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var faScrewdriver = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [
            129691
        ],
        "f54a",
        "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
    ]
};
var faFolderClosed = {
    prefix: "fas",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"
    ]
};
var faHouseTsunami = {
    prefix: "fas",
    iconName: "house-tsunami",
    icon: [
        576,
        512,
        [],
        "e515",
        "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var faSquareNfi = {
    prefix: "fas",
    iconName: "square-nfi",
    icon: [
        448,
        512,
        [],
        "e576",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
    ]
};
var faArrowUpFromGroundWater = {
    prefix: "fas",
    iconName: "arrow-up-from-ground-water",
    icon: [
        576,
        512,
        [],
        "e4b5",
        "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"
    ]
};
var faMartiniGlass = {
    prefix: "fas",
    iconName: "martini-glass",
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"
    ]
};
var faGlassMartiniAlt = faMartiniGlass;
var faRotateLeft = {
    prefix: "fas",
    iconName: "rotate-left",
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
    ]
};
var faRotateBack = faRotateLeft;
var faRotateBackward = faRotateLeft;
var faUndoAlt = faRotateLeft;
var faTableColumns = {
    prefix: "fas",
    iconName: "table-columns",
    icon: [
        512,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"
    ]
};
var faColumns = faTableColumns;
var faLemon = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
    ]
};
var faHeadSideMask = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        576,
        512,
        [],
        "e063",
        "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faHandshake = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var faGem = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
var faDolly = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"
    ]
};
var faDollyBox = faDolly;
var faSmoking = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [
            128684
        ],
        "f48d",
        "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"
    ]
};
var faMinimize = {
    prefix: "fas",
    iconName: "minimize",
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"
    ]
};
var faCompressArrowsAlt = faMinimize;
var faMonument = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faSnowplow = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faAnglesRight = {
    prefix: "fas",
    iconName: "angles-right",
    icon: [
        512,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var faAngleDoubleRight = faAnglesRight;
var faCannabis = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
    ]
};
var faCirclePlay = {
    prefix: "fas",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
var faPlayCircle = faCirclePlay;
var faTablets = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"
    ]
};
var faEthernet = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var faEuroSign = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"
    ]
};
var faEur = faEuroSign;
var faEuro = faEuroSign;
var faChair = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"
    ]
};
var faCircleCheck = {
    prefix: "fas",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var faCheckCircle = faCircleCheck;
var faCircleStop = {
    prefix: "fas",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var faStopCircle = faCircleStop;
var faCompassDrafting = {
    prefix: "fas",
    iconName: "compass-drafting",
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faDraftingCompass = faCompassDrafting;
var faPlateWheat = {
    prefix: "fas",
    iconName: "plate-wheat",
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
var faIcicles = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
    ]
};
var faPersonShelter = {
    prefix: "fas",
    iconName: "person-shelter",
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var faNeuter = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
    ]
};
var faIdBadge = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faMarker = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
    ]
};
var faFaceLaughBeam = {
    prefix: "fas",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faLaughBeam = faFaceLaughBeam;
var faHelicopterSymbol = {
    prefix: "fas",
    iconName: "helicopter-symbol",
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"
    ]
};
var faUniversalAccess = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var faCircleChevronUp = {
    prefix: "fas",
    iconName: "circle-chevron-up",
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
var faChevronCircleUp = faCircleChevronUp;
var faLariSign = {
    prefix: "fas",
    iconName: "lari-sign",
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var faVolcano = {
    prefix: "fas",
    iconName: "volcano",
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
    ]
};
var faPersonWalkingDashedLineArrowRight = {
    prefix: "fas",
    iconName: "person-walking-dashed-line-arrow-right",
    icon: [
        640,
        512,
        [],
        "e553",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"
    ]
};
var faSterlingSign = {
    prefix: "fas",
    iconName: "sterling-sign",
    icon: [
        320,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var faGbp = faSterlingSign;
var faPoundSign = faSterlingSign;
var faViruses = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faSquarePersonConfined = {
    prefix: "fas",
    iconName: "square-person-confined",
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"
    ]
};
var faUserTie = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"
    ]
};
var faArrowDownLong = {
    prefix: "fas",
    iconName: "arrow-down-long",
    icon: [
        384,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
    ]
};
var faLongArrowDown = faArrowDownLong;
var faTentArrowDownToLine = {
    prefix: "fas",
    iconName: "tent-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e57e",
        "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h80L402.7 325.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V448z"
    ]
};
var faCertificate = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
    ]
};
var faReplyAll = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"
    ]
};
var faMailReplyAll = faReplyAll;
var faSuitcase = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"
    ]
};
var faPersonSkating = {
    prefix: "fas",
    iconName: "person-skating",
    icon: [
        448,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
var faSkating = faPersonSkating;
var faFilterCircleDollar = {
    prefix: "fas",
    iconName: "filter-circle-dollar",
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"
    ]
};
var faFunnelDollar = faFilterCircleDollar;
var faCameraRetro = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"
    ]
};
var faCircleArrowDown = {
    prefix: "fas",
    iconName: "circle-arrow-down",
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"
    ]
};
var faArrowCircleDown = faCircleArrowDown;
var faFileImport = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"
    ]
};
var faArrowRightToFile = faFileImport;
var faSquareArrowUpRight = {
    prefix: "fas",
    iconName: "square-arrow-up-right",
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
    ]
};
var faExternalLinkSquare = faSquareArrowUpRight;
var faBoxOpen = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"
    ]
};
var faScroll = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"
    ]
};
var faSpa = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
    ]
};
var faLocationPinLock = {
    prefix: "fas",
    iconName: "location-pin-lock",
    icon: [
        512,
        512,
        [],
        "e51f",
        "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var faPause = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
    ]
};
var faHillAvalanche = {
    prefix: "fas",
    iconName: "hill-avalanche",
    icon: [
        576,
        512,
        [],
        "e507",
        "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
    ]
};
var faTemperatureEmpty = {
    prefix: "fas",
    iconName: "temperature-empty",
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faTemperature0 = faTemperatureEmpty;
var faThermometer0 = faTemperatureEmpty;
var faThermometerEmpty = faTemperatureEmpty;
var faBomb = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [
            128163
        ],
        "f1e2",
        "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
    ]
};
var faRegistered = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"
    ]
};
var faAddressCard = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faScaleUnbalancedFlip = {
    prefix: "fas",
    iconName: "scale-unbalanced-flip",
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
    ]
};
var faBalanceScaleRight = faScaleUnbalancedFlip;
var faSubscript = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
    ]
};
var faDiamondTurnRight = {
    prefix: "fas",
    iconName: "diamond-turn-right",
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
    ]
};
var faDirections = faDiamondTurnRight;
var faBurst = {
    prefix: "fas",
    iconName: "burst",
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
    ]
};
var faHouseLaptop = {
    prefix: "fas",
    iconName: "house-laptop",
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"
    ]
};
var faLaptopHouse = faHouseLaptop;
var faFaceTired = {
    prefix: "fas",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var faTired = faFaceTired;
var faMoneyBills = {
    prefix: "fas",
    iconName: "money-bills",
    icon: [
        640,
        512,
        [],
        "e1f3",
        "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
    ]
};
var faSmog = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"
    ]
};
var faCrutch = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
    ]
};
var faFontAwesome = {
    prefix: "fas",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384c-63.1 22.5-82.3 32-119.5 32c-62.8 0-86.6-32-149.3-32c-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2c62.7 0 86.5 32 149.3 32c20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3c-62.8 0-86.6-32-149.3-32c-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32V76.7c40.3-8 64.4-28.7 115.2-28.7c62.7 0 86.5 32 149.3 32c37.1 0 56.4-9.5 119.5-32z"
    ]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faCloudArrowUp = {
    prefix: "fas",
    iconName: "cloud-arrow-up",
    icon: [
        640,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
    ]
};
var faCloudUpload = faCloudArrowUp;
var faCloudUploadAlt = faCloudArrowUp;
var faPalette = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faArrowsTurnRight = {
    prefix: "fas",
    iconName: "arrows-turn-right",
    icon: [
        448,
        512,
        [],
        "e4c0",
        "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var faVest = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
    ]
};
var faFerry = {
    prefix: "fas",
    iconName: "ferry",
    icon: [
        576,
        512,
        [],
        "e4ea",
        "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var faArrowsDownToPeople = {
    prefix: "fas",
    iconName: "arrows-down-to-people",
    icon: [
        640,
        512,
        [],
        "e4b9",
        "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var faSeedling = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"
    ]
};
var faSprout = faSeedling;
var faLeftRight = {
    prefix: "fas",
    iconName: "left-right",
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
    ]
};
var faArrowsAltH = faLeftRight;
var faBoxesPacking = {
    prefix: "fas",
    iconName: "boxes-packing",
    icon: [
        640,
        512,
        [],
        "e4c7",
        "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
    ]
};
var faCircleArrowLeft = {
    prefix: "fas",
    iconName: "circle-arrow-left",
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"
    ]
};
var faArrowCircleLeft = faCircleArrowLeft;
var faGroupArrowsRotate = {
    prefix: "fas",
    iconName: "group-arrows-rotate",
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
    ]
};
var faBowlFood = {
    prefix: "fas",
    iconName: "bowl-food",
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
var faCandyCane = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
    ]
};
var faArrowDownWideShort = {
    prefix: "fas",
    iconName: "arrow-down-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
    ]
};
var faSortAmountAsc = faArrowDownWideShort;
var faSortAmountDown = faArrowDownWideShort;
var faCloudBolt = {
    prefix: "fas",
    iconName: "cloud-bolt",
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
    ]
};
var faThunderstorm = faCloudBolt;
var faTextSlash = {
    prefix: "fas",
    iconName: "text-slash",
    icon: [
        640,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM327.3 353.9L272.9 311 243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1z"
    ]
};
var faRemoveFormat = faTextSlash;
var faFaceSmileWink = {
    prefix: "fas",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var faSmileWink = faFaceSmileWink;
var faFileWord = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
    ]
};
var faFilePowerpoint = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"
    ]
};
var faArrowsLeftRight = {
    prefix: "fas",
    iconName: "arrows-left-right",
    icon: [
        512,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var faArrowsH = faArrowsLeftRight;
var faHouseLock = {
    prefix: "fas",
    iconName: "house-lock",
    icon: [
        640,
        512,
        [],
        "e510",
        "M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var faCloudArrowDown = {
    prefix: "fas",
    iconName: "cloud-arrow-down",
    icon: [
        640,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var faCloudDownload = faCloudArrowDown;
var faCloudDownloadAlt = faCloudArrowDown;
var faChildren = {
    prefix: "fas",
    iconName: "children",
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"
    ]
};
var faChalkboard = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
    ]
};
var faBlackboard = faChalkboard;
var faUserLargeSlash = {
    prefix: "fas",
    iconName: "user-large-slash",
    icon: [
        640,
        512,
        [
            "user-alt-slash"
        ],
        "f4fa",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"
    ]
};
var faUserAltSlash = faUserLargeSlash;
var faEnvelopeOpen = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
    ]
};
var faHandshakeSimpleSlash = {
    prefix: "fas",
    iconName: "handshake-simple-slash",
    icon: [
        640,
        512,
        [
            "handshake-alt-slash"
        ],
        "e05f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z"
    ]
};
var faHandshakeAltSlash = faHandshakeSimpleSlash;
var faMattressPillow = {
    prefix: "fas",
    iconName: "mattress-pillow",
    icon: [
        640,
        512,
        [],
        "e525",
        "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
    ]
};
var faGuaraniSign = {
    prefix: "fas",
    iconName: "guarani-sign",
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"
    ]
};
var faArrowsRotate = {
    prefix: "fas",
    iconName: "arrows-rotate",
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
    ]
};
var faRefresh = faArrowsRotate;
var faSync = faArrowsRotate;
var faFireExtinguisher = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faCruzeiroSign = {
    prefix: "fas",
    iconName: "cruzeiro-sign",
    icon: [
        448,
        512,
        [],
        "e152",
        "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"
    ]
};
var faGreaterThanEqual = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"
    ]
};
var faShieldHalved = {
    prefix: "fas",
    iconName: "shield-halved",
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
    ]
};
var faShieldAlt = faShieldHalved;
var faBookAtlas = {
    prefix: "fas",
    iconName: "book-atlas",
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
    ]
};
var faAtlas = faBookAtlas;
var faVirus = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faEnvelopeCircleCheck = {
    prefix: "fas",
    iconName: "envelope-circle-check",
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faLayerGroup = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
};
var faArrowsToDot = {
    prefix: "fas",
    iconName: "arrows-to-dot",
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faArchway = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"
    ]
};
var faHeartCircleCheck = {
    prefix: "fas",
    iconName: "heart-circle-check",
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faHouseChimneyCrack = {
    prefix: "fas",
    iconName: "house-chimney-crack",
    icon: [
        576,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"
    ]
};
var faHouseDamage = faHouseChimneyCrack;
var faFileZipper = {
    prefix: "fas",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var faFileArchive = faFileZipper;
var faSquare = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
    ]
};
var faMartiniGlassEmpty = {
    prefix: "fas",
    iconName: "martini-glass-empty",
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"
    ]
};
var faGlassMartini = faMartiniGlassEmpty;
var faCouch = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"
    ]
};
var faCediSign = {
    prefix: "fas",
    iconName: "cedi-sign",
    icon: [
        384,
        512,
        [],
        "e0df",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
    ]
};
var faItalic = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
    ]
};
var faChurch = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [
            9962
        ],
        "f51d",
        "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var faCommentsDollar = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        640,
        512,
        [],
        "f653",
        "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
    ]
};
var faDemocrat = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
    ]
};
var faZ = {
    prefix: "fas",
    iconName: "z",
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var faPersonSkiing = {
    prefix: "fas",
    iconName: "person-skiing",
    icon: [
        512,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
    ]
};
var faSkiing = faPersonSkiing;
var faRoadLock = {
    prefix: "fas",
    iconName: "road-lock",
    icon: [
        640,
        512,
        [],
        "e567",
        "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var faA = {
    prefix: "fas",
    iconName: "a",
    icon: [
        384,
        512,
        [
            97
        ],
        "41",
        "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"
    ]
};
var faTemperatureArrowDown = {
    prefix: "fas",
    iconName: "temperature-arrow-down",
    icon: [
        576,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
    ]
};
var faTemperatureDown = faTemperatureArrowDown;
var faFeatherPointed = {
    prefix: "fas",
    iconName: "feather-pointed",
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var faFeatherAlt = faFeatherPointed;
var faP = {
    prefix: "fas",
    iconName: "p",
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"
    ]
};
var faSnowflake = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
    ]
};
var faNewspaper = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var faRectangleAd = {
    prefix: "fas",
    iconName: "rectangle-ad",
    icon: [
        576,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
    ]
};
var faAd = faRectangleAd;
var faCircleArrowRight = {
    prefix: "fas",
    iconName: "circle-arrow-right",
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
    ]
};
var faArrowCircleRight = faCircleArrowRight;
var faFilterCircleXmark = {
    prefix: "fas",
    iconName: "filter-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e17b",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var faLocust = {
    prefix: "fas",
    iconName: "locust",
    icon: [
        576,
        512,
        [],
        "e520",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var faSort = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
    ]
};
var faUnsorted = faSort;
var faListOl = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faList12 = faListOl;
var faListNumeric = faListOl;
var faPersonDressBurst = {
    prefix: "fas",
    iconName: "person-dress-burst",
    icon: [
        640,
        512,
        [],
        "e544",
        "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var faMoneyCheckDollar = {
    prefix: "fas",
    iconName: "money-check-dollar",
    icon: [
        576,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var faMoneyCheckAlt = faMoneyCheckDollar;
var faVectorSquare = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"
    ]
};
var faBreadSlice = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
    ]
};
var faLanguage = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
    ]
};
var faFaceKissWinkHeart = {
    prefix: "fas",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faFilter = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
};
var faQuestion = {
    prefix: "fas",
    iconName: "question",
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var faFileSignature = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
    ]
};
var faUpDownLeftRight = {
    prefix: "fas",
    iconName: "up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var faArrowsAlt = faUpDownLeftRight;
var faHouseChimneyUser = {
    prefix: "fas",
    iconName: "house-chimney-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
    ]
};
var faHandHoldingHeart = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var faPuzzlePiece = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2z"
    ]
};
var faMoneyCheck = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        576,
        512,
        [],
        "f53c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"
    ]
};
var faStarHalfStroke = {
    prefix: "fas",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"
    ]
};
var faStarHalfAlt = faStarHalfStroke;
var faCode = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var faWhiskeyGlass = {
    prefix: "fas",
    iconName: "whiskey-glass",
    icon: [
        512,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"
    ]
};
var faGlassWhiskey = faWhiskeyGlass;
var faBuildingCircleExclamation = {
    prefix: "fas",
    iconName: "building-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4d3",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faMagnifyingGlassChart = {
    prefix: "fas",
    iconName: "magnifying-glass-chart",
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var faArrowUpRightFromSquare = {
    prefix: "fas",
    iconName: "arrow-up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var faExternalLink = faArrowUpRightFromSquare;
var faCubesStacked = {
    prefix: "fas",
    iconName: "cubes-stacked",
    icon: [
        448,
        512,
        [],
        "e4e6",
        "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"
    ]
};
var faWonSign = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"
    ]
};
var faKrw = faWonSign;
var faWon = faWonSign;
var faVirusCovid = {
    prefix: "fas",
    iconName: "virus-covid",
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faAustralSign = {
    prefix: "fas",
    iconName: "austral-sign",
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"
    ]
};
var faF = {
    prefix: "fas",
    iconName: "f",
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
    ]
};
var faLeaf = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        512,
        512,
        [],
        "f06c",
        "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
    ]
};
var faRoad = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [
            128739
        ],
        "f018",
        "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var faTaxi = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faCab = faTaxi;
var faPersonCirclePlus = {
    prefix: "fas",
    iconName: "person-circle-plus",
    icon: [
        576,
        512,
        [],
        "e541",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var faChartPie = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
    ]
};
var faPieChart = faChartPie;
var faBoltLightning = {
    prefix: "fas",
    iconName: "bolt-lightning",
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
    ]
};
var faSackXmark = {
    prefix: "fas",
    iconName: "sack-xmark",
    icon: [
        512,
        512,
        [],
        "e56a",
        "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
    ]
};
var faFileExcel = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
    ]
};
var faFileContract = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
    ]
};
var faFishFins = {
    prefix: "fas",
    iconName: "fish-fins",
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.6 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.6 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faBuildingFlag = {
    prefix: "fas",
    iconName: "building-flag",
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
    ]
};
var faFaceGrinBeam = {
    prefix: "fas",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"
    ]
};
var faPoop = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
var faLocationPin = {
    prefix: "fas",
    iconName: "location-pin",
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
    ]
};
var faMapMarker = faLocationPin;
var faKaaba = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [
            128331
        ],
        "f66b",
        "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
    ]
};
var faToiletPaper = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        640,
        512,
        [
            129531
        ],
        "f71e",
        "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var faHelmetSafety = {
    prefix: "fas",
    iconName: "helmet-safety",
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"
    ]
};
var faHardHat = faHelmetSafety;
var faHatHard = faHelmetSafety;
var faEject = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
    ]
};
var faCircleRight = {
    prefix: "fas",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"
    ]
};
var faArrowAltCircleRight = faCircleRight;
var faPlaneCircleCheck = {
    prefix: "fas",
    iconName: "plane-circle-check",
    icon: [
        640,
        512,
        [],
        "e555",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faFaceRollingEyes = {
    prefix: "fas",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
    ]
};
var faMehRollingEyes = faFaceRollingEyes;
var faObjectGroup = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var faChartLine = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
var faLineChart = faChartLine;
var faMaskVentilator = {
    prefix: "fas",
    iconName: "mask-ventilator",
    icon: [
        640,
        512,
        [],
        "e524",
        "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var faArrowRight = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
var faSignsPost = {
    prefix: "fas",
    iconName: "signs-post",
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var faMapSigns = faSignsPost;
var faCashRegister = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
    ]
};
var faPersonCircleQuestion = {
    prefix: "fas",
    iconName: "person-circle-question",
    icon: [
        576,
        512,
        [],
        "e542",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var faH = {
    prefix: "fas",
    iconName: "h",
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
    ]
};
var faTarp = {
    prefix: "fas",
    iconName: "tarp",
    icon: [
        576,
        512,
        [],
        "e57b",
        "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faScrewdriverWrench = {
    prefix: "fas",
    iconName: "screwdriver-wrench",
    icon: [
        512,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faTools = faScrewdriverWrench;
var faArrowsToEye = {
    prefix: "fas",
    iconName: "arrows-to-eye",
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var faPlugCircleBolt = {
    prefix: "fas",
    iconName: "plug-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e55b",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var faHeart = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    ]
};
var faMarsAndVenus = {
    prefix: "fas",
    iconName: "mars-and-venus",
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2V408h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V382.2C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var faHouseUser = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"
    ]
};
var faHomeUser = faHouseUser;
var faDumpsterFire = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.7-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zM480 480c88.4 0 160-71.6 160-160c0-31.8-15.5-84-74.4-142.4c-11.8-11.7-30.6-10.7-42.3 1L512 189.9l-46-46c-6-6.1-14.1-9.3-22-9.2c-5.9 .1-11.8 1.9-16.8 5.8C382.5 175.3 320 243.3 320 320c0 88.4 71.6 160 160 160zm64-111.8c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 295.1 544 331.6 544 368.2z"
    ]
};
var faHouseCrack = {
    prefix: "fas",
    iconName: "house-crack",
    icon: [
        576,
        512,
        [],
        "e3b1",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
    ]
};
var faMartiniGlassCitrus = {
    prefix: "fas",
    iconName: "martini-glass-citrus",
    icon: [
        576,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
    ]
};
var faCocktail = faMartiniGlassCitrus;
var faFaceSurprise = {
    prefix: "fas",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var faSurprise = faFaceSurprise;
var faBottleWater = {
    prefix: "fas",
    iconName: "bottle-water",
    icon: [
        320,
        512,
        [],
        "e4c5",
        "M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 167.5c0-19.5 10-37.6 26.6-47.9l15.8-9.9C88.7 100.7 105.2 96 122.1 96h75.8c16.9 0 33.4 4.7 47.7 13.7l15.8 9.9C278 129.9 288 148 288 167.5c0 17-7.5 32.3-19.4 42.6C280.6 221.7 288 238 288 256c0 19.1-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48s-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64c0-19.1 8.4-36.3 21.7-48C40.4 388.3 32 371.1 32 352s8.4-36.3 21.7-48C40.4 292.3 32 275.1 32 256c0-18 7.4-34.3 19.4-45.9C39.5 199.7 32 184.5 32 167.5zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var faCirclePause = {
    prefix: "fas",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var faPauseCircle = faCirclePause;
var faToiletPaperSlash = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
    ]
};
var faAppleWhole = {
    prefix: "fas",
    iconName: "apple-whole",
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
    ]
};
var faAppleAlt = faAppleWhole;
var faKitchenSet = {
    prefix: "fas",
    iconName: "kitchen-set",
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faR = {
    prefix: "fas",
    iconName: "r",
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var faTemperatureQuarter = {
    prefix: "fas",
    iconName: "temperature-quarter",
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var faTemperature1 = faTemperatureQuarter;
var faThermometer1 = faTemperatureQuarter;
var faThermometerQuarter = faTemperatureQuarter;
var faCube = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"
    ]
};
var faBitcoinSign = {
    prefix: "fas",
    iconName: "bitcoin-sign",
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"
    ]
};
var faShieldDog = {
    prefix: "fas",
    iconName: "shield-dog",
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var faSolarPanel = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"
    ]
};
var faLockOpen = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"
    ]
};
var faElevator = {
    prefix: "fas",
    iconName: "elevator",
    icon: [
        512,
        512,
        [],
        "e16d",
        "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
    ]
};
var faMoneyBillTransfer = {
    prefix: "fas",
    iconName: "money-bill-transfer",
    icon: [
        640,
        512,
        [],
        "e528",
        "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var faMoneyBillTrendUp = {
    prefix: "fas",
    iconName: "money-bill-trend-up",
    icon: [
        512,
        512,
        [],
        "e529",
        "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var faHouseFloodWaterCircleArrowRight = {
    prefix: "fas",
    iconName: "house-flood-water-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var faSquarePollHorizontal = {
    prefix: "fas",
    iconName: "square-poll-horizontal",
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
    ]
};
var faPollH = faSquarePollHorizontal;
var faCircle = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
    ]
};
var faBackwardFast = {
    prefix: "fas",
    iconName: "backward-fast",
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"
    ]
};
var faFastBackward = faBackwardFast;
var faRecycle = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
    ]
};
var faUserAstronaut = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faPlaneSlash = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M440.6 320h73.8c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64l-116.6 0L297.2 16.1C291.5 6.2 280.9 0 269.4 0H213.2c-10.6 0-18.3 10.2-15.4 20.4l40.3 140.9L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320zm-78.1 61.6L41.5 128.7C36 130.6 32 135.9 32 142c0 1.3 .2 2.6 .5 3.9L64 256 32.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14H88c5 0 9.8-2.4 12.8-6.4L144 320H246.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1l65.3-114.3z"
    ]
};
var faTrademark = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"
    ]
};
var faBasketball = {
    prefix: "fas",
    iconName: "basketball",
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
    ]
};
var faBasketballBall = faBasketball;
var faSatelliteDish = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faCircleUp = {
    prefix: "fas",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"
    ]
};
var faArrowAltCircleUp = faCircleUp;
var faMobileScreenButton = {
    prefix: "fas",
    iconName: "mobile-screen-button",
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"
    ]
};
var faMobileAlt = faMobileScreenButton;
var faVolumeHigh = {
    prefix: "fas",
    iconName: "volume-high",
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
    ]
};
var faVolumeUp = faVolumeHigh;
var faUsersRays = {
    prefix: "fas",
    iconName: "users-rays",
    icon: [
        640,
        512,
        [],
        "e593",
        "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faWallet = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faClipboardCheck = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var faFileAudio = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
    ]
};
var faBurger = {
    prefix: "fas",
    iconName: "burger",
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"
    ]
};
var faHamburger = faBurger;
var faWrench = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faBugs = {
    prefix: "fas",
    iconName: "bugs",
    icon: [
        576,
        512,
        [],
        "e4d0",
        "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
    ]
};
var faRupeeSign = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
    ]
};
var faRupee = faRupeeSign;
var faFileImage = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
    ]
};
var faCircleQuestion = {
    prefix: "fas",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faQuestionCircle = faCircleQuestion;
var faPlaneDeparture = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [
            128747
        ],
        "f5b0",
        "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var faHandshakeSlash = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var faBookBookmark = {
    prefix: "fas",
    iconName: "book-bookmark",
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"
    ]
};
var faCodeBranch = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faHatCowboy = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
    ]
};
var faBridge = {
    prefix: "fas",
    iconName: "bridge",
    icon: [
        576,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"
    ]
};
var faPhoneFlip = {
    prefix: "fas",
    iconName: "phone-flip",
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
    ]
};
var faPhoneAlt = faPhoneFlip;
var faTruckFront = {
    prefix: "fas",
    iconName: "truck-front",
    icon: [
        512,
        512,
        [],
        "e2b7",
        "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faCat = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        576,
        512,
        [
            128008
        ],
        "f6be",
        "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faAnchorCircleExclamation = {
    prefix: "fas",
    iconName: "anchor-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faTruckField = {
    prefix: "fas",
    iconName: "truck-field",
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var faRoute = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faClipboardQuestion = {
    prefix: "fas",
    iconName: "clipboard-question",
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faPanorama = {
    prefix: "fas",
    iconName: "panorama",
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
};
var faCommentMedical = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var faTeethOpen = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        576,
        512,
        [],
        "f62f",
        "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var faFileCircleMinus = {
    prefix: "fas",
    iconName: "file-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var faTags = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faWineGlass = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"
    ]
};
var faForwardFast = {
    prefix: "fas",
    iconName: "forward-fast",
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"
    ]
};
var faFastForward = faForwardFast;
var faFaceMehBlank = {
    prefix: "fas",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faMehBlank = faFaceMehBlank;
var faSquareParking = {
    prefix: "fas",
    iconName: "square-parking",
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
var faParking = faSquareParking;
var faHouseSignal = {
    prefix: "fas",
    iconName: "house-signal",
    icon: [
        576,
        512,
        [],
        "e012",
        "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"
    ]
};
var faBarsProgress = {
    prefix: "fas",
    iconName: "bars-progress",
    icon: [
        512,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"
    ]
};
var faTasksAlt = faBarsProgress;
var faFaucetDrip = {
    prefix: "fas",
    iconName: "faucet-drip",
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
    ]
};
var faCartFlatbed = {
    prefix: "fas",
    iconName: "cart-flatbed",
    icon: [
        640,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"
    ]
};
var faDollyFlatbed = faCartFlatbed;
var faBanSmoking = {
    prefix: "fas",
    iconName: "ban-smoking",
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"
    ]
};
var faSmokingBan = faBanSmoking;
var faTerminal = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        576,
        512,
        [],
        "f120",
        "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faMobileButton = {
    prefix: "fas",
    iconName: "mobile-button",
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faHouseMedicalFlag = {
    prefix: "fas",
    iconName: "house-medical-flag",
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
    ]
};
var faBasketShopping = {
    prefix: "fas",
    iconName: "basket-shopping",
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faShoppingBasket = faBasketShopping;
var faTape = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        576,
        512,
        [],
        "f4db",
        "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var faBusSimple = {
    prefix: "fas",
    iconName: "bus-simple",
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faBusAlt = faBusSimple;
var faEye = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
    ]
};
var faFaceSadCry = {
    prefix: "fas",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var faSadCry = faFaceSadCry;
var faAudioDescription = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        576,
        512,
        [],
        "f29e",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"
    ]
};
var faPersonMilitaryToPerson = {
    prefix: "fas",
    iconName: "person-military-to-person",
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
var faFileShield = {
    prefix: "fas",
    iconName: "file-shield",
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var faUserSlash = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
    ]
};
var faPen = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
};
var faTowerObservation = {
    prefix: "fas",
    iconName: "tower-observation",
    icon: [
        512,
        512,
        [],
        "e586",
        "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
    ]
};
var faFileCode = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var faSignal = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var faSignal5 = faSignal;
var faSignalPerfect = faSignal;
var faBus = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        576,
        512,
        [
            128653
        ],
        "f207",
        "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"
    ]
};
var faHeartCircleXmark = {
    prefix: "fas",
    iconName: "heart-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e501",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faHouseChimney = {
    prefix: "fas",
    iconName: "house-chimney",
    icon: [
        576,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"
    ]
};
var faHomeLg = faHouseChimney;
var faWindowMaximize = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faFaceFrown = {
    prefix: "fas",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faFrown = faFaceFrown;
var faPrescription = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var faShop = {
    prefix: "fas",
    iconName: "shop",
    icon: [
        640,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"
    ]
};
var faStoreAlt = faShop;
var faFloppyDisk = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var faSave = faFloppyDisk;
var faVihara = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"
    ]
};
var faScaleUnbalanced = {
    prefix: "fas",
    iconName: "scale-unbalanced",
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
    ]
};
var faBalanceScaleLeft = faScaleUnbalanced;
var faSortUp = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var faSortAsc = faSortUp;
var faCommentDots = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faCommenting = faCommentDots;
var faPlantWilt = {
    prefix: "fas",
    iconName: "plant-wilt",
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"
    ]
};
var faDiamond = {
    prefix: "fas",
    iconName: "diamond",
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
    ]
};
var faFaceGrinSquint = {
    prefix: "fas",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var faGrinSquint = faFaceGrinSquint;
var faHandHoldingDollar = {
    prefix: "fas",
    iconName: "hand-holding-dollar",
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var faHandHoldingUsd = faHandHoldingDollar;
var faBacterium = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        512,
        512,
        [],
        "e05a",
        "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faHandPointer = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var faDrumSteelpan = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
    ]
};
var faHandScissors = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
var faHandsPraying = {
    prefix: "fas",
    iconName: "hands-praying",
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
    ]
};
var faPrayingHands = faHandsPraying;
var faArrowRotateRight = {
    prefix: "fas",
    iconName: "arrow-rotate-right",
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
};
var faArrowRightRotate = faArrowRotateRight;
var faArrowRotateForward = faArrowRotateRight;
var faRedo = faArrowRotateRight;
var faBiohazard = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
    ]
};
var faLocationCrosshairs = {
    prefix: "fas",
    iconName: "location-crosshairs",
    icon: [
        512,
        512,
        [
            "location"
        ],
        "f601",
        "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var faLocation = faLocationCrosshairs;
var faMarsDouble = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
    ]
};
var faChildDress = {
    prefix: "fas",
    iconName: "child-dress",
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"
    ]
};
var faUsersBetweenLines = {
    prefix: "fas",
    iconName: "users-between-lines",
    icon: [
        640,
        512,
        [],
        "e591",
        "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var faLungsVirus = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var faFaceGrinTears = {
    prefix: "fas",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var faGrinTears = faFaceGrinTears;
var faPhone = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
    ]
};
var faCalendarXmark = {
    prefix: "fas",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
    ]
};
var faCalendarTimes = faCalendarXmark;
var faChildReaching = {
    prefix: "fas",
    iconName: "child-reaching",
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
    ]
};
var faHeadSideVirus = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var faUserGear = {
    prefix: "fas",
    iconName: "user-gear",
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7v17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V467.8c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"
    ]
};
var faUserCog = faUserGear;
var faArrowUp19 = {
    prefix: "fas",
    iconName: "arrow-up-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var faSortNumericUp = faArrowUp19;
var faDoorClosed = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        576,
        512,
        [
            128682
        ],
        "f52a",
        "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faShieldVirus = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var faDiceSix = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faMosquitoNet = {
    prefix: "fas",
    iconName: "mosquito-net",
    icon: [
        640,
        512,
        [],
        "e52c",
        "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"
    ]
};
var faBridgeWater = {
    prefix: "fas",
    iconName: "bridge-water",
    icon: [
        576,
        512,
        [],
        "e4ce",
        "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var faPersonBooth = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
    ]
};
var faTextWidth = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
var faHatWizard = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faPenFancy = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
    ]
};
var faPersonDigging = {
    prefix: "fas",
    iconName: "person-digging",
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
    ]
};
var faDigging = faPersonDigging;
var faTrash = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
};
var faGaugeSimple = {
    prefix: "fas",
    iconName: "gauge-simple",
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var faGaugeSimpleMed = faGaugeSimple;
var faTachometerAverage = faGaugeSimple;
var faBookMedical = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"
    ]
};
var faPoo = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
var faQuoteRight = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"
    ]
};
var faQuoteRightAlt = faQuoteRight;
var faShirt = {
    prefix: "fas",
    iconName: "shirt",
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
    ]
};
var faTShirt = faShirt;
var faTshirt = faShirt;
var faCubes = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        576,
        512,
        [],
        "f1b3",
        "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"
    ]
};
var faDivide = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"
    ]
};
var faTengeSign = {
    prefix: "fas",
    iconName: "tenge-sign",
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
    ]
};
var faTenge = faTengeSign;
var faHeadphones = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [
            127911
        ],
        "f025",
        "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
    ]
};
var faHandsHolding = {
    prefix: "fas",
    iconName: "hands-holding",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
var faHandsClapping = {
    prefix: "fas",
    iconName: "hands-clapping",
    icon: [
        512,
        512,
        [],
        "e1a8",
        "M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
    ]
};
var faRepublican = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"
    ]
};
var faArrowLeft = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var faPersonCircleXmark = {
    prefix: "fas",
    iconName: "person-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e543",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var faRuler = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        512,
        512,
        [
            128207
        ],
        "f545",
        "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
    ]
};
var faAlignLeft = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var faDiceD6 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
    ]
};
var faRestroom = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var faJ = {
    prefix: "fas",
    iconName: "j",
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
    ]
};
var faUsersViewfinder = {
    prefix: "fas",
    iconName: "users-viewfinder",
    icon: [
        640,
        512,
        [],
        "e595",
        "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"
    ]
};
var faFileVideo = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
    ]
};
var faUpRightFromSquare = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var faExternalLinkAlt = faUpRightFromSquare;
var faTableCells = {
    prefix: "fas",
    iconName: "table-cells",
    icon: [
        512,
        512,
        [
            "th"
        ],
        "f00a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"
    ]
};
var faTh = faTableCells;
var faFilePdf = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
var faBookBible = {
    prefix: "fas",
    iconName: "book-bible",
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"
    ]
};
var faBible = faBookBible;
var faO = {
    prefix: "fas",
    iconName: "o",
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
    ]
};
var faSuitcaseMedical = {
    prefix: "fas",
    iconName: "suitcase-medical",
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var faMedkit = faSuitcaseMedical;
var faUserSecret = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
    ]
};
var faOtter = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var faPersonDress = {
    prefix: "fas",
    iconName: "person-dress",
    icon: [
        320,
        512,
        [
            "female"
        ],
        "f182",
        "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var faFemale = faPersonDress;
var faCommentDollar = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var faBusinessTime = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
    ]
};
var faBriefcaseClock = faBusinessTime;
var faTableCellsLarge = {
    prefix: "fas",
    iconName: "table-cells-large",
    icon: [
        512,
        512,
        [
            "th-large"
        ],
        "f009",
        "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var faThLarge = faTableCellsLarge;
var faBookTanakh = {
    prefix: "fas",
    iconName: "book-tanakh",
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
    ]
};
var faTanakh = faBookTanakh;
var faPhoneVolume = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        512,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
    ]
};
var faVolumeControlPhone = faPhoneVolume;
var faHatCowboySide = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"
    ]
};
var faClipboardUser = {
    prefix: "fas",
    iconName: "clipboard-user",
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var faChild = {
    prefix: "fas",
    iconName: "child",
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"
    ]
};
var faLiraSign = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        320,
        512,
        [
            8356
        ],
        "f195",
        "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
    ]
};
var faSatellite = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
    ]
};
var faPlaneLock = {
    prefix: "fas",
    iconName: "plane-lock",
    icon: [
        640,
        512,
        [],
        "e558",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var faTag = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        448,
        512,
        [
            127991
        ],
        "f02b",
        "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faComment = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
    ]
};
var faCakeCandles = {
    prefix: "fas",
    iconName: "cake-candles",
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"
    ]
};
var faBirthdayCake = faCakeCandles;
var faCake = faCakeCandles;
var faEnvelope = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
    ]
};
var faAnglesUp = {
    prefix: "fas",
    iconName: "angles-up",
    icon: [
        448,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var faAngleDoubleUp = faAnglesUp;
var faPaperclip = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [
            128206
        ],
        "f0c6",
        "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
    ]
};
var faArrowRightToCity = {
    prefix: "fas",
    iconName: "arrow-right-to-city",
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
    ]
};
var faRibbon = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [
            127895
        ],
        "f4d6",
        "M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
    ]
};
var faLungs = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [
            129729
        ],
        "f604",
        "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
    ]
};
var faArrowUp91 = {
    prefix: "fas",
    iconName: "arrow-up-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var faSortNumericUpAlt = faArrowUp91;
var faLitecoinSign = {
    prefix: "fas",
    iconName: "litecoin-sign",
    icon: [
        384,
        512,
        [],
        "e1d3",
        "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"
    ]
};
var faBorderNone = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var faCircleNodes = {
    prefix: "fas",
    iconName: "circle-nodes",
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
var faParachuteBox = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"
    ]
};
var faIndent = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
var faTruckFieldUn = {
    prefix: "fas",
    iconName: "truck-field-un",
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faHourglass = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
    ]
};
var faHourglassEmpty = faHourglass;
var faMountain = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"
    ]
};
var faUserDoctor = {
    prefix: "fas",
    iconName: "user-doctor",
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faUserMd = faUserDoctor;
var faCircleInfo = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faInfoCircle = faCircleInfo;
var faCloudMeatball = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faCamera = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var faCameraAlt = faCamera;
var faSquareVirus = {
    prefix: "fas",
    iconName: "square-virus",
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var faMeteor = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faCarOn = {
    prefix: "fas",
    iconName: "car-on",
    icon: [
        512,
        512,
        [],
        "e4dd",
        "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
    ]
};
var faSleigh = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"
    ]
};
var faArrowDown19 = {
    prefix: "fas",
    iconName: "arrow-down-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var faSortNumericAsc = faArrowDown19;
var faSortNumericDown = faArrowDown19;
var faHandHoldingDroplet = {
    prefix: "fas",
    iconName: "hand-holding-droplet",
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var faHandHoldingWater = faHandHoldingDroplet;
var faWater = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var faCalendarCheck = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
    ]
};
var faBraille = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var faPrescriptionBottleMedical = {
    prefix: "fas",
    iconName: "prescription-bottle-medical",
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
var faLandmark = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var faTruck = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faCrosshairs = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faPersonCane = {
    prefix: "fas",
    iconName: "person-cane",
    icon: [
        448,
        512,
        [],
        "e53c",
        "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
    ]
};
var faTent = {
    prefix: "fas",
    iconName: "tent",
    icon: [
        576,
        512,
        [],
        "e57d",
        "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H464 435.8c-12.1 0-23.2-6.8-28.6-17.7L306.7 293.5c-1.7-3.4-5.1-5.5-8.8-5.5c-5.5 0-9.9 4.4-9.9 9.9V480c0 17.7-14.3 32-32 32H240 32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
    ]
};
var faVestPatches = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var faCheckDouble = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        448,
        512,
        [],
        "f560",
        "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
    ]
};
var faArrowDownAZ = {
    prefix: "fas",
    iconName: "arrow-down-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"
    ]
};
var faSortAlphaAsc = faArrowDownAZ;
var faSortAlphaDown = faArrowDownAZ;
var faMoneyBillWheat = {
    prefix: "fas",
    iconName: "money-bill-wheat",
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var faCookie = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faArrowRotateLeft = {
    prefix: "fas",
    iconName: "arrow-rotate-left",
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
};
var faArrowLeftRotate = faArrowRotateLeft;
var faArrowRotateBack = faArrowRotateLeft;
var faArrowRotateBackward = faArrowRotateLeft;
var faUndo = faArrowRotateLeft;
var faHardDrive = {
    prefix: "fas",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faHdd = faHardDrive;
var faFaceGrinSquintTears = {
    prefix: "fas",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-5.6 .9-10.3-3.9-9.5-9.5c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c5.6-.9 10.3 3.9 9.5 9.5c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.4 202.3c-4.8-11.9-20.9-10.9-26.9 .4c-19.4 36.7-46.3 73.2-79.8 106.7s-70 60.3-106.7 79.8c-11.3 6-12.3 22.1-.4 26.9c59.4 24.1 129.9 12.2 177.9-35.8s59.9-118.5 35.8-177.9zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
    ]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faDumbbell = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
    ]
};
var faRectangleList = {
    prefix: "fas",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
    ]
};
var faListAlt = faRectangleList;
var faTarpDroplet = {
    prefix: "fas",
    iconName: "tarp-droplet",
    icon: [
        576,
        512,
        [],
        "e57c",
        "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faHouseMedicalCircleCheck = {
    prefix: "fas",
    iconName: "house-medical-circle-check",
    icon: [
        640,
        512,
        [],
        "e511",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var faPersonSkiingNordic = {
    prefix: "fas",
    iconName: "person-skiing-nordic",
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"
    ]
};
var faSkiingNordic = faPersonSkiingNordic;
var faCalendarPlus = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM224 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H144c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
    ]
};
var faPlaneArrival = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [
            128748
        ],
        "f5af",
        "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14.1-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faCircleLeft = {
    prefix: "fas",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"
    ]
};
var faArrowAltCircleLeft = faCircleLeft;
var faTrainSubway = {
    prefix: "fas",
    iconName: "train-subway",
    icon: [
        448,
        512,
        [
            "subway"
        ],
        "f239",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faSubway = faTrainSubway;
var faChartGantt = {
    prefix: "fas",
    iconName: "chart-gantt",
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faIndianRupeeSign = {
    prefix: "fas",
    iconName: "indian-rupee-sign",
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"
    ]
};
var faIndianRupee = faIndianRupeeSign;
var faInr = faIndianRupeeSign;
var faCropSimple = {
    prefix: "fas",
    iconName: "crop-simple",
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
    ]
};
var faCropAlt = faCropSimple;
var faMoneyBill1 = {
    prefix: "fas",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var faMoneyBillAlt = faMoneyBill1;
var faLeftLong = {
    prefix: "fas",
    iconName: "left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"
    ]
};
var faLongArrowAltLeft = faLeftLong;
var faDna = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [
            129516
        ],
        "f471",
        "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"
    ]
};
var faVirusSlash = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"
    ]
};
var faMinus = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
};
var faSubtract = faMinus;
var faChess = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"
    ]
};
var faArrowLeftLong = {
    prefix: "fas",
    iconName: "arrow-left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
    ]
};
var faLongArrowLeft = faArrowLeftLong;
var faPlugCircleCheck = {
    prefix: "fas",
    iconName: "plug-circle-check",
    icon: [
        576,
        512,
        [],
        "e55c",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faStreetView = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
    ]
};
var faFrancSign = {
    prefix: "fas",
    iconName: "franc-sign",
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var faVolumeOff = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        320,
        512,
        [],
        "f026",
        "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
    ]
};
var faHandsAslInterpreting = {
    prefix: "fas",
    iconName: "hands-asl-interpreting",
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faAslInterpreting = faHandsAslInterpreting;
var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
var faGear = {
    prefix: "fas",
    iconName: "gear",
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var faCog = faGear;
var faDropletSlash = {
    prefix: "fas",
    iconName: "droplet-slash",
    icon: [
        640,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faTintSlash = faDropletSlash;
var faMosque = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [
            128332
        ],
        "f678",
        "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"
    ]
};
var faMosquito = {
    prefix: "fas",
    iconName: "mosquito",
    icon: [
        640,
        512,
        [],
        "e52b",
        "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
    ]
};
var faStarOfDavid = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"
    ]
};
var faPersonMilitaryRifle = {
    prefix: "fas",
    iconName: "person-military-rifle",
    icon: [
        512,
        512,
        [],
        "e54b",
        "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faCartShopping = {
    prefix: "fas",
    iconName: "cart-shopping",
    icon: [
        576,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faShoppingCart = faCartShopping;
var faVials = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        512,
        512,
        [],
        "f493",
        "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"
    ]
};
var faPlugCirclePlus = {
    prefix: "fas",
    iconName: "plug-circle-plus",
    icon: [
        576,
        512,
        [],
        "e55f",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faPlaceOfWorship = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var faGripVertical = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
    ]
};
var faArrowTurnUp = {
    prefix: "fas",
    iconName: "arrow-turn-up",
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
var faLevelUp = faArrowTurnUp;
var faU = {
    prefix: "fas",
    iconName: "u",
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"
    ]
};
var faSquareRootVariable = {
    prefix: "fas",
    iconName: "square-root-variable",
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var faSquareRootAlt = faSquareRootVariable;
var faClock = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var faClockFour = faClock;
var faBackwardStep = {
    prefix: "fas",
    iconName: "backward-step",
    icon: [
        320,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
    ]
};
var faStepBackward = faBackwardStep;
var faPallet = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"
    ]
};
var faFaucet = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
    ]
};
var faBaseballBatBall = {
    prefix: "fas",
    iconName: "baseball-bat-ball",
    icon: [
        512,
        512,
        [],
        "f432",
        "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var faS = {
    prefix: "fas",
    iconName: "s",
    icon: [
        320,
        512,
        [
            115
        ],
        "53",
        "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
    ]
};
var faTimeline = {
    prefix: "fas",
    iconName: "timeline",
    icon: [
        640,
        512,
        [],
        "e29c",
        "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faKeyboard = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"
    ]
};
var faCaretDown = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
var faHouseChimneyMedical = {
    prefix: "fas",
    iconName: "house-chimney-medical",
    icon: [
        576,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"
    ]
};
var faClinicMedical = faHouseChimneyMedical;
var faTemperatureThreeQuarters = {
    prefix: "fas",
    iconName: "temperature-three-quarters",
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var faTemperature3 = faTemperatureThreeQuarters;
var faThermometer3 = faTemperatureThreeQuarters;
var faThermometerThreeQuarters = faTemperatureThreeQuarters;
var faMobileScreen = {
    prefix: "fas",
    iconName: "mobile-screen",
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
    ]
};
var faMobileAndroidAlt = faMobileScreen;
var faPlaneUp = {
    prefix: "fas",
    iconName: "plane-up",
    icon: [
        512,
        512,
        [],
        "e22d",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
    ]
};
var faPiggyBank = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var faBatteryHalf = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        576,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"
    ]
};
var faBattery3 = faBatteryHalf;
var faMountainCity = {
    prefix: "fas",
    iconName: "mountain-city",
    icon: [
        640,
        512,
        [],
        "e52e",
        "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
    ]
};
var faCoins = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ]
};
var faKhanda = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [
            9772
        ],
        "f66d",
        "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
    ]
};
var faSliders = {
    prefix: "fas",
    iconName: "sliders",
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
    ]
};
var faSlidersH = faSliders;
var faFolderTree = {
    prefix: "fas",
    iconName: "folder-tree",
    icon: [
        576,
        512,
        [],
        "f802",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
    ]
};
var faNetworkWired = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"
    ]
};
var faMapPin = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var faHamsa = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faCentSign = {
    prefix: "fas",
    iconName: "cent-sign",
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"
    ]
};
var faFlask = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"
    ]
};
var faPersonPregnant = {
    prefix: "fas",
    iconName: "person-pregnant",
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"
    ]
};
var faWandSparkles = {
    prefix: "fas",
    iconName: "wand-sparkles",
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
var faEllipsisVertical = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
};
var faEllipsisV = faEllipsisVertical;
var faTicket = {
    prefix: "fas",
    iconName: "ticket",
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
    ]
};
var faPowerOff = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
    ]
};
var faRightLong = {
    prefix: "fas",
    iconName: "right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"
    ]
};
var faLongArrowAltRight = faRightLong;
var faFlagUsa = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        448,
        512,
        [],
        "f74d",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faLaptopFile = {
    prefix: "fas",
    iconName: "laptop-file",
    icon: [
        640,
        512,
        [],
        "e51d",
        "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"
    ]
};
var faTty = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"
    ]
};
var faTeletype = faTty;
var faDiagramNext = {
    prefix: "fas",
    iconName: "diagram-next",
    icon: [
        512,
        512,
        [],
        "e476",
        "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
    ]
};
var faPersonRifle = {
    prefix: "fas",
    iconName: "person-rifle",
    icon: [
        576,
        512,
        [],
        "e54e",
        "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"
    ]
};
var faHouseMedicalCircleExclamation = {
    prefix: "fas",
    iconName: "house-medical-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e512",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var faClosedCaptioning = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var faPersonHiking = {
    prefix: "fas",
    iconName: "person-hiking",
    icon: [
        384,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
    ]
};
var faHiking = faPersonHiking;
var faVenusDouble = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"
    ]
};
var faImages = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
    ]
};
var faCalculator = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
    ]
};
var faPeoplePulling = {
    prefix: "fas",
    iconName: "people-pulling",
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
var faN = {
    prefix: "fas",
    iconName: "n",
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"
    ]
};
var faCableCar = {
    prefix: "fas",
    iconName: "cable-car",
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"
    ]
};
var faTram = faCableCar;
var faCloudRain = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
    ]
};
var faBuildingCircleXmark = {
    prefix: "fas",
    iconName: "building-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4d4",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faShip = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        576,
        512,
        [
            128674
        ],
        "f21a",
        "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var faArrowsDownToLine = {
    prefix: "fas",
    iconName: "arrows-down-to-line",
    icon: [
        576,
        512,
        [],
        "e4b8",
        "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var faDownload = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faFaceGrin = {
    prefix: "fas",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faGrin = faFaceGrin;
var faDeleteLeft = {
    prefix: "fas",
    iconName: "delete-left",
    icon: [
        576,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var faBackspace = faDeleteLeft;
var faEyeDropper = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
    ]
};
var faEyeDropperEmpty = faEyeDropper;
var faEyedropper = faEyeDropper;
var faFileCircleCheck = {
    prefix: "fas",
    iconName: "file-circle-check",
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var faForward = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"
    ]
};
var faMobile = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faMobileAndroid = faMobile;
var faMobilePhone = faMobile;
var faFaceMeh = {
    prefix: "fas",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faMeh = faFaceMeh;
var faAlignCenter = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"
    ]
};
var faBookSkull = {
    prefix: "fas",
    iconName: "book-skull",
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
    ]
};
var faBookDead = faBookSkull;
var faIdCard = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
    ]
};
var faDriversLicense = faIdCard;
var faOutdent = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
    ]
};
var faDedent = faOutdent;
var faHeartCircleExclamation = {
    prefix: "fas",
    iconName: "heart-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faHouse = {
    prefix: "fas",
    iconName: "house",
    icon: [
        576,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    ]
};
var faHome = faHouse;
var faHomeAlt = faHouse;
var faHomeLgAlt = faHouse;
var faCalendarWeek = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var faLaptopMedical = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var faB = {
    prefix: "fas",
    iconName: "b",
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
    ]
};
var faFileMedical = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"
    ]
};
var faDiceOne = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faKiwiBird = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faArrowRightArrowLeft = {
    prefix: "fas",
    iconName: "arrow-right-arrow-left",
    icon: [
        448,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
    ]
};
var faExchange = faArrowRightArrowLeft;
var faRotateRight = {
    prefix: "fas",
    iconName: "rotate-right",
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
    ]
};
var faRedoAlt = faRotateRight;
var faRotateForward = faRotateRight;
var faUtensils = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        448,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
    ]
};
var faCutlery = faUtensils;
var faArrowUpWideShort = {
    prefix: "fas",
    iconName: "arrow-up-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var faSortAmountUp = faArrowUpWideShort;
var faMillSign = {
    prefix: "fas",
    iconName: "mill-sign",
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
    ]
};
var faBowlRice = {
    prefix: "fas",
    iconName: "bowl-rice",
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faSkull = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var faTowerBroadcast = {
    prefix: "fas",
    iconName: "tower-broadcast",
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
    ]
};
var faBroadcastTower = faTowerBroadcast;
var faTruckPickup = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
    ]
};
var faUpLong = {
    prefix: "fas",
    iconName: "up-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var faLongArrowAltUp = faUpLong;
var faStop = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        384,
        512,
        [
            9209
        ],
        "f04d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var faCodeMerge = {
    prefix: "fas",
    iconName: "code-merge",
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faUpload = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faHurricane = {
    prefix: "fas",
    iconName: "hurricane",
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faMound = {
    prefix: "fas",
    iconName: "mound",
    icon: [
        576,
        512,
        [],
        "e52d",
        "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
    ]
};
var faToiletPortable = {
    prefix: "fas",
    iconName: "toilet-portable",
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faCompactDisc = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var faFileArrowDown = {
    prefix: "fas",
    iconName: "file-arrow-down",
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var faFileDownload = faFileArrowDown;
var faCaravan = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faShieldCat = {
    prefix: "fas",
    iconName: "shield-cat",
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var faBolt = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
    ]
};
var faZap = faBolt;
var faGlassWater = {
    prefix: "fas",
    iconName: "glass-water",
    icon: [
        384,
        512,
        [],
        "e4f4",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
    ]
};
var faOilWell = {
    prefix: "fas",
    iconName: "oil-well",
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"
    ]
};
var faVault = {
    prefix: "fas",
    iconName: "vault",
    icon: [
        576,
        512,
        [],
        "e2c5",
        "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
    ]
};
var faMars = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        448,
        512,
        [
            9794
        ],
        "f222",
        "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
var faToilet = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faPlaneCircleXmark = {
    prefix: "fas",
    iconName: "plane-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e557",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faYenSign = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        320,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
    ]
};
var faCny = faYenSign;
var faJpy = faYenSign;
var faRmb = faYenSign;
var faYen = faYenSign;
var faRubleSign = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var faRouble = faRubleSign;
var faRub = faRubleSign;
var faRuble = faRubleSign;
var faSun = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var faGuitar = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faFaceLaughWink = {
    prefix: "fas",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var faLaughWink = faFaceLaughWink;
var faHorseHead = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        640,
        512,
        [],
        "f7ab",
        "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faBoreHole = {
    prefix: "fas",
    iconName: "bore-hole",
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"
    ]
};
var faIndustry = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        576,
        512,
        [],
        "f275",
        "M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"
    ]
};
var faCircleDown = {
    prefix: "fas",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"
    ]
};
var faArrowAltCircleDown = faCircleDown;
var faArrowsTurnToDots = {
    prefix: "fas",
    iconName: "arrows-turn-to-dots",
    icon: [
        512,
        512,
        [],
        "e4c1",
        "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"
    ]
};
var faFlorinSign = {
    prefix: "fas",
    iconName: "florin-sign",
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"
    ]
};
var faArrowDownShortWide = {
    prefix: "fas",
    iconName: "arrow-down-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faSortAmountDesc = faArrowDownShortWide;
var faSortAmountDownAlt = faArrowDownShortWide;
var faLessThan = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [
            62774
        ],
        "3c",
        "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
var faAngleDown = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var faCarTunnel = {
    prefix: "fas",
    iconName: "car-tunnel",
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var faHeadSideCough = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faGripLines = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
var faThumbsDown = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"
    ]
};
var faUserLock = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var faArrowRightLong = {
    prefix: "fas",
    iconName: "arrow-right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var faLongArrowRight = faArrowRightLong;
var faAnchorCircleXmark = {
    prefix: "fas",
    iconName: "anchor-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faEllipsis = {
    prefix: "fas",
    iconName: "ellipsis",
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var faEllipsisH = faEllipsis;
var faChessPawn = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"
    ]
};
var faKitMedical = {
    prefix: "fas",
    iconName: "kit-medical",
    icon: [
        576,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"
    ]
};
var faFirstAid = faKitMedical;
var faPersonThroughWindow = {
    prefix: "fas",
    iconName: "person-through-window",
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var faToolbox = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"
    ]
};
var faHandsHoldingCircle = {
    prefix: "fas",
    iconName: "hands-holding-circle",
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var faBug = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var faCreditCard = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var faCreditCardAlt = faCreditCard;
var faCar = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faAutomobile = faCar;
var faHandHoldingHand = {
    prefix: "fas",
    iconName: "hand-holding-hand",
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var faBookOpenReader = {
    prefix: "fas",
    iconName: "book-open-reader",
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
    ]
};
var faBookReader = faBookOpenReader;
var faMountainSun = {
    prefix: "fas",
    iconName: "mountain-sun",
    icon: [
        640,
        512,
        [],
        "e52f",
        "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
    ]
};
var faArrowsLeftRightToLine = {
    prefix: "fas",
    iconName: "arrows-left-right-to-line",
    icon: [
        640,
        512,
        [],
        "e4ba",
        "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var faDiceD20 = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
    ]
};
var faTruckDroplet = {
    prefix: "fas",
    iconName: "truck-droplet",
    icon: [
        640,
        512,
        [],
        "e58c",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
    ]
};
var faFileCircleXmark = {
    prefix: "fas",
    iconName: "file-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var faTemperatureArrowUp = {
    prefix: "fas",
    iconName: "temperature-arrow-up",
    icon: [
        576,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
    ]
};
var faTemperatureUp = faTemperatureArrowUp;
var faMedal = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
};
var faBed = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var faSquareH = {
    prefix: "fas",
    iconName: "square-h",
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var faHSquare = faSquareH;
var faPodcast = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var faTemperatureFull = {
    prefix: "fas",
    iconName: "temperature-full",
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var faTemperature4 = faTemperatureFull;
var faThermometer4 = faTemperatureFull;
var faThermometerFull = faTemperatureFull;
var faBell = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var faSuperscript = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
    ]
};
var faPlugCircleXmark = {
    prefix: "fas",
    iconName: "plug-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e560",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faStarOfLife = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        512,
        512,
        [],
        "f621",
        "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"
    ]
};
var faPhoneSlash = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c12 25.5 27.2 49.2 45 70.7L601.2 5.1zM234.3 415.6l91.3-72c13.7 9.1 28 17.3 43 24.3L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512c-104.9 0-201.3-36-277.7-96.4z"
    ]
};
var faPaintRoller = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"
    ]
};
var faHandshakeAngle = {
    prefix: "fas",
    iconName: "handshake-angle",
    icon: [
        640,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"
    ]
};
var faHandsHelping = faHandshakeAngle;
var faLocationDot = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var faMapMarkerAlt = faLocationDot;
var faFile = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
    ]
};
var faGreaterThan = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [
            62769
        ],
        "3e",
        "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
    ]
};
var faPersonSwimming = {
    prefix: "fas",
    iconName: "person-swimming",
    icon: [
        576,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var faSwimmer = faPersonSwimming;
var faArrowDown = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var faDroplet = {
    prefix: "fas",
    iconName: "droplet",
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
    ]
};
var faTint = faDroplet;
var faEraser = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
};
var faEarthAmericas = {
    prefix: "fas",
    iconName: "earth-americas",
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var faEarth = faEarthAmericas;
var faEarthAmerica = faEarthAmericas;
var faGlobeAmericas = faEarthAmericas;
var faPersonBurst = {
    prefix: "fas",
    iconName: "person-burst",
    icon: [
        640,
        512,
        [],
        "e53b",
        "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.3-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var faDove = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var faBatteryEmpty = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        576,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"
    ]
};
var faBattery0 = faBatteryEmpty;
var faSocks = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"
    ]
};
var faInbox = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        512,
        512,
        [],
        "f01c",
        "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"
    ]
};
var faSection = {
    prefix: "fas",
    iconName: "section",
    icon: [
        256,
        512,
        [],
        "e447",
        "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
    ]
};
var faGaugeHigh = {
    prefix: "fas",
    iconName: "gauge-high",
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faTachometerAlt = faGaugeHigh;
var faTachometerAltFast = faGaugeHigh;
var faEnvelopeOpenText = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faHospital = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"
    ]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faWineBottle = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
    ]
};
var faChessRook = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var faBarsStaggered = {
    prefix: "fas",
    iconName: "bars-staggered",
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var faReorder = faBarsStaggered;
var faStream = faBarsStaggered;
var faDharmachakra = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faHotdog = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
    ]
};
var faPersonWalkingWithCane = {
    prefix: "fas",
    iconName: "person-walking-with-cane",
    icon: [
        512,
        512,
        [
            "blind"
        ],
        "f29d",
        "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
    ]
};
var faBlind = faPersonWalkingWithCane;
var faDrum = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [
            129345
        ],
        "f569",
        "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"
    ]
};
var faIceCream = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [
            127848
        ],
        "f810",
        "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"
    ]
};
var faHeartCircleBolt = {
    prefix: "fas",
    iconName: "heart-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var faFax = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faParagraph = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
    ]
};
var faCheckToSlot = {
    prefix: "fas",
    iconName: "check-to-slot",
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"
    ]
};
var faVoteYea = faCheckToSlot;
var faStarHalf = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"
    ]
};
var faBoxesStacked = {
    prefix: "fas",
    iconName: "boxes-stacked",
    icon: [
        576,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
    ]
};
var faBoxes = faBoxesStacked;
var faBoxesAlt = faBoxesStacked;
var faLink = {
    prefix: "fas",
    iconName: "link",
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
};
var faChain = faLink;
var faEarListen = {
    prefix: "fas",
    iconName: "ear-listen",
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var faAssistiveListeningSystems = faEarListen;
var faTreeCity = {
    prefix: "fas",
    iconName: "tree-city",
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
    ]
};
var faPlay = {
    prefix: "fas",
    iconName: "play",
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
};
var faFont = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
    ]
};
var faRupiahSign = {
    prefix: "fas",
    iconName: "rupiah-sign",
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"
    ]
};
var faMagnifyingGlass = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
};
var faSearch = faMagnifyingGlass;
var faTableTennisPaddleBall = {
    prefix: "fas",
    iconName: "table-tennis-paddle-ball",
    icon: [
        640,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var faPingPongPaddleBall = faTableTennisPaddleBall;
var faTableTennis = faTableTennisPaddleBall;
var faPersonDotsFromLine = {
    prefix: "fas",
    iconName: "person-dots-from-line",
    icon: [
        576,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faDiagnoses = faPersonDotsFromLine;
var faTrashCanArrowUp = {
    prefix: "fas",
    iconName: "trash-can-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var faTrashRestoreAlt = faTrashCanArrowUp;
var faNairaSign = {
    prefix: "fas",
    iconName: "naira-sign",
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"
    ]
};
var faCartArrowDown = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var faWalkieTalkie = {
    prefix: "fas",
    iconName: "walkie-talkie",
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faFilePen = {
    prefix: "fas",
    iconName: "file-pen",
    icon: [
        576,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V299.6l-94.7 94.7c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var faFileEdit = faFilePen;
var faReceipt = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
    ]
};
var faSquarePen = {
    prefix: "fas",
    iconName: "square-pen",
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var faPenSquare = faSquarePen;
var faPencilSquare = faSquarePen;
var faSuitcaseRolling = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faPersonCircleExclamation = {
    prefix: "fas",
    iconName: "person-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e53f",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var faChevronDown = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
var faBatteryFull = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        576,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"
    ]
};
var faBattery = faBatteryFull;
var faBattery5 = faBatteryFull;
var faSkullCrossbones = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"
    ]
};
var faCodeCompare = {
    prefix: "fas",
    iconName: "code-compare",
    icon: [
        512,
        512,
        [],
        "e13a",
        "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
    ]
};
var faListUl = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var faListDots = faListUl;
var faSchoolLock = {
    prefix: "fas",
    iconName: "school-lock",
    icon: [
        640,
        512,
        [],
        "e56f",
        "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var faTowerCell = {
    prefix: "fas",
    iconName: "tower-cell",
    icon: [
        576,
        512,
        [],
        "e585",
        "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
var faDownLong = {
    prefix: "fas",
    iconName: "down-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
    ]
};
var faLongArrowAltDown = faDownLong;
var faRankingStar = {
    prefix: "fas",
    iconName: "ranking-star",
    icon: [
        640,
        512,
        [],
        "e561",
        "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
    ]
};
var faChessKing = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
    ]
};
var faPersonHarassing = {
    prefix: "fas",
    iconName: "person-harassing",
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
var faBrazilianRealSign = {
    prefix: "fas",
    iconName: "brazilian-real-sign",
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"
    ]
};
var faLandmarkDome = {
    prefix: "fas",
    iconName: "landmark-dome",
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
    ]
};
var faLandmarkAlt = faLandmarkDome;
var faArrowUp = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
var faTv = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faTelevision = faTv;
var faTvAlt = faTv;
var faShrimp = {
    prefix: "fas",
    iconName: "shrimp",
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faListCheck = {
    prefix: "fas",
    iconName: "list-check",
    icon: [
        512,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faTasks = faListCheck;
var faJugDetergent = {
    prefix: "fas",
    iconName: "jug-detergent",
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var faCircleUser = {
    prefix: "fas",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
    ]
};
var faUserCircle = faCircleUser;
var faUserShield = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"
    ]
};
var faWind = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var faCarBurst = {
    prefix: "fas",
    iconName: "car-burst",
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"
    ]
};
var faCarCrash = faCarBurst;
var faY = {
    prefix: "fas",
    iconName: "y",
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
var faPersonSnowboarding = {
    prefix: "fas",
    iconName: "person-snowboarding",
    icon: [
        512,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faSnowboarding = faPersonSnowboarding;
var faTruckFast = {
    prefix: "fas",
    iconName: "truck-fast",
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var faShippingFast = faTruckFast;
var faFish = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faUserGraduate = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
    ]
};
var faCircleHalfStroke = {
    prefix: "fas",
    iconName: "circle-half-stroke",
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var faAdjust = faCircleHalfStroke;
var faClapperboard = {
    prefix: "fas",
    iconName: "clapperboard",
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"
    ]
};
var faCircleRadiation = {
    prefix: "fas",
    iconName: "circle-radiation",
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faRadiationAlt = faCircleRadiation;
var faBaseball = {
    prefix: "fas",
    iconName: "baseball",
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
    ]
};
var faBaseballBall = faBaseball;
var faJetFighterUp = {
    prefix: "fas",
    iconName: "jet-fighter-up",
    icon: [
        512,
        512,
        [],
        "e518",
        "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
    ]
};
var faDiagramProject = {
    prefix: "fas",
    iconName: "diagram-project",
    icon: [
        576,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
    ]
};
var faProjectDiagram = faDiagramProject;
var faCopy = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
    ]
};
var faVolumeXmark = {
    prefix: "fas",
    iconName: "volume-xmark",
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var faVolumeMute = faVolumeXmark;
var faVolumeTimes = faVolumeXmark;
var faHandSparkles = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
var faGrip = {
    prefix: "fas",
    iconName: "grip",
    icon: [
        448,
        512,
        [
            "grip-horizontal"
        ],
        "f58d",
        "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"
    ]
};
var faGripHorizontal = faGrip;
var faShareFromSquare = {
    prefix: "fas",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
    ]
};
var faShareSquare = faShareFromSquare;
var faChildCombatant = {
    prefix: "fas",
    iconName: "child-combatant",
    icon: [
        576,
        512,
        [
            "child-rifle"
        ],
        "e4e0",
        "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
    ]
};
var faChildRifle = faChildCombatant;
var faGun = {
    prefix: "fas",
    iconName: "gun",
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faSquarePhone = {
    prefix: "fas",
    iconName: "square-phone",
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
    ]
};
var faPhoneSquare = faSquarePhone;
var faPlus = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    ]
};
var faAdd = faPlus;
var faExpand = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"
    ]
};
var faComputer = {
    prefix: "fas",
    iconName: "computer",
    icon: [
        640,
        512,
        [],
        "e4e5",
        "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faXmark = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
};
var faClose = faXmark;
var faMultiply = faXmark;
var faRemove = faXmark;
var faTimes = faXmark;
var faArrowsUpDownLeftRight = {
    prefix: "fas",
    iconName: "arrows-up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var faArrows = faArrowsUpDownLeftRight;
var faChalkboardUser = {
    prefix: "fas",
    iconName: "chalkboard-user",
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
    ]
};
var faChalkboardTeacher = faChalkboardUser;
var faPesoSign = {
    prefix: "fas",
    iconName: "peso-sign",
    icon: [
        384,
        512,
        [],
        "e222",
        "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"
    ]
};
var faBuildingShield = {
    prefix: "fas",
    iconName: "building-shield",
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var faBaby = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        448,
        512,
        [],
        "f77c",
        "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
    ]
};
var faUsersLine = {
    prefix: "fas",
    iconName: "users-line",
    icon: [
        640,
        512,
        [],
        "e592",
        "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var faQuoteLeft = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"
    ]
};
var faQuoteLeftAlt = faQuoteLeft;
var faTractor = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [
            128668
        ],
        "f722",
        "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
    ]
};
var faTrashArrowUp = {
    prefix: "fas",
    iconName: "trash-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var faTrashRestore = faTrashArrowUp;
var faArrowDownUpLock = {
    prefix: "fas",
    iconName: "arrow-down-up-lock",
    icon: [
        640,
        512,
        [],
        "e4b0",
        "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var faLinesLeaning = {
    prefix: "fas",
    iconName: "lines-leaning",
    icon: [
        384,
        512,
        [],
        "e51e",
        "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
    ]
};
var faRulerCombined = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
    ]
};
var faCopyright = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
    ]
};
var faEquals = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
    ]
};
var faBlender = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faTeeth = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        576,
        512,
        [],
        "f62e",
        "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
    ]
};
var faShekelSign = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"
    ]
};
var faIls = faShekelSign;
var faShekel = faShekelSign;
var faSheqel = faShekelSign;
var faSheqelSign = faShekelSign;
var faMap = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
};
var faRocket = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var faPhotoFilm = {
    prefix: "fas",
    iconName: "photo-film",
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"
    ]
};
var faPhotoVideo = faPhotoFilm;
var faFolderMinus = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var faStore = {
    prefix: "fas",
    iconName: "store",
    icon: [
        576,
        512,
        [],
        "f54e",
        "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
    ]
};
var faArrowTrendUp = {
    prefix: "fas",
    iconName: "arrow-trend-up",
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
    ]
};
var faPlugCircleMinus = {
    prefix: "fas",
    iconName: "plug-circle-minus",
    icon: [
        576,
        512,
        [],
        "e55e",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var faSignHanging = {
    prefix: "fas",
    iconName: "sign-hanging",
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var faSign = faSignHanging;
var faBezierCurve = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"
    ]
};
var faBellSlash = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-90.2-70.7c.2-.4 .4-.9 .6-1.3c5.2-11.5 3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM406.2 416L160 222.1v4.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416H406.2zm-40.9 77.3c12-12 18.7-28.3 18.7-45.3H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var faTablet = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faTabletAndroid = faTablet;
var faSchoolFlag = {
    prefix: "fas",
    iconName: "school-flag",
    icon: [
        576,
        512,
        [],
        "e56e",
        "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"
    ]
};
var faFill = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"
    ]
};
var faAngleUp = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        448,
        512,
        [
            8963
        ],
        "f106",
        "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
var faDrumstickBite = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"
    ]
};
var faHollyBerry = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var faChevronLeft = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [
            9001
        ],
        "f053",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
var faBacteria = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
    ]
};
var faHandLizard = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"
    ]
};
var faNotdef = {
    prefix: "fas",
    iconName: "notdef",
    icon: [
        384,
        512,
        [],
        "e1fe",
        "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var faDisease = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faBriefcaseMedical = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var faGenderless = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
    ]
};
var faChevronRight = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
var faRetweet = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        576,
        512,
        [],
        "f079",
        "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
    ]
};
var faCarRear = {
    prefix: "fas",
    iconName: "car-rear",
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faCarAlt = faCarRear;
var faPumpSoap = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        448,
        512,
        [],
        "e06b",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
    ]
};
var faVideoSlash = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"
    ]
};
var faBatteryQuarter = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        576,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"
    ]
};
var faBattery2 = faBatteryQuarter;
var faRadio = {
    prefix: "fas",
    iconName: "radio",
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var faBabyCarriage = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var faCarriageBaby = faBabyCarriage;
var faTrafficLight = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
    ]
};
var faThermometer = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
    ]
};
var faVrCardboard = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var faHandMiddleFinger = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
    ]
};
var faPercent = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        384,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var faPercentage = faPercent;
var faTruckMoving = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faGlassWaterDroplet = {
    prefix: "fas",
    iconName: "glass-water-droplet",
    icon: [
        384,
        512,
        [],
        "e4f5",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
var faDisplay = {
    prefix: "fas",
    iconName: "display",
    icon: [
        576,
        512,
        [],
        "e163",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"
    ]
};
var faFaceSmile = {
    prefix: "fas",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faSmile = faFaceSmile;
var faThumbtack = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var faThumbTack = faThumbtack;
var faTrophy = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [
            127942
        ],
        "f091",
        "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
    ]
};
var faPersonPraying = {
    prefix: "fas",
    iconName: "person-praying",
    icon: [
        448,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
    ]
};
var faPray = faPersonPraying;
var faHammer = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [
            128296
        ],
        "f6e3",
        "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
    ]
};
var faHandPeace = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
var faRotate = {
    prefix: "fas",
    iconName: "rotate",
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    ]
};
var faSyncAlt = faRotate;
var faSpinner = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
    ]
};
var faRobot = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"
    ]
};
var faPeace = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var faGears = {
    prefix: "fas",
    iconName: "gears",
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faCogs = faGears;
var faWarehouse = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"
    ]
};
var faArrowUpRightDots = {
    prefix: "fas",
    iconName: "arrow-up-right-dots",
    icon: [
        576,
        512,
        [],
        "e4b7",
        "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faSplotch = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
    ]
};
var faFaceGrinHearts = {
    prefix: "fas",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var faGrinHearts = faFaceGrinHearts;
var faDiceFour = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faSimCard = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
    ]
};
var faTransgender = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        512,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
    ]
};
var faTransgenderAlt = faTransgender;
var faMercury = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"
    ]
};
var faArrowTurnDown = {
    prefix: "fas",
    iconName: "arrow-turn-down",
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
var faLevelDown = faArrowTurnDown;
var faPersonFallingBurst = {
    prefix: "fas",
    iconName: "person-falling-burst",
    icon: [
        640,
        512,
        [],
        "e547",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
    ]
};
var faAward = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    ]
};
var faTicketSimple = {
    prefix: "fas",
    iconName: "ticket-simple",
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"
    ]
};
var faTicketAlt = faTicketSimple;
var faBuilding = {
    prefix: "fas",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
    ]
};
var faAnglesLeft = {
    prefix: "fas",
    iconName: "angles-left",
    icon: [
        512,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
var faAngleDoubleLeft = faAnglesLeft;
var faQrcode = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
    ]
};
var faClockRotateLeft = {
    prefix: "fas",
    iconName: "clock-rotate-left",
    icon: [
        512,
        512,
        [
            "history"
        ],
        "f1da",
        "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
    ]
};
var faHistory = faClockRotateLeft;
var faFaceGrinBeamSweat = {
    prefix: "fas",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM388.1 312.8c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5c5-11.8-7-22.5-19.3-18.7zm-170.5-84l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"
    ]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faFileExport = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
    ]
};
var faArrowRightFromFile = faFileExport;
var faShield = {
    prefix: "fas",
    iconName: "shield",
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
};
var faShieldBlank = faShield;
var faArrowUpShortWide = {
    prefix: "fas",
    iconName: "arrow-up-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var faSortAmountUpAlt = faArrowUpShortWide;
var faHouseMedical = {
    prefix: "fas",
    iconName: "house-medical",
    icon: [
        576,
        512,
        [],
        "e3b2",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var faGolfBallTee = {
    prefix: "fas",
    iconName: "golf-ball-tee",
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"
    ]
};
var faGolfBall = faGolfBallTee;
var faCircleChevronLeft = {
    prefix: "fas",
    iconName: "circle-chevron-left",
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
var faChevronCircleLeft = faCircleChevronLeft;
var faHouseChimneyWindow = {
    prefix: "fas",
    iconName: "house-chimney-window",
    icon: [
        576,
        512,
        [],
        "e00d",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"
    ]
};
var faPenNib = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
    ]
};
var faTentArrowTurnLeft = {
    prefix: "fas",
    iconName: "tent-arrow-turn-left",
    icon: [
        576,
        512,
        [],
        "e580",
        "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var faTents = {
    prefix: "fas",
    iconName: "tents",
    icon: [
        640,
        512,
        [],
        "e582",
        "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H176h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H400h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var faWandMagic = {
    prefix: "fas",
    iconName: "wand-magic",
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
    ]
};
var faMagic = faWandMagic;
var faDog = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var faCarrot = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [
            129365
        ],
        "f787",
        "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
    ]
};
var faMoon = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
    ]
};
var faWineGlassEmpty = {
    prefix: "fas",
    iconName: "wine-glass-empty",
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
    ]
};
var faWineGlassAlt = faWineGlassEmpty;
var faCheese = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"
    ]
};
var faYinYang = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faMusic = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
    ]
};
var faCodeCommit = {
    prefix: "fas",
    iconName: "code-commit",
    icon: [
        640,
        512,
        [],
        "f386",
        "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
    ]
};
var faTemperatureLow = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var faPersonBiking = {
    prefix: "fas",
    iconName: "person-biking",
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var faBiking = faPersonBiking;
var faBroom = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        576,
        512,
        [
            129529
        ],
        "f51a",
        "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"
    ]
};
var faShieldHeart = {
    prefix: "fas",
    iconName: "shield-heart",
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
    ]
};
var faGopuram = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var faEarthOceania = {
    prefix: "fas",
    iconName: "earth-oceania",
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var faGlobeOceania = faEarthOceania;
var faSquareXmark = {
    prefix: "fas",
    iconName: "square-xmark",
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var faTimesSquare = faSquareXmark;
var faXmarkSquare = faSquareXmark;
var faHashtag = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [
            62098
        ],
        "23",
        "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
    ]
};
var faUpRightAndDownLeftFromCenter = {
    prefix: "fas",
    iconName: "up-right-and-down-left-from-center",
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
    ]
};
var faExpandAlt = faUpRightAndDownLeftFromCenter;
var faOilCan = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"
    ]
};
var faT = {
    prefix: "fas",
    iconName: "t",
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"
    ]
};
var faHippo = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faChartColumn = {
    prefix: "fas",
    iconName: "chart-column",
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var faInfinity = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
    ]
};
var faVialCircleCheck = {
    prefix: "fas",
    iconName: "vial-circle-check",
    icon: [
        512,
        512,
        [],
        "e596",
        "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var faPersonArrowDownToLine = {
    prefix: "fas",
    iconName: "person-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e538",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var faVoicemail = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var faFan = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faPersonWalkingLuggage = {
    prefix: "fas",
    iconName: "person-walking-luggage",
    icon: [
        576,
        512,
        [],
        "e554",
        "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
    ]
};
var faUpDown = {
    prefix: "fas",
    iconName: "up-down",
    icon: [
        256,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
    ]
};
var faArrowsAltV = faUpDown;
var faCloudMoonRain = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
    ]
};
var faCalendar = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    ]
};
var faTrailer = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faBahai = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    ]
};
var faHaykal = faBahai;
var faSdCard = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var faDragon = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
    ]
};
var faShoePrints = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"
    ]
};
var faCirclePlus = {
    prefix: "fas",
    iconName: "circle-plus",
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var faPlusCircle = faCirclePlus;
var faFaceGrinTongueWink = {
    prefix: "fas",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faHandHolding = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z"
    ]
};
var faPlugCircleExclamation = {
    prefix: "fas",
    iconName: "plug-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e55d",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var faLinkSlash = {
    prefix: "fas",
    iconName: "link-slash",
    icon: [
        640,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM116.6 187.9L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9zM220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3L220.9 270z"
    ]
};
var faChainBroken = faLinkSlash;
var faChainSlash = faLinkSlash;
var faUnlink = faLinkSlash;
var faClone = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
    ]
};
var faPersonWalkingArrowLoopLeft = {
    prefix: "fas",
    iconName: "person-walking-arrow-loop-left",
    icon: [
        640,
        512,
        [],
        "e551",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
    ]
};
var faArrowUpZA = {
    prefix: "fas",
    iconName: "arrow-up-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"
    ]
};
var faSortAlphaUpAlt = faArrowUpZA;
var faFireFlameCurved = {
    prefix: "fas",
    iconName: "fire-flame-curved",
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
    ]
};
var faFireAlt = faFireFlameCurved;
var faTornado = {
    prefix: "fas",
    iconName: "tornado",
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
    ]
};
var faFileCirclePlus = {
    prefix: "fas",
    iconName: "file-circle-plus",
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var faBookQuran = {
    prefix: "fas",
    iconName: "book-quran",
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
    ]
};
var faQuran = faBookQuran;
var faAnchor = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"
    ]
};
var faBorderAll = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var faFaceAngry = {
    prefix: "fas",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var faAngry = faFaceAngry;
var faCookieBite = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6v0c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9v0c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faArrowTrendDown = {
    prefix: "fas",
    iconName: "arrow-trend-down",
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
    ]
};
var faRss = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faFeed = faRss;
var faDrawPolygon = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
    ]
};
var faScaleBalanced = {
    prefix: "fas",
    iconName: "scale-balanced",
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
    ]
};
var faBalanceScale = faScaleBalanced;
var faGaugeSimpleHigh = {
    prefix: "fas",
    iconName: "gauge-simple-high",
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var faTachometer = faGaugeSimpleHigh;
var faTachometerFast = faGaugeSimpleHigh;
var faShower = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faDesktop = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
    ]
};
var faDesktopAlt = faDesktop;
var faM = {
    prefix: "fas",
    iconName: "m",
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"
    ]
};
var faTableList = {
    prefix: "fas",
    iconName: "table-list",
    icon: [
        512,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
    ]
};
var faThList = faTableList;
var faCommentSms = {
    prefix: "fas",
    iconName: "comment-sms",
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8H152c8.8 0 16 7.2 16 16s-7.2 16-16 16H132.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176H392c8.8 0 16 7.2 16 16s-7.2 16-16 16H372.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z"
    ]
};
var faSms = faCommentSms;
var faBook = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faUserPlus = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var faCheck = {
    prefix: "fas",
    iconName: "check",
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var faBatteryThreeQuarters = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        576,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"
    ]
};
var faBattery4 = faBatteryThreeQuarters;
var faHouseCircleCheck = {
    prefix: "fas",
    iconName: "house-circle-check",
    icon: [
        640,
        512,
        [],
        "e509",
        "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var faAngleLeft = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        320,
        512,
        [
            8249
        ],
        "f104",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var faDiagramSuccessor = {
    prefix: "fas",
    iconName: "diagram-successor",
    icon: [
        512,
        512,
        [],
        "e47a",
        "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
    ]
};
var faTruckArrowRight = {
    prefix: "fas",
    iconName: "truck-arrow-right",
    icon: [
        640,
        512,
        [],
        "e58b",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
    ]
};
var faArrowsSplitUpAndLeft = {
    prefix: "fas",
    iconName: "arrows-split-up-and-left",
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
    ]
};
var faHandFist = {
    prefix: "fas",
    iconName: "hand-fist",
    icon: [
        448,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var faFistRaised = faHandFist;
var faCloudMoon = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var faBriefcase = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
    ]
};
var faPersonFalling = {
    prefix: "fas",
    iconName: "person-falling",
    icon: [
        512,
        512,
        [],
        "e546",
        "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var faImagePortrait = {
    prefix: "fas",
    iconName: "image-portrait",
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
    ]
};
var faPortrait = faImagePortrait;
var faUserTag = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var faRug = {
    prefix: "fas",
    iconName: "rug",
    icon: [
        640,
        512,
        [],
        "e569",
        "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"
    ]
};
var faEarthEurope = {
    prefix: "fas",
    iconName: "earth-europe",
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var faGlobeEurope = faEarthEurope;
var faCartFlatbedSuitcase = {
    prefix: "fas",
    iconName: "cart-flatbed-suitcase",
    icon: [
        640,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var faLuggageCart = faCartFlatbedSuitcase;
var faRectangleXmark = {
    prefix: "fas",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faBahtSign = {
    prefix: "fas",
    iconName: "baht-sign",
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"
    ]
};
var faBookOpen = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
    ]
};
var faBookJournalWhills = {
    prefix: "fas",
    iconName: "book-journal-whills",
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
    ]
};
var faJournalWhills = faBookJournalWhills;
var faHandcuffs = {
    prefix: "fas",
    iconName: "handcuffs",
    icon: [
        640,
        512,
        [],
        "e4f8",
        "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faTriangleExclamation = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faExclamationTriangle = faTriangleExclamation;
var faWarning = faTriangleExclamation;
var faDatabase = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"
    ]
};
var faShare = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [
            "mail-forward"
        ],
        "f064",
        "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    ]
};
var faMailForward = faShare;
var faBottleDroplet = {
    prefix: "fas",
    iconName: "bottle-droplet",
    icon: [
        320,
        512,
        [],
        "e4c4",
        "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"
    ]
};
var faMaskFace = {
    prefix: "fas",
    iconName: "mask-face",
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var faHillRockslide = {
    prefix: "fas",
    iconName: "hill-rockslide",
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faRightLeft = {
    prefix: "fas",
    iconName: "right-left",
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"
    ]
};
var faExchangeAlt = faRightLeft;
var faPaperPlane = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
};
var faRoadCircleExclamation = {
    prefix: "fas",
    iconName: "road-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e565",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var faDungeon = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
    ]
};
var faAlignRight = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var faMoneyBill1Wave = {
    prefix: "fas",
    iconName: "money-bill-1-wave",
    icon: [
        576,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var faMoneyBillWaveAlt = faMoneyBill1Wave;
var faLifeRing = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var faHands = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        576,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
    ]
};
var faSignLanguage = faHands;
var faSigning = faHands;
var faCalendarDay = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var faWaterLadder = {
    prefix: "fas",
    iconName: "water-ladder",
    icon: [
        576,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var faLadderWater = faWaterLadder;
var faSwimmingPool = faWaterLadder;
var faArrowsUpDown = {
    prefix: "fas",
    iconName: "arrows-up-down",
    icon: [
        320,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var faArrowsV = faArrowsUpDown;
var faFaceGrimace = {
    prefix: "fas",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faGrimace = faFaceGrimace;
var faWheelchairMove = {
    prefix: "fas",
    iconName: "wheelchair-move",
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var faWheelchairAlt = faWheelchairMove;
var faTurnDown = {
    prefix: "fas",
    iconName: "turn-down",
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"
    ]
};
var faLevelDownAlt = faTurnDown;
var faPersonWalkingArrowRight = {
    prefix: "fas",
    iconName: "person-walking-arrow-right",
    icon: [
        640,
        512,
        [],
        "e552",
        "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
    ]
};
var faSquareEnvelope = {
    prefix: "fas",
    iconName: "square-envelope",
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
    ]
};
var faEnvelopeSquare = faSquareEnvelope;
var faDice = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [
            127922
        ],
        "f522",
        "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faBowlingBall = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faBrain = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
    ]
};
var faBandage = {
    prefix: "fas",
    iconName: "bandage",
    icon: [
        640,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faBandAid = faBandage;
var faCalendarMinus = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H312z"
    ]
};
var faCircleXmark = {
    prefix: "fas",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faGifts = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
    ]
};
var faHotel = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"
    ]
};
var faEarthAsia = {
    prefix: "fas",
    iconName: "earth-asia",
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
    ]
};
var faGlobeAsia = faEarthAsia;
var faIdCardClip = {
    prefix: "fas",
    iconName: "id-card-clip",
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var faIdCardAlt = faIdCardClip;
var faMagnifyingGlassPlus = {
    prefix: "fas",
    iconName: "magnifying-glass-plus",
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var faSearchPlus = faMagnifyingGlassPlus;
var faThumbsUp = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
    ]
};
var faUserClock = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"
    ]
};
var faHandDots = {
    prefix: "fas",
    iconName: "hand-dots",
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var faAllergies = faHandDots;
var faFileInvoice = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faWindowMinimize = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var faMugSaucer = {
    prefix: "fas",
    iconName: "mug-saucer",
    icon: [
        640,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var faCoffee = faMugSaucer;
var faBrush = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var faMask = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var faMagnifyingGlassMinus = {
    prefix: "fas",
    iconName: "magnifying-glass-minus",
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
    ]
};
var faSearchMinus = faMagnifyingGlassMinus;
var faRulerVertical = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var faUserLarge = {
    prefix: "fas",
    iconName: "user-large",
    icon: [
        512,
        512,
        [
            "user-alt"
        ],
        "f406",
        "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"
    ]
};
var faUserAlt = faUserLarge;
var faTrainTram = {
    prefix: "fas",
    iconName: "train-tram",
    icon: [
        448,
        512,
        [
            128650
        ],
        "e5b4",
        "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faUserNurse = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"
    ]
};
var faSyringe = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [
            128137
        ],
        "f48e",
        "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
    ]
};
var faCloudSun = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [
            9925
        ],
        "f6c4",
        "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var faStopwatch20 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
    ]
};
var faSquareFull = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 0H512V512H0V0z"
    ]
};
var faMagnet = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"
    ]
};
var faJar = {
    prefix: "fas",
    iconName: "jar",
    icon: [
        320,
        512,
        [],
        "e516",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"
    ]
};
var faNoteSticky = {
    prefix: "fas",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"
    ]
};
var faStickyNote = faNoteSticky;
var faBugSlash = {
    prefix: "fas",
    iconName: "bug-slash",
    icon: [
        640,
        512,
        [],
        "e490",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zm392 430.3L336 360.7V479.2c36.6-3.6 69.7-19.6 94.8-43.8zM166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96z"
    ]
};
var faArrowUpFromWaterPump = {
    prefix: "fas",
    iconName: "arrow-up-from-water-pump",
    icon: [
        576,
        512,
        [],
        "e4b6",
        "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var faBone = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        576,
        512,
        [
            129460
        ],
        "f5d7",
        "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
    ]
};
var faUserInjured = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"
    ]
};
var faFaceSadTear = {
    prefix: "fas",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faSadTear = faFaceSadTear;
var faPlane = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
    ]
};
var faTentArrowsDown = {
    prefix: "fas",
    iconName: "tent-arrows-down",
    icon: [
        576,
        512,
        [],
        "e581",
        "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H240h16c17.7 0 32-14.3 32-32V361.9c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5l68.4 136.8c5.4 10.8 16.5 17.7 28.6 17.7H464h16c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var faExclamation = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        64,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var faArrowsSpin = {
    prefix: "fas",
    iconName: "arrows-spin",
    icon: [
        512,
        512,
        [],
        "e4bb",
        "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"
    ]
};
var faPrint = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faTurkishLiraSign = {
    prefix: "fas",
    iconName: "turkish-lira-sign",
    icon: [
        384,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var faTry = faTurkishLiraSign;
var faTurkishLira = faTurkishLiraSign;
var faDollarSign = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"
    ]
};
var faDollar = faDollarSign;
var faUsd = faDollarSign;
var faX = {
    prefix: "fas",
    iconName: "x",
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
var faMagnifyingGlassDollar = {
    prefix: "fas",
    iconName: "magnifying-glass-dollar",
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
    ]
};
var faSearchDollar = faMagnifyingGlassDollar;
var faUsersGear = {
    prefix: "fas",
    iconName: "users-gear",
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    ]
};
var faUsersCog = faUsersGear;
var faPersonMilitaryPointing = {
    prefix: "fas",
    iconName: "person-military-pointing",
    icon: [
        576,
        512,
        [],
        "e54a",
        "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"
    ]
};
var faBuildingColumns = {
    prefix: "fas",
    iconName: "building-columns",
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faBank = faBuildingColumns;
var faInstitution = faBuildingColumns;
var faMuseum = faBuildingColumns;
var faUniversity = faBuildingColumns;
var faUmbrella = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
    ]
};
var faTrowel = {
    prefix: "fas",
    iconName: "trowel",
    icon: [
        512,
        512,
        [],
        "e589",
        "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
var faD = {
    prefix: "fas",
    iconName: "d",
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"
    ]
};
var faStapler = {
    prefix: "fas",
    iconName: "stapler",
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"
    ]
};
var faMasksTheater = {
    prefix: "fas",
    iconName: "masks-theater",
    icon: [
        640,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
    ]
};
var faTheaterMasks = faMasksTheater;
var faKipSign = {
    prefix: "fas",
    iconName: "kip-sign",
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
    ]
};
var faHandPointLeft = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
    ]
};
var faHandshakeSimple = {
    prefix: "fas",
    iconName: "handshake-simple",
    icon: [
        640,
        512,
        [
            129309,
            "handshake-alt"
        ],
        "f4c6",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
    ]
};
var faHandshakeAlt = faHandshakeSimple;
var faJetFighter = {
    prefix: "fas",
    iconName: "jet-fighter",
    icon: [
        640,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var faFighterJet = faJetFighter;
var faSquareShareNodes = {
    prefix: "fas",
    iconName: "square-share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
var faShareAltSquare = faSquareShareNodes;
var faBarcode = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var faPlusMinus = {
    prefix: "fas",
    iconName: "plus-minus",
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var faVideo = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
    ]
};
var faVideoCamera = faVideo;
var faGraduationCap = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
    ]
};
var faMortarBoard = faGraduationCap;
var faHandHoldingMedical = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var faPersonCircleCheck = {
    prefix: "fas",
    iconName: "person-circle-check",
    icon: [
        576,
        512,
        [],
        "e53e",
        "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var faTurnUp = {
    prefix: "fas",
    iconName: "turn-up",
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var faLevelUpAlt = faTurnUp;
var icons = {
    fa0: fa0,
    fa1: fa1,
    fa2: fa2,
    fa3: fa3,
    fa4: fa4,
    fa5: fa5,
    fa6: fa6,
    fa7: fa7,
    fa8: fa8,
    fa9: fa9,
    faFillDrip: faFillDrip,
    faArrowsToCircle: faArrowsToCircle,
    faCircleChevronRight: faCircleChevronRight,
    faChevronCircleRight: faChevronCircleRight,
    faAt: faAt,
    faTrashCan: faTrashCan,
    faTrashAlt: faTrashAlt,
    faTextHeight: faTextHeight,
    faUserXmark: faUserXmark,
    faUserTimes: faUserTimes,
    faStethoscope: faStethoscope,
    faMessage: faMessage,
    faCommentAlt: faCommentAlt,
    faInfo: faInfo,
    faDownLeftAndUpRightToCenter: faDownLeftAndUpRightToCenter,
    faCompressAlt: faCompressAlt,
    faExplosion: faExplosion,
    faFileLines: faFileLines,
    faFileAlt: faFileAlt,
    faFileText: faFileText,
    faWaveSquare: faWaveSquare,
    faRing: faRing,
    faBuildingUn: faBuildingUn,
    faDiceThree: faDiceThree,
    faCalendarDays: faCalendarDays,
    faCalendarAlt: faCalendarAlt,
    faAnchorCircleCheck: faAnchorCircleCheck,
    faBuildingCircleArrowRight: faBuildingCircleArrowRight,
    faVolleyball: faVolleyball,
    faVolleyballBall: faVolleyballBall,
    faArrowsUpToLine: faArrowsUpToLine,
    faSortDown: faSortDown,
    faSortDesc: faSortDesc,
    faCircleMinus: faCircleMinus,
    faMinusCircle: faMinusCircle,
    faDoorOpen: faDoorOpen,
    faRightFromBracket: faRightFromBracket,
    faSignOutAlt: faSignOutAlt,
    faAtom: faAtom,
    faSoap: faSoap,
    faIcons: faIcons,
    faHeartMusicCameraBolt: faHeartMusicCameraBolt,
    faMicrophoneLinesSlash: faMicrophoneLinesSlash,
    faMicrophoneAltSlash: faMicrophoneAltSlash,
    faBridgeCircleCheck: faBridgeCircleCheck,
    faPumpMedical: faPumpMedical,
    faFingerprint: faFingerprint,
    faHandPointRight: faHandPointRight,
    faMagnifyingGlassLocation: faMagnifyingGlassLocation,
    faSearchLocation: faSearchLocation,
    faForwardStep: faForwardStep,
    faStepForward: faStepForward,
    faFaceSmileBeam: faFaceSmileBeam,
    faSmileBeam: faSmileBeam,
    faFlagCheckered: faFlagCheckered,
    faFootball: faFootball,
    faFootballBall: faFootballBall,
    faSchoolCircleExclamation: faSchoolCircleExclamation,
    faCrop: faCrop,
    faAnglesDown: faAnglesDown,
    faAngleDoubleDown: faAngleDoubleDown,
    faUsersRectangle: faUsersRectangle,
    faPeopleRoof: faPeopleRoof,
    faPeopleLine: faPeopleLine,
    faBeerMugEmpty: faBeerMugEmpty,
    faBeer: faBeer,
    faDiagramPredecessor: faDiagramPredecessor,
    faArrowUpLong: faArrowUpLong,
    faLongArrowUp: faLongArrowUp,
    faFireFlameSimple: faFireFlameSimple,
    faBurn: faBurn,
    faPerson: faPerson,
    faMale: faMale,
    faLaptop: faLaptop,
    faFileCsv: faFileCsv,
    faMenorah: faMenorah,
    faTruckPlane: faTruckPlane,
    faRecordVinyl: faRecordVinyl,
    faFaceGrinStars: faFaceGrinStars,
    faGrinStars: faGrinStars,
    faBong: faBong,
    faSpaghettiMonsterFlying: faSpaghettiMonsterFlying,
    faPastafarianism: faPastafarianism,
    faArrowDownUpAcrossLine: faArrowDownUpAcrossLine,
    faSpoon: faSpoon,
    faUtensilSpoon: faUtensilSpoon,
    faJarWheat: faJarWheat,
    faEnvelopesBulk: faEnvelopesBulk,
    faMailBulk: faMailBulk,
    faFileCircleExclamation: faFileCircleExclamation,
    faCircleH: faCircleH,
    faHospitalSymbol: faHospitalSymbol,
    faPager: faPager,
    faAddressBook: faAddressBook,
    faContactBook: faContactBook,
    faStrikethrough: faStrikethrough,
    faK: faK,
    faLandmarkFlag: faLandmarkFlag,
    faPencil: faPencil,
    faPencilAlt: faPencilAlt,
    faBackward: faBackward,
    faCaretRight: faCaretRight,
    faComments: faComments,
    faPaste: faPaste,
    faFileClipboard: faFileClipboard,
    faCodePullRequest: faCodePullRequest,
    faClipboardList: faClipboardList,
    faTruckRampBox: faTruckRampBox,
    faTruckLoading: faTruckLoading,
    faUserCheck: faUserCheck,
    faVialVirus: faVialVirus,
    faSheetPlastic: faSheetPlastic,
    faBlog: faBlog,
    faUserNinja: faUserNinja,
    faPersonArrowUpFromLine: faPersonArrowUpFromLine,
    faScrollTorah: faScrollTorah,
    faTorah: faTorah,
    faBroomBall: faBroomBall,
    faQuidditch: faQuidditch,
    faQuidditchBroomBall: faQuidditchBroomBall,
    faToggleOff: faToggleOff,
    faBoxArchive: faBoxArchive,
    faArchive: faArchive,
    faPersonDrowning: faPersonDrowning,
    faArrowDown91: faArrowDown91,
    faSortNumericDesc: faSortNumericDesc,
    faSortNumericDownAlt: faSortNumericDownAlt,
    faFaceGrinTongueSquint: faFaceGrinTongueSquint,
    faGrinTongueSquint: faGrinTongueSquint,
    faSprayCan: faSprayCan,
    faTruckMonster: faTruckMonster,
    faW: faW,
    faEarthAfrica: faEarthAfrica,
    faGlobeAfrica: faGlobeAfrica,
    faRainbow: faRainbow,
    faCircleNotch: faCircleNotch,
    faTabletScreenButton: faTabletScreenButton,
    faTabletAlt: faTabletAlt,
    faPaw: faPaw,
    faCloud: faCloud,
    faTrowelBricks: faTrowelBricks,
    faFaceFlushed: faFaceFlushed,
    faFlushed: faFlushed,
    faHospitalUser: faHospitalUser,
    faTentArrowLeftRight: faTentArrowLeftRight,
    faGavel: faGavel,
    faLegal: faLegal,
    faBinoculars: faBinoculars,
    faMicrophoneSlash: faMicrophoneSlash,
    faBoxTissue: faBoxTissue,
    faMotorcycle: faMotorcycle,
    faBellConcierge: faBellConcierge,
    faConciergeBell: faConciergeBell,
    faPenRuler: faPenRuler,
    faPencilRuler: faPencilRuler,
    faPeopleArrows: faPeopleArrows,
    faPeopleArrowsLeftRight: faPeopleArrowsLeftRight,
    faMarsAndVenusBurst: faMarsAndVenusBurst,
    faSquareCaretRight: faSquareCaretRight,
    faCaretSquareRight: faCaretSquareRight,
    faScissors: faScissors,
    faCut: faCut,
    faSunPlantWilt: faSunPlantWilt,
    faToiletsPortable: faToiletsPortable,
    faHockeyPuck: faHockeyPuck,
    faTable: faTable,
    faMagnifyingGlassArrowRight: faMagnifyingGlassArrowRight,
    faTachographDigital: faTachographDigital,
    faDigitalTachograph: faDigitalTachograph,
    faUsersSlash: faUsersSlash,
    faClover: faClover,
    faReply: faReply,
    faMailReply: faMailReply,
    faStarAndCrescent: faStarAndCrescent,
    faHouseFire: faHouseFire,
    faSquareMinus: faSquareMinus,
    faMinusSquare: faMinusSquare,
    faHelicopter: faHelicopter,
    faCompass: faCompass,
    faSquareCaretDown: faSquareCaretDown,
    faCaretSquareDown: faCaretSquareDown,
    faFileCircleQuestion: faFileCircleQuestion,
    faLaptopCode: faLaptopCode,
    faSwatchbook: faSwatchbook,
    faPrescriptionBottle: faPrescriptionBottle,
    faBars: faBars,
    faNavicon: faNavicon,
    faPeopleGroup: faPeopleGroup,
    faHourglassEnd: faHourglassEnd,
    faHourglass3: faHourglass3,
    faHeartCrack: faHeartCrack,
    faHeartBroken: faHeartBroken,
    faSquareUpRight: faSquareUpRight,
    faExternalLinkSquareAlt: faExternalLinkSquareAlt,
    faFaceKissBeam: faFaceKissBeam,
    faKissBeam: faKissBeam,
    faFilm: faFilm,
    faRulerHorizontal: faRulerHorizontal,
    faPeopleRobbery: faPeopleRobbery,
    faLightbulb: faLightbulb,
    faCaretLeft: faCaretLeft,
    faCircleExclamation: faCircleExclamation,
    faExclamationCircle: faExclamationCircle,
    faSchoolCircleXmark: faSchoolCircleXmark,
    faArrowRightFromBracket: faArrowRightFromBracket,
    faSignOut: faSignOut,
    faCircleChevronDown: faCircleChevronDown,
    faChevronCircleDown: faChevronCircleDown,
    faUnlockKeyhole: faUnlockKeyhole,
    faUnlockAlt: faUnlockAlt,
    faCloudShowersHeavy: faCloudShowersHeavy,
    faHeadphonesSimple: faHeadphonesSimple,
    faHeadphonesAlt: faHeadphonesAlt,
    faSitemap: faSitemap,
    faCircleDollarToSlot: faCircleDollarToSlot,
    faDonate: faDonate,
    faMemory: faMemory,
    faRoadSpikes: faRoadSpikes,
    faFireBurner: faFireBurner,
    faFlag: faFlag,
    faHanukiah: faHanukiah,
    faFeather: faFeather,
    faVolumeLow: faVolumeLow,
    faVolumeDown: faVolumeDown,
    faCommentSlash: faCommentSlash,
    faCloudSunRain: faCloudSunRain,
    faCompress: faCompress,
    faWheatAwn: faWheatAwn,
    faWheatAlt: faWheatAlt,
    faAnkh: faAnkh,
    faHandsHoldingChild: faHandsHoldingChild,
    faAsterisk: faAsterisk,
    faSquareCheck: faSquareCheck,
    faCheckSquare: faCheckSquare,
    faPesetaSign: faPesetaSign,
    faHeading: faHeading,
    faHeader: faHeader,
    faGhost: faGhost,
    faList: faList,
    faListSquares: faListSquares,
    faSquarePhoneFlip: faSquarePhoneFlip,
    faPhoneSquareAlt: faPhoneSquareAlt,
    faCartPlus: faCartPlus,
    faGamepad: faGamepad,
    faCircleDot: faCircleDot,
    faDotCircle: faDotCircle,
    faFaceDizzy: faFaceDizzy,
    faDizzy: faDizzy,
    faEgg: faEgg,
    faHouseMedicalCircleXmark: faHouseMedicalCircleXmark,
    faCampground: faCampground,
    faFolderPlus: faFolderPlus,
    faFutbol: faFutbol,
    faFutbolBall: faFutbolBall,
    faSoccerBall: faSoccerBall,
    faPaintbrush: faPaintbrush,
    faPaintBrush: faPaintBrush,
    faLock: faLock,
    faGasPump: faGasPump,
    faHotTubPerson: faHotTubPerson,
    faHotTub: faHotTub,
    faMapLocation: faMapLocation,
    faMapMarked: faMapMarked,
    faHouseFloodWater: faHouseFloodWater,
    faTree: faTree,
    faBridgeLock: faBridgeLock,
    faSackDollar: faSackDollar,
    faPenToSquare: faPenToSquare,
    faEdit: faEdit,
    faCarSide: faCarSide,
    faShareNodes: faShareNodes,
    faShareAlt: faShareAlt,
    faHeartCircleMinus: faHeartCircleMinus,
    faHourglassHalf: faHourglassHalf,
    faHourglass2: faHourglass2,
    faMicroscope: faMicroscope,
    faSink: faSink,
    faBagShopping: faBagShopping,
    faShoppingBag: faShoppingBag,
    faArrowDownZA: faArrowDownZA,
    faSortAlphaDesc: faSortAlphaDesc,
    faSortAlphaDownAlt: faSortAlphaDownAlt,
    faMitten: faMitten,
    faPersonRays: faPersonRays,
    faUsers: faUsers,
    faEyeSlash: faEyeSlash,
    faFlaskVial: faFlaskVial,
    faHand: faHand,
    faHandPaper: faHandPaper,
    faOm: faOm,
    faWorm: faWorm,
    faHouseCircleXmark: faHouseCircleXmark,
    faPlug: faPlug,
    faChevronUp: faChevronUp,
    faHandSpock: faHandSpock,
    faStopwatch: faStopwatch,
    faFaceKiss: faFaceKiss,
    faKiss: faKiss,
    faBridgeCircleXmark: faBridgeCircleXmark,
    faFaceGrinTongue: faFaceGrinTongue,
    faGrinTongue: faGrinTongue,
    faChessBishop: faChessBishop,
    faFaceGrinWink: faFaceGrinWink,
    faGrinWink: faGrinWink,
    faEarDeaf: faEarDeaf,
    faDeaf: faDeaf,
    faDeafness: faDeafness,
    faHardOfHearing: faHardOfHearing,
    faRoadCircleCheck: faRoadCircleCheck,
    faDiceFive: faDiceFive,
    faSquareRss: faSquareRss,
    faRssSquare: faRssSquare,
    faLandMineOn: faLandMineOn,
    faICursor: faICursor,
    faStamp: faStamp,
    faStairs: faStairs,
    faI: faI,
    faHryvniaSign: faHryvniaSign,
    faHryvnia: faHryvnia,
    faPills: faPills,
    faFaceGrinWide: faFaceGrinWide,
    faGrinAlt: faGrinAlt,
    faTooth: faTooth,
    faV: faV,
    faBangladeshiTakaSign: faBangladeshiTakaSign,
    faBicycle: faBicycle,
    faStaffSnake: faStaffSnake,
    faRodAsclepius: faRodAsclepius,
    faRodSnake: faRodSnake,
    faStaffAesculapius: faStaffAesculapius,
    faHeadSideCoughSlash: faHeadSideCoughSlash,
    faTruckMedical: faTruckMedical,
    faAmbulance: faAmbulance,
    faWheatAwnCircleExclamation: faWheatAwnCircleExclamation,
    faSnowman: faSnowman,
    faMortarPestle: faMortarPestle,
    faRoadBarrier: faRoadBarrier,
    faSchool: faSchool,
    faIgloo: faIgloo,
    faJoint: faJoint,
    faAngleRight: faAngleRight,
    faHorse: faHorse,
    faQ: faQ,
    faG: faG,
    faNotesMedical: faNotesMedical,
    faTemperatureHalf: faTemperatureHalf,
    faTemperature2: faTemperature2,
    faThermometer2: faThermometer2,
    faThermometerHalf: faThermometerHalf,
    faDongSign: faDongSign,
    faCapsules: faCapsules,
    faPooStorm: faPooStorm,
    faPooBolt: faPooBolt,
    faFaceFrownOpen: faFaceFrownOpen,
    faFrownOpen: faFrownOpen,
    faHandPointUp: faHandPointUp,
    faMoneyBill: faMoneyBill,
    faBookmark: faBookmark,
    faAlignJustify: faAlignJustify,
    faUmbrellaBeach: faUmbrellaBeach,
    faHelmetUn: faHelmetUn,
    faBullseye: faBullseye,
    faBacon: faBacon,
    faHandPointDown: faHandPointDown,
    faArrowUpFromBracket: faArrowUpFromBracket,
    faFolder: faFolder,
    faFolderBlank: faFolderBlank,
    faFileWaveform: faFileWaveform,
    faFileMedicalAlt: faFileMedicalAlt,
    faRadiation: faRadiation,
    faChartSimple: faChartSimple,
    faMarsStroke: faMarsStroke,
    faVial: faVial,
    faGauge: faGauge,
    faDashboard: faDashboard,
    faGaugeMed: faGaugeMed,
    faTachometerAltAverage: faTachometerAltAverage,
    faWandMagicSparkles: faWandMagicSparkles,
    faMagicWandSparkles: faMagicWandSparkles,
    faE: faE,
    faPenClip: faPenClip,
    faPenAlt: faPenAlt,
    faBridgeCircleExclamation: faBridgeCircleExclamation,
    faUser: faUser,
    faSchoolCircleCheck: faSchoolCircleCheck,
    faDumpster: faDumpster,
    faVanShuttle: faVanShuttle,
    faShuttleVan: faShuttleVan,
    faBuildingUser: faBuildingUser,
    faSquareCaretLeft: faSquareCaretLeft,
    faCaretSquareLeft: faCaretSquareLeft,
    faHighlighter: faHighlighter,
    faKey: faKey,
    faBullhorn: faBullhorn,
    faGlobe: faGlobe,
    faSynagogue: faSynagogue,
    faPersonHalfDress: faPersonHalfDress,
    faRoadBridge: faRoadBridge,
    faLocationArrow: faLocationArrow,
    faC: faC,
    faTabletButton: faTabletButton,
    faBuildingLock: faBuildingLock,
    faPizzaSlice: faPizzaSlice,
    faMoneyBillWave: faMoneyBillWave,
    faChartArea: faChartArea,
    faAreaChart: faAreaChart,
    faHouseFlag: faHouseFlag,
    faPersonCircleMinus: faPersonCircleMinus,
    faBan: faBan,
    faCancel: faCancel,
    faCameraRotate: faCameraRotate,
    faSprayCanSparkles: faSprayCanSparkles,
    faAirFreshener: faAirFreshener,
    faStar: faStar,
    faRepeat: faRepeat,
    faCross: faCross,
    faBox: faBox,
    faVenusMars: faVenusMars,
    faArrowPointer: faArrowPointer,
    faMousePointer: faMousePointer,
    faMaximize: faMaximize,
    faExpandArrowsAlt: faExpandArrowsAlt,
    faChargingStation: faChargingStation,
    faShapes: faShapes,
    faTriangleCircleSquare: faTriangleCircleSquare,
    faShuffle: faShuffle,
    faRandom: faRandom,
    faPersonRunning: faPersonRunning,
    faRunning: faRunning,
    faMobileRetro: faMobileRetro,
    faGripLinesVertical: faGripLinesVertical,
    faSpider: faSpider,
    faHandsBound: faHandsBound,
    faFileInvoiceDollar: faFileInvoiceDollar,
    faPlaneCircleExclamation: faPlaneCircleExclamation,
    faXRay: faXRay,
    faSpellCheck: faSpellCheck,
    faSlash: faSlash,
    faComputerMouse: faComputerMouse,
    faMouse: faMouse,
    faArrowRightToBracket: faArrowRightToBracket,
    faSignIn: faSignIn,
    faShopSlash: faShopSlash,
    faStoreAltSlash: faStoreAltSlash,
    faServer: faServer,
    faVirusCovidSlash: faVirusCovidSlash,
    faShopLock: faShopLock,
    faHourglassStart: faHourglassStart,
    faHourglass1: faHourglass1,
    faBlenderPhone: faBlenderPhone,
    faBuildingWheat: faBuildingWheat,
    faPersonBreastfeeding: faPersonBreastfeeding,
    faRightToBracket: faRightToBracket,
    faSignInAlt: faSignInAlt,
    faVenus: faVenus,
    faPassport: faPassport,
    faHeartPulse: faHeartPulse,
    faHeartbeat: faHeartbeat,
    faPeopleCarryBox: faPeopleCarryBox,
    faPeopleCarry: faPeopleCarry,
    faTemperatureHigh: faTemperatureHigh,
    faMicrochip: faMicrochip,
    faCrown: faCrown,
    faWeightHanging: faWeightHanging,
    faXmarksLines: faXmarksLines,
    faFilePrescription: faFilePrescription,
    faWeightScale: faWeightScale,
    faWeight: faWeight,
    faUserGroup: faUserGroup,
    faUserFriends: faUserFriends,
    faArrowUpAZ: faArrowUpAZ,
    faSortAlphaUp: faSortAlphaUp,
    faChessKnight: faChessKnight,
    faFaceLaughSquint: faFaceLaughSquint,
    faLaughSquint: faLaughSquint,
    faWheelchair: faWheelchair,
    faCircleArrowUp: faCircleArrowUp,
    faArrowCircleUp: faArrowCircleUp,
    faToggleOn: faToggleOn,
    faPersonWalking: faPersonWalking,
    faWalking: faWalking,
    faL: faL,
    faFire: faFire,
    faBedPulse: faBedPulse,
    faProcedures: faProcedures,
    faShuttleSpace: faShuttleSpace,
    faSpaceShuttle: faSpaceShuttle,
    faFaceLaugh: faFaceLaugh,
    faLaugh: faLaugh,
    faFolderOpen: faFolderOpen,
    faHeartCirclePlus: faHeartCirclePlus,
    faCodeFork: faCodeFork,
    faCity: faCity,
    faMicrophoneLines: faMicrophoneLines,
    faMicrophoneAlt: faMicrophoneAlt,
    faPepperHot: faPepperHot,
    faUnlock: faUnlock,
    faColonSign: faColonSign,
    faHeadset: faHeadset,
    faStoreSlash: faStoreSlash,
    faRoadCircleXmark: faRoadCircleXmark,
    faUserMinus: faUserMinus,
    faMarsStrokeUp: faMarsStrokeUp,
    faMarsStrokeV: faMarsStrokeV,
    faChampagneGlasses: faChampagneGlasses,
    faGlassCheers: faGlassCheers,
    faClipboard: faClipboard,
    faHouseCircleExclamation: faHouseCircleExclamation,
    faFileArrowUp: faFileArrowUp,
    faFileUpload: faFileUpload,
    faWifi: faWifi,
    faWifi3: faWifi3,
    faWifiStrong: faWifiStrong,
    faBath: faBath,
    faBathtub: faBathtub,
    faUnderline: faUnderline,
    faUserPen: faUserPen,
    faUserEdit: faUserEdit,
    faSignature: faSignature,
    faStroopwafel: faStroopwafel,
    faBold: faBold,
    faAnchorLock: faAnchorLock,
    faBuildingNgo: faBuildingNgo,
    faManatSign: faManatSign,
    faNotEqual: faNotEqual,
    faBorderTopLeft: faBorderTopLeft,
    faBorderStyle: faBorderStyle,
    faMapLocationDot: faMapLocationDot,
    faMapMarkedAlt: faMapMarkedAlt,
    faJedi: faJedi,
    faSquarePollVertical: faSquarePollVertical,
    faPoll: faPoll,
    faMugHot: faMugHot,
    faCarBattery: faCarBattery,
    faBatteryCar: faBatteryCar,
    faGift: faGift,
    faDiceTwo: faDiceTwo,
    faChessQueen: faChessQueen,
    faGlasses: faGlasses,
    faChessBoard: faChessBoard,
    faBuildingCircleCheck: faBuildingCircleCheck,
    faPersonChalkboard: faPersonChalkboard,
    faMarsStrokeRight: faMarsStrokeRight,
    faMarsStrokeH: faMarsStrokeH,
    faHandBackFist: faHandBackFist,
    faHandRock: faHandRock,
    faSquareCaretUp: faSquareCaretUp,
    faCaretSquareUp: faCaretSquareUp,
    faCloudShowersWater: faCloudShowersWater,
    faChartBar: faChartBar,
    faBarChart: faBarChart,
    faHandsBubbles: faHandsBubbles,
    faHandsWash: faHandsWash,
    faLessThanEqual: faLessThanEqual,
    faTrain: faTrain,
    faEyeLowVision: faEyeLowVision,
    faLowVision: faLowVision,
    faCrow: faCrow,
    faSailboat: faSailboat,
    faWindowRestore: faWindowRestore,
    faSquarePlus: faSquarePlus,
    faPlusSquare: faPlusSquare,
    faToriiGate: faToriiGate,
    faFrog: faFrog,
    faBucket: faBucket,
    faImage: faImage,
    faMicrophone: faMicrophone,
    faCow: faCow,
    faCaretUp: faCaretUp,
    faScrewdriver: faScrewdriver,
    faFolderClosed: faFolderClosed,
    faHouseTsunami: faHouseTsunami,
    faSquareNfi: faSquareNfi,
    faArrowUpFromGroundWater: faArrowUpFromGroundWater,
    faMartiniGlass: faMartiniGlass,
    faGlassMartiniAlt: faGlassMartiniAlt,
    faRotateLeft: faRotateLeft,
    faRotateBack: faRotateBack,
    faRotateBackward: faRotateBackward,
    faUndoAlt: faUndoAlt,
    faTableColumns: faTableColumns,
    faColumns: faColumns,
    faLemon: faLemon,
    faHeadSideMask: faHeadSideMask,
    faHandshake: faHandshake,
    faGem: faGem,
    faDolly: faDolly,
    faDollyBox: faDollyBox,
    faSmoking: faSmoking,
    faMinimize: faMinimize,
    faCompressArrowsAlt: faCompressArrowsAlt,
    faMonument: faMonument,
    faSnowplow: faSnowplow,
    faAnglesRight: faAnglesRight,
    faAngleDoubleRight: faAngleDoubleRight,
    faCannabis: faCannabis,
    faCirclePlay: faCirclePlay,
    faPlayCircle: faPlayCircle,
    faTablets: faTablets,
    faEthernet: faEthernet,
    faEuroSign: faEuroSign,
    faEur: faEur,
    faEuro: faEuro,
    faChair: faChair,
    faCircleCheck: faCircleCheck,
    faCheckCircle: faCheckCircle,
    faCircleStop: faCircleStop,
    faStopCircle: faStopCircle,
    faCompassDrafting: faCompassDrafting,
    faDraftingCompass: faDraftingCompass,
    faPlateWheat: faPlateWheat,
    faIcicles: faIcicles,
    faPersonShelter: faPersonShelter,
    faNeuter: faNeuter,
    faIdBadge: faIdBadge,
    faMarker: faMarker,
    faFaceLaughBeam: faFaceLaughBeam,
    faLaughBeam: faLaughBeam,
    faHelicopterSymbol: faHelicopterSymbol,
    faUniversalAccess: faUniversalAccess,
    faCircleChevronUp: faCircleChevronUp,
    faChevronCircleUp: faChevronCircleUp,
    faLariSign: faLariSign,
    faVolcano: faVolcano,
    faPersonWalkingDashedLineArrowRight: faPersonWalkingDashedLineArrowRight,
    faSterlingSign: faSterlingSign,
    faGbp: faGbp,
    faPoundSign: faPoundSign,
    faViruses: faViruses,
    faSquarePersonConfined: faSquarePersonConfined,
    faUserTie: faUserTie,
    faArrowDownLong: faArrowDownLong,
    faLongArrowDown: faLongArrowDown,
    faTentArrowDownToLine: faTentArrowDownToLine,
    faCertificate: faCertificate,
    faReplyAll: faReplyAll,
    faMailReplyAll: faMailReplyAll,
    faSuitcase: faSuitcase,
    faPersonSkating: faPersonSkating,
    faSkating: faSkating,
    faFilterCircleDollar: faFilterCircleDollar,
    faFunnelDollar: faFunnelDollar,
    faCameraRetro: faCameraRetro,
    faCircleArrowDown: faCircleArrowDown,
    faArrowCircleDown: faArrowCircleDown,
    faFileImport: faFileImport,
    faArrowRightToFile: faArrowRightToFile,
    faSquareArrowUpRight: faSquareArrowUpRight,
    faExternalLinkSquare: faExternalLinkSquare,
    faBoxOpen: faBoxOpen,
    faScroll: faScroll,
    faSpa: faSpa,
    faLocationPinLock: faLocationPinLock,
    faPause: faPause,
    faHillAvalanche: faHillAvalanche,
    faTemperatureEmpty: faTemperatureEmpty,
    faTemperature0: faTemperature0,
    faThermometer0: faThermometer0,
    faThermometerEmpty: faThermometerEmpty,
    faBomb: faBomb,
    faRegistered: faRegistered,
    faAddressCard: faAddressCard,
    faContactCard: faContactCard,
    faVcard: faVcard,
    faScaleUnbalancedFlip: faScaleUnbalancedFlip,
    faBalanceScaleRight: faBalanceScaleRight,
    faSubscript: faSubscript,
    faDiamondTurnRight: faDiamondTurnRight,
    faDirections: faDirections,
    faBurst: faBurst,
    faHouseLaptop: faHouseLaptop,
    faLaptopHouse: faLaptopHouse,
    faFaceTired: faFaceTired,
    faTired: faTired,
    faMoneyBills: faMoneyBills,
    faSmog: faSmog,
    faCrutch: faCrutch,
    faFontAwesome: faFontAwesome,
    faFontAwesomeFlag: faFontAwesomeFlag,
    faFontAwesomeLogoFull: faFontAwesomeLogoFull,
    faCloudArrowUp: faCloudArrowUp,
    faCloudUpload: faCloudUpload,
    faCloudUploadAlt: faCloudUploadAlt,
    faPalette: faPalette,
    faArrowsTurnRight: faArrowsTurnRight,
    faVest: faVest,
    faFerry: faFerry,
    faArrowsDownToPeople: faArrowsDownToPeople,
    faSeedling: faSeedling,
    faSprout: faSprout,
    faLeftRight: faLeftRight,
    faArrowsAltH: faArrowsAltH,
    faBoxesPacking: faBoxesPacking,
    faCircleArrowLeft: faCircleArrowLeft,
    faArrowCircleLeft: faArrowCircleLeft,
    faGroupArrowsRotate: faGroupArrowsRotate,
    faBowlFood: faBowlFood,
    faCandyCane: faCandyCane,
    faArrowDownWideShort: faArrowDownWideShort,
    faSortAmountAsc: faSortAmountAsc,
    faSortAmountDown: faSortAmountDown,
    faCloudBolt: faCloudBolt,
    faThunderstorm: faThunderstorm,
    faTextSlash: faTextSlash,
    faRemoveFormat: faRemoveFormat,
    faFaceSmileWink: faFaceSmileWink,
    faSmileWink: faSmileWink,
    faFileWord: faFileWord,
    faFilePowerpoint: faFilePowerpoint,
    faArrowsLeftRight: faArrowsLeftRight,
    faArrowsH: faArrowsH,
    faHouseLock: faHouseLock,
    faCloudArrowDown: faCloudArrowDown,
    faCloudDownload: faCloudDownload,
    faCloudDownloadAlt: faCloudDownloadAlt,
    faChildren: faChildren,
    faChalkboard: faChalkboard,
    faBlackboard: faBlackboard,
    faUserLargeSlash: faUserLargeSlash,
    faUserAltSlash: faUserAltSlash,
    faEnvelopeOpen: faEnvelopeOpen,
    faHandshakeSimpleSlash: faHandshakeSimpleSlash,
    faHandshakeAltSlash: faHandshakeAltSlash,
    faMattressPillow: faMattressPillow,
    faGuaraniSign: faGuaraniSign,
    faArrowsRotate: faArrowsRotate,
    faRefresh: faRefresh,
    faSync: faSync,
    faFireExtinguisher: faFireExtinguisher,
    faCruzeiroSign: faCruzeiroSign,
    faGreaterThanEqual: faGreaterThanEqual,
    faShieldHalved: faShieldHalved,
    faShieldAlt: faShieldAlt,
    faBookAtlas: faBookAtlas,
    faAtlas: faAtlas,
    faVirus: faVirus,
    faEnvelopeCircleCheck: faEnvelopeCircleCheck,
    faLayerGroup: faLayerGroup,
    faArrowsToDot: faArrowsToDot,
    faArchway: faArchway,
    faHeartCircleCheck: faHeartCircleCheck,
    faHouseChimneyCrack: faHouseChimneyCrack,
    faHouseDamage: faHouseDamage,
    faFileZipper: faFileZipper,
    faFileArchive: faFileArchive,
    faSquare: faSquare,
    faMartiniGlassEmpty: faMartiniGlassEmpty,
    faGlassMartini: faGlassMartini,
    faCouch: faCouch,
    faCediSign: faCediSign,
    faItalic: faItalic,
    faChurch: faChurch,
    faCommentsDollar: faCommentsDollar,
    faDemocrat: faDemocrat,
    faZ: faZ,
    faPersonSkiing: faPersonSkiing,
    faSkiing: faSkiing,
    faRoadLock: faRoadLock,
    faA: faA,
    faTemperatureArrowDown: faTemperatureArrowDown,
    faTemperatureDown: faTemperatureDown,
    faFeatherPointed: faFeatherPointed,
    faFeatherAlt: faFeatherAlt,
    faP: faP,
    faSnowflake: faSnowflake,
    faNewspaper: faNewspaper,
    faRectangleAd: faRectangleAd,
    faAd: faAd,
    faCircleArrowRight: faCircleArrowRight,
    faArrowCircleRight: faArrowCircleRight,
    faFilterCircleXmark: faFilterCircleXmark,
    faLocust: faLocust,
    faSort: faSort,
    faUnsorted: faUnsorted,
    faListOl: faListOl,
    faList12: faList12,
    faListNumeric: faListNumeric,
    faPersonDressBurst: faPersonDressBurst,
    faMoneyCheckDollar: faMoneyCheckDollar,
    faMoneyCheckAlt: faMoneyCheckAlt,
    faVectorSquare: faVectorSquare,
    faBreadSlice: faBreadSlice,
    faLanguage: faLanguage,
    faFaceKissWinkHeart: faFaceKissWinkHeart,
    faKissWinkHeart: faKissWinkHeart,
    faFilter: faFilter,
    faQuestion: faQuestion,
    faFileSignature: faFileSignature,
    faUpDownLeftRight: faUpDownLeftRight,
    faArrowsAlt: faArrowsAlt,
    faHouseChimneyUser: faHouseChimneyUser,
    faHandHoldingHeart: faHandHoldingHeart,
    faPuzzlePiece: faPuzzlePiece,
    faMoneyCheck: faMoneyCheck,
    faStarHalfStroke: faStarHalfStroke,
    faStarHalfAlt: faStarHalfAlt,
    faCode: faCode,
    faWhiskeyGlass: faWhiskeyGlass,
    faGlassWhiskey: faGlassWhiskey,
    faBuildingCircleExclamation: faBuildingCircleExclamation,
    faMagnifyingGlassChart: faMagnifyingGlassChart,
    faArrowUpRightFromSquare: faArrowUpRightFromSquare,
    faExternalLink: faExternalLink,
    faCubesStacked: faCubesStacked,
    faWonSign: faWonSign,
    faKrw: faKrw,
    faWon: faWon,
    faVirusCovid: faVirusCovid,
    faAustralSign: faAustralSign,
    faF: faF,
    faLeaf: faLeaf,
    faRoad: faRoad,
    faTaxi: faTaxi,
    faCab: faCab,
    faPersonCirclePlus: faPersonCirclePlus,
    faChartPie: faChartPie,
    faPieChart: faPieChart,
    faBoltLightning: faBoltLightning,
    faSackXmark: faSackXmark,
    faFileExcel: faFileExcel,
    faFileContract: faFileContract,
    faFishFins: faFishFins,
    faBuildingFlag: faBuildingFlag,
    faFaceGrinBeam: faFaceGrinBeam,
    faGrinBeam: faGrinBeam,
    faObjectUngroup: faObjectUngroup,
    faPoop: faPoop,
    faLocationPin: faLocationPin,
    faMapMarker: faMapMarker,
    faKaaba: faKaaba,
    faToiletPaper: faToiletPaper,
    faHelmetSafety: faHelmetSafety,
    faHardHat: faHardHat,
    faHatHard: faHatHard,
    faEject: faEject,
    faCircleRight: faCircleRight,
    faArrowAltCircleRight: faArrowAltCircleRight,
    faPlaneCircleCheck: faPlaneCircleCheck,
    faFaceRollingEyes: faFaceRollingEyes,
    faMehRollingEyes: faMehRollingEyes,
    faObjectGroup: faObjectGroup,
    faChartLine: faChartLine,
    faLineChart: faLineChart,
    faMaskVentilator: faMaskVentilator,
    faArrowRight: faArrowRight,
    faSignsPost: faSignsPost,
    faMapSigns: faMapSigns,
    faCashRegister: faCashRegister,
    faPersonCircleQuestion: faPersonCircleQuestion,
    faH: faH,
    faTarp: faTarp,
    faScrewdriverWrench: faScrewdriverWrench,
    faTools: faTools,
    faArrowsToEye: faArrowsToEye,
    faPlugCircleBolt: faPlugCircleBolt,
    faHeart: faHeart,
    faMarsAndVenus: faMarsAndVenus,
    faHouseUser: faHouseUser,
    faHomeUser: faHomeUser,
    faDumpsterFire: faDumpsterFire,
    faHouseCrack: faHouseCrack,
    faMartiniGlassCitrus: faMartiniGlassCitrus,
    faCocktail: faCocktail,
    faFaceSurprise: faFaceSurprise,
    faSurprise: faSurprise,
    faBottleWater: faBottleWater,
    faCirclePause: faCirclePause,
    faPauseCircle: faPauseCircle,
    faToiletPaperSlash: faToiletPaperSlash,
    faAppleWhole: faAppleWhole,
    faAppleAlt: faAppleAlt,
    faKitchenSet: faKitchenSet,
    faR: faR,
    faTemperatureQuarter: faTemperatureQuarter,
    faTemperature1: faTemperature1,
    faThermometer1: faThermometer1,
    faThermometerQuarter: faThermometerQuarter,
    faCube: faCube,
    faBitcoinSign: faBitcoinSign,
    faShieldDog: faShieldDog,
    faSolarPanel: faSolarPanel,
    faLockOpen: faLockOpen,
    faElevator: faElevator,
    faMoneyBillTransfer: faMoneyBillTransfer,
    faMoneyBillTrendUp: faMoneyBillTrendUp,
    faHouseFloodWaterCircleArrowRight: faHouseFloodWaterCircleArrowRight,
    faSquarePollHorizontal: faSquarePollHorizontal,
    faPollH: faPollH,
    faCircle: faCircle,
    faBackwardFast: faBackwardFast,
    faFastBackward: faFastBackward,
    faRecycle: faRecycle,
    faUserAstronaut: faUserAstronaut,
    faPlaneSlash: faPlaneSlash,
    faTrademark: faTrademark,
    faBasketball: faBasketball,
    faBasketballBall: faBasketballBall,
    faSatelliteDish: faSatelliteDish,
    faCircleUp: faCircleUp,
    faArrowAltCircleUp: faArrowAltCircleUp,
    faMobileScreenButton: faMobileScreenButton,
    faMobileAlt: faMobileAlt,
    faVolumeHigh: faVolumeHigh,
    faVolumeUp: faVolumeUp,
    faUsersRays: faUsersRays,
    faWallet: faWallet,
    faClipboardCheck: faClipboardCheck,
    faFileAudio: faFileAudio,
    faBurger: faBurger,
    faHamburger: faHamburger,
    faWrench: faWrench,
    faBugs: faBugs,
    faRupeeSign: faRupeeSign,
    faRupee: faRupee,
    faFileImage: faFileImage,
    faCircleQuestion: faCircleQuestion,
    faQuestionCircle: faQuestionCircle,
    faPlaneDeparture: faPlaneDeparture,
    faHandshakeSlash: faHandshakeSlash,
    faBookBookmark: faBookBookmark,
    faCodeBranch: faCodeBranch,
    faHatCowboy: faHatCowboy,
    faBridge: faBridge,
    faPhoneFlip: faPhoneFlip,
    faPhoneAlt: faPhoneAlt,
    faTruckFront: faTruckFront,
    faCat: faCat,
    faAnchorCircleExclamation: faAnchorCircleExclamation,
    faTruckField: faTruckField,
    faRoute: faRoute,
    faClipboardQuestion: faClipboardQuestion,
    faPanorama: faPanorama,
    faCommentMedical: faCommentMedical,
    faTeethOpen: faTeethOpen,
    faFileCircleMinus: faFileCircleMinus,
    faTags: faTags,
    faWineGlass: faWineGlass,
    faForwardFast: faForwardFast,
    faFastForward: faFastForward,
    faFaceMehBlank: faFaceMehBlank,
    faMehBlank: faMehBlank,
    faSquareParking: faSquareParking,
    faParking: faParking,
    faHouseSignal: faHouseSignal,
    faBarsProgress: faBarsProgress,
    faTasksAlt: faTasksAlt,
    faFaucetDrip: faFaucetDrip,
    faCartFlatbed: faCartFlatbed,
    faDollyFlatbed: faDollyFlatbed,
    faBanSmoking: faBanSmoking,
    faSmokingBan: faSmokingBan,
    faTerminal: faTerminal,
    faMobileButton: faMobileButton,
    faHouseMedicalFlag: faHouseMedicalFlag,
    faBasketShopping: faBasketShopping,
    faShoppingBasket: faShoppingBasket,
    faTape: faTape,
    faBusSimple: faBusSimple,
    faBusAlt: faBusAlt,
    faEye: faEye,
    faFaceSadCry: faFaceSadCry,
    faSadCry: faSadCry,
    faAudioDescription: faAudioDescription,
    faPersonMilitaryToPerson: faPersonMilitaryToPerson,
    faFileShield: faFileShield,
    faUserSlash: faUserSlash,
    faPen: faPen,
    faTowerObservation: faTowerObservation,
    faFileCode: faFileCode,
    faSignal: faSignal,
    faSignal5: faSignal5,
    faSignalPerfect: faSignalPerfect,
    faBus: faBus,
    faHeartCircleXmark: faHeartCircleXmark,
    faHouseChimney: faHouseChimney,
    faHomeLg: faHomeLg,
    faWindowMaximize: faWindowMaximize,
    faFaceFrown: faFaceFrown,
    faFrown: faFrown,
    faPrescription: faPrescription,
    faShop: faShop,
    faStoreAlt: faStoreAlt,
    faFloppyDisk: faFloppyDisk,
    faSave: faSave,
    faVihara: faVihara,
    faScaleUnbalanced: faScaleUnbalanced,
    faBalanceScaleLeft: faBalanceScaleLeft,
    faSortUp: faSortUp,
    faSortAsc: faSortAsc,
    faCommentDots: faCommentDots,
    faCommenting: faCommenting,
    faPlantWilt: faPlantWilt,
    faDiamond: faDiamond,
    faFaceGrinSquint: faFaceGrinSquint,
    faGrinSquint: faGrinSquint,
    faHandHoldingDollar: faHandHoldingDollar,
    faHandHoldingUsd: faHandHoldingUsd,
    faBacterium: faBacterium,
    faHandPointer: faHandPointer,
    faDrumSteelpan: faDrumSteelpan,
    faHandScissors: faHandScissors,
    faHandsPraying: faHandsPraying,
    faPrayingHands: faPrayingHands,
    faArrowRotateRight: faArrowRotateRight,
    faArrowRightRotate: faArrowRightRotate,
    faArrowRotateForward: faArrowRotateForward,
    faRedo: faRedo,
    faBiohazard: faBiohazard,
    faLocationCrosshairs: faLocationCrosshairs,
    faLocation: faLocation,
    faMarsDouble: faMarsDouble,
    faChildDress: faChildDress,
    faUsersBetweenLines: faUsersBetweenLines,
    faLungsVirus: faLungsVirus,
    faFaceGrinTears: faFaceGrinTears,
    faGrinTears: faGrinTears,
    faPhone: faPhone,
    faCalendarXmark: faCalendarXmark,
    faCalendarTimes: faCalendarTimes,
    faChildReaching: faChildReaching,
    faHeadSideVirus: faHeadSideVirus,
    faUserGear: faUserGear,
    faUserCog: faUserCog,
    faArrowUp19: faArrowUp19,
    faSortNumericUp: faSortNumericUp,
    faDoorClosed: faDoorClosed,
    faShieldVirus: faShieldVirus,
    faDiceSix: faDiceSix,
    faMosquitoNet: faMosquitoNet,
    faBridgeWater: faBridgeWater,
    faPersonBooth: faPersonBooth,
    faTextWidth: faTextWidth,
    faHatWizard: faHatWizard,
    faPenFancy: faPenFancy,
    faPersonDigging: faPersonDigging,
    faDigging: faDigging,
    faTrash: faTrash,
    faGaugeSimple: faGaugeSimple,
    faGaugeSimpleMed: faGaugeSimpleMed,
    faTachometerAverage: faTachometerAverage,
    faBookMedical: faBookMedical,
    faPoo: faPoo,
    faQuoteRight: faQuoteRight,
    faQuoteRightAlt: faQuoteRightAlt,
    faShirt: faShirt,
    faTShirt: faTShirt,
    faTshirt: faTshirt,
    faCubes: faCubes,
    faDivide: faDivide,
    faTengeSign: faTengeSign,
    faTenge: faTenge,
    faHeadphones: faHeadphones,
    faHandsHolding: faHandsHolding,
    faHandsClapping: faHandsClapping,
    faRepublican: faRepublican,
    faArrowLeft: faArrowLeft,
    faPersonCircleXmark: faPersonCircleXmark,
    faRuler: faRuler,
    faAlignLeft: faAlignLeft,
    faDiceD6: faDiceD6,
    faRestroom: faRestroom,
    faJ: faJ,
    faUsersViewfinder: faUsersViewfinder,
    faFileVideo: faFileVideo,
    faUpRightFromSquare: faUpRightFromSquare,
    faExternalLinkAlt: faExternalLinkAlt,
    faTableCells: faTableCells,
    faTh: faTh,
    faFilePdf: faFilePdf,
    faBookBible: faBookBible,
    faBible: faBible,
    faO: faO,
    faSuitcaseMedical: faSuitcaseMedical,
    faMedkit: faMedkit,
    faUserSecret: faUserSecret,
    faOtter: faOtter,
    faPersonDress: faPersonDress,
    faFemale: faFemale,
    faCommentDollar: faCommentDollar,
    faBusinessTime: faBusinessTime,
    faBriefcaseClock: faBriefcaseClock,
    faTableCellsLarge: faTableCellsLarge,
    faThLarge: faThLarge,
    faBookTanakh: faBookTanakh,
    faTanakh: faTanakh,
    faPhoneVolume: faPhoneVolume,
    faVolumeControlPhone: faVolumeControlPhone,
    faHatCowboySide: faHatCowboySide,
    faClipboardUser: faClipboardUser,
    faChild: faChild,
    faLiraSign: faLiraSign,
    faSatellite: faSatellite,
    faPlaneLock: faPlaneLock,
    faTag: faTag,
    faComment: faComment,
    faCakeCandles: faCakeCandles,
    faBirthdayCake: faBirthdayCake,
    faCake: faCake,
    faEnvelope: faEnvelope,
    faAnglesUp: faAnglesUp,
    faAngleDoubleUp: faAngleDoubleUp,
    faPaperclip: faPaperclip,
    faArrowRightToCity: faArrowRightToCity,
    faRibbon: faRibbon,
    faLungs: faLungs,
    faArrowUp91: faArrowUp91,
    faSortNumericUpAlt: faSortNumericUpAlt,
    faLitecoinSign: faLitecoinSign,
    faBorderNone: faBorderNone,
    faCircleNodes: faCircleNodes,
    faParachuteBox: faParachuteBox,
    faIndent: faIndent,
    faTruckFieldUn: faTruckFieldUn,
    faHourglass: faHourglass,
    faHourglassEmpty: faHourglassEmpty,
    faMountain: faMountain,
    faUserDoctor: faUserDoctor,
    faUserMd: faUserMd,
    faCircleInfo: faCircleInfo,
    faInfoCircle: faInfoCircle,
    faCloudMeatball: faCloudMeatball,
    faCamera: faCamera,
    faCameraAlt: faCameraAlt,
    faSquareVirus: faSquareVirus,
    faMeteor: faMeteor,
    faCarOn: faCarOn,
    faSleigh: faSleigh,
    faArrowDown19: faArrowDown19,
    faSortNumericAsc: faSortNumericAsc,
    faSortNumericDown: faSortNumericDown,
    faHandHoldingDroplet: faHandHoldingDroplet,
    faHandHoldingWater: faHandHoldingWater,
    faWater: faWater,
    faCalendarCheck: faCalendarCheck,
    faBraille: faBraille,
    faPrescriptionBottleMedical: faPrescriptionBottleMedical,
    faPrescriptionBottleAlt: faPrescriptionBottleAlt,
    faLandmark: faLandmark,
    faTruck: faTruck,
    faCrosshairs: faCrosshairs,
    faPersonCane: faPersonCane,
    faTent: faTent,
    faVestPatches: faVestPatches,
    faCheckDouble: faCheckDouble,
    faArrowDownAZ: faArrowDownAZ,
    faSortAlphaAsc: faSortAlphaAsc,
    faSortAlphaDown: faSortAlphaDown,
    faMoneyBillWheat: faMoneyBillWheat,
    faCookie: faCookie,
    faArrowRotateLeft: faArrowRotateLeft,
    faArrowLeftRotate: faArrowLeftRotate,
    faArrowRotateBack: faArrowRotateBack,
    faArrowRotateBackward: faArrowRotateBackward,
    faUndo: faUndo,
    faHardDrive: faHardDrive,
    faHdd: faHdd,
    faFaceGrinSquintTears: faFaceGrinSquintTears,
    faGrinSquintTears: faGrinSquintTears,
    faDumbbell: faDumbbell,
    faRectangleList: faRectangleList,
    faListAlt: faListAlt,
    faTarpDroplet: faTarpDroplet,
    faHouseMedicalCircleCheck: faHouseMedicalCircleCheck,
    faPersonSkiingNordic: faPersonSkiingNordic,
    faSkiingNordic: faSkiingNordic,
    faCalendarPlus: faCalendarPlus,
    faPlaneArrival: faPlaneArrival,
    faCircleLeft: faCircleLeft,
    faArrowAltCircleLeft: faArrowAltCircleLeft,
    faTrainSubway: faTrainSubway,
    faSubway: faSubway,
    faChartGantt: faChartGantt,
    faIndianRupeeSign: faIndianRupeeSign,
    faIndianRupee: faIndianRupee,
    faInr: faInr,
    faCropSimple: faCropSimple,
    faCropAlt: faCropAlt,
    faMoneyBill1: faMoneyBill1,
    faMoneyBillAlt: faMoneyBillAlt,
    faLeftLong: faLeftLong,
    faLongArrowAltLeft: faLongArrowAltLeft,
    faDna: faDna,
    faVirusSlash: faVirusSlash,
    faMinus: faMinus,
    faSubtract: faSubtract,
    faChess: faChess,
    faArrowLeftLong: faArrowLeftLong,
    faLongArrowLeft: faLongArrowLeft,
    faPlugCircleCheck: faPlugCircleCheck,
    faStreetView: faStreetView,
    faFrancSign: faFrancSign,
    faVolumeOff: faVolumeOff,
    faHandsAslInterpreting: faHandsAslInterpreting,
    faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
    faAslInterpreting: faAslInterpreting,
    faHandsAmericanSignLanguageInterpreting: faHandsAmericanSignLanguageInterpreting,
    faGear: faGear,
    faCog: faCog,
    faDropletSlash: faDropletSlash,
    faTintSlash: faTintSlash,
    faMosque: faMosque,
    faMosquito: faMosquito,
    faStarOfDavid: faStarOfDavid,
    faPersonMilitaryRifle: faPersonMilitaryRifle,
    faCartShopping: faCartShopping,
    faShoppingCart: faShoppingCart,
    faVials: faVials,
    faPlugCirclePlus: faPlugCirclePlus,
    faPlaceOfWorship: faPlaceOfWorship,
    faGripVertical: faGripVertical,
    faArrowTurnUp: faArrowTurnUp,
    faLevelUp: faLevelUp,
    faU: faU,
    faSquareRootVariable: faSquareRootVariable,
    faSquareRootAlt: faSquareRootAlt,
    faClock: faClock,
    faClockFour: faClockFour,
    faBackwardStep: faBackwardStep,
    faStepBackward: faStepBackward,
    faPallet: faPallet,
    faFaucet: faFaucet,
    faBaseballBatBall: faBaseballBatBall,
    faS: faS,
    faTimeline: faTimeline,
    faKeyboard: faKeyboard,
    faCaretDown: faCaretDown,
    faHouseChimneyMedical: faHouseChimneyMedical,
    faClinicMedical: faClinicMedical,
    faTemperatureThreeQuarters: faTemperatureThreeQuarters,
    faTemperature3: faTemperature3,
    faThermometer3: faThermometer3,
    faThermometerThreeQuarters: faThermometerThreeQuarters,
    faMobileScreen: faMobileScreen,
    faMobileAndroidAlt: faMobileAndroidAlt,
    faPlaneUp: faPlaneUp,
    faPiggyBank: faPiggyBank,
    faBatteryHalf: faBatteryHalf,
    faBattery3: faBattery3,
    faMountainCity: faMountainCity,
    faCoins: faCoins,
    faKhanda: faKhanda,
    faSliders: faSliders,
    faSlidersH: faSlidersH,
    faFolderTree: faFolderTree,
    faNetworkWired: faNetworkWired,
    faMapPin: faMapPin,
    faHamsa: faHamsa,
    faCentSign: faCentSign,
    faFlask: faFlask,
    faPersonPregnant: faPersonPregnant,
    faWandSparkles: faWandSparkles,
    faEllipsisVertical: faEllipsisVertical,
    faEllipsisV: faEllipsisV,
    faTicket: faTicket,
    faPowerOff: faPowerOff,
    faRightLong: faRightLong,
    faLongArrowAltRight: faLongArrowAltRight,
    faFlagUsa: faFlagUsa,
    faLaptopFile: faLaptopFile,
    faTty: faTty,
    faTeletype: faTeletype,
    faDiagramNext: faDiagramNext,
    faPersonRifle: faPersonRifle,
    faHouseMedicalCircleExclamation: faHouseMedicalCircleExclamation,
    faClosedCaptioning: faClosedCaptioning,
    faPersonHiking: faPersonHiking,
    faHiking: faHiking,
    faVenusDouble: faVenusDouble,
    faImages: faImages,
    faCalculator: faCalculator,
    faPeoplePulling: faPeoplePulling,
    faN: faN,
    faCableCar: faCableCar,
    faTram: faTram,
    faCloudRain: faCloudRain,
    faBuildingCircleXmark: faBuildingCircleXmark,
    faShip: faShip,
    faArrowsDownToLine: faArrowsDownToLine,
    faDownload: faDownload,
    faFaceGrin: faFaceGrin,
    faGrin: faGrin,
    faDeleteLeft: faDeleteLeft,
    faBackspace: faBackspace,
    faEyeDropper: faEyeDropper,
    faEyeDropperEmpty: faEyeDropperEmpty,
    faEyedropper: faEyedropper,
    faFileCircleCheck: faFileCircleCheck,
    faForward: faForward,
    faMobile: faMobile,
    faMobileAndroid: faMobileAndroid,
    faMobilePhone: faMobilePhone,
    faFaceMeh: faFaceMeh,
    faMeh: faMeh,
    faAlignCenter: faAlignCenter,
    faBookSkull: faBookSkull,
    faBookDead: faBookDead,
    faIdCard: faIdCard,
    faDriversLicense: faDriversLicense,
    faOutdent: faOutdent,
    faDedent: faDedent,
    faHeartCircleExclamation: faHeartCircleExclamation,
    faHouse: faHouse,
    faHome: faHome,
    faHomeAlt: faHomeAlt,
    faHomeLgAlt: faHomeLgAlt,
    faCalendarWeek: faCalendarWeek,
    faLaptopMedical: faLaptopMedical,
    faB: faB,
    faFileMedical: faFileMedical,
    faDiceOne: faDiceOne,
    faKiwiBird: faKiwiBird,
    faArrowRightArrowLeft: faArrowRightArrowLeft,
    faExchange: faExchange,
    faRotateRight: faRotateRight,
    faRedoAlt: faRedoAlt,
    faRotateForward: faRotateForward,
    faUtensils: faUtensils,
    faCutlery: faCutlery,
    faArrowUpWideShort: faArrowUpWideShort,
    faSortAmountUp: faSortAmountUp,
    faMillSign: faMillSign,
    faBowlRice: faBowlRice,
    faSkull: faSkull,
    faTowerBroadcast: faTowerBroadcast,
    faBroadcastTower: faBroadcastTower,
    faTruckPickup: faTruckPickup,
    faUpLong: faUpLong,
    faLongArrowAltUp: faLongArrowAltUp,
    faStop: faStop,
    faCodeMerge: faCodeMerge,
    faUpload: faUpload,
    faHurricane: faHurricane,
    faMound: faMound,
    faToiletPortable: faToiletPortable,
    faCompactDisc: faCompactDisc,
    faFileArrowDown: faFileArrowDown,
    faFileDownload: faFileDownload,
    faCaravan: faCaravan,
    faShieldCat: faShieldCat,
    faBolt: faBolt,
    faZap: faZap,
    faGlassWater: faGlassWater,
    faOilWell: faOilWell,
    faVault: faVault,
    faMars: faMars,
    faToilet: faToilet,
    faPlaneCircleXmark: faPlaneCircleXmark,
    faYenSign: faYenSign,
    faCny: faCny,
    faJpy: faJpy,
    faRmb: faRmb,
    faYen: faYen,
    faRubleSign: faRubleSign,
    faRouble: faRouble,
    faRub: faRub,
    faRuble: faRuble,
    faSun: faSun,
    faGuitar: faGuitar,
    faFaceLaughWink: faFaceLaughWink,
    faLaughWink: faLaughWink,
    faHorseHead: faHorseHead,
    faBoreHole: faBoreHole,
    faIndustry: faIndustry,
    faCircleDown: faCircleDown,
    faArrowAltCircleDown: faArrowAltCircleDown,
    faArrowsTurnToDots: faArrowsTurnToDots,
    faFlorinSign: faFlorinSign,
    faArrowDownShortWide: faArrowDownShortWide,
    faSortAmountDesc: faSortAmountDesc,
    faSortAmountDownAlt: faSortAmountDownAlt,
    faLessThan: faLessThan,
    faAngleDown: faAngleDown,
    faCarTunnel: faCarTunnel,
    faHeadSideCough: faHeadSideCough,
    faGripLines: faGripLines,
    faThumbsDown: faThumbsDown,
    faUserLock: faUserLock,
    faArrowRightLong: faArrowRightLong,
    faLongArrowRight: faLongArrowRight,
    faAnchorCircleXmark: faAnchorCircleXmark,
    faEllipsis: faEllipsis,
    faEllipsisH: faEllipsisH,
    faChessPawn: faChessPawn,
    faKitMedical: faKitMedical,
    faFirstAid: faFirstAid,
    faPersonThroughWindow: faPersonThroughWindow,
    faToolbox: faToolbox,
    faHandsHoldingCircle: faHandsHoldingCircle,
    faBug: faBug,
    faCreditCard: faCreditCard,
    faCreditCardAlt: faCreditCardAlt,
    faCar: faCar,
    faAutomobile: faAutomobile,
    faHandHoldingHand: faHandHoldingHand,
    faBookOpenReader: faBookOpenReader,
    faBookReader: faBookReader,
    faMountainSun: faMountainSun,
    faArrowsLeftRightToLine: faArrowsLeftRightToLine,
    faDiceD20: faDiceD20,
    faTruckDroplet: faTruckDroplet,
    faFileCircleXmark: faFileCircleXmark,
    faTemperatureArrowUp: faTemperatureArrowUp,
    faTemperatureUp: faTemperatureUp,
    faMedal: faMedal,
    faBed: faBed,
    faSquareH: faSquareH,
    faHSquare: faHSquare,
    faPodcast: faPodcast,
    faTemperatureFull: faTemperatureFull,
    faTemperature4: faTemperature4,
    faThermometer4: faThermometer4,
    faThermometerFull: faThermometerFull,
    faBell: faBell,
    faSuperscript: faSuperscript,
    faPlugCircleXmark: faPlugCircleXmark,
    faStarOfLife: faStarOfLife,
    faPhoneSlash: faPhoneSlash,
    faPaintRoller: faPaintRoller,
    faHandshakeAngle: faHandshakeAngle,
    faHandsHelping: faHandsHelping,
    faLocationDot: faLocationDot,
    faMapMarkerAlt: faMapMarkerAlt,
    faFile: faFile,
    faGreaterThan: faGreaterThan,
    faPersonSwimming: faPersonSwimming,
    faSwimmer: faSwimmer,
    faArrowDown: faArrowDown,
    faDroplet: faDroplet,
    faTint: faTint,
    faEraser: faEraser,
    faEarthAmericas: faEarthAmericas,
    faEarth: faEarth,
    faEarthAmerica: faEarthAmerica,
    faGlobeAmericas: faGlobeAmericas,
    faPersonBurst: faPersonBurst,
    faDove: faDove,
    faBatteryEmpty: faBatteryEmpty,
    faBattery0: faBattery0,
    faSocks: faSocks,
    faInbox: faInbox,
    faSection: faSection,
    faGaugeHigh: faGaugeHigh,
    faTachometerAlt: faTachometerAlt,
    faTachometerAltFast: faTachometerAltFast,
    faEnvelopeOpenText: faEnvelopeOpenText,
    faHospital: faHospital,
    faHospitalAlt: faHospitalAlt,
    faHospitalWide: faHospitalWide,
    faWineBottle: faWineBottle,
    faChessRook: faChessRook,
    faBarsStaggered: faBarsStaggered,
    faReorder: faReorder,
    faStream: faStream,
    faDharmachakra: faDharmachakra,
    faHotdog: faHotdog,
    faPersonWalkingWithCane: faPersonWalkingWithCane,
    faBlind: faBlind,
    faDrum: faDrum,
    faIceCream: faIceCream,
    faHeartCircleBolt: faHeartCircleBolt,
    faFax: faFax,
    faParagraph: faParagraph,
    faCheckToSlot: faCheckToSlot,
    faVoteYea: faVoteYea,
    faStarHalf: faStarHalf,
    faBoxesStacked: faBoxesStacked,
    faBoxes: faBoxes,
    faBoxesAlt: faBoxesAlt,
    faLink: faLink,
    faChain: faChain,
    faEarListen: faEarListen,
    faAssistiveListeningSystems: faAssistiveListeningSystems,
    faTreeCity: faTreeCity,
    faPlay: faPlay,
    faFont: faFont,
    faRupiahSign: faRupiahSign,
    faMagnifyingGlass: faMagnifyingGlass,
    faSearch: faSearch,
    faTableTennisPaddleBall: faTableTennisPaddleBall,
    faPingPongPaddleBall: faPingPongPaddleBall,
    faTableTennis: faTableTennis,
    faPersonDotsFromLine: faPersonDotsFromLine,
    faDiagnoses: faDiagnoses,
    faTrashCanArrowUp: faTrashCanArrowUp,
    faTrashRestoreAlt: faTrashRestoreAlt,
    faNairaSign: faNairaSign,
    faCartArrowDown: faCartArrowDown,
    faWalkieTalkie: faWalkieTalkie,
    faFilePen: faFilePen,
    faFileEdit: faFileEdit,
    faReceipt: faReceipt,
    faSquarePen: faSquarePen,
    faPenSquare: faPenSquare,
    faPencilSquare: faPencilSquare,
    faSuitcaseRolling: faSuitcaseRolling,
    faPersonCircleExclamation: faPersonCircleExclamation,
    faChevronDown: faChevronDown,
    faBatteryFull: faBatteryFull,
    faBattery: faBattery,
    faBattery5: faBattery5,
    faSkullCrossbones: faSkullCrossbones,
    faCodeCompare: faCodeCompare,
    faListUl: faListUl,
    faListDots: faListDots,
    faSchoolLock: faSchoolLock,
    faTowerCell: faTowerCell,
    faDownLong: faDownLong,
    faLongArrowAltDown: faLongArrowAltDown,
    faRankingStar: faRankingStar,
    faChessKing: faChessKing,
    faPersonHarassing: faPersonHarassing,
    faBrazilianRealSign: faBrazilianRealSign,
    faLandmarkDome: faLandmarkDome,
    faLandmarkAlt: faLandmarkAlt,
    faArrowUp: faArrowUp,
    faTv: faTv,
    faTelevision: faTelevision,
    faTvAlt: faTvAlt,
    faShrimp: faShrimp,
    faListCheck: faListCheck,
    faTasks: faTasks,
    faJugDetergent: faJugDetergent,
    faCircleUser: faCircleUser,
    faUserCircle: faUserCircle,
    faUserShield: faUserShield,
    faWind: faWind,
    faCarBurst: faCarBurst,
    faCarCrash: faCarCrash,
    faY: faY,
    faPersonSnowboarding: faPersonSnowboarding,
    faSnowboarding: faSnowboarding,
    faTruckFast: faTruckFast,
    faShippingFast: faShippingFast,
    faFish: faFish,
    faUserGraduate: faUserGraduate,
    faCircleHalfStroke: faCircleHalfStroke,
    faAdjust: faAdjust,
    faClapperboard: faClapperboard,
    faCircleRadiation: faCircleRadiation,
    faRadiationAlt: faRadiationAlt,
    faBaseball: faBaseball,
    faBaseballBall: faBaseballBall,
    faJetFighterUp: faJetFighterUp,
    faDiagramProject: faDiagramProject,
    faProjectDiagram: faProjectDiagram,
    faCopy: faCopy,
    faVolumeXmark: faVolumeXmark,
    faVolumeMute: faVolumeMute,
    faVolumeTimes: faVolumeTimes,
    faHandSparkles: faHandSparkles,
    faGrip: faGrip,
    faGripHorizontal: faGripHorizontal,
    faShareFromSquare: faShareFromSquare,
    faShareSquare: faShareSquare,
    faChildCombatant: faChildCombatant,
    faChildRifle: faChildRifle,
    faGun: faGun,
    faSquarePhone: faSquarePhone,
    faPhoneSquare: faPhoneSquare,
    faPlus: faPlus,
    faAdd: faAdd,
    faExpand: faExpand,
    faComputer: faComputer,
    faXmark: faXmark,
    faClose: faClose,
    faMultiply: faMultiply,
    faRemove: faRemove,
    faTimes: faTimes,
    faArrowsUpDownLeftRight: faArrowsUpDownLeftRight,
    faArrows: faArrows,
    faChalkboardUser: faChalkboardUser,
    faChalkboardTeacher: faChalkboardTeacher,
    faPesoSign: faPesoSign,
    faBuildingShield: faBuildingShield,
    faBaby: faBaby,
    faUsersLine: faUsersLine,
    faQuoteLeft: faQuoteLeft,
    faQuoteLeftAlt: faQuoteLeftAlt,
    faTractor: faTractor,
    faTrashArrowUp: faTrashArrowUp,
    faTrashRestore: faTrashRestore,
    faArrowDownUpLock: faArrowDownUpLock,
    faLinesLeaning: faLinesLeaning,
    faRulerCombined: faRulerCombined,
    faCopyright: faCopyright,
    faEquals: faEquals,
    faBlender: faBlender,
    faTeeth: faTeeth,
    faShekelSign: faShekelSign,
    faIls: faIls,
    faShekel: faShekel,
    faSheqel: faSheqel,
    faSheqelSign: faSheqelSign,
    faMap: faMap,
    faRocket: faRocket,
    faPhotoFilm: faPhotoFilm,
    faPhotoVideo: faPhotoVideo,
    faFolderMinus: faFolderMinus,
    faStore: faStore,
    faArrowTrendUp: faArrowTrendUp,
    faPlugCircleMinus: faPlugCircleMinus,
    faSignHanging: faSignHanging,
    faSign: faSign,
    faBezierCurve: faBezierCurve,
    faBellSlash: faBellSlash,
    faTablet: faTablet,
    faTabletAndroid: faTabletAndroid,
    faSchoolFlag: faSchoolFlag,
    faFill: faFill,
    faAngleUp: faAngleUp,
    faDrumstickBite: faDrumstickBite,
    faHollyBerry: faHollyBerry,
    faChevronLeft: faChevronLeft,
    faBacteria: faBacteria,
    faHandLizard: faHandLizard,
    faNotdef: faNotdef,
    faDisease: faDisease,
    faBriefcaseMedical: faBriefcaseMedical,
    faGenderless: faGenderless,
    faChevronRight: faChevronRight,
    faRetweet: faRetweet,
    faCarRear: faCarRear,
    faCarAlt: faCarAlt,
    faPumpSoap: faPumpSoap,
    faVideoSlash: faVideoSlash,
    faBatteryQuarter: faBatteryQuarter,
    faBattery2: faBattery2,
    faRadio: faRadio,
    faBabyCarriage: faBabyCarriage,
    faCarriageBaby: faCarriageBaby,
    faTrafficLight: faTrafficLight,
    faThermometer: faThermometer,
    faVrCardboard: faVrCardboard,
    faHandMiddleFinger: faHandMiddleFinger,
    faPercent: faPercent,
    faPercentage: faPercentage,
    faTruckMoving: faTruckMoving,
    faGlassWaterDroplet: faGlassWaterDroplet,
    faDisplay: faDisplay,
    faFaceSmile: faFaceSmile,
    faSmile: faSmile,
    faThumbtack: faThumbtack,
    faThumbTack: faThumbTack,
    faTrophy: faTrophy,
    faPersonPraying: faPersonPraying,
    faPray: faPray,
    faHammer: faHammer,
    faHandPeace: faHandPeace,
    faRotate: faRotate,
    faSyncAlt: faSyncAlt,
    faSpinner: faSpinner,
    faRobot: faRobot,
    faPeace: faPeace,
    faGears: faGears,
    faCogs: faCogs,
    faWarehouse: faWarehouse,
    faArrowUpRightDots: faArrowUpRightDots,
    faSplotch: faSplotch,
    faFaceGrinHearts: faFaceGrinHearts,
    faGrinHearts: faGrinHearts,
    faDiceFour: faDiceFour,
    faSimCard: faSimCard,
    faTransgender: faTransgender,
    faTransgenderAlt: faTransgenderAlt,
    faMercury: faMercury,
    faArrowTurnDown: faArrowTurnDown,
    faLevelDown: faLevelDown,
    faPersonFallingBurst: faPersonFallingBurst,
    faAward: faAward,
    faTicketSimple: faTicketSimple,
    faTicketAlt: faTicketAlt,
    faBuilding: faBuilding,
    faAnglesLeft: faAnglesLeft,
    faAngleDoubleLeft: faAngleDoubleLeft,
    faQrcode: faQrcode,
    faClockRotateLeft: faClockRotateLeft,
    faHistory: faHistory,
    faFaceGrinBeamSweat: faFaceGrinBeamSweat,
    faGrinBeamSweat: faGrinBeamSweat,
    faFileExport: faFileExport,
    faArrowRightFromFile: faArrowRightFromFile,
    faShield: faShield,
    faShieldBlank: faShieldBlank,
    faArrowUpShortWide: faArrowUpShortWide,
    faSortAmountUpAlt: faSortAmountUpAlt,
    faHouseMedical: faHouseMedical,
    faGolfBallTee: faGolfBallTee,
    faGolfBall: faGolfBall,
    faCircleChevronLeft: faCircleChevronLeft,
    faChevronCircleLeft: faChevronCircleLeft,
    faHouseChimneyWindow: faHouseChimneyWindow,
    faPenNib: faPenNib,
    faTentArrowTurnLeft: faTentArrowTurnLeft,
    faTents: faTents,
    faWandMagic: faWandMagic,
    faMagic: faMagic,
    faDog: faDog,
    faCarrot: faCarrot,
    faMoon: faMoon,
    faWineGlassEmpty: faWineGlassEmpty,
    faWineGlassAlt: faWineGlassAlt,
    faCheese: faCheese,
    faYinYang: faYinYang,
    faMusic: faMusic,
    faCodeCommit: faCodeCommit,
    faTemperatureLow: faTemperatureLow,
    faPersonBiking: faPersonBiking,
    faBiking: faBiking,
    faBroom: faBroom,
    faShieldHeart: faShieldHeart,
    faGopuram: faGopuram,
    faEarthOceania: faEarthOceania,
    faGlobeOceania: faGlobeOceania,
    faSquareXmark: faSquareXmark,
    faTimesSquare: faTimesSquare,
    faXmarkSquare: faXmarkSquare,
    faHashtag: faHashtag,
    faUpRightAndDownLeftFromCenter: faUpRightAndDownLeftFromCenter,
    faExpandAlt: faExpandAlt,
    faOilCan: faOilCan,
    faT: faT,
    faHippo: faHippo,
    faChartColumn: faChartColumn,
    faInfinity: faInfinity,
    faVialCircleCheck: faVialCircleCheck,
    faPersonArrowDownToLine: faPersonArrowDownToLine,
    faVoicemail: faVoicemail,
    faFan: faFan,
    faPersonWalkingLuggage: faPersonWalkingLuggage,
    faUpDown: faUpDown,
    faArrowsAltV: faArrowsAltV,
    faCloudMoonRain: faCloudMoonRain,
    faCalendar: faCalendar,
    faTrailer: faTrailer,
    faBahai: faBahai,
    faHaykal: faHaykal,
    faSdCard: faSdCard,
    faDragon: faDragon,
    faShoePrints: faShoePrints,
    faCirclePlus: faCirclePlus,
    faPlusCircle: faPlusCircle,
    faFaceGrinTongueWink: faFaceGrinTongueWink,
    faGrinTongueWink: faGrinTongueWink,
    faHandHolding: faHandHolding,
    faPlugCircleExclamation: faPlugCircleExclamation,
    faLinkSlash: faLinkSlash,
    faChainBroken: faChainBroken,
    faChainSlash: faChainSlash,
    faUnlink: faUnlink,
    faClone: faClone,
    faPersonWalkingArrowLoopLeft: faPersonWalkingArrowLoopLeft,
    faArrowUpZA: faArrowUpZA,
    faSortAlphaUpAlt: faSortAlphaUpAlt,
    faFireFlameCurved: faFireFlameCurved,
    faFireAlt: faFireAlt,
    faTornado: faTornado,
    faFileCirclePlus: faFileCirclePlus,
    faBookQuran: faBookQuran,
    faQuran: faQuran,
    faAnchor: faAnchor,
    faBorderAll: faBorderAll,
    faFaceAngry: faFaceAngry,
    faAngry: faAngry,
    faCookieBite: faCookieBite,
    faArrowTrendDown: faArrowTrendDown,
    faRss: faRss,
    faFeed: faFeed,
    faDrawPolygon: faDrawPolygon,
    faScaleBalanced: faScaleBalanced,
    faBalanceScale: faBalanceScale,
    faGaugeSimpleHigh: faGaugeSimpleHigh,
    faTachometer: faTachometer,
    faTachometerFast: faTachometerFast,
    faShower: faShower,
    faDesktop: faDesktop,
    faDesktopAlt: faDesktopAlt,
    faM: faM,
    faTableList: faTableList,
    faThList: faThList,
    faCommentSms: faCommentSms,
    faSms: faSms,
    faBook: faBook,
    faUserPlus: faUserPlus,
    faCheck: faCheck,
    faBatteryThreeQuarters: faBatteryThreeQuarters,
    faBattery4: faBattery4,
    faHouseCircleCheck: faHouseCircleCheck,
    faAngleLeft: faAngleLeft,
    faDiagramSuccessor: faDiagramSuccessor,
    faTruckArrowRight: faTruckArrowRight,
    faArrowsSplitUpAndLeft: faArrowsSplitUpAndLeft,
    faHandFist: faHandFist,
    faFistRaised: faFistRaised,
    faCloudMoon: faCloudMoon,
    faBriefcase: faBriefcase,
    faPersonFalling: faPersonFalling,
    faImagePortrait: faImagePortrait,
    faPortrait: faPortrait,
    faUserTag: faUserTag,
    faRug: faRug,
    faEarthEurope: faEarthEurope,
    faGlobeEurope: faGlobeEurope,
    faCartFlatbedSuitcase: faCartFlatbedSuitcase,
    faLuggageCart: faLuggageCart,
    faRectangleXmark: faRectangleXmark,
    faRectangleTimes: faRectangleTimes,
    faTimesRectangle: faTimesRectangle,
    faWindowClose: faWindowClose,
    faBahtSign: faBahtSign,
    faBookOpen: faBookOpen,
    faBookJournalWhills: faBookJournalWhills,
    faJournalWhills: faJournalWhills,
    faHandcuffs: faHandcuffs,
    faTriangleExclamation: faTriangleExclamation,
    faExclamationTriangle: faExclamationTriangle,
    faWarning: faWarning,
    faDatabase: faDatabase,
    faShare: faShare,
    faMailForward: faMailForward,
    faBottleDroplet: faBottleDroplet,
    faMaskFace: faMaskFace,
    faHillRockslide: faHillRockslide,
    faRightLeft: faRightLeft,
    faExchangeAlt: faExchangeAlt,
    faPaperPlane: faPaperPlane,
    faRoadCircleExclamation: faRoadCircleExclamation,
    faDungeon: faDungeon,
    faAlignRight: faAlignRight,
    faMoneyBill1Wave: faMoneyBill1Wave,
    faMoneyBillWaveAlt: faMoneyBillWaveAlt,
    faLifeRing: faLifeRing,
    faHands: faHands,
    faSignLanguage: faSignLanguage,
    faSigning: faSigning,
    faCalendarDay: faCalendarDay,
    faWaterLadder: faWaterLadder,
    faLadderWater: faLadderWater,
    faSwimmingPool: faSwimmingPool,
    faArrowsUpDown: faArrowsUpDown,
    faArrowsV: faArrowsV,
    faFaceGrimace: faFaceGrimace,
    faGrimace: faGrimace,
    faWheelchairMove: faWheelchairMove,
    faWheelchairAlt: faWheelchairAlt,
    faTurnDown: faTurnDown,
    faLevelDownAlt: faLevelDownAlt,
    faPersonWalkingArrowRight: faPersonWalkingArrowRight,
    faSquareEnvelope: faSquareEnvelope,
    faEnvelopeSquare: faEnvelopeSquare,
    faDice: faDice,
    faBowlingBall: faBowlingBall,
    faBrain: faBrain,
    faBandage: faBandage,
    faBandAid: faBandAid,
    faCalendarMinus: faCalendarMinus,
    faCircleXmark: faCircleXmark,
    faTimesCircle: faTimesCircle,
    faXmarkCircle: faXmarkCircle,
    faGifts: faGifts,
    faHotel: faHotel,
    faEarthAsia: faEarthAsia,
    faGlobeAsia: faGlobeAsia,
    faIdCardClip: faIdCardClip,
    faIdCardAlt: faIdCardAlt,
    faMagnifyingGlassPlus: faMagnifyingGlassPlus,
    faSearchPlus: faSearchPlus,
    faThumbsUp: faThumbsUp,
    faUserClock: faUserClock,
    faHandDots: faHandDots,
    faAllergies: faAllergies,
    faFileInvoice: faFileInvoice,
    faWindowMinimize: faWindowMinimize,
    faMugSaucer: faMugSaucer,
    faCoffee: faCoffee,
    faBrush: faBrush,
    faMask: faMask,
    faMagnifyingGlassMinus: faMagnifyingGlassMinus,
    faSearchMinus: faSearchMinus,
    faRulerVertical: faRulerVertical,
    faUserLarge: faUserLarge,
    faUserAlt: faUserAlt,
    faTrainTram: faTrainTram,
    faUserNurse: faUserNurse,
    faSyringe: faSyringe,
    faCloudSun: faCloudSun,
    faStopwatch20: faStopwatch20,
    faSquareFull: faSquareFull,
    faMagnet: faMagnet,
    faJar: faJar,
    faNoteSticky: faNoteSticky,
    faStickyNote: faStickyNote,
    faBugSlash: faBugSlash,
    faArrowUpFromWaterPump: faArrowUpFromWaterPump,
    faBone: faBone,
    faUserInjured: faUserInjured,
    faFaceSadTear: faFaceSadTear,
    faSadTear: faSadTear,
    faPlane: faPlane,
    faTentArrowsDown: faTentArrowsDown,
    faExclamation: faExclamation,
    faArrowsSpin: faArrowsSpin,
    faPrint: faPrint,
    faTurkishLiraSign: faTurkishLiraSign,
    faTry: faTry,
    faTurkishLira: faTurkishLira,
    faDollarSign: faDollarSign,
    faDollar: faDollar,
    faUsd: faUsd,
    faX: faX,
    faMagnifyingGlassDollar: faMagnifyingGlassDollar,
    faSearchDollar: faSearchDollar,
    faUsersGear: faUsersGear,
    faUsersCog: faUsersCog,
    faPersonMilitaryPointing: faPersonMilitaryPointing,
    faBuildingColumns: faBuildingColumns,
    faBank: faBank,
    faInstitution: faInstitution,
    faMuseum: faMuseum,
    faUniversity: faUniversity,
    faUmbrella: faUmbrella,
    faTrowel: faTrowel,
    faD: faD,
    faStapler: faStapler,
    faMasksTheater: faMasksTheater,
    faTheaterMasks: faTheaterMasks,
    faKipSign: faKipSign,
    faHandPointLeft: faHandPointLeft,
    faHandshakeSimple: faHandshakeSimple,
    faHandshakeAlt: faHandshakeAlt,
    faJetFighter: faJetFighter,
    faFighterJet: faFighterJet,
    faSquareShareNodes: faSquareShareNodes,
    faShareAltSquare: faShareAltSquare,
    faBarcode: faBarcode,
    faPlusMinus: faPlusMinus,
    faVideo: faVideo,
    faVideoCamera: faVideoCamera,
    faGraduationCap: faGraduationCap,
    faMortarBoard: faMortarBoard,
    faHandHoldingMedical: faHandHoldingMedical,
    faPersonCircleCheck: faPersonCircleCheck,
    faTurnUp: faTurnUp,
    faLevelUpAlt: faLevelUpAlt
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jMWuK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _routes = require("./Constants/Routes");
var _authService = require("./Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _constants = require("./Styles/constants");
var _asset = require("./Pages/Asset");
var _assetDefault = parcelHelpers.interopDefault(_asset);
var _noDataIndication = require("./Components/NoDataIndication");
var _notFound = require("./Pages/NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
var _inventorySidebar = require("./Components/Organization/InventorySidebar");
var _inventorySidebarDefault = parcelHelpers.interopDefault(_inventorySidebar);
const AssetModel = /*#__PURE__*/ (0, _react.lazy)(()=>require("1de320b353d69a3a"));
const Events = /*#__PURE__*/ (0, _react.lazy)(()=>require("2fd0d9a5cdca3bd9"));
const CsvReport = /*#__PURE__*/ (0, _react.lazy)(()=>require("1ec7da0aac839b45"));
const CsvReports = /*#__PURE__*/ (0, _react.lazy)(()=>require("f7bde95760aa20ad"));
const EngineApp = /*#__PURE__*/ (0, _react.lazy)(()=>require("1654af66b80278a0"));
const Fleet = /*#__PURE__*/ (0, _react.lazy)(()=>require("85f918934d0e4a14"));
const Geofence = /*#__PURE__*/ (0, _react.lazy)(()=>require("cd59403a919c46a"));
const Header = /*#__PURE__*/ (0, _react.lazy)(()=>require("88cdf5fa5e22311c"));
const Login = /*#__PURE__*/ (0, _react.lazy)(()=>require("a58cfa0fb6d5964b"));
const Maintenance = /*#__PURE__*/ (0, _react.lazy)(()=>require("afe00dbb103d2cb7"));
const MaintenanceReport = /*#__PURE__*/ (0, _react.lazy)(()=>require("94f3476dbf6d4984"));
const Map = /*#__PURE__*/ (0, _react.lazy)(()=>require("3aa193b193f9cc7"));
const Organization = /*#__PURE__*/ (0, _react.lazy)(()=>require("377aac2a808594e2"));
const CreateEditSchedule = /*#__PURE__*/ (0, _react.lazy)(()=>require("d6176734670671eb"));
const Search = /*#__PURE__*/ (0, _react.lazy)(()=>require("3b5714c8ecd857a5"));
const Settings = /*#__PURE__*/ (0, _react.lazy)(()=>require("2cad22e778cb1d01"));
const WaterPump = /*#__PURE__*/ (0, _react.lazy)(()=>require("4f4ce7326504f8f6"));
exports.default = /*#__PURE__*/ (0, _react.memo)(Routes);
function Routes(props) {
    const auth = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []);
    const [isLoggedIn, setIsLoggedIn] = (0, _react.useState)(!!auth.getToken());
    const { currentOrg, currentUser, handleLoginSuccess, handleSearchTerm, missingImage, nextOrgName, orgsMap, rootOrg, profileIcon, searchTerm, setCurrentOrg, showOverlay, sidebarCollapsed, updateCurrentUser, width } = props;
    const isDesktop = (0, _react.useMemo)(()=>width >= (0, _constants.LARGE_WIDTH_PX), [
        width
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _styleDefault.default).dynamic([
            [
                "3426555681",
                [
                    isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)
                ]
            ]
        ]) + " " + `min-vw-100 min-vh-100 ${isLoggedIn ? "app-container" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "3426555681",
                        [
                            isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)
                        ]
                    ]
                ]) + " " + ((isLoggedIn ? "header-container h-100" : "d-none") || ""),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                        handleSearchTerm: handleSearchTerm,
                        orgsMap: orgsMap,
                        sideBar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inventorySidebarDefault.default), {
                            orgsMap: orgsMap
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "3426555681",
                        [
                            isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)
                        ]
                    ]
                ]) + " " + "switch-router-container position-relative",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            exact: true,
                            path: "/",
                            children: isLoggedIn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                                to: (0, _routes.MAP)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                                to: "/login"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/login",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Login, {
                                    handleLoginSuccess: handleLoginSuccess,
                                    isLoggedIn: isLoggedIn,
                                    setIsLoggedIn: setIsLoggedIn
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/maintenance",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Maintenance, {})
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: (0, _routes.MAINTENANCE_REPORT),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MaintenanceReport, {
                                    currentOrg: currentOrg,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: (0, _routes.MAP),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Map, {
                                    currentOrg: currentOrg,
                                    handleSearchTerm: handleSearchTerm,
                                    searchTerm: searchTerm,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: [
                                "/fleet/:dashboardID",
                                (0, _routes.FLEET)
                            ],
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Fleet, {
                                    currentOrg: currentOrg,
                                    currentUser: currentUser,
                                    orgsMap: orgsMap,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/organization",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Organization, {
                                    currentOrg: currentOrg,
                                    handleSearchTerm: handleSearchTerm,
                                    missingImage: missingImage,
                                    orgsMap: orgsMap,
                                    profileIcon: profileIcon,
                                    searchTerm: searchTerm,
                                    sidebarCollapsed: sidebarCollapsed,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/events",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Events, {
                                    currentOrg: currentOrg,
                                    orgsMap: orgsMap,
                                    user: currentUser,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            exact: true,
                            path: "/csv-reports",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CsvReports, {
                                    currentOrg: currentOrg,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/csv-reports/:reportID",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CsvReport, {
                                    currentOrg: currentOrg,
                                    currentUser: currentUser,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/asset/:assetID",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: currentOrg?._id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "3426555681",
                                            [
                                                isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)
                                            ]
                                        ]
                                    ]) + " " + "h-100 w-100 d-flex justify-content-center align-items-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/asset-model/:templateID",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AssetModel, {
                                    currentOrg: currentOrg,
                                    orgsMap: orgsMap,
                                    setCurrentOrg: setCurrentOrg,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/geofence/:geofenceID",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Geofence, {
                                    rootOrg: rootOrg
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: [
                                "/schedule/:scheduleId",
                                "/schedule"
                            ],
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CreateEditSchedule, {
                                    currentOrg: currentOrg,
                                    currentUser: currentUser,
                                    rootOrg: rootOrg,
                                    setCurrentOrg: setCurrentOrg,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: [
                                "/watertransfer/:waterpumpId",
                                "/watertransfer"
                            ],
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(WaterPump, {})
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: [
                                "/engineanalysis/:assetID",
                                "/engineanalysis"
                            ],
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EngineApp, {})
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/search",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Search, {
                                    currentOrg: currentOrg,
                                    currentUser: currentUser,
                                    orgsMap: orgsMap,
                                    rootOrg: rootOrg,
                                    sidebarCollapsed: sidebarCollapsed,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/settings",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {}),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Settings, {
                                    updateCurrentUser: updateCurrentUser,
                                    width: width
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFoundDefault.default), {
                                width: width
                            })
                        })
                    ]
                })
            }),
            showOverlay ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "3426555681",
                        [
                            isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)
                        ]
                    ]
                ]) + " " + "overlay text-white font-weight-light position-fixed d-flex flex-column justify-content-center align-items-center w-100 h-100",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCircleNotch),
                        size: "2x",
                        spin: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "3426555681",
                                [
                                    isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)
                                ]
                            ]
                        ]) + " " + "mt-3",
                        children: `Returning to ${nextOrgName}`
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3426555681",
                dynamic: [
                    isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)
                ],
                children: `.overlay.__jsx-style-dynamic-selector{background-color:rgba(0,0,0,0.5);bottom:0;left:0;right:0;top:0;z-index:2000;}.app-container.__jsx-style-dynamic-selector{display:grid;grid-template-areas:'header' 'main';grid-template-columns:1fr;grid-template-rows:${isDesktop ? (0, _constants.HEADER_HEIGHT) : (0, _constants.MOBILE_HEADER_HEIGHT)} 1fr;}.header-container.__jsx-style-dynamic-selector{grid-area:header;}.switch-router-container.__jsx-style-dynamic-selector{grid-area:main;}`
            })
        ]
    });
}
Routes.propTypes = {
    currentOrg: (0, _propTypesDefault.default).object,
    currentUser: (0, _propTypesDefault.default).object,
    handleLoginSuccess: (0, _propTypesDefault.default).func,
    handleSearchTerm: (0, _propTypesDefault.default).func,
    missingImage: (0, _propTypesDefault.default).string,
    nextOrgName: (0, _propTypesDefault.default).string,
    orgsMap: (0, _propTypesDefault.default).object,
    profileIcon: (0, _propTypesDefault.default).string,
    resetStateOnLogout: (0, _propTypesDefault.default).func,
    rootOrg: (0, _propTypesDefault.default).object,
    searchTerm: (0, _propTypesDefault.default).string,
    setCurrentOrg: (0, _propTypesDefault.default).func,
    showOverlay: (0, _propTypesDefault.default).bool,
    sidebarCollapsed: (0, _propTypesDefault.default).bool,
    updateCurrentUser: (0, _propTypesDefault.default).func,
    width: (0, _propTypesDefault.default).number
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./Constants/Routes":"3Lt5k","./Services/AuthService":"8Bjjn","./Styles/constants":"gIVbf","./Pages/Asset":"6fvH0","1de320b353d69a3a":"asi9N","2fd0d9a5cdca3bd9":"dNhmt","1ec7da0aac839b45":"7wvZW","f7bde95760aa20ad":"bAPlJ","1654af66b80278a0":"70dmO","85f918934d0e4a14":"lSzq7","cd59403a919c46a":"kXOSG","88cdf5fa5e22311c":"uPgny","./Components/NoDataIndication":"clGpp","a58cfa0fb6d5964b":"eYU2k","afe00dbb103d2cb7":"lN2rM","94f3476dbf6d4984":"a5vyp","3aa193b193f9cc7":"bQcdR","./Pages/NotFound":"gNZTL","377aac2a808594e2":"j8uEx","d6176734670671eb":"cYj99","3b5714c8ecd857a5":"cRmIF","2cad22e778cb1d01":"6nSzI","./Components/Organization/InventorySidebar":"3dwjU","4f4ce7326504f8f6":"c38es","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6lVCJ":[function(require,module,exports) {
module.exports = require("bdcfbabd96dfea07").style;

},{"bdcfbabd96dfea07":"dXeWl"}],"dXeWl":[function(require,module,exports) {
var process = require("af8c38aadc4d67ae");
require("4edf3e4ad8a8eaff");
var React = require("f41a058e0375fe07");
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && false;
var isString = function(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node = typeof window !== "undefined" && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    }
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if (typeof window !== "undefined" && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function(rule, index) {
                if (typeof index === "number") _this._serverSheet.cssRules[index] = {
                    cssText: rule
                };
                else _this._serverSheet.cssRules.push({
                    cssText: rule
                });
                return index;
            },
            deleteRule: function(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) return tag.sheet;
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (typeof window === "undefined") {
            if (typeof index !== "number") index = this._serverSheet.cssRules.length;
            this._serverSheet.insertRule(rule, index);
            return this._rulesCount++;
        }
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") index = sheet.cssRules.length;
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || typeof window === "undefined") {
            var sheet = typeof window !== "undefined" ? this.getSheet() : this._serverSheet;
            if (!rule.trim()) rule = this._deletedRulePlaceholder;
            if (!sheet.cssRules[index]) // @TBD Should we throw an error?
            return index;
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (typeof window === "undefined") {
            this._serverSheet.deleteRule(index);
            return;
        }
        if (this._optimizeForSpeed) this.replaceRule(index, "");
        else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (typeof window !== "undefined") {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else // simpler on server
        this._serverSheet.cssRules = [];
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (typeof window === "undefined") return this._serverSheet.cssRules;
        return this._tags.reduce(function(rules, tag) {
            if (tag) rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
            }));
            else rules.push(null);
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) tag.appendChild(document.createTextNode(cssString));
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) head.insertBefore(tag, relativeToTag);
        else head.appendChild(tag);
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) throw new Error("StyleSheet: " + message + ".");
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i)_$hash = _$hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) return "jsx-" + baseId;
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (typeof window === "undefined") css = sanitize(css);
    var idcss = id + css;
    if (!cache[idcss]) cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    }
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if (typeof window !== "undefined" && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) throw new Error("StyleSheetRegistry: " + message + ".");
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry = typeof window !== "undefined" ? createStyleRegistry() : undefined;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) return null;
    if (typeof window === "undefined") {
        registry.add(props);
        return null;
    }
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
exports.StyleRegistry = StyleRegistry;
exports.createStyleRegistry = createStyleRegistry;
exports.style = JSXStyle;
exports.useStyleRegistry = useStyleRegistry;

},{"af8c38aadc4d67ae":"5jT8D","4edf3e4ad8a8eaff":"5XdMS","f41a058e0375fe07":"9njXz"}],"5XdMS":[function(require,module,exports) {

},{}],"3Lt5k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASSET_DETAILS", ()=>ASSET_DETAILS);
parcelHelpers.export(exports, "ASSET_INVENTORY", ()=>ASSET_INVENTORY);
parcelHelpers.export(exports, "ASSET_MODEL_DETAILS", ()=>ASSET_MODEL_DETAILS);
parcelHelpers.export(exports, "CSV_REPORTS", ()=>CSV_REPORTS);
parcelHelpers.export(exports, "ENGINEANALYSIS", ()=>ENGINEANALYSIS);
parcelHelpers.export(exports, "FLEET", ()=>FLEET);
parcelHelpers.export(exports, "MAINTENANCE", ()=>MAINTENANCE);
parcelHelpers.export(exports, "MAINTENANCE_REPORT", ()=>MAINTENANCE_REPORT);
parcelHelpers.export(exports, "MAP", ()=>MAP);
parcelHelpers.export(exports, "REPORTS", ()=>REPORTS);
parcelHelpers.export(exports, "WATERTRANSFER", ()=>WATERTRANSFER);
const ASSET_DETAILS = "/asset";
const ASSET_INVENTORY = "/organization/assets";
const ASSET_MODEL_DETAILS = "/asset-model";
const CSV_REPORTS = "/csv-reports";
const ENGINEANALYSIS = "/engineanalysis";
const FLEET = "/fleet";
const MAINTENANCE = "/maintenance";
const MAINTENANCE_REPORT = "/maintenance-report";
const MAP = "/map";
const REPORTS = "/reports";
const WATERTRANSFER = "/watertransfer";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIVbf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BODY_HEIGHT", ()=>BODY_HEIGHT);
parcelHelpers.export(exports, "EXTRA_LARGE_WIDTH_PX", ()=>EXTRA_LARGE_WIDTH_PX);
parcelHelpers.export(exports, "HEADER_HEIGHT", ()=>HEADER_HEIGHT);
parcelHelpers.export(exports, "LARGE_WIDTH_PX", ()=>LARGE_WIDTH_PX);
parcelHelpers.export(exports, "MAIN_HEIGHT", ()=>MAIN_HEIGHT);
parcelHelpers.export(exports, "MEDIUM_WIDTH_PX", ()=>MEDIUM_WIDTH_PX);
parcelHelpers.export(exports, "MOBILE_HEADER_HEIGHT", ()=>MOBILE_HEADER_HEIGHT);
parcelHelpers.export(exports, "MOBILE_MAIN_HEIGHT", ()=>MOBILE_MAIN_HEIGHT);
parcelHelpers.export(exports, "SMALL_WIDTH_PX", ()=>SMALL_WIDTH_PX);
const BODY_HEIGHT = "100vh";
const EXTRA_LARGE_WIDTH_PX = 1200;
const HEADER_HEIGHT = "90px";
const LARGE_WIDTH_PX = 992;
const MAIN_HEIGHT = `calc(${BODY_HEIGHT} - ${HEADER_HEIGHT})`;
const MEDIUM_WIDTH_PX = 768;
const MOBILE_HEADER_HEIGHT = "70px";
const MOBILE_MAIN_HEIGHT = `calc(${BODY_HEIGHT} - ${MOBILE_HEADER_HEIGHT})`;
const SMALL_WIDTH_PX = 576;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fvH0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _socketIoClient = require("socket.io-client");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _authService = require("../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _dashboardSocketContext = require("../Context/DashboardSocketContext");
var _withAuth = require("../Components/withAuth");
var _withAuthDefault = parcelHelpers.interopDefault(_withAuth);
var _assetDetailsLayout = require("../Components/Asset/AssetDetailsLayout");
var _assetDetailsLayoutDefault = parcelHelpers.interopDefault(_assetDetailsLayout);
exports.default = (0, _withAuthDefault.default)(/*#__PURE__*/ (0, _react.memo)(AssetDetails));
const host = "elevat-api-dev.elevat-iot.com", port = "443", protocol = "https";
function AssetDetails(props) {
    const { assetID } = (0, _reactRouterDom.useParams)();
    const authService = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []), token = (0, _react.useMemo)(()=>authService.getToken(), [
        authService
    ]);
    const [socket, setSocket] = (0, _react.useState)(), [socketConnectError, setSocketError] = (0, _react.useState)("");
    (0, _react.useEffect)(()=>{
        if (socket?.connected) return;
        const auth = {
            gatewayID: assetID,
            token: `Bearer ${token}`
        }, path = "/websocket", socketURL = `${protocol}://${host}:${port}/dashboard`, transports = [
            "polling",
            "websocket"
        ];
        const socketInstance = (0, _socketIoClient.io)(socketURL, {
            auth,
            path,
            transports
        }).on("connect", ()=>setSocket(socketInstance)).on("connect_error", (err)=>{
            if (!authService.getToken()) return;
            setSocketError(err?.message);
            socketInstance?.disconnect?.();
        }).on("disconnect", (reason)=>{
            if (reason === "io server disconnect") socketInstance?.connect();
        }).on("error", (err)=>{
            setSocketError(err?.message);
            socketInstance?.disconnect?.();
        });
        return ()=>{
            socketInstance?.disconnect?.();
        };
    }, [
        assetID,
        authService,
        socket?.connected,
        token
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardSocketContext.SocketContextProvider), {
        value: socket,
        children: socket ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDetailsLayoutDefault.default), {
            ...props,
            socketConnectError: socketConnectError
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "h-100 w-100 d-flex align-items-center justify-content-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                color: "var(--brand-primary)",
                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                size: "5x",
                spin: true
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","socket.io-client":"7zppl","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../Services/AuthService":"8Bjjn","../Context/DashboardSocketContext":"ly197","../Components/withAuth":"5591i","../Components/Asset/AssetDetailsLayout":"9wvMZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7zppl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Protocol version.
 *
 * @public
 */ parcelHelpers.export(exports, "protocol", ()=>(0, _socketIoParser.protocol));
/**
 * Expose constructors for standalone build.
 *
 * @public
 */ parcelHelpers.export(exports, "Manager", ()=>(0, _managerJs.Manager));
parcelHelpers.export(exports, "Socket", ()=>(0, _socketJs.Socket));
parcelHelpers.export(exports, "io", ()=>lookup);
parcelHelpers.export(exports, "connect", ()=>lookup);
parcelHelpers.export(exports, "default", ()=>lookup);
var _urlJs = require("./url.js");
var _managerJs = require("./manager.js");
var _socketJs = require("./socket.js");
var _socketIoParser = require("socket.io-parser");
/**
 * Managers cache.
 */ const cache = {};
function lookup(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, _urlJs.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = cache[id] && path in cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, _managerJs.Manager)(source, opts);
    else {
        if (!cache[id]) cache[id] = new (0, _managerJs.Manager)(source, opts);
        io = cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign(lookup, {
    Manager: (0, _managerJs.Manager),
    Socket: (0, _socketJs.Socket),
    io: lookup,
    connect: lookup
});

},{"./url.js":"gtQtO","./manager.js":"ewexY","./socket.js":"5MUJD","socket.io-parser":"rfB0h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtQtO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * URL parser.
 *
 * @param uri - url
 * @param path - the request path of the connection
 * @param loc - An object meant to mimic window.location.
 *        Defaults to window.location.
 * @public
 */ parcelHelpers.export(exports, "url", ()=>url);
var _engineIoClient = require("engine.io-client");
function url(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, _engineIoClient.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

},{"engine.io-client":"6PDTb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6PDTb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transport", ()=>(0, _transportJs.Transport));
parcelHelpers.export(exports, "TransportError", ()=>(0, _transportJs.TransportError));
parcelHelpers.export(exports, "transports", ()=>(0, _indexJs.transports));
parcelHelpers.export(exports, "installTimerFunctions", ()=>(0, _utilJs.installTimerFunctions));
parcelHelpers.export(exports, "parse", ()=>(0, _parseuriJs.parse));
parcelHelpers.export(exports, "nextTick", ()=>(0, _websocketConstructorJs.nextTick));
parcelHelpers.export(exports, "Socket", ()=>(0, _socketJs.Socket));
parcelHelpers.export(exports, "protocol", ()=>protocol);
var _socketJs = require("./socket.js");
var _transportJs = require("./transport.js");
var _indexJs = require("./transports/index.js");
var _utilJs = require("./util.js");
var _parseuriJs = require("./contrib/parseuri.js");
var _websocketConstructorJs = require("./transports/websocket-constructor.js");
const protocol = (0, _socketJs.Socket).protocol;

},{"./socket.js":"ecS8U","./transport.js":"eFIkS","./transports/index.js":"a9hZQ","./util.js":"3d5D6","./contrib/parseuri.js":"1dyEW","./transports/websocket-constructor.js":"ieUbd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecS8U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Socket", ()=>Socket);
var _indexJs = require("./transports/index.js");
var _utilJs = require("./util.js");
var _parseqsJs = require("./contrib/parseqs.js");
var _parseuriJs = require("./contrib/parseuri.js");
var _componentEmitter = require("@socket.io/component-emitter");
var _engineIoParser = require("engine.io-parser");
var _websocketConstructorJs = require("./transports/websocket-constructor.js");
class Socket extends (0, _componentEmitter.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, _websocketConstructorJs.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, _parseuriJs.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, _parseuriJs.parse)(opts.host).host;
        (0, _utilJs.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, _parseqsJs.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, _engineIoParser.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, _indexJs.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        Socket.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    Socket.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        Socket.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, _utilJs.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        Socket.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
Socket.protocol = (0, _engineIoParser.protocol);

},{"./transports/index.js":"a9hZQ","./util.js":"3d5D6","./contrib/parseqs.js":"k8UKf","./contrib/parseuri.js":"1dyEW","@socket.io/component-emitter":"2t9Mj","engine.io-parser":"bVFoq","./transports/websocket-constructor.js":"ieUbd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9hZQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transports", ()=>transports);
var _pollingJs = require("./polling.js");
var _websocketJs = require("./websocket.js");
var _webtransportJs = require("./webtransport.js");
const transports = {
    websocket: (0, _websocketJs.WS),
    webtransport: (0, _webtransportJs.WT),
    polling: (0, _pollingJs.Polling)
};

},{"./polling.js":"b1YoZ","./websocket.js":"3RBH6","./webtransport.js":"ccjeT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b1YoZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Polling", ()=>Polling);
parcelHelpers.export(exports, "Request", ()=>Request);
var _transportJs = require("../transport.js");
var _yeastJs = require("../contrib/yeast.js");
var _engineIoParser = require("engine.io-parser");
var _xmlhttprequestJs = require("./xmlhttprequest.js");
var _componentEmitter = require("@socket.io/component-emitter");
var _utilJs = require("../util.js");
var _globalThisJs = require("../globalThis.js");
function empty() {}
const hasXHR2 = function() {
    const xhr = new (0, _xmlhttprequestJs.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class Polling extends (0, _transportJs.Transport) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, _xmlhttprequestJs.createCookieJar)();
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, _engineIoParser.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, _engineIoParser.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, _yeastJs.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new Request(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class Request extends (0, _componentEmitter.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, _utilJs.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, _utilJs.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, _xmlhttprequestJs.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = Request.requestsCount++;
            Request.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete Request.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
}
Request.requestsCount = 0;
Request.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in globalThis ? "pagehide" : "unload";
        addEventListener(terminationEvent, unloadHandler, false);
    }
}
function unloadHandler() {
    for(let i in Request.requests)if (Request.requests.hasOwnProperty(i)) Request.requests[i].abort();
}

},{"../transport.js":"eFIkS","../contrib/yeast.js":"9iByX","engine.io-parser":"bVFoq","./xmlhttprequest.js":"gGiKV","@socket.io/component-emitter":"2t9Mj","../util.js":"3d5D6","../globalThis.js":"5P8Lv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFIkS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransportError", ()=>TransportError);
parcelHelpers.export(exports, "Transport", ()=>Transport);
var _engineIoParser = require("engine.io-parser");
var _componentEmitter = require("@socket.io/component-emitter");
var _utilJs = require("./util.js");
var _parseqsJs = require("./contrib/parseqs.js");
class TransportError extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class Transport extends (0, _componentEmitter.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, _utilJs.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new TransportError(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, _engineIoParser.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, _parseqsJs.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

},{"engine.io-parser":"bVFoq","@socket.io/component-emitter":"2t9Mj","./util.js":"3d5D6","./contrib/parseqs.js":"k8UKf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bVFoq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPacketEncoderStream", ()=>createPacketEncoderStream);
parcelHelpers.export(exports, "createPacketDecoderStream", ()=>createPacketDecoderStream);
parcelHelpers.export(exports, "protocol", ()=>protocol);
parcelHelpers.export(exports, "encodePacket", ()=>(0, _encodePacketJs.encodePacket));
parcelHelpers.export(exports, "encodePayload", ()=>encodePayload);
parcelHelpers.export(exports, "decodePacket", ()=>(0, _decodePacketJs.decodePacket));
parcelHelpers.export(exports, "decodePayload", ()=>decodePayload);
var _encodePacketJs = require("./encodePacket.js");
var _decodePacketJs = require("./decodePacket.js");
var _commonsJs = require("./commons.js");
const SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const encodePayload = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, _encodePacketJs.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join(SEPARATOR));
        });
    });
};
const decodePayload = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split(SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, _decodePacketJs.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function createPacketEncoderStream() {
    return new TransformStream({
        transform (packet, controller) {
            (0, _encodePacketJs.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let TEXT_DECODER;
function totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function createPacketDecoderStream(maxPayload, binaryType) {
    if (!TEXT_DECODER) TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if (totalLength(chunks) < 1) break;
                    const header = concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if (totalLength(chunks) < 2) break;
                    const headerArray = concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if (totalLength(chunks) < 8) break;
                    const headerArray = concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, _commonsJs.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if (totalLength(chunks) < expectedLength) break;
                    const data = concatChunks(chunks, expectedLength);
                    controller.enqueue((0, _decodePacketJs.decodePacket)(isBinary ? data : TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, _commonsJs.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const protocol = 4;

},{"./encodePacket.js":"kPaJJ","./decodePacket.js":"5CBdb","./commons.js":"1jKe3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kPaJJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encodePacketToBinary", ()=>encodePacketToBinary);
parcelHelpers.export(exports, "encodePacket", ()=>encodePacket);
var _commonsJs = require("./commons.js");
const withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const encodePacket = ({ type, data }, supportsBinary, callback)=>{
    if (withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return encodeBlobAsBase64(data, callback);
    } else if (withNativeArrayBuffer && (data instanceof ArrayBuffer || isView(data))) {
        if (supportsBinary) return callback(data);
        else return encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, _commonsJs.PACKET_TYPES)[type] + (data || ""));
};
const encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let TEXT_ENCODER;
function encodePacketToBinary(packet, callback) {
    if (withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then(toArray).then(callback);
    else if (withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || isView(packet.data))) return callback(toArray(packet.data));
    encodePacket(packet, false, (encoded)=>{
        if (!TEXT_ENCODER) TEXT_ENCODER = new TextEncoder();
        callback(TEXT_ENCODER.encode(encoded));
    });
}

},{"./commons.js":"1jKe3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1jKe3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PACKET_TYPES", ()=>PACKET_TYPES);
parcelHelpers.export(exports, "PACKET_TYPES_REVERSE", ()=>PACKET_TYPES_REVERSE);
parcelHelpers.export(exports, "ERROR_PACKET", ()=>ERROR_PACKET);
const PACKET_TYPES = Object.create(null); // no Map = no polyfill
PACKET_TYPES["open"] = "0";
PACKET_TYPES["close"] = "1";
PACKET_TYPES["ping"] = "2";
PACKET_TYPES["pong"] = "3";
PACKET_TYPES["message"] = "4";
PACKET_TYPES["upgrade"] = "5";
PACKET_TYPES["noop"] = "6";
const PACKET_TYPES_REVERSE = Object.create(null);
Object.keys(PACKET_TYPES).forEach((key)=>{
    PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
});
const ERROR_PACKET = {
    type: "error",
    data: "parser error"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5CBdb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodePacket", ()=>decodePacket);
var _commonsJs = require("./commons.js");
var _base64ArraybufferJs = require("./contrib/base64-arraybuffer.js");
const withNativeArrayBuffer = typeof ArrayBuffer === "function";
const decodePacket = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, _commonsJs.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, _commonsJs.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, _commonsJs.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, _commonsJs.PACKET_TYPES_REVERSE)[type]
    };
};
const decodeBase64Packet = (data, binaryType)=>{
    if (withNativeArrayBuffer) {
        const decoded = (0, _base64ArraybufferJs.decode)(data);
        return mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data
    }; // fallback for old browsers
};
const mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

},{"./commons.js":"1jKe3","./contrib/base64-arraybuffer.js":"c0HfT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0HfT":[function(require,module,exports) {
// imported from https://github.com/socketio/base64-arraybuffer
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
const encode = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const decode = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2t9Mj":[function(require,module,exports) {
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Emitter", ()=>Emitter);
function Emitter(obj) {
    if (obj) return mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function mixin(obj) {
    for(var key in Emitter.prototype)obj[key] = Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
Emitter.prototype.emitReserved = Emitter.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3d5D6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "installTimerFunctions", ()=>installTimerFunctions);
// we could also have used `new Blob([obj]).size`, but it isn't supported in IE9
parcelHelpers.export(exports, "byteLength", ()=>byteLength);
var _globalThisJs = require("./globalThis.js");
function pick(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const NATIVE_SET_TIMEOUT = globalThis.setTimeout;
const NATIVE_CLEAR_TIMEOUT = globalThis.clearTimeout;
function installTimerFunctions(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThis);
        obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThis);
    } else {
        obj.setTimeoutFn = globalThis.setTimeout.bind(globalThis);
        obj.clearTimeoutFn = globalThis.clearTimeout.bind(globalThis);
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const BASE64_OVERHEAD = 1.33;
function byteLength(obj) {
    if (typeof obj === "string") return utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
}
function utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}

},{"./globalThis.js":"5P8Lv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5P8Lv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalThisShim", ()=>globalThisShim);
const globalThisShim = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8UKf":[function(require,module,exports) {
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */ parcelHelpers.export(exports, "decode", ()=>decode);
function encode(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function decode(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9iByX":[function(require,module,exports) {
// imported from https://github.com/unshiftio/yeast
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */ parcelHelpers.export(exports, "encode", ()=>encode);
/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */ parcelHelpers.export(exports, "decode", ()=>decode);
/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */ parcelHelpers.export(exports, "yeast", ()=>yeast);
"use strict";
const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), length = 64, map = {};
let seed = 0, i = 0, prev;
function encode(num) {
    let encoded = "";
    do {
        encoded = alphabet[num % length] + encoded;
        num = Math.floor(num / length);
    }while (num > 0);
    return encoded;
}
function decode(str) {
    let decoded = 0;
    for(i = 0; i < str.length; i++)decoded = decoded * length + map[str.charAt(i)];
    return decoded;
}
function yeast() {
    const now = encode(+new Date());
    if (now !== prev) return seed = 0, prev = now;
    return now + "." + encode(seed++);
}
//
// Map each character to its index.
//
for(; i < length; i++)map[alphabet[i]] = i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gGiKV":[function(require,module,exports) {
// browser shim for xmlhttprequest module
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XHR", ()=>XHR);
parcelHelpers.export(exports, "createCookieJar", ()=>createCookieJar);
var _hasCorsJs = require("../contrib/has-cors.js");
var _globalThisJs = require("../globalThis.js");
function XHR(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, _hasCorsJs.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new globalThis[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function createCookieJar() {}

},{"../contrib/has-cors.js":"7UJpu","../globalThis.js":"5P8Lv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7UJpu":[function(require,module,exports) {
// imported from https://github.com/component/has-cors
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasCORS", ()=>hasCORS);
let value = false;
try {
    value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const hasCORS = value;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RBH6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WS", ()=>WS);
var _transportJs = require("../transport.js");
var _yeastJs = require("../contrib/yeast.js");
var _utilJs = require("../util.js");
var _websocketConstructorJs = require("./websocket-constructor.js");
var _engineIoParser = require("engine.io-parser");
var Buffer = require("64d8415e9cf90979").Buffer;
// detect ReactNative environment
const isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class WS extends (0, _transportJs.Transport) {
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = isReactNative ? {} : (0, _utilJs.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, _websocketConstructorJs.usingBrowserWebSocket) && !isReactNative ? protocols ? new (0, _websocketConstructorJs.WebSocket)(uri, protocols) : new (0, _websocketConstructorJs.WebSocket)(uri) : new (0, _websocketConstructorJs.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, _engineIoParser.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, _websocketConstructorJs.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, _websocketConstructorJs.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, _websocketConstructorJs.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, _yeastJs.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, _websocketConstructorJs.WebSocket);
    }
}

},{"64d8415e9cf90979":"dB11O","../transport.js":"eFIkS","../contrib/yeast.js":"9iByX","../util.js":"3d5D6","./websocket-constructor.js":"ieUbd","engine.io-parser":"bVFoq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ieUbd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nextTick", ()=>nextTick);
parcelHelpers.export(exports, "WebSocket", ()=>WebSocket);
parcelHelpers.export(exports, "usingBrowserWebSocket", ()=>usingBrowserWebSocket);
parcelHelpers.export(exports, "defaultBinaryType", ()=>defaultBinaryType);
var _globalThisJs = require("../globalThis.js");
const nextTick = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const WebSocket = globalThis.WebSocket || globalThis.MozWebSocket;
const usingBrowserWebSocket = true;
const defaultBinaryType = "arraybuffer";

},{"../globalThis.js":"5P8Lv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccjeT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WT", ()=>WT);
var _transportJs = require("../transport.js");
var _websocketConstructorJs = require("./websocket-constructor.js");
var _engineIoParser = require("engine.io-parser");
class WT extends (0, _transportJs.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, _engineIoParser.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, _engineIoParser.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done, value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, _websocketConstructorJs.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}

},{"../transport.js":"eFIkS","./websocket-constructor.js":"ieUbd","engine.io-parser":"bVFoq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dyEW":[function(require,module,exports) {
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", ()=>parse);
const re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function parse(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = pathNames(uri, uri["path"]);
    uri.queryKey = queryKey(uri, uri["query"]);
    return uri;
}
function pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewexY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Manager", ()=>Manager);
var _engineIoClient = require("engine.io-client");
var _socketJs = require("./socket.js");
var _socketIoParser = require("socket.io-parser");
var _onJs = require("./on.js");
var _backo2Js = require("./contrib/backo2.js");
var _componentEmitter = require("@socket.io/component-emitter");
class Manager extends (0, _componentEmitter.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, _engineIoClient.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, _backo2Js.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || _socketIoParser;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, _engineIoClient.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, _onJs.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, _onJs.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, _onJs.on)(socket, "ping", this.onping.bind(this)), (0, _onJs.on)(socket, "data", this.ondata.bind(this)), (0, _onJs.on)(socket, "error", this.onerror.bind(this)), (0, _onJs.on)(socket, "close", this.onclose.bind(this)), (0, _onJs.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, _engineIoClient.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, _socketJs.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

},{"engine.io-client":"6PDTb","./socket.js":"5MUJD","socket.io-parser":"rfB0h","./on.js":"6sA4Y","./contrib/backo2.js":"e7g90","@socket.io/component-emitter":"2t9Mj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5MUJD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A Socket is the fundamental class for interacting with the server.
 *
 * A Socket belongs to a certain Namespace (by default /) and uses an underlying {@link Manager} to communicate.
 *
 * @example
 * const socket = io();
 *
 * socket.on("connect", () => {
 *   console.log("connected");
 * });
 *
 * // send an event to the server
 * socket.emit("foo", "bar");
 *
 * socket.on("foobar", () => {
 *   // an event was received from the server
 * });
 *
 * // upon disconnection
 * socket.on("disconnect", (reason) => {
 *   console.log(`disconnected due to ${reason}`);
 * });
 */ parcelHelpers.export(exports, "Socket", ()=>Socket);
var _socketIoParser = require("socket.io-parser");
var _onJs = require("./on.js");
var _componentEmitter = require("@socket.io/component-emitter");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class Socket extends (0, _componentEmitter.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, _onJs.on)(io, "open", this.onopen.bind(this)),
            (0, _onJs.on)(io, "packet", this.onpacket.bind(this)),
            (0, _onJs.on)(io, "error", this.onerror.bind(this)),
            (0, _onJs.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if (RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, _socketIoParser.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, _socketIoParser.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, _socketIoParser.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, _socketIoParser.PacketType).EVENT:
            case (0, _socketIoParser.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, _socketIoParser.PacketType).ACK:
            case (0, _socketIoParser.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, _socketIoParser.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, _socketIoParser.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, _socketIoParser.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, _socketIoParser.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

},{"socket.io-parser":"rfB0h","./on.js":"6sA4Y","@socket.io/component-emitter":"2t9Mj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"rfB0h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "protocol", ()=>protocol);
parcelHelpers.export(exports, "PacketType", ()=>PacketType);
/**
 * A socket.io Encoder instance
 */ parcelHelpers.export(exports, "Encoder", ()=>Encoder);
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 */ parcelHelpers.export(exports, "Decoder", ()=>Decoder);
var _componentEmitter = require("@socket.io/component-emitter");
var _binaryJs = require("./binary.js");
var _isBinaryJs = require("./is-binary.js");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const protocol = 5;
var PacketType;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})(PacketType || (PacketType = {}));
class Encoder {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
            if ((0, _isBinaryJs.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === PacketType.BINARY_EVENT || obj.type === PacketType.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, _binaryJs.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class Decoder extends (0, _componentEmitter.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === PacketType.BINARY_EVENT;
            if (isBinaryEvent || packet.type === PacketType.BINARY_ACK) {
                packet.type = isBinaryEvent ? PacketType.EVENT : PacketType.ACK;
                // binary packet's json
                this.reconstructor = new BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, _isBinaryJs.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if (PacketType[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === PacketType.BINARY_EVENT || p.type === PacketType.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if (Decoder.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case PacketType.CONNECT:
                return isObject(payload);
            case PacketType.DISCONNECT:
                return payload === undefined;
            case PacketType.CONNECT_ERROR:
                return typeof payload === "string" || isObject(payload);
            case PacketType.EVENT:
            case PacketType.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case PacketType.ACK:
            case PacketType.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, _binaryJs.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

},{"@socket.io/component-emitter":"2t9Mj","./binary.js":"aDR3t","./is-binary.js":"d487m","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDR3t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @public
 */ parcelHelpers.export(exports, "deconstructPacket", ()=>deconstructPacket);
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @public
 */ parcelHelpers.export(exports, "reconstructPacket", ()=>reconstructPacket);
var _isBinaryJs = require("./is-binary.js");
function deconstructPacket(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = _deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function _deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, _isBinaryJs.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = _deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = _deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function reconstructPacket(packet, buffers) {
    packet.data = _reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function _reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = _reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = _reconstructPacket(data[key], buffers);
    }
    return data;
}

},{"./is-binary.js":"d487m","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d487m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
 *
 * @private
 */ parcelHelpers.export(exports, "isBinary", ()=>isBinary);
parcelHelpers.export(exports, "hasBinary", ()=>hasBinary);
const withNativeArrayBuffer = typeof ArrayBuffer === "function";
const isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const toString = Object.prototype.toString;
const withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString.call(Blob) === "[object BlobConstructor]";
const withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString.call(File) === "[object FileConstructor]";
function isBinary(obj) {
    return withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)) || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File;
}
function hasBinary(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if (hasBinary(obj[i])) return true;
        }
        return false;
    }
    if (isBinary(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return hasBinary(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6sA4Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "on", ()=>on);
function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e7g90":[function(require,module,exports) {
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Backoff", ()=>Backoff);
function Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ly197":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SocketContext", ()=>SocketContext);
parcelHelpers.export(exports, "SocketContextProvider", ()=>SocketContextProvider);
var _react = require("react");
const SocketContext = /*#__PURE__*/ (0, _react.createContext)();
const SocketContextProvider = SocketContext.Provider;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5591i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WithAuth);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _authService = require("../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
var _loadingCircle = require("./LoadingCircle");
function WithAuth(AuthComponent) {
    function Authenticated(props) {
        const [state, updateState] = (0, _react.useState)({
            isLoading: true
        });
        const history = (0, _reactRouterDom.useHistory)(), location = (0, _reactRouterDom.useLocation)(), { scheduleId } = (0, _reactRouterDom.useParams)();
        const api = (0, _react.useMemo)(()=>new (0, _requestsDefault.default)(), []), auth = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []), token = (0, _react.useMemo)(()=>auth.getToken(), [
            auth
        ]);
        const targetPath = (0, _react.useMemo)(()=>`${location.pathname}${location.search}`, [
            location.pathname,
            location.search
        ]), loginRedirect = (0, _react.useMemo)(()=>({
                pathname: "/login",
                state: {
                    targetPath
                }
            }), [
            targetPath
        ]);
        const validateToken = (0, _react.useCallback)(async ()=>{
            try {
                const source = (0, _axios.CancelToken).source();
                await api.request(auth.buildValidateRequest(source.token));
                updateState((prevState)=>({
                        ...prevState,
                        isLoading: false
                    }));
            } catch (err) {
                if ((0, _axios.isCancel)(err)) return;
                auth.logout();
                history.replace(loginRedirect);
            }
        }, [
            api,
            auth,
            loginRedirect,
            history
        ]);
        (0, _react.useEffect)(()=>{
            if (!token) return history.replace(loginRedirect);
            validateToken();
        }, [
            loginRedirect,
            history,
            token,
            validateToken
        ]);
        return state.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "vh-100 vw-100 d-flex align-items-center justify-content-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                size: "5x"
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuthComponent, {
            ...props,
            history: history,
            location: location,
            scheduleId: scheduleId
        });
    }
    Authenticated.displayName = `Authenticated(${AuthComponent.displayName ?? AuthComponent.name})`;
    Authenticated.propTypes = {
        history: (0, _propTypesDefault.default).shape({
            replace: (0, _propTypesDefault.default).func
        }),
        location: (0, _propTypesDefault.default).shape({
            pathname: (0, _propTypesDefault.default).string,
            search: (0, _propTypesDefault.default).string
        })
    };
    return Authenticated;
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","../Services/AuthService":"8Bjjn","../Lib/Requests":"j1WJQ","./LoadingCircle":"aIADA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wvMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactstrap = require("reactstrap");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _reactImage = require("react-image");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _alertService = require("../../Services/AlertService");
var _alertServiceDefault = parcelHelpers.interopDefault(_alertService);
var _assetGroupService = require("../../Services/AssetGroupService");
var _assetGroupServiceDefault = parcelHelpers.interopDefault(_assetGroupService);
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _authService = require("../../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _dm1Service = require("../../Services/DM1Service");
var _dm1ServiceDefault = parcelHelpers.interopDefault(_dm1Service);
var _templateDashboardService = require("../../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
var _assetUtils = require("../../Lib/AssetUtils");
var _assetUtilsDefault = parcelHelpers.interopDefault(_assetUtils);
var _asset = require("../../Constants/Asset");
var _rbac = require("../../Constants/RBAC");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _vendors = require("../../Constants/Vendors");
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _currentUserContext = require("../../Context/CurrentUserContext");
var _currentUserContextDefault = parcelHelpers.interopDefault(_currentUserContext);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _setCurrentOrgContext = require("../../Context/SetCurrentOrgContext");
var _setCurrentOrgContextDefault = parcelHelpers.interopDefault(_setCurrentOrgContext);
var _updateTagsContext = require("../../Context/UpdateTagsContext");
var _updateCurrentOrgContext = require("../../Context/UpdateCurrentOrgContext");
var _dashboardSocketContext = require("../../Context/DashboardSocketContext");
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _activateAssetModal = require("./ActivateAssetModal");
var _activateAssetModalDefault = parcelHelpers.interopDefault(_activateAssetModal);
var _assetDetailsTabContainer = require("./AssetDetailsTabContainer");
var _assetDetailsTabContainerDefault = parcelHelpers.interopDefault(_assetDetailsTabContainer);
var _assetDashboardContainer = require("./AssetDashboardContainer");
var _assetDashboardContainerDefault = parcelHelpers.interopDefault(_assetDashboardContainer);
var _assetMaintenanceContainer = require("./AssetMaintenanceContainer");
var _assetMaintenanceContainerDefault = parcelHelpers.interopDefault(_assetMaintenanceContainer);
var _assetAlarmsTabContainer = require("./AssetAlarmsTabContainer");
var _assetAlarmsTabContainerDefault = parcelHelpers.interopDefault(_assetAlarmsTabContainer);
var _assetDM1FaultsContainer = require("./AssetDM1FaultsContainer");
var _assetDM1FaultsContainerDefault = parcelHelpers.interopDefault(_assetDM1FaultsContainer);
var _assetSubscriptionsContainer = require("./AssetSubscriptionsContainer");
var _assetSubscriptionsContainerDefault = parcelHelpers.interopDefault(_assetSubscriptionsContainer);
var _assetCommandHistoryContainer = require("./AssetCommandHistoryContainer");
var _assetCommandHistoryContainerDefault = parcelHelpers.interopDefault(_assetCommandHistoryContainer);
var _assetValidationErrorsContainer = require("./AssetValidationErrorsContainer");
var _assetValidationErrorsContainerDefault = parcelHelpers.interopDefault(_assetValidationErrorsContainer);
var _assetV2MaintenanceTabContainer = require("./AssetV2MaintenanceTabContainer");
var _assetV2MaintenanceTabContainerDefault = parcelHelpers.interopDefault(_assetV2MaintenanceTabContainer);
var _deleteAssetModal = require("./DeleteAssetModal");
var _deleteAssetModalDefault = parcelHelpers.interopDefault(_deleteAssetModal);
var _editAssetModal = require("./EditAssetModal");
var _editAssetModalDefault = parcelHelpers.interopDefault(_editAssetModal);
var _errorBoundary = require("../ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _executeCommandModalContainer = require("./ExecuteCommandModalContainer");
var _executeCommandModalContainerDefault = parcelHelpers.interopDefault(_executeCommandModalContainer);
var _gatewaySwapModal = require("./GatewaySwapModal");
var _gatewaySwapModalDefault = parcelHelpers.interopDefault(_gatewaySwapModal);
var _loadingCircle = require("../LoadingCircle");
var _loadingCircleDefault = parcelHelpers.interopDefault(_loadingCircle);
var _mobileTabLinksModal = require("./MobileTabLinksModal");
var _mobileTabLinksModalDefault = parcelHelpers.interopDefault(_mobileTabLinksModal);
var _moveAssetModal = require("./MoveAssetModal");
var _moveAssetModalDefault = parcelHelpers.interopDefault(_moveAssetModal);
var _newCertificateModalContainer = require("./NewCertificateModalContainer");
var _newCertificateModalContainerDefault = parcelHelpers.interopDefault(_newCertificateModalContainer);
var _rerunOutputSignalsModal = require("./RerunOutputSignalsModal");
var _rerunOutputSignalsModalDefault = parcelHelpers.interopDefault(_rerunOutputSignalsModal);
var _validateAssetModal = require("./ValidateAssetModal");
var _validateAssetModalDefault = parcelHelpers.interopDefault(_validateAssetModal);
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetDetailsLayout);
const { className: alertClass, styles: alertStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "45955649",
        children: ".alert.jsx-45955649{z-index:1;right:12.5%;top:5rem;opacity:0.9;}"
    }),
    className: "jsx-45955649"
};
let alertTimeout;
const initState = {
    activeAlertCount: 0,
    activeDmAlertCount: 0,
    asset: {},
    assetGroups: [],
    assetLoading: true,
    currentDashboard: {},
    error: "",
    showActivateAssetModal: false,
    showAddUsersModal: false,
    showCreateDashboardModal: false,
    showCreateWidgetModal: false,
    showDeleteDashboardModal: false,
    showEditAssetModal: false,
    showEditDashboardModal: false,
    showGatewaySwapModal: false,
    showRerunOutputSignalsModal: false,
    showValidateAssetModal: false,
    showViewTemplateDashboardsModal: false,
    templateDashboards: [],
    widgets: []
};
const initAlertState = {
    alertColor: "",
    alertMessage: "",
    alertText: "",
    flexColumn: false,
    showAlert: false
};
const alertReqParams = {
    transitionFilter: "positive",
    typeFilter: "rule",
    severityFilter: "critical"
};
function AssetDetailsLayout(props) {
    const history = (0, _reactRouterDom.useHistory)(), { pathname, search } = (0, _reactRouterDom.useLocation)(), { assetID } = (0, _reactRouterDom.useParams)();
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    const { _id: currentOrgID, features } = currentOrg;
    const currentUser = (0, _react.useContext)((0, _currentUserContextDefault.default)) || {};
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const setCurrentOrg = (0, _react.useContext)((0, _setCurrentOrgContextDefault.default));
    const socket = (0, _react.useContext)((0, _dashboardSocketContext.SocketContext));
    const alertService = (0, _react.useMemo)(()=>new (0, _alertServiceDefault.default)(), []), assetGroupService = (0, _react.useMemo)(()=>new (0, _assetGroupServiceDefault.default)(), []), assetService = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []), assetUtils = (0, _react.useMemo)(()=>new (0, _assetUtilsDefault.default)(), []), authService = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []), dmAlertService = (0, _react.useMemo)(()=>new (0, _dm1ServiceDefault.default)(), []), source = (0, _react.useMemo)(()=>(0, _axios.CancelToken).source(), []), templateDashboardService = (0, _react.useMemo)(()=>new (0, _templateDashboardServiceDefault.default)(), []);
    const usesV1Maintenance = (0, _react.useMemo)(()=>features?.maintenance_v1?.enabled ?? false, [
        features?.maintenance_v1?.enabled
    ]), usesV2Maintenance = (0, _react.useMemo)(()=>features?.maintenance_v2?.enabled ?? false, [
        features?.maintenance_v2?.enabled
    ]), tabLinks = (0, _react.useMemo)(()=>{
        const staticTabs = [
            [
                (0, _asset.DASHBOARD),
                "Dashboard",
                (0, _freeSolidSvgIcons.faTachometerAlt)
            ],
            [
                (0, _asset.DETAILS),
                "Details",
                (0, _freeSolidSvgIcons.faInfoCircle)
            ],
            [
                (0, _asset.ALERTS),
                "Alerts",
                (0, _freeSolidSvgIcons.faBell)
            ],
            [
                (0, _asset.DM1_FAULTS),
                "DM1 Faults",
                (0, _freeSolidSvgIcons.faExclamationTriangle)
            ],
            [
                (0, _asset.COMMAND_HISTORY),
                "Command History",
                (0, _freeSolidSvgIcons.faWifi)
            ],
            [
                (0, _asset.SUBSCRIPTIONS),
                "Subscriptions",
                (0, _freeSolidSvgIcons.faEnvelopeOpenText)
            ],
            [
                (0, _asset.VALIDATION_ERRORS),
                "Errors",
                (0, _freeSolidSvgIcons.faTimes)
            ]
        ];
        switch(true){
            case usesV1Maintenance && usesV2Maintenance:
                staticTabs.splice(2, 0, [
                    (0, _asset.MAINTENANCE),
                    "Maintenance (Legacy)",
                    (0, _freeSolidSvgIcons.faTools)
                ], [
                    (0, _asset.V2_MAINTENANCE),
                    "Maintenance",
                    (0, _freeSolidSvgIcons.faScrewdriverWrench)
                ]);
                break;
            case usesV1Maintenance:
                staticTabs.splice(2, 0, [
                    (0, _asset.MAINTENANCE),
                    "Maintenance (Legacy)",
                    (0, _freeSolidSvgIcons.faTools)
                ]);
                break;
            case usesV2Maintenance:
                staticTabs.splice(2, 0, [
                    (0, _asset.V2_MAINTENANCE),
                    "Maintenance",
                    (0, _freeSolidSvgIcons.faScrewdriverWrench)
                ]);
                break;
        }
        return staticTabs;
    }, [
        usesV1Maintenance,
        usesV2Maintenance
    ]);
    const dashboardRef = (0, _react.useRef)(null);
    const [state, updateState] = (0, _react.useState)(initState);
    const [alertState, updateAlertState] = (0, _react.useState)(initAlertState);
    const [commandExecuted, toggleCommandExecuted] = (0, _react.useState)(false);
    const [showDeleteAssetModal, toggleDeleteAssetModal] = (0, _react.useState)(false);
    const [showExecuteCommandModal, toggleExecuteCommandModal] = (0, _react.useState)(false);
    const [showMobileTabLinksModal, toggleMobileTabLinksModal] = (0, _react.useState)(false);
    const [showMoveAssetModal, toggleMoveAssetModal] = (0, _react.useState)(false);
    const [showNewCertificateModal, toggleNewCertificateModal] = (0, _react.useState)(false);
    const isRestrictedAssetForCommands = (0, _react.useMemo)(()=>checkAssetVendorForCommands(state.asset), [
        state.asset
    ]), isRestrictedAssetForDM1Tab = (0, _react.useMemo)(()=>checkAssetVendorForDM1Tab(state.asset), [
        state.asset
    ]), isRestrictedAssetForOtherThings = (0, _react.useMemo)(()=>checkAssetVendorForOtherThings(state.asset), [
        state.asset
    ]), otaHiddenForEdge = (0, _react.useMemo)(()=>checkOtaHiddenForEdge(state.asset), [
        state.asset
    ]);
    const { tab = (0, _asset.DASHBOARD) } = (0, _queryStringDefault.default).parse(search);
    const handleSubtractAssetAction = (0, _react.useCallback)(()=>history.push("/organization/assets"), [
        history
    ]), handleTabChange = (0, _react.useCallback)((t)=>{
        history.push(`${pathname}?tab=${t}`);
    }, [
        history,
        pathname
    ]);
    const toggleAlert = (0, _react.useCallback)(()=>{
        updateAlertState(initAlertState);
        updateState((prevState)=>({
                ...prevState,
                error: ""
            }));
    }, []), _alertTimeout = (0, _react.useCallback)(()=>{
        window.clearTimeout(alertTimeout);
        alertTimeout = window.setTimeout(toggleAlert, 8000);
    }, [
        toggleAlert
    ]);
    const handleConnectivityUpdate = (0, _react.useCallback)(({ signals = {} } = {})=>{
        const { value: connectivity } = Object.values(signals || {}).find(({ name })=>name === "connect-disconnect") || {};
        if (!connectivity || connectivity === state.connectivity) return;
        updateState((prevState)=>({
                ...prevState,
                connectivity
            }));
    }, [
        state.connectivity
    ]), fetchAsset = (0, _react.useCallback)(async (edit)=>{
        try {
            const assetReq = assetService.fetchAsset({
                assetID,
                includeLocation: true,
                shadow: true
            }, source.token);
            const assetGroupsReq = assetGroupService.fetchGatewayAssetGroups(assetID, source.token);
            const alertCountParams = {
                ...alertReqParams,
                gatewayIdFilter: assetID,
                orgIdFilter: currentOrgID,
                orgID: currentOrgID
            };
            const activeAlertsCountReq = alertService.fetchAlertByRuleMetrics(alertCountParams, source.token);
            const activeDmAlertsCountReq = dmAlertService.getDM1FaultsCount(alertCountParams, source.token);
            const [asset, { assetGroups }, { Count: activeAlertCount }, { Count: activeDmAlertCount }] = await Promise.all([
                assetReq,
                assetGroupsReq,
                activeAlertsCountReq,
                activeDmAlertsCountReq
            ]);
            let templateDashboards = [];
            let error = props.socketConnectError;
            if (asset?.gtemplateID) try {
                templateDashboards = await templateDashboardService.fetchAllTemplateDashboards(asset.gtemplateID, source.token);
            } catch (err) {
                const { message = "" } = err.response?.data ?? err;
                error = message.concat(error ? "\n" : "", error);
            }
            const connectivity = asset ? assetUtils.getConnectivityFromShadow(asset) : "";
            updateState((prevState)=>({
                    ...prevState,
                    activeAlertCount,
                    activeDmAlertCount,
                    asset,
                    assetGroups,
                    assetLoading: false,
                    connectivity,
                    currentDashboard: asset.dashboard || {},
                    error,
                    showActivateAssetModal: false,
                    showEditAssetModal: !!edit,
                    showValidateAssetModal: false,
                    templateDashboards,
                    widgets: Array.isArray(asset.gtemplate?.widgets) ? asset.gtemplate.widgets : []
                }));
            if (asset.orgID !== currentOrg._id) {
                authService.setCurrentOrgID(asset.orgID);
                setCurrentOrg();
            }
            socket?.on?.(`realtime:${assetID}:${(0, _staticUUIDs.CONNECT_DISCONNECT_ID)}`, handleConnectivityUpdate);
            if (edit === false) dashboardRef.current?.fetchWidgetData({
                dashboardID: asset?.dashboard?._id,
                widgets: asset?.gtemplate?.widgets || []
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const { message = "" } = err.response?.data ?? err;
            const error = message.concat(props.socketConnectError ? "\n" : "", props.socketConnectError);
            updateState((prevState)=>({
                    ...prevState,
                    assetLoading: false,
                    error
                }));
        }
    }, [
        alertService,
        assetGroupService,
        assetID,
        assetService,
        assetUtils,
        authService,
        currentOrg._id,
        currentOrgID,
        dmAlertService,
        handleConnectivityUpdate,
        props.socketConnectError,
        setCurrentOrg,
        socket,
        source.token,
        templateDashboardService
    ]);
    const cancelGatewaySwap = (0, _react.useCallback)(async (provisionID)=>{
        try {
            await assetService.deleteProvisionRequest(provisionID);
            updateState((prevState)=>{
                const asset = {
                    ...prevState.asset,
                    mac: "",
                    provision: null
                };
                return {
                    ...prevState,
                    asset
                };
            });
            updateAlertState((prevState)=>({
                    ...prevState,
                    alertColor: "cyan-blue",
                    alertMessage: "Gateway Swap Cancelled",
                    alertText: "text-white",
                    flexColumn: false,
                    showAlert: true
                }));
            _alertTimeout();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    }, [
        _alertTimeout,
        assetService
    ]), handleActivateAssetSuccess = (0, _react.useCallback)(async (activatedAsset)=>{
        updateState((prevState)=>({
                ...prevState,
                assetLoading: true
            }));
        await fetchAsset();
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "alert-confirmation",
                alertMessage: `${activatedAsset.nickname} Successfully Activated!`,
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout,
        fetchAsset
    ]), handleAssetWasMoved = (0, _react.useCallback)(({ nickname, orgID } = {})=>{
        const newOrgName = orgsMap[orgID] ? ` to ${orgsMap[orgID].name}` : "";
        const assetMovedMessage = `${nickname || "Asset"} successfully moved${newOrgName}`;
        history.push({
            pathname: "/organization/assets",
            state: {
                assetMovedMessage
            }
        });
    }, [
        history,
        orgsMap
    ]), handleCommandExecutedFromWidget = (0, _react.useCallback)((commandName)=>{
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "cyan-blue",
                alertMessage: `${commandName} Command Executed`,
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout
    ]), handleGatewaySwap = (0, _react.useCallback)((assetUpdate)=>{
        updateState((prevState)=>({
                ...prevState,
                asset: {
                    ...prevState.asset,
                    ...assetUpdate
                },
                showGatewaySwapModal: false
            }));
    }, []), handleOutputSignalRerunSuccess = (0, _react.useCallback)(()=>{
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "alert-confirmation",
                alertMessage: "Success - This action can take several minutes. Check back on the Dashboard for the Calculated Signals",
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        updateState((prevState)=>({
                ...prevState,
                showRerunOutputSignalsModal: false
            }));
        _alertTimeout();
    }, [
        _alertTimeout
    ]), handleSubscriptionAlert = (0, _react.useCallback)((action)=>{
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: action === "Added" ? "cyan-blue" : "active-dm",
                alertMessage: `Subscription ${action}`,
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout
    ]), handleTagsChange = (0, _react.useCallback)((tags)=>{
        updateState((prevState)=>({
                ...prevState,
                asset: {
                    ...prevState.asset,
                    tags
                }
            }));
    }, []), handleValidateAssetSuccess = (0, _react.useCallback)(async ()=>{
        updateState((prevState)=>({
                ...prevState,
                assetLoading: true
            }));
        await fetchAsset();
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "alert-confirmation",
                alertMessage: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0",
                                children: "Validation Process has kicked off"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0",
                                children: "Asset will automatically revert back to Provisioning Model after 4 hours"
                            })
                        ]
                    }),
                alertText: "text-white",
                flexColumn: true,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout,
        fetchAsset
    ]), handleXirgoCertUpdated = (0, _react.useCallback)(()=>{
        toggleNewCertificateModal(false);
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "cyan-blue",
                alertMessage: "Certificate Updated",
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout
    ]), showCompleteMaintenanceSuccessAlert = (0, _react.useCallback)(()=>{
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "cyan-blue",
                alertMessage: "Maintenance Completed Successfully",
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout
    ]), showUpdateMaintenanceServiceValuesSuccessAlert = (0, _react.useCallback)(()=>{
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "cyan-blue",
                alertMessage: "Maintenance Service Values Updated Successfully",
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout
    ]), updateAsset = (0, _react.useCallback)((update = {})=>{
        updateState((prevState)=>{
            const asset = {
                ...(0, _mergeDefault.default)(prevState.asset, update),
                settings: update.settings
            };
            return {
                ...prevState,
                asset,
                showEditAssetModal: false
            };
        });
    }, []);
    const handleAddUsersSave = (0, _react.useCallback)(async (users)=>{
        const currentDashboard = await templateDashboardService.updateTemplateDashboard(state.asset?.gtemplateID, state.currentDashboard?._id, {
            ...state.currentDashboard,
            users
        }, source.token);
        updateState((prevState)=>({
                ...prevState,
                currentDashboard,
                showAddUsersModal: false
            }));
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "cyan-blue",
                alertMessage: "Users for Private Dashboard updated",
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout,
        source.token,
        state.asset?.gtemplateID,
        state.currentDashboard,
        templateDashboardService
    ]), handleChangeCurrentDashboard = (0, _react.useCallback)((dashboard)=>{
        updateState((prevState)=>({
                ...prevState,
                currentDashboard: dashboard || {},
                showViewTemplateDashboardsModal: false,
                widgets: dashboard?.widgets || []
            }));
        dashboardRef.current?.fetchWidgetData({
            dashboardID: dashboard._id,
            widgets: dashboard.widgets || []
        });
    }, []), handleDashboardCreated = (0, _react.useCallback)((dashboard)=>{
        updateState((prevState)=>{
            const templateDashboards = prevState.templateDashboards.concat(dashboard);
            dashboardRef?.current?.fetchWidgetData({
                dashboardID: dashboard?._id,
                widgets: dashboard?.widgets || []
            });
            return {
                ...prevState,
                currentDashboard: dashboard,
                showCreateDashboardModal: false,
                templateDashboards,
                widgets: dashboard?.widgets || []
            };
        });
    }, []), handleEditDashboardSave = (0, _react.useCallback)(async ({ isPrivate, isUserPreference, name })=>{
        const updateDashboardRequest = templateDashboardService.updateTemplateDashboard(state.asset?.gtemplateID, state.currentDashboard?._id, {
            name,
            isPrivate
        }, source.token);
        let updateUserPreferenceRequest = Promise.resolve();
        if (isUserPreference) updateUserPreferenceRequest = templateDashboardService.setUserDefaultDashboard(assetID, {
            dashboardID: state.currentDashboard?._id
        }, source.token);
        await Promise.all([
            updateDashboardRequest,
            updateUserPreferenceRequest
        ]); // error handled in modal
        updateState((prevState)=>({
                ...prevState,
                currentDashboard: {
                    ...prevState.currentDashboard,
                    isPrivate,
                    name
                },
                showEditDashboardModal: false
            }));
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "cyan-blue",
                alertMessage: "Dashboard updated",
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout,
        assetID,
        source.token,
        state.asset?.gtemplateID,
        state.currentDashboard?._id,
        templateDashboardService
    ]), handleSetDashboardAsDefault = (0, _react.useCallback)(async ()=>{
        try {
            await templateDashboardService.setUserDefaultDashboard(state.asset?._id, {
                dashboardID: state.currentDashboard._id
            }, source.token);
            updateAlertState((prevState)=>({
                    ...prevState,
                    alertColor: "cyan-blue",
                    alertMessage: "Dashboard set as default",
                    alertText: "text-white",
                    flexColumn: false,
                    showAlert: true
                }));
            _alertTimeout();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    }, [
        _alertTimeout,
        source.token,
        state.asset?._id,
        state.currentDashboard?._id,
        templateDashboardService
    ]), handleTemplateDashboardDeleted = (0, _react.useCallback)((dashboardID)=>{
        updateState((prevState)=>{
            const templateDashboards = prevState.templateDashboards.filter(({ _id })=>dashboardID !== _id);
            const currentDashboard = templateDashboards.find(({ isDefault })=>isDefault);
            dashboardRef.current?.fetchWidgetData({
                dashboardID: currentDashboard?._id,
                widgets: currentDashboard?.widgets || []
            });
            return {
                ...prevState,
                currentDashboard,
                showDeleteDashboardModal: false,
                templateDashboards,
                widgets: currentDashboard?.widgets || []
            };
        });
    }, []);
    const handleWidgetAdded = (0, _react.useCallback)((widgets)=>{
        updateState((prevState)=>{
            const templateDashboards = prevState.templateDashboards.map((t)=>{
                if (t._id !== prevState.currentDashboard._id) return t;
                return {
                    ...t,
                    widgets
                };
            });
            const currentDashboard = {
                ...prevState.currentDashboard,
                widgets
            };
            dashboardRef?.current?.fetchWidgetData({
                widgets
            });
            return {
                ...prevState,
                currentDashboard,
                showCreateWidgetModal: false,
                templateDashboards,
                widgets
            };
        });
    }, []), handleWidgetDeleted = (0, _react.useCallback)((widgetID)=>{
        updateState((prevState)=>{
            const widgets = prevState.widgets.filter(({ _id })=>widgetID !== _id);
            const currentDashboard = {
                ...prevState.currentDashboard,
                widgets
            };
            dashboardRef?.current?.fetchWidgetData({
                widgets
            });
            return {
                ...prevState,
                currentDashboard,
                widgets
            };
        });
    }, []), handleWidgetUpdated = (0, _react.useCallback)((widgets)=>{
        updateState((prevState)=>{
            const currentDashboard = {
                ...prevState.currentDashboard,
                widgets
            };
            dashboardRef?.current?.fetchWidgetData({
                widgets
            });
            return {
                ...prevState,
                currentDashboard,
                widgets
            };
        });
    }, []), handleWidgetsUpdate = (0, _react.useCallback)((widgets)=>{
        updateState((prevState)=>({
                ...prevState,
                widgets
            }));
    }, []);
    const toggleActivateAssetModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showActivateAssetModal: !prevState.showActivateAssetModal
            }));
    }, []), toggleAddUsersModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showAddUsersModal: !prevState.showAddUsersModal
            }));
    }, []), toggleCreateDashboardModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showCreateDashboardModal: !prevState.showCreateDashboardModal
            }));
    }, []), toggleCreateWidgetModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showCreateWidgetModal: !prevState.showCreateWidgetModal
            }));
    }, []), toggleDeleteDashboardModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showDeleteDashboardModal: !prevState.showDeleteDashboardModal
            }));
    }, []), toggleEditDashboardModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showEditDashboardModal: !prevState.showEditDashboardModal
            }));
    }, []), toggleGatewaySwapModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showGatewaySwapModal: !prevState.showGatewaySwapModal
            }));
    }, []), toggleRerunOutputSignalsModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showRerunOutputSignalsModal: !prevState.showRerunOutputSignalsModal
            }));
    }, []), toggleShowEditAssetModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showEditAssetModal: !prevState.showEditAssetModal
            }));
    }, []), toggleValidateAssetModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showValidateAssetModal: !prevState.showValidateAssetModal
            }));
    }, []), toggleViewTemplateDashboardsModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showViewTemplateDashboardsModal: !prevState.showViewTemplateDashboardsModal
            }));
    }, []);
    const updateActiveAlertCount = (0, _react.useCallback)((activeAlertCount)=>{
        updateState((prevState)=>({
                ...prevState,
                activeAlertCount
            }));
    }, []);
    (0, _react.useEffect)(()=>{
        if (!state.error || alertState.showAlert) return;
        updateAlertState((prevState)=>({
                ...prevState,
                alertColor: "active-dm",
                alertMessage: state.error,
                alertText: "text-white",
                flexColumn: false,
                showAlert: true
            }));
        _alertTimeout();
    }, [
        _alertTimeout,
        alertState.showAlert,
        state.error
    ]);
    (0, _react.useEffect)(()=>{
        const { edit } = (0, _queryStringDefault.default).parse(search);
        fetchAsset(edit);
        return ()=>{
            window.clearTimeout(alertTimeout);
            source.cancel();
        };
    }, []);
    (0, _react.useEffect)(()=>{
        showMobileTabLinksModal && toggleMobileTabLinksModal(false);
    }, [
        tab
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-1046242580 position-absolute h-100 w-100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Alert), {
                className: `${alertClass} position-fixed w-75 border-0`,
                closeClassName: alertState.alertText,
                color: alertState.alertColor,
                isOpen: alertState.showAlert,
                toggle: toggleAlert,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-1046242580 " + `d-flex ${alertState.flexColumn ? "flex-column" : ""} align-items-center justify-content-center ${alertState.alertText}`,
                    children: typeof alertState.alertMessage === "function" ? alertState.alertMessage() : alertState.alertMessage
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-1046242580 h-100 w-100 d-flex flex-column bg-background-gray pt-2 px-2 p-md-3 py-lg-4 px-lg-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1046242580 main-section-container flex-fill",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1046242580 page-info-container d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1046242580 back-button-container mr-3 mr-md-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/organization/assets",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "jsx-1046242580 fa-layers fa-fw three-quarter-text circle",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "jsx-1046242580 arrow-state",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                            icon: (0, _freeSolidSvgIcons.faArrowLeft),
                                                            size: "lg",
                                                            style: {
                                                                left: 6
                                                            },
                                                            className: "text-muted"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "jsx-1046242580 arrow-state-hover",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                icon: (0, _freeSolidSvgIcons.faCircle),
                                                                color: "white",
                                                                size: "2x"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                icon: (0, _freeSolidSvgIcons.faArrowLeft),
                                                                size: "lg",
                                                                style: {
                                                                    left: 6
                                                                },
                                                                className: "text-muted"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1046242580 d-none d-lg-block ml-lg-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AssetImage, {
                                            profileImage: state.asset?.gtemplate?.profileImage ?? ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1046242580",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faCircle),
                                            className: `ml-md-3 text-${state.connectivity === "deviceConnect" ? "device-connected-green" : "icon-link-gray"}`,
                                            size: "xs"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-1046242580 flex-grow-1 ml-2 d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                                className: "jsx-1046242580 mb-0 font-weight-bold",
                                                children: state.asset?.nickname || "Asset Details"
                                            }),
                                            state.asset?.needsNewConfig ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                "data-for": "templateSyncIcon",
                                                "data-tip": "Sync in Progress. Please ensure device is online.",
                                                className: "jsx-1046242580 ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        color: "var(--brand-primary)",
                                                        icon: (0, _freeSolidSvgIcons.faSyncAlt)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                        id: "templateSyncIcon"
                                                    })
                                                ]
                                            }) : null,
                                            state.asset?.provision ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                "data-for": "assetSwap",
                                                "data-tip": "Waiting for Gateway Swap",
                                                className: "jsx-1046242580 ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        icon: (0, _freeSolidSvgIcons.faRetweet)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                        arrowColor: "#fff",
                                                        className: "bg-white rounded-lg shadow border border-icon-link-gray",
                                                        id: "assetSwap",
                                                        textColor: "var(--brand-primary)"
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    isRestrictedAssetForCommands ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1046242580 execute-button-container d-flex justify-content-end mr-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                            data: {
                                                assetRemote: state.asset?.remote
                                            },
                                            no: ()=>null,
                                            orgID: state.asset?.orgID,
                                            perform: (0, _rbac.REMOTE_EXECUTE),
                                            resource: (0, _rbac.REMOTE),
                                            yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RestrictedCommandsButton, {
                                                    showExecuteCommandModal: showExecuteCommandModal,
                                                    toggleExecuteCommandModal: toggleExecuteCommandModal
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1046242580 settings-button-container d-flex justify-content-end",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                            no: (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RestrictedSettings, {
                                                    handleSetDashboardAsDefault: handleSetDashboardAsDefault,
                                                    isDisabled: true,
                                                    orgID: state.asset?.orgID,
                                                    tab: tab,
                                                    tooltipData: data
                                                }),
                                            orgID: state.asset?.orgID,
                                            perform: (0, _rbac.ASSET_UPDATE),
                                            resource: (0, _rbac.CORE),
                                            yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RestrictedSettings, {
                                                    cancelGatewaySwap: cancelGatewaySwap,
                                                    handleSetDashboardAsDefault: handleSetDashboardAsDefault,
                                                    hasDefaultTemplate: (0, _staticUUIDs.PROVISION_MODEL_ID_SET).has(state.asset?.gtemplateID),
                                                    orgID: state.asset?.orgID,
                                                    provision: state.asset?.provision,
                                                    showDeleteAssetModal: showDeleteAssetModal,
                                                    showMoveAssetModal: showMoveAssetModal,
                                                    showNewCertificateModal: showNewCertificateModal,
                                                    tab: tab,
                                                    toggleActivateAssetModal: toggleActivateAssetModal,
                                                    toggleDeleteAssetModal: toggleDeleteAssetModal,
                                                    toggleGatewaySwapModal: toggleGatewaySwapModal,
                                                    toggleMoveAssetModal: toggleMoveAssetModal,
                                                    toggleNewCertificateModal: toggleNewCertificateModal,
                                                    toggleRerunOutputSignalsModal: toggleRerunOutputSignalsModal,
                                                    toggleShowEditAssetModal: toggleShowEditAssetModal,
                                                    toggleValidateAssetModal: toggleValidateAssetModal,
                                                    vendor: state.asset?.vendor
                                                })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1046242580 page-nav-container d-none d-lg-flex flex-lg-column justify-content-lg-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                        className: "jsx-1046242580 nav",
                                        children: tabLinks.filter(([tabName])=>{
                                            switch(true){
                                                case state.asset?.format !== "json" && tabName === (0, _asset.VALIDATION_ERRORS):
                                                    return false;
                                                case isRestrictedAssetForCommands && [
                                                    (0, _asset.COMMAND_HISTORY)
                                                ].includes(tabName):
                                                    return false;
                                                case isRestrictedAssetForDM1Tab && [
                                                    (0, _asset.DM1_FAULTS)
                                                ].includes(tabName):
                                                    return false;
                                                default:
                                                    return true;
                                            }
                                        }).map(([tabName, displayName])=>{
                                            switch(tabName){
                                                case 0, _asset.COMMAND_HISTORY:
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                                        no: ()=>null,
                                                        orgID: state.asset?.orgID,
                                                        perform: (0, _rbac.REMOTE_READ),
                                                        resource: (0, _rbac.REMOTE),
                                                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DesktopNavTabLink, {
                                                                displayName: displayName,
                                                                handleTabChange: handleTabChange,
                                                                isActive: tab === tabName,
                                                                tabName: tabName
                                                            }, tabName)
                                                    }, tabName);
                                                case 0, _asset.MAINTENANCE:
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                                        no: ()=>null,
                                                        orgID: state.asset?.orgID,
                                                        perform: (0, _rbac.MAINTENANCE_READ),
                                                        resource: (0, _rbac.MAINTENANCE),
                                                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DesktopNavTabLink, {
                                                                displayName: displayName,
                                                                handleTabChange: handleTabChange,
                                                                isActive: tab === tabName,
                                                                tabName: tabName
                                                            }, tabName)
                                                    }, tabName);
                                                default:
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DesktopNavTabLink, {
                                                        activeAlertCount: state.activeAlertCount,
                                                        activeDmAlertCount: state.activeDmAlertCount,
                                                        displayName: displayName,
                                                        handleTabChange: handleTabChange,
                                                        isActive: tab === tabName,
                                                        tabName: tabName
                                                    }, tabName);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            height: "1px"
                                        },
                                        className: "jsx-1046242580 w-100 mb-3 bg-third-gray"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1046242580 main-page-content position-relative",
                                children: {
                                    [(0, _asset.ALERTS)]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetAlarmsTabContainerDefault.default), {
                                        ...props,
                                        asset: state.asset,
                                        updateActiveAlertCount: updateActiveAlertCount
                                    }),
                                    [(0, _asset.COMMAND_HISTORY)]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetCommandHistoryContainerDefault.default), {
                                        ...props,
                                        asset: state.asset,
                                        commandExecuted: commandExecuted,
                                        toggleCommandExecuted: ()=>toggleCommandExecuted(!commandExecuted)
                                    }),
                                    [(0, _asset.DASHBOARD)]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
                                        children: state.assetLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-1046242580 align-items-center d-flex h-100 justify-content-center w-100",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                color: "var(--brand-primary)",
                                                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                size: "3x",
                                                spin: true
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDashboardContainerDefault.default), {
                                            ...state,
                                            handleAddUsersSave: handleAddUsersSave,
                                            handleChangeCurrentDashboard: handleChangeCurrentDashboard,
                                            handleCommandExecutedFromWidget: handleCommandExecutedFromWidget,
                                            handleDashboardCreated: handleDashboardCreated,
                                            handleEditDashboardSave: handleEditDashboardSave,
                                            handleTemplateDashboardDeleted: handleTemplateDashboardDeleted,
                                            handleWidgetAdded: handleWidgetAdded,
                                            handleWidgetDeleted: handleWidgetDeleted,
                                            handleWidgetUpdated: handleWidgetUpdated,
                                            handleWidgetsUpdate: handleWidgetsUpdate,
                                            ref: dashboardRef,
                                            toggleAddUsersModal: toggleAddUsersModal,
                                            toggleCreateDashboardModal: toggleCreateDashboardModal,
                                            toggleCreateWidgetModal: toggleCreateWidgetModal,
                                            toggleDeleteDashboardModal: toggleDeleteDashboardModal,
                                            toggleEditDashboardModal: toggleEditDashboardModal,
                                            toggleViewTemplateDashboardsModal: toggleViewTemplateDashboardsModal
                                        })
                                    }),
                                    [(0, _asset.DETAILS)]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDetailsTabContainerDefault.default), {
                                        ...props,
                                        asset: state.asset,
                                        assetGroups: state.assetGroups,
                                        currentUser: currentUser,
                                        isRestrictedAssetForOtherThings: isRestrictedAssetForOtherThings,
                                        otaHiddenForEdge: otaHiddenForEdge
                                    }),
                                    [(0, _asset.DM1_FAULTS)]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDM1FaultsContainerDefault.default), {
                                        ...props,
                                        asset: state.asset
                                    }),
                                    [(0, _rbac.MAINTENANCE)]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetMaintenanceContainerDefault.default), {
                                        asset: state.asset
                                    }),
                                    [(0, _asset.SUBSCRIPTIONS)]: !(0, _isEmptyDefault.default)(state.asset) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetSubscriptionsContainerDefault.default), {
                                        ...props,
                                        asset: state.asset,
                                        handleSubscriptionAlert: handleSubscriptionAlert
                                    }) : null,
                                    [(0, _asset.VALIDATION_ERRORS)]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetValidationErrorsContainerDefault.default), {
                                        ...props,
                                        asset: state.asset
                                    }),
                                    [(0, _asset.V2_MAINTENANCE)]: state.asset?._id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetV2MaintenanceTabContainerDefault.default), {
                                        ...props,
                                        ...state,
                                        showCompleteMaintenanceSuccessAlert: showCompleteMaintenanceSuccessAlert,
                                        showUpdateMaintenanceServiceValuesSuccessAlert: showUpdateMaintenanceServiceValuesSuccessAlert
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircleDefault.default), {
                                        size: "3x"
                                    })
                                }[tab]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1046242580 d-flex justify-content-around align-items-center d-lg-none bg-white shadow-lg mx-n2 py-1",
                        children: [
                            tabLinks.slice(0, 4).map(([tabName, displayName, icon])=>tabName === (0, _asset.MAINTENANCE) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                    no: ()=>null,
                                    orgID: state.asset?.orgID,
                                    perform: (0, _rbac.MAINTENANCE_READ),
                                    resource: (0, _rbac.MAINTENANCE),
                                    yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            onClick: ()=>handleTabChange(tabName),
                                            style: {
                                                color: `var(--${tab === tabName && !showMobileTabLinksModal ? "brand-primary" : "text-lighter"})`
                                            },
                                            className: "jsx-1046242580 position-relative btn btn-link d-flex flex-column px-0 align-items-center three-quarter-text text-decoration-none",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: icon
                                                }),
                                                displayName
                                            ]
                                        }, `${tabName}:${displayName}`)
                                }, `${tabName}:${displayName}`) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    onClick: ()=>handleTabChange(tabName),
                                    style: {
                                        color: `var(--${tab === tabName && !showMobileTabLinksModal ? "brand-primary" : "text-lighter"})`
                                    },
                                    className: "jsx-1046242580 position-relative btn btn-link d-flex flex-column px-0 align-items-center three-quarter-text text-decoration-none",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: icon
                                        }),
                                        displayName,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActiveAlertBadge, {
                                            activeAlertCount: state.activeAlertCount,
                                            activeDmAlertCount: state.activeDmAlertCount,
                                            mobile: true,
                                            tab: tabName
                                        })
                                    ]
                                }, `${tabName}:${displayName}`)),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: ()=>toggleMobileTabLinksModal(!showMobileTabLinksModal),
                                style: {
                                    color: `var(--${showMobileTabLinksModal ? "brand-primary" : "text-lighter"})`
                                },
                                className: "jsx-1046242580 btn btn-link d-flex flex-column px-0 align-items-center three-quarter-text text-decoration-none",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faEllipsisH)
                                    }),
                                    "More"
                                ]
                            })
                        ]
                    })
                ]
            }),
            state.showActivateAssetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activateAssetModalDefault.default), {
                asset: state.asset,
                handleActivateAssetSuccess: handleActivateAssetSuccess,
                isOpen: state.showActivateAssetModal,
                toggleModal: toggleActivateAssetModal
            }) : null,
            showExecuteCommandModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _executeCommandModalContainerDefault.default), {
                asset: state.asset,
                isOpen: showExecuteCommandModal,
                toggleCommandExecuted: ()=>toggleCommandExecuted(!commandExecuted),
                toggleModal: ()=>toggleExecuteCommandModal(!showExecuteCommandModal)
            }) : null,
            showMoveAssetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateCurrentOrgContext.UpdateCurrentOrgConsumer), {
                children: (updateCurrentOrg)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveAssetModalDefault.default), {
                        currentOrg: currentOrg,
                        isOpen: showMoveAssetModal,
                        handleAssetWasMoved: handleAssetWasMoved,
                        selectedAsset: state.asset,
                        toggleModal: ()=>toggleMoveAssetModal(!showMoveAssetModal),
                        updateCurrentOrg: updateCurrentOrg
                    })
            }) : null,
            state.showEditAssetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateTagsContext.UpdateTagsProvider), {
                value: handleTagsChange,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editAssetModalDefault.default), {
                    asset: state.asset,
                    isOpen: state.showEditAssetModal,
                    refreshAsset: fetchAsset,
                    toggle: toggleShowEditAssetModal,
                    updateAsset: updateAsset
                })
            }) : null,
            showDeleteAssetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteAssetModalDefault.default), {
                isOpen: showDeleteAssetModal,
                toggleModal: ()=>toggleDeleteAssetModal(!showDeleteAssetModal),
                assetToDelete: state.asset,
                handleSubtractAsset: handleSubtractAssetAction
            }) : null,
            showNewCertificateModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newCertificateModalContainerDefault.default), {
                asset: state.asset,
                handleXirgoCertUpdated: handleXirgoCertUpdated,
                isOpen: showNewCertificateModal,
                toggleModal: ()=>toggleNewCertificateModal(!showNewCertificateModal)
            }) : null,
            showMobileTabLinksModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileTabLinksModalDefault.default), {
                assetFormat: state.asset?.format,
                handleTabChange: handleTabChange,
                isOpen: showMobileTabLinksModal,
                tab: tab,
                toggleModal: ()=>toggleMobileTabLinksModal(!showMobileTabLinksModal)
            }) : null,
            state.showRerunOutputSignalsModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rerunOutputSignalsModalDefault.default), {
                handleOutputSignalRerunSuccess: handleOutputSignalRerunSuccess,
                isOpen: state.showRerunOutputSignalsModal,
                toggleModal: toggleRerunOutputSignalsModal
            }) : null,
            state.showGatewaySwapModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gatewaySwapModalDefault.default), {
                asset: state.asset,
                handleGatewaySwap: handleGatewaySwap,
                isOpen: state.showGatewaySwapModal,
                toggleModal: toggleGatewaySwapModal
            }) : null,
            state.showValidateAssetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validateAssetModalDefault.default), {
                asset: state.asset,
                handleValidateAssetSuccess: handleValidateAssetSuccess,
                isOpen: state.showValidateAssetModal,
                toggleModal: toggleValidateAssetModal
            }) : null,
            alertStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1046242580",
                children: ".main-section-container.jsx-1046242580{display:grid;grid-template-columns:1fr;grid-template-rows:35px auto;grid-template-areas:'page-info' 'main-page-content';}.page-info-container.jsx-1046242580{grid-area:page-info;}.main-page-content.jsx-1046242580{grid-area:main-page-content;}.back-button-container.jsx-1046242580{grid-area:back-button;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;}.btn.jsx-1046242580:focus{box-shadow:none;}@media (min-width:992px){.main-section-container.jsx-1046242580{grid-template-rows:30px 60px minmax(auto,auto);grid-template-areas: 'desktop-page-info' 'desktop-tab-nav' 'desktop-main-content';}.page-info-container.jsx-1046242580{grid-area:desktop-page-info;}.page-nav-container.jsx-1046242580{grid-area:desktop-tab-nav;}.main-page-content.jsx-1046242580{grid-area:desktop-main-content;}}"
            })
        ]
    });
}
AssetDetailsLayout.propTypes = {
    socketConnectError: (0, _propTypesDefault.default).string
};
// display components
function AssetImage({ profileImage }) {
    const { missingImage } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactImage.Img), {
        className: "img-fluid mh-100",
        container: (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    maxWidth: 30
                },
                children: children
            }),
        src: [
            profileImage,
            missingImage
        ]
    });
}
AssetImage.propTypes = {
    profileImage: (0, _propTypesDefault.default).string
};
function DesktopNavTabLink(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
        className: "jsx-2158186770 " + `${props.isActive ? "active-tab" : "inactive-tab"} nav-item`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                onClick: ()=>props.handleTabChange(props.tabName),
                className: "jsx-2158186770 btn btn-link three-quarter-text text-decoration-none",
                children: [
                    props.displayName,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActiveAlertBadge, {
                        activeAlertCount: props.activeAlertCount,
                        activeDmAlertCount: props.activeDmAlertCount,
                        tab: props.tabName
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2158186770",
                children: ".active-tab.jsx-2158186770{border-bottom:3px solid var(--brand-primary);}.active-tab.jsx-2158186770 button.jsx-2158186770{color:var(--text-muted);font-size:0.8rem !important;font-weight:500 !important;}.btn.jsx-2158186770:focus{box-shadow:none;}.inactive-tab.jsx-2158186770 button.jsx-2158186770{font-weight:400;color:var(--muted-gray);font-size:0.8rem;}.inactive-tab.jsx-2158186770 button.jsx-2158186770:hover{color:var(--text-muted);}"
            })
        ]
    }, props.tabName);
}
DesktopNavTabLink.propTypes = {
    activeAlertCount: (0, _propTypesDefault.default).number,
    activeDmAlertCount: (0, _propTypesDefault.default).number,
    displayName: (0, _propTypesDefault.default).string,
    handleTabChange: (0, _propTypesDefault.default).func,
    isActive: (0, _propTypesDefault.default).bool,
    tabName: (0, _propTypesDefault.default).string
};
function RestrictedCommandsButton({ isDisabled, showExecuteCommandModal, toggleExecuteCommandModal }) {
    const conditionallyDisabled = isDisabled ? {
        disabled: true
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        ...conditionallyDisabled,
        className: "btn modal-button-primary three-quarter-text p-1 py-md-0 px-md-4",
        onClick: ()=>toggleExecuteCommandModal(!showExecuteCommandModal),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-reset d-none d-md-inline",
                children: "Execute"
            }),
            " Command"
        ]
    });
}
RestrictedCommandsButton.propTypes = {
    isDisabled: (0, _propTypesDefault.default).bool,
    showExecuteCommandModal: (0, _propTypesDefault.default).bool,
    toggleExecuteCommandModal: (0, _propTypesDefault.default).func
};
function RestrictedSettings(props) {
    const { className: settingsClass, styles: settingsStyles } = {
        styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
            id: "662170114",
            children: "button.jsx-662170114:hover{color:white !important;background-color:#6c757d !important;}"
        }),
        className: "jsx-662170114"
    };
    const { className: dropdownClass, styles: dropdownStyles } = {
        styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
            id: "189252835",
            children: ".dropdown-menu.jsx-189252835{border-radius:1rem;z-index:1050;}"
        }),
        className: "jsx-189252835"
    };
    const { className: dropdownItemClass, styles: dropdownItemStyles } = {
        styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
            id: "3602371267",
            children: "button.jsx-3602371267{font-size:0.8rem;cursor:pointer;box-shadow:none;outline:none;color:var(--text-muted);}button.jsx-3602371267:hover{background-color:transparent;}"
        }),
        className: "jsx-3602371267"
    };
    const conditionallyDisabled = props.isDisabled ? {
        disabled: true
    } : {};
    const conditionalTooltip = props.isDisabled ? {
        ["data-for"]: "assetSettings",
        ["data-tip"]: props.tooltipData
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownToggle), {
                ...conditionalTooltip,
                color: "outline-secondary",
                className: `p-1 py-md-0 px-md-4 ${settingsClass} bg-white three-quarter-text shadow-none`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCogs),
                        className: "d-md-none"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "d-none d-md-inline",
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                        id: "assetSettings"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                right: true,
                className: `${dropdownClass} shadow`,
                children: [
                    !props.isDisabled && props.hasDefaultTemplate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        className: dropdownItemClass,
                        onClick: props.toggleActivateAssetModal,
                        children: "Activate Asset"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        ...conditionallyDisabled,
                        className: dropdownItemClass,
                        onClick: ()=>props.toggleMoveAssetModal(!props.showMoveAssetModal),
                        children: "Move"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        ...conditionallyDisabled,
                        className: dropdownItemClass,
                        onClick: props.toggleShowEditAssetModal,
                        children: "Edit"
                    }),
                    ![
                        "1"
                    ].includes(props.vendor) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: props.orgID,
                        perform: (0, _rbac.PROVISION_UPDATE),
                        resource: (0, _rbac.PROVISION),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                className: dropdownItemClass,
                                onClick: ()=>props.toggleNewCertificateModal(!props.showNewCertificateModal),
                                children: "New Certificate"
                            })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        className: props.tab !== (0, _asset.DASHBOARD) ? "d-none" : dropdownItemClass,
                        onClick: props.handleSetDashboardAsDefault,
                        children: "Set Dashboard as Default"
                    }),
                    !props.isDisabled && props.hasDefaultTemplate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        className: dropdownItemClass,
                        onClick: props.toggleValidateAssetModal,
                        children: "Validate Asset"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: props.orgID,
                        perform: (0, _rbac.PROVISION_UPDATE),
                        resource: (0, _rbac.PROVISION),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                className: props.vendor === "elevat" ? dropdownItemClass : "d-none",
                                onClick: ()=>props.provision ? props.cancelGatewaySwap(props.provision._id) : props.toggleGatewaySwapModal(),
                                children: props.provision ? "Cancel Gateway Swap" : "Swap Gateway"
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        ...conditionallyDisabled,
                        className: dropdownItemClass,
                        onClick: props.toggleRerunOutputSignalsModal,
                        children: "Rerun Calculated Signals"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                        ...conditionallyDisabled,
                        className: `${dropdownItemClass} text-danger`,
                        onClick: ()=>props.toggleDeleteAssetModal(!props.showDeleteAssetModal),
                        children: "Delete"
                    })
                ]
            }),
            dropdownItemStyles,
            dropdownStyles,
            settingsStyles
        ]
    });
}
RestrictedSettings.propTypes = {
    cancelGatewaySwap: (0, _propTypesDefault.default).func,
    handleSetDashboardAsDefault: (0, _propTypesDefault.default).func,
    hasDefaultTemplate: (0, _propTypesDefault.default).bool,
    isDisabled: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    provision: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string
    }),
    showDeleteAssetModal: (0, _propTypesDefault.default).bool,
    showMoveAssetModal: (0, _propTypesDefault.default).bool,
    showNewCertificateModal: (0, _propTypesDefault.default).bool,
    tab: (0, _propTypesDefault.default).string,
    toggleActivateAssetModal: (0, _propTypesDefault.default).func,
    toggleDeleteAssetModal: (0, _propTypesDefault.default).func,
    toggleGatewaySwapModal: (0, _propTypesDefault.default).func,
    toggleMoveAssetModal: (0, _propTypesDefault.default).func,
    toggleNewCertificateModal: (0, _propTypesDefault.default).func,
    toggleRerunOutputSignalsModal: (0, _propTypesDefault.default).func,
    toggleShowEditAssetModal: (0, _propTypesDefault.default).func,
    toggleValidateAssetModal: (0, _propTypesDefault.default).func,
    tooltipData: (0, _propTypesDefault.default).string,
    vendor: (0, _propTypesDefault.default).oneOf([
        "1",
        "elevat",
        (0, _vendors.XIRGO_V1_VENDOR_ID),
        (0, _vendors.XIRGO_V2_VENDOR_ID),
        (0, _vendors.EPEC_6200_VENDOR_ID),
        (0, _vendors.ACTIA_ACU6_VENDOR_ID)
    ])
};
function ActiveAlertBadge({ activeAlertCount, activeDmAlertCount, mobile, tab }) {
    const mobileStyle = mobile ? {
        right: "-0.25rem"
    } : {};
    switch(true){
        case ![
            (0, _asset.ALERTS),
            (0, _asset.DM1_FAULTS)
        ].includes(tab):
            return null;
        case tab === (0, _asset.ALERTS) && !activeAlertCount:
        case tab === (0, _asset.DM1_FAULTS) && !activeDmAlertCount:
            return null;
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `badge badge-danger ml-1 ${mobile ? "position-absolute" : ""}`,
                style: mobileStyle,
                children: tab === (0, _asset.ALERTS) ? activeAlertCount : activeDmAlertCount
            });
    }
}
ActiveAlertBadge.propTypes = {
    activeAlertCount: (0, _propTypesDefault.default).number,
    activeDmAlertCount: (0, _propTypesDefault.default).number,
    mobile: (0, _propTypesDefault.default).bool,
    tab: (0, _propTypesDefault.default).string
};
function checkAssetVendorForCommands(asset = {}) {
    if (!Object.keys(asset).length) return true;
    return [
        "1"
    ].includes(asset?.vendor);
}
function checkAssetVendorForOtherThings(asset = {}) {
    if (!Object.keys(asset).length) return true;
    return [
        "1",
        (0, _vendors.XIRGO_V1_VENDOR_ID),
        (0, _vendors.XIRGO_V2_VENDOR_ID)
    ].includes(asset?.vendor);
}
function checkOtaHiddenForEdge(asset = {}) {
    if (!Object.keys(asset).length) return true;
    return [
        (0, _vendors.EPEC_6200_VENDOR_ID),
        (0, _vendors.ACTIA_ACU6_VENDOR_ID)
    ].includes(asset?.vendor);
}
function checkAssetVendorForDM1Tab(asset = {}) {
    if (!Object.keys(asset).length) return true;
    return [
        "1",
        (0, _vendors.XIRGO_V1_VENDOR_ID)
    ].includes(asset?.vendor); // xirgo V2 now has dm1
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","reactstrap":"kjd7g","react-tooltip":"4ejwp","react-image":"d5uD5","query-string":"h6dFx","lodash/isEmpty":"6WyGC","lodash/merge":"iHC1F","../../Services/AlertService":"i23f0","../../Services/AssetGroupService":"5rDjw","../../Services/AssetService":"fL096","../../Services/AuthService":"8Bjjn","../../Services/DM1Service":"72XwI","../../Services/TemplateDashboardService":"kZyFp","../../Lib/AssetUtils":"gdVNl","../../Constants/Asset":"1OiRg","../../Constants/RBAC":"ieo1E","../../Constants/StaticUUIDs":"cpjYY","../../Constants/Vendors":"jVaXW","../../Context/CurrentOrgContext":"jQXcJ","../../Context/CurrentUserContext":"4sVVe","../../Context/IconsContext":"lzIpe","../../Context/OrgsMapContext":"asozp","../../Context/SetCurrentOrgContext":"bWsFg","../../Context/UpdateTagsContext":"jhC9G","../../Context/UpdateCurrentOrgContext":"eVyI1","../../Context/DashboardSocketContext":"ly197","../../RBAC/Can":"l4l8D","./ActivateAssetModal":"lP8X4","./AssetDetailsTabContainer":"5p77l","./AssetDashboardContainer":"TP2ny","./AssetMaintenanceContainer":"TjKme","./AssetAlarmsTabContainer":"6wYv9","./AssetDM1FaultsContainer":"asYLH","./AssetSubscriptionsContainer":"bhv9t","./AssetCommandHistoryContainer":"9mWBa","./AssetValidationErrorsContainer":"jhZsi","./AssetV2MaintenanceTabContainer":"njLMH","./DeleteAssetModal":"9MxoK","./EditAssetModal":"iJk2B","../ErrorBoundary":"e71Au","./ExecuteCommandModalContainer":"jbIPF","./GatewaySwapModal":"4RAmr","../LoadingCircle":"aIADA","./MobileTabLinksModal":"v80Rq","./MoveAssetModal":"byFgU","./NewCertificateModalContainer":"4EqvY","./RerunOutputSignalsModal":"2pplv","./ValidateAssetModal":"hqoZs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kjd7g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownContext", ()=>(0, _dropdownContext.DropdownContext));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Row", ()=>(0, _rowDefault.default));
parcelHelpers.export(exports, "Col", ()=>(0, _colDefault.default));
parcelHelpers.export(exports, "Navbar", ()=>(0, _navbarDefault.default));
parcelHelpers.export(exports, "NavbarBrand", ()=>(0, _navbarBrandDefault.default));
parcelHelpers.export(exports, "NavbarText", ()=>(0, _navbarTextDefault.default));
parcelHelpers.export(exports, "NavbarToggler", ()=>(0, _navbarTogglerDefault.default));
parcelHelpers.export(exports, "Nav", ()=>(0, _navDefault.default));
parcelHelpers.export(exports, "NavItem", ()=>(0, _navItemDefault.default));
parcelHelpers.export(exports, "NavLink", ()=>(0, _navLinkDefault.default));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbDefault.default));
parcelHelpers.export(exports, "BreadcrumbItem", ()=>(0, _breadcrumbItemDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "ButtonToggle", ()=>(0, _buttonToggleDefault.default));
parcelHelpers.export(exports, "ButtonDropdown", ()=>(0, _buttonDropdownDefault.default));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupDefault.default));
parcelHelpers.export(exports, "ButtonToolbar", ()=>(0, _buttonToolbarDefault.default));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdownDefault.default));
parcelHelpers.export(exports, "DropdownItem", ()=>(0, _dropdownItemDefault.default));
parcelHelpers.export(exports, "DropdownMenu", ()=>(0, _dropdownMenuDefault.default));
parcelHelpers.export(exports, "DropdownToggle", ()=>(0, _dropdownToggleDefault.default));
parcelHelpers.export(exports, "Fade", ()=>(0, _fadeDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "Card", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "CardGroup", ()=>(0, _cardGroupDefault.default));
parcelHelpers.export(exports, "CardDeck", ()=>(0, _cardDeckDefault.default));
parcelHelpers.export(exports, "CardColumns", ()=>(0, _cardColumnsDefault.default));
parcelHelpers.export(exports, "CardBody", ()=>(0, _cardBodyDefault.default));
parcelHelpers.export(exports, "CardLink", ()=>(0, _cardLinkDefault.default));
parcelHelpers.export(exports, "CardFooter", ()=>(0, _cardFooterDefault.default));
parcelHelpers.export(exports, "CardHeader", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "CardImg", ()=>(0, _cardImgDefault.default));
parcelHelpers.export(exports, "CardImgOverlay", ()=>(0, _cardImgOverlayDefault.default));
parcelHelpers.export(exports, "Carousel", ()=>(0, _carouselDefault.default));
parcelHelpers.export(exports, "UncontrolledCarousel", ()=>(0, _uncontrolledCarouselDefault.default));
parcelHelpers.export(exports, "CarouselControl", ()=>(0, _carouselControlDefault.default));
parcelHelpers.export(exports, "CarouselItem", ()=>(0, _carouselItemDefault.default));
parcelHelpers.export(exports, "CarouselIndicators", ()=>(0, _carouselIndicatorsDefault.default));
parcelHelpers.export(exports, "CarouselCaption", ()=>(0, _carouselCaptionDefault.default));
parcelHelpers.export(exports, "CardSubtitle", ()=>(0, _cardSubtitleDefault.default));
parcelHelpers.export(exports, "CardText", ()=>(0, _cardTextDefault.default));
parcelHelpers.export(exports, "CardTitle", ()=>(0, _cardTitleDefault.default));
parcelHelpers.export(exports, "CustomFileInput", ()=>(0, _customFileInputDefault.default));
parcelHelpers.export(exports, "CustomInput", ()=>(0, _customInputDefault.default));
parcelHelpers.export(exports, "PopperContent", ()=>(0, _popperContentDefault.default));
parcelHelpers.export(exports, "PopperTargetHelper", ()=>(0, _popperTargetHelperDefault.default));
parcelHelpers.export(exports, "Popover", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "UncontrolledPopover", ()=>(0, _uncontrolledPopoverDefault.default));
parcelHelpers.export(exports, "PopoverHeader", ()=>(0, _popoverHeaderDefault.default));
parcelHelpers.export(exports, "PopoverBody", ()=>(0, _popoverBodyDefault.default));
parcelHelpers.export(exports, "Progress", ()=>(0, _progressDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ModalHeader", ()=>(0, _modalHeaderDefault.default));
parcelHelpers.export(exports, "ModalBody", ()=>(0, _modalBodyDefault.default));
parcelHelpers.export(exports, "ModalFooter", ()=>(0, _modalFooterDefault.default));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "ListGroup", ()=>(0, _listGroupDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "FormFeedback", ()=>(0, _formFeedbackDefault.default));
parcelHelpers.export(exports, "FormGroup", ()=>(0, _formGroupDefault.default));
parcelHelpers.export(exports, "FormText", ()=>(0, _formTextDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "InputGroup", ()=>(0, _inputGroupDefault.default));
parcelHelpers.export(exports, "InputGroupAddon", ()=>(0, _inputGroupAddonDefault.default));
parcelHelpers.export(exports, "InputGroupButtonDropdown", ()=>(0, _inputGroupButtonDropdownDefault.default));
parcelHelpers.export(exports, "InputGroupText", ()=>(0, _inputGroupTextDefault.default));
parcelHelpers.export(exports, "Label", ()=>(0, _labelDefault.default));
parcelHelpers.export(exports, "Media", ()=>(0, _mediaDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "PaginationItem", ()=>(0, _paginationItemDefault.default));
parcelHelpers.export(exports, "PaginationLink", ()=>(0, _paginationLinkDefault.default));
parcelHelpers.export(exports, "TabContent", ()=>(0, _tabContentDefault.default));
parcelHelpers.export(exports, "TabPane", ()=>(0, _tabPaneDefault.default));
parcelHelpers.export(exports, "Jumbotron", ()=>(0, _jumbotronDefault.default));
parcelHelpers.export(exports, "Alert", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "Toast", ()=>(0, _toastDefault.default));
parcelHelpers.export(exports, "ToastBody", ()=>(0, _toastBodyDefault.default));
parcelHelpers.export(exports, "ToastHeader", ()=>(0, _toastHeaderDefault.default));
parcelHelpers.export(exports, "Collapse", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "ListGroupItem", ()=>(0, _listGroupItemDefault.default));
parcelHelpers.export(exports, "ListGroupItemHeading", ()=>(0, _listGroupItemHeadingDefault.default));
parcelHelpers.export(exports, "ListGroupItemText", ()=>(0, _listGroupItemTextDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "ListInlineItem", ()=>(0, _listInlineItemDefault.default));
parcelHelpers.export(exports, "UncontrolledAlert", ()=>(0, _uncontrolledAlertDefault.default));
parcelHelpers.export(exports, "UncontrolledButtonDropdown", ()=>(0, _uncontrolledButtonDropdownDefault.default));
parcelHelpers.export(exports, "UncontrolledCollapse", ()=>(0, _uncontrolledCollapseDefault.default));
parcelHelpers.export(exports, "UncontrolledDropdown", ()=>(0, _uncontrolledDropdownDefault.default));
parcelHelpers.export(exports, "UncontrolledTooltip", ()=>(0, _uncontrolledTooltipDefault.default));
parcelHelpers.export(exports, "Spinner", ()=>(0, _spinnerDefault.default));
parcelHelpers.export(exports, "Util", ()=>_utils);
parcelHelpers.export(exports, "Polyfill", ()=>_polyfill);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _row = require("./Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _navbar = require("./Navbar");
var _navbarDefault = parcelHelpers.interopDefault(_navbar);
var _navbarBrand = require("./NavbarBrand");
var _navbarBrandDefault = parcelHelpers.interopDefault(_navbarBrand);
var _navbarText = require("./NavbarText");
var _navbarTextDefault = parcelHelpers.interopDefault(_navbarText);
var _navbarToggler = require("./NavbarToggler");
var _navbarTogglerDefault = parcelHelpers.interopDefault(_navbarToggler);
var _nav = require("./Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _breadcrumb = require("./Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _breadcrumbItem = require("./BreadcrumbItem");
var _breadcrumbItemDefault = parcelHelpers.interopDefault(_breadcrumbItem);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonToggle = require("./ButtonToggle");
var _buttonToggleDefault = parcelHelpers.interopDefault(_buttonToggle);
var _buttonDropdown = require("./ButtonDropdown");
var _buttonDropdownDefault = parcelHelpers.interopDefault(_buttonDropdown);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonToolbar = require("./ButtonToolbar");
var _buttonToolbarDefault = parcelHelpers.interopDefault(_buttonToolbar);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _dropdownContext = require("./DropdownContext");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardGroup = require("./CardGroup");
var _cardGroupDefault = parcelHelpers.interopDefault(_cardGroup);
var _cardDeck = require("./CardDeck");
var _cardDeckDefault = parcelHelpers.interopDefault(_cardDeck);
var _cardColumns = require("./CardColumns");
var _cardColumnsDefault = parcelHelpers.interopDefault(_cardColumns);
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _carousel = require("./Carousel");
var _carouselDefault = parcelHelpers.interopDefault(_carousel);
var _uncontrolledCarousel = require("./UncontrolledCarousel");
var _uncontrolledCarouselDefault = parcelHelpers.interopDefault(_uncontrolledCarousel);
var _carouselControl = require("./CarouselControl");
var _carouselControlDefault = parcelHelpers.interopDefault(_carouselControl);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _carouselIndicators = require("./CarouselIndicators");
var _carouselIndicatorsDefault = parcelHelpers.interopDefault(_carouselIndicators);
var _carouselCaption = require("./CarouselCaption");
var _carouselCaptionDefault = parcelHelpers.interopDefault(_carouselCaption);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _customFileInput = require("./CustomFileInput");
var _customFileInputDefault = parcelHelpers.interopDefault(_customFileInput);
var _customInput = require("./CustomInput");
var _customInputDefault = parcelHelpers.interopDefault(_customInput);
var _popperContent = require("./PopperContent");
var _popperContentDefault = parcelHelpers.interopDefault(_popperContent);
var _popperTargetHelper = require("./PopperTargetHelper");
var _popperTargetHelperDefault = parcelHelpers.interopDefault(_popperTargetHelper);
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _uncontrolledPopover = require("./UncontrolledPopover");
var _uncontrolledPopoverDefault = parcelHelpers.interopDefault(_uncontrolledPopover);
var _popoverHeader = require("./PopoverHeader");
var _popoverHeaderDefault = parcelHelpers.interopDefault(_popoverHeader);
var _popoverBody = require("./PopoverBody");
var _popoverBodyDefault = parcelHelpers.interopDefault(_popoverBody);
var _progress = require("./Progress");
var _progressDefault = parcelHelpers.interopDefault(_progress);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _listGroup = require("./ListGroup");
var _listGroupDefault = parcelHelpers.interopDefault(_listGroup);
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formFeedback = require("./FormFeedback");
var _formFeedbackDefault = parcelHelpers.interopDefault(_formFeedback);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _inputGroup = require("./InputGroup");
var _inputGroupDefault = parcelHelpers.interopDefault(_inputGroup);
var _inputGroupAddon = require("./InputGroupAddon");
var _inputGroupAddonDefault = parcelHelpers.interopDefault(_inputGroupAddon);
var _inputGroupButtonDropdown = require("./InputGroupButtonDropdown");
var _inputGroupButtonDropdownDefault = parcelHelpers.interopDefault(_inputGroupButtonDropdown);
var _inputGroupText = require("./InputGroupText");
var _inputGroupTextDefault = parcelHelpers.interopDefault(_inputGroupText);
var _label = require("./Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _media = require("./Media");
var _mediaDefault = parcelHelpers.interopDefault(_media);
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationItem = require("./PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _paginationLink = require("./PaginationLink");
var _paginationLinkDefault = parcelHelpers.interopDefault(_paginationLink);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _jumbotron = require("./Jumbotron");
var _jumbotronDefault = parcelHelpers.interopDefault(_jumbotron);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _toast = require("./Toast");
var _toastDefault = parcelHelpers.interopDefault(_toast);
var _toastBody = require("./ToastBody");
var _toastBodyDefault = parcelHelpers.interopDefault(_toastBody);
var _toastHeader = require("./ToastHeader");
var _toastHeaderDefault = parcelHelpers.interopDefault(_toastHeader);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _listGroupItem = require("./ListGroupItem");
var _listGroupItemDefault = parcelHelpers.interopDefault(_listGroupItem);
var _listGroupItemHeading = require("./ListGroupItemHeading");
var _listGroupItemHeadingDefault = parcelHelpers.interopDefault(_listGroupItemHeading);
var _listGroupItemText = require("./ListGroupItemText");
var _listGroupItemTextDefault = parcelHelpers.interopDefault(_listGroupItemText);
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listInlineItem = require("./ListInlineItem");
var _listInlineItemDefault = parcelHelpers.interopDefault(_listInlineItem);
var _uncontrolledAlert = require("./UncontrolledAlert");
var _uncontrolledAlertDefault = parcelHelpers.interopDefault(_uncontrolledAlert);
var _uncontrolledButtonDropdown = require("./UncontrolledButtonDropdown");
var _uncontrolledButtonDropdownDefault = parcelHelpers.interopDefault(_uncontrolledButtonDropdown);
var _uncontrolledCollapse = require("./UncontrolledCollapse");
var _uncontrolledCollapseDefault = parcelHelpers.interopDefault(_uncontrolledCollapse);
var _uncontrolledDropdown = require("./UncontrolledDropdown");
var _uncontrolledDropdownDefault = parcelHelpers.interopDefault(_uncontrolledDropdown);
var _uncontrolledTooltip = require("./UncontrolledTooltip");
var _uncontrolledTooltipDefault = parcelHelpers.interopDefault(_uncontrolledTooltip);
var _spinner = require("./Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _utils = require("./utils");
var _polyfill = require("./polyfill");

},{"./Container":"6jZgz","./Row":"7KNK1","./Col":"exx8j","./Navbar":"9qLqG","./NavbarBrand":"5sGVm","./NavbarText":false,"./NavbarToggler":false,"./Nav":"3FRlB","./NavItem":"5sCKB","./NavLink":"cYbl3","./Breadcrumb":"lnMs5","./BreadcrumbItem":"8LtSl","./Button":"7coms","./ButtonToggle":false,"./ButtonDropdown":false,"./ButtonGroup":"iALm6","./ButtonToolbar":false,"./Dropdown":"7eEBk","./DropdownItem":"2jSBY","./DropdownMenu":"hEatL","./DropdownToggle":"9uLB8","./DropdownContext":false,"./Fade":false,"./Badge":false,"./Card":"Cuhve","./CardGroup":false,"./CardDeck":false,"./CardColumns":false,"./CardBody":"hB1zW","./CardLink":false,"./CardFooter":false,"./CardHeader":"lmzTf","./CardImg":false,"./CardImgOverlay":false,"./Carousel":false,"./UncontrolledCarousel":false,"./CarouselControl":false,"./CarouselItem":false,"./CarouselIndicators":false,"./CarouselCaption":false,"./CardSubtitle":false,"./CardText":false,"./CardTitle":"bFs6I","./CustomFileInput":false,"./CustomInput":false,"./PopperContent":false,"./PopperTargetHelper":false,"./Popover":false,"./UncontrolledPopover":false,"./PopoverHeader":false,"./PopoverBody":false,"./Progress":"hysNz","./Modal":"k2AXs","./ModalHeader":"fu5sV","./ModalBody":"h0Ijt","./ModalFooter":"7uFZp","./Tooltip":false,"./Table":"5CVnB","./ListGroup":false,"./Form":"2ECXs","./FormFeedback":"8rrrt","./FormGroup":"4C5hq","./FormText":false,"./Input":"jF6wA","./InputGroup":"48DIi","./InputGroupAddon":"avymG","./InputGroupButtonDropdown":false,"./InputGroupText":"6nuKb","./Label":"5ZGRu","./Media":false,"./Pagination":false,"./PaginationItem":false,"./PaginationLink":false,"./TabContent":false,"./TabPane":false,"./Jumbotron":false,"./Alert":"1ottv","./Toast":false,"./ToastBody":false,"./ToastHeader":false,"./Collapse":"3Q6Yw","./ListGroupItem":false,"./ListGroupItemHeading":false,"./ListGroupItemText":false,"./List":false,"./ListInlineItem":false,"./UncontrolledAlert":"89BHQ","./UncontrolledButtonDropdown":false,"./UncontrolledCollapse":false,"./UncontrolledDropdown":"01xUr","./UncontrolledTooltip":"97tdP","./Spinner":false,"./utils":false,"./polyfill":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jZgz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "fluid",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    fluid: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var Container = function Container(props) {
    var className = props.className, cssModule = props.cssModule, fluid = props.fluid, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var containerClass = "container";
    if (fluid === true) containerClass = "container-fluid";
    else if (fluid) containerClass = "container-" + fluid;
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, containerClass), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
exports.default = Container;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Een2":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"gIzRi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScrollbarWidth", ()=>getScrollbarWidth);
parcelHelpers.export(exports, "setScrollbarWidth", ()=>setScrollbarWidth);
parcelHelpers.export(exports, "isBodyOverflowing", ()=>isBodyOverflowing);
parcelHelpers.export(exports, "getOriginalBodyPadding", ()=>getOriginalBodyPadding);
parcelHelpers.export(exports, "conditionallyUpdateScrollbar", ()=>conditionallyUpdateScrollbar);
parcelHelpers.export(exports, "setGlobalCssModule", ()=>setGlobalCssModule);
parcelHelpers.export(exports, "mapToCssModules", ()=>mapToCssModules);
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */ parcelHelpers.export(exports, "omit", ()=>omit);
/**
 * Returns a filtered copy of an object with only the specified keys.
 */ parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
parcelHelpers.export(exports, "deprecated", ()=>deprecated) // Shim Element if needed (e.g. in Node environment)
;
parcelHelpers.export(exports, "DOMElement", ()=>DOMElement);
parcelHelpers.export(exports, "targetPropType", ()=>targetPropType);
parcelHelpers.export(exports, "tagPropType", ()=>tagPropType);
parcelHelpers.export(exports, "TransitionTimeouts", ()=>TransitionTimeouts);
parcelHelpers.export(exports, "TransitionPropTypeKeys", ()=>TransitionPropTypeKeys);
parcelHelpers.export(exports, "TransitionStatuses", ()=>TransitionStatuses);
parcelHelpers.export(exports, "keyCodes", ()=>keyCodes);
parcelHelpers.export(exports, "PopperPlacements", ()=>PopperPlacements);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "isReactRefObj", ()=>isReactRefObj);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "findDOMElements", ()=>findDOMElements);
parcelHelpers.export(exports, "isArrayOrNodeList", ()=>isArrayOrNodeList);
parcelHelpers.export(exports, "getTarget", ()=>getTarget);
parcelHelpers.export(exports, "defaultToggleEvents", ()=>defaultToggleEvents);
parcelHelpers.export(exports, "addMultipleEventListeners", ()=>addMultipleEventListeners);
parcelHelpers.export(exports, "focusableElements", ()=>focusableElements);
var _propTypes = require("prop-types"); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function getScrollbarWidth() {
    var scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
function setScrollbarWidth(padding) {
    document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function isBodyOverflowing() {
    return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
    var style = window.getComputedStyle(document.body, null);
    return parseInt(style && style.getPropertyValue("padding-right") || 0, 10);
}
function conditionallyUpdateScrollbar() {
    var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
    var fixedContent = document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")[0];
    var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
    if (isBodyOverflowing()) setScrollbarWidth(bodyPadding + scrollbarWidth);
}
var globalCssModule;
function setGlobalCssModule(cssModule) {
    globalCssModule = cssModule;
}
function mapToCssModules(className, cssModule) {
    if (className === void 0) className = "";
    if (cssModule === void 0) cssModule = globalCssModule;
    if (!cssModule) return className;
    return className.split(" ").map(function(c) {
        return cssModule[c] || c;
    }).join(" ");
}
function omit(obj, omitKeys) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (omitKeys.indexOf(key) === -1) result[key] = obj[key];
    });
    return result;
}
function pick(obj, keys) {
    var pickKeys = Array.isArray(keys) ? keys : [
        keys
    ];
    var length = pickKeys.length;
    var key;
    var result = {};
    while(length > 0){
        length -= 1;
        key = pickKeys[length];
        result[key] = obj[key];
    }
    return result;
}
var warned = {};
function warnOnce(message) {
    if (!warned[message]) {
        /* istanbul ignore else */ if (typeof console !== "undefined") console.error(message); // eslint-disable-line no-console
        warned[message] = true;
    }
}
function deprecated(propType, explanation) {
    return function validate(props, propName, componentName) {
        if (props[propName] !== null && typeof props[propName] !== "undefined") warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
        return propType.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest));
    };
}
var Element = typeof window === "object" && window.Element || function() {};
function DOMElement(props, propName, componentName) {
    if (!(props[propName] instanceof Element)) return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Expected prop to be an instance of Element. Validation failed.");
}
var targetPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).func,
    DOMElement,
    (0, _propTypesDefault.default).shape({
        current: (0, _propTypesDefault.default).any
    })
]);
var tagPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        $$typeof: (0, _propTypesDefault.default).symbol,
        render: (0, _propTypesDefault.default).func
    }),
    (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            $$typeof: (0, _propTypesDefault.default).symbol,
            render: (0, _propTypesDefault.default).func
        })
    ]))
]);
var TransitionTimeouts = {
    Fade: 150,
    // $transition-fade
    Collapse: 350,
    // $transition-collapse
    Modal: 300,
    // $modal-transition
    Carousel: 600 // $carousel-transition
}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
var TransitionPropTypeKeys = [
    "in",
    "mountOnEnter",
    "unmountOnExit",
    "appear",
    "enter",
    "exit",
    "timeout",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
];
var TransitionStatuses = {
    ENTERING: "entering",
    ENTERED: "entered",
    EXITING: "exiting",
    EXITED: "exited"
};
var keyCodes = {
    esc: 27,
    space: 32,
    enter: 13,
    tab: 9,
    up: 38,
    down: 40,
    home: 36,
    end: 35,
    n: 78,
    p: 80
};
var PopperPlacements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function isReactRefObj(target) {
    if (target && typeof target === "object") return "current" in target;
    return false;
}
function getTag(value) {
    if (value == null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function toNumber(value) {
    var type = typeof value;
    var NAN = 0 / 0;
    if (type === "number") return value;
    if (type === "symbol" || type === "object" && getTag(value) === "[object Symbol]") return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf === "function" ? value.valueOf() : value;
        value = isObject(other) ? "" + other : other;
    }
    if (type !== "string") return value === 0 ? value : +value;
    value = value.replace(/^\s+|\s+$/g, "");
    var isBinary = /^0b[01]+$/i.test(value);
    return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}
function isObject(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function");
}
function isFunction(value) {
    if (!isObject(value)) return false;
    var tag = getTag(value);
    return tag === "[object Function]" || tag === "[object AsyncFunction]" || tag === "[object GeneratorFunction]" || tag === "[object Proxy]";
}
function findDOMElements(target) {
    if (isReactRefObj(target)) return target.current;
    if (isFunction(target)) return target();
    if (typeof target === "string" && canUseDOM) {
        var selection = document.querySelectorAll(target);
        if (!selection.length) selection = document.querySelectorAll("#" + target);
        if (!selection.length) throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
        return selection;
    }
    return target;
}
function isArrayOrNodeList(els) {
    if (els === null) return false;
    return Array.isArray(els) || canUseDOM && typeof els.length === "number";
}
function getTarget(target, allElements) {
    var els = findDOMElements(target);
    if (allElements) {
        if (isArrayOrNodeList(els)) return els;
        if (els === null) return [];
        return [
            els
        ];
    } else {
        if (isArrayOrNodeList(els)) return els[0];
        return els;
    }
}
var defaultToggleEvents = [
    "touchstart",
    "click"
];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
    var els = _els;
    if (!isArrayOrNodeList(els)) els = [
        els
    ];
    var events = _events;
    if (typeof events === "string") events = events.split(/\s+/);
    if (!isArrayOrNodeList(els) || typeof handler !== "function" || !Array.isArray(events)) throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
    Array.prototype.forEach.call(events, function(event) {
        Array.prototype.forEach.call(els, function(el) {
            el.addEventListener(event, handler, useCapture);
        });
    });
    return function removeEvents() {
        Array.prototype.forEach.call(events, function(event) {
            Array.prototype.forEach.call(els, function(el) {
                el.removeEventListener(event, handler, useCapture);
            });
        });
    };
}
var focusableElements = [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "object",
    "embed",
    "[tabindex]:not(.modal)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7KNK1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "noGutters",
    "tag",
    "form",
    "widths"
];
var rowColWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var rowColsPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string
]);
var propTypes = {
    tag: (0, _utils.tagPropType),
    noGutters: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    form: (0, _propTypesDefault.default).bool,
    xs: rowColsPropType,
    sm: rowColsPropType,
    md: rowColsPropType,
    lg: rowColsPropType,
    xl: rowColsPropType
};
var defaultProps = {
    tag: "div",
    widths: rowColWidths
};
var Row = function Row(props) {
    var className = props.className, cssModule = props.cssModule, noGutters = props.noGutters, Tag = props.tag, form = props.form, widths = props.widths, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var colSize = props[colWidth];
        delete attributes[colWidth];
        if (!colSize) return;
        var isXs = !i;
        colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
    });
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, noGutters ? "no-gutters" : null, form ? "form-row" : "row", colClasses), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
exports.default = Row;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"exx8j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "widths",
    "tag"
];
var colWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var stringOrNumberProp = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string
]);
var columnProps = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).bool,
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        size: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).bool,
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ]),
        order: stringOrNumberProp,
        offset: stringOrNumberProp
    })
]);
var propTypes = {
    tag: (0, _utils.tagPropType),
    xs: columnProps,
    sm: columnProps,
    md: columnProps,
    lg: columnProps,
    xl: columnProps,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    widths: (0, _propTypesDefault.default).array
};
var defaultProps = {
    tag: "div",
    widths: colWidths
};
var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
    if (colSize === true || colSize === "") return isXs ? "col" : "col-" + colWidth;
    else if (colSize === "auto") return isXs ? "col-auto" : "col-" + colWidth + "-auto";
    return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};
var Col = function Col(props) {
    var className = props.className, cssModule = props.cssModule, widths = props.widths, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var columnProp = props[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== "") return;
        var isXs = !i;
        if ((0, _utils.isObject)(columnProp)) {
            var _classNames;
            var colSizeInterfix = isXs ? "-" : "-" + colWidth + "-";
            var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
            colClasses.push((0, _utils.mapToCssModules)((0, _classnamesDefault.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === "", _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
        } else {
            var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(_colClass);
        }
    });
    if (!colClasses.length) colClasses.push("col");
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, colClasses), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
exports.default = Col;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9qLqG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "expand",
    "className",
    "cssModule",
    "light",
    "dark",
    "fixed",
    "sticky",
    "color",
    "tag"
];
var propTypes = {
    light: (0, _propTypesDefault.default).bool,
    dark: (0, _propTypesDefault.default).bool,
    full: (0, _propTypesDefault.default).bool,
    fixed: (0, _propTypesDefault.default).string,
    sticky: (0, _propTypesDefault.default).string,
    color: (0, _propTypesDefault.default).string,
    role: (0, _propTypesDefault.default).string,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    expand: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ])
};
var defaultProps = {
    tag: "nav",
    expand: false
};
var getExpandClass = function getExpandClass(expand) {
    if (expand === false) return false;
    else if (expand === true || expand === "xs") return "navbar-expand";
    return "navbar-expand-" + expand;
};
var Navbar = function Navbar(props) {
    var _classNames;
    var expand = props.expand, className = props.className, cssModule = props.cssModule, light = props.light, dark = props.dark, fixed = props.fixed, sticky = props.sticky, color = props.color, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "navbar", getExpandClass(expand), (_classNames = {
        "navbar-light": light,
        "navbar-dark": dark
    }, _classNames["bg-" + color] = color, _classNames["fixed-" + fixed] = fixed, _classNames["sticky-" + sticky] = sticky, _classNames)), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
exports.default = Navbar;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sGVm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "a"
};
var NavbarBrand = function NavbarBrand(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "navbar-brand"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
NavbarBrand.propTypes = propTypes;
NavbarBrand.defaultProps = defaultProps;
exports.default = NavbarBrand;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3FRlB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tabs",
    "pills",
    "vertical",
    "horizontal",
    "justified",
    "fill",
    "navbar",
    "card",
    "tag"
];
var propTypes = {
    tabs: (0, _propTypesDefault.default).bool,
    pills: (0, _propTypesDefault.default).bool,
    vertical: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    horizontal: (0, _propTypesDefault.default).string,
    justified: (0, _propTypesDefault.default).bool,
    fill: (0, _propTypesDefault.default).bool,
    navbar: (0, _propTypesDefault.default).bool,
    card: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "ul",
    vertical: false
};
var getVerticalClass = function getVerticalClass(vertical) {
    if (vertical === false) return false;
    else if (vertical === true || vertical === "xs") return "flex-column";
    return "flex-" + vertical + "-column";
};
var Nav = function Nav(props) {
    var className = props.className, cssModule = props.cssModule, tabs = props.tabs, pills = props.pills, vertical = props.vertical, horizontal = props.horizontal, justified = props.justified, fill = props.fill, navbar = props.navbar, card = props.card, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, navbar ? "navbar-nav" : "nav", horizontal ? "justify-content-" + horizontal : false, getVerticalClass(vertical), {
        "nav-tabs": tabs,
        "card-header-tabs": card && tabs,
        "nav-pills": pills,
        "card-header-pills": card && pills,
        "nav-justified": justified,
        "nav-fill": fill
    }), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
exports.default = Nav;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sCKB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "active",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    active: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "li"
};
var NavItem = function NavItem(props) {
    var className = props.className, cssModule = props.cssModule, active = props.active, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "nav-item", active ? "active" : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
exports.default = NavItem;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cYbl3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "active",
    "tag",
    "innerRef"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    disabled: (0, _propTypesDefault.default).bool,
    active: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    onClick: (0, _propTypesDefault.default).func,
    href: (0, _propTypesDefault.default).any
};
var defaultProps = {
    tag: "a"
};
var NavLink = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(NavLink, _React$Component);
    function NavLink(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = NavLink.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.href === "#") e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, active = _this$props.active, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "nav-link", {
            disabled: attributes.disabled,
            active: active
        }), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            ref: innerRef,
            onClick: this.onClick,
            className: classes
        }));
    };
    return NavLink;
}((0, _reactDefault.default).Component);
NavLink.propTypes = propTypes;
NavLink.defaultProps = defaultProps;
exports.default = NavLink;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJtsr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnMs5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "listClassName",
    "cssModule",
    "children",
    "tag",
    "listTag",
    "aria-label"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    listTag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    listClassName: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).node,
    "aria-label": (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: "nav",
    listTag: "ol",
    "aria-label": "breadcrumb"
};
var Breadcrumb = function Breadcrumb(props) {
    var className = props.className, listClassName = props.listClassName, cssModule = props.cssModule, children = props.children, Tag = props.tag, ListTag = props.listTag, label = props["aria-label"], attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className), cssModule);
    var listClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("breadcrumb", listClassName), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        "aria-label": label
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ListTag, {
        className: listClasses
    }, children));
};
Breadcrumb.propTypes = propTypes;
Breadcrumb.defaultProps = defaultProps;
exports.default = Breadcrumb;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8LtSl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "active",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    active: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "li"
};
var BreadcrumbItem = function BreadcrumbItem(props) {
    var className = props.className, cssModule = props.cssModule, active = props.active, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, active ? "active" : false, "breadcrumb-item"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        "aria-current": active ? "page" : undefined
    }));
};
BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
exports.default = BreadcrumbItem;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7coms":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "active",
    "aria-label",
    "block",
    "className",
    "close",
    "cssModule",
    "color",
    "outline",
    "size",
    "tag",
    "innerRef"
];
var propTypes = {
    active: (0, _propTypesDefault.default).bool,
    "aria-label": (0, _propTypesDefault.default).string,
    block: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    disabled: (0, _propTypesDefault.default).bool,
    outline: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    onClick: (0, _propTypesDefault.default).func,
    size: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    close: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    color: "secondary",
    tag: "button"
};
var Button = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Button, _React$Component);
    function Button(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = Button.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) return this.props.onClick(e);
    };
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, ariaLabel = _this$props["aria-label"], block = _this$props.block, className = _this$props.className, close = _this$props.close, cssModule = _this$props.cssModule, color = _this$props.color, outline = _this$props.outline, size = _this$props.size, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        if (close && typeof attributes.children === "undefined") attributes.children = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": true
        }, "\xd7");
        var btnOutlineColor = "btn" + (outline ? "-outline" : "") + "-" + color;
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
            close: close
        }, close || "btn", close || btnOutlineColor, size ? "btn-" + size : false, block ? "btn-block" : false, {
            active: active,
            disabled: this.props.disabled
        }), cssModule);
        if (attributes.href && Tag === "button") Tag = "a";
        var defaultAriaLabel = close ? "Close" : null;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            type: Tag === "button" && attributes.onClick ? "button" : undefined
        }, attributes, {
            className: classes,
            ref: innerRef,
            onClick: this.onClick,
            "aria-label": ariaLabel || defaultAriaLabel
        }));
    };
    return Button;
}((0, _reactDefault.default).Component);
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
exports.default = Button;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iALm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "size",
    "vertical",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    "aria-label": (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    role: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).string,
    vertical: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    tag: "div",
    role: "group"
};
var ButtonGroup = function ButtonGroup(props) {
    var className = props.className, cssModule = props.cssModule, size = props.size, vertical = props.vertical, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, size ? "btn-group-" + size : false, vertical ? "btn-group-vertical" : "btn-group"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
exports.default = ButtonGroup;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7eEBk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
/* eslint react/no-find-dom-node: 0 */ // https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactPopper = require("react-popper");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "direction",
    "isOpen",
    "group",
    "size",
    "nav",
    "setActiveFromChild",
    "active",
    "addonType",
    "tag",
    "menuRole"
];
var propTypes = {
    a11y: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    direction: (0, _propTypesDefault.default).oneOf([
        "up",
        "down",
        "left",
        "right"
    ]),
    group: (0, _propTypesDefault.default).bool,
    isOpen: (0, _propTypesDefault.default).bool,
    nav: (0, _propTypesDefault.default).bool,
    active: (0, _propTypesDefault.default).bool,
    addonType: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).oneOf([
            "prepend",
            "append"
        ])
    ]),
    size: (0, _propTypesDefault.default).string,
    tag: (0, _utils.tagPropType),
    toggle: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    inNavbar: (0, _propTypesDefault.default).bool,
    setActiveFromChild: (0, _propTypesDefault.default).bool,
    menuRole: (0, _propTypesDefault.default).oneOf([
        "listbox",
        "menu"
    ])
};
var defaultProps = {
    a11y: true,
    isOpen: false,
    direction: "down",
    nav: false,
    active: false,
    addonType: false,
    inNavbar: false,
    setActiveFromChild: false
};
var preventDefaultKeys = [
    (0, _utils.keyCodes).space,
    (0, _utils.keyCodes).enter,
    (0, _utils.keyCodes).up,
    (0, _utils.keyCodes).down,
    (0, _utils.keyCodes).end,
    (0, _utils.keyCodes).home
];
var Dropdown = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Dropdown, _React$Component);
    function Dropdown(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.addEvents = _this.addEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.removeEvents = _this.removeEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleMenuRef = _this.handleMenuRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.containerRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        _this.menuRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        return _this;
    }
    var _proto = Dropdown.prototype;
    _proto.handleMenuRef = function handleMenuRef(menuRef) {
        this.menuRef.current = menuRef;
    };
    _proto.getContextValue = function getContextValue() {
        return {
            toggle: this.toggle,
            isOpen: this.props.isOpen,
            direction: this.props.direction === "down" && this.props.dropup ? "up" : this.props.direction,
            inNavbar: this.props.inNavbar,
            disabled: this.props.disabled,
            // Callback that should be called by DropdownMenu to provide a ref to
            // a HTML tag that's used for the DropdownMenu
            onMenuRef: this.handleMenuRef,
            menuRole: this.props.menuRole
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.handleProps();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) this.handleProps();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.removeEvents();
    };
    _proto.getContainer = function getContainer() {
        return this.containerRef.current;
    };
    _proto.getMenu = function getMenu() {
        return this.menuRef.current;
    };
    _proto.getMenuCtrl = function getMenuCtrl() {
        if (this._$menuCtrl) return this._$menuCtrl;
        this._$menuCtrl = this.getContainer().querySelector("[aria-expanded]");
        return this._$menuCtrl;
    };
    _proto.getItemType = function getItemType() {
        if (this.context.menuRole === "listbox") return "option";
        return "menuitem";
    };
    _proto.getMenuItems = function getMenuItems() {
        // In a real menu with a child DropdownMenu, `this.getMenu()` should never
        // be null, but it is sometimes null in tests. To mitigate that, we just
        // use `this.getContainer()` as the fallback `menuContainer`.
        var menuContainer = this.getMenu() || this.getContainer();
        return [].slice.call(menuContainer.querySelectorAll('[role="' + this.getItemType() + '"]'));
    };
    _proto.addEvents = function addEvents() {
        var _this2 = this;
        [
            "click",
            "touchstart",
            "keyup"
        ].forEach(function(event) {
            return document.addEventListener(event, _this2.handleDocumentClick, true);
        });
    };
    _proto.removeEvents = function removeEvents() {
        var _this3 = this;
        [
            "click",
            "touchstart",
            "keyup"
        ].forEach(function(event) {
            return document.removeEventListener(event, _this3.handleDocumentClick, true);
        });
    };
    _proto.handleDocumentClick = function handleDocumentClick(e) {
        if (e && (e.which === 3 || e.type === "keyup" && e.which !== (0, _utils.keyCodes).tab)) return;
        var container = this.getContainer();
        var menu = this.getMenu();
        var clickIsInContainer = container.contains(e.target) && container !== e.target;
        var clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
        if ((clickIsInContainer || clickIsInMenu) && (e.type !== "keyup" || e.which === (0, _utils.keyCodes).tab)) return;
        this.toggle(e);
    };
    _proto.handleKeyDown = function handleKeyDown(e) {
        var _this4 = this;
        var isTargetMenuItem = e.target.getAttribute("role") === "menuitem" || e.target.getAttribute("role") === "option";
        var isTargetMenuCtrl = this.getMenuCtrl() === e.target;
        var isTab = (0, _utils.keyCodes).tab === e.which;
        if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) return;
        if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) e.preventDefault();
        if (this.props.disabled) return;
        if (isTargetMenuCtrl) {
            if ([
                (0, _utils.keyCodes).space,
                (0, _utils.keyCodes).enter,
                (0, _utils.keyCodes).up,
                (0, _utils.keyCodes).down
            ].indexOf(e.which) > -1) {
                // Open the menu (if not open) and focus the first menu item
                if (!this.props.isOpen) this.toggle(e);
                setTimeout(function() {
                    return _this4.getMenuItems()[0].focus();
                });
            } else if (this.props.isOpen && isTab) {
                // Focus the first menu item if tabbing from an open menu. We need this
                // for cases where the DropdownMenu sets a custom container, which may
                // not be the natural next item to tab to from the DropdownToggle.
                e.preventDefault();
                this.getMenuItems()[0].focus();
            } else if (this.props.isOpen && e.which === (0, _utils.keyCodes).esc) this.toggle(e);
        }
        if (this.props.isOpen && isTargetMenuItem) {
            if ([
                (0, _utils.keyCodes).tab,
                (0, _utils.keyCodes).esc
            ].indexOf(e.which) > -1) {
                this.toggle(e);
                this.getMenuCtrl().focus();
            } else if ([
                (0, _utils.keyCodes).space,
                (0, _utils.keyCodes).enter
            ].indexOf(e.which) > -1) {
                e.target.click();
                this.getMenuCtrl().focus();
            } else if ([
                (0, _utils.keyCodes).down,
                (0, _utils.keyCodes).up
            ].indexOf(e.which) > -1 || [
                (0, _utils.keyCodes).n,
                (0, _utils.keyCodes).p
            ].indexOf(e.which) > -1 && e.ctrlKey) {
                var $menuitems = this.getMenuItems();
                var index = $menuitems.indexOf(e.target);
                if ((0, _utils.keyCodes).up === e.which || (0, _utils.keyCodes).p === e.which && e.ctrlKey) index = index !== 0 ? index - 1 : $menuitems.length - 1;
                else if ((0, _utils.keyCodes).down === e.which || (0, _utils.keyCodes).n === e.which && e.ctrlKey) index = index === $menuitems.length - 1 ? 0 : index + 1;
                $menuitems[index].focus();
            } else if ((0, _utils.keyCodes).end === e.which) {
                var _$menuitems = this.getMenuItems();
                _$menuitems[_$menuitems.length - 1].focus();
            } else if ((0, _utils.keyCodes).home === e.which) {
                var _$menuitems2 = this.getMenuItems();
                _$menuitems2[0].focus();
            } else if (e.which >= 48 && e.which <= 90) {
                var _$menuitems3 = this.getMenuItems();
                var charPressed = String.fromCharCode(e.which).toLowerCase();
                for(var i = 0; i < _$menuitems3.length; i += 1){
                    var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
                    if (firstLetter === charPressed) {
                        _$menuitems3[i].focus();
                        break;
                    }
                }
            }
        }
    };
    _proto.handleProps = function handleProps() {
        if (this.props.isOpen) this.addEvents();
        else this.removeEvents();
    };
    _proto.toggle = function toggle(e) {
        if (this.props.disabled) return e && e.preventDefault();
        return this.props.toggle(e);
    };
    _proto.render = function render() {
        var _classNames, _ref;
        var _omit = (0, _utils.omit)(this.props, [
            "toggle",
            "disabled",
            "inNavbar",
            "a11y"
        ]), className = _omit.className, cssModule = _omit.cssModule, direction = _omit.direction, isOpen = _omit.isOpen, group = _omit.group, size = _omit.size, nav = _omit.nav, setActiveFromChild = _omit.setActiveFromChild, active = _omit.active, addonType = _omit.addonType, tag = _omit.tag, menuRole = _omit.menuRole, attrs = (0, _objectWithoutPropertiesLooseDefault.default)(_omit, _excluded);
        var Tag = tag || (nav ? "li" : "div");
        var subItemIsActive = false;
        if (setActiveFromChild) (0, _reactDefault.default).Children.map(this.props.children[1].props.children, function(dropdownItem) {
            if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
        });
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, direction !== "down" && "drop" + direction, nav && active ? "active" : false, setActiveFromChild && subItemIsActive ? "active" : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames["btn-group"] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames["nav-item"] = nav, _classNames)), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropdownContext.DropdownContext).Provider, {
            value: this.getContextValue()
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Manager), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attrs, (_ref = {}, _ref[typeof Tag === "string" ? "ref" : "innerRef"] = this.containerRef, _ref), {
            onKeyDown: this.handleKeyDown,
            className: classes
        }))));
    };
    return Dropdown;
}((0, _reactDefault.default).Component);
Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
exports.default = Dropdown;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","react-popper":"lohlT","classnames":"5Een2","./DropdownContext":"dUz1l","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lohlT":[function(require,module,exports) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popperDefault.default)) // Public types
;
parcelHelpers.export(exports, "placements", ()=>(0, _popper.placements));
parcelHelpers.export(exports, "Manager", ()=>(0, _managerDefault.default));
parcelHelpers.export(exports, "Reference", ()=>(0, _referenceDefault.default));
var _popper = require("./Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _manager = require("./Manager");
var _managerDefault = parcelHelpers.interopDefault(_manager);
var _reference = require("./Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);

},{"./Popper":"f98UF","./Manager":"i8ZFL","./Reference":"6LY2i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f98UF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerPopper", ()=>InnerPopper);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "default", ()=>Popper);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _deepEqual = require("deep-equal");
var _deepEqualDefault = parcelHelpers.interopDefault(_deepEqual);
var _react = require("react");
var _popperJs = require("popper.js");
var _popperJsDefault = parcelHelpers.interopDefault(_popperJs);
var _manager = require("./Manager");
var _utils = require("./utils");
var initialStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    opacity: 0,
    pointerEvents: "none"
};
var initialArrowStyle = {};
var InnerPopper = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InnerPopper, _React$Component);
    function InnerPopper() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "state", {
            data: undefined,
            placement: undefined
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "popperInstance", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "popperNode", null);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "arrowNode", null);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setPopperNode", function(popperNode) {
            if (!popperNode || _this.popperNode === popperNode) return;
            (0, _utils.setRef)(_this.props.innerRef, popperNode);
            _this.popperNode = popperNode;
            _this.updatePopperInstance();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setArrowNode", function(arrowNode) {
            _this.arrowNode = arrowNode;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "updateStateModifier", {
            enabled: true,
            order: 900,
            fn: function fn(data) {
                var placement = data.placement;
                _this.setState({
                    data: data,
                    placement: placement
                });
                return data;
            }
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getOptions", function() {
            return {
                placement: _this.props.placement,
                eventsEnabled: _this.props.eventsEnabled,
                positionFixed: _this.props.positionFixed,
                modifiers: (0, _extendsDefault.default)({}, _this.props.modifiers, {
                    arrow: (0, _extendsDefault.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
                        enabled: !!_this.arrowNode,
                        element: _this.arrowNode
                    }),
                    applyStyle: {
                        enabled: false
                    },
                    updateStateModifier: _this.updateStateModifier
                })
            };
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getPopperStyle", function() {
            return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extendsDefault.default)({
                position: _this.state.data.offsets.popper.position
            }, _this.state.data.styles);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getPopperPlacement", function() {
            return !_this.state.data ? undefined : _this.state.placement;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getArrowStyle", function() {
            return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getOutOfBoundariesState", function() {
            return _this.state.data ? _this.state.data.hide : undefined;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "destroyPopperInstance", function() {
            if (!_this.popperInstance) return;
            _this.popperInstance.destroy();
            _this.popperInstance = null;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "updatePopperInstance", function() {
            _this.destroyPopperInstance();
            var _assertThisInitialize = (0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), popperNode = _assertThisInitialize.popperNode;
            var referenceElement = _this.props.referenceElement;
            if (!referenceElement || !popperNode) return;
            _this.popperInstance = new (0, _popperJsDefault.default)(referenceElement, popperNode, _this.getOptions());
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "scheduleUpdate", function() {
            if (_this.popperInstance) _this.popperInstance.scheduleUpdate();
        });
        return _this;
    }
    var _proto = InnerPopper.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // If the Popper.js options have changed, update the instance (destroy + create)
        if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqualDefault.default)(this.props.modifiers, prevProps.modifiers, {
            strict: true
        })) {
            if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
            this.updatePopperInstance();
        } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
         // A placement difference in state means popper determined a new placement
        // apart from the props value. By the time the popper element is rendered with
        // the new position Popper has already measured it, if the place change triggers
        // a size change it will result in a misaligned popper. So we schedule an update to be sure.
        if (prevState.placement !== this.state.placement) this.scheduleUpdate();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, _utils.setRef)(this.props.innerRef, null);
        this.destroyPopperInstance();
    };
    _proto.render = function render() {
        return (0, _utils.unwrapArray)(this.props.children)({
            ref: this.setPopperNode,
            style: this.getPopperStyle(),
            placement: this.getPopperPlacement(),
            outOfBoundaries: this.getOutOfBoundariesState(),
            scheduleUpdate: this.scheduleUpdate,
            arrowProps: {
                ref: this.setArrowNode,
                style: this.getArrowStyle()
            }
        });
    };
    return InnerPopper;
}(_react.Component);
(0, _definePropertyDefault.default)(InnerPopper, "defaultProps", {
    placement: "bottom",
    eventsEnabled: true,
    referenceElement: undefined,
    positionFixed: false
});
var placements = (0, _popperJsDefault.default).placements;
function Popper(_ref) {
    var referenceElement = _ref.referenceElement, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "referenceElement"
    ]);
    return _react.createElement((0, _manager.ManagerReferenceNodeContext).Consumer, null, function(referenceNode) {
        return _react.createElement(InnerPopper, (0, _extendsDefault.default)({
            referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
        }, props));
    });
}

},{"@babel/runtime/helpers/objectWithoutPropertiesLoose":"imPRm","@babel/runtime/helpers/extends":"ktcBy","@babel/runtime/helpers/inheritsLoose":"kUsrV","@babel/runtime/helpers/assertThisInitialized":"f0luE","@babel/runtime/helpers/defineProperty":"hjdoh","deep-equal":"jaMJH","react":"9njXz","popper.js":"1dDyS","./Manager":"i8ZFL","./utils":"RIAfm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imPRm":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"ktcBy":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kUsrV":[function(require,module,exports) {
var setPrototypeOf = require("56507d829b6b7d3d");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"56507d829b6b7d3d":"iyNOR"}],"iyNOR":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"f0luE":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hjdoh":[function(require,module,exports) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"6uI3m"}],"6uI3m":[function(require,module,exports) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"979to","2713647ce51d8c75":"3Msou"}],"979to":[function(require,module,exports) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"3Msou":[function(require,module,exports) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"979to"}],"jaMJH":[function(require,module,exports) {
var objectKeys = require("9d296fdae66bfcb1");
var isArguments = require("a56ef758adf731c7");
var is = require("e44b998993473df2");
var isRegex = require("73f9c073234120c3");
var flags = require("52fc175a677119d5");
var isDate = require("e3ca8205133ca3b6");
var getTime = Date.prototype.getTime;
function deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? is(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? is(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return objEquiv(actual, expected, opts);
}
function isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return true;
}
function objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if (isArguments(a) !== isArguments(b)) return false;
    var aIsRegex = isRegex(a);
    var bIsRegex = isRegex(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && flags(a) === flags(b);
    if (isDate(a) && isDate(b)) return getTime.call(a) === getTime.call(b);
    var aIsBuffer = isBuffer(a);
    var bIsBuffer = isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = objectKeys(a);
        var kb = objectKeys(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = deepEqual;

},{"9d296fdae66bfcb1":"7AE8b","a56ef758adf731c7":"ikBfj","e44b998993473df2":"41SFz","73f9c073234120c3":"YNqlw","52fc175a677119d5":"dXFr5","e3ca8205133ca3b6":"3HCJv"}],"7AE8b":[function(require,module,exports) {
"use strict";
var slice = Array.prototype.slice;
var isArgs = require("93e8460f624c96f4");
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : require("344bb0d7b2568e03");
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
module.exports = keysShim;

},{"93e8460f624c96f4":"hFngz","344bb0d7b2568e03":"5BYnt"}],"hFngz":[function(require,module,exports) {
"use strict";
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

},{}],"5BYnt":[function(require,module,exports) {
"use strict";
var keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = require("b0d8c8b84be91ffd"); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
    var dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = toStr.call(object) === "[object Function]";
        var isArguments = isArgs(object);
        var isString = isObject && toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = keysShim;

},{"b0d8c8b84be91ffd":"hFngz"}],"ikBfj":[function(require,module,exports) {
"use strict";
var hasToStringTag = require("e2b01ce809f132fb")();
var callBound = require("649cbf9949986a39");
var $toString = callBound("Object.prototype.toString");
var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $toString(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"e2b01ce809f132fb":"daNF4","649cbf9949986a39":"6cPux"}],"daNF4":[function(require,module,exports) {
"use strict";
var hasSymbols = require("2ef89576d4959bff");
module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"77zbC"}],"77zbC":[function(require,module,exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"6cPux":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"dRNto","266fc50410cfc4a":"hMR6y"}],"dRNto":[function(require,module,exports) {
"use strict";
var undefined1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var hasProto = require("23730654306aa64c")();
var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"1f00f712d594ccf":"9IzVf","23730654306aa64c":"cq3zS","7c5e688e48cd07b0":"jn7fQ","af36d49b4b8c6c7c":"aZ5G0"}],"9IzVf":[function(require,module,exports) {
"use strict";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"77zbC"}],"cq3zS":[function(require,module,exports) {
"use strict";
var test = {
    foo: {}
};
var $Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: test
    }).foo === test.foo && !(({
        __proto__: null
    }) instanceof $Object);
};

},{}],"jn7fQ":[function(require,module,exports) {
"use strict";
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"3CVeo"}],"3CVeo":[function(require,module,exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"aZ5G0":[function(require,module,exports) {
"use strict";
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"jn7fQ"}],"hMR6y":[function(require,module,exports) {
"use strict";
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var setFunctionLength = require("f4b53071c102d4e");
var $TypeError = GetIntrinsic("%TypeError%");
var $apply = GetIntrinsic("%Function.prototype.apply%");
var $call = GetIntrinsic("%Function.prototype.call%");
var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
var $max = GetIntrinsic("%Math.max%");
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $TypeError("a function is required");
    var func = $reflectApply(bind, $call, arguments);
    return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, "apply", {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"jn7fQ","68d2ad3775278f43":"dRNto","f4b53071c102d4e":"hRIKQ"}],"hRIKQ":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = GetIntrinsic("%TypeError%");
var $floor = GetIntrinsic("%Math.floor%");
module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && gOPD) {
        var desc = gOPD(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(fn, "length", length, true, true);
        else define(fn, "length", length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"dRNto","37dd1486f0f556ef":"l1706","6a9d2b46085df706":"gruPM","2d412b0f532d1834":"iyLmA"}],"l1706":[function(require,module,exports) {
"use strict";
var hasPropertyDescriptors = require("1ed580143eb408b3")();
var GetIntrinsic = require("971d0ad91a472750");
var $defineProperty = hasPropertyDescriptors && GetIntrinsic("%Object.defineProperty%", true);
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
var $SyntaxError = GetIntrinsic("%SyntaxError%");
var $TypeError = GetIntrinsic("%TypeError%");
var gopd = require("3f9bd39335781ec7");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

},{"1ed580143eb408b3":"gruPM","971d0ad91a472750":"dRNto","3f9bd39335781ec7":"iyLmA"}],"gruPM":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("b0bf8b8435d3abc");
var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!hasPropertyDescriptors()) return null;
    try {
        return $defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"b0bf8b8435d3abc":"dRNto"}],"iyLmA":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("693e651525841e04");
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"693e651525841e04":"dRNto"}],"41SFz":[function(require,module,exports) {
"use strict";
var define = require("7a0bb7df335a6af");
var callBind = require("794ce1103c4a65ba");
var implementation = require("f52a71fcf365d3bd");
var getPolyfill = require("59addbaef079e040");
var shim = require("c0e8b0f7342ba484");
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"7a0bb7df335a6af":"iXqnd","794ce1103c4a65ba":"hMR6y","f52a71fcf365d3bd":"kxFs1","59addbaef079e040":"gpUkX","c0e8b0f7342ba484":"235ds"}],"iXqnd":[function(require,module,exports) {
"use strict";
var keys = require("7ff177585d1618f0");
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = require("84ca194f5a28ce70");
var isFunction = function(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
};
var supportsDescriptors = require("c52d62086511583f")();
var defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!isFunction(predicate) || !predicate()) return;
    }
    if (supportsDescriptors) defineDataProperty(object, name, value, true);
    else defineDataProperty(object, name, value);
};
var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"7ff177585d1618f0":"7AE8b","84ca194f5a28ce70":"l1706","c52d62086511583f":"gruPM"}],"kxFs1":[function(require,module,exports) {
"use strict";
var numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN(a) && numberIsNaN(b)) return true;
    return false;
};

},{}],"gpUkX":[function(require,module,exports) {
"use strict";
var implementation = require("ff80ab827617d6fd");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : implementation;
};

},{"ff80ab827617d6fd":"kxFs1"}],"235ds":[function(require,module,exports) {
"use strict";
var getPolyfill = require("f188d636391a5061");
var define = require("155865cffc557cd");
module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

},{"f188d636391a5061":"gpUkX","155865cffc557cd":"iXqnd"}],"YNqlw":[function(require,module,exports) {
"use strict";
var callBound = require("5d96af94ba428cfc");
var hasToStringTag = require("a5e890a505b039e5")();
var has;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag) {
    has = callBound("Object.prototype.hasOwnProperty");
    $exec = callBound("RegExp.prototype.exec");
    isRegexMarker = {};
    var throwRegexMarker = function() {
        throw isRegexMarker;
    };
    badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") badStringifier[Symbol.toPrimitive] = throwRegexMarker;
}
var $toString = callBound("Object.prototype.toString");
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = "[object RegExp]";
module.exports = hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $exec(value, badStringifier);
    } catch (e) {
        return e === isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $toString(value) === regexClass;
};

},{"5d96af94ba428cfc":"6cPux","a5e890a505b039e5":"daNF4"}],"dXFr5":[function(require,module,exports) {
"use strict";
var define = require("234cd2776d15a037");
var callBind = require("6f662a760b1534f2");
var implementation = require("92a1454309a44466");
var getPolyfill = require("3ca514117a836edc");
var shim = require("e153862c910219d2");
var flagsBound = callBind(getPolyfill());
define(flagsBound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = flagsBound;

},{"234cd2776d15a037":"iXqnd","6f662a760b1534f2":"hMR6y","92a1454309a44466":"hbHj3","3ca514117a836edc":"kUBio","e153862c910219d2":"kJbzx"}],"hbHj3":[function(require,module,exports) {
"use strict";
var setFunctionName = require("73fe2073c023acf2");
var $Object = Object;
var $TypeError = TypeError;
module.exports = setFunctionName(function flags() {
    if (this != null && this !== $Object(this)) throw new $TypeError("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
}, "get flags", true);

},{"73fe2073c023acf2":"56KB4"}],"56KB4":[function(require,module,exports) {
"use strict";
var define = require("151b89e8a715d4f3");
var hasDescriptors = require("e4d428b901bb50")();
var functionsHaveConfigurableNames = require("ff3f0082d0e55515").functionsHaveConfigurableNames();
var $TypeError = TypeError;
module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || functionsHaveConfigurableNames) {
        if (hasDescriptors) define(fn, "name", name, true, true);
        else define(fn, "name", name);
    }
    return fn;
};

},{"151b89e8a715d4f3":"l1706","e4d428b901bb50":"gruPM","ff3f0082d0e55515":"c55xM"}],"c55xM":[function(require,module,exports) {
"use strict";
var functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) try {
    gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    gOPD = null;
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) return false;
    var desc = gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = functionsHaveNames;

},{}],"kUBio":[function(require,module,exports) {
"use strict";
var implementation = require("758a981608e1eeda");
var supportsDescriptors = require("6f5c0dd77da656ca").supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if (supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return implementation;
};

},{"758a981608e1eeda":"hbHj3","6f5c0dd77da656ca":"iXqnd"}],"kJbzx":[function(require,module,exports) {
"use strict";
var supportsDescriptors = require("d860dcb1943639b0").supportsDescriptors;
var getPolyfill = require("cdfc6652a32f035d");
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;
module.exports = function shimFlags() {
    if (!supportsDescriptors || !getProto) throw new TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = getPolyfill();
    var proto = getProto(regex);
    var descriptor = gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

},{"d860dcb1943639b0":"iXqnd","cdfc6652a32f035d":"kUBio"}],"3HCJv":[function(require,module,exports) {
"use strict";
var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
    try {
        getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var dateClass = "[object Date]";
var hasToStringTag = require("a0fda07f3b6c493a")();
module.exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

},{"a0fda07f3b6c493a":"daNF4"}],"1dDyS":[function(require,module,exports) {
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        "Edge",
        "Trident",
        "Firefox"
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, timeoutDuration);
        }
    };
}
var supportsMicroTasks = isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function getParentNode(element) {
    if (element.nodeName === "HTML") return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case "HTML":
        case "BODY":
            return element.ownerDocument.body;
        case "#document":
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return getScrollParent(getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function isIE(version) {
    if (version === 11) return isIE11;
    if (version === 10) return isIE10;
    return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        "TH",
        "TD",
        "TABLE"
    ].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, "position") === "static") return getOffsetParent(offsetParent);
    return offsetParent;
}
function isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") return false;
    return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function getRoot(node) {
    if (node.parentNode !== null) return getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if (isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = getRoot(element1);
    if (element1root.host) return findCommonOffsetParent(element1root.host, element2);
    else return findCommonOffsetParent(element1, getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = getScroll(element, "top");
    var scrollLeft = getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function getSize(axis, body, html, computedStyle) {
    return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = isIE(10) && getComputedStyle(html);
    return {
        height: getSize("Height", body, html, computedStyle),
        width: getSize("Width", body, html, computedStyle)
    };
}
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function getClientRect(offsets) {
    return _extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if (isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = getScroll(element, "top");
            var scrollLeft = getScroll(element, "left");
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = getStyleComputedProperty(element);
        horizScrollbar -= getBordersSize(styles, "x");
        vertScrollbar -= getBordersSize(styles, "y");
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = getBoundingClientRect(children);
    var parentRect = getBoundingClientRect(parent);
    var scrollParent = getScrollParent(children);
    var styles = getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = includeScroll(offsets, parent);
    return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if (getStyleComputedProperty(element, "position") === "fixed") return true;
    var parentNode = getParentNode(element);
    if (!parentNode) return false;
    return isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === "viewport") boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === "scrollParent") {
            boundariesNode = getScrollParent(getParentNode(reference));
            if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
            var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) return placement;
    var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return _extends({
            key: key
        }, rects[key], {
            area: getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function getOppositePlacement(placement) {
    var hash = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0];
    // Get popper node sizes
    var popperRect = getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        "right",
        "left"
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier["function"]) // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = getClientRect(data.offsets.popper);
            data.offsets.reference = getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
    // run the modifiers
    data = runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function getSupportedPropertyName(property) {
    var prefixes = [
        false,
        "ms",
        "Webkit",
        "Moz",
        "O"
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? "" + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if (isModifierEnabled(this.modifiers, "applyStyle")) {
        this.popper.removeAttribute("x-placement");
        this.popper.style.position = "";
        this.popper.style.top = "";
        this.popper.style.left = "";
        this.popper.style.right = "";
        this.popper.style.bottom = "";
        this.popper.style.willChange = "";
        this.popper.style[getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    getWindow(reference).addEventListener("resize", state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = getScrollParent(reference);
    attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function removeEventListeners(reference, state) {
    // Remove resize event listener on window
    getWindow(reference).removeEventListener("resize", state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener("scroll", state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = "";
        // add unit if the value is numeric and is one of the following
        if ([
            "width",
            "height",
            "top",
            "right",
            "bottom",
            "left"
        ].indexOf(prop) !== -1 && isNumeric(styles[prop])) unit = "px";
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute("x-placement", placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    setStyles(popper, {
        position: options.positionFixed ? "fixed" : "absolute"
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        "left",
        "right"
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
        return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = getOffsetParent(data.instance.popper);
    var offsetParentRect = getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right";
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = getSupportedPropertyName("transform");
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === "bottom") {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === "right") {
        if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = "transform";
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === "bottom" ? -1 : 1;
        var invertLeft = sideB === "right" ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ", " + sideB;
    }
    // Attributes
    var attributes = {
        "x-placement": data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = _extends({}, attributes, data.attributes);
    data.styles = _extends({}, styles, data.styles);
    data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = "`" + requestingName + "`";
        var requested = "`" + requestedName + "`";
        console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn("WARNING: `arrow.element` must be child of its popper element!");
        return data;
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        "left",
        "right"
    ].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
    var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function getOppositeVariation(variation) {
    if (variation === "end") return "start";
    else if (variation === "start") return "end";
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = validPlacements.indexOf(placement);
    var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise"
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if (isModifierEnabled(data.instance.modifiers, "inner")) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split("-")[0];
    var placementOpposite = getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch(options.behavior){
        case BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case BEHAVIORS.CLOCKWISE:
            flipOrder = clockwise(placement);
            break;
        case BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split("-")[0];
        placementOpposite = getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = getOppositeVariation(variation);
            data.placement = placement + (variation ? "-" + variation : "");
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = runModifiers(data.instance.modifiers, data, "flip");
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = [
        "top",
        "bottom"
    ].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf("%") === 0) {
        var element = void 0;
        switch(unit){
            case "%p":
                element = popperOffsets;
                break;
            case "%":
            case "%r":
            default:
                element = referenceOffsets;
        }
        var rect = getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === "vh" || unit === "vw") {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        "right",
        "left"
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf(find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === "" && [
                "+",
                "-"
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if (isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if (isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === "left") {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === "right") {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === "top") {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === "right" ? "left" : "top";
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
            return defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            "left",
            "top"
        ].indexOf(placement) !== -1 ? "primary" : "secondary";
        popper = _extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            "bottom",
            "top"
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        var shiftOffsets = {
            start: defineProperty({}, side, reference[side]),
            end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function hide(data) {
    if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
    var refRect = data.offsets.reference;
    var bound = find(data.instance.modifiers, function(modifier) {
        return modifier.name === "preventOverflow";
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        "left",
        "right"
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        "top",
        "left"
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = getOppositePlacement(placement);
    data.offsets.popper = getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: "scrollParent"
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: "flip",
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: "viewport",
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: "bottom",
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: "right"
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: applyStyle,
        /** @prop {Function} */ onLoad: applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: "bottom",
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = _extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return _extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    createClass(Popper, [
        {
            key: "update",
            value: function update$$1() {
                return update.call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy$$1() {
                return destroy.call(this);
            }
        },
        {
            key: "enableEventListeners",
            value: function enableEventListeners$$1() {
                return enableEventListeners.call(this);
            }
        },
        {
            key: "disableEventListeners",
            value: function disableEventListeners$$1() {
                return disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ Popper.Utils = (typeof window !== "undefined" ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
exports.default = Popper;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8ZFL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", ()=>ManagerReferenceNodeContext);
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", ()=>ManagerReferenceNodeSetterContext);
parcelHelpers.export(exports, "default", ()=>Manager);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _createReactContext = require("@hypnosphi/create-react-context");
var _createReactContextDefault = parcelHelpers.interopDefault(_createReactContext);
var ManagerReferenceNodeContext = (0, _createReactContextDefault.default)();
var ManagerReferenceNodeSetterContext = (0, _createReactContextDefault.default)();
var Manager = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Manager, _React$Component);
    function Manager() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "referenceNode", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setReferenceNode", function(newReferenceNode) {
            if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
                _this.referenceNode = newReferenceNode;
                _this.forceUpdate();
            }
        });
        return _this;
    }
    var _proto = Manager.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.referenceNode = null;
    };
    _proto.render = function render() {
        return _react.createElement(ManagerReferenceNodeContext.Provider, {
            value: this.referenceNode
        }, _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
            value: this.setReferenceNode
        }, this.props.children));
    };
    return Manager;
}(_react.Component);

},{"@babel/runtime/helpers/inheritsLoose":"kUsrV","@babel/runtime/helpers/assertThisInitialized":"f0luE","@babel/runtime/helpers/defineProperty":"hjdoh","react":"9njXz","@hypnosphi/create-react-context":"iI4v8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iI4v8":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _react = require("ddac09876d051a09");
var _react2 = _interopRequireDefault(_react);
var _implementation = require("73440850e08f5e9a");
var _implementation2 = _interopRequireDefault(_implementation);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports["default"];

},{"ddac09876d051a09":"9njXz","73440850e08f5e9a":"kP99i"}],"kP99i":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
var _react = require("b66096a24343785f");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("9a7f0b75e5abd6be");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _gud = require("c6e18d8274bd2f62");
var _gud2 = _interopRequireDefault(_gud);
var _warning = require("f3c3d30113536d1d");
var _warning2 = _interopRequireDefault(_warning);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + (0, _gud2.default)() + "__";
    var Provider = function(_Component) {
        _inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            _classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, "calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }(_react.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        _inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            _classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), _possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }(_react.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
exports.default = createReactContext;
module.exports = exports["default"];

},{"b66096a24343785f":"9njXz","9a7f0b75e5abd6be":"bnNSm","c6e18d8274bd2f62":"ecHJd","f3c3d30113536d1d":"4kUCc"}],"ecHJd":[function(require,module,exports) {
// @flow
var global = arguments[3];
"use strict";
var key = "__global_unique_id__";
module.exports = function() {
    return global[key] = (global[key] || 0) + 1;
};

},{}],"4kUCc":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = true;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"RIAfm":[function(require,module,exports) {
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", ()=>unwrapArray);
parcelHelpers.export(exports, "safeInvoke", ()=>safeInvoke);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "setRef", ()=>setRef);
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var shallowEqual = function shallowEqual(objA, objB) {
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    if (bKeys.length !== aKeys.length) return false;
    for(var i = 0; i < bKeys.length; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LY2i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Reference);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
var InnerReference = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InnerReference, _React$Component);
    function InnerReference() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "refHandler", function(node) {
            (0, _utils.setRef)(_this.props.innerRef, node);
            (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
        });
        return _this;
    }
    var _proto = InnerReference.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, _utils.setRef)(this.props.innerRef, null);
    };
    _proto.render = function render() {
        (0, _warningDefault.default)(Boolean(this.props.setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
        return (0, _utils.unwrapArray)(this.props.children)({
            ref: this.refHandler
        });
    };
    return InnerReference;
}(_react.Component);
function Reference(props) {
    return _react.createElement((0, _manager.ManagerReferenceNodeSetterContext).Consumer, null, function(setReferenceNode) {
        return _react.createElement(InnerReference, (0, _extendsDefault.default)({
            setReferenceNode: setReferenceNode
        }, props));
    });
}

},{"@babel/runtime/helpers/extends":"ktcBy","@babel/runtime/helpers/inheritsLoose":"kUsrV","@babel/runtime/helpers/assertThisInitialized":"f0luE","@babel/runtime/helpers/defineProperty":"hjdoh","react":"9njXz","warning":"4kUCc","./Manager":"i8ZFL","./utils":"RIAfm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dUz1l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownContext", ()=>DropdownContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DropdownContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jSBY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "divider",
    "tag",
    "header",
    "active",
    "text"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    active: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    divider: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    header: (0, _propTypesDefault.default).bool,
    onClick: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    toggle: (0, _propTypesDefault.default).bool,
    text: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    tag: "button",
    toggle: true
};
var DropdownItem = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(DropdownItem, _React$Component);
    function DropdownItem(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getTabIndex = _this.getTabIndex.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = DropdownItem.prototype;
    _proto.getRole = function getRole() {
        if (this.context.menuRole === "listbox") return "option";
        return "menuitem";
    };
    _proto.onClick = function onClick(e) {
        var _this$props = this.props, disabled = _this$props.disabled, header = _this$props.header, divider = _this$props.divider, text = _this$props.text;
        if (disabled || header || divider || text) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) this.props.onClick(e);
        if (this.props.toggle) this.context.toggle(e);
    };
    _proto.getTabIndex = function getTabIndex() {
        var _this$props2 = this.props, disabled = _this$props2.disabled, header = _this$props2.header, divider = _this$props2.divider, text = _this$props2.text;
        if (disabled || header || divider || text) return "-1";
        return "0";
    };
    _proto.render = function render() {
        var tabIndex = this.getTabIndex();
        var role = tabIndex > -1 ? this.getRole() : undefined;
        var _omit = (0, _utils.omit)(this.props, [
            "toggle"
        ]), className = _omit.className, cssModule = _omit.cssModule, divider = _omit.divider, Tag = _omit.tag, header = _omit.header, active = _omit.active, text = _omit.text, props = (0, _objectWithoutPropertiesLooseDefault.default)(_omit, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
            disabled: props.disabled,
            "dropdown-item": !divider && !header && !text,
            active: active,
            "dropdown-header": header,
            "dropdown-divider": divider,
            "dropdown-item-text": text
        }), cssModule);
        if (Tag === "button") {
            if (header) Tag = "h6";
            else if (divider) Tag = "div";
            else if (props.href) Tag = "a";
            else if (text) Tag = "span";
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            type: Tag === "button" && (props.onClick || this.props.toggle) ? "button" : undefined
        }, props, {
            tabIndex: tabIndex,
            role: role,
            className: classes,
            onClick: this.onClick
        }));
    };
    return DropdownItem;
}((0, _reactDefault.default).Component);
DropdownItem.propTypes = propTypes;
DropdownItem.defaultProps = defaultProps;
DropdownItem.contextType = (0, _dropdownContext.DropdownContext);
exports.default = DropdownItem;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./DropdownContext":"dUz1l","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hEatL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactPopper = require("react-popper");
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "right",
    "tag",
    "flip",
    "modifiers",
    "persist",
    "positionFixed",
    "container"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = {
    tag: (0, _utils.tagPropType),
    children: (0, _propTypesDefault.default).node.isRequired,
    right: (0, _propTypesDefault.default).bool,
    flip: (0, _propTypesDefault.default).bool,
    modifiers: (0, _propTypesDefault.default).object,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    persist: (0, _propTypesDefault.default).bool,
    positionFixed: (0, _propTypesDefault.default).bool,
    container: (0, _utils.targetPropType)
};
var defaultProps = {
    tag: "div",
    flip: true
};
var noFlipModifier = {
    flip: {
        enabled: false
    }
};
var directionPositionMap = {
    up: "top",
    left: "left",
    right: "right",
    down: "bottom"
};
var DropdownMenu = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(DropdownMenu, _React$Component);
    function DropdownMenu() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = DropdownMenu.prototype;
    _proto.getRole = function getRole() {
        if (this.context.menuRole === "listbox") return "listbox";
        return "menu";
    };
    _proto.render = function render() {
        var _this = this;
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, right = _this$props.right, tag = _this$props.tag, flip = _this$props.flip, modifiers = _this$props.modifiers, persist = _this$props.persist, positionFixed = _this$props.positionFixed, container = _this$props.container, attrs = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "dropdown-menu", {
            "dropdown-menu-right": right,
            show: this.context.isOpen
        }), cssModule);
        var Tag = tag;
        if (persist || this.context.isOpen && !this.context.inNavbar) {
            var position1 = directionPositionMap[this.context.direction] || "bottom";
            var position2 = right ? "end" : "start";
            var poperPlacement = position1 + "-" + position2;
            var poperModifiers = !flip ? _objectSpread(_objectSpread({}, modifiers), noFlipModifier) : modifiers;
            var popperPositionFixed = !!positionFixed;
            var popper = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Popper), {
                placement: poperPlacement,
                modifiers: poperModifiers,
                positionFixed: popperPositionFixed
            }, function(_ref) {
                var ref = _ref.ref, style = _ref.style, placement = _ref.placement;
                var combinedStyle = _objectSpread(_objectSpread({}, _this.props.style), style);
                var handleRef = function handleRef(tagRef) {
                    // Send the ref to `react-popper`
                    ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
                    // it will cause it to close
                    var onMenuRef = _this.context.onMenuRef;
                    if (onMenuRef) onMenuRef(tagRef);
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
                    tabIndex: "-1",
                    role: _this.getRole(),
                    ref: handleRef
                }, attrs, {
                    style: combinedStyle,
                    "aria-hidden": !_this.context.isOpen,
                    className: classes,
                    "x-placement": placement
                }));
            });
            if (container) return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(popper, (0, _utils.getTarget)(container));
            else return popper;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            tabIndex: "-1",
            role: this.getRole()
        }, attrs, {
            "aria-hidden": !this.context.isOpen,
            className: classes,
            "x-placement": attrs.placement
        }));
    };
    return DropdownMenu;
}((0, _reactDefault.default).Component);
DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
DropdownMenu.contextType = (0, _dropdownContext.DropdownContext);
exports.default = DropdownMenu;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/defineProperty":"5zOJa","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","react-dom":"2ApDx","classnames":"5Een2","react-popper":"lohlT","./DropdownContext":"dUz1l","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zOJa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(obj, key, value) {
    key = (0, _toPropertyKeyJsDefault.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61Sn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : String(i);
}

},{"./typeof.js":"la19k","./toPrimitive.js":"cVPci","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"la19k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVPci":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"la19k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9uLB8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactPopper = require("react-popper");
var _dropdownContext = require("./DropdownContext");
var _utils = require("./utils");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _excluded = [
    "className",
    "color",
    "cssModule",
    "caret",
    "split",
    "nav",
    "tag",
    "innerRef"
];
var propTypes = {
    caret: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    disabled: (0, _propTypesDefault.default).bool,
    onClick: (0, _propTypesDefault.default).func,
    "aria-haspopup": (0, _propTypesDefault.default).bool,
    split: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    nav: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    color: "secondary",
    "aria-haspopup": true
};
var DropdownToggle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(DropdownToggle, _React$Component);
    function DropdownToggle(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = DropdownToggle.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled || this.context.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.nav && !this.props.tag) e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
        this.context.toggle(e);
    };
    _proto.getRole = function getRole() {
        return this.context.menuRole || this.props["aria-haspopup"];
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, className = _this$props.className, color = _this$props.color, cssModule = _this$props.cssModule, caret = _this$props.caret, split = _this$props.split, nav = _this$props.nav, tag = _this$props.tag, innerRef = _this$props.innerRef, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var ariaLabel = props["aria-label"] || "Toggle Dropdown";
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, {
            "dropdown-toggle": caret || split,
            "dropdown-toggle-split": split,
            "nav-link": nav
        }), cssModule);
        var children = typeof props.children !== "undefined" ? props.children : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "sr-only"
        }, ariaLabel);
        var Tag;
        if (nav && !tag) {
            Tag = "a";
            props.href = "#";
        } else if (!tag) {
            Tag = (0, _buttonDefault.default);
            props.color = color;
            props.cssModule = cssModule;
        } else Tag = tag;
        if (this.context.inNavbar) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, props, {
            className: classes,
            onClick: this.onClick,
            "aria-expanded": this.context.isOpen,
            "aria-haspopup": this.getRole(),
            children: children
        }));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Reference), {
            innerRef: innerRef
        }, function(_ref) {
            var _ref2;
            var ref = _ref.ref;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === "string" ? "ref" : "innerRef"] = ref, _ref2), {
                className: classes,
                onClick: _this2.onClick,
                "aria-expanded": _this2.context.isOpen,
                "aria-haspopup": _this2.getRole(),
                children: children
            }));
        });
    };
    return DropdownToggle;
}((0, _reactDefault.default).Component);
DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
DropdownToggle.contextType = (0, _dropdownContext.DropdownContext);
exports.default = DropdownToggle;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","react-popper":"lohlT","./DropdownContext":"dUz1l","./utils":"gIzRi","./Button":"7coms","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kwBuH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("./utils");
var _excluded = [
    "tag",
    "baseClass",
    "baseClassActive",
    "className",
    "cssModule",
    "children",
    "innerRef"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).propTypes), {}, {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
        (0, _propTypesDefault.default).node
    ]),
    tag: (0, _utils.tagPropType),
    baseClass: (0, _propTypesDefault.default).string,
    baseClassActive: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
});
var defaultProps = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).defaultProps), {}, {
    tag: "div",
    baseClass: "fade",
    baseClassActive: "show",
    timeout: (0, _utils.TransitionTimeouts).Fade,
    appear: true,
    enter: true,
    exit: true,
    in: true
});
function Fade(props) {
    var Tag = props.tag, baseClass = props.baseClass, baseClassActive = props.baseClassActive, className = props.className, cssModule = props.cssModule, children = props.children, innerRef = props.innerRef, otherProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var transitionProps = (0, _utils.pick)(otherProps, (0, _utils.TransitionPropTypeKeys));
    var childProps = (0, _utils.omit)(otherProps, (0, _utils.TransitionPropTypeKeys));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), transitionProps, function(status) {
        var isActive = status === "entered";
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, baseClass, isActive && baseClassActive), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
            className: classes
        }, childProps, {
            ref: innerRef
        }), children);
    });
}
Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
exports.default = Fade;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/defineProperty":"5zOJa","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","react-transition-group":"cN5fd","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cN5fd":[function(require,module,exports) {
"use strict";
var _CSSTransition = _interopRequireDefault(require("8bfee68ff795128d"));
var _ReplaceTransition = _interopRequireDefault(require("c542d7d348a799bc"));
var _TransitionGroup = _interopRequireDefault(require("c0ea70f0f47bc59d"));
var _Transition = _interopRequireDefault(require("f390101c0f4be195"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = {
    Transition: _Transition.default,
    TransitionGroup: _TransitionGroup.default,
    ReplaceTransition: _ReplaceTransition.default,
    CSSTransition: _CSSTransition.default
};

},{"8bfee68ff795128d":"8HtvS","c542d7d348a799bc":"hBXD0","c0ea70f0f47bc59d":"6eGIQ","f390101c0f4be195":"2Aykb"}],"8HtvS":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var PropTypes = _interopRequireWildcard(require("f2a3e50c536fae0f"));
var _addClass = _interopRequireDefault(require("694ed92e2771eec2"));
var _removeClass = _interopRequireDefault(require("14b67602839c359a"));
var _react = _interopRequireDefault(require("f839b546a7c5d008"));
var _Transition = _interopRequireDefault(require("a36057805c73b37"));
var _PropTypes = require("a723ea4b292c544");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _addClass.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && removeClass(node, className);
        activeClassName && removeClass(node, activeClassName);
        doneClassName && removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = _extends({}, this.props);
        delete props.classNames;
        return _react.default.createElement(_Transition.default, _extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}(_react.default.Component);
CSSTransition.defaultProps = {
    classNames: ""
};
CSSTransition.propTypes = _extends({}, _Transition.default.propTypes, {
    /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */ classNames: _PropTypes.classNamesShape,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEnter: PropTypes.func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: PropTypes.func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntered: PropTypes.func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */ onExit: PropTypes.func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */ onExiting: PropTypes.func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */ onExited: PropTypes.func
});
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

},{"f2a3e50c536fae0f":"bnNSm","694ed92e2771eec2":"8H7U5","14b67602839c359a":"gfB73","f839b546a7c5d008":"9njXz","a36057805c73b37":"2Aykb","a723ea4b292c544":"7jHR8"}],"8H7U5":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a3ff600ca6bfd2cd");
exports.__esModule = true;
exports.default = addClass;
var _hasClass = _interopRequireDefault(require("460f4cc64e5850f6"));
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = exports["default"];

},{"a3ff600ca6bfd2cd":"kZ6eK","460f4cc64e5850f6":"jwfRV"}],"kZ6eK":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jwfRV":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = hasClass;
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

},{}],"gfB73":[function(require,module,exports) {
"use strict";
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
};

},{}],"2Aykb":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
var PropTypes = _interopRequireWildcard(require("e127ce950a0781ce"));
var _react = _interopRequireDefault(require("e965df18f394fb02"));
var _reactDom = _interopRequireDefault(require("fbea1bd81de077af"));
var _reactLifecyclesCompat = require("e061c13ca3e27047");
var _PropTypes = require("8030f812aab3636c");
var _TransitionGroupContext = _interopRequireDefault(require("bbb054715ca992be"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var UNMOUNTED = "unmounted";
exports.UNMOUNTED = UNMOUNTED;
var EXITED = "exited";
exports.EXITED = EXITED;
var ENTERING = "entering";
exports.ENTERING = ENTERING;
var ENTERED = "entered";
exports.ENTERED = ENTERED;
var EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ exports.EXITING = EXITING;
var Transition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = _reactDom.default.findDOMNode(this);
            if (nextStatus === ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = _objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") // allows for nested Transitions
        return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: null
        }, children(status, childProps));
        var child = _react.default.Children.only(children);
        return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: null
        }, _react.default.cloneElement(child, childProps));
    };
    return Transition;
}(_react.default.Component);
Transition.contextType = _TransitionGroupContext.default;
Transition.propTypes = {
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: PropTypes.oneOfType([
        PropTypes.func.isRequired,
        PropTypes.element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: PropTypes.bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: PropTypes.bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: PropTypes.bool,
    /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */ appear: PropTypes.bool,
    /**
   * Enable or disable enter transitions.
   */ enter: PropTypes.bool,
    /**
   * Enable or disable exit transitions.
   */ exit: PropTypes.bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = _PropTypes.timeoutsShape;
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: PropTypes.func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: PropTypes.func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: PropTypes.func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: PropTypes.func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: PropTypes.func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: PropTypes.func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: PropTypes.func // Name the function so it is clearer in the documentation
};
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
exports.default = _default;

},{"e127ce950a0781ce":"bnNSm","e965df18f394fb02":"9njXz","fbea1bd81de077af":"2ApDx","e061c13ca3e27047":"9jQEY","8030f812aab3636c":"7jHR8","bbb054715ca992be":"iOxfR"}],"9jQEY":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7jHR8":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;
var _propTypes = _interopRequireDefault(require("cc5f4aaee211ee"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var timeoutsShape = _propTypes.default.oneOfType([
    _propTypes.default.number,
    _propTypes.default.shape({
        enter: _propTypes.default.number,
        exit: _propTypes.default.number,
        appear: _propTypes.default.number
    }).isRequired
]);
exports.timeoutsShape = timeoutsShape;
var classNamesShape = _propTypes.default.oneOfType([
    _propTypes.default.string,
    _propTypes.default.shape({
        enter: _propTypes.default.string,
        exit: _propTypes.default.string,
        active: _propTypes.default.string
    }),
    _propTypes.default.shape({
        enter: _propTypes.default.string,
        enterDone: _propTypes.default.string,
        enterActive: _propTypes.default.string,
        exit: _propTypes.default.string,
        exitDone: _propTypes.default.string,
        exitActive: _propTypes.default.string
    })
]);
exports.classNamesShape = classNamesShape;

},{"cc5f4aaee211ee":"bnNSm"}],"iOxfR":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("29353d6fc52e19c0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = _react.default.createContext(null);
exports.default = _default;
module.exports = exports["default"];

},{"29353d6fc52e19c0":"9njXz"}],"hBXD0":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("45c9bc64d4d6bccd"));
var _react = _interopRequireDefault(require("b73fe14ab058d72"));
var _reactDom = require("7ff2b3445fa5026e");
var _TransitionGroup = _interopRequireDefault(require("6ce223923339bf27"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = _react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = _objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = _react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : _react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}(_react.default.Component);
ReplaceTransition.propTypes = {
    in: _propTypes.default.bool.isRequired,
    children: function children(props, propName) {
        if (_react.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');
        return null;
    }
};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

},{"45c9bc64d4d6bccd":"bnNSm","b73fe14ab058d72":"9njXz","7ff2b3445fa5026e":"2ApDx","6ce223923339bf27":"6eGIQ"}],"6eGIQ":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("2ebcb01af4674c13"));
var _react = _interopRequireDefault(require("5be31f0ea626c7d4"));
var _reactLifecyclesCompat = require("5451653a763ef126");
var _TransitionGroupContext = _interopRequireDefault(require("c0bcd7012e8ff9b5"));
var _ChildMapping = require("38e37bb9524bb96e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = _extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: contextValue
        }, children);
        return _react.default.createElement(_TransitionGroupContext.default.Provider, {
            value: contextValue
        }, _react.default.createElement(Component, props, children));
    };
    return TransitionGroup;
}(_react.default.Component);
TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: _propTypes.default.any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: _propTypes.default.node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: _propTypes.default.bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: _propTypes.default.bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: _propTypes.default.bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: _propTypes.default.func
};
TransitionGroup.defaultProps = defaultProps;
var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
exports.default = _default;
module.exports = exports["default"];

},{"2ebcb01af4674c13":"bnNSm","5be31f0ea626c7d4":"9njXz","5451653a763ef126":"9jQEY","c0bcd7012e8ff9b5":"iOxfR","38e37bb9524bb96e":"dizhJ"}],"dizhJ":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;
var _react = require("219f56f8a3fa16bd");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) _react.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, "appear", props),
            enter: getProp(child, "enter", props),
            exit: getProp(child, "exit", props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
    });
    return children;
}

},{"219f56f8a3fa16bd":"9njXz"}],"Cuhve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "color",
    "body",
    "inverse",
    "outline",
    "tag",
    "innerRef"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    inverse: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    body: (0, _propTypesDefault.default).bool,
    outline: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    tag: "div"
};
var Card = function Card(props) {
    var className = props.className, cssModule = props.cssModule, color = props.color, body = props.body, inverse = props.inverse, outline = props.outline, Tag = props.tag, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "card", inverse ? "text-white" : false, body ? "card-body" : false, color ? (outline ? "border" : "bg") + "-" + color : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
exports.default = Card;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hB1zW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "innerRef",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    tag: "div"
};
var CardBody = function CardBody(props) {
    var className = props.className, cssModule = props.cssModule, innerRef = props.innerRef, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "card-body"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
CardBody.propTypes = propTypes;
CardBody.defaultProps = defaultProps;
exports.default = CardBody;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lmzTf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var CardHeader = function CardHeader(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "card-header"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;
exports.default = CardHeader;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bFs6I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var CardTitle = function CardTitle(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "card-title"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
CardTitle.propTypes = propTypes;
CardTitle.defaultProps = defaultProps;
exports.default = CardTitle;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a77zB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactPopper = require("react-popper");
var _utils = require("./utils");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _excluded = [
    "cssModule",
    "children",
    "isOpen",
    "flip",
    "target",
    "offset",
    "fallbackPlacement",
    "placementPrefix",
    "arrowClassName",
    "hideArrow",
    "popperClassName",
    "tag",
    "container",
    "modifiers",
    "positionFixed",
    "boundariesElement",
    "onClosed",
    "fade",
    "transition",
    "placement"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function noop() {}
var propTypes = {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]).isRequired,
    popperClassName: (0, _propTypesDefault.default).string,
    placement: (0, _propTypesDefault.default).string,
    placementPrefix: (0, _propTypesDefault.default).string,
    arrowClassName: (0, _propTypesDefault.default).string,
    hideArrow: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    isOpen: (0, _propTypesDefault.default).bool.isRequired,
    cssModule: (0, _propTypesDefault.default).object,
    offset: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    fallbackPlacement: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).array
    ]),
    flip: (0, _propTypesDefault.default).bool,
    container: (0, _utils.targetPropType),
    target: (0, _utils.targetPropType).isRequired,
    modifiers: (0, _propTypesDefault.default).object,
    positionFixed: (0, _propTypesDefault.default).bool,
    boundariesElement: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _utils.DOMElement)
    ]),
    onClosed: (0, _propTypesDefault.default).func,
    fade: (0, _propTypesDefault.default).bool,
    transition: (0, _propTypesDefault.default).shape((0, _fadeDefault.default).propTypes)
};
var defaultProps = {
    boundariesElement: "scrollParent",
    placement: "auto",
    hideArrow: false,
    isOpen: false,
    offset: 0,
    fallbackPlacement: "flip",
    flip: true,
    container: "body",
    modifiers: {},
    onClosed: noop,
    fade: true,
    transition: _objectSpread({}, (0, _fadeDefault.default).defaultProps)
};
var PopperContent = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(PopperContent, _React$Component);
    function PopperContent(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.setTargetNode = _this.setTargetNode.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getTargetNode = _this.getTargetNode.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onClosed = _this.onClosed.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            isOpen: props.isOpen
        };
        return _this;
    }
    PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    };
    var _proto = PopperContent.prototype;
    _proto.componentDidUpdate = function componentDidUpdate() {
        if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) this._element.childNodes[0].focus();
    };
    _proto.setTargetNode = function setTargetNode(node) {
        this.targetNode = typeof node === "string" ? (0, _utils.getTarget)(node) : node;
    };
    _proto.getTargetNode = function getTargetNode() {
        return this.targetNode;
    };
    _proto.getContainerNode = function getContainerNode() {
        return (0, _utils.getTarget)(this.props.container);
    };
    _proto.getRef = function getRef(ref) {
        this._element = ref;
    };
    _proto.onClosed = function onClosed() {
        this.props.onClosed();
        this.setState({
            isOpen: false
        });
    };
    _proto.renderChildren = function renderChildren() {
        var _this$props = this.props, cssModule = _this$props.cssModule, children = _this$props.children, isOpen = _this$props.isOpen, flip = _this$props.flip, target = _this$props.target, offset = _this$props.offset, fallbackPlacement = _this$props.fallbackPlacement, placementPrefix = _this$props.placementPrefix, _arrowClassName = _this$props.arrowClassName, hideArrow = _this$props.hideArrow, _popperClassName = _this$props.popperClassName, tag = _this$props.tag, container = _this$props.container, modifiers = _this$props.modifiers, positionFixed = _this$props.positionFixed, boundariesElement = _this$props.boundariesElement, onClosed = _this$props.onClosed, fade = _this$props.fade, transition = _this$props.transition, placement = _this$props.placement, attrs = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var arrowClassName = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("arrow", _arrowClassName), cssModule);
        var popperClassName = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(_popperClassName, placementPrefix ? placementPrefix + "-auto" : ""), this.props.cssModule);
        var extendedModifiers = _objectSpread({
            offset: {
                offset: offset
            },
            flip: {
                enabled: flip,
                behavior: fallbackPlacement
            },
            preventOverflow: {
                boundariesElement: boundariesElement
            }
        }, modifiers);
        var popperTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), transition), {}, {
            baseClass: fade ? transition.baseClass : "",
            timeout: fade ? transition.timeout : 0
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, popperTransition, attrs, {
            in: isOpen,
            onExited: this.onClosed,
            tag: tag
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactPopper.Popper), {
            referenceElement: this.targetNode,
            modifiers: extendedModifiers,
            placement: placement,
            positionFixed: positionFixed
        }, function(_ref) {
            var ref = _ref.ref, style = _ref.style, placement = _ref.placement, outOfBoundaries = _ref.outOfBoundaries, arrowProps = _ref.arrowProps, scheduleUpdate = _ref.scheduleUpdate;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                ref: ref,
                style: style,
                className: popperClassName,
                "x-placement": placement,
                "x-out-of-boundaries": outOfBoundaries ? "true" : undefined
            }, typeof children === "function" ? children({
                scheduleUpdate: scheduleUpdate
            }) : children, !hideArrow && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                ref: arrowProps.ref,
                className: arrowClassName,
                style: arrowProps.style
            }));
        }));
    };
    _proto.render = function render() {
        this.setTargetNode(this.props.target);
        if (this.state.isOpen) return this.props.container === "inline" ? this.renderChildren() : /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.getRef
        }, this.renderChildren()), this.getContainerNode());
        return null;
    };
    return PopperContent;
}((0, _reactDefault.default).Component);
PopperContent.propTypes = propTypes;
PopperContent.defaultProps = defaultProps;
exports.default = PopperContent;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","@babel/runtime/helpers/esm/defineProperty":"5zOJa","react":"9njXz","prop-types":"bnNSm","react-dom":"2ApDx","classnames":"5Een2","react-popper":"lohlT","./utils":"gIzRi","./Fade":"kwBuH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hysNz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "children",
    "className",
    "barClassName",
    "cssModule",
    "value",
    "min",
    "max",
    "animated",
    "striped",
    "color",
    "bar",
    "multi",
    "tag",
    "style",
    "barStyle",
    "barAriaValueText",
    "barAriaLabelledBy"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    bar: (0, _propTypesDefault.default).bool,
    multi: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    min: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    max: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    animated: (0, _propTypesDefault.default).bool,
    striped: (0, _propTypesDefault.default).bool,
    color: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    barClassName: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    style: (0, _propTypesDefault.default).object,
    barStyle: (0, _propTypesDefault.default).object,
    barAriaValueText: (0, _propTypesDefault.default).string,
    barAriaLabelledBy: (0, _propTypesDefault.default).string
};
var defaultProps = {
    tag: "div",
    value: 0,
    min: 0,
    max: 100,
    style: {},
    barStyle: {}
};
var Progress = function Progress(props) {
    var children = props.children, className = props.className, barClassName = props.barClassName, cssModule = props.cssModule, value = props.value, min = props.min, max = props.max, animated = props.animated, striped = props.striped, color = props.color, bar = props.bar, multi = props.multi, Tag = props.tag, style = props.style, barStyle = props.barStyle, barAriaValueText = props.barAriaValueText, barAriaLabelledBy = props.barAriaLabelledBy, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var percent = (0, _utils.toNumber)(value) / (0, _utils.toNumber)(max) * 100;
    var progressClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "progress"), cssModule);
    var progressBarClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("progress-bar", bar ? className || barClassName : barClassName, animated ? "progress-bar-animated" : null, color ? "bg-" + color : null, striped || animated ? "progress-bar-striped" : null), cssModule);
    var progressBarProps = {
        className: progressBarClasses,
        style: _objectSpread(_objectSpread(_objectSpread({}, bar ? style : {}), barStyle), {}, {
            width: percent + "%"
        }),
        role: "progressbar",
        "aria-valuenow": value,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuetext": barAriaValueText,
        "aria-labelledby": barAriaLabelledBy,
        children: children
    };
    if (bar) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, progressBarProps));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        style: style,
        className: progressClasses
    }), multi ? children : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", progressBarProps));
};
Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;
exports.default = Progress;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/defineProperty":"5zOJa","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k2AXs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function noop() {}
var FadePropTypes = (0, _propTypesDefault.default).shape((0, _fadeDefault.default).propTypes);
var propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    autoFocus: (0, _propTypesDefault.default).bool,
    centered: (0, _propTypesDefault.default).bool,
    scrollable: (0, _propTypesDefault.default).bool,
    size: (0, _propTypesDefault.default).string,
    toggle: (0, _propTypesDefault.default).func,
    keyboard: (0, _propTypesDefault.default).bool,
    role: (0, _propTypesDefault.default).string,
    labelledBy: (0, _propTypesDefault.default).string,
    backdrop: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).oneOf([
            "static"
        ])
    ]),
    onEnter: (0, _propTypesDefault.default).func,
    onExit: (0, _propTypesDefault.default).func,
    onOpened: (0, _propTypesDefault.default).func,
    onClosed: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    wrapClassName: (0, _propTypesDefault.default).string,
    modalClassName: (0, _propTypesDefault.default).string,
    backdropClassName: (0, _propTypesDefault.default).string,
    contentClassName: (0, _propTypesDefault.default).string,
    external: (0, _propTypesDefault.default).node,
    fade: (0, _propTypesDefault.default).bool,
    cssModule: (0, _propTypesDefault.default).object,
    zIndex: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    backdropTransition: FadePropTypes,
    modalTransition: FadePropTypes,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    unmountOnClose: (0, _propTypesDefault.default).bool,
    returnFocusAfterClose: (0, _propTypesDefault.default).bool,
    container: (0, _utils.targetPropType),
    trapFocus: (0, _propTypesDefault.default).bool
};
var propsToOmit = Object.keys(propTypes);
var defaultProps = {
    isOpen: false,
    autoFocus: true,
    centered: false,
    scrollable: false,
    role: "dialog",
    backdrop: true,
    keyboard: true,
    zIndex: 1050,
    fade: true,
    onOpened: noop,
    onClosed: noop,
    modalTransition: {
        timeout: (0, _utils.TransitionTimeouts).Modal
    },
    backdropTransition: {
        mountOnEnter: true,
        timeout: (0, _utils.TransitionTimeouts).Fade // uses standard fade transition
    },
    unmountOnClose: true,
    returnFocusAfterClose: true,
    container: "body",
    trapFocus: false
};
var Modal = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Modal, _React$Component);
    function Modal(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._element = null;
        _this._originalBodyPadding = null;
        _this.getFocusableChildren = _this.getFocusableChildren.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleBackdropClick = _this.handleBackdropClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleStaticBackdropAnimation = _this.handleStaticBackdropAnimation.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleTab = _this.handleTab.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onOpened = _this.onOpened.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onClosed = _this.onClosed.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.clearBackdropAnimationTimeout = _this.clearBackdropAnimationTimeout.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.trapFocus = _this.trapFocus.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            isOpen: false,
            showStaticBackdropAnimation: false
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this$props = this.props, isOpen = _this$props.isOpen, autoFocus = _this$props.autoFocus, onEnter = _this$props.onEnter;
        if (isOpen) {
            this.init();
            this.setState({
                isOpen: true
            });
            if (autoFocus) this.setFocus();
        }
        if (onEnter) onEnter();
         // traps focus inside the Modal, even if the browser address bar is focused
        document.addEventListener("focus", this.trapFocus, true);
        this._isMounted = true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.init();
            this.setState({
                isOpen: true
            }); // let render() renders Modal Dialog first
            return;
        } // now Modal Dialog is rendered and we can refer this._element and this._dialog
        if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) this.setFocus();
        if (this._element && prevProps.zIndex !== this.props.zIndex) this._element.style.zIndex = this.props.zIndex;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.clearBackdropAnimationTimeout();
        if (this.props.onExit) this.props.onExit();
        if (this._element) {
            this.destroy();
            if (this.props.isOpen || this.state.isOpen) this.close();
        }
        document.removeEventListener("focus", this.trapFocus, true);
        this._isMounted = false;
    };
    _proto.trapFocus = function trapFocus(ev) {
        if (!this.props.trapFocus) return;
        if (!this._element) return;
        if (this._dialog && this._dialog.parentNode === ev.target) return;
        if (this.modalIndex < Modal.openCount - 1) return;
        var children = this.getFocusableChildren();
        for(var i = 0; i < children.length; i++){
            // focus is already inside the Modal
            if (children[i] === ev.target) return;
        }
        if (children.length > 0) {
            // otherwise focus the first focusable element in the Modal
            ev.preventDefault();
            ev.stopPropagation();
            children[0].focus();
        }
    };
    _proto.onOpened = function onOpened(node, isAppearing) {
        this.props.onOpened();
        (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    };
    _proto.onClosed = function onClosed(node) {
        var unmountOnClose = this.props.unmountOnClose; // so all methods get called before it is unmounted
        this.props.onClosed();
        (this.props.modalTransition.onExited || noop)(node);
        if (unmountOnClose) this.destroy();
        this.close();
        if (this._isMounted) this.setState({
            isOpen: false
        });
    };
    _proto.setFocus = function setFocus() {
        if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === "function") this._dialog.parentNode.focus();
    };
    _proto.getFocusableChildren = function getFocusableChildren() {
        return this._element.querySelectorAll((0, _utils.focusableElements).join(", "));
    };
    _proto.getFocusedChild = function getFocusedChild() {
        var currentFocus;
        var focusableChildren = this.getFocusableChildren();
        try {
            currentFocus = document.activeElement;
        } catch (err) {
            currentFocus = focusableChildren[0];
        }
        return currentFocus;
    } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
    ;
    _proto.handleBackdropClick = function handleBackdropClick(e) {
        if (e.target === this._mouseDownElement) {
            e.stopPropagation();
            var backdrop = this._dialog ? this._dialog.parentNode : null;
            if (backdrop && e.target === backdrop && this.props.backdrop === "static") this.handleStaticBackdropAnimation();
            if (!this.props.isOpen || this.props.backdrop !== true) return;
            if (backdrop && e.target === backdrop && this.props.toggle) this.props.toggle(e);
        }
    };
    _proto.handleTab = function handleTab(e) {
        if (e.which !== 9) return;
        if (this.modalIndex < Modal.openCount - 1) return; // last opened modal
        var focusableChildren = this.getFocusableChildren();
        var totalFocusable = focusableChildren.length;
        if (totalFocusable === 0) return;
        var currentFocus = this.getFocusedChild();
        var focusedIndex = 0;
        for(var i = 0; i < totalFocusable; i += 1)if (focusableChildren[i] === currentFocus) {
            focusedIndex = i;
            break;
        }
        if (e.shiftKey && focusedIndex === 0) {
            e.preventDefault();
            focusableChildren[totalFocusable - 1].focus();
        } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
            e.preventDefault();
            focusableChildren[0].focus();
        }
    };
    _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
        this._mouseDownElement = e.target;
    };
    _proto.handleEscape = function handleEscape(e) {
        if (this.props.isOpen && e.keyCode === (0, _utils.keyCodes).esc && this.props.toggle) {
            if (this.props.keyboard) {
                e.preventDefault();
                e.stopPropagation();
                this.props.toggle(e);
            } else if (this.props.backdrop === "static") {
                e.preventDefault();
                e.stopPropagation();
                this.handleStaticBackdropAnimation();
            }
        }
    };
    _proto.handleStaticBackdropAnimation = function handleStaticBackdropAnimation() {
        var _this2 = this;
        this.clearBackdropAnimationTimeout();
        this.setState({
            showStaticBackdropAnimation: true
        });
        this._backdropAnimationTimeout = setTimeout(function() {
            _this2.setState({
                showStaticBackdropAnimation: false
            });
        }, 100);
    };
    _proto.init = function init() {
        try {
            this._triggeringElement = document.activeElement;
        } catch (err) {
            this._triggeringElement = null;
        }
        if (!this._element) {
            this._element = document.createElement("div");
            this._element.setAttribute("tabindex", "-1");
            this._element.style.position = "relative";
            this._element.style.zIndex = this.props.zIndex;
            this._mountContainer = (0, _utils.getTarget)(this.props.container);
            this._mountContainer.appendChild(this._element);
        }
        this._originalBodyPadding = (0, _utils.getOriginalBodyPadding)();
        (0, _utils.conditionallyUpdateScrollbar)();
        if (Modal.openCount === 0) document.body.className = (0, _classnamesDefault.default)(document.body.className, (0, _utils.mapToCssModules)("modal-open", this.props.cssModule));
        this.modalIndex = Modal.openCount;
        Modal.openCount += 1;
    };
    _proto.destroy = function destroy() {
        if (this._element) {
            this._mountContainer.removeChild(this._element);
            this._element = null;
        }
        this.manageFocusAfterClose();
    };
    _proto.manageFocusAfterClose = function manageFocusAfterClose() {
        if (this._triggeringElement) {
            var returnFocusAfterClose = this.props.returnFocusAfterClose;
            if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
            this._triggeringElement = null;
        }
    };
    _proto.close = function close() {
        if (Modal.openCount <= 1) {
            var modalOpenClassName = (0, _utils.mapToCssModules)("modal-open", this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
            var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
            document.body.className = document.body.className.replace(modalOpenClassNameRegex, " ").trim();
        }
        this.manageFocusAfterClose();
        Modal.openCount = Math.max(0, Modal.openCount - 1);
        (0, _utils.setScrollbarWidth)(this._originalBodyPadding);
    };
    _proto.renderModalDialog = function renderModalDialog() {
        var _classNames, _this3 = this;
        var attributes = (0, _utils.omit)(this.props, propsToOmit);
        var dialogBaseClass = "modal-dialog";
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({}, attributes, {
            className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames[dialogBaseClass + "-scrollable"] = this.props.scrollable, _classNames)), this.props.cssModule),
            role: "document",
            ref: function ref(c) {
                _this3._dialog = c;
            }
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("modal-content", this.props.contentClassName), this.props.cssModule)
        }, this.props.children));
    };
    _proto.render = function render() {
        var unmountOnClose = this.props.unmountOnClose;
        if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
            var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
            this._element.style.display = isModalHidden ? "none" : "block";
            var _this$props2 = this.props, wrapClassName = _this$props2.wrapClassName, modalClassName = _this$props2.modalClassName, backdropClassName = _this$props2.backdropClassName, cssModule = _this$props2.cssModule, isOpen = _this$props2.isOpen, backdrop = _this$props2.backdrop, role = _this$props2.role, labelledBy = _this$props2.labelledBy, external = _this$props2.external, innerRef = _this$props2.innerRef;
            var modalAttributes = {
                onClick: this.handleBackdropClick,
                onMouseDown: this.handleBackdropMouseDown,
                onKeyUp: this.handleEscape,
                onKeyDown: this.handleTab,
                style: {
                    display: "block"
                },
                "aria-labelledby": labelledBy,
                role: role,
                tabIndex: "-1"
            };
            var hasTransition = this.props.fade;
            var modalTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), this.props.modalTransition), {}, {
                baseClass: hasTransition ? this.props.modalTransition.baseClass : "",
                timeout: hasTransition ? this.props.modalTransition.timeout : 0
            });
            var backdropTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), this.props.backdropTransition), {}, {
                baseClass: hasTransition ? this.props.backdropTransition.baseClass : "",
                timeout: hasTransition ? this.props.backdropTransition.timeout : 0
            });
            var Backdrop = backdrop && (hasTransition ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, backdropTransition, {
                in: isOpen && !!backdrop,
                cssModule: cssModule,
                className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("modal-backdrop", backdropClassName), cssModule)
            })) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("modal-backdrop", "show", backdropClassName), cssModule)
            }));
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalDefault.default), {
                node: this._element
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _utils.mapToCssModules)(wrapClassName)
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, modalAttributes, modalTransition, {
                in: isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("modal", modalClassName, this.state.showStaticBackdropAnimation && "modal-static"), cssModule),
                innerRef: innerRef
            }), external, this.renderModalDialog()), Backdrop));
        }
        return null;
    };
    _proto.clearBackdropAnimationTimeout = function clearBackdropAnimationTimeout() {
        if (this._backdropAnimationTimeout) {
            clearTimeout(this._backdropAnimationTimeout);
            this._backdropAnimationTimeout = undefined;
        }
    };
    return Modal;
}((0, _reactDefault.default).Component);
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.openCount = 0;
exports.default = Modal;

},{"@babel/runtime/helpers/esm/defineProperty":"5zOJa","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./Portal":"bViZ7","./Fade":"kwBuH","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bViZ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("./utils");
var propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    node: (0, _propTypesDefault.default).any
};
var Portal = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Portal, _React$Component);
    function Portal() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Portal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.defaultNode) document.body.removeChild(this.defaultNode);
        this.defaultNode = null;
    };
    _proto.render = function render() {
        if (!(0, _utils.canUseDOM)) return null;
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = document.createElement("div");
            document.body.appendChild(this.defaultNode);
        }
        return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(this.props.children, this.props.node || this.defaultNode);
    };
    return Portal;
}((0, _reactDefault.default).Component);
Portal.propTypes = propTypes;
exports.default = Portal;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","react-dom":"2ApDx","prop-types":"bnNSm","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fu5sV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "children",
    "toggle",
    "tag",
    "wrapTag",
    "closeAriaLabel",
    "charCode",
    "close"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    wrapTag: (0, _utils.tagPropType),
    toggle: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).node,
    closeAriaLabel: (0, _propTypesDefault.default).string,
    charCode: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    close: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "h5",
    wrapTag: "div",
    closeAriaLabel: "Close",
    charCode: 215
};
var ModalHeader = function ModalHeader(props) {
    var closeButton;
    var className = props.className, cssModule = props.cssModule, children = props.children, toggle = props.toggle, Tag = props.tag, WrapTag = props.wrapTag, closeAriaLabel = props.closeAriaLabel, charCode = props.charCode, close = props.close, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "modal-header"), cssModule);
    if (!close && toggle) {
        var closeIcon = typeof charCode === "number" ? String.fromCharCode(charCode) : charCode;
        closeButton = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            onClick: toggle,
            className: (0, _utils.mapToCssModules)("close", cssModule),
            "aria-label": closeAriaLabel
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true"
        }, closeIcon));
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapTag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, {
        className: (0, _utils.mapToCssModules)("modal-title", cssModule)
    }, children), close || closeButton);
};
ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
exports.default = ModalHeader;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0Ijt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var ModalBody = function ModalBody(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "modal-body"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
exports.default = ModalBody;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7uFZp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var ModalFooter = function ModalFooter(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "modal-footer"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
exports.default = ModalFooter;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jFOD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _tooltipPopoverWrapper = require("./TooltipPopoverWrapper");
var _tooltipPopoverWrapperDefault = parcelHelpers.interopDefault(_tooltipPopoverWrapper);
var defaultProps = {
    placement: "top",
    autohide: true,
    placementPrefix: "bs-tooltip",
    trigger: "hover focus"
};
var Tooltip = function Tooltip(props) {
    var popperClasses = (0, _classnamesDefault.default)("tooltip", "show", props.popperClassName);
    var classes = (0, _classnamesDefault.default)("tooltip-inner", props.innerClassName);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipPopoverWrapperDefault.default), (0, _extendsDefault.default)({}, props, {
        popperClassName: popperClasses,
        innerClassName: classes
    }));
};
Tooltip.propTypes = (0, _tooltipPopoverWrapper.propTypes);
Tooltip.defaultProps = defaultProps;
exports.default = Tooltip;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","classnames":"5Een2","./TooltipPopoverWrapper":"dw63l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dw63l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propTypes", ()=>propTypes);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _popperContent = require("./PopperContent");
var _popperContentDefault = parcelHelpers.interopDefault(_popperContent);
var _utils = require("./utils");
var propTypes = {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    placement: (0, _propTypesDefault.default).oneOf((0, _utils.PopperPlacements)),
    target: (0, _utils.targetPropType).isRequired,
    container: (0, _utils.targetPropType),
    isOpen: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    hideArrow: (0, _propTypesDefault.default).bool,
    boundariesElement: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _utils.DOMElement)
    ]),
    className: (0, _propTypesDefault.default).string,
    innerClassName: (0, _propTypesDefault.default).string,
    arrowClassName: (0, _propTypesDefault.default).string,
    popperClassName: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    toggle: (0, _propTypesDefault.default).func,
    autohide: (0, _propTypesDefault.default).bool,
    placementPrefix: (0, _propTypesDefault.default).string,
    delay: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).shape({
            show: (0, _propTypesDefault.default).number,
            hide: (0, _propTypesDefault.default).number
        }),
        (0, _propTypesDefault.default).number
    ]),
    modifiers: (0, _propTypesDefault.default).object,
    positionFixed: (0, _propTypesDefault.default).bool,
    offset: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    trigger: (0, _propTypesDefault.default).string,
    fade: (0, _propTypesDefault.default).bool,
    flip: (0, _propTypesDefault.default).bool
};
var DEFAULT_DELAYS = {
    show: 0,
    hide: 50
};
var defaultProps = {
    isOpen: false,
    hideArrow: false,
    autohide: false,
    delay: DEFAULT_DELAYS,
    toggle: function toggle() {},
    trigger: "click",
    fade: true
};
function isInDOMSubtree(element, subtreeRoot) {
    return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}
function isInDOMSubtrees(element, subtreeRoots) {
    if (subtreeRoots === void 0) subtreeRoots = [];
    return subtreeRoots && subtreeRoots.length && subtreeRoots.filter(function(subTreeRoot) {
        return isInDOMSubtree(element, subTreeRoot);
    })[0];
}
var TooltipPopoverWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TooltipPopoverWrapper, _React$Component);
    function TooltipPopoverWrapper(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._targets = [];
        _this.currentTargetElement = null;
        _this.addTargetEvents = _this.addTargetEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.removeTargetEvents = _this.removeTargetEvents.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.showWithDelay = _this.showWithDelay.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hideWithDelay = _this.hideWithDelay.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.show = _this.show.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.hide = _this.hide.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.onEscKeyDown = _this.onEscKeyDown.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.state = {
            isOpen: props.isOpen
        };
        _this._isMounted = false;
        return _this;
    }
    var _proto = TooltipPopoverWrapper.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.updateTarget();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        this.removeTargetEvents();
        this._targets = null;
        this.clearShowTimeout();
        this.clearHideTimeout();
    };
    TooltipPopoverWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    };
    _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
        if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.state.isOpen && !this.props.isOpen) this.toggle();
        }
    };
    _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
        if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
            if (this._showTimeout) this.clearShowTimeout();
            e.persist();
            this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
        }
    };
    _proto.onEscKeyDown = function onEscKeyDown(e) {
        if (e.key === "Escape") this.hide(e);
    };
    _proto.getRef = function getRef(ref) {
        var innerRef = this.props.innerRef;
        if (innerRef) {
            if (typeof innerRef === "function") innerRef(ref);
            else if (typeof innerRef === "object") innerRef.current = ref;
        }
        this._popover = ref;
    };
    _proto.getDelay = function getDelay(key) {
        var delay = this.props.delay;
        if (typeof delay === "object") return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
        return delay;
    };
    _proto.getCurrentTarget = function getCurrentTarget(target) {
        if (!target) return null;
        var index = this._targets.indexOf(target);
        if (index >= 0) return this._targets[index];
        return this.getCurrentTarget(target.parentElement);
    };
    _proto.show = function show(e) {
        if (!this.props.isOpen) {
            this.clearShowTimeout();
            this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;
            if (e && e.composedPath && typeof e.composedPath === "function") {
                var path = e.composedPath();
                this.currentTargetElement = path && path[0] || this.currentTargetElement;
            }
            this.toggle(e);
        }
    };
    _proto.showWithDelay = function showWithDelay(e) {
        if (this._hideTimeout) this.clearHideTimeout();
        this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay("show"));
    };
    _proto.hide = function hide(e) {
        if (this.props.isOpen) {
            this.clearHideTimeout();
            this.currentTargetElement = null;
            this.toggle(e);
        }
    };
    _proto.hideWithDelay = function hideWithDelay(e) {
        if (this._showTimeout) this.clearShowTimeout();
        this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
    };
    _proto.clearShowTimeout = function clearShowTimeout() {
        clearTimeout(this._showTimeout);
        this._showTimeout = undefined;
    };
    _proto.clearHideTimeout = function clearHideTimeout() {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = undefined;
    };
    _proto.handleDocumentClick = function handleDocumentClick(e) {
        var triggers = this.props.trigger.split(" ");
        if (triggers.indexOf("legacy") > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) this.hideWithDelay(e);
            else if (!this.props.isOpen) this.showWithDelay(e);
        } else if (triggers.indexOf("click") > -1 && isInDOMSubtrees(e.target, this._targets)) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (!this.props.isOpen) this.showWithDelay(e);
            else this.hideWithDelay(e);
        }
    };
    _proto.addEventOnTargets = function addEventOnTargets(type, handler, isBubble) {
        this._targets.forEach(function(target) {
            target.addEventListener(type, handler, isBubble);
        });
    };
    _proto.removeEventOnTargets = function removeEventOnTargets(type, handler, isBubble) {
        this._targets.forEach(function(target) {
            target.removeEventListener(type, handler, isBubble);
        });
    };
    _proto.addTargetEvents = function addTargetEvents() {
        if (this.props.trigger) {
            var triggers = this.props.trigger.split(" ");
            if (triggers.indexOf("manual") === -1) {
                if (triggers.indexOf("click") > -1 || triggers.indexOf("legacy") > -1) document.addEventListener("click", this.handleDocumentClick, true);
                if (this._targets && this._targets.length) {
                    if (triggers.indexOf("hover") > -1) {
                        this.addEventOnTargets("mouseover", this.showWithDelay, true);
                        this.addEventOnTargets("mouseout", this.hideWithDelay, true);
                    }
                    if (triggers.indexOf("focus") > -1) {
                        this.addEventOnTargets("focusin", this.show, true);
                        this.addEventOnTargets("focusout", this.hide, true);
                    }
                    this.addEventOnTargets("keydown", this.onEscKeyDown, true);
                }
            }
        }
    };
    _proto.removeTargetEvents = function removeTargetEvents() {
        if (this._targets) {
            this.removeEventOnTargets("mouseover", this.showWithDelay, true);
            this.removeEventOnTargets("mouseout", this.hideWithDelay, true);
            this.removeEventOnTargets("keydown", this.onEscKeyDown, true);
            this.removeEventOnTargets("focusin", this.show, true);
            this.removeEventOnTargets("focusout", this.hide, true);
        }
        document.removeEventListener("click", this.handleDocumentClick, true);
    };
    _proto.updateTarget = function updateTarget() {
        var newTarget = (0, _utils.getTarget)(this.props.target, true);
        if (newTarget !== this._targets) {
            this.removeTargetEvents();
            this._targets = newTarget ? Array.from(newTarget) : [];
            this.currentTargetElement = this.currentTargetElement || this._targets[0];
            this.addTargetEvents();
        }
    };
    _proto.toggle = function toggle(e) {
        if (this.props.disabled || !this._isMounted) return e && e.preventDefault();
        return this.props.toggle(e);
    };
    _proto.render = function render() {
        var _this2 = this;
        if (this.props.isOpen) this.updateTarget();
        var target = this.currentTargetElement || this._targets[0];
        if (!target) return null;
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, innerClassName = _this$props.innerClassName, isOpen = _this$props.isOpen, hideArrow = _this$props.hideArrow, boundariesElement = _this$props.boundariesElement, placement = _this$props.placement, placementPrefix = _this$props.placementPrefix, arrowClassName = _this$props.arrowClassName, popperClassName = _this$props.popperClassName, container = _this$props.container, modifiers = _this$props.modifiers, positionFixed = _this$props.positionFixed, offset = _this$props.offset, fade = _this$props.fade, flip = _this$props.flip, children = _this$props.children;
        var attributes = (0, _utils.omit)(this.props, Object.keys(propTypes));
        var popperClasses = (0, _utils.mapToCssModules)(popperClassName, cssModule);
        var classes = (0, _utils.mapToCssModules)(innerClassName, cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popperContentDefault.default), {
            className: className,
            target: target,
            isOpen: isOpen,
            hideArrow: hideArrow,
            boundariesElement: boundariesElement,
            placement: placement,
            placementPrefix: placementPrefix,
            arrowClassName: arrowClassName,
            popperClassName: popperClasses,
            container: container,
            modifiers: modifiers,
            positionFixed: positionFixed,
            offset: offset,
            cssModule: cssModule,
            fade: fade,
            flip: flip
        }, function(_ref) {
            var scheduleUpdate = _ref.scheduleUpdate;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({}, attributes, {
                ref: _this2.getRef,
                className: classes,
                role: "tooltip",
                onMouseOver: _this2.onMouseOverTooltipContent,
                onMouseLeave: _this2.onMouseLeaveTooltipContent,
                onKeyDown: _this2.onEscKeyDown
            }), typeof children === "function" ? children({
                scheduleUpdate: scheduleUpdate
            }) : children);
        });
    };
    return TooltipPopoverWrapper;
}((0, _reactDefault.default).Component);
TooltipPopoverWrapper.propTypes = propTypes;
TooltipPopoverWrapper.defaultProps = defaultProps;
exports.default = TooltipPopoverWrapper;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","./PopperContent":"a77zB","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5CVnB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "size",
    "bordered",
    "borderless",
    "striped",
    "dark",
    "hover",
    "responsive",
    "tag",
    "responsiveTag",
    "innerRef"
];
var propTypes = {
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    size: (0, _propTypesDefault.default).string,
    bordered: (0, _propTypesDefault.default).bool,
    borderless: (0, _propTypesDefault.default).bool,
    striped: (0, _propTypesDefault.default).bool,
    dark: (0, _propTypesDefault.default).bool,
    hover: (0, _propTypesDefault.default).bool,
    responsive: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    tag: (0, _utils.tagPropType),
    responsiveTag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ])
};
var defaultProps = {
    tag: "table",
    responsiveTag: "div"
};
var Table = function Table(props) {
    var className = props.className, cssModule = props.cssModule, size = props.size, bordered = props.bordered, borderless = props.borderless, striped = props.striped, dark = props.dark, hover = props.hover, responsive = props.responsive, Tag = props.tag, ResponsiveTag = props.responsiveTag, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "table", size ? "table-" + size : false, bordered ? "table-bordered" : false, borderless ? "table-borderless" : false, striped ? "table-striped" : false, dark ? "table-dark" : false, hover ? "table-hover" : false), cssModule);
    var table = /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        ref: innerRef,
        className: classes
    }));
    if (responsive) {
        var responsiveClassName = (0, _utils.mapToCssModules)(responsive === true ? "table-responsive" : "table-responsive-" + responsive, cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(ResponsiveTag, {
            className: responsiveClassName
        }, table);
    }
    return table;
};
Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
exports.default = Table;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ECXs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "inline",
    "tag",
    "innerRef"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    inline: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "form"
};
var Form = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(Form, _Component);
    function Form(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.submit = _this.submit.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = Form.prototype;
    _proto.getRef = function getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    };
    _proto.submit = function submit() {
        if (this.ref) this.ref.submit();
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, inline = _this$props.inline, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, inline ? "form-inline" : false), cssModule);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            ref: innerRef,
            className: classes
        }));
    };
    return Form;
}((0, _react.Component));
Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
exports.default = Form;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rrrt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "valid",
    "tooltip",
    "tag"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    valid: (0, _propTypesDefault.default).bool,
    tooltip: (0, _propTypesDefault.default).bool
};
var defaultProps = {
    tag: "div",
    valid: undefined
};
var FormFeedback = function FormFeedback(props) {
    var className = props.className, cssModule = props.cssModule, valid = props.valid, tooltip = props.tooltip, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var validMode = tooltip ? "tooltip" : "feedback";
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, valid ? "valid-" + validMode : "invalid-" + validMode), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
FormFeedback.propTypes = propTypes;
FormFeedback.defaultProps = defaultProps;
exports.default = FormFeedback;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4C5hq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "row",
    "disabled",
    "check",
    "inline",
    "tag"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    row: (0, _propTypesDefault.default).bool,
    check: (0, _propTypesDefault.default).bool,
    inline: (0, _propTypesDefault.default).bool,
    disabled: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var FormGroup = function FormGroup(props) {
    var className = props.className, cssModule = props.cssModule, row = props.row, disabled = props.disabled, check = props.check, inline = props.inline, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, row ? "row" : false, check ? "form-check" : "form-group", check && inline ? "form-check-inline" : false, check && disabled ? "disabled" : false), cssModule);
    if (Tag === "fieldset") attributes.disabled = disabled;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
FormGroup.propTypes = propTypes;
FormGroup.defaultProps = defaultProps;
exports.default = FormGroup;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jF6wA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
/* eslint react/prefer-stateless-function: 0 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "type",
    "bsSize",
    "valid",
    "invalid",
    "tag",
    "addon",
    "plaintext",
    "innerRef"
];
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    type: (0, _propTypesDefault.default).string,
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    bsSize: (0, _propTypesDefault.default).string,
    valid: (0, _propTypesDefault.default).bool,
    invalid: (0, _propTypesDefault.default).bool,
    tag: (0, _utils.tagPropType),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string
    ]),
    plaintext: (0, _propTypesDefault.default).bool,
    addon: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    type: "text"
};
var Input = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Input, _React$Component);
    function Input(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.getRef = _this.getRef.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.focus = _this.focus.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = Input.prototype;
    _proto.getRef = function getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    };
    _proto.focus = function focus() {
        if (this.ref) this.ref.focus();
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, type = _this$props.type, bsSize = _this$props.bsSize, valid = _this$props.valid, invalid = _this$props.invalid, tag = _this$props.tag, addon = _this$props.addon, plaintext = _this$props.plaintext, innerRef = _this$props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var checkInput = [
            "radio",
            "checkbox"
        ].indexOf(type) > -1;
        var isNotaNumber = new RegExp("\\D", "g");
        var fileInput = type === "file";
        var textareaInput = type === "textarea";
        var selectInput = type === "select";
        var rangeInput = type === "range";
        var Tag = tag || (selectInput || textareaInput ? type : "input");
        var formControlClass = "form-control";
        if (plaintext) {
            formControlClass = formControlClass + "-plaintext";
            Tag = tag || "input";
        } else if (fileInput) formControlClass = formControlClass + "-file";
        else if (rangeInput) formControlClass = formControlClass + "-range";
        else if (checkInput) {
            if (addon) formControlClass = null;
            else formControlClass = "form-check-input";
        }
        if (attributes.size && isNotaNumber.test(attributes.size)) {
            (0, _utils.warnOnce)('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
            bsSize = attributes.size;
            delete attributes.size;
        }
        var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, invalid && "is-invalid", valid && "is-valid", bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
        if (Tag === "input" || tag && typeof tag === "function") attributes.type = type;
        if (attributes.children && !(plaintext || type === "select" || typeof Tag !== "string" || Tag === "select")) {
            (0, _utils.warnOnce)('Input with a type of "' + type + '" cannot have children. Please use "value"/"defaultValue" instead.');
            delete attributes.children;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
            ref: innerRef,
            className: classes,
            "aria-invalid": invalid
        }));
    };
    return Input;
}((0, _reactDefault.default).Component);
Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
exports.default = Input;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"48DIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "size"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    size: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var InputGroup = function InputGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, size = props.size, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "input-group", size ? "input-group-" + size : null), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;
exports.default = InputGroup;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avymG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _inputGroupText = require("./InputGroupText");
var _inputGroupTextDefault = parcelHelpers.interopDefault(_inputGroupText);
var _excluded = [
    "className",
    "cssModule",
    "tag",
    "addonType",
    "children"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    addonType: (0, _propTypesDefault.default).oneOf([
        "prepend",
        "append"
    ]).isRequired,
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "div"
};
var InputGroupAddon = function InputGroupAddon(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, addonType = props.addonType, children = props.children, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "input-group-" + addonType), cssModule); // Convenience to assist with transition
    if (typeof children === "string") return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inputGroupTextDefault.default), {
        children: children
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes,
        children: children
    }));
};
InputGroupAddon.propTypes = propTypes;
InputGroupAddon.defaultProps = defaultProps;
exports.default = InputGroupAddon;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","./InputGroupText":"6nuKb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6nuKb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "tag"
];
var propTypes = {
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object
};
var defaultProps = {
    tag: "span"
};
var InputGroupText = function InputGroupText(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "input-group-text"), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, attributes, {
        className: classes
    }));
};
InputGroupText.propTypes = propTypes;
InputGroupText.defaultProps = defaultProps;
exports.default = InputGroupText;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ZGRu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _excluded = [
    "className",
    "cssModule",
    "hidden",
    "widths",
    "tag",
    "check",
    "size",
    "for"
];
var colWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var stringOrNumberProp = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).string
]);
var columnProps = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).bool,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).shape({
        size: stringOrNumberProp,
        order: stringOrNumberProp,
        offset: stringOrNumberProp
    })
]);
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    hidden: (0, _propTypesDefault.default).bool,
    check: (0, _propTypesDefault.default).bool,
    size: (0, _propTypesDefault.default).string,
    for: (0, _propTypesDefault.default).string,
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    xs: columnProps,
    sm: columnProps,
    md: columnProps,
    lg: columnProps,
    xl: columnProps,
    widths: (0, _propTypesDefault.default).array
};
var defaultProps = {
    tag: "label",
    widths: colWidths
};
var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
    if (colSize === true || colSize === "") return isXs ? "col" : "col-" + colWidth;
    else if (colSize === "auto") return isXs ? "col-auto" : "col-" + colWidth + "-auto";
    return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};
var Label = function Label(props) {
    var className = props.className, cssModule = props.cssModule, hidden = props.hidden, widths = props.widths, Tag = props.tag, check = props.check, size = props.size, htmlFor = props.for, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var columnProp = props[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== "") return;
        var isXs = !i;
        var colClass;
        if ((0, _utils.isObject)(columnProp)) {
            var _classNames;
            var colSizeInterfix = isXs ? "-" : "-" + colWidth + "-";
            colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
            colClasses.push((0, _utils.mapToCssModules)((0, _classnamesDefault.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === "", _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
        } else {
            colClass = getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(colClass);
        }
    });
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, hidden ? "sr-only" : false, check ? "form-check-label" : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? "col-form-label" : false), cssModule);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({
        htmlFor: htmlFor
    }, attributes, {
        className: classes
    }));
};
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
exports.default = Label;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ottv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("./utils");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _excluded = [
    "className",
    "closeClassName",
    "closeAriaLabel",
    "cssModule",
    "tag",
    "color",
    "isOpen",
    "toggle",
    "children",
    "transition",
    "fade",
    "innerRef"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = {
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    closeClassName: (0, _propTypesDefault.default).string,
    closeAriaLabel: (0, _propTypesDefault.default).string,
    cssModule: (0, _propTypesDefault.default).object,
    color: (0, _propTypesDefault.default).string,
    fade: (0, _propTypesDefault.default).bool,
    isOpen: (0, _propTypesDefault.default).bool,
    toggle: (0, _propTypesDefault.default).func,
    tag: (0, _utils.tagPropType),
    transition: (0, _propTypesDefault.default).shape((0, _fadeDefault.default).propTypes),
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ])
};
var defaultProps = {
    color: "success",
    isOpen: true,
    tag: "div",
    closeAriaLabel: "Close",
    fade: true,
    transition: _objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), {}, {
        unmountOnExit: true
    })
};
function Alert(props) {
    var className = props.className, closeClassName = props.closeClassName, closeAriaLabel = props.closeAriaLabel, cssModule = props.cssModule, Tag = props.tag, color = props.color, isOpen = props.isOpen, toggle = props.toggle, children = props.children, transition = props.transition, fade = props.fade, innerRef = props.innerRef, attributes = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, "alert", "alert-" + color, {
        "alert-dismissible": toggle
    }), cssModule);
    var closeClasses = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)("close", closeClassName), cssModule);
    var alertTransition = _objectSpread(_objectSpread(_objectSpread({}, (0, _fadeDefault.default).defaultProps), transition), {}, {
        baseClass: fade ? transition.baseClass : "",
        timeout: fade ? transition.timeout : 0
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fadeDefault.default), (0, _extendsDefault.default)({}, attributes, alertTransition, {
        tag: Tag,
        className: classes,
        in: isOpen,
        role: "alert",
        innerRef: innerRef
    }), toggle ? /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: closeClasses,
        "aria-label": closeAriaLabel,
        onClick: toggle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true"
    }, "\xd7")) : null, children);
}
Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
exports.default = Alert;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/defineProperty":"5zOJa","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","./utils":"gIzRi","./Fade":"kwBuH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Q6Yw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("./utils");
var _excluded = [
    "tag",
    "isOpen",
    "className",
    "navbar",
    "cssModule",
    "children",
    "innerRef"
];
var _transitionStatusToCl;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var propTypes = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).propTypes), {}, {
    isOpen: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
        (0, _propTypesDefault.default).node
    ]),
    tag: (0, _utils.tagPropType),
    className: (0, _propTypesDefault.default).node,
    navbar: (0, _propTypesDefault.default).bool,
    cssModule: (0, _propTypesDefault.default).object,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ])
});
var defaultProps = _objectSpread(_objectSpread({}, (0, _reactTransitionGroup.Transition).defaultProps), {}, {
    isOpen: false,
    appear: false,
    enter: true,
    exit: true,
    tag: "div",
    timeout: (0, _utils.TransitionTimeouts).Collapse
});
var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[(0, _utils.TransitionStatuses).ENTERING] = "collapsing", _transitionStatusToCl[(0, _utils.TransitionStatuses).ENTERED] = "collapse show", _transitionStatusToCl[(0, _utils.TransitionStatuses).EXITING] = "collapsing", _transitionStatusToCl[(0, _utils.TransitionStatuses).EXITED] = "collapse", _transitionStatusToCl);
function getTransitionClass(status) {
    return transitionStatusToClassHash[status] || "collapse";
}
function getHeight(node) {
    return node.scrollHeight;
}
var Collapse = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(Collapse, _Component);
    function Collapse(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            height: null
        };
        [
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited"
        ].forEach(function(name) {
            _this[name] = _this[name].bind((0, _assertThisInitializedDefault.default)(_this));
        });
        return _this;
    }
    var _proto = Collapse.prototype;
    _proto.onEntering = function onEntering(node, isAppearing) {
        this.setState({
            height: getHeight(node)
        });
        this.props.onEntering(node, isAppearing);
    };
    _proto.onEntered = function onEntered(node, isAppearing) {
        this.setState({
            height: null
        });
        this.props.onEntered(node, isAppearing);
    };
    _proto.onExit = function onExit(node) {
        this.setState({
            height: getHeight(node)
        });
        this.props.onExit(node);
    };
    _proto.onExiting = function onExiting(node) {
        // getting this variable triggers a reflow
        var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
        this.setState({
            height: 0
        });
        this.props.onExiting(node);
    };
    _proto.onExited = function onExited(node) {
        this.setState({
            height: null
        });
        this.props.onExited(node);
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, Tag = _this$props.tag, isOpen = _this$props.isOpen, className = _this$props.className, navbar = _this$props.navbar, cssModule = _this$props.cssModule, children = _this$props.children, innerRef = _this$props.innerRef, otherProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, _excluded);
        var height = this.state.height;
        var transitionProps = (0, _utils.pick)(otherProps, (0, _utils.TransitionPropTypeKeys));
        var childProps = (0, _utils.omit)(otherProps, (0, _utils.TransitionPropTypeKeys));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), (0, _extendsDefault.default)({}, transitionProps, {
            in: isOpen,
            onEntering: this.onEntering,
            onEntered: this.onEntered,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }), function(status) {
            var collapseClass = getTransitionClass(status);
            var classes = (0, _utils.mapToCssModules)((0, _classnamesDefault.default)(className, collapseClass, navbar && "navbar-collapse"), cssModule);
            var style = height === null ? null : {
                height: height
            };
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, (0, _extendsDefault.default)({}, childProps, {
                style: _objectSpread(_objectSpread({}, childProps.style), style),
                className: classes,
                ref: _this2.props.innerRef
            }), children);
        });
    };
    return Collapse;
}((0, _react.Component));
Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
exports.default = Collapse;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","@babel/runtime/helpers/esm/defineProperty":"5zOJa","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","react-transition-group":"cN5fd","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"89BHQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var UncontrolledAlert = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledAlert, _Component);
    function UncontrolledAlert(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: true
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledAlert.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _alertDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, this.props));
    };
    return UncontrolledAlert;
}((0, _react.Component));
exports.default = UncontrolledAlert;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","./Alert":"1ottv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01xUr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UncontrolledDropdown);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var omitKeys = [
    "defaultOpen"
];
var UncontrolledDropdown = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledDropdown, _Component);
    function UncontrolledDropdown(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledDropdown.prototype;
    _proto.toggle = function toggle(e) {
        var _this2 = this;
        var isOpen = !this.state.isOpen;
        this.setState({
            isOpen: isOpen
        }, function() {
            if (_this2.props.onToggle) _this2.props.onToggle(e, isOpen);
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropdownDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, _utils.omit)(this.props, omitKeys)));
    };
    return UncontrolledDropdown;
}((0, _react.Component));
UncontrolledDropdown.propTypes = _objectSpread({
    defaultOpen: (0, _propTypesDefault.default).bool,
    onToggle: (0, _propTypesDefault.default).func
}, (0, _dropdownDefault.default).propTypes);

},{"@babel/runtime/helpers/esm/defineProperty":"5zOJa","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","./Dropdown":"7eEBk","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97tdP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UncontrolledTooltip);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _utils = require("./utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var omitKeys = [
    "defaultOpen"
];
var UncontrolledTooltip = /*#__PURE__*/ function(_Component) {
    (0, _inheritsLooseDefault.default)(UncontrolledTooltip, _Component);
    function UncontrolledTooltip(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, _assertThisInitializedDefault.default)(_this));
        return _this;
    }
    var _proto = UncontrolledTooltip.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), (0, _extendsDefault.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, _utils.omit)(this.props, omitKeys)));
    };
    return UncontrolledTooltip;
}((0, _react.Component));
UncontrolledTooltip.propTypes = _objectSpread({
    defaultOpen: (0, _propTypesDefault.default).bool
}, (0, _tooltipDefault.default).propTypes);

},{"@babel/runtime/helpers/esm/defineProperty":"5zOJa","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","./Tooltip":"2jFOD","./utils":"gIzRi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ejwp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReactTooltip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _uuid = require("uuid");
var global = arguments[3];
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self1);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var objectGetOwnPropertyDescriptor = {};
var fails$9 = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var fails$8 = fails$9;
// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var fails$7 = fails$9;
var functionBindNative = !fails$7(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var NATIVE_BIND$2 = functionBindNative;
var call$4 = Function.prototype.call;
var functionCall = NATIVE_BIND$2 ? call$4.bind(call$4) : function() {
    return call$4.apply(call$4, arguments);
};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var createPropertyDescriptor$2 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var NATIVE_BIND$1 = functionBindNative;
var FunctionPrototype$1 = Function.prototype;
var call$3 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND$1 && FunctionPrototype$1.bind.bind(call$3, call$3);
var functionUncurryThisRaw = function(fn) {
    return NATIVE_BIND$1 ? uncurryThisWithBind(fn) : function() {
        return call$3.apply(fn, arguments);
    };
};
var uncurryThisRaw$1 = functionUncurryThisRaw;
var toString$1 = uncurryThisRaw$1({}.toString);
var stringSlice = uncurryThisRaw$1("".slice);
var classofRaw$2 = function(it) {
    return stringSlice(toString$1(it), 8, -1);
};
var classofRaw$1 = classofRaw$2;
var uncurryThisRaw = functionUncurryThisRaw;
var functionUncurryThis = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if (classofRaw$1(fn) === "Function") return uncurryThisRaw(fn);
};
var uncurryThis$9 = functionUncurryThis;
var fails$6 = fails$9;
var classof$3 = classofRaw$2;
var $Object$3 = Object;
var split = uncurryThis$9("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object$3("z").propertyIsEnumerable(0);
}) ? function(it) {
    return classof$3(it) == "String" ? split(it, "") : $Object$3(it);
} : $Object$3;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function(it) {
    return it === null || it === undefined;
};
var isNullOrUndefined$1 = isNullOrUndefined$2;
var $TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function(it) {
    if (isNullOrUndefined$1(it)) throw $TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;
var toIndexedObject$4 = function(it) {
    return IndexedObject$1(requireObjectCoercible$1(it));
};
var documentAll$2 = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll$2 == "undefined" && documentAll$2 !== undefined;
var documentAll_1 = {
    all: documentAll$2,
    IS_HTMLDDA: IS_HTMLDDA
};
var $documentAll$1 = documentAll_1;
var documentAll$1 = $documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$c = $documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === documentAll$1;
} : function(argument) {
    return typeof argument == "function";
};
var isCallable$b = isCallable$c;
var $documentAll = documentAll_1;
var documentAll = $documentAll.all;
var isObject$6 = $documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : isCallable$b(it) || it === documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : isCallable$b(it);
};
var global$9 = global$a;
var isCallable$a = isCallable$c;
var aFunction = function(argument) {
    return isCallable$a(argument) ? argument : undefined;
};
var getBuiltIn$5 = function(namespace, method) {
    return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};
var uncurryThis$8 = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$8({}.isPrototypeOf);
var getBuiltIn$4 = getBuiltIn$5;
var engineUserAgent = getBuiltIn$4("navigator", "userAgent") || "";
var global$8 = global$a;
var userAgent = engineUserAgent;
var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
var engineV8Version = version;
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = engineV8Version;
var fails$5 = fails$9;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$5(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var getBuiltIn$3 = getBuiltIn$5;
var isCallable$9 = isCallable$c;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var $Object$2 = Object;
var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = getBuiltIn$3("Symbol");
    return isCallable$9($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
};
var $String$1 = String;
var tryToString$1 = function(argument) {
    try {
        return $String$1(argument);
    } catch (error) {
        return "Object";
    }
};
var isCallable$8 = isCallable$c;
var tryToString = tryToString$1;
var $TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var aCallable$2 = function(argument) {
    if (isCallable$8(argument)) return argument;
    throw $TypeError$4(tryToString(argument) + " is not a function");
};
var aCallable$1 = aCallable$2;
var isNullOrUndefined = isNullOrUndefined$2;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable$1(func);
};
var call$2 = functionCall;
var isCallable$7 = isCallable$c;
var isObject$5 = isObject$6;
var $TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
    if (isCallable$7(fn = input.valueOf) && !isObject$5(val = call$2(fn, input))) return val;
    if (pref !== "string" && isCallable$7(fn = input.toString) && !isObject$5(val = call$2(fn, input))) return val;
    throw $TypeError$3("Can't convert object to primitive value");
};
var shared$3 = {
    exports: {}
};
var global$7 = global$a;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;
var defineGlobalProperty$3 = function(key, value) {
    try {
        defineProperty$2(global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        global$7[key] = value;
    }
    return value;
};
var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;
var SHARED = "__core-js_shared__";
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});
var sharedStore = store$3;
var store$2 = sharedStore;
(shared$3.exports = function(key, value) {
    return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.25.5",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var requireObjectCoercible = requireObjectCoercible$2;
var $Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function(argument) {
    return $Object$1(requireObjectCoercible(argument));
};
var uncurryThis$7 = functionUncurryThis;
var toObject$1 = toObject$2;
var hasOwnProperty = uncurryThis$7({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject$1(it), key);
};
var uncurryThis$6 = functionUncurryThis;
var id = 0;
var postfix = Math.random();
var toString = uncurryThis$6(1.0.toString);
var uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
};
var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var WellKnownSymbolsStore = shared$2("wks");
var Symbol$1 = global$5.Symbol;
var symbolFor = Symbol$1 && Symbol$1["for"];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;
var wellKnownSymbol$5 = function(name) {
    if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
        else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
        else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
    return WellKnownSymbolsStore[name];
};
var call$1 = functionCall;
var isObject$4 = isObject$6;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$4 = wellKnownSymbol$5;
var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$4("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function(input, pref) {
    if (!isObject$4(input) || isSymbol$1(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = call$1(exoticToPrim, input, pref);
        if (!isObject$4(result) || isSymbol$1(result)) return result;
        throw $TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return ordinaryToPrimitive(input, pref);
};
var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function(argument) {
    var key = toPrimitive(argument, "string");
    return isSymbol(key) ? key : key + "";
};
var global$4 = global$a;
var isObject$3 = isObject$6;
var document$1 = global$4.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);
var documentCreateElement$1 = function(it) {
    return EXISTS$1 ? document$1.createElement(it) : {};
};
var DESCRIPTORS$7 = descriptors;
var fails$4 = fails$9;
var createElement = documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var DESCRIPTORS$6 = descriptors;
var call = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject$3(O);
    P = toPropertyKey$1(P);
    if (IE8_DOM_DEFINE$1) try {
        return $getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};
var objectDefineProperty = {};
var DESCRIPTORS$5 = descriptors;
var fails$3 = fails$9;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var isObject$2 = isObject$6;
var $String = String;
var $TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var anObject$4 = function(argument) {
    if (isObject$2(argument)) return argument;
    throw $TypeError$1($String(argument) + " is not an object");
};
var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$3 = anObject$4;
var toPropertyKey = toPropertyKey$2;
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE$1 = "configurable";
var WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    anObject$3(O);
    P = toPropertyKey(P);
    anObject$3(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject$3(O);
    P = toPropertyKey(P);
    anObject$3(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;
var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function(object, key, value) {
    return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var makeBuiltIn$2 = {
    exports: {}
};
var DESCRIPTORS$2 = descriptors;
var hasOwn$4 = hasOwnProperty_1;
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$4(FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || DESCRIPTORS$2 && getDescriptor(FunctionPrototype, "name").configurable);
var functionName = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};
var uncurryThis$5 = functionUncurryThis;
var isCallable$6 = isCallable$c;
var store$1 = sharedStore;
var functionToString = uncurryThis$5(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$6(store$1.inspectSource)) store$1.inspectSource = function(it) {
    return functionToString(it);
};
var inspectSource$2 = store$1.inspectSource;
var global$3 = global$a;
var isCallable$5 = isCallable$c;
var WeakMap$1 = global$3.WeakMap;
var weakMapBasicDetection = isCallable$5(WeakMap$1) && /native code/.test(String(WeakMap$1));
var shared$1 = shared$3.exports;
var uid = uid$2;
var keys = shared$1("keys");
var sharedKey$2 = function(key) {
    return keys[key] || (keys[key] = uid(key));
};
var hiddenKeys$4 = {};
var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$2 = global$a;
var isObject$1 = isObject$6;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
var hasOwn$3 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError$1 = global$2.TypeError;
var WeakMap = global$2.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject$1(it) || (state = get(it)).type !== TYPE) throw TypeError$1("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
    store.has = store.has;
    store.set = store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
        if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store.get(it) || {};
    };
    has = function(it) {
        return store.has(it);
    };
} else {
    var STATE = sharedKey$1("state");
    hiddenKeys$3[STATE] = true;
    set = function(it, metadata) {
        if (hasOwn$3(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty$1(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn$3(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn$3(it, STATE);
    };
}
var internalState = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};
var fails$2 = fails$9;
var isCallable$4 = isCallable$c;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource$1 = inspectSource$2;
var InternalStateModule = internalState;
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;
var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function() {
    return defineProperty$1(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var TEMPLATE = String(String).split("String");
var makeBuiltIn$1 = makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!hasOwn$2(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS$1) defineProperty$1(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, "arity") && value.length !== options.arity) defineProperty$1(value, "length", {
        value: options.arity
    });
    try {
        if (options && hasOwn$2(options, "constructor") && options.constructor) {
            if (DESCRIPTORS$1) defineProperty$1(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = enforceInternalState(value);
    if (!hasOwn$2(state, "source")) state.source = TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
    return isCallable$4(this) && getInternalState(this).source || inspectSource$1(this);
}, "toString");
var isCallable$3 = isCallable$c;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;
var defineBuiltIn$1 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if (isCallable$3(value)) makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var objectGetOwnPropertyNames = {};
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};
var trunc = mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};
var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;
var max = Math.max;
var min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function(index, length) {
    var integer = toIntegerOrInfinity$1(index);
    return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};
var toIntegerOrInfinity = toIntegerOrInfinity$2;
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function(argument) {
    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var toLength = toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function(obj) {
    return toLength(obj.length);
};
var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject$2($this);
        var length = lengthOfArrayLike$1(O);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod$1(false)
};
var uncurryThis$4 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;
var push$1 = uncurryThis$4([].push);
var objectKeysInternal = function(object, names) {
    var O = toIndexedObject$1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn$1(hiddenKeys$2, key) && hasOwn$1(O, key) && push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn$1(O, key = names[i++])) ~indexOf(result, key) || push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
var hiddenKeys$1 = enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys$1(O, hiddenKeys$1);
};
var objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$2 = getBuiltIn$5;
var uncurryThis$3 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject$2 = anObject$4;
var concat = uncurryThis$3([].concat);
// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$2("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject$2(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};
var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;
var copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule$1.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var fails$1 = fails$9;
var isCallable$2 = isCallable$c;
var replacement = /#|\.prototype\./;
var isForced$1 = function(feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true : value == NATIVE ? false : isCallable$2(detection) ? fails$1(detection) : !!detection;
};
var normalize = isForced$1.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = "N";
var POLYFILL = isForced$1.POLYFILL = "P";
var isForced_1 = isForced$1;
var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$2;
var defineBuiltIn = defineBuiltIn$1;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var _export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = global$1;
    else if (STATIC) target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
    else target = (global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
        defineBuiltIn(target, key, sourceProperty, options);
    }
};
var uncurryThis$2 = functionUncurryThis;
var aCallable = aCallable$2;
var NATIVE_BIND = functionBindNative;
var bind$1 = uncurryThis$2(uncurryThis$2.bind);
// optional / simple context binding
var functionBindContext = function(fn, that) {
    aCallable(fn);
    return that === undefined ? fn : NATIVE_BIND ? bind$1(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var classof$2 = classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
    return classof$2(argument) == "Array";
};
var wellKnownSymbol$3 = wellKnownSymbol$5;
var TO_STRING_TAG$1 = wellKnownSymbol$3("toStringTag");
var test = {};
test[TO_STRING_TAG$1] = "z";
var toStringTagSupport = String(test) === "[object z]";
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$c;
var classofRaw = classofRaw$2;
var wellKnownSymbol$2 = wellKnownSymbol$5;
var TO_STRING_TAG = wellKnownSymbol$2("toStringTag");
var $Object = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && isCallable$1(O.callee) ? "Arguments" : result;
};
var uncurryThis$1 = functionUncurryThis;
var fails = fails$9;
var isCallable = isCallable$c;
var classof = classof$1;
var getBuiltIn$1 = getBuiltIn$5;
var inspectSource = inspectSource$2;
var noop = function() {};
var empty = [];
var construct = getBuiltIn$1("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$1(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
var isConstructorModern = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    try {
        construct(noop, empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var isConstructorLegacy = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    switch(classof(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
    } catch (error) {
        return true;
    }
};
isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails(function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
        called = true;
    }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var isArray = isArray$1;
var isConstructor = isConstructor$1;
var isObject = isObject$6;
var wellKnownSymbol$1 = wellKnownSymbol$5;
var SPECIES = wellKnownSymbol$1("species");
var $Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
        else if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $Array : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function(originalArray, length) {
    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var bind = functionBindContext;
var uncurryThis = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject = toObject$2;
var lengthOfArrayLike = lengthOfArrayLike$2;
var arraySpeciesCreate = arraySpeciesCreate$1;
var push = uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = toObject($this);
        var self1 = IndexedObject(O);
        var boundFunction = bind(callbackfn, that);
        var length = lengthOfArrayLike(self1);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: createMethod(7)
};
var objectDefineProperties = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys$1);
};
var DESCRIPTORS = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$1 = anObject$4;
var toIndexedObject = toIndexedObject$4;
var objectKeys = objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject$1(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};
var getBuiltIn = getBuiltIn$5;
var html$1 = getBuiltIn("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var anObject = anObject$4;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$2;
var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement("iframe");
    var JS = "java" + SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};
var wellKnownSymbol = wellKnownSymbol$5;
var create = objectCreate;
var defineProperty = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol("unscopables");
var ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
});
// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function(key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
};
var $ = _export;
var $find = arrayIteration.find;
var addToUnscopables = addToUnscopables$1;
var FIND = "find";
var SKIPS_HOLES = true;
// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function() {
    SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({
    target: "Array",
    proto: true,
    forced: SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);
var CONSTANT = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};
/**
 * Static methods for react-tooltip
 */ var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: _defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, customListeners.get(ele, event));
            var customListener = checkStatus.bind(_this, dataEventOff);
            customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
}
/**
 * Util method to get effect
 */ var makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === "function") proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = null;
    var forId;
    var target = e.target;
    var lastTarget;
    // walk up parent chain until tip is found
    // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
    while(tip === null && target !== null){
        lastTarget = target;
        tip = target.getAttribute("data-tip") || null;
        forId = target.getAttribute("data-for") || null;
        target = target.parentElement;
    }
    target = lastTarget || e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
        var proxy = makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(" ").forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var getBody = function getBody() {
    return document.getElementsByTagName("body")[0];
};
function bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = getBody();
        var customEvents = findCustomEvents(targetArray, "data-event");
        var customEventsOff = findCustomEvents(targetArray, "data-event-off");
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(" ").forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(" ").forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
            checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside("top"),
        bottom: inside("bottom"),
        left: inside("left"),
        right: inside("right")
    };
    function choose() {
        var allPlaces = desiredPlace.split(",").concat(place, [
            "top",
            "bottom",
            "left",
            "right"
        ]);
        var _iterator = _createForOfIteratorHelper(allPlaces), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
        // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return place;
    }
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffsetY -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffsetY += parseInt(offset[key], 10);
        else if (key === "left") extraOffsetX -= parseInt(offset[key], 10);
        else if (key === "right") extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue("transform") !== "none" || computedStyle.getPropertyValue("will-change") === "transform") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function TipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function generateUUID() {
    return "t" + (0, _uuid.v4)();
}
var baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
/**
 * Default pop-up style values (text color, background color).
 */ var defaultColors = {
    dark: {
        text: "#fff",
        background: "#222",
        border: "transparent",
        arrow: "#222"
    },
    success: {
        text: "#fff",
        background: "#8DC572",
        border: "transparent",
        arrow: "#8DC572"
    },
    warning: {
        text: "#fff",
        background: "#F0AD4E",
        border: "transparent",
        arrow: "#F0AD4E"
    },
    error: {
        text: "#fff",
        background: "#BE6464",
        border: "transparent",
        arrow: "#BE6464"
    },
    info: {
        text: "#fff",
        background: "#337AB7",
        border: "transparent",
        arrow: "#337AB7"
    },
    light: {
        text: "#222",
        background: "#fff",
        border: "transparent",
        arrow: "#fff"
    }
};
function getDefaultPopupColors(type) {
    return defaultColors[type] ? _objectSpread2({}, defaultColors[type]) : undefined;
}
var DEFAULT_PADDING = "8px 21px";
var DEFAULT_RADIUS = {
    tooltip: 3,
    arrow: 0
};
/**
 * Generates the specific tooltip style for use on render.
 */ function generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
    return generateStyle(uuid, getPopupColors(customColors, type, hasBorder), padding, radius);
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function generateStyle(uuid, colors) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_PADDING;
    var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_RADIUS;
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    var arrowRadius = radius.arrow;
    var tooltipRadius = radius.tooltip;
    return "\n  	.".concat(uuid, " {\n	    color: ").concat(textColor, ";\n	    background: ").concat(backgroundColor, ";\n	    border: 1px solid ").concat(borderColor, ";\n	    border-radius: ").concat(tooltipRadius, "px;\n	    padding: ").concat(padding, ";\n  	}\n\n  	.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, '.place-top::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .').concat(uuid, '.place-top::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, '.place-bottom::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .').concat(uuid, '.place-bottom::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, '.place-left::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-left::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, '.place-right::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(uuid, '.place-right::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === "light" ? "black" : "white";
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var _class, _class2;
/* Polyfill */ var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_class2 = /*#__PURE__*/ function(_React$Component) {
    _inherits(ReactTooltip, _React$Component);
    var _super = _createSuper(ReactTooltip);
    function ReactTooltip(props) {
        var _this;
        _classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
            uuid: props.uuid || generateUUID(),
            place: props.place || "top",
            // Direction of tooltip
            desiredPlace: props.place || "top",
            type: props.type || "dark",
            // Color theme of tooltip
            effect: props.effect || "float",
            // float or fixed
            show: false,
            border: false,
            borderClass: "border",
            customColors: {},
            customRadius: {},
            offset: {},
            padding: props.padding,
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || "",
            possibleCustomEventsOff: props.possibleCustomEventsOff || "",
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ _createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props;
                _this$props.insecure;
                var resizeHide = _this$props.resizeHide, disableInternalStyle = _this$props.disableInternalStyle;
                this.mount = true;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                if (!disableInternalStyle) this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case "Document":
                    case "HTMLDocument":
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case "ShadowRoot":
                    default:
                        domRoot = parentNode;
                        break;
                }
                // Prevent styles duplication.
                if (!domRoot.querySelector("style[data-react-tooltip]")) {
                    var style = document.createElement("style");
                    style.textContent = baseCss;
                    style.setAttribute("data-react-tooltip", "true");
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = "[data-tip]:not([data-for])";
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    selector = '[data-tip][data-for="'.concat(escaped, '"]');
                }
                // Scan document for shadow DOM elements
                nodeListToArray(document.getElementsByTagName("*")).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat(nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat(nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    target.addEventListener("focus", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                    target.addEventListener("blur", _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute("aria-describedby", this.props.id || this.state.uuid);
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(",")[0], desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace.split(",")[0];
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || self1.props.type || "dark",
                        customColors: {
                            text: target.getAttribute("data-text-color") || self1.props.textColor || null,
                            background: target.getAttribute("data-background-color") || self1.props.backgroundColor || null,
                            border: target.getAttribute("data-border-color") || self1.props.borderColor || null,
                            arrow: target.getAttribute("data-arrow-color") || self1.props.arrowColor || null
                        },
                        customRadius: {
                            tooltip: target.getAttribute("data-tooltip-radius") || self1.props.tooltipRadius || "3",
                            arrow: target.getAttribute("data-arrow-radius") || self1.props.arrowRadius || "0"
                        },
                        effect: effect,
                        offset: offset,
                        padding: target.getAttribute("data-padding") || self1.props.padding,
                        html: (target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self1.props.html) || false,
                        delayShow: target.getAttribute("data-delay-show") || self1.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || self1.props.delayUpdate || 0,
                        border: (target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self1.props.border) || false,
                        borderClass: target.getAttribute("data-border-class") || self1.props.borderClass || "border",
                        extraClass: target.getAttribute("data-class") || self1.props["class"] || self1.props.className || "",
                        disable: (target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = TipContent(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable || disableProp) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition(function() {
                                if (isInvisible && afterShow) afterShow(e);
                            });
                        });
                    }
                };
                if (this.delayShowLoop) clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else {
                    this.delayShowLoop = null;
                    updateState();
                }
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute("aria-describedby");
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(callbackAfter) {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition(callbackAfter);
                });
                if (callbackAfter && typeof callbackAfter === "function") callbackAfter();
                // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                if (this.delayShowLoop) {
                    clearTimeout(this.delayShowLoop);
                    this.delayShowLoop = null;
                }
                if (this.delayHideLoop) {
                    clearTimeout(this.delayHideLoop);
                    this.delayHideLoop = null;
                }
                if (this.delayReshow) {
                    clearTimeout(this.delayReshow);
                    this.delayReshow = null;
                }
                if (this.intervalUpdateContent) {
                    clearInterval(this.intervalUpdateContent);
                    this.intervalUpdateContent = null;
                }
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== "border" && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors["border"]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = this.props.disableInternalStyle ? "" : generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
                var tooltipClass = "__react_component_tooltip" + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " " + this.state.borderClass : "") + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + // dark, success, warning, error, info, light, custom
                (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(" ");
                if (html) {
                    var htmlContent = "".concat(content).concat(style ? '\n<style aria-hidden="true">'.concat(style, "</style>") : "");
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Wrapper, _extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return /*#__PURE__*/ (0, _reactDefault.default).createElement(Wrapper, _extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), style && /*#__PURE__*/ (0, _reactDefault.default).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, _propTypesDefault.default).string,
                    children: (0, _propTypesDefault.default).any,
                    place: (0, _propTypesDefault.default).string,
                    type: (0, _propTypesDefault.default).string,
                    effect: (0, _propTypesDefault.default).string,
                    offset: (0, _propTypesDefault.default).object,
                    padding: (0, _propTypesDefault.default).string,
                    multiline: (0, _propTypesDefault.default).bool,
                    border: (0, _propTypesDefault.default).bool,
                    borderClass: (0, _propTypesDefault.default).string,
                    textColor: (0, _propTypesDefault.default).string,
                    backgroundColor: (0, _propTypesDefault.default).string,
                    borderColor: (0, _propTypesDefault.default).string,
                    arrowColor: (0, _propTypesDefault.default).string,
                    arrowRadius: (0, _propTypesDefault.default).string,
                    tooltipRadius: (0, _propTypesDefault.default).string,
                    insecure: (0, _propTypesDefault.default).bool,
                    "class": (0, _propTypesDefault.default).string,
                    className: (0, _propTypesDefault.default).string,
                    id: (0, _propTypesDefault.default).string,
                    html: (0, _propTypesDefault.default).bool,
                    delayHide: (0, _propTypesDefault.default).number,
                    delayUpdate: (0, _propTypesDefault.default).number,
                    delayShow: (0, _propTypesDefault.default).number,
                    event: (0, _propTypesDefault.default).string,
                    eventOff: (0, _propTypesDefault.default).string,
                    isCapture: (0, _propTypesDefault.default).bool,
                    globalEventOff: (0, _propTypesDefault.default).string,
                    getContent: (0, _propTypesDefault.default).any,
                    afterShow: (0, _propTypesDefault.default).func,
                    afterHide: (0, _propTypesDefault.default).func,
                    overridePosition: (0, _propTypesDefault.default).func,
                    disable: (0, _propTypesDefault.default).bool,
                    scrollHide: (0, _propTypesDefault.default).bool,
                    resizeHide: (0, _propTypesDefault.default).bool,
                    wrapper: (0, _propTypesDefault.default).string,
                    bodyMode: (0, _propTypesDefault.default).bool,
                    possibleCustomEvents: (0, _propTypesDefault.default).string,
                    possibleCustomEventsOff: (0, _propTypesDefault.default).string,
                    clickable: (0, _propTypesDefault.default).bool,
                    disableInternalStyle: (0, _propTypesDefault.default).bool
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return _objectSpread2(_objectSpread2({}, prevState), {}, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, _reactDefault.default).Component), _defineProperty(_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}), _defineProperty(_class2, "supportedWrappers", [
    "div",
    "span"
]), _defineProperty(_class2, "displayName", "ReactTooltip"), _class2)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

},{"react":"9njXz","prop-types":"bnNSm","uuid":"dsauQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dsauQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"2Rmi2","./v5.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Rmi2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _bytesToUuidJs = require("./bytesToUuid.js");
var _bytesToUuidJsDefault = parcelHelpers.interopDefault(_bytesToUuidJs);
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, _bytesToUuidJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"171P9","./bytesToUuid.js":"9AEh7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"171P9":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function rng() {
    if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9AEh7":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
exports.default = bytesToUuid;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d5uD5":[function(require,module,exports) {
(function(a, b) {
    b(exports, require("7d65b23dec5b1305"), require("71cf0af2d3b745cd"), require("419ec16771cd53d"));
})(this, function(a, b, c, d) {
    "use strict";
    function e(a) {
        return a && "object" == typeof a && "default" in a ? a : {
            default: a
        };
    }
    function f(a, b) {
        var c = Object.keys(a);
        if (Object.getOwnPropertySymbols) {
            var d = Object.getOwnPropertySymbols(a);
            b && (d = d.filter(function(b) {
                return Object.getOwnPropertyDescriptor(a, b).enumerable;
            })), c.push.apply(c, d);
        }
        return c;
    }
    function g(a) {
        for(var b, c = 1; c < arguments.length; c++)b = null == arguments[c] ? {} : arguments[c], c % 2 ? f(Object(b), !0).forEach(function(c) {
            l["default"](a, c, b[c]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : f(Object(b)).forEach(function(c) {
            Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
        });
        return a;
    }
    function h(a) {
        var b = a.srcList, c = a.imgPromise, e = void 0 === c ? o({
            decode: !0
        }) : c, f = a.useSuspense, h = void 0 === f || f, i = d.useState(!1), j = i[1], k = p(q(b)), l = k.join("");
        if (r[l] || (r[l] = {
            promise: s(k, e),
            cache: "pending",
            error: null
        }), "resolved" === r[l].cache) return {
            src: r[l].src,
            isLoading: !1,
            error: null
        };
        if ("rejected" === r[l].cache) {
            if (h) throw r[l].error;
            return {
                isLoading: !1,
                error: r[l].error,
                src: void 0
            };
        }
        if (r[l].promise.then(function(a) {
            r[l] = g(g({}, r[l]), {}, {
                cache: "resolved",
                src: a
            }), h || j(l);
        })["catch"](function(a) {
            r[l] = g(g({}, r[l]), {}, {
                cache: "rejected",
                error: a
            }), h || j(l);
        }), h) throw r[l].promise;
        return {
            isLoading: !0,
            src: void 0,
            error: null
        };
    }
    function j(a, b) {
        var c = Object.keys(a);
        if (Object.getOwnPropertySymbols) {
            var d = Object.getOwnPropertySymbols(a);
            b && (d = d.filter(function(b) {
                return Object.getOwnPropertyDescriptor(a, b).enumerable;
            })), c.push.apply(c, d);
        }
        return c;
    }
    function k(a) {
        for(var b, c = 1; c < arguments.length; c++)b = null == arguments[c] ? {} : arguments[c], c % 2 ? j(Object(b), !0).forEach(function(c) {
            l["default"](a, c, b[c]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : j(Object(b)).forEach(function(c) {
            Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
        });
        return a;
    }
    var l = e(b), m = e(c), n = e(d), o = function(a) {
        var b = a.decode, c = a.crossOrigin, d = void 0 === c ? "" : c;
        return function(a) {
            return new Promise(function(c, e) {
                var f = new Image;
                d && (f.crossOrigin = d), f.onload = function() {
                    (!(void 0 !== b) || b) && f.decode ? f.decode().then(c)["catch"](e) : c();
                }, f.onerror = e, f.src = a;
            });
        };
    }, p = function(b) {
        return b.filter(function(a) {
            return a;
        });
    }, q = function(a) {
        return Array.isArray(a) ? a : [
            a
        ];
    }, r = {}, s = function(a, b) {
        var c = !1;
        return new Promise(function(d, e) {
            var f = function(a) {
                return b(a).then(function() {
                    c = !0, d(a);
                });
            };
            a.reduce(function(a, b) {
                return a["catch"](function() {
                    if (!c) return f(b);
                });
            }, f(a.shift()))["catch"](e);
        });
    }, t = [
        "decode",
        "src",
        "loader",
        "unloader",
        "container",
        "loaderContainer",
        "unloaderContainer",
        "imgPromise",
        "crossorigin",
        "useSuspense"
    ], u = function(a) {
        return a;
    };
    a.Img = function(a) {
        var b = a.decode, c = a.src, d = void 0 === c ? [] : c, e = a.loader, f = void 0 === e ? null : e, g = a.unloader, i = void 0 === g ? null : g, j = a.container, l = void 0 === j ? u : j, p = a.loaderContainer, q = void 0 === p ? u : p, r = a.unloaderContainer, s = void 0 === r ? u : r, v = a.imgPromise, w = a.crossorigin, x = a.useSuspense, y = void 0 !== x && x, z = m["default"](a, t);
        v = v || o({
            decode: !(void 0 !== b) || b,
            crossOrigin: w
        });
        var A = h({
            srcList: d,
            imgPromise: v,
            useSuspense: y
        }), B = A.src, C = A.isLoading;
        return B ? l(n["default"].createElement("img", k({
            src: B
        }, z))) : !y && C ? q(f) : !y && i ? s(i) : null;
    }, a.useImage = h, Object.defineProperty(a, "__esModule", {
        value: !0
    });
}); //# sourceMappingURL=index.js.map

},{"7d65b23dec5b1305":"hjdoh","71cf0af2d3b745cd":"imPRm","419ec16771cd53d":"9njXz"}],"h6dFx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseJs = require("./base.js");
exports.default = _baseJs;

},{"./base.js":"ldO3X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ldO3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extract", ()=>extract);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
parcelHelpers.export(exports, "stringifyUrl", ()=>stringifyUrl);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "exclude", ()=>exclude);
var _decodeUriComponent = require("decode-uri-component");
var _decodeUriComponentDefault = parcelHelpers.interopDefault(_decodeUriComponent);
var _splitOnFirst = require("split-on-first");
var _splitOnFirstDefault = parcelHelpers.interopDefault(_splitOnFirst);
var _filterObj = require("filter-obj");
const isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            encode(index, options),
                            "]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            ":list=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                encode(key, options),
                                keyValueSep,
                                encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return (0, _decodeUriComponentDefault.default)(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function parse(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, _splitOnFirstDefault.default)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = parseValue(value2, options);
        else returnValue[key] = parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
function stringify(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function parseUrl(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, _splitOnFirstDefault.default)(url, "#");
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split("?")?.[0] ?? "",
        query: parse(extract(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: decode(hash, options)
        } : {}
    };
}
function stringifyUrl(object, options) {
    options = {
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true,
        ...options
    };
    const url = removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = extract(object.url);
    const query = {
        ...parse(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = stringify(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function pick(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false,
        ...options
    };
    const { url, query, fragmentIdentifier } = parseUrl(input, options);
    return stringifyUrl({
        url,
        query: (0, _filterObj.includeKeys)(query, filter),
        fragmentIdentifier
    }, options);
}
function exclude(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return pick(input, exclusionFilter, options);
}

},{"decode-uri-component":"diofT","split-on-first":"3Kl5z","filter-obj":"d7zD9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"diofT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>decodeUriComponent);
const token = "%[a-f0-9]{2}";
const singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
const multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match(singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join("");
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    let match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function decodeUriComponent(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Kl5z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>splitOnFirst);
function splitOnFirst(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7zD9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "includeKeys", ()=>includeKeys);
parcelHelpers.export(exports, "excludeKeys", ()=>excludeKeys);
function includeKeys(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function excludeKeys(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return includeKeys(object, (key)=>!set.has(key));
    }
    return includeKeys(object, (key, value, object)=>!predicate(key, value, object));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6WyGC":[function(require,module,exports) {
var baseKeys = require("a008df59f82d2c8f"), getTag = require("d63799a808049d04"), isArguments = require("1f4ee6aee3a7eae0"), isArray = require("b708be4f72c2a706"), isArrayLike = require("ab4b4eaf96f9163a"), isBuffer = require("80b58ade5ee2f70"), isPrototype = require("3a444e8bd8b275f2"), isTypedArray = require("6af418b3352c301b");
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"a008df59f82d2c8f":"f4fT3","d63799a808049d04":"1chae","1f4ee6aee3a7eae0":"bpegN","b708be4f72c2a706":"1DVeR","ab4b4eaf96f9163a":"kzICo","80b58ade5ee2f70":"26W2O","3a444e8bd8b275f2":"6l00J","6af418b3352c301b":"hq5rz"}],"f4fT3":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"6l00J","3ec652610d8dd5d3":"39iyK"}],"6l00J":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"39iyK":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"3OxAn"}],"3OxAn":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"1chae":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"7C8Fy","28e3344aae951f13":"bEqpc","b286298be5b1d9a4":"97fST","3ae50c158f89813":"juoJE","9f458755f627d456":"9vICk","8e9160b373d7fe66":"5ltt8","b210627dd951641f":"2HVCC"}],"7C8Fy":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"bz0ok","f83c375075418382":"gVq56"}],"bz0ok":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"i4SFU","16db51a0e009bd8c":"fQ3rQ"}],"i4SFU":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"3A7xI","cabbc2adfaeb27d9":"eUAv3","cbb5703fe1562e7f":"6hgJK","388b819f47a43aa5":"2HVCC"}],"3A7xI":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"5ltt8","3cba3c966459d528":"6hgJK"}],"5ltt8":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"crlKT","9b2aaf31b7bdd837":"66zQh","46d5beb3375f8a28":"7zYCt"}],"crlKT":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"gVq56"}],"gVq56":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"egvmL"}],"egvmL":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"66zQh":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"crlKT"}],"7zYCt":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"6hgJK":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"eUAv3":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"h0VAr"}],"h0VAr":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"gVq56"}],"2HVCC":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"fQ3rQ":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"bEqpc":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"bz0ok","29224713b8d411e6":"gVq56"}],"97fST":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"bz0ok","a5c6637bac681a0":"gVq56"}],"juoJE":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"bz0ok","ca486d41cdf819d4":"gVq56"}],"9vICk":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"bz0ok","7a9a6581834a8452":"gVq56"}],"bpegN":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"5IKlp","bead821d6af018b5":"4gOki"}],"5IKlp":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"5ltt8","b6cdbe52dcf709f8":"4gOki"}],"4gOki":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"1DVeR":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"kzICo":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"3A7xI","f3db08d4d1110aaf":"aFNSq"}],"aFNSq":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"26W2O":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"gVq56","a1e87b138cf75d1d":"gotX4"}],"gotX4":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"hq5rz":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"jRqan","903f50eb1c16d257":"jVyhK","fa49853a82034c30":"bPzLC"}],"jRqan":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"5ltt8","f661b3a120d7a4cb":"aFNSq","cdd86c83797c0618":"4gOki"}],"jVyhK":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"bPzLC":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"egvmL"}],"iHC1F":[function(require,module,exports) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"1n4LL","e87a09d93c0fc32d":"e0xvq"}],"1n4LL":[function(require,module,exports) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"cltFt","76e9fd6386317324":"e0LII","e7dca58bcfe9c669":"9oLrx","4ea46d88599071ec":"8JjIw","c52c932be04280cc":"6hgJK","27adf66142f57b4b":"6emcB","564385b2292facea":"34puL"}],"cltFt":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"iugcK","ceda2a63c77c915":"5KcsT","91ee1b348d9d7172":"hJzOg","3fe28318f65b9332":"ck5Lg","724ca4def8b84e06":"Ez0QG","e9ceacb40d9582bd":"iepWB"}],"iugcK":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"5b3H7","b700cb849df2c166":"bZ5tW","d76dd90eead6cced":"11sMk","3d210628ba60ec8":"TkrmM","76026bf2d4cfff93":"cCYah"}],"5b3H7":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"bZ5tW":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"5AZA1"}],"5AZA1":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"evtiM"}],"evtiM":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"11sMk":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"5AZA1"}],"TkrmM":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"5AZA1"}],"cCYah":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"5AZA1"}],"5KcsT":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"iugcK"}],"hJzOg":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"ck5Lg":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"Ez0QG":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"iepWB":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"iugcK","1494efbafafa9552":"bEqpc","6049e8027fe9407f":"lV1BE"}],"lV1BE":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"6JGdu","d2967b0e32ccfa56":"jD16i","ca21409ea89624c0":"9OB5v","f88fd07f8dd1f67d":"hsHKK","dbf3eae765642a3b":"5bQCB"}],"6JGdu":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"1q5yZ","a07dcf3fd3097a0c":"iugcK","92c01c953ef00ded":"bEqpc"}],"1q5yZ":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"77BkF","bc25d439ccd1fb47":"jt1rM","f096b37295a92ab0":"finz6","d88173cbc6a133c8":"5E27p","afb9b3bae0461cbf":"giimS"}],"77BkF":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"lElJo"}],"lElJo":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"bz0ok"}],"jt1rM":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"finz6":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"lElJo"}],"5E27p":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"lElJo"}],"giimS":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"lElJo"}],"jD16i":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"hINJU"}],"hINJU":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"5JCrb"}],"5JCrb":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"9OB5v":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"hINJU"}],"hsHKK":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"hINJU"}],"5bQCB":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"hINJU"}],"e0LII":[function(require,module,exports) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"ba13n","7d9c95e1ffdd4f16":"evtiM"}],"ba13n":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"fUDy8"}],"fUDy8":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"bz0ok"}],"9oLrx":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"d4N9s"}],"d4N9s":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"8JjIw":[function(require,module,exports) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"e0LII","ec8e1b90277c5e12":"aNaSh","4b1a2b5090faf247":"WFexx","d7675bdf0a02bffc":"lWbYv","1067a6f3f6bd5986":"fGkGx","2238139506f6727b":"bpegN","290c774b41e416bb":"1DVeR","f481819c40e5b527":"gamaN","6532fda6a198015f":"26W2O","7f306c94b573f977":"3A7xI","32c89e763261c579":"6hgJK","ff359d315efefc4f":"lCxAG","61ce92c01fd411fe":"hq5rz","abfa8f7e72201edb":"34puL","c54d414b219fa287":"i8tDZ"}],"aNaSh":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"gVq56"}],"WFexx":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"ZLaCu"}],"ZLaCu":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"eHExv"}],"eHExv":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"gVq56"}],"lWbYv":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"fGkGx":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"5YCvM","8c92276927b7c3e0":"9DBU4","e939f15d7a0f64a5":"6l00J"}],"5YCvM":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"6hgJK"}],"9DBU4":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"3OxAn"}],"gamaN":[function(require,module,exports) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"kzICo","639a4883b097af28":"4gOki"}],"lCxAG":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"5ltt8","2ca5b85a120835de":"9DBU4","963b65e043435612":"4gOki"}],"34puL":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = safeGet;

},{}],"i8tDZ":[function(require,module,exports) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"vDc33","437a3e3814017158":"6emcB"}],"vDc33":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"aKTSf","9cddf6ac1a092765":"ba13n"}],"aKTSf":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"ba13n","b62ef95b3cf1cde1":"evtiM"}],"6emcB":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"aB7KR","194eb1a802636842":"5O0AO","ac15afdc3ddd76cd":"kzICo"}],"aB7KR":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"iMrJS","9cdb51ffa56f149b":"bpegN","38cd49f1e493b3d7":"1DVeR","b379831fe1873fed":"26W2O","f362a34cd8321bb7":"bxLaX","c019db5297494469":"hq5rz"}],"iMrJS":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"bxLaX":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"5O0AO":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"6hgJK","f7d53cd92b2b977b":"6l00J","c039208a16eb68bd":"8srRf"}],"8srRf":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"e0xvq":[function(require,module,exports) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"5w1TW","4f5832110eba92d3":"gTLnH"}],"5w1TW":[function(require,module,exports) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"2HXBf","ff7d23ff2a2ea6f8":"rlFXD","a11d545e809d14f7":"cmKNW"}],"2HXBf":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"rlFXD":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"bZSxb"}],"bZSxb":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"cmKNW":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"i2oRN","9114f59293388d49":"9rYPt"}],"i2oRN":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"bvu2c","eff1240bc0447727":"fUDy8","b00d1e57326793e1":"2HXBf"}],"bvu2c":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"9rYPt":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"gTLnH":[function(require,module,exports) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"evtiM","616bc732534dffe0":"kzICo","e781332a36d1bd7":"bxLaX","c8548bf6929b8a5d":"6hgJK"}],"i23f0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class AlertService {
    api = new (0, _requestsDefault.default)();
    buildAlertByRuleMetricsRequest(params, cancelToken) {
        return {
            cancelToken,
            endpoint: "/v1/metrics/alerts",
            method: "get",
            params,
            service: "rules"
        };
    }
    async fetchAlertByRuleMetrics(params, cancelToken) {
        const { data } = await this.api.request(this.buildAlertByRuleMetricsRequest(params, cancelToken));
        return data;
    }
    buildAlertsByRuleRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/alerts",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchPaginatedAlertsByRule(params, cancelToken) {
        const { data } = await this.api.request(this.buildAlertsByRuleRequest(params, cancelToken));
        return data;
    }
    buildClearAlertRequest({ alertID, ...params }, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/alerts/${alertID}/clear`,
            method: "put",
            params,
            cancelToken
        };
    }
    async clearAlert(params, cancelToken) {
        const { data } = await this.api.request(this.buildClearAlertRequest(params, cancelToken));
        return data;
    }
}
exports.default = AlertService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5rDjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class AssetGroupService {
    api = new (0, _requestsDefault.default)();
    buildCreateOrgAssetGroupRequest(params, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: "/v1/assetGroups",
            method: "post",
            params,
            service: "gateway"
        };
    }
    async createOrgAssetGroup(params, body, cancelToken) {
        const { data } = await this.api.request(this.buildCreateOrgAssetGroupRequest(params, body, cancelToken));
        return data;
    }
    buildUpdateOrgAssetGroupRequest(groupID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v1/assetGroups/${groupID}`,
            method: "put",
            service: "gateway"
        };
    }
    async updateOrgAssetGroup(groupID, body, cancelToken) {
        const { data } = await this.api.request(this.buildUpdateOrgAssetGroupRequest(groupID, body, cancelToken));
        return data;
    }
    buildFetchOrgAssetGroupsRequest(params, cancelToken) {
        return {
            cancelToken,
            endpoint: "/v1/assetGroups",
            method: "get",
            params,
            service: "gateway"
        };
    }
    async fetchOrgAssetGroups(params, cancelToken) {
        const { data } = await this.api.request(this.buildFetchOrgAssetGroupsRequest(params, cancelToken));
        return data;
    }
    buildFetchOrgAssetGroupDetailRequest(groupID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v1/assetGroups/${groupID}`,
            method: "get",
            service: "gateway"
        };
    }
    async fetchAssetGroupDetail(groupID, cancelToken) {
        const { data } = await this.api.request(this.buildFetchOrgAssetGroupDetailRequest(groupID, cancelToken));
        return data;
    }
    buildDeleteOrgAssetGroupRequest(groupID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v1/assetGroups/${groupID}`,
            method: "delete",
            service: "gateway"
        };
    }
    deleteOrgAssetGroup(groupID, cancelToken) {
        return this.api.request(this.buildDeleteOrgAssetGroupRequest(groupID, cancelToken));
    }
    buildRemoveAssetFromGroupRequest(groupID, assetID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v1/assetGroups/${groupID}/gateway/${assetID}`,
            method: "delete",
            service: "gateway"
        };
    }
    async removeAssetFromGroup(groupID, assetID, cancelToken) {
        const { data } = await this.api.request(this.buildRemoveAssetFromGroupRequest(groupID, assetID, cancelToken));
        return data;
    }
    buildAddAssetToGroupRequest(groupID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v1/assetGroups/${groupID}/gateway`,
            method: "post",
            service: "gateway"
        };
    }
    async addAssetToGroup(groupID, body, cancelToken) {
        const { data } = await this.api.request(this.buildAddAssetToGroupRequest(groupID, body, cancelToken));
        return data;
    }
    buildUpdateAssetGroupGatewayRequest(groupID, assetID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v1/assetGroups/${groupID}/gateway/${assetID}`,
            method: "put",
            service: "gateway"
        };
    }
    async updateAssetGroupGateway(groupID, assetID, body, cancelToken) {
        const { data } = await this.api.request(this.buildUpdateAssetGroupGatewayRequest(groupID, assetID, body, cancelToken));
        return data;
    }
    buildFetchGatewayAssetGroupsRequest(gatewayID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/gateway/${gatewayID}/assetGroups`,
            method: "get",
            service: "gateway"
        };
    }
    async fetchGatewayAssetGroups(gatewayID, cancelToken) {
        const { data } = await this.api.request(this.buildFetchGatewayAssetGroupsRequest(gatewayID, cancelToken));
        return data;
    }
}
exports.default = AssetGroupService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fL096":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _authService = require("./AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class AssetService {
    auth = new (0, _authServiceDefault.default)();
    api = new (0, _requestsDefault.default)();
    buildAssetsRequestForMap({ children = false, includeAlertStatus = true, includeAssetCount = true, limit = 200, orgID = this.auth.getCurrentOrgID(), page = 1 }, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/maps",
            method: "get",
            params: {
                children,
                includeAlertStatus,
                includeAssetCount,
                limit,
                orgID,
                page
            },
            cancelToken
        };
    }
    async getOrgAssetsForMap(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAssetsRequestForMap(params, cancelToken));
        return data;
    }
    handleAdditionalOrgAssetRequests = async (count, limit, orgID, cancelToken)=>{
        const params = {
            count,
            limit,
            orgID
        };
        const requestsMap = this.api.createAdditionalRequestMap(params, this.buildAssetsRequestForMap, cancelToken);
        return Promise.all(requestsMap);
    };
    handleAdditionalEcosystemAssetRequests = async (count, limit, orgID, cancelToken)=>{
        const params = {
            count,
            limit,
            orgID,
            children: true
        };
        const requestsMap = this.api.createAdditionalRequestMap(params, this.buildAssetsRequestForMap, cancelToken);
        return Promise.all(requestsMap);
    };
    buildAssetsRequestForInventory(params, cancelToken) {
        return {
            cancelToken,
            endpoint: "/v2/gateway",
            method: "get",
            params,
            service: "gateway"
        };
    }
    getOrgAssetsForInventory = async ({ children = false, limit = 10, order = "ASC", orgID = this.auth.getCurrentOrgID(), page = 1, search = "", shadow = true, sort = "nickname" }, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildAssetsRequestForInventory({
            children,
            limit,
            order,
            orgID,
            page,
            search,
            shadow,
            sort
        }, cancelToken));
        return data;
    };
    buildFetchProvisionedAssetsRequest(params, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/provision",
            method: "get",
            params,
            cancelToken
        };
    }
    fetchProvisionedAssets = async (params, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildFetchProvisionedAssetsRequest(params, cancelToken));
        return data;
    };
    buildProvisionAssetRequest(vendor, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/provision/${vendor}`,
            method: "post",
            service: "gateway"
        };
    }
    async provisionAsset(vendor, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildProvisionAssetRequest(vendor, body, cancelToken));
        return data;
    }
    buildProvisionAssetBulkRequest(data, orgID) {
        return {
            service: "gateway",
            endpoint: "/provision/bulk",
            method: "post",
            params: {
                orgID
            },
            data
        };
    }
    async ProvisionAssetBulk(body, orgID) {
        const { data = {} } = await this.api.request(this.buildProvisionAssetBulkRequest(body, orgID));
        return data;
    }
    buildCreateAssetRequest(data) {
        return {
            service: "gateway",
            endpoint: "/gateway",
            method: "post",
            data
        };
    }
    async createAsset(body) {
        const { data = {} } = await this.api.request(this.buildCreateAssetRequest(body));
        return data;
    }
    buildMoveAssetToNewOrgRequest(assetID, data) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/org`,
            method: "put",
            data
        };
    }
    async moveAssetToNewOrg(assetID, body) {
        const { data = {} } = await this.api.request(this.buildMoveAssetToNewOrgRequest(assetID, body));
        return data;
    }
    buildDeleteAssetRequest(assetID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/gateway/${assetID}`,
            method: "delete",
            service: "gateway"
        };
    }
    async deleteAsset(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteAssetRequest(assetID, cancelToken));
        return data;
    }
    buildDeleteProvisionRequest(provisionID) {
        return {
            service: "gateway",
            endpoint: `/provision/${provisionID}`,
            method: "delete"
        };
    }
    async deleteProvisionRequest(provisionID) {
        const { data = {} } = await this.api.request(this.buildDeleteProvisionRequest(provisionID));
        return data;
    }
    buildFetchAssetRequest({ assetID, ...params }, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}`,
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchAsset(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetRequest(params, cancelToken));
        return data;
    }
    buildFetchAllAssetsRequest(orgID, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/gateway/all",
            method: "get",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async fetchAllAssets(orgID, cancelToken) {
        const { data = [] } = await this.api.request(this.buildFetchAllAssetsRequest(orgID, cancelToken));
        return data;
    }
    buildGetEcosystemAssetsForService({ orgID = this.auth.getCurrentOrgID(), cancelToken }) {
        return {
            service: "gateway",
            endpoint: "/v2/gateway",
            method: "get",
            params: {
                orgID,
                shadow: true,
                children: true
            },
            cancelToken
        };
    }
    getEcosystemAssetsForService = async (params)=>{
        const { data = {} } = await this.api.request(this.buildGetEcosystemAssetsForService(params));
        return data;
    };
    buildAssetUpdateRequest(assetID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}`,
            method: "put",
            data,
            cancelToken
        };
    }
    async updateAssetDetails(assetID, update, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAssetUpdateRequest(assetID, update, cancelToken));
        return data;
    }
    buildUpdateAssetRemoteRequest(assetID, enable, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/remote`,
            method: "post",
            params: {
                enable
            },
            cancelToken
        };
    }
    async updateAssetRemote(assetID, enable, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateAssetRemoteRequest(assetID, enable, cancelToken));
        return data;
    }
    buildExecuteAssetCommandRequest(assetID, params, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/job`,
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async executeAssetCommand(assetID, params, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildExecuteAssetCommandRequest(assetID, params, body, cancelToken));
        return data;
    }
    buildGenerateCertificateRequest(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/certificate`,
            method: "post",
            cancelToken
        };
    }
    async generateCertificate(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGenerateCertificateRequest(assetID, cancelToken));
        return data;
    }
    buildFetchAssetsRequest(params, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/gateway",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchAssets(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetsRequest(params, cancelToken));
        return data;
    }
    buildExportAllAssetByOrgRequest(params, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/gateway/export",
            method: "get",
            params,
            cancelToken
        };
    }
    async exportAllAssetsByOrg(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildExportAllAssetByOrgRequest(params, cancelToken));
        return data;
    }
    buildAssetSearchRequest(params, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/gateway/search",
            method: "get",
            params,
            cancelToken
        };
    }
    async searchAssets(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAssetSearchRequest(params, cancelToken));
        return data;
    }
    buildFetchModelByTemplateIdRequest(templateID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}`,
            method: "get",
            cancelToken
        };
    }
    async fetchModelByTemplateId(templateID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchModelByTemplateIdRequest(templateID, cancelToken));
        return data;
    }
    buildFetchModelByAssetIdRequest(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/template`,
            method: "get",
            cancelToken
        };
    }
    async fetchModelByAssetId(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchModelByAssetIdRequest(assetID, cancelToken));
        return data;
    }
    buildFetchAssetOTA(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/ota`,
            method: "get",
            cancelToken
        };
    }
    async fetchAssetOTA(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetOTA(assetID, cancelToken));
        return data;
    }
    buildFetchAssetTwin(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/twin`,
            method: "get",
            cancelToken
        };
    }
    async fetchAssetTwin(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetTwin(assetID, cancelToken));
        return data;
    }
    buildFetchAssetTwin2(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/twin2`,
            method: "get",
            cancelToken
        };
    }
    async fetchAssetTwin2(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetTwin2(assetID, cancelToken));
        return data;
    }
    buildFetchAssetIdentity(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/identity`,
            method: "get",
            cancelToken
        };
    }
    async fetchAssetIdentity(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetIdentity(assetID, cancelToken));
        return data;
    }
    buildFetchAssetIdentity2(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/identity2`,
            method: "get",
            cancelToken
        };
    }
    async fetchAssetIdentity2(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetIdentity2(assetID, cancelToken));
        return data;
    }
    buildFetchAssetDeviceStreamsInfo(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/deviceStream`,
            method: "get",
            cancelToken
        };
    }
    async fetchAssetDeviceStreamsInfo(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetDeviceStreamsInfo(assetID, cancelToken));
        return data;
    }
    buildUpdateAssetSoftware(assetID, params, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/ota`,
            method: "post",
            params,
            cancelToken
        };
    }
    async updateAssetSoftware(assetID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateAssetSoftware(assetID, params, cancelToken));
        return data;
    }
    buildSetAwsKeysRequest(params, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v1/keys",
            method: "put",
            cancelToken,
            data,
            params
        };
    }
    setAwsKeys(params, data, cancelToken) {
        return this.api.request(this.buildSetAwsKeysRequest(params, data, cancelToken));
    }
    buildDeleteAwsKeysRequest(params, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v1/keys",
            method: "put",
            cancelToken,
            params
        };
    }
    deleteAwsKeys(params, cancelToken) {
        return this.api.request(this.buildDeleteAwsKeysRequest(params, cancelToken));
    }
    buildFetchAssetSnapshotsRequest(gatewayID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/gateway/${gatewayID}/snapshots`,
            method: "get",
            params,
            service: "gateway"
        };
    }
    async fetchAssetSnapshots(gatewayID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetSnapshotsRequest(gatewayID, params, cancelToken));
        return data;
    }
    buildFetchAssetFcNotificationsRequest(gatewayID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/gateway/${gatewayID}/fcNotifications`,
            method: "get",
            params,
            service: "gateway"
        };
    }
    async fetchAssetFcNotifications(gatewayID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetFcNotificationsRequest(gatewayID, params, cancelToken));
        return data;
    }
    buildFetchAssetFcNotificationMetricsRequest(gatewayID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/gateway/${gatewayID}/fcNotifications-filters`,
            method: "get",
            params,
            service: "gateway"
        };
    }
    async fetchAssetFcNotificationMetrics(gatewayID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetFcNotificationMetricsRequest(gatewayID, params, cancelToken));
        return data;
    }
    buildFetchCumminsResponseRequest(gatewayID, timestamp, cancelToken) {
        return {
            cancelToken,
            endpoint: `/gateway/${gatewayID}/diagnosticResponse/${timestamp}`,
            method: "get",
            service: "gateway"
        };
    }
    async fetchCumminsResponse(gatewayID, timestamp, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchCumminsResponseRequest(gatewayID, timestamp, cancelToken));
        return data;
    }
    buildValidateAssetRequest(gatewayID, templateID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/gateway/${gatewayID}/validate/${templateID}`,
            method: "post",
            service: "gateway"
        };
    }
    async validateAsset(gatewayID, templateID, cancelToken) {
        return this.api.request(this.buildValidateAssetRequest(gatewayID, templateID, cancelToken));
    }
    buildFetchAssetCustomerOTAs(assetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/customerOta`,
            method: "get",
            cancelToken
        };
    }
    async fetchAssetCustomerOTAs(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetCustomerOTAs(assetID, cancelToken));
        return data;
    }
    buildAddAssetCustomerOTA(assetID, data, cancelToken) {
        return {
            data,
            service: "gateway",
            endpoint: `/gateway/${assetID}/customerOta`,
            method: "post",
            cancelToken
        };
    }
    async addAssetCustomerOTA(assetID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAddAssetCustomerOTA(assetID, body, cancelToken));
        return data;
    }
    buildDeleteAssetCustomerOTA(assetID, params, cancelToken) {
        return {
            params,
            service: "gateway",
            endpoint: `/gateway/${assetID}/customerOta`,
            method: "delete",
            cancelToken
        };
    }
    async deleteAssetCustomerOTA(assetID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteAssetCustomerOTA(assetID, params, cancelToken));
        return data;
    }
    buildAssetAssociationExistsRequest(assetID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/gateway/${assetID}/assetAssociationExists`,
            method: "get",
            service: "gateway"
        };
    }
    async assetAssociationExists(assetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAssetAssociationExistsRequest(assetID, cancelToken));
        return data;
    }
    buildListActivationCodesRequest(assetID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/gateway/${assetID}/activationCodes`,
            method: "get",
            params,
            service: "gateway"
        };
    }
    async listActivationCodes(assetID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildListActivationCodesRequest(assetID, params, cancelToken));
        return data;
    }
}
exports.default = AssetService;

},{"./AuthService":"8Bjjn","../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72XwI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class DM1Service {
    api = new (0, _requestsDefault.default)();
    buildDM1FaultsRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/dm-alerts`,
            method: "get",
            params,
            cancelToken
        };
    }
    getDM1Faults = async (params, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildDM1FaultsRequest(params, cancelToken));
        return data;
    };
    buildDM1FiltersRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/dm-alert-filters`,
            method: "get",
            params,
            cancelToken
        };
    }
    getDM1Filters = async (params, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildDM1FiltersRequest(params, cancelToken));
        return data;
    };
    buildDM1FaultsCountRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/metrics/dm-alerts`,
            method: "get",
            params,
            cancelToken
        };
    }
    getDM1FaultsCount = async (params, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildDM1FaultsCountRequest(params, cancelToken));
        return data;
    };
    buildFetchDm1SnapshotsCsvRequest(gatewayID, dm1ID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/gateway/${gatewayID}/snapshot/${dm1ID}`,
            method: "get",
            service: "gateway"
        };
    }
    async fetchDm1SnapshotsCsv(gatewayID, dm1ID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchDm1SnapshotsCsvRequest(gatewayID, dm1ID, cancelToken));
        return data;
    }
}
exports.default = DM1Service;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZyFp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class TemplateDashboardService {
    api = new (0, _requestsDefault.default)();
    buildCreateTemplateDashboardRequest(templateID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard`,
            method: "post",
            data,
            cancelToken
        };
    }
    async createTemplateDashboard(templateID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateTemplateDashboardRequest(templateID, body, cancelToken));
        return data;
    }
    buildFetchAllTemplateDashboardsRequest(templateID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard`,
            method: "get",
            cancelToken
        };
    }
    async fetchAllTemplateDashboards(templateID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAllTemplateDashboardsRequest(templateID, cancelToken));
        return data;
    }
    buildFetchTemplateDashboardRequest(templateID, dashboardID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}`,
            method: "get",
            cancelToken
        };
    }
    async fetchTemplateDashboard(templateID, dashboardID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchTemplateDashboardRequest(templateID, dashboardID, cancelToken));
        return data;
    }
    buildUpdateTemplateDashboardRequest(templateID, dashboardID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}`,
            method: "put",
            data,
            cancelToken
        };
    }
    async updateTemplateDashboard(templateID, dashboardID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateTemplateDashboardRequest(templateID, dashboardID, body, cancelToken));
        return data;
    }
    buildDeleteTemplateDashboardRequest(templateID, dashboardID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}`,
            method: "delete",
            cancelToken
        };
    }
    async deleteTemplateDashboard(templateID, dashboardID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteTemplateDashboardRequest(templateID, dashboardID, cancelToken));
        return data;
    }
    buildCreateTemplateDashboardWidgetRequest(templateID, dashboardID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}/widget`,
            method: "post",
            data,
            cancelToken
        };
    }
    async createTemplateDashboardWidget(templateID, dashboardID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateTemplateDashboardWidgetRequest(templateID, dashboardID, body, cancelToken));
        return data;
    }
    buildUpdateTemplateDashboardWidgetRequest(templateID, dashboardID, widgetID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}/widget/${widgetID}`,
            method: "put",
            data,
            cancelToken
        };
    }
    async updateTemplateDashboardWidget(templateID, dashboardID, widgetID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateTemplateDashboardWidgetRequest(templateID, dashboardID, widgetID, body, cancelToken));
        return data;
    }
    buildDeleteTemplateDashboardWidgetRequest(templateID, dashboardID, widgetID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}/widget/${widgetID}`,
            method: "delete",
            cancelToken
        };
    }
    async deleteTemplateDashboardWidget(templateID, dashboardID, widgetID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteTemplateDashboardWidgetRequest(templateID, dashboardID, widgetID, cancelToken));
        return data;
    }
    buildSetUserDefaultDashboardRequest(gatewayID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/gateway/${gatewayID}/dashboard`,
            method: "post",
            data,
            cancelToken
        };
    }
    async setUserDefaultDashboard(gatewayID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildSetUserDefaultDashboardRequest(gatewayID, body, cancelToken));
        return data;
    }
    buildCheckUserPreferenceDashboardRequest(gatewayID, dashboardID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/gateway/${gatewayID}/dashboard/${dashboardID}/isUserPreference`,
            method: "get",
            cancelToken
        };
    }
    async checkUserPreferenceDashboard(gatewayID, dashboardID, cancelToken) {
        return this.api.request(this.buildCheckUserPreferenceDashboardRequest(gatewayID, dashboardID, cancelToken));
    }
}
exports.default = TemplateDashboardService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdVNl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduce = require("lodash/reduce");
var _reduceDefault = parcelHelpers.interopDefault(_reduce);
var _round = require("lodash/round");
var _roundDefault = parcelHelpers.interopDefault(_round);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _staticUUIDs = require("../Constants/StaticUUIDs");
class AssetUtils {
    handleInfoBoxOpenClose(assetID, isOpen) {
        return (0, _reduceDefault.default)(isOpen, (acc, val, key)=>{
            if (!isOpen[assetID]) acc[assetID] = true;
            else if (key === assetID) acc[key] = !val;
            else acc[key] = false;
            return acc;
        }, {});
    }
    getAssetOnlineTime(timestamp) {
        return (0, _momentDefault.default)(timestamp).toNow(true);
    }
    getAssetLastUpdatedAt(lastUpdated) {
        if (!lastUpdated) return;
        return (0, _momentDefault.default)(lastUpdated).format("YYYY-M-D");
    }
    getAssetCreatedAt(createdAt) {
        if (!createdAt) return;
        return (0, _momentDefault.default)(createdAt).format("YYYY-M-D");
    }
    getAssetActivatedOn(activatedOn) {
        if (!activatedOn) return "--";
        return (0, _momentDefault.default)(activatedOn).format("YYYY-M-D");
    }
    parseDateToYearMonthDay(dateString) {
        if (!dateString) return "--";
        return (0, _momentDefault.default)(dateString).format("YYYY-M-D");
    }
    parseGpsForDisplay(input, axis) {
        if (typeof input !== "number" || !axis) return input;
        const positiveSymbol = axis == "latitude" ? "N" : "E";
        const negativeSymbol = axis == "latitude" ? "S" : "W";
        const directionSymbol = input >= 0 ? positiveSymbol : negativeSymbol;
        return `${Math.abs((0, _roundDefault.default)(input, 1))}\u00b0${directionSymbol}`;
    }
    getConnectivityFromShadow({ shadow = {} } = {}) {
        if (!Object.keys(shadow).length) return;
        const { signalCollections } = shadow;
        const { signals: [{ value = "" }] = [
            {}
        ] } = signalCollections.find((s)=>s._id === (0, _staticUUIDs.CONNECT_DISCONNECT_ID)) || {};
        return value;
    }
    getOnlineTimeFromShadow({ shadow = {} }) {
        if (!Object.keys(shadow).length) return;
        const { signalCollections = [] } = shadow;
        const { timestamp = "" } = signalCollections.find((s)=>s._id === (0, _staticUUIDs.CONNECT_DISCONNECT_ID)) || {};
        return (0, _momentDefault.default)(timestamp).toNow(true);
    }
    getActiveSignalsFromShadow({ shadow = {} }) {
        const { signalCollections } = shadow;
        if ((0, _isEmptyDefault.default)(signalCollections)) return 0;
        return signalCollections.reduce((active, { _id, signals })=>{
            if ((0, _isEmptyDefault.default)(signals)) return active;
            _id !== (0, _staticUUIDs.CONNECT_DISCONNECT_ID) && (active += signals.length);
            return active;
        }, 0);
    }
    parseLastUpdatedForDetails(lastUpdated) {
        if (!lastUpdated) return;
        return (0, _momentDefault.default)(lastUpdated).format("MMMM D, YYYY hh:mm:ss a");
    }
}
exports.default = AssetUtils;

},{"lodash/reduce":"brdcj","lodash/round":"immc6","lodash/isEmpty":"6WyGC","moment":"1e4qG","../Constants/StaticUUIDs":"cpjYY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brdcj":[function(require,module,exports) {
var arrayReduce = require("8772d9c160085222"), baseEach = require("7c156122a905f02e"), baseIteratee = require("288ce78b1e338692"), baseReduce = require("7941e51212237a70"), isArray = require("b7d00545ad8400ba");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}
module.exports = reduce;

},{"8772d9c160085222":"4xeZ0","7c156122a905f02e":"hbtgh","288ce78b1e338692":"6jZAq","7941e51212237a70":"aIFrG","b7d00545ad8400ba":"1DVeR"}],"4xeZ0":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"hbtgh":[function(require,module,exports) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"i7P4y","f1e3fc84161ef3ec":"bY6r9"}],"i7P4y":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"9oLrx","1fb77c53defe5720":"9qKxr"}],"9qKxr":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"aB7KR","e8453365fdacc8da":"f4fT3","7760b47b02971dfa":"kzICo"}],"bY6r9":[function(require,module,exports) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"kzICo"}],"6jZAq":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"1Dnfv","4f010869f7b63154":"flZVA","28f06147d1eb9502":"2HXBf","3c56f88c4debf449":"1DVeR","aee920e0ef5bf111":"bSOBT"}],"1Dnfv":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"5GI5z","89e9034a8071e297":"eEnTQ","782598b150762386":"18Sgh"}],"5GI5z":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"cltFt","9003c0cc8ac007b6":"hrIE8"}],"hrIE8":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"9gcZQ","809bbb0c20650dbc":"4gOki"}],"9gcZQ":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"cltFt","96bc8a1825db53a5":"cXMUl","8bdece495e87fb69":"7eeNO","bb94920432a68eca":"kyaB8","45495edff98e5837":"1chae","18256411ae9e2858":"1DVeR","e5ba7abf54247fc5":"26W2O","50d786bb5c7366af":"hq5rz"}],"cXMUl":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"irm8l","1ee20de911db0cb0":"bjRBC","defff3d81be91b23":"c2cDw"}],"irm8l":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"lV1BE","9a831e81e9a1f98c":"blGac","1a2b6c8a7399c39f":"h2eS8"}],"blGac":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"h2eS8":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"bjRBC":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"c2cDw":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7eeNO":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"crlKT","dbf6aa5033a0f48":"eHExv","539966708f906e61":"evtiM","8142d4017f0a425f":"cXMUl","48cddf732eff33ba":"7z4fi","9dc78b26c5daba20":"lxNlE"}],"7z4fi":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"lxNlE":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"kyaB8":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"lOHy9"}],"lOHy9":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"hu5MU","aa79b69a13f924db":"igqw1","e3ad83e53433bc8a":"9qKxr"}],"hu5MU":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"8JuEE","148b85918856c33a":"1DVeR"}],"8JuEE":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"igqw1":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"egrke","6b1c62cea92cdb9":"gRVIR"}],"egrke":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"gRVIR":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"eEnTQ":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"6mRk0","94ffded3a85af2f6":"9qKxr"}],"6mRk0":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"6hgJK"}],"18Sgh":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"flZVA":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"hrIE8","d5ca180f7d6f956a":"dBTJh","3462bb3f546fa1f7":"105Hu","f5fef07966a1c4ee":"c7lh2","2a1cd212d48516":"6mRk0","885e72ee7fc6d296":"18Sgh","cd65eaf4a3af29f6":"b5swP"}],"dBTJh":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"5Vkba"}],"5Vkba":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"1tEcE","c3296f04fad32769":"b5swP"}],"1tEcE":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"1DVeR","e823e604d75f975b":"c7lh2","f5fff1c342107fbd":"6K5tB","b04e8cc634273c23":"iEDGT"}],"c7lh2":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"1DVeR","4cdff6c9e9ff5d38":"fMaHV"}],"fMaHV":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"5ltt8","74644060ad1a1d3c":"4gOki"}],"6K5tB":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"9EwFx"}],"9EwFx":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"kx0Xn"}],"kx0Xn":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"lV1BE"}],"iEDGT":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"E4Kq0"}],"E4Kq0":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"crlKT","8439a3a1551d0706":"chzeu","4b12c9f502d3288a":"1DVeR","a0ebd327d618908a":"fMaHV"}],"chzeu":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"b5swP":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"fMaHV"}],"105Hu":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"fdP9g","b0aefd36de99e579":"7O6Cp"}],"fdP9g":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"7O6Cp":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"1tEcE","47ffafdab3ba0d6f":"bpegN","93ebd263ff0131c1":"1DVeR","252ef74480e01958":"bxLaX","23c2f64e75e90a2":"aFNSq","af5ade297cb685ee":"b5swP"}],"bSOBT":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"fzLOJ","abf31da39349df22":"f5Egk","a387ef4a4373de2c":"c7lh2","9315973458389ae7":"b5swP"}],"fzLOJ":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"f5Egk":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"5Vkba"}],"aIFrG":[function(require,module,exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = baseReduce;

},{}],"immc6":[function(require,module,exports) {
var createRound = require("3079752f460caf92");
/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */ var round = createRound("round");
module.exports = round;

},{"3079752f460caf92":"4QB3j"}],"4QB3j":[function(require,module,exports) {
var root = require("247b8eb83876b1f9"), toInteger = require("952fa79a801c6577"), toNumber = require("86db409959857090"), toString = require("e9a71500a2fbf00");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsFinite = root.isFinite, nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = createRound;

},{"247b8eb83876b1f9":"gVq56","952fa79a801c6577":"fCKw5","86db409959857090":"3MLIQ","e9a71500a2fbf00":"iEDGT"}],"fCKw5":[function(require,module,exports) {
var toFinite = require("e624a4916a3de577");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"e624a4916a3de577":"b6tZP"}],"b6tZP":[function(require,module,exports) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"3MLIQ"}],"3MLIQ":[function(require,module,exports) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"57o9c","faaa289d287a34a5":"6hgJK","47b3bd23f771891":"fMaHV"}],"57o9c":[function(require,module,exports) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"gJ6UK"}],"gJ6UK":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"1e4qG":[function(require,module,exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

},{}],"cpjYY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONNECT_DISCONNECT_ID", ()=>CONNECT_DISCONNECT_ID);
parcelHelpers.export(exports, "DF_PROVISIONING_MODEL_ID", ()=>DF_PROVISIONING_MODEL_ID);
parcelHelpers.export(exports, "MAINTENANCE_LOG_ID", ()=>MAINTENANCE_LOG_ID);
parcelHelpers.export(exports, "NIL_UUID", ()=>NIL_UUID);
parcelHelpers.export(exports, "PROVISIONING_MODEL_ID", ()=>PROVISIONING_MODEL_ID);
parcelHelpers.export(exports, "PROVISIONING_MODEL_ORGID", ()=>PROVISIONING_MODEL_ORGID);
parcelHelpers.export(exports, "START_PUMP_COMMAND_ID", ()=>START_PUMP_COMMAND_ID);
parcelHelpers.export(exports, "STOP_PUMP_COMMAND_ID", ()=>STOP_PUMP_COMMAND_ID);
parcelHelpers.export(exports, "SET_PUMP_RPM_COMMAND_ID", ()=>SET_PUMP_RPM_COMMAND_ID);
parcelHelpers.export(exports, "XIRGO_PROVISIONING_MODEL_ID", ()=>XIRGO_PROVISIONING_MODEL_ID);
parcelHelpers.export(exports, "XIRGO_V2_PROVISIONING_MODEL_ID", ()=>XIRGO_V2_PROVISIONING_MODEL_ID);
parcelHelpers.export(exports, "XIRGO_STATIC_SIGNALS", ()=>XIRGO_STATIC_SIGNALS);
parcelHelpers.export(exports, "PROVISION_MODEL_ID_SET", ()=>PROVISION_MODEL_ID_SET);
parcelHelpers.export(exports, "HFX_FLASH_JOB_COMMAND_ID", ()=>HFX_FLASH_JOB_COMMAND_ID);
parcelHelpers.export(exports, "PROVISION_MODEL_ID_MAP", ()=>PROVISION_MODEL_ID_MAP);
parcelHelpers.export(exports, "isValidNotNilUuid", ()=>isValidNotNilUuid);
var _uuid = require("uuid");
var _vendors = require("./Vendors");
const CONNECT_DISCONNECT_ID = "2aedf7c0-7072-11e6-9616-d1436e22fac1";
const DF_PROVISIONING_MODEL_ID = "00000000-0000-0000-0000-000000000002";
const MAINTENANCE_LOG_ID = "00000000-0000-0000-0000-000000000000";
const NIL_UUID = "00000000-0000-0000-0000-000000000000";
const PROVISIONING_MODEL_ID = "00000000-0000-0000-0000-000000000001";
const PROVISIONING_MODEL_ORGID = "00000000-0000-0000-0000-000000000001";
const START_PUMP_COMMAND_ID = "00000000-0000-0000-0000-000000000001";
const STOP_PUMP_COMMAND_ID = "00000000-0000-0000-0000-000000000002";
const SET_PUMP_RPM_COMMAND_ID = "00000000-0000-0000-0000-000000000003";
const XIRGO_PROVISIONING_MODEL_ID = "00000000-0000-0000-0000-000000000003";
const XIRGO_V2_PROVISIONING_MODEL_ID = "00000000-0000-0000-0000-000000000004";
const XIRGO_STATIC_SIGNALS = [
    "10000000-0000-0000-0000-000000000001",
    "10000000-0000-0000-0000-000000000002",
    "10000000-0000-0000-0000-000000000003"
];
const PROVISION_MODEL_ID_SET = new Set([
    DF_PROVISIONING_MODEL_ID,
    PROVISIONING_MODEL_ID,
    XIRGO_PROVISIONING_MODEL_ID,
    XIRGO_V2_PROVISIONING_MODEL_ID
]);
const HFX_FLASH_JOB_COMMAND_ID = "00000000-0000-0000-0000-000000000200";
const PROVISION_MODEL_ID_MAP = new Map([
    [
        (0, _vendors.DF),
        DF_PROVISIONING_MODEL_ID
    ],
    [
        "protobuf",
        PROVISIONING_MODEL_ID
    ],
    [
        "json",
        PROVISIONING_MODEL_ID
    ],
    [
        (0, _vendors.XIRGO_V1_VENDOR_ID),
        XIRGO_PROVISIONING_MODEL_ID
    ],
    [
        (0, _vendors.XIRGO_V2_VENDOR_ID),
        XIRGO_V2_PROVISIONING_MODEL_ID
    ]
]);
function isValidNotNilUuid(uuid) {
    return (0, _uuid.validate)(uuid) && uuid !== NIL_UUID;
}

},{"uuid":"hIyym","./Vendors":"jVaXW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jVaXW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DF", ()=>DF);
parcelHelpers.export(exports, "ELEVAT", ()=>ELEVAT);
parcelHelpers.export(exports, "XIRGO_V1_VENDOR_ID", ()=>XIRGO_V1_VENDOR_ID);
parcelHelpers.export(exports, "XIRGO_V2_VENDOR_ID", ()=>XIRGO_V2_VENDOR_ID);
parcelHelpers.export(exports, "EPEC_6200_VENDOR_ID", ()=>EPEC_6200_VENDOR_ID);
parcelHelpers.export(exports, "ACTIA_ACU6_VENDOR_ID", ()=>ACTIA_ACU6_VENDOR_ID);
const DF = "1";
const ELEVAT = "elevat";
const XIRGO_V1_VENDOR_ID = "xirgo";
const XIRGO_V2_VENDOR_ID = "xirgov2";
const EPEC_6200_VENDOR_ID = "epec_6200";
const ACTIA_ACU6_VENDOR_ID = "actia_acu6";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1OiRg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALERTS", ()=>ALERTS);
parcelHelpers.export(exports, "COMMAND_HISTORY", ()=>COMMAND_HISTORY);
parcelHelpers.export(exports, "DASHBOARD", ()=>DASHBOARD);
parcelHelpers.export(exports, "DETAILS", ()=>DETAILS);
parcelHelpers.export(exports, "DM1_FAULTS", ()=>DM1_FAULTS);
parcelHelpers.export(exports, "MAINTENANCE", ()=>MAINTENANCE);
parcelHelpers.export(exports, "SUBSCRIPTIONS", ()=>SUBSCRIPTIONS);
parcelHelpers.export(exports, "VALIDATION_ERRORS", ()=>VALIDATION_ERRORS);
parcelHelpers.export(exports, "V2_MAINTENANCE", ()=>V2_MAINTENANCE);
parcelHelpers.export(exports, "ASSET_TABS", ()=>ASSET_TABS);
const ALERTS = "alerts";
const COMMAND_HISTORY = "commandHistory";
const DASHBOARD = "dashboard";
const DETAILS = "details";
const DM1_FAULTS = "dm1faults";
const MAINTENANCE = "maintenance";
const SUBSCRIPTIONS = "subscriptions";
const VALIDATION_ERRORS = "validationErrors";
const V2_MAINTENANCE = "v2_maintenance";
const ASSET_TABS = [
    ALERTS,
    COMMAND_HISTORY,
    DASHBOARD,
    DETAILS,
    DM1_FAULTS,
    MAINTENANCE,
    SUBSCRIPTIONS,
    VALIDATION_ERRORS,
    V2_MAINTENANCE
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ieo1E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASSET_MODEL", ()=>ASSET_MODEL);
parcelHelpers.export(exports, "BILLING", ()=>BILLING);
parcelHelpers.export(exports, "CORE", ()=>CORE);
parcelHelpers.export(exports, "DASHBOARD", ()=>DASHBOARD);
parcelHelpers.export(exports, "GEOFENCE", ()=>GEOFENCE);
parcelHelpers.export(exports, "MAINTENANCE", ()=>MAINTENANCE);
parcelHelpers.export(exports, "ORGANIZATION", ()=>ORGANIZATION);
parcelHelpers.export(exports, "PROVISION", ()=>PROVISION);
parcelHelpers.export(exports, "REMOTE", ()=>REMOTE);
parcelHelpers.export(exports, "REPORT", ()=>REPORT);
parcelHelpers.export(exports, "USER", ()=>USER);
parcelHelpers.export(exports, "USER_PERMISSION", ()=>USER_PERMISSION);
parcelHelpers.export(exports, "CREATE", ()=>CREATE);
parcelHelpers.export(exports, "READ", ()=>READ);
parcelHelpers.export(exports, "UPDATE", ()=>UPDATE);
parcelHelpers.export(exports, "DELETE", ()=>DELETE);
parcelHelpers.export(exports, "MANAGE", ()=>MANAGE);
parcelHelpers.export(exports, "NO_PERMISSION", ()=>NO_PERMISSION);
parcelHelpers.export(exports, "READ_PERMISSION", ()=>READ_PERMISSION);
parcelHelpers.export(exports, "WRITE_PERMISSION", ()=>WRITE_PERMISSION);
parcelHelpers.export(exports, "MANAGE_PERMISSION", ()=>MANAGE_PERMISSION);
parcelHelpers.export(exports, "ASSET_MODEL_CREATE", ()=>ASSET_MODEL_CREATE);
parcelHelpers.export(exports, "ASSET_MODEL_READ", ()=>ASSET_MODEL_READ);
parcelHelpers.export(exports, "ASSET_MODEL_UPDATE", ()=>ASSET_MODEL_UPDATE);
parcelHelpers.export(exports, "ASSET_MODEL_DELETE", ()=>ASSET_MODEL_DELETE);
parcelHelpers.export(exports, "OUTPUTSIGNAL_CREATE", ()=>OUTPUTSIGNAL_CREATE);
parcelHelpers.export(exports, "OUTPUTSIGNAL_UPDATE", ()=>OUTPUTSIGNAL_UPDATE);
parcelHelpers.export(exports, "OUTPUTSIGNAL_DELETE", ()=>OUTPUTSIGNAL_DELETE);
parcelHelpers.export(exports, "RULES_CREATE", ()=>RULES_CREATE);
parcelHelpers.export(exports, "RULES_UPDATE", ()=>RULES_UPDATE);
parcelHelpers.export(exports, "RULES_DELETE", ()=>RULES_DELETE);
parcelHelpers.export(exports, "RULE_CONDITIONS_CREATE", ()=>RULE_CONDITIONS_CREATE);
parcelHelpers.export(exports, "RULE_CONDITIONS_UPDATE", ()=>RULE_CONDITIONS_UPDATE);
parcelHelpers.export(exports, "RULE_CONDITIONS_DELETE", ()=>RULE_CONDITIONS_DELETE);
parcelHelpers.export(exports, "SIGNAL_CARDS_UPDATE", ()=>SIGNAL_CARDS_UPDATE);
parcelHelpers.export(exports, "SIGNAL_COLLECTIONS_CREATE", ()=>SIGNAL_COLLECTIONS_CREATE);
parcelHelpers.export(exports, "SIGNAL_COLLECTIONS_UPDATE", ()=>SIGNAL_COLLECTIONS_UPDATE);
parcelHelpers.export(exports, "SIGNAL_COLLECTIONS_DELETE", ()=>SIGNAL_COLLECTIONS_DELETE);
parcelHelpers.export(exports, "TRANSFORMS_CREATE", ()=>TRANSFORMS_CREATE);
parcelHelpers.export(exports, "TRANSFORMS_UPDATE", ()=>TRANSFORMS_UPDATE);
parcelHelpers.export(exports, "TRANSFORMS_DELETE", ()=>TRANSFORMS_DELETE);
parcelHelpers.export(exports, "BILLING_WRITE", ()=>BILLING_WRITE);
parcelHelpers.export(exports, "ALERTS_CLEAR", ()=>ALERTS_CLEAR);
parcelHelpers.export(exports, "ASSET_CREATE", ()=>ASSET_CREATE);
parcelHelpers.export(exports, "ASSET_UPDATE", ()=>ASSET_UPDATE);
parcelHelpers.export(exports, "ASSET_DELETE", ()=>ASSET_DELETE);
parcelHelpers.export(exports, "CORE_READ", ()=>CORE_READ);
parcelHelpers.export(exports, "WATERTRANSFER_CREATE", ()=>WATERTRANSFER_CREATE);
parcelHelpers.export(exports, "WATERTRANSFER_UPDATE", ()=>WATERTRANSFER_UPDATE);
parcelHelpers.export(exports, "WATERTRANSFER_DELETE", ()=>WATERTRANSFER_DELETE);
parcelHelpers.export(exports, "DASHBOARD_CREATE", ()=>DASHBOARD_CREATE);
parcelHelpers.export(exports, "DASHBOARD_READ", ()=>DASHBOARD_READ);
parcelHelpers.export(exports, "DASHBOARD_UPDATE", ()=>DASHBOARD_UPDATE);
parcelHelpers.export(exports, "DASHBOARD_DELETE", ()=>DASHBOARD_DELETE);
parcelHelpers.export(exports, "WIDGET_CREATE", ()=>WIDGET_CREATE);
parcelHelpers.export(exports, "WIDGET_UPDATE", ()=>WIDGET_UPDATE);
parcelHelpers.export(exports, "WIDGET_DELETE", ()=>WIDGET_DELETE);
parcelHelpers.export(exports, "WIDGET_GRID_UPDATE", ()=>WIDGET_GRID_UPDATE);
parcelHelpers.export(exports, "GEOFENCE_CREATE", ()=>GEOFENCE_CREATE);
parcelHelpers.export(exports, "GEOFENCE_READ", ()=>GEOFENCE_READ);
parcelHelpers.export(exports, "GEOFENCE_UPDATE", ()=>GEOFENCE_UPDATE);
parcelHelpers.export(exports, "GEOFENCE_DELETE", ()=>GEOFENCE_DELETE);
parcelHelpers.export(exports, "MAINTENANCE_LOG_CREATE", ()=>MAINTENANCE_LOG_CREATE);
parcelHelpers.export(exports, "MAINTENANCE_MANAGE", ()=>MAINTENANCE_MANAGE);
parcelHelpers.export(exports, "MAINTENANCE_READ", ()=>MAINTENANCE_READ);
parcelHelpers.export(exports, "MAINTENANCE_PARTS_CREATE", ()=>MAINTENANCE_PARTS_CREATE);
parcelHelpers.export(exports, "MAINTENANCE_PARTS_UPDATE", ()=>MAINTENANCE_PARTS_UPDATE);
parcelHelpers.export(exports, "MAINTENANCE_PARTS_DELETE", ()=>MAINTENANCE_PARTS_DELETE);
parcelHelpers.export(exports, "MAINTENANCE_REMINDERS_CREATE", ()=>MAINTENANCE_REMINDERS_CREATE);
parcelHelpers.export(exports, "MAINTENANCE_REMINDERS_UPDATE", ()=>MAINTENANCE_REMINDERS_UPDATE);
parcelHelpers.export(exports, "MAINTENANCE_REMINDERS_DELETE", ()=>MAINTENANCE_REMINDERS_DELETE);
parcelHelpers.export(exports, "MAINTENANCE_SCHEDULES_CREATE", ()=>MAINTENANCE_SCHEDULES_CREATE);
parcelHelpers.export(exports, "MAINTENANCE_SCHEDULES_UPDATE", ()=>MAINTENANCE_SCHEDULES_UPDATE);
parcelHelpers.export(exports, "MAINTENANCE_SCHEDULES_DELETE", ()=>MAINTENANCE_SCHEDULES_DELETE);
parcelHelpers.export(exports, "ORGANIZATION_CREATE", ()=>ORGANIZATION_CREATE);
parcelHelpers.export(exports, "ORGANIZATION_READ", ()=>ORGANIZATION_READ);
parcelHelpers.export(exports, "ORGANIZATION_UPDATE", ()=>ORGANIZATION_UPDATE);
parcelHelpers.export(exports, "ORGANIZATION_DELETE", ()=>ORGANIZATION_DELETE);
parcelHelpers.export(exports, "ORGANIZATION_MOVE", ()=>ORGANIZATION_MOVE);
parcelHelpers.export(exports, "PROVISION_CREATE", ()=>PROVISION_CREATE);
parcelHelpers.export(exports, "PROVISION_READ", ()=>PROVISION_READ);
parcelHelpers.export(exports, "PROVISION_UPDATE", ()=>PROVISION_UPDATE);
parcelHelpers.export(exports, "PROVISION_DELETE", ()=>PROVISION_DELETE);
parcelHelpers.export(exports, "ASSET_COMMANDS_UPDATE", ()=>ASSET_COMMANDS_UPDATE);
parcelHelpers.export(exports, "GATEWAY_VERSION_UPDATE", ()=>GATEWAY_VERSION_UPDATE);
parcelHelpers.export(exports, "REMOTE_CREATE", ()=>REMOTE_CREATE);
parcelHelpers.export(exports, "REMOTE_READ", ()=>REMOTE_READ);
parcelHelpers.export(exports, "REMOTE_UPDATE", ()=>REMOTE_UPDATE);
parcelHelpers.export(exports, "REMOTE_DELETE", ()=>REMOTE_DELETE);
parcelHelpers.export(exports, "REMOTE_EXECUTE", ()=>REMOTE_EXECUTE);
parcelHelpers.export(exports, "USER_COMMANDS_UPDATE", ()=>USER_COMMANDS_UPDATE);
parcelHelpers.export(exports, "FLEET_CREATE", ()=>FLEET_CREATE);
parcelHelpers.export(exports, "FLEET_UPDATE", ()=>FLEET_UPDATE);
parcelHelpers.export(exports, "FLEET_DELETE", ()=>FLEET_DELETE);
parcelHelpers.export(exports, "FLEET_REPORTS", ()=>FLEET_REPORTS);
parcelHelpers.export(exports, "REPORT_CREATE", ()=>REPORT_CREATE);
parcelHelpers.export(exports, "REPORT_READ", ()=>REPORT_READ);
parcelHelpers.export(exports, "REPORT_UPDATE", ()=>REPORT_UPDATE);
parcelHelpers.export(exports, "REPORT_DELETE", ()=>REPORT_DELETE);
parcelHelpers.export(exports, "REPORT_SCHEDULE", ()=>REPORT_SCHEDULE);
parcelHelpers.export(exports, "NON_PLATFORM_USER_SUBSCRIPTION", ()=>NON_PLATFORM_USER_SUBSCRIPTION);
parcelHelpers.export(exports, "RULE_SUBSCRIPTION_USERS", ()=>RULE_SUBSCRIPTION_USERS);
parcelHelpers.export(exports, "USER_CREATE", ()=>USER_CREATE);
parcelHelpers.export(exports, "USER_READ", ()=>USER_READ);
parcelHelpers.export(exports, "USER_UPDATE", ()=>USER_UPDATE);
parcelHelpers.export(exports, "USER_DELETE", ()=>USER_DELETE);
parcelHelpers.export(exports, "USER_PROFILE_CREATE", ()=>USER_PROFILE_CREATE);
parcelHelpers.export(exports, "USER_PROFILE_READ", ()=>USER_PROFILE_READ);
parcelHelpers.export(exports, "USER_PROFILE_UPDATE", ()=>USER_PROFILE_UPDATE);
parcelHelpers.export(exports, "USER_PROFILE_DELETE", ()=>USER_PROFILE_DELETE);
parcelHelpers.export(exports, "USER_PERMISSION_CREATE", ()=>USER_PERMISSION_CREATE);
parcelHelpers.export(exports, "USER_PERMISSION_READ", ()=>USER_PERMISSION_READ);
parcelHelpers.export(exports, "USER_PERMISSION_UPDATE", ()=>USER_PERMISSION_UPDATE);
parcelHelpers.export(exports, "USER_PERMISSION_DELETE", ()=>USER_PERMISSION_DELETE);
const ASSET_MODEL = "asset_model";
const BILLING = "billing";
const CORE = "core";
const DASHBOARD = "dashboard";
const GEOFENCE = "geofence";
const MAINTENANCE = "maintenance";
const ORGANIZATION = "organization";
const PROVISION = "provision";
const REMOTE = "remote";
const REPORT = "report";
const USER = "user";
const USER_PERMISSION = "user_permission";
const CREATE = "create";
const READ = "read";
const UPDATE = "update";
const DELETE = "delete";
const MANAGE = "manage";
const NO_PERMISSION = 0;
const READ_PERMISSION = 1;
const WRITE_PERMISSION = 2;
const MANAGE_PERMISSION = 3;
const ASSET_MODEL_CREATE = `${ASSET_MODEL}:${CREATE}`;
const ASSET_MODEL_READ = `${ASSET_MODEL}:${READ}`;
const ASSET_MODEL_UPDATE = `${ASSET_MODEL}:${UPDATE}`;
const ASSET_MODEL_DELETE = `${ASSET_MODEL}:${DELETE}`;
const OUTPUTSIGNAL_CREATE = `outputsignals:${CREATE}`;
const OUTPUTSIGNAL_UPDATE = `outputsignals:${UPDATE}`;
const OUTPUTSIGNAL_DELETE = `outputsignals:${DELETE}`;
const RULES_CREATE = `rules:${CREATE}`;
const RULES_UPDATE = `rules:${UPDATE}`;
const RULES_DELETE = `rules:${DELETE}`;
const RULE_CONDITIONS_CREATE = `rule-conditions:${CREATE}`;
const RULE_CONDITIONS_UPDATE = `rule-conditions:${UPDATE}`;
const RULE_CONDITIONS_DELETE = `rule-conditions:${DELETE}`;
const SIGNAL_CARDS_UPDATE = `signal-cards:${UPDATE}`;
const SIGNAL_COLLECTIONS_CREATE = `signal-collections:${CREATE}`;
const SIGNAL_COLLECTIONS_UPDATE = `signal-collections:${UPDATE}`;
const SIGNAL_COLLECTIONS_DELETE = `signal-collections:${DELETE}`;
const TRANSFORMS_CREATE = `transforms:${CREATE}`;
const TRANSFORMS_UPDATE = `transforms:${UPDATE}`;
const TRANSFORMS_DELETE = `transforms:${DELETE}`;
const BILLING_WRITE = `${BILLING}:write`;
const ALERTS_CLEAR = "alerts:clear";
const ASSET_CREATE = `asset:${CREATE}`;
const ASSET_UPDATE = `asset:${UPDATE}`;
const ASSET_DELETE = `asset:${DELETE}`;
const CORE_READ = `${CORE}:${READ}`;
const WATERTRANSFER_CREATE = `watertransfer:${CREATE}`;
const WATERTRANSFER_UPDATE = `watertransfer:${UPDATE}`;
const WATERTRANSFER_DELETE = `watertransfer:${DELETE}`;
const DASHBOARD_CREATE = `${DASHBOARD}:${CREATE}`;
const DASHBOARD_READ = `${DASHBOARD}:${READ}`;
const DASHBOARD_UPDATE = `${DASHBOARD}:${UPDATE}`;
const DASHBOARD_DELETE = `${DASHBOARD}:${DELETE}`;
const WIDGET_CREATE = `widget:${CREATE}`;
const WIDGET_UPDATE = `widget:${UPDATE}`;
const WIDGET_DELETE = `widget:${DELETE}`;
const WIDGET_GRID_UPDATE = `widget-grid:${UPDATE}`;
const GEOFENCE_CREATE = `${GEOFENCE}:${CREATE}`;
const GEOFENCE_READ = `${GEOFENCE}:${READ}`;
const GEOFENCE_UPDATE = `${GEOFENCE}:${UPDATE}`;
const GEOFENCE_DELETE = `${GEOFENCE}:${DELETE}`;
const MAINTENANCE_LOG_CREATE = `${MAINTENANCE}-log:${CREATE}`;
const MAINTENANCE_MANAGE = `${MAINTENANCE}:${MANAGE}`;
const MAINTENANCE_READ = `${MAINTENANCE}:${READ}`;
const MAINTENANCE_PARTS_CREATE = `maintenance-parts:${CREATE}`;
const MAINTENANCE_PARTS_UPDATE = `maintenance-parts:${UPDATE}`;
const MAINTENANCE_PARTS_DELETE = `maintenance-parts:${DELETE}`;
const MAINTENANCE_REMINDERS_CREATE = `maintenance-reminders:${CREATE}`;
const MAINTENANCE_REMINDERS_UPDATE = `maintenance-reminders:${UPDATE}`;
const MAINTENANCE_REMINDERS_DELETE = `maintenance-reminders:${DELETE}`;
const MAINTENANCE_SCHEDULES_CREATE = `maintenance-schedules:${CREATE}`;
const MAINTENANCE_SCHEDULES_UPDATE = `maintenance-schedules:${UPDATE}`;
const MAINTENANCE_SCHEDULES_DELETE = `maintenance-schedules:${DELETE}`;
const ORGANIZATION_CREATE = `${ORGANIZATION}:${CREATE}`;
const ORGANIZATION_READ = `${ORGANIZATION}:${READ}`;
const ORGANIZATION_UPDATE = `${ORGANIZATION}:${UPDATE}`;
const ORGANIZATION_DELETE = `${ORGANIZATION}:${DELETE}`;
const ORGANIZATION_MOVE = `${ORGANIZATION}:move`;
const PROVISION_CREATE = `${PROVISION}:${CREATE}`;
const PROVISION_READ = `${PROVISION}:${READ}`;
const PROVISION_UPDATE = `${PROVISION}:${UPDATE}`;
const PROVISION_DELETE = `${PROVISION}:${DELETE}`;
const ASSET_COMMANDS_UPDATE = `asset-commands:${UPDATE}`;
const GATEWAY_VERSION_UPDATE = `gateway-version:${UPDATE}`;
const REMOTE_CREATE = `${REMOTE}:${CREATE}`;
const REMOTE_READ = `${REMOTE}:${READ}`;
const REMOTE_UPDATE = `${REMOTE}:${UPDATE}`;
const REMOTE_DELETE = `${REMOTE}:${DELETE}`;
const REMOTE_EXECUTE = `${REMOTE}:execute`;
const USER_COMMANDS_UPDATE = `user-commands:${UPDATE}`;
const FLEET_CREATE = `fleet:${CREATE}`;
const FLEET_UPDATE = `fleet:${UPDATE}`;
const FLEET_DELETE = `fleet:${DELETE}`;
const FLEET_REPORTS = `fleet:reports`;
const REPORT_CREATE = `${REPORT}:${CREATE}`;
const REPORT_READ = `${REPORT}:${READ}`;
const REPORT_UPDATE = `${REPORT}:${UPDATE}`;
const REPORT_DELETE = `${REPORT}:${DELETE}`;
const REPORT_SCHEDULE = `${REPORT}:schedule`;
const NON_PLATFORM_USER_SUBSCRIPTION = `non-platform-${USER}:${UPDATE}`;
const RULE_SUBSCRIPTION_USERS = `rule-subscription-${USER}:${UPDATE}`;
const USER_CREATE = `${USER}:${CREATE}`;
const USER_READ = `${USER}:${READ}`;
const USER_UPDATE = `${USER}:${UPDATE}`;
const USER_DELETE = `${USER}:${DELETE}`;
const USER_PROFILE_CREATE = `user-profile:${CREATE}`;
const USER_PROFILE_READ = `user-profile:${READ}`;
const USER_PROFILE_UPDATE = `user-profile:${UPDATE}`;
const USER_PROFILE_DELETE = `user-profile:${DELETE}`;
const USER_PERMISSION_CREATE = `${USER_PERMISSION}:${CREATE}`;
const USER_PERMISSION_READ = `${USER_PERMISSION}:${READ}`;
const USER_PERMISSION_UPDATE = `${USER_PERMISSION}:${UPDATE}`;
const USER_PERMISSION_DELETE = `${USER_PERMISSION}:${DELETE}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQXcJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CurrentOrgProvider", ()=>CurrentOrgProvider);
parcelHelpers.export(exports, "CurrentOrgConsumer", ()=>CurrentOrgConsumer);
var _react = require("react");
const CurrentOrgContext = /*#__PURE__*/ (0, _react.createContext)({
    _id: "",
    features: {},
    logo: "",
    name: "",
    path: "",
    settings: {},
    Users: []
});
const CurrentOrgProvider = CurrentOrgContext.Provider;
const CurrentOrgConsumer = CurrentOrgContext.Consumer;
exports.default = CurrentOrgContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sVVe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CurrentUserProvider", ()=>CurrentUserProvider);
parcelHelpers.export(exports, "CurrentUserConsumer", ()=>CurrentUserConsumer);
var _react = require("react");
const CurrentUserContext = /*#__PURE__*/ (0, _react.createContext)({
    _id: ""
});
const CurrentUserProvider = CurrentUserContext.Provider;
const CurrentUserConsumer = CurrentUserContext.Consumer;
exports.default = CurrentUserContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lzIpe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsProvider", ()=>IconsProvider);
parcelHelpers.export(exports, "IconsConsumer", ()=>IconsConsumer);
var _react = require("react");
const IconsContext = /*#__PURE__*/ (0, _react.createContext)({
    alarmPin: "",
    alertHeaderDesktop: "",
    alertHeaderMobile: "",
    assetIcon: "",
    assetIconRed: "",
    assetIconWhite: "",
    assetModelIcon: "",
    assetModelIconWhite: "",
    avatar: "",
    certificateIcon: "",
    chartIcon: "",
    commandControlIcon: "",
    conditionsIcon: "",
    cumminsBannerDesktop: "",
    cumminsBannerMobile: "",
    cumminsIconBlack: "",
    cumminsIconWhite: "",
    emptyStateIcon: "",
    engineIcon: "",
    errorPageIcon: "",
    eventsHeaderDesktop: "",
    eventsIcon: "",
    fleetHeaderDesktop: "",
    fleetIcon: "",
    geofencingIconBlue: "",
    geofencingIconWhite: "",
    groupPin: "",
    inventoryHeaderDesktop: "",
    inventoryHeaderMobile: "",
    loginBackgroundImage: "",
    maintenanceIconEmpty: "",
    maintenanceIconWhite: "",
    mapClusterIcon: "",
    missingImage: "",
    modbusIcon: "",
    offlinePin: "",
    onlinePin: "",
    orgIcon: "",
    orgIconWhite: "",
    partsIconBlue: "",
    partsIconGrey: "",
    primaryLinkIcon: "",
    profileIcon: "",
    provisionIcon: "",
    provisionIconWhite: "",
    pumpIcon: "",
    reminderIcon: "",
    reportingIcon: "",
    reportsHeaderDesktop: "",
    reportsHeaderMobile: "",
    searchIcon: "",
    searchIconLg: "",
    signalIcon: "",
    signalIconWhite: "",
    tigeLoginBackgroundImage: "",
    usersIcon: "",
    usersIconWhite: "",
    widgetIcon: ""
});
const IconsProvider = IconsContext.Provider;
const IconsConsumer = IconsContext.Consumer;
exports.default = IconsContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asozp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrgsMapProvider", ()=>OrgsMapProvider);
parcelHelpers.export(exports, "OrgsMapConsumer", ()=>OrgsMapConsumer);
var _react = require("react");
const OrgsMapContext = /*#__PURE__*/ (0, _react.createContext)({
    "org._id": {
        gatewayCount: 0,
        logo: "org logo",
        name: "org name",
        path: "org path"
    }
});
const OrgsMapProvider = OrgsMapContext.Provider;
const OrgsMapConsumer = OrgsMapContext.Consumer;
exports.default = OrgsMapContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bWsFg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetCurrentOrgProvider", ()=>SetCurrentOrgProvider);
parcelHelpers.export(exports, "SetCurrentOrgConsumer", ()=>SetCurrentOrgConsumer);
var _react = require("react");
const SetCurrentOrgContext = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const SetCurrentOrgProvider = SetCurrentOrgContext.Provider;
const SetCurrentOrgConsumer = SetCurrentOrgContext.Consumer;
exports.default = SetCurrentOrgContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jhC9G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateTagsProvider", ()=>UpdateTagsProvider);
parcelHelpers.export(exports, "UpdateTagsConsumer", ()=>UpdateTagsConsumer);
var _react = require("react");
const { Provider, Consumer } = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const UpdateTagsProvider = Provider;
const UpdateTagsConsumer = Consumer;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eVyI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateCurrentOrgProvider", ()=>UpdateCurrentOrgProvider);
parcelHelpers.export(exports, "UpdateCurrentOrgConsumer", ()=>UpdateCurrentOrgConsumer);
var _react = require("react");
const UpdateCurrentOrgContext = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const UpdateCurrentOrgProvider = UpdateCurrentOrgContext.Provider;
const UpdateCurrentOrgConsumer = UpdateCurrentOrgContext.Consumer;
exports.default = UpdateCurrentOrgContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4l8D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkV2", ()=>checkV2);
parcelHelpers.export(exports, "tip", ()=>tip);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _rbacrules = require("./RBACRules");
var _dataTips = require("./DataTips");
var _dataTipsDefault = parcelHelpers.interopDefault(_dataTips);
var _accessTools = require("./AccessTools");
var _rbac = require("../Constants/RBAC");
var _staticUUIDs = require("../Constants/StaticUUIDs");
var _orgsMapContext = require("../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _rootOrgContext = require("../Context/RootOrgContext");
var _rootOrgContextDefault = parcelHelpers.interopDefault(_rootOrgContext);
function checkV2({ action, orgID, orgsMap, resource, rootOrgID, sharedGtemplate, sharedUserProfile }) {
    let permissionOrgID = orgID;
    if (sharedGtemplate?.orgID) {
        // if editLocked use sharedGtemplate.orgID for write actions
        const isWriteAction = action.includes((0, _rbac.UPDATE)) || action.includes((0, _rbac.DELETE));
        if (sharedGtemplate.editLocked && isWriteAction) permissionOrgID = sharedGtemplate.orgID;
        else {
            // get the user's rootOrg path
            const { path = "" } = orgsMap?.[rootOrgID] || {};
            // if the sharedGtemplate is from an org somewhere in the path
            // use the user's rootOrgID for the permissions check of asset_model
            if (path?.includes?.(sharedGtemplate?.orgID)) permissionOrgID = rootOrgID;
        }
    }
    // sharedUserProfile only passed in from src/Components/Organization/UserProfileActionDropdown from the Edit toggle wrapper
    // there is no individual READ op to consider and only profile owning org can delete
    if (sharedUserProfile?.shared && !sharedUserProfile?.editLocked) {
        // get the user's rootOrg path
        const { path = "" } = orgsMap?.[rootOrgID] || {};
        // if the sharedUserProfile is from an org somewhere in the path
        // use the user's rootOrgID for the permissions check of user
        if (path?.includes?.(orgID)) permissionOrgID = rootOrgID;
    }
    const permission = (0, _accessTools.getPermissionForResource)(permissionOrgID, resource);
    if (!permission) return false;
    return (0, _rbacrules.rulesV2).get(Number.parseInt(permission, 10))?.get?.(resource)?.has?.(action);
}
function tip(dataTips, action, data) {
    const staticDataTips = dataTips.static;
    if (staticDataTips && staticDataTips[action]) // static data-tip provided for action
    return staticDataTips[action];
    const dynamicDataTips = dataTips.dynamic;
    if (dynamicDataTips) {
        const dataTipCondition = dynamicDataTips[action];
        if (!dataTipCondition) // dynamic data-tip not provided for action
        return false;
        // dynamic data-tip provided for action
        return dataTipCondition(data);
    }
    // no data-tips provided
    return false;
}
function Can({ data = {}, no, orgID, perform, resource, sharedGtemplate, sharedUserProfile, yes }) {
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const { _id: rootOrgID } = (0, _react.useContext)((0, _rootOrgContextDefault.default));
    if (perform === (0, _rbac.ASSET_MODEL_READ) && orgID === (0, _staticUUIDs.PROVISIONING_MODEL_ORGID)) return yes();
    if (perform === (0, _rbac.REPORT_CREATE) && !(0, _accessTools.hasReadAccessToResource)(orgID, (0, _rbac.ASSET_MODEL))) return no();
    // checks user permissions
    const isAuthorized = checkV2({
        action: perform,
        orgID,
        orgsMap,
        resource,
        rootOrgID,
        sharedGtemplate,
        sharedUserProfile
    });
    // extra check to make sure org is enabled for remote actions
    const currentOrgRemote = orgsMap?.[orgID]?.features?.remote;
    const orgRemoteCheck = resource !== (0, _rbac.REMOTE) || currentOrgRemote;
    // extra check to make sure that gateway is remote enabled for execute
    const gatewayRemoteCheck = perform !== (0, _rbac.REMOTE_EXECUTE) || data?.assetRemote;
    if (isAuthorized && orgRemoteCheck && gatewayRemoteCheck) return yes();
    const conditionalRemoteTooltipData = resource === (0, _rbac.REMOTE) ? {
        currentUserRemote: isAuthorized
    } : {};
    const dataTip = tip((0, _dataTipsDefault.default), perform, {
        ...data,
        currentOrgRemote,
        ...conditionalRemoteTooltipData
    });
    return dataTip ? no(dataTip) : no();
}
Can.propTypes = {
    data: (0, _propTypesDefault.default).any,
    no: (0, _propTypesDefault.default).func,
    orgID: (0, _propTypesDefault.default).string,
    perform: (0, _propTypesDefault.default).string,
    resource: (0, _propTypesDefault.default).string,
    sharedGtemplate: (0, _propTypesDefault.default).shape({
        editLocked: (0, _propTypesDefault.default).bool,
        orgID: (0, _propTypesDefault.default).string
    }),
    yes: (0, _propTypesDefault.default).func
};
Can.defaultProps = {
    no: ()=>null,
    yes: ()=>null
};
exports.default = Can;

},{"react":"9njXz","prop-types":"bnNSm","./RBACRules":"hAwa5","./DataTips":"owX2p","./AccessTools":"j912a","../Constants/RBAC":"ieo1E","../Constants/StaticUUIDs":"cpjYY","../Context/OrgsMapContext":"asozp","../Context/RootOrgContext":"2o1kk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAwa5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rulesV2", ()=>rulesV2);
var _rbac = require("../Constants/RBAC");
const rulesV2 = new Map([
    [
        1,
        new Map([
            [
                (0, _rbac.ASSET_MODEL),
                new Set([
                    (0, _rbac.ASSET_MODEL_READ)
                ])
            ],
            [
                (0, _rbac.CORE),
                new Set([
                    (0, _rbac.CORE_READ)
                ])
            ],
            [
                (0, _rbac.DASHBOARD),
                new Set([
                    (0, _rbac.DASHBOARD_READ)
                ])
            ],
            [
                (0, _rbac.GEOFENCE),
                new Set([
                    (0, _rbac.GEOFENCE_READ)
                ])
            ],
            [
                (0, _rbac.MAINTENANCE),
                new Set([
                    (0, _rbac.MAINTENANCE_READ)
                ])
            ],
            [
                (0, _rbac.ORGANIZATION),
                new Set([
                    (0, _rbac.ORGANIZATION_READ)
                ])
            ],
            [
                (0, _rbac.PROVISION),
                new Set([
                    (0, _rbac.PROVISION_READ)
                ])
            ],
            [
                (0, _rbac.REMOTE),
                new Set([
                    (0, _rbac.REMOTE_READ)
                ])
            ],
            [
                (0, _rbac.REPORT),
                new Set([
                    (0, _rbac.REPORT_READ)
                ])
            ],
            [
                (0, _rbac.USER),
                new Set([
                    (0, _rbac.USER_READ),
                    (0, _rbac.USER_PROFILE_READ)
                ])
            ],
            [
                (0, _rbac.USER_PERMISSION),
                new Set([
                    (0, _rbac.USER_PERMISSION_READ),
                    (0, _rbac.USER_PROFILE_READ)
                ])
            ]
        ])
    ],
    [
        2,
        new Map([
            [
                (0, _rbac.ASSET_MODEL),
                new Set([
                    (0, _rbac.ASSET_MODEL_READ),
                    (0, _rbac.ASSET_MODEL_CREATE),
                    (0, _rbac.ASSET_MODEL_UPDATE),
                    (0, _rbac.ASSET_MODEL_DELETE),
                    (0, _rbac.OUTPUTSIGNAL_CREATE),
                    (0, _rbac.OUTPUTSIGNAL_DELETE),
                    (0, _rbac.OUTPUTSIGNAL_UPDATE),
                    (0, _rbac.RULES_CREATE),
                    (0, _rbac.RULES_UPDATE),
                    (0, _rbac.RULES_DELETE),
                    (0, _rbac.RULE_CONDITIONS_CREATE),
                    (0, _rbac.RULE_CONDITIONS_UPDATE),
                    (0, _rbac.RULE_CONDITIONS_DELETE),
                    (0, _rbac.SIGNAL_CARDS_UPDATE),
                    (0, _rbac.SIGNAL_COLLECTIONS_CREATE),
                    (0, _rbac.SIGNAL_COLLECTIONS_UPDATE),
                    (0, _rbac.SIGNAL_COLLECTIONS_DELETE),
                    (0, _rbac.TRANSFORMS_CREATE),
                    (0, _rbac.TRANSFORMS_UPDATE),
                    (0, _rbac.TRANSFORMS_DELETE)
                ])
            ],
            [
                (0, _rbac.BILLING),
                new Set([
                    (0, _rbac.BILLING_WRITE)
                ])
            ],
            [
                (0, _rbac.CORE),
                new Set([
                    (0, _rbac.ALERTS_CLEAR),
                    (0, _rbac.ASSET_CREATE),
                    (0, _rbac.ASSET_UPDATE),
                    (0, _rbac.ASSET_DELETE),
                    (0, _rbac.CORE_READ),
                    (0, _rbac.WATERTRANSFER_CREATE),
                    (0, _rbac.WATERTRANSFER_DELETE),
                    (0, _rbac.WATERTRANSFER_UPDATE)
                ])
            ],
            [
                (0, _rbac.DASHBOARD),
                new Set([
                    (0, _rbac.DASHBOARD_CREATE),
                    (0, _rbac.DASHBOARD_READ),
                    (0, _rbac.DASHBOARD_UPDATE),
                    (0, _rbac.DASHBOARD_DELETE),
                    (0, _rbac.WIDGET_CREATE),
                    (0, _rbac.WIDGET_DELETE),
                    (0, _rbac.WIDGET_UPDATE),
                    (0, _rbac.WIDGET_GRID_UPDATE)
                ])
            ],
            [
                (0, _rbac.GEOFENCE),
                new Set([
                    (0, _rbac.GEOFENCE_READ),
                    (0, _rbac.GEOFENCE_CREATE),
                    (0, _rbac.GEOFENCE_UPDATE),
                    (0, _rbac.GEOFENCE_DELETE)
                ])
            ],
            [
                (0, _rbac.MAINTENANCE),
                new Set([
                    (0, _rbac.MAINTENANCE_READ),
                    (0, _rbac.MAINTENANCE_LOG_CREATE),
                    (0, _rbac.MAINTENANCE_PARTS_CREATE),
                    (0, _rbac.MAINTENANCE_PARTS_DELETE),
                    (0, _rbac.MAINTENANCE_PARTS_UPDATE),
                    (0, _rbac.MAINTENANCE_REMINDERS_CREATE),
                    (0, _rbac.MAINTENANCE_REMINDERS_UPDATE),
                    (0, _rbac.MAINTENANCE_REMINDERS_DELETE),
                    (0, _rbac.MAINTENANCE_SCHEDULES_CREATE),
                    (0, _rbac.MAINTENANCE_SCHEDULES_UPDATE),
                    (0, _rbac.MAINTENANCE_SCHEDULES_DELETE)
                ])
            ],
            [
                (0, _rbac.ORGANIZATION),
                new Set([
                    (0, _rbac.ORGANIZATION_CREATE),
                    (0, _rbac.ORGANIZATION_READ),
                    (0, _rbac.ORGANIZATION_UPDATE),
                    (0, _rbac.ORGANIZATION_DELETE),
                    (0, _rbac.ORGANIZATION_MOVE)
                ])
            ],
            [
                (0, _rbac.PROVISION),
                new Set([
                    (0, _rbac.ASSET_CREATE),
                    (0, _rbac.PROVISION_READ),
                    (0, _rbac.PROVISION_CREATE),
                    (0, _rbac.PROVISION_UPDATE),
                    (0, _rbac.PROVISION_DELETE)
                ])
            ],
            [
                (0, _rbac.REMOTE),
                new Set([
                    (0, _rbac.ASSET_COMMANDS_UPDATE),
                    (0, _rbac.REMOTE_READ),
                    (0, _rbac.REMOTE_CREATE),
                    (0, _rbac.REMOTE_UPDATE),
                    (0, _rbac.REMOTE_DELETE),
                    (0, _rbac.REMOTE_EXECUTE),
                    (0, _rbac.GATEWAY_VERSION_UPDATE),
                    (0, _rbac.USER_COMMANDS_UPDATE)
                ])
            ],
            [
                (0, _rbac.REPORT),
                new Set([
                    (0, _rbac.FLEET_CREATE),
                    (0, _rbac.FLEET_UPDATE),
                    (0, _rbac.FLEET_DELETE),
                    (0, _rbac.FLEET_REPORTS),
                    (0, _rbac.REPORT_READ),
                    (0, _rbac.REPORT_CREATE),
                    (0, _rbac.REPORT_DELETE),
                    (0, _rbac.REPORT_UPDATE),
                    (0, _rbac.REPORT_SCHEDULE)
                ])
            ],
            [
                (0, _rbac.USER),
                new Set([
                    (0, _rbac.NON_PLATFORM_USER_SUBSCRIPTION),
                    (0, _rbac.RULE_SUBSCRIPTION_USERS),
                    (0, _rbac.USER_READ),
                    (0, _rbac.USER_CREATE),
                    (0, _rbac.USER_UPDATE),
                    (0, _rbac.USER_DELETE)
                ])
            ],
            [
                (0, _rbac.USER_PERMISSION),
                new Set([
                    (0, _rbac.USER_PERMISSION_READ),
                    (0, _rbac.USER_PERMISSION_CREATE),
                    (0, _rbac.USER_PERMISSION_UPDATE),
                    (0, _rbac.USER_PERMISSION_DELETE),
                    (0, _rbac.USER_PROFILE_READ),
                    (0, _rbac.USER_PROFILE_CREATE),
                    (0, _rbac.USER_PROFILE_UPDATE),
                    (0, _rbac.USER_PROFILE_DELETE)
                ])
            ]
        ])
    ],
    [
        3,
        new Map([
            [
                (0, _rbac.MAINTENANCE),
                new Set([
                    (0, _rbac.MAINTENANCE_LOG_CREATE),
                    (0, _rbac.MAINTENANCE_MANAGE),
                    (0, _rbac.MAINTENANCE_READ),
                    (0, _rbac.MAINTENANCE_REMINDERS_CREATE),
                    (0, _rbac.MAINTENANCE_REMINDERS_UPDATE),
                    (0, _rbac.MAINTENANCE_REMINDERS_DELETE)
                ])
            ]
        ])
    ]
]);

},{"../Constants/RBAC":"ieo1E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"owX2p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ref", ()=>ref);
var _rbac = require("../Constants/RBAC");
const ref = {
    accessDefault: "Your account does not have the permission required to perform this action",
    accessDropdown: "Some of these actions are restricted based on your access level",
    commandsDefault: "Command and Control is disabled",
    commandsOrg: "Command and Control is disabled for this organization",
    commandsAsset: "Command and Control is disabled for this asset",
    commandsAssetModel: "Command and Control is disabled for this asset model",
    commandsUser: "Command and Control is disabled for this user"
};
const tips = {
    static: {
        [(0, _rbac.ALERTS_CLEAR)]: ref.accessDefault,
        [(0, _rbac.ASSET_CREATE)]: ref.accessDefault,
        [(0, _rbac.ASSET_UPDATE)]: ref.accessDropdown,
        [(0, _rbac.ASSET_DELETE)]: ref.accessDefault,
        [(0, _rbac.ASSET_MODEL_CREATE)]: ref.accessDefault,
        [(0, _rbac.ASSET_MODEL_READ)]: ref.accessDefault,
        [(0, _rbac.ASSET_MODEL_UPDATE)]: ref.accessDefault,
        [(0, _rbac.ASSET_MODEL_DELETE)]: ref.accessDefault,
        [(0, _rbac.CORE_READ)]: ref.accessDefault,
        [(0, _rbac.REMOTE_DELETE)]: ref.accessDefault,
        [(0, _rbac.FLEET_CREATE)]: ref.accessDefault,
        [(0, _rbac.FLEET_DELETE)]: ref.accessDefault,
        [(0, _rbac.FLEET_UPDATE)]: ref.accessDefault,
        [(0, _rbac.FLEET_REPORTS)]: ref.accessDefault,
        [(0, _rbac.GEOFENCE_CREATE)]: ref.accessDefault,
        [(0, _rbac.GEOFENCE_UPDATE)]: ref.accessDefault,
        [(0, _rbac.GEOFENCE_DELETE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_PARTS_CREATE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_PARTS_UPDATE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_PARTS_DELETE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_REMINDERS_CREATE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_REMINDERS_UPDATE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_REMINDERS_DELETE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_SCHEDULES_CREATE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_SCHEDULES_UPDATE)]: ref.accessDefault,
        [(0, _rbac.MAINTENANCE_SCHEDULES_DELETE)]: ref.accessDefault,
        [(0, _rbac.ORGANIZATION_CREATE)]: ref.accessDefault,
        [(0, _rbac.ORGANIZATION_UPDATE)]: ref.accessDefault,
        [(0, _rbac.ORGANIZATION_DELETE)]: ref.accessDefault,
        [(0, _rbac.ORGANIZATION_MOVE)]: ref.accessDefault,
        [(0, _rbac.OUTPUTSIGNAL_CREATE)]: ref.accessDefault,
        [(0, _rbac.OUTPUTSIGNAL_DELETE)]: ref.accessDefault,
        [(0, _rbac.OUTPUTSIGNAL_UPDATE)]: ref.accessDefault,
        [(0, _rbac.REPORT_CREATE)]: ref.accessDefault,
        [(0, _rbac.REPORT_DELETE)]: ref.accessDefault,
        [(0, _rbac.REPORT_UPDATE)]: ref.accessDefault,
        [(0, _rbac.REPORT_SCHEDULE)]: ref.accessDefault,
        [(0, _rbac.RULES_CREATE)]: ref.accessDefault,
        [(0, _rbac.RULES_UPDATE)]: ref.accessDefault,
        [(0, _rbac.RULES_DELETE)]: ref.accessDefault,
        [(0, _rbac.RULE_CONDITIONS_CREATE)]: ref.accessDefault,
        [(0, _rbac.RULE_CONDITIONS_UPDATE)]: ref.accessDefault,
        [(0, _rbac.RULE_CONDITIONS_DELETE)]: ref.accessDefault,
        [(0, _rbac.SIGNAL_CARDS_UPDATE)]: ref.accessDefault,
        [(0, _rbac.SIGNAL_COLLECTIONS_CREATE)]: ref.accessDefault,
        [(0, _rbac.SIGNAL_COLLECTIONS_UPDATE)]: ref.accessDefault,
        [(0, _rbac.SIGNAL_COLLECTIONS_DELETE)]: ref.accessDefault,
        [(0, _rbac.TRANSFORMS_CREATE)]: ref.accessDefault,
        [(0, _rbac.TRANSFORMS_UPDATE)]: ref.accessDefault,
        [(0, _rbac.TRANSFORMS_DELETE)]: ref.accessDefault,
        [(0, _rbac.USER_CREATE)]: ref.accessDefault,
        [(0, _rbac.USER_UPDATE)]: ref.accessDefault,
        [(0, _rbac.USER_DELETE)]: ref.accessDefault,
        [(0, _rbac.USER_PERMISSION_CREATE)]: ref.accessDefault,
        [(0, _rbac.USER_PERMISSION_UPDATE)]: ref.accessDefault,
        [(0, _rbac.USER_PERMISSION_DELETE)]: ref.accessDefault,
        [(0, _rbac.USER_PROFILE_CREATE)]: ref.accessDefault,
        [(0, _rbac.USER_PROFILE_UPDATE)]: ref.accessDefault,
        [(0, _rbac.USER_PROFILE_DELETE)]: ref.accessDefault,
        [(0, _rbac.USER_COMMANDS_UPDATE)]: ref.accessDefault,
        [(0, _rbac.WATERTRANSFER_CREATE)]: ref.accessDefault,
        [(0, _rbac.WATERTRANSFER_UPDATE)]: ref.accessDefault,
        [(0, _rbac.WATERTRANSFER_DELETE)]: ref.accessDefault,
        [(0, _rbac.WIDGET_CREATE)]: ref.accessDefault,
        [(0, _rbac.WIDGET_UPDATE)]: ref.accessDropdown,
        [(0, _rbac.WIDGET_DELETE)]: ref.accessDefault,
        [(0, _rbac.WIDGET_GRID_UPDATE)]: ref.accessDefault
    },
    dynamic: {
        [(0, _rbac.REMOTE_CREATE)]: ({ currentOrgRemote, currentUserRemote })=>{
            return !currentOrgRemote ? ref.commandsOrg : !currentUserRemote ? ref.commandsUser : ref.commandsAssetModel;
        },
        [(0, _rbac.REMOTE_EXECUTE)]: ({ assetRemote, currentOrgRemote, currentUserRemote })=>{
            return !assetRemote ? ref.commandsAsset : !currentOrgRemote ? ref.commandsOrg : !currentUserRemote ? ref.commandsUser : ref.commandsDefault;
        }
    }
};
exports.default = tips;

},{"../Constants/RBAC":"ieo1E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j912a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PERMISSION_ORDERING_MAP", ()=>PERMISSION_ORDERING_MAP);
/**
 * TODO: #getPermissionsFromLocalStorage should be replaced
 * by an implementation of SSE that updates the session
 * permissions whenever an organizatin is created/moved
 */ parcelHelpers.export(exports, "getPermissionsFromLocalStorage", ()=>getPermissionsFromLocalStorage);
parcelHelpers.export(exports, "getPermissionForResource", ()=>getPermissionForResource);
parcelHelpers.export(exports, "hasReadAccessToResource", ()=>hasReadAccessToResource);
parcelHelpers.export(exports, "hasWriteAccessToResource", ()=>hasWriteAccessToResource);
parcelHelpers.export(exports, "hasManageAccessToResource", ()=>hasManageAccessToResource);
parcelHelpers.export(exports, "hasReadAccessToEcosystem", ()=>hasReadAccessToEcosystem);
var _authService = require("../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _localStorageService = require("../Services/LocalStorageService");
var _localStorageServiceDefault = parcelHelpers.interopDefault(_localStorageService);
var _rbac = require("../Constants/RBAC");
const PERMISSION_ORDERING_MAP = new Map([
    [
        (0, _rbac.CORE),
        0
    ],
    [
        (0, _rbac.ASSET_MODEL),
        1
    ],
    [
        (0, _rbac.DASHBOARD),
        2
    ],
    [
        (0, _rbac.GEOFENCE),
        3
    ],
    [
        (0, _rbac.MAINTENANCE),
        4
    ],
    [
        (0, _rbac.ORGANIZATION),
        5
    ],
    [
        (0, _rbac.PROVISION),
        6
    ],
    [
        (0, _rbac.REMOTE),
        7
    ],
    [
        (0, _rbac.REPORT),
        8
    ],
    [
        (0, _rbac.USER),
        9
    ],
    [
        (0, _rbac.USER_PERMISSION),
        10
    ],
    [
        (0, _rbac.BILLING),
        11
    ]
]);
const auth = new (0, _authServiceDefault.default)();
const ls = new (0, _localStorageServiceDefault.default)();
function getPermissionsFromLocalStorage(orgID) {
    const rootOrgID = auth.getUserRootOrgID();
    const permissions = ls.getObjectByKey("permissions");
    if (!permissions) return {};
    if (orgID in permissions) return permissions;
    const rootOrgPerms = permissions[rootOrgID] || "";
    const newOrgAddedPerms = Object.assign({}, permissions, {
        [orgID]: rootOrgPerms
    });
    ls.setObject("permissions", newOrgAddedPerms);
    return newOrgAddedPerms;
}
function getPermissionForResource(orgID, resource) {
    const permissions = getPermissionsFromLocalStorage(orgID);
    const resourcePermission = permissions?.[orgID]?.split(",")?.[PERMISSION_ORDERING_MAP.get(resource)];
    return Number.parseInt(resourcePermission, 10);
}
function hasReadAccessToResource(orgID, resource) {
    const permissions = getPermissionsFromLocalStorage(orgID);
    const resourcePermission = permissions?.[orgID]?.split(",")?.[PERMISSION_ORDERING_MAP.get(resource)];
    return !!Number.parseInt(resourcePermission, 10);
}
function hasWriteAccessToResource(orgID, resource) {
    const permissions = getPermissionsFromLocalStorage(orgID);
    const resourcePermission = permissions?.[orgID]?.split(",")?.[PERMISSION_ORDERING_MAP.get(resource)];
    return Number.parseInt(resourcePermission, 10) >= 2;
}
function hasManageAccessToResource(orgID, resource) {
    const permissions = getPermissionsFromLocalStorage(orgID);
    const resourcePermission = permissions?.[orgID]?.split(",")?.[PERMISSION_ORDERING_MAP.get(resource)];
    return Number.parseInt(resourcePermission, 10) >= 3;
}
function hasReadAccessToEcosystem(orgID, resource, orgsMap = {}) {
    const permissions = getPermissionsFromLocalStorage(orgID);
    const targetOrgResourcePermission = permissions?.[orgID]?.split(",")?.[PERMISSION_ORDERING_MAP.get(resource)];
    if (!Number.parseInt(targetOrgResourcePermission, 10)) return false;
    const ecosystemOrgIDs = Object.entries(orgsMap).reduce((acc, [id, { path }])=>path.includes(orgID) && id !== orgID ? acc.concat(id) : acc, []);
    if (!ecosystemOrgIDs?.length) return false;
    return ecosystemOrgIDs.some((id)=>!!Number.parseInt(permissions?.[id]?.split(",")?.[PERMISSION_ORDERING_MAP.get(resource)], 10));
}

},{"../Services/AuthService":"8Bjjn","../Services/LocalStorageService":"3Alt2","../Constants/RBAC":"ieo1E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2o1kk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootOrgProvider", ()=>RootOrgProvider);
parcelHelpers.export(exports, "RootOrgConsumer", ()=>RootOrgConsumer);
var _react = require("react");
const RootOrgContext = /*#__PURE__*/ (0, _react.createContext)({
    _id: "",
    logo: "",
    name: "",
    path: ""
});
const RootOrgProvider = RootOrgContext.Provider;
const RootOrgConsumer = RootOrgContext.Consumer;
exports.default = RootOrgContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lP8X4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _parseISO = require("date-fns/parseISO");
var _parseISODefault = parcelHelpers.interopDefault(_parseISO);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactstrap = require("reactstrap");
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _debouncePromise = require("debounce-promise");
var _debouncePromiseDefault = parcelHelpers.interopDefault(_debouncePromise);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _loadingCircle = require("../LoadingCircle");
var _activationCodes = require("../../Constants/ActivationCodes");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _rbac = require("../../Constants/RBAC");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _accessTools = require("../../RBAC/AccessTools");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _authService = require("../../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _gtemplateReminderService = require("../../Services/GtemplateReminderService");
var _gtemplateReminderServiceDefault = parcelHelpers.interopDefault(_gtemplateReminderService);
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _selectStyles = require("../../Styles/SelectStyles");
exports.default = /*#__PURE__*/ (0, _react.memo)(ActivateAssetModal);
const initState = {
    activationModelReminders: [],
    associationExists: false,
    associationCheckPending: true,
    activationCodeSearchPending: false,
    error: "",
    instanceInitValuesMap: new Map(),
    modelSearchPending: true,
    remindersLoading: false,
    requestPending: false
};
function ActivateAssetModal(props) {
    const { reminderIcon } = (0, _react.useContext)((0, _iconsContextDefault.default)), orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const assetOrgBillingEnabled = (0, _react.useMemo)(()=>orgsMap?.[props.asset?.orgID]?.features?.billing?.enabled ?? false, [
        orgsMap,
        props.asset?.orgID
    ]);
    const [state, updateState] = (0, _react.useState)(()=>({
            ...initState,
            associationCheckPending: assetOrgBillingEnabled
        }));
    const assetService = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []), authService = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []), hasBillingWritePermission = (0, _react.useMemo)(()=>(0, _accessTools.hasWriteAccessToResource)(props.asset?.orgID, (0, _rbac.BILLING)), [
        props.asset?.orgID
    ]), reminderService = (0, _react.useMemo)(()=>new (0, _gtemplateReminderServiceDefault.default)(), []), sessionUserRootOrgID = (0, _react.useMemo)(()=>authService.getUserRootOrgID(), [
        authService
    ]), templateService = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    let source = (0, _axios.CancelToken).source();
    const fetchActivationCodes = async (po_number = "")=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    activationCodeSearchPending: true
                }));
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const params = {
                children: false,
                limit: 50,
                order: "asc",
                org_id: sessionUserRootOrgID,
                page: 1,
                po_number,
                sort: "po_number"
            };
            const { data } = await assetService.listActivationCodes(props.asset?._id, params, source.token);
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    activationCodeSearchPending: false
                }));
            return data?.map?.(({ _id, expiration_date, num_assets, num_assets_associated, org_id, po_number, type, use_for_suborgs })=>({
                    activation_code_id: _id,
                    expiration_date,
                    label: po_number,
                    num_assets,
                    num_assets_associated,
                    org_id,
                    po_number,
                    type,
                    use_for_suborgs,
                    value: _id
                })) ?? [];
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    activationCodeSearchPending: false
                }));
            return [];
        }
    };
    const fetchModels = async (search = "")=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    modelSearchPending: true
                }));
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const { data } = await templateService.fetchPaginatedTemplates(1, props.asset?.orgID, 50, "name", "asc", search, props.asset?.vendor, source.token);
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    modelSearchPending: false
                }));
            return data.filter(({ _id })=>!(0, _staticUUIDs.PROVISION_MODEL_ID_SET).has(_id)).map(({ _id, name })=>({
                    label: name,
                    value: _id
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    modelSearchPending: false
                }));
            return [];
        }
    };
    const fetchModelReminders = (0, _react.useCallback)(async ()=>{
        if (!state.selectedModel?.value) return;
        try {
            updateState((prevState)=>({
                    ...prevState,
                    remindersLoading: true
                }));
            const params = {
                gtemplate_id: state.selectedModel.value,
                limit: 500,
                page: 1
            };
            const { data: activationModelReminders } = await reminderService.getPaginatedGtemplateReminders(params);
            updateState((prevState)=>({
                    ...prevState,
                    activationModelReminders,
                    remindersLoading: false
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    remindersLoading: false
                }));
        }
    }, [
        reminderService,
        state.selectedModel?.value
    ]);
    const handleActivateClick = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    requestPending: true
                }));
            source = (0, _axios.CancelToken).source();
            const instance_init_values = Array.from(state.instanceInitValuesMap).reduce((acc, [reminder_id, initValues])=>{
                const conditionalInitDate = (0, _isValidDefault.default)(initValues.initial_date_value) ? {
                    initial_date_value: initValues.initial_date_value.toISOString()
                } : {};
                const conditionalInitSignal = Number.isFinite(Number.parseFloat(initValues.initial_signal_value)) ? {
                    initial_signal_value: Number.parseFloat(initValues.initial_signal_value)
                } : {};
                return acc.concat({
                    ...conditionalInitDate,
                    ...conditionalInitSignal,
                    reminder_id
                });
            }, []);
            const body = !assetOrgBillingEnabled || state.associationExists ? {
                instance_init_values
            } : {
                activationCodeID: state.selectedActivationCode?.value,
                instance_init_values
            };
            const activatedAsset = await templateService.assignTemplate(props.asset?._id, state.selectedModel?.value, body, source.token);
            props.handleActivateAssetSuccess(activatedAsset);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    };
    const handleActivationCodeSelected = (0, _react.useCallback)((selectedActivationCode)=>{
        updateState((prevState)=>({
                ...prevState,
                error: "",
                selectedActivationCode
            }));
    }, []);
    const handleModelSelected = (0, _react.useCallback)((selectedModel)=>{
        updateState((prevState)=>({
                ...prevState,
                activationModelReminders: [],
                error: "",
                instanceInitValuesMap: new Map(),
                selectedModel
            }));
    }, []);
    const handleCalendarReminderInstanceUpdate = (0, _react.useCallback)((reminder_id, initial_date_value)=>{
        updateState((prevState)=>{
            const instanceInitValuesMap = new Map(prevState.instanceInitValuesMap);
            const targetValues = instanceInitValuesMap.get(reminder_id) || {};
            return {
                ...prevState,
                instanceInitValuesMap: instanceInitValuesMap.set(reminder_id, {
                    ...targetValues,
                    initial_date_value
                })
            };
        });
    }, []), handleSignalReminderInstanceUpdate = (0, _react.useCallback)((reminder_id, initial_signal_value)=>{
        updateState((prevState)=>{
            const instanceInitValuesMap = new Map(prevState.instanceInitValuesMap);
            const targetValues = instanceInitValuesMap.get(reminder_id) || {};
            return {
                ...prevState,
                instanceInitValuesMap: instanceInitValuesMap.set(reminder_id, {
                    ...targetValues,
                    initial_signal_value
                })
            };
        });
    }, []);
    const isActivationCodeOptionDisabled = (0, _react.useCallback)(({ num_assets, num_assets_associated, org_id, type, use_for_suborgs })=>{
        switch(true){
            case type !== (0, _activationCodes.UNLIMITED) && num_assets_associated >= num_assets:
                return true;
            case !use_for_suborgs && org_id !== props.asset?.orgID:
                return true;
            default:
                return false;
        }
    }, [
        props.asset?.orgID
    ]);
    const showActivationCodeSelect = (0, _react.useMemo)(()=>assetOrgBillingEnabled && !state.associationExists, [
        assetOrgBillingEnabled,
        state.associationExists
    ]), showNoPaymentErrorMsg = (0, _react.useMemo)(()=>assetOrgBillingEnabled && !state.associationExists && !hasBillingWritePermission, [
        assetOrgBillingEnabled,
        hasBillingWritePermission,
        state.associationExists
    ]), submitIsDisabled = (0, _react.useMemo)(()=>{
        switch(true){
            case state.remindersLoading:
            case state.requestPending:
            case !state.selectedModel?.value:
            case assetOrgBillingEnabled && !state.associationExists && !state.selectedActivationCode?.value:
                return true;
            default:
                return false;
        }
    }, [
        assetOrgBillingEnabled,
        state.associationExists,
        state.remindersLoading,
        state.requestPending,
        state.selectedActivationCode?.value,
        state.selectedModel?.value
    ]);
    const startAtZeroReminders = (0, _react.useMemo)(()=>state.activationModelReminders?.filter?.(({ start_at_zero } = {})=>start_at_zero) ?? [], [
        state.activationModelReminders
    ]);
    (0, _react.useEffect)(()=>{
        fetchModelReminders();
    }, [
        fetchModelReminders
    ]);
    (0, _react.useEffect)(()=>{
        if (!assetOrgBillingEnabled) return;
        const checkSource = (0, _axios.CancelToken).source();
        (async function checkIfAssociationExists() {
            try {
                const { exists } = await assetService.assetAssociationExists(props.asset?._id, checkSource.token);
                updateState((prevState)=>({
                        ...prevState,
                        associationExists: exists,
                        associationCheckPending: false
                    }));
            } catch  {
                updateState((prevState)=>({
                        ...prevState,
                        associationCheckPending: false
                    }));
            }
        })();
        return checkSource.cancel;
    }, [
        assetOrgBillingEnabled,
        assetService,
        props.asset?._id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        centered: true,
        isOpen: props.isOpen,
        size: "lg",
        scrollable: true,
        toggle: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-0",
                toggle: props.toggleModal,
                children: "Activate Asset"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                className: "container-fluid",
                children: (()=>{
                    switch(true){
                        case state.associationCheckPending:
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "row align-items-center justify-content-center",
                                style: {
                                    height: "300px"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-auto",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                                        size: "3x"
                                    })
                                })
                            });
                        case showNoPaymentErrorMsg:
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "row align-items-center justify-content-center",
                                style: {
                                    height: "300px"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "col-12 col-md-10 text-center text-danger",
                                    children: "No form of payment was detected. Please contact your Billing Administrator to provide payment for subscription activation."
                                })
                            });
                        default:
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "row align-items-center justify-content-center",
                                        children: assetOrgBillingEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "col-12 col-md-10 modal-supplemental-text text-center text-md-left",
                                            children: "Activating an asset will begin a billing subscription. If the asset is associated to a payment method through an Activation Code, the activation will automatically happen. If not, then an Activation Code is required."
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "col-12 col-md-10 modal-supplemental-text text-center text-md-left",
                                            children: [
                                                "Choosing an Asset Model will activate a subscription and begin a billing cycle for this asset:",
                                                " ",
                                                props.asset?.nickname,
                                                "."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "row align-items-center justify-content-center mt-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "col-12 col-md-10 form-group",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "modal-inputlabel-text",
                                                    htmlFor: "assetModel",
                                                    children: "Asset Model"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                                                    cacheOptions: true,
                                                    captureMenuScroll: false,
                                                    defaultOptions: true,
                                                    className: "flex-grow-1",
                                                    isClearable: true,
                                                    isDisabled: state.requestPending,
                                                    isLoading: state.modelSearchPending,
                                                    isSearchable: true,
                                                    loadingMessage: ()=>"Searching Asset Models...",
                                                    loadOptions: (0, _debouncePromiseDefault.default)(fetchModels, 1000),
                                                    maxMenuHeight: 250,
                                                    menuShouldScrollIntoView: true,
                                                    name: "assetModel",
                                                    noOptionsMessage: ({ inputValue })=>`No models match: ${inputValue}`,
                                                    onChange: handleModelSelected,
                                                    placeholder: "Select an Asset Model",
                                                    styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                                    value: state.selectedModel
                                                })
                                            ]
                                        })
                                    }),
                                    showActivationCodeSelect ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "row align-items-center justify-content-center mt-3 mb-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "col-12 col-md-10 form-group",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                    className: "modal-inputlabel-text",
                                                    htmlFor: "activationCode",
                                                    children: [
                                                        "Activation Code",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                            className: "ml-3 text-danger",
                                                            icon: (0, _freeSolidSvgIcons.faAsterisk),
                                                            size: "xs"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "mb-0 form-text text-danger three-quarter-text",
                                                    children: "Activation Code was not found. Please select an Activation Code for payment method."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "form-text text-danger three-quarter-text",
                                                    children: "If no Activation Codes are available please contact your Billing Administrator."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                                                    cacheOptions: true,
                                                    captureMenuScroll: false,
                                                    defaultOptions: false,
                                                    className: "flex-grow-1",
                                                    formatOptionLabel: formatActivationCodeOptionLabel,
                                                    isClearable: true,
                                                    isDisabled: state.requestPending,
                                                    isLoading: state.activationCodeSearchPending,
                                                    isMulti: false,
                                                    isOptionDisabled: isActivationCodeOptionDisabled,
                                                    isSearchable: true,
                                                    loadingMessage: ()=>"Searching Activation Codes...",
                                                    loadOptions: (0, _debouncePromiseDefault.default)(fetchActivationCodes, 1000),
                                                    maxMenuHeight: 150,
                                                    menuShouldScrollIntoView: true,
                                                    name: "activationCode",
                                                    noOptionsMessage: ({ inputValue })=>inputValue ? `No Activation Codes match: ${inputValue}` : "Search by PO Number",
                                                    onChange: handleActivationCodeSelected,
                                                    placeholder: "Activation Code required to Activate",
                                                    styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                                    value: state.selectedActivationCode
                                                })
                                            ]
                                        })
                                    }) : null,
                                    startAtZeroReminders?.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "row align-items-center justify-content-center mt-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                                    className: "col-12 col-md-11",
                                                    children: `Set Maintenance Reminders Initial Value${startAtZeroReminders.length > 1 ? "s" : ""}`
                                                })
                                            }),
                                            startAtZeroReminders.map((r)=>{
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "row align-items-center justify-content-center mb-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "col-12 col-md-10 row rounded-lg border border-muted py-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "col-1 d-flex align-items-center justify-content-center",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    alt: "reminders icon",
                                                                    height: 20,
                                                                    src: reminderIcon
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "col-11",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        className: "mb-2",
                                                                        children: r.name
                                                                    }),
                                                                    (()=>{
                                                                        switch(r.type){
                                                                            case 0, _gtemplateReminder.ALL_TYPE:
                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                            className: "mb-2",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                    className: "mr-2 three-quarter-text text-muted",
                                                                                                    children: "Set next maintenance trigger to"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                                                    className: "form-control form-control-sm d-inline rounded-lg",
                                                                                                    onChange: ({ target: { value } })=>handleSignalReminderInstanceUpdate(r._id, value),
                                                                                                    style: {
                                                                                                        width: "80px"
                                                                                                    },
                                                                                                    type: "number",
                                                                                                    value: state.instanceInitValuesMap.get(r._id)?.initial_signal_value ?? ""
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                    className: "mr-2 three-quarter-text text-muted",
                                                                                                    children: "Set next maintenance trigger to"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                                                                    autoComplete: "off",
                                                                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InlineDatepicker, {}),
                                                                                                    onChange: (selected)=>handleCalendarReminderInstanceUpdate(r._id, selected),
                                                                                                    selected: state.instanceInitValuesMap.get(r._id)?.initial_date_value,
                                                                                                    showYearDropdown: true,
                                                                                                    withPortal: true
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            case 0, _gtemplateReminder.CALENDAR_TYPE:
                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "mr-2 three-quarter-text text-muted",
                                                                                            children: "Set next maintenance trigger to"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                                                            autoComplete: "off",
                                                                                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InlineDatepicker, {}),
                                                                                            onChange: (selected)=>handleCalendarReminderInstanceUpdate(r._id, selected),
                                                                                            selected: state.instanceInitValuesMap.get(r._id)?.initial_date_value,
                                                                                            showYearDropdown: true,
                                                                                            withPortal: true
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            case 0, _gtemplateReminder.SIGNAL_TYPE:
                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "mr-2 three-quarter-text text-muted",
                                                                                            children: "Set next maintenance trigger to"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                                            className: "form-control form-control-sm d-inline rounded-lg",
                                                                                            onChange: ({ target: { value } })=>handleSignalReminderInstanceUpdate(r._id, value),
                                                                                            style: {
                                                                                                width: "80px"
                                                                                            },
                                                                                            type: "number",
                                                                                            value: state.instanceInitValuesMap.get(r._id)?.initial_signal_value ?? ""
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            default:
                                                                                return null;
                                                                        }
                                                                    })()
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, r._id);
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "row align-items-end justify-content-end",
                                        style: {
                                            height: "100px"
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "col-12 col-md-10 text-right three-quarter-text text-danger",
                                            children: state.error
                                        })
                                    })
                                ]
                            });
                    }
                })()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "border-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-sm modal-button-submit ml-3 px-md-4 nine-tenth-text",
                    disabled: submitIsDisabled,
                    onClick: handleActivateClick,
                    children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCircleNotch),
                        spin: true
                    }) : "Activate"
                })
            })
        ]
    });
}
ActivateAssetModal.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        nickname: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        vendor: (0, _propTypesDefault.default).string
    }),
    handleActivateAssetSuccess: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};
function formatActivationCodeOptionLabel(data) {
    const expires = data?.expiration_date && (0, _isValidDefault.default)((0, _parseISODefault.default)(data.expiration_date)) ? (0, _formatDefault.default)((0, _parseISODefault.default)(data.expiration_date), "yyyy-MM-dd") : "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "d-flex flex-nowrap align-items-center text-muted",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-grow-1 d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-0 text-muted fs-eight-tenth text-nowrap",
                        children: data?.po_number
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-0 fs-three-quarter",
                        children: data?.activation_code_id
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "d-flex align-items-center justify-content-end fs-eight-tenth",
                children: data?.type === (0, _activationCodes.UNLIMITED) ? `Expires: ${expires}` : `${data?.num_assets_associated} / ${data?.num_assets}`
            })
        ]
    });
}
const InlineDatepicker = /*#__PURE__*/ (0, _react.forwardRef)(function InlineDatePicker({ onClick, value }, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "input-group input-group-sm rounded-lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "form-control border-right-0",
                onClick: onClick,
                ref: ref,
                style: {
                    width: "120px"
                },
                value: value
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input-group-append",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "input-group-text bg-white",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCalendarDays)
                    })
                })
            })
        ]
    });
});
InlineDatepicker.propTypes = {
    onClick: (0, _propTypesDefault.default).func,
    value: (0, _propTypesDefault.default).any
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","date-fns/format":"520Dk","date-fns/isValid":"l72u5","date-fns/parseISO":"7FPd2","react-datepicker":"cGh5X","reactstrap":"kjd7g","react-select/async":"iHFh7","debounce-promise":"fqOKC","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../LoadingCircle":"aIADA","../../Constants/ActivationCodes":"jlEqD","../../Constants/GtemplateReminder":"kNNU0","../../Constants/RBAC":"ieo1E","../../Constants/StaticUUIDs":"cpjYY","../../Context/IconsContext":"lzIpe","../../Context/OrgsMapContext":"asozp","../../RBAC/AccessTools":"j912a","../../Services/AssetService":"fL096","../../Services/AuthService":"8Bjjn","../../Services/GtemplateReminderService":"8VB1E","../../Services/TemplateService":"hGdvK","../../Styles/SelectStyles":"1LnYJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"520Dk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"l72u5","../subMilliseconds/index.js":"8J3yE","../toDate/index.js":"9koxn","../_lib/format/formatters/index.js":"l17xy","../_lib/format/longFormatters/index.js":"l4aYZ","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/protectedTokens/index.js":"5gdbP","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","../_lib/defaultLocale/index.js":"5kaPu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l72u5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"gmfSU","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gmfSU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bkfg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9koxn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8J3yE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ueVg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKtzz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l17xy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"aCfY8","../../../_lib/getUTCISOWeek/index.js":"hMWge","../../../_lib/getUTCISOWeekYear/index.js":"brbzX","../../../_lib/getUTCWeek/index.js":"8MUbv","../../../_lib/getUTCWeekYear/index.js":"18XUY","../../addLeadingZeros/index.js":"9Bsa8","../lightFormatters/index.js":"6EcHD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCfY8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMWge":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"9koxn","../startOfUTCISOWeek/index.js":"aTskV","../startOfUTCISOWeekYear/index.js":"37Lio","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aTskV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37Lio":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"brbzX","../startOfUTCISOWeek/index.js":"aTskV","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brbzX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MUbv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"9koxn","../startOfUTCWeek/index.js":"20vji","../startOfUTCWeekYear/index.js":"3h6rf","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20vji":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cViP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3h6rf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"18XUY","../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18XUY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Bsa8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EcHD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"9Bsa8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4aYZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dIoK7":[function(require,module,exports) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gdbP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kaPu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"4vfjK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vfjK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"33ZTo","./_lib/formatLong/index.js":"3snKV","./_lib/formatRelative/index.js":"aDrXK","./_lib/localize/index.js":"cGr1B","./_lib/match/index.js":"gyWiy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33ZTo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3snKV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"begpu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDrXK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGr1B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apnSk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyWiy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8m1gR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imsfL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7FPd2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseISO);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"49NaD","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49NaD":[function(require,module,exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGh5X":[function(require,module,exports) {
!function(e, t) {
    t(exports, require("55b400dfb9477df9"), require("6a082dc438cb1ca2"), require("3647656f9c7ebc5e"), require("13c776570732a9da"), require("6553b0b4b603e1c3"), require("d7b993ace1eca80"), require("786b9925c1b6b5ed"), require("4f1b37d05fed00b3"), require("5fc940b8b11b2f30"), require("b78d0278e54da1b4"), require("baecc74d7df402ea"), require("13428a01c277b105"), require("7360dafd9cf06bde"), require("aa659b497503e983"), require("7b7bf8fb2c20e0c7"), require("f501b8cd52ae4ff"), require("d616e9f0b9bc7b7a"), require("9e212fc4b323ed41"), require("e8ff49b0d1cab426"), require("12eec1f6d562e008"), require("72fc20cc52029f11"), require("42e3036b4499153e"), require("5592c752ef1290f4"), require("8406427195a66845"), require("fa470ac376b26caf"), require("bf3222da2f520817"), require("685dda4962dc82e1"), require("d6dea87c85b53e02"), require("b9a1398c1c94250d"), require("e1fbbdf633f9e5ae"), require("8ac41f1b252a0973"), require("156a522b3b8fd124"), require("f2620442a53b80d6"), require("1b94d4eb34edeca3"), require("47020b485e994171"), require("9818583261d8a102"), require("1a7d4440a348b466"), require("50dce9ec585a5332"), require("cdc90b6df52760f"), require("2fdd28e51cf3c8b2"), require("72fb68fdc0d9bca3"), require("964e71bf85841794"), require("38468de993ee0549"), require("ec1866b328e982ea"), require("5c05196fbf6d6b4d"), require("9a6937c0aa7a418e"), require("23c6d2169b7feabe"), require("7ec00ac1947d54ca"), require("fda4089c257f1876"), require("b5061c3c95f48e73"), require("f57afb99b9b06613"), require("496ef8c8ed2b34d6"), require("6663b9b2b265a941"), require("c3348d940b830a7f"), require("53a4aaeeb87e1c51"), require("45f66dd8a17e85aa"), require("a3a5398768dc185f"), require("201a807b2e6adc5e"), require("a89a534c753bb4c3"), require("11a993db5effee60"), require("96de361de41dc920"), require("acb830835f9d8af1"), require("80c2a8fbe4339722"));
}(this, function(e, t, r, a, n, o, s, i, p, l, c, d, u, f, h, m, y, v, D, g, k, w, b, S, C, _, M, P, E, N, x, Y, O, I, T, R, L, F, A, W, q, K, B, Q, H, j, V, U, z, $, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe, le) {
    "use strict";
    function ce(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = ce(t), ue = ce(a), fe = ce(n), he = ce(o), me = ce(s), ye = ce(i), ve = ce(p), De = ce(l), ge = ce(c), ke = ce(d), we = ce(u), be = ce(f), Se = ce(h), Ce = ce(m), _e = ce(y), Me = ce(v), Pe = ce(D), Ee = ce(g), Ne = ce(k), xe = ce(w), Ye = ce(b), Oe = ce(S), Ie = ce(C), Te = ce(_), Re = ce(M), Le = ce(P), Fe = ce(E), Ae = ce(N), We = ce(x), qe = ce(Y), Ke = ce(O), Be = ce(I), Qe = ce(T), He = ce(R), je = ce(L), Ve = ce(F), Ue = ce(A), ze = ce(W), $e = ce(q), Ge = ce(K), Je = ce(B), Xe = ce(Q), Ze = ce(H), et = ce(j), tt = ce(U), rt = ce(z), at = ce($), nt = ce(G), ot = ce(J), st = ce(X), it = ce(Z), pt = ce(ee), lt = ce(te), ct = ce(re), dt = ce(ae), ut = ce(ne), ft = ce(oe), ht = ce(se), mt = ce(ie), yt = ce(le);
    function vt(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Dt(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? vt(Object(r), !0).forEach(function(t) {
                St(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vt(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function gt(e) {
        return gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, gt(e);
    }
    function kt(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function wt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, Ot(a.key), a);
        }
    }
    function bt(e, t, r) {
        return t && wt(e.prototype, t), r && wt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function St(e, t, r) {
        return (t = Ot(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function Ct() {
        return Ct = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }, Ct.apply(this, arguments);
    }
    function _t(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && Pt(e, t);
    }
    function Mt(e) {
        return Mt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, Mt(e);
    }
    function Pt(e, t) {
        return Pt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        }, Pt(e, t);
    }
    function Et(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function Nt(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = Mt(e);
            if (t) {
                var n = Mt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return function(e, t) {
                if (t && ("object" == typeof t || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return Et(e);
            }(this, r);
        };
    }
    function xt(e) {
        return function(e) {
            if (Array.isArray(e)) return Yt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Yt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Yt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Ot(e) {
        var t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
                var a = r.call(e, t || "default");
                if ("object" != typeof a) return a;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    var It = function(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            default:
                return t.date({
                    width: "full"
                });
        }
    }, Tt = function(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            default:
                return t.time({
                    width: "full"
                });
        }
    }, Rt = {
        p: Tt,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return It(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", It(n, t)).replace("{{time}}", Tt(o, t));
        }
    }, Lt = 12, Ft = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function At(e) {
        var t = e ? "string" == typeof e || e instanceof String ? ft.default(e) : dt.default(e) : new Date;
        return Wt(t) ? t : null;
    }
    function Wt(e, t) {
        return t = t || new Date("1/1/1000"), he.default(e) && !lt.default(e, t);
    }
    function qt(e, t, r) {
        if ("en" === r) return me.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = tr(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && er() && tr(er()) && (a = tr(er())), me.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Kt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && qt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Bt(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return qe.default(We.default(Ae.default(e, i), o), a);
    }
    function Qt(e, t, r) {
        var a = tr(t || er());
        return Ge.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Ht(e) {
        return Je.default(e);
    }
    function jt(e) {
        return Ze.default(e);
    }
    function Vt(e) {
        return Xe.default(e);
    }
    function Ut() {
        return $e.default(At());
    }
    function zt(e, t) {
        return e && t ? st.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? ot.default(e, t) : !e && !t;
    }
    function Gt(e, t) {
        return e && t ? it.default(e, t) : !e && !t;
    }
    function Jt(e, t) {
        return e && t ? nt.default(e, t) : !e && !t;
    }
    function Xt(e, t) {
        return e && t ? at.default(e, t) : !e && !t;
    }
    function Zt(e, t, r) {
        var a, n = $e.default(t), o = et.default(r);
        try {
            a = ct.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function er() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function tr(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function rr(e, t) {
        return qt(Ke.default(At(), e), "LLLL", t);
    }
    function ar(e, t) {
        return qt(Ke.default(At(), e), "LLL", t);
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return ur(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Jt(e, t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return ct.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return Jt(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return ct.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(At(e)) || !1;
    }
    function or(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return ct.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return Jt(e, t);
        }) || !1;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return ur(e, {
            minDate: Je.default(r),
            maxDate: tt.default(a)
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && !o.some(function(t) {
            return $t(e, t);
        }) || s && !s(At(e)) || !1;
    }
    function ir(e, t, r, a) {
        var n = Le.default(e), o = Te.default(e), s = Le.default(t), i = Te.default(t), p = Le.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function pr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return ur(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Gt(e, t);
        }) || o && !o.some(function(t) {
            return Gt(e, t);
        }) || s && !s(At(e)) || !1;
    }
    function lr(e, t, r) {
        if (!he.default(t) || !he.default(r)) return !1;
        var a = Le.default(t), n = Le.default(r);
        return a <= e && n >= e;
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate, i = new Date(e, 0, 1);
        return ur(i, {
            minDate: Ze.default(r),
            maxDate: rt.default(a)
        }) || n && n.some(function(e) {
            return zt(i, e);
        }) || o && !o.some(function(e) {
            return zt(i, e);
        }) || s && !s(At(i)) || !1;
    }
    function dr(e, t, r, a) {
        var n = Le.default(e), o = Re.default(e), s = Le.default(t), i = Re.default(t), p = Le.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function ur(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && Ve.default(e, r) < 0 || a && Ve.default(e, a) > 0;
    }
    function fr(e, t) {
        return t.some(function(t) {
            return xe.default(t) === xe.default(e) && Ne.default(t) === Ne.default(e);
        });
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && fr(e, r) || a && !fr(e, a) || n && !n(e) || !1;
    }
    function mr(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = At(), s = qe.default(We.default(o, Ne.default(e)), xe.default(e)), i = qe.default(We.default(o, Ne.default(r)), xe.default(r)), p = qe.default(We.default(o, Ne.default(a)), xe.default(a));
        try {
            n = !ct.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = _e.default(e, 1);
        return r && Ue.default(r, n) > 0 || a && a.every(function(e) {
            return Ue.default(e, n) > 0;
        }) || !1;
    }
    function vr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ke.default(e, 1);
        return r && Ue.default(n, r) > 0 || a && a.every(function(e) {
            return Ue.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Pe.default(e, 1);
        return r && ze.default(r, n) > 0 || a && a.every(function(e) {
            return ze.default(e, n) > 0;
        }) || !1;
    }
    function gr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = be.default(e, 1);
        return r && ze.default(n, r) > 0 || a && a.every(function(e) {
            return ze.default(n, e) > 0;
        }) || !1;
    }
    function kr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return Ve.default(e, t) >= 0;
            });
            return He.default(a);
        }
        return r ? He.default(r) : t;
    }
    function wr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return Ve.default(e, t) <= 0;
            });
            return je.default(a);
        }
        return r ? je.default(r) : t;
    }
    function br() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (fe.default(o)) {
                var s = qt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === gt(o)) {
                var p = Object.keys(o), l = p[0], c = o[p[0]];
                if ("string" == typeof l && c.constructor === Array) for(var d = 0, u = c.length; d < u; d++){
                    var f = qt(c[d], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function Sr() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--holidays", r = new Map;
        return e.forEach(function(e) {
            var a = e.date, n = e.holidayName;
            if (fe.default(a)) {
                var o = qt(a, "MM.dd.yyyy"), s = r.get(o) || {};
                if (!("className" in s) || s.className !== t || (i = s.holidayNames, p = [
                    n
                ], i.length !== p.length || !i.every(function(e, t) {
                    return e === p[t];
                }))) {
                    var i, p;
                    s.className = t;
                    var l = s.holidayNames;
                    s.holidayNames = l ? [].concat(xt(l), [
                        n
                    ]) : [
                        n
                    ], r.set(o, s);
                }
            }
        }), r;
    }
    function Cr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = ye.default(ve.default(e, xe.default(n[i])), Ne.default(n[i])), l = ye.default(e, (r + 1) * a);
            pt.default(p, t) && lt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function _r(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function Mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Lt, r = Math.ceil(Le.default(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function Pr(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return dt.default(e.getTime() - 1e3 * t - r);
    }
    function Er(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Le.default(r) <= s), a && i && (i = Le.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Nr = function(e) {
        _t(a, e);
        var r = Nt(a);
        function a(e) {
            var n;
            kt(this, a), St(Et(n = r.call(this, e)), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(Et(n), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Le.default(n.props.minDate) : null, a = n.props.maxDate ? Le.default(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), St(Et(n), "onChange", function(e) {
                n.props.onChange(e);
            }), St(Et(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), St(Et(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), St(Et(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), St(Et(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, i = o || (s ? 10 : 5);
            return n.state = {
                yearsList: Er(n.props.year, i, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return bt(a, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    if (e) {
                        var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                            return e.ariaSelected;
                        }) : null;
                        e.scrollTop = r ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ue.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), xr = ht.default(Nr), Yr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), St(Et(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Le.default(e.props.minDate) : 1900, r = e.props.maxDate ? Le.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), St(Et(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), St(Et(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), St(Et(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), St(Et(e), "renderDropdown", function() {
                return de.default.createElement(xr, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), St(Et(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), St(Et(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), St(Et(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), St(Et(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), St(Et(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), St(Et(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Or = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), St(Et(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(Et(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), St(Et(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), St(Et(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Ir = ht.default(Or), Tr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), St(Et(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), St(Et(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), St(Et(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), St(Et(e), "renderDropdown", function(t) {
                return de.default.createElement(Ir, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), St(Et(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), St(Et(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), St(Et(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return ar(e, t.props.locale);
                    } : function(e) {
                        return rr(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function Rr(e, t) {
        for(var r = [], a = Ht(e), n = Ht(t); !pt.default(a, n);)r.push(At(a)), a = ke.default(a, 1);
        return r;
    }
    var Lr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Fe.default(e), r = zt(a.props.date, e) && $t(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(Et(a), t),
                        "aria-selected": r ? "true" : void 0
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", qt(e, a.props.dateFormat, a.props.locale));
                });
            }), St(Et(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), St(Et(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: Rr(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e = ue.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Fr = ht.default(Lr), Ar = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), St(Et(e), "renderSelectOptions", function() {
                for(var t = Ht(e.props.minDate), r = Ht(e.props.maxDate), a = []; !pt.default(t, r);){
                    var n = Fe.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, qt(t, e.props.dateFormat, e.props.locale))), t = ke.default(t, 1);
                }
                return a;
            }), St(Et(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), St(Et(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Fe.default(Ht(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), St(Et(e), "renderReadView", function(t) {
                var r = qt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), St(Et(e), "renderDropdown", function() {
                return de.default.createElement(Fr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), St(Et(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), St(Et(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = At(parseInt(t));
                zt(e.props.date, r) && $t(e.props.date, r) || e.props.onChange(r);
            }), St(Et(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), St(Et(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), St(Et(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), St(Et(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), St(Et(e), "isSameDay", function(t) {
                return Jt(e.props.day, t);
            }), St(Et(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !(e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected)) && (e.isSameDay(e.props.preSelection) || e.isSameWeek(e.props.preSelection));
            }), St(Et(e), "isDisabled", function() {
                return nr(e.props.day, e.props);
            }), St(Et(e), "isExcluded", function() {
                return or(e.props.day, e.props);
            }), St(Et(e), "isStartOfWeek", function() {
                return Jt(e.props.day, Qt(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), St(Et(e), "isSameWeek", function(t) {
                return e.props.showWeekPicker && Jt(t, Qt(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), St(Et(e), "getHighLightedClass", function() {
                var t = e.props, r = t.day, a = t.highlightDates;
                if (!a) return !1;
                var n = qt(r, "MM.dd.yyyy");
                return a.get(n);
            }), St(Et(e), "getHolidaysClass", function() {
                var t = e.props, r = t.day, a = t.holidays;
                if (!a) return !1;
                var n = qt(r, "MM.dd.yyyy");
                return a.has(n) ? [
                    a.get(n).className
                ] : void 0;
            }), St(Et(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Zt(r, a, n);
            }), St(Et(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, c = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !c || !i && e.isDisabled()) && (n && l && (lt.default(c, l) || Xt(c, l)) ? Zt(a, c, l) : (o && p && (pt.default(c, p) || Xt(c, p)) || !(!s || !p || l || !pt.default(c, p) && !Xt(c, p))) && Zt(a, p, c));
            }), St(Et(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Jt(a, o ? s : n);
            }), St(Et(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Jt(a, o || s ? i : n);
            }), St(Et(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Jt(a, r);
            }), St(Et(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Jt(n, r);
            }), St(Et(e), "isWeekend", function() {
                var t = Ye.default(e.props.day);
                return 0 === t || 6 === t;
            }), St(Et(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === Te.default(e.props.day);
            }), St(Et(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (Te.default(e.props.day) + 1) % 12 === e.props.month;
            }), St(Et(e), "isCurrentDay", function() {
                return e.isSameDay(At());
            }), St(Et(e), "isSelected", function() {
                return e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected);
            }), St(Et(e), "getClassNames", function(t) {
                var r, a = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ue.default("react-datepicker__day", a, "react-datepicker__day--" + qt(e.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"), e.getHolidaysClass());
            }), St(Et(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(qt(r, "PPPP", e.props.locale));
            }), St(Et(e), "getTitle", function() {
                var t = e.props, r = t.day, a = t.holidays, n = void 0 === a ? new Map : a, o = qt(r, "MM.dd.yyyy");
                return n.has(o) && n.get(o).holidayNames.length > 0 ? n.get(o).holidayNames.join(", ") : "";
            }), St(Et(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return (!e.props.showWeekPicker || !e.props.showWeekNumber && e.isStartOfWeek()) && (e.isKeyboardSelected() || e.isSameDay(a) && Jt(n, a)) ? 0 : -1;
            }), St(Et(e), "handleFocusDay", function() {
                var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = !1;
                0 === e.getTabIndex() && !r.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (a = !0), e.props.inline && !e.props.shouldFocusDayInline && (a = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (a = !0), e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() && (a = !1), e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() && (a = !1)), a && (null === (t = e.dayEl.current) || void 0 === t || t.focus({
                    preventScroll: !0
                }));
            }), St(Et(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Oe.default(e.props.day), e.props.day) : Oe.default(e.props.day);
            }), St(Et(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    title: e.getTitle(),
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected() || e.isInRange()
                }, e.renderDayContents(), "" !== e.getTitle() && de.default.createElement("span", {
                    className: "holiday-overlay"
                }, e.getTitle()));
            }), e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), qr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "weekNumberEl", de.default.createRef()), St(Et(e), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), St(Et(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), St(Et(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Jt(e.props.date, e.props.selected) && Jt(e.props.date, e.props.preSelection);
            }), St(Et(e), "getTabIndex", function() {
                return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || Jt(e.props.date, e.props.selected) && Jt(e.props.preSelection, e.props.selected)) ? 0 : -1;
            }), St(Et(e), "handleFocusWeekNumber", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && Jt(e.props.date, e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && e.weekNumberEl.current && e.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }), e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusWeekNumber();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusWeekNumber(e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick,
                        "react-datepicker__week-number--selected": Jt(this.props.date, this.props.selected),
                        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        ref: this.weekNumberEl,
                        className: ue.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick,
                        onKeyDown: this.handleOnKeyDown,
                        tabIndex: this.getTabIndex()
                    }, t);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        ariaLabelPrefix: "week "
                    };
                }
            }
        ]), r;
    }(de.default.Component), Kr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), St(Et(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), St(Et(e), "handleWeekClick", function(t, r, a) {
                if ("function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.showWeekPicker) {
                    var n = Qt(t, e.props.locale, e.props.calendarStartDay);
                    e.handleDayClick(n, a);
                }
                e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), St(Et(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : function(e, t) {
                    var r = t && tr(t) || er() && tr(er());
                    return Ie.default(e, r ? {
                        locale: r
                    } : null);
                }(t);
            }), St(Et(e), "renderDays", function() {
                var t = Qt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(Et(e), t, a) : void 0;
                    r.push(de.default.createElement(qr, {
                        key: "W",
                        weekNumber: a,
                        date: t,
                        onClick: n,
                        selected: e.props.selected,
                        preSelection: e.props.preSelection,
                        ariaLabelPrefix: e.props.ariaLabelPrefix,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Wr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(Et(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(Et(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        holidays: e.props.holidays,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), St(Et(e), "startOfWeek", function() {
                return Qt(e.props.day, e.props.locale, e.props.calendarStartDay);
            }), St(Et(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Jt(e.startOfWeek(), e.props.selected) && Jt(e.startOfWeek(), e.props.preSelection);
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e = {
                        "react-datepicker__week": !0,
                        "react-datepicker__week--selected": Jt(this.startOfWeek(), this.props.selected),
                        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        className: ue.default(e)
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Br = "two_columns", Qr = "three_columns", Hr = "four_columns", jr = St(St(St({}, Br, {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }), Qr, {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }), Hr, {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    });
    function Vr(e, t) {
        return e ? Hr : t ? Br : Qr;
    }
    var Ur = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", xt(Array(12)).map(function() {
                return de.default.createRef();
            })), St(Et(e), "QUARTER_REFS", xt(Array(4)).map(function() {
                return de.default.createRef();
            })), St(Et(e), "isDisabled", function(t) {
                return nr(t, e.props);
            }), St(Et(e), "isExcluded", function(t) {
                return or(t, e.props);
            }), St(Et(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), St(Et(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), St(Et(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), St(Et(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && $t(Ke.default(a, t), n);
            }), St(Et(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Gt(Be.default(a, t), n);
            }), St(Et(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && $t(Ke.default(a, t), o);
            }), St(Et(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Gt(Be.default(a, t), o);
            }), St(Et(e), "isInSelectingRangeMonth", function(t) {
                var r, a = e.props, n = a.day, o = a.selectsStart, s = a.selectsEnd, i = a.selectsRange, p = a.startDate, l = a.endDate, c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !c) && (o && l ? ir(c, l, t, n) : (s && p || !(!i || !p || l)) && ir(p, c, t, n));
            }), St(Et(e), "isSelectingMonthRangeStart", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var a = e.props, n = a.day, o = a.startDate, s = a.selectsStart, i = Ke.default(n, t), p = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return $t(i, s ? p : o);
            }), St(Et(e), "isSelectingMonthRangeEnd", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var a = e.props, n = a.day, o = a.endDate, s = a.selectsEnd, i = a.selectsRange, p = Ke.default(n, t), l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return $t(p, s || i ? l : o);
            }), St(Et(e), "isInSelectingRangeQuarter", function(t) {
                var r, a = e.props, n = a.day, o = a.selectsStart, s = a.selectsEnd, i = a.selectsRange, p = a.startDate, l = a.endDate, c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !c) && (o && l ? dr(c, l, t, n) : (s && p || !(!i || !p || l)) && dr(p, c, t, n));
            }), St(Et(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return $t(t, r) || $t(a, r);
            }), St(Et(e), "isCurrentMonth", function(e, t) {
                return Le.default(e) === Le.default(At()) && t === Te.default(At());
            }), St(Et(e), "isCurrentQuarter", function(e, t) {
                return Le.default(e) === Le.default(At()) && t === Re.default(At());
            }), St(Et(e), "isSelectedMonth", function(e, t, r) {
                return Te.default(r) === t && Le.default(e) === Le.default(r);
            }), St(Et(e), "isSelectedQuarter", function(e, t, r) {
                return Re.default(e) === t && Le.default(e) === Le.default(r);
            }), St(Et(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Qt(Ht(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Kr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Te.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    holidays: e.props.holidays,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    showWeekPicker: e.props.showWeekPicker,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ge.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), St(Et(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Ht(Ke.default(e.props.day, r)), t);
            }), St(Et(e), "onMonthMouseEnter", function(t) {
                e.handleDayMouseEnter(Ht(Ke.default(e.props.day, t)));
            }), St(Et(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), St(Et(e), "onMonthKeyDown", function(t, r) {
                var a = e.props, n = a.selected, o = a.preSelection, s = a.disabledKeyboardNavigation, i = a.showTwoColumnMonthYearPicker, p = a.showFourColumnMonthYearPicker, l = a.setPreSelection, c = t.key;
                if ("Tab" !== c && t.preventDefault(), !s) {
                    var d = Vr(p, i), u = jr[d].verticalNavigationOffset, f = jr[d].grid;
                    switch(c){
                        case "Enter":
                            e.onMonthClick(t, r), l(n);
                            break;
                        case "ArrowRight":
                            e.handleMonthNavigation(11 === r ? 0 : r + 1, ke.default(o, 1));
                            break;
                        case "ArrowLeft":
                            e.handleMonthNavigation(0 === r ? 11 : r - 1, _e.default(o, 1));
                            break;
                        case "ArrowUp":
                            e.handleMonthNavigation(f[0].includes(r) ? r + 12 - u : r - u, _e.default(o, u));
                            break;
                        case "ArrowDown":
                            e.handleMonthNavigation(f[f.length - 1].includes(r) ? r - 12 + u : r + u, ke.default(o, u));
                    }
                }
            }), St(Et(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(Vt(Be.default(e.props.day, r)), t);
            }), St(Et(e), "onQuarterMouseEnter", function(t) {
                e.handleDayMouseEnter(Vt(Be.default(e.props.day, t)));
            }), St(Et(e), "handleQuarterNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.QUARTER_REFS[t - 1].current && e.QUARTER_REFS[t - 1].current.focus());
            }), St(Et(e), "onQuarterKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onQuarterClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleQuarterNavigation(4 === r ? 1 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleQuarterNavigation(1 === r ? 4 : r - 1, Me.default(e.props.preSelection, 1));
                }
            }), St(Et(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, c = r.monthClassName, d = r.excludeDates, u = r.includeDates, f = c ? c(Ke.default(a, t)) : void 0, h = Ke.default(a, t);
                return ue.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), f, {
                    "react-datepicker__month-text--disabled": (i || p || d || u) && sr(h, e.props),
                    "react-datepicker__month-text--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && Te.default(l) === t,
                    "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(t),
                    "react-datepicker__month-text--in-range": ir(n, o, t, a),
                    "react-datepicker__month-text--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month-text--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(t),
                    "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), St(Et(e), "getTabIndex", function(t) {
                var r = Te.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), St(Et(e), "getQuarterTabIndex", function(t) {
                var r = Re.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), St(Et(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.chooseDayAriaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = Ke.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(qt(p, "MMMM yyyy"));
            }), St(Et(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, c = r.disabledKeyboardNavigation;
                return ue.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter-text--disabled": (i || p) && pr(Be.default(a, t), e.props),
                    "react-datepicker__quarter-text--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter-text--keyboard-selected": !c && Re.default(l) === t,
                    "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(t),
                    "react-datepicker__quarter-text--in-range": dr(n, o, t, a),
                    "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(t)
                });
            }), St(Et(e), "getMonthContent", function(t) {
                var r = e.props, a = r.showFullMonthYearPicker, n = r.renderMonthContent, o = r.locale, s = r.day, i = ar(t, o), p = rr(t, o);
                return n ? n(t, i, p, s) : a ? p : i;
            }), St(Et(e), "getQuarterContent", function(t) {
                var r = e.props, a = r.renderQuarterContent, n = function(e, t) {
                    return qt(Be.default(At(), e), "QQQ", t);
                }(t, r.locale);
                return a ? a(t, n) : n;
            }), St(Et(e), "renderMonths", function() {
                var t = e.props, r = t.showTwoColumnMonthYearPicker, a = t.showFourColumnMonthYearPicker, n = t.day, o = t.selected;
                return jr[Vr(a, r)].grid.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, t.map(function(t, r) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: r,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            onMouseEnter: function() {
                                return e.onMonthMouseEnter(t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(n, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(n, t, o)
                        }, e.getMonthContent(t));
                    }));
                });
            }), St(Et(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        ref: e.QUARTER_REFS[n],
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        onKeyDown: function(r) {
                            e.onQuarterKeyDown(r, t);
                        },
                        onMouseEnter: function() {
                            return e.onQuarterMouseEnter(t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a),
                        tabIndex: e.getQuarterTabIndex(t),
                        "aria-current": e.isCurrentQuarter(r, t) ? "date" : void 0
                    }, e.getQuarterContent(t));
                }));
            }), St(Et(e), "getClassNames", function() {
                var t = e.props, r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker, i = t.showWeekPicker;
                return ue.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                }, {
                    "react-datepicker__weekPicker": i
                });
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(qt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), zr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), St(Et(e), "scrollToTheSelectedTime", function() {
                requestAnimationFrame(function() {
                    e.list && (e.list.scrollTop = e.centerLi && r.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - e.header.clientHeight : e.list.clientHeight, e.centerLi));
                });
            }), St(Et(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && mr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && hr(t, e.props) || e.props.onChange(t);
            }), St(Et(e), "isSelectedTime", function(t) {
                var r, a;
                return e.props.selected && (r = e.props.selected, a = t, Pr(r).getTime() === Pr(a).getTime());
            }), St(Et(e), "isDisabledTime", function(t) {
                return (e.props.minTime || e.props.maxTime) && mr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && hr(t, e.props);
            }), St(Et(e), "liClasses", function(t) {
                var r = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t) : void 0
                ];
                return e.isSelectedTime(t) && r.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(t) && r.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * xe.default(t) + Ne.default(t)) % e.props.intervals != 0 && r.push("react-datepicker__time-list-item--injected"), r.join(" ");
            }), St(Et(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "ArrowUp" !== t.key && "ArrowLeft" !== t.key || !t.target.previousSibling || (t.preventDefault(), t.target.previousSibling.focus()), "ArrowDown" !== t.key && "ArrowRight" !== t.key || !t.target.nextSibling || (t.preventDefault(), t.target.nextSibling.focus()), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), St(Et(e), "renderTimes", function() {
                for(var t, r = [], a = e.props.format ? e.props.format : "p", n = e.props.intervals, o = e.props.selected || e.props.openToDate || At(), s = (t = o, $e.default(t)), i = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), p = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(o), l = p / n, c = 0; c < l; c++){
                    var d = ye.default(s, c * n);
                    if (r.push(d), i) {
                        var u = Cr(s, d, c, n, i);
                        r = r.concat(u);
                    }
                }
                var f = r.reduce(function(e, t) {
                    return t.getTime() <= o.getTime() ? t : e;
                }, r[0]);
                return r.map(function(t, r) {
                    return de.default.createElement("li", {
                        key: r,
                        onClick: e.handleClick.bind(Et(e), t),
                        className: e.liClasses(t),
                        ref: function(r) {
                            t === f && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: t === f ? 0 : -1,
                        role: "option",
                        "aria-selected": e.isSelectedTime(t) ? "true" : void 0,
                        "aria-disabled": e.isDisabledTime(t) ? "true" : void 0
                    }, qt(t, a, e.props.locale));
                });
            }), e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        role: "listbox",
                        "aria-label": this.props.timeCaption
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    St(zr, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var $r = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "YEAR_REFS", xt(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), St(Et(a), "isDisabled", function(e) {
                return nr(e, a.props);
            }), St(Et(a), "isExcluded", function(e) {
                return or(e, a.props);
            }), St(Et(a), "selectingDate", function() {
                var e;
                return null !== (e = a.props.selectingDate) && void 0 !== e ? e : a.props.preSelection;
            }), St(Et(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(Et(a));
                window.requestAnimationFrame(t);
            }), St(Et(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), St(Et(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = Mr(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), St(Et(a), "isSameDay", function(e, t) {
                return Jt(e, t);
            }), St(Et(a), "isCurrentYear", function(e) {
                return e === Le.default(At());
            }), St(Et(a), "isRangeStart", function(e) {
                return a.props.startDate && a.props.endDate && zt(Qe.default(At(), e), a.props.startDate);
            }), St(Et(a), "isRangeEnd", function(e) {
                return a.props.startDate && a.props.endDate && zt(Qe.default(At(), e), a.props.endDate);
            }), St(Et(a), "isInRange", function(e) {
                return lr(e, a.props.startDate, a.props.endDate);
            }), St(Et(a), "isInSelectingRange", function(e) {
                var t = a.props, r = t.selectsStart, n = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(r || n || o) || !a.selectingDate()) && (r && i ? lr(e, a.selectingDate(), i) : (n && s || !(!o || !s || i)) && lr(e, s, a.selectingDate()));
            }), St(Et(a), "isSelectingRangeStart", function(e) {
                if (!a.isInSelectingRange(e)) return !1;
                var t = a.props, r = t.startDate, n = t.selectsStart, o = Qe.default(At(), e);
                return zt(o, n ? a.selectingDate() : r);
            }), St(Et(a), "isSelectingRangeEnd", function(e) {
                if (!a.isInSelectingRange(e)) return !1;
                var t = a.props, r = t.endDate, n = t.selectsEnd, o = t.selectsRange, s = Qe.default(At(), e);
                return zt(s, n || o ? a.selectingDate() : r);
            }), St(Et(a), "isKeyboardSelected", function(e) {
                var t = jt(Qe.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !Jt(t, jt(a.props.selected)) && Jt(t, jt(a.props.preSelection));
            }), St(Et(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(jt(Qe.default(r, t)), e);
            }), St(Et(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, be.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Pe.default(a.props.preSelection, 1));
                }
            }), St(Et(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected, s = t.excludeDates, i = t.includeDates, p = t.filterDate;
                return ue.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Le.default(o),
                    "react-datepicker__year-text--disabled": (r || n || s || i || p) && cr(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": a.isRangeStart(e),
                    "react-datepicker__year-text--range-end": a.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": a.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }), St(Et(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Le.default(a.props.preSelection) ? "0" : "-1";
            }), St(Et(a), "getYearContainerClassNames", function() {
                var e = a.props, t = e.selectingDate, r = e.selectsStart, n = e.selectsEnd, o = e.selectsRange;
                return ue.default("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": t && (r || n || o)
                });
            }), St(Et(a), "getYearContent", function(e) {
                return a.props.renderYearContent ? a.props.renderYearContent(e) : e;
            }), a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = r.date, n = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave, i = Mr(a, n), p = i.startPeriod, l = i.endPeriod, c = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - p],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            onMouseEnter: function(e) {
                                return o(e, r);
                            },
                            onMouseLeave: function(e) {
                                return s(e, r);
                            },
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, e.getYearContent(r)));
                    }, d = p; d <= l; d++)c(d);
                    return de.default.createElement("div", {
                        className: this.getYearContainerClassNames()
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper",
                        onMouseLeave: this.props.clearSelectingDate
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Gr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = a.props.date, r = t instanceof Date && !isNaN(t) ? t : new Date;
                r.setHours(e.split(":")[0]), r.setMinutes(e.split(":")[1]), a.props.onChange(r);
            }), St(Et(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Jr(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", Ct({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Xr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Zr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), St(Et(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), St(Et(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Xr.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), St(Et(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = kr(a.props), s = wr(a.props), i = At(), p = n || r || t;
                return p || (o && lt.default(i, o) ? o : s && pt.default(i, s) ? s : i);
            }), St(Et(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ke.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), St(Et(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: _e.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), St(Et(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), St(Et(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), St(Et(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), St(Et(a), "handleYearMouseEnter", function(e, t) {
                a.setState({
                    selectingDate: Qe.default(At(), t)
                }), a.props.onYearMouseEnter && a.props.onYearMouseEnter(e, t);
            }), St(Et(a), "handleYearMouseLeave", function(e, t) {
                a.props.onYearMouseLeave && a.props.onYearMouseLeave(e, t);
            }), St(Et(a), "handleYearChange", function(e) {
                a.props.onYearChange && (a.props.onYearChange(e), a.setState({
                    isRenderAriaLiveMessage: !0
                })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), St(Et(a), "handleMonthChange", function(e) {
                a.handleCustomMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), St(Et(a), "handleCustomMonthChange", function(e) {
                a.props.onMonthChange && (a.props.onMonthChange(e), a.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }), St(Et(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), St(Et(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Qe.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), St(Et(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Ke.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), St(Et(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Qe.default(Ke.default(r, Te.default(e)), Le.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), St(Et(a), "header", function() {
                var e = Qt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, a.props.locale, a.props.calendarStartDay), t = [];
                return a.props.showWeekNumbers && t.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), t.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(t) {
                    var r = De.default(e, t), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: t,
                        className: ue.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), St(Et(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(qt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return qt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return qt(e, "EEEEEE", t);
                }(e, t);
            }), St(Et(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Pe.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), St(Et(a), "clearSelectingDate", function() {
                a.setState({
                    selectingDate: null
                });
            }), St(Et(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = Dr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? Lt : a, o = Mr(jt(Pe.default(e, n)), n).endPeriod, s = r && Le.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = yr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = a.props, l = p.previousMonthAriaLabel, c = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, d = p.previousYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Previous Year" : d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), St(Et(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: be.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), St(Et(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = gr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? Lt : a, o = Mr(be.default(e, n), n).startPeriod, s = r && Le.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = vr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = a.props, l = p.nextMonthAriaLabel, c = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, d = p.nextYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Next Year" : d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), St(Et(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, qt(e, a.props.dateFormat, a.props.locale));
            }), St(Et(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Yr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Le.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), St(Et(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Tr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: Te.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), St(Et(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Ar, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), St(Et(a), "handleTodayButtonClick", function(e) {
                a.props.onSelect(Ut(), e), a.props.setPreSelection && a.props.setPreSelection(Ut());
            }), St(Et(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.handleTodayButtonClick(e);
                    }
                }, a.props.todayButton);
            }), St(Et(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), St(Et(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = yr(a.state.date, a.props), o = vr(a.state.date, a.props), s = Dr(a.state.date, a.props), i = gr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(Dt(Dt({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), St(Et(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = Mr(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Le.default(e));
            }), St(Et(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), St(Et(a), "renderMonths", function() {
                var e;
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var t = [], r = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, n = _e.default(a.state.date, r), o = null !== (e = a.props.monthSelectedIn) && void 0 !== e ? e : r, s = 0; s < a.props.monthsShown; ++s){
                        var i = s - o + r, p = ke.default(n, i), l = "month-".concat(s), c = s < a.props.monthsShown - 1, d = s > 0;
                        t.push(de.default.createElement("div", {
                            key: l,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: p,
                            i: s
                        }), de.default.createElement(Ur, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: a.props.monthAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: p,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: s,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            excludeDateIntervals: a.props.excludeDateIntervals,
                            highlightDates: a.props.highlightDates,
                            holidays: a.props.holidays,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            includeDateIntervals: a.props.includeDateIntervals,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            renderMonthContent: a.props.renderMonthContent,
                            renderQuarterContent: a.props.renderQuarterContent,
                            renderYearContent: a.props.renderYearContent,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            showWeekPicker: a.props.showWeekPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: c,
                            monthShowsDuplicateDaysStart: d
                        })));
                    }
                    return t;
                }
            }), St(Et(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement($r, Ct({
                    onDayClick: a.handleDayClick,
                    selectingDate: a.state.selectingDate,
                    clearSelectingDate: a.clearSelectingDate,
                    date: a.state.date
                }, a.props, {
                    onYearMouseEnter: a.handleYearMouseEnter,
                    onYearMouseLeave: a.handleYearMouseLeave
                }))) : void 0;
            }), St(Et(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(zr, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), St(Et(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = Wt(e) && Boolean(a.props.selected) ? "".concat(_r(e.getHours()), ":").concat(_r(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Gr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), St(Et(a), "renderAriaLiveRegion", function() {
                var e, t = Mr(a.state.date, a.props.yearItemNumber), r = t.startPeriod, n = t.endPeriod;
                return e = a.props.showYearPicker ? "".concat(r, " - ").concat(n) : a.props.showMonthYearPicker || a.props.showQuarterYearPicker ? Le.default(a.state.date) : "".concat(rr(Te.default(a.state.date), a.props.locale), " ").concat(Le.default(a.state.date)), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, a.state.isRenderAriaLiveMessage && e);
            }), St(Et(a), "renderChildren", function() {
                if (a.props.children) return de.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, a.props.children);
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null,
                isRenderAriaLiveMessage: !1
            }, a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    var t = this;
                    if (!this.props.preSelection || Jt(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Jt(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                    else {
                        var r = !$t(this.state.date, this.props.preSelection);
                        this.setState({
                            date: this.props.preSelection
                        }, function() {
                            return r && t.handleCustomMonthChange(t.state.date);
                        });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Jr;
                    return de.default.createElement("div", {
                        style: {
                            display: "contents"
                        },
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ue.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: Lt
                    };
                }
            }
        ]), r;
    }(de.default.Component), ea = function(e) {
        var t = e.icon, r = e.className, a = void 0 === r ? "" : r, n = e.onClick, o = "react-datepicker__calendar-icon";
        return de.default.isValidElement(t) ? de.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(a),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof n && n(e);
            }
        }) : "string" == typeof t ? de.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(a),
            "aria-hidden": "true",
            onClick: n
        }) : de.default.createElement("svg", {
            className: "".concat(o, " ").concat(a),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: n
        }, de.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, ta = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return mt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), ra = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, aa = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(ra);
            }), St(Et(a), "handleFocusStart", function() {
                var e = a.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }), St(Et(a), "handleFocusEnd", function() {
                var e = a.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), na = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            return kt(this, r), t.apply(this, arguments);
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, c = t.enableTabLoop, d = t.popperOnKeyDown, u = t.portalId, f = t.portalHost;
                    if (!n) {
                        var h = ue.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, Ct({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(aa, {
                                enableTabLoop: c
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: h,
                                "data-placement": a,
                                onKeyDown: d
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(ta, {
                        portalId: u,
                        portalHost: f
                    }, e));
                    var m = ue.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: m
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), oa = "react-datepicker-ignore-onclickoutside", sa = ht.default(Zr);
    var ia = "Date input not valid.", pa = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : At();
            }), St(Et(a), "modifyHolidays", function() {
                var e;
                return null === (e = a.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return he.default(r) ? [].concat(xt(e), [
                        Dt(Dt({}, t), {}, {
                            date: r
                        })
                    ]) : e;
                }, []);
            }), St(Et(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = kr(a.props), n = wr(a.props), o = r && lt.default(t, $e.default(r)) ? r : n && pt.default(t, et.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: br(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1
                };
            }), St(Et(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), St(Et(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), St(Et(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), St(Et(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: ca
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), St(Et(a), "inputOk", function() {
                return fe.default(a.state.preSelection);
            }), St(Et(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), St(Et(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), St(Et(a), "sendFocusBackToInput", function() {
                a.preventFocusTimeout && a.clearPreventFocusTimeout(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.preventFocusTimeout = setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                });
            }), St(Et(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), St(Et(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), St(Et(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), St(Et(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), St(Et(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), St(Et(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(Et(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: la
                    });
                    var o, s, i, p, l, c, d, u, f = (o = n.target.value, s = a.props.dateFormat, i = a.props.locale, p = a.props.strictParsing, l = a.props.minDate, c = null, d = tr(i) || tr(er()), u = !0, Array.isArray(s) ? (s.forEach(function(e) {
                        var t = ut.default(o, e, new Date, {
                            locale: d
                        });
                        p && (u = Wt(t, l) && o === qt(t, e, i)), Wt(t, l) && u && (c = t);
                    }), c) : (c = ut.default(o, s, new Date, {
                        locale: d
                    }), p ? u = Wt(c) && o === qt(c, s, i) : Wt(c) || (s = s.match(Ft).map(function(e) {
                        var t = e[0];
                        return "p" === t || "P" === t ? d ? (0, Rt[t])(e, d.formatLong) : t : e;
                    }).join(""), o.length > 0 && (c = ut.default(o, s.slice(0, o.length), new Date)), Wt(c) || (c = new Date(o))), Wt(c) && u ? c : null));
                    a.props.showTimeSelectOnly && a.props.selected && f && !Jt(f, a.props.selected) && (f = yt.default(a.props.selected, {
                        hours: xe.default(f),
                        minutes: Ne.default(f),
                        seconds: Ee.default(f)
                    })), !f && n.target.value || (a.props.showWeekPicker && (f = Qt(f, a.props.locale, a.props.calendarStartDay)), a.setSelected(f, n, !0));
                }
            }), St(Et(a), "handleSelect", function(e, t, r) {
                if (a.props.shouldCloseOnSelect && !a.props.showTimeSelect && a.sendFocusBackToInput(), a.props.onChangeRaw && a.props.onChangeRaw(t), a.props.showWeekPicker && (e = Qt(e, a.props.locale, a.props.calendarStartDay)), a.setSelected(e, t, !1, r), a.props.showDateSelect && a.setState({
                    isRenderAriaLiveMessage: !0
                }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || lt.default(e, o) || a.setOpen(!1);
                }
            }), St(Et(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (a.props.showYearPicker) {
                    if (null !== o && cr(Le.default(o), a.props)) return;
                } else if (a.props.showMonthYearPicker) {
                    if (null !== o && sr(o, a.props)) return;
                } else if (null !== o && nr(o, a.props)) return;
                var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, c = s.endDate;
                if (!Xt(a.props.selected, o) || a.props.allowSameDay || p) {
                    if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Bt(o, {
                        hour: xe.default(a.props.selected),
                        minute: Ne.default(a.props.selected),
                        second: Ee.default(a.props.selected)
                    })), a.props.inline || a.setState({
                        preSelection: o
                    }), a.props.focusSelectedMonth || a.setState({
                        monthSelectedIn: n
                    })), p) {
                        var d = l && !c, u = l && c;
                        !l && !c ? i([
                            o,
                            null
                        ], t) : d && (lt.default(o, l) ? i([
                            o,
                            null
                        ], t) : i([
                            l,
                            o
                        ], t)), u && i([
                            o,
                            null
                        ], t);
                    } else i(o, t);
                }
                r || (a.props.onSelect(o, t), a.setState({
                    inputValue: null
                }));
            }), St(Et(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    a.props.showWeekPicker && (e = Qt(e, a.props.locale, a.props.calendarStartDay));
                    var o = $e.default(e);
                    if (t && r) n = Zt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = $e.default(a.props.minDate);
                        n = pt.default(e, s) || Xt(o, s);
                    } else if (r) {
                        var i = et.default(a.props.maxDate);
                        n = lt.default(e, i) || Xt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), St(Et(a), "toggleCalendar", function() {
                a.setOpen(!a.state.open);
            }), St(Et(a), "handleTimeChange", function(e) {
                var t = a.props.selected ? a.props.selected : a.getPreSelection(), r = a.props.selected ? e : Bt(t, {
                    hour: xe.default(e),
                    minute: Ne.default(e)
                });
                a.setState({
                    preSelection: r
                }), a.props.onChange(r), a.props.shouldCloseOnSelect && (a.sendFocusBackToInput(), a.setOpen(!1)), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({
                    isRenderAriaLiveMessage: !0
                }), a.setState({
                    inputValue: null
                });
            }), St(Et(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), St(Et(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.props.showWeekPicker && a.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', n = a.calendar.componentNode && a.calendar.componentNode.querySelector(r);
                            return void (n && n.focus({
                                preventScroll: !0
                            }));
                        }
                        var o = At(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === ca ? (a.handleSelect(o, e), !a.props.shouldCloseOnSelect && a.setPreSelection(o)) : a.setOpen(!1)) : "Escape" === t ? (e.preventDefault(), a.sendFocusBackToInput(), a.setOpen(!1)) : "Tab" === t && a.setOpen(!1), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: ia
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), St(Et(a), "onPortalKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), St(Et(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = At(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: ia
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = a.props.showWeekPicker ? Ce.default(r, 1) : Se.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = a.props.showWeekPicker ? ge.default(r, 1) : De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = Ce.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ge.default(r, 1);
                            break;
                        case "PageUp":
                            n = _e.default(r, 1);
                            break;
                        case "PageDown":
                            n = ke.default(r, 1);
                            break;
                        case "Home":
                            n = Pe.default(r, 1);
                            break;
                        case "End":
                            n = be.default(r, 1);
                            break;
                        default:
                            n = null;
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: ia
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: ca
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = Te.default(r), s = Te.default(n), i = Le.default(r), p = Le.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), St(Et(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.sendFocusBackToInput());
            }), St(Et(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.sendFocusBackToInput(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), St(Et(a), "clear", function() {
                a.onClearClick();
            }), St(Et(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), St(Et(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(sa, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    excludeDateIntervals: a.props.excludeDateIntervals,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    holidays: Sr(a.modifyHolidays()),
                    includeDates: a.props.includeDates,
                    includeDateIntervals: a.props.includeDateIntervals,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: oa,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showDateSelect: a.props.showDateSelect,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: a.props.previousYearAriaLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearAriaLabel: a.props.nextYearAriaLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    renderMonthContent: a.props.renderMonthContent,
                    renderQuarterContent: a.props.renderQuarterContent,
                    renderYearContent: a.props.renderYearContent,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    onYearMouseEnter: a.props.onYearMouseEnter,
                    onYearMouseLeave: a.props.onYearMouseLeave,
                    selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showWeekPicker: a.props.showWeekPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), St(Et(a), "renderAriaLiveRegion", function() {
                var e, t = a.props, r = t.dateFormat, n = t.locale, o = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = a.props.selectsRange ? "Selected start date: ".concat(Kt(a.props.startDate, {
                    dateFormat: o,
                    locale: n
                }), ". ").concat(a.props.endDate ? "End date: " + Kt(a.props.endDate, {
                    dateFormat: o,
                    locale: n
                }) : "") : a.props.showTimeSelectOnly ? "Selected time: ".concat(Kt(a.props.selected, {
                    dateFormat: r,
                    locale: n
                })) : a.props.showYearPicker ? "Selected year: ".concat(Kt(a.props.selected, {
                    dateFormat: "yyyy",
                    locale: n
                })) : a.props.showMonthYearPicker ? "Selected month: ".concat(Kt(a.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: n
                })) : a.props.showQuarterYearPicker ? "Selected quarter: ".concat(Kt(a.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: n
                })) : "Selected date: ".concat(Kt(a.props.selected, {
                    dateFormat: o,
                    locale: n
                })), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }), St(Et(a), "renderDateInput", function() {
                var e, t = ue.default(a.props.className, St({}, oa, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Kt(e, r), n = t ? Kt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Kt(a.props.selected, a.props);
                return de.default.cloneElement(r, (St(St(St(St(St(St(St(St(St(St(e = {}, n, function(e) {
                    a.input = e;
                }), "value", o), "onBlur", a.handleBlur), "onChange", a.handleChange), "onClick", a.onInputClick), "onFocus", a.handleFocus), "onKeyDown", a.onInputKeyDown), "id", a.props.id), "name", a.props.name), "form", a.props.form), St(St(St(St(St(St(St(St(St(St(e, "autoFocus", a.props.autoFocus), "placeholder", a.props.placeholderText), "disabled", a.props.disabled), "autoComplete", a.props.autoComplete), "className", ue.default(r.props.className, t)), "title", a.props.title), "readOnly", a.props.readOnly), "required", a.props.required), "tabIndex", a.props.tabIndex), "aria-describedby", a.props.ariaDescribedBy), St(St(St(e, "aria-invalid", a.props.ariaInvalid), "aria-labelledby", a.props.ariaLabelledBy), "aria-required", a.props.ariaRequired)));
            }), St(Et(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.disabled, n = e.selected, o = e.startDate, s = e.endDate, i = e.clearButtonTitle, p = e.clearButtonClassName, l = void 0 === p ? "" : p, c = e.ariaLabelClose, d = void 0 === c ? "Close" : c;
                return !t || null == n && null == o && null == s ? null : de.default.createElement("button", {
                    type: "button",
                    className: ue.default("react-datepicker__close-icon", l, {
                        "react-datepicker__close-icon--disabled": r
                    }),
                    disabled: r,
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: i,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a.preventFocusTimeout = null, a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Te.default(r) !== Te.default(a) || Le.default(r) !== Le.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: br(this.props.highlightDates)
                    }), t.focused || Xt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    var e = this.props, t = e.showIcon, r = e.icon, a = e.calendarIconClassname, n = e.toggleCalendarOnIconClick, o = this.state.open;
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "")
                    }, t && de.default.createElement(ea, Ct({
                        icon: r,
                        className: "".concat(a, " ").concat(o && "react-datepicker-ignore-onclickoutside")
                    }, n ? {
                        onClick: this.toggleCalendar
                    } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement(aa, {
                            enableTabLoop: this.props.enableTabLoop
                        }, de.default.createElement("div", {
                            className: "react-datepicker__portal",
                            tabIndex: -1,
                            onKeyDown: this.onPortalKeyDown
                        }, e)) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(ta, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(na, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        showWeekPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: Lt,
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0,
                        toggleCalendarOnIconClick: !1
                    };
                }
            }
        ]), r;
    }(de.default.Component), la = "input", ca = "navigate";
    e.CalendarContainer = Jr, e.default = pa, e.getDefaultLocale = er, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{"55b400dfb9477df9":"9njXz","6a082dc438cb1ca2":"bnNSm","3647656f9c7ebc5e":"5Een2","13c776570732a9da":"gmfSU","6553b0b4b603e1c3":"l72u5","d7b993ace1eca80":"520Dk","786b9925c1b6b5ed":"2LfIe","4f1b37d05fed00b3":"1WytR","5fc940b8b11b2f30":"fK40q","b78d0278e54da1b4":"6qgbJ","baecc74d7df402ea":"luR8G","13428a01c277b105":"irq9v","7360dafd9cf06bde":"dwe65","aa659b497503e983":"0Vpj8","7b7bf8fb2c20e0c7":"c1mfa","f501b8cd52ae4ff":"135UL","d616e9f0b9bc7b7a":"gHbP3","9e212fc4b323ed41":"6E2gG","e8ff49b0d1cab426":"bdFXx","12eec1f6d562e008":"FWRfr","72fc20cc52029f11":"1nSRE","42e3036b4499153e":"1tAAj","5592c752ef1290f4":"cIzT5","8406427195a66845":"3RwbN","fa470ac376b26caf":"iIEQj","bf3222da2f520817":"hehyE","685dda4962dc82e1":"cD64I","d6dea87c85b53e02":"3O7In","b9a1398c1c94250d":"4E92Q","e1fbbdf633f9e5ae":"jO4BN","8ac41f1b252a0973":"8Gl2s","156a522b3b8fd124":"5lQsS","f2620442a53b80d6":"8tdvO","1b94d4eb34edeca3":"8eGGa","47020b485e994171":"7SRyU","9818583261d8a102":"jGJ2T","1a7d4440a348b466":"9Dyug","50dce9ec585a5332":"iE73E","cdc90b6df52760f":"3B4AF","2fdd28e51cf3c8b2":"7nCna","72fb68fdc0d9bca3":"3si6M","964e71bf85841794":"blk2u","38468de993ee0549":"jexg9","ec1866b328e982ea":"45KIf","5c05196fbf6d6b4d":"hBRHp","9a6937c0aa7a418e":"7V8st","23c6d2169b7feabe":"9a5Tk","7ec00ac1947d54ca":"eK735","fda4089c257f1876":"53fX5","b5061c3c95f48e73":"i4e28","f57afb99b9b06613":"2bGq4","496ef8c8ed2b34d6":"jauD1","6663b9b2b265a941":"3rxYw","c3348d940b830a7f":"1N23w","53a4aaeeb87e1c51":"joMzA","45f66dd8a17e85aa":"6Kjfz","a3a5398768dc185f":"9koxn","201a807b2e6adc5e":"72XNY","a89a534c753bb4c3":"7FPd2","11a993db5effee60":"dcYJ9","96de361de41dc920":"2ApDx","acb830835f9d8af1":"pYnxB","80c2a8fbe4339722":"adITT"}],"2LfIe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1WytR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fK40q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6qgbJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addDays/index.js":"fK40q","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luR8G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irq9v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addQuarters);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addQuarters(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var months = amount * 3;
    return (0, _indexJsDefault1.default)(dirtyDate, months);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMonths/index.js":"luR8G","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dwe65":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMonths/index.js":"luR8G","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0Vpj8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subDays);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"fK40q","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1mfa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addWeeks/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addWeeks/index.js":"6qgbJ","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"135UL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMonths/index.js":"luR8G","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHbP3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subQuarters);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addQuarters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subQuarters(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addQuarters/index.js":"irq9v","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6E2gG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addYears/index.js":"dwe65","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdFXx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getSeconds);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getSeconds(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"FWRfr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMinutes);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMinutes(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1nSRE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHours);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getHours(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tAAj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIzT5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDate);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDate(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RwbN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getISOWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../toDate/index.js":"9koxn","../startOfISOWeek/index.js":"6qre3","../startOfISOWeekYear/index.js":"cU0Cy","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6qre3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfISOWeek);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../startOfWeek/index.js":"3si6M","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3si6M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cU0Cy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfISOWeekYear);
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getISOWeekYear/index.js":"fSHi1","../startOfISOWeek/index.js":"6qre3","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSHi1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getISOWeekYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../toDate/index.js":"9koxn","../startOfISOWeek/index.js":"6qre3","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iIEQj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hehyE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getQuarter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cD64I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getFullYear();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3O7In":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTime);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4E92Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setSeconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setSeconds(dirtyDate, dirtySeconds) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var seconds = (0, _indexJsDefault.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jO4BN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setMinutes(dirtyDate, dirtyMinutes) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var minutes = (0, _indexJsDefault.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Gl2s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setHours(dirtyDate, dirtyHours) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var hours = (0, _indexJsDefault.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5lQsS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMonth);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../getDaysInMonth/index.js":"gvmhi","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvmhi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDaysInMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8tdvO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setQuarter);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../setMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setQuarter(dirtyDate, dirtyQuarter) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var quarter = (0, _indexJsDefault.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, _indexJsDefault2.default)(date, date.getMonth() + diff * 3);
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../setMonth/index.js":"5lQsS","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8eGGa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setYear);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SRyU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGJ2T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Dyug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarDays);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../startOfDay/index.js":"7nCna","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7nCna":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iE73E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3B4AF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blk2u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jexg9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfQuarter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45KIf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hBRHp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7V8st":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfWeek);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"1cViP","../toDate/index.js":"9koxn","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9a5Tk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eK735":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"53fX5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isEqual);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyLeftDate);
    var dateRight = (0, _indexJsDefault.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4e28":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameDay);
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"7nCna","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2bGq4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jauD1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rxYw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameQuarter);
var _indexJs = require("../startOfQuarter/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

},{"../startOfQuarter/index.js":"jexg9","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1N23w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAfter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"joMzA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isBefore);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Kjfz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isWithinInterval);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWithinInterval(dirtyDate, interval) {
    (0, _indexJsDefault1.default)(2, arguments);
    var time = (0, _indexJsDefault.default)(dirtyDate).getTime();
    var startTime = (0, _indexJsDefault.default)(interval.start).getTime();
    var endTime = (0, _indexJsDefault.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72XNY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","@babel/runtime/helpers/esm/createForOfIteratorHelper":"aDWbJ","../_lib/defaultLocale/index.js":"5kaPu","../subMilliseconds/index.js":"8J3yE","../toDate/index.js":"9koxn","../_lib/assign/index.js":"ebaSr","../_lib/format/longFormatters/index.js":"l4aYZ","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/protectedTokens/index.js":"5gdbP","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","./_lib/Setter.js":"8MMcx","./_lib/parsers/index.js":"7IUvF","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDWbJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createForOfIteratorHelper);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, _unsupportedIterableToArrayJsDefault.default)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"K5PcV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"K5PcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
}

},{"./arrayLikeToArray.js":"enjjy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enjjy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ebaSr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MMcx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/defineProperty":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6oM96":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Qcqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructJsDefault.default)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfJsDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, result);
    };
}

},{"./getPrototypeOf.js":"kxTHC","./isNativeReflectConstruct.js":"3xdRH","./possibleConstructorReturn.js":"gHSsV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxTHC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xdRH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHSsV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(self, call) {
    if (call && ((0, _typeofJsDefault.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(self);
}

},{"./typeof.js":"la19k","./assertThisInitialized.js":"jJtsr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chhAr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3gRhs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, _toPropertyKeyJsDefault.default)(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IUvF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"kab4g","./YearParser.js":"99jVP","./LocalWeekYearParser.js":"2ttXC","./ISOWeekYearParser.js":"i0O3C","./ExtendedYearParser.js":"gotWm","./QuarterParser.js":"akkU8","./StandAloneQuarterParser.js":"2H4wl","./MonthParser.js":"7TuPi","./StandAloneMonthParser.js":"99rFP","./LocalWeekParser.js":"25yMP","./ISOWeekParser.js":"lKKiL","./DateParser.js":"aFDfi","./DayOfYearParser.js":"hA8D5","./DayParser.js":"jai6O","./LocalDayParser.js":"gPIfk","./StandAloneLocalDayParser.js":"c3sA0","./ISODayParser.js":"jXlK8","./AMPMParser.js":"6p81p","./AMPMMidnightParser.js":"JSP3I","./DayPeriodParser.js":"3rj7q","./Hour1to12Parser.js":"i0gZf","./Hour0to23Parser.js":"aPngu","./Hour0To11Parser.js":"gMmlD","./Hour1To24Parser.js":"aJEhQ","./MinuteParser.js":"269sd","./SecondParser.js":"e4ZOc","./FractionOfSecondParser.js":"izdK9","./ISOTimezoneWithZParser.js":"1udJV","./ISOTimezoneParser.js":"9DGq4","./TimestampSecondsParser.js":"hZAUb","./TimestampMillisecondsParser.js":"1WTFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kab4g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dCP1D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/defineProperty":"5zOJa","./Setter.js":"8MMcx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99jVP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cJqi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"49NaD","./constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mpGj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ttXC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/getUTCWeekYear/index.js":"18XUY","../../../_lib/startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0O3C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gotWm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akkU8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2H4wl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7TuPi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../utils.js":"1cJqi","../Parser.js":"dCP1D","../constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99rFP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"25yMP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","../../../_lib/setUTCWeek/index.js":"lcKkD","../../../_lib/startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcKkD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"gKtzz","../../toDate/index.js":"9koxn","../getUTCWeek/index.js":"8MUbv","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lKKiL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","../../../_lib/setUTCISOWeek/index.js":"kNScb","../../../_lib/startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kNScb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"gKtzz","../../toDate/index.js":"9koxn","../getUTCISOWeek/index.js":"hMWge","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFDfi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../utils.js":"1cJqi","../Parser.js":"dCP1D","../constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hA8D5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jai6O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jcEwJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPIfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c3sA0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXlK8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCISODay/index.js":"b0WCQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0WCQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6p81p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"JSP3I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rj7q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0gZf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aPngu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gMmlD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJEhQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"269sd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4ZOc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"izdK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1udJV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DGq4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZAUb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1WTFB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dcYJ9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IGNORE_CLASS_NAME", ()=>IGNORE_CLASS_NAME);
var _react = require("react");
var _reactDom = require("react-dom");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    var passive = false;
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener("testPassiveEventSupport", noop, options);
    window.removeEventListener("testPassiveEventSupport", noop, options);
    return passive;
};
function autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = [
    "touchstart",
    "touchmove"
];
var IGNORE_CLASS_NAME = "ignore-react-onclickoutside";
/**
 * Options for addEventHandler and removeEventHandler
 */ function getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        _inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === "function") {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === "function") {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === "function") {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === "function") return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === "function") return instance.setClickOutsideRef();
                return (0, _reactDom.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === "undefined" || enabledInstances[_this._uid]) return;
                if (typeof passiveEventSupport === "undefined") passiveEventSupport = testPassiveEventSupport();
                enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete enabledInstances[_this._uid];
                var fn = handlersMap[_this._uid];
                if (fn && typeof document !== "undefined") {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                    });
                    delete handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === "undefined" || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === "function") {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== "function") throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = _objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, _react.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, _react.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: IGNORE_CLASS_NAME,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
exports.default = onClickOutsideHOC;

},{"react":"9njXz","react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pYnxB":[function(require,module,exports) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper)) // Public types
;
parcelHelpers.export(exports, "Manager", ()=>(0, _manager.Manager));
parcelHelpers.export(exports, "Reference", ()=>(0, _reference.Reference));
parcelHelpers.export(exports, "usePopper", ()=>(0, _usePopper.usePopper));
var _popper = require("./Popper");
var _manager = require("./Manager");
var _reference = require("./Reference");
var _usePopper = require("./usePopper");

},{"./Popper":"kIqmu","./Manager":"hfvQw","./Reference":"jo721","./usePopper":"le44j","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIqmu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>Popper);
var _react = require("react");
var _manager = require("./Manager");
var _utils = require("./utils");
var _usePopper = require("./usePopper");
var NOOP = function NOOP() {
    return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = _react.useContext((0, _manager.ManagerReferenceNodeContext));
    var _React$useState = _react.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = _react.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    _react.useEffect(function() {
        (0, _utils.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = _react.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper1 = (0, _usePopper.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper1.state, styles = _usePopper1.styles, forceUpdate = _usePopper1.forceUpdate, update = _usePopper1.update;
    var childrenProps = _react.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || NOOP,
            update: update || NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, _utils.unwrapArray)(children)(childrenProps);
}

},{"react":"9njXz","./Manager":"hfvQw","./utils":"1Yvps","./usePopper":"le44j","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfvQw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", ()=>ManagerReferenceNodeContext);
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", ()=>ManagerReferenceNodeSetterContext);
parcelHelpers.export(exports, "Manager", ()=>Manager);
var _react = require("react");
var ManagerReferenceNodeContext = _react.createContext();
var ManagerReferenceNodeSetterContext = _react.createContext();
function Manager(_ref) {
    var children = _ref.children;
    var _React$useState = _react.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = _react.useRef(false);
    _react.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = _react.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ _react.createElement(ManagerReferenceNodeContext.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
        value: handleSetReferenceNode
    }, children));
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Yvps":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", ()=>unwrapArray);
parcelHelpers.export(exports, "safeInvoke", ()=>safeInvoke);
parcelHelpers.export(exports, "setRef", ()=>setRef);
parcelHelpers.export(exports, "fromEntries", ()=>fromEntries);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};
var fromEntries = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"le44j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopper", ()=>usePopper);
var _react = require("react");
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _utils = require("./utils");
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = _react.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || EMPTY_MODIFIERS
    };
    var _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = _react.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, _reactFastCompareDefault.default)(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = _react.useRef();
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, _core.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

},{"react":"9njXz","react-dom":"2ApDx","@popperjs/core":"4kymL","react-fast-compare":"ga979","./utils":"1Yvps","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kymL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"23oSG","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVkdf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead"; // pure-logic modifiers
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4uCU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"4mQXp","./dom-utils/getLayoutRect.js":"bweSm","./dom-utils/listScrollParents.js":"1qClO","./dom-utils/getOffsetParent.js":"bLvkb","./utils/orderModifiers.js":"4RWkj","./utils/debounce.js":"gcfKw","./utils/mergeByName.js":"kcmZR","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mQXp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","./getNodeScroll.js":"8P5ka","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","./getWindowScrollBarX.js":"kaNJ3","./getDocumentElement.js":"gcVmr","./isScrollParent.js":"eD7m7","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XyXs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"1bDAn","../utils/math.js":"8B7aS","./getWindow.js":"3ynkX","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bDAn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ynkX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B7aS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAhTK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fpMW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P5ka":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"btekq","./getWindow.js":"3ynkX","./instanceOf.js":"1bDAn","./getHTMLElementScroll.js":"hYXUH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btekq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYXUH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyQUh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaNJ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"4XyXs","./getDocumentElement.js":"gcVmr","./getWindowScroll.js":"btekq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcVmr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD7m7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"5uZSa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uZSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bweSm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qClO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"1igW6","./getParentNode.js":"k0cfu","./getWindow.js":"3ynkX","./isScrollParent.js":"eD7m7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1igW6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"k0cfu","./isScrollParent.js":"eD7m7","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0cfu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"jyQUh","./getDocumentElement.js":"gcVmr","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLvkb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === "html" || (0, _getNodeNameJsDefault.default)(offsetParent) === "body" && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"3ynkX","./getNodeName.js":"jyQUh","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./isTableElement.js":"btBRX","./getParentNode.js":"k0cfu","../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBRX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"jyQUh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RWkj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcfKw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcmZR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6v2ts":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"YPNSr","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getBoundingClientRect.js":"4XyXs","./computeOffsets.js":"gnv44","./rectToClientRect.js":"5PWlE","../enums.js":"gVkdf","../dom-utils/instanceOf.js":"1bDAn","./mergePaddingObject.js":"43lYJ","./expandToHashMap.js":"16QKI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YPNSr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"gVkdf","./getViewportRect.js":"2wQ5y","./getDocumentRect.js":"3LAyO","./listScrollParents.js":"1qClO","./getOffsetParent.js":"bLvkb","./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./getBoundingClientRect.js":"4XyXs","./getParentNode.js":"k0cfu","./contains.js":"eGlaM","./getNodeName.js":"jyQUh","../utils/rectToClientRect.js":"5PWlE","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wQ5y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"3ynkX","./getDocumentElement.js":"gcVmr","./getWindowScrollBarX.js":"kaNJ3","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LAyO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === "rtl") x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./getWindowScrollBarX.js":"kaNJ3","./getWindowScroll.js":"btekq","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGlaM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PWlE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnv44":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"5S4fc","./getVariation.js":"4BYPr","./getMainAxisFromPlacement.js":"avEhJ","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5S4fc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split("-")[0];
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BYPr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split("-")[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avEhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43lYJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"gtdyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtdyp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16QKI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"23oSG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"b4uCU","./modifiers/eventListeners.js":"5tT8s","./modifiers/popperOffsets.js":"hVDuj","./modifiers/computeStyles.js":"jvHvj","./modifiers/applyStyles.js":"ewuA1","./modifiers/offset.js":"2lcLd","./modifiers/flip.js":"8WVPr","./modifiers/preventOverflow.js":"jUko2","./modifiers/arrow.js":"5Trmz","./modifiers/hide.js":"6kFua","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tT8s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, passive);
    });
    if (resize) window.addEventListener("resize", instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVDuj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"gnv44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jvHvj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"gVkdf","../dom-utils/getOffsetParent.js":"bLvkb","../dom-utils/getWindow.js":"3ynkX","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getComputedStyle.js":"5uZSa","../utils/getBasePlacement.js":"5S4fc","../utils/getVariation.js":"4BYPr","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewuA1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: applyStyles,
    effect: effect,
    requires: [
        "computeStyles"
    ]
};

},{"../dom-utils/getNodeName.js":"jyQUh","../dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lcLd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"5S4fc","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WVPr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"htgah","../utils/getBasePlacement.js":"5S4fc","../utils/getOppositeVariationPlacement.js":"3n1hw","../utils/detectOverflow.js":"6v2ts","../utils/computeAutoPlacement.js":"clJeY","../enums.js":"gVkdf","../utils/getVariation.js":"4BYPr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htgah":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n1hw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: "end",
    end: "start"
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clJeY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"4BYPr","../enums.js":"gVkdf","./detectOverflow.js":"6v2ts","./getBasePlacement.js":"5S4fc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUko2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === "x" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

},{"../enums.js":"gVkdf","../utils/getBasePlacement.js":"5S4fc","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/getAltAxis.js":"l4M4a","../utils/within.js":"cdkh1","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/getOffsetParent.js":"bLvkb","../utils/detectOverflow.js":"6v2ts","../utils/getVariation.js":"4BYPr","../utils/getFreshSideObject.js":"gtdyp","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4M4a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdkh1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Trmz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: arrow,
    effect: effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

},{"../utils/getBasePlacement.js":"5S4fc","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/contains.js":"eGlaM","../dom-utils/getOffsetParent.js":"bLvkb","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/within.js":"cdkh1","../utils/mergePaddingObject.js":"43lYJ","../utils/expandToHashMap.js":"16QKI","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kFua":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: hide
};

},{"../enums.js":"gVkdf","../utils/detectOverflow.js":"6v2ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ga979":[function(require,module,exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"jo721":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reference", ()=>Reference);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
function Reference(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = _react.useContext((0, _manager.ManagerReferenceNodeSetterContext));
    var refHandler = _react.useCallback(function(node) {
        (0, _utils.setRef)(innerRef, node);
        (0, _utils.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _react.useEffect(function() {
        return function() {
            return (0, _utils.setRef)(innerRef, null);
        };
    }, []);
    _react.useEffect(function() {
        (0, _warningDefault.default)(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, _utils.unwrapArray)(children)({
        ref: refHandler
    });
}

},{"react":"9njXz","warning":"4kUCc","./Manager":"hfvQw","./utils":"1Yvps","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"adITT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>set);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../setMonth/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function set(dirtyDate, values) {
    (0, _indexJsDefault3.default)(2, arguments);
    if ((0, _typeofDefault.default)(values) !== "object" || values === null) throw new RangeError("values parameter must be an object");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    if (values.year != null) date.setFullYear(values.year);
    if (values.month != null) date = (0, _indexJsDefault1.default)(date, values.month);
    if (values.date != null) date.setDate((0, _indexJsDefault2.default)(values.date));
    if (values.hours != null) date.setHours((0, _indexJsDefault2.default)(values.hours));
    if (values.minutes != null) date.setMinutes((0, _indexJsDefault2.default)(values.minutes));
    if (values.seconds != null) date.setSeconds((0, _indexJsDefault2.default)(values.seconds));
    if (values.milliseconds != null) date.setMilliseconds((0, _indexJsDefault2.default)(values.milliseconds));
    return date;
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../toDate/index.js":"9koxn","../setMonth/index.js":"5lQsS","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHFh7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAsync", ()=>(0, _useAsyncBa7C6B77EsmJs.u));
parcelHelpers.export(exports, "default", ()=>AsyncSelect$1);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _select49A62830EsmJs = require("../../dist/Select-49a62830.esm.js");
var _useStateManager7E1E8489EsmJs = require("../../dist/useStateManager-7e1e8489.esm.js");
var _useAsyncBa7C6B77EsmJs = require("../../dist/useAsync-ba7c6b77.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _indexA301F526EsmJs = require("../../dist/index-a301f526.esm.js");
var _react1 = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _memoizeOne = require("memoize-one");
var AsyncSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, _useAsyncBa7C6B77EsmJs.u)(props);
    var selectProps = (0, _useStateManager7E1E8489EsmJs.u)(stateManagedProps);
    return /*#__PURE__*/ _react.createElement((0, _select49A62830EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, selectProps));
});
var AsyncSelect$1 = AsyncSelect;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../../dist/Select-49a62830.esm.js":"dKKB5","../../dist/useStateManager-7e1e8489.esm.js":"DxpkG","../../dist/useAsync-ba7c6b77.esm.js":"fNCN5","@babel/runtime/helpers/objectSpread2":"TY7Mr","@babel/runtime/helpers/classCallCheck":"6C9u8","@babel/runtime/helpers/createClass":"g9J5L","@babel/runtime/helpers/inherits":"43peb","@babel/runtime/helpers/createSuper":"ayUOk","@babel/runtime/helpers/toConsumableArray":"c2UGM","../../dist/index-a301f526.esm.js":"gYAEP","@emotion/react":"2WHWE","@babel/runtime/helpers/slicedToArray":"cSV7V","@babel/runtime/helpers/objectWithoutProperties":"5xa1i","@babel/runtime/helpers/typeof":"979to","@babel/runtime/helpers/taggedTemplateLiteral":"cpSDa","@babel/runtime/helpers/defineProperty":"hjdoh","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","memoize-one":"jucOx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dKKB5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>Select);
parcelHelpers.export(exports, "a", ()=>defaultProps);
parcelHelpers.export(exports, "b", ()=>getOptionLabel$1);
parcelHelpers.export(exports, "c", ()=>createFilter);
parcelHelpers.export(exports, "d", ()=>defaultTheme);
parcelHelpers.export(exports, "g", ()=>getOptionValue$1);
parcelHelpers.export(exports, "m", ()=>mergeStyles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _react1 = require("@emotion/react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = {
    name: "1f43avz-a11yText-A11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var A11yText = function A11yText(props) {
    return (0, _react1.jsx)("span", (0, _extendsDefault.default)({
        css: _ref
    }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, _objectSpread2Default.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, _react.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, _react.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, _react1.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, _react1.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, _react1.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)(A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, _react1.jsx)(A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)(stripDiacritics);
var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, _objectSpread2Default.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var _excluded = [
    "innerRef"
];
function DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, _indexA301F526EsmJs.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, _react1.jsx)("input", (0, _extendsDefault.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, _react1.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, ";label:DummyInput;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
    }));
}
var cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _indexA301F526EsmJs.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function preventTouchMove(e) {
    e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
                touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = {
    name: "bp8cua-ScrollManager",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, _react1.jsx)((0, _react.Fragment), null, lockEnabled && (0, _react1.jsx)("div", {
        onClick: blurSelectInput,
        css: _ref2$1
    }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = {
    name: "5kkxb2-requiredInput-RequiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, _react1.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: _ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var RequiredInput$1 = RequiredInput;
/// <reference types="user-agent-data-types" />
function testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
    return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
    return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var defaultStyles = {
    clearIndicator: (0, _indexA301F526EsmJs.a),
    container: (0, _indexA301F526EsmJs.b),
    control: (0, _indexA301F526EsmJs.d),
    dropdownIndicator: (0, _indexA301F526EsmJs.e),
    group: (0, _indexA301F526EsmJs.g),
    groupHeading: (0, _indexA301F526EsmJs.f),
    indicatorsContainer: (0, _indexA301F526EsmJs.i),
    indicatorSeparator: (0, _indexA301F526EsmJs.h),
    input: (0, _indexA301F526EsmJs.j),
    loadingIndicator: (0, _indexA301F526EsmJs.l),
    loadingMessage: (0, _indexA301F526EsmJs.k),
    menu: (0, _indexA301F526EsmJs.m),
    menuList: (0, _indexA301F526EsmJs.n),
    menuPortal: (0, _indexA301F526EsmJs.o),
    multiValue: (0, _indexA301F526EsmJs.p),
    multiValueLabel: (0, _indexA301F526EsmJs.q),
    multiValueRemove: (0, _indexA301F526EsmJs.t),
    noOptionsMessage: (0, _indexA301F526EsmJs.u),
    option: (0, _indexA301F526EsmJs.v),
    placeholder: (0, _indexA301F526EsmJs.w),
    singleValue: (0, _indexA301F526EsmJs.x),
    valueContainer: (0, _indexA301F526EsmJs.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, _objectSpread2Default.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
};
var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
};
var defaultProps = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, _indexA301F526EsmJs.z)(),
    captureMenuScroll: !(0, _indexA301F526EsmJs.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel$1,
    getOptionValue: getOptionValue$1,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, _indexA301F526EsmJs.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);
    var isSelected = _isOptionSelected(props, option, selectValue);
    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, _indexA301F526EsmJs.K));
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue(props, option);
    return selectValue.some(function(i) {
        return getOptionValue(props, i) === candidate;
    });
}
function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Select, _Component);
    var _super = (0, _createSuperDefault.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, _indexA301F526EsmJs.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, _indexA301F526EsmJs.B)([].concat((0, _toConsumableArrayDefault.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, _indexA301F526EsmJs.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, _indexA301F526EsmJs.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, _indexA301F526EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, _indexA301F526EsmJs.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, _indexA301F526EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, _indexA301F526EsmJs.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, _indexA301F526EsmJs.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _objectSpread2Default.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, _indexA301F526EsmJs.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _indexA301F526EsmJs.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, _createClassDefault.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, _indexA301F526EsmJs.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, _indexA301F526EsmJs.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return defaultTheme;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme(defaultTheme);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultTheme), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return _isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return _isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return _filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ _react.createElement(DummyInput, (0, _extendsDefault.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, _indexA301F526EsmJs.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ _react.createElement(Input, (0, _extendsDefault.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ _react.createElement(Placeholder, (0, _extendsDefault.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ _react.createElement(MultiValue, (0, _extendsDefault.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ _react.createElement(SingleValue, (0, _extendsDefault.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ _react.createElement(ClearIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ _react.createElement(LoadingIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ _react.createElement(IndicatorSeparator, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ _react.createElement(DropdownIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ _react.createElement(Option, (0, _extendsDefault.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ _react.createElement(Group, (0, _extendsDefault.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ _react.createElement((0, _indexA301F526EsmJs.M), (0, _extendsDefault.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ _react.createElement(Menu, (0, _extendsDefault.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ _react.createElement(ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ _react.createElement(MenuList, (0, _extendsDefault.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ _react.createElement(MenuPortal, (0, _extendsDefault.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ _react.createElement(RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ _react.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ _react.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ _react.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ _react.createElement(LiveRegion$1, (0, _extendsDefault.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ _react.createElement(SelectContainer, (0, _extendsDefault.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ _react.createElement(Control, (0, _extendsDefault.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ _react.createElement(ValueContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ _react.createElement(IndicatorsContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, _indexA301F526EsmJs.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, _indexA301F526EsmJs.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/toConsumableArray":"iT0h5","react":"9njXz","./index-a301f526.esm.js":"gYAEP","@emotion/react":"2WHWE","memoize-one":"jucOx","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59BsR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iT0h5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toConsumableArray);
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(arr) {
    return (0, _arrayWithoutHolesJsDefault.default)(arr) || (0, _iterableToArrayJsDefault.default)(arr) || (0, _unsupportedIterableToArrayJsDefault.default)(arr) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"1M61l","./iterableToArray.js":"isHxT","./unsupportedIterableToArray.js":"K5PcV","./nonIterableSpread.js":"8TA3X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1M61l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithoutHoles);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJsDefault.default)(arr);
}

},{"./arrayLikeToArray.js":"enjjy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"isHxT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TA3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableSpread);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gYAEP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>isMobileDevice);
parcelHelpers.export(exports, "B", ()=>multiValueAsValue);
parcelHelpers.export(exports, "C", ()=>singleValueAsValue);
parcelHelpers.export(exports, "D", ()=>valueTernary);
parcelHelpers.export(exports, "E", ()=>classNames);
parcelHelpers.export(exports, "F", ()=>defaultComponents);
parcelHelpers.export(exports, "G", ()=>isDocumentElement);
parcelHelpers.export(exports, "H", ()=>cleanValue);
parcelHelpers.export(exports, "I", ()=>scrollIntoView);
parcelHelpers.export(exports, "J", ()=>noop);
parcelHelpers.export(exports, "K", ()=>notNullish);
parcelHelpers.export(exports, "L", ()=>handleInputChange);
parcelHelpers.export(exports, "M", ()=>MenuPlacer);
parcelHelpers.export(exports, "a", ()=>clearIndicatorCSS);
parcelHelpers.export(exports, "b", ()=>containerCSS);
parcelHelpers.export(exports, "c", ()=>components);
parcelHelpers.export(exports, "d", ()=>css$1);
parcelHelpers.export(exports, "e", ()=>dropdownIndicatorCSS);
parcelHelpers.export(exports, "f", ()=>groupHeadingCSS);
parcelHelpers.export(exports, "g", ()=>groupCSS);
parcelHelpers.export(exports, "h", ()=>indicatorSeparatorCSS);
parcelHelpers.export(exports, "i", ()=>indicatorsContainerCSS);
parcelHelpers.export(exports, "j", ()=>inputCSS);
parcelHelpers.export(exports, "k", ()=>loadingMessageCSS);
parcelHelpers.export(exports, "l", ()=>loadingIndicatorCSS);
parcelHelpers.export(exports, "m", ()=>menuCSS);
parcelHelpers.export(exports, "n", ()=>menuListCSS);
parcelHelpers.export(exports, "o", ()=>menuPortalCSS);
parcelHelpers.export(exports, "p", ()=>multiValueCSS);
parcelHelpers.export(exports, "q", ()=>multiValueLabelCSS);
parcelHelpers.export(exports, "r", ()=>removeProps);
parcelHelpers.export(exports, "s", ()=>supportsPassiveEvents);
parcelHelpers.export(exports, "t", ()=>multiValueRemoveCSS);
parcelHelpers.export(exports, "u", ()=>noOptionsMessageCSS);
parcelHelpers.export(exports, "v", ()=>optionCSS);
parcelHelpers.export(exports, "w", ()=>placeholderCSS);
parcelHelpers.export(exports, "x", ()=>css);
parcelHelpers.export(exports, "y", ()=>valueContainerCSS);
parcelHelpers.export(exports, "z", ()=>isTouchCapable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _taggedTemplateLiteral = require("@babel/runtime/helpers/esm/taggedTemplateLiteral");
var _taggedTemplateLiteralDefault = parcelHelpers.interopDefault(_taggedTemplateLiteral);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react1 = require("react");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function classNames(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var cleanValue = function cleanValue(value) {
    if (isArray(value)) return value.filter(Boolean);
    if ((0, _typeofDefault.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded$4);
    return (0, _objectSpread2Default.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function isTouchCapable() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
    w.addEventListener("p", noop, options);
    w.removeEventListener("p", noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
    return item != null;
}
function isArray(arg) {
    return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
    return singleValue;
}
function multiValueAsValue(multiValue) {
    return multiValue;
}
var removeProps = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, _slicedToArrayDefault.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, _slicedToArrayDefault.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var _excluded$3 = [
    "children",
    "innerProps"
], _excluded2$1 = [
    "children",
    "innerProps"
];
function getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, _objectSpread2Default.default)((_objectSpread2 = {
        label: "menu"
    }, (0, _definePropertyDefault.default)(_objectSpread2, alignToControl(placement), "100%"), (0, _definePropertyDefault.default)(_objectSpread2, "position", "absolute"), (0, _definePropertyDefault.default)(_objectSpread2, "width", "100%"), (0, _definePropertyDefault.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var PortalPlacementContext = /*#__PURE__*/ (0, _react1.createContext)(null);
// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, _react1.useContext)(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, _react1.useRef)(null);
    var _useState = (0, _react1.useState)(maxMenuHeight), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, _react1.useState)(null), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var Menu$1 = Menu;
// ==============================
// Menu List
// ==============================
var menuListCSS = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, _objectSpread2Default.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref6, _excluded$3);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var menuPortalCSS = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, _react1.useRef)(null);
    var cleanupRef = (0, _react1.useRef)(null);
    var _useState5 = (0, _react1.useState)(coercePlacement(menuPlacement)), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, _react1.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, _react1.useState)(null), _useState8 = (0, _slicedToArrayDefault.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, _react1.useCallback)(function() {
        if (!controlElement) return;
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, _react1.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, _react1.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: setMenuPortalElement
    }, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, _react.jsx)(PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, _objectSpread2Default.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var _templateObject;
var _excluded$2 = [
    "size"
], _excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 = {
    name: "tj5bde-Svg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$2);
    return (0, _react.jsx)("svg", (0, _extendsDefault.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: _ref2
    }, props));
};
var CrossIcon = function CrossIcon(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var DownChevron = function DownChevron(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, _react.jsx)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, _react.jsx)(CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, _react.jsx)("span", (0, _extendsDefault.default)({}, innerProps, getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var loadingDotAnimations = (0, _react.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralDefault.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, _react.jsx)("span", {
        css: /*#__PURE__*/ (0, _react.css)({
            animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, ";label:LoadingDot;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, _react.jsx)(LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, _react.jsx)(LoadingDot, {
        delay: 160,
        offset: true
    }), (0, _react.jsx)(LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var css$1 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: innerRef
    }, getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var Control$1 = Control;
var _excluded$1 = [
    "data"
];
var groupCSS = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, _react.jsx)(Heading, (0, _extendsDefault.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, _react.jsx)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var Group$1 = Group;
var _excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var inputCSS = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, _objectSpread2Default.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
    return (0, _objectSpread2Default.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, spacingStyle);
};
var Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, _react.jsx)("input", (0, _extendsDefault.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, _objectSpread2Default.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, _objectSpread2Default.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, _react.jsx)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        role: "button"
    }, innerProps), children || (0, _react.jsx)(CrossIcon, {
        size: 14
    }));
}
var MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, _react.jsx)(Container, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, _react.jsx)(Label, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)({}, getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, _react.jsx)(Remove, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
    ClearIndicator: ClearIndicator,
    Control: Control$1,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group$1,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input$1,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu$1,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue$1,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option$1,
    Placeholder: Placeholder$1,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue$1,
    ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, components), props.components);
};

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/react":"2WHWE","@babel/runtime/helpers/esm/slicedToArray":"idCNq","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","@babel/runtime/helpers/esm/typeof":"la19k","@babel/runtime/helpers/esm/taggedTemplateLiteral":"fonV0","@babel/runtime/helpers/esm/defineProperty":"5zOJa","react":"9njXz","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2WHWE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementC39617D8BrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementC39617D8BrowserEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementC39617D8BrowserEsmJs.a));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementC39617D8BrowserEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementC39617D8BrowserEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementC39617D8BrowserEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementC39617D8BrowserEsmJs.b));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementC39617D8BrowserEsmJs = require("./emotion-element-c39617d8.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var global = arguments[3];
var pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElementC39617D8BrowserEsmJs.h).call(props, "css")) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementC39617D8BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementC39617D8BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementC39617D8BrowserEsmJs.w)(function(props, cache) {
    if (!warnedAboutCssPropForGlobal && // probably using the custom createElement which
    // means it will be turned into a className prop
    // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
    (props.className || props.css)) {
        console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
        warnedAboutCssPropForGlobal = true;
    }
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementC39617D8BrowserEsmJs.T)));
    if (!(0, _emotionElementC39617D8BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
Global.displayName = "EmotionGlobal";
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    if (arg.styles !== undefined && arg.name !== undefined) console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementC39617D8BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && true) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && true) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementC39617D8BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
ClassNames.displayName = "EmotionClassNames";
var isBrowser = true; // #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked
var isTestEnv = typeof jest !== "undefined" || typeof vi !== "undefined";
if (isBrowser && !isTestEnv) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = typeof globalThis !== "undefined" ? globalThis // eslint-disable-line no-undef
     : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__";
    if (globalContext[globalKey]) console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used.");
    globalContext[globalKey] = true;
}

},{"./emotion-element-c39617d8.browser.esm.js":"kj16U","react":"9njXz","@emotion/utils":"4Xw0c","@emotion/use-insertion-effect-with-fallbacks":"hkQyF","@emotion/serialize":"lqJRs","@emotion/cache":"6qnZr","@babel/runtime/helpers/extends":"ktcBy","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"i0Hen","hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kj16U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>ThemeProvider);
parcelHelpers.export(exports, "b", ()=>withTheme);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwnProperty);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: "css"
}) : null);
EmotionCacheContext.displayName = "EmotionCacheContext";
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: "css"
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
ThemeContext.displayName = "EmotionThemeContext";
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        if (mergedTheme == null || typeof mergedTheme !== "object" || Array.isArray(mergedTheme)) throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
        return mergedTheme;
    }
    if (theme == null || typeof theme !== "object" || Array.isArray(theme)) throw new Error("[ThemeProvider] Please make your theme prop a plain object");
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps(type, props) {
    if (typeof props.css === "string" && // check if there is a css declaration
    props.css.indexOf(":") !== -1) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    // the label hasn't already been computed
    if (!!props.css && (typeof props.css !== "object" || typeof props.css.name !== "string" || props.css.name.indexOf("-") === -1)) {
        var label = getLabelFromStackTrace(new Error().stack);
        if (label) newProps[labelPropName] = label;
    }
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    if (serialized.name.indexOf("-") === -1) {
        var labelFromStack = props[labelPropName];
        if (labelFromStack) serialized = (0, _serialize.serializeStyles)([
            serialized,
            "label:" + labelFromStack + ";"
        ]);
    }
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && key !== labelPropName) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
Emotion.displayName = "EmotionCssPropInternal";
var Emotion$1 = Emotion;

},{"react":"9njXz","@emotion/cache":"6qnZr","@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"i0Hen","@emotion/utils":"4Xw0c","@emotion/serialize":"lqJRs","@emotion/use-insertion-effect-with-fallbacks":"hkQyF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6qnZr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + "box-$1$2" + (0, _stylis.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-item-" + (0, _stylis.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-line-pack" + (0, _stylis.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + "box-" + (0, _stylis.replace)(value, "-grow", "") + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, "$1" + (0, _stylis.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + "$1"), /(image-set)/, (0, _stylis.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + "box-pack:$3" + (0, _stylis.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, _stylis.WEBKIT) + "$2-$3" + "$1" + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, "stretch") ? prefix((0, _stylis.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ":", ":" + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, _stylis.WEBKIT) + "$2$3" + "$1" + (0, _stylis.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, "@", "@" + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (!key) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
        get compat () {
            return cache.compat;
        }
    }), incorrectImportAlarm);
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        function(element) {
            if (!element.root) {
                if (element["return"]) currentSheet.insert(element["return"]);
                else if (element.value && element.type !== (0, _stylis.COMMENT)) // insert empty rule in non-production environments
                // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
                currentSheet.insert(element.value + "{}");
            }
        }
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        if (serialized.map !== undefined) currentSheet = {
            insert: function insert(rule) {
                sheet.insert(rule + serialized.map);
            }
        };
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"dgNMt","stylis":"90CnP","@emotion/weak-memoize":"8azSs","@emotion/memoize":"jtoId","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dgNMt":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? false : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
        if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
        this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {
                if (!/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) console.error('There was a problem inserting the following rule: "' + rule + '"', e);
            }
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
        this._alreadyInsertedOrderInsensitiveRule = false;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"90CnP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8azSs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtoId":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0Hen":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Xw0c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lqJRs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
var contentValues = [
    "normal",
    "none",
    "initial",
    "inherit",
    "unset"
];
var oldProcessStyleValue = processStyleValue;
var msPattern = /^-ms-/;
var hyphenPattern = /-(.)/g;
var hyphenatedCache = {};
processStyleValue = function processStyleValue(key, value) {
    if (key === "content") {
        if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== "" && !isCustomProperty(key) && key.indexOf("-") !== -1 && hyphenatedCache[key] === undefined) {
        hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
            return _char.toUpperCase();
        }) + "?");
    }
    return processed;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) {
        if (interpolation.toString() === "NO_COMPONENT_SELECTOR") throw new Error(noComponentSelectorMessage);
        return interpolation;
    }
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                if (interpolation.map !== undefined) styles += interpolation.map;
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            } else console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
            break;
        case "string":
            var matched = [];
            var replaced = interpolation.replace(animationRegex, function(match, p1, p2) {
                var fakeVarName = "animation" + matched.length;
                matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
                return "${" + fakeVarName + "}";
            });
            if (matched.length) console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, [
                "`" + replaced + "`"
            ]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else {
            if (_key === "NO_COMPONENT_SELECTOR" && true) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case "animation":
                    case "animationName":
                        string += processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        if (_key === "undefined") console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        if (strings[0] === undefined) console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        styles += strings[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            if (strings[i] === undefined) console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            styles += strings[i];
        }
    }
    var sourceMap;
    styles = styles.replace(sourceMapPattern, function(match) {
        sourceMap = match;
        return "";
    });
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: cursor,
        toString: function toString() {
            return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
    };
};

},{"@emotion/hash":"dkAbc","@emotion/unitless":"fqldX","@emotion/memoize":"b2aiu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dkAbc":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fqldX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2aiu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hkQyF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"idCNq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_slicedToArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(arr, i) {
    return (0, _arrayWithHolesJsDefault.default)(arr) || (0, _iterableToArrayLimitJsDefault.default)(arr, i) || (0, _unsupportedIterableToArrayJsDefault.default)(arr, i) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"81tIH","./iterableToArrayLimit.js":"8js8z","./unsupportedIterableToArray.js":"K5PcV","./nonIterableRest.js":"7uBRd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81tIH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8js8z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArrayLimit);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7uBRd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFSss":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutProperties);
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJsDefault.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./objectWithoutPropertiesLoose.js":"jGdYV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fonV0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_taggedTemplateLiteral);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vfaI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrow", ()=>(0, _core.arrow));
parcelHelpers.export(exports, "autoPlacement", ()=>(0, _core.autoPlacement));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _core.detectOverflow));
parcelHelpers.export(exports, "flip", ()=>(0, _core.flip));
parcelHelpers.export(exports, "hide", ()=>(0, _core.hide));
parcelHelpers.export(exports, "inline", ()=>(0, _core.inline));
parcelHelpers.export(exports, "limitShift", ()=>(0, _core.limitShift));
parcelHelpers.export(exports, "offset", ()=>(0, _core.offset));
parcelHelpers.export(exports, "shift", ()=>(0, _core.shift));
parcelHelpers.export(exports, "size", ()=>(0, _core.size));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "platform", ()=>platform);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, _dom.getWindow)(currentIFrame).frameElement;
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect, offsetParent, strategy } = _ref;
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + (0, _dom.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === "rtl") x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    return getCssDimensions(element);
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const window = (0, _dom.getWindow)(element);
    if (!(0, _dom.isHTMLElement)(element)) return window;
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && (0, _dom.getComputedStyle)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, _dom.getNodeName)(offsetParent) === "html" || (0, _dom.getNodeName)(offsetParent) === "body" && (0, _dom.getComputedStyle)(offsetParent).position === "static" && !(0, _dom.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, _dom.getContainingBlock)(element) || window;
}
const getElementRects = async function(_ref) {
    let { reference, floating, strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === "rtl";
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left, top, width, height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === "function", layoutShift = typeof IntersectionObserver === "function", animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"jiGLa","@floating-ui/utils":"4C4fb","@floating-ui/utils/dom":"1hnW6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiGLa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = "bottom", strategy = "absolute", middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = "clippingAncestors", rootBoundary = "viewport", elementContext = "floating", altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x,
        y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: "arrow",
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = "bestFit", fallbackAxisSideDirection = "none", flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = "referenceHidden", ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === "left";
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options,
        async fn (state) {
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === "y";
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, _utils.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, _utils.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"4C4fb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4C4fb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const alignments = [
    "start",
    "end"
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1hnW6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes(getNodeName(element));
}
function isContainingBlock(element) {
    const webkit = isWebKit();
    const css = getComputedStyle(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Jrzu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var index = (0, _react.useLayoutEffect);
exports.default = index;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jucOx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoizeOne);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"DxpkG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useStateManager);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function useStateManager(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _useState = (0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, _react.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, _react.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/slicedToArray":"idCNq","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNCN5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useAsync);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function useAsync(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, _react.useRef)(undefined);
    var mounted = (0, _react.useRef)(false);
    var _useState = (0, _react.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, _react.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, _react.useState)(propsDefaultOptions === true), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, _react.useState)(undefined), _useState8 = (0, _slicedToArrayDefault.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, _react.useState)([]), _useState10 = (0, _slicedToArrayDefault.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, _react.useState)(false), _useState12 = (0, _slicedToArrayDefault.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, _react.useState)({}), _useState14 = (0, _slicedToArrayDefault.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, _react.useState)(undefined), _useState16 = (0, _slicedToArrayDefault.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, _react.useState)(undefined), _useState18 = (0, _slicedToArrayDefault.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, _react.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, _react.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, _react.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, _react.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, _indexA301F526EsmJs.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, optionsCache), {}, (0, _definePropertyDefault.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

},{"@babel/runtime/helpers/esm/defineProperty":"5zOJa","@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/slicedToArray":"idCNq","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","react":"9njXz","./index-a301f526.esm.js":"gYAEP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TY7Mr":[function(require,module,exports) {
var defineProperty = require("818faec3224b1d63");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"818faec3224b1d63":"hjdoh"}],"6C9u8":[function(require,module,exports) {
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"g9J5L":[function(require,module,exports) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"6uI3m"}],"43peb":[function(require,module,exports) {
var setPrototypeOf = require("f41396146170672b");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f41396146170672b":"iyNOR"}],"ayUOk":[function(require,module,exports) {
var getPrototypeOf = require("b241ea01e2bf5861");
var isNativeReflectConstruct = require("35b08a444265bcf9");
var possibleConstructorReturn = require("d50bbe07b7bb3622");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return possibleConstructorReturn(this, result);
    };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b241ea01e2bf5861":"CaUfL","35b08a444265bcf9":"4whD7","d50bbe07b7bb3622":"2pp8P"}],"CaUfL":[function(require,module,exports) {
function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4whD7":[function(require,module,exports) {
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2pp8P":[function(require,module,exports) {
var _typeof = require("52fa942c15a57b36")["default"];
var assertThisInitialized = require("ca3744a9acc8b6f9");
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"52fa942c15a57b36":"979to","ca3744a9acc8b6f9":"f0luE"}],"c2UGM":[function(require,module,exports) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"aOlvk","4f1268a27b81f1fd":"1KRMO","bfa7725fe5f724b":"4zHVJ","24ae2b6222a85da6":"jdiaX"}],"aOlvk":[function(require,module,exports) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"1AicQ"}],"1AicQ":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1KRMO":[function(require,module,exports) {
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4zHVJ":[function(require,module,exports) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"1AicQ"}],"jdiaX":[function(require,module,exports) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"cSV7V":[function(require,module,exports) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"1GvOn","c109e0e3b1a7ef05":"5o08D","6782568c4383bd49":"4zHVJ","1e06d43f4bd6e532":"aSebZ"}],"1GvOn":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5o08D":[function(require,module,exports) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"aSebZ":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5xa1i":[function(require,module,exports) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"imPRm"}],"cpSDa":[function(require,module,exports) {
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fqOKC":[function(require,module,exports) {
"use strict";
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function getWait(wait) {
    return typeof wait === "function" ? wait() : wait;
}
function defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

},{}],"jlEqD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNLIMITED", ()=>UNLIMITED);
const UNLIMITED = "Unlimited";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kNNU0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL_TYPE", ()=>ALL_TYPE);
parcelHelpers.export(exports, "CALENDAR_TYPE", ()=>CALENDAR_TYPE);
parcelHelpers.export(exports, "SIGNAL_TYPE", ()=>SIGNAL_TYPE);
parcelHelpers.export(exports, "GTEMPLATE_REMINDER_TYPES", ()=>GTEMPLATE_REMINDER_TYPES);
parcelHelpers.export(exports, "ALL_TYPE_LABEL", ()=>ALL_TYPE_LABEL);
parcelHelpers.export(exports, "CALENDAR_TYPE_LABEL", ()=>CALENDAR_TYPE_LABEL);
parcelHelpers.export(exports, "SIGNAL_TYPE_LABEL", ()=>SIGNAL_TYPE_LABEL);
parcelHelpers.export(exports, "REMINDER_TYPE_DISPLAY_MAP", ()=>REMINDER_TYPE_DISPLAY_MAP);
parcelHelpers.export(exports, "REMINDER_TYPE_OPTIONS", ()=>REMINDER_TYPE_OPTIONS);
parcelHelpers.export(exports, "ONE_TIME_REMINDER_LABEL", ()=>ONE_TIME_REMINDER_LABEL);
parcelHelpers.export(exports, "RECURRING_REMINDER_LABEL", ()=>RECURRING_REMINDER_LABEL);
parcelHelpers.export(exports, "REMINDER_CYCLE_OPTIONS", ()=>REMINDER_CYCLE_OPTIONS);
parcelHelpers.export(exports, "CAN0_LABEL", ()=>CAN0_LABEL);
parcelHelpers.export(exports, "CAN0", ()=>CAN0);
parcelHelpers.export(exports, "CAN1_LABEL", ()=>CAN1_LABEL);
parcelHelpers.export(exports, "CAN1", ()=>CAN1);
parcelHelpers.export(exports, "CAN2_LABEL", ()=>CAN2_LABEL);
parcelHelpers.export(exports, "CAN2", ()=>CAN2);
parcelHelpers.export(exports, "CAN3_LABEL", ()=>CAN3_LABEL);
parcelHelpers.export(exports, "CAN3", ()=>CAN3);
parcelHelpers.export(exports, "CAN_BUS_OPTIONS", ()=>CAN_BUS_OPTIONS);
parcelHelpers.export(exports, "CALENDAR_TYPE_UNITS_MAP", ()=>CALENDAR_TYPE_UNITS_MAP);
parcelHelpers.export(exports, "CALENDAR_TYPE_UNITS_TO_DURATION_MAP", ()=>CALENDAR_TYPE_UNITS_TO_DURATION_MAP);
const ALL_TYPE = "All";
const CALENDAR_TYPE = "Calendar";
const SIGNAL_TYPE = "Signal";
const GTEMPLATE_REMINDER_TYPES = [
    ALL_TYPE,
    CALENDAR_TYPE,
    SIGNAL_TYPE
];
const ALL_TYPE_LABEL = "Whichever Comes First";
const CALENDAR_TYPE_LABEL = "Time Based";
const SIGNAL_TYPE_LABEL = "Condition Based";
const REMINDER_TYPE_DISPLAY_MAP = new Map([
    [
        ALL_TYPE,
        ALL_TYPE_LABEL
    ],
    [
        CALENDAR_TYPE,
        CALENDAR_TYPE
    ],
    [
        SIGNAL_TYPE,
        SIGNAL_TYPE
    ]
]);
const REMINDER_TYPE_OPTIONS = [
    {
        label: ALL_TYPE_LABEL,
        value: ALL_TYPE
    },
    {
        label: CALENDAR_TYPE_LABEL,
        value: CALENDAR_TYPE
    },
    {
        label: SIGNAL_TYPE_LABEL,
        value: SIGNAL_TYPE
    }
];
const ONE_TIME_REMINDER_LABEL = "One-Time";
const RECURRING_REMINDER_LABEL = "Recurring";
const REMINDER_CYCLE_OPTIONS = [
    {
        label: RECURRING_REMINDER_LABEL,
        value: true
    },
    {
        label: ONE_TIME_REMINDER_LABEL,
        value: false
    }
];
const CAN0_LABEL = "can0";
const CAN0 = "can0";
const CAN1_LABEL = "can1";
const CAN1 = "can1";
const CAN2_LABEL = "can2";
const CAN2 = "can2";
const CAN3_LABEL = "can3";
const CAN3 = "can3";
const CAN_BUS_OPTIONS = [
    {
        label: CAN0_LABEL,
        value: CAN0
    },
    {
        label: CAN1_LABEL,
        value: CAN1
    },
    {
        label: CAN2_LABEL,
        value: CAN2
    },
    {
        label: CAN3_LABEL,
        value: CAN3
    }
];
const CALENDAR_TYPE_UNITS_MAP = new Map([
    [
        "d",
        "Day(s)"
    ],
    [
        "w",
        "Week(s)"
    ],
    [
        "m",
        "Month(s)"
    ],
    [
        "y",
        "Year(s)"
    ]
]);
const CALENDAR_TYPE_UNITS_TO_DURATION_MAP = new Map([
    [
        "d",
        "days"
    ],
    [
        "w",
        "weeks"
    ],
    [
        "m",
        "months"
    ],
    [
        "y",
        "years"
    ]
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8VB1E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class GtemplateReminderService {
    api = new (0, _requestsDefault.default)();
    buildCreateGtemplateReminderRequest(data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: "/v2/reminder",
            method: "post",
            service: "maintenance"
        };
    }
    async createGtemplateReminder(body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateGtemplateReminderRequest(body, cancelToken));
        return data;
    }
    buildGetPaginatedGtemplateRemindersRequest(params, cancelToken) {
        return {
            cancelToken,
            endpoint: "/v2/reminder",
            method: "get",
            params,
            service: "maintenance"
        };
    }
    async getPaginatedGtemplateReminders(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGetPaginatedGtemplateRemindersRequest(params, cancelToken));
        return data;
    }
    buildGetGtemplateReminderRequest(reminderId, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/reminder/${reminderId}`,
            method: "get",
            service: "maintenance"
        };
    }
    async getGtemplateReminder(reminderId, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGetGtemplateReminderRequest(reminderId, cancelToken));
        return data;
    }
    buildUpdateGtemplateReminderRequest(reminderId, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v2/reminder/${reminderId}`,
            method: "put",
            service: "maintenance"
        };
    }
    async updateGtemplateReminder(reminderId, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateGtemplateReminderRequest(reminderId, body, cancelToken));
        return data;
    }
    buildDeleteGtemplateReminderRequest(reminderId, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/reminder/${reminderId}`,
            method: "delete",
            service: "maintenance"
        };
    }
    async deleteGtemplateReminder(reminderId, cancelToken) {
        return this.api.request(this.buildDeleteGtemplateReminderRequest(reminderId, cancelToken));
    }
}
exports.default = GtemplateReminderService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hGdvK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _authService = require("./AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
var _vendors = require("../Constants/Vendors");
class TemplateService {
    auth = new (0, _authServiceDefault.default)();
    api = new (0, _requestsDefault.default)();
    buildTemplateCountForOrgRequest(orgID, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/template",
            method: "get",
            params: {
                orgID,
                limit: 0
            },
            cancelToken
        };
    }
    buildPaginatedTemplatesRequest(page, orgID, limit = 100, sort = "name", order = "asc", search, vendor, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/template",
            method: "get",
            params: {
                orgID,
                page,
                limit,
                sort,
                order,
                search,
                vendor
            },
            cancelToken
        };
    }
    async fetchTemplateCountForOrg(orgID = this.auth.getCurrentOrgID(), cancelToken) {
        const { data = {} } = await this.api.request(this.buildTemplateCountForOrgRequest(orgID, cancelToken));
        return data;
    }
    async fetchPaginatedTemplates(page = 1, orgID = this.auth.getCurrentOrgID(), limit, sort, order, search, vendor, cancelToken) {
        let vendorInUse;
        if (vendor === (0, _vendors.EPEC_6200_VENDOR_ID) || vendor === (0, _vendors.ACTIA_ACU6_VENDOR_ID)) vendorInUse = "elevat";
        else vendorInUse = vendor;
        const { data = {} } = await this.api.request(this.buildPaginatedTemplatesRequest(page, orgID, limit, sort, order, search, vendorInUse, cancelToken));
        return data;
    }
    buildAdditionalPaginatedTemplatesRequest({ order, orgID, page, search, sort = "name", vendor }, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/template",
            method: "get",
            params: {
                limit: 100,
                order,
                orgID,
                page,
                search,
                sort,
                vendor
            },
            cancelToken
        };
    }
    async handleAdditionalTemplateRequests({ cancelToken, count, limit, order, orgID, search, sort, vendor }) {
        const requestsMap = this.api.createAdditionalRequestMap({
            count,
            limit,
            order,
            orgID,
            search,
            sort,
            vendor
        }, this.buildAdditionalPaginatedTemplatesRequest, cancelToken);
        return Promise.all(requestsMap);
    }
    buildAssignTemplateRequest(gatewayID, templateID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/gateway/${gatewayID}/template/${templateID}`,
            method: "post",
            service: "gateway"
        };
    }
    async assignTemplate(assetID, templateID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAssignTemplateRequest(assetID, templateID, body, cancelToken));
        return data;
    }
    buildCreateNewTemplateRequest(orgID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template`,
            method: "post",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async createNewTemplate(orgID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateNewTemplateRequest(orgID, body, cancelToken));
        return data;
    }
    buildFetchTemplateRequest(templateID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}`,
            method: "get",
            cancelToken
        };
    }
    async fetchTemplate(templateID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchTemplateRequest(templateID, cancelToken));
        return data;
    }
    buildCheckTemplateRequest(templateID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/check`,
            method: "get",
            cancelToken
        };
    }
    async checkTemplate(templateID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCheckTemplateRequest(templateID, cancelToken));
        return data;
    }
    buildFetchAllTemplatesRequest(orgID, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/template/all",
            method: "get",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async fetchAllTemplates(orgID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAllTemplatesRequest(orgID, cancelToken));
        return data;
    }
    buildEditTemplateRequest(templateID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}`,
            method: "put",
            data,
            cancelToken
        };
    }
    async editTemplate(templateID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildEditTemplateRequest(templateID, body, cancelToken));
        return data;
    }
    buildDeleteTemplateRequest(templateID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}`,
            method: "delete",
            cancelToken
        };
    }
    async deleteTemplate(templateID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteTemplateRequest(templateID, cancelToken));
        return data;
    }
    buildDuplicateTemplateRequest(templateID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/clone`,
            method: "post",
            data,
            cancelToken
        };
    }
    async duplicateTemplate(templateID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDuplicateTemplateRequest(templateID, body, cancelToken));
        return data;
    }
    buildTemplateSignalCreateRequest(templateID, datapointID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/datapoint/${datapointID}/value`,
            method: "post",
            data,
            cancelToken
        };
    }
    async addSignalToCollection(templateID, datapointID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildTemplateSignalCreateRequest(templateID, datapointID, body, cancelToken));
        return data;
    }
    buildTemplateSignalDeleteRequest(templateID, datapointID, signalID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/datapoint/${datapointID}/value/${signalID}`,
            method: "delete",
            cancelToken
        };
    }
    async deleteSignal(templateID, datapointID, signalID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildTemplateSignalDeleteRequest(templateID, datapointID, signalID, cancelToken));
        return data;
    }
    buildUpdateSignalRequest(templateID, collectionID, signalID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/datapoint/${collectionID}/value/${signalID}`,
            method: "put",
            data,
            cancelToken
        };
    }
    async updateSignal(templateID, collectionID, signalID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateSignalRequest(templateID, collectionID, signalID, body, cancelToken));
        return data;
    }
    buildEditSignalCollectionRequest(templateID, collectionID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/datapoint/${collectionID}`,
            method: "put",
            data,
            cancelToken
        };
    }
    async editSignalCollection(templateID, collectionID, body, cancelToken) {
        const { data } = await this.api.request(this.buildEditSignalCollectionRequest(templateID, collectionID, body, cancelToken));
        return data;
    }
    buildDeleteSignalCollectionRequest(templateID, collectionID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/datapoint/${collectionID}`,
            method: "delete",
            cancelToken
        };
    }
    async deleteSignalCollection(templateID, collectionID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteSignalCollectionRequest(templateID, collectionID, cancelToken));
        return data;
    }
    buildAddSignalCollectionRequest(templateID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/template/${templateID}/datapoint`,
            method: "post",
            data,
            cancelToken
        };
    }
    async addSignalCollection(templateID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAddSignalCollectionRequest(templateID, body, cancelToken));
        return data;
    }
    buildTemplateSearchRequest(params, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/template/search",
            method: "get",
            params,
            cancelToken
        };
    }
    async searchTemplates(params, cancelToken) {
        const { data } = await this.api.request(this.buildTemplateSearchRequest(params, cancelToken));
        return data;
    }
    buildCreateVendorTemplateRequest({ vendor = "danfoss", ...params }, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${vendor}`,
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async createVendorTemplate(params, body, cancelToken) {
        const { data } = await this.api.request(this.buildCreateVendorTemplateRequest(params, body, cancelToken));
        return data;
    }
    buildUpdateVendorTemplateRequest(templateID, { vendor, ...params }, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/${vendor}`,
            method: "put",
            params,
            data,
            cancelToken
        };
    }
    async updateVendorTemplate(templateID, params, body, cancelToken) {
        const { data } = await this.api.request(this.buildUpdateVendorTemplateRequest(templateID, params, body, cancelToken));
        return data;
    }
    buildCreateWaterpumpTemplateRequest(params, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/waterPump`,
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async createWaterpumpTemplate(params, body, cancelToken) {
        const { data } = await this.api.request(this.buildCreateWaterpumpTemplateRequest(params, body, cancelToken));
        return data;
    }
    buildFetchPaginatedOutputSignalsRequest(templateID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/template/${templateID}/outputSignal`,
            method: "get",
            params,
            service: "gateway"
        };
    }
    async fetchPaginatedOutputSignals(gtemplateID, params, cancelToken) {
        const { data } = await this.api.request(this.buildFetchPaginatedOutputSignalsRequest(gtemplateID, params, cancelToken));
        return data;
    }
    buildCreateOutputSignalRequest(templateID, data, params, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v2/template/${templateID}/outputSignal`,
            method: "post",
            params,
            service: "gateway"
        };
    }
    async createOutputSignal(templateID, body, params, cancelToken) {
        const { data } = await this.api.request(this.buildCreateOutputSignalRequest(templateID, body, params, cancelToken));
        return data;
    }
    buildUpdateOutputSignalRequest(templateID, outputSignalID, data, params, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v2/template/${templateID}/outputSignal/${outputSignalID}`,
            method: "put",
            params,
            service: "gateway"
        };
    }
    async updateOutputSignal(templateID, outputSignalID, body, params, cancelToken) {
        const { data } = await this.api.request(this.buildUpdateOutputSignalRequest(templateID, outputSignalID, body, params, cancelToken));
        return data;
    }
    buildDeleteOutputSignalRequest(templateID, outputSignalID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/template/${templateID}/outputSignal/${outputSignalID}`,
            method: "delete",
            service: "gateway"
        };
    }
    deleteOutputSignal(templateID, outputSignalID, cancelToken) {
        return this.api.request(this.buildDeleteOutputSignalRequest(templateID, outputSignalID, cancelToken));
    }
    buildSearchOutputSignalsRequest(templateID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/template/${templateID}/outputSignalSearch`,
            method: "get",
            params,
            service: "gateway"
        };
    }
    async searchOutputSignals(templateID, params, cancelToken) {
        const { data } = await this.api.request(this.buildSearchOutputSignalsRequest(templateID, params, cancelToken));
        return data;
    }
    buildFetchOutputSignalRequest(templateID, outputSignalID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/template/${templateID}/outputSignal/${outputSignalID}`,
            method: "get",
            service: "gateway"
        };
    }
    async fetchOutputSignal(templateID, outputSignalID, cancelToken) {
        const { data } = await this.api.request(this.buildFetchOutputSignalRequest(templateID, outputSignalID, cancelToken));
        return data;
    }
    buildCreateBulkSignalsRequest(templateID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/createBulkSignals`,
            method: "post",
            data,
            cancelToken
        };
    }
    async createBulkSignals(templateID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateBulkSignalsRequest(templateID, body, cancelToken));
        return data;
    }
    buildCloneSignalRequest(templateID, datapointID, signalID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/datapoint/${datapointID}/value/${signalID}/clone`,
            method: "post",
            data,
            cancelToken
        };
    }
    async cloneSignal(templateID, datapointID, signalID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCloneSignalRequest(templateID, datapointID, signalID, body, cancelToken));
        return data;
    }
    buildEnableForWaterpumpRequest(templateID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/template/${templateID}/waterpump`,
            method: "put",
            service: "gateway"
        };
    }
    async enableForWaterpump(templateID, cancelToken) {
        const { data } = await this.api.request(this.buildEnableForWaterpumpRequest(templateID, cancelToken));
        return data;
    }
    buildUpdateSharedGtemplateRequest(templateID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v2/template/${templateID}/sharedGtemplate`,
            method: "put",
            service: "gateway"
        };
    }
    async updateSharedGtemplate(templateID, body, cancelToken) {
        const { data } = await this.api.request(this.buildUpdateSharedGtemplateRequest(templateID, body, cancelToken));
        return data;
    }
    buildCreateEzSignalRequest(templateID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v2/template/${templateID}/xirgoSignal`,
            method: "post",
            service: "gateway"
        };
    }
    async createEzSignal(templateID, body, cancelToken) {
        const { data } = await this.api.request(this.buildCreateEzSignalRequest(templateID, body, cancelToken));
        return data;
    }
    buildUpdateEzSignalRequest(templateID, signalID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v2/template/${templateID}/xirgoSignal/${signalID}`,
            method: "put",
            service: "gateway"
        };
    }
    async updateEzSignal(templateID, signalID, body, cancelToken) {
        const { data } = await this.api.request(this.buildUpdateEzSignalRequest(templateID, signalID, body, cancelToken));
        return data;
    }
    buildDeleteEzSignalRequest(templateID, signalID, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/template/${templateID}/xirgoSignal/${signalID}`,
            method: "delete",
            service: "gateway"
        };
    }
    async deleteEzSignal(templateID, signalID, cancelToken) {
        return this.api.request(this.buildDeleteEzSignalRequest(templateID, signalID, cancelToken));
    }
}
exports.default = TemplateService;

},{"./AuthService":"8Bjjn","../Lib/Requests":"j1WJQ","../Constants/Vendors":"jVaXW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1LnYJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FLEET_REPORTS_SELECT_STYLES", ()=>FLEET_REPORTS_SELECT_STYLES);
parcelHelpers.export(exports, "BASIC_SELECT_STYLES", ()=>BASIC_SELECT_STYLES);
parcelHelpers.export(exports, "BASIC_SELECT_STYLES_Z_INDEX_OVERRIDE", ()=>BASIC_SELECT_STYLES_Z_INDEX_OVERRIDE);
parcelHelpers.export(exports, "GTEMPLATE_REMINDER_SIGNAL_HEADER_DROPDOWN", ()=>GTEMPLATE_REMINDER_SIGNAL_HEADER_DROPDOWN);
var _zIndex = require("./Z-INDEX");
const FLEET_REPORTS_SELECT_STYLES = {
    control: (base)=>({
            ...base,
            borderColor: "var(--third-gray) !important",
            boxShadow: "none"
        }),
    indicatorsContainer: (base)=>({
            ...base,
            paddingLeft: 0
        }),
    indicatorSeparator: (base)=>({
            ...base,
            display: "none"
        }),
    multiValue: (base)=>({
            ...base,
            backgroundColor: "var(--background-gray) !important"
        }),
    multiValueLabel: (base)=>({
            ...base,
            backgroundColor: "transparent !important"
        }),
    multiValueRemove: (base)=>({
            ...base,
            backgroundColor: "transparent !important"
        }),
    valueContainer: (base)=>({
            ...base,
            paddingRight: 0
        })
};
const BASIC_SELECT_STYLES = {
    indicatorSeparator: (base)=>({
            ...base,
            visibility: "hidden"
        }),
    control: (base)=>({
            ...base,
            outline: "none",
            boxShadow: "none"
        })
};
const BASIC_SELECT_STYLES_Z_INDEX_OVERRIDE = {
    control: (base)=>({
            ...base,
            outline: "none",
            boxShadow: "none"
        }),
    indicatorSeparator: (base)=>({
            ...base,
            visibility: "hidden"
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, _zIndex.STICKY_OVERRIDE)
        })
};
const GTEMPLATE_REMINDER_SIGNAL_HEADER_DROPDOWN = {
    clearIndicator: (base)=>({
            ...base,
            color: "var(--danger) !important"
        }),
    container: (base)=>({
            ...base,
            zIndex: (0, _zIndex.STICKY_OVERRIDE)
        }),
    control: (base)=>({
            ...base,
            border: "none",
            boxShadow: "none",
            outline: "none"
        }),
    dropdownIndicator: (base)=>({
            ...base,
            color: "var(--text-muted) !important"
        }),
    indicatorSeparator: (base)=>({
            ...base,
            display: "none"
        }),
    placeholder: (base)=>({
            ...base,
            color: "var(--text-muted) !important",
            marginLeft: 0,
            marginRight: 0
        })
};

},{"./Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CxzKK":[function(require,module,exports) {
/**
 * bootstrap defaults
 * {@link https://getbootstrap.com/docs/4.6/extend/approach/#component-elements}
 * {@link https://getbootstrap.com/docs/4.6/layout/overview/#z-index}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPONENT_DEFAULT", ()=>COMPONENT_DEFAULT);
parcelHelpers.export(exports, "COMPONENT_HOVER", ()=>COMPONENT_HOVER);
parcelHelpers.export(exports, "COMPONENT_ACTIVE", ()=>COMPONENT_ACTIVE);
parcelHelpers.export(exports, "COMPONENT_FOCUS", ()=>COMPONENT_FOCUS);
parcelHelpers.export(exports, "DROPDOWN_DEFAULT", ()=>DROPDOWN_DEFAULT);
parcelHelpers.export(exports, "STICKY_DEFAULT", ()=>STICKY_DEFAULT);
parcelHelpers.export(exports, "FIXED_DEFAULT", ()=>FIXED_DEFAULT);
parcelHelpers.export(exports, "MODAL_BACKDROP_DEFAULT", ()=>MODAL_BACKDROP_DEFAULT);
parcelHelpers.export(exports, "MODAL_DEFAULT", ()=>MODAL_DEFAULT);
parcelHelpers.export(exports, "POPOVER_DEFAULT", ()=>POPOVER_DEFAULT);
parcelHelpers.export(exports, "TOOLTIP_DEFAULT", ()=>TOOLTIP_DEFAULT);
parcelHelpers.export(exports, "COMPONENT_OVERRIDE", ()=>COMPONENT_OVERRIDE);
parcelHelpers.export(exports, "DROPDOWN_OVERRIDE", ()=>DROPDOWN_OVERRIDE);
parcelHelpers.export(exports, "STICKY_OVERRIDE", ()=>STICKY_OVERRIDE);
parcelHelpers.export(exports, "FIXED_OVERRIDE", ()=>FIXED_OVERRIDE);
parcelHelpers.export(exports, "MODAL_BACKDROP_OVERRIDE", ()=>MODAL_BACKDROP_OVERRIDE);
parcelHelpers.export(exports, "MODAL_OVERRIDE", ()=>MODAL_OVERRIDE);
parcelHelpers.export(exports, "POPOVER_OVERRIDE", ()=>POPOVER_OVERRIDE);
parcelHelpers.export(exports, "TOOLTIP_OVERRIDE", ()=>TOOLTIP_OVERRIDE);
const COMPONENT_DEFAULT = 0;
const COMPONENT_HOVER = 1;
const COMPONENT_ACTIVE = 2;
const COMPONENT_FOCUS = 3;
const DROPDOWN_DEFAULT = 1000;
const STICKY_DEFAULT = 1020;
const FIXED_DEFAULT = 1030;
const MODAL_BACKDROP_DEFAULT = 1040;
const MODAL_DEFAULT = 1050;
const POPOVER_DEFAULT = 1060;
const TOOLTIP_DEFAULT = 1070;
const COMPONENT_OVERRIDE = COMPONENT_DEFAULT + 1;
const DROPDOWN_OVERRIDE = DROPDOWN_DEFAULT + 1;
const STICKY_OVERRIDE = STICKY_DEFAULT + 1;
const FIXED_OVERRIDE = FIXED_DEFAULT + 1;
const MODAL_BACKDROP_OVERRIDE = MODAL_BACKDROP_DEFAULT + 1;
const MODAL_OVERRIDE = MODAL_DEFAULT + 1;
const POPOVER_OVERRIDE = POPOVER_DEFAULT + 1;
const TOOLTIP_OVERRIDE = TOOLTIP_DEFAULT + 1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5p77l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _rbac = require("../../Constants/RBAC");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _assetUtils = require("../../Lib/AssetUtils");
var _assetUtilsDefault = parcelHelpers.interopDefault(_assetUtils);
var _authService = require("../../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _currentUserContext = require("../../Context/CurrentUserContext");
var _currentUserContextDefault = parcelHelpers.interopDefault(_currentUserContext);
var _accessTools = require("../../RBAC/AccessTools");
var _assetDetailsTabDisplay = require("./AssetDetailsTabDisplay");
var _assetDetailsTabDisplayDefault = parcelHelpers.interopDefault(_assetDetailsTabDisplay);
var _assetUpdateModal = require("./AssetUpdateModal");
var _assetUpdateModalDefault = parcelHelpers.interopDefault(_assetUpdateModal);
var _rawAPIModal = require("./RawAPIModal");
var _rawAPIModalDefault = parcelHelpers.interopDefault(_rawAPIModal);
var _uploadCustomerOTAModal = require("./UploadCustomerOTAModal");
var _uploadCustomerOTAModalDefault = parcelHelpers.interopDefault(_uploadCustomerOTAModal);
var _runCustomerOTAModal = require("./RunCustomerOTAModal");
var _runCustomerOTAModalDefault = parcelHelpers.interopDefault(_runCustomerOTAModal);
var _deleteCustomerOTAModal = require("./DeleteCustomerOTAModal");
var _deleteCustomerOTAModalDefault = parcelHelpers.interopDefault(_deleteCustomerOTAModal);
var _otaTypes = require("../../Constants/OtaTypes");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetDetailsTabContainer);
const initState = {
    activeSignals: 0,
    assetAddress: "",
    assetCoords: "",
    assetIsOnline: false,
    bridgeElevatURL: "",
    bridgeKey: "",
    bridgeKeyUpdatedTime: "",
    dateActivated: "",
    dateCreated: "",
    deviceStreamsElevatURL: "",
    deviceStreamsError: "",
    error: "",
    haveSystemAdminData: false,
    identityAssetIsOnline: false,
    identityConnectionStateUpdatedTime: "",
    identityLastActivityTime: "",
    identity2AssetIsOnline: false,
    identity2ConnectionStateUpdatedTime: "",
    identity2LastActivityTime: "",
    lastUpdated: "",
    modalIsOpen: false,
    onlineTime: "",
    otaPrintedData: "",
    packagesToUpdate: [],
    RawAPIData: "",
    RawAPIDataName: "",
    showRawAPIModal: false,
    showUploadCustomerOTAModal: false,
    showRunCustomerOTAModal: false,
    showDeleteCustomerOTAModal: false,
    twin: "",
    twin2: "",
    updatePending: false,
    updating: false,
    updateInProgress: false
};
function AssetDetailsTabContainer(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const currentUser = (0, _react.useContext)((0, _currentUserContextDefault.default));
    const assetService = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []);
    const assetUtils = (0, _react.useMemo)(()=>new (0, _assetUtilsDefault.default)(), []);
    const authService = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []);
    const { assetID } = (0, _reactRouterDom.useParams)();
    const source = (0, _axios.CancelToken).source();
    const userHasRemoteRead = (0, _accessTools.hasReadAccessToResource)(props.asset?.orgID, (0, _rbac.REMOTE));
    const parseAssetConnectivity = (asset)=>{
        return assetUtils.getConnectivityFromShadow(asset) === "deviceConnect";
    };
    const fetchTwinsAndIdentities = ()=>{
        const twinRequest = assetService.fetchAssetTwin(assetID, source.token);
        const twin2Request = assetService.fetchAssetTwin2(assetID, source.token);
        const identityRequest = assetService.fetchAssetIdentity(assetID, source.token);
        const identity2Request = assetService.fetchAssetIdentity2(assetID, source.token);
        return Promise.all([
            twinRequest,
            twin2Request,
            identityRequest,
            identity2Request
        ].map((p)=>p.catch((e)=>e)));
    };
    const getDeviceStreamsKey = async ()=>{
        const deviceStreamsInfo = await assetService.fetchAssetDeviceStreamsInfo(assetID, source.token);
        return deviceStreamsInfo?.elevatURL ?? "";
    };
    const fetchRemoteData = async ()=>{
        const [twin, twin2, identity, identity2] = await fetchTwinsAndIdentities();
        const bridgeData = parseTwinDataForBridge(twin);
        const identityData = parseIdentityData(identity);
        const identity2Data = parseIdentity2Data(identity2);
        let ota;
        let customerOTAfromAPI;
        if (userHasRemoteRead) try {
            ota = await assetService.fetchAssetOTA(assetID, source.token);
            customerOTAfromAPI = await assetService.fetchAssetCustomerOTAs(assetID, source.token);
        } catch (err) {
        // nothing
        }
        const otaAndTwinData = parseOtaAndTwinData(ota, twin);
        const customerOTAlist = parseCustomerOTAdata(customerOTAfromAPI);
        return {
            ...bridgeData,
            ...identityData,
            ...identity2Data,
            ...otaAndTwinData,
            twin: twin?.twin ?? JSON.stringify({
                error: twin?.message
            }),
            twin2: twin2?.twin ?? JSON.stringify({
                error: twin2?.message
            }),
            customerOTAlist
        };
    };
    const handleSubmitUpdate = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    updatePending: true
                }));
            const packageUpdateRequests = state.packagesToUpdate.map((blobName)=>{
                return assetService.updateAssetSoftware(assetID, {
                    blobName
                }, source.token);
            });
            await Promise.all(packageUpdateRequests);
            updateState((prevState)=>({
                    ...prevState,
                    updating: true,
                    updatePending: false
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    updatePending: false,
                    error
                }));
        }
    };
    const parseCoordinates = (shadow)=>{
        if (!shadow.gps) return "";
        const { latitude, longitude } = shadow.gps;
        const lat = assetUtils.parseGpsForDisplay(latitude, "latitude") || "";
        const lng = assetUtils.parseGpsForDisplay(longitude, "longitude") || "";
        return `${lat} ${lng}`;
    };
    const parseIdentityData = (identity)=>{
        if (!identity || identity?.message) return {};
        const identityParsed = JSON.parse(identity?.identity || {});
        let identityConnectionStateUpdatedTime;
        if (identityParsed.connectionStateUpdatedTime) {
            const updatedTime = (0, _momentDefault.default)(identityParsed.connectionStateUpdatedTime);
            // consider times before this to be "never" - elevat was not running at this time
            if (updatedTime.isSameOrAfter((0, _momentDefault.default)("20100101", "YYYYMMDD"))) identityConnectionStateUpdatedTime = `${updatedTime.toNow(true)} ago`;
            else identityConnectionStateUpdatedTime = "never";
        } else identityConnectionStateUpdatedTime = "unknown";
        // this is updated on connection or packets being sent
        let identityLastActivityTime;
        if (identityParsed.lastActivityTime) {
            const updatedTime = (0, _momentDefault.default)(identityParsed.lastActivityTime);
            // consider times before this to be "never" - elevat was not running at this time
            if (updatedTime.isSameOrAfter((0, _momentDefault.default)("20100101", "YYYYMMDD"))) identityLastActivityTime = `${updatedTime.toNow(true)} ago`;
            else identityLastActivityTime = "never";
        } else identityLastActivityTime = "unknown";
        return {
            identityAssetIsOnline: identityParsed.connectionState === "Connected",
            // "Disconnected" or "Connected"
            identityConnectionStateUpdatedTime,
            identityLastActivityTime
        };
    };
    const parseIdentity2Data = (identity2)=>{
        // copy of identity1 above
        if (!identity2 || identity2?.message) return {};
        const identity2Parsed = JSON.parse(identity2?.identity || {});
        let identity2ConnectionStateUpdatedTime;
        if (identity2Parsed.connectionStateUpdatedTime) {
            const updatedTime = (0, _momentDefault.default)(identity2Parsed.connectionStateUpdatedTime);
            // consider times before this to be "never" - elevat was not running at this time
            if (updatedTime.isSameOrAfter((0, _momentDefault.default)("20100101", "YYYYMMDD"))) identity2ConnectionStateUpdatedTime = `${updatedTime.toNow(true)} ago`;
            else identity2ConnectionStateUpdatedTime = "never";
        } else identity2ConnectionStateUpdatedTime = "unknown";
        // this is updated on connection or packets being sent
        let identity2LastActivityTime;
        if (identity2Parsed.lastActivityTime) {
            const updatedTime = (0, _momentDefault.default)(identity2Parsed.lastActivityTime);
            // consider times before this to be "never" - elevat was not running at this time
            if (updatedTime.isSameOrAfter((0, _momentDefault.default)("20100101", "YYYYMMDD"))) identity2LastActivityTime = `${updatedTime.toNow(true)} ago`;
            else identity2LastActivityTime = "never";
        } else identity2LastActivityTime = "unknown";
        return {
            identity2AssetIsOnline: identity2Parsed.connectionState === "Connected",
            // "Disconnected" or "Connected"
            identity2ConnectionStateUpdatedTime,
            identity2LastActivityTime
        };
    };
    const parseOtaAndTwinData = (ota, twin)=>{
        if (!ota || !twin) return {};
        const otaPackages = JSON.parse(ota?.packages || {});
        const twinParsed = JSON.parse(twin?.twin || {});
        const twinDesiredPackages = twinParsed?.properties?.desired?.jobs ?? {};
        const twinReportedPackages = twinParsed?.properties?.reported?.jobs ?? {};
        const packagesToUpdate = Object.entries(otaPackages).reduce((packages, [key, value = ""])=>{
            const twinPackage = twinParsed?.properties?.reported?.softwareVersions?.[key] ?? "";
            return transformVal(twinPackage) === transformVal(value) ? packages : [
                ...packages,
                value
            ];
        }, []);
        const desiredJobsKeys = Object.keys(twinDesiredPackages).sort();
        const reportedJobsKeys = Object.keys(twinReportedPackages).sort();
        const updateInProgress = !(0, _isEqualDefault.default)(desiredJobsKeys, reportedJobsKeys);
        const reportedVersions = twinParsed?.properties?.reported?.softwareVersions ?? {};
        return {
            updateInProgress,
            packagesToUpdate,
            otaPrintedData: "Packages to Update:\n" + JSON.stringify(packagesToUpdate, null, 2) + "\n\n" + "Installed Versions:\n" + JSON.stringify(reportedVersions, null, 2) + "\n\n" + "Twin Reported Jobs:\n" + JSON.stringify(twinReportedPackages, null, 2) + "\n\n" + "Twin Desired Jobs:\n" + JSON.stringify(twinDesiredPackages, null, 2)
        };
    };
    const parseCustomerOTAdata = (customerOTAfromAPI)=>{
        if (!customerOTAfromAPI) return [];
        const parsed = JSON.parse(customerOTAfromAPI?.result || []);
        const output = parsed.map((ota)=>{
            const createdOn = (0, _momentDefault.default)(ota.properties?.createdOn);
            const createdOnText = `${createdOn.toNow(true)}`;
            const typeName = (0, _otaTypes.otaTypes).find((otaType)=>otaType.value == ota.type)?.label || ota.type;
            let displayName = ota.filename;
            const MAX_FILENAME_DISPLAY_LENGTH = 40; // length based on what looks good in the grid on the details tab
            if (displayName.length > MAX_FILENAME_DISPLAY_LENGTH) displayName = displayName.substring(0, MAX_FILENAME_DISPLAY_LENGTH - 3) + "...";
            return {
                ...ota,
                typeName,
                displayName,
                createdOn: createdOnText
            };
        });
        // sort newest to oldest
        output.sort((a, b)=>{
            return (0, _momentDefault.default)(b.properties.createdOn) - (0, _momentDefault.default)(a.properties.createdOn);
        });
        return output;
    };
    const parseTwinDataForBridge = (twin)=>{
        if (!twin) return {};
        const twinParsed = JSON.parse(twin?.twin || {});
        const bridgeKey = twinParsed?.properties?.reported?.key ?? ""; // looks like "QRDUOU6L"
        const bridgeKeyUpdatedTimeRaw = twinParsed?.properties?.reported?.$metadata?.key?.$lastUpdated; // looks like "2019-09-30T20:58:03.1424309Z"
        let bridgeKeyUpdatedTime;
        if (bridgeKeyUpdatedTimeRaw) bridgeKeyUpdatedTime = `${(0, _momentDefault.default)(bridgeKeyUpdatedTimeRaw).toNow(true)} ago`;
        else bridgeKeyUpdatedTime = "no bridge key";
        const token = authService.getToken();
        const bridgeElevatURL = formatBridgeLink(currentUser._id, token, bridgeKey);
        return {
            bridgeElevatURL,
            bridgeKey,
            bridgeKeyUpdatedTime
        };
    };
    const setInitialState = async ()=>{
        const { asset } = props;
        const assetAddress = asset.shadow?.location || "--";
        const assetIsOnline = parseAssetConnectivity(asset);
        const onlineTime = assetUtils.getOnlineTimeFromShadow(asset);
        const lastUpdated = assetUtils.parseLastUpdatedForDetails(asset.shadow?.timestamp);
        const assetCoords = parseCoordinates(asset.shadow);
        const activeSignals = Array.isArray(asset.shadow?.signalCollections) ? assetUtils.getActiveSignalsFromShadow(asset) : 0;
        const dateCreated = assetUtils.getAssetCreatedAt(asset.createdAt);
        const dateActivated = assetUtils.getAssetActivatedOn(asset.activatedOn);
        if (!userHasRemoteRead) return updateState((prevState)=>({
                ...prevState,
                activeSignals,
                assetAddress,
                assetCoords,
                assetIsOnline,
                dateActivated,
                dateCreated,
                onlineTime,
                lastUpdated
            }));
        let deviceStreamsElevatURL = state.deviceStreamsElevatURL;
        let deviceStreamsError = state.deviceStreamsError;
        try {
            deviceStreamsElevatURL = await getDeviceStreamsKey();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            deviceStreamsError = err.response?.data?.message ?? err.message;
        }
        let remoteData = {};
        let error = state.error;
        try {
            remoteData = await fetchRemoteData();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            error = err.response?.data?.message ?? err.message;
        }
        updateState((prevState)=>({
                ...prevState,
                ...remoteData,
                activeSignals,
                assetAddress,
                assetCoords,
                assetIsOnline,
                dateActivated,
                dateCreated,
                deviceStreamsElevatURL,
                deviceStreamsError,
                error,
                haveSystemAdminData: true,
                onlineTime,
                lastUpdated
            }));
    };
    const toggleModal = ()=>{
        updateState((prevState)=>({
                ...prevState,
                modalIsOpen: !state.modalIsOpen
            }));
    };
    const toggleRawAPIModal = (whichAPI)=>{
        let RawAPIData;
        let RawAPIDataName;
        switch(whichAPI){
            case "twin":
                {
                    let parsed;
                    try {
                        parsed = JSON.parse(state.twin || {});
                    } catch (err) {
                        parsed = {
                            error: err.message
                        };
                    }
                    RawAPIData = JSON.stringify(parsed, null, 4);
                    RawAPIDataName = "Main IoT Hub Twin";
                }
                break;
            case "twin2":
                {
                    let parsed;
                    try {
                        parsed = JSON.parse(state.twin2 || {});
                    } catch (err) {
                        parsed = {
                            error: err.message
                        };
                    }
                    RawAPIData = JSON.stringify(parsed, null, 4);
                    RawAPIDataName = "Alt IoT Hub Twin";
                }
                break;
            case "OTAs":
                RawAPIData = state.otaPrintedData;
                RawAPIDataName = "OTA Info";
                break;
            default:
                RawAPIData = "";
                RawAPIDataName = "";
                break;
        }
        updateState((prevState)=>({
                ...prevState,
                showRawAPIModal: !state.showRawAPIModal,
                RawAPIData,
                RawAPIDataName
            }));
    };
    const toggleUploadCustomerOTAModal = ()=>{
        updateState((prevState)=>({
                ...prevState,
                showUploadCustomerOTAModal: !state.showUploadCustomerOTAModal
            }));
    };
    const toggleRunCustomerOTAModal = (customerOTAselected)=>{
        updateState((prevState)=>({
                ...prevState,
                showRunCustomerOTAModal: !state.showRunCustomerOTAModal,
                customerOTAselected
            }));
    };
    const toggleDeleteCustomerOTAModal = (customerOTAselected)=>{
        updateState((prevState)=>({
                ...prevState,
                showDeleteCustomerOTAModal: !state.showDeleteCustomerOTAModal,
                customerOTAselected
            }));
    };
    const handleCustomerOTADeleted = (customerOTAselected)=>{
        const filteredOTAs = state.customerOTAlist.filter(function(ota) {
            return ota.type !== customerOTAselected.type || ota.filename !== customerOTAselected.filename;
        });
        updateState((prevState)=>({
                ...prevState,
                customerOTAlist: filteredOTAs
            }));
    };
    const handleCustomerOTAUpdated = async ()=>{
        let remoteData = {};
        let error = state.error;
        try {
            remoteData = await fetchRemoteData();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            error = err.response?.data?.message ?? err.message;
        }
        updateState((prevState)=>({
                ...prevState,
                ...remoteData,
                error
            }));
    };
    (0, _react.useEffect)(()=>{
        if (!props.asset?._id) return;
        setInitialState();
        return source.cancel;
    }, [
        props.asset?._id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "position-absolute container-fluid h-100 bg-white rounded py-4 d-flex flex-column overflow-auto",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDetailsTabDisplayDefault.default), {
                ...props,
                ...state,
                toggleModal: toggleModal,
                toggleRawAPIModal: toggleRawAPIModal,
                toggleUploadCustomerOTAModal: toggleUploadCustomerOTAModal,
                toggleRunCustomerOTAModal: toggleRunCustomerOTAModal,
                toggleDeleteCustomerOTAModal: toggleDeleteCustomerOTAModal
            }),
            state.modalIsOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetUpdateModalDefault.default), {
                isOpen: state.modalIsOpen,
                toggleModal: toggleModal,
                handleSubmitUpdate: handleSubmitUpdate,
                updatePending: state.updatePending,
                updating: state.updating
            }) : null,
            state.showRawAPIModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rawAPIModalDefault.default), {
                data: state.RawAPIData,
                isOpen: state.showRawAPIModal,
                title: state.RawAPIDataName,
                toggleModal: toggleRawAPIModal
            }) : null,
            state.showUploadCustomerOTAModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadCustomerOTAModalDefault.default), {
                ...props,
                isOpen: state.showUploadCustomerOTAModal,
                handleCustomerOTAUpdated: handleCustomerOTAUpdated,
                toggleModal: toggleUploadCustomerOTAModal
            }) : null,
            state.showRunCustomerOTAModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runCustomerOTAModalDefault.default), {
                ...props,
                customerOTAselected: state.customerOTAselected,
                isOpen: state.showRunCustomerOTAModal,
                toggleModal: toggleRunCustomerOTAModal
            }) : null,
            state.showDeleteCustomerOTAModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteCustomerOTAModalDefault.default), {
                ...props,
                customerOTAselected: state.customerOTAselected,
                handleCustomerOTADeleted: handleCustomerOTADeleted,
                isOpen: state.showDeleteCustomerOTAModal,
                toggleModal: toggleDeleteCustomerOTAModal
            }) : null
        ]
    });
}
AssetDetailsTabContainer.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    assetGroups: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    isRestrictedAssetForOtherThings: (0, _propTypesDefault.default).bool,
    otaHiddenForEdge: (0, _propTypesDefault.default).bool
};
function formatBridgeLink(userID, token, bridgeKey) {
    return `elevat://Action=bridge;UserUUID=${userID};Token=${token};BridgeKey=${bridgeKey}`;
}
function transformVal(val) {
    return val?.split?.("/")?.pop?.();
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","axios":"ffpgq","lodash/isEqual":"3mRdp","moment":"1e4qG","prop-types":"bnNSm","../../Constants/RBAC":"ieo1E","../../Services/AssetService":"fL096","../../Lib/AssetUtils":"gdVNl","../../Services/AuthService":"8Bjjn","../../Context/CurrentUserContext":"4sVVe","../../RBAC/AccessTools":"j912a","./AssetDetailsTabDisplay":"8s3Om","./AssetUpdateModal":"9dtC9","./RawAPIModal":"e92R5","./UploadCustomerOTAModal":"5TaKX","./RunCustomerOTAModal":"h8yKx","./DeleteCustomerOTAModal":"lsL4V","../../Constants/OtaTypes":"4qfIk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3mRdp":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"hrIE8"}],"8s3Om":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _assetUtils = require("../../Lib/AssetUtils");
var _assetUtilsDefault = parcelHelpers.interopDefault(_assetUtils);
var _accessTools = require("../../RBAC/AccessTools");
var _assetTag = require("./AssetTag");
var _assetTagDefault = parcelHelpers.interopDefault(_assetTag);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _rbac = require("../../Constants/RBAC");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetDetailsTabDisplay);
function AssetDetailsTabDisplay(props) {
    const { activeSignals, asset, assetAddress, assetCoords, assetGroups, assetIsOnline, bridgeElevatURL, bridgeKey, bridgeKeyUpdatedTime, dateActivated, dateCreated, deviceStreamsElevatURL, deviceStreamsError, haveSystemAdminData, identityAssetIsOnline, identityConnectionStateUpdatedTime, identityLastActivityTime, identity2AssetIsOnline, identity2ConnectionStateUpdatedTime, identity2LastActivityTime, isRestrictedAssetForOtherThings, otaHiddenForEdge, lastUpdated, onlineTime, packagesToUpdate, toggleModal, toggleRawAPIModal, toggleUploadCustomerOTAModal, toggleRunCustomerOTAModal, toggleDeleteCustomerOTAModal, updateInProgress, customerOTAlist } = props;
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default));
    const { cumminsIconBlack } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const assetLinks = asset?.gtemplate?.links ?? [];
    const assetUtils = (0, _react.useMemo)(()=>new (0, _assetUtilsDefault.default)(), []);
    const orgUsesNewBilling = (0, _react.useMemo)(()=>currentOrg?.features?.billing?.enabled, [
        currentOrg?.features?.billing?.enabled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-2241326221 flex-grow-1 row nine-tenth-text",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2241326221 col-12 col-md-6 col-lg-4 px-0 px-md-4 mb-3 mb-lg-0 text-text-dark d-lg-flex flex-lg-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2241326221 border rounded p-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                className: "jsx-2241326221 font-weight-bold mb-3",
                                children: "Info"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Asset Model"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                            no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    disabled: true,
                                                    className: "jsx-2241326221 btn btn-link p-0 m-0 border-0 nine-tenth-text",
                                                    children: asset?.gtemplate?.name ?? "--"
                                                }),
                                            orgID: asset?.orgID,
                                            perform: (0, _rbac.ASSET_MODEL_READ),
                                            resource: (0, _rbac.ASSET_MODEL),
                                            sharedGtemplate: asset?.gtemplate?.sharedGtemplate,
                                            yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    className: "btn btn-link p-0 m-0 border-0 nine-tenth-text",
                                                    to: `/asset-model/${asset?.gtemplateID ?? ""}`,
                                                    children: asset?.gtemplate?.name ?? "--"
                                                })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Gateway"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: asset?.nickname ?? "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Location"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: assetAddress ? assetAddress : "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Timezone"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: asset?.timezone ?? "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Owner"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: orgsMap[asset?.orgID]?.name ?? "--"
                                    })
                                ]
                            }),
                            asset?.gtemplate?.settings?.engineanalysis ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "jsx-2241326221 d-md-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex justify-content-between mt-lg-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "jsx-2241326221 d-flex align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        alt: "cummins logo",
                                                        height: 25,
                                                        src: cumminsIconBlack,
                                                        width: 25,
                                                        className: "jsx-2241326221 mr-1"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "jsx-2241326221 mb-0 text-text-light-gray",
                                                        children: "Diagnostics"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                className: "p-0 m-0 border-0 nine-tenth-text text-right",
                                                to: `/engineanalysis/${asset?._id}?${(0, _queryStringDefault.default).stringify({
                                                    viewing: "details"
                                                })}`,
                                                children: "View Details"
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            isRestrictedAssetForOtherThings || otaHiddenForEdge ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "jsx-2241326221 d-md-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                        orgID: asset?.orgID,
                                        perform: (0, _rbac.GATEWAY_VERSION_UPDATE),
                                        resource: (0, _rbac.REMOTE),
                                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "jsx-2241326221 text-text-light-gray",
                                                        children: "Gateway Software Version"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            onClick: toggleModal,
                                                            disabled: (0, _isEmptyDefault.default)(packagesToUpdate) || updateInProgress,
                                                            className: "jsx-2241326221 " + `btn ${(0, _isEmptyDefault.default)(packagesToUpdate) ? "text-alert-confirmation border-alert-confirmation" : updateInProgress ? "text-gradient-first-blue border-gradient-first-blue" : "text-gradient-second-red border-gradient-second-red"} rounded three-quarter-text py-0 mr-1`,
                                                            children: (0, _isEmptyDefault.default)(packagesToUpdate) ? "Up to date" : updateInProgress ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "jsx-2241326221",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                        icon: (0, _freeSolidSvgIcons.faSyncAlt),
                                                                        size: "xs"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "jsx-2241326221 pl-2",
                                                                        children: "In Progress"
                                                                    })
                                                                ]
                                                            }) : "Update Available"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "jsx-2241326221 font-weight-bold text-text-dark",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            onClick: ()=>toggleRawAPIModal("OTAs"),
                                                            className: "jsx-2241326221 p-1 btn btn-sm modal-button-primary three-quarter-text",
                                                            children: "View OTA Data"
                                                        })
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            }),
                            (0, _accessTools.hasReadAccessToResource)(asset?.orgID, (0, _rbac.REMOTE)) && !isRestrictedAssetForOtherThings ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "jsx-2241326221 d-md-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 text-text-light-gray",
                                                children: "Main IoT Hub"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>toggleRawAPIModal("twin"),
                                                    className: "jsx-2241326221 p-1 btn btn-sm modal-button-primary three-quarter-text",
                                                    children: "View Twin"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "jsx-2241326221 d-md-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 text-text-light-gray",
                                                children: "Alt IoT Hub"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>toggleRawAPIModal("twin2"),
                                                    className: "jsx-2241326221 p-1 btn btn-sm modal-button-primary three-quarter-text",
                                                    children: "View Twin"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    haveSystemAdminData && !isRestrictedAssetForOtherThings ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2241326221 border rounded mt-3 flex-fill p-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                className: "jsx-2241326221 font-weight-bold",
                                children: "Remote Access"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Bridge Link"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: bridgeElevatURL,
                                            className: "jsx-2241326221 btn btn-link p-0",
                                            children: "Click to Open Windows Client"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Bridge Key"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark",
                                        children: bridgeKey || "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Bridge Key Updated"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: bridgeKeyUpdatedTime || "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Elevat Device Link"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: deviceStreamsError ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            "data-for": "deviceStreamsError",
                                            "data-tip": deviceStreamsError,
                                            className: "jsx-2241326221 text-text-light-gray",
                                            children: [
                                                "not available",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                    id: "deviceStreamsError"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: deviceStreamsElevatURL,
                                            className: "jsx-2241326221 btn btn-link p-0",
                                            children: "Click to Open Windows Client"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Device Link IoT Hub State"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex align-items-center justify-content-end",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faCircle),
                                                size: "xs",
                                                className: `text-${identity2AssetIsOnline ? "alert-confirmation" : "hr-gray"}`
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "jsx-2241326221 " + `${identity2AssetIsOnline ? "text-success" : "text-icon-link-gray"} ml-1`,
                                                children: identity2AssetIsOnline ? "Online" : "Offline"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "jsx-2241326221 ml-1 font-weight-bold text-text-dark text-right",
                                                children: `updated ${identity2ConnectionStateUpdatedTime}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Device Link IoT Hub Last Activity"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: identity2LastActivityTime || "--"
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2241326221 col-12 col-md-6 col-lg-4 px-0 px-md-4 mb-3 mb-lg-0 text-text-dark d-md-flex flex-md-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2241326221 border rounded p-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                className: "jsx-2241326221 font-weight-bold mb-3",
                                children: "Stats"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faCircle),
                                        size: "xs",
                                        className: `text-${assetIsOnline ? "alert-confirmation" : "hr-gray"}`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "jsx-2241326221 " + `${assetIsOnline ? "text-success" : "text-icon-link-gray"} ml-1`,
                                        children: assetIsOnline ? "Online" : "Offline"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "jsx-2241326221 " + ((assetIsOnline ? "text-gray font-weight-light ml-1 three-quarter-text" : "d-none") || ""),
                                        children: `for ${onlineTime}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Last Updated"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: lastUpdated ? lastUpdated : "--"
                                    })
                                ]
                            }),
                            haveSystemAdminData && !isRestrictedAssetForOtherThings ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "jsx-2241326221 d-md-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 text-text-light-gray",
                                                children: "IoT Hub State"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "jsx-2241326221 d-flex align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        icon: (0, _freeSolidSvgIcons.faCircle),
                                                        size: "xs",
                                                        className: `text-${identityAssetIsOnline ? "alert-confirmation" : "hr-gray"}`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "jsx-2241326221 " + `${identityAssetIsOnline ? "text-success" : "text-icon-link-gray"} ml-1`,
                                                        children: identityAssetIsOnline ? "Online" : "Offline"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "jsx-2241326221 ml-1 font-weight-bold text-text-dark text-right",
                                                        children: `updated ${identityConnectionStateUpdatedTime}`
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "jsx-2241326221 d-md-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 text-text-light-gray",
                                                children: "IoT Hub Last Activity"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                                children: identityLastActivityTime ? identityLastActivityTime : "--"
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Serial Number"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: asset?.mac ?? "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Coordinates"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: assetCoords ? assetCoords : "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Signals Reporting Data"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: activeSignals ? activeSignals : "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Date Created"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: dateCreated ? dateCreated : "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            orgUsesNewBilling ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 text-text-light-gray",
                                                children: "Subscription Start Date"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                                children: assetUtils.parseDateToYearMonthDay(asset?.assetAssociation?.term_start)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "jsx-2241326221 d-md-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 text-text-light-gray",
                                                children: "Subscription Renewal Date"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                                children: assetUtils.parseDateToYearMonthDay(asset?.assetAssociation?.renewal_date)
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "Date Activated"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold text-text-dark text-right",
                                        children: dateActivated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-2241326221 d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 d-flex justify-content-between mt-lg-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 text-text-light-gray",
                                        children: "UUID"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2241326221 font-weight-bold three-quarter-text asset-uuid text-text-dark text-right",
                                        children: asset?._id ?? "--"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2241326221 " + `border rounded p-3 mt-3 ${customerOTAlist?.length ? "flex-md-fill" : ""} d-lg-flex flex-lg-column`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2241326221 w-100 mb-3 d-flex align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                        className: "jsx-2241326221 mb-0 font-weight-bold",
                                        children: "Customer OTAs"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>toggleUploadCustomerOTAModal(),
                                        className: "jsx-2241326221 p-1 btn btn-sm modal-button-primary three-quarter-text",
                                        children: "Upload new OTA file"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2241326221 flex-fill position-relative",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-2241326221 inner-otas-container",
                                    children: customerOTAlist?.length ? customerOTAlist.map((customerOTAselected, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "jsx-2241326221 row no-gutters align-items-center justify-content-between my-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "jsx-2241326221 col-auto",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        "data-for": `deleteOta-${i}`,
                                                        "data-tip": "Delete OTA",
                                                        "data-type": "error",
                                                        onClick: ()=>toggleDeleteCustomerOTAModal(customerOTAselected),
                                                        className: "jsx-2241326221 btn btn-danger px-1 py-0",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                icon: (0, _freeSolidSvgIcons.faTrashAlt),
                                                                size: "xs"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                                id: `deleteOta-${i}`
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    "data-for": `otaDetails-${i}`,
                                                    "data-multiline": true,
                                                    "data-tip": `Type: ${customerOTAselected.typeName}<br />Created: ${customerOTAselected.createdOn} ago`,
                                                    "data-type": "info",
                                                    className: "jsx-2241326221 col px-3 d-flex align-items-center justify-content-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "jsx-2241326221 font-weight-bold text-text-dark three-quarter-text text-center text-break mb-0",
                                                            children: customerOTAselected.displayName
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                            id: `otaDetails-${i}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "jsx-2241326221 col-auto",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        "data-arrow-color": "transparent",
                                                        "data-class": "bg-brand-primary text-white",
                                                        "data-for": `runOta-${i}`,
                                                        "data-tip": "Run OTA",
                                                        onClick: ()=>toggleRunCustomerOTAModal(customerOTAselected),
                                                        className: "jsx-2241326221 btn btn-sm modal-button-primary text-white px-1 py-0",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                icon: (0, _freeSolidSvgIcons.faPlay),
                                                                size: "xs"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                                id: `runOta-${i}`
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, i)) : null
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2241326221 col-12 col-md-6 col-lg-4 px-0 px-md-4 text-text-dark d-flex flex-column mb-3 mb-lg-0",
                children: [
                    currentOrg?.features?.apps?.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            minHeight: "10rem"
                        },
                        className: "jsx-2241326221 flex-fill border rounded p-3 mb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                className: "jsx-2241326221 font-weight-bold",
                                children: "Groups"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2241326221 outer-groups-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-2241326221 inner-groups-container w-100",
                                    children: assetGroups?.map?.(({ _id, name, orgID, type })=>{
                                        const urlBase = type === "waterpump" ? "watertransfer" : type;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            className: "btn btn-link d-block text-left p-0 m-0 border-0 nine-tenth-text",
                                            to: `/${urlBase}/${_id}?orgID=${orgID}&viewing=lineDetail`,
                                            children: name ?? "--"
                                        }, _id);
                                    })
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            minHeight: "10rem"
                        },
                        className: "jsx-2241326221 border rounded p-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                className: "jsx-2241326221 font-weight-bold mb-3",
                                children: "Links"
                            }),
                            assetLinks.map(({ name, link }, i)=>{
                                return link ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-2241326221 mt-1 mt-lg-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: link,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "jsx-2241326221 btn btn-link p-0",
                                        children: name || link
                                    })
                                }, i) : null;
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            minHeight: "10rem"
                        },
                        className: "jsx-2241326221 border rounded p-3 mt-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                                className: "jsx-2241326221 font-weight-bold",
                                children: "Tags"
                            }),
                            asset?.tags?.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2241326221 outer-tags-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-2241326221 inner-tags-container w-100",
                                    children: asset.tags.map((tag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetTagDefault.default), {
                                            tagName: tag.name,
                                            tagValue: tag.value,
                                            tagID: tag._id,
                                            hideDeleteButton: true
                                        }, tag._id))
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2241326221",
                children: ".row.jsx-2241326221{margin-top:0.5rem;margin-left:0;margin-right:0;}.dynamic-content-row.jsx-2241326221{height:1.5rem;}.profile-image-container.jsx-2241326221{height:8rem;}.asset-uuid.jsx-2241326221{line-height:2;}.text-gray.jsx-2241326221{color:var(--text-light-gray);}.border.jsx-2241326221{border-color:var(--lightest-gray) !important;}@media (min-width:992px){.outer-groups-container.jsx-2241326221,.outer-tags-container.jsx-2241326221{position:relative;height:100%;}.inner-groups-container.jsx-2241326221,.inner-tags-container.jsx-2241326221{position:absolute;height:80%;overflow:auto;}.inner-otas-container.jsx-2241326221{height:100%;overflow:auto;position:absolute;width:100%;}}"
            })
        ]
    });
}
AssetDetailsTabDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    assetAddress: (0, _propTypesDefault.default).string,
    assetGroups: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        name: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        type: (0, _propTypesDefault.default).string
    })),
    assetIsOnline: (0, _propTypesDefault.default).bool,
    onlineTime: (0, _propTypesDefault.default).string,
    lastUpdated: (0, _propTypesDefault.default).string,
    assetCoords: (0, _propTypesDefault.default).string,
    activeSignals: (0, _propTypesDefault.default).number,
    dateCreated: (0, _propTypesDefault.default).string,
    dateActivated: (0, _propTypesDefault.default).string,
    toggleModal: (0, _propTypesDefault.default).func,
    packagesToUpdate: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    updateInProgress: (0, _propTypesDefault.default).bool,
    haveSystemAdminData: (0, _propTypesDefault.default).bool,
    deviceStreamsElevatURL: (0, _propTypesDefault.default).string,
    deviceStreamsError: (0, _propTypesDefault.default).string,
    bridgeElevatURL: (0, _propTypesDefault.default).string,
    bridgeKey: (0, _propTypesDefault.default).string,
    bridgeKeyUpdatedTime: (0, _propTypesDefault.default).string,
    identityAssetIsOnline: (0, _propTypesDefault.default).bool,
    identityConnectionStateUpdatedTime: (0, _propTypesDefault.default).string,
    identityLastActivityTime: (0, _propTypesDefault.default).string,
    identity2AssetIsOnline: (0, _propTypesDefault.default).bool,
    identity2ConnectionStateUpdatedTime: (0, _propTypesDefault.default).string,
    identity2LastActivityTime: (0, _propTypesDefault.default).string,
    isRestrictedAssetForOtherThings: (0, _propTypesDefault.default).bool,
    otaHiddenForEdge: (0, _propTypesDefault.default).bool,
    toggleRawAPIModal: (0, _propTypesDefault.default).func,
    toggleUploadCustomerOTAModal: (0, _propTypesDefault.default).func,
    toggleRunCustomerOTAModal: (0, _propTypesDefault.default).func,
    toggleDeleteCustomerOTAModal: (0, _propTypesDefault.default).func,
    customerOTAlist: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        filename: (0, _propTypesDefault.default).string,
        // just the filename
        displayName: (0, _propTypesDefault.default).string,
        // the filename but maybe truncated for display
        name: (0, _propTypesDefault.default).string,
        // blob storage name
        type: (0, _propTypesDefault.default).string,
        // just the prefix like "hfx_flash"
        typeName: (0, _propTypesDefault.default).string,
        // name found from looking up in our types table
        properties: (0, _propTypesDefault.default).object,
        // from blob storage
        createdOn: (0, _propTypesDefault.default).string // "x ago" string from properties.createdOn time
    }))
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","react-tooltip":"4ejwp","prop-types":"bnNSm","react-router-dom":"3uzXR","query-string":"h6dFx","lodash/isEmpty":"6WyGC","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/CurrentOrgContext":"jQXcJ","../../Context/IconsContext":"lzIpe","../../Context/OrgsMapContext":"asozp","../../Lib/AssetUtils":"gdVNl","../../RBAC/AccessTools":"j912a","./AssetTag":"jTrGQ","../../RBAC/Can":"l4l8D","../../Constants/RBAC":"ieo1E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jTrGQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetTag);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
function AssetTag(props) {
    const { tagName, tagValue, handleDelete, tagID, deleteTagRequestPending, hideDeleteButton } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3712138734 col-auto p-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-3712138734 float-left bg-white pr-2 text-black tag-label",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-3712138734 font-weight-bold ml-2",
                        children: tagName
                    }),
                    " : ",
                    tagValue,
                    hideDeleteButton ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleDelete(tagID),
                        className: "jsx-3712138734 btn btn-link text-decoration-none p-0 text-hr-gray ml-2 mr-1",
                        children: deleteTagRequestPending === tagID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            color: "var(--brand-primary-alert)"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTimes)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3712138734",
                children: ".tag-label.jsx-3712138734{margin:0.2rem;padding:0.2rem;border-radius:6px;border:0.5px solid var(--third-gray);font-size:14px;}button.jsx-3712138734:hover{color:var(--error-red) !important;}"
            })
        ]
    });
}
AssetTag.propTypes = {
    tagName: (0, _propTypesDefault.default).string,
    tagValue: (0, _propTypesDefault.default).string,
    tagID: (0, _propTypesDefault.default).string,
    deleteTagRequestPending: (0, _propTypesDefault.default).string,
    handleDelete: (0, _propTypesDefault.default).func,
    hideDeleteButton: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9dtC9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetUpdateModal);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2755872101",
        children: "@media (max-width:767px){.modal-dialog.jsx-2755872101{margin:0;}}"
    }),
    className: "jsx-2755872101"
};
const { className: contentClass, styles: contentStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2879347659",
        children: ".modal-content.jsx-2879347659{height:100%;border-radius:0;}@media (min-width:768px){.modal-content.jsx-2879347659{height:50%;border-radius:1rem;}}"
    }),
    className: "jsx-2879347659"
};
function AssetUpdateModal(props) {
    const { isOpen, toggleModal, handleSubmitUpdate, updatePending, updating } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        toggle: toggleModal,
        size: "md",
        centered: true,
        className: modalClass,
        contentClassName: contentClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0 font-weight-medium text-text-dark",
                children: "There are available updates for your Gateway"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "text-muted text-center position-relative nine-tenth-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-3",
                        children: "Updating your Gateway will take your asset offline. Please check this page again in about 20 minutes to see if the update was successful."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `btn ${updating ? "btn-icon-link-gray" : "modal-button-submit"} mt-2 py-0 px-5 px-md-3 text-white nine-tenth-text`,
                        onClick: handleSubmitUpdate,
                        children: updatePending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : updating ? "Gateway Update In Progress" : "Update Gateway Now"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-outline-secondary py-0 px-4 nine-tenth-text ml-4",
                    onClick: toggleModal,
                    children: "Close"
                })
            }),
            modalStyles,
            contentStyles
        ]
    });
}
AssetUpdateModal.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    updatePending: (0, _propTypesDefault.default).bool,
    handleSubmitUpdate: (0, _propTypesDefault.default).func,
    updating: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e92R5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RawAPIModal);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
const { className: footerClassName, styles: footerStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3530038914",
        children: "@media (min-width:768px){div.jsx-3530038914{border-top:none;}}"
    }),
    className: "jsx-3530038914"
};
function RawAPIModal(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        isOpen: props.isOpen,
        toggleModal: props.toggleModal,
        scrollable: true,
        style: {
            maxWidth: "1600px",
            width: "80%"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: props.toggleModal,
                children: props.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                className: "modal-body pt-5 px-md-5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                    children: props.data
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: `justify-content-between justify-content-md-end ${footerClassName}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-sm btn-outline-icon-link-gray bg-white text-muted shadow-none py-0 px-3 ml-md-3 three-quarter-text",
                    onClick: props.toggleModal,
                    children: "Close"
                })
            }),
            footerStyles
        ]
    });
}
RawAPIModal.propTypes = {
    data: (0, _propTypesDefault.default).string,
    title: (0, _propTypesDefault.default).string,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};
RawAPIModal.defaultProps = {};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","../ModalLayout":"2RoDj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2RoDj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ModalLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1467669322",
        children: "@media (max-width:767px){.modal-dialog.jsx-1467669322{height:100%;width:100%;max-height:100%;max-width:100%;margin:0;}}@media (min-width:768px){.modal-dialog.jsx-1467669322{height:50%;}}"
    }),
    className: "jsx-1467669322"
};
function getModalContentCss(desktopHeight) {
    return {
        styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
            id: "590490971",
            dynamic: [
                desktopHeight
            ],
            children: `@media (max-width:767px){.modal-content.__jsx-style-dynamic-selector{border-radius:0;height:100% !important;}}@media (min-width:768px){.modal-content.__jsx-style-dynamic-selector{border-radius:1rem;height:${desktopHeight};}}`
        }),
        className: (0, _styleDefault.default).dynamic([
            [
                "590490971",
                [
                    desktopHeight
                ]
            ]
        ])
    };
}
function ModalLayout({ backdrop = true, backdropClassName = "", centered = true, children, contentClassName = "", desktopHeight = "80vh", dialogClassName = "", isOpen = false, scrollable = false, size = "lg", toggleModal, style = {} }) {
    const { className: contentClass, styles: contentStyles } = getModalContentCss(desktopHeight);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdrop: backdrop,
        backdropClassName: backdropClassName,
        centered: centered,
        className: `${modalClass} ${dialogClassName}`,
        contentClassName: `${contentClass} ${contentClassName}`,
        isOpen: isOpen,
        scrollable: scrollable,
        size: size,
        toggle: toggleModal,
        style: style,
        children: [
            children,
            modalStyles,
            contentStyles
        ]
    });
}
ModalLayout.propTypes = {
    backdrop: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).oneOf([
            "static"
        ])
    ]),
    backdropClassName: (0, _propTypesDefault.default).string,
    centered: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).node,
    contentClassName: (0, _propTypesDefault.default).string,
    desktopHeight: (0, _propTypesDefault.default).string,
    dialogClassName: (0, _propTypesDefault.default).string,
    isOpen: (0, _propTypesDefault.default).bool,
    scrollable: (0, _propTypesDefault.default).bool,
    size: (0, _propTypesDefault.default).oneOf([
        "xs",
        "sm",
        "lg",
        "xl"
    ]),
    toggleModal: (0, _propTypesDefault.default).func,
    style: (0, _propTypesDefault.default).object
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5TaKX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _uploadCustomerOTAModalDisplay = require("./UploadCustomerOTAModalDisplay");
var _uploadCustomerOTAModalDisplayDefault = parcelHelpers.interopDefault(_uploadCustomerOTAModalDisplay);
var _fileHelpers = require("../../Lib/FileHelpers");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
class UploadCustomerOTAModal extends (0, _react.Component) {
    static propTypes = {
        asset: (0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string
        }),
        toggleModal: (0, _propTypesDefault.default).func,
        handleCustomerOTAUpdated: (0, _propTypesDefault.default).func
    };
    state = {
        error: "",
        file: undefined,
        fileDataBase64: undefined,
        otaType: {
            value: "hfx_flash",
            label: "HFX Flash"
        },
        uploadPending: false
    };
    assetService = new (0, _assetServiceDefault.default)();
    source = (0, _axios.CancelToken).source();
    componentWillUnmount() {
        this.source.cancel();
    }
    handleFileSelect = ([file])=>{
        this.setState({
            file
        }); // has properties: path, name, size and a few others
        const handleError = ()=>{
            this.setState({
                error: "error reading file"
            });
        };
        const handleSuccess = (fileDataBase64)=>{
            this.setState({
                fileDataBase64
            });
        };
        (0, _fileHelpers.handleFileRead)(file, handleError, handleSuccess);
    };
    handleFileUpload = async ()=>{
        this.setState({
            uploadPending: true
        });
        try {
            const { asset: { _id: assetID } } = this.props;
            await this.assetService.addAssetCustomerOTA(assetID, {
                file: this.state.fileDataBase64,
                filename: this.state.file.name,
                type: this.state.otaType.value
            }, this.source.token);
            this.setState({
                uploadPending: false
            });
            await this.props.handleCustomerOTAUpdated();
            this.props.toggleModal();
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) {
                this.setState({
                    uploadPending: true
                });
                this.setState({
                    error: err.response?.data?.message ?? err.message
                });
            }
        }
    };
    setOTAType = (otaType)=>{
        this.setState({
            otaType
        });
    };
    setError = (error)=>{
        this.setState({
            error
        });
    };
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadCustomerOTAModalDisplayDefault.default), {
            ...this.props,
            ...this.state,
            handleFileSelect: this.handleFileSelect,
            handleFileUpload: this.handleFileUpload,
            setOTAType: this.setOTAType,
            setError: this.setError
        });
    }
}
exports.default = UploadCustomerOTAModal;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","./UploadCustomerOTAModalDisplay":"keSzy","../../Lib/FileHelpers":"5Iydq","../../Services/AssetService":"fL096","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"keSzy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RawAPIModal);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDropzone = require("react-dropzone");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _selectStyles = require("../../Styles/SelectStyles");
var _otaTypes = require("../../Constants/OtaTypes");
const baseStyle = {
    backgroundColor: "#fafafa",
    borderWidth: 3,
    borderRadius: 5,
    borderColor: "var(--brand-primary)",
    borderStyle: "dashed",
    color: "var(--muted-gray)",
    outline: "none",
    transition: "border .24s ease-in-out"
};
const acceptStyle = {
    borderColor: "var(--alert-confirmation)"
};
const focusedStyle = {
    borderColor: "var(--brand-primary-alert)"
};
const rejectStyle = {
    borderColor: "var(--warning-yellow)"
};
function RawAPIModal(props) {
    const { handleFileSelect, file } = props;
    const onDrop = (0, _react.useCallback)((acceptedFiles, fileRejections)=>{
        fileRejections.forEach((file)=>{
            file.errors.forEach((err)=>{
                props.setError(`Error: ${err.message}`);
            });
        });
        if (acceptedFiles.length) handleFileSelect(acceptedFiles);
    }, []);
    const { getRootProps, getInputProps, isDragAccept, isDragActive, isDragReject, isFocused } = (0, _reactDropzone.useDropzone)({
        maxSize: 5242880 /* 5MB */ ,
        maxFiles: 1,
        multiple: false,
        onDrop
    });
    const style = (0, _react.useMemo)(()=>({
            ...baseStyle,
            ...isFocused ? focusedStyle : {},
            ...isDragAccept ? acceptStyle : {},
            ...isDragReject ? rejectStyle : {}
        }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);
    const { commandControlIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: props.isOpen,
        size: "lg",
        toggle: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "pb-0 border-bottom-0",
                toggle: props.toggleModal,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: commandControlIcon,
                        alt: "command icon",
                        style: {
                            height: "4rem"
                        },
                        className: "jsx-1956239040 img-fluid mx-auto"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-1956239040 mb-0 modal-title-text text-center",
                        children: "New Customer OTA File"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-md-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-1956239040 col-12 col-md-10 d-flex justify-content-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1956239040 form-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "otaType",
                                        className: "jsx-1956239040 modal-inputlabel-text",
                                        children: "Choose OTA Type"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                        isSearchable: true,
                                        maxMenuHeight: 150,
                                        name: "otaType",
                                        onChange: props.setOTAType,
                                        options: (0, _otaTypes.otaTypes),
                                        styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                        value: props.otaType
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-md-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-left text-muted",
                            children: "The file will be uploaded to the platform and made available in the customer OTA list. When run, the gateway will download the OTA file and execute it."
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-md-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-left text-muted",
                            children: "If this upload creates more than the maximum number of OTAs stored on the platform (5), the oldest OTA will be deleted from the platform. Uploading a same-named file twice will overwrite the existing file."
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-md-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-left text-muted",
                            children: "The platform will automatically delete OTAs older than six months."
                        })
                    }),
                    file ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-md-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-center text-dark",
                            children: [
                                "selected file: ",
                                file.name,
                                " ",
                                file.size,
                                " bytes"
                            ]
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 flex-fill row justify-content-center mt-md-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            ...getRootProps({
                                style
                            }),
                            className: "jsx-1956239040 col-12 col-md-10 d-flex flex-column align-items-center justify-content-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    ...getInputProps(),
                                    className: "jsx-1956239040"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-1956239040 mb-0",
                                    children: isDragActive ? "Drop the file here ..." : `Drag 'n' drop a file here, or click to select one`
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "justify-content-between border-0 px-md-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 " + ((props.error ? "text-danger three-quarter-text" : "d-none") || ""),
                        children: props.error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: props.toggleModal,
                        className: "jsx-1956239040 btn btn-outline-secondary px-4 py-0 nine-tenth-text",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: !props.file || !props.otaType || !props.fileDataBase64,
                        onClick: props.handleFileUpload,
                        className: "jsx-1956239040 btn modal-button-submit px-4 py-0 nine-tenth-text",
                        children: props.uploadPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            size: "lg"
                        }) : "Upload"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1956239040",
                children: ".modal-title{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-right:-1.5rem;}"
            })
        ]
    });
}
RawAPIModal.propTypes = {
    error: (0, _propTypesDefault.default).string,
    file: (0, _propTypesDefault.default).object,
    fileDataBase64: (0, _propTypesDefault.default).string,
    uploadPending: (0, _propTypesDefault.default).bool,
    otaType: (0, _propTypesDefault.default).object,
    handleFileSelect: (0, _propTypesDefault.default).func,
    handleFileUpload: (0, _propTypesDefault.default).func,
    setOTAType: (0, _propTypesDefault.default).func,
    setError: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};
RawAPIModal.defaultProps = {};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","react-dropzone":"9kTqj","prop-types":"bnNSm","reactstrap":"kjd7g","react-select":"j36cq","../../Context/IconsContext":"lzIpe","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../ModalLayout":"2RoDj","../../Styles/SelectStyles":"1LnYJ","../../Constants/OtaTypes":"4qfIk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9kTqj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>(0, _utils.ErrorCode));
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */ parcelHelpers.export(exports, "useDropzone", ()=>useDropzone);
/* eslint prefer-template: 0 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _fileSelector = require("file-selector");
var _index = require("./utils/index");
var _utils = require("./utils");
var _excluded = [
    "children"
], _excluded2 = [
    "open"
], _excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], _excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var Dropzone = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = _objectWithoutProperties(_ref, _excluded);
    var _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties(_useDropzone, _excluded2);
    (0, _react.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, children(_objectSpread(_objectSpread({}, props), {}, {
        open: open
    })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, _fileSelector.fromEvent),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, _propTypesDefault.default).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, _propTypesDefault.default).objectOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, _propTypesDefault.default).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, _propTypesDefault.default).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, _propTypesDefault.default).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, _propTypesDefault.default).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, _propTypesDefault.default).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, _propTypesDefault.default).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, _propTypesDefault.default).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, _propTypesDefault.default).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, _propTypesDefault.default).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, _propTypesDefault.default).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, _propTypesDefault.default).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, _propTypesDefault.default).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, _propTypesDefault.default).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, _propTypesDefault.default).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, _propTypesDefault.default).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, _propTypesDefault.default).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, _propTypesDefault.default).func
};
exports.default = Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function useDropzone() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, _react.useMemo)(function() {
        return (0, _index.acceptPropAsAcceptAttr)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, _react.useMemo)(function() {
        return (0, _index.pickerOptionsFromAccept)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, _react.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, _react.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, _react.useRef)(null);
    var inputRef = (0, _react.useRef)(null);
    var _useReducer = (0, _react.useReducer)(reducer, initialState), _useReducer2 = _slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, _react.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, _index.canUseFileSystemAccessAPI)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, _react.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, _react.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, _react.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, _index.onDocumentDragOver), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, _index.onDocumentDragOver));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, _react.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, _react.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, _react.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, _index.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, _index.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, _index.allFilesAccepted)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, _index.isEvtWithFiles)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, _index.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, _react.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, _index.fileAccepted)(file, acceptAttr), _fileAccepted2 = _slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, _index.fileMatchSize)(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, _index.TOO_MANY_FILES_REJECTION)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, _react.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, _index.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, _index.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, _react.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, _index.isAbort)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, _index.isSecurityError)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, _react.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, _react.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, _react.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, _react.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, _index.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, _react.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = _objectWithoutProperties(_ref2, _excluded3);
            return _objectSpread(_objectSpread(_defineProperty({
                onKeyDown: composeKeyboardHandler((0, _index.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, _index.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, _index.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, _index.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, _index.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, _index.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, _index.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, _index.composeEventHandlers)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, _react.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, _react.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = _objectWithoutProperties(_ref3, _excluded4);
            var inputProps = _defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, _index.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, _index.composeEventHandlers)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return _objectSpread(_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return _objectSpread(_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return _objectSpread(_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return _objectSpread(_objectSpread({}, initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return _objectSpread(_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return _objectSpread(_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return _objectSpread(_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return _objectSpread({}, initialState);
        default:
            return state;
    }
}
function noop() {}

},{"react":"9njXz","prop-types":"bnNSm","file-selector":"04ehM","./utils/index":"lKdeo","./utils":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04ehM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fileSelector.fromEvent));
var _fileSelector = require("./file-selector");

},{"./file-selector":"ggjz1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ggjz1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */ parcelHelpers.export(exports, "fromEvent", ()=>fromEvent);
var _tslib = require("tslib");
var _file = require("./file");
var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function fromEvent(evt) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if (isChangeEvt(evt)) return [
                2 /*return*/ ,
                getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === "object" && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function(file) {
        return (0, _file.toFileWithPath)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var files;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, _file.toFileWithPath)(file);
                        })
                    ];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var items, files;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map(toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        noIgnoredFiles(flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        noIgnoredFiles(fromList(dt.files).map(function(file) {
                            return (0, _file.toFileWithPath)(file);
                        }))
                    ];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function(file) {
        return FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return fromDirEntry(entry);
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(acc), false), (0, _tslib.__read)(Array.isArray(files) ? flatten(files) : [
            files
        ]), false);
    }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, _file.toFileWithPath)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map(fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, _file.toFileWithPath)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}

},{"tslib":"b4wpY","./file":"jtTHX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4wpY":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtTHX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMMON_MIME_TYPES", ()=>COMMON_MIME_TYPES);
parcelHelpers.export(exports, "toFileWithPath", ()=>toFileWithPath);
var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lKdeo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FILE_INVALID_TYPE", ()=>FILE_INVALID_TYPE);
parcelHelpers.export(exports, "FILE_TOO_LARGE", ()=>FILE_TOO_LARGE);
parcelHelpers.export(exports, "FILE_TOO_SMALL", ()=>FILE_TOO_SMALL);
parcelHelpers.export(exports, "TOO_MANY_FILES", ()=>TOO_MANY_FILES);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "getInvalidTypeRejectionErr", ()=>getInvalidTypeRejectionErr);
parcelHelpers.export(exports, "getTooLargeRejectionErr", ()=>getTooLargeRejectionErr);
parcelHelpers.export(exports, "getTooSmallRejectionErr", ()=>getTooSmallRejectionErr);
parcelHelpers.export(exports, "TOO_MANY_FILES_REJECTION", ()=>TOO_MANY_FILES_REJECTION);
// that MIME type will always be accepted
parcelHelpers.export(exports, "fileAccepted", ()=>fileAccepted);
parcelHelpers.export(exports, "fileMatchSize", ()=>fileMatchSize);
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */ parcelHelpers.export(exports, "allFilesAccepted", ()=>allFilesAccepted) // React's synthetic events has event.isPropagationStopped,
;
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble
parcelHelpers.export(exports, "isPropagationStopped", ()=>isPropagationStopped);
parcelHelpers.export(exports, "isEvtWithFiles", ()=>isEvtWithFiles);
parcelHelpers.export(exports, "isKindFile", ()=>isKindFile) // allow the entire document to be a drag target
;
parcelHelpers.export(exports, "onDocumentDragOver", ()=>onDocumentDragOver);
parcelHelpers.export(exports, "isIeOrEdge", ()=>isIeOrEdge);
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */ parcelHelpers.export(exports, "composeEventHandlers", ()=>composeEventHandlers);
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */ parcelHelpers.export(exports, "canUseFileSystemAccessAPI", ()=>canUseFileSystemAccessAPI);
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */ parcelHelpers.export(exports, "pickerOptionsFromAccept", ()=>pickerOptionsFromAccept);
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */ parcelHelpers.export(exports, "acceptPropAsAcceptAttr", ()=>acceptPropAsAcceptAttr);
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */ parcelHelpers.export(exports, "isAbort", ()=>isAbort);
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */ parcelHelpers.export(exports, "isSecurityError", ()=>isSecurityError);
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */ parcelHelpers.export(exports, "isMIMEType", ()=>isMIMEType);
/**
 * Check if v is a file extension.
 * @param {string} v
 */ parcelHelpers.export(exports, "isExt", ()=>isExt) /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ ;
var _attrAccept = require("attr-accept"); // Error codes
var _attrAcceptDefault = parcelHelpers.interopDefault(_attrAccept);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
    FileInvalidType: FILE_INVALID_TYPE,
    FileTooLarge: FILE_TOO_LARGE,
    FileTooSmall: FILE_TOO_SMALL,
    TooManyFiles: TOO_MANY_FILES
}; // File Errors
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: FILE_INVALID_TYPE,
        message: "File type must be ".concat(messageSuffix)
    };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
    return {
        code: FILE_TOO_LARGE,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
    return {
        code: FILE_TOO_SMALL,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var TOO_MANY_FILES_REJECTION = {
    code: TOO_MANY_FILES,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function fileAccepted(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, _attrAcceptDefault.default)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : getInvalidTypeRejectionErr(accept)
    ];
}
function fileMatchSize(file, minSize, maxSize) {
    if (isDefined(file.size)) {
        if (isDefined(minSize) && isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                getTooLargeRejectionErr(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                getTooSmallRejectionErr(minSize)
            ];
        } else if (isDefined(minSize) && file.size < minSize) return [
            false,
            getTooSmallRejectionErr(minSize)
        ];
        else if (isDefined(maxSize) && file.size > maxSize) return [
            false,
            getTooLargeRejectionErr(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function allFilesAccepted(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
}
function isPropagationStopped(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function isEvtWithFiles(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function isKindFile(item) {
    return _typeof(item) === "object" && item !== null && item.kind === "file";
}
function onDocumentDragOver(event) {
    event.preventDefault();
}
function isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!isPropagationStopped(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return isPropagationStopped(event);
        });
    };
}
function canUseFileSystemAccessAPI() {
    return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
    if (isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!isMIMEType(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every(isExt)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = _slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function acceptPropAsAcceptAttr(accept) {
    if (isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat(_toConsumableArray(a), [
            mimeType
        ], _toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return isMIMEType(v) || isExt(v);
    }).join(",");
    return undefined;
}
function isAbort(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function isSecurityError(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function isMIMEType(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function isExt(v) {
    return /^.*\.[\w]+$/.test(v);
}

},{"attr-accept":"8B0mf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B0mf":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};

},{}],"j36cq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateManager", ()=>(0, _useStateManager7E1E8489EsmJs.u));
parcelHelpers.export(exports, "createFilter", ()=>(0, _select49A62830EsmJs.c));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _select49A62830EsmJs.d));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _select49A62830EsmJs.m));
parcelHelpers.export(exports, "components", ()=>(0, _indexA301F526EsmJs.c));
parcelHelpers.export(exports, "NonceProvider", ()=>NonceProvider);
parcelHelpers.export(exports, "default", ()=>StateManagedSelect$1);
var _useStateManager7E1E8489EsmJs = require("./useStateManager-7e1e8489.esm.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _select49A62830EsmJs = require("./Select-49a62830.esm.js");
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _memoizeOne = require("memoize-one");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var StateManagedSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    return /*#__PURE__*/ _react.createElement((0, _select49A62830EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
var NonceProvider = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, _react.useMemo)(function() {
        return (0, _cacheDefault.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement((0, _react1.CacheProvider), {
        value: emotionCache
    }, children);
};

},{"./useStateManager-7e1e8489.esm.js":"DxpkG","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","./Select-49a62830.esm.js":"dKKB5","@emotion/react":"2WHWE","@emotion/cache":"6qnZr","./index-a301f526.esm.js":"gYAEP","@babel/runtime/helpers/objectSpread2":"TY7Mr","@babel/runtime/helpers/slicedToArray":"cSV7V","@babel/runtime/helpers/objectWithoutProperties":"5xa1i","@babel/runtime/helpers/classCallCheck":"6C9u8","@babel/runtime/helpers/createClass":"g9J5L","@babel/runtime/helpers/inherits":"43peb","@babel/runtime/helpers/createSuper":"ayUOk","@babel/runtime/helpers/toConsumableArray":"c2UGM","memoize-one":"jucOx","@babel/runtime/helpers/typeof":"979to","@babel/runtime/helpers/taggedTemplateLiteral":"cpSDa","@babel/runtime/helpers/defineProperty":"hjdoh","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4qfIk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "otaTypes", ()=>otaTypes);
const otaTypes = [
    {
        label: "HFX Flash",
        value: "hfx_flash"
    }
]; // customer OTA types. laid out like select options

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Iydq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleImageFileConversion", ()=>handleImageFileConversion);
parcelHelpers.export(exports, "handleFileRead", ()=>handleFileRead);
function handleImageFileConversion(file, handleError, handleSuccess, MAX_DIMENSION = 150) {
    const reader = new FileReader();
    reader.onerror = (e)=>{
        handleError(e);
        reader.abort();
    };
    reader.onload = (e)=>{
        const image = document.createElement("img");
        image.onload = ()=>{
            const canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            if (image.height > MAX_DIMENSION) {
                image.width *= MAX_DIMENSION / image.height;
                image.height = MAX_DIMENSION;
            } else if (image.width > MAX_DIMENSION) {
                image.height *= MAX_DIMENSION / image.width;
                image.width = MAX_DIMENSION;
            }
            canvas.width = image.width;
            canvas.height = image.height;
            ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            handleSuccess(canvas.toDataURL());
        };
        image.src = e.target.result;
    };
    reader.readAsDataURL(file);
}
function handleFileRead(file, handleError, handleSuccess) {
    const reader = new FileReader();
    reader.onerror = (e)=>{
        handleError(e);
        reader.abort();
    };
    reader.addEventListener("load", ()=>{
        // result will look like "data:*/*;base64," so we get only the base64 string after the comma
        handleSuccess(reader.result.split(",")[1]);
    }, false);
    reader.readAsDataURL(file);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h8yKx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _runCustomerOTAModalDisplay = require("./RunCustomerOTAModalDisplay");
var _runCustomerOTAModalDisplayDefault = parcelHelpers.interopDefault(_runCustomerOTAModalDisplay);
var _staticUUIDs = require("../../Constants/StaticUUIDs");
class RunCustomerOTAModal extends (0, _react.Component) {
    static propTypes = {
        asset: (0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string
        }),
        toggleModal: (0, _propTypesDefault.default).func,
        customerOTAselected: (0, _propTypesDefault.default).shape({
            filename: (0, _propTypesDefault.default).string,
            // just the filename
            displayName: (0, _propTypesDefault.default).string,
            // the filename but maybe truncated for display
            name: (0, _propTypesDefault.default).string,
            // blob storage name
            type: (0, _propTypesDefault.default).string,
            // just the prefix like "hfx_flash"
            typeName: (0, _propTypesDefault.default).string,
            // name found from looking up in our types table
            properties: (0, _propTypesDefault.default).object,
            // from blob storage
            createdOn: (0, _propTypesDefault.default).string // "x ago" string from properties.createdOn time
        })
    };
    static defaultProps = {
        asset: {
            gtemplate: {
                name: ""
            }
        }
    };
    state = {
        error: "",
        canbus: "0",
        executeRequestPending: false,
        setSourceAddress: true
    };
    assetService = new (0, _assetServiceDefault.default)();
    source = (0, _axios.CancelToken).source();
    componentWillUnmount() {
        this.source.cancel();
    }
    handleExecuteCustomerOTA = async (e)=>{
        e.preventDefault();
        this.setState({
            executeRequestPending: true
        });
        try {
            const { asset: { _id: assetID }, customerOTAselected } = this.props;
            switch(customerOTAselected.type){
                default:
                    throw new Error(`unknown job type ${customerOTAselected.type}`);
                case "hfx_flash":
                    {
                        if (this.state.setSourceAddress && !this.state.source_address) throw new Error(`fill in a target source address for HFX flashing`);
                        // source address is hard coded as parameter 0 for hfx_flash jobs
                        // can bus is parameter 1
                        let body;
                        if (!this.state.setSourceAddress) body = {
                            jobParameters: [
                                "any",
                                this.state.canbus
                            ]
                        };
                        else body = {
                            jobParameters: [
                                this.state.source_address,
                                this.state.canbus
                            ]
                        };
                        await this.assetService.executeAssetCommand(assetID, {
                            commandID: (0, _staticUUIDs.HFX_FLASH_JOB_COMMAND_ID),
                            customerOTAfilename: customerOTAselected.filename,
                            customerOTAtype: customerOTAselected.type
                        }, body, this.source.token);
                        this.setState({
                            executeRequestPending: false
                        });
                        this.props.toggleModal();
                    }
            }
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) {
                const error = err.response?.data?.message ?? err.message;
                this.setState({
                    error,
                    executeRequestPending: false
                });
            }
        }
    };
    handlePropUpdate = ({ target: { name, value } })=>{
        this.setState({
            [name]: value
        });
    };
    handleSourceAddressUpdate = (e)=>{
        const { validity, value, name } = e.target;
        if (validity.valid) this.setState({
            [name]: value,
            sourceAddressError: ""
        });
        else {
            const sourceAddressError = "Integer between 0 and 255";
            this.setState({
                sourceAddressError
            });
        }
    };
    handleSetSourceAddress = ()=>{
        this.setState({
            setSourceAddress: !this.state.setSourceAddress
        });
    };
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runCustomerOTAModalDisplayDefault.default), {
            ...this.props,
            ...this.state,
            handleExecuteCustomerOTA: this.handleExecuteCustomerOTA,
            canbus: this.canbus,
            source_address: this.source_address,
            handlePropUpdate: this.handlePropUpdate,
            handleSourceAddressUpdate: this.handleSourceAddressUpdate,
            handleSetSourceAddress: this.handleSetSourceAddress
        });
    }
}
exports.default = RunCustomerOTAModal;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/AssetService":"fL096","./RunCustomerOTAModalDisplay":"1HlG6","../../Constants/StaticUUIDs":"cpjYY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1HlG6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RunCustomerOTAModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
function RunCustomerOTAModalDisplay(props) {
    const { customerOTAselected } = props;
    const { commandControlIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: props.isOpen,
        size: "lg",
        toggle: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "pb-0 border-bottom-0",
                toggle: props.toggleModal,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: commandControlIcon,
                        alt: "command icon",
                        style: {
                            height: "4rem"
                        },
                        className: "jsx-1956239040 img-fluid mx-auto"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-1956239040 mb-0 modal-title-text text-center",
                        children: "Run Customer OTA on gateway"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "p-3 px-md-4 container-fluid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-left text-muted",
                            children: "The OTA file will be downloaded and run by the gateway. status will be reported in the command history tab"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-left text-muted",
                            children: [
                                "selected: ",
                                customerOTAselected.typeName,
                                " ",
                                customerOTAselected.filename,
                                ",",
                                " ",
                                customerOTAselected.properties.contentLength,
                                " bytes, created",
                                " ",
                                customerOTAselected.createdOn,
                                " ago"
                            ]
                        })
                    }),
                    customerOTAselected.type === "hfx_flash" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-5",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-1956239040 col-12 col-md-10",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1956239040 form-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "source_address",
                                        className: "jsx-1956239040 text-muted",
                                        children: "Target CAN Bus"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        "data-for": "can",
                                        "data-tip": "CAN bus for the target HFX module",
                                        className: "jsx-1956239040 col-6 form-group mb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                            name: "canbus",
                                            onBlur: props.handlePropUpdate,
                                            onChange: props.handlePropUpdate,
                                            type: "select",
                                            value: props.canbus,
                                            className: "jsx-1956239040 form-control form-control-sm w-auto",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "0",
                                                    className: "jsx-1956239040",
                                                    children: "can0"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "1",
                                                    className: "jsx-1956239040",
                                                    children: "can1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "2",
                                                    className: "jsx-1956239040",
                                                    children: "can2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                    value: "3",
                                                    className: "jsx-1956239040",
                                                    children: "can3"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-1956239040 col-6 form-group mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                checked: props.setSourceAddress,
                                                id: "isSetSourceAddress",
                                                onChange: props.handleSetSourceAddress,
                                                type: "checkbox",
                                                className: "jsx-1956239040 form-check-input"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "set-source-address",
                                                className: "jsx-1956239040 form-check-label text-text-light-gray",
                                                children: "set source address? (if unset, any HFX module on the bus will be flashed)"
                                            })
                                        ]
                                    }),
                                    props.setSourceAddress ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-1956239040 col-6 form-group mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                htmlFor: "source_address",
                                                className: "jsx-1956239040 text-muted",
                                                children: "Target J1939 Source Address"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                "aria-describedby": "saHelp",
                                                max: "255",
                                                min: "0",
                                                name: "source_address",
                                                onChange: props.handleSourceAddressUpdate,
                                                type: "number",
                                                value: props.source_address,
                                                className: "jsx-1956239040 form-control form-control-sm w-25"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                id: "saHelp",
                                                className: "jsx-1956239040 form-text text-muted",
                                                children: "Source Address for the target HFX module"
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-danger three-quarter-text text-right",
                            children: props.error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "justify-content-between border-0 px-md-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: props.toggleModal,
                        className: "jsx-1956239040 btn btn-outline-secondary px-4 py-0 nine-tenth-text",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: props.handleExecuteCustomerOTA,
                        className: "jsx-1956239040 btn modal-button-submit px-4 py-0 nine-tenth-text",
                        children: props.executeRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            size: "lg"
                        }) : "Execute"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1956239040",
                children: ".modal-title{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-right:-1.5rem;}"
            })
        ]
    });
}
RunCustomerOTAModalDisplay.propTypes = {
    error: (0, _propTypesDefault.default).string,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    canbus: (0, _propTypesDefault.default).number,
    source_address: (0, _propTypesDefault.default).string,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleSourceAddressUpdate: (0, _propTypesDefault.default).func,
    handleExecuteCustomerOTA: (0, _propTypesDefault.default).func,
    executeRequestPending: (0, _propTypesDefault.default).bool,
    setSourceAddress: (0, _propTypesDefault.default).bool,
    handleSetSourceAddress: (0, _propTypesDefault.default).func,
    customerOTAselected: (0, _propTypesDefault.default).shape({
        filename: (0, _propTypesDefault.default).string,
        // just the filename
        displayName: (0, _propTypesDefault.default).string,
        // the filename but maybe truncated for display
        name: (0, _propTypesDefault.default).string,
        // blob storage name
        type: (0, _propTypesDefault.default).string,
        // just the prefix like "hfx_flash"
        typeName: (0, _propTypesDefault.default).string,
        // name found from looking up in our types table
        properties: (0, _propTypesDefault.default).object,
        // from blob storage
        createdOn: (0, _propTypesDefault.default).string // "x ago" string from properties.createdOn time
    })
};
RunCustomerOTAModalDisplay.defaultProps = {};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","../../Context/IconsContext":"lzIpe","../ModalLayout":"2RoDj","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lsL4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _deleteCustomerOTAModalDisplay = require("./DeleteCustomerOTAModalDisplay");
var _deleteCustomerOTAModalDisplayDefault = parcelHelpers.interopDefault(_deleteCustomerOTAModalDisplay);
class DeleteCustomerOTAModal extends (0, _react.Component) {
    static propTypes = {
        asset: (0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            gtemplateID: (0, _propTypesDefault.default).string
        }),
        isOpen: (0, _propTypesDefault.default).bool,
        handleCustomerOTADeleted: (0, _propTypesDefault.default).func,
        toggleModal: (0, _propTypesDefault.default).func,
        customerOTAselected: (0, _propTypesDefault.default).shape({
            filename: (0, _propTypesDefault.default).string,
            // just the filename
            displayName: (0, _propTypesDefault.default).string,
            // the filename but maybe truncated for display
            name: (0, _propTypesDefault.default).string,
            // blob storage name
            type: (0, _propTypesDefault.default).string,
            // just the prefix like "hfx_flash"
            typeName: (0, _propTypesDefault.default).string,
            // name found from looking up in our types table
            properties: (0, _propTypesDefault.default).object,
            // from blob storage
            createdOn: (0, _propTypesDefault.default).string // "x ago" string from properties.createdOn time
        })
    };
    state = {
        error: "",
        deleteRequestPending: false
    };
    assetService = new (0, _assetServiceDefault.default)();
    source = (0, _axios.CancelToken).source();
    componentWillUnmount() {
        this.source.cancel();
    }
    handleCustomerOTADelete = async ()=>{
        this.setState({
            deleteRequestPending: true
        });
        try {
            const { asset: { _id: assetID }, customerOTAselected } = this.props;
            await this.assetService.deleteAssetCustomerOTA(assetID, {
                filename: customerOTAselected.filename,
                type: customerOTAselected.type
            }, this.source.token);
            this.setState({
                deleteRequestPending: false
            }, ()=>{
                this.props.handleCustomerOTADeleted(customerOTAselected);
                this.props.toggleModal();
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            this.setState({
                error,
                deleteRequestPending: false
            });
        }
    };
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteCustomerOTAModalDisplayDefault.default), {
            ...this.props,
            ...this.state,
            handleCustomerOTADelete: this.handleCustomerOTADelete
        });
    }
}
exports.default = DeleteCustomerOTAModal;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/AssetService":"fL096","./DeleteCustomerOTAModalDisplay":"jaoED","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jaoED":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteCustomerOTAModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
function DeleteCustomerOTAModalDisplay(props) {
    const { isOpen, toggleModal, handleCustomerOTADelete, error, deleteRequestPending, customerOTAselected } = props;
    const { commandControlIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: isOpen,
        scrollable: true,
        size: "lg",
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "pb-0 border-bottom-0",
                toggle: props.toggleModal,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: commandControlIcon,
                        alt: "command icon",
                        style: {
                            height: "4rem"
                        },
                        className: "jsx-1956239040 img-fluid mx-auto"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-1956239040 mb-0 modal-title-text text-center",
                        children: "Delete Customer OTA file?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "p-3 px-md-4 container-fluid d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-left text-muted",
                            children: "This will delete this OTA file from platform storage"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 row justify-content-center mt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-left text-muted",
                            children: [
                                "selected: ",
                                customerOTAselected.typeName,
                                " ",
                                customerOTAselected.filename,
                                ",",
                                " ",
                                customerOTAselected.properties.contentLength,
                                " bytes, created",
                                " ",
                                customerOTAselected.createdOn,
                                " ago"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1956239040 flex-fill row justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1956239040 col-12 col-md-10 text-danger text-right",
                            children: error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "justify-content-between border-0 px-md-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-1956239040 btn btn-outline-secondary px-4 py-0 nine-tenth-text",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleCustomerOTADelete,
                        className: "jsx-1956239040 btn btn-danger px-4 py-0 nine-tenth-text",
                        children: deleteRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            size: "lg"
                        }) : "Yes, Delete"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1956239040",
                children: ".modal-title{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-right:-1.5rem;}"
            })
        ]
    });
}
DeleteCustomerOTAModalDisplay.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    handleCustomerOTADelete: (0, _propTypesDefault.default).func,
    error: (0, _propTypesDefault.default).string,
    deleteRequestPending: (0, _propTypesDefault.default).bool,
    customerOTAselected: (0, _propTypesDefault.default).shape({
        filename: (0, _propTypesDefault.default).string,
        // just the filename
        displayName: (0, _propTypesDefault.default).string,
        // the filename but maybe truncated for display
        name: (0, _propTypesDefault.default).string,
        // blob storage name
        type: (0, _propTypesDefault.default).string,
        // just the prefix like "hfx_flash"
        typeName: (0, _propTypesDefault.default).string,
        // name found from looking up in our types table
        properties: (0, _propTypesDefault.default).object,
        // from blob storage
        createdOn: (0, _propTypesDefault.default).string // "x ago" string from properties.createdOn time
    })
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/IconsContext":"lzIpe","../ModalLayout":"2RoDj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TP2ny":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _subDays = require("date-fns/subDays");
var _subDaysDefault = parcelHelpers.interopDefault(_subDays);
var _subMonths = require("date-fns/subMonths");
var _subMonthsDefault = parcelHelpers.interopDefault(_subMonths);
var _subWeeks = require("date-fns/subWeeks");
var _subWeeksDefault = parcelHelpers.interopDefault(_subWeeks);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _signal = require("../../Constants/Signal");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _dashboardSocketContext = require("../../Context/DashboardSocketContext");
var _assetDashboardDisplay = require("./AssetDashboardDisplay");
var _assetDashboardDisplayDefault = parcelHelpers.interopDefault(_assetDashboardDisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(AssetDashboardContainer));
const GRAPH_WIDGETS = new Set([
    (0, _widgetTypes.AREA),
    (0, _widgetTypes.BAR_ENGINE_UTILIZATION),
    (0, _widgetTypes.BAR_FUEL_UTILIZATION),
    (0, _widgetTypes.COLUMN_GRAPH),
    (0, _widgetTypes.GAUGE),
    (0, _widgetTypes.HIGH_BAR),
    (0, _widgetTypes.LINE_GRAPH),
    (0, _widgetTypes.LINE_HIGH_CHART),
    (0, _widgetTypes.PIE),
    (0, _widgetTypes.VERTICAL_COLUMN_GRAPH)
]);
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
const cols = {
    xs: 1,
    sm: 1,
    md: 1,
    lg: 3,
    xl: 3
};
const aggregateIntervalMap = new Map([
    [
        (0, _signal.DAILY),
        "day"
    ],
    [
        (0, _signal.MONTHLY),
        "month"
    ],
    [
        (0, _signal.WEEKLY),
        "week"
    ]
]), initState = {
    dashboardSearchTerm: "",
    dataLoading: true,
    error: "",
    fetchedData: new Map(),
    graphWidgets: [],
    historicalUtilizationData: new Map(),
    layout: [],
    nonGraphWidgets: [],
    signalNamesMap: new Map(),
    signalUnitsMap: new Map(),
    utilizationData: new Map()
}, utilizationWidgetSet = new Set([
    (0, _widgetTypes.TEXT_ENGINE),
    (0, _widgetTypes.TEXT_FUEL)
]);
function AssetDashboardContainer(props, ref) {
    const socket = (0, _react.useContext)((0, _dashboardSocketContext.SocketContext));
    const initDataLoaded = (0, _react.useRef)(false);
    const [state, updateState] = (0, _react.useState)(initState);
    const parseWidgetDataResponse = (0, _react.useCallback)((data, widgets)=>{
        const fetchedData = Object.keys(data || {})?.length ? new Map(Object.entries(data).filter(([key])=>key !== "undefined")) : new Map();
        const { signalNamesMap, signalUnitsMap } = createSignalsMaps(props.asset?.gtemplate?.datapoints, fetchedData);
        const { graphWidgets = [], nonGraphWidgets = [] } = parseWidgetTypes(widgets || []) || {};
        const layout = createGridLayouts(graphWidgets, nonGraphWidgets);
        updateState((prevState)=>({
                ...prevState,
                dataLoading: false,
                fetchedData,
                graphWidgets,
                layout,
                nonGraphWidgets,
                signalNamesMap,
                signalUnitsMap
            }));
    }, [
        props.asset?.gtemplate?.datapoints
    ]), fetchWidgetData = (0, _react.useCallback)(({ dashboardID = props.currentDashboard?._id, widgets = props.widgets } = {})=>{
        try {
            initDataLoaded.current = true;
            if (socket?.disconnected) socket?.connect?.();
            if (!state.dataLoading) updateState((prevState)=>({
                    ...prevState,
                    dataLoading: true
                }));
            socket?.on?.("connect_error", (err)=>{
                throw err;
            })?.on?.("error", (err)=>{
                throw err;
            })?.emit?.("dashboard:initial", {
                dashboardID
            }, (data)=>{
                parseWidgetDataResponse(data, widgets);
            })?.emit?.("dashboard:realtime", {
                dashboardID
            }, ({ error })=>{
                if (error) throw new Error(error.message);
            });
            if (widgets?.some?.(({ type })=>utilizationWidgetSet.has(type))) socket?.emit?.("utilization:static", null, (data)=>{
                const utilizationData = new Map(Object.entries(data || {}).reduce((map, [period, signals])=>map.set(period, signals), new Map()));
                updateState((prevState)=>({
                        ...prevState,
                        utilizationData
                    }));
            });
            if (widgets?.some?.(({ settings })=>settings?.aggregation === (0, _signal.DAILY))) {
                const now = new Date();
                socket?.emit?.("utilization:report", {
                    dateStart: (0, _subDaysDefault.default)(now, 7).toISOString(),
                    dateStop: now.toISOString(),
                    interval: aggregateIntervalMap.get((0, _signal.DAILY))
                }, (data)=>{
                    updateState((prevState)=>{
                        const dailyData = new Map(Object.entries(data || {}).reduce((map, [dateStr, signals])=>map.set(dateStr, signals), new Map()));
                        const historicalUtilizationData = new Map(prevState.historicalUtilizationData).set((0, _signal.DAILY), dailyData);
                        return {
                            ...prevState,
                            historicalUtilizationData
                        };
                    });
                });
            }
            if (widgets?.some?.(({ settings })=>settings?.aggregation === (0, _signal.WEEKLY))) {
                const now = new Date();
                socket?.emit?.("utilization:report", {
                    dateStart: (0, _subWeeksDefault.default)(now, 5).toISOString(),
                    dateStop: now.toISOString(),
                    interval: aggregateIntervalMap.get((0, _signal.WEEKLY))
                }, (data)=>{
                    updateState((prevState)=>{
                        const dailyData = new Map(Object.entries(data || {}).reduce((map, [dateStr, signals])=>map.set(dateStr, signals), new Map()));
                        const historicalUtilizationData = new Map(prevState.historicalUtilizationData).set((0, _signal.WEEKLY), dailyData);
                        return {
                            ...prevState,
                            historicalUtilizationData
                        };
                    });
                });
            }
            if (widgets?.some?.(({ settings })=>settings?.aggregation === (0, _signal.MONTHLY))) {
                const now = new Date();
                socket?.emit?.("utilization:report", {
                    dateStart: (0, _subMonthsDefault.default)(now, 5).toISOString(),
                    dateStop: now.toISOString(),
                    interval: aggregateIntervalMap.get((0, _signal.MONTHLY))
                }, (data)=>{
                    updateState((prevState)=>{
                        const dailyData = new Map(Object.entries(data || {}).reduce((map, [dateStr, signals])=>map.set(dateStr, signals), new Map()));
                        const historicalUtilizationData = new Map(prevState.historicalUtilizationData).set((0, _signal.MONTHLY), dailyData);
                        return {
                            ...prevState,
                            historicalUtilizationData
                        };
                    });
                });
            }
        } catch (err) {
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    dataLoading: false
                }));
        }
    }, [
        parseWidgetDataResponse,
        props.currentDashboard?._id,
        props.widgets,
        socket,
        state.dataLoading
    ]);
    const handlePropUpdate = (0, _react.useCallback)(({ target: { name, value } = {} })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    }, []);
    (0, _react.useImperativeHandle)(ref, ()=>({
            fetchWidgetData
        }));
    (0, _react.useEffect)(()=>{
        if (initDataLoaded?.current) return;
        fetchWidgetData();
    }, [
        fetchWidgetData
    ]);
    return state.dataLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "align-items-center d-flex h-100 jsx-58948489 justify-content-center w-100",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            color: "var(--brand-primary)",
            icon: (0, _freeSolidSvgIcons.faCircleNotch),
            size: "3x",
            spin: true
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDashboardDisplayDefault.default), {
        ...state,
        asset: props.asset,
        breakpoints: breakpoints,
        cols: cols,
        currentDashboard: props.currentDashboard,
        handleAddUsersSave: props.handleAddUsersSave,
        handleChangeCurrentDashboard: props.handleChangeCurrentDashboard,
        handleCommandExecutedFromWidget: props.handleCommandExecutedFromWidget,
        handleDashboardCreated: props.handleDashboardCreated,
        handleDashboardWidgetDeleted: props.handleDashboardWidgetDeleted,
        handleEditDashboardSave: props.handleEditDashboardSave,
        handlePropUpdate: handlePropUpdate,
        handleTemplateDashboardDeleted: props.handleTemplateDashboardDeleted,
        handleWidgetAdded: props.handleWidgetAdded,
        handleWidgetDeleted: props.handleWidgetDeleted,
        handleWidgetUpdated: props.handleWidgetUpdated,
        handleWidgetsUpdate: props.handleWidgetsUpdate,
        showAddUsersModal: props.showAddUsersModal,
        showCreateDashboardModal: props.showCreateDashboardModal,
        showCreateWidgetModal: props.showCreateWidgetModal,
        showDeleteDashboardModal: props.showDeleteDashboardModal,
        showEditDashboardModal: props.showEditDashboardModal,
        showViewTemplateDashboardsModal: props.showViewTemplateDashboardsModal,
        templateDashboards: props.templateDashboards,
        toggleAddUsersModal: props.toggleAddUsersModal,
        toggleCreateDashboardModal: props.toggleCreateDashboardModal,
        toggleCreateWidgetModal: props.toggleCreateWidgetModal,
        toggleDeleteDashboardModal: props.toggleDeleteDashboardModal,
        toggleEditDashboardModal: props.toggleEditDashboardModal,
        toggleViewTemplateDashboardsModal: props.toggleViewTemplateDashboardsModal,
        widgets: props.widgets
    });
}
AssetDashboardContainer.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        dashboard: (0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            isDefault: (0, _propTypesDefault.default).bool,
            name: (0, _propTypesDefault.default).string
        }),
        format: (0, _propTypesDefault.default).string,
        gtemplate: (0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            commands: (0, _propTypesDefault.default).array,
            datapoints: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
            description: (0, _propTypesDefault.default).string,
            links: (0, _propTypesDefault.default).array,
            name: (0, _propTypesDefault.default).string,
            orgID: (0, _propTypesDefault.default).string,
            settings: (0, _propTypesDefault.default).object,
            widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                _id: (0, _propTypesDefault.default).string,
                col: (0, _propTypesDefault.default).number,
                row: (0, _propTypesDefault.default).number,
                settings: (0, _propTypesDefault.default).object,
                sizeX: (0, _propTypesDefault.default).number,
                sizeY: (0, _propTypesDefault.default).number
            }))
        }),
        gtemplateID: (0, _propTypesDefault.default).string,
        shadow: (0, _propTypesDefault.default).object
    }),
    currentDashboard: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplateID: (0, _propTypesDefault.default).string,
        isDefault: (0, _propTypesDefault.default).bool,
        isPrivate: (0, _propTypesDefault.default).bool,
        name: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            col: (0, _propTypesDefault.default).number,
            row: (0, _propTypesDefault.default).number,
            settings: (0, _propTypesDefault.default).object,
            sizeX: (0, _propTypesDefault.default).number,
            sizeY: (0, _propTypesDefault.default).number
        }))
    }),
    handleAddUsersSave: (0, _propTypesDefault.default).func,
    handleChangeCurrentDashboard: (0, _propTypesDefault.default).func,
    handleCommandExecutedFromWidget: (0, _propTypesDefault.default).func,
    handleDashboardCreated: (0, _propTypesDefault.default).func,
    handleDashboardWidgetDeleted: (0, _propTypesDefault.default).func,
    handleEditDashboardSave: (0, _propTypesDefault.default).func,
    handleTemplateDashboardDeleted: (0, _propTypesDefault.default).func,
    handleWidgetAdded: (0, _propTypesDefault.default).func,
    handleWidgetDeleted: (0, _propTypesDefault.default).func,
    handleWidgetUpdated: (0, _propTypesDefault.default).func,
    handleWidgetsUpdate: (0, _propTypesDefault.default).func,
    showAddUsersModal: (0, _propTypesDefault.default).bool,
    showCreateDashboardModal: (0, _propTypesDefault.default).bool,
    showCreateWidgetModal: (0, _propTypesDefault.default).bool,
    showDeleteDashboardModal: (0, _propTypesDefault.default).bool,
    showEditDashboardModal: (0, _propTypesDefault.default).bool,
    showViewTemplateDashboardsModal: (0, _propTypesDefault.default).bool,
    templateDashboards: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplateID: (0, _propTypesDefault.default).string,
        isDefault: (0, _propTypesDefault.default).bool,
        name: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            col: (0, _propTypesDefault.default).number,
            row: (0, _propTypesDefault.default).number,
            settings: (0, _propTypesDefault.default).object,
            sizeX: (0, _propTypesDefault.default).number,
            sizeY: (0, _propTypesDefault.default).number
        }))
    })),
    toggleAddUsersModal: (0, _propTypesDefault.default).func,
    toggleCreateDashboardModal: (0, _propTypesDefault.default).func,
    toggleCreateWidgetModal: (0, _propTypesDefault.default).func,
    toggleDeleteDashboardModal: (0, _propTypesDefault.default).func,
    toggleEditDashboardModal: (0, _propTypesDefault.default).func,
    toggleViewTemplateDashboardsModal: (0, _propTypesDefault.default).func,
    widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        col: (0, _propTypesDefault.default).number,
        row: (0, _propTypesDefault.default).number,
        settings: (0, _propTypesDefault.default).object,
        sizeX: (0, _propTypesDefault.default).number,
        sizeY: (0, _propTypesDefault.default).number
    }))
};
AssetDashboardContainer.defaultProps = {};
function createSignalsMaps(datapoints, fetchedData) {
    const defaultValue = {
        signalUnitsMap: new Map(),
        signalNamesMap: new Map()
    };
    if ((0, _isEmptyDefault.default)(datapoints)) return defaultValue;
    return datapoints.reduce((map, collection)=>{
        if ((0, _isEmptyDefault.default)(collection?.values)) return map;
        const [{ signals } = {}] = fetchedData.get(collection._id) || [];
        const unitsValue = collection.values.reduce((acc, { _id, display_precision, label, name, unit })=>{
            map.signalNamesMap.set(_id, name || label);
            const { uom = "" } = signals?.[_id] || {};
            acc[name || label] = {
                display_precision,
                unit: uom || unit
            };
            return acc;
        }, {});
        map.signalUnitsMap.set(collection._id, unitsValue);
        return map;
    }, {
        signalUnitsMap: new Map(),
        signalNamesMap: new Map()
    });
}
function parseWidgetTypes(widgets) {
    return widgets.reduce((acc, w)=>{
        if (GRAPH_WIDGETS.has(w.type)) acc.graphWidgets.push(w);
        else acc.nonGraphWidgets.push(w);
        return acc;
    }, {
        graphWidgets: [],
        nonGraphWidgets: []
    });
}
function createGridLayouts(graphWidgets, nonGraphWidgets) {
    if (!graphWidgets.length && !nonGraphWidgets.length) return [];
    return [
        ...graphWidgets,
        ...nonGraphWidgets
    ].map((w)=>{
        const { _id, col, row, sizeX, sizeY } = w;
        return {
            i: _id,
            x: col,
            y: row,
            h: sizeY,
            w: sizeX
        };
    });
}

},{"react/jsx-runtime":"1dlk8","date-fns/subDays":"0Vpj8","date-fns/subMonths":"135UL","date-fns/subWeeks":"c1mfa","lodash/isEmpty":"6WyGC","prop-types":"bnNSm","react":"9njXz","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/Signal":"bTf7q","../../Constants/WidgetTypes":"frQz2","../../Context/DashboardSocketContext":"ly197","./AssetDashboardDisplay":"a50Jf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bTf7q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CAN_OPTIONS", ()=>CAN_OPTIONS);
parcelHelpers.export(exports, "FIELD_TYPE_OPTIONS", ()=>FIELD_TYPE_OPTIONS);
parcelHelpers.export(exports, "ENGINE_HOURS", ()=>ENGINE_HOURS);
parcelHelpers.export(exports, "FUEL_USED", ()=>FUEL_USED);
parcelHelpers.export(exports, "IDLE_ENGINE_HOURS", ()=>IDLE_ENGINE_HOURS);
parcelHelpers.export(exports, "IDLE_FUEL_USED", ()=>IDLE_FUEL_USED);
parcelHelpers.export(exports, "REPORTING_TYPE_OPTIONS", ()=>REPORTING_TYPE_OPTIONS);
parcelHelpers.export(exports, "DAILY", ()=>DAILY);
parcelHelpers.export(exports, "LIFETIME", ()=>LIFETIME);
parcelHelpers.export(exports, "MONTHLY", ()=>MONTHLY);
parcelHelpers.export(exports, "WEEKLY", ()=>WEEKLY);
parcelHelpers.export(exports, "SA_TOOLTIP_MESSAGE", ()=>SA_TOOLTIP_MESSAGE);
const CAN_OPTIONS = [
    {
        label: "can0",
        value: "can0"
    },
    {
        label: "can1",
        value: "can1"
    },
    {
        label: "can2",
        value: "can2"
    },
    {
        label: "can3",
        value: "can3"
    }
];
const FIELD_TYPE_OPTIONS = [
    {
        label: "unused",
        value: ""
    },
    {
        label: "uint32 (or smaller uint)",
        value: "uint32"
    },
    {
        label: "uint64",
        value: "uint64"
    },
    {
        label: "int16",
        value: "int16"
    },
    {
        label: "int32",
        value: "int32"
    },
    {
        label: "int64",
        value: "int64"
    },
    {
        label: "float32",
        value: "float32"
    },
    {
        label: "float64",
        value: "float64"
    },
    {
        label: "uint32 (or smaller uint, big endian)",
        value: "uint32-be"
    },
    {
        label: "uint64 (big endian)",
        value: "uint64-be"
    },
    {
        label: "int16 (big endian)",
        value: "int16-be"
    },
    {
        label: "int32 (big endian)",
        value: "int32-be"
    },
    {
        label: "int64 (big endian)",
        value: "int64-be"
    },
    {
        label: "float32 (big endian)",
        value: "float32-be"
    },
    {
        label: "float64 (big endian)",
        value: "float64-be"
    },
    {
        label: "ASCII",
        value: "ascii"
    }
];
const ENGINE_HOURS = "engine_hours";
const FUEL_USED = "fuel_used";
const IDLE_ENGINE_HOURS = "idle_engine_hours";
const IDLE_FUEL_USED = "idle_fuel_used";
const REPORTING_TYPE_OPTIONS = [
    {
        label: ENGINE_HOURS,
        value: ENGINE_HOURS
    },
    {
        label: IDLE_ENGINE_HOURS,
        value: IDLE_ENGINE_HOURS
    },
    {
        label: FUEL_USED,
        value: FUEL_USED
    },
    {
        label: IDLE_FUEL_USED,
        value: IDLE_FUEL_USED
    }
];
const DAILY = "daily";
const LIFETIME = "lifetime";
const MONTHLY = "monthly";
const WEEKLY = "weekly";
const SA_TOOLTIP_MESSAGE = '"Source" field must include can<N>.j1939 value';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"frQz2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AREA", ()=>AREA);
parcelHelpers.export(exports, "BAR_ENGINE_UTILIZATION", ()=>BAR_ENGINE_UTILIZATION);
parcelHelpers.export(exports, "BAR_FUEL_UTILIZATION", ()=>BAR_FUEL_UTILIZATION);
parcelHelpers.export(exports, "BOOLEAN", ()=>BOOLEAN);
parcelHelpers.export(exports, "CAN_SCAN", ()=>CAN_SCAN);
parcelHelpers.export(exports, "COLUMN_GRAPH", ()=>COLUMN_GRAPH);
parcelHelpers.export(exports, "COMMAND", ()=>COMMAND);
parcelHelpers.export(exports, "GAUGE", ()=>GAUGE);
parcelHelpers.export(exports, "GAUGE_RANGE", ()=>GAUGE_RANGE);
parcelHelpers.export(exports, "HIGH_BAR", ()=>HIGH_BAR);
parcelHelpers.export(exports, "IMAGE", ()=>IMAGE);
parcelHelpers.export(exports, "LINE_GRAPH", ()=>LINE_GRAPH);
parcelHelpers.export(exports, "LINE_HIGH_CHART", ()=>LINE_HIGH_CHART);
parcelHelpers.export(exports, "LOCATION", ()=>LOCATION);
parcelHelpers.export(exports, "MAINTENANCE", ()=>MAINTENANCE);
parcelHelpers.export(exports, "MAP", ()=>MAP);
parcelHelpers.export(exports, "PIE", ()=>PIE);
parcelHelpers.export(exports, "TEXT", ()=>TEXT);
parcelHelpers.export(exports, "TEXT_ENGINE", ()=>TEXT_ENGINE);
parcelHelpers.export(exports, "TEXT_FUEL", ()=>TEXT_FUEL);
parcelHelpers.export(exports, "TEXT_STATIC", ()=>TEXT_STATIC);
parcelHelpers.export(exports, "TEXT_TAGS", ()=>TEXT_TAGS);
parcelHelpers.export(exports, "VERTICAL_COLUMN_GRAPH", ()=>VERTICAL_COLUMN_GRAPH);
parcelHelpers.export(exports, "MIN_MAX_TYPE_SET", ()=>MIN_MAX_TYPE_SET);
parcelHelpers.export(exports, "HISTORICAL_UTILIZATION_TYPES", ()=>HISTORICAL_UTILIZATION_TYPES);
const AREA = "area";
const BAR_ENGINE_UTILIZATION = "bar-engine-utilization";
const BAR_FUEL_UTILIZATION = "bar-fuel-utilization";
const BOOLEAN = "boolean";
const CAN_SCAN = "scan";
const COLUMN_GRAPH = "column-graph";
const COMMAND = "command";
const GAUGE = "gauge";
const GAUGE_RANGE = "gauge-range";
const HIGH_BAR = "high-bar";
const IMAGE = "image";
const LINE_GRAPH = "line-graph";
const LINE_HIGH_CHART = "line-high-chart";
const LOCATION = "location";
const MAINTENANCE = "maintenance";
const MAP = "map";
const PIE = "pie";
const TEXT = "text";
const TEXT_ENGINE = "text-engine";
const TEXT_FUEL = "text-fuel";
const TEXT_STATIC = "text-static";
const TEXT_TAGS = "text-tags";
const VERTICAL_COLUMN_GRAPH = "vertical-column-graph";
const MIN_MAX_TYPE_SET = new Set([
    AREA,
    COLUMN_GRAPH,
    HIGH_BAR,
    LINE_GRAPH,
    VERTICAL_COLUMN_GRAPH
]);
const HISTORICAL_UTILIZATION_TYPES = new Set([
    BAR_ENGINE_UTILIZATION,
    BAR_FUEL_UTILIZATION
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a50Jf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactGridLayout = require("react-grid-layout");
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactstrap = require("reactstrap");
var _sessionStorageService = require("../../Services/SessionStorageService");
var _sessionStorageServiceDefault = parcelHelpers.interopDefault(_sessionStorageService);
var _widgetUpdateHelper = require("../../Lib/WidgetUpdateHelper");
var _widgetUpdateHelperDefault = parcelHelpers.interopDefault(_widgetUpdateHelper);
var _rbac = require("../../Constants/RBAC");
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _dashboardSocketContext = require("../../Context/DashboardSocketContext");
var _widgetDisplayContainer = require("./WidgetDisplayContainer");
var _widgetDisplayContainerDefault = parcelHelpers.interopDefault(_widgetDisplayContainer);
var _noDataIndication = require("../NoDataIndication");
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _createTemplateDashboardModal = require("./CreateTemplateDashboardModal");
var _createTemplateDashboardModalDefault = parcelHelpers.interopDefault(_createTemplateDashboardModal);
var _createWidgetModal = require("./CreateWidgetModal");
var _createWidgetModalDefault = parcelHelpers.interopDefault(_createWidgetModal);
var _deleteTemplateDashboardModal = require("./DeleteTemplateDashboardModal");
var _deleteTemplateDashboardModalDefault = parcelHelpers.interopDefault(_deleteTemplateDashboardModal);
var _viewTemplateDashboardsModal = require("./ViewTemplateDashboardsModal");
var _viewTemplateDashboardsModalDefault = parcelHelpers.interopDefault(_viewTemplateDashboardsModal);
var _editDashboardModal = require("./EditDashboardModal");
var _editDashboardModalDefault = parcelHelpers.interopDefault(_editDashboardModal);
var _addDashboardUsersModal = require("./AddDashboardUsersModal");
var _addDashboardUsersModalDefault = parcelHelpers.interopDefault(_addDashboardUsersModal);
var _timeRangeDropdown = require("./AssetTimeFilter/TimeRangeDropdown");
var _timeRangeDropdownDefault = parcelHelpers.interopDefault(_timeRangeDropdown);
var _utils = require("./AssetTimeFilter/utils");
var _customTimeFilterModal = require("./AssetTimeFilter/CustomTimeFilterModal");
var _customTimeFilterModalDefault = parcelHelpers.interopDefault(_customTimeFilterModal);
var _subHours = require("date-fns/subHours");
var _subHoursDefault = parcelHelpers.interopDefault(_subHours);
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetDashboardDisplay);
const ResponsiveGridLayout = (0, _reactGridLayout.WidthProvider)((0, _reactGridLayout.Responsive));
const { className: menuToggleClass, styles: menuToggleStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3296917868",
        children: "button.jsx-3296917868{min-width:15rem;}"
    }),
    className: "jsx-3296917868"
};
const { className: menuClass, styles: menuStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "753048376",
        children: ".dropdown-menu.jsx-753048376{min-width:15rem;}"
    }),
    className: "jsx-753048376"
};
const { className: itemClass, styles: itemStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "489889255",
        children: ".dropdown-item.jsx-489889255:focus{outline:none;}"
    }),
    className: "jsx-489889255"
};
const initState = {
    editingGridLayout: false,
    error: "",
    graphWidgetIDs: [],
    isDraggable: false,
    isResizable: false,
    timeRangeUpdateRealTime: true,
    showCustomFilterModal: false,
    timeFilter: null,
    customStartTimestamp: null,
    customEndTimestamp: null,
    maxDatapoints: null
};
function AssetDashboardDisplay(props) {
    const { asset: { gtemplateID } = {}, currentDashboard, dashboardSearchTerm, graphWidgets, handleWidgetsUpdate, templateDashboards, widgets } = props;
    const widgetsWithTimeFilter = widgets?.filter((w)=>{
        return (0, _utils.isTimeFilterVisible)(w.type, w.settings?.displayTextAsGrid);
    }) || [];
    const displayGlobalTimeFilter = !!widgetsWithTimeFilter.length;
    const [state, setState] = (0, _react.useState)(initState);
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default)), socket = (0, _react.useContext)((0, _dashboardSocketContext.SocketContext));
    const source = (0, _react.useMemo)(()=>(0, _axios.CancelToken).source(), []);
    const filteredDashboards = (0, _react.useMemo)(()=>{
        return templateDashboards.filter(({ _id, name = "" })=>{
            if (_id === currentDashboard?._id) return false;
            if (!dashboardSearchTerm) return true;
            const prunedName = name.toLowerCase().trim();
            const prunedSearch = dashboardSearchTerm.toLowerCase().trim();
            return prunedName.includes(prunedSearch);
        });
    }, [
        currentDashboard,
        dashboardSearchTerm,
        templateDashboards
    ]), graphWidgetIDs = (0, _react.useMemo)(()=>graphWidgets.map(({ _id })=>_id), [
        graphWidgets
    ]), sessionStorageService = (0, _react.useMemo)(()=>new (0, _sessionStorageServiceDefault.default)(), []), widgetUpdateHelper = (0, _react.useMemo)(()=>new (0, _widgetUpdateHelperDefault.default)(), []);
    const handleLayoutChange = (0, _react.useCallback)((layout)=>{
        sessionStorageService.setItem("gridLayout", layout);
        const layoutDictionary = layout.reduce((acc, l)=>{
            acc[l.i] = l;
            return acc;
        }, {});
        const checkForWidgetUpdates = (widget)=>{
            if (widgetUpdateHelper.widgetHasBeenUpdated(layoutDictionary, widget)) {
                const updatedWidget = widgetUpdateHelper.formWidgetLayoutUpdateBody(layoutDictionary, widget);
                widget = {
                    ...updatedWidget,
                    updated: true
                };
            }
            return widget;
        };
        const updates = widgets.map(checkForWidgetUpdates);
        handleWidgetsUpdate(updates);
    }, [
        handleWidgetsUpdate,
        sessionStorageService,
        widgets,
        widgetUpdateHelper
    ]), updateWidgetLayouts = (0, _react.useCallback)(async ()=>{
        try {
            const updatedWidgets = await widgetUpdateHelper.updateGridLayout(widgets, gtemplateID, currentDashboard, source.token);
            handleWidgetsUpdate(updatedWidgets);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            setState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    }, [
        currentDashboard,
        gtemplateID,
        handleWidgetsUpdate,
        source.token,
        widgets,
        widgetUpdateHelper
    ]), handleEditGridToggle = (0, _react.useCallback)((nextState)=>{
        setState((prevState)=>({
                ...prevState,
                editingGridLayout: nextState,
                isDraggable: nextState,
                isResizable: nextState
            }));
        if (!nextState) updateWidgetLayouts();
    }, [
        updateWidgetLayouts
    ]);
    const renderNextGraphWidget = (0, _react.useCallback)((widgetID)=>{
        setState((prevState)=>({
                ...prevState,
                [`render_${widgetID}`]: true
            }));
    }, []);
    const handleTimeRangeFilter = (0, _react.useCallback)((timeFilter)=>{
        if (timeFilter === "custom") return setState((prevState)=>({
                ...prevState,
                showCustomFilterModal: true
            }));
        const customEndTimestamp = Date.now(), customStartTimestamp = (0, _subHoursDefault.default)(customEndTimestamp, timeFilter).getTime();
        setState((prevState)=>({
                ...prevState,
                timeFilter,
                customStartTimestamp,
                customEndTimestamp,
                timeRangeUpdateRealTime: false
            }));
    }, [
        setState
    ]);
    const handleReturnToRealTime = (0, _react.useCallback)(()=>{
        setState((prevState)=>({
                ...prevState,
                customEndTimestamp: null,
                customStartTimestamp: null,
                timeFilter: null,
                timeRangeUpdateRealTime: true
            }));
    }, [
        setState
    ]);
    const handleCustomFilterSaveCallback = (0, _react.useCallback)(({ customEndTimestamp, maxDatapoints, customStartTimestamp })=>{
        setState((prevState)=>({
                ...prevState,
                customEndTimestamp,
                maxDatapoints,
                customStartTimestamp,
                timeFilter: "custom",
                showCustomFilterModal: false,
                timeRangeUpdateRealTime: false
            }));
    }, [
        setState
    ]);
    const toggleCustomFilterModal = (0, _react.useCallback)(()=>{
        setState((prevState)=>({
                ...prevState,
                showCustomFilterModal: !state.showCustomFilterModal
            }));
    }, [
        setState,
        state.showCustomFilterModal
    ]);
    (0, _react.useEffect)(()=>{
        if (!graphWidgetIDs?.length) return;
        setState((prevState)=>({
                ...prevState,
                graphWidgetIDs,
                [`render_${graphWidgetIDs[0]}`]: true
            }));
    }, [
        graphWidgetIDs
    ]);
    (0, _react.useEffect)(()=>source.cancel, [
        source.cancel
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
            [
                "998272971",
                [
                    state.isResizable ? "block" : "none"
                ]
            ]
        ]) + " " + "position-absolute container-fluid h-100 overflow-auto",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                    [
                        "998272971",
                        [
                            state.isResizable ? "block" : "none"
                        ]
                    ]
                ]) + " " + "row d-lg-none",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                        [
                            "998272971",
                            [
                                state.isResizable ? "block" : "none"
                            ]
                        ]
                    ]) + " " + "col-12",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                        className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                            [
                                "998272971",
                                [
                                    state.isResizable ? "block" : "none"
                                ]
                            ]
                        ]) + " " + "mb-0"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                    [
                        "998272971",
                        [
                            state.isResizable ? "block" : "none"
                        ]
                    ]
                ]) + " " + "row d-flex align-items-center justify-content-between justify-content-md-start my-3 mt-lg-0 three-quarter-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                            [
                                "998272971",
                                [
                                    state.isResizable ? "block" : "none"
                                ]
                            ]
                        ]) + " " + "col-auto",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
                            className: "mr-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                    no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                                            className: `${menuToggleClass} text-text-dark d-flex align-items-center justify-content-between shadow-none px-0 py-1`,
                                            color: "none",
                                            disabled: true,
                                            children: currentDashboard?.name ?? "Dashboards"
                                        }),
                                    orgID: props.asset?.orgID,
                                    perform: (0, _rbac.DASHBOARD_READ),
                                    resource: (0, _rbac.DASHBOARD),
                                    yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownToggle), {
                                            className: `${menuToggleClass} text-text-dark d-flex align-items-center justify-content-between shadow-none px-0 py-1`,
                                            color: "none",
                                            children: [
                                                currentDashboard?.name ?? "Dashboards",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    className: "ml-2 pr-0",
                                                    icon: (0, _freeSolidSvgIcons.faChevronDown)
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                                    className: `${menuClass} rounded-lg`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownItem), {
                                            className: "input-group input-group-sm px-2",
                                            header: true,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    "aria-label": "Dashboard Search",
                                                    "aria-describedby": "search-icon",
                                                    name: "dashboardSearchTerm",
                                                    onChange: props.handlePropUpdate,
                                                    placeholder: "Search for dashboards...",
                                                    type: "text",
                                                    value: dashboardSearchTerm,
                                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                                        [
                                                            "998272971",
                                                            [
                                                                state.isResizable ? "block" : "none"
                                                            ]
                                                        ]
                                                    ]) + " " + "form-control rounded-lg"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                                        [
                                                            "998272971",
                                                            [
                                                                state.isResizable ? "block" : "none"
                                                            ]
                                                        ]
                                                    ]) + " " + "input-group-append",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        id: "search-icon",
                                                        className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                                            [
                                                                "998272971",
                                                                [
                                                                    state.isResizable ? "block" : "none"
                                                                ]
                                                            ]
                                                        ]) + " " + "input-group-text bg-transparent border-0 pr-0",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                            className: "text-text-light-gray",
                                                            icon: (0, _freeSolidSvgIcons.faSearch)
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        filteredDashboards.slice(0, 3).map((dashboard, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownItem), {
                                                className: "px-2 text-truncate",
                                                id: `dashboard-${i}`,
                                                onClick: ()=>props.handleChangeCurrentDashboard(dashboard),
                                                children: [
                                                    dashboard.name,
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                                        target: `dashboard-${i}`,
                                                        children: dashboard.name
                                                    })
                                                ]
                                            }, dashboard._id)),
                                        filteredDashboards.length > 3 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                            className: "px-2 three-quarter-text",
                                            onClick: props.toggleViewTemplateDashboardsModal,
                                            children: "Show All"
                                        }) : null,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                            no: ()=>null,
                                            orgID: props.asset?.orgID,
                                            perform: (0, _rbac.DASHBOARD_CREATE),
                                            resource: (0, _rbac.DASHBOARD),
                                            yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                            className: "mt-0",
                                                            divider: true
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownItem), {
                                                            className: props.asset?.gtemplateID ? `${itemClass} px-2` : "d-none",
                                                            onClick: props.toggleCreateDashboardModal,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                    className: "pr-2",
                                                                    icon: (0, _freeSolidSvgIcons.faPlus),
                                                                    size: "lg"
                                                                }),
                                                                "Create New Dashboard"
                                                            ]
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    props.asset?.gtemplateID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                            [
                                "998272971",
                                [
                                    state.isResizable ? "block" : "none"
                                ]
                            ]
                        ]) + " " + `col-auto ${props.currentDashboard?.isPrivate ? "" : "mr-auto mr-md-3"}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                            no: ()=>null,
                            orgID: props.asset?.orgID,
                            perform: (0, _rbac.WIDGET_CREATE),
                            resource: (0, _rbac.DASHBOARD),
                            yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RestrictedCreateButton, {
                                    isDisabled: !props.asset?.gtemplate,
                                    toggleCreateWidgetModal: props.toggleCreateWidgetModal
                                })
                        })
                    }) : null,
                    props.currentDashboard?.isPrivate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: props.currentDashboard?.orgID,
                        perform: (0, _rbac.DASHBOARD_UPDATE),
                        resource: (0, _rbac.DASHBOARD),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                    [
                                        "998272971",
                                        [
                                            state.isResizable ? "block" : "none"
                                        ]
                                    ]
                                ]) + " " + "col-auto mr-auto mr-md-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: props.toggleAddUsersModal,
                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                        [
                                            "998272971",
                                            [
                                                state.isResizable ? "block" : "none"
                                            ]
                                        ]
                                    ]) + " " + "btn btn-sm rounded-lg modal-button-primary py-md-0 px-md-3 three-quarter-text",
                                    children: "Manage Users"
                                })
                            })
                    }) : null,
                    props.asset?.gtemplateID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                            [
                                "998272971",
                                [
                                    state.isResizable ? "block" : "none"
                                ]
                            ]
                        ]) + " " + `d-none ${props.currentDashboard?._id ? "d-lg-block mr-lg-auto col-lg-auto" : "d-none"}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                            no: ()=>null,
                            orgID: props.asset?.orgID,
                            perform: (0, _rbac.WIDGET_GRID_UPDATE),
                            resource: (0, _rbac.DASHBOARD),
                            yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    htmlFor: "edit-grid-toggle",
                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                        [
                                            "998272971",
                                            [
                                                state.isResizable ? "block" : "none"
                                            ]
                                        ]
                                    ]) + " " + "mb-0 d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                                [
                                                    "998272971",
                                                    [
                                                        state.isResizable ? "block" : "none"
                                                    ]
                                                ]
                                            ]) + " " + "mr-2 font-weight-bold",
                                            children: "Edit Grid"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(RestrictedSwitch, {
                                            editingGridLayout: state.editingGridLayout,
                                            handleEditGridToggle: handleEditGridToggle
                                        })
                                    ]
                                })
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeRangeDropdownDefault.default), {
                        forceDisplay: displayGlobalTimeFilter,
                        updateRealTime: state.timeRangeUpdateRealTime,
                        handleTimeRangeFilter: handleTimeRangeFilter,
                        handleReturnToRealTime: handleReturnToRealTime
                    }),
                    currentDashboard?._id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: props.currentDashboard?.orgID,
                        perform: (0, _rbac.DASHBOARD_UPDATE),
                        resource: (0, _rbac.DASHBOARD),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                    [
                                        "998272971",
                                        [
                                            state.isResizable ? "block" : "none"
                                        ]
                                    ]
                                ]) + " " + "col-auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: props.toggleEditDashboardModal,
                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                        [
                                            "998272971",
                                            [
                                                state.isResizable ? "block" : "none"
                                            ]
                                        ]
                                    ]) + " " + "btn btn-link p-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faPencilAlt)
                                    })
                                })
                            })
                    }) : null,
                    currentDashboard?._id && !currentDashboard?.isDefault ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: props.currentDashboard?.orgID,
                        perform: (0, _rbac.DASHBOARD_DELETE),
                        resource: (0, _rbac.DASHBOARD),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                    [
                                        "998272971",
                                        [
                                            state.isResizable ? "block" : "none"
                                        ]
                                    ]
                                ]) + " " + "col-auto pl-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: props.toggleDeleteDashboardModal,
                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                        [
                                            "998272971",
                                            [
                                                state.isResizable ? "block" : "none"
                                            ]
                                        ]
                                    ]) + " " + "btn btn-link text-decoration-none shadow-none text-danger p-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faTrashAlt)
                                    })
                                })
                            })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                    [
                        "998272971",
                        [
                            state.isResizable ? "block" : "none"
                        ]
                    ]
                ]) + " " + ((state.editingGridLayout ? "row justify-content-end" : "d-none") || ""),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                        [
                            "998272971",
                            [
                                state.isResizable ? "block" : "none"
                            ]
                        ]
                    ]) + " " + "col-auto text-right text-muted bg-white rounded mb-2",
                    children: "Click and drag widgets to move them. Drag the corners to resize them. Click the switch again to save!"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                    [
                        "998272971",
                        [
                            state.isResizable ? "block" : "none"
                        ]
                    ]
                ]) + " " + "row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                        [
                            "998272971",
                            [
                                state.isResizable ? "block" : "none"
                            ]
                        ]
                    ]) + " " + "col-12",
                    children: (()=>{
                        switch(true){
                            case !!props.error:
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                        [
                                            "998272971",
                                            [
                                                state.isResizable ? "block" : "none"
                                            ]
                                        ]
                                    ]) + " " + "h-100 w-100 d-flex align-items-center justify-content-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                            [
                                                "998272971",
                                                [
                                                    state.isResizable ? "block" : "none"
                                                ]
                                            ]
                                        ]) + " " + "mb-0 text-danger three-quarter-text",
                                        children: props.error
                                    })
                                });
                            case !!props.layout.length:
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ResponsiveGridLayout, {
                                    breakpoints: props.breakpoints,
                                    cols: props.cols,
                                    draggableHandle: ".draggable",
                                    layouts: {
                                        xs: props.layout,
                                        sm: props.layout,
                                        md: props.layout,
                                        lg: props.layout,
                                        xl: props.layout
                                    },
                                    onLayoutChange: handleLayoutChange,
                                    onResizeStart: handleWidgetResizeStart,
                                    onResizeStop: handleWidgetResizeStop,
                                    rowHeight: 300,
                                    verticalCompact: true,
                                    children: [
                                        props.nonGraphWidgets?.map?.((w)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                id: w._id,
                                                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                                    [
                                                        "998272971",
                                                        [
                                                            state.isResizable ? "block" : "none"
                                                        ]
                                                    ]
                                                ]) + " " + `bg-white widget-outer-container ${state.isDraggable ? "draggable" : "not-draggable"}`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetDisplayContainerDefault.default), {
                                                    asset: props.asset,
                                                    dashboardID: currentDashboard._id,
                                                    fetchCustomRangeUtilizationData: props.fetchCustomRangeUtilizationData,
                                                    fetchedData: props.fetchedData,
                                                    handleCommandExecutedFromWidget: props.handleCommandExecutedFromWidget,
                                                    handleWidgetDeleted: props.handleWidgetDeleted,
                                                    handleWidgetUpdated: props.handleWidgetUpdated,
                                                    historicalUtilizationData: props.historicalUtilizationData,
                                                    signalNamesMap: props.signalNamesMap,
                                                    signalUnitsMap: props.signalUnitsMap,
                                                    socket: socket,
                                                    updateWidgets: props.updateWidgets,
                                                    utilizationData: props.utilizationData,
                                                    widget: w,
                                                    timeFilter: state.timeFilter,
                                                    customStartTimestamp: state.customStartTimestamp,
                                                    customEndTimestamp: state.customEndTimestamp,
                                                    updateRealTime: state.timeRangeUpdateRealTime,
                                                    maxDatapoints: state.maxDatapoints
                                                })
                                            }, w._id)) || null,
                                        props.graphWidgets?.map?.((w, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                id: w._id,
                                                className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                                    [
                                                        "998272971",
                                                        [
                                                            state.isResizable ? "block" : "none"
                                                        ]
                                                    ]
                                                ]) + " " + `bg-white widget-outer-container ${state.isDraggable ? "draggable" : "not-draggable"}`,
                                                children: state[`render_${w._id}`] ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetDisplayContainerDefault.default), {
                                                    asset: props.asset,
                                                    dashboardID: currentDashboard._id,
                                                    fetchCustomRangeUtilizationData: props.fetchCustomRangeUtilizationData,
                                                    fetchedData: props.fetchedData,
                                                    graphIndex: i,
                                                    graphWidgetIDs: state.graphWidgetIDs,
                                                    handleWidgetDeleted: props.handleWidgetDeleted,
                                                    handleWidgetUpdated: props.handleWidgetUpdated,
                                                    historicalUtilizationData: props.historicalUtilizationData,
                                                    renderNextGraph: renderNextGraphWidget,
                                                    signalNamesMap: props.signalNamesMap,
                                                    signalUnitsMap: props.signalUnitsMap,
                                                    socket: socket,
                                                    updateWidgets: props.updateWidgets,
                                                    utilizationData: props.utilizationData,
                                                    widget: w,
                                                    timeFilter: state.timeFilter,
                                                    customStartTimestamp: state.customStartTimestamp,
                                                    customEndTimestamp: state.customEndTimestamp,
                                                    updateRealTime: state.timeRangeUpdateRealTime,
                                                    maxDatapoints: state.maxDatapoints
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                                        [
                                                            "998272971",
                                                            [
                                                                state.isResizable ? "block" : "none"
                                                            ]
                                                        ]
                                                    ]) + " " + "row h-100 align-items-center justify-content-center",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        color: "var(--brand-primary)",
                                                        icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                        size: "2x",
                                                        spin: true
                                                    })
                                                })
                                            }, w._id)) || null
                                    ]
                                });
                            default:
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        height: "15rem"
                                    },
                                    className: "jsx-2920360227 " + (0, _styleDefault.default).dynamic([
                                        [
                                            "998272971",
                                            [
                                                state.isResizable ? "block" : "none"
                                            ]
                                        ]
                                    ]) + " " + "d-flex align-items-center justify-content-center mb-5 mb-md-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.NoItemsExist), {
                                        alt: "empty state",
                                        text: "No smart tiles on this dashboard yet."
                                    })
                                });
                        }
                    })()
                })
            }),
            state.showCustomFilterModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customTimeFilterModalDefault.default), {
                customEndTimestamp: state.customEndTimestamp,
                customStartTimestamp: state.customStartTimestamp,
                showCustomFilterModal: state.showCustomFilterModal,
                handleCustomFilterSaveCallback: handleCustomFilterSaveCallback,
                toggleCustomFilterModal: toggleCustomFilterModal
            }) : null,
            props.showAddUsersModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDashboardUsersModalDefault.default), {
                dashboard: props.currentDashboard,
                handleAddUsersSave: props.handleAddUsersSave,
                isOpen: props.showAddUsersModal,
                toggleModal: props.toggleAddUsersModal
            }) : null,
            props.showCreateDashboardModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createTemplateDashboardModalDefault.default), {
                assetID: props.asset?._id,
                gtemplateID: props.asset?.gtemplateID,
                handleDashboardCreated: props.handleDashboardCreated,
                isOpen: props.showCreateDashboardModal,
                orgID: props.asset?.orgID,
                toggleModal: props.toggleCreateDashboardModal
            }) : null,
            props.showCreateWidgetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWidgetModalDefault.default), {
                asset: props.asset,
                currentOrg: currentOrg,
                dashboardID: currentDashboard._id,
                isOpen: props.showCreateWidgetModal,
                toggleModal: props.toggleCreateWidgetModal,
                updateWidgets: props.handleWidgetAdded
            }) : null,
            props.showDeleteDashboardModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteTemplateDashboardModalDefault.default), {
                dashboard: currentDashboard,
                gtemplateID: props.asset?.gtemplateID,
                handleDashboardDeleted: props.handleTemplateDashboardDeleted,
                isOpen: props.showDeleteDashboardModal,
                toggleModal: props.toggleDeleteDashboardModal
            }) : null,
            props.showEditDashboardModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editDashboardModalDefault.default), {
                assetID: props.asset?._id,
                dashboard: currentDashboard,
                handleEditDashboardSave: props.handleEditDashboardSave,
                isOpen: props.showEditDashboardModal,
                toggleModal: props.toggleEditDashboardModal
            }) : null,
            props.showViewTemplateDashboardsModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _viewTemplateDashboardsModalDefault.default), {
                dashboardSearchTerm: dashboardSearchTerm,
                handleDashboardSelected: props.handleChangeCurrentDashboard,
                isOpen: props.showViewTemplateDashboardsModal,
                templateDashboards: templateDashboards,
                toggleModal: props.toggleViewTemplateDashboardsModal
            }) : null,
            menuToggleStyles,
            menuStyles,
            itemStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2920360227",
                children: ".btn.jsx-2920360227:focus{outline:none !important;}.widget-outer-container.jsx-2920360227{border-radius:1rem;}"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "998272971",
                dynamic: [
                    state.isResizable ? "block" : "none"
                ],
                children: `.react-resizable-handle{bottom:0;cursor:se-resize;display:${state.isResizable ? "block" : "none"};height:20px;right:0;position:absolute;width:20px;}.react-resizable-handle:after{border-bottom:5px solid var(--alert-confirmation);border-radius:3px;border-right:5px solid var(--alert-confirmation);bottom:5px;content:'';height:20px;position:absolute;right:5px;width:20px;}`
            })
        ]
    });
}
AssetDashboardDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplate: (0, _propTypesDefault.default).object,
        gtemplateID: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    }),
    breakpoints: (0, _propTypesDefault.default).shape({
        xs: (0, _propTypesDefault.default).number,
        sm: (0, _propTypesDefault.default).number,
        md: (0, _propTypesDefault.default).number,
        lg: (0, _propTypesDefault.default).number,
        xl: (0, _propTypesDefault.default).number
    }),
    cols: (0, _propTypesDefault.default).shape({
        xs: (0, _propTypesDefault.default).number,
        sm: (0, _propTypesDefault.default).number,
        md: (0, _propTypesDefault.default).number,
        lg: (0, _propTypesDefault.default).number,
        xl: (0, _propTypesDefault.default).number
    }),
    currentDashboard: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplateID: (0, _propTypesDefault.default).string,
        isDefault: (0, _propTypesDefault.default).bool,
        isPrivate: (0, _propTypesDefault.default).bool,
        name: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            col: (0, _propTypesDefault.default).number,
            row: (0, _propTypesDefault.default).number,
            settings: (0, _propTypesDefault.default).object,
            sizeX: (0, _propTypesDefault.default).number,
            sizeY: (0, _propTypesDefault.default).number
        }))
    }),
    dashboardSearchTerm: (0, _propTypesDefault.default).string,
    dataLoading: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    fetchCustomRangeUtilizationData: (0, _propTypesDefault.default).func,
    fetchedData: (0, _propTypesDefault.default).object,
    graphWidgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    handleAddUsersSave: (0, _propTypesDefault.default).func,
    handleChangeCurrentDashboard: (0, _propTypesDefault.default).func,
    handleCommandExecutedFromWidget: (0, _propTypesDefault.default).func,
    handleDashboardCreated: (0, _propTypesDefault.default).func,
    handleEditDashboardSave: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleTemplateDashboardDeleted: (0, _propTypesDefault.default).func,
    handleWidgetAdded: (0, _propTypesDefault.default).func,
    handleWidgetDeleted: (0, _propTypesDefault.default).func,
    handleWidgetUpdated: (0, _propTypesDefault.default).func,
    handleWidgetsUpdate: (0, _propTypesDefault.default).func,
    historicalUtilizationData: (0, _propTypesDefault.default).object,
    layout: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        i: (0, _propTypesDefault.default).string,
        x: (0, _propTypesDefault.default).number,
        y: (0, _propTypesDefault.default).number,
        h: (0, _propTypesDefault.default).number,
        w: (0, _propTypesDefault.default).number
    })),
    nonGraphWidgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    showAddUsersModal: (0, _propTypesDefault.default).bool,
    showCreateDashboardModal: (0, _propTypesDefault.default).bool,
    showCreateWidgetModal: (0, _propTypesDefault.default).bool,
    showDeleteDashboardModal: (0, _propTypesDefault.default).bool,
    showEditDashboardModal: (0, _propTypesDefault.default).bool,
    showViewTemplateDashboardsModal: (0, _propTypesDefault.default).bool,
    signalNamesMap: (0, _propTypesDefault.default).object,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    templateDashboards: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplateID: (0, _propTypesDefault.default).string,
        isDefault: (0, _propTypesDefault.default).bool,
        name: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            col: (0, _propTypesDefault.default).number,
            row: (0, _propTypesDefault.default).number,
            settings: (0, _propTypesDefault.default).object,
            sizeX: (0, _propTypesDefault.default).number,
            sizeY: (0, _propTypesDefault.default).number
        }))
    })),
    toggleAddUsersModal: (0, _propTypesDefault.default).func,
    toggleCreateDashboardModal: (0, _propTypesDefault.default).func,
    toggleCreateWidgetModal: (0, _propTypesDefault.default).func,
    toggleDeleteDashboardModal: (0, _propTypesDefault.default).func,
    toggleEditDashboardModal: (0, _propTypesDefault.default).func,
    toggleViewTemplateDashboardsModal: (0, _propTypesDefault.default).func,
    updateWidgets: (0, _propTypesDefault.default).func,
    utilizationData: (0, _propTypesDefault.default).object,
    widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
};
AssetDashboardDisplay.defaultProps = {
    graphWidgets: [],
    layout: [],
    templateDashboards: []
};
function RestrictedCreateButton(props) {
    const conditionallyDisabled = props.isDisabled ? {
        disabled: true
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        ...conditionallyDisabled,
        onClick: props.toggleCreateWidgetModal,
        className: "jsx-907359250 btn btn-sm rounded-lg modal-button-primary py-md-0 px-md-3 three-quarter-text d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                icon: (0, _freeSolidSvgIcons.faPlus)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "jsx-907359250 d-none d-md-block ml-md-2",
                children: "New Smart Tile"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "907359250",
                children: ".btn.jsx-907359250:focus{outline:none;}"
            })
        ]
    });
}
RestrictedCreateButton.propTypes = {
    isDisabled: (0, _propTypesDefault.default).bool,
    toggleCreateWidgetModal: (0, _propTypesDefault.default).func
};
function RestrictedSwitch(props) {
    const { primary_alert } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const conditionallyDisabled = props.isDisabled ? {
        disabled: true
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
        ...conditionallyDisabled,
        onChange: props.handleEditGridToggle,
        checked: props.editingGridLayout,
        checkedIcon: false,
        uncheckedIcon: false,
        height: 15,
        width: 30,
        onColor: primary_alert,
        id: "edit-grid-toggle"
    });
}
RestrictedSwitch.propTypes = {
    editingGridLayout: (0, _propTypesDefault.default).bool,
    handleEditGridToggle: (0, _propTypesDefault.default).func,
    isDisabled: (0, _propTypesDefault.default).bool
};
RestrictedSwitch.defaultProps = {
    handleEditGridToggle: ()=>{}
};
function handleWidgetResizeStart(...allArgs) {
    const detail = {
        detail: {
            resize: true,
            id: allArgs[1].i
        }
    };
    const event = new CustomEvent("resize", detail);
    window.dispatchEvent(event);
}
function handleWidgetResizeStop(...allArgs) {
    const detail = {
        detail: {
            resize: false,
            id: allArgs[1].i
        }
    };
    const event = new CustomEvent("resize", detail);
    window.dispatchEvent(event);
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","react-grid-layout":"9R1hF","react-switch":"7hX7V","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","reactstrap":"kjd7g","../../Services/SessionStorageService":"kNRx3","../../Lib/WidgetUpdateHelper":"6sUgi","../../Constants/RBAC":"ieo1E","../../Context/BrandingContext":"bKKTd","../../Context/CurrentOrgContext":"jQXcJ","../../Context/DashboardSocketContext":"ly197","./WidgetDisplayContainer":"3pRgR","../NoDataIndication":"clGpp","../../RBAC/Can":"l4l8D","./CreateTemplateDashboardModal":"10CFi","./CreateWidgetModal":"6vBt9","./DeleteTemplateDashboardModal":"hjFjB","./ViewTemplateDashboardsModal":"5Si3l","./EditDashboardModal":"gT2rI","./AddDashboardUsersModal":"6nPcI","./AssetTimeFilter/TimeRangeDropdown":"6jqy0","./AssetTimeFilter/utils":"dnj44","./AssetTimeFilter/CustomTimeFilterModal":"8a27C","date-fns/subHours":"jSfbp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9R1hF":[function(require,module,exports) {
module.exports = require("6f263ff4f450f748").default;
module.exports.utils = require("e6314e18256c1382");
module.exports.Responsive = require("c42febc4fc3c99e2").default;
module.exports.Responsive.utils = require("9dd34df1a5567ffa");
module.exports.WidthProvider = require("9eb2c2318bc2e9e2").default;

},{"6f263ff4f450f748":"9TfNa","e6314e18256c1382":"cVeAG","c42febc4fc3c99e2":"4lgsw","9dd34df1a5567ffa":"lxM8B","9eb2c2318bc2e9e2":"eUSGn"}],"9TfNa":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("409273444d54d2e6"));
var _lodash = _interopRequireDefault(require("3338709fa731add5"));
var _clsx = _interopRequireDefault(require("4773afa329a201de"));
var _utils = require("b76a978504eb07e");
var _calculateUtils = require("febfe73b7c2bfcfb");
var _GridItem = _interopRequireDefault(require("6250ac3f7be359ba"));
var _ReactGridLayoutPropTypes = _interopRequireDefault(require("fb2346cfe785b8c2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// End Types
var layoutClassName = "react-grid-layout";
var isFirefox = false; // Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ var ReactGridLayout = /*#__PURE__*/ function(_React$Component) {
    _inherits(ReactGridLayout, _React$Component);
    var _super = _createSuper(ReactGridLayout);
    function ReactGridLayout() {
        var _this;
        _classCallCheck(this, ReactGridLayout);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            activeDrag: null,
            layout: (0, _utils.synchronizeLayoutWithChildren)(_this.props.layout, _this.props.children, _this.props.cols, (0, _utils.compactType)(_this.props), _this.props.allowOverlap),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            droppingDOMNode: null,
            children: []
        });
        _defineProperty(_assertThisInitialized(_this), "dragEnterCounter", 0);
        _defineProperty(_assertThisInitialized(_this), "onDragStart", function(i, x, y, _ref) {
            var e = _ref.e, node = _ref.node;
            var layout = _this.state.layout;
            var l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return;
            _this.setState({
                oldDragItem: (0, _utils.cloneLayoutItem)(l),
                oldLayout: layout
            });
            return _this.props.onDragStart(layout, l, l, null, e, node);
        });
        _defineProperty(_assertThisInitialized(_this), "onDrag", function(i, x, y, _ref2) {
            var e = _ref2.e, node = _ref2.node;
            var oldDragItem = _this.state.oldDragItem;
            var layout = _this.state.layout;
            var _this$props = _this.props, cols = _this$props.cols, allowOverlap = _this$props.allowOverlap, preventCollision = _this$props.preventCollision;
            var l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return; // Create placeholder (display only)
            var placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            }; // Move the element to the dragged location.
            var isUserAction = true;
            layout = (0, _utils.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, _utils.compactType)(_this.props), cols, allowOverlap);
            _this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
            _this.setState({
                layout: allowOverlap ? layout : (0, _utils.compact)(layout, (0, _utils.compactType)(_this.props), cols),
                activeDrag: placeholder
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onDragStop", function(i, x, y, _ref3) {
            var e = _ref3.e, node = _ref3.node;
            if (!_this.state.activeDrag) return;
            var oldDragItem = _this.state.oldDragItem;
            var layout = _this.state.layout;
            var _this$props2 = _this.props, cols = _this$props2.cols, preventCollision = _this$props2.preventCollision, allowOverlap = _this$props2.allowOverlap;
            var l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return; // Move the element here
            var isUserAction = true;
            layout = (0, _utils.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, _utils.compactType)(_this.props), cols, allowOverlap);
            _this.props.onDragStop(layout, oldDragItem, l, null, e, node); // Set state
            var newLayout = allowOverlap ? layout : (0, _utils.compact)(layout, (0, _utils.compactType)(_this.props), cols);
            var oldLayout = _this.state.oldLayout;
            _this.setState({
                activeDrag: null,
                layout: newLayout,
                oldDragItem: null,
                oldLayout: null
            });
            _this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        _defineProperty(_assertThisInitialized(_this), "onResizeStart", function(i, w, h, _ref4) {
            var e = _ref4.e, node = _ref4.node;
            var layout = _this.state.layout;
            var l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return;
            _this.setState({
                oldResizeItem: (0, _utils.cloneLayoutItem)(l),
                oldLayout: _this.state.layout
            });
            _this.props.onResizeStart(layout, l, l, null, e, node);
        });
        _defineProperty(_assertThisInitialized(_this), "onResize", function(i, w, h, _ref5) {
            var e = _ref5.e, node = _ref5.node;
            var _this$state = _this.state, layout = _this$state.layout, oldResizeItem = _this$state.oldResizeItem;
            var _this$props3 = _this.props, cols = _this$props3.cols, preventCollision = _this$props3.preventCollision, allowOverlap = _this$props3.allowOverlap;
            var _withLayoutItem = (0, _utils.withLayoutItem)(layout, i, function(l) {
                // Something like quad tree should be used
                // to find collisions faster
                var hasCollisions;
                if (preventCollision && !allowOverlap) {
                    var collisions = (0, _utils.getAllCollisions)(layout, _objectSpread(_objectSpread({}, l), {}, {
                        w: w,
                        h: h
                    })).filter(function(layoutItem) {
                        return layoutItem.i !== l.i;
                    });
                    hasCollisions = collisions.length > 0; // If we're colliding, we need adjust the placeholder.
                    // If we're colliding, we need adjust the placeholder.
                    if (hasCollisions) {
                        // adjust w && h to maximum allowed space
                        var leastX = Infinity, leastY = Infinity;
                        collisions.forEach(function(layoutItem) {
                            if (layoutItem.x > l.x) leastX = Math.min(leastX, layoutItem.x);
                            if (layoutItem.y > l.y) leastY = Math.min(leastY, layoutItem.y);
                        });
                        if (Number.isFinite(leastX)) l.w = leastX - l.x;
                        if (Number.isFinite(leastY)) l.h = leastY - l.y;
                    }
                }
                if (!hasCollisions) {
                    // Set new width and height.
                    l.w = w;
                    l.h = h;
                }
                return l;
            }), _withLayoutItem2 = _slicedToArray(_withLayoutItem, 2), newLayout = _withLayoutItem2[0], l = _withLayoutItem2[1]; // Shouldn't ever happen, but typechecking makes it necessary
            if (!l) return; // Create placeholder element (display only)
            var placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                static: true,
                i: i
            };
            _this.props.onResize(newLayout, oldResizeItem, l, placeholder, e, node); // Re-compact the newLayout and set the drag placeholder.
            _this.setState({
                layout: allowOverlap ? newLayout : (0, _utils.compact)(newLayout, (0, _utils.compactType)(_this.props), cols),
                activeDrag: placeholder
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onResizeStop", function(i, w, h, _ref6) {
            var e = _ref6.e, node = _ref6.node;
            var _this$state2 = _this.state, layout = _this$state2.layout, oldResizeItem = _this$state2.oldResizeItem;
            var _this$props4 = _this.props, cols = _this$props4.cols, allowOverlap = _this$props4.allowOverlap;
            var l = (0, _utils.getLayoutItem)(layout, i);
            _this.props.onResizeStop(layout, oldResizeItem, l, null, e, node); // Set state
            var newLayout = allowOverlap ? layout : (0, _utils.compact)(layout, (0, _utils.compactType)(_this.props), cols);
            var oldLayout = _this.state.oldLayout;
            _this.setState({
                activeDrag: null,
                layout: newLayout,
                oldResizeItem: null,
                oldLayout: null
            });
            _this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        _defineProperty(_assertThisInitialized(_this), "onDragOver", function(e) {
            var _e$nativeEvent$target;
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation(); // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if (isFirefox && // $FlowIgnore can't figure this out
            !((_e$nativeEvent$target = e.nativeEvent.target) !== null && _e$nativeEvent$target !== void 0 && _e$nativeEvent$target.classList.contains(layoutClassName))) return false;
            var _this$props5 = _this.props, droppingItem = _this$props5.droppingItem, onDropDragOver = _this$props5.onDropDragOver, margin = _this$props5.margin, cols = _this$props5.cols, rowHeight = _this$props5.rowHeight, maxRows = _this$props5.maxRows, width = _this$props5.width, containerPadding = _this$props5.containerPadding, transformScale = _this$props5.transformScale; // Allow user to customize the dropping item or short-circuit the drop based on the results
            // of the `onDragOver(e: Event)` callback.
            var onDragOverResult = onDropDragOver === null || onDropDragOver === void 0 ? void 0 : onDropDragOver(e);
            if (onDragOverResult === false) {
                if (_this.state.droppingDOMNode) _this.removeDroppingPlaceholder();
                return false;
            }
            var finalDroppingItem = _objectSpread(_objectSpread({}, droppingItem), onDragOverResult);
            var layout = _this.state.layout; // This is relative to the DOM element that this event fired for.
            var _e$nativeEvent = e.nativeEvent, layerX = _e$nativeEvent.layerX, layerY = _e$nativeEvent.layerY;
            var droppingPosition = {
                left: layerX / transformScale,
                top: layerY / transformScale,
                e: e
            };
            if (!_this.state.droppingDOMNode) {
                var positionParams = {
                    cols: cols,
                    margin: margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                var calculatedPosition = (0, _calculateUtils.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
                _this.setState({
                    droppingDOMNode: /*#__PURE__*/ React.createElement("div", {
                        key: finalDroppingItem.i
                    }),
                    droppingPosition: droppingPosition,
                    layout: [].concat(_toConsumableArray(layout), [
                        _objectSpread(_objectSpread({}, finalDroppingItem), {}, {
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        })
                    ])
                });
            } else if (_this.state.droppingPosition) {
                var _this$state$droppingP = _this.state.droppingPosition, left = _this$state$droppingP.left, top = _this$state$droppingP.top;
                var shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) _this.setState({
                    droppingPosition: droppingPosition
                });
            }
        });
        _defineProperty(_assertThisInitialized(_this), "removeDroppingPlaceholder", function() {
            var _this$props6 = _this.props, droppingItem = _this$props6.droppingItem, cols = _this$props6.cols;
            var layout = _this.state.layout;
            var newLayout = (0, _utils.compact)(layout.filter(function(l) {
                return l.i !== droppingItem.i;
            }), (0, _utils.compactType)(_this.props), cols);
            _this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onDragLeave", function(e) {
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            _this.dragEnterCounter--; // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (_this.dragEnterCounter === 0) _this.removeDroppingPlaceholder();
        });
        _defineProperty(_assertThisInitialized(_this), "onDragEnter", function(e) {
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            _this.dragEnterCounter++;
        });
        _defineProperty(_assertThisInitialized(_this), "onDrop", function(e) {
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            var droppingItem = _this.props.droppingItem;
            var layout = _this.state.layout;
            var item = layout.find(function(l) {
                return l.i === droppingItem.i;
            }); // reset dragEnter counter on drop
            _this.dragEnterCounter = 0;
            _this.removeDroppingPlaceholder();
            _this.props.onDrop(layout, item, e);
        });
        return _this;
    }
    _createClass(ReactGridLayout, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    mounted: true
                }); // Possibly call back with layout on mount. This should be done after correcting the layout width
                // to ensure we don't rerender with the wrong width.
                this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) /*: boolean*/ {
                return(// from SCU is if the user intentionally memoizes children. If they do, and they can
                // handle changes properly, performance will increase.
                this.props.children !== nextProps.children || !(0, _utils.fastRGLPropsEqual)(this.props, nextProps, _lodash.default) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!this.state.activeDrag) {
                    var newLayout = this.state.layout;
                    var oldLayout = prevState.layout;
                    this.onLayoutMaybeChanged(newLayout, oldLayout);
                }
            }
        },
        {
            key: "containerHeight",
            value: function containerHeight() /*: ?string*/ {
                if (!this.props.autoSize) return;
                var nbRow = (0, _utils.bottom)(this.state.layout);
                var containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
                return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
            }
        },
        {
            key: "onLayoutMaybeChanged",
            value: function onLayoutMaybeChanged(newLayout, oldLayout) {
                if (!oldLayout) oldLayout = this.state.layout;
                if (!(0, _lodash.default)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
            }
        },
        {
            key: "placeholder",
            value: /**
     * Create a placeholder object.
     * @return {Element} Placeholder div.
     */ function placeholder() /*: ?ReactElement<any>*/ {
                var activeDrag = this.state.activeDrag;
                if (!activeDrag) return null;
                var _this$props7 = this.props, width = _this$props7.width, cols = _this$props7.cols, margin = _this$props7.margin, containerPadding = _this$props7.containerPadding, rowHeight = _this$props7.rowHeight, maxRows = _this$props7.maxRows, useCSSTransforms = _this$props7.useCSSTransforms, transformScale = _this$props7.transformScale; // {...this.state.activeDrag} is pretty slow, actually
                return /*#__PURE__*/ React.createElement(_GridItem.default, {
                    w: activeDrag.w,
                    h: activeDrag.h,
                    x: activeDrag.x,
                    y: activeDrag.y,
                    i: activeDrag.i,
                    className: "react-grid-placeholder",
                    containerWidth: width,
                    cols: cols,
                    margin: margin,
                    containerPadding: containerPadding || margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    isDraggable: false,
                    isResizable: false,
                    isBounded: false,
                    useCSSTransforms: useCSSTransforms,
                    transformScale: transformScale
                }, /*#__PURE__*/ React.createElement("div", null));
            }
        },
        {
            key: "processGridItem",
            value: function processGridItem(child, isDroppingItem) /*: ?ReactElement<any>*/ {
                if (!child || !child.key) return;
                var l = (0, _utils.getLayoutItem)(this.state.layout, String(child.key));
                if (!l) return null;
                var _this$props8 = this.props, width = _this$props8.width, cols = _this$props8.cols, margin = _this$props8.margin, containerPadding = _this$props8.containerPadding, rowHeight = _this$props8.rowHeight, maxRows = _this$props8.maxRows, isDraggable = _this$props8.isDraggable, isResizable = _this$props8.isResizable, isBounded = _this$props8.isBounded, useCSSTransforms = _this$props8.useCSSTransforms, transformScale = _this$props8.transformScale, draggableCancel = _this$props8.draggableCancel, draggableHandle = _this$props8.draggableHandle, resizeHandles = _this$props8.resizeHandles, resizeHandle = _this$props8.resizeHandle;
                var _this$state3 = this.state, mounted = _this$state3.mounted, droppingPosition = _this$state3.droppingPosition; // Determine user manipulations possible.
                // If an item is static, it can't be manipulated by default.
                // Any properties defined directly on the grid item will take precedence.
                var draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
                var resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
                var resizeHandlesOptions = l.resizeHandles || resizeHandles; // isBounded set on child if set on parent, and child is not explicitly false
                var bounded = draggable && isBounded && l.isBounded !== false;
                return /*#__PURE__*/ React.createElement(_GridItem.default, {
                    containerWidth: width,
                    cols: cols,
                    margin: margin,
                    containerPadding: containerPadding || margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    cancel: draggableCancel,
                    handle: draggableHandle,
                    onDragStop: this.onDragStop,
                    onDragStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onResizeStart: this.onResizeStart,
                    onResize: this.onResize,
                    onResizeStop: this.onResizeStop,
                    isDraggable: draggable,
                    isResizable: resizable,
                    isBounded: bounded,
                    useCSSTransforms: useCSSTransforms && mounted,
                    usePercentages: !mounted,
                    transformScale: transformScale,
                    w: l.w,
                    h: l.h,
                    x: l.x,
                    y: l.y,
                    i: l.i,
                    minH: l.minH,
                    minW: l.minW,
                    maxH: l.maxH,
                    maxW: l.maxW,
                    static: l.static,
                    droppingPosition: isDroppingItem ? droppingPosition : undefined,
                    resizeHandles: resizeHandlesOptions,
                    resizeHandle: resizeHandle
                }, child);
            } // Called while dragging an element. Part of browser native drag/drop API.
        },
        {
            key: "render",
            value: function render() /*: React.Element<"div">*/ {
                var _this2 = this;
                var _this$props9 = this.props, className = _this$props9.className, style = _this$props9.style, isDroppable = _this$props9.isDroppable, innerRef = _this$props9.innerRef;
                var mergedClassName = (0, _clsx.default)(layoutClassName, className);
                var mergedStyle = _objectSpread({
                    height: this.containerHeight()
                }, style);
                return /*#__PURE__*/ React.createElement("div", {
                    ref: innerRef,
                    className: mergedClassName,
                    style: mergedStyle,
                    onDrop: isDroppable ? this.onDrop : _utils.noop,
                    onDragLeave: isDroppable ? this.onDragLeave : _utils.noop,
                    onDragEnter: isDroppable ? this.onDragEnter : _utils.noop,
                    onDragOver: isDroppable ? this.onDragOver : _utils.noop
                }, React.Children.map(this.props.children, function(child) {
                    return _this2.processGridItem(child);
                }), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) /*: $Shape<State> | null*/ {
                var newLayoutBase;
                if (prevState.activeDrag) return null;
                 // Legacy support for compactType
                // Allow parent to set layout directly.
                if (!(0, _lodash.default)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
                else if (!(0, _utils.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
                // as the base in case because it may be more up to date than
                // what is in props.
                newLayoutBase = prevState.layout;
                 // We need to regenerate the layout.
                if (newLayoutBase) {
                    var newLayout = (0, _utils.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, _utils.compactType)(nextProps), nextProps.allowOverlap);
                    return {
                        layout: newLayout,
                        // We need to save these props to state for using
                        // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                        compactType: nextProps.compactType,
                        children: nextProps.children,
                        propsLayout: nextProps.layout
                    };
                }
                return null;
            }
        }
    ]);
    return ReactGridLayout;
}(React.Component);
exports.default = ReactGridLayout;
_defineProperty(ReactGridLayout, "displayName", "ReactGridLayout");
_defineProperty(ReactGridLayout, "propTypes", _ReactGridLayoutPropTypes.default);
_defineProperty(ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    allowOverlap: false,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: _utils.noop,
    onDragStart: _utils.noop,
    onDrag: _utils.noop,
    onDragStop: _utils.noop,
    onResizeStart: _utils.noop,
    onResize: _utils.noop,
    onResizeStop: _utils.noop,
    onDrop: _utils.noop,
    onDropDragOver: _utils.noop
});

},{"409273444d54d2e6":"9njXz","3338709fa731add5":"heWiN","4773afa329a201de":"5PNR8","b76a978504eb07e":"cVeAG","febfe73b7c2bfcfb":"124H5","6250ac3f7be359ba":"bBZma","fb2346cfe785b8c2":"aMAHM"}],"heWiN":[function(require,module,exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var global = arguments[3];
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

},{}],"5PNR8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVeAG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bottom = bottom;
exports.childrenEqual = childrenEqual;
exports.cloneLayout = cloneLayout;
exports.cloneLayoutItem = cloneLayoutItem;
exports.collides = collides;
exports.compact = compact;
exports.compactItem = compactItem;
exports.compactType = compactType;
exports.correctBounds = correctBounds;
exports.fastPositionEqual = fastPositionEqual;
exports.fastRGLPropsEqual = void 0;
exports.getAllCollisions = getAllCollisions;
exports.getFirstCollision = getFirstCollision;
exports.getLayoutItem = getLayoutItem;
exports.getStatics = getStatics;
exports.modifyLayout = modifyLayout;
exports.moveElement = moveElement;
exports.moveElementAwayFromCollision = moveElementAwayFromCollision;
exports.noop = void 0;
exports.perc = perc;
exports.setTopLeft = setTopLeft;
exports.setTransform = setTransform;
exports.sortLayoutItems = sortLayoutItems;
exports.sortLayoutItemsByColRow = sortLayoutItemsByColRow;
exports.sortLayoutItemsByRowCol = sortLayoutItemsByRowCol;
exports.synchronizeLayoutWithChildren = synchronizeLayoutWithChildren;
exports.validateLayout = validateLayout;
exports.withLayoutItem = withLayoutItem;
var _lodash = _interopRequireDefault(require("ab8da7a7f20b3647"));
var _react = _interopRequireDefault(require("93eb75e331e65467"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var isProduction = false;
var DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function bottom(layout) /*: number*/ {
    var max = 0, bottomY;
    for(var i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function cloneLayout(layout) /*: Layout*/ {
    var newLayout = Array(layout.length);
    for(var i = 0, len = layout.length; i < len; i++)newLayout[i] = cloneLayoutItem(layout[i]);
    return newLayout;
} // Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function modifyLayout(layout, layoutItem) /*: Layout*/ {
    var newLayout = Array(layout.length);
    for(var i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
} // Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function withLayoutItem(layout, itemKey, cb) /*: [Layout, ?LayoutItem]*/ {
    var item = getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb(cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = modifyLayout(layout, item);
    return [
        layout,
        item
    ];
} // Fast path to cloning, since this is monomorphic
function cloneLayoutItem(layoutItem) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function childrenEqual(a, b) /*: boolean*/ {
    return (0, _lodash.default)(_react.default.Children.map(a, function(c) {
        return c === null || c === void 0 ? void 0 : c.key;
    }), _react.default.Children.map(b, function(c) {
        return c === null || c === void 0 ? void 0 : c.key;
    }));
}
/**
 * See `fastRGLPropsEqual.js`.
 * We want this to run as fast as possible - it is called often - and to be
 * resilient to new props that we add. So rather than call lodash.isEqual,
 * which isn't suited to comparing props very well, we use this specialized
 * function in conjunction with preval to generate the fastest possible comparison
 * function, tuned for exactly our props.
 */ /*:: type FastRGLPropsEqual = (Object, Object, Function) => boolean;*/ var fastRGLPropsEqual = require("b5171ea604fb430f"); // Like the above, but a lot simpler.
exports.fastRGLPropsEqual = fastRGLPropsEqual;
function fastPositionEqual(a, b) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function collides(l1, l2) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}       Compacted Layout.
 */ function compact(layout, compactType, cols) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    var compareWith = getStatics(layout); // We go through the items by row and column.
    var sorted = sortLayoutItems(layout, compactType); // Holding for new items.
    var out = Array(layout.length);
    for(var i = 0, len = sorted.length; i < len; i++){
        var l = cloneLayoutItem(sorted[i]); // Don't move static elements
        if (!l.static) {
            l = compactItem(compareWith, l, compactType, cols, sorted); // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        } // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l; // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
var heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function resolveCompactionCollision(layout, item, moveToCoord, axis) {
    var sizeProp = heightWidth[axis];
    item[axis] += 1;
    var itemIndex = layout.map(function(layoutItem) {
        return layoutItem.i;
    }).indexOf(item.i); // Go through each item we collide with.
    for(var i = itemIndex + 1; i < layout.length; i++){
        var otherItem = layout[i]; // Ignore static items
        if (otherItem.static) continue; // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if (collides(item, otherItem)) resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function compactItem(compareWith, l, compactType, cols, fullLayout) /*: LayoutItem*/ {
    var compactV = compactType === "vertical";
    var compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        l.y = Math.min(bottom(compareWith), l.y); // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !getFirstCollision(compareWith, l))l.x--;
     // Move it down, and keep moving it down if it's colliding.
    var collides;
    while(collides = getFirstCollision(compareWith, l)){
        if (compactH) resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
         // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
        }
    } // Ensure that there are no negative positions
    l.y = Math.max(l.y, 0);
    l.x = Math.max(l.x, 0);
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function correctBounds(layout, bounds) /*: Layout*/ {
    var collidesWith = getStatics(layout);
    for(var i = 0, len = layout.length; i < len; i++){
        var l = layout[i]; // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w; // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while(getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function getLayoutItem(layout, id) /*: ?LayoutItem*/ {
    for(var i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function getFirstCollision(layout, layoutItem) /*: ?LayoutItem*/ {
    for(var i = 0, len = layout.length; i < len; i++){
        if (collides(layout[i], layoutItem)) return layout[i];
    }
}
function getAllCollisions(layout, layoutItem) /*: Array<LayoutItem>*/ {
    return layout.filter(function(l) {
        return collides(l, layoutItem);
    });
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function getStatics(layout) /*: Array<LayoutItem>*/ {
    return layout.filter(function(l) {
        return l.static;
    });
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function moveElement(layout, l, x, y, isUserAction, preventCollision, compactType, cols, allowOverlap) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout; // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    log("Moving element ".concat(l.i, " to [").concat(String(x), ",").concat(String(y), "] from [").concat(l.x, ",").concat(l.y, "]"));
    var oldX = l.x;
    var oldY = l.y; // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true; // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    var sorted = sortLayoutItems(layout, compactType);
    var movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false; // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    var collisions = getAllCollisions(sorted, l);
    var hasCollisions = collisions.length > 0; // We may have collisions. We can short-circuit if we've turned off collisions or
    // allowed overlap.
    if (hasCollisions && allowOverlap) // Easy, we don't need to resolve collisions. But we *did* change the layout,
    // so clone it on the way out.
    return cloneLayout(layout);
    else if (hasCollisions && preventCollision) {
        // If we are preventing collision but not allowing overlap, we need to
        // revert the position of this element so it goes to where it came from, rather
        // than the user's desired location.
        log("Collision prevented on ".concat(l.i, ", reverting."));
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout; // did not change so don't clone
    } // Move each item that collides away from this element.
    for(var i = 0, len = collisions.length; i < len; i++){
        var collision = collisions[i];
        log("Resolving collision between ".concat(l.i, " at [").concat(l.x, ",").concat(l.y, "] and ").concat(collision.i, " at [").concat(collision.x, ",").concat(collision.y, "]")); // Short circuit so we can't infinite loop
        if (collision.moved) continue; // Don't move static items - we have to move *this* element away
        if (collision.static) layout = moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction, compactType, cols) /*: Layout*/ {
    var compactH = compactType === "horizontal"; // Compact vertically if not set to horizontal
    var compactV = compactType !== "horizontal";
    var preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false; // Make a mock item so we don't modify the item here, only modify in moveElement.
        var fakeItem = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        }; // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!getFirstCollision(layout, fakeItem)) {
            log("Doing reverse collision on ".concat(itemToMove.i, " up to [").concat(fakeItem.x, ",").concat(fakeItem.y, "]."));
            return moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        }
    }
    return moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function perc(num) /*: string*/ {
    return num * 100 + "%";
}
function setTransform(_ref) /*: Object*/ {
    var top = _ref.top, left = _ref.left, width = _ref.width, height = _ref.height;
    // Replace unitless items with px
    var translate = "translate(".concat(left, "px,").concat(top, "px)");
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        position: "absolute"
    };
}
function setTopLeft(_ref2) /*: Object*/ {
    var top = _ref2.top, left = _ref2.left, width = _ref2.width, height = _ref2.height;
    return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function sortLayoutItems(layout, compactType) /*: Layout*/ {
    if (compactType === "horizontal") return sortLayoutItemsByColRow(layout);
    if (compactType === "vertical") return sortLayoutItemsByRowCol(layout);
    else return layout;
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function sortLayoutItemsByRowCol(layout) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function sortLayoutItemsByColRow(layout) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function synchronizeLayoutWithChildren(initialLayout, children, cols, compactType, allowOverlap) /*: Layout*/ {
    initialLayout = initialLayout || []; // Generate one layout item per child.
    var layout = [];
    _react.default.Children.forEach(children, function(child) {
        // Child may not exist
        if ((child === null || child === void 0 ? void 0 : child.key) == null) return; // Don't overwrite if it already exists.
        var exists = getLayoutItem(initialLayout, String(child.key));
        if (exists) layout.push(cloneLayoutItem(exists));
        else {
            if (!isProduction && child.props._grid) console.warn("`_grid` properties on children have been deprecated as of React 15.2. Please use `data-grid` or add your properties directly to the `layout`.");
            var g = child.props["data-grid"] || child.props._grid; // Hey, this item has a data-grid property, use it.
            if (g) {
                if (!isProduction) validateLayout([
                    g
                ], "ReactGridLayout.children");
                 // FIXME clone not really necessary here
                layout.push(cloneLayoutItem(_objectSpread(_objectSpread({}, g), {}, {
                    i: child.key
                })));
            } else // Nothing provided: ensure this is added to the bottom
            // FIXME clone not really necessary here
            layout.push(cloneLayoutItem({
                w: 1,
                h: 1,
                x: 0,
                y: bottom(layout),
                i: String(child.key)
            }));
        }
    }); // Correct the layout.
    var correctedLayout = correctBounds(layout, {
        cols: cols
    });
    return allowOverlap ? correctedLayout : compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function validateLayout(layout) /*: void*/ {
    var contextName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    var subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(var i = 0, len = layout.length; i < len; i++){
        var item = layout[i];
        for(var j = 0; j < subProps.length; j++){
            if (typeof item[subProps[j]] !== "number") throw new Error("ReactGridLayout: " + contextName + "[" + i + "]." + subProps[j] + " must be a number!");
        }
    }
} // Legacy support for verticalCompact: false
function compactType(props) /*: CompactType*/ {
    var _ref3 = props || {}, verticalCompact = _ref3.verticalCompact, compactType = _ref3.compactType;
    return verticalCompact === false ? null : compactType;
}
function log() {
    var _console;
    if (!DEBUG) return; // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, arguments);
}
var noop = function noop() {};
exports.noop = noop;

},{"ab8da7a7f20b3647":"heWiN","93eb75e331e65467":"9njXz","b5171ea604fb430f":"fMyGP"}],"fMyGP":[function(require,module,exports) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

},{}],"124H5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calcGridColWidth = calcGridColWidth;
exports.calcGridItemPosition = calcGridItemPosition;
exports.calcGridItemWHPx = calcGridItemWHPx;
exports.calcWH = calcWH;
exports.calcXY = calcXY;
exports.clamp = clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function calcGridColWidth(positionParams) /*: number*/ {
    var margin = positionParams.margin, containerPadding = positionParams.containerPadding, containerWidth = positionParams.containerWidth, cols = positionParams.cols;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
} // This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function calcGridItemWHPx(gridUnits, colOrRowSize, marginPx) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function calcGridItemPosition(positionParams, x, y, w, h, state) /*: Position*/ {
    var margin = positionParams.margin, containerPadding = positionParams.containerPadding, rowHeight = positionParams.rowHeight;
    var colWidth = calcGridColWidth(positionParams);
    var out = {}; // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = calcGridItemWHPx(h, rowHeight, margin[1]);
    } // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function calcXY(positionParams, top, left, w, h) /*: { x: number, y: number }*/ {
    var margin = positionParams.margin, cols = positionParams.cols, rowHeight = positionParams.rowHeight, maxRows = positionParams.maxRows;
    var colWidth = calcGridColWidth(positionParams); // left = colWidth * x + margin * (x + 1)
    // l = cx + m(x+1)
    // l = cx + mx + m
    // l - m = cx + mx
    // l - m = x(c + m)
    // (l - m) / (c + m) = x
    // x = (left - margin) / (coldWidth + margin)
    var x = Math.round((left - margin[0]) / (colWidth + margin[0]));
    var y = Math.round((top - margin[1]) / (rowHeight + margin[1])); // Capping
    x = clamp(x, 0, cols - w);
    y = clamp(y, 0, maxRows - h);
    return {
        x: x,
        y: y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @return {Object}                         w, h as grid units.
 */ function calcWH(positionParams, width, height, x, y) /*: { w: number, h: number }*/ {
    var margin = positionParams.margin, maxRows = positionParams.maxRows, cols = positionParams.cols, rowHeight = positionParams.rowHeight;
    var colWidth = calcGridColWidth(positionParams); // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    var w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    var h = Math.round((height + margin[1]) / (rowHeight + margin[1])); // Capping
    w = clamp(w, 0, cols - x);
    h = clamp(h, 0, maxRows - y);
    return {
        w: w,
        h: h
    };
} // Similar to _.clamp
function clamp(num, lowerBound, upperBound) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

},{}],"bBZma":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("e6c023845ec8e836"));
var _propTypes = _interopRequireDefault(require("9d4ca7bf8b09c0ba"));
var _reactDraggable = require("c759770490f68107");
var _reactResizable = require("1626b4c369c9848e");
var _utils = require("7d607e9dede9bbd7");
var _calculateUtils = require("690df644bca08ce0");
var _ReactGridLayoutPropTypes = require("e8cbc2ae1b33bf31");
var _clsx = _interopRequireDefault(require("f16d20165e3cc81"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * An individual item within a ReactGridLayout.
 */ var GridItem = /*#__PURE__*/ function(_React$Component) {
    _inherits(GridItem, _React$Component);
    var _super = _createSuper(GridItem);
    function GridItem() {
        var _this;
        _classCallCheck(this, GridItem);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        _defineProperty(_assertThisInitialized(_this), "elementRef", /*#__PURE__*/ _react.default.createRef());
        _defineProperty(_assertThisInitialized(_this), "onDragStart", function(e, _ref) {
            var node = _ref.node;
            var _this$props = _this.props, onDragStart = _this$props.onDragStart, transformScale = _this$props.transformScale;
            if (!onDragStart) return;
            var newPosition = {
                top: 0,
                left: 0
            }; // TODO: this wont work on nested parents
            var offsetParent = node.offsetParent;
            if (!offsetParent) return;
            var parentRect = offsetParent.getBoundingClientRect();
            var clientRect = node.getBoundingClientRect();
            var cLeft = clientRect.left / transformScale;
            var pLeft = parentRect.left / transformScale;
            var cTop = clientRect.top / transformScale;
            var pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            _this.setState({
                dragging: newPosition
            }); // Call callback with this data
            var _calcXY = (0, _calculateUtils.calcXY)(_this.getPositionParams(), newPosition.top, newPosition.left, _this.props.w, _this.props.h), x = _calcXY.x, y = _calcXY.y;
            return onDragStart.call(_assertThisInitialized(_this), _this.props.i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onDrag", function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            var onDrag = _this.props.onDrag;
            if (!onDrag) return;
            if (!_this.state.dragging) throw new Error("onDrag called before onDragStart.");
            var top = _this.state.dragging.top + deltaY;
            var left = _this.state.dragging.left + deltaX;
            var _this$props2 = _this.props, isBounded = _this$props2.isBounded, i = _this$props2.i, w = _this$props2.w, h = _this$props2.h, containerWidth = _this$props2.containerWidth;
            var positionParams = _this.getPositionParams(); // Boundary calculations; keeps items within the grid
            if (isBounded) {
                var offsetParent = node.offsetParent;
                if (offsetParent) {
                    var _this$props3 = _this.props, margin = _this$props3.margin, rowHeight = _this$props3.rowHeight;
                    var bottomBoundary = offsetParent.clientHeight - (0, _calculateUtils.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, _calculateUtils.clamp)(top, 0, bottomBoundary);
                    var colWidth = (0, _calculateUtils.calcGridColWidth)(positionParams);
                    var rightBoundary = containerWidth - (0, _calculateUtils.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, _calculateUtils.clamp)(left, 0, rightBoundary);
                }
            }
            var newPosition = {
                top: top,
                left: left
            };
            _this.setState({
                dragging: newPosition
            }); // Call callback with this data
            var _calcXY2 = (0, _calculateUtils.calcXY)(positionParams, top, left, w, h), x = _calcXY2.x, y = _calcXY2.y;
            return onDrag.call(_assertThisInitialized(_this), i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onDragStop", function(e, _ref3) {
            var node = _ref3.node;
            var onDragStop = _this.props.onDragStop;
            if (!onDragStop) return;
            if (!_this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            var _this$props4 = _this.props, w = _this$props4.w, h = _this$props4.h, i = _this$props4.i;
            var _this$state$dragging = _this.state.dragging, left = _this$state$dragging.left, top = _this$state$dragging.top;
            var newPosition = {
                top: top,
                left: left
            };
            _this.setState({
                dragging: null
            });
            var _calcXY3 = (0, _calculateUtils.calcXY)(_this.getPositionParams(), top, left, w, h), x = _calcXY3.x, y = _calcXY3.y;
            return onDragStop.call(_assertThisInitialized(_this), i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onResizeStop", function(e, callbackData) {
            _this.onResizeHandler(e, callbackData, "onResizeStop");
        });
        _defineProperty(_assertThisInitialized(_this), "onResizeStart", function(e, callbackData) {
            _this.onResizeHandler(e, callbackData, "onResizeStart");
        });
        _defineProperty(_assertThisInitialized(_this), "onResize", function(e, callbackData) {
            _this.onResizeHandler(e, callbackData, "onResize");
        });
        return _this;
    }
    _createClass(GridItem, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) /*: boolean*/ {
                // We can't deeply compare children. If the developer memoizes them, we can
                // use this optimization.
                if (this.props.children !== nextProps.children) return true;
                if (this.props.droppingPosition !== nextProps.droppingPosition) return true; // TODO memoize these calculations so they don't take so long?
                var oldPosition = (0, _calculateUtils.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
                var newPosition = (0, _calculateUtils.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
                return !(0, _utils.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.moveDroppingItem({});
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                this.moveDroppingItem(prevProps);
            } // When a droppingPosition is present, this means we should fire a move event, as if we had moved
        },
        {
            key: "moveDroppingItem",
            value: function moveDroppingItem(prevProps) {
                var droppingPosition = this.props.droppingPosition;
                if (!droppingPosition) return;
                var node = this.elementRef.current; // Can't find DOM node (are we unmounted?)
                if (!node) return;
                var prevDroppingPosition = prevProps.droppingPosition || {
                    left: 0,
                    top: 0
                };
                var dragging = this.state.dragging;
                var shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
                if (!dragging) this.onDragStart(droppingPosition.e, {
                    node: node,
                    deltaX: droppingPosition.left,
                    deltaY: droppingPosition.top
                });
                else if (shouldDrag) {
                    var deltaX = droppingPosition.left - dragging.left;
                    var deltaY = droppingPosition.top - dragging.top;
                    this.onDrag(droppingPosition.e, {
                        node: node,
                        deltaX: deltaX,
                        deltaY: deltaY
                    });
                }
            }
        },
        {
            key: "getPositionParams",
            value: function getPositionParams() /*: PositionParams*/ {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                return {
                    cols: props.cols,
                    containerPadding: props.containerPadding,
                    containerWidth: props.containerWidth,
                    margin: props.margin,
                    maxRows: props.maxRows,
                    rowHeight: props.rowHeight
                };
            }
        },
        {
            key: "createStyle",
            value: function createStyle(pos) /*: { [key: string]: ?string }*/ {
                var _this$props5 = this.props, usePercentages = _this$props5.usePercentages, containerWidth = _this$props5.containerWidth, useCSSTransforms = _this$props5.useCSSTransforms;
                var style; // CSS Transforms support (default)
                if (useCSSTransforms) style = (0, _utils.setTransform)(pos);
                else {
                    // top,left (slow)
                    style = (0, _utils.setTopLeft)(pos); // This is used for server rendering.
                    if (usePercentages) {
                        style.left = (0, _utils.perc)(pos.left / containerWidth);
                        style.width = (0, _utils.perc)(pos.width / containerWidth);
                    }
                }
                return style;
            }
        },
        {
            key: "mixinDraggable",
            value: function mixinDraggable(child, isDraggable) /*: ReactElement<any>*/ {
                return /*#__PURE__*/ _react.default.createElement(_reactDraggable.DraggableCore, {
                    disabled: !isDraggable,
                    onStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onStop: this.onDragStop,
                    handle: this.props.handle,
                    cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
                    scale: this.props.transformScale,
                    nodeRef: this.elementRef
                }, child);
            }
        },
        {
            key: "mixinResizable",
            value: function mixinResizable(child, position, isResizable) /*: ReactElement<any>*/ {
                var _this$props6 = this.props, cols = _this$props6.cols, x = _this$props6.x, minW = _this$props6.minW, minH = _this$props6.minH, maxW = _this$props6.maxW, maxH = _this$props6.maxH, transformScale = _this$props6.transformScale, resizeHandles = _this$props6.resizeHandles, resizeHandle = _this$props6.resizeHandle;
                var positionParams = this.getPositionParams(); // This is the max possible width - doesn't go to infinity because of the width of the window
                var maxWidth = (0, _calculateUtils.calcGridItemPosition)(positionParams, 0, 0, cols - x, 0).width; // Calculate min/max constraints using our min & maxes
                var mins = (0, _calculateUtils.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
                var maxes = (0, _calculateUtils.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
                var minConstraints = [
                    mins.width,
                    mins.height
                ];
                var maxConstraints = [
                    Math.min(maxes.width, maxWidth),
                    Math.min(maxes.height, Infinity)
                ];
                return /*#__PURE__*/ _react.default.createElement(_reactResizable.Resizable // These are opts for the resize handle itself
                , {
                    draggableOpts: {
                        disabled: !isResizable
                    },
                    className: isResizable ? undefined : "react-resizable-hide",
                    width: position.width,
                    height: position.height,
                    minConstraints: minConstraints,
                    maxConstraints: maxConstraints,
                    onResizeStop: this.onResizeStop,
                    onResizeStart: this.onResizeStart,
                    onResize: this.onResize,
                    transformScale: transformScale,
                    resizeHandles: resizeHandles,
                    handle: resizeHandle
                }, child);
            }
        },
        {
            key: "onResizeHandler",
            value: /**
     * Wrapper around drag events to provide more useful data.
     * All drag events call the function with the given handler name,
     * with the signature (index, x, y).
     *
     * @param  {String} handlerName Handler name to wrap.
     * @return {Function}           Handler function.
     */ function onResizeHandler(e, _ref4, handlerName) /*: void*/ {
                var node = _ref4.node, size = _ref4.size;
                var handler = this.props[handlerName];
                if (!handler) return;
                var _this$props7 = this.props, cols = _this$props7.cols, x = _this$props7.x, y = _this$props7.y, i = _this$props7.i, maxH = _this$props7.maxH, minH = _this$props7.minH;
                var _this$props8 = this.props, minW = _this$props8.minW, maxW = _this$props8.maxW; // Get new XY
                var _calcWH = (0, _calculateUtils.calcWH)(this.getPositionParams(), size.width, size.height, x, y), w = _calcWH.w, h = _calcWH.h; // minW should be at least 1 (TODO propTypes validation?)
                minW = Math.max(minW, 1); // maxW should be at most (cols - x)
                maxW = Math.min(maxW, cols - x); // Min/max capping
                w = (0, _calculateUtils.clamp)(w, minW, maxW);
                h = (0, _calculateUtils.clamp)(h, minH, maxH);
                this.setState({
                    resizing: handlerName === "onResizeStop" ? null : size
                });
                handler.call(this, i, w, h, {
                    e: e,
                    node: node,
                    size: size
                });
            }
        },
        {
            key: "render",
            value: function render() /*: ReactNode*/ {
                var _this$props9 = this.props, x = _this$props9.x, y = _this$props9.y, w = _this$props9.w, h = _this$props9.h, isDraggable = _this$props9.isDraggable, isResizable = _this$props9.isResizable, droppingPosition = _this$props9.droppingPosition, useCSSTransforms = _this$props9.useCSSTransforms;
                var pos = (0, _calculateUtils.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
                var child = _react.default.Children.only(this.props.children); // Create the child element. We clone the existing element but modify its className and style.
                var newChild = /*#__PURE__*/ _react.default.cloneElement(child, {
                    ref: this.elementRef,
                    className: (0, _clsx.default)("react-grid-item", child.props.className, this.props.className, {
                        static: this.props.static,
                        resizing: Boolean(this.state.resizing),
                        "react-draggable": isDraggable,
                        "react-draggable-dragging": Boolean(this.state.dragging),
                        dropping: Boolean(droppingPosition),
                        cssTransforms: useCSSTransforms
                    }),
                    // We can set the width and height on the child, but unfortunately we can't set the position.
                    style: _objectSpread(_objectSpread(_objectSpread({}, this.props.style), child.props.style), this.createStyle(pos))
                }); // Resizable support. This is usually on but the user can toggle it off.
                newChild = this.mixinResizable(newChild, pos, isResizable); // Draggable support. This is always on, except for with placeholders.
                newChild = this.mixinDraggable(newChild, isDraggable);
                return newChild;
            }
        }
    ]);
    return GridItem;
}(_react.default.Component);
exports.default = GridItem;
_defineProperty(GridItem, "propTypes", {
    // Children must be only a single element
    children: _propTypes.default.element,
    // General grid attributes
    cols: _propTypes.default.number.isRequired,
    containerWidth: _propTypes.default.number.isRequired,
    rowHeight: _propTypes.default.number.isRequired,
    margin: _propTypes.default.array.isRequired,
    maxRows: _propTypes.default.number.isRequired,
    containerPadding: _propTypes.default.array.isRequired,
    // These are all in grid units
    x: _propTypes.default.number.isRequired,
    y: _propTypes.default.number.isRequired,
    w: _propTypes.default.number.isRequired,
    h: _propTypes.default.number.isRequired,
    // All optional
    minW: function minW(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function maxW(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function minH(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function maxH(props, propName) {
        var value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: _propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: _ReactGridLayoutPropTypes.resizeHandleAxesType,
    resizeHandle: _ReactGridLayoutPropTypes.resizeHandleType,
    // Functions
    onDragStop: _propTypes.default.func,
    onDragStart: _propTypes.default.func,
    onDrag: _propTypes.default.func,
    onResizeStop: _propTypes.default.func,
    onResizeStart: _propTypes.default.func,
    onResize: _propTypes.default.func,
    // Flags
    isDraggable: _propTypes.default.bool.isRequired,
    isResizable: _propTypes.default.bool.isRequired,
    isBounded: _propTypes.default.bool.isRequired,
    static: _propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: _propTypes.default.bool.isRequired,
    transformScale: _propTypes.default.number,
    // Others
    className: _propTypes.default.string,
    // Selector for draggable handle
    handle: _propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: _propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: _propTypes.default.shape({
        e: _propTypes.default.object.isRequired,
        left: _propTypes.default.number.isRequired,
        top: _propTypes.default.number.isRequired
    })
});
_defineProperty(GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

},{"e6c023845ec8e836":"9njXz","9d4ca7bf8b09c0ba":"bnNSm","c759770490f68107":"6cObg","1626b4c369c9848e":"8Doba","7d607e9dede9bbd7":"cVeAG","690df644bca08ce0":"124H5","e8cbc2ae1b33bf31":"aMAHM","f16d20165e3cc81":"5PNR8"}],"6cObg":[function(require,module,exports) {
"use strict";
const { default: Draggable, DraggableCore } = require("39b5312b4b7f8b31");
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = DraggableCore;

},{"39b5312b4b7f8b31":"iGiUT"}],"iGiUT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return _DraggableCore.default;
    }
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f06ad358256d46ae"));
var _propTypes = _interopRequireDefault(require("9f8816d66633a995"));
var _reactDom = _interopRequireDefault(require("fd97d82c5bf54e9d"));
var _clsx = _interopRequireDefault(require("26060e24796bfa96"));
var _domFns = require("4e40e768124450c6");
var _positionFns = require("6ac2262d9826d85d");
var _shims = require("2838a27078c4cbed");
var _DraggableCore = _interopRequireDefault(require("2ae804dc0d7f535c"));
var _log = _interopRequireDefault(require("6e73015298a24ef9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class Draggable extends React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, _log.default)("Draggable: getDerivedStateFromProps %j", {
                position,
                prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        _defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, _log.default)("Draggable: onDragStart: %j", coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, _positionFns.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        _defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, _log.default)("Draggable: onDrag: %j", coreData);
            const uiData = (0, _positionFns.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x, y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, _positionFns.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        _defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, _positionFns.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, _log.default)("Draggable: onDragStop: %j", coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x, y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis, bounds, children, defaultPosition, defaultClassName, defaultClassNameDragging, defaultClassNameDragged, position, positionOffset, scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, _clsx.default)(children.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ React.cloneElement(React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
exports.default = Draggable;
_defineProperty(Draggable, "displayName", "Draggable");
_defineProperty(Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ..._DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: _propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: _propTypes.default.oneOfType([
        _propTypes.default.shape({
            left: _propTypes.default.number,
            right: _propTypes.default.number,
            top: _propTypes.default.number,
            bottom: _propTypes.default.number
        }),
        _propTypes.default.string,
        _propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: _propTypes.default.string,
    defaultClassNameDragging: _propTypes.default.string,
    defaultClassNameDragged: _propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
    }),
    positionOffset: _propTypes.default.shape({
        x: _propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ]),
        y: _propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: _shims.dontSetMe,
    style: _shims.dontSetMe,
    transform: _shims.dontSetMe
});
_defineProperty(Draggable, "defaultProps", {
    ..._DraggableCore.default.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});

},{"f06ad358256d46ae":"9njXz","9f8816d66633a995":"bnNSm","fd97d82c5bf54e9d":"2ApDx","26060e24796bfa96":"5PNR8","4e40e768124450c6":"79Aw5","6ac2262d9826d85d":"3vGqc","2838a27078c4cbed":"WQdKb","2ae804dc0d7f535c":"gANt0","6e73015298a24ef9":"gtEjY"}],"79Aw5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addClassName = addClassName;
exports.addEvent = addEvent;
exports.addUserSelectStyles = addUserSelectStyles;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.getTranslation = getTranslation;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.offsetXYFromParent = offsetXYFromParent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.removeClassName = removeClassName;
exports.removeEvent = removeEvent;
exports.removeUserSelectStyles = removeUserSelectStyles;
var _shims = require("af60d0462ec484c0");
var _getPrefix = _interopRequireWildcard(require("25bee73a12bb5ee8"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let matchesSelectorFunc = "";
function matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!matchesSelectorFunc) matchesSelectorFunc = (0, _shims.findInArray)([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, _shims.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if (matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = handler;
}
function removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = null;
}
function outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, _shims.int)(computedStyle.borderTopWidth);
    height += (0, _shims.int)(computedStyle.borderBottomWidth);
    return height;
}
function outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, _shims.int)(computedStyle.borderLeftWidth);
    width += (0, _shims.int)(computedStyle.borderRightWidth);
    return width;
}
function innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, _shims.int)(computedStyle.paddingTop);
    height -= (0, _shims.int)(computedStyle.paddingBottom);
    return height;
}
function innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, _shims.int)(computedStyle.paddingLeft);
    width -= (0, _shims.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x,
        y
    };
}
function createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = getTranslation(controlPos, positionOffset, "px");
    return {
        [(0, _getPrefix.browserPrefixToKey)("transform", _getPrefix.default)]: translation
    };
}
function createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = getTranslation(controlPos, positionOffset, "");
    return translation;
}
function getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x, y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) addClassName(doc.body, "react-draggable-transparent-selection");
}
function removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) removeClassName(doc.body, "react-draggable-transparent-selection");
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
}

},{"af60d0462ec484c0":"WQdKb","25bee73a12bb5ee8":"biOpG"}],"WQdKb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dontSetMe = dontSetMe;
exports.findInArray = findInArray;
exports.int = int;
exports.isFunction = isFunction;
exports.isNum = isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === "number" && !isNaN(num);
}
function int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

},{}],"biOpG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports.default = void 0;
exports.getPrefix = getPrefix;
const prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === "undefined") return "";
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < prefixes.length; i++){
        if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
    }
    return "";
}
function browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}
function browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var _default = exports.default = getPrefix();

},{}],"3vGqc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;
exports.getBoundPosition = getBoundPosition;
exports.getControlPosition = getControlPosition;
exports.snapToGrid = snapToGrid;
var _shims = require("44bb88b39f2262ab");
var _domFns = require("6d8383fdeb613c7c");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : cloneBounds(bounds);
    const node = findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
            right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
            bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === "number" ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
    const node = findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, _shims.isNum)(draggable.lastX);
    const node = findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x,
        y
    };
    else // Otherwise calculate proper values.
    return {
        node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x,
        y
    };
}
// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

},{"44bb88b39f2262ab":"WQdKb","6d8383fdeb613c7c":"79Aw5"}],"gANt0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d830172ba8d01674"));
var _propTypes = _interopRequireDefault(require("936051a0e8f63cef"));
var _reactDom = _interopRequireDefault(require("51e89cac1fd8612a"));
var _domFns = require("a60a19bd70f37cbe");
var _positionFns = require("32cd453cf02f7977");
var _shims = require("b3ef123d6f743aa4");
var _log = _interopRequireDefault(require("71bc142b940fef0c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
// Default to mouse events.
let dragEventFor = eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class DraggableCore extends React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        _defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        _defineProperty(this, "lastX", NaN);
        _defineProperty(this, "lastY", NaN);
        _defineProperty(this, "touchIdentifier", null);
        _defineProperty(this, "mounted", false);
        _defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === "touchstart") e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, _positionFns.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x, y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
            (0, _log.default)("DraggableCore: handleDragStart: %j", coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, _log.default)("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, this.handleDrag);
            (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, this.handleDragStop);
        });
        _defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x, y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
            (0, _log.default)("DraggableCore: handleDrag: %j", coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent("MouseEvents");
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        _defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x, y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, _log.default)("DraggableCore: handleDragStop: %j", coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, _log.default)("DraggableCore: Removing handlers");
                (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, this.handleDrag);
                (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, this.handleDragStop);
            }
        });
        _defineProperty(this, "onMouseDown", (e)=>{
            dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        _defineProperty(this, "onMouseUp", (e)=>{
            dragEventFor = eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        _defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            dragEventFor = eventsFor.touch;
            return this.handleDragStart(e);
        });
        _defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            dragEventFor = eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument } = thisNode;
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
            (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : _reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ React.cloneElement(React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
exports.default = DraggableCore;
_defineProperty(DraggableCore, "displayName", "DraggableCore");
_defineProperty(DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: _propTypes.default.bool,
    children: _propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: _propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: _propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: _propTypes.default.arrayOf(_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: _propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: _propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: _propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: _propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: _propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: _propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: _propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: _propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: _shims.dontSetMe,
    style: _shims.dontSetMe,
    transform: _shims.dontSetMe
});
_defineProperty(DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

},{"d830172ba8d01674":"9njXz","936051a0e8f63cef":"bnNSm","51e89cac1fd8612a":"2ApDx","a60a19bd70f37cbe":"79Aw5","32cd453cf02f7977":"3vGqc","b3ef123d6f743aa4":"WQdKb","71bc142b940fef0c":"gtEjY"}],"gtEjY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
/*eslint no-console:0*/ function log() {}

},{}],"8Doba":[function(require,module,exports) {
"use strict";
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
module.exports.Resizable = require("b0fa7aaa97d8ef04").default;
module.exports.ResizableBox = require("3d6fd9d31ed5b9c8").default;

},{"b0fa7aaa97d8ef04":"9H3Ou","3d6fd9d31ed5b9c8":"ktuF8"}],"9H3Ou":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("3cbdee721f241241"));
var _reactDraggable = require("e9f39e09282da14c");
var _utils = require("fd058e0f9ce7dc70");
var _propTypes = require("aec0c8dfc1b80a4f");
var _excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
var Resizable = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleRefs = {};
        _this.lastHandleRect = null;
        _this.slack = null;
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
        var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            var ratio = this.props.width / this.props.height;
            var deltaW = width - this.props.width;
            var deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        var oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    } /**
   * Wrapper around drag events to provide more useful data.
   *
   * @param  {String} handlerName Handler name to wrap.
   * @return {Function}           Handler function.
   */ ;
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === "onResizeStart") _this2.resetData();
            // Axis restrictions
            var canDragX = (_this2.props.axis === "both" || _this2.props.axis === "x") && axis !== "n" && axis !== "s";
            var canDragY = (_this2.props.axis === "both" || _this2.props.axis === "y") && axis !== "e" && axis !== "w";
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === "w") {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === "n") {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === "w") deltaX = -deltaX;
            if (axisV === "n") deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
            // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
            // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === "function" ? _this2.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === "onResize" && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === "onResizeStop") _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
        var handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === "function") return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        var isDOMElement = typeof handle.type === "string";
        var props = _objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ React.cloneElement(handle, props);
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = _objectWithoutPropertiesLoose(_this$props2, _excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, _utils.cloneElement)(children, _objectSpread(_objectSpread({}, p), {}, {
            className: (className ? className + " " : "") + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                var _this3$handleRefs$han;
                // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /*#__PURE__*/ React.createRef();
                return /*#__PURE__*/ React.createElement(_reactDraggable.DraggableCore, _extends({}, draggableOpts, {
                    nodeRef: ref,
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler("onResizeStop", handleAxis),
                    onStart: _this3.resizeHandler("onResizeStart", handleAxis),
                    onDrag: _this3.resizeHandler("onResize", handleAxis)
                }), _this3.renderResizeHandle(handleAxis, ref));
            }))
        }));
    };
    return Resizable;
}(React.Component);
exports.default = Resizable;
Resizable.propTypes = _propTypes.resizableProps;
Resizable.defaultProps = {
    axis: "both",
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        "se"
    ],
    transformScale: 1
};

},{"3cbdee721f241241":"9njXz","e9f39e09282da14c":"6cObg","fd058e0f9ce7dc70":"3PKvB","aec0c8dfc1b80a4f":"gcjuS"}],"3PKvB":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.cloneElement = cloneElement;
var _react = _interopRequireDefault(require("afa18fb69f62be75"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function cloneElement(element, props) {
    if (props.style && element.props.style) props.style = _objectSpread(_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ _react.default.cloneElement(element, props);
}

},{"afa18fb69f62be75":"9njXz"}],"gcjuS":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.resizableProps = void 0;
var _propTypes = _interopRequireDefault(require("40a30ea6afe62634"));
var _reactDraggable = require("5e54b5c5bc137992");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: _propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    className: _propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: _propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: _propTypes.default.shape({
        allowAnyClick: _propTypes.default.bool,
        cancel: _propTypes.default.string,
        children: _propTypes.default.node,
        disabled: _propTypes.default.bool,
        enableUserSelectHack: _propTypes.default.bool,
        offsetParent: _propTypes.default.node,
        grid: _propTypes.default.arrayOf(_propTypes.default.number),
        handle: _propTypes.default.string,
        nodeRef: _propTypes.default.object,
        onStart: _propTypes.default.func,
        onDrag: _propTypes.default.func,
        onStop: _propTypes.default.func,
        onMouseDown: _propTypes.default.func,
        scale: _propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function height() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var props = args[0];
        // Required if resizing height or both
        if (props.axis === "both" || props.axis === "y") {
            var _PropTypes$number;
            return (_PropTypes$number = _propTypes.default.number).isRequired.apply(_PropTypes$number, args);
        }
        return _propTypes.default.number.apply(_propTypes.default, args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: _propTypes.default.oneOfType([
        _propTypes.default.node,
        _propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: _propTypes.default.arrayOf(_propTypes.default.number),
    lockAspectRatio: _propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: _propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: _propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: _propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: _propTypes.default.arrayOf(_propTypes.default.oneOf([
        "s",
        "w",
        "e",
        "n",
        "sw",
        "nw",
        "se",
        "ne"
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: _propTypes.default.number,
    /*
   * Initial width
   */ width: function width() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var props = args[0];
        // Required if resizing width or both
        if (props.axis === "both" || props.axis === "x") {
            var _PropTypes$number2;
            return (_PropTypes$number2 = _propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
        }
        return _propTypes.default.number.apply(_propTypes.default, args);
    }
};
exports.resizableProps = resizableProps;

},{"40a30ea6afe62634":"bnNSm","5e54b5c5bc137992":"6cObg"}],"ktuF8":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("732ff3f6b965ac42"));
var _propTypes = _interopRequireDefault(require("ac46386b62a76a93"));
var _Resizable = _interopRequireDefault(require("cb18bf27b4a8b12"));
var _propTypes2 = require("3d4c280e5b389282");
var _excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var ResizableBox = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        };
        _this.onResize = function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist == null || e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        };
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = _objectWithoutPropertiesLoose(_this$props, _excluded);
        return /*#__PURE__*/ React.createElement(_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ React.createElement("div", _extends({}, props, {
            style: _objectSpread(_objectSpread({}, style), {}, {
                width: this.state.width + "px",
                height: this.state.height + "px"
            })
        })));
    };
    return ResizableBox;
}(React.Component);
exports.default = ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
ResizableBox.propTypes = _objectSpread(_objectSpread({}, _propTypes2.resizableProps), {}, {
    children: _propTypes.default.element
});

},{"732ff3f6b965ac42":"9njXz","ac46386b62a76a93":"bnNSm","cb18bf27b4a8b12":"9H3Ou","3d4c280e5b389282":"gcjuS"}],"aMAHM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resizeHandleType = exports.resizeHandleAxesType = exports.default = void 0;
var _propTypes = _interopRequireDefault(require("541a8d56a0c85011"));
var _react = _interopRequireDefault(require("90303995d3461de8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
var resizeHandleAxesType = _propTypes.default.arrayOf(_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
])); // Custom component for resize handles
exports.resizeHandleAxesType = resizeHandleAxesType;
var resizeHandleType = _propTypes.default.oneOfType([
    _propTypes.default.node,
    _propTypes.default.func
]);
/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,
  allowOverlap: boolean,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDropDragOver: (e: DragOverEvent) => ?({| w?: number, h?: number |} | false),
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ exports.resizeHandleType = resizeHandleType;
var _default = {
    //
    // Basic props
    //
    className: _propTypes.default.string,
    style: _propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: _propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: _propTypes.default.bool,
    // # of cols.
    cols: _propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: _propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: _propTypes.default.string,
    // Deprecated
    verticalCompact: function verticalCompact(props) {
        if (props.verticalCompact === false && true) console.warn('`verticalCompact` on <ReactGridLayout> is deprecated and will be removed soon. Use `compactType`: "horizontal" | "vertical" | null.');
    },
    // Choose vertical or hotizontal compaction
    compactType: _propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function layout(props) {
        var layout = props.layout; // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        require("90e010a11fe8429").validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: _propTypes.default.arrayOf(_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: _propTypes.default.arrayOf(_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: _propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: _propTypes.default.number,
    //
    // Flags
    //
    isBounded: _propTypes.default.bool,
    isDraggable: _propTypes.default.bool,
    isResizable: _propTypes.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: _propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: _propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: _propTypes.default.bool,
    // parent layout transform scale
    transformScale: _propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: _propTypes.default.bool,
    // Resize handle options
    resizeHandles: resizeHandleAxesType,
    resizeHandle: resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: _propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: _propTypes.default.func,
    // Calls on each drag movement.
    onDrag: _propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: _propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: _propTypes.default.func,
    // Calls when resize movement happens.
    onResize: _propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: _propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: _propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: _propTypes.default.shape({
        i: _propTypes.default.string.isRequired,
        w: _propTypes.default.number.isRequired,
        h: _propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function children(props, propName) {
        var children = props[propName]; // Check children keys for duplicates. Throw if found.
        var keys = {};
        _react.default.Children.forEach(children, function(child) {
            if ((child === null || child === void 0 ? void 0 : child.key) == null) return;
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: _propTypes.default.any
};
exports.default = _default;

},{"541a8d56a0c85011":"bnNSm","90303995d3461de8":"9njXz","90e010a11fe8429":"cVeAG"}],"4lgsw":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("c62eb11db86f83d7"));
var _propTypes = _interopRequireDefault(require("6f7e566320038446"));
var _lodash = _interopRequireDefault(require("c606c3955831aeda"));
var _utils = require("db2321e68f3438af");
var _responsiveUtils = require("71b865f319bbc8a9");
var _ReactGridLayout = _interopRequireDefault(require("b9efa97f3d60f705"));
var _excluded = [
    "breakpoint",
    "breakpoints",
    "cols",
    "layouts",
    "margin",
    "containerPadding",
    "onBreakpointChange",
    "onLayoutChange",
    "onWidthChange"
];
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// $FlowFixMe[method-unbinding]
var type = function type(obj) {
    return Object.prototype.toString.call(obj);
};
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function getIndentationValue(param, breakpoint) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null; // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    allowOverlap: 0,
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ var ResponsiveReactGridLayout = /*#__PURE__*/ function(_React$Component) {
    _inherits(ResponsiveReactGridLayout, _React$Component);
    var _super = _createSuper(ResponsiveReactGridLayout);
    function ResponsiveReactGridLayout() {
        var _this;
        _classCallCheck(this, ResponsiveReactGridLayout);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", _this.generateInitialState());
        _defineProperty(_assertThisInitialized(_this), "onLayoutChange", function(layout) {
            _this.props.onLayoutChange(layout, _objectSpread(_objectSpread({}, _this.props.layouts), {}, _defineProperty({}, _this.state.breakpoint, layout)));
        });
        return _this;
    }
    _createClass(ResponsiveReactGridLayout, [
        {
            key: "generateInitialState",
            value: function generateInitialState() /*: State*/ {
                var _this$props = this.props, width = _this$props.width, breakpoints = _this$props.breakpoints, layouts = _this$props.layouts, cols = _this$props.cols;
                var breakpoint = (0, _responsiveUtils.getBreakpointFromWidth)(breakpoints, width);
                var colNo = (0, _responsiveUtils.getColsFromBreakpoint)(breakpoint, cols); // verticalCompact compatibility, now deprecated
                var compactType = this.props.verticalCompact === false ? null : this.props.compactType; // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
                // for this layout.
                var initialLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
                return {
                    layout: initialLayout,
                    breakpoint: breakpoint,
                    cols: colNo
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // Allow parent to set width or breakpoint directly.
                if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, _lodash.default)(this.props.breakpoints, prevProps.breakpoints) || !(0, _lodash.default)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
            } // wrap layouts so we do not need to pass layouts to child
        },
        {
            key: "onWidthChange",
            value: /**
     * When the width changes work through breakpoints and reset state with the new width & breakpoint.
     * Width changes are necessary to figure out the widget widths.
     */ function onWidthChange(prevProps) {
                var _this$props2 = this.props, breakpoints = _this$props2.breakpoints, cols = _this$props2.cols, layouts = _this$props2.layouts, compactType = _this$props2.compactType;
                var newBreakpoint = this.props.breakpoint || (0, _responsiveUtils.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
                var lastBreakpoint = this.state.breakpoint;
                var newCols = (0, _responsiveUtils.getColsFromBreakpoint)(newBreakpoint, cols);
                var newLayouts = _objectSpread({}, layouts); // Breakpoint change
                if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
                    // Preserve the current layout if the current breakpoint is not present in the next layouts.
                    if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, _utils.cloneLayout)(this.state.layout); // Find or generate a new layout.
                    var layout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType); // This adds missing items.
                    layout = (0, _utils.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType, this.props.allowOverlap); // Store the new layout.
                    newLayouts[newBreakpoint] = layout; // callbacks
                    this.props.onLayoutChange(layout, newLayouts);
                    this.props.onBreakpointChange(newBreakpoint, newCols);
                    this.setState({
                        breakpoint: newBreakpoint,
                        layout: layout,
                        cols: newCols
                    });
                }
                var margin = getIndentationValue(this.props.margin, newBreakpoint);
                var containerPadding = getIndentationValue(this.props.containerPadding, newBreakpoint); //call onWidthChange on every change of width, not only on breakpoint changes
                this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
            }
        },
        {
            key: "render",
            value: function render() /*: React.Element<typeof ReactGridLayout>*/ {
                /* eslint-disable no-unused-vars */ var _this$props3 = this.props, breakpoint = _this$props3.breakpoint, breakpoints = _this$props3.breakpoints, cols = _this$props3.cols, layouts = _this$props3.layouts, margin = _this$props3.margin, containerPadding = _this$props3.containerPadding, onBreakpointChange = _this$props3.onBreakpointChange, onLayoutChange = _this$props3.onLayoutChange, onWidthChange = _this$props3.onWidthChange, other = _objectWithoutProperties(_this$props3, _excluded);
                /* eslint-enable no-unused-vars */ return /*#__PURE__*/ React.createElement(_ReactGridLayout.default, _extends({}, other, {
                    // $FlowIgnore should allow nullable here due to DefaultProps
                    margin: getIndentationValue(margin, this.state.breakpoint),
                    containerPadding: getIndentationValue(containerPadding, this.state.breakpoint),
                    onLayoutChange: this.onLayoutChange,
                    layout: this.state.layout,
                    cols: this.state.cols
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) /*: ?$Shape<State>*/ {
                if (!(0, _lodash.default)(nextProps.layouts, prevState.layouts)) {
                    // Allow parent to set layouts directly.
                    var breakpoint = prevState.breakpoint, _cols = prevState.cols; // Since we're setting an entirely new layout object, we must generate a new responsive layout
                    // if one does not exist.
                    var newLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, _cols, nextProps.compactType);
                    return {
                        layout: newLayout,
                        layouts: nextProps.layouts
                    };
                }
                return null;
            }
        }
    ]);
    return ResponsiveReactGridLayout;
}(React.Component);
exports.default = ResponsiveReactGridLayout;
_defineProperty(ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: _propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: _propTypes.default.object,
    allowOverlap: _propTypes.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: _propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: _propTypes.default.oneOfType([
        _propTypes.default.array,
        _propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: _propTypes.default.oneOfType([
        _propTypes.default.array,
        _propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts: function layouts(props, propName) {
        if (type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + type(props[propName]));
        Object.keys(props[propName]).forEach(function(key) {
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, _utils.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: _propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: _propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: _propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: _propTypes.default.func
});
_defineProperty(ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    allowOverlap: false,
    onBreakpointChange: _utils.noop,
    onLayoutChange: _utils.noop,
    onWidthChange: _utils.noop
});

},{"c62eb11db86f83d7":"9njXz","6f7e566320038446":"bnNSm","c606c3955831aeda":"heWiN","db2321e68f3438af":"cVeAG","71b865f319bbc8a9":"lxM8B","b9efa97f3d60f705":"9TfNa"}],"lxM8B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findOrGenerateResponsiveLayout = findOrGenerateResponsiveLayout;
exports.getBreakpointFromWidth = getBreakpointFromWidth;
exports.getColsFromBreakpoint = getColsFromBreakpoint;
exports.sortBreakpoints = sortBreakpoints;
var _utils = require("f14931bd44e22b3");
/**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function getBreakpointFromWidth(breakpoints, width) /*: Breakpoint*/ {
    var sorted = sortBreakpoints(breakpoints);
    var matching = sorted[0];
    for(var i = 1, len = sorted.length; i < len; i++){
        var breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function getColsFromBreakpoint(breakpoint, cols) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function findOrGenerateResponsiveLayout(layouts, breakpoints, breakpoint, lastBreakpoint, cols, compactType) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, _utils.cloneLayout)(layouts[breakpoint]); // Find or generate the next layout
    var layout = layouts[lastBreakpoint];
    var breakpointsSorted = sortBreakpoints(breakpoints);
    var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(var i = 0, len = breakpointsAbove.length; i < len; i++){
        var b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, _utils.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, _utils.compact)((0, _utils.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function sortBreakpoints(breakpoints) /*: Array<Breakpoint>*/ {
    var keys = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

},{"f14931bd44e22b3":"cVeAG"}],"eUSGn":[function(require,module,exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = WidthProvideRGL;
var React = _interopRequireWildcard(require("c94a10d52a7721d7"));
var _propTypes = _interopRequireDefault(require("8e644f2a56dcf21f"));
var _clsx = _interopRequireDefault(require("c7463e11bcf1c801"));
var _excluded = [
    "measureBeforeMount"
];
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var layoutClassName = "react-grid-layout";
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function WidthProvideRGL(ComposedComponent) /*: React.AbstractComponent<ComposedProps<Config>>*/ {
    var _class;
    return _class = /*#__PURE__*/ function(_React$Component) {
        _inherits(WidthProvider, _React$Component);
        var _super = _createSuper(WidthProvider);
        function WidthProvider() {
            var _this;
            _classCallCheck(this, WidthProvider);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _defineProperty(_assertThisInitialized(_this), "state", {
                width: 1280
            });
            _defineProperty(_assertThisInitialized(_this), "elementRef", /*#__PURE__*/ React.createRef());
            _defineProperty(_assertThisInitialized(_this), "mounted", false);
            _defineProperty(_assertThisInitialized(_this), "onWindowResize", function() {
                if (!_this.mounted) return;
                var node = _this.elementRef.current; // Flow casts this to Text | Element
                // fix: grid position error when node or parentNode display is none by window resize
                // #924 #1084
                if (node instanceof HTMLElement && node.offsetWidth) _this.setState({
                    width: node.offsetWidth
                });
            });
            return _this;
        }
        _createClass(WidthProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.mounted = true;
                    window.addEventListener("resize", this.onWindowResize); // Call to properly set the breakpoint and resize the elements.
                    // Note that if you're doing a full-width element, this can get a little wonky if a scrollbar
                    // appears because of the grid. In that case, fire your own resize event, or set `overflow: scroll` on your body.
                    this.onWindowResize();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.mounted = false;
                    window.removeEventListener("resize", this.onWindowResize);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, measureBeforeMount = _this$props.measureBeforeMount, rest = _objectWithoutProperties(_this$props, _excluded);
                    if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ React.createElement("div", {
                        className: (0, _clsx.default)(this.props.className, layoutClassName),
                        style: this.props.style // $FlowIgnore ref types
                        ,
                        ref: this.elementRef
                    });
                    return /*#__PURE__*/ React.createElement(ComposedComponent, _extends({
                        innerRef: this.elementRef
                    }, rest, this.state));
                }
            }
        ]);
        return WidthProvider;
    }(React.Component), _defineProperty(_class, "defaultProps", {
        measureBeforeMount: false
    }), _defineProperty(_class, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: _propTypes.default.bool
    }), _class;
}

},{"c94a10d52a7721d7":"9njXz","8e644f2a56dcf21f":"bnNSm","c7463e11bcf1c801":"5PNR8"}],"7hX7V":[function(require,module,exports) {
module.exports = require("d9f809c0d07d35e0");

},{"d9f809c0d07d35e0":"7e6HH"}],"7e6HH":[function(require,module,exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
var React = require("5208d6b05c49ef89");
var PropTypes = require("6009d1c9773c1506");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/*
The MIT License (MIT)

Copyright (c) 2015 instructure-react

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/ var uncheckedIcon = React.createElement("svg", {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: {
        position: "absolute",
        top: 0
    }
}, React.createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
}));
var checkedIcon = React.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: {
        position: "absolute",
        top: 0
    }
}, React.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
}));
function createBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
    var relativePos = (pos - uncheckedPos) / (checkedPos - uncheckedPos);
    if (relativePos === 0) return offColor;
    if (relativePos === 1) return onColor;
    var newColor = "#";
    for(var i = 1; i < 6; i += 2){
        var offComponent = parseInt(offColor.substr(i, 2), 16);
        var onComponent = parseInt(onColor.substr(i, 2), 16);
        var weightedValue = Math.round((1 - relativePos) * offComponent + relativePos * onComponent);
        var newComponent = weightedValue.toString(16);
        if (newComponent.length === 1) newComponent = "0" + newComponent;
        newColor += newComponent;
    }
    return newColor;
}
function convertShorthandColor(color) {
    if (color.length === 7) return color;
    var sixDigitColor = "#";
    for(var i = 1; i < 4; i += 1)sixDigitColor += color[i] + color[i];
    return sixDigitColor;
}
function getBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
    var sixDigitOffColor = convertShorthandColor(offColor);
    var sixDigitOnColor = convertShorthandColor(onColor);
    return createBackgroundColor(pos, checkedPos, uncheckedPos, sixDigitOffColor, sixDigitOnColor);
}
// Make sure color props are strings that start with "#" since other ways to write colors are not supported.
var hexColorPropType = function(props, propName, componentName) {
    var prop = props[propName];
    if (typeof prop !== "string" || prop[0] !== "#" || prop.length !== 4 && prop.length !== 7) return new Error("Invalid prop '" + propName + "' supplied to '" + componentName + "'. '" + propName + "' has to be either a 3-digit or 6-digit hex-color string. Valid examples: '#abc', '#123456'");
    return null;
};
function objectWithoutProperties(obj, exclude) {
    var target = {};
    for(var k in obj)if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
    return target;
}
var ReactSwitch = /*@__PURE__*/ function(Component) {
    function ReactSwitch(props) {
        Component.call(this, props);
        var height = props.height;
        var width = props.width;
        var handleDiameter = props.handleDiameter;
        var checked = props.checked;
        this.$handleDiameter = handleDiameter || height - 2;
        this.$checkedPos = Math.max(width - height, width - (height + this.$handleDiameter) / 2);
        this.$uncheckedPos = Math.max(0, (height - this.$handleDiameter) / 2);
        this.state = {
            $pos: checked ? this.$checkedPos : this.$uncheckedPos
        };
        this.$lastDragAt = 0;
        this.$lastKeyUpAt = 0;
        this.$onMouseDown = this.$onMouseDown.bind(this);
        this.$onMouseMove = this.$onMouseMove.bind(this);
        this.$onMouseUp = this.$onMouseUp.bind(this);
        this.$onTouchStart = this.$onTouchStart.bind(this);
        this.$onTouchMove = this.$onTouchMove.bind(this);
        this.$onTouchEnd = this.$onTouchEnd.bind(this);
        this.$onClick = this.$onClick.bind(this);
        this.$onInputChange = this.$onInputChange.bind(this);
        this.$onKeyUp = this.$onKeyUp.bind(this);
        this.$setHasOutline = this.$setHasOutline.bind(this);
        this.$unsetHasOutline = this.$unsetHasOutline.bind(this);
        this.$getInputRef = this.$getInputRef.bind(this);
    }
    if (Component) ReactSwitch.__proto__ = Component;
    ReactSwitch.prototype = Object.create(Component && Component.prototype);
    ReactSwitch.prototype.constructor = ReactSwitch;
    ReactSwitch.prototype.componentDidMount = function componentDidMount() {
        this.$isMounted = true;
    };
    ReactSwitch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.checked === this.props.checked) return;
        var $pos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
        this.setState({
            $pos: $pos
        });
    };
    ReactSwitch.prototype.componentWillUnmount = function componentWillUnmount() {
        this.$isMounted = false;
    };
    ReactSwitch.prototype.$onDragStart = function $onDragStart(clientX) {
        this.$inputRef.focus();
        this.setState({
            $startX: clientX,
            $hasOutline: true,
            $dragStartingTime: Date.now()
        });
    };
    ReactSwitch.prototype.$onDrag = function $onDrag(clientX) {
        var ref = this.state;
        var $startX = ref.$startX;
        var $isDragging = ref.$isDragging;
        var $pos = ref.$pos;
        var ref$1 = this.props;
        var checked = ref$1.checked;
        var startPos = checked ? this.$checkedPos : this.$uncheckedPos;
        var mousePos = startPos + clientX - $startX; // We need this check to fix a windows glitch where onDrag is triggered onMouseDown in some cases
        if (!$isDragging && clientX !== $startX) this.setState({
            $isDragging: true
        });
        var newPos = Math.min(this.$checkedPos, Math.max(this.$uncheckedPos, mousePos)); // Prevent unnecessary rerenders
        if (newPos !== $pos) this.setState({
            $pos: newPos
        });
    };
    ReactSwitch.prototype.$onDragStop = function $onDragStop(event) {
        var ref = this.state;
        var $pos = ref.$pos;
        var $isDragging = ref.$isDragging;
        var $dragStartingTime = ref.$dragStartingTime;
        var ref$1 = this.props;
        var checked = ref$1.checked;
        var halfwayCheckpoint = (this.$checkedPos + this.$uncheckedPos) / 2;
        /*
      Set position state back to the previous position even if user drags the switch with intention to change the state.
      This is to prevent the switch from getting stuck in the middle if the event isn't handled in the onChange callback.
    */ var prevPos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
        this.setState({
            $pos: prevPos
        }); // Act as if the user clicked the handle if they didn't drag it _or_ the dragged it for less than 250ms
        var timeSinceStart = Date.now() - $dragStartingTime;
        var isSimulatedClick = !$isDragging || timeSinceStart < 250; // Handle when the user has dragged the switch more than halfway from either side
        var isDraggedHalfway = checked && $pos <= halfwayCheckpoint || !checked && $pos >= halfwayCheckpoint;
        if (isSimulatedClick || isDraggedHalfway) this.$onChange(event);
        if (this.$isMounted) this.setState({
            $isDragging: false,
            $hasOutline: false
        });
        this.$lastDragAt = Date.now();
    };
    ReactSwitch.prototype.$onMouseDown = function $onMouseDown(event) {
        event.preventDefault(); // Ignore right click and scroll
        if (typeof event.button === "number" && event.button !== 0) return;
        this.$onDragStart(event.clientX);
        window.addEventListener("mousemove", this.$onMouseMove);
        window.addEventListener("mouseup", this.$onMouseUp);
    };
    ReactSwitch.prototype.$onMouseMove = function $onMouseMove(event) {
        event.preventDefault();
        this.$onDrag(event.clientX);
    };
    ReactSwitch.prototype.$onMouseUp = function $onMouseUp(event) {
        this.$onDragStop(event);
        window.removeEventListener("mousemove", this.$onMouseMove);
        window.removeEventListener("mouseup", this.$onMouseUp);
    };
    ReactSwitch.prototype.$onTouchStart = function $onTouchStart(event) {
        this.$checkedStateFromDragging = null;
        this.$onDragStart(event.touches[0].clientX);
    };
    ReactSwitch.prototype.$onTouchMove = function $onTouchMove(event) {
        this.$onDrag(event.touches[0].clientX);
    };
    ReactSwitch.prototype.$onTouchEnd = function $onTouchEnd(event) {
        event.preventDefault();
        this.$onDragStop(event);
    };
    ReactSwitch.prototype.$onInputChange = function $onInputChange(event) {
        // This condition is unfortunately needed in some browsers where the input's change event might get triggered
        // right after the dragstop event is triggered (occurs when dropping over a label element)
        if (Date.now() - this.$lastDragAt > 50) {
            this.$onChange(event); // Prevent clicking label, but not key activation from setting outline to true - yes, this is absurd
            if (Date.now() - this.$lastKeyUpAt > 50) {
                if (this.$isMounted) this.setState({
                    $hasOutline: false
                });
            }
        }
    };
    ReactSwitch.prototype.$onKeyUp = function $onKeyUp() {
        this.$lastKeyUpAt = Date.now();
    };
    ReactSwitch.prototype.$setHasOutline = function $setHasOutline() {
        this.setState({
            $hasOutline: true
        });
    };
    ReactSwitch.prototype.$unsetHasOutline = function $unsetHasOutline() {
        this.setState({
            $hasOutline: false
        });
    };
    ReactSwitch.prototype.$getInputRef = function $getInputRef(el) {
        this.$inputRef = el;
    };
    ReactSwitch.prototype.$onClick = function $onClick(event) {
        event.preventDefault();
        this.$inputRef.focus();
        this.$onChange(event);
        if (this.$isMounted) this.setState({
            $hasOutline: false
        });
    };
    ReactSwitch.prototype.$onChange = function $onChange(event) {
        var ref = this.props;
        var checked = ref.checked;
        var onChange = ref.onChange;
        var id = ref.id;
        onChange(!checked, event, id);
    };
    ReactSwitch.prototype.render = function render() {
        var ref = this.props;
        var checked = ref.checked;
        var disabled = ref.disabled;
        var className = ref.className;
        var offColor = ref.offColor;
        var onColor = ref.onColor;
        var offHandleColor = ref.offHandleColor;
        var onHandleColor = ref.onHandleColor;
        var checkedIcon = ref.checkedIcon;
        var uncheckedIcon = ref.uncheckedIcon;
        var checkedHandleIcon = ref.checkedHandleIcon;
        var uncheckedHandleIcon = ref.uncheckedHandleIcon;
        var boxShadow = ref.boxShadow;
        var activeBoxShadow = ref.activeBoxShadow;
        var height = ref.height;
        var width = ref.width;
        var borderRadius = ref.borderRadius;
        ref.handleDiameter;
        var rest$1 = objectWithoutProperties(ref, [
            "checked",
            "disabled",
            "className",
            "offColor",
            "onColor",
            "offHandleColor",
            "onHandleColor",
            "checkedIcon",
            "uncheckedIcon",
            "checkedHandleIcon",
            "uncheckedHandleIcon",
            "boxShadow",
            "activeBoxShadow",
            "height",
            "width",
            "borderRadius",
            "handleDiameter"
        ]);
        var rest = rest$1;
        var ref$1 = this.state;
        var $pos = ref$1.$pos;
        var $isDragging = ref$1.$isDragging;
        var $hasOutline = ref$1.$hasOutline;
        var rootStyle = {
            position: "relative",
            display: "inline-block",
            textAlign: "left",
            opacity: disabled ? 0.5 : 1,
            direction: "ltr",
            borderRadius: height / 2,
            WebkitTransition: "opacity 0.25s",
            MozTransition: "opacity 0.25s",
            transition: "opacity 0.25s",
            touchAction: "none",
            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            userSelect: "none"
        };
        var backgroundStyle = {
            height: height,
            width: width,
            margin: Math.max(0, (this.$handleDiameter - height) / 2),
            position: "relative",
            background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offColor, onColor),
            borderRadius: typeof borderRadius === "number" ? borderRadius : height / 2,
            cursor: disabled ? "default" : "pointer",
            WebkitTransition: $isDragging ? null : "background 0.25s",
            MozTransition: $isDragging ? null : "background 0.25s",
            transition: $isDragging ? null : "background 0.25s"
        };
        var checkedIconStyle = {
            height: height,
            width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
            position: "relative",
            opacity: ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
            pointerEvents: "none",
            WebkitTransition: $isDragging ? null : "opacity 0.25s",
            MozTransition: $isDragging ? null : "opacity 0.25s",
            transition: $isDragging ? null : "opacity 0.25s"
        };
        var uncheckedIconStyle = {
            height: height,
            width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
            position: "absolute",
            opacity: 1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
            right: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: $isDragging ? null : "opacity 0.25s",
            MozTransition: $isDragging ? null : "opacity 0.25s",
            transition: $isDragging ? null : "opacity 0.25s"
        };
        var handleStyle = {
            height: this.$handleDiameter,
            width: this.$handleDiameter,
            background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offHandleColor, onHandleColor),
            display: "inline-block",
            cursor: disabled ? "default" : "pointer",
            borderRadius: typeof borderRadius === "number" ? borderRadius - 1 : "50%",
            position: "absolute",
            transform: "translateX(" + $pos + "px)",
            top: Math.max(0, (height - this.$handleDiameter) / 2),
            outline: 0,
            boxShadow: $hasOutline ? activeBoxShadow : boxShadow,
            border: 0,
            WebkitTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            MozTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            transition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
        };
        var uncheckedHandleIconStyle = {
            height: this.$handleDiameter,
            width: this.$handleDiameter,
            opacity: Math.max((1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: $isDragging ? null : "opacity 0.25s",
            MozTransition: $isDragging ? null : "opacity 0.25s",
            transition: $isDragging ? null : "opacity 0.25s"
        };
        var checkedHandleIconStyle = {
            height: this.$handleDiameter,
            width: this.$handleDiameter,
            opacity: Math.max((($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: $isDragging ? null : "opacity 0.25s",
            MozTransition: $isDragging ? null : "opacity 0.25s",
            transition: $isDragging ? null : "opacity 0.25s"
        };
        var inputStyle = {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: 1,
            margin: -1,
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            width: 1
        };
        return React.createElement("div", {
            className: className,
            style: rootStyle
        }, React.createElement("div", {
            className: "react-switch-bg",
            style: backgroundStyle,
            onClick: disabled ? null : this.$onClick,
            onMouseDown: function(e) {
                return e.preventDefault();
            }
        }, checkedIcon && React.createElement("div", {
            style: checkedIconStyle
        }, checkedIcon), uncheckedIcon && React.createElement("div", {
            style: uncheckedIconStyle
        }, uncheckedIcon)), React.createElement("div", {
            className: "react-switch-handle",
            style: handleStyle,
            onClick: function(e) {
                return e.preventDefault();
            },
            onMouseDown: disabled ? null : this.$onMouseDown,
            onTouchStart: disabled ? null : this.$onTouchStart,
            onTouchMove: disabled ? null : this.$onTouchMove,
            onTouchEnd: disabled ? null : this.$onTouchEnd,
            onTouchCancel: disabled ? null : this.$unsetHasOutline
        }, uncheckedHandleIcon && React.createElement("div", {
            style: uncheckedHandleIconStyle
        }, uncheckedHandleIcon), checkedHandleIcon && React.createElement("div", {
            style: checkedHandleIconStyle
        }, checkedHandleIcon)), React.createElement("input", _extends({}, {
            type: "checkbox",
            role: "switch",
            "aria-checked": checked,
            checked: checked,
            disabled: disabled,
            style: inputStyle
        }, rest, {
            ref: this.$getInputRef,
            onFocus: this.$setHasOutline,
            onBlur: this.$unsetHasOutline,
            onKeyUp: this.$onKeyUp,
            onChange: this.$onInputChange
        })));
    };
    return ReactSwitch;
}(React.Component);
ReactSwitch.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    offColor: hexColorPropType,
    onColor: hexColorPropType,
    offHandleColor: hexColorPropType,
    onHandleColor: hexColorPropType,
    handleDiameter: PropTypes.number,
    uncheckedIcon: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.element
    ]),
    checkedIcon: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.element
    ]),
    boxShadow: PropTypes.string,
    borderRadius: PropTypes.number,
    activeBoxShadow: PropTypes.string,
    uncheckedHandleIcon: PropTypes.element,
    checkedHandleIcon: PropTypes.element,
    height: PropTypes.number,
    width: PropTypes.number,
    id: PropTypes.string,
    className: PropTypes.string
};
ReactSwitch.defaultProps = {
    disabled: false,
    offColor: "#888",
    onColor: "#080",
    offHandleColor: "#fff",
    onHandleColor: "#fff",
    uncheckedIcon: uncheckedIcon,
    checkedIcon: checkedIcon,
    boxShadow: null,
    activeBoxShadow: "0 0 2px 3px #3bf",
    height: 28,
    width: 56
};
exports["default"] = ReactSwitch;

},{"5208d6b05c49ef89":"9njXz","6009d1c9773c1506":"bnNSm"}],"kNRx3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class SessionStorageService {
    getObjectItemByKey(key) {
        try {
            const item = JSON.parse(window.sessionStorage.getItem(key) || "{}");
            return item;
        } catch ({ message }) {
            return message;
        }
    }
    setItem(key, value) {
        if (!window && !window.sessionStorage) return;
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }
}
exports.default = SessionStorageService;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6sUgi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var _widgetTypes = require("../Constants/WidgetTypes");
var _sessionStorageService = require("../Services/SessionStorageService");
var _sessionStorageServiceDefault = parcelHelpers.interopDefault(_sessionStorageService);
var _templateDashboardService = require("../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
var _widgetUtils = require("./WidgetUtils");
var _widgetUtilsDefault = parcelHelpers.interopDefault(_widgetUtils);
const NON_SIGNAL_TYPES = new Set([
    (0, _widgetTypes.BAR_ENGINE_UTILIZATION),
    (0, _widgetTypes.BAR_FUEL_UTILIZATION),
    (0, _widgetTypes.LOCATION),
    (0, _widgetTypes.MAINTENANCE),
    (0, _widgetTypes.MAP),
    (0, _widgetTypes.TEXT_ENGINE),
    (0, _widgetTypes.TEXT_FUEL)
]);
class WidgetUpdateHelper {
    sessionStorageService = new (0, _sessionStorageServiceDefault.default)();
    templateDashboardService = new (0, _templateDashboardServiceDefault.default)();
    widgetUtils = new (0, _widgetUtilsDefault.default)();
    async updateGridLayout(currentWidgets, templateID, dashboard, cancelToken) {
        if (!Array.isArray(currentWidgets) || !currentWidgets.length) throw new Error("No widgets to update");
        const layout = this.sessionStorageService.getObjectItemByKey("gridLayout");
        if (!Array.isArray(layout) || !layout.length) throw new Error("Error retrieving grid layout. Please try again.");
        const layoutDictionary = layout.reduce((acc, l)=>{
            acc[l.i] = l;
            return acc;
        }, {});
        const updates = currentWidgets.filter(({ updated })=>updated);
        if (!updates.length) return currentWidgets;
        const updatedWidgets = currentWidgets.map((widget)=>{
            return this.formWidgetLayoutUpdateBody(layoutDictionary, widget);
        });
        const { _id: dashboardID, name } = dashboard || {};
        const { widgets } = await this.templateDashboardService.updateTemplateDashboard(templateID, dashboardID, {
            name,
            widgets: updatedWidgets
        }, cancelToken);
        return widgets;
    }
    widgetHasBeenUpdated(layout, widget) {
        const { _id, col, row, sizeX, sizeY } = widget;
        const { w, h, x, y } = layout[_id] || {};
        const heightChanged = h !== sizeY;
        const widthChanged = w !== sizeX;
        const rowChanged = y !== row;
        const colChanged = x !== col;
        return heightChanged || widthChanged || rowChanged || colChanged;
    }
    formWidgetLayoutUpdateBody(layout, { updated, ...widget }) {
        const { h, w, x, y } = layout[widget._id] || {};
        return {
            ...widget,
            sizeY: h,
            sizeX: w,
            col: x,
            row: y
        };
    }
    _formTimeSeriesWidgetUpdate(widgetSignals, isImageOverlay) {
        const update = widgetSignals.map(({ datapoint, signal, x, y })=>{
            if (!datapoint.value) throw new Error("Smart Tile must have datapoint selected!");
            else if (!signal.label) throw new Error("Smart Tile must have signal selected");
            const conditionalImageOverlyProps = isImageOverlay ? {
                x,
                y
            } : {};
            let conditionalType = {};
            let datapointID = datapoint.value;
            if (datapoint.value === "outputSignal") {
                conditionalType = {
                    type: datapoint.value
                };
                if (!signal?.value?._id) throw new Error("Smart Tile must have signal selected");
                datapointID = signal.value._id;
            }
            return {
                ...conditionalImageOverlyProps,
                ...conditionalType,
                datapointID,
                key: signal.label
            };
        }).filter((u)=>!!u);
        if ((0, _isEmptyDefault.default)(update)) throw new Error("Signal must be selected for smart tile.");
        return update;
    }
    setCommandSettings(widgetSignals = []) {
        return widgetSignals.map((c)=>{
            const { color, command: { value } = {}, friendlyName } = c || {};
            if (!color || !value || !friendlyName) throw new Error("Each row must have a command, friendly name and color selected.");
            return {
                color,
                commandID: value,
                friendlyName
            };
        });
    }
    buildUpdateRequestBody(updates, { _id, image, type, settings }, { datapoints }, imageCoordinatesMap) {
        const { displayTextAsGrid, selectedAggregation, selectedInstances, showTimeSinceLastUpdated, widgetName, widgetSignals } = updates;
        if (!widgetSignals.length && !NON_SIGNAL_TYPES.has(type)) throw new Error("Signal must be selected for smart tile.");
        if (type === (0, _widgetTypes.MAINTENANCE) && !selectedInstances?.length) throw new Error("Reminder must be selected for smart tile.");
        const conditionalImageSetting = type === (0, _widgetTypes.IMAGE) ? {
            image
        } : {};
        const conditionalMaintenanceSetting = type === (0, _widgetTypes.MAINTENANCE) ? {
            maintenance: selectedInstances.map((opt)=>({
                    reminder_id: opt.value,
                    reminder_name: opt.label
                }))
        } : {};
        const conditionalTextSettings = type === (0, _widgetTypes.TEXT) ? {
            displayTextAsGrid,
            showTimeSinceLastUpdated
        } : {};
        const conditionalUtilizationSettings = (0, _widgetTypes.HISTORICAL_UTILIZATION_TYPES).has(type) ? {
            aggregation: selectedAggregation
        } : {};
        const body = {
            _id,
            settings: {
                ...conditionalImageSetting,
                ...conditionalMaintenanceSetting,
                ...conditionalTextSettings,
                ...conditionalUtilizationSettings,
                title: widgetName
            },
            type
        };
        if ((0, _widgetTypes.MIN_MAX_TYPE_SET).has(type)) {
            const yMax = Number.parseFloat(updates.yMax), yMin = Number.parseFloat(updates.yMin);
            if (Number.isFinite(yMax)) body.settings.yMax = yMax;
            if (Number.isFinite(yMin)) body.settings.yMin = yMin;
        }
        const { settingsSignalArrayNameMap } = this.widgetUtils;
        const isImageOverlay = type === (0, _widgetTypes.IMAGE);
        switch(true){
            case type === (0, _widgetTypes.COMMAND):
                body.settings = {
                    ...body.settings,
                    commands: this.setCommandSettings(widgetSignals)
                };
                break;
            case settingsSignalArrayNameMap.has(type):
                body.settings[settingsSignalArrayNameMap.get(type)] = this._formTimeSeriesWidgetUpdate(isImageOverlay ? [
                    ...imageCoordinatesMap.values()
                ] : widgetSignals, isImageOverlay);
                break;
            case type === (0, _widgetTypes.GAUGE):
                {
                    const [{ datapoint: { value: selectedDP }, maxValue, minValue, signal }, { datapoint: datapoint2, maxValue: maxValue2, minValue: minValue2, signal: signal2 } = {}] = widgetSignals;
                    if ((0, _isEmptyDefault.default)(selectedDP) || (0, _isEmptyDefault.default)(signal)) throw new Error("Signal must be selected for smart tile.");
                    const max = Number.parseFloat(maxValue);
                    const min = Number.parseFloat(minValue);
                    if (Number.isNaN(max) || Number.isNaN(min)) throw new Error("Min and Max must be configured.");
                    if (max <= min) throw new Error("Max value must be greater than min.");
                    if (selectedDP === "outputSignal") {
                        body.settings.type = selectedDP;
                        body.settings.datapoint = signal.value;
                        body.settings.datapointID = signal.value?._id;
                    } else {
                        body.settings.datapoint = datapoints.find(({ _id })=>_id === selectedDP);
                        body.settings.datapointID = selectedDP;
                    }
                    body.settings.key = signal.label;
                    body.settings.max = max;
                    body.settings.min = min;
                    if (datapoint2?.value) {
                        const max2 = Number.parseFloat(maxValue2);
                        const min2 = Number.parseFloat(minValue2);
                        if (Number.isNaN(max2) || Number.isNaN(min2)) throw new Error("Min and Max must be configured.");
                        if (max2 <= min2) throw new Error("Max value must be greater than min.");
                        if (datapoint2?.value === "outputSignal") body.settings.secondGauge = {
                            datapoint: signal2?.value,
                            datapointID: signal2?.value?._id,
                            key: signal2?.label,
                            max: max2,
                            min: min2,
                            type: datapoint2.value
                        };
                        else body.settings.secondGauge = {
                            datapoint: datapoints.find(({ _id })=>_id === datapoint2.value),
                            datapointID: datapoint2.value,
                            key: signal2?.label,
                            max: max2,
                            min: min2
                        };
                    }
                    break;
                }
            case type === (0, _widgetTypes.GAUGE_RANGE):
                {
                    const [{ datapoint: { value: selectedDP }, ranges, signal }, { datapoint: datapoint2, ranges: ranges2, signal: signal2 } = {}] = widgetSignals;
                    if ((0, _isEmptyDefault.default)(selectedDP) || (0, _isEmptyDefault.default)(signal)) throw new Error("Signal must be selected for smart tile.");
                    const firstWidgetRanges = ranges.map(({ color, label, maxValue, minValue })=>{
                        validateWidgetRanges({
                            color,
                            label,
                            maxValue,
                            minValue
                        });
                        const max = Number.parseFloat(maxValue);
                        const min = Number.parseFloat(minValue);
                        return {
                            color,
                            label,
                            max,
                            min
                        };
                    });
                    if (selectedDP === "outputSignal") {
                        body.settings.type = selectedDP;
                        body.settings.datapoint = signal.value;
                        body.settings.datapointID = signal.value?._id;
                    } else {
                        body.settings.datapoint = datapoints.find(({ _id })=>_id === selectedDP);
                        body.settings.datapointID = selectedDP;
                    }
                    body.settings.key = signal.label;
                    body.settings.ranges = firstWidgetRanges;
                    if (datapoint2?.value) {
                        const secondWidgetRanges = ranges2.map(({ color, label, maxValue, minValue })=>{
                            validateWidgetRanges({
                                color,
                                label,
                                maxValue,
                                minValue
                            });
                            const max = Number.parseFloat(maxValue);
                            const min = Number.parseFloat(minValue);
                            return {
                                color,
                                label,
                                max,
                                min
                            };
                        });
                        if (datapoint2?.value === "outputSignal") body.settings.secondGauge = {
                            datapoint: signal2?.value,
                            datapointID: signal2?.value?._id,
                            key: signal2.label,
                            ranges: secondWidgetRanges
                        };
                        else body.settings.secondGauge = {
                            datapoint: datapoints.find(({ _id })=>_id === datapoint2.value),
                            datapointID: datapoint2.value,
                            key: signal2.label,
                            ranges: secondWidgetRanges
                        };
                    }
                    break;
                }
            case [
                (0, _widgetTypes.LOCATION),
                (0, _widgetTypes.MAP)
            ].includes(type):
                body.settings = {
                    ...settings,
                    ...body.settings
                };
                break;
            case type === (0, _widgetTypes.TEXT_STATIC):
                {
                    const [{ links: inputLinks, value: staticText = "" } = {}] = widgetSignals;
                    if (!staticText || staticText.length > 512) throw new Error("Text required. Maximum characters allowed is 512");
                    const links = inputLinks?.reduce?.((acc, l)=>l?.display && l?.url ? acc.concat(l) : acc, []);
                    body.settings.links = links;
                    body.settings.staticText = staticText;
                    break;
                }
            case type === (0, _widgetTypes.TEXT_TAGS):
                body.settings.tags = widgetSignals.map(({ value })=>value).filter((t)=>!!t);
                break;
            default:
                break;
        }
        return body;
    }
}
exports.default = WidgetUpdateHelper;
function validateWidgetRanges({ color, label, maxValue, minValue }) {
    if (!(0, _tinycolor2Default.default)(color).isValid()) throw new Error("Valid hex color must be configured for each range.");
    if (!label) throw new Error("Label must be configured for each range.");
    if (Number.isNaN(Number.parseFloat(maxValue))) throw new Error("Max value for ranges must be a valid floating point number.");
    if (Number.isNaN(Number.parseFloat(minValue))) throw new Error("Min value for ranges must be a valid floating point number.");
    if (Number.parseFloat(maxValue) < Number.parseFloat(minValue)) throw new Error("Max value must be greater than Min value for each range.");
    if (Number.parseFloat(minValue) > Number.parseFloat(maxValue)) throw new Error("Min value must be less than Max value for each range.");
}

},{"lodash/isEmpty":"6WyGC","tinycolor2":"4AVaN","../Constants/WidgetTypes":"frQz2","../Services/SessionStorageService":"kNRx3","../Services/TemplateDashboardService":"kZyFp","./WidgetUtils":"uF2rc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AVaN":[function(require,module,exports) {
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});

},{}],"uF2rc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENGINE_HOURS_HELP_TEXT", ()=>ENGINE_HOURS_HELP_TEXT);
parcelHelpers.export(exports, "FUEL_USED_HELP_TEXT", ()=>FUEL_USED_HELP_TEXT);
parcelHelpers.export(exports, "GAUGE_HELP_TEXT", ()=>GAUGE_HELP_TEXT);
parcelHelpers.export(exports, "IMAGE_HELP_TEXT", ()=>IMAGE_HELP_TEXT);
parcelHelpers.export(exports, "MAINTENANCE_HELP_TEXT", ()=>MAINTENANCE_HELP_TEXT);
parcelHelpers.export(exports, "MAP_HELP_TEXT", ()=>MAP_HELP_TEXT);
parcelHelpers.export(exports, "SCAN_SIGNAL_TEXT", ()=>SCAN_SIGNAL_TEXT);
parcelHelpers.export(exports, "TEN_SIGNAL_TEXT", ()=>TEN_SIGNAL_TEXT);
parcelHelpers.export(exports, "TEXT_STATIC_HELP_TEXT", ()=>TEXT_STATIC_HELP_TEXT);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _round = require("lodash/round");
var _roundDefault = parcelHelpers.interopDefault(_round);
var _uuid = require("uuid");
var _signal = require("../Constants/Signal");
var _signalCollection = require("../Constants/SignalCollection");
var _staticUUIDs = require("../Constants/StaticUUIDs");
var _widgetTypes = require("../Constants/WidgetTypes");
const ENGINE_HOURS_HELP_TEXT = 'Note: Engine Hours Utilization Tile requires Engine Hours "reporting_type" to be configured on Asset Model Signals';
const FUEL_USED_HELP_TEXT = 'Note: Fuel Used Utilization Tile requires Fuel Used "reporting_type" to be configured on Asset Model Signals';
const GAUGE_HELP_TEXT = "Configure 1 or 2 gauges for display on this smart tile";
const IMAGE_HELP_TEXT = "Click on the image below to add up to 10 signals for this smart tile";
const MAINTENANCE_HELP_TEXT = "Select Maintenance Reminders to display in this smart tile";
const MAP_HELP_TEXT = "All map widgets are configured automatically, there's no need to select any collections or signals";
const SCAN_SIGNAL_TEXT = "Choose either a CAN or J1939 Scan signal";
const TEN_SIGNAL_TEXT = "You can add up to 10 signals for this smart tile";
const TEXT_STATIC_HELP_TEXT = "Add up to 512 characters of freeform text to be displayed on the dashboard";
class WidgetUtils {
    constructor(){
        this.types = [
            {
                helpText: TEN_SIGNAL_TEXT,
                label: "Area Line Chart",
                maxSignals: 10,
                value: (0, _widgetTypes.AREA)
            },
            {
                helpText: ENGINE_HOURS_HELP_TEXT,
                label: "Bar Chart - Engine Hour Utilization",
                value: (0, _widgetTypes.BAR_ENGINE_UTILIZATION)
            },
            {
                helpText: FUEL_USED_HELP_TEXT,
                label: "Bar Chart - Fuel Used Utilization",
                value: (0, _widgetTypes.BAR_FUEL_UTILIZATION)
            },
            {
                helpText: TEN_SIGNAL_TEXT,
                label: "Bar Chart - Horizontal",
                maxSignals: 10,
                value: (0, _widgetTypes.COLUMN_GRAPH)
            },
            {
                helpText: TEN_SIGNAL_TEXT,
                label: "Bar Chart - Vertical",
                maxSignals: 10,
                value: (0, _widgetTypes.VERTICAL_COLUMN_GRAPH)
            },
            {
                label: "Boolean - Latest Data Available",
                value: (0, _widgetTypes.BOOLEAN)
            },
            {
                helpText: SCAN_SIGNAL_TEXT,
                label: "CAN/J1939 Scan",
                maxSignals: 1,
                value: (0, _widgetTypes.CAN_SCAN)
            },
            {
                label: "Command and Control",
                value: (0, _widgetTypes.COMMAND)
            },
            {
                helpText: MAP_HELP_TEXT,
                label: "Current Asset Location",
                maxSignals: 2,
                value: (0, _widgetTypes.MAP)
            },
            {
                helpText: GAUGE_HELP_TEXT,
                label: "Gauge - Most Recent Value",
                maxSignals: 2,
                value: (0, _widgetTypes.GAUGE)
            },
            {
                helpText: GAUGE_HELP_TEXT,
                label: "Gauge - Flexible Range Values",
                maxSignals: 2,
                value: (0, _widgetTypes.GAUGE_RANGE)
            },
            {
                helpText: IMAGE_HELP_TEXT,
                label: "Image Overlay",
                maxSignals: 10,
                value: (0, _widgetTypes.IMAGE)
            },
            {
                helpText: TEN_SIGNAL_TEXT,
                label: "Line Graph",
                maxSignals: 10,
                value: (0, _widgetTypes.LINE_GRAPH)
            },
            {
                helpText: MAINTENANCE_HELP_TEXT,
                label: "Maintenance",
                value: (0, _widgetTypes.MAINTENANCE)
            },
            {
                helpText: TEN_SIGNAL_TEXT,
                label: "Pie Chart",
                maxSignals: 10,
                value: (0, _widgetTypes.PIE)
            },
            {
                helpText: MAP_HELP_TEXT,
                label: "Recent Asset Path",
                maxSignals: 2,
                value: (0, _widgetTypes.LOCATION)
            },
            {
                label: "Text",
                value: (0, _widgetTypes.TEXT)
            },
            {
                helpText: TEXT_STATIC_HELP_TEXT,
                label: "Text (Static)",
                value: (0, _widgetTypes.TEXT_STATIC)
            },
            {
                label: "Text (Tags)",
                value: (0, _widgetTypes.TEXT_TAGS)
            },
            {
                helpText: ENGINE_HOURS_HELP_TEXT,
                label: "Text - Engine Hour Utilization",
                value: (0, _widgetTypes.TEXT_ENGINE)
            },
            {
                helpText: FUEL_USED_HELP_TEXT,
                label: "Text - Fuel Used Utilization",
                value: (0, _widgetTypes.TEXT_FUEL)
            }
        ];
        this.legacyTypes = [
            {
                helpText: TEN_SIGNAL_TEXT,
                label: "Line Graph",
                maxSignals: 10,
                value: (0, _widgetTypes.LINE_HIGH_CHART)
            },
            {
                helpText: TEN_SIGNAL_TEXT,
                label: "Bar Chart",
                maxSignals: 10,
                value: (0, _widgetTypes.HIGH_BAR)
            }
        ];
        this.settingsSignalArrayNameMap = new Map([
            [
                (0, _widgetTypes.AREA),
                "lines"
            ],
            [
                (0, _widgetTypes.BOOLEAN),
                (0, _widgetTypes.BOOLEAN)
            ],
            [
                (0, _widgetTypes.COLUMN_GRAPH),
                "columns"
            ],
            [
                (0, _widgetTypes.COMMAND),
                "commands"
            ],
            [
                (0, _widgetTypes.HIGH_BAR),
                "columns"
            ],
            [
                (0, _widgetTypes.IMAGE),
                "lines"
            ],
            [
                (0, _widgetTypes.LINE_GRAPH),
                "lines"
            ],
            [
                (0, _widgetTypes.LINE_HIGH_CHART),
                "lines"
            ],
            [
                (0, _widgetTypes.PIE),
                "lines"
            ],
            [
                (0, _widgetTypes.CAN_SCAN),
                (0, _widgetTypes.CAN_SCAN)
            ],
            [
                (0, _widgetTypes.TEXT),
                (0, _widgetTypes.TEXT)
            ],
            [
                (0, _widgetTypes.VERTICAL_COLUMN_GRAPH),
                "columns"
            ]
        ]);
        this.timeAggregationOptions = [
            {
                label: "Daily Aggregation",
                value: (0, _signal.DAILY)
            },
            {
                label: "Weekly Aggregation",
                value: (0, _signal.WEEKLY)
            },
            {
                label: "Monthly Aggregation",
                value: (0, _signal.MONTHLY)
            }
        ];
        this.widgetSignalDefault = {
            datapoint: {},
            maxValue: "",
            minValue: "",
            ranges: [
                {
                    id: (0, _uuid.v4)()
                }
            ],
            signal: {}
        };
        this.nonSignalTypes = new Set([
            (0, _widgetTypes.BAR_ENGINE_UTILIZATION),
            (0, _widgetTypes.BAR_FUEL_UTILIZATION),
            (0, _widgetTypes.COMMAND),
            (0, _widgetTypes.MAINTENANCE),
            (0, _widgetTypes.TEXT_ENGINE),
            (0, _widgetTypes.TEXT_FUEL),
            (0, _widgetTypes.TEXT_STATIC),
            (0, _widgetTypes.TEXT_TAGS)
        ]);
    }
    createDatapointMapForDisplay(datapoints = [], scanSelected) {
        const eventCollectionOptions = datapoints.map((dp)=>{
            const { _id: datapointID, name: datapointName, type, values } = dp;
            if (scanSelected && !(0, _signalCollection.SCAN_TYPE_SET).has(type)) return;
            return {
                value: datapointID,
                label: datapointName,
                values: values.map(({ _id, name, label })=>{
                    return {
                        value: _id,
                        label: name || label
                    };
                }).filter((s)=>!!s)
            };
        }).filter((dp)=>!!dp);
        const outputSignalOption = {
            label: "Calculated Signal",
            value: "outputSignal"
        };
        return [
            outputSignalOption,
            ...eventCollectionOptions
        ];
    }
    parseFetchedData(fetchedData, lines, last) {
        if (!lines.length) return new Map();
        return lines.reduce((map, { datapointID })=>{
            if (fetchedData.has(datapointID)) {
                const data = fetchedData.get(datapointID);
                const targetData = last ? data[0] || {} : data;
                map.set(datapointID, targetData);
            }
            return map;
        }, new Map());
    }
    parseEventsForLatest(lines, dataMap, max = null) {
        const signals = Array.from(dataMap.values()).reduce((acc, { signals } = {})=>{
            if (Object.keys(signals || {})?.length) acc.push(...Object.values(signals));
            return acc;
        }, []);
        return lines.reduce((series, { key }, i)=>{
            const { value } = signals.find(({ name })=>name === key) || {};
            if (max) lines[i].originalValue = value;
            series = value || [
                0,
                "0"
            ].includes(value) ? [
                ...series,
                {
                    name: key,
                    data: [
                        value
                    ]
                }
            ] : [
                ...series,
                {
                    name: key,
                    data: []
                }
            ];
            return series;
        }, []);
    }
    parseEventsForPieChart(lines, dataMap) {
        return lines.reduce((series, { datapointID, key })=>{
            const { signals } = dataMap.get(datapointID) ?? {};
            if (!Object.keys(signals || {})?.length) return series;
            const { value } = Object.values(signals).find(({ name })=>name === key) || {};
            if (!value && value !== 0) return series;
            return series.concat(value);
        }, []);
    }
    parseEventsForTimeseries(lines, dataMap, signalNamesMap, signalUnitsMap) {
        const series = lines.reduce((s, { key: name, datapointID, type })=>{
            return s.set(name, {
                name,
                data: [],
                datapointID,
                signalType: type
            });
        }, new Map());
        dataMap.forEach((value, key)=>{
            if ((0, _isEmptyDefault.default)(value)) return;
            for (const event of value){
                const { signals, createdAt } = event;
                const time = new Date(createdAt).getTime();
                Object.entries(signals || {}).forEach(([signalID, signal])=>{
                    const { name, value: val } = signal || {};
                    const signalName = signalNamesMap.get(signalID) ?? name;
                    const signalInSeries = series.get(signalName);
                    if (signalInSeries) {
                        const { datapointID } = signalInSeries ?? {};
                        if (datapointID === key) {
                            const { display_precision = 2 } = signalUnitsMap.get(datapointID)?.[signalName] ?? {};
                            const dataPoint = [
                                time,
                                (0, _roundDefault.default)(val, display_precision)
                            ];
                            series.set(signalName, {
                                ...signalInSeries,
                                data: [
                                    ...signalInSeries.data,
                                    dataPoint
                                ]
                            });
                        }
                    }
                });
            }
        });
        return Array.from(series.values());
    }
    parseEventsForGraph(lines = [
        {}
    ], dataDict, type, signalNamesMap, signalUnitsMap) {
        switch(type){
            case 0, _widgetTypes.AREA:
            case 0, _widgetTypes.LINE_HIGH_CHART:
            case 0, _widgetTypes.LINE_GRAPH:
                return this.parseEventsForTimeseries(lines, dataDict, signalNamesMap, signalUnitsMap);
            case 0, _widgetTypes.COLUMN_GRAPH:
            case 0, _widgetTypes.HIGH_BAR:
            case 0, _widgetTypes.IMAGE:
            case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
                return this.parseEventsForLatest(lines, dataDict);
            case 0, _widgetTypes.PIE:
                return this.parseEventsForPieChart(lines, dataDict);
        }
    }
    getWidgetAttributes(type, widgetSettings) {
        const { columns, title } = widgetSettings;
        let { lines } = widgetSettings;
        let last = false;
        switch(type){
            case 0, _widgetTypes.COLUMN_GRAPH:
            case 0, _widgetTypes.HIGH_BAR:
            case 0, _widgetTypes.IMAGE:
            case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
                last = true;
                if (columns) lines = columns;
                break;
            case 0, _widgetTypes.PIE:
                last = true;
                break;
        }
        return {
            last,
            lines,
            title
        };
    }
    noDataIsAvailable(series = [], type) {
        const locationWidgetKeys = new Set([
            "latitude",
            "longitude"
        ]);
        switch(type){
            case 0, _widgetTypes.AREA:
            case 0, _widgetTypes.COLUMN_GRAPH:
            case 0, _widgetTypes.HIGH_BAR:
            case 0, _widgetTypes.IMAGE:
            case 0, _widgetTypes.LINE_HIGH_CHART:
            case 0, _widgetTypes.LINE_GRAPH:
            case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
                return series?.every?.(({ data })=>!data?.length);
            case 0, _widgetTypes.BOOLEAN:
            case 0, _widgetTypes.TEXT:
                return series?.every?.(({ value })=>!value && value !== 0);
            case 0, _widgetTypes.GAUGE:
            case 0, _widgetTypes.GAUGE_RANGE:
            case 0, _widgetTypes.MAINTENANCE:
                return false;
            case 0, _widgetTypes.MAP:
                {
                    const { latitude, longitude } = series.reduce((acc, { signals })=>{
                        if (!Object.keys(signals || {})?.length) return acc;
                        Object.values(signals).forEach(({ name, value })=>{
                            if (locationWidgetKeys.has(name)) acc[name] = value;
                        });
                        return acc;
                    }, {});
                    return !latitude || !longitude;
                }
            case 0, _widgetTypes.COMMAND:
            case 0, _widgetTypes.LOCATION:
            case 0, _widgetTypes.PIE:
            case 0, _widgetTypes.CAN_SCAN:
            case 0, _widgetTypes.TEXT_TAGS:
                return !series?.length;
            case 0, _widgetTypes.BAR_ENGINE_UTILIZATION:
            case 0, _widgetTypes.BAR_FUEL_UTILIZATION:
            case 0, _widgetTypes.TEXT_ENGINE:
            case 0, _widgetTypes.TEXT_FUEL:
                return !series?.size;
            case 0, _widgetTypes.TEXT_STATIC:
                return !series?.links?.length && !series?.staticText?.length;
            default:
                return true;
        }
    }
    buildRealtimeSubscriptionKeySet(gatewayID, { settings = {}, type } = {}) {
        const result = new Set();
        switch(true){
            case "lines" in settings:
                settings?.lines?.forEach?.(({ datapointID })=>{
                    result.add(`${gatewayID}:${datapointID}`);
                });
                break;
            case "columns" in settings:
                settings?.columns?.forEach?.(({ datapointID })=>{
                    result.add(`${gatewayID}:${datapointID}`);
                });
                break;
            case (0, _widgetTypes.TEXT) in settings:
                settings?.text?.forEach?.(({ datapointID })=>{
                    result.add(`${gatewayID}:${datapointID}`);
                });
                break;
            case (0, _widgetTypes.BOOLEAN) in settings:
                settings?.boolean?.forEach?.(({ datapointID })=>{
                    result.add(`${gatewayID}:${datapointID}`);
                });
                break;
            case (0, _widgetTypes.CAN_SCAN) in settings:
                settings?.scan?.forEach?.(({ datapointID })=>{
                    result.add(`${gatewayID}:${datapointID}`);
                });
                break;
            case type === (0, _widgetTypes.LOCATION):
            case type === (0, _widgetTypes.MAP):
                result.add(`${gatewayID}:${(0, _staticUUIDs.CONNECT_DISCONNECT_ID)}`).add(`${gatewayID}:${settings?.datapointID}`);
                break;
            case "datapointID" in settings:
                result.add(`${gatewayID}:${settings.datapointID}`);
                if (settings.secondGauge?.datapointID) result.add(`${gatewayID}:${settings.secondGauge.datapointID}`);
                break;
        }
        return result;
    }
}
exports.default = WidgetUtils;

},{"lodash/isEmpty":"6WyGC","lodash/round":"immc6","uuid":"hIyym","../Constants/Signal":"bTf7q","../Constants/SignalCollection":"b6HoH","../Constants/StaticUUIDs":"cpjYY","../Constants/WidgetTypes":"frQz2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6HoH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCELEROMETER_TYPE", ()=>ACCELEROMETER_TYPE);
parcelHelpers.export(exports, "ACCELEROMETER_CALCULATED_TYPE", ()=>ACCELEROMETER_CALCULATED_TYPE);
parcelHelpers.export(exports, "CAN_0_DIAGNOSTICS_TYPE", ()=>CAN_0_DIAGNOSTICS_TYPE);
parcelHelpers.export(exports, "CAN_1_DIAGNOSTICS_TYPE", ()=>CAN_1_DIAGNOSTICS_TYPE);
parcelHelpers.export(exports, "CAN_2_DIAGNOSTICS_TYPE", ()=>CAN_2_DIAGNOSTICS_TYPE);
parcelHelpers.export(exports, "CAN_3_DIAGNOSTICS_TYPE", ()=>CAN_3_DIAGNOSTICS_TYPE);
parcelHelpers.export(exports, "CUSTOM_TYPE", ()=>CUSTOM_TYPE);
parcelHelpers.export(exports, "GATEWAY_LOAD_TYPE", ()=>GATEWAY_LOAD_TYPE);
parcelHelpers.export(exports, "GATEWAY_LOGS_TYPE", ()=>GATEWAY_LOGS_TYPE);
parcelHelpers.export(exports, "GATEWAY_MEMORY_TYPE", ()=>GATEWAY_MEMORY_TYPE);
parcelHelpers.export(exports, "GATEWAY_SIGNAL_TYPE", ()=>GATEWAY_SIGNAL_TYPE);
parcelHelpers.export(exports, "GPS_TYPE", ()=>GPS_TYPE);
parcelHelpers.export(exports, "GPS_ALTITUDE_TYPE", ()=>GPS_ALTITUDE_TYPE);
parcelHelpers.export(exports, "GPS_DISTANCE_TYPE", ()=>GPS_DISTANCE_TYPE);
parcelHelpers.export(exports, "GPS_OTHER_TYPE", ()=>GPS_OTHER_TYPE);
parcelHelpers.export(exports, "GPS_HEADING_TYPE", ()=>GPS_HEADING_TYPE);
parcelHelpers.export(exports, "GPS_SPEED_TYPE", ()=>GPS_SPEED_TYPE);
parcelHelpers.export(exports, "MODBUS_TCP_TYPE", ()=>MODBUS_TCP_TYPE);
parcelHelpers.export(exports, "SCAN_CAN_TYPE", ()=>SCAN_CAN_TYPE);
parcelHelpers.export(exports, "SCAN_J1939_TYPE", ()=>SCAN_J1939_TYPE);
parcelHelpers.export(exports, "COLLECTION_TYPE_SET", ()=>COLLECTION_TYPE_SET);
parcelHelpers.export(exports, "GATEWAY_TYPE_SET", ()=>GATEWAY_TYPE_SET);
parcelHelpers.export(exports, "SCAN_TYPE_SET", ()=>SCAN_TYPE_SET);
parcelHelpers.export(exports, "WATER_POND_TYPE", ()=>WATER_POND_TYPE);
parcelHelpers.export(exports, "WATER_PUMP_TYPE", ()=>WATER_PUMP_TYPE);
parcelHelpers.export(exports, "WATER_TRANSFER_TYPE_SET", ()=>WATER_TRANSFER_TYPE_SET);
parcelHelpers.export(exports, "READ_ONLY_TYPE", ()=>READ_ONLY_TYPE);
parcelHelpers.export(exports, "LEGACY_COLLECTION_TYPES", ()=>LEGACY_COLLECTION_TYPES);
parcelHelpers.export(exports, "COLLECTION_TYPE_OPTIONS", ()=>COLLECTION_TYPE_OPTIONS);
parcelHelpers.export(exports, "EZ_GPS_TYPE", ()=>EZ_GPS_TYPE);
parcelHelpers.export(exports, "EZ_SATELLITES_IN_VIEW_TYPE", ()=>EZ_SATELLITES_IN_VIEW_TYPE);
parcelHelpers.export(exports, "EZ_COLLECTION_TYPE_OPTIONS", ()=>EZ_COLLECTION_TYPE_OPTIONS);
parcelHelpers.export(exports, "EZ_COLLECTION_TYPE_SET", ()=>EZ_COLLECTION_TYPE_SET);
const ACCELEROMETER_TYPE = "accelerometer";
const ACCELEROMETER_CALCULATED_TYPE = "accelerometer-calculated";
const CAN_0_DIAGNOSTICS_TYPE = "diag-can0";
const CAN_1_DIAGNOSTICS_TYPE = "diag-can1";
const CAN_2_DIAGNOSTICS_TYPE = "diag-can2";
const CAN_3_DIAGNOSTICS_TYPE = "diag-can3";
const CUSTOM_TYPE = "custom";
const GATEWAY_LOAD_TYPE = "gateway-load";
const GATEWAY_LOGS_TYPE = "gateway-logs";
const GATEWAY_MEMORY_TYPE = "gateway-memory";
const GATEWAY_SIGNAL_TYPE = "gateway-signal";
const GPS_TYPE = "GPS";
const GPS_ALTITUDE_TYPE = "altitude";
const GPS_DISTANCE_TYPE = "distance";
const GPS_OTHER_TYPE = "gps-other";
const GPS_HEADING_TYPE = "heading";
const GPS_SPEED_TYPE = "speed";
const MODBUS_TCP_TYPE = "modbus-tcp";
const SCAN_CAN_TYPE = "scan-can"; // legacy as of 8/2023
const SCAN_J1939_TYPE = "scan-j1939"; // legacy as of 8/2023
const COLLECTION_TYPE_SET = new Set([
    ACCELEROMETER_TYPE,
    ACCELEROMETER_CALCULATED_TYPE,
    CAN_0_DIAGNOSTICS_TYPE,
    CAN_1_DIAGNOSTICS_TYPE,
    CAN_2_DIAGNOSTICS_TYPE,
    CAN_3_DIAGNOSTICS_TYPE,
    CUSTOM_TYPE,
    GATEWAY_LOAD_TYPE,
    GATEWAY_LOGS_TYPE,
    GATEWAY_MEMORY_TYPE,
    GATEWAY_SIGNAL_TYPE,
    GPS_TYPE,
    GPS_ALTITUDE_TYPE,
    GPS_DISTANCE_TYPE,
    GPS_HEADING_TYPE,
    GPS_OTHER_TYPE,
    GPS_SPEED_TYPE,
    MODBUS_TCP_TYPE
]);
const GATEWAY_TYPE_SET = new Set([
    GATEWAY_LOAD_TYPE,
    GATEWAY_LOGS_TYPE,
    GATEWAY_MEMORY_TYPE,
    GATEWAY_SIGNAL_TYPE
]);
const SCAN_TYPE_SET = new Set(SCAN_CAN_TYPE, SCAN_J1939_TYPE);
const WATER_POND_TYPE = "Water Pond";
const WATER_PUMP_TYPE = "Water Pump";
const WATER_TRANSFER_TYPE_SET = new Set([
    WATER_POND_TYPE,
    WATER_PUMP_TYPE
]);
const READ_ONLY_TYPE = "read_only";
const LEGACY_COLLECTION_TYPES = [
    ...COLLECTION_TYPE_SET,
    ...SCAN_TYPE_SET,
    ...WATER_TRANSFER_TYPE_SET,
    READ_ONLY_TYPE
];
const COLLECTION_TYPE_OPTIONS = [
    {
        label: "GPS - Lat/Lng",
        value: GPS_TYPE
    },
    {
        label: "GPS - Altitude",
        value: GPS_ALTITUDE_TYPE
    },
    {
        label: "GPS - Speed",
        value: GPS_SPEED_TYPE
    },
    {
        label: "GPS - Distance",
        value: GPS_DISTANCE_TYPE
    },
    {
        label: "GPS - Other",
        value: GPS_OTHER_TYPE
    },
    {
        label: "Accelerometer",
        value: ACCELEROMETER_TYPE
    },
    {
        label: "Accelerometer - Calculated",
        value: ACCELEROMETER_CALCULATED_TYPE
    },
    {
        label: "Gateway - Load Avg over 1 min",
        value: GATEWAY_LOAD_TYPE
    },
    {
        label: "Gateway - Logs % used",
        value: GATEWAY_LOGS_TYPE
    },
    {
        label: "Gateway - Memory % used",
        value: GATEWAY_MEMORY_TYPE
    },
    {
        label: "Gateway - Signal Strength",
        value: GATEWAY_SIGNAL_TYPE
    },
    {
        label: "Modbus - TCP",
        value: MODBUS_TCP_TYPE
    },
    {
        label: "Custom",
        value: CUSTOM_TYPE
    },
    {
        label: "CAN0 diagnostics",
        value: CAN_0_DIAGNOSTICS_TYPE
    },
    {
        label: "CAN1 diagnostics",
        value: CAN_1_DIAGNOSTICS_TYPE
    },
    {
        label: "CAN2 diagnostics",
        value: CAN_2_DIAGNOSTICS_TYPE
    },
    {
        label: "CAN3 diagnostics",
        value: CAN_3_DIAGNOSTICS_TYPE
    }
];
const EZ_GPS_TYPE = "gps";
const EZ_SATELLITES_IN_VIEW_TYPE = "satellites_in_view";
const EZ_COLLECTION_TYPE_OPTIONS = [
    {
        label: "Custom CAN signal",
        value: CUSTOM_TYPE
    },
    {
        label: "GPS signals",
        value: EZ_GPS_TYPE
    },
    {
        label: "GPS satellite count",
        value: EZ_SATELLITES_IN_VIEW_TYPE
    }
];
const EZ_COLLECTION_TYPE_SET = new Set([
    CUSTOM_TYPE,
    EZ_GPS_TYPE,
    EZ_SATELLITES_IN_VIEW_TYPE
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKKTd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrandingProvider", ()=>BrandingProvider);
parcelHelpers.export(exports, "BrandingConsumer", ()=>BrandingConsumer);
var _react = require("react");
const BrandingContext = /*#__PURE__*/ (0, _react.createContext)("user");
const BrandingProvider = BrandingContext.Provider;
const BrandingConsumer = BrandingContext.Consumer;
exports.default = BrandingContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pRgR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _round = require("lodash/round");
var _roundDefault = parcelHelpers.interopDefault(_round);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _subHours = require("date-fns/subHours");
var _subHoursDefault = parcelHelpers.interopDefault(_subHours);
var _max = require("date-fns/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _min = require("date-fns/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _papaparse = require("papaparse");
var _papaparseDefault = parcelHelpers.interopDefault(_papaparse);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactstrap = require("reactstrap");
var _dateFormatStrings = require("../../Constants/DateFormatStrings");
var _rbac = require("../../Constants/RBAC");
var _signal = require("../../Constants/Signal");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _widgetUtils = require("../../Lib/WidgetUtils");
var _widgetUtilsDefault = parcelHelpers.interopDefault(_widgetUtils);
var _zIndex = require("../../Styles/Z-INDEX");
var _dateFormatHelpersUtil = require("../../Utils/dateFormatHelpers.util");
var _deleteWidgetModal = require("./DeleteWidgetModal");
var _deleteWidgetModalDefault = parcelHelpers.interopDefault(_deleteWidgetModal);
var _editWidgetModal = require("./EditWidgetModal");
var _editWidgetModalDefault = parcelHelpers.interopDefault(_editWidgetModal);
var _errorBoundary = require("../ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _exportSignalCollectionModalContainer = require("./ExportSignalCollectionModalContainer");
var _exportSignalCollectionModalContainerDefault = parcelHelpers.interopDefault(_exportSignalCollectionModalContainer);
var _utilizationTimeSelectModal = require("./UtilizationTimeSelectModal");
var _utilizationTimeSelectModalDefault = parcelHelpers.interopDefault(_utilizationTimeSelectModal);
var _widget = require("./Widget");
var _widgetDefault = parcelHelpers.interopDefault(_widget);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _timeRangeDropdown = require("./AssetTimeFilter/TimeRangeDropdown");
var _timeRangeDropdownDefault = parcelHelpers.interopDefault(_timeRangeDropdown);
var _customTimeFilterModal = require("./AssetTimeFilter/CustomTimeFilterModal");
var _customTimeFilterModalDefault = parcelHelpers.interopDefault(_customTimeFilterModal);
var _utils = require("./AssetTimeFilter/utils");
const { className: dropdownItemClass, styles: dropdownItemStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2018757355",
        children: "button.jsx-2018757355,a.jsx-2018757355{color:var(--text-light-gray);font-size:0.75rem;cursor:pointer;box-shadow:none;outline:none;}button.jsx-2018757355:hover{background-color:transparent;}button.jsx-2018757355:focus{outline:none;}"
    }),
    className: "jsx-2018757355"
};
const EXPORT_DISABLED = new Set([
    (0, _widgetTypes.COMMAND),
    (0, _widgetTypes.MAINTENANCE),
    (0, _widgetTypes.TEXT_STATIC),
    (0, _widgetTypes.TEXT_TAGS)
]), fields = [
    "Timestamp",
    "Total Engine Hours",
    "Active Engine Hours",
    "Idle Engine Hours",
    "Total Fuel Used",
    "Active Fuel Used",
    "Idle Fuel Used"
], intervalAggregateMap = new Map([
    [
        "day",
        (0, _signal.DAILY)
    ],
    [
        "month",
        (0, _signal.MONTHLY)
    ],
    [
        "week",
        (0, _signal.WEEKLY)
    ]
]), MAX_DATAPOINTS = 3000, SHOW_UPDATED_AT = new Set([
    (0, _widgetTypes.AREA),
    (0, _widgetTypes.GAUGE),
    (0, _widgetTypes.GAUGE_RANGE),
    (0, _widgetTypes.LINE_GRAPH),
    (0, _widgetTypes.LINE_HIGH_CHART),
    (0, _widgetTypes.LOCATION),
    (0, _widgetTypes.MAP),
    (0, _widgetTypes.CAN_SCAN)
]), UI_SERVICE_MAX_DATAPOINTS = 10000;
class WidgetDisplayContainer extends (0, _react.PureComponent) {
    static propTypes = {
        asset: (0, _propTypesDefault.default).object,
        dashboardID: (0, _propTypesDefault.default).string,
        fetchedData: (0, _propTypesDefault.default).object,
        graphIndex: (0, _propTypesDefault.default).number,
        graphWidgetIDs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
        handleCommandExecutedFromWidget: (0, _propTypesDefault.default).func,
        handleWidgetDeleted: (0, _propTypesDefault.default).func,
        handleWidgetUpdated: (0, _propTypesDefault.default).func,
        historicalUtilizationData: (0, _propTypesDefault.default).object,
        renderNextGraph: (0, _propTypesDefault.default).func,
        signalNamesMap: (0, _propTypesDefault.default).object,
        signalUnitsMap: (0, _propTypesDefault.default).object,
        socket: (0, _propTypesDefault.default).object,
        updateWidgets: (0, _propTypesDefault.default).func,
        utilizationData: (0, _propTypesDefault.default).object,
        widget: (0, _propTypesDefault.default).object,
        timeFilter: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).number
        ]),
        customStartTimestamp: (0, _propTypesDefault.default).number,
        customEndTimestamp: (0, _propTypesDefault.default).number,
        updateRealTime: (0, _propTypesDefault.default).bool,
        maxDatapoints: (0, _propTypesDefault.default).number
    };
    state = {
        customEndTimestamp: null,
        customStartTimestamp: null,
        fetchedData: this.props.fetchedData,
        historicalUtilizationData: this.props.historicalUtilizationData,
        maxDatapoints: this.props.widget?.type === (0, _widgetTypes.TEXT) ? 1 : MAX_DATAPOINTS,
        returningToRealTime: false,
        showCustomFilterModal: false,
        showDeleteWidgetModal: false,
        showEditWidgetModal: false,
        showExportSignalCollectionModal: false,
        showUtilizationTimeSelectModal: false,
        timeFilter: null,
        updateRealTime: true
    };
    eventHandlerMap = new Map();
    textTagsWidgetRef = /*#__PURE__*/ (0, _react.createRef)();
    widgetUtils = new (0, _widgetUtilsDefault.default)();
    isTimeFilterVisible = (0, _utils.isTimeFilterVisible)(this.props.widget.type, !!this.props.widget.settings?.displayTextAsGrid);
    componentDidMount() {
        this.initializeSocketListeners();
    }
    componentDidUpdate = ({ fetchedData: prevData, historicalUtilizationData: prevHistoricalUtilizationData })=>{
        const { fetchedData = new Map(), historicalUtilizationData = new Map() } = this.props;
        if (!(0, _isEqualDefault.default)(prevData, fetchedData)) this.setState({
            fetchedData
        });
        if (!(0, _isEqualDefault.default)(prevHistoricalUtilizationData, historicalUtilizationData)) this.setState({
            historicalUtilizationData
        });
        //was time filter updated globally?
        const globalTimeFilterDidChange = !(0, _isEqualDefault.default)(this.props.timeFilter, this.state.timeFilter), globalCustomStartTimeStampDidChange = !(0, _isEqualDefault.default)(this.props.customStartTimestamp, this.state.customStartTimestamp), globalCustomEndTimeStampDidChange = !(0, _isEqualDefault.default)(this.props.customEndTimestamp, this.state.customEndTimestamp), globalMaxDatapointsDidChange = !(0, _isEqualDefault.default)(this.props.maxDatapoints, this.state.maxDatapoints);
        if ((globalTimeFilterDidChange || globalCustomStartTimeStampDidChange || globalCustomEndTimeStampDidChange || globalMaxDatapointsDidChange) && this.isTimeFilterVisible) this.setState({
            customEndTimestamp: this.props.customEndTimestamp,
            customStartTimestamp: this.props.customStartTimestamp,
            timeFilter: this.props.timeFilter,
            maxDatapoints: this.props.maxDatapoints
        }, ()=>this.updateFetchedData(this.props.timeFilter, this.props.customStartTimestamp, this.props.customEndTimestamp));
        //was time filter updated globally to return to real time?
        if (!(0, _isEqualDefault.default)(this.props.updateRealTime, this.state.updateRealTime) && this.isTimeFilterVisible) {
            this.setState({
                updateRealTime: this.props.updateRealTime
            });
            if (this.props.updateRealTime) this.handleReturnToRealTime();
        }
    };
    componentWillUnmount() {
        this.removeSocketListeners();
    }
    exportHistoricalUtilizationCsv = ()=>{
        try {
            const targetData = this.state.historicalUtilizationData.get(this.props.widget?.settings?.aggregation) ?? new Map();
            const data = Array.from(targetData).reduce((acc, [timestamp, signals])=>{
                if (Object.values(signals)?.some(({ max, min })=>!max || !min)) return acc;
                const { [(0, _signal.ENGINE_HOURS)]: totalEngine, [(0, _signal.FUEL_USED)]: totalFuel, [(0, _signal.IDLE_ENGINE_HOURS)]: idleEngine, [(0, _signal.IDLE_FUEL_USED)]: idleFuel } = signals;
                const idleEngineHours = idleEngine?.max - idleEngine?.min, totalEngineHours = totalEngine?.max - totalEngine?.min, idleFuelUsed = idleFuel?.max - idleFuel?.min, totalFuelUsed = totalFuel?.max - totalFuel?.min;
                return acc.concat([
                    [
                        timestamp,
                        (0, _roundDefault.default)(totalEngineHours, 2),
                        (0, _roundDefault.default)(totalEngineHours - idleEngineHours, 2),
                        (0, _roundDefault.default)(idleEngineHours, 2),
                        (0, _roundDefault.default)(totalFuelUsed, 2),
                        (0, _roundDefault.default)(totalFuelUsed - idleFuelUsed, 2),
                        (0, _roundDefault.default)(idleFuelUsed, 2)
                    ]
                ]);
            }, []);
            const csv = (0, _papaparseDefault.default).unparse({
                data,
                fields
            }), blob = new Blob([
                csv
            ], {
                type: "text/csv;charset=utf-8"
            }), filename = `${this.props.asset?.nickname}_${this.props.widget?.settings?.title}.csv`, link = document.createElement("a"), url = URL.createObjectURL(blob);
            link.download = filename;
            link.href = url;
            link.style = "display: none";
            document.body.appendChild(link);
            link.click();
            window.setTimeout(()=>{
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            });
        } catch (error) {
            this.setState({
                error: error.message
            });
        }
    };
    exportStaticUtilizationCsv = ()=>{
        try {
            const data = Array.from(this.props.utilizationData).reduce((acc, [timestamp, signals])=>{
                if (Object.values(signals)?.some(({ max, min })=>!max || !min)) return acc;
                const { [(0, _signal.ENGINE_HOURS)]: totalEngine, [(0, _signal.FUEL_USED)]: totalFuel, [(0, _signal.IDLE_ENGINE_HOURS)]: idleEngine, [(0, _signal.IDLE_FUEL_USED)]: idleFuel } = signals;
                const idleEngineHours = idleEngine?.max - idleEngine?.min, totalEngineHours = totalEngine?.max - totalEngine?.min, idleFuelUsed = idleFuel?.max - idleFuel?.min, totalFuelUsed = totalFuel?.max - totalFuel?.min;
                return acc.concat([
                    [
                        timestamp.charAt(0).toUpperCase().concat(timestamp.slice(1)),
                        (0, _roundDefault.default)(totalEngineHours, 2),
                        (0, _roundDefault.default)(totalEngineHours - idleEngineHours, 2),
                        (0, _roundDefault.default)(idleEngineHours, 2),
                        (0, _roundDefault.default)(totalFuelUsed, 2),
                        (0, _roundDefault.default)(totalFuelUsed - idleFuelUsed, 2),
                        (0, _roundDefault.default)(idleFuelUsed, 2)
                    ]
                ]);
            }, []);
            const csv = (0, _papaparseDefault.default).unparse({
                data,
                fields
            }), blob = new Blob([
                csv
            ], {
                type: "text/csv;charset=utf-8"
            }), filename = `${this.props.asset?.nickname}_${this.props.widget?.settings?.title}_${(0, _formatDefault.default)(new Date(), (0, _dateFormatStrings.MONTH_DAY_YEAR))}.csv`, link = document.createElement("a"), url = URL.createObjectURL(blob);
            link.download = filename;
            link.href = url;
            link.style = "display: none";
            document.body.appendChild(link);
            link.click();
            window.setTimeout(()=>{
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            });
        } catch (error) {
            this.setState({
                error: error.message
            });
        }
    };
    fetchCustomRangeUtilizationData = ({ dateStart, dateStop, interval })=>{
        this.props.socket?.emit?.("utilization:report", {
            dateStart,
            dateStop,
            interval
        }, (data)=>{
            const dailyData = new Map(Object.entries(data || {}).reduce((map, [dateStr, signals])=>map.set(dateStr, signals), new Map()));
            const historicalUtilizationData = new Map(this.state.historicalUtilizationData).set(intervalAggregateMap.get(interval), dailyData);
            this.setState({
                historicalUtilizationData
            });
        });
    };
    getTimeRange = ()=>{
        const { props: { widget: { settings, type } = {} }, state: { fetchedData, timeFilter } } = this, isTextGridTile = type === (0, _widgetTypes.TEXT) && !!settings?.displayTextAsGrid;
        let showUpdatedAt = SHOW_UPDATED_AT.has(type) || isTextGridTile;
        let firstDatapoint = "", updatedAt = "";
        if (!this.state.fetchedData.size) return {
            firstDatapoint,
            showUpdatedAt: false,
            updatedAt
        };
        if (!showUpdatedAt) return {
            firstDatapoint,
            showUpdatedAt,
            updatedAt
        };
        const { datapointID, lines = [], text = [], type: signalType } = settings || {}, data = fetchedData.get(datapointID) || [];
        switch(type){
            case 0, _widgetTypes.LOCATION:
                {
                    if (!data?.length) return {
                        firstDatapoint: "",
                        showUpdatedAt: false,
                        updatedAt: ""
                    };
                    // Order of data coming in changes depending on whether a timefilter is specified or not
                    const [first, last] = timeFilter ? [
                        data[0].createdAt,
                        data[data.length - 1].createdAt
                    ] : [
                        data[data.length - 1].createdAt,
                        data[0].createdAt
                    ];
                    firstDatapoint = (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(new Date(first));
                    updatedAt = (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(new Date(last));
                    if (!firstDatapoint && !updatedAt) showUpdatedAt = false;
                    break;
                }
            case 0, _widgetTypes.AREA:
            case 0, _widgetTypes.LINE_GRAPH:
                {
                    const allOutputSignals = lines?.every?.(({ type } = {})=>type === "outputSignal"), eventDates = lines.reduce((timestamps, { datapointID })=>{
                        const signalData = fetchedData.get(datapointID);
                        return signalData?.length ? signalData.reduce((acc, { createdAt } = {})=>{
                            const date = new Date(createdAt);
                            return (0, _isValidDefault.default)(date) ? acc.concat(date) : acc;
                        }, timestamps) : timestamps;
                    }, []), firstDate = (0, _minDefault.default)(eventDates), lastDate = (0, _maxDefault.default)(eventDates);
                    firstDatapoint = allOutputSignals ? (0, _dateFormatHelpersUtil.formatUTCForAssetDashboardTile)(firstDate) : (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(firstDate);
                    updatedAt = allOutputSignals ? (0, _dateFormatHelpersUtil.formatUTCForAssetDashboardTile)(lastDate) : (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(lastDate);
                    if (!firstDatapoint && !updatedAt) showUpdatedAt = false;
                    break;
                }
            case 0, _widgetTypes.GAUGE:
            case 0, _widgetTypes.GAUGE_RANGE:
                {
                    const { secondGauge: { datapointID: secondDpID } = {} } = settings || {};
                    if (!secondDpID || datapointID === secondDpID) {
                        if (!data[0]?.createdAt) return {
                            firstDatapoint: "",
                            showUpdatedAt: false,
                            updatedAt: ""
                        };
                        updatedAt = signalType === "outputSignal" ? (0, _dateFormatHelpersUtil.formatUTCForAssetDashboardTile)(new Date(data[0]?.createdAt)) : (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(new Date(data[0]?.createdAt));
                        break;
                    }
                    const secondGaugeData = fetchedData.get(secondDpID) || [];
                    const mostRecent = (0, _maxDefault.default)([
                        new Date(data[0]?.createdAt),
                        new Date(secondGaugeData[0]?.createdAt)
                    ]);
                    updatedAt = signalType === "outputSignal" ? (0, _dateFormatHelpersUtil.formatUTCForAssetDashboardTile)(mostRecent) : (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(mostRecent);
                    if (!updatedAt) showUpdatedAt = false;
                    break;
                }
            case 0, _widgetTypes.CAN_SCAN:
                updatedAt = Array.isArray(settings?.scan) ? settings.scan.reduce((formatted, { datapointID })=>{
                    const [{ createdAt } = {}] = fetchedData.get(datapointID) || [];
                    return createdAt ? (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(new Date(createdAt)) : "";
                }, "") : "";
                if (!updatedAt) showUpdatedAt = false;
                break;
            default:
                if (isTextGridTile) {
                    const eventDates = text.reduce((timestamps, { datapointID })=>{
                        const signalData = fetchedData.get(datapointID);
                        if (!Array.isArray(signalData) || !signalData.length) return timestamps;
                        return signalData.reduce((acc, { createdAt } = {})=>createdAt ? acc.concat(new Date(createdAt)) : acc, timestamps);
                    }, []), latestEvent = (0, _maxDefault.default)(eventDates);
                    updatedAt = (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(latestEvent);
                    if (!updatedAt) showUpdatedAt = false;
                    break;
                }
                if (!data[0]?.createdAt) return {
                    firstDatapoint: "",
                    showUpdatedAt: false,
                    updatedAt: ""
                };
                updatedAt = signalType === "outputSignal" ? (0, _dateFormatHelpersUtil.formatUTCForAssetDashboardTile)(new Date(data[0]?.createdAt)) : (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(new Date(data[0]?.createdAt));
                if (!updatedAt) showUpdatedAt = false;
                break;
        }
        return {
            showUpdatedAt,
            firstDatapoint,
            updatedAt
        };
    };
    handleCustomFilterSaveCallback = ({ customEndTimestamp, maxDatapoints, customStartTimestamp })=>{
        this.setState({
            customEndTimestamp,
            customStartTimestamp,
            maxDatapoints,
            showCustomFilterModal: false,
            timeFilter: "custom"
        }, ()=>this.updateFetchedData("custom", customStartTimestamp, customEndTimestamp));
    };
    handleExportClick = ()=>{
        switch(this.props.widget?.type){
            case 0, _widgetTypes.BAR_ENGINE_UTILIZATION:
            case 0, _widgetTypes.BAR_FUEL_UTILIZATION:
                return this.exportHistoricalUtilizationCsv();
            case 0, _widgetTypes.TEXT_ENGINE:
            case 0, _widgetTypes.TEXT_FUEL:
                return this.exportStaticUtilizationCsv();
            default:
                return this.toggleExportSignalCollectionModal();
        }
    };
    handleRealtimeData = (key)=>{
        const eventHandler = (newData)=>{
            if (this.props.socket?.disconnected) return;
            if (!this.state.updateRealTime) return;
            const [, datapointID] = key.split(":"), currentData = JSON.parse(JSON.stringify([
                ...this.state.fetchedData.get(datapointID) || []
            ]));
            if (currentData?.length >= this.state.maxDatapoints) currentData.pop();
            currentData.unshift(newData);
            const fetchedData = new Map([
                ...this.state.fetchedData,
                [
                    datapointID,
                    currentData
                ]
            ]);
            this.setState({
                fetchedData
            });
        };
        this.eventHandlerMap.set(key, eventHandler);
        return eventHandler;
    };
    handleReturnToRealTime = async ()=>{
        this.setState({
            customEndTimestamp: null,
            customStartTimestamp: null,
            fetchedData: new Map(),
            returningToRealTime: true,
            timeFilter: null,
            updateRealTime: true
        }, this.refreshFetchedData);
    };
    handleTimeRangeFilter = (timeFilter)=>{
        if (timeFilter === "custom") return this.setState({
            showCustomFilterModal: true
        });
        const customEndTimestamp = Date.now(), customStartTimestamp = (0, _subHoursDefault.default)(customEndTimestamp, timeFilter).getTime();
        this.setState({
            customEndTimestamp,
            customStartTimestamp,
            timeFilter
        }, ()=>this.updateFetchedData(timeFilter, customStartTimestamp, customEndTimestamp));
    };
    handleUtilizationTimeSelect = (dateStart, dateStop, interval)=>{
        this.setState({
            customEndTimestamp: dateStop.getTime(),
            customStartTimestamp: dateStart.getTime(),
            showUtilizationTimeSelectModal: false
        }, ()=>{
            this.fetchCustomRangeUtilizationData({
                dateStart: dateStart.toISOString(),
                dateStop: dateStop.toISOString(),
                interval
            });
        });
    };
    initializeSocketListeners() {
        const keySet = this.widgetUtils.buildRealtimeSubscriptionKeySet(this.props.asset?._id, this.props.widget);
        if (!keySet.size) return;
        keySet.forEach((key)=>{
            this.props.socket?.on?.(`realtime:${key}`, this.handleRealtimeData(key));
        });
    }
    refreshFetchedData = ()=>{
        this.props.socket?.emit?.("dashboard:initial", {
            dashboardID: this.props.dashboardID
        }, (data)=>{
            const fetchedData = Object.keys(data || {})?.length ? new Map(Object.entries(data).filter(([key])=>key !== "undefined")) : new Map();
            this.setState({
                fetchedData,
                returningToRealTime: false
            });
        });
    };
    removeSocketListeners = ()=>{
        this.eventHandlerMap.forEach((handler, key)=>{
            this.props.socket?.off?.(`realtime:${key}`, handler);
        });
    };
    toggleCustomFilterModal = ()=>{
        this.setState({
            showCustomFilterModal: !this.state.showCustomFilterModal
        });
    };
    toggleDeleteWidgetModal = ()=>{
        this.setState({
            showDeleteWidgetModal: !this.state.showDeleteWidgetModal
        });
    };
    toggleEditWidgetModal = ()=>{
        this.setState({
            showEditWidgetModal: !this.state.showEditWidgetModal
        });
    };
    toggleExportSignalCollectionModal = ()=>{
        this.setState({
            showExportSignalCollectionModal: !this.state.showExportSignalCollectionModal
        });
    };
    toggleUtilizationTimeSelectModal = ()=>{
        this.setState({
            showUtilizationTimeSelectModal: !this.state.showUtilizationTimeSelectModal
        });
    };
    updateFetchedData = async (timeFilter, dateStart, dateStop)=>{
        const datapointIDs = [
            ...this.widgetUtils.buildRealtimeSubscriptionKeySet(this.props.asset?._id, this.props.widget)
        ].map((key = "")=>key?.split?.(":")[1]), limit = timeFilter === 24 ? UI_SERVICE_MAX_DATAPOINTS : this.state.maxDatapoints, order = this.props.widget?.type === (0, _widgetTypes.TEXT) ? "desc" : "asc";
        this.props.socket?.emit("widget:events", {
            datapointIDs,
            dateStart,
            dateStop,
            order,
            limit
        }, (data)=>{
            if (data?.error) return this.setState({
                error: data.error.message
            });
            const fetchedData = new Map(Object.entries(data || {}));
            this.setState({
                fetchedData,
                updateRealTime: false
            });
        });
    };
    render() {
        const { asset, dashboardID, graphIndex, graphWidgetIDs, handleCommandExecutedFromWidget, handleWidgetDeleted, handleWidgetUpdated, renderNextGraph, signalNamesMap, signalUnitsMap, utilizationData, widget, widget: { _id: widgetID, settings, type } = {} } = this.props;
        const { customEndTimestamp, customStartTimestamp, fetchedData, historicalUtilizationData, maxDatapoints, returningToRealTime, showCustomFilterModal, showDeleteWidgetModal, showEditWidgetModal, showExportSignalCollectionModal, showUtilizationTimeSelectModal, timeFilter, updateRealTime } = this.state;
        const { firstDatapoint, showUpdatedAt, updatedAt } = this.getTimeRange();
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "jsx-1107306638 h-100 w-100 widget-outer-wrapper",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-1107306638 header-container h-100 w-100 position-relative",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1107306638 position-absolute h-100 w-100 d-flex align-items-center flex-nowrap border-bottom",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1107306638 flex-grow-1 m-0 pl-3 overflow-auto",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h6", {
                                        "data-for": `${widgetID}-title`,
                                        "data-tip": widget.settings?.title,
                                        className: "jsx-1107306638 text-muted text-truncate m-0",
                                        children: [
                                            widget.settings?.title,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                id: `${widgetID}-title`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1107306638 " + `${!showUpdatedAt ? "d-none" : "d-none d-md-flex"} row text-secondary-gray three-quarter-text pl-3`,
                                        children: `updated ${!firstDatapoint ? `at ${updatedAt}` : `from ${firstDatapoint} to ${updatedAt}`}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1107306638 flex-grow-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeRangeDropdownDefault.default), {
                                    timeFilter: timeFilter,
                                    dropdownItemClass: dropdownItemClass,
                                    displayTextAsGrid: !!settings?.displayTextAsGrid,
                                    type: type,
                                    updateRealTime: updateRealTime,
                                    toggleUtilizationTimeSelectModal: this.toggleUtilizationTimeSelectModal,
                                    handleReturnToRealTime: this.handleReturnToRealTime,
                                    handleTimeRangeFilter: this.handleTimeRangeFilter
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1107306638 flex-grow-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                    no: (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                                                    color: "link",
                                                    className: "py-0 three-quarter-text shadow-none",
                                                    "data-for": widgetID,
                                                    "data-tip": data,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        icon: (0, _freeSolidSvgIcons.faEllipsisH),
                                                        className: "text-muted"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownMenu), {
                                                    right: true,
                                                    className: "rounded-lg shadow",
                                                    style: {
                                                        zIndex: (0, _zIndex.STICKY_OVERRIDE)
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                        className: dropdownItemClass,
                                                        disabled: EXPORT_DISABLED.has(type),
                                                        onClick: this.handleExportClick,
                                                        children: "Export"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                    id: widgetID
                                                })
                                            ]
                                        }),
                                    orgID: asset?.orgID,
                                    perform: (0, _rbac.WIDGET_UPDATE),
                                    resource: (0, _rbac.DASHBOARD),
                                    yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                                                    color: "link",
                                                    className: "py-0 three-quarter-text shadow-none",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        icon: (0, _freeSolidSvgIcons.faEllipsisH),
                                                        className: "text-muted"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                                                    right: true,
                                                    className: "rounded-lg shadow",
                                                    style: {
                                                        zIndex: (0, _zIndex.STICKY_OVERRIDE)
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                            className: dropdownItemClass,
                                                            onClick: this.toggleEditWidgetModal,
                                                            children: "Edit"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                            className: dropdownItemClass,
                                                            disabled: EXPORT_DISABLED.has(type),
                                                            onClick: this.handleExportClick,
                                                            children: "Export"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                                            className: `${dropdownItemClass} text-danger`,
                                                            onClick: this.toggleDeleteWidgetModal,
                                                            children: "Delete"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                })
                            }),
                            dropdownItemStyles
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-1107306638 main-content-container h-100 w-100 position-relative",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetDefault.default), {
                            asset: asset,
                            fetchedData: fetchedData,
                            graphIndex: graphIndex,
                            graphWidgetIDs: graphWidgetIDs,
                            handleCommandExecutedFromWidget: handleCommandExecutedFromWidget,
                            historicalUtilizationData: historicalUtilizationData,
                            renderNextGraph: renderNextGraph,
                            returningToRealTime: returningToRealTime,
                            signalNamesMap: signalNamesMap,
                            signalUnitsMap: signalUnitsMap,
                            textTagsWidgetRef: this.textTagsWidgetRef,
                            updateRealTime: updateRealTime,
                            utilizationData: utilizationData,
                            widget: widget
                        })
                    })
                }),
                showCustomFilterModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customTimeFilterModalDefault.default), {
                    customEndTimestamp: customEndTimestamp,
                    customStartTimestamp: customStartTimestamp,
                    type: type,
                    maxDatapoints: maxDatapoints,
                    showCustomFilterModal: showCustomFilterModal,
                    handleCustomFilterSaveCallback: this.handleCustomFilterSaveCallback,
                    toggleCustomFilterModal: this.toggleCustomFilterModal
                }) : null,
                showDeleteWidgetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteWidgetModalDefault.default), {
                    asset: asset,
                    dashboardID: dashboardID,
                    isOpen: showDeleteWidgetModal,
                    handleWidgetDeleted: handleWidgetDeleted,
                    toggleModal: this.toggleDeleteWidgetModal,
                    widget: widget
                }) : null,
                showEditWidgetModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editWidgetModalDefault.default), {
                    asset: asset,
                    dashboardID: dashboardID,
                    isOpen: showEditWidgetModal,
                    handleWidgetUpdated: handleWidgetUpdated,
                    toggleModal: this.toggleEditWidgetModal,
                    widget: widget
                }) : null,
                showExportSignalCollectionModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exportSignalCollectionModalContainerDefault.default), {
                    gatewayID: asset?._id,
                    isOpen: showExportSignalCollectionModal,
                    orgID: asset?.orgID,
                    toggleModal: this.toggleExportSignalCollectionModal,
                    widget: widget
                }) : null,
                showUtilizationTimeSelectModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utilizationTimeSelectModalDefault.default), {
                    customEndTimestamp: customEndTimestamp,
                    customStartTimestamp: customStartTimestamp,
                    handleUtilizationTimeSelect: this.handleUtilizationTimeSelect,
                    isOpen: showUtilizationTimeSelectModal,
                    settings: settings,
                    toggleModal: this.toggleUtilizationTimeSelectModal
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                    id: "1107306638",
                    children: ".widget-outer-wrapper.jsx-1107306638{display:grid;grid-template-rows:4rem minmax(auto,auto);grid-template-areas:'header' 'content';}.header-container.jsx-1107306638{grid-area:header;}.main-content-container.jsx-1107306638{grid-area:content;}@media (min-width:768px){.widget-outer-wrapper.jsx-1107306638{grid-template-rows:3rem minmax(auto,auto);}}"
                })
            ]
        });
    }
}
exports.default = WidgetDisplayContainer;

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","lodash/isEqual":"3mRdp","lodash/round":"immc6","date-fns/format":"520Dk","date-fns/isValid":"l72u5","date-fns/subHours":"jSfbp","date-fns/max":"jGJ2T","date-fns/min":"7SRyU","papaparse":"8J3nL","react-tooltip":"4ejwp","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","reactstrap":"kjd7g","../../Constants/DateFormatStrings":"8sDpe","../../Constants/RBAC":"ieo1E","../../Constants/Signal":"bTf7q","../../Constants/WidgetTypes":"frQz2","../../Lib/WidgetUtils":"uF2rc","../../Styles/Z-INDEX":"CxzKK","../../Utils/dateFormatHelpers.util":"kzAoV","./DeleteWidgetModal":"a3atF","./EditWidgetModal":"8ApW3","../ErrorBoundary":"e71Au","./ExportSignalCollectionModalContainer":"aJVUV","./UtilizationTimeSelectModal":"ckALm","./Widget":"emC8E","../../RBAC/Can":"l4l8D","./AssetTimeFilter/TimeRangeDropdown":"6jqy0","./AssetTimeFilter/CustomTimeFilterModal":"8a27C","./AssetTimeFilter/utils":"dnj44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jSfbp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subHours);
var _indexJs = require("../addHours/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addHours/index.js":"1WytR","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8J3nL":[function(require,module,exports) {
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : module.exports = t();
}(this, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "	",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});

},{}],"8sDpe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FULL_MONTH", ()=>FULL_MONTH);
parcelHelpers.export(exports, "MONTH_DAY", ()=>MONTH_DAY);
parcelHelpers.export(exports, "MONTH_DAY_YEAR_HOUR_MINUTE", ()=>MONTH_DAY_YEAR_HOUR_MINUTE);
parcelHelpers.export(exports, "MONTH_DAY_YEAR", ()=>MONTH_DAY_YEAR);
parcelHelpers.export(exports, "MONTH_DAY_YEAR_SLASH", ()=>MONTH_DAY_YEAR_SLASH);
parcelHelpers.export(exports, "UTC", ()=>UTC);
const FULL_MONTH = "MMMM";
const MONTH_DAY = "M/d";
const MONTH_DAY_YEAR_HOUR_MINUTE = "MM-dd-y HH:mm";
const MONTH_DAY_YEAR = "MM-dd-y";
const MONTH_DAY_YEAR_SLASH = "MM/dd/y";
const UTC = "UTC";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzAoV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLocalForAssetDashboardTile", ()=>formatLocalForAssetDashboardTile);
parcelHelpers.export(exports, "formatLocalMonthDayYear", ()=>formatLocalMonthDayYear);
parcelHelpers.export(exports, "formatUTCForAssetDashboardTile", ()=>formatUTCForAssetDashboardTile);
parcelHelpers.export(exports, "formatUTCForWeeklyUtilizationTile", ()=>formatUTCForWeeklyUtilizationTile);
parcelHelpers.export(exports, "formatUTCFullMonth", ()=>formatUTCFullMonth);
parcelHelpers.export(exports, "formatUTCMonthDay", ()=>formatUTCMonthDay);
var _jsxRuntime = require("react/jsx-runtime");
var _addDays = require("date-fns/addDays");
var _addDaysDefault = parcelHelpers.interopDefault(_addDays);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _format1 = require("date-fns-tz/format");
var _formatDefault1 = parcelHelpers.interopDefault(_format1);
var _utcToZonedTime = require("date-fns-tz/utcToZonedTime");
var _utcToZonedTimeDefault = parcelHelpers.interopDefault(_utcToZonedTime);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _dateFormatStrings = require("../Constants/DateFormatStrings");
function formatLocalForAssetDashboardTile(date) {
    return (0, _isValidDefault.default)(date) ? (0, _formatDefault.default)(date, (0, _dateFormatStrings.MONTH_DAY_YEAR_HOUR_MINUTE)) : "";
}
function formatLocalMonthDayYear(date_string) {
    const date = new Date(date_string);
    return (0, _isValidDefault.default)(date) ? (0, _formatDefault.default)(date, (0, _dateFormatStrings.MONTH_DAY_YEAR_SLASH)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        icon: (0, _freeSolidSvgIcons.faMinus)
    });
}
function formatUTCForAssetDashboardTile(date) {
    return (0, _isValidDefault.default)(date) ? (0, _formatDefault1.default)((0, _utcToZonedTimeDefault.default)(date, (0, _dateFormatStrings.UTC)), (0, _dateFormatStrings.MONTH_DAY_YEAR), {
        timeZone: (0, _dateFormatStrings.UTC)
    }) : "";
}
function formatUTCForWeeklyUtilizationTile(date) {
    return (0, _isValidDefault.default)(date) ? `${formatUTCMonthDay(date)} - ${formatUTCMonthDay((0, _addDaysDefault.default)(date, 6))}` : "";
}
function formatUTCFullMonth(date) {
    return (0, _isValidDefault.default)(date) ? (0, _formatDefault1.default)((0, _utcToZonedTimeDefault.default)(date, (0, _dateFormatStrings.UTC)), (0, _dateFormatStrings.FULL_MONTH), {
        timeZone: (0, _dateFormatStrings.UTC)
    }) : "";
}
function formatUTCMonthDay(date) {
    return (0, _isValidDefault.default)(date) ? (0, _formatDefault1.default)((0, _utcToZonedTimeDefault.default)(date, (0, _dateFormatStrings.UTC)), (0, _dateFormatStrings.MONTH_DAY), {
        timeZone: (0, _dateFormatStrings.UTC)
    }) : "";
}

},{"react/jsx-runtime":"1dlk8","date-fns/addDays":"fK40q","date-fns/format":"520Dk","date-fns/isValid":"l72u5","date-fns-tz/format":"cEzmy","date-fns-tz/utcToZonedTime":"egkRD","react":"9njXz","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../Constants/DateFormatStrings":"8sDpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cEzmy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("date-fns/format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./formatters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match(tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, _indexJsDefault2.default)(dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, _indexJsDefault1.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, _indexJsDefault.default)(dirtyDate, formatStr, options);
}

},{"date-fns/format/index.js":"cnVe2","./formatters/index.js":"irkMu","../toDate/index.js":"c5C6z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnVe2":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("f86d579e42626f4f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = format;
var _index = _interopRequireDefault(require("1fe30f48a2b12a18"));
var _index2 = _interopRequireDefault(require("91da7a7bb9731bc8"));
var _index3 = _interopRequireDefault(require("cbcdcb8bbba7cdd6"));
var _index4 = _interopRequireDefault(require("4bf37781a1e85da9"));
var _index5 = _interopRequireDefault(require("c7c9036672c9968"));
var _index6 = _interopRequireDefault(require("9b7316e82f4ca54d"));
var _index7 = require("a5dc5e69d88524a");
var _index8 = _interopRequireDefault(require("80674666a5ea4684"));
var _index9 = _interopRequireDefault(require("a70699f62d7110c2"));
var _index10 = require("87602e21a4fc6ea7");
var _index11 = _interopRequireDefault(require("6ecf1bdd9838a1b6"));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _index10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
    var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _index3.default)(dirtyDate);
    if (!(0, _index.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _index6.default)(originalDate);
    var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = _index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = _index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;

},{"f86d579e42626f4f":"kZ6eK","1fe30f48a2b12a18":"sVYaY","91da7a7bb9731bc8":"4cGN8","cbcdcb8bbba7cdd6":"gXAVm","4bf37781a1e85da9":"7pEDK","c7c9036672c9968":"8DtMz","9b7316e82f4ca54d":"dOJRl","a5dc5e69d88524a":"kbVzs","80674666a5ea4684":"l4B11","a70699f62d7110c2":"a596E","87602e21a4fc6ea7":"aHkDq","6ecf1bdd9838a1b6":"eyN48"}],"sVYaY":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("3339310cd01d224c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValid;
var _index = _interopRequireDefault(require("17f7a33424d53065"));
var _index2 = _interopRequireDefault(require("988a1b9d58fb9dc3"));
var _index3 = _interopRequireDefault(require("e664e6a1553fb1e0"));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function isValid(dirtyDate) {
    (0, _index3.default)(1, arguments);
    if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = exports.default;

},{"3339310cd01d224c":"kZ6eK","17f7a33424d53065":"5t5IA","988a1b9d58fb9dc3":"gXAVm","e664e6a1553fb1e0":"a596E"}],"5t5IA":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("338466e455b14575").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isDate;
var _typeof2 = _interopRequireDefault(require("b8bbff02b11f8d53"));
var _index = _interopRequireDefault(require("711bcf4ba0de247c"));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function isDate(value) {
    (0, _index.default)(1, arguments);
    return value instanceof Date || (0, _typeof2.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
module.exports = exports.default;

},{"338466e455b14575":"kZ6eK","b8bbff02b11f8d53":"979to","711bcf4ba0de247c":"a596E"}],"a596E":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = requiredArgs;
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
module.exports = exports.default;

},{}],"gXAVm":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2b2ebc7d56df52bd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toDate;
var _typeof2 = _interopRequireDefault(require("a126697796216d4d"));
var _index = _interopRequireDefault(require("5c5ecf72f02d842c"));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    (0, _index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeof2.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = exports.default;

},{"2b2ebc7d56df52bd":"kZ6eK","a126697796216d4d":"979to","5c5ecf72f02d842c":"a596E"}],"4cGN8":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("982587670168e5f3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subMilliseconds;
var _index = _interopRequireDefault(require("c5d9824c393085d7"));
var _index2 = _interopRequireDefault(require("d8f669c4845e1248"));
var _index3 = _interopRequireDefault(require("4c81ec5fa767dd0e"));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index2.default)(2, arguments);
    var amount = (0, _index3.default)(dirtyAmount);
    return (0, _index.default)(dirtyDate, -amount);
}
module.exports = exports.default;

},{"982587670168e5f3":"kZ6eK","c5d9824c393085d7":"5xM9i","d8f669c4845e1248":"a596E","4c81ec5fa767dd0e":"l4B11"}],"5xM9i":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("95756b80fa126250").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addMilliseconds;
var _index = _interopRequireDefault(require("e0d1cd2fc430dc41"));
var _index2 = _interopRequireDefault(require("2c24b24f968ff7de"));
var _index3 = _interopRequireDefault(require("169293c116ef1f15"));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var timestamp = (0, _index2.default)(dirtyDate).getTime();
    var amount = (0, _index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = exports.default;

},{"95756b80fa126250":"kZ6eK","e0d1cd2fc430dc41":"l4B11","2c24b24f968ff7de":"gXAVm","169293c116ef1f15":"a596E"}],"l4B11":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toInteger;
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

},{}],"7pEDK":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c3cabd8a75691399").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("e18d65780c808351"));
var _index2 = _interopRequireDefault(require("7a7545910d16b33f"));
var _index3 = _interopRequireDefault(require("c03a85779c66753e"));
var _index4 = _interopRequireDefault(require("17e4cc5d10f8dd59"));
var _index5 = _interopRequireDefault(require("792bde6e71038421"));
var _index6 = _interopRequireDefault(require("3d2219d4eacb96a7"));
var _index7 = _interopRequireDefault(require("aa768d00659e9a8b"));
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return _index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _index3.default)(date);
        // Padding
        return (0, _index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return _index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _index4.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _index2.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return _index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _index.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return _index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return _index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return _index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return _index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return _index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _index6.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"c3cabd8a75691399":"kZ6eK","e18d65780c808351":"dwGun","7a7545910d16b33f":"huaw6","c03a85779c66753e":"5PlmB","17e4cc5d10f8dd59":"23xgT","792bde6e71038421":"XQNJE","3d2219d4eacb96a7":"7RWFH","aa768d00659e9a8b":"4fRLQ"}],"dwGun":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("63ab70f76e61c379").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCDayOfYear;
var _index = _interopRequireDefault(require("4b7483fab6f6f147"));
var _index2 = _interopRequireDefault(require("467f90d9b0286522"));
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;

},{"63ab70f76e61c379":"kZ6eK","4b7483fab6f6f147":"gXAVm","467f90d9b0286522":"a596E"}],"huaw6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("fb68fbc215d258f4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeek;
var _index = _interopRequireDefault(require("3e4a03f3d08187e5"));
var _index2 = _interopRequireDefault(require("12a52f6fe6354603"));
var _index3 = _interopRequireDefault(require("33a067968a51f03b"));
var _index4 = _interopRequireDefault(require("8c2e14ddd62ad78a"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"fb68fbc215d258f4":"kZ6eK","3e4a03f3d08187e5":"gXAVm","12a52f6fe6354603":"d0ebO","33a067968a51f03b":"gvLHz","8c2e14ddd62ad78a":"a596E"}],"d0ebO":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2393c04e863e086f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeek;
var _index = _interopRequireDefault(require("88bd8243a6fb9a75"));
var _index2 = _interopRequireDefault(require("7185b2bd8b0e0ab0"));
function startOfUTCISOWeek(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"2393c04e863e086f":"kZ6eK","88bd8243a6fb9a75":"gXAVm","7185b2bd8b0e0ab0":"a596E"}],"gvLHz":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b5d4742ad8f9124e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(require("4df9ac36cfb76094"));
var _index2 = _interopRequireDefault(require("3e25d8f8bf5f9829"));
var _index3 = _interopRequireDefault(require("25e58783c3feea35"));
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var year = (0, _index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _index2.default)(fourthOfJanuary);
    return date;
}
module.exports = exports.default;

},{"b5d4742ad8f9124e":"kZ6eK","4df9ac36cfb76094":"5PlmB","3e25d8f8bf5f9829":"d0ebO","25e58783c3feea35":"a596E"}],"5PlmB":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2d47386185bb2409").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeekYear;
var _index = _interopRequireDefault(require("c140cac95f358d97"));
var _index2 = _interopRequireDefault(require("81cc93a9fe9fbf4b"));
var _index3 = _interopRequireDefault(require("23fc4aa122fcad18"));
function getUTCISOWeekYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"2d47386185bb2409":"kZ6eK","c140cac95f358d97":"gXAVm","81cc93a9fe9fbf4b":"a596E","23fc4aa122fcad18":"d0ebO"}],"23xgT":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2b29c1a3ff28030a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeek;
var _index = _interopRequireDefault(require("9c098228a4cb1ff0"));
var _index2 = _interopRequireDefault(require("fecdbb0ae8f01baa"));
var _index3 = _interopRequireDefault(require("b3e36117033835d5"));
var _index4 = _interopRequireDefault(require("bae4d6de1972a08d"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"2b29c1a3ff28030a":"kZ6eK","9c098228a4cb1ff0":"gXAVm","fecdbb0ae8f01baa":"6k1iV","b3e36117033835d5":"e4nsr","bae4d6de1972a08d":"a596E"}],"6k1iV":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("b9ccd1e3e5453533").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeek;
var _index = _interopRequireDefault(require("3cf930c1f8a75177"));
var _index2 = _interopRequireDefault(require("16657271cd31aa61"));
var _index3 = _interopRequireDefault(require("59c0acd5397c2e99"));
var _index4 = require("50cd3ec2eee20af4");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index4.getDefaultOptions)();
    var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"b9ccd1e3e5453533":"kZ6eK","3cf930c1f8a75177":"gXAVm","16657271cd31aa61":"a596E","59c0acd5397c2e99":"l4B11","50cd3ec2eee20af4":"aHkDq"}],"aHkDq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{}],"e4nsr":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("29e744893ccacc45").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeekYear;
var _index = _interopRequireDefault(require("1e46324a3287aee4"));
var _index2 = _interopRequireDefault(require("d22b2df3e54bba59"));
var _index3 = _interopRequireDefault(require("cd0cf10ea1b96f85"));
var _index4 = _interopRequireDefault(require("1020ce8d2bc92a46"));
var _index5 = require("972a0ccb92d8bbe4");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _index3.default)(firstWeek, options);
    return date;
}
module.exports = exports.default;

},{"29e744893ccacc45":"kZ6eK","1e46324a3287aee4":"XQNJE","d22b2df3e54bba59":"a596E","cd0cf10ea1b96f85":"6k1iV","1020ce8d2bc92a46":"l4B11","972a0ccb92d8bbe4":"aHkDq"}],"XQNJE":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("92759581cef1be85").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeekYear;
var _index = _interopRequireDefault(require("38626c34abbfd5cc"));
var _index2 = _interopRequireDefault(require("dc8dd1ae5924c300"));
var _index3 = _interopRequireDefault(require("391cd5e455c9f364"));
var _index4 = _interopRequireDefault(require("fa6c59702933a671"));
var _index5 = require("11ea2a2b415afa1");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"92759581cef1be85":"kZ6eK","38626c34abbfd5cc":"gXAVm","dc8dd1ae5924c300":"a596E","391cd5e455c9f364":"6k1iV","fa6c59702933a671":"l4B11","11ea2a2b415afa1":"aHkDq"}],"7RWFH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
module.exports = exports.default;

},{}],"4fRLQ":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("31b536496484381f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("70c9714f0a3fc09e"));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.default)(fractionalSeconds, token.length);
    }
};
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"31b536496484381f":"kZ6eK","70c9714f0a3fc09e":"7RWFH"}],"8DtMz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;

},{}],"dOJRl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

},{}],"kbVzs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{}],"eyN48":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("ff544fa389713d11").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("f3c5cb0655b45cc9"));
var _default = _index.default;
exports.default = _default;
module.exports = exports.default;

},{"ff544fa389713d11":"kZ6eK","f3c5cb0655b45cc9":"gqqxX"}],"gqqxX":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("8f4b9a4f1b239517").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("a646f952b19f4966"));
var _index2 = _interopRequireDefault(require("33fc832b764d1ce6"));
var _index3 = _interopRequireDefault(require("335053a879a54f9"));
var _index4 = _interopRequireDefault(require("c96792daf63a81fa"));
var _index5 = _interopRequireDefault(require("f1f6ef78114f9d94"));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: _index.default,
    formatLong: _index2.default,
    formatRelative: _index3.default,
    localize: _index4.default,
    match: _index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var _default = locale;
exports.default = _default;
module.exports = exports.default;

},{"8f4b9a4f1b239517":"kZ6eK","a646f952b19f4966":"aWINV","33fc832b764d1ce6":"cJRzD","335053a879a54f9":"c7VYp","c96792daf63a81fa":"3boa5","f1f6ef78114f9d94":"g0X76"}],"aWINV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var _default = formatDistance;
exports.default = _default;
module.exports = exports.default;

},{}],"cJRzD":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("22d6b94e52f0d51c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("9a7f687abdf37369"));
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _index.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _index.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _index.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
var _default = formatLong;
exports.default = _default;
module.exports = exports.default;

},{"22d6b94e52f0d51c":"kZ6eK","9a7f687abdf37369":"apzff"}],"apzff":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildFormatLongFn;
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = exports.default;

},{}],"c7VYp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
var _default = formatRelative;
exports.default = _default;
module.exports = exports.default;

},{}],"3boa5":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("eb01f1742f0dce6a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("df0d0075432877a6"));
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _index.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _index.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _index.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _index.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _index.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var _default = localize;
exports.default = _default;
module.exports = exports.default;

},{"eb01f1742f0dce6a":"kZ6eK","df0d0075432877a6":"iLfR5"}],"iLfR5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildLocalizeFn;
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = exports.default;

},{}],"g0X76":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("54673652a9d9ab5e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("1158505ef900e368"));
var _index2 = _interopRequireDefault(require("49922fc0dddfaa90"));
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _index2.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _index.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _index.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _index.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _index.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _index.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var _default = match;
exports.default = _default;
module.exports = exports.default;

},{"54673652a9d9ab5e":"kZ6eK","1158505ef900e368":"3XA0v","49922fc0dddfaa90":"jol1B"}],"3XA0v":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchFn;
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = exports.default;

},{}],"jol1B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchPatternFn;
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = exports.default;

},{}],"irkMu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../_lib/tzIntlTimeZoneName/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../_lib/tzParseTimezone/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_MINUTE = 60000;
var formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        var originalDate = options._originalDate || date;
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return (0, _indexJsDefault.default)("short", originalDate, options);
            // Long
            case "zzzz":
            default:
                return (0, _indexJsDefault.default)("long", originalDate, options);
        }
    }
};
function getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, _indexJsDefault1.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError("Invalid time zone specified: " + timeZone);
    return timeZoneOffset;
}
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
function formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimeter);
}
function formatTimezoneShort(offset, dirtyDelimeter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimeter = dirtyDelimeter || "";
    return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2);
}
exports.default = formatters;

},{"../../_lib/tzIntlTimeZoneName/index.js":"gV60S","../../_lib/tzParseTimezone/index.js":"846od","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gV60S":[function(require,module,exports) {
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzIntlTimeZoneName);
function tzIntlTimeZoneName(length, date, options) {
    var dtf = getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}
function partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === "timeZoneName") return formatted[i].value;
    }
}
function hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, "");
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : "";
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        "en-US"
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"846od":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzParseTimezone);
var _indexJs = require("../tzTokenizeDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../newDateUTC/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!validateTimezone(hours)) return NaN;
        return -(hours * MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        var minutes = parseInt(token[2], 10);
        if (!validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
        return hours > 0 ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if (isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : toUtcDate(date);
        var offset = calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function toUtcDate(date) {
    return (0, _indexJsDefault1.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function calcOffset(date, timezoneString) {
    var tokens = (0, _indexJsDefault.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, _indexJsDefault1.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
    if (validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

},{"../tzTokenizeDate/index.js":"9OXaO","../newDateUTC/index.js":"b4kv3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9OXaO":[function(require,module,exports) {
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tzTokenizeDate);
function tzTokenizeDate(date, timeZone) {
    var dtf = getDateTimeFormat(timeZone);
    return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
var typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, "");
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {};
function getDateTimeFormat(timeZone) {
    if (!dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: "America/New_York",
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z"));
        var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return dtfCache[timeZone];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4kv3":[function(require,module,exports) {
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newDateUTC);
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5C6z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _indexJs = require("date-fns/_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/tzPattern/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, _indexJsDefault3.default)
};
function toDate(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _indexJsDefault.default)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") return new Date(argument);
    else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, _indexJsDefault2.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time));
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function splitDateString(dateString) {
    var dateStrings = {};
    var parts = patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var patternYYY = patterns.YYY[additionalDigits];
    var patternYYYYY = patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!validateWeekDate(year, week)) return new Date(NaN);
        return dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(",", "."));
        if (!validateTime(hours)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(",", "."));
        if (!validateTime(hours, minutes)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(",", "."));
        if (!validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = isLeapYearIndex(year);
        if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

},{"date-fns/_lib/toInteger/index.js":"l4B11","date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js":"dOJRl","../_lib/tzParseTimezone/index.js":"846od","../_lib/tzPattern/index.js":"elKoB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"elKoB":[function(require,module,exports) {
/** Regex to identify the presence of a time zone specifier in a date string */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
exports.default = tzPattern;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"egkRD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcToZonedTime);
var _indexJs = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function utcToZonedTime(dirtyDate, timeZone, options) {
    var date = (0, _indexJsDefault1.default)(dirtyDate, options);
    var offsetMilliseconds = (0, _indexJsDefault.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

},{"../_lib/tzParseTimezone/index.js":"846od","../toDate/index.js":"c5C6z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a3atF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _templateDashboardService = require("../../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
var _deleteWidgetModalDisplay = require("./DeleteWidgetModalDisplay");
var _deleteWidgetModalDisplayDefault = parcelHelpers.interopDefault(_deleteWidgetModalDisplay);
class DeleteWidgetModal extends (0, _react.Component) {
    static propTypes = {
        asset: (0, _propTypesDefault.default).shape({
            gtemplateID: (0, _propTypesDefault.default).string
        }),
        dashboardID: (0, _propTypesDefault.default).string,
        isOpen: (0, _propTypesDefault.default).bool,
        handleWidgetDeleted: (0, _propTypesDefault.default).func,
        toggleModal: (0, _propTypesDefault.default).func,
        widget: (0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string
        })
    };
    state = {
        error: "",
        deleteRequestPending: false
    };
    source = (0, _axios.CancelToken).source();
    service = new (0, _templateDashboardServiceDefault.default)();
    componentWillUnmount() {
        this.source.cancel();
    }
    handleWidgetDelete = async ()=>{
        this.setState({
            deleteRequestPending: true
        });
        try {
            const { asset: { gtemplateID }, dashboardID, handleWidgetDeleted, widget: { _id: widgetID } } = this.props;
            await this.service.deleteTemplateDashboardWidget(gtemplateID, dashboardID, widgetID, this.source.token);
            this.setState({
                deleteRequestPending: false
            }, ()=>{
                handleWidgetDeleted(widgetID);
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            this.setState({
                error,
                deleteRequestPending: false
            });
        }
    };
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteWidgetModalDisplayDefault.default), {
            ...this.props,
            ...this.state,
            handleWidgetDelete: this.handleWidgetDelete
        });
    }
}
exports.default = DeleteWidgetModal;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/TemplateDashboardService":"kZyFp","./DeleteWidgetModalDisplay":"9dIPy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9dIPy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteWidgetModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
function DeleteWidgetModalDisplay(props) {
    const { isOpen, toggleModal, handleWidgetDelete, error, deleteRequestPending } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        desktopHeight: "unset",
        isOpen: isOpen,
        toggleModal: toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-0 modal-title-text",
                toggle: toggleModal,
                children: "Delete Smart Tile?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid py-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1340956879 row justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1340956879 col-12 col-lg-10 text-left modal-supplemental-text",
                            children: "Deleting this smart tile will permanently remove it from this asset, and all other assets with the same Asset Model."
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1340956879 row justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1340956879 col-12 col-lg-10 text-left modal-supplemental-text",
                            children: "Configuration data associated with this smart tile will be lost, but you can create the same smart tile with the same signals at any time if you\u2019d like."
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1340956879 row justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-1340956879 col-12 col-lg-10 text-danger text-right",
                            children: error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-1340956879 btn btn-outline-secondary py-0 px-3 ml-4",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleWidgetDelete,
                        className: "jsx-1340956879 btn btn-danger py-0 px-3",
                        children: deleteRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            size: "lg"
                        }) : "Yes, Delete"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1340956879",
                children: ".btn.jsx-1340956879{font-size:0.9rem;}.description-container.jsx-1340956879{font-size:0.75rem;}@media (min-width:768px){.description-container.jsx-1340956879{font-size:1rem;}}"
            })
        ]
    });
}
DeleteWidgetModalDisplay.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    handleWidgetDelete: (0, _propTypesDefault.default).func,
    error: (0, _propTypesDefault.default).string,
    deleteRequestPending: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../ModalLayout":"2RoDj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ApW3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _uuid = require("uuid");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _gatewayReminderInstanceService = require("../../Services/GatewayReminderInstanceService");
var _gatewayReminderInstanceServiceDefault = parcelHelpers.interopDefault(_gatewayReminderInstanceService);
var _tagService = require("../../Services/TagService");
var _tagServiceDefault = parcelHelpers.interopDefault(_tagService);
var _templateDashboardService = require("../../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _widgetUpdateHelper = require("../../Lib/WidgetUpdateHelper");
var _widgetUpdateHelperDefault = parcelHelpers.interopDefault(_widgetUpdateHelper);
var _widgetUtils = require("../../Lib/WidgetUtils");
var _widgetUtilsDefault = parcelHelpers.interopDefault(_widgetUtils);
var _editWidgetModalDisplay = require("./EditWidgetModalDisplay");
var _editWidgetModalDisplayDefault = parcelHelpers.interopDefault(_editWidgetModalDisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(EditWidgetModal);
const initState = {
    activeImageCoordinate: new Map(),
    displayTextAsGrid: false,
    editRequestPending: false,
    image: "",
    imageCoordinatesMap: new Map(),
    maintenanceLoading: true,
    reminderInstanceOptions: [],
    selectedAggregation: "",
    selectedInstances: [],
    showTimeSinceLastUpdated: false,
    tagsLoading: true,
    widgetName: "",
    widgetSignals: [],
    widgetType: {},
    yMax: null,
    yMin: null
};
function EditWidgetModal(props) {
    const source = (0, _axios.CancelToken).source();
    const dashboardWidgetService = (0, _react.useMemo)(()=>new (0, _templateDashboardServiceDefault.default)(), []), reminderInstanceService = (0, _react.useMemo)(()=>new (0, _gatewayReminderInstanceServiceDefault.default)(), []), tagService = (0, _react.useMemo)(()=>new (0, _tagServiceDefault.default)(), []), templateService = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []), widgetUpdateHelper = (0, _react.useMemo)(()=>new (0, _widgetUpdateHelperDefault.default)(), []), widgetUtils = (0, _react.useMemo)(()=>new (0, _widgetUtilsDefault.default)(), []), widgetTypes = (0, _react.useMemo)(()=>[
            ...widgetUtils.types,
            ...widgetUtils.legacyTypes
        ], [
        widgetUtils.legacyTypes,
        widgetUtils.types
    ]);
    const imageOverlayRef = (0, _react.useRef)();
    const [state, updateState] = (0, _react.useState)(()=>{
        const { aggregation: selectedAggregation, displayTextAsGrid = false, image = "", showTimeSinceLastUpdated = false, title: widgetName = "", yMax = null, yMin = null } = props.widget?.settings || {};
        const datapointsMap = widgetUtils.createDatapointMapForDisplay(props.asset?.gtemplate?.datapoints);
        const widgetType = widgetTypes.find(({ value } = {})=>value === props.widget?.type) || {};
        return {
            ...initState,
            datapointsMap,
            displayTextAsGrid,
            image,
            selectedAggregation,
            showTimeSinceLastUpdated,
            widgetName,
            widgetType,
            yMax,
            yMin
        };
    });
    const editWidget = async ()=>{
        const { asset: { gtemplateID, gtemplate }, dashboardID, handleWidgetUpdated, toggleModal, widget, widget: { _id: widgetID } } = props;
        try {
            updateState((prevState)=>({
                    ...prevState,
                    editRequestPending: true
                }));
            const body = widgetUpdateHelper.buildUpdateRequestBody(state, widget, gtemplate, state.imageCoordinatesMap);
            const { widgets } = await dashboardWidgetService.updateTemplateDashboardWidget(gtemplateID, dashboardID, widgetID, body, source.token);
            handleWidgetUpdated(widgets);
            toggleModal();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    editRequestPending: false,
                    error
                }));
        }
    };
    const handleAddImageOverlaySignal = (0, _react.useCallback)((coordinates, signal)=>{
        updateState((prevState)=>{
            const imageCoordinatesMap = new Map(prevState.imageCoordinatesMap).set(coordinates, signal);
            return {
                ...prevState,
                imageCoordinatesMap,
                activeImageCoordinate: new Map()
            };
        });
    }, []);
    const handleAddRange = (outerIndex, innerIndex)=>{
        if (innerIndex >= 4) return;
        try {
            const widgetSignals = state.widgetSignals.map((s, index)=>{
                if (index !== outerIndex) return s;
                const validRange = s.ranges?.every?.(({ color, label, maxValue, minValue } = {})=>{
                    return color && label && maxValue && minValue;
                });
                if (!validRange) throw new Error("Each range must have a Min/Max Value, Label and Color.");
                const { maxValue } = s.ranges[innerIndex] || {};
                return {
                    ...s,
                    ranges: s.ranges.concat({
                        id: (0, _uuid.v4)(),
                        minValue: maxValue
                    })
                };
            });
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    widgetSignals
                }));
        } catch ({ message: error }) {
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    };
    const handleAddStaticTextLink = (0, _react.useCallback)(()=>{
        updateState((prevState)=>{
            const [{ links: prevLinks = [] }] = prevState.widgetSignals;
            const links = [
                ...prevLinks,
                {
                    display: "",
                    link: ""
                }
            ];
            return {
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        links
                    }
                ]
            };
        });
    }, []);
    const handleAddWidgetCommand = (0, _react.useCallback)((command, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? command : s);
            return {
                ...prevState,
                widgetSignals,
                error: ""
            };
        });
    }, []);
    const handleAddWidgetSignal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>{
            if (prevState.widgetSignals?.length === prevState.widgetType?.maxSignals) return prevState;
            const rowToAdd = widgetUtils.nonSignalTypes.has(prevState.widgetType) ? {} : widgetUtils.widgetSignalDefault;
            return {
                ...prevState,
                widgetSignals: prevState.widgetSignals.concat(rowToAdd)
            };
        });
    }, [
        widgetUtils.nonSignalTypes,
        widgetUtils.widgetSignalDefault
    ]);
    const handleAggregationSelect = (0, _react.useCallback)((selected)=>{
        updateState((prevState)=>({
                ...prevState,
                selectedAggregation: selected?.value
            }));
    }, []);
    const handleColorInput = (0, _react.useCallback)(({ target: { value } }, outerIndex, innerIndex)=>{
        const trimmedInput = value.trim();
        const color = trimmedInput.startsWith("#") ? trimmedInput : "#".concat(trimmedInput);
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>{
                if (i !== outerIndex) return s;
                const ranges = s.ranges.map((r, index)=>index === innerIndex ? {
                        ...r,
                        color
                    } : r);
                return {
                    ...s,
                    ranges
                };
            });
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleColorSelected = (0, _react.useCallback)((color, outerIndex, innerIndex)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>{
                if (i !== outerIndex) return s;
                const ranges = s.ranges.map((r, index)=>index === innerIndex ? {
                        ...r,
                        color
                    } : r);
                return {
                    ...s,
                    ranges
                };
            });
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleCoordinateClick = (0, _react.useCallback)((x, y, overlayConfig)=>{
        updateState((prevState)=>{
            const activeImageCoordinate = new Map([
                [
                    "x",
                    Number(x)
                ],
                [
                    "y",
                    Number(y)
                ],
                [
                    "overlayConfig",
                    overlayConfig
                ]
            ]);
            return {
                ...prevState,
                activeImageCoordinate
            };
        });
    }, []);
    const handleDatapointSelect = (0, _react.useCallback)((datapoint, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>{
                if (i !== index) return s;
                return {
                    ...s,
                    datapoint,
                    signal: {}
                };
            });
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleDisplayTextAsGridClick = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                displayTextAsGrid: !prevState.displayTextAsGrid
            }));
    }, []);
    const handleImageClick = (0, _react.useCallback)(({ clientX, clientY, target })=>{
        const { bottom, left, right, top } = target.getBoundingClientRect?.() || {};
        const xCalc = (clientX - left) * 100 / (right - left);
        const x = Number(xCalc.toFixed());
        const yCalc = (clientY - top) * 100 / (bottom - top);
        const y = Number(yCalc.toFixed());
        const activeImageCoordinate = new Map([
            [
                "x",
                clientX
            ],
            [
                "y",
                clientY
            ],
            [
                "overlayConfig",
                {
                    x,
                    y
                }
            ]
        ]);
        updateState((prevState)=>({
                ...prevState,
                activeImageCoordinate
            }));
    }, []);
    const handleInstanceSelect = (0, _react.useCallback)((selectedInstances)=>{
        updateState((prevState)=>({
                ...prevState,
                selectedInstances
            }));
    }, []);
    const handleMinMaxValueUpdate = (0, _react.useCallback)(({ target: { name, value } }, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? {
                    ...s,
                    [name]: value
                } : s);
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleNameAndYScaleUpdate = (0, _react.useCallback)(({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    }, []);
    const handleOptionDisabled = (0, _react.useCallback)((signal)=>{
        return state.widgetSignals.some((widgetSignal)=>signal.value === widgetSignal.signal.value);
    }, [
        state.widgetSignals
    ]);
    const handleRangeValueUpdate = (0, _react.useCallback)(({ target: { name, value } }, outerIndex, innerIndex)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, index)=>{
                if (index !== outerIndex) return s;
                const ranges = s.ranges.map((r, i)=>{
                    switch(true){
                        case i === innerIndex:
                            return {
                                ...r,
                                [name]: value
                            };
                        case name === "maxValue" && innerIndex === i - 1:
                            return {
                                ...r,
                                minValue: value
                            };
                        default:
                            return r;
                    }
                });
                return {
                    ...s,
                    ranges
                };
            });
            return {
                ...prevState,
                error: "",
                widgetSignals
            };
        });
    }, []);
    const handleRemoveImageOverlaySignal = (0, _react.useCallback)((coordinates)=>{
        updateState((prevState)=>{
            const imageCoordinatesMap = new Map(prevState.imageCoordinatesMap);
            imageCoordinatesMap.delete(coordinates);
            return {
                ...prevState,
                imageCoordinatesMap,
                activeImageCoordinate: new Map()
            };
        });
    }, []);
    const handleRemoveRange = (0, _react.useCallback)((outerIndex, innerIndex)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, index)=>{
                if (index !== outerIndex) return s;
                const filtered = s.ranges.map((r, i, arr)=>{
                    if (!innerIndex || i !== innerIndex + 1) return r;
                    const { maxValue } = arr[innerIndex - 1] || {};
                    return {
                        ...r,
                        minValue: maxValue
                    };
                }).filter((r, i)=>i !== innerIndex);
                const ranges = filtered.length ? filtered : [
                    {
                        id: (0, _uuid.v4)()
                    }
                ];
                return {
                    ...s,
                    ranges
                };
            });
            return {
                ...prevState,
                error: "",
                widgetSignals
            };
        });
    }, []);
    const handleRemoveStaticTextLink = (0, _react.useCallback)((index)=>{
        updateState((prevState)=>{
            const links = prevState.widgetSignals[0].links.filter((_, i)=>i !== index);
            return {
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        links
                    }
                ]
            };
        });
    }, []);
    const handleRemoveWidgetSignal = (0, _react.useCallback)((index)=>{
        updateState((prevState)=>{
            const update = prevState.widgetSignals.filter((x, i)=>i !== index);
            const widgetSignals = update.length ? update : [
                widgetUtils.nonSignalTypes.has(prevState.widgetType) ? {} : widgetUtils.widgetSignalDefault
            ];
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, [
        widgetUtils.nonSignalTypes,
        widgetUtils.widgetSignalDefault
    ]);
    const handleSignalSelect = (0, _react.useCallback)((signal, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? {
                    ...s,
                    signal
                } : s);
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleStaticTextInput = (0, _react.useCallback)(({ target: { value } })=>{
        updateState((prevState)=>({
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        value
                    }
                ],
                error: ""
            }));
    }, []);
    const handleStaticTextLinkInput = (0, _react.useCallback)(({ target: { name, value } }, i)=>{
        updateState((prevState)=>{
            const links = prevState.widgetSignals[0].links?.map((link, index)=>index === i ? {
                    ...link,
                    [name]: value
                } : link);
            return {
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        links
                    }
                ]
            };
        });
    }, []);
    const handleTagSelect = (0, _react.useCallback)((selectedTag, index)=>{
        if (!selectedTag) return;
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? selectedTag : s);
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleTimeSinceLastUpdatedClick = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showTimeSinceLastUpdated: !prevState.showTimeSinceLastUpdated
            }));
    }, []);
    const getWidgetSignals = ({ type, settings } = {}, datapointsMap, asset = {})=>{
        switch(true){
            case type === (0, _widgetTypes.COMMAND):
                return getCommands(settings, asset);
            case widgetUtils.settingsSignalArrayNameMap.has(type):
                return getSignalsFromWidgetSettings(type, settings, datapointsMap, widgetUtils.settingsSignalArrayNameMap, props.asset?.gtemplateID, templateService, source.token);
            case type === (0, _widgetTypes.GAUGE):
                return getGaugeWidgetSignals(settings);
            case type === (0, _widgetTypes.GAUGE_RANGE):
                return getFlexibleRangeGaugeSignals(settings);
            case [
                (0, _widgetTypes.LOCATION),
                (0, _widgetTypes.MAP)
            ].includes(type):
                return [];
            case type === (0, _widgetTypes.TEXT_STATIC):
                return [
                    {
                        links: settings?.links,
                        value: settings?.staticText || ""
                    }
                ];
            case type === (0, _widgetTypes.TEXT_TAGS):
                return getTextTags(settings);
            default:
                return [];
        }
    };
    const setAsyncState = async ()=>{
        try {
            const widgetSignals = await getWidgetSignals(props.widget, state.datapointsMap, props.asset);
            switch(true){
                case props.widget?.type === (0, _widgetTypes.IMAGE):
                    {
                        const { left, height, top, width } = imageOverlayRef?.current?.getBoundingClientRect?.() || {};
                        const imageCoordinatesMap = new Map(props.widget?.settings?.lines?.map?.(({ x, y })=>{
                            const clientX = left + width * (x / 100);
                            const clientY = top + height * (y / 100);
                            const config = widgetSignals.find((signal)=>signal.x === x && signal.y === y) || {};
                            return [
                                `${clientX}-${clientY}`,
                                config
                            ];
                        }) || []);
                        return updateState((prevState)=>({
                                ...prevState,
                                imageCoordinatesMap,
                                tagsLoading: false,
                                widgetSignals
                            }));
                    }
                case props.widget?.type === (0, _widgetTypes.MAINTENANCE):
                    if (!state.maintenanceLoading) return;
                    try {
                        const params = {
                            gateway_id: props.asset?._id,
                            limit: 500,
                            page: 1
                        };
                        const { data } = await reminderInstanceService.getPaginatedGatewayReminderInstances(params, source.token);
                        const reminderInstanceOptions = data?.map?.((instance)=>({
                                label: instance?.GtemplateReminder?.name,
                                value: instance?.GtemplateReminder?._id
                            })), selectedInstances = props.widget?.settings?.maintenance?.map?.((instance)=>({
                                label: instance?.reminder_name,
                                value: instance?.reminder_id
                            }));
                        return updateState((prevState)=>({
                                ...prevState,
                                maintenanceLoading: false,
                                reminderInstanceOptions,
                                selectedInstances
                            }));
                    } catch (err) {
                        if ((0, _axios.isCancel)(err)) return;
                        const error = err.response?.data?.message ?? err.message;
                        return updateState((prevState)=>({
                                ...prevState,
                                error,
                                maintenanceLoading: false
                            }));
                    }
                case props.widget?.type !== (0, _widgetTypes.TEXT_TAGS) || state.tagsLoaded:
                    return updateState((prevState)=>({
                            ...prevState,
                            tagsLoading: false,
                            widgetSignals
                        }));
                default:
                    {
                        const params = {
                            orgID: props.asset?.orgID
                        };
                        const tags = await tagService.getTags(params, source.token);
                        const tagSet = new Set(tags.map(({ name })=>name));
                        const tagOptions = Array.from(tagSet).map((t)=>({
                                label: t,
                                value: t
                            }));
                        updateState((prevState)=>({
                                ...prevState,
                                tagOptions,
                                tagsLoaded: true,
                                tagsLoading: false,
                                widgetSignals
                            }));
                    }
            }
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err?.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    tagsLoading: false
                }));
        }
    };
    const toggleImageOverlayModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                activeImageCoordinate: new Map()
            }));
    }, []);
    (0, _react.useEffect)(()=>{
        setAsyncState();
        return source.cancel;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editWidgetModalDisplayDefault.default), {
        ...props,
        ...state,
        editWidget: editWidget,
        handleAddImageOverlaySignal: handleAddImageOverlaySignal,
        handleAddRange: handleAddRange,
        handleAddStaticTextLink: handleAddStaticTextLink,
        handleAddWidgetCommand: handleAddWidgetCommand,
        handleAddWidgetSignal: handleAddWidgetSignal,
        handleAggregationSelect: handleAggregationSelect,
        handleColorInput: handleColorInput,
        handleColorSelected: handleColorSelected,
        handleCoordinateClick: handleCoordinateClick,
        handleDatapointSelect: handleDatapointSelect,
        handleDisplayTextAsGridClick: handleDisplayTextAsGridClick,
        handleImageClick: handleImageClick,
        handleInstanceSelect: handleInstanceSelect,
        handleMinMaxValueUpdate: handleMinMaxValueUpdate,
        handleNameAndYScaleUpdate: handleNameAndYScaleUpdate,
        handleOptionDisabled: handleOptionDisabled,
        handleRangeValueUpdate: handleRangeValueUpdate,
        handleRemoveImageOverlaySignal: handleRemoveImageOverlaySignal,
        handleRemoveRange: handleRemoveRange,
        handleRemoveStaticTextLink: handleRemoveStaticTextLink,
        handleRemoveWidgetSignal: handleRemoveWidgetSignal,
        handleSignalSelect: handleSignalSelect,
        handleStaticTextInput: handleStaticTextInput,
        handleStaticTextLinkInput: handleStaticTextLinkInput,
        handleTagSelect: handleTagSelect,
        handleTimeSinceLastUpdatedClick: handleTimeSinceLastUpdatedClick,
        imageOverlayRef: imageOverlayRef,
        timeAggregationOptions: widgetUtils.timeAggregationOptions,
        toggleImageOverlayModal: toggleImageOverlayModal,
        updateState: updateState
    });
}
EditWidgetModal.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    dashboardID: (0, _propTypesDefault.default).string,
    handleWidgetUpdated: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    updateWidgets: (0, _propTypesDefault.default).func,
    widget: (0, _propTypesDefault.default).object
};
function getCommands({ commands = [] }, { gtemplate }) {
    return commands.map?.((c)=>{
        const { name: label = "" } = gtemplate?.commands?.find?.(({ _id })=>_id === c.commandID) || {};
        return {
            ...c,
            command: {
                label,
                value: c.commandID
            }
        };
    });
}
function getFlexibleRangeGaugeSignals(settings) {
    const { datapoint, datapoint: { name, values }, datapointID, key, ranges, secondGauge: { datapoint: datapoint2, datapoint: { name: name2, values: values2 } = {}, datapointID: datapointID2, key: key2, ranges: ranges2, type: secondGaugeType } = {}, type } = settings;
    if (type !== "outputSignal" && !values?.length) return [];
    let gaugeSignals;
    const firstGaugeRanges = ranges.map((range)=>{
        const { color, label, max, min } = range || {};
        const maxValue = String(max);
        const minValue = String(min);
        return {
            color,
            id: (0, _uuid.v4)(),
            label,
            maxValue,
            minValue
        };
    });
    if (type === "outputSignal") gaugeSignals = [
        {
            datapoint: {
                label: "Calculated Signal",
                value: "outputSignal"
            },
            ranges: firstGaugeRanges,
            signal: {
                label: name,
                value: datapoint
            }
        }
    ];
    else {
        const { _id: signalID } = values.find(({ name, label })=>{
            return name === key || label === key;
        });
        gaugeSignals = [
            {
                datapoint: {
                    label: name,
                    value: datapointID,
                    values
                },
                ranges: firstGaugeRanges,
                signal: {
                    label: key,
                    value: signalID
                }
            }
        ];
    }
    if (!datapointID2) return gaugeSignals;
    const secondGaugeRanges = ranges2.map((range)=>{
        const { color, label, max, min } = range || {};
        const maxValue = String(max);
        const minValue = String(min);
        return {
            color,
            id: (0, _uuid.v4)(),
            label,
            maxValue,
            minValue
        };
    });
    if (secondGaugeType === "outputSignal") return [
        ...gaugeSignals,
        {
            datapoint: {
                label: "Calculated Signal",
                value: "outputSignal"
            },
            ranges: secondGaugeRanges,
            signal: {
                label: name2,
                value: datapoint2
            }
        }
    ];
    const { _id: signalID2 } = values2.find(({ label, name })=>{
        return label === key2 || name === key2;
    });
    return [
        ...gaugeSignals,
        {
            datapoint: {
                label: name2,
                value: datapointID2,
                values: values2
            },
            ranges: secondGaugeRanges,
            signal: {
                label: key2,
                value: signalID2
            }
        }
    ];
}
function getGaugeWidgetSignals(settings) {
    const { datapoint, datapoint: { name, values }, datapointID, key, max, min, secondGauge: { datapoint: datapoint2, datapoint: { name: name2, values: values2 } = {}, datapointID: datapointID2, key: key2, max: max2, min: min2, type: secondGaugeType } = {}, type } = settings;
    if (type !== "outputSignal" && !values?.length) return [];
    const maxValue = String(max);
    const minValue = String(min);
    let gaugeSignals;
    if (type === "outputSignal") gaugeSignals = [
        {
            datapoint: {
                label: "Calculated Signal",
                value: "outputSignal"
            },
            maxValue,
            minValue,
            signal: {
                label: name,
                value: datapoint
            }
        }
    ];
    else {
        const { _id: signalID } = values.find(({ name, label })=>{
            return name === key || label === key;
        });
        gaugeSignals = [
            {
                datapoint: {
                    label: name,
                    value: datapointID,
                    values
                },
                maxValue,
                minValue,
                signal: {
                    label: key,
                    value: signalID
                }
            }
        ];
    }
    if (!datapointID2) return gaugeSignals;
    const maxValue2 = String(max2);
    const minValue2 = String(min2);
    if (secondGaugeType === "outputSignal") return [
        ...gaugeSignals,
        {
            datapoint: {
                label: "Calculated Signal",
                value: "outputSignal"
            },
            maxValue: maxValue2,
            minValue: minValue2,
            signal: {
                label: name2,
                value: datapoint2
            }
        }
    ];
    const { _id: signalID2 } = values2.find(({ label, name })=>{
        return label === key2 || name === key2;
    });
    return [
        ...gaugeSignals,
        {
            datapoint: {
                label: name2,
                value: datapointID2,
                values: values2
            },
            maxValue: maxValue2,
            minValue: minValue2,
            signal: {
                label: key2,
                value: signalID2
            }
        }
    ];
}
async function getSignalsFromWidgetSettings(type, settings, datapointsMap, settingsSignalArrayNameMap, templateID, templateService, cancelToken) {
    const currentDatapoints = settings[settingsSignalArrayNameMap.get(type)];
    if (!currentDatapoints?.length) return [];
    const { eventDatapoints, outputSignals } = currentDatapoints.reduce((acc, { datapointID, key, type, x, y } = {})=>{
        if (type === "outputSignal") acc.outputSignals.push({
            datapointID,
            x,
            y
        });
        else {
            const { label, value, values = [] } = datapointsMap.find(({ value })=>value === datapointID) || {};
            const { label: signalLabel = "", value: signalValue = "" } = values.find(({ label })=>label === key) || {};
            acc.eventDatapoints.push({
                datapoint: {
                    label,
                    value,
                    values
                },
                signal: {
                    label: signalLabel,
                    value: signalValue
                },
                x,
                y
            });
        }
        return acc;
    }, {
        eventDatapoints: [],
        outputSignals: []
    });
    if (!outputSignals.length) return eventDatapoints;
    const outputSignalProms = outputSignals.map(({ datapointID })=>{
        return templateService.fetchOutputSignal(templateID, datapointID, cancelToken);
    });
    const outputSignalsRes = await Promise.all(outputSignalProms);
    const formattedOutputSignals = outputSignalsRes?.map((os, i)=>({
            datapoint: {
                label: "Calculated Signal",
                value: "outputSignal"
            },
            signal: {
                label: os?.name,
                value: os
            },
            x: outputSignals[i].x,
            y: outputSignals[i].y
        }));
    return eventDatapoints.concat(formattedOutputSignals);
}
function getTextTags({ tags = [] } = {}) {
    return tags.map((t)=>({
            label: t,
            value: t
        }));
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","uuid":"hIyym","../../Constants/WidgetTypes":"frQz2","../../Services/GatewayReminderInstanceService":"WwEop","../../Services/TagService":"6HtCg","../../Services/TemplateDashboardService":"kZyFp","../../Services/TemplateService":"hGdvK","../../Lib/WidgetUpdateHelper":"6sUgi","../../Lib/WidgetUtils":"uF2rc","./EditWidgetModalDisplay":"a1IvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"WwEop":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class GatewayReminderInstanceService {
    api = new (0, _requestsDefault.default)();
    buildGetPaginatedGatewayReminderInstancesRequest(params, cancelToken) {
        return {
            cancelToken,
            endpoint: "/v2/reminder-instance",
            method: "get",
            params,
            service: "maintenance"
        };
    }
    async getPaginatedGatewayReminderInstances(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGetPaginatedGatewayReminderInstancesRequest(params, cancelToken));
        return data;
    }
    buildGetPaginatedOrgReportReminderInstancesRequest(orgID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/reminder-instance/${orgID}/report`,
            method: "get",
            params,
            service: "maintenance"
        };
    }
    async getPaginatedOrgReportReminderInstances(orgID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGetPaginatedOrgReportReminderInstancesRequest(orgID, params, cancelToken));
        return data;
    }
    buildGetOrgReportReminderInstancesRequestCsv(orgID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v2/reminder-instance/${orgID}/csv`,
            method: "get",
            params,
            service: "maintenance"
        };
    }
    async getOrgReportReminderInstancesCsv(orgID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGetOrgReportReminderInstancesRequestCsv(orgID, params, cancelToken));
        return data;
    }
    buildUpdateGatewayReminderInstancesRequest(gatewayID, data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: `/v2/reminder-instance/${gatewayID}`,
            method: "put",
            service: "maintenance"
        };
    }
    async updateGatewayReminderInstances(gatewayID, body, cancelToken) {
        return this.api.request(this.buildUpdateGatewayReminderInstancesRequest(gatewayID, body, cancelToken));
    }
}
exports.default = GatewayReminderInstanceService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HtCg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _authService = require("./AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class TagService {
    auth = new (0, _authServiceDefault.default)();
    api = new (0, _requestsDefault.default)();
    // Create tag request
    buildCreateTagRequest(gatewayID, orgID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/gateway/${gatewayID}/tag`,
            method: "post",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async createNewTag(gatewayID, orgID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateTagRequest(gatewayID, orgID, body, cancelToken));
        return data;
    }
    // Get a specific tag request
    buildFetchTagRequest(gatewayID, tagID, orgID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/gateway/${gatewayID}/tag/${tagID}`,
            method: "get",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async fetchTag(gatewayID, tagID, orgID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchTagRequest(gatewayID, tagID, orgID, cancelToken));
        return data;
    }
    // Get all tags request
    buildFetchAllTagsRequest(gatewayID, params, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/gateway/${gatewayID}/tag`,
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchAllTags(gatewayID, params, cancelToken) {
        const { data } = await this.api.request(this.buildFetchAllTagsRequest(gatewayID, params, cancelToken));
        return data;
    }
    //Edit tag request
    buildEditTagRequest(gatewayID, tagID, orgID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/gateway/${gatewayID}/tag/${tagID}`,
            method: "put",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async editTag(gatewayID, tagID, orgID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildEditTagRequest(gatewayID, tagID, orgID, body, cancelToken));
        return data;
    }
    //Delete tag request
    buildDeleteTagRequest(gatewayID, tagID, orgID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/gateway/${gatewayID}/tag/${tagID}`,
            method: "delete",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async deleteTag(gatewayID, tagID, orgID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteTagRequest(gatewayID, tagID, orgID, cancelToken));
        return data;
    }
    // search for existing tag names
    buildSearchNameRequest(orgID, nameSearch, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/tags",
            method: "get",
            params: {
                orgID: orgID,
                nameSearch: nameSearch
            },
            cancelToken
        };
    }
    async getTagNames(orgID, nameSearch, cancelToken) {
        const { data = {} } = await this.api.request(this.buildSearchNameRequest(orgID, nameSearch, cancelToken));
        return data;
    }
    // search for tags by name or value match
    buildSearchTagRequest(params, cancelToken) {
        return {
            service: "gateway",
            endpoint: "/v2/tags",
            method: "get",
            params,
            cancelToken
        };
    }
    async getTags(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildSearchTagRequest(params, cancelToken));
        return data;
    }
}
exports.default = TagService;

},{"./AuthService":"8Bjjn","../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a1IvP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _animated = require("react-select/animated");
var _animatedDefault = parcelHelpers.interopDefault(_animated);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _widgetModalDisplayComponents = require("./WidgetModalDisplayComponents");
var _configureGaugeWidget = require("./ConfigureGaugeWidget");
var _configureGaugeWidgetDefault = parcelHelpers.interopDefault(_configureGaugeWidget);
var _configureImageWidget = require("./ConfigureImageWidget");
var _configureImageWidgetDefault = parcelHelpers.interopDefault(_configureImageWidget);
var _selectStyles = require("../../Styles/SelectStyles");
exports.default = /*#__PURE__*/ (0, _react.memo)(EditWidgetModalDisplay);
const animatedComponents = (0, _animatedDefault.default)();
function EditWidgetModalDisplay(props) {
    const { asset, activeImageCoordinate, datapointsMap, displayTextAsGrid, editRequestPending, editWidget, error, handleAddImageOverlaySignal, handleAddRange, handleAddStaticTextLink, handleAddWidgetCommand, handleAddWidgetSignal, handleAggregationSelect, handleColorInput, handleColorSelected, handleCoordinateClick, handleDatapointSelect, handleDisplayTextAsGridClick, handleImageClick, handleInstanceSelect, handleMinMaxValueUpdate, handleNameAndYScaleUpdate, handleOptionDisabled, handleRangeValueUpdate, handleRemoveImageOverlaySignal, handleRemoveRange, handleRemoveStaticTextLink, handleRemoveWidgetSignal, handleSignalSelect, handleStaticTextInput, handleStaticTextLinkInput, handleTagSelect, handleTimeSinceLastUpdatedClick, image, imageCoordinatesMap, imageOverlayRef, isOpen, maintenanceLoading, reminderInstanceOptions, selectedAggregation, selectedInstances, showTimeSinceLastUpdated, tagsLoaded, tagsLoading, tagOptions, timeAggregationOptions, toggleImageOverlayModal, toggleModal, updateState, widgetName, widgetSignals, widgetType, yMax, yMin } = props;
    const hideSignals = (0, _react.useMemo)(()=>new Set([
            (0, _widgetTypes.IMAGE),
            (0, _widgetTypes.LOCATION),
            (0, _widgetTypes.MAP),
            (0, _widgetTypes.TEXT_ENGINE),
            (0, _widgetTypes.TEXT_FUEL)
        ]).has(widgetType?.value), [
        widgetType?.value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        isOpen: isOpen,
        toggle: toggleModal,
        scrollable: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: toggleModal,
                children: "Edit Smart Tile"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "p-3 py-md-2 px-md-4 nine-tenth-text container-fluid d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-239583115 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-239583115 form-group col-12 mt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "widgetName",
                                    className: "jsx-239583115",
                                    children: "Smart Tile Name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    name: "widgetName",
                                    type: "text",
                                    value: widgetName,
                                    onChange: handleNameAndYScaleUpdate,
                                    className: "jsx-239583115 form-control form-control-sm"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-239583115 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-239583115 form-group col-12 mt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-239583115 mb-2",
                                    children: "Smart Tile Type"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-239583115",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-239583115 text-brand-primary",
                                            children: widgetType?.label
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-239583115 text-muted pl-2",
                                            children: widgetType?.helpText
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.ConfigureAxisMaxMin), {
                        handleNameAndYScaleUpdate: handleNameAndYScaleUpdate,
                        widgetType: widgetType?.value,
                        yMax: yMax,
                        yMin: yMin
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.AddDataRow), {
                        handleAddWidgetSignal: handleAddWidgetSignal,
                        selectedType: widgetType,
                        widgetSignals: widgetSignals,
                        widgetType: widgetType?.value
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.BarUtilizationTimeAggregation), {
                        handleAggregationSelect: handleAggregationSelect,
                        isEdit: true,
                        selectedAggregation: selectedAggregation,
                        timeAggregationOptions: timeAggregationOptions,
                        widgetType: widgetType?.value
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.TimeSinceLastUpdatedToggle), {
                        handleTimeSinceLastUpdatedClick: handleTimeSinceLastUpdatedClick,
                        showTimeSinceLastUpdated: showTimeSinceLastUpdated,
                        widgetType: widgetType?.value
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.DisplayTextAsGridToggle), {
                        displayTextAsGrid: displayTextAsGrid,
                        handleDisplayTextAsGridClick: handleDisplayTextAsGridClick,
                        widgetType: widgetType?.value
                    }),
                    widgetType?.value === (0, _widgetTypes.IMAGE) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configureImageWidgetDefault.default), {
                        activeImageCoordinate: activeImageCoordinate,
                        datapointsMap: datapointsMap,
                        gtemplateID: asset?.gtemplateID,
                        handleAddImageOverlaySignal: handleAddImageOverlaySignal,
                        handleCoordinateClick: handleCoordinateClick,
                        handleImageClick: handleImageClick,
                        handleRemoveImageOverlaySignal: handleRemoveImageOverlaySignal,
                        image: image,
                        imageCoordinatesMap: imageCoordinatesMap,
                        imageOverlayRef: imageOverlayRef,
                        isEdit: true,
                        orgID: asset?.orgID,
                        toggleImageOverlayModal: toggleImageOverlayModal,
                        widgetType: widgetType?.value
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-239583115 " + `row position-relative ${widgetType?.value === (0, _widgetTypes.IMAGE) ? "" : "flex-fill"}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-239583115 " + ((hideSignals ? "d-none" : "overflow-auto col-12 h-100 signals-inner-container") || ""),
                            children: widgetType?.value === (0, _widgetTypes.MAINTENANCE) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                components: animatedComponents,
                                isDisabled: maintenanceLoading,
                                isMulti: true,
                                isSearchable: true,
                                onChange: handleInstanceSelect,
                                options: reminderInstanceOptions,
                                placeholder: "Search by Reminder Name",
                                styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                value: selectedInstances
                            }) : widgetSignals.map((s, i)=>{
                                switch(widgetType?.value){
                                    case 0, _widgetTypes.COMMAND:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.CommandsCard), {
                                            asset: asset,
                                            command: s,
                                            handleAddCommand: handleAddWidgetCommand,
                                            handleRemoveCommand: handleRemoveWidgetSignal,
                                            index: i,
                                            selectedCommands: widgetSignals
                                        }, s?.command?.value ?? i);
                                    case 0, _widgetTypes.GAUGE:
                                    case 0, _widgetTypes.GAUGE_RANGE:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configureGaugeWidgetDefault.default), {
                                            datapointsMap: datapointsMap,
                                            gtemplateID: asset?.gtemplateID,
                                            handleAddRange: handleAddRange,
                                            handleColorInput: handleColorInput,
                                            handleColorSelected: handleColorSelected,
                                            handleDatapointSelect: handleDatapointSelect,
                                            handleMinMaxValueUpdate: handleMinMaxValueUpdate,
                                            handleOptionDisabled: handleOptionDisabled,
                                            handleRangeValueUpdate: handleRangeValueUpdate,
                                            handleRemoveRange: handleRemoveRange,
                                            handleRemoveWidgetSignal: handleRemoveWidgetSignal,
                                            handleSignalSelect: handleSignalSelect,
                                            index: i,
                                            orgID: asset?.orgID,
                                            row: s,
                                            updateState: updateState,
                                            widgetType: widgetType?.value
                                        }, i);
                                    case 0, _widgetTypes.TEXT_STATIC:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.TextStaticConfig), {
                                            handleAddStaticTextLink: handleAddStaticTextLink,
                                            handleRemoveStaticTextLink: handleRemoveStaticTextLink,
                                            handleStaticTextInput: handleStaticTextInput,
                                            handleStaticTextLinkInput: handleStaticTextLinkInput,
                                            widgetSignals: widgetSignals
                                        }, i);
                                    case 0, _widgetTypes.TEXT_TAGS:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.TagsCard), {
                                            handleRemoveTag: handleRemoveWidgetSignal,
                                            handleTagSelect: handleTagSelect,
                                            index: i,
                                            row: s,
                                            selectedTags: widgetSignals,
                                            tagOptions: tagOptions,
                                            tagsLoaded: tagsLoaded,
                                            tagsLoading: tagsLoading
                                        }, i);
                                    default:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.SignalsCard), {
                                            datapointsMap: datapointsMap,
                                            gtemplateID: asset?.gtemplateID,
                                            handleDatapointSelect: handleDatapointSelect,
                                            handleOptionDisabled: handleOptionDisabled,
                                            handleRemoveWidgetSignal: handleRemoveWidgetSignal,
                                            handleSignalSelect: handleSignalSelect,
                                            index: i,
                                            orgID: asset?.orgID,
                                            row: s,
                                            updateState: updateState
                                        }, i);
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-239583115 " + ((error ? "row justify-content-end" : "d-none") || ""),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-239583115 col-auto text-danger mb-0",
                            children: error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-239583115 btn btn-outline-secondary py-0 px-3 mr-3",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: editWidget,
                        className: "jsx-239583115 btn modal-button-submit py-0 px-4",
                        children: editRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Save"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "239583115",
                children: ".btn.jsx-239583115{font-size:0.75rem;}.remove-condition.jsx-239583115{color:var(--icon-link-gray) !important;}.remove-condition.jsx-239583115:hover{color:var(--text-light-gray) !important;}@media (min-width:768px){.signals-inner-container.jsx-239583115{position:absolute;}}"
            })
        ]
    });
}
EditWidgetModalDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    activeImageCoordinate: (0, _propTypesDefault.default).object,
    datapointsMap: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    displayTextAsGrid: (0, _propTypesDefault.default).bool,
    editRequestPending: (0, _propTypesDefault.default).bool,
    editWidget: (0, _propTypesDefault.default).func,
    error: (0, _propTypesDefault.default).string,
    handleAddImageOverlaySignal: (0, _propTypesDefault.default).func,
    handleAddRange: (0, _propTypesDefault.default).func,
    handleAddStaticTextLink: (0, _propTypesDefault.default).func,
    handleAddWidgetCommand: (0, _propTypesDefault.default).func,
    handleAddWidgetSignal: (0, _propTypesDefault.default).func,
    handleAggregationSelect: (0, _propTypesDefault.default).func,
    handleColorInput: (0, _propTypesDefault.default).func,
    handleColorSelected: (0, _propTypesDefault.default).func,
    handleCoordinateClick: (0, _propTypesDefault.default).func,
    handleDatapointSelect: (0, _propTypesDefault.default).func,
    handleDisplayTextAsGridClick: (0, _propTypesDefault.default).func,
    handleImageClick: (0, _propTypesDefault.default).func,
    handleInstanceSelect: (0, _propTypesDefault.default).func,
    handleMinMaxValueUpdate: (0, _propTypesDefault.default).func,
    handleNameAndYScaleUpdate: (0, _propTypesDefault.default).func,
    handleOptionDisabled: (0, _propTypesDefault.default).func,
    handleRangeValueUpdate: (0, _propTypesDefault.default).func,
    handleRemoveImageOverlaySignal: (0, _propTypesDefault.default).func,
    handleRemoveRange: (0, _propTypesDefault.default).func,
    handleRemoveStaticTextLink: (0, _propTypesDefault.default).func,
    handleRemoveWidgetSignal: (0, _propTypesDefault.default).func,
    handleSignalSelect: (0, _propTypesDefault.default).func,
    handleStaticTextInput: (0, _propTypesDefault.default).func,
    handleStaticTextLinkInput: (0, _propTypesDefault.default).func,
    handleTagSelect: (0, _propTypesDefault.default).func,
    handleTimeSinceLastUpdatedClick: (0, _propTypesDefault.default).func,
    image: (0, _propTypesDefault.default).string,
    imageCoordinatesMap: (0, _propTypesDefault.default).object,
    imageOverlayRef: (0, _propTypesDefault.default).object,
    isOpen: (0, _propTypesDefault.default).bool,
    maintenanceLoading: (0, _propTypesDefault.default).bool,
    maxValue: (0, _propTypesDefault.default).number,
    reminderInstanceOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    selectedAggregation: (0, _propTypesDefault.default).string,
    selectedInstances: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    showTimeSinceLastUpdated: (0, _propTypesDefault.default).bool,
    tagOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    tagsLoaded: (0, _propTypesDefault.default).bool,
    tagsLoading: (0, _propTypesDefault.default).bool,
    timeAggregationOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    toggleImageOverlayModal: (0, _propTypesDefault.default).func,
    toggleModal: (0, _propTypesDefault.default).func,
    updateState: (0, _propTypesDefault.default).func,
    widgetName: (0, _propTypesDefault.default).string,
    widgetSignals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    widgetType: (0, _propTypesDefault.default).object,
    yMax: (0, _propTypesDefault.default).number,
    yMin: (0, _propTypesDefault.default).number
};
EditWidgetModalDisplay.defaultProps = {
    widgetSignals: []
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-select":"j36cq","react-select/animated":"jbxWd","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/WidgetTypes":"frQz2","../ModalLayout":"2RoDj","./WidgetModalDisplayComponents":"2mwfq","./ConfigureGaugeWidget":"bp5hi","./ConfigureImageWidget":"5Fa08","../../Styles/SelectStyles":"1LnYJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jbxWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>Input);
parcelHelpers.export(exports, "MultiValue", ()=>MultiValue);
parcelHelpers.export(exports, "Placeholder", ()=>Placeholder);
parcelHelpers.export(exports, "SingleValue", ()=>SingleValue);
parcelHelpers.export(exports, "ValueContainer", ()=>ValueContainer);
parcelHelpers.export(exports, "default", ()=>index);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _indexA301F526EsmJs = require("../../dist/index-a301f526.esm.js");
var _react = require("react");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _reactTransitionGroup = require("react-transition-group");
var _react1 = require("@emotion/react");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _excluded$4 = [
    "in",
    "onExited",
    "appear",
    "enter",
    "exit"
];
// strip transition props off before spreading onto select component
var AnimatedInput = function AnimatedInput(WrappedComponent) {
    return function(_ref) {
        _ref.in;
        _ref.onExited;
        _ref.appear;
        _ref.enter;
        _ref.exit;
        var props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$4);
        return /*#__PURE__*/ _react.createElement(WrappedComponent, props);
    };
};
var AnimatedInput$1 = AnimatedInput;
var _excluded$3 = [
    "component",
    "duration",
    "in",
    "onExited"
];
var Fade = function Fade(_ref) {
    var Tag = _ref.component, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 1 : _ref$duration, inProp = _ref.in;
    _ref.onExited;
    var props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$3);
    var nodeRef = (0, _react.useRef)(null);
    var transition = {
        entering: {
            opacity: 0
        },
        entered: {
            opacity: 1,
            transition: "opacity ".concat(duration, "ms")
        },
        exiting: {
            opacity: 0
        },
        exited: {
            opacity: 0
        }
    };
    return /*#__PURE__*/ _react.createElement((0, _reactTransitionGroup.Transition), {
        mountOnEnter: true,
        unmountOnExit: true,
        in: inProp,
        timeout: duration,
        nodeRef: nodeRef
    }, function(state) {
        var innerProps = {
            style: (0, _objectSpread2Default.default)({}, transition[state]),
            ref: nodeRef
        };
        return /*#__PURE__*/ _react.createElement(Tag, (0, _extendsDefault.default)({
            innerProps: innerProps
        }, props));
    });
};
// ==============================
// Collapse Transition
// ==============================
var collapseDuration = 260;
// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = function Collapse(_ref2) {
    var children = _ref2.children, _in = _ref2.in, _onExited = _ref2.onExited;
    var ref = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)("auto"), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    (0, _react.useEffect)(function() {
        var el = ref.current;
        if (!el) return;
        /*
      Here we're invoking requestAnimationFrame with a callback invoking our
      call to getBoundingClientRect and setState in order to resolve an edge case
      around portalling. Certain portalling solutions briefly remove children from the DOM
      before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
      while the Select component is in this state.
    */ // cannot use `offsetWidth` because it is rounded
        var rafId = window.requestAnimationFrame(function() {
            return setWidth(el.getBoundingClientRect().width);
        });
        return function() {
            return window.cancelAnimationFrame(rafId);
        };
    }, []);
    var getStyleFromStatus = function getStyleFromStatus(status) {
        switch(status){
            default:
                return {
                    width: width
                };
            case "exiting":
                return {
                    width: 0,
                    transition: "width ".concat(collapseDuration, "ms ease-out")
                };
            case "exited":
                return {
                    width: 0
                };
        }
    };
    return /*#__PURE__*/ _react.createElement((0, _reactTransitionGroup.Transition), {
        enter: false,
        mountOnEnter: true,
        unmountOnExit: true,
        in: _in,
        onExited: function onExited() {
            var el = ref.current;
            if (!el) return;
            _onExited === null || _onExited === void 0 || _onExited(el);
        },
        timeout: collapseDuration,
        nodeRef: ref
    }, function(status) {
        return /*#__PURE__*/ _react.createElement("div", {
            ref: ref,
            style: (0, _objectSpread2Default.default)({
                overflow: "hidden",
                whiteSpace: "nowrap"
            }, getStyleFromStatus(status))
        }, children);
    });
};
var _excluded$2 = [
    "in",
    "onExited"
];
// strip transition props off before spreading onto actual component
var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
    return function(_ref) {
        var inProp = _ref.in, onExited = _ref.onExited, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$2);
        return /*#__PURE__*/ _react.createElement(Collapse, {
            in: inProp,
            onExited: onExited
        }, /*#__PURE__*/ _react.createElement(WrappedComponent, (0, _extendsDefault.default)({
            cropWithEllipsis: inProp
        }, props)));
    };
};
var AnimatedMultiValue$1 = AnimatedMultiValue;
// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ _react.createElement(Fade, (0, _extendsDefault.default)({
            component: WrappedComponent,
            duration: props.isMulti ? collapseDuration : 1
        }, props));
    };
};
var AnimatedPlaceholder$1 = AnimatedPlaceholder;
// instant fade; all transition-group children must be transitions
var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ _react.createElement(Fade, (0, _extendsDefault.default)({
            component: WrappedComponent
        }, props));
    };
};
var AnimatedSingleValue$1 = AnimatedSingleValue;
var _excluded$1 = [
    "component"
], _excluded2 = [
    "children"
];
// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
    return function(props) {
        return props.isMulti ? /*#__PURE__*/ _react.createElement(IsMultiValueContainer, (0, _extendsDefault.default)({
            component: WrappedComponent
        }, props)) : /*#__PURE__*/ _react.createElement((0, _reactTransitionGroup.TransitionGroup), (0, _extendsDefault.default)({
            component: WrappedComponent
        }, props));
    };
};
var IsMultiValueContainer = function IsMultiValueContainer(_ref) {
    var component = _ref.component, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$1);
    var multiProps = useIsMultiValueContainer(restProps);
    return /*#__PURE__*/ _react.createElement((0, _reactTransitionGroup.TransitionGroup), (0, _extendsDefault.default)({
        component: component
    }, multiProps));
};
var useIsMultiValueContainer = function useIsMultiValueContainer(_ref2) {
    var children = _ref2.children, props = (0, _objectWithoutPropertiesDefault.default)(_ref2, _excluded2);
    var isMulti = props.isMulti, hasValue = props.hasValue, innerProps = props.innerProps, _props$selectProps = props.selectProps, components = _props$selectProps.components, controlShouldRenderValue = _props$selectProps.controlShouldRenderValue;
    var _useState = (0, _react.useState)(isMulti && controlShouldRenderValue && hasValue), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), cssDisplayFlex = _useState2[0], setCssDisplayFlex = _useState2[1];
    var _useState3 = (0, _react.useState)(false), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), removingValue = _useState4[0], setRemovingValue = _useState4[1];
    (0, _react.useEffect)(function() {
        if (hasValue && !cssDisplayFlex) setCssDisplayFlex(true);
    }, [
        hasValue,
        cssDisplayFlex
    ]);
    (0, _react.useEffect)(function() {
        if (removingValue && !hasValue && cssDisplayFlex) setCssDisplayFlex(false);
        setRemovingValue(false);
    }, [
        removingValue,
        hasValue,
        cssDisplayFlex
    ]);
    var onExited = function onExited() {
        return setRemovingValue(true);
    };
    var childMapper = function childMapper(child) {
        if (isMulti && /*#__PURE__*/ _react.isValidElement(child)) {
            // Add onExited callback to MultiValues
            if (child.type === components.MultiValue) return /*#__PURE__*/ _react.cloneElement(child, {
                onExited: onExited
            });
            // While container flexed, Input cursor is shown after Placeholder text,
            // so remove Placeholder until display is set back to grid
            if (child.type === components.Placeholder && cssDisplayFlex) return null;
        }
        return child;
    };
    var newInnerProps = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, innerProps), {}, {
        style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, innerProps === null || innerProps === void 0 ? void 0 : innerProps.style), {}, {
            display: isMulti && hasValue || cssDisplayFlex ? "flex" : "grid"
        })
    });
    var newProps = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
        innerProps: newInnerProps,
        children: _react.Children.toArray(children).map(childMapper)
    });
    return newProps;
};
var AnimatedValueContainer$1 = AnimatedValueContainer;
var _excluded = [
    "Input",
    "MultiValue",
    "Placeholder",
    "SingleValue",
    "ValueContainer"
];
var makeAnimated = function makeAnimated() {
    var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var components = (0, _indexA301F526EsmJs.F)({
        components: externalComponents
    });
    var Input = components.Input, MultiValue = components.MultiValue, Placeholder = components.Placeholder, SingleValue = components.SingleValue, ValueContainer = components.ValueContainer, rest = (0, _objectWithoutPropertiesDefault.default)(components, _excluded);
    return (0, _objectSpread2Default.default)({
        Input: AnimatedInput$1(Input),
        MultiValue: AnimatedMultiValue$1(MultiValue),
        Placeholder: AnimatedPlaceholder$1(Placeholder),
        SingleValue: AnimatedSingleValue$1(SingleValue),
        ValueContainer: AnimatedValueContainer$1(ValueContainer)
    }, rest);
};
var AnimatedComponents = makeAnimated();
var Input = AnimatedComponents.Input;
var MultiValue = AnimatedComponents.MultiValue;
var Placeholder = AnimatedComponents.Placeholder;
var SingleValue = AnimatedComponents.SingleValue;
var ValueContainer = AnimatedComponents.ValueContainer;
var index = (0, _memoizeOneDefault.default)(makeAnimated);

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","memoize-one":"jucOx","../../dist/index-a301f526.esm.js":"gYAEP","react":"9njXz","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/slicedToArray":"idCNq","react-transition-group":"hnCQJ","@emotion/react":"2WHWE","@babel/runtime/helpers/typeof":"979to","@babel/runtime/helpers/taggedTemplateLiteral":"cpSDa","@babel/runtime/helpers/defineProperty":"hjdoh","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnCQJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"iyv3L","./ReplaceTransition":"1v1ld","./SwitchTransition":"iEWMb","./TransitionGroup":"4WN9V","./Transition":"6LVcl","./config":"7vGu2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyv3L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ""
};
CSSTransition.propTypes = (0, _extendsDefault.default)({}, (0, _transitionDefault.default).propTypes, {
    /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */ classNames: (0, _propTypes1.classNamesShape),
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEnter: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntered: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExit: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExiting: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExited: (0, _propTypesDefault.default).func
});
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","dom-helpers/addClass":"16v5y","dom-helpers/removeClass":"cUvLe","react":"9njXz","./Transition":"6LVcl","./utils/PropTypes":"8gMVu","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16v5y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

},{"./hasClass":"3I5QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I5QN":[function(require,module,exports) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUvLe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LVcl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, _propTypesDefault.default).shape({
        current: typeof Element === "undefined" ? (0, _propTypesDefault.default).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, _propTypesDefault.default).instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func.isRequired,
        (0, _propTypesDefault.default).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, _propTypesDefault.default).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, _propTypesDefault.default).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, _propTypesDefault.default).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, _propTypesDefault.default).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, _propTypesDefault.default).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, _propTypesDefault.default).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, _propTypes1.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, _propTypesDefault.default).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, _propTypesDefault.default).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, _propTypesDefault.default).func
}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./config":"7vGu2","./utils/PropTypes":"8gMVu","./TransitionGroupContext":"162y0","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vGu2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gMVu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).shape({
        enter: (0, _propTypesDefault.default).number,
        exit: (0, _propTypesDefault.default).number,
        appear: (0, _propTypesDefault.default).number
    }).isRequired
]);
var classNamesShape = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        enter: (0, _propTypesDefault.default).string,
        exit: (0, _propTypesDefault.default).string,
        active: (0, _propTypesDefault.default).string
    }),
    (0, _propTypesDefault.default).shape({
        enter: (0, _propTypesDefault.default).string,
        enterDone: (0, _propTypesDefault.default).string,
        enterActive: (0, _propTypesDefault.default).string,
        exit: (0, _propTypesDefault.default).string,
        exitDone: (0, _propTypesDefault.default).string,
        exitActive: (0, _propTypesDefault.default).string
    })
]);

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"162y0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V7Al":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1v1ld":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = (0, _reactDefault.default).Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) {
            var maybeNode = child.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this);
            this.props[handler](maybeNode);
        }
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = (0, _reactDefault.default).Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupDefault.default), props, inProp ? (0, _reactDefault.default).cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : (0, _reactDefault.default).cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}((0, _reactDefault.default).Component);
ReplaceTransition.propTypes = {
    in: (0, _propTypesDefault.default).bool.isRequired,
    children: function children(props, propName) {
        if ((0, _reactDefault.default).Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');
        return null;
    }
};
exports.default = ReplaceTransition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./TransitionGroup":"4WN9V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4WN9V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, _propTypesDefault.default).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, _propTypesDefault.default).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, _propTypesDefault.default).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, _propTypesDefault.default).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, _propTypesDefault.default).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, _propTypesDefault.default).func
};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","./TransitionGroupContext":"162y0","./utils/ChildMapping":"kq3eN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kq3eN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, "appear", props),
            enter: getProp(child, "enter", props),
            exit: getProp(child, "exit", props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
    });
    return children;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iEWMb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modes", ()=>modes);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _transition = require("./Transition");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
    if (oldChildren === newChildren) return false;
    if ((0, _reactDefault.default).isValidElement(oldChildren) && (0, _reactDefault.default).isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) return false;
    return true;
}
var modes = {
    out: "out-in",
    in: "in-out"
};
var callHook = function callHook(element, name, cb) {
    return function() {
        var _element$props;
        element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
        cb();
    };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function(_ref) {
    var current = _ref.current, changeState = _ref.changeState;
    return (0, _reactDefault.default).cloneElement(current, {
        in: false,
        onExited: callHook(current, "onExited", function() {
            changeState((0, _transition.ENTERING), null);
        })
    });
}, _leaveRenders[modes.in] = function(_ref2) {
    var current = _ref2.current, changeState = _ref2.changeState, children = _ref2.children;
    return [
        current,
        (0, _reactDefault.default).cloneElement(children, {
            in: true,
            onEntered: callHook(children, "onEntered", function() {
                changeState((0, _transition.ENTERING));
            })
        })
    ];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function(_ref3) {
    var children = _ref3.children, changeState = _ref3.changeState;
    return (0, _reactDefault.default).cloneElement(children, {
        in: true,
        onEntered: callHook(children, "onEntered", function() {
            changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                in: true
            }));
        })
    });
}, _enterRenders[modes.in] = function(_ref4) {
    var current = _ref4.current, children = _ref4.children, changeState = _ref4.changeState;
    return [
        (0, _reactDefault.default).cloneElement(current, {
            in: false,
            onExited: callHook(current, "onExited", function() {
                changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                    in: true
                }));
            })
        }),
        (0, _reactDefault.default).cloneElement(children, {
            in: true
        })
    ];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */ var SwitchTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(SwitchTransition, _React$Component);
    function SwitchTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            status: (0, _transition.ENTERED),
            current: null
        };
        _this.appeared = false;
        _this.changeState = function(status, current) {
            if (current === void 0) current = _this.state.current;
            _this.setState({
                status: status,
                current: current
            });
        };
        return _this;
    }
    var _proto = SwitchTransition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
    };
    SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.children == null) return {
            current: null
        };
        if (state.status === (0, _transition.ENTERING) && props.mode === modes.in) return {
            status: (0, _transition.ENTERING)
        };
        if (state.current && areChildrenDifferent(state.current, props.children)) return {
            status: (0, _transition.EXITING)
        };
        return {
            current: (0, _reactDefault.default).cloneElement(props.children, {
                in: true
            })
        };
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, mode = _this$props.mode, _this$state = this.state, status = _this$state.status, current = _this$state.current;
        var data = {
            children: children,
            current: current,
            changeState: this.changeState,
            status: status
        };
        var component;
        switch(status){
            case 0, _transition.ENTERING:
                component = enterRenders[mode](data);
                break;
            case 0, _transition.EXITING:
                component = leaveRenders[mode](data);
                break;
            case 0, _transition.ENTERED:
                component = current;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: {
                isMounting: !this.appeared
            }
        }, component);
    };
    return SwitchTransition;
}((0, _reactDefault.default).Component);
SwitchTransition.propTypes = {
    /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */ mode: (0, _propTypesDefault.default).oneOf([
        modes.in,
        modes.out
    ]),
    /**
   * Any `Transition` or `CSSTransition` component.
   */ children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).element.isRequired
    ])
};
SwitchTransition.defaultProps = {
    mode: modes.out
};
exports.default = SwitchTransition;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","./Transition":"6LVcl","./TransitionGroupContext":"162y0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2mwfq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CommandsCard", ()=>CommandsCard);
parcelHelpers.export(exports, "ConfigureAxisMaxMin", ()=>ConfigureAxisMaxMin);
parcelHelpers.export(exports, "AddDataRow", ()=>AddDataRow);
parcelHelpers.export(exports, "BarUtilizationTimeAggregation", ()=>BarUtilizationTimeAggregation);
parcelHelpers.export(exports, "SignalsCard", ()=>SignalsCard);
parcelHelpers.export(exports, "TagsCard", ()=>TagsCard);
parcelHelpers.export(exports, "TextStaticConfig", ()=>TextStaticConfig);
parcelHelpers.export(exports, "TimeSinceLastUpdatedToggle", ()=>TimeSinceLastUpdatedToggle);
parcelHelpers.export(exports, "DisplayTextAsGridToggle", ()=>DisplayTextAsGridToggle);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _debouncePromise = require("debounce-promise");
var _debouncePromiseDefault = parcelHelpers.interopDefault(_debouncePromise);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
const CommandsCard = /*#__PURE__*/ (0, _react.memo)(function CommandsCard({ asset, command, handleAddCommand, handleRemoveCommand, index, selectedCommands }) {
    const commandOptions = ()=>{
        if (!asset?.gtemplate?.commands?.length) return [];
        return asset.gtemplate.commands.filter((c)=>!selectedCommands.some((x)=>x?.command?.value === c._id)).map((c)=>({
                label: c.name,
                value: c._id
            }));
    };
    const handleColorSelect = (color)=>{
        const update = {
            ...command,
            color
        };
        handleAddCommand(update, index);
    };
    const handleCommandSelect = (selected)=>{
        const update = {
            ...command,
            command: selected
        };
        handleAddCommand(update, index);
    };
    const handleFriendlyNameUpdate = ({ target: { name, value } })=>{
        const update = {
            ...command,
            [name]: value
        };
        handleAddCommand(update, index);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            minHeight: "5rem"
        },
        className: "jsx-907359250 row no-gutters align-items-center bg-background-gray rounded my-3 py-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-907359250 col-1 pl-1 px-md-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "jsx-907359250 fa-layers fa-fw",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircle),
                            color: "white",
                            size: "lg"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "jsx-907359250 fa-layers-text signal-number-text font-weight-bold text-muted",
                            children: index + 1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-907359250 px-md-0 col-10 d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-907359250 form-group row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "command",
                                className: "jsx-907359250 col-sm-3 col-form-label",
                                children: "Command Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-907359250 col-sm-8",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                    onChange: handleCommandSelect,
                                    options: commandOptions(),
                                    value: command?.command
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-907359250 form-group row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "friendlyName",
                                className: "jsx-907359250 col-sm-3 col-form-label",
                                children: "Friendly Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-907359250 col-sm-8",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    name: "friendlyName",
                                    onChange: handleFriendlyNameUpdate,
                                    type: "text",
                                    value: command?.friendlyName,
                                    className: "jsx-907359250 form-control"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-907359250 form-group row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "color",
                                className: "jsx-907359250 col-sm-3 col-form-label",
                                children: "Color"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-907359250 col-sm-8 container-fluid mx-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-907359250 row no-gutters align-items-stretch h-100",
                                    children: [
                                        "cyan-blue",
                                        "danger",
                                        "warning-yellow",
                                        "alert-confirmation"
                                    ].map((color)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-907359250 " + `col-1 mr-2 d-flex align-items-center justify-content-center ${command?.color === color ? "border border-dark" : ""}`,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>handleColorSelect(color),
                                                className: "jsx-907359250 " + `btn h-75 w-75 btn-${color} shadow-none rounded-0`
                                            })
                                        }, color))
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-907359250 col-1 pl-1 pl-md-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: ()=>handleRemoveCommand(index),
                    className: "jsx-907359250 btn btn-link p-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTrashAlt),
                        className: "text-text-dark"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "907359250",
                children: ".btn.jsx-907359250:focus{outline:none;}"
            })
        ]
    });
});
CommandsCard.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        gtemplate: (0, _propTypesDefault.default).shape({
            commands: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        })
    }),
    command: (0, _propTypesDefault.default).shape({
        color: (0, _propTypesDefault.default).string,
        command: (0, _propTypesDefault.default).object,
        friendlyName: (0, _propTypesDefault.default).string
    }),
    index: (0, _propTypesDefault.default).number,
    handleAddCommand: (0, _propTypesDefault.default).func,
    handleRemoveCommand: (0, _propTypesDefault.default).func,
    selectedCommands: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
};
const ConfigureAxisMaxMin = /*#__PURE__*/ (0, _react.memo)(function ConfigureAxisMaxMin({ handleNameAndYScaleUpdate, widgetType, yMax, yMin }) {
    return (0, _widgetTypes.MIN_MAX_TYPE_SET).has(widgetType) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "row justify-content-between",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group col-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "yMin",
                        children: "Y Axis Minimum"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        name: "yMin",
                        type: "text",
                        className: "form-control",
                        value: yMin,
                        onChange: handleNameAndYScaleUpdate
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group col-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "yMax",
                        children: "Y Axis Maximum"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        name: "yMax",
                        type: "text",
                        className: "form-control",
                        value: yMax,
                        onChange: handleNameAndYScaleUpdate
                    })
                ]
            })
        ]
    }) : null;
});
ConfigureAxisMaxMin.propTypes = {
    handleNameAndYScaleUpdate: (0, _propTypesDefault.default).func,
    widgetType: (0, _propTypesDefault.default).string,
    yMax: (0, _propTypesDefault.default).string,
    yMin: (0, _propTypesDefault.default).string
};
const noAddButtonTypeSet = new Set([
    (0, _widgetTypes.BAR_ENGINE_UTILIZATION),
    (0, _widgetTypes.BAR_FUEL_UTILIZATION),
    (0, _widgetTypes.IMAGE),
    (0, _widgetTypes.LOCATION),
    (0, _widgetTypes.MAINTENANCE),
    (0, _widgetTypes.MAP),
    (0, _widgetTypes.TEXT_ENGINE),
    (0, _widgetTypes.TEXT_FUEL),
    (0, _widgetTypes.TEXT_STATIC)
]);
const AddDataRow = /*#__PURE__*/ (0, _react.memo)(function AddDataRow({ handleAddWidgetSignal, selectedType, widgetSignals, widgetType }) {
    const addButtonDisplayText = (0, _react.useMemo)(()=>{
        switch(widgetType){
            case 0, _widgetTypes.TEXT_TAGS:
                return "Tag";
            case 0, _widgetTypes.COMMAND:
                return "Command";
            case 0, _widgetTypes.GAUGE:
                return "Gauge";
            default:
                return "Signal";
        }
    }, [
        widgetType
    ]), containerClassName = (0, _react.useMemo)(()=>{
        if (!widgetType) return "d-none";
        return noAddButtonTypeSet.has(widgetType) ? "d-none" : "row mb-2";
    }, [
        widgetType
    ]), dataTypeDisplayText = (0, _react.useMemo)(()=>{
        switch(widgetType){
            case 0, _widgetTypes.GAUGE:
                return "Gauges";
            case 0, _widgetTypes.TEXT_TAGS:
                return "Tags";
            case 0, _widgetTypes.COMMAND:
                return "Commands";
            default:
                return "Signals";
        }
    }, [
        widgetType
    ]), displayAddButton = (0, _react.useMemo)(()=>{
        if (!selectedType?.maxSignals) return true;
        return widgetSignals?.length < selectedType?.maxSignals;
    }, [
        selectedType,
        widgetSignals?.length
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "col-12",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "font-weight-bold",
                    children: dataTypeDisplayText
                }),
                displayAddButton ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    className: "btn modal-button-secondary py-0 ml-3 three-quarter-text",
                    onClick: handleAddWidgetSignal,
                    children: [
                        "Add",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-reset ml-1",
                            children: addButtonDisplayText
                        })
                    ]
                }) : null
            ]
        })
    });
});
AddDataRow.propTypes = {
    handleAddWidgetSignal: (0, _propTypesDefault.default).func,
    selectedType: (0, _propTypesDefault.default).shape({
        maxSignals: (0, _propTypesDefault.default).number
    }),
    widgetSignals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    widgetType: (0, _propTypesDefault.default).string
};
AddDataRow.defaultProps = {
    selectedType: {},
    widgetSignals: []
};
const barUtilizationTypeSet = new Set([
    (0, _widgetTypes.BAR_ENGINE_UTILIZATION),
    (0, _widgetTypes.BAR_FUEL_UTILIZATION)
]);
const BarUtilizationTimeAggregation = /*#__PURE__*/ (0, _react.memo)(function BarUtilizationTimeAggregation(props) {
    const wrapperClassName = (0, _react.useMemo)(()=>barUtilizationTypeSet.has(props.widgetType) ? "row" : "d-none", [
        props.widgetType
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: wrapperClassName,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "form-group col-12 col-md-5",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: "selectedAggregation",
                    children: "Time Aggregation"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                    classNamePrefix: "select",
                    isClearable: false,
                    isSearchable: false,
                    name: "selectedAggregation",
                    options: props.timeAggregationOptions,
                    onChange: props.handleAggregationSelect,
                    value: props.timeAggregationOptions.find(({ value })=>value === props.selectedAggregation)
                })
            ]
        })
    });
});
BarUtilizationTimeAggregation.propTypes = {
    handleAggregationSelect: (0, _propTypesDefault.default).func,
    selectedAggregation: (0, _propTypesDefault.default).string,
    timeAggregationOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    widgetType: (0, _propTypesDefault.default).string
};
const SignalsCard = /*#__PURE__*/ (0, _react.memo)(function SignalsCard({ datapointsMap, gtemplateID, handleDatapointSelect, handleOptionDisabled, handleRemoveWidgetSignal, handleSignalSelect, index, orgID, row, updateState }) {
    const [requestPending, setRequestPending] = (0, _react.useState)(false);
    const service = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    let source = (0, _axios.CancelToken).source();
    const fetchOutputSignals = async (searchTerm)=>{
        try {
            setRequestPending(true);
            const params = {
                limit: 100,
                orgID,
                search: "name",
                searchTerm
            };
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const { data } = await service.searchOutputSignals(gtemplateID, params, source.token);
            setRequestPending(false);
            return data.map((os)=>({
                    label: os.name,
                    value: os
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
            setRequestPending(false);
            return [];
        }
    };
    (0, _react.useEffect)(()=>source?.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "row no-gutters align-items-center bg-background-gray rounded my-3 py-2 py-md-0",
        style: {
            minHeight: "5rem"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-1 pl-1 px-md-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "fa-layers fa-fw",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircle),
                            color: "white",
                            size: "lg"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "fa-layers-text signal-number-text font-weight-bold text-muted",
                            children: index + 1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "px-md-0 col-10 d-flex flex-column flex-md-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-fill pr-md-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: `signalCollection-${index}`,
                                children: "Signal Collection"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                captureMenuScroll: false,
                                isSearchable: true,
                                maxMenuHeight: 200,
                                menuPortalTarget: document.body,
                                name: `signalCollection-${index}`,
                                options: datapointsMap,
                                onChange: (e)=>handleDatapointSelect(e, index),
                                styles: {
                                    menuPortal: (base)=>({
                                            ...base,
                                            zIndex: 9999
                                        })
                                },
                                value: row?.datapoint
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-fill pl-md-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: `signal-${index}`,
                                children: "Signal to track"
                            }),
                            row?.datapoint?.value === "outputSignal" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                                cacheOptions: true,
                                captureMenuScroll: false,
                                defaultOptions: true,
                                isLoading: requestPending,
                                loadOptions: (0, _debouncePromiseDefault.default)(fetchOutputSignals, 1000),
                                maxMenuHeight: 200,
                                menuPortalTarget: document.body,
                                name: `signal-${index}`,
                                onChange: (e)=>handleSignalSelect(e, index),
                                styles: {
                                    menuPortal: (base)=>({
                                            ...base,
                                            zIndex: 9999
                                        })
                                },
                                value: row?.signal
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                captureMenuScroll: false,
                                isOptionDisabled: handleOptionDisabled,
                                isSearchable: true,
                                maxMenuHeight: 200,
                                menuPortalTarget: document.body,
                                name: `signal-${index}`,
                                options: row?.datapoint?.values || [],
                                onChange: (e)=>handleSignalSelect(e, index),
                                styles: {
                                    menuPortal: (base)=>({
                                            ...base,
                                            zIndex: 9999
                                        })
                                },
                                value: row?.signal
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-1 pl-1 pl-md-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-link p-0",
                    onClick: ()=>handleRemoveWidgetSignal(index),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTimes),
                        className: "text-text-dark"
                    })
                })
            })
        ]
    });
});
SignalsCard.propTypes = {
    datapointsMap: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    gtemplateID: (0, _propTypesDefault.default).string,
    handleDatapointSelect: (0, _propTypesDefault.default).func,
    handleOptionDisabled: (0, _propTypesDefault.default).func,
    handleRemoveWidgetSignal: (0, _propTypesDefault.default).func,
    handleSignalSelect: (0, _propTypesDefault.default).func,
    index: (0, _propTypesDefault.default).number,
    orgID: (0, _propTypesDefault.default).string,
    row: (0, _propTypesDefault.default).shape({
        datapoint: (0, _propTypesDefault.default).shape({
            value: (0, _propTypesDefault.default).string,
            values: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        }),
        signal: (0, _propTypesDefault.default).object
    }),
    updateState: (0, _propTypesDefault.default).func
};
SignalsCard.defaultProps = {
    row: {
        datapoint: {},
        signal: {}
    }
};
const TagsCard = /*#__PURE__*/ (0, _react.memo)(function TagsCard({ handleRemoveTag, handleTagSelect, index, row, selectedTags, tagOptions, tagsLoaded, tagsLoading }) {
    const selectedTagsSet = new Set(selectedTags.map(({ value } = {})=>value));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "row no-gutters align-items-center bg-background-gray rounded my-3 py-2 py-md-0",
        style: {
            minHeight: "5rem"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-1 pl-1 px-md-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "fa-layers fa-fw",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircle),
                            className: "text-white",
                            size: "lg"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "fa-layers-text signal-number-text font-weight-bold text-muted",
                            children: index + 1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "px-md-0 col-10 col-md-6 form-group mb-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: `tag-${index}`,
                        children: "TagName"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        captureMenuScroll: false,
                        isDisabled: !tagsLoaded,
                        isLoading: tagsLoading,
                        isOptionDisabled: ({ value })=>selectedTagsSet.has(value),
                        isSearchable: true,
                        maxMenuHeight: 200,
                        menuPortalTarget: document.body,
                        name: `tag-${index}`,
                        options: tagOptions,
                        onChange: (e)=>handleTagSelect(e, index),
                        styles: {
                            menuPortal: (base)=>({
                                    ...base,
                                    zIndex: 9999
                                })
                        },
                        value: row
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-1 pl-1 pl-md-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-link p-0",
                    onClick: ()=>handleRemoveTag(index),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTimes),
                        className: "text-text-dark"
                    })
                })
            })
        ]
    });
});
TagsCard.propTypes = {
    handleRemoveTag: (0, _propTypesDefault.default).func,
    handleTagSelect: (0, _propTypesDefault.default).func,
    index: (0, _propTypesDefault.default).number,
    row: (0, _propTypesDefault.default).object,
    selectedTags: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string,
        value: (0, _propTypesDefault.default).string
    })),
    tagOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string,
        value: (0, _propTypesDefault.default).string
    })),
    tagsLoaded: (0, _propTypesDefault.default).bool,
    tagsLoading: (0, _propTypesDefault.default).bool
};
TagsCard.defaultProps = {
    row: {},
    selectedTags: [],
    tagOptions: []
};
const TextStaticConfig = /*#__PURE__*/ (0, _react.memo)(function TextStaticConfig({ handleAddStaticTextLink, handleRemoveStaticTextLink, handleStaticTextInput, handleStaticTextLinkInput, widgetSignals: [{ links, value }] }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "row no-gutters align-items-center my-3 rounded",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                    autoComplete: "off",
                    autoCorrect: "off",
                    className: "form-control nine-tenth-text",
                    cols: 50,
                    minLength: 1,
                    maxLength: 512,
                    onChange: handleStaticTextInput,
                    placeholder: "Enter text here...",
                    rows: 10,
                    spellCheck: "false",
                    value: value
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "col-12 d-flex justify-content-end my-2",
                children: [
                    links?.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mr-auto mb-0 nine-tenth-text text-dark",
                        children: "Links"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "btn btn-sm modal-button-primary py-0 three-quarter-text",
                        onClick: handleAddStaticTextLink,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                className: "mr-2",
                                icon: (0, _freeSolidSvgIcons.faPlus)
                            }),
                            "Link"
                        ]
                    })
                ]
            }),
            links?.map?.(({ display, url }, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "col-12 d-flex mb-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "form-control form-control-sm flex-fill mr-1",
                            name: "url",
                            onChange: (e)=>handleStaticTextLinkInput(e, i),
                            placeholder: "URL",
                            type: "text",
                            value: url
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "form-control form-control-sm flex-fill ml-1",
                            name: "display",
                            onChange: (e)=>handleStaticTextLinkInput(e, i),
                            placeholder: "Display Text",
                            type: "text",
                            value: display
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "flex-auto btn btn-link text-danger py-0 d-flex align-items-center justify-content-center",
                            onClick: ()=>handleRemoveStaticTextLink(i),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faTrashAlt)
                            })
                        })
                    ]
                }, i))
        ]
    });
});
TextStaticConfig.propTypes = {
    handleAddStaticTextLink: (0, _propTypesDefault.default).func,
    handleRemoveStaticTextLink: (0, _propTypesDefault.default).func,
    handleStaticTextInput: (0, _propTypesDefault.default).func,
    handleStaticTextLinkInput: (0, _propTypesDefault.default).func,
    widgetSignals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        value: (0, _propTypesDefault.default).string
    }))
};
TextStaticConfig.defaultProps = [
    {
        value: ""
    }
];
const TimeSinceLastUpdatedToggle = /*#__PURE__*/ (0, _react.memo)(function TimeSinceLastUpdatedToggle(props) {
    return props.widgetType === (0, _widgetTypes.TEXT) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "form-check form-check-inline",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                checked: props.showTimeSinceLastUpdated,
                className: "form-check-input",
                id: "lastUpdatedTime",
                onChange: props.handleTimeSinceLastUpdatedClick,
                type: "checkbox"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "form-check-label",
                htmlFor: "lastUpdatedTime",
                children: "Calculate Time Since Last Updated for Timestamp Column"
            })
        ]
    }) : null;
});
TimeSinceLastUpdatedToggle.propTypes = {
    handleTimeSinceLastUpdatedClick: (0, _propTypesDefault.default).func,
    showTimeSinceLastUpdated: (0, _propTypesDefault.default).bool,
    widgetType: (0, _propTypesDefault.default).string
};
const DisplayTextAsGridToggle = /*#__PURE__*/ (0, _react.memo)(function DisplayTextAsGridToggle(props) {
    return props.widgetType === (0, _widgetTypes.TEXT) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "form-check form-check-inline",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                checked: props.displayTextAsGrid,
                className: "form-check-input",
                id: "displayTextAsGrid",
                onChange: props.handleDisplayTextAsGridClick,
                type: "checkbox"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "form-check-label",
                htmlFor: "displayTextAsGrid",
                children: "Display Selected Signal Values on Tile in Large Grid Format"
            })
        ]
    }) : null;
});
DisplayTextAsGridToggle.propTypes = {
    displayTextAsGrid: (0, _propTypesDefault.default).bool,
    handleDisplayTextAsGridClick: (0, _propTypesDefault.default).func,
    widgetType: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","react-select":"j36cq","react-select/async":"iHFh7","debounce-promise":"fqOKC","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/WidgetTypes":"frQz2","../../Services/TemplateService":"hGdvK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bp5hi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _debouncePromise = require("debounce-promise");
var _debouncePromiseDefault = parcelHelpers.interopDefault(_debouncePromise);
var _reactColor = require("react-color");
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _colorPaletteOptions = require("../../Constants/ColorPaletteOptions");
exports.default = /*#__PURE__*/ (0, _react.memo)(ConfigureGaugeWidget);
function ConfigureGaugeWidget({ datapointsMap, gtemplateID, handleAddRange, handleColorInput, handleColorSelected, handleDatapointSelect, handleMinMaxValueUpdate, handleOptionDisabled, handleRangeValueUpdate, handleRemoveRange, handleRemoveWidgetSignal, handleSignalSelect, index, row, orgID, updateState, widgetType }) {
    const [showColorPicker, toggleColorPicker] = (0, _react.useState)("");
    const [requestPending, setRequestPending] = (0, _react.useState)(false);
    const isLegacy = widgetType === (0, _widgetTypes.GAUGE);
    const cover = {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px"
    };
    const service = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    let source = (0, _axios.CancelToken).source();
    const fetchOutputSignals = async (searchTerm)=>{
        try {
            setRequestPending(true);
            const params = {
                limit: 100,
                orgID,
                search: "name",
                searchTerm
            };
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const { data } = await service.searchOutputSignals(gtemplateID, params, source.token);
            setRequestPending(false);
            return data.map((os)=>({
                    label: os.name,
                    value: os
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
            setRequestPending(false);
            return [];
        }
    };
    (0, _react.useEffect)(()=>source?.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `row no-gutters align-items-center bg-background-gray rounded my-3 py-2${isLegacy ? " py-md-0" : ""}`,
        style: {
            minHeight: "5rem"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-1 pl-1 px-md-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "fa-layers fa-fw",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircle),
                            color: "white",
                            size: "lg"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "fa-layers-text signal-number-text font-weight-bold text-muted",
                            children: index + 1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `px-md-0 col-10 d-flex flex-column flex-md-row${isLegacy ? "" : " flex-md-wrap"}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: isLegacy ? "flex-grow-1 pr-md-2" : "col-12 col-md-6 pl-md-0 pr-md-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: `signalCollection-${index}`,
                                children: "Signal Collection"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                captureMenuScroll: false,
                                isSearchable: true,
                                maxMenuHeight: 200,
                                menuPortalTarget: document.body,
                                name: `signalCollection-${index}`,
                                options: datapointsMap,
                                onChange: (e)=>handleDatapointSelect(e, index),
                                styles: {
                                    menuPortal: (base)=>({
                                            ...base,
                                            zIndex: 9999
                                        })
                                },
                                value: row.datapoint
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: isLegacy ? "flex-grow-1 px-md-2" : "col-12 col-md-6 px-md-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: `signal-${index}`,
                                children: "Signal to track"
                            }),
                            row?.datapoint?.value === "outputSignal" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                                cacheOptions: true,
                                captureMenuScroll: false,
                                defaultOptions: true,
                                isLoading: requestPending,
                                loadOptions: (0, _debouncePromiseDefault.default)(fetchOutputSignals, 1000),
                                maxMenuHeight: 200,
                                menuPortalTarget: document.body,
                                name: `signal-${index}`,
                                onChange: (e)=>handleSignalSelect(e, index),
                                styles: {
                                    menuPortal: (base)=>({
                                            ...base,
                                            zIndex: 9999
                                        })
                                },
                                value: row?.signal
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                captureMenuScroll: false,
                                isDisabled: !row?.datapoint?.values?.length,
                                isOptionDisabled: handleOptionDisabled,
                                isSearchable: true,
                                maxMenuHeight: 200,
                                menuPortalTarget: document.body,
                                name: `signal-${index}`,
                                options: row?.datapoint?.values || [],
                                onChange: (e)=>handleSignalSelect(e, index),
                                styles: {
                                    menuPortal: (base)=>({
                                            ...base,
                                            zIndex: 9999
                                        })
                                },
                                value: row.signal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: isLegacy ? "col-md-3 px-0 form-group mb-0" : "d-none",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "text-nowrap",
                                htmlFor: "maxValue",
                                children: "Gauge Min/Max Value"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "row no-gutters align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " col-12 col-md-6 mb-1 mb-md-0 pr-md-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "form-control",
                                            name: "minValue",
                                            onChange: (e)=>handleMinMaxValueUpdate(e, index),
                                            placeholder: "Min",
                                            type: "text",
                                            value: row.minValue
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "col-12 col-md-6 pl-md-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "form-control",
                                            name: "maxValue",
                                            onChange: (e)=>handleMinMaxValueUpdate(e, index),
                                            placeholder: "Max",
                                            type: "text",
                                            value: row.maxValue
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isLegacy ? null : row.ranges?.map?.((range, i)=>{
                        const colorPreviewStyle = (0, _tinycolor2Default.default)(range?.color).isValid() ? {
                            backgroundColor: range.color
                        } : {};
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "row align-items-stretch my-2 mr-md-n5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-1 d-flex align-items-center justify-content-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "fa-layers fa-fw",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faCircle),
                                                color: "white"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "fa-layers-text signal-number-text font-weight-bold text-muted",
                                                children: String.fromCharCode(97 + i)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-10 row flex-column flex-md-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "col-12 col-md-3 pl-md-0",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "text-nowrap",
                                                    htmlFor: "minValue",
                                                    children: "Range Min Value"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "form-control form-control-sm",
                                                    name: "minValue",
                                                    onChange: (e)=>handleRangeValueUpdate(e, index, i),
                                                    readOnly: !!i,
                                                    type: "text",
                                                    value: range?.minValue || ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "col-12 col-md-3 pl-md-0",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "text-nowrap",
                                                    htmlFor: "maxValue",
                                                    children: "Range Max Value"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "form-control form-control-sm",
                                                    name: "maxValue",
                                                    onChange: (e)=>handleRangeValueUpdate(e, index, i),
                                                    type: "text",
                                                    value: range?.maxValue || ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "col-12 col-md-3 pl-md-0",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "text-nowrap",
                                                    htmlFor: "label",
                                                    children: "Range Label"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "form-control form-control-sm",
                                                    name: "label",
                                                    onChange: (e)=>handleRangeValueUpdate(e, index, i),
                                                    type: "text",
                                                    value: range?.label || ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "col-12 col-md-3 px-md-0",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "text-nowrap",
                                                    htmlFor: "color",
                                                    children: "Choose a Color"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "input-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            "aria-describedby": `colorPickerAddon${index}-${i}`,
                                                            "aria-label": "choose range color",
                                                            className: "form-control form-control-sm",
                                                            name: "color",
                                                            onChange: (e)=>handleColorInput(e, index, i),
                                                            type: "text",
                                                            value: range?.color
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "input-group-append position-relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: "btn btn-sm input-group-text shadow-none",
                                                                    id: `colorPickerAddon${index}-${i}`,
                                                                    onClick: ()=>toggleColorPicker(showColorPicker === `${index}-${i}` ? "" : `${index}-${i}`),
                                                                    style: {
                                                                        ...colorPreviewStyle
                                                                    },
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                        className: range?.color ? "d-none" : "text-brand-primary",
                                                                        icon: (0, _freeSolidSvgIcons.faPalette)
                                                                    })
                                                                }),
                                                                showColorPicker === `${index}-${i}` ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "position-absolute",
                                                                    style: {
                                                                        right: 0,
                                                                        top: "3rem",
                                                                        zIndex: 10
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            "aria-hidden": true,
                                                                            onClick: ()=>toggleColorPicker(""),
                                                                            style: cover
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactColor.GithubPicker), {
                                                                            colors: (0, _colorPaletteOptions.gaugeRangeColorOptions),
                                                                            onChangeComplete: ({ hex })=>handleColorSelected(hex, index, i),
                                                                            triangle: "top-right"
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-1 d-flex flex-column align-items-center justify-content-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "btn btn-link px-0 py-1",
                                            onClick: ()=>handleRemoveRange(index, i),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faTimes),
                                                className: "text-danger"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: i >= 4 ? "d-none" : "btn btn-link px-0 py-1",
                                            onClick: ()=>handleAddRange(index, i),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faPlus),
                                                className: "text-alert-confirmation"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, range?.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-1 pl-1 pl-md-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-link p-0",
                    onClick: ()=>handleRemoveWidgetSignal(index),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTimes),
                        className: "text-text-dark"
                    })
                })
            })
        ]
    });
}
ConfigureGaugeWidget.propTypes = {
    datapointsMap: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string,
        value: (0, _propTypesDefault.default).string,
        values: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            label: (0, _propTypesDefault.default).string,
            value: (0, _propTypesDefault.default).string
        }))
    })),
    gtemplateID: (0, _propTypesDefault.default).string,
    handleAddRange: (0, _propTypesDefault.default).func,
    handleColorInput: (0, _propTypesDefault.default).func,
    handleColorSelected: (0, _propTypesDefault.default).func,
    handleDatapointSelect: (0, _propTypesDefault.default).func,
    handleMinMaxValueUpdate: (0, _propTypesDefault.default).func,
    handleOptionDisabled: (0, _propTypesDefault.default).func,
    handleRangeValueUpdate: (0, _propTypesDefault.default).func,
    handleRemoveRange: (0, _propTypesDefault.default).func,
    handleRemoveWidgetSignal: (0, _propTypesDefault.default).func,
    handleSignalSelect: (0, _propTypesDefault.default).func,
    index: (0, _propTypesDefault.default).number,
    orgID: (0, _propTypesDefault.default).string,
    row: (0, _propTypesDefault.default).shape({
        datapoint: (0, _propTypesDefault.default).shape({
            value: (0, _propTypesDefault.default).string,
            values: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        }),
        minValue: (0, _propTypesDefault.default).string,
        maxValue: (0, _propTypesDefault.default).string,
        ranges: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            id: (0, _propTypesDefault.default).string,
            color: (0, _propTypesDefault.default).string,
            label: (0, _propTypesDefault.default).string,
            maxValue: (0, _propTypesDefault.default).string,
            minValue: (0, _propTypesDefault.default).string
        })),
        signal: (0, _propTypesDefault.default).object
    }),
    updateState: (0, _propTypesDefault.default).func,
    widgetType: (0, _propTypesDefault.default).oneOf([
        (0, _widgetTypes.GAUGE),
        (0, _widgetTypes.GAUGE_RANGE)
    ])
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","react-select":"j36cq","react-select/async":"iHFh7","debounce-promise":"fqOKC","react-color":"eCm3k","tinycolor2":"4AVaN","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/WidgetTypes":"frQz2","../../Services/TemplateService":"hGdvK","../../Constants/ColorPaletteOptions":"byZ6X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eCm3k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "BlockPicker", ()=>(0, _blockDefault.default));
parcelHelpers.export(exports, "CirclePicker", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "ChromePicker", ()=>(0, _chromeDefault.default));
parcelHelpers.export(exports, "CompactPicker", ()=>(0, _compactDefault.default));
parcelHelpers.export(exports, "GithubPicker", ()=>(0, _githubDefault.default));
parcelHelpers.export(exports, "HuePicker", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "MaterialPicker", ()=>(0, _materialDefault.default));
parcelHelpers.export(exports, "PhotoshopPicker", ()=>(0, _photoshopDefault.default));
parcelHelpers.export(exports, "SketchPicker", ()=>(0, _sketchDefault.default));
parcelHelpers.export(exports, "SliderPicker", ()=>(0, _sliderDefault.default));
parcelHelpers.export(exports, "SwatchesPicker", ()=>(0, _swatchesDefault.default));
parcelHelpers.export(exports, "TwitterPicker", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "GooglePicker", ()=>(0, _googleDefault.default));
parcelHelpers.export(exports, "CustomPicker", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _chromeDefault.default));
var _alpha = require("./components/alpha/Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _block = require("./components/block/Block");
var _blockDefault = parcelHelpers.interopDefault(_block);
var _circle = require("./components/circle/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _chrome = require("./components/chrome/Chrome");
var _chromeDefault = parcelHelpers.interopDefault(_chrome);
var _compact = require("./components/compact/Compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _github = require("./components/github/Github");
var _githubDefault = parcelHelpers.interopDefault(_github);
var _hue = require("./components/hue/Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _material = require("./components/material/Material");
var _materialDefault = parcelHelpers.interopDefault(_material);
var _photoshop = require("./components/photoshop/Photoshop");
var _photoshopDefault = parcelHelpers.interopDefault(_photoshop);
var _sketch = require("./components/sketch/Sketch");
var _sketchDefault = parcelHelpers.interopDefault(_sketch);
var _slider = require("./components/slider/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _swatches = require("./components/swatches/Swatches");
var _swatchesDefault = parcelHelpers.interopDefault(_swatches);
var _twitter = require("./components/twitter/Twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _google = require("./components/google/Google");
var _googleDefault = parcelHelpers.interopDefault(_google);
var _colorWrap = require("./components/common/ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);

},{"./components/alpha/Alpha":"ivNSt","./components/block/Block":"lM1AY","./components/circle/Circle":"4tT9V","./components/chrome/Chrome":"6EiGv","./components/compact/Compact":"4fCZ7","./components/github/Github":"5a9tU","./components/hue/Hue":"aRmaX","./components/material/Material":"jlcVF","./components/photoshop/Photoshop":"grH58","./components/sketch/Sketch":"761c2","./components/slider/Slider":"LOOqi","./components/swatches/Swatches":"in5kC","./components/twitter/Twitter":"lypvp","./components/google/Google":"bK2GH","./components/common/ColorWrap":"jBu17","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivNSt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>AlphaPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _alphaPointer = require("./AlphaPointer");
var _alphaPointerDefault = parcelHelpers.interopDefault(_alphaPointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var AlphaPicker = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            alpha: {
                radius: "2px",
                style: style
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "alpha-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), _extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
AlphaPicker.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, _alphaPointerDefault.default)
};
exports.default = (0, _common.ColorWrap)(AlphaPicker);

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","./AlphaPointer":"dStp4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7O6YP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
var _flattenNames = require("d21bbaf20f135ed7");
var _flattenNames2 = _interopRequireDefault(_flattenNames);
var _mergeClasses = require("7ab5259b27ba03f4");
var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
var _autoprefix = require("f7ab0b82c66de9f6");
var _autoprefix2 = _interopRequireDefault(_autoprefix);
var _hover2 = require("610a3f6b931726da");
var _hover3 = _interopRequireDefault(_hover2);
var _active = require("8d8d6281227b8365");
var _active2 = _interopRequireDefault(_active);
var _loop2 = require("c3bae8551a541b09");
var _loop3 = _interopRequireDefault(_loop2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, _flattenNames2.default)(activations);
    var merged = (0, _mergeClasses2.default)(classes, activeNames);
    return (0, _autoprefix2.default)(merged);
};
exports.default = ReactCSS;

},{"d21bbaf20f135ed7":"3ptd2","7ab5259b27ba03f4":"crkaN","f7ab0b82c66de9f6":"1xeaO","610a3f6b931726da":"5kyFi","8d8d6281227b8365":"fpdHy","c3bae8551a541b09":"leyEG"}],"3ptd2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.flattenNames = undefined;
var _isString2 = require("cc07907b88eac890");
var _isString3 = _interopRequireDefault(_isString2);
var _forOwn2 = require("2db844d13e15e498");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _isPlainObject2 = require("8ea197129e7ee890");
var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
var _map2 = require("8f65518dcbd71fa0");
var _map3 = _interopRequireDefault(_map2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var flattenNames = exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, _map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, _isPlainObject3.default)(thing)) (0, _forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, _isString3.default)(thing)) names.push(thing);
    });
    return names;
};
exports.default = flattenNames;

},{"cc07907b88eac890":"5nkFr","2db844d13e15e498":"jhROb","8ea197129e7ee890":"lCxAG","8f65518dcbd71fa0":"lEbGY"}],"5nkFr":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"5ltt8","46fdd4d2c5d7b4ab":"1DVeR","36ebbb6a9d8b3fe4":"4gOki"}],"jhROb":[function(require,module,exports) {
var baseForOwn = require("29fecbf008d96984"), castFunction = require("e9d5e9d48b9f93d3");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forOwn(object, iteratee) {
    return object && baseForOwn(object, castFunction(iteratee));
}
module.exports = forOwn;

},{"29fecbf008d96984":"i7P4y","e9d5e9d48b9f93d3":"jVEVZ"}],"jVEVZ":[function(require,module,exports) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == "function" ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"2HXBf"}],"lEbGY":[function(require,module,exports) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"chzeu","8bad46685c8864d":"6jZAq","51c76ab24fdb66f9":"8JEHD","7cb4cacc4dea406c":"1DVeR"}],"8JEHD":[function(require,module,exports) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"hbtgh","2924e2db4bb5430d":"kzICo"}],"crkaN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeClasses = undefined;
var _forOwn2 = require("42f7fd880fbb6b28");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _cloneDeep2 = require("fe0598645aa3c32b");
var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, _forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = _extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
exports.default = mergeClasses;

},{"42f7fd880fbb6b28":"jhROb","fe0598645aa3c32b":"kA4yF"}],"kA4yF":[function(require,module,exports) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"dqsfF"}],"dqsfF":[function(require,module,exports) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"cltFt","3a79976eb46af94a":"gM7YB","bc83a05a4f99d69b":"aKTSf","e6b4c3e6c85df6bb":"7HkQg","f340cc553ba5643c":"c7Ii5","e72e99883a50402d":"aNaSh","dc840ead07f1054":"lWbYv","309288e8ee190af0":"4A2Va","687fa30fede0b048":"7bLYw","bb0ba724f98b094d":"lOHy9","12bae1dca0e83064":"iZ6gY","4c3204eaea28d680":"1chae","fd7741200b462cdf":"cSkwN","f93a1d24ac08e076":"jeUN0","630039e80f692f17":"fGkGx","f37949484ab52dae":"1DVeR","ac876cc65d29c86e":"26W2O","1056c031d98783c0":"hm6iH","1800fb3122907fc2":"6hgJK","31f022f648037bd3":"7SeAd","5f3267fbd9848a7d":"9qKxr","7d3f3bdc4f2e7bb8":"6emcB"}],"gM7YB":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"7HkQg":[function(require,module,exports) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"vDc33","fcf23a0242ef0da9":"9qKxr"}],"c7Ii5":[function(require,module,exports) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"vDc33","7697a1565646c93":"6emcB"}],"4A2Va":[function(require,module,exports) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"vDc33","39cbde2205d9399c":"igqw1"}],"7bLYw":[function(require,module,exports) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"vDc33","9b660e6b0c20d303":"IRyaH"}],"IRyaH":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"8JuEE","6ccae2aa7cfa3c66":"9DBU4","bdb501682ee9305d":"igqw1","7641fe4ae6d2cc96":"gRVIR"}],"iZ6gY":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"hu5MU","feede5d0a2d06427":"IRyaH","287f70f798405911":"6emcB"}],"cSkwN":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"jeUN0":[function(require,module,exports) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"ZLaCu","dbf04edaab2ae376":"kzyXT","763300f2dd9bdaf3":"aRqyO","c30e64d90e4b92d1":"2D8ix","d1edd8349e9ad54d":"WFexx"}],"kzyXT":[function(require,module,exports) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"ZLaCu"}],"aRqyO":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"2D8ix":[function(require,module,exports) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"crlKT"}],"hm6iH":[function(require,module,exports) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"iXyzE","6a7e6b1a2d9fb1d5":"jVyhK","7d4f449dd306450f":"bPzLC"}],"iXyzE":[function(require,module,exports) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"1chae","88260e33e0003386":"4gOki"}],"7SeAd":[function(require,module,exports) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"2H7vq","3cb35dba719c68b1":"jVyhK","7a3e899a332ff7be":"bPzLC"}],"2H7vq":[function(require,module,exports) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"1chae","b6fc875bc5f351c9":"4gOki"}],"1xeaO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoprefix = undefined;
var _forOwn2 = require("6b2ab06ed0e74650");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var autoprefix = exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, _forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, _forOwn3.default)(styles, function(value, key) {
            var transform = transforms[key];
            if (transform) expanded = _extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
exports.default = autoprefix;

},{"6b2ab06ed0e74650":"jhROb"}],"5kyFi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hover = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("a618bb79e13970dd");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hover = exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }(_react2.default.Component);
};
exports.default = hover;

},{"a618bb79e13970dd":"9njXz"}],"fpdHy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.active = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("91e1b91cd0b21ba2");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var active = exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }(_react2.default.Component);
};
exports.default = active;

},{"91e1b91cd0b21ba2":"9njXz"}],"leyEG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
exports.default = loopable;

},{}],"f3pVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "Checkboard", ()=>(0, _checkboardDefault.default));
parcelHelpers.export(exports, "EditableInput", ()=>(0, _editableInputDefault.default));
parcelHelpers.export(exports, "Hue", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "Raised", ()=>(0, _raisedDefault.default));
parcelHelpers.export(exports, "Saturation", ()=>(0, _saturationDefault.default));
parcelHelpers.export(exports, "ColorWrap", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "Swatch", ()=>(0, _swatchDefault.default));
var _alpha = require("./Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _editableInput = require("./EditableInput");
var _editableInputDefault = parcelHelpers.interopDefault(_editableInput);
var _hue = require("./Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _raised = require("./Raised");
var _raisedDefault = parcelHelpers.interopDefault(_raised);
var _saturation = require("./Saturation");
var _saturationDefault = parcelHelpers.interopDefault(_saturation);
var _colorWrap = require("./ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);
var _swatch = require("./Swatch");
var _swatchDefault = parcelHelpers.interopDefault(_swatch);

},{"./Alpha":"bNP8e","./Checkboard":"fcpxn","./EditableInput":"3kxQY","./Hue":"gWPQU","./Raised":"4HUee","./Saturation":"lSRGQ","./ColorWrap":"jBu17","./Swatch":"aOxoG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNP8e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>Alpha);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _alpha = require("../../helpers/alpha");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function(_ref) {
    _inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": _extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.checkboard
                }, (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
                    renderers: this.props.renderers
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.gradient
                }), (0, _reactDefault.default).createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Alpha;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/alpha":"6FdAZ","./Checkboard":"fcpxn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FdAZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fcpxn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkboard", ()=>Checkboard);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _checkboard = require("../../helpers/checkboard");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + _checkboard.get(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, _react.isValidElement)(children) ? (0, _reactDefault.default).cloneElement(children, _extends({}, children.props, {
        style: _extends({}, children.props.style, styles.grid)
    })) : (0, _reactDefault.default).createElement("div", {
        style: styles.grid
    });
};
Checkboard.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
exports.default = Checkboard;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/checkboard":"gWhkt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWhkt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "get", ()=>get);
var checkboardCache = {};
var render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if (checkboardCache[key]) return checkboardCache[key];
    var checkboard = render(c1, c2, size, serverCanvas);
    checkboardCache[key] = checkboard;
    return checkboard;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kxQY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableInput", ()=>EditableInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [
    UP_KEY_CODE,
    DOWN_KEY_CODE
];
var isValidKeyCode = function isValidKeyCode(keyCode) {
    return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var idCounter = 1;
var EditableInput = function(_ref) {
    _inherits(EditableInput, _ref);
    function EditableInput(props) {
        _classCallCheck(this, EditableInput);
        var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = getNumberValue(e.target.value);
            if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + idCounter++;
        return _this;
    }
    _createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return _defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.wrap
                }, (0, _reactDefault.default).createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? (0, _reactDefault.default).createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = EditableInput;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWPQU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hue", ()=>Hue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _hue = require("../../helpers/hue");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref) {
    _inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), (0, _reactDefault.default).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Hue;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/hue":"gdsf5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdsf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4HUee":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Raised", ()=>Raised);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.wrap
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.bg
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.content
    }, children));
};
Raised.propTypes = {
    background: (0, _propTypesDefault.default).string,
    zDepth: (0, _propTypesDefault.default).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Raised.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
exports.default = Raised;

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQl8F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMergeJs = require("./_baseMerge.js");
var _baseMergeJsDefault = parcelHelpers.interopDefault(_baseMergeJs);
var _createAssignerJs = require("./_createAssigner.js");
var _createAssignerJsDefault = parcelHelpers.interopDefault(_createAssignerJs);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = (0, _createAssignerJsDefault.default)(function(object, source, srcIndex) {
    (0, _baseMergeJsDefault.default)(object, source, srcIndex);
});
exports.default = merge;

},{"./_baseMerge.js":"eeDiO","./_createAssigner.js":"ktr6u","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eeDiO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _baseMergeDeepJs = require("./_baseMergeDeep.js");
var _baseMergeDeepJsDefault = parcelHelpers.interopDefault(_baseMergeDeepJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, _baseForJsDefault.default)(source, function(srcValue, key) {
        stack || (stack = new (0, _stackJsDefault.default));
        if ((0, _isObjectJsDefault.default)(srcValue)) (0, _baseMergeDeepJsDefault.default)(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, _safeGetJsDefault.default)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, _assignMergeValueJsDefault.default)(object, key, newValue);
        }
    }, (0, _keysInJsDefault.default));
}
exports.default = baseMerge;

},{"./_Stack.js":"6rfzp","./_assignMergeValue.js":"37hpW","./_baseFor.js":"1b7Jy","./_baseMergeDeep.js":"dHfag","./isObject.js":"ah1Cr","./keysIn.js":"dOdxD","./_safeGet.js":"b7qYM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6rfzp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype["delete"] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"l0uYx","./_stackClear.js":"4HglF","./_stackDelete.js":"5fTer","./_stackGet.js":"ggfNK","./_stackHas.js":"aqvsn","./_stackSet.js":"4AL0c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l0uYx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype["delete"] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"e2ep2","./_listCacheDelete.js":"kGwFB","./_listCacheGet.js":"9ygkc","./_listCacheHas.js":"2iuXe","./_listCacheSet.js":"feYC4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2ep2":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGwFB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6u8FR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"d11tM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d11tM":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ygkc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2iuXe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"feYC4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"6u8FR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4HglF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"l0uYx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5fTer":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ggfNK":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aqvsn":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AL0c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"l0uYx","./_Map.js":"13fDv","./_MapCache.js":"iZCA7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13fDv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Map");
exports.default = Map;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Z5FSj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"1NgxH","./_getValue.js":"hw7N6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1NgxH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"7pb6H","./_isMasked.js":"bAGVh","./isObject.js":"ah1Cr","./_toSource.js":"755gJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pb6H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"9Chff","./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Chff":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"c53Uj","./_getRawTag.js":"gkm0n","./_objectToString.js":"2GCBc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c53Uj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10cmd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function("return this")();
exports.default = root;

},{"./_freeGlobal.js":"cvlFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvlFB":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkm0n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"c53Uj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2GCBc":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ah1Cr":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bAGVh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"dEPG8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEPG8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)["__core-js_shared__"];
exports.default = coreJsData;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"755gJ":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hw7N6":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZCA7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype["delete"] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"Y4N34","./_mapCacheDelete.js":"bwNmW","./_mapCacheGet.js":"a2tVV","./_mapCacheHas.js":"9OBkA","./_mapCacheSet.js":"aGCjp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Y4N34":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, _hashJsDefault.default),
        "map": new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        "string": new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"fCdET","./_ListCache.js":"l0uYx","./_Map.js":"13fDv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCdET":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype["delete"] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"9SoV8","./_hashDelete.js":"13WpC","./_hashGet.js":"f7SyB","./_hashHas.js":"jRz4J","./_hashSet.js":"5hFaM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9SoV8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1gQwf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, "create");
exports.default = nativeCreate;

},{"./_getNative.js":"Z5FSj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13WpC":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7SyB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jRz4J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5hFaM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"1gQwf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bwNmW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwpVt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"8UcYi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UcYi":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a2tVV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9OBkA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aGCjp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"hwpVt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37hpW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, _eqJsDefault.default)(object[key], value) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignMergeValue;

},{"./_baseAssignValue.js":"7WwSg","./eq.js":"d11tM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7WwSg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"hoPLT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hoPLT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"Z5FSj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1b7Jy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createBaseForJs = require("./_createBaseFor.js");
var _createBaseForJsDefault = parcelHelpers.interopDefault(_createBaseForJs);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = (0, _createBaseForJsDefault.default)();
exports.default = baseFor;

},{"./_createBaseFor.js":"2ZwGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZwGj":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
exports.default = createBaseFor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dHfag":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeObjectJs = require("./isArrayLikeObject.js");
var _isArrayLikeObjectJsDefault = parcelHelpers.interopDefault(_isArrayLikeObjectJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPlainObjectJs = require("./isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
var _toPlainObjectJs = require("./toPlainObject.js");
var _toPlainObjectJsDefault = parcelHelpers.interopDefault(_toPlainObjectJs);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, _safeGetJsDefault.default)(object, key), srcValue = (0, _safeGetJsDefault.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, _assignMergeValueJsDefault.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, _isArrayJsDefault.default)(srcValue), isBuff = !isArr && (0, _isBufferJsDefault.default)(srcValue), isTyped = !isArr && !isBuff && (0, _isTypedArrayJsDefault.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, _isArrayJsDefault.default)(objValue)) newValue = objValue;
            else if ((0, _isArrayLikeObjectJsDefault.default)(objValue)) newValue = (0, _copyArrayJsDefault.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, _cloneBufferJsDefault.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, _cloneTypedArrayJsDefault.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, _isPlainObjectJsDefault.default)(srcValue) || (0, _isArgumentsJsDefault.default)(srcValue)) {
            newValue = objValue;
            if ((0, _isArgumentsJsDefault.default)(objValue)) newValue = (0, _toPlainObjectJsDefault.default)(objValue);
            else if (!(0, _isObjectJsDefault.default)(objValue) || (0, _isFunctionJsDefault.default)(objValue)) newValue = (0, _initCloneObjectJsDefault.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, _assignMergeValueJsDefault.default)(object, key, newValue);
}
exports.default = baseMergeDeep;

},{"./_assignMergeValue.js":"37hpW","./_cloneBuffer.js":"9bdhA","./_cloneTypedArray.js":"9tA9m","./_copyArray.js":"jjYsM","./_initCloneObject.js":"4hEhH","./isArguments.js":"3o5tK","./isArray.js":"dB5dn","./isArrayLikeObject.js":"4iqeX","./isBuffer.js":"dkqfQ","./isFunction.js":"7pb6H","./isObject.js":"ah1Cr","./isPlainObject.js":"fiE8B","./isTypedArray.js":"fH44A","./_safeGet.js":"b7qYM","./toPlainObject.js":"dGHEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bdhA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tA9m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"1RxFP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1RxFP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"cyDAa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cyDAa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jjYsM":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4hEhH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"kSx59","./_getPrototype.js":"gSX6x","./_isPrototype.js":"kOZ2F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kSx59":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gSX6x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"gLjM1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gLjM1":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOZ2F":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3o5tK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"3ufDO","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ufDO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"9Chff","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kL9F":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == "object";
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dB5dn":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4iqeX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isArrayLikeJsDefault.default)(value);
}
exports.default = isArrayLikeObject;

},{"./isArrayLike.js":"6DRGr","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6DRGr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"7pb6H","./isLength.js":"jbwyd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jbwyd":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dkqfQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"10cmd","./stubFalse.js":"hcocD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hcocD":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiE8B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"9Chff","./_getPrototype.js":"gSX6x","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fH44A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"kuqtj","./_baseUnary.js":"9mRng","./_nodeUtil.js":"jdWud","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kuqtj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"9Chff","./isLength.js":"jbwyd","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9mRng":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdWud":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"cvlFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b7qYM":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
exports.default = safeGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGHEy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return (0, _copyObjectJsDefault.default)(value, (0, _keysInJsDefault.default)(value));
}
exports.default = toPlainObject;

},{"./_copyObject.js":"iLQwq","./keysIn.js":"dOdxD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLQwq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"6Dqnr","./_baseAssignValue.js":"7WwSg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Dqnr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"7WwSg","./eq.js":"d11tM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dOdxD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"fwfx8","./_baseKeysIn.js":"i1Mf7","./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fwfx8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"9nudW","./isArguments.js":"3o5tK","./isArray.js":"dB5dn","./isBuffer.js":"dkqfQ","./_isIndex.js":"axaW4","./isTypedArray.js":"fH44A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9nudW":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axaW4":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i1Mf7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"ah1Cr","./_isPrototype.js":"kOZ2F","./_nativeKeysIn.js":"cTfMl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTfMl":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktr6u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseRestJs = require("./_baseRest.js");
var _baseRestJsDefault = parcelHelpers.interopDefault(_baseRestJs);
var _isIterateeCallJs = require("./_isIterateeCall.js");
var _isIterateeCallJsDefault = parcelHelpers.interopDefault(_isIterateeCallJs);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return (0, _baseRestJsDefault.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, _isIterateeCallJsDefault.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
exports.default = createAssigner;

},{"./_baseRest.js":"gtLav","./_isIterateeCall.js":"ddyyQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtLav":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _overRestJs = require("./_overRest.js");
var _overRestJsDefault = parcelHelpers.interopDefault(_overRestJs);
var _setToStringJs = require("./_setToString.js");
var _setToStringJsDefault = parcelHelpers.interopDefault(_setToStringJs);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return (0, _setToStringJsDefault.default)((0, _overRestJsDefault.default)(func, start, (0, _identityJsDefault.default)), func + "");
}
exports.default = baseRest;

},{"./identity.js":"1Jo6N","./_overRest.js":"33KqE","./_setToString.js":"2i4Wc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Jo6N":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function identity(value) {
    return value;
}
exports.default = identity;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33KqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _applyJs = require("./_apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, _applyJsDefault.default)(func, this, otherArgs);
    };
}
exports.default = overRest;

},{"./_apply.js":"lEMSr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEMSr":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
exports.default = apply;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2i4Wc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSetToStringJs = require("./_baseSetToString.js");
var _baseSetToStringJsDefault = parcelHelpers.interopDefault(_baseSetToStringJs);
var _shortOutJs = require("./_shortOut.js");
var _shortOutJsDefault = parcelHelpers.interopDefault(_shortOutJs);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = (0, _shortOutJsDefault.default)((0, _baseSetToStringJsDefault.default));
exports.default = setToString;

},{"./_baseSetToString.js":"6kp8T","./_shortOut.js":"fyiMt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kp8T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !(0, _definePropertyJsDefault.default) ? (0, _identityJsDefault.default) : function(func, string) {
    return (0, _definePropertyJsDefault.default)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, _constantJsDefault.default)(string),
        "writable": true
    });
};
exports.default = baseSetToString;

},{"./constant.js":"d1OmC","./_defineProperty.js":"hoPLT","./identity.js":"1Jo6N","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d1OmC":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function constant(value) {
    return function() {
        return value;
    };
}
exports.default = constant;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fyiMt":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
exports.default = shortOut;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddyyQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!(0, _isObjectJsDefault.default)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, _isArrayLikeJsDefault.default)(object) && (0, _isIndexJsDefault.default)(index, object.length) : type == "string" && index in object) return (0, _eqJsDefault.default)(object[index], value);
    return false;
}
exports.default = isIterateeCall;

},{"./eq.js":"d11tM","./isArrayLike.js":"6DRGr","./_isIndex.js":"axaW4","./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lSRGQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Saturation", ()=>Saturation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _throttle = require("lodash-es/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _saturation = require("../../helpers/saturation");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref) {
    _inherits(Saturation, _ref);
    function Saturation(props) {
        _classCallCheck(this, Saturation);
        var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, _saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, _throttleDefault.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    _createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), (0, _reactDefault.default).createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), (0, _reactDefault.default).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Saturation;

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/throttle":"aRatu","../../helpers/saturation":"3obSh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRatu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounceJs = require("./debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, _debounceJsDefault.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
exports.default = throttle;

},{"./debounce.js":"l3yba","./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l3yba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _nowJs = require("./now.js");
var _nowJsDefault = parcelHelpers.interopDefault(_nowJs);
var _toNumberJs = require("./toNumber.js");
var _toNumberJsDefault = parcelHelpers.interopDefault(_toNumberJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    wait = (0, _toNumberJsDefault.default)(wait) || 0;
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax((0, _toNumberJsDefault.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, _nowJsDefault.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, _nowJsDefault.default)());
    }
    function debounced() {
        var time = (0, _nowJsDefault.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
exports.default = debounce;

},{"./isObject.js":"ah1Cr","./now.js":"i9l7u","./toNumber.js":"4AdPu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9l7u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return (0, _rootJsDefault.default).Date.now();
};
exports.default = now;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AdPu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTrimJs = require("./_baseTrim.js");
var _baseTrimJsDefault = parcelHelpers.interopDefault(_baseTrimJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, _isSymbolJsDefault.default)(value)) return NAN;
    if ((0, _isObjectJsDefault.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, _isObjectJsDefault.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, _baseTrimJsDefault.default)(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
exports.default = toNumber;

},{"./_baseTrim.js":"luSuV","./isObject.js":"ah1Cr","./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luSuV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trimmedEndIndexJs = require("./_trimmedEndIndex.js");
var _trimmedEndIndexJsDefault = parcelHelpers.interopDefault(_trimmedEndIndexJs);
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, (0, _trimmedEndIndexJsDefault.default)(string) + 1).replace(reTrimStart, "") : string;
}
exports.default = baseTrim;

},{"./_trimmedEndIndex.js":"c0kTb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0kTb":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
exports.default = trimmedEndIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V8ty":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"9Chff","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3obSh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jBu17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWrap", ()=>ColorWrap);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounce = require("lodash-es/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _color = require("../../helpers/color");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        _inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            _classCallCheck(this, ColorPicker);
            var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = _extends({}, _color.toState(props.color, 0));
            _this.debounce = (0, _debounceDefault.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        _createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, _reactDefault.default).createElement(Picker, _extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return _extends({}, _color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, _react.PureComponent) || (0, _react.Component));
    ColorPicker.propTypes = _extends({}, Picker.propTypes);
    ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
exports.default = ColorWrap;

},{"react":"9njXz","lodash-es/debounce":"l3yba","../../helpers/color":"lNUGR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lNUGR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "simpleCheckForValidColor", ()=>simpleCheckForValidColor);
parcelHelpers.export(exports, "toState", ()=>toState);
parcelHelpers.export(exports, "isValidHex", ()=>isValidHex);
parcelHelpers.export(exports, "getContrastingColor", ()=>getContrastingColor);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "isvalidColorString", ()=>isvalidColorString);
var _each = require("lodash-es/each");
var _eachDefault = parcelHelpers.interopDefault(_each);
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, _eachDefault.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var toState = function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2Default.default)(data.hex) : (0, _tinycolor2Default.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var isValidHex = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2Default.default)(hex).isValid();
};
var getContrastingColor = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = toState(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, _tinycolor2Default.default)(type + " (" + stringWithoutDegree + ")")._ok;
};

},{"lodash-es/each":"jhCGo","tinycolor2":"4AVaN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jhCGo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _forEachJsDefault.default));
var _forEachJs = require("./forEach.js");
var _forEachJsDefault = parcelHelpers.interopDefault(_forEachJs);

},{"./forEach.js":"6jYhk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jYhk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayEachJs = require("./_arrayEach.js");
var _arrayEachJsDefault = parcelHelpers.interopDefault(_arrayEachJs);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _castFunctionJs = require("./_castFunction.js");
var _castFunctionJsDefault = parcelHelpers.interopDefault(_castFunctionJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayEachJsDefault.default) : (0, _baseEachJsDefault.default);
    return func(collection, (0, _castFunctionJsDefault.default)(iteratee));
}
exports.default = forEach;

},{"./_arrayEach.js":"4J6Eo","./_baseEach.js":"jNEvS","./_castFunction.js":"3z0qa","./isArray.js":"dB5dn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4J6Eo":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
exports.default = arrayEach;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNEvS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForOwnJs = require("./_baseForOwn.js");
var _baseForOwnJsDefault = parcelHelpers.interopDefault(_baseForOwnJs);
var _createBaseEachJs = require("./_createBaseEach.js");
var _createBaseEachJsDefault = parcelHelpers.interopDefault(_createBaseEachJs);
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = (0, _createBaseEachJsDefault.default)((0, _baseForOwnJsDefault.default));
exports.default = baseEach;

},{"./_baseForOwn.js":"3eFz9","./_createBaseEach.js":"ga21g","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3eFz9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && (0, _baseForJsDefault.default)(object, iteratee, (0, _keysJsDefault.default));
}
exports.default = baseForOwn;

},{"./_baseFor.js":"1b7Jy","./keys.js":"h1d6U","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h1d6U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object) : (0, _baseKeysJsDefault.default)(object);
}
exports.default = keys;

},{"./_arrayLikeKeys.js":"fwfx8","./_baseKeys.js":"hSUtG","./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hSUtG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"kOZ2F","./_nativeKeys.js":"6brqc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6brqc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"gLjM1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ga21g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, _isArrayLikeJsDefault.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
exports.default = createBaseEach;

},{"./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3z0qa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == "function" ? value : (0, _identityJsDefault.default);
}
exports.default = castFunction;

},{"./identity.js":"1Jo6N","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOxoG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatch", ()=>Swatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _interaction = require("../../helpers/interaction");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var ENTER = 13;
var Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, _reactcssDefault.default)({
        default: {
            swatch: _extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, _reactDefault.default).createElement("div", _extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
exports.default = (0, _interaction.handleFocus)(Swatch);

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/interaction":"7EkZ3","./Checkboard":"fcpxn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7EkZ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleFocus", ()=>handleFocus);
/* eslint-disable no-invalid-this */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return (0, _reactDefault.default).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, _reactDefault.default).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, _reactDefault.default).Component);
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dStp4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPointer", ()=>AlphaPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var AlphaPointer = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = AlphaPointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lM1AY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Block", ()=>Block);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _blockSwatches = require("./BlockSwatches");
var _blockSwatchesDefault = parcelHelpers.interopDefault(_blockSwatches);
var Block = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var transparent = hex === "transparent";
    var handleChange = function handleChange(hexCode, e) {
        _color.isValidHex(hexCode) && onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                boxShadow: "0 1px rgba(0,0,0,.1)",
                borderRadius: "6px",
                position: "relative"
            },
            head: {
                height: "110px",
                background: hex,
                borderRadius: "6px 6px 0 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative"
            },
            body: {
                padding: "10px"
            },
            label: {
                fontSize: "18px",
                color: _color.getContrastingColor(hex),
                position: "relative"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 10px 10px 10px",
                borderColor: "transparent transparent " + hex + " transparent",
                position: "absolute",
                top: "-10px",
                left: "50%",
                marginLeft: "-10px"
            },
            input: {
                width: "100%",
                fontSize: "12px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "22px",
                boxShadow: "inset 0 0 0 1px #ddd",
                borderRadius: "4px",
                padding: "0 7px",
                boxSizing: "border-box"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide"
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "block-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.head
    }, transparent && (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        borderRadius: "6px 6px 0 0"
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.label
    }, hex)), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _reactDefault.default).createElement((0, _blockSwatchesDefault.default), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
Block.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        "top",
        "hide"
    ]),
    styles: (0, _propTypesDefault.default).object
};
Block.defaultProps = {
    width: 170,
    colors: [
        "#D9E3F0",
        "#F47373",
        "#697689",
        "#37D67A",
        "#2CCCE4",
        "#555555",
        "#dce775",
        "#ff8a65",
        "#ba68c8"
    ],
    triangle: "top",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Block);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","./BlockSwatches":"5a558","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5a558":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockSwatches", ()=>BlockSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _common = require("../common");
var BlockSwatches = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatches: {
                marginRight: "-10px"
            },
            swatch: {
                width: "22px",
                height: "22px",
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "4px"
            },
            clear: {
                clear: "both"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    }));
};
exports.default = BlockSwatches;

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/map":"8jKVV","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8jKVV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _baseIterateeJs = require("./_baseIteratee.js");
var _baseIterateeJsDefault = parcelHelpers.interopDefault(_baseIterateeJs);
var _baseMapJs = require("./_baseMap.js");
var _baseMapJsDefault = parcelHelpers.interopDefault(_baseMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayMapJsDefault.default) : (0, _baseMapJsDefault.default);
    return func(collection, (0, _baseIterateeJsDefault.default)(iteratee, 3));
}
exports.default = map;

},{"./_arrayMap.js":"1tnvM","./_baseIteratee.js":"7juta","./_baseMap.js":"4OYjy","./isArray.js":"dB5dn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tnvM":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
exports.default = arrayMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7juta":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMatchesJs = require("./_baseMatches.js");
var _baseMatchesJsDefault = parcelHelpers.interopDefault(_baseMatchesJs);
var _baseMatchesPropertyJs = require("./_baseMatchesProperty.js");
var _baseMatchesPropertyJsDefault = parcelHelpers.interopDefault(_baseMatchesPropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, _identityJsDefault.default;
    if (typeof value == "object") return (0, _isArrayJsDefault.default)(value) ? (0, _baseMatchesPropertyJsDefault.default)(value[0], value[1]) : (0, _baseMatchesJsDefault.default)(value);
    return (0, _propertyJsDefault.default)(value);
}
exports.default = baseIteratee;

},{"./_baseMatches.js":"6cNES","./_baseMatchesProperty.js":"jSEeK","./identity.js":"1Jo6N","./isArray.js":"dB5dn","./property.js":"k8mcz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cNES":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsMatchJs = require("./_baseIsMatch.js");
var _baseIsMatchJsDefault = parcelHelpers.interopDefault(_baseIsMatchJs);
var _getMatchDataJs = require("./_getMatchData.js");
var _getMatchDataJsDefault = parcelHelpers.interopDefault(_getMatchDataJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = (0, _getMatchDataJsDefault.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, _matchesStrictComparableJsDefault.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, _baseIsMatchJsDefault.default)(object, source, matchData);
    };
}
exports.default = baseMatches;

},{"./_baseIsMatch.js":"5QyMm","./_getMatchData.js":"fhomB","./_matchesStrictComparable.js":"knWvD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5QyMm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, _stackJsDefault.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
exports.default = baseIsMatch;

},{"./_Stack.js":"6rfzp","./_baseIsEqual.js":"6HlYN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HlYN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualDeepJs = require("./_baseIsEqualDeep.js");
var _baseIsEqualDeepJsDefault = parcelHelpers.interopDefault(_baseIsEqualDeepJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, _isObjectLikeJsDefault.default)(value) && !(0, _isObjectLikeJsDefault.default)(other)) return value !== value && other !== other;
    return (0, _baseIsEqualDeepJsDefault.default)(value, other, bitmask, customizer, baseIsEqual, stack);
}
exports.default = baseIsEqual;

},{"./_baseIsEqualDeep.js":"kCgzd","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCgzd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _equalByTagJs = require("./_equalByTag.js");
var _equalByTagJsDefault = parcelHelpers.interopDefault(_equalByTagJs);
var _equalObjectsJs = require("./_equalObjects.js");
var _equalObjectsJsDefault = parcelHelpers.interopDefault(_equalObjectsJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, _isArrayJsDefault.default)(object), othIsArr = (0, _isArrayJsDefault.default)(other), objTag = objIsArr ? arrayTag : (0, _getTagJsDefault.default)(object), othTag = othIsArr ? arrayTag : (0, _getTagJsDefault.default)(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, _isBufferJsDefault.default)(object)) {
        if (!(0, _isBufferJsDefault.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, _stackJsDefault.default));
        return objIsArr || (0, _isTypedArrayJsDefault.default)(object) ? (0, _equalArraysJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, _equalByTagJsDefault.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, _stackJsDefault.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, _stackJsDefault.default));
    return (0, _equalObjectsJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack);
}
exports.default = baseIsEqualDeep;

},{"./_Stack.js":"6rfzp","./_equalArrays.js":"lsOdO","./_equalByTag.js":"7NOrr","./_equalObjects.js":"79mhq","./_getTag.js":"2LNQq","./isArray.js":"dB5dn","./isBuffer.js":"dkqfQ","./isTypedArray.js":"fH44A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lsOdO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setCacheJs = require("./_SetCache.js");
var _setCacheJsDefault = parcelHelpers.interopDefault(_setCacheJs);
var _arraySomeJs = require("./_arraySome.js");
var _arraySomeJsDefault = parcelHelpers.interopDefault(_arraySomeJs);
var _cacheHasJs = require("./_cacheHas.js");
var _cacheHasJsDefault = parcelHelpers.interopDefault(_cacheHasJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new (0, _setCacheJsDefault.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, _arraySomeJsDefault.default)(other, function(othValue, othIndex) {
                if (!(0, _cacheHasJsDefault.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
exports.default = equalArrays;

},{"./_SetCache.js":"1J5sL","./_arraySome.js":"kXvJ8","./_cacheHas.js":"66YrX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1J5sL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
var _setCacheAddJs = require("./_setCacheAdd.js");
var _setCacheAddJsDefault = parcelHelpers.interopDefault(_setCacheAddJs);
var _setCacheHasJs = require("./_setCacheHas.js");
var _setCacheHasJsDefault = parcelHelpers.interopDefault(_setCacheHasJs);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, _mapCacheJsDefault.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = (0, _setCacheAddJsDefault.default);
SetCache.prototype.has = (0, _setCacheHasJsDefault.default);
exports.default = SetCache;

},{"./_MapCache.js":"iZCA7","./_setCacheAdd.js":"39Tn6","./_setCacheHas.js":"2s3eV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39Tn6":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
exports.default = setCacheAdd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2s3eV":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setCacheHas(value) {
    return this.__data__.has(value);
}
exports.default = setCacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXvJ8":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
exports.default = arraySome;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"66YrX":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function cacheHas(cache, key) {
    return cache.has(key);
}
exports.default = cacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NOrr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _mapToArrayJs = require("./_mapToArray.js");
var _mapToArrayJsDefault = parcelHelpers.interopDefault(_mapToArrayJs);
var _setToArrayJs = require("./_setToArray.js");
var _setToArrayJsDefault = parcelHelpers.interopDefault(_setToArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, _uint8ArrayJsDefault.default)(object), new (0, _uint8ArrayJsDefault.default)(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, _eqJsDefault.default)(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = (0, _mapToArrayJsDefault.default);
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, _setToArrayJsDefault.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, _equalArraysJsDefault.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
exports.default = equalByTag;

},{"./_Symbol.js":"c53Uj","./_Uint8Array.js":"cyDAa","./eq.js":"d11tM","./_equalArrays.js":"lsOdO","./_mapToArray.js":"dnqp1","./_setToArray.js":"eND1b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnqp1":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
exports.default = mapToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eND1b":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
exports.default = setToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"79mhq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getAllKeysJs = require("./_getAllKeys.js");
var _getAllKeysJsDefault = parcelHelpers.interopDefault(_getAllKeysJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = (0, _getAllKeysJsDefault.default)(object), objLength = objProps.length, othProps = (0, _getAllKeysJsDefault.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
exports.default = equalObjects;

},{"./_getAllKeys.js":"3kMpy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kMpy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysJsDefault.default), (0, _getSymbolsJsDefault.default));
}
exports.default = getAllKeys;

},{"./_baseGetAllKeys.js":"dzcVX","./_getSymbols.js":"clM4u","./keys.js":"h1d6U","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzcVX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, _isArrayJsDefault.default)(object) ? result : (0, _arrayPushJsDefault.default)(result, symbolsFunc(object));
}
exports.default = baseGetAllKeys;

},{"./_arrayPush.js":"a6JW1","./isArray.js":"dB5dn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6JW1":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
exports.default = arrayPush;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clM4u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFilterJs = require("./_arrayFilter.js");
var _arrayFilterJsDefault = parcelHelpers.interopDefault(_arrayFilterJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, _arrayFilterJsDefault.default)(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
exports.default = getSymbols;

},{"./_arrayFilter.js":"brmpQ","./stubArray.js":"bgOWo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brmpQ":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
exports.default = arrayFilter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgOWo":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubArray() {
    return [];
}
exports.default = stubArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LNQq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"56JMA","./_Map.js":"13fDv","./_Promise.js":"gv9IS","./_Set.js":"9sKcS","./_WeakMap.js":"lEW1C","./_baseGetTag.js":"9Chff","./_toSource.js":"755gJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"56JMA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "DataView");
exports.default = DataView;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gv9IS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Promise");
exports.default = Promise;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9sKcS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Set");
exports.default = Set;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEW1C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "WeakMap");
exports.default = WeakMap;

},{"./_getNative.js":"Z5FSj","./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhomB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = (0, _keysJsDefault.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, _isStrictComparableJsDefault.default)(value)
        ];
    }
    return result;
}
exports.default = getMatchData;

},{"./_isStrictComparable.js":"fvm5A","./keys.js":"h1d6U","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fvm5A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !(0, _isObjectJsDefault.default)(value);
}
exports.default = isStrictComparable;

},{"./isObject.js":"ah1Cr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knWvD":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
exports.default = matchesStrictComparable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jSEeK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
var _getJs = require("./get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if ((0, _isKeyJsDefault.default)(path) && (0, _isStrictComparableJsDefault.default)(srcValue)) return (0, _matchesStrictComparableJsDefault.default)((0, _toKeyJsDefault.default)(path), srcValue);
    return function(object) {
        var objValue = (0, _getJsDefault.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, _hasInJsDefault.default)(object, path) : (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
exports.default = baseMatchesProperty;

},{"./_baseIsEqual.js":"6HlYN","./get.js":"khbYF","./hasIn.js":"il2K5","./_isKey.js":"f9sqz","./_isStrictComparable.js":"fvm5A","./_matchesStrictComparable.js":"knWvD","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"khbYF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, _baseGetJsDefault.default)(object, path);
    return result === undefined ? defaultValue : result;
}
exports.default = get;

},{"./_baseGet.js":"12l3C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"12l3C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, _toKeyJsDefault.default)(path[index++])];
    return index && index == length ? object : undefined;
}
exports.default = baseGet;

},{"./_castPath.js":"75Zqo","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"75Zqo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _stringToPathJs = require("./_stringToPath.js");
var _stringToPathJsDefault = parcelHelpers.interopDefault(_stringToPathJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return value;
    return (0, _isKeyJsDefault.default)(value, object) ? [
        value
    ] : (0, _stringToPathJsDefault.default)((0, _toStringJsDefault.default)(value));
}
exports.default = castPath;

},{"./isArray.js":"dB5dn","./_isKey.js":"f9sqz","./_stringToPath.js":"e7FCA","./toString.js":"4if57","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f9sqz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, _isSymbolJsDefault.default)(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
exports.default = isKey;

},{"./isArray.js":"dB5dn","./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e7FCA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeCappedJs = require("./_memoizeCapped.js");
var _memoizeCappedJsDefault = parcelHelpers.interopDefault(_memoizeCappedJs);
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = (0, _memoizeCappedJsDefault.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
exports.default = stringToPath;

},{"./_memoizeCapped.js":"eYQBK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYQBK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = (0, _memoizeJsDefault.default)(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
exports.default = memoizeCapped;

},{"./memoize.js":"eD0Xs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD0Xs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"iZCA7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4if57":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseToStringJs = require("./_baseToString.js");
var _baseToStringJsDefault = parcelHelpers.interopDefault(_baseToStringJs);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : (0, _baseToStringJsDefault.default)(value);
}
exports.default = toString;

},{"./_baseToString.js":"7fpnr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7fpnr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, _isArrayJsDefault.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMapJsDefault.default)(value, baseToString) + "";
    if ((0, _isSymbolJsDefault.default)(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = baseToString;

},{"./_Symbol.js":"c53Uj","./_arrayMap.js":"1tnvM","./isArray.js":"dB5dn","./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoJfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || (0, _isSymbolJsDefault.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = toKey;

},{"./isSymbol.js":"8V8ty","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"il2K5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseHasInJs = require("./_baseHasIn.js");
var _baseHasInJsDefault = parcelHelpers.interopDefault(_baseHasInJs);
var _hasPathJs = require("./_hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && (0, _hasPathJsDefault.default)(object, path, (0, _baseHasInJsDefault.default));
}
exports.default = hasIn;

},{"./_baseHasIn.js":"16Jzn","./_hasPath.js":"iHiGa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16Jzn":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
exports.default = baseHasIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHiGa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, _toKeyJsDefault.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, _isLengthJsDefault.default)(length) && (0, _isIndexJsDefault.default)(key, length) && ((0, _isArrayJsDefault.default)(object) || (0, _isArgumentsJsDefault.default)(object));
}
exports.default = hasPath;

},{"./_castPath.js":"75Zqo","./isArguments.js":"3o5tK","./isArray.js":"dB5dn","./_isIndex.js":"axaW4","./isLength.js":"jbwyd","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8mcz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basePropertyJs = require("./_baseProperty.js");
var _basePropertyJsDefault = parcelHelpers.interopDefault(_basePropertyJs);
var _basePropertyDeepJs = require("./_basePropertyDeep.js");
var _basePropertyDeepJsDefault = parcelHelpers.interopDefault(_basePropertyDeepJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return (0, _isKeyJsDefault.default)(path) ? (0, _basePropertyJsDefault.default)((0, _toKeyJsDefault.default)(path)) : (0, _basePropertyDeepJsDefault.default)(path);
}
exports.default = property;

},{"./_baseProperty.js":"6B23c","./_basePropertyDeep.js":"gIV4H","./_isKey.js":"f9sqz","./_toKey.js":"aoJfk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6B23c":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
exports.default = baseProperty;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIV4H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return (0, _baseGetJsDefault.default)(object, path);
    };
}
exports.default = basePropertyDeep;

},{"./_baseGet.js":"12l3C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OYjy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = (0, _isArrayLikeJsDefault.default)(collection) ? Array(collection.length) : [];
    (0, _baseEachJsDefault.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
exports.default = baseMap;

},{"./_baseEach.js":"jNEvS","./isArrayLike.js":"6DRGr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tT9V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", ()=>Circle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _circleSwatch = require("./CircleSwatch");
var _circleSwatchDefault = parcelHelpers.interopDefault(_circleSwatch);
var Circle = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                display: "flex",
                flexWrap: "wrap",
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "circle-picker " + className
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _circleSwatchDefault.default), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
Circle.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    circleSize: (0, _propTypesDefault.default).number,
    circleSpacing: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Circle.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        _materialColors.red["500"],
        _materialColors.pink["500"],
        _materialColors.purple["500"],
        _materialColors.deepPurple["500"],
        _materialColors.indigo["500"],
        _materialColors.blue["500"],
        _materialColors.lightBlue["500"],
        _materialColors.cyan["500"],
        _materialColors.teal["500"],
        _materialColors.green["500"],
        _materialColors.lightGreen["500"],
        _materialColors.lime["500"],
        _materialColors.yellow["500"],
        _materialColors.amber["500"],
        _materialColors.orange["500"],
        _materialColors.deepOrange["500"],
        _materialColors.brown["500"],
        _materialColors.blueGrey["500"]
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Circle);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","material-colors":"5pcDo","../common":"f3pVr","./CircleSwatch":"h5WAH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5pcDo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "pink", ()=>pink);
parcelHelpers.export(exports, "purple", ()=>purple);
parcelHelpers.export(exports, "deepPurple", ()=>deepPurple);
parcelHelpers.export(exports, "indigo", ()=>indigo);
parcelHelpers.export(exports, "blue", ()=>blue);
parcelHelpers.export(exports, "lightBlue", ()=>lightBlue);
parcelHelpers.export(exports, "cyan", ()=>cyan);
parcelHelpers.export(exports, "teal", ()=>teal);
parcelHelpers.export(exports, "green", ()=>green);
parcelHelpers.export(exports, "lightGreen", ()=>lightGreen);
parcelHelpers.export(exports, "lime", ()=>lime);
parcelHelpers.export(exports, "yellow", ()=>yellow);
parcelHelpers.export(exports, "amber", ()=>amber);
parcelHelpers.export(exports, "orange", ()=>orange);
parcelHelpers.export(exports, "deepOrange", ()=>deepOrange);
parcelHelpers.export(exports, "brown", ()=>brown);
parcelHelpers.export(exports, "grey", ()=>grey);
parcelHelpers.export(exports, "blueGrey", ()=>blueGrey);
parcelHelpers.export(exports, "darkText", ()=>darkText);
parcelHelpers.export(exports, "lightText", ()=>lightText);
parcelHelpers.export(exports, "darkIcons", ()=>darkIcons);
parcelHelpers.export(exports, "lightIcons", ()=>lightIcons);
parcelHelpers.export(exports, "white", ()=>white);
parcelHelpers.export(exports, "black", ()=>black);
var red = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var pink = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var purple = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var deepPurple = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var indigo = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var blue = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var lightBlue = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var cyan = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var teal = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var green = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var lightGreen = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var lime = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var yellow = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var amber = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var orange = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var deepOrange = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var brown = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var grey = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var blueGrey = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var darkText = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var lightText = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var darkIcons = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var lightIcons = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var white = "#ffffff";
var black = "#000000";
exports.default = {
    red: red,
    pink: pink,
    purple: purple,
    deepPurple: deepPurple,
    indigo: indigo,
    blue: blue,
    lightBlue: lightBlue,
    cyan: cyan,
    teal: teal,
    green: green,
    lightGreen: lightGreen,
    lime: lime,
    yellow: yellow,
    amber: amber,
    orange: orange,
    deepOrange: deepOrange,
    brown: brown,
    grey: grey,
    blueGrey: blueGrey,
    darkText: darkText,
    lightText: lightText,
    darkIcons: darkIcons,
    lightIcons: lightIcons,
    white: white,
    black: black
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5WAH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleSwatch", ()=>CircleSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CircleSwatch = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: "scale(1)",
                transition: "100ms transform ease"
            },
            Swatch: {
                borderRadius: "50%",
                background: "transparent",
                boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
                transition: "100ms box-shadow ease"
            }
        },
        "hover": {
            swatch: {
                transform: "scale(1.2)"
            }
        },
        "active": {
            Swatch: {
                boxShadow: "inset 0 0 0 3px " + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color
        }
    }));
};
CircleSwatch.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
exports.default = (0, _reactcss.handleHover)(CircleSwatch);

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EiGv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chrome", ()=>Chrome);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _chromeFields = require("./ChromeFields");
var _chromeFieldsDefault = parcelHelpers.interopDefault(_chromeFields);
var _chromePointer = require("./ChromePointer");
var _chromePointerDefault = parcelHelpers.interopDefault(_chromePointer);
var _chromePointerCircle = require("./ChromePointerCircle");
var _chromePointerCircleDefault = parcelHelpers.interopDefault(_chromePointerCircle);
var Chrome = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                borderRadius: "2px",
                boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
                boxSizing: "initial",
                fontFamily: "Menlo"
            },
            saturation: {
                width: "100%",
                paddingBottom: "55%",
                position: "relative",
                borderRadius: "2px 2px 0 0",
                overflow: "hidden"
            },
            Saturation: {
                radius: "2px 2px 0 0"
            },
            body: {
                padding: "16px 16px 12px"
            },
            controls: {
                display: "flex"
            },
            color: {
                width: "32px"
            },
            swatch: {
                marginTop: "6px",
                width: "16px",
                height: "16px",
                borderRadius: "8px",
                position: "relative",
                overflow: "hidden"
            },
            active: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "8px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
                zIndex: "2"
            },
            toggles: {
                flex: "1"
            },
            hue: {
                height: "10px",
                position: "relative",
                marginBottom: "8px"
            },
            Hue: {
                radius: "2px"
            },
            alpha: {
                height: "10px",
                position: "relative"
            },
            Alpha: {
                radius: "2px"
            }
        },
        "disableAlpha": {
            color: {
                width: "22px"
            },
            alpha: {
                display: "none"
            },
            hue: {
                marginBottom: "0px"
            },
            swatch: {
                width: "10px",
                height: "10px",
                marginTop: "0px"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "chrome-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _chromePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.color
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        renderers: renderers
    }))), (0, _reactDefault.default).createElement("div", {
        style: styles.toggles
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        renderers: renderers,
        onChange: onChange
    })))), (0, _reactDefault.default).createElement((0, _chromeFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
Chrome.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    disableAlpha: (0, _propTypesDefault.default).bool,
    styles: (0, _propTypesDefault.default).object,
    defaultView: (0, _propTypesDefault.default).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
Chrome.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Chrome);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./ChromeFields":"4JtUy","./ChromePointer":"60CH6","./ChromePointerCircle":"ghSy8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4JtUy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromeFields", ()=>ChromeFields);
/* eslint-disable react/no-did-mount-set-state, no-param-reassign */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _isUndefined = require("lodash-es/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _common = require("../common");
var _unfoldMoreHorizontalIcon = require("@icons/material/UnfoldMoreHorizontalIcon");
var _unfoldMoreHorizontalIconDefault = parcelHelpers.interopDefault(_unfoldMoreHorizontalIcon);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
    _inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        _classCallCheck(this, ChromeFields);
        var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === "hex") _this.setState({
                view: "rgb"
            });
            else if (_this.state.view === "rgb") _this.setState({
                view: "hsl"
            });
            else if (_this.state.view === "hsl") {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: "hex"
                });
                else _this.setState({
                    view: "rgb"
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) _color.isValidHex(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: "hex"
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: "rgb"
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: "rgb"
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === "string" && data.s.includes("%")) data.s = data.s.replace("%", "");
                if (typeof data.l === "string" && data.l.includes("%")) data.l = data.l.replace("%", "");
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, _isUndefinedDefault.default)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, _isUndefinedDefault.default)(data.l) ? data.l : _this.props.hsl.l),
                    source: "hsl"
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = "#eee";
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = "transparent";
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    _createClass(ChromeFields, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        wrap: {
                            paddingTop: "16px",
                            display: "flex"
                        },
                        fields: {
                            flex: "1",
                            display: "flex",
                            marginLeft: "-6px"
                        },
                        field: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        alpha: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        toggle: {
                            width: "32px",
                            textAlign: "right",
                            position: "relative"
                        },
                        icon: {
                            marginRight: "-4px",
                            marginTop: "12px",
                            cursor: "pointer",
                            position: "relative"
                        },
                        iconHighlight: {
                            position: "absolute",
                            width: "24px",
                            height: "28px",
                            background: "#eee",
                            borderRadius: "4px",
                            top: "10px",
                            left: "12px",
                            display: "none"
                        },
                        input: {
                            fontSize: "11px",
                            color: "#333",
                            width: "100%",
                            borderRadius: "2px",
                            border: "none",
                            boxShadow: "inset 0 0 0 1px #dadada",
                            height: "21px",
                            textAlign: "center"
                        },
                        label: {
                            textTransform: "uppercase",
                            fontSize: "11px",
                            lineHeight: "11px",
                            color: "#969696",
                            textAlign: "center",
                            display: "block",
                            marginTop: "12px"
                        },
                        svg: {
                            fill: "#333",
                            width: "24px",
                            height: "24px",
                            border: "1px transparent solid",
                            borderRadius: "5px"
                        }
                    },
                    "disableAlpha": {
                        alpha: {
                            display: "none"
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === "hex") fields = (0, _reactDefault.default).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "hex",
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "rgb") fields = (0, _reactDefault.default).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "r",
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "g",
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "b",
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "hsl") fields = (0, _reactDefault.default).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "h",
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "s",
                    value: Math.round(this.props.hsl.s * 100) + "%",
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "l",
                    value: Math.round(this.props.hsl.l * 100) + "%",
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.wrap,
                    className: "flexbox-fix"
                }, fields, (0, _reactDefault.default).createElement("div", {
                    style: styles.toggle
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, _reactDefault.default).createElement((0, _unfoldMoreHorizontalIconDefault.default), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === "hex") return {
                    view: "rgb"
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, _reactDefault.default).Component);
ChromeFields.defaultProps = {
    view: "hex"
};
exports.default = ChromeFields;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","lodash-es/isUndefined":"fHZZI","../common":"f3pVr","@icons/material/UnfoldMoreHorizontalIcon":"gPvel","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHZZI":[function(require,module,exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isUndefined(value) {
    return value === undefined;
}
exports.default = isUndefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPvel":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("cab3160a8154bde");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return _react2.default.createElement("svg", _extends({
        viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
};

},{"cab3160a8154bde":"9njXz"}],"60CH6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointer", ()=>ChromePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointer = function ChromePointer() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                transform: "translate(-6px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = ChromePointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ghSy8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointerCircle", ()=>ChromePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointerCircle = function ChromePointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = ChromePointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4fCZ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compact", ()=>Compact);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _compactColor = require("./CompactColor");
var _compactColorDefault = parcelHelpers.interopDefault(_compactColor);
var _compactFields = require("./CompactFields");
var _compactFieldsDefault = parcelHelpers.interopDefault(_compactFields);
var Compact = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            Compact: {
                background: "#f6f6f6",
                radius: "4px"
            },
            compact: {
                paddingTop: "5px",
                paddingLeft: "5px",
                boxSizing: "initial",
                width: "240px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else onChange(data, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.compact,
        className: "compact-picker " + className
    }, (0, _reactDefault.default).createElement("div", null, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _compactColorDefault.default), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    })), (0, _reactDefault.default).createElement((0, _compactFieldsDefault.default), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
Compact.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Compact.defaultProps = {
    colors: [
        "#4D4D4D",
        "#999999",
        "#FFFFFF",
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#333333",
        "#808080",
        "#cccccc",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#666666",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Compact);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","./CompactColor":"diC19","./CompactFields":"7Lbwh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"diC19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactColor", ()=>CompactColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var CompactColor = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            color: {
                background: color,
                width: "15px",
                height: "15px",
                float: "left",
                marginRight: "5px",
                marginBottom: "5px",
                position: "relative",
                cursor: "pointer"
            },
            dot: {
                absolute: "5px 5px 5px 5px",
                background: _color.getContrastingColor(color),
                borderRadius: "50%",
                opacity: "0"
            }
        },
        "active": {
            dot: {
                opacity: "1"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            dot: {
                background: "#000"
            }
        },
        "transparent": {
            dot: {
                background: "#000"
            }
        }
    }, {
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.dot
    }));
};
exports.default = CompactColor;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Lbwh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactFields", ()=>CompactFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CompactFields = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            fields: {
                display: "flex",
                paddingBottom: "6px",
                paddingRight: "5px",
                position: "relative"
            },
            active: {
                position: "absolute",
                top: "6px",
                left: "5px",
                height: "9px",
                width: "9px",
                background: hex
            },
            HEXwrap: {
                flex: "6",
                position: "relative"
            },
            HEXinput: {
                width: "80%",
                padding: "0px",
                paddingLeft: "20%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            HEXlabel: {
                display: "none"
            },
            RGBwrap: {
                flex: "3",
                position: "relative"
            },
            RGBinput: {
                width: "70%",
                padding: "0px",
                paddingLeft: "30%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            RGBlabel: {
                position: "absolute",
                top: "3px",
                left: "0px",
                lineHeight: "16px",
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#999"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else onChange({
            hex: data.hex,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }));
};
exports.default = CompactFields;

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5a9tU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Github", ()=>Github);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _githubSwatch = require("./GithubSwatch");
var _githubSwatchDefault = parcelHelpers.interopDefault(_githubSwatch);
var Github = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                borderRadius: "4px",
                position: "relative",
                padding: "5px",
                display: "flex",
                flexWrap: "wrap"
            },
            triangle: {
                position: "absolute",
                border: "7px solid transparent",
                borderBottomColor: "#fff"
            },
            triangleShadow: {
                position: "absolute",
                border: "8px solid transparent",
                borderBottomColor: "rgba(0,0,0,0.15)"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-14px",
                left: "10px"
            },
            triangleShadow: {
                top: "-16px",
                left: "9px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-14px",
                right: "10px"
            },
            triangleShadow: {
                top: "-16px",
                right: "9px"
            }
        },
        "bottom-left-triangle": {
            triangle: {
                top: "35px",
                left: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                left: "9px",
                transform: "rotate(180deg)"
            }
        },
        "bottom-right-triangle": {
            triangle: {
                top: "35px",
                right: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                right: "9px",
                transform: "rotate(180deg)"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right",
        "bottom-left-triangle": triangle === "bottom-left",
        "bottom-right-triangle": triangle === "bottom-right"
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "github-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.triangle
    }), (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _githubSwatchDefault.default), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
Github.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        "hide",
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]),
    styles: (0, _propTypesDefault.default).object
};
Github.defaultProps = {
    width: 200,
    colors: [
        "#B80000",
        "#DB3E00",
        "#FCCB00",
        "#008B02",
        "#006B76",
        "#1273DE",
        "#004DCF",
        "#5300EB",
        "#EB9694",
        "#FAD0C3",
        "#FEF3BD",
        "#C1E1C5",
        "#BEDADC",
        "#C4DEF6",
        "#BED3F3",
        "#D4C4FB"
    ],
    triangle: "top-left",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Github);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","../common":"f3pVr","./GithubSwatch":"Ge9C9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Ge9C9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GithubSwatch", ()=>GithubSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var GithubSwatch = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
    };
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatch: {
                width: "25px",
                height: "25px",
                fontSize: "0"
            }
        },
        "hover": {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
exports.default = (0, _reactcss.handleHover)(GithubSwatch);

},{"react":"9njXz","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRmaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HuePicker", ()=>HuePicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _huePointer = require("./HuePointer");
var _huePointerDefault = parcelHelpers.interopDefault(_huePointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var HuePicker = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "hue-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.Hue), _extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
HuePicker.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
HuePicker.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, _huePointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(HuePicker);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./HuePointer":"kIjBW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIjBW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jlcVF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Material", ()=>Material);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Material = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            material: {
                width: "98px",
                height: "98px",
                padding: "16px",
                fontFamily: "Roboto"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "2px solid " + hex,
                outline: "none",
                height: "30px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "1px solid #eee",
                outline: "none",
                height: "30px"
            },
            RGBlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            split: {
                display: "flex",
                marginRight: "-10px",
                paddingTop: "11px"
            },
            third: {
                flex: "1",
                paddingRight: "10px"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        styles: passedStyles
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.material,
        className: "material-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.split,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    })))));
};
exports.default = (0, _common.ColorWrap)(Material);

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grH58":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Photoshop", ()=>Photoshop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _photoshopFields = require("./PhotoshopFields");
var _photoshopFieldsDefault = parcelHelpers.interopDefault(_photoshopFields);
var _photoshopPointerCircle = require("./PhotoshopPointerCircle");
var _photoshopPointerCircleDefault = parcelHelpers.interopDefault(_photoshopPointerCircle);
var _photoshopPointer = require("./PhotoshopPointer");
var _photoshopPointerDefault = parcelHelpers.interopDefault(_photoshopPointer);
var _photoshopButton = require("./PhotoshopButton");
var _photoshopButtonDefault = parcelHelpers.interopDefault(_photoshopButton);
var _photoshopPreviews = require("./PhotoshopPreviews");
var _photoshopPreviewsDefault = parcelHelpers.interopDefault(_photoshopPreviews);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
    _inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        _classCallCheck(this, Photoshop);
        var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    _createClass(Photoshop, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? "" : _props$className;
                var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
                    "default": {
                        picker: {
                            background: "#DCDCDC",
                            borderRadius: "4px",
                            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                            boxSizing: "initial",
                            width: "513px"
                        },
                        head: {
                            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                            borderBottom: "1px solid #B1B1B1",
                            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                            height: "23px",
                            lineHeight: "24px",
                            borderRadius: "4px 4px 0 0",
                            fontSize: "13px",
                            color: "#4D4D4D",
                            textAlign: "center"
                        },
                        body: {
                            padding: "15px 15px 0",
                            display: "flex"
                        },
                        saturation: {
                            width: "256px",
                            height: "256px",
                            position: "relative",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0",
                            overflow: "hidden"
                        },
                        hue: {
                            position: "relative",
                            height: "256px",
                            width: "19px",
                            marginLeft: "10px",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0"
                        },
                        controls: {
                            width: "180px",
                            marginLeft: "10px"
                        },
                        top: {
                            display: "flex"
                        },
                        previews: {
                            width: "60px"
                        },
                        actions: {
                            flex: "1",
                            marginLeft: "20px"
                        }
                    }
                }, passedStyles));
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.picker,
                    className: "photoshop-picker " + className
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.head
                }, this.props.header), (0, _reactDefault.default).createElement("div", {
                    style: styles.body,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.saturation
                }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, _photoshopPointerCircleDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement((0, _common.Hue), {
                    direction: "vertical",
                    hsl: this.props.hsl,
                    pointer: (0, _photoshopPointerDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.controls
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.top,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.previews
                }, (0, _reactDefault.default).createElement((0, _photoshopPreviewsDefault.default), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.actions
                }, (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: "OK",
                    onClick: this.props.onAccept,
                    active: true
                }), (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: "Cancel",
                    onClick: this.props.onCancel
                }), (0, _reactDefault.default).createElement((0, _photoshopFieldsDefault.default), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, _reactDefault.default).Component);
Photoshop.propTypes = {
    header: (0, _propTypesDefault.default).string,
    styles: (0, _propTypesDefault.default).object
};
Photoshop.defaultProps = {
    header: "Color Picker",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Photoshop);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./PhotoshopFields":"ehPj5","./PhotoshopPointerCircle":"dbUrt","./PhotoshopPointer":"hjrq1","./PhotoshopButton":"hHf6K","./PhotoshopPreviews":"e6EKG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehPj5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPicker", ()=>PhotoshopPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var PhotoshopPicker = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            fields: {
                paddingTop: "5px",
                paddingBottom: "9px",
                width: "80px",
                position: "relative"
            },
            divider: {
                height: "5px"
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                marginLeft: "40%",
                width: "40%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "5px",
                fontSize: "13px",
                paddingLeft: "3px",
                marginRight: "10px"
            },
            RGBlabel: {
                left: "0px",
                top: "0px",
                width: "34px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px",
                position: "absolute"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                marginLeft: "20%",
                width: "80%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "6px",
                fontSize: "13px",
                paddingLeft: "3px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "14px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px"
            },
            fieldSymbols: {
                position: "absolute",
                top: "5px",
                right: "-7px",
                fontSize: "13px"
            },
            symbol: {
                height: "20px",
                lineHeight: "22px",
                paddingBottom: "7px"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data["#"]) _color.isValidHex(data["#"]) && onChange({
            hex: data["#"],
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: "hsv"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.fields
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "h",
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "s",
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "v",
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "#",
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.fieldSymbols
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.symbol
    }, "\xb0"), (0, _reactDefault.default).createElement("div", {
        style: styles.symbol
    }, "%"), (0, _reactDefault.default).createElement("div", {
        style: styles.symbol
    }, "%")));
};
exports.default = PhotoshopPicker;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbUrt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        },
        "black-outline": {
            picker: {
                boxShadow: "inset 0 0 0 1px #000"
            }
        }
    }, {
        "black-outline": hsl.l > 0.5
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = PhotoshopPointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hjrq1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "4px 0 4px 6px",
                borderColor: "transparent transparent transparent #fff",
                position: "absolute",
                top: "1px",
                left: "1px"
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "5px 0 5px 8px",
                borderColor: "transparent transparent transparent #555"
            },
            left: {
                Extend: "triangleBorder",
                transform: "translate(-13px, -4px)"
            },
            leftInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            },
            right: {
                Extend: "triangleBorder",
                transform: "translate(20px, -14px) rotate(180deg)"
            },
            rightInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.pointer
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.left
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.leftInside
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.right
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.rightInside
    })));
};
exports.default = PhotoshopPointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHf6K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopButton", ()=>PhotoshopButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopButton = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            button: {
                backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
                border: "1px solid #878787",
                borderRadius: "2px",
                height: "20px",
                boxShadow: "0 1px 0 0 #EAEAEA",
                fontSize: "14px",
                color: "#000",
                lineHeight: "20px",
                textAlign: "center",
                marginBottom: "10px",
                cursor: "pointer"
            }
        },
        "active": {
            button: {
                boxShadow: "0 0 0 1px #878787"
            }
        }
    }, {
        active: active
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
exports.default = PhotoshopButton;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e6EKG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPreviews", ()=>PhotoshopPreviews);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatches: {
                border: "1px solid #B3B3B3",
                borderBottom: "1px solid #F0F0F0",
                marginBottom: "2px",
                marginTop: "1px"
            },
            new: {
                height: "34px",
                background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
            },
            current: {
                height: "34px",
                background: currentColor,
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
            },
            label: {
                fontSize: "14px",
                color: "#000",
                textAlign: "center"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", null, (0, _reactDefault.default).createElement("div", {
        style: styles.label
    }, "new"), (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.new
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.current
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.label
    }, "current"));
};
exports.default = PhotoshopPreviews;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"761c2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sketch", ()=>Sketch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sketchFields = require("./SketchFields");
var _sketchFieldsDefault = parcelHelpers.interopDefault(_sketchFields);
var _sketchPresetColors = require("./SketchPresetColors");
var _sketchPresetColorsDefault = parcelHelpers.interopDefault(_sketchPresetColors);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Sketch = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": _extends({
            picker: {
                width: width,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, passedStyles),
        "disableAlpha": {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "sketch-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.sliders
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, _reactDefault.default).createElement("div", {
        style: styles.color
    }, (0, _reactDefault.default).createElement((0, _common.Checkboard), null), (0, _reactDefault.default).createElement("div", {
        style: styles.activeColor
    }))), (0, _reactDefault.default).createElement((0, _sketchFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, _reactDefault.default).createElement((0, _sketchPresetColorsDefault.default), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
Sketch.propTypes = {
    disableAlpha: (0, _propTypesDefault.default).bool,
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object
};
Sketch.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
};
exports.default = (0, _common.ColorWrap)(Sketch);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./SketchFields":"d9y7k","./SketchPresetColors":"d3ITg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9y7k":[function(require,module,exports) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchFields", ()=>SketchFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var SketchFields = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
exports.default = SketchFields;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3ITg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchPresetColors", ()=>SketchPresetColors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var SketchPresetColors = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return (0, _reactDefault.default).createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, (0, _reactDefault.default).createElement((0, _common.Swatch), _extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
SketchPresetColors.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            color: (0, _propTypesDefault.default).string,
            title: (0, _propTypesDefault.default).string
        })
    ])).isRequired
};
exports.default = SketchPresetColors;

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LOOqi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sliderSwatches = require("./SliderSwatches");
var _sliderSwatchesDefault = parcelHelpers.interopDefault(_sliderSwatches);
var _sliderPointer = require("./SliderPointer");
var _sliderPointerDefault = parcelHelpers.interopDefault(_sliderPointer);
var Slider = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            hue: {
                height: "12px",
                position: "relative"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement("div", {
        style: styles.wrap || {},
        className: "slider-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchesDefault.default), {
        hsl: hsl,
        onClick: onChange
    })));
};
Slider.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
Slider.defaultProps = {
    pointer: (0, _sliderPointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Slider);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./SliderSwatches":"676z7","./SliderPointer":"JmgA6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"676z7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatches", ()=>SliderSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _sliderSwatch = require("./SliderSwatch");
var _sliderSwatchDefault = parcelHelpers.interopDefault(_sliderSwatch);
var SliderSwatches = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatches: {
                marginTop: "20px"
            },
            swatch: {
                boxSizing: "border-box",
                width: "20%",
                paddingRight: "1px",
                float: "left"
            },
            clear: {
                clear: "both"
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    }));
};
exports.default = SliderSwatches;

},{"react":"9njXz","reactcss":"7O6YP","./SliderSwatch":"9gr7X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gr7X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatch", ()=>SliderSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderSwatch = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatch: {
                height: "12px",
                background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
                cursor: "pointer"
            }
        },
        "first": {
            swatch: {
                borderRadius: "2px 0 0 2px"
            }
        },
        "last": {
            swatch: {
                borderRadius: "0 2px 2px 0"
            }
        },
        "active": {
            swatch: {
                transform: "scaleY(1.8)",
                borderRadius: "3.6px/2px"
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: "hsl"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatch,
        onClick: handleClick
    });
};
exports.default = SliderSwatch;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"JmgA6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "14px",
                height: "14px",
                borderRadius: "6px",
                transform: "translate(-7px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"9njXz","reactcss":"7O6YP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"in5kC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatches", ()=>Swatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _swatchesGroup = require("./SwatchesGroup");
var _swatchesGroupDefault = parcelHelpers.interopDefault(_swatchesGroup);
var Swatches = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: "scroll"
            },
            body: {
                padding: "16px 0 6px 16px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "swatches-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.Raised), null, (0, _reactDefault.default).createElement("div", {
        style: styles.overflow
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(group) {
        return (0, _reactDefault.default).createElement((0, _swatchesGroupDefault.default), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    })))));
};
Swatches.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    height: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)),
    styles: (0, _propTypesDefault.default).object
};
Swatches.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            _materialColors.red["900"],
            _materialColors.red["700"],
            _materialColors.red["500"],
            _materialColors.red["300"],
            _materialColors.red["100"]
        ],
        [
            _materialColors.pink["900"],
            _materialColors.pink["700"],
            _materialColors.pink["500"],
            _materialColors.pink["300"],
            _materialColors.pink["100"]
        ],
        [
            _materialColors.purple["900"],
            _materialColors.purple["700"],
            _materialColors.purple["500"],
            _materialColors.purple["300"],
            _materialColors.purple["100"]
        ],
        [
            _materialColors.deepPurple["900"],
            _materialColors.deepPurple["700"],
            _materialColors.deepPurple["500"],
            _materialColors.deepPurple["300"],
            _materialColors.deepPurple["100"]
        ],
        [
            _materialColors.indigo["900"],
            _materialColors.indigo["700"],
            _materialColors.indigo["500"],
            _materialColors.indigo["300"],
            _materialColors.indigo["100"]
        ],
        [
            _materialColors.blue["900"],
            _materialColors.blue["700"],
            _materialColors.blue["500"],
            _materialColors.blue["300"],
            _materialColors.blue["100"]
        ],
        [
            _materialColors.lightBlue["900"],
            _materialColors.lightBlue["700"],
            _materialColors.lightBlue["500"],
            _materialColors.lightBlue["300"],
            _materialColors.lightBlue["100"]
        ],
        [
            _materialColors.cyan["900"],
            _materialColors.cyan["700"],
            _materialColors.cyan["500"],
            _materialColors.cyan["300"],
            _materialColors.cyan["100"]
        ],
        [
            _materialColors.teal["900"],
            _materialColors.teal["700"],
            _materialColors.teal["500"],
            _materialColors.teal["300"],
            _materialColors.teal["100"]
        ],
        [
            "#194D33",
            _materialColors.green["700"],
            _materialColors.green["500"],
            _materialColors.green["300"],
            _materialColors.green["100"]
        ],
        [
            _materialColors.lightGreen["900"],
            _materialColors.lightGreen["700"],
            _materialColors.lightGreen["500"],
            _materialColors.lightGreen["300"],
            _materialColors.lightGreen["100"]
        ],
        [
            _materialColors.lime["900"],
            _materialColors.lime["700"],
            _materialColors.lime["500"],
            _materialColors.lime["300"],
            _materialColors.lime["100"]
        ],
        [
            _materialColors.yellow["900"],
            _materialColors.yellow["700"],
            _materialColors.yellow["500"],
            _materialColors.yellow["300"],
            _materialColors.yellow["100"]
        ],
        [
            _materialColors.amber["900"],
            _materialColors.amber["700"],
            _materialColors.amber["500"],
            _materialColors.amber["300"],
            _materialColors.amber["100"]
        ],
        [
            _materialColors.orange["900"],
            _materialColors.orange["700"],
            _materialColors.orange["500"],
            _materialColors.orange["300"],
            _materialColors.orange["100"]
        ],
        [
            _materialColors.deepOrange["900"],
            _materialColors.deepOrange["700"],
            _materialColors.deepOrange["500"],
            _materialColors.deepOrange["300"],
            _materialColors.deepOrange["100"]
        ],
        [
            _materialColors.brown["900"],
            _materialColors.brown["700"],
            _materialColors.brown["500"],
            _materialColors.brown["300"],
            _materialColors.brown["100"]
        ],
        [
            _materialColors.blueGrey["900"],
            _materialColors.blueGrey["700"],
            _materialColors.blueGrey["500"],
            _materialColors.blueGrey["300"],
            _materialColors.blueGrey["100"]
        ],
        [
            "#000000",
            "#525252",
            "#969696",
            "#D9D9D9",
            "#FFFFFF"
        ]
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Swatches);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","material-colors":"5pcDo","../common":"f3pVr","./SwatchesGroup":"cCLCe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cCLCe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesGroup", ()=>SwatchesGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _swatchesColor = require("./SwatchesColor");
var _swatchesColorDefault = parcelHelpers.interopDefault(_swatchesColor);
var SwatchesGroup = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            group: {
                paddingBottom: "10px",
                width: "40px",
                float: "left",
                marginRight: "10px"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.group
    }, (0, _mapDefault.default)(group, function(color, i) {
        return (0, _reactDefault.default).createElement((0, _swatchesColorDefault.default), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
exports.default = SwatchesGroup;

},{"react":"9njXz","reactcss":"7O6YP","lodash-es/map":"8jKVV","./SwatchesColor":"cJdP3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJdP3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesColor", ()=>SwatchesColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var _checkIcon = require("@icons/material/CheckIcon");
var _checkIconDefault = parcelHelpers.interopDefault(_checkIcon);
var SwatchesColor = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            color: {
                width: "40px",
                height: "24px",
                cursor: "pointer",
                background: color,
                marginBottom: "1px"
            },
            check: {
                color: _color.getContrastingColor(color),
                marginLeft: "8px",
                display: "none"
            }
        },
        "first": {
            color: {
                overflow: "hidden",
                borderRadius: "2px 2px 0 0"
            }
        },
        "last": {
            color: {
                overflow: "hidden",
                borderRadius: "0 0 2px 2px"
            }
        },
        "active": {
            check: {
                display: "block"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            check: {
                color: "#333"
            }
        },
        "transparent": {
            check: {
                color: "#333"
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.check
    }, (0, _reactDefault.default).createElement((0, _checkIconDefault.default), null)));
};
exports.default = SwatchesColor;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@icons/material/CheckIcon":"26Pe1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"26Pe1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("b7292f2d749daff7");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return _react2.default.createElement("svg", _extends({
        viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};

},{"b7292f2d749daff7":"9njXz"}],"lypvp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Twitter", ()=>Twitter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Twitter = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "0 solid rgba(0,0,0,0.25)",
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                borderRadius: "4px",
                position: "relative"
            },
            body: {
                padding: "15px 9px 9px 15px"
            },
            label: {
                fontSize: "18px",
                color: "#fff"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent #fff transparent",
                position: "absolute"
            },
            triangleShadow: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
                position: "absolute"
            },
            hash: {
                background: "#F0F0F0",
                height: "30px",
                width: "30px",
                borderRadius: "4px 0 0 4px",
                float: "left",
                color: "#98A1A4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            input: {
                width: "100px",
                fontSize: "14px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "28px",
                boxShadow: "inset 0 0 0 1px #F0F0F0",
                boxSizing: "content-box",
                borderRadius: "0 4px 4px 0",
                float: "left",
                paddingLeft: "8px"
            },
            swatch: {
                width: "30px",
                height: "30px",
                float: "left",
                borderRadius: "4px",
                margin: "0 6px 6px 0"
            },
            clear: {
                clear: "both"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-10px",
                left: "12px"
            },
            triangleShadow: {
                top: "-11px",
                left: "12px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-10px",
                right: "12px"
            },
            triangleShadow: {
                top: "-11px",
                right: "12px"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right"
    });
    var handleChange = function handleChange(hexcode, e) {
        _color.isValidHex(hexcode) && onChange({
            hex: hexcode,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "twitter-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(c, i) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.hash
    }, "#"), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    })));
};
Twitter.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    triangle: (0, _propTypesDefault.default).oneOf([
        "hide",
        "top-left",
        "top-right"
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Twitter.defaultProps = {
    width: 276,
    colors: [
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ],
    triangle: "top-left",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Twitter);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/map":"8jKVV","lodash-es/merge":"jQl8F","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bK2GH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Google", ()=>Google);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _googlePointerCircle = require("./GooglePointerCircle");
var _googlePointerCircleDefault = parcelHelpers.interopDefault(_googlePointerCircle);
var _googlePointer = require("./GooglePointer");
var _googlePointerDefault = parcelHelpers.interopDefault(_googlePointer);
var _googleFields = require("./GoogleFields");
var _googleFieldsDefault = parcelHelpers.interopDefault(_googleFields);
var Google = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                border: "1px solid #dfe1e5",
                boxSizing: "initial",
                display: "flex",
                flexWrap: "wrap",
                borderRadius: "8px 8px 0px 0px"
            },
            head: {
                height: "57px",
                width: "100%",
                paddingTop: "16px",
                paddingBottom: "16px",
                paddingLeft: "16px",
                fontSize: "20px",
                boxSizing: "border-box",
                fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
            },
            saturation: {
                width: "70%",
                padding: "0px",
                position: "relative",
                overflow: "hidden"
            },
            swatch: {
                width: "30%",
                height: "228px",
                padding: "0px",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
                position: "relative",
                overflow: "hidden"
            },
            body: {
                margin: "auto",
                width: "95%"
            },
            controls: {
                display: "flex",
                boxSizing: "border-box",
                height: "52px",
                paddingTop: "22px"
            },
            color: {
                width: "32px"
            },
            hue: {
                height: "8px",
                position: "relative",
                margin: "0px 16px 0px 16px",
                width: "100%"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "google-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.head
    }, header), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _googlePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        radius: "4px",
        pointer: (0, _googlePointerDefault.default),
        onChange: onChange
    }))), (0, _reactDefault.default).createElement((0, _googleFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
Google.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object,
    header: (0, _propTypesDefault.default).string
};
Google.defaultProps = {
    width: 652,
    styles: {},
    header: "Color picker"
};
exports.default = (0, _common.ColorWrap)(Google);

},{"react":"9njXz","prop-types":"bnNSm","reactcss":"7O6YP","lodash-es/merge":"jQl8F","../common":"f3pVr","./GooglePointerCircle":"d9qLv","./GooglePointer":"9U4G4","./GoogleFields":"i3CDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9qLv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointerCircle", ()=>GooglePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointerCircle = function GooglePointerCircle(props) {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                border: "2px #fff solid",
                transform: "translate(-12px, -13px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
GooglePointerCircle.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointerCircle.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointerCircle;

},{"react":"9njXz","reactcss":"7O6YP","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9U4G4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointer", ()=>GooglePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointer = function GooglePointer(props) {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                transform: "translate(-10px, -7px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
                border: "2px white solid"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
GooglePointer.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointer.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointer;

},{"react":"9njXz","reactcss":"7O6YP","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3CDE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleFields", ()=>GoogleFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var GoogleFields = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(",");
            _color.isvalidColorString(data.rgb, "rgb") && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: "rgb"
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(",");
            if (_color.isvalidColorString(data.hsv, "hsv")) {
                _values[2] = _values[2].replace("%", "");
                _values[1] = _values[1].replace("%", "");
                _values[0] = _values[0].replace("\xb0", "");
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: "hsv"
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(",");
            if (_color.isvalidColorString(data.hsl, "hsl")) {
                _values2[2] = _values2[2].replace("%", "");
                _values2[1] = _values2[1].replace("%", "");
                _values2[0] = _values2[0].replace("\xb0", "");
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: "hsl"
                }, e);
            }
        }
    };
    var styles = (0, _reactcssDefault.default)({
        "default": {
            wrap: {
                display: "flex",
                height: "100px",
                marginTop: "4px"
            },
            fields: {
                width: "100%"
            },
            column: {
                paddingTop: "10px",
                display: "flex",
                justifyContent: "space-between"
            },
            double: {
                padding: "0px 4.4px",
                boxSizing: "border-box"
            },
            input: {
                width: "100%",
                height: "38px",
                boxSizing: "border-box",
                padding: "4px 10% 3px",
                textAlign: "center",
                border: "1px solid #dadce0",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            input2: {
                height: "38px",
                width: "100%",
                border: "1px solid #dadce0",
                boxSizing: "border-box",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                paddingLeft: "10px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label: {
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "35px",
                top: "-6px",
                left: "0",
                right: "0",
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label2: {
                left: "10px",
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "32px",
                top: "-6px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            single: {
                flexGrow: "1",
                margin: "0px 4.4px"
            }
        }
    });
    var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
    var hslValue = Math.round(hsl.h) + "\xb0, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
    var hsvValue = Math.round(hsv.h) + "\xb0, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
    return (0, _reactDefault.default).createElement("div", {
        style: styles.wrap,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.fields
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.column
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "rgb",
        value: rgbValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsv",
        value: hsvValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsl",
        value: hslValue,
        onChange: handleChange
    })))));
};
exports.default = GoogleFields;

},{"react":"9njXz","reactcss":"7O6YP","../../helpers/color":"lNUGR","../common":"f3pVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byZ6X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorOptions", ()=>colorOptions);
parcelHelpers.export(exports, "gaugeRangeColorOptions", ()=>gaugeRangeColorOptions);
const colorOptions = [
    "#85BFCC",
    "#FFAEA4",
    "#4196D6",
    "#09D8D8",
    "#DE473A",
    "#89261D",
    "#262E72",
    "#07A7A7",
    "#74D17D",
    "#1A7C25",
    "#F36E41",
    "#914AE5",
    "#AF431E",
    "#56E242"
];
const gaugeRangeColorOptions = [
    "#de473a",
    "#f24631",
    "#f36e41",
    "#ffff00",
    "#ffef00",
    "#f7ed61",
    "#32b740",
    "#70bc7c",
    "#74d17d"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Fa08":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react"); // , useEffect, useMemo, useState
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDropzone = require("react-dropzone");
var _reactstrap = require("reactstrap");
var _axios = require("axios");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _debouncePromise = require("debounce-promise");
var _debouncePromiseDefault = parcelHelpers.interopDefault(_debouncePromise);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _widgetTypes = require("../../Constants/WidgetTypes");
var _selectStyles = require("../../Styles/SelectStyles");
var _zIndex = require("../../Styles/Z-INDEX");
exports.default = /*#__PURE__*/ (0, _react.memo)(ConfigureImageWidget);
const baseStyle = {
    backgroundColor: "#fafafa",
    borderWidth: 3,
    borderRadius: 5,
    borderColor: "var(--brand-primary)",
    borderStyle: "dashed",
    color: "var(--muted-gray)",
    outline: "none",
    transition: "border .24s ease-in-out"
};
const acceptStyle = {
    borderColor: "var(--alert-confirmation)"
};
const focusedStyle = {
    borderColor: "var(--brand-primary-alert)"
};
const rejectStyle = {
    borderColor: "var(--warning-yellow)"
};
function ConfigureImageWidget(props) {
    const { activeImageCoordinate, clearImage, datapointsMap, gtemplateID, handleAddImageOverlaySignal, handleCoordinateClick, handleImageClick, handleImageSelect, handleRemoveImageOverlaySignal, image, imageOverlayRef, isEdit, orgID, toggleImageOverlayModal, widgetType } = props;
    const accept = {
        "image/*": []
    };
    const onDrop = (0, _react.useCallback)((acceptedFiles)=>{
        handleImageSelect(acceptedFiles);
    }, [
        handleImageSelect
    ]);
    const { getRootProps, getInputProps, isDragAccept, isDragActive, isDragReject, isFocused } = (0, _reactDropzone.useDropzone)({
        accept,
        maxSize: 5000000,
        multiple: false,
        onDrop
    });
    const style = (0, _react.useMemo)(()=>({
            ...baseStyle,
            ...isFocused ? focusedStyle : {},
            ...isDragAccept ? acceptStyle : {},
            ...isDragReject ? rejectStyle : {}
        }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);
    return widgetType === (0, _widgetTypes.IMAGE) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3995395406 flex-fill row no-gutters align-items-stretch justify-content-center position-relative",
        children: [
            !isEdit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !image,
                onClick: clearImage,
                style: {
                    right: 0,
                    top: 0,
                    zIndex: (0, _zIndex.COMPONENT_OVERRIDE)
                },
                className: "jsx-3995395406 " + ((image ? "btn btn-link p-0 position-absolute" : "d-none") || ""),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    className: "text-danger",
                    icon: (0, _freeSolidSvgIcons.faTimes)
                })
            }) : null,
            image ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3995395406 position-absolute h-100 w-100 d-flex align-items-center justify-content-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    alt: "overlay",
                    id: "image-overlay",
                    onClick: handleImageClick,
                    onKeyDown: handleImageClick,
                    ref: imageOverlayRef,
                    src: image,
                    style: {
                        cursor: "grab"
                    },
                    className: "jsx-3995395406 img-fluid mx-auto mh-100 rounded rounded-lg"
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ...getRootProps({
                    style
                }),
                className: "jsx-3995395406 col-12 d-flex flex-column align-items-center justify-content-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ...getInputProps(),
                        className: "jsx-3995395406"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-3995395406 mb-0",
                        children: isDragActive ? "Drop the file here ..." : `Drag 'n' drop a photo here, or click to select one`
                    })
                ]
            }),
            props.imageCoordinatesMap?.size ? [
                ...props.imageCoordinatesMap.entries()
            ].map(([coordinates, config])=>{
                const [x, y] = coordinates.split("-");
                const { datapoint: { label: collectionName } = {}, signal: { label: signalName } = {} } = config || {};
                const { className: overlayMarkerClassName, styles: overlayMarkerStyle } = getOverlayMarkerStyle(x, y);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    "data-for": coordinates,
                    "data-tip": true,
                    onClick: ()=>handleCoordinateClick(x, y, config),
                    className: "jsx-3995395406 " + `btn p-0 position-fixed shadow-lg overlay-marker ${overlayMarkerClassName}`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactTooltipDefault.default), {
                            backgroundColor: "var(--brand-primary)",
                            id: coordinates,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-3995395406 mb-0 text-white text-center",
                                    children: collectionName
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-3995395406 mb-0 text-white text-center",
                                    children: signalName
                                })
                            ]
                        }),
                        overlayMarkerStyle
                    ]
                }, coordinates);
            }) : null,
            props.activeImageCoordinate?.size ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageOverlayModal, {
                activeImageCoordinate: activeImageCoordinate,
                datapointsMap: datapointsMap,
                gtemplateID: gtemplateID,
                handleAddImageOverlaySignal: handleAddImageOverlaySignal,
                handleRemoveImageOverlaySignal: handleRemoveImageOverlaySignal,
                orgID: orgID,
                toggleImageOverlayModal: toggleImageOverlayModal
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3995395406",
                children: "@-webkit-keyframes pulse{0%{background-color:var(--brand-primary);}100%{background-color:var(--brand-primary-alert);}}@keyframes pulse{0%{background-color:var(--brand-primary);}100%{background-color:var(--brand-primary-alert);}}"
            })
        ]
    }) : null;
}
ConfigureImageWidget.propTypes = {
    activeImageCoordinate: (0, _propTypesDefault.default).object,
    clearImage: (0, _propTypesDefault.default).func,
    datapointsMap: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    gtemplateID: (0, _propTypesDefault.default).string,
    handleAddImageOverlaySignal: (0, _propTypesDefault.default).func,
    handleCoordinateClick: (0, _propTypesDefault.default).func,
    handleImageClick: (0, _propTypesDefault.default).func,
    handleImageSelect: (0, _propTypesDefault.default).func,
    handleRemoveImageOverlaySignal: (0, _propTypesDefault.default).func,
    image: (0, _propTypesDefault.default).string,
    imageCoordinatesMap: (0, _propTypesDefault.default).object,
    imageOverlayRef: (0, _propTypesDefault.default).object,
    isEdit: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    toggleImageOverlayModal: (0, _propTypesDefault.default).func,
    widgetType: (0, _propTypesDefault.default).string
};
function ImageOverlayModal(props) {
    const [x, y, imageOverlay] = [
        ...props.activeImageCoordinate.values()
    ];
    const [datapoint, setCollection] = (0, _react.useState)(imageOverlay?.datapoint);
    const [signal, setSignal] = (0, _react.useState)(imageOverlay?.signal);
    const [error, setError] = (0, _react.useState)("");
    const [requestPending, setRequestPending] = (0, _react.useState)(false);
    const service = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    let source = (0, _axios.CancelToken).source();
    const fetchOutputSignals = async (searchTerm)=>{
        try {
            setRequestPending(true);
            const params = {
                limit: 100,
                orgID: props.orgID,
                search: "name",
                searchTerm
            };
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const { data } = await service.searchOutputSignals(props.gtemplateID, params, source.token);
            setRequestPending(false);
            return data.map((os)=>({
                    label: os.name,
                    value: os
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const reqError = err.response?.data?.message ?? err.message;
            setError(reqError);
            setRequestPending(false);
            return [];
        }
    };
    (0, _react.useEffect)(()=>source?.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdrop: "static",
        centered: true,
        isOpen: !!props.activeImageCoordinate.size,
        toggle: props.toggleImageOverlayModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0 modal-title-text",
                toggle: props.toggleImageOverlayModal,
                children: "Choose signal to display on image"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "col-12 form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "signalCollection",
                                    className: "modal-inputlabel-text",
                                    children: "Signal Collection"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                    isSearchable: true,
                                    maxMenuHeight: 150,
                                    name: "signalCollection",
                                    onChange: setCollection,
                                    options: props.datapointsMap,
                                    placeholder: "Select Collection",
                                    styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                    value: datapoint
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "col-12 form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "signal",
                                    className: "modal-inputlabel-text",
                                    children: "Signal"
                                }),
                                datapoint?.value === "outputSignal" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                                    cacheOptions: true,
                                    defaultOptions: true,
                                    disabled: !datapoint.value,
                                    isLoading: requestPending,
                                    loadOptions: (0, _debouncePromiseDefault.default)(fetchOutputSignals, 1000),
                                    maxMenuHeight: 150,
                                    name: "signal",
                                    onChange: setSignal,
                                    placeholder: "Select Signal",
                                    styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                    value: signal
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                    disabled: !datapoint?.value,
                                    isSearchable: true,
                                    maxMenuHeight: 150,
                                    name: "signal",
                                    onChange: setSignal,
                                    options: datapoint?.values,
                                    placeholder: "Select Signal",
                                    styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                    value: signal
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col-12 mb-0 three-quarter-text text-danger",
                            children: error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-danger py-0 px-3",
                        onClick: ()=>props.handleRemoveImageOverlaySignal(`${x}-${y}`),
                        children: "Remove"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn modal-button-secondary py-0 px-3",
                        disabled: !datapoint?.value || !signal?.value,
                        onClick: ()=>props.handleAddImageOverlaySignal(`${x}-${y}`, {
                                ...imageOverlay,
                                datapoint,
                                signal
                            }),
                        children: "Update"
                    })
                ]
            })
        ]
    });
}
ImageOverlayModal.propTypes = {
    activeImageCoordinate: (0, _propTypesDefault.default).object,
    datapointsMap: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    gtemplateID: (0, _propTypesDefault.default).string,
    handleAddImageOverlaySignal: (0, _propTypesDefault.default).func,
    handleRemoveImageOverlaySignal: (0, _propTypesDefault.default).func,
    orgID: (0, _propTypesDefault.default).string,
    toggleImageOverlayModal: (0, _propTypesDefault.default).func
};
function getOverlayMarkerStyle(x, y) {
    return {
        styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
            id: "3109566503",
            dynamic: [
                x,
                y,
                (0, _zIndex.TOOLTIP_OVERRIDE)
            ],
            children: `.overlay-marker.__jsx-style-dynamic-selector{-webkit-animation-direction:alternate;animation-direction:alternate;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:pulse-__jsx-style-dynamic-selector;animation-name:pulse-__jsx-style-dynamic-selector;border-radius:50%;height:10px;left:${x}px;-moz-animation-direction:alternate;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:pulse;top:${y}px;-webkit-animation-direction:alternate;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:pulse;width:10px;z-index:${(0, _zIndex.TOOLTIP_OVERRIDE)};}`
        }),
        className: (0, _styleDefault.default).dynamic([
            [
                "3109566503",
                [
                    x,
                    y,
                    (0, _zIndex.TOOLTIP_OVERRIDE)
                ]
            ]
        ])
    };
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-dropzone":"9kTqj","reactstrap":"kjd7g","axios":"ffpgq","react-select":"j36cq","react-select/async":"iHFh7","debounce-promise":"fqOKC","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-tooltip":"4ejwp","../../Services/TemplateService":"hGdvK","../../Constants/WidgetTypes":"frQz2","../../Styles/SelectStyles":"1LnYJ","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJVUV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _widgetTypes = require("../../Constants/WidgetTypes");
var _eventService = require("../../Services/EventService");
var _eventServiceDefault = parcelHelpers.interopDefault(_eventService);
var _widthContext = require("../../Context/WidthContext");
var _exportSignalCollectionModalDisplay = require("./ExportSignalCollectionModalDisplay");
var _exportSignalCollectionModalDisplayDefault = parcelHelpers.interopDefault(_exportSignalCollectionModalDisplay);
class ExportSignalCollectionModalContainer extends (0, _react.Component) {
    static propTypes = {
        isOpen: (0, _propTypesDefault.default).bool,
        widget: (0, _propTypesDefault.default).object,
        toggleModal: (0, _propTypesDefault.default).func,
        gatewayID: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    };
    state = {
        startDate: null,
        endDate: null,
        requestPending: false,
        requestSuccessful: false,
        showTooManyJobsError: false,
        error: ""
    };
    eventService = new (0, _eventServiceDefault.default)();
    source = new (0, _axios.CancelToken).source();
    componentWillUnmount() {
        this.source.cancel();
    }
    handleChangeStart = (date)=>{
        this.setState({
            startDate: date
        });
    };
    handleChangeEnd = (date)=>{
        this.setState({
            endDate: date
        });
    };
    getSignalCollections = ()=>{
        const { widget: { settings = {}, type = "" } = {} } = this.props;
        const signalCollectionIdSet = new Set();
        switch(true){
            case type === (0, _widgetTypes.GAUGE):
            case type === (0, _widgetTypes.GAUGE_RANGE):
                signalCollectionIdSet.add(settings.datapointID);
                if (settings.secondGauge?.datapointID) signalCollectionIdSet.add(settings.secondGauge.datapointID);
                break;
            case "lines" in settings:
                settings.lines.forEach(({ datapointID })=>{
                    signalCollectionIdSet.add(datapointID);
                });
                break;
            case "columns" in settings:
                settings.columns.forEach(({ datapointID })=>{
                    signalCollectionIdSet.add(datapointID);
                });
                break;
            case (0, _widgetTypes.TEXT) in settings:
                settings.text.forEach(({ datapointID })=>{
                    signalCollectionIdSet.add(datapointID);
                });
                break;
            case (0, _widgetTypes.BOOLEAN) in settings:
                settings.boolean.forEach(({ datapointID })=>{
                    signalCollectionIdSet.add(datapointID);
                });
                break;
            case (0, _widgetTypes.CAN_SCAN) in settings:
                settings.scan.forEach(({ datapointID })=>{
                    signalCollectionIdSet.add(datapointID);
                });
                break;
            case type === (0, _widgetTypes.LOCATION):
            case type === (0, _widgetTypes.MAP):
            case "datapointID" in settings:
                signalCollectionIdSet.add(settings.datapointID);
                break;
        }
        return signalCollectionIdSet;
    };
    handleSave = async ()=>{
        this.setState({
            requestPending: true
        });
        try {
            const { gatewayID } = this.props;
            const { startDate, endDate } = this.state;
            const datapoints = Array.from(this.getSignalCollections());
            const params = {
                dateStart: (0, _momentDefault.default)(startDate).valueOf(),
                dateStop: (0, _momentDefault.default)(endDate).valueOf()
            };
            await this.eventService.exportEventsToCSV(gatewayID, {
                datapoints
            }, params, this.source.token);
            this.setState({
                requestPending: false,
                requestSuccessful: true
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            if (error === "Too many requests") this.setState({
                requestPending: false,
                showTooManyJobsError: true
            });
            else this.setState({
                error,
                requestPending: false
            });
        }
    };
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widthContext.WidthConsumer), {
            children: (width)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exportSignalCollectionModalDisplayDefault.default), {
                    ...this.props,
                    ...this.state,
                    handleChangeStart: this.handleChangeStart,
                    handleChangeEnd: this.handleChangeEnd,
                    handleSave: this.handleSave,
                    width: width
                })
        });
    }
}
exports.default = ExportSignalCollectionModalContainer;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","moment":"1e4qG","../../Constants/WidgetTypes":"frQz2","../../Services/EventService":"3ybd9","../../Context/WidthContext":"5c6Dv","./ExportSignalCollectionModalDisplay":"hmVL3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ybd9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
class EventService {
    api = new (0, _requestsDefault.default)();
    buildEventDatapointRequest({ gatewayID, datapointID, last = false, limit = 200, dateStart = (0, _momentDefault.default)().subtract(4, "h").valueOf(), dateStop = null, cancelToken }) {
        const lastString = last ? "/last" : "";
        const conditionalLimit = last ? {} : {
            limit
        };
        return {
            service: "gateway",
            endpoint: `/gateway/${gatewayID}/datapoint/${datapointID}/events${lastString}`,
            method: "get",
            params: {
                dateStart,
                dateStop,
                ...conditionalLimit
            },
            cancelToken
        };
    }
    getEventDatapoints = async (params)=>{
        const { data = {} } = await this.api.request(this.buildEventDatapointRequest(params));
        return data;
    };
    buildExportEventsToCSVRequest(gatewayID, data, params, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${gatewayID}/datapoint/export`,
            method: "post",
            data,
            params,
            cancelToken
        };
    }
    exportEventsToCSV = async (gatewayID, dateBody, params, cancelToken)=>{
        const { data = {} } = await this.api.request(this.buildExportEventsToCSVRequest(gatewayID, dateBody, params, cancelToken));
        return data;
    };
    buildFetchEventsForSignalsOnMapRequest({ assetID, datapointID, cancelToken, ...params }) {
        return {
            service: "gateway",
            endpoint: `/gateway/${assetID}/datapoint/${datapointID}/events`,
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchEventsForSignalsOnMap(params) {
        const { data = {} } = await this.api.request(this.buildFetchEventsForSignalsOnMapRequest(params));
        return data;
    }
}
exports.default = EventService;

},{"../Lib/Requests":"j1WJQ","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5c6Dv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Width", ()=>Width);
parcelHelpers.export(exports, "WidthProvider", ()=>WidthProvider);
parcelHelpers.export(exports, "WidthConsumer", ()=>WidthConsumer);
var _react = require("react");
const Width = /*#__PURE__*/ (0, _react.createContext)(0);
const WidthProvider = Width.Provider;
const WidthConsumer = Width.Consumer;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmVL3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExportSignalCollectionModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _trackerClasses = require("../../Constants/TrackerClasses");
const { className: popperClass, styles: popperStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2653111275",
        children: "@media (max-width:767px){.react-datepicker-popper.jsx-2653111275{-webkit-transform:none !important;-ms-transform:none !important;transform:none !important;left:calc(50% - 150px) !important;top:20% !important;margin:0 auto;}}"
    }),
    className: "jsx-2653111275"
};
function ExportSignalCollectionModalDisplay(props) {
    const { isOpen, toggleModal, startDate, endDate, requestPending, requestSuccessful, handleChangeStart, handleChangeEnd, handleSave, showTooManyJobsError, error, widget: { settings: { title = "" } = {} } = {}, width } = props;
    const desktopView = width >= 992;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        toggle: toggleModal,
        size: "lg",
        centered: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                toggle: toggleModal,
                className: "text-nowrap",
                children: [
                    "Export Data",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-3032156261 three-quarter-text text-text-lighter font-weight-normal",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                children: requestSuccessful ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3032156261 px-5 d-flex flex-column align-items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-3032156261 form-group w-100 mt-5 d-flex justify-content-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                className: "text-alert-confirmation",
                                icon: (0, _freeSolidSvgIcons.faCheckCircle),
                                size: "5x"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-3032156261 form-group w-100 mt-4 text-text-lighter text-center",
                            children: [
                                `Job successfully created. This process could take a few minutes.`,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {
                                    className: "jsx-3032156261"
                                }),
                                `We'll send a download link to your email when the process is
              complete.`
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3032156261 px-5 d-flex flex-column align-items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-3032156261 form-group w-100 mt-4 d-flex flex-column flex-md-row justify-content-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-3032156261 d-flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "startDate",
                                            className: "jsx-3032156261",
                                            children: "Start Date"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            autoComplete: "off",
                                            className: "form-control",
                                            timeFormat: "HH:mm",
                                            dateFormat: [
                                                "MMM d, yyyy H:mm",
                                                "P",
                                                "PP",
                                                "PPP",
                                                "MMM dd yyyy",
                                                "MMMM dd yyyy",
                                                "MM/yyyy"
                                            ],
                                            maxDate: new Date(),
                                            name: "startDate",
                                            onChange: handleChangeStart,
                                            placeholderText: "From",
                                            popperClassName: popperClass,
                                            selected: startDate,
                                            selectsStart: true,
                                            showTimeSelect: true,
                                            timeCaption: "time",
                                            timeIntervals: 15
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-3032156261 align-self-end mx-4 mb-2 d-none d-md-block",
                                    children: "\u2014"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                    className: "jsx-3032156261 d-block d-md-none"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-3032156261 d-flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "startDate",
                                            className: "jsx-3032156261",
                                            children: "End Date"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            autoComplete: "off",
                                            className: "form-control",
                                            dateFormat: [
                                                "MMM d, yyyy H:mm",
                                                "P",
                                                "PP",
                                                "PPP",
                                                "MMM dd yyyy",
                                                "MMMM dd yyyy",
                                                "MM/yyyy"
                                            ],
                                            maxDate: new Date(),
                                            minDate: startDate,
                                            name: "endDate",
                                            onChange: handleChangeEnd,
                                            placeholderText: "To",
                                            popperClassName: popperClass,
                                            selected: endDate,
                                            selectsEnd: true,
                                            showTimeSelect: true,
                                            timeFormat: "HH:mm",
                                            timeIntervals: 15,
                                            timeCaption: "time"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-3032156261 " + `${desktopView && "w-75 px-3 mt-4"} px-0 mt-2 form-group text-muted three-quarter-text`,
                            children: `Maximum of 60,000 datapoints per signal collection. All the
                signals in the signal collection(s) in this smart tile will be
                exported.`
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-3032156261 " + `${!showTooManyJobsError && "d-none"} ${desktopView && "w-75 px-3 mt-4"} form-group text-danger three-quarter-text`,
                            children: `You already have 5 jobs in progress. Keep an eye on your email and
              check back soon to start a new job.`
                        }),
                        error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-3032156261 position-absolute text-danger three-quarter-text px-2 error-container",
                            children: error
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-3032156261 btn btn-outline-secondary py-0 px-3 mr-3",
                        children: requestSuccessful ? "Close" : "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleSave,
                        disabled: !startDate || !endDate,
                        className: "jsx-3032156261 " + `${requestSuccessful && "d-none"} btn modal-button-submit py-0 px-4 ${0, _trackerClasses.ASSET_SIGNAL_CSV}`,
                        children: requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Start Job"
                    })
                ]
            }),
            popperStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3032156261",
                children: ".btn.jsx-3032156261{font-size:0.75rem;}.remove-condition.jsx-3032156261{color:var(--icon-link-gray) !important;}.remove-condition.jsx-3032156261:hover{color:var(--text-light-gray) !important;}.calendar-class.jsx-3032156261{z-index:5000;}.error-container.jsx-3032156261{top:0.25rem;max-height:2.25rem;overflow:scroll;}"
            })
        ]
    });
}
ExportSignalCollectionModalDisplay.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    handleChangeStart: (0, _propTypesDefault.default).func,
    handleChangeEnd: (0, _propTypesDefault.default).func,
    handleChangeCombine: (0, _propTypesDefault.default).func,
    handleSave: (0, _propTypesDefault.default).func,
    maxDatapointsState: (0, _propTypesDefault.default).number,
    handleChangeMaxDatapoints: (0, _propTypesDefault.default).func,
    globalMaxDatapoints: (0, _propTypesDefault.default).number,
    showTooManyJobsError: (0, _propTypesDefault.default).bool,
    startDate: (0, _propTypesDefault.default).instanceOf(Date),
    endDate: (0, _propTypesDefault.default).instanceOf(Date),
    requestPending: (0, _propTypesDefault.default).bool,
    requestSuccessful: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    widget: (0, _propTypesDefault.default).object,
    width: (0, _propTypesDefault.default).number
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","react-datepicker":"cGh5X","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-datepicker/dist/react-datepicker.css":"chsuV","../../Constants/TrackerClasses":"1AdWb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"1AdWb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASSET_SIGNAL_CSV", ()=>ASSET_SIGNAL_CSV);
parcelHelpers.export(exports, "CREATE_ALERT_EVENT", ()=>CREATE_ALERT_EVENT);
parcelHelpers.export(exports, "CREATE_SCHEDULE_EVENT", ()=>CREATE_SCHEDULE_EVENT);
parcelHelpers.export(exports, "ERROR_LOGIN_FORM", ()=>ERROR_LOGIN_FORM);
parcelHelpers.export(exports, "EXIT_ORG_EVENT", ()=>EXIT_ORG_EVENT);
parcelHelpers.export(exports, "EXPORT_ASSETS_EVENT", ()=>EXPORT_ASSETS_EVENT);
parcelHelpers.export(exports, "EXPORT_DM1_CSV_DATA", ()=>EXPORT_DM1_CSV_DATA);
parcelHelpers.export(exports, "SUBSCRIPTION_ASSET_ALERTS", ()=>SUBSCRIPTION_ASSET_ALERTS);
parcelHelpers.export(exports, "SUBSCRIPTION_ASSET_DM1S", ()=>SUBSCRIPTION_ASSET_DM1S);
parcelHelpers.export(exports, "TAG_CREATE_EVENT", ()=>TAG_CREATE_EVENT);
const ASSET_SIGNAL_CSV = "tracker-asset-signal-csv";
const CREATE_ALERT_EVENT = "tracker-create-alert";
const CREATE_SCHEDULE_EVENT = "tracker-create-schedule";
const ERROR_LOGIN_FORM = "tracker-error-login-form";
const EXIT_ORG_EVENT = "tracker-exit-org";
const EXPORT_ASSETS_EVENT = "tracker-export-assets";
const EXPORT_DM1_CSV_DATA = "tracker-export-dm1-csv-data";
const SUBSCRIPTION_ASSET_ALERTS = "tracker-subscription-asset-alerts";
const SUBSCRIPTION_ASSET_DM1S = "tracker-subscription-asset-dm1s";
const TAG_CREATE_EVENT = "tracker-create-tag";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckALm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _addDays = require("date-fns/addDays");
var _addDaysDefault = parcelHelpers.interopDefault(_addDays);
var _addMonths = require("date-fns/addMonths");
var _addMonthsDefault = parcelHelpers.interopDefault(_addMonths);
var _addWeeks = require("date-fns/addWeeks");
var _addWeeksDefault = parcelHelpers.interopDefault(_addWeeks);
var _isAfter = require("date-fns/isAfter");
var _isAfterDefault = parcelHelpers.interopDefault(_isAfter);
var _subDays = require("date-fns/subDays");
var _subDaysDefault = parcelHelpers.interopDefault(_subDays);
var _subMonths = require("date-fns/subMonths");
var _subMonthsDefault = parcelHelpers.interopDefault(_subMonths);
var _subWeeks = require("date-fns/subWeeks");
var _subWeeksDefault = parcelHelpers.interopDefault(_subWeeks);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _signal = require("../../Constants/Signal");
exports.default = /*#__PURE__*/ (0, _react.memo)(UtilizationTimeSelectModal);
const aggregateIntervalMap = new Map([
    [
        (0, _signal.DAILY),
        "day"
    ],
    [
        (0, _signal.MONTHLY),
        "month"
    ],
    [
        (0, _signal.WEEKLY),
        "week"
    ]
]);
function UtilizationTimeSelectModal(props) {
    const { handleUtilizationTimeSelect, settings } = props;
    const now = (0, _react.useMemo)(()=>new Date(), []);
    const [state, updateState] = (0, _react.useState)(()=>{
        const end = props.customEndTimestamp ? new Date(props.customEndTimestamp) : null, start = props.customStartTimestamp ? new Date(props.customStartTimestamp) : null;
        return {
            endDate: (0, _isValidDefault.default)(end) ? end : null,
            startDate: (0, _isValidDefault.default)(start) ? start : null
        };
    });
    const helperText = (0, _react.useMemo)(()=>{
        switch(props.settings?.aggregation){
            case 0, _signal.DAILY:
                return "Choose a window of up to 7 days to display.";
            case 0, _signal.MONTHLY:
                return "Choose a window of up to 6 months to display.";
            case 0, _signal.WEEKLY:
                return "Choose a window of up to 6 weeks to display.";
            default:
                return "";
        }
    }, [
        props.settings?.aggregation
    ]), startMinDate = (0, _react.useMemo)(()=>{
        if (!(0, _isValidDefault.default)(state.endDate)) return null;
        switch(settings?.aggregation){
            case 0, _signal.DAILY:
                return (0, _subDaysDefault.default)(state.endDate, 7);
            case 0, _signal.WEEKLY:
                return (0, _subWeeksDefault.default)(state.endDate, 5);
            case 0, _signal.MONTHLY:
                return (0, _subMonthsDefault.default)(state.endDate, 5);
        }
    }, [
        settings?.aggregation,
        state.endDate
    ]), endMaxDate = (0, _react.useMemo)(()=>{
        if (!(0, _isValidDefault.default)(state.startDate)) return now;
        let maxDate;
        switch(settings?.aggregation){
            case 0, _signal.DAILY:
                maxDate = (0, _addDaysDefault.default)(state.startDate, 7);
                break;
            case 0, _signal.WEEKLY:
                maxDate = (0, _addWeeksDefault.default)(state.startDate, 5);
                break;
            case 0, _signal.MONTHLY:
                maxDate = (0, _addMonthsDefault.default)(state.startDate, 5);
                break;
        }
        return (0, _isAfterDefault.default)(maxDate, now) ? now : maxDate;
    }, [
        now,
        settings?.aggregation,
        state.startDate
    ]);
    const handleChangeEnd = (0, _react.useCallback)((endDate)=>{
        updateState((prevState)=>({
                ...prevState,
                endDate
            }));
    }, []), handleChangeStart = (0, _react.useCallback)((startDate)=>{
        updateState((prevState)=>({
                ...prevState,
                startDate
            }));
    }, []), handleUpdate = (0, _react.useCallback)(()=>{
        const dateStop = state.endDate ?? new Date(), interval = aggregateIntervalMap.get(settings?.aggregation);
        let dateStart = state.startDate;
        if (!dateStart) switch(settings?.aggregation){
            case 0, _signal.DAILY:
                dateStart = (0, _subDaysDefault.default)(dateStop, 7);
                break;
            case 0, _signal.WEEKLY:
                dateStart = (0, _subWeeksDefault.default)(dateStop, 5);
                break;
            case 0, _signal.MONTHLY:
                dateStart = (0, _subMonthsDefault.default)(dateStop, 5);
                break;
        }
        handleUtilizationTimeSelect(dateStart, dateStop, interval);
    }, [
        handleUtilizationTimeSelect,
        settings?.aggregation,
        state.endDate,
        state.startDate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        centered: true,
        isOpen: props.isOpen,
        toggle: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: props.toggleModal
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid py-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col-12 modal-supplemental-text",
                            children: helperText
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "row align-items-stretch",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group col-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "modal-inputlabel-text",
                                        htmlFor: "startDate",
                                        children: "Start Date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                        autoComplete: "off",
                                        className: "form-control",
                                        endDate: state.endDate,
                                        minDate: startMinDate,
                                        maxDate: state.endDate ?? now,
                                        name: "startDate",
                                        onChange: handleChangeStart,
                                        placeholderText: "From",
                                        selected: state.startDate,
                                        selectsStart: true,
                                        startDate: state.startDate,
                                        withPortal: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "col-2 d-flex align-items-center justify-content-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faMinus)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group col-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "modal-inputlabel-text",
                                        htmlFor: "endDate",
                                        children: "End Date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                        autoComplete: "off",
                                        className: "form-control",
                                        endDate: state.endDate,
                                        name: "endDate",
                                        onChange: handleChangeEnd,
                                        maxDate: endMaxDate,
                                        minDate: state.startDate,
                                        placeholderText: "To",
                                        selected: state.endDate,
                                        selectsEnd: true,
                                        startDate: state.startDate,
                                        withPortal: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "py-0 px-3 mr-3 three-quarter-text",
                        onClick: props.toggleModal,
                        outline: true,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "modal-button-submit py-0 px-4 three-quarter-text",
                        onClick: handleUpdate,
                        children: "Set Time Frame"
                    })
                ]
            })
        ]
    });
}
UtilizationTimeSelectModal.propTypes = {
    customEndTimestamp: (0, _propTypesDefault.default).number,
    customStartTimestamp: (0, _propTypesDefault.default).number,
    handleUtilizationTimeSelect: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    settings: (0, _propTypesDefault.default).object,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","date-fns/isValid":"l72u5","date-fns/addDays":"fK40q","date-fns/addMonths":"luR8G","date-fns/addWeeks":"6qgbJ","date-fns/isAfter":"1N23w","date-fns/subDays":"0Vpj8","date-fns/subMonths":"135UL","date-fns/subWeeks":"c1mfa","prop-types":"bnNSm","react":"9njXz","reactstrap":"kjd7g","react-datepicker":"cGh5X","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/Signal":"bTf7q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"emC8E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Widget);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactstrap = require("reactstrap");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _widgetUtils = require("../../Lib/WidgetUtils");
var _widgetUtilsDefault = parcelHelpers.interopDefault(_widgetUtils);
var _assetPathWidget = require("./AssetPathWidget");
var _assetPathWidgetDefault = parcelHelpers.interopDefault(_assetPathWidget);
var _booleanWidget = require("./BooleanWidget");
var _booleanWidgetDefault = parcelHelpers.interopDefault(_booleanWidget);
var _commandsWidget = require("./CommandsWidget");
var _commandsWidgetDefault = parcelHelpers.interopDefault(_commandsWidget);
var _currentLocationWidget = require("./CurrentLocationWidget");
var _currentLocationWidgetDefault = parcelHelpers.interopDefault(_currentLocationWidget);
var _flexibleRangeGaugeWidget = require("./FlexibleRangeGaugeWidget");
var _flexibleRangeGaugeWidgetDefault = parcelHelpers.interopDefault(_flexibleRangeGaugeWidget);
var _legacyGaugeWidget = require("./LegacyGaugeWidget");
var _legacyGaugeWidgetDefault = parcelHelpers.interopDefault(_legacyGaugeWidget);
var _maintenanceWidget = require("./MaintenanceWidget");
var _maintenanceWidgetDefault = parcelHelpers.interopDefault(_maintenanceWidget);
var _staticTextWidget = require("./StaticTextWidget");
var _staticTextWidgetDefault = parcelHelpers.interopDefault(_staticTextWidget);
var _textTagsWidget = require("./TextTagsWidget");
var _textTagsWidgetDefault = parcelHelpers.interopDefault(_textTagsWidget);
var _textWidget = require("./TextWidget");
var _textWidgetDefault = parcelHelpers.interopDefault(_textWidget);
var _utilizationBarWidgets = require("./UtilizationBarWidgets");
var _utilizationTextWidgets = require("./UtilizationTextWidgets");
var _widgetDisplayComponents = require("./WidgetDisplayComponents");
var _imageOverlayWidget = require("./ImageOverlayWidget");
var _imageOverlayWidgetDefault = parcelHelpers.interopDefault(_imageOverlayWidget);
var _loadingCircle = require("../LoadingCircle");
const { className: alertClass, styles: alertStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2988632737",
        children: ".alert.jsx-2988632737{z-index:1;top:40%;left:0;right:0;width:260px;box-shadow:0px 0px 10px 0px var(--icon-link-gray);}"
    }),
    className: "jsx-2988632737"
};
const ALERT_MESSAGE_MAP = new Map([
    [
        (0, _widgetTypes.AREA),
        "No data to display for the selected time range"
    ],
    [
        (0, _widgetTypes.BOOLEAN),
        "No signal data available for these signals"
    ],
    [
        (0, _widgetTypes.COLUMN_GRAPH),
        "No data has been received for these signals"
    ],
    [
        (0, _widgetTypes.COMMAND),
        "No commands have been defined for this smart tile"
    ],
    [
        (0, _widgetTypes.GAUGE),
        "No data has been received for this signal"
    ],
    [
        (0, _widgetTypes.HIGH_BAR),
        "No data has been received for these signals"
    ],
    [
        (0, _widgetTypes.LINE_GRAPH),
        "No data to display for the selected time range"
    ],
    [
        (0, _widgetTypes.LINE_HIGH_CHART),
        "No data to display for the selected time range"
    ],
    [
        (0, _widgetTypes.LOCATION),
        "No data to display for the selected time range"
    ],
    [
        (0, _widgetTypes.MAP),
        "No data has been received for this signal"
    ],
    [
        (0, _widgetTypes.PIE),
        "No data has been received for these signals"
    ],
    [
        (0, _widgetTypes.CAN_SCAN),
        "No scan data available"
    ],
    [
        (0, _widgetTypes.TEXT),
        "No data has been received for these signals"
    ],
    [
        (0, _widgetTypes.TEXT_STATIC),
        "No text has been configured for this tile"
    ],
    [
        (0, _widgetTypes.TEXT_TAGS),
        "No tags have been defined for this smart tile"
    ],
    [
        (0, _widgetTypes.VERTICAL_COLUMN_GRAPH),
        "No data has been received for these signals"
    ]
]), flexDisplayTypesSet = new Set([
    (0, _widgetTypes.BOOLEAN),
    (0, _widgetTypes.COMMAND),
    (0, _widgetTypes.MAINTENANCE),
    (0, _widgetTypes.TEXT),
    (0, _widgetTypes.TEXT_STATIC),
    (0, _widgetTypes.TEXT_TAGS)
]);
function Widget({ asset, fetchedData, graphIndex, graphWidgetIDs, handleCommandExecutedFromWidget, historicalUtilizationData, renderNextGraph, returningToRealTime, signalNamesMap, signalUnitsMap, textTagsWidgetRef, updateRealTime, utilizationData, widget, widget: { _id: widgetID, settings, settings: { aggregation, boolean, commands, displayTextAsGrid, links, scan, showTimeSinceLastUpdated, staticText, tags, text, title } = {}, type } = {} }) {
    const widgetUtils = (0, _react.useMemo)(()=>new (0, _widgetUtilsDefault.default)(), []);
    const data = (0, _react.useMemo)(()=>{
        switch(type){
            case 0, _widgetTypes.AREA:
            case 0, _widgetTypes.LINE_HIGH_CHART:
            case 0, _widgetTypes.LINE_GRAPH:
            case 0, _widgetTypes.COLUMN_GRAPH:
            case 0, _widgetTypes.HIGH_BAR:
            case 0, _widgetTypes.IMAGE:
            case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
            case 0, _widgetTypes.PIE:
                {
                    const { last, lines } = widgetUtils.getWidgetAttributes(type, settings);
                    const dataMap = widgetUtils.parseFetchedData(fetchedData, lines, last);
                    return widgetUtils.parseEventsForGraph(lines, dataMap, type, signalNamesMap, signalUnitsMap);
                }
            case 0, _widgetTypes.BAR_ENGINE_UTILIZATION:
            case 0, _widgetTypes.BAR_FUEL_UTILIZATION:
                return historicalUtilizationData;
            case 0, _widgetTypes.BOOLEAN:
                {
                    const dataMap = widgetUtils.parseFetchedData(fetchedData, boolean, true);
                    return boolean.map(({ key: name, datapointID, type })=>{
                        const { createdAt = "", signals = {} } = dataMap.get(datapointID) || {};
                        let value;
                        let time;
                        if (Object.keys(signals || {})?.length) {
                            const target = Object.values(signals).find(({ name: n })=>n === name) || {};
                            value = target.value;
                            time = !createdAt ? "--" : type === "outputSignal" ? (0, _momentDefault.default).utc(createdAt).format("MM-DD-YYYY") : (0, _momentDefault.default)(createdAt).format("MM-DD-YYYY HH:mm");
                        }
                        return {
                            name,
                            value,
                            time
                        };
                    });
                }
            case 0, _widgetTypes.COMMAND:
                return commands;
            case 0, _widgetTypes.LOCATION:
            case 0, _widgetTypes.MAP:
                return fetchedData.get(widget?.settings?.datapointID);
            case 0, _widgetTypes.CAN_SCAN:
                {
                    const dataMap = widgetUtils.parseFetchedData(fetchedData, scan, true);
                    const [{ datapointID }] = scan || [
                        {}
                    ];
                    const { signals } = dataMap.get(datapointID) || {};
                    const [signal] = Object.values(signals || {});
                    return signal?.value ?? "";
                }
            case 0, _widgetTypes.TEXT:
                {
                    const dataMap = widgetUtils.parseFetchedData(fetchedData, text, true);
                    return text.map(({ key: name, datapointID, type })=>{
                        const { createdAt = "", signals = [] } = dataMap.get(datapointID) || {};
                        const { display_precision } = signalUnitsMap.get(datapointID)?.[name] ?? {};
                        let unit = "";
                        let value;
                        if (Object.keys(signals || {})?.length) {
                            const target = Object.values(signals).find(({ name: n })=>n === name) || {};
                            if (target?.uom) unit = target.uom;
                            switch(typeof target?.value){
                                case "string":
                                    value = target.value;
                                    break;
                                case "number":
                                    value = _truncateValue(target.value, display_precision);
                                    break;
                                case 0, _widgetTypes.BOOLEAN:
                                    value = String(target.value);
                                    break;
                                default:
                                    value = "";
                                    break;
                            }
                        }
                        return {
                            name,
                            timestamp: createdAt,
                            type,
                            unit,
                            value
                        };
                    });
                }
            case 0, _widgetTypes.TEXT_ENGINE:
            case 0, _widgetTypes.TEXT_FUEL:
                return utilizationData;
            case 0, _widgetTypes.TEXT_STATIC:
                return {
                    links,
                    staticText
                };
            case 0, _widgetTypes.TEXT_TAGS:
                return tags;
            default:
                return null;
        }
    }, [
        boolean,
        commands,
        fetchedData,
        historicalUtilizationData,
        links,
        scan,
        settings,
        signalNamesMap,
        signalUnitsMap,
        staticText,
        tags,
        text,
        type,
        utilizationData,
        widget?.settings?.datapointID,
        widgetUtils
    ]);
    const alertMessage = (0, _react.useMemo)(()=>ALERT_MESSAGE_MAP.get(type) || "No data available", [
        type
    ]), alertVisibility = (0, _react.useMemo)(()=>!returningToRealTime && widgetUtils.noDataIsAvailable(data, type), [
        data,
        returningToRealTime,
        type,
        widgetUtils
    ]), flexDisplay = (0, _react.useMemo)(()=>flexDisplayTypesSet.has(type) ? " d-flex flex-column" : "", [
        type
    ]), overflowDisplay = (0, _react.useMemo)(()=>widgetID && [
            (0, _widgetTypes.BOOLEAN),
            (0, _widgetTypes.COMMAND),
            (0, _widgetTypes.MAINTENANCE),
            (0, _widgetTypes.TEXT),
            (0, _widgetTypes.TEXT_STATIC),
            (0, _widgetTypes.TEXT_TAGS)
        ].includes(type) ? " pb-2 overflow-auto" : "", [
        type,
        widgetID
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `position-absolute h-100 w-100${flexDisplay}${overflowDisplay}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Alert), {
                className: `${alertClass} mx-auto position-fixed text-center text-muted`,
                color: "light",
                isOpen: alertVisibility,
                children: alertMessage
            }),
            (()=>{
                if (returningToRealTime) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "h-100 w-100 d-flex align-items-center justify-content-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                        size: "3x"
                    })
                });
                switch(type){
                    case 0, _widgetTypes.AREA:
                    case 0, _widgetTypes.LINE_HIGH_CHART:
                    case 0, _widgetTypes.LINE_GRAPH:
                    case 0, _widgetTypes.COLUMN_GRAPH:
                    case 0, _widgetTypes.HIGH_BAR:
                    case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
                    case 0, _widgetTypes.PIE:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetDisplayComponents.GraphWidget), {
                            alertVisibility: alertVisibility,
                            fetchedData: fetchedData,
                            graphIndex: graphIndex,
                            graphWidgetIDs: graphWidgetIDs,
                            renderNextGraph: renderNextGraph,
                            series: data,
                            settings: settings,
                            signalUnitsMap: signalUnitsMap,
                            type: type
                        });
                    case 0, _widgetTypes.BAR_ENGINE_UTILIZATION:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utilizationBarWidgets.EngineUtilizationBarChart), {
                            aggregation: aggregation,
                            data: data,
                            graphIndex: graphIndex,
                            graphWidgetIDs: graphWidgetIDs,
                            renderNextGraph: renderNextGraph,
                            title: title
                        });
                    case 0, _widgetTypes.BAR_FUEL_UTILIZATION:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utilizationBarWidgets.FuelUtilizationBarChart), {
                            aggregation: aggregation,
                            data: data,
                            graphIndex: graphIndex,
                            graphWidgetIDs: graphWidgetIDs,
                            renderNextGraph: renderNextGraph,
                            title: title
                        });
                    case 0, _widgetTypes.BOOLEAN:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _booleanWidgetDefault.default), {
                            data: data
                        });
                    case 0, _widgetTypes.CAN_SCAN:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetDisplayComponents.ScanWidget), {
                            data: data
                        });
                    case 0, _widgetTypes.COMMAND:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandsWidgetDefault.default), {
                            asset: asset,
                            commands: commands,
                            handleCommandExecuted: handleCommandExecutedFromWidget
                        });
                    case 0, _widgetTypes.GAUGE:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _legacyGaugeWidgetDefault.default), {
                            fetchedData: fetchedData,
                            graphIndex: graphIndex,
                            graphWidgetIDs: graphWidgetIDs,
                            renderNextGraph: renderNextGraph,
                            signalUnitsMap: signalUnitsMap,
                            widget: widget
                        });
                    case 0, _widgetTypes.GAUGE_RANGE:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flexibleRangeGaugeWidgetDefault.default), {
                            fetchedData: fetchedData,
                            graphIndex: graphIndex,
                            graphWidgetIDs: graphWidgetIDs,
                            renderNextGraph: renderNextGraph,
                            signalUnitsMap: signalUnitsMap,
                            widget: widget
                        });
                    case 0, _widgetTypes.IMAGE:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageOverlayWidgetDefault.default), {
                            asset: asset,
                            data: data,
                            fetchedData: fetchedData,
                            signalUnitsMap: signalUnitsMap,
                            widget: widget
                        });
                    case 0, _widgetTypes.LOCATION:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetPathWidgetDefault.default), {
                            assetPathData: data,
                            datapointID: widget?.settings?.datapointID,
                            fetchedData: fetchedData,
                            signalUnitsMap: signalUnitsMap,
                            widgetID: widgetID
                        });
                    case 0, _widgetTypes.MAINTENANCE:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maintenanceWidgetDefault.default), {
                            asset: asset,
                            shadow: asset?.shadow,
                            signalUnitsMap: signalUnitsMap,
                            widget: widget
                        });
                    case 0, _widgetTypes.MAP:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _currentLocationWidgetDefault.default), {
                            datapointID: widget?.settings?.datapointID,
                            fetchedData: fetchedData
                        });
                    case 0, _widgetTypes.TEXT:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textWidgetDefault.default), {
                            data: data,
                            displayTextAsGrid: displayTextAsGrid,
                            showTimeSinceLastUpdated: showTimeSinceLastUpdated,
                            updateRealTime: updateRealTime
                        });
                    case 0, _widgetTypes.TEXT_ENGINE:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utilizationTextWidgets.EngineUtilizationTextWidget), {
                            data: data
                        });
                    case 0, _widgetTypes.TEXT_FUEL:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utilizationTextWidgets.FuelUtilizationTextWidget), {
                            data: data
                        });
                    case 0, _widgetTypes.TEXT_STATIC:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _staticTextWidgetDefault.default), {
                            data: data
                        });
                    case 0, _widgetTypes.TEXT_TAGS:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textTagsWidgetDefault.default), {
                            asset: asset,
                            ref: textTagsWidgetRef,
                            widget: widget
                        });
                    default:
                        return null;
                }
            })(),
            alertStyles
        ]
    });
}
Widget.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    fetchedData: (0, _propTypesDefault.default).object,
    graphIndex: (0, _propTypesDefault.default).number,
    graphWidgetIDs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    handleCommandExecutedFromWidget: (0, _propTypesDefault.default).func,
    historicalUtilizationData: (0, _propTypesDefault.default).object,
    renderNextGraph: (0, _propTypesDefault.default).func,
    returningToRealTime: (0, _propTypesDefault.default).bool,
    signalNamesMap: (0, _propTypesDefault.default).object,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    textTagsWidgetRef: (0, _propTypesDefault.default).object,
    updateRealTime: (0, _propTypesDefault.default).bool,
    utilizationData: (0, _propTypesDefault.default).object,
    widget: (0, _propTypesDefault.default).object
};
function _truncateValue(value, precision) {
    return Number.isInteger(value) ? value : Number(value).toFixed(precision ?? 2);
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","reactstrap":"kjd7g","../../Constants/WidgetTypes":"frQz2","../../Lib/WidgetUtils":"uF2rc","./AssetPathWidget":"aVPxb","./BooleanWidget":"8u6bN","./CommandsWidget":"bIm4e","./CurrentLocationWidget":"bIlyG","./FlexibleRangeGaugeWidget":"lXUOv","./LegacyGaugeWidget":"h5n2c","./MaintenanceWidget":"93meY","./StaticTextWidget":"lUTDF","./TextTagsWidget":"4f9Yq","./TextWidget":"jUy6V","./UtilizationBarWidgets":"33zDF","./UtilizationTextWidgets":"7AAiW","./WidgetDisplayComponents":"9or2Y","./ImageOverlayWidget":"9bQmh","../LoadingCircle":"aIADA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aVPxb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _api = require("@react-google-maps/api");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _alertUtils = require("../../Lib/AlertUtils");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetPathWidget);
const { className: spinnerClass, styles: spinnerStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1752217972",
        children: "svg.jsx-1752217972{position:absolute;top:50%;left:50%;}"
    }),
    className: "jsx-1752217972"
};
const initPathPointInfoWindowState = {
    show: false,
    position: {},
    timestamp: ""
};
const initViewDistanceState = {
    distance: 0,
    endingPoint: null,
    startingPoint: null
};
function AssetPathWidget({ assetPathData, datapointID, fetchedData, signalUnitsMap, widgetID }) {
    const [recentPath, updateRecentPath] = (0, _react.useState)([]);
    const [pathPointToShow, setPathPointToShow] = (0, _react.useState)(initPathPointInfoWindowState);
    const [viewDistance, updateViewDistance] = (0, _react.useState)(initViewDistanceState);
    const { offlinePin, onlinePin } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const dataLayer = (0, _react.useRef)();
    const viewDistanceWindow = (0, _react.useRef)();
    const viewDistancePolyline = (0, _react.useRef)();
    const displayDistanceWindow = (0, _react.useRef)();
    const { display_precision = 2 } = signalUnitsMap.get(datapointID)?.latitude || signalUnitsMap.get(datapointID)?.longitude || {};
    const [{ signals = {} } = {}] = fetchedData.get((0, _staticUUIDs.CONNECT_DISCONNECT_ID)) || [];
    const { value: status } = Object.values(signals || {}).find(({ name } = {})=>name === "connect-disconnect") || {};
    const handleMapLoaded = (map)=>{
        if (!recentPath.length) return;
        const gm = window.google.maps;
        const bounds = new gm.LatLngBounds();
        recentPath.map(({ lat, lng })=>{
            const coordinate = new gm.LatLng(lat, lng);
            bounds.extend(coordinate);
        });
        map.fitBounds(bounds);
    };
    const handleMouseOverPath = (newPoint)=>{
        const timestampMap = newPoint.feature.getProperty("timestampMap");
        const { latLng } = newPoint;
        if (!timestampMap || !latLng) return;
        const { computeDistanceBetween } = window.google.maps.geometry.spherical;
        const [, timestamp] = Array.from(timestampMap).find(([ll])=>computeDistanceBetween(latLng, ll) < 20) || [];
        if (!timestamp) return;
        const focusedPoint = {
            position: latLng.toJSON(),
            show: true,
            timestamp
        };
        setPathPointToShow(focusedPoint);
    };
    const handleMouseOutOfPath = ()=>{
        setPathPointToShow(initPathPointInfoWindowState);
    };
    const handleDataLayerLoaded = (data)=>{
        dataLayer.current = data;
        addDataLayer(recentPath);
    };
    const addDataLayer = (path = [])=>{
        if (!path.length) return;
        const { coordinates, properties } = path.reduce((acc, { lat, lng, timestamp })=>{
            acc.coordinates.push([
                lng,
                lat
            ]);
            acc.properties.timestampMap.set(new window.google.maps.LatLng(lat, lng), timestamp);
            return acc;
        }, {
            coordinates: [],
            properties: {
                timestampMap: new Map()
            }
        });
        const feature = {
            type: "FeatureCollection",
            features: [
                {
                    type: "Feature",
                    id: widgetID,
                    geometry: {
                        type: "LineString",
                        coordinates
                    },
                    properties
                }
            ]
        };
        dataLayer?.current?.forEach?.((f)=>dataLayer?.current?.remove?.(f));
        dataLayer.current.addGeoJson(feature, {
            idPropertyName: widgetID
        });
    };
    const parseAssetPathData = ()=>{
        const parsedPath = assetPathData.map(({ createdAt, signals } = {})=>{
            if (!Object.keys(signals)?.length) return;
            const { latitude: lat, longitude: lng } = Object.values(signals || {}).reduce((acc, { name = "", value } = {})=>{
                acc[name.toLowerCase()] = value;
                return acc;
            }, {});
            if (!(0, _alertUtils.isValidLat)(lat) || !(0, _alertUtils.isValidLng)(lng)) return;
            return {
                lat,
                lng,
                timestamp: createdAt
            };
        }).filter((gps)=>!!gps);
        updateRecentPath(parsedPath);
        dataLayer?.current && addDataLayer(parsedPath);
    };
    const handleStartLocationClick = ({ latLng })=>{
        updateViewDistance({
            ...viewDistance,
            startingPoint: latLng
        });
    };
    const handleEndLocationClick = ({ latLng })=>{
        switch(true){
            case !viewDistance.startingPoint:
                return;
            case !!viewDistance.startingPoint && !viewDistance.endingPoint:
                updateViewDistance({
                    ...viewDistance,
                    endingPoint: latLng
                });
                viewDistanceWindow.current?.close();
                break;
            case !!viewDistance.startingPoint && !!viewDistance.endingPoint:
                updateViewDistance(initViewDistanceState);
                break;
            default:
                return;
        }
    };
    const handleViewDistanceWindowLoaded = (window1)=>{
        viewDistanceWindow.current = window1;
    };
    const handleViewDistanceWindowClosed = ()=>{
        updateViewDistance(initViewDistanceState);
    };
    const handlePolylineLoaded = (line)=>{
        viewDistancePolyline.current = line;
        const distance = window.google.maps.geometry.spherical.computeLength(line.getPath().getArray());
        updateViewDistance({
            ...viewDistance,
            distance
        });
    };
    const handleDisplayDistanceWindowLoaded = (window1)=>{
        displayDistanceWindow.current = window1;
    };
    (0, _react.useEffect)(()=>{
        parseAssetPathData();
    }, [
        assetPathData
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _api.GoogleMap), {
        clickableIcons: false,
        mapContainerClassName: "h-100",
        mapContainerStyle: {
            borderBottomLeftRadius: "1rem",
            borderBottomRightRadius: "1rem"
        },
        onClick: handleEndLocationClick,
        onLoad: handleMapLoaded,
        onRightClick: handleStartLocationClick,
        options: {
            gestureHandling: "cooperative",
            streetViewControl: false
        },
        children: [
            window && window.google && recentPath ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.Data), {
                        onLoad: handleDataLayerLoaded,
                        onMouseOut: handleMouseOutOfPath,
                        onMouseOver: handleMouseOverPath,
                        options: {
                            style: {
                                strokeColor: "#74d17d",
                                strokeWeight: 3
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.Marker), {
                        icon: status === "deviceConnect" ? onlinePin : offlinePin,
                        position: recentPath[0],
                        zIndex: 100000
                    }),
                    pathPointToShow.show ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.InfoWindow), {
                        options: {
                            disableAutoPan: true
                        },
                        position: pathPointToShow.position,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "container text-text-gray",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "col font-weight-bold mb-2 text-center",
                                        children: (0, _momentDefault.default)(pathPointToShow.timestamp).format("M-D-Y")
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "col font-weight-bold mb-2 text-center",
                                        children: (0, _momentDefault.default)(pathPointToShow.timestamp).format("HH:mm:ss")
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "col font-weight-bold text-center",
                                        children: `${Number(pathPointToShow.position.lat).toFixed(2)}, ${Number(pathPointToShow.position.lng).toFixed(2)}`
                                    })
                                })
                            ]
                        })
                    }) : null,
                    viewDistance.startingPoint ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.InfoWindow), {
                        onCloseClick: handleViewDistanceWindowClosed,
                        onLoad: handleViewDistanceWindowLoaded,
                        options: {
                            disableAutoPan: true,
                            maxWidth: 150
                        },
                        position: viewDistance.startingPoint,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "row no-gutters flex-wrap text-dark",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "col mb-0 text-center",
                                children: "Click another point on the map to view distance."
                            })
                        })
                    }) : null,
                    viewDistance.startingPoint && viewDistance.endingPoint ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.Polyline), {
                        draggable: false,
                        editable: false,
                        onLoad: handlePolylineLoaded,
                        options: {
                            geodesic: true
                        },
                        path: [
                            viewDistance.startingPoint,
                            viewDistance.endingPoint
                        ],
                        visible: true
                    }) : null,
                    viewDistance.startingPoint && viewDistance.endingPoint && viewDistance.distance ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.InfoWindow), {
                        onCloseClick: handleViewDistanceWindowClosed,
                        onLoad: handleDisplayDistanceWindowLoaded,
                        options: {
                            disableAutoPan: true
                        },
                        position: viewDistance.endingPoint,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "container-fluid",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "row no-gutters text-dark",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "col-12 mb-2 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-weight-light mr-2",
                                                children: "Starting:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: viewDistance.startingPoint.toUrlValue(display_precision)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "row no-gutters text-dark",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "col-12 mb-2 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-weight-light mr-2",
                                                children: "Ending:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: viewDistance.endingPoint.toUrlValue(display_precision)
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "row no-gutters text-dark",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "col-12 mb-2 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-weight-light mr-2",
                                                children: "Distance:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: `${Number(viewDistance.distance).toFixed(2)} m`
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }) : null
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                className: spinnerClass,
                color: "var(--brand-primary)",
                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                size: "2x",
                spin: true
            }),
            spinnerStyles
        ]
    });
}
AssetPathWidget.propTypes = {
    assetPathData: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    datapointID: (0, _propTypesDefault.default).string,
    fetchedData: (0, _propTypesDefault.default).object,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    widgetID: (0, _propTypesDefault.default).string
};
AssetPathWidget.defaultProps = {
    assetPathData: []
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","@react-google-maps/api":"jDQ7N","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/IconsContext":"lzIpe","../../Constants/StaticUUIDs":"cpjYY","../../Lib/AlertUtils":"fHOhn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHOhn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidLat", ()=>isValidLat);
parcelHelpers.export(exports, "isValidLng", ()=>isValidLng);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _ruleUtils = require("./RuleUtils");
var _ruleUtilsDefault = parcelHelpers.interopDefault(_ruleUtils);
const ruleUtils = new (0, _ruleUtilsDefault.default)();
function isValidLat(lat) {
    return Number.isFinite(lat) && lat >= -90 && lat <= 90;
}
function isValidLng(lng) {
    return Number.isFinite(lng) && lng >= -180 && lng <= 180;
}
const STATUS_DISPLAY_MAP = new Map([
    [
        "positive",
        "Active"
    ],
    [
        "negative",
        "Resolved"
    ]
]);
class AlertUtils {
    formatAlertForCsv(alert, orgsMap) {
        const { AlertData: { signals = [] } = {}, DetectedAt, GatewayName: Asset_Name, GpsData: { Lat, Long } = {}, OrgId, RuleName: Rule_Name, Transition, TriggeredAt } = alert;
        const Detected_At = (0, _momentDefault.default)(DetectedAt).toISOString();
        const Org_Name = orgsMap?.[OrgId]?.name ?? "";
        const Resolved = Transition === "negative" ? (0, _momentDefault.default)(TriggeredAt).toISOString() : "";
        const Latitude = isValidLat(Lat) ? Lat.toFixed(2) : "--";
        const Longitude = isValidLng(Long) ? Long.toFixed(2) : "--";
        const Status = STATUS_DISPLAY_MAP.get(Transition);
        return signals.reduce((acc, { name, threshold, type, value })=>{
            acc.push({
                Detected_At,
                Resolved,
                Asset_Name,
                Rule_Name,
                Org_Name,
                Latitude,
                Longitude,
                Status,
                Signal_Name: name || "Signal Name Not Found",
                Rule_Type: ruleUtils.ruleTypeDisplayMap.get(type),
                Rule_Threshold: threshold,
                Data_Value: value
            });
            return acc;
        }, []);
    }
    generateCsvFilename() {
        return `${new (0, _momentDefault.default)().format("YYYY-M-D_HH\u02F8mm\u02F8ss")}_Alerts Record`;
    }
}
exports.default = AlertUtils;

},{"moment":"1e4qG","./RuleUtils":"9Tnix","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Tnix":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _keyBy = require("lodash/keyBy");
var _keyByDefault = parcelHelpers.interopDefault(_keyBy);
var _rule = require("../Constants/Rule");
var _templateService = require("../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
const templateService = new (0, _templateServiceDefault.default)();
class RuleUtils {
    ruleTypeDisplayMap = new Map([
        [
            "lessThan",
            "Less Than"
        ],
        [
            "greaterThan",
            "Greater Than"
        ],
        [
            "between",
            "Between"
        ],
        [
            "outsideOf",
            "Outside"
        ],
        [
            "equalTo",
            "Equals"
        ],
        [
            "notEqualTo",
            "Does Not Equal"
        ],
        [
            "contains",
            "Contains"
        ],
        [
            "startsWith",
            "Starts With"
        ],
        [
            "endsWith",
            "Ends With"
        ]
    ]);
    ruleSeverityDisplayMap = new Map((0, _rule.SEVERITIES).map((s)=>[
            s,
            s.charAt(0).toUpperCase() + s.slice(1)
        ]));
    frequencyIntervalMap = new Map([
        [
            "second(s)",
            1
        ],
        [
            "minutes(s)",
            60
        ],
        [
            "hours(s)",
            3600
        ],
        [
            "days(s)",
            86400
        ]
    ]);
    secondsInDay = 86400;
    secondsInHour = 3600;
    secondsInMinute = 60;
    parseFrequencyFromSeconds(value) {
        switch(true){
            case value >= this.secondsInDay:
                return {
                    frequencyValue: String(value / this.secondsInDay),
                    selectedFrequency: {
                        label: "days(s)",
                        value: this.frequencyIntervalMap.get("days(s)")
                    }
                };
            case value >= this.secondsInHour:
                return {
                    frequencyValue: String(value / this.secondsInHour),
                    selectedFrequency: {
                        label: "hours(s)",
                        value: this.frequencyIntervalMap.get("hours(s)")
                    }
                };
            case value >= this.secondsInMinute:
                return {
                    frequencyValue: String(value / this.secondsInMinute),
                    selectedFrequency: {
                        label: "minutes(s)",
                        value: this.frequencyIntervalMap.get("minutes(s)")
                    }
                };
            default:
                return {
                    frequencyValue: String(value),
                    selectedFrequency: {
                        label: "second(s)",
                        value: this.frequencyIntervalMap.get("second(s)")
                    }
                };
        }
    }
    parseSeverityForDisplay(severity) {
        if ((0, _isEmptyDefault.default)(severity)) return null;
        const label = this.ruleSeverityDisplayMap.get(severity);
        return {
            value: severity,
            label
        };
    }
    findModelBySourceId(gtemplateID, templates) {
        const target = templates.find(({ _id })=>_id === gtemplateID);
        const selectedModel = target ? {
            label: target.name,
            value: target
        } : null;
        return {
            selectedModel
        };
    }
    _handleConditionSignalCollectionAndSignal(collectionsMap = new Map(), collectionID, signalID) {
        const targetCollection = collectionsMap.get(collectionID);
        if ((0, _isEmptyDefault.default)(targetCollection)) return {
            selectedSignalCollection: null,
            selectedSignal: null,
            signals: []
        };
        const selectedSignalCollection = {
            label: targetCollection.name,
            value: targetCollection
        };
        const { values } = targetCollection;
        if ((0, _isEmptyDefault.default)(values)) return {
            selectedSignalCollection,
            selectedSignal: null,
            signals: []
        };
        const signals = values.map((value)=>{
            return {
                label: value.name || "",
                value
            };
        });
        const targetSignal = values.find(({ _id })=>_id === signalID);
        if ((0, _isEmptyDefault.default)(targetSignal)) return {
            selectedSignalCollection,
            selectedSignal: null,
            signals
        };
        const selectedSignal = {
            label: targetSignal.name,
            value: targetSignal
        };
        let unit = targetSignal.unit;
        if (Array.isArray(targetSignal.transforms) && targetSignal.transforms.length) {
            const [{ uom }] = targetSignal.transforms;
            unit = uom ?? targetSignal.unit;
        }
        return {
            selectedSignalCollection,
            selectedSignal,
            signals,
            unit
        };
    }
    _handleOutputSignalCondtions(conditions, templateID, cancelToken) {
        const outputSignalRequests = conditions.map(async (c, i)=>{
            const { SignalId, Type, Value } = c;
            const selectedConditionType = this._handleSelectedConditionType(Type);
            const selectedSignalCollection = {
                label: "Calculated Signal",
                value: "outputSignal"
            };
            const outputSignal = await templateService.fetchOutputSignal(templateID, SignalId, cancelToken);
            const selectedSignal = {
                label: outputSignal?.name,
                value: outputSignal
            };
            return {
                key: `${SignalId}-${i}`,
                selectedConditionType,
                selectedSignal,
                selectedSignalCollection,
                signals: [],
                ...this._handleConditionValue(Value)
            };
        });
        return Promise.all(outputSignalRequests);
    }
    _handleSelectedConditionType(type) {
        const label = this.ruleTypeDisplayMap.get(type);
        if (!label) return null;
        return {
            value: type,
            label
        };
    }
    _handleConditionValue(value) {
        if (Array.isArray(value)) {
            const [low, high] = value;
            return {
                singleOrLowValue: String(low),
                highValue: String(high)
            };
        }
        return {
            singleOrLowValue: String(value)
        };
    }
    async transformConditionsForDisplay(Conditions, model, cancelToken) {
        if ((0, _isEmptyDefault.default)(Conditions) || (0, _isEmptyDefault.default)(model)) {
            const key = String(Math.ceil(Math.random() * 100000000000));
            return [
                {
                    key
                }
            ];
        }
        const collectionsMap = new Map(model.datapoints?.map?.((sc)=>[
                sc?._id,
                sc
            ]) || []);
        const { eventCollectionConditions, outputSignalConditions } = Conditions.reduce((acc, condition)=>{
            if (collectionsMap.has(condition.SignalCollectionId)) acc.eventCollectionConditions.push(condition);
            else acc.outputSignalConditions.push(condition);
            return acc;
        }, {
            eventCollectionConditions: [],
            outputSignalConditions: []
        });
        const eventConditions = eventCollectionConditions.map((c, i)=>{
            const { SignalId, SignalCollectionId, Type, Value } = c;
            const { selectedSignalCollection, selectedSignal, signals, unit } = this._handleConditionSignalCollectionAndSignal(collectionsMap, SignalCollectionId, SignalId);
            const selectedConditionType = this._handleSelectedConditionType(Type);
            const displayProps = {
                key: `${SignalId}-${i}`,
                selectedSignalCollection,
                selectedSignal,
                signals,
                unit,
                selectedConditionType,
                ...this._handleConditionValue(Value)
            };
            return {
                ...c,
                ...displayProps
            };
        });
        const outputSignalConditionProms = await this._handleOutputSignalCondtions(outputSignalConditions, model?._id, cancelToken);
        return eventConditions.concat(outputSignalConditionProms);
    }
    parseCondition(datapointMap, datapointID, signalID) {
        const targetCollection = datapointMap[datapointID];
        if ((0, _isEmptyDefault.default)(targetCollection.values)) return {};
        const targetSignal = targetCollection.values.find(({ _id })=>_id === signalID);
        if ((0, _isEmptyDefault.default)(targetSignal)) return {};
        const { name, label, unit = "" } = targetSignal;
        return {
            signalCollectionName: targetCollection.name,
            signalName: name || label,
            unit
        };
    }
    parseThresholdValue(value) {
        return Array.isArray(value) ? value.join(" | ") : value;
    }
    transformRulesForDisplay(asset, rules = []) {
        const { gtemplate: { datapoints } } = asset;
        const datapointMap = (0, _keyByDefault.default)(datapoints, "_id");
        return rules.map(({ Id, Name, Conditions, Enabled, Frequency })=>{
            if ((0, _isEmptyDefault.default)(Conditions)) return;
            const ProcessedConditions = Conditions.map(({ SignalCollectionId, SignalId, Type, Value })=>{
                const { signalCollectionName, signalName, unit } = this.parseCondition(datapointMap, SignalCollectionId, SignalId);
                const threshold = this.ruleTypeDisplayMap.get(Type);
                const value = this.parseThresholdValue(Value);
                return {
                    threshold,
                    value,
                    signalCollectionName,
                    signalName,
                    SignalId,
                    unit
                };
            });
            return {
                Id,
                Name,
                Enabled,
                Frequency,
                Conditions: ProcessedConditions
            };
        }).filter((r)=>!!r);
    }
    addSubscriptionsToRules(rules, subs) {
        const ruleSubsDictionary = subs.reduce((dict, sub)=>{
            if (sub.Trigger === "dm1") return dict;
            dict[sub.RuleId] = sub;
            return dict;
        }, {});
        return rules.map((rule)=>{
            const { Notification, Id } = ruleSubsDictionary[rule.Id] || {};
            if (!Id || !Notification) return rule;
            const Subscription = {
                [Notification]: ruleSubsDictionary[rule.Id]
            };
            return Object.assign({}, rule, Subscription);
        });
    }
}
exports.default = RuleUtils;

},{"lodash/isEmpty":"6WyGC","lodash/keyBy":"jPLxF","../Constants/Rule":"2HV6i","../Services/TemplateService":"hGdvK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jPLxF":[function(require,module,exports) {
var baseAssignValue = require("c46c3767ff672674"), createAggregator = require("6b8d7408337ccc56");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var keyBy = createAggregator(function(result, value, key) {
    baseAssignValue(result, key, value);
});
module.exports = keyBy;

},{"c46c3767ff672674":"ba13n","6b8d7408337ccc56":"jVRMw"}],"jVRMw":[function(require,module,exports) {
var arrayAggregator = require("64738ab87169df22"), baseAggregator = require("d5eaf98cd48e9d0f"), baseIteratee = require("161d63ee0d95ee81"), isArray = require("3ebefba2225c8b9e");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
module.exports = createAggregator;

},{"64738ab87169df22":"6j2f9","d5eaf98cd48e9d0f":"bF1ce","161d63ee0d95ee81":"6jZAq","3ebefba2225c8b9e":"1DVeR"}],"6j2f9":[function(require,module,exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = arrayAggregator;

},{}],"bF1ce":[function(require,module,exports) {
var baseEach = require("b2d4f581dd6625d8");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = baseAggregator;

},{"b2d4f581dd6625d8":"hbtgh"}],"2HV6i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEVERITY_CRITICAL", ()=>SEVERITY_CRITICAL);
parcelHelpers.export(exports, "SEVERITY_INFO", ()=>SEVERITY_INFO);
parcelHelpers.export(exports, "SEVERITY_WARNING", ()=>SEVERITY_WARNING);
parcelHelpers.export(exports, "SEVERITIES", ()=>SEVERITIES);
parcelHelpers.export(exports, "TEMPLATE_TYPE", ()=>TEMPLATE_TYPE);
parcelHelpers.export(exports, "TEMPLATE_WEATHER_TYPE", ()=>TEMPLATE_WEATHER_TYPE);
parcelHelpers.export(exports, "friendlyRuleNameMap", ()=>friendlyRuleNameMap);
parcelHelpers.export(exports, "ruleTypeFriendlyName", ()=>ruleTypeFriendlyName);
const SEVERITY_CRITICAL = "critical";
const SEVERITY_INFO = "info";
const SEVERITY_WARNING = "warning";
const SEVERITIES = [
    SEVERITY_CRITICAL,
    SEVERITY_INFO,
    SEVERITY_WARNING
];
const TEMPLATE_TYPE = "template";
const TEMPLATE_WEATHER_TYPE = "template-weather";
const friendlyRuleNameMap = new Map([
    [
        TEMPLATE_TYPE,
        "Signal"
    ],
    [
        TEMPLATE_WEATHER_TYPE,
        "Weather"
    ]
]);
function ruleTypeFriendlyName(type) {
    return friendlyRuleNameMap.get(type) ?? "Unknown";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8u6bN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BooleanWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
function BooleanWidget({ data }) {
    function parseValue(value) {
        if (!value || value === 0) return {
            className: "text-danger",
            icon: (0, _freeSolidSvgIcons.faTimes)
        };
        return {
            className: "text-success",
            icon: (0, _freeSolidSvgIcons.faCheck)
        };
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "container-fluid",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "row py-2 sticky-top font-weight-light text-text-light-gray bg-white",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "col-6 mb-0",
                        children: "Signal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "col-4 col-md-5 mb-0",
                        children: "Timestamp"
                    })
                ]
            }),
            Array.isArray(data) ? data.map(({ name, value, time }, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "row mb-1 align-items-center text-muted nine-tenth-text",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                ...parseValue(value)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col-6 break-word mb-0",
                            children: name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col-4 col-md-5 mb-0",
                            children: time
                        })
                    ]
                }, `${name}_${i}`)) : null
        ]
    });
}
BooleanWidget.propTypes = {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
};
BooleanWidget.defaultProps = {
    data: []
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bIm4e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _rbac = require("../../Constants/RBAC");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
exports.default = /*#__PURE__*/ (0, _react.memo)(CommandsWidget);
const initState = {
    error: "",
    executeRequestPending: false,
    jobParameter: "",
    showConfirmationModal: ""
};
function CommandsWidget(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const source = (0, _axios.CancelToken).source();
    const { _id: assetID, gtemplate, orgID, remote: assetRemote } = props.asset || {};
    const commands = props.commands?.filter?.(({ commandID } = {})=>{
        return gtemplate?.commands?.some?.(({ _id })=>_id === commandID);
    }) || [];
    const commandToExecute = (0, _react.useMemo)(()=>{
        if (!state.showConfirmationModal) return {};
        return gtemplate?.commands?.find?.(({ _id })=>_id === state.showConfirmationModal);
    }, [
        gtemplate?.commands,
        state.showConfirmationModal
    ]);
    const executeCommand = async ()=>{
        try {
            if (!commandToExecute?._id) throw new Error("Invalid command selected");
            updateState((prevState)=>({
                    ...prevState,
                    executeRequestPending: true
                }));
            const body = state.jobParameter ? {
                jobParameters: [
                    state.jobParameter
                ]
            } : {};
            await new (0, _assetServiceDefault.default)().executeAssetCommand(assetID, {
                commandID: commandToExecute._id
            }, body, source.token);
            props.handleCommandExecuted(commandToExecute?.name);
            updateState(initState);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    executeRequestPending: false
                }));
        }
    };
    const handleParameterInput = ({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value,
                error: ""
            }));
    };
    const toggleConfirmationModal = (showConfirmationModal = "")=>{
        updateState((prevState)=>({
                ...prevState,
                showConfirmationModal
            }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "p-3 px-md-5",
        children: [
            commands.map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "my-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        data: {
                            assetRemote
                        },
                        no: (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                "data-for": c.friendlyName,
                                "data-tip": data,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExecuteCommandButton, {
                                        ...c,
                                        isDisabled: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                        id: c.friendlyName
                                    })
                                ]
                            }),
                        orgID: orgID,
                        perform: (0, _rbac.REMOTE_EXECUTE),
                        resource: (0, _rbac.REMOTE),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ExecuteCommandButton, {
                                ...c,
                                toggleConfirmationModal: toggleConfirmationModal
                            })
                    })
                }, c.commandID)),
            state.showConfirmationModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CommandConfirmationModal, {
                ...props,
                ...state,
                command: commandToExecute,
                executeCommand: executeCommand,
                handleParameterInput: handleParameterInput,
                toggleConfirmationModal: toggleConfirmationModal
            }) : null
        ]
    });
}
CommandsWidget.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplate: (0, _propTypesDefault.default).shape({
            commands: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        }),
        nickname: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        remote: (0, _propTypesDefault.default).bool
    }),
    commands: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        color: (0, _propTypesDefault.default).string,
        commandID: (0, _propTypesDefault.default).string,
        friendlyName: (0, _propTypesDefault.default).string
    })),
    handleCommandExecuted: (0, _propTypesDefault.default).func
};
function ExecuteCommandButton(props) {
    const conditionallyDisabled = props.isDisabled ? {
        disabled: true
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ...conditionallyDisabled,
        className: `btn btn-block btn-${props.color} text-white shadow-none rounded-lg`,
        onClick: ()=>props.toggleConfirmationModal(props.commandID),
        children: props.friendlyName
    });
}
ExecuteCommandButton.propTypes = {
    color: (0, _propTypesDefault.default).string,
    commandID: (0, _propTypesDefault.default).string,
    friendlyName: (0, _propTypesDefault.default).string,
    isDisabled: (0, _propTypesDefault.default).bool,
    toggleConfirmationModal: (0, _propTypesDefault.default).func
};
function CommandConfirmationModal(props) {
    const { commandControlIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const isParameterized = props.command?.parameters?.length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdrop: props.executeRequestPending ? "static" : true,
        centered: true,
        isOpen: !!props.showConfirmationModal,
        toggle: ()=>props.executeRequestPending ? null : props.toggleConfirmationModal(),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: ()=>props.executeRequestPending ? null : props.toggleConfirmationModal(),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        alt: "command-icon",
                        height: 40,
                        src: commandControlIcon,
                        width: 40,
                        className: "jsx-2864349061"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-2864349061 mb-0 mx-2 text-dark font-weight-bold",
                        children: "Execute Command"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-2864349061 mb-0 text-text-light-gray font-weight-light",
                        children: props.asset?.nickname ?? ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-2864349061",
                        children: "Please ensure that this is the Command that you wish to send to the device."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2864349061 text-dark font-weight-bold d-flex align-items-center justify-content-between",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-2864349061",
                            children: props.command?.name
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2864349061 " + ((isParameterized ? "form-group row align-items-center" : "d-none") || ""),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "jobParameter",
                                className: "jsx-2864349061 col-sm-4 col-form-label three-quarter-text",
                                children: "Parameter:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2864349061 col-sm-8",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    name: "jobParameter",
                                    onChange: props.handleParameterInput,
                                    type: "text",
                                    value: props.jobParameter,
                                    className: "jsx-2864349061 form-control form-control-sm"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-2864349061 text-alert-orange font-weight-bold",
                        children: "Warning: you can't undo this action."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-2864349061 " + ((props.error ? "text-danger text-right" : "d-none") || ""),
                        children: props.error
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: props.executeRequestPending,
                        onClick: ()=>props.toggleConfirmationModal(),
                        className: "jsx-2864349061 btn btn-sm btn-outline-secondary bg-white text-muted shadow-none rounded-lg",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: props.executeRequestPending || isParameterized && !props.jobParameter,
                        onClick: props.executeCommand,
                        className: "jsx-2864349061 btn btn-sm modal-button-submit rounded-lg",
                        children: props.executeRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            className: "text-white",
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Yes, Execute Command"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2864349061",
                children: ".btn:focus{outline:none;}.modal-title{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}@media (min-width:768px){.modal-title{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}}"
            })
        ]
    });
}
CommandConfirmationModal.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        nickname: (0, _propTypesDefault.default).string
    }),
    command: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        name: (0, _propTypesDefault.default).string,
        command: (0, _propTypesDefault.default).string,
        parameters: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
    }),
    error: (0, _propTypesDefault.default).string,
    executeCommand: (0, _propTypesDefault.default).func,
    executeRequestPending: (0, _propTypesDefault.default).bool,
    handleParameterInput: (0, _propTypesDefault.default).func,
    jobParameter: (0, _propTypesDefault.default).string,
    showConfirmationModal: (0, _propTypesDefault.default).string,
    toggleConfirmationModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","react-tooltip":"4ejwp","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../RBAC/Can":"l4l8D","../../Services/AssetService":"fL096","../../Constants/RBAC":"ieo1E","../../Context/IconsContext":"lzIpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bIlyG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _api = require("@react-google-maps/api");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _staticUUIDs = require("../../Constants/StaticUUIDs");
exports.default = /*#__PURE__*/ (0, _react.memo)(CurrentLocationWidget);
function CurrentLocationWidget({ datapointID, fetchedData }) {
    const { offlinePin, onlinePin } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const [{ signals = {} } = {}] = fetchedData.get((0, _staticUUIDs.CONNECT_DISCONNECT_ID)) || [];
    const { value: status } = Object.values(signals || {}).find(({ name } = {})=>name === "connect-disconnect") || {};
    const mostRecentEvent = (fetchedData.get(datapointID) || []).reduce((mostRecent, event)=>{
        if (!mostRecent.createdAt) return event;
        const eventIsMoreRecent = new Date(event.createdAt).valueOf() > new Date(mostRecent.createdAt).valueOf();
        return eventIsMoreRecent ? event : mostRecent;
    }, {});
    const { latitude, longitude } = Object.values(mostRecentEvent?.signals || {})?.reduce?.((acc, { name, value })=>{
        const keys = Object.keys(acc);
        if (keys.includes(name)) acc[name] = value;
        return acc;
    }, {
        latitude: null,
        longitude: null
    }) ?? {};
    const position = latitude && longitude ? {
        lat: latitude,
        lng: longitude
    } : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.GoogleMap), {
        center: position,
        clickableIcons: false,
        zoom: 15,
        mapContainerClassName: "h-100",
        mapContainerStyle: {
            borderBottomLeftRadius: "1rem",
            borderBottomRightRadius: "1rem"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _api.Marker), {
            clickable: false,
            icon: status === "deviceConnect" ? onlinePin : offlinePin,
            position: position
        })
    });
}
CurrentLocationWidget.propTypes = {
    datapointID: (0, _propTypesDefault.default).string,
    fetchedData: (0, _propTypesDefault.default).object
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@react-google-maps/api":"jDQ7N","../../Context/IconsContext":"lzIpe","../../Constants/StaticUUIDs":"cpjYY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lXUOv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactD3Speedometer = require("react-d3-speedometer");
var _reactD3SpeedometerDefault = parcelHelpers.interopDefault(_reactD3Speedometer);
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _widthContext = require("../../Context/WidthContext");
exports.default = /*#__PURE__*/ (0, _react.memo)(FlexibleRangeGaugeWidget);
function FlexibleRangeGaugeWidget(props) {
    const [state, updateState] = (0, _react.useState)({
        height: 0,
        width: 0
    });
    const { primary } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const vw = (0, _react.useContext)((0, _widthContext.Width));
    const containerRef = (0, _react.useRef)();
    const { datapointID, key, ranges, secondGauge: { datapointID: datapointID1, key: key1, ranges: ranges1 } = {} } = props.widget?.settings || {};
    const lines = [
        {
            cID: datapointID,
            k: key,
            r: ranges
        },
        {
            cID: datapointID1,
            k: key1,
            r: ranges1
        }
    ].reduce((acc, { cID, k, r })=>{
        if (!cID) return acc;
        const { signals = {} } = props.fetchedData?.get?.(cID)?.[0] || {};
        let { value } = Object.values(signals || {})?.find(({ name })=>name === k) || {};
        const { display_precision = 2, unit } = props.signalUnitsMap.get(cID)?.[k] || {};
        const displayValue = Number.isInteger(value) ? value : value?.toFixed?.(display_precision ?? 2) ?? "";
        const { customSegmentLabels, customSegmentStops, maxValue, minValue, segmentColors, segments } = r.reduce((acc, { color, label, max, min } = {})=>{
            acc.customSegmentLabels.push({
                color: "#494949",
                fontSize: datapointID1 ? "10px" : "14px",
                position: vw >= 768 ? (0, _reactD3Speedometer.CustomSegmentLabelPosition).Inside : (0, _reactD3Speedometer.CustomSegmentLabelPosition).Outside,
                text: label
            });
            acc.customSegmentStops = [
                ...new Set([
                    ...acc.customSegmentStops,
                    min,
                    max
                ])
            ].sort((a, b)=>a - b);
            acc.segmentColors.push(color);
            acc.segments += 1;
            if (typeof acc.maxValue === "undefined" || acc.maxValue < max) acc.maxValue = max;
            if (typeof acc.minValue === "undefined" || acc.minValue > min) acc.minValue = min;
            return acc;
        }, {
            customSegmentLabels: [],
            customSegmentStops: [],
            maxValue: undefined,
            minValue: undefined,
            segmentColors: [],
            segments: 0
        });
        let currentValueText = `${displayValue}${unit ? ` ${unit}` : ""}`;
        if (value < minValue) {
            currentValueText = `Current value: ${displayValue} < ${minValue}${unit ? ` ${unit}` : ""}`;
            value = minValue;
        }
        if (value > maxValue) {
            currentValueText = `Current value: ${displayValue} > ${maxValue}${unit ? ` ${unit}` : ""}`;
            value = maxValue;
        }
        acc.push({
            currentValueText,
            customSegmentLabels,
            customSegmentStops,
            maxValue,
            minValue,
            segmentColors,
            segments,
            signalName: k,
            value: typeof value === "string" ? undefined : value
        });
        return acc;
    }, []);
    const needleHeightRatio = (0, _react.useMemo)(()=>{
        switch(true){
            case vw < 768 && lines.length === 2:
                return 0.6;
            case vw < 768 && lines.length === 1:
            case vw > 768 && lines.length === 2:
                return 0.75;
            default:
                return 0.9;
        }
    }, [
        lines.length,
        vw
    ]);
    const ringWidth = (0, _react.useMemo)(()=>{
        switch(true){
            case vw < 768 && lines.length === 2:
                return 15;
            case vw > 768 && lines.length === 2:
            case vw < 768 && lines.length === 1:
                return 30;
            default:
                return 60;
        }
    }, [
        lines.length,
        vw
    ]);
    (0, _react.useEffect)(()=>{
        window.setTimeout(()=>{
            const { width: containerWidth } = containerRef?.current?.getBoundingClientRect?.() || {};
            let width = containerWidth;
            if (lines.length === 2) {
                const padding = vw < 768 ? 10 : 0;
                width = containerWidth / 2 - padding;
            } else if (vw > 1500) width = containerWidth * 0.75;
            else if (vw < 992 && vw >= 576) width = containerWidth * 0.5;
            const height = width / 2 + 30;
            updateState((prevState)=>({
                    ...prevState,
                    height,
                    width
                }));
        });
    }, [
        lines.length,
        vw
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "position-absolute h-100 w-100 row no-gutters align-items-stretch",
        ref: containerRef,
        children: lines.map((l, i)=>{
            const noData = !l.value && l.value !== 0;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col p-0 position-relative",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "position-absolute h-100 w-100 d-flex flex-column align-items-center justify-content-center",
                    children: [
                        lines.length === 2 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-center text-bold mb-0 px-1 px-md-3 three-quarter-text",
                            children: noData ? "" : l.signalName
                        }) : null,
                        noData ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-fill d-flex align-items-center justify-content-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-center three-quarter-text mb-0 mx-4 p-3 border border-hr-gray shadow-sm rounded rounded-lg",
                                children: `No data for ${l.signalName}`
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactD3SpeedometerDefault.default), {
                            customSegmentLabels: l.customSegmentLabels,
                            currentValueText: l.currentValueText,
                            customSegmentStops: l.customSegmentStops,
                            forceRender: true,
                            height: state.height,
                            maxValue: l.maxValue,
                            minValue: l.minValue,
                            needleColor: primary,
                            needleHeightRatio: needleHeightRatio,
                            needleTransitionDuration: 0,
                            ringWidth: ringWidth,
                            segmentColors: l.segmentColors,
                            segments: l.segments,
                            textColor: "#494949",
                            value: l.value,
                            valueTextFontSize: "12px",
                            width: state.width
                        })
                    ]
                })
            }, `${l.cID}${i}`);
        })
    });
}
FlexibleRangeGaugeWidget.propTypes = {
    fetchedData: (0, _propTypesDefault.default).object,
    graphIndex: (0, _propTypesDefault.default).number,
    graphWidgetIDs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    renderNextGraph: (0, _propTypesDefault.default).func,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    widget: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        settings: (0, _propTypesDefault.default).shape({
            datapoint: (0, _propTypesDefault.default).object,
            datapointID: (0, _propTypesDefault.default).string,
            key: (0, _propTypesDefault.default).string,
            ranges: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                color: (0, _propTypesDefault.default).string,
                label: (0, _propTypesDefault.default).string,
                max: (0, _propTypesDefault.default).number,
                min: (0, _propTypesDefault.default).number
            })),
            secondGauge: (0, _propTypesDefault.default).shape({
                datapoint: (0, _propTypesDefault.default).object,
                datapointID: (0, _propTypesDefault.default).string,
                key: (0, _propTypesDefault.default).string,
                ranges: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                    color: (0, _propTypesDefault.default).string,
                    label: (0, _propTypesDefault.default).string,
                    max: (0, _propTypesDefault.default).number,
                    min: (0, _propTypesDefault.default).number
                }))
            }),
            title: (0, _propTypesDefault.default).string
        })
    })
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-d3-speedometer":"mDdG3","../../Context/BrandingContext":"bKKTd","../../Context/WidthContext":"5c6Dv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"mDdG3":[function(require,module,exports) {
"use strict";
var _interopRequireWildcard = require("2d5dd064868a87c4"), _interopRequireDefault = require("51e0df6b29058db0");
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "CustomSegmentLabelPosition", {
    enumerable: !0,
    get: function get() {
        return _enums.CustomSegmentLabelPosition;
    }
}), Object.defineProperty(exports, "Transition", {
    enumerable: !0,
    get: function get() {
        return _enums.Transition;
    }
}), exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("3215c3d1b52762ba")), _createClass2 = _interopRequireDefault(require("fed77715f8e17beb")), _assertThisInitialized2 = _interopRequireDefault(require("9b05ce1dc13eb57e")), _inherits2 = _interopRequireDefault(require("fa561395401402e")), _possibleConstructorReturn2 = _interopRequireDefault(require("8ea6120aa7e81bc3")), _getPrototypeOf2 = _interopRequireDefault(require("394b181ece31c466")), _defineProperty2 = _interopRequireDefault(require("4ba5fd0fb2e193b9")), _react = _interopRequireWildcard(require("1a31f24702202057")), _propTypes = _interopRequireDefault(require("b28a8dd7c0db0785")), _d = require("7bd566931bff9c75"), _config = require("f6bdcb9106f32c65"), _render = require("367d554b814b7567"), _enums = require("34837e696aae80b4");
function _createSuper(a) {
    var b = _isNativeReflectConstruct();
    return function() {
        var c, d = (0, _getPrototypeOf2["default"])(a);
        if (b) {
            var e = (0, _getPrototypeOf2["default"])(this).constructor;
            c = Reflect.construct(d, arguments, e);
        } else c = d.apply(this, arguments);
        return (0, _possibleConstructorReturn2["default"])(this, c);
    };
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
    } catch (a) {
        return !1;
    }
}
var ReactSpeedometer = function(a) {
    function b(a) {
        var d;
        return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "render", function() {
            return _react["default"].createElement("div", {
                ref: function ref(a) {
                    return d.gaugeDiv = a;
                }
            });
        }), d.d3_refs = {
            pointer: !1,
            current_value_text: !1
        }, d;
    }
    (0, _inherits2["default"])(b, a);
    var c = _createSuper(b);
    return (0, _createClass2["default"])(b, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderGauge();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.props.forceRender ? this.renderGauge() : this.updateReadings();
            }
        },
        {
            key: "renderGauge",
            value: function renderGauge() {
                this.config = (0, _config.getConfig)({
                    PROPS: this.props,
                    parentWidth: this.gaugeDiv.parentNode.clientWidth,
                    parentHeight: this.gaugeDiv.parentNode.clientHeight
                }), (0, _d.select)(this.gaugeDiv).select("svg").remove(), this.d3_refs = (0, _render.render)({
                    container: this.gaugeDiv,
                    config: this.config
                }), (0, _render.update)({
                    d3_refs: this.d3_refs,
                    newValue: this.props.value,
                    config: this.config
                });
            }
        },
        {
            key: "updateReadings",
            value: function updateReadings() {
                this.config = (0, _config.updateConfig)(this.config, {
                    labelFormat: (0, _d.format)(this.props.valueFormat || ""),
                    segmentValueFormatter: this.props.segmentValueFormatter || _config.defaultSegmentValueFormatter,
                    currentValueText: this.props.currentValueText || "${value}"
                }), (0, _render.update)({
                    d3_refs: this.d3_refs,
                    newValue: this.props.value || 0,
                    config: this.config
                });
            }
        }
    ]), b;
}(_react.PureComponent);
(0, _defineProperty2["default"])(ReactSpeedometer, "displayName", "ReactSpeedometer"), ReactSpeedometer.propTypes = {
    value: _propTypes["default"].number.isRequired,
    minValue: _propTypes["default"].number.isRequired,
    maxValue: _propTypes["default"].number.isRequired,
    forceRender: _propTypes["default"].bool.isRequired,
    width: _propTypes["default"].number.isRequired,
    height: _propTypes["default"].number.isRequired,
    paddingHorizontal: _propTypes["default"].number.isRequired,
    paddingVertical: _propTypes["default"].number.isRequired,
    dimensionUnit: _propTypes["default"].string.isRequired,
    fluidWidth: _propTypes["default"].bool.isRequired,
    segments: _propTypes["default"].number.isRequired,
    maxSegmentLabels: _propTypes["default"].number,
    customSegmentStops: _propTypes["default"].array,
    customSegmentLabels: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        text: _propTypes["default"].string,
        position: _propTypes["default"].oneOf([
            "OUTSIDE",
            "INSIDE"
        ]),
        fontSize: _propTypes["default"].string,
        color: _propTypes["default"].string
    })),
    needleColor: _propTypes["default"].string.isRequired,
    startColor: _propTypes["default"].string.isRequired,
    endColor: _propTypes["default"].string.isRequired,
    segmentColors: _propTypes["default"].array.isRequired,
    needleTransition: _propTypes["default"].string.isRequired,
    needleTransitionDuration: _propTypes["default"].number.isRequired,
    needleHeightRatio: _propTypes["default"].number.isRequired,
    ringWidth: _propTypes["default"].number.isRequired,
    textColor: _propTypes["default"].string.isRequired,
    valueFormat: _propTypes["default"].string.isRequired,
    segmentValueFormatter: _propTypes["default"].func,
    currentValueText: _propTypes["default"].string.isRequired,
    currentValuePlaceholderStyle: _propTypes["default"].string.isRequired,
    labelFontSize: _propTypes["default"].string.isRequired,
    valueTextFontSize: _propTypes["default"].string.isRequired,
    valueTextFontWeight: _propTypes["default"].string.isRequired,
    svgAriaLabel: _propTypes["default"].string
}, ReactSpeedometer.defaultProps = _config.DEFAULT_PROPS;
var _default = ReactSpeedometer;
exports["default"] = _default;

},{"2d5dd064868a87c4":"fiRIh","51e0df6b29058db0":"kZ6eK","3215c3d1b52762ba":"6C9u8","fed77715f8e17beb":"g9J5L","9b05ce1dc13eb57e":"f0luE","fa561395401402e":"43peb","8ea6120aa7e81bc3":"2pp8P","394b181ece31c466":"CaUfL","4ba5fd0fb2e193b9":"hjdoh","1a31f24702202057":"9njXz","b28a8dd7c0db0785":"bnNSm","7bd566931bff9c75":"aLplL","f6bdcb9106f32c65":"5OZt8","367d554b814b7567":"1RJOt","34837e696aae80b4":"dU9sa"}],"fiRIh":[function(require,module,exports) {
var _typeof = require("41c629e90a135a51")["default"];
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"41c629e90a135a51":"979to"}],"aLplL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>(0, _packageJs.version));
var _packageJs = require("./dist/package.js");
var _d3Array = require("d3-array");
parcelHelpers.exportAll(_d3Array, exports);
var _d3Axis = require("d3-axis");
parcelHelpers.exportAll(_d3Axis, exports);
var _d3Brush = require("d3-brush");
parcelHelpers.exportAll(_d3Brush, exports);
var _d3Chord = require("d3-chord");
parcelHelpers.exportAll(_d3Chord, exports);
var _d3Color = require("d3-color");
parcelHelpers.exportAll(_d3Color, exports);
var _d3Contour = require("d3-contour");
parcelHelpers.exportAll(_d3Contour, exports);
var _d3Delaunay = require("d3-delaunay");
parcelHelpers.exportAll(_d3Delaunay, exports);
var _d3Dispatch = require("d3-dispatch");
parcelHelpers.exportAll(_d3Dispatch, exports);
var _d3Drag = require("d3-drag");
parcelHelpers.exportAll(_d3Drag, exports);
var _d3Dsv = require("d3-dsv");
parcelHelpers.exportAll(_d3Dsv, exports);
var _d3Ease = require("d3-ease");
parcelHelpers.exportAll(_d3Ease, exports);
var _d3Fetch = require("d3-fetch");
parcelHelpers.exportAll(_d3Fetch, exports);
var _d3Force = require("d3-force");
parcelHelpers.exportAll(_d3Force, exports);
var _d3Format = require("d3-format");
parcelHelpers.exportAll(_d3Format, exports);
var _d3Geo = require("d3-geo");
parcelHelpers.exportAll(_d3Geo, exports);
var _d3Hierarchy = require("d3-hierarchy");
parcelHelpers.exportAll(_d3Hierarchy, exports);
var _d3Interpolate = require("d3-interpolate");
parcelHelpers.exportAll(_d3Interpolate, exports);
var _d3Path = require("d3-path");
parcelHelpers.exportAll(_d3Path, exports);
var _d3Polygon = require("d3-polygon");
parcelHelpers.exportAll(_d3Polygon, exports);
var _d3Quadtree = require("d3-quadtree");
parcelHelpers.exportAll(_d3Quadtree, exports);
var _d3Random = require("d3-random");
parcelHelpers.exportAll(_d3Random, exports);
var _d3Scale = require("d3-scale");
parcelHelpers.exportAll(_d3Scale, exports);
var _d3ScaleChromatic = require("d3-scale-chromatic");
parcelHelpers.exportAll(_d3ScaleChromatic, exports);
var _d3Selection = require("d3-selection");
parcelHelpers.exportAll(_d3Selection, exports);
var _d3Shape = require("d3-shape");
parcelHelpers.exportAll(_d3Shape, exports);
var _d3Time = require("d3-time");
parcelHelpers.exportAll(_d3Time, exports);
var _d3TimeFormat = require("d3-time-format");
parcelHelpers.exportAll(_d3TimeFormat, exports);
var _d3Timer = require("d3-timer");
parcelHelpers.exportAll(_d3Timer, exports);
var _d3Transition = require("d3-transition");
parcelHelpers.exportAll(_d3Transition, exports);
var _d3Zoom = require("d3-zoom");
parcelHelpers.exportAll(_d3Zoom, exports);

},{"./dist/package.js":"8lz8F","d3-array":"aoYKF","d3-axis":"41neH","d3-brush":"eFd4k","d3-chord":"4B9KG","d3-color":"jv6Pr","d3-contour":"klb8D","d3-delaunay":"lOwa3","d3-dispatch":"2VwUr","d3-drag":"HHNYu","d3-dsv":"59Jxi","d3-ease":"djx4i","d3-fetch":"cZ2qo","d3-force":"67Mne","d3-format":"97aCb","d3-geo":"iQZKv","d3-hierarchy":"cFwdY","d3-interpolate":"5gJW0","d3-path":"a7nC8","d3-polygon":"e5TI9","d3-quadtree":"5yYuF","d3-random":"4hcGu","d3-scale":"8BE7D","d3-scale-chromatic":"1ruLi","d3-selection":"9PvvP","d3-shape":"c0b97","d3-time":"bCmrc","d3-time-format":"6Z3KL","d3-timer":"lpgSt","d3-transition":"aj1c5","d3-zoom":"9wSnq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lz8F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "description", ()=>description);
parcelHelpers.export(exports, "keywords", ()=>keywords);
parcelHelpers.export(exports, "homepage", ()=>homepage);
parcelHelpers.export(exports, "license", ()=>license);
parcelHelpers.export(exports, "author", ()=>author);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "unpkg", ()=>unpkg);
parcelHelpers.export(exports, "jsdelivr", ()=>jsdelivr);
parcelHelpers.export(exports, "module", ()=>module);
parcelHelpers.export(exports, "repository", ()=>repository);
parcelHelpers.export(exports, "files", ()=>files);
parcelHelpers.export(exports, "scripts", ()=>scripts);
parcelHelpers.export(exports, "devDependencies", ()=>devDependencies);
parcelHelpers.export(exports, "dependencies", ()=>dependencies);
var name = "d3";
var version = "6.7.0";
var description = "Data-Driven Documents";
var keywords = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var main = "dist/d3.node.js";
var unpkg = "dist/d3.min.js";
var jsdelivr = "dist/d3.min.js";
var module = "index.js";
var repository = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var files = [
    "dist/**/*.js",
    "index.js"
];
var scripts = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": 'git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m "d3 ${npm_package_version}" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js'
};
var devDependencies = {
    "json2module": "0.0",
    "rimraf": "3",
    "rollup": "2",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "5",
    "rollup-plugin-terser": "7",
    "tape": "4",
    "tape-await": "0.1"
};
var dependencies = {
    "d3-array": "2",
    "d3-axis": "2",
    "d3-brush": "2",
    "d3-chord": "2",
    "d3-color": "2",
    "d3-contour": "2",
    "d3-delaunay": "5",
    "d3-dispatch": "2",
    "d3-drag": "2",
    "d3-dsv": "2",
    "d3-ease": "2",
    "d3-fetch": "2",
    "d3-force": "2",
    "d3-format": "2",
    "d3-geo": "2",
    "d3-hierarchy": "2",
    "d3-interpolate": "2",
    "d3-path": "2",
    "d3-polygon": "2",
    "d3-quadtree": "2",
    "d3-random": "2",
    "d3-scale": "3",
    "d3-scale-chromatic": "2",
    "d3-selection": "2",
    "d3-shape": "2",
    "d3-time": "2",
    "d3-time-format": "3",
    "d3-timer": "2",
    "d3-transition": "2",
    "d3-zoom": "2"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoYKF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectJsDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisectJs.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisectJs.bisectLeft));
parcelHelpers.export(exports, "bisectCenter", ()=>(0, _bisectJs.bisectCenter));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorJsDefault.default));
parcelHelpers.export(exports, "count", ()=>(0, _countJsDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "cumsum", ()=>(0, _cumsumJsDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationJsDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentJsDefault.default));
parcelHelpers.export(exports, "Adder", ()=>(0, _fsumJs.Adder));
parcelHelpers.export(exports, "fsum", ()=>(0, _fsumJs.fsum));
parcelHelpers.export(exports, "fcumsum", ()=>(0, _fsumJs.fcumsum));
parcelHelpers.export(exports, "group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "groups", ()=>(0, _groupJs.groups));
parcelHelpers.export(exports, "index", ()=>(0, _groupJs.index));
parcelHelpers.export(exports, "indexes", ()=>(0, _groupJs.indexes));
parcelHelpers.export(exports, "rollup", ()=>(0, _groupJs.rollup));
parcelHelpers.export(exports, "rollups", ()=>(0, _groupJs.rollups));
parcelHelpers.export(exports, "groupSort", ()=>(0, _groupSortJsDefault.default));
parcelHelpers.export(exports, "bin", ()=>(0, _binJsDefault.default)) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", ()=>(0, _binJsDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisJsDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottJsDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxIndex", ()=>(0, _maxIndexJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minIndex", ()=>(0, _minIndexJsDefault.default));
parcelHelpers.export(exports, "nice", ()=>(0, _niceJsDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsJsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteJsDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "quantileSorted", ()=>(0, _quantileJs.quantileSorted));
parcelHelpers.export(exports, "quickselect", ()=>(0, _quickselectJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "least", ()=>(0, _leastJsDefault.default));
parcelHelpers.export(exports, "leastIndex", ()=>(0, _leastIndexJsDefault.default));
parcelHelpers.export(exports, "greatest", ()=>(0, _greatestJsDefault.default));
parcelHelpers.export(exports, "greatestIndex", ()=>(0, _greatestIndexJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default)) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "shuffler", ()=>(0, _shuffleJs.shuffler));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksJsDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticksJs.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticksJs.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "every", ()=>(0, _everyJsDefault.default));
parcelHelpers.export(exports, "some", ()=>(0, _someJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "disjoint", ()=>(0, _disjointJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "subset", ()=>(0, _subsetJsDefault.default));
parcelHelpers.export(exports, "superset", ()=>(0, _supersetJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "InternMap", ()=>(0, _internmap.InternMap));
parcelHelpers.export(exports, "InternSet", ()=>(0, _internmap.InternSet));
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"e2SWo","./ascending.js":"1y6jc","./bisector.js":"8AGhY","./count.js":"9yjzz","./cross.js":"fiX4X","./cumsum.js":"lLQdF","./descending.js":"hogJT","./deviation.js":"dG1f7","./extent.js":"hurrf","./fsum.js":"beEop","./group.js":"1CXDs","./groupSort.js":"efAid","./bin.js":"2pJxw","./threshold/freedmanDiaconis.js":"6Od34","./threshold/scott.js":"c0ke1","./threshold/sturges.js":"70wjL","./max.js":"lyQpF","./maxIndex.js":"dU47S","./mean.js":"64dcr","./median.js":"vw2AB","./merge.js":"1SDhC","./min.js":"1bloD","./minIndex.js":"9duGZ","./nice.js":"5tubz","./pairs.js":"hJu6c","./permute.js":"5UdXT","./quantile.js":"jofqf","./quickselect.js":"32BMd","./range.js":"4AFrP","./least.js":"1I9Ny","./leastIndex.js":"99kCD","./greatest.js":"khpM9","./greatestIndex.js":"fNeTR","./scan.js":"8RClz","./shuffle.js":"8oVcf","./sum.js":"gdn1u","./ticks.js":"8lqi0","./transpose.js":"5jrVL","./variance.js":"chdhs","./zip.js":"byBEE","./every.js":"j9oEd","./some.js":"4YvdA","./filter.js":"9Wd4L","./map.js":"lyGin","./reduce.js":"arQsm","./reverse.js":"lvvJN","./sort.js":"3tJWd","./difference.js":"8i7Zn","./disjoint.js":"bum5t","./intersection.js":"1dzcd","./subset.js":"2qorS","./superset.js":"1EyFC","./union.js":"4zRJ1","internmap":"fCSDr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2SWo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"1y6jc","./bisector.js":"8AGhY","./number.js":"cQ9YG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1y6jc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8AGhY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(f) {
        let delta = f;
        let compare = f;
        if (f.length === 1) {
            delta = (d, x)=>f(d) - x;
            compare = ascendingComparator(f);
        }
        function left(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                const mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        }
        function right(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                const mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
        function center(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            const i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
        }
        return {
            left,
            center,
            right
        };
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function ascendingComparator(f) {
    return (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
}

},{"./ascending.js":"1y6jc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQ9YG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x === null ? NaN : +x;
    });
parcelHelpers.export(exports, "numbers", ()=>numbers);
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9yjzz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>count);
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiX4X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cross);
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLQdF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cumsum);
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hogJT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dG1f7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deviation);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
function deviation(values, valueof) {
    const v = (0, _varianceJsDefault.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"./variance.js":"chdhs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chdhs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>variance);
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hurrf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        let min;
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beEop":[function(require,module,exports) {
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adder", ()=>Adder);
parcelHelpers.export(exports, "fsum", ()=>fsum);
parcelHelpers.export(exports, "fcumsum", ()=>fcumsum);
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1CXDs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>group);
parcelHelpers.export(exports, "groups", ()=>groups);
parcelHelpers.export(exports, "rollup", ()=>rollup);
parcelHelpers.export(exports, "rollups", ()=>rollups);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "indexes", ()=>indexes);
var _internmap = require("internmap");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
function group(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), (0, _identityJsDefault.default), keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, (0, _identityJsDefault.default), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, (0, _identityJsDefault.default), reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, _internmap.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"internmap":"fCSDr","./identity.js":"UdjmT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCSDr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", ()=>InternMap);
parcelHelpers.export(exports, "InternSet", ()=>InternSet);
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"UdjmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"efAid":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>groupSort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
function groupSort(values, reduce, key) {
    return (reduce.length === 1 ? (0, _sortJsDefault.default)((0, _groupJs.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascendingJsDefault.default)(av, bv) || (0, _ascendingJsDefault.default)(ak, bk)) : (0, _sortJsDefault.default)((0, _groupJsDefault.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascendingJsDefault.default)(ak, bk))).map(([key])=>key);
}

},{"./ascending.js":"1y6jc","./group.js":"1CXDs","./sort.js":"3tJWd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3tJWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f = (0, _ascendingJsDefault.default)] = F;
    if (f.length === 1 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = (0, _ascendingJsDefault.default)(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>(0, _ascendingJsDefault.default)(f[i], f[j]));
        }
        return (0, _permuteJsDefault.default)(values, index);
    }
    return values.sort(f);
}

},{"./ascending.js":"1y6jc","./permute.js":"5UdXT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UdXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(source, keys) {
        return Array.from(keys, (key)=>source[key]);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pJxw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), domain = (0, _extentJsDefault.default), threshold = (0, _sturgesJsDefault.default);
        function histogram(data) {
            if (!Array.isArray(data)) data = Array.from(data);
            var i, n = data.length, x, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds, and nice the
            // default domain accordingly.
            if (!Array.isArray(tz)) {
                const max = x1, tn = +tz;
                if (domain === (0, _extentJsDefault.default)) [x0, x1] = (0, _niceJsDefault.default)(x0, x1, tn);
                tz = (0, _ticksJsDefault.default)(x0, x1, tn);
                // If the last threshold is coincident with the domain’s upper bound, the
                // last bin will be zero-width. If the default domain is used, and this
                // last threshold is coincident with the maximum input value, we can
                // extend the niced upper bound by one tick to ensure uniform bin widths;
                // otherwise, we simply remove the last threshold. Note that we don’t
                // coerce values or the domain to numbers, and thus must be careful to
                // compare order (>=) rather than strict equality (===)!
                if (tz[tz.length - 1] >= x1) {
                    if (max >= x1 && domain === (0, _extentJsDefault.default)) {
                        const step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
                        if (isFinite(step)) {
                            if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                            else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                        }
                    } else tz.pop();
                }
            }
            // Remove any thresholds outside the domain.
            var m = tz.length;
            while(tz[0] <= x0)tz.shift(), --m;
            while(tz[m - 1] > x1)tz.pop(), --m;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            for(i = 0; i < n; ++i){
                x = values[i];
                if (x0 <= x && x <= x1) bins[(0, _bisectJsDefault.default)(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), histogram) : threshold;
        };
        return histogram;
    });
var _arrayJs = require("./array.js");
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);

},{"./array.js":"aKBe4","./bisect.js":"e2SWo","./constant.js":"ed8jk","./extent.js":"hurrf","./identity.js":"UdjmT","./nice.js":"5tubz","./ticks.js":"8lqi0","./threshold/sturges.js":"70wjL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKBe4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ed8jk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tubz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
var _ticksJs = require("./ticks.js");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticksJs.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"./ticks.js":"8lqi0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lqi0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [
            start
        ];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
        if (step > 0) {
            let r0 = Math.round(start / step), r1 = Math.round(stop / step);
            if (r0 * step < start) ++r0;
            if (r1 * step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) * step;
        } else {
            step = -step;
            let r0 = Math.round(start * step), r1 = Math.round(stop * step);
            if (r0 / step < start) ++r0;
            if (r1 / step > stop) --r1;
            ticks = new Array(n = r1 - r0 + 1);
            while(++i < n)ticks[i] = (r0 + i) / step;
        }
        if (reverse) ticks.reverse();
        return ticks;
    });
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70wjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        return Math.ceil(Math.log((0, _countJsDefault.default)(values)) / Math.LN2) + 1;
    });
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);

},{"../count.js":"9yjzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Od34":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        return Math.ceil((max - min) / (2 * ((0, _quantileJsDefault.default)(values, 0.75) - (0, _quantileJsDefault.default)(values, 0.25)) * Math.pow((0, _countJsDefault.default)(values), -1 / 3)));
    });
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _quantileJs = require("../quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);

},{"../count.js":"9yjzz","../quantile.js":"jofqf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jofqf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
parcelHelpers.export(exports, "quantileSorted", ()=>quantileSorted);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _numberJs.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, _minJsDefault.default)(values);
    if (p >= 1) return (0, _maxJsDefault.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _maxJsDefault.default)((0, _quickselectJsDefault.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _minJsDefault.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = (0, _numberJsDefault.default)) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

},{"./max.js":"lyQpF","./min.js":"1bloD","./quickselect.js":"32BMd","./number.js":"cQ9YG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyQpF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bloD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32BMd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function quickselect(array, k, left = 0, right = array.length - 1, compare = (0, _ascendingJsDefault.default)) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"./ascending.js":"1y6jc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0ke1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        return Math.ceil((max - min) / (3.5 * (0, _deviationJsDefault.default)(values) * Math.pow((0, _countJsDefault.default)(values), -1 / 3)));
    });
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _deviationJs = require("../deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);

},{"../count.js":"9yjzz","../deviation.js":"dG1f7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dU47S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxIndex);
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"64dcr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mean);
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vw2AB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        return (0, _quantileJsDefault.default)(values, 0.5, valueof);
    });
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);

},{"./quantile.js":"jofqf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1SDhC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>merge);
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9duGZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minIndex);
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hJu6c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pairs);
parcelHelpers.export(exports, "pair", ()=>pair);
function pairs(values, pairof = pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AFrP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1I9Ny":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>least);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function least(values, compare = (0, _ascendingJsDefault.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, minValue) < 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"./ascending.js":"1y6jc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99kCD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>leastIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
function leastIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _minIndexJsDefault.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"./ascending.js":"1y6jc","./minIndex.js":"9duGZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"khpM9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatest);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function greatest(values, compare = (0, _ascendingJsDefault.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, maxValue) > 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"./ascending.js":"1y6jc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNeTR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatestIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
function greatestIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _maxIndexJsDefault.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"./ascending.js":"1y6jc","./maxIndex.js":"dU47S","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8RClz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scan);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
function scan(values, compare) {
    const index = (0, _leastIndexJsDefault.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"./leastIndex.js":"99kCD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oVcf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shuffler", ()=>shuffler);
exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdn1u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sum);
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jrVL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = (0, _minJsDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    });
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
function length(d) {
    return d.length;
}

},{"./min.js":"1bloD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byBEE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _transposeJsDefault.default)(arguments);
    });
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);

},{"./transpose.js":"5jrVL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9oEd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>every);
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4YvdA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>some);
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Wd4L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filter);
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyGin":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>map);
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"arQsm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvvJN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reverse);
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8i7Zn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>difference);
function difference(values, ...others) {
    values = new Set(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bum5t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>disjoint);
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new Set();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dzcd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersection);
var _setJs = require("./set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
function intersection(values, ...others) {
    values = new Set(values);
    others = others.map((0, _setJsDefault.default));
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}

},{"./set.js":"dCzJR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dCzJR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>set);
function set(values) {
    return values instanceof Set ? values : new Set(values);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2qorS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subset);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
function subset(values, other) {
    return (0, _supersetJsDefault.default)(other, values);
}

},{"./superset.js":"1EyFC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1EyFC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>superset);
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        if (set.has(o)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            set.add(value);
            if (Object.is(o, value)) break;
        }
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4zRJ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>union);
function union(...others) {
    const set = new Set();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"41neH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>(0, _axisJs.axisTop));
parcelHelpers.export(exports, "axisRight", ()=>(0, _axisJs.axisRight));
parcelHelpers.export(exports, "axisBottom", ()=>(0, _axisJs.axisBottom));
parcelHelpers.export(exports, "axisLeft", ()=>(0, _axisJs.axisLeft));
var _axisJs = require("./axis.js");

},{"./axis.js":"gl0Cu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gl0Cu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>axisTop);
parcelHelpers.export(exports, "axisRight", ()=>axisRight);
parcelHelpers.export(exports, "axisBottom", ()=>axisBottom);
parcelHelpers.export(exports, "axisLeft", ()=>axisLeft);
var _arrayJs = require("./array.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var top = 1, right = 2, bottom = 3, left = 4, epsilon = 1e-6;
function translateX(x) {
    return "translate(" + x + ",0)";
}
function translateY(y) {
    return "translate(0," + y + ")";
}
function number(scale) {
    return (d)=>+scale(d);
}
function center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function entering() {
    return !this.__axis;
}
function axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, _identityJsDefault.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center : number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, _arrayJs.slice).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, _arrayJs.slice).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, _arrayJs.slice).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function axisTop(scale) {
    return axis(top, scale);
}
function axisRight(scale) {
    return axis(right, scale);
}
function axisBottom(scale) {
    return axis(bottom, scale);
}
function axisLeft(scale) {
    return axis(left, scale);
}

},{"./array.js":"fncYV","./identity.js":"aUrCV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fncYV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUrCV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFd4k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "brushX", ()=>(0, _brushJs.brushX));
parcelHelpers.export(exports, "brushY", ()=>(0, _brushJs.brushY));
parcelHelpers.export(exports, "brushSelection", ()=>(0, _brushJs.brushSelection));
var _brushJs = require("./brush.js");
var _brushJsDefault = parcelHelpers.interopDefault(_brushJs);

},{"./brush.js":"8FHep","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8FHep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brushSelection", ()=>brushSelection);
parcelHelpers.export(exports, "brushX", ()=>brushX);
parcelHelpers.export(exports, "brushY", ()=>brushY);
parcelHelpers.export(exports, "default", ()=>function() {
        return brush(XY);
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var MODE_DRAG = {
    name: "drag"
}, MODE_SPACE = {
    name: "space"
}, MODE_HANDLE = {
    name: "handle"
}, MODE_CENTER = {
    name: "center"
};
const { abs, max, min } = Math;
function number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function number2(e) {
    return [
        number1(e[0]),
        number1(e[1])
    ];
}
var X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map(type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map(type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map(type),
    input: function(xy) {
        return xy == null ? null : number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function brushSelection(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function brushX() {
    return brush(X);
}
function brushY() {
    return brush(Y);
}
function brush(dim) {
    var extent = defaultExtent, filter = defaultFilter, touchable = defaultTouchable, keys = true, listeners = (0, _d3Dispatch.dispatch)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
            var extent = local(this).extent;
            (0, _d3Selection.select)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, _d3Interpolate.interpolate)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, _d3Transition.interrupt)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, _d3Selection.select)(this), selection = local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, _d3Selection.select)(this.that).datum();
            listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, _d3Selection.pointer)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === Y ? W : min(pts[0][0], pts[1][0]),
                    n0 = dim === X ? N : min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === Y ? E : max(pts[0][0], pts[1][0]),
                    s0 = dim === X ? S : max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move();
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, _d3Selection.select)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
        (0, _d3Transition.interrupt)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, _d3Selection.select)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, _d3Drag.dragDisable)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, _d3Selection.pointer)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if (abs(point.cur[0] - point[0]) > abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, _noeventJsDefault.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case MODE_SPACE:
                case MODE_DRAG:
                    if (signX) dx = max(W - w0, min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = max(N - n0, min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = max(W, min(E, points[0][0])), e1 = max(W, min(E, points[1][0])), signX = 1;
                        if (signY) n1 = max(N, min(S, points[0][1])), s1 = max(N, min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = max(W - w0, min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = max(W - e0, min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = max(N - n0, min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = max(N - s0, min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case MODE_CENTER:
                    if (signX) w1 = max(W, min(E, w0 - dx * signX)), e1 = max(W, min(E, e0 + dx * signX));
                    if (signY) n1 = max(N, min(S, n0 - dy * signY)), s1 = max(N, min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, _noeventJs.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, _d3Drag.dragEnable)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if (empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = MODE_SPACE;
                        overlay.attr("cursor", cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = MODE_HANDLE;
                        }
                        overlay.attr("cursor", cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

},{"d3-dispatch":"2VwUr","d3-drag":"HHNYu","d3-interpolate":"5gJW0","d3-selection":"9PvvP","d3-transition":"aj1c5","./constant.js":"4jWqH","./event.js":"9LU8z","./noevent.js":"4ofxs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2VwUr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"cWgMh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWgMh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HHNYu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>(0, _dragJsDefault.default));
parcelHelpers.export(exports, "dragDisable", ()=>(0, _nodragJsDefault.default));
parcelHelpers.export(exports, "dragEnable", ()=>(0, _nodragJs.yesdrag));
var _dragJs = require("./drag.js");
var _dragJsDefault = parcelHelpers.interopDefault(_dragJs);
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);

},{"./drag.js":"6a3PW","./nodrag.js":"kOGkY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6a3PW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            (0, _d3Selection.select)(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
            (0, _nodragJsDefault.default)(event.view);
            (0, _noeventJs.nopropagation)(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            (0, _noeventJsDefault.default)(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            (0, _d3Selection.select)(event.view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)(event.view, mousemoving);
            (0, _noeventJsDefault.default)(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                (0, _noeventJs.nopropagation)(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = (0, _d3Selection.pointer)(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new (0, _eventJsDefault.default)("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier,
                active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // nobreak
                    case "drag":
                        p = (0, _d3Selection.pointer)(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":"2VwUr","d3-selection":"9PvvP","./nodrag.js":"kOGkY","./noevent.js":"8rhnL","./constant.js":"gczea","./event.js":"6OX4n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PvvP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>(0, _createJsDefault.default));
parcelHelpers.export(exports, "creator", ()=>(0, _creatorJsDefault.default));
parcelHelpers.export(exports, "local", ()=>(0, _localJsDefault.default));
parcelHelpers.export(exports, "matcher", ()=>(0, _matcherJsDefault.default));
parcelHelpers.export(exports, "namespace", ()=>(0, _namespaceJsDefault.default));
parcelHelpers.export(exports, "namespaces", ()=>(0, _namespacesJsDefault.default));
parcelHelpers.export(exports, "pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "pointers", ()=>(0, _pointersJsDefault.default));
parcelHelpers.export(exports, "select", ()=>(0, _selectJsDefault.default));
parcelHelpers.export(exports, "selectAll", ()=>(0, _selectAllJsDefault.default));
parcelHelpers.export(exports, "selection", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "selector", ()=>(0, _selectorJsDefault.default));
parcelHelpers.export(exports, "selectorAll", ()=>(0, _selectorAllJsDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleJs.styleValue));
parcelHelpers.export(exports, "window", ()=>(0, _windowJsDefault.default));
var _createJs = require("./create.js");
var _createJsDefault = parcelHelpers.interopDefault(_createJs);
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _localJs = require("./local.js");
var _localJsDefault = parcelHelpers.interopDefault(_localJs);
var _matcherJs = require("./matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _pointersJs = require("./pointers.js");
var _pointersJsDefault = parcelHelpers.interopDefault(_pointersJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _indexJs = require("./selection/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _selectorJs = require("./selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
var _selectorAllJs = require("./selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
var _styleJs = require("./selection/style.js");
var _windowJs = require("./window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);

},{"./create.js":"aThp7","./creator.js":"9J1Uc","./local.js":"8V0zV","./matcher.js":"3cbxf","./namespace.js":"890X9","./namespaces.js":"1Q4PJ","./pointer.js":"3xcdW","./pointers.js":"crSlp","./select.js":"2Rc7o","./selectAll.js":"1EslL","./selection/index.js":"a5jDB","./selector.js":"hZ4f6","./selectorAll.js":"9WsMK","./selection/style.js":"4vnVK","./window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aThp7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return (0, _selectJsDefault.default)((0, _creatorJsDefault.default)(name).call(document.documentElement));
    });
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);

},{"./creator.js":"9J1Uc","./select.js":"2Rc7o","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9J1Uc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespacesJs.xhtml) && document.documentElement.namespaceURI === (0, _namespacesJs.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace.js":"890X9","./namespaces.js":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"890X9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesJsDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesJsDefault.default)[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    });
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);

},{"./namespaces.js":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Q4PJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Rc7o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            [
                selector
            ]
        ], (0, _indexJs.root));
    });
var _indexJs = require("./selection/index.js");

},{"./selection/index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a5jDB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectChildJs = require("./selectChild.js");
var _selectChildJsDefault = parcelHelpers.interopDefault(_selectChildJs);
var _selectChildrenJs = require("./selectChildren.js");
var _selectChildrenJsDefault = parcelHelpers.interopDefault(_selectChildrenJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _enterJs = require("./enter.js");
var _enterJsDefault = parcelHelpers.interopDefault(_enterJs);
var _exitJs = require("./exit.js");
var _exitJsDefault = parcelHelpers.interopDefault(_exitJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _orderJs = require("./order.js");
var _orderJsDefault = parcelHelpers.interopDefault(_orderJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _nodesJs = require("./nodes.js");
var _nodesJsDefault = parcelHelpers.interopDefault(_nodesJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _classedJs = require("./classed.js");
var _classedJsDefault = parcelHelpers.interopDefault(_classedJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _htmlJs = require("./html.js");
var _htmlJsDefault = parcelHelpers.interopDefault(_htmlJs);
var _raiseJs = require("./raise.js");
var _raiseJsDefault = parcelHelpers.interopDefault(_raiseJs);
var _lowerJs = require("./lower.js");
var _lowerJsDefault = parcelHelpers.interopDefault(_lowerJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _datumJs = require("./datum.js");
var _datumJsDefault = parcelHelpers.interopDefault(_datumJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
function selection_selection() {
    return this;
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: (0, _selectChildJsDefault.default),
    selectChildren: (0, _selectChildrenJsDefault.default),
    filter: (0, _filterJsDefault.default),
    data: (0, _dataJsDefault.default),
    enter: (0, _enterJsDefault.default),
    exit: (0, _exitJsDefault.default),
    join: (0, _joinJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: selection_selection,
    order: (0, _orderJsDefault.default),
    sort: (0, _sortJsDefault.default),
    call: (0, _callJsDefault.default),
    nodes: (0, _nodesJsDefault.default),
    node: (0, _nodeJsDefault.default),
    size: (0, _sizeJsDefault.default),
    empty: (0, _emptyJsDefault.default),
    each: (0, _eachJsDefault.default),
    attr: (0, _attrJsDefault.default),
    style: (0, _styleJsDefault.default),
    property: (0, _propertyJsDefault.default),
    classed: (0, _classedJsDefault.default),
    text: (0, _textJsDefault.default),
    html: (0, _htmlJsDefault.default),
    raise: (0, _raiseJsDefault.default),
    lower: (0, _lowerJsDefault.default),
    append: (0, _appendJsDefault.default),
    insert: (0, _insertJsDefault.default),
    remove: (0, _removeJsDefault.default),
    clone: (0, _cloneJsDefault.default),
    datum: (0, _datumJsDefault.default),
    on: (0, _onJsDefault.default),
    dispatch: (0, _dispatchJsDefault.default),
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};
exports.default = selection;

},{"./select.js":"4cEkx","./selectAll.js":"kCglL","./selectChild.js":"M1ElV","./selectChildren.js":"6txEr","./filter.js":"eNhDs","./data.js":"9DDr4","./enter.js":"gP2QE","./exit.js":"jH42X","./join.js":"1AmkZ","./merge.js":"4XmUG","./order.js":"hgq2c","./sort.js":"jZWGX","./call.js":"lf3EW","./nodes.js":"j05Td","./node.js":"8ksut","./size.js":"cMqWP","./empty.js":"jngRU","./each.js":"3Fax0","./attr.js":"4sWgc","./style.js":"4vnVK","./property.js":"gUsSc","./classed.js":"7umaZ","./text.js":"8vz6Q","./html.js":"fkrCd","./raise.js":"i9fD3","./lower.js":"cy1Ek","./append.js":"dA1zq","./insert.js":"kmSFy","./remove.js":"bjetH","./clone.js":"3ll3H","./datum.js":"i9Aev","./on.js":"Lh6iE","./dispatch.js":"4tSUD","./iterator.js":"8wNwM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cEkx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);

},{"./index.js":"a5jDB","../selector.js":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZ4f6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCglL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = (0, _selectorAllJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _indexJs.Selection)(subgroups, parents);
    });
var _indexJs = require("./index.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _selectorAllJs = require("../selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
function arrayAll(select) {
    return function() {
        var group = select.apply(this, arguments);
        return group == null ? [] : (0, _arrayJsDefault.default)(group);
    };
}

},{"./index.js":"a5jDB","../array.js":"jeIHr","../selectorAll.js":"9WsMK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jeIHr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WsMK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"M1ElV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var find = Array.prototype.find;
function childFind(match) {
    return function() {
        return find.call(this.children, match);
    };
}
function childFirst() {
    return this.firstElementChild;
}

},{"../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cbxf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });
parcelHelpers.export(exports, "childMatcher", ()=>childMatcher);
function childMatcher(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6txEr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var filter = Array.prototype.filter;
function children() {
    return this.children;
}
function childrenFilter(match) {
    return function() {
        return filter.call(this.children, match);
    };
}

},{"../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNhDs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherJsDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _matcherJs = require("../matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);

},{"./index.js":"a5jDB","../matcher.js":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DDr4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantJsDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = (0, _arrayJsDefault.default)(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _indexJs.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _indexJs = require("./index.js");
var _enterJs = require("./enter.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function datum(node) {
    return node.__data__;
}

},{"./index.js":"a5jDB","./enter.js":"gP2QE","../array.js":"jeIHr","../constant.js":"c7sKD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gP2QE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._enter || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse.js":"4Dzlv","./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Dzlv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7sKD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jH42X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._exit || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");

},{"./sparse.js":"4Dzlv","./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AmkZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
        if (onupdate != null) update = onupdate(update);
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XmUG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selection) {
        if (!(selection instanceof (0, _indexJs.Selection))) throw new Error("invalid merge");
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Selection)(merges, this._parents);
    });
var _indexJs = require("./index.js");

},{"./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgq2c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZWGX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _indexJs.Selection)(sortgroups, this._parents).order();
    });
var _indexJs = require("./index.js");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lf3EW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j05Td":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ksut":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMqWP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jngRU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Fax0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sWgc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespaceJs = require("../namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace.js":"890X9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vnVK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowJsDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXAiN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUsSc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7umaZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vz6Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fkrCd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9fD3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cy1Ek":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dA1zq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);

},{"../creator.js":"9J1Uc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kmSFy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorJsDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
function constantNull() {
    return null;
}

},{"../creator.js":"9J1Uc","../selector.js":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjetH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ll3H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9Aev":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Lh6iE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    });
function contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tSUD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function dispatchEvent(node, type, params) {
    var window = (0, _windowJsDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window.js":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wNwM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V0zV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>local);
var nextId = 0;
function local() {
    return new Local;
}
function Local() {
    this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local.prototype = {
    constructor: Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xcdW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event, node) {
        event = (0, _sourceEventJsDefault.default)(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    });
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./sourceEvent.js":"fQtlW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQtlW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crSlp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(events, node) {
        if (events.target) {
            events = (0, _sourceEventJsDefault.default)(events);
            if (node === undefined) node = events.currentTarget;
            events = events.touches || [
                events
            ];
        }
        return Array.from(events, (event)=>(0, _pointerJsDefault.default)(event, node));
    });
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./pointer.js":"3xcdW","./sourceEvent.js":"fQtlW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1EslL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            selector == null ? [] : (0, _arrayJsDefault.default)(selector)
        ], (0, _indexJs.root));
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _indexJs = require("./selection/index.js");

},{"./array.js":"jeIHr","./selection/index.js":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOGkY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), true);
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), true);
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":"9PvvP","./noevent.js":"8rhnL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rhnL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gczea":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6OX4n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(type, { sourceEvent, subject, target, identifier, active, x, y, dx, dy, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gJW0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"78upz","./array.js":"eb1ox","./basis.js":"6hdhZ","./basisClosed.js":"pPwhQ","./date.js":"eBq0A","./discrete.js":"cDTKZ","./hue.js":"6bCtD","./number.js":"j5icT","./numberArray.js":"2R8WR","./object.js":"dfxE0","./round.js":"2oPnZ","./string.js":"fqpjr","./transform/index.js":"5Kwa1","./zoom.js":"dYZqs","./rgb.js":"f5JLR","./hsl.js":"gpCEl","./lab.js":"59sZQ","./hcl.js":"8D5sR","./cubehelix.js":"fTpuZ","./piecewise.js":"8nOq6","./quantize.js":"hHRVh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78upz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":"jv6Pr","./rgb.js":"f5JLR","./array.js":"eb1ox","./date.js":"eBq0A","./number.js":"j5icT","./object.js":"dfxE0","./string.js":"fqpjr","./constant.js":"xDayq","./numberArray.js":"2R8WR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jv6Pr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"bQ7hd","./lab.js":"80Y9r","./cubehelix.js":"bpc6C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQ7hd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"fhaY4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhaY4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"80Y9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "default", ()=>lab);
parcelHelpers.export(exports, "Lab", ()=>Lab);
parcelHelpers.export(exports, "lch", ()=>lch);
parcelHelpers.export(exports, "hcl", ()=>hcl);
parcelHelpers.export(exports, "Hcl", ()=>Hcl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Lab, lab, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new (0, _colorJs.Rgb)(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, _mathJs.degrees);
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * (0, _mathJs.radians);
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _defineJsDefault.default)(Hcl, hcl, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return hcl2lab(this).rgb();
    }
}));

},{"./define.js":"fhaY4","./color.js":"bQ7hd","./math.js":"aokDz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aokDz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "degrees", ()=>degrees);
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bpc6C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.degrees) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"fhaY4","./color.js":"bQ7hd","./math.js":"aokDz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f5JLR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"jv6Pr","./basis.js":"6hdhZ","./basisClosed.js":"pPwhQ","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hdhZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pPwhQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"6hdhZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoWOo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"xDayq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xDayq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eb1ox":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"78upz","./numberArray.js":"2R8WR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2R8WR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBq0A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j5icT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dfxE0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"78upz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fqpjr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"j5icT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cDTKZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6bCtD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = (0, _colorJs.hue)(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    });
var _colorJs = require("./color.js");

},{"./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2oPnZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Kwa1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"j5icT","./parse.js":"lUixM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUixM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"fFCw3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFCw3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYZqs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gpCEl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslLong", ()=>hslLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hsl((0, _colorJs.hue));
var hslLong = hsl((0, _colorJsDefault.default));

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59sZQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lab);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function lab(start, end) {
    var l = (0, _colorJsDefault.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l), a = (0, _colorJsDefault.default)(start.a, end.a), b = (0, _colorJsDefault.default)(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8D5sR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hclLong", ()=>hclLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h), c = (0, _colorJsDefault.default)(start.c, end.c), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hcl((0, _colorJs.hue));
var hclLong = hcl((0, _colorJsDefault.default));

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fTpuZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nOq6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>piecewise);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, _valueJsDefault.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"./value.js":"78upz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHRVh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aj1c5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "active", ()=>(0, _activeJsDefault.default));
parcelHelpers.export(exports, "interrupt", ()=>(0, _interruptJsDefault.default));
var _indexJs = require("./selection/index.js");
var _indexJs1 = require("./transition/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _activeJs = require("./active.js");
var _activeJsDefault = parcelHelpers.interopDefault(_activeJs);
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"./selection/index.js":"kZ3M7","./transition/index.js":"5tqW2","./active.js":"1yv3Z","./interrupt.js":"3IFg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZ3M7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _d3Selection = require("d3-selection");
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
(0, _d3Selection.selection).prototype.interrupt = (0, _interruptJsDefault.default);
(0, _d3Selection.selection).prototype.transition = (0, _transitionJsDefault.default);

},{"d3-selection":"9PvvP","./interrupt.js":"coKKt","./transition.js":"a9oBa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coKKt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return this.each(function() {
            (0, _interruptJsDefault.default)(this, name);
        });
    });
var _interruptJs = require("../interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"../interrupt.js":"3IFg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IFg8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > (0, _scheduleJs.STARTING) && schedule.state < (0, _scheduleJs.ENDING);
            schedule.state = (0, _scheduleJs.ENDED);
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    });
var _scheduleJs = require("./transition/schedule.js");

},{"./transition/schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2KS27":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CREATED", ()=>CREATED);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
parcelHelpers.export(exports, "STARTING", ()=>STARTING);
parcelHelpers.export(exports, "STARTED", ()=>STARTED);
parcelHelpers.export(exports, "RUNNING", ()=>RUNNING);
parcelHelpers.export(exports, "ENDING", ()=>ENDING);
parcelHelpers.export(exports, "ENDED", ()=>ENDED);
parcelHelpers.export(exports, "default", ()=>function(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    });
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "get", ()=>get);
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function init(node, id) {
    var schedule = get(node, id);
    if (schedule.state > CREATED) throw new Error("too late; already scheduled");
    return schedule;
}
function set(node, id) {
    var schedule = get(node, id);
    if (schedule.state > STARTED) throw new Error("too late; already running");
    return schedule;
}
function get(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = SCHEDULED;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== SCHEDULED) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, _d3Timer.timeout)(function() {
            if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = STARTING;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== STARTING) return; // interrupted
        self.state = STARTED;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = ENDED;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

},{"d3-dispatch":"2VwUr","d3-timer":"lpgSt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpgSt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"atLFA","./timeout.js":"h5YmT","./interval.js":"MBzPK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atLFA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5YmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"atLFA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"MBzPK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer), total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? (0, _timerJs.now)() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"atLFA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9oBa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var id, timing;
        if (name instanceof (0, _indexJs.Transition)) id = name._id, name = name._name;
        else id = (0, _indexJs.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, _scheduleJsDefault.default)(node, name, id, i, group, timing || inherit(node, id));
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id);
    });
var _indexJs = require("../transition/index.js");
var _scheduleJs = require("../transition/schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);
var _d3Ease = require("d3-ease");
var _d3Timer = require("d3-timer");
var defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, _d3Ease.easeCubicInOut)
};
function inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}

},{"../transition/index.js":"5tqW2","../transition/schedule.js":"2KS27","d3-ease":"djx4i","d3-timer":"lpgSt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tqW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "default", ()=>transition);
parcelHelpers.export(exports, "newId", ()=>newId);
var _d3Selection = require("d3-selection");
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _attrTweenJs = require("./attrTween.js");
var _attrTweenJsDefault = parcelHelpers.interopDefault(_attrTweenJs);
var _delayJs = require("./delay.js");
var _delayJsDefault = parcelHelpers.interopDefault(_delayJs);
var _durationJs = require("./duration.js");
var _durationJsDefault = parcelHelpers.interopDefault(_durationJs);
var _easeJs = require("./ease.js");
var _easeJsDefault = parcelHelpers.interopDefault(_easeJs);
var _easeVaryingJs = require("./easeVarying.js");
var _easeVaryingJsDefault = parcelHelpers.interopDefault(_easeVaryingJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectionJs = require("./selection.js");
var _selectionJsDefault = parcelHelpers.interopDefault(_selectionJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleTweenJs = require("./styleTween.js");
var _styleTweenJsDefault = parcelHelpers.interopDefault(_styleTweenJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _textTweenJs = require("./textTween.js");
var _textTweenJsDefault = parcelHelpers.interopDefault(_textTweenJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _tweenJs = require("./tween.js");
var _tweenJsDefault = parcelHelpers.interopDefault(_tweenJs);
var _endJs = require("./end.js");
var _endJsDefault = parcelHelpers.interopDefault(_endJs);
var id = 0;
function Transition(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function transition(name) {
    return (0, _d3Selection.selection)().transition(name);
}
function newId() {
    return ++id;
}
var selection_prototype = (0, _d3Selection.selection).prototype;
Transition.prototype = transition.prototype = {
    constructor: Transition,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    filter: (0, _filterJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: (0, _selectionJsDefault.default),
    transition: (0, _transitionJsDefault.default),
    call: selection_prototype.call,
    nodes: selection_prototype.nodes,
    node: selection_prototype.node,
    size: selection_prototype.size,
    empty: selection_prototype.empty,
    each: selection_prototype.each,
    on: (0, _onJsDefault.default),
    attr: (0, _attrJsDefault.default),
    attrTween: (0, _attrTweenJsDefault.default),
    style: (0, _styleJsDefault.default),
    styleTween: (0, _styleTweenJsDefault.default),
    text: (0, _textJsDefault.default),
    textTween: (0, _textTweenJsDefault.default),
    remove: (0, _removeJsDefault.default),
    tween: (0, _tweenJsDefault.default),
    delay: (0, _delayJsDefault.default),
    duration: (0, _durationJsDefault.default),
    ease: (0, _easeJsDefault.default),
    easeVarying: (0, _easeVaryingJsDefault.default),
    end: (0, _endJsDefault.default),
    [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

},{"d3-selection":"9PvvP","./attr.js":"ettza","./attrTween.js":"fKBNf","./delay.js":"3uMbw","./duration.js":"k5T03","./ease.js":"lDozG","./easeVarying.js":"hcVmw","./filter.js":"1mjyo","./merge.js":"lnzih","./on.js":"gvIIF","./remove.js":"1KRzH","./select.js":"5uH34","./selectAll.js":"ZI7Ih","./selection.js":"1VhQX","./style.js":"gijRh","./styleTween.js":"bC37S","./text.js":"6eNBo","./textTween.js":"cwqtH","./transition.js":"htXRp","./tween.js":"fPCiA","./end.js":"a4mEw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ettza":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _d3Selection.namespace)(name), i = fullname === "transform" ? (0, _d3Interpolate.interpolateTransformSvg) : (0, _interpolateJsDefault.default);
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tweenJs.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}

},{"d3-interpolate":"5gJW0","d3-selection":"9PvvP","./tween.js":"fPCiA","./interpolate.js":"jmTgx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fPCiA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = (0, _scheduleJs.get)(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    });
parcelHelpers.export(exports, "tweenValue", ()=>tweenValue);
var _scheduleJs = require("./schedule.js");
function tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function tweenValue(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, _scheduleJs.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, _scheduleJs.get)(node, id).value[name];
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmTgx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var c;
        return (typeof b === "number" ? (0, _d3Interpolate.interpolateNumber) : b instanceof (0, _d3Color.color) ? (0, _d3Interpolate.interpolateRgb) : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : (0, _d3Interpolate.interpolateString))(a, b);
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");

},{"d3-color":"jv6Pr","d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKBNf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = (0, _d3Selection.namespace)(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    });
var _d3Selection = require("d3-selection");
function attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3uMbw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).delay;
    });
var _scheduleJs = require("./schedule.js");
function delayFunction(id, value) {
    return function() {
        (0, _scheduleJs.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.init)(this, id).delay = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k5T03":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).duration;
    });
var _scheduleJs = require("./schedule.js");
function durationFunction(id, value) {
    return function() {
        (0, _scheduleJs.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.set)(this, id).duration = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDozG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : (0, _scheduleJs.get)(this.node(), id).ease;
    });
var _scheduleJs = require("./schedule.js");
function easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, _scheduleJs.set)(this, id).ease = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hcVmw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    });
var _scheduleJs = require("./schedule.js");
function easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, _scheduleJs.set)(this, id).ease = v;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mjyo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, this._name, this._id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");

},{"d3-selection":"9PvvP","./index.js":"5tqW2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnzih":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Transition)(merges, this._parents, this._name, this._id);
    });
var _indexJs = require("./index.js");

},{"./index.js":"5tqW2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvIIF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? (0, _scheduleJs.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    });
var _scheduleJs = require("./schedule.js");
function start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function onFunction(id, name, listener) {
    var on0, on1, sit = start(name) ? (0, _scheduleJs.init) : (0, _scheduleJs.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1KRzH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.on("end.remove", removeFunction(this._id));
    });
function removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uH34":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                (0, _scheduleJsDefault.default)(subgroup[i], name, id, i, subgroup, (0, _scheduleJs.get)(node, id));
            }
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"9PvvP","./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ZI7Ih":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, _scheduleJs.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, _scheduleJsDefault.default)(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new (0, _indexJs.Transition)(subgroups, parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"9PvvP","./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1VhQX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Selection(this._groups, this._parents);
    });
var _d3Selection = require("d3-selection");
var Selection = (0, _d3Selection.selection).prototype.constructor;

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gijRh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var i = (name += "") === "transform" ? (0, _d3Interpolate.interpolateTransformCss) : (0, _interpolateJsDefault.default);
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, (0, _tweenJs.tweenValue)(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _scheduleJs = require("./schedule.js");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), string1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}

},{"d3-interpolate":"5gJW0","d3-selection":"9PvvP","./schedule.js":"2KS27","./tween.js":"fPCiA","./interpolate.js":"jmTgx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bC37S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    });
function styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6eNBo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.tween("text", typeof value === "function" ? textFunction((0, _tweenJs.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    });
var _tweenJs = require("./tween.js");
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}

},{"./tween.js":"fPCiA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cwqtH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    });
function textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htXRp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var name = this._name, id0 = this._id, id1 = (0, _indexJs.newId)();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = (0, _scheduleJs.get)(node, id0);
                (0, _scheduleJsDefault.default)(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id1);
    });
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a4mEw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    });
var _scheduleJs = require("./schedule.js");

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"djx4i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeLinear", ()=>(0, _linearJs.linear));
parcelHelpers.export(exports, "easeQuad", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeQuadIn", ()=>(0, _quadJs.quadIn));
parcelHelpers.export(exports, "easeQuadOut", ()=>(0, _quadJs.quadOut));
parcelHelpers.export(exports, "easeQuadInOut", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeCubic", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easeCubicIn", ()=>(0, _cubicJs.cubicIn));
parcelHelpers.export(exports, "easeCubicOut", ()=>(0, _cubicJs.cubicOut));
parcelHelpers.export(exports, "easeCubicInOut", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easePoly", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easePolyIn", ()=>(0, _polyJs.polyIn));
parcelHelpers.export(exports, "easePolyOut", ()=>(0, _polyJs.polyOut));
parcelHelpers.export(exports, "easePolyInOut", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easeSin", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeSinIn", ()=>(0, _sinJs.sinIn));
parcelHelpers.export(exports, "easeSinOut", ()=>(0, _sinJs.sinOut));
parcelHelpers.export(exports, "easeSinInOut", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeExp", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeExpIn", ()=>(0, _expJs.expIn));
parcelHelpers.export(exports, "easeExpOut", ()=>(0, _expJs.expOut));
parcelHelpers.export(exports, "easeExpInOut", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeCircle", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeCircleIn", ()=>(0, _circleJs.circleIn));
parcelHelpers.export(exports, "easeCircleOut", ()=>(0, _circleJs.circleOut));
parcelHelpers.export(exports, "easeCircleInOut", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeBounce", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceIn", ()=>(0, _bounceJs.bounceIn));
parcelHelpers.export(exports, "easeBounceOut", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceInOut", ()=>(0, _bounceJs.bounceInOut));
parcelHelpers.export(exports, "easeBack", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeBackIn", ()=>(0, _backJs.backIn));
parcelHelpers.export(exports, "easeBackOut", ()=>(0, _backJs.backOut));
parcelHelpers.export(exports, "easeBackInOut", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeElastic", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticIn", ()=>(0, _elasticJs.elasticIn));
parcelHelpers.export(exports, "easeElasticOut", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticInOut", ()=>(0, _elasticJs.elasticInOut));
var _linearJs = require("./linear.js");
var _quadJs = require("./quad.js");
var _cubicJs = require("./cubic.js");
var _polyJs = require("./poly.js");
var _sinJs = require("./sin.js");
var _expJs = require("./exp.js");
var _circleJs = require("./circle.js");
var _bounceJs = require("./bounce.js");
var _backJs = require("./back.js");
var _elasticJs = require("./elastic.js");

},{"./linear.js":"50jbt","./quad.js":"iWfjc","./cubic.js":"kXdds","./poly.js":"3T1Tc","./sin.js":"7HLKm","./exp.js":"dATgq","./circle.js":"kGt6T","./bounce.js":"5VFCT","./back.js":"kSI9R","./elastic.js":"9vwgb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50jbt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linear", ()=>linear);
const linear = (t)=>+t;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWfjc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadIn", ()=>quadIn);
parcelHelpers.export(exports, "quadOut", ()=>quadOut);
parcelHelpers.export(exports, "quadInOut", ()=>quadInOut);
function quadIn(t) {
    return t * t;
}
function quadOut(t) {
    return t * (2 - t);
}
function quadInOut(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXdds":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", ()=>cubicIn);
parcelHelpers.export(exports, "cubicOut", ()=>cubicOut);
parcelHelpers.export(exports, "cubicInOut", ()=>cubicInOut);
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3T1Tc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyIn", ()=>polyIn);
parcelHelpers.export(exports, "polyOut", ()=>polyOut);
parcelHelpers.export(exports, "polyInOut", ()=>polyInOut);
var exponent = 3;
var polyIn = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}(exponent);
var polyOut = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}(exponent);
var polyInOut = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}(exponent);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7HLKm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinIn", ()=>sinIn);
parcelHelpers.export(exports, "sinOut", ()=>sinOut);
parcelHelpers.export(exports, "sinInOut", ()=>sinInOut);
var pi = Math.PI, halfPi = pi / 2;
function sinIn(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * halfPi);
}
function sinOut(t) {
    return Math.sin(t * halfPi);
}
function sinInOut(t) {
    return (1 - Math.cos(pi * t)) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dATgq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expIn", ()=>expIn);
parcelHelpers.export(exports, "expOut", ()=>expOut);
parcelHelpers.export(exports, "expInOut", ()=>expInOut);
var _mathJs = require("./math.js");
function expIn(t) {
    return (0, _mathJs.tpmt)(1 - +t);
}
function expOut(t) {
    return 1 - (0, _mathJs.tpmt)(t);
}
function expInOut(t) {
    return ((t *= 2) <= 1 ? (0, _mathJs.tpmt)(1 - t) : 2 - (0, _mathJs.tpmt)(t - 1)) / 2;
}

},{"./math.js":"3aorF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3aorF":[function(require,module,exports) {
// tpmt is two power minus ten times t scaled to [0,1]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tpmt", ()=>tpmt);
function tpmt(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGt6T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circleIn", ()=>circleIn);
parcelHelpers.export(exports, "circleOut", ()=>circleOut);
parcelHelpers.export(exports, "circleInOut", ()=>circleInOut);
function circleIn(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function circleOut(t) {
    return Math.sqrt(1 - --t * t);
}
function circleInOut(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5VFCT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bounceIn", ()=>bounceIn);
parcelHelpers.export(exports, "bounceOut", ()=>bounceOut);
parcelHelpers.export(exports, "bounceInOut", ()=>bounceInOut);
var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
function bounceIn(t) {
    return 1 - bounceOut(1 - t);
}
function bounceOut(t) {
    return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}
function bounceInOut(t) {
    return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kSI9R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", ()=>backIn);
parcelHelpers.export(exports, "backOut", ()=>backOut);
parcelHelpers.export(exports, "backInOut", ()=>backInOut);
var overshoot = 1.70158;
var backIn = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}(overshoot);
var backOut = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}(overshoot);
var backInOut = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}(overshoot);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9vwgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elasticIn", ()=>elasticIn);
parcelHelpers.export(exports, "elasticOut", ()=>elasticOut);
parcelHelpers.export(exports, "elasticInOut", ()=>elasticInOut);
var _mathJs = require("./math.js");
var tau = 2 * Math.PI, amplitude = 1, period = 0.3;
var elasticIn = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticIn(t) {
        return a * (0, _mathJs.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}(amplitude, period);
var elasticOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticOut(t) {
        return 1 - a * (0, _mathJs.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}(amplitude, period);
var elasticInOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, _mathJs.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, _mathJs.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}(amplitude, period);

},{"./math.js":"3aorF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1yv3Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, i;
        if (schedules) {
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).state > (0, _scheduleJs.SCHEDULED) && schedule.name === name) return new (0, _indexJs.Transition)([
                    [
                        node
                    ]
                ], root, name, +i);
            }
        }
        return null;
    });
var _indexJs = require("./transition/index.js");
var _scheduleJs = require("./transition/schedule.js");
var root = [
    null
];

},{"./transition/index.js":"5tqW2","./transition/schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jWqH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9LU8z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BrushEvent);
function BrushEvent(type, { sourceEvent, target, selection, mode, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ofxs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4B9KG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chord", ()=>(0, _chordJsDefault.default));
parcelHelpers.export(exports, "chordTranspose", ()=>(0, _chordJs.chordTranspose));
parcelHelpers.export(exports, "chordDirected", ()=>(0, _chordJs.chordDirected));
parcelHelpers.export(exports, "ribbon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "ribbonArrow", ()=>(0, _ribbonJs.ribbonArrow));
var _chordJs = require("./chord.js");
var _chordJsDefault = parcelHelpers.interopDefault(_chordJs);
var _ribbonJs = require("./ribbon.js");
var _ribbonJsDefault = parcelHelpers.interopDefault(_ribbonJs);

},{"./chord.js":"jN3jv","./ribbon.js":"9EMll","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jN3jv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return chord(false, false);
    });
parcelHelpers.export(exports, "chordTranspose", ()=>chordTranspose);
parcelHelpers.export(exports, "chordDirected", ()=>chordDirected);
var _mathJs = require("./math.js");
function range(i, j) {
    return Array.from({
        length: j - i
    }, (_, k)=>i + k);
}
function compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function chordTranspose() {
    return chord(false, true);
}
function chordDirected() {
    return chord(true, false);
}
function chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({
            length: n * n
        }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
        // Compute the scaling factor from value to angle in [0, 2pi].
        for(let i = 0; i < n; ++i){
            let x = 0;
            for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = (0, _mathJs.max)(0, (0, _mathJs.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, _mathJs.tau) / n;
        // Compute the angles for each group and constituent chord.
        {
            let x = 0;
            if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
            for (const i of groupIndex){
                const x0 = x;
                if (directed) {
                    const subgroupIndex = range(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                    for (const j of subgroupIndex)if (j < 0) {
                        const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                            source: null,
                            target: null
                        });
                        chord.target = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[~j * n + i] * k,
                            value: matrix[~j * n + i]
                        };
                    } else {
                        const chord = chords[i * n + j] || (chords[i * n + j] = {
                            source: null,
                            target: null
                        });
                        chord.source = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[i * n + j] * k,
                            value: matrix[i * n + j]
                        };
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                } else {
                    const subgroupIndex = range(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                    for (const j of subgroupIndex){
                        let chord;
                        if (i < j) {
                            chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        } else {
                            chord = chords[j * n + i] || (chords[j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                            if (i === j) chord.source = chord.target;
                        }
                        if (chord.source && chord.target && chord.source.value < chord.target.value) {
                            const source = chord.source;
                            chord.source = chord.target;
                            chord.target = source;
                        }
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                }
                x += dx;
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, _mathJs.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

},{"./math.js":"b6B7b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6B7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
var abs = Math.abs;
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;
var epsilon = 1e-12;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9EMll":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return ribbon();
    });
parcelHelpers.export(exports, "ribbonArrow", ()=>ribbonArrow);
var _d3Path = require("d3-path");
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function defaultSource(d) {
    return d.source;
}
function defaultTarget(d) {
    return d.target;
}
function defaultRadius(d) {
    return d.radius;
}
function defaultStartAngle(d) {
    return d.startAngle;
}
function defaultEndAngle(d) {
    return d.endAngle;
}
function defaultPadAngle() {
    return 0;
}
function defaultArrowheadRadius() {
    return 10;
}
function ribbon(headRadius) {
    var source = defaultSource, target = defaultTarget, sourceRadius = defaultRadius, targetRadius = defaultRadius, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
    function ribbon() {
        var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = (0, _arrayJs.slice).call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, _mathJs.halfPi), sa1 = endAngle.apply(this, argv) - (0, _mathJs.halfPi), tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, _mathJs.halfPi), ta1 = endAngle.apply(this, argv) - (0, _mathJs.halfPi);
        if (!context) context = buffer = (0, _d3Path.path)();
        if (ap > (0, _mathJs.epsilon)) {
            if ((0, _mathJs.abs)(sa1 - sa0) > ap * 2 + (0, _mathJs.epsilon)) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
            else sa0 = sa1 = (sa0 + sa1) / 2;
            if ((0, _mathJs.abs)(ta1 - ta0) > ap * 2 + (0, _mathJs.epsilon)) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
            else ta0 = ta1 = (ta0 + ta1) / 2;
        }
        context.moveTo(sr * (0, _mathJs.cos)(sa0), sr * (0, _mathJs.sin)(sa0));
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            if (headRadius) {
                var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                context.quadraticCurveTo(0, 0, tr2 * (0, _mathJs.cos)(ta0), tr2 * (0, _mathJs.sin)(ta0));
                context.lineTo(tr * (0, _mathJs.cos)(ta2), tr * (0, _mathJs.sin)(ta2));
                context.lineTo(tr2 * (0, _mathJs.cos)(ta1), tr2 * (0, _mathJs.sin)(ta1));
            } else {
                context.quadraticCurveTo(0, 0, tr * (0, _mathJs.cos)(ta0), tr * (0, _mathJs.sin)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
        }
        context.quadraticCurveTo(0, 0, sr * (0, _mathJs.cos)(sa0), sr * (0, _mathJs.sin)(sa0));
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    if (headRadius) ribbon.headRadius = function(_) {
        return arguments.length ? (headRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : headRadius;
    };
    ribbon.radius = function(_) {
        return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.sourceRadius = function(_) {
        return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.targetRadius = function(_) {
        return arguments.length ? (targetRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : targetRadius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : endAngle;
    };
    ribbon.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : padAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}
function ribbonArrow() {
    return ribbon(defaultArrowheadRadius);
}

},{"d3-path":"a7nC8","./array.js":"eGSaf","./constant.js":"1Nhsa","./math.js":"b6B7b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a7nC8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "path", ()=>(0, _pathJsDefault.default));
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);

},{"./path.js":"lMfok","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMfok":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path;
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
exports.default = path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGSaf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Nhsa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klb8D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contours", ()=>(0, _contoursJsDefault.default));
parcelHelpers.export(exports, "contourDensity", ()=>(0, _densityJsDefault.default));
var _contoursJs = require("./contours.js");
var _contoursJsDefault = parcelHelpers.interopDefault(_contoursJs);
var _densityJs = require("./density.js");
var _densityJsDefault = parcelHelpers.interopDefault(_densityJs);

},{"./contours.js":"gIi5F","./density.js":"jKHuJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIi5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, threshold = (0, _d3Array.thresholdSturges), smooth = smoothLinear;
        function contours(values) {
            var tz = threshold(values);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                var domain = (0, _d3Array.extent)(values), start = domain[0], stop = domain[1];
                tz = (0, _d3Array.tickStep)(start, stop, tz);
                tz = (0, _d3Array.range)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
            } else tz = tz.slice().sort((0, _ascendingJsDefault.default));
            return tz.map(function(value) {
                return contour(values, value);
            });
        }
        // Accumulate, smooth contour rings, assign holes to exterior rings.
        // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
        function contour(values, value) {
            var polygons = [], holes = [];
            isorings(values, value, function(ring) {
                smooth(ring, values, value);
                if ((0, _areaJsDefault.default)(ring) > 0) polygons.push([
                    ring
                ]);
                else holes.push(ring);
            });
            holes.forEach(function(hole) {
                for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, _containsJsDefault.default)((polygon = polygons[i])[0], hole) !== -1) {
                    polygon.push(hole);
                    return;
                }
            });
            return {
                type: "MultiPolygon",
                value: value,
                coordinates: polygons
            };
        }
        // Marching squares with isolines stitched into rings.
        // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
        function isorings(values, value, callback) {
            var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
            // Special case for the first row (y = -1, t2 = t3 = 0).
            x = y = -1;
            t1 = values[0] >= value;
            cases[t1 << 1].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[x + 1] >= value;
                cases[t0 | t1 << 1].forEach(stitch);
            }
            cases[t1 << 0].forEach(stitch);
            // General case for the intermediate rows.
            while(++y < dy - 1){
                x = -1;
                t1 = values[y * dx + dx] >= value;
                t2 = values[y * dx] >= value;
                cases[t1 << 1 | t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                    t3 = t2, t2 = values[y * dx + x + 1] >= value;
                    cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t1 | t2 << 3].forEach(stitch);
            }
            // Special case for the last row (y = dy - 1, t0 = t1 = 0).
            x = -1;
            t2 = values[y * dx] >= value;
            cases[t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                cases[t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t2 << 3].forEach(stitch);
            function stitch(line) {
                var start = [
                    line[0][0] + x,
                    line[0][1] + y
                ], end = [
                    line[1][0] + x,
                    line[1][1] + y
                ], startIndex = index(start), endIndex = index(end), f, g;
                if (f = fragmentByEnd[startIndex]) {
                    if (g = fragmentByStart[endIndex]) {
                        delete fragmentByEnd[f.end];
                        delete fragmentByStart[g.start];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                            start: f.start,
                            end: g.end,
                            ring: f.ring.concat(g.ring)
                        };
                    } else {
                        delete fragmentByEnd[f.end];
                        f.ring.push(end);
                        fragmentByEnd[f.end = endIndex] = f;
                    }
                } else if (f = fragmentByStart[endIndex]) {
                    if (g = fragmentByEnd[startIndex]) {
                        delete fragmentByStart[f.start];
                        delete fragmentByEnd[g.end];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                            start: g.start,
                            end: f.end,
                            ring: g.ring.concat(f.ring)
                        };
                    } else {
                        delete fragmentByStart[f.start];
                        f.ring.unshift(start);
                        fragmentByStart[f.start = startIndex] = f;
                    }
                } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                    start: startIndex,
                    end: endIndex,
                    ring: [
                        start,
                        end
                    ]
                };
            }
        }
        function index(point) {
            return point[0] * 2 + point[1] * (dx + 1) * 4;
        }
        function smoothLinear(ring, values, value) {
            ring.forEach(function(point) {
                var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
                if (x > 0 && x < dx && xt === x) {
                    v0 = values[yt * dx + xt - 1];
                    point[0] = x + (value - v0) / (v1 - v0) - 0.5;
                }
                if (y > 0 && y < dy && yt === y) {
                    v0 = values[(yt - 1) * dx + xt];
                    point[1] = y + (value - v0) / (v1 - v0) - 0.5;
                }
            });
        }
        contours.contour = contour;
        contours.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, contours;
        };
        contours.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), contours) : threshold;
        };
        contours.smooth = function(_) {
            return arguments.length ? (smooth = _ ? smoothLinear : (0, _noopJsDefault.default), contours) : smooth === smoothLinear;
        };
        return contours;
    });
var _d3Array = require("d3-array");
var _arrayJs = require("./array.js");
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];

},{"d3-array":"aoYKF","./array.js":"1JdE0","./ascending.js":"45San","./area.js":"9oTPo","./constant.js":"h2LxA","./contains.js":"aZqVT","./noop.js":"l9h0Z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1JdE0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var array = Array.prototype;
var slice = array.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45San":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a - b;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9oTPo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring) {
        var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h2LxA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZqVT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring, hole) {
        var i = -1, n = hole.length, c;
        while(++i < n)if (c = ringContains(ring, hole[i])) return c;
        return 0;
    });
function ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if (segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function segmentContains(a, b, c) {
    var i;
    return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l9h0Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jKHuJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x = defaultX, y = defaultY, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, _constantJsDefault.default)(20);
        function density(data) {
            var values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
            data.forEach(function(d, i, data) {
                var xi = +x(d, i, data) + o >> k, yi = +y(d, i, data) + o >> k, wi = +weight(d, i, data);
                if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += wi;
            });
            // TODO Optimize.
            (0, _blurJs.blurX)({
                width: n,
                height: m,
                data: values0
            }, {
                width: n,
                height: m,
                data: values1
            }, r >> k);
            (0, _blurJs.blurY)({
                width: n,
                height: m,
                data: values1
            }, {
                width: n,
                height: m,
                data: values0
            }, r >> k);
            (0, _blurJs.blurX)({
                width: n,
                height: m,
                data: values0
            }, {
                width: n,
                height: m,
                data: values1
            }, r >> k);
            (0, _blurJs.blurY)({
                width: n,
                height: m,
                data: values1
            }, {
                width: n,
                height: m,
                data: values0
            }, r >> k);
            (0, _blurJs.blurX)({
                width: n,
                height: m,
                data: values0
            }, {
                width: n,
                height: m,
                data: values1
            }, r >> k);
            (0, _blurJs.blurY)({
                width: n,
                height: m,
                data: values1
            }, {
                width: n,
                height: m,
                data: values0
            }, r >> k);
            var tz = threshold(values0);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                var stop = (0, _d3Array.max)(values0);
                tz = (0, _d3Array.tickStep)(0, stop, tz);
                tz = (0, _d3Array.range)(0, Math.floor(stop / tz) * tz, tz);
                tz.shift();
            }
            return (0, _contoursJsDefault.default)().thresholds(tz).size([
                n,
                m
            ])(values0).map(transform);
        }
        function transform(geometry) {
            geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
            geometry.coordinates.forEach(transformPolygon);
            return geometry;
        }
        function transformPolygon(coordinates) {
            coordinates.forEach(transformRing);
        }
        function transformRing(coordinates) {
            coordinates.forEach(transformPoint);
        }
        // TODO Optimize.
        function transformPoint(coordinates) {
            coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
            coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
        }
        function resize() {
            o = r * 3;
            n = dx + o * 2 >> k;
            m = dy + o * 2 >> k;
            return density;
        }
        density.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : x;
        };
        density.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : y;
        };
        density.weight = function(_) {
            return arguments.length ? (weight = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : weight;
        };
        density.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = +_[0], _1 = +_[1];
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, resize();
        };
        density.cellSize = function(_) {
            if (!arguments.length) return 1 << k;
            if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
            return k = Math.floor(Math.log(_) / Math.LN2), resize();
        };
        density.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), density) : threshold;
        };
        density.bandwidth = function(_) {
            if (!arguments.length) return Math.sqrt(r * (r + 1));
            if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
            return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
        };
        return density;
    });
var _d3Array = require("d3-array");
var _arrayJs = require("./array.js");
var _blurJs = require("./blur.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _contoursJs = require("./contours.js");
var _contoursJsDefault = parcelHelpers.interopDefault(_contoursJs);
function defaultX(d) {
    return d[0];
}
function defaultY(d) {
    return d[1];
}
function defaultWeight() {
    return 1;
}

},{"d3-array":"aoYKF","./array.js":"1JdE0","./blur.js":"8ln6A","./constant.js":"h2LxA","./contours.js":"gIi5F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ln6A":[function(require,module,exports) {
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blurX", ()=>blurX);
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
parcelHelpers.export(exports, "blurY", ()=>blurY);
function blurX(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var j = 0; j < m; ++j)for(var i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source.data[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source.data[i - w + j * n];
            target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function blurY(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var i = 0; i < n; ++i)for(var j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source.data[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source.data[i + (j - w) * n];
            target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lOwa3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delaunay", ()=>(0, _delaunayJsDefault.default));
parcelHelpers.export(exports, "Voronoi", ()=>(0, _voronoiJsDefault.default));
var _delaunayJs = require("./delaunay.js");
var _delaunayJsDefault = parcelHelpers.interopDefault(_delaunayJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);

},{"./delaunay.js":"hfEHi","./voronoi.js":"Z64rv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfEHi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _delaunator = require("delaunator");
var _delaunatorDefault = parcelHelpers.interopDefault(_delaunator);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);
const tau = 2 * Math.PI, pow = Math.pow;
function pointX(p) {
    return p[0];
}
function pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
    const { triangles, coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class Delaunay {
    static from(points, fx = pointX, fy = pointY, that) {
        return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, _delaunatorDefault.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, _delaunatorDefault.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            this.triangles[1] = hull[1];
            this.triangles[2] = hull[1];
            inedges[hull[0]] = 1;
            if (hull.length === 2) inedges[hull[1]] = 0;
        }
    }
    voronoi(bounds) {
        return new (0, _voronoiJsDefault.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges, hull, _hullIndex, halfedges, triangles, collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges, hull, _hullIndex, halfedges, triangles, points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, halfedges, triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r = 2) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { hull, points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
exports.default = Delaunay;
function flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

},{"delaunator":"4UlH7","./path.js":"e9zXa","./polygon.js":"98mgp","./voronoi.js":"Z64rv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4UlH7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
    static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new Delaunator(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let minDist = Infinity;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0; i < n; i++){
            const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        minDist = Infinity;
        // find the point closest to the seed
        for(let i = 0; i < n; i++){
            if (i === i0) continue;
            const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], !orient(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], orient(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1])){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], orient(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
exports.default = Delaunator;
// monotonically increases with real angle, but doesn't need expensive trigonometry
function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
// return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
function orientIfSure(px, py, rx, ry, qx, qy) {
    const l = (ry - py) * (qx - px);
    const r = (rx - px) * (qy - py);
    return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
}
// a more robust orientation test that's stable in a given triangle (to fix robustness issues)
function orient(rx, ry, qx, qy, px, py) {
    const sign = orientIfSure(px, py, rx, ry, qx, qy) || orientIfSure(rx, ry, qx, qy, px, py) || orientIfSure(qx, qy, px, py, rx, ry);
    return sign < 0;
}
function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x,
        y
    };
}
function quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            quicksort(ids, dists, i, right);
            quicksort(ids, dists, left, j - 1);
        } else {
            quicksort(ids, dists, left, j - 1);
            quicksort(ids, dists, i, right);
        }
    }
}
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function defaultGetX(p) {
    return p[0];
}
function defaultGetY(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9zXa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const epsilon = 1e-6;
class Path {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}
exports.default = Path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98mgp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Polygon {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}
exports.default = Polygon;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Z64rv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
class Voronoi {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points, hull, triangles }, vectors } = this;
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            const ab = (dx * ey - dy * ex) * 2;
            if (!ab) {
                // degenerate case (collinear diagram)
                x = (x1 + x3) / 2 - 1e8 * ey;
                y = (y1 + y3) / 2 + 1e8 * ex;
            } else if (Math.abs(ab) < 1e-8) {
                // almost equal points (degenerate triangle)
                x = (x1 + x3) / 2;
                y = (y1 + y3) / 2;
            } else {
                const d = 1 / ab;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { delaunay: { halfedges, inedges, hull }, circumcenters, vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        while(true){
            if (c0 === 0 && c1 === 0) return [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        if (P.length > 4) for(let i = 0; i < P.length; i += 2){
            const j = (i + 2) % P.length, k = (i + 4) % P.length;
            if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
}
exports.default = Voronoi;

},{"./path.js":"e9zXa","./polygon.js":"98mgp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Jxi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsvFormat", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csvParse", ()=>(0, _csvJs.csvParse));
parcelHelpers.export(exports, "csvParseRows", ()=>(0, _csvJs.csvParseRows));
parcelHelpers.export(exports, "csvFormat", ()=>(0, _csvJs.csvFormat));
parcelHelpers.export(exports, "csvFormatBody", ()=>(0, _csvJs.csvFormatBody));
parcelHelpers.export(exports, "csvFormatRows", ()=>(0, _csvJs.csvFormatRows));
parcelHelpers.export(exports, "csvFormatRow", ()=>(0, _csvJs.csvFormatRow));
parcelHelpers.export(exports, "csvFormatValue", ()=>(0, _csvJs.csvFormatValue));
parcelHelpers.export(exports, "tsvParse", ()=>(0, _tsvJs.tsvParse));
parcelHelpers.export(exports, "tsvParseRows", ()=>(0, _tsvJs.tsvParseRows));
parcelHelpers.export(exports, "tsvFormat", ()=>(0, _tsvJs.tsvFormat));
parcelHelpers.export(exports, "tsvFormatBody", ()=>(0, _tsvJs.tsvFormatBody));
parcelHelpers.export(exports, "tsvFormatRows", ()=>(0, _tsvJs.tsvFormatRows));
parcelHelpers.export(exports, "tsvFormatRow", ()=>(0, _tsvJs.tsvFormatRow));
parcelHelpers.export(exports, "tsvFormatValue", ()=>(0, _tsvJs.tsvFormatValue));
parcelHelpers.export(exports, "autoType", ()=>(0, _autoTypeJsDefault.default));
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _csvJs = require("./csv.js");
var _tsvJs = require("./tsv.js");
var _autoTypeJs = require("./autoType.js");
var _autoTypeJsDefault = parcelHelpers.interopDefault(_autoTypeJs);

},{"./dsv.js":"aG13X","./csv.js":"6akDa","./tsv.js":"hJZEe","./autoType.js":"e6fGF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aG13X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(delimiter) {
        var reFormat = new RegExp('["' + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, '"');
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    });
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + '] || ""';
    }).join(",") + "}");
}
function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear(year) {
    return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : formatYear(date.getUTCFullYear(), 4) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6akDa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "csvParse", ()=>csvParse);
parcelHelpers.export(exports, "csvParseRows", ()=>csvParseRows);
parcelHelpers.export(exports, "csvFormat", ()=>csvFormat);
parcelHelpers.export(exports, "csvFormatBody", ()=>csvFormatBody);
parcelHelpers.export(exports, "csvFormatRows", ()=>csvFormatRows);
parcelHelpers.export(exports, "csvFormatRow", ()=>csvFormatRow);
parcelHelpers.export(exports, "csvFormatValue", ()=>csvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var csv = (0, _dsvJsDefault.default)(",");
var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatBody = csv.formatBody;
var csvFormatRows = csv.formatRows;
var csvFormatRow = csv.formatRow;
var csvFormatValue = csv.formatValue;

},{"./dsv.js":"aG13X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hJZEe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tsvParse", ()=>tsvParse);
parcelHelpers.export(exports, "tsvParseRows", ()=>tsvParseRows);
parcelHelpers.export(exports, "tsvFormat", ()=>tsvFormat);
parcelHelpers.export(exports, "tsvFormatBody", ()=>tsvFormatBody);
parcelHelpers.export(exports, "tsvFormatRows", ()=>tsvFormatRows);
parcelHelpers.export(exports, "tsvFormatRow", ()=>tsvFormatRow);
parcelHelpers.export(exports, "tsvFormatValue", ()=>tsvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var tsv = (0, _dsvJsDefault.default)("	");
var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatBody = tsv.formatBody;
var tsvFormatRows = tsv.formatRows;
var tsvFormatRow = tsv.formatRow;
var tsvFormatValue = tsv.formatValue;

},{"./dsv.js":"aG13X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e6fGF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>autoType);
function autoType(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZ2qo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blob", ()=>(0, _blobJsDefault.default));
parcelHelpers.export(exports, "buffer", ()=>(0, _bufferJsDefault.default));
parcelHelpers.export(exports, "dsv", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csv", ()=>(0, _dsvJs.csv));
parcelHelpers.export(exports, "tsv", ()=>(0, _dsvJs.tsv));
parcelHelpers.export(exports, "image", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "json", ()=>(0, _jsonJsDefault.default));
parcelHelpers.export(exports, "text", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "xml", ()=>(0, _xmlJsDefault.default));
parcelHelpers.export(exports, "html", ()=>(0, _xmlJs.html));
parcelHelpers.export(exports, "svg", ()=>(0, _xmlJs.svg));
var _blobJs = require("./blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _imageJs = require("./image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _jsonJs = require("./json.js");
var _jsonJsDefault = parcelHelpers.interopDefault(_jsonJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _xmlJs = require("./xml.js");
var _xmlJsDefault = parcelHelpers.interopDefault(_xmlJs);

},{"./blob.js":"52NQv","./buffer.js":"g92qc","./dsv.js":"8P16R","./image.js":"9Zx5V","./json.js":"ceAuY","./text.js":"d6voj","./xml.js":"5aqmc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"52NQv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseBlob);
    });
function responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g92qc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseArrayBuffer);
    });
function responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P16R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dsv);
parcelHelpers.export(exports, "csv", ()=>csv);
parcelHelpers.export(exports, "tsv", ()=>tsv);
var _d3Dsv = require("d3-dsv");
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, _textJsDefault.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function dsv(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, _d3Dsv.dsvFormat)(delimiter);
    return (0, _textJsDefault.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var csv = dsvParse((0, _d3Dsv.csvParse));
var tsv = dsvParse((0, _d3Dsv.tsvParse));

},{"d3-dsv":"59Jxi","./text.js":"d6voj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6voj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseText);
    });
function responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Zx5V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return new Promise(function(resolve, reject) {
            var image = new Image;
            for(var key in init)image[key] = init[key];
            image.onerror = reject;
            image.onload = function() {
                resolve(image);
            };
            image.src = input;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ceAuY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseJson);
    });
function responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5aqmc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "svg", ()=>svg);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function parser(type) {
    return (input, init)=>(0, _textJsDefault.default)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
exports.default = parser("application/xml");
var html = parser("text/html");
var svg = parser("image/svg+xml");

},{"./text.js":"d6voj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67Mne":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceCenter", ()=>(0, _centerJsDefault.default));
parcelHelpers.export(exports, "forceCollide", ()=>(0, _collideJsDefault.default));
parcelHelpers.export(exports, "forceLink", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "forceManyBody", ()=>(0, _manyBodyJsDefault.default));
parcelHelpers.export(exports, "forceRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "forceSimulation", ()=>(0, _simulationJsDefault.default));
parcelHelpers.export(exports, "forceX", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "forceY", ()=>(0, _yJsDefault.default));
var _centerJs = require("./center.js");
var _centerJsDefault = parcelHelpers.interopDefault(_centerJs);
var _collideJs = require("./collide.js");
var _collideJsDefault = parcelHelpers.interopDefault(_collideJs);
var _linkJs = require("./link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _manyBodyJs = require("./manyBody.js");
var _manyBodyJsDefault = parcelHelpers.interopDefault(_manyBodyJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _simulationJs = require("./simulation.js");
var _simulationJsDefault = parcelHelpers.interopDefault(_simulationJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);

},{"./center.js":"d1ShK","./collide.js":"4XlLY","./link.js":"5c9TZ","./manyBody.js":"gAD1B","./radial.js":"21kIj","./simulation.js":"3RfPP","./x.js":"kRsbd","./y.js":"d6AXc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d1ShK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XlLY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                            if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function x(d) {
    return d.x + d.vx;
}
function y(d) {
    return d.y + d.vy;
}

},{"d3-quadtree":"5yYuF","./constant.js":"2kwg2","./jiggle.js":"axE08","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5yYuF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadtree", ()=>(0, _quadtreeJsDefault.default));
var _quadtreeJs = require("./quadtree.js");
var _quadtreeJsDefault = parcelHelpers.interopDefault(_quadtreeJs);

},{"./quadtree.js":"6vDgM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vDgM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quadtree);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _coverJs = require("./cover.js");
var _coverJsDefault = parcelHelpers.interopDefault(_coverJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _rootJs = require("./root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _visitJs = require("./visit.js");
var _visitJsDefault = parcelHelpers.interopDefault(_visitJs);
var _visitAfterJs = require("./visitAfter.js");
var _visitAfterJsDefault = parcelHelpers.interopDefault(_visitAfterJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);
function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? (0, _xJs.defaultX) : x, y == null ? (0, _yJs.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = leaf_copy(child);
        }
    }
    return copy;
};
treeProto.add = (0, _addJsDefault.default);
treeProto.addAll = (0, _addJs.addAll);
treeProto.cover = (0, _coverJsDefault.default);
treeProto.data = (0, _dataJsDefault.default);
treeProto.extent = (0, _extentJsDefault.default);
treeProto.find = (0, _findJsDefault.default);
treeProto.remove = (0, _removeJsDefault.default);
treeProto.removeAll = (0, _removeJs.removeAll);
treeProto.root = (0, _rootJsDefault.default);
treeProto.size = (0, _sizeJsDefault.default);
treeProto.visit = (0, _visitJsDefault.default);
treeProto.visitAfter = (0, _visitAfterJsDefault.default);
treeProto.x = (0, _xJsDefault.default);
treeProto.y = (0, _yJsDefault.default);

},{"./add.js":"7LC4G","./cover.js":"5es8I","./data.js":"8I0lM","./extent.js":"aU9hE","./find.js":"jpx7G","./remove.js":"3QFtD","./root.js":"khDrv","./size.js":"cQzYu","./visit.js":"8xbxh","./visitAfter.js":"ihORj","./x.js":"iDUW5","./y.js":"iLKgW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LC4G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    });
parcelHelpers.export(exports, "addAll", ()=>addAll);
function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5es8I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8I0lM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aU9hE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jpx7G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new (0, _quadJsDefault.default)(node[3], xm, ym, x2, y2), new (0, _quadJsDefault.default)(node[2], x1, ym, xm, y2), new (0, _quadJsDefault.default)(node[1], xm, y1, x2, ym), new (0, _quadJsDefault.default)(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2MGsj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QFtD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    });
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
function removeAll(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"khDrv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._root;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQzYu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xbxh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
        }
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihORj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new (0, _quadJsDefault.default)(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDUW5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultX", ()=>defaultX);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    });
function defaultX(d) {
    return d[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLKgW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultY", ()=>defaultY);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    });
function defaultY(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kwg2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axE08":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(random) {
        return (random() - 0.5) * 1e-6;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5c9TZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(links) {
        var id = index, strength = defaultStrength, strengths, distance = (0, _constantJsDefault.default)(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || (0, _jiggleJsDefault.default)(random);
                y = target.y + target.vy - source.y - source.vy || (0, _jiggleJsDefault.default)(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeDistance(), force) : distance;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function index(d) {
    return d.index;
}
function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}

},{"./constant.js":"2kwg2","./jiggle.js":"axE08","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAD1B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes, node, random, alpha, strength = (0, _constantJsDefault.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = (0, _d3Quadtree.quadtree)(nodes, (0, _simulationJs.x), (0, _simulationJs.y)).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                    if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
var _simulationJs = require("./simulation.js");

},{"d3-quadtree":"5yYuF","./constant.js":"2kwg2","./jiggle.js":"axE08","./simulation.js":"3RfPP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RfPP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
parcelHelpers.export(exports, "default", ()=>function(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, _d3Timer.timer)(step), event = (0, _d3Dispatch.dispatch)("tick", "end"), random = (0, _lcgJsDefault.default)();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function x(d) {
    return d.x;
}
function y(d) {
    return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));

},{"d3-dispatch":"2VwUr","d3-timer":"lpgSt","./lcg.js":"1I11x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1I11x":[function(require,module,exports) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21kIj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius, x, y) {
        var nodes, strength = (0, _constantJsDefault.default)(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kRsbd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = (0, _constantJsDefault.default)(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : x;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6AXc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(y) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = (0, _constantJsDefault.default)(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97aCb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _defaultLocaleJs.format));
parcelHelpers.export(exports, "formatPrefix", ()=>(0, _defaultLocaleJs.formatPrefix));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "formatSpecifier", ()=>(0, _formatSpecifierJsDefault.default));
parcelHelpers.export(exports, "FormatSpecifier", ()=>(0, _formatSpecifierJs.FormatSpecifier));
parcelHelpers.export(exports, "precisionFixed", ()=>(0, _precisionFixedJsDefault.default));
parcelHelpers.export(exports, "precisionPrefix", ()=>(0, _precisionPrefixJsDefault.default));
parcelHelpers.export(exports, "precisionRound", ()=>(0, _precisionRoundJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"j70HL","./locale.js":"lYlSA","./formatSpecifier.js":"51Kl1","./precisionFixed.js":"k1LIY","./precisionPrefix.js":"jGAhd","./precisionRound.js":"1aiyN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j70HL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"lYlSA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lYlSA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"2idUI","./formatGroup.js":"8F8bk","./formatNumerals.js":"evZ3T","./formatSpecifier.js":"51Kl1","./formatTrim.js":"5Jmf8","./formatTypes.js":"9eqgx","./formatPrefixAuto.js":"8YfIw","./identity.js":"21vxF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2idUI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"6SG29","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6SG29":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8F8bk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evZ3T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51Kl1":[function(require,module,exports) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Jmf8":[function(require,module,exports) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9eqgx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, _formatDecimalJsDefault.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRoundedJsDefault.default)(x * 100, p),
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

},{"./formatDecimal.js":"6SG29","./formatPrefixAuto.js":"8YfIw","./formatRounded.js":"jQKJD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YfIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"6SG29","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQKJD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"6SG29","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21vxF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1LIY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"2idUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGAhd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"2idUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1aiyN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"2idUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQZKv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "geoBounds", ()=>(0, _boundsJsDefault.default));
parcelHelpers.export(exports, "geoCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "geoCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "geoClipAntimeridian", ()=>(0, _antimeridianJsDefault.default));
parcelHelpers.export(exports, "geoClipCircle", ()=>(0, _circleJsDefault1.default));
parcelHelpers.export(exports, "geoClipExtent", ()=>(0, _extentJsDefault.default)) // DEPRECATED! Use d3.geoIdentity().clipExtent(…).
;
parcelHelpers.export(exports, "geoClipRectangle", ()=>(0, _rectangleJsDefault.default));
parcelHelpers.export(exports, "geoContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "geoDistance", ()=>(0, _distanceJsDefault.default));
parcelHelpers.export(exports, "geoGraticule", ()=>(0, _graticuleJsDefault.default));
parcelHelpers.export(exports, "geoGraticule10", ()=>(0, _graticuleJs.graticule10));
parcelHelpers.export(exports, "geoInterpolate", ()=>(0, _interpolateJsDefault.default));
parcelHelpers.export(exports, "geoLength", ()=>(0, _lengthJsDefault.default));
parcelHelpers.export(exports, "geoPath", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "geoAlbers", ()=>(0, _albersJsDefault.default));
parcelHelpers.export(exports, "geoAlbersUsa", ()=>(0, _albersUsaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualArea", ()=>(0, _azimuthalEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualAreaRaw", ()=>(0, _azimuthalEqualAreaJs.azimuthalEqualAreaRaw));
parcelHelpers.export(exports, "geoAzimuthalEquidistant", ()=>(0, _azimuthalEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEquidistantRaw", ()=>(0, _azimuthalEquidistantJs.azimuthalEquidistantRaw));
parcelHelpers.export(exports, "geoConicConformal", ()=>(0, _conicConformalJsDefault.default));
parcelHelpers.export(exports, "geoConicConformalRaw", ()=>(0, _conicConformalJs.conicConformalRaw));
parcelHelpers.export(exports, "geoConicEqualArea", ()=>(0, _conicEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoConicEqualAreaRaw", ()=>(0, _conicEqualAreaJs.conicEqualAreaRaw));
parcelHelpers.export(exports, "geoConicEquidistant", ()=>(0, _conicEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoConicEquidistantRaw", ()=>(0, _conicEquidistantJs.conicEquidistantRaw));
parcelHelpers.export(exports, "geoEqualEarth", ()=>(0, _equalEarthJsDefault.default));
parcelHelpers.export(exports, "geoEqualEarthRaw", ()=>(0, _equalEarthJs.equalEarthRaw));
parcelHelpers.export(exports, "geoEquirectangular", ()=>(0, _equirectangularJsDefault.default));
parcelHelpers.export(exports, "geoEquirectangularRaw", ()=>(0, _equirectangularJs.equirectangularRaw));
parcelHelpers.export(exports, "geoGnomonic", ()=>(0, _gnomonicJsDefault.default));
parcelHelpers.export(exports, "geoGnomonicRaw", ()=>(0, _gnomonicJs.gnomonicRaw));
parcelHelpers.export(exports, "geoIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "geoProjection", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "geoProjectionMutator", ()=>(0, _indexJs1.projectionMutator));
parcelHelpers.export(exports, "geoMercator", ()=>(0, _mercatorJsDefault.default));
parcelHelpers.export(exports, "geoMercatorRaw", ()=>(0, _mercatorJs.mercatorRaw));
parcelHelpers.export(exports, "geoNaturalEarth1", ()=>(0, _naturalEarth1JsDefault.default));
parcelHelpers.export(exports, "geoNaturalEarth1Raw", ()=>(0, _naturalEarth1Js.naturalEarth1Raw));
parcelHelpers.export(exports, "geoOrthographic", ()=>(0, _orthographicJsDefault.default));
parcelHelpers.export(exports, "geoOrthographicRaw", ()=>(0, _orthographicJs.orthographicRaw));
parcelHelpers.export(exports, "geoStereographic", ()=>(0, _stereographicJsDefault.default));
parcelHelpers.export(exports, "geoStereographicRaw", ()=>(0, _stereographicJs.stereographicRaw));
parcelHelpers.export(exports, "geoTransverseMercator", ()=>(0, _transverseMercatorJsDefault.default));
parcelHelpers.export(exports, "geoTransverseMercatorRaw", ()=>(0, _transverseMercatorJs.transverseMercatorRaw));
parcelHelpers.export(exports, "geoRotation", ()=>(0, _rotationJsDefault.default));
parcelHelpers.export(exports, "geoStream", ()=>(0, _streamJsDefault.default));
parcelHelpers.export(exports, "geoTransform", ()=>(0, _transformJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _circleJs = require("./circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _antimeridianJs = require("./clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs1 = require("./clip/circle.js");
var _circleJsDefault1 = parcelHelpers.interopDefault(_circleJs1);
var _extentJs = require("./clip/extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _rectangleJs = require("./clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _graticuleJs = require("./graticule.js");
var _graticuleJsDefault = parcelHelpers.interopDefault(_graticuleJs);
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _indexJs = require("./path/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _albersJs = require("./projection/albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _albersUsaJs = require("./projection/albersUsa.js");
var _albersUsaJsDefault = parcelHelpers.interopDefault(_albersUsaJs);
var _azimuthalEqualAreaJs = require("./projection/azimuthalEqualArea.js");
var _azimuthalEqualAreaJsDefault = parcelHelpers.interopDefault(_azimuthalEqualAreaJs);
var _azimuthalEquidistantJs = require("./projection/azimuthalEquidistant.js");
var _azimuthalEquidistantJsDefault = parcelHelpers.interopDefault(_azimuthalEquidistantJs);
var _conicConformalJs = require("./projection/conicConformal.js");
var _conicConformalJsDefault = parcelHelpers.interopDefault(_conicConformalJs);
var _conicEqualAreaJs = require("./projection/conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _conicEquidistantJs = require("./projection/conicEquidistant.js");
var _conicEquidistantJsDefault = parcelHelpers.interopDefault(_conicEquidistantJs);
var _equalEarthJs = require("./projection/equalEarth.js");
var _equalEarthJsDefault = parcelHelpers.interopDefault(_equalEarthJs);
var _equirectangularJs = require("./projection/equirectangular.js");
var _equirectangularJsDefault = parcelHelpers.interopDefault(_equirectangularJs);
var _gnomonicJs = require("./projection/gnomonic.js");
var _gnomonicJsDefault = parcelHelpers.interopDefault(_gnomonicJs);
var _identityJs = require("./projection/identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _indexJs1 = require("./projection/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _mercatorJs = require("./projection/mercator.js");
var _mercatorJsDefault = parcelHelpers.interopDefault(_mercatorJs);
var _naturalEarth1Js = require("./projection/naturalEarth1.js");
var _naturalEarth1JsDefault = parcelHelpers.interopDefault(_naturalEarth1Js);
var _orthographicJs = require("./projection/orthographic.js");
var _orthographicJsDefault = parcelHelpers.interopDefault(_orthographicJs);
var _stereographicJs = require("./projection/stereographic.js");
var _stereographicJsDefault = parcelHelpers.interopDefault(_stereographicJs);
var _transverseMercatorJs = require("./projection/transverseMercator.js");
var _transverseMercatorJsDefault = parcelHelpers.interopDefault(_transverseMercatorJs);
var _rotationJs = require("./rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./area.js":"hfp1u","./bounds.js":"3mtJj","./centroid.js":"e2FyM","./circle.js":"i8eJz","./clip/antimeridian.js":"gdVz3","./clip/circle.js":"jHMRk","./clip/extent.js":"6NFVu","./clip/rectangle.js":"cmyz6","./contains.js":"4Ax1X","./distance.js":"2Xo7Z","./graticule.js":"5h4Wk","./interpolate.js":"c6YqV","./length.js":"lcoiE","./path/index.js":"8Av9e","./projection/albers.js":"lTRWa","./projection/albersUsa.js":"enFIP","./projection/azimuthalEqualArea.js":"5uowk","./projection/azimuthalEquidistant.js":"47ye5","./projection/conicConformal.js":"kIoAV","./projection/conicEqualArea.js":"cGDVP","./projection/conicEquidistant.js":"1hkbk","./projection/equalEarth.js":"lMwLK","./projection/equirectangular.js":"cTwHL","./projection/gnomonic.js":"hx9Pk","./projection/identity.js":"fJNsT","./projection/index.js":"h6rSs","./projection/mercator.js":"itxln","./projection/naturalEarth1.js":"6uiN3","./projection/orthographic.js":"9l5H5","./projection/stereographic.js":"iSTLy","./projection/transverseMercator.js":"kRAj0","./rotation.js":"kS2aY","./stream.js":"l5ilc","./transform.js":"hXP19","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfp1u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areaRingSum", ()=>areaRingSum);
parcelHelpers.export(exports, "areaStream", ()=>areaStream);
parcelHelpers.export(exports, "default", ()=>function(object) {
        areaSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, areaStream);
        return areaSum * 2;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var areaRingSum = new (0, _d3Array.Adder)();
// hello?
var areaSum = new (0, _d3Array.Adder)(), lambda00, phi00, lambda0, cosPhi0, sinPhi0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaRingSum = new (0, _d3Array.Adder)();
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +areaRingSum;
        areaSum.add(areaRing < 0 ? (0, _mathJs.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, _noopJsDefault.default);
    },
    sphere: function() {
        areaSum.add((0, _mathJs.tau));
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaRingEnd() {
    areaPoint(lambda00, phi00);
}
function areaPointFirst(lambda, phi) {
    areaStream.point = areaPoint;
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, cosPhi0 = (0, _mathJs.cos)(phi = phi / 2 + (0, _mathJs.quarterPi)), sinPhi0 = (0, _mathJs.sin)(phi);
}
function areaPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    phi = phi / 2 + (0, _mathJs.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.sin)(phi), k = sinPhi0 * sinPhi, u = cosPhi0 * cosPhi + k * (0, _mathJs.cos)(adLambda), v = k * sdLambda * (0, _mathJs.sin)(adLambda);
    areaRingSum.add((0, _mathJs.atan2)(v, u));
    // Advance the previous points.
    lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

},{"d3-array":"aoYKF","./math.js":"3L2E2","./noop.js":"aImez","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3L2E2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "hypot", ()=>hypot);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "haversin", ()=>haversin);
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
    return (x = sin(x / 2)) * x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aImez":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l5ilc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    });
function streamGeometry(geometry, stream) {
    if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
}
var streamObjectType = {
    Feature: function(object, stream) {
        streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)streamGeometry(features[i].geometry, stream);
    }
};
var streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)streamGeometry(geometries[i], stream);
    }
};
function streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3mtJj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
        ranges = [];
        (0, _streamJsDefault.default)(feature, boundsStream);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    });
var _d3Array = require("d3-array");
var _areaJs = require("./area.js");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lambda0, phi0, lambda1, phi1, lambda2, lambda00, phi00, p0, deltaSum, ranges, range;
var boundsStream = {
    point: boundsPoint,
    lineStart: boundsLineStart,
    lineEnd: boundsLineEnd,
    polygonStart: function() {
        boundsStream.point = boundsRingPoint;
        boundsStream.lineStart = boundsRingStart;
        boundsStream.lineEnd = boundsRingEnd;
        deltaSum = new (0, _d3Array.Adder)();
        (0, _areaJs.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, _areaJs.areaStream).polygonEnd();
        boundsStream.point = boundsPoint;
        boundsStream.lineStart = boundsLineStart;
        boundsStream.lineEnd = boundsLineEnd;
        if ((0, _areaJs.areaRingSum) < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        else if (deltaSum > (0, _mathJs.epsilon)) phi1 = 90;
        else if (deltaSum < -(0, _mathJs.epsilon)) phi0 = -90;
        range[0] = lambda0, range[1] = lambda1;
    },
    sphere: function() {
        lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    }
};
function boundsPoint(lambda, phi) {
    ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
}
function linePoint(lambda, phi) {
    var p = (0, _cartesianJs.cartesian)([
        lambda * (0, _mathJs.radians),
        phi * (0, _mathJs.radians)
    ]);
    if (p0) {
        var normal = (0, _cartesianJs.cartesianCross)(p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, _cartesianJs.cartesianCross)(equatorial, normal);
        (0, _cartesianJs.cartesianNormalizeInPlace)(inflection);
        inflection = (0, _cartesianJs.spherical)(inflection);
        var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, _mathJs.degrees) * sign, phii, antimeridian = (0, _mathJs.abs)(delta) > 180;
        if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, _mathJs.degrees);
            if (phii > phi1) phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, _mathJs.degrees);
            if (phii < phi0) phi0 = phii;
        } else {
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        } else if (lambda1 >= lambda0) {
            if (lambda < lambda0) lambda0 = lambda;
            if (lambda > lambda1) lambda1 = lambda;
        } else {
            if (lambda > lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
    } else ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
    p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
    boundsStream.point = linePoint;
}
function boundsLineEnd() {
    range[0] = lambda0, range[1] = lambda1;
    boundsStream.point = boundsPoint;
    p0 = null;
}
function boundsRingPoint(lambda, phi) {
    if (p0) {
        var delta = lambda - lambda2;
        deltaSum.add((0, _mathJs.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else lambda00 = lambda, phi00 = phi;
    (0, _areaJs.areaStream).point(lambda, phi);
    linePoint(lambda, phi);
}
function boundsRingStart() {
    (0, _areaJs.areaStream).lineStart();
}
function boundsRingEnd() {
    boundsRingPoint(lambda00, phi00);
    (0, _areaJs.areaStream).lineEnd();
    if ((0, _mathJs.abs)(deltaSum) > (0, _mathJs.epsilon)) lambda0 = -(lambda1 = 180);
    range[0] = lambda0, range[1] = lambda1;
    p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function rangeCompare(a, b) {
    return a[0] - b[0];
}
function rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

},{"d3-array":"aoYKF","./area.js":"hfp1u","./cartesian.js":"gJZ0B","./math.js":"3L2E2","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJZ0B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spherical", ()=>spherical);
parcelHelpers.export(exports, "cartesian", ()=>cartesian);
parcelHelpers.export(exports, "cartesianDot", ()=>cartesianDot);
parcelHelpers.export(exports, "cartesianCross", ()=>cartesianCross);
// TODO return a
parcelHelpers.export(exports, "cartesianAddInPlace", ()=>cartesianAddInPlace);
parcelHelpers.export(exports, "cartesianScale", ()=>cartesianScale);
// TODO return d
parcelHelpers.export(exports, "cartesianNormalizeInPlace", ()=>cartesianNormalizeInPlace);
var _mathJs = require("./math.js");
function spherical(cartesian) {
    return [
        (0, _mathJs.atan2)(cartesian[1], cartesian[0]),
        (0, _mathJs.asin)(cartesian[2])
    ];
}
function cartesian(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, _mathJs.cos)(phi);
    return [
        cosPhi * (0, _mathJs.cos)(lambda),
        cosPhi * (0, _mathJs.sin)(lambda),
        (0, _mathJs.sin)(phi)
    ];
}
function cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function cartesianAddInPlace(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function cartesianNormalizeInPlace(d) {
    var l = (0, _mathJs.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

},{"./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2FyM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = 0;
        X2 = new (0, _d3Array.Adder)();
        Y2 = new (0, _d3Array.Adder)();
        Z2 = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, centroidStream);
        var x = +X2, y = +Y2, z = +Z2, m = (0, _mathJs.hypot)(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < (0, _mathJs.epsilon2)) {
            x = X1, y = Y1, z = Z1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < (0, _mathJs.epsilon)) x = X0, y = Y0, z = Z0;
            m = (0, _mathJs.hypot)(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < (0, _mathJs.epsilon2)) return [
                NaN,
                NaN
            ];
        }
        return [
            (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
            (0, _mathJs.asin)(z / m) * (0, _mathJs.degrees)
        ];
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, x0, y0, z0; // previous point
var centroidStream = {
    sphere: (0, _noopJsDefault.default),
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    centroidPointCartesian(cosPhi * (0, _mathJs.cos)(lambda), cosPhi * (0, _mathJs.sin)(lambda), (0, _mathJs.sin)(phi));
}
function centroidPointCartesian(x, y, z) {
    ++W0;
    X0 += (x - X0) / W0;
    Y0 += (y - Y0) / W0;
    Z0 += (z - Z0) / W0;
}
function centroidLineStart() {
    centroidStream.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidStream.point = centroidLinePoint;
    centroidPointCartesian(x0, y0, z0);
}
function centroidLinePoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), w = (0, _mathJs.atan2)((0, _mathJs.sqrt)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
    centroidStream.point = centroidRingPointFirst;
}
function centroidRingEnd() {
    centroidRingPoint(lambda00, phi00);
    centroidStream.point = centroidPoint;
}
function centroidRingPointFirst(lambda, phi) {
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    centroidStream.point = centroidRingPoint;
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidPointCartesian(x0, y0, z0);
}
function centroidRingPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = (0, _mathJs.hypot)(cx, cy, cz), w = (0, _mathJs.asin)(m), v = m && -w / m; // area weight multiplier
    X2.add(v * cx);
    Y2.add(v * cy);
    Z2.add(v * cz);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}

},{"d3-array":"aoYKF","./math.js":"3L2E2","./noop.js":"aImez","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8eJz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generates a circle centered at [0°, 0°], with a given radius and precision.
parcelHelpers.export(exports, "circleStream", ()=>circleStream);
parcelHelpers.export(exports, "default", ()=>function() {
        var center = (0, _constantJsDefault.default)([
            0,
            0
        ]), radius = (0, _constantJsDefault.default)(90), precision = (0, _constantJsDefault.default)(6), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= (0, _mathJs.degrees), x[1] *= (0, _mathJs.degrees);
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, _mathJs.radians), p = precision.apply(this, arguments) * (0, _mathJs.radians);
            ring = [];
            rotate = (0, _rotationJs.rotateRadians)(-c[0] * (0, _mathJs.radians), -c[1] * (0, _mathJs.radians), 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : precision;
        };
        return circle;
    });
var _cartesianJs = require("./cartesian.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _rotationJs = require("./rotation.js");
function circleStream(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, _mathJs.cos)(radius), sinRadius = (0, _mathJs.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, _mathJs.tau);
        t1 = radius - step / 2;
    } else {
        t0 = circleRadius(cosRadius, t0);
        t1 = circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, _mathJs.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, _cartesianJs.spherical)([
            cosRadius,
            -sinRadius * (0, _mathJs.cos)(t),
            -sinRadius * (0, _mathJs.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
    point = (0, _cartesianJs.cartesian)(point), point[0] -= cosRadius;
    (0, _cartesianJs.cartesianNormalizeInPlace)(point);
    var radius = (0, _mathJs.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, _mathJs.tau) - (0, _mathJs.epsilon)) % (0, _mathJs.tau);
}

},{"./cartesian.js":"gJZ0B","./constant.js":"PdAls","./math.js":"3L2E2","./rotation.js":"kS2aY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"PdAls":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kS2aY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rotateRadians", ()=>rotateRadians);
parcelHelpers.export(exports, "default", ()=>function(rotate) {
        rotate = rotateRadians(rotate[0] * (0, _mathJs.radians), rotate[1] * (0, _mathJs.radians), rotate.length > 2 ? rotate[2] * (0, _mathJs.radians) : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        };
        return forward;
    });
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mathJs = require("./math.js");
function rotationIdentity(lambda, phi) {
    return [
        (0, _mathJs.abs)(lambda) > (0, _mathJs.pi) ? lambda + Math.round(-lambda / (0, _mathJs.tau)) * (0, _mathJs.tau) : lambda,
        phi
    ];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, _mathJs.tau)) ? deltaPhi || deltaGamma ? (0, _composeJsDefault.default)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, _mathJs.pi) ? lambda - (0, _mathJs.tau) : lambda < -(0, _mathJs.pi) ? lambda + (0, _mathJs.tau) : lambda,
            phi
        ];
    };
}
function rotationLambda(deltaLambda) {
    var rotation = forwardRotationLambda(deltaLambda);
    rotation.invert = forwardRotationLambda(-deltaLambda);
    return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, _mathJs.cos)(deltaPhi), sinDeltaPhi = (0, _mathJs.sin)(deltaPhi), cosDeltaGamma = (0, _mathJs.cos)(deltaGamma), sinDeltaGamma = (0, _mathJs.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}

},{"./compose.js":"aIo7W","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aIo7W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdVz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
exports.default = (0, _indexJsDefault.default)(function() {
    return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [
    -(0, _mathJs.pi),
    -(0, _mathJs.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi), delta = (0, _mathJs.abs)(lambda1 - lambda0);
            if ((0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, _mathJs.halfPi) : -(0, _mathJs.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, _mathJs.pi)) {
                if ((0, _mathJs.abs)(lambda0 - sign0) < (0, _mathJs.epsilon)) lambda0 -= sign0 * (0, _mathJs.epsilon); // handle degeneracies
                if ((0, _mathJs.abs)(lambda1 - sign1) < (0, _mathJs.epsilon)) lambda1 -= sign1 * (0, _mathJs.epsilon);
                phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, _mathJs.sin)(lambda0 - lambda1);
    return (0, _mathJs.abs)(sinLambda0Lambda1) > (0, _mathJs.epsilon) ? (0, _mathJs.atan)(((0, _mathJs.sin)(phi0) * (cosPhi1 = (0, _mathJs.cos)(phi1)) * (0, _mathJs.sin)(lambda1) - (0, _mathJs.sin)(phi1) * (cosPhi0 = (0, _mathJs.cos)(phi0)) * (0, _mathJs.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, _mathJs.halfPi);
        stream.point(-(0, _mathJs.pi), phi);
        stream.point(0, phi);
        stream.point((0, _mathJs.pi), phi);
        stream.point((0, _mathJs.pi), 0);
        stream.point((0, _mathJs.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, _mathJs.pi), -phi);
        stream.point(-(0, _mathJs.pi), 0);
        stream.point(-(0, _mathJs.pi), phi);
    } else if ((0, _mathJs.abs)(from[0] - to[0]) > (0, _mathJs.epsilon)) {
        var lambda = from[0] < to[0] ? (0, _mathJs.pi) : -(0, _mathJs.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

},{"./index.js":"iTS9b","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iTS9b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = (0, _bufferJsDefault.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = (0, _d3Array.merge)(segments);
                    var startInside = (0, _polygonContainsJsDefault.default)(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    });
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _mathJs = require("../math.js");
var _polygonContainsJs = require("../polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _d3Array = require("d3-array");
function validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - b[1]);
}

},{"./buffer.js":"jYtWq","./rejoin.js":"dTo08","../math.js":"3L2E2","../polygonContains.js":"bRTnR","d3-array":"aoYKF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYtWq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: (0, _noopJsDefault.default),
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);

},{"../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dTo08":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
parcelHelpers.export(exports, "default", ()=>function(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if ((0, _pointEqualJsDefault.default)(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * (0, _mathJs.epsilon);
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link(subject);
        link(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    });
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _mathJs = require("../math.js");
function Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

},{"../pointEqual.js":"2g1IQ","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2g1IQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return (0, _mathJs.abs)(a[0] - b[0]) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(a[1] - b[1]) < (0, _mathJs.epsilon);
    });
var _mathJs = require("./math.js");

},{"./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRTnR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = (0, _mathJs.sin)(phi), normal = [
            (0, _mathJs.sin)(lambda),
            -(0, _mathJs.cos)(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new (0, _d3Array.Adder)();
        if (sinPhi === 1) phi = (0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        else if (sinPhi === -1) phi = -(0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + (0, _mathJs.quarterPi), sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + (0, _mathJs.quarterPi), sinPhi1 = (0, _mathJs.sin)(phi1), cosPhi1 = (0, _mathJs.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, _mathJs.pi), k = sinPhi0 * sinPhi1;
                sum.add((0, _mathJs.atan2)(k * sign * (0, _mathJs.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, _mathJs.cos)(absDelta)));
                angle += antimeridian ? delta + sign * (0, _mathJs.tau) : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = (0, _cartesianJs.cartesianCross)((0, _cartesianJs.cartesian)(point0), (0, _cartesianJs.cartesian)(point1));
                    (0, _cartesianJs.cartesianNormalizeInPlace)(arc);
                    var intersection = (0, _cartesianJs.cartesianCross)(normal, arc);
                    (0, _cartesianJs.cartesianNormalizeInPlace)(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _mathJs.asin)(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -(0, _mathJs.epsilon) || angle < (0, _mathJs.epsilon) && sum < -(0, _mathJs.epsilon2)) ^ winding & 1;
    });
var _d3Array = require("d3-array");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
function longitude(point) {
    if ((0, _mathJs.abs)(point[0]) <= (0, _mathJs.pi)) return point[0];
    else return (0, _mathJs.sign)(point[0]) * (((0, _mathJs.abs)(point[0]) + (0, _mathJs.pi)) % (0, _mathJs.tau) - (0, _mathJs.pi));
}

},{"d3-array":"aoYKF","./cartesian.js":"gJZ0B","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jHMRk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var cr = (0, _mathJs.cos)(radius), delta = 6 * (0, _mathJs.radians), smallRadius = cr > 0, notHemisphere = (0, _mathJs.abs)(cr) > (0, _mathJs.epsilon); // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            (0, _circleJs.circleStream)(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return (0, _mathJs.cos)(lambda) * (0, _mathJs.cos)(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi)), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || (0, _pointEqualJsDefault.default)(point0, point2) || (0, _pointEqualJsDefault.default)(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !(0, _pointEqualJsDefault.default)(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = (0, _cartesianJs.cartesian)(a), pb = (0, _cartesianJs.cartesian)(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = (0, _cartesianJs.cartesianCross)(pa, pb), n2n2 = (0, _cartesianJs.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, _cartesianJs.cartesianCross)(n1, n2), A = (0, _cartesianJs.cartesianScale)(n1, c1), B = (0, _cartesianJs.cartesianScale)(n2, c2);
            (0, _cartesianJs.cartesianAddInPlace)(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = (0, _cartesianJs.cartesianDot)(A, u), uu = (0, _cartesianJs.cartesianDot)(u, u), t2 = w * w - uu * ((0, _cartesianJs.cartesianDot)(A, A) - 1);
            if (t2 < 0) return;
            var t = (0, _mathJs.sqrt)(t2), q = (0, _cartesianJs.cartesianScale)(u, (-w - t) / uu);
            (0, _cartesianJs.cartesianAddInPlace)(q, A);
            q = (0, _cartesianJs.spherical)(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = (0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon), meridian = polar || delta < (0, _mathJs.epsilon);
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _mathJs.abs)(q[0] - lambda0) < (0, _mathJs.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, _mathJs.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = (0, _cartesianJs.cartesianScale)(u, (-w + t) / uu);
                (0, _cartesianJs.cartesianAddInPlace)(q1, A);
                return [
                    q,
                    (0, _cartesianJs.spherical)(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : (0, _mathJs.pi) - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return (0, _indexJsDefault.default)(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -(0, _mathJs.pi),
            radius - (0, _mathJs.pi)
        ]);
    });
var _cartesianJs = require("../cartesian.js");
var _circleJs = require("../circle.js");
var _mathJs = require("../math.js");
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../cartesian.js":"gJZ0B","../circle.js":"i8eJz","../math.js":"3L2E2","../pointEqual.js":"2g1IQ","./index.js":"iTS9b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6NFVu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
        return clip = {
            stream: function(stream) {
                return cache && cacheStream === stream ? cache : cache = (0, _rectangleJsDefault.default)(x0, y0, x1, y1)(cacheStream = stream);
            },
            extent: function(_) {
                return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            }
        };
    });
var _rectangleJs = require("./rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);

},{"./rectangle.js":"cmyz6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cmyz6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>clipRectangle);
var _mathJs = require("../math.js");
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _d3Array = require("d3-array");
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, _mathJs.abs)(p[0] - x0) < (0, _mathJs.epsilon) ? direction > 0 ? 0 : 3 : (0, _mathJs.abs)(p[0] - x1) < (0, _mathJs.epsilon) ? direction > 0 ? 2 : 1 : (0, _mathJs.abs)(p[1] - y0) < (0, _mathJs.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, _bufferJsDefault.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, _d3Array.merge)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                    y_ = Math.max(clipMin, Math.min(clipMax, y_))
                ], b = [
                    x = Math.max(clipMin, Math.min(clipMax, x)),
                    y = Math.max(clipMin, Math.min(clipMax, y))
                ];
                if ((0, _lineJsDefault.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

},{"../math.js":"3L2E2","./buffer.js":"jYtWq","./line.js":"bEYjL","./rejoin.js":"dTo08","d3-array":"aoYKF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bEYjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Ax1X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, point) {
        return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
    });
var _polygonContainsJs = require("./polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _mathJs = require("./math.js");
var containsObjectType = {
    Feature: function(object, point) {
        return containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if (containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function containsGeometry(geometry, point) {
    return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
}
function containsPoint(coordinates, point) {
    return (0, _distanceJsDefault.default)(coordinates, point) === 0;
}
function containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, _distanceJsDefault.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, _distanceJsDefault.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, _mathJs.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function containsPolygon(coordinates, point) {
    return !!(0, _polygonContainsJsDefault.default)(coordinates.map(ringRadians), pointRadians(point));
}
function ringRadians(ring) {
    return ring = ring.map(pointRadians), ring.pop(), ring;
}
function pointRadians(point) {
    return [
        point[0] * (0, _mathJs.radians),
        point[1] * (0, _mathJs.radians)
    ];
}

},{"./polygonContains.js":"bRTnR","./distance.js":"2Xo7Z","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Xo7Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        coordinates[0] = a;
        coordinates[1] = b;
        return (0, _lengthJsDefault.default)(object);
    });
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var coordinates = [
    null,
    null
], object = {
    type: "LineString",
    coordinates: coordinates
};

},{"./length.js":"lcoiE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcoiE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        lengthSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, lengthStream);
        return +lengthSum;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lengthSum, lambda0, sinPhi0, cosPhi0;
var lengthStream = {
    sphere: (0, _noopJsDefault.default),
    point: (0, _noopJsDefault.default),
    lineStart: lengthLineStart,
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default)
};
function lengthLineStart() {
    lengthStream.point = lengthPointFirst;
    lengthStream.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
    lengthStream.point = lengthStream.lineEnd = (0, _noopJsDefault.default);
}
function lengthPointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, sinPhi0 = (0, _mathJs.sin)(phi), cosPhi0 = (0, _mathJs.cos)(phi);
    lengthStream.point = lengthPoint;
}
function lengthPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var sinPhi = (0, _mathJs.sin)(phi), cosPhi = (0, _mathJs.cos)(phi), delta = (0, _mathJs.abs)(lambda - lambda0), cosDelta = (0, _mathJs.cos)(delta), sinDelta = (0, _mathJs.sin)(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
    lengthSum.add((0, _mathJs.atan2)((0, _mathJs.sqrt)(x * x + y * y), z));
    lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

},{"d3-array":"aoYKF","./math.js":"3L2E2","./noop.js":"aImez","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5h4Wk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>graticule);
parcelHelpers.export(exports, "graticule10", ()=>graticule10);
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
function graticuleX(y0, y1, dy) {
    var y = (0, _d3Array.range)(y0, y1 - (0, _mathJs.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function graticuleY(x0, x1, dx) {
    var x = (0, _d3Array.range)(x0, x1 - (0, _mathJs.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function graticule() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, _d3Array.range)((0, _mathJs.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, _d3Array.range)((0, _mathJs.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, _d3Array.range)((0, _mathJs.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, _mathJs.abs)(x % DX) > (0, _mathJs.epsilon);
        }).map(x)).concat((0, _d3Array.range)((0, _mathJs.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, _mathJs.abs)(y % DY) > (0, _mathJs.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = graticuleX(y0, y1, 90);
        y = graticuleY(x0, x1, precision);
        X = graticuleX(Y0, Y1, 90);
        Y = graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, _mathJs.epsilon)
        ],
        [
            180,
            90 - (0, _mathJs.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, _mathJs.epsilon)
        ],
        [
            180,
            80 + (0, _mathJs.epsilon)
        ]
    ]);
}
function graticule10() {
    return graticule()();
}

},{"d3-array":"aoYKF","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6YqV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var x0 = a[0] * (0, _mathJs.radians), y0 = a[1] * (0, _mathJs.radians), x1 = b[0] * (0, _mathJs.radians), y1 = b[1] * (0, _mathJs.radians), cy0 = (0, _mathJs.cos)(y0), sy0 = (0, _mathJs.sin)(y0), cy1 = (0, _mathJs.cos)(y1), sy1 = (0, _mathJs.sin)(y1), kx0 = cy0 * (0, _mathJs.cos)(x0), ky0 = cy0 * (0, _mathJs.sin)(x0), kx1 = cy1 * (0, _mathJs.cos)(x1), ky1 = cy1 * (0, _mathJs.sin)(x1), d = 2 * (0, _mathJs.asin)((0, _mathJs.sqrt)((0, _mathJs.haversin)(y1 - y0) + cy0 * cy1 * (0, _mathJs.haversin)(x1 - x0))), k = (0, _mathJs.sin)(d);
        var interpolate = d ? function(t) {
            var B = (0, _mathJs.sin)(t *= d) / k, A = (0, _mathJs.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
                (0, _mathJs.atan2)(z, (0, _mathJs.sqrt)(x * x + y * y)) * (0, _mathJs.degrees)
            ];
        } : function() {
            return [
                x0 * (0, _mathJs.degrees),
                y0 * (0, _mathJs.degrees)
            ];
        };
        interpolate.distance = d;
        return interpolate;
    });
var _mathJs = require("./math.js");

},{"./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Av9e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projection, context) {
        var pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                (0, _streamJsDefault.default)(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _areaJsDefault.default)));
            return (0, _areaJsDefault.default).result();
        };
        path.measure = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _measureJsDefault.default)));
            return (0, _measureJsDefault.default).result();
        };
        path.bounds = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _boundsJsDefault.default)));
            return (0, _boundsJsDefault.default).result();
        };
        path.centroid = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _centroidJsDefault.default)));
            return (0, _centroidJsDefault.default).result();
        };
        path.projection = function(_) {
            return arguments.length ? (projectionStream = _ == null ? (projection = null, _identityJsDefault.default) : (projection = _).stream, path) : projection;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new (0, _stringJsDefault.default)) : new (0, _contextJsDefault.default)(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        return path.projection(projection).context(context);
    });
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _contextJs = require("./context.js");
var _contextJsDefault = parcelHelpers.interopDefault(_contextJs);
var _measureJs = require("./measure.js");
var _measureJsDefault = parcelHelpers.interopDefault(_measureJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);

},{"../identity.js":"5LHbX","../stream.js":"l5ilc","./area.js":"eQFfj","./bounds.js":"beMh6","./centroid.js":"d3AmC","./context.js":"fKqEr","./measure.js":"agEQd","./string.js":"jgqRu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5LHbX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eQFfj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var areaSum = new (0, _d3Array.Adder)(), areaRingSum = new (0, _d3Array.Adder)(), x00, y00, x0, y0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        areaStream.lineStart = areaStream.lineEnd = areaStream.point = (0, _noopJsDefault.default);
        areaSum.add((0, _mathJs.abs)(areaRingSum));
        areaRingSum = new (0, _d3Array.Adder)();
    },
    result: function() {
        var area = areaSum / 2;
        areaSum = new (0, _d3Array.Adder)();
        return area;
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
    areaStream.point = areaPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function areaPoint(x, y) {
    areaRingSum.add(y0 * x - x0 * y);
    x0 = x, y0 = y;
}
function areaRingEnd() {
    areaPoint(x00, y00);
}
exports.default = areaStream;

},{"d3-array":"aoYKF","../math.js":"3L2E2","../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beMh6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
var boundsStream = {
    point: boundsPoint,
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default),
    result: function() {
        var bounds = [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x1 = y1 = -(y0 = x0 = Infinity);
        return bounds;
    }
};
function boundsPoint(x, y) {
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
}
exports.default = boundsStream;

},{"../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3AmC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
// TODO Enforce positive area for exterior, negative area for interior?
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00, y00, x0, y0;
var centroidStream = {
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.point = centroidPoint;
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    },
    result: function() {
        var centroid = Z2 ? [
            X2 / Z2,
            Y2 / Z2
        ] : Z1 ? [
            X1 / Z1,
            Y1 / Z1
        ] : Z0 ? [
            X0 / Z0,
            Y0 / Z0
        ] : [
            NaN,
            NaN
        ];
        X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
        return centroid;
    }
};
function centroidPoint(x, y) {
    X0 += x;
    Y0 += y;
    ++Z0;
}
function centroidLineStart() {
    centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
    centroidStream.point = centroidPointLine;
    centroidPoint(x0 = x, y0 = y);
}
function centroidPointLine(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    centroidPoint(x0 = x, y0 = y);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
function centroidRingStart() {
    centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
    centroidPointRing(x00, y00);
}
function centroidPointFirstRing(x, y) {
    centroidStream.point = centroidPointRing;
    centroidPoint(x00 = x0 = x, y00 = y0 = y);
}
function centroidPointRing(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    z = y0 * x - x0 * y;
    X2 += z * (x0 + x);
    Y2 += z * (y0 + y);
    Z2 += z * 3;
    centroidPoint(x0 = x, y0 = y);
}
exports.default = centroidStream;

},{"../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKqEr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathContext);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function PathContext(context) {
    this._context = context;
}
PathContext.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, _mathJs.tau));
                break;
        }
    },
    result: (0, _noopJsDefault.default)
};

},{"../math.js":"3L2E2","../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agEQd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var lengthSum = new (0, _d3Array.Adder)(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
    point: (0, _noopJsDefault.default),
    lineStart: function() {
        lengthStream.point = lengthPointFirst;
    },
    lineEnd: function() {
        if (lengthRing) lengthPoint(x00, y00);
        lengthStream.point = (0, _noopJsDefault.default);
    },
    polygonStart: function() {
        lengthRing = true;
    },
    polygonEnd: function() {
        lengthRing = null;
    },
    result: function() {
        var length = +lengthSum;
        lengthSum = new (0, _d3Array.Adder)();
        return length;
    }
};
function lengthPointFirst(x, y) {
    lengthStream.point = lengthPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
    x0 -= x, y0 -= y;
    lengthSum.add((0, _mathJs.sqrt)(x0 * x0 + y0 * y0));
    x0 = x, y0 = y;
}
exports.default = lengthStream;

},{"d3-array":"aoYKF","../math.js":"3L2E2","../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jgqRu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathString);
function PathString() {
    this._string = [];
}
PathString.prototype = {
    _radius: 4.5,
    _circle: circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTRWa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicEqualAreaJsDefault.default)().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    });
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);

},{"./conicEqualArea.js":"cGDVP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGDVP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEqualAreaRaw", ()=>conicEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
function conicEqualAreaRaw(y0, y1) {
    var sy0 = (0, _mathJs.sin)(y0), n = (sy0 + (0, _mathJs.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return (0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, _mathJs.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, _mathJs.sqrt)(c - 2 * n * (0, _mathJs.sin)(y)) / n;
        return [
            r * (0, _mathJs.sin)(x *= n),
            r0 - r * (0, _mathJs.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(r0y)) * (0, _mathJs.sign)(r0y);
        if (r0y * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(r0y);
        return [
            l / n,
            (0, _mathJs.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}

},{"../math.js":"3L2E2","./conic.js":"4evSq","./cylindricalEqualArea.js":"8B2Uy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4evSq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicProjection", ()=>conicProjection);
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
function conicProjection(projectAt) {
    var phi0 = 0, phi1 = (0, _mathJs.pi) / 3, m = (0, _indexJs.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, _mathJs.radians), phi1 = _[1] * (0, _mathJs.radians)) : [
            phi0 * (0, _mathJs.degrees),
            phi1 * (0, _mathJs.degrees)
        ];
    };
    return p;
}

},{"../math.js":"3L2E2","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6rSs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>projection);
parcelHelpers.export(exports, "projectionMutator", ()=>projectionMutator);
var _antimeridianJs = require("../clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs = require("../clip/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _composeJs = require("../compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _resampleJs = require("./resample.js");
var _resampleJsDefault = parcelHelpers.interopDefault(_resampleJs);
var transformRadians = (0, _transformJs.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, _mathJs.radians), y * (0, _mathJs.radians));
    }
});
function transformRotate(rotate) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, _mathJs.cos)(alpha), sinAlpha = (0, _mathJs.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function projection(project) {
    return projectionMutator(function() {
        return project;
    })();
}
function projectionMutator(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, _antimeridianJsDefault.default), x0 = null, y0, x1, y1, postclip = (0, _identityJsDefault.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, _mathJs.radians), point[1] * (0, _mathJs.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, _mathJs.degrees),
            point[1] * (0, _mathJs.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, _circleJsDefault.default)(theta = _ * (0, _mathJs.radians)) : (theta = null, _antimeridianJsDefault.default), reset()) : theta * (0, _mathJs.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, _mathJs.radians), phi = _[1] % 360 * (0, _mathJs.radians), recenter()) : [
            lambda * (0, _mathJs.degrees),
            phi * (0, _mathJs.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, _mathJs.radians), deltaPhi = _[1] % 360 * (0, _mathJs.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, _mathJs.radians) : 0, recenter()) : [
            deltaLambda * (0, _mathJs.degrees),
            deltaPhi * (0, _mathJs.degrees),
            deltaGamma * (0, _mathJs.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), recenter()) : alpha * (0, _mathJs.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2 = _ * _), reset()) : (0, _mathJs.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, _fitJs.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, _fitJs.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, _fitJs.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, _fitJs.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, _rotationJs.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, _composeJsDefault.default)(project, transform);
        projectRotateTransform = (0, _composeJsDefault.default)(rotate, projectTransform);
        projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

},{"../clip/antimeridian.js":"gdVz3","../clip/circle.js":"jHMRk","../clip/rectangle.js":"cmyz6","../compose.js":"aIo7W","../identity.js":"5LHbX","../math.js":"3L2E2","../rotation.js":"kS2aY","../transform.js":"hXP19","./fit.js":"7Eu5K","./resample.js":"blIXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXP19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(methods) {
        return {
            stream: transformer(methods)
        };
    });
parcelHelpers.export(exports, "transformer", ()=>transformer);
function transformer(methods) {
    return function(stream) {
        var s = new TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function TransformStream() {}
TransformStream.prototype = {
    constructor: TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Eu5K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fitExtent", ()=>fitExtent);
parcelHelpers.export(exports, "fitSize", ()=>fitSize);
parcelHelpers.export(exports, "fitWidth", ()=>fitWidth);
parcelHelpers.export(exports, "fitHeight", ()=>fitHeight);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _boundsJs = require("../path/bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
function fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, _streamJsDefault.default)(object, projection.stream((0, _boundsJsDefault.default)));
    fitBounds((0, _boundsJsDefault.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function fitExtent(projection, extent, object) {
    return fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitSize(projection, size, object) {
    return fitExtent(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function fitWidth(projection, width, object) {
    return fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitHeight(projection, height, object) {
    return fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

},{"../stream.js":"l5ilc","../path/bounds.js":"beMh6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blIXs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project, delta2) {
        return +delta2 ? resample(project, delta2) : resampleNone(project);
    });
var _cartesianJs = require("../cartesian.js");
var _mathJs = require("../math.js");
var _transformJs = require("../transform.js");
var maxDepth = 16, cosMinDistance = (0, _mathJs.cos)(30 * (0, _mathJs.radians)); // cos(minimum angular distance)
function resampleNone(project) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, _mathJs.sqrt)(a * a + b * b + c * c), phi2 = (0, _mathJs.asin)(c /= m), lambda2 = (0, _mathJs.abs)((0, _mathJs.abs)(c) - 1) < (0, _mathJs.epsilon) || (0, _mathJs.abs)(lambda0 - lambda1) < (0, _mathJs.epsilon) ? (lambda0 + lambda1) / 2 : (0, _mathJs.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, _mathJs.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, _cartesianJs.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

},{"../cartesian.js":"gJZ0B","../math.js":"3L2E2","../transform.js":"hXP19","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B2Uy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalEqualAreaRaw", ()=>cylindricalEqualAreaRaw);
var _mathJs = require("../math.js");
function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, _mathJs.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

},{"../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enFIP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
parcelHelpers.export(exports, "default", ()=>function() {
        var cache, cacheStream, lower48 = (0, _albersJsDefault.default)(), lower48Point, alaska = (0, _conicEqualAreaJsDefault.default)().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = (0, _conicEqualAreaJsDefault.default)().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + (0, _mathJs.epsilon),
                    y + 0.120 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.214 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + (0, _mathJs.epsilon),
                    y + 0.166 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.115 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    });
var _mathJs = require("../math.js");
var _albersJs = require("./albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _fitJs = require("./fit.js");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}

},{"../math.js":"3L2E2","./albers.js":"lTRWa","./conicEqualArea.js":"cGDVP","./fit.js":"7Eu5K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uowk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEqualAreaRaw", ()=>azimuthalEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEqualAreaRaw = (0, _azimuthalJs.azimuthalRaw)(function(cxcy) {
    return (0, _mathJs.sqrt)(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.asin)(z / 2);
});

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4zgCZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalRaw", ()=>azimuthalRaw);
parcelHelpers.export(exports, "azimuthalInvert", ()=>azimuthalInvert);
var _mathJs = require("../math.js");
function azimuthalRaw(scale) {
    return function(x, y) {
        var cx = (0, _mathJs.cos)(x), cy = (0, _mathJs.cos)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, _mathJs.sin)(x),
            k * (0, _mathJs.sin)(y)
        ];
    };
}
function azimuthalInvert(angle) {
    return function(x, y) {
        var z = (0, _mathJs.sqrt)(x * x + y * y), c = angle(z), sc = (0, _mathJs.sin)(c), cc = (0, _mathJs.cos)(c);
        return [
            (0, _mathJs.atan2)(x * sc, z * cc),
            (0, _mathJs.asin)(z && y * sc / z)
        ];
    };
}

},{"../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"47ye5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEquidistantRaw", ()=>azimuthalEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEquidistantRaw = (0, _azimuthalJs.azimuthalRaw)(function(c) {
    return (c = (0, _mathJs.acos)(c)) && c / (0, _mathJs.sin)(c);
});
azimuthalEquidistantRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return z;
});

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIoAV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicConformalRaw", ()=>conicConformalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _mercatorJs = require("./mercator.js");
function tany(y) {
    return (0, _mathJs.tan)(((0, _mathJs.halfPi) + y) / 2);
}
function conicConformalRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (0, _mathJs.log)(cy0 / (0, _mathJs.cos)(y1)) / (0, _mathJs.log)(tany(y1) / tany(y0)), f = cy0 * (0, _mathJs.pow)(tany(y0), n) / n;
    if (!n) return 0, _mercatorJs.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, _mathJs.halfPi) + (0, _mathJs.epsilon)) y = -(0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        } else if (y > (0, _mathJs.halfPi) - (0, _mathJs.epsilon)) y = (0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        var r = f / (0, _mathJs.pow)(tany(y), n);
        return [
            r * (0, _mathJs.sin)(n * x),
            f - r * (0, _mathJs.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + fy * fy), l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(fy)) * (0, _mathJs.sign)(fy);
        if (fy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(fy);
        return [
            l / n,
            2 * (0, _mathJs.atan)((0, _mathJs.pow)(f / r, 1 / n)) - (0, _mathJs.halfPi)
        ];
    };
    return project;
}

},{"../math.js":"3L2E2","./conic.js":"4evSq","./mercator.js":"itxln","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"itxln":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercatorRaw", ()=>mercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return mercatorProjection(mercatorRaw).scale(961 / (0, _mathJs.tau));
    });
parcelHelpers.export(exports, "mercatorProjection", ()=>mercatorProjection);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function mercatorRaw(lambda, phi) {
    return [
        lambda,
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2))
    ];
}
mercatorRaw.invert = function(x, y) {
    return [
        x,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(y)) - (0, _mathJs.halfPi)
    ];
};
function mercatorProjection(project) {
    var m = (0, _indexJsDefault.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, _mathJs.pi) * scale(), t = m((0, _rotationJsDefault.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === mercatorRaw ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

},{"../math.js":"3L2E2","../rotation.js":"kS2aY","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1hkbk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEquidistantRaw", ()=>conicEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _equirectangularJs = require("./equirectangular.js");
function conicEquidistantRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (cy0 - (0, _mathJs.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return 0, _equirectangularJs.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, _mathJs.sin)(nx),
            g - gy * (0, _mathJs.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(gy)) * (0, _mathJs.sign)(gy);
        if (gy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(gy);
        return [
            l / n,
            g - (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}

},{"../math.js":"3L2E2","./conic.js":"4evSq","./equirectangular.js":"cTwHL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTwHL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equirectangularRaw", ()=>equirectangularRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equirectangularRaw).scale(152.63);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function equirectangularRaw(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
equirectangularRaw.invert = equirectangularRaw;

},{"./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMwLK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equalEarthRaw", ()=>equalEarthRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equalEarthRaw).scale(177.158);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = (0, _mathJs.sqrt)(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi) {
    var l = (0, _mathJs.asin)(M * (0, _mathJs.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, _mathJs.cos)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
        l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
    ];
}
equalEarthRaw.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < iterations; ++i){
        fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
        fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon2)) break;
    }
    return [
        M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0, _mathJs.cos)(l),
        (0, _mathJs.asin)((0, _mathJs.sin)(l) / M)
    ];
};

},{"./index.js":"h6rSs","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hx9Pk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gnomonicRaw", ()=>gnomonicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(gnomonicRaw).scale(144.049).clipAngle(60);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function gnomonicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
gnomonicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.atan));

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fJNsT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, _transformJs.transformer)({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = (0, _identityJsDefault.default), cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), sa = (0, _mathJs.sin)(alpha), ca = (0, _mathJs.cos)(alpha), reset()) : alpha * (0, _mathJs.degrees);
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(projection, height, object);
        };
        return projection;
    });
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _mathJs = require("../math.js");

},{"../clip/rectangle.js":"cmyz6","../identity.js":"5LHbX","../transform.js":"hXP19","./fit.js":"7Eu5K","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6uiN3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "naturalEarth1Raw", ()=>naturalEarth1Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(naturalEarth1Raw).scale(175.295);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
function naturalEarth1Raw(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
naturalEarth1Raw.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};

},{"./index.js":"h6rSs","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9l5H5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orthographicRaw", ()=>orthographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(orthographicRaw).scale(249.5).clipAngle(90 + (0, _mathJs.epsilon));
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function orthographicRaw(x, y) {
    return [
        (0, _mathJs.cos)(y) * (0, _mathJs.sin)(x),
        (0, _mathJs.sin)(y)
    ];
}
orthographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.asin));

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iSTLy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stereographicRaw", ()=>stereographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(stereographicRaw).scale(250).clipAngle(142);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function stereographicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = 1 + (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
stereographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.atan)(z);
});

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kRAj0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transverseMercatorRaw", ()=>transverseMercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var m = (0, _mercatorJs.mercatorProjection)(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    });
var _mathJs = require("../math.js");
var _mercatorJs = require("./mercator.js");
function transverseMercatorRaw(lambda, phi) {
    return [
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2)),
        -lambda
    ];
}
transverseMercatorRaw.invert = function(x, y) {
    return [
        -y,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(x)) - (0, _mathJs.halfPi)
    ];
};

},{"../math.js":"3L2E2","./mercator.js":"itxln","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cFwdY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cluster", ()=>(0, _clusterJsDefault.default));
parcelHelpers.export(exports, "hierarchy", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "pack", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "packSiblings", ()=>(0, _siblingsJsDefault.default));
parcelHelpers.export(exports, "packEnclose", ()=>(0, _encloseJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "stratify", ()=>(0, _stratifyJsDefault.default));
parcelHelpers.export(exports, "tree", ()=>(0, _treeJsDefault.default));
parcelHelpers.export(exports, "treemap", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "treemapBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "treemapDice", ()=>(0, _diceJsDefault.default));
parcelHelpers.export(exports, "treemapSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "treemapSliceDice", ()=>(0, _sliceDiceJsDefault.default));
parcelHelpers.export(exports, "treemapSquarify", ()=>(0, _squarifyJsDefault.default));
parcelHelpers.export(exports, "treemapResquarify", ()=>(0, _resquarifyJsDefault.default));
var _clusterJs = require("./cluster.js");
var _clusterJsDefault = parcelHelpers.interopDefault(_clusterJs);
var _indexJs = require("./hierarchy/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./pack/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _siblingsJs = require("./pack/siblings.js");
var _siblingsJsDefault = parcelHelpers.interopDefault(_siblingsJs);
var _encloseJs = require("./pack/enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _stratifyJs = require("./stratify.js");
var _stratifyJsDefault = parcelHelpers.interopDefault(_stratifyJs);
var _treeJs = require("./tree.js");
var _treeJsDefault = parcelHelpers.interopDefault(_treeJs);
var _indexJs2 = require("./treemap/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _binaryJs = require("./treemap/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./treemap/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sliceDiceJs = require("./treemap/sliceDice.js");
var _sliceDiceJsDefault = parcelHelpers.interopDefault(_sliceDiceJs);
var _squarifyJs = require("./treemap/squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _resquarifyJs = require("./treemap/resquarify.js");
var _resquarifyJsDefault = parcelHelpers.interopDefault(_resquarifyJs);

},{"./cluster.js":"6HKtw","./hierarchy/index.js":"1kLlO","./pack/index.js":"5J3V4","./pack/siblings.js":"gORqP","./pack/enclose.js":"4MtLA","./partition.js":"4iNvs","./stratify.js":"32r3u","./tree.js":"e7DRS","./treemap/index.js":"e5q11","./treemap/binary.js":"93Bqf","./treemap/dice.js":"9U0kv","./treemap/slice.js":"iPXtV","./treemap/sliceDice.js":"3nypX","./treemap/squarify.js":"8lg5l","./treemap/resquarify.js":"dz45X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HKtw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    });
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
}
function meanXReduce(x, c) {
    return x + c.x;
}
function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
}
function maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1kLlO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hierarchy);
parcelHelpers.export(exports, "computeHeight", ()=>computeHeight);
parcelHelpers.export(exports, "Node", ()=>Node);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _eachBeforeJs = require("./eachBefore.js");
var _eachBeforeJsDefault = parcelHelpers.interopDefault(_eachBeforeJs);
var _eachAfterJs = require("./eachAfter.js");
var _eachAfterJsDefault = parcelHelpers.interopDefault(_eachAfterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _ancestorsJs = require("./ancestors.js");
var _ancestorsJsDefault = parcelHelpers.interopDefault(_ancestorsJs);
var _descendantsJs = require("./descendants.js");
var _descendantsJsDefault = parcelHelpers.interopDefault(_descendantsJs);
var _leavesJs = require("./leaves.js");
var _leavesJsDefault = parcelHelpers.interopDefault(_leavesJs);
var _linksJs = require("./links.js");
var _linksJsDefault = parcelHelpers.interopDefault(_linksJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
function hierarchy(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = mapChildren;
    } else if (children === undefined) children = objectChildren;
    var root = new Node(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new Node(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore(computeHeight);
}
function node_copy() {
    return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
    return d.children;
}
function mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: (0, _countJsDefault.default),
    each: (0, _eachJsDefault.default),
    eachAfter: (0, _eachAfterJsDefault.default),
    eachBefore: (0, _eachBeforeJsDefault.default),
    find: (0, _findJsDefault.default),
    sum: (0, _sumJsDefault.default),
    sort: (0, _sortJsDefault.default),
    path: (0, _pathJsDefault.default),
    ancestors: (0, _ancestorsJsDefault.default),
    descendants: (0, _descendantsJsDefault.default),
    leaves: (0, _leavesJsDefault.default),
    links: (0, _linksJsDefault.default),
    copy: node_copy,
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};

},{"./count.js":"2sGb7","./each.js":"7WXcZ","./eachBefore.js":"bmq4n","./eachAfter.js":"cZjeZ","./find.js":"lnpDp","./sum.js":"1cuXk","./sort.js":"1cxiV","./path.js":"9wQhJ","./ancestors.js":"bdyH6","./descendants.js":"lcRrI","./leaves.js":"hi2Ek","./links.js":"koCGV","./iterator.js":"2xYLN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2sGb7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.eachAfter(count);
    });
function count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7WXcZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bmq4n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZjeZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnpDp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cuXk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cxiV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wQhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    });
function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdyH6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcRrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hi2Ek":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"koCGV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2xYLN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5J3V4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var radius = null, dx = 1, dy = 1, padding = (0, _constantJs.constantZero);
        function pack(root) {
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, 0.5)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren((0, _constantJs.constantZero), 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = (0, _accessorsJs.optional)(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), pack) : padding;
        };
        return pack;
    });
var _siblingsJs = require("./siblings.js");
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function defaultRadius(d) {
    return Math.sqrt(d.value);
}
function radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, _siblingsJs.packEnclose)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

},{"./siblings.js":"gORqP","../accessors.js":"ly2Ie","../constant.js":"jF1ly","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gORqP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "packEnclose", ()=>packEnclose);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        packEnclose(circles);
        return circles;
    });
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _encloseJs = require("./enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
function place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function packEnclose(circles) {
    if (!(n = (circles = (0, _arrayJsDefault.default)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new Node(a), b = new Node(b), c = new Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        place(a._, b._, c = circles[i]), c = new Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if (intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if (intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = score(a);
        while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, _encloseJsDefault.default)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}

},{"../array.js":"7o1RV","./enclose.js":"4MtLA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7o1RV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
function shuffle(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4MtLA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        var i = 0, n = (circles = (0, _arrayJs.shuffle)(Array.from(circles))).length, B = [], p, e;
        while(i < n){
            p = circles[i];
            if (e && enclosesWeak(e, p)) ++i;
            else e = encloseBasis(B = extendBasis(B, p)), i = 0;
        }
        return e;
    });
var _arrayJs = require("../array.js");
function extendBasis(B, p) {
    var i, j;
    if (enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function encloseBasis(B) {
    switch(B.length){
        case 1:
            return encloseBasis1(B[0]);
        case 2:
            return encloseBasis2(B[0], B[1]);
        case 3:
            return encloseBasis3(B[0], B[1], B[2]);
    }
}
function encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

},{"../array.js":"7o1RV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ly2Ie":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optional", ()=>optional);
parcelHelpers.export(exports, "required", ()=>required);
function optional(f) {
    return f == null ? null : required(f);
}
function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jF1ly":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantZero", ()=>constantZero);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });
function constantZero() {
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4iNvs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) (0, _diceJsDefault.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    });
var _roundJs = require("./treemap/round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);

},{"./treemap/round.js":"4p2rf","./treemap/dice.js":"9U0kv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4p2rf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9U0kv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32r3u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var id = defaultId, parentId = defaultParentId;
        function stratify(data) {
            var nodes = Array.from(data), n = nodes.length, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            for(i = 0; i < n; ++i){
                d = nodes[i], node = nodes[i] = new (0, _indexJs.Node)(d);
                if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = parentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore((0, _indexJs.computeHeight));
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = (0, _accessorsJs.required)(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = (0, _accessorsJs.required)(x), stratify) : parentId;
        };
        return stratify;
    });
var _accessorsJs = require("./accessors.js");
var _indexJs = require("./hierarchy/index.js");
var preroot = {
    depth: -1
}, ambiguous = {};
function defaultId(d) {
    return d.id;
}
function defaultParentId(d) {
    return d.parentId;
}

},{"./accessors.js":"ly2Ie","./hierarchy/index.js":"1kLlO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e7DRS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    });
var _indexJs = require("./hierarchy/index.js");
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
TreeNode.prototype = Object.create((0, _indexJs.Node).prototype);
function treeRoot(root) {
    var tree = new TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}

},{"./hierarchy/index.js":"1kLlO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e5q11":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var tile = (0, _squarifyJsDefault.default), round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = (0, _constantJs.constantZero), paddingTop = (0, _constantJs.constantZero), paddingRight = (0, _constantJs.constantZero), paddingBottom = (0, _constantJs.constantZero), paddingLeft = (0, _constantJs.constantZero);
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = (0, _accessorsJs.required)(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingLeft;
        };
        return treemap;
    });
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _squarifyJs = require("./squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./round.js":"4p2rf","./squarify.js":"8lg5l","../accessors.js":"ly2Ie","../constant.js":"jF1ly","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lg5l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phi", ()=>phi);
parcelHelpers.export(exports, "squarifyRatio", ()=>squarifyRatio);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
exports.default = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}(phi);

},{"./dice.js":"9U0kv","./slice.js":"iPXtV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPXtV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93Bqf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nypX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? (0, _sliceJsDefault.default) : (0, _diceJsDefault.default))(parent, x0, y0, x1, y1);
    });
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);

},{"./dice.js":"9U0kv","./slice.js":"iPXtV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dz45X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _squarifyJs = require("./squarify.js");
exports.default = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, _squarifyJs.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, _squarifyJs.phi));

},{"./dice.js":"9U0kv","./slice.js":"iPXtV","./squarify.js":"8lg5l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e5TI9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polygonArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "polygonCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "polygonHull", ()=>(0, _hullJsDefault.default));
parcelHelpers.export(exports, "polygonContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "polygonLength", ()=>(0, _lengthJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _hullJs = require("./hull.js");
var _hullJsDefault = parcelHelpers.interopDefault(_hullJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);

},{"./area.js":"c5eKj","./centroid.js":"4ri0v","./hull.js":"gAq6K","./contains.js":"fwWVy","./length.js":"dDLFj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5eKj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            area += a[1] * b[0] - a[0] * b[1];
        }
        return area / 2;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ri0v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            k += c = a[0] * b[1] - b[0] * a[1];
            x += (a[0] + b[0]) * c;
            y += (a[1] + b[1]) * c;
        }
        return k *= 3, [
            x / k,
            y / k
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAq6K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(points) {
        if ((n = points.length) < 3) return null;
        var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
        for(i = 0; i < n; ++i)sortedPoints[i] = [
            +points[i][0],
            +points[i][1],
            i
        ];
        sortedPoints.sort(lexicographicOrder);
        for(i = 0; i < n; ++i)flippedPoints[i] = [
            sortedPoints[i][0],
            -sortedPoints[i][1]
        ];
        var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
        // Construct the hull polygon, removing possible duplicate endpoints.
        var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
        // Add upper hull in right-to-l order.
        // Then add lower hull in left-to-right order.
        for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
        for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
        return hull;
    });
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
function lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
    const n = points.length, indexes = [
        0,
        1
    ];
    let size = 2, i;
    for(i = 2; i < n; ++i){
        while(size > 1 && (0, _crossJsDefault.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}

},{"./cross.js":"el7lZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"el7lZ":[function(require,module,exports) {
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fwWVy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
        for(var i = 0; i < n; ++i){
            p = polygon[i], x1 = p[0], y1 = p[1];
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            x0 = x1, y0 = y1;
        }
        return inside;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dDLFj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
        while(++i < n){
            xa = xb;
            ya = yb;
            b = polygon[i];
            xb = b[0];
            yb = b[1];
            xa -= xb;
            ya -= yb;
            perimeter += Math.hypot(xa, ya);
        }
        return perimeter;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4hcGu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "randomUniform", ()=>(0, _uniformJsDefault.default));
parcelHelpers.export(exports, "randomInt", ()=>(0, _intJsDefault.default));
parcelHelpers.export(exports, "randomNormal", ()=>(0, _normalJsDefault.default));
parcelHelpers.export(exports, "randomLogNormal", ()=>(0, _logNormalJsDefault.default));
parcelHelpers.export(exports, "randomBates", ()=>(0, _batesJsDefault.default));
parcelHelpers.export(exports, "randomIrwinHall", ()=>(0, _irwinHallJsDefault.default));
parcelHelpers.export(exports, "randomExponential", ()=>(0, _exponentialJsDefault.default));
parcelHelpers.export(exports, "randomPareto", ()=>(0, _paretoJsDefault.default));
parcelHelpers.export(exports, "randomBernoulli", ()=>(0, _bernoulliJsDefault.default));
parcelHelpers.export(exports, "randomGeometric", ()=>(0, _geometricJsDefault.default));
parcelHelpers.export(exports, "randomBinomial", ()=>(0, _binomialJsDefault.default));
parcelHelpers.export(exports, "randomGamma", ()=>(0, _gammaJsDefault.default));
parcelHelpers.export(exports, "randomBeta", ()=>(0, _betaJsDefault.default));
parcelHelpers.export(exports, "randomWeibull", ()=>(0, _weibullJsDefault.default));
parcelHelpers.export(exports, "randomCauchy", ()=>(0, _cauchyJsDefault.default));
parcelHelpers.export(exports, "randomLogistic", ()=>(0, _logisticJsDefault.default));
parcelHelpers.export(exports, "randomPoisson", ()=>(0, _poissonJsDefault.default));
parcelHelpers.export(exports, "randomLcg", ()=>(0, _lcgJsDefault.default));
var _uniformJs = require("./uniform.js");
var _uniformJsDefault = parcelHelpers.interopDefault(_uniformJs);
var _intJs = require("./int.js");
var _intJsDefault = parcelHelpers.interopDefault(_intJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
var _logNormalJs = require("./logNormal.js");
var _logNormalJsDefault = parcelHelpers.interopDefault(_logNormalJs);
var _batesJs = require("./bates.js");
var _batesJsDefault = parcelHelpers.interopDefault(_batesJs);
var _irwinHallJs = require("./irwinHall.js");
var _irwinHallJsDefault = parcelHelpers.interopDefault(_irwinHallJs);
var _exponentialJs = require("./exponential.js");
var _exponentialJsDefault = parcelHelpers.interopDefault(_exponentialJs);
var _paretoJs = require("./pareto.js");
var _paretoJsDefault = parcelHelpers.interopDefault(_paretoJs);
var _bernoulliJs = require("./bernoulli.js");
var _bernoulliJsDefault = parcelHelpers.interopDefault(_bernoulliJs);
var _geometricJs = require("./geometric.js");
var _geometricJsDefault = parcelHelpers.interopDefault(_geometricJs);
var _binomialJs = require("./binomial.js");
var _binomialJsDefault = parcelHelpers.interopDefault(_binomialJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
var _betaJs = require("./beta.js");
var _betaJsDefault = parcelHelpers.interopDefault(_betaJs);
var _weibullJs = require("./weibull.js");
var _weibullJsDefault = parcelHelpers.interopDefault(_weibullJs);
var _cauchyJs = require("./cauchy.js");
var _cauchyJsDefault = parcelHelpers.interopDefault(_cauchyJs);
var _logisticJs = require("./logistic.js");
var _logisticJsDefault = parcelHelpers.interopDefault(_logisticJs);
var _poissonJs = require("./poisson.js");
var _poissonJsDefault = parcelHelpers.interopDefault(_poissonJs);
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);

},{"./uniform.js":"dQgvT","./int.js":"kB1F6","./normal.js":"hiccp","./logNormal.js":"68TAU","./bates.js":"27u5F","./irwinHall.js":"hZ1mH","./exponential.js":"aL3g0","./pareto.js":"aJfCn","./bernoulli.js":"h3UNV","./geometric.js":"bId4v","./binomial.js":"7zBkZ","./gamma.js":"3WVFS","./beta.js":"9xbqw","./weibull.js":"bdHfE","./cauchy.js":"aWbuU","./logistic.js":"6GXJO","./poisson.js":"icamu","./lcg.js":"8xOiE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dQgvT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"rc0WM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Math.random;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kB1F6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomInt(source) {
    function randomInt(min, max) {
        if (arguments.length < 2) max = min, min = 0;
        min = Math.floor(min);
        max = Math.floor(max) - min;
        return function() {
            return Math.floor(source() * max + min);
        };
    }
    randomInt.source = sourceRandomInt;
    return randomInt;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hiccp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68TAU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
exports.default = function sourceRandomLogNormal(source) {
    var N = (0, _normalJsDefault.default).source(source);
    function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","./normal.js":"hiccp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"27u5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _irwinHallJs = require("./irwinHall.js");
var _irwinHallJsDefault = parcelHelpers.interopDefault(_irwinHallJs);
exports.default = function sourceRandomBates(source) {
    var I = (0, _irwinHallJsDefault.default).source(source);
    function randomBates(n) {
        // use limiting distribution at n === 0
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","./irwinHall.js":"hZ1mH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZ1mH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        if ((n = +n) <= 0) return ()=>0;
        return function() {
            for(var sum = 0, i = n; i > 1; --i)sum += source();
            return sum + i * source();
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aL3g0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJfCn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h3UNV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomBernoulli(source) {
    function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
            return Math.floor(source() + p);
        };
    }
    randomBernoulli.source = sourceRandomBernoulli;
    return randomBernoulli;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bId4v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomGeometric(source) {
    function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return ()=>Infinity;
        if (p === 1) return ()=>1;
        p = Math.log1p(-p);
        return function() {
            return 1 + Math.floor(Math.log1p(-source()) / p);
        };
    }
    randomGeometric.source = sourceRandomGeometric;
    return randomGeometric;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7zBkZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _betaJs = require("./beta.js");
var _betaJsDefault = parcelHelpers.interopDefault(_betaJs);
var _geometricJs = require("./geometric.js");
var _geometricJsDefault = parcelHelpers.interopDefault(_geometricJs);
exports.default = function sourceRandomBinomial(source) {
    var G = (0, _geometricJsDefault.default).source(source), B = (0, _betaJsDefault.default).source(source);
    function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return ()=>n;
        if (p <= 0) return ()=>0;
        return function() {
            var acc = 0, nn = n, pp = p;
            while(nn * pp > 16 && nn * (1 - pp) > 16){
                var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                if (y <= pp) {
                    acc += i;
                    nn -= i;
                    pp = (pp - y) / (1 - y);
                } else {
                    nn = i - 1;
                    pp /= y;
                }
            }
            var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
            for(var s = g(), k = 0; s <= nn; ++k)s += g();
            return acc + (sign ? k : nn - k);
        };
    }
    randomBinomial.source = sourceRandomBinomial;
    return randomBinomial;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","./beta.js":"9xbqw","./geometric.js":"bId4v","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9xbqw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
exports.default = function sourceRandomBeta(source) {
    var G = (0, _gammaJsDefault.default).source(source);
    function randomBeta(alpha, beta) {
        var X = G(alpha), Y = G(beta);
        return function() {
            var x = X();
            return x === 0 ? 0 : x / (x + Y());
        };
    }
    randomBeta.source = sourceRandomBeta;
    return randomBeta;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","./gamma.js":"3WVFS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3WVFS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
exports.default = function sourceRandomGamma(source) {
    var randomNormal = (0, _normalJsDefault.default).source(source)();
    function randomGamma(k, theta) {
        if ((k = +k) < 0) throw new RangeError("invalid k");
        // degenerate distribution if k === 0
        if (k === 0) return ()=>0;
        theta = theta == null ? 1 : +theta;
        // exponential distribution if k === 1
        if (k === 1) return ()=>-Math.log1p(-source()) * theta;
        var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
        return function() {
            do {
                do var x = randomNormal(), v = 1 + c * x;
                while (v <= 0);
                v *= v * v;
                var u = 1 - source();
            }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
            return d * v * multiplier() * theta;
        };
    }
    randomGamma.source = sourceRandomGamma;
    return randomGamma;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","./normal.js":"hiccp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdHfE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomWeibull(source) {
    function randomWeibull(k, a, b) {
        var outerFunc;
        if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
        else {
            k = 1 / k;
            outerFunc = (x)=>Math.pow(x, k);
        }
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * outerFunc(-Math.log1p(-source()));
        };
    }
    randomWeibull.source = sourceRandomWeibull;
    return randomWeibull;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aWbuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomCauchy(source) {
    function randomCauchy(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * Math.tan(Math.PI * source());
        };
    }
    randomCauchy.source = sourceRandomCauchy;
    return randomCauchy;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GXJO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomLogistic(source) {
    function randomLogistic(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            var u = source();
            return a + b * Math.log(u / (1 - u));
        };
    }
    randomLogistic.source = sourceRandomLogistic;
    return randomLogistic;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"icamu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _binomialJs = require("./binomial.js");
var _binomialJsDefault = parcelHelpers.interopDefault(_binomialJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
exports.default = function sourceRandomPoisson(source) {
    var G = (0, _gammaJsDefault.default).source(source), B = (0, _binomialJsDefault.default).source(source);
    function randomPoisson(lambda) {
        return function() {
            var acc = 0, l = lambda;
            while(l > 16){
                var n = Math.floor(0.875 * l), t = G(n)();
                if (t > l) return acc + B(n - 1, l / t)();
                acc += n;
                l -= t;
            }
            for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
            return acc + k;
        };
    }
    randomPoisson.source = sourceRandomPoisson;
    return randomPoisson;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"rc0WM","./binomial.js":"7zBkZ","./gamma.js":"3WVFS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xOiE":[function(require,module,exports) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lcg);
const mul = 0x19660D;
const inc = 0x3C6EF35F;
const eps = 1 / 0x100000000;
function lcg(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
    return ()=>(state = mul * state + inc | 0, eps * (state >>> 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8BE7D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandJsDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _bandJs.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogJsDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalJsDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinalJs.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powJsDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _powJs.sqrt));
parcelHelpers.export(exports, "scaleRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdJsDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeJsDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeJsDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialJsDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequentialJs.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequentialJs.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequentialJs.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequentialJs.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileJsDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _divergingJs.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _divergingJs.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _divergingJs.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _divergingJs.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatJsDefault.default));
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"bNEFi","./identity.js":"8Lo1M","./linear.js":"c7lPL","./log.js":"jzsSJ","./symlog.js":"k6LKH","./ordinal.js":"ekwn9","./pow.js":"8uRFM","./radial.js":"6Il94","./quantile.js":"fRuUt","./quantize.js":"49qXX","./threshold.js":"dqjBZ","./time.js":"5wvQp","./utcTime.js":"dAkX6","./sequential.js":"d5bJE","./sequentialQuantile.js":"6H4Zg","./diverging.js":"6LSy6","./tickFormat.js":"bBGVj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNEFi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":"aoYKF","./init.js":"2454B","./ordinal.js":"ekwn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2454B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ekwn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _initJs = require("./init.js");
const implicit = Symbol("implicit");
function ordinal() {
    var index = new Map(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== implicit) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new Map();
        for (const value of _){
            const key = value + "";
            if (index.has(key)) continue;
            index.set(key, domain.push(value));
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Lo1M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, _numberJsDefault.default)) : [
        0,
        1
    ];
    return (0, _linearJs.linearish)(scale);
}

},{"./linear.js":"c7lPL","./number.js":"6Bdiz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7lPL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":"aoYKF","./continuous.js":"6WTm8","./init.js":"2454B","./tickFormat.js":"bBGVj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6WTm8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":"aoYKF","d3-interpolate":"5gJW0","./constant.js":"57TP9","./number.js":"6Bdiz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"57TP9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Bdiz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bBGVj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tickFormat);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"aoYKF","d3-format":"97aCb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jzsSJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function loggish(transform) {
    var scale = transform(transformLog, transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, _d3Format.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function log() {
    var scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, log()).base(scale.base());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"aoYKF","d3-format":"97aCb","./nice.js":"lkpC0","./continuous.js":"6WTm8","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lkpC0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6LKH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linearJs.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"./linear.js":"c7lPL","./continuous.js":"6WTm8","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8uRFM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuousJs.identity), (0, _continuousJs.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuousJs.identity), (0, _continuousJs.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linearJs.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear.js":"c7lPL","./continuous.js":"6WTm8","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Il94":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>radial);
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuousJsDefault.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, _numberJsDefault.default))).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return (0, _linearJs.linearish)(scale);
}

},{"./continuous.js":"6WTm8","./init.js":"2454B","./linear.js":"c7lPL","./number.js":"6Bdiz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fRuUt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"aoYKF","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49qXX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _linearJs = require("./linear.js");
var _initJs = require("./init.js");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply((0, _linearJs.linearish)(scale), arguments);
}

},{"d3-array":"aoYKF","./linear.js":"c7lPL","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dqjBZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>threshold);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"aoYKF","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5wvQp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>time);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuousJsDefault.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _niceJsDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return (0, _initJs.initRange).apply(calendar((0, _d3Time.timeTicks), (0, _d3Time.timeTickInterval), (0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3TimeFormat.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"bCmrc","d3-time-format":"6Z3KL","./continuous.js":"6WTm8","./init.js":"2454B","./nice.js":"lkpC0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bCmrc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJsDefault.default));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJsDefault.default));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.minutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJsDefault.default));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.hours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJsDefault.default));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.days));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.monday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.mondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.tuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.tuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.wednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.wednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.thursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.thursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.friday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.fridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.saturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.saturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJsDefault.default));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.months));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJsDefault.default));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.years));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _utcMinuteJsDefault.default));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _utcMinuteJs.utcMinutes));
parcelHelpers.export(exports, "utcHour", ()=>(0, _utcHourJsDefault.default));
parcelHelpers.export(exports, "utcHours", ()=>(0, _utcHourJs.utcHours));
parcelHelpers.export(exports, "utcDay", ()=>(0, _utcDayJsDefault.default));
parcelHelpers.export(exports, "utcDays", ()=>(0, _utcDayJs.utcDays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _utcWeekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _utcWeekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _utcWeekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _utcWeekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _utcWeekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _utcWeekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _utcWeekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _utcWeekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _utcWeekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _utcWeekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _utcWeekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _utcWeekJs.utcSaturdays));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _utcMonthJsDefault.default));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _utcMonthJs.utcMonths));
parcelHelpers.export(exports, "utcYear", ()=>(0, _utcYearJsDefault.default));
parcelHelpers.export(exports, "utcYears", ()=>(0, _utcYearJs.utcYears));
parcelHelpers.export(exports, "utcTicks", ()=>(0, _ticksJs.utcTicks));
parcelHelpers.export(exports, "utcTickInterval", ()=>(0, _ticksJs.utcTickInterval));
parcelHelpers.export(exports, "timeTicks", ()=>(0, _ticksJs.timeTicks));
parcelHelpers.export(exports, "timeTickInterval", ()=>(0, _ticksJs.timeTickInterval));
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _millisecondJs = require("./millisecond.js");
var _millisecondJsDefault = parcelHelpers.interopDefault(_millisecondJs);
var _secondJs = require("./second.js");
var _secondJsDefault = parcelHelpers.interopDefault(_secondJs);
var _minuteJs = require("./minute.js");
var _minuteJsDefault = parcelHelpers.interopDefault(_minuteJs);
var _hourJs = require("./hour.js");
var _hourJsDefault = parcelHelpers.interopDefault(_hourJs);
var _dayJs = require("./day.js");
var _dayJsDefault = parcelHelpers.interopDefault(_dayJs);
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _monthJsDefault = parcelHelpers.interopDefault(_monthJs);
var _yearJs = require("./year.js");
var _yearJsDefault = parcelHelpers.interopDefault(_yearJs);
var _utcMinuteJs = require("./utcMinute.js");
var _utcMinuteJsDefault = parcelHelpers.interopDefault(_utcMinuteJs);
var _utcHourJs = require("./utcHour.js");
var _utcHourJsDefault = parcelHelpers.interopDefault(_utcHourJs);
var _utcDayJs = require("./utcDay.js");
var _utcDayJsDefault = parcelHelpers.interopDefault(_utcDayJs);
var _utcWeekJs = require("./utcWeek.js");
var _utcMonthJs = require("./utcMonth.js");
var _utcMonthJsDefault = parcelHelpers.interopDefault(_utcMonthJs);
var _utcYearJs = require("./utcYear.js");
var _utcYearJsDefault = parcelHelpers.interopDefault(_utcYearJs);
var _ticksJs = require("./ticks.js");

},{"./interval.js":"9PMsD","./millisecond.js":"4b22w","./second.js":"3vDNh","./minute.js":"1BGJT","./hour.js":"k19pO","./day.js":"6QUnG","./week.js":"5p1DK","./month.js":"hs4om","./year.js":"3np0J","./utcMinute.js":"esPT2","./utcHour.js":"e97nA","./utcDay.js":"jokEx","./utcWeek.js":"blkIw","./utcMonth.js":"jR17X","./utcYear.js":"aUWVW","./ticks.js":"1yETU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PMsD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newInterval);
var t0 = new Date, t1 = new Date;
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4b22w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var millisecond = (0, _intervalJsDefault.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJsDefault.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
exports.default = millisecond;
var milliseconds = millisecond.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3vDNh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var second = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
exports.default = second;
var seconds = second.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lM7m4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
parcelHelpers.export(exports, "durationMonth", ()=>durationMonth);
parcelHelpers.export(exports, "durationYear", ()=>durationYear);
const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1BGJT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minutes", ()=>minutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var minute = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
exports.default = minute;
var minutes = minute.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k19pO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hours", ()=>hours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var hour = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
exports.default = hour;
var hours = hour.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6QUnG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", ()=>days);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var day = (0, _intervalJsDefault.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay), (date)=>date.getDate() - 1);
exports.default = day;
var days = day.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5p1DK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sunday", ()=>sunday);
parcelHelpers.export(exports, "monday", ()=>monday);
parcelHelpers.export(exports, "tuesday", ()=>tuesday);
parcelHelpers.export(exports, "wednesday", ()=>wednesday);
parcelHelpers.export(exports, "thursday", ()=>thursday);
parcelHelpers.export(exports, "friday", ()=>friday);
parcelHelpers.export(exports, "saturday", ()=>saturday);
parcelHelpers.export(exports, "sundays", ()=>sundays);
parcelHelpers.export(exports, "mondays", ()=>mondays);
parcelHelpers.export(exports, "tuesdays", ()=>tuesdays);
parcelHelpers.export(exports, "wednesdays", ()=>wednesdays);
parcelHelpers.export(exports, "thursdays", ()=>thursdays);
parcelHelpers.export(exports, "fridays", ()=>fridays);
parcelHelpers.export(exports, "saturdays", ()=>saturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function weekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hs4om":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", ()=>months);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var month = (0, _intervalJsDefault.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
exports.default = month;
var months = month.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3np0J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "years", ()=>years);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var year = (0, _intervalJsDefault.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
exports.default = year;
var years = year.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"esPT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcMinute = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
exports.default = utcMinute;
var utcMinutes = utcMinute.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e97nA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcHour = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
exports.default = utcHour;
var utcHours = utcHour.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jokEx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcDay = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
exports.default = utcDay;
var utcDays = utcDay.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blkIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function utcWeekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jR17X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcMonth = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
exports.default = utcMonth;
var utcMonths = utcMonth.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUWVW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcYear = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
exports.default = utcYear;
var utcYears = utcYear.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1yETU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcTicks", ()=>utcTicks);
parcelHelpers.export(exports, "utcTickInterval", ()=>utcTickInterval);
parcelHelpers.export(exports, "timeTicks", ()=>timeTicks);
parcelHelpers.export(exports, "timeTickInterval", ()=>timeTickInterval);
var _d3Array = require("d3-array");
var _durationJs = require("./duration.js");
var _millisecondJs = require("./millisecond.js");
var _millisecondJsDefault = parcelHelpers.interopDefault(_millisecondJs);
var _secondJs = require("./second.js");
var _secondJsDefault = parcelHelpers.interopDefault(_secondJs);
var _minuteJs = require("./minute.js");
var _minuteJsDefault = parcelHelpers.interopDefault(_minuteJs);
var _hourJs = require("./hour.js");
var _hourJsDefault = parcelHelpers.interopDefault(_hourJs);
var _dayJs = require("./day.js");
var _dayJsDefault = parcelHelpers.interopDefault(_dayJs);
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _monthJsDefault = parcelHelpers.interopDefault(_monthJs);
var _yearJs = require("./year.js");
var _yearJsDefault = parcelHelpers.interopDefault(_yearJs);
var _utcMinuteJs = require("./utcMinute.js");
var _utcMinuteJsDefault = parcelHelpers.interopDefault(_utcMinuteJs);
var _utcHourJs = require("./utcHour.js");
var _utcHourJsDefault = parcelHelpers.interopDefault(_utcHourJs);
var _utcDayJs = require("./utcDay.js");
var _utcDayJsDefault = parcelHelpers.interopDefault(_utcDayJs);
var _utcWeekJs = require("./utcWeek.js");
var _utcMonthJs = require("./utcMonth.js");
var _utcMonthJsDefault = parcelHelpers.interopDefault(_utcMonthJs);
var _utcYearJs = require("./utcYear.js");
var _utcYearJsDefault = parcelHelpers.interopDefault(_utcYearJs);
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, _secondJsDefault.default),
            1,
            (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJsDefault.default),
            5,
            5 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJsDefault.default),
            15,
            15 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJsDefault.default),
            30,
            30 * (0, _durationJs.durationSecond)
        ],
        [
            minute,
            1,
            (0, _durationJs.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, _durationJs.durationMinute)
        ],
        [
            hour,
            1,
            (0, _durationJs.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, _durationJs.durationHour)
        ],
        [
            day,
            1,
            (0, _durationJs.durationDay)
        ],
        [
            day,
            2,
            2 * (0, _durationJs.durationDay)
        ],
        [
            week,
            1,
            (0, _durationJs.durationWeek)
        ],
        [
            month,
            1,
            (0, _durationJs.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, _durationJs.durationMonth)
        ],
        [
            year,
            1,
            (0, _durationJs.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _d3Array.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _d3Array.tickStep)(start / (0, _durationJs.durationYear), stop / (0, _durationJs.durationYear), count));
        if (i === 0) return (0, _millisecondJsDefault.default).every(Math.max((0, _d3Array.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker((0, _utcYearJsDefault.default), (0, _utcMonthJsDefault.default), (0, _utcWeekJs.utcSunday), (0, _utcDayJsDefault.default), (0, _utcHourJsDefault.default), (0, _utcMinuteJsDefault.default));
const [timeTicks, timeTickInterval] = ticker((0, _yearJsDefault.default), (0, _monthJsDefault.default), (0, _weekJs.sunday), (0, _dayJsDefault.default), (0, _hourJsDefault.default), (0, _minuteJsDefault.default));

},{"d3-array":"aoYKF","./duration.js":"lM7m4","./millisecond.js":"4b22w","./second.js":"3vDNh","./minute.js":"1BGJT","./hour.js":"k19pO","./day.js":"6QUnG","./week.js":"5p1DK","./month.js":"hs4om","./year.js":"3np0J","./utcMinute.js":"esPT2","./utcHour.js":"e97nA","./utcDay.js":"jokEx","./utcWeek.js":"blkIw","./utcMonth.js":"jR17X","./utcYear.js":"aUWVW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Z3KL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "timeFormat", ()=>(0, _defaultLocaleJs.timeFormat));
parcelHelpers.export(exports, "timeParse", ()=>(0, _defaultLocaleJs.timeParse));
parcelHelpers.export(exports, "utcFormat", ()=>(0, _defaultLocaleJs.utcFormat));
parcelHelpers.export(exports, "utcParse", ()=>(0, _defaultLocaleJs.utcParse));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "isoFormat", ()=>(0, _isoFormatJsDefault.default));
parcelHelpers.export(exports, "isoParse", ()=>(0, _isoParseJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"cIkVK","./locale.js":"eLl5Y","./isoFormat.js":"7vlRp","./isoParse.js":"aKCVQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIkVK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"eLl5Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eLl5Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"bCmrc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vlRp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isoSpecifier", ()=>isoSpecifier);
var _defaultLocaleJs = require("./defaultLocale.js");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocaleJs.utcFormat)(isoSpecifier);
exports.default = formatIso;

},{"./defaultLocale.js":"cIkVK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKCVQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isoFormatJs = require("./isoFormat.js");
var _defaultLocaleJs = require("./defaultLocale.js");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocaleJs.utcParse)((0, _isoFormatJs.isoSpecifier));
exports.default = parseIso;

},{"./isoFormat.js":"7vlRp","./defaultLocale.js":"cIkVK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAkX6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcTime);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _timeJs = require("./time.js");
var _initJs = require("./init.js");
function utcTime() {
    return (0, _initJs.initRange).apply((0, _timeJs.calendar)((0, _d3Time.utcTicks), (0, _d3Time.utcTickInterval), (0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3TimeFormat.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"bCmrc","d3-time-format":"6Z3KL","./time.js":"5wvQp","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d5bJE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuousJs.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"5gJW0","./continuous.js":"6WTm8","./init.js":"2454B","./linear.js":"c7lPL","./log.js":"jzsSJ","./symlog.js":"k6LKH","./pow.js":"8uRFM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6H4Zg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sequentialQuantile);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function sequentialQuantile() {
    var domain = [], interpolator = (0, _continuousJs.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _d3Array.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _d3Array.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}

},{"d3-array":"aoYKF","./continuous.js":"6WTm8","./init.js":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LSy6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>diverging);
parcelHelpers.export(exports, "divergingLog", ()=>divergingLog);
parcelHelpers.export(exports, "divergingSymlog", ()=>divergingSymlog);
parcelHelpers.export(exports, "divergingPow", ()=>divergingPow);
parcelHelpers.export(exports, "divergingSqrt", ()=>divergingSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _sequentialJs = require("./sequential.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, _continuousJs.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _d3Interpolate.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, diverging());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":"5gJW0","./continuous.js":"6WTm8","./init.js":"2454B","./linear.js":"c7lPL","./log.js":"jzsSJ","./sequential.js":"d5bJE","./symlog.js":"k6LKH","./pow.js":"8uRFM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ruLi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"5jSvZ","./categorical/Accent.js":"lMRDh","./categorical/Dark2.js":"geyEl","./categorical/Paired.js":"2dEpS","./categorical/Pastel1.js":"9gkRy","./categorical/Pastel2.js":"gXFa6","./categorical/Set1.js":"evCZl","./categorical/Set2.js":"3wPdi","./categorical/Set3.js":"hubKu","./categorical/Tableau10.js":"e9MzL","./diverging/BrBG.js":"tTdAL","./diverging/PRGn.js":"6Mo0j","./diverging/PiYG.js":"hpB27","./diverging/PuOr.js":"eHirj","./diverging/RdBu.js":"1AEca","./diverging/RdGy.js":"bVkJg","./diverging/RdYlBu.js":"bSyTu","./diverging/RdYlGn.js":"i6WSx","./diverging/Spectral.js":"8HAw0","./sequential-multi/BuGn.js":"3nGZW","./sequential-multi/BuPu.js":"kePiO","./sequential-multi/GnBu.js":"8TDEP","./sequential-multi/OrRd.js":"ixYEJ","./sequential-multi/PuBuGn.js":"6RkW2","./sequential-multi/PuBu.js":"ajWB7","./sequential-multi/PuRd.js":"3Qgit","./sequential-multi/RdPu.js":"kU2Wx","./sequential-multi/YlGnBu.js":"ghGBr","./sequential-multi/YlGn.js":"c6q2h","./sequential-multi/YlOrBr.js":"74hlN","./sequential-multi/YlOrRd.js":"2UKDL","./sequential-single/Blues.js":"7Xh8u","./sequential-single/Greens.js":"b8eLb","./sequential-single/Greys.js":"hIsSh","./sequential-single/Purples.js":"f8zU8","./sequential-single/Reds.js":"1mWp4","./sequential-single/Oranges.js":"5xWYU","./sequential-multi/cividis.js":"4Slzk","./sequential-multi/cubehelix.js":"h6xPU","./sequential-multi/rainbow.js":"4Avio","./sequential-multi/sinebow.js":"iPuSr","./sequential-multi/turbo.js":"3EPRL","./sequential-multi/viridis.js":"4iNb6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jSvZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7ZyK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMRDh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"geyEl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2dEpS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gkRy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXFa6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evCZl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3wPdi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hubKu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9MzL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"tTdAL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"26zom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Interpolate = require("d3-interpolate");
exports.default = (scheme)=>(0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);

},{"d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Mo0j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hpB27":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eHirj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AEca":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bVkJg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bSyTu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6WSx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8HAw0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nGZW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kePiO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TDEP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixYEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6RkW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ajWB7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Qgit":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kU2Wx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ghGBr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6q2h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74hlN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2UKDL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Xh8u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b8eLb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hIsSh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f8zU8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mWp4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5xWYU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Slzk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6xPU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"jv6Pr","d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Avio":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":"jv6Pr","d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPuSr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    });
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"jv6Pr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EPRL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4iNb6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsJsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsJsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0b97":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>(0, _arcJsDefault.default));
parcelHelpers.export(exports, "area", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "pie", ()=>(0, _pieJsDefault.default));
parcelHelpers.export(exports, "areaRadial", ()=>(0, _areaRadialJsDefault.default)) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", ()=>(0, _areaRadialJsDefault.default));
parcelHelpers.export(exports, "lineRadial", ()=>(0, _lineRadialJsDefault.default)) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", ()=>(0, _lineRadialJsDefault.default));
parcelHelpers.export(exports, "pointRadial", ()=>(0, _pointRadialJsDefault.default));
parcelHelpers.export(exports, "linkHorizontal", ()=>(0, _indexJs.linkHorizontal));
parcelHelpers.export(exports, "linkVertical", ()=>(0, _indexJs.linkVertical));
parcelHelpers.export(exports, "linkRadial", ()=>(0, _indexJs.linkRadial));
parcelHelpers.export(exports, "symbol", ()=>(0, _symbolJsDefault.default));
parcelHelpers.export(exports, "symbols", ()=>(0, _symbolJs.symbols));
parcelHelpers.export(exports, "symbolCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "symbolCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "symbolSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "symbolStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "symbolWye", ()=>(0, _wyeJsDefault.default));
parcelHelpers.export(exports, "curveBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "curveBasisOpen", ()=>(0, _basisOpenJsDefault.default));
parcelHelpers.export(exports, "curveBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "curveBumpX", ()=>(0, _bumpJs.bumpX));
parcelHelpers.export(exports, "curveBumpY", ()=>(0, _bumpJs.bumpY));
parcelHelpers.export(exports, "curveBundle", ()=>(0, _bundleJsDefault.default));
parcelHelpers.export(exports, "curveCardinalClosed", ()=>(0, _cardinalClosedJsDefault.default));
parcelHelpers.export(exports, "curveCardinalOpen", ()=>(0, _cardinalOpenJsDefault.default));
parcelHelpers.export(exports, "curveCardinal", ()=>(0, _cardinalJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomClosed", ()=>(0, _catmullRomClosedJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomOpen", ()=>(0, _catmullRomOpenJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRom", ()=>(0, _catmullRomJsDefault.default));
parcelHelpers.export(exports, "curveLinearClosed", ()=>(0, _linearClosedJsDefault.default));
parcelHelpers.export(exports, "curveLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "curveMonotoneX", ()=>(0, _monotoneJs.monotoneX));
parcelHelpers.export(exports, "curveMonotoneY", ()=>(0, _monotoneJs.monotoneY));
parcelHelpers.export(exports, "curveNatural", ()=>(0, _naturalJsDefault.default));
parcelHelpers.export(exports, "curveStep", ()=>(0, _stepJsDefault.default));
parcelHelpers.export(exports, "curveStepAfter", ()=>(0, _stepJs.stepAfter));
parcelHelpers.export(exports, "curveStepBefore", ()=>(0, _stepJs.stepBefore));
parcelHelpers.export(exports, "stack", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "stackOffsetExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "stackOffsetDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "stackOffsetNone", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "stackOffsetSilhouette", ()=>(0, _silhouetteJsDefault.default));
parcelHelpers.export(exports, "stackOffsetWiggle", ()=>(0, _wiggleJsDefault.default));
parcelHelpers.export(exports, "stackOrderAppearance", ()=>(0, _appearanceJsDefault.default));
parcelHelpers.export(exports, "stackOrderAscending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderDescending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderInsideOut", ()=>(0, _insideOutJsDefault.default));
parcelHelpers.export(exports, "stackOrderNone", ()=>(0, _noneJsDefault1.default));
parcelHelpers.export(exports, "stackOrderReverse", ()=>(0, _reverseJsDefault.default));
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _indexJs = require("./link/index.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bumpJs = require("./curve/bump.js");
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"eW6xE","./area.js":"2B8Op","./line.js":"gnQTs","./pie.js":"3lWHz","./areaRadial.js":"5vmgg","./lineRadial.js":"bXtNa","./pointRadial.js":"a6Uf9","./link/index.js":"cXICL","./symbol.js":"hBVmE","./symbol/circle.js":"eefhB","./symbol/cross.js":"juUuo","./symbol/diamond.js":"k4QPR","./symbol/square.js":"i4RLX","./symbol/star.js":"ci6Xo","./symbol/triangle.js":"bOLuc","./symbol/wye.js":"lgFvs","./curve/basisClosed.js":"aONXZ","./curve/basisOpen.js":"dthU4","./curve/basis.js":"d9HhJ","./curve/bump.js":"5171a","./curve/bundle.js":"fFlgO","./curve/cardinalClosed.js":"6fW4g","./curve/cardinalOpen.js":"hnBZo","./curve/cardinal.js":"4ulw7","./curve/catmullRomClosed.js":"eYcPU","./curve/catmullRomOpen.js":"bNGKA","./curve/catmullRom.js":"klRKm","./curve/linearClosed.js":"iBRgd","./curve/linear.js":"57yu7","./curve/monotone.js":"bNKMh","./curve/natural.js":"l475B","./curve/step.js":"ecbaV","./stack.js":"bbH4m","./offset/expand.js":"bdZ1X","./offset/diverging.js":"aqEGC","./offset/none.js":"joCmo","./offset/silhouette.js":"jOOqg","./offset/wiggle.js":"cLCZj","./order/appearance.js":"hvQ57","./order/ascending.js":"20KtN","./order/descending.js":"bjr8r","./order/insideOut.js":"7Tk3d","./order/none.js":"cpMJc","./order/reverse.js":"9K4On","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eW6xE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = (0, _d3Path.path)();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle.
                    if (da < (0, _mathJs.pi) && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"d3-path":"a7nC8","./constant.js":"kiwm6","./math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kiwm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j0LEm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2B8Op":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x0, y0, y1) {
        var x1 = null, defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constantJsDefault.default)(0) : (0, _constantJsDefault.default)(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(+y1);
        function area(data) {
            var i, j, k, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    });
var _d3Path = require("d3-path");
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pointJs = require("./point.js");

},{"d3-path":"a7nC8","./array.js":"hmji0","./constant.js":"kiwm6","./curve/linear.js":"57yu7","./line.js":"gnQTs","./point.js":"iW2VA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmji0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"57yu7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnQTs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        x = typeof x === "function" ? x : x === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(x);
        y = typeof y === "function" ? y : y === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(y);
        function line(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _d3Path = require("d3-path");
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pointJs = require("./point.js");

},{"d3-path":"a7nC8","./array.js":"hmji0","./constant.js":"kiwm6","./curve/linear.js":"57yu7","./point.js":"iW2VA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iW2VA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3lWHz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./array.js":"hmji0","./constant.js":"kiwm6","./descending.js":"6vkEX","./identity.js":"lCwIW","./math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vkEX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCwIW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        return d;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5vmgg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var a = (0, _areaJsDefault.default)().curve((0, _radialJs.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
        };
        return a;
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineRadialJs = require("./lineRadial.js");

},{"./curve/radial.js":"2cZlP","./area.js":"2B8Op","./lineRadial.js":"bXtNa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2cZlP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curveRadialLinear", ()=>curveRadialLinear);
parcelHelpers.export(exports, "default", ()=>curveRadial);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var curveRadialLinear = curveRadial((0, _linearJsDefault.default));
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"./linear.js":"57yu7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bXtNa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineRadial", ()=>lineRadial);
parcelHelpers.export(exports, "default", ()=>function() {
        return lineRadial((0, _lineJsDefault.default)().curve((0, _radialJs.curveRadialLinear)));
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
    };
    return l;
}

},{"./curve/radial.js":"2cZlP","./line.js":"gnQTs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6Uf9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXICL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linkHorizontal", ()=>linkHorizontal);
parcelHelpers.export(exports, "linkVertical", ()=>linkVertical);
parcelHelpers.export(exports, "linkRadial", ()=>linkRadial);
var _d3Path = require("d3-path");
var _arrayJs = require("../array.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _pointJs = require("../point.js");
var _pointRadialJs = require("../pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    var source = linkSource, target = linkTarget, x = (0, _pointJs.x), y = (0, _pointJs.y), context = null;
    function link() {
        var buffer, argv = (0, _arrayJs.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, _d3Path.path)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, _pointRadialJsDefault.default)(x0, y0), p1 = (0, _pointRadialJsDefault.default)(x0, y0 = (y0 + y1) / 2), p2 = (0, _pointRadialJsDefault.default)(x1, y0), p3 = (0, _pointRadialJsDefault.default)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function linkHorizontal() {
    return link(curveHorizontal);
}
function linkVertical() {
    return link(curveVertical);
}
function linkRadial() {
    var l = link(curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"d3-path":"a7nC8","../array.js":"hmji0","../constant.js":"kiwm6","../point.js":"iW2VA","../pointRadial.js":"a6Uf9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hBVmE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symbols", ()=>symbols);
parcelHelpers.export(exports, "default", ()=>function(type, size) {
        var context = null;
        type = typeof type === "function" ? type : (0, _constantJsDefault.default)(type || (0, _circleJsDefault.default));
        size = typeof size === "function" ? size : (0, _constantJsDefault.default)(size === undefined ? 64 : +size);
        function symbol() {
            var buffer;
            if (!context) context = buffer = (0, _d3Path.path)();
            type.apply(this, arguments).draw(context, +size.apply(this, arguments));
            if (buffer) return context = null, buffer + "" || null;
        }
        symbol.type = function(_) {
            return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), symbol) : type;
        };
        symbol.size = function(_) {
            return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), symbol) : size;
        };
        symbol.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, symbol) : context;
        };
        return symbol;
    });
var _d3Path = require("d3-path");
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var symbols = [
    (0, _circleJsDefault.default),
    (0, _crossJsDefault.default),
    (0, _diamondJsDefault.default),
    (0, _squareJsDefault.default),
    (0, _starJsDefault.default),
    (0, _triangleJsDefault.default),
    (0, _wyeJsDefault.default)
];

},{"d3-path":"a7nC8","./symbol/circle.js":"eefhB","./symbol/cross.js":"juUuo","./symbol/diamond.js":"k4QPR","./symbol/star.js":"ci6Xo","./symbol/square.js":"i4RLX","./symbol/triangle.js":"bOLuc","./symbol/wye.js":"lgFvs","./constant.js":"kiwm6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eefhB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, _mathJs.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, _mathJs.tau));
    }
};

},{"../math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"juUuo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k4QPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tan30 = Math.sqrt(1 / 3), tan30_2 = tan30 * 2;
exports.default = {
    draw: function(context, size) {
        var y = Math.sqrt(size / tan30_2), x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ci6Xo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
var ka = 0.89081309152928522810, kr = Math.sin((0, _mathJs.pi) / 10) / Math.sin(7 * (0, _mathJs.pi) / 10), kx = Math.sin((0, _mathJs.tau) / 10) * kr, ky = -Math.cos((0, _mathJs.tau) / 10) * kr;
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size * ka), x = kx * r, y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, _mathJs.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"../math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4RLX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bOLuc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var sqrt3 = Math.sqrt(3);
exports.default = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lgFvs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var c = -0.5, s = Math.sqrt(3) / 2, k = 1 / Math.sqrt(12), a = (k / 2 + 1) * 3;
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size / a), x0 = r / 2, y0 = r * k, x1 = x0, y1 = r * k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aONXZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"7aIZJ","./basis.js":"d9HhJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7aIZJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9HhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dthU4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"d9HhJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5171a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bumpX", ()=>bumpX);
parcelHelpers.export(exports, "bumpY", ()=>bumpY);
class Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFlgO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"d9HhJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fW4g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"7aIZJ","./cardinal.js":"4ulw7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ulw7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnBZo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"4ulw7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYcPU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"6fW4g","../noop.js":"7aIZJ","./catmullRom.js":"klRKm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klRKm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"j0LEm","./cardinal.js":"4ulw7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNGKA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"hnBZo","./catmullRom.js":"klRKm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iBRgd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"7aIZJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNKMh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l475B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecbaV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bbH4m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
            for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                0,
                +value(d, sz[i].key, j, data)
            ]).data = d;
            for(i = 0, oz = (0, _arrayJsDefault.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}

},{"./array.js":"hmji0","./constant.js":"kiwm6","./offset/none.js":"joCmo","./order/none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"joCmo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cpMJc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdZ1X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"joCmo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aqEGC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOOqg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"joCmo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cLCZj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"joCmo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hvQ57":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20KtN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    });
parcelHelpers.export(exports, "sum", ()=>sum);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjr8r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"20KtN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Tk3d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    });
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"hvQ57","./ascending.js":"20KtN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9K4On":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wSnq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "zoomTransform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "zoomIdentity", ()=>(0, _transformJs.identity));
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./zoom.js":"lvjYn","./transform.js":"boRyC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvjYn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = (0, _d3Interpolate.interpolateZoom), listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain((0, _transformJs.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new (0, _transformJs.Transform)(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new (0, _transformJs.Transform)(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new (0, _transformJs.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = (0, _d3Selection.select)(this.that).datum();
                listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, _d3Selection.pointer)(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
            (0, _noeventJsDefault.default)(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var g = gesture(this, args, true).event(event), v = (0, _d3Selection.select)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, _d3Selection.pointer)(event, currentTarget), currentTarget = event.currentTarget, x0 = event.clientX, y0 = event.clientY;
            (0, _d3Drag.dragDisable)(event.view);
            (0, _noeventJs.nopropagation)(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            (0, _d3Transition.interrupt)(this);
            g.start();
            function mousemoved(event) {
                (0, _noeventJsDefault.default)(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.pointer)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                (0, _d3Drag.dragEnable)(event.view, g.moved);
                (0, _noeventJsDefault.default)(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = (0, _d3Selection.pointer)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            (0, _noeventJsDefault.default)(event);
            if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0, event);
            else (0, _d3Selection.select)(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            (0, _noeventJs.nopropagation)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            (0, _noeventJsDefault.default)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            (0, _noeventJs.nopropagation)(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = (0, _d3Selection.pointer)(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = (0, _d3Selection.select)(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _transformJs = require("./transform.js");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function defaultFilter(event) {
    return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function defaultTransform() {
    return this.__zoom || (0, _transformJs.identity);
}
function defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}

},{"d3-dispatch":"2VwUr","d3-drag":"HHNYu","d3-interpolate":"5gJW0","d3-selection":"9PvvP","d3-transition":"aj1c5","./constant.js":"i5Vxu","./event.js":"aUnay","./transform.js":"boRyC","./noevent.js":"67dpU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5Vxu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUnay":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomEvent);
function ZoomEvent(type, { sourceEvent, target, transform, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"boRyC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>transform);
function Transform(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
Transform.prototype = {
    constructor: Transform,
    scale: function(k) {
        return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var identity = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return identity;
    return node.__zoom;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67dpU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5OZt8":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("2f981e185ecfe0fb");
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.updateConfig = exports.getConfig = exports.DEFAULT_PROPS = exports.defaultSegmentValueFormatter = void 0;
var _defineProperty2 = _interopRequireDefault(require("eeb51451908664d")), _d = require("75793e5b705d1407"), _util = require("a3f9e41b4f1b69ae"), _enums = require("2df4096cab0cf7d5");
function ownKeys(a, b) {
    var c = Object.keys(a);
    if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(a);
        b && (d = d.filter(function(b) {
            return Object.getOwnPropertyDescriptor(a, b).enumerable;
        })), c.push.apply(c, d);
    }
    return c;
}
function _objectSpread(a) {
    for(var b, c = 1; c < arguments.length; c++)b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function(c) {
        (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function(c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
    return a;
}
var defaultSegmentValueFormatter = function(a) {
    return a;
};
exports.defaultSegmentValueFormatter = defaultSegmentValueFormatter;
var DEFAULT_PROPS = {
    value: 0,
    minValue: 0,
    maxValue: 1e3,
    forceRender: !1,
    width: 300,
    height: 300,
    paddingHorizontal: 0,
    paddingVertical: 0,
    fluidWidth: !1,
    dimensionUnit: "px",
    segments: 5,
    maxSegmentLabels: -1,
    customSegmentStops: [],
    customSegmentLabels: [],
    needleColor: "steelblue",
    startColor: "#FF471A",
    endColor: "#33CC33",
    segmentColors: [],
    needleTransition: _enums.Transition.easeQuadInOut,
    needleTransitionDuration: 500,
    needleHeightRatio: .9,
    ringWidth: 60,
    textColor: "#666",
    valueFormat: "",
    segmentValueFormatter: defaultSegmentValueFormatter,
    currentValueText: "${value}",
    currentValuePlaceholderStyle: "${value}",
    labelFontSize: "14px",
    valueTextFontSize: "16px",
    valueTextFontWeight: "bold",
    svgAriaLabel: "React d3 speedometer"
};
exports.DEFAULT_PROPS = DEFAULT_PROPS;
var DEFAULT_CONFIG = {
    ringInset: 20,
    pointerWidth: 10,
    pointerTailLength: 5,
    minAngle: -90,
    maxAngle: 90,
    labelInset: 10
}, getConfig = function(a) {
    var b = a.PROPS, c = a.parentWidth, d = a.parentHeight, e = {
        width: b.fluidWidth ? c : b.width,
        height: b.fluidWidth ? d : b.height,
        paddingHorizontal: b.paddingHorizontal,
        paddingVertical: b.paddingVertical,
        dimensionUnit: b.dimensionUnit,
        ringWidth: b.ringWidth,
        minValue: b.minValue,
        maxValue: b.maxValue,
        needleColor: b.needleColor,
        majorTicks: b.segments,
        customSegmentStops: b.customSegmentStops,
        customSegmentLabels: b.customSegmentLabels,
        maxSegmentLabels: (0, _util.calculateSegmentLabelCount)({
            maxSegmentLabelCount: b.maxSegmentLabels,
            segmentCount: b.segments
        }),
        segmentColors: b.segmentColors,
        arcColorFn: 0 < b.segmentColors.length ? (0, _d.scaleQuantize)(b.segmentColors) : (0, _d.interpolateHsl)((0, _d.rgb)(b.startColor), (0, _d.rgb)(b.endColor)),
        needleTransition: b.needleTransition,
        needleTransitionDuration: b.needleTransitionDuration,
        needleHeightRatio: b.needleHeightRatio,
        textColor: b.textColor,
        labelFormat: (0, _d.format)(b.valueFormat),
        segmentValueFormatter: b.segmentValueFormatter,
        currentValueText: b.currentValueText,
        currentValuePlaceholderStyle: b.currentValuePlaceholderStyle,
        labelFontSize: b.labelFontSize,
        valueTextFontSize: b.valueTextFontSize,
        valueTextFontWeight: b.valueTextFontWeight,
        svgAriaLabel: b.svgAriaLabel
    };
    return Object.assign({}, DEFAULT_CONFIG, e);
};
exports.getConfig = getConfig;
var updateConfig = function(a, b) {
    return _objectSpread(_objectSpread({}, a), b);
};
exports.updateConfig = updateConfig;

},{"2f981e185ecfe0fb":"kZ6eK","eeb51451908664d":"hjdoh","75793e5b705d1407":"aLplL","a3f9e41b4f1b69ae":"aFSFi","2df4096cab0cf7d5":"dU9sa"}],"aFSFi":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("cc84eea15f2d7152");
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.sumArrayTill = sumArrayTill, exports.calculateSegmentStops = calculateSegmentStops, exports.calculateNeedleHeight = calculateNeedleHeight, exports.calculateSegmentLabelCount = calculateSegmentLabelCount, exports.calculateScale = calculateScale, exports.calculateTicks = calculateTicks, exports.formatCurrentValueText = formatCurrentValueText, exports.deg2rad = deg2rad, exports.centerTranslation = centerTranslation, exports.getRadius = getRadius;
var _isNumber2 = _interopRequireDefault(require("fb9d2bf8bf971494")), _sum2 = _interopRequireDefault(require("dd9ae5bdd5f6b8ec")), _isEmpty = _interopRequireDefault(require("677aedc97151de1a")), _isArray = _interopRequireDefault(require("5d66574949435102")), _head2 = _interopRequireDefault(require("b8d89d4a1a61a91b")), _last2 = _interopRequireDefault(require("76ff82938e81c5b8")), _drop2 = _interopRequireDefault(require("708f461dd1c792c0")), _times2 = _interopRequireDefault(require("2e8cc9c24cdaf3c3")), _take2 = _interopRequireDefault(require("b98697f184f36b2c")), _d = require("84f4e4850fd3b75b");
function sumArrayTill(a, b) {
    return (0, _sum2["default"])((0, _take2["default"])(a, b));
}
function calculateSegmentStops(a) {
    var b = a.tickData, c = a.customSegmentStops, d = a.min, e = a.max;
    if (!(0, _isArray["default"])(c) || (0, _isEmpty["default"])(c)) return b;
    if ((0, _head2["default"])(c) !== d) throw new Error("First value should be equivalent to min value given. Current min value - ".concat(d));
    if ((0, _last2["default"])(c) !== e) throw new Error("Last value should be equivalent to max value given. Current min value - ".concat(e));
    var f = c.map(function(a, b) {
        return 0 === b ? void 0 : (a - c[b - 1]) / (e - d);
    });
    return (0, _drop2["default"])(f);
}
function calculateNeedleHeight(a) {
    var b = a.heightRatio, c = a.radius;
    if (0 > b || 1 < b) throw new Error("Invalid needleHeightRatio given - ".concat(b));
    return Math.round(c * b);
}
function calculateSegmentLabelCount(a) {
    var b = a.maxSegmentLabelCount, c = a.segmentCount, d = parseInt(b, 10), e = parseInt(c, 10);
    return (0, _isNumber2["default"])(d) && 0 <= d && d <= e ? d : e;
}
function calculateScale(a) {
    var b = a.min, c = a.max, d = a.segments;
    return (0, _d.scaleLinear)().range([
        0,
        1
    ]).domain([
        b,
        c
    ]);
}
function calculateTicks(a, b) {
    var c = b.min, d = b.max, e = b.segments, f = [];
    f = a.ticks(e);
    var g = ((0, _last2["default"])(f) !== d || e < f.length) && 1 < f.length;
    if (g) f = [
        c
    ], (0, _times2["default"])(e, function(a) {
        f.push(c + (a + 1) * ((d - c) / e));
    });
    return 1 === f.length && (f = [
        c,
        d
    ]), f;
}
function formatCurrentValueText(a, b) {
    var c = b.labelFormat(a), d = b.currentValuePlaceholderStyle;
    return b.currentValueText.replace(d, c);
}
function deg2rad(a) {
    return a * Math.PI / 180;
}
function centerTranslation(a, b, c) {
    return "translate(".concat(a + b, ", ").concat(a + c, ")");
}
function getRadius(a) {
    return a.width / 2;
}

},{"cc84eea15f2d7152":"kZ6eK","fb9d2bf8bf971494":"952WQ","dd9ae5bdd5f6b8ec":"dOINE","677aedc97151de1a":"6e5jm","5d66574949435102":"dB5dn","b8d89d4a1a61a91b":"97uzr","76ff82938e81c5b8":"iErh4","708f461dd1c792c0":"1UsNr","2e8cc9c24cdaf3c3":"g8BzA","b98697f184f36b2c":"gsFb5","84f4e4850fd3b75b":"aLplL"}],"952WQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == "number" || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == numberTag;
}
exports.default = isNumber;

},{"./_baseGetTag.js":"9Chff","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dOINE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSumJs = require("./_baseSum.js");
var _baseSumJsDefault = parcelHelpers.interopDefault(_baseSumJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function sum(array) {
    return array && array.length ? (0, _baseSumJsDefault.default)(array, (0, _identityJsDefault.default)) : 0;
}
exports.default = sum;

},{"./_baseSum.js":"7DtwM","./identity.js":"1Jo6N","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7DtwM":[function(require,module,exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
exports.default = baseSum;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6e5jm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if ((0, _isArrayLikeJsDefault.default)(value) && ((0, _isArrayJsDefault.default)(value) || typeof value == "string" || typeof value.splice == "function" || (0, _isBufferJsDefault.default)(value) || (0, _isTypedArrayJsDefault.default)(value) || (0, _isArgumentsJsDefault.default)(value))) return !value.length;
    var tag = (0, _getTagJsDefault.default)(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if ((0, _isPrototypeJsDefault.default)(value)) return !(0, _baseKeysJsDefault.default)(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
exports.default = isEmpty;

},{"./_baseKeys.js":"hSUtG","./_getTag.js":"2LNQq","./isArguments.js":"3o5tK","./isArray.js":"dB5dn","./isArrayLike.js":"6DRGr","./isBuffer.js":"dkqfQ","./_isPrototype.js":"kOZ2F","./isTypedArray.js":"fH44A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97uzr":[function(require,module,exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function head(array) {
    return array && array.length ? array[0] : undefined;
}
exports.default = head;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iErh4":[function(require,module,exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
exports.default = last;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1UsNr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSliceJs = require("./_baseSlice.js");
var _baseSliceJsDefault = parcelHelpers.interopDefault(_baseSliceJs);
var _toIntegerJs = require("./toInteger.js");
var _toIntegerJsDefault = parcelHelpers.interopDefault(_toIntegerJs);
/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */ function drop(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    n = guard || n === undefined ? 1 : (0, _toIntegerJsDefault.default)(n);
    return (0, _baseSliceJsDefault.default)(array, n < 0 ? 0 : n, length);
}
exports.default = drop;

},{"./_baseSlice.js":"2kpBx","./toInteger.js":"3m3YT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kpBx":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
exports.default = baseSlice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3m3YT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFiniteJs = require("./toFinite.js");
var _toFiniteJsDefault = parcelHelpers.interopDefault(_toFiniteJs);
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = (0, _toFiniteJsDefault.default)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
exports.default = toInteger;

},{"./toFinite.js":"7NWZt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NWZt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toNumberJs = require("./toNumber.js");
var _toNumberJsDefault = parcelHelpers.interopDefault(_toNumberJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, _toNumberJsDefault.default)(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
exports.default = toFinite;

},{"./toNumber.js":"4AdPu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g8BzA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _castFunctionJs = require("./_castFunction.js");
var _castFunctionJsDefault = parcelHelpers.interopDefault(_castFunctionJs);
var _toIntegerJs = require("./toInteger.js");
var _toIntegerJsDefault = parcelHelpers.interopDefault(_toIntegerJs);
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function times(n, iteratee) {
    n = (0, _toIntegerJsDefault.default)(n);
    if (n < 1 || n > MAX_SAFE_INTEGER) return [];
    var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
    iteratee = (0, _castFunctionJsDefault.default)(iteratee);
    n -= MAX_ARRAY_LENGTH;
    var result = (0, _baseTimesJsDefault.default)(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
exports.default = times;

},{"./_baseTimes.js":"9nudW","./_castFunction.js":"3z0qa","./toInteger.js":"3m3YT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsFb5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSliceJs = require("./_baseSlice.js");
var _baseSliceJsDefault = parcelHelpers.interopDefault(_baseSliceJs);
var _toIntegerJs = require("./toInteger.js");
var _toIntegerJsDefault = parcelHelpers.interopDefault(_toIntegerJs);
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */ function take(array, n, guard) {
    if (!(array && array.length)) return [];
    n = guard || n === undefined ? 1 : (0, _toIntegerJsDefault.default)(n);
    return (0, _baseSliceJsDefault.default)(array, 0, n < 0 ? 0 : n);
}
exports.default = take;

},{"./_baseSlice.js":"2kpBx","./toInteger.js":"3m3YT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dU9sa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.Transition = exports.CustomSegmentLabelPosition = void 0;
var CustomSegmentLabelPosition = {
    Inside: "INSIDE",
    Outside: "OUTSIDE"
};
exports.CustomSegmentLabelPosition = CustomSegmentLabelPosition;
var Transition = {
    easeLinear: "easeLinear",
    easeQuadIn: "easeQuadIn",
    easeQuadOut: "easeQuadOut",
    easeQuadInOut: "easeQuadInOut",
    easeCubicIn: "easeCubicIn",
    easeCubicOut: "easeCubicOut",
    easeCubicInOut: "easeCubicInOut",
    easePolyIn: "easePolyIn",
    easePolyOut: "easePolyOut",
    easePolyInOut: "easePolyInOut",
    easeSinIn: "easeSinIn",
    easeSinOut: "easeSinOut",
    easeSinInOut: "easeSinInOut",
    easeExpIn: "easeExpIn",
    easeExpOut: "easeExpOut",
    easeExpInOut: "easeExpInOut",
    easeCircleIn: "easeCircleIn",
    easeCircleOut: "easeCircleOut",
    easeCircleInOut: "easeCircleInOut",
    easeBounceIn: "easeBounceIn",
    easeBounceOut: "easeBounceOut",
    easeBounceInOut: "easeBounceInOut",
    easeBackIn: "easeBackIn",
    easeBackOut: "easeBackOut",
    easeBackInOut: "easeBackInOut",
    easeElasticIn: "easeElasticIn",
    easeElasticOut: "easeElasticOut",
    easeElasticInOut: "easeElasticInOut",
    easeElastic: "easeElastic"
};
exports.Transition = Transition;

},{}],"1RJOt":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("c9e0edd638ccc7be");
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports._renderLabels = _renderLabels, exports.render = exports.update = void 0;
var _d = require("8bc315da29fae907"), _isEmpty = _interopRequireDefault(require("43aba26b436e7141")), _isArray = _interopRequireDefault(require("c9e7c7a011311d4c")), _util = require("332b19f4438521da"), _getNeedleTransition = require("863477ef612713ae"), _configure = require("113c9b4261cd380e"), update = function(a) {
    var b = a.d3_refs, c = a.newValue, d = a.config, e = (0, _configure.configureScale)(d), f = e(c), g = d.maxAngle - d.minAngle, h = d.minAngle + f * g;
    b.pointer.transition().duration(d.needleTransitionDuration).ease((0, _getNeedleTransition.getNeedleTransition)(d.needleTransition)).attr("transform", "rotate(".concat(h, ")")), b.current_value_text.text((0, _util.formatCurrentValueText)(c, d));
};
exports.update = update;
var render = function(a) {
    var b = a.container, c = a.config, d = (0, _util.getRadius)(c), e = (0, _util.centerTranslation)(d, c.paddingHorizontal, c.paddingVertical), f = _renderSVG({
        container: b,
        config: c
    });
    return _renderArcs({
        config: c,
        svg: f,
        centerTx: e
    }), _renderLabels({
        config: c,
        svg: f,
        centerTx: e,
        r: d
    }), {
        current_value_text: _renderCurrentValueText({
            config: c,
            svg: f
        }),
        pointer: _renderNeedle({
            config: c,
            svg: f,
            r: d,
            centerTx: e
        })
    };
};
exports.render = render;
function _renderSVG(a) {
    var b = a.container, c = a.config, d = c.width + 2 * c.paddingHorizontal, e = c.height + 2 * c.paddingVertical;
    return (0, _d.select)(b).append("svg:svg").attr("class", "speedometer").attr("width", "".concat(d).concat(c.dimensionUnit)).attr("height", "".concat(e).concat(c.dimensionUnit)).attr("role", "img").attr("focusable", "false").attr("aria-label", c.svgAriaLabel).style("width", "".concat(d).concat(c.dimensionUnit)).style("height", "".concat(e).concat(c.dimensionUnit));
}
function _renderArcs(a) {
    var b = a.config, c = a.svg, d = a.centerTx, e = (0, _configure.configureTickData)(b), f = (0, _configure.configureArc)(b), g = c.append("g").attr("class", "arc").attr("transform", d);
    g.selectAll("path").data(e).enter().append("path").attr("class", "speedo-segment").attr("fill", function(a, c) {
        return !(0, _isEmpty["default"])(b.segmentColors) && b.segmentColors[c] ? b.segmentColors[c] : b.arcColorFn(a * c);
    }).attr("d", f);
}
function _renderLabels(a) {
    var b = a.config, c = a.svg, d = a.centerTx, e = a.r, f = (0, _configure.configureTicks)(b), g = (0, _configure.configureTickData)(b), h = (0, _configure.configureScale)(b), j = b.maxAngle - b.minAngle, k = b.customSegmentLabels, l = (0, _isArray["default"])(k) && !(0, _isEmpty["default"])(k), m = l && k.length === g.length;
    if (l && !m) throw new Error("Custom Segment Labels should be an array with length of ".concat(g.length));
    if (l && m) return void _renderCustomSegmentLabels({
        config: b,
        svg: c,
        centerTx: d,
        r: e,
        ticks: f,
        tickData: g,
        scale: h,
        range: j
    });
    var n = c.append("g").attr("class", "label").attr("transform", d);
    n.selectAll("text").data(f).enter().append("text").attr("transform", function(a, c) {
        var d = 0 === b.customSegmentStops.length ? h(a) : (0, _util.sumArrayTill)(g, c), f = b.minAngle + d * j;
        return "rotate(".concat(f, ") translate(0, ").concat(b.labelInset - e, ")");
    }).text(function(a) {
        return b.segmentValueFormatter(b.labelFormat(a));
    }).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", b.labelFontSize).style("font-weight", "bold").style("fill", b.textColor);
}
function _renderCustomSegmentLabels(a) {
    function b(a, b) {
        var d = 0 === l.length ? j(a) : (0, _util.sumArrayTill)(h, b), e = c.minAngle + d * k;
        return e;
    }
    var c = a.config, d = a.svg, e = a.centerTx, f = a.r, g = a.ticks, h = a.tickData, j = a.scale, k = a.range, l = c.customSegmentStops, m = c.customSegmentLabels, n = m.map(function(a, c) {
        var d = c, e = c + 1, f = g[d], h = b(f, d), i = g[e], j = b(i, e);
        return (j + h) / 2;
    }), o = f - c.ringWidth - c.ringInset, p = f - c.ringInset, q = d.append("g").attr("class", "label").attr("transform", e);
    q.selectAll("text").data(m).enter().append("text").attr("transform", function(a, b) {
        var d = n[b], e = "rotate(".concat(d, ") translate(0, ").concat(c.labelInset - f, ")"), g = "rotate(".concat(d, ") translate(0, ").concat(c.labelInset / 2 - (p - (p - o) / 2), ")");
        return "OUTSIDE" === a.position ? e : g;
    }).text(function(a) {
        return a.text || "";
    }).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", function(a) {
        return a.fontSize || c.labelFontSize;
    }).style("font-weight", "bold").style("fill", function(a) {
        return a.color || c.textColor;
    });
}
function _renderCurrentValueText(a) {
    var b = a.config, c = a.svg, d = (b.width + 2 * b.paddingHorizontal) / 2, e = (b.width + 4 * b.paddingVertical) / 2;
    return c.append("g").attr("transform", "translate(".concat(d, ", ").concat(e, ")")).append("text").attr("class", "current-value").attr("text-anchor", "middle").attr("y", 23).text(b.currentValue).style("font-size", b.valueTextFontSize).style("font-weight", b.valueTextFontWeight).style("fill", b.textColor);
}
function _renderNeedle(a) {
    var b = a.config, c = a.svg, d = a.r, e = a.centerTx, f = (0, _util.calculateNeedleHeight)({
        heightRatio: b.needleHeightRatio,
        radius: d
    }), g = [
        [
            b.pointerWidth / 2,
            0
        ],
        [
            0,
            -f
        ],
        [
            -(b.pointerWidth / 2),
            0
        ],
        [
            0,
            b.pointerTailLength
        ],
        [
            b.pointerWidth / 2,
            0
        ]
    ], h = (0, _d.line)().curve(_d.curveMonotoneX), i = c.append("g").data([
        g
    ]).attr("class", "pointer").attr("transform", e).style("fill", b.needleColor);
    return i.append("path").attr("d", h).attr("transform", "rotate(".concat(b.minAngle, ")"));
}

},{"c9e0edd638ccc7be":"kZ6eK","8bc315da29fae907":"aLplL","43aba26b436e7141":"6e5jm","c9e7c7a011311d4c":"dB5dn","332b19f4438521da":"aFSFi","863477ef612713ae":"hmBUI","113c9b4261cd380e":"8yHk6"}],"hmBUI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.getNeedleTransition = getNeedleTransition;
var _d = require("f33bd8559cb59c13"), _enums = require("3cff818565df3b26");
function getNeedleTransition(a) {
    return a === _enums.Transition.easeLinear ? _d.easeLinear : a === _enums.Transition.easeQuadIn ? _d.easeQuadIn : a === _enums.Transition.easeQuadOut ? _d.easeQuadOut : a === _enums.Transition.easeQuadInOut ? _d.easeQuadInOut : a === _enums.Transition.easeCubicIn ? _d.easeCubicIn : a === _enums.Transition.easeCubicOut ? _d.easeCubicOut : a === _enums.Transition.easeCubicInOut ? _d.easeCubicInOut : a === _enums.Transition.easePolyIn ? _d.easePolyIn : a === _enums.Transition.easePolyOut ? _d.easePolyOut : a === _enums.Transition.easePolyInOut ? _d.easePolyInOut : a === _enums.Transition.easeSinIn ? _d.easeSinIn : a === _enums.Transition.easeSinOut ? _d.easeSinOut : a === _enums.Transition.easeSinInOut ? _d.easeSinInOut : a === _enums.Transition.easeExpIn ? _d.easeExpIn : a === _enums.Transition.easeExpOut ? _d.easeExpOut : a === _enums.Transition.easeExpInOut ? _d.easeExpInOut : a === _enums.Transition.easeCircleIn ? _d.easeCircleIn : a === _enums.Transition.easeCircleOut ? _d.easeCircleOut : a === _enums.Transition.easeCircleInOut ? _d.easeCircleInOut : a === _enums.Transition.easeBounceIn ? _d.easeBounceIn : a === _enums.Transition.easeBounceOut ? _d.easeBounceOut : a === _enums.Transition.easeBounceInOut ? _d.easeBounceInOut : a === _enums.Transition.easeBackIn ? _d.easeBackIn : a === _enums.Transition.easeBackOut ? _d.easeBackOut : a === _enums.Transition.easeBackInOut ? _d.easeBackInOut : a === _enums.Transition.easeElasticIn ? _d.easeElasticIn : a === _enums.Transition.easeElasticOut ? _d.easeElasticOut : a === _enums.Transition.easeElasticInOut ? _d.easeElasticInOut : a === _enums.Transition.easeElastic ? _d.easeElastic : _d.easeQuadInOut;
}

},{"f33bd8559cb59c13":"aLplL","3cff818565df3b26":"dU9sa"}],"8yHk6":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("666d5525c7ab3fe4");
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.configureArc = exports.configureTickData = exports.configureTicks = exports.configureScale = void 0;
var _memoizeOne = _interopRequireDefault(require("4e784015180da16a")), _d = require("28b509cd21358124"), _util = require("f8c3d34cb9386415"), configureScale = (0, _memoizeOne["default"])(_configureScale);
exports.configureScale = configureScale;
var configureTicks = (0, _memoizeOne["default"])(_configureTicks);
exports.configureTicks = configureTicks;
var configureTickData = (0, _memoizeOne["default"])(_configureTickData);
exports.configureTickData = configureTickData;
var configureArc = (0, _memoizeOne["default"])(_configureArc);
exports.configureArc = configureArc;
function _configureScale(a) {
    return (0, _util.calculateScale)({
        min: a.minValue,
        max: a.maxValue,
        segments: a.maxSegmentLabels
    });
}
function _configureTicks(a) {
    var b = configureScale(a), c = (0, _util.calculateTicks)(b, {
        min: a.minValue,
        max: a.maxValue,
        segments: a.maxSegmentLabels
    });
    return 0 < a.customSegmentStops.length && 0 !== a.maxSegmentLabels && (c = a.customSegmentStops), c;
}
function _configureTickData(a) {
    var b = (0, _d.range)(a.majorTicks).map(function() {
        return 1 / a.majorTicks;
    }), c = (0, _util.calculateSegmentStops)({
        tickData: b,
        customSegmentStops: a.customSegmentStops,
        min: a.minValue,
        max: a.maxValue
    });
    return c;
}
function _configureArc(a) {
    var b = configureTickData(a), c = a.maxAngle - a.minAngle, d = a.width / 2, e = (0, _d.arc)().innerRadius(d - a.ringWidth - a.ringInset).outerRadius(d - a.ringInset).startAngle(function(e, d) {
        var f = (0, _util.sumArrayTill)(b, d);
        return (0, _util.deg2rad)(a.minAngle + f * c);
    }).endAngle(function(e, d) {
        var f = (0, _util.sumArrayTill)(b, d + 1);
        return (0, _util.deg2rad)(a.minAngle + f * c);
    });
    return e;
}

},{"666d5525c7ab3fe4":"kZ6eK","4e784015180da16a":"eFj2c","28b509cd21358124":"aLplL","f8c3d34cb9386415":"aFSFi"}],"eFj2c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
exports.default = memoizeOne;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5n2c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactApexcharts = require("react-apexcharts");
var _reactApexchartsDefault = parcelHelpers.interopDefault(_reactApexcharts);
var _apexcharts = require("apexcharts");
var _apexchartsDefault = parcelHelpers.interopDefault(_apexcharts);
var _widthContext = require("../../Context/WidthContext");
exports.default = /*#__PURE__*/ (0, _react.memo)(LegacyGaugeWidget);
function LegacyGaugeWidget(props) {
    const vw = (0, _react.useContext)((0, _widthContext.Width));
    const { datapointID, key, max, min, secondGauge: { datapointID: datapointID1, key: key1, max: max1, min: min1 } = {}, title } = props.widget?.settings || {};
    const lines = [
        {
            cID: datapointID,
            k: key,
            mn: min,
            mx: max
        },
        {
            cID: datapointID1,
            k: key1,
            mn: min1,
            mx: max1
        }
    ].reduce((acc, { cID, k, mn, mx }, i)=>{
        if (!cID) return acc;
        const { signals = {} } = props.fetchedData?.get?.(cID)?.[0] || {};
        const { value } = Object.values(signals || {})?.find(({ name })=>name === k) || {};
        switch(true){
            case Number.isFinite(mx) && value >= mx:
            case Number.isFinite(mn) && value <= mn:
                acc[i] = {
                    data: [
                        value >= mx ? 100 : 0
                    ],
                    datapointID: cID,
                    max: mx,
                    min: mn,
                    name: k,
                    originalValue: value
                };
                break;
            default:
                {
                    const calculated = (value - mn) * 100 / (mx - mn);
                    const data = Number.isFinite(calculated) ? [
                        calculated
                    ] : [];
                    acc[i] = {
                        data,
                        datapointID: cID,
                        max: mx,
                        min: mn,
                        name: k,
                        originalValue: value
                    };
                    break;
                }
        }
        return acc;
    }, []);
    const height = (0, _react.useMemo)(()=>{
        switch(true){
            case lines.length === 2:
                return "95%";
            default:
                return "120%";
        }
    }, [
        lines.length,
        vw
    ]);
    return lines.map((line, index)=>{
        const options = new GaugeGraphOptionsBuilder(title, props.graphWidgetIDs, props.graphIndex, props.renderNextGraph, index).addOptions(line, props.fetchedData, props.signalUnitsMap);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `d-inline-block h-100 w-${lines?.length === 2 ? "50" : "100"} position-relative`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GaugeWrapper, {
                data: line?.data?.[0],
                height: height,
                name: line?.name,
                options: options,
                showName: lines?.length === 2
            })
        }, `${title}-${index}`);
    });
}
LegacyGaugeWidget.propTypes = {
    fetchedData: (0, _propTypesDefault.default).object,
    graphIndex: (0, _propTypesDefault.default).number,
    graphWidgetIDs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    renderNextGraph: (0, _propTypesDefault.default).func,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    widget: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        settings: (0, _propTypesDefault.default).shape({
            datapoint: (0, _propTypesDefault.default).object,
            datapointID: (0, _propTypesDefault.default).string,
            key: (0, _propTypesDefault.default).string,
            max: (0, _propTypesDefault.default).number,
            secondGauge: (0, _propTypesDefault.default).shape({
                datapoint: (0, _propTypesDefault.default).object,
                datapointID: (0, _propTypesDefault.default).string,
                key: (0, _propTypesDefault.default).string,
                max: (0, _propTypesDefault.default).number
            }),
            title: (0, _propTypesDefault.default).string
        })
    })
};
class GaugeGraphOptionsBuilder {
    constructor(id, graphWidgetIDs, graphIndex, renderNextGraph, index){
        this.chart = {
            events: {
                mounted: ()=>{
                    if (graphWidgetIDs?.length - 1 > graphIndex) renderNextGraph(graphWidgetIDs[graphIndex + 1]);
                }
            },
            fontFamily: '"Roboto", sans-serif',
            id: `${id}-${graphIndex}-${index}`
        };
        this.noData = {
            text: "No data available for this signal."
        };
        this.stroke = {
            width: 1.5
        };
        this.xaxis = {};
    }
    addOptions(line, fetchedData, signalUnitsMap = new Map()) {
        const { name, datapointID, max, min, originalValue } = line || {}, { display_precision, unit } = signalUnitsMap.get(datapointID)?.[name] ?? {}, inRange = originalValue < max && originalValue > min;
        this.labels = [
            unit || ""
        ];
        this.plotOptions = {
            radialBar: {
                startAngle: -135,
                endAngle: 135,
                dataLabels: {
                    name: {
                        color: inRange ? "#878787" : "#4196D6",
                        fontFamily: '"Roboto", sans-serif',
                        fontSize: "16px",
                        offsetY: 25
                    },
                    value: {
                        offsetY: -12,
                        fontSize: "28px",
                        color: inRange ? "#4196D6" : "#878787",
                        formatter: (val)=>{
                            const displayVal = Number.isInteger(originalValue) ? originalValue : originalValue.toFixed(display_precision ?? 2);
                            return val <= 100 && val >= 0 ? displayVal : val > 100 ? `> ${max}` : `< ${min}`;
                        }
                    }
                }
            }
        };
        this.fill = {
            gradient: {
                enabled: true,
                shade: "dark",
                shadeIntensity: 0.15,
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1
            }
        };
        this.stroke = {
            dashArray: 4
        };
        this.states = {
            hover: {
                filter: {
                    type: "none"
                }
            }
        };
        return this;
    }
}
function GaugeWrapper(props) {
    const series = (0, _react.useMemo)(()=>!props.data && props.data !== 0 ? [] : [
            props.data
        ], [
        props.data
    ]);
    (0, _react.useEffect)(()=>{
        if (!props.data && props.data !== 0) return;
        (0, _apexchartsDefault.default).exec(props.options.chart.id, "updateSeries", series);
        (0, _apexchartsDefault.default).exec(props.options.chart.id, "updateOptions", props.options);
    }, [
        props.data,
        props.options,
        series
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "position-absolute h-100 w-100 d-flex flex-column align-items-center justify-content-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex-fill w-100 position-relative",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "position-absolute h-100 w-100",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactApexchartsDefault.default), {
                        height: "100%",
                        options: props.options,
                        series: series,
                        type: "radialBar"
                    })
                })
            }),
            props.showName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-0 px-1 px-md-3 text-center text-bold three-quarter-text",
                children: props.name
            }) : null
        ]
    });
}
GaugeWrapper.propTypes = {
    data: (0, _propTypesDefault.default).number,
    height: (0, _propTypesDefault.default).string,
    name: (0, _propTypesDefault.default).string,
    options: (0, _propTypesDefault.default).object,
    showName: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-apexcharts":"lEV8Y","apexcharts":"93box","../../Context/WidthContext":"5c6Dv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEV8Y":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
    return typeof e;
} : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, _extends = Object.assign || function(e) {
    for(var t = 1; t < arguments.length; t++){
        var r, n = arguments[t];
        for(r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
}, _createClass = function() {
    function n(e, t) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    return function(e, t, r) {
        return t && n(e.prototype, t), r && n(e, r), e;
    };
}(), _apexcharts = require("da04fa78b9a71d7a"), _apexcharts2 = _interopRequireDefault(_apexcharts), _react = require("a558e37992849081"), _react2 = _interopRequireDefault(_react), _propTypes = require("2e2c019741f4d0"), _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _defineProperty(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _objectWithoutProperties(e, t) {
    var r, n = {};
    for(r in e)0 <= t.indexOf(r) || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    return n;
}
function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(e, t) {
    if (e) return !t || "object" != typeof t && "function" != typeof t ? e : t;
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
}
function _inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
window.ApexCharts = _apexcharts2.default;
var Charts = function() {
    function r(e) {
        _classCallCheck(this, r);
        var t = _possibleConstructorReturn(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));
        return _react2.default.createRef ? t.chartRef = _react2.default.createRef() : t.setRef = function(e) {
            return t.chartRef = e;
        }, t.chart = null, t;
    }
    return _inherits(r, _react.Component), _createClass(r, [
        {
            key: "render",
            value: function() {
                var e = _objectWithoutProperties(this.props, []);
                return _react2.default.createElement("div", _extends({
                    ref: _react2.default.createRef ? this.chartRef : this.setRef
                }, e));
            }
        },
        {
            key: "componentDidMount",
            value: function() {
                var e = _react2.default.createRef ? this.chartRef.current : this.chartRef;
                this.chart = new _apexcharts2.default(e, this.getConfig()), this.chart.render();
            }
        },
        {
            key: "getConfig",
            value: function() {
                var e = this.props, t = e.type, r = e.height, n = e.width, o = e.series, e = e.options;
                return this.extend(e, {
                    chart: {
                        type: t,
                        height: r,
                        width: n
                    },
                    series: o
                });
            }
        },
        {
            key: "isObject",
            value: function(e) {
                return e && "object" === (void 0 === e ? "undefined" : _typeof(e)) && !Array.isArray(e) && null != e;
            }
        },
        {
            key: "extend",
            value: function(t, r) {
                var n = this, o = ("function" != typeof Object.assign && (Object.assign = function(e) {
                    if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                    for(var t = Object(e), r = 1; r < arguments.length; r++){
                        var n = arguments[r];
                        if (null != n) for(var o in n)n.hasOwnProperty(o) && (t[o] = n[o]);
                    }
                    return t;
                }), Object.assign({}, t));
                return this.isObject(t) && this.isObject(r) && Object.keys(r).forEach(function(e) {
                    n.isObject(r[e]) && e in t ? o[e] = n.extend(t[e], r[e]) : Object.assign(o, _defineProperty({}, e, r[e]));
                }), o;
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e) {
                if (!this.chart) return null;
                var t = this.props, r = t.options, n = t.series, o = t.height, t = t.width, i = JSON.stringify(e.options), a = JSON.stringify(e.series), r = JSON.stringify(r), s = JSON.stringify(n);
                i === r && a === s && o === e.height && t === e.width || (a !== s && i === r && o === e.height && t === e.width ? this.chart.updateSeries(n) : this.chart.updateOptions(this.getConfig()));
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.chart && "function" == typeof this.chart.destroy && this.chart.destroy();
            }
        }
    ]), r;
}();
(exports.default = Charts).propTypes = {
    type: _propTypes2.default.string.isRequired,
    width: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.number
    ]),
    height: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.number
    ]),
    series: _propTypes2.default.array.isRequired,
    options: _propTypes2.default.object.isRequired
}, Charts.defaultProps = {
    type: "line",
    width: "100%",
    height: "auto"
};

},{"da04fa78b9a71d7a":"93box","a558e37992849081":"9njXz","2e2c019741f4d0":"bnNSm"}],"93box":[function(require,module,exports) {
/*!
 * ApexCharts v3.45.1
 * (c) 2018-2023 ApexCharts
 * Released under the MIT License.
 */ "use strict";
function t(t, e) {
    var i = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        e && (a = a.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), i.push.apply(i, a);
    }
    return i;
}
function e(e) {
    for(var i = 1; i < arguments.length; i++){
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? t(Object(a), !0).forEach(function(t) {
            o(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : t(Object(a)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
    }
    return e;
}
function i(t) {
    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, i(t);
}
function a(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function s(t, e) {
    for(var i = 0; i < e.length; i++){
        var a = e[i];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
}
function r(t, e, i) {
    return e && s(t.prototype, e), i && s(t, i), t;
}
function o(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
function n(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), e && h(t, e);
}
function l(t) {
    return l = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, l(t);
}
function h(t, e) {
    return h = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, h(t, e);
}
function c(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function d(t) {
    var e = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }();
    return function() {
        var i, a = l(t);
        if (e) {
            var s = l(this).constructor;
            i = Reflect.construct(a, arguments, s);
        } else i = a.apply(this, arguments);
        return function(t, e) {
            if (e && ("object" == typeof e || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return c(t);
        }(this, i);
    };
}
function g(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, e) {
        var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null == i) return;
        var a, s, r = [], o = !0, n = !1;
        try {
            for(i = i.call(t); !(o = (a = i.next()).done) && (r.push(a.value), !e || r.length !== e); o = !0);
        } catch (t) {
            n = !0, s = t;
        } finally{
            try {
                o || null == i.return || i.return();
            } finally{
                if (n) throw s;
            }
        }
        return r;
    }(t, e) || p(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function u(t) {
    return function(t) {
        if (Array.isArray(t)) return f(t);
    }(t) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(t) || p(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function p(t, e) {
    if (t) {
        if ("string" == typeof t) return f(t, e);
        var i = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? f(t, e) : void 0;
    }
}
function f(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, a = new Array(e); i < e; i++)a[i] = t[i];
    return a;
}
var x = function() {
    function t() {
        a(this, t);
    }
    return r(t, [
        {
            key: "shadeRGBColor",
            value: function(t, e) {
                var i = e.split(","), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = parseInt(i[0].slice(4), 10), o = parseInt(i[1], 10), n = parseInt(i[2], 10);
                return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - o) * s) + o) + "," + (Math.round((a - n) * s) + n) + ")";
            }
        },
        {
            key: "shadeHexColor",
            value: function(t, e) {
                var i = parseInt(e.slice(1), 16), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = i >> 16, o = i >> 8 & 255, n = 255 & i;
                return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - o) * s) + o) + (Math.round((a - n) * s) + n)).toString(16).slice(1);
            }
        },
        {
            key: "shadeColor",
            value: function(e, i) {
                return t.isColorHex(i) ? this.shadeHexColor(e, i) : this.shadeRGBColor(e, i);
            }
        }
    ], [
        {
            key: "bind",
            value: function(t, e) {
                return function() {
                    return t.apply(e, arguments);
                };
            }
        },
        {
            key: "isObject",
            value: function(t) {
                return t && "object" === i(t) && !Array.isArray(t) && null != t;
            }
        },
        {
            key: "is",
            value: function(t, e) {
                return Object.prototype.toString.call(e) === "[object " + t + "]";
            }
        },
        {
            key: "listToArray",
            value: function(t) {
                var e, i = [];
                for(e = 0; e < t.length; e++)i[e] = t[e];
                return i;
            }
        },
        {
            key: "extend",
            value: function(t, e) {
                var i = this;
                "function" != typeof Object.assign && (Object.assign = function(t) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for(var e = Object(t), i = 1; i < arguments.length; i++){
                        var a = arguments[i];
                        if (null != a) for(var s in a)a.hasOwnProperty(s) && (e[s] = a[s]);
                    }
                    return e;
                });
                var a = Object.assign({}, t);
                return this.isObject(t) && this.isObject(e) && Object.keys(e).forEach(function(s) {
                    i.isObject(e[s]) && s in t ? a[s] = i.extend(t[s], e[s]) : Object.assign(a, o({}, s, e[s]));
                }), a;
            }
        },
        {
            key: "extendArray",
            value: function(e, i) {
                var a = [];
                return e.map(function(e) {
                    a.push(t.extend(i, e));
                }), e = a;
            }
        },
        {
            key: "monthMod",
            value: function(t) {
                return t % 12;
            }
        },
        {
            key: "clone",
            value: function(e) {
                if (t.is("Array", e)) {
                    for(var a = [], s = 0; s < e.length; s++)a[s] = this.clone(e[s]);
                    return a;
                }
                if (t.is("Null", e)) return null;
                if (t.is("Date", e)) return e;
                if ("object" === i(e)) {
                    var r = {};
                    for(var o in e)e.hasOwnProperty(o) && (r[o] = this.clone(e[o]));
                    return r;
                }
                return e;
            }
        },
        {
            key: "log10",
            value: function(t) {
                return Math.log(t) / Math.LN10;
            }
        },
        {
            key: "roundToBase10",
            value: function(t) {
                return Math.pow(10, Math.floor(Math.log10(t)));
            }
        },
        {
            key: "roundToBase",
            value: function(t, e) {
                return Math.pow(e, Math.floor(Math.log(t) / Math.log(e)));
            }
        },
        {
            key: "parseNumber",
            value: function(t) {
                return null === t ? t : parseFloat(t);
            }
        },
        {
            key: "stripNumber",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
                return Number.isInteger(t) ? t : parseFloat(t.toPrecision(e));
            }
        },
        {
            key: "randomId",
            value: function() {
                return (Math.random() + 1).toString(36).substring(4);
            }
        },
        {
            key: "noExponents",
            value: function(t) {
                var e = String(t).split(/[eE]/);
                if (1 === e.length) return e[0];
                var i = "", a = t < 0 ? "-" : "", s = e[0].replace(".", ""), r = Number(e[1]) + 1;
                if (r < 0) {
                    for(i = a + "0."; r++;)i += "0";
                    return i + s.replace(/^-/, "");
                }
                for(r -= s.length; r--;)i += "0";
                return s + i;
            }
        },
        {
            key: "getDimensions",
            value: function(t) {
                var e = getComputedStyle(t, null), i = t.clientHeight, a = t.clientWidth;
                return i -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), [
                    a -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                    i
                ];
            }
        },
        {
            key: "getBoundingClientRect",
            value: function(t) {
                var e = t.getBoundingClientRect();
                return {
                    top: e.top,
                    right: e.right,
                    bottom: e.bottom,
                    left: e.left,
                    width: t.clientWidth,
                    height: t.clientHeight,
                    x: e.left,
                    y: e.top
                };
            }
        },
        {
            key: "getLargestStringFromArr",
            value: function(t) {
                return t.reduce(function(t, e) {
                    return Array.isArray(e) && (e = e.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    })), t.length > e.length ? t : e;
                }, 0);
            }
        },
        {
            key: "hexToRgba",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#999999", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .6;
                "#" !== t.substring(0, 1) && (t = "#999999");
                var i = t.replace("#", "");
                i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                for(var a = 0; a < i.length; a++)i[a] = parseInt(1 === i[a].length ? i[a] + i[a] : i[a], 16);
                return void 0 !== e && i.push(e), "rgba(" + i.join(",") + ")";
            }
        },
        {
            key: "getOpacityFromRGBA",
            value: function(t) {
                return parseFloat(t.replace(/^.*,(.+)\)/, "$1"));
            }
        },
        {
            key: "rgb2hex",
            value: function(t) {
                return (t = t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === t.length ? "#" + ("0" + parseInt(t[1], 10).toString(16)).slice(-2) + ("0" + parseInt(t[2], 10).toString(16)).slice(-2) + ("0" + parseInt(t[3], 10).toString(16)).slice(-2) : "";
            }
        },
        {
            key: "isColorHex",
            value: function(t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t);
            }
        },
        {
            key: "getPolygonPos",
            value: function(t, e) {
                for(var i = [], a = 2 * Math.PI / e, s = 0; s < e; s++){
                    var r = {};
                    r.x = t * Math.sin(s * a), r.y = -t * Math.cos(s * a), i.push(r);
                }
                return i;
            }
        },
        {
            key: "polarToCartesian",
            value: function(t, e, i, a) {
                var s = (a - 90) * Math.PI / 180;
                return {
                    x: t + i * Math.cos(s),
                    y: e + i * Math.sin(s)
                };
            }
        },
        {
            key: "escapeString",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x", i = t.toString().slice();
                return i = i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, e);
            }
        },
        {
            key: "negToZero",
            value: function(t) {
                return t < 0 ? 0 : t;
            }
        },
        {
            key: "moveIndexInArray",
            value: function(t, e, i) {
                if (i >= t.length) for(var a = i - t.length + 1; a--;)t.push(void 0);
                return t.splice(i, 0, t.splice(e, 1)[0]), t;
            }
        },
        {
            key: "extractNumber",
            value: function(t) {
                return parseFloat(t.replace(/[^\d.]*/g, ""));
            }
        },
        {
            key: "findAncestor",
            value: function(t, e) {
                for(; (t = t.parentElement) && !t.classList.contains(e););
                return t;
            }
        },
        {
            key: "setELstyles",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && (t.style.key = e[i]);
            }
        },
        {
            key: "isNumber",
            value: function(t) {
                return !isNaN(t) && parseFloat(Number(t)) === t && !isNaN(parseInt(t, 10));
            }
        },
        {
            key: "isFloat",
            value: function(t) {
                return Number(t) === t && t % 1 != 0;
            }
        },
        {
            key: "isSafari",
            value: function() {
                return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        {
            key: "isFirefox",
            value: function() {
                return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
            }
        },
        {
            key: "isIE11",
            value: function() {
                if (-1 !== window.navigator.userAgent.indexOf("MSIE") || window.navigator.appVersion.indexOf("Trident/") > -1) return !0;
            }
        },
        {
            key: "isIE",
            value: function() {
                var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
                if (e > 0) return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
                if (t.indexOf("Trident/") > 0) {
                    var i = t.indexOf("rv:");
                    return parseInt(t.substring(i + 3, t.indexOf(".", i)), 10);
                }
                var a = t.indexOf("Edge/");
                return a > 0 && parseInt(t.substring(a + 5, t.indexOf(".", a)), 10);
            }
        }
    ]), t;
}(), b = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.setEasingFunctions();
    }
    return r(t, [
        {
            key: "setEasingFunctions",
            value: function() {
                var t;
                if (!this.w.globals.easing) {
                    switch(this.w.config.chart.animations.easing){
                        case "linear":
                            t = "-";
                            break;
                        case "easein":
                            t = "<";
                            break;
                        case "easeout":
                            t = ">";
                            break;
                        case "easeinout":
                        default:
                            t = "<>";
                            break;
                        case "swing":
                            t = function(t) {
                                var e = 1.70158;
                                return (t -= 1) * t * ((e + 1) * t + e) + 1;
                            };
                            break;
                        case "bounce":
                            t = function(t) {
                                return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
                            };
                            break;
                        case "elastic":
                            t = function(t) {
                                return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - .075) * (2 * Math.PI) / .3) + 1;
                            };
                    }
                    this.w.globals.easing = t;
                }
            }
        },
        {
            key: "animateLine",
            value: function(t, e, i, a) {
                t.attr(e).animate(a).attr(i);
            }
        },
        {
            key: "animateMarker",
            value: function(t, e, i, a, s, r) {
                e || (e = 0), t.attr({
                    r: e,
                    width: e,
                    height: e
                }).animate(a, s).attr({
                    r: i,
                    width: i.width,
                    height: i.height
                }).afterAll(function() {
                    r();
                });
            }
        },
        {
            key: "animateCircle",
            value: function(t, e, i, a, s) {
                t.attr({
                    r: e.r,
                    cx: e.cx,
                    cy: e.cy
                }).animate(a, s).attr({
                    r: i.r,
                    cx: i.cx,
                    cy: i.cy
                });
            }
        },
        {
            key: "animateRect",
            value: function(t, e, i, a, s) {
                t.attr(e).animate(a).attr(i).afterAll(function() {
                    return s();
                });
            }
        },
        {
            key: "animatePathsGradually",
            value: function(t) {
                var e = t.el, i = t.realIndex, a = t.j, s = t.fill, r = t.pathFrom, o = t.pathTo, n = t.speed, l = t.delay, h = this.w, c = 0;
                h.config.chart.animations.animateGradually.enabled && (c = h.config.chart.animations.animateGradually.delay), h.config.chart.animations.dynamicAnimation.enabled && h.globals.dataChanged && "bar" !== h.config.chart.type && (c = 0), this.morphSVG(e, i, a, "line" !== h.config.chart.type || h.globals.comboCharts ? s : "stroke", r, o, n, l * c);
            }
        },
        {
            key: "showDelayedElements",
            value: function() {
                this.w.globals.delayedElements.forEach(function(t) {
                    var e = t.el;
                    e.classList.remove("apexcharts-element-hidden"), e.classList.add("apexcharts-hidden-element-shown");
                });
            }
        },
        {
            key: "animationCompleted",
            value: function(t) {
                var e = this.w;
                e.globals.animationEnded || (e.globals.animationEnded = !0, this.showDelayedElements(), "function" == typeof e.config.chart.events.animationEnd && e.config.chart.events.animationEnd(this.ctx, {
                    el: t,
                    w: e
                }));
            }
        },
        {
            key: "morphSVG",
            value: function(t, e, i, a, s, r, o, n) {
                var l = this, h = this.w;
                s || (s = t.attr("pathFrom")), r || (r = t.attr("pathTo"));
                var c = function(t) {
                    return "radar" === h.config.chart.type && (o = 1), "M 0 ".concat(h.globals.gridHeight);
                };
                (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = c()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = c()), h.globals.shouldAnimate || (o = 1), t.plot(s).animate(1, h.globals.easing, n).plot(s).animate(o, h.globals.easing, n).plot(r).afterAll(function() {
                    x.isNumber(i) ? i === h.globals.series[h.globals.maxValsInArrayIndex].length - 2 && h.globals.shouldAnimate && l.animationCompleted(t) : "none" !== a && h.globals.shouldAnimate && (!h.globals.comboCharts && e === h.globals.series.length - 1 || h.globals.comboCharts) && l.animationCompleted(t), l.showDelayedElements();
                });
            }
        }
    ]), t;
}(), v = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "getDefaultFilter",
            value: function(t, e) {
                var i = this.w;
                t.unfilter(!0), (new window.SVG.Filter).size("120%", "180%", "-5%", "-40%"), "none" !== i.config.states.normal.filter ? this.applyFilter(t, e, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addNormalFilter",
            value: function(t, e) {
                var i = this.w;
                i.config.chart.dropShadow.enabled && !t.node.classList.contains("apexcharts-marker") && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addLightenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: 1.5,
                            intercept: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "addDarkenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "applyFilter",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                switch(i){
                    case "none":
                        this.addNormalFilter(t, e);
                        break;
                    case "lighten":
                        this.addLightenFilter(t, e, {
                            intensity: a
                        });
                        break;
                    case "darken":
                        this.addDarkenFilter(t, e, {
                            intensity: a
                        });
                }
            }
        },
        {
            key: "addShadow",
            value: function(t, e, i) {
                var a = i.blur, s = i.top, r = i.left, o = i.color, n = i.opacity, l = t.flood(Array.isArray(o) ? o[e] : o, n).composite(t.sourceAlpha, "in").offset(r, s).gaussianBlur(a).merge(t.source);
                return t.blend(t.source, l);
            }
        },
        {
            key: "dropShadow",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = e.top, s = e.left, r = e.blur, o = e.color, n = e.opacity, l = e.noUserSpaceOnUse, h = this.w;
                return t.unfilter(!0), x.isIE() && "radialBar" === h.config.chart.type || (o = Array.isArray(o) ? o[i] : o, t.filter(function(t) {
                    var e = null;
                    e = x.isSafari() || x.isFirefox() || x.isIE() ? t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r) : t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r).merge(t.source), t.blend(t.source, e);
                }), l || t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node)), t;
            }
        },
        {
            key: "setSelectionFilter",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.globals.selectedDataPoints[e] && a.globals.selectedDataPoints[e].indexOf(i) > -1) {
                    t.node.setAttribute("selected", !0);
                    var s = a.config.states.active.filter;
                    "none" !== s && this.applyFilter(t, e, s.type, s.value);
                }
            }
        },
        {
            key: "_scaleFilterSize",
            value: function(t) {
                !function(e) {
                    for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
                }({
                    width: "200%",
                    height: "200%",
                    x: "-50%",
                    y: "-50%"
                });
            }
        }
    ]), t;
}(), m = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "roundPathCorners",
            value: function(t, e) {
                function i(t, e, i) {
                    var s = e.x - t.x, r = e.y - t.y, o = Math.sqrt(s * s + r * r);
                    return a(t, e, Math.min(1, i / o));
                }
                function a(t, e, i) {
                    return {
                        x: t.x + (e.x - t.x) * i,
                        y: t.y + (e.y - t.y) * i
                    };
                }
                function s(t, e) {
                    t.length > 2 && (t[t.length - 2] = e.x, t[t.length - 1] = e.y);
                }
                function r(t) {
                    return {
                        x: parseFloat(t[t.length - 2]),
                        y: parseFloat(t[t.length - 1])
                    };
                }
                t.indexOf("NaN") > -1 && (t = "");
                var o = t.split(/[,\s]/).reduce(function(t, e) {
                    var i = e.match("([a-zA-Z])(.+)");
                    return i ? (t.push(i[1]), t.push(i[2])) : t.push(e), t;
                }, []).reduce(function(t, e) {
                    return parseFloat(e) == e && t.length ? t[t.length - 1].push(e) : t.push([
                        e
                    ]), t;
                }, []), n = [];
                if (o.length > 1) {
                    var l = r(o[0]), h = null;
                    "Z" == o[o.length - 1][0] && o[0].length > 2 && (h = [
                        "L",
                        l.x,
                        l.y
                    ], o[o.length - 1] = h), n.push(o[0]);
                    for(var c = 1; c < o.length; c++){
                        var d = n[n.length - 1], g = o[c], u = g == h ? o[1] : o[c + 1];
                        if (u && d && d.length > 2 && "L" == g[0] && u.length > 2 && "L" == u[0]) {
                            var p, f, x = r(d), b = r(g), v = r(u);
                            p = i(b, x, e), f = i(b, v, e), s(g, p), g.origPoint = b, n.push(g);
                            var m = a(p, b, .5), y = a(b, f, .5), w = [
                                "C",
                                m.x,
                                m.y,
                                y.x,
                                y.y,
                                f.x,
                                f.y
                            ];
                            w.origPoint = b, n.push(w);
                        } else n.push(g);
                    }
                    if (h) {
                        var k = r(n[n.length - 1]);
                        n.push([
                            "Z"
                        ]), s(n[0], k);
                    }
                } else n = o;
                return n.reduce(function(t, e) {
                    return t + e.join(" ") + " ";
                }, "");
            }
        },
        {
            key: "drawLine",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "butt";
                return this.w.globals.dom.Paper.line().attr({
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: a,
                    stroke: s,
                    "stroke-dasharray": r,
                    "stroke-width": o,
                    "stroke-linecap": n
                });
            }
        },
        {
            key: "drawRect",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "#fefefe", o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null, h = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0, c = this.w.globals.dom.Paper.rect();
                return c.attr({
                    x: t,
                    y: e,
                    width: i > 0 ? i : 0,
                    height: a > 0 ? a : 0,
                    rx: s,
                    ry: s,
                    opacity: o,
                    "stroke-width": null !== n ? n : 0,
                    stroke: null !== l ? l : "none",
                    "stroke-dasharray": h
                }), c.node.setAttribute("fill", r), c;
            }
        },
        {
            key: "drawPolygon",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "none";
                return this.w.globals.dom.Paper.polygon(t).attr({
                    fill: a,
                    stroke: e,
                    "stroke-width": i
                });
            }
        },
        {
            key: "drawCircle",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                t < 0 && (t = 0);
                var i = this.w.globals.dom.Paper.circle(2 * t);
                return null !== e && i.attr(e), i;
            }
        },
        {
            key: "drawPath",
            value: function(t) {
                var e = t.d, i = void 0 === e ? "" : e, a = t.stroke, s = void 0 === a ? "#a8a8a8" : a, r = t.strokeWidth, o = void 0 === r ? 1 : r, n = t.fill, l = t.fillOpacity, h = void 0 === l ? 1 : l, c = t.strokeOpacity, d = void 0 === c ? 1 : c, g = t.classes, u = t.strokeLinecap, p = void 0 === u ? null : u, f = t.strokeDashArray, x = void 0 === f ? 0 : f, b = this.w;
                return null === p && (p = b.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(b.globals.gridHeight)), b.globals.dom.Paper.path(i).attr({
                    fill: n,
                    "fill-opacity": h,
                    stroke: s,
                    "stroke-opacity": d,
                    "stroke-linecap": p,
                    "stroke-width": o,
                    "stroke-dasharray": x,
                    class: g
                });
            }
        },
        {
            key: "group",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w.globals.dom.Paper.group();
                return null !== t && e.attr(t), e;
            }
        },
        {
            key: "move",
            value: function(t, e) {
                var i = [
                    "M",
                    t,
                    e
                ].join(" ");
                return i;
            }
        },
        {
            key: "line",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = null;
                return null === i ? a = [
                    " L",
                    t,
                    e
                ].join(" ") : "H" === i ? a = [
                    " H",
                    t
                ].join(" ") : "V" === i && (a = [
                    " V",
                    e
                ].join(" ")), a;
            }
        },
        {
            key: "curve",
            value: function(t, e, i, a, s, r) {
                var o = [
                    "C",
                    t,
                    e,
                    i,
                    a,
                    s,
                    r
                ].join(" ");
                return o;
            }
        },
        {
            key: "quadraticCurve",
            value: function(t, e, i, a) {
                return [
                    "Q",
                    t,
                    e,
                    i,
                    a
                ].join(" ");
            }
        },
        {
            key: "arc",
            value: function(t, e, i, a, s, r, o) {
                var n = "A";
                arguments.length > 7 && void 0 !== arguments[7] && arguments[7] && (n = "a");
                var l = [
                    n,
                    t,
                    e,
                    i,
                    a,
                    s,
                    r,
                    o
                ].join(" ");
                return l;
            }
        },
        {
            key: "renderPaths",
            value: function(t) {
                var i, a = t.j, s = t.realIndex, r = t.pathFrom, o = t.pathTo, n = t.stroke, l = t.strokeWidth, h = t.strokeLinecap, c = t.fill, d = t.animationDelay, g = t.initialSpeed, u = t.dataChangeSpeed, p = t.className, f = t.shouldClipToGrid, x = void 0 === f || f, m = t.bindEventsOnPaths, y = void 0 === m || m, w = t.drawShadow, k = void 0 === w || w, A = this.w, S = new v(this.ctx), C = new b(this.ctx), L = this.w.config.chart.animations.enabled, P = L && this.w.config.chart.animations.dynamicAnimation.enabled, I = !!(L && !A.globals.resized || P && A.globals.dataChanged && A.globals.shouldAnimate);
                I ? i = r : (i = o, A.globals.animationEnded = !0);
                var T = A.config.stroke.dashArray, M = 0;
                M = Array.isArray(T) ? T[s] : A.config.stroke.dashArray;
                var z = this.drawPath({
                    d: i,
                    stroke: n,
                    strokeWidth: l,
                    fill: c,
                    fillOpacity: 1,
                    classes: p,
                    strokeLinecap: h,
                    strokeDashArray: M
                });
                if (z.attr("index", s), x && z.attr({
                    "clip-path": "url(#gridRectMask".concat(A.globals.cuid, ")")
                }), "none" !== A.config.states.normal.filter.type) S.getDefaultFilter(z, s);
                else if (A.config.chart.dropShadow.enabled && k && (!A.config.chart.dropShadow.enabledOnSeries || A.config.chart.dropShadow.enabledOnSeries && -1 !== A.config.chart.dropShadow.enabledOnSeries.indexOf(s))) {
                    var X = A.config.chart.dropShadow;
                    S.dropShadow(z, X, s);
                }
                y && (z.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, z)), z.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, z)), z.node.addEventListener("mousedown", this.pathMouseDown.bind(this, z))), z.attr({
                    pathTo: o,
                    pathFrom: r
                });
                var E = {
                    el: z,
                    j: a,
                    realIndex: s,
                    pathFrom: r,
                    pathTo: o,
                    fill: c,
                    strokeWidth: l,
                    delay: d
                };
                return !L || A.globals.resized || A.globals.dataChanged ? !A.globals.resized && A.globals.dataChanged || C.showDelayedElements() : C.animatePathsGradually(e(e({}, E), {}, {
                    speed: g
                })), A.globals.dataChanged && P && I && C.animatePathsGradually(e(e({}, E), {}, {
                    speed: u
                })), z;
            }
        },
        {
            key: "drawPattern",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                return this.w.globals.dom.Paper.pattern(e, i, function(r) {
                    "horizontalLines" === t ? r.line(0, 0, i, 0).stroke({
                        color: a,
                        width: s + 1
                    }) : "verticalLines" === t ? r.line(0, 0, 0, e).stroke({
                        color: a,
                        width: s + 1
                    }) : "slantedLines" === t ? r.line(0, 0, e, i).stroke({
                        color: a,
                        width: s
                    }) : "squares" === t ? r.rect(e, i).fill("none").stroke({
                        color: a,
                        width: s
                    }) : "circles" === t && r.circle(e).fill("none").stroke({
                        color: a,
                        width: s
                    });
                });
            }
        },
        {
            key: "drawGradient",
            value: function(t, e, i, a, s) {
                var r, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, n = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, h = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, c = this.w;
                e.length < 9 && 0 === e.indexOf("#") && (e = x.hexToRgba(e, a)), i.length < 9 && 0 === i.indexOf("#") && (i = x.hexToRgba(i, s));
                var d = 0, g = 1, u = 1, p = null;
                null !== n && (d = void 0 !== n[0] ? n[0] / 100 : 0, g = void 0 !== n[1] ? n[1] / 100 : 1, u = void 0 !== n[2] ? n[2] / 100 : 1, p = void 0 !== n[3] ? n[3] / 100 : null);
                var f = !("donut" !== c.config.chart.type && "pie" !== c.config.chart.type && "polarArea" !== c.config.chart.type && "bubble" !== c.config.chart.type);
                if (r = null === l || 0 === l.length ? c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    t.at(d, e, a), t.at(g, i, s), t.at(u, i, s), null !== p && t.at(p, e, a);
                }) : c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    (Array.isArray(l[h]) ? l[h] : l).forEach(function(e) {
                        t.at(e.offset / 100, e.color, e.opacity);
                    });
                }), f) {
                    var b = c.globals.gridWidth / 2, v = c.globals.gridHeight / 2;
                    "bubble" !== c.config.chart.type ? r.attr({
                        gradientUnits: "userSpaceOnUse",
                        cx: b,
                        cy: v,
                        r: o
                    }) : r.attr({
                        cx: .5,
                        cy: .5,
                        r: .8,
                        fx: .2,
                        fy: .2
                    });
                } else "vertical" === t ? r.from(0, 0).to(0, 1) : "diagonal" === t ? r.from(0, 0).to(1, 1) : "horizontal" === t ? r.from(0, 1).to(1, 1) : "diagonal2" === t && r.from(1, 0).to(0, 1);
                return r;
            }
        },
        {
            key: "getTextBasedOnMaxWidth",
            value: function(t) {
                var e = t.text, i = t.maxWidth, a = t.fontSize, s = t.fontFamily, r = this.getTextRects(e, a, s), o = r.width / e.length, n = Math.floor(i / o);
                return i < r.width ? e.slice(0, n - 3) + "..." : e;
            }
        },
        {
            key: "drawText",
            value: function(t) {
                var i = this, a = t.x, s = t.y, r = t.text, o = t.textAnchor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.foreColor, d = t.opacity, g = t.maxWidth, u = t.cssClass, p = void 0 === u ? "" : u, f = t.isPlainText, x = void 0 === f || f, b = t.dominantBaseline, v = void 0 === b ? "auto" : b, m = this.w;
                void 0 === r && (r = "");
                var y = r;
                o || (o = "start"), c && c.length || (c = m.config.chart.foreColor), l = l || m.config.chart.fontFamily, h = h || "regular";
                var w, k = {
                    maxWidth: g,
                    fontSize: n = n || "11px",
                    fontFamily: l
                };
                return Array.isArray(r) ? w = m.globals.dom.Paper.text(function(t) {
                    for(var a = 0; a < r.length; a++)y = r[a], g && (y = i.getTextBasedOnMaxWidth(e({
                        text: r[a]
                    }, k))), 0 === a ? t.tspan(y) : t.tspan(y).newLine();
                }) : (g && (y = this.getTextBasedOnMaxWidth(e({
                    text: r
                }, k))), w = x ? m.globals.dom.Paper.plain(r) : m.globals.dom.Paper.text(function(t) {
                    return t.tspan(y);
                })), w.attr({
                    x: a,
                    y: s,
                    "text-anchor": o,
                    "dominant-baseline": v,
                    "font-size": n,
                    "font-family": l,
                    "font-weight": h,
                    fill: c,
                    class: "apexcharts-text " + p
                }), w.node.style.fontFamily = l, w.node.style.opacity = d, w;
            }
        },
        {
            key: "drawMarker",
            value: function(t, e, i) {
                t = t || 0;
                var a = i.pSize || 0, s = null;
                if ("square" === i.shape || "rect" === i.shape) {
                    var r = void 0 === i.pRadius ? a / 2 : i.pRadius;
                    null !== e && a || (a = 0, r = 0);
                    var o = 1.2 * a + r, n = this.drawRect(o, o, o, o, r);
                    n.attr({
                        x: t - o / 2,
                        y: e - o / 2,
                        cx: t,
                        cy: e,
                        class: i.class ? i.class : "",
                        fill: i.pointFillColor,
                        "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                        stroke: i.pointStrokeColor,
                        "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                        "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                    }), s = n;
                } else "circle" !== i.shape && i.shape || (x.isNumber(e) || (a = 0, e = 0), s = this.drawCircle(a, {
                    cx: t,
                    cy: e,
                    class: i.class ? i.class : "",
                    stroke: i.pointStrokeColor,
                    fill: i.pointFillColor,
                    "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                    "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                    "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                }));
                return s;
            }
        },
        {
            key: "pathMouseEnter",
            value: function(t, e) {
                var i = this.w, a = new v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                if ("function" == typeof i.config.chart.events.dataPointMouseEnter && i.config.chart.events.dataPointMouseEnter(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), ("none" === i.config.states.active.filter.type || "true" !== t.node.getAttribute("selected")) && "none" !== i.config.states.hover.filter.type && !i.globals.isTouchDevice) {
                    var o = i.config.states.hover.filter;
                    a.applyFilter(t, s, o.type, o.value);
                }
            }
        },
        {
            key: "pathMouseLeave",
            value: function(t, e) {
                var i = this.w, a = new v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                "function" == typeof i.config.chart.events.dataPointMouseLeave && i.config.chart.events.dataPointMouseLeave(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), "none" !== i.config.states.active.filter.type && "true" === t.node.getAttribute("selected") || "none" !== i.config.states.hover.filter.type && a.getDefaultFilter(t, s);
            }
        },
        {
            key: "pathMouseDown",
            value: function(t, e) {
                var i = this.w, a = new v(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10), o = "false";
                if ("true" === t.node.getAttribute("selected")) {
                    if (t.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                        var n = i.globals.selectedDataPoints[s].indexOf(r);
                        i.globals.selectedDataPoints[s].splice(n, 1);
                    }
                } else {
                    if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                        i.globals.selectedDataPoints = [];
                        var l = i.globals.dom.Paper.select(".apexcharts-series path").members, h = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members, c = function(t) {
                            Array.prototype.forEach.call(t, function(t) {
                                t.node.setAttribute("selected", "false"), a.getDefaultFilter(t, s);
                            });
                        };
                        c(l), c(h);
                    }
                    t.node.setAttribute("selected", "true"), o = "true", void 0 === i.globals.selectedDataPoints[s] && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                }
                if ("true" === o) {
                    var d = i.config.states.active.filter;
                    if ("none" !== d) a.applyFilter(t, s, d.type, d.value);
                    else if ("none" !== i.config.states.hover.filter && !i.globals.isTouchDevice) {
                        var g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                } else if ("none" !== i.config.states.active.filter.type) {
                    if ("none" === i.config.states.hover.filter.type || i.globals.isTouchDevice) a.getDefaultFilter(t, s);
                    else {
                        g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                }
                "function" == typeof i.config.chart.events.dataPointSelection && i.config.chart.events.dataPointSelection(e, this.ctx, {
                    selectedDataPoints: i.globals.selectedDataPoints,
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), e && this.ctx.events.fireEvent("dataPointSelection", [
                    e,
                    this.ctx,
                    {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]);
            }
        },
        {
            key: "rotateAroundCenter",
            value: function(t) {
                var e = {};
                return t && "function" == typeof t.getBBox && (e = t.getBBox()), {
                    x: e.x + e.width / 2,
                    y: e.y + e.height / 2
                };
            }
        },
        {
            key: "getTextRects",
            value: function(t, e, i, a) {
                var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = this.w, o = this.drawText({
                    x: -200,
                    y: -200,
                    text: t,
                    textAnchor: "start",
                    fontSize: e,
                    fontFamily: i,
                    foreColor: "#fff",
                    opacity: 0
                });
                a && o.attr("transform", a), r.globals.dom.Paper.add(o);
                var n = o.bbox();
                return s || (n = o.node.getBoundingClientRect()), o.remove(), {
                    width: n.width,
                    height: n.height
                };
            }
        },
        {
            key: "placeTextWithEllipsis",
            value: function(t, e, i) {
                if ("function" == typeof t.getComputedTextLength && (t.textContent = e, e.length > 0 && t.getComputedTextLength() >= i / 1.1)) {
                    for(var a = e.length - 3; a > 0; a -= 3)if (t.getSubStringLength(0, a) <= i / 1.1) return void (t.textContent = e.substring(0, a) + "...");
                    t.textContent = ".";
                }
            }
        }
    ], [
        {
            key: "setAttrs",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
            }
        }
    ]), t;
}(), y = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "getStackedSeriesTotals",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = this.w, i = [];
                if (0 === e.globals.series.length) return i;
                for(var a = 0; a < e.globals.series[e.globals.maxValsInArrayIndex].length; a++){
                    for(var s = 0, r = 0; r < e.globals.series.length; r++)void 0 !== e.globals.series[r][a] && -1 === t.indexOf(r) && (s += e.globals.series[r][a]);
                    i.push(s);
                }
                return i;
            }
        },
        {
            key: "getSeriesTotalByIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return null === t ? this.w.config.series.reduce(function(t, e) {
                    return t + e;
                }, 0) : this.w.globals.series[t].reduce(function(t, e) {
                    return t + e;
                }, 0);
            }
        },
        {
            key: "getStackedSeriesTotalsByGroups",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.globals.seriesGroups.forEach(function(a) {
                    var s = [];
                    e.config.series.forEach(function(t, e) {
                        a.indexOf(t.name) > -1 && s.push(e);
                    });
                    var r = e.globals.series.map(function(t, e) {
                        return -1 === s.indexOf(e) ? e : -1;
                    }).filter(function(t) {
                        return -1 !== t;
                    });
                    i.push(t.getStackedSeriesTotals(r));
                }), i;
            }
        },
        {
            key: "isSeriesNull",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return 0 === (null === t ? this.w.config.series.filter(function(t) {
                    return null !== t;
                }) : this.w.config.series[t].data.filter(function(t) {
                    return null !== t;
                })).length;
            }
        },
        {
            key: "seriesHaveSameValues",
            value: function(t) {
                return this.w.globals.series[t].every(function(t, e, i) {
                    return t === i[0];
                });
            }
        },
        {
            key: "getCategoryLabels",
            value: function(t) {
                var e = this.w, i = t.slice();
                return e.config.xaxis.convertedCatToNumeric && (i = t.map(function(t, i) {
                    return e.config.xaxis.labels.formatter(t - e.globals.minX + 1);
                })), i;
            }
        },
        {
            key: "getLargestSeries",
            value: function() {
                var t = this.w;
                t.globals.maxValsInArrayIndex = t.globals.series.map(function(t) {
                    return t.length;
                }).indexOf(Math.max.apply(Math, t.globals.series.map(function(t) {
                    return t.length;
                })));
            }
        },
        {
            key: "getLargestMarkerSize",
            value: function() {
                var t = this.w, e = 0;
                return t.globals.markers.size.forEach(function(t) {
                    e = Math.max(e, t);
                }), t.config.markers.discrete && t.config.markers.discrete.length && t.config.markers.discrete.forEach(function(t) {
                    e = Math.max(e, t.size);
                }), e > 0 && (e += t.config.markers.hover.sizeOffset + 1), t.globals.markers.largestSize = e, e;
            }
        },
        {
            key: "getSeriesTotals",
            value: function() {
                var t = this.w;
                t.globals.seriesTotals = t.globals.series.map(function(t, e) {
                    var i = 0;
                    if (Array.isArray(t)) for(var a = 0; a < t.length; a++)i += t[a];
                    else i += t;
                    return i;
                });
            }
        },
        {
            key: "getSeriesTotalsXRange",
            value: function(t, e) {
                var i = this.w;
                return i.globals.series.map(function(a, s) {
                    for(var r = 0, o = 0; o < a.length; o++)i.globals.seriesX[s][o] > t && i.globals.seriesX[s][o] < e && (r += a[o]);
                    return r;
                });
            }
        },
        {
            key: "getPercentSeries",
            value: function() {
                var t = this.w;
                t.globals.seriesPercent = t.globals.series.map(function(e, i) {
                    var a = [];
                    if (Array.isArray(e)) for(var s = 0; s < e.length; s++){
                        var r = t.globals.stackedSeriesTotals[s], o = 0;
                        r && (o = 100 * e[s] / r), a.push(o);
                    }
                    else {
                        var n = 100 * e / t.globals.seriesTotals.reduce(function(t, e) {
                            return t + e;
                        }, 0);
                        a.push(n);
                    }
                    return a;
                });
            }
        },
        {
            key: "getCalculatedRatios",
            value: function() {
                var t, e, i, a, s = this.w.globals, r = [], o = 0, n = [], l = .1, h = 0;
                if (s.yRange = [], s.isMultipleYAxis) for(var c = 0; c < s.minYArr.length; c++)s.yRange.push(Math.abs(s.minYArr[c] - s.maxYArr[c])), n.push(0);
                else s.yRange.push(Math.abs(s.minY - s.maxY));
                s.xRange = Math.abs(s.maxX - s.minX), s.zRange = Math.abs(s.maxZ - s.minZ);
                for(var d = 0; d < s.yRange.length; d++)r.push(s.yRange[d] / s.gridHeight);
                if (e = s.xRange / s.gridWidth, i = Math.abs(s.initialMaxX - s.initialMinX) / s.gridWidth, t = s.yRange / s.gridWidth, a = s.xRange / s.gridHeight, (o = s.zRange / s.gridHeight * 16) || (o = 1), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (s.hasNegs = !0), s.isMultipleYAxis) {
                    n = [];
                    for(var g = 0; g < r.length; g++)n.push(-s.minYArr[g] / r[g]);
                } else n.push(-s.minY / r[0]), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (l = -s.minY / t, h = s.minX / e);
                return {
                    yRatio: r,
                    invertedYRatio: t,
                    zRatio: o,
                    xRatio: e,
                    initialXRatio: i,
                    invertedXRatio: a,
                    baseLineInvertedY: l,
                    baseLineY: n,
                    baseLineX: h
                };
            }
        },
        {
            key: "getLogSeries",
            value: function(t) {
                var e = this, i = this.w;
                return i.globals.seriesLog = t.map(function(t, a) {
                    return i.config.yaxis[a] && i.config.yaxis[a].logarithmic ? t.map(function(t) {
                        return null === t ? null : e.getLogVal(i.config.yaxis[a].logBase, t, a);
                    }) : t;
                }), i.globals.invalidLogScale ? t : i.globals.seriesLog;
            }
        },
        {
            key: "getBaseLog",
            value: function(t, e) {
                return Math.log(e) / Math.log(t);
            }
        },
        {
            key: "getLogVal",
            value: function(t, e, i) {
                if (0 === e) return 0;
                var a = this.w, s = 0 === a.globals.minYArr[i] ? -1 : this.getBaseLog(t, a.globals.minYArr[i]), r = (0 === a.globals.maxYArr[i] ? 0 : this.getBaseLog(t, a.globals.maxYArr[i])) - s;
                return e < 1 ? e / r : (this.getBaseLog(t, e) - s) / r;
            }
        },
        {
            key: "getLogYRatios",
            value: function(t) {
                var e = this, i = this.w, a = this.w.globals;
                return a.yLogRatio = t.slice(), a.logYRange = a.yRange.map(function(t, s) {
                    if (i.config.yaxis[s] && e.w.config.yaxis[s].logarithmic) {
                        var r, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                        return a.seriesLog.forEach(function(t, e) {
                            t.forEach(function(t) {
                                i.config.yaxis[e] && i.config.yaxis[e].logarithmic && (o = Math.max(t, o), n = Math.min(t, n));
                            });
                        }), r = Math.pow(a.yRange[s], Math.abs(n - o) / a.yRange[s]), a.yLogRatio[s] = r / a.gridHeight, r;
                    }
                }), a.invalidLogScale ? t.slice() : a.yLogRatio;
            }
        }
    ], [
        {
            key: "checkComboSeries",
            value: function(t) {
                var e = !1, i = 0, a = 0;
                return t.length && void 0 !== t[0].type && t.forEach(function(t) {
                    "bar" !== t.type && "column" !== t.type && "candlestick" !== t.type && "boxPlot" !== t.type || i++, void 0 !== t.type && a++;
                }), a > 0 && (e = !0), {
                    comboBarCount: i,
                    comboCharts: e
                };
            }
        },
        {
            key: "extendArrayProps",
            value: function(t, e, i) {
                return e.yaxis && (e = t.extendYAxis(e, i)), e.annotations && (e.annotations.yaxis && (e = t.extendYAxisAnnotations(e)), e.annotations.xaxis && (e = t.extendXAxisAnnotations(e)), e.annotations.points && (e = t.extendPointAnnotations(e))), e;
            }
        }
    ]), t;
}(), w = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.annoCtx = e;
    }
    return r(t, [
        {
            key: "setOrientations",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.w;
                if ("vertical" === t.label.orientation) {
                    var a = null !== e ? e : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                    if (null !== s) {
                        var r = s.getBoundingClientRect();
                        s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4), "top" === t.label.position ? s.setAttribute("y", parseFloat(s.getAttribute("y")) + r.width) : s.setAttribute("y", parseFloat(s.getAttribute("y")) - r.width);
                        var o = this.annoCtx.graphics.rotateAroundCenter(s), n = o.x, l = o.y;
                        s.setAttribute("transform", "rotate(-90 ".concat(n, " ").concat(l, ")"));
                    }
                }
            }
        },
        {
            key: "addBackgroundToAnno",
            value: function(t, e) {
                var i = this.w;
                if (!t || void 0 === e.label.text || void 0 !== e.label.text && !String(e.label.text).trim()) return null;
                var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = t.getBoundingClientRect(), r = e.label.style.padding.left, o = e.label.style.padding.right, n = e.label.style.padding.top, l = e.label.style.padding.bottom;
                "vertical" === e.label.orientation && (n = e.label.style.padding.left, l = e.label.style.padding.right, r = e.label.style.padding.top, o = e.label.style.padding.bottom);
                var h = s.left - a.left - r, c = s.top - a.top - n, d = this.annoCtx.graphics.drawRect(h - i.globals.barPadForNumericAxis, c, s.width + r + o, s.height + n + l, e.label.borderRadius, e.label.style.background, 1, e.label.borderWidth, e.label.borderColor, 0);
                return e.id && d.node.classList.add(e.id), d;
            }
        },
        {
            key: "annotationsBackground",
            value: function() {
                var t = this, e = this.w, i = function(i, a, s) {
                    var r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(a, "']"));
                    if (r) {
                        var o = r.parentNode, n = t.addBackgroundToAnno(r, i);
                        n && (o.insertBefore(n.node, r), i.label.mouseEnter && n.node.addEventListener("mouseenter", i.label.mouseEnter.bind(t, i)), i.label.mouseLeave && n.node.addEventListener("mouseleave", i.label.mouseLeave.bind(t, i)), i.label.click && n.node.addEventListener("click", i.label.click.bind(t, i)));
                    }
                };
                e.config.annotations.xaxis.map(function(t, e) {
                    i(t, e, "xaxis");
                }), e.config.annotations.yaxis.map(function(t, e) {
                    i(t, e, "yaxis");
                }), e.config.annotations.points.map(function(t, e) {
                    i(t, e, "point");
                });
            }
        },
        {
            key: "getY1Y2",
            value: function(t, e) {
                var i, a = "y1" === t ? e.y : e.y2, s = this.w;
                if (this.annoCtx.invertAxis) {
                    var r = s.globals.labels.indexOf(a);
                    s.config.xaxis.convertedCatToNumeric && (r = s.globals.categoryLabels.indexOf(a));
                    var o = s.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(" + (r + 1) + ")");
                    o && (i = parseFloat(o.getAttribute("y"))), void 0 !== e.seriesIndex && s.globals.barHeight && (i = i - s.globals.barHeight / 2 * (s.globals.series.length - 1) + s.globals.barHeight * e.seriesIndex);
                } else {
                    var n;
                    if (s.config.yaxis[e.yAxisIndex].logarithmic) n = (a = new y(this.annoCtx.ctx).getLogVal(a, e.yAxisIndex)) / s.globals.yLogRatio[e.yAxisIndex];
                    else n = (a - s.globals.minYArr[e.yAxisIndex]) / (s.globals.yRange[e.yAxisIndex] / s.globals.gridHeight);
                    i = s.globals.gridHeight - n, !e.marker || void 0 !== e.y && null !== e.y || (i = 0), s.config.yaxis[e.yAxisIndex] && s.config.yaxis[e.yAxisIndex].reversed && (i = n);
                }
                return "string" == typeof a && a.indexOf("px") > -1 && (i = parseFloat(a)), i;
            }
        },
        {
            key: "getX1X2",
            value: function(t, e) {
                var i = this.w, a = this.annoCtx.invertAxis ? i.globals.minY : i.globals.minX, s = this.annoCtx.invertAxis ? i.globals.maxY : i.globals.maxX, r = this.annoCtx.invertAxis ? i.globals.yRange[0] : i.globals.xRange, o = (e.x - a) / (r / i.globals.gridWidth);
                this.annoCtx.inversedReversedAxis && (o = (s - e.x) / (r / i.globals.gridWidth)), "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (o = this.getStringX(e.x));
                var n = (e.x2 - a) / (r / i.globals.gridWidth);
                return this.annoCtx.inversedReversedAxis && (n = (s - e.x2) / (r / i.globals.gridWidth)), "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || (n = this.getStringX(e.x2)), void 0 !== e.x && null !== e.x || !e.marker || (o = i.globals.gridWidth), "x1" === t && "string" == typeof e.x && e.x.indexOf("px") > -1 && (o = parseFloat(e.x)), "x2" === t && "string" == typeof e.x2 && e.x2.indexOf("px") > -1 && (n = parseFloat(e.x2)), void 0 !== e.seriesIndex && i.globals.barWidth && !this.annoCtx.invertAxis && (o = o - i.globals.barWidth / 2 * (i.globals.series.length - 1) + i.globals.barWidth * e.seriesIndex), "x1" === t ? o : n;
            }
        },
        {
            key: "getStringX",
            value: function(t) {
                var e = this.w, i = t;
                e.config.xaxis.convertedCatToNumeric && e.globals.categoryLabels.length && (t = e.globals.categoryLabels.indexOf(t) + 1);
                var a = e.globals.labels.indexOf(t), s = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(" + (a + 1) + ")");
                return s && (i = parseFloat(s.getAttribute("x"))), i;
            }
        }
    ]), t;
}(), k = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new w(this.annoCtx);
    }
    return r(t, [
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = this.helpers.getX1X2("x1", t), o = t.label.text, n = t.strokeDashArray;
                if (x.isNumber(r)) {
                    if (null === t.x2 || void 0 === t.x2) {
                        var l = this.annoCtx.graphics.drawLine(r + t.offsetX, 0 + t.offsetY, r + t.offsetX, s.globals.gridHeight + t.offsetY, t.borderColor, n, t.borderWidth);
                        e.appendChild(l.node), t.id && l.node.classList.add(t.id);
                    } else {
                        if ((a = this.helpers.getX1X2("x2", t)) < r) {
                            var h = r;
                            r = a, a = h;
                        }
                        var c = this.annoCtx.graphics.drawRect(r + t.offsetX, 0 + t.offsetY, a - r, s.globals.gridHeight + t.offsetY, 0, t.fillColor, t.opacity, 1, t.borderColor, n);
                        c.node.classList.add("apexcharts-annotation-rect"), c.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                    }
                    var d = this.annoCtx.graphics.getTextRects(o, parseFloat(t.label.style.fontSize)), g = "top" === t.label.position ? 4 : "center" === t.label.position ? s.globals.gridHeight / 2 + ("vertical" === t.label.orientation ? d.width / 2 : 0) : s.globals.gridHeight, u = this.annoCtx.graphics.drawText({
                        x: r + t.label.offsetX,
                        y: g + t.label.offsetY - ("vertical" === t.label.orientation ? "top" === t.label.position ? d.width / 2 - 12 : -d.width / 2 : 0),
                        text: o,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    u.attr({
                        rel: i
                    }), e.appendChild(u.node), this.annoCtx.helpers.setOrientations(t, i);
                }
            }
        },
        {
            key: "drawXAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-xaxis-annotations"
                });
                return e.config.annotations.xaxis.map(function(e, a) {
                    t.addXaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), A = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new w(this.annoCtx);
    }
    return r(t, [
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = t.strokeDashArray, o = this.helpers.getY1Y2("y1", t), n = t.label.text;
                if (null === t.y2 || void 0 === t.y2) {
                    var l = this.annoCtx.graphics.drawLine(0 + t.offsetX, o + t.offsetY, this._getYAxisAnnotationWidth(t), o + t.offsetY, t.borderColor, r, t.borderWidth);
                    e.appendChild(l.node), t.id && l.node.classList.add(t.id);
                } else {
                    if ((a = this.helpers.getY1Y2("y2", t)) > o) {
                        var h = o;
                        o = a, a = h;
                    }
                    var c = this.annoCtx.graphics.drawRect(0 + t.offsetX, a + t.offsetY, this._getYAxisAnnotationWidth(t), o - a, 0, t.fillColor, t.opacity, 1, t.borderColor, r);
                    c.node.classList.add("apexcharts-annotation-rect"), c.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                }
                var d = "right" === t.label.position ? s.globals.gridWidth : "center" === t.label.position ? s.globals.gridWidth / 2 : 0, g = this.annoCtx.graphics.drawText({
                    x: d + t.label.offsetX,
                    y: (null != a ? a : o) + t.label.offsetY - 3,
                    text: n,
                    textAnchor: t.label.textAnchor,
                    fontSize: t.label.style.fontSize,
                    fontFamily: t.label.style.fontFamily,
                    fontWeight: t.label.style.fontWeight,
                    foreColor: t.label.style.color,
                    cssClass: "apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                });
                g.attr({
                    rel: i
                }), e.appendChild(g.node);
            }
        },
        {
            key: "_getYAxisAnnotationWidth",
            value: function(t) {
                var e = this.w;
                e.globals.gridWidth;
                return (t.width.indexOf("%") > -1 ? e.globals.gridWidth * parseInt(t.width, 10) / 100 : parseInt(t.width, 10)) + t.offsetX;
            }
        },
        {
            key: "drawYAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-yaxis-annotations"
                });
                return e.config.annotations.yaxis.map(function(e, a) {
                    t.addYaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), S = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new w(this.annoCtx);
    }
    return r(t, [
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.w;
                var a = this.helpers.getX1X2("x1", t), s = this.helpers.getY1Y2("y1", t);
                if (x.isNumber(a)) {
                    var r = {
                        pSize: t.marker.size,
                        pointStrokeWidth: t.marker.strokeWidth,
                        pointFillColor: t.marker.fillColor,
                        pointStrokeColor: t.marker.strokeColor,
                        shape: t.marker.shape,
                        pRadius: t.marker.radius,
                        class: "apexcharts-point-annotation-marker ".concat(t.marker.cssClass, " ").concat(t.id ? t.id : "")
                    }, o = this.annoCtx.graphics.drawMarker(a + t.marker.offsetX, s + t.marker.offsetY, r);
                    e.appendChild(o.node);
                    var n = t.label.text ? t.label.text : "", l = this.annoCtx.graphics.drawText({
                        x: a + t.label.offsetX,
                        y: s + t.label.offsetY - t.marker.size - parseFloat(t.label.style.fontSize) / 1.6,
                        text: n,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-point-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    if (l.attr({
                        rel: i
                    }), e.appendChild(l.node), t.customSVG.SVG) {
                        var h = this.annoCtx.graphics.group({
                            class: "apexcharts-point-annotations-custom-svg " + t.customSVG.cssClass
                        });
                        h.attr({
                            transform: "translate(".concat(a + t.customSVG.offsetX, ", ").concat(s + t.customSVG.offsetY, ")")
                        }), h.node.innerHTML = t.customSVG.SVG, e.appendChild(h.node);
                    }
                    if (t.image.path) {
                        var c = t.image.width ? t.image.width : 20, d = t.image.height ? t.image.height : 20;
                        o = this.annoCtx.addImage({
                            x: a + t.image.offsetX - c / 2,
                            y: s + t.image.offsetY - d / 2,
                            width: c,
                            height: d,
                            path: t.image.path,
                            appendTo: ".apexcharts-point-annotations"
                        });
                    }
                    t.mouseEnter && o.node.addEventListener("mouseenter", t.mouseEnter.bind(this, t)), t.mouseLeave && o.node.addEventListener("mouseleave", t.mouseLeave.bind(this, t)), t.click && o.node.addEventListener("click", t.click.bind(this, t));
                }
            }
        },
        {
            key: "drawPointAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-point-annotations"
                });
                return e.config.annotations.points.map(function(e, a) {
                    t.addPointAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}();
var C = {
    name: "en",
    options: {
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        toolbar: {
            exportToSVG: "Download SVG",
            exportToPNG: "Download PNG",
            exportToCSV: "Download CSV",
            menu: "Menu",
            selection: "Selection",
            selectionZoom: "Selection Zoom",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out",
            pan: "Panning",
            reset: "Reset Zoom"
        }
    }
}, L = function() {
    function t() {
        a(this, t), this.yAxis = {
            show: !0,
            showAlways: !1,
            showForNullSeries: !0,
            seriesName: void 0,
            opposite: !1,
            reversed: !1,
            logarithmic: !1,
            logBase: 10,
            tickAmount: void 0,
            stepSize: void 0,
            forceNiceScale: !1,
            max: void 0,
            min: void 0,
            floating: !1,
            decimalsInFloat: void 0,
            labels: {
                show: !0,
                minWidth: 0,
                maxWidth: 160,
                offsetX: 0,
                offsetY: 0,
                align: void 0,
                rotate: 0,
                padding: 20,
                style: {
                    colors: [],
                    fontSize: "11px",
                    fontWeight: 400,
                    fontFamily: void 0,
                    cssClass: ""
                },
                formatter: void 0
            },
            axisBorder: {
                show: !1,
                color: "#e0e0e0",
                width: 1,
                offsetX: 0,
                offsetY: 0
            },
            axisTicks: {
                show: !1,
                color: "#e0e0e0",
                width: 6,
                offsetX: 0,
                offsetY: 0
            },
            title: {
                text: void 0,
                rotate: -90,
                offsetY: 0,
                offsetX: 0,
                style: {
                    color: void 0,
                    fontSize: "11px",
                    fontWeight: 900,
                    fontFamily: void 0,
                    cssClass: ""
                }
            },
            tooltip: {
                enabled: !1,
                offsetX: 0
            },
            crosshairs: {
                show: !0,
                position: "front",
                stroke: {
                    color: "#b6b6b6",
                    width: 1,
                    dashArray: 0
                }
            }
        }, this.pointAnnotation = {
            id: void 0,
            x: 0,
            y: null,
            yAxisIndex: 0,
            seriesIndex: void 0,
            mouseEnter: void 0,
            mouseLeave: void 0,
            click: void 0,
            marker: {
                size: 4,
                fillColor: "#fff",
                strokeWidth: 2,
                strokeColor: "#333",
                shape: "circle",
                offsetX: 0,
                offsetY: 0,
                radius: 2,
                cssClass: ""
            },
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            },
            customSVG: {
                SVG: void 0,
                cssClass: void 0,
                offsetX: 0,
                offsetY: 0
            },
            image: {
                path: void 0,
                width: 20,
                height: 20,
                offsetX: 0,
                offsetY: 0
            }
        }, this.yAxisAnnotation = {
            id: void 0,
            y: 0,
            y2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            width: "100%",
            yAxisIndex: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "end",
                position: "right",
                offsetX: 0,
                offsetY: -3,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.xAxisAnnotation = {
            id: void 0,
            x: 0,
            x2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                orientation: "vertical",
                position: "top",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.text = {
            x: 0,
            y: 0,
            text: "",
            textAnchor: "start",
            foreColor: void 0,
            fontSize: "13px",
            fontFamily: void 0,
            fontWeight: 400,
            appendTo: ".apexcharts-annotations",
            backgroundColor: "transparent",
            borderColor: "#c2c2c2",
            borderRadius: 0,
            borderWidth: 0,
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 2,
            paddingBottom: 2
        };
    }
    return r(t, [
        {
            key: "init",
            value: function() {
                return {
                    annotations: {
                        yaxis: [
                            this.yAxisAnnotation
                        ],
                        xaxis: [
                            this.xAxisAnnotation
                        ],
                        points: [
                            this.pointAnnotation
                        ],
                        texts: [],
                        images: [],
                        shapes: []
                    },
                    chart: {
                        animations: {
                            enabled: !0,
                            easing: "easeinout",
                            speed: 800,
                            animateGradually: {
                                delay: 150,
                                enabled: !0
                            },
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 350
                            }
                        },
                        background: "transparent",
                        locales: [
                            C
                        ],
                        defaultLocale: "en",
                        dropShadow: {
                            enabled: !1,
                            enabledOnSeries: void 0,
                            top: 2,
                            left: 2,
                            blur: 4,
                            color: "#000",
                            opacity: .35
                        },
                        events: {
                            animationEnd: void 0,
                            beforeMount: void 0,
                            mounted: void 0,
                            updated: void 0,
                            click: void 0,
                            mouseMove: void 0,
                            mouseLeave: void 0,
                            xAxisLabelClick: void 0,
                            legendClick: void 0,
                            markerClick: void 0,
                            selection: void 0,
                            dataPointSelection: void 0,
                            dataPointMouseEnter: void 0,
                            dataPointMouseLeave: void 0,
                            beforeZoom: void 0,
                            beforeResetZoom: void 0,
                            zoomed: void 0,
                            scrolled: void 0,
                            brushScrolled: void 0
                        },
                        foreColor: "#373d3f",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        height: "auto",
                        parentHeightOffset: 15,
                        redrawOnParentResize: !0,
                        redrawOnWindowResize: !0,
                        id: void 0,
                        group: void 0,
                        nonce: void 0,
                        offsetX: 0,
                        offsetY: 0,
                        selection: {
                            enabled: !1,
                            type: "x",
                            fill: {
                                color: "#24292e",
                                opacity: .1
                            },
                            stroke: {
                                width: 1,
                                color: "#24292e",
                                opacity: .4,
                                dashArray: 3
                            },
                            xaxis: {
                                min: void 0,
                                max: void 0
                            },
                            yaxis: {
                                min: void 0,
                                max: void 0
                            }
                        },
                        sparkline: {
                            enabled: !1
                        },
                        brush: {
                            enabled: !1,
                            autoScaleYaxis: !0,
                            target: void 0,
                            targets: void 0
                        },
                        stacked: !1,
                        stackOnlyBar: !0,
                        stackType: "normal",
                        toolbar: {
                            show: !0,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: !0,
                                selection: !0,
                                zoom: !0,
                                zoomin: !0,
                                zoomout: !0,
                                pan: !0,
                                reset: !0,
                                customIcons: []
                            },
                            export: {
                                csv: {
                                    filename: void 0,
                                    columnDelimiter: ",",
                                    headerCategory: "category",
                                    headerValue: "value",
                                    dateFormatter: function(t) {
                                        return new Date(t).toDateString();
                                    }
                                },
                                png: {
                                    filename: void 0
                                },
                                svg: {
                                    filename: void 0
                                }
                            },
                            autoSelected: "zoom"
                        },
                        type: "line",
                        width: "100%",
                        zoom: {
                            enabled: !0,
                            type: "x",
                            autoScaleYaxis: !1,
                            zoomedArea: {
                                fill: {
                                    color: "#90CAF9",
                                    opacity: .4
                                },
                                stroke: {
                                    color: "#0D47A1",
                                    opacity: .4,
                                    width: 1
                                }
                            }
                        }
                    },
                    plotOptions: {
                        area: {
                            fillTo: "origin"
                        },
                        bar: {
                            horizontal: !1,
                            columnWidth: "70%",
                            barHeight: "70%",
                            distributed: !1,
                            borderRadius: 0,
                            borderRadiusApplication: "around",
                            borderRadiusWhenStacked: "last",
                            rangeBarOverlap: !0,
                            rangeBarGroupRows: !1,
                            hideZeroBarsWhenGrouped: !1,
                            isDumbbell: !1,
                            dumbbellColors: void 0,
                            isFunnel: !1,
                            isFunnel3d: !0,
                            colors: {
                                ranges: [],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                                backgroundBarRadius: 0
                            },
                            dataLabels: {
                                position: "top",
                                maxItems: 100,
                                hideOverflowingLabels: !0,
                                orientation: "horizontal",
                                total: {
                                    enabled: !1,
                                    formatter: void 0,
                                    offsetX: 0,
                                    offsetY: 0,
                                    style: {
                                        color: "#373d3f",
                                        fontSize: "12px",
                                        fontFamily: void 0,
                                        fontWeight: 600
                                    }
                                }
                            }
                        },
                        bubble: {
                            zScaling: !0,
                            minBubbleRadius: void 0,
                            maxBubbleRadius: void 0
                        },
                        candlestick: {
                            colors: {
                                upward: "#00B746",
                                downward: "#EF403C"
                            },
                            wick: {
                                useFillColor: !0
                            }
                        },
                        boxPlot: {
                            colors: {
                                upper: "#00E396",
                                lower: "#008FFB"
                            }
                        },
                        heatmap: {
                            radius: 2,
                            enableShades: !0,
                            shadeIntensity: .5,
                            reverseNegativeShade: !1,
                            distributed: !1,
                            useFillColorAsStroke: !1,
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        treemap: {
                            enableShades: !0,
                            shadeIntensity: .5,
                            distributed: !1,
                            reverseNegativeShade: !1,
                            useFillColorAsStroke: !1,
                            dataLabels: {
                                format: "scale"
                            },
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        radialBar: {
                            inverseOrder: !1,
                            startAngle: 0,
                            endAngle: 360,
                            offsetX: 0,
                            offsetY: 0,
                            hollow: {
                                margin: 5,
                                size: "50%",
                                background: "transparent",
                                image: void 0,
                                imageWidth: 150,
                                imageHeight: 150,
                                imageOffsetX: 0,
                                imageOffsetY: 0,
                                imageClipped: !0,
                                position: "front",
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            track: {
                                show: !0,
                                startAngle: void 0,
                                endAngle: void 0,
                                background: "#f2f2f2",
                                strokeWidth: "97%",
                                opacity: 1,
                                margin: 5,
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            dataLabels: {
                                show: !0,
                                name: {
                                    show: !0,
                                    fontSize: "16px",
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    color: void 0,
                                    offsetY: 0,
                                    formatter: function(t) {
                                        return t;
                                    }
                                },
                                value: {
                                    show: !0,
                                    fontSize: "14px",
                                    fontFamily: void 0,
                                    fontWeight: 400,
                                    color: void 0,
                                    offsetY: 16,
                                    formatter: function(t) {
                                        return t + "%";
                                    }
                                },
                                total: {
                                    show: !1,
                                    label: "Total",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    fontFamily: void 0,
                                    color: void 0,
                                    formatter: function(t) {
                                        return t.globals.seriesTotals.reduce(function(t, e) {
                                            return t + e;
                                        }, 0) / t.globals.series.length + "%";
                                    }
                                }
                            },
                            barLabels: {
                                enabled: !1,
                                margin: 5,
                                useSeriesColors: !0,
                                fontFamily: void 0,
                                fontWeight: 600,
                                fontSize: "16px",
                                formatter: function(t) {
                                    return t;
                                },
                                onClick: void 0
                            }
                        },
                        pie: {
                            customScale: 1,
                            offsetX: 0,
                            offsetY: 0,
                            startAngle: 0,
                            endAngle: 360,
                            expandOnClick: !0,
                            dataLabels: {
                                offset: 0,
                                minAngleToShowLabel: 10
                            },
                            donut: {
                                size: "65%",
                                background: "transparent",
                                labels: {
                                    show: !1,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: -10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "20px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        showAlways: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 400,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(t) {
                                            return t.globals.seriesTotals.reduce(function(t, e) {
                                                return t + e;
                                            }, 0);
                                        }
                                    }
                                }
                            }
                        },
                        polarArea: {
                            rings: {
                                strokeWidth: 1,
                                strokeColor: "#e8e8e8"
                            },
                            spokes: {
                                strokeWidth: 1,
                                connectorColors: "#e8e8e8"
                            }
                        },
                        radar: {
                            size: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            polygons: {
                                strokeWidth: 1,
                                strokeColors: "#e8e8e8",
                                connectorColors: "#e8e8e8",
                                fill: {
                                    colors: void 0
                                }
                            }
                        }
                    },
                    colors: void 0,
                    dataLabels: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        formatter: function(t) {
                            return null !== t ? t : "";
                        },
                        textAnchor: "middle",
                        distributed: !1,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 600,
                            colors: void 0
                        },
                        background: {
                            enabled: !0,
                            foreColor: "#fff",
                            borderRadius: 2,
                            padding: 4,
                            opacity: .9,
                            borderWidth: 1,
                            borderColor: "#fff",
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: .45
                            }
                        },
                        dropShadow: {
                            enabled: !1,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: "#000",
                            opacity: .45
                        }
                    },
                    fill: {
                        type: "solid",
                        colors: void 0,
                        opacity: .85,
                        gradient: {
                            shade: "dark",
                            type: "horizontal",
                            shadeIntensity: .5,
                            gradientToColors: void 0,
                            inverseColors: !0,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                0,
                                50,
                                100
                            ],
                            colorStops: []
                        },
                        image: {
                            src: [],
                            width: void 0,
                            height: void 0
                        },
                        pattern: {
                            style: "squares",
                            width: 6,
                            height: 6,
                            strokeWidth: 2
                        }
                    },
                    forecastDataPoints: {
                        count: 0,
                        fillOpacity: .5,
                        strokeWidth: void 0,
                        dashArray: 4
                    },
                    grid: {
                        show: !0,
                        borderColor: "#e0e0e0",
                        strokeDashArray: 0,
                        position: "back",
                        xaxis: {
                            lines: {
                                show: !1
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        row: {
                            colors: void 0,
                            opacity: .5
                        },
                        column: {
                            colors: void 0,
                            opacity: .5
                        },
                        padding: {
                            top: 0,
                            right: 10,
                            bottom: 0,
                            left: 12
                        }
                    },
                    labels: [],
                    legend: {
                        show: !0,
                        showForSingleSeries: !1,
                        showForNullSeries: !0,
                        showForZeroSeries: !0,
                        floating: !1,
                        position: "bottom",
                        horizontalAlign: "center",
                        inverseOrder: !1,
                        fontSize: "12px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        width: void 0,
                        height: void 0,
                        formatter: void 0,
                        tooltipHoverFormatter: void 0,
                        offsetX: -20,
                        offsetY: 4,
                        customLegendItems: [],
                        labels: {
                            colors: void 0,
                            useSeriesColors: !1
                        },
                        markers: {
                            width: 12,
                            height: 12,
                            strokeWidth: 0,
                            fillColors: void 0,
                            strokeColor: "#fff",
                            radius: 12,
                            customHTML: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            onClick: void 0
                        },
                        itemMargin: {
                            horizontal: 5,
                            vertical: 2
                        },
                        onItemClick: {
                            toggleDataSeries: !0
                        },
                        onItemHover: {
                            highlightDataSeries: !0
                        }
                    },
                    markers: {
                        discrete: [],
                        size: 0,
                        colors: void 0,
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        strokeOpacity: .9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        shape: "circle",
                        width: 8,
                        height: 8,
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: void 0,
                        onDblClick: void 0,
                        showNullDataPoints: !0,
                        hover: {
                            size: void 0,
                            sizeOffset: 3
                        }
                    },
                    noData: {
                        text: void 0,
                        align: "center",
                        verticalAlign: "middle",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: void 0,
                            fontSize: "14px",
                            fontFamily: void 0
                        }
                    },
                    responsive: [],
                    series: void 0,
                    states: {
                        normal: {
                            filter: {
                                type: "none",
                                value: 0
                            }
                        },
                        hover: {
                            filter: {
                                type: "lighten",
                                value: .1
                            }
                        },
                        active: {
                            allowMultipleDataPointsSelection: !1,
                            filter: {
                                type: "darken",
                                value: .5
                            }
                        }
                    },
                    title: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: !1,
                        style: {
                            fontSize: "14px",
                            fontWeight: 900,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    subtitle: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 30,
                        floating: !1,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    stroke: {
                        show: !0,
                        curve: "smooth",
                        lineCap: "butt",
                        width: 2,
                        colors: void 0,
                        dashArray: 0,
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: .85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: .5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    0,
                                    50,
                                    100
                                ],
                                colorStops: []
                            }
                        }
                    },
                    tooltip: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        shared: !0,
                        hideEmptySeries: !0,
                        followCursor: !1,
                        intersect: !1,
                        inverseOrder: !1,
                        custom: void 0,
                        fillSeriesColor: !1,
                        theme: "light",
                        cssClass: "",
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0
                        },
                        onDatasetHover: {
                            highlightDataSeries: !1
                        },
                        x: {
                            show: !0,
                            format: "dd MMM",
                            formatter: void 0
                        },
                        y: {
                            formatter: void 0,
                            title: {
                                formatter: function(t) {
                                    return t ? t + ": " : "";
                                }
                            }
                        },
                        z: {
                            formatter: void 0,
                            title: "Size: "
                        },
                        marker: {
                            show: !0,
                            fillColors: void 0
                        },
                        items: {
                            display: "flex"
                        },
                        fixed: {
                            enabled: !1,
                            position: "topRight",
                            offsetX: 0,
                            offsetY: 0
                        }
                    },
                    xaxis: {
                        type: "category",
                        categories: [],
                        convertedCatToNumeric: !1,
                        offsetX: 0,
                        offsetY: 0,
                        overwriteCategories: void 0,
                        labels: {
                            show: !0,
                            rotate: -45,
                            rotateAlways: !1,
                            hideOverlappingLabels: !0,
                            trim: !1,
                            minHeight: void 0,
                            maxHeight: 120,
                            showDuplicates: !0,
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            },
                            offsetX: 0,
                            offsetY: 0,
                            format: void 0,
                            formatter: void 0,
                            datetimeUTC: !0,
                            datetimeFormatter: {
                                year: "yyyy",
                                month: "MMM 'yy",
                                day: "dd MMM",
                                hour: "HH:mm",
                                minute: "HH:mm:ss",
                                second: "HH:mm:ss"
                            }
                        },
                        group: {
                            groups: [],
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        axisBorder: {
                            show: !0,
                            color: "#e0e0e0",
                            width: "100%",
                            height: 1,
                            offsetX: 0,
                            offsetY: 0
                        },
                        axisTicks: {
                            show: !0,
                            color: "#e0e0e0",
                            height: 6,
                            offsetX: 0,
                            offsetY: 0
                        },
                        stepSize: void 0,
                        tickAmount: void 0,
                        tickPlacement: "on",
                        min: void 0,
                        max: void 0,
                        range: void 0,
                        floating: !1,
                        decimalsInFloat: void 0,
                        position: "bottom",
                        title: {
                            text: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "12px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        crosshairs: {
                            show: !0,
                            width: 1,
                            position: "back",
                            opacity: .9,
                            stroke: {
                                color: "#b6b6b6",
                                width: 1,
                                dashArray: 3
                            },
                            fill: {
                                type: "solid",
                                color: "#B1B9C4",
                                gradient: {
                                    colorFrom: "#D8E3F0",
                                    colorTo: "#BED1E6",
                                    stops: [
                                        0,
                                        100
                                    ],
                                    opacityFrom: .4,
                                    opacityTo: .5
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                left: 0,
                                top: 0,
                                blur: 1,
                                opacity: .4
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            offsetY: 0,
                            formatter: void 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            }
                        }
                    },
                    yaxis: this.yAxis,
                    theme: {
                        mode: "light",
                        palette: "palette1",
                        monochrome: {
                            enabled: !1,
                            color: "#008FFB",
                            shadeTo: "light",
                            shadeIntensity: .65
                        }
                    }
                };
            }
        }
    ]), t;
}(), P = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.graphics = new m(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new w(this), this.xAxisAnnotations = new k(this), this.yAxisAnnotations = new A(this), this.pointsAnnotations = new S(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
    }
    return r(t, [
        {
            key: "drawAxesAnnotations",
            value: function() {
                var t = this.w;
                if (t.globals.axisCharts) {
                    for(var e = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = t.config.chart.animations.enabled, r = [
                        e,
                        i,
                        a
                    ], o = [
                        i.node,
                        e.node,
                        a.node
                    ], n = 0; n < 3; n++)t.globals.dom.elGraphical.add(r[n]), !s || t.globals.resized || t.globals.dataChanged || "scatter" !== t.config.chart.type && "bubble" !== t.config.chart.type && t.globals.dataPoints > 1 && o[n].classList.add("apexcharts-element-hidden"), t.globals.delayedElements.push({
                        el: o[n],
                        index: 0
                    });
                    this.helpers.annotationsBackground();
                }
            }
        },
        {
            key: "drawImageAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.images.map(function(e, i) {
                    t.addImage(e, i);
                });
            }
        },
        {
            key: "drawTextAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.texts.map(function(e, i) {
                    t.addText(e, i);
                });
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                this.xAxisAnnotations.addXaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                this.yAxisAnnotations.addYaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.pointsAnnotations.addPointAnnotation(t, e, i);
            }
        },
        {
            key: "addText",
            value: function(t, e) {
                var i = t.x, a = t.y, s = t.text, r = t.textAnchor, o = t.foreColor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.cssClass, d = t.backgroundColor, g = t.borderWidth, u = t.strokeDashArray, p = t.borderRadius, f = t.borderColor, x = t.appendTo, b = void 0 === x ? ".apexcharts-svg" : x, v = t.paddingLeft, m = void 0 === v ? 4 : v, y = t.paddingRight, w = void 0 === y ? 4 : y, k = t.paddingBottom, A = void 0 === k ? 2 : k, S = t.paddingTop, C = void 0 === S ? 2 : S, L = this.w, P = this.graphics.drawText({
                    x: i,
                    y: a,
                    text: s,
                    textAnchor: r || "start",
                    fontSize: n || "12px",
                    fontWeight: h || "regular",
                    fontFamily: l || L.config.chart.fontFamily,
                    foreColor: o || L.config.chart.foreColor,
                    cssClass: c
                }), I = L.globals.dom.baseEl.querySelector(b);
                I && I.appendChild(P.node);
                var T = P.bbox();
                if (s) {
                    var M = this.graphics.drawRect(T.x - m, T.y - C, T.width + m + w, T.height + A + C, p, d || "transparent", 1, g, f, u);
                    I.insertBefore(M.node, P.node);
                }
            }
        },
        {
            key: "addImage",
            value: function(t, e) {
                var i = this.w, a = t.path, s = t.x, r = void 0 === s ? 0 : s, o = t.y, n = void 0 === o ? 0 : o, l = t.width, h = void 0 === l ? 20 : l, c = t.height, d = void 0 === c ? 20 : c, g = t.appendTo, u = void 0 === g ? ".apexcharts-svg" : g, p = i.globals.dom.Paper.image(a);
                p.size(h, d).move(r, n);
                var f = i.globals.dom.baseEl.querySelector(u);
                return f && f.appendChild(p.node), p;
            }
        },
        {
            key: "addXaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "xaxis",
                    contextMethod: i.addXaxisAnnotation
                }), i;
            }
        },
        {
            key: "addYaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "yaxis",
                    contextMethod: i.addYaxisAnnotation
                }), i;
            }
        },
        {
            key: "addPointAnnotationExternal",
            value: function(t, e, i) {
                return void 0 === this.invertAxis && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "point",
                    contextMethod: i.addPointAnnotation
                }), i;
            }
        },
        {
            key: "addAnnotationExternal",
            value: function(t) {
                var e = t.params, i = t.pushToMemory, a = t.context, s = t.type, r = t.contextMethod, o = a, n = o.w, l = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), h = l.childNodes.length + 1, c = new L, d = Object.assign({}, "xaxis" === s ? c.xAxisAnnotation : "yaxis" === s ? c.yAxisAnnotation : c.pointAnnotation), g = x.extend(d, e);
                switch(s){
                    case "xaxis":
                        this.addXaxisAnnotation(g, l, h);
                        break;
                    case "yaxis":
                        this.addYaxisAnnotation(g, l, h);
                        break;
                    case "point":
                        this.addPointAnnotation(g, l, h);
                }
                var u = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(h, "']")), p = this.helpers.addBackgroundToAnno(u, g);
                return p && l.insertBefore(p.node, u), i && n.globals.memory.methodsToExec.push({
                    context: o,
                    id: g.id ? g.id : x.randomId(),
                    method: r,
                    label: "addAnnotation",
                    params: e
                }), a;
            }
        },
        {
            key: "clearAnnotations",
            value: function(t) {
                var e = t.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");
                e.globals.memory.methodsToExec.map(function(t, i) {
                    "addText" !== t.label && "addAnnotation" !== t.label || e.globals.memory.methodsToExec.splice(i, 1);
                }), i = x.listToArray(i), Array.prototype.forEach.call(i, function(t) {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                });
            }
        },
        {
            key: "removeAnnotation",
            value: function(t, e) {
                var i = t.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(e));
                a && (i.globals.memory.methodsToExec.map(function(t, a) {
                    t.id === e && i.globals.memory.methodsToExec.splice(a, 1);
                }), Array.prototype.forEach.call(a, function(t) {
                    t.parentElement.removeChild(t);
                }));
            }
        }
    ]), t;
}(), I = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.months31 = [
            1,
            3,
            5,
            7,
            8,
            10,
            12
        ], this.months30 = [
            2,
            4,
            6,
            9,
            11
        ], this.daysCntOfYear = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
    }
    return r(t, [
        {
            key: "isValidDate",
            value: function(t) {
                return "number" != typeof t && !isNaN(this.parseDate(t));
            }
        },
        {
            key: "getTimeStamp",
            value: function(t) {
                return Date.parse(t) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toISOString().substr(0, 25)).getTime() : new Date(t).getTime() : t;
            }
        },
        {
            key: "getDate",
            value: function(t) {
                return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toUTCString()) : new Date(t);
            }
        },
        {
            key: "parseDate",
            value: function(t) {
                var e = Date.parse(t);
                if (!isNaN(e)) return this.getTimeStamp(t);
                var i = Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                return i = this.getTimeStamp(i);
            }
        },
        {
            key: "parseDateWithTimezone",
            value: function(t) {
                return Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
            }
        },
        {
            key: "formatDate",
            value: function(t, e) {
                var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                    "\x00"
                ].concat(u(i.months)), r = [
                    "\x01"
                ].concat(u(i.shortMonths)), o = [
                    "\x02"
                ].concat(u(i.days)), n = [
                    "\x03"
                ].concat(u(i.shortDays));
                function l(t, e) {
                    var i = t + "";
                    for(e = e || 2; i.length < e;)i = "0" + i;
                    return i;
                }
                var h = a ? t.getUTCFullYear() : t.getFullYear();
                e = (e = (e = e.replace(/(^|[^\\])yyyy+/g, "$1" + h)).replace(/(^|[^\\])yy/g, "$1" + h.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + h);
                var c = (a ? t.getUTCMonth() : t.getMonth()) + 1;
                e = (e = (e = (e = e.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + l(c))).replace(/(^|[^\\])M/g, "$1" + c);
                var d = a ? t.getUTCDate() : t.getDate();
                e = (e = (e = (e = e.replace(/(^|[^\\])dddd+/g, "$1" + o[0])).replace(/(^|[^\\])ddd/g, "$1" + n[0])).replace(/(^|[^\\])dd/g, "$1" + l(d))).replace(/(^|[^\\])d/g, "$1" + d);
                var g = a ? t.getUTCHours() : t.getHours(), p = g > 12 ? g - 12 : 0 === g ? 12 : g;
                e = (e = (e = (e = e.replace(/(^|[^\\])HH+/g, "$1" + l(g))).replace(/(^|[^\\])H/g, "$1" + g)).replace(/(^|[^\\])hh+/g, "$1" + l(p))).replace(/(^|[^\\])h/g, "$1" + p);
                var f = a ? t.getUTCMinutes() : t.getMinutes();
                e = (e = e.replace(/(^|[^\\])mm+/g, "$1" + l(f))).replace(/(^|[^\\])m/g, "$1" + f);
                var x = a ? t.getUTCSeconds() : t.getSeconds();
                e = (e = e.replace(/(^|[^\\])ss+/g, "$1" + l(x))).replace(/(^|[^\\])s/g, "$1" + x);
                var b = a ? t.getUTCMilliseconds() : t.getMilliseconds();
                e = e.replace(/(^|[^\\])fff+/g, "$1" + l(b, 3)), b = Math.round(b / 10), e = e.replace(/(^|[^\\])ff/g, "$1" + l(b)), b = Math.round(b / 10);
                var v = g < 12 ? "AM" : "PM";
                e = (e = (e = e.replace(/(^|[^\\])f/g, "$1" + b)).replace(/(^|[^\\])TT+/g, "$1" + v)).replace(/(^|[^\\])T/g, "$1" + v.charAt(0));
                var m = v.toLowerCase();
                e = (e = e.replace(/(^|[^\\])tt+/g, "$1" + m)).replace(/(^|[^\\])t/g, "$1" + m.charAt(0));
                var y = -t.getTimezoneOffset(), w = a || !y ? "Z" : y > 0 ? "+" : "-";
                if (!a) {
                    var k = (y = Math.abs(y)) % 60;
                    w += l(Math.floor(y / 60)) + ":" + l(k);
                }
                e = e.replace(/(^|[^\\])K/g, "$1" + w);
                var A = (a ? t.getUTCDay() : t.getDay()) + 1;
                return e = (e = (e = (e = (e = e.replace(new RegExp(o[0], "g"), o[A])).replace(new RegExp(n[0], "g"), n[A])).replace(new RegExp(s[0], "g"), s[c])).replace(new RegExp(r[0], "g"), r[c])).replace(/\\(.)/g, "$1");
            }
        },
        {
            key: "getTimeUnitsfromTimestamp",
            value: function(t, e, i) {
                var a = this.w;
                void 0 !== a.config.xaxis.min && (t = a.config.xaxis.min), void 0 !== a.config.xaxis.max && (e = a.config.xaxis.max);
                var s = this.getDate(t), r = this.getDate(e), o = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), n = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                return {
                    minMillisecond: parseInt(o[6], 10),
                    maxMillisecond: parseInt(n[6], 10),
                    minSecond: parseInt(o[5], 10),
                    maxSecond: parseInt(n[5], 10),
                    minMinute: parseInt(o[4], 10),
                    maxMinute: parseInt(n[4], 10),
                    minHour: parseInt(o[3], 10),
                    maxHour: parseInt(n[3], 10),
                    minDate: parseInt(o[2], 10),
                    maxDate: parseInt(n[2], 10),
                    minMonth: parseInt(o[1], 10) - 1,
                    maxMonth: parseInt(n[1], 10) - 1,
                    minYear: parseInt(o[0], 10),
                    maxYear: parseInt(n[0], 10)
                };
            }
        },
        {
            key: "isLeapYear",
            value: function(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
            }
        },
        {
            key: "calculcateLastDaysOfMonth",
            value: function(t, e, i) {
                return this.determineDaysOfMonths(t, e) - i;
            }
        },
        {
            key: "determineDaysOfYear",
            value: function(t) {
                var e = 365;
                return this.isLeapYear(t) && (e = 366), e;
            }
        },
        {
            key: "determineRemainingDaysOfYear",
            value: function(t, e, i) {
                var a = this.daysCntOfYear[e] + i;
                return e > 1 && this.isLeapYear() && a++, a;
            }
        },
        {
            key: "determineDaysOfMonths",
            value: function(t, e) {
                var i = 30;
                switch(t = x.monthMod(t), !0){
                    case this.months30.indexOf(t) > -1:
                        2 === t && (i = this.isLeapYear(e) ? 29 : 28);
                        break;
                    case this.months31.indexOf(t) > -1:
                    default:
                        i = 31;
                }
                return i;
            }
        }
    ]), t;
}(), T = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
    }
    return r(t, [
        {
            key: "xLabelFormat",
            value: function(t, e, i, a) {
                var s = this.w;
                if ("datetime" === s.config.xaxis.type && void 0 === s.config.xaxis.labels.formatter && void 0 === s.config.tooltip.x.formatter) {
                    var r = new I(this.ctx);
                    return r.formatDate(r.getDate(e), s.config.tooltip.x.format);
                }
                return t(e, i, a);
            }
        },
        {
            key: "defaultGeneralFormatter",
            value: function(t) {
                return Array.isArray(t) ? t.map(function(t) {
                    return t;
                }) : t;
            }
        },
        {
            key: "defaultYFormatter",
            value: function(t, e, i) {
                var a = this.w;
                return x.isNumber(t) && (t = 0 !== a.globals.yValueDecimal ? t.toFixed(void 0 !== e.decimalsInFloat ? e.decimalsInFloat : a.globals.yValueDecimal) : a.globals.maxYArr[i] - a.globals.minYArr[i] < 5 ? t.toFixed(1) : t.toFixed(0)), t;
            }
        },
        {
            key: "setLabelFormatters",
            value: function() {
                var t = this, e = this.w;
                return e.globals.xaxisTooltipFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttKeyFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttZFormatter = function(t) {
                    return t;
                }, e.globals.legendFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, void 0 !== e.config.xaxis.labels.formatter ? e.globals.xLabelFormatter = e.config.xaxis.labels.formatter : e.globals.xLabelFormatter = function(t) {
                    if (x.isNumber(t)) {
                        if (!e.config.xaxis.convertedCatToNumeric && "numeric" === e.config.xaxis.type) {
                            if (x.isNumber(e.config.xaxis.decimalsInFloat)) return t.toFixed(e.config.xaxis.decimalsInFloat);
                            var i = e.globals.maxX - e.globals.minX;
                            return i > 0 && i < 100 ? t.toFixed(1) : t.toFixed(0);
                        }
                        if (e.globals.isBarHorizontal) {
                            if (e.globals.maxY - e.globals.minYArr < 4) return t.toFixed(1);
                        }
                        return t.toFixed(0);
                    }
                    return t;
                }, "function" == typeof e.config.tooltip.x.formatter ? e.globals.ttKeyFormatter = e.config.tooltip.x.formatter : e.globals.ttKeyFormatter = e.globals.xLabelFormatter, "function" == typeof e.config.xaxis.tooltip.formatter && (e.globals.xaxisTooltipFormatter = e.config.xaxis.tooltip.formatter), (Array.isArray(e.config.tooltip.y) || void 0 !== e.config.tooltip.y.formatter) && (e.globals.ttVal = e.config.tooltip.y), void 0 !== e.config.tooltip.z.formatter && (e.globals.ttZFormatter = e.config.tooltip.z.formatter), void 0 !== e.config.legend.formatter && (e.globals.legendFormatter = e.config.legend.formatter), e.config.yaxis.forEach(function(i, a) {
                    void 0 !== i.labels.formatter ? e.globals.yLabelFormatters[a] = i.labels.formatter : e.globals.yLabelFormatters[a] = function(s) {
                        return e.globals.xyCharts ? Array.isArray(s) ? s.map(function(e) {
                            return t.defaultYFormatter(e, i, a);
                        }) : t.defaultYFormatter(s, i, a) : s;
                    };
                }), e.globals;
            }
        },
        {
            key: "heatmapLabelFormatters",
            value: function() {
                var t = this.w;
                if ("heatmap" === t.config.chart.type) {
                    t.globals.yAxisScale[0].result = t.globals.seriesNames.slice();
                    var e = t.globals.seriesNames.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0);
                    t.globals.yAxisScale[0].niceMax = e, t.globals.yAxisScale[0].niceMin = e;
                }
            }
        }
    ]), t;
}(), M = function(t) {
    var e, i = t.isTimeline, a = t.ctx, s = t.seriesIndex, r = t.dataPointIndex, o = t.y1, n = t.y2, l = t.w, h = l.globals.seriesRangeStart[s][r], c = l.globals.seriesRangeEnd[s][r], d = l.globals.labels[r], g = l.config.series[s].name ? l.config.series[s].name : "", u = l.globals.ttKeyFormatter, p = l.config.tooltip.y.title.formatter, f = {
        w: l,
        seriesIndex: s,
        dataPointIndex: r,
        start: h,
        end: c
    };
    ("function" == typeof p && (g = p(g, f)), null !== (e = l.config.series[s].data[r]) && void 0 !== e && e.x && (d = l.config.series[s].data[r].x), i) || "datetime" === l.config.xaxis.type && (d = new T(a).xLabelFormat(l.globals.ttKeyFormatter, d, d, {
        i: void 0,
        dateFormatter: new I(a).formatDate,
        w: l
    }));
    "function" == typeof u && (d = u(d, f)), Number.isFinite(o) && Number.isFinite(n) && (h = o, c = n);
    var x = "", b = "", v = l.globals.colors[s];
    if (void 0 === l.config.tooltip.x.formatter) {
        if ("datetime" === l.config.xaxis.type) {
            var m = new I(a);
            x = m.formatDate(m.getDate(h), l.config.tooltip.x.format), b = m.formatDate(m.getDate(c), l.config.tooltip.x.format);
        } else x = h, b = c;
    } else x = l.config.tooltip.x.formatter(h), b = l.config.tooltip.x.formatter(c);
    return {
        start: h,
        end: c,
        startVal: x,
        endVal: b,
        ylabel: d,
        color: v,
        seriesName: g
    };
}, z = function(t) {
    var e = t.color, i = t.seriesName, a = t.ylabel, s = t.start, r = t.end, o = t.seriesIndex, n = t.dataPointIndex, l = t.ctx.tooltip.tooltipLabels.getFormatters(o);
    s = l.yLbFormatter(s), r = l.yLbFormatter(r);
    var h = l.yLbFormatter(t.w.globals.series[o][n]), c = '<span class="value start-value">\n  '.concat(s, '\n  </span> <span class="separator">-</span> <span class="value end-value">\n  ').concat(r, "\n  </span>");
    return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (i || "") + '</span></div><div> <span class="category">' + a + ": </span> " + (t.w.globals.comboCharts ? "rangeArea" === t.w.config.series[o].type || "rangeBar" === t.w.config.series[o].type ? c : "<span>".concat(h, "</span>") : c) + " </div></div>";
}, X = function() {
    function t(e) {
        a(this, t), this.opts = e;
    }
    return r(t, [
        {
            key: "hideYAxis",
            value: function() {
                this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
            }
        },
        {
            key: "line",
            value: function() {
                return {
                    chart: {
                        animations: {
                            easing: "swing"
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "sparkline",
            value: function(t) {
                this.hideYAxis();
                return x.extend(t, {
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    legend: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    },
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    }
                });
            }
        },
        {
            key: "bar",
            value: function() {
                return {
                    chart: {
                        stacked: !1,
                        animations: {
                            easing: "swing"
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "round"
                    },
                    fill: {
                        opacity: .85
                    },
                    legend: {
                        markers: {
                            shape: "square",
                            radius: 2,
                            size: 8
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        },
                        tickPlacement: "between",
                        crosshairs: {
                            width: "barWidth",
                            position: "back",
                            fill: {
                                type: "gradient"
                            },
                            dropShadow: {
                                enabled: !1
                            },
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "funnel",
            value: function() {
                return this.hideYAxis(), e(e({}, this.bar()), {}, {
                    chart: {
                        animations: {
                            easing: "linear",
                            speed: 800,
                            animateGradually: {
                                enabled: !1
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: !0,
                            borderRadiusApplication: "around",
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    }
                });
            }
        },
        {
            key: "candlestick",
            value: function() {
                var t = this;
                return {
                    stroke: {
                        width: 1,
                        colors: [
                            "#333"
                        ]
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Open",
                                "High",
                                "",
                                "Low",
                                "Close"
                            ], "candlestick");
                        }
                    },
                    states: {
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "boxPlot",
            value: function() {
                var t = this;
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !1
                            }
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: [
                            "#24292e"
                        ]
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Minimum",
                                "Q1",
                                "Median",
                                "Q3",
                                "Maximum"
                            ], "boxPlot");
                        }
                    },
                    markers: {
                        size: 5,
                        strokeWidth: 1,
                        strokeColors: "#111"
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "rangeBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            animateGradually: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "square"
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        enabled: !1,
                        formatter: function(t, e) {
                            e.ctx;
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w, r = function() {
                                var t = s.globals.seriesRangeStart[i][a];
                                return s.globals.seriesRangeEnd[i][a] - t;
                            };
                            return s.globals.comboCharts ? "rangeBar" === s.config.series[i].type || "rangeArea" === s.config.series[i].type ? r() : t : r();
                        },
                        background: {
                            enabled: !1
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    markers: {
                        size: 10
                    },
                    tooltip: {
                        shared: !1,
                        followCursor: !0,
                        custom: function(t) {
                            return t.w.config.plotOptions && t.w.config.plotOptions.bar && t.w.config.plotOptions.bar.horizontal ? function(t) {
                                var i = M(e(e({}, t), {}, {
                                    isTimeline: !0
                                })), a = i.color, s = i.seriesName, r = i.ylabel, o = i.startVal, n = i.endVal;
                                return z(e(e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t) : function(t) {
                                var i = M(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.start, n = i.end;
                                return z(e(e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t);
                        }
                    },
                    xaxis: {
                        tickPlacement: "between",
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "dumbbell",
            value: function(t) {
                var e, i;
                return null !== (e = t.plotOptions.bar) && void 0 !== e && e.barHeight || (t.plotOptions.bar.barHeight = 2), null !== (i = t.plotOptions.bar) && void 0 !== i && i.columnWidth || (t.plotOptions.bar.columnWidth = 2), t;
            }
        },
        {
            key: "area",
            value: function() {
                return {
                    stroke: {
                        width: 4,
                        fill: {
                            type: "solid",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: .65,
                                opacityTo: .5,
                                stops: [
                                    0,
                                    100,
                                    100
                                ]
                            }
                        }
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            inverseColors: !1,
                            shade: "light",
                            type: "vertical",
                            opacityFrom: .65,
                            opacityTo: .5,
                            stops: [
                                0,
                                100,
                                100
                            ]
                        }
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    tooltip: {
                        followCursor: !1
                    }
                };
            }
        },
        {
            key: "rangeArea",
            value: function() {
                return {
                    stroke: {
                        curve: "straight",
                        width: 0
                    },
                    fill: {
                        type: "solid",
                        opacity: .6
                    },
                    markers: {
                        size: 0
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "none"
                            }
                        },
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    tooltip: {
                        intersect: !1,
                        shared: !0,
                        followCursor: !0,
                        custom: function(t) {
                            return function(t) {
                                var i = M(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.start, n = i.end;
                                return z(e(e({}, t), {}, {
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                }));
                            }(t);
                        }
                    }
                };
            }
        },
        {
            key: "brush",
            value: function(t) {
                return x.extend(t, {
                    chart: {
                        toolbar: {
                            autoSelected: "selection",
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 1
                    },
                    tooltip: {
                        enabled: !1
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        }
                    }
                });
            }
        },
        {
            key: "stacked100",
            value: function(t) {
                t.dataLabels = t.dataLabels || {}, t.dataLabels.formatter = t.dataLabels.formatter || void 0;
                var e = t.dataLabels.formatter;
                return t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }), "bar" === t.chart.type && (t.dataLabels.formatter = e || function(t) {
                    return "number" == typeof t && t ? t.toFixed(0) + "%" : t;
                }), t;
            }
        },
        {
            key: "stackedBars",
            value: function() {
                var t = this.bar();
                return e(e({}, t), {}, {
                    plotOptions: e(e({}, t.plotOptions), {}, {
                        bar: e(e({}, t.plotOptions.bar), {}, {
                            borderRadiusApplication: "end",
                            borderRadiusWhenStacked: "last"
                        })
                    })
                });
            }
        },
        {
            key: "convertCatToNumeric",
            value: function(t) {
                return t.xaxis.convertedCatToNumeric = !0, t;
            }
        },
        {
            key: "convertCatToNumericXaxis",
            value: function(t, e, i) {
                t.xaxis.type = "numeric", t.xaxis.labels = t.xaxis.labels || {}, t.xaxis.labels.formatter = t.xaxis.labels.formatter || function(t) {
                    return x.isNumber(t) ? Math.floor(t) : t;
                };
                var a = t.xaxis.labels.formatter, s = t.xaxis.categories && t.xaxis.categories.length ? t.xaxis.categories : t.labels;
                return i && i.length && (s = i.map(function(t) {
                    return Array.isArray(t) ? t : String(t);
                })), s && s.length && (t.xaxis.labels.formatter = function(t) {
                    return x.isNumber(t) ? a(s[Math.floor(t) - 1]) : a(t);
                }), t.xaxis.categories = [], t.labels = [], t.xaxis.tickAmount = t.xaxis.tickAmount || "dataPoints", t;
            }
        },
        {
            key: "bubble",
            value: function() {
                return {
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        crosshairs: {
                            width: 0
                        }
                    },
                    fill: {
                        type: "solid",
                        gradient: {
                            shade: "light",
                            inverse: !0,
                            shadeIntensity: .55,
                            opacityFrom: .4,
                            opacityTo: .8
                        }
                    }
                };
            }
        },
        {
            key: "scatter",
            value: function() {
                return {
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    markers: {
                        size: 6,
                        strokeWidth: 1,
                        hover: {
                            sizeOffset: 2
                        }
                    }
                };
            }
        },
        {
            key: "heatmap",
            value: function() {
                return {
                    chart: {
                        stacked: !1
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    tooltip: {
                        followCursor: !0,
                        marker: {
                            show: !1
                        },
                        x: {
                            show: !1
                        }
                    },
                    legend: {
                        position: "top",
                        markers: {
                            shape: "square",
                            size: 10,
                            offsetY: 2
                        }
                    },
                    grid: {
                        padding: {
                            right: 20
                        }
                    }
                };
            }
        },
        {
            key: "treemap",
            value: function() {
                return {
                    chart: {
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        style: {
                            fontSize: 14,
                            fontWeight: 600,
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        show: !0,
                        width: 2,
                        colors: [
                            "#fff"
                        ]
                    },
                    legend: {
                        show: !1
                    },
                    fill: {
                        gradient: {
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        followCursor: !0,
                        x: {
                            show: !1
                        }
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        }
                    }
                };
            }
        },
        {
            key: "pie",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: !1
                                }
                            }
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "donut",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            shadeIntensity: .35,
                            stops: [
                                80,
                                100
                            ],
                            opacityFrom: 1,
                            opacityTo: 1
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "polarArea",
            value: function() {
                return this.opts.yaxis[0].tickAmount = this.opts.yaxis[0].tickAmount ? this.opts.yaxis[0].tickAmount : 6, {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        enabled: !1
                    },
                    stroke: {
                        show: !0,
                        width: 2
                    },
                    fill: {
                        opacity: .7
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "radar",
            value: function() {
                return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                    dataLabels: {
                        enabled: !1,
                        style: {
                            fontSize: "11px"
                        }
                    },
                    stroke: {
                        width: 2
                    },
                    markers: {
                        size: 3,
                        strokeWidth: 1,
                        strokeOpacity: 1
                    },
                    fill: {
                        opacity: .2
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    grid: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            formatter: function(t) {
                                return t;
                            },
                            style: {
                                colors: [
                                    "#a8a8a8"
                                ],
                                fontSize: "11px"
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    }
                };
            }
        },
        {
            key: "radialBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 800
                            }
                        },
                        toolbar: {
                            show: !1
                        }
                    },
                    fill: {
                        gradient: {
                            shade: "dark",
                            shadeIntensity: .4,
                            inverseColors: !1,
                            type: "diagonal2",
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                70,
                                98,
                                100
                            ]
                        }
                    },
                    legend: {
                        show: !1,
                        position: "right"
                    },
                    tooltip: {
                        enabled: !1,
                        fillSeriesColor: !0
                    }
                };
            }
        },
        {
            key: "_getBoxTooltip",
            value: function(t, e, i, a, s) {
                var r = t.globals.seriesCandleO[e][i], o = t.globals.seriesCandleH[e][i], n = t.globals.seriesCandleM[e][i], l = t.globals.seriesCandleL[e][i], h = t.globals.seriesCandleC[e][i];
                return t.config.series[e].type && t.config.series[e].type !== s ? '<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name ? t.config.series[e].name : "series-" + (e + 1), ": <strong>").concat(t.globals.series[e][i], "</strong>\n        </div>") : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + o + "</span></div>" + (n ? "<div>".concat(a[2], ': <span class="value">') + n + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + l + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + h + "</span></div></div>";
            }
        }
    ]), t;
}(), E = function() {
    function t(e) {
        a(this, t), this.opts = e;
    }
    return r(t, [
        {
            key: "init",
            value: function(t) {
                var e = t.responsiveOverride, a = this.opts, s = new L, r = new X(a);
                this.chartType = a.chart.type, a = this.extendYAxis(a), a = this.extendAnnotations(a);
                var o = s.init(), n = {};
                if (a && "object" === i(a)) {
                    var l, h, c, d, g, u, p, f, b, v, m = {};
                    m = -1 !== [
                        "line",
                        "area",
                        "bar",
                        "candlestick",
                        "boxPlot",
                        "rangeBar",
                        "rangeArea",
                        "bubble",
                        "scatter",
                        "heatmap",
                        "treemap",
                        "pie",
                        "polarArea",
                        "donut",
                        "radar",
                        "radialBar"
                    ].indexOf(a.chart.type) ? r[a.chart.type]() : r.line(), null !== (l = a.plotOptions) && void 0 !== l && null !== (h = l.bar) && void 0 !== h && h.isFunnel && (m = r.funnel()), a.chart.stacked && "bar" === a.chart.type && (m = r.stackedBars()), null !== (c = a.chart.brush) && void 0 !== c && c.enabled && (m = r.brush(m)), a.chart.stacked && "100%" === a.chart.stackType && (a = r.stacked100(a)), null !== (d = a.plotOptions) && void 0 !== d && null !== (g = d.bar) && void 0 !== g && g.isDumbbell && (a = r.dumbbell(a)), "monotoneCubic" === (null === (u = a) || void 0 === u || null === (p = u.stroke) || void 0 === p ? void 0 : p.curve) && (a.stroke.curve = "smooth"), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(a), a.xaxis = a.xaxis || window.Apex.xaxis || {}, e || (a.xaxis.convertedCatToNumeric = !1), (null !== (f = (a = this.checkForCatToNumericXAxis(this.chartType, m, a)).chart.sparkline) && void 0 !== f && f.enabled || null !== (b = window.Apex.chart) && void 0 !== b && null !== (v = b.sparkline) && void 0 !== v && v.enabled) && (m = r.sparkline(m)), n = x.extend(o, m);
                }
                var y = x.extend(n, window.Apex);
                return o = x.extend(y, a), o = this.handleUserInputErrors(o);
            }
        },
        {
            key: "checkForCatToNumericXAxis",
            value: function(t, e, i) {
                var a, s, r = new X(i), o = ("bar" === t || "boxPlot" === t) && (null === (a = i.plotOptions) || void 0 === a || null === (s = a.bar) || void 0 === s ? void 0 : s.horizontal), n = "pie" === t || "polarArea" === t || "donut" === t || "radar" === t || "radialBar" === t || "heatmap" === t, l = "datetime" !== i.xaxis.type && "numeric" !== i.xaxis.type, h = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : e.xaxis && e.xaxis.tickPlacement;
                return o || n || !l || "between" === h || (i = r.convertCatToNumeric(i)), i;
            }
        },
        {
            key: "extendYAxis",
            value: function(t, e) {
                var i = new L;
                (void 0 === t.yaxis || !t.yaxis || Array.isArray(t.yaxis) && 0 === t.yaxis.length) && (t.yaxis = {}), t.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (t.yaxis = x.extend(t.yaxis, window.Apex.yaxis)), t.yaxis.constructor !== Array ? t.yaxis = [
                    x.extend(i.yAxis, t.yaxis)
                ] : t.yaxis = x.extendArray(t.yaxis, i.yAxis);
                var a = !1;
                t.yaxis.forEach(function(t) {
                    t.logarithmic && (a = !0);
                });
                var s = t.series;
                return e && !s && (s = e.config.series), a && s.length !== t.yaxis.length && s.length && (t.yaxis = s.map(function(e, a) {
                    if (e.name || (s[a].name = "series-".concat(a + 1)), t.yaxis[a]) return t.yaxis[a].seriesName = s[a].name, t.yaxis[a];
                    var r = x.extend(i.yAxis, t.yaxis[0]);
                    return r.show = !1, r;
                })), a && s.length > 1 && s.length !== t.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"), t;
            }
        },
        {
            key: "extendAnnotations",
            value: function(t) {
                return void 0 === t.annotations && (t.annotations = {}, t.annotations.yaxis = [], t.annotations.xaxis = [], t.annotations.points = []), t = this.extendYAxisAnnotations(t), t = this.extendXAxisAnnotations(t), t = this.extendPointAnnotations(t);
            }
        },
        {
            key: "extendYAxisAnnotations",
            value: function(t) {
                var e = new L;
                return t.annotations.yaxis = x.extendArray(void 0 !== t.annotations.yaxis ? t.annotations.yaxis : [], e.yAxisAnnotation), t;
            }
        },
        {
            key: "extendXAxisAnnotations",
            value: function(t) {
                var e = new L;
                return t.annotations.xaxis = x.extendArray(void 0 !== t.annotations.xaxis ? t.annotations.xaxis : [], e.xAxisAnnotation), t;
            }
        },
        {
            key: "extendPointAnnotations",
            value: function(t) {
                var e = new L;
                return t.annotations.points = x.extendArray(void 0 !== t.annotations.points ? t.annotations.points : [], e.pointAnnotation), t;
            }
        },
        {
            key: "checkForDarkTheme",
            value: function(t) {
                t.theme && "dark" === t.theme.mode && (t.tooltip || (t.tooltip = {}), "light" !== t.tooltip.theme && (t.tooltip.theme = "dark"), t.chart.foreColor || (t.chart.foreColor = "#f6f7f8"), t.chart.background || (t.chart.background = "#424242"), t.theme.palette || (t.theme.palette = "palette4"));
            }
        },
        {
            key: "handleUserInputErrors",
            value: function(t) {
                var e = t;
                if (e.tooltip.shared && e.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                if ("bar" === e.chart.type && e.plotOptions.bar.horizontal) {
                    if (e.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                    e.yaxis[0].reversed && (e.yaxis[0].opposite = !0), e.xaxis.tooltip.enabled = !1, e.yaxis[0].tooltip.enabled = !1, e.chart.zoom.enabled = !1;
                }
                return "bar" !== e.chart.type && "rangeBar" !== e.chart.type || e.tooltip.shared && "barWidth" === e.xaxis.crosshairs.width && e.series.length > 1 && (e.xaxis.crosshairs.width = "tickWidth"), "candlestick" !== e.chart.type && "boxPlot" !== e.chart.type || e.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(e.chart.type, " chart is not supported.")), e.yaxis[0].reversed = !1), e;
            }
        }
    ]), t;
}(), Y = function() {
    function t() {
        a(this, t);
    }
    return r(t, [
        {
            key: "initGlobalVars",
            value: function(t) {
                t.series = [], t.seriesCandleO = [], t.seriesCandleH = [], t.seriesCandleM = [], t.seriesCandleL = [], t.seriesCandleC = [], t.seriesRangeStart = [], t.seriesRangeEnd = [], t.seriesRange = [], t.seriesPercent = [], t.seriesGoals = [], t.seriesX = [], t.seriesZ = [], t.seriesNames = [], t.seriesTotals = [], t.seriesLog = [], t.seriesColors = [], t.stackedSeriesTotals = [], t.seriesXvalues = [], t.seriesYvalues = [], t.labels = [], t.hasXaxisGroups = !1, t.groups = [], t.hasSeriesGroups = !1, t.seriesGroups = [], t.categoryLabels = [], t.timescaleLabels = [], t.noLabelsProvided = !1, t.resizeTimer = null, t.selectionResizeTimer = null, t.delayedElements = [], t.pointsArray = [], t.dataLabelsRects = [], t.isXNumeric = !1, t.skipLastTimelinelabel = !1, t.skipFirstTimelinelabel = !1, t.isDataXYZ = !1, t.isMultiLineX = !1, t.isMultipleYAxis = !1, t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE, t.minYArr = [], t.maxYArr = [], t.maxX = -Number.MAX_VALUE, t.minX = Number.MAX_VALUE, t.initialMaxX = -Number.MAX_VALUE, t.initialMinX = Number.MAX_VALUE, t.maxDate = 0, t.minDate = Number.MAX_VALUE, t.minZ = Number.MAX_VALUE, t.maxZ = -Number.MAX_VALUE, t.minXDiff = Number.MAX_VALUE, t.yAxisScale = [], t.xAxisScale = null, t.xAxisTicksPositions = [], t.yLabelsCoords = [], t.yTitleCoords = [], t.barPadForNumericAxis = 0, t.padHorizontal = 0, t.xRange = 0, t.yRange = [], t.zRange = 0, t.dataPoints = 0, t.xTickAmount = 0;
            }
        },
        {
            key: "globalVars",
            value: function(t) {
                return {
                    chartID: null,
                    cuid: null,
                    events: {
                        beforeMount: [],
                        mounted: [],
                        updated: [],
                        clicked: [],
                        selection: [],
                        dataPointSelection: [],
                        zoomed: [],
                        scrolled: []
                    },
                    colors: [],
                    clientX: null,
                    clientY: null,
                    fill: {
                        colors: []
                    },
                    stroke: {
                        colors: []
                    },
                    dataLabels: {
                        style: {
                            colors: []
                        }
                    },
                    radarPolygons: {
                        fill: {
                            colors: []
                        }
                    },
                    markers: {
                        colors: [],
                        size: t.markers.size,
                        largestSize: 0
                    },
                    animationEnded: !1,
                    isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                    isDirty: !1,
                    isExecCalled: !1,
                    initialConfig: null,
                    initialSeries: [],
                    lastXAxis: [],
                    lastYAxis: [],
                    columnSeries: null,
                    labels: [],
                    timescaleLabels: [],
                    noLabelsProvided: !1,
                    allSeriesCollapsed: !1,
                    collapsedSeries: [],
                    collapsedSeriesIndices: [],
                    ancillaryCollapsedSeries: [],
                    ancillaryCollapsedSeriesIndices: [],
                    risingSeries: [],
                    dataFormatXNumeric: !1,
                    capturedSeriesIndex: -1,
                    capturedDataPointIndex: -1,
                    selectedDataPoints: [],
                    goldenPadding: 35,
                    invalidLogScale: !1,
                    ignoreYAxisIndexes: [],
                    yAxisSameScaleIndices: [],
                    maxValsInArrayIndex: 0,
                    radialSize: 0,
                    selection: void 0,
                    zoomEnabled: "zoom" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.zoom && t.chart.zoom.enabled,
                    panEnabled: "pan" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.pan,
                    selectionEnabled: "selection" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.selection,
                    yaxis: null,
                    mousedown: !1,
                    lastClientPosition: {},
                    visibleXRange: void 0,
                    yValueDecimal: 0,
                    total: 0,
                    SVGNS: "http://www.w3.org/2000/svg",
                    svgWidth: 0,
                    svgHeight: 0,
                    noData: !1,
                    locale: {},
                    dom: {},
                    memory: {
                        methodsToExec: []
                    },
                    shouldAnimate: !0,
                    skipLastTimelinelabel: !1,
                    skipFirstTimelinelabel: !1,
                    delayedElements: [],
                    axisCharts: !0,
                    isDataXYZ: !1,
                    resized: !1,
                    resizeTimer: null,
                    comboCharts: !1,
                    dataChanged: !1,
                    previousPaths: [],
                    allSeriesHasEqualX: !0,
                    pointsArray: [],
                    dataLabelsRects: [],
                    lastDrawnDataLabelsIndexes: [],
                    hasNullValues: !1,
                    easing: null,
                    zoomed: !1,
                    gridWidth: 0,
                    gridHeight: 0,
                    rotateXLabels: !1,
                    defaultLabels: !1,
                    xLabelFormatter: void 0,
                    yLabelFormatters: [],
                    xaxisTooltipFormatter: void 0,
                    ttKeyFormatter: void 0,
                    ttVal: void 0,
                    ttZFormatter: void 0,
                    LINE_HEIGHT_RATIO: 1.618,
                    xAxisLabelsHeight: 0,
                    xAxisGroupLabelsHeight: 0,
                    xAxisLabelsWidth: 0,
                    yAxisLabelsWidth: 0,
                    scaleX: 1,
                    scaleY: 1,
                    translateX: 0,
                    translateY: 0,
                    translateYAxisX: [],
                    yAxisWidths: [],
                    translateXAxisY: 0,
                    translateXAxisX: 0,
                    tooltip: null
                };
            }
        },
        {
            key: "init",
            value: function(t) {
                var e = this.globalVars(t);
                return this.initGlobalVars(e), e.initialConfig = x.extend({}, t), e.initialSeries = x.clone(t.series), e.lastXAxis = x.clone(e.initialConfig.xaxis), e.lastYAxis = x.clone(e.initialConfig.yaxis), e;
            }
        }
    ]), t;
}(), F = function() {
    function t(e) {
        a(this, t), this.opts = e;
    }
    return r(t, [
        {
            key: "init",
            value: function() {
                var t = new E(this.opts).init({
                    responsiveOverride: !1
                });
                return {
                    config: t,
                    globals: (new Y).init(t)
                };
            }
        }
    ]), t;
}(), R = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0;
    }
    return r(t, [
        {
            key: "clippedImgArea",
            value: function(t) {
                var e = this.w, i = e.config, a = parseInt(e.globals.gridWidth, 10), s = parseInt(e.globals.gridHeight, 10), r = a > s ? a : s, o = t.image, n = 0, l = 0;
                void 0 === t.width && void 0 === t.height ? void 0 !== i.fill.image.width && void 0 !== i.fill.image.height ? (n = i.fill.image.width + 1, l = i.fill.image.height) : (n = r + 1, l = r) : (n = t.width, l = t.height);
                var h = document.createElementNS(e.globals.SVGNS, "pattern");
                m.setAttrs(h, {
                    id: t.patternID,
                    patternUnits: t.patternUnits ? t.patternUnits : "userSpaceOnUse",
                    width: n + "px",
                    height: l + "px"
                });
                var c = document.createElementNS(e.globals.SVGNS, "image");
                h.appendChild(c), c.setAttributeNS(window.SVG.xlink, "href", o), m.setAttrs(c, {
                    x: 0,
                    y: 0,
                    preserveAspectRatio: "none",
                    width: n + "px",
                    height: l + "px"
                }), c.style.opacity = t.opacity, e.globals.dom.elDefs.node.appendChild(h);
            }
        },
        {
            key: "getSeriesIndex",
            value: function(t) {
                var e = this.w, i = e.config.chart.type;
                return ("bar" === i || "rangeBar" === i) && e.config.plotOptions.bar.distributed || "heatmap" === i || "treemap" === i ? this.seriesIndex = t.seriesNumber : this.seriesIndex = t.seriesNumber % e.globals.series.length, this.seriesIndex;
            }
        },
        {
            key: "fillPath",
            value: function(t) {
                var e = this.w;
                this.opts = t;
                var i, a, s, r = this.w.config;
                this.seriesIndex = this.getSeriesIndex(t);
                var o = this.getFillColors()[this.seriesIndex];
                void 0 !== e.globals.seriesColors[this.seriesIndex] && (o = e.globals.seriesColors[this.seriesIndex]), "function" == typeof o && (o = o({
                    seriesIndex: this.seriesIndex,
                    dataPointIndex: t.dataPointIndex,
                    value: t.value,
                    w: e
                }));
                var n = t.fillType ? t.fillType : this.getFillType(this.seriesIndex), l = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                t.color && (o = t.color), o || (o = "#fff", console.warn("undefined color - ApexCharts"));
                var h = o;
                if (-1 === o.indexOf("rgb") ? o.length < 9 && (h = x.hexToRgba(o, l)) : o.indexOf("rgba") > -1 && (l = x.getOpacityFromRGBA(o)), t.opacity && (l = t.opacity), "pattern" === n && (a = this.handlePatternFill({
                    fillConfig: t.fillConfig,
                    patternFill: a,
                    fillColor: o,
                    fillOpacity: l,
                    defaultColor: h
                })), "gradient" === n && (s = this.handleGradientFill({
                    fillConfig: t.fillConfig,
                    fillColor: o,
                    fillOpacity: l,
                    i: this.seriesIndex
                })), "image" === n) {
                    var c = r.fill.image.src, d = t.patternID ? t.patternID : "";
                    this.clippedImgArea({
                        opacity: l,
                        image: Array.isArray(c) ? t.seriesNumber < c.length ? c[t.seriesNumber] : c[0] : c,
                        width: t.width ? t.width : void 0,
                        height: t.height ? t.height : void 0,
                        patternUnits: t.patternUnits,
                        patternID: "pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d)
                    }), i = "url(#pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d, ")");
                } else i = "gradient" === n ? s : "pattern" === n ? a : h;
                return t.solid && (i = h), i;
            }
        },
        {
            key: "getFillType",
            value: function(t) {
                var e = this.w;
                return Array.isArray(e.config.fill.type) ? e.config.fill.type[t] : e.config.fill.type;
            }
        },
        {
            key: "getFillColors",
            value: function() {
                var t = this.w, e = t.config, i = this.opts, a = [];
                return t.globals.comboCharts ? "line" === t.config.series[this.seriesIndex].type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors) : "line" === e.chart.type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors), void 0 !== i.fillColors && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
            }
        },
        {
            key: "handlePatternFill",
            value: function(t) {
                var e = t.fillConfig, i = t.patternFill, a = t.fillColor, s = t.fillOpacity, r = t.defaultColor, o = this.w.config.fill;
                e && (o = e);
                var n = this.opts, l = new m(this.ctx), h = Array.isArray(o.pattern.strokeWidth) ? o.pattern.strokeWidth[this.seriesIndex] : o.pattern.strokeWidth, c = a;
                Array.isArray(o.pattern.style) ? i = void 0 !== o.pattern.style[n.seriesNumber] ? l.drawPattern(o.pattern.style[n.seriesNumber], o.pattern.width, o.pattern.height, c, h, s) : r : i = l.drawPattern(o.pattern.style, o.pattern.width, o.pattern.height, c, h, s);
                return i;
            }
        },
        {
            key: "handleGradientFill",
            value: function(t) {
                var i = t.fillColor, a = t.fillOpacity, s = t.fillConfig, r = t.i, o = this.w.config.fill;
                s && (o = e(e({}, o), s));
                var n, l = this.opts, h = new m(this.ctx), c = new x, d = o.gradient.type, g = i, u = void 0 === o.gradient.opacityFrom ? a : Array.isArray(o.gradient.opacityFrom) ? o.gradient.opacityFrom[r] : o.gradient.opacityFrom;
                g.indexOf("rgba") > -1 && (u = x.getOpacityFromRGBA(g));
                var p = void 0 === o.gradient.opacityTo ? a : Array.isArray(o.gradient.opacityTo) ? o.gradient.opacityTo[r] : o.gradient.opacityTo;
                if (void 0 === o.gradient.gradientToColors || 0 === o.gradient.gradientToColors.length) n = "dark" === o.gradient.shade ? c.shadeColor(-1 * parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? x.rgb2hex(i) : i) : c.shadeColor(parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? x.rgb2hex(i) : i);
                else if (o.gradient.gradientToColors[l.seriesNumber]) {
                    var f = o.gradient.gradientToColors[l.seriesNumber];
                    n = f, f.indexOf("rgba") > -1 && (p = x.getOpacityFromRGBA(f));
                } else n = i;
                if (o.gradient.gradientFrom && (g = o.gradient.gradientFrom), o.gradient.gradientTo && (n = o.gradient.gradientTo), o.gradient.inverseColors) {
                    var b = g;
                    g = n, n = b;
                }
                return g.indexOf("rgb") > -1 && (g = x.rgb2hex(g)), n.indexOf("rgb") > -1 && (n = x.rgb2hex(n)), h.drawGradient(d, g, n, u, p, l.size, o.gradient.stops, o.gradient.colorStops, r);
            }
        }
    ]), t;
}(), H = function() {
    function t(e, i) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "setGlobalMarkerSize",
            value: function() {
                var t = this.w;
                if (t.globals.markers.size = Array.isArray(t.config.markers.size) ? t.config.markers.size : [
                    t.config.markers.size
                ], t.globals.markers.size.length > 0) {
                    if (t.globals.markers.size.length < t.globals.series.length + 1) for(var e = 0; e <= t.globals.series.length; e++)void 0 === t.globals.markers.size[e] && t.globals.markers.size.push(t.globals.markers.size[0]);
                } else t.globals.markers.size = t.config.series.map(function(e) {
                    return t.config.markers.size;
                });
            }
        },
        {
            key: "plotChartMarkers",
            value: function(t, e, i, a) {
                var s, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = this.w, n = e, l = t, h = null, c = new m(this.ctx), d = o.config.markers.discrete && o.config.markers.discrete.length;
                if ((o.globals.markers.size[e] > 0 || r || d) && (h = c.group({
                    class: r || d ? "" : "apexcharts-series-markers"
                })).attr("clip-path", "url(#gridRectMarkerMask".concat(o.globals.cuid, ")")), Array.isArray(l.x)) for(var g = 0; g < l.x.length; g++){
                    var u = i;
                    1 === i && 0 === g && (u = 0), 1 === i && 1 === g && (u = 1);
                    var p = "apexcharts-marker";
                    if ("line" !== o.config.chart.type && "area" !== o.config.chart.type || o.globals.comboCharts || o.config.tooltip.intersect || (p += " no-pointer-events"), (Array.isArray(o.config.markers.size) ? o.globals.markers.size[e] > 0 : o.config.markers.size > 0) || r || d) {
                        x.isNumber(l.y[g]) ? p += " w".concat(x.randomId()) : p = "apexcharts-nullpoint";
                        var f = this.getMarkerConfig({
                            cssClass: p,
                            seriesIndex: e,
                            dataPointIndex: u
                        });
                        o.config.series[n].data[u] && (o.config.series[n].data[u].fillColor && (f.pointFillColor = o.config.series[n].data[u].fillColor), o.config.series[n].data[u].strokeColor && (f.pointStrokeColor = o.config.series[n].data[u].strokeColor)), a && (f.pSize = a), (l.x[g] < 0 || l.x[g] > o.globals.gridWidth || l.y[g] < -o.globals.markers.largestSize || l.y[g] > o.globals.gridHeight + o.globals.markers.largestSize) && (f.pSize = 0), (s = c.drawMarker(l.x[g], l.y[g], f)).attr("rel", u), s.attr("j", u), s.attr("index", e), s.node.setAttribute("default-marker-size", f.pSize), new v(this.ctx).setSelectionFilter(s, e, u), this.addEvents(s), h && h.add(s);
                    } else void 0 === o.globals.pointsArray[e] && (o.globals.pointsArray[e] = []), o.globals.pointsArray[e].push([
                        l.x[g],
                        l.y[g]
                    ]);
                }
                return h;
            }
        },
        {
            key: "getMarkerConfig",
            value: function(t) {
                var e = t.cssClass, i = t.seriesIndex, a = t.dataPointIndex, s = void 0 === a ? null : a, r = t.finishRadius, o = void 0 === r ? null : r, n = this.w, l = this.getMarkerStyle(i), h = n.globals.markers.size[i], c = n.config.markers;
                return null !== s && c.discrete.length && c.discrete.map(function(t) {
                    t.seriesIndex === i && t.dataPointIndex === s && (l.pointStrokeColor = t.strokeColor, l.pointFillColor = t.fillColor, h = t.size, l.pointShape = t.shape);
                }), {
                    pSize: null === o ? h : o,
                    pRadius: c.radius,
                    width: Array.isArray(c.width) ? c.width[i] : c.width,
                    height: Array.isArray(c.height) ? c.height[i] : c.height,
                    pointStrokeWidth: Array.isArray(c.strokeWidth) ? c.strokeWidth[i] : c.strokeWidth,
                    pointStrokeColor: l.pointStrokeColor,
                    pointFillColor: l.pointFillColor,
                    shape: l.pointShape || (Array.isArray(c.shape) ? c.shape[i] : c.shape),
                    class: e,
                    pointStrokeOpacity: Array.isArray(c.strokeOpacity) ? c.strokeOpacity[i] : c.strokeOpacity,
                    pointStrokeDashArray: Array.isArray(c.strokeDashArray) ? c.strokeDashArray[i] : c.strokeDashArray,
                    pointFillOpacity: Array.isArray(c.fillOpacity) ? c.fillOpacity[i] : c.fillOpacity,
                    seriesIndex: i
                };
            }
        },
        {
            key: "addEvents",
            value: function(t) {
                var e = this.w, i = new m(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, t)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, t)), t.node.addEventListener("click", e.config.markers.onClick), t.node.addEventListener("dblclick", e.config.markers.onDblClick), t.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, t), {
                    passive: !0
                });
            }
        },
        {
            key: "getMarkerStyle",
            value: function(t) {
                var e = this.w, i = e.globals.markers.colors, a = e.config.markers.strokeColor || e.config.markers.strokeColors;
                return {
                    pointStrokeColor: Array.isArray(a) ? a[t] : a,
                    pointFillColor: Array.isArray(i) ? i[t] : i
                };
            }
        }
    ]), t;
}(), D = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled;
    }
    return r(t, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this.w, s = new m(this.ctx), r = i.realIndex, o = i.pointsPos, n = i.zRatio, l = i.elParent, h = s.group({
                    class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                });
                if (h.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(o.x)) for(var c = 0; c < o.x.length; c++){
                    var d = e + 1, g = !0;
                    0 === e && 0 === c && (d = 0), 0 === e && 1 === c && (d = 1);
                    var u = 0, p = a.globals.markers.size[r];
                    if (n !== 1 / 0) {
                        var f = a.config.plotOptions.bubble;
                        p = a.globals.seriesZ[r][d], f.zScaling && (p /= n), f.minBubbleRadius && p < f.minBubbleRadius && (p = f.minBubbleRadius), f.maxBubbleRadius && p > f.maxBubbleRadius && (p = f.maxBubbleRadius);
                    }
                    a.config.chart.animations.enabled || (u = p);
                    var x = o.x[c], b = o.y[c];
                    if (u = u || 0, null !== b && void 0 !== a.globals.series[r][d] || (g = !1), g) {
                        var v = this.drawPoint(x, b, u, p, r, d, e);
                        h.add(v);
                    }
                    l.add(h);
                }
            }
        },
        {
            key: "drawPoint",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = s, h = new b(this.ctx), c = new v(this.ctx), d = new R(this.ctx), g = new H(this.ctx), u = new m(this.ctx), p = g.getMarkerConfig({
                    cssClass: "apexcharts-marker",
                    seriesIndex: l,
                    dataPointIndex: r,
                    finishRadius: "bubble" === n.config.chart.type || n.globals.comboCharts && n.config.series[s] && "bubble" === n.config.series[s].type ? a : null
                });
                a = p.pSize;
                var f, x = d.fillPath({
                    seriesNumber: s,
                    dataPointIndex: r,
                    color: p.pointFillColor,
                    patternUnits: "objectBoundingBox",
                    value: n.globals.series[s][o]
                });
                if ("circle" === p.shape ? f = u.drawCircle(i) : "square" !== p.shape && "rect" !== p.shape || (f = u.drawRect(0, 0, p.width - p.pointStrokeWidth / 2, p.height - p.pointStrokeWidth / 2, p.pRadius)), n.config.series[l].data[r] && n.config.series[l].data[r].fillColor && (x = n.config.series[l].data[r].fillColor), f.attr({
                    x: t - p.width / 2 - p.pointStrokeWidth / 2,
                    y: e - p.height / 2 - p.pointStrokeWidth / 2,
                    cx: t,
                    cy: e,
                    fill: x,
                    "fill-opacity": p.pointFillOpacity,
                    stroke: p.pointStrokeColor,
                    r: a,
                    "stroke-width": p.pointStrokeWidth,
                    "stroke-dasharray": p.pointStrokeDashArray,
                    "stroke-opacity": p.pointStrokeOpacity
                }), n.config.chart.dropShadow.enabled) {
                    var y = n.config.chart.dropShadow;
                    c.dropShadow(f, y, s);
                }
                if (!this.initialAnim || n.globals.dataChanged || n.globals.resized) n.globals.animationEnded = !0;
                else {
                    var w = n.config.chart.animations.speed;
                    h.animateMarker(f, 0, "circle" === p.shape ? a : {
                        width: p.width,
                        height: p.height
                    }, w, n.globals.easing, function() {
                        window.setTimeout(function() {
                            h.animationCompleted(f);
                        }, 100);
                    });
                }
                if (n.globals.dataChanged && "circle" === p.shape) {
                    if (this.dynamicAnim) {
                        var k, A, S, C, L = n.config.chart.animations.dynamicAnimation.speed;
                        null != (C = n.globals.previousPaths[s] && n.globals.previousPaths[s][o]) && (k = C.x, A = C.y, S = void 0 !== C.r ? C.r : a);
                        for(var P = 0; P < n.globals.collapsedSeries.length; P++)n.globals.collapsedSeries[P].index === s && (L = 1, a = 0);
                        0 === t && 0 === e && (a = 0), h.animateCircle(f, {
                            cx: k,
                            cy: A,
                            r: S
                        }, {
                            cx: t,
                            cy: e,
                            r: a
                        }, L, n.globals.easing);
                    } else f.attr({
                        r: a
                    });
                }
                return f.attr({
                    rel: r,
                    j: r,
                    index: s,
                    "default-marker-size": a
                }), c.setSelectionFilter(f, s, r), g.addEvents(f), f.node.classList.add("apexcharts-marker"), f;
            }
        },
        {
            key: "centerTextInBubble",
            value: function(t) {
                var e = this.w;
                return {
                    y: t += parseInt(e.config.dataLabels.style.fontSize, 10) / 4
                };
            }
        }
    ]), t;
}(), O = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "dataLabelsCorrection",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = !1, h = new m(this.ctx).getTextRects(i, o), c = h.width, d = h.height;
                e < 0 && (e = 0), e > n.globals.gridHeight + d && (e = n.globals.gridHeight + d / 2), void 0 === n.globals.dataLabelsRects[a] && (n.globals.dataLabelsRects[a] = []), n.globals.dataLabelsRects[a].push({
                    x: t,
                    y: e,
                    width: c,
                    height: d
                });
                var g = n.globals.dataLabelsRects[a].length - 2, u = void 0 !== n.globals.lastDrawnDataLabelsIndexes[a] ? n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                if (void 0 !== n.globals.dataLabelsRects[a][g]) {
                    var p = n.globals.dataLabelsRects[a][u];
                    (t > p.x + p.width || e > p.y + p.height || e + d < p.y || t + c < p.x) && (l = !0);
                }
                return (0 === s || r) && (l = !0), {
                    x: t,
                    y: e,
                    textRects: h,
                    drawnextLabel: l
                };
            }
        },
        {
            key: "drawDataLabel",
            value: function(t) {
                var e = this, i = t.type, a = t.pos, s = t.i, r = t.j, o = t.isRangeStart, n = t.strokeWidth, l = void 0 === n ? 2 : n, h = this.w, c = new m(this.ctx), d = h.config.dataLabels, g = 0, u = 0, p = r, f = null;
                if (!d.enabled || !Array.isArray(a.x)) return f;
                f = c.group({
                    class: "apexcharts-data-labels"
                });
                for(var x = 0; x < a.x.length; x++)if (g = a.x[x] + d.offsetX, u = a.y[x] + d.offsetY + l, !isNaN(g)) {
                    1 === r && 0 === x && (p = 0), 1 === r && 1 === x && (p = 1);
                    var b = h.globals.series[s][p];
                    "rangeArea" === i && (b = o ? h.globals.seriesRangeStart[s][p] : h.globals.seriesRangeEnd[s][p]);
                    var v = "", y = function(t) {
                        return h.config.dataLabels.formatter(t, {
                            ctx: e.ctx,
                            seriesIndex: s,
                            dataPointIndex: p,
                            w: h
                        });
                    };
                    if ("bubble" === h.config.chart.type) v = y(b = h.globals.seriesZ[s][p]), u = a.y[x], u = new D(this.ctx).centerTextInBubble(u, s, p).y;
                    else void 0 !== b && (v = y(b));
                    this.plotDataLabelsText({
                        x: g,
                        y: u,
                        text: v,
                        i: s,
                        j: p,
                        parent: f,
                        offsetCorrection: !0,
                        dataLabelsConfig: h.config.dataLabels
                    });
                }
                return f;
            }
        },
        {
            key: "plotDataLabelsText",
            value: function(t) {
                var e = this.w, i = new m(this.ctx), a = t.x, s = t.y, r = t.i, o = t.j, n = t.text, l = t.textAnchor, h = t.fontSize, c = t.parent, d = t.dataLabelsConfig, g = t.color, u = t.alwaysDrawDataLabel, p = t.offsetCorrection;
                if (!(Array.isArray(e.config.dataLabels.enabledOnSeries) && e.config.dataLabels.enabledOnSeries.indexOf(r) < 0)) {
                    var f = {
                        x: a,
                        y: s,
                        drawnextLabel: !0,
                        textRects: null
                    };
                    p && (f = this.dataLabelsCorrection(a, s, n, r, o, u, parseInt(d.style.fontSize, 10))), e.globals.zoomed || (a = f.x, s = f.y), f.textRects && (a < -20 - f.textRects.width || a > e.globals.gridWidth + f.textRects.width + 30) && (n = "");
                    var x = e.globals.dataLabels.style.colors[r];
                    (("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || e.config.dataLabels.distributed) && (x = e.globals.dataLabels.style.colors[o]), "function" == typeof x && (x = x({
                        series: e.globals.series,
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: e
                    })), g && (x = g);
                    var b = d.offsetX, y = d.offsetY;
                    if ("bar" !== e.config.chart.type && "rangeBar" !== e.config.chart.type || (b = 0, y = 0), f.drawnextLabel) {
                        var w = i.drawText({
                            width: 100,
                            height: parseInt(d.style.fontSize, 10),
                            x: a + b,
                            y: s + y,
                            foreColor: x,
                            textAnchor: l || d.textAnchor,
                            text: n,
                            fontSize: h || d.style.fontSize,
                            fontFamily: d.style.fontFamily,
                            fontWeight: d.style.fontWeight || "normal"
                        });
                        if (w.attr({
                            class: "apexcharts-datalabel",
                            cx: a,
                            cy: s
                        }), d.dropShadow.enabled) {
                            var k = d.dropShadow;
                            new v(this.ctx).dropShadow(w, k);
                        }
                        c.add(w), void 0 === e.globals.lastDrawnDataLabelsIndexes[r] && (e.globals.lastDrawnDataLabelsIndexes[r] = []), e.globals.lastDrawnDataLabelsIndexes[r].push(o);
                    }
                }
            }
        },
        {
            key: "addBackgroundToDataLabel",
            value: function(t, e) {
                var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, o = e.width, n = e.height, l = new m(this.ctx).drawRect(e.x - s, e.y - r / 2, o + 2 * s, n + r, a.borderRadius, "transparent" === i.config.chart.background ? "#fff" : i.config.chart.background, a.opacity, a.borderWidth, a.borderColor);
                a.dropShadow.enabled && new v(this.ctx).dropShadow(l, a.dropShadow);
                return l;
            }
        },
        {
            key: "dataLabelsBackground",
            value: function() {
                var t = this.w;
                if ("bubble" !== t.config.chart.type) for(var e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < e.length; i++){
                    var a = e[i], s = a.getBBox(), r = null;
                    if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                        a.parentNode.insertBefore(r.node, a);
                        var o = a.getAttribute("fill");
                        t.config.chart.animations.enabled && !t.globals.resized && !t.globals.dataChanged ? r.animate().attr({
                            fill: o
                        }) : r.attr({
                            fill: o
                        }), a.setAttribute("fill", t.config.dataLabels.background.foreColor);
                    }
                }
            }
        },
        {
            key: "bringForward",
            value: function() {
                for(var t = this.w, e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < e.length; a++)i && i.insertBefore(e[a], i.nextSibling);
            }
        }
    ]), t;
}(), N = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
    }
    return r(t, [
        {
            key: "getAllSeriesEls",
            value: function() {
                return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
            }
        },
        {
            key: "getSeriesByName",
            value: function(t) {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(x.escapeString(t), "']"));
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                var e = this.getSeriesByName(t), i = parseInt(e.getAttribute("data:realIndex"), 10);
                return {
                    isHidden: e.classList.contains("apexcharts-series-collapsed"),
                    realIndex: i
                };
            }
        },
        {
            key: "addCollapsedClassToSeries",
            value: function(t, e) {
                var i = this.w;
                function a(i) {
                    for(var a = 0; a < i.length; a++)i[a].index === e && t.node.classList.add("apexcharts-series-collapsed");
                }
                a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, e.isHidden), e.isHidden;
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !0);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !1);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w, s = x.clone(a.globals.initialSeries);
                a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, t && (e && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
            }
        },
        {
            key: "emptyCollapsedSeries",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)e.globals.collapsedSeriesIndices.indexOf(i) > -1 && (t[i].data = []);
                return t;
            }
        },
        {
            key: "toggleSeriesOnHover",
            value: function(t, e) {
                var i = this.w;
                e || (e = t.target);
                var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");
                if ("mousemove" === t.type) {
                    var s = parseInt(e.getAttribute("rel"), 10) - 1, r = null, o = null;
                    i.globals.axisCharts || "radialBar" === i.config.chart.type ? i.globals.axisCharts ? (r = i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s, "']")), o = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s, "']"))) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "']")) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "'] path"));
                    for(var n = 0; n < a.length; n++)a[n].classList.add(this.legendInactiveClass);
                    null !== r && (i.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), null !== o && o.classList.remove(this.legendInactiveClass));
                } else if ("mouseout" === t.type) for(var l = 0; l < a.length; l++)a[l].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "highlightRangeInSeries",
            value: function(t, e) {
                var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(t) {
                    for(var e = 0; e < s.length; e++)s[e].classList[t](i.legendInactiveClass);
                };
                if ("mousemove" === t.type) {
                    var o = parseInt(e.getAttribute("rel"), 10) - 1;
                    r("add"), function(t) {
                        for(var e = 0; e < s.length; e++){
                            var a = parseInt(s[e].getAttribute("val"), 10);
                            a >= t.from && a <= t.to && s[e].classList.remove(i.legendInactiveClass);
                        }
                    }(a.config.plotOptions.heatmap.colorScale.ranges[o]);
                } else "mouseout" === t.type && r("remove");
            }
        },
        {
            key: "getActiveConfigSeriesIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "asc", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], i = this.w, a = 0;
                if (i.config.series.length > 1) {
                    for(var s = i.config.series.map(function(t, a) {
                        return t.data && t.data.length > 0 && -1 === i.globals.collapsedSeriesIndices.indexOf(a) && (!i.globals.comboCharts || 0 === e.length || e.length && e.indexOf(i.config.series[a].type) > -1) ? a : -1;
                    }), r = "asc" === t ? 0 : s.length - 1; "asc" === t ? r < s.length : r >= 0; "asc" === t ? r++ : r--)if (-1 !== s[r]) {
                        a = s[r];
                        break;
                    }
                }
                return a;
            }
        },
        {
            key: "getBarSeriesIndices",
            value: function() {
                return this.w.globals.comboCharts ? this.w.config.series.map(function(t, e) {
                    return "bar" === t.type || "column" === t.type ? e : -1;
                }).filter(function(t) {
                    return -1 !== t;
                }) : this.w.config.series.map(function(t, e) {
                    return e;
                });
            }
        },
        {
            key: "getPreviousPaths",
            value: function() {
                var t = this.w;
                function e(e, i, a) {
                    for(var s = e[i].childNodes, r = {
                        type: a,
                        paths: [],
                        realIndex: e[i].getAttribute("data:realIndex")
                    }, o = 0; o < s.length; o++)if (s[o].hasAttribute("pathTo")) {
                        var n = s[o].getAttribute("pathTo");
                        r.paths.push({
                            d: n
                        });
                    }
                    t.globals.previousPaths.push(r);
                }
                t.globals.previousPaths = [];
                [
                    "line",
                    "area",
                    "bar",
                    "rangebar",
                    "rangeArea",
                    "candlestick",
                    "radar"
                ].forEach(function(i) {
                    for(var a, s = (a = i, t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a, "-series .apexcharts-series"))), r = 0; r < s.length; r++)e(s, r, i);
                }), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series"));
                if (i.length > 0) for(var a = function(e) {
                    for(var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(e, "'] rect")), a = [], s = function(t) {
                        var e = function(e) {
                            return i[t].getAttribute(e);
                        }, s = {
                            x: parseFloat(e("x")),
                            y: parseFloat(e("y")),
                            width: parseFloat(e("width")),
                            height: parseFloat(e("height"))
                        };
                        a.push({
                            rect: s,
                            color: i[t].getAttribute("color")
                        });
                    }, r = 0; r < i.length; r++)s(r);
                    t.globals.previousPaths.push(a);
                }, s = 0; s < i.length; s++)a(s);
                t.globals.axisCharts || (t.globals.previousPaths = t.globals.series);
            }
        },
        {
            key: "handlePrevBubbleScatterPaths",
            value: function(t) {
                var e = this.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series"));
                if (i.length > 0) for(var a = 0; a < i.length; a++){
                    for(var s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series[data\\:realIndex='").concat(a, "'] circle")), r = [], o = 0; o < s.length; o++)r.push({
                        x: s[o].getAttribute("cx"),
                        y: s[o].getAttribute("cy"),
                        r: s[o].getAttribute("r")
                    });
                    e.globals.previousPaths.push(r);
                }
            }
        },
        {
            key: "clearPreviousPaths",
            value: function() {
                var t = this.w;
                t.globals.previousPaths = [], t.globals.allSeriesCollapsed = !1;
            }
        },
        {
            key: "handleNoData",
            value: function() {
                var t = this.w, e = t.config.noData, i = new m(this.ctx), a = t.globals.svgWidth / 2, s = t.globals.svgHeight / 2, r = "middle";
                if (t.globals.noData = !0, t.globals.animationEnded = !0, "left" === e.align ? (a = 10, r = "start") : "right" === e.align && (a = t.globals.svgWidth - 10, r = "end"), "top" === e.verticalAlign ? s = 50 : "bottom" === e.verticalAlign && (s = t.globals.svgHeight - 50), a += e.offsetX, s = s + parseInt(e.style.fontSize, 10) + 2 + e.offsetY, void 0 !== e.text && "" !== e.text) {
                    var o = i.drawText({
                        x: a,
                        y: s,
                        text: e.text,
                        textAnchor: r,
                        fontSize: e.style.fontSize,
                        fontFamily: e.style.fontFamily,
                        foreColor: e.style.color,
                        opacity: 1,
                        class: "apexcharts-text-nodata"
                    });
                    t.globals.dom.Paper.add(o);
                }
            }
        },
        {
            key: "setNullSeriesToZeroValues",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)if (0 === t[i].length) for(var a = 0; a < t[e.globals.maxValsInArrayIndex].length; a++)t[i].push(0);
                return t;
            }
        },
        {
            key: "hasAllSeriesEqualX",
            value: function() {
                for(var t = !0, e = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                    t = !1;
                    break;
                }
                return e.globals.allSeriesHasEqualX = t, t;
            }
        },
        {
            key: "filteredSeriesX",
            value: function() {
                var t = this.w.globals.seriesX.map(function(t) {
                    return t.length > 0 ? t : [];
                });
                return t;
            }
        }
    ]), t;
}(), W = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new y(this.ctx);
    }
    return r(t, [
        {
            key: "isMultiFormat",
            value: function() {
                return this.isFormatXY() || this.isFormat2DArray();
            }
        },
        {
            key: "isFormatXY",
            value: function() {
                var t = this.w.config.series.slice(), e = new N(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && null !== t[this.activeSeriesIndex].data[0] && void 0 !== t[this.activeSeriesIndex].data[0].x && null !== t[this.activeSeriesIndex].data[0]) return !0;
            }
        },
        {
            key: "isFormat2DArray",
            value: function() {
                var t = this.w.config.series.slice(), e = new N(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && void 0 !== t[this.activeSeriesIndex].data[0] && null !== t[this.activeSeriesIndex].data[0] && t[this.activeSeriesIndex].data[0].constructor === Array) return !0;
            }
        },
        {
            key: "handleFormat2DArray",
            value: function(t, e) {
                for(var i = this.w.config, a = this.w.globals, s = "boxPlot" === i.chart.type || "boxPlot" === i.series[e].type, r = 0; r < t[e].data.length; r++)if (void 0 !== t[e].data[r][1] && (Array.isArray(t[e].data[r][1]) && 4 === t[e].data[r][1].length && !s ? this.twoDSeries.push(x.parseNumber(t[e].data[r][1][3])) : t[e].data[r].length >= 5 ? this.twoDSeries.push(x.parseNumber(t[e].data[r][4])) : this.twoDSeries.push(x.parseNumber(t[e].data[r][1])), a.dataFormatXNumeric = !0), "datetime" === i.xaxis.type) {
                    var o = new Date(t[e].data[r][0]);
                    o = new Date(o).getTime(), this.twoDSeriesX.push(o);
                } else this.twoDSeriesX.push(t[e].data[r][0]);
                for(var n = 0; n < t[e].data.length; n++)void 0 !== t[e].data[n][2] && (this.threeDSeries.push(t[e].data[n][2]), a.isDataXYZ = !0);
            }
        },
        {
            key: "handleFormatXY",
            value: function(t, e) {
                var i = this.w.config, a = this.w.globals, s = new I(this.ctx), r = e;
                a.collapsedSeriesIndices.indexOf(e) > -1 && (r = this.activeSeriesIndex);
                for(var o = 0; o < t[e].data.length; o++)void 0 !== t[e].data[o].y && (Array.isArray(t[e].data[o].y) ? this.twoDSeries.push(x.parseNumber(t[e].data[o].y[t[e].data[o].y.length - 1])) : this.twoDSeries.push(x.parseNumber(t[e].data[o].y))), void 0 !== t[e].data[o].goals && Array.isArray(t[e].data[o].goals) ? (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(t[e].data[o].goals)) : (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(null));
                for(var n = 0; n < t[r].data.length; n++){
                    var l = "string" == typeof t[r].data[n].x, h = Array.isArray(t[r].data[n].x), c = !h && !!s.isValidDate(t[r].data[n].x);
                    if (l || c) {
                        if (l || i.xaxis.convertedCatToNumeric) {
                            var d = a.isBarHorizontal && a.isRangeData;
                            "datetime" !== i.xaxis.type || d ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x), isNaN(t[r].data[n].x) || "category" === this.w.config.xaxis.type || "string" == typeof t[r].data[n].x || (a.isXNumeric = !0)) : this.twoDSeriesX.push(s.parseDate(t[r].data[n].x));
                        } else "datetime" === i.xaxis.type ? this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));
                    } else h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(t[r].data[n].x));
                }
                if (t[e].data[0] && void 0 !== t[e].data[0].z) {
                    for(var g = 0; g < t[e].data.length; g++)this.threeDSeries.push(t[e].data[g].z);
                    a.isDataXYZ = !0;
                }
            }
        },
        {
            key: "handleRangeData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", t, e)), i.seriesRangeStart.push(a.start), i.seriesRangeEnd.push(a.end), i.seriesRange.push(a.rangeUniques), i.seriesRange.forEach(function(t, e) {
                    t && t.forEach(function(t, e) {
                        t.y.forEach(function(e, i) {
                            for(var a = 0; a < t.y.length; a++)if (i !== a) {
                                var s = e.y1, r = e.y2, o = t.y[a].y1;
                                s <= t.y[a].y2 && o <= r && (t.overlaps.indexOf(e.rangeName) < 0 && t.overlaps.push(e.rangeName), t.overlaps.indexOf(t.y[a].rangeName) < 0 && t.overlaps.push(t.y[a].rangeName));
                            }
                        });
                    });
                }), a;
            }
        },
        {
            key: "handleCandleStickBoxData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", t, e)), i.seriesCandleO[e] = a.o, i.seriesCandleH[e] = a.h, i.seriesCandleM[e] = a.m, i.seriesCandleL[e] = a.l, i.seriesCandleC[e] = a.c, a;
            }
        },
        {
            key: "handleRangeDataFormat",
            value: function(t, e, i) {
                var a = [], s = [], r = e[i].data.filter(function(t, e, i) {
                    return e === i.findIndex(function(e) {
                        return e.x === t.x;
                    });
                }).map(function(t, e) {
                    return {
                        x: t.x,
                        overlaps: [],
                        y: []
                    };
                });
                if ("array" === t) for(var o = 0; o < e[i].data.length; o++)Array.isArray(e[i].data[o]) ? (a.push(e[i].data[o][1][0]), s.push(e[i].data[o][1][1])) : (a.push(e[i].data[o]), s.push(e[i].data[o]));
                else if ("xy" === t) for(var n = function(t) {
                    var o = Array.isArray(e[i].data[t].y), n = x.randomId(), l = e[i].data[t].x, h = {
                        y1: o ? e[i].data[t].y[0] : e[i].data[t].y,
                        y2: o ? e[i].data[t].y[1] : e[i].data[t].y,
                        rangeName: n
                    };
                    e[i].data[t].rangeName = n;
                    var c = r.findIndex(function(t) {
                        return t.x === l;
                    });
                    r[c].y.push(h), a.push(h.y1), s.push(h.y2);
                }, l = 0; l < e[i].data.length; l++)n(l);
                return {
                    start: a,
                    end: s,
                    rangeUniques: r
                };
            }
        },
        {
            key: "handleCandleStickBoxDataFormat",
            value: function(t, e, i) {
                var a = this.w, s = "boxPlot" === a.config.chart.type || "boxPlot" === a.config.series[i].type, r = [], o = [], n = [], l = [], h = [];
                if ("array" === t) {
                    if (s && 6 === e[i].data[0].length || !s && 5 === e[i].data[0].length) for(var c = 0; c < e[i].data.length; c++)r.push(e[i].data[c][1]), o.push(e[i].data[c][2]), s ? (n.push(e[i].data[c][3]), l.push(e[i].data[c][4]), h.push(e[i].data[c][5])) : (l.push(e[i].data[c][3]), h.push(e[i].data[c][4]));
                    else for(var d = 0; d < e[i].data.length; d++)Array.isArray(e[i].data[d][1]) && (r.push(e[i].data[d][1][0]), o.push(e[i].data[d][1][1]), s ? (n.push(e[i].data[d][1][2]), l.push(e[i].data[d][1][3]), h.push(e[i].data[d][1][4])) : (l.push(e[i].data[d][1][2]), h.push(e[i].data[d][1][3])));
                } else if ("xy" === t) for(var g = 0; g < e[i].data.length; g++)Array.isArray(e[i].data[g].y) && (r.push(e[i].data[g].y[0]), o.push(e[i].data[g].y[1]), s ? (n.push(e[i].data[g].y[2]), l.push(e[i].data[g].y[3]), h.push(e[i].data[g].y[4])) : (l.push(e[i].data[g].y[2]), h.push(e[i].data[g].y[3])));
                return {
                    o: r,
                    h: o,
                    m: n,
                    l: l,
                    c: h
                };
            }
        },
        {
            key: "parseDataAxisCharts",
            value: function(t) {
                var e, i = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.ctx, s = this.w.config, r = this.w.globals, o = new I(a), n = s.labels.length > 0 ? s.labels.slice() : s.xaxis.categories.slice();
                if (r.isRangeBar = "rangeBar" === s.chart.type && r.isBarHorizontal, r.hasXaxisGroups = "category" === s.xaxis.type && s.xaxis.group.groups.length > 0, r.hasXaxisGroups && (r.groups = s.xaxis.group.groups), r.hasSeriesGroups = null === (e = t[0]) || void 0 === e ? void 0 : e.group, r.hasSeriesGroups) {
                    var l = [], h = u(new Set(t.map(function(t) {
                        return t.group;
                    })));
                    t.forEach(function(t, e) {
                        var i = h.indexOf(t.group);
                        l[i] || (l[i] = []), l[i].push(t.name);
                    }), r.seriesGroups = l;
                }
                for(var c = function() {
                    for(var t = 0; t < n.length; t++)if ("string" == typeof n[t]) {
                        if (!o.isValidDate(n[t])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                        i.twoDSeriesX.push(o.parseDate(n[t]));
                    } else i.twoDSeriesX.push(n[t]);
                }, d = 0; d < t.length; d++){
                    if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], void 0 === t[d].data) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                    if ("rangeBar" !== s.chart.type && "rangeArea" !== s.chart.type && "rangeBar" !== t[d].type && "rangeArea" !== t[d].type || (r.isRangeData = !0, "rangeBar" !== s.chart.type && "rangeArea" !== s.chart.type || this.handleRangeData(t, d)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(t, d) : this.isFormatXY() && this.handleFormatXY(t, d), "candlestick" !== s.chart.type && "candlestick" !== t[d].type && "boxPlot" !== s.chart.type && "boxPlot" !== t[d].type || this.handleCandleStickBoxData(t, d), r.series.push(this.twoDSeries), r.labels.push(this.twoDSeriesX), r.seriesX.push(this.twoDSeriesX), r.seriesGoals = this.seriesGoals, d !== this.activeSeriesIndex || this.fallbackToCategory || (r.isXNumeric = !0);
                    else {
                        "datetime" === s.xaxis.type ? (r.isXNumeric = !0, c(), r.seriesX.push(this.twoDSeriesX)) : "numeric" === s.xaxis.type && (r.isXNumeric = !0, n.length > 0 && (this.twoDSeriesX = n, r.seriesX.push(this.twoDSeriesX))), r.labels.push(this.twoDSeriesX);
                        var g = t[d].data.map(function(t) {
                            return x.parseNumber(t);
                        });
                        r.series.push(g);
                    }
                    r.seriesZ.push(this.threeDSeries), void 0 !== t[d].name ? r.seriesNames.push(t[d].name) : r.seriesNames.push("series-" + parseInt(d + 1, 10)), void 0 !== t[d].color ? r.seriesColors.push(t[d].color) : r.seriesColors.push(void 0);
                }
                return this.w;
            }
        },
        {
            key: "parseDataNonAxisCharts",
            value: function(t) {
                var e = this.w.globals, i = this.w.config;
                e.series = t.slice(), e.seriesNames = i.labels.slice();
                for(var a = 0; a < e.series.length; a++)void 0 === e.seriesNames[a] && e.seriesNames.push("series-" + (a + 1));
                return this.w;
            }
        },
        {
            key: "handleExternalLabelsData",
            value: function(t) {
                var e = this.w.config, i = this.w.globals;
                if (e.xaxis.categories.length > 0) i.labels = e.xaxis.categories;
                else if (e.labels.length > 0) i.labels = e.labels.slice();
                else if (this.fallbackToCategory) {
                    if (i.labels = i.labels[0], i.seriesRange.length && (i.seriesRange.map(function(t) {
                        t.forEach(function(t) {
                            i.labels.indexOf(t.x) < 0 && t.x && i.labels.push(t.x);
                        });
                    }), i.labels = Array.from(new Set(i.labels.map(JSON.stringify)), JSON.parse)), e.xaxis.convertedCatToNumeric) new X(e).convertCatToNumericXaxis(e, this.ctx, i.seriesX[0]), this._generateExternalLabels(t);
                } else this._generateExternalLabels(t);
            }
        },
        {
            key: "_generateExternalLabels",
            value: function(t) {
                var e = this.w.globals, i = this.w.config, a = [];
                if (e.axisCharts) {
                    if (e.series.length > 0) {
                        if (this.isFormatXY()) for(var s = i.series.map(function(t, e) {
                            return t.data.filter(function(t, e, i) {
                                return i.findIndex(function(e) {
                                    return e.x === t.x;
                                }) === e;
                            });
                        }), r = s.reduce(function(t, e, i, a) {
                            return a[t].length > e.length ? t : i;
                        }, 0), o = 0; o < s[r].length; o++)a.push(o + 1);
                        else for(var n = 0; n < e.series[e.maxValsInArrayIndex].length; n++)a.push(n + 1);
                    }
                    e.seriesX = [];
                    for(var l = 0; l < t.length; l++)e.seriesX.push(a);
                    this.w.globals.isBarHorizontal || (e.isXNumeric = !0);
                }
                if (0 === a.length) {
                    a = e.axisCharts ? [] : e.series.map(function(t, e) {
                        return e + 1;
                    });
                    for(var h = 0; h < t.length; h++)e.seriesX.push(a);
                }
                e.labels = a, i.xaxis.convertedCatToNumeric && (e.categoryLabels = a.map(function(t) {
                    return i.xaxis.labels.formatter(t);
                })), e.noLabelsProvided = !0;
            }
        },
        {
            key: "parseData",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? (this.parseDataAxisCharts(t), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(t), i.chart.stacked) {
                    var s = new N(this.ctx);
                    a.series = s.setNullSeriesToZeroValues(a.series);
                }
                this.coreUtils.getSeriesTotals(), a.axisCharts && (a.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals(), a.stackedSeriesTotalsByGroups = this.coreUtils.getStackedSeriesTotalsByGroups()), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && ("numeric" !== i.xaxis.type || 0 !== i.labels.length || 0 !== i.xaxis.categories.length) || this.handleExternalLabelsData(t);
                for(var r = this.coreUtils.getCategoryLabels(a.labels), o = 0; o < r.length; o++)if (Array.isArray(r[o])) {
                    a.isMultiLineX = !0;
                    break;
                }
            }
        },
        {
            key: "excludeCollapsedSeriesInYAxis",
            value: function() {
                var t = this, e = this.w;
                e.globals.ignoreYAxisIndexes = e.globals.collapsedSeries.map(function(i, a) {
                    if (t.w.globals.isMultipleYAxis && !e.config.chart.stacked) return i.index;
                });
            }
        }
    ]), t;
}(), B = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "getLabel",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "12px", o = !(arguments.length > 6 && void 0 !== arguments[6]) || arguments[6], n = this.w, l = void 0 === t[a] ? "" : t[a], h = l, c = n.globals.xLabelFormatter, d = n.config.xaxis.labels.formatter, g = !1, u = new T(this.ctx), p = l;
                o && (h = u.xLabelFormat(c, l, p, {
                    i: a,
                    dateFormatter: new I(this.ctx).formatDate,
                    w: n
                }), void 0 !== d && (h = d(l, t[a], {
                    i: a,
                    dateFormatter: new I(this.ctx).formatDate,
                    w: n
                })));
                var f, x;
                e.length > 0 ? (f = e[a].unit, x = null, e.forEach(function(t) {
                    "month" === t.unit ? x = "year" : "day" === t.unit ? x = "month" : "hour" === t.unit ? x = "day" : "minute" === t.unit && (x = "hour");
                }), g = x === f, i = e[a].position, h = e[a].value) : "datetime" === n.config.xaxis.type && void 0 === d && (h = ""), void 0 === h && (h = ""), h = Array.isArray(h) ? h : h.toString();
                var b = new m(this.ctx), v = {};
                v = n.globals.rotateXLabels && o ? b.getTextRects(h, parseInt(r, 10), null, "rotate(".concat(n.config.xaxis.labels.rotate, " 0 0)"), !1) : b.getTextRects(h, parseInt(r, 10));
                var y = !n.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                return !Array.isArray(h) && (0 === h.indexOf("NaN") || 0 === h.toLowerCase().indexOf("invalid") || h.toLowerCase().indexOf("infinity") >= 0 || s.indexOf(h) >= 0 && y) && (h = ""), {
                    x: i,
                    text: h,
                    textRect: v,
                    isBold: g
                };
            }
        },
        {
            key: "checkLabelBasedOnTickamount",
            value: function(t, e, i) {
                var a = this.w, s = a.config.xaxis.tickAmount;
                return "dataPoints" === s && (s = Math.round(a.globals.gridWidth / 120)), s > i || t % Math.round(i / (s + 1)) == 0 || (e.text = ""), e;
            }
        },
        {
            key: "checkForOverflowingLabels",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (0 === t && r.globals.skipFirstTimelinelabel && (e.text = ""), t === i - 1 && r.globals.skipLastTimelinelabel && (e.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                    var o = s[s.length - 1];
                    e.x < o.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + o.x && (e.text = "");
                }
                return e;
            }
        },
        {
            key: "checkForReversedLabels",
            value: function(t, e) {
                var i = this.w;
                return i.config.yaxis[t] && i.config.yaxis[t].reversed && e.reverse(), e;
            }
        },
        {
            key: "isYAxisHidden",
            value: function(t) {
                var e = this.w, i = new y(this.ctx);
                return !e.config.yaxis[t].show || !e.config.yaxis[t].showForNullSeries && i.isSeriesNull(t) && -1 === e.globals.collapsedSeriesIndices.indexOf(t);
            }
        },
        {
            key: "getYAxisForeColor",
            value: function(t, e) {
                var i = this.w;
                return Array.isArray(t) && i.globals.yAxisScale[e] && this.ctx.theme.pushExtraColors(t, i.globals.yAxisScale[e].result.length, !1), t;
            }
        },
        {
            key: "drawYAxisTicks",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = new m(this.ctx), h = n.globals.translateY;
                if (a.show && e > 0) {
                    !0 === n.config.yaxis[s].opposite && (t += a.width);
                    for(var c = e; c >= 0; c--){
                        var d = h + e / 10 + n.config.yaxis[s].labels.offsetY - 1;
                        n.globals.isBarHorizontal && (d = r * c), "heatmap" === n.config.chart.type && (d += r / 2);
                        var g = l.drawLine(t + i.offsetX - a.width + a.offsetX, d + a.offsetY, t + i.offsetX + a.offsetX, d + a.offsetY, a.color);
                        o.add(g), h += r;
                    }
                }
            }
        }
    ]), t;
}(), G = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "scaleSvgNode",
            value: function(t, e) {
                var i = parseFloat(t.getAttributeNS(null, "width")), a = parseFloat(t.getAttributeNS(null, "height"));
                t.setAttributeNS(null, "width", i * e), t.setAttributeNS(null, "height", a * e), t.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
            }
        },
        {
            key: "fixSvgStringForIe11",
            value: function(t) {
                if (!x.isIE11()) return t.replace(/&nbsp;/g, "&#160;");
                var e = 0, i = t.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g, function(t) {
                    return 2 === ++e ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"' : t;
                });
                return i = (i = i.replace(/xmlns:NS\d+=""/g, "")).replace(/NS\d+:(\w+:\w+=")/g, "$1");
            }
        },
        {
            key: "getSvgString",
            value: function(t) {
                null == t && (t = 1);
                var e = this.w.globals.dom.Paper.svg();
                if (1 !== t) {
                    var i = this.w.globals.dom.Paper.node.cloneNode(!0);
                    this.scaleSvgNode(i, t), e = (new XMLSerializer).serializeToString(i);
                }
                return this.fixSvgStringForIe11(e);
            }
        },
        {
            key: "cleanup",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"), i = t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                Array.prototype.forEach.call(a, function(t) {
                    t.setAttribute("width", 0);
                }), e && e[0] && (e[0].setAttribute("x", -500), e[0].setAttribute("x1", -500), e[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100));
            }
        },
        {
            key: "svgUrl",
            value: function() {
                this.cleanup();
                var t = this.getSvgString(), e = new Blob([
                    t
                ], {
                    type: "image/svg+xml;charset=utf-8"
                });
                return URL.createObjectURL(e);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                var e = this;
                return new Promise(function(i) {
                    var a = e.w, s = t ? t.scale || t.width / a.globals.svgWidth : 1;
                    e.cleanup();
                    var r = document.createElement("canvas");
                    r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                    var o = "transparent" === a.config.chart.background ? "#fff" : a.config.chart.background, n = r.getContext("2d");
                    n.fillStyle = o, n.fillRect(0, 0, r.width * s, r.height * s);
                    var l = e.getSvgString(s);
                    if (window.canvg && x.isIE11()) {
                        var h = window.canvg.Canvg.fromString(n, l, {
                            ignoreClear: !0,
                            ignoreDimensions: !0
                        });
                        h.start();
                        var c = r.msToBlob();
                        h.stop(), i({
                            blob: c
                        });
                    } else {
                        var d = "data:image/svg+xml," + encodeURIComponent(l), g = new Image;
                        g.crossOrigin = "anonymous", g.onload = function() {
                            if (n.drawImage(g, 0, 0), r.msToBlob) {
                                var t = r.msToBlob();
                                i({
                                    blob: t
                                });
                            } else {
                                var e = r.toDataURL("image/png");
                                i({
                                    imgURI: e
                                });
                            }
                        }, g.src = d;
                    }
                });
            }
        },
        {
            key: "exportToSVG",
            value: function() {
                this.triggerDownload(this.svgUrl(), this.w.config.chart.toolbar.export.svg.filename, ".svg");
            }
        },
        {
            key: "exportToPng",
            value: function() {
                var t = this;
                this.dataURI().then(function(e) {
                    var i = e.imgURI, a = e.blob;
                    a ? navigator.msSaveOrOpenBlob(a, t.w.globals.chartID + ".png") : t.triggerDownload(i, t.w.config.chart.toolbar.export.png.filename, ".png");
                });
            }
        },
        {
            key: "exportToCSV",
            value: function(t) {
                var e = this, i = t.series, a = t.fileName, s = t.columnDelimiter, r = void 0 === s ? "," : s, o = t.lineDelimiter, n = void 0 === o ? "\n" : o, l = this.w;
                i || (i = l.config.series);
                var h, c, d = [], g = [], p = "", f = l.globals.series.map(function(t, e) {
                    return -1 === l.globals.collapsedSeriesIndices.indexOf(e) ? t : [];
                }), b = function(t) {
                    return "datetime" === l.config.xaxis.type && String(t).length >= 10;
                }, v = Math.max.apply(Math, u(i.map(function(t) {
                    return t.data ? t.data.length : 0;
                }))), m = new W(this.ctx), y = new B(this.ctx), w = function(t) {
                    var i = "";
                    if (l.globals.axisCharts) {
                        if ("category" === l.config.xaxis.type || l.config.xaxis.convertedCatToNumeric) {
                            if (l.globals.isBarHorizontal) {
                                var a = l.globals.yLabelFormatters[0], s = new N(e.ctx).getActiveConfigSeriesIndex();
                                i = a(l.globals.labels[t], {
                                    seriesIndex: s,
                                    dataPointIndex: t,
                                    w: l
                                });
                            } else i = y.getLabel(l.globals.labels, l.globals.timescaleLabels, 0, t).text;
                        }
                        "datetime" === l.config.xaxis.type && (l.config.xaxis.categories.length ? i = l.config.xaxis.categories[t] : l.config.labels.length && (i = l.config.labels[t]));
                    } else i = l.config.labels[t];
                    return Array.isArray(i) && (i = i.join(" ")), x.isNumber(i) ? i : i.split(r).join("");
                }, k = function(t, e) {
                    if (d.length && 0 === e && g.push(d.join(r)), t.data) {
                        t.data = t.data.length && t.data || u(Array(v)).map(function() {
                            return "";
                        });
                        for(var a = 0; a < t.data.length; a++){
                            d = [];
                            var s = w(a);
                            if (s || (m.isFormatXY() ? s = i[e].data[a].x : m.isFormat2DArray() && (s = i[e].data[a] ? i[e].data[a][0] : "")), 0 === e) {
                                d.push(b(s) ? l.config.chart.toolbar.export.csv.dateFormatter(s) : x.isNumber(s) ? s : s.split(r).join(""));
                                for(var o = 0; o < l.globals.series.length; o++){
                                    var n;
                                    if (m.isFormatXY()) d.push(null === (n = i[o].data[a]) || void 0 === n ? void 0 : n.y);
                                    else d.push(f[o][a]);
                                }
                            }
                            ("candlestick" === l.config.chart.type || t.type && "candlestick" === t.type) && (d.pop(), d.push(l.globals.seriesCandleO[e][a]), d.push(l.globals.seriesCandleH[e][a]), d.push(l.globals.seriesCandleL[e][a]), d.push(l.globals.seriesCandleC[e][a])), ("boxPlot" === l.config.chart.type || t.type && "boxPlot" === t.type) && (d.pop(), d.push(l.globals.seriesCandleO[e][a]), d.push(l.globals.seriesCandleH[e][a]), d.push(l.globals.seriesCandleM[e][a]), d.push(l.globals.seriesCandleL[e][a]), d.push(l.globals.seriesCandleC[e][a])), "rangeBar" === l.config.chart.type && (d.pop(), d.push(l.globals.seriesRangeStart[e][a]), d.push(l.globals.seriesRangeEnd[e][a])), d.length && g.push(d.join(r));
                        }
                    }
                };
                d.push(l.config.chart.toolbar.export.csv.headerCategory), "boxPlot" === l.config.chart.type ? (d.push("minimum"), d.push("q1"), d.push("median"), d.push("q3"), d.push("maximum")) : "candlestick" === l.config.chart.type ? (d.push("open"), d.push("high"), d.push("low"), d.push("close")) : "rangeBar" === l.config.chart.type ? (d.push("minimum"), d.push("maximum")) : i.map(function(t, e) {
                    var i = (t.name ? t.name : "series-".concat(e)) + "";
                    l.globals.axisCharts && d.push(i.split(r).join("") ? i.split(r).join("") : "series-".concat(e));
                }), l.globals.axisCharts || (d.push(l.config.chart.toolbar.export.csv.headerValue), g.push(d.join(r))), l.globals.allSeriesHasEqualX || !l.globals.axisCharts || l.config.xaxis.categories.length || l.config.labels.length ? i.map(function(t, e) {
                    l.globals.axisCharts ? k(t, e) : ((d = []).push(l.globals.labels[e].split(r).join("")), d.push(f[e]), g.push(d.join(r)));
                }) : (h = new Set, c = {}, i.forEach(function(t, e) {
                    null == t || t.data.forEach(function(t) {
                        var a, s;
                        if (m.isFormatXY()) a = t.x, s = t.y;
                        else {
                            if (!m.isFormat2DArray()) return;
                            a = t[0], s = t[1];
                        }
                        c[a] || (c[a] = Array(i.length).fill("")), c[a][e] = s, h.add(a);
                    });
                }), d.length && g.push(d.join(r)), Array.from(h).sort().forEach(function(t) {
                    g.push([
                        b(t) && "datetime" === l.config.xaxis.type ? l.config.chart.toolbar.export.csv.dateFormatter(t) : x.isNumber(t) ? t : t.split(r).join(""),
                        c[t].join(r)
                    ]);
                })), p += g.join(n), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\uFEFF" + p), a || l.config.chart.toolbar.export.csv.filename, ".csv");
            }
        },
        {
            key: "triggerDownload",
            value: function(t, e, i) {
                var a = document.createElement("a");
                a.href = t, a.download = (e || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
            }
        }
    ]), t;
}(), V = function() {
    function t(e, i) {
        a(this, t), this.ctx = e, this.elgrid = i, this.w = e.w;
        var s = this.w;
        this.axesUtils = new B(e), this.xaxisLabels = s.globals.labels.slice(), s.globals.timescaleLabels.length > 0 && !s.globals.isBarHorizontal && (this.xaxisLabels = s.globals.timescaleLabels.slice()), s.config.xaxis.overwriteCategories && (this.xaxisLabels = s.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], "top" === s.config.xaxis.position ? this.offY = 0 : this.offY = s.globals.gridHeight + 1, this.offY = this.offY + s.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.xaxisBorderWidth = s.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = s.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = s.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = s.config.xaxis.axisBorder.height, this.yaxis = s.config.yaxis[0];
    }
    return r(t, [
        {
            key: "drawXaxis",
            value: function() {
                var t = this.w, e = new m(this.ctx), i = e.group({
                    class: "apexcharts-xaxis",
                    transform: "translate(".concat(t.config.xaxis.offsetX, ", ").concat(t.config.xaxis.offsetY, ")")
                }), a = e.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")")
                });
                i.add(a);
                for(var s = [], r = 0; r < this.xaxisLabels.length; r++)s.push(this.xaxisLabels[r]);
                if (this.drawXAxisLabelAndGroup(!0, e, a, s, t.globals.isXNumeric, function(t, e) {
                    return e;
                }), t.globals.hasXaxisGroups) {
                    var o = t.globals.groups;
                    s = [];
                    for(var n = 0; n < o.length; n++)s.push(o[n].title);
                    var l = {};
                    t.config.xaxis.group.style && (l.xaxisFontSize = t.config.xaxis.group.style.fontSize, l.xaxisFontFamily = t.config.xaxis.group.style.fontFamily, l.xaxisForeColors = t.config.xaxis.group.style.colors, l.fontWeight = t.config.xaxis.group.style.fontWeight, l.cssClass = t.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, e, a, s, !1, function(t, e) {
                        return o[t].cols * e;
                    }, l);
                }
                if (void 0 !== t.config.xaxis.title.text) {
                    var h = e.group({
                        class: "apexcharts-xaxis-title"
                    }), c = e.drawText({
                        x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX,
                        y: this.offY + parseFloat(this.xaxisFontSize) + ("bottom" === t.config.xaxis.position ? t.globals.xAxisLabelsHeight : -t.globals.xAxisLabelsHeight - 10) + t.config.xaxis.title.offsetY,
                        text: t.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: t.config.xaxis.title.style.fontSize,
                        fontFamily: t.config.xaxis.title.style.fontFamily,
                        fontWeight: t.config.xaxis.title.style.fontWeight,
                        foreColor: t.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + t.config.xaxis.title.style.cssClass
                    });
                    h.add(c), i.add(h);
                }
                if (t.config.xaxis.axisBorder.show) {
                    var d = t.globals.barPadForNumericAxis, g = e.drawLine(t.globals.padHorizontal + t.config.xaxis.axisBorder.offsetX - d, this.offY, this.xaxisBorderWidth + d, this.offY, t.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                    this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(g) : i.add(g);
                }
                return i;
            }
        },
        {
            key: "drawXAxisLabelAndGroup",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : {}, h = [], c = [], d = this.w, g = l.xaxisFontSize || this.xaxisFontSize, u = l.xaxisFontFamily || this.xaxisFontFamily, p = l.xaxisForeColors || this.xaxisForeColors, f = l.fontWeight || d.config.xaxis.labels.style.fontWeight, x = l.cssClass || d.config.xaxis.labels.style.cssClass, b = d.globals.padHorizontal, v = a.length, m = "category" === d.config.xaxis.type ? d.globals.dataPoints : v;
                if (0 === m && v > m && (m = v), s) {
                    var y = m > 1 ? m - 1 : m;
                    o = d.globals.gridWidth / Math.min(y, v - 1), b = b + r(0, o) / 2 + d.config.xaxis.labels.offsetX;
                } else o = d.globals.gridWidth / m, b = b + r(0, o) + d.config.xaxis.labels.offsetX;
                for(var w = function(s) {
                    var l = b - r(s, o) / 2 + d.config.xaxis.labels.offsetX;
                    0 === s && 1 === v && o / 2 === b && 1 === m && (l = d.globals.gridWidth / 2);
                    var y = n.axesUtils.getLabel(a, d.globals.timescaleLabels, l, s, h, g, t), w = 28;
                    d.globals.rotateXLabels && t && (w = 22), d.config.xaxis.title.text && "top" === d.config.xaxis.position && (w += parseFloat(d.config.xaxis.title.style.fontSize) + 2), t || (w = w + parseFloat(g) + (d.globals.xAxisLabelsHeight - d.globals.xAxisGroupLabelsHeight) + (d.globals.rotateXLabels ? 10 : 0)), y = void 0 !== d.config.xaxis.tickAmount && "dataPoints" !== d.config.xaxis.tickAmount && "datetime" !== d.config.xaxis.type ? n.axesUtils.checkLabelBasedOnTickamount(s, y, v) : n.axesUtils.checkForOverflowingLabels(s, y, v, h, c);
                    if (d.config.xaxis.labels.show) {
                        var k = e.drawText({
                            x: y.x,
                            y: n.offY + d.config.xaxis.labels.offsetY + w - ("top" === d.config.xaxis.position ? d.globals.xAxisHeight + d.config.xaxis.axisTicks.height - 2 : 0),
                            text: y.text,
                            textAnchor: "middle",
                            fontWeight: y.isBold ? 600 : f,
                            fontSize: g,
                            fontFamily: u,
                            foreColor: Array.isArray(p) ? t && d.config.xaxis.convertedCatToNumeric ? p[d.globals.minX + s - 1] : p[s] : p,
                            isPlainText: !1,
                            cssClass: (t ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + x
                        });
                        if (i.add(k), k.on("click", function(t) {
                            if ("function" == typeof d.config.chart.events.xAxisLabelClick) {
                                var e = Object.assign({}, d, {
                                    labelIndex: s
                                });
                                d.config.chart.events.xAxisLabelClick(t, n.ctx, e);
                            }
                        }), t) {
                            var A = document.createElementNS(d.globals.SVGNS, "title");
                            A.textContent = Array.isArray(y.text) ? y.text.join(" ") : y.text, k.node.appendChild(A), "" !== y.text && (h.push(y.text), c.push(y));
                        }
                    }
                    s < v - 1 && (b += r(s + 1, o));
                }, k = 0; k <= v - 1; k++)w(k);
            }
        },
        {
            key: "drawXaxisInversed",
            value: function(t) {
                var e, i, a = this, s = this.w, r = new m(this.ctx), o = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[t] : 0, n = r.group({
                    class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                    rel: t
                }), l = r.group({
                    class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                    transform: "translate(" + o + ", 0)"
                });
                n.add(l);
                var h = [];
                if (s.config.yaxis[t].show) for(var c = 0; c < this.xaxisLabels.length; c++)h.push(this.xaxisLabels[c]);
                e = s.globals.gridHeight / h.length, i = -e / 2.2;
                var d = s.globals.yLabelFormatters[0], g = s.config.yaxis[0].labels;
                if (g.show) for(var u = function(o) {
                    var n = void 0 === h[o] ? "" : h[o];
                    n = d(n, {
                        seriesIndex: t,
                        dataPointIndex: o,
                        w: s
                    });
                    var c = a.axesUtils.getYAxisForeColor(g.style.colors, t), u = 0;
                    Array.isArray(n) && (u = n.length / 2 * parseInt(g.style.fontSize, 10));
                    var p = g.offsetX - 15, f = "end";
                    a.yaxis.opposite && (f = "start"), "left" === s.config.yaxis[0].labels.align ? (p = g.offsetX, f = "start") : "center" === s.config.yaxis[0].labels.align ? (p = g.offsetX, f = "middle") : "right" === s.config.yaxis[0].labels.align && (f = "end");
                    var x = r.drawText({
                        x: p,
                        y: i + e + g.offsetY - u,
                        text: n,
                        textAnchor: f,
                        foreColor: Array.isArray(c) ? c[o] : c,
                        fontSize: g.style.fontSize,
                        fontFamily: g.style.fontFamily,
                        fontWeight: g.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + g.style.cssClass,
                        maxWidth: g.maxWidth
                    });
                    l.add(x), x.on("click", function(t) {
                        if ("function" == typeof s.config.chart.events.xAxisLabelClick) {
                            var e = Object.assign({}, s, {
                                labelIndex: o
                            });
                            s.config.chart.events.xAxisLabelClick(t, a.ctx, e);
                        }
                    });
                    var b = document.createElementNS(s.globals.SVGNS, "title");
                    if (b.textContent = Array.isArray(n) ? n.join(" ") : n, x.node.appendChild(b), 0 !== s.config.yaxis[t].labels.rotate) {
                        var v = r.rotateAroundCenter(x.node);
                        x.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[t].labels.rotate, " 0 ").concat(v.y, ")"));
                    }
                    i += e;
                }, p = 0; p <= h.length - 1; p++)u(p);
                if (void 0 !== s.config.yaxis[0].title.text) {
                    var f = r.group({
                        class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                        transform: "translate(" + o + ", 0)"
                    }), x = r.drawText({
                        x: s.config.yaxis[0].title.offsetX,
                        y: s.globals.gridHeight / 2 + s.config.yaxis[0].title.offsetY,
                        text: s.config.yaxis[0].title.text,
                        textAnchor: "middle",
                        foreColor: s.config.yaxis[0].title.style.color,
                        fontSize: s.config.yaxis[0].title.style.fontSize,
                        fontWeight: s.config.yaxis[0].title.style.fontWeight,
                        fontFamily: s.config.yaxis[0].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                    });
                    f.add(x), n.add(f);
                }
                var b = 0;
                this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (b = s.globals.gridWidth);
                var v = s.config.xaxis.axisBorder;
                if (v.show) {
                    var y = r.drawLine(s.globals.padHorizontal + v.offsetX + b, 1 + v.offsetY, s.globals.padHorizontal + v.offsetX + b, s.globals.gridHeight + v.offsetY, v.color, 0);
                    this.elgrid && this.elgrid.elGridBorders && s.config.grid.show ? this.elgrid.elGridBorders.add(y) : n.add(y);
                }
                return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(b, h.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, e, n), n;
            }
        },
        {
            key: "drawXaxisTicks",
            value: function(t, e, i) {
                var a = this.w, s = t;
                if (!(t < 0 || t - 2 > a.globals.gridWidth)) {
                    var r = this.offY + a.config.xaxis.axisTicks.offsetY;
                    if (e = e + r + a.config.xaxis.axisTicks.height, "top" === a.config.xaxis.position && (e = r - a.config.xaxis.axisTicks.height), a.config.xaxis.axisTicks.show) {
                        var o = new m(this.ctx).drawLine(t + a.config.xaxis.axisTicks.offsetX, r + a.config.xaxis.offsetY, s + a.config.xaxis.axisTicks.offsetX, e + a.config.xaxis.offsetY, a.config.xaxis.axisTicks.color);
                        i.add(o), o.node.classList.add("apexcharts-xaxis-tick");
                    }
                }
            }
        },
        {
            key: "getXAxisTicksPositions",
            value: function() {
                var t = this.w, e = [], i = this.xaxisLabels.length, a = t.globals.padHorizontal;
                if (t.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, e.push(a);
                else for(var r = i, o = 0; o < r; o++){
                    var n = r;
                    t.globals.isXNumeric && "bar" !== t.config.chart.type && (n -= 1), a += t.globals.gridWidth / n, e.push(a);
                }
                return e;
            }
        },
        {
            key: "xAxisLabelCorrections",
            value: function() {
                var t = this.w, e = new m(this.ctx), i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                if (t.globals.rotateXLabels || t.config.xaxis.labels.rotateAlways) for(var o = 0; o < a.length; o++){
                    var n = e.rotateAroundCenter(a[o]);
                    n.y = n.y - 1, n.x = n.x + 1, a[o].setAttribute("transform", "rotate(".concat(t.config.xaxis.labels.rotate, " ").concat(n.x, " ").concat(n.y, ")")), a[o].setAttribute("text-anchor", "end");
                    i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                    var l = a[o].childNodes;
                    t.config.xaxis.labels.trim && Array.prototype.forEach.call(l, function(i) {
                        e.placeTextWithEllipsis(i, i.textContent, t.globals.xAxisLabelsHeight - ("bottom" === t.config.legend.position ? 20 : 10));
                    });
                }
                else !function() {
                    for(var i = t.globals.gridWidth / (t.globals.labels.length + 1), s = 0; s < a.length; s++){
                        var r = a[s].childNodes;
                        t.config.xaxis.labels.trim && "datetime" !== t.config.xaxis.type && Array.prototype.forEach.call(r, function(t) {
                            e.placeTextWithEllipsis(t, t.textContent, i);
                        });
                    }
                }();
                if (s.length > 0) {
                    var h = s[s.length - 1].getBBox(), c = s[0].getBBox();
                    h.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), c.x + c.width > t.globals.gridWidth && !t.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                    for(var d = 0; d < r.length; d++)e.placeTextWithEllipsis(r[d], r[d].textContent, t.config.yaxis[0].labels.maxWidth - (t.config.yaxis[0].title.text ? 2 * parseFloat(t.config.yaxis[0].title.style.fontSize) : 0) - 15);
                }
            }
        }
    ]), t;
}(), j = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.xaxisLabels = i.globals.labels.slice(), this.axesUtils = new B(e), this.isRangeBar = i.globals.seriesRange.length && i.globals.isBarHorizontal, i.globals.timescaleLabels.length > 0 && (this.xaxisLabels = i.globals.timescaleLabels.slice());
    }
    return r(t, [
        {
            key: "drawGridArea",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w, i = new m(this.ctx);
                null === t && (t = i.group({
                    class: "apexcharts-grid"
                }));
                var a = i.drawLine(e.globals.padHorizontal, 1, e.globals.padHorizontal, e.globals.gridHeight, "transparent"), s = i.drawLine(e.globals.padHorizontal, e.globals.gridHeight, e.globals.gridWidth, e.globals.gridHeight, "transparent");
                return t.add(s), t.add(a), t;
            }
        },
        {
            key: "drawGrid",
            value: function() {
                var t = null;
                return this.w.globals.axisCharts && (t = this.renderGrid(), this.drawGridArea(t.el)), t;
            }
        },
        {
            key: "createGridMask",
            value: function() {
                var t = this.w, e = t.globals, i = new m(this.ctx), a = Array.isArray(t.config.stroke.width) ? 0 : t.config.stroke.width;
                if (Array.isArray(t.config.stroke.width)) {
                    var s = 0;
                    t.config.stroke.width.forEach(function(t) {
                        s = Math.max(s, t);
                    }), a = s;
                }
                e.dom.elGridRectMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMask.setAttribute("id", "gridRectMask".concat(e.cuid)), e.dom.elGridRectMarkerMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMarkerMask.setAttribute("id", "gridRectMarkerMask".concat(e.cuid)), e.dom.elForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elForecastMask.setAttribute("id", "forecastMask".concat(e.cuid)), e.dom.elNonForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elNonForecastMask.setAttribute("id", "nonForecastMask".concat(e.cuid));
                var r = t.config.chart.type, o = 0, n = 0;
                ("bar" === r || "rangeBar" === r || "candlestick" === r || "boxPlot" === r || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && (o = t.config.grid.padding.left, n = t.config.grid.padding.right, e.barPadForNumericAxis > o && (o = e.barPadForNumericAxis, n = e.barPadForNumericAxis)), e.dom.elGridRect = i.drawRect(-a - o - 2, 2 * -a - 2, e.gridWidth + a + n + o + 4, e.gridHeight + 4 * a + 4, 0, "#fff");
                var l = t.globals.markers.largestSize + 1;
                e.dom.elGridRectMarker = i.drawRect(2 * -l, 2 * -l, e.gridWidth + 4 * l, e.gridHeight + 4 * l, 0, "#fff"), e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node), e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);
                var h = e.dom.baseEl.querySelector("defs");
                h.appendChild(e.dom.elGridRectMask), h.appendChild(e.dom.elForecastMask), h.appendChild(e.dom.elNonForecastMask), h.appendChild(e.dom.elGridRectMarkerMask);
            }
        },
        {
            key: "_drawGridLines",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w;
                if (!(0 === e && l.globals.skipFirstTimelinelabel || e === o - 1 && l.globals.skipLastTimelinelabel && !l.config.xaxis.labels.formatter || "radar" === l.config.chart.type)) {
                    l.config.grid.xaxis.lines.show && this._drawGridLine({
                        i: e,
                        x1: i,
                        y1: a,
                        x2: s,
                        y2: r,
                        xCount: o,
                        parent: n
                    });
                    var h = 0;
                    if (l.globals.hasXaxisGroups && "between" === l.config.xaxis.tickPlacement) {
                        var c = l.globals.groups;
                        if (c) {
                            for(var d = 0, g = 0; d < e && g < c.length; g++)d += c[g].cols;
                            d === e && (h = .6 * l.globals.xAxisLabelsHeight);
                        }
                    }
                    new V(this.ctx).drawXaxisTicks(i, h, l.globals.dom.elGraphical);
                }
            }
        },
        {
            key: "_drawGridLine",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w, h = !1, c = n.node.classList.contains("apexcharts-gridlines-horizontal"), d = l.config.grid.strokeDashArray, g = l.globals.barPadForNumericAxis;
                (0 === a && 0 === r || 0 === i && 0 === s) && (h = !0), a === l.globals.gridHeight && r === l.globals.gridHeight && (h = !0), !l.globals.isBarHorizontal || 0 !== e && e !== o - 1 || (h = !0);
                var u = new m(this).drawLine(i - (c ? g : 0), a, s + (c ? g : 0), r, l.config.grid.borderColor, d);
                u.node.classList.add("apexcharts-gridline"), h && l.config.grid.show ? this.elGridBorders.add(u) : n.add(u);
            }
        },
        {
            key: "_drawGridBandRect",
            value: function(t) {
                var e = t.c, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.type, n = this.w, l = new m(this.ctx), h = n.globals.barPadForNumericAxis;
                if ("column" !== o || "datetime" !== n.config.xaxis.type) {
                    var c = n.config.grid[o].colors[e], d = l.drawRect(i - ("row" === o ? h : 0), a, s + ("row" === o ? 2 * h : 0), r, 0, c, n.config.grid[o].opacity);
                    this.elg.add(d), d.attr("clip-path", "url(#gridRectMask".concat(n.globals.cuid, ")")), d.node.classList.add("apexcharts-grid-".concat(o));
                }
            }
        },
        {
            key: "_drawXYLines",
            value: function(t) {
                var e = this, i = t.xCount, a = t.tickAmount, s = this.w;
                if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                    var r, o = s.globals.padHorizontal, n = s.globals.gridHeight;
                    s.globals.timescaleLabels.length ? function(t) {
                        for(var a = t.xC, s = t.x1, r = t.y1, o = t.x2, n = t.y2, l = 0; l < a; l++)s = e.xaxisLabels[l].position, o = e.xaxisLabels[l].position, e._drawGridLines({
                            i: l,
                            x1: s,
                            y1: r,
                            x2: o,
                            y2: n,
                            xCount: i,
                            parent: e.elgridLinesV
                        });
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), function(t) {
                        for(var a = t.xC, r = t.x1, o = t.y1, n = t.x2, l = t.y2, h = 0; h < a + (s.globals.isXNumeric ? 0 : 1); h++)0 === h && 1 === a && 1 === s.globals.dataPoints && (n = r = s.globals.gridWidth / 2), e._drawGridLines({
                            i: h,
                            x1: r,
                            y1: o,
                            x2: n,
                            y2: l,
                            xCount: i,
                            parent: e.elgridLinesV
                        }), n = r += s.globals.gridWidth / (s.globals.isXNumeric ? a - 1 : a);
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }));
                }
                if (s.config.grid.yaxis.lines.show) {
                    var l = 0, h = 0, c = s.globals.gridWidth, d = a + 1;
                    this.isRangeBar && (d = s.globals.labels.length);
                    for(var g = 0; g < d + (this.isRangeBar ? 1 : 0); g++)this._drawGridLine({
                        i: g,
                        xCount: d + (this.isRangeBar ? 1 : 0),
                        x1: 0,
                        y1: l,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = l += s.globals.gridHeight / (this.isRangeBar ? d : a);
                }
            }
        },
        {
            key: "_drawInvertedXYLines",
            value: function(t) {
                var e = t.xCount, i = this.w;
                if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, o = 0; o < e + 1; o++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                    i: o,
                    xCount: e + 1,
                    x1: s,
                    y1: 0,
                    x2: a,
                    y2: r,
                    parent: this.elgridLinesV
                }), new V(this.ctx).drawXaxisTicks(s, 0, i.globals.dom.elGraphical), a = s = s + i.globals.gridWidth / e + .3;
                if (i.config.grid.yaxis.lines.show) for(var n = 0, l = 0, h = i.globals.gridWidth, c = 0; c < i.globals.dataPoints + 1; c++)this._drawGridLine({
                    i: c,
                    xCount: i.globals.dataPoints + 1,
                    x1: 0,
                    y1: n,
                    x2: h,
                    y2: l,
                    parent: this.elgridLinesH
                }), l = n += i.globals.gridHeight / i.globals.dataPoints;
            }
        },
        {
            key: "renderGrid",
            value: function() {
                var t = this.w, e = new m(this.ctx);
                this.elg = e.group({
                    class: "apexcharts-grid"
                }), this.elgridLinesH = e.group({
                    class: "apexcharts-gridlines-horizontal"
                }), this.elgridLinesV = e.group({
                    class: "apexcharts-gridlines-vertical"
                }), this.elGridBorders = e.group({
                    class: "apexcharts-grid-borders"
                }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), t.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
                for(var i, a = t.globals.yAxisScale.length ? t.globals.yAxisScale[0].result.length - 1 : 5, s = 0; s < t.globals.series.length && (void 0 !== t.globals.yAxisScale[s] && (a = t.globals.yAxisScale[s].result.length - 1), !(a > 2)); s++);
                if (!t.globals.isBarHorizontal || this.isRangeBar) {
                    var r, o, n;
                    if (i = this.xaxisLabels.length, this.isRangeBar) i--, a = t.globals.labels.length, t.config.xaxis.tickAmount && t.config.xaxis.labels.formatter && (i = t.config.xaxis.tickAmount), (null === (r = t.globals.yAxisScale) || void 0 === r || null === (o = r[0]) || void 0 === o || null === (n = o.result) || void 0 === n ? void 0 : n.length) > 0 && "datetime" !== t.config.xaxis.type && (i = t.globals.yAxisScale[0].result.length - 1);
                    this._drawXYLines({
                        xCount: i,
                        tickAmount: a
                    });
                } else i = a, a = t.globals.xTickAmount, this._drawInvertedXYLines({
                    xCount: i,
                    tickAmount: a
                });
                return this.drawGridBands(i, a), {
                    el: this.elg,
                    elGridBorders: this.elGridBorders,
                    xAxisTickWidth: t.globals.gridWidth / i
                };
            }
        },
        {
            key: "drawGridBands",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== i.config.grid.row.colors && i.config.grid.row.colors.length > 0) for(var a = 0, s = i.globals.gridHeight / e, r = i.globals.gridWidth, o = 0, n = 0; o < e; o++, n++)n >= i.config.grid.row.colors.length && (n = 0), this._drawGridBandRect({
                    c: n,
                    x1: 0,
                    y1: a,
                    x2: r,
                    y2: s,
                    type: "row"
                }), a += i.globals.gridHeight / e;
                if (void 0 !== i.config.grid.column.colors && i.config.grid.column.colors.length > 0) for(var l = i.globals.isBarHorizontal || "on" !== i.config.xaxis.tickPlacement || "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric ? t : t - 1, h = i.globals.padHorizontal, c = i.globals.padHorizontal + i.globals.gridWidth / l, d = i.globals.gridHeight, g = 0, u = 0; g < t; g++, u++)u >= i.config.grid.column.colors.length && (u = 0), this._drawGridBandRect({
                    c: u,
                    x1: h,
                    y1: 0,
                    x2: c,
                    y2: d,
                    type: "column"
                }), h += i.globals.gridWidth / l;
            }
        }
    ]), t;
}(), _ = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "niceScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 5, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 ? arguments[4] : void 0, r = this.w, o = Math.abs(e - t);
                if ("dataPoints" === (i = this._adjustTicksForSmallRange(i, a, o)) && (i = r.globals.dataPoints - 1), t === Number.MIN_VALUE && 0 === e || !x.isNumber(t) && !x.isNumber(e) || t === Number.MIN_VALUE && e === -Number.MAX_VALUE) return t = 0, e = i, this.linearScale(t, e, i, a, r.config.yaxis[a].stepSize);
                t > e ? (console.warn("axis.min cannot be greater than axis.max"), e = t + .1) : t === e && (t = 0 === t ? 0 : t - .5, e = 0 === e ? 2 : e + .5);
                var n = [];
                o < 1 && s && ("candlestick" === r.config.chart.type || "candlestick" === r.config.series[a].type || "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[a].type || r.globals.isRangeData) && (e *= 1.01);
                var l = i + 1;
                l < 2 ? l = 2 : l > 2 && (l -= 2);
                var h = o / l, c = Math.floor(x.log10(h)), d = Math.pow(10, c), g = Math.round(h / d);
                g < 1 && (g = 1);
                var u = g * d;
                r.config.yaxis[a].stepSize && (u = r.config.yaxis[a].stepSize), r.globals.isBarHorizontal && r.config.xaxis.stepSize && "datetime" !== r.config.xaxis.type && (u = r.config.xaxis.stepSize);
                var p = u * Math.floor(t / u), f = u * Math.ceil(e / u), b = p;
                if (s && o > 2) {
                    for(; n.push(x.stripNumber(b, 7)), !((b += u) > f););
                    return {
                        result: n,
                        niceMin: n[0],
                        niceMax: n[n.length - 1]
                    };
                }
                var v = t;
                (n = []).push(x.stripNumber(v, 7));
                for(var m = Math.abs(e - t) / i, y = 0; y <= i; y++)v += m, n.push(v);
                return n[n.length - 2] >= e && n.pop(), {
                    result: n,
                    niceMin: n[0],
                    niceMax: n[n.length - 1]
                };
            }
        },
        {
            key: "linearScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 5, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : void 0, r = Math.abs(e - t);
                "dataPoints" === (i = this._adjustTicksForSmallRange(i, a, r)) && (i = this.w.globals.dataPoints - 1), s || (s = r / i), i === Number.MAX_VALUE && (i = 5, s = 1);
                for(var o = [], n = t; i >= 0;)o.push(n), n += s, i -= 1;
                return {
                    result: o,
                    niceMin: o[0],
                    niceMax: o[o.length - 1]
                };
            }
        },
        {
            key: "logarithmicScaleNice",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.ceil(Math.log(e) / Math.log(i) + 1), r = Math.floor(Math.log(t) / Math.log(i)); r < s; r++)a.push(Math.pow(i, r));
                return {
                    result: a,
                    niceMin: a[0],
                    niceMax: a[a.length - 1]
                };
            }
        },
        {
            key: "logarithmicScale",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.log(e) / Math.log(i), r = Math.log(t) / Math.log(i), o = s - r, n = Math.round(o), l = o / n, h = 0, c = r; h < n; h++, c += l)a.push(Math.pow(i, c));
                return a.push(Math.pow(i, s)), {
                    result: a,
                    niceMin: t,
                    niceMax: e
                };
            }
        },
        {
            key: "_adjustTicksForSmallRange",
            value: function(t, e, i) {
                var a = t;
                if (void 0 !== e && this.w.config.yaxis[e].labels.formatter && void 0 === this.w.config.yaxis[e].tickAmount) {
                    var s = Number(this.w.config.yaxis[e].labels.formatter(1));
                    x.isNumber(s) && 0 === this.w.globals.yValueDecimal && (a = Math.ceil(i));
                }
                return a < t ? a : t;
            }
        },
        {
            key: "setYScaleForIndex",
            value: function(t, e, i) {
                var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[t];
                void 0 === a.yAxisScale[t] && (a.yAxisScale[t] = []);
                var o = Math.abs(i - e);
                if (r.logarithmic && o <= 5 && (a.invalidLogScale = !0), r.logarithmic && o > 5) a.allSeriesCollapsed = !1, a.yAxisScale[t] = this.logarithmicScale(e, i, r.logBase), a.yAxisScale[t] = r.forceNiceScale ? this.logarithmicScaleNice(e, i, r.logBase) : this.logarithmicScale(e, i, r.logBase);
                else if (i !== -Number.MAX_VALUE && x.isNumber(i)) {
                    if (a.allSeriesCollapsed = !1, void 0 === r.min && void 0 === r.max || r.forceNiceScale) {
                        var n = void 0 === s.yaxis[t].max && void 0 === s.yaxis[t].min || s.yaxis[t].forceNiceScale;
                        a.yAxisScale[t] = this.niceScale(e, i, r.tickAmount ? r.tickAmount : o < 5 && o > 1 ? o + 1 : 5, t, n);
                    } else a.yAxisScale[t] = this.linearScale(e, i, r.tickAmount, t, s.yaxis[t].stepSize);
                } else a.yAxisScale[t] = this.linearScale(0, 5, 5, t, s.yaxis[t].stepSize);
            }
        },
        {
            key: "setXScale",
            value: function(t, e) {
                var i = this.w, a = i.globals, s = Math.abs(e - t);
                return e !== -Number.MAX_VALUE && x.isNumber(e) ? a.xAxisScale = this.linearScale(t, e, i.config.xaxis.tickAmount ? i.config.xaxis.tickAmount : s < 5 && s > 1 ? s + 1 : 5, 0, i.config.xaxis.stepSize) : a.xAxisScale = this.linearScale(0, 5, 5), a.xAxisScale;
            }
        },
        {
            key: "setMultipleYScales",
            value: function() {
                var t = this, e = this.w.globals, i = this.w.config, a = e.minYArr.concat([]), s = e.maxYArr.concat([]), r = [];
                i.yaxis.forEach(function(e, o) {
                    var n = o;
                    i.series.forEach(function(t, i) {
                        t.name === e.seriesName && (n = i, o !== i ? r.push({
                            index: i,
                            similarIndex: o,
                            alreadyExists: !0
                        }) : r.push({
                            index: i
                        }));
                    });
                    var l = a[n], h = s[n];
                    t.setYScaleForIndex(o, l, h);
                }), this.sameScaleInMultipleAxes(a, s, r);
            }
        },
        {
            key: "sameScaleInMultipleAxes",
            value: function(t, e, i) {
                var a = this, s = this.w.config, r = this.w.globals, o = [];
                i.forEach(function(t) {
                    t.alreadyExists && (void 0 === o[t.index] && (o[t.index] = []), o[t.index].push(t.index), o[t.index].push(t.similarIndex));
                }), r.yAxisSameScaleIndices = o, o.forEach(function(t, e) {
                    o.forEach(function(i, a) {
                        var s, r;
                        e !== a && (s = t, r = i, s.filter(function(t) {
                            return -1 !== r.indexOf(t);
                        })).length > 0 && (o[e] = o[e].concat(o[a]));
                    });
                });
                var n = o.map(function(t) {
                    return t.filter(function(e, i) {
                        return t.indexOf(e) === i;
                    });
                }).map(function(t) {
                    return t.sort();
                });
                o = o.filter(function(t) {
                    return !!t;
                });
                var l = n.slice(), h = l.map(function(t) {
                    return JSON.stringify(t);
                });
                l = l.filter(function(t, e) {
                    return h.indexOf(JSON.stringify(t)) === e;
                });
                var c = [], d = [];
                t.forEach(function(t, i) {
                    l.forEach(function(a, s) {
                        a.indexOf(i) > -1 && (void 0 === c[s] && (c[s] = [], d[s] = []), c[s].push({
                            key: i,
                            value: t
                        }), d[s].push({
                            key: i,
                            value: e[i]
                        }));
                    });
                });
                var g = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, Number.MIN_VALUE), u = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, -Number.MAX_VALUE);
                c.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        g[e] = Math.min(t.value, g[e]);
                    });
                }), d.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        u[e] = Math.max(t.value, u[e]);
                    });
                }), t.forEach(function(t, e) {
                    d.forEach(function(t, i) {
                        var o = g[i], n = u[i];
                        s.chart.stacked && (n = 0, t.forEach(function(t, e) {
                            t.value !== -Number.MAX_VALUE && (n += t.value), o !== Number.MIN_VALUE && (o += c[i][e].value);
                        })), t.forEach(function(i, l) {
                            t[l].key === e && (void 0 !== s.yaxis[e].min && (o = "function" == typeof s.yaxis[e].min ? s.yaxis[e].min(r.minY) : s.yaxis[e].min), void 0 !== s.yaxis[e].max && (n = "function" == typeof s.yaxis[e].max ? s.yaxis[e].max(r.maxY) : s.yaxis[e].max), a.setYScaleForIndex(e, o, n));
                        });
                    });
                });
            }
        },
        {
            key: "autoScaleY",
            value: function(t, e, i) {
                t || (t = this);
                var a = t.w;
                if (a.globals.isMultipleYAxis || a.globals.collapsedSeries.length) return console.warn("autoScaleYaxis not supported in a multi-yaxis chart."), e;
                var s = a.globals.seriesX[0], r = a.config.chart.stacked;
                return e.forEach(function(t, o) {
                    for(var n = 0, l = 0; l < s.length; l++)if (s[l] >= i.xaxis.min) {
                        n = l;
                        break;
                    }
                    var h, c, d = a.globals.minYArr[o], g = a.globals.maxYArr[o], u = a.globals.stackedSeriesTotals;
                    a.globals.series.forEach(function(o, l) {
                        var p = o[n];
                        r ? (p = u[n], h = c = p, u.forEach(function(t, e) {
                            s[e] <= i.xaxis.max && s[e] >= i.xaxis.min && (t > c && null !== t && (c = t), o[e] < h && null !== o[e] && (h = o[e]));
                        })) : (h = c = p, o.forEach(function(t, e) {
                            if (s[e] <= i.xaxis.max && s[e] >= i.xaxis.min) {
                                var r = t, o = t;
                                a.globals.series.forEach(function(i, a) {
                                    null !== t && (r = Math.min(i[e], r), o = Math.max(i[e], o));
                                }), o > c && null !== o && (c = o), r < h && null !== r && (h = r);
                            }
                        })), void 0 === h && void 0 === c && (h = d, c = g), c *= c < 0 ? .9 : 1.1, 0 === (h *= h < 0 ? 1.1 : .9) && 0 === c && (h = -1, c = 1), c < 0 && c < g && (c = g), h < 0 && h > d && (h = d), e.length > 1 ? (e[l].min = void 0 === t.min ? h : t.min, e[l].max = void 0 === t.max ? c : t.max) : (e[0].min = void 0 === t.min ? h : t.min, e[0].max = void 0 === t.max ? c : t.max);
                    });
                }), e;
            }
        }
    ]), t;
}(), U = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.scales = new _(e);
    }
    return r(t, [
        {
            key: "init",
            value: function() {
                this.setYRange(), this.setXRange(), this.setZRange();
            }
        },
        {
            key: "getMinYMaxY",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w.config, r = this.w.globals, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                null === a && (a = t + 1);
                var l = r.series, h = l, c = l;
                "candlestick" === s.chart.type ? (h = r.seriesCandleL, c = r.seriesCandleH) : "boxPlot" === s.chart.type ? (h = r.seriesCandleO, c = r.seriesCandleC) : r.isRangeData && (h = r.seriesRangeStart, c = r.seriesRangeEnd);
                for(var d = t; d < a; d++){
                    r.dataPoints = Math.max(r.dataPoints, l[d].length), r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(t) {
                        return void 0 !== t;
                    }).length), r.labels.length && "datetime" !== s.xaxis.type && 0 !== r.series.reduce(function(t, e) {
                        return t + e.length;
                    }, 0) && (r.dataPoints = Math.max(r.dataPoints, r.labels.length));
                    for(var g = 0; g < r.series[d].length; g++){
                        var u = l[d][g];
                        null !== u && x.isNumber(u) ? (void 0 !== c[d][g] && (o = Math.max(o, c[d][g]), e = Math.min(e, c[d][g])), void 0 !== h[d][g] && (e = Math.min(e, h[d][g]), i = Math.max(i, h[d][g])), "candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type && "rangeArea" === this.w.config.chart.type && "rangeBar" === this.w.config.chart.type || ("candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type || void 0 !== r.seriesCandleC[d][g] && (o = Math.max(o, r.seriesCandleO[d][g]), o = Math.max(o, r.seriesCandleH[d][g]), o = Math.max(o, r.seriesCandleL[d][g]), o = Math.max(o, r.seriesCandleC[d][g]), "boxPlot" === this.w.config.chart.type && (o = Math.max(o, r.seriesCandleM[d][g]))), !s.series[d].type || "candlestick" === s.series[d].type && "boxPlot" === s.series[d].type && "rangeArea" === s.series[d].type && "rangeBar" === s.series[d].type || (o = Math.max(o, r.series[d][g]), e = Math.min(e, r.series[d][g])), i = o), r.seriesGoals[d] && r.seriesGoals[d][g] && Array.isArray(r.seriesGoals[d][g]) && r.seriesGoals[d][g].forEach(function(t) {
                            n !== Number.MIN_VALUE && (n = Math.min(n, t.value), e = n), o = Math.max(o, t.value), i = o;
                        }), x.isFloat(u) && (u = x.noExponents(u), r.yValueDecimal = Math.max(r.yValueDecimal, u.toString().split(".")[1].length)), n > h[d][g] && h[d][g] < 0 && (n = h[d][g])) : r.hasNullValues = !0;
                    }
                }
                return "rangeBar" === s.chart.type && r.seriesRangeStart.length && r.isBarHorizontal && (n = e), "bar" === s.chart.type && (n < 0 && o < 0 && (o = 0), n === Number.MIN_VALUE && (n = 0)), {
                    minY: n,
                    maxY: o,
                    lowestY: e,
                    highestY: i
                };
            }
        },
        {
            key: "setYRange",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE;
                var i = Number.MAX_VALUE;
                if (t.isMultipleYAxis) for(var a = 0; a < t.series.length; a++){
                    var s = this.getMinYMaxY(a, i, null, a + 1);
                    t.minYArr.push(s.minY), t.maxYArr.push(s.maxY), i = s.lowestY;
                }
                var r = this.getMinYMaxY(0, i, null, t.series.length);
                if (t.minY = r.minY, t.maxY = r.maxY, i = r.lowestY, e.chart.stacked && this._setStackedMinMax(), ("line" === e.chart.type || "area" === e.chart.type || "candlestick" === e.chart.type || "boxPlot" === e.chart.type || "rangeBar" === e.chart.type && !t.isBarHorizontal) && t.minY === Number.MIN_VALUE && i !== -Number.MAX_VALUE && i !== t.maxY) {
                    var o = t.maxY - i;
                    (i >= 0 && i <= 10 || void 0 !== e.yaxis[0].min || void 0 !== e.yaxis[0].max) && (o = 0), t.minY = i - 5 * o / 100, i > 0 && t.minY < 0 && (t.minY = 0), t.maxY = t.maxY + 5 * o / 100;
                }
                if (e.yaxis.forEach(function(e, i) {
                    void 0 !== e.max && ("number" == typeof e.max ? t.maxYArr[i] = e.max : "function" == typeof e.max && (t.maxYArr[i] = e.max(t.isMultipleYAxis ? t.maxYArr[i] : t.maxY)), t.maxY = t.maxYArr[i]), void 0 !== e.min && ("number" == typeof e.min ? t.minYArr[i] = e.min : "function" == typeof e.min && (t.minYArr[i] = e.min(t.isMultipleYAxis ? t.minYArr[i] === Number.MIN_VALUE ? 0 : t.minYArr[i] : t.minY)), t.minY = t.minYArr[i]);
                }), t.isBarHorizontal) [
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== e.xaxis[i] && "number" == typeof e.xaxis[i] && ("min" === i ? t.minY = e.xaxis[i] : t.maxY = e.xaxis[i]);
                });
                return t.isMultipleYAxis ? (this.scales.setMultipleYScales(), t.minY = i, t.yAxisScale.forEach(function(e, i) {
                    t.minYArr[i] = e.niceMin, t.maxYArr[i] = e.niceMax;
                })) : (this.scales.setYScaleForIndex(0, t.minY, t.maxY), t.minY = t.yAxisScale[0].niceMin, t.maxY = t.yAxisScale[0].niceMax, t.minYArr[0] = t.yAxisScale[0].niceMin, t.maxYArr[0] = t.yAxisScale[0].niceMax), {
                    minY: t.minY,
                    maxY: t.maxY,
                    minYArr: t.minYArr,
                    maxYArr: t.maxYArr,
                    yAxisScale: t.yAxisScale
                };
            }
        },
        {
            key: "setXRange",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = "numeric" === e.xaxis.type || "datetime" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided || t.noLabelsProvided || t.isXNumeric;
                if (t.isXNumeric && function() {
                    for(var e = 0; e < t.series.length; e++)if (t.labels[e]) for(var i = 0; i < t.labels[e].length; i++)null !== t.labels[e][i] && x.isNumber(t.labels[e][i]) && (t.maxX = Math.max(t.maxX, t.labels[e][i]), t.initialMaxX = Math.max(t.maxX, t.labels[e][i]), t.minX = Math.min(t.minX, t.labels[e][i]), t.initialMinX = Math.min(t.minX, t.labels[e][i]));
                }(), t.noLabelsProvided && 0 === e.xaxis.categories.length && (t.maxX = t.labels[t.labels.length - 1], t.initialMaxX = t.labels[t.labels.length - 1], t.minX = 1, t.initialMinX = 1), t.isXNumeric || t.noLabelsProvided || t.dataFormatXNumeric) {
                    var a;
                    if (void 0 === e.xaxis.tickAmount ? (a = Math.round(t.svgWidth / 150), "numeric" === e.xaxis.type && t.dataPoints < 30 && (a = t.dataPoints - 1), a > t.dataPoints && 0 !== t.dataPoints && (a = t.dataPoints - 1)) : "dataPoints" === e.xaxis.tickAmount ? (t.series.length > 1 && (a = t.series[t.maxValsInArrayIndex].length - 1), t.isXNumeric && (a = t.maxX - t.minX - 1)) : a = e.xaxis.tickAmount, t.xTickAmount = a, void 0 !== e.xaxis.max && "number" == typeof e.xaxis.max && (t.maxX = e.xaxis.max), void 0 !== e.xaxis.min && "number" == typeof e.xaxis.min && (t.minX = e.xaxis.min), void 0 !== e.xaxis.range && (t.minX = t.maxX - e.xaxis.range), t.minX !== Number.MAX_VALUE && t.maxX !== -Number.MAX_VALUE) {
                        if (e.xaxis.convertedCatToNumeric && !t.dataFormatXNumeric) {
                            for(var s = [], r = t.minX - 1; r < t.maxX; r++)s.push(r + 1);
                            t.xAxisScale = {
                                result: s,
                                niceMin: s[0],
                                niceMax: s[s.length - 1]
                            };
                        } else t.xAxisScale = this.scales.setXScale(t.minX, t.maxX);
                    } else t.xAxisScale = this.scales.linearScale(0, a, a, 0, e.xaxis.stepSize), t.noLabelsProvided && t.labels.length > 0 && (t.xAxisScale = this.scales.linearScale(1, t.labels.length, a - 1, 0, e.xaxis.stepSize), t.seriesX = t.labels.slice());
                    i && (t.labels = t.xAxisScale.result.slice());
                }
                return t.isBarHorizontal && t.labels.length && (t.xTickAmount = t.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                    minX: t.minX,
                    maxX: t.maxX
                };
            }
        },
        {
            key: "setZRange",
            value: function() {
                var t = this.w.globals;
                if (t.isDataXYZ) {
                    for(var e = 0; e < t.series.length; e++)if (void 0 !== t.seriesZ[e]) for(var i = 0; i < t.seriesZ[e].length; i++)null !== t.seriesZ[e][i] && x.isNumber(t.seriesZ[e][i]) && (t.maxZ = Math.max(t.maxZ, t.seriesZ[e][i]), t.minZ = Math.min(t.minZ, t.seriesZ[e][i]));
                }
            }
        },
        {
            key: "_handleSingleDataPoint",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                if (t.minX === t.maxX) {
                    var i = new I(this.ctx);
                    if ("datetime" === e.xaxis.type) {
                        var a = i.getDate(t.minX);
                        e.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), t.minX = new Date(a).getTime();
                        var s = i.getDate(t.maxX);
                        e.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), t.maxX = new Date(s).getTime();
                    } else ("numeric" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided) && (t.minX = t.minX - 2, t.initialMinX = t.minX, t.maxX = t.maxX + 2, t.initialMaxX = t.maxX);
                }
            }
        },
        {
            key: "_getMinXDiff",
            value: function() {
                var t = this.w.globals;
                t.isXNumeric && t.seriesX.forEach(function(e, i) {
                    1 === e.length && e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length - 1]);
                    var a = e.slice();
                    a.sort(function(t, e) {
                        return t - e;
                    }), a.forEach(function(e, i) {
                        if (i > 0) {
                            var s = e - a[i - 1];
                            s > 0 && (t.minXDiff = Math.min(s, t.minXDiff));
                        }
                    }), 1 !== t.dataPoints && t.minXDiff !== Number.MAX_VALUE || (t.minXDiff = .5);
                });
            }
        },
        {
            key: "_setStackedMinMax",
            value: function() {
                var t = this, e = this.w.globals;
                if (e.series.length) {
                    var i = e.seriesGroups;
                    i.length || (i = [
                        this.w.config.series.map(function(t) {
                            return t.name;
                        })
                    ]);
                    var a = {}, s = {};
                    i.forEach(function(i) {
                        a[i] = [], s[i] = [], t.w.config.series.map(function(t, e) {
                            return i.indexOf(t.name) > -1 ? e : null;
                        }).filter(function(t) {
                            return null !== t;
                        }).forEach(function(r) {
                            for(var o = 0; o < e.series[e.maxValsInArrayIndex].length; o++){
                                var n, l;
                                void 0 === a[i][o] && (a[i][o] = 0, s[i][o] = 0), (t.w.config.chart.stacked && !e.comboCharts || t.w.config.chart.stacked && e.comboCharts && (!t.w.config.chart.stackOnlyBar || "bar" === (null === (n = t.w.config.series) || void 0 === n || null === (l = n[r]) || void 0 === l ? void 0 : l.type))) && null !== e.series[r][o] && x.isNumber(e.series[r][o]) && (e.series[r][o] > 0 ? a[i][o] += parseFloat(e.series[r][o]) + 1e-4 : s[i][o] += parseFloat(e.series[r][o]));
                            }
                        });
                    }), Object.entries(a).forEach(function(t) {
                        var i = g(t, 1)[0];
                        a[i].forEach(function(t, r) {
                            e.maxY = Math.max(e.maxY, a[i][r]), e.minY = Math.min(e.minY, s[i][r]);
                        });
                    });
                }
            }
        }
    ]), t;
}(), q = function() {
    function t(e, i) {
        a(this, t), this.ctx = e, this.elgrid = i, this.w = e.w;
        var s = this.w;
        this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.axisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xAxisoffX = 0, "bottom" === s.config.xaxis.position && (this.xAxisoffX = s.globals.gridHeight), this.drawnLabels = [], this.axesUtils = new B(e);
    }
    return r(t, [
        {
            key: "drawYaxis",
            value: function(t) {
                var e = this, i = this.w, a = new m(this.ctx), s = i.config.yaxis[t].labels.style, r = s.fontSize, o = s.fontFamily, n = s.fontWeight, l = a.group({
                    class: "apexcharts-yaxis",
                    rel: t,
                    transform: "translate(" + i.globals.translateYAxisX[t] + ", 0)"
                });
                if (this.axesUtils.isYAxisHidden(t)) return l;
                var h = a.group({
                    class: "apexcharts-yaxis-texts-g"
                });
                l.add(h);
                var c = i.globals.yAxisScale[t].result.length - 1, d = i.globals.gridHeight / c, g = i.globals.translateY, u = i.globals.yLabelFormatters[t], p = i.globals.yAxisScale[t].result.slice();
                p = this.axesUtils.checkForReversedLabels(t, p);
                var f = "";
                if (i.config.yaxis[t].labels.show) for(var x = function(l) {
                    var x = p[l];
                    x = u(x, l, i);
                    var b = i.config.yaxis[t].labels.padding;
                    i.config.yaxis[t].opposite && 0 !== i.config.yaxis.length && (b *= -1);
                    var v = "end";
                    i.config.yaxis[t].opposite && (v = "start"), "left" === i.config.yaxis[t].labels.align ? v = "start" : "center" === i.config.yaxis[t].labels.align ? v = "middle" : "right" === i.config.yaxis[t].labels.align && (v = "end");
                    var m = e.axesUtils.getYAxisForeColor(s.colors, t), y = i.config.yaxis[t].labels.offsetY;
                    "heatmap" === i.config.chart.type && (y -= (i.globals.gridHeight / i.globals.series.length - 1) / 2);
                    var w = a.drawText({
                        x: b,
                        y: g + c / 10 + y + 1,
                        text: x,
                        textAnchor: v,
                        fontSize: r,
                        fontFamily: o,
                        fontWeight: n,
                        maxWidth: i.config.yaxis[t].labels.maxWidth,
                        foreColor: Array.isArray(m) ? m[l] : m,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + s.cssClass
                    });
                    l === c && (f = w), h.add(w);
                    var k = document.createElementNS(i.globals.SVGNS, "title");
                    if (k.textContent = Array.isArray(x) ? x.join(" ") : x, w.node.appendChild(k), 0 !== i.config.yaxis[t].labels.rotate) {
                        var A = a.rotateAroundCenter(f.node), S = a.rotateAroundCenter(w.node);
                        w.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[t].labels.rotate, " ").concat(A.x, " ").concat(S.y, ")"));
                    }
                    g += d;
                }, b = c; b >= 0; b--)x(b);
                if (void 0 !== i.config.yaxis[t].title.text) {
                    var v = a.group({
                        class: "apexcharts-yaxis-title"
                    }), y = 0;
                    i.config.yaxis[t].opposite && (y = i.globals.translateYAxisX[t]);
                    var w = a.drawText({
                        x: y,
                        y: i.globals.gridHeight / 2 + i.globals.translateY + i.config.yaxis[t].title.offsetY,
                        text: i.config.yaxis[t].title.text,
                        textAnchor: "end",
                        foreColor: i.config.yaxis[t].title.style.color,
                        fontSize: i.config.yaxis[t].title.style.fontSize,
                        fontWeight: i.config.yaxis[t].title.style.fontWeight,
                        fontFamily: i.config.yaxis[t].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[t].title.style.cssClass
                    });
                    v.add(w), l.add(v);
                }
                var k = i.config.yaxis[t].axisBorder, A = 31 + k.offsetX;
                if (i.config.yaxis[t].opposite && (A = -31 - k.offsetX), k.show) {
                    var S = a.drawLine(A, i.globals.translateY + k.offsetY - 2, A, i.globals.gridHeight + i.globals.translateY + k.offsetY + 2, k.color, 0, k.width);
                    l.add(S);
                }
                return i.config.yaxis[t].axisTicks.show && this.axesUtils.drawYAxisTicks(A, c, k, i.config.yaxis[t].axisTicks, t, d, l), l;
            }
        },
        {
            key: "drawYaxisInversed",
            value: function(t) {
                var e = this.w, i = new m(this.ctx), a = i.group({
                    class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                }), s = i.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                });
                a.add(s);
                var r = e.globals.yAxisScale[t].result.length - 1, o = e.globals.gridWidth / r + .1, n = o + e.config.xaxis.labels.offsetX, l = e.globals.xLabelFormatter, h = e.globals.yAxisScale[t].result.slice(), c = e.globals.timescaleLabels;
                c.length > 0 && (this.xaxisLabels = c.slice(), r = (h = c.slice()).length), h = this.axesUtils.checkForReversedLabels(t, h);
                var d = c.length;
                if (e.config.xaxis.labels.show) for(var g = d ? 0 : r; d ? g < d : g >= 0; d ? g++ : g--){
                    var u = h[g];
                    u = l(u, g, e);
                    var p = e.globals.gridWidth + e.globals.padHorizontal - (n - o + e.config.xaxis.labels.offsetX);
                    if (c.length) {
                        var f = this.axesUtils.getLabel(h, c, p, g, this.drawnLabels, this.xaxisFontSize);
                        p = f.x, u = f.text, this.drawnLabels.push(f.text), 0 === g && e.globals.skipFirstTimelinelabel && (u = ""), g === h.length - 1 && e.globals.skipLastTimelinelabel && (u = "");
                    }
                    var x = i.drawText({
                        x: p,
                        y: this.xAxisoffX + e.config.xaxis.labels.offsetY + 30 - ("top" === e.config.xaxis.position ? e.globals.xAxisHeight + e.config.xaxis.axisTicks.height - 2 : 0),
                        text: u,
                        textAnchor: "middle",
                        foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[t] : this.xaxisForeColors,
                        fontSize: this.xaxisFontSize,
                        fontFamily: this.xaxisFontFamily,
                        fontWeight: e.config.xaxis.labels.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-xaxis-label " + e.config.xaxis.labels.style.cssClass
                    });
                    s.add(x), x.tspan(u);
                    var b = document.createElementNS(e.globals.SVGNS, "title");
                    b.textContent = u, x.node.appendChild(b), n += o;
                }
                return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
            }
        },
        {
            key: "inversedYAxisBorder",
            value: function(t) {
                var e = this.w, i = new m(this.ctx), a = e.config.xaxis.axisBorder;
                if (a.show) {
                    var s = 0;
                    "bar" === e.config.chart.type && e.globals.isXNumeric && (s -= 15);
                    var r = i.drawLine(e.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, e.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                    this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(r) : t.add(r);
                }
            }
        },
        {
            key: "inversedYAxisTitleText",
            value: function(t) {
                var e = this.w, i = new m(this.ctx);
                if (void 0 !== e.config.xaxis.title.text) {
                    var a = i.group({
                        class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                    }), s = i.drawText({
                        x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                        y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(e.config.xaxis.title.style.fontSize) + e.config.xaxis.title.offsetY + 20,
                        text: e.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: e.config.xaxis.title.style.fontSize,
                        fontFamily: e.config.xaxis.title.style.fontFamily,
                        fontWeight: e.config.xaxis.title.style.fontWeight,
                        foreColor: e.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass
                    });
                    a.add(s), t.add(a);
                }
            }
        },
        {
            key: "yAxisTitleRotate",
            value: function(t, e) {
                var i = this.w, a = new m(this.ctx), s = {
                    width: 0,
                    height: 0
                }, r = {
                    width: 0,
                    height: 0
                }, o = i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-texts-g"));
                null !== o && (s = o.getBoundingClientRect());
                var n = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-title text"));
                if (null !== n && (r = n.getBoundingClientRect()), null !== n) {
                    var l = this.xPaddingForYAxisTitle(t, s, r, e);
                    n.setAttribute("x", l.xPos - (e ? 10 : 0));
                }
                if (null !== n) {
                    var h = a.rotateAroundCenter(n);
                    n.setAttribute("transform", "rotate(".concat(e ? -1 * i.config.yaxis[t].title.rotate : i.config.yaxis[t].title.rotate, " ").concat(h.x, " ").concat(h.y, ")"));
                }
            }
        },
        {
            key: "xPaddingForYAxisTitle",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = 0, n = 10;
                return void 0 === s.config.yaxis[t].title.text || t < 0 ? {
                    xPos: o,
                    padd: 0
                } : (a ? (o = e.width + s.config.yaxis[t].title.offsetX + i.width / 2 + n / 2, 0 === (r += 1) && (o -= n / 2)) : (o = -1 * e.width + s.config.yaxis[t].title.offsetX + n / 2 + i.width / 2, s.globals.isBarHorizontal && (n = 25, o = -1 * e.width - s.config.yaxis[t].title.offsetX - n)), {
                    xPos: o,
                    padd: n
                });
            }
        },
        {
            key: "setYAxisXPosition",
            value: function(t, e) {
                var i = this.w, a = 0, s = 0, r = 18, o = 1;
                i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.map(function(n, l) {
                    var h = i.globals.ignoreYAxisIndexes.indexOf(l) > -1 || !n.show || n.floating || 0 === t[l].width, c = t[l].width + e[l].width;
                    n.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[l] = s - n.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + o, h || (o = o + c + 20), i.globals.translateYAxisX[l] = s - n.labels.offsetX + 20) : (a = i.globals.translateX - r, h || (r = r + c + 20), i.globals.translateYAxisX[l] = a + n.labels.offsetX);
                });
            }
        },
        {
            key: "setYAxisTextAlignments",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");
                (e = x.listToArray(e)).forEach(function(e, i) {
                    var a = t.config.yaxis[i];
                    if (a && !a.floating && void 0 !== a.labels.align) {
                        var s = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-texts-g")), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-label"));
                        r = x.listToArray(r);
                        var o = s.getBoundingClientRect();
                        "left" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "start");
                        }), a.opposite || s.setAttribute("transform", "translate(-".concat(o.width, ", 0)"))) : "center" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "middle");
                        }), s.setAttribute("transform", "translate(".concat(o.width / 2 * (a.opposite ? 1 : -1), ", 0)"))) : "right" === a.labels.align && (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "end");
                        }), a.opposite && s.setAttribute("transform", "translate(".concat(o.width, ", 0)")));
                    }
                });
            }
        }
    ]), t;
}(), Z = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.documentEvent = x.bind(this.documentEvent, this);
    }
    return r(t, [
        {
            key: "addEventListener",
            value: function(t, e) {
                var i = this.w;
                i.globals.events.hasOwnProperty(t) ? i.globals.events[t].push(e) : i.globals.events[t] = [
                    e
                ];
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    var a = i.globals.events[t].indexOf(e);
                    -1 !== a && i.globals.events[t].splice(a, 1);
                }
            }
        },
        {
            key: "fireEvent",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    e && e.length || (e = []);
                    for(var a = i.globals.events[t], s = a.length, r = 0; r < s; r++)a[r].apply(null, e);
                }
            }
        },
        {
            key: "setupEventHandlers",
            value: function() {
                var t = this, e = this.w, i = this.ctx, a = e.globals.dom.baseEl.querySelector(e.globals.chartClass);
                this.ctx.eventList.forEach(function(t) {
                    a.addEventListener(t, function(t) {
                        var a = Object.assign({}, e, {
                            seriesIndex: e.globals.capturedSeriesIndex,
                            dataPointIndex: e.globals.capturedDataPointIndex
                        });
                        "mousemove" === t.type || "touchmove" === t.type ? "function" == typeof e.config.chart.events.mouseMove && e.config.chart.events.mouseMove(t, i, a) : "mouseleave" === t.type || "touchleave" === t.type ? "function" == typeof e.config.chart.events.mouseLeave && e.config.chart.events.mouseLeave(t, i, a) : ("mouseup" === t.type && 1 === t.which || "touchend" === t.type) && ("function" == typeof e.config.chart.events.click && e.config.chart.events.click(t, i, a), i.ctx.events.fireEvent("click", [
                            t,
                            i,
                            a
                        ]));
                    }, {
                        capture: !1,
                        passive: !0
                    });
                }), this.ctx.eventList.forEach(function(i) {
                    e.globals.dom.baseEl.addEventListener(i, t.documentEvent, {
                        passive: !0
                    });
                }), this.ctx.core.setupBrushHandler();
            }
        },
        {
            key: "documentEvent",
            value: function(t) {
                var e = this.w, i = t.target.className;
                if ("click" === t.type) {
                    var a = e.globals.dom.baseEl.querySelector(".apexcharts-menu");
                    a && a.classList.contains("apexcharts-menu-open") && "apexcharts-menu-icon" !== i && a.classList.remove("apexcharts-menu-open");
                }
                e.globals.clientX = "touchmove" === t.type ? t.touches[0].clientX : t.clientX, e.globals.clientY = "touchmove" === t.type ? t.touches[0].clientY : t.clientY;
            }
        }
    ]), t;
}(), $ = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "setCurrentLocaleValues",
            value: function(t) {
                var e = this.w.config.chart.locales;
                window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (e = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                var i = e.filter(function(e) {
                    return e.name === t;
                })[0];
                if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                var a = x.extend(C, i);
                this.w.globals.locale = a.options;
            }
        }
    ]), t;
}(), J = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "drawAxis",
            value: function(t, e) {
                var i, a, s = this, r = this.w.globals, o = this.w.config, n = new V(this.ctx, e), l = new q(this.ctx, e);
                r.axisCharts && "radar" !== t && (r.isBarHorizontal ? (a = l.drawYaxisInversed(0), i = n.drawXaxisInversed(0), r.dom.elGraphical.add(i), r.dom.elGraphical.add(a)) : (i = n.drawXaxis(), r.dom.elGraphical.add(i), o.yaxis.map(function(t, e) {
                    if (-1 === r.ignoreYAxisIndexes.indexOf(e) && (a = l.drawYaxis(e), r.dom.Paper.add(a), "back" === s.w.config.grid.position)) {
                        var i = r.dom.Paper.children()[1];
                        i.remove(), r.dom.Paper.add(i);
                    }
                })));
            }
        }
    ]), t;
}(), Q = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "drawXCrosshairs",
            value: function() {
                var t = this.w, e = new m(this.ctx), i = new v(this.ctx), a = t.config.xaxis.crosshairs.fill.gradient, s = t.config.xaxis.crosshairs.dropShadow, r = t.config.xaxis.crosshairs.fill.type, o = a.colorFrom, n = a.colorTo, l = a.opacityFrom, h = a.opacityTo, c = a.stops, d = s.enabled, g = s.left, u = s.top, p = s.blur, f = s.color, b = s.opacity, y = t.config.xaxis.crosshairs.fill.color;
                if (t.config.xaxis.crosshairs.show) {
                    "gradient" === r && (y = e.drawGradient("vertical", o, n, l, h, null, c, null));
                    var w = e.drawRect();
                    1 === t.config.xaxis.crosshairs.width && (w = e.drawLine());
                    var k = t.globals.gridHeight;
                    (!x.isNumber(k) || k < 0) && (k = 0);
                    var A = t.config.xaxis.crosshairs.width;
                    (!x.isNumber(A) || A < 0) && (A = 0), w.attr({
                        class: "apexcharts-xcrosshairs",
                        x: 0,
                        y: 0,
                        y2: k,
                        width: A,
                        height: k,
                        fill: y,
                        filter: "none",
                        "fill-opacity": t.config.xaxis.crosshairs.opacity,
                        stroke: t.config.xaxis.crosshairs.stroke.color,
                        "stroke-width": t.config.xaxis.crosshairs.stroke.width,
                        "stroke-dasharray": t.config.xaxis.crosshairs.stroke.dashArray
                    }), d && (w = i.dropShadow(w, {
                        left: g,
                        top: u,
                        blur: p,
                        color: f,
                        opacity: b
                    })), t.globals.dom.elGraphical.add(w);
                }
            }
        },
        {
            key: "drawYCrosshairs",
            value: function() {
                var t = this.w, e = new m(this.ctx), i = t.config.yaxis[0].crosshairs, a = t.globals.barPadForNumericAxis;
                if (t.config.yaxis[0].crosshairs.show) {
                    var s = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                    s.attr({
                        class: "apexcharts-ycrosshairs"
                    }), t.globals.dom.elGraphical.add(s);
                }
                var r = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                r.attr({
                    class: "apexcharts-ycrosshairs-hidden"
                }), t.globals.dom.elGraphical.add(r);
            }
        }
    ]), t;
}(), K = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "checkResponsiveConfig",
            value: function(t) {
                var e = this, i = this.w, a = i.config;
                if (0 !== a.responsive.length) {
                    var s = a.responsive.slice();
                    s.sort(function(t, e) {
                        return t.breakpoint > e.breakpoint ? 1 : e.breakpoint > t.breakpoint ? -1 : 0;
                    }).reverse();
                    var r = new E({}), o = function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = s[0].breakpoint, o = window.innerWidth > 0 ? window.innerWidth : screen.width;
                        if (o > a) {
                            var n = y.extendArrayProps(r, i.globals.initialConfig, i);
                            t = x.extend(n, t), t = x.extend(i.config, t), e.overrideResponsiveOptions(t);
                        } else for(var l = 0; l < s.length; l++)o < s[l].breakpoint && (t = y.extendArrayProps(r, s[l].options, i), t = x.extend(i.config, t), e.overrideResponsiveOptions(t));
                    };
                    if (t) {
                        var n = y.extendArrayProps(r, t, i);
                        n = x.extend(i.config, n), o(n = x.extend(n, t));
                    } else o({});
                }
            }
        },
        {
            key: "overrideResponsiveOptions",
            value: function(t) {
                var e = new E(t).init({
                    responsiveOverride: !0
                });
                this.w.config = e;
            }
        }
    ]), t;
}(), tt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.colors = [], this.w = e.w;
        var i = this.w;
        this.isColorFn = !1, this.isHeatmapDistributed = "treemap" === i.config.chart.type && i.config.plotOptions.treemap.distributed || "heatmap" === i.config.chart.type && i.config.plotOptions.heatmap.distributed, this.isBarDistributed = i.config.plotOptions.bar.distributed && ("bar" === i.config.chart.type || "rangeBar" === i.config.chart.type);
    }
    return r(t, [
        {
            key: "init",
            value: function() {
                this.setDefaultColors();
            }
        },
        {
            key: "setDefaultColors",
            value: function() {
                var t, e = this, i = this.w, a = new x;
                if (i.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(i.config.theme.mode)), void 0 === i.config.colors || 0 === (null === (t = i.config.colors) || void 0 === t ? void 0 : t.length) ? i.globals.colors = this.predefined() : (i.globals.colors = i.config.colors, Array.isArray(i.config.colors) && i.config.colors.length > 0 && "function" == typeof i.config.colors[0] && (i.globals.colors = i.config.series.map(function(t, a) {
                    var s = i.config.colors[a];
                    return s || (s = i.config.colors[0]), "function" == typeof s ? (e.isColorFn = !0, s({
                        value: i.globals.axisCharts ? i.globals.series[a][0] ? i.globals.series[a][0] : 0 : i.globals.series[a],
                        seriesIndex: a,
                        dataPointIndex: a,
                        w: i
                    })) : s;
                }))), i.globals.seriesColors.map(function(t, e) {
                    t && (i.globals.colors[e] = t);
                }), i.config.theme.monochrome.enabled) {
                    var s = [], r = i.globals.series.length;
                    (this.isBarDistributed || this.isHeatmapDistributed) && (r = i.globals.series[0].length * i.globals.series.length);
                    for(var o = i.config.theme.monochrome.color, n = 1 / (r / i.config.theme.monochrome.shadeIntensity), l = i.config.theme.monochrome.shadeTo, h = 0, c = 0; c < r; c++){
                        var d = void 0;
                        "dark" === l ? (d = a.shadeColor(-1 * h, o), h += n) : (d = a.shadeColor(h, o), h += n), s.push(d);
                    }
                    i.globals.colors = s.slice();
                }
                var g = i.globals.colors.slice();
                this.pushExtraColors(i.globals.colors);
                [
                    "fill",
                    "stroke"
                ].forEach(function(t) {
                    void 0 === i.config[t].colors ? i.globals[t].colors = e.isColorFn ? i.config.colors : g : i.globals[t].colors = i.config[t].colors.slice(), e.pushExtraColors(i.globals[t].colors);
                }), void 0 === i.config.dataLabels.style.colors ? i.globals.dataLabels.style.colors = g : i.globals.dataLabels.style.colors = i.config.dataLabels.style.colors.slice(), this.pushExtraColors(i.globals.dataLabels.style.colors, 50), void 0 === i.config.plotOptions.radar.polygons.fill.colors ? i.globals.radarPolygons.fill.colors = [
                    "dark" === i.config.theme.mode ? "#424242" : "none"
                ] : i.globals.radarPolygons.fill.colors = i.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(i.globals.radarPolygons.fill.colors, 20), void 0 === i.config.markers.colors ? i.globals.markers.colors = g : i.globals.markers.colors = i.config.markers.colors.slice(), this.pushExtraColors(i.globals.markers.colors);
            }
        },
        {
            key: "pushExtraColors",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = e || a.globals.series.length;
                if (null === i && (i = this.isBarDistributed || this.isHeatmapDistributed || "heatmap" === a.config.chart.type && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), t.length < s) for(var r = s - t.length, o = 0; o < r; o++)t.push(t[o]);
            }
        },
        {
            key: "updateThemeOptions",
            value: function(t) {
                t.chart = t.chart || {}, t.tooltip = t.tooltip || {};
                var e = t.theme.mode || "light", i = t.theme.palette ? t.theme.palette : "dark" === e ? "palette4" : "palette1", a = t.chart.foreColor ? t.chart.foreColor : "dark" === e ? "#f6f7f8" : "#373d3f";
                return t.tooltip.theme = e, t.chart.foreColor = a, t.theme.palette = i, t;
            }
        },
        {
            key: "predefined",
            value: function() {
                switch(this.w.config.theme.palette){
                    case "palette1":
                    default:
                        this.colors = [
                            "#008FFB",
                            "#00E396",
                            "#FEB019",
                            "#FF4560",
                            "#775DD0"
                        ];
                        break;
                    case "palette2":
                        this.colors = [
                            "#3f51b5",
                            "#03a9f4",
                            "#4caf50",
                            "#f9ce1d",
                            "#FF9800"
                        ];
                        break;
                    case "palette3":
                        this.colors = [
                            "#33b2df",
                            "#546E7A",
                            "#d4526e",
                            "#13d8aa",
                            "#A5978B"
                        ];
                        break;
                    case "palette4":
                        this.colors = [
                            "#4ecdc4",
                            "#c7f464",
                            "#81D4FA",
                            "#fd6a6a",
                            "#546E7A"
                        ];
                        break;
                    case "palette5":
                        this.colors = [
                            "#2b908f",
                            "#f9a3a4",
                            "#90ee7e",
                            "#fa4443",
                            "#69d2e7"
                        ];
                        break;
                    case "palette6":
                        this.colors = [
                            "#449DD1",
                            "#F86624",
                            "#EA3546",
                            "#662E9B",
                            "#C5D86D"
                        ];
                        break;
                    case "palette7":
                        this.colors = [
                            "#D7263D",
                            "#1B998B",
                            "#2E294E",
                            "#F46036",
                            "#E2C044"
                        ];
                        break;
                    case "palette8":
                        this.colors = [
                            "#662E9B",
                            "#F86624",
                            "#F9C80E",
                            "#EA3546",
                            "#43BCCD"
                        ];
                        break;
                    case "palette9":
                        this.colors = [
                            "#5C4742",
                            "#A5978B",
                            "#8D5B4C",
                            "#5A2A27",
                            "#C4BBAF"
                        ];
                        break;
                    case "palette10":
                        this.colors = [
                            "#A300D6",
                            "#7D02EB",
                            "#5653FE",
                            "#2983FF",
                            "#00B1F2"
                        ];
                }
                return this.colors;
            }
        }
    ]), t;
}(), et = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "draw",
            value: function() {
                this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
            }
        },
        {
            key: "drawTitleSubtitle",
            value: function(t) {
                var e = this.w, i = "title" === t ? e.config.title : e.config.subtitle, a = e.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                if ("left" === i.align ? (a = 10, r = "start") : "right" === i.align && (a = e.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, void 0 !== i.text) {
                    var o = new m(this.ctx).drawText({
                        x: a,
                        y: s,
                        text: i.text,
                        textAnchor: r,
                        fontSize: i.style.fontSize,
                        fontFamily: i.style.fontFamily,
                        fontWeight: i.style.fontWeight,
                        foreColor: i.style.color,
                        opacity: 1
                    });
                    o.node.setAttribute("class", "apexcharts-".concat(t, "-text")), e.globals.dom.Paper.add(o);
                }
            }
        }
    ]), t;
}(), it = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.dCtx = e;
    }
    return r(t, [
        {
            key: "getTitleSubtitleCoords",
            value: function(t) {
                var e = this.w, i = 0, a = 0, s = "title" === t ? e.config.title.floating : e.config.subtitle.floating, r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t, "-text"));
                if (null !== r && !s) {
                    var o = r.getBoundingClientRect();
                    i = o.width, a = e.globals.axisCharts ? o.height + 5 : o.height;
                }
                return {
                    width: i,
                    height: a
                };
            }
        },
        {
            key: "getLegendsRect",
            value: function() {
                var t = this.w, e = t.globals.dom.elLegendWrap;
                t.config.legend.height || "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || (e.style.maxHeight = t.globals.svgHeight / 2 + "px");
                var i = Object.assign({}, x.getBoundingClientRect(e));
                return null !== e && !t.config.legend.floating && t.config.legend.show ? this.dCtx.lgRect = {
                    x: i.x,
                    y: i.y,
                    height: i.height,
                    width: 0 === i.height ? 0 : i.width
                } : this.dCtx.lgRect = {
                    x: 0,
                    y: 0,
                    height: 0,
                    width: 0
                }, "left" !== t.config.legend.position && "right" !== t.config.legend.position || 1.5 * this.dCtx.lgRect.width > t.globals.svgWidth && (this.dCtx.lgRect.width = t.globals.svgWidth / 1.5), this.dCtx.lgRect;
            }
        },
        {
            key: "getLargestStringFromMultiArr",
            value: function(t, e) {
                var i = t;
                if (this.w.globals.isMultiLineX) {
                    var a = e.map(function(t, e) {
                        return Array.isArray(t) ? t.length : 1;
                    }), s = Math.max.apply(Math, u(a));
                    i = e[a.indexOf(s)];
                }
                return i;
            }
        }
    ]), t;
}(), at = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.dCtx = e;
    }
    return r(t, [
        {
            key: "getxAxisLabelsCoords",
            value: function() {
                var t, e = this.w, i = e.globals.labels.slice();
                if (e.config.xaxis.convertedCatToNumeric && 0 === i.length && (i = e.globals.categoryLabels), e.globals.timescaleLabels.length > 0) {
                    var a = this.getxAxisTimeScaleLabelsCoords();
                    t = {
                        width: a.width,
                        height: a.height
                    }, e.globals.rotateXLabels = !1;
                } else {
                    this.dCtx.lgWidthForSideLegends = "left" !== e.config.legend.position && "right" !== e.config.legend.position || e.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                    var s = e.globals.xLabelFormatter, r = x.getLargestStringFromArr(i), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                    e.globals.isBarHorizontal && (o = r = e.globals.yAxisScale[0].result.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0));
                    var n = new T(this.dCtx.ctx), l = r;
                    r = n.xLabelFormat(s, r, l, {
                        i: void 0,
                        dateFormatter: new I(this.dCtx.ctx).formatDate,
                        w: e
                    }), o = n.xLabelFormat(s, o, l, {
                        i: void 0,
                        dateFormatter: new I(this.dCtx.ctx).formatDate,
                        w: e
                    }), (e.config.xaxis.convertedCatToNumeric && void 0 === r || "" === String(r).trim()) && (o = r = "1");
                    var h = new m(this.dCtx.ctx), c = h.getTextRects(r, e.config.xaxis.labels.style.fontSize), d = c;
                    if (r !== o && (d = h.getTextRects(o, e.config.xaxis.labels.style.fontSize)), (t = {
                        width: c.width >= d.width ? c.width : d.width,
                        height: c.height >= d.height ? c.height : d.height
                    }).width * i.length > e.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && 0 !== e.config.xaxis.labels.rotate || e.config.xaxis.labels.rotateAlways) {
                        if (!e.globals.isBarHorizontal) {
                            e.globals.rotateXLabels = !0;
                            var g = function(t) {
                                return h.getTextRects(t, e.config.xaxis.labels.style.fontSize, e.config.xaxis.labels.style.fontFamily, "rotate(".concat(e.config.xaxis.labels.rotate, " 0 0)"), !1);
                            };
                            c = g(r), r !== o && (d = g(o)), t.height = (c.height > d.height ? c.height : d.height) / 1.5, t.width = c.width > d.width ? c.width : d.width;
                        }
                    } else e.globals.rotateXLabels = !1;
                }
                return e.config.xaxis.labels.show || (t = {
                    width: 0,
                    height: 0
                }), {
                    width: t.width,
                    height: t.height
                };
            }
        },
        {
            key: "getxAxisGroupLabelsCoords",
            value: function() {
                var t, e = this.w;
                if (!e.globals.hasXaxisGroups) return {
                    width: 0,
                    height: 0
                };
                var i, a = (null === (t = e.config.xaxis.group.style) || void 0 === t ? void 0 : t.fontSize) || e.config.xaxis.labels.style.fontSize, s = e.globals.groups.map(function(t) {
                    return t.title;
                }), r = x.getLargestStringFromArr(s), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, s), n = new m(this.dCtx.ctx), l = n.getTextRects(r, a), h = l;
                return r !== o && (h = n.getTextRects(o, a)), i = {
                    width: l.width >= h.width ? l.width : h.width,
                    height: l.height >= h.height ? l.height : h.height
                }, e.config.xaxis.labels.show || (i = {
                    width: 0,
                    height: 0
                }), {
                    width: i.width,
                    height: i.height
                };
            }
        },
        {
            key: "getxAxisTitleCoords",
            value: function() {
                var t = this.w, e = 0, i = 0;
                if (void 0 !== t.config.xaxis.title.text) {
                    var a = new m(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text, t.config.xaxis.title.style.fontSize);
                    e = a.width, i = a.height;
                }
                return {
                    width: e,
                    height: i
                };
            }
        },
        {
            key: "getxAxisTimeScaleLabelsCoords",
            value: function() {
                var t, e = this.w;
                this.dCtx.timescaleLabels = e.globals.timescaleLabels.slice();
                var i = this.dCtx.timescaleLabels.map(function(t) {
                    return t.value;
                }), a = i.reduce(function(t, e) {
                    return void 0 === t ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : t.length > e.length ? t : e;
                }, 0);
                return 1.05 * (t = new m(this.dCtx.ctx).getTextRects(a, e.config.xaxis.labels.style.fontSize)).width * i.length > e.globals.gridWidth && 0 !== e.config.xaxis.labels.rotate && (e.globals.overlappingXLabels = !0), t;
            }
        },
        {
            key: "additionalPaddingXLabels",
            value: function(t) {
                var e = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, o = t.width;
                a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                var n = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, l = function(t, n) {
                    s.yaxis.length > 1 && function(t) {
                        return -1 !== a.collapsedSeriesIndices.indexOf(t);
                    }(n) || function(t) {
                        if (e.dCtx.timescaleLabels && e.dCtx.timescaleLabels.length) {
                            var n = e.dCtx.timescaleLabels[0], l = e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length - 1].position + o / 1.75 - e.dCtx.yAxisWidthRight, h = n.position - o / 1.75 + e.dCtx.yAxisWidthLeft, c = "right" === i.config.legend.position && e.dCtx.lgRect.width > 0 ? e.dCtx.lgRect.width : 0;
                            l > a.svgWidth - a.translateX - c && (a.skipLastTimelinelabel = !0), h < -(t.show && !t.floating || "bar" !== s.chart.type && "candlestick" !== s.chart.type && "rangeBar" !== s.chart.type && "boxPlot" !== s.chart.type ? 10 : o / 1.75) && (a.skipFirstTimelinelabel = !0);
                        } else "datetime" === r ? e.dCtx.gridPad.right < o && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : "datetime" !== r && e.dCtx.gridPad.right < o / 2 - e.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && ("between" !== i.config.xaxis.tickPlacement || i.globals.isBarHorizontal) && (e.dCtx.xPadRight = o / 2 + 1);
                    }(t);
                };
                s.yaxis.forEach(function(t, i) {
                    n ? (e.dCtx.gridPad.left < o && (e.dCtx.xPadLeft = o / 2 + 1), e.dCtx.xPadRight = o / 2 + 1) : l(t, i);
                });
            }
        }
    ]), t;
}(), st = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.dCtx = e;
    }
    return r(t, [
        {
            key: "getyAxisLabelsCoords",
            value: function() {
                var t = this, e = this.w, i = [], a = 10, s = new B(this.dCtx.ctx);
                return e.config.yaxis.map(function(r, o) {
                    var n = {
                        seriesIndex: o,
                        dataPointIndex: -1,
                        w: e
                    }, l = e.globals.yAxisScale[o], h = 0;
                    if (!s.isYAxisHidden(o) && r.labels.show && void 0 !== r.labels.minWidth && (h = r.labels.minWidth), !s.isYAxisHidden(o) && r.labels.show && l.result.length) {
                        var c = e.globals.yLabelFormatters[o], d = l.niceMin === Number.MIN_VALUE ? 0 : l.niceMin, g = l.result.reduce(function(t, e) {
                            var i, a;
                            return (null === (i = String(c(t, n))) || void 0 === i ? void 0 : i.length) > (null === (a = String(c(e, n))) || void 0 === a ? void 0 : a.length) ? t : e;
                        }, d), u = g = c(g, n);
                        if (void 0 !== g && 0 !== g.length || (g = l.niceMax), e.globals.isBarHorizontal) {
                            a = 0;
                            var p = e.globals.labels.slice();
                            g = x.getLargestStringFromArr(p), g = c(g, {
                                seriesIndex: o,
                                dataPointIndex: -1,
                                w: e
                            }), u = t.dCtx.dimHelpers.getLargestStringFromMultiArr(g, p);
                        }
                        var f = new m(t.dCtx.ctx), b = "rotate(".concat(r.labels.rotate, " 0 0)"), v = f.getTextRects(g, r.labels.style.fontSize, r.labels.style.fontFamily, b, !1), y = v;
                        g !== u && (y = f.getTextRects(u, r.labels.style.fontSize, r.labels.style.fontFamily, b, !1)), i.push({
                            width: (h > y.width || h > v.width ? h : y.width > v.width ? y.width : v.width) + a,
                            height: y.height > v.height ? y.height : v.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getyAxisTitleCoords",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.config.yaxis.map(function(e, a) {
                    if (e.show && void 0 !== e.title.text) {
                        var s = new m(t.dCtx.ctx), r = "rotate(".concat(e.title.rotate, " 0 0)"), o = s.getTextRects(e.title.text, e.title.style.fontSize, e.title.style.fontFamily, r, !1);
                        i.push({
                            width: o.width,
                            height: o.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getTotalYAxisWidth",
            value: function() {
                var t = this.w, e = 0, i = 0, a = 0, s = t.globals.yAxisScale.length > 1 ? 10 : 0, r = new B(this.dCtx.ctx), o = function(o, n) {
                    var l = t.config.yaxis[n].floating, h = 0;
                    o.width > 0 && !l ? (h = o.width + s, function(e) {
                        return t.globals.ignoreYAxisIndexes.indexOf(e) > -1;
                    }(n) && (h = h - o.width - s)) : h = l || r.isYAxisHidden(n) ? 0 : 5, t.config.yaxis[n].opposite ? a += h : i += h, e += h;
                };
                return t.globals.yLabelsCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.yTitleCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.isBarHorizontal && !t.config.yaxis[0].floating && (e = t.globals.yLabelsCoords[0].width + t.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, e;
            }
        }
    ]), t;
}(), rt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.dCtx = e;
    }
    return r(t, [
        {
            key: "gridPadForColumnsInNumericAxis",
            value: function(t) {
                var e = this.w;
                if (e.globals.noData || e.globals.allSeriesCollapsed) return 0;
                var i = function(t) {
                    return "bar" === t || "rangeBar" === t || "candlestick" === t || "boxPlot" === t;
                }, a = e.config.chart.type, s = 0, r = i(a) ? e.config.series.length : 1;
                if (e.globals.comboBarCount > 0 && (r = e.globals.comboBarCount), e.globals.collapsedSeries.forEach(function(t) {
                    i(t.type) && (r -= 1);
                }), e.config.chart.stacked && (r = 1), (i(a) || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && r > 0) {
                    var o, n, l = Math.abs(e.globals.initialMaxX - e.globals.initialMinX);
                    l <= 3 && (l = e.globals.dataPoints), o = l / t, e.globals.minXDiff && e.globals.minXDiff / o > 0 && (n = e.globals.minXDiff / o), n > t / 2 && (n /= 2), (s = n / r * parseInt(e.config.plotOptions.bar.columnWidth, 10) / 100) < 1 && (s = 1), s = s / (r > 1 ? 1 : 1.5) + 5, e.globals.barPadForNumericAxis = s;
                }
                return s;
            }
        },
        {
            key: "gridPadFortitleSubtitle",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 10;
                [
                    "title",
                    "subtitle"
                ].forEach(function(i) {
                    void 0 !== e.config[i].text ? a += e.config[i].margin : a += t.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 5;
                }), !e.config.legend.show || "bottom" !== e.config.legend.position || e.config.legend.floating || e.globals.axisCharts || (a += 10);
                var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                i.gridHeight = i.gridHeight - s.height - r.height - a, i.translateY = i.translateY + s.height + r.height + a;
            }
        },
        {
            key: "setGridXPosForDualYAxis",
            value: function(t, e) {
                var i = this.w, a = new B(this.dCtx.ctx);
                i.config.yaxis.map(function(s, r) {
                    -1 !== i.globals.ignoreYAxisIndexes.indexOf(r) || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX = i.globals.translateX - (e[r].width + t[r].width) - parseInt(i.config.yaxis[r].labels.style.fontSize, 10) / 1.2 - 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                });
            }
        }
    ]), t;
}(), ot = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new it(this), this.dimYAxis = new st(this), this.dimXAxis = new at(this), this.dimGrid = new rt(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
    }
    return r(t, [
        {
            key: "plotCoords",
            value: function() {
                var t = this, e = this.w, i = e.globals;
                this.lgRect = this.dimHelpers.getLegendsRect(), this.isSparkline && ((e.config.markers.discrete.length > 0 || e.config.markers.size > 0) && Object.entries(this.gridPad).forEach(function(e) {
                    var i = g(e, 2), a = i[0], s = i[1];
                    t.gridPad[a] = Math.max(s, t.w.globals.markers.largestSize / 1.5);
                }), this.gridPad.top = Math.max(e.config.stroke.width / 2, this.gridPad.top), this.gridPad.bottom = Math.max(e.config.stroke.width / 2, this.gridPad.bottom)), i.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), i.gridHeight = i.gridHeight - this.gridPad.top - this.gridPad.bottom, i.gridWidth = i.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                var a = this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);
                i.gridWidth = i.gridWidth - 2 * a, i.translateX = i.translateX + this.gridPad.left + this.xPadLeft + (a > 0 ? a + 4 : 0), i.translateY = i.translateY + this.gridPad.top;
            }
        },
        {
            key: "setDimensionsForAxisCharts",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                e.globals.yLabelsCoords = [], e.globals.yTitleCoords = [], e.config.yaxis.map(function(t, i) {
                    e.globals.yLabelsCoords.push({
                        width: a[i].width,
                        index: i
                    }), e.globals.yTitleCoords.push({
                        width: s[i].width,
                        index: i
                    });
                }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                var r = this.dimXAxis.getxAxisLabelsCoords(), o = this.dimXAxis.getxAxisGroupLabelsCoords(), n = this.dimXAxis.getxAxisTitleCoords();
                this.conditionalChecksForAxisCoords(r, n, o), i.translateXAxisY = e.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = e.globals.rotateXLabels && e.globals.isXNumeric && e.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, e.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(e.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + e.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + e.config.xaxis.labels.offsetX;
                var l = this.yAxisWidth, h = this.xAxisHeight;
                i.xAxisLabelsHeight = this.xAxisHeight - n.height, i.xAxisGroupLabelsHeight = i.xAxisLabelsHeight - r.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                var c = 10;
                ("radar" === e.config.chart.type || this.isSparkline) && (l = 0, h = i.goldenPadding), this.isSparkline && (this.lgRect = {
                    height: 0,
                    width: 0
                }), (this.isSparkline || "treemap" === e.config.chart.type) && (l = 0, h = 0, c = 0), this.isSparkline || this.dimXAxis.additionalPaddingXLabels(r);
                var d = function() {
                    i.translateX = l, i.gridHeight = i.svgHeight - t.lgRect.height - h - (t.isSparkline || "treemap" === e.config.chart.type ? 0 : e.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - l;
                };
                switch("top" === e.config.xaxis.position && (c = i.xAxisHeight - e.config.xaxis.axisTicks.height - 5), e.config.legend.position){
                    case "bottom":
                        i.translateY = c, d();
                        break;
                    case "top":
                        i.translateY = this.lgRect.height + c, d();
                        break;
                    case "left":
                        i.translateY = c, i.translateX = this.lgRect.width + l, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l;
                        break;
                    case "right":
                        i.translateY = c, i.translateX = l, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l - 5;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
                this.dimGrid.setGridXPosForDualYAxis(s, a), new q(this.ctx).setYAxisXPosition(a, s);
            }
        },
        {
            key: "setDimensionsForNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = 0;
                t.config.legend.show && !t.config.legend.floating && (a = 20);
                var s = "pie" === i.chart.type || "polarArea" === i.chart.type || "donut" === i.chart.type ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, o = i.plotOptions[s].offsetX;
                if (!i.legend.show || i.legend.floating) return e.gridHeight = e.svgHeight - i.grid.padding.left + i.grid.padding.right, e.gridWidth = e.gridHeight, e.translateY = r, void (e.translateX = o + (e.svgWidth - e.gridWidth) / 2);
                switch(i.legend.position){
                    case "bottom":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = r - 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "top":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = this.lgRect.height + r + 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "left":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + this.lgRect.width + a;
                        break;
                    case "right":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a - 5, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + 10;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
            }
        },
        {
            key: "conditionalChecksForAxisCoords",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.hasXaxisGroups ? 2 : 1, r = i.height + t.height + e.height, o = a.globals.isMultiLineX ? 1.2 : a.globals.LINE_HEIGHT_RATIO, n = a.globals.rotateXLabels ? 22 : 10, l = a.globals.rotateXLabels && "bottom" === a.config.legend.position ? 10 : 0;
                this.xAxisHeight = r * o + s * n + l, this.xAxisWidth = t.width, this.xAxisHeight - e.height > a.config.xaxis.labels.maxHeight && (this.xAxisHeight = a.config.xaxis.labels.maxHeight), a.config.xaxis.labels.minHeight && this.xAxisHeight < a.config.xaxis.labels.minHeight && (this.xAxisHeight = a.config.xaxis.labels.minHeight), a.config.xaxis.floating && (this.xAxisHeight = 0);
                var h = 0, c = 0;
                a.config.yaxis.forEach(function(t) {
                    h += t.labels.minWidth, c += t.labels.maxWidth;
                }), this.yAxisWidth < h && (this.yAxisWidth = h), this.yAxisWidth > c && (this.yAxisWidth = c);
            }
        }
    ]), t;
}(), nt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.lgCtx = e;
    }
    return r(t, [
        {
            key: "getLegendStyles",
            value: function() {
                var t, e, i, a = document.createElement("style");
                a.setAttribute("type", "text/css");
                var s = (null === (t = this.lgCtx.ctx) || void 0 === t || null === (e = t.opts) || void 0 === e || null === (i = e.chart) || void 0 === i ? void 0 : i.nonce) || this.w.config.chart.nonce;
                s && a.setAttribute("nonce", s);
                var r = document.createTextNode("	\n    	\n      .apexcharts-legend {	\n        display: flex;	\n        overflow: auto;	\n        padding: 0 10px;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {	\n        flex-wrap: wrap	\n      }	\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	\n        flex-direction: column;	\n        bottom: 0;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	\n        justify-content: flex-start;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {	\n        justify-content: center;  	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {	\n        justify-content: flex-end;	\n      }	\n      .apexcharts-legend-series {	\n        cursor: pointer;	\n        line-height: normal;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{	\n        display: flex;	\n        align-items: center;	\n      }	\n      .apexcharts-legend-text {	\n        position: relative;	\n        font-size: 14px;	\n      }	\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {	\n        pointer-events: none;	\n      }	\n      .apexcharts-legend-marker {	\n        position: relative;	\n        display: inline-block;	\n        cursor: pointer;	\n        margin-right: 3px;	\n        border-style: solid;\n      }	\n      	\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{	\n        display: inline-block;	\n      }	\n      .apexcharts-legend-series.apexcharts-no-click {	\n        cursor: auto;	\n      }	\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {	\n        display: none !important;	\n      }	\n      .apexcharts-inactive-legend {	\n        opacity: 0.45;	\n      }");
                return a.appendChild(r), a;
            }
        },
        {
            key: "getLegendBBox",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), e = t.width;
                return {
                    clwh: t.height,
                    clww: e
                };
            }
        },
        {
            key: "appendToForeignObject",
            value: function() {
                this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles());
            }
        },
        {
            key: "toggleDataSeries",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.axisCharts || "radialBar" === a.config.chart.type) {
                    a.globals.resized = !0;
                    var s = null, r = null;
                    if (a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), e) [
                        {
                            cs: a.globals.collapsedSeries,
                            csi: a.globals.collapsedSeriesIndices
                        },
                        {
                            cs: a.globals.ancillaryCollapsedSeries,
                            csi: a.globals.ancillaryCollapsedSeriesIndices
                        }
                    ].forEach(function(t) {
                        i.riseCollapsedSeries(t.cs, t.csi, r);
                    });
                    else this.hideSeries({
                        seriesEl: s,
                        realIndex: r
                    });
                } else {
                    var o = a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t + 1, "'] path")), n = a.config.chart.type;
                    if ("pie" === n || "polarArea" === n || "donut" === n) {
                        var l = a.config.plotOptions.pie.donut.labels;
                        new m(this.lgCtx.ctx).pathMouseDown(o.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node, l);
                    }
                    o.fire("click");
                }
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = t.seriesEl, i = t.realIndex, a = this.w, s = x.clone(a.config.series);
                if (a.globals.axisCharts) {
                    var r = !1;
                    if (a.config.yaxis[i] && a.config.yaxis[i].show && a.config.yaxis[i].showAlways && (r = !0, a.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 && (a.globals.ancillaryCollapsedSeries.push({
                        index: i,
                        data: s[i].data.slice(),
                        type: e.parentNode.className.baseVal.split("-")[1]
                    }), a.globals.ancillaryCollapsedSeriesIndices.push(i))), !r) {
                        a.globals.collapsedSeries.push({
                            index: i,
                            data: s[i].data.slice(),
                            type: e.parentNode.className.baseVal.split("-")[1]
                        }), a.globals.collapsedSeriesIndices.push(i);
                        var o = a.globals.risingSeries.indexOf(i);
                        a.globals.risingSeries.splice(o, 1);
                    }
                } else a.globals.collapsedSeries.push({
                    index: i,
                    data: s[i]
                }), a.globals.collapsedSeriesIndices.push(i);
                for(var n = e.childNodes, l = 0; l < n.length; l++)n[l].classList.contains("apexcharts-series-markers-wrap") && (n[l].classList.contains("apexcharts-hide") ? n[l].classList.remove("apexcharts-hide") : n[l].classList.add("apexcharts-hide"));
                a.globals.allSeriesCollapsed = a.globals.collapsedSeries.length === a.config.series.length, s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
            }
        },
        {
            key: "riseCollapsedSeries",
            value: function(t, e, i) {
                var a = this.w, s = x.clone(a.config.series);
                if (t.length > 0) {
                    for(var r = 0; r < t.length; r++)t[r].index === i && (a.globals.axisCharts ? (s[i].data = t[r].data.slice(), t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)) : (s[i] = t[r].data, t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)));
                    s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            }
        },
        {
            key: "_getSeriesBasedOnCollapsedState",
            value: function(t) {
                var e = this.w;
                return e.globals.axisCharts ? t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a].data = []);
                }) : t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a] = 0);
                }), t;
            }
        }
    ]), t;
}(), lt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = "bar" === this.w.config.chart.type && this.w.config.plotOptions.bar.distributed && 1 === this.w.config.series.length, this.legendHelpers = new nt(this);
    }
    return r(t, [
        {
            key: "init",
            value: function() {
                var t = this.w, e = t.globals, i = t.config;
                if ((i.legend.showForSingleSeries && 1 === e.series.length || this.isBarsDistributed || e.series.length > 1 || !e.axisCharts) && i.legend.show) {
                    for(; e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);
                    this.drawLegends(), x.isIE11() ? document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()) : this.legendHelpers.appendToForeignObject(), "bottom" === i.legend.position || "top" === i.legend.position ? this.legendAlignHorizontal() : "right" !== i.legend.position && "left" !== i.legend.position || this.legendAlignVertical();
                }
            }
        },
        {
            key: "drawLegends",
            value: function() {
                var t = this, e = this.w, i = e.config.legend.fontFamily, a = e.globals.seriesNames, s = e.globals.colors.slice();
                if ("heatmap" === e.config.chart.type) {
                    var r = e.config.plotOptions.heatmap.colorScale.ranges;
                    a = r.map(function(t) {
                        return t.name ? t.name : t.from + " - " + t.to;
                    }), s = r.map(function(t) {
                        return t.color;
                    });
                } else this.isBarsDistributed && (a = e.globals.labels.slice());
                e.config.legend.customLegendItems.length && (a = e.config.legend.customLegendItems);
                for(var o = e.globals.legendFormatter, n = e.config.legend.inverseOrder, l = n ? a.length - 1 : 0; n ? l >= 0 : l <= a.length - 1; n ? l-- : l++){
                    var h, c = o(a[l], {
                        seriesIndex: l,
                        w: e
                    }), d = !1, g = !1;
                    if (e.globals.collapsedSeries.length > 0) for(var u = 0; u < e.globals.collapsedSeries.length; u++)e.globals.collapsedSeries[u].index === l && (d = !0);
                    if (e.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var p = 0; p < e.globals.ancillaryCollapsedSeriesIndices.length; p++)e.globals.ancillaryCollapsedSeriesIndices[p] === l && (g = !0);
                    var f = document.createElement("span");
                    f.classList.add("apexcharts-legend-marker");
                    var b = e.config.legend.markers.offsetX, v = e.config.legend.markers.offsetY, w = e.config.legend.markers.height, k = e.config.legend.markers.width, A = e.config.legend.markers.strokeWidth, S = e.config.legend.markers.strokeColor, C = e.config.legend.markers.radius, L = f.style;
                    L.background = s[l], L.color = s[l], L.setProperty("background", s[l], "important"), e.config.legend.markers.fillColors && e.config.legend.markers.fillColors[l] && (L.background = e.config.legend.markers.fillColors[l]), void 0 !== e.globals.seriesColors[l] && (L.background = e.globals.seriesColors[l], L.color = e.globals.seriesColors[l]), L.height = Array.isArray(w) ? parseFloat(w[l]) + "px" : parseFloat(w) + "px", L.width = Array.isArray(k) ? parseFloat(k[l]) + "px" : parseFloat(k) + "px", L.left = (Array.isArray(b) ? parseFloat(b[l]) : parseFloat(b)) + "px", L.top = (Array.isArray(v) ? parseFloat(v[l]) : parseFloat(v)) + "px", L.borderWidth = Array.isArray(A) ? A[l] : A, L.borderColor = Array.isArray(S) ? S[l] : S, L.borderRadius = Array.isArray(C) ? parseFloat(C[l]) + "px" : parseFloat(C) + "px", e.config.legend.markers.customHTML && (Array.isArray(e.config.legend.markers.customHTML) ? e.config.legend.markers.customHTML[l] && (f.innerHTML = e.config.legend.markers.customHTML[l]()) : f.innerHTML = e.config.legend.markers.customHTML()), m.setAttrs(f, {
                        rel: l + 1,
                        "data:collapsed": d || g
                    }), (d || g) && f.classList.add("apexcharts-inactive-legend");
                    var P = document.createElement("div"), I = document.createElement("span");
                    I.classList.add("apexcharts-legend-text"), I.innerHTML = Array.isArray(c) ? c.join(" ") : c;
                    var T = e.config.legend.labels.useSeriesColors ? e.globals.colors[l] : Array.isArray(e.config.legend.labels.colors) ? null === (h = e.config.legend.labels.colors) || void 0 === h ? void 0 : h[l] : e.config.legend.labels.colors;
                    T || (T = e.config.chart.foreColor), I.style.color = T, I.style.fontSize = parseFloat(e.config.legend.fontSize) + "px", I.style.fontWeight = e.config.legend.fontWeight, I.style.fontFamily = i || e.config.chart.fontFamily, m.setAttrs(I, {
                        rel: l + 1,
                        i: l,
                        "data:default-text": encodeURIComponent(c),
                        "data:collapsed": d || g
                    }), P.appendChild(f), P.appendChild(I);
                    var M = new y(this.ctx);
                    if (!e.config.legend.showForZeroSeries) 0 === M.getSeriesTotalByIndex(l) && M.seriesHaveSameValues(l) && !M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && P.classList.add("apexcharts-hidden-zero-series");
                    e.config.legend.showForNullSeries || M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && P.classList.add("apexcharts-hidden-null-series"), e.globals.dom.elLegendWrap.appendChild(P), e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)), e.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + e.config.legend.position), P.classList.add("apexcharts-legend-series"), P.style.margin = "".concat(e.config.legend.itemMargin.vertical, "px ").concat(e.config.legend.itemMargin.horizontal, "px"), e.globals.dom.elLegendWrap.style.width = e.config.legend.width ? e.config.legend.width + "px" : "", e.globals.dom.elLegendWrap.style.height = e.config.legend.height ? e.config.legend.height + "px" : "", m.setAttrs(P, {
                        rel: l + 1,
                        seriesName: x.escapeString(a[l]),
                        "data:collapsed": d || g
                    }), (d || g) && P.classList.add("apexcharts-inactive-legend"), e.config.legend.onItemClick.toggleDataSeries || P.classList.add("apexcharts-no-click");
                }
                e.globals.dom.elWrap.addEventListener("click", t.onLegendClick, !0), e.config.legend.onItemHover.highlightDataSeries && 0 === e.config.legend.customLegendItems.length && (e.globals.dom.elWrap.addEventListener("mousemove", t.onLegendHovered, !0), e.globals.dom.elWrap.addEventListener("mouseout", t.onLegendHovered, !0));
            }
        },
        {
            key: "setLegendWrapXY",
            value: function(t, e) {
                var i = this.w, a = i.globals.dom.elLegendWrap, s = a.getBoundingClientRect(), r = 0, o = 0;
                if ("bottom" === i.config.legend.position) o += i.globals.svgHeight - s.height / 2;
                else if ("top" === i.config.legend.position) {
                    var n = new ot(this.ctx), l = n.dimHelpers.getTitleSubtitleCoords("title").height, h = n.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                    o = o + (l > 0 ? l - 10 : 0) + (h > 0 ? h - 10 : 0);
                }
                a.style.position = "absolute", r = r + t + i.config.legend.offsetX, o = o + e + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = o + "px", "bottom" === i.config.legend.position ? (a.style.top = "auto", a.style.bottom = 5 - i.config.legend.offsetY + "px") : "right" === i.config.legend.position && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px");
                [
                    "width",
                    "height"
                ].forEach(function(t) {
                    a.style[t] && (a.style[t] = parseInt(i.config.legend[t], 10) + "px");
                });
            }
        },
        {
            key: "legendAlignHorizontal",
            value: function() {
                var t = this.w;
                t.globals.dom.elLegendWrap.style.right = 0;
                var e = this.legendHelpers.getLegendBBox(), i = new ot(this.ctx), a = i.dimHelpers.getTitleSubtitleCoords("title"), s = i.dimHelpers.getTitleSubtitleCoords("subtitle"), r = 0;
                "bottom" === t.config.legend.position ? r = -e.clwh / 1.8 : "top" === t.config.legend.position && (r = a.height + s.height + t.config.title.margin + t.config.subtitle.margin - 10), this.setLegendWrapXY(20, r);
            }
        },
        {
            key: "legendAlignVertical",
            value: function() {
                var t = this.w, e = this.legendHelpers.getLegendBBox(), i = 0;
                "left" === t.config.legend.position && (i = 20), "right" === t.config.legend.position && (i = t.globals.svgWidth - e.clww - 10), this.setLegendWrapXY(i, 20);
            }
        },
        {
            key: "onLegendHovered",
            value: function(t) {
                var e = this.w, i = t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker");
                if ("heatmap" === e.config.chart.type || this.isBarsDistributed) {
                    if (i) {
                        var a = parseInt(t.target.getAttribute("rel"), 10) - 1;
                        this.ctx.events.fireEvent("legendHover", [
                            this.ctx,
                            a,
                            this.w
                        ]), new N(this.ctx).highlightRangeInSeries(t, t.target);
                    }
                } else !t.target.classList.contains("apexcharts-inactive-legend") && i && new N(this.ctx).toggleSeriesOnHover(t, t.target);
            }
        },
        {
            key: "onLegendClick",
            value: function(t) {
                var e = this.w;
                if (!e.config.legend.customLegendItems.length && (t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker"))) {
                    var i = parseInt(t.target.getAttribute("rel"), 10) - 1, a = "true" === t.target.getAttribute("data:collapsed"), s = this.w.config.chart.events.legendClick;
                    "function" == typeof s && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                        this.ctx,
                        i,
                        this.w
                    ]);
                    var r = this.w.config.legend.markers.onClick;
                    "function" == typeof r && t.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                        this.ctx,
                        i,
                        this.w
                    ])), "treemap" !== e.config.chart.type && "heatmap" !== e.config.chart.type && !this.isBarsDistributed && e.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                }
            }
        }
    ]), t;
}(), ht = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = i.globals.minX, this.maxX = i.globals.maxX;
    }
    return r(t, [
        {
            key: "createToolbar",
            value: function() {
                var t = this, e = this.w, i = function() {
                    return document.createElement("div");
                }, a = i();
                if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = e.config.chart.toolbar.offsetY + "px", a.style.right = 3 - e.config.chart.toolbar.offsetX + "px", e.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = e.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                var r = [], o = function(i, a, s) {
                    var o = i.toLowerCase();
                    t.t[o] && e.config.chart.zoom.enabled && r.push({
                        el: a,
                        icon: "string" == typeof t.t[o] ? t.t[o] : s,
                        title: t.localeValues[i],
                        class: "apexcharts-".concat(o, "-icon")
                    });
                };
                o("zoomIn", this.elZoomIn, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'), o("zoomOut", this.elZoomOut, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');
                var n = function(i) {
                    t.t[i] && e.config.chart[i].enabled && r.push({
                        el: "zoom" === i ? t.elZoom : t.elSelection,
                        icon: "string" == typeof t.t[i] ? t.t[i] : "zoom" === i ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>' : '<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',
                        title: t.localeValues["zoom" === i ? "selectionZoom" : "selection"],
                        class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(i, "-icon")
                    });
                };
                n("zoom"), n("selection"), this.t.pan && e.config.chart.zoom.enabled && r.push({
                    el: this.elPan,
                    icon: "string" == typeof this.t.pan ? this.t.pan : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',
                    title: this.localeValues.pan,
                    class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                }), o("reset", this.elZoomReset, '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'), this.t.download && r.push({
                    el: this.elMenuIcon,
                    icon: "string" == typeof this.t.download ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                    title: this.localeValues.menu,
                    class: "apexcharts-menu-icon"
                });
                for(var l = 0; l < this.elCustomIcons.length; l++)r.push({
                    el: this.elCustomIcons[l],
                    icon: this.t.customIcons[l].icon,
                    title: this.t.customIcons[l].title,
                    index: this.t.customIcons[l].index,
                    class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[l].class
                });
                r.forEach(function(t, e) {
                    t.index && x.moveIndexInArray(r, e, t.index);
                });
                for(var h = 0; h < r.length; h++)m.setAttrs(r[h].el, {
                    class: r[h].class,
                    title: r[h].title
                }), r[h].el.innerHTML = r[h].icon, a.appendChild(r[h].el);
                this._createHamburgerMenu(a), e.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : e.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : e.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
            }
        },
        {
            key: "_createHamburgerMenu",
            value: function(t) {
                this.elMenuItems = [], t.appendChild(this.elMenu), m.setAttrs(this.elMenu, {
                    class: "apexcharts-menu"
                });
                for(var e = [
                    {
                        name: "exportSVG",
                        title: this.localeValues.exportToSVG
                    },
                    {
                        name: "exportPNG",
                        title: this.localeValues.exportToPNG
                    },
                    {
                        name: "exportCSV",
                        title: this.localeValues.exportToCSV
                    }
                ], i = 0; i < e.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = e[i].title, m.setAttrs(this.elMenuItems[i], {
                    class: "apexcharts-menu-item ".concat(e[i].name),
                    title: e[i].title
                }), this.elMenu.appendChild(this.elMenuItems[i]);
            }
        },
        {
            key: "addToolbarEventListeners",
            value: function() {
                var t = this;
                this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(e) {
                    e.classList.contains("exportSVG") ? e.addEventListener("click", t.handleDownload.bind(t, "svg")) : e.classList.contains("exportPNG") ? e.addEventListener("click", t.handleDownload.bind(t, "png")) : e.classList.contains("exportCSV") && e.addEventListener("click", t.handleDownload.bind(t, "csv"));
                });
                for(var e = 0; e < this.t.customIcons.length; e++)this.elCustomIcons[e].addEventListener("click", this.t.customIcons[e].click.bind(this, this.ctx, this.ctx.w));
            }
        },
        {
            key: "toggleZoomSelection",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(e) {
                    e.ctx.toolbar.toggleOtherControls();
                    var i = "selection" === t ? e.ctx.toolbar.elSelection : e.ctx.toolbar.elZoom, a = "selection" === t ? "selectionEnabled" : "zoomEnabled";
                    e.w.globals[a] = !e.w.globals[a], i.classList.contains(e.ctx.toolbar.selectedClass) ? i.classList.remove(e.ctx.toolbar.selectedClass) : i.classList.add(e.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "getToolbarIconsReference",
            value: function() {
                var t = this.w;
                this.elZoom || (this.elZoom = t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
            }
        },
        {
            key: "enableZoomPanFromToolbar",
            value: function(t) {
                this.toggleOtherControls(), "pan" === t ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                var e = "pan" === t ? this.elPan : this.elZoom, i = "pan" === t ? this.elZoom : this.elPan;
                e && e.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
            }
        },
        {
            key: "togglePanning",
            value: function() {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    t.ctx.toolbar.toggleOtherControls(), t.w.globals.panEnabled = !t.w.globals.panEnabled, t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass) ? t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass) : t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "toggleOtherControls",
            value: function() {
                var t = this, e = this.w;
                e.globals.panEnabled = !1, e.globals.zoomEnabled = !1, e.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                    this.elPan,
                    this.elSelection,
                    this.elZoom
                ].forEach(function(e) {
                    e && e.classList.remove(t.selectedClass);
                });
            }
        },
        {
            key: "handleZoomIn",
            value: function() {
                var t = this.w;
                t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY);
                var e = (this.minX + this.maxX) / 2, i = (this.minX + e) / 2, a = (this.maxX + e) / 2, s = this._getNewMinXMaxX(i, a);
                t.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
            }
        },
        {
            key: "handleZoomOut",
            value: function() {
                var t = this.w;
                if (t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY), !("datetime" === t.config.xaxis.type && new Date(this.minX).getUTCFullYear() < 1e3)) {
                    var e = (this.minX + this.maxX) / 2, i = this.minX - (e - this.minX), a = this.maxX - (e - this.maxX), s = this._getNewMinXMaxX(i, a);
                    t.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            }
        },
        {
            key: "_getNewMinXMaxX",
            value: function(t, e) {
                var i = this.w.config.xaxis.convertedCatToNumeric;
                return {
                    minX: i ? Math.floor(t) : t,
                    maxX: i ? Math.floor(e) : e
                };
            }
        },
        {
            key: "zoomUpdateOptions",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== t || void 0 !== e) {
                    if (!(i.config.xaxis.convertedCatToNumeric && (t < 1 && (t = 1, e = i.globals.dataPoints), e - t < 2))) {
                        var a = {
                            min: t,
                            max: e
                        }, s = this.getBeforeZoomRange(a);
                        s && (a = s.xaxis);
                        var r = {
                            xaxis: a
                        }, o = x.clone(i.globals.initialConfig.yaxis);
                        if (i.config.chart.zoom.autoScaleYaxis) o = new _(this.ctx).autoScaleY(this.ctx, o, {
                            xaxis: a
                        });
                        i.config.chart.group || (r.yaxis = o), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, o);
                    }
                } else this.handleZoomReset();
            }
        },
        {
            key: "zoomCallback",
            value: function(t, e) {
                "function" == typeof this.ev.zoomed && this.ev.zoomed(this.ctx, {
                    xaxis: t,
                    yaxis: e
                });
            }
        },
        {
            key: "getBeforeZoomRange",
            value: function(t, e) {
                var i = null;
                return "function" == typeof this.ev.beforeZoom && (i = this.ev.beforeZoom(this, {
                    xaxis: t,
                    yaxis: e
                })), i;
            }
        },
        {
            key: "toggleMenu",
            value: function() {
                var t = this;
                window.setTimeout(function() {
                    t.elMenu.classList.contains("apexcharts-menu-open") ? t.elMenu.classList.remove("apexcharts-menu-open") : t.elMenu.classList.add("apexcharts-menu-open");
                }, 0);
            }
        },
        {
            key: "handleDownload",
            value: function(t) {
                var e = this.w, i = new G(this.ctx);
                switch(t){
                    case "svg":
                        i.exportToSVG(this.ctx);
                        break;
                    case "png":
                        i.exportToPng(this.ctx);
                        break;
                    case "csv":
                        i.exportToCSV({
                            series: e.config.series,
                            columnDelimiter: e.config.chart.toolbar.export.csv.columnDelimiter
                        });
                }
            }
        },
        {
            key: "handleZoomReset",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    var e = t.w;
                    if (e.globals.lastXAxis.min = e.globals.initialConfig.xaxis.min, e.globals.lastXAxis.max = e.globals.initialConfig.xaxis.max, t.updateHelpers.revertDefaultAxisMinMax(), "function" == typeof e.config.chart.events.beforeResetZoom) {
                        var i = e.config.chart.events.beforeResetZoom(t, e);
                        i && t.updateHelpers.revertDefaultAxisMinMax(i);
                    }
                    "function" == typeof e.config.chart.events.zoomed && t.ctx.toolbar.zoomCallback({
                        min: e.config.xaxis.min,
                        max: e.config.xaxis.max
                    }), e.globals.zoomed = !1;
                    var a = t.ctx.series.emptyCollapsedSeries(x.clone(e.globals.initialSeries));
                    t.updateHelpers._updateSeries(a, e.config.chart.animations.dynamicAnimation.enabled);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
            }
        }
    ]), t;
}(), ct = function(t) {
    n(i, ht);
    var e = d(i);
    function i(t) {
        var s;
        return a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.dragged = !1, s.graphics = new m(s.ctx), s.eventList = [
            "mousedown",
            "mouseleave",
            "mousemove",
            "touchstart",
            "touchmove",
            "mouseup",
            "touchend"
        ], s.clientX = 0, s.clientY = 0, s.startX = 0, s.endX = 0, s.dragX = 0, s.startY = 0, s.endY = 0, s.dragY = 0, s.moveDirection = "none", s;
    }
    return r(i, [
        {
            key: "init",
            value: function(t) {
                var e = this, i = t.xyRatios, a = this.w, s = this;
                this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = a.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), a.globals.dom.elGraphical.add(this.zoomRect), a.globals.dom.elGraphical.add(this.selectionRect), "x" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    minY: 0,
                    maxX: a.globals.gridWidth,
                    maxY: a.globals.gridHeight
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : "y" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    maxX: a.globals.gridWidth
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(t) {
                    e.hoverArea.addEventListener(t, s.svgMouseEvents.bind(s, i), {
                        capture: !1,
                        passive: !0
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
            }
        },
        {
            key: "svgMouseEvents",
            value: function(t, e) {
                var i = this.w, a = this, s = this.ctx.toolbar, r = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type, o = i.config.chart.toolbar.autoSelected;
                if (e.shiftKey ? (this.shiftWasPressed = !0, s.enableZoomPanFromToolbar("pan" === o ? "zoom" : "pan")) : this.shiftWasPressed && (s.enableZoomPanFromToolbar(o), this.shiftWasPressed = !1), e.target) {
                    var n, l = e.target.classList;
                    if (e.target.parentNode && null !== e.target.parentNode && (n = e.target.parentNode.classList), !(l.contains("apexcharts-selection-rect") || l.contains("apexcharts-legend-marker") || l.contains("apexcharts-legend-text") || n && n.contains("apexcharts-toolbar"))) {
                        if (a.clientX = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientX : "touchend" === e.type ? e.changedTouches[0].clientX : e.clientX, a.clientY = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientY : "touchend" === e.type ? e.changedTouches[0].clientY : e.clientY, "mousedown" === e.type && 1 === e.which) {
                            var h = a.gridRect.getBoundingClientRect();
                            a.startX = a.clientX - h.left, a.startY = a.clientY - h.top, a.dragged = !1, a.w.globals.mousedown = !0;
                        }
                        if (("mousemove" === e.type && 1 === e.which || "touchmove" === e.type) && (a.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, a.w.globals.mousedown && a.panDragging({
                            context: a,
                            zoomtype: r,
                            xyRatios: t
                        })) : (a.w.globals.mousedown && i.globals.zoomEnabled || a.w.globals.mousedown && i.globals.selectionEnabled) && (a.selection = a.selectionDrawing({
                            context: a,
                            zoomtype: r
                        }))), "mouseup" === e.type || "touchend" === e.type || "mouseleave" === e.type) {
                            var c = a.gridRect.getBoundingClientRect();
                            a.w.globals.mousedown && (a.endX = a.clientX - c.left, a.endY = a.clientY - c.top, a.dragX = Math.abs(a.endX - a.startX), a.dragY = Math.abs(a.endY - a.startY), (i.globals.zoomEnabled || i.globals.selectionEnabled) && a.selectionDrawn({
                                context: a,
                                zoomtype: r
                            }), i.globals.panEnabled && i.config.xaxis.convertedCatToNumeric && a.delayedPanScrolled()), i.globals.zoomEnabled && a.hideSelectionRect(this.selectionRect), a.dragged = !1, a.w.globals.mousedown = !1;
                        }
                        this.makeSelectionRectDraggable();
                    }
                }
            }
        },
        {
            key: "makeSelectionRectDraggable",
            value: function() {
                var t = this.w;
                if (this.selectionRect) {
                    var e = this.selectionRect.node.getBoundingClientRect();
                    e.width > 0 && e.height > 0 && this.slDraggableRect.selectize({
                        points: "l, r",
                        pointSize: 8,
                        pointType: "rect"
                    }).resize({
                        constraint: {
                            minX: 0,
                            minY: 0,
                            maxX: t.globals.gridWidth,
                            maxY: t.globals.gridHeight
                        }
                    }).on("resizing", this.selectionDragging.bind(this, "resizing"));
                }
            }
        },
        {
            key: "preselectedSelection",
            value: function() {
                var t = this.w, e = this.xyRatios;
                if (!t.globals.zoomEnabled) {
                    if (void 0 !== t.globals.selection && null !== t.globals.selection) this.drawSelectionRect(t.globals.selection);
                    else if (void 0 !== t.config.chart.selection.xaxis.min && void 0 !== t.config.chart.selection.xaxis.max) {
                        var i = (t.config.chart.selection.xaxis.min - t.globals.minX) / e.xRatio, a = t.globals.gridWidth - (t.globals.maxX - t.config.chart.selection.xaxis.max) / e.xRatio - i;
                        t.globals.isRangeBar && (i = (t.config.chart.selection.xaxis.min - t.globals.yAxisScale[0].niceMin) / e.invertedYRatio, a = (t.config.chart.selection.xaxis.max - t.config.chart.selection.xaxis.min) / e.invertedYRatio);
                        var s = {
                            x: i,
                            y: 0,
                            width: a,
                            height: t.globals.gridHeight,
                            translateX: 0,
                            translateY: 0,
                            selectionEnabled: !0
                        };
                        this.drawSelectionRect(s), this.makeSelectionRectDraggable(), "function" == typeof t.config.chart.events.selection && t.config.chart.events.selection(this.ctx, {
                            xaxis: {
                                min: t.config.chart.selection.xaxis.min,
                                max: t.config.chart.selection.xaxis.max
                            },
                            yaxis: {}
                        });
                    }
                }
            }
        },
        {
            key: "drawSelectionRect",
            value: function(t) {
                var e = t.x, i = t.y, a = t.width, s = t.height, r = t.translateX, o = void 0 === r ? 0 : r, n = t.translateY, l = void 0 === n ? 0 : n, h = this.w, c = this.zoomRect, d = this.selectionRect;
                if (this.dragged || null !== h.globals.selection) {
                    var g = {
                        transform: "translate(" + o + ", " + l + ")"
                    };
                    h.globals.zoomEnabled && this.dragged && (a < 0 && (a = 1), c.attr({
                        x: e,
                        y: i,
                        width: a,
                        height: s,
                        fill: h.config.chart.zoom.zoomedArea.fill.color,
                        "fill-opacity": h.config.chart.zoom.zoomedArea.fill.opacity,
                        stroke: h.config.chart.zoom.zoomedArea.stroke.color,
                        "stroke-width": h.config.chart.zoom.zoomedArea.stroke.width,
                        "stroke-opacity": h.config.chart.zoom.zoomedArea.stroke.opacity
                    }), m.setAttrs(c.node, g)), h.globals.selectionEnabled && (d.attr({
                        x: e,
                        y: i,
                        width: a > 0 ? a : 0,
                        height: s > 0 ? s : 0,
                        fill: h.config.chart.selection.fill.color,
                        "fill-opacity": h.config.chart.selection.fill.opacity,
                        stroke: h.config.chart.selection.stroke.color,
                        "stroke-width": h.config.chart.selection.stroke.width,
                        "stroke-dasharray": h.config.chart.selection.stroke.dashArray,
                        "stroke-opacity": h.config.chart.selection.stroke.opacity
                    }), m.setAttrs(d.node, g));
                }
            }
        },
        {
            key: "hideSelectionRect",
            value: function(t) {
                t && t.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
        },
        {
            key: "selectionDrawing",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.gridRect.getBoundingClientRect(), o = s.startX - 1, n = s.startY, l = !1, h = !1, c = s.clientX - r.left - o, d = s.clientY - r.top - n, g = {};
                return Math.abs(c + o) > a.globals.gridWidth ? c = a.globals.gridWidth - o : s.clientX - r.left < 0 && (c = o), o > s.clientX - r.left && (l = !0, c = Math.abs(c)), n > s.clientY - r.top && (h = !0, d = Math.abs(d)), g = "x" === i ? {
                    x: l ? o - c : o,
                    y: 0,
                    width: c,
                    height: a.globals.gridHeight
                } : "y" === i ? {
                    x: 0,
                    y: h ? n - d : n,
                    width: a.globals.gridWidth,
                    height: d
                } : {
                    x: l ? o - c : o,
                    y: h ? n - d : n,
                    width: c,
                    height: d
                }, s.drawSelectionRect(g), s.selectionDragging("resizing"), g;
            }
        },
        {
            key: "selectionDragging",
            value: function(t, e) {
                var i = this, a = this.w, s = this.xyRatios, r = this.selectionRect, o = 0;
                "resizing" === t && (o = 30);
                var n = function(t) {
                    return parseFloat(r.node.getAttribute(t));
                }, l = {
                    x: n("x"),
                    y: n("y"),
                    width: n("width"),
                    height: n("height")
                };
                a.globals.selection = l, "function" == typeof a.config.chart.events.selection && a.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                    var t, e, o, n, l = i.gridRect.getBoundingClientRect(), h = r.node.getBoundingClientRect();
                    a.globals.isRangeBar ? (t = a.globals.yAxisScale[0].niceMin + (h.left - l.left) * s.invertedYRatio, e = a.globals.yAxisScale[0].niceMin + (h.right - l.left) * s.invertedYRatio, o = 0, n = 1) : (t = a.globals.xAxisScale.niceMin + (h.left - l.left) * s.xRatio, e = a.globals.xAxisScale.niceMin + (h.right - l.left) * s.xRatio, o = a.globals.yAxisScale[0].niceMin + (l.bottom - h.bottom) * s.yRatio[0], n = a.globals.yAxisScale[0].niceMax - (h.top - l.top) * s.yRatio[0]);
                    var c = {
                        xaxis: {
                            min: t,
                            max: e
                        },
                        yaxis: {
                            min: o,
                            max: n
                        }
                    };
                    a.config.chart.events.selection(i.ctx, c), a.config.chart.brush.enabled && void 0 !== a.config.chart.events.brushScrolled && a.config.chart.events.brushScrolled(i.ctx, c);
                }, o));
            }
        },
        {
            key: "selectionDrawn",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.xyRatios, o = this.ctx.toolbar;
                if (s.startX > s.endX) {
                    var n = s.startX;
                    s.startX = s.endX, s.endX = n;
                }
                if (s.startY > s.endY) {
                    var l = s.startY;
                    s.startY = s.endY, s.endY = l;
                }
                var h = void 0, c = void 0;
                a.globals.isRangeBar ? (h = a.globals.yAxisScale[0].niceMin + s.startX * r.invertedYRatio, c = a.globals.yAxisScale[0].niceMin + s.endX * r.invertedYRatio) : (h = a.globals.xAxisScale.niceMin + s.startX * r.xRatio, c = a.globals.xAxisScale.niceMin + s.endX * r.xRatio);
                var d = [], g = [];
                if (a.config.yaxis.forEach(function(t, e) {
                    d.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.startY), g.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.endY);
                }), s.dragged && (s.dragX > 10 || s.dragY > 10) && h !== c) {
                    if (a.globals.zoomEnabled) {
                        var u = x.clone(a.globals.initialConfig.yaxis), p = x.clone(a.globals.initialConfig.xaxis);
                        if (a.globals.zoomed = !0, a.config.xaxis.convertedCatToNumeric && (h = Math.floor(h), c = Math.floor(c), h < 1 && (h = 1, c = a.globals.dataPoints), c - h < 2 && (c = h + 1)), "xy" !== i && "x" !== i || (p = {
                            min: h,
                            max: c
                        }), "xy" !== i && "y" !== i || u.forEach(function(t, e) {
                            u[e].min = g[e], u[e].max = d[e];
                        }), a.config.chart.zoom.autoScaleYaxis) {
                            var f = new _(s.ctx);
                            u = f.autoScaleY(s.ctx, u, {
                                xaxis: p
                            });
                        }
                        if (o) {
                            var b = o.getBeforeZoomRange(p, u);
                            b && (p = b.xaxis ? b.xaxis : p, u = b.yaxis ? b.yaxis : u);
                        }
                        var v = {
                            xaxis: p
                        };
                        a.config.chart.group || (v.yaxis = u), s.ctx.updateHelpers._updateOptions(v, !1, s.w.config.chart.animations.dynamicAnimation.enabled), "function" == typeof a.config.chart.events.zoomed && o.zoomCallback(p, u);
                    } else if (a.globals.selectionEnabled) {
                        var m, y = null;
                        m = {
                            min: h,
                            max: c
                        }, "xy" !== i && "y" !== i || (y = x.clone(a.config.yaxis)).forEach(function(t, e) {
                            y[e].min = g[e], y[e].max = d[e];
                        }), a.globals.selection = s.selection, "function" == typeof a.config.chart.events.selection && a.config.chart.events.selection(s.ctx, {
                            xaxis: m,
                            yaxis: y
                        });
                    }
                }
            }
        },
        {
            key: "panDragging",
            value: function(t) {
                var e = t.context, i = this.w, a = e;
                if (void 0 !== i.globals.lastClientPosition.x) {
                    var s = i.globals.lastClientPosition.x - a.clientX, r = i.globals.lastClientPosition.y - a.clientY;
                    Math.abs(s) > Math.abs(r) && s > 0 ? this.moveDirection = "left" : Math.abs(s) > Math.abs(r) && s < 0 ? this.moveDirection = "right" : Math.abs(r) > Math.abs(s) && r > 0 ? this.moveDirection = "up" : Math.abs(r) > Math.abs(s) && r < 0 && (this.moveDirection = "down");
                }
                i.globals.lastClientPosition = {
                    x: a.clientX,
                    y: a.clientY
                };
                var o = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, n = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                i.config.xaxis.convertedCatToNumeric || a.panScrolled(o, n);
            }
        },
        {
            key: "delayedPanScrolled",
            value: function() {
                var t = this.w, e = t.globals.minX, i = t.globals.maxX, a = (t.globals.maxX - t.globals.minX) / 2;
                "left" === this.moveDirection ? (e = t.globals.minX + a, i = t.globals.maxX + a) : "right" === this.moveDirection && (e = t.globals.minX - a, i = t.globals.maxX - a), e = Math.floor(e), i = Math.floor(i), this.updateScrolledChart({
                    xaxis: {
                        min: e,
                        max: i
                    }
                }, e, i);
            }
        },
        {
            key: "panScrolled",
            value: function(t, e) {
                var i = this.w, a = this.xyRatios, s = x.clone(i.globals.initialConfig.yaxis), r = a.xRatio, o = i.globals.minX, n = i.globals.maxX;
                i.globals.isRangeBar && (r = a.invertedYRatio, o = i.globals.minY, n = i.globals.maxY), "left" === this.moveDirection ? (t = o + i.globals.gridWidth / 15 * r, e = n + i.globals.gridWidth / 15 * r) : "right" === this.moveDirection && (t = o - i.globals.gridWidth / 15 * r, e = n - i.globals.gridWidth / 15 * r), i.globals.isRangeBar || (t < i.globals.initialMinX || e > i.globals.initialMaxX) && (t = o, e = n);
                var l = {
                    min: t,
                    max: e
                };
                i.config.chart.zoom.autoScaleYaxis && (s = new _(this.ctx).autoScaleY(this.ctx, s, {
                    xaxis: l
                }));
                var h = {
                    xaxis: {
                        min: t,
                        max: e
                    }
                };
                i.config.chart.group || (h.yaxis = s), this.updateScrolledChart(h, t, e);
            }
        },
        {
            key: "updateScrolledChart",
            value: function(t, e, i) {
                var a = this.w;
                this.ctx.updateHelpers._updateOptions(t, !1, !1), "function" == typeof a.config.chart.events.scrolled && a.config.chart.events.scrolled(this.ctx, {
                    xaxis: {
                        min: e,
                        max: i
                    }
                });
            }
        }
    ]), i;
}(), dt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
    }
    return r(t, [
        {
            key: "getNearestValues",
            value: function(t) {
                var e = t.hoverArea, i = t.elGrid, a = t.clientX, s = t.clientY, r = this.w, o = i.getBoundingClientRect(), n = o.width, l = o.height, h = n / (r.globals.dataPoints - 1), c = l / r.globals.dataPoints, d = this.hasBars();
                !r.globals.comboCharts && !d || r.config.xaxis.convertedCatToNumeric || (h = n / r.globals.dataPoints);
                var g = a - o.left - r.globals.barPadForNumericAxis, u = s - o.top;
                g < 0 || u < 0 || g > n || u > l ? (e.classList.remove("hovering-zoom"), e.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (e.classList.remove("hovering-pan"), e.classList.add("hovering-zoom")) : r.globals.panEnabled && (e.classList.remove("hovering-zoom"), e.classList.add("hovering-pan"));
                var p = Math.round(g / h), f = Math.floor(u / c);
                d && !r.config.xaxis.convertedCatToNumeric && (p = Math.ceil(g / h), p -= 1);
                var b = null, v = null, m = r.globals.seriesXvalues.map(function(t) {
                    return t.filter(function(t) {
                        return x.isNumber(t);
                    });
                }), y = r.globals.seriesYvalues.map(function(t) {
                    return t.filter(function(t) {
                        return x.isNumber(t);
                    });
                });
                if (r.globals.isXNumeric) {
                    var w = this.ttCtx.getElGrid().getBoundingClientRect(), k = g * (w.width / n), A = u * (w.height / l);
                    b = (v = this.closestInMultiArray(k, A, m, y)).index, p = v.j, null !== b && (m = r.globals.seriesXvalues[b], p = (v = this.closestInArray(k, m)).index);
                }
                return r.globals.capturedSeriesIndex = null === b ? -1 : b, (!p || p < 1) && (p = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = f : r.globals.capturedDataPointIndex = p, {
                    capturedSeries: b,
                    j: r.globals.isBarHorizontal ? f : p,
                    hoverX: g,
                    hoverY: u
                };
            }
        },
        {
            key: "closestInMultiArray",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = null, n = -1;
                s.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : o = 0;
                var l = i[r][0], h = Math.abs(t - l);
                if (i.forEach(function(e) {
                    e.forEach(function(e, i) {
                        var a = Math.abs(t - e);
                        a <= h && (h = a, n = i);
                    });
                }), -1 !== n) {
                    var c = a[r][n], d = Math.abs(e - c);
                    o = r, a.forEach(function(t, i) {
                        var a = Math.abs(e - t[n]);
                        a <= d && (d = a, o = i);
                    });
                }
                return {
                    index: o,
                    j: n
                };
            }
        },
        {
            key: "getFirstActiveXArray",
            value: function(t) {
                for(var e = this.w, i = 0, a = t.map(function(t, e) {
                    return t.length > 0 ? e : -1;
                }), s = 0; s < a.length; s++)if (-1 !== a[s] && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)) {
                    i = a[s];
                    break;
                }
                return i;
            }
        },
        {
            key: "closestInArray",
            value: function(t, e) {
                for(var i = e[0], a = null, s = Math.abs(t - i), r = 0; r < e.length; r++){
                    var o = Math.abs(t - e[r]);
                    o < s && (s = o, a = r);
                }
                return {
                    index: a
                };
            }
        },
        {
            key: "isXoverlap",
            value: function(t) {
                var e = [], i = this.w.globals.seriesX.filter(function(t) {
                    return void 0 !== t[0];
                });
                if (i.length > 0) for(var a = 0; a < i.length - 1; a++)void 0 !== i[a][t] && void 0 !== i[a + 1][t] && i[a][t] !== i[a + 1][t] && e.push("unEqual");
                return 0 === e.length;
            }
        },
        {
            key: "isInitialSeriesSameLen",
            value: function() {
                for(var t = !0, e = this.w.globals.initialSeries, i = 0; i < e.length - 1; i++)if (e[i].data.length !== e[i + 1].data.length) {
                    t = !1;
                    break;
                }
                return t;
            }
        },
        {
            key: "getBarsHeight",
            value: function(t) {
                return u(t).reduce(function(t, e) {
                    return t + e.getBBox().height;
                }, 0);
            }
        },
        {
            key: "getElMarkers",
            value: function(t) {
                return "number" == typeof t ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
            }
        },
        {
            key: "getAllMarkers",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                (t = u(t)).sort(function(t, e) {
                    var i = Number(t.getAttribute("data:realIndex")), a = Number(e.getAttribute("data:realIndex"));
                    return a < i ? 1 : a > i ? -1 : 0;
                });
                var e = [];
                return t.forEach(function(t) {
                    e.push(t.querySelector(".apexcharts-marker"));
                }), e;
            }
        },
        {
            key: "hasMarkers",
            value: function(t) {
                return this.getElMarkers(t).length > 0;
            }
        },
        {
            key: "getElBars",
            value: function() {
                return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
            }
        },
        {
            key: "hasBars",
            value: function() {
                return this.getElBars().length > 0;
            }
        },
        {
            key: "getHoverMarkerSize",
            value: function(t) {
                var e = this.w, i = e.config.markers.hover.size;
                return void 0 === i && (i = e.globals.markers.size[t] + e.config.markers.hover.sizeOffset), i;
            }
        },
        {
            key: "toggleAllTooltipSeriesGroups",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                0 === i.allTooltipSeriesGroups.length && (i.allTooltipSeriesGroups = e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)"enable" === t ? (a[s].classList.add("apexcharts-active"), a[s].style.display = e.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
            }
        }
    ]), t;
}(), gt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new dt(e);
    }
    return r(t, [
        {
            key: "drawSeriesTexts",
            value: function(t) {
                var e = t.shared, i = void 0 === e || e, a = t.ttItems, s = t.i, r = void 0 === s ? 0 : s, o = t.j, n = void 0 === o ? null : o, l = t.y1, h = t.y2, c = t.e, d = this.w;
                void 0 !== d.config.tooltip.custom ? this.handleCustomTooltip({
                    i: r,
                    j: n,
                    y1: l,
                    y2: h,
                    w: d
                }) : this.toggleActiveInactiveSeries(i);
                var g = this.getValuesToPrint({
                    i: r,
                    j: n
                });
                this.printLabels({
                    i: r,
                    j: n,
                    values: g,
                    ttItems: a,
                    shared: i,
                    e: c
                });
                var u = this.ttCtx.getElTooltip();
                this.ttCtx.tooltipRect.ttWidth = u.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = u.getBoundingClientRect().height;
            }
        },
        {
            key: "printLabels",
            value: function(t) {
                var i, a = this, s = t.i, r = t.j, o = t.values, n = t.ttItems, l = t.shared, h = t.e, c = this.w, d = [], g = function(t) {
                    return c.globals.seriesGoals[t] && c.globals.seriesGoals[t][r] && Array.isArray(c.globals.seriesGoals[t][r]);
                }, u = o.xVal, p = o.zVal, f = o.xAxisTTVal, x = "", b = c.globals.colors[s];
                null !== r && c.config.plotOptions.bar.distributed && (b = c.globals.colors[r]);
                for(var v = function(t, o) {
                    var v = a.getFormatters(s);
                    x = a.getSeriesName({
                        fn: v.yLbTitleFormatter,
                        index: s,
                        seriesIndex: s,
                        j: r
                    }), "treemap" === c.config.chart.type && (x = v.yLbTitleFormatter(String(c.config.series[s].data[r].x), {
                        series: c.globals.series,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: c
                    }));
                    var m = c.config.tooltip.inverseOrder ? o : t;
                    if (c.globals.axisCharts) {
                        var y = function(t) {
                            var e, i, a, s;
                            return c.globals.isRangeData ? v.yLbFormatter(null === (e = c.globals.seriesRangeStart) || void 0 === e || null === (i = e[t]) || void 0 === i ? void 0 : i[r], {
                                series: c.globals.seriesRangeStart,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            }) + " - " + v.yLbFormatter(null === (a = c.globals.seriesRangeEnd) || void 0 === a || null === (s = a[t]) || void 0 === s ? void 0 : s[r], {
                                series: c.globals.seriesRangeEnd,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            }) : v.yLbFormatter(c.globals.series[t][r], {
                                series: c.globals.series,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            });
                        };
                        if (l) v = a.getFormatters(m), x = a.getSeriesName({
                            fn: v.yLbTitleFormatter,
                            index: m,
                            seriesIndex: s,
                            j: r
                        }), b = c.globals.colors[m], i = y(m), g(m) && (d = c.globals.seriesGoals[m][r].map(function(t) {
                            return {
                                attrs: t,
                                val: v.yLbFormatter(t.value, {
                                    seriesIndex: m,
                                    dataPointIndex: r,
                                    w: c
                                })
                            };
                        }));
                        else {
                            var w, k = null == h || null === (w = h.target) || void 0 === w ? void 0 : w.getAttribute("fill");
                            k && (b = -1 !== k.indexOf("url") ? document.querySelector(k.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke") : k), i = y(s), g(s) && Array.isArray(c.globals.seriesGoals[s][r]) && (d = c.globals.seriesGoals[s][r].map(function(t) {
                                return {
                                    attrs: t,
                                    val: v.yLbFormatter(t.value, {
                                        seriesIndex: s,
                                        dataPointIndex: r,
                                        w: c
                                    })
                                };
                            }));
                        }
                    }
                    null === r && (i = v.yLbFormatter(c.globals.series[s], e(e({}, c), {}, {
                        seriesIndex: s,
                        dataPointIndex: s
                    }))), a.DOMHandling({
                        i: s,
                        t: m,
                        j: r,
                        ttItems: n,
                        values: {
                            val: i,
                            goalVals: d,
                            xVal: u,
                            xAxisTTVal: f,
                            zVal: p
                        },
                        seriesName: x,
                        shared: l,
                        pColor: b
                    });
                }, m = 0, y = c.globals.series.length - 1; m < c.globals.series.length; m++, y--)v(m, y);
            }
        },
        {
            key: "getFormatters",
            value: function(t) {
                var e, i = this.w, a = i.globals.yLabelFormatters[t];
                return void 0 !== i.globals.ttVal ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[t] && i.globals.ttVal[t].formatter, e = i.globals.ttVal[t] && i.globals.ttVal[t].title && i.globals.ttVal[t].title.formatter) : (a = i.globals.ttVal.formatter, "function" == typeof i.globals.ttVal.title.formatter && (e = i.globals.ttVal.title.formatter)) : e = i.config.tooltip.y.title.formatter, "function" != typeof a && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(t) {
                    return t;
                }), "function" != typeof e && (e = function(t) {
                    return t;
                }), {
                    yLbFormatter: a,
                    yLbTitleFormatter: e
                };
            }
        },
        {
            key: "getSeriesName",
            value: function(t) {
                var e = t.fn, i = t.index, a = t.seriesIndex, s = t.j, r = this.w;
                return e(String(r.globals.seriesNames[i]), {
                    series: r.globals.series,
                    seriesIndex: a,
                    dataPointIndex: s,
                    w: r
                });
            }
        },
        {
            key: "DOMHandling",
            value: function(t) {
                t.i;
                var e = t.t, i = t.j, a = t.ttItems, s = t.values, r = t.seriesName, o = t.shared, n = t.pColor, l = this.w, h = this.ttCtx, c = s.val, d = s.goalVals, g = s.xVal, u = s.xAxisTTVal, p = s.zVal, f = null;
                f = a[e].children, l.config.tooltip.fillSeriesColor && (a[e].style.backgroundColor = n, f[0].style.display = "none"), h.showTooltipTitle && (null === h.tooltipTitle && (h.tooltipTitle = l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), h.tooltipTitle.innerHTML = g), h.isXAxisTooltipEnabled && (h.xaxisTooltipText.innerHTML = "" !== u ? u : g);
                var x = a[e].querySelector(".apexcharts-tooltip-text-y-label");
                x && (x.innerHTML = r || "");
                var b = a[e].querySelector(".apexcharts-tooltip-text-y-value");
                b && (b.innerHTML = void 0 !== c ? c : ""), f[0] && f[0].classList.contains("apexcharts-tooltip-marker") && (l.config.tooltip.marker.fillColors && Array.isArray(l.config.tooltip.marker.fillColors) && (n = l.config.tooltip.marker.fillColors[e]), f[0].style.backgroundColor = n), l.config.tooltip.marker.show || (f[0].style.display = "none");
                var v = a[e].querySelector(".apexcharts-tooltip-text-goals-label"), m = a[e].querySelector(".apexcharts-tooltip-text-goals-value");
                if (d.length && l.globals.seriesGoals[e]) {
                    var y = function() {
                        var t = "<div >", e = "<div>";
                        d.forEach(function(i, a) {
                            t += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name, "</div>"), e += "<div>".concat(i.val, "</div>");
                        }), v.innerHTML = t + "</div>", m.innerHTML = e + "</div>";
                    };
                    o ? l.globals.seriesGoals[e][i] && Array.isArray(l.globals.seriesGoals[e][i]) ? y() : (v.innerHTML = "", m.innerHTML = "") : y();
                } else v.innerHTML = "", m.innerHTML = "";
                null !== p && (a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = l.config.tooltip.z.title, a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = void 0 !== p ? p : "");
                if (o && f[0]) {
                    if (l.config.tooltip.hideEmptySeries) {
                        var w = a[e].querySelector(".apexcharts-tooltip-marker"), k = a[e].querySelector(".apexcharts-tooltip-text");
                        0 == parseFloat(c) ? (w.style.display = "none", k.style.display = "none") : (w.style.display = "block", k.style.display = "block");
                    }
                    null == c || l.globals.ancillaryCollapsedSeriesIndices.indexOf(e) > -1 || l.globals.collapsedSeriesIndices.indexOf(e) > -1 ? f[0].parentNode.style.display = "none" : f[0].parentNode.style.display = l.config.tooltip.items.display;
                }
            }
        },
        {
            key: "toggleActiveInactiveSeries",
            value: function(t) {
                var e = this.w;
                if (t) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                else {
                    this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                    var i = e.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");
                    i && (i.classList.add("apexcharts-active"), i.style.display = e.config.tooltip.items.display);
                }
            }
        },
        {
            key: "getValuesToPrint",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", o = "", n = null, l = null, h = {
                    series: a.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }, c = a.globals.ttZFormatter;
                null === i ? l = a.globals.series[e] : a.globals.isXNumeric && "treemap" !== a.config.chart.type ? (r = s[e][i], 0 === s[e].length && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = void 0 !== a.globals.labels[i] ? a.globals.labels[i] : "";
                var d = r;
                a.globals.isXNumeric && "datetime" === a.config.xaxis.type ? r = new T(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, d, d, {
                    i: void 0,
                    dateFormatter: new I(this.ctx).formatDate,
                    w: this.w
                }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](d, h) : a.globals.xLabelFormatter(d, h);
                return void 0 !== a.config.tooltip.x.formatter && (r = a.globals.ttKeyFormatter(d, h)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[e].length > 0 && (n = c(a.globals.seriesZ[e][i], a)), o = "function" == typeof a.config.xaxis.tooltip.formatter ? a.globals.xaxisTooltipFormatter(d, h) : r, {
                    val: Array.isArray(l) ? l.join(" ") : l,
                    xVal: Array.isArray(r) ? r.join(" ") : r,
                    xAxisTTVal: Array.isArray(o) ? o.join(" ") : o,
                    zVal: n
                };
            }
        },
        {
            key: "handleCustomTooltip",
            value: function(t) {
                var e = t.i, i = t.j, a = t.y1, s = t.y2, r = t.w, o = this.ttCtx.getElTooltip(), n = r.config.tooltip.custom;
                Array.isArray(n) && n[e] && (n = n[e]), o.innerHTML = n({
                    ctx: this.ctx,
                    series: r.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    y1: a,
                    y2: s,
                    w: r
                });
            }
        }
    ]), t;
}(), ut = function() {
    function t(e) {
        a(this, t), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
    }
    return r(t, [
        {
            key: "moveXCrosshairs",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = t - i.xcrosshairsWidth / 2, o = a.globals.labels.slice().length;
                if (null !== e && (r = a.globals.gridWidth / o * e), null === s || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                    var n = r;
                    "tickWidth" !== a.config.xaxis.crosshairs.width && "barWidth" !== a.config.xaxis.crosshairs.width || (n = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(n);
                }
            }
        },
        {
            key: "moveYCrosshairs",
            value: function(t) {
                var e = this.ttCtx;
                null !== e.ycrosshairs && m.setAttrs(e.ycrosshairs, {
                    y1: t,
                    y2: t
                }), null !== e.ycrosshairsHidden && m.setAttrs(e.ycrosshairsHidden, {
                    y1: t,
                    y2: t
                });
            }
        },
        {
            key: "moveXAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                if (null !== i.xaxisTooltip && 0 !== i.xcrosshairsWidth) {
                    i.xaxisTooltip.classList.add("apexcharts-active");
                    var a = i.xaxisOffY + e.config.xaxis.tooltip.offsetY + e.globals.translateY + 1 + e.config.xaxis.offsetY;
                    if (t -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(t)) {
                        t += e.globals.translateX;
                        var s;
                        s = new m(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = t + "px", i.xaxisTooltip.style.top = a + "px";
                    }
                }
            }
        },
        {
            key: "moveYAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                null === i.yaxisTTEls && (i.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = e.globals.translateY + a, r = i.yaxisTTEls[t].getBoundingClientRect().height, o = e.globals.translateYAxisX[t] - 2;
                e.config.yaxis[t].opposite && (o -= 26), s -= r / 2, -1 === e.globals.ignoreYAxisIndexes.indexOf(t) ? (i.yaxisTTEls[t].classList.add("apexcharts-active"), i.yaxisTTEls[t].style.top = s + "px", i.yaxisTTEls[t].style.left = o + e.config.yaxis[t].tooltip.offsetX + "px") : i.yaxisTTEls[t].classList.remove("apexcharts-active");
            }
        },
        {
            key: "moveTooltip",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), o = s.tooltipRect, n = null !== i ? parseFloat(i) : 1, l = parseFloat(t) + n + 5, h = parseFloat(e) + n / 2;
                if (l > a.globals.gridWidth / 2 && (l = l - o.ttWidth - n - 10), l > a.globals.gridWidth - o.ttWidth - 10 && (l = a.globals.gridWidth - o.ttWidth), l < -20 && (l = -20), a.config.tooltip.followCursor) {
                    var c = s.getElGrid().getBoundingClientRect();
                    (l = s.e.clientX - c.left) > a.globals.gridWidth / 2 && (l -= s.tooltipRect.ttWidth), (h = s.e.clientY + a.globals.translateY - c.top) > a.globals.gridHeight / 2 && (h -= s.tooltipRect.ttHeight);
                } else a.globals.isBarHorizontal || o.ttHeight / 2 + h > a.globals.gridHeight && (h = a.globals.gridHeight - o.ttHeight + a.globals.translateY);
                isNaN(l) || (l += a.globals.translateX, r.style.left = l + "px", r.style.top = h + "px");
            }
        },
        {
            key: "moveMarkers",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx;
                if (i.globals.markers.size[t] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === e && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(e, s[r]));
                else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(e, t);
            }
        },
        {
            key: "moveDynamicPointOnHover",
            value: function(t, e) {
                var i, a, s = this.w, r = this.ttCtx, o = s.globals.pointsArray, n = r.tooltipUtil.getHoverMarkerSize(e), l = s.config.series[e].type;
                if (!l || "column" !== l && "candlestick" !== l && "boxPlot" !== l) {
                    i = o[e][t][0], a = o[e][t][1] ? o[e][t][1] : 0;
                    var h = s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers circle"));
                    h && a < s.globals.gridHeight && a > 0 && (h.setAttribute("r", n), h.setAttribute("cx", i), h.setAttribute("cy", a)), this.moveXCrosshairs(i), r.fixedTooltip || this.moveTooltip(i, a, n);
                }
            }
        },
        {
            key: "moveDynamicPointsOnHover",
            value: function(t) {
                var e, i = this.ttCtx, a = i.w, s = 0, r = 0, o = a.globals.pointsArray;
                e = new N(this.ctx).getActiveConfigSeriesIndex("asc", [
                    "line",
                    "area",
                    "scatter",
                    "bubble"
                ]);
                var n = i.tooltipUtil.getHoverMarkerSize(e);
                o[e] && (s = o[e][t][0], r = o[e][t][1]);
                var l = i.tooltipUtil.getAllMarkers();
                if (null !== l) for(var h = 0; h < a.globals.series.length; h++){
                    var c = o[h];
                    if (a.globals.comboCharts && void 0 === c && l.splice(h, 0, null), c && c.length) {
                        var d = o[h][t][1], g = void 0;
                        if (l[h].setAttribute("cx", s), "rangeArea" === a.config.chart.type && !a.globals.comboCharts) {
                            var u = t + a.globals.series[h].length;
                            g = o[h][u][1], d -= Math.abs(d - g) / 2;
                        }
                        null !== d && !isNaN(d) && d < a.globals.gridHeight + n && d + n > 0 ? (l[h] && l[h].setAttribute("r", n), l[h] && l[h].setAttribute("cy", d)) : l[h] && l[h].setAttribute("r", 0);
                    }
                }
                this.moveXCrosshairs(s), i.fixedTooltip || this.moveTooltip(s, r || a.globals.gridHeight, n);
            }
        },
        {
            key: "moveStickyTooltipOverBars",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx, s = i.globals.columnSeries ? i.globals.columnSeries.length : i.globals.series.length, r = s >= 2 && s % 2 == 0 ? Math.floor(s / 2) : Math.floor(s / 2) + 1;
                i.globals.isBarHorizontal && (r = new N(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
                var o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r, "'] path[j='").concat(t, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "']"));
                o || "number" != typeof e || (o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "']")));
                var n = o ? parseFloat(o.getAttribute("cx")) : 0, l = o ? parseFloat(o.getAttribute("cy")) : 0, h = o ? parseFloat(o.getAttribute("barWidth")) : 0, c = a.getElGrid().getBoundingClientRect(), d = o && (o.classList.contains("apexcharts-candlestick-area") || o.classList.contains("apexcharts-boxPlot-area"));
                i.globals.isXNumeric ? (o && !d && (n -= s % 2 != 0 ? h / 2 : 0), o && d && i.globals.comboCharts && (n -= h / 2)) : i.globals.isBarHorizontal || (n = a.xAxisTicksPositions[t - 1] + a.dataPointsDividedWidth / 2, isNaN(n) && (n = a.xAxisTicksPositions[t] - a.dataPointsDividedWidth / 2)), i.globals.isBarHorizontal ? l -= a.tooltipRect.ttHeight : i.config.tooltip.followCursor ? l = a.e.clientY - c.top - a.tooltipRect.ttHeight / 2 : l + a.tooltipRect.ttHeight + 15 > i.globals.gridHeight && (l = i.globals.gridHeight), i.globals.isBarHorizontal || this.moveXCrosshairs(n), a.fixedTooltip || this.moveTooltip(n, l || i.globals.gridHeight);
            }
        }
    ]), t;
}(), pt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new ut(e);
    }
    return r(t, [
        {
            key: "drawDynamicPoints",
            value: function() {
                var t = this.w, e = new m(this.ctx), i = new H(this.ctx), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                a = u(a), t.config.chart.stacked && a.sort(function(t, e) {
                    return parseFloat(t.getAttribute("data:realIndex")) - parseFloat(e.getAttribute("data:realIndex"));
                });
                for(var s = 0; s < a.length; s++){
                    var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                    if (null !== r) {
                        var o = void 0, n = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                        "line" !== t.config.chart.type && "area" !== t.config.chart.type || t.globals.comboCharts || t.config.tooltip.intersect || (n += " no-pointer-events");
                        var l = i.getMarkerConfig({
                            cssClass: n,
                            seriesIndex: Number(r.getAttribute("data:realIndex"))
                        });
                        (o = e.drawMarker(0, 0, l)).node.setAttribute("default-marker-size", 0);
                        var h = document.createElementNS(t.globals.SVGNS, "g");
                        h.classList.add("apexcharts-series-markers"), h.appendChild(o.node), r.appendChild(h);
                    }
                }
            }
        },
        {
            key: "enlargeCurrentPoint",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w;
                "bubble" !== s.config.chart.type && this.newPointSize(t, e);
                var r = e.getAttribute("cx"), o = e.getAttribute("cy");
                if (null !== i && null !== a && (r = i, o = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                    if ("radar" === s.config.chart.type) {
                        var n = this.ttCtx.getElGrid().getBoundingClientRect();
                        r = this.ttCtx.e.clientX - n.left;
                    }
                    this.tooltipPosition.moveTooltip(r, o, s.config.markers.hover.size);
                }
            }
        },
        {
            key: "enlargePoints",
            value: function(t) {
                for(var e = this.w, i = this, a = this.ttCtx, s = t, r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), o = e.config.markers.hover.size, n = 0; n < r.length; n++){
                    var l = r[n].getAttribute("rel"), h = r[n].getAttribute("index");
                    if (void 0 === o && (o = e.globals.markers.size[h] + e.config.markers.hover.sizeOffset), s === parseInt(l, 10)) {
                        i.newPointSize(s, r[n]);
                        var c = r[n].getAttribute("cx"), d = r[n].getAttribute("cy");
                        i.tooltipPosition.moveXCrosshairs(c), a.fixedTooltip || i.tooltipPosition.moveTooltip(c, d, o);
                    } else i.oldPointSize(r[n]);
                }
            }
        },
        {
            key: "newPointSize",
            value: function(t, e) {
                var i = this.w, a = i.config.markers.hover.size, s = 0 === t ? e.parentNode.firstChild : e.parentNode.lastChild;
                if ("0" !== s.getAttribute("default-marker-size")) {
                    var r = parseInt(s.getAttribute("index"), 10);
                    void 0 === a && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0), s.setAttribute("r", a);
                }
            }
        },
        {
            key: "oldPointSize",
            value: function(t) {
                var e = parseFloat(t.getAttribute("default-marker-size"));
                t.setAttribute("r", e);
            }
        },
        {
            key: "resetPointsSize",
            value: function() {
                for(var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), e = 0; e < t.length; e++){
                    var i = parseFloat(t[e].getAttribute("default-marker-size"));
                    x.isNumber(i) && i >= 0 ? t[e].setAttribute("r", i) : t[e].setAttribute("r", 0);
                }
            }
        }
    ]), t;
}(), ft = function() {
    function t(e) {
        a(this, t), this.w = e.w;
        var i = this.w;
        this.ttCtx = e, this.isVerticalGroupedRangeBar = !i.globals.isBarHorizontal && "rangeBar" === i.config.chart.type && i.config.plotOptions.bar.rangeBarGroupRows;
    }
    return r(t, [
        {
            key: "getAttr",
            value: function(t, e) {
                return parseFloat(t.target.getAttribute(e));
            }
        },
        {
            key: "handleHeatTreeTooltip",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.x, s = t.y, r = t.type, o = this.ttCtx, n = this.w;
                if (e.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                    var l = this.getAttr(e, "i"), h = this.getAttr(e, "j"), c = this.getAttr(e, "cx"), d = this.getAttr(e, "cy"), g = this.getAttr(e, "width"), u = this.getAttr(e, "height");
                    if (o.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: l,
                        j: h,
                        shared: !1,
                        e: e
                    }), n.globals.capturedSeriesIndex = l, n.globals.capturedDataPointIndex = h, a = c + o.tooltipRect.ttWidth / 2 + g, s = d + o.tooltipRect.ttHeight / 2 - u / 2, o.tooltipPosition.moveXCrosshairs(c + g / 2), a > n.globals.gridWidth / 2 && (a = c - o.tooltipRect.ttWidth / 2 + g), o.w.config.tooltip.followCursor) {
                        var p = n.globals.dom.elWrap.getBoundingClientRect();
                        a = n.globals.clientX - p.left - (a > n.globals.gridWidth / 2 ? o.tooltipRect.ttWidth : 0), s = n.globals.clientY - p.top - (s > n.globals.gridHeight / 2 ? o.tooltipRect.ttHeight : 0);
                    }
                }
                return {
                    x: a,
                    y: s
                };
            }
        },
        {
            key: "handleMarkerTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = t.x, o = t.y, n = this.w, l = this.ttCtx;
                if (a.target.classList.contains("apexcharts-marker")) {
                    var h = parseInt(s.paths.getAttribute("cx"), 10), c = parseInt(s.paths.getAttribute("cy"), 10), d = parseFloat(s.paths.getAttribute("val"));
                    if (i = parseInt(s.paths.getAttribute("rel"), 10), e = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, l.intersect) {
                        var g = x.findAncestor(s.paths, "apexcharts-series");
                        g && (e = parseInt(g.getAttribute("data:realIndex"), 10));
                    }
                    if (l.tooltipLabels.drawSeriesTexts({
                        ttItems: s.ttItems,
                        i: e,
                        j: i,
                        shared: !l.showOnIntersect && n.config.tooltip.shared,
                        e: a
                    }), "mouseup" === a.type && l.markerClick(a, e, i), n.globals.capturedSeriesIndex = e, n.globals.capturedDataPointIndex = i, r = h, o = c + n.globals.translateY - 1.4 * l.tooltipRect.ttHeight, l.w.config.tooltip.followCursor) {
                        var u = l.getElGrid().getBoundingClientRect();
                        o = l.e.clientY + n.globals.translateY - u.top;
                    }
                    d < 0 && (o = c), l.marker.enlargeCurrentPoint(i, s.paths, r, o);
                }
                return {
                    x: r,
                    y: o
                };
            }
        },
        {
            key: "handleBarTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = this.ttCtx, n = o.getElTooltip(), l = 0, h = 0, c = 0, d = this.getBarTooltipXY({
                    e: a,
                    opt: s
                });
                e = d.i;
                var g = d.barHeight, u = d.j;
                r.globals.capturedSeriesIndex = e, r.globals.capturedDataPointIndex = u, r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (h = d.x, c = d.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[e] : r.config.stroke.width, l = h) : r.globals.comboCharts || r.config.tooltip.shared || (l /= 2), isNaN(c) && (c = r.globals.svgHeight - o.tooltipRect.ttHeight);
                var p = parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10), f = r.globals.isMultipleYAxis ? r.config.yaxis[p] && r.config.yaxis[p].reversed : r.config.yaxis[0].reversed;
                if (h + o.tooltipRect.ttWidth > r.globals.gridWidth && !f ? h -= o.tooltipRect.ttWidth : h < 0 && (h = 0), o.w.config.tooltip.followCursor) {
                    var x = o.getElGrid().getBoundingClientRect();
                    c = o.e.clientY - x.top;
                }
                null === o.tooltip && (o.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? o.tooltipPosition.moveXCrosshairs(l + i / 2) : o.tooltipPosition.moveXCrosshairs(l)), !o.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && o.tooltipUtil.hasBars()) && (f && (h -= o.tooltipRect.ttWidth) < 0 && (h = 0), !f || r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || (c = c + g - 2 * (r.globals.series[e][u] < 0 ? g : 0)), c = c + r.globals.translateY - o.tooltipRect.ttHeight / 2, n.style.left = h + r.globals.translateX + "px", n.style.top = c + "px");
            }
        },
        {
            key: "getBarTooltipXY",
            value: function(t) {
                var e = this, i = t.e, a = t.opt, s = this.w, r = null, o = this.ttCtx, n = 0, l = 0, h = 0, c = 0, d = 0, g = i.target.classList;
                if (g.contains("apexcharts-bar-area") || g.contains("apexcharts-candlestick-area") || g.contains("apexcharts-boxPlot-area") || g.contains("apexcharts-rangebar-area")) {
                    var u = i.target, p = u.getBoundingClientRect(), f = a.elGrid.getBoundingClientRect(), x = p.height;
                    d = p.height;
                    var b = p.width, v = parseInt(u.getAttribute("cx"), 10), m = parseInt(u.getAttribute("cy"), 10);
                    c = parseFloat(u.getAttribute("barWidth"));
                    var y = "touchmove" === i.type ? i.touches[0].clientX : i.clientX;
                    r = parseInt(u.getAttribute("j"), 10), n = parseInt(u.parentNode.getAttribute("rel"), 10) - 1;
                    var w = u.getAttribute("data-range-y1"), k = u.getAttribute("data-range-y2");
                    s.globals.comboCharts && (n = parseInt(u.parentNode.getAttribute("data:realIndex"), 10));
                    var A = function(t) {
                        return s.globals.isXNumeric ? v - b / 2 : e.isVerticalGroupedRangeBar ? v + b / 2 : v - o.dataPointsDividedWidth + b / 2;
                    }, S = function() {
                        return m - o.dataPointsDividedHeight + x / 2 - o.tooltipRect.ttHeight / 2;
                    };
                    o.tooltipLabels.drawSeriesTexts({
                        ttItems: a.ttItems,
                        i: n,
                        j: r,
                        y1: w ? parseInt(w, 10) : null,
                        y2: k ? parseInt(k, 10) : null,
                        shared: !o.showOnIntersect && s.config.tooltip.shared,
                        e: i
                    }), s.config.tooltip.followCursor ? s.globals.isBarHorizontal ? (l = y - f.left + 15, h = S()) : (l = A(), h = i.clientY - f.top - o.tooltipRect.ttHeight / 2 - 15) : s.globals.isBarHorizontal ? ((l = v) < o.xyRatios.baseLineInvertedY && (l = v - o.tooltipRect.ttWidth), h = S()) : (l = A(), h = m);
                }
                return {
                    x: l,
                    y: h,
                    barHeight: d,
                    barWidth: c,
                    i: n,
                    j: r
                };
            }
        }
    ]), t;
}(), xt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.ttCtx = e;
    }
    return r(t, [
        {
            key: "drawXaxisTooltip",
            value: function() {
                var t = this.w, e = this.ttCtx, i = "bottom" === t.config.xaxis.position;
                e.xaxisOffY = i ? t.globals.gridHeight + 1 : -t.globals.xAxisHeight - t.config.xaxis.axisTicks.height + 3;
                var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = t.globals.dom.elWrap;
                e.isXAxisTooltipEnabled && null === t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") && (e.xaxisTooltip = document.createElement("div"), e.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + t.config.tooltip.theme), s.appendChild(e.xaxisTooltip), e.xaxisTooltipText = document.createElement("div"), e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), e.xaxisTooltipText.style.fontFamily = t.config.xaxis.tooltip.style.fontFamily || t.config.chart.fontFamily, e.xaxisTooltipText.style.fontSize = t.config.xaxis.tooltip.style.fontSize, e.xaxisTooltip.appendChild(e.xaxisTooltipText));
            }
        },
        {
            key: "drawYaxisTooltip",
            value: function() {
                for(var t = this.w, e = this.ttCtx, i = function(i) {
                    var a = t.config.yaxis[i].opposite || t.config.yaxis[i].crosshairs.opposite;
                    e.yaxisOffX = a ? t.globals.gridWidth + 1 : 1;
                    var s = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i, a ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left");
                    t.globals.yAxisSameScaleIndices.map(function(e, a) {
                        e.map(function(e, a) {
                            a === i && (s += t.config.yaxis[a].show ? " " : " apexcharts-yaxistooltip-hidden");
                        });
                    });
                    var r = t.globals.dom.elWrap;
                    null === t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i)) && (e.yaxisTooltip = document.createElement("div"), e.yaxisTooltip.setAttribute("class", s + " apexcharts-theme-" + t.config.tooltip.theme), r.appendChild(e.yaxisTooltip), 0 === i && (e.yaxisTooltipText = []), e.yaxisTooltipText[i] = document.createElement("div"), e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"), e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]));
                }, a = 0; a < t.config.yaxis.length; a++)i(a);
            }
        },
        {
            key: "setXCrosshairWidth",
            value: function() {
                var t = this.w, e = this.ttCtx, i = e.getElXCrosshairs();
                if (e.xcrosshairsWidth = parseInt(t.config.xaxis.crosshairs.width, 10), t.globals.comboCharts) {
                    var a = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== a && "barWidth" === t.config.xaxis.crosshairs.width) {
                        var s = parseFloat(a.getAttribute("barWidth"));
                        e.xcrosshairsWidth = s;
                    } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                        var r = t.globals.labels.length;
                        e.xcrosshairsWidth = t.globals.gridWidth / r;
                    }
                } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                    var o = t.globals.labels.length;
                    e.xcrosshairsWidth = t.globals.gridWidth / o;
                } else if ("barWidth" === t.config.xaxis.crosshairs.width) {
                    var n = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== n) {
                        var l = parseFloat(n.getAttribute("barWidth"));
                        e.xcrosshairsWidth = l;
                    } else e.xcrosshairsWidth = 1;
                }
                t.globals.isBarHorizontal && (e.xcrosshairsWidth = 0), null !== i && e.xcrosshairsWidth > 0 && i.setAttribute("width", e.xcrosshairsWidth);
            }
        },
        {
            key: "handleYCrosshair",
            value: function() {
                var t = this.w, e = this.ttCtx;
                e.ycrosshairs = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), e.ycrosshairsHidden = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
            }
        },
        {
            key: "drawYaxisTooltipText",
            value: function(t, e, i) {
                var a = this.ttCtx, s = this.w, r = s.globals.yLabelFormatters[t];
                if (a.yaxisTooltips[t]) {
                    var o = a.getElGrid().getBoundingClientRect(), n = (e - o.top) * i.yRatio[t], l = s.globals.maxYArr[t] - s.globals.minYArr[t], h = s.globals.minYArr[t] + (l - n);
                    a.tooltipPosition.moveYCrosshairs(e - o.top), a.yaxisTooltipText[t].innerHTML = r(h), a.tooltipPosition.moveYAxisTooltip(t);
                }
            }
        }
    ]), t;
}(), bt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.tConfig = i.config.tooltip, this.tooltipUtil = new dt(this), this.tooltipLabels = new gt(this), this.tooltipPosition = new ut(this), this.marker = new pt(this), this.intersect = new ft(this), this.axesTooltip = new xt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !i.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
    }
    return r(t, [
        {
            key: "getElTooltip",
            value: function(t) {
                return t || (t = this), t.w.globals.dom.baseEl ? t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
            }
        },
        {
            key: "getElXCrosshairs",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
            }
        },
        {
            key: "getElGrid",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
            }
        },
        {
            key: "drawTooltip",
            value: function(t) {
                var e = this.w;
                this.xyRatios = t, this.isXAxisTooltipEnabled = e.config.xaxis.tooltip.enabled && e.globals.axisCharts, this.yaxisTooltips = e.config.yaxis.map(function(t, i) {
                    return !!(t.show && t.tooltip.enabled && e.globals.axisCharts);
                }), this.allTooltipSeriesGroups = [], e.globals.axisCharts || (this.showTooltipTitle = !1);
                var i = document.createElement("div");
                if (i.classList.add("apexcharts-tooltip"), e.config.tooltip.cssClass && i.classList.add(e.config.tooltip.cssClass), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), e.globals.dom.elWrap.appendChild(i), e.globals.axisCharts) {
                    this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                    var a = new V(this.ctx);
                    this.xAxisTicksPositions = a.getXAxisTicksPositions();
                }
                if (!e.globals.comboCharts && !this.tConfig.intersect && "rangeBar" !== e.config.chart.type || this.tConfig.shared || (this.showOnIntersect = !0), 0 !== e.config.markers.size && 0 !== e.globals.markers.largestSize || this.marker.drawDynamicPoints(this), e.globals.collapsedSeries.length !== e.globals.series.length) {
                    this.dataPointsDividedHeight = e.globals.gridHeight / e.globals.dataPoints, this.dataPointsDividedWidth = e.globals.gridWidth / e.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                    var s = e.globals.series.length;
                    (e.globals.xyCharts || e.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : e.globals.series.length), this.legendLabels = e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                }
            }
        },
        {
            key: "createTTElements",
            value: function(t) {
                for(var e = this, i = this.w, a = [], s = this.getElTooltip(), r = function(r) {
                    var o = document.createElement("div");
                    o.classList.add("apexcharts-tooltip-series-group"), o.style.order = i.config.tooltip.inverseOrder ? t - r : r + 1, e.tConfig.shared && e.tConfig.enabledOnSeries && Array.isArray(e.tConfig.enabledOnSeries) && e.tConfig.enabledOnSeries.indexOf(r) < 0 && o.classList.add("apexcharts-tooltip-series-group-hidden");
                    var n = document.createElement("span");
                    n.classList.add("apexcharts-tooltip-marker"), n.style.backgroundColor = i.globals.colors[r], o.appendChild(n);
                    var l = document.createElement("div");
                    l.classList.add("apexcharts-tooltip-text"), l.style.fontFamily = e.tConfig.style.fontFamily || i.config.chart.fontFamily, l.style.fontSize = e.tConfig.style.fontSize, [
                        "y",
                        "goals",
                        "z"
                    ].forEach(function(t) {
                        var e = document.createElement("div");
                        e.classList.add("apexcharts-tooltip-".concat(t, "-group"));
                        var i = document.createElement("span");
                        i.classList.add("apexcharts-tooltip-text-".concat(t, "-label")), e.appendChild(i);
                        var a = document.createElement("span");
                        a.classList.add("apexcharts-tooltip-text-".concat(t, "-value")), e.appendChild(a), l.appendChild(e);
                    }), o.appendChild(l), s.appendChild(o), a.push(o);
                }, o = 0; o < t; o++)r(o);
                return a;
            }
        },
        {
            key: "addSVGEvents",
            value: function() {
                var t = this.w, e = t.config.chart.type, i = this.getElTooltip(), a = !("bar" !== e && "candlestick" !== e && "boxPlot" !== e && "rangeBar" !== e), s = "area" === e || "line" === e || "scatter" === e || "bubble" === e || "radar" === e, r = t.globals.dom.Paper.node, o = this.getElGrid();
                o && (this.seriesBound = o.getBoundingClientRect());
                var n, l = [], h = [], c = {
                    hoverArea: r,
                    elGrid: o,
                    tooltipEl: i,
                    tooltipY: l,
                    tooltipX: h,
                    ttItems: this.ttItems
                };
                if (t.globals.axisCharts && (s ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : "heatmap" !== e && "treemap" !== e || (n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), n && n.length)) for(var d = 0; d < n.length; d++)l.push(n[d].getAttribute("cy")), h.push(n[d].getAttribute("cx"));
                if (t.globals.xyCharts && !this.showOnIntersect || t.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                    r
                ], c);
                else if (a && !t.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(c);
                else if (!t.globals.axisCharts || "heatmap" === e || "treemap" === e) {
                    var g = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    this.addPathsEventListeners(g, c);
                }
                if (this.showOnIntersect) {
                    var u = t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                    u.length > 0 && this.addPathsEventListeners(u, c), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(c);
                }
            }
        },
        {
            key: "drawFixedTooltipRect",
            value: function() {
                var t = this.w, e = this.getElTooltip(), i = e.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, o = this.tConfig.fixed.offsetY, n = this.tConfig.fixed.position.toLowerCase();
                return n.indexOf("right") > -1 && (r = r + t.globals.svgWidth - a + 10), n.indexOf("bottom") > -1 && (o = o + t.globals.svgHeight - s - 10), e.style.left = r + "px", e.style.top = o + "px", {
                    x: r,
                    y: o,
                    ttWidth: a,
                    ttHeight: s
                };
            }
        },
        {
            key: "addDatapointEventsListeners",
            value: function(t) {
                var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                this.addPathsEventListeners(e, t);
            }
        },
        {
            key: "addPathsEventListeners",
            value: function(t, e) {
                for(var i = this, a = function(a) {
                    var s = {
                        paths: t[a],
                        tooltipEl: e.tooltipEl,
                        tooltipY: e.tooltipY,
                        tooltipX: e.tooltipX,
                        elGrid: e.elGrid,
                        hoverArea: e.hoverArea,
                        ttItems: e.ttItems
                    };
                    [
                        "mousemove",
                        "mouseup",
                        "touchmove",
                        "mouseout",
                        "touchend"
                    ].map(function(e) {
                        return t[a].addEventListener(e, i.onSeriesHover.bind(i, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }, s = 0; s < t.length; s++)a(s);
            }
        },
        {
            key: "onSeriesHover",
            value: function(t, e) {
                var i = this, a = Date.now() - this.lastHoverTime;
                a >= 100 ? this.seriesHover(t, e) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                    i.seriesHover(t, e);
                }, 100 - a));
            }
        },
        {
            key: "seriesHover",
            value: function(t, e) {
                var i = this;
                this.lastHoverTime = Date.now();
                var a = [], s = this.w;
                s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || 0 === s.globals.dataPoints) || (a.length ? a.forEach(function(a) {
                    var s = i.getElTooltip(a), r = {
                        paths: t.paths,
                        tooltipEl: s,
                        tooltipY: t.tooltipY,
                        tooltipX: t.tooltipX,
                        elGrid: t.elGrid,
                        hoverArea: t.hoverArea,
                        ttItems: a.w.globals.tooltip.ttItems
                    };
                    a.w.globals.minX === i.w.globals.minX && a.w.globals.maxX === i.w.globals.maxX && a.w.globals.tooltip.seriesHoverByContext({
                        chartCtx: a,
                        ttCtx: a.w.globals.tooltip,
                        opt: r,
                        e: e
                    });
                }) : this.seriesHoverByContext({
                    chartCtx: this.ctx,
                    ttCtx: this.w.globals.tooltip,
                    opt: t,
                    e: e
                }));
            }
        },
        {
            key: "seriesHoverByContext",
            value: function(t) {
                var e = t.chartCtx, i = t.ttCtx, a = t.opt, s = t.e, r = e.w, o = this.getElTooltip();
                if (o) {
                    if (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: o.getBoundingClientRect().width,
                        ttHeight: o.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared) {
                        if (this.tConfig.onDatasetHover.highlightDataSeries) new N(e).toggleSeriesOnHover(s, s.target.parentNode);
                    }
                    i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    });
                }
            }
        },
        {
            key: "axisChartsTooltips",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = s.elGrid.getBoundingClientRect(), n = "touchmove" === a.type ? a.touches[0].clientX : a.clientX, l = "touchmove" === a.type ? a.touches[0].clientY : a.clientY;
                if (this.clientY = l, this.clientX = n, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, l < o.top || l > o.top + o.height) this.handleMouseOut(s);
                else {
                    if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                        var h = parseInt(s.paths.getAttribute("index"), 10);
                        if (this.tConfig.enabledOnSeries.indexOf(h) < 0) return void this.handleMouseOut(s);
                    }
                    var c = this.getElTooltip(), d = this.getElXCrosshairs(), g = r.globals.xyCharts || "bar" === r.config.chart.type && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                    if ("mousemove" === a.type || "touchmove" === a.type || "mouseup" === a.type) {
                        if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                        null !== d && d.classList.add("apexcharts-active");
                        var u = this.yaxisTooltips.filter(function(t) {
                            return !0 === t;
                        });
                        if (null !== this.ycrosshairs && u.length && this.ycrosshairs.classList.add("apexcharts-active"), g && !this.showOnIntersect) this.handleStickyTooltip(a, n, l, s);
                        else if ("heatmap" === r.config.chart.type || "treemap" === r.config.chart.type) {
                            var p = this.intersect.handleHeatTreeTooltip({
                                e: a,
                                opt: s,
                                x: e,
                                y: i,
                                type: r.config.chart.type
                            });
                            e = p.x, i = p.y, c.style.left = e + "px", c.style.top = i + "px";
                        } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                            e: a,
                            opt: s
                        }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                            e: a,
                            opt: s,
                            x: e,
                            y: i
                        });
                        if (this.yaxisTooltips.length) for(var f = 0; f < r.config.yaxis.length; f++)this.axesTooltip.drawYaxisTooltipText(f, l, this.xyRatios);
                        s.tooltipEl.classList.add("apexcharts-active");
                    } else "mouseout" !== a.type && "touchend" !== a.type || this.handleMouseOut(s);
                }
            }
        },
        {
            key: "nonAxisChartsTooltips",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), o = this.getElTooltip(), n = s.globals.dom.elWrap.getBoundingClientRect();
                if ("mousemove" === e.type || "touchmove" === e.type) {
                    o.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: parseInt(r, 10) - 1,
                        shared: !1
                    });
                    var l = s.globals.clientX - n.left - a.ttWidth / 2, h = s.globals.clientY - n.top - a.ttHeight - 10;
                    if (o.style.left = l + "px", o.style.top = h + "px", s.config.legend.tooltipHoverFormatter) {
                        var c = r - 1, d = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"), {
                            seriesIndex: c,
                            dataPointIndex: c,
                            w: s
                        });
                        this.legendLabels[c].innerHTML = d;
                    }
                } else "mouseout" !== e.type && "touchend" !== e.type || (o.classList.remove("apexcharts-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                }));
            }
        },
        {
            key: "handleStickyTooltip",
            value: function(t, e, i, a) {
                var s = this.w, r = this.tooltipUtil.getNearestValues({
                    context: this,
                    hoverArea: a.hoverArea,
                    elGrid: a.elGrid,
                    clientX: e,
                    clientY: i
                }), o = r.j, n = r.capturedSeries;
                s.globals.collapsedSeriesIndices.includes(n) && (n = null);
                var l = a.elGrid.getBoundingClientRect();
                if (r.hoverX < 0 || r.hoverX > l.width) this.handleMouseOut(a);
                else if (null !== n) this.handleStickyCapturedSeries(t, n, a, o);
                else if (this.tooltipUtil.isXoverlap(o) || s.globals.isBarHorizontal) {
                    var h = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, h, o, a.ttItems);
                }
            }
        },
        {
            key: "handleStickyCapturedSeries",
            value: function(t, e, i, a) {
                var s = this.w;
                if (!this.tConfig.shared && null === s.globals.series[e][a]) return void this.handleMouseOut(i);
                if (void 0 !== s.globals.series[e][a]) this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(t, this, e, a, i.ttItems) : this.create(t, this, e, a, i.ttItems, !1);
                else if (this.tooltipUtil.isXoverlap(a)) {
                    var r = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, r, a, i.ttItems);
                }
            }
        },
        {
            key: "deactivateHoverFilter",
            value: function() {
                for(var t = this.w, e = new m(this.ctx), i = t.globals.dom.Paper.select(".apexcharts-bar-area"), a = 0; a < i.length; a++)e.pathMouseLeave(i[a]);
            }
        },
        {
            key: "handleMouseOut",
            value: function(t) {
                var e = this.w, i = this.getElXCrosshairs();
                if (t.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), "bubble" !== e.config.chart.type && this.marker.resetPointsSize(), null !== i && i.classList.remove("apexcharts-active"), null !== this.ycrosshairs && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                    null === this.yaxisTTEls && (this.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                }
                e.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                });
            }
        },
        {
            key: "markerClick",
            value: function(t, e, i) {
                var a = this.w;
                "function" == typeof a.config.chart.events.markerClick && a.config.chart.events.markerClick(t, this.ctx, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }), this.ctx.events.fireEvent("markerClick", [
                    t,
                    this.ctx,
                    {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: a
                    }
                ]);
            }
        },
        {
            key: "create",
            value: function(t, i, a, s, r) {
                var o, n, l, h, c, d, g, u, p, f, x, b, v, y, w, k, A = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, S = this.w, C = i;
                "mouseup" === t.type && this.markerClick(t, a, s), null === A && (A = this.tConfig.shared);
                var L = this.tooltipUtil.hasMarkers(a), P = this.tooltipUtil.getElBars();
                if (S.config.legend.tooltipHoverFormatter) {
                    var I = S.config.legend.tooltipHoverFormatter, T = Array.from(this.legendLabels);
                    T.forEach(function(t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e);
                    });
                    for(var M = 0; M < T.length; M++){
                        var z = T[M], X = parseInt(z.getAttribute("i"), 10), E = decodeURIComponent(z.getAttribute("data:default-text")), Y = I(E, {
                            seriesIndex: A ? X : a,
                            dataPointIndex: s,
                            w: S
                        });
                        if (A) z.innerHTML = S.globals.collapsedSeriesIndices.indexOf(X) < 0 ? Y : E;
                        else if (z.innerHTML = X === a ? Y : E, a === X) break;
                    }
                }
                var F = e(e({
                    ttItems: r,
                    i: a,
                    j: s
                }, void 0 !== (null === (o = S.globals.seriesRange) || void 0 === o || null === (n = o[a]) || void 0 === n || null === (l = n[s]) || void 0 === l || null === (h = l.y[0]) || void 0 === h ? void 0 : h.y1) && {
                    y1: null === (c = S.globals.seriesRange) || void 0 === c || null === (d = c[a]) || void 0 === d || null === (g = d[s]) || void 0 === g || null === (u = g.y[0]) || void 0 === u ? void 0 : u.y1
                }), void 0 !== (null === (p = S.globals.seriesRange) || void 0 === p || null === (f = p[a]) || void 0 === f || null === (x = f[s]) || void 0 === x || null === (b = x.y[0]) || void 0 === b ? void 0 : b.y2) && {
                    y2: null === (v = S.globals.seriesRange) || void 0 === v || null === (y = v[a]) || void 0 === y || null === (w = y[s]) || void 0 === w || null === (k = w.y[0]) || void 0 === k ? void 0 : k.y2
                });
                if (A) {
                    if (C.tooltipLabels.drawSeriesTexts(e(e({}, F), {}, {
                        shared: !this.showOnIntersect && this.tConfig.shared
                    })), L) S.globals.markers.largestSize > 0 ? C.marker.enlargePoints(s) : C.tooltipPosition.moveDynamicPointsOnHover(s);
                    else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(P), this.barSeriesHeight > 0)) {
                        var R = new m(this.ctx), H = S.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(s, "']"));
                        this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(s, a);
                        for(var D = 0; D < H.length; D++)R.pathMouseEnter(H[D]);
                    }
                } else C.tooltipLabels.drawSeriesTexts(e({
                    shared: !1
                }, F)), this.tooltipUtil.hasBars() && C.tooltipPosition.moveStickyTooltipOverBars(s, a), L && C.tooltipPosition.moveMarkers(a, s);
            }
        }
    ]), t;
}(), vt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
    }
    return r(t, [
        {
            key: "handleBarDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.y1, s = t.y2, r = t.i, o = t.j, n = t.realIndex, l = t.groupIndex, h = t.series, c = t.barHeight, d = t.barWidth, g = t.barXPosition, u = t.barYPosition, p = t.visibleSeries, f = t.renderedPath, x = this.w, b = new m(this.barCtx.ctx), v = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[n] : this.barCtx.strokeWidth, y = e + parseFloat(d * p), w = i + parseFloat(c * p);
                x.globals.isXNumeric && !x.globals.isBarHorizontal && (y = e + parseFloat(d * (p + 1)), w = i + parseFloat(c * (p + 1)) - v);
                var k, A = null, S = e, C = i, L = {}, P = x.config.dataLabels, I = this.barCtx.barOptions.dataLabels, T = this.barCtx.barOptions.dataLabels.total;
                void 0 !== u && this.barCtx.isRangeBar && (w = u, C = u), void 0 !== g && this.barCtx.isVerticalGroupedRangeBar && (y = g, S = g);
                var M = P.offsetX, z = P.offsetY, X = {
                    width: 0,
                    height: 0
                };
                if (x.config.dataLabels.enabled) {
                    var E = this.barCtx.series[r][o];
                    X = b.getTextRects(x.globals.yLabelFormatters[0](E), parseFloat(P.style.fontSize));
                }
                var Y = {
                    x: e,
                    y: i,
                    i: r,
                    j: o,
                    realIndex: n,
                    groupIndex: l || -1,
                    renderedPath: f,
                    bcx: y,
                    bcy: w,
                    barHeight: c,
                    barWidth: d,
                    textRects: X,
                    strokeWidth: v,
                    dataLabelsX: S,
                    dataLabelsY: C,
                    dataLabelsConfig: P,
                    barDataLabelsConfig: I,
                    barTotalDataLabelsConfig: T,
                    offX: M,
                    offY: z
                };
                return L = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(Y) : this.calculateColumnsDataLabelsPosition(Y), f.attr({
                    cy: L.bcy,
                    cx: L.bcx,
                    j: o,
                    val: h[r][o],
                    barHeight: c,
                    barWidth: d
                }), k = this.drawCalculatedDataLabels({
                    x: L.dataLabelsX,
                    y: L.dataLabelsY,
                    val: this.barCtx.isRangeBar ? [
                        a,
                        s
                    ] : h[r][o],
                    i: n,
                    j: o,
                    barWidth: d,
                    barHeight: c,
                    textRects: X,
                    dataLabelsConfig: P
                }), x.config.chart.stacked && T.enabled && (A = this.drawTotalDataLabels({
                    x: L.totalDataLabelsX,
                    y: L.totalDataLabelsY,
                    barWidth: d,
                    barHeight: c,
                    realIndex: n,
                    textAnchor: L.totalDataLabelsAnchor,
                    val: this.getStackedTotalDataLabel({
                        realIndex: n,
                        j: o
                    }),
                    dataLabelsConfig: P,
                    barTotalDataLabelsConfig: T
                })), {
                    dataLabels: k,
                    totalDataLabels: A
                };
            }
        },
        {
            key: "getStackedTotalDataLabel",
            value: function(t) {
                var i = t.realIndex, a = t.j, s = this.w, r = this.barCtx.stackedSeriesTotals[a];
                return this.totalFormatter && (r = this.totalFormatter(r, e(e({}, s), {}, {
                    seriesIndex: i,
                    dataPointIndex: a,
                    w: s
                }))), r;
            }
        },
        {
            key: "calculateColumnsDataLabelsPosition",
            value: function(t) {
                var e, i, a = this.w, s = t.i, r = t.j, o = t.realIndex, n = t.groupIndex, l = t.y, h = t.bcx, c = t.barWidth, d = t.barHeight, g = t.textRects, u = t.dataLabelsX, p = t.dataLabelsY, f = t.dataLabelsConfig, x = t.barDataLabelsConfig, b = t.barTotalDataLabelsConfig, v = t.strokeWidth, y = t.offX, w = t.offY;
                d = Math.abs(d);
                var k = "vertical" === a.config.plotOptions.bar.dataLabels.orientation, A = this.barCtx.barHelpers.getZeroValueEncounters({
                    i: s,
                    j: r
                }).zeroEncounters;
                h = h - v / 2 + (-1 !== n ? n * c : 0);
                var S = a.globals.gridWidth / a.globals.dataPoints;
                if (this.barCtx.isVerticalGroupedRangeBar ? u += c / 2 : (u = a.globals.isXNumeric ? h - c / 2 + y : h - S + c / 2 + y, A > 0 && a.config.plotOptions.bar.hideZeroBarsWhenGrouped && (u -= c * A)), k) u = u + g.height / 2 - v / 2 - 2;
                var C = this.barCtx.series[s][r] < 0, L = l;
                switch(this.barCtx.isReversed && (L = l - d + (C ? 2 * d : 0), l -= d), x.position){
                    case "center":
                        p = k ? C ? L - d / 2 + w : L + d / 2 - w : C ? L - d / 2 + g.height / 2 + w : L + d / 2 + g.height / 2 - w;
                        break;
                    case "bottom":
                        p = k ? C ? L - d + w : L + d - w : C ? L - d + g.height + v + w : L + d - g.height / 2 + v - w;
                        break;
                    case "top":
                        p = k ? C ? L + w : L - w : C ? L - g.height / 2 - w : L + g.height + w;
                }
                if (this.barCtx.lastActiveBarSerieIndex === o && b.enabled) {
                    var P = new m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: o,
                        j: r
                    }), f.fontSize);
                    e = C ? L - P.height / 2 - w - b.offsetY + 18 : L + P.height + w + b.offsetY - 18, i = u + b.offsetX;
                }
                return a.config.chart.stacked || (p < 0 ? p = 0 + v : p + g.height / 3 > a.globals.gridHeight && (p = a.globals.gridHeight - v)), {
                    bcx: h,
                    bcy: l,
                    dataLabelsX: u,
                    dataLabelsY: p,
                    totalDataLabelsX: i,
                    totalDataLabelsY: e,
                    totalDataLabelsAnchor: "middle"
                };
            }
        },
        {
            key: "calculateBarsDataLabelsPosition",
            value: function(t) {
                var e = this.w, i = t.x, a = t.i, s = t.j, r = t.realIndex, o = t.groupIndex, n = t.bcy, l = t.barHeight, h = t.barWidth, c = t.textRects, d = t.dataLabelsX, g = t.strokeWidth, u = t.dataLabelsConfig, p = t.barDataLabelsConfig, f = t.barTotalDataLabelsConfig, x = t.offX, b = t.offY, v = e.globals.gridHeight / e.globals.dataPoints;
                h = Math.abs(h);
                var y, w, k = (n += -1 !== o ? o * l : 0) - (this.barCtx.isRangeBar ? 0 : v) + l / 2 + c.height / 2 + b - 3, A = "start", S = this.barCtx.series[a][s] < 0, C = i;
                switch(this.barCtx.isReversed && (C = i + h - (S ? 2 * h : 0), i = e.globals.gridWidth - h), p.position){
                    case "center":
                        d = S ? C + h / 2 - x : Math.max(c.width / 2, C - h / 2) + x;
                        break;
                    case "bottom":
                        d = S ? C + h - g - Math.round(c.width / 2) - x : C - h + g + Math.round(c.width / 2) + x;
                        break;
                    case "top":
                        d = S ? C - g + Math.round(c.width / 2) - x : C - g - Math.round(c.width / 2) + x;
                }
                if (this.barCtx.lastActiveBarSerieIndex === r && f.enabled) {
                    var L = new m(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: r,
                        j: s
                    }), u.fontSize);
                    S ? (y = C - g + Math.round(L.width / 2) - x - f.offsetX - 15, A = "end") : y = C - g - Math.round(L.width / 2) + x + f.offsetX + 15, w = k + f.offsetY;
                }
                return e.config.chart.stacked || (d < 0 ? d = d + c.width + g : d + c.width / 2 > e.globals.gridWidth && (d = e.globals.gridWidth - c.width - g)), {
                    bcx: i,
                    bcy: n,
                    dataLabelsX: d,
                    dataLabelsY: k,
                    totalDataLabelsX: y,
                    totalDataLabelsY: w,
                    totalDataLabelsAnchor: A
                };
            }
        },
        {
            key: "drawCalculatedDataLabels",
            value: function(t) {
                var i = t.x, a = t.y, s = t.val, r = t.i, o = t.j, n = t.textRects, l = t.barHeight, h = t.barWidth, c = t.dataLabelsConfig, d = this.w, g = "rotate(0)";
                "vertical" === d.config.plotOptions.bar.dataLabels.orientation && (g = "rotate(-90, ".concat(i, ", ").concat(a, ")"));
                var u = new O(this.barCtx.ctx), p = new m(this.barCtx.ctx), f = c.formatter, x = null, b = d.globals.collapsedSeriesIndices.indexOf(r) > -1;
                if (c.enabled && !b) {
                    x = p.group({
                        class: "apexcharts-data-labels",
                        transform: g
                    });
                    var v = "";
                    void 0 !== s && (v = f(s, e(e({}, d), {}, {
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: d
                    }))), !s && d.config.plotOptions.bar.hideZeroBarsWhenGrouped && (v = "");
                    var y = d.globals.series[r][o] < 0, w = d.config.plotOptions.bar.dataLabels.position;
                    if ("vertical" === d.config.plotOptions.bar.dataLabels.orientation && ("top" === w && (c.textAnchor = y ? "end" : "start"), "center" === w && (c.textAnchor = "middle"), "bottom" === w && (c.textAnchor = y ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels) h < p.getTextRects(v, parseFloat(c.style.fontSize)).width && (v = "");
                    d.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? n.width / 1.6 > Math.abs(h) && (v = "") : n.height / 1.6 > Math.abs(l) && (v = ""));
                    var k = e({}, c);
                    this.barCtx.isHorizontal && s < 0 && ("start" === c.textAnchor ? k.textAnchor = "end" : "end" === c.textAnchor && (k.textAnchor = "start")), u.plotDataLabelsText({
                        x: i,
                        y: a,
                        text: v,
                        i: r,
                        j: o,
                        parent: x,
                        dataLabelsConfig: k,
                        alwaysDrawDataLabel: !0,
                        offsetCorrection: !0
                    });
                }
                return x;
            }
        },
        {
            key: "drawTotalDataLabels",
            value: function(t) {
                var e, i = t.x, a = t.y, s = t.val, r = t.barWidth, o = t.barHeight, n = t.realIndex, l = t.textAnchor, h = t.barTotalDataLabelsConfig, c = this.w, d = new m(this.barCtx.ctx);
                return h.enabled && void 0 !== i && void 0 !== a && this.barCtx.lastActiveBarSerieIndex === n && (e = d.drawText({
                    x: i - (!c.globals.isBarHorizontal && c.globals.seriesGroups.length ? r / c.globals.seriesGroups.length : 0),
                    y: a - (c.globals.isBarHorizontal && c.globals.seriesGroups.length ? o / c.globals.seriesGroups.length : 0),
                    foreColor: h.style.color,
                    text: s,
                    textAnchor: l,
                    fontFamily: h.style.fontFamily,
                    fontSize: h.style.fontSize,
                    fontWeight: h.style.fontWeight
                })), e;
            }
        }
    ]), t;
}(), mt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.barCtx = e;
    }
    return r(t, [
        {
            key: "initVariables",
            value: function(t) {
                var e = this.w;
                this.barCtx.series = t, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                for(var i = 0; i < t.length; i++)if (t[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += t[i].length), e.globals.isXNumeric) for(var a = 0; a < t[i].length; a++)e.globals.seriesX[i][a] > e.globals.minX && e.globals.seriesX[i][a] < e.globals.maxX && this.barCtx.visibleItems++;
                else this.barCtx.visibleItems = e.globals.dataPoints;
                0 === this.barCtx.seriesLen && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], e.globals.comboCharts || this.checkZeroSeries({
                    series: t
                });
            }
        },
        {
            key: "initialPositions",
            value: function() {
                var t, e, i, a, s, r, o, n, l = this.w, h = l.globals.dataPoints;
                this.barCtx.isRangeBar && (h = l.globals.labels.length);
                var c = this.barCtx.seriesLen;
                if (l.config.plotOptions.bar.rangeBarGroupRows && (c = 1), this.barCtx.isHorizontal) s = (i = l.globals.gridHeight / h) / c, l.globals.isXNumeric && (s = (i = l.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), s = s * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, -1 === String(this.barCtx.barOptions.barHeight).indexOf("%") && (s = parseInt(this.barCtx.barOptions.barHeight, 10)), n = this.barCtx.baseLineInvertedY + l.globals.padHorizontal + (this.barCtx.isReversed ? l.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (n = l.globals.gridWidth / 2), e = (i - s * this.barCtx.seriesLen) / 2;
                else {
                    if (a = l.globals.gridWidth / this.barCtx.visibleItems, l.config.xaxis.convertedCatToNumeric && (a = l.globals.gridWidth / l.globals.dataPoints), r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, l.globals.isXNumeric) {
                        var d = this.barCtx.xRatio;
                        l.config.xaxis.convertedCatToNumeric && (d = this.barCtx.initialXRatio), l.globals.minXDiff && .5 !== l.globals.minXDiff && l.globals.minXDiff / d > 0 && (a = l.globals.minXDiff / d), (r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1);
                    }
                    -1 === String(this.barCtx.barOptions.columnWidth).indexOf("%") && (r = parseInt(this.barCtx.barOptions.columnWidth, 10)), o = l.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.yaxisIndex] - (this.barCtx.isReversed ? l.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.yaxisIndex] : 0), t = l.globals.padHorizontal + (a - r * this.barCtx.seriesLen) / 2;
                }
                return l.globals.barHeight = s, l.globals.barWidth = r, {
                    x: t,
                    y: e,
                    yDivision: i,
                    xDivision: a,
                    barHeight: s,
                    barWidth: r,
                    zeroH: o,
                    zeroW: n
                };
            }
        },
        {
            key: "initializeStackedPrevVars",
            value: function(t) {
                var e = t.w;
                e.globals.hasSeriesGroups ? e.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].prevY = [], t[e].prevX = [], t[e].prevYF = [], t[e].prevXF = [], t[e].prevYVal = [], t[e].prevXVal = [];
                }) : (t.prevY = [], t.prevX = [], t.prevYF = [], t.prevXF = [], t.prevYVal = [], t.prevXVal = []);
            }
        },
        {
            key: "initializeStackedXYVars",
            value: function(t) {
                var e = t.w;
                e.globals.hasSeriesGroups ? e.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].xArrj = [], t[e].xArrjF = [], t[e].xArrjVal = [], t[e].yArrj = [], t[e].yArrjF = [], t[e].yArrjVal = [];
                }) : (t.xArrj = [], t.xArrjF = [], t.xArrjVal = [], t.yArrj = [], t.yArrjF = [], t.yArrjVal = []);
            }
        },
        {
            key: "getPathFillColor",
            value: function(t, e, i, a) {
                var s, r, o, n, l = this.w, h = new R(this.barCtx.ctx), c = null, d = this.barCtx.barOptions.distributed ? i : e;
                this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(a) {
                    t[e][i] >= a.from && t[e][i] <= a.to && (c = a.color);
                });
                return l.config.series[e].data[i] && l.config.series[e].data[i].fillColor && (c = l.config.series[e].data[i].fillColor), h.fillPath({
                    seriesNumber: this.barCtx.barOptions.distributed ? d : a,
                    dataPointIndex: i,
                    color: c,
                    value: t[e][i],
                    fillConfig: null === (s = l.config.series[e].data[i]) || void 0 === s ? void 0 : s.fill,
                    fillType: null !== (r = l.config.series[e].data[i]) && void 0 !== r && null !== (o = r.fill) && void 0 !== o && o.type ? null === (n = l.config.series[e].data[i]) || void 0 === n ? void 0 : n.fill.type : Array.isArray(l.config.fill.type) ? l.config.fill.type[e] : l.config.fill.type
                });
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t, e, i) {
                var a = 0, s = this.w;
                return this.barCtx.series[t][e] ? this.barCtx.isNullValue = !1 : this.barCtx.isNullValue = !0, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
            }
        },
        {
            key: "shouldApplyRadius",
            value: function(t) {
                var e = this.w, i = !1;
                return e.config.plotOptions.bar.borderRadius > 0 && (e.config.chart.stacked && "last" === e.config.plotOptions.bar.borderRadiusWhenStacked ? this.barCtx.lastActiveBarSerieIndex === t && (i = !0) : i = !0), i;
            }
        },
        {
            key: "barBackground",
            value: function(t) {
                var e = t.j, i = t.i, a = t.x1, s = t.x2, r = t.y1, o = t.y2, n = t.elSeries, l = this.w, h = new m(this.barCtx.ctx), c = new N(this.barCtx.ctx).getActiveConfigSeriesIndex();
                if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && c === i) {
                    e >= this.barCtx.barOptions.colors.backgroundBarColors.length && (e %= this.barCtx.barOptions.colors.backgroundBarColors.length);
                    var d = this.barCtx.barOptions.colors.backgroundBarColors[e], g = h.drawRect(void 0 !== a ? a : 0, void 0 !== r ? r : 0, void 0 !== s ? s : l.globals.gridWidth, void 0 !== o ? o : l.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, d, this.barCtx.barOptions.colors.backgroundBarOpacity);
                    n.add(g), g.node.classList.add("apexcharts-backgroundBar");
                }
            }
        },
        {
            key: "getColumnPaths",
            value: function(t) {
                var e, i = t.barWidth, a = t.barXPosition, s = t.y1, r = t.y2, o = t.strokeWidth, n = t.seriesGroup, l = t.realIndex, h = t.i, c = t.j, d = t.w, g = new m(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[l] : o) || (o = 0);
                var u = i, p = a;
                null !== (e = d.config.series[l].data[c]) && void 0 !== e && e.columnWidthOffset && (p = a - d.config.series[l].data[c].columnWidthOffset / 2, u = i + d.config.series[l].data[c].columnWidthOffset);
                var f = p, x = p + u;
                s += .001, r += .001;
                var b = g.move(f, s), v = g.move(f, s), y = g.line(x - o, s);
                if (d.globals.previousPaths.length > 0 && (v = this.barCtx.getPreviousPath(l, c, !1)), b = b + g.line(f, r) + g.line(x - o, r) + g.line(x - o, s) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), v = v + g.line(f, s) + y + y + y + y + y + g.line(f, s) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), this.shouldApplyRadius(l) && (b = g.roundPathCorners(b, d.config.plotOptions.bar.borderRadius)), d.config.chart.stacked) {
                    var w = this.barCtx;
                    d.globals.hasSeriesGroups && n && (w = this.barCtx[n]), w.yArrj.push(r), w.yArrjF.push(Math.abs(s - r)), w.yArrjVal.push(this.barCtx.series[h][c]);
                }
                return {
                    pathTo: b,
                    pathFrom: v
                };
            }
        },
        {
            key: "getBarpaths",
            value: function(t) {
                var e, i = t.barYPosition, a = t.barHeight, s = t.x1, r = t.x2, o = t.strokeWidth, n = t.seriesGroup, l = t.realIndex, h = t.i, c = t.j, d = t.w, g = new m(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[l] : o) || (o = 0);
                var u = i, p = a;
                null !== (e = d.config.series[l].data[c]) && void 0 !== e && e.barHeightOffset && (u = i - d.config.series[l].data[c].barHeightOffset / 2, p = a + d.config.series[l].data[c].barHeightOffset);
                var f = u, x = u + p;
                s += .001, r += .001;
                var b = g.move(s, f), v = g.move(s, f);
                d.globals.previousPaths.length > 0 && (v = this.barCtx.getPreviousPath(l, c, !1));
                var y = g.line(s, x - o);
                if (b = b + g.line(r, f) + g.line(r, x - o) + y + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), v = v + g.line(s, f) + y + y + y + y + y + g.line(s, f) + ("around" === d.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z"), this.shouldApplyRadius(l) && (b = g.roundPathCorners(b, d.config.plotOptions.bar.borderRadius)), d.config.chart.stacked) {
                    var w = this.barCtx;
                    d.globals.hasSeriesGroups && n && (w = this.barCtx[n]), w.xArrj.push(r), w.xArrjF.push(Math.abs(s - r)), w.xArrjVal.push(this.barCtx.series[h][c]);
                }
                return {
                    pathTo: b,
                    pathFrom: v
                };
            }
        },
        {
            key: "checkZeroSeries",
            value: function(t) {
                for(var e = t.series, i = this.w, a = 0; a < e.length; a++){
                    for(var s = 0, r = 0; r < e[i.globals.maxValsInArrayIndex].length; r++)s += e[a][r];
                    0 === s && this.barCtx.zeroSerieses.push(a);
                }
            }
        },
        {
            key: "getXForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e + t / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? t / this.barCtx.invertedYRatio : 0)), i;
            }
        },
        {
            key: "getYForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e - t / this.barCtx.yRatio[this.barCtx.yaxisIndex] + 2 * (this.barCtx.isReversed ? t / this.barCtx.yRatio[this.barCtx.yaxisIndex] : 0)), i;
            }
        },
        {
            key: "getGoalValues",
            value: function(t, i, a, s, r) {
                var n = this, l = this.w, h = [], c = function(e, s) {
                    var r;
                    h.push((o(r = {}, t, "x" === t ? n.getXForValue(e, i, !1) : n.getYForValue(e, a, !1)), o(r, "attrs", s), r));
                };
                if (l.globals.seriesGoals[s] && l.globals.seriesGoals[s][r] && Array.isArray(l.globals.seriesGoals[s][r]) && l.globals.seriesGoals[s][r].forEach(function(t) {
                    c(t.value, t);
                }), this.barCtx.barOptions.isDumbbell && l.globals.seriesRange.length) {
                    var d = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : l.globals.colors, g = {
                        strokeHeight: "x" === t ? 0 : l.globals.markers.size[s],
                        strokeWidth: "x" === t ? l.globals.markers.size[s] : 0,
                        strokeDashArray: 0,
                        strokeLineCap: "round",
                        strokeColor: Array.isArray(d[s]) ? d[s][0] : d[s]
                    };
                    c(l.globals.seriesRangeStart[s][r], g), c(l.globals.seriesRangeEnd[s][r], e(e({}, g), {}, {
                        strokeColor: Array.isArray(d[s]) ? d[s][1] : d[s]
                    }));
                }
                return h;
            }
        },
        {
            key: "drawGoalLine",
            value: function(t) {
                var e = t.barXPosition, i = t.barYPosition, a = t.goalX, s = t.goalY, r = t.barWidth, o = t.barHeight, n = new m(this.barCtx.ctx), l = n.group({
                    className: "apexcharts-bar-goals-groups"
                });
                l.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({
                    el: l.node
                }), l.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
                var h = null;
                return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(t) {
                    var e = void 0 !== t.attrs.strokeHeight ? t.attrs.strokeHeight : o / 2, a = i + e + o / 2;
                    h = n.drawLine(t.x, a - 2 * e, t.x, a, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeWidth ? t.attrs.strokeWidth : 2, t.attrs.strokeLineCap), l.add(h);
                }) : Array.isArray(s) && s.forEach(function(t) {
                    var i = void 0 !== t.attrs.strokeWidth ? t.attrs.strokeWidth : r / 2, a = e + i + r / 2;
                    h = n.drawLine(a - 2 * i, t.y, a, t.y, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeHeight ? t.attrs.strokeHeight : 2, t.attrs.strokeLineCap), l.add(h);
                }), l;
            }
        },
        {
            key: "drawBarShadow",
            value: function(t) {
                var e = t.prevPaths, i = t.currPaths, a = t.color, s = this.w, r = e.x, o = e.x1, n = e.barYPosition, l = i.x, h = i.x1, c = i.barYPosition, d = n + i.barHeight, g = new m(this.barCtx.ctx), u = new x, p = g.move(o, d) + g.line(r, d) + g.line(l, c) + g.line(h, c) + g.line(o, d) + ("around" === s.config.plotOptions.bar.borderRadiusApplication ? " Z" : " z");
                return g.drawPath({
                    d: p,
                    fill: u.shadeColor(.5, x.rgb2hex(a)),
                    stroke: "none",
                    strokeWidth: 0,
                    fillOpacity: 1,
                    classes: "apexcharts-bar-shadows"
                });
            }
        },
        {
            key: "getZeroValueEncounters",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = 0, r = 0;
                return a.globals.seriesPercent.forEach(function(t, a) {
                    t[i] && s++, a < e && 0 === t[i] && r++;
                }), {
                    nonZeroColumns: s,
                    zeroEncounters: r
                };
            }
        }
    ]), t;
}(), yt = function() {
    function t(e, i) {
        a(this, t), this.ctx = e, this.w = e.w;
        var s = this.w;
        this.barOptions = s.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = s.config.stroke.width, this.isNullValue = !1, this.isRangeBar = s.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !s.globals.isBarHorizontal && s.globals.seriesRange.length && s.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = i, null !== this.xyRatios && (this.xRatio = i.xRatio, this.initialXRatio = i.initialXRatio, this.yRatio = i.yRatio, this.invertedXRatio = i.invertedXRatio, this.invertedYRatio = i.invertedYRatio, this.baseLineY = i.baseLineY, this.baseLineInvertedY = i.baseLineInvertedY), this.yaxisIndex = 0, this.seriesLen = 0, this.pathArr = [];
        var r = new N(this.ctx);
        this.lastActiveBarSerieIndex = r.getActiveConfigSeriesIndex("desc", [
            "bar",
            "column"
        ]);
        var o = r.getBarSeriesIndices(), n = new y(this.ctx);
        this.stackedSeriesTotals = n.getStackedSeriesTotals(this.w.config.series.map(function(t, e) {
            return -1 === o.indexOf(e) ? e : -1;
        }).filter(function(t) {
            return -1 !== t;
        })), this.barHelpers = new mt(this);
    }
    return r(t, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new m(this.ctx), r = new y(this.ctx, a);
                t = r.getLogSeries(t), this.series = t, this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                var o = s.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                });
                a.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");
                for(var n = 0, l = 0; n < t.length; n++, l++){
                    var h, c, d, g, u = void 0, p = void 0, f = [], b = [], v = a.globals.comboCharts ? i[n] : n, w = s.group({
                        class: "apexcharts-series",
                        rel: n + 1,
                        seriesName: x.escapeString(a.globals.seriesNames[v]),
                        "data:realIndex": v
                    });
                    this.ctx.series.addCollapsedClassToSeries(w, v), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var k = 0, A = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = v), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed;
                    var S = this.barHelpers.initialPositions();
                    p = S.y, k = S.barHeight, c = S.yDivision, g = S.zeroW, u = S.x, A = S.barWidth, h = S.xDivision, d = S.zeroH, this.horizontal || b.push(u + A / 2);
                    var C = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    });
                    a.globals.delayedElements.push({
                        el: C.node
                    }), C.node.classList.add("apexcharts-element-hidden");
                    var L = s.group({
                        class: "apexcharts-bar-goals-markers"
                    }), P = s.group({
                        class: "apexcharts-bar-shadows"
                    });
                    a.globals.delayedElements.push({
                        el: P.node
                    }), P.node.classList.add("apexcharts-element-hidden");
                    for(var I = 0; I < a.globals.dataPoints; I++){
                        var T = this.barHelpers.getStrokeWidth(n, I, v), M = null, z = {
                            indexes: {
                                i: n,
                                j: I,
                                realIndex: v,
                                bc: l
                            },
                            x: u,
                            y: p,
                            strokeWidth: T,
                            elSeries: w
                        };
                        this.isHorizontal ? (M = this.drawBarPaths(e(e({}, z), {}, {
                            barHeight: k,
                            zeroW: g,
                            yDivision: c
                        })), A = this.series[n][I] / this.invertedYRatio) : (M = this.drawColumnPaths(e(e({}, z), {}, {
                            xDivision: h,
                            barWidth: A,
                            zeroH: d
                        })), k = this.series[n][I] / this.yRatio[this.yaxisIndex]);
                        var X = this.barHelpers.getPathFillColor(t, n, I, v);
                        if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && I > 0) {
                            var E = this.barHelpers.drawBarShadow({
                                color: "string" == typeof X && -1 === (null == X ? void 0 : X.indexOf("url")) ? X : x.hexToRgba(a.globals.colors[n]),
                                prevPaths: this.pathArr[this.pathArr.length - 1],
                                currPaths: M
                            });
                            E && P.add(E);
                        }
                        this.pathArr.push(M);
                        var Y = this.barHelpers.drawGoalLine({
                            barXPosition: M.barXPosition,
                            barYPosition: M.barYPosition,
                            goalX: M.goalX,
                            goalY: M.goalY,
                            barHeight: k,
                            barWidth: A
                        });
                        Y && L.add(Y), p = M.y, u = M.x, I > 0 && b.push(u + A / 2), f.push(p), this.renderSeries({
                            realIndex: v,
                            pathFill: X,
                            j: I,
                            i: n,
                            pathFrom: M.pathFrom,
                            pathTo: M.pathTo,
                            strokeWidth: T,
                            elSeries: w,
                            x: u,
                            y: p,
                            series: t,
                            barHeight: M.barHeight ? M.barHeight : k,
                            barWidth: M.barWidth ? M.barWidth : A,
                            elDataLabelsWrap: C,
                            elGoalsMarkers: L,
                            elBarShadows: P,
                            visibleSeries: this.visibleI,
                            type: "bar"
                        });
                    }
                    a.globals.seriesXvalues[v] = b, a.globals.seriesYvalues[v] = f, o.add(w);
                }
                return o;
            }
        },
        {
            key: "renderSeries",
            value: function(t) {
                var e = t.realIndex, i = t.pathFill, a = t.lineFill, s = t.j, r = t.i, o = t.groupIndex, n = t.pathFrom, l = t.pathTo, h = t.strokeWidth, c = t.elSeries, d = t.x, g = t.y, u = t.y1, p = t.y2, f = t.series, x = t.barHeight, b = t.barWidth, y = t.barXPosition, w = t.barYPosition, k = t.elDataLabelsWrap, A = t.elGoalsMarkers, S = t.elBarShadows, C = t.visibleSeries, L = t.type, P = this.w, I = new m(this.ctx);
                a || (a = this.barOptions.distributed ? P.globals.stroke.colors[s] : P.globals.stroke.colors[e]), P.config.series[r].data[s] && P.config.series[r].data[s].strokeColor && (a = P.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                var T = s / P.config.chart.animations.animateGradually.delay * (P.config.chart.animations.speed / P.globals.dataPoints) / 2.4, M = I.renderPaths({
                    i: r,
                    j: s,
                    realIndex: e,
                    pathFrom: n,
                    pathTo: l,
                    stroke: a,
                    strokeWidth: h,
                    strokeLineCap: P.config.stroke.lineCap,
                    fill: i,
                    animationDelay: T,
                    initialSpeed: P.config.chart.animations.speed,
                    dataChangeSpeed: P.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(L, "-area")
                });
                M.attr("clip-path", "url(#gridRectMask".concat(P.globals.cuid, ")"));
                var z = P.config.forecastDataPoints;
                z.count > 0 && s >= P.globals.dataPoints - z.count && (M.node.setAttribute("stroke-dasharray", z.dashArray), M.node.setAttribute("stroke-width", z.strokeWidth), M.node.setAttribute("fill-opacity", z.fillOpacity)), void 0 !== u && void 0 !== p && (M.attr("data-range-y1", u), M.attr("data-range-y2", p)), new v(this.ctx).setSelectionFilter(M, e, s), c.add(M);
                var X = new vt(this).handleBarDataLabels({
                    x: d,
                    y: g,
                    y1: u,
                    y2: p,
                    i: r,
                    j: s,
                    series: f,
                    realIndex: e,
                    groupIndex: o,
                    barHeight: x,
                    barWidth: b,
                    barXPosition: y,
                    barYPosition: w,
                    renderedPath: M,
                    visibleSeries: C
                });
                return null !== X.dataLabels && k.add(X.dataLabels), X.totalDataLabels && k.add(X.totalDataLabels), c.add(k), A && c.add(A), S && c.add(S), c;
            }
        },
        {
            key: "drawBarPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.yDivision, h = t.elSeries, c = this.w, d = i.i, g = i.j;
                if (c.globals.isXNumeric) e = (n = (c.globals.seriesX[d][g] - c.globals.minX) / this.invertedXRatio - a) + a * this.visibleI;
                else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var u = 0, p = 0;
                    c.globals.seriesPercent.forEach(function(t, e) {
                        t[g] && u++, e < d && 0 === t[g] && p++;
                    }), u > 0 && (a = this.seriesLen * a / u), e = n + a * this.visibleI, e -= a * p;
                } else e = n + a * this.visibleI;
                this.isFunnel && (r -= (this.barHelpers.getXForValue(this.series[d][g], r) - r) / 2), o = this.barHelpers.getXForValue(this.series[d][g], r);
                var f = this.barHelpers.getBarpaths({
                    barYPosition: e,
                    barHeight: a,
                    x1: r,
                    x2: o,
                    strokeWidth: s,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return c.globals.isXNumeric || (n += l), this.barHelpers.barBackground({
                    j: g,
                    i: d,
                    y1: e - a * this.visibleI,
                    y2: a * this.seriesLen,
                    elSeries: h
                }), {
                    pathTo: f.pathTo,
                    pathFrom: f.pathFrom,
                    x1: r,
                    x: o,
                    y: n,
                    goalX: this.barHelpers.getGoalValues("x", r, null, d, g),
                    barYPosition: e,
                    barHeight: a
                };
            }
        },
        {
            key: "drawColumnPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.x, s = t.y, r = t.xDivision, o = t.barWidth, n = t.zeroH, l = t.strokeWidth, h = t.elSeries, c = this.w, d = i.realIndex, g = i.i, u = i.j, p = i.bc;
                if (c.globals.isXNumeric) {
                    var f = this.getBarXForNumericXAxis({
                        x: a,
                        j: u,
                        realIndex: d,
                        barWidth: o
                    });
                    a = f.x, e = f.barXPosition;
                } else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var x = this.barHelpers.getZeroValueEncounters({
                        i: g,
                        j: u
                    }), b = x.nonZeroColumns, v = x.zeroEncounters;
                    b > 0 && (o = this.seriesLen * o / b), e = a + o * this.visibleI, e -= o * v;
                } else e = a + o * this.visibleI;
                s = this.barHelpers.getYForValue(this.series[g][u], n);
                var m = this.barHelpers.getColumnPaths({
                    barXPosition: e,
                    barWidth: o,
                    y1: n,
                    y2: s,
                    strokeWidth: l,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: g,
                    j: u,
                    w: c
                });
                return c.globals.isXNumeric || (a += r), this.barHelpers.barBackground({
                    bc: p,
                    j: u,
                    i: g,
                    x1: e - l / 2 - o * this.visibleI,
                    x2: o * this.seriesLen + l / 2,
                    elSeries: h
                }), {
                    pathTo: m.pathTo,
                    pathFrom: m.pathFrom,
                    x: a,
                    y: s,
                    goalY: this.barHelpers.getGoalValues("y", null, n, g, u),
                    barXPosition: e,
                    barWidth: o
                };
            }
        },
        {
            key: "getBarXForNumericXAxis",
            value: function(t) {
                var e = t.x, i = t.barWidth, a = t.realIndex, s = t.j, r = this.w, o = a;
                return r.globals.seriesX[a].length || (o = r.globals.maxValsInArrayIndex), r.globals.seriesX[o][s] && (e = (r.globals.seriesX[o][s] - r.globals.minX) / this.xRatio - i * this.seriesLen / 2), {
                    barXPosition: e + i * this.visibleI,
                    x: e
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t, e) {
                for(var i, a = this.w, s = 0; s < a.globals.previousPaths.length; s++){
                    var r = a.globals.previousPaths[s];
                    r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(t, 10) && void 0 !== a.globals.previousPaths[s].paths[e] && (i = a.globals.previousPaths[s].paths[e].d);
                }
                return i;
            }
        }
    ]), t;
}(), wt = function(t) {
    n(s, yt);
    var i = d(s);
    function s() {
        return a(this, s), i.apply(this, arguments);
    }
    return r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this, s = this.w;
                this.graphics = new m(this.ctx), this.bar = new yt(this.ctx, this.xyRatios);
                var r = new y(this.ctx, s);
                t = r.getLogSeries(t), this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t), "100%" === s.config.chart.stackType && (t = s.globals.seriesPercent.slice()), this.series = t, this.barHelpers.initializeStackedPrevVars(this);
                for(var o = this.graphics.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                }), n = 0, l = 0, h = function(r, h) {
                    var c = void 0, d = void 0, g = void 0, u = void 0, p = -1;
                    a.groupCtx = a, s.globals.seriesGroups.forEach(function(t, e) {
                        t.indexOf(s.config.series[r].name) > -1 && (p = e);
                    }), -1 !== p && (a.groupCtx = a[s.globals.seriesGroups[p]]);
                    var f = [], b = [], v = s.globals.comboCharts ? i[r] : r;
                    a.yRatio.length > 1 && (a.yaxisIndex = v), a.isReversed = s.config.yaxis[a.yaxisIndex] && s.config.yaxis[a.yaxisIndex].reversed;
                    var m = a.graphics.group({
                        class: "apexcharts-series",
                        seriesName: x.escapeString(s.globals.seriesNames[v]),
                        rel: r + 1,
                        "data:realIndex": v
                    });
                    a.ctx.series.addCollapsedClassToSeries(m, v);
                    var y = a.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    }), w = a.graphics.group({
                        class: "apexcharts-bar-goals-markers"
                    }), k = 0, A = 0, S = a.initialPositions(n, l, c, d, g, u);
                    l = S.y, k = S.barHeight, d = S.yDivision, u = S.zeroW, n = S.x, A = S.barWidth, c = S.xDivision, g = S.zeroH, s.globals.barHeight = k, s.globals.barWidth = A, a.barHelpers.initializeStackedXYVars(a), 1 === a.groupCtx.prevY.length && a.groupCtx.prevY[0].every(function(t) {
                        return isNaN(t);
                    }) && (a.groupCtx.prevY[0] = a.groupCtx.prevY[0].map(function(t) {
                        return g;
                    }), a.groupCtx.prevYF[0] = a.groupCtx.prevYF[0].map(function(t) {
                        return 0;
                    }));
                    for(var C = 0; C < s.globals.dataPoints; C++){
                        var L = a.barHelpers.getStrokeWidth(r, C, v), P = {
                            indexes: {
                                i: r,
                                j: C,
                                realIndex: v,
                                bc: h
                            },
                            strokeWidth: L,
                            x: n,
                            y: l,
                            elSeries: m,
                            groupIndex: p,
                            seriesGroup: s.globals.seriesGroups[p]
                        }, I = null;
                        a.isHorizontal ? (I = a.drawStackedBarPaths(e(e({}, P), {}, {
                            zeroW: u,
                            barHeight: k,
                            yDivision: d
                        })), A = a.series[r][C] / a.invertedYRatio) : (I = a.drawStackedColumnPaths(e(e({}, P), {}, {
                            xDivision: c,
                            barWidth: A,
                            zeroH: g
                        })), k = a.series[r][C] / a.yRatio[a.yaxisIndex]);
                        var T = a.barHelpers.drawGoalLine({
                            barXPosition: I.barXPosition,
                            barYPosition: I.barYPosition,
                            goalX: I.goalX,
                            goalY: I.goalY,
                            barHeight: k,
                            barWidth: A
                        });
                        T && w.add(T), l = I.y, n = I.x, f.push(n), b.push(l);
                        var M = a.barHelpers.getPathFillColor(t, r, C, v);
                        m = a.renderSeries({
                            realIndex: v,
                            pathFill: M,
                            j: C,
                            i: r,
                            groupIndex: p,
                            pathFrom: I.pathFrom,
                            pathTo: I.pathTo,
                            strokeWidth: L,
                            elSeries: m,
                            x: n,
                            y: l,
                            series: t,
                            barHeight: k,
                            barWidth: A,
                            elDataLabelsWrap: y,
                            elGoalsMarkers: w,
                            type: "bar",
                            visibleSeries: 0
                        });
                    }
                    s.globals.seriesXvalues[v] = f, s.globals.seriesYvalues[v] = b, a.groupCtx.prevY.push(a.groupCtx.yArrj), a.groupCtx.prevYF.push(a.groupCtx.yArrjF), a.groupCtx.prevYVal.push(a.groupCtx.yArrjVal), a.groupCtx.prevX.push(a.groupCtx.xArrj), a.groupCtx.prevXF.push(a.groupCtx.xArrjF), a.groupCtx.prevXVal.push(a.groupCtx.xArrjVal), o.add(m);
                }, c = 0, d = 0; c < t.length; c++, d++)h(c, d);
                return o;
            }
        },
        {
            key: "initialPositions",
            value: function(t, e, i, a, s, r) {
                var o, n, l, h, c = this.w;
                return this.isHorizontal ? (l = (l = a = c.globals.gridHeight / c.globals.dataPoints) * parseInt(c.config.plotOptions.bar.barHeight, 10) / 100, -1 === String(c.config.plotOptions.bar.barHeight).indexOf("%") && (l = parseInt(c.config.plotOptions.bar.barHeight, 10)), r = this.baseLineInvertedY + c.globals.padHorizontal + (this.isReversed ? c.globals.gridWidth : 0) - (this.isReversed ? 2 * this.baseLineInvertedY : 0), e = (a - l) / 2) : (h = i = c.globals.gridWidth / c.globals.dataPoints, h = c.globals.isXNumeric && c.globals.dataPoints > 1 ? (i = c.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : h * parseInt(c.config.plotOptions.bar.columnWidth, 10) / 100, -1 === String(c.config.plotOptions.bar.columnWidth).indexOf("%") && (h = parseInt(c.config.plotOptions.bar.columnWidth, 10)), s = c.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? c.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), t = c.globals.padHorizontal + (i - h) / 2), {
                    x: t,
                    y: e,
                    yDivision: a,
                    xDivision: i,
                    barHeight: null !== (o = c.globals.seriesGroups) && void 0 !== o && o.length ? l / c.globals.seriesGroups.length : l,
                    barWidth: null !== (n = c.globals.seriesGroups) && void 0 !== n && n.length ? h / c.globals.seriesGroups.length : h,
                    zeroH: s,
                    zeroW: r
                };
            }
        },
        {
            key: "drawStackedBarPaths",
            value: function(t) {
                for(var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.groupIndex, h = t.seriesGroup, c = t.yDivision, d = t.elSeries, g = this.w, u = n + (-1 !== l ? l * a : 0), p = i.i, f = i.j, x = 0, b = 0; b < this.groupCtx.prevXF.length; b++)x += this.groupCtx.prevXF[b][f];
                var v = p;
                if (h && (v = h.indexOf(g.config.series[p].name)), v > 0) {
                    var m = r;
                    this.groupCtx.prevXVal[v - 1][f] < 0 ? m = this.series[p][f] >= 0 ? this.groupCtx.prevX[v - 1][f] + x - 2 * (this.isReversed ? x : 0) : this.groupCtx.prevX[v - 1][f] : this.groupCtx.prevXVal[v - 1][f] >= 0 && (m = this.series[p][f] >= 0 ? this.groupCtx.prevX[v - 1][f] : this.groupCtx.prevX[v - 1][f] - x + 2 * (this.isReversed ? x : 0)), e = m;
                } else e = r;
                o = null === this.series[p][f] ? e : e + this.series[p][f] / this.invertedYRatio - 2 * (this.isReversed ? this.series[p][f] / this.invertedYRatio : 0);
                var y = this.barHelpers.getBarpaths({
                    barYPosition: u,
                    barHeight: a,
                    x1: e,
                    x2: o,
                    strokeWidth: s,
                    series: this.series,
                    realIndex: i.realIndex,
                    seriesGroup: h,
                    i: p,
                    j: f,
                    w: g
                });
                return this.barHelpers.barBackground({
                    j: f,
                    i: p,
                    y1: u,
                    y2: a,
                    elSeries: d
                }), n += c, {
                    pathTo: y.pathTo,
                    pathFrom: y.pathFrom,
                    goalX: this.barHelpers.getGoalValues("x", r, null, p, f),
                    barYPosition: u,
                    x: o,
                    y: n
                };
            }
        },
        {
            key: "drawStackedColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.y, s = t.xDivision, r = t.barWidth, o = t.zeroH, n = t.groupIndex, l = t.seriesGroup, h = t.elSeries, c = this.w, d = e.i, g = e.j, u = e.bc;
                if (c.globals.isXNumeric) {
                    var p = c.globals.seriesX[d][g];
                    p || (p = 0), i = (p - c.globals.minX) / this.xRatio - r / 2, c.globals.seriesGroups.length && (i = (p - c.globals.minX) / this.xRatio - r / 2 * c.globals.seriesGroups.length);
                }
                for(var f, x = i + (-1 !== n ? n * r : 0), b = 0, v = 0; v < this.groupCtx.prevYF.length; v++)b += isNaN(this.groupCtx.prevYF[v][g]) ? 0 : this.groupCtx.prevYF[v][g];
                var m = d;
                if (l && (m = l.indexOf(c.config.series[d].name)), m > 0 && !c.globals.isXNumeric || m > 0 && c.globals.isXNumeric && c.globals.seriesX[d - 1][g] === c.globals.seriesX[d][g]) {
                    var y, w, k, A = Math.min(this.yRatio.length + 1, d + 1);
                    if (void 0 !== this.groupCtx.prevY[m - 1] && this.groupCtx.prevY[m - 1].length) for(var S = 1; S < A; S++){
                        var C;
                        if (!isNaN(null === (C = this.groupCtx.prevY[m - S]) || void 0 === C ? void 0 : C[g])) {
                            k = this.groupCtx.prevY[m - S][g];
                            break;
                        }
                    }
                    for(var L = 1; L < A; L++){
                        var P, I;
                        if ((null === (P = this.groupCtx.prevYVal[m - L]) || void 0 === P ? void 0 : P[g]) < 0) {
                            w = this.series[d][g] >= 0 ? k - b + 2 * (this.isReversed ? b : 0) : k;
                            break;
                        }
                        if ((null === (I = this.groupCtx.prevYVal[m - L]) || void 0 === I ? void 0 : I[g]) >= 0) {
                            w = this.series[d][g] >= 0 ? k : k + b - 2 * (this.isReversed ? b : 0);
                            break;
                        }
                    }
                    void 0 === w && (w = c.globals.gridHeight), f = null !== (y = this.groupCtx.prevYF[0]) && void 0 !== y && y.every(function(t) {
                        return 0 === t;
                    }) && this.groupCtx.prevYF.slice(1, m).every(function(t) {
                        return t.every(function(t) {
                            return isNaN(t);
                        });
                    }) ? o : w;
                } else f = o;
                a = this.series[d][g] ? f - this.series[d][g] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[d][g] / this.yRatio[this.yaxisIndex] : 0) : f;
                var T = this.barHelpers.getColumnPaths({
                    barXPosition: x,
                    barWidth: r,
                    y1: f,
                    y2: a,
                    yRatio: this.yRatio[this.yaxisIndex],
                    strokeWidth: this.strokeWidth,
                    series: this.series,
                    seriesGroup: l,
                    realIndex: e.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return this.barHelpers.barBackground({
                    bc: u,
                    j: g,
                    i: d,
                    x1: x,
                    x2: r,
                    elSeries: h
                }), i += s, {
                    pathTo: T.pathTo,
                    pathFrom: T.pathFrom,
                    goalY: this.barHelpers.getGoalValues("y", null, o, d, g),
                    barXPosition: x,
                    x: c.globals.isXNumeric ? i - s : i,
                    y: a
                };
            }
        }
    ]), s;
}(), kt = function(t) {
    n(s, yt);
    var i = d(s);
    function s() {
        return a(this, s), i.apply(this, arguments);
    }
    return r(s, [
        {
            key: "draw",
            value: function(t, i, a) {
                var s = this, r = this.w, o = new m(this.ctx), n = r.globals.comboCharts ? i : r.config.chart.type, l = new R(this.ctx);
                this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = r.config.plotOptions.bar.horizontal;
                var h = new y(this.ctx, r);
                t = h.getLogSeries(t), this.series = t, this.yRatio = h.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                for(var c = o.group({
                    class: "apexcharts-".concat(n, "-series apexcharts-plot-series")
                }), d = function(i) {
                    s.isBoxPlot = "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[i].type;
                    var n, h, d, g, u = void 0, p = void 0, f = [], b = [], v = r.globals.comboCharts ? a[i] : i, m = o.group({
                        class: "apexcharts-series",
                        seriesName: x.escapeString(r.globals.seriesNames[v]),
                        rel: i + 1,
                        "data:realIndex": v
                    });
                    s.ctx.series.addCollapsedClassToSeries(m, v), t[i].length > 0 && (s.visibleI = s.visibleI + 1);
                    var y, w;
                    s.yRatio.length > 1 && (s.yaxisIndex = v);
                    var k = s.barHelpers.initialPositions();
                    p = k.y, y = k.barHeight, h = k.yDivision, g = k.zeroW, u = k.x, w = k.barWidth, n = k.xDivision, d = k.zeroH, b.push(u + w / 2);
                    for(var A = o.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    }), S = function(a) {
                        var o = s.barHelpers.getStrokeWidth(i, a, v), c = null, x = {
                            indexes: {
                                i: i,
                                j: a,
                                realIndex: v
                            },
                            x: u,
                            y: p,
                            strokeWidth: o,
                            elSeries: m
                        };
                        c = s.isHorizontal ? s.drawHorizontalBoxPaths(e(e({}, x), {}, {
                            yDivision: h,
                            barHeight: y,
                            zeroW: g
                        })) : s.drawVerticalBoxPaths(e(e({}, x), {}, {
                            xDivision: n,
                            barWidth: w,
                            zeroH: d
                        })), p = c.y, u = c.x, a > 0 && b.push(u + w / 2), f.push(p), c.pathTo.forEach(function(e, n) {
                            var h = !s.isBoxPlot && s.candlestickOptions.wick.useFillColor ? c.color[n] : r.globals.stroke.colors[i], d = l.fillPath({
                                seriesNumber: v,
                                dataPointIndex: a,
                                color: c.color[n],
                                value: t[i][a]
                            });
                            s.renderSeries({
                                realIndex: v,
                                pathFill: d,
                                lineFill: h,
                                j: a,
                                i: i,
                                pathFrom: c.pathFrom,
                                pathTo: e,
                                strokeWidth: o,
                                elSeries: m,
                                x: u,
                                y: p,
                                series: t,
                                barHeight: y,
                                barWidth: w,
                                elDataLabelsWrap: A,
                                visibleSeries: s.visibleI,
                                type: r.config.chart.type
                            });
                        });
                    }, C = 0; C < r.globals.dataPoints; C++)S(C);
                    r.globals.seriesXvalues[v] = b, r.globals.seriesYvalues[v] = f, c.add(m);
                }, g = 0; g < t.length; g++)d(g);
                return c;
            }
        },
        {
            key: "drawVerticalBoxPaths",
            value: function(t) {
                var e = t.indexes, i = t.x;
                t.y;
                var a = t.xDivision, s = t.barWidth, r = t.zeroH, o = t.strokeWidth, n = this.w, l = new m(this.ctx), h = e.i, c = e.j, d = !0, g = n.config.plotOptions.candlestick.colors.upward, u = n.config.plotOptions.candlestick.colors.downward, p = "";
                this.isBoxPlot && (p = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var f = this.yRatio[this.yaxisIndex], x = e.realIndex, b = this.getOHLCValue(x, c), v = r, y = r;
                b.o > b.c && (d = !1);
                var w = Math.min(b.o, b.c), k = Math.max(b.o, b.c), A = b.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[x][c] - n.globals.minX) / this.xRatio - s / 2);
                var S = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (w = r, k = r) : (w = r - w / f, k = r - k / f, v = r - b.h / f, y = r - b.l / f, A = r - b.m / f);
                var C = l.move(S, r), L = l.move(S + s / 2, w);
                return n.globals.previousPaths.length > 0 && (L = this.getPreviousPath(x, c, !0)), C = this.isBoxPlot ? [
                    l.move(S, w) + l.line(S + s / 2, w) + l.line(S + s / 2, v) + l.line(S + s / 4, v) + l.line(S + s - s / 4, v) + l.line(S + s / 2, v) + l.line(S + s / 2, w) + l.line(S + s, w) + l.line(S + s, A) + l.line(S, A) + l.line(S, w + o / 2),
                    l.move(S, A) + l.line(S + s, A) + l.line(S + s, k) + l.line(S + s / 2, k) + l.line(S + s / 2, y) + l.line(S + s - s / 4, y) + l.line(S + s / 4, y) + l.line(S + s / 2, y) + l.line(S + s / 2, k) + l.line(S, k) + l.line(S, A) + "z"
                ] : [
                    l.move(S, k) + l.line(S + s / 2, k) + l.line(S + s / 2, v) + l.line(S + s / 2, k) + l.line(S + s, k) + l.line(S + s, w) + l.line(S + s / 2, w) + l.line(S + s / 2, y) + l.line(S + s / 2, w) + l.line(S, w) + l.line(S, k - o / 2)
                ], L += l.move(S, w), n.globals.isXNumeric || (i += a), {
                    pathTo: C,
                    pathFrom: L,
                    x: i,
                    y: k,
                    barXPosition: S,
                    color: this.isBoxPlot ? p : d ? [
                        g
                    ] : [
                        u
                    ]
                };
            }
        },
        {
            key: "drawHorizontalBoxPaths",
            value: function(t) {
                var e = t.indexes;
                t.x;
                var i = t.y, a = t.yDivision, s = t.barHeight, r = t.zeroW, o = t.strokeWidth, n = this.w, l = new m(this.ctx), h = e.i, c = e.j, d = this.boxOptions.colors.lower;
                this.isBoxPlot && (d = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var g = this.invertedYRatio, u = e.realIndex, p = this.getOHLCValue(u, c), f = r, x = r, b = Math.min(p.o, p.c), v = Math.max(p.o, p.c), y = p.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[u][c] - n.globals.minX) / this.invertedXRatio - s / 2);
                var w = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (b = r, v = r) : (b = r + b / g, v = r + v / g, f = r + p.h / g, x = r + p.l / g, y = r + p.m / g);
                var k = l.move(r, w), A = l.move(b, w + s / 2);
                return n.globals.previousPaths.length > 0 && (A = this.getPreviousPath(u, c, !0)), k = [
                    l.move(b, w) + l.line(b, w + s / 2) + l.line(f, w + s / 2) + l.line(f, w + s / 2 - s / 4) + l.line(f, w + s / 2 + s / 4) + l.line(f, w + s / 2) + l.line(b, w + s / 2) + l.line(b, w + s) + l.line(y, w + s) + l.line(y, w) + l.line(b + o / 2, w),
                    l.move(y, w) + l.line(y, w + s) + l.line(v, w + s) + l.line(v, w + s / 2) + l.line(x, w + s / 2) + l.line(x, w + s - s / 4) + l.line(x, w + s / 4) + l.line(x, w + s / 2) + l.line(v, w + s / 2) + l.line(v, w) + l.line(y, w) + "z"
                ], A += l.move(b, w), n.globals.isXNumeric || (i += a), {
                    pathTo: k,
                    pathFrom: A,
                    x: v,
                    y: i,
                    barYPosition: w,
                    color: d
                };
            }
        },
        {
            key: "getOHLCValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    o: this.isBoxPlot ? i.globals.seriesCandleH[t][e] : i.globals.seriesCandleO[t][e],
                    h: this.isBoxPlot ? i.globals.seriesCandleO[t][e] : i.globals.seriesCandleH[t][e],
                    m: i.globals.seriesCandleM[t][e],
                    l: this.isBoxPlot ? i.globals.seriesCandleC[t][e] : i.globals.seriesCandleL[t][e],
                    c: this.isBoxPlot ? i.globals.seriesCandleL[t][e] : i.globals.seriesCandleC[t][e]
                };
            }
        }
    ]), s;
}(), At = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "checkColorRange",
            value: function() {
                var t = this.w, e = !1, i = t.config.plotOptions[t.config.chart.type];
                return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(t, i) {
                    t.from <= 0 && (e = !0);
                }), e;
            }
        },
        {
            key: "getShadeColor",
            value: function(t, e, i, a) {
                var s = this.w, r = 1, o = s.config.plotOptions[t].shadeIntensity, n = this.determineColor(t, e, i);
                s.globals.hasNegs || a ? r = s.config.plotOptions[t].reverseNegativeShade ? n.percent < 0 ? n.percent / 100 * (1.25 * o) : (1 - n.percent / 100) * (1.25 * o) : n.percent <= 0 ? 1 - (1 + n.percent / 100) * o : (1 - n.percent / 100) * o : (r = 1 - n.percent / 100, "treemap" === t && (r = (1 - n.percent / 100) * (1.25 * o)));
                var l = n.color, h = new x;
                return s.config.plotOptions[t].enableShades && (l = "dark" === this.w.config.theme.mode ? x.hexToRgba(h.shadeColor(-1 * r, n.color), s.config.fill.opacity) : x.hexToRgba(h.shadeColor(r, n.color), s.config.fill.opacity)), {
                    color: l,
                    colorProps: n
                };
            }
        },
        {
            key: "determineColor",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.series[e][i], r = a.config.plotOptions[t], o = r.colorScale.inverse ? i : e;
                r.distributed && "treemap" === a.config.chart.type && (o = i);
                var n = a.globals.colors[o], l = null, h = Math.min.apply(Math, u(a.globals.series[e])), c = Math.max.apply(Math, u(a.globals.series[e]));
                r.distributed || "heatmap" !== t || (h = a.globals.minY, c = a.globals.maxY), void 0 !== r.colorScale.min && (h = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, c = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                var d = Math.abs(c) + Math.abs(h), g = 100 * s / (0 === d ? d - 1e-6 : d);
                r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(t, e) {
                    if (s >= t.from && s <= t.to) {
                        n = t.color, l = t.foreColor ? t.foreColor : null, h = t.from, c = t.to;
                        var i = Math.abs(c) + Math.abs(h);
                        g = 100 * s / (0 === i ? i - 1e-6 : i);
                    }
                });
                return {
                    color: n,
                    foreColor: l,
                    percent: g
                };
            }
        },
        {
            key: "calculateDataLabels",
            value: function(t) {
                var e = t.text, i = t.x, a = t.y, s = t.i, r = t.j, o = t.colorProps, n = t.fontSize, l = this.w.config.dataLabels, h = new m(this.ctx), c = new O(this.ctx), d = null;
                if (l.enabled) {
                    d = h.group({
                        class: "apexcharts-data-labels"
                    });
                    var g = l.offsetX, u = l.offsetY, p = i + g, f = a + parseFloat(l.style.fontSize) / 3 + u;
                    c.plotDataLabelsText({
                        x: p,
                        y: f,
                        text: e,
                        i: s,
                        j: r,
                        color: o.foreColor,
                        parent: d,
                        fontSize: n,
                        dataLabelsConfig: l
                    });
                }
                return d;
            }
        },
        {
            key: "addListeners",
            value: function(t) {
                var e = new m(this.ctx);
                t.node.addEventListener("mouseenter", e.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", e.pathMouseLeave.bind(this, t)), t.node.addEventListener("mousedown", e.pathMouseDown.bind(this, t));
            }
        }
    ]), t;
}(), St = function() {
    function t(e, i) {
        a(this, t), this.ctx = e, this.w = e.w, this.xRatio = i.xRatio, this.yRatio = i.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new At(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
    }
    return r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new m(this.ctx), a = i.group({
                    class: "apexcharts-heatmap"
                });
                a.attr("clip-path", "url(#gridRectMask".concat(e.globals.cuid, ")"));
                var s = e.globals.gridWidth / e.globals.dataPoints, r = e.globals.gridHeight / e.globals.series.length, o = 0, n = !1;
                this.negRange = this.helpers.checkColorRange();
                var l = t.slice();
                e.config.yaxis[0].reversed && (n = !0, l.reverse());
                for(var h = n ? 0 : l.length - 1; n ? h < l.length : h >= 0; n ? h++ : h--){
                    var c = i.group({
                        class: "apexcharts-series apexcharts-heatmap-series",
                        seriesName: x.escapeString(e.globals.seriesNames[h]),
                        rel: h + 1,
                        "data:realIndex": h
                    });
                    if (this.ctx.series.addCollapsedClassToSeries(c, h), e.config.chart.dropShadow.enabled) {
                        var d = e.config.chart.dropShadow;
                        new v(this.ctx).dropShadow(c, d, h);
                    }
                    for(var g = 0, u = e.config.plotOptions.heatmap.shadeIntensity, p = 0; p < l[h].length; p++){
                        var f = this.helpers.getShadeColor(e.config.chart.type, h, p, this.negRange), b = f.color, y = f.colorProps;
                        if ("image" === e.config.fill.type) b = new R(this.ctx).fillPath({
                            seriesNumber: h,
                            dataPointIndex: p,
                            opacity: e.globals.hasNegs ? y.percent < 0 ? 1 - (1 + y.percent / 100) : u + y.percent / 100 : y.percent / 100,
                            patternID: x.randomId(),
                            width: e.config.fill.image.width ? e.config.fill.image.width : s,
                            height: e.config.fill.image.height ? e.config.fill.image.height : r
                        });
                        var w = this.rectRadius, k = i.drawRect(g, o, s, r, w);
                        if (k.attr({
                            cx: g,
                            cy: o
                        }), k.node.classList.add("apexcharts-heatmap-rect"), c.add(k), k.attr({
                            fill: b,
                            i: h,
                            index: h,
                            j: p,
                            val: t[h][p],
                            "stroke-width": this.strokeWidth,
                            stroke: e.config.plotOptions.heatmap.useFillColorAsStroke ? b : e.globals.stroke.colors[0],
                            color: b
                        }), this.helpers.addListeners(k), e.config.chart.animations.enabled && !e.globals.dataChanged) {
                            var A = 1;
                            e.globals.resized || (A = e.config.chart.animations.speed), this.animateHeatMap(k, g, o, s, r, A);
                        }
                        if (e.globals.dataChanged) {
                            var S = 1;
                            if (this.dynamicAnim.enabled && e.globals.shouldAnimate) {
                                S = this.dynamicAnim.speed;
                                var C = e.globals.previousPaths[h] && e.globals.previousPaths[h][p] && e.globals.previousPaths[h][p].color;
                                C || (C = "rgba(255, 255, 255, 0)"), this.animateHeatColor(k, x.isColorHex(C) ? C : x.rgb2hex(C), x.isColorHex(b) ? b : x.rgb2hex(b), S);
                            }
                        }
                        var L = (0, e.config.dataLabels.formatter)(e.globals.series[h][p], {
                            value: e.globals.series[h][p],
                            seriesIndex: h,
                            dataPointIndex: p,
                            w: e
                        }), P = this.helpers.calculateDataLabels({
                            text: L,
                            x: g + s / 2,
                            y: o + r / 2,
                            i: h,
                            j: p,
                            colorProps: y,
                            series: l
                        });
                        null !== P && c.add(P), g += s;
                    }
                    o += r, a.add(c);
                }
                var I = e.globals.yAxisScale[0].result.slice();
                return e.config.yaxis[0].reversed ? I.unshift("") : I.push(""), e.globals.yAxisScale[0].result = I, a;
            }
        },
        {
            key: "animateHeatMap",
            value: function(t, e, i, a, s, r) {
                var o = new b(this.ctx);
                o.animateRect(t, {
                    x: e + a / 2,
                    y: i + s / 2,
                    width: 0,
                    height: 0
                }, {
                    x: e,
                    y: i,
                    width: a,
                    height: s
                }, r, function() {
                    o.animationCompleted(t);
                });
            }
        },
        {
            key: "animateHeatColor",
            value: function(t, e, i, a) {
                t.attr({
                    fill: e
                }).animate(a).attr({
                    fill: i
                });
            }
        }
    ]), t;
}(), Ct = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "drawYAxisTexts",
            value: function(t, e, i, a) {
                var s = this.w, r = s.config.yaxis[0], o = s.globals.yLabelFormatters[0];
                return new m(this.ctx).drawText({
                    x: t + r.labels.offsetX,
                    y: e + r.labels.offsetY,
                    text: o(a, i),
                    textAnchor: "middle",
                    fontSize: r.labels.style.fontSize,
                    fontFamily: r.labels.style.fontFamily,
                    foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                });
            }
        }
    ]), t;
}(), Lt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
            0
        ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = Math.min(i.globals.gridWidth, i.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = i.globals.gridWidth / 2, "radialBar" === i.config.chart.type ? this.fullAngle = 360 : this.fullAngle = Math.abs(i.config.plotOptions.pie.endAngle - i.config.plotOptions.pie.startAngle), this.initialAngle = i.config.plotOptions.pie.startAngle % this.fullAngle, i.globals.radialSize = this.defaultSize / 2.05 - i.config.stroke.width - (i.config.chart.sparkline.enabled ? 0 : i.config.chart.dropShadow.blur), this.donutSize = i.globals.radialSize * parseInt(i.config.plotOptions.pie.donut.size, 10) / 100, this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
    }
    return r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new m(this.ctx);
                if (this.ret = a.group({
                    class: "apexcharts-pie"
                }), i.globals.noData) return this.ret;
                for(var s = 0, r = 0; r < t.length; r++)s += x.negToZero(t[r]);
                var o = [], n = a.group();
                0 === s && (s = 1e-5), t.forEach(function(t) {
                    e.maxY = Math.max(e.maxY, t);
                }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), "back" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret);
                for(var l = 0; l < t.length; l++){
                    var h = this.fullAngle * x.negToZero(t[l]) / s;
                    o.push(h), "polarArea" === this.chartType ? (o[l] = this.fullAngle / t.length, this.sliceSizes.push(i.globals.radialSize * t[l] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                }
                if (i.globals.dataChanged) {
                    for(var c, d = 0, g = 0; g < i.globals.previousPaths.length; g++)d += x.negToZero(i.globals.previousPaths[g]);
                    for(var u = 0; u < i.globals.previousPaths.length; u++)c = this.fullAngle * x.negToZero(i.globals.previousPaths[u]) / d, this.prevSectorAngleArr.push(c);
                }
                this.donutSize < 0 && (this.donutSize = 0);
                var p = i.config.plotOptions.pie.customScale, f = i.globals.gridWidth / 2, b = i.globals.gridHeight / 2, v = f - i.globals.gridWidth / 2 * p, y = b - i.globals.gridHeight / 2 * p;
                if ("donut" === this.chartType) {
                    var w = a.drawCircle(this.donutSize);
                    w.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                    }), n.add(w);
                }
                var k = this.drawArcs(o, t);
                if (this.sliceLabels.forEach(function(t) {
                    k.add(t);
                }), n.attr({
                    transform: "translate(".concat(v, ", ").concat(y, ") scale(").concat(p, ")")
                }), n.add(k), this.ret.add(n), this.donutDataLabels.show) {
                    var A = this.renderInnerDataLabels(this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show,
                        translateX: v,
                        translateY: y
                    });
                    this.ret.add(A);
                }
                return "front" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret), this.ret;
            }
        },
        {
            key: "drawArcs",
            value: function(t, e) {
                var i = this.w, a = new v(this.ctx), s = new m(this.ctx), r = new R(this.ctx), o = s.group({
                    class: "apexcharts-slices"
                }), n = this.initialAngle, l = this.initialAngle, h = this.initialAngle, c = this.initialAngle;
                this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                for(var d = 0; d < t.length; d++){
                    var g = s.group({
                        class: "apexcharts-series apexcharts-pie-series",
                        seriesName: x.escapeString(i.globals.seriesNames[d]),
                        rel: d + 1,
                        "data:realIndex": d
                    });
                    o.add(g), l = c, h = (n = h) + t[d], c = l + this.prevSectorAngleArr[d];
                    var u = h < n ? this.fullAngle + h - n : h - n, p = r.fillPath({
                        seriesNumber: d,
                        size: this.sliceSizes[d],
                        value: e[d]
                    }), f = this.getChangedPath(l, c), b = s.drawPath({
                        d: f,
                        stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[d] : this.lineColorArr,
                        strokeWidth: 0,
                        fill: p,
                        fillOpacity: i.config.fill.opacity,
                        classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(d)
                    });
                    if (b.attr({
                        index: 0,
                        j: d
                    }), a.setSelectionFilter(b, 0, d), i.config.chart.dropShadow.enabled) {
                        var y = i.config.chart.dropShadow;
                        a.dropShadow(b, y, d);
                    }
                    this.addListeners(b, this.donutDataLabels), m.setAttrs(b.node, {
                        "data:angle": u,
                        "data:startAngle": n,
                        "data:strokeWidth": this.strokeWidth,
                        "data:value": e[d]
                    });
                    var w = {
                        x: 0,
                        y: 0
                    };
                    "pie" === this.chartType || "polarArea" === this.chartType ? w = x.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle) : "donut" === this.chartType && (w = x.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle)), g.add(b);
                    var k = 0;
                    if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : (0 === (k = u / this.fullAngle * i.config.chart.animations.speed) && (k = 1), this.animDur = k + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(b, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        prevStartAngle: l,
                        prevEndAngle: c,
                        animateStartingPos: !0,
                        i: d,
                        animBeginArr: this.animBeginArr,
                        shouldSetPrevPaths: !0,
                        dur: i.config.chart.animations.dynamicAnimation.speed
                    }) : this.animatePaths(b, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        i: d,
                        totalItems: t.length - 1,
                        animBeginArr: this.animBeginArr,
                        dur: k
                    }), i.config.plotOptions.pie.expandOnClick && "polarArea" !== this.chartType && b.click(this.pieClicked.bind(this, d)), void 0 !== i.globals.selectedDataPoints[0] && i.globals.selectedDataPoints[0].indexOf(d) > -1 && this.pieClicked(d), i.config.dataLabels.enabled) {
                        var A = w.x, S = w.y, C = 100 * u / this.fullAngle + "%";
                        if (0 !== u && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < t[d]) {
                            var L = i.config.dataLabels.formatter;
                            void 0 !== L && (C = L(i.globals.seriesPercent[d][0], {
                                seriesIndex: d,
                                w: i
                            }));
                            var P = i.globals.dataLabels.style.colors[d], I = s.group({
                                class: "apexcharts-datalabels"
                            }), T = s.drawText({
                                x: A,
                                y: S,
                                text: C,
                                textAnchor: "middle",
                                fontSize: i.config.dataLabels.style.fontSize,
                                fontFamily: i.config.dataLabels.style.fontFamily,
                                fontWeight: i.config.dataLabels.style.fontWeight,
                                foreColor: P
                            });
                            if (I.add(T), i.config.dataLabels.dropShadow.enabled) {
                                var M = i.config.dataLabels.dropShadow;
                                a.dropShadow(T, M);
                            }
                            T.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && !1 === i.globals.resized && (T.node.classList.add("apexcharts-pie-label-delay"), T.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(I);
                        }
                    }
                }
                return o;
            }
        },
        {
            key: "addListeners",
            value: function(t, e) {
                var i = new m(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, t)), t.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this, t)), this.donutDataLabels.total.showAlways || (t.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, t.node, e)));
            }
        },
        {
            key: "animatePaths",
            value: function(t, e) {
                var i = this.w, a = e.endAngle < e.startAngle ? this.fullAngle + e.endAngle - e.startAngle : e.endAngle - e.startAngle, s = a, r = e.startAngle, o = e.startAngle;
                void 0 !== e.prevStartAngle && void 0 !== e.prevEndAngle && (r = e.prevEndAngle, s = e.prevEndAngle < e.prevStartAngle ? this.fullAngle + e.prevEndAngle - e.prevStartAngle : e.prevEndAngle - e.prevStartAngle), e.i === i.config.series.length - 1 && (a + o > this.fullAngle ? e.endAngle = e.endAngle - (a + o) : a + o < this.fullAngle && (e.endAngle = e.endAngle + (this.fullAngle - (a + o)))), a === this.fullAngle && (a = this.fullAngle - .01), this.animateArc(t, r, o, a, s, e);
            }
        },
        {
            key: "animateArc",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = this.w, h = new b(this.ctx), c = r.size;
                (isNaN(e) || isNaN(s)) && (e = i, s = a, r.dur = 0);
                var d = a, g = i, u = e < i ? this.fullAngle + e - i : e - i;
                l.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (o = n.getPiePath({
                    me: n,
                    startAngle: r.prevStartAngle,
                    angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                    size: c
                }), t.attr({
                    d: o
                })), 0 !== r.dur ? t.animate(r.dur, l.globals.easing, r.animBeginArr[r.i]).afterAll(function() {
                    "pie" !== n.chartType && "donut" !== n.chartType && "polarArea" !== n.chartType || this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({
                        "stroke-width": n.strokeWidth
                    }), r.i === l.config.series.length - 1 && h.animationCompleted(t);
                }).during(function(l) {
                    d = u + (a - u) * l, r.animateStartingPos && (d = s + (a - s) * l, g = e - s + (i - (e - s)) * l), o = n.getPiePath({
                        me: n,
                        startAngle: g,
                        angle: d,
                        size: c
                    }), t.node.setAttribute("data:pathOrig", o), t.attr({
                        d: o
                    });
                }) : (o = n.getPiePath({
                    me: n,
                    startAngle: g,
                    angle: a,
                    size: c
                }), r.isTrack || (l.globals.animationEnded = !0), t.node.setAttribute("data:pathOrig", o), t.attr({
                    d: o,
                    "stroke-width": n.strokeWidth
                }));
            }
        },
        {
            key: "pieClicked",
            value: function(t) {
                var e, i = this.w, a = this, s = a.sliceSizes[t] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(t)).members[0];
                if ("true" !== r.attr("data:pieClicked")) {
                    var o = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                    Array.prototype.forEach.call(o, function(t) {
                        t.setAttribute("data:pieClicked", "false");
                        var e = t.getAttribute("data:pathOrig");
                        e && t.setAttribute("d", e);
                    }), r.attr("data:pieClicked", "true");
                    var n = parseInt(r.attr("data:startAngle"), 10), l = parseInt(r.attr("data:angle"), 10);
                    e = a.getPiePath({
                        me: a,
                        startAngle: n,
                        angle: l,
                        size: s
                    }), 360 !== l && r.plot(e);
                } else {
                    r.attr({
                        "data:pieClicked": "false"
                    }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                    var h = r.attr("data:pathOrig");
                    r.attr({
                        d: h
                    });
                }
            }
        },
        {
            key: "getChangedPath",
            value: function(t, e) {
                var i = "";
                return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                    me: this,
                    startAngle: t,
                    angle: e - t,
                    size: this.size
                })), i;
            }
        },
        {
            key: "getPiePath",
            value: function(t) {
                var e, i = t.me, a = t.startAngle, s = t.angle, r = t.size, o = new m(this.ctx), n = a, l = Math.PI * (n - 90) / 180, h = s + a;
                Math.ceil(h) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (h = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - .01), Math.ceil(h) > this.fullAngle && (h -= this.fullAngle);
                var c = Math.PI * (h - 90) / 180, d = i.centerX + r * Math.cos(l), g = i.centerY + r * Math.sin(l), u = i.centerX + r * Math.cos(c), p = i.centerY + r * Math.sin(c), f = x.polarToCartesian(i.centerX, i.centerY, i.donutSize, h), b = x.polarToCartesian(i.centerX, i.centerY, i.donutSize, n), v = s > 180 ? 1 : 0, y = [
                    "M",
                    d,
                    g,
                    "A",
                    r,
                    r,
                    0,
                    v,
                    1,
                    u,
                    p
                ];
                return e = "donut" === i.chartType ? [].concat(y, [
                    "L",
                    f.x,
                    f.y,
                    "A",
                    i.donutSize,
                    i.donutSize,
                    0,
                    v,
                    0,
                    b.x,
                    b.y,
                    "L",
                    d,
                    g,
                    "z"
                ]).join(" ") : "pie" === i.chartType || "polarArea" === i.chartType ? [].concat(y, [
                    "L",
                    i.centerX,
                    i.centerY,
                    "L",
                    d,
                    g
                ]).join(" ") : [].concat(y).join(" "), o.roundPathCorners(e, 2 * this.strokeWidth);
            }
        },
        {
            key: "drawPolarElements",
            value: function(t) {
                var e = this.w, i = new _(this.ctx), a = new m(this.ctx), s = new Ct(this.ctx), r = a.group(), o = a.group(), n = i.niceScale(0, Math.ceil(this.maxY), e.config.yaxis[0].tickAmount, 0, !0), l = n.result.reverse(), h = n.result.length;
                this.maxY = n.niceMax;
                for(var c = e.globals.radialSize, d = c / (h - 1), g = 0; g < h - 1; g++){
                    var u = a.drawCircle(c);
                    if (u.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: "none",
                        "stroke-width": e.config.plotOptions.polarArea.rings.strokeWidth,
                        stroke: e.config.plotOptions.polarArea.rings.strokeColor
                    }), e.config.yaxis[0].show) {
                        var p = s.drawYAxisTexts(this.centerX, this.centerY - c + parseInt(e.config.yaxis[0].labels.style.fontSize, 10) / 2, g, l[g]);
                        o.add(p);
                    }
                    r.add(u), c -= d;
                }
                this.drawSpokes(t), t.add(r), t.add(o);
            }
        },
        {
            key: "renderInnerDataLabels",
            value: function(t, e) {
                var i = this.w, a = new m(this.ctx), s = a.group({
                    class: "apexcharts-datalabels-group",
                    transform: "translate(".concat(e.translateX ? e.translateX : 0, ", ").concat(e.translateY ? e.translateY : 0, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                }), r = t.total.show;
                s.node.style.opacity = e.opacity;
                var o, n, l = e.centerX, h = e.centerY;
                o = void 0 === t.name.color ? i.globals.colors[0] : t.name.color;
                var c = t.name.fontSize, d = t.name.fontFamily, g = t.name.fontWeight;
                n = void 0 === t.value.color ? i.config.chart.foreColor : t.value.color;
                var u = t.value.formatter, p = "", f = "";
                if (r ? (o = t.total.color, c = t.total.fontSize, d = t.total.fontFamily, g = t.total.fontWeight, f = t.total.label, p = t.total.formatter(i)) : 1 === i.globals.series.length && (p = u(i.globals.series[0], i), f = i.globals.seriesNames[0]), f && (f = t.name.formatter(f, t.total.show, i)), t.name.show) {
                    var x = a.drawText({
                        x: l,
                        y: h + parseFloat(t.name.offsetY),
                        text: f,
                        textAnchor: "middle",
                        foreColor: o,
                        fontSize: c,
                        fontWeight: g,
                        fontFamily: d
                    });
                    x.node.classList.add("apexcharts-datalabel-label"), s.add(x);
                }
                if (t.value.show) {
                    var b = t.name.show ? parseFloat(t.value.offsetY) + 16 : t.value.offsetY, v = a.drawText({
                        x: l,
                        y: h + b,
                        text: p,
                        textAnchor: "middle",
                        foreColor: n,
                        fontWeight: t.value.fontWeight,
                        fontSize: t.value.fontSize,
                        fontFamily: t.value.fontFamily
                    });
                    v.node.classList.add("apexcharts-datalabel-value"), s.add(v);
                }
                return s;
            }
        },
        {
            key: "printInnerLabels",
            value: function(t, e, i, a) {
                var s, r = this.w;
                a ? s = void 0 === t.name.color ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : t.name.color : r.globals.series.length > 1 && t.total.show && (s = t.total.color);
                var o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                i = (0, t.value.formatter)(i, r), a || "function" != typeof t.total.formatter || (i = t.total.formatter(r));
                var l = e === t.total.label;
                e = t.name.formatter(e, l, r), null !== o && (o.textContent = e), null !== n && (n.textContent = i), null !== o && (o.style.fill = s);
            }
        },
        {
            key: "printDataLabelsInner",
            value: function(t, e) {
                var i = this.w, a = t.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"), 10) - 1];
                i.globals.series.length > 1 && this.printInnerLabels(e, s, a, t);
                var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                null !== r && (r.style.opacity = 1);
            }
        },
        {
            key: "drawSpokes",
            value: function(t) {
                var e = this, i = this.w, a = new m(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                if (0 !== s.strokeWidth) {
                    for(var r = [], o = 360 / i.globals.series.length, n = 0; n < i.globals.series.length; n++)r.push(x.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + o * n));
                    r.forEach(function(i, r) {
                        var o = a.drawLine(i.x, i.y, e.centerX, e.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[r] : s.connectorColors);
                        t.add(o);
                    });
                }
            }
        },
        {
            key: "revertDataLabelsInner",
            value: function(t, e, i) {
                var a = this, s = this.w, r = s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"), o = !1, n = s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"), l = function(t) {
                    var i = t.makeSliceOut, s = t.printLabel;
                    Array.prototype.forEach.call(n, function(t) {
                        "true" === t.getAttribute("data:pieClicked") && (i && (o = !0), s && a.printDataLabelsInner(t, e));
                    });
                };
                if (l({
                    makeSliceOut: !0,
                    printLabel: !1
                }), e.total.show && s.globals.series.length > 1) o && !e.total.showAlways ? l({
                    makeSliceOut: !1,
                    printLabel: !0
                }) : this.printInnerLabels(e, e.total.label, e.total.formatter(s));
                else if (l({
                    makeSliceOut: !1,
                    printLabel: !0
                }), !o) {
                    if (s.globals.selectedDataPoints.length && s.globals.series.length > 1) {
                        if (s.globals.selectedDataPoints[0].length > 0) {
                            var h = s.globals.selectedDataPoints[0], c = s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(h));
                            this.printDataLabelsInner(c, e);
                        } else r && s.globals.selectedDataPoints.length && 0 === s.globals.selectedDataPoints[0].length && (r.style.opacity = 0);
                    } else r && s.globals.series.length > 1 && (r.style.opacity = 0);
                }
            }
        }
    ]), t;
}(), Pt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
        var i = this.w;
        this.graphics = new m(this.ctx), this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = i.globals.svgHeight < i.globals.svgWidth ? i.globals.gridHeight + 1.5 * i.globals.goldenPadding : i.globals.gridWidth, this.isLog = i.config.yaxis[0].logarithmic, this.coreUtils = new y(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(i.globals.maxY, 0) : i.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.w.globals.minY, 0) : i.globals.minY, this.polygons = i.config.plotOptions.radar.polygons, this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - i.config.chart.dropShadow.blur, i.config.xaxis.labels.show && (this.size = this.size - i.globals.xAxisLabelsWidth / 1.75), void 0 !== i.config.plotOptions.radar.size && (this.size = i.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
    }
    return r(t, [
        {
            key: "draw",
            value: function(t) {
                var i = this, a = this.w, s = new R(this.ctx), r = [], o = new O(this.ctx);
                t.length && (this.dataPointsLen = t[a.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                var n = a.globals.gridWidth / 2, l = a.globals.gridHeight / 2, h = n + a.config.plotOptions.radar.offsetX, c = l + a.config.plotOptions.radar.offsetY, d = this.graphics.group({
                    class: "apexcharts-radar-series apexcharts-plot-series",
                    transform: "translate(".concat(h || 0, ", ").concat(c || 0, ")")
                }), g = [], u = null, p = null;
                if (this.yaxisLabels = this.graphics.group({
                    class: "apexcharts-yaxis"
                }), t.forEach(function(t, n) {
                    var l = t.length === a.globals.dataPoints, h = i.graphics.group().attr({
                        class: "apexcharts-series",
                        "data:longestSeries": l,
                        seriesName: x.escapeString(a.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    i.dataRadiusOfPercent[n] = [], i.dataRadius[n] = [], i.angleArr[n] = [], t.forEach(function(t, e) {
                        var a = Math.abs(i.maxValue - i.minValue);
                        t += Math.abs(i.minValue), i.isLog && (t = i.coreUtils.getLogVal(t, 0)), i.dataRadiusOfPercent[n][e] = t / a, i.dataRadius[n][e] = i.dataRadiusOfPercent[n][e] * i.size, i.angleArr[n][e] = e * i.disAngle;
                    }), g = i.getDataPointsPos(i.dataRadius[n], i.angleArr[n]);
                    var c = i.createPaths(g, {
                        x: 0,
                        y: 0
                    });
                    u = i.graphics.group({
                        class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                    }), p = i.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": n
                    }), a.globals.delayedElements.push({
                        el: u.node,
                        index: n
                    });
                    var d = {
                        i: n,
                        realIndex: n,
                        animationDelay: n,
                        initialSpeed: a.config.chart.animations.speed,
                        dataChangeSpeed: a.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-radar",
                        shouldClipToGrid: !1,
                        bindEventsOnPaths: !1,
                        stroke: a.globals.stroke.colors[n],
                        strokeLineCap: a.config.stroke.lineCap
                    }, f = null;
                    a.globals.previousPaths.length > 0 && (f = i.getPreviousPath(n));
                    for(var b = 0; b < c.linePathsTo.length; b++){
                        var m = i.graphics.renderPaths(e(e({}, d), {}, {
                            pathFrom: null === f ? c.linePathsFrom[b] : f,
                            pathTo: c.linePathsTo[b],
                            strokeWidth: Array.isArray(i.strokeWidth) ? i.strokeWidth[n] : i.strokeWidth,
                            fill: "none",
                            drawShadow: !1
                        }));
                        h.add(m);
                        var y = s.fillPath({
                            seriesNumber: n
                        }), w = i.graphics.renderPaths(e(e({}, d), {}, {
                            pathFrom: null === f ? c.areaPathsFrom[b] : f,
                            pathTo: c.areaPathsTo[b],
                            strokeWidth: 0,
                            fill: y,
                            drawShadow: !1
                        }));
                        if (a.config.chart.dropShadow.enabled) {
                            var k = new v(i.ctx), A = a.config.chart.dropShadow;
                            k.dropShadow(w, Object.assign({}, A, {
                                noUserSpaceOnUse: !0
                            }), n);
                        }
                        h.add(w);
                    }
                    t.forEach(function(t, s) {
                        var r = new H(i.ctx).getMarkerConfig({
                            cssClass: "apexcharts-marker",
                            seriesIndex: n,
                            dataPointIndex: s
                        }), l = i.graphics.drawMarker(g[s].x, g[s].y, r);
                        l.attr("rel", s), l.attr("j", s), l.attr("index", n), l.node.setAttribute("default-marker-size", r.pSize);
                        var c = i.graphics.group({
                            class: "apexcharts-series-markers"
                        });
                        c && c.add(l), u.add(c), h.add(u);
                        var d = a.config.dataLabels;
                        if (d.enabled) {
                            var f = d.formatter(a.globals.series[n][s], {
                                seriesIndex: n,
                                dataPointIndex: s,
                                w: a
                            });
                            o.plotDataLabelsText({
                                x: g[s].x,
                                y: g[s].y,
                                text: f,
                                textAnchor: "middle",
                                i: n,
                                j: n,
                                parent: p,
                                offsetCorrection: !1,
                                dataLabelsConfig: e({}, d)
                            });
                        }
                        h.add(p);
                    }), r.push(h);
                }), this.drawPolygons({
                    parent: d
                }), a.config.xaxis.labels.show) {
                    var f = this.drawXAxisTexts();
                    d.add(f);
                }
                return r.forEach(function(t) {
                    d.add(t);
                }), d.add(this.yaxisLabels), d;
            }
        },
        {
            key: "drawPolygons",
            value: function(t) {
                for(var e = this, i = this.w, a = t.parent, s = new Ct(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), o = r.length, n = [], l = this.size / (o - 1), h = 0; h < o; h++)n[h] = l * h;
                n.reverse();
                var c = [], d = [];
                n.forEach(function(t, i) {
                    var a = x.getPolygonPos(t, e.dataPointsLen), s = "";
                    a.forEach(function(t, a) {
                        if (0 === i) {
                            var r = e.graphics.drawLine(t.x, t.y, 0, 0, Array.isArray(e.polygons.connectorColors) ? e.polygons.connectorColors[a] : e.polygons.connectorColors);
                            d.push(r);
                        }
                        0 === a && e.yaxisLabelsTextsPos.push({
                            x: t.x,
                            y: t.y
                        }), s += t.x + "," + t.y + " ";
                    }), c.push(s);
                }), c.forEach(function(t, s) {
                    var r = e.polygons.strokeColors, o = e.polygons.strokeWidth, n = e.graphics.drawPolygon(t, Array.isArray(r) ? r[s] : r, Array.isArray(o) ? o[s] : o, i.globals.radarPolygons.fill.colors[s]);
                    a.add(n);
                }), d.forEach(function(t) {
                    a.add(t);
                }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(t, i) {
                    var a = s.drawYAxisTexts(t.x, t.y, i, r[i]);
                    e.yaxisLabels.add(a);
                });
            }
        },
        {
            key: "drawXAxisTexts",
            value: function() {
                var t = this, i = this.w, a = i.config.xaxis.labels, s = this.graphics.group({
                    class: "apexcharts-xaxis"
                }), r = x.getPolygonPos(this.size, this.dataPointsLen);
                return i.globals.labels.forEach(function(o, n) {
                    var l = i.config.xaxis.labels.formatter, h = new O(t.ctx);
                    if (r[n]) {
                        var c = t.getTextPos(r[n], t.size), d = l(o, {
                            seriesIndex: -1,
                            dataPointIndex: n,
                            w: i
                        });
                        h.plotDataLabelsText({
                            x: c.newX,
                            y: c.newY,
                            text: d,
                            textAnchor: c.textAnchor,
                            i: n,
                            j: n,
                            parent: s,
                            color: Array.isArray(a.style.colors) && a.style.colors[n] ? a.style.colors[n] : "#a8a8a8",
                            dataLabelsConfig: e({
                                textAnchor: c.textAnchor,
                                dropShadow: {
                                    enabled: !1
                                }
                            }, a),
                            offsetCorrection: !1
                        });
                    }
                }), s;
            }
        },
        {
            key: "createPaths",
            value: function(t, e) {
                var i = this, a = [], s = [], r = [], o = [];
                if (t.length) {
                    s = [
                        this.graphics.move(e.x, e.y)
                    ], o = [
                        this.graphics.move(e.x, e.y)
                    ];
                    var n = this.graphics.move(t[0].x, t[0].y), l = this.graphics.move(t[0].x, t[0].y);
                    t.forEach(function(e, a) {
                        n += i.graphics.line(e.x, e.y), l += i.graphics.line(e.x, e.y), a === t.length - 1 && (n += "Z", l += "Z");
                    }), a.push(n), r.push(l);
                }
                return {
                    linePathsFrom: s,
                    linePathsTo: a,
                    areaPathsFrom: o,
                    areaPathsTo: r
                };
            }
        },
        {
            key: "getTextPos",
            value: function(t, e) {
                var i = "middle", a = t.x, s = t.y;
                return Math.abs(t.x) >= 10 ? t.x > 0 ? (i = "start", a += 10) : t.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(t.y) >= e - 10 && (t.y < 0 ? s -= 10 : t.y > 0 && (s += 10)), {
                    textAnchor: i,
                    newX: a,
                    newY: s
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t) {
                for(var e = this.w, i = null, a = 0; a < e.globals.previousPaths.length; a++){
                    var s = e.globals.previousPaths[a];
                    s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(t, 10) && void 0 !== e.globals.previousPaths[a].paths[0] && (i = e.globals.previousPaths[a].paths[0].d);
                }
                return i;
            }
        },
        {
            key: "getDataPointsPos",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.dataPointsLen;
                t = t || [], e = e || [];
                for(var a = [], s = 0; s < i; s++){
                    var r = {};
                    r.x = t[s] * Math.sin(e[s]), r.y = -t[s] * Math.cos(e[s]), a.push(r);
                }
                return a;
            }
        }
    ]), t;
}(), It = function(t) {
    n(i, Lt);
    var e = d(i);
    function i(t) {
        var s;
        a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.animBeginArr = [
            0
        ], s.animDur = 0;
        var r = s.w;
        return s.startAngle = r.config.plotOptions.radialBar.startAngle, s.endAngle = r.config.plotOptions.radialBar.endAngle, s.totalAngle = Math.abs(r.config.plotOptions.radialBar.endAngle - r.config.plotOptions.radialBar.startAngle), s.trackStartAngle = r.config.plotOptions.radialBar.track.startAngle, s.trackEndAngle = r.config.plotOptions.radialBar.track.endAngle, s.barLabels = s.w.config.plotOptions.radialBar.barLabels, s.donutDataLabels = s.w.config.plotOptions.radialBar.dataLabels, s.radialDataLabels = s.donutDataLabels, s.trackStartAngle || (s.trackStartAngle = s.startAngle), s.trackEndAngle || (s.trackEndAngle = s.endAngle), 360 === s.endAngle && (s.endAngle = 359.99), s.margin = parseInt(r.config.plotOptions.radialBar.track.margin, 10), s.onBarLabelClick = s.onBarLabelClick.bind(c(s)), s;
    }
    return r(i, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new m(this.ctx), a = i.group({
                    class: "apexcharts-radialbar"
                });
                if (e.globals.noData) return a;
                var s = i.group(), r = this.defaultSize / 2, o = e.globals.gridWidth / 2, n = this.defaultSize / 2.05;
                e.config.chart.sparkline.enabled || (n = n - e.config.stroke.width - e.config.chart.dropShadow.blur);
                var l = e.globals.fill.colors;
                if (e.config.plotOptions.radialBar.track.show) {
                    var h = this.drawTracks({
                        size: n,
                        centerX: o,
                        centerY: r,
                        colorArr: l,
                        series: t
                    });
                    s.add(h);
                }
                var c = this.drawArcs({
                    size: n,
                    centerX: o,
                    centerY: r,
                    colorArr: l,
                    series: t
                }), d = 360;
                e.config.plotOptions.radialBar.startAngle < 0 && (d = this.totalAngle);
                var g = (360 - d) / 360;
                if (e.globals.radialSize = n - n * g, this.radialDataLabels.value.show) {
                    var u = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                    e.globals.radialSize += u * g;
                }
                return s.add(c.g), "front" === e.config.plotOptions.radialBar.hollow.position && (c.g.add(c.elHollow), c.dataLabels && c.g.add(c.dataLabels)), a.add(s), a;
            }
        },
        {
            key: "drawTracks",
            value: function(t) {
                var e = this.w, i = new m(this.ctx), a = i.group({
                    class: "apexcharts-tracks"
                }), s = new v(this.ctx), r = new R(this.ctx), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                for(var n = 0; n < t.series.length; n++){
                    var l = i.group({
                        class: "apexcharts-radialbar-track apexcharts-track"
                    });
                    a.add(l), l.attr({
                        rel: n + 1
                    }), t.size = t.size - o - this.margin;
                    var h = e.config.plotOptions.radialBar.track, c = r.fillPath({
                        seriesNumber: 0,
                        size: t.size,
                        fillColors: Array.isArray(h.background) ? h.background[n] : h.background,
                        solid: !0
                    }), d = this.trackStartAngle, g = this.trackEndAngle;
                    Math.abs(g) + Math.abs(d) >= 360 && (g = 360 - Math.abs(this.startAngle) - .1);
                    var u = i.drawPath({
                        d: "",
                        stroke: c,
                        strokeWidth: o * parseInt(h.strokeWidth, 10) / 100,
                        fill: "none",
                        strokeOpacity: h.opacity,
                        classes: "apexcharts-radialbar-area"
                    });
                    if (h.dropShadow.enabled) {
                        var p = h.dropShadow;
                        s.dropShadow(u, p);
                    }
                    l.add(u), u.attr("id", "apexcharts-radialbarTrack-" + n), this.animatePaths(u, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: g,
                        startAngle: d,
                        size: t.size,
                        i: n,
                        totalItems: 2,
                        animBeginArr: 0,
                        dur: 0,
                        isTrack: !0,
                        easing: e.globals.easing
                    });
                }
                return a;
            }
        },
        {
            key: "drawArcs",
            value: function(t) {
                var e = this.w, i = new m(this.ctx), a = new R(this.ctx), s = new v(this.ctx), r = i.group(), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                var n = e.config.plotOptions.radialBar.hollow.background, l = t.size - o * t.series.length - this.margin * t.series.length - o * parseInt(e.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, h = l - e.config.plotOptions.radialBar.hollow.margin;
                void 0 !== e.config.plotOptions.radialBar.hollow.image && (n = this.drawHollowImage(t, r, l, n));
                var c = this.drawHollow({
                    size: h,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    fill: n || "transparent"
                });
                if (e.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                    var d = e.config.plotOptions.radialBar.hollow.dropShadow;
                    s.dropShadow(c, d);
                }
                var g = 1;
                !this.radialDataLabels.total.show && e.globals.series.length > 1 && (g = 0);
                var u = null;
                this.radialDataLabels.show && (u = this.renderInnerDataLabels(this.radialDataLabels, {
                    hollowSize: l,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    opacity: g
                })), "back" === e.config.plotOptions.radialBar.hollow.position && (r.add(c), u && r.add(u));
                var p = !1;
                e.config.plotOptions.radialBar.inverseOrder && (p = !0);
                for(var f = p ? t.series.length - 1 : 0; p ? f >= 0 : f < t.series.length; p ? f-- : f++){
                    var b = i.group({
                        class: "apexcharts-series apexcharts-radial-series",
                        seriesName: x.escapeString(e.globals.seriesNames[f])
                    });
                    r.add(b), b.attr({
                        rel: f + 1,
                        "data:realIndex": f
                    }), this.ctx.series.addCollapsedClassToSeries(b, f), t.size = t.size - o - this.margin;
                    var y = a.fillPath({
                        seriesNumber: f,
                        size: t.size,
                        value: t.series[f]
                    }), w = this.startAngle, k = void 0, A = x.negToZero(t.series[f] > 100 ? 100 : t.series[f]) / 100, S = Math.round(this.totalAngle * A) + this.startAngle, C = void 0;
                    e.globals.dataChanged && (k = this.startAngle, C = Math.round(this.totalAngle * x.negToZero(e.globals.previousPaths[f]) / 100) + k), Math.abs(S) + Math.abs(w) >= 360 && (S -= .01), Math.abs(C) + Math.abs(k) >= 360 && (C -= .01);
                    var L = S - w, P = Array.isArray(e.config.stroke.dashArray) ? e.config.stroke.dashArray[f] : e.config.stroke.dashArray, I = i.drawPath({
                        d: "",
                        stroke: y,
                        strokeWidth: o,
                        fill: "none",
                        fillOpacity: e.config.fill.opacity,
                        classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + f,
                        strokeDashArray: P
                    });
                    if (m.setAttrs(I.node, {
                        "data:angle": L,
                        "data:value": t.series[f]
                    }), e.config.chart.dropShadow.enabled) {
                        var T = e.config.chart.dropShadow;
                        s.dropShadow(I, T, f);
                    }
                    if (s.setSelectionFilter(I, 0, f), this.addListeners(I, this.radialDataLabels), b.add(I), I.attr({
                        index: 0,
                        j: f
                    }), this.barLabels.enabled) {
                        var M = x.polarToCartesian(t.centerX, t.centerY, t.size, w), z = this.barLabels.formatter(e.globals.seriesNames[f], {
                            seriesIndex: f,
                            w: e
                        }), X = [
                            "apexcharts-radialbar-label"
                        ];
                        this.barLabels.onClick || X.push("apexcharts-no-click");
                        var E = this.barLabels.useSeriesColors ? e.globals.colors[f] : e.config.chart.foreColor;
                        E || (E = e.config.chart.foreColor);
                        var Y = M.x - this.barLabels.margin, F = M.y, H = i.drawText({
                            x: Y,
                            y: F,
                            text: z,
                            textAnchor: "end",
                            dominantBaseline: "middle",
                            fontFamily: this.barLabels.fontFamily,
                            fontWeight: this.barLabels.fontWeight,
                            fontSize: this.barLabels.fontSize,
                            foreColor: E,
                            cssClass: X.join(" ")
                        });
                        H.on("click", this.onBarLabelClick), H.attr({
                            rel: f + 1
                        }), 0 !== w && H.attr({
                            "transform-origin": "".concat(Y, " ").concat(F),
                            transform: "rotate(".concat(w, " 0 0)")
                        }), b.add(H);
                    }
                    var D = 0;
                    !this.initialAnim || e.globals.resized || e.globals.dataChanged || (D = e.config.chart.animations.speed), e.globals.dataChanged && (D = e.config.chart.animations.dynamicAnimation.speed), this.animDur = D / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(I, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: S,
                        startAngle: w,
                        prevEndAngle: C,
                        prevStartAngle: k,
                        size: t.size,
                        i: f,
                        totalItems: 2,
                        animBeginArr: this.animBeginArr,
                        dur: D,
                        shouldSetPrevPaths: !0,
                        easing: e.globals.easing
                    });
                }
                return {
                    g: r,
                    elHollow: c,
                    dataLabels: u
                };
            }
        },
        {
            key: "drawHollow",
            value: function(t) {
                var e = new m(this.ctx).drawCircle(2 * t.size);
                return e.attr({
                    class: "apexcharts-radialbar-hollow",
                    cx: t.centerX,
                    cy: t.centerY,
                    r: t.size,
                    fill: t.fill
                }), e;
            }
        },
        {
            key: "drawHollowImage",
            value: function(t, e, i, a) {
                var s = this.w, r = new R(this.ctx), o = x.randomId(), n = s.config.plotOptions.radialBar.hollow.image;
                if (s.config.plotOptions.radialBar.hollow.imageClipped) r.clippedImgArea({
                    width: i,
                    height: i,
                    image: n,
                    patternID: "pattern".concat(s.globals.cuid).concat(o)
                }), a = "url(#pattern".concat(s.globals.cuid).concat(o, ")");
                else {
                    var l = s.config.plotOptions.radialBar.hollow.imageWidth, h = s.config.plotOptions.radialBar.hollow.imageHeight;
                    if (void 0 === l && void 0 === h) {
                        var c = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - e.width / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - e.height / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY);
                        });
                        e.add(c);
                    } else {
                        var d = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - l / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - h / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(l, h);
                        });
                        e.add(d);
                    }
                }
                return a;
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t) {
                var e = this.w;
                return t.size * (100 - parseInt(e.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (t.series.length + 1) - this.margin;
            }
        },
        {
            key: "onBarLabelClick",
            value: function(t) {
                var e = parseInt(t.target.getAttribute("rel"), 10) - 1, i = this.barLabels.onClick, a = this.w;
                i && i(a.globals.seriesNames[e], {
                    w: a,
                    seriesIndex: e
                });
            }
        }
    ]), i;
}(), Tt = function(t) {
    n(s, yt);
    var i = d(s);
    function s() {
        return a(this, s), i.apply(this, arguments);
    }
    return r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new m(this.ctx);
                this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = t, this.seriesRangeStart = a.globals.seriesRangeStart, this.seriesRangeEnd = a.globals.seriesRangeEnd, this.barHelpers.initVariables(t);
                for(var r = s.group({
                    class: "apexcharts-rangebar-series apexcharts-plot-series"
                }), n = 0; n < t.length; n++){
                    var l, h, c, d, g = void 0, u = void 0, p = a.globals.comboCharts ? i[n] : n, f = s.group({
                        class: "apexcharts-series",
                        seriesName: x.escapeString(a.globals.seriesNames[p]),
                        rel: n + 1,
                        "data:realIndex": p
                    });
                    this.ctx.series.addCollapsedClassToSeries(f, p), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var b = 0, v = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = p);
                    var y = this.barHelpers.initialPositions();
                    u = y.y, d = y.zeroW, g = y.x, v = y.barWidth, b = y.barHeight, l = y.xDivision, h = y.yDivision, c = y.zeroH;
                    for(var w = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": p
                    }), k = s.group({
                        class: "apexcharts-rangebar-goals-markers"
                    }), A = 0; A < a.globals.dataPoints; A++){
                        var S, C = this.barHelpers.getStrokeWidth(n, A, p), L = this.seriesRangeStart[n][A], P = this.seriesRangeEnd[n][A], I = null, T = null, M = null, z = {
                            x: g,
                            y: u,
                            strokeWidth: C,
                            elSeries: f
                        }, X = this.seriesLen;
                        if (a.config.plotOptions.bar.rangeBarGroupRows && (X = 1), void 0 === a.config.series[n].data[A]) break;
                        if (this.isHorizontal) {
                            M = u + b * this.visibleI;
                            var E = (h - b * X) / 2;
                            if (a.config.series[n].data[A].x) {
                                var Y = this.detectOverlappingBars({
                                    i: n,
                                    j: A,
                                    barYPosition: M,
                                    srty: E,
                                    barHeight: b,
                                    yDivision: h,
                                    initPositions: y
                                });
                                b = Y.barHeight, M = Y.barYPosition;
                            }
                            v = (I = this.drawRangeBarPaths(e({
                                indexes: {
                                    i: n,
                                    j: A,
                                    realIndex: p
                                },
                                barHeight: b,
                                barYPosition: M,
                                zeroW: d,
                                yDivision: h,
                                y1: L,
                                y2: P
                            }, z))).barWidth;
                        } else {
                            a.globals.isXNumeric && (g = (a.globals.seriesX[n][A] - a.globals.minX) / this.xRatio - v / 2), T = g + v * this.visibleI;
                            var F = (l - v * X) / 2;
                            if (a.config.series[n].data[A].x) {
                                var R = this.detectOverlappingBars({
                                    i: n,
                                    j: A,
                                    barXPosition: T,
                                    srtx: F,
                                    barWidth: v,
                                    xDivision: l,
                                    initPositions: y
                                });
                                v = R.barWidth, T = R.barXPosition;
                            }
                            b = (I = this.drawRangeColumnPaths(e({
                                indexes: {
                                    i: n,
                                    j: A,
                                    realIndex: p
                                },
                                barWidth: v,
                                barXPosition: T,
                                zeroH: c,
                                xDivision: l
                            }, z))).barHeight;
                        }
                        var H = this.barHelpers.drawGoalLine({
                            barXPosition: I.barXPosition,
                            barYPosition: M,
                            goalX: I.goalX,
                            goalY: I.goalY,
                            barHeight: b,
                            barWidth: v
                        });
                        H && k.add(H), u = I.y, g = I.x;
                        var D = this.barHelpers.getPathFillColor(t, n, A, p), O = a.globals.stroke.colors[p];
                        this.renderSeries((o(S = {
                            realIndex: p,
                            pathFill: D,
                            lineFill: O,
                            j: A,
                            i: n,
                            x: g,
                            y: u,
                            y1: L,
                            y2: P,
                            pathFrom: I.pathFrom,
                            pathTo: I.pathTo,
                            strokeWidth: C,
                            elSeries: f,
                            series: t,
                            barHeight: b,
                            barWidth: v,
                            barXPosition: T,
                            barYPosition: M
                        }, "barWidth", v), o(S, "elDataLabelsWrap", w), o(S, "elGoalsMarkers", k), o(S, "visibleSeries", this.visibleI), o(S, "type", "rangebar"), S));
                    }
                    r.add(f);
                }
                return r;
            }
        },
        {
            key: "detectOverlappingBars",
            value: function(t) {
                var e = t.i, i = t.j, a = t.barYPosition, s = t.barXPosition, r = t.srty, o = t.srtx, n = t.barHeight, l = t.barWidth, h = t.yDivision, c = t.xDivision, d = t.initPositions, g = this.w, u = [], p = g.config.series[e].data[i].rangeName, f = g.config.series[e].data[i].x, x = Array.isArray(f) ? f.join(" ") : f, b = g.globals.labels.map(function(t) {
                    return Array.isArray(t) ? t.join(" ") : t;
                }).indexOf(x), v = g.globals.seriesRange[e].findIndex(function(t) {
                    return t.x === x && t.overlaps.length > 0;
                });
                return this.isHorizontal ? (a = g.config.plotOptions.bar.rangeBarGroupRows ? r + h * b : r + n * this.visibleI + h * b, v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(p) > -1 && (a = (n = d.barHeight / u.length) * this.visibleI + h * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + n * (this.visibleI + u.indexOf(p)) + h * b)) : (b > -1 && (s = g.config.plotOptions.bar.rangeBarGroupRows ? o + c * b : o + l * this.visibleI + c * b), v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(p) > -1 && (s = (l = d.barWidth / u.length) * this.visibleI + c * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + l * (this.visibleI + u.indexOf(p)) + c * b)), {
                    barYPosition: a,
                    barXPosition: s,
                    barHeight: n,
                    barWidth: l
                };
            }
        },
        {
            key: "drawRangeColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.xDivision, s = t.barWidth, r = t.barXPosition, o = t.zeroH, n = this.w, l = e.i, h = e.j, c = this.yRatio[this.yaxisIndex], d = e.realIndex, g = this.getRangeValue(d, h), u = Math.min(g.start, g.end), p = Math.max(g.start, g.end);
                void 0 === this.series[l][h] || null === this.series[l][h] ? u = o : (u = o - u / c, p = o - p / c);
                var f = Math.abs(p - u), x = this.barHelpers.getColumnPaths({
                    barXPosition: r,
                    barWidth: s,
                    y1: u,
                    y2: p,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    realIndex: e.realIndex,
                    i: d,
                    j: h,
                    w: n
                });
                if (n.globals.isXNumeric) {
                    var b = this.getBarXForNumericXAxis({
                        x: i,
                        j: h,
                        realIndex: d,
                        barWidth: s
                    });
                    i = b.x, r = b.barXPosition;
                } else i += a;
                return {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    barHeight: f,
                    x: i,
                    y: p,
                    goalY: this.barHelpers.getGoalValues("y", null, o, l, h),
                    barXPosition: r
                };
            }
        },
        {
            key: "drawRangeBarPaths",
            value: function(t) {
                var e = t.indexes, i = t.y, a = t.y1, s = t.y2, r = t.yDivision, o = t.barHeight, n = t.barYPosition, l = t.zeroW, h = this.w, c = l + a / this.invertedYRatio, d = l + s / this.invertedYRatio, g = Math.abs(d - c), u = this.barHelpers.getBarpaths({
                    barYPosition: n,
                    barHeight: o,
                    x1: c,
                    x2: d,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    i: e.realIndex,
                    realIndex: e.realIndex,
                    j: e.j,
                    w: h
                });
                return h.globals.isXNumeric || (i += r), {
                    pathTo: u.pathTo,
                    pathFrom: u.pathFrom,
                    barWidth: g,
                    x: d,
                    goalX: this.barHelpers.getGoalValues("x", l, null, e.realIndex, e.j),
                    y: i
                };
            }
        },
        {
            key: "getRangeValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    start: i.globals.seriesRangeStart[t][e],
                    end: i.globals.seriesRangeEnd[t][e]
                };
            }
        }
    ]), s;
}(), Mt = function() {
    function t(e) {
        a(this, t), this.w = e.w, this.lineCtx = e;
    }
    return r(t, [
        {
            key: "sameValueSeriesFix",
            value: function(t, e) {
                var i = this.w;
                if (("gradient" === i.config.fill.type || "gradient" === i.config.fill.type[t]) && new y(this.lineCtx.ctx, i).seriesHaveSameValues(t)) {
                    var a = e[t].slice();
                    a[a.length - 1] = a[a.length - 1] + 1e-6, e[t] = a;
                }
                return e;
            }
        },
        {
            key: "calculatePoints",
            value: function(t) {
                var e = t.series, i = t.realIndex, a = t.x, s = t.y, r = t.i, o = t.j, n = t.prevY, l = this.w, h = [], c = [];
                if (0 === o) {
                    var d = this.lineCtx.categoryAxisCorrection + l.config.markers.offsetX;
                    l.globals.isXNumeric && (d = (l.globals.seriesX[i][0] - l.globals.minX) / this.lineCtx.xRatio + l.config.markers.offsetX), h.push(d), c.push(x.isNumber(e[r][0]) ? n + l.config.markers.offsetY : null), h.push(a + l.config.markers.offsetX), c.push(x.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                } else h.push(a + l.config.markers.offsetX), c.push(x.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                return {
                    x: h,
                    y: c
                };
            }
        },
        {
            key: "checkPreviousPaths",
            value: function(t) {
                for(var e = t.pathFromLine, i = t.pathFromArea, a = t.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                    var o = s.globals.previousPaths[r];
                    ("line" === o.type || "area" === o.type) && o.paths.length > 0 && parseInt(o.realIndex, 10) === parseInt(a, 10) && ("line" === o.type ? (this.lineCtx.appendPathFrom = !1, e = s.globals.previousPaths[r].paths[0].d) : "area" === o.type && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (e = s.globals.previousPaths[r].paths[1].d)));
                }
                return {
                    pathFromLine: e,
                    pathFromArea: i
                };
            }
        },
        {
            key: "determineFirstPrevY",
            value: function(t) {
                var e, i, a = t.i, s = t.series, r = t.prevY, o = t.lineYPosition, n = this.w, l = n.config.chart.stacked && !n.globals.comboCharts || n.config.chart.stacked && n.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || "bar" === (null === (e = this.w.config.series[a]) || void 0 === e ? void 0 : e.type));
                if (void 0 !== (null === (i = s[a]) || void 0 === i ? void 0 : i[0])) r = (o = l && a > 0 ? this.lineCtx.prevSeriesY[a - 1][0] : this.lineCtx.zeroY) - s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] + 2 * (this.lineCtx.isReversed ? s[a][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] : 0);
                else if (l && a > 0 && void 0 === s[a][0]) {
                    for(var h = a - 1; h >= 0; h--)if (null !== s[h][0] && void 0 !== s[h][0]) {
                        r = o = this.lineCtx.prevSeriesY[h][0];
                        break;
                    }
                }
                return {
                    prevY: r,
                    lineYPosition: o
                };
            }
        }
    ]), t;
}(), zt = function(t) {
    for(var e, i, a, s, r = function(t) {
        for(var e = [], i = t[0], a = t[1], s = e[0] = Yt(i, a), r = 1, o = t.length - 1; r < o; r++)i = a, a = t[r + 1], e[r] = .5 * (s + (s = Yt(i, a)));
        return e[r] = s, e;
    }(t), o = t.length - 1, n = [], l = 0; l < o; l++)a = Yt(t[l], t[l + 1]), Math.abs(a) < 1e-6 ? r[l] = r[l + 1] = 0 : (s = (e = r[l] / a) * e + (i = r[l + 1] / a) * i) > 9 && (s = 3 * a / Math.sqrt(s), r[l] = s * e, r[l + 1] = s * i);
    for(var h = 0; h <= o; h++)s = (t[Math.min(o, h + 1)][0] - t[Math.max(0, h - 1)][0]) / (6 * (1 + r[h] * r[h])), n.push([
        s || 0,
        r[h] * s || 0
    ]);
    return n;
}, Xt = function(t, e) {
    for(var i = "", a = 0; a < t.length; a++){
        var s = t[a], r = t[a - 1], o = s.length, n = null == r ? void 0 : r.length;
        a > 1 && Math.abs(s[o - 2] - r[n - 2]) < e / 25 ? i += "L".concat(s[2], ", ").concat(s[3]) : o > 4 ? (i += "C".concat(s[0], ", ").concat(s[1]), i += ", ".concat(s[2], ", ").concat(s[3]), i += ", ".concat(s[4], ", ").concat(s[5])) : o > 2 && (i += "S".concat(s[0], ", ").concat(s[1]), i += ", ".concat(s[2], ", ").concat(s[3]));
    }
    return i;
}, Et = function(t) {
    var e = zt(t), i = t[1], a = t[0], s = [], r = e[1], o = e[0];
    s.push(a, [
        a[0] + o[0],
        a[1] + o[1],
        i[0] - r[0],
        i[1] - r[1],
        i[0],
        i[1]
    ]);
    for(var n = 2, l = e.length; n < l; n++){
        var h = t[n], c = e[n];
        s.push([
            h[0] - c[0],
            h[1] - c[1],
            h[0],
            h[1]
        ]);
    }
    return s;
};
function Yt(t, e) {
    return (e[1] - t[1]) / (e[0] - t[0]);
}
var Ft = function() {
    function t(e, i, s) {
        a(this, t), this.ctx = e, this.w = e.w, this.xyRatios = i, this.pointsChart = !("bubble" !== this.w.config.chart.type && "scatter" !== this.w.config.chart.type) || s, this.scatter = new D(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new Mt(this), this.markers = new H(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
    }
    return r(t, [
        {
            key: "draw",
            value: function(t, i, a, s) {
                var r, o = this.w, n = new m(this.ctx), l = o.globals.comboCharts ? i : o.config.chart.type, h = n.group({
                    class: "apexcharts-".concat(l, "-series apexcharts-plot-series")
                }), c = new y(this.ctx, o);
                this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, t = c.getLogSeries(t), this.yRatio = c.getLogYRatios(this.yRatio);
                for(var d = [], g = 0; g < t.length; g++){
                    t = this.lineHelpers.sameValueSeriesFix(g, t);
                    var u = o.globals.comboCharts ? a[g] : g;
                    this._initSerieVariables(t, g, u);
                    var p = [], f = [], x = [], b = o.globals.padHorizontal + this.categoryAxisCorrection;
                    this.ctx.series.addCollapsedClassToSeries(this.elSeries, u), o.globals.isXNumeric && o.globals.seriesX.length > 0 && (b = (o.globals.seriesX[u][0] - o.globals.minX) / this.xRatio), x.push(b);
                    var v = b, w = this.zeroY, k = this.zeroY;
                    w = this.lineHelpers.determineFirstPrevY({
                        i: g,
                        series: t,
                        prevY: w,
                        lineYPosition: 0
                    }).prevY, "smooth" === o.config.stroke.curve && null === t[g][0] ? p.push(null) : p.push(w);
                    "rangeArea" === l && (k = this.lineHelpers.determineFirstPrevY({
                        i: g,
                        series: s,
                        prevY: k,
                        lineYPosition: 0
                    }).prevY, f.push(k));
                    var A = {
                        type: l,
                        series: t,
                        realIndex: u,
                        i: g,
                        x: b,
                        y: 1,
                        pathsFrom: this._calculatePathsFrom({
                            type: l,
                            series: t,
                            i: g,
                            realIndex: u,
                            prevX: v,
                            prevY: w,
                            prevY2: k
                        }),
                        linePaths: [],
                        areaPaths: [],
                        seriesIndex: a,
                        lineYPosition: 0,
                        xArrj: x,
                        yArrj: p,
                        y2Arrj: f,
                        seriesRangeEnd: s
                    }, S = this._iterateOverDataPoints(e(e({}, A), {}, {
                        iterations: "rangeArea" === l ? t[g].length - 1 : void 0,
                        isRangeStart: !0
                    }));
                    if ("rangeArea" === l) {
                        var C = this._calculatePathsFrom({
                            series: s,
                            i: g,
                            realIndex: u,
                            prevX: v,
                            prevY: k
                        }), L = this._iterateOverDataPoints(e(e({}, A), {}, {
                            series: s,
                            pathsFrom: C,
                            iterations: s[g].length - 1,
                            isRangeStart: !1
                        }));
                        S.linePaths[0] = L.linePath + S.linePath, S.pathFromLine = L.pathFromLine + S.pathFromLine;
                    }
                    this._handlePaths({
                        type: l,
                        realIndex: u,
                        i: g,
                        paths: S
                    }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), d.push(this.elSeries);
                }
                if (void 0 !== (null === (r = o.config.series[0]) || void 0 === r ? void 0 : r.zIndex) && d.sort(function(t, e) {
                    return Number(t.node.getAttribute("zIndex")) - Number(e.node.getAttribute("zIndex"));
                }), o.config.chart.stacked) for(var P = d.length; P > 0; P--)h.add(d[P - 1]);
                else for(var I = 0; I < d.length; I++)h.add(d[I]);
                return h;
            }
        },
        {
            key: "_initSerieVariables",
            value: function(t, e, i) {
                var a = this.w, s = new m(this.ctx);
                this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - ("on" === a.config.xaxis.tickPlacement ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width, this.yRatio.length > 1 && (this.yaxisIndex = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || "end" === a.config.plotOptions.area.fillTo) && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                    class: "apexcharts-series",
                    zIndex: void 0 !== a.config.series[i].zIndex ? a.config.series[i].zIndex : i,
                    seriesName: x.escapeString(a.globals.seriesNames[i])
                }), this.elPointsMain = s.group({
                    class: "apexcharts-series-markers-wrap",
                    "data:realIndex": i
                }), this.elDataLabelsWrap = s.group({
                    class: "apexcharts-datalabels",
                    "data:realIndex": i
                });
                var r = t[e].length === a.globals.dataPoints;
                this.elSeries.attr({
                    "data:longestSeries": r,
                    rel: e + 1,
                    "data:realIndex": i
                }), this.appendPathFrom = !0;
            }
        },
        {
            key: "_calculatePathsFrom",
            value: function(t) {
                var e, i, a, s, r = t.type, o = t.series, n = t.i, l = t.realIndex, h = t.prevX, c = t.prevY, d = t.prevY2, g = this.w, u = new m(this.ctx);
                if (null === o[n][0]) {
                    for(var p = 0; p < o[n].length; p++)if (null !== o[n][p]) {
                        h = this.xDivision * p, c = this.zeroY - o[n][p] / this.yRatio[this.yaxisIndex], e = u.move(h, c), i = u.move(h, this.areaBottomY);
                        break;
                    }
                } else e = u.move(h, c), "rangeArea" === r && (e = u.move(h, d) + u.line(h, c)), i = u.move(h, this.areaBottomY) + u.line(h, c);
                if (a = u.move(-1, this.zeroY) + u.line(-1, this.zeroY), s = u.move(-1, this.zeroY) + u.line(-1, this.zeroY), g.globals.previousPaths.length > 0) {
                    var f = this.lineHelpers.checkPreviousPaths({
                        pathFromLine: a,
                        pathFromArea: s,
                        realIndex: l
                    });
                    a = f.pathFromLine, s = f.pathFromArea;
                }
                return {
                    prevX: h,
                    prevY: c,
                    linePath: e,
                    areaPath: i,
                    pathFromLine: a,
                    pathFromArea: s
                };
            }
        },
        {
            key: "_handlePaths",
            value: function(t) {
                var i = t.type, a = t.realIndex, s = t.i, r = t.paths, o = this.w, n = new m(this.ctx), l = new R(this.ctx);
                this.prevSeriesY.push(r.yArrj), o.globals.seriesXvalues[a] = r.xArrj, o.globals.seriesYvalues[a] = r.yArrj;
                var h = o.config.forecastDataPoints;
                if (h.count > 0 && "rangeArea" !== i) {
                    var c = o.globals.seriesXvalues[a][o.globals.seriesXvalues[a].length - h.count - 1], d = n.drawRect(c, 0, o.globals.gridWidth, o.globals.gridHeight, 0);
                    o.globals.dom.elForecastMask.appendChild(d.node);
                    var g = n.drawRect(0, 0, c, o.globals.gridHeight, 0);
                    o.globals.dom.elNonForecastMask.appendChild(g.node);
                }
                this.pointsChart || o.globals.delayedElements.push({
                    el: this.elPointsMain.node,
                    index: a
                });
                var u = {
                    i: s,
                    realIndex: a,
                    animationDelay: s,
                    initialSpeed: o.config.chart.animations.speed,
                    dataChangeSpeed: o.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(i)
                };
                if ("area" === i) for(var p = l.fillPath({
                    seriesNumber: a
                }), f = 0; f < r.areaPaths.length; f++){
                    var x = n.renderPaths(e(e({}, u), {}, {
                        pathFrom: r.pathFromArea,
                        pathTo: r.areaPaths[f],
                        stroke: "none",
                        strokeWidth: 0,
                        strokeLineCap: null,
                        fill: p
                    }));
                    this.elSeries.add(x);
                }
                if (o.config.stroke.show && !this.pointsChart) {
                    var b = null;
                    if ("line" === i) b = l.fillPath({
                        seriesNumber: a,
                        i: s
                    });
                    else if ("solid" === o.config.stroke.fill.type) b = o.globals.stroke.colors[a];
                    else {
                        var v = o.config.fill;
                        o.config.fill = o.config.stroke.fill, b = l.fillPath({
                            seriesNumber: a,
                            i: s
                        }), o.config.fill = v;
                    }
                    for(var y = 0; y < r.linePaths.length; y++){
                        var w = b;
                        "rangeArea" === i && (w = l.fillPath({
                            seriesNumber: a
                        }));
                        var k = e(e({}, u), {}, {
                            pathFrom: r.pathFromLine,
                            pathTo: r.linePaths[y],
                            stroke: b,
                            strokeWidth: this.strokeWidth,
                            strokeLineCap: o.config.stroke.lineCap,
                            fill: "rangeArea" === i ? w : "none"
                        }), A = n.renderPaths(k);
                        if (this.elSeries.add(A), A.attr("fill-rule", "evenodd"), h.count > 0 && "rangeArea" !== i) {
                            var S = n.renderPaths(k);
                            S.node.setAttribute("stroke-dasharray", h.dashArray), h.strokeWidth && S.node.setAttribute("stroke-width", h.strokeWidth), this.elSeries.add(S), S.attr("clip-path", "url(#forecastMask".concat(o.globals.cuid, ")")), A.attr("clip-path", "url(#nonForecastMask".concat(o.globals.cuid, ")"));
                        }
                    }
                }
            }
        },
        {
            key: "_iterateOverDataPoints",
            value: function(t) {
                var e, i = this, a = t.type, s = t.series, r = t.iterations, o = t.realIndex, n = t.i, l = t.x, h = t.y, c = t.pathsFrom, d = t.linePaths, g = t.areaPaths, u = t.seriesIndex, p = t.lineYPosition, f = t.xArrj, b = t.yArrj, v = t.y2Arrj, y = t.isRangeStart, w = t.seriesRangeEnd, k = this.w, A = new m(this.ctx), S = this.yRatio, C = c.prevY, L = c.linePath, P = c.areaPath, I = c.pathFromLine, T = c.pathFromArea, M = x.isNumber(k.globals.minYArr[o]) ? k.globals.minYArr[o] : k.globals.minY;
                r || (r = k.globals.dataPoints > 1 ? k.globals.dataPoints - 1 : k.globals.dataPoints);
                for(var z = function(t, e) {
                    return e - t / S[i.yaxisIndex] + 2 * (i.isReversed ? t / S[i.yaxisIndex] : 0);
                }, X = h, E = k.config.chart.stacked && !k.globals.comboCharts || k.config.chart.stacked && k.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || "bar" === (null === (e = this.w.config.series[o]) || void 0 === e ? void 0 : e.type)), Y = 0; Y < r; Y++){
                    var F = void 0 === s[n][Y + 1] || null === s[n][Y + 1];
                    if (k.globals.isXNumeric) {
                        var R = k.globals.seriesX[o][Y + 1];
                        void 0 === k.globals.seriesX[o][Y + 1] && (R = k.globals.seriesX[o][r - 1]), l = (R - k.globals.minX) / this.xRatio;
                    } else l += this.xDivision;
                    if (E) {
                        if (n > 0 && k.globals.collapsedSeries.length < k.config.series.length - 1) p = this.prevSeriesY[function(t) {
                            for(var e = t, i = 0; i < k.globals.series.length; i++)if (k.globals.collapsedSeriesIndices.indexOf(t) > -1) {
                                e--;
                                break;
                            }
                            return e >= 0 ? e : 0;
                        }(n - 1)][Y + 1];
                        else p = this.zeroY;
                    } else p = this.zeroY;
                    F ? h = z(M, p) : (h = z(s[n][Y + 1], p), "rangeArea" === a && (X = z(w[n][Y + 1], p))), f.push(l), F && "smooth" === k.config.stroke.curve ? b.push(null) : b.push(h), v.push(X);
                    var H = this.lineHelpers.calculatePoints({
                        series: s,
                        x: l,
                        y: h,
                        realIndex: o,
                        i: n,
                        j: Y,
                        prevY: C
                    }), D = this._createPaths({
                        type: a,
                        series: s,
                        i: n,
                        realIndex: o,
                        j: Y,
                        x: l,
                        y: h,
                        y2: X,
                        xArrj: f,
                        yArrj: b,
                        y2Arrj: v,
                        linePath: L,
                        areaPath: P,
                        linePaths: d,
                        areaPaths: g,
                        seriesIndex: u,
                        isRangeStart: y
                    });
                    g = D.areaPaths, d = D.linePaths, P = D.areaPath, L = D.linePath, !this.appendPathFrom || "smooth" === k.config.stroke.curve && "rangeArea" === a || (I += A.line(l, this.zeroY), T += A.line(l, this.zeroY)), this.handleNullDataPoints(s, H, n, Y, o), this._handleMarkersAndLabels({
                        type: a,
                        pointsPos: H,
                        i: n,
                        j: Y,
                        realIndex: o,
                        isRangeStart: y
                    });
                }
                return {
                    yArrj: b,
                    xArrj: f,
                    pathFromArea: T,
                    areaPaths: g,
                    pathFromLine: I,
                    linePaths: d,
                    linePath: L,
                    areaPath: P
                };
            }
        },
        {
            key: "_handleMarkersAndLabels",
            value: function(t) {
                var e = t.type, i = t.pointsPos, a = t.isRangeStart, s = t.i, r = t.j, o = t.realIndex, n = this.w, l = new O(this.ctx);
                if (this.pointsChart) this.scatter.draw(this.elSeries, r, {
                    realIndex: o,
                    pointsPos: i,
                    zRatio: this.zRatio,
                    elParent: this.elPointsMain
                });
                else {
                    n.globals.series[s].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                    var h = this.markers.plotChartMarkers(i, o, r + 1);
                    null !== h && this.elPointsMain.add(h);
                }
                var c = l.drawDataLabel({
                    type: e,
                    isRangeStart: a,
                    pos: i,
                    i: o,
                    j: r + 1
                });
                null !== c && this.elDataLabelsWrap.add(c);
            }
        },
        {
            key: "_createPaths",
            value: function(t) {
                var e = t.type, i = t.series, a = t.i, s = t.realIndex, r = t.j, o = t.x, n = t.y, l = t.xArrj, h = t.yArrj, c = t.y2, d = t.y2Arrj, g = t.linePath, u = t.areaPath, p = t.linePaths, f = t.areaPaths, x = t.seriesIndex, b = t.isRangeStart, v = this.w, y = new m(this.ctx), w = v.config.stroke.curve, k = this.areaBottomY;
                if (Array.isArray(v.config.stroke.curve) && (w = Array.isArray(x) ? v.config.stroke.curve[x[a]] : v.config.stroke.curve[a]), "rangeArea" === e && (v.globals.hasNullValues || v.config.forecastDataPoints.count > 0) && "smooth" === w && (w = "straight"), "smooth" === w) {
                    var A = "rangeArea" === e ? l.length === v.globals.dataPoints : r === i[a].length - 2, S = l.map(function(t, e) {
                        return [
                            l[e],
                            h[e]
                        ];
                    }).filter(function(t) {
                        return null !== t[1];
                    });
                    if (A && S.length > 1) {
                        var C = Et(S);
                        if (g += Xt(C, v.globals.gridWidth), null === i[a][0] ? u = g : u += Xt(C, v.globals.gridWidth), "rangeArea" === e && b) {
                            g += y.line(l[l.length - 1], d[d.length - 1]);
                            var L = l.slice().reverse(), P = d.slice().reverse(), I = L.map(function(t, e) {
                                return [
                                    L[e],
                                    P[e]
                                ];
                            }), T = Et(I);
                            u = g += Xt(T, v.globals.gridWidth);
                        } else u += y.line(S[S.length - 1][0], k) + y.line(S[0][0], k) + y.move(S[0][0], S[0][1]) + "z";
                        p.push(g), f.push(u);
                    }
                } else {
                    if (null === i[a][r + 1]) {
                        g += y.move(o, n);
                        var M = v.globals.isXNumeric ? (v.globals.seriesX[s][r] - v.globals.minX) / this.xRatio : o - this.xDivision;
                        u = u + y.line(M, k) + y.move(o, n) + "z";
                    }
                    null === i[a][r] && (g += y.move(o, n), u += y.move(o, k)), "stepline" === w ? (g = g + y.line(o, null, "H") + y.line(null, n, "V"), u = u + y.line(o, null, "H") + y.line(null, n, "V")) : "straight" === w && (g += y.line(o, n), u += y.line(o, n)), r === i[a].length - 2 && (u = u + y.line(o, k) + y.move(o, n) + "z", "rangeArea" === e && b ? g = g + y.line(o, c) + y.move(o, c) + "z" : (p.push(g), f.push(u)));
                }
                return {
                    linePaths: p,
                    areaPaths: f,
                    linePath: g,
                    areaPath: u
                };
            }
        },
        {
            key: "handleNullDataPoints",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (null === t[i][a] && r.config.markers.showNullDataPoints || 1 === t[i].length) {
                    var o = this.markers.plotChartMarkers(e, s, a + 1, this.strokeWidth - r.config.markers.strokeWidth / 2, !0);
                    null !== o && this.elPointsMain.add(o);
                }
            }
        }
    ]), t;
}();
window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
    function t(e, i, a, s) {
        this.xoffset = e, this.yoffset = i, this.height = s, this.width = a, this.shortestEdge = function() {
            return Math.min(this.height, this.width);
        }, this.getCoordinates = function(t) {
            var e, i = [], a = this.xoffset, s = this.yoffset, o = r(t) / this.height, n = r(t) / this.width;
            if (this.width >= this.height) for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + o,
                s + t[e] / o
            ]), s += t[e] / o;
            else for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + t[e] / n,
                s + n
            ]), a += t[e] / n;
            return i;
        }, this.cutArea = function(e) {
            var i;
            if (this.width >= this.height) {
                var a = e / this.height, s = this.width - a;
                i = new t(this.xoffset + a, this.yoffset, s, this.height);
            } else {
                var r = e / this.width, o = this.height - r;
                i = new t(this.xoffset, this.yoffset + r, this.width, o);
            }
            return i;
        };
    }
    function e(e, a, s, o, n) {
        o = void 0 === o ? 0 : o, n = void 0 === n ? 0 : n;
        var l = i(function(t, e) {
            var i, a = [], s = e / r(t);
            for(i = 0; i < t.length; i++)a[i] = t[i] * s;
            return a;
        }(e, a * s), [], new t(o, n, a, s), []);
        return function(t) {
            var e, i, a = [];
            for(e = 0; e < t.length; e++)for(i = 0; i < t[e].length; i++)a.push(t[e][i]);
            return a;
        }(l);
    }
    function i(t, e, s, o) {
        var n, l, h;
        if (0 !== t.length) return n = s.shortestEdge(), function(t, e, i) {
            var s;
            if (0 === t.length) return !0;
            (s = t.slice()).push(e);
            var r = a(t, i), o = a(s, i);
            return r >= o;
        }(e, l = t[0], n) ? (e.push(l), i(t.slice(1), e, s, o)) : (h = s.cutArea(r(e), o), o.push(s.getCoordinates(e)), i(t, [], h, o)), o;
        o.push(s.getCoordinates(e));
    }
    function a(t, e) {
        var i = Math.min.apply(Math, t), a = Math.max.apply(Math, t), s = r(t);
        return Math.max(Math.pow(e, 2) * a / Math.pow(s, 2), Math.pow(s, 2) / (Math.pow(e, 2) * i));
    }
    function s(t) {
        return t && t.constructor === Array;
    }
    function r(t) {
        var e, i = 0;
        for(e = 0; e < t.length; e++)i += t[e];
        return i;
    }
    function o(t) {
        var e, i = 0;
        if (s(t[0])) for(e = 0; e < t.length; e++)i += o(t[e]);
        else i = r(t);
        return i;
    }
    return function t(i, a, r, n, l) {
        n = void 0 === n ? 0 : n, l = void 0 === l ? 0 : l;
        var h, c, d = [], g = [];
        if (s(i[0])) {
            for(c = 0; c < i.length; c++)d[c] = o(i[c]);
            for(h = e(d, a, r, n, l), c = 0; c < i.length; c++)g.push(t(i[c], h[c][2] - h[c][0], h[c][3] - h[c][1], h[c][0], h[c][1]));
        } else g = e(i, a, r, n, l);
        return g;
    };
}();
var Rt, Ht, Dt = function() {
    function t(e, i) {
        a(this, t), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new At(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
    }
    return r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new m(this.ctx), s = new R(this.ctx), r = a.group({
                    class: "apexcharts-treemap"
                });
                if (i.globals.noData) return r;
                var o = [];
                return t.forEach(function(t) {
                    var e = t.map(function(t) {
                        return Math.abs(t);
                    });
                    o.push(e);
                }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(t, i) {
                    t.data.forEach(function(t) {
                        Array.isArray(e.labels[i]) || (e.labels[i] = []), e.labels[i].push(t.x);
                    });
                }), window.TreemapSquared.generate(o, i.globals.gridWidth, i.globals.gridHeight).forEach(function(o, n) {
                    var l = a.group({
                        class: "apexcharts-series apexcharts-treemap-series",
                        seriesName: x.escapeString(i.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    if (i.config.chart.dropShadow.enabled) {
                        var h = i.config.chart.dropShadow;
                        new v(e.ctx).dropShadow(r, h, n);
                    }
                    var c = a.group({
                        class: "apexcharts-data-labels"
                    });
                    o.forEach(function(r, o) {
                        var h = r[0], c = r[1], d = r[2], g = r[3], u = a.drawRect(h, c, d - h, g - c, 0, "#fff", 1, e.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? f : i.globals.stroke.colors[n]);
                        u.attr({
                            cx: h,
                            cy: c,
                            index: n,
                            i: n,
                            j: o,
                            width: d - h,
                            height: g - c
                        });
                        var p = e.helpers.getShadeColor(i.config.chart.type, n, o, e.negRange), f = p.color;
                        void 0 !== i.config.series[n].data[o] && i.config.series[n].data[o].fillColor && (f = i.config.series[n].data[o].fillColor);
                        var x = s.fillPath({
                            color: f,
                            seriesNumber: n,
                            dataPointIndex: o
                        });
                        u.node.classList.add("apexcharts-treemap-rect"), u.attr({
                            fill: x
                        }), e.helpers.addListeners(u);
                        var b = {
                            x: h + (d - h) / 2,
                            y: c + (g - c) / 2,
                            width: 0,
                            height: 0
                        }, v = {
                            x: h,
                            y: c,
                            width: d - h,
                            height: g - c
                        };
                        if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                            var m = 1;
                            i.globals.resized || (m = i.config.chart.animations.speed), e.animateTreemap(u, b, v, m);
                        }
                        if (i.globals.dataChanged) {
                            var y = 1;
                            e.dynamicAnim.enabled && i.globals.shouldAnimate && (y = e.dynamicAnim.speed, i.globals.previousPaths[n] && i.globals.previousPaths[n][o] && i.globals.previousPaths[n][o].rect && (b = i.globals.previousPaths[n][o].rect), e.animateTreemap(u, b, v, y));
                        }
                        var w = e.getFontSize(r), k = i.config.dataLabels.formatter(e.labels[n][o], {
                            value: i.globals.series[n][o],
                            seriesIndex: n,
                            dataPointIndex: o,
                            w: i
                        });
                        "truncate" === i.config.plotOptions.treemap.dataLabels.format && (w = parseInt(i.config.dataLabels.style.fontSize, 10), k = e.truncateLabels(k, w, h, c, d, g));
                        var A = e.helpers.calculateDataLabels({
                            text: k,
                            x: (h + d) / 2,
                            y: (c + g) / 2 + e.strokeWidth / 2 + w / 3,
                            i: n,
                            j: o,
                            colorProps: p,
                            fontSize: w,
                            series: t
                        });
                        i.config.dataLabels.enabled && A && e.rotateToFitLabel(A, w, k, h, c, d, g), l.add(u), null !== A && l.add(A);
                    }), l.add(c), r.add(l);
                }), r;
            }
        },
        {
            key: "getFontSize",
            value: function(t) {
                var e = this.w;
                var i, a, s, r, o = function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += e[i].length;
                    return a;
                }(this.labels) / function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += 1;
                    return a;
                }(this.labels);
                return i = t[2] - t[0], a = t[3] - t[1], s = i * a, r = Math.pow(s, .5), Math.min(r / o, parseInt(e.config.dataLabels.style.fontSize, 10));
            }
        },
        {
            key: "rotateToFitLabel",
            value: function(t, e, i, a, s, r, o) {
                var n = new m(this.ctx), l = n.getTextRects(i, e);
                if (l.width + this.w.config.stroke.width + 5 > r - a && l.width <= o - s) {
                    var h = n.rotateAroundCenter(t.node);
                    t.node.setAttribute("transform", "rotate(-90 ".concat(h.x, " ").concat(h.y, ") translate(").concat(l.height / 3, ")"));
                }
            }
        },
        {
            key: "truncateLabels",
            value: function(t, e, i, a, s, r) {
                var o = new m(this.ctx), n = o.getTextRects(t, e).width + this.w.config.stroke.width + 5 > s - i && r - a > s - i ? r - a : s - i, l = o.getTextBasedOnMaxWidth({
                    text: t,
                    maxWidth: n,
                    fontSize: e
                });
                return t.length !== l.length && n / e < 5 ? "" : l;
            }
        },
        {
            key: "animateTreemap",
            value: function(t, e, i, a) {
                var s = new b(this.ctx);
                s.animateRect(t, {
                    x: e.x,
                    y: e.y,
                    width: e.width,
                    height: e.height
                }, {
                    x: i.x,
                    y: i.y,
                    width: i.width,
                    height: i.height
                }, a, function() {
                    s.animationCompleted(t);
                });
            }
        }
    ]), t;
}(), Ot = 86400, Nt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
    }
    return r(t, [
        {
            key: "calculateTimeScaleTicks",
            value: function(t, i) {
                var a = this, s = this.w;
                if (s.globals.allSeriesCollapsed) return s.globals.labels = [], s.globals.timescaleLabels = [], [];
                var r = new I(this.ctx), o = (i - t) / 864e5;
                this.determineInterval(o), s.globals.disableZoomIn = !1, s.globals.disableZoomOut = !1, o < .00011574074074074075 ? s.globals.disableZoomIn = !0 : o > 5e4 && (s.globals.disableZoomOut = !0);
                var n = r.getTimeUnitsfromTimestamp(t, i, this.utc), l = s.globals.gridWidth / o, h = l / 24, c = h / 60, d = c / 60, g = Math.floor(24 * o), u = Math.floor(1440 * o), p = Math.floor(o * Ot), f = Math.floor(o), x = Math.floor(o / 30), b = Math.floor(o / 365), v = {
                    minMillisecond: n.minMillisecond,
                    minSecond: n.minSecond,
                    minMinute: n.minMinute,
                    minHour: n.minHour,
                    minDate: n.minDate,
                    minMonth: n.minMonth,
                    minYear: n.minYear
                }, m = {
                    firstVal: v,
                    currentMillisecond: v.minMillisecond,
                    currentSecond: v.minSecond,
                    currentMinute: v.minMinute,
                    currentHour: v.minHour,
                    currentMonthDate: v.minDate,
                    currentDate: v.minDate,
                    currentMonth: v.minMonth,
                    currentYear: v.minYear,
                    daysWidthOnXAxis: l,
                    hoursWidthOnXAxis: h,
                    minutesWidthOnXAxis: c,
                    secondsWidthOnXAxis: d,
                    numberOfSeconds: p,
                    numberOfMinutes: u,
                    numberOfHours: g,
                    numberOfDays: f,
                    numberOfMonths: x,
                    numberOfYears: b
                };
                switch(this.tickInterval){
                    case "years":
                        this.generateYearScale(m);
                        break;
                    case "months":
                    case "half_year":
                        this.generateMonthScale(m);
                        break;
                    case "months_days":
                    case "months_fortnight":
                    case "days":
                    case "week_days":
                        this.generateDayScale(m);
                        break;
                    case "hours":
                        this.generateHourScale(m);
                        break;
                    case "minutes_fives":
                    case "minutes":
                        this.generateMinuteScale(m);
                        break;
                    case "seconds_tens":
                    case "seconds_fives":
                    case "seconds":
                        this.generateSecondScale(m);
                }
                var y = this.timeScaleArray.map(function(t) {
                    var i = {
                        position: t.position,
                        unit: t.unit,
                        year: t.year,
                        day: t.day ? t.day : 1,
                        hour: t.hour ? t.hour : 0,
                        month: t.month + 1
                    };
                    return "month" === t.unit ? e(e({}, i), {}, {
                        day: 1,
                        value: t.value + 1
                    }) : "day" === t.unit || "hour" === t.unit ? e(e({}, i), {}, {
                        value: t.value
                    }) : "minute" === t.unit ? e(e({}, i), {}, {
                        value: t.value,
                        minute: t.value
                    }) : "second" === t.unit ? e(e({}, i), {}, {
                        value: t.value,
                        minute: t.minute,
                        second: t.second
                    }) : t;
                });
                return y.filter(function(t) {
                    var e = 1, i = Math.ceil(s.globals.gridWidth / 120), r = t.value;
                    void 0 !== s.config.xaxis.tickAmount && (i = s.config.xaxis.tickAmount), y.length > i && (e = Math.floor(y.length / i));
                    var o = !1, n = !1;
                    switch(a.tickInterval){
                        case "years":
                            "year" === t.unit && (o = !0);
                            break;
                        case "half_year":
                            e = 7, "year" === t.unit && (o = !0);
                            break;
                        case "months":
                            e = 1, "year" === t.unit && (o = !0);
                            break;
                        case "months_fortnight":
                            e = 15, "year" !== t.unit && "month" !== t.unit || (o = !0), 30 === r && (n = !0);
                            break;
                        case "months_days":
                            e = 10, "month" === t.unit && (o = !0), 30 === r && (n = !0);
                            break;
                        case "week_days":
                            e = 8, "month" === t.unit && (o = !0);
                            break;
                        case "days":
                            e = 1, "month" === t.unit && (o = !0);
                            break;
                        case "hours":
                            "day" === t.unit && (o = !0);
                            break;
                        case "minutes_fives":
                        case "seconds_fives":
                            r % 5 != 0 && (n = !0);
                            break;
                        case "seconds_tens":
                            r % 10 != 0 && (n = !0);
                    }
                    if ("hours" === a.tickInterval || "minutes_fives" === a.tickInterval || "seconds_tens" === a.tickInterval || "seconds_fives" === a.tickInterval) {
                        if (!n) return !0;
                    } else if ((r % e == 0 || o) && !n) return !0;
                });
            }
        },
        {
            key: "recalcDimensionsBasedOnFormat",
            value: function(t, e) {
                var i = this.w, a = this.formatDates(t), s = this.removeOverlappingTS(a);
                i.globals.timescaleLabels = s.slice(), new ot(this.ctx).plotCoords();
            }
        },
        {
            key: "determineInterval",
            value: function(t) {
                var e = 24 * t, i = 60 * e;
                switch(!0){
                    case t / 365 > 5:
                        this.tickInterval = "years";
                        break;
                    case t > 800:
                        this.tickInterval = "half_year";
                        break;
                    case t > 180:
                        this.tickInterval = "months";
                        break;
                    case t > 90:
                        this.tickInterval = "months_fortnight";
                        break;
                    case t > 60:
                        this.tickInterval = "months_days";
                        break;
                    case t > 30:
                        this.tickInterval = "week_days";
                        break;
                    case t > 2:
                        this.tickInterval = "days";
                        break;
                    case e > 2.4:
                        this.tickInterval = "hours";
                        break;
                    case i > 15:
                        this.tickInterval = "minutes_fives";
                        break;
                    case i > 5:
                        this.tickInterval = "minutes";
                        break;
                    case i > 1:
                        this.tickInterval = "seconds_tens";
                        break;
                    case 60 * i > 20:
                        this.tickInterval = "seconds_fives";
                        break;
                    default:
                        this.tickInterval = "seconds";
                }
            }
        },
        {
            key: "generateYearScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.daysWidthOnXAxis, r = t.numberOfYears, o = e.minYear, n = 0, l = new I(this.ctx), h = "year";
                if (e.minDate > 1 || e.minMonth > 0) {
                    var c = l.determineRemainingDaysOfYear(e.minYear, e.minMonth, e.minDate);
                    n = (l.determineDaysOfYear(e.minYear) - c + 1) * s, o = e.minYear + 1, this.timeScaleArray.push({
                        position: n,
                        value: o,
                        unit: h,
                        year: o,
                        month: x.monthMod(i + 1)
                    });
                } else 1 === e.minDate && 0 === e.minMonth && this.timeScaleArray.push({
                    position: n,
                    value: o,
                    unit: h,
                    year: a,
                    month: x.monthMod(i + 1)
                });
                for(var d = o, g = n, u = 0; u < r; u++)d++, g = l.determineDaysOfYear(d - 1) * s + g, this.timeScaleArray.push({
                    position: g,
                    value: d,
                    unit: h,
                    year: d,
                    month: 1
                });
            }
        },
        {
            key: "generateMonthScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonthDate, a = t.currentMonth, s = t.currentYear, r = t.daysWidthOnXAxis, o = t.numberOfMonths, n = a, l = 0, h = new I(this.ctx), c = "month", d = 0;
                if (e.minDate > 1) {
                    l = (h.determineDaysOfMonths(a + 1, e.minYear) - i + 1) * r, n = x.monthMod(a + 1);
                    var g = s + d, u = x.monthMod(n), p = n;
                    0 === n && (c = "year", p = g, u = 1, g += d += 1), this.timeScaleArray.push({
                        position: l,
                        value: p,
                        unit: c,
                        year: g,
                        month: u
                    });
                } else this.timeScaleArray.push({
                    position: l,
                    value: n,
                    unit: c,
                    year: s,
                    month: x.monthMod(a)
                });
                for(var f = n + 1, b = l, v = 0, m = 1; v < o; v++, m++){
                    0 === (f = x.monthMod(f)) ? (c = "year", d += 1) : c = "month";
                    var y = this._getYear(s, f, d);
                    b = h.determineDaysOfMonths(f, y) * r + b;
                    var w = 0 === f ? y : f;
                    this.timeScaleArray.push({
                        position: b,
                        value: w,
                        unit: c,
                        year: y,
                        month: 0 === f ? 1 : f
                    }), f++;
                }
            }
        },
        {
            key: "generateDayScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.hoursWidthOnXAxis, r = t.numberOfDays, o = new I(this.ctx), n = "day", l = e.minDate + 1, h = l, c = function(t, e, i) {
                    return t > o.determineDaysOfMonths(e + 1, i) ? (h = 1, n = "month", g = e += 1, e) : e;
                }, d = (24 - e.minHour) * s, g = l, u = c(h, i, a);
                0 === e.minHour && 1 === e.minDate ? (d = 0, g = x.monthMod(e.minMonth), n = "month", h = e.minDate) : 1 !== e.minDate && 0 === e.minHour && 0 === e.minMinute && (d = 0, l = e.minDate, g = l, u = c(h = l, i, a)), this.timeScaleArray.push({
                    position: d,
                    value: g,
                    unit: n,
                    year: this._getYear(a, u, 0),
                    month: x.monthMod(u),
                    day: h
                });
                for(var p = d, f = 0; f < r; f++){
                    n = "day", u = c(h += 1, u, this._getYear(a, u, 0));
                    var b = this._getYear(a, u, 0);
                    p = 24 * s + p;
                    var v = 1 === h ? x.monthMod(u) : h;
                    this.timeScaleArray.push({
                        position: p,
                        value: v,
                        unit: n,
                        year: b,
                        month: x.monthMod(u),
                        day: v
                    });
                }
            }
        },
        {
            key: "generateHourScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentDate, a = t.currentMonth, s = t.currentYear, r = t.minutesWidthOnXAxis, o = t.numberOfHours, n = new I(this.ctx), l = "hour", h = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) && (f = 1, e += 1), {
                        month: e,
                        date: f
                    };
                }, c = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) ? e += 1 : e;
                }, d = 60 - (e.minMinute + e.minSecond / 60), g = d * r, u = e.minHour + 1, p = u;
                60 === d && (g = 0, p = u = e.minHour);
                var f = i;
                p >= 24 && (p = 0, f += 1, l = "day");
                var b = h(f, a).month;
                b = c(f, b), this.timeScaleArray.push({
                    position: g,
                    value: u,
                    unit: l,
                    day: f,
                    hour: p,
                    year: s,
                    month: x.monthMod(b)
                }), p++;
                for(var v = g, m = 0; m < o; m++){
                    if (l = "hour", p >= 24) p = 0, l = "day", b = h(f += 1, b).month, b = c(f, b);
                    var y = this._getYear(s, b, 0);
                    v = 60 * r + v;
                    var w = 0 === p ? f : p;
                    this.timeScaleArray.push({
                        position: v,
                        value: w,
                        unit: l,
                        hour: p,
                        day: f,
                        year: y,
                        month: x.monthMod(b)
                    }), p++;
                }
            }
        },
        {
            key: "generateMinuteScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.minutesWidthOnXAxis, h = t.secondsWidthOnXAxis, c = t.numberOfMinutes, d = a + 1, g = r, u = o, p = n, f = s, b = (60 - i - e / 1e3) * h, v = 0; v < c; v++)d >= 60 && (d = 0, 24 === (f += 1) && (f = 0)), this.timeScaleArray.push({
                    position: b,
                    value: d,
                    unit: "minute",
                    hour: f,
                    minute: d,
                    day: g,
                    year: this._getYear(p, u, 0),
                    month: x.monthMod(u)
                }), b += l, d++;
            }
        },
        {
            key: "generateSecondScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.secondsWidthOnXAxis, h = t.numberOfSeconds, c = i + 1, d = a, g = r, u = o, p = n, f = s, b = (1e3 - e) / 1e3 * l, v = 0; v < h; v++)c >= 60 && (c = 0, ++d >= 60 && (d = 0, 24 === ++f && (f = 0))), this.timeScaleArray.push({
                    position: b,
                    value: c,
                    unit: "second",
                    hour: f,
                    minute: d,
                    second: c,
                    day: g,
                    year: this._getYear(p, u, 0),
                    month: x.monthMod(u)
                }), b += l, c++;
            }
        },
        {
            key: "createRawDateString",
            value: function(t, e) {
                var i = t.year;
                return 0 === t.month && (t.month = 1), i += "-" + ("0" + t.month.toString()).slice(-2), "day" === t.unit ? i += "day" === t.unit ? "-" + ("0" + e).slice(-2) : "-01" : i += "-" + ("0" + (t.day ? t.day : "1")).slice(-2), "hour" === t.unit ? i += "hour" === t.unit ? "T" + ("0" + e).slice(-2) : "T00" : i += "T" + ("0" + (t.hour ? t.hour : "0")).slice(-2), "minute" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":" + (t.minute ? ("0" + t.minute).slice(-2) : "00"), "second" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
            }
        },
        {
            key: "formatDates",
            value: function(t) {
                var e = this, i = this.w;
                return t.map(function(t) {
                    var a = t.value.toString(), s = new I(e.ctx), r = e.createRawDateString(t, a), o = s.getDate(s.parseDate(r));
                    if (e.utc || (o = s.getDate(s.parseDateWithTimezone(r))), void 0 === i.config.xaxis.labels.format) {
                        var n = "dd MMM", l = i.config.xaxis.labels.datetimeFormatter;
                        "year" === t.unit && (n = l.year), "month" === t.unit && (n = l.month), "day" === t.unit && (n = l.day), "hour" === t.unit && (n = l.hour), "minute" === t.unit && (n = l.minute), "second" === t.unit && (n = l.second), a = s.formatDate(o, n);
                    } else a = s.formatDate(o, i.config.xaxis.labels.format);
                    return {
                        dateString: r,
                        position: t.position,
                        value: a,
                        unit: t.unit,
                        year: t.year,
                        month: t.month
                    };
                });
            }
        },
        {
            key: "removeOverlappingTS",
            value: function(t) {
                var e, i = this, a = new m(this.ctx), s = !1;
                t.length > 0 && t[0].value && t.every(function(e) {
                    return e.value.length === t[0].value.length;
                }) && (s = !0, e = a.getTextRects(t[0].value).width);
                var r = 0, o = t.map(function(o, n) {
                    if (n > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                        var l = s ? e : a.getTextRects(t[r].value).width, h = t[r].position;
                        return o.position > h + l + 10 ? (r = n, o) : null;
                    }
                    return o;
                });
                return o = o.filter(function(t) {
                    return null !== t;
                });
            }
        },
        {
            key: "_getYear",
            value: function(t, e, i) {
                return t + Math.floor(e / 12) + i;
            }
        }
    ]), t;
}(), Wt = function() {
    function t(e, i) {
        a(this, t), this.ctx = i, this.w = i.w, this.el = e;
    }
    return r(t, [
        {
            key: "setupElements",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = e.chart.type;
                t.axisCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble",
                    "radar",
                    "heatmap",
                    "treemap"
                ].indexOf(i) > -1, t.xyCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble"
                ].indexOf(i) > -1, t.isBarHorizontal = ("bar" === e.chart.type || "rangeBar" === e.chart.type || "boxPlot" === e.chart.type) && e.plotOptions.bar.horizontal, t.chartClass = ".apexcharts" + t.chartID, t.dom.baseEl = this.el, t.dom.elWrap = document.createElement("div"), m.setAttrs(t.dom.elWrap, {
                    id: t.chartClass.substring(1),
                    class: "apexcharts-canvas " + t.chartClass.substring(1)
                }), this.el.appendChild(t.dom.elWrap), t.dom.Paper = new window.SVG.Doc(t.dom.elWrap), t.dom.Paper.attr({
                    class: "apexcharts-svg",
                    "xmlns:data": "ApexChartsNS",
                    transform: "translate(".concat(e.chart.offsetX, ", ").concat(e.chart.offsetY, ")")
                }), t.dom.Paper.node.style.background = "dark" !== e.theme.mode || e.chart.background ? e.chart.background : "rgba(0, 0, 0, 0.8)", this.setSVGDimensions(), t.dom.elLegendForeign = document.createElementNS(t.SVGNS, "foreignObject"), m.setAttrs(t.dom.elLegendForeign, {
                    x: 0,
                    y: 0,
                    width: t.svgWidth,
                    height: t.svgHeight
                }), t.dom.elLegendWrap = document.createElement("div"), t.dom.elLegendWrap.classList.add("apexcharts-legend"), t.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), t.dom.elLegendForeign.appendChild(t.dom.elLegendWrap), t.dom.Paper.node.appendChild(t.dom.elLegendForeign), t.dom.elGraphical = t.dom.Paper.group().attr({
                    class: "apexcharts-inner apexcharts-graphical"
                }), t.dom.elDefs = t.dom.Paper.defs(), t.dom.Paper.add(t.dom.elGraphical), t.dom.elGraphical.add(t.dom.elDefs);
            }
        },
        {
            key: "plotChartType",
            value: function(t, e) {
                var i = this.w, a = i.config, s = i.globals, r = {
                    series: [],
                    i: []
                }, o = {
                    series: [],
                    i: []
                }, n = {
                    series: [],
                    i: []
                }, l = {
                    series: [],
                    i: []
                }, h = {
                    series: [],
                    i: []
                }, c = {
                    series: [],
                    i: []
                }, d = {
                    series: [],
                    i: []
                }, g = {
                    series: [],
                    i: []
                }, u = {
                    series: [],
                    seriesRangeEnd: [],
                    i: []
                };
                s.series.map(function(e, p) {
                    var f = 0;
                    void 0 !== t[p].type ? ("column" === t[p].type || "bar" === t[p].type ? (s.series.length > 1 && a.plotOptions.bar.horizontal && console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"), h.series.push(e), h.i.push(p), f++, i.globals.columnSeries = h.series) : "area" === t[p].type ? (o.series.push(e), o.i.push(p), f++) : "line" === t[p].type ? (r.series.push(e), r.i.push(p), f++) : "scatter" === t[p].type ? (n.series.push(e), n.i.push(p)) : "bubble" === t[p].type ? (l.series.push(e), l.i.push(p), f++) : "candlestick" === t[p].type ? (c.series.push(e), c.i.push(p), f++) : "boxPlot" === t[p].type ? (d.series.push(e), d.i.push(p), f++) : "rangeBar" === t[p].type ? (g.series.push(e), g.i.push(p), f++) : "rangeArea" === t[p].type ? (u.series.push(s.seriesRangeStart[p]), u.seriesRangeEnd.push(s.seriesRangeEnd[p]), u.i.push(p), f++) : console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble/candlestick/boxPlot/rangeBar/rangeArea"), f > 1 && (s.comboCharts = !0)) : (r.series.push(e), r.i.push(p));
                });
                var p = new Ft(this.ctx, e), f = new kt(this.ctx, e);
                this.ctx.pie = new Lt(this.ctx);
                var x = new It(this.ctx);
                this.ctx.rangeBar = new Tt(this.ctx, e);
                var b = new Pt(this.ctx), v = [];
                if (s.comboCharts) {
                    if (o.series.length > 0 && v.push(p.draw(o.series, "area", o.i)), h.series.length > 0) {
                        if (i.config.chart.stacked) {
                            var m = new wt(this.ctx, e);
                            v.push(m.draw(h.series, h.i));
                        } else this.ctx.bar = new yt(this.ctx, e), v.push(this.ctx.bar.draw(h.series, h.i));
                    }
                    if (u.series.length > 0 && v.push(p.draw(u.series, "rangeArea", u.i, u.seriesRangeEnd)), r.series.length > 0 && v.push(p.draw(r.series, "line", r.i)), c.series.length > 0 && v.push(f.draw(c.series, "candlestick", c.i)), d.series.length > 0 && v.push(f.draw(d.series, "boxPlot", d.i)), g.series.length > 0 && v.push(this.ctx.rangeBar.draw(g.series, g.i)), n.series.length > 0) {
                        var y = new Ft(this.ctx, e, !0);
                        v.push(y.draw(n.series, "scatter", n.i));
                    }
                    if (l.series.length > 0) {
                        var w = new Ft(this.ctx, e, !0);
                        v.push(w.draw(l.series, "bubble", l.i));
                    }
                } else switch(a.chart.type){
                    case "line":
                        v = p.draw(s.series, "line");
                        break;
                    case "area":
                        v = p.draw(s.series, "area");
                        break;
                    case "bar":
                        if (a.chart.stacked) v = new wt(this.ctx, e).draw(s.series);
                        else this.ctx.bar = new yt(this.ctx, e), v = this.ctx.bar.draw(s.series);
                        break;
                    case "candlestick":
                        v = new kt(this.ctx, e).draw(s.series, "candlestick");
                        break;
                    case "boxPlot":
                        v = new kt(this.ctx, e).draw(s.series, a.chart.type);
                        break;
                    case "rangeBar":
                        v = this.ctx.rangeBar.draw(s.series);
                        break;
                    case "rangeArea":
                        v = p.draw(s.seriesRangeStart, "rangeArea", void 0, s.seriesRangeEnd);
                        break;
                    case "heatmap":
                        v = new St(this.ctx, e).draw(s.series);
                        break;
                    case "treemap":
                        v = new Dt(this.ctx, e).draw(s.series);
                        break;
                    case "pie":
                    case "donut":
                    case "polarArea":
                        v = this.ctx.pie.draw(s.series);
                        break;
                    case "radialBar":
                        v = x.draw(s.series);
                        break;
                    case "radar":
                        v = b.draw(s.series);
                        break;
                    default:
                        v = p.draw(s.series);
                }
                return v;
            }
        },
        {
            key: "setSVGDimensions",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.svgWidth = e.chart.width, t.svgHeight = e.chart.height;
                var i = x.getDimensions(this.el), a = e.chart.width.toString().split(/[0-9]+/g).pop();
                "%" === a ? x.isNumber(i[0]) && (0 === i[0].width && (i = x.getDimensions(this.el.parentNode)), t.svgWidth = i[0] * parseInt(e.chart.width, 10) / 100) : "px" !== a && "" !== a || (t.svgWidth = parseInt(e.chart.width, 10));
                var s = e.chart.height.toString().split(/[0-9]+/g).pop();
                if ("auto" !== t.svgHeight && "" !== t.svgHeight) {
                    if ("%" === s) {
                        var r = x.getDimensions(this.el.parentNode);
                        t.svgHeight = r[1] * parseInt(e.chart.height, 10) / 100;
                    } else t.svgHeight = parseInt(e.chart.height, 10);
                } else t.axisCharts ? t.svgHeight = t.svgWidth / 1.61 : t.svgHeight = t.svgWidth / 1.2;
                if (t.svgWidth < 0 && (t.svgWidth = 0), t.svgHeight < 0 && (t.svgHeight = 0), m.setAttrs(t.dom.Paper.node, {
                    width: t.svgWidth,
                    height: t.svgHeight
                }), "%" !== s) {
                    var o = e.chart.sparkline.enabled ? 0 : t.axisCharts ? e.chart.parentHeightOffset : 0;
                    t.dom.Paper.node.parentNode.parentNode.style.minHeight = t.svgHeight + o + "px";
                }
                t.dom.elWrap.style.width = t.svgWidth + "px", t.dom.elWrap.style.height = t.svgHeight + "px";
            }
        },
        {
            key: "shiftGraphPosition",
            value: function() {
                var t = this.w.globals, e = t.translateY, i = {
                    transform: "translate(" + t.translateX + ", " + e + ")"
                };
                m.setAttrs(t.dom.elGraphical.node, i);
            }
        },
        {
            key: "resizeNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = 0, a = t.config.chart.sparkline.enabled ? 1 : 15;
                a += t.config.grid.padding.bottom, "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || !t.config.legend.show || t.config.legend.floating || (i = new lt(this.ctx).legendHelpers.getLegendBBox().clwh + 10);
                var s = t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * t.globals.radialSize;
                if (s && !t.config.chart.sparkline.enabled && 0 !== t.config.plotOptions.radialBar.startAngle) {
                    var o = x.getBoundingClientRect(s);
                    r = o.bottom;
                    var n = o.bottom - o.top;
                    r = Math.max(2.05 * t.globals.radialSize, n);
                }
                var l = r + e.translateY + i + a;
                e.dom.elLegendForeign && e.dom.elLegendForeign.setAttribute("height", l), t.config.chart.height && String(t.config.chart.height).indexOf("%") > 0 || (e.dom.elWrap.style.height = l + "px", m.setAttrs(e.dom.Paper.node, {
                    height: l
                }), e.dom.Paper.node.parentNode.parentNode.style.minHeight = l + "px");
            }
        },
        {
            key: "coreCalculations",
            value: function() {
                new U(this.ctx).init();
            }
        },
        {
            key: "resetGlobals",
            value: function() {
                var t = this, e = function() {
                    return t.w.config.series.map(function(t) {
                        return [];
                    });
                }, i = new Y, a = this.w.globals;
                i.initGlobalVars(a), a.seriesXvalues = e(), a.seriesYvalues = e();
            }
        },
        {
            key: "isMultipleY",
            value: function() {
                if (this.w.config.yaxis.constructor === Array && this.w.config.yaxis.length > 1) return this.w.globals.isMultipleYAxis = !0, !0;
            }
        },
        {
            key: "xySettings",
            value: function() {
                var t = null, e = this.w;
                if (e.globals.axisCharts) {
                    if ("back" === e.config.xaxis.crosshairs.position) new Q(this.ctx).drawXCrosshairs();
                    if ("back" === e.config.yaxis[0].crosshairs.position) new Q(this.ctx).drawYCrosshairs();
                    if ("datetime" === e.config.xaxis.type && void 0 === e.config.xaxis.labels.formatter) {
                        this.ctx.timeScale = new Nt(this.ctx);
                        var i = [];
                        isFinite(e.globals.minX) && isFinite(e.globals.maxX) && !e.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX, e.globals.maxX) : e.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY, e.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                    }
                    t = new y(this.ctx).getCalculatedRatios();
                }
                return t;
            }
        },
        {
            key: "updateSourceChart",
            value: function(t) {
                this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                    chart: {
                        selection: {
                            xaxis: {
                                min: t.w.globals.minX,
                                max: t.w.globals.maxX
                            }
                        }
                    }
                }, !1, !1);
            }
        },
        {
            key: "setupBrushHandler",
            value: function() {
                var t = this, i = this.w;
                if (i.config.chart.brush.enabled && "function" != typeof i.config.chart.events.selection) {
                    var a = Array.isArray(i.config.chart.brush.targets) || [
                        i.config.chart.brush.target
                    ];
                    a.forEach(function(e) {
                        var i = ApexCharts.getChartByID(e);
                        i.w.globals.brushSource = t.ctx, "function" != typeof i.w.config.chart.events.zoomed && (i.w.config.chart.events.zoomed = function() {
                            t.updateSourceChart(i);
                        }), "function" != typeof i.w.config.chart.events.scrolled && (i.w.config.chart.events.scrolled = function() {
                            t.updateSourceChart(i);
                        });
                    }), i.config.chart.events.selection = function(t, s) {
                        a.forEach(function(t) {
                            var a = ApexCharts.getChartByID(t), r = x.clone(i.config.yaxis);
                            if (i.config.chart.brush.autoScaleYaxis && 1 === a.w.globals.series.length) {
                                var o = new _(a);
                                r = o.autoScaleY(a, r, s);
                            }
                            var n = a.w.config.yaxis.reduce(function(t, i, s) {
                                return [].concat(u(t), [
                                    e(e({}, a.w.config.yaxis[s]), {}, {
                                        min: r[0].min,
                                        max: r[0].max
                                    })
                                ]);
                            }, []);
                            a.ctx.updateHelpers._updateOptions({
                                xaxis: {
                                    min: s.xaxis.min,
                                    max: s.xaxis.max
                                },
                                yaxis: n
                            }, !1, !1, !1, !1);
                        });
                    };
                }
            }
        }
    ]), t;
}(), Bt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "_updateOptions",
            value: function(t) {
                var e = this, a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], s = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return new Promise(function(n) {
                    var l = [
                        e.ctx
                    ];
                    r && (l = e.ctx.getSyncedCharts()), e.ctx.w.globals.isExecCalled && (l = [
                        e.ctx
                    ], e.ctx.w.globals.isExecCalled = !1), l.forEach(function(r, h) {
                        var c = r.w;
                        if (c.globals.shouldAnimate = s, a || (c.globals.resized = !0, c.globals.dataChanged = !0, s && r.series.getPreviousPaths()), t && "object" === i(t) && (r.config = new E(t), t = y.extendArrayProps(r.config, t, c), r.w.globals.chartID !== e.ctx.w.globals.chartID && delete t.series, c.config = x.extend(c.config, t), o && (c.globals.lastXAxis = t.xaxis ? x.clone(t.xaxis) : [], c.globals.lastYAxis = t.yaxis ? x.clone(t.yaxis) : [], c.globals.initialConfig = x.extend({}, c.config), c.globals.initialSeries = x.clone(c.config.series), t.series))) {
                            for(var d = 0; d < c.globals.collapsedSeriesIndices.length; d++){
                                var g = c.config.series[c.globals.collapsedSeriesIndices[d]];
                                c.globals.collapsedSeries[d].data = c.globals.axisCharts ? g.data.slice() : g;
                            }
                            for(var u = 0; u < c.globals.ancillaryCollapsedSeriesIndices.length; u++){
                                var p = c.config.series[c.globals.ancillaryCollapsedSeriesIndices[u]];
                                c.globals.ancillaryCollapsedSeries[u].data = c.globals.axisCharts ? p.data.slice() : p;
                            }
                            r.series.emptyCollapsedSeries(c.config.series);
                        }
                        return r.update(t).then(function() {
                            h === l.length - 1 && n(r);
                        });
                    });
                });
            }
        },
        {
            key: "_updateSeries",
            value: function(t, e) {
                var i = this, a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise(function(s) {
                    var r, o = i.w;
                    return o.globals.shouldAnimate = e, o.globals.dataChanged = !0, e && i.ctx.series.getPreviousPaths(), o.globals.axisCharts ? (0 === (r = t.map(function(t, e) {
                        return i._extendSeries(t, e);
                    })).length && (r = [
                        {
                            data: []
                        }
                    ]), o.config.series = r) : o.config.series = t.slice(), a && (o.globals.initialConfig.series = x.clone(o.config.series), o.globals.initialSeries = x.clone(o.config.series)), i.ctx.update().then(function() {
                        s(i.ctx);
                    });
                });
            }
        },
        {
            key: "_extendSeries",
            value: function(t, i) {
                var a = this.w, s = a.config.series[i];
                return e(e({}, a.config.series[i]), {}, {
                    name: t.name ? t.name : null == s ? void 0 : s.name,
                    color: t.color ? t.color : null == s ? void 0 : s.color,
                    type: t.type ? t.type : null == s ? void 0 : s.type,
                    group: t.group ? t.group : null == s ? void 0 : s.group,
                    data: t.data ? t.data : null == s ? void 0 : s.data,
                    zIndex: void 0 !== t.zIndex ? t.zIndex : i
                });
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(t, "']");
                return i.globals.axisCharts ? a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(e, "'], ").concat(s, " circle[j='").concat(e, "'], ").concat(s, " rect[j='").concat(e, "']")).members[0] : void 0 === e && (a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(t, "']")).members[0], "pie" !== i.config.chart.type && "polarArea" !== i.config.chart.type && "donut" !== i.config.chart.type || this.ctx.pie.pieClicked(t)), a ? (new m(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
            }
        },
        {
            key: "forceXAxisUpdate",
            value: function(t) {
                var e = this.w;
                if ([
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== t.xaxis[i] && (e.config.xaxis[i] = t.xaxis[i], e.globals.lastXAxis[i] = t.xaxis[i]);
                }), t.xaxis.categories && t.xaxis.categories.length && (e.config.xaxis.categories = t.xaxis.categories), e.config.xaxis.convertedCatToNumeric) {
                    var i = new X(t);
                    t = i.convertCatToNumericXaxis(t, this.ctx);
                }
                return t;
            }
        },
        {
            key: "forceYAxisUpdate",
            value: function(t) {
                return t.chart && t.chart.stacked && "100%" === t.chart.stackType && (Array.isArray(t.yaxis) ? t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }) : (t.yaxis.min = 0, t.yaxis.max = 100)), t;
            }
        },
        {
            key: "revertDefaultAxisMinMax",
            value: function(t) {
                var e = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                t && t.xaxis && (a = t.xaxis), t && t.yaxis && (s = t.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                var r = function(t) {
                    void 0 !== s[t] && (i.config.yaxis[t].min = s[t].min, i.config.yaxis[t].max = s[t].max);
                };
                i.config.yaxis.map(function(t, a) {
                    i.globals.zoomed || void 0 !== s[a] ? r(a) : void 0 !== e.ctx.opts.yaxis[a] && (t.min = e.ctx.opts.yaxis[a].min, t.max = e.ctx.opts.yaxis[a].max);
                });
            }
        }
    ]), t;
}();
Rt = "undefined" != typeof window ? window : void 0, Ht = function(t, e) {
    var a = (void 0 !== this ? this : t).SVG = function(t) {
        if (a.supported) return t = new a.Doc(t), a.parser.draw || a.prepare(), t;
    };
    if (a.ns = "http://www.w3.org/2000/svg", a.xmlns = "http://www.w3.org/2000/xmlns/", a.xlink = "http://www.w3.org/1999/xlink", a.svgjs = "http://svgjs.dev", a.supported = !0, !a.supported) return !1;
    a.did = 1e3, a.eid = function(t) {
        return "Svgjs" + d(t) + a.did++;
    }, a.create = function(t) {
        var i = e.createElementNS(this.ns, t);
        return i.setAttribute("id", this.eid(t)), i;
    }, a.extend = function() {
        var t, e;
        e = (t = [].slice.call(arguments)).pop();
        for(var i = t.length - 1; i >= 0; i--)if (t[i]) for(var s in e)t[i].prototype[s] = e[s];
        a.Set && a.Set.inherit && a.Set.inherit();
    }, a.invent = function(t) {
        var e = "function" == typeof t.create ? t.create : function() {
            this.constructor.call(this, a.create(t.create));
        };
        return t.inherit && (e.prototype = new t.inherit), t.extend && a.extend(e, t.extend), t.construct && a.extend(t.parent || a.Container, t.construct), e;
    }, a.adopt = function(e) {
        var i;
        return e ? e.instance ? e.instance : ((i = "svg" == e.nodeName ? e.parentNode instanceof t.SVGElement ? new a.Nested : new a.Doc : "linearGradient" == e.nodeName ? new a.Gradient("linear") : "radialGradient" == e.nodeName ? new a.Gradient("radial") : a[d(e.nodeName)] ? new a[d(e.nodeName)] : new a.Element(e)).type = e.nodeName, i.node = e, e.instance = i, i instanceof a.Doc && i.namespace().defs(), i.setData(JSON.parse(e.getAttribute("svgjs:data")) || {}), i) : null;
    }, a.prepare = function() {
        var t = e.getElementsByTagName("body")[0], i = (t ? new a.Doc(t) : a.adopt(e.documentElement).nested()).size(2, 0);
        a.parser = {
            body: t || e.documentElement,
            draw: i.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
            poly: i.polyline().node,
            path: i.path().node,
            native: a.create("svg")
        };
    }, a.parser = {
        native: a.create("svg")
    }, e.addEventListener("DOMContentLoaded", function() {
        a.parser.draw || a.prepare();
    }, !1), a.regex = {
        numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
        hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /rgb\((\d+),(\d+),(\d+)\)/,
        reference: /#([a-z0-9\-_]+)/i,
        transforms: /\)\s*,?\s*/,
        whitespace: /\s/g,
        isHex: /^#[a-f0-9]{3,6}$/i,
        isRgb: /^rgb\(/,
        isCss: /[^:]+:[^;]+;?/,
        isBlank: /^(\s+)?$/,
        isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
        isPercent: /^-?[\d\.]+%$/,
        isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
        delimiter: /[\s,]+/,
        hyphen: /([^e])\-/gi,
        pathLetters: /[MLHVCSQTAZ]/gi,
        isPathLetter: /[MLHVCSQTAZ]/i,
        numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
        dots: /\./g
    }, a.utils = {
        map: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)a.push(e(t[s]));
            return a;
        },
        filter: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)e(t[s]) && a.push(t[s]);
            return a;
        },
        filterSVGElements: function(e) {
            return this.filter(e, function(e) {
                return e instanceof t.SVGElement;
            });
        }
    }, a.defaults = {
        attrs: {
            "fill-opacity": 1,
            "stroke-opacity": 1,
            "stroke-width": 0,
            "stroke-linejoin": "miter",
            "stroke-linecap": "butt",
            fill: "#000000",
            stroke: "#000000",
            opacity: 1,
            x: 0,
            y: 0,
            cx: 0,
            cy: 0,
            width: 0,
            height: 0,
            r: 0,
            rx: 0,
            ry: 0,
            offset: 0,
            "stop-opacity": 1,
            "stop-color": "#000000",
            "font-size": 16,
            "font-family": "Helvetica, Arial, sans-serif",
            "text-anchor": "start"
        }
    }, a.Color = function(t) {
        var e, s;
        this.r = 0, this.g = 0, this.b = 0, t && ("string" == typeof t ? a.regex.isRgb.test(t) ? (e = a.regex.rgb.exec(t.replace(a.regex.whitespace, "")), this.r = parseInt(e[1]), this.g = parseInt(e[2]), this.b = parseInt(e[3])) : a.regex.isHex.test(t) && (e = a.regex.hex.exec(4 == (s = t).length ? [
            "#",
            s.substring(1, 2),
            s.substring(1, 2),
            s.substring(2, 3),
            s.substring(2, 3),
            s.substring(3, 4),
            s.substring(3, 4)
        ].join("") : s), this.r = parseInt(e[1], 16), this.g = parseInt(e[2], 16), this.b = parseInt(e[3], 16)) : "object" === i(t) && (this.r = t.r, this.g = t.g, this.b = t.b));
    }, a.extend(a.Color, {
        toString: function() {
            return this.toHex();
        },
        toHex: function() {
            return "#" + g(this.r) + g(this.g) + g(this.b);
        },
        toRgb: function() {
            return "rgb(" + [
                this.r,
                this.g,
                this.b
            ].join() + ")";
        },
        brightness: function() {
            return this.r / 255 * .3 + this.g / 255 * .59 + this.b / 255 * .11;
        },
        morph: function(t) {
            return this.destination = new a.Color(t), this;
        },
        at: function(t) {
            return this.destination ? (t = t < 0 ? 0 : t > 1 ? 1 : t, new a.Color({
                r: ~~(this.r + (this.destination.r - this.r) * t),
                g: ~~(this.g + (this.destination.g - this.g) * t),
                b: ~~(this.b + (this.destination.b - this.b) * t)
            })) : this;
        }
    }), a.Color.test = function(t) {
        return t += "", a.regex.isHex.test(t) || a.regex.isRgb.test(t);
    }, a.Color.isRgb = function(t) {
        return t && "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b;
    }, a.Color.isColor = function(t) {
        return a.Color.isRgb(t) || a.Color.test(t);
    }, a.Array = function(t, e) {
        0 == (t = (t || []).valueOf()).length && e && (t = e.valueOf()), this.value = this.parse(t);
    }, a.extend(a.Array, {
        toString: function() {
            return this.value.join(" ");
        },
        valueOf: function() {
            return this.value;
        },
        parse: function(t) {
            return t = t.valueOf(), Array.isArray(t) ? t : this.split(t);
        }
    }), a.PointArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                0,
                0
            ]
        ]);
    }, a.PointArray.prototype = new a.Array, a.PointArray.prototype.constructor = a.PointArray;
    for(var s = {
        M: function(t, e, i) {
            return e.x = i.x = t[0], e.y = i.y = t[1], [
                "M",
                e.x,
                e.y
            ];
        },
        L: function(t, e) {
            return e.x = t[0], e.y = t[1], [
                "L",
                t[0],
                t[1]
            ];
        },
        H: function(t, e) {
            return e.x = t[0], [
                "H",
                t[0]
            ];
        },
        V: function(t, e) {
            return e.y = t[0], [
                "V",
                t[0]
            ];
        },
        C: function(t, e) {
            return e.x = t[4], e.y = t[5], [
                "C",
                t[0],
                t[1],
                t[2],
                t[3],
                t[4],
                t[5]
            ];
        },
        Q: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "Q",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        S: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "S",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        Z: function(t, e, i) {
            return e.x = i.x, e.y = i.y, [
                "Z"
            ];
        }
    }, r = "mlhvqtcsaz".split(""), o = 0, n = r.length; o < n; ++o)s[r[o]] = function(t) {
        return function(e, i, a) {
            if ("H" == t) e[0] = e[0] + i.x;
            else if ("V" == t) e[0] = e[0] + i.y;
            else if ("A" == t) e[5] = e[5] + i.x, e[6] = e[6] + i.y;
            else for(var r = 0, o = e.length; r < o; ++r)e[r] = e[r] + (r % 2 ? i.y : i.x);
            if (s && "function" == typeof s[t]) return s[t](e, i, a);
        };
    }(r[o].toUpperCase());
    a.PathArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                "M",
                0,
                0
            ]
        ]);
    }, a.PathArray.prototype = new a.Array, a.PathArray.prototype.constructor = a.PathArray, a.extend(a.PathArray, {
        toString: function() {
            return function(t) {
                for(var e = 0, i = t.length, a = ""; e < i; e++)a += t[e][0], null != t[e][1] && (a += t[e][1], null != t[e][2] && (a += " ", a += t[e][2], null != t[e][3] && (a += " ", a += t[e][3], a += " ", a += t[e][4], null != t[e][5] && (a += " ", a += t[e][5], a += " ", a += t[e][6], null != t[e][7] && (a += " ", a += t[e][7])))));
                return a + " ";
            }(this.value);
        },
        move: function(t, e) {
            var i = this.bbox();
            return i.x, i.y, this;
        },
        at: function(t) {
            if (!this.destination) return this;
            for(var e = this.value, i = this.destination.value, s = [], r = new a.PathArray, o = 0, n = e.length; o < n; o++){
                s[o] = [
                    e[o][0]
                ];
                for(var l = 1, h = e[o].length; l < h; l++)s[o][l] = e[o][l] + (i[o][l] - e[o][l]) * t;
                "A" === s[o][0] && (s[o][4] = +(0 != s[o][4]), s[o][5] = +(0 != s[o][5]));
            }
            return r.value = s, r;
        },
        parse: function(t) {
            if (t instanceof a.PathArray) return t.valueOf();
            var e, i = {
                M: 2,
                L: 2,
                H: 1,
                V: 1,
                C: 6,
                S: 4,
                Q: 4,
                T: 2,
                A: 7,
                Z: 0
            };
            t = "string" == typeof t ? t.replace(a.regex.numbersWithDots, h).replace(a.regex.pathLetters, " $& ").replace(a.regex.hyphen, "$1 -").trim().split(a.regex.delimiter) : t.reduce(function(t, e) {
                return [].concat.call(t, e);
            }, []);
            var r = [], o = new a.Point, n = new a.Point, l = 0, c = t.length;
            do a.regex.isPathLetter.test(t[l]) ? (e = t[l], ++l) : "M" == e ? e = "L" : "m" == e && (e = "l"), r.push(s[e].call(null, t.slice(l, l += i[e.toUpperCase()]).map(parseFloat), o, n));
            while (c > l);
            return r;
        },
        bbox: function() {
            return a.parser.draw || a.prepare(), a.parser.path.setAttribute("d", this.toString()), a.parser.path.getBBox();
        }
    }), a.Number = a.invent({
        create: function(t, e) {
            this.value = 0, this.unit = e || "", "number" == typeof t ? this.value = isNaN(t) ? 0 : isFinite(t) ? t : t < 0 ? -340000000000000000000000000000000000000 : 34e37 : "string" == typeof t ? (e = t.match(a.regex.numberAndUnit)) && (this.value = parseFloat(e[1]), "%" == e[5] ? this.value /= 100 : "s" == e[5] && (this.value *= 1e3), this.unit = e[5]) : t instanceof a.Number && (this.value = t.valueOf(), this.unit = t.unit);
        },
        extend: {
            toString: function() {
                return ("%" == this.unit ? ~~(1e8 * this.value) / 1e6 : "s" == this.unit ? this.value / 1e3 : this.value) + this.unit;
            },
            toJSON: function() {
                return this.toString();
            },
            valueOf: function() {
                return this.value;
            },
            plus: function(t) {
                return t = new a.Number(t), new a.Number(this + t, this.unit || t.unit);
            },
            minus: function(t) {
                return t = new a.Number(t), new a.Number(this - t, this.unit || t.unit);
            },
            times: function(t) {
                return t = new a.Number(t), new a.Number(this * t, this.unit || t.unit);
            },
            divide: function(t) {
                return t = new a.Number(t), new a.Number(this / t, this.unit || t.unit);
            },
            to: function(t) {
                var e = new a.Number(this);
                return "string" == typeof t && (e.unit = t), e;
            },
            morph: function(t) {
                return this.destination = new a.Number(t), t.relative && (this.destination.value += this.value), this;
            },
            at: function(t) {
                return this.destination ? new a.Number(this.destination).minus(this).times(t).plus(this) : this;
            }
        }
    }), a.Element = a.invent({
        create: function(t) {
            this._stroke = a.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = t) && (this.type = t.nodeName, this.node.instance = this, this._stroke = t.getAttribute("stroke") || this._stroke);
        },
        extend: {
            x: function(t) {
                return this.attr("x", t);
            },
            y: function(t) {
                return this.attr("y", t);
            },
            cx: function(t) {
                return null == t ? this.x() + this.width() / 2 : this.x(t - this.width() / 2);
            },
            cy: function(t) {
                return null == t ? this.y() + this.height() / 2 : this.y(t - this.height() / 2);
            },
            move: function(t, e) {
                return this.x(t).y(e);
            },
            center: function(t, e) {
                return this.cx(t).cy(e);
            },
            width: function(t) {
                return this.attr("width", t);
            },
            height: function(t) {
                return this.attr("height", t);
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.width(new a.Number(i.width)).height(new a.Number(i.height));
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = x(this.node.cloneNode(!0));
                return t ? t.add(e) : this.after(e), e;
            },
            remove: function() {
                return this.parent() && this.parent().removeElement(this), this;
            },
            replace: function(t) {
                return this.after(t).remove(), t;
            },
            addTo: function(t) {
                return t.put(this);
            },
            putIn: function(t) {
                return t.add(this);
            },
            id: function(t) {
                return this.attr("id", t);
            },
            show: function() {
                return this.style("display", "");
            },
            hide: function() {
                return this.style("display", "none");
            },
            visible: function() {
                return "none" != this.style("display");
            },
            toString: function() {
                return this.attr("id");
            },
            classes: function() {
                var t = this.attr("class");
                return null == t ? [] : t.trim().split(a.regex.delimiter);
            },
            hasClass: function(t) {
                return -1 != this.classes().indexOf(t);
            },
            addClass: function(t) {
                if (!this.hasClass(t)) {
                    var e = this.classes();
                    e.push(t), this.attr("class", e.join(" "));
                }
                return this;
            },
            removeClass: function(t) {
                return this.hasClass(t) && this.attr("class", this.classes().filter(function(e) {
                    return e != t;
                }).join(" ")), this;
            },
            toggleClass: function(t) {
                return this.hasClass(t) ? this.removeClass(t) : this.addClass(t);
            },
            reference: function(t) {
                return a.get(this.attr(t));
            },
            parent: function(e) {
                var i = this;
                if (!i.node.parentNode) return null;
                if (i = a.adopt(i.node.parentNode), !e) return i;
                for(; i && i.node instanceof t.SVGElement;){
                    if ("string" == typeof e ? i.matches(e) : i instanceof e) return i;
                    if (!i.node.parentNode || "#document" == i.node.parentNode.nodeName) return null;
                    i = a.adopt(i.node.parentNode);
                }
            },
            doc: function() {
                return this instanceof a.Doc ? this : this.parent(a.Doc);
            },
            parents: function(t) {
                var e = [], i = this;
                do {
                    if (!(i = i.parent(t)) || !i.node) break;
                    e.push(i);
                }while (i.parent);
                return e;
            },
            matches: function(t) {
                return function(t, e) {
                    return (t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector).call(t, e);
                }(this.node, t);
            },
            native: function() {
                return this.node;
            },
            svg: function(t) {
                var i = e.createElement("svg");
                if (!(t && this instanceof a.Parent)) return i.appendChild(t = e.createElement("svg")), this.writeDataToDom(), t.appendChild(this.node.cloneNode(!0)), i.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                i.innerHTML = "<svg>" + t.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                for(var s = 0, r = i.firstChild.childNodes.length; s < r; s++)this.node.appendChild(i.firstChild.firstChild);
                return this;
            },
            writeDataToDom: function() {
                return (this.each || this.lines) && (this.each ? this : this.lines()).each(function() {
                    this.writeDataToDom();
                }), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this;
            },
            setData: function(t) {
                return this.dom = t, this;
            },
            is: function(t) {
                return function(t, e) {
                    return t instanceof e;
                }(this, t);
            }
        }
    }), a.easing = {
        "-": function(t) {
            return t;
        },
        "<>": function(t) {
            return -Math.cos(t * Math.PI) / 2 + .5;
        },
        ">": function(t) {
            return Math.sin(t * Math.PI / 2);
        },
        "<": function(t) {
            return 1 - Math.cos(t * Math.PI / 2);
        }
    }, a.morph = function(t) {
        return function(e, i) {
            return new a.MorphObj(e, i).at(t);
        };
    }, a.Situation = a.invent({
        create: function(t) {
            this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new a.Number(t.duration).valueOf(), this.delay = new a.Number(t.delay).valueOf(), this.start = +new Date + this.delay, this.finish = this.start + this.duration, this.ease = t.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {};
        }
    }), a.FX = a.invent({
        create: function(t) {
            this._target = t, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1;
        },
        extend: {
            animate: function(t, e, s) {
                "object" === i(t) && (e = t.ease, s = t.delay, t = t.duration);
                var r = new a.Situation({
                    duration: t || 1e3,
                    delay: s || 0,
                    ease: a.easing[e || "-"] || e
                });
                return this.queue(r), this;
            },
            target: function(t) {
                return t && t instanceof a.Element ? (this._target = t, this) : this._target;
            },
            timeToAbsPos: function(t) {
                return (t - this.situation.start) / (this.situation.duration / this._speed);
            },
            absPosToTime: function(t) {
                return this.situation.duration / this._speed * t + this.situation.start;
            },
            startAnimFrame: function() {
                this.stopAnimFrame(), this.animationFrame = t.requestAnimationFrame((function() {
                    this.step();
                }).bind(this));
            },
            stopAnimFrame: function() {
                t.cancelAnimationFrame(this.animationFrame);
            },
            start: function() {
                return !this.active && this.situation && (this.active = !0, this.startCurrent()), this;
            },
            startCurrent: function() {
                return this.situation.start = +new Date + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step();
            },
            queue: function(t) {
                return ("function" == typeof t || t instanceof a.Situation) && this.situations.push(t), this.situation || (this.situation = this.situations.shift()), this;
            },
            dequeue: function() {
                return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof a.Situation ? this.start() : this.situation.call(this)), this;
            },
            initAnimations: function() {
                var t, e = this.situation;
                if (e.init) return this;
                for(var i in e.animations){
                    t = this.target()[i](), Array.isArray(t) || (t = [
                        t
                    ]), Array.isArray(e.animations[i]) || (e.animations[i] = [
                        e.animations[i]
                    ]);
                    for(var s = t.length; s--;)e.animations[i][s] instanceof a.Number && (t[s] = new a.Number(t[s])), e.animations[i][s] = t[s].morph(e.animations[i][s]);
                }
                for(var i in e.attrs)e.attrs[i] = new a.MorphObj(this.target().attr(i), e.attrs[i]);
                for(var i in e.styles)e.styles[i] = new a.MorphObj(this.target().style(i), e.styles[i]);
                return e.initialTransformation = this.target().matrixify(), e.init = !0, this;
            },
            clearQueue: function() {
                return this.situations = [], this;
            },
            clearCurrent: function() {
                return this.situation = null, this;
            },
            stop: function(t, e) {
                var i = this.active;
                return this.active = !1, e && this.clearQueue(), t && this.situation && (!i && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent();
            },
            after: function(t) {
                var e = this.last();
                return this.target().on("finished.fx", function i(a) {
                    a.detail.situation == e && (t.call(this, e), this.off("finished.fx", i));
                }), this._callStart();
            },
            during: function(t) {
                var e = this.last(), i = function(i) {
                    i.detail.situation == e && t.call(this, i.detail.pos, a.morph(i.detail.pos), i.detail.eased, e);
                };
                return this.target().off("during.fx", i).on("during.fx", i), this.after(function() {
                    this.off("during.fx", i);
                }), this._callStart();
            },
            afterAll: function(t) {
                var e = function e(i) {
                    t.call(this), this.off("allfinished.fx", e);
                };
                return this.target().off("allfinished.fx", e).on("allfinished.fx", e), this._callStart();
            },
            last: function() {
                return this.situations.length ? this.situations[this.situations.length - 1] : this.situation;
            },
            add: function(t, e, i) {
                return this.last()[i || "animations"][t] = e, this._callStart();
            },
            step: function(t) {
                var e, i, a;
                t || (this.absPos = this.timeToAbsPos(+new Date)), !1 !== this.situation.loops ? (e = Math.max(this.absPos, 0), i = Math.floor(e), !0 === this.situation.loops || i < this.situation.loops ? (this.pos = e - i, a = this.situation.loop, this.situation.loop = i) : (this.absPos = this.situation.loops, this.pos = 1, a = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - a) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                var s = this.situation.ease(this.pos);
                for(var r in this.situation.once)r > this.lastPos && r <= s && (this.situation.once[r].call(this.target(), this.pos, s), delete this.situation.once[r]);
                return this.active && this.target().fire("during", {
                    pos: this.pos,
                    eased: s,
                    fx: this,
                    situation: this.situation
                }), this.situation ? (this.eachAt(), 1 == this.pos && !this.situation.reversed || this.situation.reversed && 0 == this.pos ? (this.stopAnimFrame(), this.target().fire("finished", {
                    fx: this,
                    situation: this.situation
                }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = s, this) : this;
            },
            eachAt: function() {
                var t, e = this, i = this.target(), s = this.situation;
                for(var r in s.animations)t = [].concat(s.animations[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i[r].apply(i, t);
                for(var r in s.attrs)t = [
                    r
                ].concat(s.attrs[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.attr.apply(i, t);
                for(var r in s.styles)t = [
                    r
                ].concat(s.styles[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.style.apply(i, t);
                if (s.transforms.length) {
                    t = s.initialTransformation, r = 0;
                    for(var o = s.transforms.length; r < o; r++){
                        var n = s.transforms[r];
                        n instanceof a.Matrix ? t = n.relative ? t.multiply((new a.Matrix).morph(n).at(s.ease(this.pos))) : t.morph(n).at(s.ease(this.pos)) : (n.relative || n.undo(t.extract()), t = t.multiply(n.at(s.ease(this.pos))));
                    }
                    i.matrix(t);
                }
                return this;
            },
            once: function(t, e, i) {
                var a = this.last();
                return i || (t = a.ease(t)), a.once[t] = e, this;
            },
            _callStart: function() {
                return setTimeout((function() {
                    this.start();
                }).bind(this), 0), this;
            }
        },
        parent: a.Element,
        construct: {
            animate: function(t, e, i) {
                return (this.fx || (this.fx = new a.FX(this))).animate(t, e, i);
            },
            delay: function(t) {
                return (this.fx || (this.fx = new a.FX(this))).delay(t);
            },
            stop: function(t, e) {
                return this.fx && this.fx.stop(t, e), this;
            },
            finish: function() {
                return this.fx && this.fx.finish(), this;
            }
        }
    }), a.MorphObj = a.invent({
        create: function(t, e) {
            return a.Color.isColor(e) ? new a.Color(t).morph(e) : a.regex.delimiter.test(t) ? a.regex.pathLetters.test(t) ? new a.PathArray(t).morph(e) : new a.Array(t).morph(e) : a.regex.numberAndUnit.test(e) ? new a.Number(t).morph(e) : (this.value = t, void (this.destination = e));
        },
        extend: {
            at: function(t, e) {
                return e < 1 ? this.value : this.destination;
            },
            valueOf: function() {
                return this.value;
            }
        }
    }), a.extend(a.FX, {
        attr: function(t, e, a) {
            if ("object" === i(t)) for(var s in t)this.attr(s, t[s]);
            else this.add(t, e, "attrs");
            return this;
        },
        plot: function(t, e, i, a) {
            return 4 == arguments.length ? this.plot([
                t,
                e,
                i,
                a
            ]) : this.add("plot", new (this.target()).morphArray(t));
        }
    }), a.Box = a.invent({
        create: function(t, e, s, r) {
            if (!("object" !== i(t) || t instanceof a.Element)) return a.Box.call(this, null != t.left ? t.left : t.x, null != t.top ? t.top : t.y, t.width, t.height);
            var o;
            4 == arguments.length && (this.x = t, this.y = e, this.width = s, this.height = r), null == (o = this).x && (o.x = 0, o.y = 0, o.width = 0, o.height = 0), o.w = o.width, o.h = o.height, o.x2 = o.x + o.width, o.y2 = o.y + o.height, o.cx = o.x + o.width / 2, o.cy = o.y + o.height / 2;
        }
    }), a.BBox = a.invent({
        create: function(t) {
            if (a.Box.apply(this, [].slice.call(arguments)), t instanceof a.Element) {
                var i;
                try {
                    if (!e.documentElement.contains) {
                        for(var s = t.node; s.parentNode;)s = s.parentNode;
                        if (s != e) throw new Error("Element not in the dom");
                    }
                    i = t.node.getBBox();
                } catch (e) {
                    if (t instanceof a.Shape) {
                        a.parser.draw || a.prepare();
                        var r = t.clone(a.parser.draw.instance).show();
                        r && r.node && "function" == typeof r.node.getBBox && (i = r.node.getBBox()), r && "function" == typeof r.remove && r.remove();
                    } else i = {
                        x: t.node.clientLeft,
                        y: t.node.clientTop,
                        width: t.node.clientWidth,
                        height: t.node.clientHeight
                    };
                }
                a.Box.call(this, i);
            }
        },
        inherit: a.Box,
        parent: a.Element,
        construct: {
            bbox: function() {
                return new a.BBox(this);
            }
        }
    }), a.BBox.prototype.constructor = a.BBox, a.Matrix = a.invent({
        create: function(t) {
            var e = f([
                1,
                0,
                0,
                1,
                0,
                0
            ]);
            t = null === t ? e : t instanceof a.Element ? t.matrixify() : "string" == typeof t ? f(t.split(a.regex.delimiter).map(parseFloat)) : 6 == arguments.length ? f([].slice.call(arguments)) : Array.isArray(t) ? f(t) : t && "object" === i(t) ? t : e;
            for(var s = v.length - 1; s >= 0; --s)this[v[s]] = null != t[v[s]] ? t[v[s]] : e[v[s]];
        },
        extend: {
            extract: function() {
                var t = p(this, 0, 1);
                p(this, 1, 0);
                var e = 180 / Math.PI * Math.atan2(t.y, t.x) - 90;
                return {
                    x: this.e,
                    y: this.f,
                    transformedX: (this.e * Math.cos(e * Math.PI / 180) + this.f * Math.sin(e * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                    transformedY: (this.f * Math.cos(e * Math.PI / 180) + this.e * Math.sin(-e * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                    rotation: e,
                    a: this.a,
                    b: this.b,
                    c: this.c,
                    d: this.d,
                    e: this.e,
                    f: this.f,
                    matrix: new a.Matrix(this)
                };
            },
            clone: function() {
                return new a.Matrix(this);
            },
            morph: function(t) {
                return this.destination = new a.Matrix(t), this;
            },
            multiply: function(t) {
                return new a.Matrix(this.native().multiply((function(t) {
                    return t instanceof a.Matrix || (t = new a.Matrix(t)), t;
                })(t).native()));
            },
            inverse: function() {
                return new a.Matrix(this.native().inverse());
            },
            translate: function(t, e) {
                return new a.Matrix(this.native().translate(t || 0, e || 0));
            },
            native: function() {
                for(var t = a.parser.native.createSVGMatrix(), e = v.length - 1; e >= 0; e--)t[v[e]] = this[v[e]];
                return t;
            },
            toString: function() {
                return "matrix(" + b(this.a) + "," + b(this.b) + "," + b(this.c) + "," + b(this.d) + "," + b(this.e) + "," + b(this.f) + ")";
            }
        },
        parent: a.Element,
        construct: {
            ctm: function() {
                return new a.Matrix(this.node.getCTM());
            },
            screenCTM: function() {
                if (this instanceof a.Nested) {
                    var t = this.rect(1, 1), e = t.node.getScreenCTM();
                    return t.remove(), new a.Matrix(e);
                }
                return new a.Matrix(this.node.getScreenCTM());
            }
        }
    }), a.Point = a.invent({
        create: function(t, e) {
            var a;
            a = Array.isArray(t) ? {
                x: t[0],
                y: t[1]
            } : "object" === i(t) ? {
                x: t.x,
                y: t.y
            } : null != t ? {
                x: t,
                y: null != e ? e : t
            } : {
                x: 0,
                y: 0
            }, this.x = a.x, this.y = a.y;
        },
        extend: {
            clone: function() {
                return new a.Point(this);
            },
            morph: function(t, e) {
                return this.destination = new a.Point(t, e), this;
            }
        }
    }), a.extend(a.Element, {
        point: function(t, e) {
            return new a.Point(t, e).transform(this.screenCTM().inverse());
        }
    }), a.extend(a.Element, {
        attr: function(t, e, s) {
            if (null == t) {
                for(t = {}, s = (e = this.node.attributes).length - 1; s >= 0; s--)t[e[s].nodeName] = a.regex.isNumber.test(e[s].nodeValue) ? parseFloat(e[s].nodeValue) : e[s].nodeValue;
                return t;
            }
            if ("object" === i(t)) for(var r in t)this.attr(r, t[r]);
            else if (null === e) this.node.removeAttribute(t);
            else {
                if (null == e) return null == (e = this.node.getAttribute(t)) ? a.defaults.attrs[t] : a.regex.isNumber.test(e) ? parseFloat(e) : e;
                "stroke-width" == t ? this.attr("stroke", parseFloat(e) > 0 ? this._stroke : null) : "stroke" == t && (this._stroke = e), "fill" != t && "stroke" != t || (a.regex.isImage.test(e) && (e = this.doc().defs().image(e, 0, 0)), e instanceof a.Image && (e = this.doc().defs().pattern(0, 0, function() {
                    this.add(e);
                }))), "number" == typeof e ? e = new a.Number(e) : a.Color.isColor(e) ? e = new a.Color(e) : Array.isArray(e) && (e = new a.Array(e)), "leading" == t ? this.leading && this.leading(e) : "string" == typeof s ? this.node.setAttributeNS(s, t, e.toString()) : this.node.setAttribute(t, e.toString()), !this.rebuild || "font-size" != t && "x" != t || this.rebuild(t, e);
            }
            return this;
        }
    }), a.extend(a.Element, {
        transform: function(t, e) {
            var s;
            return "object" !== i(t) ? (s = new a.Matrix(this).extract(), "string" == typeof t ? s[t] : s) : (s = new a.Matrix(this), e = !!e || !!t.relative, null != t.a && (s = e ? s.multiply(new a.Matrix(t)) : new a.Matrix(t)), this.attr("transform", s));
        }
    }), a.extend(a.Element, {
        untransform: function() {
            return this.attr("transform", null);
        },
        matrixify: function() {
            return (this.attr("transform") || "").split(a.regex.transforms).slice(0, -1).map(function(t) {
                var e = t.trim().split("(");
                return [
                    e[0],
                    e[1].split(a.regex.delimiter).map(function(t) {
                        return parseFloat(t);
                    })
                ];
            }).reduce(function(t, e) {
                return "matrix" == e[0] ? t.multiply(f(e[1])) : t[e[0]].apply(t, e[1]);
            }, new a.Matrix);
        },
        toParent: function(t) {
            if (this == t) return this;
            var e = this.screenCTM(), i = t.screenCTM().inverse();
            return this.addTo(t).untransform().transform(i.multiply(e)), this;
        },
        toDoc: function() {
            return this.toParent(this.doc());
        }
    }), a.Transformation = a.invent({
        create: function(t, e) {
            if (arguments.length > 1 && "boolean" != typeof e) return this.constructor.call(this, [].slice.call(arguments));
            if (Array.isArray(t)) for(var a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[a];
            else if (t && "object" === i(t)) for(a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[this.arguments[a]];
            this.inversed = !1, !0 === e && (this.inversed = !0);
        }
    }), a.Translate = a.invent({
        parent: a.Matrix,
        inherit: a.Transformation,
        create: function(t, e) {
            this.constructor.apply(this, [].slice.call(arguments));
        },
        extend: {
            arguments: [
                "transformedX",
                "transformedY"
            ],
            method: "translate"
        }
    }), a.extend(a.Element, {
        style: function(t, e) {
            if (0 == arguments.length) return this.node.style.cssText || "";
            if (arguments.length < 2) {
                if ("object" === i(t)) for(var s in t)this.style(s, t[s]);
                else {
                    if (!a.regex.isCss.test(t)) return this.node.style[c(t)];
                    for(t = t.split(/\s*;\s*/).filter(function(t) {
                        return !!t;
                    }).map(function(t) {
                        return t.split(/\s*:\s*/);
                    }); e = t.pop();)this.style(e[0], e[1]);
                }
            } else this.node.style[c(t)] = null === e || a.regex.isBlank.test(e) ? "" : e;
            return this;
        }
    }), a.Parent = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element,
        extend: {
            children: function() {
                return a.utils.map(a.utils.filterSVGElements(this.node.childNodes), function(t) {
                    return a.adopt(t);
                });
            },
            add: function(t, e) {
                return null == e ? this.node.appendChild(t.node) : t.node != this.node.childNodes[e] && this.node.insertBefore(t.node, this.node.childNodes[e]), this;
            },
            put: function(t, e) {
                return this.add(t, e), t;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return [].slice.call(this.node.childNodes).indexOf(t.node);
            },
            get: function(t) {
                return a.adopt(this.node.childNodes[t]);
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.node.childNodes.length - 1);
            },
            each: function(t, e) {
                for(var i = this.children(), s = 0, r = i.length; s < r; s++)i[s] instanceof a.Element && t.apply(i[s], [
                    s,
                    i
                ]), e && i[s] instanceof a.Container && i[s].each(t, e);
                return this;
            },
            removeElement: function(t) {
                return this.node.removeChild(t.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, this;
            },
            defs: function() {
                return this.doc().defs();
            }
        }
    }), a.extend(a.Parent, {
        ungroup: function(t, e) {
            return 0 === e || this instanceof a.Defs || this.node == a.parser.draw || (t = t || (this instanceof a.Doc ? this : this.parent(a.Parent)), e = e || 1 / 0, this.each(function() {
                return this instanceof a.Defs ? this : this instanceof a.Parent ? this.ungroup(t, e - 1) : this.toParent(t);
            }), this.node.firstChild || this.remove()), this;
        },
        flatten: function(t, e) {
            return this.ungroup(t, e);
        }
    }), a.Container = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Parent
    }), a.ViewBox = a.invent({
        parent: a.Container,
        construct: {}
    }), [
        "click",
        "dblclick",
        "mousedown",
        "mouseup",
        "mouseover",
        "mouseout",
        "mousemove",
        "touchstart",
        "touchmove",
        "touchleave",
        "touchend",
        "touchcancel"
    ].forEach(function(t) {
        a.Element.prototype[t] = function(e) {
            return a.on(this.node, t, e), this;
        };
    }), a.listeners = [], a.handlerMap = [], a.listenerId = 0, a.on = function(t, e, i, s, r) {
        var o = i.bind(s || t.instance || t), n = (a.handlerMap.indexOf(t) + 1 || a.handlerMap.push(t)) - 1, l = e.split(".")[0], h = e.split(".")[1] || "*";
        a.listeners[n] = a.listeners[n] || {}, a.listeners[n][l] = a.listeners[n][l] || {}, a.listeners[n][l][h] = a.listeners[n][l][h] || {}, i._svgjsListenerId || (i._svgjsListenerId = ++a.listenerId), a.listeners[n][l][h][i._svgjsListenerId] = o, t.addEventListener(l, o, r || {
            passive: !0
        });
    }, a.off = function(t, e, i) {
        var s = a.handlerMap.indexOf(t), r = e && e.split(".")[0], o = e && e.split(".")[1], n = "";
        if (-1 != s) {
            if (i) {
                if ("function" == typeof i && (i = i._svgjsListenerId), !i) return;
                a.listeners[s][r] && a.listeners[s][r][o || "*"] && (t.removeEventListener(r, a.listeners[s][r][o || "*"][i], !1), delete a.listeners[s][r][o || "*"][i]);
            } else if (o && r) {
                if (a.listeners[s][r] && a.listeners[s][r][o]) {
                    for(var l in a.listeners[s][r][o])a.off(t, [
                        r,
                        o
                    ].join("."), l);
                    delete a.listeners[s][r][o];
                }
            } else if (o) for(var h in a.listeners[s])for(var n in a.listeners[s][h])o === n && a.off(t, [
                h,
                o
            ].join("."));
            else if (r) {
                if (a.listeners[s][r]) {
                    for(var n in a.listeners[s][r])a.off(t, [
                        r,
                        n
                    ].join("."));
                    delete a.listeners[s][r];
                }
            } else {
                for(var h in a.listeners[s])a.off(t, h);
                delete a.listeners[s], delete a.handlerMap[s];
            }
        }
    }, a.extend(a.Element, {
        on: function(t, e, i, s) {
            return a.on(this.node, t, e, i, s), this;
        },
        off: function(t, e) {
            return a.off(this.node, t, e), this;
        },
        fire: function(e, i) {
            return e instanceof t.Event ? this.node.dispatchEvent(e) : this.node.dispatchEvent(e = new a.CustomEvent(e, {
                detail: i,
                cancelable: !0
            })), this._event = e, this;
        },
        event: function() {
            return this._event;
        }
    }), a.Defs = a.invent({
        create: "defs",
        inherit: a.Container
    }), a.G = a.invent({
        create: "g",
        inherit: a.Container,
        extend: {
            x: function(t) {
                return null == t ? this.transform("x") : this.transform({
                    x: t - this.x()
                }, !0);
            }
        },
        construct: {
            group: function() {
                return this.put(new a.G);
            }
        }
    }), a.Doc = a.invent({
        create: function(t) {
            t && ("svg" == (t = "string" == typeof t ? e.getElementById(t) : t).nodeName ? this.constructor.call(this, t) : (this.constructor.call(this, a.create("svg")), t.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs());
        },
        inherit: a.Container,
        extend: {
            namespace: function() {
                return this.attr({
                    xmlns: a.ns,
                    version: "1.1"
                }).attr("xmlns:xlink", a.xlink, a.xmlns).attr("xmlns:svgjs", a.svgjs, a.xmlns);
            },
            defs: function() {
                var t;
                return this._defs || ((t = this.node.getElementsByTagName("defs")[0]) ? this._defs = a.adopt(t) : this._defs = new a.Defs, this.node.appendChild(this._defs.node)), this._defs;
            },
            parent: function() {
                return this.node.parentNode && "#document" != this.node.parentNode.nodeName ? this.node.parentNode : null;
            },
            remove: function() {
                return this.parent() && this.parent().removeChild(this.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, a.parser.draw && !a.parser.draw.parentNode && this.node.appendChild(a.parser.draw), this;
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = this.node, i = x(e.cloneNode(!0));
                return t ? (t.node || t).appendChild(i.node) : e.parentNode.insertBefore(i.node, e.nextSibling), i;
            }
        }
    }), a.extend(a.Element, {}), a.Gradient = a.invent({
        create: function(t) {
            this.constructor.call(this, a.create(t + "Gradient")), this.type = t;
        },
        inherit: a.Container,
        extend: {
            at: function(t, e, i) {
                return this.put(new a.Stop).update(t, e, i);
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "gradientTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            gradient: function(t, e) {
                return this.defs().gradient(t, e);
            }
        }
    }), a.extend(a.Gradient, a.FX, {
        from: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                fx: new a.Number(t),
                fy: new a.Number(e)
            }) : this.attr({
                x1: new a.Number(t),
                y1: new a.Number(e)
            });
        },
        to: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                cx: new a.Number(t),
                cy: new a.Number(e)
            }) : this.attr({
                x2: new a.Number(t),
                y2: new a.Number(e)
            });
        }
    }), a.extend(a.Defs, {
        gradient: function(t, e) {
            return this.put(new a.Gradient(t)).update(e);
        }
    }), a.Stop = a.invent({
        create: "stop",
        inherit: a.Element,
        extend: {
            update: function(t) {
                return ("number" == typeof t || t instanceof a.Number) && (t = {
                    offset: arguments[0],
                    color: arguments[1],
                    opacity: arguments[2]
                }), null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", new a.Number(t.offset)), this;
            }
        }
    }), a.Pattern = a.invent({
        create: "pattern",
        inherit: a.Container,
        extend: {
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "patternTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            pattern: function(t, e, i) {
                return this.defs().pattern(t, e, i);
            }
        }
    }), a.extend(a.Defs, {
        pattern: function(t, e, i) {
            return this.put(new a.Pattern).update(i).attr({
                x: 0,
                y: 0,
                width: t,
                height: e,
                patternUnits: "userSpaceOnUse"
            });
        }
    }), a.Shape = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element
    }), a.Symbol = a.invent({
        create: "symbol",
        inherit: a.Container,
        construct: {
            symbol: function() {
                return this.put(new a.Symbol);
            }
        }
    }), a.Use = a.invent({
        create: "use",
        inherit: a.Shape,
        extend: {
            element: function(t, e) {
                return this.attr("href", (e || "") + "#" + t, a.xlink);
            }
        },
        construct: {
            use: function(t, e) {
                return this.put(new a.Use).element(t, e);
            }
        }
    }), a.Rect = a.invent({
        create: "rect",
        inherit: a.Shape,
        construct: {
            rect: function(t, e) {
                return this.put(new a.Rect).size(t, e);
            }
        }
    }), a.Circle = a.invent({
        create: "circle",
        inherit: a.Shape,
        construct: {
            circle: function(t) {
                return this.put(new a.Circle).rx(new a.Number(t).divide(2)).move(0, 0);
            }
        }
    }), a.extend(a.Circle, a.FX, {
        rx: function(t) {
            return this.attr("r", t);
        },
        ry: function(t) {
            return this.rx(t);
        }
    }), a.Ellipse = a.invent({
        create: "ellipse",
        inherit: a.Shape,
        construct: {
            ellipse: function(t, e) {
                return this.put(new a.Ellipse).size(t, e).move(0, 0);
            }
        }
    }), a.extend(a.Ellipse, a.Rect, a.FX, {
        rx: function(t) {
            return this.attr("rx", t);
        },
        ry: function(t) {
            return this.attr("ry", t);
        }
    }), a.extend(a.Circle, a.Ellipse, {
        x: function(t) {
            return null == t ? this.cx() - this.rx() : this.cx(t + this.rx());
        },
        y: function(t) {
            return null == t ? this.cy() - this.ry() : this.cy(t + this.ry());
        },
        cx: function(t) {
            return null == t ? this.attr("cx") : this.attr("cx", t);
        },
        cy: function(t) {
            return null == t ? this.attr("cy") : this.attr("cy", t);
        },
        width: function(t) {
            return null == t ? 2 * this.rx() : this.rx(new a.Number(t).divide(2));
        },
        height: function(t) {
            return null == t ? 2 * this.ry() : this.ry(new a.Number(t).divide(2));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.rx(new a.Number(i.width).divide(2)).ry(new a.Number(i.height).divide(2));
        }
    }), a.Line = a.invent({
        create: "line",
        inherit: a.Shape,
        extend: {
            array: function() {
                return new a.PointArray([
                    [
                        this.attr("x1"),
                        this.attr("y1")
                    ],
                    [
                        this.attr("x2"),
                        this.attr("y2")
                    ]
                ]);
            },
            plot: function(t, e, i, s) {
                return null == t ? this.array() : (t = void 0 !== e ? {
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: s
                } : new a.PointArray(t).toLine(), this.attr(t));
            },
            move: function(t, e) {
                return this.attr(this.array().move(t, e).toLine());
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.attr(this.array().size(i.width, i.height).toLine());
            }
        },
        construct: {
            line: function(t, e, i, s) {
                return a.Line.prototype.plot.apply(this.put(new a.Line), null != t ? [
                    t,
                    e,
                    i,
                    s
                ] : [
                    0,
                    0,
                    0,
                    0
                ]);
            }
        }
    }), a.Polyline = a.invent({
        create: "polyline",
        inherit: a.Shape,
        construct: {
            polyline: function(t) {
                return this.put(new a.Polyline).plot(t || new a.PointArray);
            }
        }
    }), a.Polygon = a.invent({
        create: "polygon",
        inherit: a.Shape,
        construct: {
            polygon: function(t) {
                return this.put(new a.Polygon).plot(t || new a.PointArray);
            }
        }
    }), a.extend(a.Polyline, a.Polygon, {
        array: function() {
            return this._array || (this._array = new a.PointArray(this.attr("points")));
        },
        plot: function(t) {
            return null == t ? this.array() : this.clear().attr("points", "string" == typeof t ? t : this._array = new a.PointArray(t));
        },
        clear: function() {
            return delete this._array, this;
        },
        move: function(t, e) {
            return this.attr("points", this.array().move(t, e));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.attr("points", this.array().size(i.width, i.height));
        }
    }), a.extend(a.Line, a.Polyline, a.Polygon, {
        morphArray: a.PointArray,
        x: function(t) {
            return null == t ? this.bbox().x : this.move(t, this.bbox().y);
        },
        y: function(t) {
            return null == t ? this.bbox().y : this.move(this.bbox().x, t);
        },
        width: function(t) {
            var e = this.bbox();
            return null == t ? e.width : this.size(t, e.height);
        },
        height: function(t) {
            var e = this.bbox();
            return null == t ? e.height : this.size(e.width, t);
        }
    }), a.Path = a.invent({
        create: "path",
        inherit: a.Shape,
        extend: {
            morphArray: a.PathArray,
            array: function() {
                return this._array || (this._array = new a.PathArray(this.attr("d")));
            },
            plot: function(t) {
                return null == t ? this.array() : this.clear().attr("d", "string" == typeof t ? t : this._array = new a.PathArray(t));
            },
            clear: function() {
                return delete this._array, this;
            }
        },
        construct: {
            path: function(t) {
                return this.put(new a.Path).plot(t || new a.PathArray);
            }
        }
    }), a.Image = a.invent({
        create: "image",
        inherit: a.Shape,
        extend: {
            load: function(e) {
                if (!e) return this;
                var i = this, s = new t.Image;
                return a.on(s, "load", function() {
                    a.off(s);
                    var t = i.parent(a.Pattern);
                    null !== t && (0 == i.width() && 0 == i.height() && i.size(s.width, s.height), t && 0 == t.width() && 0 == t.height() && t.size(i.width(), i.height()), "function" == typeof i._loaded && i._loaded.call(i, {
                        width: s.width,
                        height: s.height,
                        ratio: s.width / s.height,
                        url: e
                    }));
                }), a.on(s, "error", function(t) {
                    a.off(s), "function" == typeof i._error && i._error.call(i, t);
                }), this.attr("href", s.src = this.src = e, a.xlink);
            },
            loaded: function(t) {
                return this._loaded = t, this;
            },
            error: function(t) {
                return this._error = t, this;
            }
        },
        construct: {
            image: function(t, e, i) {
                return this.put(new a.Image).load(t).size(e || 0, i || e || 0);
            }
        }
    }), a.Text = a.invent({
        create: function() {
            this.constructor.call(this, a.create("text")), this.dom.leading = new a.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", a.defaults.attrs["font-family"]);
        },
        inherit: a.Shape,
        extend: {
            x: function(t) {
                return null == t ? this.attr("x") : this.attr("x", t);
            },
            text: function(t) {
                if (void 0 === t) {
                    t = "";
                    for(var e = this.node.childNodes, i = 0, s = e.length; i < s; ++i)0 != i && 3 != e[i].nodeType && 1 == a.adopt(e[i]).dom.newLined && (t += "\n"), t += e[i].textContent;
                    return t;
                }
                if (this.clear().build(!0), "function" == typeof t) t.call(this, this);
                else {
                    i = 0;
                    for(var r = (t = t.split("\n")).length; i < r; i++)this.tspan(t[i]).newLine();
                }
                return this.build(!1).rebuild();
            },
            size: function(t) {
                return this.attr("font-size", t).rebuild();
            },
            leading: function(t) {
                return null == t ? this.dom.leading : (this.dom.leading = new a.Number(t), this.rebuild());
            },
            lines: function() {
                var t = (this.textPath && this.textPath() || this).node, e = a.utils.map(a.utils.filterSVGElements(t.childNodes), function(t) {
                    return a.adopt(t);
                });
                return new a.Set(e);
            },
            rebuild: function(t) {
                if ("boolean" == typeof t && (this._rebuild = t), this._rebuild) {
                    var e = this, i = 0, s = this.dom.leading * new a.Number(this.attr("font-size"));
                    this.lines().each(function() {
                        this.dom.newLined && (e.textPath() || this.attr("x", e.attr("x")), "\n" == this.text() ? i += s : (this.attr("dy", s + i), i = 0));
                    }), this.fire("rebuild");
                }
                return this;
            },
            build: function(t) {
                return this._build = !!t, this;
            },
            setData: function(t) {
                return this.dom = t, this.dom.leading = new a.Number(t.leading || 1.3), this;
            }
        },
        construct: {
            text: function(t) {
                return this.put(new a.Text).text(t);
            },
            plain: function(t) {
                return this.put(new a.Text).plain(t);
            }
        }
    }), a.Tspan = a.invent({
        create: "tspan",
        inherit: a.Shape,
        extend: {
            text: function(t) {
                return null == t ? this.node.textContent + (this.dom.newLined ? "\n" : "") : ("function" == typeof t ? t.call(this, this) : this.plain(t), this);
            },
            dx: function(t) {
                return this.attr("dx", t);
            },
            dy: function(t) {
                return this.attr("dy", t);
            },
            newLine: function() {
                var t = this.parent(a.Text);
                return this.dom.newLined = !0, this.dy(t.dom.leading * t.attr("font-size")).attr("x", t.x());
            }
        }
    }), a.extend(a.Text, a.Tspan, {
        plain: function(t) {
            return !1 === this._build && this.clear(), this.node.appendChild(e.createTextNode(t)), this;
        },
        tspan: function(t) {
            var e = (this.textPath && this.textPath() || this).node, i = new a.Tspan;
            return !1 === this._build && this.clear(), e.appendChild(i.node), i.text(t);
        },
        clear: function() {
            for(var t = (this.textPath && this.textPath() || this).node; t.hasChildNodes();)t.removeChild(t.lastChild);
            return this;
        },
        length: function() {
            return this.node.getComputedTextLength();
        }
    }), a.TextPath = a.invent({
        create: "textPath",
        inherit: a.Parent,
        parent: a.Text,
        construct: {
            morphArray: a.PathArray,
            array: function() {
                var t = this.track();
                return t ? t.array() : null;
            },
            plot: function(t) {
                var e = this.track(), i = null;
                return e && (i = e.plot(t)), null == t ? i : this;
            },
            track: function() {
                var t = this.textPath();
                if (t) return t.reference("href");
            },
            textPath: function() {
                if (this.node.firstChild && "textPath" == this.node.firstChild.nodeName) return a.adopt(this.node.firstChild);
            }
        }
    }), a.Nested = a.invent({
        create: function() {
            this.constructor.call(this, a.create("svg")), this.style("overflow", "visible");
        },
        inherit: a.Container,
        construct: {
            nested: function() {
                return this.put(new a.Nested);
            }
        }
    });
    var l = {
        stroke: [
            "color",
            "width",
            "opacity",
            "linecap",
            "linejoin",
            "miterlimit",
            "dasharray",
            "dashoffset"
        ],
        fill: [
            "color",
            "opacity",
            "rule"
        ],
        prefix: function(t, e) {
            return "color" == e ? t : t + "-" + e;
        }
    };
    function h(t, e, i, s) {
        return i + s.replace(a.regex.dots, " .");
    }
    function c(t) {
        return t.toLowerCase().replace(/-(.)/g, function(t, e) {
            return e.toUpperCase();
        });
    }
    function d(t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
    }
    function g(t) {
        var e = t.toString(16);
        return 1 == e.length ? "0" + e : e;
    }
    function u(t, e, i) {
        if (null == e || null == i) {
            var a = t.bbox();
            null == e ? e = a.width / a.height * i : null == i && (i = a.height / a.width * e);
        }
        return {
            width: e,
            height: i
        };
    }
    function p(t, e, i) {
        return {
            x: e * t.a + i * t.c + 0,
            y: e * t.b + i * t.d + 0
        };
    }
    function f(t) {
        return {
            a: t[0],
            b: t[1],
            c: t[2],
            d: t[3],
            e: t[4],
            f: t[5]
        };
    }
    function x(e) {
        for(var i = e.childNodes.length - 1; i >= 0; i--)e.childNodes[i] instanceof t.SVGElement && x(e.childNodes[i]);
        return a.adopt(e).id(a.eid(e.nodeName));
    }
    function b(t) {
        return Math.abs(t) > 1e-37 ? t : 0;
    }
    [
        "fill",
        "stroke"
    ].forEach(function(t) {
        var e = {};
        e[t] = function(e) {
            if (void 0 === e) return this;
            if ("string" == typeof e || a.Color.isRgb(e) || e && "function" == typeof e.fill) this.attr(t, e);
            else for(var i = l[t].length - 1; i >= 0; i--)null != e[l[t][i]] && this.attr(l.prefix(t, l[t][i]), e[l[t][i]]);
            return this;
        }, a.extend(a.Element, a.FX, e);
    }), a.extend(a.Element, a.FX, {
        translate: function(t, e) {
            return this.transform({
                x: t,
                y: e
            });
        },
        matrix: function(t) {
            return this.attr("transform", new a.Matrix(6 == arguments.length ? [].slice.call(arguments) : t));
        },
        opacity: function(t) {
            return this.attr("opacity", t);
        },
        dx: function(t) {
            return this.x(new a.Number(t).plus(this instanceof a.FX ? 0 : this.x()), !0);
        },
        dy: function(t) {
            return this.y(new a.Number(t).plus(this instanceof a.FX ? 0 : this.y()), !0);
        }
    }), a.extend(a.Path, {
        length: function() {
            return this.node.getTotalLength();
        },
        pointAt: function(t) {
            return this.node.getPointAtLength(t);
        }
    }), a.Set = a.invent({
        create: function(t) {
            Array.isArray(t) ? this.members = t : this.clear();
        },
        extend: {
            add: function() {
                for(var t = [].slice.call(arguments), e = 0, i = t.length; e < i; e++)this.members.push(t[e]);
                return this;
            },
            remove: function(t) {
                var e = this.index(t);
                return e > -1 && this.members.splice(e, 1), this;
            },
            each: function(t) {
                for(var e = 0, i = this.members.length; e < i; e++)t.apply(this.members[e], [
                    e,
                    this.members
                ]);
                return this;
            },
            clear: function() {
                return this.members = [], this;
            },
            length: function() {
                return this.members.length;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return this.members.indexOf(t);
            },
            get: function(t) {
                return this.members[t];
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.members.length - 1);
            },
            valueOf: function() {
                return this.members;
            }
        },
        construct: {
            set: function(t) {
                return new a.Set(t);
            }
        }
    }), a.FX.Set = a.invent({
        create: function(t) {
            this.set = t;
        }
    }), a.Set.inherit = function() {
        var t = [];
        for(var e in a.Shape.prototype)"function" == typeof a.Shape.prototype[e] && "function" != typeof a.Set.prototype[e] && t.push(e);
        for(var e in t.forEach(function(t) {
            a.Set.prototype[t] = function() {
                for(var e = 0, i = this.members.length; e < i; e++)this.members[e] && "function" == typeof this.members[e][t] && this.members[e][t].apply(this.members[e], arguments);
                return "animate" == t ? this.fx || (this.fx = new a.FX.Set(this)) : this;
            };
        }), t = [], a.FX.prototype)"function" == typeof a.FX.prototype[e] && "function" != typeof a.FX.Set.prototype[e] && t.push(e);
        t.forEach(function(t) {
            a.FX.Set.prototype[t] = function() {
                for(var e = 0, i = this.set.members.length; e < i; e++)this.set.members[e].fx[t].apply(this.set.members[e].fx, arguments);
                return this;
            };
        });
    }, a.extend(a.Element, {}), a.extend(a.Element, {
        remember: function(t, e) {
            if ("object" === i(arguments[0])) for(var a in t)this.remember(a, t[a]);
            else {
                if (1 == arguments.length) return this.memory()[t];
                this.memory()[t] = e;
            }
            return this;
        },
        forget: function() {
            if (0 == arguments.length) this._memory = {};
            else for(var t = arguments.length - 1; t >= 0; t--)delete this.memory()[arguments[t]];
            return this;
        },
        memory: function() {
            return this._memory || (this._memory = {});
        }
    }), a.get = function(t) {
        var i = e.getElementById(function(t) {
            var e = (t || "").toString().match(a.regex.reference);
            if (e) return e[1];
        }(t) || t);
        return a.adopt(i);
    }, a.select = function(t, i) {
        return new a.Set(a.utils.map((i || e).querySelectorAll(t), function(t) {
            return a.adopt(t);
        }));
    }, a.extend(a.Parent, {
        select: function(t) {
            return a.select(t, this.node);
        }
    });
    var v = "abcdef".split("");
    if ("function" != typeof t.CustomEvent) {
        var m = function(t, i) {
            i = i || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
            };
            var a = e.createEvent("CustomEvent");
            return a.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), a;
        };
        m.prototype = t.Event.prototype, a.CustomEvent = m;
    } else a.CustomEvent = t.CustomEvent;
    return a;
}, "function" == typeof define && define.amd ? define(function() {
    return Ht(Rt, Rt.document);
}) : "object" === i(exports) && true ? module.exports = Rt.document ? Ht(Rt, Rt.document) : function(t) {
    return Ht(t, t.document);
} : Rt.SVG = Ht(Rt, Rt.document), /*! svg.filter.js - v2.0.2 - 2016-02-24
* https://github.com/wout/svg.filter.js
* Copyright (c) 2016 Wout Fierens; Licensed MIT */ (function() {
    SVG.Filter = SVG.invent({
        create: "filter",
        inherit: SVG.Parent,
        extend: {
            source: "SourceGraphic",
            sourceAlpha: "SourceAlpha",
            background: "BackgroundImage",
            backgroundAlpha: "BackgroundAlpha",
            fill: "FillPaint",
            stroke: "StrokePaint",
            autoSetIn: !0,
            put: function(t, e) {
                return this.add(t, e), !t.attr("in") && this.autoSetIn && t.attr("in", this.source), t.attr("result") || t.attr("result", t), t;
            },
            blend: function(t, e, i) {
                return this.put(new SVG.BlendEffect(t, e, i));
            },
            colorMatrix: function(t, e) {
                return this.put(new SVG.ColorMatrixEffect(t, e));
            },
            convolveMatrix: function(t) {
                return this.put(new SVG.ConvolveMatrixEffect(t));
            },
            componentTransfer: function(t) {
                return this.put(new SVG.ComponentTransferEffect(t));
            },
            composite: function(t, e, i) {
                return this.put(new SVG.CompositeEffect(t, e, i));
            },
            flood: function(t, e) {
                return this.put(new SVG.FloodEffect(t, e));
            },
            offset: function(t, e) {
                return this.put(new SVG.OffsetEffect(t, e));
            },
            image: function(t) {
                return this.put(new SVG.ImageEffect(t));
            },
            merge: function() {
                var t = [
                    void 0
                ];
                for(var e in arguments)t.push(arguments[e]);
                return this.put(new (SVG.MergeEffect.bind.apply(SVG.MergeEffect, t)));
            },
            gaussianBlur: function(t, e) {
                return this.put(new SVG.GaussianBlurEffect(t, e));
            },
            morphology: function(t, e) {
                return this.put(new SVG.MorphologyEffect(t, e));
            },
            diffuseLighting: function(t, e, i) {
                return this.put(new SVG.DiffuseLightingEffect(t, e, i));
            },
            displacementMap: function(t, e, i, a, s) {
                return this.put(new SVG.DisplacementMapEffect(t, e, i, a, s));
            },
            specularLighting: function(t, e, i, a) {
                return this.put(new SVG.SpecularLightingEffect(t, e, i, a));
            },
            tile: function() {
                return this.put(new SVG.TileEffect);
            },
            turbulence: function(t, e, i, a, s) {
                return this.put(new SVG.TurbulenceEffect(t, e, i, a, s));
            },
            toString: function() {
                return "url(#" + this.attr("id") + ")";
            }
        }
    }), SVG.extend(SVG.Defs, {
        filter: function(t) {
            var e = this.put(new SVG.Filter);
            return "function" == typeof t && t.call(e, e), e;
        }
    }), SVG.extend(SVG.Container, {
        filter: function(t) {
            return this.defs().filter(t);
        }
    }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
        filter: function(t) {
            return this.filterer = t instanceof SVG.Element ? t : this.doc().filter(t), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer;
        },
        unfilter: function(t) {
            return this.filterer && !0 === t && this.filterer.remove(), delete this.filterer, this.attr("filter", null);
        }
    }), SVG.Effect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    }), SVG.ParentEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Parent,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    });
    var t = {
        blend: function(t, e) {
            return this.parent() && this.parent().blend(this, t, e);
        },
        colorMatrix: function(t, e) {
            return this.parent() && this.parent().colorMatrix(t, e).in(this);
        },
        convolveMatrix: function(t) {
            return this.parent() && this.parent().convolveMatrix(t).in(this);
        },
        componentTransfer: function(t) {
            return this.parent() && this.parent().componentTransfer(t).in(this);
        },
        composite: function(t, e) {
            return this.parent() && this.parent().composite(this, t, e);
        },
        flood: function(t, e) {
            return this.parent() && this.parent().flood(t, e);
        },
        offset: function(t, e) {
            return this.parent() && this.parent().offset(t, e).in(this);
        },
        image: function(t) {
            return this.parent() && this.parent().image(t);
        },
        merge: function() {
            return this.parent() && this.parent().merge.apply(this.parent(), [
                this
            ].concat(arguments));
        },
        gaussianBlur: function(t, e) {
            return this.parent() && this.parent().gaussianBlur(t, e).in(this);
        },
        morphology: function(t, e) {
            return this.parent() && this.parent().morphology(t, e).in(this);
        },
        diffuseLighting: function(t, e, i) {
            return this.parent() && this.parent().diffuseLighting(t, e, i).in(this);
        },
        displacementMap: function(t, e, i, a) {
            return this.parent() && this.parent().displacementMap(this, t, e, i, a);
        },
        specularLighting: function(t, e, i, a) {
            return this.parent() && this.parent().specularLighting(t, e, i, a).in(this);
        },
        tile: function() {
            return this.parent() && this.parent().tile().in(this);
        },
        turbulence: function(t, e, i, a, s) {
            return this.parent() && this.parent().turbulence(t, e, i, a, s).in(this);
        }
    };
    SVG.extend(SVG.Effect, t), SVG.extend(SVG.ParentEffect, t), SVG.ChildEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                this.attr("in", t);
            }
        }
    });
    var e = {
        blend: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                mode: i || "normal"
            });
        },
        colorMatrix: function(t, e) {
            "matrix" == t && (e = s(e)), this.attr({
                type: t,
                values: void 0 === e ? null : e
            });
        },
        convolveMatrix: function(t) {
            t = s(t), this.attr({
                order: Math.sqrt(t.split(" ").length),
                kernelMatrix: t
            });
        },
        composite: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                operator: i
            });
        },
        flood: function(t, e) {
            this.attr("flood-color", t), null != e && this.attr("flood-opacity", e);
        },
        offset: function(t, e) {
            this.attr({
                dx: t,
                dy: e
            });
        },
        image: function(t) {
            this.attr("href", t, SVG.xlink);
        },
        displacementMap: function(t, e, i, a, s) {
            this.attr({
                in: t,
                in2: e,
                scale: i,
                xChannelSelector: a,
                yChannelSelector: s
            });
        },
        gaussianBlur: function(t, e) {
            null != t || null != e ? this.attr("stdDeviation", function(t) {
                if (!Array.isArray(t)) return t;
                for(var e = 0, i = t.length, a = []; e < i; e++)a.push(t[e]);
                return a.join(" ");
            }(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0");
        },
        morphology: function(t, e) {
            this.attr({
                operator: t,
                radius: e
            });
        },
        tile: function() {},
        turbulence: function(t, e, i, a, s) {
            this.attr({
                numOctaves: e,
                seed: i,
                stitchTiles: a,
                baseFrequency: t,
                type: s
            });
        }
    }, i = {
        merge: function() {
            var t;
            if (arguments[0] instanceof SVG.Set) {
                var e = this;
                arguments[0].each(function(t) {
                    this instanceof SVG.MergeNode ? e.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && e.put(new SVG.MergeNode(this));
                });
            } else {
                t = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                for(var i = 0; i < t.length; i++)t[i] instanceof SVG.MergeNode ? this.put(t[i]) : this.put(new SVG.MergeNode(t[i]));
            }
        },
        componentTransfer: function(t) {
            if (this.rgb = new SVG.Set, [
                "r",
                "g",
                "b",
                "a"
            ].forEach((function(t) {
                this[t] = new SVG["Func" + t.toUpperCase()]("identity"), this.rgb.add(this[t]), this.node.appendChild(this[t].node);
            }).bind(this)), t) for(var e in t.rgb && ([
                "r",
                "g",
                "b"
            ].forEach((function(e) {
                this[e].attr(t.rgb);
            }).bind(this)), delete t.rgb), t)this[e].attr(t[e]);
        },
        diffuseLighting: function(t, e, i) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                kernelUnitLength: i
            });
        },
        specularLighting: function(t, e, i, a) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                specularExponent: i,
                kernelUnitLength: a
            });
        }
    }, a = {
        distantLight: function(t, e) {
            this.attr({
                azimuth: t,
                elevation: e
            });
        },
        pointLight: function(t, e, i) {
            this.attr({
                x: t,
                y: e,
                z: i
            });
        },
        spotLight: function(t, e, i, a, s, r) {
            this.attr({
                x: t,
                y: e,
                z: i,
                pointsAtX: a,
                pointsAtY: s,
                pointsAtZ: r
            });
        },
        mergeNode: function(t) {
            this.attr("in", t);
        }
    };
    function s(t) {
        return Array.isArray(t) && (t = new SVG.Array(t)), t.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
    }
    function r() {
        var t = function() {};
        for(var e in "function" == typeof arguments[arguments.length - 1] && (t = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)for(var i in arguments[e])t(arguments[e][i], i, arguments[e]);
    }
    [
        "r",
        "g",
        "b",
        "a"
    ].forEach(function(t) {
        a["Func" + t.toUpperCase()] = function(t) {
            switch(this.attr("type", t), t){
                case "table":
                    this.attr("tableValues", arguments[1]);
                    break;
                case "linear":
                    this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                    break;
                case "gamma":
                    this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2]);
            }
        };
    }), r(e, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.Effect,
            extend: {}
        });
    }), r(i, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.ParentEffect,
            extend: {}
        });
    }), r(a, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments);
            },
            inherit: SVG.ChildEffect,
            extend: {}
        });
    }), SVG.extend(SVG.MergeEffect, {
        in: function(t) {
            return t instanceof SVG.MergeNode ? this.add(t, 0) : this.add(new SVG.MergeNode(t), 0), this;
        }
    }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
        in2: function(t) {
            return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", t);
        }
    }), SVG.filter = {
        sepiatone: [
            .343,
            .669,
            .119,
            0,
            0,
            .249,
            .626,
            .13,
            0,
            0,
            .172,
            .334,
            .111,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ]
    };
}).call(void 0), function() {
    function t(t, s, r, o, n, l, h) {
        for(var c = t.slice(s, r || h), d = o.slice(n, l || h), g = 0, u = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        }, p = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        };;){
            if (c[g] = e.call(u, c[g]), d[g] = e.call(p, d[g]), c[g][0] != d[g][0] || "M" == c[g][0] || "A" == c[g][0] && (c[g][4] != d[g][4] || c[g][5] != d[g][5]) ? (Array.prototype.splice.apply(c, [
                g,
                1
            ].concat(a.call(u, c[g]))), Array.prototype.splice.apply(d, [
                g,
                1
            ].concat(a.call(p, d[g])))) : (c[g] = i.call(u, c[g]), d[g] = i.call(p, d[g])), ++g == c.length && g == d.length) break;
            g == c.length && c.push([
                "C",
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1]
            ]), g == d.length && d.push([
                "C",
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1]
            ]);
        }
        return {
            start: c,
            dest: d
        };
    }
    function e(t) {
        switch(t[0]){
            case "z":
            case "Z":
                t[0] = "L", t[1] = this.start[0], t[2] = this.start[1];
                break;
            case "H":
                t[0] = "L", t[2] = this.pos[1];
                break;
            case "V":
                t[0] = "L", t[2] = t[1], t[1] = this.pos[0];
                break;
            case "T":
                t[0] = "Q", t[3] = t[1], t[4] = t[2], t[1] = this.reflection[1], t[2] = this.reflection[0];
                break;
            case "S":
                t[0] = "C", t[6] = t[4], t[5] = t[3], t[4] = t[2], t[3] = t[1], t[2] = this.reflection[1], t[1] = this.reflection[0];
        }
        return t;
    }
    function i(t) {
        var e = t.length;
        return this.pos = [
            t[e - 2],
            t[e - 1]
        ], -1 != "SCQT".indexOf(t[0]) && (this.reflection = [
            2 * this.pos[0] - t[e - 4],
            2 * this.pos[1] - t[e - 3]
        ]), t;
    }
    function a(t) {
        var e = [
            t
        ];
        switch(t[0]){
            case "M":
                return this.pos = this.start = [
                    t[1],
                    t[2]
                ], e;
            case "L":
                t[5] = t[3] = t[1], t[6] = t[4] = t[2], t[1] = this.pos[0], t[2] = this.pos[1];
                break;
            case "Q":
                t[6] = t[4], t[5] = t[3], t[4] = 1 * t[4] / 3 + 2 * t[2] / 3, t[3] = 1 * t[3] / 3 + 2 * t[1] / 3, t[2] = 1 * this.pos[1] / 3 + 2 * t[2] / 3, t[1] = 1 * this.pos[0] / 3 + 2 * t[1] / 3;
                break;
            case "A":
                e = function(t, e) {
                    var i, a, s, r, o, n, l, h, c, d, g, u, p, f, x, b, v, m, y, w, k, A, S, C, L, P, I = Math.abs(e[1]), T = Math.abs(e[2]), M = e[3] % 360, z = e[4], X = e[5], E = e[6], Y = e[7], F = new SVG.Point(t), R = new SVG.Point(E, Y), H = [];
                    if (0 === I || 0 === T || F.x === R.x && F.y === R.y) return [
                        [
                            "C",
                            F.x,
                            F.y,
                            R.x,
                            R.y,
                            R.x,
                            R.y
                        ]
                    ];
                    i = new SVG.Point((F.x - R.x) / 2, (F.y - R.y) / 2).transform((new SVG.Matrix).rotate(M)), (a = i.x * i.x / (I * I) + i.y * i.y / (T * T)) > 1 && (I *= a = Math.sqrt(a), T *= a);
                    s = (new SVG.Matrix).rotate(M).scale(1 / I, 1 / T).rotate(-M), F = F.transform(s), R = R.transform(s), r = [
                        R.x - F.x,
                        R.y - F.y
                    ], n = r[0] * r[0] + r[1] * r[1], o = Math.sqrt(n), r[0] /= o, r[1] /= o, l = n < 4 ? Math.sqrt(1 - n / 4) : 0, z === X && (l *= -1);
                    h = new SVG.Point((R.x + F.x) / 2 + l * -r[1], (R.y + F.y) / 2 + l * r[0]), c = new SVG.Point(F.x - h.x, F.y - h.y), d = new SVG.Point(R.x - h.x, R.y - h.y), g = Math.acos(c.x / Math.sqrt(c.x * c.x + c.y * c.y)), c.y < 0 && (g *= -1);
                    u = Math.acos(d.x / Math.sqrt(d.x * d.x + d.y * d.y)), d.y < 0 && (u *= -1);
                    X && g > u && (u += 2 * Math.PI);
                    !X && g < u && (u -= 2 * Math.PI);
                    for(f = Math.ceil(2 * Math.abs(g - u) / Math.PI), b = [], v = g, p = (u - g) / f, x = 4 * Math.tan(p / 4) / 3, k = 0; k <= f; k++)y = Math.cos(v), m = Math.sin(v), w = new SVG.Point(h.x + y, h.y + m), b[k] = [
                        new SVG.Point(w.x + x * m, w.y - x * y),
                        w,
                        new SVG.Point(w.x - x * m, w.y + x * y)
                    ], v += p;
                    for(b[0][0] = b[0][1].clone(), b[b.length - 1][2] = b[b.length - 1][1].clone(), s = (new SVG.Matrix).rotate(M).scale(I, T).rotate(-M), k = 0, A = b.length; k < A; k++)b[k][0] = b[k][0].transform(s), b[k][1] = b[k][1].transform(s), b[k][2] = b[k][2].transform(s);
                    for(k = 1, A = b.length; k < A; k++)S = (w = b[k - 1][2]).x, C = w.y, L = (w = b[k][0]).x, P = w.y, E = (w = b[k][1]).x, Y = w.y, H.push([
                        "C",
                        S,
                        C,
                        L,
                        P,
                        E,
                        Y
                    ]);
                    return H;
                }(this.pos, t), t = e[0];
        }
        return t[0] = "C", this.pos = [
            t[5],
            t[6]
        ], this.reflection = [
            2 * t[5] - t[3],
            2 * t[6] - t[4]
        ], e;
    }
    function s(t, e) {
        if (!1 === e) return !1;
        for(var i = e, a = t.length; i < a; ++i)if ("M" == t[i][0]) return i;
        return !1;
    }
    SVG.extend(SVG.PathArray, {
        morph: function(e) {
            for(var i = this.value, a = this.parse(e), r = 0, o = 0, n = !1, l = !1; !1 !== r || !1 !== o;){
                var h;
                n = s(i, !1 !== r && r + 1), l = s(a, !1 !== o && o + 1), !1 === r && (r = 0 == (h = new SVG.PathArray(c.start).bbox()).height || 0 == h.width ? i.push(i[0]) - 1 : i.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1), !1 === o && (o = 0 == (h = new SVG.PathArray(c.dest).bbox()).height || 0 == h.width ? a.push(a[0]) - 1 : a.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1);
                var c = t(i, r, n, a, o, l);
                i = i.slice(0, r).concat(c.start, !1 === n ? [] : i.slice(n)), a = a.slice(0, o).concat(c.dest, !1 === l ? [] : a.slice(l)), r = !1 !== n && r + c.start.length, o = !1 !== l && o + c.dest.length;
            }
            return this.value = i, this.destination = new SVG.PathArray, this.destination.value = a, this;
        }
    });
}(), /*! svg.draggable.js - v2.2.2 - 2019-01-08
* https://github.com/svgdotjs/svg.draggable.js
* Copyright (c) 2019 Wout Fierens; Licensed MIT */ (function() {
    function t(t) {
        t.remember("_draggable", this), this.el = t;
    }
    t.prototype.init = function(t, e) {
        var i = this;
        this.constraint = t, this.value = e, this.el.on("mousedown.drag", function(t) {
            i.start(t);
        }), this.el.on("touchstart.drag", function(t) {
            i.start(t);
        });
    }, t.prototype.transformPoint = function(t, e) {
        var i = (t = t || window.event).changedTouches && t.changedTouches[0] || t;
        return this.p.x = i.clientX - (e || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m);
    }, t.prototype.getBBox = function() {
        var t = this.el.bbox();
        return this.el instanceof SVG.Nested && (t = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (t.x = this.el.x(), t.y = this.el.y()), t;
    }, t.prototype.start = function(t) {
        if ("click" != t.type && "mousedown" != t.type && "mousemove" != t.type || 1 == (t.which || t.buttons)) {
            var e = this;
            if (this.el.fire("beforedrag", {
                event: t,
                handler: this
            }), !this.el.event().defaultPrevented) {
                t.preventDefault(), t.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                var i, a = this.getBBox();
                if (this.el instanceof SVG.Text) switch(i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")){
                    case "middle":
                        i /= 2;
                        break;
                    case "start":
                        i = 0;
                }
                this.startPoints = {
                    point: this.transformPoint(t, i),
                    box: a,
                    transform: this.el.transform()
                }, SVG.on(window, "mousemove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "touchmove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "mouseup.drag", function(t) {
                    e.end(t);
                }), SVG.on(window, "touchend.drag", function(t) {
                    e.end(t);
                }), this.el.fire("dragstart", {
                    event: t,
                    p: this.startPoints.point,
                    m: this.m,
                    handler: this
                });
            }
        }
    }, t.prototype.drag = function(t) {
        var e = this.getBBox(), i = this.transformPoint(t), a = this.startPoints.box.x + i.x - this.startPoints.point.x, s = this.startPoints.box.y + i.y - this.startPoints.point.y, r = this.constraint, o = i.x - this.startPoints.point.x, n = i.y - this.startPoints.point.y;
        if (this.el.fire("dragmove", {
            event: t,
            p: i,
            m: this.m,
            handler: this
        }), this.el.event().defaultPrevented) return i;
        if ("function" == typeof r) {
            var l = r.call(this.el, a, s, this.m);
            "boolean" == typeof l && (l = {
                x: l,
                y: l
            }), !0 === l.x ? this.el.x(a) : !1 !== l.x && this.el.x(l.x), !0 === l.y ? this.el.y(s) : !1 !== l.y && this.el.y(l.y);
        } else "object" == typeof r && (null != r.minX && a < r.minX ? o = (a = r.minX) - this.startPoints.box.x : null != r.maxX && a > r.maxX - e.width && (o = (a = r.maxX - e.width) - this.startPoints.box.x), null != r.minY && s < r.minY ? n = (s = r.minY) - this.startPoints.box.y : null != r.maxY && s > r.maxY - e.height && (n = (s = r.maxY - e.height) - this.startPoints.box.y), null != r.snapToGrid && (a -= a % r.snapToGrid, s -= s % r.snapToGrid, o -= o % r.snapToGrid, n -= n % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
            x: o,
            y: n
        }, !0) : this.el.move(a, s));
        return i;
    }, t.prototype.end = function(t) {
        var e = this.drag(t);
        this.el.fire("dragend", {
            event: t,
            p: e,
            m: this.m,
            handler: this
        }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag");
    }, SVG.extend(SVG.Element, {
        draggable: function(e, i) {
            "function" != typeof e && "object" != typeof e || (i = e, e = !0);
            var a = this.remember("_draggable") || new t(this);
            return (e = void 0 === e || e) ? a.init(i || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this;
        }
    });
}).call(void 0), function() {
    function t(t) {
        this.el = t, t.remember("_selectHandler", this), this.pointSelection = {
            isSelected: !1
        }, this.rectSelection = {
            isSelected: !1
        }, this.pointsList = {
            lt: [
                0,
                0
            ],
            rt: [
                "width",
                0
            ],
            rb: [
                "width",
                "height"
            ],
            lb: [
                0,
                "height"
            ],
            t: [
                "width",
                0
            ],
            r: [
                "width",
                "height"
            ],
            b: [
                "width",
                "height"
            ],
            l: [
                0,
                "height"
            ]
        }, this.pointCoord = function(t, e, i) {
            var a = "string" != typeof t ? t : e[t];
            return i ? a / 2 : a;
        }, this.pointCoords = function(t, e) {
            var i = this.pointsList[t];
            return {
                x: this.pointCoord(i[0], e, "t" === t || "b" === t),
                y: this.pointCoord(i[1], e, "r" === t || "l" === t)
            };
        };
    }
    t.prototype.init = function(t, e) {
        var i = this.el.bbox();
        this.options = {};
        var a = this.el.selectize.defaults.points;
        for(var s in this.el.selectize.defaults)this.options[s] = this.el.selectize.defaults[s], void 0 !== e[s] && (this.options[s] = e[s]);
        var r = [
            "points",
            "pointsExclude"
        ];
        for(var s in r){
            var o = this.options[r[s]];
            "string" == typeof o ? o = o.length > 0 ? o.split(/\s*,\s*/i) : [] : "boolean" == typeof o && "points" === r[s] && (o = o ? a : []), this.options[r[s]] = o;
        }
        this.options.points = [
            a,
            this.options.points
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) > -1;
            });
        }), this.options.points = [
            this.options.points,
            this.options.pointsExclude
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) < 0;
            });
        }), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && -1 !== [
            "line",
            "polyline",
            "polygon"
        ].indexOf(this.el.type) ? this.selectPoints(t) : this.selectRect(t), this.observe(), this.cleanup();
    }, t.prototype.selectPoints = function(t) {
        return this.pointSelection.isSelected = t, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this;
    }, t.prototype.getPointArray = function() {
        var t = this.el.bbox();
        return this.el.array().valueOf().map(function(e) {
            return [
                e[0] - t.x,
                e[1] - t.y
            ];
        });
    }, t.prototype.drawPoints = function() {
        for(var t = this, e = this.getPointArray(), i = 0, a = e.length; i < a; ++i){
            var s = function(e) {
                return function(i) {
                    (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                    var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                    t.el.fire("point", {
                        x: a,
                        y: s,
                        i: e,
                        event: i
                    });
                };
            }(i), r = this.drawPoint(e[i][0], e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", s).on("mousedown", s);
            this.pointSelection.set.add(r);
        }
    }, t.prototype.drawPoint = function(t, e) {
        var i = this.options.pointType;
        switch(i){
            case "circle":
                return this.drawCircle(t, e);
            case "rect":
                return this.drawRect(t, e);
            default:
                if ("function" == typeof i) return i.call(this, t, e);
                throw new Error("Unknown " + i + " point type!");
        }
    }, t.prototype.drawCircle = function(t, e) {
        return this.nested.circle(this.options.pointSize).center(t, e);
    }, t.prototype.drawRect = function(t, e) {
        return this.nested.rect(this.options.pointSize, this.options.pointSize).center(t, e);
    }, t.prototype.updatePointSelection = function() {
        var t = this.getPointArray();
        this.pointSelection.set.each(function(e) {
            this.cx() === t[e][0] && this.cy() === t[e][1] || this.center(t[e][0], t[e][1]);
        });
    }, t.prototype.updateRectSelection = function() {
        var t = this, e = this.el.bbox();
        if (this.rectSelection.set.get(0).attr({
            width: e.width,
            height: e.height
        }), this.options.points.length && this.options.points.map(function(i, a) {
            var s = t.pointCoords(i, e);
            t.rectSelection.set.get(a + 1).center(s.x, s.y);
        }), this.options.rotationPoint) {
            var i = this.rectSelection.set.length();
            this.rectSelection.set.get(i - 1).center(e.width / 2, 20);
        }
    }, t.prototype.selectRect = function(t) {
        var e = this, i = this.el.bbox();
        function a(t) {
            return function(i) {
                (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                e.el.fire(t, {
                    x: a,
                    y: s,
                    event: i
                });
            };
        }
        if (this.rectSelection.isSelected = t, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2) this.options.points.map(function(t, s) {
            var r = e.pointCoords(t, i), o = e.drawPoint(r.x, r.y).attr("class", e.options.classPoints + "_" + t).on("mousedown", a(t)).on("touchstart", a(t));
            e.rectSelection.set.add(o);
        }), this.rectSelection.set.each(function() {
            this.addClass(e.options.classPoints);
        });
        if (this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
            var s = function(t) {
                (t = t || window.event).preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation();
                var i = t.pageX || t.touches[0].pageX, a = t.pageY || t.touches[0].pageY;
                e.el.fire("rot", {
                    x: i,
                    y: a,
                    event: t
                });
            }, r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", s).on("mousedown", s);
            this.rectSelection.set.add(r);
        }
    }, t.prototype.handler = function() {
        var t = this.el.bbox();
        this.nested.matrix(new SVG.Matrix(this.el).translate(t.x, t.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection();
    }, t.prototype.observe = function() {
        var t = this;
        if (MutationObserver) {
            if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver(function() {
                t.handler();
            }), this.observerInst.observe(this.el.node, {
                attributes: !0
            });
            else try {
                this.observerInst.disconnect(), delete this.observerInst;
            } catch (t) {}
        } else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", function() {
            t.handler();
        });
    }, t.prototype.cleanup = function() {
        !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each(function() {
            this.remove();
        }), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each(function() {
            this.remove();
        }), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested);
    }, SVG.extend(SVG.Element, {
        selectize: function(e, i) {
            return "object" == typeof e && (i = e, e = !0), (this.remember("_selectHandler") || new t(this)).init(void 0 === e || e, i || {}), this;
        }
    }), SVG.Element.prototype.selectize.defaults = {
        points: [
            "lt",
            "rt",
            "rb",
            "lb",
            "t",
            "r",
            "b",
            "l"
        ],
        pointsExclude: [],
        classRect: "svg_select_boundingRect",
        classPoints: "svg_select_points",
        pointSize: 7,
        rotationPoint: !0,
        deepSelect: !1,
        pointType: "circle"
    };
}(), function() {
    (function() {
        function t(t) {
            t.remember("_resizeHandler", this), this.el = t, this.parameters = {}, this.lastUpdateCall = null, this.p = t.doc().node.createSVGPoint();
        }
        t.prototype.transformPoint = function(t, e, i) {
            return this.p.x = t - (this.offset.x - window.pageXOffset), this.p.y = e - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m);
        }, t.prototype._extractPosition = function(t) {
            return {
                x: null != t.clientX ? t.clientX : t.touches[0].clientX,
                y: null != t.clientY ? t.clientY : t.touches[0].clientY
            };
        }, t.prototype.init = function(t) {
            var e = this;
            if (this.stop(), "stop" !== t) {
                for(var i in this.options = {}, this.el.resize.defaults)this.options[i] = this.el.resize.defaults[i], void 0 !== t[i] && (this.options[i] = t[i]);
                this.el.on("lt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("lb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("t.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("r.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("b.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("l.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rot.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("point.resize", function(t) {
                    e.resize(t || window.event);
                }), this.update();
            }
        }, t.prototype.stop = function() {
            return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this;
        }, t.prototype.resize = function(t) {
            var e = this;
            this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                x: window.pageXOffset,
                y: window.pageYOffset
            };
            var i = this._extractPosition(t.detail.event);
            if (this.parameters = {
                type: this.el.type,
                p: this.transformPoint(i.x, i.y),
                x: t.detail.x,
                y: t.detail.y,
                box: this.el.bbox(),
                rotation: this.el.transform().rotation
            }, "text" === this.el.type && (this.parameters.fontSize = this.el.attr()["font-size"]), void 0 !== t.detail.i) {
                var a = this.el.array().valueOf();
                this.parameters.i = t.detail.i, this.parameters.pointCoords = [
                    a[t.detail.i][0],
                    a[t.detail.i][1]
                ];
            }
            switch(t.type){
                case "lt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y + i[1]).size(this.parameters.box.width - i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).size(this.parameters.box.width + i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "lb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).size(this.parameters.box.width - i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "t":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).height(this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "r":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + i[0]);
                        }
                    };
                    break;
                case "b":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "l":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).width(this.parameters.box.width - i[0]);
                        }
                    };
                    break;
                case "rot":
                    this.calc = function(t, e) {
                        var i = t + this.parameters.p.x, a = e + this.parameters.p.y, s = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2), r = Math.atan2(a - this.parameters.box.y - this.parameters.box.height / 2, i - this.parameters.box.x - this.parameters.box.width / 2), o = this.parameters.rotation + 180 * (r - s) / Math.PI + this.options.snapToAngle / 2;
                        this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(o - o % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy);
                    };
                    break;
                case "point":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, this.parameters.pointCoords[0], this.parameters.pointCoords[1]), a = this.el.array().valueOf();
                        a[this.parameters.i][0] = this.parameters.pointCoords[0] + i[0], a[this.parameters.i][1] = this.parameters.pointCoords[1] + i[1], this.el.plot(a);
                    };
            }
            this.el.fire("resizestart", {
                dx: this.parameters.x,
                dy: this.parameters.y,
                event: t
            }), SVG.on(window, "touchmove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "touchend.resize", function() {
                e.done();
            }), SVG.on(window, "mousemove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "mouseup.resize", function() {
                e.done();
            });
        }, t.prototype.update = function(t) {
            if (t) {
                var e = this._extractPosition(t), i = this.transformPoint(e.x, e.y), a = i.x - this.parameters.p.x, s = i.y - this.parameters.p.y;
                this.lastUpdateCall = [
                    a,
                    s
                ], this.calc(a, s), this.el.fire("resizing", {
                    dx: a,
                    dy: s,
                    event: t
                });
            } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1]);
        }, t.prototype.done = function() {
            this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone");
        }, t.prototype.snapToGrid = function(t, e, i, a) {
            var s;
            return void 0 !== a ? s = [
                (i + t) % this.options.snapToGrid,
                (a + e) % this.options.snapToGrid
            ] : (i = null == i ? 3 : i, s = [
                (this.parameters.box.x + t + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid,
                (this.parameters.box.y + e + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid
            ]), t < 0 && (s[0] -= this.options.snapToGrid), e < 0 && (s[1] -= this.options.snapToGrid), t -= Math.abs(s[0]) < this.options.snapToGrid / 2 ? s[0] : s[0] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), e -= Math.abs(s[1]) < this.options.snapToGrid / 2 ? s[1] : s[1] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(t, e, i, a);
        }, t.prototype.constraintToBox = function(t, e, i, a) {
            var s, r, o = this.options.constraint || {};
            return void 0 !== a ? (s = i, r = a) : (s = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), void 0 !== o.minX && s + t < o.minX && (t = o.minX - s), void 0 !== o.maxX && s + t > o.maxX && (t = o.maxX - s), void 0 !== o.minY && r + e < o.minY && (e = o.minY - r), void 0 !== o.maxY && r + e > o.maxY && (e = o.maxY - r), [
                t,
                e
            ];
        }, t.prototype.checkAspectRatio = function(t, e) {
            if (!this.options.saveAspectRatio) return t;
            var i = t.slice(), a = this.parameters.box.width / this.parameters.box.height, s = this.parameters.box.width + t[0], r = this.parameters.box.height - t[1], o = s / r;
            return o < a ? (i[1] = s / a - this.parameters.box.height, e && (i[1] = -i[1])) : o > a && (i[0] = this.parameters.box.width - r * a, e && (i[0] = -i[0])), i;
        }, SVG.extend(SVG.Element, {
            resize: function(e) {
                return (this.remember("_resizeHandler") || new t(this)).init(e || {}), this;
            }
        }), SVG.Element.prototype.resize.defaults = {
            snapToAngle: .1,
            snapToGrid: 1,
            constraint: {},
            saveAspectRatio: !1
        };
    }).call(this);
}(), void 0 === window.Apex && (window.Apex = {});
var Gt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "initModules",
            value: function() {
                this.ctx.publicMethods = [
                    "updateOptions",
                    "updateSeries",
                    "appendData",
                    "appendSeries",
                    "isSeriesHidden",
                    "toggleSeries",
                    "showSeries",
                    "hideSeries",
                    "setLocale",
                    "resetSeries",
                    "zoomX",
                    "toggleDataPointSelection",
                    "dataURI",
                    "exportToCSV",
                    "addXaxisAnnotation",
                    "addYaxisAnnotation",
                    "addPointAnnotation",
                    "clearAnnotations",
                    "removeAnnotation",
                    "paper",
                    "destroy"
                ], this.ctx.eventList = [
                    "click",
                    "mousedown",
                    "mousemove",
                    "mouseleave",
                    "touchstart",
                    "touchmove",
                    "touchleave",
                    "mouseup",
                    "touchend"
                ], this.ctx.animations = new b(this.ctx), this.ctx.axes = new J(this.ctx), this.ctx.core = new Wt(this.ctx.el, this.ctx), this.ctx.config = new E({}), this.ctx.data = new W(this.ctx), this.ctx.grid = new j(this.ctx), this.ctx.graphics = new m(this.ctx), this.ctx.coreUtils = new y(this.ctx), this.ctx.crosshairs = new Q(this.ctx), this.ctx.events = new Z(this.ctx), this.ctx.exports = new G(this.ctx), this.ctx.localization = new $(this.ctx), this.ctx.options = new L, this.ctx.responsive = new K(this.ctx), this.ctx.series = new N(this.ctx), this.ctx.theme = new tt(this.ctx), this.ctx.formatters = new T(this.ctx), this.ctx.titleSubtitle = new et(this.ctx), this.ctx.legend = new lt(this.ctx), this.ctx.toolbar = new ht(this.ctx), this.ctx.tooltip = new bt(this.ctx), this.ctx.dimensions = new ot(this.ctx), this.ctx.updateHelpers = new Bt(this.ctx), this.ctx.zoomPanSelection = new ct(this.ctx), this.ctx.w.globals.tooltip = new bt(this.ctx);
            }
        }
    ]), t;
}(), Vt = function() {
    function t(e) {
        a(this, t), this.ctx = e, this.w = e.w;
    }
    return r(t, [
        {
            key: "clear",
            value: function(t) {
                var e = t.isUpdating;
                this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                    isUpdating: e
                });
            }
        },
        {
            key: "killSVG",
            value: function(t) {
                t.each(function(t, e) {
                    this.removeClass("*"), this.off(), this.stop();
                }, !0), t.ungroup(), t.clear();
            }
        },
        {
            key: "clearDomElements",
            value: function(t) {
                var e = this, i = t.isUpdating, a = this.w.globals.dom.Paper.node;
                a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                var s = this.w.globals.dom.baseEl;
                s && this.ctx.eventList.forEach(function(t) {
                    s.removeEventListener(t, e.ctx.events.documentEvent);
                });
                var r = this.w.globals.dom;
                if (null !== this.ctx.el) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elLegendWrap = null, r.elLegendForeign = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
            }
        }
    ]), t;
}(), jt = new WeakMap;
var _t = function() {
    function t(e, i) {
        a(this, t), this.opts = i, this.ctx = this, this.w = new F(i).init(), this.el = e, this.w.globals.cuid = x.randomId(), this.w.globals.chartID = this.w.config.chart.id ? x.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new Gt(this).initModules(), this.create = x.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
    }
    return r(t, [
        {
            key: "render",
            value: function() {
                var t = this;
                return new Promise(function(e, i) {
                    if (null !== t.el) {
                        void 0 === Apex._chartInstances && (Apex._chartInstances = []), t.w.config.chart.id && Apex._chartInstances.push({
                            id: t.w.globals.chartID,
                            group: t.w.config.chart.group,
                            chart: t
                        }), t.setLocale(t.w.config.chart.defaultLocale);
                        var a = t.w.config.chart.events.beforeMount;
                        if ("function" == typeof a && a(t, t.w), t.events.fireEvent("beforeMount", [
                            t,
                            t.w
                        ]), window.addEventListener("resize", t.windowResizeHandler), function(t, e) {
                            var i = !1;
                            if (t.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
                                var a = t.getBoundingClientRect();
                                "none" !== t.style.display && 0 !== a.width || (i = !0);
                            }
                            var s = new ResizeObserver(function(a) {
                                i && e.call(t, a), i = !0;
                            });
                            t.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(t.children).forEach(function(t) {
                                return s.observe(t);
                            }) : s.observe(t), jt.set(e, s);
                        }(t.el.parentNode, t.parentResizeHandler), !t.css) {
                            var s = t.el.getRootNode && t.el.getRootNode(), r = x.is("ShadowRoot", s), o = t.el.ownerDocument, n = o.getElementById("apexcharts-css");
                            if (r || !n) {
                                var l;
                                t.css = document.createElement("style"), t.css.id = "apexcharts-css", t.css.textContent = '@keyframes opaque {\n  0% {\n      opacity: 0\n  }\n\n  to {\n      opacity: 1\n  }\n}\n\n@keyframes resizeanim {\n  0%,to {\n      opacity: 0\n  }\n}\n\n.apexcharts-canvas {\n  position: relative;\n  user-select: none\n}\n\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0,0,0,.5);\n  box-shadow: 0 0 1px rgba(255,255,255,.5);\n  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5)\n}\n\n.apexcharts-inner {\n  position: relative\n}\n\n.apexcharts-text tspan {\n  font-family: inherit\n}\n\n.legend-mouseover-inactive {\n  transition: .15s ease all;\n  opacity: .2\n}\n\n.apexcharts-legend-text {\n  padding-left: 15px;\n  margin-left: -15px;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255,255,255,.96)\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30,30,30,.8)\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit\n}\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #eceff1;\n  border-bottom: 1px solid #ddd\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0,0,0,.7);\n  border-bottom: 1px solid #333\n}\n\n.apexcharts-tooltip-text-goals-value,.apexcharts-tooltip-text-y-value,.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  margin-left: 5px;\n  font-weight: 600\n}\n\n.apexcharts-tooltip-text-goals-label:empty,.apexcharts-tooltip-text-goals-value:empty,.apexcharts-tooltip-text-y-label:empty,.apexcharts-tooltip-text-y-value:empty,.apexcharts-tooltip-text-z-value:empty,.apexcharts-tooltip-title:empty {\n  display: none\n}\n\n.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px\n}\n\n.apexcharts-tooltip-goals-group,.apexcharts-tooltip-text-goals-label,.apexcharts-tooltip-text-goals-value {\n  display: flex\n}\n\n.apexcharts-tooltip-text-goals-label:not(:empty),.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0;\n  margin-right: 10px;\n  border-radius: 50%\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px\n}\n\n.apexcharts-tooltip-series-group-hidden {\n  opacity: 0;\n  height: 0;\n  line-height: 0;\n  padding: 0!important\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px\n}\n\n.apexcharts-custom-tooltip,.apexcharts-tooltip-box {\n  padding: 4px 8px\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: 700\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 5px\n}\n\n.apexcharts-xaxistooltip,.apexcharts-yaxistooltip {\n  opacity: 0;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #eceff1;\n  border: 1px solid #90a4ae\n}\n\n.apexcharts-xaxistooltip {\n  padding: 9px 10px;\n  transition: .15s ease all\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-xaxistooltip:after,.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-left: -6px\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-left: -7px\n}\n\n.apexcharts-xaxistooltip-bottom:after,.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%\n}\n\n.apexcharts-xaxistooltip-top:after,.apexcharts-xaxistooltip-top:before {\n  top: 100%\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-yaxistooltip {\n  padding: 4px 10px\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0,0,0,.7);\n  border: 1px solid rgba(0,0,0,.5);\n  color: #fff\n}\n\n.apexcharts-yaxistooltip:after,.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-top: -6px\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-top: -7px\n}\n\n.apexcharts-yaxistooltip-left:after,.apexcharts-yaxistooltip-left:before {\n  left: 100%\n}\n\n.apexcharts-yaxistooltip-right:after,.apexcharts-yaxistooltip-right:before {\n  right: 100%\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0,0,0,.5)\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none\n}\n\n.apexcharts-xcrosshairs,.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: .15s ease all\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0\n}\n\n.apexcharts-selection-rect {\n  cursor: move\n}\n\n.svg_select_boundingRect,.svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_boundingRect,.apexcharts-selection-rect+g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_points_l,.apexcharts-selection-rect+g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-menu-icon,.apexcharts-pan-icon,.apexcharts-reset-icon,.apexcharts-selection-icon,.apexcharts-toolbar-custom-icon,.apexcharts-zoom-icon,.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6e8192;\n  text-align: center\n}\n\n.apexcharts-menu-icon svg,.apexcharts-reset-icon svg,.apexcharts-zoom-icon svg,.apexcharts-zoomin-icon svg,.apexcharts-zoomout-icon svg {\n  fill: #6e8192\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(.76)\n}\n\n.apexcharts-theme-dark .apexcharts-menu-icon svg,.apexcharts-theme-dark .apexcharts-pan-icon svg,.apexcharts-theme-dark .apexcharts-reset-icon svg,.apexcharts-theme-dark .apexcharts-selection-icon svg,.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,.apexcharts-theme-dark .apexcharts-zoom-icon svg,.apexcharts-theme-dark .apexcharts-zoomin-icon svg,.apexcharts-theme-dark .apexcharts-zoomout-icon svg {\n  fill: #f3f4f5\n}\n\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {\n  fill: #008ffb\n}\n\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg,.apexcharts-theme-light .apexcharts-reset-icon:hover svg,.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {\n  fill: #333\n}\n\n.apexcharts-menu-icon,.apexcharts-selection-icon {\n  position: relative\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px\n}\n\n.apexcharts-menu-icon,.apexcharts-reset-icon,.apexcharts-zoom-icon {\n  transform: scale(.85)\n}\n\n.apexcharts-zoomin-icon,.apexcharts-zoomout-icon {\n  transform: scale(.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px\n}\n\n.apexcharts-pan-icon {\n  transform: scale(.62);\n  position: relative;\n  left: 1px;\n  top: 0\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6e8192;\n  stroke-width: 2\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008ffb\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0 6px 2px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: .15s ease all;\n  pointer-events: none\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: .15s ease all\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0,0,0,.7);\n  color: #fff\n}\n\n@media screen and (min-width:768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n      opacity: 1\n  }\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,.apexcharts-datalabel.apexcharts-element-hidden,.apexcharts-hide .apexcharts-series-points {\n  opacity: 0\n}\n\n.apexcharts-hidden-element-shown {\n  opacity: 1;\n  transition: 0.25s ease all;\n}\n.apexcharts-datalabel,.apexcharts-datalabel-label,.apexcharts-datalabel-value,.apexcharts-datalabels,.apexcharts-pie-label {\n  cursor: default;\n  pointer-events: none\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: .3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease\n}\n\n.apexcharts-radialbar-label {\n  cursor: pointer;\n}\n\n.apexcharts-annotation-rect,.apexcharts-area-series .apexcharts-area,.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-gridline,.apexcharts-line,.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,.apexcharts-point-annotation-label,.apexcharts-radar-series path,.apexcharts-radar-series polygon,.apexcharts-toolbar svg,.apexcharts-tooltip .apexcharts-marker,.apexcharts-xaxis-annotation-label,.apexcharts-yaxis-annotation-label,.apexcharts-zoom-rect {\n  pointer-events: none\n}\n\n.apexcharts-marker {\n  transition: .15s ease all\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden\n}\n\n.contract-trigger:before,.resize-triggers,.resize-triggers>div {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0\n}\n\n.resize-triggers>div {\n  height: 100%;\n  width: 100%;\n  background: #eee;\n  overflow: auto\n}\n\n.contract-trigger:before {\n  overflow: hidden;\n  width: 200%;\n  height: 200%\n}\n\n.apexcharts-bar-goals-markers{\n  pointer-events: none\n}\n\n.apexcharts-bar-shadows{\n  pointer-events: none\n}\n\n.apexcharts-rangebar-goals-markers{\n  pointer-events: none\n}';
                                var h = (null === (l = t.opts.chart) || void 0 === l ? void 0 : l.nonce) || t.w.config.chart.nonce;
                                h && t.css.setAttribute("nonce", h), r ? s.prepend(t.css) : o.head.appendChild(t.css);
                            }
                        }
                        var c = t.create(t.w.config.series, {});
                        if (!c) return e(t);
                        t.mount(c).then(function() {
                            "function" == typeof t.w.config.chart.events.mounted && t.w.config.chart.events.mounted(t, t.w), t.events.fireEvent("mounted", [
                                t,
                                t.w
                            ]), e(c);
                        }).catch(function(t) {
                            i(t);
                        });
                    } else i(new Error("Element not found"));
                });
            }
        },
        {
            key: "create",
            value: function(t, e) {
                var i = this.w;
                new Gt(this).initModules();
                var a = this.w.globals;
                (a.noData = !1, a.animationEnded = !1, this.responsive.checkResponsiveConfig(e), i.config.xaxis.convertedCatToNumeric) && new X(i.config).convertCatToNumericXaxis(i.config, this.ctx);
                if (null === this.el) return a.animationEnded = !0, null;
                if (this.core.setupElements(), "treemap" === i.config.chart.type && (i.config.grid.show = !1, i.config.yaxis[0].show = !1), 0 === a.svgWidth) return a.animationEnded = !0, null;
                var s = y.checkComboSeries(t);
                a.comboCharts = s.comboCharts, a.comboBarCount = s.comboBarCount;
                var r = t.every(function(t) {
                    return t.data && 0 === t.data.length;
                });
                (0 === t.length || r) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(t), this.theme.init(), new H(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), a.noData && a.collapsedSeries.length !== a.series.length && !i.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), a.axisCharts && (this.core.coreCalculations(), "category" !== i.config.xaxis.type && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = i.globals.minX, this.ctx.toolbar.maxX = i.globals.maxX), this.formatters.heatmapLabelFormatters(), new y(this).getLargestMarkerSize(), this.dimensions.plotCoords();
                var o = this.core.xySettings();
                this.grid.createGridMask();
                var n = this.core.plotChartType(t, o), l = new O(this);
                return l.bringForward(), i.config.dataLabels.background.enabled && l.dataLabelsBackground(), this.core.shiftGraphPosition(), {
                    elGraph: n,
                    xyRatios: o,
                    dimensions: {
                        plot: {
                            left: i.globals.translateX,
                            top: i.globals.translateY,
                            width: i.globals.gridWidth,
                            height: i.globals.gridHeight
                        }
                    }
                };
            }
        },
        {
            key: "mount",
            value: function() {
                var t = this, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = this, a = i.w;
                return new Promise(function(s, r) {
                    if (null === i.el) return r(new Error("Not enough data to display or target element not found"));
                    (null === e || a.globals.allSeriesCollapsed) && i.series.handleNoData(), i.grid = new j(i);
                    var o, n, l = i.grid.drawGrid();
                    (i.annotations = new P(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), "back" === a.config.grid.position) && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (o = l.elGridBorders) && void 0 !== o && o.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    if (Array.isArray(e.elGraph)) for(var h = 0; h < e.elGraph.length; h++)a.globals.dom.elGraphical.add(e.elGraph[h]);
                    else a.globals.dom.elGraphical.add(e.elGraph);
                    "front" === a.config.grid.position && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (n = l.elGridBorders) && void 0 !== n && n.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    "front" === a.config.xaxis.crosshairs.position && i.crosshairs.drawXCrosshairs(), "front" === a.config.yaxis[0].crosshairs.position && i.crosshairs.drawYCrosshairs(), "treemap" !== a.config.chart.type && i.axes.drawAxis(a.config.chart.type, l);
                    var c = new V(t.ctx, l), d = new q(t.ctx, l);
                    if (null !== l && (c.xAxisLabelCorrections(l.xAxisTickWidth), d.setYAxisTextAlignments(), a.config.yaxis.map(function(t, e) {
                        -1 === a.globals.ignoreYAxisIndexes.indexOf(e) && d.yAxisTitleRotate(e, t.opposite);
                    })), i.annotations.drawAxesAnnotations(), !a.globals.noData) {
                        if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(e.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                            xyRatios: e.xyRatios
                        });
                        else {
                            var g = a.config.chart.toolbar.tools;
                            [
                                "zoom",
                                "zoomin",
                                "zoomout",
                                "selection",
                                "pan",
                                "reset"
                            ].forEach(function(t) {
                                g[t] = !1;
                            });
                        }
                        a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                    }
                    a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(t) {
                        t.method(t.params, !1, t.context);
                    }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                var t, e;
                window.removeEventListener("resize", this.windowResizeHandler), this.el.parentNode, t = this.parentResizeHandler, (e = jt.get(t)) && (e.disconnect(), jt.delete(t));
                var i = this.w.config.chart.id;
                i && Apex._chartInstances.forEach(function(t, e) {
                    t.id === x.escapeString(i) && Apex._chartInstances.splice(e, 1);
                }), new Vt(this.ctx).clear({
                    isUpdating: !1
                });
            }
        },
        {
            key: "updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], o = this.w;
                return o.globals.selection = void 0, t.series && (this.series.resetSeries(!1, !0, !1), t.series.length && t.series[0].data && (t.series = t.series.map(function(t, i) {
                    return e.updateHelpers._extendSeries(t, i);
                })), this.updateHelpers.revertDefaultAxisMinMax()), t.xaxis && (t = this.updateHelpers.forceXAxisUpdate(t)), t.yaxis && (t = this.updateHelpers.forceYAxisUpdate(t)), o.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), t.theme && (t = this.theme.updateThemeOptions(t)), this.updateHelpers._updateOptions(t, i, a, s, r);
            }
        },
        {
            key: "updateSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(t, e, i);
            }
        },
        {
            key: "appendSeries",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w.config.series.slice();
                return a.push(t), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, e, i);
            }
        },
        {
            key: "appendData",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this;
                i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (null !== t[s] && void 0 !== t[s]) for(var r = 0; r < t[s].data.length; r++)a[s].data.push(t[s].data[r]);
                return i.w.config.series = a, e && (i.w.globals.initialSeries = x.clone(i.w.config.series)), this.update();
            }
        },
        {
            key: "update",
            value: function(t) {
                var e = this;
                return new Promise(function(i, a) {
                    new Vt(e.ctx).clear({
                        isUpdating: !0
                    });
                    var s = e.create(e.w.config.series, t);
                    if (!s) return i(e);
                    e.mount(s).then(function() {
                        "function" == typeof e.w.config.chart.events.updated && e.w.config.chart.events.updated(e, e.w), e.events.fireEvent("updated", [
                            e,
                            e.w
                        ]), e.w.globals.isDirty = !0, i(e);
                    }).catch(function(t) {
                        a(t);
                    });
                });
            }
        },
        {
            key: "getSyncedCharts",
            value: function() {
                var t = this.getGroupedCharts(), e = [
                    this
                ];
                return t.length && (e = [], t.forEach(function(t) {
                    e.push(t);
                })), e;
            }
        },
        {
            key: "getGroupedCharts",
            value: function() {
                var t = this;
                return Apex._chartInstances.filter(function(t) {
                    if (t.group) return !0;
                }).map(function(e) {
                    return t.w.config.chart.group === e.group ? e.chart : t;
                });
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                return this.series.toggleSeries(t);
            }
        },
        {
            key: "highlightSeriesOnLegendHover",
            value: function(t, e) {
                return this.series.toggleSeriesOnHover(t, e);
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                this.series.showSeries(t);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                this.series.hideSeries(t);
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                this.series.isSeriesHidden(t);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.series.resetSeries(t, e);
            }
        },
        {
            key: "addEventListener",
            value: function(t, e) {
                this.events.addEventListener(t, e);
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                this.events.removeEventListener(t, e);
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addXaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addYaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addPointAnnotationExternal(t, e, a);
            }
        },
        {
            key: "clearAnnotations",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, e = this;
                t && (e = t), e.annotations.clearAnnotations(e);
            }
        },
        {
            key: "removeAnnotation",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = this;
                e && (i = e), i.annotations.removeAnnotation(i, t);
            }
        },
        {
            key: "getChartArea",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
            }
        },
        {
            key: "getSeriesTotalXRange",
            value: function(t, e) {
                return this.coreUtils.getSeriesTotalsXRange(t, e);
            }
        },
        {
            key: "getHighestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new U(this.ctx).getMinYMaxY(t).highestY;
            }
        },
        {
            key: "getLowestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new U(this.ctx).getMinYMaxY(t).lowestY;
            }
        },
        {
            key: "getSeriesTotal",
            value: function() {
                return this.w.globals.seriesTotals;
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                return this.updateHelpers.toggleDataPointSelection(t, e);
            }
        },
        {
            key: "zoomX",
            value: function(t, e) {
                this.ctx.toolbar.zoomUpdateOptions(t, e);
            }
        },
        {
            key: "setLocale",
            value: function(t) {
                this.localization.setCurrentLocaleValues(t);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                return new G(this.ctx).dataURI(t);
            }
        },
        {
            key: "exportToCSV",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new G(this.ctx).exportToCSV(t);
            }
        },
        {
            key: "paper",
            value: function() {
                return this.w.globals.dom.Paper;
            }
        },
        {
            key: "_parentResizeCallback",
            value: function() {
                this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
            }
        },
        {
            key: "_windowResize",
            value: function() {
                var t = this;
                clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                    t.w.globals.resized = !0, t.w.globals.dataChanged = !1, t.ctx.update();
                }, 150);
            }
        },
        {
            key: "_windowResizeHandler",
            value: function() {
                var t = this.w.config.chart.redrawOnWindowResize;
                "function" == typeof t && (t = t()), t && this._windowResize();
            }
        }
    ], [
        {
            key: "getChartByID",
            value: function(t) {
                var e = x.escapeString(t);
                if (Apex._chartInstances) {
                    var i = Apex._chartInstances.filter(function(t) {
                        return t.id === e;
                    })[0];
                    return i && i.chart;
                }
            }
        },
        {
            key: "initOnLoad",
            value: function() {
                for(var e = document.querySelectorAll("[data-apexcharts]"), i = 0; i < e.length; i++)new t(e[i], JSON.parse(e[i].getAttribute("data-options"))).render();
            }
        },
        {
            key: "exec",
            value: function(t, e) {
                var i = this.getChartByID(t);
                if (i) {
                    i.w.globals.isExecCalled = !0;
                    var a = null;
                    if (-1 !== i.publicMethods.indexOf(e)) {
                        for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)r[o - 2] = arguments[o];
                        a = i[e].apply(i, r);
                    }
                    return a;
                }
            }
        },
        {
            key: "merge",
            value: function(t, e) {
                return x.extend(t, e);
            }
        }
    ]), t;
}();
module.exports = _t;

},{}],"93meY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _axios = require("axios");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _completeMaintenanceModal = require("./CompleteMaintenanceModal");
var _completeMaintenanceModalDefault = parcelHelpers.interopDefault(_completeMaintenanceModal);
var _loadingCircle = require("../LoadingCircle");
var _gatewayReminderInstances = require("../../Constants/GatewayReminderInstances");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _gatewayReminderInstance = require("../../Lib/GatewayReminderInstance");
var _gatewayReminderInstanceService = require("../../Services/GatewayReminderInstanceService");
var _gatewayReminderInstanceServiceDefault = parcelHelpers.interopDefault(_gatewayReminderInstanceService);
var _dateFormatHelpersUtil = require("../../Utils/dateFormatHelpers.util");
exports.default = /*#__PURE__*/ (0, _react.memo)(MaintenanceWidget);
const initState = {
    error: "",
    instances: [],
    instancesLoading: true,
    showCompleteMaintenanceModal: ""
};
function MaintenanceWidget({ asset, shadow, signalUnitsMap, widget }) {
    const api = (0, _react.useMemo)(()=>new (0, _gatewayReminderInstanceServiceDefault.default)(), []), reminderIdSet = (0, _react.useMemo)(()=>widget?.settings?.maintenance?.reduce?.((set, { reminder_id })=>set.add(reminder_id), new Set()), [
        widget?.settings?.maintenance
    ]), refreshSource = (0, _axios.CancelToken).source();
    const [state, updateState] = (0, _react.useState)(initState);
    const fetchReminderInstances = (0, _react.useCallback)(async (source)=>{
        try {
            updateState(initState);
            const params = {
                gateway_id: asset?._id,
                limit: 500,
                page: 1
            };
            const { data: instances } = await api.getPaginatedGatewayReminderInstances(params, source.token);
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    instances,
                    instancesLoading: false
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    instancesLoading: false
                }));
        }
    }, [
        api,
        asset?._id
    ]), toggleCompleteMaintenanceModal = (0, _react.useCallback)((showCompleteMaintenanceModal = "")=>{
        updateState((prevState)=>({
                ...prevState,
                showCompleteMaintenanceModal
            }));
    }, []);
    const shadowValueBySignalIdMap = (0, _react.useMemo)(()=>shadow?.signalCollections?.reduce?.((map, col)=>{
            if (!Array.isArray(col?.signals) || !col?.signals?.length) return map;
            return col.signals.reduce((acc, s)=>acc.set(s._id, s.value), map);
        }, new Map()) ?? new Map(), [
        shadow
    ]), sortedInstances = (0, _react.useMemo)(()=>state.instances?.filter?.((instance)=>reminderIdSet.has(instance?.GtemplateReminder?._id))?.sort?.((a, b)=>{
            const { MaintenanceNotifications: [{ maintenance_completed, status } = {}] = [] } = a ?? {}, { MaintenanceNotifications: [{ status: s2 } = {}] = [] } = b ?? {};
            switch(true){
                case maintenance_completed:
                case status === (0, _gatewayReminderInstances.UPCOMING) && s2 === (0, _gatewayReminderInstances.DUE):
                    return 1;
                case status === (0, _gatewayReminderInstances.DUE):
                case status === (0, _gatewayReminderInstances.UPCOMING) && s2 !== (0, _gatewayReminderInstances.DUE):
                    return -1;
                default:
                    return 0;
            }
        })?.map?.((instance)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "mb-2 col-6 pl-4 nine-tenth-text text-muted text-truncate",
                        id: `reminder-name-${instance?._id}`,
                        children: [
                            instance?.GtemplateReminder?.name,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                innerClassName: "three-quarter-text rounded-pill",
                                target: `reminder-name-${instance?._id}`,
                                children: instance?.GtemplateReminder?.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-3 d-flex align-items-center justify-content-center mb-2 px-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimeLengthButton, {
                            instance: instance,
                            toggleCompleteMaintenanceModal: toggleCompleteMaintenanceModal
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-2 col-3 d-flex align-items-center justify-content-center nine-tenth-text text-muted pl-0",
                        children: (0, _dateFormatHelpersUtil.formatLocalMonthDayYear)(instance?.MaintenanceHistoryLogs?.[0]?.service_date)
                    })
                ]
            }, instance?._id)) ?? null, [
        reminderIdSet,
        state.instances,
        toggleCompleteMaintenanceModal
    ]);
    const checkedInstances = (0, _react.useMemo)(()=>state.instances?.reduce?.((map, instance)=>state.showCompleteMaintenanceModal === instance._id ? map.set(instance._id, instance) : map, new Map()) ?? new Map(), [
        state.instances,
        state.showCompleteMaintenanceModal
    ]), instanceShadowValueMap = (0, _react.useMemo)(()=>{
        const now = Date.now();
        return state.instances?.reduce?.((map, instance)=>{
            switch(instance.GtemplateReminder.type){
                case 0, _gtemplateReminder.ALL_TYPE:
                    {
                        const calendarProps = (0, _gatewayReminderInstance.generateCalendarTypeProps)(instance, now);
                        const signalProps = (0, _gatewayReminderInstance.generateSignalTypeProps)(instance, shadowValueBySignalIdMap);
                        return map.set(instance._id, {
                            ...calendarProps,
                            ...signalProps
                        });
                    }
                case 0, _gtemplateReminder.CALENDAR_TYPE:
                    return map.set(instance._id, (0, _gatewayReminderInstance.generateCalendarTypeProps)(instance, now));
                case 0, _gtemplateReminder.SIGNAL_TYPE:
                    return map.set(instance._id, (0, _gatewayReminderInstance.generateSignalTypeProps)(instance, shadowValueBySignalIdMap));
                default:
                    break;
            }
            return map;
        }, new Map()) ?? new Map();
    }, [
        shadowValueBySignalIdMap,
        state.instances
    ]);
    const handleCompleteMaintenanceSuccess = (0, _react.useCallback)(async ()=>{
        fetchReminderInstances(refreshSource);
    }, [
        fetchReminderInstances,
        refreshSource
    ]);
    (0, _react.useEffect)(()=>{
        if (!widget.settings?.maintenance?.length) return;
        const source = (0, _axios.CancelToken).source();
        fetchReminderInstances(source);
        return source.cancel;
    }, [
        fetchReminderInstances,
        widget.settings?.maintenance
    ]);
    (0, _react.useEffect)(()=>refreshSource?.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-100 flex-grow-1",
                children: state.instancesLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "h-100 w-100 d-flex align-items-center justify-content-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                        size: "3x"
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "row sticky-top bg-white py-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mb-0 col-6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mb-0 col-3 px-0 text-center text-nowrap nine-tenth-text text-dark font-weight-bold",
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mb-0 col-3 pl-0 text-center text-nowrap nine-tenth-text text-dark font-weight-bold",
                                    children: "Last Service"
                                })
                            ]
                        }),
                        sortedInstances,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "row py-2",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 col-12 text-right text-danger nine-tenth-text",
                                children: state.error
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completeMaintenanceModalDefault.default), {
                checkedInstances: checkedInstances,
                handleCompleteMaintenanceSuccess: handleCompleteMaintenanceSuccess,
                instanceShadowValueMap: instanceShadowValueMap,
                isOpen: !!state.showCompleteMaintenanceModal,
                signalUnitMap: signalUnitsMap,
                toggleModal: ()=>toggleCompleteMaintenanceModal("")
            })
        ]
    });
}
MaintenanceWidget.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    shadow: (0, _propTypesDefault.default).object,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    widget: (0, _propTypesDefault.default).object
};
function TimeLengthButton({ instance, toggleCompleteMaintenanceModal }) {
    const { color, text } = (0, _react.useMemo)(()=>{
        switch(instance?.MaintenanceNotifications?.[0]?.status){
            case 0, _gatewayReminderInstances.DUE:
                return {
                    color: "danger",
                    text: "Due"
                };
            case 0, _gatewayReminderInstances.UPCOMING:
                return {
                    color: "warning",
                    text: "Upcoming"
                };
            default:
                return {
                    color: "success",
                    text: "Ok"
                };
        }
    }, [
        instance?.MaintenanceNotifications
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
        className: `p-0 nine-tenth-text text-${color}`,
        color: "link",
        onClick: ()=>toggleCompleteMaintenanceModal(instance?._id),
        children: text
    });
}
TimeLengthButton.propTypes = {
    instance: (0, _propTypesDefault.default).object,
    toggleCompleteMaintenanceModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","axios":"ffpgq","prop-types":"bnNSm","react":"9njXz","reactstrap":"kjd7g","./CompleteMaintenanceModal":"8CakJ","../LoadingCircle":"aIADA","../../Constants/GatewayReminderInstances":"cmyGT","../../Constants/GtemplateReminder":"kNNU0","../../Lib/GatewayReminderInstance":"gE5HX","../../Services/GatewayReminderInstanceService":"WwEop","../../Utils/dateFormatHelpers.util":"kzAoV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8CakJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactstrap = require("reactstrap");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _progressBars = require("../ProgressBars");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _rbac = require("../../Constants/RBAC");
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _signalUtils = require("../../Lib/SignalUtils");
var _accessTools = require("../../RBAC/AccessTools");
var _maintenanceLogsService = require("../../Services/MaintenanceLogsService");
var _maintenanceLogsServiceDefault = parcelHelpers.interopDefault(_maintenanceLogsService);
exports.default = /*#__PURE__*/ (0, _react.memo)(CompleteMaintenanceModal);
const initState = {
    error: "",
    logInfoMap: new Map(),
    requestPending: false
};
function CompleteMaintenanceModal(props) {
    const { _id: orgID } = (0, _react.useContext)((0, _currentOrgContextDefault.default)), userHasManageAccess = (0, _react.useMemo)(()=>(0, _accessTools.hasManageAccessToResource)(orgID, (0, _rbac.MAINTENANCE)), [
        orgID
    ]), now = (0, _react.useMemo)(()=>new Date(), []), service = (0, _react.useMemo)(()=>new (0, _maintenanceLogsServiceDefault.default)(), []), [state, updateState] = (0, _react.useState)(()=>{
        const logInfoMap = Array.from(props.checkedInstances?.keys?.() ?? []).reduce((map, gateway_reminder_instance_id)=>{
            const { signal_current } = props.instanceShadowValueMap?.get(gateway_reminder_instance_id) || {};
            return map.set(gateway_reminder_instance_id, {
                message: "",
                service_date: now,
                service_value: signal_current
            });
        }, new Map());
        return {
            ...initState,
            logInfoMap
        };
    });
    let source;
    const handleCompleteMaintenanceClick = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    requestPending: true
                }));
            source = (0, _axios.CancelToken).source();
            const body = Array.from(props.checkedInstances ?? new Map()).map(([gateway_reminder_instance_id])=>{
                const { message, service_date, service_value } = state.logInfoMap.get(gateway_reminder_instance_id) ?? {};
                return {
                    gateway_reminder_instance_id,
                    message,
                    service_date,
                    service_value
                };
            });
            await service.createMaintenanceLogs(body, source.token);
            props.handleCompleteMaintenanceSuccess();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    };
    const handleStatePropUpdate = ({ target: { name, value } })=>{
        const [prop, instance_id] = name.split(":");
        updateState((prevState)=>{
            const instanceInfo = prevState.logInfoMap.get(instance_id);
            const logInfoMap = prevState.logInfoMap.set(instance_id, {
                ...instanceInfo,
                [prop]: value
            });
            return {
                ...prevState,
                logInfoMap
            };
        });
    };
    (0, _react.useEffect)(()=>source?.cancel, [
        source
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: props.isOpen,
        scrollable: true,
        size: "xl",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0 modal-title-text",
                toggle: props.toggleModal,
                children: [
                    "Review Reminders",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "text-muted nine-tenth-text ml-3",
                        children: [
                            props.checkedInstances?.size ?? 0,
                            " selected"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid pb-0",
                children: [
                    state.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row sticky-top bg-white",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col-12 text-center text-danger nine-tenth-text",
                            children: state.error
                        })
                    }) : null,
                    Array.from(state.logInfoMap ?? new Map()).map(([instance_id, values])=>{
                        const instance = props.checkedInstances?.get?.(instance_id) || {}, { display_precision, unit } = props.signalUnitMap?.get(instance.GtemplateReminder?.signal_id) || {}, { calendar_end, calendar_percentage, calendar_progress, calendar_text, calendar_upcoming, signal_current, signal_end, signal_margin, signal_next_maintenance_due_at, signal_percentage, signal_progress, signal_text } = props.instanceShadowValueMap?.get(instance_id) || {}, showNextMaintenanceDue = (instance.GtemplateReminder.recurring || userHasManageAccess) && [
                            (0, _gtemplateReminder.ALL_TYPE),
                            (0, _gtemplateReminder.SIGNAL_TYPE)
                        ].includes(instance.GtemplateReminder.type);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "row justify-content-center mb-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                                className: "col-11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardHeader), {
                                        className: "bg-white",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "mb-0 font-weight-bolder text-muted",
                                                children: instance?.GtemplateReminder?.name ?? ""
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "w-75",
                                                children: (()=>{
                                                    switch(instance.GtemplateReminder.type){
                                                        case 0, _gtemplateReminder.ALL_TYPE:
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "mt-2 mb-1",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                                            calendar_end: calendar_end,
                                                                            calendar_percentage: calendar_percentage,
                                                                            calendar_upcoming: calendar_upcoming,
                                                                            instance: instance,
                                                                            progress_color: calendar_progress,
                                                                            text: calendar_text
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "mt-1",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                                            display_precision: display_precision,
                                                                            instance: instance,
                                                                            progress_color: signal_progress,
                                                                            signal_current: signal_current,
                                                                            signal_end: signal_end,
                                                                            signal_margin: signal_margin,
                                                                            signal_percentage: signal_percentage,
                                                                            text: signal_text,
                                                                            unit: unit
                                                                        })
                                                                    })
                                                                ]
                                                            });
                                                        case 0, _gtemplateReminder.CALENDAR_TYPE:
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                                calendar_end: calendar_end,
                                                                calendar_percentage: calendar_percentage,
                                                                calendar_upcoming: calendar_upcoming,
                                                                instance: instance,
                                                                progress_color: calendar_progress,
                                                                text: calendar_text
                                                            });
                                                        case 0, _gtemplateReminder.SIGNAL_TYPE:
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                                instance: instance,
                                                                progress_color: signal_progress,
                                                                signal_current: signal_current,
                                                                signal_end: signal_end,
                                                                signal_margin: signal_margin,
                                                                signal_percentage: signal_percentage,
                                                                text: signal_text,
                                                                unit: unit
                                                            });
                                                        default:
                                                            return null;
                                                    }
                                                })()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardBody), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "d-flex align-items-center justify-content-between",
                                                children: [
                                                    showNextMaintenanceDue ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "mb-0 text-muted three-quarter-text text-nowrap mr-2",
                                                                children: userHasManageAccess ? "Signal value when serviced:" : "Next Maintenance Due at:"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                className: "form-control form-control-sm rounded-lg d-inline",
                                                                disabled: !userHasManageAccess,
                                                                name: `service_value:${instance_id}`,
                                                                onChange: handleStatePropUpdate,
                                                                readOnly: !userHasManageAccess,
                                                                type: "number",
                                                                value: (0, _signalUtils.truncateValueFromString)(userHasManageAccess ? values.service_value : signal_next_maintenance_due_at)
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "mb-0 ml-2 text-muted three-quarter-text text-nowrap",
                                                                children: unit
                                                            })
                                                        ]
                                                    }) : null,
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "mb-0 text-muted three-quarter-text text-nowrap mr-2",
                                                                children: "Service Completion Date:"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                                autoComplete: "off",
                                                                className: "form-control form-control-sm",
                                                                dateFormat: [
                                                                    "MMM do, y"
                                                                ],
                                                                disabled: !userHasManageAccess,
                                                                onChange: (selected)=>handleStatePropUpdate({
                                                                        target: {
                                                                            name: `service_date:${instance_id}`,
                                                                            value: selected
                                                                        }
                                                                    }),
                                                                selected: values.service_date,
                                                                showMonthDropdown: true,
                                                                showYearDropdown: true,
                                                                withPortal: true
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.FormGroup), {
                                                className: "mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                        className: "modal-inputlabel-text",
                                                        for: `message:${instance_id}`,
                                                        children: "Notes"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                                        name: `message:${instance_id}`,
                                                        onChange: handleStatePropUpdate,
                                                        type: "textarea",
                                                        value: values.message
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, instance_id);
                    }) ?? null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "px-4 py-0 nine-tenth-text",
                        color: "outline-secondary",
                        disabled: state.requestPending,
                        onClick: props.toggleModal,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "px-4 py-0 nine-tenth-text",
                        color: "success",
                        disabled: state.requestPending,
                        onClick: handleCompleteMaintenanceClick,
                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Yes, Complete Maintenance"
                    })
                ]
            })
        ]
    });
}
CompleteMaintenanceModal.propTypes = {
    checkedInstances: (0, _propTypesDefault.default).object,
    handleCompleteMaintenanceSuccess: (0, _propTypesDefault.default).func,
    instanceShadowValueMap: (0, _propTypesDefault.default).object,
    isOpen: (0, _propTypesDefault.default).bool,
    signalUnitMap: (0, _propTypesDefault.default).object,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-datepicker":"cGh5X","reactstrap":"kjd7g","../ModalLayout":"2RoDj","../ProgressBars":"bRUqk","../../Constants/GtemplateReminder":"kNNU0","../../Constants/RBAC":"ieo1E","../../Context/CurrentOrgContext":"jQXcJ","../../Lib/SignalUtils":"eTEQK","../../RBAC/AccessTools":"j912a","../../Services/MaintenanceLogsService":"7RlqL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRUqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReminderInstanceCalendarType", ()=>ReminderInstanceCalendarType);
parcelHelpers.export(exports, "ReminderInstanceSignalType", ()=>ReminderInstanceSignalType);
var _jsxRuntime = require("react/jsx-runtime");
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _formatDistanceToNow = require("date-fns/formatDistanceToNow");
var _formatDistanceToNowDefault = parcelHelpers.interopDefault(_formatDistanceToNow);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _gatewayReminderInstances = require("../Constants/GatewayReminderInstances");
var _signalUtils = require("../Lib/SignalUtils");
function ReminderInstanceCalendarType(props) {
    const friendlyFormattedOverdueDisplay = (0, _react.useMemo)(()=>(0, _formatDistanceToNowDefault.default)(new Date(props.calendar_end)), [
        props.calendar_end
    ]), maintenanceDueFormatted = (0, _react.useMemo)(()=>(0, _formatDefault.default)(new Date(props.calendar_end), "LLLL do, y"), [
        props.calendar_end
    ]), status = (0, _react.useMemo)(()=>props.isReportDisplay ? props.instance?.MaintenanceNotifications?.status : props.instance?.MaintenanceNotifications?.[0]?.status, [
        props.instance?.MaintenanceNotifications,
        props.isReportDisplay
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Progress), {
                className: "mb-1",
                color: props.progress_color,
                style: {
                    height: "0.5rem"
                },
                value: props.calendar_percentage * 100
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex align-items-center justify-content-between",
                children: [
                    props.isCompletedOneTimeReminder ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                        className: `three-quarter-text text-${props.text}`,
                        children: "Complete"
                    }) : !status || [
                        (0, _gatewayReminderInstances.COMPLETE),
                        (0, _gatewayReminderInstances.UPCOMING)
                    ].includes(status) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        className: `three-quarter-text text-${props.text}`,
                        children: [
                            "Next upcoming on ",
                            props.calendar_upcoming
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                        className: `three-quarter-text text-${props.text}`,
                        children: (()=>{
                            if (props.isCompletedOneTimeReminder) return null;
                            switch(status){
                                case 0, _gatewayReminderInstances.DUE:
                                    return `${friendlyFormattedOverdueDisplay} overdue`;
                                case 0, _gatewayReminderInstances.UPCOMING:
                                case 0, _gatewayReminderInstances.COMPLETE:
                                default:
                                    return `Next due on ${maintenanceDueFormatted}`;
                            }
                        })()
                    })
                ]
            })
        ]
    });
}
ReminderInstanceCalendarType.propTypes = {
    calendar_end: (0, _propTypesDefault.default).number,
    calendar_percentage: (0, _propTypesDefault.default).number,
    calendar_upcoming: (0, _propTypesDefault.default).string,
    instance: (0, _propTypesDefault.default).object,
    isCompletedOneTimeReminder: (0, _propTypesDefault.default).bool,
    isReportDisplay: (0, _propTypesDefault.default).bool,
    progress_color: (0, _propTypesDefault.default).string,
    text: (0, _propTypesDefault.default).string
};
function ReminderInstanceSignalType(props) {
    const completedAtValue = (0, _react.useMemo)(()=>(0, _signalUtils.truncateValueFromString)(props.signal_value_when_serviced, props.display_precision), [
        props.display_precision,
        props.signal_value_when_serviced
    ]), currentValue = (0, _react.useMemo)(()=>(0, _signalUtils.truncateValueFromString)(props.signal_current, props.display_precision), [
        props.display_precision,
        props.signal_current
    ]), nextDueValue = (0, _react.useMemo)(()=>(0, _signalUtils.truncateValueFromString)(props.instance.next_signal_value_due, props.display_precision), [
        props.display_precision,
        props.instance.next_signal_value_due
    ]), pastDueValue = (0, _react.useMemo)(()=>(0, _signalUtils.truncateValueFromString)(props.signal_current, props.display_precision) - props.signal_end, [
        props.display_precision,
        props.signal_current,
        props.signal_end
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Progress), {
                className: "my-1",
                color: props.progress_color,
                style: {
                    height: "0.5rem"
                },
                value: props.signal_percentage * 100
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "d-flex align-items-center justify-content-between",
                children: [
                    (()=>{
                        switch(true){
                            case !props.isCompletedOneTimeReminder && Number.isFinite(currentValue):
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                    className: `three-quarter-text text-${props.text}`,
                                    children: [
                                        currentValue,
                                        " Total ",
                                        props.unit ?? ""
                                    ]
                                });
                            case props.isCompletedOneTimeReminder && Number.isFinite(completedAtValue):
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                    className: `three-quarter-text text-${props.text}`,
                                    children: [
                                        "Completed at ",
                                        completedAtValue,
                                        " ",
                                        props.unit ?? ""
                                    ]
                                });
                            case !Number.isFinite(completedAtValue):
                            case !Number.isFinite(currentValue):
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                    className: "three-quarter-text text-danger",
                                    children: "Current signal value is unavailable."
                                });
                            default:
                                return null;
                        }
                    })(),
                    Number.isFinite(currentValue) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                        className: `three-quarter-text text-${props.text}`,
                        children: (()=>{
                            if (props.isCompletedOneTimeReminder) return null;
                            switch(props.instance?.MaintenanceNotifications?.[0]?.status){
                                case 0, _gatewayReminderInstances.DUE:
                                    return `${pastDueValue} ${props.unit ?? ""} overdue`;
                                case 0, _gatewayReminderInstances.UPCOMING:
                                case 0, _gatewayReminderInstances.COMPLETE:
                                default:
                                    return `Next due at ${nextDueValue} ${props.unit ?? ""}`;
                            }
                        })()
                    }) : null
                ]
            })
        ]
    });
}
ReminderInstanceSignalType.propTypes = {
    display_precision: (0, _propTypesDefault.default).number,
    instance: (0, _propTypesDefault.default).object,
    isCompletedOneTimeReminder: (0, _propTypesDefault.default).bool,
    isReportDisplay: (0, _propTypesDefault.default).bool,
    progress_color: (0, _propTypesDefault.default).string,
    signal_current: (0, _propTypesDefault.default).number,
    signal_end: (0, _propTypesDefault.default).number,
    signal_margin: (0, _propTypesDefault.default).number,
    signal_percentage: (0, _propTypesDefault.default).number,
    signal_value_when_serviced: (0, _propTypesDefault.default).string,
    text: (0, _propTypesDefault.default).string,
    unit: (0, _propTypesDefault.default).string
};
ReminderInstanceSignalType.defaultProps = {
    display_precision: 2
};

},{"react/jsx-runtime":"1dlk8","date-fns/format":"520Dk","date-fns/formatDistanceToNow":"dEX18","prop-types":"bnNSm","react":"9njXz","reactstrap":"kjd7g","../Constants/GatewayReminderInstances":"cmyGT","../Lib/SignalUtils":"eTEQK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEX18":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatDistanceToNow);
var _indexJs = require("../formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function formatDistanceToNow(dirtyDate, options) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, Date.now(), options);
}

},{"../formatDistance/index.js":"5792U","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5792U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatDistance);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../compareAsc/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../differenceInMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../differenceInSeconds/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultLocale/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../toDate/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/cloneObject/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../_lib/assign/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs9);
var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
function formatDistance(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, _indexJsDefault8.default)(2, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault3.default);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, _indexJsDefault.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, _indexJsDefault6.default)((0, _indexJsDefault5.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, _indexJsDefault4.default)(dirtyBaseDate);
        dateRight = (0, _indexJsDefault4.default)(dirtyDate);
    } else {
        dateLeft = (0, _indexJsDefault4.default)(dirtyDate);
        dateRight = (0, _indexJsDefault4.default)(dirtyBaseDate);
    }
    var seconds = (0, _indexJsDefault2.default)(dateRight, dateLeft);
    var offsetInSeconds = ((0, _indexJsDefault7.default)(dateRight) - (0, _indexJsDefault7.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < MINUTES_IN_MONTH) {
        var days = Math.round(minutes / MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, _indexJsDefault1.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}

},{"../_lib/defaultOptions/index.js":"1cViP","../compareAsc/index.js":"6EgNY","../differenceInMonths/index.js":"hS4KR","../differenceInSeconds/index.js":"16fnU","../_lib/defaultLocale/index.js":"5kaPu","../toDate/index.js":"9koxn","../_lib/cloneObject/index.js":"8f5Mf","../_lib/assign/index.js":"ebaSr","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EgNY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compareAsc);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function compareAsc(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hS4KR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../isLastDayOfMonth/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _indexJsDefault4.default)((0, _indexJsDefault.default)(dirtyDateLeft)) && difference === 1 && (0, _indexJsDefault2.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"9koxn","../differenceInCalendarMonths/index.js":"iE73E","../compareAsc/index.js":"6EgNY","../_lib/requiredArgs/index.js":"9bkfg","../isLastDayOfMonth/index.js":"k8eg9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8eg9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLastDayOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../endOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../endOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function isLastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    return (0, _indexJsDefault1.default)(date).getTime() === (0, _indexJsDefault2.default)(date).getTime();
}

},{"../toDate/index.js":"9koxn","../endOfDay/index.js":"hBRHp","../endOfMonth/index.js":"9a5Tk","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16fnU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInSeconds);
var _indexJs = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInSeconds(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 1000;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInMilliseconds/index.js":"iHFMa","../_lib/requiredArgs/index.js":"9bkfg","../_lib/roundingMethods/index.js":"4ejGu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHFMa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMilliseconds);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInMilliseconds(dateLeft, dateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    return (0, _indexJsDefault.default)(dateLeft).getTime() - (0, _indexJsDefault.default)(dateRight).getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ejGu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", ()=>getRoundingMethod);
var roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
    return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8f5Mf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cloneObject);
var _indexJs = require("../assign/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function cloneObject(object) {
    return (0, _indexJsDefault.default)({}, object);
}

},{"../assign/index.js":"ebaSr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cmyGT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPLETE", ()=>COMPLETE);
parcelHelpers.export(exports, "DUE", ()=>DUE);
parcelHelpers.export(exports, "UPCOMING", ()=>UPCOMING);
parcelHelpers.export(exports, "MAINTENANCE_NOTIFICATION_STATUSES", ()=>MAINTENANCE_NOTIFICATION_STATUSES);
parcelHelpers.export(exports, "DUE_DISPLAY", ()=>DUE_DISPLAY);
parcelHelpers.export(exports, "ONE_TIME_COMPLETE_DISPLAY", ()=>ONE_TIME_COMPLETE_DISPLAY);
parcelHelpers.export(exports, "NEUTRAL_DISPLAY", ()=>NEUTRAL_DISPLAY);
parcelHelpers.export(exports, "UPCOMING_DISPLAY", ()=>UPCOMING_DISPLAY);
parcelHelpers.export(exports, "INSTANCE_COLOR_MAP", ()=>INSTANCE_COLOR_MAP);
parcelHelpers.export(exports, "TAB_NAV_MAP", ()=>TAB_NAV_MAP);
const COMPLETE = "Complete";
const DUE = "Due";
const UPCOMING = "Upcoming";
const MAINTENANCE_NOTIFICATION_STATUSES = [
    COMPLETE,
    DUE,
    UPCOMING
];
const DUE_DISPLAY = {
    progress: "active-dm",
    text: "active-dm"
};
const ONE_TIME_COMPLETE_DISPLAY = {
    progress: "success",
    text: "success"
};
const NEUTRAL_DISPLAY = {
    progress: "dark",
    text: "muted"
};
const UPCOMING_DISPLAY = {
    progress: "warning-yellow",
    text: "muted"
};
const INSTANCE_COLOR_MAP = new Map([
    [
        COMPLETE,
        {
            false: ONE_TIME_COMPLETE_DISPLAY,
            true: NEUTRAL_DISPLAY
        }
    ],
    [
        DUE,
        {
            false: DUE_DISPLAY,
            true: DUE_DISPLAY
        }
    ],
    [
        UPCOMING,
        {
            false: UPCOMING_DISPLAY,
            true: UPCOMING_DISPLAY
        }
    ],
    [
        undefined,
        {
            false: NEUTRAL_DISPLAY,
            true: NEUTRAL_DISPLAY
        }
    ]
]);
const TAB_NAV_MAP = new Map([
    [
        DUE,
        "Overdue"
    ],
    [
        UPCOMING,
        UPCOMING
    ],
    [
        COMPLETE,
        "Historical"
    ]
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eTEQK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchSignals", ()=>fetchSignals);
parcelHelpers.export(exports, "SignalsOption", ()=>SignalsOption);
parcelHelpers.export(exports, "truncateValueFromString", ()=>truncateValueFromString);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
async function fetchSignals({ dataService, doneCallback, errorCallback, orgID, outputSignalLimit, outputSignalPage, searchByName, signalLimit, signalPage, startCallback }) {
    let refineQueryMessage = {
        showNoSearchMessage: true
    };
    if (searchByName) try {
        if (startCallback) startCallback();
        const params = {
            orgID,
            outputSignalLimit,
            outputSignalPage,
            searchByName,
            signalLimit,
            signalPage
        };
        const source = (0, _axios.CancelToken).source();
        const { data, outputSignalCount, signalCount } = await dataService.fetchSignalsData(params, source.token);
        const totalCount = outputSignalCount + signalCount;
        refineQueryMessage = totalCount > data.length ? {
            refineQueryMessage: `${totalCount - data.length} more signals match this search. Please refine your query.`
        } : totalCount === 0 ? {
            showNoResultsMessage: true
        } : {};
        if (doneCallback) doneCallback();
        return data.map(({ name, assetCount })=>{
            return {
                label: name,
                value: name,
                assetCount
            };
        }).concat(refineQueryMessage);
    } catch (err) {
        if ((0, _axios.isCancel)(err)) return;
        const error = err.response?.data?.message ?? err.message;
        if (errorCallback) errorCallback(error);
        return [
            {
                error
            }
        ];
    }
    return [
        refineQueryMessage
    ];
}
function SignalsOption({ data, innerProps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "d-flex align-items-center mt-3 w-100",
        ...innerProps,
        children: (()=>{
            switch(true){
                case !!data.refineQueryMessage:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-warning nine-tenth-text ml-3",
                        children: data.refineQueryMessage
                    });
                case !!data.error:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-danger nine-tenth-text ml-3",
                        children: data.error
                    });
                case !!data.value:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "ml-3 nine-tenth-text text-gray",
                                children: data.value || ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "three-quarter-text ml-4 text-icon-link-gray",
                                children: `Signal found on ${data.assetCount || 0} Assets`
                            }),
                            " "
                        ]
                    });
                case data.showNoResultsMessage:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "mx-auto text-gray three-quarters-text mb-3",
                        children: "No signals match this search"
                    });
                case data.showNoSearchMessage:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "mx-auto text-gray three-quarters-text mb-3",
                        children: "Start typing to search for a signal"
                    });
                default:
                    return null;
            }
        })()
    });
}
SignalsOption.propTypes = {
    innerProps: (0, _propTypesDefault.default).object,
    data: (0, _propTypesDefault.default).shape({
        value: (0, _propTypesDefault.default).string,
        assetCount: (0, _propTypesDefault.default).number,
        refineQueryMessage: (0, _propTypesDefault.default).string,
        showNoSearchMessage: (0, _propTypesDefault.default).bool,
        showNoResultsMessage: (0, _propTypesDefault.default).bool,
        error: (0, _propTypesDefault.default).string
    })
};
function truncateValueFromString(value, precision) {
    const parsed = Number.parseFloat(value);
    if (!Number.isFinite(parsed)) return;
    return Number.isInteger(parsed) ? value : Number.parseFloat(parsed.toFixed(precision ?? 2));
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7RlqL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class MaintenanceLogsService {
    api = new (0, _requestsDefault.default)();
    buildGetMaintenanceLogsRequest(params, cancelToken) {
        return {
            cancelToken,
            endpoint: "/v2/maintenance-log",
            method: "get",
            params,
            service: "maintenance"
        };
    }
    async getMaintenanceLogs(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGetMaintenanceLogsRequest(params, cancelToken));
        return data;
    }
    buildDownloadMaintenanceLogsCsvRequest(params, cancelToken) {
        return {
            cancelToken,
            endpoint: "/v2/maintenance-log/csv",
            method: "get",
            params,
            service: "maintenance"
        };
    }
    async downloadMaintenanceLogsCsv(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDownloadMaintenanceLogsCsvRequest(params, cancelToken));
        return data;
    }
    buildCreateMaintenanceLogsRequest(data, cancelToken) {
        return {
            cancelToken,
            data,
            endpoint: "/v2/maintenance-log",
            method: "post",
            service: "maintenance"
        };
    }
    async createMaintenanceLogs(body, cancelToken) {
        return this.api.request(this.buildCreateMaintenanceLogsRequest(body, cancelToken));
    }
}
exports.default = MaintenanceLogsService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gE5HX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateCalendarTypeProps", ()=>generateCalendarTypeProps);
parcelHelpers.export(exports, "generateSignalTypeProps", ()=>generateSignalTypeProps);
parcelHelpers.export(exports, "generateOrgReportSignalTypeProps", ()=>generateOrgReportSignalTypeProps);
parcelHelpers.export(exports, "getDateTriggered", ()=>getDateTriggered);
parcelHelpers.export(exports, "getOrgReportDateTriggered", ()=>getOrgReportDateTriggered);
parcelHelpers.export(exports, "getOrgReportServiceDetails", ()=>getOrgReportServiceDetails);
parcelHelpers.export(exports, "getOrgReportTimeTriggered", ()=>getOrgReportTimeTriggered);
parcelHelpers.export(exports, "getServiceDetails", ()=>getServiceDetails);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _isAfter = require("date-fns/isAfter");
var _isAfterDefault = parcelHelpers.interopDefault(_isAfter);
var _gatewayReminderInstances = require("../Constants/GatewayReminderInstances");
function generateCalendarTypeProps(instance, now, isOrgReport = false) {
    const { GtemplateReminder: { recurring }, MaintenanceHistoryLogs, MaintenanceNotifications, next_time_due, next_time_upcoming } = instance;
    const calendar_start = new Date(next_time_upcoming).getTime(), calendar_end = new Date(next_time_due).getTime(), isCompletedOneTimeReminder = isOrgReport ? !recurring && !!MaintenanceNotifications?.MaintenanceHistoryLog?._id : !recurring && !!MaintenanceHistoryLogs?.length, calendar_percentage = isCompletedOneTimeReminder ? 1 : (now - calendar_start) / (calendar_end - calendar_start), calendar_upcoming_epoch = new Date(next_time_upcoming).getTime(), calendar_upcoming = (0, _formatDefault.default)(calendar_upcoming_epoch, "LLLL do, y");
    const status = (0, _isAfterDefault.default)(now, calendar_end) ? (0, _gatewayReminderInstances.DUE) : (0, _isAfterDefault.default)(now, calendar_start) ? (0, _gatewayReminderInstances.UPCOMING) : undefined, { progress, text } = (0, _gatewayReminderInstances.INSTANCE_COLOR_MAP).get(status)?.[recurring] || {};
    return {
        calendar_end,
        calendar_percentage,
        calendar_progress: progress,
        calendar_start,
        calendar_text: text,
        calendar_upcoming,
        calendar_upcoming_epoch
    };
}
function generateSignalTypeProps(instance, shadowValueBySignalIdMap) {
    const { GtemplateReminder: { recurring, signal_id, trigger_conditions: { signal_trigger: { interval, margin } } }, MaintenanceHistoryLogs, MaintenanceNotifications, next_signal_value_due } = instance;
    const isCompletedOneTimeReminder = !recurring && !!MaintenanceHistoryLogs?.length, signal_current = shadowValueBySignalIdMap.get(signal_id), signal_end = Number.parseFloat(next_signal_value_due), signal_next_maintenance_due_at = signal_current + interval, signal_start = Number.parseFloat(next_signal_value_due) - interval, signal_percentage = isCompletedOneTimeReminder ? 1 : (signal_current - signal_start) / (Number.parseFloat(next_signal_value_due) - signal_start);
    let status = Array.isArray(MaintenanceNotifications) ? MaintenanceNotifications?.[0]?.status : MaintenanceNotifications?.status;
    switch(true){
        case signal_current >= signal_end:
            status = (0, _gatewayReminderInstances.DUE);
            break;
        case signal_current >= signal_end - Number.parseInt(margin):
            status = (0, _gatewayReminderInstances.UPCOMING);
            break;
        case !Number.isFinite(signal_current):
        default:
            break;
    }
    const { progress, text } = (0, _gatewayReminderInstances.INSTANCE_COLOR_MAP).get(status)?.[recurring] || {};
    return {
        signal_current,
        signal_end,
        signal_margin: margin,
        signal_next_maintenance_due_at,
        signal_percentage,
        signal_progress: progress,
        signal_start,
        signal_text: text
    };
}
function generateOrgReportSignalTypeProps(instance) {
    const { GtemplateReminder: { recurring, trigger_conditions: { signal_trigger: { interval, margin } } }, MaintenanceNotifications: { MaintenanceHistoryLog } = {}, next_signal_value_due, shadow_value } = instance;
    const isCompletedOneTimeReminder = !recurring && !!MaintenanceHistoryLog?._id, signal_current = shadow_value, signal_end = Number.parseFloat(next_signal_value_due), signal_next_maintenance_due_at = signal_current + interval, signal_start = Number.parseFloat(next_signal_value_due) - interval, signal_percentage = isCompletedOneTimeReminder ? 1 : (signal_current - signal_start) / (Number.parseFloat(next_signal_value_due) - signal_start);
    return {
        signal_current,
        signal_end,
        signal_margin: margin,
        signal_next_maintenance_due_at,
        signal_percentage,
        signal_start
    };
}
function getDateTriggered(instance) {
    const { MaintenanceNotifications: [{ status, updatedAt } = {}] = {} } = instance;
    switch(status){
        case 0, _gatewayReminderInstances.DUE:
        case 0, _gatewayReminderInstances.UPCOMING:
            return (0, _formatDefault.default)(new Date(updatedAt), "LLLL do, y");
        case 0, _gatewayReminderInstances.COMPLETE:
        default:
            return "N/A";
    }
}
function getOrgReportDateTriggered(instance) {
    const { MaintenanceNotifications: { updatedAt } = {} } = instance;
    return (0, _formatDefault.default)(new Date(updatedAt), "LLLL do, y");
}
function getOrgReportServiceDetails(instance) {
    const { MaintenanceNotifications: { MaintenanceHistoryLog: { contact_info, service_date } = {} } = {} } = instance;
    const last_service_date = service_date ? (0, _formatDefault.default)(new Date(service_date), "LLLL do, y") : "";
    return {
        contact_info,
        last_service_date
    };
}
function getOrgReportTimeTriggered(instance) {
    const { MaintenanceNotifications: { updatedAt } = {} } = instance;
    return (0, _formatDefault.default)(new Date(updatedAt), "h:mm aa");
}
function getServiceDetails(instance) {
    const { MaintenanceHistoryLogs: [{ contact_info, service_date } = {}] = [] } = instance;
    const last_service_date = service_date ? (0, _formatDefault.default)(new Date(service_date), "LLLL do, y") : "";
    return {
        contact_info,
        last_service_date
    };
}

},{"date-fns/format":"520Dk","date-fns/isAfter":"1N23w","../Constants/GatewayReminderInstances":"cmyGT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUTDF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
exports.default = /*#__PURE__*/ (0, _react.memo)(StaticTextWidget);
function StaticTextWidget({ data: { links, staticText } }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "container-fluid nine-tenth-text",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "row my-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "col-12 mb-0",
                    style: {
                        whiteSpace: "pre-line"
                    },
                    children: staticText
                })
            }),
            links?.map?.(({ display, url }, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col-12",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "btn btn-link p-0 nine-tenth-text",
                            href: url,
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: display
                        })
                    })
                }, `${display}-${i}`)) || null
        ]
    });
}
StaticTextWidget.propTypes = {
    data: (0, _propTypesDefault.default).shape({
        links: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            display: (0, _propTypesDefault.default).string,
            url: (0, _propTypesDefault.default).string
        })),
        staticText: (0, _propTypesDefault.default).string
    })
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4f9Yq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _tagService = require("../../Services/TagService");
var _tagServiceDefault = parcelHelpers.interopDefault(_tagService);
exports.default = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(TextTagsWidget));
function TextTagsWidget({ asset, widget }, ref) {
    const [state, updateState] = (0, _react.useState)({
        assetTagsMap: new Map(),
        dataLoading: true
    });
    const source = (0, _axios.CancelToken).source();
    const fetchAssetTags = async ()=>{
        try {
            const params = {
                orgID: asset.orgID
            };
            const assetTags = await new (0, _tagServiceDefault.default)().fetchAllTags(asset._id, params, source.token);
            const assetTagsMap = new Map(assetTags.map(({ name, value })=>[
                    name,
                    value
                ]));
            updateState({
                ...state,
                assetTagsMap,
                dataLoading: false
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                dataLoading: false
            });
        }
    };
    (0, _react.useImperativeHandle)(ref, ()=>({
            fetchAssetTags
        }));
    (0, _react.useEffect)(()=>{
        fetchAssetTags();
        return source.cancel;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "w-100 overflow-auto px-3",
        children: state.dataLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "h-100 w-100 d-flex align-items-center justify-content-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                color: "var(--brand-primary)",
                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                size: "2x",
                spin: true
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "table table-borderless table-sm",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "text-left font-weight-light sticky-top bg-white text-text-light-gray",
                                scope: "col",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "text-left font-weight-light sticky-top bg-white text-text-light-gray",
                                scope: "col",
                                children: "Value"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: (widget?.settings?.tags ?? []).map((name, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            className: "text-break",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-muted font-weight-medium text-left",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-muted font-weight-medium text-left",
                                    children: state.assetTagsMap.get(name) || ""
                                })
                            ]
                        }, `${name}-${i}`))
                })
            ]
        })
    });
}
TextTagsWidget.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    }),
    widget: (0, _propTypesDefault.default).shape({
        settings: (0, _propTypesDefault.default).shape({
            tags: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
        })
    })
};
TextTagsWidget.defaultProps = {
    asset: {},
    widget: {
        settings: {}
    }
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Services/TagService":"6HtCg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUy6V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _dateFormatHelpersUtil = require("../../Utils/dateFormatHelpers.util");
function TextWidget({ data = [], displayTextAsGrid, showTimeSinceLastUpdated, updateRealTime }) {
    const timeSinceLastUpdatedEnabled = (0, _react.useMemo)(()=>showTimeSinceLastUpdated && updateRealTime, [
        showTimeSinceLastUpdated,
        updateRealTime
    ]);
    const dataRef = (0, _react.useRef)(data);
    const [state, updateState] = (0, _react.useState)(data);
    const displayDates = state.map(({ timestamp, type })=>{
        return getTimeFormat(timestamp, timeSinceLastUpdatedEnabled, type === "outputSignal");
    });
    useInterval(()=>{
        if (!timeSinceLastUpdatedEnabled) return;
        updateState([
            ...state
        ]);
    }, 1000);
    (0, _react.useEffect)(()=>{
        if ((0, _isEqualDefault.default)(data, dataRef?.current)) return;
        dataRef.current = data;
        updateState(data);
    }, [
        data
    ]);
    const formatValue = (0, _react.useCallback)((value)=>{
        if ((0, _isNilDefault.default)(value)) return "--";
        return (0, _isStringDefault.default)(value) && /\n/.exec(value) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
            children: value
        }) : value; // add pre tags only for strings with newlines in them
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "overflow-auto w-100 flex-grow-1",
        children: displayTextAsGrid ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "h-100 container-fluid",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "h-100 row align-items-stretch justify-content-center",
                children: state.map(({ name, unit, value }, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `d-flex col-${state?.length === 1 ? "12" : state?.length === 2 ? "auto" : "6"} align-items-center justify-content-center ${state?.length === 2 ? "px-0" : ""}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                            className: `mb-0 display-${state?.length <= 2 ? 1 : state?.length - 1} text-muted font-weight-normal`,
                            "data-tip": true,
                            "data-for": `${name}-${i}-tooltip`,
                            children: [
                                formatValue(value),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactTooltipDefault.default), {
                                    id: `${name}-${i}-tooltip`,
                                    type: "info",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "mb-0 text-center",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "mb-0 text-center",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: formatValue(value)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: !(0, _isNilDefault.default)(value) && unit ? ` ${unit}` : ""
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, `${name}-${i}`))
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "text-left w-auto my-1 mx-3",
            style: {
                tableLayout: "fixed"
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "font-weight-light p-1 sticky-top bg-white text-text-light-gray",
                                children: "Signal Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "font-weight-light p-1 sticky-top bg-white text-text-light-gray",
                                children: "Value"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "font-weight-light p-1 sticky-top bg-white text-text-light-gray text-nowrap",
                                children: showTimeSinceLastUpdated && updateRealTime ? "Last Updated" : "Updated At"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                    children: state.map(({ name, unit, value }, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            className: "text-break nine-tenth-text",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-muted font-weight-normal p-1",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                    className: "text-muted font-weight-normal p-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: formatValue(value)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-weight-light",
                                            children: !(0, _isNilDefault.default)(value) && unit ? ` ${unit}` : ""
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-muted font-weight-normal p-1",
                                    children: displayDates[i]
                                })
                            ]
                        }, `${name}-${i}`))
                })
            ]
        })
    });
}
TextWidget.propTypes = {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    displayTextAsGrid: (0, _propTypesDefault.default).bool,
    showTimeSinceLastUpdated: (0, _propTypesDefault.default).bool,
    updateRealTime: (0, _propTypesDefault.default).bool
};
TextWidget.defaultProps = {
    data: []
};
function useInterval(callback, delay) {
    const savedCallback = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, _react.useEffect)(()=>{
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = window.setInterval(tick, delay);
            return ()=>window.clearInterval(id);
        }
    }, [
        delay
    ]);
}
function getTimeFormat(timestamp, showLastUpdated, isCalculatedSignal) {
    const date = new Date(timestamp);
    if (!(0, _isValidDefault.default)(date)) return "--";
    if (!showLastUpdated) return isCalculatedSignal ? (0, _dateFormatHelpersUtil.formatUTCForAssetDashboardTile)(date) : (0, _dateFormatHelpersUtil.formatLocalForAssetDashboardTile)(date);
    const diff = (0, _momentDefault.default)().diff((0, _momentDefault.default)(timestamp));
    const duration = (0, _momentDefault.default).duration(diff);
    const days = Math.floor(duration.asDays());
    const hours = String(Math.floor(duration.asHours() % 24)).padStart(2, "0");
    const mins = String(Math.floor(duration.asMinutes() % 60)).padStart(2, "0");
    const secs = String(Math.floor(duration.asSeconds() % 60)).padStart(2, "0");
    return `${days ? `${days}d ` : ""}${hours}:${mins}:${secs}`;
}

},{"react/jsx-runtime":"1dlk8","date-fns/isValid":"l72u5","lodash/isEqual":"3mRdp","lodash/isNil":"eS6AM","lodash/isString":"5nkFr","moment":"1e4qG","prop-types":"bnNSm","react":"9njXz","react-tooltip":"4ejwp","../../Utils/dateFormatHelpers.util":"kzAoV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eS6AM":[function(require,module,exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"33zDF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EngineUtilizationBarChart", ()=>EngineUtilizationBarChart);
parcelHelpers.export(exports, "FuelUtilizationBarChart", ()=>FuelUtilizationBarChart);
var _jsxRuntime = require("react/jsx-runtime");
var _round = require("lodash/round");
var _roundDefault = parcelHelpers.interopDefault(_round);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactApexcharts = require("react-apexcharts");
var _reactApexchartsDefault = parcelHelpers.interopDefault(_reactApexcharts);
var _signal = require("../../Constants/Signal");
var _dateFormatHelpersUtil = require("../../Utils/dateFormatHelpers.util");
const IDLE_ENGINE_HOURS_LABEL = "Idle Engine Hours";
const IDLE_FUEL_USED_LABEL = "Idle Fuel Used";
const WORKING_ENGINE_HOURS_LABEL = "Working Engine Hours";
const WORKING_FUEL_USED_LABEL = "Working Fuel Used";
function EngineUtilizationBarChart({ aggregation, data, graphIndex, graphWidgetIDs, renderNextGraph, title }) {
    const targetData = (0, _react.useMemo)(()=>data?.get?.(aggregation) ?? new Map(), [
        aggregation,
        data
    ]);
    const { categories, series } = (0, _react.useMemo)(()=>Array.from(targetData).reduce((acc, [ts, values])=>{
            const { [(0, _signal.ENGINE_HOURS)]: total, [(0, _signal.IDLE_ENGINE_HOURS)]: idle } = values;
            const totalHours = total?.max - total?.min, idleHours = idle?.max - idle?.min, activeHours = totalHours - idleHours;
            if (Number.isFinite(activeHours)) {
                acc.categories.push(ts);
                acc.series[0].data.push((0, _roundDefault.default)(activeHours, 2));
                acc.series[1].data.push((0, _roundDefault.default)(idleHours, 2));
            }
            return acc;
        }, {
            categories: [],
            series: [
                {
                    data: [],
                    name: WORKING_ENGINE_HOURS_LABEL
                },
                {
                    data: [],
                    name: IDLE_ENGINE_HOURS_LABEL
                }
            ]
        }), [
        targetData
    ]);
    const options = (0, _react.useMemo)(()=>({
            chart: {
                events: {
                    mounted: function() {
                        if (graphWidgetIDs.length - 1 <= graphIndex) return;
                        renderNextGraph(graphWidgetIDs[graphIndex + 1]);
                    }
                },
                fontFamily: '"Roboto", sans-serif',
                id: `${title}-${graphIndex}`,
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: true
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                fontSize: "10px",
                position: "bottom"
            },
            plotOptions: {
                bar: {
                    barHeight: "100%",
                    dataLabels: {
                        total: {
                            enabled: true,
                            formatter: (value)=>(0, _roundDefault.default)(value, 2),
                            style: {
                                fontSize: "13px",
                                fontWeight: 900
                            }
                        }
                    },
                    horizontal: false
                }
            },
            theme: {
                palette: "palette6"
            },
            xaxis: {
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                categories,
                labels: {
                    formatter: (value)=>{
                        const date = new Date(value);
                        switch(aggregation){
                            case 0, _signal.DAILY:
                                return (0, _dateFormatHelpersUtil.formatUTCMonthDay)(date);
                            case 0, _signal.MONTHLY:
                                return (0, _dateFormatHelpersUtil.formatUTCFullMonth)(date);
                            case 0, _signal.WEEKLY:
                                return (0, _dateFormatHelpersUtil.formatUTCForWeeklyUtilizationTile)(date);
                            default:
                                return value;
                        }
                    },
                    rotate: -33
                },
                type: "category"
            },
            yaxis: {
                labels: {
                    formatter: (val)=>(0, _roundDefault.default)(val, 2)
                }
            }
        }), [
        aggregation,
        categories,
        graphIndex,
        graphWidgetIDs,
        renderNextGraph,
        title
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactApexchartsDefault.default), {
        height: "100%",
        options: options,
        series: series,
        type: "bar",
        width: "100%"
    });
}
EngineUtilizationBarChart.propTypes = {
    aggregation: (0, _propTypesDefault.default).string,
    data: (0, _propTypesDefault.default).object,
    graphIndex: (0, _propTypesDefault.default).number,
    graphWidgetIDs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    renderNextGraph: (0, _propTypesDefault.default).func,
    title: (0, _propTypesDefault.default).string
};
function FuelUtilizationBarChart({ aggregation, data, graphIndex, graphWidgetIDs, renderNextGraph, title }) {
    const targetData = (0, _react.useMemo)(()=>data?.get?.(aggregation) ?? new Map(), [
        aggregation,
        data
    ]);
    const { categories, series } = (0, _react.useMemo)(()=>Array.from(targetData).reduce((acc, [ts, values])=>{
            const { [(0, _signal.FUEL_USED)]: total, [(0, _signal.IDLE_FUEL_USED)]: idle } = values;
            const totalHours = total?.max - total?.min, idleHours = idle?.max - idle?.min, activeHours = totalHours - idleHours;
            if (Number.isFinite(activeHours)) {
                acc.categories.push(ts);
                acc.series[0].data.push((0, _roundDefault.default)(activeHours, 2));
                acc.series[1].data.push((0, _roundDefault.default)(idleHours, 2));
            }
            return acc;
        }, {
            categories: [],
            series: [
                {
                    data: [],
                    name: WORKING_FUEL_USED_LABEL
                },
                {
                    data: [],
                    name: IDLE_FUEL_USED_LABEL
                }
            ]
        }), [
        targetData
    ]);
    const options = (0, _react.useMemo)(()=>({
            chart: {
                events: {
                    mounted: function() {
                        if (graphWidgetIDs.length - 1 <= graphIndex) return;
                        renderNextGraph(graphWidgetIDs[graphIndex + 1]);
                    }
                },
                fontFamily: '"Roboto", sans-serif',
                id: `${title}-${graphIndex}`,
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: true
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                fontSize: "10px",
                position: "bottom"
            },
            plotOptions: {
                bar: {
                    barHeight: "100%",
                    dataLabels: {
                        total: {
                            enabled: true,
                            formatter: (value)=>(0, _roundDefault.default)(value, 2),
                            style: {
                                fontSize: "13px",
                                fontWeight: 900
                            }
                        }
                    },
                    horizontal: false
                }
            },
            theme: {
                palette: "palette5"
            },
            xaxis: {
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                categories,
                labels: {
                    formatter: (value)=>{
                        const date = new Date(value);
                        switch(aggregation){
                            case 0, _signal.DAILY:
                                return (0, _dateFormatHelpersUtil.formatUTCMonthDay)(date);
                            case 0, _signal.MONTHLY:
                                return (0, _dateFormatHelpersUtil.formatUTCFullMonth)(date);
                            case 0, _signal.WEEKLY:
                                return (0, _dateFormatHelpersUtil.formatUTCForWeeklyUtilizationTile)(date);
                            default:
                                return value;
                        }
                    },
                    rotate: -25
                },
                type: "category"
            },
            yaxis: {
                labels: {
                    formatter: (val)=>(0, _roundDefault.default)(val, 2)
                }
            }
        }), [
        aggregation,
        categories,
        graphIndex,
        graphWidgetIDs,
        renderNextGraph,
        title
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactApexchartsDefault.default), {
        height: "100%",
        options: options,
        series: series,
        type: "bar",
        width: "100%"
    });
}
FuelUtilizationBarChart.propTypes = {
    aggregation: (0, _propTypesDefault.default).string,
    data: (0, _propTypesDefault.default).object,
    graphIndex: (0, _propTypesDefault.default).number,
    graphWidgetIDs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    renderNextGraph: (0, _propTypesDefault.default).func,
    title: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"1dlk8","lodash/round":"immc6","prop-types":"bnNSm","react":"9njXz","react-apexcharts":"lEV8Y","../../Constants/Signal":"bTf7q","../../Utils/dateFormatHelpers.util":"kzAoV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7AAiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EngineUtilizationTextWidget", ()=>EngineUtilizationTextWidget);
parcelHelpers.export(exports, "FuelUtilizationTextWidget", ()=>FuelUtilizationTextWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _signal = require("../../Constants/Signal");
function EngineUtilizationTextWidget({ data }) {
    const daily = (0, _react.useMemo)(()=>{
        const { [(0, _signal.ENGINE_HOURS)]: all, [(0, _signal.IDLE_ENGINE_HOURS)]: idle } = data?.get?.((0, _signal.DAILY)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = (total - idle_total) / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]), lifetime = (0, _react.useMemo)(()=>{
        const { [(0, _signal.ENGINE_HOURS)]: all, [(0, _signal.IDLE_ENGINE_HOURS)]: idle } = data?.get?.((0, _signal.LIFETIME)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = (total - idle_total) / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]), monthly = (0, _react.useMemo)(()=>{
        const { [(0, _signal.ENGINE_HOURS)]: all, [(0, _signal.IDLE_ENGINE_HOURS)]: idle } = data?.get?.((0, _signal.MONTHLY)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = (total - idle_total) / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]), weekly = (0, _react.useMemo)(()=>{
        const { [(0, _signal.ENGINE_HOURS)]: all, [(0, _signal.IDLE_ENGINE_HOURS)]: idle } = data?.get?.((0, _signal.WEEKLY)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = (total - idle_total) / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]);
    const formatNumber = (0, _react.useCallback)((value)=>{
        if (!Number.isFinite(value)) return "not available";
        return Number.isInteger(value) ? `${value} Hrs` : `${value.toFixed(2)} Hrs`;
    }, []);
    const formatPercentage = (0, _react.useCallback)((value)=>{
        if (!Number.isFinite(value)) return "not available";
        return Number.isInteger(value) ? `${value} %` : `${value.toFixed(2)} %`;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "h-100 w-100 px-3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "table table-borderless table-hover table-responsive-sm h-100 text-secondary",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                scope: "col"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "text-nowrap text-center",
                                scope: "col",
                                children: "Engine Hours"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "text-nowrap text-center",
                                scope: "col",
                                children: "Engine Working %"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    scope: "row",
                                    children: "Lifetime"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(lifetime?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(lifetime?.percentage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    scope: "row",
                                    children: "Today"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(daily?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(daily?.percentage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-nowrap",
                                    scope: "row",
                                    children: "This Week"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(weekly?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(weekly?.percentage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-nowrap",
                                    scope: "row",
                                    children: "This Month"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(monthly?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(monthly?.percentage)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
EngineUtilizationTextWidget.propTypes = {
    data: (0, _propTypesDefault.default).object
};
function FuelUtilizationTextWidget({ data }) {
    const daily = (0, _react.useMemo)(()=>{
        const { [(0, _signal.FUEL_USED)]: all, [(0, _signal.IDLE_FUEL_USED)]: idle } = data?.get?.((0, _signal.DAILY)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = idle_total / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]), lifetime = (0, _react.useMemo)(()=>{
        const { [(0, _signal.FUEL_USED)]: all, [(0, _signal.IDLE_FUEL_USED)]: idle } = data?.get?.((0, _signal.LIFETIME)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = (total - idle_total) / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]), monthly = (0, _react.useMemo)(()=>{
        const { [(0, _signal.FUEL_USED)]: all, [(0, _signal.IDLE_FUEL_USED)]: idle } = data?.get?.((0, _signal.MONTHLY)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = (total - idle_total) / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]), weekly = (0, _react.useMemo)(()=>{
        const { [(0, _signal.FUEL_USED)]: all, [(0, _signal.IDLE_FUEL_USED)]: idle } = data?.get?.((0, _signal.WEEKLY)) ?? {};
        const idle_total = idle?.max - idle?.min, total = all?.max - all?.min, percentage = (total - idle_total) / total * 100;
        return {
            percentage,
            total
        };
    }, [
        data
    ]);
    const formatNumber = (0, _react.useCallback)((value)=>{
        if (!Number.isFinite(value)) return "not available";
        return Number.isInteger(value) ? value : value.toFixed(2);
    }, []);
    const formatPercentage = (0, _react.useCallback)((value)=>{
        if (!Number.isFinite(value)) return "not available";
        return Number.isInteger(value) ? `${value} %` : `${value.toFixed(2)} %`;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "h-100 w-100 px-3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
            className: "table table-borderless table-hover table-responsive-sm h-100 text-secondary",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                scope: "col"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "text-nowrap text-center",
                                scope: "col",
                                children: "Fuel Used (gal/hr)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "text-nowrap text-center",
                                scope: "col",
                                children: "Working Fuel %"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    scope: "row",
                                    children: "Lifetime"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(lifetime?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(lifetime?.percentage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    scope: "row",
                                    children: "Today"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(daily?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(daily?.percentage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-nowrap",
                                    scope: "row",
                                    children: "This Week"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(weekly?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(weekly?.percentage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "text-nowrap",
                                    scope: "row",
                                    children: "This Month"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatNumber(monthly?.total)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    className: "text-center",
                                    children: formatPercentage(monthly?.percentage)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
FuelUtilizationTextWidget.propTypes = {
    data: (0, _propTypesDefault.default).object
};

},{"react/jsx-runtime":"1dlk8","prop-types":"bnNSm","react":"9njXz","../../Constants/Signal":"bTf7q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9or2Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScanWidget", ()=>ScanWidget);
parcelHelpers.export(exports, "GraphWidget", ()=>GraphWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactApexcharts = require("react-apexcharts");
var _reactApexchartsDefault = parcelHelpers.interopDefault(_reactApexcharts);
var _widgetTypes = require("../../Constants/WidgetTypes");
var _graphOptionsBuilder = require("../../Lib/GraphOptionsBuilder");
var _graphOptionsBuilderDefault = parcelHelpers.interopDefault(_graphOptionsBuilder);
var _widgetUtils = require("../../Lib/WidgetUtils");
var _widgetUtilsDefault = parcelHelpers.interopDefault(_widgetUtils);
const ScanWidget = /*#__PURE__*/ (0, _react.memo)(function ScanWidget({ data }) {
    if (!data?.length) return null;
    const splitString = data.split("\n");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "p-2",
        children: splitString.map((line, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-0 text-nowrap",
                children: line
            }, i))
    });
});
ScanWidget.propTypes = {
    data: (0, _propTypesDefault.default).string
};
const graphTypeMap = new Map([
    [
        (0, _widgetTypes.AREA),
        (0, _widgetTypes.AREA)
    ],
    [
        (0, _widgetTypes.COLUMN_GRAPH),
        "bar"
    ],
    [
        (0, _widgetTypes.HIGH_BAR),
        "bar"
    ],
    [
        (0, _widgetTypes.LINE_GRAPH),
        "line"
    ],
    [
        (0, _widgetTypes.LINE_HIGH_CHART),
        "line"
    ],
    [
        (0, _widgetTypes.PIE),
        (0, _widgetTypes.PIE)
    ],
    [
        (0, _widgetTypes.VERTICAL_COLUMN_GRAPH),
        "bar"
    ]
]);
const GraphWidget = /*#__PURE__*/ (0, _react.memo)(function GraphWidget({ alertVisibility, fetchedData, graphIndex, graphWidgetIDs, renderNextGraph, series, settings, signalUnitsMap, type }) {
    const widgetUtils = (0, _react.useMemo)(()=>new (0, _widgetUtilsDefault.default)(), []);
    const { lines, title } = widgetUtils.getWidgetAttributes(type, settings);
    const yMinMax = alertVisibility ? {} : settings;
    const options = buildGraphOptions({
        fetchedData,
        graphIndex,
        graphWidgetIDs,
        lines,
        renderNextGraph,
        signalUnitsMap,
        title,
        type,
        yMinMax
    });
    const seriesForType = (0, _react.useMemo)(()=>{
        switch(type){
            case 0, _widgetTypes.COLUMN_GRAPH:
            case 0, _widgetTypes.HIGH_BAR:
            case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
                return series.reduce((acc, s)=>{
                    const data = acc[0].data.concat(...s.data);
                    return [
                        {
                            data
                        }
                    ];
                }, [
                    {
                        data: []
                    }
                ]);
            default:
                return series;
        }
    }, [
        series,
        type
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactApexchartsDefault.default), {
        height: "100%",
        options: options,
        series: seriesForType,
        type: graphTypeMap.get(type),
        width: "100%"
    });
});
GraphWidget.propTypes = {
    alertVisibility: (0, _propTypesDefault.default).bool,
    fetchedData: (0, _propTypesDefault.default).object,
    graphIndex: (0, _propTypesDefault.default).number,
    graphWidgetIDs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    renderNextGraph: (0, _propTypesDefault.default).func,
    series: (0, _propTypesDefault.default).array,
    settings: (0, _propTypesDefault.default).object,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    type: (0, _propTypesDefault.default).string
};
function buildGraphOptions({ fetchedData, graphIndex, graphWidgetIDs, lines, renderNextGraph, signalUnitsMap, title, type, yMinMax: { yMax, yMin } }) {
    const options = new (0, _graphOptionsBuilderDefault.default)(title, graphWidgetIDs, graphIndex, renderNextGraph);
    switch(type){
        case 0, _widgetTypes.AREA:
        case 0, _widgetTypes.LINE_HIGH_CHART:
        case 0, _widgetTypes.LINE_GRAPH:
            return options.addLineAndAreaOptions({
                yMax,
                yMin
            }, signalUnitsMap);
        case 0, _widgetTypes.COLUMN_GRAPH:
        case 0, _widgetTypes.HIGH_BAR:
            return options.addBarOptions(lines, fetchedData, signalUnitsMap, {
                yMax,
                yMin
            });
        case 0, _widgetTypes.PIE:
            return options.addPieChartOptions(lines, fetchedData, signalUnitsMap);
        case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
            return options.addVerticalBarOptions(lines, fetchedData, signalUnitsMap, {
                yMax,
                yMin
            });
    }
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-apexcharts":"lEV8Y","../../Constants/WidgetTypes":"frQz2","../../Lib/GraphOptionsBuilder":"a4oeZ","../../Lib/WidgetUtils":"uF2rc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a4oeZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
class GraphOptionsBuilder {
    constructor(title, graphWidgetIDs, graphIndex, renderNextGraph){
        this.xaxis = {};
        this.chart = {
            fontFamily: '"Roboto", sans-serif',
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    pan: true,
                    reset: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true
                }
            },
            id: `${title}-${graphIndex}`,
            events: {
                mounted: ()=>{
                    if (graphWidgetIDs.length - 1 <= graphIndex) return;
                    renderNextGraph(graphWidgetIDs[graphIndex + 1]);
                }
            }
        };
        this.stroke = {
            width: 1.5
        };
    }
    addLineAndAreaOptions({ yMax, yMin } = {}, signalUnitsMap) {
        this.xaxis = {
            labels: {
                style: {
                    fontSize: "10px",
                    fontFamily: '"Roboto", sans-serif'
                },
                formatter: (val, timestamp, { w: { config: { series = [] } = {} } = {} })=>{
                    const allOutputSignals = series?.every?.(({ signalType } = {})=>signalType === "outputSignal");
                    const now = (0, _momentDefault.default)(timestamp);
                    return allOutputSignals ? [
                        (0, _momentDefault.default).utc(timestamp).format("MM-DD-YYYY")
                    ] : [
                        now.format("MM-DD-YYYY"),
                        now.format("HH:mm:ss")
                    ];
                }
            },
            type: "datetime"
        };
        const findYMin = (defaultMin)=>{
            if (yMin || yMin === 0) return yMin;
            return defaultMin;
        };
        const findYMax = (defaultMax)=>{
            if (yMax || yMax === 0) return yMax;
            return defaultMax;
        };
        this.yaxis = {
            min: findYMin(),
            max: findYMax(),
            forceNiceScale: true,
            labels: {
                formatter: (val)=>{
                    return Number.isInteger(val) ? val : Number.parseFloat(val.toFixed(2));
                }
            }
        };
        this.dataLabels = {
            enabled: false
        };
        this.legend = {
            horizontalAlign: "center",
            fontSize: "12px",
            fontFamily: '"Roboto", sans-serif'
        };
        this.tooltip = {
            x: {
                formatter: (val, { seriesIndex, w: { config: { series = [] } = {} } = {} })=>{
                    const { signalType } = series?.[seriesIndex] || {};
                    return signalType === "outputSignal" ? (0, _momentDefault.default).utc(val).format("MM-DD-YYYY") : (0, _momentDefault.default)(val).format("MM-DD-YYYY HH:mm:ss");
                }
            },
            y: {
                title: {
                    formatter: (seriesName, config)=>{
                        if (!signalUnitsMap?.size) return `${seriesName}: `;
                        const { seriesIndex, w: { config: { series = [] } = {} } = {} } = config || {}, { datapointID } = series?.[seriesIndex] || {}, { unit } = signalUnitsMap.get(datapointID)?.[seriesName] ?? {};
                        if (!unit) return `${seriesName}: `;
                        return `${seriesName} (${unit}): `;
                    }
                }
            }
        };
        return this;
    }
    addBarOptions(lines, fetchedData, signalUnitsMap, { yMax, yMin } = {}) {
        const minMax = this._getNegativeMinMax(lines, fetchedData);
        if (Number.isFinite(yMax)) minMax.max = yMax;
        if (Number.isFinite(yMin)) minMax.min = yMin;
        this.chart.toolbar.show = false;
        this.dataLabels = this._generateBarDataLabels(lines, fetchedData, false, signalUnitsMap);
        this.grid = {
            show: false
        };
        this.legend = {
            showForSingleSeries: true
        };
        this.plotOptions = {
            bar: {
                barHeight: "95%",
                columnWidth: "100%",
                dataLabels: {
                    position: "center"
                },
                distributed: true,
                horizontal: true
            }
        };
        this.stroke = {
            colors: [
                "#fff"
            ],
            width: 3
        };
        this.tooltip = this._generateBarTooltip(lines, fetchedData, signalUnitsMap);
        this.xaxis.categories = Array.isArray(lines) ? lines.map(({ key })=>key) : [];
        this.yaxis = {
            ...minMax,
            labels: {
                show: false
            }
        };
        return this;
    }
    addVerticalBarOptions(lines, fetchedData, signalUnitsMap, { yMax, yMin } = {}) {
        const minMax = this._getNegativeMinMax(lines, fetchedData);
        if (Number.isFinite(yMax)) minMax.max = yMax;
        if (Number.isFinite(yMin)) minMax.min = yMin;
        this.dataLabels = this._generateBarDataLabels(lines, fetchedData, true, signalUnitsMap);
        this.legend = {
            fontSize: "10px",
            position: "bottom",
            showForSingleSeries: true
        };
        this.plotOptions = {
            bar: {
                barHeight: "100%",
                columnWidth: "90%",
                dataLabels: {
                    orientation: "horizontal"
                },
                distributed: true
            }
        };
        this.stroke = {
            colors: [
                "#fff"
            ],
            width: 2
        };
        this.tooltip = this._generateBarTooltip(lines, fetchedData, signalUnitsMap);
        this.xaxis = {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            categories: lines?.map?.(({ key })=>key) ?? [],
            labels: {
                show: false
            }
        };
        this.yaxis = {
            ...minMax,
            decimalsInFloat: 0,
            tickAmount: 6
        };
        return this;
    }
    _formatBarTooltipX(val, dataPointIndex, lines, fetchedData) {
        const { datapointID, type } = lines[dataPointIndex] || {};
        const [{ createdAt } = {}] = fetchedData.get(datapointID) || [];
        return !createdAt ? "" : type === "outputSignal" ? `updated at ${(0, _momentDefault.default).utc(createdAt).format("MM-DD-YYYY")}` : `updated at ${(0, _momentDefault.default)(createdAt).format("MM-DD-YYYY HH:mm")}`;
    }
    _formatBarTooltipY(val, dataPointIndex, labels, lines, fetchedData, signalUnitsMap) {
        const { key, datapointID } = lines[dataPointIndex];
        const [{ signals = {} } = {}] = fetchedData.get(datapointID) || [];
        let uom = "";
        if (Object.keys(signals || {})?.length) ({ uom = "" } = Object.values(signals).find(({ name })=>name === key) || {});
        const { display_precision, unit } = signalUnitsMap.get(datapointID)?.[key] || {};
        const value = Number.isInteger(val) ? val : Number(val).toFixed(display_precision ?? 2);
        return `${labels[dataPointIndex]} ${value} ${unit || uom}`;
    }
    _generateBarDataLabels(lines, fetchedData, isVertical, signalUnitsMap) {
        return {
            formatter: (val, { dataPointIndex })=>{
                const { key: name, datapointID } = lines[dataPointIndex] || {};
                const [{ signals = {} } = {}] = fetchedData.get(datapointID) || [];
                let rawValue = val, uom = "";
                if (Object.keys(signals || {})?.length) ({ uom = "", value: rawValue } = Object.values(signals).find(({ name: n })=>n === name) || {});
                const { display_precision, unit } = signalUnitsMap.get(datapointID)?.[name] ?? {};
                const value = Number.isInteger(val) ? val : Number(val).toFixed(display_precision ?? 2);
                return value === "NaN" ? rawValue : `${value} ${unit || uom}`;
            },
            offsetY: isVertical ? -2 : 5,
            style: {
                colors: [
                    "#686868"
                ],
                fontFamily: '"Roboto", sans-serif',
                fontSize: "0.75rem"
            },
            textAnchor: isVertical ? "middle" : "start"
        };
    }
    _generateBarTooltip(lines, fetchedData, signalUnitsMap) {
        return {
            style: {
                fontFamily: '"Roboto", sans-serif',
                fontSize: "10px"
            },
            x: {
                formatter: (val, { dataPointIndex })=>{
                    return this._formatBarTooltipX(val, dataPointIndex, lines, fetchedData);
                }
            },
            y: {
                formatter: (val, { dataPointIndex, w: { globals: { labels = [] } = {} } = {} })=>{
                    return this._formatBarTooltipY(val, dataPointIndex, labels, lines, fetchedData, signalUnitsMap);
                },
                title: {
                    formatter: ()=>""
                }
            }
        };
    }
    _getNegativeMinMax(lines = [], fetchedData = new Map()) {
        return lines.reduce((minMax, { datapointID = "", key = "" } = {})=>{
            const [{ signals = {} } = {}] = fetchedData.get(datapointID) || [];
            if (!Object.keys(signals || {}).length) return minMax;
            const { value } = Object.values(signals).find(({ name } = {})=>name === key) || {};
            if (!value) return minMax;
            if (value > 0) {
                if (!minMax.max || minMax.max < value) minMax.max = value;
            }
            if (value < 0) {
                if (!minMax.min || minMax.min > value) minMax.min = value;
            }
            return minMax;
        }, {});
    }
    addPieChartOptions(lines, fetchedData, signalUnitsMap) {
        const unitsMap = new Map();
        this.labels = lines.reduce((l, { datapointID, key })=>{
            const [{ signals } = {}] = fetchedData.get(datapointID) ?? [];
            if (!Object.keys(signals || {})?.length) return l;
            const { name, uom = "", value } = Object.values(signals).find(({ name })=>name === key) || {};
            if (!value && value !== 0) return l;
            const { display_precision, unit } = signalUnitsMap.get(datapointID)?.[key] || {};
            unitsMap.set(name, {
                display_precision,
                uom: unit || uom
            });
            return l.concat(key);
        }, []);
        this.dataLabels = {
            enabled: true,
            formatter: (percentage, opts)=>{
                return this._formatPieDataLabels(opts, unitsMap);
            },
            style: {
                fontSize: "10px"
            }
        };
        this.legend = {
            fontSize: "10px",
            position: "bottom"
        };
        this.tooltip = {
            custom: (opts)=>{
                const { seriesIndex, w: { globals: { colors = [] } } } = opts;
                return `
          <div class="arrow_box" style="background-color:${colors[seriesIndex]};padding:5px">
            <span>${this._formatPieDataLabels(opts, unitsMap)}</span>
          </div>
        `;
            }
        };
        return this;
    }
    _formatPieDataLabels({ seriesIndex, w }, units = new Map()) {
        const rawValue = w?.config?.series?.[seriesIndex];
        if (!rawValue && rawValue !== 0) return;
        const { display_precision, uom } = units.get(w?.config?.labels?.[seriesIndex]) ?? {};
        switch(true){
            case typeof rawValue === "number":
                return `${Number.isInteger(rawValue) ? rawValue : rawValue.toFixed(display_precision ?? 2)} ${uom}`;
            case typeof rawValue === "string":
                {
                    const [int, dec] = rawValue.split(".");
                    return `${int}.${dec.slice(0, display_precision ?? 2)} ${uom}`;
                }
            default:
                return;
        }
    }
}
exports.default = GraphOptionsBuilder;

},{"moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bQmh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _zIndex = require("../../Styles/Z-INDEX");
exports.default = /*#__PURE__*/ (0, _react.memo)(ImageOverlayWidget);
const { className: tooltipClassName, styles: tooltipStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1563643945",
        children: `div.jsx-1563643945{z-index:${(0, _zIndex.COMPONENT_OVERRIDE)};}`
    }),
    className: "jsx-1563643945"
};
function ImageOverlayWidget(props) {
    const dataMap = Array.isArray(props.data) ? new Map(props.data.map(({ data: [signalValue] = [], name })=>[
            name,
            signalValue
        ])) : new Map();
    const [signalOverlays, setSignalOverlays] = (0, _react.useState)(new Map());
    const imgRef = (0, _react.useRef)();
    const resizeObserverRef = (0, _react.useRef)();
    const disconnectResizeObserver = ()=>{
        resizeObserverRef?.current?.disconnect();
    };
    const generateSignalOverlays = ()=>{
        if (!imgRef?.current?.getBoundingClientRect) return;
        const { height, width } = imgRef.current.getBoundingClientRect() || {};
        const container = document.getElementById(props.widget?._id);
        const { height: containerHeight = 0, width: containerWidth = 0 } = container?.getBoundingClientRect?.() || {};
        const offsetX = (containerWidth - width) / 2;
        const offsetY = (containerHeight - height) / 2;
        const signalOverlayMap = new Map(props.widget?.settings?.lines?.map?.(({ datapointID, key, x, y })=>{
            const clientX = width * (x / 100) + offsetX;
            const clientY = height * (y / 100) + offsetY;
            const [{ createdAt } = {}] = props.fetchedData?.get?.(datapointID) || [];
            const createdAtDate = new Date(createdAt);
            const timestamp = (0, _isValidDefault.default)(createdAtDate) ? (0, _formatDefault.default)(createdAtDate, "MM-dd-yyyy HH:mm:ss") : "";
            const { display_precision, unit } = props.signalUnitsMap?.get?.(datapointID)?.[key] || {};
            const value = formatDisplayValue({
                display_precision,
                unit,
                value: dataMap.get(key)
            });
            return [
                `${clientX}-${clientY}`,
                {
                    key,
                    timestamp,
                    value
                }
            ];
        }) || []);
        setSignalOverlays(signalOverlayMap);
    };
    const handleTooltipHide = ({ target: { id } })=>{
        const coordinates = id.substring(0, id.lastIndexOf("-"));
        [
            ...signalOverlays.keys()
        ].forEach((c)=>{
            if (c === coordinates) return;
            const overlayElement = document.getElementById(`${c}-overlay`);
            const className = overlayElement.className.replace("invisible", "").trim();
            overlayElement.className = className;
        });
    };
    const handleTooltipShow = ({ target: { id } })=>{
        const coordinates = id.substring(0, id.lastIndexOf("-"));
        [
            ...signalOverlays.keys()
        ].forEach((c)=>{
            if (c === coordinates) return;
            const overlayElement = document.getElementById(`${c}-overlay`);
            const className = overlayElement.className.concat(" invisible");
            overlayElement.className = className;
        });
    };
    const initResizeObserver = ()=>{
        if (!window.ResizeObserver) return;
        const container = document.getElementById(props.widget?._id);
        resizeObserverRef.current = new window.ResizeObserver(()=>{
            generateSignalOverlays();
        });
        resizeObserverRef.current.observe(container);
    };
    (0, _react.useEffect)(()=>{
        if (!signalOverlays.size) return;
        generateSignalOverlays();
    }, [
        ...dataMap?.values?.() || []
    ]);
    (0, _react.useEffect)(()=>{
        if (!resizeObserverRef?.current) initResizeObserver();
        return disconnectResizeObserver;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "h-100 w-100 d-flex align-items-center justify-content-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                alt: "annotated overlay signals",
                className: "img-fluid mx-auto mh-100 rounded rounded-lg",
                onLoad: generateSignalOverlays,
                ref: imgRef,
                src: props.widget?.settings?.image
            }),
            signalOverlays.size ? [
                ...signalOverlays.entries()
            ].map(([coordinates, config])=>{
                const [x, y] = coordinates.split("-");
                const { key, timestamp, value } = config || {};
                const { className: signalOverlayClassName, styles: signalOverlayStyles } = getOverlayMarkerStyle(x, y);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: `py-1 px-2 position-fixed rounded rounded-lg shadow-lg text-white three-quarter-text signal-overlay ${signalOverlayClassName}`,
                    "data-for": coordinates,
                    "data-tip": true,
                    id: `${coordinates}-overlay`,
                    children: [
                        !value && value !== 0 ? "No data" : value,
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactTooltipDefault.default), {
                            afterHide: handleTooltipHide,
                            afterShow: handleTooltipShow,
                            backgroundColor: "var(--brand-primary)",
                            border: true,
                            className: tooltipClassName,
                            effect: "solid",
                            id: coordinates,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mb-0 text-white text-center",
                                    children: key
                                }),
                                timestamp ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "mb-0 text-white text-center",
                                    children: timestamp
                                }) : null,
                                tooltipStyles
                            ]
                        }),
                        signalOverlayStyles
                    ]
                }, coordinates);
            }) : null
        ]
    });
}
ImageOverlayWidget.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        data: (0, _propTypesDefault.default).array,
        name: (0, _propTypesDefault.default).string
    })),
    fetchedData: (0, _propTypesDefault.default).object,
    signalUnitsMap: (0, _propTypesDefault.default).object,
    widget: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        settings: (0, _propTypesDefault.default).shape({
            image: (0, _propTypesDefault.default).string,
            lines: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                datapointID: (0, _propTypesDefault.default).string,
                key: (0, _propTypesDefault.default).string,
                x: (0, _propTypesDefault.default).number,
                y: (0, _propTypesDefault.default).number
            }))
        })
    })
};
function formatDisplayValue({ display_precision = 2, unit, value }) {
    const displayUnit = unit ? ` ${unit}` : "";
    switch(true){
        case !value && value !== 0:
            return value;
        case typeof value === "string":
        case Number.isInteger(value):
            return `${value}${displayUnit}`;
        case Number.isFinite(value):
            return `${value.toFixed(display_precision)}${displayUnit}`;
        default:
            return value;
    }
}
function getOverlayMarkerStyle(x, y) {
    return {
        styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
            id: "3418727522",
            dynamic: [
                x,
                y
            ],
            children: `.signal-overlay.__jsx-style-dynamic-selector{background-color:var(--dark);left:${x}px;opacity:0.9;top:${y}px;}`
        }),
        className: (0, _styleDefault.default).dynamic([
            [
                "3418727522",
                [
                    x,
                    y
                ]
            ]
        ])
    };
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","date-fns/format":"520Dk","date-fns/isValid":"l72u5","react-tooltip":"4ejwp","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jqy0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TIME_RANGE_OPTIONS", ()=>TIME_RANGE_OPTIONS);
parcelHelpers.export(exports, "default", ()=>TimeRangeDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _widgetTypes = require("../../../Constants/WidgetTypes");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _zIndex = require("../../../Styles/Z-INDEX");
var _utils = require("./utils");
const TIME_RANGE_OPTIONS = [
    {
        label: "custom",
        value: "custom"
    },
    {
        label: "1 hr",
        value: 1
    },
    {
        label: "3 hrs",
        value: 3
    },
    {
        label: "8 hrs",
        value: 8
    }
];
function TimeRangeDropdown(props) {
    const { timeFilter, dropdownItemClass, displayTextAsGrid, type, updateRealTime, toggleUtilizationTimeSelectModal, handleTimeRangeFilter, handleReturnToRealTime, forceDisplay } = props;
    const timeFilterVisibility = forceDisplay || (0, _utils.isTimeFilterVisible)(type, displayTextAsGrid) ? "visible" : "d-none";
    const timeRangeOptions = type === (0, _widgetTypes.LOCATION) ? TIME_RANGE_OPTIONS.concat({
        label: "24 hrs",
        value: 24
    }) : TIME_RANGE_OPTIONS;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
                className: timeFilterVisibility,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                        color: "link",
                        className: "p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCalendarAlt),
                            className: "text-muted"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                        right: true,
                        className: "rounded-lg shadow",
                        style: {
                            minWidth: "6rem",
                            transform: "translate3d(-5rem, 16px, 0px)",
                            zIndex: (0, _zIndex.STICKY_OVERRIDE)
                        },
                        children: [
                            !updateRealTime ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                className: dropdownItemClass,
                                disabled: type === (0, _widgetTypes.COMMAND),
                                onClick: handleReturnToRealTime,
                                children: "return to real time"
                            }) : null,
                            type === (0, _widgetTypes.TEXT) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                className: `${dropdownItemClass} ${timeFilter ? "text-brand-primary" : ""}`,
                                onClick: ()=>handleTimeRangeFilter("custom"),
                                children: "view historical"
                            }) : timeRangeOptions.map(({ label, value }, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                                    className: `${dropdownItemClass} ${value === timeFilter ? "text-brand-primary" : ""}`,
                                    onClick: ()=>handleTimeRangeFilter(value),
                                    children: label
                                }, i))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                className: (0, _widgetTypes.HISTORICAL_UTILIZATION_TYPES).has(type) ? "p-0" : "d-none",
                color: "link",
                onClick: toggleUtilizationTimeSelectModal,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt),
                    className: "text-muted"
                })
            })
        ]
    });
}
TimeRangeDropdown.propTypes = {
    dropdownItemClass: (0, _propTypesDefault.default).string,
    timeFilter: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    displayTextAsGrid: (0, _propTypesDefault.default).bool,
    type: (0, _propTypesDefault.default).string,
    updateRealTime: (0, _propTypesDefault.default).bool,
    forceDisplay: (0, _propTypesDefault.default).bool,
    toggleUtilizationTimeSelectModal: (0, _propTypesDefault.default).func,
    handleTimeRangeFilter: (0, _propTypesDefault.default).func,
    handleReturnToRealTime: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","../../../Constants/WidgetTypes":"frQz2","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../../Styles/Z-INDEX":"CxzKK","./utils":"dnj44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnj44":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTimeFilterVisible", ()=>isTimeFilterVisible);
var _widgetTypes = require("../../../Constants/WidgetTypes");
const TIMESERIES_TYPES = new Set([
    (0, _widgetTypes.LINE_HIGH_CHART),
    (0, _widgetTypes.LINE_GRAPH),
    (0, _widgetTypes.LOCATION),
    (0, _widgetTypes.AREA)
]);
function isTimeFilterVisible(type, displayTextAsGrid) {
    return TIMESERIES_TYPES.has(type) || type === (0, _widgetTypes.TEXT) && !displayTextAsGrid;
}

},{"../../../Constants/WidgetTypes":"frQz2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8a27C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CustomTimeFilterModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _widgetTypes = require("../../../Constants/WidgetTypes");
var _customFilterModal = require("../../CustomFilterModal");
var _customFilterModalDefault = parcelHelpers.interopDefault(_customFilterModal);
var _subDays = require("date-fns/subDays");
var _subDaysDefault = parcelHelpers.interopDefault(_subDays);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
const MAX_DATAPOINTS = 3000;
function CustomTimeFilterModal(props) {
    const { customEndTimestamp, customStartTimestamp, type, maxDatapoints, showCustomFilterModal, handleCustomFilterSaveCallback, toggleCustomFilterModal } = props;
    const handleCustomFilterSave = (0, _react.useCallback)(({ endDate, maxDatapoints, startDate })=>{
        const end = new Date(endDate), customEndTimestamp = (0, _isValidDefault.default)(end) ? end.getTime() : Date.now(), start = new Date(startDate), customStartTimestamp = (0, _isValidDefault.default)(start) ? start.getTime() : (0, _subDaysDefault.default)(customEndTimestamp, 7);
        handleCustomFilterSaveCallback({
            customEndTimestamp,
            maxDatapoints,
            customStartTimestamp
        });
    }, [
        handleCustomFilterSaveCallback
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customFilterModalDefault.default), {
        customEndTimestamp: customEndTimestamp,
        customStartTimestamp: customStartTimestamp,
        globalMaxDatapoints: MAX_DATAPOINTS,
        handleCustomFilterSave: handleCustomFilterSave,
        isOpen: showCustomFilterModal,
        isTextTile: type === (0, _widgetTypes.TEXT),
        maxDatapoints: maxDatapoints || MAX_DATAPOINTS,
        toggleModal: toggleCustomFilterModal
    });
}
CustomTimeFilterModal.propTypes = {
    customEndTimestamp: (0, _propTypesDefault.default).number,
    customStartTimestamp: (0, _propTypesDefault.default).number,
    type: (0, _propTypesDefault.default).string,
    maxDatapoints: (0, _propTypesDefault.default).number,
    showCustomFilterModal: (0, _propTypesDefault.default).bool,
    handleCustomFilterSaveCallback: (0, _propTypesDefault.default).func,
    toggleCustomFilterModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","../../../Constants/WidgetTypes":"frQz2","../../CustomFilterModal":"e1Qxb","date-fns/subDays":"0Vpj8","date-fns/isValid":"l72u5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1Qxb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _customFilterModalDisplay = require("./CustomFilterModalDisplay");
var _customFilterModalDisplayDefault = parcelHelpers.interopDefault(_customFilterModalDisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(CustomFilterModal);
function CustomFilterModal(props) {
    const [state, updateState] = (0, _react.useState)(()=>({
            endDate: props.customEndTimestamp ? new Date(props.customEndTimestamp) : null,
            maxDatapoints: props.maxDatapoints,
            startDate: props.customStartTimestamp ? new Date(props.customStartTimestamp) : null
        }));
    const handleChangeEnd = (0, _react.useCallback)((endDate)=>{
        updateState((prevState)=>({
                ...prevState,
                endDate
            }));
    }, []), handleChangeMaxDatapoints = (0, _react.useCallback)(({ target: { value } })=>{
        const maxDatapoints = value > props.globalMaxDatapoints ? props.globalMaxDatapoints : value < 0 ? 0 : value;
        updateState((prevState)=>({
                ...prevState,
                maxDatapoints
            }));
    }, [
        props.globalMaxDatapoints
    ]), handleChangeStart = (0, _react.useCallback)((startDate)=>{
        updateState((prevState)=>({
                ...prevState,
                startDate
            }));
    }, []), handleSave = ()=>{
        props.handleCustomFilterSave({
            endDate: state.endDate,
            maxDatapoints: state.maxDatapoints,
            startDate: state.startDate
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customFilterModalDisplayDefault.default), {
        ...props,
        ...state,
        handleChangeEnd: handleChangeEnd,
        handleChangeMaxDatapoints: handleChangeMaxDatapoints,
        handleChangeStart: handleChangeStart,
        handleSave: handleSave
    });
}
CustomFilterModal.propTypes = {
    customEndTimestamp: (0, _propTypesDefault.default).number,
    customStartTimestamp: (0, _propTypesDefault.default).number,
    globalMaxDatapoints: (0, _propTypesDefault.default).number,
    handleCustomFilterSave: (0, _propTypesDefault.default).func,
    isTextTile: (0, _propTypesDefault.default).bool,
    maxDatapoints: (0, _propTypesDefault.default).number,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","./CustomFilterModalDisplay":"8UogN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UogN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addWeeks = require("date-fns/addWeeks");
var _addWeeksDefault = parcelHelpers.interopDefault(_addWeeks);
var _isAfter = require("date-fns/isAfter");
var _isAfterDefault = parcelHelpers.interopDefault(_isAfter);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _subWeeks = require("date-fns/subWeeks");
var _subWeeksDefault = parcelHelpers.interopDefault(_subWeeks);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
exports.default = /*#__PURE__*/ (0, _react.memo)(CustomFilterModalDisplay);
function CustomFilterModalDisplay(props) {
    const { endDate, globalMaxDatapoints, handleChangeMaxDatapoints, handleChangeStart, handleChangeEnd, handleSave, isOpen, isTextTile, maxDatapoints, startDate, toggleModal } = props;
    const now = (0, _react.useMemo)(()=>new Date(), []), startMinDate = (0, _react.useMemo)(()=>{
        if (!isTextTile) return null;
        return (0, _isValidDefault.default)(endDate) ? (0, _subWeeksDefault.default)(endDate, 1) : null;
    }, [
        endDate,
        isTextTile
    ]), endMaxDate = (0, _react.useMemo)(()=>{
        if (!isTextTile || !(0, _isValidDefault.default)(startDate)) return now;
        const oneWeekAhead = (0, _addWeeksDefault.default)(startDate, 1);
        return (0, _isAfterDefault.default)(oneWeekAhead, now) ? now : oneWeekAhead;
    }, [
        isTextTile,
        now,
        startDate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        centered: true,
        className: "rounded-lg",
        isOpen: isOpen,
        size: "md",
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: toggleModal,
                children: "Filter Data"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: isTextTile ? "text-left modal-supplemental-text mb-5" : "d-none",
                        children: "Choose a range in the past of up to 1 week. The most recent value within that range for each signal will be retrieved. If no data is available within that range a message will be displayed."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex flex-column flex-md-row justify-content-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group d-flex flex-column",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "d-block modal-inputlabel-text",
                                        htmlFor: "startDate",
                                        children: "Start Date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                        allowSameDay: true,
                                        autoComplete: "off",
                                        className: "form-control",
                                        dateFormat: [
                                            "MMM d, yyyy H:mm",
                                            "P",
                                            "PP",
                                            "PPP",
                                            "MMM dd yyyy",
                                            "MMMM dd yyyy",
                                            "MM/yyyy"
                                        ],
                                        endDate: endDate,
                                        name: "startDate",
                                        minDate: startMinDate,
                                        maxDate: endDate ?? now,
                                        onChange: handleChangeStart,
                                        placeholderText: "From",
                                        selected: startDate,
                                        selectsStart: true,
                                        showTimeSelect: true,
                                        showYearDropdown: true,
                                        startDate: startDate,
                                        timeCaption: "time",
                                        timeFormat: "HH:mm",
                                        timeIntervals: 15
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "d-none d-md-flex align-items-center justify-content-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faMinus)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "d-md-none"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group d-flex flex-column",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "d-block modal-inputlabel-text",
                                        htmlFor: "endDate",
                                        children: "End Date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                        allowSameDay: true,
                                        autoComplete: "off",
                                        className: "form-control",
                                        dateFormat: [
                                            "MMM d, yyyy H:mm",
                                            "P",
                                            "PP",
                                            "PPP",
                                            "MMM dd yyyy",
                                            "MMMM dd yyyy",
                                            "MM/yyyy"
                                        ],
                                        endDate: endDate,
                                        name: "endDate",
                                        onChange: handleChangeEnd,
                                        minDate: startDate,
                                        maxDate: endMaxDate,
                                        placeholderText: "To",
                                        selected: endDate,
                                        selectsEnd: true,
                                        showTimeSelect: true,
                                        showYearDropdown: true,
                                        startDate: startDate,
                                        timeCaption: "time",
                                        timeFormat: "HH:mm",
                                        timeIntervals: 15
                                    })
                                ]
                            })
                        ]
                    }),
                    isTextTile ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group mt-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                className: "modal-inputlabel-text",
                                htmlFor: "datapoints",
                                children: [
                                    "Datapoints",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                        className: "text-muted",
                                        children: ` (Max of ${globalMaxDatapoints})`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "form-control",
                                max: globalMaxDatapoints,
                                min: "1",
                                name: "datapoints",
                                onChange: handleChangeMaxDatapoints,
                                type: "number",
                                value: maxDatapoints
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-outline-secondary py-0 px-3 mr-3 three-quarter-text",
                        onClick: toggleModal,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn modal-button-submit py-0 px-4 three-quarter-text",
                        onClick: handleSave,
                        children: "Update"
                    })
                ]
            })
        ]
    });
}
CustomFilterModalDisplay.propTypes = {
    endDate: (0, _propTypesDefault.default).object,
    globalMaxDatapoints: (0, _propTypesDefault.default).number,
    handleChangeEnd: (0, _propTypesDefault.default).func,
    handleChangeMaxDatapoints: (0, _propTypesDefault.default).func,
    handleChangeStart: (0, _propTypesDefault.default).func,
    handleSave: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    isTextTile: (0, _propTypesDefault.default).bool,
    maxDatapoints: (0, _propTypesDefault.default).number,
    startDate: (0, _propTypesDefault.default).object,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","date-fns/addWeeks":"6qgbJ","date-fns/isAfter":"1N23w","date-fns/isValid":"l72u5","date-fns/subWeeks":"c1mfa","react-datepicker":"cGh5X","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-datepicker/dist/react-datepicker.css":"chsuV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"clGpp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoItemsFound", ()=>NoItemsFound);
parcelHelpers.export(exports, "NoItemsExist", ()=>NoItemsExist);
parcelHelpers.export(exports, "NoResultsFound", ()=>NoResultsFound);
parcelHelpers.export(exports, "Loading", ()=>Loading);
parcelHelpers.export(exports, "SearchLoading", ()=>SearchLoading);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _iconsContext = require("../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
const { className: searchSpinnerclass, styles: searchSpinnerStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3482964578",
        children: "svg.jsx-3482964578{position:static;width:100%;}@media (min-width:992px){svg.jsx-3482964578{position:absolute;top:35%;left:0;}}"
    }),
    className: "jsx-3482964578"
};
const NoItemsFound = ({ text })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: "text-center text-text-light-gray",
        children: text
    });
NoItemsFound.propTypes = {
    text: (0, _propTypesDefault.default).string
};
const NoItemsExist = (props)=>{
    const { emptyStateIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const { alt, altMessage = "", color = "blue", height = 100, icon = emptyStateIcon, reminders = false, text, width = 100 } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `${reminders ? "h-100" : ""} text-center`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: icon,
                alt: alt,
                className: "mx-auto",
                height: height,
                width: width
            }),
            text ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-text-light-gray three-quarter-text mb-2",
                children: text
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-muted nine-tenth-text",
                children: altMessage || `Click the ${color} button to create some!`
            })
        ]
    });
};
NoItemsExist.propTypes = {
    alt: (0, _propTypesDefault.default).string,
    altMessage: (0, _propTypesDefault.default).string,
    color: (0, _propTypesDefault.default).string,
    height: (0, _propTypesDefault.default).number,
    icon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    reminders: (0, _propTypesDefault.default).bool,
    text: (0, _propTypesDefault.default).string,
    width: (0, _propTypesDefault.default).number
};
const NoResultsFound = ({ searchTerm })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3226771682 container position-static w-100 text-center mt-2 mt-lg-0 d-lg-flex flex-lg-column justify-content-lg-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "jsx-3226771682 font-weight-bold text-text-light-gray",
                children: `No results found for "${searchTerm}"`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "jsx-3226771682 text-text-light-gray",
                children: "Please check your spelling or use different keywords."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3226771682",
                children: "@media (min-width:992px){.container.jsx-3226771682{height:100%;}}"
            })
        ]
    });
NoResultsFound.propTypes = {
    searchTerm: (0, _propTypesDefault.default).string
};
const Loading = ({ size = "2x" })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        className: "w-100",
        color: "var(--brand-primary)",
        icon: (0, _freeSolidSvgIcons.faCircleNotch),
        size: size,
        spin: true
    });
Loading.propTypes = {
    size: (0, _propTypesDefault.default).string
};
const SearchLoading = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                className: `${searchSpinnerclass} mt-3 mt-lg-0`,
                color: "var(--brand-primary)",
                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                size: "2x",
                spin: true
            }),
            searchSpinnerStyles
        ]
    });

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../Context/IconsContext":"lzIpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10CFi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _templateDashboardService = require("../../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
exports.default = /*#__PURE__*/ (0, _react.memo)(CreateTemplateDashboardModal);
const initState = {
    error: "",
    isDefault: false,
    isPrivate: false,
    name: "",
    saveRequestPending: false
};
function CreateTemplateDashboardModal(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const source = (0, _axios.CancelToken).source();
    const service = new (0, _templateDashboardServiceDefault.default)();
    const handleNameUpdate = ({ target: { name, value } })=>{
        updateState({
            ...state,
            [name]: value
        });
    };
    const handleCheckboxClick = ({ target: { name } })=>{
        updateState({
            ...state,
            [name]: !state[name]
        });
    };
    const handleSave = async ()=>{
        try {
            updateState({
                ...state,
                saveRequestPending: true
            });
            const dashboard = await service.createTemplateDashboard(props.gtemplateID, {
                isPrivate: state.isPrivate,
                name: state.name,
                widgets: []
            }, source.token);
            if (state.isDefault) await service.setUserDefaultDashboard(props.assetID, {
                dashboardID: dashboard._id
            }, source.token);
            props.handleDashboardCreated(dashboard);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                saveRequestPending: false
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        centered: true,
        isOpen: props.isOpen,
        toggle: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: props.toggleModal,
                children: "Create New Dashboard"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid pt-0 pb-md-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-907359250 col-12 three-quarter-text text-left",
                            children: "Creating a new dashboard will allow for all assets associated to this Asset Model to view the same signal data on this dashboard"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-907359250 col-12 form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "name",
                                    className: "jsx-907359250 nine-tenth-text",
                                    children: "Dashboard Name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    name: "name",
                                    onChange: handleNameUpdate,
                                    type: "text",
                                    value: state.name,
                                    className: "jsx-907359250 form-control form-control-sm rounded-lg"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row my-2 my-md-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-907359250 col-12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-907359250 form-check form-check-inline",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        checked: state.isDefault,
                                        name: "isDefault",
                                        onChange: handleCheckboxClick,
                                        type: "checkbox",
                                        className: "jsx-907359250 form-check-input"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "isDefault",
                                        className: "jsx-907359250 form-check-label ml-3",
                                        children: "Set as your Default Dashboard?"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row my-2 my-md-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-907359250 col-12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-907359250 form-check form-check-inline",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        checked: state.isPrivate,
                                        name: "isPrivate",
                                        onChange: handleCheckboxClick,
                                        type: "checkbox",
                                        className: "jsx-907359250 form-check-input"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        htmlFor: "isPrivate",
                                        className: "jsx-907359250 form-check-label ml-3",
                                        children: "Set as Private Dashboard and grant other users access?"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 " + ((state.error ? "row" : "d-none") || ""),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-907359250 col-12 three-quarter-text text-danger",
                            children: state.error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: props.toggleModal,
                        className: "jsx-907359250 btn btn-outline-secondary bg-white text-muted py-0 px-3 shadow-none three-quarter-text",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: !state.name || state.saveRequestPending,
                        onClick: handleSave,
                        className: "jsx-907359250 btn modal-button-submit three-quarter-text py-0 px-3",
                        children: state.saveRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Create"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "907359250",
                children: ".btn.jsx-907359250:focus{outline:none;}"
            })
        ]
    });
}
CreateTemplateDashboardModal.propTypes = {
    assetID: (0, _propTypesDefault.default).string,
    gtemplateID: (0, _propTypesDefault.default).string,
    handleDashboardCreated: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Services/TemplateDashboardService":"kZyFp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vBt9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _uuid = require("uuid");
var _signal = require("../../Constants/Signal");
var _widgetTypes = require("../../Constants/WidgetTypes");
var _createWidgetHelper = require("../../Lib/CreateWidgetHelper");
var _createWidgetHelperDefault = parcelHelpers.interopDefault(_createWidgetHelper);
var _fileHelpers = require("../../Lib/FileHelpers");
var _tagService = require("../../Services/TagService");
var _tagServiceDefault = parcelHelpers.interopDefault(_tagService);
var _templateDashboardService = require("../../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
var _widgetUtils = require("../../Lib/WidgetUtils");
var _widgetUtilsDefault = parcelHelpers.interopDefault(_widgetUtils);
var _createWidgetModalDisplay = require("./CreateWidgetModalDisplay");
var _createWidgetModalDisplayDefault = parcelHelpers.interopDefault(_createWidgetModalDisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(CreateWidgetModal);
const initState = {
    activeImageCoordinate: new Map(),
    createRequestPending: false,
    datapointsMap: [],
    displayTextAsGrid: false,
    error: "",
    helpText: "",
    image: "",
    imageCoordinatesMap: new Map(),
    selectedAggregation: (0, _signal.DAILY),
    selectedType: {},
    showTimeSinceLastUpdated: false,
    tagOptions: [],
    tagsLoaded: false,
    widgetName: "",
    widgetSignals: [],
    widgetType: null,
    yMax: undefined,
    yMin: undefined
};
function CreateWidgetModal(props) {
    const [state, updateState] = (0, _react.useState)(()=>{
        const { gtemplate, gtemplate: { datapoints } = {} } = props.asset || {};
        let configError = "";
        if (!Object.keys(gtemplate || {}).length) configError = 'Asset must be assigned to a model before a smart tile can be created. This can be done by clicking "Edit" in the Settings dropdown menu.';
        else if (!Array.isArray(datapoints) || !datapoints?.length) configError = "Asset model does not currently have any collections or signals configured.";
        return {
            ...initState,
            configError
        };
    });
    const tagService = (0, _react.useMemo)(()=>new (0, _tagServiceDefault.default)(), []);
    const templateDashboardService = (0, _react.useMemo)(()=>new (0, _templateDashboardServiceDefault.default)(), []);
    const widgetUtils = (0, _react.useMemo)(()=>new (0, _widgetUtilsDefault.default)(), []);
    const source = (0, _axios.CancelToken).source();
    const maintenanceSelectRef = (0, _react.useRef)();
    const widgetOptions = (0, _react.useMemo)(()=>widgetUtils.types.filter(({ value })=>{
            switch(value){
                case 0, _widgetTypes.COMMAND:
                    return props.currentOrg?.features?.remote;
                case 0, _widgetTypes.BAR_ENGINE_UTILIZATION:
                case 0, _widgetTypes.BAR_FUEL_UTILIZATION:
                case 0, _widgetTypes.TEXT_ENGINE:
                case 0, _widgetTypes.TEXT_FUEL:
                    return props.currentOrg?.features?.utilization_reporting?.enabled;
                default:
                    return true;
            }
        }), [
        props.currentOrg?.features?.remote,
        props.currentOrg?.features?.utilization_reporting?.enabled,
        widgetUtils.types
    ]);
    const clearImage = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                activeImageCoordinate: new Map(),
                image: "",
                imageCoordinatesMap: new Map()
            }));
    }, []);
    const createWidget = async ()=>{
        const { displayTextAsGrid, image, imageCoordinatesMap, selectedAggregation, showTimeSinceLastUpdated, widgetName, widgetSignals, widgetType, yMin, yMax } = state;
        const { asset: { gtemplateID, gtemplate: { datapoints = [] } = {} }, dashboardID, toggleModal, updateWidgets } = props, maintenanceSelectValue = maintenanceSelectRef?.current?.getValue?.();
        if (!widgetType) return updateState((prevState)=>({
                ...prevState,
                error: "Smart Tile Type must be selected."
            }));
        if (widgetType === (0, _widgetTypes.MAINTENANCE) && !maintenanceSelectValue?.length) return updateState((prevState)=>({
                ...prevState,
                error: "Please select a Maintenance Reminder to display."
            }));
        try {
            updateState((prevState)=>({
                    ...prevState,
                    createRequestPending: true,
                    error: ""
                }));
            const newWidget = new (0, _createWidgetHelperDefault.default)(widgetType).addSettingsByType({
                displayTextAsGrid,
                image,
                imageCoordinatesMap,
                maintenanceSelectValue,
                selectedAggregation,
                selectedSignals: widgetSignals,
                showTimeSinceLastUpdated,
                signalCollections: datapoints,
                title: widgetName,
                yMin: Number.parseFloat(yMin),
                yMax: Number.parseFloat(yMax)
            });
            const { widgets } = await templateDashboardService.createTemplateDashboardWidget(gtemplateID, dashboardID, newWidget, source.token);
            if (Array.isArray(widgets) && widgets.length) return updateWidgets(widgets.reverse());
            toggleModal();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    createRequestPending: false,
                    error
                }));
        }
    };
    const handleAddRange = (outerIndex, innerIndex)=>{
        if (innerIndex >= 4) return;
        try {
            const widgetSignals = state.widgetSignals.map((s, index)=>{
                if (index !== outerIndex) return s;
                const validRange = s.ranges?.every?.(({ color, label, maxValue, minValue } = {})=>{
                    return color && label && maxValue && minValue;
                });
                if (!validRange) throw new Error("Each range must have a Min/Max Value, Label and Color.");
                const { maxValue } = s.ranges[innerIndex] || {};
                return {
                    ...s,
                    ranges: s.ranges.concat({
                        id: (0, _uuid.v4)(),
                        minValue: maxValue
                    })
                };
            });
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    widgetSignals
                }));
        } catch ({ message: error }) {
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    };
    const handleAggregationSelect = (0, _react.useCallback)((selected)=>{
        updateState((prevState)=>({
                ...prevState,
                selectedAggregation: selected?.value
            }));
    }, []);
    const handleAddImageOverlaySignal = (0, _react.useCallback)((coordinates, signal)=>{
        updateState((prevState)=>{
            const imageCoordinatesMap = new Map(prevState.imageCoordinatesMap).set(coordinates, signal);
            return {
                ...prevState,
                imageCoordinatesMap,
                activeImageCoordinate: new Map()
            };
        });
    }, []);
    const handleAddStaticTextLink = (0, _react.useCallback)(()=>{
        updateState((prevState)=>{
            const [{ links: prevLinks = [] }] = prevState.widgetSignals;
            const links = [
                ...prevLinks,
                {
                    display: "",
                    link: ""
                }
            ];
            return {
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        links
                    }
                ]
            };
        });
    }, []);
    const handleAddWidgetCommand = (0, _react.useCallback)((command, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? command : s);
            return {
                ...prevState,
                widgetSignals,
                error: ""
            };
        });
    }, []);
    const handleAddWidgetSignal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>{
            if (prevState.widgetSignals.length === prevState.selectedType.maxSignals) return prevState;
            const rowToAdd = widgetUtils.nonSignalTypes.has(prevState.widgetType) ? {} : widgetUtils.widgetSignalDefault;
            return {
                ...prevState,
                widgetSignals: prevState.widgetSignals.concat(rowToAdd)
            };
        });
    }, [
        widgetUtils.nonSignalTypes,
        widgetUtils.widgetSignalDefault
    ]);
    const handleColorInput = (0, _react.useCallback)(({ target: { value } }, outerIndex, innerIndex)=>{
        const trimmedInput = value.trim();
        const color = trimmedInput.startsWith("#") ? trimmedInput : "#".concat(trimmedInput);
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>{
                if (i !== outerIndex) return s;
                const ranges = s.ranges.map((r, index)=>index === innerIndex ? {
                        ...r,
                        color
                    } : r);
                return {
                    ...s,
                    ranges
                };
            });
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleColorSelected = (0, _react.useCallback)((color, outerIndex, innerIndex)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>{
                if (i !== outerIndex) return s;
                const ranges = s.ranges.map((r, index)=>index === innerIndex ? {
                        ...r,
                        color
                    } : r);
                return {
                    ...s,
                    ranges
                };
            });
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleCoordinateClick = (0, _react.useCallback)((x, y, overlayConfig)=>{
        updateState((prevState)=>{
            const activeImageCoordinate = new Map([
                [
                    "x",
                    Number(x)
                ],
                [
                    "y",
                    Number(y)
                ],
                [
                    "overlayConfig",
                    overlayConfig
                ]
            ]);
            return {
                ...prevState,
                activeImageCoordinate
            };
        });
    }, []);
    const handleDatapointSelect = (0, _react.useCallback)((datapoint, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>{
                if (i !== index) return s;
                return {
                    ...s,
                    datapoint,
                    signal: {}
                };
            });
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleDisplayTextAsGridClick = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                displayTextAsGrid: !prevState.displayTextAsGrid
            }));
    }, []);
    const handleImageClick = (0, _react.useCallback)(({ clientX, clientY, target })=>{
        const { bottom, left, right, top } = target.getBoundingClientRect?.() || {};
        const xCalc = (clientX - left) * 100 / (right - left);
        const x = Number(xCalc.toFixed());
        const yCalc = (clientY - top) * 100 / (bottom - top);
        const y = Number(yCalc.toFixed());
        const activeImageCoordinate = new Map([
            [
                "x",
                clientX
            ],
            [
                "y",
                clientY
            ],
            [
                "overlayConfig",
                {
                    x,
                    y
                }
            ]
        ]);
        updateState((prevState)=>({
                ...prevState,
                activeImageCoordinate
            }));
    }, []);
    const handleImageSelect = ([file])=>{
        const handleError = ()=>{
            updateState({
                ...state,
                error: "Error loading image. Please try again."
            });
        };
        const handleSuccess = (image)=>updateState({
                ...state,
                image
            });
        (0, _fileHelpers.handleImageFileConversion)(file, handleError, handleSuccess, 500);
    };
    const handleMinMaxValueUpdate = (0, _react.useCallback)(({ target: { name, value } }, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? {
                    ...s,
                    [name]: value
                } : s);
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleNameAndYScaleUpdate = (0, _react.useCallback)(({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    }, []);
    const handleCommandTypeSelect = (0, _react.useCallback)((selectedType)=>{
        const { helpText, value: widgetType } = selectedType;
        updateState((prevState)=>({
                ...prevState,
                helpText,
                selectedType,
                widgetSignals: [
                    {}
                ],
                widgetType
            }));
    }, []);
    const handleOptionDisabled = (0, _react.useCallback)((signal)=>{
        return state.widgetSignals.some((widgetSignal)=>signal?.value === widgetSignal?.signal?.value);
    }, [
        state.widgetSignals
    ]);
    const handleRangeValueUpdate = ({ target: { name, value } }, outerIndex, innerIndex)=>{
        if (innerIndex && name === "minValue") return;
        const widgetSignals = state.widgetSignals.map((s, index)=>{
            if (index !== outerIndex) return s;
            const ranges = s.ranges.map((r, i)=>{
                switch(true){
                    case i === innerIndex:
                        return {
                            ...r,
                            [name]: value
                        };
                    case name === "maxValue" && innerIndex === i - 1:
                        return {
                            ...r,
                            minValue: value
                        };
                    default:
                        return r;
                }
            });
            return {
                ...s,
                ranges
            };
        });
        updateState((prevState)=>({
                ...prevState,
                error: "",
                widgetSignals
            }));
    };
    const handleRemoveImageOverlaySignal = (0, _react.useCallback)((coordinates)=>{
        updateState((prevState)=>{
            const imageCoordinatesMap = new Map(prevState.imageCoordinatesMap);
            imageCoordinatesMap.delete(coordinates);
            return {
                ...prevState,
                imageCoordinatesMap,
                activeImageCoordinate: new Map()
            };
        });
    }, []);
    const handleRemoveRange = (0, _react.useCallback)((outerIndex, innerIndex)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, index)=>{
                if (index !== outerIndex) return s;
                const filtered = s.ranges.map((r, i, arr)=>{
                    if (!innerIndex || i !== innerIndex + 1) return r;
                    const { maxValue } = arr[innerIndex - 1] || {};
                    return {
                        ...r,
                        minValue: maxValue
                    };
                }).filter((r, i)=>i !== innerIndex);
                const ranges = filtered.length ? filtered : [
                    {
                        id: (0, _uuid.v4)()
                    }
                ];
                return {
                    ...s,
                    ranges
                };
            });
            return {
                ...prevState,
                error: "",
                widgetSignals
            };
        });
    }, []);
    const handleRemoveStaticTextLink = (0, _react.useCallback)((index)=>{
        updateState((prevState)=>{
            const links = prevState.widgetSignals[0].links.filter((_, i)=>i !== index);
            return {
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        links
                    }
                ]
            };
        });
    }, []);
    const handleRemoveWidgetSignal = (0, _react.useCallback)((index)=>{
        updateState((prevState)=>{
            const update = prevState.widgetSignals.filter((x, i)=>i !== index);
            const widgetSignals = update.length ? update : [
                widgetUtils.nonSignalTypes.has(prevState.widgetType) ? {} : widgetUtils.widgetSignalDefault
            ];
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, [
        widgetUtils.nonSignalTypes,
        widgetUtils.widgetSignalDefault
    ]);
    const handleSignalSelect = (0, _react.useCallback)((signal, index)=>{
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? {
                    ...s,
                    signal
                } : s);
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleSignalTypeSelect = (0, _react.useCallback)((selectedType)=>{
        const { helpText, value: widgetType } = selectedType;
        const datapointsMap = widgetUtils.createDatapointMapForDisplay(props.asset?.gtemplate?.datapoints || [], widgetType === (0, _widgetTypes.CAN_SCAN));
        updateState((prevState)=>({
                ...prevState,
                datapointsMap,
                helpText,
                selectedType,
                widgetSignals: [
                    widgetUtils.widgetSignalDefault
                ],
                widgetType
            }));
    }, [
        props.asset?.gtemplate?.datapoints,
        widgetUtils
    ]);
    const handleStaticTextInput = (0, _react.useCallback)(({ target: { value } })=>{
        updateState((prevState)=>({
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        value
                    }
                ],
                error: ""
            }));
    }, []);
    const handleStaticTextLinkInput = (0, _react.useCallback)(({ target: { name, value } }, i)=>{
        updateState((prevState)=>{
            const links = prevState.widgetSignals[0].links?.map((link, index)=>index === i ? {
                    ...link,
                    [name]: value
                } : link);
            return {
                ...prevState,
                widgetSignals: [
                    {
                        ...prevState.widgetSignals[0],
                        links
                    }
                ]
            };
        });
    }, []);
    const handleTagSelect = (0, _react.useCallback)((selectedTag, index)=>{
        if (!selectedTag) return;
        updateState((prevState)=>{
            const widgetSignals = prevState.widgetSignals.map((s, i)=>i === index ? selectedTag : s);
            return {
                ...prevState,
                widgetSignals
            };
        });
    }, []);
    const handleTextStaticTypeSelect = (0, _react.useCallback)((selectedType)=>{
        const { helpText, value: widgetType } = selectedType;
        updateState((prevState)=>({
                ...prevState,
                helpText,
                selectedType,
                widgetSignals: [
                    {
                        value: ""
                    }
                ],
                widgetType
            }));
    }, []);
    const handleTextTagTypeSelect = async (selectedType)=>{
        try {
            const { helpText, value: widgetType } = selectedType;
            updateState((prevState)=>({
                    ...prevState,
                    helpText,
                    selectedType,
                    tagsLoading: true,
                    widgetSignals: [
                        {}
                    ],
                    widgetType
                }));
            const params = {
                orgID: props.asset?.orgID
            };
            const tags = await tagService.getTags(params, source.token);
            const tagSet = new Set(tags.map(({ name })=>name));
            const tagOptions = Array.from(tagSet).map((t)=>({
                    label: t,
                    value: t
                }));
            updateState((prevState)=>({
                    ...prevState,
                    tagsLoaded: true,
                    tagsLoading: false,
                    tagOptions
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    tagsLoading: false
                }));
        }
    };
    const handleTimeSinceLastUpdatedClick = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showTimeSinceLastUpdated: !prevState.showTimeSinceLastUpdated
            }));
    }, []);
    const handleWidgetTypeSelect = async (selectedType)=>{
        switch(selectedType?.value){
            case 0, _widgetTypes.TEXT_STATIC:
                handleTextStaticTypeSelect(selectedType);
                break;
            case 0, _widgetTypes.TEXT_TAGS:
                handleTextTagTypeSelect(selectedType);
                break;
            case 0, _widgetTypes.COMMAND:
                handleCommandTypeSelect(selectedType);
                break;
            default:
                handleSignalTypeSelect(selectedType);
                break;
        }
    };
    const toggleImageOverlayModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                activeImageCoordinate: new Map()
            }));
    }, []);
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWidgetModalDisplayDefault.default), {
        ...props,
        ...state,
        clearImage: clearImage,
        createWidget: createWidget,
        handleAddRange: handleAddRange,
        handleAddImageOverlaySignal: handleAddImageOverlaySignal,
        handleAddStaticTextLink: handleAddStaticTextLink,
        handleAddWidgetCommand: handleAddWidgetCommand,
        handleAddWidgetSignal: handleAddWidgetSignal,
        handleAggregationSelect: handleAggregationSelect,
        handleColorInput: handleColorInput,
        handleColorSelected: handleColorSelected,
        handleCoordinateClick: handleCoordinateClick,
        handleDatapointSelect: handleDatapointSelect,
        handleDisplayTextAsGridClick: handleDisplayTextAsGridClick,
        handleImageClick: handleImageClick,
        handleImageSelect: handleImageSelect,
        handleMinMaxValueUpdate: handleMinMaxValueUpdate,
        handleNameAndYScaleUpdate: handleNameAndYScaleUpdate,
        handleOptionDisabled: handleOptionDisabled,
        handleRangeValueUpdate: handleRangeValueUpdate,
        handleRemoveImageOverlaySignal: handleRemoveImageOverlaySignal,
        handleRemoveRange: handleRemoveRange,
        handleRemoveStaticTextLink: handleRemoveStaticTextLink,
        handleRemoveWidgetSignal: handleRemoveWidgetSignal,
        handleSignalSelect: handleSignalSelect,
        handleStaticTextInput: handleStaticTextInput,
        handleStaticTextLinkInput: handleStaticTextLinkInput,
        handleTagSelect: handleTagSelect,
        handleTimeSinceLastUpdatedClick: handleTimeSinceLastUpdatedClick,
        handleWidgetTypeSelect: handleWidgetTypeSelect,
        maintenanceSelectRef: maintenanceSelectRef,
        timeAggregationOptions: widgetUtils.timeAggregationOptions,
        toggleImageOverlayModal: toggleImageOverlayModal,
        updateState: updateState,
        widgetOptions: widgetOptions
    });
}
CreateWidgetModal.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplate: (0, _propTypesDefault.default).shape({
            commands: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
            datapoints: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object)
        }),
        gtemplateID: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    }),
    currentOrg: (0, _propTypesDefault.default).shape({
        features: (0, _propTypesDefault.default).shape({
            remote: (0, _propTypesDefault.default).bool,
            utilization_reporting: (0, _propTypesDefault.default).shape({
                enabled: (0, _propTypesDefault.default).bool
            })
        })
    }),
    dashboardID: (0, _propTypesDefault.default).string,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    updateWidgets: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","uuid":"hIyym","../../Constants/Signal":"bTf7q","../../Constants/WidgetTypes":"frQz2","../../Lib/CreateWidgetHelper":"dEHje","../../Lib/FileHelpers":"5Iydq","../../Services/TagService":"6HtCg","../../Services/TemplateDashboardService":"kZyFp","../../Lib/WidgetUtils":"uF2rc","./CreateWidgetModalDisplay":"hXSIQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEHje":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var _widgetTypes = require("../Constants/WidgetTypes");
class CreateWidgetHelper {
    constructor(type){
        this.type = type;
        this.settings = {};
        this.sizeX = 1;
        this.sizeY = 1;
        this.row = 0;
        this.col = 0;
    }
    addSettingsByType({ displayTextAsGrid, image, imageCoordinatesMap, maintenanceSelectValue, selectedAggregation, selectedSignals, showTimeSinceLastUpdated, signalCollections, title, yMin, yMax }) {
        switch(this.type){
            case 0, _widgetTypes.BAR_ENGINE_UTILIZATION:
            case 0, _widgetTypes.BAR_FUEL_UTILIZATION:
                return this.addBarUtilizationSettings(title, selectedAggregation);
            case 0, _widgetTypes.COLUMN_GRAPH:
            case 0, _widgetTypes.VERTICAL_COLUMN_GRAPH:
                return this.addBarChartSettings(title, selectedSignals, yMin, yMax);
            case 0, _widgetTypes.LOCATION:
            case 0, _widgetTypes.MAP:
                return this.addMapSettings(title, signalCollections);
            case 0, _widgetTypes.GAUGE:
                return this.addGaugeSettings(title, selectedSignals, signalCollections);
            case 0, _widgetTypes.GAUGE_RANGE:
                return this.addGaugeRangeSettings(title, selectedSignals, signalCollections);
            case 0, _widgetTypes.AREA:
            case 0, _widgetTypes.LINE_GRAPH:
                return this.addLineGraphSettings(title, selectedSignals, yMin, yMax);
            case 0, _widgetTypes.TEXT:
                return this.addTextSettings(title, selectedSignals, showTimeSinceLastUpdated, displayTextAsGrid);
            case 0, _widgetTypes.TEXT_ENGINE:
            case 0, _widgetTypes.TEXT_FUEL:
                return this.addUtilizationSettings(title);
            case 0, _widgetTypes.TEXT_STATIC:
                return this.addTextStaticSettings(title, selectedSignals);
            case 0, _widgetTypes.TEXT_TAGS:
                return this.addTextTagsSettings(title, selectedSignals);
            case 0, _widgetTypes.CAN_SCAN:
                return this.addScanSettings(title, selectedSignals);
            case 0, _widgetTypes.BOOLEAN:
                return this.addBooleanSettings(title, selectedSignals);
            case 0, _widgetTypes.PIE:
                return this.addPieChartSettings(title, selectedSignals);
            case 0, _widgetTypes.COMMAND:
                return this.addCommandSettings(title, selectedSignals);
            case 0, _widgetTypes.IMAGE:
                return this.addImageOverlaySettings(title, image, imageCoordinatesMap);
            case 0, _widgetTypes.MAINTENANCE:
                return this.addMaintenanceSettings(title, maintenanceSelectValue);
        }
    }
    addBarChartSettings(title, selectedSignals, yMin, yMax) {
        const conditionalMaxMin = {};
        if (Number.isFinite(yMax)) conditionalMaxMin.yMax = yMax;
        if (Number.isFinite(yMin)) conditionalMaxMin.yMin = yMin;
        const columns = this.transformSelectedSignals(selectedSignals);
        this.settings = {
            columns,
            title,
            ...conditionalMaxMin
        };
        return this;
    }
    addMapSettings(title, signalCollections) {
        const gpsDP = signalCollections.find(({ type = "" })=>{
            return type.toLowerCase() === "gps";
        });
        this.settings = {
            title,
            latitude: "latitude",
            longitude: "longitude",
            datapointID: gpsDP._id,
            datapoint: gpsDP
        };
        return this;
    }
    addGaugeSettings(title, selectedSignals, signalCollections) {
        const { datapoint: { value: datapointID }, maxValue, minValue, signal: { label: key, value: outputSignal } } = selectedSignals[0];
        let conditionalType = {};
        let datapoint;
        if (datapointID === "outputSignal") {
            conditionalType = {
                type: datapointID
            };
            datapoint = outputSignal;
        } else datapoint = signalCollections.find(({ _id })=>_id === datapointID);
        const max = Number.parseFloat(maxValue);
        const min = Number.parseFloat(minValue);
        if (Number.isNaN(max) || Number.isNaN(min)) throw new Error("Min and Max must be configured.");
        if (max <= min) throw new Error("Max value must be greater than min.");
        let optionalSecond = {};
        if (selectedSignals[1]?.signal?.value) {
            const { datapoint: { value: selectedDP2 }, maxValue: maxValue2, minValue: minValue2, signal } = selectedSignals[1];
            let conditionalType2 = {};
            let datapoint2;
            if (selectedDP2 === "outputSignal") {
                conditionalType2 = {
                    type: selectedDP2
                };
                datapoint2 = signal?.value;
            } else datapoint2 = signalCollections.find(({ _id })=>_id === selectedDP2);
            const max2 = Number.parseFloat(maxValue2);
            const min2 = Number.parseFloat(minValue2);
            if (Number.isNaN(max2) || Number.isNaN(min2)) throw new Error("Min and Max must be configured.");
            if (max2 <= min2) throw new Error("Max value must be greater than min.");
            optionalSecond = {
                secondGauge: {
                    ...conditionalType2,
                    datapoint: datapoint2,
                    datapointID: datapoint2?._id,
                    key: signal.label,
                    max: max2,
                    min: min2
                }
            };
        }
        this.settings = {
            ...conditionalType,
            datapoint,
            datapointID: datapoint._id,
            key,
            max,
            min,
            ...optionalSecond,
            title
        };
        return this;
    }
    addGaugeRangeSettings(title, selectedSignals, signalCollections) {
        const { datapoint: { value: selectedDP }, ranges, signal: { label: key, value: outputSignal } } = selectedSignals[0];
        let conditionalType = {};
        let datapoint;
        if (selectedDP === "outputSignal") {
            conditionalType = {
                type: selectedDP
            };
            datapoint = outputSignal;
        } else datapoint = signalCollections.find(({ _id })=>_id === selectedDP);
        const firstWidgetRanges = ranges.map(({ color, label, maxValue, minValue })=>{
            validateWidgetRanges({
                color,
                label,
                maxValue,
                minValue
            });
            const max = Number.parseFloat(maxValue);
            const min = Number.parseFloat(minValue);
            return {
                color,
                label,
                max,
                min
            };
        });
        let optionalSecond = {};
        if (selectedSignals[1]?.signal?.value) {
            const { datapoint: { value: selectedDP2 }, ranges: ranges2, signal } = selectedSignals[1];
            let conditionalType2 = {};
            let datapoint2;
            if (selectedDP2 === "outputSignal") {
                conditionalType2 = {
                    type: selectedDP2
                };
                datapoint2 = signal?.value;
            } else datapoint2 = signalCollections.find(({ _id })=>_id === selectedDP2);
            const secondWidgetRanges = ranges2.map(({ color, label, maxValue, minValue })=>{
                validateWidgetRanges({
                    color,
                    label,
                    maxValue,
                    minValue
                });
                const max = Number.parseFloat(maxValue);
                const min = Number.parseFloat(minValue);
                return {
                    color,
                    label,
                    max,
                    min
                };
            });
            optionalSecond = {
                secondGauge: {
                    ...conditionalType2,
                    datapoint: datapoint2,
                    datapointID: datapoint2?._id,
                    key: signal.label,
                    ranges: secondWidgetRanges
                }
            };
        }
        this.settings = {
            ...conditionalType,
            datapoint,
            datapointID: datapoint._id,
            key,
            ranges: firstWidgetRanges,
            ...optionalSecond,
            title
        };
        return this;
    }
    addImageOverlaySettings(title, image, imageCoordinatesMap) {
        const lines = this.transformImageCoordinatesMap(imageCoordinatesMap);
        this.settings = {
            image,
            lines,
            title
        };
        return this;
    }
    addLineGraphSettings(title, selectedSignals, yMin, yMax) {
        const conditionalMaxMin = {};
        if (Number.isFinite(yMax)) conditionalMaxMin.yMax = yMax;
        if (Number.isFinite(yMin)) conditionalMaxMin.yMin = yMin;
        const lines = this.transformSelectedSignals(selectedSignals);
        this.settings = {
            title,
            lines,
            ...conditionalMaxMin
        };
        return this;
    }
    addMaintenanceSettings(title, maintenanceSelectValue) {
        const maintenance = maintenanceSelectValue.map(({ label, value })=>({
                reminder_id: value,
                reminder_name: label
            }));
        this.settings = {
            maintenance,
            title
        };
        return this;
    }
    addTextSettings(title, selectedSignals, showTimeSinceLastUpdated, displayTextAsGrid) {
        const text = this.transformSelectedSignals(selectedSignals);
        this.settings = {
            displayTextAsGrid,
            showTimeSinceLastUpdated,
            title,
            text
        };
        return this;
    }
    addTextStaticSettings(title, selectedSignals) {
        const [{ links: inputLinks, value: staticText }] = selectedSignals;
        if (!staticText || staticText.length > 512) throw new Error("Text required. Maximum characters allowed is 512");
        const links = inputLinks?.reduce?.((acc, l)=>l?.display && l?.url ? acc.concat(l) : acc, []);
        this.settings = {
            links,
            staticText,
            title
        };
        return this;
    }
    addTextTagsSettings(title, selectedTags) {
        const tags = selectedTags.map(({ value })=>value).filter((t)=>!!t);
        this.settings = {
            title,
            tags
        };
        return this;
    }
    addScanSettings(title, selectedSignals) {
        const scan = this.transformSelectedSignals(selectedSignals);
        this.settings = {
            title,
            scan
        };
        return this;
    }
    addBooleanSettings(title, selectedSignals) {
        const boolean = this.transformSelectedSignals(selectedSignals);
        this.settings = {
            title,
            boolean
        };
        return this;
    }
    addPieChartSettings(title, selectedSignals) {
        const lines = this.transformSelectedSignals(selectedSignals);
        this.settings = {
            title,
            lines
        };
        return this;
    }
    addCommandSettings(title, selectedSignals) {
        const commands = selectedSignals.map((c)=>{
            const { color, command: { value } = {}, friendlyName } = c || {};
            if (!color || !value || !friendlyName) throw new Error("Each row must have a command, friendly name and color selected.");
            return {
                color,
                commandID: value,
                friendlyName
            };
        });
        this.settings = {
            title,
            commands
        };
        return this;
    }
    addBarUtilizationSettings(title, aggregation) {
        this.settings = {
            aggregation,
            title
        };
        return this;
    }
    addUtilizationSettings(title) {
        this.settings = {
            title
        };
        return this;
    }
    transformImageCoordinatesMap(imageCoordinatesMap) {
        if (!imageCoordinatesMap?.size) throw new Error("Tile must have at least one image overlay configured.");
        return [
            ...imageCoordinatesMap.values()
        ].map(({ datapoint, signal, x, y })=>{
            if (!datapoint?.value) throw new Error("Smart Tile must have datapoint selected!");
            else if (!signal?.label) throw new Error("Smart Tile must have signal selected");
            let conditionalType = {};
            let datapointID = datapoint.value;
            if (datapoint.value === "outputSignal") {
                conditionalType = {
                    type: datapoint.value
                };
                if (!signal?.value?._id) throw new Error("Smart Tile must have signal selected");
                datapointID = signal.value._id;
            }
            return {
                ...conditionalType,
                datapointID,
                key: signal.label,
                x,
                y
            };
        });
    }
    transformSelectedSignals(selectedSignals) {
        return selectedSignals.map(({ datapoint, signal })=>{
            if (!datapoint?.value) throw new Error("Smart Tile must have datapoint selected!");
            else if (!signal?.label) throw new Error("Smart Tile must have signal selected");
            let conditionalType = {};
            let datapointID = datapoint.value;
            if (datapoint.value === "outputSignal") {
                conditionalType = {
                    type: datapoint.value
                };
                if (!signal?.value?._id) throw new Error("Smart Tile must have signal selected");
                datapointID = signal.value._id;
            }
            return {
                ...conditionalType,
                datapointID,
                key: signal.label
            };
        });
    }
}
exports.default = CreateWidgetHelper;
function validateWidgetRanges({ color, label, maxValue, minValue }) {
    if (!(0, _tinycolor2Default.default)(color).isValid()) throw new Error("Valid hex color must be configured for each range.");
    if (!label) throw new Error("Label must be configured for each range.");
    if (Number.isNaN(Number.parseFloat(maxValue))) throw new Error("Max value for ranges must be a valid floating point number.");
    if (Number.isNaN(Number.parseFloat(minValue))) throw new Error("Min value for ranges must be a valid floating point number.");
    if (Number.parseFloat(maxValue) < Number.parseFloat(minValue)) throw new Error("Max value must be greater than Min value for each range.");
    if (Number.parseFloat(minValue) > Number.parseFloat(maxValue)) throw new Error("Min value must be less than Max value for each range.");
}

},{"tinycolor2":"4AVaN","../Constants/WidgetTypes":"frQz2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXSIQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _animated = require("react-select/animated");
var _animatedDefault = parcelHelpers.interopDefault(_animated);
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _debouncePromise = require("debounce-promise");
var _debouncePromiseDefault = parcelHelpers.interopDefault(_debouncePromise);
var _widgetTypes = require("../../Constants/WidgetTypes");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _gatewayReminderInstanceService = require("../../Services/GatewayReminderInstanceService");
var _gatewayReminderInstanceServiceDefault = parcelHelpers.interopDefault(_gatewayReminderInstanceService);
var _selectStyles = require("../../Styles/SelectStyles");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _widgetModalDisplayComponents = require("./WidgetModalDisplayComponents");
var _configureGaugeWidget = require("./ConfigureGaugeWidget");
var _configureGaugeWidgetDefault = parcelHelpers.interopDefault(_configureGaugeWidget);
var _configureImageWidget = require("./ConfigureImageWidget");
var _configureImageWidgetDefault = parcelHelpers.interopDefault(_configureImageWidget);
exports.default = /*#__PURE__*/ (0, _react.memo)(CreateWidgetModalDisplay);
const animatedComponents = (0, _animatedDefault.default)();
function CreateWidgetModalDisplay(props) {
    const { activeImageCoordinate, asset, clearImage, configError, createRequestPending, createWidget, datapointsMap, displayTextAsGrid, error, handleAddImageOverlaySignal, handleAddRange, handleAddStaticTextLink, handleAddWidgetCommand, handleAddWidgetSignal, handleAggregationSelect, handleColorInput, handleColorSelected, handleCoordinateClick, handleDatapointSelect, handleDisplayTextAsGridClick, handleImageClick, handleImageSelect, handleMinMaxValueUpdate, handleNameAndYScaleUpdate, handleOptionDisabled, handleRangeValueUpdate, handleRemoveImageOverlaySignal, handleRemoveRange, handleRemoveStaticTextLink, handleRemoveWidgetSignal, handleSignalSelect, handleStaticTextInput, handleStaticTextLinkInput, handleTagSelect, handleTimeSinceLastUpdatedClick, handleWidgetTypeSelect, helpText, image, imageCoordinatesMap, isOpen, maintenanceSelectRef, selectedAggregation, selectedType, showTimeSinceLastUpdated, tagOptions, tagsLoaded, tagsLoading, timeAggregationOptions, toggleImageOverlayModal, toggleModal, updateState, widgetName, widgetOptions, widgetSignals, widgetType, yMax, yMin } = props;
    const { widgetIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const hideSignals = (0, _react.useMemo)(()=>new Set([
            (0, _widgetTypes.BAR_ENGINE_UTILIZATION),
            (0, _widgetTypes.BAR_FUEL_UTILIZATION),
            (0, _widgetTypes.IMAGE),
            (0, _widgetTypes.LOCATION),
            (0, _widgetTypes.MAP),
            (0, _widgetTypes.TEXT_ENGINE),
            (0, _widgetTypes.TEXT_FUEL)
        ]).has(widgetType), [
        widgetType
    ]), reminderInstanceService = (0, _react.useMemo)(()=>new (0, _gatewayReminderInstanceServiceDefault.default)(), []);
    const templateHasGps = (0, _react.useMemo)(()=>props.asset?.gtemplate?.datapoints?.some?.((c)=>c?.type?.toLowerCase?.() === "gps"), [
        props.asset?.gtemplate?.datapoints
    ]);
    const isWidgetTypeOptionDisabled = (0, _react.useCallback)((type)=>{
        switch(type?.value){
            case 0, _widgetTypes.LOCATION:
            case 0, _widgetTypes.MAP:
                return !templateHasGps;
            default:
                return false;
        }
    }, [
        templateHasGps
    ]);
    const [optionsLoading, setOptionsLoading] = (0, _react.useState)(false), loadInstanceOptions = (0, _react.useCallback)(async (reminder_name)=>{
        try {
            setOptionsLoading(true);
            const params = {
                gateway_id: asset?._id,
                limit: 100,
                page: 1,
                reminder_name
            };
            const { data } = await reminderInstanceService.getPaginatedGatewayReminderInstances(params);
            setOptionsLoading(false);
            return data.map((instance)=>{
                return {
                    label: instance.GtemplateReminder?.name,
                    value: instance.GtemplateReminder?._id
                };
            });
        } catch (error) {
            setOptionsLoading(false);
            return [];
        }
    }, [
        asset?._id,
        reminderInstanceService
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: isOpen,
        scrollable: true,
        size: "lg",
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "pb-0 border-bottom-0",
                toggle: toggleModal,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: widgetIcon,
                        alt: "widget icon",
                        style: {
                            height: "4rem"
                        },
                        className: "jsx-4123256519 img-fluid mx-auto"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-4123256519 mb-0 modal-title-text text-center",
                        children: "New Smart Tile"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "three-quarter-text p-3 px-md-4 container-fluid d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-4123256519 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-4123256519 col-12 form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "widgetName",
                                    className: "jsx-4123256519",
                                    children: "Smart Tile Name"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    name: "widgetName",
                                    type: "text",
                                    value: widgetName,
                                    onChange: handleNameAndYScaleUpdate,
                                    className: "jsx-4123256519 form-control"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-4123256519 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-4123256519 form-group col-12 col-md-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "widgetType",
                                    className: "jsx-4123256519",
                                    children: "Smart Tile Type"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                    classNamePrefix: "select",
                                    components: {
                                        Option
                                    },
                                    isOptionDisabled: isWidgetTypeOptionDisabled,
                                    isSearchable: true,
                                    name: "widgetType",
                                    options: widgetOptions,
                                    onChange: handleWidgetTypeSelect,
                                    value: selectedType
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            height: "2.5rem"
                        },
                        className: "jsx-4123256519 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-4123256519 mb-0 col-12 text-muted helper-text",
                            children: helpText
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.ConfigureAxisMaxMin), {
                        handleNameAndYScaleUpdate: handleNameAndYScaleUpdate,
                        widgetType: widgetType,
                        yMax: yMax,
                        yMin: yMin
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.AddDataRow), {
                        handleAddWidgetSignal: handleAddWidgetSignal,
                        selectedType: selectedType,
                        widgetSignals: widgetSignals,
                        widgetType: widgetType
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.BarUtilizationTimeAggregation), {
                        handleAggregationSelect: handleAggregationSelect,
                        selectedAggregation: selectedAggregation,
                        timeAggregationOptions: timeAggregationOptions,
                        widgetType: widgetType
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.TimeSinceLastUpdatedToggle), {
                        handleTimeSinceLastUpdatedClick: handleTimeSinceLastUpdatedClick,
                        showTimeSinceLastUpdated: showTimeSinceLastUpdated,
                        widgetType: widgetType
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.DisplayTextAsGridToggle), {
                        displayTextAsGrid: displayTextAsGrid,
                        handleDisplayTextAsGridClick: handleDisplayTextAsGridClick,
                        widgetType: widgetType
                    }),
                    widgetType === (0, _widgetTypes.IMAGE) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configureImageWidgetDefault.default), {
                        activeImageCoordinate: activeImageCoordinate,
                        clearImage: clearImage,
                        datapointsMap: datapointsMap,
                        gtemplateID: asset?.gtemplateID,
                        handleAddImageOverlaySignal: handleAddImageOverlaySignal,
                        handleCoordinateClick: handleCoordinateClick,
                        handleImageClick: handleImageClick,
                        handleImageSelect: handleImageSelect,
                        handleRemoveImageOverlaySignal: handleRemoveImageOverlaySignal,
                        image: image,
                        imageCoordinatesMap: imageCoordinatesMap,
                        orgID: asset?.orgID,
                        toggleImageOverlayModal: toggleImageOverlayModal,
                        widgetType: widgetType
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-4123256519 " + `row position-relative ${widgetType === (0, _widgetTypes.IMAGE) ? "" : "flex-fill"}`,
                        children: widgetType ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-4123256519 " + ((hideSignals ? "d-none" : "overflow-auto col-12 h-100 signals-inner-container") || ""),
                            children: widgetSignals.map((s, i)=>{
                                switch(widgetType){
                                    case 0, _widgetTypes.COMMAND:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.CommandsCard), {
                                            asset: asset,
                                            command: s,
                                            handleAddCommand: handleAddWidgetCommand,
                                            handleRemoveCommand: handleRemoveWidgetSignal,
                                            index: i,
                                            selectedCommands: widgetSignals
                                        }, s?.command?.value ?? i);
                                    case 0, _widgetTypes.GAUGE:
                                    case 0, _widgetTypes.GAUGE_RANGE:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configureGaugeWidgetDefault.default), {
                                            datapointsMap: datapointsMap,
                                            gtemplateID: asset?.gtemplateID,
                                            handleAddRange: handleAddRange,
                                            handleColorInput: handleColorInput,
                                            handleColorSelected: handleColorSelected,
                                            handleDatapointSelect: handleDatapointSelect,
                                            handleMinMaxValueUpdate: handleMinMaxValueUpdate,
                                            handleOptionDisabled: handleOptionDisabled,
                                            handleRangeValueUpdate: handleRangeValueUpdate,
                                            handleRemoveRange: handleRemoveRange,
                                            handleRemoveWidgetSignal: handleRemoveWidgetSignal,
                                            handleSignalSelect: handleSignalSelect,
                                            index: i,
                                            orgID: asset?.orgID,
                                            row: s,
                                            updateState: updateState,
                                            widgetType: widgetType
                                        }, i);
                                    case 0, _widgetTypes.MAINTENANCE:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                                            cacheOptions: true,
                                            components: animatedComponents,
                                            defaultOptions: true,
                                            isClearable: true,
                                            isLoading: optionsLoading,
                                            isMulti: true,
                                            isSearchable: true,
                                            loadOptions: (0, _debouncePromiseDefault.default)(loadInstanceOptions, 1000),
                                            placeholder: "Search by Reminder Name",
                                            ref: maintenanceSelectRef,
                                            styles: (0, _selectStyles.BASIC_SELECT_STYLES)
                                        }, `maintenance-reminder-select-${i}`);
                                    case 0, _widgetTypes.TEXT_STATIC:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.TextStaticConfig), {
                                            handleAddStaticTextLink: handleAddStaticTextLink,
                                            handleRemoveStaticTextLink: handleRemoveStaticTextLink,
                                            handleStaticTextInput: handleStaticTextInput,
                                            handleStaticTextLinkInput: handleStaticTextLinkInput,
                                            widgetSignals: widgetSignals
                                        }, i);
                                    case 0, _widgetTypes.TEXT_TAGS:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.TagsCard), {
                                            handleRemoveTag: handleRemoveWidgetSignal,
                                            handleTagSelect: handleTagSelect,
                                            index: i,
                                            row: s,
                                            selectedTags: widgetSignals,
                                            tagOptions: tagOptions,
                                            tagsLoaded: tagsLoaded,
                                            tagsLoading: tagsLoading
                                        }, i);
                                    default:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetModalDisplayComponents.SignalsCard), {
                                            datapointsMap: datapointsMap,
                                            gtemplateID: asset?.gtemplateID,
                                            handleDatapointSelect: handleDatapointSelect,
                                            handleOptionDisabled: handleOptionDisabled,
                                            handleRemoveWidgetSignal: handleRemoveWidgetSignal,
                                            handleSignalSelect: handleSignalSelect,
                                            index: i,
                                            orgID: asset?.orgID,
                                            row: s,
                                            updateState: updateState
                                        }, i);
                                }
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-4123256519 " + ((configError ? "row mt-2 justify-content-end" : "d-none") || ""),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-4123256519 col-auto mb-0 text-danger",
                            children: configError
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-4123256519 " + ((error ? "row mt-2 justify-content-end" : "d-none") || ""),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "jsx-4123256519 col-auto mb-0 text-danger",
                            children: [
                                " ",
                                error
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "justify-content-between border-0 px-md-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-4123256519 btn btn-outline-secondary py-0 px-3",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: configError,
                        onClick: createWidget,
                        className: "jsx-4123256519 btn modal-button-submit py-0 px-3",
                        children: createRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Create"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2047833902",
                children: ".close-modal-x.jsx-4123256519{right:3px;top:3px;font-size:1rem;background-color:transparent;-webkit-text-decoration:none;text-decoration:none;outline:none;cursor:pointer;}.btn.jsx-4123256519{font-size:0.75rem;}@media (min-width:768px){.signals-inner-container.jsx-4123256519{position:absolute;}}"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1956239040",
                children: ".modal-title{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-right:-1.5rem;}"
            })
        ]
    });
}
CreateWidgetModalDisplay.propTypes = {
    activeImageCoordinate: (0, _propTypesDefault.default).object,
    asset: (0, _propTypesDefault.default).object,
    clearImage: (0, _propTypesDefault.default).func,
    createWidget: (0, _propTypesDefault.default).func,
    datapointsMap: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    configError: (0, _propTypesDefault.default).string,
    createRequestPending: (0, _propTypesDefault.default).bool,
    displayTextAsGrid: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    handleAddImageOverlaySignal: (0, _propTypesDefault.default).func,
    handleAddRange: (0, _propTypesDefault.default).func,
    handleAddStaticTextLink: (0, _propTypesDefault.default).func,
    handleAddWidgetCommand: (0, _propTypesDefault.default).func,
    handleAddWidgetSignal: (0, _propTypesDefault.default).func,
    handleAggregationSelect: (0, _propTypesDefault.default).func,
    handleColorInput: (0, _propTypesDefault.default).func,
    handleColorSelected: (0, _propTypesDefault.default).func,
    handleCoordinateClick: (0, _propTypesDefault.default).func,
    handleDatapointSelect: (0, _propTypesDefault.default).func,
    handleDisplayTextAsGridClick: (0, _propTypesDefault.default).func,
    handleImageClick: (0, _propTypesDefault.default).func,
    handleImageSelect: (0, _propTypesDefault.default).func,
    handleMinMaxValueUpdate: (0, _propTypesDefault.default).func,
    handleNameAndYScaleUpdate: (0, _propTypesDefault.default).func,
    handleOptionDisabled: (0, _propTypesDefault.default).func,
    handleRangeValueUpdate: (0, _propTypesDefault.default).func,
    handleRemoveImageOverlaySignal: (0, _propTypesDefault.default).func,
    handleRemoveRange: (0, _propTypesDefault.default).func,
    handleRemoveStaticTextLink: (0, _propTypesDefault.default).func,
    handleRemoveWidgetSignal: (0, _propTypesDefault.default).func,
    handleSignalSelect: (0, _propTypesDefault.default).func,
    handleStaticTextInput: (0, _propTypesDefault.default).func,
    handleStaticTextLinkInput: (0, _propTypesDefault.default).func,
    handleTagSelect: (0, _propTypesDefault.default).func,
    handleTimeSinceLastUpdatedClick: (0, _propTypesDefault.default).func,
    handleWidgetTypeSelect: (0, _propTypesDefault.default).func,
    helpText: (0, _propTypesDefault.default).string,
    image: (0, _propTypesDefault.default).string,
    imageCoordinatesMap: (0, _propTypesDefault.default).object,
    isOpen: (0, _propTypesDefault.default).bool,
    maintenanceSelectRef: (0, _propTypesDefault.default).object,
    maxValue: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    selectedAggregation: (0, _propTypesDefault.default).string,
    selectedType: (0, _propTypesDefault.default).object,
    showTimeSinceLastUpdated: (0, _propTypesDefault.default).bool,
    tagOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    tagsLoaded: (0, _propTypesDefault.default).bool,
    tagsLoading: (0, _propTypesDefault.default).bool,
    timeAggregationOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    toggleImageOverlayModal: (0, _propTypesDefault.default).func,
    toggleModal: (0, _propTypesDefault.default).func,
    updateState: (0, _propTypesDefault.default).func,
    widgetName: (0, _propTypesDefault.default).string,
    widgetOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    widgetSignals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    widgetType: (0, _propTypesDefault.default).string,
    yMax: (0, _propTypesDefault.default).string,
    yMin: (0, _propTypesDefault.default).string
};
CreateWidgetModalDisplay.defaultProps = {
    widgetSignals: [],
    selectedType: {}
};
function Option(props) {
    return props.isDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Option, {
                ...props
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                target: props.innerProps.id,
                children: "Asset Model does not have a GPS Signal Collection"
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Option, {
        ...props
    });
}
Option.propTypes = {
    innerProps: (0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string
    }),
    isDisabled: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","react-select/animated":"jbxWd","react-select/async":"iHFh7","react-select":"j36cq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","debounce-promise":"fqOKC","../../Constants/WidgetTypes":"frQz2","../../Context/IconsContext":"lzIpe","../../Services/GatewayReminderInstanceService":"WwEop","../../Styles/SelectStyles":"1LnYJ","../ModalLayout":"2RoDj","./WidgetModalDisplayComponents":"2mwfq","./ConfigureGaugeWidget":"bp5hi","./ConfigureImageWidget":"5Fa08","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hjFjB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _templateDashboardService = require("../../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
var _basicDeleteConfirmationModal = require("../BasicDeleteConfirmationModal");
var _basicDeleteConfirmationModalDefault = parcelHelpers.interopDefault(_basicDeleteConfirmationModal);
exports.default = /*#__PURE__*/ (0, _react.memo)(DeleteTemplateDashboardModal);
function DeleteTemplateDashboardModal(props) {
    const [state, updateState] = (0, _react.useState)({
        deleteRequestPending: false,
        error: ""
    });
    const source = (0, _axios.CancelToken).source();
    const handleDelete = async ()=>{
        try {
            updateState({
                ...state,
                deleteRequestPending: true
            });
            await new (0, _templateDashboardServiceDefault.default)().deleteTemplateDashboard(props.gtemplateID, props.dashboard._id, source.token);
            props.handleDashboardDeleted(props.dashboard._id);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                error,
                deleteRequestPending: false
            });
        }
    };
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _basicDeleteConfirmationModalDefault.default), {
        ...props,
        deleteRequestPending: state.deleteRequestPending,
        error: state.error,
        handleDelete: handleDelete,
        modalData: {
            itemName: props.dashboard.name,
            itemType: "asset model dashboard"
        }
    });
}
DeleteTemplateDashboardModal.propTypes = {
    dashboard: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        name: (0, _propTypesDefault.default).string
    }),
    gtemplateID: (0, _propTypesDefault.default).string,
    handleDashboardDeleted: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/TemplateDashboardService":"kZyFp","../BasicDeleteConfirmationModal":"kvnYU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kvnYU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const propTypes = {
    deleteRequestPending: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    handleDelete: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    modalData: (0, _propTypesDefault.default).shape({
        itemType: (0, _propTypesDefault.default).string,
        itemName: (0, _propTypesDefault.default).string
    }),
    toggleModal: (0, _propTypesDefault.default).func
};
const defaultProps = {
    deleteRequestPending: false,
    error: "",
    handleDelete: ()=>{},
    isOpen: false,
    modalData: {},
    toggleModal: ()=>{}
};
const BasicDeleteConfirmationModal = ({ deleteRequestPending, isOpen, toggleModal, error, handleDelete, modalData: { itemType = "", itemName = "" } })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        centered: true,
        contentClassName: "rounded-lg",
        isOpen: isOpen,
        toggle: ()=>toggleModal(!isOpen),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: ()=>toggleModal(!isOpen),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "jsx-460176460 text-muted",
                    children: `Delete ${itemType.charAt(0).toUpperCase()}${itemType.substring(1)}?`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "d-flex flex-column pt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "jsx-460176460 mt-3 text-muted three-quarter-text desktop-text",
                        children: [
                            "The selected ",
                            itemType.toLowerCase(),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-460176460 font-weight-bolder mark",
                                children: itemName
                            }),
                            " will be deleted"
                        ]
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-460176460 text-danger",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "justify-content-between justify-content-md-end border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleDelete,
                        className: "jsx-460176460 btn btn-danger px-3 py-0 nine-tenth-text text-nowrap",
                        children: deleteRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            size: "lg",
                            className: "m-1"
                        }) : "Yes, Delete"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>toggleModal(!isOpen),
                        className: "jsx-460176460 btn btn-outline-secondary ml-md-4 px-4 py-0 nine-tenth-text",
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "460176460",
                children: "@media (min-width:768px){.desktop-text.jsx-460176460{font-size:1rem !important;}}"
            })
        ]
    });
};
BasicDeleteConfirmationModal.propTypes = propTypes;
BasicDeleteConfirmationModal.defaultProps = defaultProps;
exports.default = /*#__PURE__*/ (0, _react.memo)(BasicDeleteConfirmationModal);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Si3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
exports.default = /*#__PURE__*/ (0, _react.memo)(ViewTemplateDashboardsModal);
function ViewTemplateDashboardsModal(props) {
    const [state, updateState] = (0, _react.useState)({
        dashboardSearchTerm: props.dashboardSearchTerm
    });
    const handleSearch = ({ target: { name, value } })=>{
        updateState({
            ...state,
            [name]: value
        });
    };
    const filteredDashboards = (0, _react.useMemo)(()=>{
        return props.templateDashboards.filter(({ name = "" })=>{
            if (!state.dashboardSearchTerm) return true;
            const prunedName = name.toLowerCase().trim();
            const prunedSearch = state.dashboardSearchTerm.toLowerCase().trim();
            return prunedName.includes(prunedSearch);
        });
    }, [
        state.dashboardSearchTerm
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        isOpen: props.isOpen,
        toggleModal: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: props.toggleModal,
                children: "Choose a Dashboard"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "py-0 container-fluid d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row no-gutters",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-907359250 col-12 three-quarter-text text-left",
                            children: "Select a dashboard from below to view. You can then set it as the default view for your user from the \u201CSettings\u201D dropdown located at the top right of the Asset details page"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row no-gutters mb-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-907359250 col-12 input-group input-group-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    "aria-label": "Dashboard Search",
                                    "aria-describedby": "search-icon",
                                    name: "dashboardSearchTerm",
                                    onChange: handleSearch,
                                    placeholder: "Search for dashboards...",
                                    type: "text",
                                    value: state.dashboardSearchTerm,
                                    className: "jsx-907359250 form-control rounded-lg"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-907359250 input-group-append",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        id: "search-icon",
                                        className: "jsx-907359250 input-group-text bg-transparent border-0 pr-0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: "text-text-light-gray",
                                            icon: (0, _freeSolidSvgIcons.faSearch)
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row no-gutters flex-fill position-relative overflow-auto",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-907359250 position-absolute h-100 w-100 container-fluid",
                            children: filteredDashboards.map((dashboard)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-907359250 row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-907359250 col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>props.handleDashboardSelected(dashboard),
                                            className: "jsx-907359250 btn btn-link",
                                            children: dashboard.name
                                        })
                                    })
                                }, dashboard._id))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: props.toggleModal,
                    className: "jsx-907359250 btn btn-outline-secondary bg-white text-muted shadow-none py-0 px-3",
                    children: "Cancel"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "907359250",
                children: ".btn.jsx-907359250:focus{outline:none;}"
            })
        ]
    });
}
ViewTemplateDashboardsModal.propTypes = {
    dashboardSearchTerm: (0, _propTypesDefault.default).string,
    handleDashboardSelected: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    templateDashboards: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplateID: (0, _propTypesDefault.default).string,
        isDefault: (0, _propTypesDefault.default).bool,
        name: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        widgets: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            col: (0, _propTypesDefault.default).number,
            row: (0, _propTypesDefault.default).number,
            settings: (0, _propTypesDefault.default).object,
            sizeX: (0, _propTypesDefault.default).number,
            sizeY: (0, _propTypesDefault.default).number
        }))
    })),
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../ModalLayout":"2RoDj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gT2rI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _templateDashboardService = require("../../Services/TemplateDashboardService");
var _templateDashboardServiceDefault = parcelHelpers.interopDefault(_templateDashboardService);
exports.default = /*#__PURE__*/ (0, _react.memo)(EditDashboardModal);
const initState = {
    error: "",
    isUserPreference: false,
    requestPending: true
};
function EditDashboardModal(props) {
    const [state, updateState] = (0, _react.useState)(()=>{
        const { isPrivate, name } = props.dashboard;
        return {
            ...initState,
            isPrivate,
            name
        };
    });
    const source = (0, _axios.CancelToken).source();
    const checkIfUserPreference = async ()=>{
        try {
            await new (0, _templateDashboardServiceDefault.default)().checkUserPreferenceDashboard(props.assetID, props.dashboard._id, source.token);
            updateState({
                ...state,
                isUserPreference: true,
                requestPending: false
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            updateState({
                ...state,
                isUserPreference: false,
                requestPending: false
            });
        }
    };
    const handleCheckboxChecked = ({ target: { id, checked } })=>{
        updateState({
            ...state,
            [id]: checked
        });
    };
    const handleSave = async ()=>{
        try {
            updateState({
                ...state,
                requestPending: true
            });
            await props.handleEditDashboardSave(state);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                requestPending: false
            });
        }
    };
    (0, _react.useEffect)(()=>{
        checkIfUserPreference();
        return source.cancel;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        centered: true,
        isOpen: props.isOpen,
        size: "md",
        toggle: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: props.toggleModal,
                children: "Edit Dashboard"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "pb-md-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "name",
                                children: "Dashboard Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "form-control form-control-sm",
                                name: "name",
                                onChange: ({ target: { value } })=>updateState({
                                        ...state,
                                        name: value
                                    }),
                                readOnly: state.requestPending,
                                type: "text",
                                value: state.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-check my-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                checked: state.isUserPreference,
                                className: "form-check-input",
                                id: "isUserPreference",
                                onChange: handleCheckboxChecked,
                                readOnly: state.requestPending,
                                type: "checkbox"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "form-check-label text-text-light-gray",
                                htmlFor: "isUserPreference",
                                children: "Set as your Default Dashboard?"
                            })
                        ]
                    }),
                    !props.dashboard.isDefault ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-check my-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                checked: state.isPrivate,
                                className: "form-check-input",
                                id: "isPrivate",
                                onChange: handleCheckboxChecked,
                                readOnly: state.requestPending,
                                type: "checkbox"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "form-check-label text-text-light-gray",
                                htmlFor: "isPrivate",
                                children: "Set as Private Dashboard and grant other users access?"
                            })
                        ]
                    }) : null,
                    state.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-error three-quarter-text text-right",
                        children: state.error
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-outline-secondary text-muted bg-white shadow-none rounded-lg three-quarter-text py-0 px-3",
                        disabled: state.requestPending,
                        onClick: props.toggleModal,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn modal-button-submit rounded-lg three-quarter-text py-0 px-3",
                        disabled: state.requestPending,
                        onClick: handleSave,
                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Save"
                    })
                ]
            })
        ]
    });
}
EditDashboardModal.propTypes = {
    assetID: (0, _propTypesDefault.default).string,
    dashboard: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        isDefault: (0, _propTypesDefault.default).bool,
        isPrivate: (0, _propTypesDefault.default).bool,
        name: (0, _propTypesDefault.default).string
    }),
    handleEditDashboardSave: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};
EditDashboardModal.defaultProps = {
    dashboard: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Services/TemplateDashboardService":"kZyFp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6nPcI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactstrap = require("reactstrap");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _organizationService = require("../../Services/OrganizationService");
var _organizationServiceDefault = parcelHelpers.interopDefault(_organizationService);
var _rootOrgContext = require("../../Context/RootOrgContext");
var _rootOrgContextDefault = parcelHelpers.interopDefault(_rootOrgContext);
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _loadingCircle = require("../LoadingCircle");
exports.default = /*#__PURE__*/ (0, _react.memo)(AddDashboardUsersModal);
const initState = {
    dashboardUsers: [],
    ecosystemUsers: [],
    error: "",
    requestPending: true,
    saveRequestPending: false
};
const selectStyles = {
    control: (base)=>({
            ...base,
            borderColor: "var(--third-gray) !important",
            outline: "none",
            boxShadow: "none"
        }),
    dropdownIndicator: (base)=>({
            ...base,
            display: "none"
        }),
    indicatorSeparator: (base)=>({
            ...base,
            display: "none"
        })
};
function AddDashboardUsersModal(props) {
    const { isSupraUi, isVersatileUi } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const { profileIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const [state, updateState] = (0, _react.useState)(initState);
    const source = (0, _axios.CancelToken).source();
    const { _id: rootOrgID } = (0, _react.useContext)((0, _rootOrgContextDefault.default));
    const { _id: currentOrgID, path: currentOrgPath } = (0, _react.useContext)((0, _currentOrgContextDefault.default));
    const pathOrgIDs = currentOrgPath.split(".");
    const disabledOptions = ({ value: { userID } })=>{
        return state.dashboardUsers.some((u)=>u.userID === userID);
    };
    const userIsInPath = (Orgs)=>{
        if (!Array.isArray(Orgs)) return false;
        return Orgs.some(({ _id, OrgUser })=>{
            switch(true){
                case _id === currentOrgID:
                case pathOrgIDs.includes(OrgUser.orgID):
                    return true;
                case !Object.keys(OrgUser || {}).length:
                    return false;
                default:
                    return false;
            }
        });
    };
    const fetchEcosystemUsers = async ()=>{
        try {
            const allUsers = await new (0, _organizationServiceDefault.default)().fetchAllOrganizationUsers(rootOrgID, source.token);
            const { dashboardUsers, ecosystemUsers } = allUsers.reduce((acc, u)=>{
                const { _id: userID, email, firstName, lastName, Orgs } = u;
                if (!userIsInPath(Orgs)) return acc;
                const value = {
                    userID,
                    email,
                    firstName,
                    lastName
                };
                if (props.dashboard.users.includes(userID)) acc.dashboardUsers.push(value);
                acc.ecosystemUsers.push({
                    label: `${firstName} ${lastName} (${email})`,
                    value
                });
                return acc;
            }, {
                dashboardUsers: [],
                ecosystemUsers: []
            });
            updateState({
                ...state,
                dashboardUsers,
                ecosystemUsers,
                requestPending: false
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                requestPending: false
            });
        }
    };
    const filterOptions = ({ value: { email = "", firstName = "", lastName = "" } }, search)=>{
        if (!search) return true;
        const prunedEmail = email.toLowerCase().trim();
        const prunedFirst = firstName.toLowerCase().trim();
        const prunedLast = lastName.toLowerCase().trim();
        const prunedSearch = search.toLowerCase().trim();
        return prunedEmail.includes(prunedSearch) || prunedFirst.includes(prunedSearch) || prunedLast.includes(prunedSearch);
    };
    const handleAddUser = ()=>{
        const dashboardUsers = [
            state.selectedUser.value,
            ...state.dashboardUsers
        ];
        updateState({
            ...state,
            dashboardUsers,
            selectedUser: null
        });
    };
    const handleRemoveUser = ({ userID })=>{
        const dashboardUsers = state.dashboardUsers.filter((u)=>{
            return u.userID !== userID;
        });
        updateState({
            ...state,
            dashboardUsers
        });
    };
    const handleUserSelect = (selectedUser)=>{
        updateState({
            ...state,
            selectedUser
        });
    };
    const handleSave = async ()=>{
        try {
            updateState({
                ...state,
                saveRequestPending: true
            });
            const users = state.dashboardUsers.map(({ userID })=>userID);
            await props.handleAddUsersSave(users);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                saveRequestPending: false
            });
        }
    };
    (0, _react.useEffect)(()=>{
        fetchEcosystemUsers();
        return source.cancel;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        isOpen: props.isOpen,
        toggleModal: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0 pb-0",
                toggle: props.toggleModal,
                children: "Manage Users For Private Dashboard"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "d-flex flex-column px-md-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-907359250 modal-supplemental-text w-75",
                        children: "Manage users from the ecosystem with to access this private dashboard. Anyone added to the dashboard will be able to add others."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-907359250 d-flex",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-907359250 flex-grow-1 mr-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                    filterOption: filterOptions,
                                    isClearable: true,
                                    isLoading: state.requestPending,
                                    isOptionDisabled: disabledOptions,
                                    onChange: handleUserSelect,
                                    options: state.ecosystemUsers,
                                    placeholder: "Give user access...",
                                    styles: selectStyles,
                                    value: state.selectedUser
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-907359250 flex-shrink-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    disabled: !state.selectedUser,
                                    onClick: handleAddUser,
                                    className: "jsx-907359250 btn btn-block h-100 modal-button-secondary three-quarter-text rounded-lg px-3",
                                    children: "Add"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 mt-3 flex-fill position-relative overflow-auto",
                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-907359250 h-100 w-100 d-flex align-items-center justify-content-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                                size: "3x"
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-907359250 h-100 w-100 position-absolute container-fluid",
                            children: state.dashboardUsers.map((u)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-907359250 row align-items-center my-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-907359250 col-auto",
                                            children: isSupraUi || isVersatileUi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faUser),
                                                size: "lg"
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                alt: "profile icon",
                                                height: 30,
                                                src: profileIcon,
                                                width: 30,
                                                className: "jsx-907359250"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "jsx-907359250 col d-flex flex-column",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    className: "jsx-907359250 font-weight-bold text-dark mb-0",
                                                    children: [
                                                        u.firstName,
                                                        " ",
                                                        u.lastName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                    className: "jsx-907359250 text-text-light-gray",
                                                    children: u.email
                                                })
                                            ]
                                        }),
                                        state.dashboardUsers.length > 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-907359250 col-auto",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>handleRemoveUser(u),
                                                className: "jsx-907359250 btn btn-link text-decoration-none text-icon-link-gray p-0 shadow-none",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faTimes),
                                                    size: "lg"
                                                })
                                            })
                                        }) : null
                                    ]
                                }, u.userID))
                        })
                    }),
                    state.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-907359250 text-danger three-quarter-text text-right mb-0",
                        children: state.error
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: state.requestPending,
                        onClick: props.toggleModal,
                        className: "jsx-907359250 btn btn-outline-secondary text-muted bg-white rounded-lg three-quarter-text py-0 px-3",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: state.requestPending,
                        onClick: handleSave,
                        className: "jsx-907359250 btn modal-button-submit rounded-lg three-quarter-text py-0 px-3",
                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Save"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "907359250",
                children: ".btn.jsx-907359250:focus{outline:none;}"
            })
        ]
    });
}
AddDashboardUsersModal.propTypes = {
    dashboard: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        users: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    }),
    handleAddUsersSave: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","reactstrap":"kjd7g","react-select":"j36cq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/BrandingContext":"bKKTd","../../Context/IconsContext":"lzIpe","../../Services/OrganizationService":"lm5wc","../../Context/RootOrgContext":"2o1kk","../../Context/CurrentOrgContext":"jQXcJ","../ModalLayout":"2RoDj","../LoadingCircle":"aIADA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TjKme":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _schedulesService = require("../../Services/SchedulesService");
var _schedulesServiceDefault = parcelHelpers.interopDefault(_schedulesService);
var _assetMaintenanceDisplay = require("./AssetMaintenanceDisplay");
var _assetMaintenanceDisplayDefault = parcelHelpers.interopDefault(_assetMaintenanceDisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetMaintenanceContainer);
const initState = {
    assetReminderInstances: [],
    checkedInstances: new Map(),
    dataLoading: true,
    reminderNameSearch: "",
    scheduleNameSearch: "",
    typeFilter: [
        "complete",
        "due",
        "upcoming"
    ]
};
function AssetMaintenanceContainer(props) {
    const { assetID } = (0, _reactRouterDom.useParams)();
    const { _id: orgID } = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    const [state, updateState] = (0, _react.useState)(initState);
    const [page, updatePage] = (0, _react.useState)(0);
    const [showServiceCompleteModal, toggleServiceCompleteModal] = (0, _react.useState)(false);
    const source = (0, _axios.CancelToken).source();
    const assetShadowSignalsMap = (0, _react.useMemo)(()=>{
        if (!props.asset.shadow?.signalCollections?.length) return new Map();
        const entries = props.asset.shadow.signalCollections.reduce((acc, { signals = [] } = {})=>{
            if (!signals.length) return acc;
            signals.forEach(({ name, ...rest } = {})=>{
                acc.push([
                    name,
                    rest
                ]);
            });
            return acc;
        }, []);
        return new Map(entries);
    }, [
        props.asset.shadow?.signalCollections?.length
    ]);
    const handlePropUpdate = ({ target: { name, value } } = {})=>{
        updateState({
            ...state,
            [name]: value
        });
    };
    const handleTypeFilterSelect = ({ value })=>{
        const typeFilter = state.typeFilter.includes(value) ? state.typeFilter.filter((f)=>f !== value) : state.typeFilter.concat(value);
        updateState({
            ...state,
            typeFilter
        });
    };
    const handleInstanceChecked = ([id, instance])=>{
        const checkedInstances = new Map(state.checkedInstances);
        if (checkedInstances.has(id)) checkedInstances.delete(id);
        else checkedInstances.set(id, instance);
        updateState({
            ...state,
            checkedInstances
        });
    };
    const handleSelectAllInstances = (instances, allChecked)=>{
        const checkedInstances = allChecked ? new Map() : new Map(instances);
        updateState({
            ...state,
            checkedInstances
        });
    };
    const fetchAssetInstances = async (filters = {}, closeServiceCompleteModal = false)=>{
        try {
            const params = {
                orgID,
                children: true,
                gatewayIdFilter: assetID,
                ...filters
            };
            const assetReminderInstances = await new (0, _schedulesServiceDefault.default)().fetchReminderInstances(params, source.token);
            updateState({
                ...state,
                assetReminderInstances,
                dataLoading: false
            });
            closeServiceCompleteModal && toggleServiceCompleteModal(!showServiceCompleteModal);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                dataLoading: false
            });
        }
    };
    const clearFilters = ()=>{
        updateState({
            ...state,
            reminderNameSearch: "",
            scheduleNameSearch: "",
            typeFilter: [
                "due",
                "upcoming"
            ]
        });
    };
    (0, _react.useEffect)(()=>{
        if (!orgID) return;
        fetchAssetInstances();
    }, [
        orgID
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetMaintenanceDisplayDefault.default), {
        ...state,
        assetShadowSignalsMap: assetShadowSignalsMap,
        clearFilters: clearFilters,
        fetchAssetInstances: fetchAssetInstances,
        handleInstanceChecked: handleInstanceChecked,
        handlePropUpdate: handlePropUpdate,
        handleSelectAllInstances: handleSelectAllInstances,
        handleTypeFilterSelect: handleTypeFilterSelect,
        page: page,
        showServiceCompleteModal: showServiceCompleteModal,
        toggleServiceCompleteModal: toggleServiceCompleteModal,
        updatePage: updatePage
    });
}
AssetMaintenanceContainer.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplate: (0, _propTypesDefault.default).shape({
            datapoints: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                _id: (0, _propTypesDefault.default).string,
                name: (0, _propTypesDefault.default).string,
                values: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                    _id: (0, _propTypesDefault.default).string,
                    name: (0, _propTypesDefault.default).string
                }))
            }))
        }),
        orgID: (0, _propTypesDefault.default).string,
        shadow: (0, _propTypesDefault.default).shape({
            signalCollections: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                _id: (0, _propTypesDefault.default).string,
                signals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                    _id: (0, _propTypesDefault.default).string,
                    name: (0, _propTypesDefault.default).string,
                    value: (0, _propTypesDefault.default).oneOfType([
                        (0, _propTypesDefault.default).number,
                        (0, _propTypesDefault.default).string
                    ]),
                    timestamp: (0, _propTypesDefault.default).number
                }))
            }))
        })
    })
};
AssetMaintenanceContainer.defaultProps = {
    asset: {},
    currentOrg: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","../../Context/CurrentOrgContext":"jQXcJ","../../Services/SchedulesService":"3S44n","./AssetMaintenanceDisplay":"iKpf1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3S44n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _authService = require("./AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class SchedulesService {
    auth = new (0, _authServiceDefault.default)();
    api = new (0, _requestsDefault.default)();
    buildSchedulesForOrgRequest({ params, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/schedule",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchSchedulesForOrg(params) {
        const { data = {} } = await this.api.request(this.buildSchedulesForOrgRequest(params));
        return data;
    }
    buildScheduleRequest({ orgID = this.auth.getCurrentOrgID(), scheduleId, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}`,
            method: "get",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async fetchSchedule(params) {
        const { data = {} } = await this.api.request(this.buildScheduleRequest(params));
        return data;
    }
    buildCreateScheduleRequest({ orgID = this.auth.getCurrentOrgID(), data, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/schedule",
            method: "post",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async createSchedule(params) {
        const { data = {} } = await this.api.request(this.buildCreateScheduleRequest(params));
        return data;
    }
    buildDeleteScheduleRequest({ orgID = this.auth.getCurrentOrgID(), scheduleId }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}`,
            method: "delete",
            params: {
                orgID
            }
        };
    }
    async deleteSchedule(params) {
        const { data = {} } = await this.api.request(this.buildDeleteScheduleRequest(params));
        return data;
    }
    buildUpdateScheduleRequest({ orgID = this.auth.getCurrentOrgID(), scheduleId, data, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}`,
            method: "put",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async updateSchedule(params) {
        const { data = {} } = await this.api.request(this.buildUpdateScheduleRequest(params));
        return data;
    }
    buildAddGatewayRequest({ orgID = this.auth.getCurrentOrgID(), scheduleId, data, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/gateway`,
            method: "post",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async addGateway(params) {
        const { data = {} } = await this.api.request(this.buildAddGatewayRequest(params));
        return data;
    }
    buildDeleteGatewayRequest({ orgID = this.auth.getCurrentOrgID(), scheduleId, gatewayId, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/gateway/${gatewayId}`,
            method: "delete",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async deleteGateway(params) {
        const { data = {} } = await this.api.request(this.buildDeleteGatewayRequest(params));
        return data;
    }
    buildCreateReminderRequest(params, data, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/reminder",
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async createReminder(params, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateReminderRequest(params, body, cancelToken));
        return data;
    }
    buildUpdateReminderRequest(reminderID, params, data, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/reminder/${reminderID}`,
            method: "put",
            params,
            data,
            cancelToken
        };
    }
    async updateReminder(reminderID, params, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateReminderRequest(reminderID, params, body, cancelToken));
        return data;
    }
    buildDeleteReminderRequest(reminderID, params, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/reminder/${reminderID}`,
            method: "delete",
            params,
            cancelToken
        };
    }
    deleteReminder(reminderID, params, cancelToken) {
        return this.api.request(this.buildDeleteReminderRequest(reminderID, params, cancelToken));
    }
    buildReminderInstancesRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/reminder-instance",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchReminderInstances(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildReminderInstancesRequest(params, cancelToken));
        return data;
    }
    buildEditReminderInstancesRequest({ orgID = this.auth.getCurrentOrgID(), instanceId, data, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/reminder-instance/${instanceId}`,
            method: "put",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async editReminderInstance(params) {
        const { data = {} } = await this.api.request(this.buildEditReminderInstancesRequest(params));
        return data;
    }
    buildFetchScheduleGatewayRequest({ orgID = this.auth.getCurrentOrgID(), scheduleId, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/gateway`,
            method: "get",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async fetchScheduleGateways(params) {
        const { data = [] } = await this.api.request(this.buildFetchScheduleGatewayRequest(params));
        return data;
    }
    buildReminderTriggersRequest({ orgID = this.auth.getCurrentOrgID(), instanceId, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/reminder-trigger",
            method: "get",
            params: {
                orgID,
                instanceIdFilter: instanceId
            },
            cancelToken
        };
    }
    async fetchReminderTriggers(params) {
        const { data = {} } = await this.api.request(this.buildReminderTriggersRequest(params));
        return data;
    }
    buildAddServiceManualRequest({ scheduleId, data, orgID, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/service-manual`,
            method: "put",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async addServiceManual(params) {
        const { data = {} } = await this.api.request(this.buildAddServiceManualRequest(params));
        return data;
    }
    buildGetServiceManualRequest({ scheduleId, orgID, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/service-manual`,
            method: "get",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async getServiceManual(params) {
        const { data = {} } = await this.api.request(this.buildGetServiceManualRequest(params));
        return data;
    }
    buildDeleteServiceManualRequest({ scheduleId, orgID, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/service-manual`,
            method: "delete",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async deleteServiceManual(params) {
        const { data = {} } = await this.api.request(this.buildDeleteServiceManualRequest(params));
        return data;
    }
    buildAddReminderAttachmentRequest({ scheduleId, reminderId, data, orgID, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/attachment/${reminderId}`,
            method: "put",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async addReminderAttachment(params) {
        const { data = {} } = await this.api.request(this.buildAddReminderAttachmentRequest(params));
        return data;
    }
    buildGetReminderAttachmentRequest({ scheduleId, reminderId, orgID, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/attachment/${reminderId}`,
            method: "get",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async getReminderAttachment(params) {
        const { data = {} } = await this.api.request(this.buildGetReminderAttachmentRequest(params));
        return data;
    }
    buildDeleteReminderAttachmentRequest({ scheduleId, reminderId, orgID, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/schedule/${scheduleId}/attachment/${reminderId}`,
            method: "delete",
            params: {
                orgID
            },
            cancelToken
        };
    }
    async deleteReminderAttachment(params) {
        const { data = {} } = await this.api.request(this.buildDeleteReminderAttachmentRequest(params));
        return data;
    }
    buildAddMaintenanceLog({ reminderTriggerId, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/reminder-trigger/${reminderTriggerId}/maintenance-log`,
            method: "post",
            cancelToken
        };
    }
    async addMaintenanceLog(params) {
        const { data = {} } = await this.api.request(this.buildAddMaintenanceLog(params));
        return data;
    }
    buildAddMaintenanceLogBulk({ orgID, data, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/reminder-trigger/maintenance-log/bulk",
            method: "post",
            params: {
                orgID
            },
            data,
            cancelToken
        };
    }
    async addMaintenanceLogBulk(params) {
        const { data = {} } = await this.api.request(this.buildAddMaintenanceLogBulk(params));
        return data;
    }
    buildFetchOrgMaintenanceMetricsRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/metrics/maintenance",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchOrgMaintenanceMetrics(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchOrgMaintenanceMetricsRequest(params, cancelToken));
        return data;
    }
    buildFetchAssetsForMaintenanceDashboardRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/metrics/gateway/reminders",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchAssetsForMaintenanceDashboard(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchAssetsForMaintenanceDashboardRequest(params, cancelToken));
        return data;
    }
}
exports.default = SchedulesService;

},{"./AuthService":"8Bjjn","../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iKpf1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _widthContext = require("../../Context/WidthContext");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _serviceTableMobileFilters = require("../Maintenance/ServiceTableMobileFilters");
var _serviceTableMobileFiltersDefault = parcelHelpers.interopDefault(_serviceTableMobileFilters);
var _serviceCompleteModalContainer = require("../Maintenance/ServiceCompleteModalContainer");
var _serviceCompleteModalContainerDefault = parcelHelpers.interopDefault(_serviceCompleteModalContainer);
var _assetMaintenanceTable = require("./AssetMaintenanceTable");
var _assetMaintenanceTableDefault = parcelHelpers.interopDefault(_assetMaintenanceTable);
var _mobileMaintenanceCard = require("./MobileMaintenanceCard");
var _mobileMaintenanceCardDefault = parcelHelpers.interopDefault(_mobileMaintenanceCard);
var _mobileMaintenanceFilters = require("./MobileMaintenanceFilters");
var _mobileMaintenanceFiltersDefault = parcelHelpers.interopDefault(_mobileMaintenanceFilters);
var _loadingCircle = require("../LoadingCircle");
var _loadingCircleDefault = parcelHelpers.interopDefault(_loadingCircle);
var _noDataIndication = require("../NoDataIndication");
var _paginationFooter = require("../PaginationFooter");
var _paginationFooterDefault = parcelHelpers.interopDefault(_paginationFooter);
var _zIndex = require("../../Styles/Z-INDEX");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetMaintenanceDisplay);
const pageLimit = 12;
function AssetMaintenanceDisplay(props) {
    const width = (0, _react.useContext)((0, _widthContext.Width));
    const [showMobileFilters, toggleMobileFilters] = (0, _react.useState)(false);
    const filteredData = (0, _react.useMemo)(()=>{
        const parsedInstances = props.assetReminderInstances.reduce((acc, { triggerHistory = [], ...instance })=>{
            triggerHistory.forEach(({ _id, ...history } = {})=>{
                const mapValue = {
                    ...instance,
                    ...history
                };
                switch(true){
                    case !!history.maintenanceLogId && history.maintenanceLogId !== (0, _staticUUIDs.MAINTENANCE_LOG_ID):
                        acc.complete.set(_id, mapValue);
                        break;
                    case !history.due:
                        acc.upcoming.set(_id, mapValue);
                        break;
                    case history.due && !history.maintenanceLogId || history.maintenanceLogId === (0, _staticUUIDs.MAINTENANCE_LOG_ID):
                        acc.due.set(_id, mapValue);
                }
            });
            return acc;
        }, {
            complete: new Map(),
            due: new Map(),
            upcoming: new Map()
        });
        return props.typeFilter.reduce((acc, type)=>{
            if (parsedInstances[type]) acc.push(...Array.from(parsedInstances[type]));
            return acc;
        }, []).filter(([, { reminder: { name: reminderName } = {}, scheduleName = "" }])=>{
            if (!props.reminderNameSearch && !props.scheduleNameSearch) return true;
            const prunedReminderName = reminderName.trim().toLowerCase();
            const prunedScheduleName = scheduleName.trim().toLowerCase();
            switch(true){
                case !!props.reminderNameSearch && !!props.scheduleNameSearch:
                    {
                        const prunedReminderSearch = props.reminderNameSearch.trim().toLowerCase();
                        const prunedScheduleSearch = props.scheduleNameSearch.trim().toLowerCase();
                        return prunedReminderName.includes(prunedReminderSearch) && prunedScheduleName.includes(prunedScheduleSearch);
                    }
                case !!props.reminderNameSearch:
                    {
                        const prunedReminderSearch = props.reminderNameSearch.trim().toLowerCase();
                        return prunedReminderName.includes(prunedReminderSearch);
                    }
                case !!props.scheduleNameSearch:
                    {
                        const prunedScheduleSearch = props.scheduleNameSearch.trim().toLowerCase();
                        return prunedScheduleName.includes(prunedScheduleSearch);
                    }
                default:
                    return false;
            }
        }).sort(([, { createdAt: a }], [, { createdAt: b }])=>{
            const dateA = new Date(a).valueOf();
            const dateB = new Date(b).valueOf();
            switch(true){
                case dateA > dateB:
                    return -1;
                case dateA < dateB:
                    return 1;
                default:
                    return 0;
            }
        });
    }, [
        props.assetReminderInstances,
        props.reminderNameSearch,
        props.scheduleNameSearch,
        props.typeFilter
    ]);
    const upcomingAndDue = filteredData.filter(([, { due, maintenanceLogId } = {}])=>due && !maintenanceLogId || maintenanceLogId === (0, _staticUUIDs.MAINTENANCE_LOG_ID));
    const handleAllRowsChecked = ()=>{
        if (!upcomingAndDue.length) return;
        const allChecked = upcomingAndDue.length && props.checkedInstances.size === upcomingAndDue.length;
        props.handleSelectAllInstances(upcomingAndDue, allChecked);
    };
    const pages = Math.ceil(filteredData.length / pageLimit);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "d-lg-none btn btn-link p-0 shadow-none text-decoration-none position-absolute",
                onClick: ()=>toggleMobileFilters(!showMobileFilters),
                style: {
                    right: "0.5rem",
                    top: "-5.7rem",
                    zIndex: (0, _zIndex.STICKY_OVERRIDE)
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    className: "text-brand-primary",
                    icon: (0, _freeSolidSvgIcons.faSlidersH),
                    size: "lg"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "position-absolute h-100 w-100 bg-white rounded-lg d-flex flex-column p-1 p-lg-3 px-lg-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledAlert), {
                        className: "text-white text-center",
                        color: "danger",
                        children: "This Maintenance feature is deprecated and will be removed in December 2023. Please migrate to using Maintenance Reminders in Asset Model."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-fill d-flex flex-column",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "w-100 d-flex align-items-center my-2 my-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn modal-button-primary three-quarter-text",
                                        onClick: ()=>props.toggleServiceCompleteModal(!props.showServiceCompleteModal),
                                        disabled: props.dataLoading || !props.checkedInstances.size,
                                        children: "Complete Maintenance"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "nine-tenth-text text-icon-link-gray mb-0 mx-2 rounded",
                                        children: [
                                            props.checkedInstances.size,
                                            " selected"
                                        ]
                                    })
                                ]
                            }),
                            upcomingAndDue.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "d-lg-none btn btn-block btn-outline-warning text-warning bg-white py-0 w-75 align-self-center",
                                onClick: handleAllRowsChecked,
                                children: "Select All Reminders"
                            }) : null,
                            props.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "w-100 mb-0 nine-tenth-text text-danger",
                                children: props.error
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-fill mt-2 position-relative",
                                children: (()=>{
                                    switch(true){
                                        case props.dataLoading:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircleDefault.default), {
                                                size: "4x"
                                            });
                                        case !filteredData.length && props.error:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.NoItemsFound), {
                                                text: "There was an error fetching your data. Please contact an administrator if the problem persists."
                                            });
                                        case showEmptyState(filteredData, props):
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.NoItemsFound), {
                                                text: "No reminders for this asset."
                                            });
                                        default:
                                            return width > 991 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "position-absolute h-100 w-100 overflow-auto",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetMaintenanceTableDefault.default), {
                                                    allInstancesChecked: !!filteredData.length && props.checkedInstances.size === filteredData.length,
                                                    assetShadowSignalsMap: props.assetShadowSignalsMap,
                                                    checkedInstances: props.checkedInstances,
                                                    handleAllRowsChecked: handleAllRowsChecked,
                                                    handleInstanceChecked: props.handleInstanceChecked,
                                                    handlePropUpdate: props.handlePropUpdate,
                                                    handleTypeFilterSelect: props.handleTypeFilterSelect,
                                                    reminderNameSearch: props.reminderNameSearch,
                                                    rows: filteredData.slice(pageLimit * props.page, pageLimit * props.page + pageLimit),
                                                    scheduleNameSearch: props.scheduleNameSearch,
                                                    typeFilter: props.typeFilter
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "position-absolute h-100 w-100 overflow-auto",
                                                children: filteredData?.slice?.(pageLimit * props.page, pageLimit * props.page + pageLimit)?.map?.((instance, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "d-lg-none m-2",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileMaintenanceCardDefault.default), {
                                                            assetShadowSignalsMap: props.assetShadowSignalsMap,
                                                            checkedInstances: props.checkedInstances,
                                                            handleMobileCardClick: props.handleInstanceChecked,
                                                            instance: instance
                                                        })
                                                    }, `${instance._id}-${i}`)) ?? null
                                            });
                                    }
                                })()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationFooterDefault.default), {
                        handlePageChange: (selectedPlusOne)=>props.updatePage(selectedPlusOne - 1),
                        page: props.page + 1,
                        pages: pages,
                        rowsLength: props.assetReminderInstances?.length,
                        rowsLoading: props.dataLoading
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serviceTableMobileFiltersDefault.default), {
                        ...props
                    }),
                    props.showServiceCompleteModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serviceCompleteModalContainerDefault.default), {
                        acknowledgementQueue: props.checkedInstances,
                        assetShadowSignalsMap: props.assetShadowSignalsMap,
                        isOpen: props.showServiceCompleteModal,
                        refreshState: props.fetchAssetInstances,
                        selectedCount: props.checkedInstances.size,
                        toggleModal: ()=>props.toggleServiceCompleteModal(!props.showServiceCompleteModal)
                    }) : null,
                    showMobileFilters ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileMaintenanceFiltersDefault.default), {
                        clearFilters: props.clearFilters,
                        handlePropUpdate: props.handlePropUpdate,
                        handleTypeFilterSelect: props.handleTypeFilterSelect,
                        isOpen: showMobileFilters,
                        reminderNameSearch: props.reminderNameSearch,
                        scheduleNameSearch: props.scheduleNameSearch,
                        toggleModal: toggleMobileFilters,
                        typeFilter: props.typeFilter
                    }) : null
                ]
            })
        ]
    });
}
AssetMaintenanceDisplay.propTypes = {
    assetReminderInstances: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string,
        orgId: (0, _propTypesDefault.default).string,
        orgName: (0, _propTypesDefault.default).string,
        scheduleName: (0, _propTypesDefault.default).string,
        gatewayId: (0, _propTypesDefault.default).string,
        gatewayName: (0, _propTypesDefault.default).string,
        reminder: (0, _propTypesDefault.default).shape({
            id: (0, _propTypesDefault.default).string,
            maintenance_schedule_id: (0, _propTypesDefault.default).string,
            name: (0, _propTypesDefault.default).string,
            type: (0, _propTypesDefault.default).string,
            message: (0, _propTypesDefault.default).string,
            recurring: (0, _propTypesDefault.default).bool,
            trigger: (0, _propTypesDefault.default).shape({
                type: (0, _propTypesDefault.default).oneOf([
                    "conditional",
                    "calendar"
                ]),
                value: (0, _propTypesDefault.default).number,
                name: (0, _propTypesDefault.default).string,
                reminderMargin: (0, _propTypesDefault.default).number
            }),
            attachment: (0, _propTypesDefault.default).string
        }),
        enabled: (0, _propTypesDefault.default).bool,
        offset: (0, _propTypesDefault.default).number,
        startDate: (0, _propTypesDefault.default).string,
        endData: (0, _propTypesDefault.default).string,
        lastRun: (0, _propTypesDefault.default).string,
        pending: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
        lastTriggerVal: (0, _propTypesDefault.default).number,
        preacknowledged: (0, _propTypesDefault.default).bool,
        triggerHistory: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            createdAt: (0, _propTypesDefault.default).string,
            // Date Trigger column value
            value: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).number
            ]),
            due: (0, _propTypesDefault.default).bool,
            // true === 'due', false === 'upcoming'
            maintenanceLogId: (0, _propTypesDefault.default).string,
            // when present === 'completed'
            partsCost: (0, _propTypesDefault.default).string,
            // parts revenue column
            serviceDate: (0, _propTypesDefault.default).string // will be present if 'completed'
        }))
    })),
    assetShadowSignalsMap: (0, _propTypesDefault.default).object,
    checkedInstances: (0, _propTypesDefault.default).object,
    clearFilters: (0, _propTypesDefault.default).func,
    dataLoading: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    fetchAssetInstances: (0, _propTypesDefault.default).func,
    handleInstanceChecked: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleSelectAllInstances: (0, _propTypesDefault.default).func,
    handleTypeFilterSelect: (0, _propTypesDefault.default).func,
    page: (0, _propTypesDefault.default).number,
    reminderNameSearch: (0, _propTypesDefault.default).string,
    scheduleNameSearch: (0, _propTypesDefault.default).string,
    showServiceCompleteModal: (0, _propTypesDefault.default).bool,
    toggleServiceCompleteModal: (0, _propTypesDefault.default).func,
    typeFilter: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
        "complete",
        "due",
        "upcoming"
    ])),
    updatePage: (0, _propTypesDefault.default).func
};
AssetMaintenanceDisplay.defaultProps = {
    assetReminderInstances: [],
    checkedInstances: new Map(),
    typeFilter: []
};
function showEmptyState(data, props) {
    return !data.length && !props.dataLoading && !props.error && !props.reminderNameSearch && !props.scheduleNameSearch && props.typeFilter.length > 3;
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/WidthContext":"5c6Dv","../../Constants/StaticUUIDs":"cpjYY","../Maintenance/ServiceTableMobileFilters":"9Whvf","../Maintenance/ServiceCompleteModalContainer":"7JFUI","./AssetMaintenanceTable":"dxgP0","./MobileMaintenanceCard":"gykEB","./MobileMaintenanceFilters":"4O0JN","../LoadingCircle":"aIADA","../NoDataIndication":"clGpp","../PaginationFooter":"kV15Q","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Whvf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _breakpointContext = require("../../Context/BreakpointContext");
const propTypes = {
    filterByAsset: (0, _propTypesDefault.default).string,
    filterByLabel: (0, _propTypesDefault.default).string,
    filterByOrg: (0, _propTypesDefault.default).string,
    filterByReminder: (0, _propTypesDefault.default).string,
    filterByStatus: (0, _propTypesDefault.default).string,
    handleClearFilters: (0, _propTypesDefault.default).func,
    handleDropdownFilter: (0, _propTypesDefault.default).func,
    handleSearchFilter: (0, _propTypesDefault.default).func,
    showMobileFilters: (0, _propTypesDefault.default).bool,
    toggleMobileFilters: (0, _propTypesDefault.default).func
};
const defaultProps = {
    filterByAsset: "",
    filterByLabel: "",
    filterByOrg: "",
    filterByReminder: "",
    filterByStatus: "",
    handleClearFilters: ()=>{},
    handleDropdownFilter: ()=>{},
    handleSearchFilter: ()=>{},
    showMobileFilters: false,
    toggleMobileFilters: ()=>{}
};
const ServiceTableMobileFilters = ({ filterByAsset, filterByLabel, filterByOrg, filterByReminder, filterByStatus, handleClearFilters, handleDropdownFilter, handleSearchFilter, showMobileFilters: isOpen, toggleMobileFilters: toggleModal })=>{
    const { smMobile } = (0, _breakpointContext.useBreakpoint)();
    const statusOptions = [
        {
            display: "Due",
            value: "due"
        },
        {
            display: "Upcoming",
            value: "upcoming"
        },
        {
            display: "All",
            value: ""
        }
    ];
    const statusDisplay = new Map([
        [
            "due",
            "Due"
        ],
        [
            "upcoming",
            "Upcoming"
        ],
        [
            "",
            "All"
        ]
    ]);
    const labelOptions = [
        {
            display: "Inspection",
            value: "Inspection"
        },
        {
            display: "Maintenance",
            value: "Maintenance"
        },
        {
            display: "Parts",
            value: "Parts"
        },
        {
            display: "Sales",
            value: "Sales"
        },
        {
            display: "Service",
            value: "Service"
        },
        {
            display: "Warranty",
            value: "Warranty"
        },
        {
            display: "All",
            value: ""
        }
    ];
    const labelDisplay = new Map([
        [
            "Inspection",
            "Inspection"
        ],
        [
            "Maintenance",
            "Maintenance"
        ],
        [
            "Parts",
            "Parts"
        ],
        [
            "Sales",
            "Sales"
        ],
        [
            "Service",
            "Service"
        ],
        [
            "Warranty",
            "Warranty"
        ],
        [
            "",
            "Label"
        ]
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        toggle: ()=>toggleModal(false),
        className: className,
        contentClassName: `border-0 shadow ${smMobile ? "h-75 overflow-auto" : ""}`,
        backdropClassName: "bg-transparent",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: ()=>toggleModal(false),
                className: "border-bottom-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-weight-normal",
                    children: "Filters"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid pt-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2643519050 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-2643519050 col form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "status",
                                    className: "jsx-2643519050 three-quarter-text text-text-gray",
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-2643519050 dropdown",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            id: "mobileStatusSelectMenuButton",
                                            "data-toggle": "dropdown",
                                            "aria-haspopup": "true",
                                            "aria-expanded": "false",
                                            name: "status",
                                            className: "jsx-2643519050 btn btn-sm btn-outline-third-gray w-100 dropdown-toggle d-flex align-items-center justify-content-between text-text-gray",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "jsx-2643519050 text-capitalize three-quarter-text",
                                                children: statusDisplay.get(filterByStatus)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            "aria-labelledby": "mobileStatusSelectMenuButton",
                                            className: "jsx-2643519050 dropdown-menu w-100 rounded-lg shadow",
                                            children: statusOptions.map(({ display, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>handleDropdownFilter(value, "status"),
                                                    className: "jsx-2643519050 " + `dropdown-item px-3 three-quarter-text ${value === filterByStatus ? "" : "text-text-light-gray"}`,
                                                    children: display
                                                }, `status_${value}`))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2643519050 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-2643519050 col form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "asset",
                                    className: "jsx-2643519050 three-quarter-text text-text-gray",
                                    children: "Asset"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-2643519050 input-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Asset",
                                            value: filterByAsset,
                                            name: "asset",
                                            onChange: handleSearchFilter,
                                            "aria-describedby": "mobileAssetSearchCaret",
                                            className: "jsx-2643519050 form-control form-control-sm three-quarter-text"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-2643519050 input-group-append",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                id: "mobileAssetSearchCaret",
                                                className: "jsx-2643519050 input-group-text bg-white",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    className: "text-text-light-gray",
                                                    icon: (0, _freeSolidSvgIcons.faSearch),
                                                    size: "xs"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2643519050 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-2643519050 col form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "organization",
                                    className: "jsx-2643519050 three-quarter-text text-text-gray",
                                    children: "Org"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-2643519050 input-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Organization",
                                            value: filterByOrg,
                                            name: "organization",
                                            onChange: handleSearchFilter,
                                            "aria-describedby": "mobileAssetSearchCaret",
                                            className: "jsx-2643519050 form-control form-control-sm three-quarter-text"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-2643519050 input-group-append",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                id: "mobileAssetSearchCaret",
                                                className: "jsx-2643519050 input-group-text bg-white",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    className: "text-text-light-gray",
                                                    icon: (0, _freeSolidSvgIcons.faSearch),
                                                    size: "xs"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2643519050 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-2643519050 col form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "reminder",
                                    className: "jsx-2643519050 three-quarter-text text-text-gray",
                                    children: "Reminder"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-2643519050 input-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Reminder",
                                            value: filterByReminder,
                                            name: "reminder",
                                            onChange: handleSearchFilter,
                                            "aria-describedby": "mobileAssetSearchCaret",
                                            className: "jsx-2643519050 form-control form-control-sm three-quarter-text"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-2643519050 input-group-append",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                id: "mobileAssetSearchCaret",
                                                className: "jsx-2643519050 input-group-text bg-white",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    className: "text-text-light-gray",
                                                    icon: (0, _freeSolidSvgIcons.faSearch),
                                                    size: "xs"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2643519050 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-2643519050 col form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "label",
                                    className: "jsx-2643519050 three-quarter-text text-text-gray",
                                    children: "Label"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-2643519050 dropdown",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            id: "mobileStatusSelectMenuButton",
                                            "data-toggle": "dropdown",
                                            "aria-haspopup": "true",
                                            "aria-expanded": "false",
                                            name: "label",
                                            className: "jsx-2643519050 btn btn-sm btn-outline-third-gray w-100 dropdown-toggle d-flex align-items-center justify-content-between text-text-gray",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "jsx-2643519050 text-capitalize three-quarter-text",
                                                children: labelDisplay.get(filterByLabel)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            "aria-labelledby": "mobileStatusSelectMenuButton",
                                            className: "jsx-2643519050 dropdown-menu w-100 rounded-lg shadow",
                                            children: labelOptions.map(({ display, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>handleDropdownFilter(value, "label"),
                                                    className: "jsx-2643519050 " + `dropdown-item px-3 three-quarter-text ${value === filterByLabel ? "" : "text-text-light-gray"}`,
                                                    children: display
                                                }, `label_${value}`))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                        id: "2643519050",
                        children: ".dropdown-toggle.jsx-2643519050::after{margin-left:1.5rem;}.dropdown-item.jsx-2643519050{outline:none;}.dropdown-item.jsx-2643519050:hover{background:transparent;}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "align-items-center justify-content-center border-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-100 p-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-third-gray text-text-gray py-0 w-100",
                        onClick: handleClearFilters,
                        children: "Clear Filters"
                    })
                })
            }),
            styles
        ]
    });
};
ServiceTableMobileFilters.propTypes = propTypes;
ServiceTableMobileFilters.defaultProps = defaultProps;
const { className, styles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1935516619",
        children: ".modal-dialog.jsx-1935516619{margin-top:75px;}"
    }),
    className: "jsx-1935516619"
};
exports.default = /*#__PURE__*/ (0, _react.memo)(ServiceTableMobileFilters); // Exports to ./ServiceDisplay

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","reactstrap":"kjd7g","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/BreakpointContext":"lh42t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lh42t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBreakpoint", ()=>useBreakpoint);
parcelHelpers.export(exports, "BreakpointProvider", ()=>BreakpointProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const defaultValue = {};
const BreakpointContext = /*#__PURE__*/ (0, _react.createContext)(defaultValue);
const queries = {
    smMobile: "(max-width: 319px)",
    mdMobile: "(max-width: 479px)",
    stdMobile: "(max-width: 767px)",
    tablet: "(max-width: 991px)",
    laptop: "(max-width: 1199px)",
    desktop: "(min-width: 1679px)",
    portrait: "(orientation: portrait)",
    landscape: "(orientation: landscape)"
};
const BreakpointProvider = ({ children })=>{
    BreakpointProvider.propTypes = {
        children: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
            (0, _propTypesDefault.default).node
        ]).isRequired
    };
    const [queryMatch, setQueryMatch] = (0, _react.useState)({});
    (0, _react.useEffect)(()=>{
        const mediaQueryLists = {};
        const keys = Object.keys(queries);
        let isAttached = false;
        const handleQueryListener = ()=>{
            const updatedMatches = keys.reduce((acc, media)=>{
                acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
                return acc;
            }, {});
            setQueryMatch(updatedMatches);
        };
        if (window && window.matchMedia) {
            const matches = {};
            keys.forEach((media)=>{
                if (typeof queries[media] === "string") {
                    mediaQueryLists[media] = window.matchMedia(queries[media]);
                    matches[media] = mediaQueryLists[media].matches;
                } else matches[media] = false;
            });
            setQueryMatch(matches);
            isAttached = true;
            keys.forEach((media)=>{
                if (typeof queries[media] === "string") mediaQueryLists[media].addListener(handleQueryListener);
            });
        }
        return ()=>{
            if (isAttached) keys.forEach((media)=>{
                if (typeof queries[media] === "string") mediaQueryLists[media].removeListener(handleQueryListener);
            });
        };
    }, [
        queries
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreakpointContext.Provider, {
        value: queryMatch,
        children: children
    });
};
function useBreakpoint() {
    const context = (0, _react.useContext)(BreakpointContext);
    return context;
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7JFUI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _axios = require("axios");
var _currentUserContext = require("../../Context/CurrentUserContext");
var _currentUserContextDefault = parcelHelpers.interopDefault(_currentUserContext);
var _authService = require("../../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _schedulesService = require("../../Services/SchedulesService");
var _schedulesServiceDefault = parcelHelpers.interopDefault(_schedulesService);
var _serviceCompleteModalDisplay = require("./ServiceCompleteModalDisplay");
var _serviceCompleteModalDisplayDefault = parcelHelpers.interopDefault(_serviceCompleteModalDisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(ServiceCompleteModalContainer);
ServiceCompleteModalContainer.propTypes = {
    acknowledgementQueue: (0, _propTypesDefault.default).object,
    assetShadowSignalsMap: (0, _propTypesDefault.default).object,
    isOpen: (0, _propTypesDefault.default).bool,
    refreshState: (0, _propTypesDefault.default).func,
    selectedCount: (0, _propTypesDefault.default).number,
    toggleModal: (0, _propTypesDefault.default).func
};
ServiceCompleteModalContainer.defaultProps = {
    acknowledgementQueue: new Map(),
    isOpen: false,
    refreshState: ()=>{},
    selectedCount: 0,
    toggleModal: ()=>{}
};
function ServiceCompleteModalContainer(props) {
    const [resetReminder, toggleResetReminder] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)("");
    const [processing, setProcessing] = (0, _react.useState)(false);
    const { _id: currentUserID } = (0, _react.useContext)((0, _currentUserContextDefault.default));
    const now = (0, _momentDefault.default)();
    const authService = new (0, _authServiceDefault.default)();
    const schedulesService = new (0, _schedulesServiceDefault.default)();
    const source = (0, _axios.CancelToken).source();
    const handleCompleteMaintenance = async ()=>{
        setProcessing(true);
        try {
            await handleApiRequests(props.acknowledgementQueue);
            setProcessing("complete");
            await props.refreshState({}, true);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const { message } = err.response?.data ?? err;
            setError(message);
            setProcessing(false);
        }
    };
    const buildUpdateRequest = (instance)=>{
        const { id, reminder: { trigger: { name, type } = {} } = {}, value } = instance;
        const { value: signalValue = 0 } = props.assetShadowSignalsMap.get(name) ?? {};
        const offset = Math.round(signalValue) - Math.round(value);
        const lastRun = new Date().toISOString();
        const data = type === "conditional" ? {
            offset
        } : {
            lastRun
        };
        return schedulesService.editReminderInstance({
            orgID: authService.getUserRootOrgID(),
            instanceId: id,
            data,
            cancelToken: source.token
        });
    };
    const handleApiRequests = (acknowledgementQueue = new Map())=>{
        if (!acknowledgementQueue.size) return Promise.resolve();
        const { completeRequestData, updateReminderRequests } = [
            ...acknowledgementQueue.entries()
        ].reduce((reqs, [triggerID, instance])=>{
            const { name } = instance?.reminder?.trigger ?? {};
            const { value: signalValue } = props.assetShadowSignalsMap.get(name) ?? {};
            const serviceDate = now.clone().utc().format();
            const body = {
                serviceDate,
                signalValue,
                userId: currentUserID,
                reminderTriggerId: triggerID,
                reminderInstanceId: instance.id
            };
            reqs.completeRequestData.push(body);
            if (resetReminder) reqs.updateReminderRequests.push(buildUpdateRequest(instance));
            return reqs;
        }, {
            completeRequestData: [],
            updateReminderRequests: []
        });
        const completeServiceRequest = schedulesService.addMaintenanceLogBulk({
            data: completeRequestData,
            orgID: authService.getUserRootOrgID(),
            cancelToken: source.token
        });
        return Promise.all([
            completeServiceRequest,
            ...updateReminderRequests
        ]);
    };
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serviceCompleteModalDisplayDefault.default), {
        ...props,
        error: error,
        handleCompleteMaintenance: handleCompleteMaintenance,
        now: now,
        processing: processing,
        resetReminder: resetReminder,
        toggleResetReminder: toggleResetReminder
    });
} // Exports to ./ServiceTableDisplay

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","axios":"ffpgq","../../Context/CurrentUserContext":"4sVVe","../../Services/AuthService":"8Bjjn","../../Services/SchedulesService":"3S44n","./ServiceCompleteModalDisplay":"1KCjn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1KCjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _elevatRadioButtons = require("../ElevatRadioButtons");
var _elevatRadioButtonsDefault = parcelHelpers.interopDefault(_elevatRadioButtons);
var _serviceCompleteCard = require("./ServiceCompleteCard");
var _serviceCompleteCardDefault = parcelHelpers.interopDefault(_serviceCompleteCard);
var _breakpointContext = require("../../Context/BreakpointContext");
var _noDataIndication = require("../NoDataIndication");
const propTypes = {
    acknowledgementQueue: (0, _propTypesDefault.default).object,
    assetShadowSignalsMap: (0, _propTypesDefault.default).object,
    error: (0, _propTypesDefault.default).string,
    handleCompleteMaintenance: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    now: (0, _propTypesDefault.default).object,
    processing: (0, _propTypesDefault.default).oneOf([
        true,
        false,
        "complete"
    ]),
    resetReminder: (0, _propTypesDefault.default).bool,
    selectedCount: (0, _propTypesDefault.default).number,
    toggleModal: (0, _propTypesDefault.default).func,
    toggleResetReminder: (0, _propTypesDefault.default).func
};
const defaultProps = {
    acknowledgementQueue: new Map(),
    error: "",
    handleCompleteMaintenance: ()=>{},
    isOpen: false,
    processing: false,
    resetReminder: true,
    selectedCount: 0,
    toggleModal: ()=>{},
    toggleResetReminder: ()=>{}
};
const ServiceCompleteModalDisplay = ({ acknowledgementQueue, assetShadowSignalsMap, error, handleCompleteMaintenance, isOpen, now, processing, resetReminder, selectedCount, toggleModal, toggleResetReminder })=>{
    const radioData = [
        [
            "Stay on Default Schedule",
            false
        ],
        [
            "Reset Reminder(s) from Current Interval",
            true
        ]
    ];
    const radioConfig = {
        handleOnChange: toggleResetReminder,
        initialStatus: resetReminder,
        size: "14",
        orientation: "stacked",
        disabled: !!processing || !acknowledgementQueue.size
    };
    const { smMobile } = (0, _breakpointContext.useBreakpoint)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: isOpen,
        scrollable: true,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: toggleModal,
                className: "border-bottom-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "font-weight-normal",
                    children: [
                        "Review Reminders",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "nine-tenth-text text-icon-link-gray mx-1 rounded",
                            children: [
                                selectedCount,
                                " selected"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "d-flex flex-column text-muted container-fluid py-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `row ${smMobile ? "three-quarter-text" : "nine-tenth-text"}`,
                        style: {
                            minHeight: "75px"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _elevatRadioButtonsDefault.default), {
                                data: radioData,
                                config: radioConfig
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row",
                        style: {
                            minHeight: "40px"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col text-text-light-gray",
                            children: `Reminder${acknowledgementQueue.size > 1 ? "s" : ""}`
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col",
                            children: acknowledgementQueue.size ? [
                                ...acknowledgementQueue
                            ].map(([triggerID, instance])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serviceCompleteCardDefault.default), {
                                    assetShadowSignalsMap: assetShadowSignalsMap,
                                    instance: instance,
                                    now: now,
                                    processing: processing,
                                    resetReminder: resetReminder
                                }, triggerID)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.NoItemsFound), {
                                text: "No reminders selected"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: error ? "row" : "d-none",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col text-danger nine-tenth-text",
                            children: error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn btn-sm btn-outline-secondary three-quarter-text px-4 py-1",
                        onClick: toggleModal,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn modal-button-submit three-quarter-text px-4 py-1 m-0",
                        onClick: handleCompleteMaintenance,
                        disabled: !!processing || !acknowledgementQueue.size,
                        children: "Complete Maintenance"
                    })
                ]
            })
        ]
    });
};
ServiceCompleteModalDisplay.propTypes = propTypes;
ServiceCompleteModalDisplay.defaultProps = defaultProps;
exports.default = /*#__PURE__*/ (0, _react.memo)(ServiceCompleteModalDisplay); // Exports to ./ServiceCompleteModalContainer

},{"react/jsx-runtime":"1dlk8","react":"9njXz","reactstrap":"kjd7g","prop-types":"bnNSm","../ModalLayout":"2RoDj","../ElevatRadioButtons":"ayffo","./ServiceCompleteCard":"jGtY7","../../Context/BreakpointContext":"lh42t","../NoDataIndication":"clGpp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ayffo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const propTypes = {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).array).isRequired,
    config: (0, _propTypesDefault.default).shape({
        disabled: (0, _propTypesDefault.default).bool,
        handleOnChange: (0, _propTypesDefault.default).func,
        initialStatus: (0, _propTypesDefault.default).bool,
        size: (0, _propTypesDefault.default).string,
        orientation: (0, _propTypesDefault.default).oneOf([
            "inline",
            "stacked"
        ])
    })
};
const defaultProps = {
    config: {
        disabled: false,
        initialStatus: false,
        handleOnChange: ()=>{},
        size: "15",
        orientation: "inline"
    }
};
const ElevatRadioButtons = ({ data, config: { handleOnChange, initialStatus, size, orientation, disabled } })=>{
    const radioSize = {
        width: `${size}px`,
        height: `${size}px`
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            data.map(([text, selectedStatus], i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-28396621 " + `form-group ${orientation === "inline" ? "form-check-inline" : ""}`,
                    children: [
                        disabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "radio",
                            name: "inlineRadioOptions",
                            id: `inlineRadio${i}`,
                            style: radioSize,
                            disabled: disabled,
                            className: "jsx-28396621 rounded-circle mx-2"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "radio",
                            name: "inlineRadioOptions",
                            id: `inlineRadio${i}`,
                            checked: initialStatus === selectedStatus,
                            onChange: ()=>handleOnChange(selectedStatus),
                            style: radioSize,
                            disabled: disabled,
                            className: "jsx-28396621 " + `border ${initialStatus === selectedStatus ? "radio-circle border-brand-primary-alert" : "faded-circle border-icon-link-gray"} rounded-circle mx-2`
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: `inlineRadio${i}`,
                            className: "jsx-28396621 " + `form-check-label ${initialStatus === selectedStatus && !disabled ? "" : "text-icon-link-gray"}`,
                            children: text
                        })
                    ]
                }, text)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "28396621",
                children: ".radio-circle.jsx-28396621,.faded-circle.jsx-28396621{-webkit-appearance:none;outline:none;}.radio-circle.jsx-28396621:hover,.faded-circle.jsx-28396621:hover{box-shadow:0 0 5px 0px var(--brand-primary-alert);}.radio-circle.jsx-28396621:before,.faded-circle.jsx-28396621:before{content:'';display:block;width:100%;height:100%;border-radius:50%;}.radio-circle.jsx-28396621:checked.jsx-28396621:before{background:var(--brand-primary-alert);}.faded-circle.jsx-28396621:checked.jsx-28396621:before{background:var(--icon-link-gray);}"
            })
        ]
    });
};
ElevatRadioButtons.propTypes = propTypes;
ElevatRadioButtons.defaultProps = defaultProps;
exports.default = /*#__PURE__*/ (0, _react.memo)(ElevatRadioButtons);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGtY7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _staticUUIDs = require("../../Constants/StaticUUIDs");
exports.default = /*#__PURE__*/ (0, _react.memo)(ServiceCompleteCard);
ServiceCompleteCard.propTypes = {
    assetShadowSignalsMap: (0, _propTypesDefault.default).instanceOf(Map),
    instance: (0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string,
        due: (0, _propTypesDefault.default).bool,
        dueOn: (0, _propTypesDefault.default).string,
        reminder: (0, _propTypesDefault.default).shape({
            name: (0, _propTypesDefault.default).string,
            recurring: (0, _propTypesDefault.default).bool,
            trigger: (0, _propTypesDefault.default).shape({
                frequency: (0, _propTypesDefault.default).string,
                interval: (0, _propTypesDefault.default).number,
                name: (0, _propTypesDefault.default).string,
                type: (0, _propTypesDefault.default).string
            })
        }),
        value: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ])
    }),
    now: (0, _propTypesDefault.default).object,
    processing: (0, _propTypesDefault.default).oneOf([
        true,
        false,
        "complete"
    ]),
    resetReminder: (0, _propTypesDefault.default).bool
};
ServiceCompleteCard.defaultProps = {
    assetShadowSignalsMap: new Map(),
    instance: {
        reminder: {
            name: "",
            trigger: {
                type: ""
            }
        }
    },
    processing: false
};
const frequencyDisplayTextMap = new Map([
    [
        "weekly",
        "week"
    ],
    [
        "monthly",
        "month"
    ],
    [
        "yearly",
        "year"
    ]
]);
function ServiceCompleteCard({ assetShadowSignalsMap, instance, now, processing, resetReminder }) {
    const { assetIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const { reminder: { recurring, trigger: { frequency, interval, name, type, value: triggerValue } = {} } = {}, value } = instance;
    const { value: signalValue = 0 } = assetShadowSignalsMap.get(name) ?? {};
    const roundedValue = Math.round((signalValue + Number.EPSILON) * 100) / 100;
    const overdueDisplayValue = Math.round((signalValue - value + Number.EPSILON) * 100) / 100;
    const upcomingDisplayValue = Math.round((value - signalValue + Number.EPSILON) * 100) / 100;
    const nextServiceValue = (resetReminder ? Math.round(signalValue) : value) + triggerValue;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Card), {
        className: "mb-3 rounded-lg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardBody), {
            className: "container-fluid",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col d-flex align-items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: assetIcon,
                                alt: "assetImage",
                                style: {
                                    height: "25px"
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-fill ml-2 ml-lg-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReminderDetails, {
                                    assetShadowSignalsMap: assetShadowSignalsMap,
                                    instance: instance,
                                    now: now,
                                    overdueDisplayValue: overdueDisplayValue,
                                    roundedValue: roundedValue,
                                    signalValue: signalValue,
                                    upcomingDisplayValue: upcomingDisplayValue
                                })
                            }),
                            (()=>{
                                switch(processing){
                                    case true:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: "text-danger",
                                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                            size: "lg",
                                            spin: true
                                        });
                                    case "complete":
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: "text-alert-confirmation",
                                            icon: (0, _freeSolidSvgIcons.faCheck),
                                            size: "lg"
                                        });
                                    case false:
                                        return null;
                                }
                            })()
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col-12 col-lg-6 d-flex align-items-center",
                            children: recurring ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "nine-tenth-text text-text-light-gray mr-2",
                                        children: `Next Maintenance due ${type === "conditional" ? "at" : "in"}:`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "normal-text text-muted font-weight-bold mr-2",
                                        children: type === "conditional" ? `${nextServiceValue || ""}` : `${interval}`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "nine-tenth-text text-text-light-gray",
                                        children: type === "conditional" ? "hours/cycles" : `${frequencyDisplayTextMap.get(frequency) ?? ""}`
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "nine-tenth-text text-text-light-gray",
                                children: "Non-recurring Reminder. No future maintenance scheduled."
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "col-12 col-lg-6 d-flex align-items-center justify-content-lg-end mt-2 mt-lg-0",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "nine-tenth-text text-text-light-gray mr-2",
                                    children: "Service Complete Date:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "nine-tenth-text text-muted font-weight-bold",
                                    children: now ? now.format("MMMM Do, Y") : ""
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const iconDisplayMap = new Map([
    [
        "upcoming",
        {
            color: "warning-yellow"
        }
    ],
    [
        "due",
        {
            color: "active-dm"
        }
    ],
    [
        "complete",
        {
            color: "alert-confirmation"
        }
    ]
]);
const { className: progressClass, styles: progressStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3405060895",
        children: "div.progress.jsx-3405060895{height:0.5rem;}"
    }),
    className: "jsx-3405060895"
};
function ReminderDetails(props) {
    const { instance: { due, dueOn, maintenanceLogId, reminder: { name: reminderName = "", recurring, trigger: { frequency, interval, type } = {} } = {}, value }, now, overdueDisplayValue, roundedValue, signalValue, upcomingDisplayValue } = props;
    const instanceType = (0, _react.useMemo)(()=>{
        switch(true){
            case !!maintenanceLogId && maintenanceLogId !== (0, _staticUUIDs.MAINTENANCE_LOG_ID):
                return "complete";
            case !due:
                return "upcoming";
            case due && (!maintenanceLogId || maintenanceLogId === (0, _staticUUIDs.MAINTENANCE_LOG_ID)):
                return "due";
        }
    }, []);
    const { color } = iconDisplayMap.get(instanceType) ?? {};
    const dueTime = (0, _momentDefault.default)(dueOn);
    const timeDiff = now.diff(dueTime, "days");
    const timeDiffDisplayText = instanceType === "due" && timeDiff ? "Days Overdue" : "Days Left";
    const recurringDisplayText = recurring ? "Every" : "Once at";
    const frequencyDisplayText = frequencyDisplayTextMap.get(frequency);
    return type === "conditional" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "py-2 px-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-0 three-quarter-text text-dark",
                children: reminderName ?? ""
            }),
            instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: `mt-2 mb-0 text-${color}`,
                children: "Service Completed"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Progress), {
                className: `w-100 my-1 ${progressClass}`,
                color: color,
                value: instanceType === "due" ? 100 : signalValue / value * 100
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: instanceType === "complete" ? "d-none" : "w-100 d-flex justify-content-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: `text-${color} three-quarter-text`,
                        children: instanceType === "due" ? `${overdueDisplayValue} hours overdue` : `${upcomingDisplayValue} hours remaining`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: instanceType === "upcoming" ? "d-none" : `text-${color} three-quarter-text`,
                        children: [
                            roundedValue,
                            " Total Hours"
                        ]
                    })
                ]
            }),
            progressStyles
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "row no-gutters px-2 px-lg-4 py-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "col-8 py-1 pr-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-1 nine-tenth-text text-dark text-truncate",
                        children: reminderName ?? ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-0 three-quarter-text text-text-light-gray",
                        children: `${recurringDisplayText ?? ""} ${interval > 1 ? interval : ""} ${interval > 1 ? `${frequencyDisplayText}s` : frequencyDisplayText}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-4 d-flex flex-column",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `flex-fill p-2 rounded-lg border border-${color} d-flex flex-column align-items-center justify-content-around`,
                    children: instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: `text-${color} three-quarter-text`,
                        children: "Service Complete"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: `mb-0 text-${color}`,
                                children: Math.abs(timeDiff)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "three-quarter-text mb-0 text-text-light-gray text-center text-nowrap",
                                children: timeDiffDisplayText
                            })
                        ]
                    })
                })
            })
        ]
    });
}
ReminderDetails.propTypes = {
    assetShadowSignalsMap: (0, _propTypesDefault.default).object,
    instance: (0, _propTypesDefault.default).object,
    now: (0, _propTypesDefault.default).object,
    overdueDisplayValue: (0, _propTypesDefault.default).number,
    roundedValue: (0, _propTypesDefault.default).number,
    signalValue: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    upcomingDisplayValue: (0, _propTypesDefault.default).number
};
ReminderDetails.defaultProps = {
    assetShadowSignalsMap: new Map(),
    now: (0, _momentDefault.default)()
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/IconsContext":"lzIpe","../../Constants/StaticUUIDs":"cpjYY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dxgP0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactstrap = require("reactstrap");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _schedulesService = require("../../Services/SchedulesService");
var _schedulesServiceDefault = parcelHelpers.interopDefault(_schedulesService);
var _reminderMessagePreviewDisplay = require("../Maintenance/ReminderMessagePreviewDisplay");
var _reminderMessagePreviewDisplayDefault = parcelHelpers.interopDefault(_reminderMessagePreviewDisplay);
var _staticUUIDs = require("../../Constants/StaticUUIDs");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetMaintenanceTable);
const selectOptions = [
    {
        label: "Complete",
        value: "complete"
    },
    {
        label: "Upcoming",
        value: "upcoming"
    },
    {
        label: "Overdue",
        value: "due"
    }
];
const selectStyles = {
    control: (base)=>({
            ...base,
            border: "none",
            boxShadow: "none"
        }),
    indicatorSeparator: (base)=>({
            ...base,
            display: "none"
        }),
    option: (base)=>({
            ...base,
            backgroundColor: "var(--white) !important",
            outline: "none",
            padding: 0
        }),
    placeholder: (base)=>({
            ...base,
            color: "var(--text-light-gray)",
            fontWeight: "normal"
        })
};
const iconDisplayMap = new Map([
    [
        "upcoming",
        {
            icon: (0, _freeSolidSvgIcons.faExclamationTriangle),
            color: "warning-yellow"
        }
    ],
    [
        "due",
        {
            icon: (0, _freeSolidSvgIcons.faStopwatch),
            color: "active-dm"
        }
    ],
    [
        "complete",
        {
            icon: (0, _freeSolidSvgIcons.faCheckCircle),
            color: "alert-confirmation"
        }
    ]
]);
const frequencyDisplayTextMap = new Map([
    [
        "weekly",
        "week"
    ],
    [
        "monthly",
        "month"
    ],
    [
        "yearly",
        "year"
    ]
]);
const initState = {
    error: "",
    partsQuoteRequestPending: "",
    serviceManualRequestPending: ""
};
function AssetMaintenanceTable(props) {
    const source = (0, _axios.CancelToken).source();
    const [state, updateState] = (0, _react.useState)(initState);
    const [messageModalState, updateMessageModalState] = (0, _react.useState)({
        instance: {},
        show: false
    });
    const service = new (0, _schedulesServiceDefault.default)();
    const downloadPartsQuote = async ({ id, orgId: orgID, reminder: { id: reminderId } = {}, scheduleId }, i)=>{
        try {
            updateState({
                ...state,
                partsQuoteRequestPending: `${id}-${i}`
            });
            const { attachment } = await service.getReminderAttachment({
                scheduleId,
                reminderId,
                orgID,
                cancelToken: source.token
            });
            updateState({
                ...state,
                partsQuoteRequestPending: ""
            });
            window.open(attachment, "_blank");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                partsQuoteRequestPending: ""
            });
        }
    };
    const downloadServiceManual = async ({ id, orgId: orgID, scheduleId }, i)=>{
        try {
            updateState({
                ...state,
                serviceManualRequestPending: `${id}-${i}`
            });
            const { serviceManual } = await service.getServiceManual({
                scheduleId,
                orgID,
                cancelToken: source.token
            });
            updateState({
                ...state,
                serviceManualRequestPending: ""
            });
            window.open(serviceManual, "_blank");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                serviceManualRequestPending: ""
            });
        }
    };
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "d-none d-lg-table table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            className: "text-left",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0 align-middle text-center",
                                    style: {
                                        width: "3%"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "form-check",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            checked: props.allInstancesChecked,
                                            className: "form-check-input mt-n2",
                                            onChange: props.handleAllRowsChecked,
                                            type: "checkbox"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0 align-middle px-0",
                                    style: {
                                        width: "10%"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                        closeMenuOnSelect: false,
                                        controlShouldRenderValue: false,
                                        formatOptionLabel: (opt)=>formatOptionLabel(opt, props.typeFilter),
                                        isClearable: false,
                                        isOptionSelected: ()=>false,
                                        isSearchable: false,
                                        onChange: props.handleTypeFilterSelect,
                                        options: selectOptions,
                                        placeholder: "Status",
                                        styles: selectStyles
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0",
                                    style: {
                                        width: "18%"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                className: "form-control border-0 text-text-light-gray",
                                                name: "scheduleNameSearch",
                                                onChange: props.handlePropUpdate,
                                                placeholder: "Schedule",
                                                type: "text",
                                                value: props.scheduleNameSearch
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "input-group-append",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "input-group-text bg-white border-0",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        className: "text-text-light-gray",
                                                        icon: (0, _freeSolidSvgIcons.faSearch),
                                                        size: "sm"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0",
                                    style: {
                                        width: "32%"
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                className: "form-control border-0 text-text-light-gray",
                                                name: "reminderNameSearch",
                                                onChange: props.handlePropUpdate,
                                                placeholder: "Reminder",
                                                type: "text",
                                                value: props.reminderNameSearch
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "input-group-append",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "input-group-text bg-white border-0",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        className: "text-text-light-gray",
                                                        icon: (0, _freeSolidSvgIcons.faSearch),
                                                        size: "sm"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0 align-middle text-text-light-gray font-weight-normal",
                                    style: {
                                        width: "12%"
                                    },
                                    children: "Date Trigger"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0 align-middle text-text-light-gray font-weight-normal",
                                    style: {
                                        width: "12%"
                                    },
                                    children: "Date Service"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0 align-middle text-text-light-gray font-weight-normal px-0 text-nowrap",
                                    style: {
                                        width: "5%"
                                    },
                                    children: "Parts Revenue"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0",
                                    style: {
                                        width: "8%"
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0",
                                    style: {
                                        width: "5%"
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "sticky-top bg-white border-0",
                                    style: {
                                        width: "5%"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: props.rows.map(([key, instance], i)=>{
                            const instanceType = parseInstanceType(instance);
                            const { icon, color } = iconDisplayMap.get(instanceType) || {};
                            const partsQuote = instance?.reminder?.attachment ?? "";
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                className: "h-100 py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-middle text-center",
                                        children: instanceType === "complete" ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "form-check",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                checked: props.checkedInstances.has(key),
                                                className: "form-check-input mt-n2",
                                                onChange: ()=>props.handleInstanceChecked([
                                                        key,
                                                        instance
                                                    ]),
                                                type: "checkbox"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-middle text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: `text-${color}`,
                                            icon: icon,
                                            size: "lg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-middle",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            className: "btn btn-link nine-tenth-text text-left",
                                            to: `/schedule/${instance.scheduleId}`,
                                            children: instance.scheduleName || ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "p-0 h-100 position-relative",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReminderCell, {
                                            ...instance,
                                            assetShadowSignalsMap: props.assetShadowSignalsMap,
                                            color: color,
                                            instanceType: instanceType
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-middle",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-text-light-gray",
                                            children: (0, _momentDefault.default)(instance.createdAt).format("MMMM Do, Y")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-middle",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-text-light-gray",
                                            children: instance.serviceDate ? (0, _momentDefault.default)(instance.serviceDate).format("MMMM Do, Y") : ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-middle",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "mb-0 text-alert-confirmation text-center",
                                            children: instance.partsCost ? `${instance.partsCost}` : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                className: "text-alert-confirmation",
                                                icon: (0, _freeSolidSvgIcons.faMinus),
                                                size: "lg"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "align-middle",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "btn btn-outline-secondary btn-sm rounded-lg three-quarter-text text-nowrap",
                                            onClick: ()=>updateMessageModalState({
                                                    show: true,
                                                    instance
                                                }),
                                            children: "View Message"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                        className: "align-middle",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn btn-link p-0 text-decoration-none shadow-none",
                                                disabled: state.partsQuoteRequestPending || state.serviceManualRequestPending,
                                                id: `instance-quote-${i}`,
                                                onClick: ()=>partsQuote && downloadPartsQuote(instance, i),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    className: partsQuote ? "" : "text-muted",
                                                    icon: state.partsQuoteRequestPending === `${instance.id}-${i}` ? (0, _freeSolidSvgIcons.faCircleNotch) : (0, _freeSolidSvgIcons.faFileAlt),
                                                    size: "lg",
                                                    spin: state.partsQuoteRequestPending === `${instance.id}-${i}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                                innerClassName: "three-quarter-text rounded-pill",
                                                target: `instance-quote-${i}`,
                                                children: partsQuote ? "Download Parts Quote" : "No parts quote"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                        className: "align-middle",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn btn-link p-0 text-decoration-none shadow-none",
                                                disabled: state.partsQuoteRequestPending || state.serviceManualRequestPending,
                                                id: `instance-manual-${i}`,
                                                onClick: ()=>instance.serviceManual && downloadServiceManual(instance, i),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    className: instance.serviceManual ? "" : "text-muted",
                                                    icon: state.serviceManualRequestPending === `${instance.id}-${i}` ? (0, _freeSolidSvgIcons.faCircleNotch) : (0, _freeSolidSvgIcons.faTools),
                                                    size: "lg",
                                                    spin: state.serviceManualRequestPending === `${instance.id}-${i}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.UncontrolledTooltip), {
                                                innerClassName: "three-quarter-text rounded-pill",
                                                target: `instance-manual-${i}`,
                                                children: instance.serviceManual ? "Download Maintenance Manual" : "No Service Manual"
                                            })
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            messageModalState.show ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reminderMessagePreviewDisplayDefault.default), {
                instance: messageModalState.instance,
                isOpen: messageModalState.show,
                message: messageModalState.instance?.reminder?.message,
                toggleModal: ()=>updateMessageModalState({
                        show: false,
                        instance: {}
                    })
            }) : null
        ]
    });
}
AssetMaintenanceTable.propTypes = {
    allInstancesChecked: (0, _propTypesDefault.default).bool,
    assetShadowSignalsMap: (0, _propTypesDefault.default).object,
    checkedInstances: (0, _propTypesDefault.default).object,
    handleAllRowsChecked: (0, _propTypesDefault.default).func,
    handleInstanceChecked: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleTypeFilterSelect: (0, _propTypesDefault.default).func,
    reminderNameSearch: (0, _propTypesDefault.default).string,
    rows: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).array),
    scheduleNameSearch: (0, _propTypesDefault.default).string,
    typeFilter: (0, _propTypesDefault.default).array
};
AssetMaintenanceTable.defaultProps = {
    rows: []
};
function formatOptionLabel({ label, value }, selected) {
    const isSelected = selected.includes(value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "input-group input-group-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input-group-prepend",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "input-group-text bg-white border-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        checked: isSelected,
                        readOnly: true,
                        type: "checkbox"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "form-control border-0 bg-white px-0",
                readOnly: true,
                type: "text",
                value: label
            })
        ]
    });
}
formatOptionLabel.propTypes = {
    label: (0, _propTypesDefault.default).string,
    value: (0, _propTypesDefault.default).string
};
const { className: progressClass, styles: progressStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3405060895",
        children: "div.progress.jsx-3405060895{height:0.5rem;}"
    }),
    className: "jsx-3405060895"
};
function ReminderCell(props) {
    const { assetShadowSignalsMap, color, dueOn, instanceType, reminder: { name: reminderName, recurring, trigger: { frequency, interval, name: signalName, type } = {} } = {}, value } = props;
    const { value: signalValue = 0 } = assetShadowSignalsMap.get(signalName) ?? {};
    const roundedValue = Math.round((signalValue + Number.EPSILON) * 100) / 100;
    const overdueDisplayValue = Math.round((signalValue - value + Number.EPSILON) * 100) / 100;
    const upcomingDisplayValue = Math.round((value - signalValue + Number.EPSILON) * 100) / 100;
    const now = (0, _momentDefault.default)();
    const due = (0, _momentDefault.default)(dueOn);
    const timeDiff = now.diff(due, "days");
    const timeDiffDisplayText = instanceType === "due" && timeDiff ? "Days Overdue" : "Days Left";
    const recurringDisplayText = recurring ? "Every" : "Once at";
    const frequencyDisplayText = frequencyDisplayTextMap.get(frequency);
    return type === "conditional" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "position-absolute h-100 w-100 py-2 px-4 d-flex flex-column justify-content-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "mb-0 three-quarter-text text-dark",
                children: reminderName ?? ""
            }),
            instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: `mt-2 mb-0 text-${color}`,
                children: "Service Completed"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Progress), {
                className: `w-100 my-1 ${progressClass}`,
                color: color,
                value: instanceType === "due" ? 100 : signalValue / value * 100
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: instanceType === "complete" ? "d-none" : "w-100 d-flex justify-content-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: `text-${color} three-quarter-text`,
                        children: instanceType === "due" ? `${overdueDisplayValue} hours overdue` : `${upcomingDisplayValue} hours remaining`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: instanceType === "upcoming" ? "d-none" : `text-${color} three-quarter-text`,
                        children: [
                            roundedValue,
                            " Total Hours"
                        ]
                    })
                ]
            }),
            progressStyles
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "h-100 w-100 position-absolute row no-gutters px-4 py-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "col-8 py-1 pr-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-1 nine-tenth-text text-dark text-truncate",
                        children: reminderName ?? ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-0 three-quarter-text text-text-light-gray",
                        children: `${recurringDisplayText ?? ""} ${interval > 1 ? interval : ""} ${interval > 1 ? `${frequencyDisplayText}s` : frequencyDisplayText}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "col-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `h-100 rounded-lg border border-${color} d-flex flex-column align-items-center justify-content-around`,
                    children: instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: `text-${color} three-quarter-text mb-0 text-center`,
                        children: "Service Complete"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: `mb-0 text-${color}`,
                                children: Math.abs(timeDiff)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "three-quarter-text mb-0 text-text-light-gray text-center text-nowrap",
                                children: timeDiffDisplayText
                            })
                        ]
                    })
                })
            })
        ]
    });
}
ReminderCell.propTypes = {
    assetShadowSignalsMap: (0, _propTypesDefault.default).object,
    color: (0, _propTypesDefault.default).oneOf([
        "active-dm",
        "alert-confirmation",
        "warning-yellow"
    ]),
    dueOn: (0, _propTypesDefault.default).string,
    instanceType: (0, _propTypesDefault.default).oneOf([
        "complete",
        "due",
        "upcoming"
    ]),
    reminder: (0, _propTypesDefault.default).shape({
        name: (0, _propTypesDefault.default).string,
        recurring: (0, _propTypesDefault.default).bool,
        trigger: (0, _propTypesDefault.default).shape({
            frequency: (0, _propTypesDefault.default).oneOf([
                "weekly",
                "monthly",
                "yearly"
            ]),
            interval: (0, _propTypesDefault.default).number,
            name: (0, _propTypesDefault.default).string,
            type: (0, _propTypesDefault.default).string
        })
    }),
    value: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ])
};
//
function parseInstanceType(instance) {
    const { due, maintenanceLogId } = instance;
    switch(true){
        case !!maintenanceLogId && maintenanceLogId !== (0, _staticUUIDs.MAINTENANCE_LOG_ID):
            return "complete";
        case !due:
            return "upcoming";
        case due && (!maintenanceLogId || maintenanceLogId === (0, _staticUUIDs.MAINTENANCE_LOG_ID)):
            return "due";
    }
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-select":"j36cq","react-router-dom":"3uzXR","axios":"ffpgq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","reactstrap":"kjd7g","moment":"1e4qG","../../Services/SchedulesService":"3S44n","../Maintenance/ReminderMessagePreviewDisplay":"i1GZC","../../Constants/StaticUUIDs":"cpjYY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i1GZC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3338366606",
        children: "@media (max-width:767px){.modal-dialog.jsx-3338366606{height:100%;width:100%;max-height:100%;max-width:100%;margin:0;}}"
    }),
    className: "jsx-3338366606"
};
const { className: contentClass, styles: contentStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "335147181",
        children: "@media (max-width:767px){.modal-content.jsx-335147181{height:100%;}}@media (min-width:768px){.modal-content.jsx-335147181{border-radius:1rem;}}@media (min-width:992px){.modal-content.jsx-335147181{max-width:75%;margin:0 auto;}}"
    }),
    className: "jsx-335147181"
};
const { className: modalBodyClass, styles: modalBodyStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "669526919",
        children: ".modal-body.jsx-669526919{padding:0;}"
    }),
    className: "jsx-669526919"
};
exports.default = /*#__PURE__*/ (0, _react.memo)(ReminderMessagePreviewDisplay);
function ReminderMessagePreviewDisplay(props) {
    const { isOpen, toggleModal, instance, message: reminderMessage } = props;
    const message = reminderMessage.replace(/{{.AssetName}}/g, instance.gatewayName).replace(/{{.OrgName}}/g, instance.orgName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        toggle: toggleModal,
        size: "lg",
        centered: true,
        className: modalClass,
        contentClassName: contentClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: modalBodyClass,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-1739644834 btn btn-link position-absolute close-modal-x text-muted",
                        children: "\u2A09"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1739644834 container-fluid message-modal-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1739644834 row title-container col-12",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h5", {
                                    className: "jsx-1739644834 font-weight-bold mb-0",
                                    children: [
                                        instance.reminder.name,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-1739644834 text-icon-link-gray nine-tenth-text font-weight-normal ml-2",
                                            children: instance.gatewayName
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1739644834 row col-12 text-left form-group",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    rows: "6",
                                    style: {
                                        resize: "none"
                                    },
                                    value: message,
                                    name: "message",
                                    readOnly: true,
                                    className: "jsx-1739644834 text-area w-100"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1739644834 row justify-content-end button-conatiner align-items-center align-items-md-end col-12",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-1739644834 col-3 col-md-3 col-lg-2 pl-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: toggleModal,
                                        className: "jsx-1739644834 btn btn-outline-secondary py-0 px-4",
                                        children: "Close"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            modalStyles,
            contentStyles,
            modalBodyStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1739644834",
                children: ".btn.jsx-1739644834{font-size:0.9rem;}.text-area.jsx-1739644834{border:none;outline:none;border-color:RGBA(104,104,104,0.34);}.message-modal-container.jsx-1739644834{display:grid;grid-template-rows:3rem calc(100% - 6rem) 3rem;padding:1rem;height:100%;}@media (min-width:768px){.message-modal-container.jsx-1739644834{padding:2rem;height:20rem;}}"
            })
        ]
    });
}
ReminderMessagePreviewDisplay.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    instance: (0, _propTypesDefault.default).object,
    message: (0, _propTypesDefault.default).string
};
ReminderMessagePreviewDisplay.defaultProps = {
    message: "",
    instance: {
        reminder: {}
    }
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gykEB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MobileMaintenanceCard);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _mobileMaintenanceCardDetails = require("./MobileMaintenanceCardDetails");
var _mobileMaintenanceCardDetailsDefault = parcelHelpers.interopDefault(_mobileMaintenanceCardDetails);
const iconDisplayMap = new Map([
    [
        "upcoming",
        {
            color: "warning-yellow"
        }
    ],
    [
        "due",
        {
            color: "active-dm"
        }
    ],
    [
        "complete",
        {
            color: "alert-confirmation"
        }
    ]
]);
const { className: progressClass, styles: progressStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3405060895",
        children: "div.progress.jsx-3405060895{height:0.5rem;}"
    }),
    className: "jsx-3405060895"
};
function MobileMaintenanceCard({ assetShadowSignalsMap, checkedInstances, handleMobileCardClick, instance: [instanceID, instance] = [] }) {
    const [showCardDetails, toggleCardDetails] = (0, _react.useState)(false);
    const isChecked = checkedInstances.has(instanceID);
    const instanceType = (0, _react.useMemo)(()=>{
        const { due, maintenanceLogId } = instance;
        switch(true){
            case !!maintenanceLogId && maintenanceLogId !== (0, _staticUUIDs.MAINTENANCE_LOG_ID):
                return "complete";
            case !due:
                return "upcoming";
            case due && (!maintenanceLogId || maintenanceLogId === (0, _staticUUIDs.MAINTENANCE_LOG_ID)):
                return "due";
        }
    }, [
        instanceID
    ]);
    const { color } = iconDisplayMap.get(instanceType) || {};
    const { value: signalValue = 0 } = assetShadowSignalsMap.get(instance?.reminder?.trigger?.name) ?? {};
    const now = (0, _momentDefault.default)();
    const due = (0, _momentDefault.default)(instance?.dueOn);
    const timeDiff = now.diff(due, "days");
    const timeDiffDisplayText = instanceType === "due" && timeDiff ? "Days Overdue" : "Days Left";
    const { type } = instance?.reminder?.trigger ?? {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
        className: `rounded-lg p-2 ${isChecked ? "border border-brand-primary-alert" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardBody), {
                className: "p-0 d-flex flex-nowrap align-items-center text-muted",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        onClick: ()=>handleMobileCardClick([
                                instanceID,
                                instance
                            ]),
                        onKeyPress: ()=>handleMobileCardClick([
                                instanceID,
                                instance
                            ]),
                        className: "jsx-1201814412 flex-fill",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1201814412 d-flex align-items-center py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: "text-brand-primary",
                                        icon: checkedInstances.has(instanceID) ? (0, _freeSolidSvgIcons.faCheck) : (0, _freeSolidSvgIcons.faTools),
                                        size: "1x"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-1201814412 font-weight-bolder flex-wrap mb-0 ml-2",
                                        children: instance.reminder?.name ?? ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-1201814412 my-2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1201814412 d-flex flex-column",
                                children: [
                                    type === "conditional" && instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-1201814412 " + `mt-2 mb-0 text-${color}`,
                                        children: "Service Completed"
                                    }) : type === "conditional" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Progress), {
                                        className: `my-2 ${progressClass}`,
                                        color: color,
                                        value: instanceType === "due" ? 100 : signalValue / instance.value * 100
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1201814412 " + `h-100 rounded-lg border border-${color} d-flex flex-column align-items-center justify-content-around`,
                                        children: instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "jsx-1201814412 " + `text-${color} three-quarter-text`,
                                            children: "Service Complete"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "jsx-1201814412 " + `mb-0 text-${color}`,
                                                    children: Math.abs(timeDiff)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "jsx-1201814412 three-quarter-text mb-0 text-text-light-gray text-center text-nowrap",
                                                    children: timeDiffDisplayText
                                                })
                                            ]
                                        })
                                    }),
                                    progressStyles
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1201814412 ml-2 d-flex align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>toggleCardDetails(!showCardDetails),
                            className: "jsx-1201814412 btn btn-link p-0 text-decoration-none shadow-none",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                className: "text-muted",
                                icon: (0, _freeSolidSvgIcons.faChevronRight),
                                size: "lg"
                            })
                        })
                    })
                ]
            }),
            showCardDetails ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileMaintenanceCardDetailsDefault.default), {
                instance: instance,
                instanceType: instanceType,
                isOpen: showCardDetails,
                signalValue: signalValue,
                timeDiff: timeDiff,
                timeDiffDisplayText: timeDiffDisplayText,
                toggleModal: ()=>toggleCardDetails(!showCardDetails)
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3710208751",
                children: "div.jsx-1201814412:active,div.jsx-1201814412:focus{outline:0;border:none;-moz-outline-style:none;}"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "478603274",
                children: ".border-brand-primary-alert{border-width:medium !important;}"
            })
        ]
    });
}
MobileMaintenanceCard.propTypes = {
    assetShadowSignalsMap: (0, _propTypesDefault.default).object,
    checkedInstances: (0, _propTypesDefault.default).object,
    createdAt: (0, _propTypesDefault.default).string,
    handleMobileCardClick: (0, _propTypesDefault.default).func,
    instance: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]))
};
MobileMaintenanceCard.defaultProps = {
    assetShadowSignalsMap: new Map(),
    checkedInstances: new Map(),
    instance: [
        "",
        {}
    ]
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/StaticUUIDs":"cpjYY","./MobileMaintenanceCardDetails":"4kUTf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kUTf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _schedulesService = require("../../Services/SchedulesService");
var _schedulesServiceDefault = parcelHelpers.interopDefault(_schedulesService);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
exports.default = /*#__PURE__*/ (0, _react.memo)(MobileMaintenanceCardDetails);
const iconDisplayMap = new Map([
    [
        "upcoming",
        {
            icon: (0, _freeSolidSvgIcons.faExclamationTriangle),
            color: "warning-yellow"
        }
    ],
    [
        "due",
        {
            icon: (0, _freeSolidSvgIcons.faStopwatch),
            color: "active-dm"
        }
    ],
    [
        "complete",
        {
            icon: (0, _freeSolidSvgIcons.faCheckCircle),
            color: "alert-confirmation"
        }
    ]
]);
const frequencyDisplayTextMap = new Map([
    [
        "weekly",
        "week"
    ],
    [
        "monthly",
        "month"
    ],
    [
        "yearly",
        "year"
    ]
]);
const reminderTypeColorMap = new Map([
    [
        "Inspection",
        "label-3"
    ],
    [
        "Maintenance",
        "highlight-blue"
    ],
    [
        "Parts",
        "label-5"
    ],
    [
        "Sales",
        "cyan-blue"
    ],
    [
        "Service",
        "darker-blue"
    ],
    [
        "Warranty",
        "label-2"
    ]
]);
const { className: progressClass, styles: progressStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3405060895",
        children: "div.progress.jsx-3405060895{height:0.5rem;}"
    }),
    className: "jsx-3405060895"
};
function MobileMaintenanceCardDetails(props) {
    const [partsQuoteRequestPending, togglePartsQuoteRequestPending] = (0, _react.useState)(false);
    const [serviceManualRequestPending, toggleServiceManualRequestPending] = (0, _react.useState)(false);
    const source = (0, _axios.CancelToken).source();
    const service = new (0, _schedulesServiceDefault.default)();
    const partsQuote = props.instance?.reminder?.attachment ?? "";
    const { icon, color } = iconDisplayMap.get(props.instanceType) ?? {};
    const { interval, type } = props.instance?.reminder?.trigger ?? {};
    const overdueDisplayValue = Math.round((props.signalValue - props.instance?.value + Number.EPSILON) * 100) / 100;
    const upcomingDisplayValue = Math.round((props.instance?.value - props.signalValue + Number.EPSILON) * 100) / 100;
    const recurringDisplayText = props.instance?.reminder?.recurring ? "Every" : "Once at";
    const frequencyDisplayText = frequencyDisplayTextMap.get(props.instance?.reminder?.trigger?.frequency) ?? "";
    const downloadPartsQuote = async ()=>{
        try {
            togglePartsQuoteRequestPending(true);
            const { attachment } = await service.getReminderAttachment({
                scheduleId: props.instance?.scheduleId,
                reminderId: props.instance?.reminder?.id,
                orgID: props.instance?.orgId,
                cancelToken: source.token
            });
            togglePartsQuoteRequestPending(false);
            window.open(attachment, "_blank");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            togglePartsQuoteRequestPending(false);
        }
    };
    const downloadServiceManual = async ()=>{
        try {
            toggleServiceManualRequestPending(true);
            const { serviceManual } = await service.getServiceManual({
                scheduleId: props.instance?.scheduleId,
                orgID: props.instance?.orgId,
                cancelToken: source.token
            });
            toggleServiceManualRequestPending(false);
            window.open(serviceManual, "_blank");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            toggleServiceManualRequestPending(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: props.isOpen,
        scrollable: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: ()=>props.toggleModal(!props.isOpen),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "jsx-2881616868 font-weight-normal",
                    children: "Review Details"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "d-flex flex-column text-muted align-items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2881616868 d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: `text-${color}`,
                                        icon: icon,
                                        size: "lg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-2881616868 text-muted font-weight-bolder ml-2 mb-0",
                                        children: props.instance?.reminder?.name
                                    })
                                ]
                            }),
                            type === "conditional" && props.instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 " + `mt-2 mb-0 text-${color}`,
                                children: "Service Completed"
                            }) : type === "conditional" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2881616868 mt-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Progress), {
                                        className: `my-1 ${progressClass}`,
                                        color: color,
                                        style: {
                                            height: "0.5rem"
                                        },
                                        value: props.instanceType === "due" ? 100 : props.signalValue / props.instance?.value * 100
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2881616868 " + ((props.instanceType === "complete" ? "d-none" : "d-block") || ""),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-2881616868 " + `text-${color} three-quarter-text`,
                                            children: props.instanceType === "due" ? `${overdueDisplayValue} hours overdue` : `${upcomingDisplayValue} hours remaining`
                                        })
                                    }),
                                    progressStyles
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-2881616868 mt-2 mb-0 three-quarter-text text-text-light-gray",
                                        children: `${recurringDisplayText ?? ""} ${interval > 1 ? interval : ""} ${interval > 1 ? `${frequencyDisplayText}s` : frequencyDisplayText}`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2881616868 " + `mt-2 rounded-lg border border-${color} d-flex flex-column align-items-center justify-content-around`,
                                        children: props.instanceType === "complete" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "jsx-2881616868 " + `text-${color} three-quarter-text`,
                                            children: "Service Complete"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "jsx-2881616868 " + `mb-0 text-${color}`,
                                                    children: Math.abs(props.timeDiff)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "jsx-2881616868 three-quarter-text mb-0 text-text-light-gray text-center text-nowrap",
                                                    children: props.timeDiffDisplayText
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Schedule"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2881616868 d-flex align-items-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    className: "btn btn-link text-left p-0 font-weight-bolder",
                                    to: `/schedule/${props.instance?.scheduleId}`,
                                    children: props.instance?.scheduleName || ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Date Trigger"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 font-weight-bolder",
                                children: (0, _momentDefault.default)(props.instance?.createdAt).format("MMMM Do, Y")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Date Serviced"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 font-weight-bolder",
                                children: props.instance?.serviceDate ? (0, _momentDefault.default)(props.instance.serviceDate).format("MMMM Do, Y") : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Parts Revenue"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 font-weight-bolder text-alert-confirmation",
                                children: props.instance?.partsCost ? `${props.instance.partsCost}` : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    className: "text-alert-confirmation",
                                    icon: (0, _freeSolidSvgIcons.faMinus),
                                    size: "lg"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Label"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2881616868 " + `badge badge-primary text-capitalize px-2 py-2 nine-tenth-text font-weight-normal bg-${reminderTypeColorMap.get(props.instance?.reminder?.type)}`,
                                children: props.instance?.reminder?.type
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Parts Quote"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2881616868 text-icon-link-gray",
                                children: partsQuote ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            disabled: partsQuoteRequestPending,
                                            onClick: downloadPartsQuote,
                                            className: "jsx-2881616868 btn btn-block modal-button-primary-outline nine-tenth-text text-center py-1 px-4 rounded",
                                            children: "Download Parts Quote"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "jsx-2881616868 three-quarter-text text-truncate text-center mt-1",
                                            children: partsQuote.substring(27, partsQuote.length)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-2881616868",
                                    children: "No Parts Quote"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2881616868 w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-2881616868 text-third-gray font-weight-light three-quarter-text",
                                children: "Service Manual"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2881616868 text-icon-link-gray",
                                children: props.instance?.serviceManual ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            disabled: serviceManualRequestPending,
                                            onClick: downloadServiceManual,
                                            className: "jsx-2881616868 btn btn-block modal-button-primary-outline nine-tenth-text text-center py-1 px-4 rounded",
                                            children: "Download Service Manual"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "jsx-2881616868 three-quarter-text text-truncate text-center mt-1",
                                            children: props.instance?.serviceManual.substring(27, props.instance?.serviceManual.length)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-2881616868",
                                    children: "No Service Manual"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2881616868",
                children: "p.jsx-2881616868{margin:0;}"
            })
        ]
    });
}
MobileMaintenanceCardDetails.propTypes = {
    instance: (0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string,
        createdAt: (0, _propTypesDefault.default).string,
        orgId: (0, _propTypesDefault.default).string,
        orgName: (0, _propTypesDefault.default).string,
        scheduleId: (0, _propTypesDefault.default).string,
        scheduleName: (0, _propTypesDefault.default).string,
        serviceManual: (0, _propTypesDefault.default).string,
        gatewayId: (0, _propTypesDefault.default).string,
        gatewayName: (0, _propTypesDefault.default).string,
        reminder: (0, _propTypesDefault.default).shape({
            id: (0, _propTypesDefault.default).string,
            maintenance_schedule_id: (0, _propTypesDefault.default).string,
            name: (0, _propTypesDefault.default).string,
            type: (0, _propTypesDefault.default).string,
            message: (0, _propTypesDefault.default).string,
            recurring: (0, _propTypesDefault.default).bool,
            trigger: (0, _propTypesDefault.default).shape({
                frequency: (0, _propTypesDefault.default).string,
                name: (0, _propTypesDefault.default).string,
                reminderMargin: (0, _propTypesDefault.default).number,
                type: (0, _propTypesDefault.default).oneOf([
                    "conditional",
                    "calendar"
                ]),
                value: (0, _propTypesDefault.default).number
            }),
            attachment: (0, _propTypesDefault.default).string
        }),
        partsCost: (0, _propTypesDefault.default).string,
        serviceDate: (0, _propTypesDefault.default).string,
        enabled: (0, _propTypesDefault.default).bool,
        offset: (0, _propTypesDefault.default).number,
        startDate: (0, _propTypesDefault.default).string,
        endData: (0, _propTypesDefault.default).string,
        lastRun: (0, _propTypesDefault.default).string,
        pending: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
        lastTriggerVal: (0, _propTypesDefault.default).number,
        preacknowledged: (0, _propTypesDefault.default).bool,
        triggerHistory: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            createdAt: (0, _propTypesDefault.default).string,
            // Date Trigger column value
            value: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).number
            ]),
            due: (0, _propTypesDefault.default).bool,
            // true === 'due', false === 'upcoming'
            maintenanceLogId: (0, _propTypesDefault.default).string,
            // when present === 'completed'
            serviceDate: (0, _propTypesDefault.default).string // will be present if 'completed'
        })),
        value: (0, _propTypesDefault.default).number
    }),
    instanceType: (0, _propTypesDefault.default).oneOf([
        "complete",
        "due",
        "upcoming"
    ]),
    isOpen: (0, _propTypesDefault.default).bool,
    signalValue: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ]),
    timeDiff: (0, _propTypesDefault.default).number,
    timeDiffDisplayText: (0, _propTypesDefault.default).string,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","moment":"1e4qG","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Services/SchedulesService":"3S44n","../ModalLayout":"2RoDj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4O0JN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const { className, styles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1935516619",
        children: ".modal-dialog.jsx-1935516619{margin-top:75px;}"
    }),
    className: "jsx-1935516619"
};
exports.default = /*#__PURE__*/ (0, _react.memo)(MobileMaintenanceFilters);
const selectOptions = [
    {
        label: "Complete",
        value: "complete"
    },
    {
        label: "Upcoming",
        value: "upcoming"
    },
    {
        label: "Overdue",
        value: "due"
    }
];
const selectStyles = {
    control: (base)=>({
            ...base,
            boxShadow: "none"
        }),
    indicatorSeparator: (base)=>({
            ...base,
            display: "none"
        }),
    option: (base)=>({
            ...base,
            backgroundColor: "var(--white) !important",
            outline: "none",
            padding: 0
        }),
    placeholder: (base)=>({
            ...base,
            color: "var(--text-light-gray)",
            fontWeight: "normal"
        })
};
function MobileMaintenanceFilters(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdropClassName: "bg-transparent",
        className: className,
        isOpen: props.isOpen,
        scrollable: true,
        toggle: ()=>props.toggleModal(!props.isOpen),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: ()=>props.toggleModal(!props.isOpen),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "mb-0 font-weight-normal nine-tenth-text",
                    children: "Filters"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "form-group",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                            controlShouldRenderValue: false,
                            formatOptionLabel: (opt)=>formatOptionLabel(opt, props.typeFilter),
                            isClearable: false,
                            isOptionSelected: ()=>false,
                            isSearchable: false,
                            onChange: props.handleTypeFilterSelect,
                            options: selectOptions,
                            placeholder: "Status",
                            styles: selectStyles
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "form-group",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "form-control text-text-light-gray",
                                    name: "scheduleNameSearch",
                                    onChange: props.handlePropUpdate,
                                    placeholder: "Schedule",
                                    type: "text",
                                    value: props.scheduleNameSearch
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "input-group-append",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "input-group-text bg-white",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: "text-text-light-gray",
                                            icon: (0, _freeSolidSvgIcons.faSearch),
                                            size: "sm"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "form-group",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "form-control text-text-light-gray",
                                    name: "reminderNameSearch",
                                    onChange: props.handlePropUpdate,
                                    placeholder: "Reminder",
                                    type: "text",
                                    value: props.reminderNameSearch
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "input-group-append",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "input-group-text bg-white",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: "text-text-light-gray",
                                            icon: (0, _freeSolidSvgIcons.faSearch),
                                            size: "sm"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "align-items-center justify-content-center border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-block btn-outline-third-gray text-text-gray bg-white py-0",
                    onClick: props.clearFilters,
                    children: "Clear Filters"
                })
            }),
            styles
        ]
    });
}
MobileMaintenanceFilters.propTypes = {
    clearFilters: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleTypeFilterSelect: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    reminderNameSearch: (0, _propTypesDefault.default).string,
    scheduleNameSearch: (0, _propTypesDefault.default).string,
    toggleModal: (0, _propTypesDefault.default).func,
    typeFilter: (0, _propTypesDefault.default).array
};
MobileMaintenanceFilters.defaultProps = {};
function formatOptionLabel({ label, value }, selected) {
    const isSelected = selected.includes(value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "input-group input-group-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input-group-prepend",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "input-group-text bg-white border-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        checked: isSelected,
                        readOnly: true,
                        type: "checkbox"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "form-control border-0 bg-white px-0",
                readOnly: true,
                type: "text",
                value: label
            })
        ]
    });
}
formatOptionLabel.propTypes = {
    label: (0, _propTypesDefault.default).string,
    value: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","react-select":"j36cq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kV15Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactPaginate = require("react-paginate");
var _reactPaginateDefault = parcelHelpers.interopDefault(_reactPaginate);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
exports.default = /*#__PURE__*/ (0, _react.memo)(PaginationFooter);
const { className: brandedBackgroundClass, styles: brandedBackgroundStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "377269797",
        children: "a.page-link.jsx-377269797{background-color:var(--brand-primary-alert) !important;color:var(--white) !important;}"
    }),
    className: "jsx-377269797"
};
const { className: brandedTextClass, styles: brandedTextStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3549877515",
        children: "a.jsx-3549877515{color:var(--brand-primary) !important;}"
    }),
    className: "jsx-3549877515"
};
function PaginationFooter(props) {
    const conditionalForcePage = props.pages ? {
        forcePage: props.page - 1
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPaginateDefault.default), {
                ...conditionalForcePage,
                activeClassName: "rounded-lg",
                activeLinkClassName: `${brandedBackgroundClass} rounded-lg`,
                breakClassName: "page-item disabled",
                breakLabel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faEllipsis)
                }),
                breakLinkClassName: `page-link border-0 text-dark shadow-none ${brandedTextClass}`,
                containerClassName: props.rowsLoading || !props.rowsLength ? "d-none" : "pagination pagination-sm justify-content-center mt-2 mb-0 align-items-center",
                disabledClassName: "disabled",
                disableInitialCallback: true,
                marginPagesDisplayed: 1,
                nextClassName: "page-item",
                nextLabel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faChevronRight)
                }),
                nextLinkClassName: `page-link ml-2 rounded-lg ${brandedTextClass} font-weight-bold shadow-none`,
                onPageChange: ({ selected })=>props.handlePageChange(selected + 1),
                pageClassName: "page-item mx-1",
                pageCount: props.pages || 0,
                pageLinkClassName: `${brandedTextClass} page-link border-0 shadow-none`,
                pageRangeDisplayed: 2,
                previousClassName: "page-item",
                previousLabel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faChevronLeft)
                }),
                previousLinkClassName: `page-link mr-2 rounded-lg ${brandedTextClass} font-weight-bold shadow-none`
            }),
            brandedBackgroundStyles,
            brandedTextStyles
        ]
    });
}
PaginationFooter.propTypes = {
    handlePageChange: (0, _propTypesDefault.default).func,
    page: (0, _propTypesDefault.default).number,
    pages: (0, _propTypesDefault.default).number,
    rowsLength: (0, _propTypesDefault.default).number,
    rowsLoading: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-paginate":"N866B","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"N866B":[function(require,module,exports) {
!function(e, a) {
    module.exports = a(require("c3c8cf1c03af2bce"));
}(this, (e)=>(()=>{
        var a = {
            703: (e, a, t)=>{
                "use strict";
                var r = t(414);
                function n() {}
                function i() {}
                i.resetWarningCache = n, e.exports = function() {
                    function e(e, a, t, n, i, s) {
                        if (s !== r) {
                            var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                            throw o.name = "Invariant Violation", o;
                        }
                    }
                    function a() {
                        return e;
                    }
                    e.isRequired = e;
                    var t = {
                        array: e,
                        bigint: e,
                        bool: e,
                        func: e,
                        number: e,
                        object: e,
                        string: e,
                        symbol: e,
                        any: e,
                        arrayOf: a,
                        element: e,
                        elementType: e,
                        instanceOf: a,
                        node: e,
                        objectOf: a,
                        oneOf: a,
                        oneOfType: a,
                        shape: a,
                        exact: a,
                        checkPropTypes: i,
                        resetWarningCache: n
                    };
                    return t.PropTypes = t, t;
                };
            },
            697: (e, a, t)=>{
                e.exports = t(703)();
            },
            414: (e)=>{
                "use strict";
                e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            },
            98: (a)=>{
                "use strict";
                a.exports = e;
            }
        }, t = {};
        function r(e) {
            var n = t[e];
            if (void 0 !== n) return n.exports;
            var i = t[e] = {
                exports: {}
            };
            return a[e](i, i.exports, r), i.exports;
        }
        r.n = (e)=>{
            var a = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(a, {
                a
            }), a;
        }, r.d = (e, a)=>{
            for(var t in a)r.o(a, t) && !r.o(e, t) && Object.defineProperty(e, t, {
                enumerable: !0,
                get: a[t]
            });
        }, r.o = (e, a)=>Object.prototype.hasOwnProperty.call(e, a), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            r.r(n), r.d(n, {
                default: ()=>k
            });
            var e = r(98), a = r.n(e), t = r(697), i = r.n(t);
            function s() {
                return s = Object.assign ? Object.assign.bind() : function(e) {
                    for(var a = 1; a < arguments.length; a++){
                        var t = arguments[a];
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }
                    return e;
                }, s.apply(this, arguments);
            }
            var o = function(e) {
                var t = e.pageClassName, r = e.pageLinkClassName, n = e.page, i = e.selected, o = e.activeClassName, l = e.activeLinkClassName, c = e.getEventListener, p = e.pageSelectedHandler, u = e.href, g = e.extraAriaContext, d = e.pageLabelBuilder, f = e.rel, b = e.ariaLabel || "Page " + n + (g ? " " + g : ""), v = null;
                return i && (v = "page", b = e.ariaLabel || "Page " + n + " is your current page", t = void 0 !== t ? t + " " + o : o, void 0 !== r ? void 0 !== l && (r = r + " " + l) : r = l), a().createElement("li", {
                    className: t
                }, a().createElement("a", s({
                    rel: f,
                    role: u ? void 0 : "button",
                    className: r,
                    href: u,
                    tabIndex: i ? "-1" : "0",
                    "aria-label": b,
                    "aria-current": v,
                    onKeyPress: p
                }, c(p)), d(n)));
            };
            o.propTypes = {
                pageSelectedHandler: i().func.isRequired,
                selected: i().bool.isRequired,
                pageClassName: i().string,
                pageLinkClassName: i().string,
                activeClassName: i().string,
                activeLinkClassName: i().string,
                extraAriaContext: i().string,
                href: i().string,
                ariaLabel: i().string,
                page: i().number.isRequired,
                getEventListener: i().func.isRequired,
                pageLabelBuilder: i().func.isRequired,
                rel: i().string
            };
            const l = o;
            function c() {
                return c = Object.assign ? Object.assign.bind() : function(e) {
                    for(var a = 1; a < arguments.length; a++){
                        var t = arguments[a];
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }
                    return e;
                }, c.apply(this, arguments);
            }
            var p = function(e) {
                var t = e.breakLabel, r = e.breakAriaLabel, n = e.breakClassName, i = e.breakLinkClassName, s = e.breakHandler, o = e.getEventListener, l = n || "break";
                return a().createElement("li", {
                    className: l
                }, a().createElement("a", c({
                    className: i,
                    role: "button",
                    tabIndex: "0",
                    "aria-label": r,
                    onKeyPress: s
                }, o(s)), t));
            };
            p.propTypes = {
                breakLabel: i().oneOfType([
                    i().string,
                    i().node
                ]),
                breakAriaLabel: i().string,
                breakClassName: i().string,
                breakLinkClassName: i().string,
                breakHandler: i().func.isRequired,
                getEventListener: i().func.isRequired
            };
            const u = p;
            function g(e) {
                var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                return null != e ? e : a;
            }
            function d(e) {
                return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, d(e);
            }
            function f() {
                return f = Object.assign ? Object.assign.bind() : function(e) {
                    for(var a = 1; a < arguments.length; a++){
                        var t = arguments[a];
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }
                    return e;
                }, f.apply(this, arguments);
            }
            function b(e, a) {
                for(var t = 0; t < a.length; t++){
                    var r = a[t];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function v(e, a) {
                return v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, a) {
                    return e.__proto__ = a, e;
                }, v(e, a);
            }
            function h(e, a) {
                if (a && ("object" === d(a) || "function" == typeof a)) return a;
                if (void 0 !== a) throw new TypeError("Derived constructors may only return object or undefined");
                return m(e);
            }
            function m(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function y(e) {
                return y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, y(e);
            }
            function C(e, a, t) {
                return a in e ? Object.defineProperty(e, a, {
                    value: t,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[a] = t, e;
            }
            var P = function(e) {
                !function(e, a) {
                    if ("function" != typeof a && null !== a) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(a && a.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), a && v(e, a);
                }(o, e);
                var t, r, n, i, s = (n = o, i = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, a = y(n);
                    if (i) {
                        var t = y(this).constructor;
                        e = Reflect.construct(a, arguments, t);
                    } else e = a.apply(this, arguments);
                    return h(this, e);
                });
                function o(e) {
                    var t, r;
                    return function(e, a) {
                        if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
                    }(this, o), C(m(t = s.call(this, e)), "handlePreviousPage", function(e) {
                        var a = t.state.selected;
                        t.handleClick(e, null, a > 0 ? a - 1 : void 0, {
                            isPrevious: !0
                        });
                    }), C(m(t), "handleNextPage", function(e) {
                        var a = t.state.selected, r = t.props.pageCount;
                        t.handleClick(e, null, a < r - 1 ? a + 1 : void 0, {
                            isNext: !0
                        });
                    }), C(m(t), "handlePageSelected", function(e, a) {
                        if (t.state.selected === e) return t.callActiveCallback(e), void t.handleClick(a, null, void 0, {
                            isActive: !0
                        });
                        t.handleClick(a, null, e);
                    }), C(m(t), "handlePageChange", function(e) {
                        t.state.selected !== e && (t.setState({
                            selected: e
                        }), t.callCallback(e));
                    }), C(m(t), "getEventListener", function(e) {
                        return C({}, t.props.eventListener, e);
                    }), C(m(t), "handleClick", function(e, a, r) {
                        var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = n.isPrevious, s = void 0 !== i && i, o = n.isNext, l = void 0 !== o && o, c = n.isBreak, p = void 0 !== c && c, u = n.isActive, g = void 0 !== u && u;
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var d = t.state.selected, f = t.props.onClick, b = r;
                        if (f) {
                            var v = f({
                                index: a,
                                selected: d,
                                nextSelectedPage: r,
                                event: e,
                                isPrevious: s,
                                isNext: l,
                                isBreak: p,
                                isActive: g
                            });
                            if (!1 === v) return;
                            Number.isInteger(v) && (b = v);
                        }
                        void 0 !== b && t.handlePageChange(b);
                    }), C(m(t), "handleBreakClick", function(e, a) {
                        var r = t.state.selected;
                        t.handleClick(a, e, r < e ? t.getForwardJump() : t.getBackwardJump(), {
                            isBreak: !0
                        });
                    }), C(m(t), "callCallback", function(e) {
                        void 0 !== t.props.onPageChange && "function" == typeof t.props.onPageChange && t.props.onPageChange({
                            selected: e
                        });
                    }), C(m(t), "callActiveCallback", function(e) {
                        void 0 !== t.props.onPageActive && "function" == typeof t.props.onPageActive && t.props.onPageActive({
                            selected: e
                        });
                    }), C(m(t), "getElementPageRel", function(e) {
                        var a = t.state.selected, r = t.props, n = r.nextPageRel, i = r.prevPageRel, s = r.selectedPageRel;
                        return a - 1 === e ? i : a === e ? s : a + 1 === e ? n : void 0;
                    }), C(m(t), "pagination", function() {
                        var e = [], r = t.props, n = r.pageRangeDisplayed, i = r.pageCount, s = r.marginPagesDisplayed, o = r.breakLabel, l = r.breakClassName, c = r.breakLinkClassName, p = r.breakAriaLabels, g = t.state.selected;
                        if (i <= n) for(var d = 0; d < i; d++)e.push(t.getPageElement(d));
                        else {
                            var f = n / 2, b = n - f;
                            g > i - n / 2 ? f = n - (b = i - g) : g < n / 2 && (b = n - (f = g));
                            var v, h, m = function(e) {
                                return t.getPageElement(e);
                            }, y = [];
                            for(v = 0; v < i; v++){
                                var C = v + 1;
                                if (C <= s) y.push({
                                    type: "page",
                                    index: v,
                                    display: m(v)
                                });
                                else if (C > i - s) y.push({
                                    type: "page",
                                    index: v,
                                    display: m(v)
                                });
                                else if (v >= g - f && v <= g + (0 === g && n > 1 ? b - 1 : b)) y.push({
                                    type: "page",
                                    index: v,
                                    display: m(v)
                                });
                                else if (o && y.length > 0 && y[y.length - 1].display !== h && (n > 0 || s > 0)) {
                                    var P = v < g ? p.backward : p.forward;
                                    h = a().createElement(u, {
                                        key: v,
                                        breakAriaLabel: P,
                                        breakLabel: o,
                                        breakClassName: l,
                                        breakLinkClassName: c,
                                        breakHandler: t.handleBreakClick.bind(null, v),
                                        getEventListener: t.getEventListener
                                    }), y.push({
                                        type: "break",
                                        index: v,
                                        display: h
                                    });
                                }
                            }
                            y.forEach(function(a, t) {
                                var r = a;
                                "break" === a.type && y[t - 1] && "page" === y[t - 1].type && y[t + 1] && "page" === y[t + 1].type && y[t + 1].index - y[t - 1].index <= 2 && (r = {
                                    type: "page",
                                    index: a.index,
                                    display: m(a.index)
                                }), e.push(r.display);
                            });
                        }
                        return e;
                    }), void 0 !== e.initialPage && void 0 !== e.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e.initialPage, ") and forcePage (").concat(e.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), r = e.initialPage ? e.initialPage : e.forcePage ? e.forcePage : 0, t.state = {
                        selected: r
                    }, t;
                }
                return t = o, r = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            var e = this.props, a = e.initialPage, t = e.disableInitialCallback, r = e.extraAriaContext, n = e.pageCount, i = e.forcePage;
                            void 0 === a || t || this.callCallback(a), r && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(n) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(n, "). Did you forget a Math.ceil()?")), void 0 !== a && a > n - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(a, " > ").concat(n - 1, ").")), void 0 !== i && i > n - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(i, " > ").concat(n - 1, ")."));
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            void 0 !== this.props.forcePage && this.props.forcePage !== e.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                                selected: this.props.forcePage
                            })), Number.isInteger(e.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
                        }
                    },
                    {
                        key: "getForwardJump",
                        value: function() {
                            var e = this.state.selected, a = this.props, t = a.pageCount, r = e + a.pageRangeDisplayed;
                            return r >= t ? t - 1 : r;
                        }
                    },
                    {
                        key: "getBackwardJump",
                        value: function() {
                            var e = this.state.selected - this.props.pageRangeDisplayed;
                            return e < 0 ? 0 : e;
                        }
                    },
                    {
                        key: "getElementHref",
                        value: function(e) {
                            var a = this.props, t = a.hrefBuilder, r = a.pageCount, n = a.hrefAllControls;
                            if (t) return n || e >= 0 && e < r ? t(e + 1, r, this.state.selected) : void 0;
                        }
                    },
                    {
                        key: "ariaLabelBuilder",
                        value: function(e) {
                            var a = e === this.state.selected;
                            if (this.props.ariaLabelBuilder && e >= 0 && e < this.props.pageCount) {
                                var t = this.props.ariaLabelBuilder(e + 1, a);
                                return this.props.extraAriaContext && !a && (t = t + " " + this.props.extraAriaContext), t;
                            }
                        }
                    },
                    {
                        key: "getPageElement",
                        value: function(e) {
                            var t = this.state.selected, r = this.props, n = r.pageClassName, i = r.pageLinkClassName, s = r.activeClassName, o = r.activeLinkClassName, c = r.extraAriaContext, p = r.pageLabelBuilder;
                            return a().createElement(l, {
                                key: e,
                                pageSelectedHandler: this.handlePageSelected.bind(null, e),
                                selected: t === e,
                                rel: this.getElementPageRel(e),
                                pageClassName: n,
                                pageLinkClassName: i,
                                activeClassName: s,
                                activeLinkClassName: o,
                                extraAriaContext: c,
                                href: this.getElementHref(e),
                                ariaLabel: this.ariaLabelBuilder(e),
                                page: e + 1,
                                pageLabelBuilder: p,
                                getEventListener: this.getEventListener
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this.props.renderOnZeroPageCount;
                            if (0 === this.props.pageCount && void 0 !== e) return e ? e(this.props) : e;
                            var t = this.props, r = t.disabledClassName, n = t.disabledLinkClassName, i = t.pageCount, s = t.className, o = t.containerClassName, l = t.previousLabel, c = t.previousClassName, p = t.previousLinkClassName, u = t.previousAriaLabel, d = t.prevRel, b = t.nextLabel, v = t.nextClassName, h = t.nextLinkClassName, m = t.nextAriaLabel, y = t.nextRel, C = this.state.selected, P = 0 === C, k = C === i - 1, x = "".concat(g(c)).concat(P ? " ".concat(g(r)) : ""), L = "".concat(g(v)).concat(k ? " ".concat(g(r)) : ""), N = "".concat(g(p)).concat(P ? " ".concat(g(n)) : ""), O = "".concat(g(h)).concat(k ? " ".concat(g(n)) : ""), R = P ? "true" : "false", E = k ? "true" : "false";
                            return a().createElement("ul", {
                                className: s || o,
                                role: "navigation",
                                "aria-label": "Pagination"
                            }, a().createElement("li", {
                                className: x
                            }, a().createElement("a", f({
                                className: N,
                                href: this.getElementHref(C - 1),
                                tabIndex: P ? "-1" : "0",
                                role: "button",
                                onKeyPress: this.handlePreviousPage,
                                "aria-disabled": R,
                                "aria-label": u,
                                rel: d
                            }, this.getEventListener(this.handlePreviousPage)), l)), this.pagination(), a().createElement("li", {
                                className: L
                            }, a().createElement("a", f({
                                className: O,
                                href: this.getElementHref(C + 1),
                                tabIndex: k ? "-1" : "0",
                                role: "button",
                                onKeyPress: this.handleNextPage,
                                "aria-disabled": E,
                                "aria-label": m,
                                rel: y
                            }, this.getEventListener(this.handleNextPage)), b)));
                        }
                    }
                ], b(t.prototype, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), o;
            }(e.Component);
            C(P, "propTypes", {
                pageCount: i().number.isRequired,
                pageRangeDisplayed: i().number,
                marginPagesDisplayed: i().number,
                previousLabel: i().node,
                previousAriaLabel: i().string,
                prevPageRel: i().string,
                prevRel: i().string,
                nextLabel: i().node,
                nextAriaLabel: i().string,
                nextPageRel: i().string,
                nextRel: i().string,
                breakLabel: i().oneOfType([
                    i().string,
                    i().node
                ]),
                breakAriaLabels: i().shape({
                    forward: i().string,
                    backward: i().string
                }),
                hrefBuilder: i().func,
                hrefAllControls: i().bool,
                onPageChange: i().func,
                onPageActive: i().func,
                onClick: i().func,
                initialPage: i().number,
                forcePage: i().number,
                disableInitialCallback: i().bool,
                containerClassName: i().string,
                className: i().string,
                pageClassName: i().string,
                pageLinkClassName: i().string,
                pageLabelBuilder: i().func,
                activeClassName: i().string,
                activeLinkClassName: i().string,
                previousClassName: i().string,
                nextClassName: i().string,
                previousLinkClassName: i().string,
                nextLinkClassName: i().string,
                disabledClassName: i().string,
                disabledLinkClassName: i().string,
                breakClassName: i().string,
                breakLinkClassName: i().string,
                extraAriaContext: i().string,
                ariaLabelBuilder: i().func,
                eventListener: i().string,
                renderOnZeroPageCount: i().func,
                selectedPageRel: i().string
            }), C(P, "defaultProps", {
                pageRangeDisplayed: 2,
                marginPagesDisplayed: 3,
                activeClassName: "selected",
                previousLabel: "Previous",
                previousClassName: "previous",
                previousAriaLabel: "Previous page",
                prevPageRel: "prev",
                prevRel: "prev",
                nextLabel: "Next",
                nextClassName: "next",
                nextAriaLabel: "Next page",
                nextPageRel: "next",
                nextRel: "next",
                breakLabel: "...",
                breakAriaLabels: {
                    forward: "Jump forward",
                    backward: "Jump backward"
                },
                disabledClassName: "disabled",
                disableInitialCallback: !1,
                pageLabelBuilder: function(e) {
                    return e;
                },
                eventListener: "onClick",
                renderOnZeroPageCount: void 0,
                selectedPageRel: "canonical",
                hrefAllControls: !1
            });
            const k = P;
        })(), n;
    })());

},{"c3c8cf1c03af2bce":"9njXz"}],"6wYv9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetAlarmsContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _assetAlarmsTabDisplay = require("./AssetAlarmsTabDisplay");
var _assetAlarmsTabDisplayDefault = parcelHelpers.interopDefault(_assetAlarmsTabDisplay);
var _alertAndDmRequestHelper = require("../../Lib/AlertAndDmRequestHelper");
var _alertAndDmRequestHelperDefault = parcelHelpers.interopDefault(_alertAndDmRequestHelper);
const SORT_DIRECTIONS = [
    "ASC",
    "DESC"
];
const limit = 20;
const initState = {
    alertToClear: {},
    dataLoading: true,
    clearRequestPending: false,
    selectedStatus: "positive",
    ruleIdFilter: null,
    sort: "DetectedAt",
    severityFilter: "critical",
    order: "DESC",
    page: 1,
    dataCount: 0,
    data: [],
    error: ""
};
const refreshState = {
    dataLoading: true,
    page: 1,
    dataCount: 0,
    data: []
};
function AssetAlarmsContainer(props) {
    const { asset: { _id: assetID, orgID }, updateActiveAlertCount } = props;
    const [state, updateState] = (0, _react.useState)(initState);
    const [error, setError] = (0, _react.useState)("");
    const [showMobileFilters, toggleMobileFilters] = (0, _react.useState)(false);
    const [showClearAlertModal, toggleClearAlertModal] = (0, _react.useState)(false);
    const ASSET_NOT_FOUND_ERROR = "Failed to get template";
    const assetService = new (0, _assetServiceDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    let source = (0, _axios.CancelToken).source();
    const handleRuleLinkClick = async (assetID, ruleID)=>{
        try {
            updateState({
                ...state,
                dataLoading: true
            });
            const { _id } = await assetService.fetchModelByAssetId(assetID, source.token);
            history.push({
                pathname: `/asset-model/${_id}`,
                search: `?tab=editRule&RuleId=${ruleID}`
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            let { message } = err.response?.data ?? err;
            if (message === ASSET_NOT_FOUND_ERROR) message = "This rule was created on an asset that was either moved or no longer exists.";
            setError(message);
            updateState({
                ...state,
                dataLoading: false
            });
        }
    };
    const handleRuleSelected = (selected, mobileView)=>{
        const { value: ruleIdFilter } = selected || {};
        updateState({
            ...state,
            ...refreshState,
            ruleIdFilter
        });
        mobileView && toggleMobileFilters(false);
    };
    const handleSortClick = (nextSortBy)=>{
        const { sort } = state;
        switch(true){
            case nextSortBy === sort:
                {
                    const [order] = SORT_DIRECTIONS.filter((d)=>d !== state.order);
                    updateAlertsState({
                        page: 1,
                        order
                    });
                    break;
                }
            default:
                updateAlertsState({
                    page: 1,
                    sort: nextSortBy,
                    order: "DESC"
                });
        }
    };
    const setSelectedStatus = (selectedStatus, mobileView)=>{
        if (selectedStatus === state.selectedStatus) return;
        updateState({
            ...state,
            ...refreshState,
            selectedStatus
        });
        mobileView && toggleMobileFilters(false);
    };
    const setPage = (page)=>{
        if (page === state.page) return;
        updateAlertsState({
            page
        });
    };
    const fetchAlertMetrics = async ()=>{
        try {
            const request = new (0, _alertAndDmRequestHelperDefault.default)({
                ...state,
                orgID,
                typeFilter: "rule",
                gatewayIdFilter: assetID
            });
            const { Count } = await request.fetchAlertMetrics(source.token);
            return Count || 0;
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) setError(err.response?.data?.message ?? err.message);
            return 0;
        }
    };
    const fetchAlerts = async ({ page, sort, order } = {})=>{
        try {
            const request = new (0, _alertAndDmRequestHelperDefault.default)({
                ...state,
                orgID,
                typeFilter: "rule",
                severityFilter: "critical",
                gatewayIdFilter: assetID,
                page: page || state.page,
                sort: sort || state.sort,
                order: order || state.order,
                limit
            });
            const Alerts = await request.fetchAlerts(source.token);
            return Alerts || [];
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
        }
    };
    const toggleClearAlertModalClick = (alert)=>{
        updateState({
            ...state,
            alertToClear: alert || {}
        });
        setError("");
        toggleClearAlertModal(!showClearAlertModal);
    };
    const handleClearAlertClick = async ()=>{
        updateState({
            ...state,
            clearRequestPending: true
        });
        try {
            const request = new (0, _alertAndDmRequestHelperDefault.default)({
                alertID: state.alertToClear.Id,
                orgID: state.alertToClear.OrgId
            });
            await request.clearAlert(source.token);
            updateCountAndAlertsState();
            toggleClearAlertModal(!showClearAlertModal);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
        }
    };
    const updateCountAndAlertsState = async ()=>{
        try {
            const [dataCount, data] = await Promise.all([
                fetchAlertMetrics(),
                fetchAlerts()
            ]);
            updateState({
                ...state,
                dataCount,
                data,
                dataLoading: false,
                alertToClear: {},
                clearRequestPending: false
            });
            updateActiveAlertCount(dataCount);
        } catch (err) {
            setError(err.message);
            updateState({
                ...state,
                dataLoading: false
            });
        }
    };
    const updateAlertsState = async (params)=>{
        try {
            const data = await fetchAlerts(params);
            updateState({
                ...state,
                data,
                ...params,
                dataLoading: false
            });
        } catch (err) {
            setError(err.message);
            updateState({
                ...state,
                dataLoading: false
            });
        }
    };
    (0, _react.useEffect)(()=>{
        if (!assetID) return;
        source = (0, _axios.CancelToken).source();
        updateCountAndAlertsState();
        return source.cancel;
    }, [
        assetID,
        state.selectedStatus,
        state.ruleIdFilter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetAlarmsTabDisplayDefault.default), {
        ...state,
        ...props,
        tab: "alerts",
        handleStatusSelected: setSelectedStatus,
        handleRuleSelected: handleRuleSelected,
        handleRuleLinkClick: handleRuleLinkClick,
        handleClearAlertClick: handleClearAlertClick,
        toggleClearAlertModalClick: toggleClearAlertModalClick,
        showClearAlertModal: showClearAlertModal,
        clearRequestPending: state.clearRequestPending,
        sort: {
            by: state.sort,
            direction: state.order
        },
        handleSortClick: handleSortClick,
        dataLoading: state.dataLoading,
        pages: Math.ceil(state.dataCount / limit),
        handlePageChange: setPage,
        error: error,
        setError: setError,
        showMobileFilters: showMobileFilters,
        toggleMobileFilters: toggleMobileFilters
    });
}
AssetAlarmsContainer.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    currentUser: (0, _propTypesDefault.default).object,
    currentOrg: (0, _propTypesDefault.default).object,
    orgsMap: (0, _propTypesDefault.default).object,
    updateActiveAlertCount: (0, _propTypesDefault.default).func,
    width: (0, _propTypesDefault.default).number
};
AssetAlarmsContainer.defaultProps = {
    currentUser: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","../../Services/AssetService":"fL096","./AssetAlarmsTabDisplay":"lPWzq","../../Lib/AlertAndDmRequestHelper":"kBVH9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lPWzq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetAlarmsTabDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _paginationFooter = require("../PaginationFooter");
var _paginationFooterDefault = parcelHelpers.interopDefault(_paginationFooter);
var _activeAlertsBanner = require("../Events/ActiveAlertsBanner");
var _activeAlertsBannerDefault = parcelHelpers.interopDefault(_activeAlertsBanner);
var _alertAndDmTable = require("../Events/AlertAndDmTable");
var _alertAndDmTableDefault = parcelHelpers.interopDefault(_alertAndDmTable);
var _alertCard = require("../Events/AlertCard");
var _alertCardDefault = parcelHelpers.interopDefault(_alertCard);
var _mobileFiltersModal = require("../Events/MobileFiltersModal");
var _mobileFiltersModalDefault = parcelHelpers.interopDefault(_mobileFiltersModal);
var _clearAlertModal = require("../Events/ClearAlertModal");
var _clearAlertModalDefault = parcelHelpers.interopDefault(_clearAlertModal);
var _asset = require("../../Constants/Asset");
var _zIndex = require("../../Styles/Z-INDEX");
function AssetAlarmsTabDisplay(props) {
    const { asset, tab, data, dataLoading, page, pages, handlePageChange, toggleMobileFilters, showMobileFilters, handleClearAlertClick, toggleClearAlertModalClick, handleRuleLinkClick, showClearAlertModal, clearRequestPending, error } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "d-lg-none btn btn-link p-0 position-absolute shadow-none text-decoration-none ",
                onClick: ()=>toggleMobileFilters(!showMobileFilters),
                style: {
                    right: "0.5rem",
                    top: "-5.7rem",
                    zIndex: (0, _zIndex.STICKY_OVERRIDE)
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    className: "text-brand-primary",
                    icon: (0, _freeSolidSvgIcons.faSlidersH),
                    size: "lg"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2758553004 position-absolute container-fluid h-100 outer-alarms-component-wrapper rounded-lg pt-3 pt-lg-0 d-flex flex-column",
                children: [
                    asset.orgID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activeAlertsBannerDefault.default), {
                        ...props,
                        assetView: true,
                        orgID: asset.orgID,
                        gatewayIdFilter: asset._id
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2758553004 d-none d-lg-flex row flex-fill",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertAndDmTableDefault.default), {
                            ...props,
                            assetView: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2758553004 d-lg-none row flex-fill position-relative",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-2758553004 position-absolute h-100 w-100 overflow-auto",
                            children: data.map((a)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertCardDefault.default), {
                                    alert: a,
                                    assetView: true,
                                    handleRuleLinkClick: handleRuleLinkClick,
                                    tab: tab,
                                    toggleClearAlertModalClick: toggleClearAlertModalClick
                                }, a.Id))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2758553004 row justify-content-end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-2758553004 col-12 text-danger three-quarter-text text-right",
                            children: error
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2758553004 py-1 py-lg-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationFooterDefault.default), {
                            handlePageChange: handlePageChange,
                            page: page,
                            pages: pages,
                            rowsLength: data?.length,
                            rowsLoading: dataLoading
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileFiltersModalDefault.default), {
                        isOpen: showMobileFilters,
                        toggleModal: toggleMobileFilters,
                        assetView: true,
                        ...props
                    }),
                    showClearAlertModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearAlertModalDefault.default), {
                        isOpen: showClearAlertModal,
                        handleClearAlertClick: handleClearAlertClick,
                        toggleModal: toggleClearAlertModalClick,
                        clearRequestPending: clearRequestPending
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                        id: "2758553004",
                        children: "@media (min-width:992px){.outer-alarms-component-wrapper.jsx-2758553004{background-color:white;}.table-container.jsx-2758553004{overflow-y:scroll;}}"
                    })
                ]
            })
        ]
    });
}
AssetAlarmsTabDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    tab: (0, _propTypesDefault.default).oneOf([
        (0, _asset.ALERTS)
    ]),
    selectedStatus: (0, _propTypesDefault.default).oneOf([
        "positive",
        "negative",
        "all"
    ]),
    handleStatusSelected: (0, _propTypesDefault.default).func,
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "TriggeredAt",
            "DetectedAt"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "ASC",
            "DESC"
        ])
    }),
    handleSortClick: (0, _propTypesDefault.default).func,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    dataLoading: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    setError: (0, _propTypesDefault.default).func,
    page: (0, _propTypesDefault.default).number,
    pages: (0, _propTypesDefault.default).number,
    handlePageChange: (0, _propTypesDefault.default).func,
    handleRuleLinkClick: (0, _propTypesDefault.default).func,
    handleRuleSelected: (0, _propTypesDefault.default).func,
    toggleMobileFilters: (0, _propTypesDefault.default).func,
    showMobileFilters: (0, _propTypesDefault.default).bool,
    handleClearAlertClick: (0, _propTypesDefault.default).func,
    toggleClearAlertModalClick: (0, _propTypesDefault.default).func,
    showClearAlertModal: (0, _propTypesDefault.default).bool,
    clearRequestPending: (0, _propTypesDefault.default).bool
};
AssetAlarmsTabDisplay.defaultProps = {
    asset: {},
    data: []
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../PaginationFooter":"kV15Q","../Events/ActiveAlertsBanner":"bcX8h","../Events/AlertAndDmTable":"kzvBX","../Events/AlertCard":"2U5oi","../Events/MobileFiltersModal":"eFZ4N","../Events/ClearAlertModal":"ico1g","../../Constants/Asset":"1OiRg","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bcX8h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _flatten = require("lodash/flatten");
var _flattenDefault = parcelHelpers.interopDefault(_flatten);
var _exportToCsv = require("export-to-csv");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _trackerClasses = require("../../Constants/TrackerClasses");
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _alertAndDmRequestHelper = require("../../Lib/AlertAndDmRequestHelper");
var _alertAndDmRequestHelperDefault = parcelHelpers.interopDefault(_alertAndDmRequestHelper);
var _alertUtils = require("../../Lib/AlertUtils");
var _alertUtilsDefault = parcelHelpers.interopDefault(_alertUtils);
var _dm1Utils = require("../../Lib/Dm1Utils");
var _dm1UtilsDefault = parcelHelpers.interopDefault(_dm1Utils);
var _alertService = require("../../Services/AlertService");
var _alertServiceDefault = parcelHelpers.interopDefault(_alertService);
var _dm1Service = require("../../Services/DM1Service");
var _dm1ServiceDefault = parcelHelpers.interopDefault(_dm1Service);
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
const LIMIT = 100;
function ActiveAlertsBanner(props) {
    const { assetView, clearRequestPending, gatewayIdFilter, includeChildren, orgIdFilter, setError, tab } = props;
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default)), orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const alertService = (0, _react.useMemo)(()=>new (0, _alertServiceDefault.default)(), []), alertUtils = (0, _react.useMemo)(()=>new (0, _alertUtilsDefault.default)(), []), assetService = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []), dm1Service = (0, _react.useMemo)(()=>new (0, _dm1ServiceDefault.default)(), []), dm1Utils = (0, _react.useMemo)(()=>new (0, _dm1UtilsDefault.default)(), []), orgID = (0, _react.useMemo)(()=>orgIdFilter || currentOrg?._id, [
        currentOrg?._id,
        orgIdFilter
    ]), service = (0, _react.useMemo)(()=>tab === "alerts" ? alertService : dm1Service, [
        alertService,
        dm1Service,
        tab
    ]), source = (0, _react.useMemo)(()=>(0, _axios.CancelToken).source(), []), utils = (0, _react.useMemo)(()=>tab === "alerts" ? alertUtils : dm1Utils, [
        alertUtils,
        dm1Utils,
        tab
    ]);
    const [activeAlerts, setActiveAlerts] = (0, _react.useState)(0), [activeAssets, setActiveAssets] = (0, _react.useState)(0), [csvExportPending, updateCsvExportPending] = (0, _react.useState)(false), [totalAssets, setTotalAssets] = (0, _react.useState)(0);
    const fetchActiveAlerts = (0, _react.useCallback)(async ()=>{
        try {
            const conditionalFilter = gatewayIdFilter ? {
                gatewayIdFilter
            } : {};
            const { ActiveAssets, Count } = await service[tab === "alerts" ? "fetchAlertByRuleMetrics" : "getDM1FaultsCount"]({
                activeAssets: true,
                children: includeChildren,
                orgID,
                orgIdFilter: orgID,
                severityFilter: "critical",
                transitionFilter: "positive",
                ...conditionalFilter
            }, source.token);
            setActiveAlerts(Count || 0);
            setActiveAssets(ActiveAssets || 0);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
        }
    }, [
        gatewayIdFilter,
        includeChildren,
        orgID,
        service,
        setError,
        source.token,
        tab
    ]);
    const fetchAssetCountForOrg = (0, _react.useCallback)(async ()=>{
        try {
            const { count } = await assetService.searchAssets({
                children: includeChildren,
                limit: 0,
                orgID
            }, source.token);
            setTotalAssets(count || 0);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
        }
    }, [
        assetService,
        includeChildren,
        orgID,
        setError,
        source.token
    ]);
    const fetchCsvData = async ()=>{
        try {
            const request = new (0, _alertAndDmRequestHelperDefault.default)({
                ...props,
                sort: props.sort.by,
                order: props.sort.direction,
                orgID,
                orgIdFilter: orgID,
                typeFilter: tab === "alerts" ? "rule" : null
            });
            const { Count } = await request[`fetch${tab === "alerts" ? "Alert" : "DM1"}Metrics`](source.token);
            if (Count) {
                const requestCount = Math.ceil(Count / LIMIT);
                const alertRequests = Array(requestCount).fill(0).map((r, index)=>{
                    return new (0, _alertAndDmRequestHelperDefault.default)({
                        ...props,
                        sort: props.sort.by,
                        order: props.sort.direction,
                        orgID,
                        orgIdFilter: orgID,
                        typeFilter: tab === "alerts" ? "rule" : null,
                        limit: LIMIT,
                        page: index + 1
                    })[`fetch${tab === "alerts" ? "Alerts" : "DM1s"}`](source.token);
                });
                const responses = await Promise.all(alertRequests);
                return responses.reduce((data, r)=>{
                    data.push(...r);
                    return data;
                }, []);
            }
            return [];
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) setError(err.response?.data?.message ?? err.message);
            return [];
        }
    };
    const exportCsv = async ()=>{
        updateCsvExportPending(true);
        const rawData = await fetchCsvData();
        if (!rawData.length) return updateCsvExportPending(false);
        const utilsMethod = `format${tab === "alerts" ? "Alert" : "Dm1"}ForCsv`;
        const data = (0, _flattenDefault.default)(rawData.map((d)=>utils[utilsMethod](d, orgsMap)));
        const fileName = utils.generateCsvFilename();
        const csvExporter = new (0, _exportToCsv.ExportToCsv)({
            filename: fileName,
            title: fileName,
            useKeysAsHeaders: true
        });
        csvExporter.generateCsv(data);
        updateCsvExportPending(false);
    };
    (0, _react.useEffect)(()=>{
        if (clearRequestPending === true) return;
        fetchActiveAlerts();
    }, [
        clearRequestPending,
        fetchActiveAlerts
    ]);
    (0, _react.useEffect)(()=>{
        if (!orgID) return;
        fetchAssetCountForOrg();
    }, [
        fetchAssetCountForOrg,
        orgID
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            height: "4rem"
        },
        className: "jsx-2101084129 d-flex justify-content-around justify-content-lg-start align-items-center ml-lg-3 row bg-white rounded mb-3 mb-lg-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2101084129 d-flex flex-column text-center text-lg-left",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-2101084129 text-danger large-text",
                        children: activeAlerts
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-2101084129 text-muted three-quarter-text",
                        children: tab === "alerts" ? "Active Alerts" : "Active DM1 Faults"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2101084129 " + ((assetView ? "d-none" : "d-flex flex-column text-center text-lg-left ml-lg-5") || ""),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2101084129",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-2101084129 text-danger large-text",
                                children: activeAssets
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-2101084129 text-icon-link-gray three-quarter-text ml-2",
                                children: `/ ${totalAssets}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-2101084129 text-muted three-quarter-text",
                        children: "Assets affected"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2101084129 d-none d-lg-flex align-items-center ml-lg-5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    disabled: csvExportPending,
                    onClick: exportCsv,
                    className: "jsx-2101084129 " + `btn btn-sm modal-button-primary nine-tenth-text ${0, _trackerClasses.EXPORT_DM1_CSV_DATA}`,
                    children: csvExportPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCircleNotch),
                        spin: true
                    }) : "Export Data"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2101084129",
                children: ".large-text.jsx-2101084129{font-size:1.25rem;}"
            })
        ]
    });
}
ActiveAlertsBanner.propTypes = {
    assetView: (0, _propTypesDefault.default).bool,
    clearRequestPending: (0, _propTypesDefault.default).bool,
    dmExport: (0, _propTypesDefault.default).shape({
        isLoaded: (0, _propTypesDefault.default).bool,
        data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        fileName: (0, _propTypesDefault.default).string
    }),
    fmiFilter: (0, _propTypesDefault.default).number,
    gatewayIdFilter: (0, _propTypesDefault.default).string,
    includeChildren: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    orgIdFilter: (0, _propTypesDefault.default).string,
    ruleIdFilter: (0, _propTypesDefault.default).string,
    saFIlter: (0, _propTypesDefault.default).number,
    setError: (0, _propTypesDefault.default).func,
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "TriggeredAt",
            "DetectedAt"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "ASC",
            "DESC"
        ])
    }),
    spnFilter: (0, _propTypesDefault.default).number,
    tab: (0, _propTypesDefault.default).oneOf([
        "alerts",
        "dm1"
    ])
};
exports.default = /*#__PURE__*/ (0, _react.memo)(ActiveAlertsBanner);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","lodash/flatten":"cPyWt","export-to-csv":"8Z1Xa","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/TrackerClasses":"1AdWb","../../Context/CurrentOrgContext":"jQXcJ","../../Context/OrgsMapContext":"asozp","../../Lib/AlertAndDmRequestHelper":"kBVH9","../../Lib/AlertUtils":"fHOhn","../../Lib/Dm1Utils":"g5LoU","../../Services/AlertService":"i23f0","../../Services/DM1Service":"72XwI","../../Services/AssetService":"fL096","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cPyWt":[function(require,module,exports) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"iu9J0"}],"iu9J0":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"8JuEE","ec5f080ebf5764e8":"6OjlR"}],"6OjlR":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"crlKT","ee6f325d7f5309b1":"bpegN","ff8d93236e335297":"1DVeR"}],"8Z1Xa":[function(require,module,exports) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("5b4d10aadf71fcad"), exports); //# sourceMappingURL=index.js.map

},{"5b4d10aadf71fcad":"b7sFM"}],"b7sFM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ExportToCsv = exports.ConfigDefaults = exports.CsvConfigConsts = void 0;
var CsvConfigConsts = /** @class */ function() {
    function CsvConfigConsts() {}
    CsvConfigConsts.EOL = "\r\n";
    CsvConfigConsts.BOM = "\uFEFF";
    CsvConfigConsts.DEFAULT_FIELD_SEPARATOR = ",";
    CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR = ".";
    CsvConfigConsts.DEFAULT_QUOTE = '"';
    CsvConfigConsts.DEFAULT_SHOW_TITLE = false;
    CsvConfigConsts.DEFAULT_TITLE = "My Generated Report";
    CsvConfigConsts.DEFAULT_FILENAME = "generated";
    CsvConfigConsts.DEFAULT_SHOW_LABELS = false;
    CsvConfigConsts.DEFAULT_USE_TEXT_FILE = false;
    CsvConfigConsts.DEFAULT_USE_BOM = true;
    CsvConfigConsts.DEFAULT_HEADER = [];
    CsvConfigConsts.DEFAULT_KEYS_AS_HEADERS = false;
    return CsvConfigConsts;
}();
exports.CsvConfigConsts = CsvConfigConsts;
exports.ConfigDefaults = {
    filename: CsvConfigConsts.DEFAULT_FILENAME,
    fieldSeparator: CsvConfigConsts.DEFAULT_FIELD_SEPARATOR,
    quoteStrings: CsvConfigConsts.DEFAULT_QUOTE,
    decimalSeparator: CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR,
    showLabels: CsvConfigConsts.DEFAULT_SHOW_LABELS,
    showTitle: CsvConfigConsts.DEFAULT_SHOW_TITLE,
    title: CsvConfigConsts.DEFAULT_TITLE,
    useTextFile: CsvConfigConsts.DEFAULT_USE_TEXT_FILE,
    useBom: CsvConfigConsts.DEFAULT_USE_BOM,
    headers: CsvConfigConsts.DEFAULT_HEADER,
    useKeysAsHeaders: CsvConfigConsts.DEFAULT_KEYS_AS_HEADERS
};
var ExportToCsv = /** @class */ function() {
    function ExportToCsv(options) {
        this._csv = "";
        var config = options || {};
        this._options = objectAssign({}, exports.ConfigDefaults, config);
        if (this._options.useKeysAsHeaders && this._options.headers && this._options.headers.length > 0) console.warn("Option to use object keys as headers was set, but headers were still passed!");
    }
    Object.defineProperty(ExportToCsv.prototype, "options", {
        get: function() {
            return this._options;
        },
        set: function(options) {
            this._options = objectAssign({}, exports.ConfigDefaults, options);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Generate and Download Csv
     */ ExportToCsv.prototype.generateCsv = function(jsonData, shouldReturnCsv) {
        if (shouldReturnCsv === void 0) shouldReturnCsv = false;
        // Make sure to reset csv data on each run
        this._csv = "";
        this._parseData(jsonData);
        if (this._options.useBom) this._csv += CsvConfigConsts.BOM;
        if (this._options.showTitle) this._csv += this._options.title + "\r\n\n";
        this._createHeaders();
        this._createBody();
        if (this._csv == "") {
            console.log("Invalid data");
            return;
        }
        // When the consumer asks for the data, exit the function
        // by returning the CSV data built at this point
        if (shouldReturnCsv) return this._csv;
        // Create CSV blob to download if requesting in the browser and the
        // consumer doesn't set the shouldReturnCsv param
        var FileType = this._options.useTextFile ? "plain" : "csv";
        var fileExtension = this._options.useTextFile ? ".txt" : ".csv";
        var blob = new Blob([
            this._csv
        ], {
            type: "text/" + FileType + ";charset=utf8;"
        });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("visibility", "hidden");
        link.download = this._options.filename.replace(/ /g, "_") + fileExtension;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    ExportToCsv.prototype._getHeaders = function() {
        if (!this._options.showLabels && !this._options.useKeysAsHeaders) return;
        var useKeysAsHeaders = this._options.useKeysAsHeaders;
        var headers = useKeysAsHeaders ? Object.keys(this._data[0]) : this._options.headers;
        return headers;
    };
    /**
     * Create Headers
     */ ExportToCsv.prototype._createHeaders = function() {
        var headers = this._getHeaders();
        if (headers.length > 0) {
            var row = "";
            for(var keyPos = 0; keyPos < headers.length; keyPos++)row += headers[keyPos] + this._options.fieldSeparator;
            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    };
    /**
     * Create Body
     */ ExportToCsv.prototype._createBody = function() {
        var headers = this._getHeaders();
        for(var i = 0; i < this._data.length; i++){
            var row = "";
            for(var keyPos = 0; keyPos < headers.length; keyPos++){
                var header = headers[keyPos];
                row += this._formatData(this._data[i][header]) + this._options.fieldSeparator;
            }
            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    };
    /**
     * Format Data
     * @param {any} data
     */ ExportToCsv.prototype._formatData = function(data) {
        if (this._options.decimalSeparator === "locale" && this._isFloat(data)) return data.toLocaleString();
        if (this._options.decimalSeparator !== "." && this._isFloat(data)) return data.toString().replace(".", this._options.decimalSeparator);
        if (typeof data === "string") {
            data = data.replace(/"/g, '""');
            if (this._options.quoteStrings || data.indexOf(",") > -1 || data.indexOf("\n") > -1 || data.indexOf("\r") > -1) data = this._options.quoteStrings + data + this._options.quoteStrings;
            return data;
        }
        if (typeof data === "boolean") return data ? "TRUE" : "FALSE";
        return data;
    };
    /**
     * Check if is Float
     * @param {any} input
     */ ExportToCsv.prototype._isFloat = function(input) {
        return +input === input && (!isFinite(input) || Boolean(input % 1));
    };
    /**
     * Parse the collection given to it
     *
     * @private
     * @param {*} jsonData
     * @returns {any[]}
     * @memberof ExportToCsv
     */ ExportToCsv.prototype._parseData = function(jsonData) {
        this._data = typeof jsonData != "object" ? JSON.parse(jsonData) : jsonData;
        return this._data;
    };
    return ExportToCsv;
}();
exports.ExportToCsv = ExportToCsv;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
/**
 * Convet to Object
 * @param {any} val
 */ function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
/**
 * Assign data  to new Object
 * @param {any}   target
 * @param {any[]} ...source
 */ function objectAssign(target) {
    var source = [];
    for(var _i = 1; _i < arguments.length; _i++)source[_i - 1] = arguments[_i];
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (Object.getOwnPropertySymbols) {
            symbols = Object.getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
} //# sourceMappingURL=export-to-csv.js.map

},{}],"kBVH9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _alertService = require("../Services/AlertService");
var _alertServiceDefault = parcelHelpers.interopDefault(_alertService);
var _dm1Service = require("../Services/DM1Service");
var _dm1ServiceDefault = parcelHelpers.interopDefault(_dm1Service);
class AlertAndDMRequestHelper {
    constructor(params){
        this.alertID = params.alertID;
        this.canbusFilter = params.canbusFilter;
        this.children = params.children;
        this.fmiFilter = params.fmiFilter;
        this.gatewayIdFilter = params.gatewayIdFilter;
        this.limit = params.limit;
        this.order = params.order;
        this.orgID = params.orgID; // for satisfying API auth requiring a param named orgID'
        this.orgIdFilter = params.orgIdFilter; // for filtering by/modifying rules-service table column
        this.page = params.page;
        this.ruleIdFilter = params.ruleIdFilter;
        this.saFilter = params.saFilter;
        this.severityFilter = params.severityFilter;
        this.sort = params.sort;
        this.spnFilter = params.spnFilter;
        this.transitionFilter = params.selectedStatus === "all" ? null : params.selectedStatus;
        this.typeFilter = params.typeFilter;
    }
    fetchAlertMetrics(cancelToken) {
        return new (0, _alertServiceDefault.default)().fetchAlertByRuleMetrics(this, cancelToken);
    }
    async fetchAlerts(cancelToken) {
        const { Alerts } = await new (0, _alertServiceDefault.default)().fetchPaginatedAlertsByRule(this, cancelToken);
        return Alerts;
    }
    async clearAlert(cancelToken) {
        const { Alert } = await new (0, _alertServiceDefault.default)().clearAlert(this, cancelToken);
        return Alert;
    }
    fetchDM1Metrics(cancelToken) {
        return new (0, _dm1ServiceDefault.default)().getDM1FaultsCount(this, cancelToken);
    }
    async fetchDM1s(cancelToken) {
        const { DmAlerts } = await new (0, _dm1ServiceDefault.default)().getDM1Faults(this, cancelToken);
        return DmAlerts;
    }
}
exports.default = AlertAndDMRequestHelper;

},{"../Services/AlertService":"i23f0","../Services/DM1Service":"72XwI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g5LoU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _j1939DictionaryJson = require("../Static/j1939Dictionary.json");
var _j1939DictionaryJsonDefault = parcelHelpers.interopDefault(_j1939DictionaryJson);
var _dm1FaultsConstants = require("./DM1FaultsConstants");
var _dm1FaultsConstantsDefault = parcelHelpers.interopDefault(_dm1FaultsConstants);
const STATUS_DISPLAY_MAP = new Map([
    [
        "positive",
        "Active"
    ],
    [
        "negative",
        "Resolved"
    ]
]);
class Dm1Utils {
    DM1FaultsConstants = new (0, _dm1FaultsConstantsDefault.default)();
    formatDm1ForCsv(dm1, orgsMap) {
        const { Canbus: Can_Bus, FMI, GatewayName: Asset_Name, OC: Occurrence_Count, OrgId, SourceAddress, SPN, Transition, TriggeredAt } = dm1;
        const Org_Name = orgsMap?.[OrgId]?.name ?? "", spnName = (0, _j1939DictionaryJsonDefault.default)[SPN] ? (0, _j1939DictionaryJsonDefault.default)[SPN].SPN_Name : SPN, Fault_Name = `${spnName} - ${this.DM1FaultsConstants.listFMIname[FMI]}`, Source = this.DM1FaultsConstants.listSourceAddress[SourceAddress], Status = STATUS_DISPLAY_MAP.get(Transition);
        return {
            Detected_At: (0, _momentDefault.default)(TriggeredAt).toISOString(),
            Asset_Name,
            Org_Name,
            Can_Bus,
            Fault_Name,
            Source,
            SPN,
            FMI,
            Occurrence_Count,
            Status
        };
    }
    generateCsvFilename() {
        return `${new (0, _momentDefault.default)().format("YYYY-M-D_HH\u02F8mm\u02F8ss")}_Fault Record`;
    }
}
exports.default = Dm1Utils;

},{"moment":"1e4qG","../Static/j1939Dictionary.json":"3xmN5","./DM1FaultsConstants":"5zTZ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xmN5":[function(require,module,exports) {
module.exports = JSON.parse('{"20":{"PGN":65172,"PGN_Name":"Engine Auxiliary Coolant","PGN_Description":"EAC","first_bit":24,"SPN":20,"SPN_Name":"Engine Coolant Pressure 1 (Extended Range)","SPN_Description":"Gage pressure of liquid found in engine cooling system.\\r\\n\\r\\nSee also SPN 109 for alternate range and resolution.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"22":{"PGN":65263,"PGN_Name":"Engine Fluid Level/Pressure 1","PGN_Description":"EFL/P1","first_bit":8,"SPN":22,"SPN_Name":"Engine Extended Crankcase Blow-by Pressure","SPN_Description":"Differential crankcase blow-by pressure as measured through a tube with a venturi. \\r\\n\\r\\n(SPN 1264 is not to be used \u2013 obsolete)","bit_length":8,"scaling":0.05,"offset":0,"unit":"kPa","SLOT_ID":48},"27":{"PGN":64916,"PGN_Name":"Electronic Engine Controller 7","PGN_Description":"EEC7","first_bit":0,"SPN":27,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Valve Position","SPN_Description":"The position of the exhaust gas recirculation valve expressed as a percentage of full travel. Zero percent means the valve is closed and no exhaust gas is flowing into the intake air stream. One hundred percent means the valve is fully opened.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"28":{"PGN":3072,"PGN_Name":"Electronic Engine Controller 16","PGN_Description":"EEC16","first_bit":0,"SPN":28,"SPN_Name":"Accelerator Pedal Position 3","SPN_Description":"The ratio of actual position of the third analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.  This parameter is intended for the third accelerator control in an application.  If an application has only one accelerator control, use SPN 91.    \\r\\n.\\r\\nIn marine applications, this will typically be the operator\u2019s third throttle lever.\\r\\n\\r\\nIf a low idle validation switch is used in conjunction with accelerator pedal position 3, use Accelerator Pedal Low Idle Switch 3, SPN 2971.\\r\\n\\r\\nNOTE\u2014See SPNs 91 and 974 for additional accelerator position parameters.  SPN 28 is an additional SPN for accelerator position.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"29":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":32,"SPN":29,"SPN_Name":"Accelerator Pedal Position 2","SPN_Description":"The ratio of actual position of the second analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.  This parameter is intended for secondary accelerator control in an application.  If an application has only one accelerator control, use SPN 91.    \\r\\n\\r\\nIn marine applications, this will typically be the operator\u2019s second throttle lever.\\r\\n\\r\\nIf a low idle validation switch is used in conjunction with accelerator pedal position 2, use Accelerator Pedal Low Idle Switch 2, SPN 2970.\\r\\n\\r\\nNOTE\u2014See SPNs 91 and 974 for additional accelerator position parameters.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"38":{"PGN":65276,"PGN_Name":"Dash Display 1","PGN_Description":"DD1","first_bit":48,"SPN":38,"SPN_Name":"Fuel Level 2","SPN_Description":"Ratio of volume of fuel to the total volume of fuel in the second or right-side storage container.  When Fuel Level 2 is not used, Fuel Level 1 (SPN 96) represents the total fuel in all fuel storage containers.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"39":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":0,"SPN":39,"SPN_Name":"Tire Pressure Check Interval","SPN_Description":"The interval at which the system will check the tire pressures (e.g., 5, 10, 15 min.).\\r\\n\\r\\nNOTE - A value of 0 indicates continuous (real time) pressure readings.","bit_length":8,"scaling":1,"offset":0,"unit":"min","SLOT_ID":61},"46":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":0,"SPN":46,"SPN_Name":"Pneumatic Supply Pressure","SPN_Description":"The pneumatic pressure in the main reservoir, sometimes referred to as the wet tank.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"51":{"PGN":65266,"PGN_Name":"Fuel Economy (Liquid)","PGN_Description":"LFE1","first_bit":48,"SPN":51,"SPN_Name":"Engine Throttle Valve 1 Position 1","SPN_Description":"The position of the valve used to regulate the supply of a fluid, usually air or fuel/air mixture, to an engine.  0% represents no supply and 100% is full supply.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"52":{"PGN":65262,"PGN_Name":"Engine Temperature 1","PGN_Description":"ET1","first_bit":48,"SPN":52,"SPN_Name":"Engine Intercooler Temperature","SPN_Description":"Temperature of liquid found in the intercooler located after the turbocharger.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"53":{"PGN":65221,"PGN_Name":"Electronic Transmission Controller 4","PGN_Description":"ETC4","first_bit":0,"SPN":53,"SPN_Name":"Transmission Synchronizer Clutch Value","SPN_Description":"The current modulated value for the air supply to the synchronizer clutch.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"54":{"PGN":65221,"PGN_Name":"Electronic Transmission Controller 4","PGN_Description":"ETC4","first_bit":8,"SPN":54,"SPN_Name":"Transmission Synchronizer Brake Value","SPN_Description":"The current modulated value for the air supply to the synchronizer brake.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"59":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":0,"SPN":59,"SPN_Name":"Transmission Shift Finger Gear Position","SPN_Description":"The current position of the shift finger in the gear direction.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"60":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":8,"SPN":60,"SPN_Name":"Transmission Shift Finger Rail Position","SPN_Description":"The current position of the shift finger in the rail direction.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"69":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":0,"SPN":69,"SPN_Name":"Two Speed Axle Switch","SPN_Description":"Switch signal which indicates the current axle range.\\r\\n\\r\\n00 - Low speed range\\r\\n01 - High speed range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"70":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":2,"SPN":70,"SPN_Name":"Parking Brake Switch","SPN_Description":"Switch signal which indicates when the parking brake is set. In general the switch actuated by the operator\'s park brake control, whether a pedal, lever or other control mechanism  (see also SPN 619 and 5275).\\r\\n\\r\\n00 - Parking brake not set\\r\\n01 - Parking brake set\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"72":{"PGN":65277,"PGN_Name":"Alternate Fuel 1","PGN_Description":"AF1","first_bit":0,"SPN":72,"SPN_Name":"Engine Blower Bypass Valve Position","SPN_Description":"Relative position of the blower bypass valve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"73":{"PGN":65278,"PGN_Name":"Auxiliary Water Pump Pressure","PGN_Description":"AWPP","first_bit":0,"SPN":73,"SPN_Name":"Auxiliary Pump Pressure","SPN_Description":"Gage pressure of auxiliary water pump driven as a PTO device.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"74":{"PGN":65261,"PGN_Name":"Cruise Control/Vehicle Speed Setup","PGN_Description":"CCSS","first_bit":0,"SPN":74,"SPN_Name":"Maximum Vehicle Speed Limit","SPN_Description":"Maximum vehicle velocity allowed.   See SPN 6808 for an alternate resolution.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"75":{"PGN":65273,"PGN_Name":"Axle Information","PGN_Description":"AI","first_bit":0,"SPN":75,"SPN_Name":"Steering Axle Temperature","SPN_Description":"Temperature of lubricant in steering axle.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"79":{"PGN":65269,"PGN_Name":"Ambient Conditions","PGN_Description":"AMB","first_bit":48,"SPN":79,"SPN_Name":"Road Surface Temperature","SPN_Description":"Indicated temperature of road surface over which vehicle is operating.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"80":{"PGN":65276,"PGN_Name":"Dash Display 1","PGN_Description":"DD1","first_bit":0,"SPN":80,"SPN_Name":"Washer Fluid Level","SPN_Description":"Ratio of volume of liquid to total container volume of fluid reservoir in windshield wash system.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"81":{"PGN":65270,"PGN_Name":"Intake/Exhaust Conditions 1","PGN_Description":"IC1","first_bit":0,"SPN":81,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Intake Pressure (use SPN 3609)","SPN_Description":"Exhaust pressure as a result of particle accumulation on filter media placed in the exhaust stream.  It is recommended that SPN 3609 be used as it has better resolution.","bit_length":8,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":54},"82":{"PGN":65246,"PGN_Name":"Engine Air Start Pressure","PGN_Description":"AIR2","first_bit":0,"SPN":82,"SPN_Name":"Engine Air Start Pressure","SPN_Description":"Gage pressure of air in an engine starting system that utilizes compressed air to provide the force required to rotate the crankshaft.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"84":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":8,"SPN":84,"SPN_Name":"Wheel-Based Vehicle Speed","SPN_Description":"Speed of the vehicle as calculated from wheel or tailshaft speed.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"86":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":40,"SPN":86,"SPN_Name":"Cruise Control Set Speed","SPN_Description":"Value of set (chosen) velocity of velocity control system.  See SPN 6809 for an alternate resolution.\\r\\n\\r\\nIf an algorithm that can modify the cruise control set point exists in the system, such as Predictive Cruise Control or Adaptive Cruise Control, then Cruise Control Set Speed (SPN 86) will not include the speed adjustment made by that algorithm. For the parameter that includes the adjustment, see Cruise Control Speed (SPN 7319) for the final speed used by the cruise control algorithm.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"87":{"PGN":65261,"PGN_Name":"Cruise Control/Vehicle Speed Setup","PGN_Description":"CCSS","first_bit":8,"SPN":87,"SPN_Name":"Cruise Control High Set Limit Speed","SPN_Description":"Maximum vehicle velocity at which cruise can be set.\\r\\n\\r\\nIf Cruise Control Adjusted Maximum Speed (SPN 7495) is supported, then SPN 7495 has priority over SPN 87. See the definition for SPN 7495 for more details.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"88":{"PGN":65261,"PGN_Name":"Cruise Control/Vehicle Speed Setup","PGN_Description":"CCSS","first_bit":16,"SPN":88,"SPN_Name":"Cruise Control Low Set Limit Speed","SPN_Description":"Minimum vehicle velocity at which cruise can be set or minimum vehicle velocity for cruise operation before it will exit cruise control operation.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"90":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":0,"SPN":90,"SPN_Name":"Power Takeoff Oil Temperature","SPN_Description":"Temperature of lubricant in device used to transmit engine power to auxiliary equipment.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"91":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":8,"SPN":91,"SPN_Name":"Accelerator Pedal Position 1","SPN_Description":"The ratio of actual position of the analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.  This parameter is intended for the primary accelerator control in an application.  If an application has only one accelerator control, use SPN 91.    \\r\\n\\r\\nFor on-highway vehicles, this will typically be the operator\u2019s accelerator pedal.  Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.\\r\\n\\r\\nIn marine applications, this will typically be the operator\u2019s throttle lever.\\r\\n\\r\\nIf a low idle validation switch is used in conjunction with accelerator pedal position 1, use Accelerator Pedal Low Idle Switch 1, SPN 558.\\r\\n\\r\\nNOTE\u2014See SPNs 29 and 974 for additional accelerator position parameters.  SPN 28 is an additional diagnostic SPN for accelerator position.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"92":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":16,"SPN":92,"SPN_Name":"Engine Percent Load At Current Speed","SPN_Description":"The ratio of actual engine percent torque (indicated) to maximum indicated torque available at the current engine speed, clipped to zero torque during engine braking.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"94":{"PGN":65263,"PGN_Name":"Engine Fluid Level/Pressure 1","PGN_Description":"EFL/P1","first_bit":0,"SPN":94,"SPN_Name":"Engine Fuel Delivery Pressure","SPN_Description":"Gage pressure of fuel in system as delivered from supply pump to the injection pump.  See SPN 7469 for alternate resolution.\\r\\n\\r\\nSee also SPN 5578 for Fuel Delivery Absolute Pressure.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"95":{"PGN":65276,"PGN_Name":"Dash Display 1","PGN_Description":"DD1","first_bit":16,"SPN":95,"SPN_Name":"Engine Fuel Filter Differential Pressure","SPN_Description":"Change in fuel delivery pressure, measured across the filter, due to accumulation of solid or semisolid matter on the filter element.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"96":{"PGN":65276,"PGN_Name":"Dash Display 1","PGN_Description":"DD1","first_bit":8,"SPN":96,"SPN_Name":"Fuel Level 1","SPN_Description":"Ratio of volume of fuel to the total volume of fuel storage container.\\r\\n\\r\\nWhen Fuel Level 2 (SPN 38) is not used, Fuel Level 1 represents the total fuel in all fuel storage containers.  When Fuel Level 2 is used, Fuel Level 1 represents the fuel level in the primary or left-side fuel storage container.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"97":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":0,"SPN":97,"SPN_Name":"Water In Fuel Indicator 1","SPN_Description":"Signal which indicates the presence of water in the fuel.\\r\\n\\r\\n00 - No\\r\\n01 - Yes\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"98":{"PGN":65263,"PGN_Name":"Engine Fluid Level/Pressure 1","PGN_Description":"EFL/P1","first_bit":16,"SPN":98,"SPN_Name":"Engine Oil Level","SPN_Description":"Ratio of current volume of engine sump oil to maximum required volume.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"99":{"PGN":65276,"PGN_Name":"Dash Display 1","PGN_Description":"DD1","first_bit":24,"SPN":99,"SPN_Name":"Engine Oil Filter Differential Pressure","SPN_Description":"Change in engine oil pressure, measured across the filter, due to the filter and any accumulation of solid or semisolid material on or in the filter.  See SPN 7471 for alternate resolution.","bit_length":8,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":54},"100":{"PGN":65263,"PGN_Name":"Engine Fluid Level/Pressure 1","PGN_Description":"EFL/P1","first_bit":24,"SPN":100,"SPN_Name":"Engine Oil Pressure","SPN_Description":"Gage pressure of oil in engine lubrication system as provided by oil pump.  See SPN 7468 for alternate resolution.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"101":{"PGN":65263,"PGN_Name":"Engine Fluid Level/Pressure 1","PGN_Description":"EFL/P1","first_bit":32,"SPN":101,"SPN_Name":"Engine Crankcase Pressure 1","SPN_Description":"First instance of the gage pressure inside engine crankcase.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"102":{"PGN":65270,"PGN_Name":"Intake/Exhaust Conditions 1","PGN_Description":"IC1","first_bit":8,"SPN":102,"SPN_Name":"Engine Intake Manifold #1 Pressure","SPN_Description":"The gage pressure measurement of the air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.  This should be the pressure used to drive gauges and displays. See also SPNs 1127-1130 and SPN 3562  for alternate range and resolution. If there is only one pressure measurement of the air intake manifold to report and this range and resolution is adequate, this parameter should be used.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"103":{"PGN":65245,"PGN_Name":"Turbocharger","PGN_Description":"TC","first_bit":8,"SPN":103,"SPN_Name":"Engine Turbocharger 1 Speed","SPN_Description":"Rotational velocity of rotor in the turbocharger.","bit_length":16,"scaling":4,"offset":0,"unit":"rpm","SLOT_ID":77},"104":{"PGN":65245,"PGN_Name":"Turbocharger","PGN_Description":"TC","first_bit":0,"SPN":104,"SPN_Name":"Engine Turbocharger Lube Oil Pressure 1","SPN_Description":"Gage pressure of oil in turbocharger lubrication system.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"105":{"PGN":65270,"PGN_Name":"Intake/Exhaust Conditions 1","PGN_Description":"IC1","first_bit":16,"SPN":105,"SPN_Name":"Engine Intake Manifold 1 Temperature","SPN_Description":"Temperature of pre-combustion air found in intake manifold of engine air supply system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"106":{"PGN":65270,"PGN_Name":"Intake/Exhaust Conditions 1","PGN_Description":"IC1","first_bit":24,"SPN":106,"SPN_Name":"Engine Intake Air Pressure","SPN_Description":"Absolute air pressure at input port to intake manifold or air box.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"107":{"PGN":65270,"PGN_Name":"Intake/Exhaust Conditions 1","PGN_Description":"IC1","first_bit":32,"SPN":107,"SPN_Name":"Engine Air Filter 1 Differential Pressure","SPN_Description":"Change in engine air system pressure, measured across the filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\\r\\n\\r\\nThis is the measurement of the first filter in a multiple air filter system.  In a single air filter application, this is the only SPN used. Filter numbering follows the guidelines noted in section, Naming Convention For Engine Parameters.","bit_length":8,"scaling":0.05,"offset":0,"unit":"kPa","SLOT_ID":48},"108":{"PGN":65269,"PGN_Name":"Ambient Conditions","PGN_Description":"AMB","first_bit":0,"SPN":108,"SPN_Name":"Barometric Pressure","SPN_Description":"Absolute air pressure of the atmosphere.","bit_length":8,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":54},"109":{"PGN":65263,"PGN_Name":"Engine Fluid Level/Pressure 1","PGN_Description":"EFL/P1","first_bit":48,"SPN":109,"SPN_Name":"Engine Coolant Pressure 1","SPN_Description":"Gage pressure of liquid found in engine cooling system.\\r\\n\\r\\nSee SPN 20 for alternate range and resolution.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"110":{"PGN":65262,"PGN_Name":"Engine Temperature 1","PGN_Description":"ET1","first_bit":0,"SPN":110,"SPN_Name":"Engine Coolant Temperature","SPN_Description":"Temperature of liquid found in engine cooling system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"111":{"PGN":65263,"PGN_Name":"Engine Fluid Level/Pressure 1","PGN_Description":"EFL/P1","first_bit":56,"SPN":111,"SPN_Name":"Engine Coolant Level 1","SPN_Description":"Ratio of volume of liquid found in engine cooling system to total cooling system volume.  Typical monitoring location is in the coolant expansion tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"112":{"PGN":65270,"PGN_Name":"Intake/Exhaust Conditions 1","PGN_Description":"IC1","first_bit":56,"SPN":112,"SPN_Name":"Engine Coolant Filter Differential Pressure","SPN_Description":"Change in coolant pressure, measured across the filter, due to the filter and any accumulation of solid or semisolid matter on or in the filter.","bit_length":8,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":54},"114":{"PGN":65271,"PGN_Name":"Vehicle Electrical Power 1","PGN_Description":"VEP1","first_bit":0,"SPN":114,"SPN_Name":"SLI Battery 1 Net Current","SPN_Description":"Net flow of electrical current into/out of the first battery or first set of batteries used for starting the engine, for lighting, and for ignition (SLI).  If more than one battery is included in the first set of batteries and the net current for each battery is desired, then SPNs 7900, 7908, 7916, & 7924 shall be used.\\r\\n\\r\\nSee SPN 2579 for alternate range and resolution.","bit_length":8,"scaling":1,"offset":-125,"unit":"A","SLOT_ID":40},"115":{"PGN":65271,"PGN_Name":"Vehicle Electrical Power 1","PGN_Description":"VEP1","first_bit":8,"SPN":115,"SPN_Name":"Alternator Current","SPN_Description":"Measure of electrical current flow from the alternator.  Alternator Current (High Range/Resolution) parameter SPN 1795 has a higher range and resolution of the same parameter.","bit_length":8,"scaling":1,"offset":0,"unit":"A","SLOT_ID":41},"116":{"PGN":65274,"PGN_Name":"Brakes 1","PGN_Description":"B1","first_bit":0,"SPN":116,"SPN_Name":"Brake Application Pressure","SPN_Description":"Gage pressure of compressed air or fluid in vehicle braking system measured at the brake chamber when brake shoe (or pad) is placed against brake drum (or disc).","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"117":{"PGN":65274,"PGN_Name":"Brakes 1","PGN_Description":"B1","first_bit":8,"SPN":117,"SPN_Name":"Brake Primary Pressure","SPN_Description":"Gage pressure of air in the primary, or supply side, of the air brake system.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"118":{"PGN":65274,"PGN_Name":"Brakes 1","PGN_Description":"B1","first_bit":16,"SPN":118,"SPN_Name":"Brake Secondary Pressure","SPN_Description":"Gage pressure of air in the secondary, or service side, of the air brake system.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"119":{"PGN":65275,"PGN_Name":"Retarder fluids","PGN_Description":"RF","first_bit":0,"SPN":119,"SPN_Name":"Hydraulic Retarder Pressure","SPN_Description":"Gage pressure of oil in hydraulic retarder system.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"120":{"PGN":65275,"PGN_Name":"Retarder fluids","PGN_Description":"RF","first_bit":8,"SPN":120,"SPN_Name":"Hydraulic Retarder Oil Temperature","SPN_Description":"Temperature of oil found in a hydraulic retarder.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"123":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":0,"SPN":123,"SPN_Name":"Clutch Pressure","SPN_Description":"Gage pressure of oil within a wet clutch.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"124":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":8,"SPN":124,"SPN_Name":"Transmission Oil Level 1","SPN_Description":"First instance of a transmission oil level indicator. Conveys the ratio of volume of transmission sump oil to recommended volume.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"126":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":16,"SPN":126,"SPN_Name":"Transmission Filter Differential Pressure","SPN_Description":"Change in transmission fluid pressure, measured after the filter, due to accumulation of solid or semisolid material on or in the filter.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"127":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":24,"SPN":127,"SPN_Name":"Transmission Oil Pressure","SPN_Description":"Gage pressure of lubrication fluid in transmission, measured after pump.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"132":{"PGN":61450,"PGN_Name":"Engine Gas Flow Rate","PGN_Description":"EGF1","first_bit":16,"SPN":132,"SPN_Name":"Engine Intake Air Mass Flow Rate","SPN_Description":"Mass flow rate of fresh air entering the engine air intake, before any EGR mixer, if used.  Flow rate of fresh air conducted to the engine cylinders to support combustion.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kg/h","SLOT_ID":18},"136":{"PGN":65143,"PGN_Name":"Auxiliary Pressures","PGN_Description":"AP","first_bit":0,"SPN":136,"SPN_Name":"Auxiliary Vacuum Pressure Reading","SPN_Description":"Identifies the current vacuum pressure (relative to atmosphere) that is configured uniquely per application.  Not to be used in place of defined parameters.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"137":{"PGN":65143,"PGN_Name":"Auxiliary Pressures","PGN_Description":"AP","first_bit":16,"SPN":137,"SPN_Name":"Auxiliary Gage Pressure Reading 1","SPN_Description":"Identifies the current gage pressure (relative to atmosphere) that is configured uniquely per application.  Not to be used in place of defined parameters.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"138":{"PGN":65143,"PGN_Name":"Auxiliary Pressures","PGN_Description":"AP","first_bit":32,"SPN":138,"SPN_Name":"Auxiliary Absolute Pressure Reading","SPN_Description":"Identifies the current absolute pressure (relative to 0 pressure) that is configured uniquely per application.  Not to be used in place of defined parameters.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"141":{"PGN":65145,"PGN_Name":"Tire Pressure Control Unit Target Pressures","PGN_Description":"TP2","first_bit":0,"SPN":141,"SPN_Name":"Trailer, Tag Or Push Channel Tire Pressure Target","SPN_Description":"The tire pressure control system\u2019s target gage pressure for the trailer, tag, or push group of tires.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"142":{"PGN":65145,"PGN_Name":"Tire Pressure Control Unit Target Pressures","PGN_Description":"TP2","first_bit":16,"SPN":142,"SPN_Name":"Drive Channel Tire Pressure Target","SPN_Description":"The tire pressure control system\u2019s target gage pressure for the drive group of tires.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"143":{"PGN":65145,"PGN_Name":"Tire Pressure Control Unit Target Pressures","PGN_Description":"TP2","first_bit":32,"SPN":143,"SPN_Name":"Steer Channel Tire Pressure Target","SPN_Description":"The tire pressure control system\u2019s target gage pressure for the steer group of tires.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"144":{"PGN":65146,"PGN_Name":"Tire Pressure Control Unit Current Pressures","PGN_Description":"TP3","first_bit":0,"SPN":144,"SPN_Name":"Trailer, Tag Or Push Channel Tire Pressure","SPN_Description":"The latest gage pressure reading of the trailer, tag, or push group of tires, as opposed to the pressure in each tire.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"145":{"PGN":65146,"PGN_Name":"Tire Pressure Control Unit Current Pressures","PGN_Description":"TP3","first_bit":16,"SPN":145,"SPN_Name":"Drive Channel Tire Pressure","SPN_Description":"The latest gage pressure reading of the drive group of tires, as opposed to the pressure in each tire.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"146":{"PGN":65146,"PGN_Name":"Tire Pressure Control Unit Current Pressures","PGN_Description":"TP3","first_bit":32,"SPN":146,"SPN_Name":"Steer Channel Tire Pressure","SPN_Description":"The latest gage pressure reading of the steer group of tires, as opposed to the pressure in each tire.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"156":{"PGN":65243,"PGN_Name":"Engine Fluid Level/Pressure 2","PGN_Description":"EFL/P2","first_bit":32,"SPN":156,"SPN_Name":"Engine Fuel 1 Injector Timing Rail 1 Pressure","SPN_Description":"The gage pressure of fuel in the timing rail delivered from the supply pump to the injector timing intake.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"157":{"PGN":65243,"PGN_Name":"Engine Fluid Level/Pressure 2","PGN_Description":"EFL/P2","first_bit":16,"SPN":157,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 1 Pressure","SPN_Description":"The gage pressure of fuel in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"158":{"PGN":65271,"PGN_Name":"Vehicle Electrical Power 1","PGN_Description":"VEP1","first_bit":48,"SPN":158,"SPN_Name":"Key Switch Battery Potential","SPN_Description":"Battery potential measured at the input of the electronic control unit supplied through a key switch or similar switching device.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"159":{"PGN":65277,"PGN_Name":"Alternate Fuel 1","PGN_Description":"AF1","first_bit":8,"SPN":159,"SPN_Name":"Engine Gaseous Fuel Supply Pressure 1","SPN_Description":"Gage pressure of gaseous fuel supply to fuel metering device.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"160":{"PGN":61538,"PGN_Name":"Electronic Transmission Controller #12","PGN_Description":"ETC12","first_bit":48,"SPN":160,"SPN_Name":"Transmission Intermediate Shaft Speed","SPN_Description":"Rotational velocity of the first intermediate shaft of the transmission.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"161":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":40,"SPN":161,"SPN_Name":"Transmission Input Shaft Speed","SPN_Description":"Rotational velocity of the primary shaft transferring power into the transmission.  When a torque converter is present, it is the output of the torque converter.\\r\\n\\r\\nNote:\\r\\n\\r\\nSingle input shaft transmissions should use SPN 161 (Transmission Input Shaft Speed).\\r\\nMultiple input shaft transmissions should use SPN 5960 and 5961 (DCT Input Shaft 1 and 2 Speeds).\\r\\n\\r\\nFor maximum compatibility, a multiple input shaft speed transmission may also broadcast SPN 161 as a\\r\\nvirtual or current inputshaft speed with the following logic:\\r\\n\\r\\nTransmission Input Shaft Speed = DCT Input Shaft 1 Speed when shaft 1 is engaged.\\r\\nTransmission Input Shaft Speed = DCT Input Shaft 2 Speed when shaft 2 is engaged.\\r\\nTransmission Input Shaft Speed = Transitional interpolated value when shifting between shaft 1 and 2.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"162":{"PGN":61445,"PGN_Name":"Electronic Transmission Controller 2","PGN_Description":"ETC2","first_bit":32,"SPN":162,"SPN_Name":"Transmission Requested Range","SPN_Description":"Range selected by the operator.  Characters may include P, Rx, Rx-1...R2, R1, R, Nx, Nx-1...N2, N1, N, D, D1, D2..., Dx, L, L1, L2..., Lx-1, 1, 2, 3,...  If only one displayed character is required, the second character shall be used and the first character shall be a space (ASCII 32) or a control character (ASCII 0 to 31).  If the first character is a control character, refer to the manufacturer\u2019s application document for definition.","bit_length":16,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":131},"163":{"PGN":61445,"PGN_Name":"Electronic Transmission Controller 2","PGN_Description":"ETC2","first_bit":48,"SPN":163,"SPN_Name":"Transmission Current Range","SPN_Description":"Range currently being commanded by the transmission control system. Characters may include P, Rx, Rx-1...R2, R1, R, Nx, Nx-1...N2, N1, N, D, D1, D2..., Dx, L, L1, L2..., Lx-1, 1, 2, 3,... If only one displayed character is required, the second character shall be used and the first character shall be a space (ASCII 32) or a control character (ASCII 0 to 31).  If the first character is a control character, refer to the manufacturer\u2019s application document for definition.","bit_length":16,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":131},"164":{"PGN":65243,"PGN_Name":"Engine Fluid Level/Pressure 2","PGN_Description":"EFL/P2","first_bit":0,"SPN":164,"SPN_Name":"Engine Fuel Injection Control Pressure","SPN_Description":"The gage pressure of the engine oil in the hydraulic accumulator that powers an intensifier used for fuel injection.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"165":{"PGN":65256,"PGN_Name":"Vehicle Direction/Speed","PGN_Description":"VDS","first_bit":0,"SPN":165,"SPN_Name":"Compass Bearing","SPN_Description":"Present compass bearing of vehicle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"166":{"PGN":65214,"PGN_Name":"Electronic Engine Controller 4","PGN_Description":"EEC4","first_bit":0,"SPN":166,"SPN_Name":"Engine Rated Power","SPN_Description":"Net brake power that the engine will deliver continuously, specified for a given application at a rated speed.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"167":{"PGN":65271,"PGN_Name":"Vehicle Electrical Power 1","PGN_Description":"VEP1","first_bit":16,"SPN":167,"SPN_Name":"Charging System Potential (Voltage)","SPN_Description":"Electrical potential measured at the charging system output.  The charging system may be any device charging the batteries.  This includes alternators, generators, solid state charger and other charging devices.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"168":{"PGN":65271,"PGN_Name":"Vehicle Electrical Power 1","PGN_Description":"VEP1","first_bit":32,"SPN":168,"SPN_Name":"Battery Potential / Power Input 1","SPN_Description":"This parameter measures the first source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery.  This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.\\r\\n\\r\\nIf more than one battery is included in the first set of batteries and the potential for each battery is desired, then SPNs 7902, 7910, 7918, & 7926 shall be used.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"169":{"PGN":65276,"PGN_Name":"Dash Display 1","PGN_Description":"DD1","first_bit":32,"SPN":169,"SPN_Name":"Cargo Ambient Temperature","SPN_Description":"Temperature of air inside vehicle container used to accommodate cargo.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"170":{"PGN":65269,"PGN_Name":"Ambient Conditions","PGN_Description":"AMB","first_bit":8,"SPN":170,"SPN_Name":"Cab Interior Temperature","SPN_Description":"Temperature of air inside the part of the vehicle that encloses the driver and vehicle operating controls.\\r\\n\\r\\nNote: See also SPN 1691.  SPN 1662 is an additional diagnostic SPN associated with cab temperature.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"171":{"PGN":65269,"PGN_Name":"Ambient Conditions","PGN_Description":"AMB","first_bit":24,"SPN":171,"SPN_Name":"Ambient Air Temperature","SPN_Description":"Temperature of air surrounding vehicle.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"172":{"PGN":65269,"PGN_Name":"Ambient Conditions","PGN_Description":"AMB","first_bit":40,"SPN":172,"SPN_Name":"Engine Intake 1 Air Temperature","SPN_Description":"Temperature of air entering vehicle air induction system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"173":{"PGN":65270,"PGN_Name":"Intake/Exhaust Conditions 1","PGN_Description":"IC1","first_bit":40,"SPN":173,"SPN_Name":"Engine Exhaust Temperature","SPN_Description":"Temperature of combustion byproducts leaving the engine.  See SPNs 2433, 2434, 5969 and 5970 for engines with more than one exhaust temperature measurement.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"174":{"PGN":65262,"PGN_Name":"Engine Temperature 1","PGN_Description":"ET1","first_bit":8,"SPN":174,"SPN_Name":"Engine Fuel 1 Temperature 1","SPN_Description":"Temperature of fuel (or gas) of the first fuel type. See SPN 3468 for a second temperature measurement of the first fuel type.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"175":{"PGN":65262,"PGN_Name":"Engine Temperature 1","PGN_Description":"ET1","first_bit":16,"SPN":175,"SPN_Name":"Engine Oil Temperature 1","SPN_Description":"Temperature of the engine lubricant.\\r\\n\\r\\nNote:  If there is only one engine oil temperature measurement, this SPN should be used.  This is the SPN that is typically displayed on an on-highway truck instrument cluster.\\r\\n\\r\\nSee also SPNs 1135 and 5925 for additional engine oil temperature measurements.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"176":{"PGN":65262,"PGN_Name":"Engine Temperature 1","PGN_Description":"ET1","first_bit":32,"SPN":176,"SPN_Name":"Engine Turbocharger Oil Temperature","SPN_Description":"Temperature of the turbocharger lubricant.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"177":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":32,"SPN":177,"SPN_Name":"Transmission Oil Temperature 1","SPN_Description":"First instance of transmission lubricant temperature.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"180":{"PGN":65258,"PGN_Name":"Vehicle Weight","PGN_Description":"VW","first_bit":24,"SPN":180,"SPN_Name":"Trailer Weight","SPN_Description":"Total mass of freight-carrying vehicle designed to be pulled by truck, including the weight of the contents.","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"181":{"PGN":65258,"PGN_Name":"Vehicle Weight","PGN_Description":"VW","first_bit":40,"SPN":181,"SPN_Name":"Cargo Weight","SPN_Description":"The mass of freight carried.","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"182":{"PGN":65257,"PGN_Name":"Fuel Consumption (Liquid) 1","PGN_Description":"LFC1","first_bit":0,"SPN":182,"SPN_Name":"Engine Trip Fuel","SPN_Description":"Fuel consumed during all or part of a journey.  See SPN 5053 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"183":{"PGN":65266,"PGN_Name":"Fuel Economy (Liquid)","PGN_Description":"LFE1","first_bit":0,"SPN":183,"SPN_Name":"Engine Fuel Rate","SPN_Description":"Amount of fuel consumed by engine per unit of time.\\r\\n\\r\\nNOTE - See SPN 1600 for alternate resolution.","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"184":{"PGN":65266,"PGN_Name":"Fuel Economy (Liquid)","PGN_Description":"LFE1","first_bit":16,"SPN":184,"SPN_Name":"Engine Instantaneous Fuel Economy","SPN_Description":"Current fuel economy at current vehicle velocity.\\r\\n\\r\\n0xFB00 = Infinite (for example, during engine motoring)","bit_length":16,"scaling":0.001953125,"offset":0,"unit":"km/L","SLOT_ID":16},"185":{"PGN":65266,"PGN_Name":"Fuel Economy (Liquid)","PGN_Description":"LFE1","first_bit":32,"SPN":185,"SPN_Name":"Engine Average Fuel Economy","SPN_Description":"Average of instantaneous fuel economy for that segment of vehicle operation of interest.","bit_length":16,"scaling":0.001953125,"offset":0,"unit":"km/L","SLOT_ID":16},"186":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":8,"SPN":186,"SPN_Name":"Power Takeoff Speed","SPN_Description":"Rotational velocity of device used to transmit engine power to auxiliary equipment.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"187":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":24,"SPN":187,"SPN_Name":"Power Takeoff Set Speed","SPN_Description":"Rotational velocity selected by operator for device used to transmit engine power to auxiliary equipment.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"188":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":0,"SPN":188,"SPN_Name":"Engine Speed At Idle, Point 1","SPN_Description":"Stationary low idle speed of engine which includes influences due to engine temperature (after power up) and other stationary changes (calibration offsets, sensor failures, etc).  This parameter is point 1 of the engine configuration map (see PGN 65251).","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"189":{"PGN":65214,"PGN_Name":"Electronic Engine Controller 4","PGN_Description":"EEC4","first_bit":16,"SPN":189,"SPN_Name":"Engine Rated Speed","SPN_Description":"The maximum governed rotational velocity of the engine crankshaft under full load conditions.  Note that the engine speed at point 2 (SPN 528) is equal to rated engine speed only in the case when the engine has not been derated.  Please also reference PGN 65251.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"190":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":24,"SPN":190,"SPN_Name":"Engine Speed","SPN_Description":"Actual engine speed which is calculated over a minimum crankshaft angle of 720 degrees divided by the number of cylinders.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"191":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":8,"SPN":191,"SPN_Name":"Transmission Output Shaft Speed","SPN_Description":"Calculated speed of the transmission output shaft.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"235":{"PGN":65244,"PGN_Name":"Idle Operation","PGN_Description":"IO","first_bit":32,"SPN":235,"SPN_Name":"Engine Total Idle Hours","SPN_Description":"Accumulated time of operation of the engine while under idle conditions.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"236":{"PGN":65244,"PGN_Name":"Idle Operation","PGN_Description":"IO","first_bit":0,"SPN":236,"SPN_Name":"Engine Total Idle Fuel Used","SPN_Description":"Accumulated amount of fuel used during vehicle operation while under idle conditions.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"241":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":8,"SPN":241,"SPN_Name":"Tire Pressure","SPN_Description":"Pressure at which air is contained in cavity formed by tire and rim.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"242":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":16,"SPN":242,"SPN_Name":"Tire Temperature","SPN_Description":"Temperature at the surface of the tire sidewall.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"244":{"PGN":65248,"PGN_Name":"Vehicle Distance","PGN_Description":"VD","first_bit":0,"SPN":244,"SPN_Name":"Trip Distance","SPN_Description":"Distance traveled during all or part of a journey.\\r\\n\\r\\nNOTE See SPN 918 for alternate resolution.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"245":{"PGN":65248,"PGN_Name":"Vehicle Distance","PGN_Description":"VD","first_bit":32,"SPN":245,"SPN_Name":"Total Vehicle Distance","SPN_Description":"Accumulated distance traveled by vehicle during its operation.\\r\\n\\r\\nNOTE See SPN 917 for alternate resolution.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"246":{"PGN":65255,"PGN_Name":"Vehicle Hours","PGN_Description":"VH","first_bit":0,"SPN":246,"SPN_Name":"Total Vehicle Hours","SPN_Description":"Accumulated time of operation of vehicle.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"247":{"PGN":65253,"PGN_Name":"Engine Hours, Revolutions","PGN_Description":"HOURS","first_bit":0,"SPN":247,"SPN_Name":"Engine Total Hours of Operation","SPN_Description":"Accumulated time of operation of engine.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"248":{"PGN":65255,"PGN_Name":"Vehicle Hours","PGN_Description":"VH","first_bit":32,"SPN":248,"SPN_Name":"Total Power Takeoff Hours","SPN_Description":"Accumulated time of operation of power takeoff device.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"249":{"PGN":65253,"PGN_Name":"Engine Hours, Revolutions","PGN_Description":"HOURS","first_bit":32,"SPN":249,"SPN_Name":"Engine Total Revolutions","SPN_Description":"Accumulated number of revolutions of engine crankshaft during its operation.","bit_length":32,"scaling":1000,"offset":0,"unit":"r","SLOT_ID":34},"250":{"PGN":65257,"PGN_Name":"Fuel Consumption (Liquid) 1","PGN_Description":"LFC1","first_bit":32,"SPN":250,"SPN_Name":"Engine Total Fuel Used","SPN_Description":"Accumulated amount of fuel used during vehicle operation.  See SPN 5054 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"354":{"PGN":65164,"PGN_Name":"Auxiliary Analog Information","PGN_Description":"AAI","first_bit":48,"SPN":354,"SPN_Name":"Relative Humidity","SPN_Description":"Measures humidity of combustion air prior to entry into turbocharger","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"407":{"PGN":64873,"PGN_Name":"Axle Group Calibration Weights","PGN_Description":"AGCW","first_bit":24,"SPN":407,"SPN_Name":"Axle Group Full Weight Calibration","SPN_Description":"The full weight calibration measurement of an axle group","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"408":{"PGN":64873,"PGN_Name":"Axle Group Calibration Weights","PGN_Description":"AGCW","first_bit":8,"SPN":408,"SPN_Name":"Axle Group Empty Weight Calibration","SPN_Description":"The empty weight calibration measurement of an axle group","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"409":{"PGN":64874,"PGN_Name":"Axle Group Weight","PGN_Description":"AGW","first_bit":8,"SPN":409,"SPN_Name":"Axle Group Weight","SPN_Description":"Total mass imposed on the road surface by all the tires in the axle group","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"411":{"PGN":65188,"PGN_Name":"Engine Temperature 2","PGN_Description":"ET2","first_bit":32,"SPN":411,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Differential Pressure","SPN_Description":"Differential pressure across the Exhaust Gas Recirculation (EGR) system","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"412":{"PGN":65188,"PGN_Name":"Engine Temperature 2","PGN_Description":"ET2","first_bit":48,"SPN":412,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Temperature","SPN_Description":"Temperature of Recirculated Exhaust Gas.  This should not be used for Exhaust Gas Recirculation Mixer Intake Temperature.  See SPN 5020.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"413":{"PGN":64872,"PGN_Name":"Gross Combination Vehicle Weight","PGN_Description":"GCVW","first_bit":24,"SPN":413,"SPN_Name":"Net Vehicle Weight Change","SPN_Description":"Identifies the net vehicle weight change from the time of last vehicle net weight zeroing.","bit_length":24,"scaling":2,"offset":-16449535,"unit":"kg","SLOT_ID":267},"417":{"PGN":64872,"PGN_Name":"Gross Combination Vehicle Weight","PGN_Description":"GCVW","first_bit":0,"SPN":417,"SPN_Name":"Gross Combination Weight","SPN_Description":"Total weight of the truck and all the trailers with on-board scales.","bit_length":24,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":122},"441":{"PGN":65164,"PGN_Name":"Auxiliary Analog Information","PGN_Description":"AAI","first_bit":0,"SPN":441,"SPN_Name":"Auxiliary Temperature 1","SPN_Description":"Temperature measured by auxiliary temperature sensor #1.  Not to be used in place of existing SPNs.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"442":{"PGN":65164,"PGN_Name":"Auxiliary Analog Information","PGN_Description":"AAI","first_bit":8,"SPN":442,"SPN_Name":"Auxiliary Temperature 2","SPN_Description":"Temperature measured by auxiliary temperature sensor #2.  Not to be used in place of existing SPNs.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"444":{"PGN":65165,"PGN_Name":"Vehicle Electrical Power 2","PGN_Description":"VEP2","first_bit":0,"SPN":444,"SPN_Name":"Battery Potential / Power Input 2","SPN_Description":"This parameter measures the second source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery.  This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"512":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":8,"SPN":512,"SPN_Name":"Driver\'s Demand Engine - Percent Torque","SPN_Description":"The requested torque output of the engine by the driver. It is based on input from the following requestors external to the powertrain: operator (via the accelerator pedal), cruise control and/or road speed limit governor. Dynamic commands from internal powertrain functions such as smoke control, low- and high-speed engine governing; ASR and shift control are excluded from this calculation. The data is transmitted in indicated torque as a percent of the reference engine torque. See PGN 65251 for the engine configuration message. Several status bits are defined separately to indicate the request which is currently being honored. This parameter may be used for shift scheduling.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"513":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":16,"SPN":513,"SPN_Name":"Actual Engine - Percent Torque","SPN_Description":"The calculated output torque of the engine.  The data is transmitted in indicated torque as a percent of reference engine torque (see the engine configuration message, PGN 65251).  The engine percent torque value will not be less than zero and it includes the torque developed in the cylinders required to overcome friction.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"514":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":0,"SPN":514,"SPN_Name":"Nominal Friction - Percent Torque","SPN_Description":"The calculated torque that indicates the amount of torque required by the basic engine itself added by the loss torque of accessories.  It contains the frictional and thermodynamic loss of the engine itself, pumping torque loss (SPN 5398), and the losses of fuel, oil and cooling pumps.  The data is transmitted as a percent of reference engine torque (see the engine configuration message, PGN 65251).\\r\\n\\r\\nThe realization can be done by a map dependent on engine speed and engine temperature and an offset value for additional loss torques.\\r\\n\\r\\nSee SPN 2978 for an indicator that describes the possible inclusion of engine parasitic losses such as cooling fan, etc. in this parameter value.\\r\\n\\r\\nNote:  Refer to section 5.2.1 in SAE J1939-71.\\r\\n\\r\\nNote: Beginning in 2016,  HD-OBD requires reporting of engine torque to Portable Emissions Measurement System (PEMS) equipment that is representative of torque as measured by the engine dynamometer during the emissions certification process. Therefore, for applications that are subject to HD-OBD regulations in 2016 or later, estimated parasitic losses shall no longer be included in SPN 514 Nominal Friction - Percent Torque and must be included in SPN 2978 Estimated Engine Parasitic Losses - Percent Torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"515":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":8,"SPN":515,"SPN_Name":"Engine\'s Desired Operating Speed","SPN_Description":"An indication by the engine of the optimal operating speed of the engine for the current existing conditions.  These conditions may include the torque generated to accommodate powertrain demands from the operator (via the accelerator pedal), cruise control, road speed limit governors, or ASR.  Dynamic commands from functions such as smoke control or shift control are excluded from this calculation.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"517":{"PGN":65256,"PGN_Name":"Vehicle Direction/Speed","PGN_Description":"VDS","first_bit":16,"SPN":517,"SPN_Name":"Navigation-Based Vehicle Speed","SPN_Description":"Speed of the vehicle as calculated from a device such as a Global Positioning System (GPS).","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"518":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":24,"SPN":518,"SPN_Name":"Engine Requested Torque/Torque Limit","SPN_Description":"Parameter provided to the engine or retarder in the torque/speed control message for controlling or limiting the output torque.\\r\\n\\r\\nRequested torque to the engine is measured in indicated torque as a percentage of reference engine torque (see the engine configuration message, PGN 65251).  This is the engine torque at which the engine is expected to operate if the torque control mode is active or the engine torque which the engine is not expected to exceed if the torque limit mode is active.\\r\\n\\r\\nZero torque can be requested which implies zero fuel and, according to Figures SPN512_A and SPN512_B, the engine will not be allowed to stall.  The actual engine percent torque (SPN 513) should be zero and the engine should decelerate until the low idle governor kicks in, at which time the actual engine percent torque will be calculated as shown in Figures SPN512_A and SPN512_B and the engine torque mode bits (SPN 899) should be equal to 0000b - Low Idle Governor.\\r\\n\\r\\nRequested torque to the retarder is measured in indicated torque as a percentage of reference retarder torque (see the retarder configuration message,  PGN 65249).  The logic used in enabling or disabling the retarder is based on the override control mode priority bits (SPN 897).\\r\\n\\r\\nA zero torque request to the retarder is a disable request, and is used by a J1939 node to prevent the retarder from being activated by other combinations of inputs outside of J1939 commands. The Torque Limit Mode is commonly used for this purpose.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"519":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":24,"SPN":519,"SPN_Name":"Engine\'s Desired Operating Speed Asymmetry Adjustment","SPN_Description":"This byte is utilized in transmission gear selection routines and indicates the engine\'s preference of lower versus higher engine speeds should its desired speed not be achievable.  This is a scaled ratio such that 125 represents an equal preference for a speed lower or higher that the engine\'s indicated desired speed.  The higher the asymmetry adjustment value is above 125, the more the engine prefers to be operated at or above its indicated desired speed.  Conversely, the lower the asymmetry adjustment value is below 125, the more the engine prefers to operate at or below its indicated desired speed.  Typically, the engine\'s asymmetry adjustment will be predicated on fuel consumption considerations, and under these conditions, the method for computing the asymmetry adjustment is indicated in Figure SPN519_A. The engine may include other factors into its asymmetry adjustment calculation such as temperatures, pressures, and other operating parameters.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":56},"520":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":8,"SPN":520,"SPN_Name":"Actual Retarder - Percent Torque","SPN_Description":"Actual braking torque of the retarder as a percent of retarder configuration reference torque SPN 556.\\r\\n\\r\\nNote:  Refer to section 5.2.1 in SAE J1939-71.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"521":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":8,"SPN":521,"SPN_Name":"Brake Pedal Position","SPN_Description":"Ratio of brake pedal position to maximum pedal position.  Used for electric brake applications. 0% means no braking. Also when there are two brake pedals on the machine (Left Brake Pedal Position SPN 3033 and Right Brake Pedal Position SPN 3032) the maximum of the two should be transmitted for Brake Pedal Position.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"522":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":24,"SPN":522,"SPN_Name":"Percent Clutch Slip","SPN_Description":"Parameter which represents the ratio of input shaft speed to current engine speed (in percent).\\r\\n\\r\\nPercent Clutch Slip = ((Engine rpm - Input shaft rpm)/(Engine rpm)) x 100","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"523":{"PGN":61445,"PGN_Name":"Electronic Transmission Controller 2","PGN_Description":"ETC2","first_bit":24,"SPN":523,"SPN_Name":"Transmission Current Gear","SPN_Description":"The gear currently engaged in the transmission or the last gear engaged while the transmission is in the process of shifting to the new or selected gear.  Transitions toward a destination gear will not be indicated.  Once the selected gear has been engaged then Transmission Current Gear (SPN 523) will reflect that gear.","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"524":{"PGN":61445,"PGN_Name":"Electronic Transmission Controller 2","PGN_Description":"ETC2","first_bit":0,"SPN":524,"SPN_Name":"Transmission Selected Gear","SPN_Description":"The gear that the transmission will attempt to achieve during the current shift if a shift is in progress, or the next shift if one is pending (i.e., waiting for torque reduction to initiate the shift).","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"525":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":16,"SPN":525,"SPN_Name":"Transmission Requested Gear","SPN_Description":"Gear requested by the operator, ABS, or engine.\\r\\n\\r\\nNegative values are reverse gears, positive values are forward gears, zero is neutral, parameter specific indicators are listed below.\\r\\n\\r\\nParameter specific values for this parameter are as follows:\\r\\n0xFD (253 dec) = Hold current gear\\r\\n0xFC (252 dec) = Forward Drive Position\\r\\n0xFB (251 dec) = \u2018Park\u2019 position\\r\\n0xFA (250 dec) = Forward \u2018Low\u2019 position\\r\\n0xF9 (249 dec) = Upshift 1 gear from current position\\r\\n0xF8 (248 dec) = Upshift 2 gears from current position\\r\\n0xF7 (247 dec) = Downshift 1 gear from current position\\r\\n0xF6 (246 dec) = Downshift 2 gears from current position\\r\\n0xF5 (245 dec) = D-1: 1st forward selector position referenced from \u2018Drive\u2019\\r\\n0xF4 (244 dec) = D-2: 2nd forward selector position referenced from \u2018Drive\u2019\\r\\n0xF3 (243 dec) = D-3: 3rd forward selector position referenced from \u2018Drive\u2019\\r\\n0xF2 (242 dec) = D-4: 4th forward selector position referenced from \u2018Drive\u2019\\r\\n0xF1 (241 dec) = D-5: 5th forward selector position referenced from \u2018Drive\u2019\\r\\n0xF0 (240 dec) = D-6: 6th forward selector position referenced from \u2018Drive\u2019\\r\\n0xEF (239 dec) = D-7: 7th forward selector position referenced from \u2018Drive\u2019\\r\\n0xEE (238 dec) = Between two shift selector positions (if detail is unknown)\\r\\n0xED (237 dec) = Between two reverse shift selector positions\\r\\n0xEC (236 dec) = Between two forward shift selector positions\\r\\n0xEB (235 dec) = Between D-7 and D-6 shift selector positions\\r\\n0xEA (234 dec) = Between D-6 and D-5 shift selector positions\\r\\n0xE9 (233 dec) = Between D-5 and D-4 shift selector positions\\r\\n0xE8 (232 dec) = Between D-4 and D-3 shift selector positions\\r\\n0xE7 (231 dec) = Between D-3 and D-2 shift selector positions\\r\\n0xE6 (230 dec) = Between D-2 and D-1 shift selector positions\\r\\n0xE5 (229 dec) = Between D-1 and \u2018Drive\u2019 shift selector positions\\r\\n0xE4 (228 dec) = Between \u2018Drive\u2019 and \u2018Neutral\u2019 shift selector positions\\r\\n0xE3 (227 dec) = Between \u2018Neutral\u2019 and \u2018Reverse\u2019 shift selector positions\\r\\n0xE2 (226 dec) = Between \u2018Reverse\u2019 and \u2018Park\u2019 shift selector positions\\r\\n0xE1 (225 dec) = Press of momentary button to reselect current position\\r\\n0xE0 (224 dec) = Position unknown and/or no buttons pressed\\r\\n0xDF (223 dec) = Reverse Selector Position\\r\\n\\r\\n0xDE - 0xBE  (222 dec - 190 dec) = Reserved\\r\\n0x3C - 0x00   (60 dec  - 0 dec)  = Reserved\\r\\n\\r\\nForward selector position from drive (0xF5 to 0xEF) \u2013 Indicates shift selector position in reference to the \u2018Drive\u2019 position on the selector.  It is possible that the shift selector software may not know the number of forward ranges.  The shift selector may identify the position selected by the operator while the transmission ECU determines what range or gear that represents.  If there is a digital display, the transmission ECU would communicate what is to be displayed via another message such as ETC#2 or ETC#7.\\r\\n\\r\\nFor example:  Consider a vehicle with a 5-speed automatic transmission with the shift lever on the column. Suppose that shift selector has a limited number of positions, such that having positions for D-4-3-2-1 is not an option. For this example, assume there are only have enough lever positions for D-3-2-1. Pulling the lever into \\"D\\" will put the transmission in 5th (highest gear).  It is desired that pulling the lever to the physical \u201C3\u201D position will limit the transmission to a maximum range of 3rd gear.\\r\\n\\r\\nWhen the selector is pulled down into \\"3\\", the shifter selector itself has no way of correlating this physical lever position to the desired gear; it would have to be calibrated with software to tell it this information. If not calibrated, the shift selector cannot directly command the transmission to go to 3rd gear; it only knows it\'s one notch below drive.\\r\\n\\r\\nHowever, if \\"D-1\\" (lever position, as opposed to desired gear) is broadcast by the selector, the transmission ECU can receive this and then make the determination of what range is desired. The benefit is that no specific calibration of the shift selector is required. \\r\\n\\r\\nBetween selector positions (0xEE to 0xE2) \u2013 Indicates the shift selector is not in an appropriate position.  If a lever-type shift selector with a mechanical display is stuck between detents, it may appear to the operator that it is in the desired position when in fact it is not. The shift selector may be capable of reporting only that it is between positions or that it is between forward or reverse positions. If known, the transmission ECU may respond differently depending on which positions are involved.\\r\\n\\r\\nReselect current position (0xE1) - If the TC1 message continues to send the position last selected, then a capability to reselect the same position is required.  For example:  If a \u2018Neutral to Drive\u2019 shift is selected and that shift is inhibited (say for high engine speed), it may be necessary for the operator to reselect \u2018Drive\u2019 after the inhibit conditions pass in order for the transmission ECU to honor the request.\\r\\n\\r\\nPosition unknown and/or no buttons pressed (0xE0) - A push-button style shift selector with momentary contact buttons may send this indicator after initialization before any buttons are pressed, or before the transmission ECU determines and communicates the initial selection.  This indicator could also be sent between button presses as an alternative to sending the last button press.","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"526":{"PGN":61445,"PGN_Name":"Electronic Transmission Controller 2","PGN_Description":"ETC2","first_bit":8,"SPN":526,"SPN_Name":"Transmission Actual Gear Ratio","SPN_Description":"Actual ratio of input shaft speed to output shaft speed.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"527":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":53,"SPN":527,"SPN_Name":"Cruise Control States","SPN_Description":"This parameter is used to indicate the current state, or mode, of operation by the cruise control device.  This is a status parameter.\\r\\n\\r\\n000 - Off/Disabled\\r\\n001 - Hold\\r\\n010 - Accelerate\\r\\n011 - Decelerate\\r\\n100 - Resume\\r\\n101 - Set\\r\\n110 - Accelerator Override\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"528":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":24,"SPN":528,"SPN_Name":"Engine Speed At Point 2","SPN_Description":"Engine speed of point 2 of the engine torque map (see PGN 65251 and supporting document).  In engine configuration mode 1 and 3, point 2 is defined as the kick-in point from which torque is reduced to zero.  In mode 2 (see Table PGN65251_A), there are no special requirements for the definition of this point.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"529":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":48,"SPN":529,"SPN_Name":"Engine Speed At Point 3","SPN_Description":"Engine speed of point 3, 4, and 5 of the engine torque map (see PGN 65251 and supporting document).  It is recommended that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 are optional and lie between idle and point 2.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"530":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":72,"SPN":530,"SPN_Name":"Engine Speed At Point 4","SPN_Description":"Engine speed of point 3, 4, and 5 of the engine torque map (see PGN 65251 and supporting document).  It is recommended that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 are optional and lie between idle and point 2.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"531":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":96,"SPN":531,"SPN_Name":"Engine Speed At Point 5","SPN_Description":"Engine speed of point 3, 4, and 5 of the engine torque map (see PGN 65251 and supporting document).  It is recommended that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 are optional and lie between idle and point 2.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"532":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":120,"SPN":532,"SPN_Name":"Engine Speed At High Idle, Point 6","SPN_Description":"Engine speed of high idle (point 6) of the engine torque map (see PGN 65251 and supporting document).  In engine configuration mode 3 (see Figure PGN65251_C), point 6 is not defined by the engine torque map but by the governor characteristic and the zero torque line.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"533":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":168,"SPN":533,"SPN_Name":"Engine Maximum Momentary Override Speed, Point 7","SPN_Description":"The maximum engine speed above high idle allowed by the engine control during a momentary high idle override.  This duration of the override is limited by the maximum momentary override time limit, SPN 534.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"534":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":184,"SPN":534,"SPN_Name":"Engine Maximum Momentary Override Time Limit","SPN_Description":"The maximum time limit allowed to override the engine\'s high idle speed.","bit_length":8,"scaling":0.1,"offset":0,"unit":"s","SLOT_ID":59},"535":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":192,"SPN":535,"SPN_Name":"Engine Requested Speed Control Range Lower Limit","SPN_Description":"The minimum engine speed that the engine will allow when operating in a speed control/limit mode.","bit_length":8,"scaling":10,"offset":0,"unit":"rpm","SLOT_ID":79},"536":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":200,"SPN":536,"SPN_Name":"Engine Requested Speed Control Range Upper Limit","SPN_Description":"The maximum engine speed regardless of load that the engine will allow when operating in a speed control/limit mode, excluding any maximum momentary engine override speed, if supported.","bit_length":8,"scaling":10,"offset":0,"unit":"rpm","SLOT_ID":79},"537":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":208,"SPN":537,"SPN_Name":"Engine Requested Torque Control Range Lower Limit","SPN_Description":"The minimum engine torque that the engine will allow when operating in a torque control/limit mode.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"538":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":216,"SPN":538,"SPN_Name":"Engine Requested Torque Control Range Upper Limit","SPN_Description":"The maximum engine torque that the engine will allow when operating in a torque control/limit mode.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"539":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":16,"SPN":539,"SPN_Name":"Engine Percent Torque At Idle, Point 1","SPN_Description":"The torque limit that indicates the available engine torque which can be provided by the engine at idle speed.  This parameter may be influenced by engine temperature (after power up) and other stationary changes (calibration offsets, sensor failures, etc.)  See also SPN 188.  The data is transmitted in indicated torque as a percent of the reference engine torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"540":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":40,"SPN":540,"SPN_Name":"Engine Percent Torque At Point 2","SPN_Description":"The torque limit that indicates the available engine torque which can be provided by the engine at point 2 of the engine map (see PGN 65251 and supporting documents).  In engine configuration mode 1 and 3 (see Table PGN65251_A see PGN 65251), point 2 is defined as the kick-in point from which torque is reduced to zero.  In mode 2, there are no special requirements for the definition of this point.  The data is transmitted in indicated torque as a percent of the reference engine torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"541":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":64,"SPN":541,"SPN_Name":"Engine Percent Torque At Point 3","SPN_Description":"The torque limit that indicates the available engine torque which can be provided by the engine at point 3, 4, and 5 of the engine map (see PGN 65251 and supporting documents)..  It is required that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 lie between idle and point 2.  The data is transmitted in indicated torque as a percent of the reference engine torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"542":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":88,"SPN":542,"SPN_Name":"Engine Percent Torque At Point 4","SPN_Description":"The torque limit that indicates the available engine torque which can be provided by the engine at point 3, 4, and 5 of the engine map (see PGN 65251 and supporting documents).  It is required that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 lie between idle and point 2.  The data is transmitted in indicated torque as a percent of the reference engine torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"543":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":112,"SPN":543,"SPN_Name":"Engine Percent Torque At Point 5","SPN_Description":"The torque limit that indicates the available engine torque which can be provided by the engine at point 3, 4, and 5 of the engine map (see PGN 65251 and supporting documents).  It is required that one of these points indicate the peak torque point for the current engine torque map.  Points 3, 4, and 5 lie between idle and point 2.  The data is transmitted in indicated torque as a percent of the reference engine torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"544":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":152,"SPN":544,"SPN_Name":"Engine Reference Torque","SPN_Description":"This parameter is the 100% reference value for all defined indicated engine torque parameters.  It is only defined once and doesn\'t change if a different engine torque map becomes valid.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"545":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":136,"SPN":545,"SPN_Name":"Engine Gain (Kp) Of The Endspeed Governor","SPN_Description":"The endspeed governor is defined as a linear line with the following equations (Capital letters mean physical values, small letters mean normalized values).  Refer to Figures PGN65251_A and PGN65251_B.\\r\\n\\r\\nThe gain KP/kp is defined as a positive value.  The factor 4096 is necessary for realizing flat curves with sufficient resolution as well as very steep curves.\\r\\n\\r\\nKP = delta Torque / delta Speed\\r\\nkp (normalized) = KP * 250/100% * 8031 rpm/64255 * 4096 = KP * 1280 rpm/%","bit_length":16,"scaling":0.00078125,"offset":0,"unit":"%/rpm","SLOT_ID":22},"546":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":16,"SPN":546,"SPN_Name":"Retarder Speed At Idle, Point 1","SPN_Description":"Please reference PGN 65249","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"547":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":112,"SPN":547,"SPN_Name":"Retarder Speed At Peak Torque, Point 5","SPN_Description":"Please reference PGN 65249","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"548":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":40,"SPN":548,"SPN_Name":"Maximum Retarder Speed, Point 2","SPN_Description":"Maximum speed of retarder (Please reference PGN 65249).","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"549":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":64,"SPN":549,"SPN_Name":"Retarder Speed At Point 3","SPN_Description":"Retarder speed of point 3 of the engine retarder torque map.  Please reference PGN 65249.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"550":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":88,"SPN":550,"SPN_Name":"Retarder Speed At Point 4","SPN_Description":"Retarder speed of point 4 of the engine retarder torque map.  Please reference PGN 65249.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"551":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":32,"SPN":551,"SPN_Name":"Retarder Percent Torque At Idle, Point 1","SPN_Description":"The torque limit that indicates the available retarder torque which can be provided by the retarder at idle speed.  The data is transmitted in indicated torque as a percent of the reference retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"552":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":56,"SPN":552,"SPN_Name":"Retarder Percent Torque At Maximum Speed, Point 2","SPN_Description":"The torque limit that indicates the available retarder torque which can be provided by the retarder at its maximum speed.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"553":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":80,"SPN":553,"SPN_Name":"Retarder Percent Torque At Point 3","SPN_Description":"The torque limit that indicates the available retarder torque which can be provided by the retarder at points 3 and 4 of the retarder torque map.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"554":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":104,"SPN":554,"SPN_Name":"Retarder Percent Torque At Point 4","SPN_Description":"The torque limit that indicates the available retarder torque which can be provided by the retarder at points 3 and 4 of the retarder torque map.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"555":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":144,"SPN":555,"SPN_Name":"Retarder Percent Torque At Peak Torque, Point 5","SPN_Description":"The torque limit that indicates the available retarder torque which can be provided by the retarder at point 5 of the retarder torque map.  Please reference PGN 65249.  The data is transmitted in indicated torque as a percent of the reference retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"556":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":128,"SPN":556,"SPN_Name":"Retarder Reference Torque","SPN_Description":"This parameter is the 100% reference value for all defined indicated retarder torque parameters.  It is only defined once and doesn\'t change if a different retarder torque map becomes valid.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"557":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":8,"SPN":557,"SPN_Name":"Retarder Control Method","SPN_Description":"This parameter identifies the number of steps used by the retarder.","bit_length":8,"scaling":1,"offset":0,"unit":"step","SLOT_ID":84},"558":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":0,"SPN":558,"SPN_Name":"Accelerator Pedal 1 Low Idle Switch","SPN_Description":"Switch signal which indicates the state of the accelerator pedal 1 low idle switch.  The low idle switch is defined in SAE Recommended Practice J1843.\\r\\n  \\r\\n00 - Accelerator pedal 1 not in low idle condition\\r\\n01 - Accelerator pedal 1 in low idle condition\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"559":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":2,"SPN":559,"SPN_Name":"Accelerator Pedal Kickdown Switch","SPN_Description":"Switch signal which indicates whether the accelerator pedal kickdown switch is opened or closed.  The kickdown switch is defined in SAE J1843.\\r\\n\\r\\n00 - Kickdown passive\\r\\n01 - Kickdown active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"560":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":0,"SPN":560,"SPN_Name":"Transmission Driveline Engaged","SPN_Description":"Driveline engaged indicates the transmission controlled portion of the driveline is engaged sufficiently to allow a transfer of torque through the transmission.  Driveline engaged is ACTIVE whenever the transmission is in gear and the clutch (if controlled by the transmission controller) is less than 100% clutch slip (clutch able to transfer torque).  This parameter should be used in conjunction with the parameter \u201CShift in Process\u201D (SPN 574).  While a shift is in process, the receiver should not assume that the driveline is either fully engaged or disengaged (i.e., cruise control).\\r\\n\\r\\n00 - Driveline disengaged\\r\\n01 - Driveline engaged\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"561":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":0,"SPN":561,"SPN_Name":"ASR Engine Control Active","SPN_Description":"State signal which indicates that ASR engine control has been commanded to be active. Active means that ASR actually tries to control the engine. This state signal is independent of other control commands to the engine (e.g., from the transmission) which may have higher priority.\\r\\n\\r\\n00 - ASR engine control passive but installed\\r\\n01 - ASR engine control active\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"562":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":2,"SPN":562,"SPN_Name":"ASR Brake Control Active","SPN_Description":"State signal which indicates that ASR brake control is active. Active means that ASR actually controls wheel brake pressure at one or more wheels of the driven axle(s).\\r\\n\\r\\n00 - ASR brake control passive but installed\\r\\n01 - ASR brake control active\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"563":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":4,"SPN":563,"SPN_Name":"Anti-Lock Braking (ABS) Active","SPN_Description":"State signal which indicates that the ABS is active.  The signal is set active when wheel brake pressure actually starts to be modulated by ABS and is reset to passive when all wheels are in a stable condition for a certain time.  The signal can also be set active when driven wheels are in high slip  (e.g., caused by retarder).  Whenever the ABS system is not fully operational (due to a defect or during off-road ABS operation) , this signal is only valid for that part of the system that is still working.  When ABS is switched off completely, the flag is set to passive regardless of the current wheel slip conditions.\\r\\n\\r\\n00 - ABS passive but installed\\r\\n01 - ABS active\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"564":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":16,"SPN":564,"SPN_Name":"Differential Lock State - Central","SPN_Description":"State used which indicates the condition of the central differential lock.  The differential locks are located as defined in attached figure SPN564_A.\\r\\n\\r\\n00 Differential lock disengaged\\r\\n01 Differential lock engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"565":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":18,"SPN":565,"SPN_Name":"Differential Lock State - Central Front","SPN_Description":"State used which indicates the condition of the central front differential lock.  The differential locks are located as defined in figure SPN564_A.\\r\\n\\r\\n00 Differential lock disengaged\\r\\n01 Differential lock engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"566":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":20,"SPN":566,"SPN_Name":"Differential Lock State - Central Rear","SPN_Description":"State used which indicates the condition of the central rear differential lock.  The differential locks are located as defined in figure SPN564_A.\\r\\n\\r\\n00 Differential lock disengaged\\r\\n01 Differential lock engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"567":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":8,"SPN":567,"SPN_Name":"Differential Lock State - Front Axle 1","SPN_Description":"State used which indicates the condition of the front axle 1 differential lock.  The differential locks are located as defined in figure SPN564_A.\\r\\n\\r\\n00 Differential lock disengaged\\r\\n01 Differential lock engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"568":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":10,"SPN":568,"SPN_Name":"Differential Lock State - Front Axle 2","SPN_Description":"State used which indicates the condition of the front axle 2 differential lock. The differential locks are located as defined in figure SPN 564_A.\\r\\n\\r\\n00 Differential lock disengaged\\r\\n01 Differential lock engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"569":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":12,"SPN":569,"SPN_Name":"Differential Lock State - Rear Axle 1","SPN_Description":"State used which indicates the condition of the rear axle 1 differential lock.  The differential locks are located as defined in figure SPN 564_A.\\r\\n\\r\\n00 Differential lock disengaged\\r\\n01 Differential lock engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"570":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":14,"SPN":570,"SPN_Name":"Differential Lock State - Rear Axle 2","SPN_Description":"State used which indicates the condition of the rear axle 2 differential lock.  The differential locks are located as defined in figure SPN 564_A.\\r\\n\\r\\n00 Differential lock disengaged\\r\\n01 Differential lock engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"571":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":4,"SPN":571,"SPN_Name":"Retarder Enable - Brake Assist Switch","SPN_Description":"Switch signal which indicates whether the operator wishes the retarder to be enabled for vehicle braking assist. The retarder does not check this switch, nor does the enabling of this switch engage the retarder. When this switch is \u201Cenabled,\u201D the devices constructing TSC1 \u2013 destination retarder messages may command retarder torque for braking. For example, the cruise control should not request retarder torque if this switch is not \u201Cenabled.\u201D The switch exists to prevent the engine retarder from being asked to be engaged via TSC1 in a noise sensitive area. See also SPN 572\\r\\n\\r\\n00 Retarder - brake assist disabled\\r\\n01 Retarder - brake assist enabled\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"572":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":6,"SPN":572,"SPN_Name":"Retarder Enable - Shift Assist Switch","SPN_Description":"Switch signal which indicates whether the operator wishes the retarder to be enabled for transmission shift assist.  The retarder does not check this switch, nor does the enabling of this switch engage the retarder.  When this switch is \u201Cenabled,\u201D the transmission may activate the retarder (via the TSC1 message) to increase the rate of engine deceleration to assist in shift control.  The switch exists to prevent the engine retarder from being asked to be engaged via TSC1 in a noise sensitive area.  See SPN 571.\\r\\n\\r\\n00 Retarder - shift assist disabled\\r\\n01 Retarder - shift assist enabled\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"573":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":2,"SPN":573,"SPN_Name":"Transmission Torque Converter Lockup Engaged","SPN_Description":"State signal which indicates whether the torque converter lockup is engaged.\\r\\n\\r\\n00 Torque converter lockup disengaged\\r\\n01 Torque converter lockup engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"574":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":4,"SPN":574,"SPN_Name":"Transmission Shift In Process","SPN_Description":"Indicates that the transmission is in process of shifting from the current gear to the selected gear. This state is generally ACTIVE during the entire time that the transmission controls the vehicle during a shift. This includes any transmission clutch control, all engine control sequences, pulling to transmission neutral, and engaging the destination gear (e.g., until it is no longer sending commands and/or limits to the engine). See also SPN 560. (See Figure SPN574_A)\\r\\n\\r\\nThis state is INACTIVE during other engine control such as torque limiting outside of a shift.\\r\\n\\r\\n00  -  Shift is not in process \\r\\n01  -  Shift in process\\r\\n10  -  Error\\r\\n11  -  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"575":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":16,"SPN":575,"SPN_Name":"ABS Off-road Switch","SPN_Description":"Switch signal which indicates the position of the ABS off-road switch.\\r\\n\\r\\n00 - ABS off-road switch passive\\r\\n01 - ABS off-road switch active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"576":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":18,"SPN":576,"SPN_Name":"ASR Off-road Switch","SPN_Description":"Switch signal which indicates the position of the ASR off-road switch.\\r\\n\\r\\n00 - ASR off-road switch passive\\r\\n01 - ASR off-road switch active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"577":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":20,"SPN":577,"SPN_Name":"ASR \\"Hill Holder\\" Switch","SPN_Description":"Switch signal which indicates the position of the ASR \u201Chill holder\u201D switch.\\r\\n\\r\\n00 - ASR \u201Chill holder\u201D switch passive\\r\\n01 - ASR \u201Chill holder\u201D switch active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"578":{"PGN":65273,"PGN_Name":"Axle Information","PGN_Description":"AI","first_bit":24,"SPN":578,"SPN_Name":"Drive Axle Temperature","SPN_Description":"Temperature of axle lubricant in drive axle.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"579":{"PGN":65273,"PGN_Name":"Axle Information","PGN_Description":"AI","first_bit":16,"SPN":579,"SPN_Name":"Drive Axle Lift Air Pressure","SPN_Description":"Gage pressure of air in system that utilizes compressed air to provide force between axle and frame.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"580":{"PGN":65256,"PGN_Name":"Vehicle Direction/Speed","PGN_Description":"VDS","first_bit":48,"SPN":580,"SPN_Name":"Altitude","SPN_Description":"Altitude of the vehicle referenced to sea level at standard atmospheric pressure and temperature.","bit_length":16,"scaling":0.125,"offset":-2500,"unit":"m","SLOT_ID":39},"581":{"PGN":65250,"PGN_Name":"Transmission Configuration","PGN_Description":"TCFG","first_bit":16,"SPN":581,"SPN_Name":"Transmission Gear Ratio","SPN_Description":"The transmission configuration describes the number of forward gears, the number of reverse gears, and the ratio of each gear with the following resolution.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"582":{"PGN":65258,"PGN_Name":"Vehicle Weight","PGN_Description":"VW","first_bit":8,"SPN":582,"SPN_Name":"Axle Weight","SPN_Description":"Total mass imposed by the tires on the road surface at the specified axle.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":27},"583":{"PGN":65256,"PGN_Name":"Vehicle Direction/Speed","PGN_Description":"VDS","first_bit":32,"SPN":583,"SPN_Name":"Pitch","SPN_Description":"Pitch (rotation about the y-axis) of the vehicle as calculated by the navigation device(s).  The pitch angle for an angle of ascent is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"584":{"PGN":65267,"PGN_Name":"Vehicle Position 1","PGN_Description":"VP1","first_bit":0,"SPN":584,"SPN_Name":"Latitude","SPN_Description":"Latitude position of the vehicle.","bit_length":32,"scaling":1e-7,"offset":-210,"unit":"deg","SLOT_ID":7},"585":{"PGN":65267,"PGN_Name":"Vehicle Position 1","PGN_Description":"VP1","first_bit":32,"SPN":585,"SPN_Name":"Longitude","SPN_Description":"Longitude position of the vehicle.","bit_length":32,"scaling":1e-7,"offset":-210,"unit":"deg","SLOT_ID":7},"589":{"PGN":65237,"PGN_Name":"Alternator Information","PGN_Description":"AS","first_bit":0,"SPN":589,"SPN_Name":"Alternator Speed","SPN_Description":"Actual rotation speed of the alternator.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"590":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":6,"SPN":590,"SPN_Name":"Engine Idle Shutdown Timer State","SPN_Description":"Status signal which indicates the current mode of operation of the idle shutdown timer system.  See Figure SPN590_A.\\r\\n\\r\\n00 - Inactive\\r\\n01 - Active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"591":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":14,"SPN":591,"SPN_Name":"Engine Idle Shutdown Timer Function","SPN_Description":"Parameter which indicates the configuration of the idle shutdown timer system.\\r\\n\\r\\n00 - Disabled in calibration\\r\\n01 - Enabled in calibration\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"592":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":4,"SPN":592,"SPN_Name":"Engine Idle Shutdown Timer Override","SPN_Description":"Status signal which indicates the status of the override feature of the idle shutdown timer system.  See Figure SPN590_A.\\r\\n\\r\\n00 - Inactive\\r\\n01 - Active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"593":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":0,"SPN":593,"SPN_Name":"Engine Idle Shutdown has Shutdown Engine","SPN_Description":"Status signal which identifies whether or not the engine has been shutdown by the idle shutdown timer system.  See Figure SPN590_A.\\r\\n\\r\\n00 - No\\r\\n01 - Yes\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"594":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":2,"SPN":594,"SPN_Name":"Engine Idle Shutdown Driver Alert Mode","SPN_Description":"Status signal which indicates the status of the driver alert mode of the idle shutdown timer system.  While the driver alert mode is active, the idle shutdown timer may be overridden.  See Figure SPN590_A.\\r\\n\\r\\n00 - Inactive\\r\\n01 - Active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"595":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":24,"SPN":595,"SPN_Name":"Cruise Control Active","SPN_Description":"Cruise control is switched on.  It is not ensured that the engine is controlled by cruise control, as in the case of a large driver\'s demand the engine is controlled by the driver while cruise control is active (maximum selection of cruise control and driver\u2019s demand).  The cruise control is set to 0 if a switch off condition occurs.\\r\\n\\r\\n00 - Cruise control switched off\\r\\n01 - Cruise control switched on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"596":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":26,"SPN":596,"SPN_Name":"Cruise Control Enable Switch","SPN_Description":"Switch signal which indicates that it is possible to manage the cruise control function.\\r\\n\\r\\n00 - Cruise control disabled\\r\\n01 - Cruise control enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"597":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":28,"SPN":597,"SPN_Name":"Brake Switch","SPN_Description":"Switch signal which indicates that the driver operated brake foot pedal is being pressed.  This brake foot pedal is controlling the vehicles\u2019 service brake (total vehicle braking application, not park brakes).  It is necessary for safe drivetrain behavior that the switch activates before the physical braking components are activated (i.e. Disengage the cruise control function prior to the activation of friction brakes).\\r\\n\\r\\n00 - Brake pedal released\\r\\n01 - Brake pedal depressed\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"598":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":30,"SPN":598,"SPN_Name":"Clutch Switch","SPN_Description":"Switch signal which indicates that the clutch pedal is being pressed. It is necessary for a safe drivetrain behavior that the clutch switch is set before the clutch is opened (cruise control function).\\r\\n\\r\\n00 - Clutch pedal released\\r\\n01 - Clutch pedal depressed\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"599":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":32,"SPN":599,"SPN_Name":"Cruise Control Set Switch","SPN_Description":"Switch signal of the cruise control activator which indicates that the activator is in the position \u201Cset.\u201D\\r\\n\\r\\n00 - Cruise control activator not in the position \u201Cset\u201D\\r\\n01 - Cruise control activator in position \u201Cset\u201D\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"600":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":34,"SPN":600,"SPN_Name":"Cruise Control Coast (Decelerate) Switch","SPN_Description":"Switch signal of the cruise control activator which indicates that the activator is in the position \u201Ccoast (decelerate).\u201D\\r\\n\\r\\n00 - Cruise control activator not in the position \u201Ccoast\u201D\\r\\n01 - Cruise control activator in position \u201Ccoast\u201D\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"601":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":36,"SPN":601,"SPN_Name":"Cruise Control Resume Switch","SPN_Description":"Switch signal of the cruise control activator which indicates that the activator is in the position \u201Cresume.\u201D\\r\\n\\r\\n00 - Cruise control activator not in the position \u201Cresume\u201D\\r\\n01 - Cruise control activator in position \u201Cresume\u201D\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"602":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":38,"SPN":602,"SPN_Name":"Cruise Control Accelerate Switch","SPN_Description":"Switch signal of the cruise control activator which indicates that the activator is in the position \u201Caccelerate.\u201D\\r\\n\\r\\n00 - Cruise control activator not in the position \u201Caccelerate\u201D\\r\\n01 - Cruise control activator in position \u201Caccelerate\u201D\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"604":{"PGN":65219,"PGN_Name":"Electronic Transmission Controller 5","PGN_Description":"ETC5","first_bit":10,"SPN":604,"SPN_Name":"Transmission Neutral Switch","SPN_Description":"Identifies the status of the switch that indicates neutral.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"605":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":20,"SPN":605,"SPN_Name":"Refrigerant High Pressure Switch","SPN_Description":"Switch signal which indicates the position of the high pressure switch in the coolant circuit of an air conditioning system.  When the switch is enabled, the pressure inside the circuit is too high and the compressor clutch may be disengaged.\\r\\n\\r\\n00 - Pressure normal\\r\\n01 - Pressure too high, compressor clutch may be disengaged\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"606":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":32,"SPN":606,"SPN_Name":"Engine Momentary Overspeed Enable","SPN_Description":"Command signal used to indicate that the engine speed may be boosted up to the maximum engine overspeed value to accommodate transmission downshifts.  The maximum time for overspeed is limited by the time defined in the engine configuration message (see PGN 65,251).  The transmission module must command a \u201Coverride disabled\u201D state at least once before the engine will accept a subsequent request for overspeed.\\r\\n\\r\\n00 Momentary engine overspeed is disabled\\r\\n01 Momentary engine overspeed is enabled\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"607":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":34,"SPN":607,"SPN_Name":"Progressive Shift Disable","SPN_Description":"Command signal used to indicate that progressive shifting by the engine should be disallowed.\\r\\n\\r\\n00 Progressive shift is not disabled\\r\\n01 Progressive shift is disabled\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"619":{"PGN":65274,"PGN_Name":"Brakes 1","PGN_Description":"B1","first_bit":24,"SPN":619,"SPN_Name":"Parking Brake Actuator","SPN_Description":"Signal which indicates the current state of the actuator(s) that control the parking brake (see also SPN 70 and 5275).\\r\\n\\r\\n00 - Parking brake actuator inactive\\r\\n01 - Parking brake actuator active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"626":{"PGN":64966,"PGN_Name":"Cold Start Aids","PGN_Description":"CSA","first_bit":0,"SPN":626,"SPN_Name":"Engine Start Enable Device 1","SPN_Description":"Devices that assist an Engine in starting, e.g. intake heaters and ether.  Primary starting aid.\\r\\nParameter indicating whether the start enable device 1 is ON or OFF\\r\\n\\r\\n00 - start enable OFF\\r\\n01 - start enable ON\\r\\n10 - reserved\\r\\n11 - not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"632":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":26,"SPN":632,"SPN_Name":"Engine Fuel Shutoff 1 Control","SPN_Description":"Control setting for fuel shutoff 1.  The second instance is SPN 2807.  For a single fuel shutoff system, this represents its commanded position.  For a dual fuel shutoff system, this SPN is representative of the upstream fuel shutoff commanded position.  When fuel (gas) is desired at the engine, the fuel shutoff is opened.  Otherwise, it is closed.\\r\\n\\r\\n00 = Open (fuel supplied to engine)\\r\\n01 = Closed (no fuel supplied to engine)\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action\\r\\n\\r\\nIn addition to communicating desired action of fuel shutoff 1 and its driver status, this new SPN can be used to communicate whether fuel shutoff 1 feedback position (if available) matches the commanded position, through the use of FMIs.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"633":{"PGN":61466,"PGN_Name":"Engine Throttle / Fuel Actuator Control Command","PGN_Description":"TFAC","first_bit":32,"SPN":633,"SPN_Name":"Engine Fuel Actuator 1 Control Command","SPN_Description":"The control command to fuel actuator 1, normalized to percent, where 0% represents fully closed and 100% represents fully open. In applications where the fuel actuator controls to differential pressure, 0% represents minimum differential pressure and 100% represents maximum differential pressure. Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position. If only 2 actuators are present, then left/front is #1 (SPN 633) and right/rear is #2 (SPN 1244). If more than two actuators are present, then left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).\\r\\n\\r\\nThe values of 0xFB00 - 0xFB64 are sent to initiate the self calibration of the fuel actuator. The LSB specifies the % to calibrate to with a resolution of 1%/bit (eg, 0xFB32 is sent to calibrate the actuator to 50%). In the case of a differential pressure control, this calibration is in terms of differential pressure.\\r\\n\\r\\nThe value of 0xFBFF is sent to command the fully closed position for differential pressure control applications.\\r\\n\\r\\nNote:  Existing applications of this SPN may not support the calibration or forced closure features.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"635":{"PGN":64670,"PGN_Name":"Engine Timing Actuator Position","PGN_Description":"ETAP","first_bit":0,"SPN":635,"SPN_Name":"Engine Timing Actuator 1","SPN_Description":"The detected position of actuator 1 on the Engine Timing System, where the system has different timing positions depending on current operating status of the engine. Timing positions may be used to determine intake and outlet valve timings.\\r\\n\\r\\n000 - Unknown Position\\r\\n001 - Diesel Mode Position\\r\\n010 - Diesel Part Load Position\\r\\n011 - Gas Mode Position\\r\\n100 - Diesel Part Load / Gas Mode Position\\r\\n101 - 110 - Reserved\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"641":{"PGN":64931,"PGN_Name":"Electronic Engine Controller 6","PGN_Description":"EEC6","first_bit":16,"SPN":641,"SPN_Name":"Engine Variable Geometry Turbocharger Actuator #1","SPN_Description":"Actuator that controls the variable geometry turbocharger geometry.The control command to the actuator, normalized to percent, where 0% nominally represents fully closed (smallest turbocharger geometry) and 100% represents fully open (largest geometry turbocharger).","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"649":{"PGN":61486,"PGN_Name":"Engine Turbocharger Control","PGN_Description":"ETCC","first_bit":32,"SPN":649,"SPN_Name":"Engine Exhaust Bank 1 Pressure Regulator Control Command","SPN_Description":"The control command to the Engine Exhaust Pressure Regulator in bank 1, normalized to percent.  100 percent means the regulator is fully closed, providing the maximum restriction to exhaust gas flow from the engine.  Zero percent means the regulator is fully open, providing the minimum available restriction.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"681":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":0,"SPN":681,"SPN_Name":"Transmission Gear Shift Inhibit Request","SPN_Description":"Command signal to inhibit gear shifts.\\r\\n\\r\\n00 Gear shifts are allowed  (disable function)\\r\\n01 Gear shifts are inhibited  (enable function)\\r\\n10 Reserved\\r\\n11 Take no action  (leave function as is)","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"682":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":2,"SPN":682,"SPN_Name":"Transmission Torque Converter Lockup Disable Request","SPN_Description":"Command signal to prevent torque converter lockup, which may cause problems in certain circumstances for ASR.\\r\\n\\r\\n00 Allow torque converter lockup\\r\\n01 Disable torque converter lockup\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"683":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":4,"SPN":683,"SPN_Name":"Disengage Driveline Request","SPN_Description":"Command signal used to simply disengage the driveline, e.g., to prevent engine drag torque from causing high wheel slip on slippery surfaces.\\r\\n\\r\\n00 Allow driveline engagement\\r\\n01 Disengage driveline\\r\\n10 Reserved\\r\\n11 Take no action\\r\\n\\r\\nNote:  If this signal is used to disengage the driveline for fuel economy purposes, the sender should consider SPN 7430 PCC Driveline Disengage Inhibit Request.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"684":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":8,"SPN":684,"SPN_Name":"Requested Percent Clutch Slip","SPN_Description":"Parameter which represents the percent clutch slip requested by a device.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"685":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":24,"SPN":685,"SPN_Name":"Disengage Differential Lock Request - Front Axle 1","SPN_Description":"Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\\r\\n\\r\\n00 Engage differential lock\\r\\n01 Disengage differential lock\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"686":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":26,"SPN":686,"SPN_Name":"Disengage Differential Lock Request - Front Axle 2","SPN_Description":"Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\\r\\n\\r\\n00 Engage differential lock\\r\\n01 Disengage differential lock\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"687":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":28,"SPN":687,"SPN_Name":"Disengage Differential Lock Request - Rear Axle 1","SPN_Description":"Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\\r\\n\\r\\n00 Engage differential lock\\r\\n01 Disengage differential lock\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"688":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":30,"SPN":688,"SPN_Name":"Disengage Differential Lock Request - Rear Axle 2","SPN_Description":"Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\\r\\n\\r\\n00 Engage differential lock\\r\\n01 Disengage differential lock\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"689":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":32,"SPN":689,"SPN_Name":"Disengage Differential Lock Request - Central","SPN_Description":"Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\\r\\n\\r\\n00 Engage differential lock\\r\\n01 Disengage differential lock\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"690":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":34,"SPN":690,"SPN_Name":"Disengage Differential Lock Request - Central Front","SPN_Description":"Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\\r\\n\\r\\n00 Engage differential lock\\r\\n01 Disengage differential lock\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"691":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":36,"SPN":691,"SPN_Name":"Disengage Differential Lock Request - Central Rear","SPN_Description":"Command signal used to disengage the various differential locks, e.g., to allow an undistributed individual wheel control by ABS.  The differential locks are located as defined in Figure SPN564_A.\\r\\n\\r\\n00 Engage differential lock\\r\\n01 Disengage differential lock\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"695":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":0,"SPN":695,"SPN_Name":"Engine Override Control Mode","SPN_Description":"The override control mode defines which sort of command is used:\\r\\n\\r\\n00 Override disabled - Disable any existing control commanded by the source of this command.\\r\\n01 Speed control - Govern speed to the included \u201Cdesired speed\u201D value.\\r\\n10 Torque control - Control torque to the included \u201Cdesired torque\u201D value.\\r\\n11 Speed/torque limit control - Limit speed and/or torque based on the included limit values.  The speed limit governor is a droop governor where the speed limit value defines the speed at the maximum torque available during this operation.\\r\\n\\r\\nIf a device wants to know whether it has access to the engine, there are several possibilities:\\r\\n\\r\\na. Comparing its command with the actual engine broadcasts.\\r\\nb. Looking at command modes from other devices.\\r\\nc. Looking to the engine and retarder torque mode.\\r\\n\\r\\nRemarks:\\r\\n\\r\\na. The realization of a torque limit (minimum selection) is possible by setting the speed limit to a high value (0xFAFF).\\r\\nb. The realization of a speed limit (minimum selection) is possible by setting the torque limit to a high value (0xFA).\\r\\nc. Limiting the retarder torque means to limit the magnitude of the torque request.  As the brake torque is represented by negative torque values, the limitation must be done by a maximum selection of the requested torque and the retarder internal torque signals.\\r\\nd. For torque increasing functions, time limits for the torque or speed value (command) and the direct modes are desirable.\\r\\n\\r\\ne. The selection of which device has control of the engine\'s speed or torque depends on the override mode priority (see SPN 897) with the highest priority device gaining control.  In the case of two devices with identical priority, the engine responds to speed/torque control commands over speed/torque limit commands and will act on the speed or torque commands on a first come, first served basis.  The torque limit will be a \u201Clowest wins\u201D selection (e.g., if one device commands 60% limit and another 80% limit, then the engine will limit torque to 60%).  Figure SPN695_A provides a flowchart of the torque/speed control priority selection logic.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"696":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":2,"SPN":696,"SPN_Name":"Engine Requested Speed Control Conditions","SPN_Description":"This mode tells the engine control system the governor characteristics that are desired during speed control.  The four characteristics defined are:\\r\\n\\r\\n00 Transient Optimized for driveline disengaged and non-lockup conditions\\r\\n01 Stability Optimized for driveline disengaged and non-lockup conditions\\r\\n10 Stability Optimized for driveline engaged and/or in lockup condition 1 (e.g., vehicle driveline)\\r\\n11 Stability Optimized for driveline engaged and/or in lockup condition 2 (e.g., PTO driveline)\\r\\n\\r\\n00b - This speed governor gain selection is adjusted to provide rapid transition between speed setpoints.  RPM overshoot and undershoot may be greater than what is seen when the \u201Cspeed control characteristic\u201D is set to be stability optimized.\\r\\n\\r\\n01b - This control condition has been optimized to minimize rpm overshoot and undershoot given an expected plant consisting of the engine and its accessory loads.  This gain adjustment is not intended to compensate for driveline characteristics.  This characteristic is most appropriate when no driveline is connected.\\r\\n\\r\\n10b - This control condition has been optimized to minimize rpm overshoot and undershoot given a more complex plant.  For instance, the more complex plant would contain the engine, its accessory loads and the driveline characteristics.  As an example, the driveline characteristics might include the effective spring mass relationship of pumps, tires, clutches, axles, driveshafts, and multiple gear ratios.  This characteristic is most appropriate when a driveline is engaged.\\r\\n\\r\\n11b - This speed control characteristic is available for applications requiring compensation for more than one driveline characteristic.  It has been optimized to minimize rpm overshoot and undershoot given a more complex plant of the second variety.  This more complex plant would again contain the engine, its accessory loads and a second driveline characteristic unique from the one described in speed control characteristic 10b.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"701":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":6,"SPN":701,"SPN_Name":"Auxiliary I/O #01","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"702":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":4,"SPN":702,"SPN_Name":"Auxiliary I/O #02","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"703":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":2,"SPN":703,"SPN_Name":"Auxiliary I/O #03","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"704":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":0,"SPN":704,"SPN_Name":"Auxiliary I/O #04","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"705":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":14,"SPN":705,"SPN_Name":"Auxiliary I/O #05","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"706":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":12,"SPN":706,"SPN_Name":"Auxiliary I/O #06","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"707":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":10,"SPN":707,"SPN_Name":"Auxiliary I/O #07","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"708":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":8,"SPN":708,"SPN_Name":"Auxiliary I/O #08","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"709":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":22,"SPN":709,"SPN_Name":"Auxiliary I/O #09","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"710":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":20,"SPN":710,"SPN_Name":"Auxiliary I/O #10","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"711":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":18,"SPN":711,"SPN_Name":"Auxiliary I/O #11","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"712":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":16,"SPN":712,"SPN_Name":"Auxiliary I/O #12","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"713":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":30,"SPN":713,"SPN_Name":"Auxiliary I/O #13","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"714":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":28,"SPN":714,"SPN_Name":"Auxiliary I/O #14","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"715":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":26,"SPN":715,"SPN_Name":"Auxiliary I/O #15","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"716":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":24,"SPN":716,"SPN_Name":"Auxiliary I/O #16","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"723":{"PGN":61473,"PGN_Name":"Engine Speed Sensor Information 1","PGN_Description":"ESSI1","first_bit":16,"SPN":723,"SPN_Name":"Engine Speed 2","SPN_Description":"The engine speed as measured by speed sensor 2\\r\\n\\r\\nNote:  This is for the engine speed from the 2nd engine speed sensor.  This may be different than SPN 190 when used in multiple engine speed sensor configurations.   In an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"728":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":32,"SPN":728,"SPN_Name":"Engine Oil Cooler Coolant Outlet Temperature","SPN_Description":"Temperature of liquid after it exits the engine oil cooler.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"740":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":42,"SPN":740,"SPN_Name":"Transmission Torque Converter Lockup Clutch Actuator","SPN_Description":"Identifies the status of the actuator that controls the torque converter lockup clutch.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"748":{"PGN":65218,"PGN_Name":"Electronic Retarder Controller 2","PGN_Description":"ERC2","first_bit":0,"SPN":748,"SPN_Name":"Transmission Output Retarder","SPN_Description":"Identifies the status of the transmission output retarder.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"767":{"PGN":65219,"PGN_Name":"Electronic Transmission Controller 5","PGN_Description":"ETC5","first_bit":8,"SPN":767,"SPN_Name":"Transmission Reverse Direction Switch","SPN_Description":"Identifies the status of the switch that indicates reverse direction.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"768":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":32,"SPN":768,"SPN_Name":"Transmission Range High Actuator","SPN_Description":"Identifies the status of the range high actuator in the auxiliary unit.\\r\\n\\r\\n00 -Off\\r\\n01 -On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"769":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":34,"SPN":769,"SPN_Name":"Transmission Range Low Actuator","SPN_Description":"Identifies the status of the range low actuator in the auxiliary unit.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"770":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":36,"SPN":770,"SPN_Name":"Transmission Splitter Direct Actuator","SPN_Description":"Identifies the status of the splitter direct actuator in the auxiliary unit.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"771":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":38,"SPN":771,"SPN_Name":"Transmission Splitter Indirect Actuator","SPN_Description":"Identifies the status of the splitter indirect actuator in the auxiliary unit.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"772":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":24,"SPN":772,"SPN_Name":"Transmission Shift Finger Rail Actuator 1","SPN_Description":"Identifies the status of the actuator that moves the shift finger identified as rail actuator #1.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"773":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":26,"SPN":773,"SPN_Name":"Transmission Shift Finger Gear Actuator 1","SPN_Description":"Identifies the status of the actuator that moves the shift finger identified as gear actuator #1.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"778":{"PGN":65219,"PGN_Name":"Electronic Transmission Controller 5","PGN_Description":"ETC5","first_bit":0,"SPN":778,"SPN_Name":"Transmission High Range Sense Switch","SPN_Description":"Identifies the status of the switch that represents high range.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"779":{"PGN":65219,"PGN_Name":"Electronic Transmission Controller 5","PGN_Description":"ETC5","first_bit":2,"SPN":779,"SPN_Name":"Transmission Low Range Sense Switch","SPN_Description":"Identifies the status of the switch that represents low range.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"780":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":16,"SPN":780,"SPN_Name":"Transmission Shift Finger Neutral Indicator","SPN_Description":"Indicates the status of the shift finger in the neutral position.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"781":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":18,"SPN":781,"SPN_Name":"Transmission Shift Finger Engagement Indicator","SPN_Description":"Identifies the status of the shift finger in the engagement position.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"782":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":20,"SPN":782,"SPN_Name":"Transmission Shift Finger Center Rail Indicator","SPN_Description":"Identifies the status of the shift finger in the center rail position.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"783":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":28,"SPN":783,"SPN_Name":"Transmission Shift Finger Rail Actuator 2","SPN_Description":"Identifies the status of the actuator that moves the shift finger identified as rail actuator #2.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"784":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":30,"SPN":784,"SPN_Name":"Transmission Shift Finger Gear Actuator 2","SPN_Description":"Identifies the status of the actuator that moves the shift finger identified as gear actuator #2.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"786":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":44,"SPN":786,"SPN_Name":"Transmission Defuel Actuator","SPN_Description":"Identifies the status of the actuator that controls the engine defuel mechanism.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"787":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":46,"SPN":787,"SPN_Name":"Transmission Inertia Brake Actuator","SPN_Description":"Identifies the status of the actuator that controls the inertia brake.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"788":{"PGN":65223,"PGN_Name":"Electronic Transmission Controller 3","PGN_Description":"ETC3","first_bit":40,"SPN":788,"SPN_Name":"Transmission Clutch Actuator","SPN_Description":"Identifies the status of the actuator that controls the clutch.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"875":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":18,"SPN":875,"SPN_Name":"Refrigerant Low Pressure Switch","SPN_Description":"Switch signal which indicates the position of the low pressure switch in the coolant circuit of an air conditioning system.  When the switch is enabled, the pressure inside the circuit is too low and the compressor clutch may be disengaged.\\r\\n\\r\\n00 - Pressure normal\\r\\n01 - Pressure too low, compressor clutch may be disengaged\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"897":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":4,"SPN":897,"SPN_Name":"Override Control Mode Priority","SPN_Description":"This field is used as an input to the engine or retarder to determine the priority of the Override Control Mode received in the Torque/Speed Control message (see PGN 0).  The default is 11 (Low priority).  It is not required to use the same priority during the entire override function.  For example, the transmission can use priority 01 (High priority) during a shift, but can set the priority to 11 (Low priority) at the end of the shift to allow traction control to also interact with the torque limit of the engine.\\r\\n\\r\\nThe four priority levels defined are:\\r\\n\\r\\n00 Highest priority\\r\\n01 High priority\\r\\n10 Medium priority\\r\\n11 Low priority\\r\\n\\r\\n00b - Highest Priority = Used for situations that require immediate action by the receiving device in order to provide safe vehicle operation (i.e., braking systems).  This level of priority should only be used in safety critical conditions.\\r\\n\\r\\n01b -  High Priority  =  Used for control situations that require prompt action in order to provide safe vehicle operation.  An example is when the transmission is performing a shift and requires control of the engine in order to control driveline reengagement.\\r\\n\\r\\n10b - Medium Priority = Used for powertrain control operations which are related to assuring that the vehicle is in a stable operating condition.  An example is when the traction control system is commanding the engine in order to achieve traction stability.\\r\\n\\r\\n11b - Low Priority = Used to indicate that the associated command desires powertrain control but is needed for function which improves the driver comfort which may be overridden by other devices.  An example is cruise control or the non-critical part of a transmission shift to a new gear.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"898":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":8,"SPN":898,"SPN_Name":"Engine Requested Speed/Speed Limit","SPN_Description":"Parameter provided to the engine from external sources in the torque/speed control message.  This is the engine speed which the engine is expected to operate at if the speed control mode is active or the engine speed which the engine is not expected to exceed if the speed limit mode is active.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"899":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":0,"SPN":899,"SPN_Name":"Engine Torque Mode","SPN_Description":"State signal which indicates which engine torque mode is currently generating, limiting, or controlling the torque.  Note that the modes are not in prioritized order. Not all modes may be relevant for a given device.  Some devices may not implement all functions.  For typical priorities refer to Figures SPN512_A and SPN512_B for engine control.  The data type of this parameter is measured.  \\r\\n\\r\\nMode 0000b means \u201CNo request\u201D: engine torque may range from 0 to full load only due to low idle governor output.\\r\\n\\r\\nModes 0001b to 1110b indicate that there is either a torque request or the identified function is currently controlling the engine: engine torque may range from 0 (no fueling) to the upper limit.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"900":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":0,"SPN":900,"SPN_Name":"Retarder Torque Mode","SPN_Description":"State signal which indicates which retarder torque mode is currently generating, limiting, or controlling the torque.  Note that the modes are not in prioritized order. Not all modes may be relevant for a given device.  Some devices may not implement all functions.  For typical priorities refer to Tables SPN518_A to SPN518_B for retarder control.  The data type of this parameter is measured. \\r\\n\\r\\nMode 0000b means \u201CNo request\u201D: retarder torque = 0 (no braking).\\r\\n\\r\\nModes 0001b to 1110b indicate that there is either a torque request or the identified function is currently controlling the retarder: retarder torque may range from 0 (no braking) to the upper limit.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"901":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":0,"SPN":901,"SPN_Name":"Retarder Type","SPN_Description":"A vehicle retarder is a supplementary device to the wheel brakes for the driver to better control the vehicle.  The wheel brakes used in the vehicle are not designed for continuous retarding operation.  In a prolonged period of braking, the brakes can be thermally over-stressed, causing the braking effect to be reduced or even lead to complete braking system failure.  The vehicle retarder is designed for continuous operation for braking during downhill operation and is also used for braking the vehicle to comply with speed limits and traffic conditions.\\r\\n\\r\\nThis parameter provides some indication of the retarder dynamics.  It is used in the retarder configuration message.  The data type of this parameter is measured.\\r\\n\\r\\n0000      Electric/Magnetic\\r\\n0001      Hydraulic\\r\\n0010      Cooled Friction\\r\\n0011      Compression Release (Engine retarder) or Combined Compression Release with Exhaust\\r\\n0100      Exhaust\\r\\n0101-1101   Not defined\\r\\n1110      Other\\r\\n1111      Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"902":{"PGN":65249,"PGN_Name":"Retarder Configuration","PGN_Description":"RC","first_bit":4,"SPN":902,"SPN_Name":"Retarder Location","SPN_Description":"This parameter defines whether the \u201Ctorque/speed curve\u201D defined by the retarder configuration message (PGN 65249) is dependent on engine rpm, output shaft rpm, or other parameter.  The data type of this parameter is measured.\\r\\n\\r\\n0000  (Primary)        Engine Compression Release Brake or Engine Compression Release Brake Combined with Engine Exhaust Brake (Engine rpm)\\r\\n0001   (Primary)         Engine Exhaust Brake (Exhaust pressure)\\r\\n0010   (Primary)         Transmission Input (Engine rpm)\\r\\n0011   (Secondary)    Transmission Output (Output Shaft rpm)\\r\\n0100   (Secondary)    Driveline (Output Shaft rpm)\\r\\n0101                           Trailer (Vehicle speed)\\r\\n0110-1101                  Not defined\\r\\n1110                           Other\\r\\n1111                           Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"903":{"PGN":65219,"PGN_Name":"Electronic Transmission Controller 5","PGN_Description":"ETC5","first_bit":12,"SPN":903,"SPN_Name":"Transmission Forward Direction Switch","SPN_Description":"Identifies the status of the switch that indicates forward direction.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"904":{"PGN":65215,"PGN_Name":"Wheel Speed Information","PGN_Description":"EBC2","first_bit":0,"SPN":904,"SPN_Name":"Front Axle Speed","SPN_Description":"The average speed of the two front wheels.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"905":{"PGN":65215,"PGN_Name":"Wheel Speed Information","PGN_Description":"EBC2","first_bit":16,"SPN":905,"SPN_Name":"Relative Speed; Front Axle, Left Wheel","SPN_Description":"The speed of the front axle, left wheel relative to the front axle speed, SPN 904.","bit_length":8,"scaling":0.0625,"offset":-7.8125,"unit":"km/h","SLOT_ID":74},"906":{"PGN":65215,"PGN_Name":"Wheel Speed Information","PGN_Description":"EBC2","first_bit":24,"SPN":906,"SPN_Name":"Relative Speed; Front Axle, Right Wheel","SPN_Description":"The speed of the front axle, right wheel relative to the front axle speed, SPN 904.","bit_length":8,"scaling":0.0625,"offset":-7.8125,"unit":"km/h","SLOT_ID":74},"907":{"PGN":65215,"PGN_Name":"Wheel Speed Information","PGN_Description":"EBC2","first_bit":32,"SPN":907,"SPN_Name":"Relative Speed; Rear Axle #1, Left Wheel","SPN_Description":"The speed of the rear axle #1, left wheel relative to the front axle speed, SPN 904.","bit_length":8,"scaling":0.0625,"offset":-7.8125,"unit":"km/h","SLOT_ID":74},"908":{"PGN":65215,"PGN_Name":"Wheel Speed Information","PGN_Description":"EBC2","first_bit":40,"SPN":908,"SPN_Name":"Relative Speed; Rear Axle #1, Right Wheel","SPN_Description":"The speed of the rear axle #1, right wheel relative to the front axle speed, SPN 904.","bit_length":8,"scaling":0.0625,"offset":-7.8125,"unit":"km/h","SLOT_ID":74},"909":{"PGN":65215,"PGN_Name":"Wheel Speed Information","PGN_Description":"EBC2","first_bit":48,"SPN":909,"SPN_Name":"Relative Speed; Rear Axle #2, Left Wheel","SPN_Description":"The speed of the rear axle #2, left wheel relative to the front axle speed, SPN 904.","bit_length":8,"scaling":0.0625,"offset":-7.8125,"unit":"km/h","SLOT_ID":74},"910":{"PGN":65215,"PGN_Name":"Wheel Speed Information","PGN_Description":"EBC2","first_bit":56,"SPN":910,"SPN_Name":"Relative Speed; Rear Axle #2, Right Wheel","SPN_Description":"The speed of the rear axle #2, right wheel relative to the front axle speed, SPN 904.","bit_length":8,"scaling":0.0625,"offset":-7.8125,"unit":"km/h","SLOT_ID":74},"911":{"PGN":65216,"PGN_Name":"Service Information","PGN_Description":"SERV","first_bit":0,"SPN":911,"SPN_Name":"Service Component Identification","SPN_Description":"Identification of component needing service.  See Table SPN911_A.","bit_length":8,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":25},"912":{"PGN":65216,"PGN_Name":"Service Information","PGN_Description":"SERV","first_bit":24,"SPN":912,"SPN_Name":"Service Component Identification","SPN_Description":"Identification of component needing service.  See Table SPN911_A.","bit_length":8,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":25},"913":{"PGN":65216,"PGN_Name":"Service Information","PGN_Description":"SERV","first_bit":40,"SPN":913,"SPN_Name":"Service Component Identification","SPN_Description":"Identification of component needing service.  See Table SPN911_A.","bit_length":8,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":25},"914":{"PGN":65216,"PGN_Name":"Service Information","PGN_Description":"SERV","first_bit":8,"SPN":914,"SPN_Name":"Service Distance","SPN_Description":"The distance which can be traveled by the vehicle before the next service inspection is required.  A negative distance is transmitted if the service inspection has been passed.  The component that requires service is identified by the service component identification (see SPN 911-913, 1379, and 1584).","bit_length":16,"scaling":5,"offset":-160635,"unit":"km","SLOT_ID":37},"915":{"PGN":65216,"PGN_Name":"Service Information","PGN_Description":"SERV","first_bit":32,"SPN":915,"SPN_Name":"Service Delay/Calendar Time Based","SPN_Description":"The time in weeks until the next vehicle service inspection is required.  A negative value is transmitted if the service inspection has been passed.  The component that requires service is identified by the service component identification (see SPN 911-913, 1379, and 1584).","bit_length":8,"scaling":1,"offset":-125,"unit":"weeks","SLOT_ID":65},"916":{"PGN":65216,"PGN_Name":"Service Information","PGN_Description":"SERV","first_bit":48,"SPN":916,"SPN_Name":"Service Delay/Operational Time Based","SPN_Description":"The time in vehicle operational time until the next vehicle service inspection is required.  A negative value is transmitted if the service inspection has been passed.  The component that requires service is identified by the service component identification (see SPN 911-913, 1379, and 1584).","bit_length":16,"scaling":1,"offset":-32127,"unit":"h","SLOT_ID":5},"917":{"PGN":65217,"PGN_Name":"High Resolution Vehicle Distance","PGN_Description":"VDHR","first_bit":0,"SPN":917,"SPN_Name":"Total Vehicle Distance (High Resolution)","SPN_Description":"Accumulated distance traveled by the vehicle during its operation.\\r\\n\\r\\nNOTE - See SPN 245 for alternate resolution.","bit_length":32,"scaling":5,"offset":0,"unit":"m","SLOT_ID":38},"918":{"PGN":65217,"PGN_Name":"High Resolution Vehicle Distance","PGN_Description":"VDHR","first_bit":32,"SPN":918,"SPN_Name":"Trip Distance (High Resolution)","SPN_Description":"Distance traveled during all or part of a journey.\\r\\n\\r\\nNOTE - See SPN 244 for alternate resolution.","bit_length":32,"scaling":5,"offset":0,"unit":"m","SLOT_ID":38},"927":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":0,"SPN":927,"SPN_Name":"Location","SPN_Description":"To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\\r\\n\\r\\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\\r\\n\\r\\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire pressure for location 0x00 would be left front tire.\\r\\n\\r\\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"928":{"PGN":65258,"PGN_Name":"Vehicle Weight","PGN_Description":"VW","first_bit":0,"SPN":928,"SPN_Name":"Axle Location","SPN_Description":"To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\\r\\n\\r\\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\\r\\n\\r\\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire pressure for location 0x00 would be left front tire.\\r\\n\\r\\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"929":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":0,"SPN":929,"SPN_Name":"Tire Location","SPN_Description":"Identifies which tire is associated with the parametric data in this PGN.\\r\\n\\r\\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\\r\\n\\r\\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire pressure for location 0x00 would be left front tire.\\r\\n\\r\\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"930":{"PGN":65273,"PGN_Name":"Axle Information","PGN_Description":"AI","first_bit":8,"SPN":930,"SPN_Name":"Drive Axle Location","SPN_Description":"To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\\r\\n\\r\\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\\r\\n\\r\\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire pressure for location 0x00 would be left front tire.\\r\\n\\r\\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"957":{"PGN":65250,"PGN_Name":"Transmission Configuration","PGN_Description":"TCFG","first_bit":8,"SPN":957,"SPN_Name":"Number of Forward Gear Ratios","SPN_Description":"Number of forward gear ratios in the transmission, provided as part of the configuration.","bit_length":8,"scaling":1,"offset":0,"unit":"gear value","SLOT_ID":101},"958":{"PGN":65250,"PGN_Name":"Transmission Configuration","PGN_Description":"TCFG","first_bit":0,"SPN":958,"SPN_Name":"Number of Reverse Gear Ratios","SPN_Description":"Number of reverse gear ratios in the transmission, provided as part of the transmission configuration.","bit_length":8,"scaling":1,"offset":0,"unit":"gear value","SLOT_ID":101},"959":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":0,"SPN":959,"SPN_Name":"Seconds","SPN_Description":"The seconds component of the current time of day.  This should be reported as the seconds component of the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the seconds component of the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.","bit_length":8,"scaling":0.25,"offset":0,"unit":"s","SLOT_ID":63},"960":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":8,"SPN":960,"SPN_Name":"Minutes","SPN_Description":"The minutes component of the current time of day.  This should be reported as the minutes component of the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the minutes component of the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.","bit_length":8,"scaling":1,"offset":0,"unit":"min","SLOT_ID":61},"961":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":16,"SPN":961,"SPN_Name":"Hours","SPN_Description":"The hour component of the current time of day.  This should be reported as the hour component of the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the hour component of the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.","bit_length":8,"scaling":1,"offset":0,"unit":"h","SLOT_ID":3},"962":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":32,"SPN":962,"SPN_Name":"Day","SPN_Description":"The day component of the current calendar date.  This should be reported as the day component of the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the day component of the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\\r\\n\\r\\nNOTE - A value of 0 for the date is null.  The values 1, 2, 3, and 4 are used to identify the first day of the month; 5, 6, 7, and 8 identify the second day of the month; etc.  Multiples of 4 are a common encoding use.","bit_length":8,"scaling":0.25,"offset":0,"unit":"days","SLOT_ID":60},"963":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":24,"SPN":963,"SPN_Name":"Month","SPN_Description":"The month component of the current calendar date.  This should be reported as the month component of the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the month component of the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\\r\\n\\r\\nNOTE - A value of 0 for the month is null.  The value 1 identifies January; 2 identifies February; etc.","bit_length":8,"scaling":1,"offset":0,"unit":"months","SLOT_ID":62},"964":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":40,"SPN":964,"SPN_Name":"Year","SPN_Description":"The year component of the current calendar date.  This should be reported as the year component of the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the year component of the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\\r\\n\\r\\nNOTE - A value of 0 for the year identifies the year 1985; a value of 1 identifies 1986; etc.","bit_length":8,"scaling":1,"offset":1985,"unit":"years","SLOT_ID":66},"965":{"PGN":65242,"PGN_Name":"Software Identification","PGN_Description":"SOFT","first_bit":0,"SPN":965,"SPN_Name":"Number of Software Identification Fields","SPN_Description":"Number of software identification designators represented in the software identification parameter group.","bit_length":8,"scaling":1,"offset":0,"unit":"step","SLOT_ID":84},"966":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":60,"SPN":966,"SPN_Name":"Engine Diagnostic Test Mode Switch","SPN_Description":"Switch signal which indicates the position of the engine diagnostic test mode switch.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"967":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":58,"SPN":967,"SPN_Name":"Engine Idle Decrement Switch","SPN_Description":"Switch signal which indicates the position of the idle decrement switch.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"968":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":56,"SPN":968,"SPN_Name":"Engine Idle Increment Switch","SPN_Description":"Switch signal which indicates the position of the idle increment switch.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"969":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":30,"SPN":969,"SPN_Name":"Remote Accelerator Enable Switch","SPN_Description":"Switch signal which indicates that the remote accelerator has been enabled and controls the engine.  \\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nNOTE\u2014The accelerator interlock switch (see SPN 972) must be disabled in order for the remote accelerator to perform engine control.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"970":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":28,"SPN":970,"SPN_Name":"Engine Auxiliary Shutdown Switch","SPN_Description":"Switch signal which requests that all engine fueling stop.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"971":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":26,"SPN":971,"SPN_Name":"Engine Derate Switch","SPN_Description":"Switch signal used to activate the torque limiting feature of the engine.  The specific nature of torque limiting should be verified with the manufacturer.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"972":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":24,"SPN":972,"SPN_Name":"Accelerator Interlock Switch","SPN_Description":"Switch signal used to disable the accelerator and remote accelerator inputs, causing the engine to return to idle.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"973":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":32,"SPN":973,"SPN_Name":"Engine Retarder Selection","SPN_Description":"The position of the operator controlled selector, expressed as a percentage and determined by the ratio of the current position of the selector to its maximum possible position. Zero percent means no braking torque is requested by the operator from the engine while 100% means maximum braking.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"974":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":24,"SPN":974,"SPN_Name":"Remote Accelerator Pedal Position","SPN_Description":"The ratio of actual position of the remote analog engine speed/torque request input device (such as an accelerator pedal or throttle lever) to the maximum position of the input device.     \\r\\n\\r\\nFor example, in on-highway vehicles this could be an accelerator control device that is external to the drivers cab or an accelerator that is controlled by a hand lever from the operators seat. \\r\\n\\r\\nThe Remote Accelerator Enable Switch is SPN 969. This parameter enables the remote accelerator operation.\\r\\n\\r\\nNOTE\u2014See SPNs 29 and 91 for additional accelerator position parameters. If only one accelerator\\r\\nposition exists on a vehicle, SPN 91 shall be used.  SPN 28 is an additional diagnostic SPN for accelerator position.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"975":{"PGN":65213,"PGN_Name":"Fan Drive #1","PGN_Description":"FD1","first_bit":0,"SPN":975,"SPN_Name":"Engine Fan 1 Estimated Percent Speed","SPN_Description":"Estimated fan speed as a ratio of the fan drive (current speed) to the fully engaged fan drive (maximum fan speed).  A two state fan (off/on) will use 0% and 100% respectively.  A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively.  A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided.\\r\\n\\r\\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"976":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":48,"SPN":976,"SPN_Name":"PTO Governor State","SPN_Description":"This parameter is used to indicate the current state or mode of operation by the power takeoff (PTO) governor.  In lieu of support for PTO Drive Engagement parameters, this parameter may represent the status of a PTO drive.  The broadcasting device must ensure that each achieved state is conveyed in at least one message broadcast before a transition to another state is allowed.\\r\\n  \\r\\n00000     Off/Disabled\\r\\n00001     Hold\\r\\n00010     Remote Hold\\r\\n00011     Standby\\r\\n00100     Remote Standby\\r\\n00101     Set\\r\\n00110     Decelerate/Coast\\r\\n00111     Resume\\r\\n01000     Accelerate\\r\\n01001     Accelerator Override\\r\\n01010     Preprogrammed set speed 1\\r\\n01011     Preprogrammed set speed 2\\r\\n01100     Preprogrammed set speed 3\\r\\n01101     Preprogrammed set speed 4\\r\\n01110     Preprogrammed set speed 5\\r\\n01111     Preprogrammed set speed 6\\r\\n10000     Preprogrammed set speed 7\\r\\n10001     Preprogrammed set speed 8\\r\\n10010     PTO set speed memory 1\\r\\n10011     PTO set speed memory 2\\r\\n10100     PTO set speed memory 3\\r\\n10101-11110      Not defined\\r\\n11111     Not available\\r\\n\\r\\nOff/Disabled 00000b \u2014 Used to indicate that the PTO governor enable switch is in the off position.\\r\\n\\r\\nHold 00001b \u2014 Used to indicate that the PTO governor is active and currently maintaining a captured operating speed.\\r\\n\\r\\nRemote Hold 00010b \u2014 Used to indicate that the remote PTO governor is active and the PTO governor is currently maintaining a captured operating speed.\\r\\n\\r\\nStandby 00011b \u2014 Used to indicate that the PTO governor device enable switch is in the ON position and it is possible to manage the PTO governor.\\r\\n\\r\\nRemote Standby 00100b \u2014 Used to indicate that the remote PTO governor device enable switch is in the ON position and it is possible to manage the PTO governor.\\r\\n\\r\\nSet 00101b \u2014 Used to indicate that the PTO governor is establishing current speed as the operating speed (captured value).\\r\\n\\r\\nDecelerate/Coast 00110b \u2014 Used to indicate that the PTO governor is in the process of ramping down, or coasting, from the current operating speed.\\r\\n\\r\\nResume 00111b \u2014 Used to indicate that the PTO governor is in the process of resuming the operating speed to a previously captured value.\\r\\n\\r\\nAccelerate 01000b \u2014 Used to indicate that the PTO governor is in the process of ramping up the operating speed.\\r\\n\\r\\nAccelerator Override 01001b\u2014Used to indicate that the PTO governor is active but for the present time the engine is controlled by a large driver\'s demand.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 1  01010b\u2014Used to indicate that the PTO device is establishing a first preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 2  01011b\u2014Used to indicate that the PTO device is establishing a second preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 3  01100b \u2014Used to indicate that the remote PTO device is establishing a third preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 4  01101b \u2014Used to indicate that the remote PTO device is establishing a fourth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 5  01110b \u2014Used to indicate that the remote PTO device is establishing a fifth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 6  01111b\u2014Used to indicate that the remote PTO device is establishing a sixth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 7  10000b \u2014Used to indicate that the remote PTO device is establishing a seventh preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPreprogrammed PTO Governor Set Speed 8  10001b \u2014Used to indicate that the remote PTO device is establishing a eighth preprogrammed PTO governor set speed (user programmable) as the current operating speed.\\r\\n\\r\\nPTO set speed memory 1  10010b \u2014Used to indicate that PTO set speed memory one set state is active.\\r\\n\\r\\nPTO set speed memory 2  10011b \u2014 Used to indicate that PTO set speed memory two set state is active.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"977":{"PGN":65213,"PGN_Name":"Fan Drive #1","PGN_Description":"FD1","first_bit":8,"SPN":977,"SPN_Name":"Fan Drive State","SPN_Description":"This parameter is used to indicate the current state or mode of operation by the fan drive.\\r\\n\\r\\n0000 Fan off\\r\\n0001 Engine system\u2013General\\r\\n0010 Excessive engine air temperature\\r\\n0011 Excessive engine oil temperature\\r\\n0100 Excessive engine coolant temperature\\r\\n0101 Excessive transmission oil temperature\\r\\n0110 Excessive hydraulic oil temperature\\r\\n0111 Default Operation\\r\\n1000 Reverse Operation\\r\\n1001 Manual control\\r\\n1010 Transmission retarder\\r\\n1011 A/C system\\r\\n1100 Timer\\r\\n1101 Engine brake\\r\\n1110 Other\\r\\n1111 Not available\\r\\n\\r\\nFan off  0000b \u2014Used to indicate that the fan clutch is disengaged and the fan is inactive\\r\\n\\r\\nEngine system\u2013General  0001b \u2014Used to indicate that the fan is active due to an engine system not otherwise defined.\\r\\n\\r\\nExcessive engine air temperature  0010b \u2014Used to indicate that the fan is active due to high air temperature.\\r\\n\\r\\nExcessive engine oil temperature  0011b \u2014Used to indicate that the fan is active due to high oil temperature.\\r\\n\\r\\nExcessive engine coolant temperature  0100b \u2014Used to indicate that the fan is active due to high coolant temperature.\\r\\n\\r\\nReverse Operation  1000b \u2014 Used to indicate that the fan is in reverse direction of operation compared to the normal direction of operation \\r\\n\\r\\nManual control  1001b \u2014Used to indicate that the fan is active as requested by the operator.\\r\\n\\r\\nTransmission retarder  1010b \u2014Used to indicate that the fan is active as required by the transmission retarder.\\r\\n\\r\\nA/C system  1011b \u2014Used to indicate that the fan is active as required by the air conditioning system.\\r\\n\\r\\nTimer  1100b \u2014Used to indicate that the fan is active as required by a timing function.\\r\\n\\r\\nEngine brake  1101b \u2014Used to indicate that the fan is active as required to assist engine braking.\\r\\n\\r\\nExcessive transmission oil temperature - 0101b  - Used to indicate fan is active due to excessive transmission oil temperature.\\r\\n\\r\\nExcessive hydraulic oil temperature - 0110b - Used to indicate fan is active due to excessive hydraulic oil temperature.\\r\\n\\r\\nDefault Operation - 0111b - Used to indicate fan is active due to a error condition resulting in default operation","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"978":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":44,"SPN":978,"SPN_Name":"Engine Remote PTO Governor Variable Speed Control Switch","SPN_Description":"Switch signal which indicates that the remote PTO governor toggle switch is in the enabled (ON) position.  If the toggle switch is enabled and other conditions are satisfied then the remote PTO governor feature is activated and the PTO governor will control at a variable speed.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"979":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":42,"SPN":979,"SPN_Name":"Engine Remote PTO Governor Preprogrammed Speed Control Switch","SPN_Description":"Switch signal which indicates that the remote PTO governor  toggle switch is in the enabled (ON) position.  If the toggle switch is enabled and other conditions are satisfied then the remote PTO governor feature is activated and the PTO governor will control at the preprogrammed speed.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"980":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":40,"SPN":980,"SPN_Name":"Engine PTO Governor Enable Switch","SPN_Description":"Switch signal which indicates that the PTO governor toggle switch is in the enabled (ON) position and therefore it is possible to manage the PTO control function.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"981":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":54,"SPN":981,"SPN_Name":"Engine PTO Governor Accelerate Switch","SPN_Description":"Switch signal of the PTO control activator which indicates that the activator is in the position to \\"accelerate\\" the PTO governor set speed.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"982":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":52,"SPN":982,"SPN_Name":"Engine PTO Governor Resume Switch","SPN_Description":"Switch signal of the PTO control activator which indicates that the activator is in the position to \\"resume\\" a previously established PTO governor set speed.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"983":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":50,"SPN":983,"SPN_Name":"Engine PTO Governor Coast/Decelerate Switch","SPN_Description":"Switch signal of the PTO control activator which indicates that the activator is in the position to \\"coast/decelerate\\" the PTO governor set speed.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"984":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":48,"SPN":984,"SPN_Name":"Engine PTO Governor Set Switch","SPN_Description":"Switch signal of the PTO control activator which indicates that the activator is in the position to \\"set\\" the engine PTO governor set speed.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"985":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":16,"SPN":985,"SPN_Name":"A/C High Pressure Fan Switch","SPN_Description":"Switch signal which indicates that the pressure in the coolant circuit of an air conditioning system is high and the fan may be engaged.\\r\\n\\r\\n00 - Pressure normal\\r\\n01 - Pressure high, fan may be engaged\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"986":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":0,"SPN":986,"SPN_Name":"Engine Fan 1 Requested Percent Speed","SPN_Description":"Fan speed of the first or only fan in the system as a ratio of the actual fan drive (current speed) to the fully engaged fan drive (maximum fan speed). A two state fan (off/on) will use 0% and 100% respectively. A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively. A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided. Feedback to this request is provided using the estimated fan speed (see SPN 975). \\r\\n\\r\\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive. Typically, the first fan in a system will be the fan closest to the radiator. The second fan will be located farthest from the radiator.\\r\\n\\r\\nSee SPN 6730 for systems that have two fans.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"988":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":0,"SPN":988,"SPN_Name":"Trip Group 1","SPN_Description":"Command signal used to reset the PGNs and parameters as defined in Table SPN988_A.\\r\\n\\r\\n00 Take no action\\r\\n01 Reset\\r\\n10 Reserved\\r\\n11 Not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"989":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":2,"SPN":989,"SPN_Name":"Trip Group 2 - Proprietary","SPN_Description":"Command signal used to reset proprietary parameters associated with a trip but not defined within this document.\\r\\n\\r\\n00 Take no action\\r\\n01 Reset\\r\\n10 Reserved\\r\\n11 Not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"990":{"PGN":65212,"PGN_Name":"Compression/Service Brake Information","PGN_Description":"CBI","first_bit":0,"SPN":990,"SPN_Name":"Total Compression Brake Distance","SPN_Description":"Total distance over which the compression brakes have been active for the life of the engine.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"991":{"PGN":65212,"PGN_Name":"Compression/Service Brake Information","PGN_Description":"CBI","first_bit":32,"SPN":991,"SPN_Name":"Trip Compression Brake Distance","SPN_Description":"Total distance over which the compression brakes have been active since the last trip reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"992":{"PGN":65212,"PGN_Name":"Compression/Service Brake Information","PGN_Description":"CBI","first_bit":64,"SPN":992,"SPN_Name":"Trip Service Brake Distance","SPN_Description":"Total distance over which the service brakes have been active since the last trip reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"993":{"PGN":65212,"PGN_Name":"Compression/Service Brake Information","PGN_Description":"CBI","first_bit":96,"SPN":993,"SPN_Name":"Trip Service Brake Applications","SPN_Description":"Total number of times the service brakes have been activated since the last trip reset.  Brake applications of less than 0.5 s are not counted and lengthy brake applications (longer than 0.5 s) are counted as a single event.\\r\\n\\r\\nNOTE - Definition and resolution shall stay the same if brakes are applied by only the tractor, only the trailer or both.","bit_length":32,"scaling":1,"offset":0,"unit":"brake appl","SLOT_ID":81},"994":{"PGN":65211,"PGN_Name":"Trip Fan Information","PGN_Description":"TFI","first_bit":0,"SPN":994,"SPN_Name":"Trip Fan On Time","SPN_Description":"Total time the fan has been on (due to an automatic trigger or manual trigger) since the last trip reset.  The fan could be requested to be on by the engine system, a manual switch, and/or the A/C system.  Whichever system requests the fan activation first shall have the time accumulated against it.  The sum total of these three values shall equal the trip fan on time.\\r\\n\\r\\nNOTE\u2014If the fan has been requested to be on by a component that is not one of the defined categories, this time shall be accumulated in the Engine System category by default.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"995":{"PGN":65211,"PGN_Name":"Trip Fan Information","PGN_Description":"TFI","first_bit":32,"SPN":995,"SPN_Name":"Trip Fan On Time Due to the Engine System","SPN_Description":"Total time the fan has been on due to engine triggers (i.e., excluding time on due to an operator manual switch or A/C system) since the last trip reset.  For the time to be accumulated against the engine system, it is necessary that it be the first to request the fan activation or it be the only system requesting fan activation.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"996":{"PGN":65211,"PGN_Name":"Trip Fan Information","PGN_Description":"TFI","first_bit":64,"SPN":996,"SPN_Name":"Trip Fan On Time Due to a Manual Switch","SPN_Description":"Total time the fan has been on due to manual activation by the operator (i.e., excluding time on due to automatic triggers) since the last trip reset.  For the time to be accumulated against the manual switch, it is necessary that it be the first to request the fan activation or it be the only system requesting fan activation.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"997":{"PGN":65211,"PGN_Name":"Trip Fan Information","PGN_Description":"TFI","first_bit":96,"SPN":997,"SPN_Name":"Trip Fan On Time Due to the A/C System","SPN_Description":"Total time the fan has been on due to the A/C system since the last trip reset.  For the time to be accumulated against the A/C system, it is necessary that it be the first to request the fan activation or it be the only system requesting fan activation.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"998":{"PGN":65210,"PGN_Name":"Trip Distance Information","PGN_Description":"TDI","first_bit":0,"SPN":998,"SPN_Name":"Trip Distance on VSL","SPN_Description":"Total distance accumulated while the engine torque mode is road speed governing since the last trip reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"999":{"PGN":65210,"PGN_Name":"Trip Distance Information","PGN_Description":"TDI","first_bit":32,"SPN":999,"SPN_Name":"Trip Gear Down Distance","SPN_Description":"Total distance accumulated while the vehicle has operated in the gear which is one gear down from top gear and exceeds a calibrated minimum time (typically the time to shift the transmission) since the last trip reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"1000":{"PGN":65210,"PGN_Name":"Trip Distance Information","PGN_Description":"TDI","first_bit":64,"SPN":1000,"SPN_Name":"Trip Distance in Top Gear","SPN_Description":"Total distance accumulated while the vehicle has operated in top gear for a calibrated minimum time since the last trip reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"1001":{"PGN":65209,"PGN_Name":"Trip Fuel Information (Liquid)","PGN_Description":"LTFI","first_bit":0,"SPN":1001,"SPN_Name":"Trip Drive Fuel Used","SPN_Description":"Total fuel consumed while the engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and neither the PTO or the remote PTO is controlling the engine power output, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1007 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"1002":{"PGN":65209,"PGN_Name":"Trip Fuel Information (Liquid)","PGN_Description":"LTFI","first_bit":32,"SPN":1002,"SPN_Name":"Trip PTO Governor Moving Fuel Used","SPN_Description":"Total fuel consumed while either the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is greater than or equal to 2 km/h, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1008 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"1003":{"PGN":65209,"PGN_Name":"Trip Fuel Information (Liquid)","PGN_Description":"LTFI","first_bit":64,"SPN":1003,"SPN_Name":"Trip PTO Governor Non-moving Fuel Used","SPN_Description":"Total fuel consumed while either the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is less than 2 km/h, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1009 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"1004":{"PGN":65209,"PGN_Name":"Trip Fuel Information (Liquid)","PGN_Description":"LTFI","first_bit":96,"SPN":1004,"SPN_Name":"Trip Vehicle Idle Fuel Used","SPN_Description":"Total fuel consumed while neither the PTO or remote PTO governor is in the hold state, the engine speed is greater than zero, and vehicle speed is less than 2 km/h, since the last trip reset.\\r\\n\\r\\nIn marine applications, this parameter is defined as the total fuel consumed while the engine speed is greater than zero, and less than or equal to 50 RPM greater than low idle, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1010 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"1005":{"PGN":65209,"PGN_Name":"Trip Fuel Information (Liquid)","PGN_Description":"LTFI","first_bit":128,"SPN":1005,"SPN_Name":"Trip Cruise Fuel Used","SPN_Description":"Total fuel consumed while the engine is in the cruise hold state since the last trip reset.  If both cruise control and VSL (vehicle speed limiter) are commanding the same amount of fuel, the cruise control is deemed the active torque mode and fuel will be accumulated in \\"trip cruise fuel used\\" parameter.  If fuel commanded due to the accelerator pedal position is larger than fuel commanded by cruise control (e.g., accelerator override torque mode), the cruise control is not deemed the active torque mode and fuel will not be accumulated in the \\"trip cruise fuel used\\" parameter.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1011 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"1006":{"PGN":65209,"PGN_Name":"Trip Fuel Information (Liquid)","PGN_Description":"LTFI","first_bit":160,"SPN":1006,"SPN_Name":"Trip Drive Fuel Economy","SPN_Description":"Trip drive fuel economy is equal to the distance traveled by vehicle in the drive state (engine speed greater than zero, vehicle speed greater than or equal to 2 km/h, and neither the PTO or remote PTO governors are controlling engine power output) divided by trip drive fuel used (SPN 1001), since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1012 for alternate resolution.","bit_length":16,"scaling":0.001953125,"offset":0,"unit":"km/L","SLOT_ID":16},"1007":{"PGN":65208,"PGN_Name":"Trip Fuel Information (Gaseous)","PGN_Description":"GTFI","first_bit":0,"SPN":1007,"SPN_Name":"Trip Drive Fuel Used (Gaseous)","SPN_Description":"Total fuel consumed while the engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and neither the PTO or the remote PTO governors are controlling the engine power output, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1001 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1008":{"PGN":65208,"PGN_Name":"Trip Fuel Information (Gaseous)","PGN_Description":"GTFI","first_bit":32,"SPN":1008,"SPN_Name":"Trip PTO Governor Moving Fuel Used (Gaseous)","SPN_Description":"Total fuel consumed while the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is greater than or equal to 2 km/h, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1002 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1009":{"PGN":65208,"PGN_Name":"Trip Fuel Information (Gaseous)","PGN_Description":"GTFI","first_bit":64,"SPN":1009,"SPN_Name":"Trip PTO Governor Non-moving Fuel Used (Gaseous)","SPN_Description":"Total fuel consumed while the PTO or remote PTO governors are in the hold state, the engine speed is greater than zero, and vehicle speed is less than to 2 km/h, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1003 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1010":{"PGN":65208,"PGN_Name":"Trip Fuel Information (Gaseous)","PGN_Description":"GTFI","first_bit":96,"SPN":1010,"SPN_Name":"Trip Vehicle Idle Fuel Used (Gaseous)","SPN_Description":"Total fuel consumed while neither the PTO or remote PTO governors are active, the engine speed is greater than zero, and vehicle speed is less than to 2 km/h, since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1004 for alternate resolution.  Trip vehicle idle fuel while in fast idle (vehicle speed less than 2 km/h with engine speed greater than 700 rpm) shall be accumulated in the trip vehicle idle fuel category.  All other fuel usage scenarios that do not fall directly in the categories defined shall be accumulated in trip drive fuel used.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1011":{"PGN":65208,"PGN_Name":"Trip Fuel Information (Gaseous)","PGN_Description":"GTFI","first_bit":128,"SPN":1011,"SPN_Name":"Trip Cruise Fuel Used (Gaseous)","SPN_Description":"Total fuel consumed while the engine is in the cruise hold state since the last trip reset.  If both cruise control and VSL (vehicle speed limiter) are commanding the same amount of fuel, the cruise control is deemed the active torque mode and fuel will be accumulated in \\"trip cruise fuel used\\" parameter.  If fuel commanded due to the accelerator pedal position is larger than fuel commanded by cruise control (e.g., accelerator override torque mode), the cruise control is not deemed the active torque mode and fuel will not be accumulated in the \\"trip cruise fuel used\\" parameter.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1005 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1012":{"PGN":65208,"PGN_Name":"Trip Fuel Information (Gaseous)","PGN_Description":"GTFI","first_bit":160,"SPN":1012,"SPN_Name":"Trip Drive Fuel Economy (Gaseous)","SPN_Description":"Trip drive fuel economy is equal to the distance traveled by vehicle in the drive state (engine speed greater than zero, vehicle speed greater than or equal to 2 km/h, and neither the PTO or remote PTO governors are controlling engine power output) divided by trip drive fuel used (SPN 1007), since the last trip reset.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1006 for alternate resolution.","bit_length":16,"scaling":0.001953125,"offset":0,"unit":"km/kg","SLOT_ID":17},"1013":{"PGN":65207,"PGN_Name":"Engine Speed/Load Factor Information","PGN_Description":"LF","first_bit":0,"SPN":1013,"SPN_Name":"Trip Maximum Engine Speed","SPN_Description":"Maximum engine speed achieved since the last trip reset.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"1014":{"PGN":65207,"PGN_Name":"Engine Speed/Load Factor Information","PGN_Description":"LF","first_bit":16,"SPN":1014,"SPN_Name":"Trip Average Engine Speed","SPN_Description":"Average speed of the engine since the last trip reset.\\r\\n\\r\\nNOTE \u2014 Excludes ignition-on time without the engine speed above zero.  Includes idle, engine PTO governor (moving and non-moving), and drive operation.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"1015":{"PGN":65207,"PGN_Name":"Engine Speed/Load Factor Information","PGN_Description":"LF","first_bit":32,"SPN":1015,"SPN_Name":"Trip Drive Average Load Factor","SPN_Description":"Average engine load factor while engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and both the PTO (moving/non-moving) and remote PTO governors are not in the hold state, since the last trip reset.  Engine operation during cruise control operation is included.\\r\\n\\r\\nIn marine applications, this parameter is defined as the average engine load factor while engine speed is greater than zero, since last trip reset.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1016":{"PGN":65207,"PGN_Name":"Engine Speed/Load Factor Information","PGN_Description":"LF","first_bit":40,"SPN":1016,"SPN_Name":"Total Drive Average Load Factor","SPN_Description":"Average engine load factor while engine speed is greater than zero, vehicle speed is greater than or equal to 2 km/h, and both the PTO (moving/non-moving) and remote PTO governors are not in the hold state, over the life of the engine.  Engine operation during cruise control operation is included.\\r\\n\\r\\nIn marine applications, this parameter is defined as the average engine load factor while engine speed is greater than zero.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1017":{"PGN":65207,"PGN_Name":"Engine Speed/Load Factor Information","PGN_Description":"LF","first_bit":48,"SPN":1017,"SPN_Name":"Total Engine Cruise Time","SPN_Description":"Total time that the engine has operated in the cruise hold state, excluding time in accelerator override, over the life of the engine.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1018":{"PGN":65206,"PGN_Name":"Trip Vehicle Speed/Cruise Distance Information","PGN_Description":"TVI","first_bit":0,"SPN":1018,"SPN_Name":"Trip Maximum Vehicle Speed","SPN_Description":"Maximum vehicle speed achieved while the engine speed is greater than zero and the accelerator pedal position (APS) is at a value greater than 0%, since the last trip reset.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"1019":{"PGN":65206,"PGN_Name":"Trip Vehicle Speed/Cruise Distance Information","PGN_Description":"TVI","first_bit":16,"SPN":1019,"SPN_Name":"Trip Cruise Distance","SPN_Description":"Total distance that the engine has operated in the cruise hold state, excluding time in accelerator override, since the last trip reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"1020":{"PGN":65205,"PGN_Name":"Trip Shutdown Information","PGN_Description":"TSI","first_bit":0,"SPN":1020,"SPN_Name":"Trip Number of Hot Shutdowns","SPN_Description":"Total number of hot shutdowns since the last trip reset.  A hot shutdown is based on operation at high load or high engine speed or for long operating periods without allowing the engine to cool sufficiently.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"1021":{"PGN":65205,"PGN_Name":"Trip Shutdown Information","PGN_Description":"TSI","first_bit":16,"SPN":1021,"SPN_Name":"Trip Number of Idle Shutdowns","SPN_Description":"Total number of times the engine has been shutdown due to idling too long (at normal idle or fast idle) since the last trip reset.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"1022":{"PGN":65205,"PGN_Name":"Trip Shutdown Information","PGN_Description":"TSI","first_bit":32,"SPN":1022,"SPN_Name":"Trip Number of Idle Shutdown Overrides","SPN_Description":"Total number of times an operator disables idle shutdown to prevent an engine shutdown, since the last trip reset.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"1023":{"PGN":65205,"PGN_Name":"Trip Shutdown Information","PGN_Description":"TSI","first_bit":48,"SPN":1023,"SPN_Name":"Trip Sudden Decelerations","SPN_Description":"Total number of decelerations whenever the vehicle deceleration is more than XYZ km/h/sec (where XYZ is a calibratible threshold), since the last trip reset.  A lengthy deceleration shall be counted as one sudden deceleration.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"1024":{"PGN":65204,"PGN_Name":"Trip Time Information 1","PGN_Description":"TTI1","first_bit":0,"SPN":1024,"SPN_Name":"Trip Time in VSL","SPN_Description":"Total time accumulated when the engine has operated on the vehicle speed limiter (VSL) while not in the cruise hold state, since the last trip reset.  The engine torque mode is equal to road speed governor during this operation.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1025":{"PGN":65204,"PGN_Name":"Trip Time Information 1","PGN_Description":"TTI1","first_bit":32,"SPN":1025,"SPN_Name":"Trip Time in Top Gear","SPN_Description":"Total time accumulated when the vehicle has operated in top gear for a calibrated minimum time, since the last trip reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1026":{"PGN":65204,"PGN_Name":"Trip Time Information 1","PGN_Description":"TTI1","first_bit":64,"SPN":1026,"SPN_Name":"Trip Time in Gear Down","SPN_Description":"Total time accumulated when the vehicle has operated in one gear down from the top gear for a calibrated minimum time, since the last trip reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1027":{"PGN":65204,"PGN_Name":"Trip Time Information 1","PGN_Description":"TTI1","first_bit":96,"SPN":1027,"SPN_Name":"Trip Time in Derate by Engine","SPN_Description":"Total time accumulated when the engine final fueling has been derated due to an engine protection algorithm, since the last reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1028":{"PGN":65203,"PGN_Name":"Fuel Information 1 (Liquid)","PGN_Description":"LFI1","first_bit":0,"SPN":1028,"SPN_Name":"Total Engine PTO Governor Fuel Used","SPN_Description":"Total fuel used while the PTO or remote PTO governors are in the hold state and engine speed is above zero, over the life of the engine.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1030 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":20},"1029":{"PGN":65203,"PGN_Name":"Fuel Information 1 (Liquid)","PGN_Description":"LFI1","first_bit":32,"SPN":1029,"SPN_Name":"Trip Average Fuel Rate","SPN_Description":"Average fuel rate, equal to trip fuel divided by trip time while the engine speed is above zero, since the last trip reset.  This includes idle, engine PTO governor (both moving and non-moving) and drive operation but excludes ignition-on time while the engine speed is at zero rpm.\\r\\n\\r\\nNOTE\u2014This parameter is intended for liquid fueled engines.  See SPN 1031 for alternate resolution.","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"1030":{"PGN":65202,"PGN_Name":"Fuel Information 1 (Gaseous)","PGN_Description":"GFI1","first_bit":0,"SPN":1030,"SPN_Name":"Total Engine PTO Governor Fuel Used (Gaseous)","SPN_Description":"Total fuel used while the PTO or remote PTO governors are in the hold state and engine speed is above zero, over the life of the engine.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1028 for alternate resolution.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1031":{"PGN":65202,"PGN_Name":"Fuel Information 1 (Gaseous)","PGN_Description":"GFI1","first_bit":32,"SPN":1031,"SPN_Name":"Trip Average Fuel Rate (Gaseous)","SPN_Description":"Average fuel rate, equal to trip fuel divided by trip time while the engine speed is above zero, since the last trip reset.  This includes idle, engine PTO governor (both moving and non-moving) and drive operation but excludes ignition-on time while the engine speed is at zero rpm.\\r\\n\\r\\nNOTE\u2014This parameter is intended for gaseous fueled engines.  See SPN 1029 for alternate resolution.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kg/h","SLOT_ID":18},"1032":{"PGN":65201,"PGN_Name":"ECU History","PGN_Description":"EH","first_bit":0,"SPN":1032,"SPN_Name":"Total ECU Distance","SPN_Description":"Total distance accumulated over the life of the ECU.  When the ECU is replaced this value shall be reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"1033":{"PGN":65201,"PGN_Name":"ECU History","PGN_Description":"EH","first_bit":32,"SPN":1033,"SPN_Name":"Total ECU Run Time","SPN_Description":"Total time accumulated over the life of the ECU, from ignition switch ON to ignition switch OFF.  When the ECU is replaced this value shall be reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1034":{"PGN":65200,"PGN_Name":"Trip Time Information 2","PGN_Description":"TTI2","first_bit":0,"SPN":1034,"SPN_Name":"Trip Cruise Time","SPN_Description":"Total time accumulated while the engine is in the cruise hold state, excluding time in accelerator override, since the last trip reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1035":{"PGN":65200,"PGN_Name":"Trip Time Information 2","PGN_Description":"TTI2","first_bit":32,"SPN":1035,"SPN_Name":"Trip PTO Governor Time","SPN_Description":"Total time accumulated while the engine is in the PTO or remote PTO governor hold state since the last trip reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1036":{"PGN":65200,"PGN_Name":"Trip Time Information 2","PGN_Description":"TTI2","first_bit":64,"SPN":1036,"SPN_Name":"Trip Engine Running Time","SPN_Description":"Total time accumulated while the engine speed is greater than zero since the last trip reset.  Note that time with the ignition switch on but engine speed at zero is not included.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1037":{"PGN":65200,"PGN_Name":"Trip Time Information 2","PGN_Description":"TTI2","first_bit":96,"SPN":1037,"SPN_Name":"Trip Idle Time","SPN_Description":"Total time accumulated while the engine speed is greater than zero, both the PTO and remote PTO governors are inactive, and the vehicle speed is less than 2 km/h, since the last trip reset.\\r\\n\\r\\nIn marine applications, this parameter is defined as the total time accumulated while the engine speed is greater than zero, and less than or equal to 50 RPM greater than low idle, since the last trip reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1038":{"PGN":65200,"PGN_Name":"Trip Time Information 2","PGN_Description":"TTI2","first_bit":128,"SPN":1038,"SPN_Name":"Trip Air Compressor On Time","SPN_Description":"Total time that the air compressor is on and compressing air since the last trip reset.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1039":{"PGN":65199,"PGN_Name":"Fuel Consumption (Gaseous)","PGN_Description":"GFC","first_bit":0,"SPN":1039,"SPN_Name":"Trip Fuel (Gaseous)","SPN_Description":"Total fuel consumed (trip drive fuel + trip PTO governor moving fuel + trip PTO governor non-moving fuel + trip idle fuel) since the last trip reset.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1040":{"PGN":65199,"PGN_Name":"Fuel Consumption (Gaseous)","PGN_Description":"GFC","first_bit":32,"SPN":1040,"SPN_Name":"Total Fuel Used (Gaseous)","SPN_Description":"Total fuel consumed (trip drive fuel + trip PTO governor moving fuel + trip PTO governor non-moving fuel + trip idle fuel) over the life of the engine.","bit_length":32,"scaling":0.5,"offset":0,"unit":"kg","SLOT_ID":21},"1081":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":24,"SPN":1081,"SPN_Name":"Engine Wait to Start Lamp","SPN_Description":"Lamp signal which indicates that the engine is too cold to start and the operator should wait until the signal becomes inactive (turns off).  See SPN 5416 for the lamp operating condition.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1082":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":24,"SPN":1082,"SPN_Name":"Engine Coolant Load Increase","SPN_Description":"Status of an event, external to the engine, that may increase the nominal temperature of the engine coolant liquid.\\r\\n\\r\\n00 - No coolant load increase\\r\\n01 - Coolant load increase possible\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1083":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":32,"SPN":1083,"SPN_Name":"Auxiliary I/O Channel #1","SPN_Description":"Auxiliary channel of data (16 bit) read by the ECU.  This data is in A/D counts and is manufacturer specific.  It may be configured uniquely per application.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"1084":{"PGN":65241,"PGN_Name":"Auxiliary Input/Output Status 1","PGN_Description":"AUXIO1","first_bit":48,"SPN":1084,"SPN_Name":"Auxiliary I/O Channel #2","SPN_Description":"Auxiliary channel of data (16 bit) read by the ECU.  This data is in A/D counts and is manufacturer specific.  It may be configured uniquely per application.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"1085":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":16,"SPN":1085,"SPN_Name":"Intended Retarder Percent Torque","SPN_Description":"Braking torque of retarder that the retarder is currently trying to achieve.  This value takes into account all static limitations, but not the limitations due to the dynamic behavior of the retarder.  This value, if unchanged over a certain time, can and will be reached by the actual retarder - percent torque (See SPN 520).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1086":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":8,"SPN":1086,"SPN_Name":"Parking and/or Trailer Air Pressure","SPN_Description":"The pneumatic pressure in the circuit or reservoir for the parking brake and/or the trailer supply.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"1087":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":16,"SPN":1087,"SPN_Name":"Service Brake Circuit 1 Air Pressure","SPN_Description":"The pneumatic pressure in the primary service brake circuit or reservoir, supplying the rear axle.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"1088":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":24,"SPN":1088,"SPN_Name":"Service Brake Circuit 2 Air Pressure","SPN_Description":"The pneumatic pressure in the secondary service brake circuit or reservoir, supplying the front axle.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"1089":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":32,"SPN":1089,"SPN_Name":"Auxiliary Equipment Supply Pressure","SPN_Description":"The pneumatic pressure in the auxiliary circuit.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"1090":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":40,"SPN":1090,"SPN_Name":"Air Suspension Supply Pressure","SPN_Description":"The pneumatic pressure in the circuit for the electronically controlled air suspension system.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"1091":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":0,"SPN":1091,"SPN_Name":"Brake Application Pressure High Range, Front Axle, Left Wheel","SPN_Description":"The brake application pressure for the left wheel on the front axle.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1092":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":8,"SPN":1092,"SPN_Name":"Brake Application Pressure High Range, Front Axle, Right Wheel","SPN_Description":"The brake application pressure for the right wheel on the front axle.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1093":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":16,"SPN":1093,"SPN_Name":"Brake Application Pressure High Range, Rear Axle #1, Left Wheel","SPN_Description":"The brake application pressure for the left wheel on the rear axle #1.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1094":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":24,"SPN":1094,"SPN_Name":"Brake Application Pressure High Range, Rear Axle #1, Right Wheel","SPN_Description":"The brake application pressure for the right wheel on the rear axle #1.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1095":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":32,"SPN":1095,"SPN_Name":"Brake Application Pressure High Range, Rear Axle #2, Left Wheel","SPN_Description":"The brake application pressure for the left wheel on the rear axle #2.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1096":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":40,"SPN":1096,"SPN_Name":"Brake Application Pressure High Range, Rear Axle #2, Right Wheel","SPN_Description":"The brake application pressure for the right wheel on the rear axle #2.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1097":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":48,"SPN":1097,"SPN_Name":"Brake Application Pressure High Range, Rear Axle #3, Left Wheel","SPN_Description":"The brake application pressure for the left wheel on the rear axle #3.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1098":{"PGN":65197,"PGN_Name":"Wheel Application Pressure High Range Information","PGN_Description":"EBC3","first_bit":56,"SPN":1098,"SPN_Name":"Brake Application Pressure High Range, Rear Axle #3, Right Wheel","SPN_Description":"The brake application pressure for the right wheel on the rear axle #3.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"1099":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":0,"SPN":1099,"SPN_Name":"Brake Lining Remaining, Front Axle, Left Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the left wheel on the front axle.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1100":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":8,"SPN":1100,"SPN_Name":"Brake Lining Remaining, Front Axle, Right Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the right wheel on the front axle.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1101":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":16,"SPN":1101,"SPN_Name":"Brake Lining Remaining, Rear Axle #1, Left Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the left wheel on the rear axle #1.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1102":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":24,"SPN":1102,"SPN_Name":"Brake Lining Remaining, Rear Axle #1, Right Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the right wheel on the rear axle #1.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1103":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":32,"SPN":1103,"SPN_Name":"Brake Lining Remaining, Rear Axle #2, Left Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the left wheel on the rear axle #2.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1104":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":40,"SPN":1104,"SPN_Name":"Brake Lining Remaining, Rear Axle #2, Right Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the right wheel on the rear axle #2.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1105":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":48,"SPN":1105,"SPN_Name":"Brake Lining Remaining, Rear Axle #3, Left Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the left wheel on the rear axle #3.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1106":{"PGN":65196,"PGN_Name":"Wheel Brake Lining Remaining Information","PGN_Description":"EBC4","first_bit":56,"SPN":1106,"SPN_Name":"Brake Lining Remaining, Rear Axle #3, Right Wheel","SPN_Description":"The percentage of brake lining which can still be measured for the right wheel on the rear axle #3.  100% represents new brake linings, 0% represents totally worn brake linings.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1107":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":38,"SPN":1107,"SPN_Name":"Engine Protection System Timer State","SPN_Description":"Status signal which indicates the current mode of the engine protection system timer system.  See Figure SPN1107_A.\\r\\n\\r\\n00 - Inactive\\r\\n01 - Active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1108":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":36,"SPN":1108,"SPN_Name":"Engine Protection System Timer Override","SPN_Description":"Status signal which indicates the status of the override feature of the engine protection system timer. See Figure SPN1107_A.\\r\\n\\r\\n00 - Inactive\\r\\n01 - Active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1109":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":34,"SPN":1109,"SPN_Name":"Engine Protection System Approaching Shutdown","SPN_Description":"Status signal which indicates that engine shutdown is imminent.  This engine protection signal can be a result of different systems failing, i.e., engine overheating. See Figure SPN1107_A.\\r\\n\\r\\n00 - Not approaching\\r\\n01 - Approaching\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1110":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":32,"SPN":1110,"SPN_Name":"Engine Protection System has Shutdown Engine","SPN_Description":"Status signal which indicates whether or not the engine protection system has shutdown the engine.  See Figure SPN1107_A.\\r\\n\\r\\n00 - No\\r\\n01 - Yes\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1111":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":46,"SPN":1111,"SPN_Name":"Engine Protection System Configuration","SPN_Description":"Parameter which indicates the configuration of the engine shutdown system.\\r\\n\\r\\n00 - Disabled in calibration\\r\\n01 - Enabled in calibration\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1113":{"PGN":65195,"PGN_Name":"Electronic Transmission Controller 6","PGN_Description":"ETC6","first_bit":0,"SPN":1113,"SPN_Name":"Recommended Gear","SPN_Description":"The transmission calculates this gear continuously.  In dangerous situations this gear may be selected to gain back vehicle control.","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"1114":{"PGN":65195,"PGN_Name":"Electronic Transmission Controller 6","PGN_Description":"ETC6","first_bit":16,"SPN":1114,"SPN_Name":"Lowest Possible Gear","SPN_Description":"The transmission calculates this gear continuously.  Together with the highest possible gear (see SPN 1115), it enables a management computer to know the exact range of available gears.","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"1115":{"PGN":65195,"PGN_Name":"Electronic Transmission Controller 6","PGN_Description":"ETC6","first_bit":8,"SPN":1115,"SPN_Name":"Highest Possible Gear","SPN_Description":"The transmission calculates this gear continuously.  Together with the lowest possible gear (see  SPN 1114), it enables a management computer to know the exact range of available gears.","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"1116":{"PGN":65194,"PGN_Name":"Alternate Fuel 2","PGN_Description":"AF2","first_bit":0,"SPN":1116,"SPN_Name":"Gaseous Fuel Correction Factor","SPN_Description":"A correction to a predefined gaseous fuel energy (expressed in energy per unit volume) represented as a percentage.  The actual fuel energy used to control the engine is the product of the gaseous fuel correction factor and the energy of the gas.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1117":{"PGN":65193,"PGN_Name":"Exhaust Oxygen 1","PGN_Description":"EO1","first_bit":0,"SPN":1117,"SPN_Name":"Engine Desired Rated Exhaust Oxygen","SPN_Description":"The desired amount of oxygen in the exhaust at rated conditions represented as a percentage by volume with respect to the total volume of exhaust gases leaving the engine.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"1118":{"PGN":65193,"PGN_Name":"Exhaust Oxygen 1","PGN_Description":"EO1","first_bit":16,"SPN":1118,"SPN_Name":"Engine Desired Exhaust Oxygen","SPN_Description":"The desired amount of oxygen in the exhaust represented as a percentage by volume with respect to the total volume of exhaust gases leaving the engine.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"1119":{"PGN":65193,"PGN_Name":"Exhaust Oxygen 1","PGN_Description":"EO1","first_bit":32,"SPN":1119,"SPN_Name":"Engine Actual Exhaust Oxygen","SPN_Description":"The actual amount of oxygen in the exhaust represented as a percentage by volume with respect to the total volume of exhaust gases leaving the engine.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"1120":{"PGN":65192,"PGN_Name":"Articulation Control","PGN_Description":"ACTL","first_bit":0,"SPN":1120,"SPN_Name":"Articulation Angle","SPN_Description":"Angle of deflection of an articulated transit vehicle (rotation angle about the vehicles z-axis). A right turn (clockwise) is indicated with a positive angle and a left turn is indicated with a negative angle.  This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.","bit_length":8,"scaling":1,"offset":-125,"unit":"deg","SLOT_ID":11},"1121":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":6,"SPN":1121,"SPN_Name":"EBS Brake Switch","SPN_Description":"Switch signal which indicates that the brake pedal is being pressed.  The EBS brake switch is independent of the brake light switch and has no provisions for external connections.\\r\\n\\r\\n00 - Brake pedal is not being pressed\\r\\n01 - Brake pedal is being pressed\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1122":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":0,"SPN":1122,"SPN_Name":"Engine Alternator Bearing 1 Temperature","SPN_Description":"Temperature of the bearing inside the alternator.  Bearing 1 is the left or rear bearing.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1123":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":8,"SPN":1123,"SPN_Name":"Engine Alternator Bearing 2 Temperature","SPN_Description":"Temperature of the bearing inside the alternator.  Bearing 2 is the right or front bearing.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1124":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":16,"SPN":1124,"SPN_Name":"Engine Alternator Winding 1 Temperature","SPN_Description":"Temperature of the windings inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1125":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":24,"SPN":1125,"SPN_Name":"Engine Alternator Winding 2 Temperature","SPN_Description":"Temperature of the windings inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1126":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":32,"SPN":1126,"SPN_Name":"Engine Alternator Winding 3 Temperature","SPN_Description":"Temperature of the windings inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1127":{"PGN":65190,"PGN_Name":"Intake Manifold Information 1","PGN_Description":"IMT1","first_bit":0,"SPN":1127,"SPN_Name":"Engine Turbocharger 1 Boost Pressure","SPN_Description":"Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102 is adequate, then it should be used.","bit_length":16,"scaling":0.125,"offset":0,"unit":"kPa","SLOT_ID":138},"1128":{"PGN":65190,"PGN_Name":"Intake Manifold Information 1","PGN_Description":"IMT1","first_bit":16,"SPN":1128,"SPN_Name":"Engine Turbocharger 2 Boost Pressure","SPN_Description":"Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102  is adequate, then it should be used.","bit_length":16,"scaling":0.125,"offset":0,"unit":"kPa","SLOT_ID":138},"1129":{"PGN":65190,"PGN_Name":"Intake Manifold Information 1","PGN_Description":"IMT1","first_bit":32,"SPN":1129,"SPN_Name":"Engine Turbocharger 3 Boost Pressure","SPN_Description":"Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102 is adequate, then it should be used.","bit_length":16,"scaling":0.125,"offset":0,"unit":"kPa","SLOT_ID":138},"1130":{"PGN":65190,"PGN_Name":"Intake Manifold Information 1","PGN_Description":"IMT1","first_bit":48,"SPN":1130,"SPN_Name":"Engine Turbocharger 4 Boost Pressure","SPN_Description":"Gage pressure of air measured downstream of the compressor discharge side of the turbocharger.  See also SPN 102 for alternate range and resolution. If there is only one boost pressure to report and the range and resolution in SPN 102 is adequate, then it should be used.","bit_length":16,"scaling":0.125,"offset":0,"unit":"kPa","SLOT_ID":138},"1131":{"PGN":65189,"PGN_Name":"Intake Manifold Information 2","PGN_Description":"IMT2","first_bit":0,"SPN":1131,"SPN_Name":"Engine Intake Manifold 2 Temperature","SPN_Description":"Temperature of pre-combustion air found in intake manifold of engine air supply system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1132":{"PGN":65189,"PGN_Name":"Intake Manifold Information 2","PGN_Description":"IMT2","first_bit":8,"SPN":1132,"SPN_Name":"Engine Intake Manifold 3 Temperature","SPN_Description":"Temperature of pre-combustion air found in intake manifold of engine air supply system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1133":{"PGN":65189,"PGN_Name":"Intake Manifold Information 2","PGN_Description":"IMT2","first_bit":16,"SPN":1133,"SPN_Name":"Engine Intake Manifold 4 Temperature","SPN_Description":"Temperature of pre-combustion air found in intake manifold of engine air supply system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1134":{"PGN":65262,"PGN_Name":"Engine Temperature 1","PGN_Description":"ET1","first_bit":56,"SPN":1134,"SPN_Name":"Engine Charge Air Cooler Thermostat Opening","SPN_Description":"The current position of the thermostat used to regulate the temperature of the engine charge air cooler.  A value of 0% represents the thermostat being completely closed and 100% represents the thermostat being completely open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1135":{"PGN":65188,"PGN_Name":"Engine Temperature 2","PGN_Description":"ET2","first_bit":0,"SPN":1135,"SPN_Name":"Engine Oil Temperature 2","SPN_Description":"Temperature of the engine lubricant.\\r\\n\\r\\nNote:  If there is only one engine oil temperature measurement, SPN 175 should be used. \\r\\n\\r\\nSee also SPNs 175 and 5925 for additional engine oil temperature measurements.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1136":{"PGN":65188,"PGN_Name":"Engine Temperature 2","PGN_Description":"ET2","first_bit":16,"SPN":1136,"SPN_Name":"Engine ECU Temperature","SPN_Description":"Temperature of the engine electronic control unit.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1137":{"PGN":65187,"PGN_Name":"Exhaust Port Temperature 1","PGN_Description":"EPT1","first_bit":0,"SPN":1137,"SPN_Name":"Engine Exhaust Gas Port 1 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1138":{"PGN":65187,"PGN_Name":"Exhaust Port Temperature 1","PGN_Description":"EPT1","first_bit":16,"SPN":1138,"SPN_Name":"Engine Exhaust Gas Port 2 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1139":{"PGN":65187,"PGN_Name":"Exhaust Port Temperature 1","PGN_Description":"EPT1","first_bit":32,"SPN":1139,"SPN_Name":"Engine Exhaust Gas Port 3 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1140":{"PGN":65187,"PGN_Name":"Exhaust Port Temperature 1","PGN_Description":"EPT1","first_bit":48,"SPN":1140,"SPN_Name":"Engine Exhaust Gas Port 4 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1141":{"PGN":65186,"PGN_Name":"Exhaust Port Temperature 2","PGN_Description":"EPT2","first_bit":0,"SPN":1141,"SPN_Name":"Engine Exhaust Gas Port 5 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1142":{"PGN":65186,"PGN_Name":"Exhaust Port Temperature 2","PGN_Description":"EPT2","first_bit":16,"SPN":1142,"SPN_Name":"Engine Exhaust Gas Port 6 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1143":{"PGN":65186,"PGN_Name":"Exhaust Port Temperature 2","PGN_Description":"EPT2","first_bit":32,"SPN":1143,"SPN_Name":"Engine Exhaust Gas Port 7 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1144":{"PGN":65186,"PGN_Name":"Exhaust Port Temperature 2","PGN_Description":"EPT2","first_bit":48,"SPN":1144,"SPN_Name":"Engine Exhaust Gas Port 8 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1145":{"PGN":65185,"PGN_Name":"Exhaust Port Temperature 3","PGN_Description":"EPT3","first_bit":0,"SPN":1145,"SPN_Name":"Engine Exhaust Gas Port 9 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1146":{"PGN":65185,"PGN_Name":"Exhaust Port Temperature 3","PGN_Description":"EPT3","first_bit":16,"SPN":1146,"SPN_Name":"Engine Exhaust Gas Port 10 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1147":{"PGN":65185,"PGN_Name":"Exhaust Port Temperature 3","PGN_Description":"EPT3","first_bit":32,"SPN":1147,"SPN_Name":"Engine Exhaust Gas Port 11 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1148":{"PGN":65185,"PGN_Name":"Exhaust Port Temperature 3","PGN_Description":"EPT3","first_bit":48,"SPN":1148,"SPN_Name":"Engine Exhaust Gas Port 12 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1149":{"PGN":65184,"PGN_Name":"Exhaust Port Temperature 4","PGN_Description":"EPT4","first_bit":0,"SPN":1149,"SPN_Name":"Engine Exhaust Gas Port 13 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1150":{"PGN":65184,"PGN_Name":"Exhaust Port Temperature 4","PGN_Description":"EPT4","first_bit":16,"SPN":1150,"SPN_Name":"Engine Exhaust Gas Port 14 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1151":{"PGN":65184,"PGN_Name":"Exhaust Port Temperature 4","PGN_Description":"EPT4","first_bit":32,"SPN":1151,"SPN_Name":"Engine Exhaust Gas Port 15 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1152":{"PGN":65184,"PGN_Name":"Exhaust Port Temperature 4","PGN_Description":"EPT4","first_bit":48,"SPN":1152,"SPN_Name":"Engine Exhaust Gas Port 16 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1153":{"PGN":65183,"PGN_Name":"Exhaust Port Temperature 5","PGN_Description":"EPT5","first_bit":0,"SPN":1153,"SPN_Name":"Engine Exhaust Gas Port 17 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1154":{"PGN":65183,"PGN_Name":"Exhaust Port Temperature 5","PGN_Description":"EPT5","first_bit":16,"SPN":1154,"SPN_Name":"Engine Exhaust Gas Port 18 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1155":{"PGN":65183,"PGN_Name":"Exhaust Port Temperature 5","PGN_Description":"EPT5","first_bit":32,"SPN":1155,"SPN_Name":"Engine Exhaust Gas Port 19 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1156":{"PGN":65183,"PGN_Name":"Exhaust Port Temperature 5","PGN_Description":"EPT5","first_bit":48,"SPN":1156,"SPN_Name":"Engine Exhaust Gas Port 20 Temperature","SPN_Description":"Temperature at the cylinder exhaust port of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1157":{"PGN":65182,"PGN_Name":"Main Bearing Temperature 1","PGN_Description":"MBT1","first_bit":0,"SPN":1157,"SPN_Name":"Engine Main Bearing 1 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1158":{"PGN":65182,"PGN_Name":"Main Bearing Temperature 1","PGN_Description":"MBT1","first_bit":16,"SPN":1158,"SPN_Name":"Engine Main Bearing 2 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1159":{"PGN":65182,"PGN_Name":"Main Bearing Temperature 1","PGN_Description":"MBT1","first_bit":32,"SPN":1159,"SPN_Name":"Engine Main Bearing 3 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1160":{"PGN":65182,"PGN_Name":"Main Bearing Temperature 1","PGN_Description":"MBT1","first_bit":48,"SPN":1160,"SPN_Name":"Engine Main Bearing 4 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1161":{"PGN":65181,"PGN_Name":"Main Bearing Temperature 2","PGN_Description":"MBT2","first_bit":0,"SPN":1161,"SPN_Name":"Engine Main Bearing 5 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1162":{"PGN":65181,"PGN_Name":"Main Bearing Temperature 2","PGN_Description":"MBT2","first_bit":16,"SPN":1162,"SPN_Name":"Engine Main Bearing 6 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1163":{"PGN":65181,"PGN_Name":"Main Bearing Temperature 2","PGN_Description":"MBT2","first_bit":32,"SPN":1163,"SPN_Name":"Engine Main Bearing 7 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1164":{"PGN":65181,"PGN_Name":"Main Bearing Temperature 2","PGN_Description":"MBT2","first_bit":48,"SPN":1164,"SPN_Name":"Engine Main Bearing 8 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1165":{"PGN":65180,"PGN_Name":"Main Bearing Temperature 3","PGN_Description":"MBT3","first_bit":0,"SPN":1165,"SPN_Name":"Engine Main Bearing 9 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1166":{"PGN":65180,"PGN_Name":"Main Bearing Temperature 3","PGN_Description":"MBT3","first_bit":16,"SPN":1166,"SPN_Name":"Engine Main Bearing 10 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1167":{"PGN":65180,"PGN_Name":"Main Bearing Temperature 3","PGN_Description":"MBT3","first_bit":32,"SPN":1167,"SPN_Name":"Engine Main Bearing 11 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1168":{"PGN":65179,"PGN_Name":"Turbocharger Information 1","PGN_Description":"TCI1","first_bit":0,"SPN":1168,"SPN_Name":"Engine Turbocharger Lube Oil Pressure 2","SPN_Description":"Gage pressure of oil in turbocharger lubrication system.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"1169":{"PGN":65179,"PGN_Name":"Turbocharger Information 1","PGN_Description":"TCI1","first_bit":8,"SPN":1169,"SPN_Name":"Engine Turbocharger 2 Speed","SPN_Description":"Rotational velocity of rotor in the turbocharger.","bit_length":16,"scaling":4,"offset":0,"unit":"rpm","SLOT_ID":77},"1170":{"PGN":65179,"PGN_Name":"Turbocharger Information 1","PGN_Description":"TCI1","first_bit":24,"SPN":1170,"SPN_Name":"Engine Turbocharger 3 Speed","SPN_Description":"Rotational velocity of rotor in the turbocharger.","bit_length":16,"scaling":4,"offset":0,"unit":"rpm","SLOT_ID":77},"1171":{"PGN":65179,"PGN_Name":"Turbocharger Information 1","PGN_Description":"TCI1","first_bit":40,"SPN":1171,"SPN_Name":"Engine Turbocharger 4 Speed","SPN_Description":"Rotational velocity of rotor in the turbocharger.","bit_length":16,"scaling":4,"offset":0,"unit":"rpm","SLOT_ID":77},"1172":{"PGN":65178,"PGN_Name":"Turbocharger Information 2","PGN_Description":"TCI2","first_bit":0,"SPN":1172,"SPN_Name":"Engine Turbocharger 1 Compressor Intake Temperature","SPN_Description":"Temperature of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1173":{"PGN":65178,"PGN_Name":"Turbocharger Information 2","PGN_Description":"TCI2","first_bit":16,"SPN":1173,"SPN_Name":"Engine Turbocharger 2 Compressor Intake Temperature","SPN_Description":"Temperature of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1174":{"PGN":65178,"PGN_Name":"Turbocharger Information 2","PGN_Description":"TCI2","first_bit":32,"SPN":1174,"SPN_Name":"Engine Turbocharger 3 Compressor Intake Temperature","SPN_Description":"Temperature of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1175":{"PGN":65178,"PGN_Name":"Turbocharger Information 2","PGN_Description":"TCI2","first_bit":48,"SPN":1175,"SPN_Name":"Engine Turbocharger 4 Compressor Intake Temperature","SPN_Description":"Temperature of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1176":{"PGN":65177,"PGN_Name":"Turbocharger Information 3","PGN_Description":"TCI3","first_bit":0,"SPN":1176,"SPN_Name":"Engine Turbocharger 1 Compressor Intake Pressure","SPN_Description":"Gage pressure of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"1177":{"PGN":65177,"PGN_Name":"Turbocharger Information 3","PGN_Description":"TCI3","first_bit":16,"SPN":1177,"SPN_Name":"Engine Turbocharger 2 Compressor Intake Pressure","SPN_Description":"Gage pressure of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"1178":{"PGN":65177,"PGN_Name":"Turbocharger Information 3","PGN_Description":"TCI3","first_bit":32,"SPN":1178,"SPN_Name":"Engine Turbocharger 3 Compressor Intake Pressure","SPN_Description":"Gage pressure of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"1179":{"PGN":65177,"PGN_Name":"Turbocharger Information 3","PGN_Description":"TCI3","first_bit":48,"SPN":1179,"SPN_Name":"Engine Turbocharger 4 Compressor Intake Pressure","SPN_Description":"Gage pressure of the air entering the compressor side of the turbocharger.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"1180":{"PGN":65176,"PGN_Name":"Turbocharger Information 4","PGN_Description":"TCI4","first_bit":0,"SPN":1180,"SPN_Name":"Engine Turbocharger 1 Turbine Intake Temperature","SPN_Description":"Temperature of the combustion by-products entering the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1181":{"PGN":65176,"PGN_Name":"Turbocharger Information 4","PGN_Description":"TCI4","first_bit":16,"SPN":1181,"SPN_Name":"Engine Turbocharger 2 Turbine Intake Temperature","SPN_Description":"Temperature of the combustion by-products entering the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1182":{"PGN":65176,"PGN_Name":"Turbocharger Information 4","PGN_Description":"TCI4","first_bit":32,"SPN":1182,"SPN_Name":"Engine Turbocharger 3 Turbine Intake Temperature","SPN_Description":"Temperature of the combustion by-products entering the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1183":{"PGN":65176,"PGN_Name":"Turbocharger Information 4","PGN_Description":"TCI4","first_bit":48,"SPN":1183,"SPN_Name":"Engine Turbocharger 4 Turbine Intake Temperature","SPN_Description":"Temperature of the combustion by-products entering the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1184":{"PGN":65175,"PGN_Name":"Turbocharger Information 5","PGN_Description":"TCI5","first_bit":0,"SPN":1184,"SPN_Name":"Engine Turbocharger 1 Turbine Outlet Temperature","SPN_Description":"Temperature of the combustion by-products exiting the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1185":{"PGN":65175,"PGN_Name":"Turbocharger Information 5","PGN_Description":"TCI5","first_bit":16,"SPN":1185,"SPN_Name":"Engine Turbocharger 2 Turbine Outlet Temperature","SPN_Description":"Temperature of the combustion by-products exiting the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1186":{"PGN":65175,"PGN_Name":"Turbocharger Information 5","PGN_Description":"TCI5","first_bit":32,"SPN":1186,"SPN_Name":"Engine Turbocharger 3 Turbine Outlet Temperature","SPN_Description":"Temperature of the combustion by-products exiting the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1187":{"PGN":65175,"PGN_Name":"Turbocharger Information 5","PGN_Description":"TCI5","first_bit":48,"SPN":1187,"SPN_Name":"Engine Turbocharger 4 Turbine Outlet Temperature","SPN_Description":"Temperature of the combustion by-products exiting the turbine side of the turbocharger.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1188":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":0,"SPN":1188,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Position","SPN_Description":"Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1189":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":8,"SPN":1189,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Position","SPN_Description":"Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1190":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":16,"SPN":1190,"SPN_Name":"Engine Turbocharger Wastegate Actuator 3 Position","SPN_Description":"Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1191":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":24,"SPN":1191,"SPN_Name":"Engine Turbocharger Wastegate Actuator 4 Position","SPN_Description":"Position of the wastegate drive.  A value of 0% represents fully closed and a value of 100% represents fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1192":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":32,"SPN":1192,"SPN_Name":"Engine Turbocharger Wastegate Actuator Control Air Pressure","SPN_Description":"Gage pressure of the air used to control the actuator which opens and closes the wastegate valve.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"1193":{"PGN":65173,"PGN_Name":"Rebuild Information","PGN_Description":"RBI","first_bit":0,"SPN":1193,"SPN_Name":"Engine Operation Time Since Rebuild","SPN_Description":"The time in engine operation since the last engine rebuild.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"1194":{"PGN":56320,"PGN_Name":"Anti-theft Status","PGN_Description":"ATS","first_bit":0,"SPN":1194,"SPN_Name":"Anti-theft Encryption Seed Present Indicator","SPN_Description":"Indicates the presence of the encryption seed random number.\\r\\n\\r\\n00 - Random number is not present\\r\\n01 - Random number is present\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1195":{"PGN":56320,"PGN_Name":"Anti-theft Status","PGN_Description":"ATS","first_bit":2,"SPN":1195,"SPN_Name":"Anti-theft Password Valid Indicator","SPN_Description":"Indicates the presence of a validated password.\\r\\n\\r\\n00 - Password is not a validated password\\r\\n01 - Password is a validated password\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1196":{"PGN":56320,"PGN_Name":"Anti-theft Status","PGN_Description":"ATS","first_bit":4,"SPN":1196,"SPN_Name":"Anti-theft Component Status States","SPN_Description":"Indicates whether or not the component can be started.  \\r\\n\\r\\n00 Unlocked\\r\\n01 Locked\\r\\n10 Blocked\\r\\n11 Not defined\\r\\n\\r\\n00b -  Unlocked = This state indicates that the component can be started without the end user being required to enter a password.\\r\\n\\r\\n01b - Locked = This state indicates that the component can NOT be started (i.e., Unlocked) without the end user being required to enter a password.\\r\\n\\r\\n10b - Blocked = This state indicates that a Lock or Unlock command cannot be executed because some other algorithm or command of higher priority is commanding differently.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1197":{"PGN":56320,"PGN_Name":"Anti-theft Status","PGN_Description":"ATS","first_bit":6,"SPN":1197,"SPN_Name":"Anti-theft Modify Password States","SPN_Description":"This parameter is used to indicate whether a password request was successfully performed, or if the request could not be perform due to system constraints or if the request was not a valid request.  \\r\\n\\r\\n00 Ok\\r\\n01 Full_of_Passwords\\r\\n10 Empty_of_Passwords\\r\\n11 Not_valid\\r\\n\\r\\n00b - Ok = This state indicates that the request was successfully performed.\\r\\n\\r\\n01b - Full_Of_Passwords = This state indicates that the component can NOT store any additional passwords in its memory.\\r\\n\\r\\n10b - Empty_Of_Passwords = This state indicates that the component would be empty of passwords (an unacceptable condition) if the password under which the end user is logged in, is deleted.  Thus the delete password command is not successfully executed.\\r\\n\\r\\nNote that if the Delete_Password command is sent to a component that does not currently have a password the Empty_Of_Passwords state indicator shall be used.\\r\\n\\r\\n11b -  Not_Valid = This state indicates that the request is not a valid one.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1198":{"PGN":56320,"PGN_Name":"Anti-theft Status","PGN_Description":"ATS","first_bit":8,"SPN":1198,"SPN_Name":"Anti-theft Random Number","SPN_Description":"A seven byte random numeric code provided by the component in response to an anti-theft request.  This parameter is sent as a numeric value utilizing the full range of 0 to 0xFFFFFFFFFFFFFF.  The most significant byte is sent first, not following the rules of Table 1 found in J1939-71.","bit_length":56,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":110},"1199":{"PGN":56576,"PGN_Name":"Anti-theft Request","PGN_Description":"ATR","first_bit":1,"SPN":1199,"SPN_Name":"Anti-theft Encryption Indicator States","SPN_Description":"This parameter is used to indicate if a random number seed is being requested, or if an encrypted password is being provided to the component. \\r\\n\\r\\n00 Encryption_Seed_Request\\r\\n01 Encrypted_Code_Present\\r\\n10 Not defined\\r\\n11 Not_Available\\r\\n\\r\\n00b - Encryption_Seed_Request = This state represents a request to the component to provide a random number seed.\\r\\n\\r\\n01b - Encrypted_Code_Present = This state is used to indicate that an encrypted password is being provided to the component.\\r\\n\\r\\n11b - Not_Available = This state is used to indicate that a random number is NOT being requested nor is an encrypted password being provided to the component.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1200":{"PGN":56576,"PGN_Name":"Anti-theft Request","PGN_Description":"ATR","first_bit":3,"SPN":1200,"SPN_Name":"Anti-theft Desired Exit Mode States","SPN_Description":"This parameter is used to specify the desired triggers that are to be used by the component in deciding when to transition to the Locked state. \\r\\n\\r\\n00 Lock_Upon_Operator_Request\\r\\n01 Lock_When_Key_Off\\r\\n10 Not defined\\r\\n11 Not_Available\\r\\n\\r\\n00b -   Lock_Upon_Operator_Request\u2014This state is used to indicate that the end user would have to manually enter a password to Lock the engine.\\r\\n\\r\\n01b -  Lock_When_Keyoff\u2014This state is used to indicate that the component would automatically transition to the Locked state when the end user turns off the engine (i.e. without the end user being required to manually enter the password).\\r\\n\\r\\n11b - Not_Available\u2014This state is indicates that the option is not selectable or changeable by the operator via using current tool.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1201":{"PGN":56576,"PGN_Name":"Anti-theft Request","PGN_Description":"ATR","first_bit":5,"SPN":1201,"SPN_Name":"Anti-theft Command States","SPN_Description":"This parameter is used to identify the specific requests being sent to the component. \\r\\n\\r\\n000 Add_Password\\r\\n001 Delete_Password\\r\\n010 Change_Password\\r\\n011 Lock_or_Unlock\\r\\n100 Check_Status\\r\\n101 Login\\r\\n110-111 Not defined\\r\\n\\r\\n000b - Add_Password\u2014This state represents a request to the component to add a password to the list of passwords that the component has stored as valid codes.  This command will not be performed if the component has already stored, the maximum number of passwords that it is capable of storing.  The Login command must precede this command.\\r\\n\\r\\n001b - Delete_Password\u2014This state represents a request to the component to delete the password (the same one used when the end-user logged in).  See SPN 1197 for limitations.\\r\\n\\r\\n010b - Change_Password\u2014This state represents a request to the component to change the password (the same one that the end-user logged in with) to a different password, which is to be specified by the end user.  The Login command must precede this command.\\r\\n\\r\\n011b - Lock_Or_Unlock\u2014This state represents a request to the component to change from the Locked state to the Unlocked state or from the Unlocked state to the Locked state.\\r\\n\\r\\n100b - Check_Status\u2014This state represents a request to check to see if the component is in the Locked or Unlocked state.\\r\\n\\r\\n101b -  Login\u2014This state represents a request to validate the end user, before performing commands such as Add_Password and Change_Password.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1202":{"PGN":56576,"PGN_Name":"Anti-theft Request","PGN_Description":"ATR","first_bit":8,"SPN":1202,"SPN_Name":"Anti-theft Password Representation","SPN_Description":"This parameter is the seven byte numeric code (i.e., \u2018encrypted password\u2019 or \u2018key\u2019) that is generated based on the encryption algorithm, the password supplied by the end user, and the random number seed given by the component.  This parameter is sent as a numeric value utilizing the full range of 0 to 0xFFFFFFFFFFFFFF.  The most significant byte is sent first, not following the rules of Table 1 found in J1939-71.","bit_length":56,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":110},"1203":{"PGN":65172,"PGN_Name":"Engine Auxiliary Coolant","PGN_Description":"EAC","first_bit":0,"SPN":1203,"SPN_Name":"Engine Auxiliary Coolant Pressure","SPN_Description":"Gage pressure of coolant found in the intercooler which is located after the turbocharger.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"1204":{"PGN":65171,"PGN_Name":"Engine Electrical System/Module Information","PGN_Description":"EES","first_bit":0,"SPN":1204,"SPN_Name":"Electrical Load","SPN_Description":"Electrical power delivered by the engine to the electrical system connected to the generator.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"1205":{"PGN":65171,"PGN_Name":"Engine Electrical System/Module Information","PGN_Description":"EES","first_bit":16,"SPN":1205,"SPN_Name":"Safety Wire Status","SPN_Description":"Status signal which indicates that the safety wire has been activated.  When the safety wire is activated, the engine will not operate.  This is used for maintenance purposes.\\r\\n\\r\\n00 - Safety wire has not been activated\\r\\n01 - Safety wire has been activated\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1206":{"PGN":65171,"PGN_Name":"Engine Electrical System/Module Information","PGN_Description":"EES","first_bit":18,"SPN":1206,"SPN_Name":"Engine Turning Gear Engaged","SPN_Description":"Status signal which indicates that the turning gear is engaged.  The turning gear is used to turn the flywheel/crankshaft, for maintenance purposes, while the engine is not running.\\r\\n\\r\\n00 - Not engaged\\r\\n01 - Engaged\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1208":{"PGN":65170,"PGN_Name":"Engine Information 1","PGN_Description":"EI1","first_bit":0,"SPN":1208,"SPN_Name":"Engine Oil Filter Intake Pressure","SPN_Description":"Gage pressure of the engine oil before the oil reaches the oil filter.   See SPN 7470 for alternate resolution.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"1209":{"PGN":65170,"PGN_Name":"Engine Information 1","PGN_Description":"EI1","first_bit":8,"SPN":1209,"SPN_Name":"Engine Exhaust Pressure 1","SPN_Description":"Gage pressure of the exhaust gases as measured at the turbine intake of the turbocharger. This SPN to be used for inline engines or exhaust bank 1 of multiple bank engines.  See SPN 5749 for exhaust bank 2 and See SPN 6384 for alternate range and resolution.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"1210":{"PGN":65170,"PGN_Name":"Engine Information 1","PGN_Description":"EI1","first_bit":24,"SPN":1210,"SPN_Name":"Engine Fuel Rack Position","SPN_Description":"Measured position of the engine fuel rack.  A value of 0% rack represents no fueling and a value of 100% rack represents maximum fueling.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1211":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":16,"SPN":1211,"SPN_Name":"Engine Build Hours Reset","SPN_Description":"Command signal used to reset the engine rebuild hours.\\r\\n\\r\\n00 Do not reset\\r\\n01 Reset\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1212":{"PGN":65172,"PGN_Name":"Engine Auxiliary Coolant","PGN_Description":"EAC","first_bit":8,"SPN":1212,"SPN_Name":"Engine Auxiliary Coolant Temperature","SPN_Description":"Temperature of coolant found in the intercooler which is located after the turbocharger.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1237":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":62,"SPN":1237,"SPN_Name":"Engine Shutdown Override Switch","SPN_Description":"Switch signal which indicates the position of the engine shutdown override switch.  This switch function allows the operator to override an impending engine shutdown.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1238":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":22,"SPN":1238,"SPN_Name":"Traction Control Override Switch","SPN_Description":"Switch signal which indicates the position of the traction control override switch.  The traction control override signal disables the automatic traction control function allowing the wheels to spin.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1239":{"PGN":65169,"PGN_Name":"Fuel Leakage","PGN_Description":"FL","first_bit":0,"SPN":1239,"SPN_Name":"Engine Fuel Leakage 1","SPN_Description":"Status signal which indicates fuel leakage in the fuel rail of the engine. Location can be either before or after the fuel pump.  \\r\\n\\r\\n00 - no leakage detected\\r\\n01 - leakage detected\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1240":{"PGN":65169,"PGN_Name":"Fuel Leakage","PGN_Description":"FL","first_bit":2,"SPN":1240,"SPN_Name":"Engine Fuel Leakage 2","SPN_Description":"Status signal which indicates fuel leakage in the fuel rail of the engine. Location can be either before or after the fuel pump.  \\r\\n\\r\\n00 - no leakage detected\\r\\n01 - leakage detected\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1241":{"PGN":65170,"PGN_Name":"Engine Information 1","PGN_Description":"EI1","first_bit":32,"SPN":1241,"SPN_Name":"Engine Fuel System 1 Gas Mass Flow Rate","SPN_Description":"Gas mass flow rate delivered to an engine through its first fuel control system.  See SPN 3467 for the second fuel control system.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kg/h","SLOT_ID":18},"1242":{"PGN":65170,"PGN_Name":"Engine Information 1","PGN_Description":"EI1","first_bit":48,"SPN":1242,"SPN_Name":"Instantaneous Estimated Brake Power","SPN_Description":"Estimate of the power developed by the engine.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"1243":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":40,"SPN":1243,"SPN_Name":"ABS Fully Operational","SPN_Description":"Signal which indicates whether an ABS system is fully operational or whether its functionality is reduced by a defect or by an intended action (e.g., by activation of an ABS-off-road switch or during special diagnostic procedures).  There are cases where the signal is necessary to fulfill legal regulations for special applications (e.g., switching off integrated retarders).\\r\\n\\r\\n00 - Not Fully Operational\\r\\n01 - Fully Operational\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1244":{"PGN":61466,"PGN_Name":"Engine Throttle / Fuel Actuator Control Command","PGN_Description":"TFAC","first_bit":48,"SPN":1244,"SPN_Name":"Engine Fuel Actuator 2 Control Command","SPN_Description":"The control command to fuel actuator 2, normalized to percent, where 0% represents fully closed and 100% represents fully open. Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position. If only 2 actuators are present, then left/front is #1 (SPN 633) and right/rear is #2 (SPN 1244). If more than two actuators are present, then left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"1245":{"PGN":64670,"PGN_Name":"Engine Timing Actuator Position","PGN_Description":"ETAP","first_bit":3,"SPN":1245,"SPN_Name":"Engine Timing Actuator 2","SPN_Description":"The detected position of actuator 2 on the Engine Timing System, where the system has different timing positions depending on current operating status of the engine. Timing positions may be used to determine intake and outlet valve timings.\\r\\n\\r\\n000 - Unknown Position\\r\\n001 - Diesel Mode Position\\r\\n010 - Diesel Part Load Position\\r\\n011 - Gas Mode Position\\r\\n100 - Diesel Part Load / Gas Mode Position\\r\\n101 - 110 - Reserved\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1246":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":0,"SPN":1246,"SPN_Name":"Number of Engine Torque History Records","SPN_Description":"Number of torque history records contained in the engine torque history PGN.  A value of 0 is broadcast if no torque history records are stored in the ECU.","bit_length":8,"scaling":1,"offset":0,"unit":"Record","SLOT_ID":33},"1247":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":8,"SPN":1247,"SPN_Name":"Engine Power","SPN_Description":"Advertised engine power capability.  Advertised power is what a customer will find on a sales sheet for an engine with a certain calibration.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"1248":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":24,"SPN":1248,"SPN_Name":"Engine Peak Torque 1","SPN_Description":"Maximum torque output of the current ECU calibration when the engine operates on torque curve 1.  For calibrations that support two torque curves, this parameter shall be assigned the value of the lower curve.  For calibrations that support only one curve, this parameter should be used.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1249":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":40,"SPN":1249,"SPN_Name":"Engine Peak Torque 2","SPN_Description":"Maximum torque output of the current ECU calibration when the engine operates on torque curve 2.  For calibrations that support two torque curves, this parameter shall be assigned the value of the higher curve.  For calibrations that support only one curve, this parameter should to set to \u201Cnot available\u201D.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1250":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":56,"SPN":1250,"SPN_Name":"Calibration Record Start Month","SPN_Description":"Calendar month timestamp when an ECU record was established.\\r\\n\\r\\nNOTE - A value of 0 for the month is null.  The value 1 identifies January; 2 identifies February; etc.","bit_length":8,"scaling":1,"offset":0,"unit":"months","SLOT_ID":62},"1251":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":64,"SPN":1251,"SPN_Name":"Calibration Record Start Day","SPN_Description":"Calendar day timestamp when an ECU record was established.\\r\\n\\r\\nNOTE - A value of 0 for the date is null.  The values 1, 2, 3, and 4 are used to identify the first day of the month; 5, 6, 7, and 8 identify the second day of the month; etc.","bit_length":8,"scaling":0.25,"offset":0,"unit":"days","SLOT_ID":60},"1252":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":72,"SPN":1252,"SPN_Name":"Calibration Record Start Year","SPN_Description":"Calendar year timestamp when an ECU record was established.\\r\\n\\r\\nNOTE - A value of 0 for the year identifies the year 1985; a value of 1 identifies 1986; etc.","bit_length":8,"scaling":1,"offset":1985,"unit":"years","SLOT_ID":66},"1253":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":80,"SPN":1253,"SPN_Name":"Calibration Record Duration Time","SPN_Description":"Duration in hours for which the engine operated in the conditions captured in the current record.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"1254":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":112,"SPN":1254,"SPN_Name":"Torque Limiting Feature Status","SPN_Description":"Status of an ECU feature which limits the torque output of the engine. \\r\\n\\r\\n00 - Disabled\\r\\n01 - Enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1255":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":120,"SPN":1255,"SPN_Name":"Transmission Gear Ratio 1","SPN_Description":"Gear ratio value stored in the ECU that is used to define a range of transmission gears for which a limit is applied to the engine output torque.  Transmission gear ratio 1 should be the numerically highest transmission gear ratio breakpoint that defines ratio ranges for torque limits.","bit_length":16,"scaling":1,"offset":0,"unit":null,"SLOT_ID":23},"1256":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":136,"SPN":1256,"SPN_Name":"Engine Torque Limit 1, Transmission","SPN_Description":"Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically greater than transmission gear ratio 1 (see SPN 1255).","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1257":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":152,"SPN":1257,"SPN_Name":"Transmission Gear Ratio 2","SPN_Description":"Gear ratio value stored in the ECU that is used to define a range of transmission gears for which a limit is applied to the engine output torque.  Transmission gear ratio 2 should be the numerically highest transmission gear ratio breakpoint less than transmission gear ratio 1 (see SPN 1255) that defines ratio ranges for torque limits.","bit_length":16,"scaling":1,"offset":0,"unit":null,"SLOT_ID":23},"1258":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":168,"SPN":1258,"SPN_Name":"Engine Torque Limit 2, Transmission","SPN_Description":"Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically less than or equal to transmission gear ratio 1 (see SPN 1255) and numerically greater than transmission gear ratio 2 (see.SPN 1257).  For example, with transmission gear ratio 1 equal to 12.0:1 and transmission gear ratio 2 equal to 5.0:1, vehicle operation in a transmission gear with a ratio of 6.0:1 will result in the application of engine torque limit 2, transmission.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1259":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":184,"SPN":1259,"SPN_Name":"Transmission Gear Ratio 3","SPN_Description":"Gear ratio value stored in the ECU that is used to define a range of transmission gears for which a limit is applied to the engine output torque.  Transmission gear ratio 3 should be the numerically highest transmission gear ratio breakpoint less than transmission gear ratio 2 (see SPN 1257) that defines ratio ranges for torque limits.","bit_length":16,"scaling":1,"offset":0,"unit":null,"SLOT_ID":23},"1260":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":200,"SPN":1260,"SPN_Name":"Engine Torque Limit 3, Transmission","SPN_Description":"Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically less than or equal to transmission gear ratio 2 (see SPN 1257) and numerically greater than transmission gear ratio 3 (see.SPN 1259).  For example, with transmission gear ratio 2 equal to 5.0:1 and transmission gear ratio 3 equal to 2.0:1, vehicle operation in a transmission gear with a ratio of 3.0:1 will result in the application of engine torque limit 3, transmission.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1261":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":216,"SPN":1261,"SPN_Name":"Engine Torque Limit 4, Transmission","SPN_Description":"Limit applied to the engine output torque during vehicle operation in transmission gear ratios numerically less than or equal to transmission gear ratio 3 (see SPN 1259).","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1262":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":232,"SPN":1262,"SPN_Name":"Engine Torque Limit 5, Switch","SPN_Description":"Limit applied to the engine output torque based on activation of an ECU switch input.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1263":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":248,"SPN":1263,"SPN_Name":"Engine Torque Limit 6, Axle Input","SPN_Description":"Limit applied to the engine output torque based on the maximum allowable axle input torque.  Axle input torque is calculated as the current engine torque output multiplied by the transmission gear ratio.","bit_length":16,"scaling":2,"offset":0,"unit":"Nm","SLOT_ID":98},"1294":{"PGN":64887,"PGN_Name":"Engine Spark Voltage 1","PGN_Description":"ESV1","first_bit":0,"SPN":1294,"SPN_Name":"Engine Spark Plug 1","SPN_Description":"The measured voltage of the spark event on Cylinder #1","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1295":{"PGN":64887,"PGN_Name":"Engine Spark Voltage 1","PGN_Description":"ESV1","first_bit":16,"SPN":1295,"SPN_Name":"Engine Spark Plug 2","SPN_Description":"The measured voltage of the spark event on Cylinder #2","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1296":{"PGN":64887,"PGN_Name":"Engine Spark Voltage 1","PGN_Description":"ESV1","first_bit":32,"SPN":1296,"SPN_Name":"Engine Spark Plug 3","SPN_Description":"The measured voltage of the spark event on Cylinder #3","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1297":{"PGN":64887,"PGN_Name":"Engine Spark Voltage 1","PGN_Description":"ESV1","first_bit":48,"SPN":1297,"SPN_Name":"Engine Spark Plug 4","SPN_Description":"The measured voltage of the spark event on Cylinder #4","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1298":{"PGN":64886,"PGN_Name":"Engine Spark Voltage 2","PGN_Description":"ESV2","first_bit":0,"SPN":1298,"SPN_Name":"Engine Spark Plug 5","SPN_Description":"The measured voltage of the spark event on Cylinder #5","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1299":{"PGN":64886,"PGN_Name":"Engine Spark Voltage 2","PGN_Description":"ESV2","first_bit":16,"SPN":1299,"SPN_Name":"Engine Spark Plug 6","SPN_Description":"The measured voltage of the spark event on Cylinder #6","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1300":{"PGN":64886,"PGN_Name":"Engine Spark Voltage 2","PGN_Description":"ESV2","first_bit":32,"SPN":1300,"SPN_Name":"Engine Spark Plug 7","SPN_Description":"The measured voltage of the spark event on Cylinder #7","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1301":{"PGN":64886,"PGN_Name":"Engine Spark Voltage 2","PGN_Description":"ESV2","first_bit":48,"SPN":1301,"SPN_Name":"Engine Spark Plug 8","SPN_Description":"The measured voltage of the spark event on Cylinder #8","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1302":{"PGN":64885,"PGN_Name":"Engine Spark Voltage 3","PGN_Description":"ESV3","first_bit":0,"SPN":1302,"SPN_Name":"Engine Spark Plug 9","SPN_Description":"The measured voltage of the spark event on Cylinder #9","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1303":{"PGN":64885,"PGN_Name":"Engine Spark Voltage 3","PGN_Description":"ESV3","first_bit":16,"SPN":1303,"SPN_Name":"Engine Spark Plug 10","SPN_Description":"The measured voltage of the spark event on Cylinder #10","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1304":{"PGN":64885,"PGN_Name":"Engine Spark Voltage 3","PGN_Description":"ESV3","first_bit":32,"SPN":1304,"SPN_Name":"Engine Spark Plug 11","SPN_Description":"The measured voltage of the spark event on Cylinder #11","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1305":{"PGN":64885,"PGN_Name":"Engine Spark Voltage 3","PGN_Description":"ESV3","first_bit":48,"SPN":1305,"SPN_Name":"Engine Spark Plug 12","SPN_Description":"The measured voltage of the spark event on Cylinder #12","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1306":{"PGN":64884,"PGN_Name":"Engine Spark Voltage 4","PGN_Description":"ESV4","first_bit":0,"SPN":1306,"SPN_Name":"Engine Spark Plug 13","SPN_Description":"The measured voltage of the spark event on Cylinder #13","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1307":{"PGN":64884,"PGN_Name":"Engine Spark Voltage 4","PGN_Description":"ESV4","first_bit":16,"SPN":1307,"SPN_Name":"Engine Spark Plug 14","SPN_Description":"The measured voltage of the spark event on Cylinder #14","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1308":{"PGN":64884,"PGN_Name":"Engine Spark Voltage 4","PGN_Description":"ESV4","first_bit":32,"SPN":1308,"SPN_Name":"Engine Spark Plug 15","SPN_Description":"The measured voltage of the spark event on Cylinder #15","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1309":{"PGN":64884,"PGN_Name":"Engine Spark Voltage 4","PGN_Description":"ESV4","first_bit":48,"SPN":1309,"SPN_Name":"Engine Spark Plug 16","SPN_Description":"The measured voltage of the spark event on Cylinder #16","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1310":{"PGN":64883,"PGN_Name":"Engine Spark Voltage 5","PGN_Description":"ESV5","first_bit":0,"SPN":1310,"SPN_Name":"Engine Spark Plug 17","SPN_Description":"The measured voltage of the spark event on Cylinder #17","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1311":{"PGN":64883,"PGN_Name":"Engine Spark Voltage 5","PGN_Description":"ESV5","first_bit":16,"SPN":1311,"SPN_Name":"Engine Spark Plug 18","SPN_Description":"The measured voltage of the spark event on Cylinder #18","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1312":{"PGN":64883,"PGN_Name":"Engine Spark Voltage 5","PGN_Description":"ESV5","first_bit":32,"SPN":1312,"SPN_Name":"Engine Spark Plug 19","SPN_Description":"The measured voltage of the spark event on Cylinder #19","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1313":{"PGN":64883,"PGN_Name":"Engine Spark Voltage 5","PGN_Description":"ESV5","first_bit":48,"SPN":1313,"SPN_Name":"Engine Spark Plug 20","SPN_Description":"The measured voltage of the spark event on Cylinder #20","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1314":{"PGN":64882,"PGN_Name":"Engine Spark Voltage 6","PGN_Description":"ESV6","first_bit":0,"SPN":1314,"SPN_Name":"Engine Spark Plug 21","SPN_Description":"The measured voltage of the spark event on Cylinder #21","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1315":{"PGN":64882,"PGN_Name":"Engine Spark Voltage 6","PGN_Description":"ESV6","first_bit":16,"SPN":1315,"SPN_Name":"Engine Spark Plug 22","SPN_Description":"The measured voltage of the spark event on Cylinder #22","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1316":{"PGN":64882,"PGN_Name":"Engine Spark Voltage 6","PGN_Description":"ESV6","first_bit":32,"SPN":1316,"SPN_Name":"Engine Spark Plug 23","SPN_Description":"The measured voltage of the spark event on Cylinder #23","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1317":{"PGN":64882,"PGN_Name":"Engine Spark Voltage 6","PGN_Description":"ESV6","first_bit":48,"SPN":1317,"SPN_Name":"Engine Spark Plug 24","SPN_Description":"The measured voltage of the spark event on Cylinder #24","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"1320":{"PGN":65167,"PGN_Name":"Supply Pressure 2","PGN_Description":"SP2","first_bit":0,"SPN":1320,"SPN_Name":"Engine External Shutdown Air Supply Pressure","SPN_Description":"Pressure of the air used to shut off the fuel supply to the engine.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"1349":{"PGN":65243,"PGN_Name":"Engine Fluid Level/Pressure 2","PGN_Description":"EFL/P2","first_bit":48,"SPN":1349,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 2 Pressure","SPN_Description":"The gage pressure of fuel in the metering rail #2 as delivered from the supply pump to the injector metering intake.  See Figure SPN16_A for fuel system related parameters.  Although the figure does not show rail #2 it does show the relationship of rail pressure to other signals.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"1350":{"PGN":65166,"PGN_Name":"Service 2","PGN_Description":"S2","first_bit":8,"SPN":1350,"SPN_Name":"Time Since Last Service","SPN_Description":"The vehicle operation time since the last service was performed.  The type of service information is identified by the service component identification number.","bit_length":16,"scaling":1,"offset":-32127,"unit":"h","SLOT_ID":5},"1351":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":48,"SPN":1351,"SPN_Name":"Air Compressor Status","SPN_Description":"Indicates whether the air compressor is actively compressing air.  \\r\\n\\r\\n00     Compressor not active\\r\\n01     Compressor active\\r\\n10     Error indicator\\r\\n11     Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1352":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":0,"SPN":1352,"SPN_Name":"Engine Cylinder 1 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 1. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6398 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1353":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":8,"SPN":1353,"SPN_Name":"Engine Cylinder 2 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 2. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6402 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1354":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":16,"SPN":1354,"SPN_Name":"Engine Cylinder 3 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 3. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6406 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1355":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":24,"SPN":1355,"SPN_Name":"Engine Cylinder 4 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 4. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6410 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1356":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":32,"SPN":1356,"SPN_Name":"Engine Cylinder 5 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 5. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6414 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1357":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":40,"SPN":1357,"SPN_Name":"Engine Cylinder 6 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 6. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6418 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1358":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":48,"SPN":1358,"SPN_Name":"Engine Cylinder 7 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 7. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6422 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1359":{"PGN":61463,"PGN_Name":"Engine Knock Level #1","PGN_Description":"KL1","first_bit":56,"SPN":1359,"SPN_Name":"Engine Cylinder 8 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 8. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6426 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1360":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":0,"SPN":1360,"SPN_Name":"Engine Cylinder 9 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 9. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6430 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1361":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":8,"SPN":1361,"SPN_Name":"Engine Cylinder 10 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 10. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6434 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1362":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":16,"SPN":1362,"SPN_Name":"Engine Cylinder 11 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 11. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6438 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1363":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":24,"SPN":1363,"SPN_Name":"Engine Cylinder 12 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 12. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6442 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1364":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":32,"SPN":1364,"SPN_Name":"Engine Cylinder 13 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 13. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6446 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1365":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":40,"SPN":1365,"SPN_Name":"Engine Cylinder 14 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 14. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6450 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1366":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":48,"SPN":1366,"SPN_Name":"Engine Cylinder 15 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 15. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6454 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1367":{"PGN":61464,"PGN_Name":"Engine Knock Level #2","PGN_Description":"KL2","first_bit":56,"SPN":1367,"SPN_Name":"Engine Cylinder 16 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 16. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6458 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1368":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":0,"SPN":1368,"SPN_Name":"Engine Cylinder 17 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 17. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6462 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1369":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":8,"SPN":1369,"SPN_Name":"Engine Cylinder 18 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 18. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6466 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1370":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":16,"SPN":1370,"SPN_Name":"Engine Cylinder 19 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 19. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6470 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1371":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":24,"SPN":1371,"SPN_Name":"Engine Cylinder 20 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 20. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nUse SPN 6474 if knock level information is time critical or needs to be combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1372":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":32,"SPN":1372,"SPN_Name":"Engine Cylinder 21 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 21. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1373":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":40,"SPN":1373,"SPN_Name":"Engine Cylinder 22 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 22. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1374":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":48,"SPN":1374,"SPN_Name":"Engine Cylinder 23 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 23. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1375":{"PGN":61465,"PGN_Name":"Engine Knock Level #3","PGN_Description":"KL3","first_bit":56,"SPN":1375,"SPN_Name":"Engine Cylinder 24 Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 24. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1377":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":2,"SPN":1377,"SPN_Name":"Engine Synchronization Switch","SPN_Description":"This is the On/Off operation of the Multiple Unit Synchronization functionality. When it is enabled (i.e. On) the master engine will synchronize one or more slave engines to operate at the same speed. This switch position indicates whether this feature is disabled (off) or enabled (on). \\r\\n\\r\\n\\r\\n00 Functionality is disabled (off)\\r\\n01 Functionality is enabled (on)\\r\\n10 Error\\r\\n11 Not available or Unused","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1379":{"PGN":65166,"PGN_Name":"Service 2","PGN_Description":"S2","first_bit":0,"SPN":1379,"SPN_Name":"Service Component Identification","SPN_Description":"Identification of component needing service.  See Table SPN911_A.","bit_length":8,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":25},"1380":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":0,"SPN":1380,"SPN_Name":"Engine Oil Level Remote Reservoir","SPN_Description":"Ratio of current volume of engine oil in a remote reservoir to the maximum required volume.  If a single switch (on/off) is used, 20% and 100% respectively will be used where 100% means no oil needs to be added and 20% means oil needs to be added.  If two switches are used, 20%, 50%, and 100% will be used where 20% indicates the oil is critically low, 50% indicates the oil level is low, and 100% means no oil needs to be added.  For continuous sensors, the actual measured percent will be used.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1381":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":8,"SPN":1381,"SPN_Name":"Engine Fuel Supply Pump Intake Absolute Pressure","SPN_Description":"Absolute pressure of fuel at the fuel supply pump intake.  See Figures SPN16_A & SPN16_B.  See SPN 7472 for alternate resolution.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"1382":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":16,"SPN":1382,"SPN_Name":"Engine Fuel Filter (suction side) Differential Pressure","SPN_Description":"Differential pressure measured across the fuel filter located between the fuel tank and the supply pump.  See Figures SPN16_A and SPN16_B.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"1387":{"PGN":65164,"PGN_Name":"Auxiliary Analog Information","PGN_Description":"AAI","first_bit":16,"SPN":1387,"SPN_Name":"Auxiliary Pressure #1","SPN_Description":"Pressure measured by auxiliary pressure sensor #1.  Not to be used in place of existing SPNs.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"1388":{"PGN":65164,"PGN_Name":"Auxiliary Analog Information","PGN_Description":"AAI","first_bit":24,"SPN":1388,"SPN_Name":"Auxiliary Pressure #2","SPN_Description":"Pressure measured by auxiliary pressure sensor #2.  Not to be used in place of existing SPNs.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"1389":{"PGN":65202,"PGN_Name":"Fuel Information 1 (Gaseous)","PGN_Description":"GFI1","first_bit":48,"SPN":1389,"SPN_Name":"Engine Fuel Specific Gravity","SPN_Description":"This parameter conveys the specific gravity of the gaseous fuel being used by the engine.  The specific gravity of the fuel can then be used to compute the density of the fuel.","bit_length":16,"scaling":1,"offset":0,"unit":null,"SLOT_ID":82},"1390":{"PGN":65163,"PGN_Name":"Gaseous Fuel Pressure 1","PGN_Description":"GFP1","first_bit":0,"SPN":1390,"SPN_Name":"Engine Fuel Valve 1 Intake Absolute Pressure","SPN_Description":"The absolute pressure of gas on the intake side of the first system control valve.  See SPN 3466 for Engine Fuel Valve 2, 7505 for Engine Fuel Valve 3 & 7506 for Engine Fuel Valve 4.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1391":{"PGN":65163,"PGN_Name":"Gaseous Fuel Pressure 1","PGN_Description":"GFP1","first_bit":16,"SPN":1391,"SPN_Name":"Engine Fuel Valve 1 Differential Pressure","SPN_Description":"The differential pressure between the intake and the outlet of the first or only gaseous fuel valve.\\r\\n\\r\\nSee SPN 8494 for alternate range and resolution.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1392":{"PGN":65163,"PGN_Name":"Gaseous Fuel Pressure 1","PGN_Description":"GFP1","first_bit":32,"SPN":1392,"SPN_Name":"Engine Air to Fuel Differential Pressure","SPN_Description":"The differential pressure between the gaseous fuel and the air intake manifold.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1393":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":0,"SPN":1393,"SPN_Name":"Engine Cylinder 1 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1394":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":8,"SPN":1394,"SPN_Name":"Engine Cylinder 2 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1395":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":16,"SPN":1395,"SPN_Name":"Engine Cylinder 3 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1396":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":24,"SPN":1396,"SPN_Name":"Engine Cylinder 4 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1397":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":32,"SPN":1397,"SPN_Name":"Engine Cylinder 5 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1398":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":40,"SPN":1398,"SPN_Name":"Engine Cylinder 6 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1399":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":48,"SPN":1399,"SPN_Name":"Engine Cylinder 7 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1400":{"PGN":65160,"PGN_Name":"Ignition Transformer Secondary Output 1","PGN_Description":"ISO1","first_bit":56,"SPN":1400,"SPN_Name":"Engine Cylinder 8 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1401":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":0,"SPN":1401,"SPN_Name":"Engine Cylinder 9 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1402":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":8,"SPN":1402,"SPN_Name":"Engine Cylinder 10 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1403":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":16,"SPN":1403,"SPN_Name":"Engine Cylinder 11 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1404":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":24,"SPN":1404,"SPN_Name":"Engine Cylinder 12 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1405":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":32,"SPN":1405,"SPN_Name":"Engine Cylinder 13 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1406":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":40,"SPN":1406,"SPN_Name":"Engine Cylinder 14 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1407":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":48,"SPN":1407,"SPN_Name":"Engine Cylinder 15 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1408":{"PGN":65161,"PGN_Name":"Ignition Transformer Secondary Output 2","PGN_Description":"ISO2","first_bit":56,"SPN":1408,"SPN_Name":"Engine Cylinder 16 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1409":{"PGN":65162,"PGN_Name":"Ignition Transformer Secondary Output 3","PGN_Description":"ISO3","first_bit":0,"SPN":1409,"SPN_Name":"Engine Cylinder 17 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1410":{"PGN":65162,"PGN_Name":"Ignition Transformer Secondary Output 3","PGN_Description":"ISO3","first_bit":8,"SPN":1410,"SPN_Name":"Engine Cylinder 18 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1411":{"PGN":65162,"PGN_Name":"Ignition Transformer Secondary Output 3","PGN_Description":"ISO3","first_bit":16,"SPN":1411,"SPN_Name":"Engine Cylinder 19 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1412":{"PGN":65162,"PGN_Name":"Ignition Transformer Secondary Output 3","PGN_Description":"ISO3","first_bit":24,"SPN":1412,"SPN_Name":"Engine Cylinder 20 Ignition Transformer Secondary Output","SPN_Description":"This parameter indicates the relative intensity of the secondary output voltage of the ignition transformer.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1413":{"PGN":65154,"PGN_Name":"Ignition Timing 1","PGN_Description":"IT1","first_bit":0,"SPN":1413,"SPN_Name":"Engine Cylinder 1 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1414":{"PGN":65154,"PGN_Name":"Ignition Timing 1","PGN_Description":"IT1","first_bit":16,"SPN":1414,"SPN_Name":"Engine Cylinder 2 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1415":{"PGN":65154,"PGN_Name":"Ignition Timing 1","PGN_Description":"IT1","first_bit":32,"SPN":1415,"SPN_Name":"Engine Cylinder 3 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1416":{"PGN":65154,"PGN_Name":"Ignition Timing 1","PGN_Description":"IT1","first_bit":48,"SPN":1416,"SPN_Name":"Engine Cylinder 4 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1417":{"PGN":65155,"PGN_Name":"Ignition Timing 2","PGN_Description":"IT2","first_bit":0,"SPN":1417,"SPN_Name":"Engine Cylinder 5 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1418":{"PGN":65155,"PGN_Name":"Ignition Timing 2","PGN_Description":"IT2","first_bit":16,"SPN":1418,"SPN_Name":"Engine Cylinder 6 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1419":{"PGN":65155,"PGN_Name":"Ignition Timing 2","PGN_Description":"IT2","first_bit":32,"SPN":1419,"SPN_Name":"Engine Cylinder 7 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1420":{"PGN":65155,"PGN_Name":"Ignition Timing 2","PGN_Description":"IT2","first_bit":48,"SPN":1420,"SPN_Name":"Engine Cylinder 8 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1421":{"PGN":65156,"PGN_Name":"Ignition Timing 3","PGN_Description":"IT3","first_bit":0,"SPN":1421,"SPN_Name":"Engine Cylinder 9 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1422":{"PGN":65156,"PGN_Name":"Ignition Timing 3","PGN_Description":"IT3","first_bit":16,"SPN":1422,"SPN_Name":"Engine Cylinder 10 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1423":{"PGN":65156,"PGN_Name":"Ignition Timing 3","PGN_Description":"IT3","first_bit":32,"SPN":1423,"SPN_Name":"Engine Cylinder 11 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1424":{"PGN":65156,"PGN_Name":"Ignition Timing 3","PGN_Description":"IT3","first_bit":48,"SPN":1424,"SPN_Name":"Engine Cylinder 12 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1425":{"PGN":65157,"PGN_Name":"Ignition Timing 4","PGN_Description":"IT4","first_bit":0,"SPN":1425,"SPN_Name":"Engine Cylinder 13 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1426":{"PGN":65157,"PGN_Name":"Ignition Timing 4","PGN_Description":"IT4","first_bit":16,"SPN":1426,"SPN_Name":"Engine Cylinder 14 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1427":{"PGN":65157,"PGN_Name":"Ignition Timing 4","PGN_Description":"IT4","first_bit":32,"SPN":1427,"SPN_Name":"Engine Cylinder 15 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1428":{"PGN":65157,"PGN_Name":"Ignition Timing 4","PGN_Description":"IT4","first_bit":48,"SPN":1428,"SPN_Name":"Engine Cylinder 16 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1429":{"PGN":65158,"PGN_Name":"Ignition Timing 5","PGN_Description":"IT5","first_bit":0,"SPN":1429,"SPN_Name":"Engine Cylinder 17 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1430":{"PGN":65158,"PGN_Name":"Ignition Timing 5","PGN_Description":"IT5","first_bit":16,"SPN":1430,"SPN_Name":"Engine Cylinder 18 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1431":{"PGN":65158,"PGN_Name":"Ignition Timing 5","PGN_Description":"IT5","first_bit":32,"SPN":1431,"SPN_Name":"Engine Cylinder 19 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1432":{"PGN":65158,"PGN_Name":"Ignition Timing 5","PGN_Description":"IT5","first_bit":48,"SPN":1432,"SPN_Name":"Engine Cylinder 20 Ignition Timing","SPN_Description":"The ignition timing (SI engines) or main fuel injection timing (CI engines) of the cylinder. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1433":{"PGN":65159,"PGN_Name":"Ignition Timing 6","PGN_Description":"IT6","first_bit":0,"SPN":1433,"SPN_Name":"Engine Desired Ignition Timing 1","SPN_Description":"A programmable timing value specific to the engine\u2019s application. Factors affecting this value include both fuel type and the nature of the load being driven. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1434":{"PGN":65159,"PGN_Name":"Ignition Timing 6","PGN_Description":"IT6","first_bit":16,"SPN":1434,"SPN_Name":"Engine Desired Ignition Timing 2","SPN_Description":"A programmable timing value specific to the engine\u2019s application. Factors affecting this value include both fuel type and the nature of the load being driven. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1435":{"PGN":65159,"PGN_Name":"Ignition Timing 6","PGN_Description":"IT6","first_bit":32,"SPN":1435,"SPN_Name":"Engine Desired Ignition Timing 3","SPN_Description":"A programmable timing value specific to the engine\u2019s application. Factors affecting this value include both fuel type and the nature of the load being driven. Positive values indicate an increasingly advanced timing from TDC.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1436":{"PGN":65159,"PGN_Name":"Ignition Timing 6","PGN_Description":"IT6","first_bit":48,"SPN":1436,"SPN_Name":"Engine Actual Ignition Timing","SPN_Description":"The actual ignition timing at the current engine conditions. This parameter may or may not be equal to one of the desired timing parameters (see SPNs 1433-1435), depending on the status of the engine. Positive values indicate an increasingly advanced timing from TDC. See SPN 7355 for commanded ignition timing.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"1437":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":4,"SPN":1437,"SPN_Name":"Road Speed Limit Status","SPN_Description":"Status (active or not active) of the system used to limit maximum vehicle velocity.\\r\\n\\r\\n00 - Active\\r\\n01 - Not Active\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nNOTE - While somewhat inconsistent with other J1939 status parameters, the states defining 00 = active and 01 = inactive for Road Speed Limit Status are NOT typographical errors, and should be implemented as stated.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1438":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":44,"SPN":1438,"SPN_Name":"ABS/EBS Amber Warning Signal (Powered Vehicle)","SPN_Description":"This parameter commands the ABS/EBS amber/yellow optical warning signal\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1439":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":42,"SPN":1439,"SPN_Name":"EBS Red Warning Signal","SPN_Description":"This parameter commands the EBS red optical warning signal\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1440":{"PGN":65153,"PGN_Name":"Fuel Information 2 (Gaseous)","PGN_Description":"GFI2","first_bit":0,"SPN":1440,"SPN_Name":"Engine Fuel Flow Rate 1","SPN_Description":"The rate at which the fuel is flowing through a fuel valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"m\xb3/h","SLOT_ID":19},"1441":{"PGN":65153,"PGN_Name":"Fuel Information 2 (Gaseous)","PGN_Description":"GFI2","first_bit":16,"SPN":1441,"SPN_Name":"Engine Fuel Flow Rate 2","SPN_Description":"The rate at which the fuel is flowing through a fuel valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"m\xb3/h","SLOT_ID":19},"1442":{"PGN":65153,"PGN_Name":"Fuel Information 2 (Gaseous)","PGN_Description":"GFI2","first_bit":32,"SPN":1442,"SPN_Name":"Engine Fuel Valve 1 Position","SPN_Description":"The position of a gaseous fuel valve that is metering the fuel flow to the engine.  0% indicates no fuel flow through valve and 100% means maximum fuel flow through valve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1443":{"PGN":65153,"PGN_Name":"Fuel Information 2 (Gaseous)","PGN_Description":"GFI2","first_bit":40,"SPN":1443,"SPN_Name":"Engine Fuel Valve 2 Position","SPN_Description":"The position of a gaseous fuel valve that is metering the fuel flow to the engine.  0% indicates no fuel flow through valve and 100% means maximum fuel flow through valve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1444":{"PGN":65147,"PGN_Name":"Combustion Time 1","PGN_Description":"CT1","first_bit":0,"SPN":1444,"SPN_Name":"Engine Cylinder #1 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1445":{"PGN":65147,"PGN_Name":"Combustion Time 1","PGN_Description":"CT1","first_bit":16,"SPN":1445,"SPN_Name":"Engine Cylinder #2 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1446":{"PGN":65147,"PGN_Name":"Combustion Time 1","PGN_Description":"CT1","first_bit":32,"SPN":1446,"SPN_Name":"Engine Cylinder #3 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1447":{"PGN":65147,"PGN_Name":"Combustion Time 1","PGN_Description":"CT1","first_bit":48,"SPN":1447,"SPN_Name":"Engine Cylinder #4 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1448":{"PGN":65148,"PGN_Name":"Combustion Time 2","PGN_Description":"CT2","first_bit":0,"SPN":1448,"SPN_Name":"Engine Cylinder #5 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1449":{"PGN":65148,"PGN_Name":"Combustion Time 2","PGN_Description":"CT2","first_bit":16,"SPN":1449,"SPN_Name":"Engine Cylinder #6 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1450":{"PGN":65148,"PGN_Name":"Combustion Time 2","PGN_Description":"CT2","first_bit":32,"SPN":1450,"SPN_Name":"Engine Cylinder #7 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1451":{"PGN":65148,"PGN_Name":"Combustion Time 2","PGN_Description":"CT2","first_bit":48,"SPN":1451,"SPN_Name":"Engine Cylinder #8 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1452":{"PGN":65149,"PGN_Name":"Combustion Time 3","PGN_Description":"CT3","first_bit":0,"SPN":1452,"SPN_Name":"Engine Cylinder #9 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1453":{"PGN":65149,"PGN_Name":"Combustion Time 3","PGN_Description":"CT3","first_bit":16,"SPN":1453,"SPN_Name":"Engine Cylinder #10 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1454":{"PGN":65149,"PGN_Name":"Combustion Time 3","PGN_Description":"CT3","first_bit":32,"SPN":1454,"SPN_Name":"Engine Cylinder #11 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1455":{"PGN":65149,"PGN_Name":"Combustion Time 3","PGN_Description":"CT3","first_bit":48,"SPN":1455,"SPN_Name":"Engine Cylinder #12 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1456":{"PGN":65150,"PGN_Name":"Combustion Time 4","PGN_Description":"CT4","first_bit":0,"SPN":1456,"SPN_Name":"Engine Cylinder #13 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1457":{"PGN":65150,"PGN_Name":"Combustion Time 4","PGN_Description":"CT4","first_bit":16,"SPN":1457,"SPN_Name":"Engine Cylinder #14 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1458":{"PGN":65150,"PGN_Name":"Combustion Time 4","PGN_Description":"CT4","first_bit":32,"SPN":1458,"SPN_Name":"Engine Cylinder #15 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1459":{"PGN":65150,"PGN_Name":"Combustion Time 4","PGN_Description":"CT4","first_bit":48,"SPN":1459,"SPN_Name":"Engine Cylinder #16 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1460":{"PGN":65151,"PGN_Name":"Combustion Time 5","PGN_Description":"CT5","first_bit":0,"SPN":1460,"SPN_Name":"Engine Cylinder #17 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1461":{"PGN":65151,"PGN_Name":"Combustion Time 5","PGN_Description":"CT5","first_bit":16,"SPN":1461,"SPN_Name":"Engine Cylinder #18 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1462":{"PGN":65151,"PGN_Name":"Combustion Time 5","PGN_Description":"CT5","first_bit":32,"SPN":1462,"SPN_Name":"Engine Cylinder #19 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1463":{"PGN":65151,"PGN_Name":"Combustion Time 5","PGN_Description":"CT5","first_bit":48,"SPN":1463,"SPN_Name":"Engine Cylinder #20 Combustion Time","SPN_Description":"The amount of time from when the ignition of the fuel is initiated to when the fuel is completely ignited (i.e., the flame front has propagated across the cylinder).","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1464":{"PGN":65152,"PGN_Name":"Combustion Time 6","PGN_Description":"CT6","first_bit":0,"SPN":1464,"SPN_Name":"Engine Desired Combustion Time","SPN_Description":"The desired combustion time based upon engine load and speed lookup maps.","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1465":{"PGN":65152,"PGN_Name":"Combustion Time 6","PGN_Description":"CT6","first_bit":16,"SPN":1465,"SPN_Name":"Engine Average Combustion Time","SPN_Description":"The average combustion time of all cylinders of an engine.","bit_length":16,"scaling":0.01,"offset":0,"unit":"ms","SLOT_ID":57},"1466":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":8,"SPN":1466,"SPN_Name":"Steer Channel Mode","SPN_Description":"Indicates the functional mode of steer channel of the tire pressure control system. \\r\\n\\r\\n0000 Maintain\\r\\n0001 Inflate\\r\\n0010 Deflate\\r\\n0011 Confirm\\r\\n0100 Inflate Wait \u2013 System will inflate when conditions allow\\r\\n0101 Deflate Wait \u2013 System will deflate when conditions allow\\r\\n0110 Pressure Check\\r\\n0111-1101 Reserved\\r\\n1110 Error Condition\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1467":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":16,"SPN":1467,"SPN_Name":"Trailer/tag Channel Mode","SPN_Description":"Indicates the functional mode of trailer/tag channel of the tire pressure control system.\\r\\n\\r\\n0000 Maintain\\r\\n0001 Inflate\\r\\n0010 Deflate\\r\\n0011 Confirm\\r\\n0100 Inflate Wait \u2013 System will inflate when conditions allow\\r\\n0101 Deflate Wait \u2013 System will deflate when conditions allow\\r\\n0110 Pressure Check\\r\\n0111-1101 Reserved\\r\\n1110 Error Condition\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1468":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":20,"SPN":1468,"SPN_Name":"Drive Channel Mode","SPN_Description":"Indicates the functional mode of trailer/tag channel of the tire pressure control system.  \\r\\n\\r\\n0000 Maintain\\r\\n0001 Inflate\\r\\n0010 Deflate\\r\\n0011 Confirm\\r\\n0100 Inflate Wait \u2013 System will inflate when conditions allow\\r\\n0101 Deflate Wait \u2013 System will deflate when conditions allow\\r\\n0110 Pressure Check\\r\\n0111-1101 Reserved\\r\\n1110 Error Condition\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1469":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":24,"SPN":1469,"SPN_Name":"PCU Drive Solenoid Status","SPN_Description":"Current state of the drive solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1470":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":26,"SPN":1470,"SPN_Name":"PCU Steer Solenoid Status","SPN_Description":"Current state of the steer solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1471":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":28,"SPN":1471,"SPN_Name":"Tire Pressure Supply Switch Status","SPN_Description":"Current state of an open/closed type switch used to determine if adequate pressure exists for system implementation.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1472":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":32,"SPN":1472,"SPN_Name":"PCU Deflate Solenoid Status","SPN_Description":"Current state of the deflate solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1473":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":34,"SPN":1473,"SPN_Name":"PCU Control Solenoid Status","SPN_Description":"Current state of the control solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1474":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":36,"SPN":1474,"SPN_Name":"PCU Supply Solenoid Status","SPN_Description":"Current state of the supply solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1475":{"PGN":65144,"PGN_Name":"Tire Pressure Control Unit Mode and Status","PGN_Description":"TP1","first_bit":38,"SPN":1475,"SPN_Name":"PCU Trailer, Tag or Push Solenoid Status","SPN_Description":"Current state of the trailer, tag, or push solenoid used to implement a tire pressure control system in its pneumatic control unit (PCU).\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1480":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":32,"SPN":1480,"SPN_Name":"Source Address of Controlling Device for Retarder Control","SPN_Description":"The source address of the SAE J1939 device currently controlling the retarder.  It is used to expand the torque mode parameter (see SPN 899) in cases where control is in response to an ECU that is not listed in Table SPN899_A.  Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-SAE J1939 data link such as SAE J1922 or a proprietary link.","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"1481":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":48,"SPN":1481,"SPN_Name":"Source Address of Controlling Device for Brake Control","SPN_Description":"The source address of the SAE J1939 device currently controlling the brake system. Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-SAE J1939 data link such as SAE J1922 or a proprietary link.","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"1482":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":56,"SPN":1482,"SPN_Name":"Source Address of Controlling Device for Transmission Control","SPN_Description":"The source address of the SAE J1939 device currently controlling the transmission. Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-SAE J1939 data link such as SAE J1922 or a proprietary link.","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"1483":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":40,"SPN":1483,"SPN_Name":"Source Address of Controlling Device for Engine Control","SPN_Description":"The source address of the SAE J1939 device currently controlling the engine.  It is used to expand the torque mode parameter (see SPN 899) in cases where control is in response to an ECU that is not listed in Table SPN899_A.  Its value may be the source address of the ECU transmitting the message (which means that no external SAE J1939 message is providing the active command) or the source address of the SAE J1939 ECU that is currently providing the active command in a TSC1 (see PGN 0) or similar message.  Note that if this parameter value is the same as the source address of the device transmitting it, the control may be due to a message on a non-J1939 data link such as SAE J1922 or a proprietary link.","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"1487":{"PGN":53248,"PGN_Name":"Cab Illumination Message","PGN_Description":"CL","first_bit":0,"SPN":1487,"SPN_Name":"Illumination Brightness Percent","SPN_Description":"Commanded backlight brightness level for all cab displays.  \\r\\n\\r\\nNote:  If a separate device is used to independently control the switch backlight brightness level, see SPN 5532.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1503":{"PGN":64745,"PGN_Name":"Armrest Switch Matrix Commands","PGN_Description":"ARMSWIMC","first_bit":0,"SPN":1503,"SPN_Name":"Armrest 1 Switch 1","SPN_Description":"Status of the first switch located in armrest 1.\\r\\n\\r\\n00: Off\\r\\n01: On\\r\\n10: Reserved\\r\\n11: Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1550":{"PGN":64817,"PGN_Name":"Fan Drive #2","PGN_Description":"FD2","first_bit":0,"SPN":1550,"SPN_Name":"Estimated Percent Fan 2 Speed","SPN_Description":"Estimated fan speed as a ratio of the fan drive (current speed) to the fully engaged fan drive (maximum fan speed).  A two state fan (off/on) will use 0% and 100% respectively.  A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively.  A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided.\\r\\n\\r\\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1557":{"PGN":64817,"PGN_Name":"Fan Drive #2","PGN_Description":"FD2","first_bit":8,"SPN":1557,"SPN_Name":"Fan 2 Drive State","SPN_Description":"This parameter is used to indicate the current state or mode of operation by the second fan drive.\\r\\n\\r\\n0000 Fan off\\r\\n0001 Engine system\u2013General\\r\\n0010 Excessive engine air temperature\\r\\n0011 Excessive engine oil temperature\\r\\n0100 Excessive engine coolant temperature\\r\\n0101 Excessive transmission oil temperature\\r\\n0110 Excessive hydraulic oil temperature\\r\\n0111 Default Operation\\r\\n1000 Reverse Operation\\r\\n1001 Manual control\\r\\n1010 Transmission retarder\\r\\n1011 A/C system\\r\\n1100 Timer\\r\\n1101 Engine brake\\r\\n1110 Other\\r\\n1111 Not available\\r\\n\\r\\nFan off  0000b \u2014Used to indicate that the fan clutch is disengaged and the fan is inactive\\r\\n\\r\\nEngine system\u2013General  0001b \u2014Used to indicate that the fan is active due to an engine system not otherwise defined.\\r\\n\\r\\nExcessive engine air temperature  0010b \u2014Used to indicate that the fan is active due to high air temperature.\\r\\n\\r\\nExcessive engine oil temperature  0011b \u2014Used to indicate that the fan is active due to high oil temperature.\\r\\n\\r\\nExcessive engine coolant temperature  0100b \u2014Used to indicate that the fan is active due to high coolant temperature.\\r\\n\\r\\nReverse Operation  1000b \u2014 Used to indicate that the fan is in reverse direction of operation compared to the normal direction of operation \\r\\n\\r\\nManual control  1001b \u2014Used to indicate that the fan is active as requested by the operator.\\r\\n\\r\\nTransmission retarder  1010b \u2014Used to indicate that the fan is active as required by the transmission retarder.\\r\\n\\r\\nA/C system  1011b \u2014Used to indicate that the fan is active as required by the air conditioning system.\\r\\n\\r\\nTimer  1100b \u2014Used to indicate that the fan is active as required by a timing function.\\r\\n\\r\\nEngine brake  1101b \u2014Used to indicate that the fan is active as required to assist engine braking.\\r\\n\\r\\nExcessive transmission oil temperature - 0101b  - Used to indicate fan is active due to excessive transmission oil temperature.\\r\\n\\r\\nExcessive hydraulic oil temperature - 0110b - Used to indicate fan is active due to excessive hydraulic oil temperature.\\r\\n\\r\\nDefault Operation - 0111b - Used to indicate fan is active due to a error condition resulting in default operation","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1568":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":32,"SPN":1568,"SPN_Name":"Engine Torque Curve Selection","SPN_Description":"This parameter will report the selected torque curve, as indicated by SPN 6796.\\r\\n\\r\\n0 - Indicates that the engine is using a torque that is not presently selected by SPN 6796\\r\\n1 - Indicates that Torque Curve 1 is selected\\r\\n2 - Indicates that Torque Curve 2 is selected\\r\\n3 to 13 - Indicates that Torque Curve 3 through 13 is selected\\r\\n14 - Error\\r\\n15 - Not supported","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1573":{"PGN":65142,"PGN_Name":"Laser Leveling System Vertical Position Display Data","PGN_Description":"LVDD","first_bit":0,"SPN":1573,"SPN_Name":"LED Display Data #1","SPN_Description":"Informs display devices how to display the current vertical position.\\r\\n\\r\\nValues which are less than 128 decimal are bit-mapped values and any combination of these values is considered a valid value.  For example communicating the \\"High Fine LED on\\" value to the display would result in the High Fine LED being turned on.  Communicating a value with the \\"High Fine LED on\\" bit set to \\"1\\" and the \\"On-Grade LED on\\" bit set to \\"1\\" should result in the display turning on the High Fine LED AND the On-Grade LED.  \\r\\n\\r\\nValues 128 decimal and above are discrete states.  Any bit-mapped combination of these states are invalid unless the results correspond to one of the states defined.  For example, the result of adding the \\"Low Coarse\\" and \\"Low Medium\\" states results in the \\"Low Medium\\" state, which is valid.  However, adding the \\"Low Medium\\" and the \\"Low Fine\\" states results in an value which does not have a defined state and is invalid.\\r\\n\\r\\n00000010 High Coarse LED on\\r\\n00000100 High Fine LED on\\r\\n00001000 On-grade LED on\\r\\n00010000 Low Fine LED on\\r\\n00100000 Low Coarse LED on\\r\\n\\r\\n10000000 Low Coarse\\r\\n10000001 Low Medium/Coarse\\r\\n10000010 Low Medium\\r\\n10000011 Low Medium/Fine\\r\\n10000100 Low Fine\\r\\n10010000 On Grade\\r\\n10010001 High Fine\\r\\n10010010 High Medium/Fine\\r\\n10010011 High Medium\\r\\n10010100 High Medium/Coarse\\r\\n10010101 High Coarse\\r\\n10011111 No data (i.e. no laser strikes)\\r\\n11111110 Error\\r\\n11111111 Not Available\\r\\n\\r\\nUndefined values between 10100000 binary and 11111101 binary are reserved for future use.","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"1574":{"PGN":65141,"PGN_Name":"Laser Leveling System Vertical Deviation","PGN_Description":"LVD","first_bit":0,"SPN":1574,"SPN_Name":"Laser Strike Vertical Deviation","SPN_Description":"The calculated distance from the laser strike position to the current land leveling system reference point.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1575":{"PGN":65140,"PGN_Name":"Modify Leveling System Control Set Point","PGN_Description":"LSP","first_bit":0,"SPN":1575,"SPN_Name":"Modify Leveling System Set Point","SPN_Description":"Used to control and coordinate the set point for the leveling system.\\r\\n\\r\\nOperating Range: -3200 to +3200 mm, negative values are below current position, positive values are above current position, zero is no change.\\r\\nParameter specific parameter:\\r\\n0xFE01 indicates Stop modifying the set point\\r\\n0xFE03 indicates Raise the current set point by 5 mm\\r\\n0xFE11 indicates Lower the current set point by 5 mm\\r\\n0xFE13 indicates Search for laser or target\\r\\n0xFE15 indicates go to the Park position\\r\\n0xFE17 indicates go to the Bench position","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1576":{"PGN":65139,"PGN_Name":"Laser Receiver Mast Position","PGN_Description":"LMP","first_bit":0,"SPN":1576,"SPN_Name":"Mast Position","SPN_Description":"Used to monitor the position of the sensor attached to the land leveling mast.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1577":{"PGN":65138,"PGN_Name":"Laser Leveling System Blade Control","PGN_Description":"LBC","first_bit":0,"SPN":1577,"SPN_Name":"Blade Duration and Direction","SPN_Description":"Used to indicate the duration and direction that the land leveling system blade moves.","bit_length":16,"scaling":0.1,"offset":-3276.8,"unit":"s","SLOT_ID":10},"1578":{"PGN":65138,"PGN_Name":"Laser Leveling System Blade Control","PGN_Description":"LBC","first_bit":16,"SPN":1578,"SPN_Name":"Blade Control Mode","SPN_Description":"Allows the user to select the type of blade control for the land leveling system.  \\r\\n\\r\\n00000000 Manual mode\\r\\n00000001 Automatic mode\\r\\n00000010 Inactive automatic mode\\r\\nAll other values Reserved","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"1579":{"PGN":65137,"PGN_Name":"Laser Tracer Position","PGN_Description":"LTP","first_bit":0,"SPN":1579,"SPN_Name":"Laser Tracer Target Deviation","SPN_Description":"The calculated distance for the laser target to the current laser tracer reference point.\\r\\n\\r\\nParameter specific parameter: 0xFE03 indicates that the sensor can not sense the laser","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1580":{"PGN":65137,"PGN_Name":"Laser Tracer Position","PGN_Description":"LTP","first_bit":16,"SPN":1580,"SPN_Name":"Laser Tracer Vertical Distance","SPN_Description":"The elevation of the laser tracer sensor in a laser leveling system.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"1581":{"PGN":65137,"PGN_Name":"Laser Tracer Position","PGN_Description":"LTP","first_bit":32,"SPN":1581,"SPN_Name":"Laser Tracer Horizontal Deviation","SPN_Description":"The calculated percent deviation between the target distance and the center of the laser tracer.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"1582":{"PGN":65137,"PGN_Name":"Laser Tracer Position","PGN_Description":"LTP","first_bit":40,"SPN":1582,"SPN_Name":"LED Display Data #2","SPN_Description":"Informs display devices how to display the current position of the laser tracer.\\r\\n\\r\\nValues which are less than 128 decimal are bit-mapped values and any combination of these values is considered a valid value.  For example communicating the \\"Up LED on\\" value to the display would result in the Up LED being turned on.  Communicating a value with the \\"Up LED on\\" bit set to \\"1\\" and thet \\"On-Grade \'A\' LED on\\" bit set to \\"1\\" should result in the display turning on the Up LED AND the On-Grade \\"A\\" LED.  \\r\\n\\r\\nValues 128 decimal and above are discrete states.  Any bit-mapped combination of these states are invalid unless the results correspond to one of the states defined.  For example, the result of adding the \\"Low Coarse\\" and \\"Low Medium\\" states results in the \\"Low Medium\\" state, which is valid.  However, adding the \\"Low Medium\\" and the \\"Low Fine\\" states results in an value which does not have a defined state and is invalid.\\r\\n\\r\\n00000001 On-grade \u201CA\u201D LED on\\r\\n00000010 On-grade \u201CB\u201D LED on\\r\\n00000100 On-grade \u201CC\u201D LED on\\r\\n00001000 Up LED on\\r\\n00010000 Down LED on\\r\\n00100000 Left LED on\\r\\n01000000 Right LED on\\r\\n\\r\\n00000001 On-grade \u201CA\u201D LED on\\r\\n00000010 On-grade \u201CB\u201D LED on\\r\\n00000100 On-grade \u201CC\u201D LED on\\r\\n00001000 Up LED on\\r\\n00010000 Down LED on\\r\\n00100000 Left LED on\\r\\n01000000 Right LED on\\r\\n\\r\\n10000000 Low Coarse\\r\\n10000001 Low Medium/Coarse\\r\\n10000010 Low Medium\\r\\n10000011 Low Medium/Fine\\r\\n10000100 Low Fine\\r\\n10010000 On Grade\\r\\n10010001 High Fine\\r\\n10010010 High Medium/Fine\\r\\n10010011 High Medium\\r\\n10010100 High Medium/Coarse\\r\\n10010101 High Coarse\\r\\n10011111 No data (i.e. no laser strikes)\\r\\n11111110 Error\\r\\n11111111 Not Available\\r\\n\\r\\nUndefined values between 10100000 binary and 11111101 binary are reserved for future use.","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"1583":{"PGN":65137,"PGN_Name":"Laser Tracer Position","PGN_Description":"LTP","first_bit":48,"SPN":1583,"SPN_Name":"Laser Tracer Information","SPN_Description":"Provides the status of the laser tracer to the operator. \\r\\n\\r\\n00000001 Laser power is on\\r\\n00000010 Laser is ready\\r\\n00000100 Valid target (1 = yes)\\r\\n00001000 Previous pass (1 = yes)\\r\\n00010000 Stringline (1 = yes)\\r\\n00100000 Curb (1 = yes)\\r\\nAll other values Reserved","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"1584":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":8,"SPN":1584,"SPN_Name":"Service Component Identification","SPN_Description":"Identification of component needing service.  See Table SPN911_A.","bit_length":8,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":25},"1585":{"PGN":65136,"PGN_Name":"Combination Vehicle Weight","PGN_Description":"CVW","first_bit":0,"SPN":1585,"SPN_Name":"Powered Vehicle Weight","SPN_Description":"Total mass imposed by the tires of the powered vehicle on the road surface.  Does not include the trailer.","bit_length":16,"scaling":10,"offset":0,"unit":"kg","SLOT_ID":29},"1586":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":0,"SPN":1586,"SPN_Name":"Speed of forward vehicle","SPN_Description":"Absolute velocity of the preceding vehicle situated within 250 m in the same lane and moving in the same direction.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"1587":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":8,"SPN":1587,"SPN_Name":"Distance to forward vehicle","SPN_Description":"Distance to the preceding vehicle situated within 250 m in the same lane and moving in the same direction.","bit_length":8,"scaling":1,"offset":0,"unit":"m","SLOT_ID":95},"1588":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":16,"SPN":1588,"SPN_Name":"Adaptive Cruise Control Set Speed","SPN_Description":"Value of the desired (chosen) velocity of the adaptive cruise control system.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"1589":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":27,"SPN":1589,"SPN_Name":"Adaptive cruise control set distance mode","SPN_Description":"Selected distance mode for adaptive cruise control. \\r\\n\\r\\n000 ACC Distance mode #1 (largest distance)\\r\\n001 ACC Distance mode #2\\r\\n010 ACC Distance mode #3\\r\\n011 ACC Distance mode #4\\r\\n100 ACC Distance mode #5 (shortest distance)\\r\\n101 Conventional cruise control mode\\r\\n110 Error condition\\r\\n111 Not available/not valid","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1590":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":24,"SPN":1590,"SPN_Name":"Adaptive Cruise Control Mode","SPN_Description":"This parameter is used to indicate the current state, or mode, of operation by the Adaptive Cruise Control (ACC) device. The states characterize independent system states (e.g., it is not possible to express distance control active and overtake mode simultaneously). ACC must not switch itself off while active because the driver expects it to work. So if an error occurs, the ACC must signal that to the driver so that the driver knows that he has to switch off the ACC.\\r\\n\\r\\n000 Off (Standby, enabled, ready for activation)\\r\\n001 Speed control active\\r\\n010 Distance control active\\r\\n011 Overtake mode\\r\\n100 Hold mode\\r\\n101 Finish mode\\r\\n110 Disabled or error condition\\r\\n111 Not available/not valid\\r\\n\\r\\n000b - Off\u2014Used to indicate the ACC is enabled in calibration or configuration and there are no faults that would prevent the system from operating.\\r\\n001b - Speed Control Active\u2014Used to indicate that ACC is on but not currently sending control messages.  In other words, there is no target ahead and regular vehicle cruise control is controlling the vehicle speed to the driver\u2019s set speed.\\r\\n010b - Distance Control Active\u2014Used to indicate that ACC is on and actively sending control messages to maintain the appropriate following interval.\\r\\n011b - Overtake Mode\u2014Used to indicate that ACC is on but temporarily disabled because the driver is manually overriding cruise control by using either the accelerator pedal or the cruise control \u201Caccel\u201D switch.\\r\\n100b - Hold Mode\u2014Used to indicate that the ACC has lost the previous target vehicle and is in HOLD mode. In this mode, the ACC shall limit the speed to the speed held when the target was lost. For example,  if the driver activates the typical cruise buttons (Resume/Inc/Dec) the HOLD mode shall be exited and normal cruise functionality resumed. If a new target is detected, the Distance Control Active mode (010b) is again entered, unless existing conditions prohibit this.\\r\\n101b - Finish Mode\u2014Used to indicate that ACC is on with no target ahead, and ACC is currently sending control messages to return to the driver\u2019s set speed. This occurs when the target the ACC system was tracking moves out of the way so ACC returns the vehicle to the driver\u2019s set speed.\\r\\n110b - Disabled or Error Condition\u2014Used to indicate that ACC is in an error state and can not operate.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1591":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":32,"SPN":1591,"SPN_Name":"Road curvature","SPN_Description":"Estimated value of the current road curvature for use by the adaptive cruise control system.  Positive values are used for left curves.  Curvature is the inverse of the radius and is zero for straight roads.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"1/km","SLOT_ID":96},"1592":{"PGN":65134,"PGN_Name":"High Resolution Wheel Speed","PGN_Description":"HRW","first_bit":0,"SPN":1592,"SPN_Name":"Front Axle, Left Wheel Speed","SPN_Description":"High resolution measurement of the speed of the left wheel on the front axle.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"1593":{"PGN":65134,"PGN_Name":"High Resolution Wheel Speed","PGN_Description":"HRW","first_bit":16,"SPN":1593,"SPN_Name":"Front axle, right wheel speed","SPN_Description":"High resolution measurement of the speed of the right wheel on the front axle.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"1594":{"PGN":65134,"PGN_Name":"High Resolution Wheel Speed","PGN_Description":"HRW","first_bit":32,"SPN":1594,"SPN_Name":"Rear axle, left wheel speed","SPN_Description":"High resolution measurement of the speed of the left wheel on the rear axle.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"1595":{"PGN":65134,"PGN_Name":"High Resolution Wheel Speed","PGN_Description":"HRW","first_bit":48,"SPN":1595,"SPN_Name":"Rear axle, right wheel speed","SPN_Description":"High resolution measurement of the speed of the right wheel on the rear axle.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"1598":{"PGN":64817,"PGN_Name":"Fan Drive #2","PGN_Description":"FD2","first_bit":16,"SPN":1598,"SPN_Name":"Fan 2 Speed","SPN_Description":"The speed of the second fan associated with engine coolant system.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"1600":{"PGN":64737,"PGN_Name":"Fuel Economy 2 (Liquid)","PGN_Description":"LFE2","first_bit":0,"SPN":1600,"SPN_Name":"Engine Fuel Rate (High Resolution)","SPN_Description":"Amount of fuel consumed by engine per unit of time.  \\r\\n\\r\\nNOTE - See SPN 183 for alternate resolution.","bit_length":32,"scaling":0.001,"offset":0,"unit":"l/h","SLOT_ID":321},"1601":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":48,"SPN":1601,"SPN_Name":"Local minute offset","SPN_Description":"The minute component of the offset between the UTC time and date and a local time zone time and date.  This is the number of minutes to add to UTC (Universal Time Coordinate) time and date to convert to the time and date in the local time zone .  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line.\\r\\nThe Local Minute Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  Refer to SPN 1602 for details.","bit_length":8,"scaling":1,"offset":-125,"unit":"min","SLOT_ID":99},"1602":{"PGN":65254,"PGN_Name":"Time/Date","PGN_Description":"TD","first_bit":56,"SPN":1602,"SPN_Name":"Local hour offset","SPN_Description":"The hour component of the offset between the UTC (Universal Time Coordinate) time and date and a local time zone time and date.  This is the number of hours to add to UTC, a.k.a. GMT, time and date to convert to the time and date in the local time zone.  This parameter indicates the time reference of the data reported in the Time and Date SPNs 959, 960. 961, 962, 963, and 964.  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line. \\r\\nThe Local Hour Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  \\r\\n\\r\\nRecommended Settings:\\r\\n\\r\\nApplications should not use the $FF \'Not Available\' if using the Time and Date parameters due to some ambiguity of the time standard for the reported time and date values.  The recommended settings for the Local Hour Offset settings are: \\r\\nIf reporting the Time and Date as Local time, then Local Hour Offset must be reported as $FA.\\r\\nIf reporting the Time and Date as UTC time and Local Hour Offset is not supported or not known, then Local Hour Offset must be reported as $F9.\\r\\nIf reporting the Time and Date as UTC time and Local Hour Offset is known, then Local Hour Offset must be reported as a value between $66 and $94.","bit_length":8,"scaling":1,"offset":-125,"unit":"h","SLOT_ID":4},"1603":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":0,"SPN":1603,"SPN_Name":"Adjust seconds","SPN_Description":"The seconds component for setting the current time of day.  This should be reported as the seconds component of the current time according to the time of day standard indicated with the Local Hour Offset parameter (SPN 1602).  The time of day should be reported as the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.","bit_length":8,"scaling":0.25,"offset":0,"unit":"s","SLOT_ID":63},"1604":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":8,"SPN":1604,"SPN_Name":"Adjust minutes","SPN_Description":"The minutes component for setting the current time of day.  This should be reported as the minutes component of the current time according to the time of day standard indicated with the Local Hour Offset parameter (SPN 1602).  The time of day should be reported as the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.","bit_length":8,"scaling":1,"offset":0,"unit":"min","SLOT_ID":61},"1605":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":16,"SPN":1605,"SPN_Name":"Adjust hours","SPN_Description":"The hours component for setting the current time of day.  This should be reported as the hours component of the current time according to the time of day standard indicated with the Local Hour Offset parameter (SPN 1602).  The time of day should be reported as the current time at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current time at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the time of day (SPNs 959, 960, and 961) is the current UTC time or a local time zone time.  Refer to SPN 1602 for details.","bit_length":8,"scaling":1,"offset":0,"unit":"h","SLOT_ID":3},"1606":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":24,"SPN":1606,"SPN_Name":"Adjust month","SPN_Description":"The month component for setting the current calendar date.  This should be reported as the month component of the current date according to the calendar date standard indicated with the Local Hour Offset parameter (SPN 1602).  The calendar date should be reported as the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\\r\\n\\r\\nNOTE - A value of 0 for the month is null.  The value 1 identifies January; 2 identifies February; etc.","bit_length":8,"scaling":1,"offset":0,"unit":"months","SLOT_ID":62},"1607":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":32,"SPN":1607,"SPN_Name":"Adjust day","SPN_Description":"The day component for setting the current calendar date.  This should be reported as the day component of the current date according to the calendar date standard indicated with the Local Hour Offset parameter (SPN 1602).  The calendar date should be reported as the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\\r\\n\\r\\nNOTE - A value of 0 for the date is null.  The values 1, 2, 3, and 4 are used to identify the first day of the month; 5, 6, 7, and 8 identify the second day of the month; etc.","bit_length":8,"scaling":0.25,"offset":0,"unit":"days","SLOT_ID":60},"1608":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":40,"SPN":1608,"SPN_Name":"Adjust year","SPN_Description":"The year component for setting the current calendar date.  This should be reported as the year component of the current date according to the calendar date standard indicated with the Local Hour Offset parameter (SPN 1602).  The calendar date should be reported as the current date at UTC (Universal Time Coordinate), a.k.a. GMT; however, it may be reported as the current date at a local time zone.  The Local Hour Offset parameter (SPN 1602) is used to indicate if the calendar date (SPNs 962, 963, and 964) is the current UTC date or a local time zone date.  Refer to SPN 1602 for details.\\r\\n\\r\\nNOTE - A value of 0 for the year identifies the year 1985; a value of 1 identifies 1986; etc.","bit_length":8,"scaling":1,"offset":1985,"unit":"years","SLOT_ID":66},"1609":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":48,"SPN":1609,"SPN_Name":"Adjust local minute offset","SPN_Description":"The minute component for setting the offset between the UTC (Universal Time Coordinate) time and date and a the local time zone time and date.  This is the number of minutes to add to UTC, a.k.a. GMT, time and date to convert to the time and date in the Local Time Zone.  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line.\\r\\n\\r\\nThe Local Minute Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  Refer to SPN 1602 for details.","bit_length":8,"scaling":1,"offset":-125,"unit":"min","SLOT_ID":99},"1610":{"PGN":54528,"PGN_Name":"Time/Date Adjust","PGN_Description":"TDA","first_bit":56,"SPN":1610,"SPN_Name":"Adjust local hour offset","SPN_Description":"The hour component for setting the offset between the UTC (Universal Time Coordinate) time and date and a the local time zone time and date.  This is the number of minutes to add to UTC, a.k.a. GMT, time and date to convert to the time and date in the Local Time Zone.  The Local Offset is a positive value for time zones East of the Prime Meridian to the International Date Line.  The Local Offset is a negative value for time zones West of the Prime Meridian to the International Date Line.\\r\\n\\r\\nThe Local Hour Offset is only applicable when the Time and Date parameters are reported as UTC time and date.  Refer to SPN 1602 for details.","bit_length":8,"scaling":1,"offset":-125,"unit":"h","SLOT_ID":4},"1611":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":6,"SPN":1611,"SPN_Name":"Vehicle motion","SPN_Description":"Indicates whether motion of the vehicle is detected or not.\\r\\n\\r\\n00 Vehicle motion not detected\\r\\n01 Vehicle motion detected\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1612":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":0,"SPN":1612,"SPN_Name":"Driver 1 working state","SPN_Description":"State of work of the driver.  \\r\\n\\r\\n000 Rest - sleeping\\r\\n001 Driver available \u2013 short break\\r\\n010 Work \u2013 loading, unloading, working in an office\\r\\n011 Drive \u2013 behind wheel \\r\\n100-101 Reserved\\r\\n110 Error\\r\\n111 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1613":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":3,"SPN":1613,"SPN_Name":"Driver 2 working state","SPN_Description":"State of work of the driver.  \\r\\n\\r\\n000 Rest - sleeping\\r\\n001 Driver available \u2013 short break\\r\\n010 Work \u2013 loading, unloading, working in an office\\r\\n011 Drive \u2013 behind wheel \\r\\n100-101 Reserved\\r\\n110 Error\\r\\n111 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1614":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":14,"SPN":1614,"SPN_Name":"Vehicle Overspeed","SPN_Description":"Indicates whether the vehicle is exceeding the legal speed limit set in the tachograph.\\r\\n\\r\\n00 No overspeed\\r\\n01 Overspeed\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1615":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":12,"SPN":1615,"SPN_Name":"Driver card, driver 1","SPN_Description":"Indicates the presence of a driver card\\r\\n\\r\\n00 - Driver card not present\\r\\n01 - Driver card present\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1616":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":20,"SPN":1616,"SPN_Name":"Driver card, driver 2","SPN_Description":"Indicates the presence of a driver card\\r\\n\\r\\n00 - Driver card not present\\r\\n01 - Driver card present\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1617":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":8,"SPN":1617,"SPN_Name":"Driver 1 Time Related States","SPN_Description":"Indicates if the driver approaches or exceeds working time limits (or other limits).  \\r\\n\\r\\n0000 Normal/No limits reached\\r\\n0001 Limit #1 \u2013 15 min before 4 \xbd h\\r\\n0010 Limit #2 \u2013 4 \xbd h reached\\r\\n0011 Limit #3 \u2013 15 min before 9 h\\r\\n0100 Limit #4 \u2013 9 h reached\\r\\n0101 Limit #5 \u2013 15 min before 16 h (not having 8h rest during the last 24h)\\r\\n0110 Limit #6 \u2013 16 h reached\\r\\n0111-1100 Reserved\\r\\n1101 Other\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1618":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":16,"SPN":1618,"SPN_Name":"Driver 2 Time Related States","SPN_Description":"Indicates if the driver approaches or exceeds working time limits (or other limits).  \\r\\n\\r\\n0000 Normal/No limits reached\\r\\n0001 Limit #1 \u2013 15 min before 4 \xbd h\\r\\n0010 Limit #2 \u2013 4 \xbd h reached\\r\\n0011 Limit #3 \u2013 15 min before 9 h\\r\\n0100 Limit #4 \u2013 9 h reached\\r\\n0101 Limit #5 \u2013 15 min before 16 h (not having 8h rest during the last 24h)\\r\\n0110 Limit #6 \u2013 16 h reached\\r\\n0111-1100 Reserved\\r\\n1101 Other\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1619":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":30,"SPN":1619,"SPN_Name":"Direction indicator","SPN_Description":"Indicates the direction of the vehicle.\\r\\n\\r\\n00 - Forward\\r\\n01 - Reverse\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1620":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":28,"SPN":1620,"SPN_Name":"Tachograph performance","SPN_Description":"Indicates the tachograph performance; including electronic or mechanical analysis, instrument analysis, speed sensor analysis, mass storage analysis, and printer analysis.\\r\\n\\r\\n00 - Normal performance\\r\\n01 - Performance analysis\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1621":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":26,"SPN":1621,"SPN_Name":"Handling information","SPN_Description":"Indicates that handling information is present.  Information could include \u201Cno printer paper\u201D, \u201Cno driver card\u201D, etc.\\r\\n\\r\\n00 - No handling information\\r\\n01 - Handling information\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1622":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":24,"SPN":1622,"SPN_Name":"System event","SPN_Description":"Indicates that a tachograph event has occurred.  This may include power supply interruption, interruption of the speed sensor, incorrect data on the driver card, driving without a driver card, illegal removal of a driver card, insertion of a driver card during driving, and time adjustment.\\r\\n\\r\\n00 - No tachograph event\\r\\n01 - Tachograph event\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1623":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":32,"SPN":1623,"SPN_Name":"Tachograph output shaft speed","SPN_Description":"Calculated speed of the transmission output shaft.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"1624":{"PGN":65132,"PGN_Name":"Tachograph","PGN_Description":"TCO1","first_bit":48,"SPN":1624,"SPN_Name":"Tachograph vehicle speed","SPN_Description":"Speed of the vehicle registered by the tachograph.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"1632":{"PGN":65168,"PGN_Name":"Engine Torque History","PGN_Description":"ETH","first_bit":114,"SPN":1632,"SPN_Name":"Engine Torque Limit Feature","SPN_Description":"Torque limit rating described in the current record. \\r\\n\\r\\n000 Reserved\\r\\n001 Highest torque rating\\r\\n010 First torque rating\\r\\n011 Previous torque rating (rating prior to the current rating)\\r\\n100 Current torque rating\\r\\n101-110 Reserved\\r\\n111 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1633":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":4,"SPN":1633,"SPN_Name":"Cruise Control Pause Switch","SPN_Description":"Switch signal which indicates the position of the Cruise Control Pause Switch used on Remote Cruise Control applications. The Cruise Control Pause Switch signal temporarily disables the Cruise Control function.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error Indicator\\r\\n11 -Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1636":{"PGN":65129,"PGN_Name":"Engine Temperature 3","PGN_Description":"ET3","first_bit":0,"SPN":1636,"SPN_Name":"Engine Intake Manifold 1 Temperature (High Resolution)","SPN_Description":"Temperature of pre-combustion air found in intake manifold of engine air supply system. The higher resolution is required for control purposes.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1637":{"PGN":65129,"PGN_Name":"Engine Temperature 3","PGN_Description":"ET3","first_bit":16,"SPN":1637,"SPN_Name":"Engine Coolant Temperature (High Resolution)","SPN_Description":"Temperature of liquid found in engine cooling system. The higher resolution is required for control purposes.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1638":{"PGN":65128,"PGN_Name":"Vehicle Fluids","PGN_Description":"VF","first_bit":0,"SPN":1638,"SPN_Name":"Hydraulic Temperature","SPN_Description":"Temperature of hydraulic fluid.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1639":{"PGN":65213,"PGN_Name":"Fan Drive #1","PGN_Description":"FD1","first_bit":16,"SPN":1639,"SPN_Name":"Fan Speed","SPN_Description":"The speed of the fan associated with engine coolant system.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"1653":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":38,"SPN":1653,"SPN_Name":"Vehicle Limiting Speed Governor Enable Switch","SPN_Description":"Switch signal which enables the Vehicle Limiting Speed Governor (VLSG) such that the vehicle speed may be either increased or decreased when the engine is off idle.\\r\\n\\r\\n00 - Switch disabled\\r\\n01 - Switched enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1654":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":36,"SPN":1654,"SPN_Name":"Vehicle Limiting Speed Governor Increment Switch","SPN_Description":"Switch signal which increases the Vehicle Limiting Speed Governor (VLSG).\\r\\n\\r\\n00 - Switch in the off state\\r\\n01 - Switch in the on state - increase\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1655":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":34,"SPN":1655,"SPN_Name":"Vehicle Limiting Speed Governor Decrement Switch","SPN_Description":"Switch signal which decreases the Vehicle Limiting Speed Governor (VLSG).\\r\\n\\r\\n00 - Switch in the off state\\r\\n01 - Switch in the on state - decrease\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1656":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":46,"SPN":1656,"SPN_Name":"Engine Automatic Start Enable Switch","SPN_Description":"Switch signal which enables the idle management system to be enabled. When this system is enabled with the engine in an idle mode and safe operating conditions existing, then the engine may be started or stopped automatically.\\r\\n\\r\\n00 - Switch in the off state\\r\\n01 - Switch in the on state\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1665":{"PGN":65245,"PGN_Name":"Turbocharger","PGN_Description":"TC","first_bit":30,"SPN":1665,"SPN_Name":"Engine Turbocharger Oil Level Switch","SPN_Description":"Switch signal which indicates the presence of oil at the turbocharger\\r\\n\\r\\n     00 = No oil present at turbocharger\\r\\n     01 = Oil present at turbocharger\\r\\n     10 = Error\\r\\n     11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1666":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":44,"SPN":1666,"SPN_Name":"Automatic Gear Shifting Enable Switch","SPN_Description":"Indicates that automated gear shifting is enabled via a switch\\r\\n\\r\\n    00 = Automated Gear Shifting is disabled\\r\\n    01 = Automated Gear Shifting is enabled\\r\\n    10 = Error\\r\\n    11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1667":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":26,"SPN":1667,"SPN_Name":"Retarder Requesting Brake Light","SPN_Description":"Indicates that whether the retarder is requesting that the brake lights are illuminated.\\r\\n\\r\\n     00 - Retarder is not requesting that the brake lights are illuminated\\r\\n     01 - Retarder is requesting that the brake lights are illuminated\\r\\n     10 - Reserved\\r\\n     11 - Not available/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1675":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":48,"SPN":1675,"SPN_Name":"Engine Starter Mode","SPN_Description":"There are several phases in a starting action and different reasons why a start cannot take place.\\r\\n\\r\\n0000 start not requested\\r\\n0001 starter active, gear not engaged\\r\\n0010 starter active, gear engaged\\r\\n0011 start finished; starter not active after having been actively engaged (after 50ms mode goes to 0000)\\r\\n0100 starter inhibited due to engine already running\\r\\n0101 starter inhibited due to engine not ready for start (preheating)\\r\\n0110 starter inhibited due to driveline engaged or other transmission inhibit\\r\\n0111 starter inhibited due to active immobilizer\\r\\n1000 starter inhibited due to starter over-temp\\r\\n1001 starter inhibited due to intake air shutoff valve being active\\r\\n1010 starter inhibited due to active SCR inducement\\r\\n1011 Reserved\\r\\n1100 starter inhibited - reason unknown\\r\\n1101 error (legacy implementation only, use 1110)\\r\\n1110 error\\r\\n1111 not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1676":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":32,"SPN":1676,"SPN_Name":"Auxiliary Heater Water Pump Status","SPN_Description":"Parameter indicating whether the auxiliary heater water pump is running\\r\\n\\r\\n00 Water Pump is not running\\r\\n01 Water Pump is  running\\r\\n10 Reserved\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1677":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":24,"SPN":1677,"SPN_Name":"Auxiliary Heater Mode","SPN_Description":"State of the auxiliary heater\\r\\n\\r\\n0000 Heater not active\\r\\n0001 Off due to ADR per European Regulations for Transport of hazardous materials\\r\\n0010 Economy mode\\r\\n0011 Normal mode\\r\\n0100 Heater pump up-keep   (running the equipment in order to keep it in good condition)\\r\\n0101 Heater Starting - Indicates the start-phase of the heater which can be used to control the fan and circulation air flaps.\\r\\n0110 Heater Stopping - Indicates the burn-out phase of the heater which can be used to control the fan and circulation air flaps.\\r\\n0111 Diagnose Active - Indicates any active/running diagnostic service/routine/IO-control without the normal heater burn taking place.\\r\\n1000 Heater Locked - Indicates a sticky error state after running a number of failed heater start attempts.  Heater will need to be unlocked at a workshop.\\r\\n1001-1101 Not defined\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1678":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":34,"SPN":1678,"SPN_Name":"Cab Ventilation","SPN_Description":"Indicates whether the cab is being ventilated or not.\\r\\n\\r\\n00 Cab not ventilated\\r\\n01 Cab is ventilated\\r\\n10 Reserved\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1679":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":36,"SPN":1679,"SPN_Name":"Engine Heating Zone","SPN_Description":"Parameter indicating whether the engine zone is being heated.\\r\\n\\r\\n00 Engine heating zone off\\r\\n01 Engine heating zone on\\r\\n10 Reserved\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1680":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":38,"SPN":1680,"SPN_Name":"Cab Heating Zone","SPN_Description":"Parameter indicating whether the cab zone is being heated.\\r\\n\\r\\n00 Cab heating zone off\\r\\n01 Cab heating zone on\\r\\n10 Reserved\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1681":{"PGN":65126,"PGN_Name":"Battery Main Switch Information","PGN_Description":"BM","first_bit":0,"SPN":1681,"SPN_Name":"Battery Main Switch Hold State","SPN_Description":"Parameter indicating whether the battery main switch is held due to an external request or not. The state battery main switch held indicates that the battery main switch is about to switch off.\\r\\n\\r\\n00 Battery main switch not held\\r\\n01 Battery main switch held\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1682":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":26,"SPN":1682,"SPN_Name":"Battery Main Switch Hold Request","SPN_Description":"Request to hold the battery main switch.\\r\\n\\r\\n00 Release Battery Main Switch\\r\\n01 Hold Battery Main Switch\\r\\n10 undefined\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1683":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":48,"SPN":1683,"SPN_Name":"Auxiliary Heater Mode Request","SPN_Description":"Request to activate the auxiliary heater.\\r\\n\\r\\n0000 De-activate auxiliary heater\\r\\n0001 Off due to ADR per European Regulations for Transport of hazardous materials\\r\\n0010 Economy mode\\r\\n0011 Normal mode\\r\\n0100 Heater pump up-keep\\r\\n0101-1000 Reserved\\r\\n1001-1101 Not defined\\r\\n1110 Reserved\\r\\n1111 Don\'t care/take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1684":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":24,"SPN":1684,"SPN_Name":"Auxiliary Heater Coolant Pump Request","SPN_Description":"Indicates whether to activate the auxiliary heater coolant water pump.\\r\\n\\r\\n00 Deactivate water pump\\r\\n01 Activate water pump\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1685":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":52,"SPN":1685,"SPN_Name":"Request Engine Zone Heating","SPN_Description":"Request to activate engine zone heating.\\r\\n\\r\\n00 Do not heat engine zone\\r\\n01 Heat engine zone\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1686":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":54,"SPN":1686,"SPN_Name":"Request Cab Zone Heating","SPN_Description":"Request to activate cab zone heating.\\r\\n\\r\\n00 Do not heat cab engine zone\\r\\n01 Heat cab zone\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1687":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":0,"SPN":1687,"SPN_Name":"Auxiliary Heater Output Coolant Temperature","SPN_Description":"Temperature of the auxiliary heater output coolant (I.e. water in a water heater system.)","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1688":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":8,"SPN":1688,"SPN_Name":"Auxiliary Heater Input Air Temperature","SPN_Description":"Temperature of the input air in an auxiliary heater system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1689":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":16,"SPN":1689,"SPN_Name":"Auxiliary Heater Output Power Percent","SPN_Description":"Current auxiliary heater output power, relative to the auxiliary heater maximum output power.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1690":{"PGN":65127,"PGN_Name":"Climate Control Configuration","PGN_Description":"CCC","first_bit":0,"SPN":1690,"SPN_Name":"Auxiliary Heater Maximum Output Power","SPN_Description":"The maximum output power of the auxiliary heater.","bit_length":16,"scaling":2,"offset":0,"unit":"W","SLOT_ID":107},"1691":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":8,"SPN":1691,"SPN_Name":"Cab Interior Temperature Command","SPN_Description":"Parameter used to command a certain cab interior temperature.\\r\\n\\r\\nNote: See also SPN 170.  SPN 1662 is an additional diagnostic SPN associated with cab temperature.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"1692":{"PGN":65194,"PGN_Name":"Alternate Fuel 2","PGN_Description":"AF2","first_bit":8,"SPN":1692,"SPN_Name":"Engine Intake Manifold Desired Absolute Pressure","SPN_Description":"The desired absolute intake manifold pressure (turbo boost limit) of the engine.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1693":{"PGN":65194,"PGN_Name":"Alternate Fuel 2","PGN_Description":"AF2","first_bit":24,"SPN":1693,"SPN_Name":"Engine Turbocharger Wastegate Valve Position","SPN_Description":"The position of the turbocharger wastegate valve (not the electronic wastegate control valve).","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1694":{"PGN":65194,"PGN_Name":"Alternate Fuel 2","PGN_Description":"AF2","first_bit":32,"SPN":1694,"SPN_Name":"Engine Fuel System Gas Mass Flow Rate Sensor Fueling Correction","SPN_Description":"The amount of fuel the Gas Mass Flow Rate Sensor is sensing should be added or subtracted compared to the maximum amount of fuel the control system allows the sensor to add or subtract.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1695":{"PGN":65193,"PGN_Name":"Exhaust Oxygen 1","PGN_Description":"EO1","first_bit":48,"SPN":1695,"SPN_Name":"Engine Exhaust O2 Sensor Fueling Correction","SPN_Description":"The amount of fueling change required by the system based on the measured exhaust oxygen value compared to the maximum fueling change permitted by the system, expressed as percentages.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1696":{"PGN":65193,"PGN_Name":"Exhaust Oxygen 1","PGN_Description":"EO1","first_bit":62,"SPN":1696,"SPN_Name":"Engine Exhaust O2 Sensor Closed Loop Operation","SPN_Description":"Indicates whether the engine is using the exhaust oxygen sensor to control the air/fuel ratio.\\r\\n\\r\\n00 Engine not using the exhaust oxygen sensor (open loop)\\r\\n01 Engine using the exhaust oxygen sensor for a closed loop operation\\r\\n10 Reserved\\r\\n11 Don\'t Care/take no action\\r\\n\\r\\nSee also SPN 4240 for an implementation with more states.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1697":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":36,"SPN":1697,"SPN_Name":"Tire Sensor Electrical Fault","SPN_Description":"Indicates the status of electrical fault on the tire sensor.\\r\\n\\r\\n00 Ok (No Fault)\\r\\n01 Not Defined (Fault)\\r\\n10 Error\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1698":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":34,"SPN":1698,"SPN_Name":"Tire Status","SPN_Description":"Indicates the status of the tire.\\r\\n\\r\\n00 Ok (no fault)\\r\\n01 Tire leak detected\\r\\n10 Error\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1699":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":32,"SPN":1699,"SPN_Name":"Tire Sensor Enable Status","SPN_Description":"Indicates whether the tire sensor is being monitored by the controller or is Enabled/Disabled.\\r\\n\\r\\n00 Off / Isolated / Disabled\\r\\n01 On (tire is polled) / Enabled\\r\\n10 Not Defined\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1700":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":6,"SPN":1700,"SPN_Name":"Lane Departure Imminent, Left Side","SPN_Description":"Indicates departure imminent on left side of lane.\\r\\n\\r\\n00 Not imminent\\r\\n01 Imminent\\r\\n10 Reserved\\r\\n11 Not used","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1701":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":4,"SPN":1701,"SPN_Name":"Lane Departure Imminent, Right Side","SPN_Description":"Indicates departure imminent on right side of lane.\\r\\n\\r\\n00 Not imminent\\r\\n01 Imminent\\r\\n10 Reserved\\r\\n11 Not Used","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1702":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":6,"SPN":1702,"SPN_Name":"Lane Departure Indication Enable Status","SPN_Description":"Indicates whether lane departure indication is active.\\r\\n\\r\\n00 Lane Departure indication disabled\\r\\n01 Lane Departure Indication enabled \\r\\n10 Reserved\\r\\n11 Not Used","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1707":{"PGN":64817,"PGN_Name":"Fan Drive #2","PGN_Description":"FD2","first_bit":32,"SPN":1707,"SPN_Name":"Hydraulic Fan 2 Motor Pressure","SPN_Description":"The hydraulic pressure used to drive the second fan system, sensed before the hydraulic fan motor.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"1708":{"PGN":64817,"PGN_Name":"Fan Drive #2","PGN_Description":"FD2","first_bit":48,"SPN":1708,"SPN_Name":"Fan 2 Drive Bypass Command Status","SPN_Description":"Status of the Fan Drive Bypass Command for the second fan as being commanded by the ECU.  The fan drive bypass diverts pump pressure away from the hydraulic motor to maintain the fan drive pressure.  0% is defined as no bypass (i.e. diverting no fan drive pressure) and 100% is defined as full bypass (i.e. diverting the maximum fan drive pressure) from the fan motor.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1710":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":4,"SPN":1710,"SPN_Name":"Lane Tracking Status Left Side","SPN_Description":"Indicates whether the left side is tracking lane.\\r\\n\\r\\n00 Not Tracking Left side\\r\\n01 Tracking Left side\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1711":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":2,"SPN":1711,"SPN_Name":"Lane Tracking Status Right Side","SPN_Description":"Indicates whether right side is tracking lane.\\r\\n\\r\\n00 Not Tracking Right side\\r\\n01 Tracking Right side\\r\\n10 Reserved\\r\\n11 Don\'t Care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1712":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":224,"SPN":1712,"SPN_Name":"Engine Requested Speed Control Range Upper Limit (Extended Range)","SPN_Description":"The maximum engine speed regardless of load that the engine will allow when operating in a speed control/limit mode, excluding any maximum momentary engine override speed, if supported.  \\r\\n\\r\\nWhen the limit is higher than 2500 RPM the \'Requested Speed Control Range Upper Limit (Engine Configuration)\' parameter (see SPN 536) will be transmitted with a value of 2500 RPM.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"1713":{"PGN":65128,"PGN_Name":"Vehicle Fluids","PGN_Description":"VF","first_bit":8,"SPN":1713,"SPN_Name":"Hydraulic Oil Filter Restriction Switch","SPN_Description":"This switch indicates whether hydraulic oil filter is clogged. This is not the transmission oil filter restriction switch, which is SPN 3359.\\r\\n\\r\\n00 No restriction\\r\\n01 Restriction exists on oil filter\\r\\n10 Error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1714":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":28,"SPN":1714,"SPN_Name":"Operator Seat Direction Switch","SPN_Description":"Senses whether the operator seat is in the forward driving position\\r\\n\\r\\n00 Operator seat not facing forward\\r\\n01 Operator seat is facing forward\\r\\n10 Error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1715":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":40,"SPN":1715,"SPN_Name":"Drivers Demand Retarder -  Percent Torque","SPN_Description":"The Drivers demand retarder \u2013 percent torque is the maximum torque selected by the driver when one or more modes  are selected by the driver, such as hand lever, switch, constant torque, constant velocity, etc.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1716":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":48,"SPN":1716,"SPN_Name":"Retarder Selection, non-engine","SPN_Description":"The \u201CRetarder Selection, non-engine\u201D is the position of the driver\u2019s selector for retarders that are not part of the engine system, expressed as percent and determined by the ratio of current position to the maximum possible position. The physical device may be a lever, rotary dial, combination of switches, or other device that the driver can use to select the type or amount of retardation needed.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1717":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":56,"SPN":1717,"SPN_Name":"Actual Maximum Available Retarder - Percent Torque","SPN_Description":"This is the maximum amount of torque that the retarder can immediately deliver.   It is the same as the maximum torque shown in the Retarder\u2019s Configuration message, but allows for a much faster rate of change than could be communicated by reissuing the configuration message. \\r\\nApplication Note: The purpose for this parameter is to allow a \u201CMaster\u201D retarder controller to more accurately allocate the vehicle\u2019s retarder requirements among multiple retarders. Its value should be the same as the value in the Configuration message at the time that message is assembled for broadcast, but may vary between those broadcasts.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1718":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":24,"SPN":1718,"SPN_Name":"Damper Stiffness Request Front Axle","SPN_Description":"Demand value for the shock absorber control at the front axle.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1719":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":32,"SPN":1719,"SPN_Name":"Damper Stiffness Request Rear Axle","SPN_Description":"Demand value for the shock absorber control at the rear  axle.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1720":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":40,"SPN":1720,"SPN_Name":"Damper Stiffness Request Lift / Tag Axle","SPN_Description":"Demand value for the shock absorber control at the lift or tag axle","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1721":{"PGN":65113,"PGN_Name":"Air Suspension Control 3","PGN_Description":"ASC3","first_bit":0,"SPN":1721,"SPN_Name":"Relative Level Front Axle Left","SPN_Description":"Information of the height at the left side of the front axle referred to normal level 1.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1722":{"PGN":65113,"PGN_Name":"Air Suspension Control 3","PGN_Description":"ASC3","first_bit":16,"SPN":1722,"SPN_Name":"Relative Level Front Axle Right","SPN_Description":"Information of the height at the right side of the front axle referred to normal level 1.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1723":{"PGN":65113,"PGN_Name":"Air Suspension Control 3","PGN_Description":"ASC3","first_bit":48,"SPN":1723,"SPN_Name":"Relative Level Rear Axle Right","SPN_Description":"Information of the height at the left side of the rear axle referred to normal level 1.  For explanations of normal level 1 see parameter SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1724":{"PGN":65113,"PGN_Name":"Air Suspension Control 3","PGN_Description":"ASC3","first_bit":32,"SPN":1724,"SPN_Name":"Relative Level Rear Axle Left","SPN_Description":"Information of the height at the left side of the rear axle referred to normal level 1.  For explanations of normal level 1 see parameter SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1725":{"PGN":65112,"PGN_Name":"Air Suspension Control 4","PGN_Description":"ASC4","first_bit":0,"SPN":1725,"SPN_Name":"Bellow Pressure Front Axle Left","SPN_Description":"Information of the pressure of the air suspension bellow at the left side of the front axle","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1726":{"PGN":65112,"PGN_Name":"Air Suspension Control 4","PGN_Description":"ASC4","first_bit":16,"SPN":1726,"SPN_Name":"Bellow Pressure Front Axle Right","SPN_Description":"Information of the pressure of the air suspension bellow at the right side of the front axle","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1727":{"PGN":65112,"PGN_Name":"Air Suspension Control 4","PGN_Description":"ASC4","first_bit":32,"SPN":1727,"SPN_Name":"Bellow Pressure Rear Axle Left","SPN_Description":"Information of the pressure of the air suspension bellow at the left side of the rear axle","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1728":{"PGN":65112,"PGN_Name":"Air Suspension Control 4","PGN_Description":"ASC4","first_bit":48,"SPN":1728,"SPN_Name":"Bellow Pressure Rear Axle Right","SPN_Description":"Information of the pressure of the air suspension bellow at the right side of the rear axle","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"1729":{"PGN":65111,"PGN_Name":"Air Suspension Control 5","PGN_Description":"ASC5","first_bit":0,"SPN":1729,"SPN_Name":"Damper Stiffness Front Axle","SPN_Description":"Damper stiffness information of the shock absorber control at the front axle","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1730":{"PGN":65111,"PGN_Name":"Air Suspension Control 5","PGN_Description":"ASC5","first_bit":8,"SPN":1730,"SPN_Name":"Damper Stiffness Rear Axle","SPN_Description":"Damper stiffness information of the shock absorber control at the rear axle","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1731":{"PGN":65111,"PGN_Name":"Air Suspension Control 5","PGN_Description":"ASC5","first_bit":16,"SPN":1731,"SPN_Name":"Damper Stiffness Lift / Tag Axle","SPN_Description":"Damper stiffness information of the shock absorber control at the lift of tag axle","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1732":{"PGN":53504,"PGN_Name":"Air Suspension Control 6","PGN_Description":"ASC6","first_bit":0,"SPN":1732,"SPN_Name":"Level Preset Front Axle Left","SPN_Description":"Set value for nominal level \'preset level\' at the left side of the front axle. This value is referred to \'Normal level 1\'.  For explanations of normal level 1 see parameter SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1733":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":4,"SPN":1733,"SPN_Name":"Nominal Level Rear Axle","SPN_Description":"Signal which indicates the nominal (desired) height of the rear axle to be controlled by the suspension system.\\r\\n\\r\\nFor further explanations see SPN 1734 - Nominal Level Front Axle.\\r\\n\\r\\n0000 Level not specified,(i.e. the nominal level is none of the specified levels, no error condition)\\r\\n0001 \\"Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\\r\\n0010 \\"Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\\r\\n0011 \\"Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\\r\\n0100 \\"Preset Level,(i.e. a level to be defined externally via CAN)\\r\\n0101 \\"Customer Level,(i.e. a level to be defined by customer via parameter setting)\\r\\n0110 \\"Upper Level,(i.e. the highest level to be controlled)\\r\\n0111 \\"Lower Level,(i.e. the lowest level to be controlled)\\r\\n1000 Level change stopped\\r\\n1001 Raising\\r\\n1010 Lowering\\r\\n1011-1101 Reserved\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1734":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":0,"SPN":1734,"SPN_Name":"Nominal Level Front Axle","SPN_Description":"Signal which indicates the nominal (desired) height of the front axle to be controlled by the suspension system.\\r\\n\\r\\nThese heights are discrete levels.  They are the upper level, lower level, normal level 1, normal level 2, normal level 3, customer level, and preset level.  Refer to Figure SPN1734_A.\\r\\n\\r\\n\xb7 Upper Level is the highest mechanically available height of the vehicle.  \\r\\n\xb7 Lower Level is the lowest mechanically available height of the vehicle.  \\r\\n\\r\\nNormal Levels 1, 2 and 3 are heights normally used during driving.\\r\\n\xb7 Normal Level 1 is most often used and is given by design.  \\r\\n\xb7 Normal Level 2 may be chosen, for example, to be lower than Normal Level 1 for the purpose of reducing fuel consumption while driving on highways.  \\r\\n\xb7 Normal Level 3 may be chosen above Normal Level 1 for driving off road.\\r\\n\\r\\nThe preset level has to be set by means of ASC 6 (PGN: 53504).\\r\\n\\r\\nStates \'Raising\' and \'Lowering\' are only active when corresponding states are requested in SPN 1751.  This provides the possibility to adjust vehicle to a level other than the predefined levels.\\r\\n\\r\\n0000 Level not specified,(i.e. the nominal level is none of the specified levels, no error condition)\\r\\n0001 \\"Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\\r\\n0010 \\"Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\\r\\n0011 \\"Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\\r\\n0100 \\"Preset Level,(i.e. a level to be defined externally via CAN)\\r\\n0101 \\"Customer Level,(i.e. a level to be defined by customer via parameter setting)\\r\\n0110 \\"Upper Level,(i.e. the highest level to be controlled)\\r\\n0111 \\"Lower Level,(i.e. the lowest level to be controlled)\\r\\n1000 Level change stopped\\r\\n1001 Raising\\r\\n1010 Lowering\\r\\n1011-1101 Reserved\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1735":{"PGN":53504,"PGN_Name":"Air Suspension Control 6","PGN_Description":"ASC6","first_bit":48,"SPN":1735,"SPN_Name":"Level Preset Rear Axle Right","SPN_Description":"Set value for nominal level \'preset level\' at the right side of the rear axle. This value is referred to \'Normal level 1\'.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1736":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":14,"SPN":1736,"SPN_Name":"Above Nominal Level Rear Axle","SPN_Description":"Signal which indicates whether the actual height of the rear axle is above the nominal (desired) level of the rear axle. For explanations of nominal level see parameter SPN 1734 - Nominal Level Front Axle.\\r\\n\\r\\n00 Not above\\r\\n01 Above\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1737":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":12,"SPN":1737,"SPN_Name":"Above Nominal Level Front Axle","SPN_Description":"Signal which indicates whether the actual height of the front axle is above the nominal (desired) level of the front axle. For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\\r\\n\\r\\n00 Not above\\r\\n01 Above\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1738":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":8,"SPN":1738,"SPN_Name":"Below Nominal Level Front Axle","SPN_Description":"Signal which indicates whether the actual height of the front axle is below the nominal (desired) level for the front axle. For explanations of nominal level see parameter SPN 1734 - Nominal Level Front Axle.\\r\\n\\r\\n00 Not below\\r\\n01 Below\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1739":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":20,"SPN":1739,"SPN_Name":"Lifting Control Mode Front Axle","SPN_Description":"Signal which indicates the actual lifting level change at the front axle\\r\\n\\r\\n00 Lifting not active\\r\\n01 Lifting active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1740":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":16,"SPN":1740,"SPN_Name":"Lowering Control Mode Front Axle","SPN_Description":"Signal which indicates the actual lowering level change at the front axle\\r\\n\\r\\n00 Lowering not active\\r\\n01 Lowering active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1741":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":28,"SPN":1741,"SPN_Name":"Level Control Mode","SPN_Description":"Signal which indicates the actual control mode of the air suspension system\\r\\n\\r\\n0000    Normal operation; i.e. the system performs a \\"pure\\" control of the vehicle height\\r\\n0001    Traction help (load transfer); i.e. the driven axle is loaded to a maximum value given by legislation or design\\r\\n0010    Load fixing; i.e. the driven axlen is loaded to a value defined by the driver\\r\\n0011    Pressure ratio 1; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 1\\r\\n0100    Pressure ratio 2; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 2\\r\\n0101    Optimum traction 1; i.e. the pressure at the driven axle is controlled at a fixed value 1\\r\\n0110    Optimum traction 2; i.e. the pressure at the driven axle is controlled at a fixed value 2\\r\\n0111    Traction help - load reduce; (i.e. the driven axle load is reduced to normal load condition)\\r\\n1000    Exhausting bellow function; i.e. the bellows are exhausted totally\\r\\n1001    Air suspension control prohibited ( i.e. hold current pressures in all suspension devices.)\\r\\n1010    Automatic air suspension control prohibited\\r\\n1011    Force to bumper level request is in effect\\r\\n1100-1101    Not defined\\r\\n1110    Error\\r\\n1111    Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1742":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":24,"SPN":1742,"SPN_Name":"Kneeling Information","SPN_Description":"Signal which indicates the actual level change in case of kneeling function\\r\\n\\r\\n0000 Not active,(i.e. the kneeling function is not active\\")\\r\\n0001 Lowering active,(i.e. the vehicle is lowered due to a kneeling request)\\r\\n0010 Kneeling level reached,(i.e. the vehicle is at the fixed kneeling level)\\r\\n0011 Lifting active,(i.e. the vehicle is lifted due to a recover request)\\r\\n0100 Kneeling aborted,(i.e. in case of manual actuation the request was dropped before the kneeling level was reached)\\r\\n0101-1101 Not defined\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1743":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":38,"SPN":1743,"SPN_Name":"Lift Axle 1 Position","SPN_Description":"Signal which indicates the position / load condition of lift axle / tag axle 1.   Numbering of lift/tag axles starts at front axle.  See SPN 6843 for more detail.\\r\\n\\r\\n00 Lift axle position down / tag axle laden\\r\\n01 Lift axle position up / tag axle unladen\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1744":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":36,"SPN":1744,"SPN_Name":"Door Release","SPN_Description":"Signal which indicates that the doors may be opened. [Please note: doors instead of door!]\\r\\nIn case a kneeling request is active the ASC indicates during lowering the vehicle \\"doors shall not be opened\\" as a security information until the kneeling level is reached. Then \\"doors may be opened\\" is sent.\\r\\n\\r\\n00 Doors may not be opened\\r\\n01 Doors may be opened\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1745":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":34,"SPN":1745,"SPN_Name":"Vehicle Motion Inhibit","SPN_Description":"Signal which indicates whether vehicle motion is inhibited.\\r\\n\\r\\n00 Vehicle may be moved\\r\\n01 Vehicle motion is inhibited\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1746":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":32,"SPN":1746,"SPN_Name":"Security Device","SPN_Description":"The signal which indicates the status of the security device.  An example of a security device is a curbstone feeler installed beneath the doors of a bus. If the security device becomes active during kneeling the kneeling process (lowering) is stopped and the vehicle lifts back to the starting level.\\r\\n\\r\\n00 Not active\\r\\n01 Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1747":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":6,"SPN":1747,"SPN_Name":"Kneeling Control Mode Request","SPN_Description":"Command signal to select the kneeling functionality\\r\\n\\r\\n00 Automatically actuated\\r\\n01 Manually actuated\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1748":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":4,"SPN":1748,"SPN_Name":"Kneeling Request Right Side","SPN_Description":"Command signal to activate the kneeling functionality on the right side of the vehicle\\r\\n\\r\\n00 No kneeling request\\r\\n01 Kneeling request\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1749":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":2,"SPN":1749,"SPN_Name":"Kneeling Request Left Side","SPN_Description":"Command signal to activate the kneeling functionality on the left side of the vehicle\\r\\n\\r\\n00 No kneeling request\\r\\n01 Kneeling request\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1750":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":12,"SPN":1750,"SPN_Name":"Nominal Level Request Rear Axle","SPN_Description":"Command signal to activate a level of the rear axle programmed and/or memorized in the ECU.  For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\\r\\n\\r\\n0000 No level request\\r\\n0001 Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\\r\\n0010 Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\\r\\n0011 Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\\r\\n0100 Preset Level,(i.e. a level to be defined externally via CAN)\\r\\n0101 Customer Level,(i.e. a level to be defined by customer via parameter setting)\\r\\n0110 Upper Level,(i.e. the highest level to be controlled)\\r\\n0111 Lower Level,(i.e. the lowest level to be controlled)\\r\\n1000 Stop level change,(i.e. the level change in process shall be stopped immediately)\\r\\n1001  Raise Request (Continuously raising front axle, as long as active).\\r\\n1010  Lower Request (Continuously lowering front axle, as long as active).\\r\\n1011-1101 Not defined\\r\\n1110 Reserved\\r\\n1111 Don\'t care/take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1751":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":8,"SPN":1751,"SPN_Name":"Nominal Level Request Front Axle","SPN_Description":"Command signal to activate a level of the front axle programmed and/or memorized in the ECU   For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\\r\\n\\r\\n0000 No level request\\r\\n0001 Normal Level 1,(i.e. the level prescribed for normal driving, given by design)\\r\\n0010 Normal Level 2,(i.e. a level permitted for driving, for example to lower the vehicle in case of high speed)\\r\\n0011 Normal Level 3,(i.e. a level permitted for driving, for example to lift the vehicle in case of offroad)\\r\\n0100 Preset Level,(i.e. a level to be defined externally via CAN)\\r\\n0101 Customer Level,(i.e. a level to be defined by customer via parameter setting)\\r\\n0110 Upper Level,(i.e. the highest level to be controlled)\\r\\n0111 Lower Level,(i.e. the lowest level to be controlled)\\r\\n1000 Stop level change,(i.e. the level change in process shall be stopped immediately)\\r\\n1001  Raise Request (Continuously raising front axle, as long as active).\\r\\n1010  Lower Request (Continuously lowering front axle, as long as active).\\r\\n1011-1101 Not defined\\r\\n1110 Reserved\\r\\n1111 Don\'t care/take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1752":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":20,"SPN":1752,"SPN_Name":"Lift Axle 1 Position Command","SPN_Description":"Signal to command the position/load condition of lift/tag axle #1.  Numbering of lift/tag axles starts at front axle.\\r\\n\\r\\n00 Lift axle position down / tag axle laden\\r\\n01 Lift axle position up / tag axle unladen\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1753":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":16,"SPN":1753,"SPN_Name":"Level Control Mode Request","SPN_Description":"Command signal to activate a level control mode\\r\\n\\r\\n0000    Normal operation; i.e. the system performs a \\"pure\\" control of the vehicle height\\r\\n0001    Traction help (load transfer); i.e. the driven axle is loaded to a maximum value given by legislation or design\\r\\n0010    Load fixing; i.e. the driven axle is loaded to a value defined by the driver\\r\\n0011    Pressure ratio 1; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 1\\r\\n0100    Pressure ratio 2; i.e. the ratio between the pressures at the driven axle and at the third axle is controlled, so that the ratio equals a fixed value 2\\r\\n0101    Optimum traction 1; i.e. the pressure at the driven axle is controlled at a fixed value 1\\r\\n0110    Optimum traction 2; i.e. the pressure at the driven axle is controlled at a fixed value 2\\r\\n0111    Traction help - load reduce; (i.e. reduce axle load of driven axle to normal load condition)\\r\\n1000    Exhaust bellows\\r\\n1001    Force to bumper level\\r\\n1010 -1101    Not defined\\r\\n1110    Reserved\\r\\n1111    Don\'t care/take no action\\r\\n\\r\\nMode 1001 would be used to override other level change requests and force an immediate return to bumper level, e.g. in a situation where the vehicle is in danger of tilting.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1754":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":10,"SPN":1754,"SPN_Name":"Below Nominal Level Rear Axle","SPN_Description":"Signal which indicates whether the actual height of the rear axle is below the nominal (desired) level for the rear axle. For explanations of nominal level see SPN 1734 - Nominal Level Front Axle.\\r\\n\\r\\n00 Not below\\r\\n01 Below\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1755":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":18,"SPN":1755,"SPN_Name":"Lowering Control Mode Rear Axle","SPN_Description":"Signal which indicates the actual lowering level change at the rear axle\\r\\n\\r\\n00 Lowering not active\\r\\n01 Lowering active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1756":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":22,"SPN":1756,"SPN_Name":"Lifting Control Mode Rear Axle","SPN_Description":"Signal which indicates the actual lifting level change at the rear axle\\r\\n\\r\\n00 Lifting not active\\r\\n01 Lifting active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1757":{"PGN":53504,"PGN_Name":"Air Suspension Control 6","PGN_Description":"ASC6","first_bit":16,"SPN":1757,"SPN_Name":"Level Preset Front Axle Right","SPN_Description":"Set value for nominal level \'preset level\' at the right side of the front axle. This value is referred to \'Normal level 1\'.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1758":{"PGN":53504,"PGN_Name":"Air Suspension Control 6","PGN_Description":"ASC6","first_bit":32,"SPN":1758,"SPN_Name":"Level Preset Rear Axle Left","SPN_Description":"Set value for nominal level \'preset level\' at the left side of the rear axle. This value is referred to \'Normal level 1\'.  For explanations of normal level 1 see SPN 1734 - Nominal Level Front Axle.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"1759":{"PGN":65140,"PGN_Name":"Modify Leveling System Control Set Point","PGN_Description":"LSP","first_bit":16,"SPN":1759,"SPN_Name":"Blade Height Set Point (High Resolution)","SPN_Description":"High resolution for the laser guided blade set point.  The high resolution required for more accurate control and \'accurate\' unit conversions.\\r\\n\\r\\nNegative values are below grade, positive values are above grade, zero is on grade.","bit_length":32,"scaling":1e-7,"offset":-209.7152,"unit":"m","SLOT_ID":142},"1760":{"PGN":65136,"PGN_Name":"Combination Vehicle Weight","PGN_Description":"CVW","first_bit":16,"SPN":1760,"SPN_Name":"Gross Combination Vehicle Weight","SPN_Description":"The total weight of the truck and all attached trailers.","bit_length":16,"scaling":10,"offset":0,"unit":"kg","SLOT_ID":29},"1761":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":0,"SPN":1761,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Volume","SPN_Description":"Ratio of volume of diesel exhaust fluid to the total volume of diesel exhaust fluid storage container for aftertreatment system 1 (exhaust bank 1).  0% is empty and 100% is full.  See SPN 3517 and SPN 7530 for alternate measurements.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1762":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":0,"SPN":1762,"SPN_Name":"Hydraulic Pressure","SPN_Description":"Hydraulic pressure measured at the output of the hydraulic pump.","bit_length":16,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":106},"1763":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":16,"SPN":1763,"SPN_Name":"Engine Hydraulic Pressure Governor Mode Indicator","SPN_Description":"Mode for governor operation is hydraulic pressure control.\\r\\n\\r\\n00 Disabled\\r\\n01 Enabled\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1764":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":18,"SPN":1764,"SPN_Name":"Engine Hydraulic Pressure Governor Switch","SPN_Description":"Switch that sets the  mode of hydraulic governor\\r\\n\\r\\n00 Pressure Mode Inactive\\r\\n01 Pressure Mode Active\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1765":{"PGN":65153,"PGN_Name":"Fuel Information 2 (Gaseous)","PGN_Description":"GFI2","first_bit":48,"SPN":1765,"SPN_Name":"Engine Fuel Valve 1 Commanded Position","SPN_Description":"The commanded position of the first fuel valve that is metering the fuel flow to the engine.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1766":{"PGN":65153,"PGN_Name":"Fuel Information 2 (Gaseous)","PGN_Description":"GFI2","first_bit":56,"SPN":1766,"SPN_Name":"Engine Fuel Valve 2 Commanded Position","SPN_Description":"The commanded position of the second fuel valve that is metering the fuel flow to the engine.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1767":{"PGN":65109,"PGN_Name":"Gaseous Fuel Properties","PGN_Description":"GFD","first_bit":0,"SPN":1767,"SPN_Name":"Specific Heat Ratio","SPN_Description":"The specific heat ratio of the fuel.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"1768":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":0,"SPN":1768,"SPN_Name":"Engine Low Limit Threshold for Maximum RPM from Engine","SPN_Description":"Minimum allowable value for maximum continuous RPM from engine","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1769":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":8,"SPN":1769,"SPN_Name":"Engine High Limit Threshold for Minimum Continuous Engine RPM","SPN_Description":"Maximum allowable value for minimum continuous RPM from engine","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1770":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":16,"SPN":1770,"SPN_Name":"Engine Low Limit Threshold for Maximum Torque from Engine","SPN_Description":"Minimum allowable value for maximum continuous torque from engine","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1771":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":24,"SPN":1771,"SPN_Name":"Engine High Limit Threshold for Minimum Continuous Torque from Engine","SPN_Description":"Maximum allowable value for minimum continuous torque from engine","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1772":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":32,"SPN":1772,"SPN_Name":"Engine Maximum Continuous RPM","SPN_Description":"Applied limit for maximum continuous engine RPM","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1773":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":40,"SPN":1773,"SPN_Name":"Engine Minimum Continuous RPM","SPN_Description":"Applied limit for minimum continuous engine RPM","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1774":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":48,"SPN":1774,"SPN_Name":"Engine Maximum Continuous Torque","SPN_Description":"Applied limit for maximum continuous engine torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1775":{"PGN":65108,"PGN_Name":"Engine Continuous Torque & Speed Limit","PGN_Description":"ECT1","first_bit":56,"SPN":1775,"SPN_Name":"Engine Minimum Continuous Torque","SPN_Description":"Applied limit for minimum continuous engine torque","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1776":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":0,"SPN":1776,"SPN_Name":"Low Limit Threshold for Maximum RPM from Retarder","SPN_Description":"Minimum allowable value for maximum continuous retarder speed","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1777":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":8,"SPN":1777,"SPN_Name":"High Limit Threshold for Minimum Continuous RPM from Retarder","SPN_Description":"Maximum allowable value for minimum continuous retarder speed","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1778":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":16,"SPN":1778,"SPN_Name":"Low Limit Threshold for Maximum Torque from Retarder","SPN_Description":"Minimum allowable value for maximum continuous retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1779":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":24,"SPN":1779,"SPN_Name":"High Limit Threshold for Minimum Continuous Torque from Retarder","SPN_Description":"Maximum allowable value for minimum continuous retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1780":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":32,"SPN":1780,"SPN_Name":"Maximum Continuous Retarder Speed ","SPN_Description":"Applied limit for maximum continuous retarder RPM","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1781":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":40,"SPN":1781,"SPN_Name":"Minimum Continuous Retarder Speed","SPN_Description":"Applied limit for minimum continuous retarder RPM","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1782":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":48,"SPN":1782,"SPN_Name":"Maximum Continuous Retarder Torque","SPN_Description":"Applied limit for maximum continuous retarder torque.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1783":{"PGN":65107,"PGN_Name":"Retarder Continuous Torque & Speed Limit","PGN_Description":"RTC1","first_bit":56,"SPN":1783,"SPN_Name":"Minimum Continuous Retarder Torque","SPN_Description":"Applied limit for minimum continuous retarder torque","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1784":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":0,"SPN":1784,"SPN_Name":"Engine Speed Limit Request - Minimum Continuous","SPN_Description":"Requested minimum continuous engine speed","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1785":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":8,"SPN":1785,"SPN_Name":"Engine Speed Limit Request - Maximum Continuous","SPN_Description":"Requested maximum continuous engine speed","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1786":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":16,"SPN":1786,"SPN_Name":"Engine Torque Limit Request - Minimum Continuous","SPN_Description":"Requested minimum continuous engine torque (operating range: 0 to 125%)","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1787":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":24,"SPN":1787,"SPN_Name":"Engine Torque Limit Request - Maximum Continuous","SPN_Description":"Requested maximum continuous engine torque (operating range: 0 to 125%)","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1788":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":32,"SPN":1788,"SPN_Name":"Minimum Continuous Retarder Speed Limit Request","SPN_Description":"Requested minimum continuous retarder speed","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1789":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":40,"SPN":1789,"SPN_Name":"Maximum Continuous Retarder Speed Limit Request","SPN_Description":"Requested maximum continuous retarder speed","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"1790":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":48,"SPN":1790,"SPN_Name":"Minimum Continuous Retarder Torque Limit Request","SPN_Description":"Requested minimum continuous retarder torque (operating range: -125 to 0%)","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1791":{"PGN":52992,"PGN_Name":"Continuous Torque & Speed Limit Request","PGN_Description":"CTL","first_bit":56,"SPN":1791,"SPN_Name":"Maximum Continuous Retarder Torque Limit Request","SPN_Description":"Requested maximum continuous retarder torque (operating range: -125 to 0%)","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"1792":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":62,"SPN":1792,"SPN_Name":"Tractor-Mounted Trailer ABS Warning Signal","SPN_Description":"This parameter commands the tractor-mounted trailer ABS optical warning signal.\\r\\n\\r\\n00 Off\\r\\n01 On \\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1793":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":46,"SPN":1793,"SPN_Name":"ATC/ASR Information Signal","SPN_Description":"This parameter commands the ATC/ASR driver information signal, for example a dash lamp.\\r\\n\\r\\n00 Off\\r\\n01 On \\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1794":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":240,"SPN":1794,"SPN_Name":"Engine Moment of Inertia","SPN_Description":"Moment of inertia for the engine, including items driven full-time by the engine such as fuel, oil and cooling pumps.  The inertia from the following items are not included: flywheel, alternator, compressor, fan, and other engine-driven accessories.","bit_length":16,"scaling":0.004,"offset":0,"unit":"kg\u2022m\xb2","SLOT_ID":112},"1795":{"PGN":65106,"PGN_Name":"Vehicle Electrical Power 3","PGN_Description":"VEP3","first_bit":0,"SPN":1795,"SPN_Name":"Alternator Current (High Range/Resolution)","SPN_Description":"This parameter indicates the amount of electrical current output from the alternator of the main vehicle.  Alternator Current (SPN 115) has a lower range and resolution.","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"1796":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":52,"SPN":1796,"SPN_Name":"ACC Distance Alert Signal","SPN_Description":"Signal to indicate to the operator that the ACC system is not able to maintain the distance to the target. Example: Target stopping rapidly. This signal may be used to activate warning sounds or indicators.\\r\\n\\r\\n00 ACC DAS Not Active\\r\\n01 ACC DAS Active\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1797":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":50,"SPN":1797,"SPN_Name":"ACC System Shutoff Warning","SPN_Description":"Signal to warn the driver of system deactivation due to non-driver actions. Example: Attempting to control vehicle speed below or above limits of ACC. This signal may be used to activate warning sounds or indicators.\\r\\n\\r\\n00 ACC SSOW Not Active\\r\\n01 ACC SSOW Active\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1798":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":48,"SPN":1798,"SPN_Name":"ACC Target Detected","SPN_Description":"Signal to indicate to the driver that the ACC system has detected a target. \\r\\n\\r\\n00 No targets detected\\r\\n01 Target detected\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1799":{"PGN":65105,"PGN_Name":"Adaptive Cruise Control, Operator Input","PGN_Description":"ACC2","first_bit":5,"SPN":1799,"SPN_Name":"Requested ACC Distance Mode","SPN_Description":"The Requested Distance Control Mode to the ACC system from the operators interface.\\r\\n\\r\\nThe ACC Set Distance Mode (SPN 1589) indicates the selected Distance Control Mode for the ACC system. This parameter is the driver requested setting for this.\\r\\n\\r\\n000 Requested ACC Distance Mode #1 (largest distance)\\r\\n001 Requested ACC Distance Mode #2\\r\\n010 Requested ACC Distance Mode #3\\r\\n011 Requested ACC Distance Mode #4\\r\\n100 Requested ACC Distance Mode #5 (shortest distance)\\r\\n101 not defined\\r\\n110 error condition\\r\\n111 not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"1800":{"PGN":65104,"PGN_Name":"Battery Temperature","PGN_Description":"BT1","first_bit":0,"SPN":1800,"SPN_Name":"SLI Battery 1 Temperature","SPN_Description":"Temperature of the battery 1 used for starting the engine, for lighting, and for ignition (SLI). \\r\\n\\r\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1801":{"PGN":65104,"PGN_Name":"Battery Temperature","PGN_Description":"BT1","first_bit":8,"SPN":1801,"SPN_Name":"SLI Battery 2 Temperature","SPN_Description":"Temperature of the second battery or second set of batteries used for starting the engine, for lighting, and for ignition (SLI). \\r\\n\\r\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1802":{"PGN":65189,"PGN_Name":"Intake Manifold Information 2","PGN_Description":"IMT2","first_bit":24,"SPN":1802,"SPN_Name":"Engine Intake Manifold 5 Temperature","SPN_Description":"Temperature of pre-combustion air found in intake manifold number 5 of engine air supply system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1803":{"PGN":65189,"PGN_Name":"Intake Manifold Information 2","PGN_Description":"IMT2","first_bit":32,"SPN":1803,"SPN_Name":"Engine Intake Manifold 6 Temperature","SPN_Description":"Temperature of pre-combustion air found in intake manifold  number 6 of engine air supply system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"1804":{"PGN":64966,"PGN_Name":"Cold Start Aids","PGN_Description":"CSA","first_bit":2,"SPN":1804,"SPN_Name":"Engine Start Enable Device 2","SPN_Description":"Devices that assist an engine in starting, e.g. intake heaters, ether, or an alternate/secondary starting aid.  May be of the same type or different than Start Enable Device 1 (SPN 626). Parameter indicating whether the start enable device 2 is ON or OFF.\\r\\n\\r\\n00 - start enable OFF\\r\\n01 - start enable ON\\r\\n10 - reserved\\r\\n11 - not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1805":{"PGN":65142,"PGN_Name":"Laser Leveling System Vertical Position Display Data","PGN_Description":"LVDD","first_bit":8,"SPN":1805,"SPN_Name":"LED Display Mode Control","SPN_Description":"This parameter informs the system what the selected Display mode will be.\\r\\n\\r\\n0000 - Center On-Grade Display Mode 1 ( 5 CHANNEL )\\r\\n0001 - Offset On-Grade Display Mode \\r\\n0010 - Center On-Grade Display Mode 2 ( 7 CHANNEL )\\r\\n0011 - 1110 Reserved\\r\\n1111 - Not Available or Not Applicable","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1806":{"PGN":65142,"PGN_Name":"Laser Leveling System Vertical Position Display Data","PGN_Description":"LVDD","first_bit":12,"SPN":1806,"SPN_Name":"LED Display Deadband Control","SPN_Description":"This parameter informs the system what the selected Display deadband will be.\\r\\n\\r\\n0000    +/- 4.5 mm  (0.015 feet, 0.18 inches)\\r\\n0001    +/- 12 mm   (0.040 feet, 0.45 inches)\\r\\n0010    +/- 24 mm   (0.080 feet, 0.96 inches)\\r\\n0011    +/- 5  mm    (0.017 feet, 0.2 inches)\\r\\n0100    +/- 1 mm     (0.003 feet, 0.04 inches)\\r\\n0101  - 1110  Reserved\\r\\n1111    Not Available or Not applicable","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1807":{"PGN":61449,"PGN_Name":"Vehicle Dynamic Stability Control 2","PGN_Description":"VDC2","first_bit":0,"SPN":1807,"SPN_Name":"Steering Wheel Angle","SPN_Description":"The main operator`s steering wheel angle (on the steering column, not the actual wheel angle).  The vehicle being steered to the left (counterclockwise) results in a positive steering wheel angle.  This is the yaw angle of the steering wheel with the z-axis along the centerline of the steering column. This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.","bit_length":16,"scaling":0.0009765625,"offset":-31.374,"unit":"rad","SLOT_ID":113},"1808":{"PGN":61449,"PGN_Name":"Vehicle Dynamic Stability Control 2","PGN_Description":"VDC2","first_bit":24,"SPN":1808,"SPN_Name":"Yaw Rate","SPN_Description":"Indicates the rate of rotation about the vertical axis (i.e. the z-axis).  A positive yaw rate signal results when the vehicle turns counter-clockwise.   This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.  See SPN 4985 for an alternate range and resolution using a Z-Down Axis System.","bit_length":16,"scaling":0.0001220703125,"offset":-3.92,"unit":"rad/s","SLOT_ID":114},"1809":{"PGN":61449,"PGN_Name":"Vehicle Dynamic Stability Control 2","PGN_Description":"VDC2","first_bit":40,"SPN":1809,"SPN_Name":"Lateral Acceleration","SPN_Description":"Indicates a lateral acceleration of the vehicle (the component of vehicle acceleration vector along the Y-axis). A positive lateral acceleration signal results when the vehicle is accelerated to the left.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.  See SPN 5347 for an alternate range and resolution.","bit_length":16,"scaling":0.00048828125,"offset":-15.687,"unit":"m/s\xb2","SLOT_ID":115},"1810":{"PGN":61449,"PGN_Name":"Vehicle Dynamic Stability Control 2","PGN_Description":"VDC2","first_bit":56,"SPN":1810,"SPN_Name":"Longitudinal Acceleration","SPN_Description":"Indicates the longitudinal acceleration of the vehicle. A positive longitudinal acceleration signal results when the vehicle speed increases, regardless of driving the vehicle forward or backward.  This parameter is applicable to vehicle speed measurement systems, such as passive wheel speed sensors, that are not capable of determining the direction of the vehicle motion.  See SPN 5348 for an alternate longitudinal acceleration.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"m/s\xb2","SLOT_ID":140},"1811":{"PGN":61449,"PGN_Name":"Vehicle Dynamic Stability Control 2","PGN_Description":"VDC2","first_bit":16,"SPN":1811,"SPN_Name":"Steering Wheel Turn Counter","SPN_Description":"Indicates number of steering wheel turns, absolute position or relative position at ignition on. Positive values indicate left turns.","bit_length":6,"scaling":1,"offset":-32,"unit":"turns","SLOT_ID":141},"1812":{"PGN":61449,"PGN_Name":"Vehicle Dynamic Stability Control 2","PGN_Description":"VDC2","first_bit":22,"SPN":1812,"SPN_Name":"Steering Wheel Angle Sensor Type","SPN_Description":"Indicates whether the steering wheel angle sensor is capable of absolute measuring of the number of steering wheel turns or not (relative measuring to position at ignition on).\\r\\n\\r\\n00 Relative measuring principle\\r\\n01 Absolute measuring principle\\r\\n10 Reserved\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1813":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":0,"SPN":1813,"SPN_Name":"VDC Information Signal","SPN_Description":"This parameter commands the VDC information signal, for example a dash lamp.\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1814":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":2,"SPN":1814,"SPN_Name":"VDC Fully Operational","SPN_Description":"Signal that indicates whether VDC is fully operational or whether its functionality is reduced by a permanent or temporary (e.g. low voltage) defect, by intended action (e.g. disabled by a switch or during special diagnostic procedures), not configured or not yet fully initialized (e.g. missing initialization or configuration message). VDC contains ROP and YC.\\r\\n\\r\\n00 Not fully operational\\r\\n01 Fully operational\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1815":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":4,"SPN":1815,"SPN_Name":"VDC brake light request","SPN_Description":"Indicates whether VDC requests to turn the vehicle brake lights on\\r\\n\\r\\n00 Turn brake light not on\\r\\n01 Turn brake light on\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1816":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":8,"SPN":1816,"SPN_Name":"ROP Engine Control active","SPN_Description":"State Signal which indicates that the Roll Over Prevention (ROP) has commanded engine control to be active. Within the physical limits, ROP attempts to prevent rolling over of the vehicle. Active means that ROP actually tries to control the engine. This state signal is independent of other control commands to the engine which may have higher priority.\\r\\n\\r\\n00 ROP engine control passive but installed\\r\\n01 ROP engine control active\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1817":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":12,"SPN":1817,"SPN_Name":"YC Engine Control active","SPN_Description":"State Signal which indicates that the Yaw Control (YC) has commanded engine control to be active. Within the physical limits, YC attempts to prevent yawing of the vehicle. Active means that YC actually tries to control the engine. This state signal is independent of other control commands to the engine which may have higher priority.\\r\\n\\r\\n00 YC engine control passive but installed\\r\\n01 YC engine control active\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1818":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":10,"SPN":1818,"SPN_Name":"ROP Brake Control active","SPN_Description":"State signal which indicates that Roll over Prevention (ROP) has activated brake control. Active means that ROP actually controls wheel brake pressure at one or more wheels of the vehicle or vehicle combination. Within the physical limits, ROP attempts to prevent rolling over of the vehicle.\\r\\n\\r\\n00 ROP brake control passive but installed\\r\\n01 ROP brake control active\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1819":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":14,"SPN":1819,"SPN_Name":"YC Brake Control active","SPN_Description":"State signal which indicates that Yaw Control (YC) has activated brake control. Active means that YC actually controls wheel brake pressure at one or more wheels of the vehicle or vehicle combination. Within the physical limits, YC attempts to prevent yawing of the vehicle.\\r\\n\\r\\n00 YC brake control passive but installed\\r\\n01 YC brake control active\\r\\n10 Reserved\\r\\n11 Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1820":{"PGN":65102,"PGN_Name":"Door Control 1","PGN_Description":"DC1","first_bit":4,"SPN":1820,"SPN_Name":"Ramp / Wheel Chair Lift Position","SPN_Description":"Signal which indicates the actual position of the ramp / wheel chair lift.\\r\\n\\r\\n00 Inside bus\\r\\n01 Outside bus\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1821":{"PGN":65102,"PGN_Name":"Door Control 1","PGN_Description":"DC1","first_bit":0,"SPN":1821,"SPN_Name":"Position of doors","SPN_Description":"Signal which indicates the actual position of the doors.\\r\\n\\r\\n0000 At least 1 door is open\\r\\n0001 Closing last door\\r\\n0010 All doors closed\\r\\n0011-1101 Not defined\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1822":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":46,"SPN":1822,"SPN_Name":"Lift Axle 2 Position","SPN_Description":"Signal which indicates the position / load condition of lift axle / tag axle #2.   Numbering of lift/tag axles starts at front axle.  See SPN 6844 for more detail.\\r\\n\\r\\n00 Lift axle position down / tag axle laden\\r\\n01 Lift axle position up / tag axle unladen\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1823":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":42,"SPN":1823,"SPN_Name":"Rear Axle in Bumper Range","SPN_Description":"Signal which indicates that the vehicle height at the rear axle (SPNs 1723 and 1724) is within the bumper range.\\r\\n\\r\\n00 Actual level out of bumper range\\r\\n01 Actual level within bumper range\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1824":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":40,"SPN":1824,"SPN_Name":"Front Axle in Bumper Range","SPN_Description":"Signal which indicates that the vehicle height at the front axle (SPNs 1721 and 1722) is within the bumper range.\\r\\n\\r\\n00 Actual level out of bumper range\\r\\n01 Actual level within bumper range\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1825":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":50,"SPN":1825,"SPN_Name":"Suspension Remote control 2","SPN_Description":"Signal which indicates that the suspension system is controlled by remote control #2. Remote control is an external unit to operate the suspension system.\\r\\n\\r\\n00 Not active\\r\\n01 Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1826":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":48,"SPN":1826,"SPN_Name":"Suspension Remote Control 1","SPN_Description":"Signal which indicates that the suspension system is controlled by remote control #1. Remote control is an external unit to operate the suspension system.\\r\\n\\r\\n00 Not active\\r\\n01 Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1827":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":56,"SPN":1827,"SPN_Name":"Suspension Control Refusal Information","SPN_Description":"Signal which indicates that the air suspension control cannot perform a request due to the operating conditions. It also provides a reason for the refusal.\\r\\n\\r\\n0000 Actual request not refused\\r\\n0001 Axle load limit reached  (load transfer)\\r\\n0010 Would exceed axle load limit (tag axle)\\r\\n0011 Bogie differential not locked\\r\\n0100 Above speed limit\\r\\n0101 Below speed limit\\r\\n0110 General reject; I.e. no specified reason applies\\r\\n0111 Requested level not available\\r\\n1000 - 1101  Not defined\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"1828":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":22,"SPN":1828,"SPN_Name":"Lift Axle 2 Position Command","SPN_Description":"Signal to command the position / load condition of lift / tag axle #2.  Numbering of lift/tag axles starts at front axle.\\r\\n\\r\\n00 Lift axle position down / tag axle laden\\r\\n01 Lift axle position up / tag axle unladen\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1829":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":50,"SPN":1829,"SPN_Name":"Kneeling Command - Rear Axle","SPN_Description":"Command signal to activate the kneeling functionality at the rear axle of the vehicle.\\r\\n\\r\\n00 Deactivate kneeling\\r\\n01 Activate kneeling\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1830":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":48,"SPN":1830,"SPN_Name":"Kneeling Command - Front Axle","SPN_Description":"Command signal to activate the kneeling functionality at the front axle of the vehicle\\r\\n\\r\\n00 Deactivate kneeling\\r\\n01 Activate kneeling\\r\\n10 Reserved\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1831":{"PGN":65111,"PGN_Name":"Air Suspension Control 5","PGN_Description":"ASC5","first_bit":28,"SPN":1831,"SPN_Name":"Electronic Shock Absorber Control Mode - Lift/Tag Axle","SPN_Description":"Signal which indicates the current mode of operation of the electronic shock absorber control at the lift/tag axle.\\r\\n\\r\\n00 Normal operation dampers passive\\r\\n01 Normal operation dampers active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1832":{"PGN":65111,"PGN_Name":"Air Suspension Control 5","PGN_Description":"ASC5","first_bit":26,"SPN":1832,"SPN_Name":"Electronic Shock Absorber Control Mode - Rear Axle","SPN_Description":"Signal which indicates the current mode of operation of the electronic shock absorber control at the rear axle.\\r\\n\\r\\n00 Normal operation dampers passive\\r\\n01 Normal operation dampers active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1833":{"PGN":65111,"PGN_Name":"Air Suspension Control 5","PGN_Description":"ASC5","first_bit":24,"SPN":1833,"SPN_Name":"Electronic Shock Absorber Control Mode -  Front Axle","SPN_Description":"Signal which indicates the current mode of operation of the electronic shock absorber control at the front axle.\\r\\n\\r\\n00 Normal operation dampers passive\\r\\n01 Normal operation dampers active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1834":{"PGN":65101,"PGN_Name":"Total Averaged Information","PGN_Description":"TAVG","first_bit":0,"SPN":1834,"SPN_Name":"Engine Total Average Fuel Rate","SPN_Description":"Average fuel rate, equal to total fuel used divided by total engine hours, over the life of the engine","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"1835":{"PGN":65101,"PGN_Name":"Total Averaged Information","PGN_Description":"TAVG","first_bit":16,"SPN":1835,"SPN_Name":"Engine Total Average Fuel Economy","SPN_Description":"Average fuel economy, equal to total vehicle distance divided by total fuel used, over the life of the engine","bit_length":16,"scaling":0.001953125,"offset":0,"unit":"km/L","SLOT_ID":16},"1836":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":60,"SPN":1836,"SPN_Name":"Trailer ABS Status","SPN_Description":"State signal which indicates that ABS in the trailer is actively controlling the brakes.  A message is sent to the tractor from the trailer (i.e. by PLC). The receiving device in the tractor transfers this information to the J1939 network.  At the beginning of power on the message is sent by the trailer to indicate if this status information is supported. Timeout of the trailer ABS active can be done by monitoring of the Trailer warning light information.\\r\\n\\r\\n00 Trailer ABS Status Information Available But Not Active\\r\\n01 Trailer ABS Active\\r\\n10 Reserved\\r\\n11 Trailer ABS Status Information Not Available or Parameter Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1837":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":6,"SPN":1837,"SPN_Name":"Convoy Driving Lamp Select","SPN_Description":"Black Out Convoy Driving Lamp Selection\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1838":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":4,"SPN":1838,"SPN_Name":"Convoy Lamp Select","SPN_Description":"Black Out Convoy Lamp Selection\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1839":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":2,"SPN":1839,"SPN_Name":"Front Black Out Marker Lamp Select","SPN_Description":"Front Black Out Marker Lamp Selection\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1840":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":0,"SPN":1840,"SPN_Name":"Rear Black Out Marker Select","SPN_Description":"Rear Black Out Marker Selection\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1841":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":22,"SPN":1841,"SPN_Name":"Black Out Brake/Stop Lamp Select","SPN_Description":"Black Out Brake/Stop Lamp Selection\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1842":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":30,"SPN":1842,"SPN_Name":"Black Out Work Lamp Select","SPN_Description":"Black Out Work Lamp Selection\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1843":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":24,"SPN":1843,"SPN_Name":"Night Vision Illuminator Select","SPN_Description":"Night Vision Illuminator Selection\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1844":{"PGN":65100,"PGN_Name":"Military Lighting Command","PGN_Description":"ML","first_bit":56,"SPN":1844,"SPN_Name":"Operators Black Out Intensity Selection","SPN_Description":"Operators Selection of lamp intensity in black out mode.  This parameter provides the operators selected illumination intensity as a percentage of available full scale.  This parameter would be typically used as a dash or instrument cluster intensity adjustment.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"1845":{"PGN":65099,"PGN_Name":"Transmission Configuration 2","PGN_Description":"TCFG2","first_bit":0,"SPN":1845,"SPN_Name":"Transmission Torque Limit","SPN_Description":"Parameter provided to the engine from the transmission as a torque limit to be invoked by the engine in the event that J1939 communication with the transmission is lost.\\r\\n\\r\\nThe intention is to protect transmissions that use a continuous torque limit during torque converter mode or operation in specific lower gears, where stall or drivetrain torque may reach levels higher than the gearbox capacity.  If communication is lost during torque limited operation, unrestricted engine torque output could harm the transmission.\\r\\n\\r\\nIt is recommended that engines use reception of the ETC#1 message as a transmission \u201Cheartbeat\u201D.  In the event that the ETC#1 message is not received in a time period of 5 times its\u2019 broadcast rate (5 x 10 ms = 50 ms), the engine should invoke a torque limit holding the engine to less than or equal to the value of the Transmission Torque Limit parameter.  The engine may release the limit when transmission-to-engine communication is re-established.\\r\\n\\r\\nA value of 0xFF00 to 0xFFFF indicates that no transmission torque limit is desired.\\r\\n\\r\\nIt is expected that the engine will record this torque value in non-volatile memory and will include this in the engine configuration PGN as parameter Engine Default Torque Limit (SPN 1846)\\r\\n\\r\\nIf the engine observes change in this parameter value on power-up, the engine should record the new value.\\r\\n\\r\\nSPN 7827 provides an idle torque limit for the transmission in case of communications failure.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1846":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":256,"SPN":1846,"SPN_Name":"Engine Default Torque Limit","SPN_Description":"Companion parameter to Transmission Torque Limit (SPN 1845).  This \u201Cecho\u201D parameter provides confirmation to the transmission that the engine has received and will invoke the requested Transmission Torque Limit in the event that J1939 communication is lost between the two devices.\\r\\n\\r\\nIf the engine supports this protection logic, the Engine Default Torque Limit parameter should be set equal to the Transmission Torque Limit parameter as received in the Transmission Configuration 2 message (PGN 65099).  Otherwise, an Engine Default Torque Limit value of FF00 to FFFF indicates that no engine default torque limit has been received or set.\\r\\n\\r\\nThe intention is to protect transmissions that use a continuous torque limit during torque converter mode or operation in specific lower gears, where stall or drivetrain torque may reach levels higher than the gearbox capacity.  If communication is lost during torque limited operation, unrestricted engine torque output could harm the transmission.\\r\\n\\r\\nIt is recommended that engines use reception of the ETC#1 message as a transmission \u201Cheartbeat\u201D.  In the event that the ETC#1 message is not received in a time period of 5 times its\u2019 broadcast rate (5 x 10 ms = 50 ms), the engine should invoke a torque limit holding the engine to less than or equal to the value of the Transmission Torque Limit parameter.  The engine may release the limit when engine-to-transmission communication is re-established.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"1847":{"PGN":64774,"PGN_Name":"Direct Lamp Control Command 2","PGN_Description":"DLCC2","first_bit":10,"SPN":1847,"SPN_Name":"Hill Holder Lamp Command","SPN_Description":"Command signal directly controlling Hill Holder Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Lamp Flash (1 Hz)\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1848":{"PGN":64772,"PGN_Name":"Direct Lamp Control Data 2","PGN_Description":"DLCD2","first_bit":10,"SPN":1848,"SPN_Name":"Hill Holder Lamp Data","SPN_Description":"This message will be transmitted by the controller that is illuminating the lamps.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1849":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":6,"SPN":1849,"SPN_Name":"Transmission Requested Range Display Flash State","SPN_Description":"State signal indicating a transmission request for the display of the Transmission Requested Range parameter (SPN 162) to flash or not to flash. The \u2018Transmission Requested Range Display Flash State\u2019 indicator can be utilized by (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of this state is at the discretion of the transmission manufacturer. The flash period shall be 700 ms @ 50% duty cycle.\\r\\n\\r\\nTransmission manufacturers may want to flash the Transmission Requested Range display depending on certain events.  It could be because a gear could not be attained, or because fluid is low, etc.  Indicator should be on for 350 ms and off for 350 ms.\\r\\n\\r\\nTransmissions supporting both this parameter and the Transmission Requested Range Display Blank \\r\\nState should treat the active states of these parameters as mutually exclusive; both parameters should not indicate \\"active\\" at the same time.\\r\\n\\r\\n00 Inactive; Transmission Requested Range display should not be flashing\\r\\n01 Active; Transmission Requested Range display should be flashing\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1850":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":4,"SPN":1850,"SPN_Name":"Transmission Requested Range Display Blank State","SPN_Description":"State signal indicating a transmission request for the display of the Transmission Requested Range parameter (SPN162) to be blanked or not blanked.  The \u2018Transmission Requested Range Display Blank State\u2019 indicator can be utilized by (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of this state is at the discretion of the transmission manufacturer\\r\\n\\r\\nTransmission manufacturers may want to blank the Transmission Requested Range display depending on certain events.  Typically it is an indication of a shift selector problem.\\r\\n\\r\\nTransmissions supporting both this parameter and the Transmission Requested Range Display Flash \\r\\nState should treat the active states of these parameters as mutually exclusive; both parameters should not indicate \\"active\\" at the same time.\\r\\n\\r\\n00 Inactive; Transmission Requested Range display should not be blanked\\r\\n01 Active; Transmission Requested Range display should be blanked\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1851":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":14,"SPN":1851,"SPN_Name":"Transmission Shift Inhibit Indicator","SPN_Description":"State signal indicating a transmission request for the Shift Inhibit Indicator to be active or inactive. The shift inhibit indicator can be of lamp or text form, located on (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of the \u2018range inhibit\u2019 state is at the discretion of the transmission manufacturer.\\r\\n\\r\\nTransmission manufacturers may want to indicate that they currently cannot make a requested shift. This could be due to inappropriate vehicle speed or other restrictions.\\r\\n\\r\\nDistinctions in meaning between the continuous and flashing are left to the transmission manufacturer.\\r\\n\\r\\n00 Inactive; shift is not inhibited\\r\\n01 Active (on continuously); shift is inhibited\\r\\n10 Active (flashing)\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1852":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":40,"SPN":1852,"SPN_Name":"Transmission Mode 1","SPN_Description":"Indicates whether transmission mode 1 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2536.\\r\\n\\r\\n00 Disable\\r\\n01 Enable\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1853":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":42,"SPN":1853,"SPN_Name":"Transmission Mode 2","SPN_Description":"Indicates whether transmission mode 2 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2537.\\r\\n\\r\\n00 Disable\\r\\n01 Enable\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1854":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":44,"SPN":1854,"SPN_Name":"Transmission Mode 3","SPN_Description":"Indicates whether transmission mode 3 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2538.\\r\\n\\r\\n00 Disable\\r\\n01 Enable\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1855":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":46,"SPN":1855,"SPN_Name":"Transmission Mode 4","SPN_Description":"Indicates whether transmission mode 4 is enabled.  Modes are manufacturer specific and are not necessarily mutually exclusive.  See also SPN 2539.\\r\\n\\r\\n00 Disable\\r\\n01 Enable\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1856":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":30,"SPN":1856,"SPN_Name":"Seat Belt Switch","SPN_Description":"State of switch used to determine if Seat Belt is buckled\\r\\n\\r\\n00 NOT Buckled\\r\\n01 OK - Seat Belt is buckled\\r\\n10 Error - Switch state cannot be determined\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"1857":{"PGN":65128,"PGN_Name":"Vehicle Fluids","PGN_Description":"VF","first_bit":10,"SPN":1857,"SPN_Name":"Winch Oil Pressure Switch","SPN_Description":"State of switch used to determine if Winch Oil Pressure is above desired minimum\\r\\n\\r\\n00 NOT OK- Oil pressure is too low\\r\\n01 OK - Oil pressure is above minimum\\r\\n10 Error - Switch state cannot be determined\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2347":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":6,"SPN":2347,"SPN_Name":"High Beam Head Light Command","SPN_Description":"Command to activate or de-activate the tractor high beam head light lamps. \\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2348":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":6,"SPN":2348,"SPN_Name":"High Beam Head Light Data","SPN_Description":"This parameter provides measured data from the tractor high beam head light lamps. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2349":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":4,"SPN":2349,"SPN_Name":"Low Beam Head Light Command","SPN_Description":"Command to activate or de-activate the tractor low beam head light lamps. \\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2350":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":4,"SPN":2350,"SPN_Name":"Low Beam Head Light Data","SPN_Description":"This parameter provides measured data from the tractor low beam head light lamps. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2351":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":2,"SPN":2351,"SPN_Name":"Alternate Beam Head Light Command","SPN_Description":"Command to activate or de-activate the tractor alternate head lights (only low beam is available on alternate head lights).  The alternate position lights are intended for use with loader and snow plows that tend to block the primary head lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2352":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":2,"SPN":2352,"SPN_Name":"Alternate Beam Head Light Data","SPN_Description":"This parameter provides measured data from the tractor alternate beam head light lamps. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2353":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":44,"SPN":2353,"SPN_Name":"Tractor Front Low Mounted Work Lights Command","SPN_Description":"Command to activate or de-activate the tractor front low mounted work lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2354":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":44,"SPN":2354,"SPN_Name":"Tractor Front Low Mounted Work Lights","SPN_Description":"This parameter provides measured data from the tractor front low mounted work lights. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2355":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":46,"SPN":2355,"SPN_Name":"Tractor Front High Mounted Work Lights Command","SPN_Description":"Command to activate or de-activate the tractor front high mounted work lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2356":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":46,"SPN":2356,"SPN_Name":"Tractor Front High Mounted Work Lights","SPN_Description":"This parameter provides measured data from the tractor front high mounted work lights. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2357":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":34,"SPN":2357,"SPN_Name":"Tractor Underside Mounted Work Lights Command","SPN_Description":"Command to activate or de-activate the tractor underside mounted work lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2358":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":34,"SPN":2358,"SPN_Name":"Tractor Underside Mounted Work Lights","SPN_Description":"This parameter provides measured data from the tractor underside mounted work lights. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2359":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":36,"SPN":2359,"SPN_Name":"Tractor Rear Low Mounted Work Lights Command","SPN_Description":"Command to activate or de-activate the tractor rear low  mounted work lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2360":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":36,"SPN":2360,"SPN_Name":"Tractor Rear Low Mounted Work Lights","SPN_Description":"This parameter provides measured data from the tractor rear low mounted work lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2361":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":38,"SPN":2361,"SPN_Name":"Tractor Rear High Mounted Work Lights Command","SPN_Description":"Command to activate or de-activate the tractor rear high  mounted work lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2362":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":38,"SPN":2362,"SPN_Name":"Tractor Rear High Mounted Work Lights","SPN_Description":"This parameter provides measured data from the tractor rear high mounted work lights. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2363":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":40,"SPN":2363,"SPN_Name":"Tractor Side Low Mounted Work Lights Command","SPN_Description":"Command to activate or de-activate the tractor side low mounted work lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2364":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":40,"SPN":2364,"SPN_Name":"Tractor Side Low Mounted Work Lights","SPN_Description":"This parameter provides measured data from the tractor side low mounted work lights. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2365":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":42,"SPN":2365,"SPN_Name":"Tractor Side High Mounted Work Lights Command","SPN_Description":"Command to activate or de-activate the tractor side high mounted work lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2366":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":42,"SPN":2366,"SPN_Name":"Tractor Side High Mounted Work Lights","SPN_Description":"This parameter provides measured data from the tractor side high mounted work lights. \\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2367":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":14,"SPN":2367,"SPN_Name":"Left Turn Signal Lights Command","SPN_Description":"Command to activate or de-activate left turn signal lights on the tractor and all connected implements\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2368":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":14,"SPN":2368,"SPN_Name":"Left Turn Signal Lights","SPN_Description":"This parameter provides measured data from the tractor and attached implement left turn signal lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2369":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":12,"SPN":2369,"SPN_Name":"Right Turn Signal Lights Command","SPN_Description":"Command to activate or de-activate right turn signal lights on the tractor and all connected implements\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2370":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":12,"SPN":2370,"SPN_Name":"Right Turn Signal Lights","SPN_Description":"This parameter provides measured data from the tractor and attached implement right turn signal lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2371":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":22,"SPN":2371,"SPN_Name":"Left Stop Light Command","SPN_Description":"Command to activate or de-activate the tractor and implement left stop lights\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2372":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":22,"SPN":2372,"SPN_Name":"Left Stop Light","SPN_Description":"This parameter provides measured data from the tractor and attached implement left stop lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2373":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":20,"SPN":2373,"SPN_Name":"Right Stop Light Command","SPN_Description":"Command to activate or de-activate the tractor and implement right stop light\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2374":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":20,"SPN":2374,"SPN_Name":"Right Stop Light","SPN_Description":"This parameter provides measured data from the tractor and attached implement right stop lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2375":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":18,"SPN":2375,"SPN_Name":"Center Stop Light Command","SPN_Description":"Command to activate or de-activate the tractor and implement center stop light\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2376":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":18,"SPN":2376,"SPN_Name":"Center Stop Light","SPN_Description":"This parameter provides measured data from the tractor and attached implement center stop lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2377":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":30,"SPN":2377,"SPN_Name":"Tractor Marker Light Command","SPN_Description":"Command to activate or de-activate tractor and implement front position lights, rear red tail lights, side amber running lights, license plate lights and instrument and switch back lights.  \\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2378":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":30,"SPN":2378,"SPN_Name":"Tractor Marker Light","SPN_Description":"This parameter provides measured data from the tractor and attached implement marker lights, including front position lights, rear tail lights, side running lights, license plate lights and instruments and switch back lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2379":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":28,"SPN":2379,"SPN_Name":"Implement Marker Light Command","SPN_Description":"Command to activate or de-activate implement front position lights, rear red tail lights, side amber running lights, license plate lights and instrument and switch back lights.  \\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2380":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":28,"SPN":2380,"SPN_Name":"Implement Marker Light","SPN_Description":"This parameter provides measured data from an attached implement marker lights, including front position lights, rear tail lights, side running lights, license plate lights and instruments and switch back lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2381":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":26,"SPN":2381,"SPN_Name":"Tractor Clearance Light Command","SPN_Description":"Command to activate or de-activate the tractor high mounted clearance and center ID lights\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2382":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":26,"SPN":2382,"SPN_Name":"Tractor Clearance Light","SPN_Description":"This parameter provides measured data from the tractor high mounted clearance and center ID lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2383":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":24,"SPN":2383,"SPN_Name":"Implement Clearance Light Command","SPN_Description":"Command to activate or de-activate the implement high mounted clearance and lights.  \\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2384":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":24,"SPN":2384,"SPN_Name":"Implement Clearance Light","SPN_Description":"This parameter provides measured data from an attached implement high mounted clearance lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2385":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":10,"SPN":2385,"SPN_Name":"Rotating Beacon Light Command","SPN_Description":"Command to activate or de-activate slow moving vehicle indicator lights on tractor and/or implements.  Activation of the slow moving vehicle lights implies that the controller should manipulate the lighting as appropriate to provide the slow moving vehicle lighting function.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2386":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":10,"SPN":2386,"SPN_Name":"Rotating Beacon Light","SPN_Description":"This parameter provides measured data from the beacon light on tractor or attached implements.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2387":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":8,"SPN":2387,"SPN_Name":"Tractor Front Fog Lights Command","SPN_Description":"Command to activate or de-activate tractor front fog lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2388":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":8,"SPN":2388,"SPN_Name":"Tractor Front Fog Lights","SPN_Description":"This parameter provides measured data from the tractor front fog lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2389":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":32,"SPN":2389,"SPN_Name":"Rear Fog Light Command","SPN_Description":"Command to activate or de-activate tractor or implement rear fog lights.  \\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2390":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":32,"SPN":2390,"SPN_Name":"Rear Fog Lights","SPN_Description":"This parameter provides measured data from the tractor and/or implement rear fog lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2391":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":16,"SPN":2391,"SPN_Name":"Back Up Light and Alarm Horn Command","SPN_Description":"Command to activate or de-activate the back up lights and/ or associated alarm if required\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2392":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":16,"SPN":2392,"SPN_Name":"Back Up Light and Alarm Horn","SPN_Description":"This parameter provides measured data from the back up lights and/ or associated alarm.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2393":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":56,"SPN":2393,"SPN_Name":"Lighting Data Request Command","SPN_Description":"Command to provide a response of the light state\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2394":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":62,"SPN":2394,"SPN_Name":"Implement Rear Work Light","SPN_Description":"This parameter provides measured data from the implement rear work lamps.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2395":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":50,"SPN":2395,"SPN_Name":"Implement OEM Option 1 Light Command","SPN_Description":"Command to activate or de-activate an implement OEM option 1 light.  This is provided to meet special needs on implements, such as tank inspection or filling lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2396":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":50,"SPN":2396,"SPN_Name":"Implement OEM Option 1 Light","SPN_Description":"This parameter provides measured data from the implement OEM option 1 light.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2397":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":48,"SPN":2397,"SPN_Name":"Implement OEM Option 2 Light Command","SPN_Description":"Command to activate or de-activate an implement OEM option 2 light.  This is provided to meet special needs on implements, such as tank inspection or filling lights.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2398":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":48,"SPN":2398,"SPN_Name":"Implement OEM Option 2 Light","SPN_Description":"This parameter provides measured data from the implement OEM option 2 light.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2399":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":60,"SPN":2399,"SPN_Name":"Implement Left Facing Work Light Command","SPN_Description":"Command to activate or de-activate the left facing work lights toward the left end of the implement.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2400":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":60,"SPN":2400,"SPN_Name":"Implement Left Facing Work Light","SPN_Description":"This parameter provides measured data from the left facing work lights toward the left end of the implement.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2401":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":58,"SPN":2401,"SPN_Name":"Implement Right Forward Work Light Command","SPN_Description":"Command to activate or de-activate the forward facing work lights toward the right end of the implement.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2402":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":58,"SPN":2402,"SPN_Name":"Implement Right Forward Work Light","SPN_Description":"This parameter provides measured data from the forward facing work lights toward the right end of the implement.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2403":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":0,"SPN":2403,"SPN_Name":"Running Light Command","SPN_Description":"Command to activate or de-activate the tractor or powered vehicle running lights.  Usually only used for on road vehicles.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2404":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":0,"SPN":2404,"SPN_Name":"Running Light","SPN_Description":"This parameter provides measured data from the vehicle\u2019s running lights.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2405":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":62,"SPN":2405,"SPN_Name":"Implement Rear Work Light Command","SPN_Description":"Command to activate or de-activate implement rear work lights.  (This is also the same as Reversing Lights for truck applications.)  \\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2406":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":52,"SPN":2406,"SPN_Name":"Implement Right Facing Work Light Command","SPN_Description":"Command to activate or de-activate work lights mounted on an implement to illuminate beyond right end of the implement.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2407":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":52,"SPN":2407,"SPN_Name":"Implement Right Facing Work Light","SPN_Description":"This parameter provides measured data from the work lights mounted on an implement to illuminate beyond right end of the implement.\\r\\n\\r\\n00 De-activated\\r\\n01 Activated\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2432":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":56,"SPN":2432,"SPN_Name":"Engine Demand \u2013 Percent Torque","SPN_Description":"The requested torque output of the engine by all dynamic internal inputs, including smoke control, noise control and low and high speed governing.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"2433":{"PGN":65031,"PGN_Name":"Exhaust Temperature","PGN_Description":"ET","first_bit":0,"SPN":2433,"SPN_Name":"Engine Exhaust Manifold Bank 2 Temperature 1","SPN_Description":"Temperature of combustion byproducts measured in engine bank 2 (right bank) exhaust manifold.  Single manifold engines should use exhaust temperature (SPN 173).","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2434":{"PGN":65031,"PGN_Name":"Exhaust Temperature","PGN_Description":"ET","first_bit":16,"SPN":2434,"SPN_Name":"Engine Exhaust Manifold Bank 1 Temperature 1","SPN_Description":"Temperature of combustion byproducts measured in engine bank 1 (left bank) exhaust manifold.  Single manifold engines should use exhaust temperature (SPN 173).","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2435":{"PGN":65172,"PGN_Name":"Engine Auxiliary Coolant","PGN_Description":"EAC","first_bit":16,"SPN":2435,"SPN_Name":"Sea Water Pump Outlet Pressure","SPN_Description":"Gauge pressure of liquid found at outlet of sea water pump in sea water cooling system.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"2436":{"PGN":65030,"PGN_Name":"Generator Average Basic AC Quantities","PGN_Description":"GAAC","first_bit":32,"SPN":2436,"SPN_Name":"Generator Average AC Frequency","SPN_Description":"Average AC frequency measured at the generator output.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2437":{"PGN":65027,"PGN_Name":"Generator Phase A Basic AC Quantities","PGN_Description":"GPAAC","first_bit":32,"SPN":2437,"SPN_Name":"Generator Phase A AC Frequency","SPN_Description":"AC frequency measured at the generator phase A output.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2438":{"PGN":65024,"PGN_Name":"Generator Phase B Basic AC Quantities","PGN_Description":"GPBAC","first_bit":32,"SPN":2438,"SPN_Name":"Generator Phase B AC Frequency","SPN_Description":"AC frequency measured at the generator phase B output.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2439":{"PGN":65021,"PGN_Name":"Generator Phase C Basic AC Quantities","PGN_Description":"GPCAC","first_bit":32,"SPN":2439,"SPN_Name":"Generator Phase C AC Frequency","SPN_Description":"AC frequency measured at the generator phase C output.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2440":{"PGN":65030,"PGN_Name":"Generator Average Basic AC Quantities","PGN_Description":"GAAC","first_bit":0,"SPN":2440,"SPN_Name":"Generator Average Line-Line AC RMS Voltage","SPN_Description":"Average Line to Line RMS voltage measured at the generator output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2441":{"PGN":65027,"PGN_Name":"Generator Phase A Basic AC Quantities","PGN_Description":"GPAAC","first_bit":0,"SPN":2441,"SPN_Name":"Generator Phase AB Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at the generator phase AB output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2442":{"PGN":65024,"PGN_Name":"Generator Phase B Basic AC Quantities","PGN_Description":"GPBAC","first_bit":0,"SPN":2442,"SPN_Name":"Generator Phase BC Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at the generator phase BC output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2443":{"PGN":65021,"PGN_Name":"Generator Phase C Basic AC Quantities","PGN_Description":"GPCAC","first_bit":0,"SPN":2443,"SPN_Name":"Generator Phase CA Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at the generator phase CA output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2444":{"PGN":65030,"PGN_Name":"Generator Average Basic AC Quantities","PGN_Description":"GAAC","first_bit":16,"SPN":2444,"SPN_Name":"Generator Average Line-Neutral AC RMS Voltage","SPN_Description":"The average Line to Neutral AC RMS voltage measured at the Generator output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2445":{"PGN":65027,"PGN_Name":"Generator Phase A Basic AC Quantities","PGN_Description":"GPAAC","first_bit":16,"SPN":2445,"SPN_Name":"Generator Phase A Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at the generator phase A output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2446":{"PGN":65024,"PGN_Name":"Generator Phase B Basic AC Quantities","PGN_Description":"GPBAC","first_bit":16,"SPN":2446,"SPN_Name":"Generator Phase B Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at the generator phase B output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2447":{"PGN":65021,"PGN_Name":"Generator Phase C Basic AC Quantities","PGN_Description":"GPCAC","first_bit":16,"SPN":2447,"SPN_Name":"Generator Phase C Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at the generator phase C output.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2448":{"PGN":65030,"PGN_Name":"Generator Average Basic AC Quantities","PGN_Description":"GAAC","first_bit":48,"SPN":2448,"SPN_Name":"Generator Average AC RMS Current","SPN_Description":"Average RMS current measured at the generator output.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2449":{"PGN":65027,"PGN_Name":"Generator Phase A Basic AC Quantities","PGN_Description":"GPAAC","first_bit":48,"SPN":2449,"SPN_Name":"Generator Phase A AC RMS Current","SPN_Description":"RMS current measured at the generator phase A output.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2450":{"PGN":65024,"PGN_Name":"Generator Phase B Basic AC Quantities","PGN_Description":"GPBAC","first_bit":48,"SPN":2450,"SPN_Name":"Generator Phase B AC RMS Current","SPN_Description":"RMS current measured at the generator phase B output.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2451":{"PGN":65021,"PGN_Name":"Generator Phase C Basic AC Quantities","PGN_Description":"GPCAC","first_bit":48,"SPN":2451,"SPN_Name":"Generator Phase C AC RMS Current","SPN_Description":"RMS current measured at the generator phase C output.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2452":{"PGN":65029,"PGN_Name":"Generator Total AC Power","PGN_Description":"GTACP","first_bit":0,"SPN":2452,"SPN_Name":"Generator Total Real Power","SPN_Description":"Total real power delivered by the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2453":{"PGN":65026,"PGN_Name":"Generator Phase A AC Power","PGN_Description":"GPAACP","first_bit":0,"SPN":2453,"SPN_Name":"Generator Phase A Real Power","SPN_Description":"The real power delivered by phase A of the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2454":{"PGN":65023,"PGN_Name":"Generator Phase B AC Power","PGN_Description":"GPBACP","first_bit":0,"SPN":2454,"SPN_Name":"Generator Phase B Real Power","SPN_Description":"The real power delivered by phase B of the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2455":{"PGN":65020,"PGN_Name":"Generator Phase C AC Power","PGN_Description":"GPCACP","first_bit":0,"SPN":2455,"SPN_Name":"Generator Phase C Real Power","SPN_Description":"The real power delivered by phase C of the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2456":{"PGN":65028,"PGN_Name":"Generator Total AC Reactive Power","PGN_Description":"GTACR","first_bit":0,"SPN":2456,"SPN_Name":"Generator Total Reactive Power","SPN_Description":"The total reactive power delivered by the generator","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2457":{"PGN":65025,"PGN_Name":"Generator Phase A AC Reactive Power","PGN_Description":"GPAACR","first_bit":0,"SPN":2457,"SPN_Name":"Generator Phase A Reactive Power","SPN_Description":"The reactive power delivered by phase A of the generator","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2458":{"PGN":65022,"PGN_Name":"Generator Phase B AC Reactive Power","PGN_Description":"GPBACRP","first_bit":0,"SPN":2458,"SPN_Name":"Generator Phase B Reactive Power","SPN_Description":"The reactive power delivered by phase B of the generator","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2459":{"PGN":65019,"PGN_Name":"Generator Phase C AC Reactive Power","PGN_Description":"GPCACR","first_bit":0,"SPN":2459,"SPN_Name":"Generator Phase C Reactive Power","SPN_Description":"The reactive power delivered by phase C of the generator","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2460":{"PGN":65029,"PGN_Name":"Generator Total AC Power","PGN_Description":"GTACP","first_bit":32,"SPN":2460,"SPN_Name":"Generator Total Apparent Power","SPN_Description":"The total apparent power delivered by the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2461":{"PGN":65026,"PGN_Name":"Generator Phase A AC Power","PGN_Description":"GPAACP","first_bit":32,"SPN":2461,"SPN_Name":"Generator Phase A Apparent Power","SPN_Description":"The apparent power delivered by phase A of the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2462":{"PGN":65023,"PGN_Name":"Generator Phase B AC Power","PGN_Description":"GPBACP","first_bit":32,"SPN":2462,"SPN_Name":"Generator Phase B Apparent Power","SPN_Description":"The apparent power delivered by phase B of the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2463":{"PGN":65020,"PGN_Name":"Generator Phase C AC Power","PGN_Description":"GPCACP","first_bit":32,"SPN":2463,"SPN_Name":"Generator Phase C Apparent Power","SPN_Description":"The apparent power delivered by phase C of the generator.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2464":{"PGN":65028,"PGN_Name":"Generator Total AC Reactive Power","PGN_Description":"GTACR","first_bit":32,"SPN":2464,"SPN_Name":"Generator Overall Power Factor","SPN_Description":"The average power factor of the generator.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2465":{"PGN":65025,"PGN_Name":"Generator Phase A AC Reactive Power","PGN_Description":"GPAACR","first_bit":32,"SPN":2465,"SPN_Name":"Generator Phase A Power Factor","SPN_Description":"The power factor of phase A of the generator.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2466":{"PGN":65022,"PGN_Name":"Generator Phase B AC Reactive Power","PGN_Description":"GPBACRP","first_bit":32,"SPN":2466,"SPN_Name":"Generator Phase B Power Factor","SPN_Description":"The power factor of phases B of the generator.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2467":{"PGN":65019,"PGN_Name":"Generator Phase C AC Reactive Power","PGN_Description":"GPCACR","first_bit":32,"SPN":2467,"SPN_Name":"Generator Phase C Power Factor","SPN_Description":"The power factor of phases C of the generator.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2468":{"PGN":65018,"PGN_Name":"Generator Total AC Energy","PGN_Description":"GTACE","first_bit":0,"SPN":2468,"SPN_Name":"Generator Total kW Hours Export","SPN_Description":"The total kilowatt-hours that have been exported by the generator.","bit_length":32,"scaling":1,"offset":0,"unit":"kWh","SLOT_ID":150},"2469":{"PGN":65018,"PGN_Name":"Generator Total AC Energy","PGN_Description":"GTACE","first_bit":32,"SPN":2469,"SPN_Name":"Generator Total kW Hours Import","SPN_Description":"The total kilowatt-hours that have been imported by the generator.","bit_length":32,"scaling":1,"offset":0,"unit":"kWh","SLOT_ID":150},"2470":{"PGN":65017,"PGN_Name":"Utility Average Basic AC Quantities","PGN_Description":"UAAC","first_bit":32,"SPN":2470,"SPN_Name":"Utility Average AC Frequency","SPN_Description":"Average AC frequency measured at the utility incomer.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2471":{"PGN":65014,"PGN_Name":"Utility Phase A Basic AC Quantities","PGN_Description":"UPAAC","first_bit":32,"SPN":2471,"SPN_Name":"Utility Phase A AC Frequency","SPN_Description":"AC frequency measured at the utility incomer phase A.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2472":{"PGN":65011,"PGN_Name":"Utility Phase B AC Basic Quantities","PGN_Description":"UPBAC","first_bit":32,"SPN":2472,"SPN_Name":"Utility Phase B AC Frequency","SPN_Description":"AC frequency measured at the utility incomer phase B.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2473":{"PGN":65008,"PGN_Name":"Utility Phase C AC Basic Quantities","PGN_Description":"UPCAC","first_bit":32,"SPN":2473,"SPN_Name":"Utility Phase C AC Frequency","SPN_Description":"AC frequency measured at the utility incomer phase C.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2474":{"PGN":65017,"PGN_Name":"Utility Average Basic AC Quantities","PGN_Description":"UAAC","first_bit":0,"SPN":2474,"SPN_Name":"Utility Average Line-Line AC RMS Voltage","SPN_Description":"Average Line to Line RMS voltage measured at the utility incomer .","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2475":{"PGN":65014,"PGN_Name":"Utility Phase A Basic AC Quantities","PGN_Description":"UPAAC","first_bit":0,"SPN":2475,"SPN_Name":"Utility Phase AB Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at the utility incomer phase AB.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2476":{"PGN":65011,"PGN_Name":"Utility Phase B AC Basic Quantities","PGN_Description":"UPBAC","first_bit":0,"SPN":2476,"SPN_Name":"Utility Phase BC Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at the utility incomer phase BC.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2477":{"PGN":65008,"PGN_Name":"Utility Phase C AC Basic Quantities","PGN_Description":"UPCAC","first_bit":0,"SPN":2477,"SPN_Name":"Utility Phase CA Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at the utility incomer phase CA.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2478":{"PGN":65017,"PGN_Name":"Utility Average Basic AC Quantities","PGN_Description":"UAAC","first_bit":16,"SPN":2478,"SPN_Name":"Utility Average Line-Neutral AC RMS Voltage","SPN_Description":"The average Line to Neutral AC RMS voltage measured at the utility incomer .","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2479":{"PGN":65014,"PGN_Name":"Utility Phase A Basic AC Quantities","PGN_Description":"UPAAC","first_bit":16,"SPN":2479,"SPN_Name":"Utility Phase A Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at the utility incomer phase A.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2480":{"PGN":65011,"PGN_Name":"Utility Phase B AC Basic Quantities","PGN_Description":"UPBAC","first_bit":16,"SPN":2480,"SPN_Name":"Utility Phase B Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at the utility incomer phase B.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2481":{"PGN":65008,"PGN_Name":"Utility Phase C AC Basic Quantities","PGN_Description":"UPCAC","first_bit":16,"SPN":2481,"SPN_Name":"Utility Phase C Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at the utility incomer phase C.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2482":{"PGN":65017,"PGN_Name":"Utility Average Basic AC Quantities","PGN_Description":"UAAC","first_bit":48,"SPN":2482,"SPN_Name":"Utility Average AC RMS Current","SPN_Description":"Average RMS current measured at the utility incomer.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2483":{"PGN":65014,"PGN_Name":"Utility Phase A Basic AC Quantities","PGN_Description":"UPAAC","first_bit":48,"SPN":2483,"SPN_Name":"Utility Phase A AC RMS Current","SPN_Description":"RMS current measured at the utility incomer phase A.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2484":{"PGN":65011,"PGN_Name":"Utility Phase B AC Basic Quantities","PGN_Description":"UPBAC","first_bit":48,"SPN":2484,"SPN_Name":"Utility Phase B AC RMS Current","SPN_Description":"RMS current measured at the utility incomer phase B.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2485":{"PGN":65008,"PGN_Name":"Utility Phase C AC Basic Quantities","PGN_Description":"UPCAC","first_bit":48,"SPN":2485,"SPN_Name":"Utility Phase C AC RMS Current","SPN_Description":"RMS current measured at the utility incomer phase C.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"2486":{"PGN":65016,"PGN_Name":"Utility Total AC Power","PGN_Description":"UTACP","first_bit":0,"SPN":2486,"SPN_Name":"Utility Total Real Power","SPN_Description":"Total real power delivered by the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2487":{"PGN":65013,"PGN_Name":"Utility Phase A AC Power","PGN_Description":"UPAACP","first_bit":0,"SPN":2487,"SPN_Name":"Utility Phase A Real Power","SPN_Description":"The real power delivered by phase A of the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2488":{"PGN":65010,"PGN_Name":"Utility Phase B AC Power","PGN_Description":"UPBACP","first_bit":0,"SPN":2488,"SPN_Name":"Utility Phase B Real Power","SPN_Description":"The real power delivered by phase B of the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2489":{"PGN":65007,"PGN_Name":"Utility Phase C AC Power","PGN_Description":"UPCACP","first_bit":0,"SPN":2489,"SPN_Name":"Utility Phase C Real Power","SPN_Description":"The real power delivered by phase C of the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"W","SLOT_ID":147},"2490":{"PGN":65015,"PGN_Name":"Utility Total AC Reactive Power","PGN_Description":"UTACR","first_bit":0,"SPN":2490,"SPN_Name":"Utility Total Reactive Power","SPN_Description":"The total reactive power delivered by the utility incomer","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2491":{"PGN":65012,"PGN_Name":"Utility Phase A AC Reactive Power","PGN_Description":"UPACCR","first_bit":0,"SPN":2491,"SPN_Name":"Utility Phase A Reactive Power","SPN_Description":"The reactive power delivered by phase A of the utility incomer","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2492":{"PGN":65009,"PGN_Name":"Utility Phase B AC Reactive Power","PGN_Description":"UPBACR","first_bit":0,"SPN":2492,"SPN_Name":"Utility Phase B Reactive Power","SPN_Description":"The reactive power delivered by phase B of the utility incomer","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2493":{"PGN":65006,"PGN_Name":"Utility Phase C AC Reactive Power","PGN_Description":"UPCACR","first_bit":0,"SPN":2493,"SPN_Name":"Utility Phase C Reactive Power","SPN_Description":"The reactive power delivered by phase C of the utility incomer","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VAr","SLOT_ID":149},"2494":{"PGN":65016,"PGN_Name":"Utility Total AC Power","PGN_Description":"UTACP","first_bit":32,"SPN":2494,"SPN_Name":"Utility Total Apparent Power","SPN_Description":"The total apparent power delivered by the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2495":{"PGN":65013,"PGN_Name":"Utility Phase A AC Power","PGN_Description":"UPAACP","first_bit":32,"SPN":2495,"SPN_Name":"Utility Phase A Apparent Power","SPN_Description":"The apparent power delivered by phase A of the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2496":{"PGN":65010,"PGN_Name":"Utility Phase B AC Power","PGN_Description":"UPBACP","first_bit":32,"SPN":2496,"SPN_Name":"Utility Phase B Apparent Power","SPN_Description":"The apparent power delivered by phase B of the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2497":{"PGN":65007,"PGN_Name":"Utility Phase C AC Power","PGN_Description":"UPCACP","first_bit":32,"SPN":2497,"SPN_Name":"Utility Phase C Apparent Power","SPN_Description":"The apparent power delivered by phase C of the utility incomer.","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"2498":{"PGN":65015,"PGN_Name":"Utility Total AC Reactive Power","PGN_Description":"UTACR","first_bit":32,"SPN":2498,"SPN_Name":"Utility Overall Power Factor","SPN_Description":"The average power factor of the utility incomer.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2499":{"PGN":65012,"PGN_Name":"Utility Phase A AC Reactive Power","PGN_Description":"UPACCR","first_bit":32,"SPN":2499,"SPN_Name":"Utility Phase A Power Factor","SPN_Description":"The power factor of phase A of the utility incomer.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2500":{"PGN":65009,"PGN_Name":"Utility Phase B AC Reactive Power","PGN_Description":"UPBACR","first_bit":32,"SPN":2500,"SPN_Name":"Utility Phase B Power Factor","SPN_Description":"The power factor of phases B of the utility incomer.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2501":{"PGN":65006,"PGN_Name":"Utility Phase C AC Reactive Power","PGN_Description":"UPCACR","first_bit":32,"SPN":2501,"SPN_Name":"Utility Phase C Power Factor","SPN_Description":"The power factor of phases C of the utility incomer.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"2502":{"PGN":65005,"PGN_Name":"Utility Total AC Energy","PGN_Description":"UTACE","first_bit":0,"SPN":2502,"SPN_Name":"Utility Total kW Hours Export","SPN_Description":"The total kilowatt-hours that have been exported by the utility incomer.","bit_length":32,"scaling":1,"offset":0,"unit":"kWh","SLOT_ID":150},"2503":{"PGN":65005,"PGN_Name":"Utility Total AC Energy","PGN_Description":"UTACE","first_bit":32,"SPN":2503,"SPN_Name":"Utility Total kW Hours Import","SPN_Description":"The total kilowatt-hours that have been imported by the utility incomer.","bit_length":32,"scaling":1,"offset":0,"unit":"kWh","SLOT_ID":150},"2504":{"PGN":65004,"PGN_Name":"Bus #1 Average Basic AC Quantities","PGN_Description":"BAAC","first_bit":32,"SPN":2504,"SPN_Name":"Bus #1 Average AC Frequency","SPN_Description":"Average AC frequency measured at bus #1.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2505":{"PGN":65003,"PGN_Name":"Bus #1 Phase A  Basic AC Quantities","PGN_Description":"BPAAC","first_bit":32,"SPN":2505,"SPN_Name":"Bus #1 Phase A AC Frequency","SPN_Description":"AC frequency measured at bus #1 phase A.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2506":{"PGN":65002,"PGN_Name":"Bus #1 Phase B  Basic AC Quantities","PGN_Description":"BPBAC","first_bit":32,"SPN":2506,"SPN_Name":"Bus #1 Phase B AC Frequency","SPN_Description":"AC frequency measured at bus #1 phase B.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2507":{"PGN":65001,"PGN_Name":"Bus #1 Phase C  Basic AC Quantities","PGN_Description":"BPCAC","first_bit":32,"SPN":2507,"SPN_Name":"Bus #1 Phase C AC Frequency","SPN_Description":"AC frequency measured at bus #1 phase C.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"Hz","SLOT_ID":144},"2508":{"PGN":65004,"PGN_Name":"Bus #1 Average Basic AC Quantities","PGN_Description":"BAAC","first_bit":0,"SPN":2508,"SPN_Name":"Bus #1 Average Line-Line AC RMS Voltage","SPN_Description":"Average Line to Line RMS voltage measured at bus #1 .","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2509":{"PGN":65003,"PGN_Name":"Bus #1 Phase A  Basic AC Quantities","PGN_Description":"BPAAC","first_bit":0,"SPN":2509,"SPN_Name":"Bus #1 Phase AB Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at bus #1 phase AB.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2510":{"PGN":65002,"PGN_Name":"Bus #1 Phase B  Basic AC Quantities","PGN_Description":"BPBAC","first_bit":0,"SPN":2510,"SPN_Name":"Bus #1 Phase BC Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at bus #1 phase BC.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2511":{"PGN":65001,"PGN_Name":"Bus #1 Phase C  Basic AC Quantities","PGN_Description":"BPCAC","first_bit":0,"SPN":2511,"SPN_Name":"Bus #1 Phase CA Line-Line AC RMS Voltage","SPN_Description":"Line to Line RMS voltage measured at bus #1 phase CA.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2512":{"PGN":65004,"PGN_Name":"Bus #1 Average Basic AC Quantities","PGN_Description":"BAAC","first_bit":16,"SPN":2512,"SPN_Name":"Bus #1 Average Line-Neutral AC RMS Voltage","SPN_Description":"The average Line to Neutral AC RMS voltage measured at bus #1 .","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2513":{"PGN":65003,"PGN_Name":"Bus #1 Phase A  Basic AC Quantities","PGN_Description":"BPAAC","first_bit":16,"SPN":2513,"SPN_Name":"Bus #1 Phase A Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at bus #1 phase A.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2514":{"PGN":65002,"PGN_Name":"Bus #1 Phase B  Basic AC Quantities","PGN_Description":"BPBAC","first_bit":16,"SPN":2514,"SPN_Name":"Bus #1 Phase B Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at bus #1 phase B.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2515":{"PGN":65001,"PGN_Name":"Bus #1 Phase C  Basic AC Quantities","PGN_Description":"BPCAC","first_bit":16,"SPN":2515,"SPN_Name":"Bus #1 Phase C Line-Neutral AC RMS Voltage","SPN_Description":"Line to Neutral RMS voltage measured at bus #1 phase C.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"2516":{"PGN":65000,"PGN_Name":"Bus #1/Generator Sync Check Status","PGN_Description":"BGSC","first_bit":16,"SPN":2516,"SPN_Name":"Bus #1/Generator AC Phase Difference","SPN_Description":"The phase difference between the Bus #1 voltage and Generator voltage.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"2517":{"PGN":64999,"PGN_Name":"Bus #1/Utility Sync Check Status","PGN_Description":"BUSC","first_bit":16,"SPN":2517,"SPN_Name":"Bus #1/Utility AC Phase Difference","SPN_Description":"The phase difference between the Bus #1 voltage and Utility voltage.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"2518":{"PGN":65028,"PGN_Name":"Generator Total AC Reactive Power","PGN_Description":"GTACR","first_bit":48,"SPN":2518,"SPN_Name":"Generator Overall Power Factor Lagging","SPN_Description":"Lead/lag status for generator average power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2519":{"PGN":65025,"PGN_Name":"Generator Phase A AC Reactive Power","PGN_Description":"GPAACR","first_bit":48,"SPN":2519,"SPN_Name":"Generator Phase A Power Factor Lagging","SPN_Description":"Lead/lag status for generator phase A power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2520":{"PGN":65022,"PGN_Name":"Generator Phase B AC Reactive Power","PGN_Description":"GPBACRP","first_bit":48,"SPN":2520,"SPN_Name":"Generator Phase B Power Factor Lagging","SPN_Description":"Lead/lag status for generator phase B power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2521":{"PGN":65019,"PGN_Name":"Generator Phase C AC Reactive Power","PGN_Description":"GPCACR","first_bit":48,"SPN":2521,"SPN_Name":"Generator Phase C Power Factor Lagging","SPN_Description":"Lead/lag status for generator phase C power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2522":{"PGN":65015,"PGN_Name":"Utility Total AC Reactive Power","PGN_Description":"UTACR","first_bit":48,"SPN":2522,"SPN_Name":"Utility Overall Power Factor Lagging","SPN_Description":"Lead/lag status for utility incomer average power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2523":{"PGN":65012,"PGN_Name":"Utility Phase A AC Reactive Power","PGN_Description":"UPACCR","first_bit":48,"SPN":2523,"SPN_Name":"Utility Phase A Power Factor Lagging","SPN_Description":"Lead/lag status for utility incomer phase A power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2524":{"PGN":65009,"PGN_Name":"Utility Phase B AC Reactive Power","PGN_Description":"UPBACR","first_bit":48,"SPN":2524,"SPN_Name":"Utility Phase B Power Factor Lagging","SPN_Description":"Lead/lag status for utility incomer phase B power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2525":{"PGN":65006,"PGN_Name":"Utility Phase C AC Reactive Power","PGN_Description":"UPCACR","first_bit":48,"SPN":2525,"SPN_Name":"Utility Phase C Power Factor Lagging","SPN_Description":"Lead/lag status for utility incomer phase C power factor.\\r\\n\\r\\n00 Leading\\r\\n01 Lagging\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2526":{"PGN":65000,"PGN_Name":"Bus #1/Generator Sync Check Status","PGN_Description":"BGSC","first_bit":2,"SPN":2526,"SPN_Name":"Bus #1/Generator Phase Match","SPN_Description":"Indicator of whether phase difference between Bus #1 and Generator is adequate for paralleling. This indicator will be based on the measured AC phase difference qualified using parameters such as Phase Tolerance and Dwell Time.\\r\\n\\r\\n00 Phases do not match\\r\\n01 Phases match\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2527":{"PGN":65000,"PGN_Name":"Bus #1/Generator Sync Check Status","PGN_Description":"BGSC","first_bit":6,"SPN":2527,"SPN_Name":"Bus #1/Generator Voltage Match","SPN_Description":"Indicator of whether voltage difference between Bus #1 and Generator is adequate for paralleling. This indicator will be based on the measured AC voltages qualified using parameters such as Voltage Tolerance.\\r\\n\\r\\n00 Voltages do not match\\r\\n01 Voltages match\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2528":{"PGN":65000,"PGN_Name":"Bus #1/Generator Sync Check Status","PGN_Description":"BGSC","first_bit":4,"SPN":2528,"SPN_Name":"Bus #1/Generator Frequency Match","SPN_Description":"Indicator of whether frequency difference between Bus #1 and Generator is adequate for paralleling. This indicator will be based on the measured AC frequencies qualified using parameters such as Frequency Tolerance, Phase Tolerance, and Dwell Time.\\r\\n\\r\\n00 Frequencies do not match\\r\\n01 Frequencies match\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2529":{"PGN":65000,"PGN_Name":"Bus #1/Generator Sync Check Status","PGN_Description":"BGSC","first_bit":8,"SPN":2529,"SPN_Name":"Bus #1/Generator In Sync","SPN_Description":"Indicator of whether Bus #1 and Generator are properly synchronized for paralleling. This indicator will be based on parameters such as Voltage Match, Frequency Match, and Phase Match.\\r\\n\\r\\n00 Not synchronized\\r\\n01 Synchronized\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2530":{"PGN":65000,"PGN_Name":"Bus #1/Generator Sync Check Status","PGN_Description":"BGSC","first_bit":0,"SPN":2530,"SPN_Name":"Bus #1/Generator Dead Bus","SPN_Description":"Indicator of whether Bus #1 is considered dead for closing to the generator. This indicator will be based on parameters such as Bus #1 Voltage and dead bus threshold values.\\r\\n\\r\\n00 Bus is not dead\\r\\n01 Bus is dead\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2531":{"PGN":64999,"PGN_Name":"Bus #1/Utility Sync Check Status","PGN_Description":"BUSC","first_bit":2,"SPN":2531,"SPN_Name":"Bus #1/Utility Phase Match","SPN_Description":"Indicator of whether phase difference between Bus #1 and Utility is adequate for paralleling. This indicator will be based on the measured AC phase difference qualified using parameters such as Phase Tolerance and Dwell Time.\\r\\n\\r\\n00 Phases do not match\\r\\n01 Phases match\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2532":{"PGN":64999,"PGN_Name":"Bus #1/Utility Sync Check Status","PGN_Description":"BUSC","first_bit":6,"SPN":2532,"SPN_Name":"Bus #1/Utility Voltage Match","SPN_Description":"Indicator of whether voltage difference between Bus #1 and Utility is adequate for paralleling. This indicator will be based on the measured AC voltages qualified using parameters such as Voltage Tolerance.\\r\\n\\r\\n00 Voltages do not match\\r\\n01 Voltages match\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2533":{"PGN":64999,"PGN_Name":"Bus #1/Utility Sync Check Status","PGN_Description":"BUSC","first_bit":4,"SPN":2533,"SPN_Name":"Bus #1/Utility Frequency Match","SPN_Description":"Indicator of whether frequency difference between Bus #1 and Utility is adequate for paralleling. This indicator will be based on the measured AC frequencies qualified using parameters such as Frequency Tolerance, Phase Tolerance, and Dwell Time.\\r\\n\\r\\n00 Frequencies do not match\\r\\n01 Frequencies match\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2534":{"PGN":64999,"PGN_Name":"Bus #1/Utility Sync Check Status","PGN_Description":"BUSC","first_bit":8,"SPN":2534,"SPN_Name":"Bus #1/Utility In Sync","SPN_Description":"Indicator of whether Bus #1 and Utility are properly synchronized for paralleling. This indicator will be based on parameters such as Voltage Match, Frequency Match, and Phase Match.\\r\\n\\r\\n00 Not synchronized\\r\\n01 Synchronized\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2535":{"PGN":64999,"PGN_Name":"Bus #1/Utility Sync Check Status","PGN_Description":"BUSC","first_bit":0,"SPN":2535,"SPN_Name":"Bus #1/Utility Dead Bus","SPN_Description":"Indicator of whether Bus #1 is considered dead for closing to the utility. This indicator will be based on parameters such as Bus #1 Voltage and dead bus threshold values.\\r\\n\\r\\n00 Bus is not dead\\r\\n01 Bus is dead\\r\\n10 Error\\r\\n11 Not Available or Not Installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2536":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":22,"SPN":2536,"SPN_Name":"Transmission Mode 1 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 1 (SPN 1852) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n  \\r\\n00 Transmission Mode 1 not active\\r\\n01 Transmission Mode 1 Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2537":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":20,"SPN":2537,"SPN_Name":"Transmission Mode 2 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 2 (SPN 1853) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n\\r\\n00 Transmission Mode 2 not active\\r\\n01 Transmission Mode 2 Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2538":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":18,"SPN":2538,"SPN_Name":"Transmission Mode 3 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 3 (SPN 1854) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n\\r\\n00 Transmission Mode 3 not active\\r\\n01 Transmission Mode 3 Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2539":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":16,"SPN":2539,"SPN_Name":"Transmission Mode 4 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 4 (SPN 1855) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n\\r\\n00 Transmission Mode 4 not active\\r\\n01 Transmission Mode 4 Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2576":{"PGN":65141,"PGN_Name":"Laser Leveling System Vertical Deviation","PGN_Description":"LVD","first_bit":16,"SPN":2576,"SPN_Name":"Laser Receiver Type","SPN_Description":"Identifies which type of Laser Receiver transmitted the message.\\r\\n\\r\\n0 = Reserved \\r\\n1 = Linear Laser Receiver\\r\\n2 = 1 Meter Survey Receiver\\r\\n3 = 2 Meter Survey Receiver\\r\\n4 = 2.5 Meter Survey Receiver\\r\\n5-250 = Reserved","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"2577":{"PGN":65142,"PGN_Name":"Laser Leveling System Vertical Position Display Data","PGN_Description":"LVDD","first_bit":20,"SPN":2577,"SPN_Name":"Display Deadbands","SPN_Description":"Sets Display Deadbands mode.\\r\\n\\r\\n0000 - Narrow = +/- 4.5mm\\r\\n0001 - Standard = +/- 12mm\\r\\n0010 - Wide = +/- 24mm\\r\\n0011 - 1110 Reserved\\r\\n1111 Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2578":{"PGN":65142,"PGN_Name":"Laser Leveling System Vertical Position Display Data","PGN_Description":"LVDD","first_bit":16,"SPN":2578,"SPN_Name":"LED Pattern Control","SPN_Description":"Sets LED Pattern control mode on laser leveling systems.\\r\\n\\r\\n0000 - 5 Channel\\r\\n0001 - Offset\\r\\n0010 - 7 Channel\\r\\n0011 - 1110 Reserved\\r\\n1111 Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2579":{"PGN":65106,"PGN_Name":"Vehicle Electrical Power 3","PGN_Description":"VEP3","first_bit":16,"SPN":2579,"SPN_Name":"SLI Battery 1 Net Current (High Range/Resolution)","SPN_Description":"Net flow of electrical current into/out of the first battery or first set of batteries used for starting the engine, for lighting, and for ignition (SLI).  If more than one battery is included in the first set of batteries and the net current for each battery is desired, then SPNs 7900, 7908, 7916, & 7924 shall be used.\\r\\n\\n\\nSee SPN 114 for alternate range and resolution.","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"2580":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":0,"SPN":2580,"SPN_Name":"Hydraulic Brake Pressure Circuit 1","SPN_Description":"Gage hydraulic pressure in circuit 1 of the hydraulic brake system","bit_length":8,"scaling":100,"offset":0,"unit":"kPa","SLOT_ID":161},"2581":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":8,"SPN":2581,"SPN_Name":"Hydraulic Brake Pressure Circuit 2","SPN_Description":"Gage hydraulic pressure in circuit 2 of the hydraulic brake system","bit_length":8,"scaling":100,"offset":0,"unit":"kPa","SLOT_ID":161},"2582":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":20,"SPN":2582,"SPN_Name":"Hydraulic Brake Pressure Supply State Circuit 1","SPN_Description":"Signal which indicates whether the hydraulic brake pressure supply of circuit 1 is reliable; that is, able to support continued braking.\\r\\n\\r\\n00 Supply is not reliable\\r\\n01 Supply is reliable\\r\\n10 Error indicator\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2583":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":22,"SPN":2583,"SPN_Name":"Hydraulic Brake Pressure Supply State Circuit 2","SPN_Description":"Signal which indicates whether the hydraulic brake pressure supply of circuit 2 is reliable; that is, able to support continued braking.\\r\\n\\r\\n00 Supply is not reliable\\r\\n01 Supply is reliable\\r\\n10 Error indicator\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2584":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":16,"SPN":2584,"SPN_Name":"Hydraulic Brake Pressure Warning State Circuit 1","SPN_Description":"Signal which indicates whether the hydraulic brake pressure of circuit 1 is below the warning level\\r\\n\\r\\n00 Pressure level sufficient\\r\\n01 Pressure level below warning level\\r\\n10 Error indicator\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2585":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":18,"SPN":2585,"SPN_Name":"Hydraulic Brake Pressure Warning State Circuit 2","SPN_Description":"Signal which indicates whether the hydraulic brake pressure of circuit 2 is below the warning level\\r\\n\\r\\n00 Pressure level sufficient\\r\\n01 Pressure level below warning level\\r\\n10 Error indicator\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2586":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":40,"SPN":2586,"SPN_Name":"Tire Air Leakage Rate","SPN_Description":"The pressure loss rate of a tire.","bit_length":16,"scaling":0.1,"offset":0,"unit":"Pa/s","SLOT_ID":162},"2587":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":61,"SPN":2587,"SPN_Name":"Tire Pressure Threshold Detection","SPN_Description":"Signal indicating the pressure level of the tire.  The levels defined represent different pressure conditions of the tire:\\r\\n\\r\\n000 Extreme over pressure - The tire pressure is at a level where the safety of the vehicle may be jeopardised.\\r\\n001 Over pressure - The tire pressure is higher than the pressure defined by the vehicle or tire manufacturer.\\r\\n010 No warning pressure - The tire pressure is within the thresholds defined by the vehicle or tire manufacturer.\\r\\n011 Under pressure - The tire pressure is lower than the pressure defined by the vehicle or tire manufacturer.\\r\\n100 Extreme under pressure - The tire pressure is at a level where the safety of the vehicle may be jeopardised.\\r\\n101 Not defined\\r\\n110 Error indicator\\r\\n111 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"2588":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":0,"SPN":2588,"SPN_Name":"Maximum Vehicle Speed Limit 1","SPN_Description":"The lowest Maximum Vehicle Speed Limit. This value is the similar to SPN 74. However, SPN 74 was not specifically defined to convey  the applied vehicle speed limit or what was possible to be applied. This new SPN is the lowest vehicle speed limit that is possible. Additionally, the lowest vehicle speed limit shall be applied when the J1939 network is no longer providing input regarding the Selected Maximum Vehicle Speed Limit. Exceptions to this exist when the device performing the maximum vehicle speed limiting function has methods of selecting the thresholds separately from the Selected Maximum Vehicle Speed Limit parameter.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2589":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":8,"SPN":2589,"SPN_Name":"Maximum Vehicle Speed Limit 2","SPN_Description":"The highest of the two lowest vehicle speed limits","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2590":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":16,"SPN":2590,"SPN_Name":"Maximum Vehicle Speed Limit 3","SPN_Description":"The highest of the three lowest vehicle speed limits","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2591":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":24,"SPN":2591,"SPN_Name":"Maximum Vehicle Speed Limit 4","SPN_Description":"The highest of the four lowest vehicle speed limits","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2592":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":32,"SPN":2592,"SPN_Name":"Maximum Vehicle Speed Limit 5","SPN_Description":"The highest of the five lowest vehicle speed limits","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2593":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":40,"SPN":2593,"SPN_Name":"Maximum Vehicle Speed Limit 6","SPN_Description":"The highest of the six lowest vehicle speed limits","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2594":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":48,"SPN":2594,"SPN_Name":"Maximum Vehicle Speed Limit 7","SPN_Description":"The highest of the seven lowest vehicle speed limits","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2595":{"PGN":64997,"PGN_Name":"Maximum Vehicle Speed Limit Status","PGN_Description":"MVS","first_bit":56,"SPN":2595,"SPN_Name":"Applied Vehicle Speed Limit","SPN_Description":"The vehicle speed limit in effect.\\r\\n\\r\\n251 (0xFB) is used to indicate that a maximum vehicle speed limit is not selected.\\r\\n\\r\\nSee SPN 7420 for alternate resolution.","bit_length":8,"scaling":1,"offset":0,"unit":"km/h","SLOT_ID":73},"2596":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":56,"SPN":2596,"SPN_Name":"Selected Maximum Vehicle Speed Limit","SPN_Description":"User selected maximum vehicle speed.  If one is selected, then this SPN must equal one of the maximum vehicle speeds #1-#7 from PGN 64997 - Maximum Vehicle Speed Limit Status . If different maximum vehicle speed requests are present from different devices, the lowest requested value should be used.\\r\\n\\r\\n0 is used to indicate that a maximum vehicle speed is not selected.  1 through 7 are valid selectable speed limits. 8 through 250 are not allowed.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"2597":{"PGN":65089,"PGN_Name":"Lighting Command","PGN_Description":"LCMD","first_bit":54,"SPN":2597,"SPN_Name":"Implement Left Forward Work Light Command","SPN_Description":"Command to activate or de-activate work lights mounted on an implement to illuminate beyond left end of the implement.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Reserved\\r\\n11 Don\u2019t Care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2598":{"PGN":65088,"PGN_Name":"Lighting Data","PGN_Description":"LD","first_bit":54,"SPN":2598,"SPN_Name":"Implement Left Forward Work Light","SPN_Description":"This parameter provides measured data from the work lights mounted on an implement to illuminate the forward left end of the implement.\\r\\n\\r\\n00 De-activate\\r\\n01 Activate\\r\\n10 Fault Detected\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2599":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":20,"SPN":2599,"SPN_Name":"Fire Apparatus Pump Engagement","SPN_Description":"The measured status of the pump used to provide water in fire fighting apparatus for distribution of water through water cannons or fire hoses.\\r\\n\\r\\n00 Pump not engaged\\r\\n01 Pump engaged\\r\\n10 Error\\r\\n11 Not available or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2600":{"PGN":64996,"PGN_Name":"Equipment Performance Data","PGN_Description":"EPD","first_bit":0,"SPN":2600,"SPN_Name":"Payload Percentage","SPN_Description":"The current payload of the equipment, reported as a percentage of the equipment\'s rated payload limit.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"2601":{"PGN":64995,"PGN_Name":"Equipment Operation and Control","PGN_Description":"EOAC","first_bit":0,"SPN":2601,"SPN_Name":"Travel Velocity Control Position","SPN_Description":"The position of the travel velocity control component reported as a percentage of the control\'s full displacement in each direction respectively.  Positive position values indicate forward travel direction;  negative position values indicate reverse, or backward, travel direction; and zero (0) percent position indicates the control device is in the neutral position.  Higher percent for a particular travel direction indicates a higher desired travel speed in that direction.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"2602":{"PGN":65128,"PGN_Name":"Vehicle Fluids","PGN_Description":"VF","first_bit":16,"SPN":2602,"SPN_Name":"Hydraulic Oil Level","SPN_Description":"This parameter indicates the level of the hydraulic fluid in tank as a ratio of current volume to total tank volume.  This parameter is intended for reporting the hydraulic fluid level in the system tank or reservoir.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2603":{"PGN":64994,"PGN_Name":"Supply Pressure Demand","PGN_Description":"SPR","first_bit":0,"SPN":2603,"SPN_Name":"Pneumatic Supply Pressure Request","SPN_Description":"Command signal to influence the pneumatic pressure in the main reservoir.  This parameter is the setpoint for the parameter SPN 46.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"2604":{"PGN":64994,"PGN_Name":"Supply Pressure Demand","PGN_Description":"SPR","first_bit":8,"SPN":2604,"SPN_Name":"Parking and/or Trailer Air Pressure Request","SPN_Description":"Command signal to influence the pneumatic pressure in the circuit or reservoir for the parking brake and/or the trailer supply.  This parameter is the setpoint for the parameter SPN 1086.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"2605":{"PGN":64994,"PGN_Name":"Supply Pressure Demand","PGN_Description":"SPR","first_bit":16,"SPN":2605,"SPN_Name":"Service Brake Air Pressure Request, Circuit #1","SPN_Description":"Command signal to influence the pneumatic pressure in the service brake circuit or reservoir #1.  This parameter is the setpoint for the parameter SPN 1087.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"2606":{"PGN":64994,"PGN_Name":"Supply Pressure Demand","PGN_Description":"SPR","first_bit":24,"SPN":2606,"SPN_Name":"Service Brake Air Pressure Request, Circuit #2","SPN_Description":"Command signal to influence the pneumatic pressure in the service brake circuit or reservoir #2.  This parameter is the setpoint for the parameter SPN 1088.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"2607":{"PGN":64994,"PGN_Name":"Supply Pressure Demand","PGN_Description":"SPR","first_bit":32,"SPN":2607,"SPN_Name":"Auxiliary Equipment Supply Pressure Request","SPN_Description":"Command signal to influence the pneumatic pressure in the auxiliary circuit.   This parameter is the setpoint for the parameter SPN 1089.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"2608":{"PGN":64994,"PGN_Name":"Supply Pressure Demand","PGN_Description":"SPR","first_bit":40,"SPN":2608,"SPN_Name":"Air Suspension Supply Pressure Request","SPN_Description":"Command signal to influence the pneumatic pressure in the circuit for the electronically controlled air suspension system.   This parameter is the setpoint for the parameter SPN 1090.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"2609":{"PGN":64993,"PGN_Name":"Cab A/C Climate System Information","PGN_Description":"CACI","first_bit":0,"SPN":2609,"SPN_Name":"Cab A/C Refrigerant Compressor Outlet Pressure","SPN_Description":"This is the gage pressure at the compressor outlet in the cab air conditioning system.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"2610":{"PGN":64992,"PGN_Name":"Ambient Conditions 2","PGN_Description":"AMB2","first_bit":0,"SPN":2610,"SPN_Name":"Solar Intensity Percent","SPN_Description":"This is the solar radiation (power density) falling on the vehicle in percent of the maximum sensor value (SPN 2611).  Currently this is in the infra-red spectrum.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2611":{"PGN":64992,"PGN_Name":"Ambient Conditions 2","PGN_Description":"AMB2","first_bit":8,"SPN":2611,"SPN_Name":"Solar Sensor Maximum","SPN_Description":"This is the maximum value which can be reported by the sensor for the solar intensity. (This is a configuration parameter)","bit_length":8,"scaling":0.4,"offset":0,"unit":"mW/cm\xb2","SLOT_ID":204},"2612":{"PGN":64991,"PGN_Name":"Front Wheel Drive Status","PGN_Description":"FWD","first_bit":0,"SPN":2612,"SPN_Name":"Front Wheel Drive Actuator Status","SPN_Description":"Feedback on the front wheel drive actuator.\\r\\n\\r\\n00 Front Wheel Drive Actuator not engaged\\r\\n01 Front Wheel Drive Actuator engaged\\r\\n10 Error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2613":{"PGN":65273,"PGN_Name":"Axle Information","PGN_Description":"AI","first_bit":32,"SPN":2613,"SPN_Name":"Drive Axle Lube Pressure","SPN_Description":"The drive axle lubricant pressure with location determined by Drive Axle Location (SPN 930).","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"2614":{"PGN":65273,"PGN_Name":"Axle Information","PGN_Description":"AI","first_bit":56,"SPN":2614,"SPN_Name":"Steering Axle Lube Pressure","SPN_Description":"The steering axle lubricant pressure.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"2615":{"PGN":64988,"PGN_Name":"Marine Control Information","PGN_Description":"MCI","first_bit":0,"SPN":2615,"SPN_Name":"Engine Throttle Synchronization Mode Status","SPN_Description":"The status of the Throttle Synchronization Mode. Throttle Synchronization Mode is used to indicate which throttle, if any, is currently being used for the synchronized throttle.  \\r\\n\\r\\n0000 Not Synchronized\\r\\n0001 Synchronized Center\\r\\n0010 Synchronized Port\\r\\n0011 Synchronized Starboard\\r\\n0100 Synchronized Master\\r\\n0101-1110 Reserved\\r\\n1111 Take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2616":{"PGN":64988,"PGN_Name":"Marine Control Information","PGN_Description":"MCI","first_bit":4,"SPN":2616,"SPN_Name":"Trolling Mode Status","SPN_Description":"The status of the Trolling Mode.  Trolling mode limits the top speed.  Full range travel of the throttle level spans from low idle engine speed to maximum trolling speed.\\r\\n\\r\\n00 Trolling mode is OFF.\\r\\n01 Trolling mode is ACTIVE.\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2617":{"PGN":64988,"PGN_Name":"Marine Control Information","PGN_Description":"MCI","first_bit":6,"SPN":2617,"SPN_Name":"Slow Vessel Mode Status","SPN_Description":"The status of the Slow Vessel Mode.  Slow Vessel Mode puts the engine in a lower-than-normal low idle speed during docking or other slow vessel operations.\\r\\n\\r\\n00 Slow vessel mode is OFF.\\r\\n01 Slow vessel mode is ACTIVE.\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2623":{"PGN":64963,"PGN_Name":"Electronic Engine Controller 15","PGN_Description":"EEC15","first_bit":0,"SPN":2623,"SPN_Name":"Accelerator Pedal #1 Channel 2","SPN_Description":"Sensor output 2 for the accelerator pedal #1 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the first occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the second sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal #1 position.  Sensor outputs 1 & 3 (for accelerator pedal #1 position) are SPNs 91 & 2624.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2624":{"PGN":64963,"PGN_Name":"Electronic Engine Controller 15","PGN_Description":"EEC15","first_bit":8,"SPN":2624,"SPN_Name":"Accelerator Pedal #1 Channel 3","SPN_Description":"Sensor output 3 for the accelerator pedal #1 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the first occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the third sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal #1 position.  Sensor outputs 1 & 2 (for accelerator pedal #1 position) are SPNs 91 & 2623.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2625":{"PGN":64963,"PGN_Name":"Electronic Engine Controller 15","PGN_Description":"EEC15","first_bit":16,"SPN":2625,"SPN_Name":"Accelerator Pedal #2 Channel 2","SPN_Description":"Sensor output 2 for the accelerator pedal #2 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the second occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the second sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal # 2 position.  Sensor outputs 1 & 3 (for accelerator pedal #2 position) are SPNs 29 & 2626.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2626":{"PGN":64963,"PGN_Name":"Electronic Engine Controller 15","PGN_Description":"EEC15","first_bit":24,"SPN":2626,"SPN_Name":"Accelerator Pedal #2 Channel 3","SPN_Description":"Sensor output 3 for the accelerator pedal #2 position when using a redundant-style sensor.  The ratio of actual accelerator pedal position to maximum pedal position. This is for the second occurrence of the accelerator pedal. Although it is used as an input to determine powertrain demand, it also provides anticipatory information to transmission and ASR algorithms about driver actions.  This is the third sensor output when a multiple output (redundant) sensor is used for Accelerator Pedal # 2 position.  Sensor outputs 1 & 2 (for accelerator pedal #2 position) are SPNs 29 & 2625.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2629":{"PGN":64979,"PGN_Name":"Turbocharger Information 6","PGN_Description":"TCI6","first_bit":0,"SPN":2629,"SPN_Name":"Engine Turbocharger 1 Compressor Outlet Temperature","SPN_Description":"Temperature of the air or air/fuel mixture exiting the turbocharger 1 compressor outlet","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2630":{"PGN":65129,"PGN_Name":"Engine Temperature 3","PGN_Description":"ET3","first_bit":48,"SPN":2630,"SPN_Name":"Engine Charge Air Cooler 1 Outlet Temperature","SPN_Description":"Temperature of combustion air after it exits from the Charge Air Cooler 1 but before any mixing of recirculated exhaust gas.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2631":{"PGN":64938,"PGN_Name":"Engine Fluid Level/Pressure 4","PGN_Description":"EFL/P4","first_bit":56,"SPN":2631,"SPN_Name":"Engine Charge Air Cooler Outlet Pressure","SPN_Description":"Measures pressure of air at outlet from charge air cooler","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"2659":{"PGN":61450,"PGN_Name":"Engine Gas Flow Rate","PGN_Description":"EGF1","first_bit":0,"SPN":2659,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Mass Flow Rate","SPN_Description":"Flow rate of gas through the EGR system. Flow rate of the exhaust gas being recirculated into the combustion air.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kg/h","SLOT_ID":18},"2660":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":6,"SPN":2660,"SPN_Name":"Joystick 1 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2661":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":22,"SPN":2661,"SPN_Name":"Joystick 1 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2662":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":6,"SPN":2662,"SPN_Name":"Joystick 1 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2663":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":22,"SPN":2663,"SPN_Name":"Joystick 1 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2664":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":38,"SPN":2664,"SPN_Name":"Joystick 1 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2665":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":4,"SPN":2665,"SPN_Name":"Joystick 1 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2666":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":20,"SPN":2666,"SPN_Name":"Joystick 1 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2667":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":4,"SPN":2667,"SPN_Name":"Joystick 1 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2668":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":20,"SPN":2668,"SPN_Name":"Joystick 1 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2669":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":36,"SPN":2669,"SPN_Name":"Joystick 1 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2670":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":2,"SPN":2670,"SPN_Name":"Joystick 1 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2671":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":18,"SPN":2671,"SPN_Name":"Joystick 1 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2672":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":2,"SPN":2672,"SPN_Name":"Joystick 1 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2673":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":18,"SPN":2673,"SPN_Name":"Joystick 1 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2674":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":34,"SPN":2674,"SPN_Name":"Joystick 1 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2675":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":0,"SPN":2675,"SPN_Name":"Joystick 1 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2676":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":16,"SPN":2676,"SPN_Name":"Joystick 1 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2677":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":0,"SPN":2677,"SPN_Name":"Joystick 1 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2678":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":16,"SPN":2678,"SPN_Name":"Joystick 1 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2679":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":32,"SPN":2679,"SPN_Name":"Joystick 1 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2680":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":38,"SPN":2680,"SPN_Name":"Joystick 1 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2681":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":36,"SPN":2681,"SPN_Name":"Joystick 1 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2682":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":54,"SPN":2682,"SPN_Name":"Joystick 1 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2683":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":52,"SPN":2683,"SPN_Name":"Joystick 1 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2684":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":50,"SPN":2684,"SPN_Name":"Joystick 1 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2685":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":46,"SPN":2685,"SPN_Name":"Joystick 1 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2686":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":44,"SPN":2686,"SPN_Name":"Joystick 1 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2687":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":42,"SPN":2687,"SPN_Name":"Joystick 1 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2688":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":40,"SPN":2688,"SPN_Name":"Joystick 1 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2689":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":54,"SPN":2689,"SPN_Name":"Joystick 1 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2690":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":52,"SPN":2690,"SPN_Name":"Joystick 1 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2691":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":50,"SPN":2691,"SPN_Name":"Joystick 1 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2692":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":48,"SPN":2692,"SPN_Name":"Joystick 1 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2693":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":62,"SPN":2693,"SPN_Name":"Joystick 1 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2694":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":60,"SPN":2694,"SPN_Name":"Joystick 1 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2695":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":58,"SPN":2695,"SPN_Name":"Joystick 1 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2696":{"PGN":64982,"PGN_Name":"Basic Joystick Message 1","PGN_Description":"BJM1","first_bit":56,"SPN":2696,"SPN_Name":"Joystick 1 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2697":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":6,"SPN":2697,"SPN_Name":"Joystick 2 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2698":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":22,"SPN":2698,"SPN_Name":"Joystick 2 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2699":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":6,"SPN":2699,"SPN_Name":"Joystick 2 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2700":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":22,"SPN":2700,"SPN_Name":"Joystick 2 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2701":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":38,"SPN":2701,"SPN_Name":"Joystick 2 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2702":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":4,"SPN":2702,"SPN_Name":"Joystick 2 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2703":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":20,"SPN":2703,"SPN_Name":"Joystick 2 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2704":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":4,"SPN":2704,"SPN_Name":"Joystick 2 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2705":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":20,"SPN":2705,"SPN_Name":"Joystick 2 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2706":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":36,"SPN":2706,"SPN_Name":"Joystick 2 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2707":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":2,"SPN":2707,"SPN_Name":"Joystick 2 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2708":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":18,"SPN":2708,"SPN_Name":"Joystick 2 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2709":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":2,"SPN":2709,"SPN_Name":"Joystick 2 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2710":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":18,"SPN":2710,"SPN_Name":"Joystick 2 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2711":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":34,"SPN":2711,"SPN_Name":"Joystick 2 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2712":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":0,"SPN":2712,"SPN_Name":"Joystick 2 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2713":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":16,"SPN":2713,"SPN_Name":"Joystick 2 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2714":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":0,"SPN":2714,"SPN_Name":"Joystick 2 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.\\r\\n  \\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2715":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":16,"SPN":2715,"SPN_Name":"Joystick 2 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2716":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":32,"SPN":2716,"SPN_Name":"Joystick 2 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2717":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":38,"SPN":2717,"SPN_Name":"Joystick 2 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2718":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":36,"SPN":2718,"SPN_Name":"Joystick 2 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2719":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":54,"SPN":2719,"SPN_Name":"Joystick 2 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2720":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":52,"SPN":2720,"SPN_Name":"Joystick 2 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2721":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":50,"SPN":2721,"SPN_Name":"Joystick 2 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2722":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":46,"SPN":2722,"SPN_Name":"Joystick 2 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2723":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":44,"SPN":2723,"SPN_Name":"Joystick 2 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2724":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":42,"SPN":2724,"SPN_Name":"Joystick 2 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2725":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":40,"SPN":2725,"SPN_Name":"Joystick 2 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2726":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":54,"SPN":2726,"SPN_Name":"Joystick 2 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2727":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":52,"SPN":2727,"SPN_Name":"Joystick 2 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2728":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":50,"SPN":2728,"SPN_Name":"Joystick 2 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2729":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":48,"SPN":2729,"SPN_Name":"Joystick 2 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2730":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":62,"SPN":2730,"SPN_Name":"Joystick 2 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2731":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":60,"SPN":2731,"SPN_Name":"Joystick 2 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2732":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":58,"SPN":2732,"SPN_Name":"Joystick 2 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2733":{"PGN":64984,"PGN_Name":"Basic Joystick Message 2","PGN_Description":"BJM2","first_bit":56,"SPN":2733,"SPN_Name":"Joystick 2 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2734":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":6,"SPN":2734,"SPN_Name":"Joystick 3 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2735":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":22,"SPN":2735,"SPN_Name":"Joystick 3 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2736":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":6,"SPN":2736,"SPN_Name":"Joystick 3 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2737":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":22,"SPN":2737,"SPN_Name":"Joystick 3 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2738":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":38,"SPN":2738,"SPN_Name":"Joystick 3 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"2739":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":4,"SPN":2739,"SPN_Name":"Joystick 3 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2740":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":20,"SPN":2740,"SPN_Name":"Joystick 3 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2741":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":4,"SPN":2741,"SPN_Name":"Joystick 3 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2742":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":20,"SPN":2742,"SPN_Name":"Joystick 3 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2743":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":36,"SPN":2743,"SPN_Name":"Joystick 3 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2744":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":2,"SPN":2744,"SPN_Name":"Joystick 3 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2745":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":18,"SPN":2745,"SPN_Name":"Joystick 3 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2746":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":2,"SPN":2746,"SPN_Name":"Joystick 3 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2747":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":18,"SPN":2747,"SPN_Name":"Joystick 3 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2748":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":34,"SPN":2748,"SPN_Name":"Joystick 3 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2749":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":0,"SPN":2749,"SPN_Name":"Joystick 3 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2750":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":16,"SPN":2750,"SPN_Name":"Joystick 3 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2751":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":0,"SPN":2751,"SPN_Name":"Joystick 3 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2752":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":16,"SPN":2752,"SPN_Name":"Joystick 3 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2753":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":32,"SPN":2753,"SPN_Name":"Joystick 3 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2754":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":38,"SPN":2754,"SPN_Name":"Joystick 3 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2755":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":36,"SPN":2755,"SPN_Name":"Joystick 3 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2756":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":54,"SPN":2756,"SPN_Name":"Joystick 3 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2757":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":52,"SPN":2757,"SPN_Name":"Joystick 3 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2758":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":50,"SPN":2758,"SPN_Name":"Joystick 3 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2759":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":46,"SPN":2759,"SPN_Name":"Joystick 3 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2760":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":44,"SPN":2760,"SPN_Name":"Joystick 3 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2761":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":42,"SPN":2761,"SPN_Name":"Joystick 3 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2762":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":40,"SPN":2762,"SPN_Name":"Joystick 3 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2763":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":54,"SPN":2763,"SPN_Name":"Joystick 3 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2764":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":52,"SPN":2764,"SPN_Name":"Joystick 3 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2765":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":50,"SPN":2765,"SPN_Name":"Joystick 3 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2766":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":48,"SPN":2766,"SPN_Name":"Joystick 3 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2767":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":62,"SPN":2767,"SPN_Name":"Joystick 3 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2768":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":60,"SPN":2768,"SPN_Name":"Joystick 3 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2769":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":58,"SPN":2769,"SPN_Name":"Joystick 3 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2770":{"PGN":64986,"PGN_Name":"Basic Joystick Message 3","PGN_Description":"BJM3","first_bit":56,"SPN":2770,"SPN_Name":"Joystick 3 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2773":{"PGN":64918,"PGN_Name":"Fuel Information 2 (Liquid)","PGN_Description":"LFI2","first_bit":0,"SPN":2773,"SPN_Name":"Engine Fuel Supply Flow Rate","SPN_Description":"The rate of fuel flowing through a fuel supply line carrying fuel from the fuel tank to the engine.","bit_length":32,"scaling":0.001,"offset":0,"unit":"l/h","SLOT_ID":321},"2774":{"PGN":64918,"PGN_Name":"Fuel Information 2 (Liquid)","PGN_Description":"LFI2","first_bit":32,"SPN":2774,"SPN_Name":"Engine Fuel Return Flow Rate","SPN_Description":"The rate of fuel flowing through a fuel return line carrying fuel from the engine back to fuel tank.","bit_length":32,"scaling":0.001,"offset":0,"unit":"l/h","SLOT_ID":321},"2775":{"PGN":64919,"PGN_Name":"Fuel Information 3 (Liquid)","PGN_Description":"LFI3","first_bit":0,"SPN":2775,"SPN_Name":"Engine Fuel Supply Temperature","SPN_Description":"The temperature of the fuel flowing through a fuel supply line from the fuel tank to the engine.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"2776":{"PGN":64919,"PGN_Name":"Fuel Information 3 (Liquid)","PGN_Description":"LFI3","first_bit":8,"SPN":2776,"SPN_Name":"Engine Fuel Return Temperature","SPN_Description":"The temperature of the fuel flowing through a fuel return line from the engine back to the fuel tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"2777":{"PGN":64940,"PGN_Name":"Engine Fuel Information","PGN_Description":"EFI","first_bit":0,"SPN":2777,"SPN_Name":"Number of Fuel Consumption Monitoring Transducers","SPN_Description":"The number of fuel consumption monitoring transducers installed in the fuel consumption monitoring system.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"2778":{"PGN":64940,"PGN_Name":"Engine Fuel Information","PGN_Description":"EFI","first_bit":8,"SPN":2778,"SPN_Name":"Engine Idle Fuel Flow Rate Threshold","SPN_Description":"A configuration value that indicates the maximum flow rate for engine idle operation.","bit_length":32,"scaling":0.001,"offset":0,"unit":"l/h","SLOT_ID":321},"2779":{"PGN":65104,"PGN_Name":"Battery Temperature","PGN_Description":"BT1","first_bit":16,"SPN":2779,"SPN_Name":"SLI Battery 3 Temperature","SPN_Description":"Temperature of the third battery or third set of batteries used for starting the engine, for lighting, and for ignition (SLI). \\r\\n\\r\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"2780":{"PGN":65104,"PGN_Name":"Battery Temperature","PGN_Description":"BT1","first_bit":24,"SPN":2780,"SPN_Name":"SLI Battery 4 Temperature","SPN_Description":"Temperature of the fourth battery or fourth set of batteries used for starting the engine, for lighting, and for ignition (SLI). \\r\\n\\r\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"2789":{"PGN":64981,"PGN_Name":"Electronic Engine Controller 5","PGN_Description":"EEC5","first_bit":0,"SPN":2789,"SPN_Name":"Engine Turbocharger 1 Calculated Turbine Intake Temperature","SPN_Description":"Calculated value of turbine intake temperature based on engine operating conditions, such as intake manifold temperature, charge fuel ratio, injection timing, and engine speed.  Use SPN 1180 for actual measured intake temperature.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2790":{"PGN":64981,"PGN_Name":"Electronic Engine Controller 5","PGN_Description":"EEC5","first_bit":16,"SPN":2790,"SPN_Name":"Engine Turbocharger 1 Calculated Turbine Outlet Temperature","SPN_Description":"Calculated value of turbocharger compressor outlet air temperature.  Temperature of air exiting the turbocharger compressor and before entering charge air cooler.  The estimate is based on turbo speed and measured turbocharger compressor intake temperature.  Use SPN 1184 for actual measured outlet temperature.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2791":{"PGN":64981,"PGN_Name":"Electronic Engine Controller 5","PGN_Description":"EEC5","first_bit":32,"SPN":2791,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Valve 1 Control 1","SPN_Description":"Desired percentage of maximum Exhaust Gas Recirculation (EGR) valve 1 opening.  0% means valve is closed. 100% means maximum valve opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"2792":{"PGN":64981,"PGN_Name":"Electronic Engine Controller 5","PGN_Description":"EEC5","first_bit":48,"SPN":2792,"SPN_Name":"Engine Variable Geometry Turbocharger (VGT) Air Control Shutoff Valve","SPN_Description":"Isolates vehicle brake air from the Variable Geometry Turbocharger (VGT) system when engine is not running.  This valve prevents vehicle air from bleeding off through the VGT Control Valve when engine is not in use.  Primary vehicle air system from air tanks feed the VGT Air Control Shutoff Valve, which in turn provides air to the VGT Control Valve when the key switch is \'ON\'.  The VGT Control Valve delivers air to the VGT actuator to adjust turbocharger geometry.\\r\\n\\r\\n00   VGT Air Control Shutoff Valve is Off\\r\\n01   VGT Air Control Shutoff Valve is On\\r\\n10   Reserved\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2793":{"PGN":65141,"PGN_Name":"Laser Leveling System Vertical Deviation","PGN_Description":"LVD","first_bit":24,"SPN":2793,"SPN_Name":"Laser Strike Data Latency","SPN_Description":"Time from laser strike to CAN message transmission.  This parameter will be reported by survey receiver type devices only. Byte 3 (SPN 2576) of  PGN 65141 identifies the type of Laser Receiver.","bit_length":16,"scaling":0.0000512,"offset":0,"unit":"s","SLOT_ID":206},"2794":{"PGN":65141,"PGN_Name":"Laser Leveling System Vertical Deviation","PGN_Description":"LVD","first_bit":40,"SPN":2794,"SPN_Name":"Absolute Laser Strike Position","SPN_Description":"Laser Strike location on the survey type  laser receiver.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"2795":{"PGN":64981,"PGN_Name":"Electronic Engine Controller 5","PGN_Description":"EEC5","first_bit":56,"SPN":2795,"SPN_Name":"Engine Variable Geometry Turbocharger (VGT) 1 Actuator Position","SPN_Description":"Sensor that measures the position of the variable geometry turbocharger actuator.  A  position of 0% indicates the actuator is in the position creating the smallest geometry turbocharger. A position of 100% represents the largest geometry turbocharger.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2796":{"PGN":64980,"PGN_Name":"Cab Message 3","PGN_Description":"CM3","first_bit":0,"SPN":2796,"SPN_Name":"Transfer Case Selector Switch","SPN_Description":"Operator switch to select the condition of the transfer case.  States 000 and 001 should be used if the transfer case only functions to switch between 2-wheel and 4-wheel drive.  If the transfer case includes a High / Low Range function, states 011 and 100 should be supported as well.  For reporting the status of the transfer case, see SPN 3645.\\r\\n\\r\\n000:  \\t2 wheel high (Normal or \u2018On Highway\u2019 Range)\\r\\n001:  \\t4 wheel high (Normal or \u2018On Highway\u2019 Range)\\r\\n010:  \\tNeutral\\r\\n011:\\t2 wheel low (or \u2018Off Highway\u2019 Range)\\r\\n100:\\t4 wheel low (or \u2018Off Highway\u2019 Range)\\r\\n101:  \\tReserved for SAE assignment\\r\\n110:  \\tError indicator\\r\\n111:  \\tNot available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"2799":{"PGN":64979,"PGN_Name":"Turbocharger Information 6","PGN_Description":"TCI6","first_bit":16,"SPN":2799,"SPN_Name":"Engine Turbocharger 2 Compressor Outlet Temperature","SPN_Description":"Temperature of the air or air/fuel mixture exiting the turbocharger 2 compressor outlet.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2800":{"PGN":64979,"PGN_Name":"Turbocharger Information 6","PGN_Description":"TCI6","first_bit":32,"SPN":2800,"SPN_Name":"Engine Turbocharger 3 Compressor Outlet Temperature","SPN_Description":"Temperature of the air or air/fuel mixture exiting the turbocharger 3 compressor outlet.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2801":{"PGN":64979,"PGN_Name":"Turbocharger Information 6","PGN_Description":"TCI6","first_bit":48,"SPN":2801,"SPN_Name":"Engine Turbocharger 4 Compressor Outlet Temperature","SPN_Description":"Temperature of the air or air/fuel mixture exiting the turbocharger 4 compressor outlet.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"2802":{"PGN":64978,"PGN_Name":"ECU Performance","PGN_Description":"EP","first_bit":16,"SPN":2802,"SPN_Name":"Data Memory Usage","SPN_Description":"The used storage capacity of the data buffer memory internal to an ECU, such as a data logger.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2803":{"PGN":64978,"PGN_Name":"ECU Performance","PGN_Description":"EP","first_bit":0,"SPN":2803,"SPN_Name":"Keep-Alive Battery Consumption","SPN_Description":"The capacity consumed from the direct battery connection since the key was last turned off.  This value is maintained and does not accumulate while the key switch is on.  The value is reset to 0 when the key switch is turned to the off position.","bit_length":16,"scaling":1,"offset":0,"unit":"mAh","SLOT_ID":211},"2804":{"PGN":64977,"PGN_Name":"FMS-standard Interface Identity/Capabilities","PGN_Description":"FMS","first_bit":0,"SPN":2804,"SPN_Name":"FMS-standard Diagnostics Supported","SPN_Description":"Status signal which indicates if the FMS Vehicle Interface (FMS Gateway) supports the handling of diagnostic messages from the vehicle network onto the FMS network.\\r\\n\\r\\nThe FMS gateway does NOT support the re-broadcast of diagnostics messages present on the vehicle network.\\r\\n\\r\\nIf this \'FMS-standard Diagnostics Supported\' feature is supported by the FMS Gateway, the FMS Gateway will support the requests for  diagnostics information (from the FMS device) onto the vehicle network and pass the responses onto the FMS network.\\r\\n\\r\\nNote: This feature of the FMS Gateway is independent of the \'FMS-standard Requests Supported\'. The FMS Gateway may support diagnostics without supporting the \'FMS-standard Requests Supported\' function, or visa-versa.\\r\\n\\r\\n00 Diagnostics Is Not Supported\\r\\n01 Diagnostics Is Supported\\r\\n10 Reserved\\r\\n11 Don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2805":{"PGN":64977,"PGN_Name":"FMS-standard Interface Identity/Capabilities","PGN_Description":"FMS","first_bit":2,"SPN":2805,"SPN_Name":"FMS-standard Requests Supported","SPN_Description":"Status signal which indicates if the FMS Vehicle Interface (FMS Gateway) will respond to requests from the FMS device for the PGNs listed in the FMS Interface Specification.\\r\\n\\r\\nThis mode is to support FMS  gateway devices that only operate in a \'Request\' mode.\\r\\n\\r\\nThe FMS PGNs may also be broadcast periodically in this mode.\\r\\n\\r\\nThe FMS Gateway will NOT support the requests for information not included in the FMS Interface Specification onto the vehicle network.\\"\\r\\n\\r\\n\\r\\n00 On request mode is not supported\\r\\n01 On request mode is supported\\r\\n10 Reserved\\r\\n11 Don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2806":{"PGN":64977,"PGN_Name":"FMS-standard Interface Identity/Capabilities","PGN_Description":"FMS","first_bit":8,"SPN":2806,"SPN_Name":"FMS-standard SW-version supported.","SPN_Description":"Information that identifies which issue level of the FMS-standard document the software included in the FMS gateway supports. Four bytes, representing xx.yy type revision level identification.\\r\\n\\r\\nInformation to be ASCII equivalent of the numeric revision level of the FMS document, 00.01 to 99.99. The first released version will be 01.00.\\r\\n\\r\\nNote:\\r\\n\\r\\nByte 2 and byte 3 represents the SW version supported for trucks. Version number in the format ab.cd where Byte 2 represents \\"a\\" ASCII and Byte 3 represents \\"b\\" ASCII.\\r\\n\\r\\nByte 4 and byte 5 represents the SW version supported for bus and coaches; version number in the format ab.cd where Byte 4 represents \\"c\\" ASCII and Byte 5 represents \\"d\\" ASCII.","bit_length":32,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":212},"2807":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":28,"SPN":2807,"SPN_Name":"Engine Fuel Shutoff 2 Control","SPN_Description":"Control setting for fuel shutoff 2.  First instance is SPN 632.  For a dual fuel shutoff system, this SPN is representative of the downstream fuel shutoff commanded position.  When fuel (gas) is desired at the engine, the fuel shutoff is opened.  Otherwise, it is closed.\\r\\n\\r\\n00 = Open (fuel supplied to engine)\\r\\n01 = Closed (no fuel supplied to engine)\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action\\r\\n\\r\\nIn addition to communicating desired action of fuel shutoff 2 and its driver status, this new SPN can be used to communicate whether fuel shutoff 2 feedback position (if available) matches the commanded position, through the use of FMIs.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2809":{"PGN":64976,"PGN_Name":"Intake/Exhaust Conditions 2","PGN_Description":"IC2","first_bit":0,"SPN":2809,"SPN_Name":"Engine Air Filter 2 Differential Pressure","SPN_Description":"Change in engine air system pressure, measured across the second air filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\\r\\n\\r\\nThis is for monitoring the air filter on the intake to the second turbocharger. Filter numbering follows the guidelines noted in section Naming Convention For Engine Parameters.","bit_length":8,"scaling":0.05,"offset":0,"unit":"kPa","SLOT_ID":48},"2810":{"PGN":64976,"PGN_Name":"Intake/Exhaust Conditions 2","PGN_Description":"IC2","first_bit":8,"SPN":2810,"SPN_Name":"Engine Air Filter 3 Differential Pressure","SPN_Description":"Change in engine air system pressure, measured across the third air filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\\r\\n\\r\\nThis is for monitoring the air filter on the intake to the third turbocharger. Filter numbering follows the guidelines noted in section Naming Convention For Engine Parameters.","bit_length":8,"scaling":0.05,"offset":0,"unit":"kPa","SLOT_ID":48},"2811":{"PGN":64976,"PGN_Name":"Intake/Exhaust Conditions 2","PGN_Description":"IC2","first_bit":16,"SPN":2811,"SPN_Name":"Engine Air Filter 4 Differential Pressure","SPN_Description":"Change in engine air system pressure, measured across the fourth air filter, due to the filter and any accumulation of solid foreign matter on or in the filter.\\r\\n\\r\\nThis is for monitoring the air filter on the intake to the fourth turbocharger. Filter numbering follows the guidelines noted in section Naming Convention For Engine Parameters.","bit_length":8,"scaling":0.05,"offset":0,"unit":"kPa","SLOT_ID":48},"2812":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":54,"SPN":2812,"SPN_Name":"Engine Overspeed Test","SPN_Description":"The engine overspeed test signal as measured by the reporting ECM.  Engine Overspeed Test is a mechanism to simulate engine overspeed situations, while operating the engine within the engine\'s safe operating range.\\r\\n\\r\\nState signal which indicates when the overspeed test input to the ECM is being driven.\\r\\n\\r\\n00 Engine Overspeed Test Not Active\\r\\n01 Engine Overspeed Test Active\\r\\n10 Reserved\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2813":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":52,"SPN":2813,"SPN_Name":"Engine Air Shutoff Command Status","SPN_Description":"State signal which indicates when the Air Shutoff  driver output is being driven. Disabled means controller wants air flowing to the engine. Status of the airflow  shutoff as being commanded by the ECU.\\r\\n\\r\\n00 Air Shutoff Disabled, not attempting to shutoff engine air supply\\r\\n01 Air Shutoff Enabled, attempting to shutoff engine air supply\\r\\n10 Reserved\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2814":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":50,"SPN":2814,"SPN_Name":"Engine Alarm Output Command Status","SPN_Description":"State signal which indicates when the Alarm driver output is being driven. Not active means the Controller has no alarm level conditions.\\r\\n\\r\\n00 Engine Alarm Output Command Not Active\\r\\n01 Engine Alarm Output Command Active\\r\\n10 Reserved\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2815":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":48,"SPN":2815,"SPN_Name":"Engine Alarm Acknowledge","SPN_Description":"The Engine Alarm Acknowledge Input signal as measured by the reporting ECU.  The Engine Alarm Acknowledge is a mechanism for external acknowledgement of the SPN 2814,  Engine Alarm Output Command. \\r\\n\\r\\n00 Engine Alarm Acknowledge  Not Active \\r\\n01 Engine Alarm Acknowledge Active\\r\\n10 Error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2863":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":4,"SPN":2863,"SPN_Name":"Front Operator Wiper Switch","SPN_Description":"State of operation selected by operator switch for the Wiper in front of the operator position. This parameter, \'Front Operator Wiper Switch\' should be used for the control information if either of the other wiper switch parameters is \'Not Available\' and the associated wiper still needs to be controlled.\\r\\n\\r\\n0000 Off\\r\\n0001 Low\\r\\n0010 Medium\\r\\n0011 High\\r\\n0100 Delayed 1 (used for the first delay choice when the wiper switch position controls the delay)\\r\\n0101 Delayed 2 (used for the second delay choice when the wiper switch position controls the delay)\\r\\n0110 Mist (position where external sensor  controls wiper rate)\\r\\n0111 - 1110   Reserved   \\r\\n1111 Not available (do not change)","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2864":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":0,"SPN":2864,"SPN_Name":"Front Non-operator Wiper Switch","SPN_Description":"State of operation selected by operator switch for the front wiper not in front of the operator position.  The parameter, \'Front Operator Washer Switch\' should be used for the control information if this parameter is \'Not Available\' and the associated washer still needs to be controlled.\\r\\n\\r\\n0000 Off\\r\\n0001 Low\\r\\n0010 Medium\\r\\n0011 High\\r\\n0100 Delayed 1 (used for the first delay choice when the wiper switch position controls the delay)\\r\\n0101 Delayed 2 (used for the second delay choice when the wiper switch position controls the delay)\\r\\n0110 Mist (position where external sensor  controls wiper rate)\\r\\n0111 - 1110   Reserved   \\r\\n1111 Not available (do not change)","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2865":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":12,"SPN":2865,"SPN_Name":"Rear Wiper Switch","SPN_Description":"State of operation selected by operator switch for the rear wiper.  The parameter, \'Front Operator Washer Switch\' should be used for the control information if this parameter is \'Not Available\' and the associated washer still needs to be controlled.\\r\\n\\r\\n0000 Off\\r\\n0001 Low\\r\\n0010 Medium\\r\\n0011 High\\r\\n0100 Delayed 1 (used for the first delay choice when the wiper switch position controls the delay)\\r\\n0101 Delayed 2 (used for the second delay choice when the wiper switch position controls the delay)\\r\\n0110 Mist (position where external sensor  controls wiper rate)\\r\\n0111 - 1110   Reserved   \\r\\n1111 Not available (do not change)","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2866":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":45,"SPN":2866,"SPN_Name":"Front Operator Washer Switch","SPN_Description":"State of operation selected by operator switch for the washer in front of the operator position. This parameter, \'Front Operator Washer Switch\u2019 should be used for the control information if either of the other washer switch parameters  is \'Not Available\' and the associated washer still needs to be controlled.\\r\\n\\r\\n000 Off\\r\\n001 Low\\r\\n010 Medium\\r\\n011 High\\r\\n100 - 110   Reserved   \\r\\n111 Not available (do not change)","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"2867":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":42,"SPN":2867,"SPN_Name":"Front Non-operator Washer Switch","SPN_Description":"State of operation selected by operator switch for the front washer not in front of the operator position.  The parameter, \'Front Operator Washer Switch\u2019 should be used for the control information if this parameter  is \'Not Available\' and the associated washer still needs to be controlled.\\r\\n\\r\\n000 Off\\r\\n001 Low\\r\\n010 Medium\\r\\n011 High\\r\\n100 - 110   Reserved   \\r\\n111 Not available (do not change)","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"2868":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":53,"SPN":2868,"SPN_Name":"Rear Washer Function","SPN_Description":"State of operation selected by operator switch for the rear washer.   The parameter, \'Front Operator Washer Switch\u2019 should be used for the control information if this parameter is \'Not Available\' and the associated washer still needs to be controlled.\\r\\n\\r\\n000 Off\\r\\n001 Low\\r\\n010 Medium\\r\\n011 High\\r\\n100 - 110   Reserved   \\r\\n111 Not available (do not change)","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"2869":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":16,"SPN":2869,"SPN_Name":"Front Operator Wiper Delay Control","SPN_Description":"Time between cycles of the front operator side wiper (i.e. from end of cycle \'n\' to start of cycle \'n+1\') as selected by the operator control (switch, etc.) in percentage of position with maximum position corresponding to maximum delay selectable.  This parameter, \'Front Operator Wiper Delay Control\' should be used for the delay information if either of the other delay parameters is \'Not Available\' and the function needs to be provided.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2870":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":24,"SPN":2870,"SPN_Name":"Front Non-operator Wiper Delay Control","SPN_Description":"Time between cycles of the front non-operator side wiper (i.e. from end of cycle \'n\' to start of cycle \'n+1\') as selected by the operator control (switch, etc.) in percentage of position with maximum position corresponding to maximum delay selectable.  The parameter, \'Front Operator Wiper Delay Control\' should be used for the delay information if this parameter is \'Not Available\' and the function needs to be provided.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2871":{"PGN":64973,"PGN_Name":"Operator Wiper and Washer Controls Message","PGN_Description":"OWW","first_bit":32,"SPN":2871,"SPN_Name":"Rear Wiper Delay Control","SPN_Description":"Time between cycles of the rear wiper (i.e. from end of cycle \'n\' to start of cycle \'n+1\') as selected by the operator control (switch, etc.) in percentage of position with maximum position corresponding to maximum delay selectable.  The parameter, \'Front Operator Wiper Delay Control\' should be used for the delay information if this parameter is \'Not Available\' and the function needs to be provided.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2872":{"PGN":64972,"PGN_Name":"Operators External Light Controls Message","PGN_Description":"OEL","first_bit":4,"SPN":2872,"SPN_Name":"Main Light Switch","SPN_Description":"A 4 bit parameter to indicate the selected position of the operator\'s main light switch.\\r\\n\\r\\n0000  Off - The position by which the operator selects that none of the lamps are to be on.\\r\\n0001  Park On - The position by which the operator selects that the park lamps are to be on. \\r\\n0010  Headlight On - The position by which the operator selects that the headlamps are to be on.\\r\\n0011  Headlight and Park On - The position by which the operator selects that Both the Headlamps and the Park lamps are to be on.\\r\\n0100  Automatic Lights - The position by which the operator selects that the Headlamps and Park Lamps turn on and off due to outside ambient light conditions\\r\\n0101  Reserved\\r\\n0110  Reserved\\r\\n0111  Reserved   \\r\\n1000  Delayed Off - The position by which the operator selects that a certain set of lamps are to come On and then are to be turned Off following a delay time (Operators Desired - Delayed Lamp Off Time).\\r\\n1001  Reserved\\r\\n1010  Reserved\\r\\n1011  Reserved\\r\\n1100  Reserved\\r\\n1101  Reserved\\r\\n1110  Error\\r\\n1111  Not available (do not change)","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2873":{"PGN":64972,"PGN_Name":"Operators External Light Controls Message","PGN_Description":"OEL","first_bit":0,"SPN":2873,"SPN_Name":"Work Light Switch","SPN_Description":"A 4 bit parameter to indicate the selected position of the operator\'s work light switch. In Ag applications the work lights are often refereed to as field lights.  In on-highway applications the work lights are often referred to as clearance lights and may or may not be operated by a switch separate from the main light switch.\\r\\n \\r\\n0000   Off - The position by which the operator selects that none of the work lamps are to be on.\\r\\n0001   Work Light Combination #1 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #1 are to be on.\\r\\n0010   Work Light Combination #2 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #2 are to be on.\\r\\n0011   Work Light Combination #3 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #3 are to be on.\\r\\n0100   Work Light Combination #4 On - The position by which the operator selects that the lamps in the combination defined as Work Light Combination #4 are to be on.\\r\\n0101-1101    Reserved   \\r\\n1110   Error\\r\\n1111   Not available (do not change)","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2874":{"PGN":64972,"PGN_Name":"Operators External Light Controls Message","PGN_Description":"OEL","first_bit":14,"SPN":2874,"SPN_Name":"High-Low Beam Switch","SPN_Description":"A 2 bit parameter to indicate the selected position of the operator\'s high/low beam select switch.\\r\\n\\r\\n00  Low Beam Selected\\r\\n01  High Beam Selected\\r\\n10  Error\\r\\n11  Not available (do not change)","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2875":{"PGN":64972,"PGN_Name":"Operators External Light Controls Message","PGN_Description":"OEL","first_bit":12,"SPN":2875,"SPN_Name":"Hazard Light Switch","SPN_Description":"A 2 bit parameter to indicate the selected position of the operator\'s hazard light switch.\\r\\n\\r\\n00   Hazard Lamps to be Off\\r\\n01   Hazard Lamps to be Flashing\\r\\n10   Error\\r\\n11   Not available (do not change)","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2876":{"PGN":64972,"PGN_Name":"Operators External Light Controls Message","PGN_Description":"OEL","first_bit":8,"SPN":2876,"SPN_Name":"Turn Signal Switch","SPN_Description":"A 4 bit parameter to indicate the selected position of the operator\'s turn signal switch.\\r\\n\\r\\n0000   No Turn being signaled\\r\\n0001   Left Turn to be Flashing\\r\\n0010   Right turn to be Flashing\\r\\n0011 - 1101   Reserved   \\r\\n1110   Error (to include both left and right selected simultaneously)\\r\\n1111   Not available (do not change)","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2877":{"PGN":64972,"PGN_Name":"Operators External Light Controls Message","PGN_Description":"OEL","first_bit":24,"SPN":2877,"SPN_Name":"Operators Desired - Delayed Lamp Off Time","SPN_Description":"A 16 bit parameter to be associated with Delayed Off position (1000 binary) of the Main Light Switch.  This parameter indicates the time the operator wishes to have elapse following the Main Light switch being placed in Delayed Off position before the defined lights turn back off.  The Operator\'s definition as to which lamps are to turn On (and then Off of course) when the Main Light Switch is in the Delayed Off position.  The specific lamps are not identified within this message, but are to be stored by whatever device (ecu) is planning to send the lamp command message for said lamps.  Said device must also provide the means for the operator to enter and/or adjust said definition.","bit_length":16,"scaling":1,"offset":0,"unit":"s","SLOT_ID":64},"2878":{"PGN":64972,"PGN_Name":"Operators External Light Controls Message","PGN_Description":"OEL","first_bit":16,"SPN":2878,"SPN_Name":"Operators Desired Back-light","SPN_Description":"A 8 bit parameter to indicate the level of back lighting the operator has selected for displays.  This is to be differentiated from the Illumination Brightness Percent (SPN:1487 PGN:53248 Cab Illumination Message) which is sent to the displays to tell them what level to be at.  This is the operator desired level (as sensed by operator controls) for those system where the operator controls are monitored by an ecu separate from the ecu sending the command to the displays.  Note each display (if appropriate) will need to have its own balance function to compensate its nominal brightness to the same level of that of all other displays.  This is especially important for systems with back-lights which may change noticeable with aging.  In other words it will be necessary within a vehicle to scale all of the displays down to the same level as the dimmest display (since, obviously you can not make the dimmest brighter).","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2879":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":20,"SPN":2879,"SPN_Name":"Engine Droop Accelerator 2 Select","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to Accelerator 2.\\r\\n\\r\\n0000 \u2013 Normal Droop Setting is selected\\r\\n0001 thru 1101 \u2013 One of Droop Setting 1 through 13 (in sequential order) is selected\\r\\n1110 \u2013  Error condition\\r\\n1111  \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2880":{"PGN":64970,"PGN_Name":"Intermediate Speed Control","PGN_Description":"ISC","first_bit":0,"SPN":2880,"SPN_Name":"Engine Operator Primary Intermediate Speed Select","SPN_Description":"Allows the operator to select one of 13 preprogrammed Intermediate Speed Control settings. If no speed setting is requested, the engine operates normally. The Intermediate Speed Control is widely used in the Industrial application to control the engine to an intermediate speed setting which can either replace the accelerator position control altogether, or limit the accelerator position control to a selectable speed point minimum or maximum.\\r\\n\\r\\n0000 \u2013 indicates that the ISC functionality is not requested, engine operates normally\\r\\n0001 thru 1101 \u2013 indicates that the ISC Setting 1 thru 13 (in sequential order) is selected\\r\\n1110 \u2013 error condition\\r\\n1111 \u2013 not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2881":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":16,"SPN":2881,"SPN_Name":"Engine Droop Accelerator 1 Select","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to Accelerator 1.\\r\\n\\r\\n0000 \u2013 Normal Droop Setting is selected\\r\\n0001 thru 1101 \u2013 One of Droop Setting 1 through 13 (in sequential order) is selected\\r\\n1110 \u2013  Error condition\\r\\n1111  \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2882":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":8,"SPN":2882,"SPN_Name":"Engine Alternate Rating Select","SPN_Description":"In some off-highway applications it may be desirable to have multiple engine ratings available for selection by the operator. There is the default engine rating, which provides the maximum available power across the range of operation. There are additional engine ratings which the user can select that allow for alternate fueling across the operational range.  Engine rating selection number 0 is the maximum rating. Selection number 1 is the next highest, selection 2 next highest, etc. The selection impacts the operating points in the Engine Configuration.\\r\\n\\r\\n0 \u2013 indicates that Maximum Power Fueling is selected\\r\\n1 \u2013 indicates that the Alternate Power Fueling 1 is selected\\r\\n2 \u2013 indicates that the Alternate Power Fueling 2 is selected\\r\\n3 \u2013 indicates that the Alternate Power Fueling 3 is selected\\r\\n4 thru 253 - indicates that the Alternate Power Fueling 4 thru 253 (in sequential order) is selected.\\r\\n254 \u2013 Error condition.\\r\\n255 \u2013 Not available","bit_length":8,"scaling":1,"offset":0,"unit":"selection","SLOT_ID":259},"2883":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":4,"SPN":2883,"SPN_Name":"Engine Alternate Low Idle Switch","SPN_Description":"Operator switch which selects between two low idle speeds, default and alternate.\\r\\n\\r\\nThe normal programmed low idle is the default low idle, and when the Alternate Low Idle switch is activated, a alternate preprogrammed low idle speed is selected. The accelerator position control operates as normal but is now bounded to a different low idle speed. This selection impacts Point 1 on the Engine Configuration.\\r\\n\\r\\n\\r\\n00 Default low idle point is selected\\r\\n01 Alternate low idle point is selected\\r\\n10 Error\\r\\n11 Not available or Unused","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2884":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":0,"SPN":2884,"SPN_Name":"Engine Auxiliary Governor Switch","SPN_Description":"This is the On/Off operation of the Auxiliary Governor feature switch. This feature is used to allow engine speed to be controlled by an auxiliary input such as pressure or tailshaft speed. This switch position indicates whether this feature is requested or not. \\r\\n\\r\\n00 \u2013 Auxiliary Governor is disabled\\r\\n01 \u2013 Auxiliary Governor is enabled\\r\\n10 \u2013 Error condition\\r\\n11 \u2013 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2885":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":28,"SPN":2885,"SPN_Name":"Engine Droop Auxiliary Input Select","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to the engine droop auxiliary input.\\r\\n\\r\\n0000 \u2013 Normal Droop Setting is selected\\r\\n0001 thru 1101 \u2013 One of Droop Setting 1 through 13 (in sequential order) is selected\\r\\n1110 \u2013  Error condition\\r\\n1111 \u2013  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2886":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":24,"SPN":2886,"SPN_Name":"Engine Droop Remote Accelerator Select","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to the remote accelerator.\\r\\n\\r\\n0000 \u2013 Normal Droop Setting is selected\\r\\n0001 thru 1101 \u2013 One of Droop Setting 1 through 13 (in sequential order) is selected\\r\\n1110 \u2013  Error condition\\r\\n1111 \u2013  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2887":{"PGN":64969,"PGN_Name":"Electronic Control Module Information","PGN_Description":"CMI","first_bit":0,"SPN":2887,"SPN_Name":"Total Count of Configuration Changes Made","SPN_Description":"Total number of times changes have been made to any of the configurable parameters.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"2888":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":8,"SPN":2888,"SPN_Name":"Engine Alternate Rating Select State","SPN_Description":"This parameter reflects the control state that has been achieved based on the input from the SPN 2882.  In some off-highway applications it may be desirable to have multiple engine ratings available for selection by the operator.  There is the default engine rating, which provides the maximum available power across the range of operation. There are additional engine ratings which the engine controller may use that allow for alternate fueling across the operational range.  Engine rating  number 1 is the maximum rating. Rating number 2 is the next highest, rating 3 next highest, etc.\\r\\n\\r\\n00 \u2013 Control state is Maximum Power Fueling\\r\\n01 \u2013 Control state is Alternate Power Fueling 1 \\r\\n02 \u2013 Control state is Alternate Power Fueling 2 \\r\\n03 \u2013 Control state is Alternate Power Fueling 3\\r\\n04 thru 253 - Control state is Alternate Power Fueling 4 thru 253 (in sequential order) \\r\\n254 \u2013 SAE reserved\\r\\n255 \u2013 Not available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"2889":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":16,"SPN":2889,"SPN_Name":"Engine Droop Accelerator 1 Select State","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections may apply to Accelerator 1. This parameter indicates which state has been selected by the controlling ECM.\\r\\n\\r\\n0000 \u2013 Control state is Normal Droop Setting\\r\\n0001 thru 1101 \u2013 Control state is one of Droop Setting 1 through 13 (in sequential order) \\r\\n1110 \u2013  SAE reserved\\r\\n1111 \u2013  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2890":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":2,"SPN":2890,"SPN_Name":"Engine Multi-Unit Sync State","SPN_Description":"This feature is widely used in Industry to operate multiple engines from a single command source. A master engine will \u201Csynchronize\u201D one or more slave engines to operate at the same speed. This feature is requested by an operator switch, this parameter indictes the state of the feature as determined by the controlling ECM.\\r\\n\\r\\n00 Control State is Functionality disabled (off)\\r\\n01 Control State is Functionality enabled (on)\\r\\n10 SAE reserved\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2891":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":4,"SPN":2891,"SPN_Name":"Engine Alternate Low Idle Select State","SPN_Description":"In many applications, it is desirable that an alternate low idle speed setting be made available via switch input. The normal programmed low idle is the default low idle, and when the Alternate Low Idle feature is activated, an alternate preprogrammed low idle speed is selected. The accelerator position control operates as normal but is now bounded to a different low idle speed. This selection impacts Point 1 on the Engine Configuration.\\r\\n\\r\\n00 \u2013 Normal idle state\\r\\n01 \u2013 Alternate idle state\\r\\n10 \u2013 SAE reserved\\r\\n11 \u2013 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2892":{"PGN":64968,"PGN_Name":"Operator Primary Intermediate Speed Control state","PGN_Description":"ISCS","first_bit":0,"SPN":2892,"SPN_Name":"Engine Operator Primary Intermediate Speed Select State","SPN_Description":"13 preprogrammed intermediate speed control settings are available for the controlling ECM to select.  If no speed setting is requested, the engine operates normally. The Intermediate Speed Control is widely used in the Industrial application to control the engine to an intermediate speed setting which can either replace the accelerator position control altogether, or limit the accelerator position control to a selectable speed point minimum or maximum. This parameter indicates which state has been selected by the controlling ECM.\\r\\n\\r\\n0000 \u2013 Control state is ISC functionality is not requested, engine operates normally\\r\\n0001 thru 1101 \u2013 Control state is  ISC Setting 1 thru 13 (in sequential order) \\r\\n1110 \u2013 SAE reserved\\r\\n1111 \u2013 not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2893":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":20,"SPN":2893,"SPN_Name":"Engine Alternate Droop Accelerator 2 Select State","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching. The selections apply to Accelerator 2.\\r\\n\\r\\n0000 \u2013 Control\'s state is Normal Droop Setting\\r\\n0001 thru 1101 \u2013 Control\'s state is One of Alternate Droop Setting 1 through 13 (in sequential order)\\r\\n1110 \u2013  SAE reserved\\r\\n1111 \u2013  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2894":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":24,"SPN":2894,"SPN_Name":"Engine Droop Remote Accelerator Select State","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching.  The selections apply to Remote Accelerator.\\r\\n\\r\\n0000 \u2013 Control state is Normal Droop Setting\\r\\n0001 thru 1101 \u2013 Control state is One of Droop Setting 1 through 13 (in sequential order) \\r\\n1110 \u2013  SAE reserved\\r\\n1111 \u2013  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2895":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":28,"SPN":2895,"SPN_Name":"Engine Droop Auxiliary Input Select State","SPN_Description":"In some off-highway applications it may be desirable to have multiple droop settings available across the range of engine operation.  For example, in an agricultural tractor application, this functionality allows a higher engine speed during low load so as to maximize vehicle speed driven between fields on the road. Another use of the alternate droop settings would be to provide functionality for maintaining an engine speed independent of the applied load on demand. There is a normal droop setting, and up to 13 additional preprogrammed droop settings which are user selectable by switching.  The selections apply to Auxiliary Input.\\r\\n\\r\\n0000 \u2013 Control state is Normal Droop Setting\\r\\n0001 thru 1101 \u2013 Control state is One of Droop Setting 1 through 13 (in sequential order)\\r\\n1110 \u2013  SAE reserved\\r\\n1111 \u2013  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2896":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":0,"SPN":2896,"SPN_Name":"Engine Auxiliary Governor State","SPN_Description":"This is the Engine Auxiliary Governor feature. This feature is used to allow engine speed to be controlled by an auxiliary input such as pressure or tailshaft speed. This feature is requested by an operator switch, this parameter indicates the state of the feature as determined by the controlling ECM.\\r\\n\\r\\n00 \u2013 Control State is Auxiliary Governor disabled\\r\\n01 \u2013 Control State is Auxiliary Governor enabled\\r\\n10 \u2013 SAE reserved\\r\\n11 \u2013 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2897":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":56,"SPN":2897,"SPN_Name":"Operator Engine PTO Governor Memory Select Switch","SPN_Description":"Measured state of the operator\u2019s engine PTO governor memory select switch. This switch selects which of the two available memory locations is to be used to store the dynamically assigned value. This speed will be set using the PTO governor set switch and modified using the PTO governor accelerate and coast/decelerate switches.\\r\\n\\r\\n00 PTO set speed memory 1 selected\\r\\n01 PTO set speed memory 2 selected\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2898":{"PGN":64966,"PGN_Name":"Cold Start Aids","PGN_Description":"CSA","first_bit":12,"SPN":2898,"SPN_Name":"Engine Start Enable Device 2 Configuration","SPN_Description":"The start enable device installed for start enable device 2.\\r\\n\\r\\n0000 - no start enable device 2 installed\\r\\n0001 - glow plugs installed\\r\\n0010 - fuelled start installed\\r\\n0011 - ether injection installed\\r\\n0100 - electric intake air heater installed\\r\\n0101 - 1110 - reserved\\r\\n1111 - not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2899":{"PGN":64966,"PGN_Name":"Cold Start Aids","PGN_Description":"CSA","first_bit":8,"SPN":2899,"SPN_Name":"Engine Start Enable Device 1 Configuration","SPN_Description":"The start enable device installed for start enable device 1.\\r\\n\\r\\n0000 - no start enable device 1 installed\\r\\n0001 - glow plugs installed\\r\\n0010 - fuelled start installed\\r\\n0011 - ether injection installed\\r\\n0100 - electric intake air heater installed\\r\\n0101 - 1110 - reserved\\r\\n1111 - not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2900":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":12,"SPN":2900,"SPN_Name":"Transmission Engine Crank Enable","SPN_Description":"State signal from the transmission indicating if the transmission\u2019s status is such that engine cranking is allowed (i.e.  at a minimum, transmission is in neutral and the driveline is disengaged).  As sender of this information, the transmission is responsible for correct indication immediately upon first broadcast of this parameter.  \\r\\n\\r\\nAs with hard-wired neutral start implementations, those utilizing this parameter should consider the impact of the transmission or other controllers \u2018resetting\u2019 due to voltage drops during the engine start sequence.\\r\\n\\r\\nThe vehicle system design should also consider the impact of timing latency in the engine starting sequence.  For example, the turn of an ignition key from \u2018off\u2019 to \u2018start\u2019 may happen more quickly than the transmission controller can boot up, determine its\u2019 current state of being, and begin broadcasting information over the J1939 datalink. \\r\\n\\r\\n00 - Cranking disabled; engine cranking is prohibited by the transmission\\r\\n01 - Cranking enabled; engine cranking is allowed by the transmission\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2911":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":58,"SPN":2911,"SPN_Name":"Halt brake switch","SPN_Description":"Switch signal which indicates the position of the halt brake switch.\\r\\n\\r\\n00    Halt brake switch passive\\r\\n01    Halt brake switch active\\r\\n10    Error\\r\\n11    Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2912":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":5,"SPN":2912,"SPN_Name":"Hill holder mode","SPN_Description":"Signal which indicates the current mode of the hill holder function.\\r\\n\\r\\n000            Inactive\\r\\n001            Active\\r\\n010            Active, but will change to inactive in a short time.  (This mode may be used to warn the driver)\\r\\n011            Active, but may activate parking brake if needed.\\r\\n100            Reserved\\r\\n101            Reserved\\r\\n110            Hill holder not functional\\r\\n111            Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"2913":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":2,"SPN":2913,"SPN_Name":"Halt brake mode","SPN_Description":"Signal which indicates the current mode of the halt brake function.\\r\\n\\r\\n000            Inactive\\r\\n001            Active\\r\\n010            Active, but not functioning properly.  (This mode may be used to warn the driver)\\r\\n011 - 101  Not defined\\r\\n110            Halt brake not functional\\r\\n111            Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"2914":{"PGN":1024,"PGN_Name":"External Brake Request","PGN_Description":"XBR","first_bit":16,"SPN":2914,"SPN_Name":"XBR EBI Mode","SPN_Description":"The XBR EBI (Endurance Brake Integration) Mode is used as an input for the brake system to prescribe the use of endurance brakes like retarders or engine brakes.\\r\\n\\r\\n00 - No Endurance Brake Integration allowed\\r\\nThe demanded acceleration must be realized by the brake system by using only the foundation brakes. During an active XBR request, the brake system must not actively demand brake torque from other braking devices like retarders or engine brakes.\\r\\n01 - Only Endurance Brakes allowed\\r\\nThe demanded acceleration must be realized by the brake system by demanding brake torque from other brake devices like retarders or engine brakes. The foundation brake itself must not be used (e.g. to reduce brake lining wear).\\r\\n10 - Endurance Brake Integration allowed\\r\\nThe demanded acceleration may be realized by the brake system by using the foundation brakes and/or by demanding brake torque from other brake devices like retarders or engine brakes.\\r\\n11 - Not defined","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2915":{"PGN":1024,"PGN_Name":"External Brake Request","PGN_Description":"XBR","first_bit":18,"SPN":2915,"SPN_Name":"XBR Priority","SPN_Description":"The XBR Priority is used as an input to the brake system to manage the priority of overlapping external and internal requests.\\r\\n\\r\\n00 - Highest priority \u2013 used for emergency situations, e.g. for future Collision Avoidance System.  This mode overrides any brake protection measures of the brake system.\\r\\n01 - High priority \u2013 not defined\\r\\n10 - Medium priority \u2013 used for ACC-Systems. This mode does not override brake protection measures of the brake system.\\r\\n11 - Low priority \u2013 used in \u201Doverride disabled\u201D XBR Control Mode","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2916":{"PGN":1024,"PGN_Name":"External Brake Request","PGN_Description":"XBR","first_bit":20,"SPN":2916,"SPN_Name":"XBR Control Mode","SPN_Description":"The XBR Control Mode is used as an input to the brake system and defines how the external acceleration demand has to be realized.\\r\\n\\r\\n00 - Override disabled \u2013 Disable any existing control commanded by the source of this command.\\r\\n01 - Acceleration control with addition mode - Add the XBR acceleration demand to the driver\u2019s acceleration demand.\\r\\n10 - Acceleration control with maximum mode - Execute the XBR acceleration demand if it is higher than the driver\u2019s acceleration demand.\\r\\n11 - Not defined","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2917":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":10,"SPN":2917,"SPN_Name":"XBR System State","SPN_Description":"This parameter indicates which external brake control is allowed.\\r\\n\\r\\n00 - Any external brake demand will be accepted (brake system fully operational)\\r\\n01 - Only external brake demand of highest XBR Priority (00) will be accepted  (e.g. because the temperature limit of the brake system is exceeded)\\r\\n10 - No external brake demand will be accepted (e.g. because of fault in brake system)\\r\\n11 - not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2918":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":12,"SPN":2918,"SPN_Name":"XBR Active Control Mode","SPN_Description":"This parameter indicates which XBR Control Mode is executed by the brake system.\\r\\n\\r\\n0000                No brake demand being executed (default mode)\\r\\n0001                Driver\'s brake demand being executed, no external brake demand\\r\\n0010                Addition mode of XBR acceleration control being executed\\r\\n0011                Maximum mode of XBR acceleration control being executed\\r\\n0100 - 1110    Reserved for SAE assignment\\r\\n1111                Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2919":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":8,"SPN":2919,"SPN_Name":"Foundation Brake Use","SPN_Description":"This parameter indicates if the brake system presently uses the foundation brakes.\\r\\n\\r\\n00   Foundation brakes not in use\\r\\n01   Foundation brakes in use\\r\\n10   Reserved\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2920":{"PGN":1024,"PGN_Name":"External Brake Request","PGN_Description":"XBR","first_bit":0,"SPN":2920,"SPN_Name":"External Acceleration Demand","SPN_Description":"Parameter provided to the brake system from external sources. This is the acceleration which the brake system is expected to realize. It is specified as an absolute acceleration in reference to the road.  Positive values lead to increasing vehicle speed, negative values lead to decreasing vehicle speed.  Note: Normally only the negative data range is used, but e.g. in case of downhill driving also positive values are possible.","bit_length":16,"scaling":0.00048828125,"offset":-15.687,"unit":"m/s\xb2","SLOT_ID":115},"2921":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":16,"SPN":2921,"SPN_Name":"XBR Acceleration Limit","SPN_Description":"The brake system may temporarily or generally limit the maximum brake performance available for external systems. A temporary limit may be nessary due to high brake temperature; a general limit may be defined by the vehicle manufacturer, e.g. a value of -2.5 m/s\xb2 due to liability reasons. The actual limit is communicated to the external systems that request braking. The limit is only effective in the XBR Priorities 01 to 11. It is specified as an absolute acceleration in reference to the road.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"m/s\xb2","SLOT_ID":140},"2922":{"PGN":61451,"PGN_Name":"Electronic Steering Control","PGN_Description":"ESC1","first_bit":28,"SPN":2922,"SPN_Name":"Steerable Lift Axle Lowering Inhibit","SPN_Description":"A signal which indicates if lowering of lifted axle is allowed or inhibited.\\r\\n\\r\\n00      Lowering allowed\\r\\n01      Lowering inhibited\\r\\n10      Reserved\\r\\n11      Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2923":{"PGN":61451,"PGN_Name":"Electronic Steering Control","PGN_Description":"ESC1","first_bit":24,"SPN":2923,"SPN_Name":"Status of Steering Axle","SPN_Description":"A signal which indicates different states of the steering axle\\r\\n\\r\\n0000               Axle steering not active (adhesion steering)\\r\\n0001               Axle steering active\\r\\n0010               Axle centered\\r\\n0011               Axle centered, because of an error\\r\\n0100               Axle not active because of an error (adhesion steering)\\r\\n0101               Axle steering in special mode (diagnosis, calibration mode)\\r\\n0110-1110     Reserved for SAE Assignment\\r\\n1111               Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2924":{"PGN":61451,"PGN_Name":"Electronic Steering Control","PGN_Description":"ESC1","first_bit":32,"SPN":2924,"SPN_Name":"Steering Type","SPN_Description":"Indicates the different types of steering systems (ref. ECE Regulation 79 paragraph 2.5)\\r\\n\\r\\n0000             Main steering system\\r\\n0001             Auxiliary steering equipment\\r\\n0010-1110   Reserved for Assignment by SAE\\r\\n1111             Not Available\\r\\n\\r\\n\\r\\n0000    Main steering system - The steering equipment of a vehicle which is mainly responsible for determining the direction of travel.\\r\\n\\r\\n0001    Auxiliary steering equipment - A system in which the wheels on axle(s) of vehicles of categories M and N are steered in addition to the wheels of the main steering equipment in the same or opposite direction to those of the main steering equipment and/or the steering angle of the front and/or the rear wheels may be adjusted relative to vehicle behaviour.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2925":{"PGN":61451,"PGN_Name":"Electronic Steering Control","PGN_Description":"ESC1","first_bit":36,"SPN":2925,"SPN_Name":"Type of Steering Forces","SPN_Description":"Type of Steering Forces (Ref. ECE Regulation 79 paragraph 2.5)\\r\\n\\r\\n0000             Manual steering equipment\\r\\n0001             Power assisted steering equipment\\r\\n0010             Full power steering equipment\\r\\n0011             Self tracking steering equipment\\r\\n0100-1110   Reserved for SAE assignment\\r\\n1111             Not Available\\r\\n\\r\\n0000  Manual steering equipment - The steering forces result solely from the muscular effort of the driver.\\r\\n0001  Power assisted steering equipment - The steering forces result from both the muscular effort of the driver and the energy supply or supplies.\\r\\n0010  Full power steering equipment - The steering forces are provided solely by one or more energy supplies.\\r\\n0011  Self tracking steering equipment - A system designed to create a change of steering angle on one or more wheels only when acted upon by forces and/or moments applied through the tire to road contact.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2926":{"PGN":61451,"PGN_Name":"Electronic Steering Control","PGN_Description":"ESC1","first_bit":40,"SPN":2926,"SPN_Name":"Type of Steering Transmission","SPN_Description":"Type of Steering Transmission (Ref. ECE Regulation 79 paragraph 2.6)\\r\\n\\r\\n0000             Purely mechanical steering transmission\\r\\n0001             Purely hydraulic steering transmission\\r\\n0010             Purely electric steering transmission\\r\\n0011             Hybrid steering transmission\\r\\n0100-1110   Reserved for SAE assignment\\r\\n1111             Not available\\r\\n\\r\\n0000    Purely mechanical steering transmission - A steering transmission in which the steering forces are transmitted entirely by mechanical means.\\r\\n0001    Purely hydraulic steering transmission - A steering transmission in which the steering forces, somewhere in the transmission, are transmitted only by hydraulic means.\\r\\n0010    Purely electric steering transmission - A steering transmission in which the steering forces, somewhere in the transmission, are transmitted only through electric means.\\r\\n0011    Hybrid steering transmission - A steering transmission in which part of the steering forces is transmitted through one and the other part through another of the above mentioned means.  However, in the case where any mechanical part of the transmission is designed only to give position feedback and is too weak to transmit the total sum of the steering forces, this system shall be considered to be purely hydraulic or purely electric steering transmission.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"2927":{"PGN":61451,"PGN_Name":"Electronic Steering Control","PGN_Description":"ESC1","first_bit":0,"SPN":2927,"SPN_Name":"Actual Inner wheel steering angle","SPN_Description":"Signal which indicates the actual inner wheel steering angle.  The steering angle is the angle of wheel turn relative to the vehicle x-axis (yaw angle of inner wheel). See Figure SPN2927_A for explanation of positive and negative angles.  This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.","bit_length":16,"scaling":0.00390625,"offset":-125,"unit":"deg","SLOT_ID":136},"2928":{"PGN":61451,"PGN_Name":"Electronic Steering Control","PGN_Description":"ESC1","first_bit":16,"SPN":2928,"SPN_Name":"Axle Location","SPN_Description":"To identify to which of several similar devices (such as tires or fuel tanks) the information applies.\\r\\n\\r\\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\\r\\n\\r\\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire pressure for location 0x00 would be left front tire.\\r\\n\\r\\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"2930":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":24,"SPN":2930,"SPN_Name":"Hydraulic Brake System Audible Warning Command","SPN_Description":"Signal which commands an audible warning by the hydraulic braking system.\\r\\n\\r\\n00       Audible warning off\\r\\n01       Audible warning on\\r\\n10       Reserved\\r\\n11       Don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2931":{"PGN":64998,"PGN_Name":"Hydraulic Braking System","PGN_Description":"HBS","first_bit":26,"SPN":2931,"SPN_Name":"Hydraulic Brake Fluid Level Switch","SPN_Description":"Signal which indicates whether the hydraulic fluid level in the reservoir(s) is sufficient.\\r\\n\\r\\n00      Fluid level is not sufficient\\r\\n01      Fluid level is sufficient\\r\\n10      Error indicator\\r\\n11      Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2945":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":10,"SPN":2945,"SPN_Name":"Active Shift Console Indicator","SPN_Description":"Signal from transmission control unit indicating which shift console (primary or secondary) it currently considers as the active shift selector input.\\r\\n\\r\\n00        Primary shift console is active\\r\\n01        Secondary shift console is active\\r\\n10        Reserved\\r\\n11        Not available\\r\\n\\r\\nNote:  In some applications such as refuse trucks, the transmission can be operated from two positions in the vehicle.  The transmission control unit will accept changes in transmission requested gear (SPN 525) from the operator only from the active shift console.  The transmission control unit determines which shift console is active based on a switch input controlled by the operator and transmission system state criteria.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2948":{"PGN":64961,"PGN_Name":"Engine Fluid Level/Pressure 3","PGN_Description":"EFL/P3","first_bit":0,"SPN":2948,"SPN_Name":"Engine Intake Valve Actuation System Oil Pressure","SPN_Description":"The gage pressure of the oil in the hydraulic system that powers the engine intake valve actuation system","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"2970":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":6,"SPN":2970,"SPN_Name":"Accelerator Pedal 2 Low Idle Switch","SPN_Description":"Switch signal which indicates the state of the accelerator pedal 2 low idle switch.  The low idle switch is defined in SAE J1843.\\r\\n\\r\\n00    Accelerator pedal 2 not in low idle condition\\r\\n01    Accelerator pedal 2 in low idle condition\\r\\n10    Error\\r\\n11    Not available\\r\\n\\r\\nNote:  Also refer to SPN 558 Accelerator Pedal 1 Low Idle Switch and SPN 2971 Accelerator Pedal 3 Low Idle Switch.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2978":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":32,"SPN":2978,"SPN_Name":"Estimated Engine Parasitic Losses - Percent Torque","SPN_Description":"The calculated torque that indicates the estimated amount of torque loss due to engine parasitics, such as cooling fan, air compressor, air conditioning, etc. It is expressed as a percent of Engine Reference Torque.  \\r\\n\\r\\nIf there are multiple devices on a network that provide this parameter, then users of this data shall add each of these values to determine the total torque loss due to engine parasitics.  Devices that provide this parameter shall use the value of Engine Reference Torque transmitted by the engine during the current key cycle to determine the percent torque loss as seen by the engine.\\r\\n\\r\\nWhen the data value of this parameter is equal to 0xFB it means that all parasitic losses calculated by the engine are included in the Engine\'s Nominal Friction Percent Torque (SPN 514).\\r\\n\\r\\nNote:  Refer to section 5.2.1 in SAE J1939-71.\\r\\n\\r\\nNote: Beginning in 2016,  HD-OBD requires reporting of engine torque to Portable Emissions Measurement System (PEMS) equipment that is representative of torque as measured by the engine dynamometer during the emissions certification process. Therefore, for applications that are subject to HD-OBD regulations in 2016 or later, estimated parasitic losses shall no longer be included in SPN 514 Nominal Friction - Percent Torque and must be included in SPN 2978 Estimated Engine Parasitic Losses - Percent Torque.\\r\\n\\r\\nSee SPN 7837 for alternate resolution.  If both SPN 2978 and SPN 7837 are supported by a single source address, consumers of the parasitic data should only use one of these values.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"2979":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":40,"SPN":2979,"SPN_Name":"Vehicle Acceleration Rate Limit Status","SPN_Description":"Status (active or not active) of the system used to limit maximum forward vehicle acceleration.\\r\\n\\r\\n00     Limit not active\\r\\n01     Limit active\\r\\n10     Reserved\\r\\n11     Not available\\r\\n\\r\\nNOTE:  The effects of emission control limits, such as engine exhaust smoke control, are specifically excluded; they are not considered to be part of a function to limit vehicle acceleration.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2980":{"PGN":65163,"PGN_Name":"Gaseous Fuel Pressure 1","PGN_Description":"GFP1","first_bit":48,"SPN":2980,"SPN_Name":"Engine Fuel Valve 1 Outlet Absolute Pressure","SPN_Description":"Absolute Pressure of gas on outlet side of the first or only fuel system control valve.  See SPN 3469 for the second fuel control valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"2983":{"PGN":65195,"PGN_Name":"Electronic Transmission Controller 6","PGN_Description":"ETC6","first_bit":24,"SPN":2983,"SPN_Name":"Clutch Life Remaining","SPN_Description":"Signal which indicates the actual clutch life remaining in percent. One hundred percent means the clutch is brand new and zero percent means the clutch is at the end of its life.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"2984":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":0,"SPN":2984,"SPN_Name":"Automatic traction help (load transfer)","SPN_Description":"This signal enables the traction help (load transfer) in case of an active ASR function\\r\\n\\r\\n00   Disable automatic traction help \\r\\n01   Enable automatic traction help \\r\\n10   Reserved\\r\\n11   Don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2985":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":54,"SPN":2985,"SPN_Name":"Transmission Shift Selector Display Mode Switch","SPN_Description":"Status of the operator\u2019s switch used to \u2018toggle\u2019 through multiple display modes of a shift selector display.  \\r\\n\\r\\nWhen a shift selector display is capable of displaying more than just range information, this switch is toggled by the operator to move through the different display modes.   If the selector has only two display modes, this switch may behave as a typical SPST switch.  If the selector has more than two display modes, the switch may be momentary, where each activation indicates that the selector has scrolled through to the next subsequent display mode. \\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"2986":{"PGN":65129,"PGN_Name":"Engine Temperature 3","PGN_Description":"ET3","first_bit":32,"SPN":2986,"SPN_Name":"Engine Intake Valve Actuation System Oil Temperature","SPN_Description":"The temperature of the oil in the hydraulic system that powers the intake valve actuation system.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3026":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":60,"SPN":3026,"SPN_Name":"Transmission Oil Level 1 Measurement Status","SPN_Description":"Measurement status for the first instance of a transmission oil level indicator.  Indicates if conditions are acceptable to obtain a valid transmission oil level measurement as conveyed in SPN 124 Transmission Oil Level or SPN 3027 Transmission Oil Level 1 High / Low.  If conditions are not acceptable, this parameter conveys to the operator what prevents conditions from being acceptable.  Only one condition can be conveyed in this parameter at any given point in time.  If multiple conditions exist, it is not important which condition is actually broadcast, as the driver must \u2018correct\u2019 each and every condition as it is presented before a valid oil level reading can be made.  If multiple conditions exist that prevent a valid reading, the sender should broadcast one of those conditions until it is corrected; then the next condition can be conveyed to the operator, and so on.\\r\\n\\r\\n0000 Conditions valid for transmission oil level measurement\\r\\n0001 Conditions not valid \u2013 Settling timer still counting down\\r\\n0010 Conditions not valid \u2013 Transmission in gear\\r\\n0011 Conditions not valid \u2013 Transmission fluid temperature too low\\r\\n0100 Conditions not valid \u2013 Transmission fluid temperature too high\\r\\n0101 Conditions not valid \u2013 Vehicle moving; output shaft speed too high\\r\\n0110 Conditions not valid \u2013 Vehicle not level\\r\\n0111 Conditions not valid \u2013 Engine speed too low\\r\\n1000 Conditions not valid \u2013 Engine speed too high\\r\\n1001 Conditions not valid \u2013 No request for reading\\r\\n1010 Not defined\\r\\n1011 Not defined\\r\\n1100 Not defined\\r\\n1101 Conditions not valid - Other\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3027":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":48,"SPN":3027,"SPN_Name":"Transmission Oil Level 1 High / Low","SPN_Description":"First instance of a transmission oil level indicator. Conveys the amount of current volume of transmission sump oil compared to recommended volume. Positive values indicate overfill. Zero means the transmission fluild is filled to the recommended level.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid fluid level measurement.","bit_length":8,"scaling":0.5,"offset":-62.5,"unit":"l","SLOT_ID":225},"3028":{"PGN":65272,"PGN_Name":"Transmission Fluids 1","PGN_Description":"TRF1","first_bit":56,"SPN":3028,"SPN_Name":"Transmission Oil Level 1 Countdown Timer","SPN_Description":"Countdown timer for the first instance of a transmission oil level indicator.  Once all vehicle conditions (such as vehicle stopped, etc) are met, some transmissions may require a \u2018settling time\u2019 to allow the fluid level to normalize.  This parameter indicates how much of the required settling time remains.  When time reaches 0, a valid oil level measurement value will be broadcast in SPN 3027 Transmission Oil Level 1 High / Low.\\r\\n\\r\\n0000 less than 1 minute\\r\\n0001 One minute\\r\\n0010 Two minutes\\r\\n0011 Three minutes\\r\\n0100 Four minutes\\r\\n0101 Five minutes\\r\\n0110 Six minutes\\r\\n0111 Seven minutes\\r\\n1000 Eight minutes\\r\\n1001 Nine minutes\\r\\n1010 Ten minutes\\r\\n1011 Eleven minutes\\r\\n1100 Twelve minutes\\r\\n1101 Thirteen minutes\\r\\n1110 Error\\r\\n1111 Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3030":{"PGN":61452,"PGN_Name":"Electronic Transmission Controller #8","PGN_Description":"ETC8","first_bit":0,"SPN":3030,"SPN_Name":"Transmission Torque Converter Ratio","SPN_Description":"Ratio of the transmissions torque converter output torque to torque converter input torque at current speed.\\r\\n\\r\\nThe ratio of 1.000 ( 03 E8 hex ) indicates torque converter lockup.\\r\\nIf the ratio is less than 1 and the ratio can not be properly determined it shall be set to a value of FB00 hex.\\r\\nRatios above 1 indicate torque converter multiplication.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"3031":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":8,"SPN":3031,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Temperature 1","SPN_Description":"Temperature of the diesel exhaust fluid in the storage tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"3043":{"PGN":64960,"PGN_Name":"Passenger Counter","PGN_Description":"TR7","first_bit":0,"SPN":3043,"SPN_Name":"Type of Passenger Count","SPN_Description":"Used to notify transit link devices of the type of passenger counting system used in the vehicle.  Some passenger counting systems indicate real-time boarding and exiting data for other devices to accumulate. Other types of passenger counters report a current on-board total relative to a transit door status,  a fare collection status, or other signal which can define the end of the boarding/exiting period and a stable underway totalized passenger count.\\r\\n\\r\\n0 - absolute passenger count\\r\\n1 - boarding passenger\\r\\n2 - exiting passenger\\r\\n3 - boarding passenger (second passenger stream)\\r\\n4 - exiting passenger (second passenger stream)\\r\\n5 to 250 - reserved for future assignment\\r\\n251 to 253 - reserved\\r\\n254 - error indicator\\r\\n255 - not available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3044":{"PGN":64960,"PGN_Name":"Passenger Counter","PGN_Description":"TR7","first_bit":16,"SPN":3044,"SPN_Name":"Silent Alarm Status","SPN_Description":"Used to report silent alarm push button status.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error condition\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3045":{"PGN":64960,"PGN_Name":"Passenger Counter","PGN_Description":"TR7","first_bit":18,"SPN":3045,"SPN_Name":"Vehicle Use Status","SPN_Description":"Used to indicate the proper or unauthorized use of the vehicle. The administrative control device or any device issuing the vehicle use status PID should be sensitive to the run switch status (SPN 3046) and any other locally defined criteria for authorized use (i.e., driver log-ons) before the vehicle use status PID is used to generate an unauthorized use alarm.\\r\\n\\r\\n00 - Normal use\\r\\n01 - Unauthorized use\\r\\n10 - Error condition\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3046":{"PGN":64960,"PGN_Name":"Passenger Counter","PGN_Description":"TR7","first_bit":20,"SPN":3046,"SPN_Name":"Transit Run Status","SPN_Description":"Status of the run switch for the vehicle.\\r\\n\\r\\n00 - Off\\r\\n01- On\\r\\n10 - Error condition\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3047":{"PGN":64960,"PGN_Name":"Passenger Counter","PGN_Description":"TR7","first_bit":8,"SPN":3047,"SPN_Name":"Patron Count","SPN_Description":"Count of the number of passengers on a transit vehicle.  If the type of passenger count (SPN 3043) is 0, the patron count indicates the number of patrons currently on vehicle after the door has closed.  If the type of passenger count is 1 to 4, \\r\\nthe patron count indicates an incremental count of passengers since the last data transmittal.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"3070":{"PGN":64959,"PGN_Name":"Transit Milepost","PGN_Description":"TR2","first_bit":0,"SPN":3070,"SPN_Name":"Number of bytes in the Milepost Identification","SPN_Description":"Number of bytes in the Milepost Identification.  This parameter identifies the length, in bytes, of the data in SPN 509 (Milepost Identification).","bit_length":8,"scaling":1,"offset":0,"unit":"byte","SLOT_ID":239},"3071":{"PGN":64958,"PGN_Name":"Transit Route","PGN_Description":"TR1","first_bit":8,"SPN":3071,"SPN_Name":"Number of bytes in the Transit Assigned Route Identity","SPN_Description":"Number of bytes in the Transit Assigned Route Identity.  This parameter identifies the length, in bytes, of the data in SPN 3074 (Transit Assigned Route Identity).","bit_length":8,"scaling":1,"offset":0,"unit":"byte","SLOT_ID":239},"3072":{"PGN":64958,"PGN_Name":"Transit Route","PGN_Description":"TR1","first_bit":16,"SPN":3072,"SPN_Name":"Number of bytes in the Transit Assigned Run Identity","SPN_Description":"Number of bytes in the Transit Assigned Run Identity.  This parameter identifies the length, in bytes, of the data in SPN 3075 (Transit Assigned Run Identity).","bit_length":8,"scaling":1,"offset":0,"unit":"byte","SLOT_ID":239},"3073":{"PGN":64958,"PGN_Name":"Transit Route","PGN_Description":"TR1","first_bit":24,"SPN":3073,"SPN_Name":"Number of bytes in the Transit Assigned Block Identity","SPN_Description":"Number of bytes in the Transit Assigned Block Identity.  This parameter identifies the length, in bytes, of the data in SPN 3076 (Transit Assigned Block Identity).","bit_length":8,"scaling":1,"offset":0,"unit":"byte","SLOT_ID":239},"3078":{"PGN":64958,"PGN_Name":"Transit Route","PGN_Description":"TR1","first_bit":0,"SPN":3078,"SPN_Name":"Agency","SPN_Description":"The identity of the agency involved in this transaction","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"3079":{"PGN":64957,"PGN_Name":"Signal Preemption","PGN_Description":"TR3","first_bit":6,"SPN":3079,"SPN_Name":"Intersection Preemption Request/Response","SPN_Description":"Status of the intersection signal preemption\\r\\n\\r\\n00 - Message is a request directed to the emitter\\r\\n01 - Message is a response from the emitter\\r\\n10 - Error condition\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3080":{"PGN":64957,"PGN_Name":"Signal Preemption","PGN_Description":"TR3","first_bit":4,"SPN":3080,"SPN_Name":"Transit Route ID Usage","SPN_Description":"Transit route ID usage\\r\\n\\r\\n00 - Transit route ID not used for interleaved data\\r\\n01 - Transit route ID used for interleaved data (if range code not enabled)\\r\\n10 - Error condition\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3081":{"PGN":64957,"PGN_Name":"Signal Preemption","PGN_Description":"TR3","first_bit":2,"SPN":3081,"SPN_Name":"Range Code Enable","SPN_Description":"Range code enable\\r\\n\\r\\n00 - Range code not used for interleaved data\\r\\n01 - Range code used for interleaved data\\r\\n10 - Error condition\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3082":{"PGN":64957,"PGN_Name":"Signal Preemption","PGN_Description":"TR3","first_bit":14,"SPN":3082,"SPN_Name":"Strobe Activation Control Status","SPN_Description":"Strobe activation control status\\r\\n\\r\\n00 - Deactivate strobe\\r\\n01 - Activate strobe\\r\\n10 - Error condition\\r\\n11 - Not available\\r\\n\\r\\nNote: Strobe will flash if not overridden by transit door status, strobe is working, and emitter is in the normal mode.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3083":{"PGN":64957,"PGN_Name":"Signal Preemption","PGN_Description":"TR3","first_bit":12,"SPN":3083,"SPN_Name":"Transit Door Enable","SPN_Description":"Transit door enable\\r\\n\\r\\n00 - Ignore transit door status\\r\\n01 - Transit door status will override strobe activation\\r\\n10 - Error condition\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3084":{"PGN":64957,"PGN_Name":"Signal Preemption","PGN_Description":"TR3","first_bit":8,"SPN":3084,"SPN_Name":"Priority of Response Sent by Emitter","SPN_Description":"Priority of response sent by emitter\\r\\n\\r\\n0000               - Reserved\\r\\n0001               - Low priority\\r\\n0010               - Probe priority\\r\\n0011               - High priority\\r\\n0100 to 1000 - Reserved\\r\\n1001               - Priority set by hardware to low priority\\r\\n1010               - Priority set by hardware to probe priority\\r\\n1011               - Priority set by hardware to high priority\\r\\n1100 to 1101 - Reserved\\r\\n1110               - Error condition\\r\\n1111               - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3085":{"PGN":64957,"PGN_Name":"Signal Preemption","PGN_Description":"TR3","first_bit":16,"SPN":3085,"SPN_Name":"Vehicle ID","SPN_Description":"Numerical designation of the vehicle.   65535 is used to represent the vehicle ID is not available.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":208},"3086":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":8,"SPN":3086,"SPN_Name":"Transmission Ready for Brake Release","SPN_Description":"This parameter indicates that enough torque / motive force is available at the transmission output shaft to release all the brakes without a risk of unintentional movement in the opposite direction.\\r\\n\\r\\n00 - Transmission Not Ready for Brake Release\\r\\n01 - Transmission Ready for Brake Release\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3087":{"PGN":65164,"PGN_Name":"Auxiliary Analog Information","PGN_Description":"AAI","first_bit":32,"SPN":3087,"SPN_Name":"Auxiliary Level","SPN_Description":"Level measured by a sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"3156":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":0,"SPN":3156,"SPN_Name":"Blade Control Mode Switch","SPN_Description":"Indicates the blade control mode switch state the user has set for the land leveling system.  The switch value directly correlates to the current switch state, regardless of the switch being used.  This parameter is intended for use in systems using only one parameter to control the blade movement (i.e. elevation).  Systems using two independent parameters to control blade position, i.e. one blade edge maintains a constant elevation and the other blade edge maintains a constant blade angle, should use parameters specific to that usage. Only one of the following states will be active at a time.   Below are the data values defined for each switch type that may be used in this application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  Toggle button usage is as follows:\\r\\n        Manual Position  = 0010 Manual button pressed\\r\\n        Auto Position       = 0011 Automatic button pressed\\r\\n\\r\\n2.   The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.  Momentary rocker button usage is as follows:\\r\\n        No Button Pressed = 0000 No button pressed\\r\\n        Manual Button Pressed  = 0010 Manual button pressed\\r\\n        Auto Button Pressed  = 0011 Automatic button pressed\\r\\n\\r\\n3.    The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.  Momentary contact buttons (button pair) usage is as follows:\\r\\n\\r\\n        No Button Pressed = 0000 No button pressed\\r\\n        Manual Button Pressed  = 0010 Manual button pressed\\r\\n        Auto Button Pressed  = 0011 Automatic button pressed\\r\\n\\r\\n4.    The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  When the button is pressed, the \\"mode button pressed\\" state is reported and the receiving controller then changes the current mode to its opposite value (i.e. manual to automatic or vise-versa).  Momentary contact button (single button) usage is as follows:\\r\\n\\r\\n        No Button Pressed = 0000 No button pressed\\r\\n        Button Pressed  = 0001 Mode button pressed\\r\\n\\r\\nData Values and Descriptions:\\r\\n\\r\\n0000 No button pressed\\r\\n0001 Mode button pressed\\r\\n0010 Manual button pressed\\r\\n0011 Automatic button pressed\\r\\n1110 Error Indicator\\r\\n1111 Not Installed\\r\\nAll other values are reserved\\r\\n\\r\\nNotes:\\r\\n1.   The switch state can be read in two ways.  One method uses the direct analog switch input to determine the switch state, while the second method relies on a secondary control to read the analog input, then relay the information on the data link.  The parameter is designed to provide the actual switch state to other controls that need the information.\\r\\n2.   Other systems with automated blade controls should be able to use this parameter, since it is a measured switch value.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3157":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":4,"SPN":3157,"SPN_Name":"Desired Grade Offset Switch","SPN_Description":"Indicates the grade offset switch state the user has set for the land leveling system.  The desired grade offset value is the vertical offset measured from a given elevation reference point to the bottom edge of the blade.  This parameter is intended for use in systems using only elevation offset to control the blade movement (i.e. elevation).  Systems using two independent parameters to control blade position, i.e. one edge maintains a constant elevation and the other blade edge maintains a constant angle, should use parameters specific to that usage. Only one of the following states will be active at a time.   Below are the data values defined for each switch type that may be used in this application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1.  The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the no button pressed position.  Momentary rocker button usage is as follows:\\r\\n\\r\\n     No Button Pressed = 0000 No button pressed\\r\\n     Increment Button Pressed  = 0001 Increment button pressed\\r\\n     Decrement Button Pressed  = 0010 Decrement button pressed\\r\\n\\r\\n2.  The momentary contact button pair may be used, where the default is the no buttons pressed position.  The user can press the increment button, and when pressure is released, it will return to the no buttons pressed position.  The user may press the decrement button, and when pressure is released, it will return to the no buttons pressed position.  Momentary contact button (button pair) usage is as follows:\\r\\n\\r\\n     No Button Pressed = 0000 No button pressed\\r\\n     Increment Button Pressed  = 0001 Increment button pressed\\r\\n     Decrement Button Pressed  = 0010 Decrement button pressed\\r\\n\\r\\nData Values and Descriptions:\\r\\n0000 No button pressed\\r\\n0001 Increment button pressed\\r\\n0010 Decrement button pressed\\r\\n1110 Error Indicator\\r\\n1111 Not installed\\r\\nAll other values are reserved\\r\\n\\r\\nNotes:\\r\\n\\r\\n1.   The switch state can be read in two ways.  One method uses the direct analog switch input to determine the switch state, while the second method relies on a secondary control to read the analog input, then relay the information on the data link.  The parameter is designed to provide the actual switch state to other controls that need the information.\\r\\n2.   Other systems with automated blade controls should be able to use this parameter, since it is a measured switch value.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3158":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":8,"SPN":3158,"SPN_Name":"Blade Auto Mode Command","SPN_Description":"Allows other controllers to command to the primary control system what they think is the appropriate auto control mode to be engaged in, based on the information they have available to them.  When in automatic mode, the blade automatically adjusts its position to the center of the blade to maintain a desired grade offset.  Only one of the following states will be active at a time.  Below is extended information describing each command.  The purpose of this information is to define what command state should be reported based on what auto control mode command is deemed appropriate by the operational specifications of the system.\\r\\n\\r\\n   0000 Auto Allowed - Auto mode permitted as appropriate (auto button was pushed or directly returned from Suspend Auto condition)\\r\\n   0001 Activity Allows Auto - Auto mode permitted only if the primary control system detects operator activity.  The control issuing this command does not have sufficient information/reason to absolutely allow Auto mode (state 0000) or not allow Auto mode (state 0100).  The control issuing this command is permitting the primary control system to operate in auto mode only if the primary control system detects operator activity, such as direct input to the primary control system.  If the primary control system does not detect operator activity, then the control issuing this command is not allowing auto mode. For example, the control issuing this command has detected no operator activity yet it acknowledges that there may be other sources of operator activity that might make auto mode permissible.\\r\\n   0010 Suspend Auto - Auto mode is temporarily not allowed and the control issuing this command wants the primary control system to automatically return to the previous state (Auto or Manual) when the suspend auto condition is removed.\\r\\n   0011 Service Mode - Auto mode is permitted only for special services such as calibrations.\\r\\n   0100 Auto Not Allowed - Auto mode is not allowed under any condition\\r\\n\\r\\nData Values and Descriptions:\\r\\n0000 Auto Allowed\\r\\n0001 Activity Allows Auto - must detect operator before auto allowed\\r\\n0010 Suspend Auto - temporarily suspend auto mode\\r\\n0011 Service Mode - auto allowed only during service modes\\r\\n0100 Auto Not Allowed\\r\\n1110 Error Indicator\\r\\n1111 Not Supported\\r\\nAll other values are reserved\\r\\n\\r\\nNote:  \\r\\nThe control issuing this command is aware that it does not have access to all information that the primary controller of the Land Leveling System attachment has access to.  Therefore, it commands the Land Leveling system to activate a auto blade mode based on the input it has access to.  In some cases, like in the \\"Activity Allows Auto\\" situation, the control knows the Land Leveling system has access to an additional display (which has switches and several buttons) which may help determine if an operator is present.  On the other hand, the control may also have information the primary controller of the Land Leveling System does not have access to, like the parking brake status.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3159":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":24,"SPN":3159,"SPN_Name":"Trip Number","SPN_Description":"The identity number assigned to this trip.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":208},"3160":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":56,"SPN":3160,"SPN_Name":"Assigned Route","SPN_Description":"The identity number assigned to this route.\\r\\n\\r\\nNote:  This is the numerical value for the route as opposed to the \\"Transit Assigned Route Identity\\" (SPN 3074) which is variable length ASCII or the \\"Route number\\" (SPN 3169) which is 12 bit numeric.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":208},"3161":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":40,"SPN":3161,"SPN_Name":"Pattern Number ","SPN_Description":"The agency defined pattern number for this trip","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":208},"3162":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":72,"SPN":3162,"SPN_Name":"Assigned Run","SPN_Description":"The agency defined run number for this trip","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":208},"3163":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":88,"SPN":3163,"SPN_Name":"Assigned Block","SPN_Description":"The agency defined block number for this trip","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":208},"3164":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":104,"SPN":3164,"SPN_Name":"Driver\'s farebox security code","SPN_Description":"Security code for the farebox, numerical only.\\r\\n\\r\\nNote:  0 = Farebox is in reporting status\\r\\n           1 - 65535 = security code","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":208},"3165":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":16,"SPN":3165,"SPN_Name":"Fare Validity","SPN_Description":"Agency defined value indicating validity of this fare","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"3166":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":20,"SPN":3166,"SPN_Name":"Pass Category","SPN_Description":"Agency defined value indicating the category of the passenger associated with this fare","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"3167":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":24,"SPN":3167,"SPN_Name":"Initial Fare Agency","SPN_Description":"Identifies where the initial fare is paid\\r\\n\\r\\nNote:  The definition of the agency numbering plan shall be agreed by the operating agency and the farebox manufacturer.  The value of 0 is reserved, the usable range is 1 to 31.","bit_length":5,"scaling":1,"offset":0,"unit":"count","SLOT_ID":232},"3168":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":56,"SPN":3168,"SPN_Name":"Transfer Sold","SPN_Description":"Indicates that a transfer was sold or issued on this transaction including its type and/or restrictions. The final definitions of the transfer issued information shall be agreed by the operating agency and the farebox manufacturer.\\r\\n\\r\\nNote:  A non-zero value indicates that a transfer was sold or issued.  The value of zero is reserved to indicate that no transfer has been sold or issued.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"3169":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":40,"SPN":3169,"SPN_Name":"Route Number","SPN_Description":"The route number issuing the transfer.","bit_length":12,"scaling":1,"offset":0,"unit":"count","SLOT_ID":233},"3170":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":0,"SPN":3170,"SPN_Name":"Transaction Type","SPN_Description":"Enumerated value representing the type of transaction completed\\r\\n\\r\\n0000 = Cash\\r\\n0001 = Token\\r\\n0010 = Ticket\\r\\n0011 = Pass\\r\\n0100 = Card\\r\\n0101 = Permit\\r\\n0110 = Transfer\\r\\n0111 = Free\\r\\n1000-1011 = Reserved for assignment\\r\\n1100-1111 = Agency defined","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3171":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":4,"SPN":3171,"SPN_Name":"Passenger Type","SPN_Description":"Enumerated value representing the type/class of passenger, as defined by the agency.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3172":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":32,"SPN":3172,"SPN_Name":"Type of Service","SPN_Description":"The type of service provided\\r\\n\\r\\n000 = Local service\\r\\n001 = Express service\\r\\n010-111 = Agency defined","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3173":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":35,"SPN":3173,"SPN_Name":"Transfer Type","SPN_Description":"The kind of transfer used\\r\\n\\r\\n00000 = North\\r\\n00001 = South\\r\\n00010 = East\\r\\n00011 = West\\r\\n00100 = In\\r\\n00101 = Out\\r\\n00110-11111 = Agency defined","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"3174":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":8,"SPN":3174,"SPN_Name":"Trip Direction","SPN_Description":"The general direction of travel for this trip.\\r\\n\\r\\n0000 = North\\r\\n0001 = South\\r\\n0010 = East\\r\\n0011 = West\\r\\n0100 = In\\r\\n0101 = Out\\r\\n0110-1111 = Agency defined","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3175":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":16,"SPN":3175,"SPN_Name":"Fare Presets","SPN_Description":"Fare Presets\\r\\n\\r\\n00000000 to 00001111 = Agency defined\\r\\n00010000 to 11111111 = Reserved for assignment","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3176":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":8,"SPN":3176,"SPN_Name":"Type of Fare","SPN_Description":"Type of Fare\\r\\n\\r\\n0000 = Cash/No detail\\r\\n0001 = Token A\\r\\n0010 = Token B\\r\\n0011 = Ticket A\\r\\n0100 = Ticket B\\r\\n0101 = Pass A\\r\\n0110 = Pass B\\r\\n0111-1010 = Reserved for assignment\\r\\n1011-1111 = Agency defined","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3177":{"PGN":64955,"PGN_Name":"Farebox Point of Sale","PGN_Description":"TR5","first_bit":12,"SPN":3177,"SPN_Name":"Payment Details","SPN_Description":"Payment details.\\r\\n\\r\\n0000 = Not an upgrade\\r\\n0001 = Cash\\r\\n0010 = Token\\r\\n0011 = Ticket\\r\\n0100 = Pass\\r\\n0101 = Card\\r\\n0110-1010 = Reserved for assignment\\r\\n1011-1111 = Agency defined","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3178":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":0,"SPN":3178,"SPN_Name":"Farebox Service Status","SPN_Description":"Indicates if the farebox is in or out of service.\\r\\n\\r\\n00 = Farebox out of service\\r\\n01 = Farebox in service\\r\\n10 = Error Condition\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3179":{"PGN":64954,"PGN_Name":"Farebox Status","PGN_Description":"TR6","first_bit":0,"SPN":3179,"SPN_Name":"Farebox Emergency Status","SPN_Description":"Indicates if a farebox emergency condition exists.\\r\\n\\r\\n00 = Non-emergency condition\\r\\n01 = Emergency condition\\r\\n10 = Error Condition\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3180":{"PGN":64956,"PGN_Name":"Farebox Service Detail","PGN_Description":"TR4","first_bit":2,"SPN":3180,"SPN_Name":"Trip Status","SPN_Description":"Trip Status\\r\\n\\r\\n000 = Undefined\\r\\n001 = Trip start\\r\\n010 = Trip end\\r\\n011 = Undefined\\r\\n100 = Undefined\\r\\n101 = Layover start\\r\\n110 = Layover end\\r\\n111 = Undefined","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3181":{"PGN":64954,"PGN_Name":"Farebox Status","PGN_Description":"TR6","first_bit":8,"SPN":3181,"SPN_Name":"Farebox Alarm Identifier","SPN_Description":"Indicates the nature of the farebox alarm condition.\\r\\n\\r\\n0000000 = Voltage dropout\\r\\n0000001 = Voltage restored\\r\\n0000010 = Probe started\\r\\n0000011 = Probe completed\\r\\n0000100 = Cashbox removed\\r\\n0000101 = Cashbox restored\\r\\n0000110 = Cashbox door timeout\\r\\n0000111 = Cashbox opened in service, considered an alarm condition\\r\\n0001000 = Insufficient fare accepted\\r\\n0001001 = Coinbox 75% full\\r\\n0001010 = Coinbox full\\r\\n0001011 = Currency box 75% full\\r\\n0001100 = Currency box less than 75% full\\r\\n0001101 = Currency box full\\r\\n0001110 = Card/pass box 75% full\\r\\n0001111 = Card/pass box less than 75% full\\r\\n0010000 = Card/pass box full\\r\\n0010001 = Coin de-jam operated\\r\\n0010010 = Farebox set in manual bypass\\r\\n0010011 = Farebox reset to automatic mode\\r\\n0010100 = Pass/transfer jam\\r\\n0010101 = Pass/transfer jam cleared\\r\\n0010110 = Paper currency jam\\r\\n0010111 = Paper currency jam cleared\\r\\n0011000 = Maintenance access in service, considered an alarm condition\\r\\n0011001 = Maintenance access out of service\\r\\n0011010-1100000 = Reserved - to be assigned\\r\\n1100001-1111111 = Agency defined","bit_length":7,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":92},"3188":{"PGN":1024,"PGN_Name":"External Brake Request","PGN_Description":"XBR","first_bit":60,"SPN":3188,"SPN_Name":"XBR Message Checksum","SPN_Description":"The XBR message checksum is used to verify the signal path from the demanding device to the brake controller on electronic brake systems.  The support of this parameter is mandatory if PGN 1024 is supported as there is no means to indicate \u201Cnot available\u201D.\\r\\n\\r\\nThe 4 bit XBR message checksum is calculated using the first 7 data bytes, the 4 bit message counter and the bytes of the message identifier.  It is calculated as follows:\\r\\n\\r\\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\\r\\n\\r\\nXBR Message Checksum = ((Checksum >> 4) + Checksum) & 0x0F\\r\\n\\r\\n\\r\\nNote:  A failure in the communication sets the XBR system state:\\r\\n    - to \'01\' for failed XBR \'priority 01, 10 or 11\' messages\\r\\n    - to \'10\' for failed XBR \'priority 00\' messages.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"3189":{"PGN":1024,"PGN_Name":"External Brake Request","PGN_Description":"XBR","first_bit":56,"SPN":3189,"SPN_Name":"XBR Message Counter","SPN_Description":"The XBR message counter is to verify the signal path from the demanding device to the brake controller on electronic brake systems..  The support of this parameter is mandatory.\\r\\n\\r\\nNote:  The initial value of the 4 bit message counter for the first message during a driving cycle is arbitrary. In every following message the counter is incremented by 1  (0 follows 15).","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"3190":{"PGN":64953,"PGN_Name":"Tire Pressure Reference Information","PGN_Description":"TPRI","first_bit":0,"SPN":3190,"SPN_Name":"Tire Location","SPN_Description":"Identifies which tire is associated with the parametric data in this PGN.\\r\\n\\r\\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\\r\\n\\r\\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire pressure for location 0x00 would be left front tire.\\r\\n\\r\\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3191":{"PGN":64953,"PGN_Name":"Tire Pressure Reference Information","PGN_Description":"TPRI","first_bit":8,"SPN":3191,"SPN_Name":"Reference Tire Pressure","SPN_Description":"Reference value of the tire pressure as basis for the tire pressure monitoring","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"3192":{"PGN":44544,"PGN_Name":"Tire Pressure Reference Setting","PGN_Description":"TPRS","first_bit":0,"SPN":3192,"SPN_Name":"Tire Location","SPN_Description":"Identifies which tire is associated with the parametric data in this PGN.\\r\\n\\r\\nThe low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward).\\r\\n\\r\\nThe high order 4 bits represent a position number, counting front to back on the vehicle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire pressure for location 0x00 would be left front tire.\\r\\n\\r\\nTire pressure for location 0x23 would be right outside rear rear on a 3-axle tractor with dual axle per side (3rd axle, 4th tire).","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3193":{"PGN":44544,"PGN_Name":"Tire Pressure Reference Setting","PGN_Description":"TPRS","first_bit":8,"SPN":3193,"SPN_Name":"Reference Tire Pressure Setting","SPN_Description":"Reference value of the tire pressure setting as basis for the tire pressure monitoring","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"3215":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":52,"SPN":3215,"SPN_Name":"Prohibit air suspension control","SPN_Description":"This parameter is an external request to the air suspension control system to prohibit all air suspension control.  If the request is accepted,  response intended to be sent in  ASC1 (additional status requested in ASC1), there will be no control either for height changes or axle load distribution changes, i.e. hold current pressures in all suspension devices.\\r\\n\\r\\n\\r\\n00 No request \\r\\n01 Request prohibit air suspension control \\r\\n10 Error indicator \\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3216":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":0,"SPN":3216,"SPN_Name":"Aftertreatment 1 SCR Intake NOx 1","SPN_Description":"The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1 Dosing Unit 1.\\r\\n\\r\\nSPN 3216 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal (see SPN 7353) in addition to the raw NOx sensor signal output using SPN 3216.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"3217":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":16,"SPN":3217,"SPN_Name":"Aftertreatment 1 Intake Percent Oxygen 1","SPN_Description":"The actual oxidation factor (Percent Oxygen) of the gas within the exhaust stream. For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion. For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor. This value is measured by a sensor at the aftertreatment intake in exhaust bank 1.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"3218":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":32,"SPN":3218,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 1 Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 1.  This parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3219":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":34,"SPN":3219,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 1 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 1.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3220":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":36,"SPN":3220,"SPN_Name":"Aftertreatment 1 SCR Intake NOx 1 Reading Stable","SPN_Description":"Indicates that the NOx reading of the aftertreatment intake NOx sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3221":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":38,"SPN":3221,"SPN_Name":"Aftertreatment 1 Intake Wide-Range Percent Oxygen 1 Reading Stable","SPN_Description":"Indicates that the percent oxygen reading of the aftertreatment intake gas sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3222":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":40,"SPN":3222,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 1 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the intake exhaust gas sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3223":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":45,"SPN":3223,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 1 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3224":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":48,"SPN":3224,"SPN_Name":"Aftertreatment 1 SCR Intake NOx Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3225":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":56,"SPN":3225,"SPN_Name":"Aftertreatment 1 Intake Oxygen  Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake oxygen sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3226":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":0,"SPN":3226,"SPN_Name":"Aftertreatment 1 Outlet NOx 1","SPN_Description":"The amount of combined NO and NO2 in the exhaust exiting the aftertreatment system measured by a NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1.\\r\\n\\r\\nSPN 3226 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal (see SPN 7351) in addition to the raw NOx sensor signal output using SPN 3226.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"3227":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":16,"SPN":3227,"SPN_Name":"Aftertreatment 1 Outlet Percent Oxygen 1","SPN_Description":"The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment outlet in exhaust bank 1.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"3228":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":32,"SPN":3228,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 1 Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 1. This parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3229":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":34,"SPN":3229,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 1 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 1.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3230":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":36,"SPN":3230,"SPN_Name":"Aftertreatment 1 Outlet NOx 1 Reading Stable","SPN_Description":"Indicates that the NOx reading of the aftertreatment outlet NOx sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3231":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":38,"SPN":3231,"SPN_Name":"Aftertreatment 1 Outlet Wide-Range Percent Oxygen 1 Reading Stable","SPN_Description":"Indicates that the percent oxygen reading of the aftertreatment outlet gas sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3232":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":40,"SPN":3232,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 1 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3233":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":45,"SPN":3233,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 1 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3234":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":48,"SPN":3234,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3235":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":56,"SPN":3235,"SPN_Name":"Aftertreatment 1 Outlet Oxygen Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3236":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":40,"SPN":3236,"SPN_Name":"Aftertreatment 1 Exhaust Gas Mass Flow Rate","SPN_Description":"Measured/calculated exhaust gas mass upstream of the aftertreatment system in exhaust bank 1 and 2.","bit_length":16,"scaling":0.2,"offset":0,"unit":"kg/h","SLOT_ID":262},"3237":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":56,"SPN":3237,"SPN_Name":"Aftertreatment 1 Intake Dew Point","SPN_Description":"Indicates that the temperature on the intake side of the aftertreatment system has exceeded the dew point, as estimated by the ECU in exhaust bank 1.\\r\\n\\r\\n00 - Not exceeded the dew point\\r\\n01 - Exceeded the dew point\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3238":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":58,"SPN":3238,"SPN_Name":"Aftertreatment 1 Exhaust Dew Point","SPN_Description":"Indicates that the temperature on the exhaust side of the aftertreatment has exceeded the dew point, as estimated by the ECU in exhaust bank 1.\\r\\n\\r\\n00 - Not exceeded the dew point\\r\\n01 - Exceeded the dew point\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3239":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":60,"SPN":3239,"SPN_Name":"Aftertreatment 2 Intake Dew Point","SPN_Description":"Indicates that the temperature on the intake side of the aftertreatment system has exceeded the dew point, as estimated by the ECU in exhaust bank 2.\\r\\n\\r\\n00 - Not exceeded the dew point\\r\\n01 - Exceeded the dew point\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3240":{"PGN":65247,"PGN_Name":"Electronic Engine Controller 3","PGN_Description":"EEC3","first_bit":62,"SPN":3240,"SPN_Name":"Aftertreatment 2 Exhaust Dew Point","SPN_Description":"Indicates that the temperature on the exhaust side of the aftertreatment has exceeded the dew point, as estimated by the ECU in exhaust bank 2.\\r\\n\\r\\n00 - Not exceeded the dew point\\r\\n01 - Exceeded the dew point\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3241":{"PGN":64948,"PGN_Name":"Aftertreatment 1 Intake Gas 2","PGN_Description":"AT1IG2","first_bit":0,"SPN":3241,"SPN_Name":"Aftertreatment 1 Exhaust Temperature 1","SPN_Description":"The reading from the exhaust temperature sensor located farthest upstream in the aftertreatment system in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3242":{"PGN":64948,"PGN_Name":"Aftertreatment 1 Intake Gas 2","PGN_Description":"AT1IG2","first_bit":16,"SPN":3242,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the diesel particulate filter in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3243":{"PGN":64948,"PGN_Name":"Aftertreatment 1 Intake Gas 2","PGN_Description":"AT1IG2","first_bit":32,"SPN":3243,"SPN_Name":"Aftertreatment 1 Exhaust Temperature 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 1 sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.   In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3244":{"PGN":64948,"PGN_Name":"Aftertreatment 1 Intake Gas 2","PGN_Description":"AT1IG2","first_bit":40,"SPN":3244,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3245":{"PGN":64947,"PGN_Name":"Aftertreatment 1 Outlet Gas 2","PGN_Description":"AT1OG2","first_bit":0,"SPN":3245,"SPN_Name":"Aftertreatment 1 Exhaust Temperature 3","SPN_Description":"The reading from the exhaust temperature sensor located farthest downstream in the aftertreatment system in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3246":{"PGN":64947,"PGN_Name":"Aftertreatment 1 Outlet Gas 2","PGN_Description":"AT1OG2","first_bit":16,"SPN":3246,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the diesel particulate filter exhaust in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3247":{"PGN":64947,"PGN_Name":"Aftertreatment 1 Outlet Gas 2","PGN_Description":"AT1OG2","first_bit":32,"SPN":3247,"SPN_Name":"Aftertreatment 1 Exhaust Temperature 3 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 3 sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3248":{"PGN":64947,"PGN_Name":"Aftertreatment 1 Outlet Gas 2","PGN_Description":"AT1OG2","first_bit":40,"SPN":3248,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Outlet Exhaust Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter outlet temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3249":{"PGN":64946,"PGN_Name":"Aftertreatment 1 Intermediate Gas","PGN_Description":"AT1IMG","first_bit":0,"SPN":3249,"SPN_Name":"Aftertreatment 1 Exhaust Temperature 2","SPN_Description":"The reading from the exhaust temperature sensor located midstream of the other two temperature sensors in the aftertreatment system in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3250":{"PGN":64946,"PGN_Name":"Aftertreatment 1 Intermediate Gas","PGN_Description":"AT1IMG","first_bit":16,"SPN":3250,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Intermediate Temperature","SPN_Description":"Temperature of engine combustion byproducts at a mid-point in the diesel particulate filter in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3251":{"PGN":64946,"PGN_Name":"Aftertreatment 1 Intermediate Gas","PGN_Description":"AT1IMG","first_bit":32,"SPN":3251,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of a diesel particulate filter in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3252":{"PGN":64946,"PGN_Name":"Aftertreatment 1 Intermediate Gas","PGN_Description":"AT1IMG","first_bit":48,"SPN":3252,"SPN_Name":"Aftertreatment 1 Exhaust Temperature 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 2 sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3253":{"PGN":64946,"PGN_Name":"Aftertreatment 1 Intermediate Gas","PGN_Description":"AT1IMG","first_bit":53,"SPN":3253,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3254":{"PGN":64946,"PGN_Name":"Aftertreatment 1 Intermediate Gas","PGN_Description":"AT1IMG","first_bit":58,"SPN":3254,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Intermediate Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intermediate temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3255":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":0,"SPN":3255,"SPN_Name":"Aftertreatment 2 SCR Intake NOx 1","SPN_Description":"The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\nSPN 3255 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal (see SPN 7354) in addition to the raw NOx sensor signal output using SPN 3255.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"3256":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":16,"SPN":3256,"SPN_Name":"Aftertreatment 2 Intake Percent Oxygen 1","SPN_Description":"The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment intake in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"3257":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":32,"SPN":3257,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 1 Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\nThis parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3258":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":34,"SPN":3258,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 1 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.  \\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3259":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":36,"SPN":3259,"SPN_Name":"Aftertreatment 2 SCR Intake NOx 1 Reading Stable","SPN_Description":" Indicates that the NOx reading of the aftertreatment intake NOx sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3260":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":38,"SPN":3260,"SPN_Name":"Aftertreatment 2 Intake Wide-Range Percent Oxygen 1 Reading Stable","SPN_Description":"Indicates that the percent oxygen reading of the aftertreatment intake gas sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3261":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":40,"SPN":3261,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 1 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the intake exhaust gas sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3262":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":45,"SPN":3262,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 1 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3263":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":48,"SPN":3263,"SPN_Name":"Aftertreatment 2 SCR Intake NOx Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3264":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":56,"SPN":3264,"SPN_Name":"Aftertreatment 2 Intake Oxygen Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake oxygen sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3265":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":0,"SPN":3265,"SPN_Name":"Aftertreatment 2 Outlet NOx 1","SPN_Description":"The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\nSPN 3265 shall display the raw, uncorrected NOx sensor signal. 2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal (see SPN 7352) in addition to the raw NOx sensor signal output using SPN 3265.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"3266":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":16,"SPN":3266,"SPN_Name":"Aftertreatment 2 Outlet Percent Oxygen 1","SPN_Description":"The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment outlet in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"3267":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":32,"SPN":3267,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 1 Power In Range","SPN_Description":" Indicates that the power supplied to the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\nThis parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3268":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":34,"SPN":3268,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 1 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3269":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":36,"SPN":3269,"SPN_Name":"Aftertreatment 2 Outlet NOx 1 Reading Stable","SPN_Description":"Indicates that the NOx reading of the aftertreatment outlet NOx sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3270":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":38,"SPN":3270,"SPN_Name":"Aftertreatment 2 Outlet Wide-Range Percent Oxygen 1 Reading Stable","SPN_Description":"Indicates that the percent oxygen reading of the aftertreatment outlet gas sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3271":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":40,"SPN":3271,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 1 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3272":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":45,"SPN":3272,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 1 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3273":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":48,"SPN":3273,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3274":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":56,"SPN":3274,"SPN_Name":"Aftertreatment 2 Outlet Oxygen Sensor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3275":{"PGN":64945,"PGN_Name":"Aftertreatment 2 Intake Gas 2","PGN_Description":"AT2IG2","first_bit":0,"SPN":3275,"SPN_Name":"Aftertreatment 2 Exhaust Temperature 1","SPN_Description":"The reading from the exhaust temperature sensor located farthest upstream in the aftertreatment system in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3276":{"PGN":64945,"PGN_Name":"Aftertreatment 2 Intake Gas 2","PGN_Description":"AT2IG2","first_bit":16,"SPN":3276,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the diesel particulate filter in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3277":{"PGN":64945,"PGN_Name":"Aftertreatment 2 Intake Gas 2","PGN_Description":"AT2IG2","first_bit":32,"SPN":3277,"SPN_Name":"Aftertreatment 2 Exhaust Temperature 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 1 sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3278":{"PGN":64945,"PGN_Name":"Aftertreatment 2 Intake Gas 2","PGN_Description":"AT2IG2","first_bit":40,"SPN":3278,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3279":{"PGN":64944,"PGN_Name":"Aftertreatment 2 Outlet Gas 2","PGN_Description":"AT2OG2","first_bit":0,"SPN":3279,"SPN_Name":"Aftertreatment 2 Exhaust Temperature 3","SPN_Description":"The reading from the exhaust temperature sensor located farthest downstream in the aftertreatment system in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3280":{"PGN":64944,"PGN_Name":"Aftertreatment 2 Outlet Gas 2","PGN_Description":"AT2OG2","first_bit":16,"SPN":3280,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the diesel particulate filter exhaust in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3281":{"PGN":64944,"PGN_Name":"Aftertreatment 2 Outlet Gas 2","PGN_Description":"AT2OG2","first_bit":32,"SPN":3281,"SPN_Name":"Aftertreatment 2 Exhaust Temperature 3 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 3 sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3282":{"PGN":64944,"PGN_Name":"Aftertreatment 2 Outlet Gas 2","PGN_Description":"AT2OG2","first_bit":40,"SPN":3282,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Exhaust Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter outlet temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3283":{"PGN":64943,"PGN_Name":"Aftertreatment 2 Intermediate Gas","PGN_Description":"AT2IMG","first_bit":0,"SPN":3283,"SPN_Name":"Aftertreatment 2 Exhaust Temperature 2","SPN_Description":"The reading from the exhaust temperature sensor located midstream of the other two temperature sensors in the aftertreatment system in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3284":{"PGN":64943,"PGN_Name":"Aftertreatment 2 Intermediate Gas","PGN_Description":"AT2IMG","first_bit":16,"SPN":3284,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Intermediate Temperature","SPN_Description":"Temperature of engine combustion byproducts at a mid-point in the diesel particulate filter in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3285":{"PGN":64943,"PGN_Name":"Aftertreatment 2 Intermediate Gas","PGN_Description":"AT2IMG","first_bit":32,"SPN":3285,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of a diesel particulate filter in exhaust bank 2.  (For a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247)","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3286":{"PGN":64943,"PGN_Name":"Aftertreatment 2 Intermediate Gas","PGN_Description":"AT2IMG","first_bit":48,"SPN":3286,"SPN_Name":"Aftertreatment 2 Exhaust Temperature 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the exhaust temperature 2 sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3287":{"PGN":64943,"PGN_Name":"Aftertreatment 2 Intermediate Gas","PGN_Description":"AT2IMG","first_bit":53,"SPN":3287,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3288":{"PGN":64943,"PGN_Name":"Aftertreatment 2 Intermediate Gas","PGN_Description":"AT2IMG","first_bit":58,"SPN":3288,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Intermediate Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel particulate filter intermediate temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455,  64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3289":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":24,"SPN":3289,"SPN_Name":"Transmission Requested Gear Feedback","SPN_Description":"Feedback of the SPN 525 Transmission Requested Gear input as received from the shift selector, ABS or engine via PGN 256, Transmission Control 1 (TC1) or other transmission selector input.  Scaling, values and parameter specific indicators are identical to those listed for SPN 525 Requested Gear.\\r\\n\\r\\nThis feedback from the transmission allows shift selectors and other TC1 input devices to verify that their Transmission Requested Gear command has been properly received by the transmission.  (This parameter is not intended for driver display purposes).\\r\\n\\r\\nIn systems with mechanical or electrical shift selectors which do not support J1939 communication, this parameter allows the transmission ECU to convey the requested gear as interpreted by the transmission from its mechanical or electrical input.","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"3307":{"PGN":64942,"PGN_Name":"Fifth Wheel Smart Systems 2","PGN_Description":"FWSS2","first_bit":0,"SPN":3307,"SPN_Name":"Fifth Wheel Error Status","SPN_Description":"Fifth wheel error state which conveys information when coupling status is incomplete or bad.\\r\\n\\r\\n0000    0 - Improper Couple\\r\\n0001    1 - Locks Closed / No Kingpin at Startup\\r\\n0010    2 - Kingpin / Locks Open at Startup\\r\\n0011    3 - Not Used\\r\\n0100    4 - Not Used\\r\\n0101    5 - Coupling Sequence Error\\r\\n0110    6 - Coupling Sequence Error / Kingpin\\r\\n0111    7 - Coupling Timing Error\\r\\n1000    8 - Kingpin Missing More Than 5 Seconds\\r\\n1001    9 - Kingpin / Lock Open (Handle Pulled)\\r\\n1010    10 - Not Used\\r\\n1011    11 - Not Used\\r\\n1100    12 - Not Used\\r\\n1101    13 - Not Used\\r\\n1110    14 - Not Used\\r\\n1111    15 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3308":{"PGN":61458,"PGN_Name":"Fifth Wheel Smart Systems 1","PGN_Description":"FWSS1","first_bit":0,"SPN":3308,"SPN_Name":"Fifth Wheel Vertical Force","SPN_Description":"The amount of load being applied to the fifth wheel by the trailer. Zero load is indicated without a trailer.","bit_length":16,"scaling":5,"offset":0,"unit":"N","SLOT_ID":43},"3309":{"PGN":61458,"PGN_Name":"Fifth Wheel Smart Systems 1","PGN_Description":"FWSS1","first_bit":16,"SPN":3309,"SPN_Name":"Fifth Wheel Drawbar Force","SPN_Description":"Fifth wheel drawbar force, with the trailer held stationary a positive force is generated by the vehicle pulling forward.","bit_length":16,"scaling":10,"offset":-320000,"unit":"N","SLOT_ID":127},"3310":{"PGN":61458,"PGN_Name":"Fifth Wheel Smart Systems 1","PGN_Description":"FWSS1","first_bit":32,"SPN":3310,"SPN_Name":"Fifth Wheel Roll Moment ","SPN_Description":"Fifth wheel roll moment force - If the moment is positive, the trailer is rolling clockwise relative to the normal vehicle forward motion.","bit_length":16,"scaling":10,"offset":-320000,"unit":"N","SLOT_ID":127},"3311":{"PGN":64942,"PGN_Name":"Fifth Wheel Smart Systems 2","PGN_Description":"FWSS2","first_bit":8,"SPN":3311,"SPN_Name":"Fifth Wheel Slider Position","SPN_Description":"Slider position measurement. Zero equals fully back position, that is, the farthest to the rear of the vehicle.","bit_length":8,"scaling":10,"offset":0,"unit":"mm","SLOT_ID":234},"3312":{"PGN":64942,"PGN_Name":"Fifth Wheel Smart Systems 2","PGN_Description":"FWSS2","first_bit":4,"SPN":3312,"SPN_Name":"Fifth Wheel Lock Ready to Couple Indicator","SPN_Description":"Indicates to the vehicle operator that the fifth wheel lock is open and ready to couple.\\r\\n\\r\\n00   Lock not open, not ready to couple\\r\\n01   Lock open, ready to couple\\r\\n10   Error\\r\\n11   Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3313":{"PGN":64942,"PGN_Name":"Fifth Wheel Smart Systems 2","PGN_Description":"FWSS2","first_bit":6,"SPN":3313,"SPN_Name":"Fifth Wheel Lock Couple Status Indicator","SPN_Description":"Indicates results of coupling operation to the vehicle operator. For incomplete couples further information can be obtained from the fifth wheel error status SPN.\\r\\n\\r\\n00   Incomplete or bad couple, truck should not be moved\\r\\n01   Successful couple detected\\r\\n10   Error\\r\\n11   Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3314":{"PGN":64980,"PGN_Name":"Cab Message 3","PGN_Description":"CM3","first_bit":8,"SPN":3314,"SPN_Name":"Fifth Wheel Release Control","SPN_Description":"Operator input used to release the fifth wheel. Fifth Wheel Release Control Security Lockout and other conditions must be properly enabled before this will function.\\r\\n\\r\\n00   Coupler Locked\\r\\n01   Coupler Unlocked, trailer can be unhitched or hitched\\r\\n10   Error\\r\\n11   Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3315":{"PGN":64980,"PGN_Name":"Cab Message 3","PGN_Description":"CM3","first_bit":10,"SPN":3315,"SPN_Name":"Fifth Wheel Release Control Security Lockout","SPN_Description":"Operator\'s fifth wheel release control interlock. This operator input must be enabled prior to activating the fifth wheel release control (SPN 3314). \\r\\n\\r\\n00    Fifth wheel release Disabled\\r\\n01    Fifth wheel release Enabled\\r\\n10    Error   \\r\\n11    Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3316":{"PGN":64942,"PGN_Name":"Fifth Wheel Smart Systems 2","PGN_Description":"FWSS2","first_bit":16,"SPN":3316,"SPN_Name":"Fifth Wheel Slider Lock Indicator","SPN_Description":"Indicates to vehicle operator that the fifth wheel slider is in position and locked. \\r\\n\\n00 Not Locked\\r\\n01 Locked\\r\\n10 Error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3317":{"PGN":61458,"PGN_Name":"Fifth Wheel Smart Systems 1","PGN_Description":"FWSS1","first_bit":48,"SPN":3317,"SPN_Name":"Fifth Wheel Roll Warning Indicator","SPN_Description":"Indicates to the vehicle operator that the roll moment has exceeded a preset limit. \\r\\n\\n00 Limit not exceeded\\r\\n01 Limit exceeded\\r\\n10 error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3318":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":0,"SPN":3318,"SPN_Name":"Pitch Angle","SPN_Description":"The angle between the vehicle x-axis and the ground plane (i.e. rotation about the vehicle Y-axis).  The pitch angle for an angle of ascent is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 4976 for an alternate range and resolution.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"3319":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":16,"SPN":3319,"SPN_Name":"Roll Angle","SPN_Description":"The angle between the vehicle y-axis and the ground plane (i.e. rotation about the X-axis).  The roll angle for a roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  See SPN 4977 for an alternate range and resolution.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"3322":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":32,"SPN":3322,"SPN_Name":"Pitch Rate","SPN_Description":"Pitch rate is the rate-of-change of the pitch angle over time, where the pitch angle vector is in the direction of travel of the vehicle. The pitch rate for increasing ascent over time is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 4983 for an alternate range and resolution.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg/s","SLOT_ID":243},"3323":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":48,"SPN":3323,"SPN_Name":"Pitch Angle Figure of Merit","SPN_Description":"Figure of merit for pitch angle measurement.\\r\\n\\r\\n00 - Pitch angle fully functional.  Data is within sensor specification. \\r\\n01 - Pitch angle degraded.  Data is suspect due to environmental conditions.\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3324":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":50,"SPN":3324,"SPN_Name":"Roll Angle Figure of Merit","SPN_Description":"Figure of merit for roll angle measurement.\\r\\n\\r\\n00 - Roll angle fully functional.  Data is within sensor specification.   \\r\\n01 - Roll angle degraded.  Data is suspect due to environmental conditions.\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3325":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":52,"SPN":3325,"SPN_Name":"Pitch Rate Figure of Merit","SPN_Description":"Figure of merit for the pitch rate measurement.\\r\\n\\n00 - Pitch rate fully functional.  Data is within sensor specification.   \\r\\n01 - Pitch rate degraded.  Data is suspect due to environmental conditions.\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3326":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":54,"SPN":3326,"SPN_Name":"Pitch and Roll Compensated","SPN_Description":"Compensated mode for the pitch and roll measurements.  Compensation is the use of multiple sensors together to enhance the output of pitch and roll measurements.\\r\\n\\r\\n00 - Compensation Off\\r\\n01 - Compensation On\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3327":{"PGN":61459,"PGN_Name":"Slope Sensor Information","PGN_Description":"SSI","first_bit":56,"SPN":3327,"SPN_Name":"Roll and Pitch Measurement Latency","SPN_Description":"The estimated measurement latency of the measurement.  NOTE: This is only the sensor latency and does not include any additional latencies that might exist because of the CAN Bus or overall system implementation. \\nLatency is the time from sensor readings to the queuing of the message data for CAN transmission.","bit_length":8,"scaling":0.5,"offset":0,"unit":"ms","SLOT_ID":241},"3331":{"PGN":61460,"PGN_Name":"Blade Information","PGN_Description":"BI","first_bit":16,"SPN":3331,"SPN_Name":"Blade Rotation Angle","SPN_Description":"The blade rotation angle measurement around the yaw (z-axis).  The Blade Rotation Angle is defined to be the angle from the null position on the machine.  The null position is orthogonal from the z-axis along the x-axis.  A positive blade angle results when the blade is rotated clockwise from the null position. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"3332":{"PGN":61460,"PGN_Name":"Blade Information","PGN_Description":"BI","first_bit":42,"SPN":3332,"SPN_Name":"Blade Rotation Angle Figure of Merit","SPN_Description":"Figure of merit for blade rotation measurement.\\r\\n\\r\\nBits\\r\\n00  Blade Rotation Angle fully functional.  Data is within sensor specification.   \\r\\n01  Blade Rotation Angle  degraded.  Data is suspect due to environmental conditions.\\r\\n10  Blade Rotation Angle failed.  Roll sensor failed to operate correctly.\\r\\n11  Blade Rotation Angle not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3334":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":12,"SPN":3334,"SPN_Name":"Left Blade Control Mode Operator Control","SPN_Description":"This parameter indicates the left blade control mode operator control state the user has set for the land leveling system.  The operator control value directly relates to the current operator control state correlating to the left edge of the blade.  The purpose of this parameter is to set the control mode (auto/manual) for the left side of the blade. For this system, the left and right side of the blade can be adjusted independently of each other to either change the elevation from a given reference point or the blade angle (also known as blade tilt)/cross slope depending on the function requested by the operator.\\r\\n\\r\\nThis parameter is intended for use in systems using two parameters (right/left) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Blade Control Mode Switch parameter. Only one of the following states will be active at a time.   In the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  \\r\\n\\r\\nToggle button usage is as follows:\\r\\n     Manual Button Pressed       = 0010    Manual Operator Control Request\\r\\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\\r\\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n2. The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.\\r\\n\\r\\nMomentary rocker button usage is as follows:\\r\\n\\r\\n     No button pressed                = 0000    No change\\r\\n     Manual Button Pressed       = 0010    Manual Operator Control Request\\r\\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\\r\\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n3.  The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.\\r\\n\\r\\nMomentary contact buttons (button pair) usage is as follows:\\r\\n\\r\\n     No button pressed                = 0000    No change\\r\\n     Manual Button Pressed       = 0010    Manual Operator Control Request\\r\\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\\r\\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n4.  The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  If the blade is in manual mode to begin with, one press of the button will change to mode to auto.  If the button is pressed again, the blade will be put into manual mode.\\r\\n\\r\\nMomentary contact button (single button) usage is as follows:\\r\\n\\r\\n    No button pressed                = 0000    No change\\r\\n    Mode Button Pressed          = 0001    Momentary Operator Control Request\\r\\n\\r\\n\\r\\nData Values and Descriptions:\\r\\n\\r\\n0000    No Change\\r\\n0001    Momentary Operator Control Request\\r\\n0010    Manual Operator Control Request\\r\\n0011    Automatic Operator Control Request\\r\\n1100 - 1101   Reserved\\r\\n1110    Error Indicator\\r\\n1111    Not Installed\\r\\n\\r\\nNotes:\\r\\n1.  The operator control state can be read in two ways.  One method uses the direct operator control input to determine the operator control state, while the second method relies on a secondary control to read the operator control input, then relay the information on the data link.  The parameter is designed to provide the actual operator control state to other controls that need the information.\\r\\n2.  Other systems with automated blade controls should be able to use this parameter, since it is an actual operator control value.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3335":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":16,"SPN":3335,"SPN_Name":"Right Blade Control Mode Operator Control","SPN_Description":"This parameter indicates the right blade control mode operator control state the user has set for the land leveling system.  The operator control value directly relates to the current operator control state correlating to the left edge of the blade.  The purpose of this parameter is to set the control mode (auto/manual) for the left side of the blade. For this system, the left and right side of the blade can be adjusted independently of each other to either change the elevation from a given reference point or the blade angle (also known as blade tilt)/cross slope depending on the function requested by the operator.\\r\\n\\r\\nThis parameter is intended for use in systems using two parameters(right/left) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Blade Control Mode Switch parameter. Only one of the following states will be active at a time.   In the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  \\r\\n\\r\\nToggle button usage is as follows:\\r\\n     Manual Button Pressed       = 0010    Manual Operator Control Request\\r\\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\\r\\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n2. The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.\\r\\n\\r\\nMomentary rocker button usage is as follows:\\r\\n     No button pressed                = 0000    No change\\r\\n     Manual Button Pressed       = 0010    Manual Operator Control Request\\r\\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\\r\\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n3.  The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.\\r\\n\\r\\nMomentary contact buttons (button pair) usage is as follows:\\r\\n     No button pressed                = 0000    No change\\r\\n     Manual Button Pressed       = 0010    Manual Operator Control Request\\r\\n     Automatic Button Pressed  = 0011    Automatic Operator Control Request\\r\\n     Invalid Switch Input(ex. auto and manual read/pressed simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n4.  The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  If the blade is in manual mode to begin with, one press of the button will change to mode to auto.  If the button is pressed again, the blade will be put into manual mode.\\r\\n\\r\\nMomentary contact button (single button) usage is as follows:\\r\\n    No button pressed                = 0000    No change\\r\\n    Mode Button Pressed          = 0001    Momentary Operator Control Request\\r\\n\\r\\nData Values and Descriptions:\\r\\n0000    No Change\\r\\n0001    Momentary Operator Control Request\\r\\n0010    Manual Operator Control Request\\r\\n0011    Automatic Operator Control Request\\r\\n1110    Error Indicator\\r\\n1111    Not Installed\\r\\nAll other values reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3336":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":20,"SPN":3336,"SPN_Name":"Left Desired Blade Offset Operator Control","SPN_Description":"This parameter indicates the left blade offset operator control state the user has set for the land leveling system.  The left desired blade offset value is the offset measured from a given reference point to the bottom left edge of the blade. This parameter will only be used when the control mode for land leveling system has been set to auto. The purpose of this parameter is to adjust the elevation from a given reference point or the blade angle(also known as blade tilt)/cross slope depending on the function being requested by the operator for the left side of the blade.\\r\\n\\r\\nThis parameter is intended for use in systems using two parameters(left/right) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Desired Blade Offset Switch parameter. Only one of the following states will be active at a time.\\r\\n\\r\\nIn the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1. The momentary rocker switch may be used, where the default is the neutral position with no buttons pressed.  The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the neutral position.  The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the neutral position.  Momentary rocker button usage is as follows:\\r\\n\\r\\n     Neutral position = 0000  No Operator Control Request\\r\\n     Increment Button Pressed  = 0001   Increment Operator Control Request\\r\\n     Decrement Button Pressed  = 0010   Decrement Operator Control Request\\r\\n     Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n2. The momentary contact button pair may be used, where the default is the neutral position with no buttons pressed.  The user can press the increment button, and when pressure is released, it will return to the neutral position.  The user may press the decrement button, and when pressure is released, it will return to the neutral position.  Momentary contact button (button pair) usage is as follows:\\r\\n\\r\\n      No Button Pressed = 0000 No Operator Control Request\\r\\n      Increment Button Pressed  = 0001 Increment Operator Control Request\\r\\n      Decrement Button Pressed  = 0010 Decrement Operator Control Request\\r\\n      Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110 Error Indicator\\r\\n\\r\\nData Values and Descriptions:\\r\\n0000 No Operator Control Request\\r\\n0001 Increment Operator Control Request\\r\\n0010 Decrement Operator Control Request\\r\\n0011 - 1101  Reserved\\r\\n1110 Error Indicator\\r\\n1111 Not installed\\r\\n\\r\\nNotes:  \\r\\n\\r\\n1.  The operator control state can be read in two ways.  One method uses the direct operator control input to determine the operator control state, while the second method relies on a secondary control to read the operator control input, then relay the information on the data link.  The parameter is designed to provide the actual operator control state to other controls that need the information.\\r\\n2.  Other systems with automated blade controls should be able to use this parameter, since it is an actual operator control value.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3337":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":24,"SPN":3337,"SPN_Name":"Right Desired Blade Offset Operator Control","SPN_Description":"This parameter indicates the right blade offset operator control state the user has set for the land leveling system.  The right desired blade offset value is the offset measured from a given reference point to the bottom right edge of the blade. This parameter will only be used when the control mode for land leveling system has been set to auto. The purpose of this parameter is to adjust the elevation from a given reference point or the blade angle(also known as blade tilt)/cross slope depending on the function being requested by the operator for the left side of the blade.\\r\\n\\r\\nThis parameter is intended for use in systems using two parameters(left/right) to control the blade as described above.  Systems using only one parameter to control blade position, i.e. elevation, should use the Desired Blade Offset Switch parameter. Only one of the following states will be active at a time.\\r\\n\\r\\nIn the example below, data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1. The momentary rocker switch may be used, where the default is the neutral position with no buttons pressed.  The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the neutral position.  The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the neutral position.  Momentary rocker button usage is as follows:\\r\\n\\r\\n     Neutral position = 0000  No Operator Control Request\\r\\n     Increment Button Pressed  = 0001   Increment Operator Control Request\\r\\n     Decrement Button Pressed  = 0010   Decrement Operator Control Request\\r\\n     Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110    Error Indicator\\r\\n\\r\\n2. The momentary contact button pair may be used, where the default is the neutral position with no buttons pressed.  The user can press the increment button, and when pressure is released, it will return to the neutral position.  The user may press the decrement button, and when pressure is released, it will return to the neutral position.  Momentary contact button (button pair) usage is as follows:\\r\\n\\r\\n      No Button Pressed = 0000 No Operator Control Request\\r\\n      Increment Button Pressed  = 0001 Increment Operator Control Request\\r\\n      Decrement Button Pressed  = 0010 Decrement Operator Control Request\\r\\n      Invalid Switch Input(ex. inc./dec. values read simultaneously)  = 1110 Error Indicator\\r\\n\\r\\nData Values and Descriptions:\\r\\n0000 No Operator Control Request\\r\\n0001 Increment Operator Control Request\\r\\n0010 Decrement Operator Control Request\\r\\n0011 - 1101  Reserved\\r\\n1110 Error Indicator\\r\\n1111 Not installed\\r\\n\\r\\nNotes:  \\r\\n\\r\\n1.  The operator control state can be read in two ways.  One method uses the direct operator control input to determine the operator control state, while the second method relies on a secondary control to read the operator control input, then relay the information on the data link.  The parameter is designed to provide the actual operator control state to other controls that need the information.\\r\\n2.  Other systems with automated blade controls should be able to use this parameter, since it is an actual operator control value.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3338":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":28,"SPN":3338,"SPN_Name":"Side-shift Blade Control Mode Operator Control","SPN_Description":"This parameter indicates the side-shift offset operator control state the user has set for the land leveling system. When an implement moves in a side-shift direction, it moves from side to side, usually along its longitudinal axis. The desired side-shift offset value is the offset measured from a given vertical reference point to the center of the blade.\\r\\n\\r\\nOnly one of the following states will be active at a time. In the example below, the data values are defined for each switch type that may be used in an application. The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1. The momentary rocker switch may be used, where the default is the neutral position with no buttons pressed. The user can press the rocker into the increment button pressed position, and when pressure is released, it will return to the neutral position. The user may also press the rocker into the decrement button pressed position, and when pressure is released, it will return to the neutral position.  Momentary rocker button usage is as follows:\\r\\n\\r\\n - Neutral position = 0000   No Operator Control Request\\r\\n - Increment Button Pressed = 0001 Increment Operator Control Request\\r\\n - Decrement Button Pressed = 0010 Decrement Operator Control Request\\r\\n\\r\\n2. The momentary contact button pair may be used, where the default is the neutral position with no buttons pressed. The user can press the increment button, and when pressure is released, it will return to the neutral position. The user may press the decrement button, and when pressure is released, it will return to the neutral position. Momentary contact button (button pair) usage is as follows:\\r\\n\\r\\n - No Button Pressed = 0000 No Operator Control Request\\r\\n - Increment Button Pressed = 0001 Increment Operator Control Request\\r\\n - Decrement Button Pressed = 0010 Decrement Operator Control Request\\r\\n\\r\\nData Values and Descriptions:\\r\\n\\r\\n0000 No Operator Control Request\\r\\n0001 Increment Operator Control Request\\r\\n0010 Decrement Operator Control Request\\r\\n0011-1101 Reserved\\r\\n1110 Error Indicator\\r\\n1111 Not installed","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3339":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":32,"SPN":3339,"SPN_Name":"Side-shift Desired Blade Offset Operator Control","SPN_Description":"This parameter indicates the side-shift blade control mode operator control state the user has set for the land leveling system.  When an implement moves in a side-shift direction, it moves from side to side, usually along its longitudinal axis.\\r\\n\\r\\nThe operator control value directly correlates to the current operator control state.  Only one of the following states will be active at a time.  In the example below, the data values are defined for each switch type that may be used in an application.  The purpose of the following switch information is to define what data should be reported based on what type of switch is used.\\r\\n\\r\\n1.  A toggle button with two states can be used, in which the button is either in the manual or the auto position at all times.  Toggle button usage is as follows:\\r\\n     Manual Position  = 0010 Manual Operator Control Request\\r\\n     Auto Position  = 0011 Automatic Operator Control Request\\r\\n\\r\\n2.  The momentary rocker switch may be used, where the default is the no button pressed position.  The user can press the rocker into the manual position, and when pressure is released, it will return to the no button pressed position.  The user may also press the rocker into the auto position, and when pressure is released, it will return to the no button pressed position.  Momentary rocker button usage is as follows:\\r\\n     No Button Pressed = 0000 No Operator Control Request\\r\\n     Manual Button Pressed  = 0010 Manual Operator Control Request\\r\\n     Auto Button Pressed  = 0011 Automatic Operator Control Request\\r\\n\\r\\n3.  The momentary contact button pair may be used, where the default is no buttons being pressed.  The user can press the manual button, and when pressure is released, it will return to the no button pressed position.  The user may press the auto button, and when pressure is released, it will return to the no button pressed position.  Momentary contact buttons (button pair) usage is as follows:\\r\\n     No Button Pressed = 0000 No Operator Control Request\\r\\n     Manual Button Pressed  = 0010 Manual Operator Control Request\\r\\n     Auto Button Pressed  = 0011 Automatic Operator Control Request\\r\\n\\r\\n4.  The momentary contact single button may be used, where the default is no button being pressed.  The user can press the button, which is the button pressed position, and when pressure is released, it will return to the no button pressed position.  The controller receiving this command will keep track of what mode the blade is in, auto or manual.  If the blade is in manual mode to begin with, one press of the button will change to mode to auto.  If the button is pressed again, the blade will be put into manual mode.  Momentary contact button (single button) usage is as follows:\\r\\n     No Button Pressed = 0000 No Operator Control Request\\r\\n     Button Pressed  = 0001 Momentary Operator Control Request\\r\\n\\r\\nData Values and Descriptions:\\r\\n0000 No Operator Control Request\\r\\n0001 Momentary Operator Control Request\\r\\n0010 Manual Operator Control Request\\r\\n0011 Automatic Operator Control Request\\r\\n0100 - 1101   Reserved\\r\\n1110 Error Indicator\\r\\n1111 Not Installed","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3340":{"PGN":64938,"PGN_Name":"Engine Fluid Level/Pressure 4","PGN_Description":"EFL/P4","first_bit":0,"SPN":3340,"SPN_Name":"Engine Charge Air Cooler 1 Intake Pressure","SPN_Description":"Pressure of air at intake to 1st or only charge air cooler, from multiple first stage turbochargers being cooled and feeding multiple second stage turbochargers.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"3341":{"PGN":64938,"PGN_Name":"Engine Fluid Level/Pressure 4","PGN_Description":"EFL/P4","first_bit":8,"SPN":3341,"SPN_Name":"Engine Charge Air Cooler 2 Intake Pressure","SPN_Description":"Pressure of air at intake to 2nd charge air cooler, from multiple first stage turbochargers being cooled and feeding multiple second stage turbochargers.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"3342":{"PGN":64938,"PGN_Name":"Engine Fluid Level/Pressure 4","PGN_Description":"EFL/P4","first_bit":16,"SPN":3342,"SPN_Name":"Engine Coolant Pump Differential Pressure","SPN_Description":"The differential pressure measured across the input and output of the engine coolant pump.","bit_length":8,"scaling":1.64,"offset":-7,"unit":"kPa","SLOT_ID":246},"3343":{"PGN":64938,"PGN_Name":"Engine Fluid Level/Pressure 4","PGN_Description":"EFL/P4","first_bit":24,"SPN":3343,"SPN_Name":"Engine Centrifugal Oil Filter speed","SPN_Description":"The speed of a rotating (centrifugal) engine oil filter.","bit_length":16,"scaling":4,"offset":0,"unit":"rpm","SLOT_ID":77},"3344":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":272,"SPN":3344,"SPN_Name":"Support Variable Rate TSC1 Message","SPN_Description":"This parameter indicates which TSC1 transmission rates are supported by the engine ECU in addition to the required 10ms transmission rate for temporary powertrain control purposes. \\r\\n\\r\\nBit Position      Transmission Rate\\r\\n1                      1000 ms transmission rate    \\r\\n2                        750 ms transmission rate\\r\\n3                        500 ms transmission rate\\r\\n4                        250 ms transmission rate\\r\\n5                        100 ms transmission rate\\r\\n6                          50 ms transmission rate\\r\\n7                          20 ms transmission rate\\r\\n8                         Reserved for SAE assignment (set to one)\\r\\n\\r\\nWhere 0 = Transmission Rate Supported by Engine and 1 = Transmission Rate Not supported by Engine\\r\\n\\r\\nNote:  FF for this byte implies that the engine only supports standard temporary power train control (e.g. 10 ms)","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3345":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":280,"SPN":3345,"SPN_Name":"Support TSC1 Control Purpose Group 1","SPN_Description":"This parameter indicates which TSC1 control purposes are supported in group 1 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\\r\\n\\r\\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\\r\\n\\r\\n\\r\\nGroup 1 of 4\\r\\nBit Position    Control Purpose Value      Control Purpose Description\\r\\n       1                             P1                          Accelerator Pedal/Operator Selection\\r\\n       2                             P2                          Cruise Control\\r\\n       3                             P3                          PTO Governor\\r\\n       4                             P4                          Road Speed Governor\\r\\n       5                             P5                          Engine protection\\r\\n       6                             P6                          Reserved for assignment by SAE\\r\\n       7                             P7                          Reserved for assignment by SAE\\r\\n       8                             P8                          Reserved for assignment by SAE\\r\\n  \\r\\n\\r\\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3346":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":288,"SPN":3346,"SPN_Name":"Support TSC1 Control Purpose Group 2","SPN_Description":"This parameter indicates which TSC1 control purposes are supported in group 2 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\\r\\n\\r\\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\\r\\n\\r\\n\\r\\nGroup 2 of 4\\r\\nBit Position    Control Purpose Value      Control Purpose Description\\r\\n       1                             P9                          Reserved for assignment by SAE\\r\\n       2                             P10                          Reserved for assignment by SAE\\r\\n       3                             P11                        Reserved for assignment by SAE\\r\\n       4                             P12                        Reserved for assignment by SAE\\r\\n       5                             P13                        Reserved for assignment by SAE\\r\\n       6                             P14                        Reserved for assignment by SAE\\r\\n       7                             P15                        Reserved for assignment by SAE\\r\\n       8                             P16                        Reserved for assignment by SAE\\r\\n  \\r\\n\\r\\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3347":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":296,"SPN":3347,"SPN_Name":"Support TSC1 Control Purpose Group 3","SPN_Description":"This parameter indicates which TSC1 control purposes are supported in group 3 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\\r\\n\\r\\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\\r\\n\\r\\nGroup 3 of 4\\r\\nBit Position    Control Purpose Value      Control Purpose Description\\r\\n       1                             P17                        Reserved for assignment by SAE\\r\\n       2                             P18                        Reserved for assignment by SAE\\r\\n       3                             P19                        Reserved for assignment by SAE\\r\\n       4                             P20                        Reserved for assignment by SAE\\r\\n       5                             P21                        Reserved for assignment by SAE\\r\\n       6                             P22                        Reserved for assignment by SAE\\r\\n       7                             P23                        Reserved for assignment by SAE\\r\\n       8                             P24                        Reserved for assignment by SAE\\r\\n  \\r\\n\\r\\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3348":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":304,"SPN":3348,"SPN_Name":"Support TSC1 Control Purpose Group 4","SPN_Description":"This parameter indicates which TSC1 control purposes are supported in group 4 of 4. One bit is used to convey the support of each Control Purpose. A value of 0 equals supported and a value of 1 equals not supported. This bit logic is used to allow the default to FF to be backward compatible.\\r\\n\\r\\nThis group of 4 parameters (SPNs 3345, 3346, 3347, and 3348) indicates which TSC1 Control Purposes are supported by the engine ECU in addition to the Temporary Powertrain Control Purpose (which is denoted as control purpose P32). All ones in the Group 1 through 4 parameters indicates the engine only supports Temporary Powertrain Control.\\r\\n\\r\\nGroup 4 of 4\\r\\nBit Position    Control Purpose Value      Control Purpose Description\\r\\n       1                             P25                        Reserved for assignment by SAE\\r\\n       2                             P26                        Reserved for assignment by SAE\\r\\n       3                             P27                        Reserved for assignment by SAE\\r\\n       4                             P28                        Reserved for assignment by SAE\\r\\n       5                             P29                        Reserved for assignment by SAE\\r\\n       6                             P30                        Reserved for assignment by SAE\\r\\n       7                             P31                        Reserved for assignment by SAE\\r\\n       8                             See Note               Not assignable, must always be set to 1.       \\r\\n\\r\\nWhere 0 = Control Purpose is supported and 1 = Control Purpose is not supported\\r\\n\\r\\nNOTE: P32 is always supported and is Temporary Power Train Control (the original use of the TSC1 Command).\\r\\nThe engine configuration will not indicate separate support of Temporary Power Train Control mode.","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3349":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":32,"SPN":3349,"SPN_Name":"TSC1 Transmission Rate","SPN_Description":"This parameter indicates the transmission rate at which the sending device will transmit the TSC1 message.  The engine shall adjust its timeout for TSC1 messages accordingly. Variable TSC1 transmission rates shall only apply to messages sent to the engine.  \\r\\n\\r\\nA value of all ones is to be used in TSC1 messages directed to retarders because the TSC1 Transmission Rate parameter is not applicable for retarders. All TSC1 messages sent to the retarder shall use the standard 50 ms rate.\\r\\n\\r\\nDevices sending TSC1 messages to the engine should only invoke alternative transmission rates which the engine has indicated it supports in SPN 3344 \u2013 Support Variable Rate TSC1 Message.\\r\\n\\r\\n000 = 1000 ms transmission rate\\r\\n001 =   750 ms transmission rate\\r\\n010 =   500 ms transmission rate\\r\\n011 =   250 ms transmission rate\\r\\n100 =   100 ms transmission rate\\r\\n101 =     50 ms transmission rate\\r\\n110 =     20 ms transmission rate\\r\\n111 =   Use standard TSC1 transmission rates of 10 ms to engine\\r\\n\\r\\nNote:  Sending devices shall not send variable rate TSC1 messages to the engine for unsupported control purposes.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3350":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":35,"SPN":3350,"SPN_Name":"TSC1 Control Purpose","SPN_Description":"State signal which indicates which control mode the sending device is using to generate the TSC1 command.  Note that the modes are not in prioritized order. Not all modes may be relevant for a given device. Some devices may not implement all functions. For typical priorities refer to Figures SPN512_A, SPN512_B for engine control and Figure SPN695_A.  The TSC1 control purpose shall only apply to messages sent to the engine.  \\r\\n\\r\\nA value of all ones is to be used in TSC1 messages directed to retarders because the TSC1 Control Purpose parameter is not applicable for retarders.\\r\\n\\r\\n00000 =   P1 = Accelerator Pedal/Operator Selection\\r\\n00001 =   P2 = Cruise Control\\r\\n00010 =   P3 = PTO Governor\\r\\n00011 =   P4 = Road Speed Governor\\r\\n00100 =   P5 = Engine Protection\\r\\n00101 - 11110 =   P6-P31 = Reserved for SAE Assignment \\r\\n11111 = P32 = Temporary Power Train Control (Original use of TSC1 Command) \\r\\n\\r\\nNote:  Sending devices shall not send variable rate TSC1 messages to the engine for unsupported control purposes.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"3353":{"PGN":65237,"PGN_Name":"Alternator Information","PGN_Description":"AS","first_bit":16,"SPN":3353,"SPN_Name":"Alternator 1 Status","SPN_Description":"Alternator 1 operating status.\\r\\n\\r\\n00 Alternator 1 not charging\\r\\n01 Alternator 1 charging\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3354":{"PGN":65237,"PGN_Name":"Alternator Information","PGN_Description":"AS","first_bit":18,"SPN":3354,"SPN_Name":"Alternator 2 Status","SPN_Description":"Alternator 2 operating status.\\r\\n\\r\\n00 Alternator 2 not charging\\r\\n01 Alternator 2 charging\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3355":{"PGN":65237,"PGN_Name":"Alternator Information","PGN_Description":"AS","first_bit":20,"SPN":3355,"SPN_Name":"Alternator 3 Status","SPN_Description":"Alternator 3 operating status.\\r\\n\\r\\n00 Alternator 3 not charging\\r\\n01 Alternator 3 charging\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3356":{"PGN":65237,"PGN_Name":"Alternator Information","PGN_Description":"AS","first_bit":22,"SPN":3356,"SPN_Name":"Alternator 4 Status","SPN_Description":"Alternator 4 operating status.\\r\\n\\r\\n00 Alternator 4 not charging\\r\\n01 Alternator 4 charging\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3357":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":48,"SPN":3357,"SPN_Name":"Actual Maximum Available Engine - Percent Torque","SPN_Description":"This is the maximum amount of torque that the engine can immediately deliver as a percentage of the reference engine torque (SPN 544).  The Actual Maximum Available Engine - Percent Torque shall take into consideration all engine torque derates (e.g. air fuel ratio control (AFC), noise control, etc.) that could potentially be active in the system.  This parameter differentiates itself from the engine percent torque points 1 through 5 of the engine configuration map because it takes into account all dynamic internal inputs such as  AFC and that it is updated on a 50ms basis.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3358":{"PGN":64961,"PGN_Name":"Engine Fluid Level/Pressure 3","PGN_Description":"EFL/P3","first_bit":16,"SPN":3358,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Intake Pressure","SPN_Description":"EGR intake gage pressure is measured after the EGR cooler and before the EGR valve.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"3359":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":0,"SPN":3359,"SPN_Name":"Transmission Oil Filter Restriction Switch","SPN_Description":"This switch indicates whether the transmission oil filter is clogged.\\r\\n\\r\\n00 - No restriction\\r\\n01 - Restriction exists on oil filter\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3363":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":48,"SPN":3363,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Heater","SPN_Description":"Percentage of heating applied to the aftertreatment 1 diesel exhaust fluid tank heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.  See SPN 5137 for the command for this tank heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3365":{"PGN":61460,"PGN_Name":"Blade Information","PGN_Description":"BI","first_bit":0,"SPN":3365,"SPN_Name":"Relative Blade Height","SPN_Description":"The measured vertical distance from a fixed location on the machine blade to a ground-based reference (i.e. relative height).  Examples of a ground based reference include a curb, a stringline or the ground itself.  The measurement may be positive or negative based on the initial reference used.","bit_length":16,"scaling":0.1,"offset":-3200,"unit":"mm","SLOT_ID":13},"3366":{"PGN":61460,"PGN_Name":"Blade Information","PGN_Description":"BI","first_bit":32,"SPN":3366,"SPN_Name":"Relative Blade Height and Blade Rotation Angle Measurement Latency","SPN_Description":"The estimated measurement latency of the measurement.\\r\\n\\r\\nNOTE: This is only the sensor latency and does not include any additional latencies that might exist because of the CAN Bus or overall system implementation.\\r\\n\\r\\nFor example, if the technique used is a sonic pulse/echo system, the round trip time divided by two will be a reasonably accurate estimate of the measurement latency if the processing time is small with respect to the propagation time.","bit_length":8,"scaling":0.5,"offset":0,"unit":"ms","SLOT_ID":241},"3367":{"PGN":61460,"PGN_Name":"Blade Information","PGN_Description":"BI","first_bit":40,"SPN":3367,"SPN_Name":"Relative Blade Height Figure of Merit","SPN_Description":"Figure of merit for blade height measurement.\\r\\n\\r\\nBits\\r\\n00  Relative Blade Height fully functional.  Data is within sensor specification.   \\r\\n01  Relative Blade Height degraded.  Data is suspect due to environmental conditions.\\r\\n10  Relative Blade Height failed.  \\r\\n11  Relative Blade Height not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3368":{"PGN":64937,"PGN_Name":"Wireless Communications Message 1","PGN_Description":"WCM1","first_bit":0,"SPN":3368,"SPN_Name":"Network Transceiver Status 1","SPN_Description":"Indicates the status of the transceiver for the wireless communications network type\\r\\n\\r\\n0 = Off\\r\\n1 = On\\r\\n2 = Not Authorized to Operate on Network\\r\\n3-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3369":{"PGN":64937,"PGN_Name":"Wireless Communications Message 1","PGN_Description":"WCM1","first_bit":8,"SPN":3369,"SPN_Name":"Network Service Status 1","SPN_Description":"Indicates the status of the Service for the wireless communications network type\\r\\n\\r\\n0 = Local Service\\r\\n1 = Roaming Service\\r\\n2 = Service not available\\r\\n3 = Not Authorized to Operate on Service\\r\\n4-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3370":{"PGN":64937,"PGN_Name":"Wireless Communications Message 1","PGN_Description":"WCM1","first_bit":16,"SPN":3370,"SPN_Name":"Network Antenna Status 1","SPN_Description":"Indicates the status of the antenna for the wireless communications network type\\r\\n\\r\\n0 = Off\\r\\n1 = On\\r\\n2-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3371":{"PGN":64937,"PGN_Name":"Wireless Communications Message 1","PGN_Description":"WCM1","first_bit":24,"SPN":3371,"SPN_Name":"Network Signal Strength 1","SPN_Description":"Indicates the signal strength for the wireless communications network type.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3372":{"PGN":64937,"PGN_Name":"Wireless Communications Message 1","PGN_Description":"WCM1","first_bit":32,"SPN":3372,"SPN_Name":"Wireless Communication Network Type 1","SPN_Description":"Type of Wireless Communication Network\\r\\n\\r\\n0 = Cellular network #1\\r\\n1 = Cellular network #2\\r\\n2 = Wireless LAN #1\\r\\n3 = Wireless LAN #2\\r\\n4 = Satellite network\\r\\n5-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3375":{"PGN":64935,"PGN_Name":"Voltage Regulator Operating Mode","PGN_Description":"VROM","first_bit":0,"SPN":3375,"SPN_Name":"Voltage Regulator Load Compensation Mode","SPN_Description":"State signal indicating the voltage regulator load compensation mode.  Load compensation is when the voltage is adjusted based on the magnitude of load current\\r\\n\\r\\n000 - load compensation disabled\\r\\n001 - Voltage droop compensation enabled\\r\\n010 - IR line drop compensation enabled\\r\\n011 - Reserved\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Reserved\\r\\n111 - Not available\\r\\n\\r\\nNotes:\\r\\n\\r\\nVoltage droop compensation is used to minimize the amount of reactive current that flows between generators when they are parallelled together.  Excessive reactive current will result in the eventual failure of the generator exciter.\\r\\n\\r\\nIR line compensation increases the generator output voltage as the load increases so the voltage measured at the load will remain constant.  Without IR compensation, the voltage measured at the load drops due the IR losses in the power line.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3376":{"PGN":64935,"PGN_Name":"Voltage Regulator Operating Mode","PGN_Description":"VROM","first_bit":3,"SPN":3376,"SPN_Name":"Voltage Regulator VAr/Power Factor operating mode","SPN_Description":"State signal indicating the operating mode for the Voltage regulator VAr/Power Factor \\r\\n\\r\\n000 - VAr/Power Factor regulation disabled\\r\\n001 - Power factor regulation enabled\\r\\n010 - VAr regulation enabled\\r\\n011 - Reserved\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Reserved\\r\\n111 - Not available\\r\\n\\r\\nNote:\\r\\n\\r\\nThis parameter sets the mode of regulation for the voltage regulator.  The voltage regulator can regulate the generator AC output voltage by using the generator AC output voltage, the generator power factor, or the generator reactive power (VAr).  The generator AC output voltage, the generator power factor, and the generator reactive power (VAr) are defined in SAE J1939 - 75","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3377":{"PGN":64935,"PGN_Name":"Voltage Regulator Operating Mode","PGN_Description":"VROM","first_bit":6,"SPN":3377,"SPN_Name":"Voltage Regulator Underfrequency Compensation enabled","SPN_Description":"State signal indicating the operating mode for underfrequency compensation.\\r\\n\\r\\n00 - Underfrequency compensation disabled\\r\\n01 - Underfrequency compensation enabled\\r\\n10 - Reserved\\r\\n11 - Not available\\r\\n\\r\\nNote:\\r\\n\\r\\nUnderfrequency compensation is when the generator voltage is adjusted based on the generator frequency.  Typically generator voltage decreases as frequency decreases.  A frequency decrease occurs when load is increased on the genset.  Underfrequency compensation decreases the load by reducing the voltage as frequency decreases until a point is reached where the engine can accept more load.  Load is applied to the engine when the voltage increases with frequency.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3378":{"PGN":64935,"PGN_Name":"Voltage Regulator Operating Mode","PGN_Description":"VROM","first_bit":8,"SPN":3378,"SPN_Name":"Voltage Regulator Soft Start State","SPN_Description":"State signal indicating the mode of the Voltage regulator soft start function.  Soft start controls the generator voltage overshoot by controlling the rate of rise of the generator output voltage at generator start up.\\r\\n\\r\\n00 - Soft start is inactive\\r\\n01 - Soft start is active\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3379":{"PGN":64935,"PGN_Name":"Voltage Regulator Operating Mode","PGN_Description":"VROM","first_bit":10,"SPN":3379,"SPN_Name":"Voltage Regulator Enabled","SPN_Description":"State signal indicating the Voltage Regulator is enabled.  This parameter indicates whether the regulator is regulating or not regulating generator output voltage.\\r\\n\\r\\n00 - Not regulating voltage - unit disabled\\r\\n01 - Regulating voltage\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3380":{"PGN":64934,"PGN_Name":"Voltage Regulator Excitation Status","PGN_Description":"VREP","first_bit":0,"SPN":3380,"SPN_Name":"Generator Excitation Field Voltage","SPN_Description":"Measured signal that represents the generator excitation field voltage.  Generator excitation field voltage is indicative of the amount of excitation current being supplied by the voltage regulator to the generator field.","bit_length":16,"scaling":0.05,"offset":-1606,"unit":"V","SLOT_ID":249},"3381":{"PGN":64934,"PGN_Name":"Voltage Regulator Excitation Status","PGN_Description":"VREP","first_bit":16,"SPN":3381,"SPN_Name":"Generator Excitation Field Current","SPN_Description":"Measured signal that represents the generator excitation field current.","bit_length":16,"scaling":0.05,"offset":0,"unit":"A","SLOT_ID":250},"3382":{"PGN":64934,"PGN_Name":"Voltage Regulator Excitation Status","PGN_Description":"VREP","first_bit":32,"SPN":3382,"SPN_Name":"Generator Output Voltage Bias Percentage","SPN_Description":"Measured signal that represents the voltage bias percentage of the generator ouptput voltage being requested by external to the voltage regulator.  \\r\\n\\r\\nGenerator output voltage bias percentage is the amount of voltage in percent the generator output voltage will vary from the generator nominal setpoint.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":251},"3383":{"PGN":61461,"PGN_Name":"Requested Generator Total AC Reactive Power","PGN_Description":"RGTACRP","first_bit":0,"SPN":3383,"SPN_Name":"Requested Generator Total AC Reactive Power","SPN_Description":"The total reactive power requested to be delivered by the generator","bit_length":32,"scaling":1,"offset":-2000000000,"unit":"VA","SLOT_ID":148},"3384":{"PGN":61461,"PGN_Name":"Requested Generator Total AC Reactive Power","PGN_Description":"RGTACRP","first_bit":32,"SPN":3384,"SPN_Name":"Requested Generator Overall Power Factor","SPN_Description":"The requested average power factor of the generator.","bit_length":16,"scaling":0.00006103515625,"offset":-1,"unit":null,"SLOT_ID":151},"3385":{"PGN":61461,"PGN_Name":"Requested Generator Total AC Reactive Power","PGN_Description":"RGTACRP","first_bit":48,"SPN":3385,"SPN_Name":"Requested Generator Overall Power Factor Lagging","SPN_Description":"The requested lead/lag status for the generator average AC power factor\\r\\n\\r\\n00 - Leading\\r\\n01 - Lagging\\r\\n10 - Reserved\\r\\n11 - Not available or Not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3386":{"PGN":61468,"PGN_Name":"Requested Generator Average Basic AC Quantities","PGN_Description":"RGAAC","first_bit":0,"SPN":3386,"SPN_Name":"Requested Generator Average Line-Line AC RMS Voltage","SPN_Description":"The requested average AC RMS voltage to be delivered by the generator.","bit_length":32,"scaling":0.0078125,"offset":0,"unit":"V","SLOT_ID":252},"3387":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":0,"SPN":3387,"SPN_Name":"Engine Cylinder 1 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #1\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3388":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":2,"SPN":3388,"SPN_Name":"Engine Cylinder 2 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #2\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3389":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":4,"SPN":3389,"SPN_Name":"Engine Cylinder 3 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #3\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3390":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":6,"SPN":3390,"SPN_Name":"Engine Cylinder 4 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #4\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3391":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":8,"SPN":3391,"SPN_Name":"Engine Cylinder 5 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #5\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3392":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":10,"SPN":3392,"SPN_Name":"Engine Cylinder 6 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #6\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3393":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":12,"SPN":3393,"SPN_Name":"Engine Cylinder 7 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #7\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3394":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":14,"SPN":3394,"SPN_Name":"Engine Cylinder 8 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #8\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3395":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":16,"SPN":3395,"SPN_Name":"Engine Cylinder 9 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #9\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3396":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":18,"SPN":3396,"SPN_Name":"Engine Cylinder 10 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #10\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3397":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":20,"SPN":3397,"SPN_Name":"Engine Cylinder 11 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #11\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3398":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":22,"SPN":3398,"SPN_Name":"Engine Cylinder 12 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #12\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3399":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":24,"SPN":3399,"SPN_Name":"Engine Cylinder 13 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #13\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3400":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":26,"SPN":3400,"SPN_Name":"Engine Cylinder 14 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #14\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3401":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":28,"SPN":3401,"SPN_Name":"Engine Cylinder 15 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #15\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3402":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":30,"SPN":3402,"SPN_Name":"Engine Cylinder 16 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #16\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3403":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":32,"SPN":3403,"SPN_Name":"Engine Cylinder 17 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #17\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3404":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":34,"SPN":3404,"SPN_Name":"Engine Cylinder 18 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #18\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3405":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":36,"SPN":3405,"SPN_Name":"Engine Cylinder 19 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #19\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3406":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":38,"SPN":3406,"SPN_Name":"Engine Cylinder 20 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #20\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3407":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":40,"SPN":3407,"SPN_Name":"Engine Cylinder 21 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #21\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3408":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":42,"SPN":3408,"SPN_Name":"Engine Cylinder 22 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #22\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3409":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":44,"SPN":3409,"SPN_Name":"Engine Cylinder 23 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #23\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3410":{"PGN":61462,"PGN_Name":"Cylinder Combustion Status","PGN_Description":"CCS","first_bit":46,"SPN":3410,"SPN_Name":"Engine Cylinder 24 Combustion Status","SPN_Description":"This parameter is used to indicate state of combustion in engine cylinder #24\\r\\n\\r\\n00        No combustion\\r\\n01        Combustion exists\\r\\n10        Error\\r\\n11        Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3411":{"PGN":65102,"PGN_Name":"Door Control 1","PGN_Description":"DC1","first_bit":6,"SPN":3411,"SPN_Name":"Status 2 of doors","SPN_Description":"Composite indication of all bus door statuses. Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00   all bus doors are disabled\\r\\n01   at least 1 bus door enabled \\r\\n10   error\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3412":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":0,"SPN":3412,"SPN_Name":"Lock Status of Door 1","SPN_Description":"Lock status of bus door 1\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3413":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":2,"SPN":3413,"SPN_Name":"Open Status of Door 1","SPN_Description":"Open status of bus door 1\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3414":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":4,"SPN":3414,"SPN_Name":"Enable Status of Door 1","SPN_Description":"Enable status of bus door 1.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3415":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":6,"SPN":3415,"SPN_Name":"Lock Status of Door 2","SPN_Description":"Lock status of bus door 2\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3416":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":8,"SPN":3416,"SPN_Name":"Open Status of Door 2","SPN_Description":"Open status of bus door 2\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3417":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":10,"SPN":3417,"SPN_Name":"Enable Status of Door 2","SPN_Description":"Enable status of bus door 2.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3418":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":12,"SPN":3418,"SPN_Name":"Lock Status of Door 3","SPN_Description":"Lock status of bus door 3\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3419":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":14,"SPN":3419,"SPN_Name":"Open Status of Door 3","SPN_Description":"Open status of bus door 3\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3420":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":16,"SPN":3420,"SPN_Name":"Enable Status of Door 3","SPN_Description":"Enable status of bus door 3.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3421":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":18,"SPN":3421,"SPN_Name":"Lock Status of Door 4","SPN_Description":"Lock status of bus door 4\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3422":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":20,"SPN":3422,"SPN_Name":"Open Status of Door 4","SPN_Description":"Open status of bus door 4\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3423":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":22,"SPN":3423,"SPN_Name":"Enable Status of Door 4","SPN_Description":"Enable status of bus door 4.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3424":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":24,"SPN":3424,"SPN_Name":"Lock Status of Door 5","SPN_Description":"Lock status of bus door 5\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3425":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":26,"SPN":3425,"SPN_Name":"Open Status of Door 5","SPN_Description":"Open status of bus door 5\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3426":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":28,"SPN":3426,"SPN_Name":"Enable Status of Door 5","SPN_Description":"Enable status of bus door 5.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3427":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":30,"SPN":3427,"SPN_Name":"Lock Status of Door 6","SPN_Description":"Lock status of bus door 6\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3428":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":32,"SPN":3428,"SPN_Name":"Open Status of Door 6","SPN_Description":"Open status of bus door 6\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3429":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":34,"SPN":3429,"SPN_Name":"Enable Status of Door 6","SPN_Description":"Enable status of bus door 6.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3430":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":36,"SPN":3430,"SPN_Name":"Lock Status of Door 7","SPN_Description":"Lock status of bus door 7\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3431":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":38,"SPN":3431,"SPN_Name":"Open Status of Door 7","SPN_Description":"Open status of bus door 7\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3432":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":40,"SPN":3432,"SPN_Name":"Enable Status of Door 7","SPN_Description":"Enable status of bus door 7.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3433":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":42,"SPN":3433,"SPN_Name":"Lock Status of Door 8","SPN_Description":"Lock status of bus door 8\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3434":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":44,"SPN":3434,"SPN_Name":"Open Status of Door 8","SPN_Description":"Open status of bus door 8\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3435":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":46,"SPN":3435,"SPN_Name":"Enable Status of Door 8","SPN_Description":"Enable status of bus door 8.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3436":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":48,"SPN":3436,"SPN_Name":"Lock Status of Door 9","SPN_Description":"Lock status of bus door 9\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3437":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":50,"SPN":3437,"SPN_Name":"Open Status of Door 9","SPN_Description":"Open status of bus door 9\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3438":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":52,"SPN":3438,"SPN_Name":"Enable Status of Door 9","SPN_Description":"Enable status of bus door 9.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3439":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":54,"SPN":3439,"SPN_Name":"Lock Status of Door 10","SPN_Description":"Lock status of bus door 10\\r\\n\\r\\n00  unlocked \\r\\n01  locked\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3440":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":56,"SPN":3440,"SPN_Name":"Open Status of Door 10","SPN_Description":"Open status of bus door 10\\r\\n\\r\\n00  door closed\\r\\n01  door opened\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3441":{"PGN":64933,"PGN_Name":"Door Control 2","PGN_Description":"DC2","first_bit":58,"SPN":3441,"SPN_Name":"Enable Status of Door 10","SPN_Description":"Enable status of bus door 10.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00  door disabled\\r\\n01  door enabled\\r\\n10  error\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3442":{"PGN":64936,"PGN_Name":"Wireless Communications Message 2","PGN_Description":"WCM2","first_bit":0,"SPN":3442,"SPN_Name":"Network Transceiver Status 2","SPN_Description":"Indicates the status of the transceiver for the wireless communications network type\\r\\n\\r\\n0 = Off\\r\\n1 = On\\r\\n2 = Not Authorized to Operate on Network\\r\\n3-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3443":{"PGN":64936,"PGN_Name":"Wireless Communications Message 2","PGN_Description":"WCM2","first_bit":8,"SPN":3443,"SPN_Name":"Network Service Status 2","SPN_Description":"Indicates the status of the Service for the wireless communications network type\\r\\n\\r\\n0 = Local Service\\r\\n1 = Roaming Service\\r\\n2 = Service not available\\r\\n3 = Not Authorized to Operate on Service\\r\\n4-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3444":{"PGN":64936,"PGN_Name":"Wireless Communications Message 2","PGN_Description":"WCM2","first_bit":16,"SPN":3444,"SPN_Name":"Network Antenna Status 2","SPN_Description":"Indicates the status of the antenna for the wireless communications network type\\r\\n\\r\\n0 = Off\\r\\n1 = On\\r\\n2-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3445":{"PGN":64936,"PGN_Name":"Wireless Communications Message 2","PGN_Description":"WCM2","first_bit":24,"SPN":3445,"SPN_Name":"Network Signal Strength 2","SPN_Description":"Indicates the signal strength for the wireless communications network type.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3446":{"PGN":64936,"PGN_Name":"Wireless Communications Message 2","PGN_Description":"WCM2","first_bit":32,"SPN":3446,"SPN_Name":"Wireless Communication Network Type 2","SPN_Description":"Type of Wireless Communication Network\\r\\n\\r\\n0 = Cellular network #1\\r\\n1 = Cellular network #2\\r\\n2 = Wireless LAN #1\\r\\n3 = Wireless LAN #2\\r\\n4 = Satellite network\\r\\n5-250 = Reserved for Future Assignment\\r\\n251-253 = Reserved\\r\\n254 = Error\\r\\n255 = Not Available","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"3447":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":58,"SPN":3447,"SPN_Name":"Remote PTO Governor Preprogrammed Speed Control Switch #2","SPN_Description":"Switch signal which indicates that the remote PTO governor toggle switch #2 is in the enabled (ON) position. If the toggle switch is enabled and other conditions are satisfied then the remote PTO governor control feature is activated and the PTO governor will control at the preprogrammed speed #2.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not Available\\r\\n\\r\\nNote:  This switch is different than the 1-8 Preprogrammed Set Speeds because this is a physical switch input, not a user programmable set speed (although the associated PTO set speed for this toggle switch is user defined).","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3448":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":60,"SPN":3448,"SPN_Name":"Auxiliary Input Ignore Switch","SPN_Description":"Switch signal which overrides other switch input\'s ability to disable an engine\'s operating condition.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not Available\\r\\n\\r\\nThis switch input can be used to prevent the PTO from disengaging if another switch input\'s state changes.  For example, if the PTO is normally disengaged when the clutch is depressed, then this switch would allow the user to use PTO while depressing the clutch.\\r\\n\\r\\nInterlock switches which are specifically intended to inhibit PTO operation have priority over this parameter.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3452":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":6,"SPN":3452,"SPN_Name":"Enable Switch \u2013 Transmission input shaft PTO 1","SPN_Description":"Status of the operator\u2019s switch or other input which indicates the desire for engaging the first PTO drive mounted on the transmission case.  There may be more than one PTO drive mounted on the transmission case. \\r\\n\\r\\n00   Enable switch off \u2013 PTO operation not desired\\r\\n01   Enable switch on \u2013 PTO operation desired\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3453":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":4,"SPN":3453,"SPN_Name":"Enable Switch \u2013 Transmission input shaft PTO 2","SPN_Description":"Status of the operator\u2019s switch or other input which indicates the desire for engaging the second PTO drive mounted on the transmission case.   If there is only one PTO drive on the transmission case, use SPN 3452 Enable Switch \u2013 Transmission input shaft PTO 1.\\r\\n\\r\\n00   Enable switch off \u2013 PTO operation not desired\\r\\n01   Enable switch on \u2013 PTO operation desired\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3454":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":2,"SPN":3454,"SPN_Name":"Enable Switch \u2013 Transmission output shaft PTO","SPN_Description":"Status of the operator\u2019s switch or other input which indicates the desire for engaging the PTO drive mounted on the transmission output shaft. \\r\\n\\r\\n00   Enable switch off \u2013 PTO operation not desired\\r\\n01   Enable switch on \u2013 PTO operation desired\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3455":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":0,"SPN":3455,"SPN_Name":"Enable Switch \u2013 Transfer case output shaft PTO","SPN_Description":"Status of the operator\u2019s switch or other input which indicates the desire for engaging the PTO drive mounted on the output shaft of the transfer case. \\r\\n\\r\\n00   Enable switch off \u2013 PTO operation not desired\\r\\n01   Enable switch on \u2013 PTO operation desired\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3456":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":22,"SPN":3456,"SPN_Name":"Engagement Consent \u2013 Transmission input shaft PTO 1","SPN_Description":"Status of the transmission controller\u2019s consent to engage the first or sole PTO drive mounted on the transmission case.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed, while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.\\r\\n\\r\\n00   Consent not given \u2013 PTO drive should not be engaged\\r\\n01   Consent given \u2013 PTO drive may be engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3457":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":20,"SPN":3457,"SPN_Name":"Engagement Consent \u2013 Transmission input shaft PTO 2","SPN_Description":"Status of the transmission controller\u2019s consent to engage the second PTO drive mounted on the transmission case.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.  If there is only one PTO drive on the transmission case, use SPN 3456 Engagement Consent \u2013 Transmission input shaft PTO 1.\\r\\n\\r\\n00   Consent not given \u2013 PTO drive should not be engaged\\r\\n01   Consent given \u2013 PTO drive may be engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3458":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":18,"SPN":3458,"SPN_Name":"Engagement Consent \u2013 Transmission output shaft PTO","SPN_Description":"Status of the transmission controller\u2019s consent to engage the PTO drive connected to the transmission output shaft.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed, while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.\\r\\n\\r\\n00   Consent not given \u2013 PTO drive should not be engaged\\r\\n01   Consent given \u2013 PTO drive may be engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3459":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":16,"SPN":3459,"SPN_Name":"Engagement Consent \u2013 Transfer case output shaft PTO","SPN_Description":"Status of the transmission controller\u2019s consent to engage the PTO drive connected to the transfer case output shaft.  The controller in charge of the PTO drive should monitor this parameter and only engage the drive when consent is given.  If consent is removed, while the PTO drive is engaged, the drive controller should disengage the drive as soon as possible.  Engaging the drive or continuing drive engagement when consent is removed may result in damage to the transmission and / or the PTO drive mechanism.\\r\\n\\r\\n00   Consent not given \u2013 PTO drive should not be engaged\\r\\n01   Consent given \u2013 PTO drive may be engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3460":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":38,"SPN":3460,"SPN_Name":"Engagement Status \u2013 Transmission input shaft PTO 1","SPN_Description":"Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \\r\\n\\r\\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.  \\r\\n\\r\\n00   Drive not engaged\\r\\n01   Drive is engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3461":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":36,"SPN":3461,"SPN_Name":"Engagement Status \u2013 Transmission input shaft PTO 2","SPN_Description":"Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \\r\\n\\r\\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.\\r\\n\\r\\nIf there is only one PTO drive on the transmission case, SPN 3460 Engagement Status \u2013 Transmission input shaft PTO 1 should be used.  \\r\\n\\r\\n00   Drive not engaged\\r\\n01   Drive is engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3462":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":34,"SPN":3462,"SPN_Name":"Engagement Status \u2013 Transmission output shaft PTO","SPN_Description":"Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \\r\\n\\r\\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.  \\r\\n\\r\\n\\r\\n00   Drive not engaged\\r\\n01   Drive is engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3463":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":32,"SPN":3463,"SPN_Name":"Engagement Status \u2013 Transfer case output shaft PTO","SPN_Description":"Reports if this specific PTO drive is engaged.  This parameter should be broadcast only by the controller(s) receiving feedback about the specific drive.  \\r\\n\\r\\nFor example, a pressure switch may be used to determine if a PTO-driven pump has been engaged.  If the Body Controller (SA33) were monitoring this feedback signal, it should be the node broadcasting this parameter.  \\r\\n\\r\\n\\r\\n00   Drive not engaged\\r\\n01   Drive is engaged\\r\\n10   Error\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3464":{"PGN":61466,"PGN_Name":"Engine Throttle / Fuel Actuator Control Command","PGN_Description":"TFAC","first_bit":0,"SPN":3464,"SPN_Name":"Engine Throttle Actuator 1 Control Command","SPN_Description":"The control command to throttle actuator 1, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this throttle actuator is used to regulate air or air / fuel mix to the engine. Using the standard convention for determining the position.  Left/front is #1 and right/rear is #2 (SPN 3465).\\r\\n\\r\\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \\r\\n\\r\\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \\r\\n\\r\\nCalibration status from the actuator is received on SPN 5445.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3465":{"PGN":61466,"PGN_Name":"Engine Throttle / Fuel Actuator Control Command","PGN_Description":"TFAC","first_bit":16,"SPN":3465,"SPN_Name":"Engine Throttle Actuator 2 Control Command","SPN_Description":"The control command to throttle actuator 2, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this throttle actuator is used to regulate air or air / fuel mix to the engine. Using the standard convention for determining the position.  Left/front is #1 (SPN 3464) and right/rear is #2.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3466":{"PGN":64930,"PGN_Name":"Fuel Information 3 (Gaseous)","PGN_Description":"GFI3","first_bit":0,"SPN":3466,"SPN_Name":"Engine Fuel Valve 2 Intake Absolute Pressure","SPN_Description":"Absolute pressure of gas on intake side of the second fuel system control valve, using standard convention for determining position.\\r\\n\\r\\nIn a system with two fuel system control valves, left/front is #1 (SPN 1390) and right/rear is #2 (SPN 3466).\\r\\n\\r\\nIn a system with more than 2 fuel system control valves, the front left is #1 (SPN 1390), the front right is #2 (SPN 3466), the rear left is #3 (SPN 7505), and the rear right is #4 (SPN 7506).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3467":{"PGN":64930,"PGN_Name":"Fuel Information 3 (Gaseous)","PGN_Description":"GFI3","first_bit":16,"SPN":3467,"SPN_Name":"Engine Fuel System 2 Gas Mass Flow Rate","SPN_Description":"Gas mass flow rate delivered to an engine through its second fuel control system, using standard convention for determining position.\\r\\n\\r\\nIn a system with two fuel system control valves, left/front is #1 (SPN 1241) and right/rear is #2 (SPN 3467).\\r\\n\\r\\nIn a system with more than 2 fuel systems, the front left is #1 (SPN 1241), the front right is #2 (SPN 3467), the rear left is #3 (SPN 7509), and the rear right is #4 (SPN 7510).","bit_length":16,"scaling":0.05,"offset":0,"unit":"kg/h","SLOT_ID":18},"3468":{"PGN":64930,"PGN_Name":"Fuel Information 3 (Gaseous)","PGN_Description":"GFI3","first_bit":32,"SPN":3468,"SPN_Name":"Engine Fuel 1 Temperature 2","SPN_Description":"Second Temperature measurement of fuel (or gas) of the first fuel type. See SPN 174 for first fuel temperature measurement.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"3469":{"PGN":64930,"PGN_Name":"Fuel Information 3 (Gaseous)","PGN_Description":"GFI3","first_bit":48,"SPN":3469,"SPN_Name":"Engine Fuel Valve 2 Outlet Absolute Pressure","SPN_Description":"Absolute pressure of gas on outlet side of the second fuel system control valve.  See SPN 2980 for the first or only fuel system control valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3470":{"PGN":64931,"PGN_Name":"Electronic Engine Controller 6","PGN_Description":"EEC6","first_bit":0,"SPN":3470,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Command","SPN_Description":"The command to a compressor bypass actuator, normalized to percent, where 0% nominally represents fully closed and 100% represents fully open.  Typically, the turbocharger compressor bypass actuator is used to keep the engine out of surge by metering compressed air (charge).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3479":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":32,"SPN":3479,"SPN_Name":"Aftertreatment 1 Fuel Pressure 1 Control","SPN_Description":"Position that the controller is commanding the aftertreatment 1 fuel pressure control to maintain.  0% = fully closed, 100% = fully open.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3480":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":0,"SPN":3480,"SPN_Name":"Aftertreatment 1 Fuel Pressure 1","SPN_Description":"First fuel pressure measurement for the aftertreatment 1 system","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3481":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":16,"SPN":3481,"SPN_Name":"Aftertreatment 1 Fuel Rate","SPN_Description":"Rate of fuel being delivered to aftertreatment 1 for regeneration","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"3482":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":54,"SPN":3482,"SPN_Name":"Aftertreatment 1 Fuel Enable Actuator","SPN_Description":"Indicates whether aftertreatment 1 fuel enable actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3483":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":52,"SPN":3483,"SPN_Name":"Aftertreatment 1 Regeneration Status","SPN_Description":"Indicates whether regeneration is active or inactive in aftertreatment 1.  \\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3484":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":50,"SPN":3484,"SPN_Name":"Aftertreatment 1 Ignition","SPN_Description":"Indicates whether aftertreatment 1 ignition circuit is energized by the ECU.\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3485":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":0,"SPN":3485,"SPN_Name":"Aftertreatment 1 Supply Air Pressure","SPN_Description":"Pressure of the supply air for aftertreatment 1.  Supply air is the air supplied from a pneumatic line for an air-assisted or pneumatic actuator.  One example is an air assisted fuel injector (the supply air assists in the atomization of fuel).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3486":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":16,"SPN":3486,"SPN_Name":"Aftertreatment 1 Purge Air Pressure","SPN_Description":"Pressure of the purge air supply for aftertreatment 1","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3487":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":32,"SPN":3487,"SPN_Name":"Aftertreatment 1 Air Pressure Control","SPN_Description":"Position that the controller is commanding the aftertreatment 1 air pressure control to maintain.  0% = fully closed, 100% = fully open","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3488":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":48,"SPN":3488,"SPN_Name":"Aftertreatment 1 Air Pressure Actuator Position","SPN_Description":"Position of the aftertreatment 1 air pressure actuator as measured by a position feedback sensor.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3489":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":62,"SPN":3489,"SPN_Name":"Aftertreatment 1 Air Enable Actuator","SPN_Description":"Indicates whether aftertreatment 1 air enable actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3490":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":60,"SPN":3490,"SPN_Name":"Aftertreatment 1 Purge Air Actuator","SPN_Description":"Indicates whether aftertreatment 1 purge air actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3491":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":58,"SPN":3491,"SPN_Name":"Aftertreatment 1 Atomization Air Actuator","SPN_Description":"Indicates whether aftertreatment 1 atomization air actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3492":{"PGN":64927,"PGN_Name":"Aftertreatment 1 Air Control 1","PGN_Description":"AT1AC1","first_bit":56,"SPN":3492,"SPN_Name":"Aftertreatment 1 Air System Relay","SPN_Description":"Indicates whether aftertreatment 1 air system relay is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3493":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":32,"SPN":3493,"SPN_Name":"Aftertreatment 2 Fuel Pressure 1 Control","SPN_Description":"Position that the controller is commanding the aftertreatment 2 fuel pressure control to maintain.  0% = fully closed, 100% = fully open.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3494":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":0,"SPN":3494,"SPN_Name":"Aftertreatment 2 Fuel Pressure 1","SPN_Description":"Pressure of the fuel for Aftertreatment 2.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3495":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":16,"SPN":3495,"SPN_Name":"Aftertreatment 2 Fuel Rate","SPN_Description":"Rate of fuel being delivered to aftertreatment 2 for regeneration","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"3496":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":54,"SPN":3496,"SPN_Name":"Aftertreatment 2 Fuel Enable Actuator","SPN_Description":"Indicates whether aftertreatment 2 fuel enable actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3497":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":52,"SPN":3497,"SPN_Name":"Aftertreatment 2 Regeneration Status","SPN_Description":"Indicates whether regeneration is active or inactive in aftertreatment 2.  \\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3498":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":50,"SPN":3498,"SPN_Name":"Aftertreatment 2 Ignition","SPN_Description":"Indicates whether aftertreatment 2 ignition circuit is energized by the ECU.\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3499":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":0,"SPN":3499,"SPN_Name":"Aftertreatment 2 Supply Air Pressure","SPN_Description":"Pressure of the supply air for aftertreatment 2.  Supply air is the air supplied from a pneumatic line for an air-assisted or pneumatic actuator.  One example is an air assisted fuel injector (the supply air assists in the atomization of fuel).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3500":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":16,"SPN":3500,"SPN_Name":"Aftertreatment 2 Purge Air Pressure","SPN_Description":"Pressure of the purge air supply for aftertreatment 2","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3501":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":32,"SPN":3501,"SPN_Name":"Aftertreatment 2 Air Pressure Control","SPN_Description":"Position that the controller is commanding the aftertreatment 2 air pressure control to maintain.  0% = fully closed, 100% = fully open","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3502":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":48,"SPN":3502,"SPN_Name":"Aftertreatment 2 Air Pressure Actuator Position","SPN_Description":"Position of the aftertreatment 2 air pressure actuator as measured by a position feedback sensor.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3503":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":62,"SPN":3503,"SPN_Name":"Aftertreatment 2 Air Enable Actuator","SPN_Description":"Indicates whether aftertreatment 2 air enable actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3504":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":60,"SPN":3504,"SPN_Name":"Aftertreatment 2 Purge Air Actuator","SPN_Description":"Indicates whether aftertreatment 2 purge air actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3505":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":58,"SPN":3505,"SPN_Name":"Aftertreatment 2 Atomization Air Actuator","SPN_Description":"Indicates whether aftertreatment 2 atomization air actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3506":{"PGN":64926,"PGN_Name":"Aftertreatment 2 Air Control 1","PGN_Description":"AT2AC1","first_bit":56,"SPN":3506,"SPN_Name":"Aftertreatment 2 Air System Relay","SPN_Description":"Indicates whether aftertreatment 2 air system relay is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3509":{"PGN":64925,"PGN_Name":"Sensor Electrical Power #1","PGN_Description":"SEP1","first_bit":0,"SPN":3509,"SPN_Name":"Sensor supply voltage 1","SPN_Description":"Sensor ECU supply voltage 1","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3510":{"PGN":64925,"PGN_Name":"Sensor Electrical Power #1","PGN_Description":"SEP1","first_bit":16,"SPN":3510,"SPN_Name":"Sensor supply voltage 2","SPN_Description":"Sensor ECU supply voltage 2","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3511":{"PGN":64925,"PGN_Name":"Sensor Electrical Power #1","PGN_Description":"SEP1","first_bit":32,"SPN":3511,"SPN_Name":"Sensor supply voltage 3","SPN_Description":"Sensor ECU supply voltage 3","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3512":{"PGN":64925,"PGN_Name":"Sensor Electrical Power #1","PGN_Description":"SEP1","first_bit":48,"SPN":3512,"SPN_Name":"Sensor supply voltage 4","SPN_Description":"Sensor ECU supply voltage 4","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3513":{"PGN":64924,"PGN_Name":"Sensor Electrical Power #2","PGN_Description":"SEP2","first_bit":0,"SPN":3513,"SPN_Name":"Sensor supply voltage 5","SPN_Description":"Sensor ECU supply voltage 5","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3514":{"PGN":64924,"PGN_Name":"Sensor Electrical Power #2","PGN_Description":"SEP2","first_bit":16,"SPN":3514,"SPN_Name":"Sensor supply voltage 6","SPN_Description":"Sensor ECU supply voltage 6","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3515":{"PGN":64923,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 1","PGN_Description":"A1DEFI1","first_bit":0,"SPN":3515,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Temperature 2","SPN_Description":"Temperature of the diesel exhaust fluid at the device measuring diesel exhaust fluid quality","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"3516":{"PGN":64923,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 1","PGN_Description":"A1DEFI1","first_bit":8,"SPN":3516,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Concentration","SPN_Description":"A measure of the concentration of urea in water.  Zero percent means that the tank contains no urea.  A 32.5% value indicates that the diesel exhaust fluid is of the proper concentration.  The 32.5% value indicates that the concentration is highest quality.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.25,"offset":0,"unit":"%","SLOT_ID":254},"3517":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":16,"SPN":3517,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Level","SPN_Description":"The diesel exhaust fluid level height in mm in the diesel exhaust fluid storage container for aftertreatment system 1 (exhaust bank 1).  See SPN 1761 and SPN 7530 for alternate measurements. \\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"3518":{"PGN":64923,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 1","PGN_Description":"A1DEFI1","first_bit":16,"SPN":3518,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Conductivity","SPN_Description":"A measure of the conductivity of the diesel exhaust fluid at the sensor.  The conductivity is an indication of the diesel exhaust fluid\'s chemical make up.","bit_length":8,"scaling":5,"offset":0,"unit":"\xb5Siemens/mm","SLOT_ID":255},"3519":{"PGN":64923,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 1","PGN_Description":"A1DEFI1","first_bit":24,"SPN":3519,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Temperature 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid temperature sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3520":{"PGN":64923,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 1","PGN_Description":"A1DEFI1","first_bit":32,"SPN":3520,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Properties Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid properties sensor.  This may be used for indicating failures of the diesel exhaust fluid concentration, diesel exhaust fluid conductivity or diesel exhaust fluid type. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3521":{"PGN":64923,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 1","PGN_Description":"A1DEFI1","first_bit":40,"SPN":3521,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Property","SPN_Description":"This parameter indicates the property of the fluid compound in the tank.  A value of 0011 indicates uncontaminated Diesel Exhaust Fluid.\\r\\n\\r\\n0000 - Urea concentration too high\\r\\n0001 - Urea concentration too low\\r\\n0010 - Fluid is diesel\\r\\n0011 - Diesel exhaust fluid is proper mixture\\r\\n0100 to 1011 - Reserved for SAE assignment\\r\\n1100 - Diesel exhaust fluid, but concentration cannot be determined\\r\\n1101 - Not able to determine fluid property (fluid type unknown)\\r\\n1110 - Error with diesel exhaust fluid property detection\\r\\n1111 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3522":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":0,"SPN":3522,"SPN_Name":"Aftertreatment 1 Total Fuel Used","SPN_Description":"Total amount of fuel used by aftertreatment device 1 over the lifetime of the device.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"3523":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":32,"SPN":3523,"SPN_Name":"Aftertreatment 1 Total Regeneration Time","SPN_Description":"Total amount of time that aftertreatment device 1 has been regenerating over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3524":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":64,"SPN":3524,"SPN_Name":"Aftertreatment 1 Total Disabled Time","SPN_Description":"Total amount of time that aftertreatment 1 regeneration has been manually disabled.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3525":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":96,"SPN":3525,"SPN_Name":"Aftertreatment 1 Total Number of Active Regenerations","SPN_Description":"Total number of active regenerations by aftertreatment device 1 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3526":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":0,"SPN":3526,"SPN_Name":"Aftertreatment 2 Total Fuel Used","SPN_Description":"Total amount of fuel used by aftertreatment device 2 over the lifetime of the device.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"3527":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":32,"SPN":3527,"SPN_Name":"Aftertreatment 2 Total Regeneration Time","SPN_Description":"Total amount of time that aftertreatment device 2 has been regenerating over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3528":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":64,"SPN":3528,"SPN_Name":"Aftertreatment 2 Total Disabled Time","SPN_Description":"Total amount of time that aftertreatment 2 regeneration has been manually disabled.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3529":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":96,"SPN":3529,"SPN_Name":"Aftertreatment 2 Total Number of Active Regenerations","SPN_Description":"Total number of active regenerations by aftertreatment device 2 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3532":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":32,"SPN":3532,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Level/Volume Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid tank level sensor by the manufacturer\'s sensor control software.  This FMI is applicable to either the diesel exhaust fluid tank level or diesel exhaust fluid tank volume parameters.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"3533":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":2,"SPN":3533,"SPN_Name":"Transmission Oil Level Switch","SPN_Description":"This switch indicates whether transmission oil level is full or empty.\\r\\n\\r\\n00 - Empty\\r\\n01 - Full or not empty\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3542":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":0,"SPN":3542,"SPN_Name":"Requested Engine Control Mode","SPN_Description":"This parameter is used to request a change to the engine control mode.  This is a status parameter.  \\r\\nBit state 0000 = Normal Engine Shutdown\\r\\nBit state 0001 = Rapid Engine Shutdown\\r\\nBit state 0010 = Emergency Engine Shutdown\\r\\nBit state 0011 = Normal Engine Start\\r\\nBit state 0100 = Rapid Engine Start\\r\\nBit states 0101-1101 = available for SAE assignment\\r\\nBit state 1110 = <reserved>\\r\\nBit state 1111 = Don\'t Care / Take No Action\\r\\n\\n\\nNormal Engine Shutdown - \\nUsed to request that the engine control system shut down the engine, using the normal shutdown sequence for the engine.  The shutdown sequence might include cool down or other intermediate states that delay stopping the engine.\\r\\n\\nRapid Engine Shutdown - \\nUsed to request that the engine control system shut down the engine, using an abbreviated shutdown sequence for the engine.  The intent is that the rapid engine shutdown take less time than a normal engine shutdown, but the specific shutdown sequence will depend on the configuration of the engine control system.\\r\\n\\nEmergency Engine Shutdown - \\nUsed to request that the engine control system shut down the engine, using the emergency shutdown sequence for the engine.  The intent is to shut down the engine in the fastest possible manner, using all mechanisms available.  All intermediate states that delay stopping the engine must be skipped for an emergency engine shutdown.  In addition, any installed emergency stop aids (such as air shutoff, Jake Brakes, etc.) must be activated for an emergency shutdown.\\r\\n\\nNormal Engine Start - \\nUsed to request that the engine control system start the engine, using the normal starting sequence for the engine.  All starting aids and pre-start states will be employed as appropriate for the engine and the current operating conditions.\\r\\n\\nRapid Engine Start - \\nUsed to request that the engine control system start the engine, using an abbreviated starting sequence for the engine.  The intent is that the rapid engine start take less time than a normal engine start, but the specific starting sequence will depend on the configuration of the engine control system.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3543":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":0,"SPN":3543,"SPN_Name":"Engine Operating State","SPN_Description":"This parameter is used to indicate the current state, or mode, of operation by the engine.  This is a status parameter.\\r\\n\\r\\nBit state 0000 = Engine Stopped\\r\\nBit state 0001 = Pre-Start\\r\\nBit state 0010 = Starting\\r\\nBit state 0011 = Warm-Up\\r\\nBit state 0100 = Running\\r\\nBit state 0101 = Cool-down\\r\\nBit state 0110 = Engine Stopping\\r\\nBit state 0111 = Post-Run\\r\\nBit states 1000-1101 = available for SAE assignment\\r\\nBit state 1110 = <reserved>\\r\\nBit state 1111 = not available\\r\\n\\n\\nSTOPPED - \\nIn the stopped state, the ECM is powered and the engine is not turning.  The engine is ready to start.\\r\\n\\nPRE-START - \\nIn the PRE-START state, the engine is not running.  Actions are taken by various subsystem controls to prepare the engine for cranking and starting.  This may include any priming, prelubrication, preheating sequences, interlocks or other start permissives.  These subsystems have their own state based control and communicate their status to the engine state control logic.\\r\\n\\nSTARTING - \\nDuring the STARTING state, actions are taken by various subsystem controls to attempt to start the engine.\\r\\n\\nWARM-UP - \\nDuring the WARM-UP state, the engine operates at reduced speed and / or load to allow the engine to come up to operating temperature.\\r\\n\\nRUNNING - \\nIn the RUNNING state, the engine is turning and is prepared to output power.\\r\\n\\nCOOL-DOWN - \\nDuring the COOLDOWN state, the engine operates at reduced speed and / or load to allow the engine to cool off before the engine is stopped.\\r\\n\\nSTOPPING - \\nIn the STOPPING state, actions are taken by various subsystem controls to attempt to stop the engine.\\r\\n\\nPOST-RUN - \\nDuring the POST-RUN state, the engine is not turning.  Actions are taken by various subsystem controls to prevent engine damage and extend component life.  The engine is not ready to start.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3544":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":8,"SPN":3544,"SPN_Name":"Time Remaining in Engine Operating State","SPN_Description":"This parameter is used to indicate the time remaining in the current engine operating state, based on the state defined in the SPN \\"Engine Operating State\\" (SPN 3543). For the states in which time remaining is not applicable, use 65535 ($FFFF).","bit_length":16,"scaling":1,"offset":0,"unit":"s","SLOT_ID":64},"3545":{"PGN":64913,"PGN_Name":"AC Switching Device Status","PGN_Description":"ACS","first_bit":0,"SPN":3545,"SPN_Name":"Generator Circuit Breaker Status","SPN_Description":"This parameter indicates the measured state of the generator circuit breaker.\\n \\r\\n\\r\\n000 - Open\\r\\n001 - Closed\\r\\n010 - Locked Out\\r\\n011 - Transitioning to Open state\\r\\n100 - Transitioning to Closed state\\r\\n101 - Available for SAE assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3546":{"PGN":64913,"PGN_Name":"AC Switching Device Status","PGN_Description":"ACS","first_bit":3,"SPN":3546,"SPN_Name":"Utility Circuit Breaker Status","SPN_Description":"This parameter indicates the measured state of the utility circuit breaker.\\r\\n\\n\\n000 - Open\\r\\n001 - Closed\\r\\n010 - Locked Out\\r\\n011 - Transitioning to Open state\\r\\n100 - Transitioning to Closed state\\r\\n101 - Available for SAE assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3547":{"PGN":64913,"PGN_Name":"AC Switching Device Status","PGN_Description":"ACS","first_bit":8,"SPN":3547,"SPN_Name":"Automatic Transfer Switch Status","SPN_Description":"This parameter indicates the measured state of the automatic transfer switch.\\r\\r\\n\\r\\n000 - Normal position\\r\\r\\n001 - Emergency position\\r\\n010 - Available for SAE assignment\\r\\n011 - Transitioning to Normal position\\r\\n100 - Transitioning to Emergency position\\r\\n101 - Available for SAE assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3548":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":24,"SPN":3548,"SPN_Name":"Engine Waste Oil Reservoir Level","SPN_Description":"Level of crankcase blowby emulsion collected by a container.  Normalized to percent, 0% represents completely empty and 100% represents completely full.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3549":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":32,"SPN":3549,"SPN_Name":"Engine Oil Filter Outlet Pressure","SPN_Description":"Oil pressure (gage) measured just downstream of oil filter.Used in conjunction with SPN1208 (pre-filter oil pressure) to determine oil filter health.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"3550":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":40,"SPN":3550,"SPN_Name":"Engine Oil Priming Pump Switch","SPN_Description":"Switch input for activating the engine oil priming pump.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Error\\r\\n11 = Not available or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3551":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":42,"SPN":3551,"SPN_Name":"Engine Oil Priming State","SPN_Description":"Determination of whether or not the engine is (or has recently been) sufficiently lubricated for starting purposes.\\r\\n\\r\\n00 = Not sufficiently lubricated\\r\\n01 = Sufficiently lubricated\\r\\n10 = Unable to determine if sufficiently lubricated\\r\\n11 = Not available or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3552":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":44,"SPN":3552,"SPN_Name":"Engine Oil Pre-Heated State","SPN_Description":"Indicates whether the engine oil pre-heated sufficiently for starting purposes.\\r\\n\\r\\n00 = Not sufficiently pre-heated\\r\\n01 = Sufficiently pre-heated\\r\\n10 = Unable to determine if engine oil is pre-heated sufficiently\\r\\n11 = Not available or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3553":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":46,"SPN":3553,"SPN_Name":"Engine Coolant Pre-heated State","SPN_Description":"Indicates whether the engine coolant is pre-heated sufficiently for starting purposes.\\r\\n\\r\\n00 = Not sufficiently pre-heated\\r\\n01 = Sufficiently pre-heated\\r\\n10 = Unable to determine  engine coolant pre-heated sufficiently\\r\\n11 = Not available or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3554":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":48,"SPN":3554,"SPN_Name":"Engine Ventilation Status","SPN_Description":"Engine ventilation control states.\\r\\n\\r\\n000 = Sufficiently vented (all combustible gases have been evacuated from intake and exhaust systems)\\r\\n001 = Ventilation needed (combustible gases may be present in intake and exhaust systems)\\r\\n010 = Ventilation delay (delay without cranking between ventilation and start engine states)\\r\\n011 = Currently venting (engine cranks w/o gas or ignition to clear intake and exhaust systems with air)\\r\\n100 = Reserved for SAE assignment\\r\\n101 = Reserved for SAE assignment \\r\\n110 = Not able to determine if sufficiently vented\\r\\n111 = Not available or not installe","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3557":{"PGN":65274,"PGN_Name":"Brakes 1","PGN_Description":"B1","first_bit":26,"SPN":3557,"SPN_Name":"Parking Brake Red Warning Signal","SPN_Description":"This parameter commands the Parking Brake red optical warning signal.\\r\\n\\r\\n00 \u2013 off\\r\\n01 \u2013 on\\r\\n10 \u2013 Reserved \\r\\n11 \u2013 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3558":{"PGN":64912,"PGN_Name":"Advertised Engine Torque Curve","PGN_Description":"AETC","first_bit":0,"SPN":3558,"SPN_Name":"AETC Data Collection Standard","SPN_Description":"Indicates the standardized method by which torque data was obtained for the Advertised Engine Torque Curve (AETC).  For example, in North America, heavy duty diesel engine specifications are typically based on SAE J1995.  Other applicable SAE, ISO, or DIN standards may be added as necessary in the future.\\r\\n\\r\\n0000             SAE J1995\\r\\n0001-1101   Not Defined\\r\\n1111             Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3559":{"PGN":64912,"PGN_Name":"Advertised Engine Torque Curve","PGN_Description":"AETC","first_bit":4,"SPN":3559,"SPN_Name":"Number of AETC data points","SPN_Description":"Indicates the number of speed / torque data points contained in the Advertised Engine Torque Curve broadcast (AETC).  A minimum of 5 points is required, with a maximum of 15 points available as needed to accurately convey the curve.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3562":{"PGN":64976,"PGN_Name":"Intake/Exhaust Conditions 2","PGN_Description":"IC2","first_bit":24,"SPN":3562,"SPN_Name":"Engine Intake Manifold #2 Pressure","SPN_Description":"The gage pressure measurement of the air intake manifold for bank #2 or the second air intake manifold. If there are multiple air pressure sensors in the second intake stream, this is the last one in flow direction before entering the combustion chamber. See also SPNs 1127-1130 and SPN 102 for alternate range and resolution.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"3563":{"PGN":64976,"PGN_Name":"Intake/Exhaust Conditions 2","PGN_Description":"IC2","first_bit":32,"SPN":3563,"SPN_Name":"Engine Intake Manifold #1 Absolute Pressure","SPN_Description":"The absolute pressure measurement of the air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"3564":{"PGN":43264,"PGN_Name":"Forward Lane Image Command","PGN_Description":"FLIC","first_bit":0,"SPN":3564,"SPN_Name":"Lane Departure Warning Enable Command","SPN_Description":"Command to enable/disable Lane Departure Indication\\r\\n\\r\\n00   Disable Lane Departure Warning\\r\\n01   Enable Lane Departure Warning\\r\\n10   Reserved\\r\\n11   Don\xb4t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3565":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":0,"SPN":3565,"SPN_Name":"Lane Departure Left","SPN_Description":"Indicates that the middle of vehicle departs the lane on the left side. The parameter indicates that the vehicle is changing the lane to the left.\\r\\n\\r\\n00   Middle of the vehicle does not depart the lane to the left side\\r\\n01   Middle of the vehicle departs the lane to the left side\\r\\n10   Reserved\\r\\n11   Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3566":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":2,"SPN":3566,"SPN_Name":"Lane Departure Right","SPN_Description":"Indicates that the middle of vehicle departs the lane on the right side. The parameter indicates that the vehicle is changing the lane to the right.\\r\\n\\r\\n00   Middle of the vehicle does not depart the lane to the right side\\r\\n01   Middle of the vehicle departs the lane to the right side\\r\\n10   Reserved\\r\\n11   Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3567":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":4,"SPN":3567,"SPN_Name":"Generator Control Not In Automatic Start State","SPN_Description":"This parameter indicates whether or not the generator set is in a condition to automatically start up and provide power. If not, this status parameter is in the ACTIVE state.\\r\\n\\r\\n00 = inactive (ready to start automatically)\\r\\n01 = active (not ready to start automatically)\\r\\n10 = error\\r\\n11 = not available\\r\\n\\r\\nNote:  Legislative requirements for generator sets require that this condition be visually indicated (alarmed) on the local generator set control and remotely indicated on ancillary monitoring devices. The state has been defined in this manner (\'Not in automatic start\\") to allow the use of FMI 31 to indicate NOT ready to automatically start up and provide power, which is an undesired condition.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3568":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":6,"SPN":3568,"SPN_Name":"Generator Not Ready to Automatically Parallel State","SPN_Description":"This parameter indicates whether or not all systems required to start the engine and close to the bus are prepared to operate automatically. If not, the generator is not ready to automatically parallel, and the status parameter is in the ACTIVE state.\\r\\n\\r\\n00 = inactive (ready to parallel)\\r\\n01 = active (not ready to parallel)\\r\\n10 = error\\r\\n11 = not available\\r\\n\\r\\nNote:  Legislative requirements for generator sets require that this condition be visually indicated (alarmed) on the local generator set control and remotely indicated on ancillary monitoring devices. The state has been defined in this manner (\\"Not ready\\") to allow the use of FMI 31 to indicate NOT ready to automatically parallel, which is an undesired condition.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3589":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":32,"SPN":3589,"SPN_Name":"Engine Oil Priming Pump Control","SPN_Description":"This control is used to activate a pump that lubricates the engine, particularly prior to initial engine startup.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Reserved\\r\\n11 = unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3590":{"PGN":64911,"PGN_Name":"Generator Total AC Percent Power","PGN_Description":"GTACPP","first_bit":0,"SPN":3590,"SPN_Name":"Generator Total Percent kW","SPN_Description":"This parameter reports the generator total AC power, as a percentage of rated power.","bit_length":16,"scaling":0.0078125,"offset":-251,"unit":"%","SLOT_ID":256},"3591":{"PGN":64911,"PGN_Name":"Generator Total AC Percent Power","PGN_Description":"GTACPP","first_bit":16,"SPN":3591,"SPN_Name":"Generator Total Percent kVA","SPN_Description":"This parameter reports the generator total AC apparent power, as a percentage of rated power.","bit_length":16,"scaling":0.0078125,"offset":-251,"unit":"%","SLOT_ID":256},"3592":{"PGN":64911,"PGN_Name":"Generator Total AC Percent Power","PGN_Description":"GTACPP","first_bit":32,"SPN":3592,"SPN_Name":"Generator Total Percent kVAr","SPN_Description":"This parameter reports the generator total AC reactive power, as a percentage of rated power.","bit_length":16,"scaling":0.0078125,"offset":-251,"unit":"%","SLOT_ID":256},"3593":{"PGN":64910,"PGN_Name":"Generator Total AC Reactive Energy","PGN_Description":"GTACER","first_bit":0,"SPN":3593,"SPN_Name":"Generator Total kVAr Hours Export","SPN_Description":"This parameter reports the cumulative total AC reactive energy exported from the generator.","bit_length":32,"scaling":1,"offset":0,"unit":"kVArh","SLOT_ID":257},"3594":{"PGN":64910,"PGN_Name":"Generator Total AC Reactive Energy","PGN_Description":"GTACER","first_bit":32,"SPN":3594,"SPN_Name":"Generator Total kVAr Hours Import","SPN_Description":"This parameter reports the cumulative total AC reactive energy imported to the generator.","bit_length":32,"scaling":1,"offset":0,"unit":"kVArh","SLOT_ID":257},"3595":{"PGN":64909,"PGN_Name":"Utility Total AC Reactive Energy","PGN_Description":"UTACER","first_bit":0,"SPN":3595,"SPN_Name":"Utility Total kVAr Hours Export","SPN_Description":"This parameter reports the cumulative total AC reactive energy exported from the utility.","bit_length":32,"scaling":1,"offset":0,"unit":"kVArh","SLOT_ID":257},"3596":{"PGN":64909,"PGN_Name":"Utility Total AC Reactive Energy","PGN_Description":"UTACER","first_bit":32,"SPN":3596,"SPN_Name":"Utility Total kVAr Hours Import","SPN_Description":"This parameter reports the cumulative total AC reactive energy imported to the utility.","bit_length":32,"scaling":1,"offset":0,"unit":"kVArh","SLOT_ID":257},"3597":{"PGN":65165,"PGN_Name":"Vehicle Electrical Power 2","PGN_Description":"VEP2","first_bit":16,"SPN":3597,"SPN_Name":"ECU Power Output Supply Voltage #1","SPN_Description":"The first power output from an ECU.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3598":{"PGN":65165,"PGN_Name":"Vehicle Electrical Power 2","PGN_Description":"VEP2","first_bit":32,"SPN":3598,"SPN_Name":"ECU Power Output Supply Voltage #2","SPN_Description":"The second power output from an ECU.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3599":{"PGN":65165,"PGN_Name":"Vehicle Electrical Power 2","PGN_Description":"VEP2","first_bit":48,"SPN":3599,"SPN_Name":"ECU Power Output Supply Voltage #3","SPN_Description":"The third power output from an ECU.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"3600":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":18,"SPN":3600,"SPN_Name":"Steering Straight Ahead Position Reset","SPN_Description":"Used to reset the straight ahead position for a steering sensor in the steering column or a steering controller\'s straight ahead position on any steerable axle.\\r\\n\\r\\n00 Take no action - Do not Reset\\r\\n01 Reset\\r\\n10 Reserved, take no action\\r\\n11 Not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3601":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":30,"SPN":3601,"SPN_Name":"Engine Fuel Shutoff Valve Leak Test Control","SPN_Description":"Control setting for fuel shutoff valve proving system test.  Typically, this type of system can only be used with a dual fuel shutoff system.  The test consists of a small pump to pressurize the chamber between the dual fuel shutoffs when they are closed.  After pressurizing, the test is passed if the pressure is above a certain threshold, indicating the fuel shutoffs are sealed completely shut without leaks.  Otherwise, a low pressure indicates a leak is present past one or both of the fuel shutoffs. \\r\\n\\r\\n00 = Off (reset / no test in process)\\r\\n01 = On (test in process / test complete)\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action\\r\\n\\r\\nIn addition to communicating desired action of the fuel shutoff valve proving system test and its driver status, this new SPN can be used to communicate whether the fuel shutoff valve proving system test failed, through the use of FMIs.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3602":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":34,"SPN":3602,"SPN_Name":"Engine Oil Pre-heater Control","SPN_Description":"Control setting for an electrically actuated oil pre-heating device.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action\\r\\n\\r\\nIn addition to communicating desired action of the electrically actuated oil pre-heater and its driver status, this new SPN can be used to communicate if any attempts to adequately pre-heat the oil are unsuccessful, through the use of FMIs.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3603":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":36,"SPN":3603,"SPN_Name":"Engine Electrical System Power Conservation Control","SPN_Description":"Control setting for cutting power to various devices when the engine is not in use.  Useful if it is desired to keep the engine in standby, with main control ECU still powered on and communictaing with outside world, but actuators and certain other ECUs can be de-powered.\\r\\n\\r\\n00 - Off (No Power conservation; all systems with supply power available)\\r\\n01 - On (power conservation active; certain systems have supply power witheld)\\r\\n10 - Reserved\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3604":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":38,"SPN":3604,"SPN_Name":"Engine Pre-Heater Control","SPN_Description":"Control setting for an electrically actuated engine block or coolant pre-heating device.\\r\\n\\r\\n00 - Off \\r\\n01 - On\\r\\n10 - Reserved\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3605":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":40,"SPN":3605,"SPN_Name":"Engine Coolant Pump Control","SPN_Description":"Control setting for an electrically actuated engine coolant circulating pump. \\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action\\r\\n.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3606":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":42,"SPN":3606,"SPN_Name":"Engine Controlled Shutdown Request","SPN_Description":"A signal issued by the engine control system to a user or external system requesting for a controlled shutdown.  This request is made when engine protection diagnostics determine a condition warrants a shutdown soon, but it is not severe enough to necessitate an immediate shutdown.  This function gives notice such that the engine can be unloaded and cooled down before stopping.\\r\\n\\r\\n00 = Off (No Shutdown Requested)\\r\\n01 = On (Shutdown Requested)\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3607":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":44,"SPN":3607,"SPN_Name":"Engine Emergency (Immediate) Shutdown Indication","SPN_Description":"A signal issued by the engine control system to a user or external system indicating that it is immediately shutting the engine down.  This indication is made when engine protection diagnostics determine a condition necessitates an immediate shutdown.  This function gives notice that this has occurred.\\r\\n\\r\\n00 = Off (No Shutdown Requested)\\r\\n01 = On (Shutdown Requested)\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3608":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":24,"SPN":3608,"SPN_Name":"Engine Fuel Shutoff Vent Control","SPN_Description":"Control setting for a fuel shutoff vent.  Typically, for a dual fuel shutoff system, the vent line is located between them and is plumbed to vent outside to atmosphere.  The vent control typically always actuates opposite to that of the fuel shutoff(s) control.  Thus, when the fuel shutoff(s) are closed, the vent is open, thereby \'ventilating\' any leftover or leaking gas from the fuel shutoff.  When the fuel shutoff(s) are open, the vent is closed, thereby all gas passes through to the engine.\\r\\n\\r\\n00 = Closed (vent closed)\\r\\n01 = Open (vent open)\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3609":{"PGN":64908,"PGN_Name":"Aftertreatment 1 Gas Parameters","PGN_Description":"AT1GP","first_bit":0,"SPN":3609,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Intake Pressure","SPN_Description":"This parameter indicates the diesel particulate filter intake gage pressure 1 (bank 1).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3610":{"PGN":64908,"PGN_Name":"Aftertreatment 1 Gas Parameters","PGN_Description":"AT1GP","first_bit":16,"SPN":3610,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Outlet Pressure","SPN_Description":"This parameter indicates the diesel particulate filter outlet gage pressure 1 (bank 1).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3611":{"PGN":64907,"PGN_Name":"Aftertreatment 2 Gas Parameters","PGN_Description":"AT2GP","first_bit":0,"SPN":3611,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Intake Pressure","SPN_Description":"This parameter indicates the diesel particulate filter intake gage pressure 2 (bank 2).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3612":{"PGN":64907,"PGN_Name":"Aftertreatment 2 Gas Parameters","PGN_Description":"AT2GP","first_bit":16,"SPN":3612,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Outlet Pressure","SPN_Description":"This parameter indicates the diesel particulate filter outlet gage pressure 2 (bank 2).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3613":{"PGN":43008,"PGN_Name":"Text Display","PGN_Description":"DISP1","first_bit":0,"SPN":3613,"SPN_Name":"Text Display Instructions","SPN_Description":"This parameter describes the status for the display how to show the information.\\r\\n\\r\\n0000 Clear display - The displayed information should be deleted or not displayed any more.\\r\\n0001 Hold display - The presently displayed information should be retained\\r\\n0010 Append at end of display - The transmitted information should be displayed at the end of the presently displayed information\\r\\n0011 Overwrite display - The presently displayed information is to be overwritten with the transmitted information\\r\\n0100 Overwrite substring - A portion of the presently displayed information is to be overwritten with the transmitted information starting at display text index (SPN 3614)\\r\\n0101 Highlight substring\\r\\n0110 Blink substring\\r\\n0111-1110  Reserved\\r\\n1111 - Not applicable","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3614":{"PGN":43008,"PGN_Name":"Text Display","PGN_Description":"DISP1","first_bit":16,"SPN":3614,"SPN_Name":"Text Display Index","SPN_Description":"Used for overwriting consecutive bytes of a displayed string when byte 1 \\"Text Display Instructions\\" state is set for \\"overwrite substring\\" mode.  When used, this byte declares where in the text string that the new text will start overwriting, this number is also known as the start byte.  As usual for the transmitted text string, the Text Display Characters will be sent and then terminated by the null character, this will be the stop byte indicator to declare when to stop overwriting.\\r\\n\\r\\nEXAMPLE: To only modify 3 bytes (50, 51, 52) of an 87 byte character string.\\r\\n  Text Display Instructions - set to 0100b (Overwrite substring)\\r\\n  Text Display Index - set to 50d (starting byte of desired overwrite)\\r\\n  Text Display Characters - 3 characters sent, then the null ending byte","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"3619":{"PGN":64906,"PGN_Name":"SAE J2012 DTC Display","PGN_Description":"J2012","first_bit":0,"SPN":3619,"SPN_Name":"Number of J2012 DTCs","SPN_Description":"The number J2012 DTCs being conveyed in PGN 64906.  If the value of this parameter is zero, the device broadcasting PGN 64906 has no active or previously active J2012 DTCs.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"3620":{"PGN":64906,"PGN_Name":"SAE J2012 DTC Display","PGN_Description":"J2012","first_bit":8,"SPN":3620,"SPN_Name":"J2012 DTC","SPN_Description":"Five character ASCII SAE J2012 DTC, sent most significant byte first.","bit_length":40,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":273},"3621":{"PGN":64906,"PGN_Name":"SAE J2012 DTC Display","PGN_Description":"J2012","first_bit":48,"SPN":3621,"SPN_Name":"J2012 DTC Status","SPN_Description":"Indicates if the respective SAE J2012 DTC is active or previously active.\\r\\n\\r\\n0 - DTC is previously active\\r\\n1 - DTC is active","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"3622":{"PGN":64906,"PGN_Name":"SAE J2012 DTC Display","PGN_Description":"J2012","first_bit":49,"SPN":3622,"SPN_Name":"J2012 DTC Occurrence Count","SPN_Description":"Number of occurrences of the respective SAE J2012 DTC being conveyed.\\r\\nIf more than 126 occurrences happen the value shall be set to 126.\\r\\nIf the occurrence count is not available to be sent then this value shall be set to 127.","bit_length":7,"scaling":1,"offset":0,"unit":"count","SLOT_ID":260},"3623":{"PGN":64905,"PGN_Name":"Vehicle Direction/Speed 2","PGN_Description":"VDS2","first_bit":0,"SPN":3623,"SPN_Name":"Vehicle Roll","SPN_Description":"This parameter indicates the roll in degrees from level.  Facing the direction of travel a tip to the left would be indicated by a negative number and a tip to the right would be indicated by a positive number.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"3624":{"PGN":64904,"PGN_Name":"Engine Fluid Level/Pressure 5","PGN_Description":"EFL/P5","first_bit":0,"SPN":3624,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #1","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #1.  \\r\\n\\r\\nThis intake valve pressure is at the first cylinder in the engine, while SPN 2948 reflects the intake valve pressure of the entire engine system.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3625":{"PGN":64904,"PGN_Name":"Engine Fluid Level/Pressure 5","PGN_Description":"EFL/P5","first_bit":16,"SPN":3625,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #2","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #2.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3626":{"PGN":64904,"PGN_Name":"Engine Fluid Level/Pressure 5","PGN_Description":"EFL/P5","first_bit":32,"SPN":3626,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #3","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #3.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3627":{"PGN":64904,"PGN_Name":"Engine Fluid Level/Pressure 5","PGN_Description":"EFL/P5","first_bit":48,"SPN":3627,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #4","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #4.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3628":{"PGN":64903,"PGN_Name":"Engine Fluid Level/Pressure 6","PGN_Description":"EFL/P6","first_bit":0,"SPN":3628,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #5","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #5.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3629":{"PGN":64903,"PGN_Name":"Engine Fluid Level/Pressure 6","PGN_Description":"EFL/P6","first_bit":16,"SPN":3629,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #6","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #6.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3630":{"PGN":64903,"PGN_Name":"Engine Fluid Level/Pressure 6","PGN_Description":"EFL/P6","first_bit":32,"SPN":3630,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #7","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #7.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3631":{"PGN":64903,"PGN_Name":"Engine Fluid Level/Pressure 6","PGN_Description":"EFL/P6","first_bit":48,"SPN":3631,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #8","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #8.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3632":{"PGN":64902,"PGN_Name":"Engine Fluid Level/Pressure 7","PGN_Description":"EFL/P7","first_bit":0,"SPN":3632,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #9","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #9.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3633":{"PGN":64902,"PGN_Name":"Engine Fluid Level/Pressure 7","PGN_Description":"EFL/P7","first_bit":16,"SPN":3633,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #10","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #10.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3634":{"PGN":64902,"PGN_Name":"Engine Fluid Level/Pressure 7","PGN_Description":"EFL/P7","first_bit":32,"SPN":3634,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #11","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #11.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3635":{"PGN":64902,"PGN_Name":"Engine Fluid Level/Pressure 7","PGN_Description":"EFL/P7","first_bit":48,"SPN":3635,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #12","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #12.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3636":{"PGN":64901,"PGN_Name":"Engine Fluid Level/Pressure 8","PGN_Description":"EFL/P8","first_bit":0,"SPN":3636,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #13","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #13.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3637":{"PGN":64901,"PGN_Name":"Engine Fluid Level/Pressure 8","PGN_Description":"EFL/P8","first_bit":16,"SPN":3637,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #14","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #14.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3638":{"PGN":64901,"PGN_Name":"Engine Fluid Level/Pressure 8","PGN_Description":"EFL/P8","first_bit":32,"SPN":3638,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #15","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #15.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3639":{"PGN":64901,"PGN_Name":"Engine Fluid Level/Pressure 8","PGN_Description":"EFL/P8","first_bit":48,"SPN":3639,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #16","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #16.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3640":{"PGN":64900,"PGN_Name":"Engine Fluid Level/Pressure 9","PGN_Description":"EFL/P9","first_bit":0,"SPN":3640,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #17","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #17.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3641":{"PGN":64900,"PGN_Name":"Engine Fluid Level/Pressure 9","PGN_Description":"EFL/P9","first_bit":16,"SPN":3641,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #18","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #18.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3642":{"PGN":64900,"PGN_Name":"Engine Fluid Level/Pressure 9","PGN_Description":"EFL/P9","first_bit":32,"SPN":3642,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #19","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #19.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3643":{"PGN":64900,"PGN_Name":"Engine Fluid Level/Pressure 9","PGN_Description":"EFL/P9","first_bit":48,"SPN":3643,"SPN_Name":"Engine Intake Valve Actuation Oil Pressure for Cylinder #20","SPN_Description":"The gage pressure of the oil in the hydraulic accumulator that powers the engine intake valve for cylinder #20.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3644":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":56,"SPN":3644,"SPN_Name":"Engine Derate Request","SPN_Description":"This parameter is a derate request made from the engine control system to an external system, where the engine is requesting an external device to reduce the load being applied.  A zero value indicates that there is no derate being requested and 100% means full derate being requested.  Any non-zero value represents a derate is being requested, at a percentage of full load.  The engine control system identifies any problems and determines the amount of derate the situation calls for. This parameter can be useful to customer applications that prefer awareness and control of the engine derate.\\r\\n\\r\\nSee also SPN 8436 for a Derate Request in kW.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3645":{"PGN":64899,"PGN_Name":"Transfer Case Information","PGN_Description":"TCI","first_bit":0,"SPN":3645,"SPN_Name":"Transfer case status","SPN_Description":"This parameter describes the feedback from the  transfer case controller . Used by instrument clusters,  tachographs, PTOs , etc.\\r\\n\\r\\n000 2 wheel high (normal or `\'On Highway\' Range)\\r\\n001 4 wheel high (normal or  \'On Highway\' Range\\r\\n010 neutral\\r\\n011 2 wheel low (or `\'Off Highway\' Range)\\r\\n100 4 wheel low (or `\'Off Highway\' Range)\\r\\n101 Transfer Case Shift in Progress or gear not confirmed\\r\\n110 error\\r\\n111 not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3667":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":56,"SPN":3667,"SPN_Name":"Engine Air Shutoff Status","SPN_Description":"State signal which indicates the actual measured position of the Air Shutoff.\\r\\n\\r\\n00 - Air flow allowed to engine\\r\\n01 - Air flow restricted\\r\\n10 - Error\\r\\n11 - Not Available\\r\\n\\r\\nNote:   This parameter, in conjunction with SPN 2813 - \\"Engine Air Shutoff Command Status\\", is provided to allow an external system to annunciate and/or alarm on either an accidental air shutoff (shutoff detected but not commanded), or a failed air shutoff (shutoff commanded but not detected).","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3668":{"PGN":64938,"PGN_Name":"Engine Fluid Level/Pressure 4","PGN_Description":"EFL/P4","first_bit":40,"SPN":3668,"SPN_Name":"Engine Charge Air Cooler Coolant Level","SPN_Description":"Ratio of volume of liquid found in an engine charge air cooler cooling system to total engine charge air cooler cooling system volume.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3669":{"PGN":65214,"PGN_Name":"Electronic Engine Controller 4","PGN_Description":"EEC4","first_bit":32,"SPN":3669,"SPN_Name":"Engine Rotation Direction","SPN_Description":"Direction of engine rotation, as reported by the engine.  Direction convention as viewed by an observer standing at the rear of the engine, viewing the flywheel.\\r\\n\\r\\n00 - CounterClockWise (CCW)\\r\\n01 - ClockWise (CW)\\r\\n10 - Unknown  (Rotation Direction Unknown)\\r\\n11 - Not Available\\r\\n\\r\\nWhen the rotation direction is yet to be detected, Unknown will be reported.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3670":{"PGN":64895,"PGN_Name":"Engine Configuration 2","PGN_Description":"EC2","first_bit":0,"SPN":3670,"SPN_Name":"Maximum Crank Attempts per Start Attempt","SPN_Description":"The number of cranking cycles that will be performed before ending the start attempt.  This is intended to be used in conjunction with Crank Attempt Count on Present Start Attempt, in order to give a FMI 0 diagnostic on the latter.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"3671":{"PGN":65214,"PGN_Name":"Electronic Engine Controller 4","PGN_Description":"EEC4","first_bit":40,"SPN":3671,"SPN_Name":"Crank Attempt Count on Present Start Attempt","SPN_Description":"Reports the number of cranking cycles undergone during the present start attempt.\\r\\n\\r\\nNote:  This is intended to be used in conjunction with Maximum Crank Attempts per Start Attempt, in order to give a FMI 0 diagnostic on this parameter when the count exceeds the maximum.  When the engine is not in a start attempt, this parameter can either hold the last value or return a Not Available (0xFF).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"3672":{"PGN":64897,"PGN_Name":"EGR Cooler Bypass","PGN_Description":"EGRBV","first_bit":0,"SPN":3672,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Cooler Bypass Actuator Postion","SPN_Description":"The parameter gives the % open of the exhaust gas recirculation cooler bypass actuator, where 0% = Fully Closed (no gas flowing through the bypass), and 100% = Fully Open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3673":{"PGN":65266,"PGN_Name":"Fuel Economy (Liquid)","PGN_Description":"LFE1","first_bit":56,"SPN":3673,"SPN_Name":"Engine Throttle Valve 2 Position","SPN_Description":"The sensed position feedback of the valve, coming from a second electrical actuator for a second throttle plate, used to regulate the supply of a fluid, usually air or fuel//air mixture.  0% represents no supply and 100% is full supply. SPN 51 is used for the first throttle position feedback.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3675":{"PGN":64931,"PGN_Name":"Electronic Engine Controller 6","PGN_Description":"EEC6","first_bit":24,"SPN":3675,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Position","SPN_Description":"Measures the position of the turbocharger compressor bypass actuator, where 0% represents bypass fully closed and 100% represents bypass fully open.  Typically, the compressor bypass is used to lower the compressor outlet pressure and/or intake manifold pressure during situations where too much boost is being generated by the turbocharger.  Typically, a compressor bypass will be plumbed from the compressor outlet or intake manifold back to the compressor intake, with the compressor bypass actuator and valve in place to regulate bypass flow.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3676":{"PGN":64938,"PGN_Name":"Engine Fluid Level/Pressure 4","PGN_Description":"EFL/P4","first_bit":48,"SPN":3676,"SPN_Name":"Engine Aftercooler Coolant Level","SPN_Description":"Ratio of aftercooler coolant system volume of liquid to total cooling system volume.  The engine aftercooler coolant level is for  the low temperature (LT) cooling circuit used for the compressor outlet air or charge aftercooling.  \\r\\n\\r\\nSPN 111 \\"Coolant Level\\" is assumed to represent a high temperature (HT) cooling circuit used for cooling the engine and its various components.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"3683":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":0,"SPN":3683,"SPN_Name":"Steering Wheel Angle","SPN_Description":"The main operator`s steering wheel angle (on the steering column, not the actual wheel angle). The vehicle being steered to the left (counterclockwise) results in a positive steering wheel angle.  This is the yaw angle of the steering wheel with the z-axis along the centerline of the steering column. This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.","bit_length":16,"scaling":0.0009765625,"offset":-31.374,"unit":"rad","SLOT_ID":113},"3684":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":16,"SPN":3684,"SPN_Name":"Steering Wheel Angle Range Counter","SPN_Description":"The signal indicates the number of steering wheel angle range overflows if the operating range of steering wheel is greater than the measuring range of sensor element. Positive values indicate left turns (counterclockwise). If the steering wheel angle range is +/-180 degrees this signal is equivalent to a steering wheel turn counter.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.","bit_length":6,"scaling":1,"offset":-32,"unit":"range","SLOT_ID":263},"3685":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":22,"SPN":3685,"SPN_Name":"Steering Wheel Angle Range Counter Type","SPN_Description":"The signal indicates whether the steering wheel angle sensor is capable of absolute measuring of the number of steering wheel angle ranges or not.  Absolute measuring means that the steering wheel angle range counter signal indicates the real position of steering wheel at ignition on.  Relative measuring means that the steering wheel angle range counter signal is zero at ignition on independent of the real position of steering wheel.\\r\\n\\r\\n00 - relative number of counts\\r\\n01 - absolute number of counts\\r\\n10 - not defined\\r\\n11 - signal not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3686":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":32,"SPN":3686,"SPN_Name":"Steering Wheel Angle Range","SPN_Description":"The signal indicates the range of  the steering wheel angle the sensor element is capable to measure. The steering wheel angle signal ranges between the negative and the positive value of the steering wheel angle range.\\r\\n\\r\\nFor example, a steering angle sensor transmits +13.6 rad to indicate a range of +/- 13.6 rad.","bit_length":16,"scaling":0.0009765625,"offset":-31.374,"unit":"rad","SLOT_ID":113},"3687":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":48,"SPN":3687,"SPN_Name":"Steering Angle Sensor Active Mode","SPN_Description":"This signal indicates the operational mode of the steering angle sensor.\\r\\n\\r\\n00 \u2013 Programming mode active\\r\\n01 \u2013 Normal mode active\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3688":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":50,"SPN":3688,"SPN_Name":"Steering Angle Sensor Calibrated","SPN_Description":"This signal indicates the calibration status of the steering angle sensor.\\r\\n\\r\\n00 \u2013 SAS not calibrated\\r\\n01 \u2013 SAS calibrated\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3689":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":56,"SPN":3689,"SPN_Name":"Message Counter","SPN_Description":"The message counter is to verify the signal path from the demanding device to the steering controller.  The support of this parameter is mandatory.\\r\\n\\r\\nNote:  The initial value of the 4 bit message counter for the first message during a driving cycle is arbitrary. In every following message the counter is incremented by 1  (0 follows 15).","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"3690":{"PGN":61469,"PGN_Name":"Steering Angle Sensor Information","PGN_Description":"SAS","first_bit":60,"SPN":3690,"SPN_Name":"Message Checksum","SPN_Description":"The message checksum is used to verify the signal path from the demanding device to the steering controller.  The support of this parameter is mandatory if PGN 61469 is supported as there is no means to indicate \u201Cnot available\u201D.\\r\\n\\r\\nThe 4 bit checksum is the sum of the high nibble and the low nibble of the sum of the identifier, the first 7 data bytes and the 4 bit message counter.  It is calculated as follows:\\r\\n\\r\\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\\r\\n\\r\\nChecksum = ((Checksum >> 4) + Checksum) & 0x0F","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"3691":{"PGN":64894,"PGN_Name":"Adaptive Front-Lighting System Status","PGN_Description":"AFSS","first_bit":0,"SPN":3691,"SPN_Name":"Left Headlamp Dynamic Bending Light","SPN_Description":"This parameter indicates whether the dynamic bending light of the left headlamp is working properly.\\r\\n\\r\\n000   Dynamic bending light deactivated.  There is no problem but for some reasons (e.g. daylight present) the bending light is deactivated.\\r\\n001   Dynamic bending light is working properly.  Normal operation mode. Bending light is working properly.\\r\\n010   Dynamic bending light fail safe position.  Bending light is damaged, current position does not affect oncoming traffic.\\r\\n011   Dynamic bending light failure.  Bending light does not work, current position may affect oncoming traffic.\\r\\n100 \u2013 110 Reserved\\r\\n111   Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3692":{"PGN":64894,"PGN_Name":"Adaptive Front-Lighting System Status","PGN_Description":"AFSS","first_bit":3,"SPN":3692,"SPN_Name":"Right Headlamp Dynamic Bending Light","SPN_Description":"This parameter indicates whether the dynamic bending light of the left headlamp is working properly.\\r\\n\\r\\n000   Dynamic bending light deactivated.  There is no problem but for some reasons (e.g. daylight present) the bending light is deactivated.\\r\\n001   Dynamic bending light is working properly.  Normal operation mode. Bending light is working properly.\\r\\n010   Dynamic bending light fail safe position.  Bending light is damaged, current position does not affect oncoming traffic.\\r\\n011   Dynamic bending light failure.  Bending light does not work, current position may affect oncoming traffic.\\r\\n100 \u2013 110 Reserved\\r\\n111   Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3693":{"PGN":64894,"PGN_Name":"Adaptive Front-Lighting System Status","PGN_Description":"AFSS","first_bit":8,"SPN":3693,"SPN_Name":"Left Headlamp Light Distribution","SPN_Description":"This parameter indicates what kind of light distribution is set by the AFS system for the left headlamp.\\r\\n\\r\\n0000   Light distribution town - The basic light distribution for town light is generated with a symmetrical cut-off line (Class V)\\r\\n0001   Light distribution country - Country light is mostly similar to the actual SAE low beam pattern. (Class C)\\r\\n0010   Light distribution motorway - The task of motorway light is an improved overall viewing distance and an optimum of illumination of the second lane on roads with more than one lane and without oncoming traffic. (Class E)\\r\\n0011   Light distribution high beam - The high beam distribution of the module generates an illumination level that an additional high beam spot is not necessary.\\r\\n0100   Light distribution adverse weather - The adverse weather light improves the viewing situation for the driver on wet roads and reduces the amount of glare from reflections on wed reads for the oncoming traffic. (Class W) \\r\\n0101   Light distribution fail safe position - Module is damaged, current light distribution does not affect oncoming traffic.\\r\\n0110   Light distribution failure - Module is damaged, current position may affect oncoming traffic.\\r\\n0111   Different light distributions not available -  No AFS distributions available. Head lamp has only one distribution.\\r\\n1000 \u2013 1110   Reserved\\r\\n1111   Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3694":{"PGN":64894,"PGN_Name":"Adaptive Front-Lighting System Status","PGN_Description":"AFSS","first_bit":12,"SPN":3694,"SPN_Name":"Right Headlamp Light Distribution","SPN_Description":"This parameter indicates what kind of light distribution is set by the AFS system for the right headlamp.\\r\\n\\r\\n0000   Light distribution town - The basic light distribution for town light is generated with a symmetrical cut-off line (Class V)\\r\\n0001   Light distribution country - Country light is mostly similar to the actual SAE low beam pattern. (Class C)\\r\\n0010   Light distribution motorway - The task of motorway light is an improved overall viewing distance and an optimum of illumination of the second lane on roads with more than one lane and without oncoming traffic. (Class E)\\r\\n0011   Light distribution high beam - The high beam distribution of the module generates an illumination level that an additional high beam spot is not necessary.\\r\\n0100   Light distribution adverse weather - The adverse weather light improves the viewing situation for the driver on wet roads and reduces the amount of glare from reflections on wed reads for the oncoming traffic. (Class W) \\r\\n0101   Light distribution fail safe position - Module is damaged, current light distribution does not affect oncoming traffic.\\r\\n0110   Light distribution failure - Module is damaged, current position may affect oncoming traffic.\\r\\n0111   Different light distributions not available -  No AFS distributions available. Head lamp has only one distribution.\\r\\n1000 \u2013 1110   Reserved\\r\\n1111   Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"3695":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":40,"SPN":3695,"SPN_Name":"Aftertreatment Regeneration Inhibit Switch","SPN_Description":"Indicates the state of a switch available to the operator that inhibits aftertreatment regeneration. \\r\\n \\r\\n00 not active \\r\\n01 active \\r\\n10 error \\r\\n11 not available \\r\\n \\r\\nThis SPN would be \u201Cnot active\u201D when aftertreatment regeneration is allowed to occur normally (aftertreatment regeneration is not inhibited). \\r\\n \\r\\nThe engine controller shall inhibit regeneration when SPN 3695 is in the ON state.  Regeneration shall be activated by SPN 3696 when it is in the ON state and SPN 3695 is in the OFF state.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3696":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":42,"SPN":3696,"SPN_Name":"Aftertreatment Regeneration Force Switch","SPN_Description":"Indicates the state of a switch available to the operator that forces aftertreatment regeneration. \\r\\n \\r\\n00 not active \\r\\n01 active \\r\\n10 error \\r\\n11 not available \\r\\n \\r\\nThis SPN would be \u201Cnot active\u201D when aftertreatment regeneration is allowed to occur normally (aftertreatment regeneration is not being forced). \\r\\n \\r\\nThe engine controller shall inhibit regeneration when SPN 3695 is in the ON state.  Regeneration shall be activated by SPN 3696 when it is in the ON state and SPN 3695 is in the OFF state.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3697":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":0,"SPN":3697,"SPN_Name":"Diesel Particulate Filter Lamp Command","SPN_Description":"Command to control the diesel particulate filter lamp.\\r\\n\\r\\n000 Off\\r\\n001 On \u2013 solid\\r\\n010 reserved for SAE assignment \\r\\n011 reserved for SAE assignment\\r\\n100 On \u2013 fast blink (1 HZ)\\r\\n101 reserved for SAE assignment\\r\\n110 reserved for SAE assignment\\r\\n111 not available\\r\\n\\r\\nThis SPN would be \u201Coff\u201D when diesel particulate filter lamp is unlit.  The \\"on - solid\\" should indicate that diesel particulate filter active regeneration is needed at the lowest level of urgency and that operator intervention is required.  The flashing state indicates a more severe condition requiring regeneration.  \\r\\n\\r\\nThis SPN shall not be used to convey information regarding operator switch feedback from SPNs 3695 and 3696.\\r\\n\\r\\nThe ISO 2575 Symbol F21 is recommended for use with this message.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3698":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":50,"SPN":3698,"SPN_Name":"Exhaust System High Temperature Lamp Command","SPN_Description":"Command to control the exhaust system high temperature lamp.  This lamp indicates that the exhaust system temperature is high.\\r\\n\\r\\n000 Off\\r\\n001 On \u2013 solid \\r\\n010 reserved for SAE assignment \\r\\n011 reserved for SAE assignment\\r\\n100 reserved for SAE assignment\\r\\n101 reserved for SAE assignment\\r\\n110 reserved for SAE assignment\\r\\n111 not available\\r\\n\\r\\nThis SPN would be \u201Coff\u201D when the lamp is unlit.  The \\"on - solid\\" status indicates that the exhaust gas temperature is high.\\r\\n\\r\\nThis SPN shall not be used to convey information regarding operator switch feedback from SPNs 3695 and 3696.\\r\\n  \\r\\nThe ISO 2575 Symbol \\"F.26\\" is recommended for use with this message.  This symbol is the ISO exhaust gas symbol with the temperature symbol added to it.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3699":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":8,"SPN":3699,"SPN_Name":"Aftertreatment Diesel Particulate Filter Passive Regeneration Status","SPN_Description":"Indicates the state of diesel particulate filter passive regeneration.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\\r\\n\\r\\n\\r\\n00 not active\\r\\n01 active\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3700":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":10,"SPN":3700,"SPN_Name":"Aftertreatment Diesel Particulate Filter Active Regeneration Status","SPN_Description":"Indicates the state of diesel particulate filter active regeneration.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\\r\\n\\r\\n00 not active\\r\\n01 active\\r\\n10 regeneration needed - automatically initiated active regeneration imminent\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3701":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":12,"SPN":3701,"SPN_Name":"Aftertreatment Diesel Particulate Filter Status","SPN_Description":"Indicates the state of the diesel particulate filter regeneration need and urgency.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\\r\\n\\r\\n000 Regeneration not needed\\r\\n001 Regeneration needed - lowest level\\r\\n010 Regeneration needed - moderate level\\r\\n011 Regeneration needed - highest level\\r\\n100 reserved for SAE assignment\\r\\n101 reserved for SAE assignment\\r\\n110 reserved for SAE assignment\\r\\n111 not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3702":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":16,"SPN":3702,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Status","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an active regeneration or will exit an active regeneration.  If the reason for inhibiting is not covered by SPNs 3703 thru 3717 or 5629, a request for a status parameter should be submitted to the SAE Truck and Bus J1939 Request Processing Group to have the reason added.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3703":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":18,"SPN":3703,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Inhibit Switch","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the Diesel Particulate Filter Regeneration Inhibit Switch.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3704":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":20,"SPN":3704,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Clutch Disengaged","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the clutch being disengaged.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3705":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":22,"SPN":3705,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Service Brake Active","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the service brake being active.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3706":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":24,"SPN":3706,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to PTO Active","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the PTO being active.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3707":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":26,"SPN":3707,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Accelerator Pedal Off Idle","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the accelerator pedal being off idle.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3708":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":28,"SPN":3708,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Out of Neutral","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the transmission being out of neutral.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3709":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":30,"SPN":3709,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Vehicle Speed Above Allowed Speed","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the vehicle speed being above an allowed limit.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3710":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":32,"SPN":3710,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Parking Brake Not Set","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the parking brake being not set.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3711":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":34,"SPN":3711,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Low Exhaust Temperature","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the exhaust temperature being too low.  This implies that the diesel particulate filter and/or oxidation catalyst are likewise too cold for active regeneration.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3712":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":36,"SPN":3712,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to System Fault Active","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to a system fault being active.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3713":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":38,"SPN":3713,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to System Timeout","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to a system timeout.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3714":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":40,"SPN":3714,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Temporary System Lockout","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to a temporary system lockout.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3715":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":42,"SPN":3715,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Permanent System Lockout","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to a permanent system lockout.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3716":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":44,"SPN":3716,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Engine Not Warmed Up","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to the engine not being warmed up.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3717":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":46,"SPN":3717,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Vehicle Speed Below Allowed Speed","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to vehicle speed being less than the allowed vehicle speed.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3718":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":48,"SPN":3718,"SPN_Name":"Diesel Particulate Filter Automatic Active Regeneration Initiation Configuration","SPN_Description":"Indicates the configuration of diesel particulate filter active regeneration automatic initiation.\\r\\n\\r\\n00 not enabled\\r\\n01 enabled\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3719":{"PGN":64891,"PGN_Name":"Aftertreatment 1 Service 1","PGN_Description":"AT1S1","first_bit":0,"SPN":3719,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Load Percent","SPN_Description":"Indicates the soot load percent of diesel particulate filter 1.  100% is the level at which active diesel particulate filter regeneration should be triggered.\\r\\n\\r\\n100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%).  During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter.  Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"3720":{"PGN":64891,"PGN_Name":"Aftertreatment 1 Service 1","PGN_Description":"AT1S1","first_bit":8,"SPN":3720,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Ash Load Percent","SPN_Description":"Indicates the ash load percent of diesel particulate filter 1.  100% is the level at which diesel particulate filter ash service should be performed.\\r\\n\\r\\n\\r\\n100% level is the target ash service interval (and if ash service is not immediately performed, ash loading can continue beyond 100%).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"3721":{"PGN":64891,"PGN_Name":"Aftertreatment 1 Service 1","PGN_Description":"AT1S1","first_bit":16,"SPN":3721,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Time Since Last Active Regeneration","SPN_Description":"Indicates the time since the last active regeneration event of diesel particulate filter 1.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3722":{"PGN":64890,"PGN_Name":"Aftertreatment 2 Service 1","PGN_Description":"AT2S1","first_bit":0,"SPN":3722,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Load Percent","SPN_Description":"Indicates the soot load percent of diesel particulate filter 2.  100% is the level at which active diesel particulate filter regeneration should be triggered.\\r\\n\\r\\n\\r\\n100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%).  During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter.  Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"3723":{"PGN":64890,"PGN_Name":"Aftertreatment 2 Service 1","PGN_Description":"AT2S1","first_bit":8,"SPN":3723,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Ash Load Percent","SPN_Description":"Indicates the ash load percent of diesel particulate filter 2.  100% is the level at which diesel particulate filter ash service should be performed.\\r\\n\\r\\n100% level is the target ash service interval (and if ash service is not immediately performed, ash loading can continue beyond 100%).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"3724":{"PGN":64890,"PGN_Name":"Aftertreatment 2 Service 1","PGN_Description":"AT2S1","first_bit":16,"SPN":3724,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Time Since Last Active Regeneration","SPN_Description":"Indicates the time since the last active regeneration event of diesel particulate filter 2.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3725":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":128,"SPN":3725,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Total Passive Regeneration Time","SPN_Description":"Total amount of time that aftertreatment 1 diesel particulate filter has been in passive regeneration over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3726":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":160,"SPN":3726,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Total Number of Passive Regenerations","SPN_Description":"Total number of passive regenerations by aftertreatment device 1 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3727":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":192,"SPN":3727,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Total Number of Active Regeneration Inhibit Requests","SPN_Description":"Total number of aftertreatment device 1 active regeneration inhibit requests by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3728":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":224,"SPN":3728,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Total Number of Active Regeneration Manual Requests","SPN_Description":"Total number of aftertreatment device 1 active regeneration manual requests by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3729":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":128,"SPN":3729,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Total Passive Regeneration Time","SPN_Description":"Total amount of time that Aftertreatment device 2 has been in passive regeneration over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3730":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":160,"SPN":3730,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Total Number of Passive Regenerations","SPN_Description":"Total number of passive regenerations by Aftertreatment device 2 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3731":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":192,"SPN":3731,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Total Number of Active Regeneration Inhibit Requests","SPN_Description":"Total number of Aftertreatment device 2 active regeneration inhibit requests by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3732":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":224,"SPN":3732,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Total Number of Active Regeneration Manual Requests","SPN_Description":"Total number of Aftertreatment device 2 active regeneration manual requests by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3733":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":0,"SPN":3733,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Fuel Used","SPN_Description":"Total amount of fuel used by the aftertreatment 1 diesel particulate filter during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"3734":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":32,"SPN":3734,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Active Regeneration Time","SPN_Description":"Total amount of time that the aftertreatment 1 diesel particulate filter has been in active regeneration during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3735":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":64,"SPN":3735,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Disabled Time","SPN_Description":"Total amount of time that aftertreatment 1 diesel particulate filter regeneration has been manually disabled during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3736":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":96,"SPN":3736,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Number of Active Regenerations","SPN_Description":"Total number of active regenerations of the aftertreatment 1 diesel particulate filter during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3737":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":128,"SPN":3737,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Passive Regeneration Time","SPN_Description":"Total amount of time that the aftertreatment 1 diesel particulate filter has been in passive regeneration during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3738":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":160,"SPN":3738,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Number of Passive Regenerations","SPN_Description":"Total number of passive regenerations of the aftertreatment 1 diesel particulate filter during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3739":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":192,"SPN":3739,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Number of Active Regeneration Inhibit Requests","SPN_Description":"Total number of aftertreatment 1 diesel particulate filter active regeneration inhibit requests by the operator during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3740":{"PGN":64889,"PGN_Name":"Aftertreatment 1 Trip Information","PGN_Description":"AT1TI","first_bit":224,"SPN":3740,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Trip Number of Active Regeneration Manual Requests","SPN_Description":"Total number of aftertreatment 1 diesel particulate filter active regeneration manual requests by the operator during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3741":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":0,"SPN":3741,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Fuel Used","SPN_Description":"Total amount of fuel used by the aftertreatment 2 diesel particulate filter during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"3742":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":32,"SPN":3742,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Active Regeneration Time","SPN_Description":"Total amount of time that the aftertreatment 2 diesel particulate filter has been in active regeneration during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3743":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":64,"SPN":3743,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Disabled Time","SPN_Description":"Total amount of time that aftertreatment 2 diesel particulate filter regeneration has been manually disabled during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3744":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":96,"SPN":3744,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Number of Active Regenerations","SPN_Description":"Total number of active regenerations of the aftertreatment 2 diesel particulate filter during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3745":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":128,"SPN":3745,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Passive Regeneration Time","SPN_Description":"Total amount of time that the aftertreatment 2 diesel particulate filter has been in passive regeneration during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"3746":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":160,"SPN":3746,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Number of Passive Regenerations","SPN_Description":"Total number of passive regenerations of the aftertreatment 2 diesel particulate filter during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3747":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":192,"SPN":3747,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Number of Active Regeneration Inhibit Requests","SPN_Description":"Total number of aftertreatment 2 diesel particulate filter active regeneration inhibit requests by the operator during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3748":{"PGN":64888,"PGN_Name":"Aftertreatment 2 Trip Information","PGN_Description":"AT2TI","first_bit":224,"SPN":3748,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Trip Number of Active Regeneration Manual Requests","SPN_Description":"Total number of aftertreatment 2 diesel particulate filter active regeneration manual requests by the operator during the current trip period.\\r\\n\\r\\nNOTE: This SPN needs to be reset by the reset PGN 56832.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"3750":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":60,"SPN":3750,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Conditions Not Met for Active Regeneration","SPN_Description":"Indicates that diesel particulate filter 1 is not able to begin or continue an active regenerate event at the current engine operating conditions.\\r\\n\\r\\n00 active DPF regeneration not inhibited\\r\\n01 active DPF regeneration inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN would indicate that the diesel particulate filter (bank 1) is not able to begin or continue an active regeneration event due to current engine operating conditions.\\r\\n\\r\\nThe conditions on these SPNs are exclusive to the conditions in the PGN 64892\\r\\n\\r\\nExamples of these other conditions are:\\r\\n- Engine Speed/Load Conditions not met\\r\\n- Soot Load Percent not high enough\\r\\n- Engine is a working mode senario\\r\\n\\r\\nSPN 3702 should be set to inhibited when SPN 3750 goes to inhibited status.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3785":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":0,"SPN":3785,"SPN_Name":"Tractor Brake Stroke Axle 1 Left","SPN_Description":"Brake stroke status for left brake actuator on tractor axle 1. \\r\\n\\r\\n000 - OK (Normal operation)  \\r\\n001 - Non-functioning\\r\\n010 - Overstroke \\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3786":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":3,"SPN":3786,"SPN_Name":"Tractor Brake Stroke Axle 1 Right","SPN_Description":"Brake stroke status for right brake actuator on tractor axle 1. \\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3787":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":6,"SPN":3787,"SPN_Name":"Tractor Brake Stroke Axle 2 Left","SPN_Description":"Brake stroke status for left brake actuator on tractor axle 2. \\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3788":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":9,"SPN":3788,"SPN_Name":"Tractor Brake Stroke Axle 2 Right","SPN_Description":"Brake stroke status for right brake actuator on tractor axle 2.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3789":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":12,"SPN":3789,"SPN_Name":"Tractor Brake Stroke Axle 3 Left","SPN_Description":"Brake stroke status for left brake actuator on tractor axle 3.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3790":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":15,"SPN":3790,"SPN_Name":"Tractor Brake Stroke Axle 3 Right","SPN_Description":"Brake stroke status for right brake actuator on tractor axle 3.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3791":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":18,"SPN":3791,"SPN_Name":"Tractor Brake Stroke Axle 4 Left","SPN_Description":"Brake stroke status for left brake actuator on tractor axle 4.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3792":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":21,"SPN":3792,"SPN_Name":"Tractor Brake Stroke Axle 4 Right","SPN_Description":"Brake stroke status for right brake actuator on tractor axle 4.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3793":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":24,"SPN":3793,"SPN_Name":"Tractor Brake Stroke Axle 5 Left","SPN_Description":"Brake stroke status for left brake actuator on tractor axle 5.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3794":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":27,"SPN":3794,"SPN_Name":"Tractor Brake Stroke Axle 5 Right","SPN_Description":"Brake stroke status for right brake actuator on tractor axle 5.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3795":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":30,"SPN":3795,"SPN_Name":"Trailer Brake Stroke Axle 1 Left","SPN_Description":"Brake stroke status for left brake actuator on trailerr axle 1.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3796":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":33,"SPN":3796,"SPN_Name":"Trailer Brake Stroke Axle 1 Right","SPN_Description":"Brake stroke status for right brake actuator on trailer axle 1.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3797":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":36,"SPN":3797,"SPN_Name":"Trailer Brake Stroke Axle 2 Left","SPN_Description":"Brake stroke status for left brake actuator on trailer axle 2.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3798":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":39,"SPN":3798,"SPN_Name":"Trailer Brake Stroke Axle 2 Right","SPN_Description":"Brake stroke status for right brake actuator on trailer axle 2.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3799":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":42,"SPN":3799,"SPN_Name":"Trailer Brake Stroke Axle 3 Left","SPN_Description":"Brake stroke status for left brake actuator on trailer axle 3.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3800":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":45,"SPN":3800,"SPN_Name":"Trailer Brake Stroke Axle 3 Right","SPN_Description":"Brake stroke status for right brake actuator on trailer axle 3.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3801":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":48,"SPN":3801,"SPN_Name":"Trailer Brake Stroke Axle 4 Left","SPN_Description":"Brake stroke status for left brake actuator on trailer axle 4.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3802":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":51,"SPN":3802,"SPN_Name":"Trailer Brake Stroke Axle 4 Right","SPN_Description":"Brake stroke status for right brake actuator on trailer axle 4.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3803":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":54,"SPN":3803,"SPN_Name":"Trailer Brake Stroke Axle 5 Left","SPN_Description":"Brake stroke status for left brake actuator on trailer axle 5.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3804":{"PGN":64881,"PGN_Name":"Brake actuator stroke status","PGN_Description":"BSA","first_bit":57,"SPN":3804,"SPN_Name":"Trailer Brake Stroke Axle 5 Right","SPN_Description":"Brake stroke status for right brake actuator on trailer axle 5.\\r\\n\\r\\n000 - OK (Normal operation)\\r\\n001 - Non-functioning\\r\\n010 - Overstroke\\r\\n011 - Dragging brake\\r\\n100 - Reserved\\r\\n101 - Reserved\\r\\n110 - Sensor error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"3807":{"PGN":65265,"PGN_Name":"Cruise Control/Vehicle Speed 1","PGN_Description":"CCVS1","first_bit":6,"SPN":3807,"SPN_Name":"Park Brake Release Inhibit Request","SPN_Description":"Park Brake Release Inhibit Request signals the desire that an applied park brake remain applied and limit the ability of the vehicle to be moved.  \\r\\n\\r\\n00 - Park Brake Release Inhibit not requested\\r\\n01 - Park Brake Release Inhibit requested\\r\\n10 - SAE reserved\\r\\n11 - Unavailable\\r\\n\\r\\nThis parameter provides the capability to request the device controlling a parking brake to inhibit its release. This is intended for devices to request the park brake remain applied.  Status 00b is provided when conditions recommending the application of the park brake no longer exist for the sender.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3808":{"PGN":65274,"PGN_Name":"Brakes 1","PGN_Description":"B1","first_bit":28,"SPN":3808,"SPN_Name":"Park Brake Release Inhibit Status","SPN_Description":"This parameter provides reports on the status of the Park Brake Release Inhibit function.\\r\\n\\r\\n00 - Park Brake release is not inhibited\\r\\n01 - Park Brake release is inhibited\\r\\n10 - Error (for example: Park Brake release is not inhibited, but is requested to be inhibited)\\r\\n11 - Unavailable\\r\\n\\r\\nThe device controlling the Park Brake sends a status of the inhibit function.  The allowed release of the park brake is provided as status 00b.  01b indicates that the release of the park brake is inhibited.  The release may be inhibited by either an external request or by local information available to the controlling device.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3809":{"PGN":64980,"PGN_Name":"Cab Message 3","PGN_Description":"CM3","first_bit":16,"SPN":3809,"SPN_Name":"Transmission Oil Level Request","SPN_Description":"Conveys operator or vehicle system desire for a transmission oil level reading to be taken. \\r\\n\\r\\n00 - No transmission oil level reading desired\\r\\n01 - Transmission oil level reading desired\\r\\n10 - Reserved\\r\\n11 - Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3810":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":0,"SPN":3810,"SPN_Name":"Retract Status of ramp 1","SPN_Description":"Retract status of ramp at doorway 1, counting from front to back on the vehicle.\\r\\n \\r\\n00 ramp retracted\\r\\n01 ramp extended\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3811":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":2,"SPN":3811,"SPN_Name":"Enable status of ramp 1","SPN_Description":"Enable status of ramp at doorway 1, counting from front to back on the vehicle.\\r\\n\\r\\n        00 ramp disabled\\r\\n        01 ramp enabled \\r\\n       10 error \\r\\n       11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3812":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":4,"SPN":3812,"SPN_Name":"Movement status of ramp 1","SPN_Description":"Movement status of ramp at doorway 1, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp not being moved\\r\\n01 ramp being moved\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3813":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":8,"SPN":3813,"SPN_Name":"Retract Status of ramp 2","SPN_Description":"Retract status of ramp at doorway 2, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp retracted\\r\\n01 ramp extended\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3814":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":10,"SPN":3814,"SPN_Name":"Enable status of ramp 2","SPN_Description":"Enable status of ramp at doorway 2, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp disabled\\r\\n01 ramp enabled \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3815":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":12,"SPN":3815,"SPN_Name":"Movement status of ramp 2","SPN_Description":"Movement status of ramp at doorway 2, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp not being moved\\r\\n01 ramp being moved\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3816":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":16,"SPN":3816,"SPN_Name":"Retract Status of ramp 3","SPN_Description":"Retract status of ramp at doorway 3, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp retracted\\r\\n01 ramp extended\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3817":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":18,"SPN":3817,"SPN_Name":"Enable status of ramp 3","SPN_Description":"Enable status of ramp at doorway 3, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp disabled\\r\\n01 ramp enabled \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3818":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":20,"SPN":3818,"SPN_Name":"Movement status of ramp 3","SPN_Description":"Movement status of ramp at doorway 3, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp not being moved\\r\\n01 ramp being moved\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3819":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":24,"SPN":3819,"SPN_Name":"Front axle group engagement status","SPN_Description":"Front axle group engagement status \\r\\n\\r\\n00 front axle group disengaged \\r\\n01 front axle group engaged\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3820":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":26,"SPN":3820,"SPN_Name":"Rear axle group engagement status","SPN_Description":"Rear axle group engagement status\\r\\n\\r\\n00 rear axle group disengaged \\r\\n01 rear axle group engaged\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3821":{"PGN":64879,"PGN_Name":"Electronic Engine Controller 8","PGN_Description":"EEC8","first_bit":0,"SPN":3821,"SPN_Name":"Engine Exhaust Gas Recirculation 1  Valve 2 Control","SPN_Description":"Desired percentage of maximum Exhaust Gas Recirculation (EGR) valve opening for valve 2.  0% means valve is closed. 100% means maximum valve opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3822":{"PGN":64916,"PGN_Name":"Electronic Engine Controller 7","PGN_Description":"EEC7","first_bit":16,"SPN":3822,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Valve 2 Position","SPN_Description":"The position of the second exhaust gas recirculation valve expressed as a percentage of full travel. Zero percent means the valve is closed and no exhaust gas is flowing into the intake air stream. One hundred percent means the valve is fully opened.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"3823":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":8,"SPN":3823,"SPN_Name":"Transmission Torque Converter Oil Outlet Temperature","SPN_Description":"Temperature of transmission torque converter outlet oil.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3826":{"PGN":64878,"PGN_Name":"Aftertreatment 1 SCR Service Information 1","PGN_Description":"A1SCRSI1","first_bit":0,"SPN":3826,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Average Consumption","SPN_Description":"Measured use of diesel exhaust fluid by a Selective Catalytic Reduction system for exhaust emission control, averaged over the previous 15 hours of engine operation.\\r\\n\\r\\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 1 Commanded Diesel Exhaust Fluid Consumption parameter (SPN 3828).","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"3828":{"PGN":64878,"PGN_Name":"Aftertreatment 1 SCR Service Information 1","PGN_Description":"A1SCRSI1","first_bit":16,"SPN":3828,"SPN_Name":"Aftertreatment 1 SCR Commanded Diesel Exhaust Fluid Consumption","SPN_Description":"This parameter transmits the amount of diesel exhaust fluid that the emissions control system has requested to be used, averaged over the past 15 hours of engine operation.\\r\\n\\r\\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 1 Average Diesel Exhaust Fluid Consumption parameter (SPN 3826).","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"3830":{"PGN":64877,"PGN_Name":"Aftertreatment 1 Air Control 2","PGN_Description":"AT1AC2","first_bit":0,"SPN":3830,"SPN_Name":"Aftertreatment 1 Secondary Air Differential Pressure","SPN_Description":"Indicates the secondary air differential pressure for aftertreatment 1.  Secondary air is air provided to the exhaust system (per SAE J2403).","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"3831":{"PGN":64877,"PGN_Name":"Aftertreatment 1 Air Control 2","PGN_Description":"AT1AC2","first_bit":16,"SPN":3831,"SPN_Name":"Aftertreatment 1 Secondary Air Temperature","SPN_Description":"Indicates the secondary air temperature for aftertreatment 1.  Secondary air is air provided to the exhaust system (per SAE J2403).","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3832":{"PGN":64877,"PGN_Name":"Aftertreatment 1 Air Control 2","PGN_Description":"AT1AC2","first_bit":32,"SPN":3832,"SPN_Name":"Aftertreatment 1 Secondary Air Mass Flow Rate","SPN_Description":"Indicates the secondary air mass flow for aftertreatment 1.  Secondary air is the air provided to the exhaust system (per SAE J2403).","bit_length":16,"scaling":0.2,"offset":0,"unit":"kg/h","SLOT_ID":262},"3833":{"PGN":64876,"PGN_Name":"Aftertreatment 2 Air Control 2","PGN_Description":"AT2AC2","first_bit":0,"SPN":3833,"SPN_Name":"Aftertreatment 2 Secondary Air Differential Pressure","SPN_Description":"Indicates the secondary air differential pressure for aftertreatment 2.  Secondary air is air provided to the exhaust system (per SAE J2403).","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"3834":{"PGN":64876,"PGN_Name":"Aftertreatment 2 Air Control 2","PGN_Description":"AT2AC2","first_bit":16,"SPN":3834,"SPN_Name":"Aftertreatment 2 Secondary Air Temperature","SPN_Description":"Indicates the secondary air temperature for aftertreatment 2.  Secondary air is air provided to the exhaust system (per SAE J2403).","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"3835":{"PGN":64876,"PGN_Name":"Aftertreatment 2 Air Control 2","PGN_Description":"AT2AC2","first_bit":32,"SPN":3835,"SPN_Name":"Aftertreatment 2 Secondary Air Mass Flow Rate","SPN_Description":"Indicates the secondary air mass flow for aftertreatment 2.  Secondary air is the air provided to the exhaust system (per SAE J2403).","bit_length":16,"scaling":0.2,"offset":0,"unit":"kg/h","SLOT_ID":262},"3837":{"PGN":64877,"PGN_Name":"Aftertreatment 1 Air Control 2","PGN_Description":"AT1AC2","first_bit":48,"SPN":3837,"SPN_Name":"Aftertreatment 1 Secondary Air Pressure","SPN_Description":"Pressure of the secondary air for aftertreatment 1.  Secondary air is air provided to the exhaust system (per SAE J2403).\\r\\n\\r\\nFor absolute pressure, see SPN 5589.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3838":{"PGN":64876,"PGN_Name":"Aftertreatment 2 Air Control 2","PGN_Description":"AT2AC2","first_bit":48,"SPN":3838,"SPN_Name":"Aftertreatment 2 Secondary Air Pressure","SPN_Description":"Pressure of the secondary air for aftertreatment 2.  Secondary air is air provided to the exhaust system (per SAE J2403).\\r\\n\\r\\nFor absolute pressure, see SPN 5590.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"3839":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":0,"SPN":3839,"SPN_Name":"Brake Temperature Warning","SPN_Description":"This parameter indicates if the temperature in the service brakes exceeds a certain value. It can be used for a warning information for the driver. The temperature warning value is vehicle manufacturer specific.\\r\\n\\r\\n00 Not Active\\r\\n01 Active\\r\\n10 Reserved\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3840":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":6,"SPN":3840,"SPN_Name":"Auxiliary I/O #17","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3841":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":4,"SPN":3841,"SPN_Name":"Auxiliary I/O #18","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3842":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":2,"SPN":3842,"SPN_Name":"Auxiliary I/O #19","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3843":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":0,"SPN":3843,"SPN_Name":"Auxiliary I/O #20","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3844":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":14,"SPN":3844,"SPN_Name":"Auxiliary I/O #21","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3845":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":12,"SPN":3845,"SPN_Name":"Auxiliary I/O #22","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3846":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":10,"SPN":3846,"SPN_Name":"Auxiliary I/O #23","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3847":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":8,"SPN":3847,"SPN_Name":"Auxiliary I/O #24","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3848":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":22,"SPN":3848,"SPN_Name":"Auxiliary I/O #25","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3849":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":20,"SPN":3849,"SPN_Name":"Auxiliary I/O #26","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3850":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":18,"SPN":3850,"SPN_Name":"Auxiliary I/O #27","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3851":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":16,"SPN":3851,"SPN_Name":"Auxiliary I/O #28","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3852":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":30,"SPN":3852,"SPN_Name":"Auxiliary I/O #29","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3853":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":28,"SPN":3853,"SPN_Name":"Auxiliary I/O #30","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3854":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":26,"SPN":3854,"SPN_Name":"Auxiliary I/O #31","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3855":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":24,"SPN":3855,"SPN_Name":"Auxiliary I/O #32","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3856":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":38,"SPN":3856,"SPN_Name":"Auxiliary I/O #33","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3857":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":36,"SPN":3857,"SPN_Name":"Auxiliary I/O #34","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3858":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":34,"SPN":3858,"SPN_Name":"Auxiliary I/O #35","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3859":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":32,"SPN":3859,"SPN_Name":"Auxiliary I/O #36","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3860":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":46,"SPN":3860,"SPN_Name":"Auxiliary I/O #37","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3861":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":44,"SPN":3861,"SPN_Name":"Auxiliary I/O #38","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3862":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":42,"SPN":3862,"SPN_Name":"Auxiliary I/O #39","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3863":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":40,"SPN":3863,"SPN_Name":"Auxiliary I/O #40","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3864":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":54,"SPN":3864,"SPN_Name":"Auxiliary I/O #41","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3865":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":52,"SPN":3865,"SPN_Name":"Auxiliary I/O #42","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3866":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":50,"SPN":3866,"SPN_Name":"Auxiliary I/O #43","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3867":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":48,"SPN":3867,"SPN_Name":"Auxiliary I/O #44","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3868":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":62,"SPN":3868,"SPN_Name":"Auxiliary I/O #45","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3869":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":60,"SPN":3869,"SPN_Name":"Auxiliary I/O #46","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3870":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":58,"SPN":3870,"SPN_Name":"Auxiliary I/O #47","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3871":{"PGN":42752,"PGN_Name":"Auxiliary Input/Output Status 2","PGN_Description":"AUXIO2","first_bit":56,"SPN":3871,"SPN_Name":"Auxiliary I/O #48","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3872":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":6,"SPN":3872,"SPN_Name":"Auxiliary I/O #49","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3873":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":4,"SPN":3873,"SPN_Name":"Auxiliary I/O #50","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3874":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":2,"SPN":3874,"SPN_Name":"Auxiliary I/O #51","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3875":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":0,"SPN":3875,"SPN_Name":"Auxiliary I/O #52","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3876":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":14,"SPN":3876,"SPN_Name":"Auxiliary I/O #53","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3877":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":12,"SPN":3877,"SPN_Name":"Auxiliary I/O #54","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3878":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":10,"SPN":3878,"SPN_Name":"Auxiliary I/O #55","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3879":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":8,"SPN":3879,"SPN_Name":"Auxiliary I/O #56","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3880":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":22,"SPN":3880,"SPN_Name":"Auxiliary I/O #57","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3881":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":20,"SPN":3881,"SPN_Name":"Auxiliary I/O #58","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3882":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":18,"SPN":3882,"SPN_Name":"Auxiliary I/O #59","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3883":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":16,"SPN":3883,"SPN_Name":"Auxiliary I/O #60","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3884":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":30,"SPN":3884,"SPN_Name":"Auxiliary I/O #61","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3885":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":28,"SPN":3885,"SPN_Name":"Auxiliary I/O #62","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3886":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":26,"SPN":3886,"SPN_Name":"Auxiliary I/O #63","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3887":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":24,"SPN":3887,"SPN_Name":"Auxiliary I/O #64","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3888":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":38,"SPN":3888,"SPN_Name":"Auxiliary I/O #65","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3889":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":36,"SPN":3889,"SPN_Name":"Auxiliary I/O #66","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3890":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":34,"SPN":3890,"SPN_Name":"Auxiliary I/O #67","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3891":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":32,"SPN":3891,"SPN_Name":"Auxiliary I/O #68","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3892":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":46,"SPN":3892,"SPN_Name":"Auxiliary I/O #69","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3893":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":44,"SPN":3893,"SPN_Name":"Auxiliary I/O #70","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3894":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":42,"SPN":3894,"SPN_Name":"Auxiliary I/O #71","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3895":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":40,"SPN":3895,"SPN_Name":"Auxiliary I/O #72","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3896":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":54,"SPN":3896,"SPN_Name":"Auxiliary I/O #73","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3897":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":52,"SPN":3897,"SPN_Name":"Auxiliary I/O #74","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3898":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":50,"SPN":3898,"SPN_Name":"Auxiliary I/O #75","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3899":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":48,"SPN":3899,"SPN_Name":"Auxiliary I/O #76","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3900":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":62,"SPN":3900,"SPN_Name":"Auxiliary I/O #77","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3901":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":60,"SPN":3901,"SPN_Name":"Auxiliary I/O #78","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3902":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":58,"SPN":3902,"SPN_Name":"Auxiliary I/O #79","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3903":{"PGN":42496,"PGN_Name":"Auxiliary Input/Output Status 3","PGN_Description":"AUXIO3","first_bit":56,"SPN":3903,"SPN_Name":"Auxiliary I/O #80","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3904":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":6,"SPN":3904,"SPN_Name":"Auxiliary I/O #81","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3905":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":4,"SPN":3905,"SPN_Name":"Auxiliary I/O #82","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3906":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":2,"SPN":3906,"SPN_Name":"Auxiliary I/O #83","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3907":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":0,"SPN":3907,"SPN_Name":"Auxiliary I/O #84","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3908":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":14,"SPN":3908,"SPN_Name":"Auxiliary I/O #85","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3909":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":12,"SPN":3909,"SPN_Name":"Auxiliary I/O #86","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3910":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":10,"SPN":3910,"SPN_Name":"Auxiliary I/O #87","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3911":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":8,"SPN":3911,"SPN_Name":"Auxiliary I/O #88","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3912":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":22,"SPN":3912,"SPN_Name":"Auxiliary I/O #89","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3913":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":20,"SPN":3913,"SPN_Name":"Auxiliary I/O #90","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3914":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":18,"SPN":3914,"SPN_Name":"Auxiliary I/O #91","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3915":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":16,"SPN":3915,"SPN_Name":"Auxiliary I/O #92","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3916":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":30,"SPN":3916,"SPN_Name":"Auxiliary I/O #93","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3917":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":28,"SPN":3917,"SPN_Name":"Auxiliary I/O #94","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3918":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":26,"SPN":3918,"SPN_Name":"Auxiliary I/O #95","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3919":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":24,"SPN":3919,"SPN_Name":"Auxiliary I/O #96","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3920":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":38,"SPN":3920,"SPN_Name":"Auxiliary I/O #97","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3921":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":36,"SPN":3921,"SPN_Name":"Auxiliary I/O #98","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3922":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":34,"SPN":3922,"SPN_Name":"Auxiliary I/O #99","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3923":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":32,"SPN":3923,"SPN_Name":"Auxiliary I/O #100","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3924":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":46,"SPN":3924,"SPN_Name":"Auxiliary I/O #101","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3925":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":44,"SPN":3925,"SPN_Name":"Auxiliary I/O #102","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3926":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":42,"SPN":3926,"SPN_Name":"Auxiliary I/O #103","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3927":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":40,"SPN":3927,"SPN_Name":"Auxiliary I/O #104","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3928":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":54,"SPN":3928,"SPN_Name":"Auxiliary I/O #105","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3929":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":52,"SPN":3929,"SPN_Name":"Auxiliary I/O #106","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3930":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":50,"SPN":3930,"SPN_Name":"Auxiliary I/O #107","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3931":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":48,"SPN":3931,"SPN_Name":"Auxiliary I/O #108","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3932":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":62,"SPN":3932,"SPN_Name":"Auxiliary I/O #109","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3933":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":60,"SPN":3933,"SPN_Name":"Auxiliary I/O #110","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3934":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":58,"SPN":3934,"SPN_Name":"Auxiliary I/O #111","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3935":{"PGN":42240,"PGN_Name":"Auxiliary Input/Output Status 4","PGN_Description":"AUXIO4","first_bit":56,"SPN":3935,"SPN_Name":"Auxiliary I/O #112","SPN_Description":"Identifies the current status of auxiliary input/output functions that are configured uniquely per application.\\r\\n\\r\\n00 - Auxiliary channel off\\r\\n01 - Auxiliary channel on\\r\\n10 - Error Indicator or Not Used , depending on application\\r\\n11 - Not Available or Take No Action, depending on application","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3938":{"PGN":61470,"PGN_Name":"Generator Control 2","PGN_Description":"GC2","first_bit":0,"SPN":3938,"SPN_Name":"Generator Governing Bias","SPN_Description":"Control signal used to govern the genset\'s speed or load (depending on isochronous or utility parallel operation, respectively)\\r\\n\\r\\nNOTE:  If this method of engine control is used, the PGN 0 (TSC1) is not expected to be received by the engine controller and it will not be processed.","bit_length":16,"scaling":0.004,"offset":-125,"unit":"%","SLOT_ID":264},"3939":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":8,"SPN":3939,"SPN_Name":"Enable Switch - PTO Engine Flywheel","SPN_Description":"Status of the PTO Engine Flywheel enable switch\\r\\n\\r\\n00 Enable switch off \u2013 PTO operation not desired\\r\\n01 Enable switch on \u2013 PTO operation desired \\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3940":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":24,"SPN":3940,"SPN_Name":"Engagement Consent - PTO Engine Flywheel","SPN_Description":"Engagement Consent status for the PTO Engine Flywheel\\r\\n\\r\\n00 Consent not given \u2013 PTO drive may not be engaged\\r\\n01 Consent given \u2013 PTO drive may be engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3941":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":40,"SPN":3941,"SPN_Name":"Engagement Status - PTO Engine Flywheel","SPN_Description":"Engagement status of the PTO Engine Flywheel\\r\\n\\r\\n00 Drive not engaged\\r\\n01 Drive engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3942":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":10,"SPN":3942,"SPN_Name":"Enable Switch - PTO Engine Accessory Drive 1","SPN_Description":"Status of the PTO engine accessory drive 1 enable switch\\r\\n\\r\\n00 Enable switch off \u2013 PTO operation not desired\\r\\n01 Enable switch on \u2013 PTO operation desired\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3943":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":26,"SPN":3943,"SPN_Name":"Engagement Consent - PTO Engine Accessory Drive 1","SPN_Description":"Engagement consent status for the PTO engine accessory drive 1\\r\\n\\r\\n00 Consent not given \u2013 PTO drive may not be engaged\\r\\n01 Consent given \u2013 PTO drive may be engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3944":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":42,"SPN":3944,"SPN_Name":"Engagement Status - PTO Engine Accessory Drive 1","SPN_Description":"Engagement status of the PTO engine accessory drive 1\\r\\n\\r\\n00 Drive not engaged\\r\\n01 Drive engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3945":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":12,"SPN":3945,"SPN_Name":"Enable Switch - PTO Engine Accessory Drive 2","SPN_Description":"Status of the PTO engine accessory drive 2 enable switch\\r\\n\\r\\n00 Enable switch off \u2013 PTO operation not desired\\r\\n01 Enable switch on \u2013 PTO operation desired\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3946":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":28,"SPN":3946,"SPN_Name":"Engagement Consent - PTO Engine Accessory Drive 2","SPN_Description":"Engagement Consent status for the PTO engine accessory drive 2 \\r\\n\\r\\n00 Consent not given \u2013 PTO drive may not be engaged\\r\\n01 Consent given \u2013 PTO drive may be engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3947":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":44,"SPN":3947,"SPN_Name":"Engagement Status - PTO Engine Accessory Drive 2","SPN_Description":"Engagement status of the PTO engine accessory drive 2\\r\\n\\r\\n00 Drive not engaged\\r\\n01 Drive engaged\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3948":{"PGN":64932,"PGN_Name":"PTO Drive Engagement","PGN_Description":"PTODE","first_bit":48,"SPN":3948,"SPN_Name":"At least one PTO engaged","SPN_Description":"Indicates that at least one PTO is engaged\\r\\n\\r\\n00 No PTO drive is engaged\\r\\n01 At least one PTO drive is engaged\\r\\n10 Error\\r\\n11 Not available\\r\\n\\r\\nNote:  This parameter should only be sent by the controller that has knowledge of all PTO drives on the vehicle (e.g, the FMS gateway).  Individual PTO drive controllers should broadcast this parameter as \\"not available\\".","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"3987":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":10,"SPN":3987,"SPN_Name":"Compression Brake Enable Switch Indicator Lamp Command","SPN_Description":"Command signal directly controlling Compression Brake Enable Switch Indicator Lamp.  The compression brake switch indicator signals the status of the compression brake enable switch to the operator.\\r\\n \\r\\n00 - Lamp OFF\\r\\n01 - Lamp ON\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4010":{"PGN":64752,"PGN_Name":"Engine Fuel/lube systems 2","PGN_Description":"EFS2","first_bit":16,"SPN":4010,"SPN_Name":"Fuel Tank Transfer Pump","SPN_Description":"Operating state of the fuel tank transfer pump. The fuel tank transfer pump transfers fuel from the secondary fuel tank to the primary fuel tank.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4059":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":0,"SPN":4059,"SPN_Name":"Sole or Forward-most Steer Axle Group Weight Available","SPN_Description":"Indicates the availability of the sole or forward-most steer axle group for purposes of weight measurement\\r\\n\\r\\n00 = Steer axle group not present\\r\\n01 = Steer axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable\\r\\n\\r\\nIf there is only one steer axle, this SPN should be used.  See also SPN 5933 for a second steer axle.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4060":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":2,"SPN":4060,"SPN_Name":"Lift Axle Group Weight Available","SPN_Description":"Indicates the availability of the lift axle group for purposes of weight measurement\\r\\n\\r\\n00 = Lift axle group not present\\r\\n01 = Lift axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4061":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":4,"SPN":4061,"SPN_Name":"Sole or Forward-most Drive Axle Group Weight Available","SPN_Description":"Indicates the availability of the sole or forward-most drive axle group for purposes of weight measurement\\r\\n\\r\\n00 = Drive axle group not present\\r\\n01 = Drive axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable\\r\\n\\r\\nIf there is only one drive axle, this SPN should be used.  See also SPN 5934 for a second drive axle.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4062":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":6,"SPN":4062,"SPN_Name":"Tag Axle Group Weight Available","SPN_Description":"Indicates the availability of the tag axle group for purposes of weight measurement\\r\\n\\r\\n00 = Tag axle group not present\\r\\n01 = Tag axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4063":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":8,"SPN":4063,"SPN_Name":"Additional Tractor Axle Group Weight Available","SPN_Description":"Indicates the availability of the additional tractor axle group for purposes of weight measurement\\r\\n\\r\\n00 = Additional tractor axle group not present\\r\\n01 = Additional tractor axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4064":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":10,"SPN":4064,"SPN_Name":"Trailer A Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer A axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer A axle group not present\\r\\n01 = Trailer A axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4065":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":12,"SPN":4065,"SPN_Name":"Trailer B Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer B axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer B axle group not present\\r\\n01 = Trailer B axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4066":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":14,"SPN":4066,"SPN_Name":"Trailer C Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer C axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer C axle group not present\\r\\n01 = Trailer C axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4067":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":16,"SPN":4067,"SPN_Name":"Trailer D Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer D axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer D axle group not present\\r\\n01 = Trailer D axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4068":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":18,"SPN":4068,"SPN_Name":"Trailer E Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer E axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer E axle group not present\\r\\n01 = Trailer E axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4069":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":20,"SPN":4069,"SPN_Name":"Trailer F Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer F axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer F axle group not present\\r\\n01 = Trailer F axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4070":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":22,"SPN":4070,"SPN_Name":"Trailer G Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer G axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer G axle group not present\\r\\n01 = Trailer G axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4071":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":24,"SPN":4071,"SPN_Name":"Trailer H Axle Group Weight Available","SPN_Description":"Indicates the availability of the trailer H axle group for purposes of weight measurement\\r\\n\\r\\n00 = Trailer H axle group not present\\r\\n01 = Trailer H axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4072":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":26,"SPN":4072,"SPN_Name":"Additional Trailer Axle Group Weight Available","SPN_Description":"Indicates the availability of the additional trailer axle group for purposes of weight measurement\\r\\n\\r\\n00 = Additional trailer axle group not present\\r\\n01 = Additional trailer axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4073":{"PGN":64874,"PGN_Name":"Axle Group Weight","PGN_Description":"AGW","first_bit":0,"SPN":4073,"SPN_Name":"Axle Group Location","SPN_Description":"Specific axle group used in conjunction with and when communicating the axle group weight, listed from the front of the vehicle to the rear.\\r\\n\\r\\nIf the value of SPN 5935 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\\r\\n\\r\\n0 = Reserved\\r\\n1 = Sole or Forward-most Steer axle group\\r\\n2 = Lift axle group\\r\\n3 = Sole or Forward-most Drive axle group\\r\\n4 = Tag axle group\\r\\n5 = Additional tractor axle group\\r\\n6 = Trailer A axle group\\r\\n7 = Trailer B axle group\\r\\n8 = Trailer C axle group\\r\\n9 = Trailer D axle group\\r\\n10 = Trailer E axle group\\r\\n11 = Trailer F axle group\\r\\n12 = Trailer G axle group\\r\\n13 = Trailer H axle group\\r\\n14 = Additional trailer axle group\\r\\n15 = Reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4074":{"PGN":64873,"PGN_Name":"Axle Group Calibration Weights","PGN_Description":"AGCW","first_bit":0,"SPN":4074,"SPN_Name":"Axle Group Location","SPN_Description":"Specific axle group used in conjunction with and when communicating the axle group calibration, listed from the front of the vehicle to the rear.\\r\\n\\r\\nIf the value of SPN 5936 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\\r\\n\\r\\n0 = Reserved\\r\\n1 = Sole or Forward-most Steer axle group\\r\\n2 = Lift axle group\\r\\n3 = Sole or Forward-most Drive axle group\\r\\n4 = Tag axle group\\r\\n5 = Additional tractor axle group\\r\\n6 = Trailer A axle group\\r\\n7 = Trailer B axle group\\r\\n8 = Trailer C axle group\\r\\n9 = Trailer D axle group\\r\\n10 = Trailer E axle group\\r\\n11 = Trailer F axle group\\r\\n12 = Trailer G axle group\\r\\n13 = Trailer H axle group\\r\\n14 = Additional trailer axle group\\r\\n15 = Reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4075":{"PGN":64871,"PGN_Name":"Zero Net Vehicle Weight Change","PGN_Description":"ZNVW","first_bit":0,"SPN":4075,"SPN_Name":"Zero Net Vehicle Weight Change","SPN_Description":"Zero Net Vehicle Weight Change command.  A controller receiving this command will record the current Gross Combination Weight as the new Zero, and future requests for Net Vehicle Weight Change will be answered with the difference between the (then) current Gross Combination Weight and the recorded value.\\r\\n\\r\\n00 - No change to Net Vehicle Weight Change \\r\\n01 - Zero Net Vehicle Weight Change\\r\\n10 - Reserved\\r\\n11 - Not available / Not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4076":{"PGN":64870,"PGN_Name":"Engine Temperature 4","PGN_Description":"ET4","first_bit":0,"SPN":4076,"SPN_Name":"Engine Coolant Temperature 2","SPN_Description":"Second temperature of liquid found in the engine cooling system.   See also SPNs 110, 4193 and 6209.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4077":{"PGN":64869,"PGN_Name":"Aftertreatment 1 Fuel Control 2","PGN_Description":"AT1FC2","first_bit":0,"SPN":4077,"SPN_Name":"Aftertreatment 1 Fuel Pressure 2","SPN_Description":"Second fuel pressure measurement for the aftertreatment 1 system","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4078":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":8,"SPN":4078,"SPN_Name":"Generator Alternator Efficiency","SPN_Description":"Measured, calculated, and/or estimated operating efficiency of the generator alternator.  Percentage reflects ratio of power output divided by power input, multiplied by 100.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"4079":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":24,"SPN":4079,"SPN_Name":"Generator Governing Speed Command","SPN_Description":"Command from user and/or generator control system for the genset (engine) to govern to low idle or rated base speed setpoints.  If this method of engine control is used, then the PGN 0 (TSC1) is not expected to be received by the engine controller and it will not be processed.\\r\\n\\r\\n00 = Rated Speed\\r\\n01 = Low Idle Speed\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4080":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":26,"SPN":4080,"SPN_Name":"Generator Frequency Selection","SPN_Description":"Command from user and/or generator control system for the genset (engine) to target operations for 50 Hz, 60 Hz, or 400 Hz.\\r\\n\\r\\n0000 = 50 Hz\\r\\n0001 = 60 Hz\\r\\n0010 = 400 Hz\\r\\n0011 - 1101 = SAE Reserved\\r\\n1110 = Unknown\\r\\n1111= Don\'t care /take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4082":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":4,"SPN":4082,"SPN_Name":"Fuel Pump Primer Control","SPN_Description":"Parameter used to activate or deactivate a priming system on the fuel transfer system. The fuel priming system is a system that purges air in the fuel lines and may assist fuel delivery to a second pump at lower speeds.\\r\\n\\r\\n00 = Deactivate\\r\\n01 = Activate\\r\\n10 = Reserved\\r\\n11 = Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4083":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":51,"SPN":4083,"SPN_Name":"Fuel Pump Primer Status","SPN_Description":"Parameter used to transmit the actual status of the fuel priming system.  The fuel priming system is a system that purges air in the fuel lines and may assist fuel delivery to a second pump at lower speeds.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4086":{"PGN":1792,"PGN_Name":"General Purpose Valve Pressure","PGN_Description":"GPV4","first_bit":0,"SPN":4086,"SPN_Name":"Valve Load Sense Pressure","SPN_Description":"The maximum of the currently measured pressures of a valve\'s work port A and work port B.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"4087":{"PGN":1792,"PGN_Name":"General Purpose Valve Pressure","PGN_Description":"GPV4","first_bit":16,"SPN":4087,"SPN_Name":"Valve Pilot Pressure","SPN_Description":"Pressure of a valve\'s pilot supply port.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"4088":{"PGN":1792,"PGN_Name":"General Purpose Valve Pressure","PGN_Description":"GPV4","first_bit":24,"SPN":4088,"SPN_Name":"Valve Assembly Load sense Pressure","SPN_Description":"The maximum pressure of a valve assembly\'s current collective load sense pressures where a valve assembly can consist of two or more valves.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"4089":{"PGN":1792,"PGN_Name":"General Purpose Valve Pressure","PGN_Description":"GPV4","first_bit":40,"SPN":4089,"SPN_Name":"Valve Assembly Supply Pressure","SPN_Description":"Pressure of the hydraulic supply port to a valve assembly.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"4097":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":48,"SPN":4097,"SPN_Name":"Aftertreatment 1 Fuel Drain Actuator","SPN_Description":"Indicates whether aftertreatment 1 fuel drain actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4098":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":48,"SPN":4098,"SPN_Name":"Aftertreatment 2 Fuel Drain Actuator","SPN_Description":"Indicates whether aftertreatment 2 fuel drain actuator is on or off\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   reserved for SAE assignment\\r\\n11   not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4099":{"PGN":1024,"PGN_Name":"External Brake Request","PGN_Description":"XBR","first_bit":24,"SPN":4099,"SPN_Name":"XBR urgency","SPN_Description":"The idea of the urgency value is to adjust the endurance brake integration behavior in the EBS system according to the traffic situation.\\r\\n\\r\\nOn low urgency values (0%, e.g. downhill cruise control or preceding vehicle far ahead) the brake system shall primarily use endurance brakes to reduce lining wear.\\r\\n\\r\\nOn high urgency values (100%, e.g. vehicle close up or a vehicle cuts into the traffic line just before host vehicle) the brake system is expected to gain the demanded deceleration (acceleration) as fast as possible.\\r\\n\\r\\nValues:\\r\\n0% - Situation not critical; low retarder dynamics are tolerated. Activation of the foundation brakes after a time if retarder performance is insufficient\\r\\ny % - Faster activation of foundation brakes to compensate retarder performance, linear interpolation between 0 and  100%\\r\\n100% - Low retarder dynamics shall be fully compensated by the foundation brakes\\r\\n\\r\\nNotes:\\r\\n- This parameter has only an effect if XBR EBI switch is set to \\"10: endurance brake integration allowed\\"\\r\\n- XBR urgency makes sense only if the XBR request(s) is (are) processed in one device like the EBS controller which also sends TSC1 to the retarder(s). Such a data flow diagram is shown in figure PGN1024_A. When the Retarder is controlled directly by the XBR transmitter XBR urgency should be set to not available.\\r\\n\\r\\nIn adaptive cruise control (ACC) operation there are situations where it is useful to have as less lining wear as possible like keeping the set speed on going downhill. It would not be useful to activate foundation brakes in such a situation except when the capabilities of the endurance brakes are not sufficient.\\r\\n \\r\\nIn other situations like emergency braking or fast reaction on a car that cut in at a short distance in front of the own vehicle a reaction as fast as possible is needed. In such cases low retarder dynamics must be compensated by the foundation brakes.\\r\\n\\r\\nThere are two different ways to integrate the endurance brakes into the adaptive cruise control.\\r\\na) the request for deceleration could be processed by the EBS system completely. This means that the EBS receives the deceleration demand and activates the friction and/or the endurance brakes accordingly. EBS is sending the TSC1 to the retarder. (see figure PGN1024_A dataflow diagram for external brake request)\\r\\nb) the ACC sends XBR to the brake controller and TSC1 to the endurance brakes.\\r\\n\\r\\nIn case \\"a)\\" the ACC system does not have direct control of the endurance brakes. To adjust the endurance brakes according to the traffic situation (high or low urgency values see above) this new SPN is needed.\\r\\n\\r\\nIf the retarder performance is not sufficient (e.g. because of high retarder temperature) the foundation brakes will be added automatically. This case of not sufficient retarder performance cannot be covered by switching EBI mode from 01 (endurance brakes only) to EBI mode 10 (endurance brake integration allowed) because the actual deceleration caused by the retarder is less than the requested decelleration. A simple switching (01 to 10) would cause an uncomfortable jerk.\\r\\n\\r\\n\\r\\nNOTE:  This parameter is defined in European patent EP 1 386 774 B1 (see reference in section 2.1.3) and is included with permission from the patent holder.  The patent holder is prepared to grant a free license to an unrestricted number of applicants on a worldwide, non-discriminatory basis to comply with this recommended practice.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4151":{"PGN":64851,"PGN_Name":"Engine Average Information","PGN_Description":"EAI","first_bit":0,"SPN":4151,"SPN_Name":"Engine Exhaust Temperature Average","SPN_Description":"The calculated average temperature based upon all of the engine exhaust port temperatures.  This is the average temperature based upon the exhaust port temperature measurements at each of the engine cylinders.\\r\\n\\r\\nNotes: \\r\\n\\r\\nUse SPN 173 - Engine Exhaust Temperature to report the actual measured temperature of the exhaust for the entire engine, after the turbocharger.\\r\\n\\r\\nSee SPN 2433 - Engine Exhaust Manifold Bank 2 Temperature 1, and SPN 2434 - Engine Exhaust Manifold Bank 1 Temperature 1 to report the actual measured temperature of the manifold for engines requiring more than one exhaust temperature measurement.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4152":{"PGN":64851,"PGN_Name":"Engine Average Information","PGN_Description":"EAI","first_bit":32,"SPN":4152,"SPN_Name":"Engine Exhaust Bank 2 Temperature Average","SPN_Description":"The calculated average temperature based upon all of the Bank 2 (right bank) engine exhaust port temperatures.  This is the average temperature based upon the exhaust port temperature measurements of each of the engine cylinders on the right bank before the turbocharger.\\r\\n\\r\\nUse SPN 2433 Engine Exhaust Manifold Bank 2 Temperature 1 to report the actual measured temperature of the manifold on the right side as seen from the flywheel end of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4153":{"PGN":64851,"PGN_Name":"Engine Average Information","PGN_Description":"EAI","first_bit":16,"SPN":4153,"SPN_Name":"Engine Exhaust Bank 1 Temperature Average","SPN_Description":"The calculated average temperature based upon all of the Bank 1 (left bank) engine exhaust port temperatures.  This is the average temperature based upon the exhaust port temperature measurements of each of the engine cylinders on the left bank prior to the turbocharger.\\r\\n\\r\\nUse SPN 2434 Engine Exhaust Manifold Bank 1 Temperature 1 to report the actual measured temperature of the manifold on the left side as seen from the flywheel end of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4154":{"PGN":61444,"PGN_Name":"Electronic Engine Controller 1","PGN_Description":"EEC1","first_bit":4,"SPN":4154,"SPN_Name":"Actual Engine - Percent Torque (Fractional)","SPN_Description":"This parameter displays an additional torque in percent of the reference engine torque. \\r\\n\\r\\nWhen the MSB is set to 1, this parameter is not available.  When the MSB is set to 0, bits 1 to 3 indicate the desired torque with resolution of 0.125%/bit . Range is from 0 to 0.875% of reference torque.  \\r\\n\\r\\nThe parameter is used in combination with SPN 513 Actual Engine Torque. The resulting actual engine torque will be calculated by adding these two parameters. \\r\\n\\r\\nAdditional torque representations\\r\\n\\r\\n0000 = +0.000%\\r\\n0001 = +0.125%\\r\\n.\\r\\n.\\r\\n.\\r\\n0111 = +0.875%\\r\\n1000 - 1111 = not available\\r\\n\\r\\nFor example, if SPN 513 = 150 (or 25%) and this parameter is 0100, the torque would be 25.5%.\\r\\nIf SPN 513 = 175 (or 50%) and this parameter is 0001, the torque would be 50.125%\\r\\nIf SPN 513 = 175 (or 50%) and this parameter is 1111, the torque would remain 50% (no high resolution available)","bit_length":4,"scaling":0.125,"offset":0,"unit":"%","SLOT_ID":268},"4155":{"PGN":2048,"PGN_Name":"Auxiliary Input/Output Status 5","PGN_Description":"AUXIO5","first_bit":0,"SPN":4155,"SPN_Name":"Auxiliary I/O Channel #6","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"4156":{"PGN":2048,"PGN_Name":"Auxiliary Input/Output Status 5","PGN_Description":"AUXIO5","first_bit":16,"SPN":4156,"SPN_Name":"Auxiliary I/O Channel #5","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"4157":{"PGN":2048,"PGN_Name":"Auxiliary Input/Output Status 5","PGN_Description":"AUXIO5","first_bit":32,"SPN":4157,"SPN_Name":"Auxiliary I/O Channel #4","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"4158":{"PGN":2048,"PGN_Name":"Auxiliary Input/Output Status 5","PGN_Description":"AUXIO5","first_bit":48,"SPN":4158,"SPN_Name":"Auxiliary I/O Channel #3","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"4159":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":0,"SPN":4159,"SPN_Name":"Auxiliary I/O Channel #10","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4160":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":8,"SPN":4160,"SPN_Name":"Auxiliary I/O Channel #9","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4161":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":16,"SPN":4161,"SPN_Name":"Auxiliary I/O Channel #8","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4162":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":24,"SPN":4162,"SPN_Name":"Auxiliary I/O Channel #7","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4163":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":32,"SPN":4163,"SPN_Name":"Auxiliary I/O Channel #14","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4164":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":40,"SPN":4164,"SPN_Name":"Auxiliary I/O Channel #13","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4165":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":48,"SPN":4165,"SPN_Name":"Auxiliary I/O Channel #12","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4166":{"PGN":40192,"PGN_Name":"Auxiliary Input/Output Status 6","PGN_Description":"AUXIO6","first_bit":56,"SPN":4166,"SPN_Name":"Auxiliary I/O Channel #11","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4167":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":0,"SPN":4167,"SPN_Name":"Auxiliary I/O Channel #18","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4168":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":8,"SPN":4168,"SPN_Name":"Auxiliary I/O Channel #17","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4169":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":16,"SPN":4169,"SPN_Name":"Auxiliary I/O Channel #16","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4170":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":24,"SPN":4170,"SPN_Name":"Auxiliary I/O Channel #15","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4171":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":32,"SPN":4171,"SPN_Name":"Auxiliary I/O Channel #22","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4172":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":40,"SPN":4172,"SPN_Name":"Auxiliary I/O Channel #21","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4173":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":48,"SPN":4173,"SPN_Name":"Auxiliary I/O Channel #20","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4174":{"PGN":39936,"PGN_Name":"Auxiliary Input/Output Status 7","PGN_Description":"AUXIO7","first_bit":56,"SPN":4174,"SPN_Name":"Auxiliary I/O Channel #19","SPN_Description":"Identifies the current value of auxiliary input/output channels that are configured uniquely per application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"4175":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":53,"SPN":4175,"SPN_Name":"Diesel Particulate Filter Active Regeneration Forced Status","SPN_Description":"Indicates the forced execution status of diesel particulate filter regeneration.\\r\\n\\r\\n000 Not Active\\r\\n001 Active \u2013 Forced by Switch (See SPN 3696)\\r\\n010 Active \u2013 Forced by Service Tool \\r\\n011 Reserved for SAE Assignment\\r\\n100 Reserved for SAE Assignment\\r\\n101 Reserved for SAE Assignment\\r\\n110 Reserved for SAE Assignment\\r\\n111 not available\\r\\n\\r\\nThis SPN indicates the forced execution status of diesel particulate filter regeneration.  The SPN would be \u201CNot Active\u201D when the execution of diesel particulate filter regeneration has not been forced.  Either of the states \u201CActive \u2013 Forced by Switch\u201D and \u201CActive \u2013 Forced by Service Tool\u201D will be active when execution of diesel particulate filter regeneration is forced, providing feedback as to which entity forced the execution of diesel particulate filter regeneration.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4176":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":0,"SPN":4176,"SPN_Name":"Transmission Current Range Display Blank State","SPN_Description":"State signal indicating a transmission request for the display of the Transmission Current Range parameter (SPN 163) to be blanked or not blanked.  The \'Transmission Current Range Display Blank State\' indicator can be utilized by (but not limited to) the shift console, instrument cluster, or cab display.  Definition of the cause of this state is at the discretion of the transmission manufacturer.\\r\\n\\r\\n00=Not Blanked\\r\\n01=Blanked\\r\\n10=Error\\r\\n11=Not Supported\\r\\n\\r\\nNote:  This is a companion of SPN 1850, that will allow the \\"current range\\" display to be blanked as needed while still retaining a valid current range broadcast in SPN 163.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4177":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":24,"SPN":4177,"SPN_Name":"Transmission Oil Life Remaining","SPN_Description":"Signal which indicates the actual oil life remaining in percent.  100% means the transmission oil is brand new, and 0% means the transmission oil is at the end of its life.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4178":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":2,"SPN":4178,"SPN_Name":"Transmission Service Indicator","SPN_Description":"Signal from transmission indicating that some aspect of the gearbox requires servicing, such as the oil, filter, clutch(es) or other component.\\r\\n\\r\\n00  Transmission Service Indicator is off\\r\\n01  Transmission Service Indicator is on continuously\\r\\n10  Transmission Service Indicator is flashing\\r\\n11  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4180":{"PGN":39680,"PGN_Name":"Proprietary Method Identification","PGN_Description":"PMI","first_bit":0,"SPN":4180,"SPN_Name":"Data Dictionary Manufacturer Code","SPN_Description":"The J1939 Manufacturer Code (see J1939 Table B10) associated with the manufacturer who defined the proprietary communications method.  0x7FF reserved for \\"Not Available\\"","bit_length":11,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":218},"4181":{"PGN":39680,"PGN_Name":"Proprietary Method Identification","PGN_Description":"PMI","first_bit":11,"SPN":4181,"SPN_Name":"Data Dictionary Method","SPN_Description":"A manufacturer defined code to define the proprietary communications method.  The structure and interpretation of the code is manufacturer specific.  This allows manufacturers to establish their own methods for reporting proprietary support for PropA, PropA2, and PropB messages.","bit_length":21,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":217},"4191":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":40,"SPN":4191,"SPN_Name":"Engine Requested Torque (Fractional)","SPN_Description":"This parameter displays an additional torque in percent of the reference engine torque. \\r\\n\\r\\nWhen the MSB is set to 1, this parameter is not available.  When the MSB is set to 0, bits 1 to 3 indicate the desired torque with resolution of 0.125%/bit . Range is from 0 to 0.875% of reference torque.  \\r\\n\\r\\nThe parameter is used in combination with SPN 518  Engine Requested Torque/Torque Limit. The resulting torque/torque limit will be calculated by adding these two parameters. \\r\\n\\r\\nValidity of Engine Requested Torque High Res has no effect on SPN 518. \\r\\n\\r\\nAdditional torque representations\\r\\n\\r\\n0000 = +0.000%\\r\\n0001 = +0.125%\\r\\n.\\r\\n.\\r\\n.\\r\\n0111 = +0.875%\\r\\n1000 - 1111 = not available\\r\\n\\r\\nFor example, if SPN 518 = 150 (or 25%) and this parameter is 0100, the torque would be 25.5%.\\r\\nIf SPN 518 = 175 (or 50%) and this parameter is 0001, the torque would be 50.125%\\r\\nIf SPN 518 = 175 (or 50%) and this parameter is 1111, the torque would remain 50% (no high resolution available)","bit_length":4,"scaling":0.125,"offset":0,"unit":"%","SLOT_ID":268},"4193":{"PGN":64870,"PGN_Name":"Engine Temperature 4","PGN_Description":"ET4","first_bit":8,"SPN":4193,"SPN_Name":"Engine Coolant Pump Outlet Temperature","SPN_Description":"The actual value of engine coolant temperature at the coolant pump outlet.  See also SPNs 110, 4076 and 6209 for additional coolant temperature parameters.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4194":{"PGN":64870,"PGN_Name":"Engine Temperature 4","PGN_Description":"ET4","first_bit":16,"SPN":4194,"SPN_Name":"Engine Coolant Thermostat Opening","SPN_Description":"The current position of the Thermostat used to regulate the temperature of the engine coolant.  0% represents the thermostat allows flow to completely bypass the radiator and 100% represents the flow is fully through the radiator.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4195":{"PGN":64850,"PGN_Name":"Engine Coolant Control Valve Command","PGN_Description":"ECCVC","first_bit":0,"SPN":4195,"SPN_Name":"Engine Coolant Thermostat Mode","SPN_Description":"Specifies if the engine coolant thermostat valve will operate in temperature control mode or position control mode.\\r\\n\\r\\n00 = temperature control mode\\r\\n01 = position control mode (used for service only)\\r\\n10 = reserved\\r\\n11 = don\'t care/reserved","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4196":{"PGN":64850,"PGN_Name":"Engine Coolant Control Valve Command","PGN_Description":"ECCVC","first_bit":8,"SPN":4196,"SPN_Name":"Desired Engine Coolant Pump Outlet Temperature","SPN_Description":"Desired engine coolant temperature of the engine to an electronic thermostat.  If the electronic thermostat valve is operating in position control mode (see SPN 4195)  then transmit 0xFF.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4197":{"PGN":64850,"PGN_Name":"Engine Coolant Control Valve Command","PGN_Description":"ECCVC","first_bit":16,"SPN":4197,"SPN_Name":"Desired Engine Coolant Thermostat Opening","SPN_Description":"Indicates the desired position of the engine coolant control valve.   0% represents the thermostat allows flow to completely bypass the radiator and 100% represents the flow is fully through the radiator.  If the electronic thermostat is operating in temperature control mode (SPN 4195) then transmit 0xFF.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4198":{"PGN":64849,"PGN_Name":"Aftercooler Coolant Control Valve Command","PGN_Description":"ACCVC","first_bit":0,"SPN":4198,"SPN_Name":"Aftercooler Coolant Thermostat Mode","SPN_Description":"Specifies if the aftercooler coolant thermostat valve will operate in temperature control mode or position control mode.\\r\\n\\r\\n00 = temperature control mode\\r\\n01 = position control mode (used for service only)\\r\\n10 = reserved\\r\\n11 = don\'t care/reserved","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4199":{"PGN":64849,"PGN_Name":"Aftercooler Coolant Control Valve Command","PGN_Description":"ACCVC","first_bit":8,"SPN":4199,"SPN_Name":"Desired Aftercooler Coolant Intake Temperature","SPN_Description":"Indicates the desired temperature of the fluid in the low temperature aftercooler circuit to an electronic thermostat.  If the aftercooler coolant thermostat valve is operating in position control mode (see SPN 4198) then this value should be 0xFF.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4200":{"PGN":64849,"PGN_Name":"Aftercooler Coolant Control Valve Command","PGN_Description":"ACCVC","first_bit":16,"SPN":4200,"SPN_Name":"Desired Aftercooler Coolant Thermostat Opening","SPN_Description":"Used to transmit the desired position of the low temperature aftercooler temperature control valve.  0% represents the thermostat allows flow to completely bypass the aftercooler and 100% represents the flow is fully through the aftercooler.   If the aftercooler coolant thermostat is operating in temperature control mode (see SPN 4198)  then this value should be 0xFF.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4201":{"PGN":61473,"PGN_Name":"Engine Speed Sensor Information 1","PGN_Description":"ESSI1","first_bit":0,"SPN":4201,"SPN_Name":"Engine Speed 1","SPN_Description":"The engine speed as measured by speed sensor 1.\\r\\n\\r\\nNote:  This is for the engine speed from the 1st engine speed sensor.  This may be different than SPN 190 when used in multiple engine speed sensor configurations.   In an application with only one speed sensor, SPN 190 will represent both the speed and the sensor for diagnostic purposes and SPN 4201 will not be used. However, in an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"4202":{"PGN":61473,"PGN_Name":"Engine Speed Sensor Information 1","PGN_Description":"ESSI1","first_bit":32,"SPN":4202,"SPN_Name":"Engine Speed 3","SPN_Description":"The engine speed as measured by speed sensor 3.\\r\\n\\r\\nNote:  This is for the engine speed from the 3rd engine speed sensor.  This may be different than SPN 190 when used in multiple engine speed sensor configurations.   In an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"4203":{"PGN":61473,"PGN_Name":"Engine Speed Sensor Information 1","PGN_Description":"ESSI1","first_bit":54,"SPN":4203,"SPN_Name":"Engine Speed Sensor 1 Timing Pattern Status","SPN_Description":"This is the timing pattern status of the engine speed sensor signal for sensor 1.   The sensor may be sending a speed signal but the pattern may not be valid.  Since the speed is considered valid, the error indicator will not be used in the engine speed parameter (SPN 4201).  The sensor does give a speed but the pattern is not matched.  In this condition, the position of the crank has not been determined so injection is not enabled.  The engine speed signal provides both engine speed and crankshaft location information to the engine control.  A \\"Not OK\\" status may be caused by extra or missing teeth, gear runout, etc.\\r\\n\\r\\n00 = Not OK\\r\\n01 = OK\\r\\n10 = Error\\r\\n11 = Not available\\r\\n\\r\\nNote:  This is intended to be used on a service tool for troubleshooting a no start condition.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4204":{"PGN":61473,"PGN_Name":"Engine Speed Sensor Information 1","PGN_Description":"ESSI1","first_bit":52,"SPN":4204,"SPN_Name":"Engine Speed Sensor 2 Timing Pattern Status","SPN_Description":"This is the timing pattern status of the engine speed sensor signal for sensor 2.  The sensor may be sending a speed signal but the pattern may not be valid.  Since the speed is considered valid, the error indicator will not be used in the engine speed parameter (SPN 723).\\r\\n\\r\\n00 = Not OK\\r\\n01 = OK\\r\\n10 = Error\\r\\n11 = Not available\\r\\n\\r\\nNote:  This is intended to be used on a service tool for troubleshooting a no start condition.  The sensor does give a speed but the pattern is not matched.  In this condition, the position of the crank has not been determined so injection is not enabled.  The engine speed signal provides both engine speed and crankshaft location information to the engine control.  A \\"Not OK\\" status may be caused by extra or missing teeth, gear runout, etc.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4205":{"PGN":61473,"PGN_Name":"Engine Speed Sensor Information 1","PGN_Description":"ESSI1","first_bit":50,"SPN":4205,"SPN_Name":"Engine Speed Sensor 3 Timing Pattern Status","SPN_Description":"This is the timing pattern status of the engine speed sensor signal for sensor 3.  The sensor may be sending a speed signal but the pattern may not be valid.  Since the speed is considered valid, the error indicator will not be used in the engine speed parameter (SPN 4202).\\r\\n00 = Not OK\\r\\n01 = OK\\r\\n10 = Error\\r\\n11 = Not available\\r\\n\\r\\nNote:  This is intended to be used on a service tool for troubleshooting a no start condition.  The sensor does give a speed but the pattern is not matched.  In this condition, the position of the crank has not been determined so injection is not enabled.  The engine speed signal provides both engine speed and crankshaft location information to the engine control.  A \\"Not OK\\" status may be caused by extra or missing teeth, gear runout, etc.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4206":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":56,"SPN":4206,"SPN_Name":"Message Counter","SPN_Description":"The message counter is used to detect situations where the transmitting ECU malfunction repeats the same frame all the time.  The receiver of the information may use the counter parameter to detect this situation.  The transmitting device will increase the message counter in every cycle. The message counter will count from 0 to 7 and then wrap. \\r\\n\\r\\nThe values 0x8 thru 0xE are SAE reserved and should be ignored by the receiver.\\r\\n\\r\\nValue 0xF (all bits set to 1) will indicate that the message counter is not available.  For compatibility purposes, TSC1 should also be honored if the message counter is not available from the transmitting device.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"4207":{"PGN":0,"PGN_Name":"Torque/Speed Control 1","PGN_Description":"TSC1","first_bit":60,"SPN":4207,"SPN_Name":"Message Checksum","SPN_Description":"The message checksum is used to verify the signal path from the transmitting device to the receiving device.\\r\\n \\r\\nThe message checksum is calculated using the first 7 data bytes, the message counter and the bytes of the message identifier. It is calculated as follows:\\r\\n\\r\\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\\r\\n\\r\\nMessage Checksum = (((Checksum >> 6) & 0x03) + (Checksum >>3) +  Checksum) & 0x07\\r\\n\\r\\nValue 0xF (all bits set to 1) will indicate that the checksum is not available.  For compatibility purposes, TSC1 should also be honored if the checksum is not available from the transmitting device.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"4211":{"PGN":65213,"PGN_Name":"Fan Drive #1","PGN_Description":"FD1","first_bit":32,"SPN":4211,"SPN_Name":"Hydraulic Fan Motor Pressure","SPN_Description":"The hydraulic pressure used to drive the fan system, sensed before the hydraulic fan motor.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"4212":{"PGN":65213,"PGN_Name":"Fan Drive #1","PGN_Description":"FD1","first_bit":48,"SPN":4212,"SPN_Name":"Fan Drive Bypass Command Status","SPN_Description":"Status of the Fan Drive Bypass Command as being commanded by the ECU.  The fan drive bypass diverts pump pressure away from the hydraulic motor to maintain the fan drive pressure.  0% is defined as no bypass (i.e. diverting no fan drive pressure) and 100% is defined as full bypass (i.e. diverting the maximum fan drive pressure) from the fan motor.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4218":{"PGN":64704,"PGN_Name":"Electronic Transmission Controller #11","PGN_Description":"ETC11","first_bit":0,"SPN":4218,"SPN_Name":"Transmission Shift Rail 1 Position","SPN_Description":"The current position of transmission shift rail identified as rail #1.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4219":{"PGN":64704,"PGN_Name":"Electronic Transmission Controller #11","PGN_Description":"ETC11","first_bit":8,"SPN":4219,"SPN_Name":"Transmission Shift Rail 2 Position","SPN_Description":"The current position of transmission shift rail identified as rail #2.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4220":{"PGN":64704,"PGN_Name":"Electronic Transmission Controller #11","PGN_Description":"ETC11","first_bit":16,"SPN":4220,"SPN_Name":"Transmission Shift Rail 3 Position","SPN_Description":"The current position of transmission shift rail identified as rail #3.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4233":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":28,"SPN":4233,"SPN_Name":"Retarder Road Speed Limit Switch","SPN_Description":"Retarder road speed limit switch states:\\r\\n\\r\\n00   Road speed limiting by retarder is disabled\\r\\n01   Road speed limiting by retarder is enabled.  The road speed that the retarder will limit will be determined when the switch transitions from 00 to 01\\r\\n10   Error Indicator\\r\\n11   Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4234":{"PGN":61440,"PGN_Name":"Electronic Retarder Controller 1","PGN_Description":"ERC1","first_bit":30,"SPN":4234,"SPN_Name":"Retarder Road Speed Exceeded Status","SPN_Description":"Retarder Road Speed Exceeded Status:\\r\\n\\r\\n00   Road speed is below threshold \\r\\n01   Road speed is above threshold and retarder is allowed to be activated\\r\\n10   Reserved\\r\\n11   Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4236":{"PGN":64841,"PGN_Name":"Engine Exhaust Bank 1 O2 Fuel Trim","PGN_Description":"O2FT1","first_bit":16,"SPN":4236,"SPN_Name":"Short-term Fuel Trim - Bank 1","SPN_Description":"This parameter is the short-term percent change in fueling based on the O2 sensor feedback for cylinder bank 1, based on the operating point in the nominal fuel map.\\r\\n\\r\\nNote:  This is similar to SPN 1695, but with higher resolution.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":251},"4237":{"PGN":64841,"PGN_Name":"Engine Exhaust Bank 1 O2 Fuel Trim","PGN_Description":"O2FT1","first_bit":0,"SPN":4237,"SPN_Name":"Long-term Fuel Trim - Bank 1","SPN_Description":"This parameter is the long-term percent change in fueling based on the O2 sensor feedback for cylinder bank 1, based on the operating point in the nominal fuel map.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":251},"4238":{"PGN":64840,"PGN_Name":"Engine Exhaust Bank 2 O2 Fuel Trim","PGN_Description":"O2FT2","first_bit":16,"SPN":4238,"SPN_Name":"Short-term Fuel Trim - Bank 2","SPN_Description":"This parameter is the short-term percent change in fueling based on the O2 sensor feedback for cylinder bank 2, based on the operating point in the nominal fuel map.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":251},"4239":{"PGN":64840,"PGN_Name":"Engine Exhaust Bank 2 O2 Fuel Trim","PGN_Description":"O2FT2","first_bit":0,"SPN":4239,"SPN_Name":"Long-term Fuel Trim - Bank 2","SPN_Description":"This parameter is the long-term percent change in fueling based on the O2 sensor feedback for cylinder bank 2, based on the operating point in the nominal fuel map.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":251},"4240":{"PGN":64841,"PGN_Name":"Engine Exhaust Bank 1 O2 Fuel Trim","PGN_Description":"O2FT1","first_bit":32,"SPN":4240,"SPN_Name":"Engine Exhaust Bank 1 O2 Sensor Closed Loop Operation","SPN_Description":"This parameter indicates the status of the bank 1 O2 sensor feedback closed loop operation\\r\\n\\r\\n0000 = Open loop - has not yet satisfied conditions to go closed loop\\r\\n0001 = Closed loop - using oxygen sensor(s) as feedback for fuel control\\r\\n0010 = Open loop due to driving conditions (e.g., power enrichment, deceleration enleanment)\\r\\n0011 = Open loop - due to detected system fault \\r\\n0100 = Closed loop, but fault with at least one oxygen sensor - may be using single oxygen sensor for fuel control\\r\\n0101-1110 = reserved\\r\\n1111 = not supported\\r\\n\\r\\nSee also SPN 1696 as an prior implementation.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4241":{"PGN":64840,"PGN_Name":"Engine Exhaust Bank 2 O2 Fuel Trim","PGN_Description":"O2FT2","first_bit":32,"SPN":4241,"SPN_Name":"Engine Exhaust Bank 2 O2 Sensor Closed Loop Operation","SPN_Description":"This parameter indicates the status of the bank 2 O2 sensor feedback closed loop operation\\r\\n\\r\\n0000 = Open loop - has not yet satisfied conditions to go closed loop\\r\\n0001 = Closed loop - using oxygen sensor(s) as feedback for fuel control\\r\\n0010 = Open loop due to driving conditions (e.g., power enrichment, deceleration enleanment)\\r\\n0011 = Open loop - due to detected system fault \\r\\n0100 = Closed loop, but fault with at least one oxygen sensor - may be using single oxygen sensor for fuel control\\r\\n0101-1110 = reserved\\r\\n1111 = not supported","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4242":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":6,"SPN":4242,"SPN_Name":"Transmission Reverse Gear Shift Inhibit Request","SPN_Description":"Allows devices external to the normal transmission shift selector system to request the transmission to inhibit shifts into any Reverse gear and force the transmission into Neutral if it is currently in Reverse or attempting to shift to Reverse.  These transmission responses occur regardless of shift selector (Forward, Neutral or Reverse) position at the time the request is received.\\r\\n\\r\\nThis request would typically come from a component wishing to override the vehicle operator\u2019s ability to shift or keep the transmission in Reverse.  For example, the control system of a rear-loading refuse packer may wish to prevent shifts to reverse when it detects the presence of someone behind the vehicle.\\r\\n\\r\\nReverse gear shift inhibits include all \u2018Neutral-to-Reverse\u2019 shifts and \u2018Forward-to-Reverse\u2019 shifts; the ability of the transmission to complete \u2018Neutral-to-Forward\u2019 or \u2018Forward-to-Forward\u2019 gear shifts is not impacted.\\r\\n\\r\\nIf the transmission is in Reverse or attempting to shift to Reverse and receives an active Reverse gear shift inhibit request (0b01), the transmission will shift to Neutral.  When the request subsequently goes inactive (0b00), the transmission will remain in Neutral until it receives a selector input from the vehicle operator requesting it to shift into a Non-Neutral gear.  The transmission should not automatically return to the previous gear when this signal goes inactive.\\r\\n\\r\\nTransmission response to this request can be monitored via SPN 4261 \u2013 Transmission Reverse Gear Shift Inhibit Status, SPN 523 Transmission Current Gear, and SPN 524 Transmission Selected Gear.\\r\\n\\r\\n00 = Allow shifts into Reverse gear\\r\\n01 = Inhibit shifts into Reverse gear, and shift transmission to Neutral if already in Reverse or attempting to shift to Reverse\\r\\n10 = Reserved \\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4245":{"PGN":65109,"PGN_Name":"Gaseous Fuel Properties","PGN_Description":"GFD","first_bit":32,"SPN":4245,"SPN_Name":"Fuel energy content","SPN_Description":"Energy content (lower heating value) of the gaseous fuel.\\r\\n\\r\\nNote:  For gaseous fuels, the fuel\'s energy content (lower heating value) is commonly defined in terms of energy / volume. The gas volume is defined for regular pressure and temperature conditions and is stated in terms of normal cubic meters.  For the purpose of measuring energy content in gaseous fuels, the normal conditions are defined to be 101.31 kPa and 0 degC as defined in ISO 10780:1994 \u2013 Stationary source emissions, Measurement of velocity and volume flowrate of gas streams in ducts","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MJ/Nm\xb3","SLOT_ID":323},"4246":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":56,"SPN":4246,"SPN_Name":"Transmission Mode 5","SPN_Description":"Indicates whether transmission mode 5 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4250.\\r\\n\\r\\n00  Disable\\r\\n01  Enable\\r\\n10  Reserved\\r\\n11  Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4247":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":58,"SPN":4247,"SPN_Name":"Transmission Mode 6","SPN_Description":"Indicates whether transmission mode 6 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4251.\\r\\n\\r\\n00  Disable\\r\\n01  Enable\\r\\n10  Reserved\\r\\n11  Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4248":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":60,"SPN":4248,"SPN_Name":"Transmission Mode 7","SPN_Description":"Indicates whether transmission mode 7 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4252.\\r\\n\\r\\n00  Disable\\r\\n01  Enable\\r\\n10  Reserved\\r\\n11  Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4249":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":62,"SPN":4249,"SPN_Name":"Transmission Mode 8","SPN_Description":"Indicates whether transmission mode 8 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 4253.\\r\\n\\r\\n00  Disable\\r\\n01  Enable\\r\\n10  Reserved\\r\\n11  Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4250":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":32,"SPN":4250,"SPN_Name":"Transmission Mode 5 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 5 (SPN 4246) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n\\r\\n00 Transmission Mode 5 not active\\r\\n01 Transmission Mode 5 active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4251":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":34,"SPN":4251,"SPN_Name":"Transmission Mode 6 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 6 (SPN 4247) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n\\r\\n00 Transmission Mode 6 not active\\r\\n01 Transmission Mode 6 active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4252":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":36,"SPN":4252,"SPN_Name":"Transmission Mode 7 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 7 (SPN 4248) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n\\r\\n00 Transmission Mode 7 not active\\r\\n01 Transmission Mode 7 active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4253":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":38,"SPN":4253,"SPN_Name":"Transmission Mode 8 Indicator","SPN_Description":"This state signal is the transmission\u2019s indication that it is operating under transmission mode 8 (SPN 4249) as commanded via the TC1 message (PGN 256).  The definition of the transmission mode is left to the discretion of the transmission manufacturer.\\r\\n\\r\\n00 Transmission Mode 8 not active\\r\\n01 Transmission Mode 8 active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4255":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":50,"SPN":4255,"SPN_Name":"Transmission Requested Launch Gear","SPN_Description":"Initial gear for the transmission to start out in when the vehicle is launched from a standing stop, as specified by the vehicle operator or vehicle system.  Automatic transmissions typically default to starting out in 1st gear.  However, in applications such as those with very low gearing, it is desirable to launch the vehicle in a range higher than 1st.   For example, when the vehicle has little or no payload, the operator may wish to launch from 2nd or 3rd gear to avoid stacked, unnecessary shifts in the lower ranges.\\r\\n\\r\\nThe intent of SPN 4255 is to request the initial starting range to be used when the vehicle gets underway from a stop; it does not request direction changes (forward / reverse). SPN 525 sets the direction requested by the operator. For example, if SPN 525 is requesting a Reverse range, any SPN 4255 value indicating a desired forward launch gear would be ignored by the transmission controller. The SPN 4255 value is only utilized by the transmission controller when its direction matches that of the current SPN 525 value.\\r\\n\\r\\n0000 = No specific launch gear requested; use default launch gear\\r\\n0001 = Launch the vehicle in 1st gear\\r\\n0010 = Launch the vehicle in 2nd gear\\r\\n0011 = Launch the vehicle in 3rd gear\\r\\n0100 = Launch the vehicle in 4th gear\\r\\n0101 = Launch the vehicle in 5th gear\\r\\n0110 = Launch the vehicle in 6th gear\\r\\n0111 = Launch the vehicle in 7th gear\\r\\n1000 = Launch the vehicle in 8th gear\\r\\n1001 = Launch the vehicle in Reverse 1\\r\\n1010 = Launch the vehicle in Reverse 2\\r\\n1011 = Launch the vehicle in Reverse 3\\r\\n1100 = Launch the vehicle in Reverse 4 \\r\\n1101 = Allow transmission to select the optimum launch gear\\r\\n1110 = Error\\r\\n1111 = Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4261":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":40,"SPN":4261,"SPN_Name":"Transmission Reverse Gear Shift Inhibit Status","SPN_Description":"Reflects the status of transmission reverse inhibit activity in response to requests via SPN 4242 - Transmission Reverse Gear Shift Inhibit Request.  Typically broadcast by the transmission controller.\\r\\n\\r\\n00 = Reverse gear shifts are currently allowed\\r\\n01 = Reverse gear shifts are currently inhibited\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4287":{"PGN":64961,"PGN_Name":"Engine Fluid Level/Pressure 3","PGN_Description":"EFL/P3","first_bit":24,"SPN":4287,"SPN_Name":"Engine Exhaust Valve Actuation System Oil Pressure","SPN_Description":"The absolute pressure of the oil in the hydraulic system that powers the engine exhaust valve actuation system","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"4288":{"PGN":64870,"PGN_Name":"Engine Temperature 4","PGN_Description":"ET4","first_bit":24,"SPN":4288,"SPN_Name":"Engine Exhaust Valve Actuation System Oil Temperature","SPN_Description":"The temperature of the oil in the hydraulic system that powers the engine exhaust valve actuation system","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4289":{"PGN":64838,"PGN_Name":"Aftertreatment 1 Three Way Catalyst","PGN_Description":"AT1TWC","first_bit":0,"SPN":4289,"SPN_Name":"Aftertreatment 1 Three Way Catalyst Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the Three Way Catalyst in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4290":{"PGN":64838,"PGN_Name":"Aftertreatment 1 Three Way Catalyst","PGN_Description":"AT1TWC","first_bit":16,"SPN":4290,"SPN_Name":"Aftertreatment 1 Three Way Catalyst Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the Three Way Catalyst in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4291":{"PGN":64838,"PGN_Name":"Aftertreatment 1 Three Way Catalyst","PGN_Description":"AT1TWC","first_bit":32,"SPN":4291,"SPN_Name":"Aftertreatment 1 Three Way Catalyst Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of a Three Way Catalyst in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4292":{"PGN":64838,"PGN_Name":"Aftertreatment 1 Three Way Catalyst","PGN_Description":"AT1TWC","first_bit":48,"SPN":4292,"SPN_Name":"Aftertreatment 1 Three Way Catalyst Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4293":{"PGN":64838,"PGN_Name":"Aftertreatment 1 Three Way Catalyst","PGN_Description":"AT1TWC","first_bit":53,"SPN":4293,"SPN_Name":"Aftertreatment 1 Three Way Catalyst Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst outlet temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4294":{"PGN":64838,"PGN_Name":"Aftertreatment 1 Three Way Catalyst","PGN_Description":"AT1TWC","first_bit":58,"SPN":4294,"SPN_Name":"Aftertreatment 1 Three Way Catalytic Converter Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Three Way Catalytic Converter differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4295":{"PGN":64837,"PGN_Name":"Aftertreatment 2 Three Way Catalyst","PGN_Description":"AT2TWC","first_bit":0,"SPN":4295,"SPN_Name":"Aftertreatment 2 Three Way Catalyst Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the Three Way Catalyst in exhaust bank 2.\\r\\n\\r\\n(For a single exhaust bank system, refer to parameters in PGN 64838.)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4296":{"PGN":64837,"PGN_Name":"Aftertreatment 2 Three Way Catalyst","PGN_Description":"AT2TWC","first_bit":16,"SPN":4296,"SPN_Name":"Aftertreatment 2 Three Way Catalyst Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the Three Way Catalyst in exhaust bank 2. \\r\\n \\r\\n(For a single exhaust bank system, refer to parameters in PGN 64838.)","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4297":{"PGN":64837,"PGN_Name":"Aftertreatment 2 Three Way Catalyst","PGN_Description":"AT2TWC","first_bit":32,"SPN":4297,"SPN_Name":"Aftertreatment 2 Three Way Catalyst Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of a Three Way Catalyst in exhaust bank 2.\\r\\n\\r\\n(For a single exhaust bank system, refer to parameters in PGN 64838.)","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4298":{"PGN":64837,"PGN_Name":"Aftertreatment 2 Three Way Catalyst","PGN_Description":"AT2TWC","first_bit":48,"SPN":4298,"SPN_Name":"Aftertreatment 2 Three Way Catalyst Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGN 64838.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4299":{"PGN":64837,"PGN_Name":"Aftertreatment 2 Three Way Catalyst","PGN_Description":"AT2TWC","first_bit":53,"SPN":4299,"SPN_Name":"Aftertreatment 2 Three Way Catalyst Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Three Way Catalyst outlet temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGN 64838.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4300":{"PGN":64837,"PGN_Name":"Aftertreatment 2 Three Way Catalyst","PGN_Description":"AT2TWC","first_bit":58,"SPN":4300,"SPN_Name":"Aftertreatment 2 Three Way Catalytic Converter Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Three Way Catalytic Converter differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGN AT1TWCC.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4301":{"PGN":64929,"PGN_Name":"Aftertreatment 1 Fuel Control 1","PGN_Description":"AT1FC1","first_bit":56,"SPN":4301,"SPN_Name":"Aftertreatment 1 Fuel Injector 1 Heater Control","SPN_Description":"Heating level that the controller is commanding the aftertreatment 1 fuel injector 1 heater control to maintain. 0% = off, 100% = maximum.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4302":{"PGN":64928,"PGN_Name":"Aftertreatment 2 Fuel Control 1","PGN_Description":"AT2FC1","first_bit":56,"SPN":4302,"SPN_Name":"Aftertreatment 2 Fuel Injector 1 Heater Control","SPN_Description":"Heating level that the controller is commanding the aftertreatment 2 fuel injector 1 heater control to maintain. 0% = off, 100% = maximum.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4303":{"PGN":64836,"PGN_Name":"Aftertreatment 2 Fuel Control 2","PGN_Description":"AT2FC2","first_bit":0,"SPN":4303,"SPN_Name":"Aftertreatment 2 Fuel Pressure 2","SPN_Description":"Second fuel pressure measurement for the aftertreatment 2 system.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4331":{"PGN":61475,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 1","PGN_Description":"A1SCRDSI1","first_bit":0,"SPN":4331,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Actual Dosing Quantity","SPN_Description":"Actual reducing agent quantity of SCR-system","bit_length":16,"scaling":0.3,"offset":0,"unit":"g/h","SLOT_ID":272},"4332":{"PGN":61475,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 1","PGN_Description":"A1SCRDSI1","first_bit":16,"SPN":4332,"SPN_Name":"Aftertreatment 1 SCR System 1 State","SPN_Description":"Actual state of SCR system\\r\\n\\r\\n0000    Dormant (sleep mode)\\r\\n0001    Preparing dosing readiness (wake up; prepare to operate; wait for start)\\r\\n0010    Normal dosing operation\\r\\n0011    System error pending\\r\\n0100    Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\\r\\n0101    Protect mode against heat  (pressure buildup)\\r\\n0110    Protect mode against cold  (defreeze)\\r\\n0111    Shutoff  (wait for after-run)\\r\\n1000    Diagnosis (after-run)\\r\\n1001    Service test mode, dosing allowed \\r\\n1010    Service test mode, dosing not allowed\\r\\n1011    Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed.)\\r\\n1100    Priming (Pressure Buildup)\\r\\n1101    Reserved for future assignment by SAE\\r\\n1110    Error\\r\\n1111    Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4333":{"PGN":61475,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 1","PGN_Description":"A1SCRDSI1","first_bit":24,"SPN":4333,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Actual Quantity of Integrator","SPN_Description":"The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 1 (exhaust bank 1).","bit_length":16,"scaling":0.1,"offset":0,"unit":"g","SLOT_ID":227},"4334":{"PGN":61475,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 1","PGN_Description":"A1SCRDSI1","first_bit":40,"SPN":4334,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Absolute Pressure","SPN_Description":"The absolute pressure (measured closest to dosing valve) of the first or only DEF dosing unit for aftertreatment system 1 (exhaust bank 1).","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"4335":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":0,"SPN":4335,"SPN_Name":"Aftertreatment 1 SCR Dosing Air Assist Absolute Pressure","SPN_Description":"The SCR dosing system air assist absolute pressure for aftertreatment system 1 (exhaust bank 1).  The air assist system is used to improve the dosed reagent atomization.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"4336":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":8,"SPN":4336,"SPN_Name":"Aftertreatment 1 SCR Dosing Air Assist Valve","SPN_Description":"The position of the valve used to regulate the air supply of an air assist SCR dosing system for an engine. 0% represents no supply and 100% is full supply.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4337":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":16,"SPN":4337,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Temperature","SPN_Description":"The temperature (measured closest to dosing valve) of the first or only DEF dosing unit for aftertreatment system 1 (exhaust bank 1).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4338":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":24,"SPN":4338,"SPN_Name":"Aftertreatment 1 SCR Doser Valve Exhaust Temperature Reduction Request","SPN_Description":"Protection request for the doser valve of the SCR system to prevent overheating\\r\\n\\r\\n  000:    no request \\r\\n  001:    reduction request stage 1\\r\\n  010:    reduction request stage 2\\r\\n  011:    reserved for future assignment by SAE\\r\\n  100:    reserved for future assignment by SAE\\r\\n  101:    reserved for future assignment by SAE\\r\\n  110:    error\\r\\n  111:    not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4339":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":27,"SPN":4339,"SPN_Name":"Aftertreatment 1 SCR Feedback Control Status","SPN_Description":"The SCR feedback control status (open/closed loop) for aftertreatment system 1 (exhaust bank 1).\\r\\n \\r\\n000 open loop control active \\r\\n001 closed loop control active \\r\\n010 reserved for future assignment by SAE \\r\\n011 reserved for future assignment by SAE \\r\\n100 reserved for future assignment by SAE \\r\\n101 reserved for future assignment by SAE \\r\\n110 error \\r\\n111 not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4340":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":32,"SPN":4340,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1 State","SPN_Description":"The diesel exhaust fluid line heater 1 state for aftertreatment system 1 (exhaust bank 1). \\r\\n\\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4341":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":34,"SPN":4341,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 1, by the manufacturer\u2019s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4342":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":40,"SPN":4342,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2 State","SPN_Description":"The diesel exhaust fluid line heater 2 state for aftertreatment system 1 (exhaust bank 1). \\r\\n \\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4343":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":42,"SPN":4343,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 2, by the manufacturer\u2019s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4344":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":48,"SPN":4344,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3 State","SPN_Description":"The diesel exhaust fluid line heater 3 state for aftertreatment system 1 (exhaust bank 1). \\r\\n\\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4345":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":50,"SPN":4345,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 3, by the manufacturer\u2019s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4346":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":56,"SPN":4346,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4 State","SPN_Description":"The diesel exhaust fluid line heater 4 state for aftertreatment system 1 (exhaust bank 1). \\r\\n\\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4347":{"PGN":64833,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 2","PGN_Description":"A1SCRDSI2","first_bit":58,"SPN":4347,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 4, by the manufacturer\u2019s control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4348":{"PGN":61476,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 1","PGN_Description":"A1SCRDSR1","first_bit":0,"SPN":4348,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Dosing Requested Quantity","SPN_Description":"Actual requested dosing quantity of diesel exhaust fluid.","bit_length":16,"scaling":0.3,"offset":0,"unit":"g/h","SLOT_ID":272},"4349":{"PGN":61476,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 1","PGN_Description":"A1SCRDSR1","first_bit":16,"SPN":4349,"SPN_Name":"Aftertreatment 1 SCR System Requested State","SPN_Description":"Requested state of SCR system for aftertreatment system 1 (exhaust bank 1).\\r\\n \\r\\n0000 Dormant (sleep mode) \\r\\n0001 Preparing dosing readiness (wake up; prepare to operate; wait for start) \\r\\n0010 Normal dosing operation \\r\\n0011 System error pending \\r\\n0100 Reserved for future assignment by SAE \\r\\n0101 Protect mode against heat (pressure buildup) \\r\\n0110 Protect mode against cold (defreeze) \\r\\n0111 Shutoff (wait for after-run) \\r\\n1000 Diagnosis (after-run) \\r\\n1001 Service test mode, dosing allowed \\r\\n1010 Service test mode, dosing not allowed\\r\\n1011-1101 Reserved for future assignment by SAE\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4350":{"PGN":61476,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 1","PGN_Description":"A1SCRDSR1","first_bit":24,"SPN":4350,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Requested Quantity of Integrator","SPN_Description":"Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit.  See SPN 7783 for alternate resolution.","bit_length":16,"scaling":0.1,"offset":0,"unit":"g","SLOT_ID":227},"4352":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":2,"SPN":4352,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser Fault Suppression Request","SPN_Description":"Used if external devices can warn of conditions that require suppression of potential faults in the doser due to environmental conditions.\\r\\n\\r\\n00    Error suppression off\\r\\n01    Error suppression on\\r\\n10    Reserved\\r\\n11    Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4353":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":4,"SPN":4353,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser Heating Mode Request","SPN_Description":"Used if multiple heater modes are available in the Doser.\\r\\n\\r\\n000   Heater off\\r\\n001   Heater economy mode\\r\\n010   Heater automatic mode\\r\\n011   Heater on\\r\\n100 - 110    Reserved\\r\\n111   Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4354":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":8,"SPN":4354,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 1","SPN_Description":"The diesel exhaust fluid line heater 1 request for aftertreatment system 1 (exhaust bank 1).\\r\\n \\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4355":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":10,"SPN":4355,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 2","SPN_Description":"The diesel exhaust fluid line heater 2 request for aftertreatment system 1 (exhaust bank 1).\\r\\n \\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4356":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":12,"SPN":4356,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 3","SPN_Description":"The diesel exhaust fluid line heater 3 request for aftertreatment system 1 (exhaust bank 1).\\r\\n \\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4357":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":14,"SPN":4357,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 4","SPN_Description":"The diesel exhaust fluid line heater 4 request for aftertreatment system 1 (exhaust bank 1).\\r\\n \\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4358":{"PGN":64831,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Pressures","PGN_Description":"A1SCREGP","first_bit":0,"SPN":4358,"SPN_Name":"Aftertreatment 1 SCR Differential Pressure","SPN_Description":"Differential pressure measured between the intake and outlet of an SCR component in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4359":{"PGN":64831,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Pressures","PGN_Description":"A1SCREGP","first_bit":16,"SPN":4359,"SPN_Name":"Aftertreatment 1 SCR Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the SCR differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"4360":{"PGN":64830,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Temperature 1","PGN_Description":"A1SCREGT1","first_bit":0,"SPN":4360,"SPN_Name":"Aftertreatment 1 SCR Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the SCR in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4361":{"PGN":64830,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Temperature 1","PGN_Description":"A1SCREGT1","first_bit":16,"SPN":4361,"SPN_Name":"Aftertreatment 1 SCR Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the SCR intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"4362":{"PGN":64830,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Temperature 1","PGN_Description":"A1SCREGT1","first_bit":40,"SPN":4362,"SPN_Name":"Aftertreatment 1 SCR Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the SCR outlet temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"4363":{"PGN":64830,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Temperature 1","PGN_Description":"A1SCREGT1","first_bit":24,"SPN":4363,"SPN_Name":"Aftertreatment 1 SCR Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the SCR outlet in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4364":{"PGN":64878,"PGN_Name":"Aftertreatment 1 SCR Service Information 1","PGN_Description":"A1SCRSI1","first_bit":32,"SPN":4364,"SPN_Name":"Aftertreatment 1 SCR Conversion Efficiency","SPN_Description":"The SCR conversion efficiency percentage.  Calculated as 100 times the catalyst intake NOx minus the catalyst outlet NOx divided by the catalyst intake NOx.  The catalyst conversion efficiency number in itself does not imply emissions compliance or system function or system malfunction.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4365":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":40,"SPN":4365,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid tank temperature for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer\u2019s control software. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4366":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":56,"SPN":4366,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid tank for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer\'s control software.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4367":{"PGN":64829,"PGN_Name":"Aftertreatment 1 SCR Reagant Tank 2 Information","PGN_Description":"A1SCRRT2I","first_bit":0,"SPN":4367,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Tank Volume","SPN_Description":"Ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1).  0% is empty and 100% is full.  See SPN 4369 for an alternate measurement.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4368":{"PGN":64829,"PGN_Name":"Aftertreatment 1 SCR Reagant Tank 2 Information","PGN_Description":"A1SCRRT2I","first_bit":8,"SPN":4368,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Temperature","SPN_Description":"The diesel exhaust fluid quick thaw tank temperature for aftertreatment system 1 (exhaust bank 1).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4369":{"PGN":64829,"PGN_Name":"Aftertreatment 1 SCR Reagant Tank 2 Information","PGN_Description":"A1SCRRT2I","first_bit":16,"SPN":4369,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Tank Level","SPN_Description":"The diesel exhaust fluid level height in mm in the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1). See SPN 4367 for alternate measurement. \\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"4370":{"PGN":64829,"PGN_Name":"Aftertreatment 1 SCR Reagant Tank 2 Information","PGN_Description":"A1SCRRT2I","first_bit":32,"SPN":4370,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Level/Volume Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the fluid level height of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer\'s control software.  This FMI is applicable to either the diesel exhaust fluid quick thaw tank level or diesel exhaust fluid quick thaw tank volume parameters.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4371":{"PGN":64829,"PGN_Name":"Aftertreatment 1 SCR Reagant Tank 2 Information","PGN_Description":"A1SCRRT2I","first_bit":40,"SPN":4371,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid quick thaw tank temperature for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer\u2019s control software.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4372":{"PGN":64829,"PGN_Name":"Aftertreatment 1 SCR Reagant Tank 2 Information","PGN_Description":"A1SCRRT2I","first_bit":48,"SPN":4372,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Heater","SPN_Description":"The diesel exhaust fluid quick thaw tank heater percentage for aftertreatment system 1 (exhaust bank 1). 0% is off. See SPN 5414 for the command for this tank heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4373":{"PGN":64829,"PGN_Name":"Aftertreatment 1 SCR Reagant Tank 2 Information","PGN_Description":"A1SCRRT2I","first_bit":56,"SPN":4373,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1), as detected by the manufacturer\'s control software.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4374":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":0,"SPN":4374,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Motor Speed","SPN_Description":"Rotational speed of the motor driving the first or only pump for the diesel exhaust fluid used in aftertreatment system 1 (exhaust bank 1).","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"4375":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":16,"SPN":4375,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump Drive Percentage","SPN_Description":"The percent (command) sent to the motor to control the speed of the diesel exhaust fluid pump.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4376":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":24,"SPN":4376,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1 Diverter Valve","SPN_Description":"Command to the valve which determines whether the diesel exhaust fluid on dosing unit 1 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4377":{"PGN":61477,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information","PGN_Description":"A1SCRAI","first_bit":0,"SPN":4377,"SPN_Name":"Aftertreatment 1 Outlet NH3","SPN_Description":"The amount of NH3 in the exhaust exiting the aftertreatment system measured by a NH3 sensor at the aftertreatment outlet, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 1.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"4378":{"PGN":61477,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information","PGN_Description":"A1SCRAI","first_bit":16,"SPN":4378,"SPN_Name":"Aftertreatment 1 Outlet NH3 Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NH3 sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4379":{"PGN":61477,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information","PGN_Description":"A1SCRAI","first_bit":24,"SPN":4379,"SPN_Name":"Aftertreatment 1 Outlet NH3 Reading Stable","SPN_Description":"Indicates that the NH3 reading of the aftertreatment outlet NH3 sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 1.\\r\\n\\r\\n00 - Reading is not stable\\r\\n01 - Reading is stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4380":{"PGN":61477,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information","PGN_Description":"A1SCRAI","first_bit":26,"SPN":4380,"SPN_Name":"Aftertreatment 1 Outlet NH3 Gas Sensor Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment outlet NH3 gas sensor is within the manufacturer\u2019s specification in exhaust bank 1.\\r\\n\\r\\n00 - Power is not in range\\r\\n01 - Power is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4381":{"PGN":61477,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information","PGN_Description":"A1SCRAI","first_bit":28,"SPN":4381,"SPN_Name":"Aftertreatment 1 Outlet NH3 Gas Sensor at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment outlet NH3 gas sensor is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 1.\\r\\n\\r\\n00 - Heater element is not in range\\r\\n01 - Heater element is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4382":{"PGN":61477,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information","PGN_Description":"A1SCRAI","first_bit":32,"SPN":4382,"SPN_Name":"Aftertreatment 1 Outlet NH3 Gas Sensor Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the outlet NH3 exhaust gas sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4383":{"PGN":61477,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information","PGN_Description":"A1SCRAI","first_bit":40,"SPN":4383,"SPN_Name":"Aftertreatment 1 Outlet NH3 Gas Sensor Heater Control","SPN_Description":"Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 gas sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1. \\r\\n00 - Automatic \\r\\n01 - Preheat 2 \\r\\n10 - Preheat 1 \\r\\n11 - Heater off or not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4384":{"PGN":61478,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 1","PGN_Description":"A2SCRDSI1","first_bit":0,"SPN":4384,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Actual Dosing Quantity","SPN_Description":"Actual reducing agent quantity of SCR system.","bit_length":16,"scaling":0.3,"offset":0,"unit":"g/h","SLOT_ID":272},"4385":{"PGN":61478,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 1","PGN_Description":"A2SCRDSI1","first_bit":16,"SPN":4385,"SPN_Name":"Aftertreatment 2 SCR System 1 State","SPN_Description":"Actual state of SCR system 1.\\r\\n\\r\\n0000    Dormant (sleep mode)\\r\\n0001    Preparing dosing readiness (wake up; prepare to operate; wait for start)\\r\\n0010    Normal dosing operation\\r\\n0011    System error pending\\r\\n0100    Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\\r\\n0101    Protect mode against heat (pressure buildup) \\r\\n0110    Protect mode against cold (defreeze) \\r\\n0111    Shutoff (wait for after-run) \\r\\n1000    Diagnosis (after-run)\\r\\n1001    Service test mode, dosing allowed \\r\\n1010    Service test mode, dosing not allowed\\r\\n1011    Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed)\\r\\n1100    Priming (Pressure Buildup)\\r\\n1101    Reserved for future assignment by SAE\\r\\n1110    Error\\r\\n1111    Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4386":{"PGN":61478,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 1","PGN_Description":"A2SCRDSI1","first_bit":24,"SPN":4386,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Actual Quantity of Integrator","SPN_Description":"The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 2 (exhaust bank 2).","bit_length":16,"scaling":0.1,"offset":0,"unit":"g","SLOT_ID":227},"4387":{"PGN":61478,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 1","PGN_Description":"A2SCRDSI1","first_bit":40,"SPN":4387,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Doser 1 Absolute Pressure","SPN_Description":"The absolute pressure (measured closest to dosing valve) of the first or only DEF doser for aftertreatment system 2 (exhaust bank 2).","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"4388":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":0,"SPN":4388,"SPN_Name":"Aftertreatment 2 SCR Dosing Air Assist Absolute Pressure","SPN_Description":"The SCR dosing system air assist absolute pressure for aftertreatment system 2 (exhaust bank 2).  The air assist system is used to improve the dosed reagent atomization.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"4389":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":8,"SPN":4389,"SPN_Name":"Aftertreatment 2 SCR Dosing Air Assist Valve","SPN_Description":"The position of the valve used to regulate the air supply of an air assist SCR dosing system for an engine. 0% represents no supply and 100% is full supply.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4390":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":16,"SPN":4390,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Doser 1 Temperature","SPN_Description":"The temperature (measured closest to dosing valve) of the first or only DEF doser for aftertreatment system 2 (exhaust bank 2).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4391":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":24,"SPN":4391,"SPN_Name":"Aftertreatment 2 SCR Doser Valve Exhaust Temperature Reduction Request","SPN_Description":"Protection request for the doser valve of the SCR system to prevent overheating\\r\\n\\r\\n  000:    no request \\r\\n  001:    reduction request stage 1\\r\\n  010:    reduction request stage 2\\r\\n  011:    reserved for future assignment by SAE\\r\\n  100:    reserved for future assignment by SAE\\r\\n  101:    reserved for future assignment by SAE\\r\\n  110:    error\\r\\n  111:    not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4392":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":27,"SPN":4392,"SPN_Name":"Aftertreatment 2 SCR Feedback Control Status","SPN_Description":"The SCR feedback control status (open/closed loop) for aftertreatment system 2 (exhaust bank 2).\\r\\n \\r\\n000 open loop control active \\r\\n001 closed loop control active \\r\\n010 reserved for future assignment by SAE \\r\\n011 reserved for future assignment by SAE \\r\\n100 reserved for future assignment by SAE \\r\\n101 reserved for future assignment by SAE \\r\\n110 error \\r\\n111 not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4393":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":32,"SPN":4393,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 1 State","SPN_Description":"The diesel exhaust fluid line heater 1 state for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4394":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":34,"SPN":4394,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 1, by the manufacturer\u2019s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4395":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":40,"SPN":4395,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 2 State","SPN_Description":"The diesel exhaust fluid line heater 2 state for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4396":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":42,"SPN":4396,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 2, by the manufacturer\u2019s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4397":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":48,"SPN":4397,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 3 State","SPN_Description":"The diesel exhaust fluid line heater 3 state for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4398":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":50,"SPN":4398,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 3 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 3, by the manufacturer\u2019s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4399":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":56,"SPN":4399,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 4 State","SPN_Description":"The diesel exhaust fluid line heater 4 state for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 heater inactive \\r\\n01 heater active \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4400":{"PGN":64827,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 2","PGN_Description":"A2SCRDSI2","first_bit":58,"SPN":4400,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 4 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid line heater 4, by the manufacturer\u2019s control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4401":{"PGN":61479,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 1","PGN_Description":"A2SCRDSR1","first_bit":0,"SPN":4401,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Dosing Requested Quantity","SPN_Description":"Actual requested dosing quantity of diesel exhaust fluid.","bit_length":16,"scaling":0.3,"offset":0,"unit":"g/h","SLOT_ID":272},"4402":{"PGN":61479,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 1","PGN_Description":"A2SCRDSR1","first_bit":16,"SPN":4402,"SPN_Name":"Aftertreatment 2 SCR System Requested State","SPN_Description":"Requested state of SCR system for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n0000 Dormant (sleep mode) \\r\\n0001 Preparing dosing readiness (wake up; prepare to operate; wait for start) \\r\\n0010 Normal dosing operation \\r\\n0011 System error pending \\r\\n0100 Reserved for future assignment by SAE \\r\\n0101 Protect mode against heat (pressure buildup) \\r\\n0110 Protect mode against cold (defreeze) \\r\\n0111 Shutoff (wait for after-run) \\r\\n1000 Diagnosis (after-run)\\r\\n1001 Service test mode, dosing allowed \\r\\n1010 Service test mode, dosing not allowed\\r\\n1011-1101 Reserved for future assignment by SAE\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4403":{"PGN":61479,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 1","PGN_Description":"A2SCRDSR1","first_bit":24,"SPN":4403,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Requested Quantity of Integrator","SPN_Description":"Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit. See SPN 7784 for alternate resolution.","bit_length":16,"scaling":0.1,"offset":0,"unit":"g","SLOT_ID":227},"4405":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":2,"SPN":4405,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid  Doser Fault Suppression Request","SPN_Description":"Used if external devices can warn of conditions that require suppression of potential faults in the doser due to environmental conditions.\\r\\n\\n00    Error suppression off\\r\\n01    Error suppression on\\r\\n10    Reserved\\r\\n11    Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4406":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":4,"SPN":4406,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Doser Heating Mode Request","SPN_Description":"Used if multiple heater modes are available in the Doser.\\r\\n\\r\\n000   Heater off\\r\\n001   Heater economy mode\\r\\n010   Heater automatic mode\\r\\n011   Heater on\\r\\n100 - 110    Reserved\\r\\n111   Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4407":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":8,"SPN":4407,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 1","SPN_Description":"The diesel exhaust fluid line heater 1 request for aftertreatment system 2 (exhaust bank 2). \\r\\n\\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4408":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":10,"SPN":4408,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 2","SPN_Description":"The diesel exhaust fluid line heater 2 request for aftertreatment system 2 (exhaust bank 2). \\r\\n\\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4409":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":12,"SPN":4409,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 3","SPN_Description":"The diesel exhaust fluid line heater 3 request for aftertreatment system 2 (exhaust bank 2). \\r\\n\\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4410":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":14,"SPN":4410,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 4","SPN_Description":"The diesel exhaust fluid line heater 4 request for aftertreatment system 2 (exhaust bank 2). \\r\\n \\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4411":{"PGN":64825,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Pressures","PGN_Description":"A2SCREGP","first_bit":0,"SPN":4411,"SPN_Name":"Aftertreatment 2 SCR Differential Pressure","SPN_Description":"Differential pressure measured between the intake and exhaust of an SCR component in exhaust bank 2.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4412":{"PGN":64825,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Pressures","PGN_Description":"A2SCREGP","first_bit":16,"SPN":4412,"SPN_Name":"Aftertreatment 2 SCR Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the SCR differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"4413":{"PGN":64824,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Temperature 1","PGN_Description":"A2SCREGT1","first_bit":0,"SPN":4413,"SPN_Name":"Aftertreatment 2 SCR Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the SCR in exhaust bank 2.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4414":{"PGN":64824,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Temperature 1","PGN_Description":"A2SCREGT1","first_bit":16,"SPN":4414,"SPN_Name":"Aftertreatment 2 SCR Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the SCR intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"4415":{"PGN":64824,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Temperature 1","PGN_Description":"A2SCREGT1","first_bit":24,"SPN":4415,"SPN_Name":"Aftertreatment 2 SCR Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the SCR exhaust in exhaust bank 2.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4416":{"PGN":64824,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Temperature 1","PGN_Description":"A2SCREGT1","first_bit":40,"SPN":4416,"SPN_Name":"Aftertreatment 2 SCR Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the SCR outlet temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"4417":{"PGN":64823,"PGN_Name":"Aftertreatment 2 SCR Service Information 1","PGN_Description":"A2SCRSI1","first_bit":0,"SPN":4417,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Average Consumption","SPN_Description":"Measured use of diesel exhaust fluid by a Selective Catalytic Reduction system for exhaust emission control, averaged over the previous 15 hours of engine operation.\\r\\n\\r\\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 2 Commanded Diesel Exhaust Fluid Consumption parameter (SPN 4418).","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"4418":{"PGN":64823,"PGN_Name":"Aftertreatment 2 SCR Service Information 1","PGN_Description":"A2SCRSI1","first_bit":16,"SPN":4418,"SPN_Name":"Aftertreatment 2 SCR Commanded Diesel Exhaust Fluid Consumption","SPN_Description":"This parameter transmits the amount of diesel exhaust fluid that the emissions control system has requested to be used, averaged over the past 15 hours of engine operation.\\r\\n\\r\\nUsed to determine whether the SCR system is using an appropriate amount of diesel exhaust fluid, by comparing with the Aftertreatment 2 Average Diesel Exhaust Fluid Consumption parameter (SPN 4417).","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"4419":{"PGN":64823,"PGN_Name":"Aftertreatment 2 SCR Service Information 1","PGN_Description":"A2SCRSI1","first_bit":32,"SPN":4419,"SPN_Name":"Aftertreatment 2 SCR Conversion Efficiency","SPN_Description":"The SCR conversion efficiency percentage.  Calculated as 100 times the catalyst intake NOx minus the catalyst outlet NOx divided by the catalyst intake NOx.  The catalyst conversion efficiency number in itself does not imply emissions compliance or system function or system malfunction.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4420":{"PGN":64822,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 1","PGN_Description":"A2DEFI1","first_bit":0,"SPN":4420,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Temperature 2","SPN_Description":"Temperature of the diesel exhaust fluid at the device measuring diesel exhaust fluid quality","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4421":{"PGN":64822,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 1","PGN_Description":"A2DEFI1","first_bit":8,"SPN":4421,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Concentration","SPN_Description":"A measure of the concentration of urea in water.  Zero percent means that the tank contains no urea.  A 32.5% value indicates that the reagent is of the proper concentration.  The 32.5% value indicates that the concentration is highest quality.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.25,"offset":0,"unit":"%","SLOT_ID":254},"4422":{"PGN":64822,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 1","PGN_Description":"A2DEFI1","first_bit":16,"SPN":4422,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Conductivity","SPN_Description":"A measure of the conductivity of the diesel exhaust fluid at the sensor.  The conductivity is an indication of the diesel exhaust fluid\'s chemical make up.","bit_length":8,"scaling":5,"offset":0,"unit":"\xb5Siemens/mm","SLOT_ID":255},"4423":{"PGN":64822,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 1","PGN_Description":"A2DEFI1","first_bit":24,"SPN":4423,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Temperature 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid temperature sensor. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4424":{"PGN":64822,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 1","PGN_Description":"A2DEFI1","first_bit":32,"SPN":4424,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Properties Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI that applies to the most significant failure of the diesel exhaust fluid properties sensor.  This may be used for indicating failures of the diesel exhaust fluid concentration, diesel exhaust fluid conductivity or diesel exhaust fluid type.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4425":{"PGN":64822,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 1","PGN_Description":"A2DEFI1","first_bit":40,"SPN":4425,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Type Property","SPN_Description":"This parameter indicates the property of the fluid compound in the tank.  A value of 0011 indicates uncontaminated Diesel Exhaust Fluid.\\r\\n\\r\\n0000 - Urea concentration too high\\r\\n0001 - Urea concentration too low\\r\\n0010 - Fluid is diesel\\r\\n0011 - Diesel exhaust fluid is proper mixture\\r\\n0100 to 1011 - Reserved for SAE assignment\\r\\n1100 - Diesel exhaust fluid, but concentration cannot be determined\\r\\n1101 - Not able to determine fluid property (fluid type unknown)\\r\\n1110 - Error with diesel exhaust fluid property detection\\r\\n1111 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4426":{"PGN":64821,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"A2DEFT1I1","first_bit":0,"SPN":4426,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Volume","SPN_Description":"Ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  0% is empty and 100% is full.  See SPN 4428 and SPN 7531 for alternate measurements.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4427":{"PGN":64821,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"A2DEFT1I1","first_bit":8,"SPN":4427,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Temperature 1","SPN_Description":"Temperature of the diesel exhaust fluid in the storage tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4428":{"PGN":64821,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"A2DEFT1I1","first_bit":16,"SPN":4428,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Level","SPN_Description":"The diesel exhaust fluid level height in mm in the diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  See SPN 4426 and SPN 7531 for alternate measurements. \\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"4429":{"PGN":64821,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"A2DEFT1I1","first_bit":32,"SPN":4429,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Level/Volume Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel exhaust fluid tank level sensor by the manufacturer\'s sensor control software.  This FMI is applicable to either the diesel exhaust fluid tank level or diesel exhaust fluid tank volume parameters.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4430":{"PGN":64821,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"A2DEFT1I1","first_bit":40,"SPN":4430,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid tank temperature for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer\u2019s control software. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4431":{"PGN":64821,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"A2DEFT1I1","first_bit":48,"SPN":4431,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Heater","SPN_Description":"Percentage of heating applied to the aftertreatment 2 diesel exhaust fluid tank heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.  See SPN 5138 for the command for this tank heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4432":{"PGN":64821,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"A2DEFT1I1","first_bit":56,"SPN":4432,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid tank for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer\'s control software.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4433":{"PGN":64820,"PGN_Name":"Aftertreatment 2 SCR Reagant Tank 2 Information","PGN_Description":"A2SCRRT2I","first_bit":0,"SPN":4433,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Tank Volume","SPN_Description":"Ratio of volume of diesel exhaust fluid to the total volume of diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  0% is empty and 100% is full.  An alternative to this SPN is SPN 4435.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4434":{"PGN":64820,"PGN_Name":"Aftertreatment 2 SCR Reagant Tank 2 Information","PGN_Description":"A2SCRRT2I","first_bit":8,"SPN":4434,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Temperature","SPN_Description":"The diesel exhaust fluid quick thaw tank temperature for aftertreatment system 2 (exhaust bank 2).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"4435":{"PGN":64820,"PGN_Name":"Aftertreatment 2 SCR Reagant Tank 2 Information","PGN_Description":"A2SCRRT2I","first_bit":16,"SPN":4435,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Tank Level","SPN_Description":"The diesel exhaust fluid level height in mm in the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2).  See SPN 4433 for alternate measurement. \\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"4436":{"PGN":64820,"PGN_Name":"Aftertreatment 2 SCR Reagant Tank 2 Information","PGN_Description":"A2SCRRT2I","first_bit":32,"SPN":4436,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Level Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the fluid level height of the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer\'s control software.  This FMI is applicable to either the diesel exhaust fluid quick thaw tank level or diesel exhaust fluid quick thaw tank volume parameters.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4437":{"PGN":64820,"PGN_Name":"Aftertreatment 2 SCR Reagant Tank 2 Information","PGN_Description":"A2SCRRT2I","first_bit":40,"SPN":4437,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the diesel exhaust fluid quick thaw tank temperature for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer\u2019s control software. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4438":{"PGN":64820,"PGN_Name":"Aftertreatment 2 SCR Reagant Tank 2 Information","PGN_Description":"A2SCRRT2I","first_bit":48,"SPN":4438,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Heater","SPN_Description":"The diesel exhaust fluid quick thaw tank heater percentage for aftertreatment system 2 (exhaust bank 2). 0% is off. See SPN 5415 for the command for this tank heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4439":{"PGN":64820,"PGN_Name":"Aftertreatment 2 SCR Reagant Tank 2 Information","PGN_Description":"A2SCRRT2I","first_bit":56,"SPN":4439,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2), as detected by the manufacturer\'s control software.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4440":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":0,"SPN":4440,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump 1 Motor Speed","SPN_Description":"Rotational speed of the motor driving the first or only pump for the diesel exhaust fluid used in aftertreatment system 2 (exhaust bank 2).","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"4441":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":16,"SPN":4441,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump Drive Percentage","SPN_Description":"The percent (command) sent to the motor to control the speed of  the diesel exhaust fluid pump.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4442":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":24,"SPN":4442,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Dosing Unit 1 Diverter Valve","SPN_Description":"Command to the valve which determines whether the diesel exhaust fluid of dosing unit 1 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4443":{"PGN":61480,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information","PGN_Description":"A2SCRAI","first_bit":0,"SPN":4443,"SPN_Name":"Aftertreatment 2 Outlet NH3","SPN_Description":"The amount of NH3 in the exhaust exiting the aftertreatment system measured by a NH3 sensor at the aftertreatment outlet, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 2.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"4444":{"PGN":61480,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information","PGN_Description":"A2SCRAI","first_bit":16,"SPN":4444,"SPN_Name":"Aftertreatment 2 Outlet NH3 Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NH3 sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4445":{"PGN":61480,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information","PGN_Description":"A2SCRAI","first_bit":24,"SPN":4445,"SPN_Name":"Aftertreatment 2 Outlet NH3 Reading Stable","SPN_Description":"Indicates that the NH3 reading of the aftertreatment outlet NH3 sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 2.\\r\\n\\r\\n00 - Reading is not stable\\r\\n01 - Reading is stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4446":{"PGN":61480,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information","PGN_Description":"A2SCRAI","first_bit":26,"SPN":4446,"SPN_Name":"Aftertreatment 2 Outlet NH3 Gas Sensor Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment outlet NH3 gas sensor is within the manufacturer\u2019s specification in exhaust bank 2.\\r\\n\\r\\n00 - Heater element is not in range\\r\\n01 - Heater element is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4447":{"PGN":61480,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information","PGN_Description":"A2SCRAI","first_bit":28,"SPN":4447,"SPN_Name":"Aftertreatment 2 Outlet NH3 Gas Sensor at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment outlet NH3 gas sensor is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 2.\\r\\n\\r\\n00 - Heater element is not in range\\r\\n01 - Heater element is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4448":{"PGN":61480,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information","PGN_Description":"A2SCRAI","first_bit":32,"SPN":4448,"SPN_Name":"Aftertreatment 2 Outlet NH3 Gas Sensor Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the outlet NH3 exhaust gas sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4449":{"PGN":61480,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information","PGN_Description":"A2SCRAI","first_bit":40,"SPN":4449,"SPN_Name":"Aftertreatment 2 Outlet NH3 Gas Sensor Heater Control","SPN_Description":"Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 gas sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\\r\\n \\r\\n00 - Automatic \\r\\n01 - Preheat 2 \\r\\n10 - Preheat 1 \\r\\n11 - Heater off or Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4454":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":24,"SPN":4454,"SPN_Name":"Retract Status of ramp 4","SPN_Description":"Retract status of ramp at doorway 4, counting from front to back on the vehicle.\\r\\n \\r\\n00 ramp retracted\\r\\n01 ramp extended\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4455":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":26,"SPN":4455,"SPN_Name":"Enable status of ramp 4","SPN_Description":"Enable status of ramp at doorway 4, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp disabled\\r\\n01 ramp enabled \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4456":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":28,"SPN":4456,"SPN_Name":"Movement status of ramp 4","SPN_Description":"Movement status of ramp at doorway 4, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp not being moved\\r\\n01 ramp being moved\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4457":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":32,"SPN":4457,"SPN_Name":"Retract Status of ramp 5","SPN_Description":"Retract status of ramp at doorway 5, counting from front to back on the vehicle.\\r\\n \\r\\n00 ramp retracted\\r\\n01 ramp extended\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4458":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":34,"SPN":4458,"SPN_Name":"Enable status of ramp 5","SPN_Description":"Enable status of ramp at doorway 5, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp disabled\\r\\n01 ramp enabled \\r\\n10 error \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4459":{"PGN":64880,"PGN_Name":"Door ramp control","PGN_Description":"DRC","first_bit":36,"SPN":4459,"SPN_Name":"Movement status of ramp 5","SPN_Description":"Movement status of ramp at doorway 5, counting from front to back on the vehicle.\\r\\n\\r\\n00 ramp not being moved\\r\\n01 ramp being moved\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4460":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":0,"SPN":4460,"SPN_Name":"Joystick 1 Lamp 1 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 1.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4461":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":2,"SPN":4461,"SPN_Name":"Joystick 1 Lamp 2 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 2.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4462":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":4,"SPN":4462,"SPN_Name":"Joystick 1 Lamp 3 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 3.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4463":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":6,"SPN":4463,"SPN_Name":"Joystick 1 Lamp 4 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 4.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4464":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":8,"SPN":4464,"SPN_Name":"Joystick 1 Lamp 5 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 5.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4465":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":10,"SPN":4465,"SPN_Name":"Joystick 1 Lamp 6 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 6.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4466":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":12,"SPN":4466,"SPN_Name":"Joystick 1 Lamp 7 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 7.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4467":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":14,"SPN":4467,"SPN_Name":"Joystick 1 Lamp 8 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 8.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4468":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":16,"SPN":4468,"SPN_Name":"Joystick 1 Lamp 9 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 9.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4469":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":18,"SPN":4469,"SPN_Name":"Joystick 1 Lamp 10 Command","SPN_Description":"Tells joystick 1 to switch on/off/blinking lamp 10.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4470":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":20,"SPN":4470,"SPN_Name":"Joystick 2 Lamp 1 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 1.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4471":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":22,"SPN":4471,"SPN_Name":"Joystick 2 Lamp 2 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 2.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4472":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":24,"SPN":4472,"SPN_Name":"Joystick 2 Lamp 3 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 3.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4473":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":26,"SPN":4473,"SPN_Name":"Joystick 2 Lamp 4 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 4.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4474":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":28,"SPN":4474,"SPN_Name":"Joystick 2 Lamp 5 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 5.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4475":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":30,"SPN":4475,"SPN_Name":"Joystick 2 Lamp 6 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 6.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4476":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":32,"SPN":4476,"SPN_Name":"Joystick 2 Lamp 7 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 7.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4477":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":34,"SPN":4477,"SPN_Name":"Joystick 2 Lamp 8 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 8.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4478":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":36,"SPN":4478,"SPN_Name":"Joystick 2 Lamp 9 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 9.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4479":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":38,"SPN":4479,"SPN_Name":"Joystick 2 Lamp 10 Command","SPN_Description":"Tells joystick 2 to switch on/off/blinking lamp 10.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4480":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":40,"SPN":4480,"SPN_Name":"Joystick 3 Lamp 1 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 1.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4481":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":42,"SPN":4481,"SPN_Name":"Joystick 3 Lamp 2 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 2.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4482":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":44,"SPN":4482,"SPN_Name":"Joystick 3 Lamp 3 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 3.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4483":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":46,"SPN":4483,"SPN_Name":"Joystick 3 Lamp 4 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 4.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4484":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":48,"SPN":4484,"SPN_Name":"Joystick 3 Lamp 5 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 5.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4485":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":50,"SPN":4485,"SPN_Name":"Joystick 3 Lamp 6 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 6.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4486":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":52,"SPN":4486,"SPN_Name":"Joystick 3 Lamp 7 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 7.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4487":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":54,"SPN":4487,"SPN_Name":"Joystick 3 Lamp 8 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 8.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4488":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":56,"SPN":4488,"SPN_Name":"Joystick 3 Lamp 9 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 9.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4489":{"PGN":39168,"PGN_Name":"Joystick Lamp Command Message","PGN_Description":"JLCM","first_bit":58,"SPN":4489,"SPN_Name":"Joystick 3 Lamp 10 Command","SPN_Description":"Tells joystick 3 to switch on/off/blinking lamp 10.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Blinking\\r\\n11 - Don\'t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4490":{"PGN":64992,"PGN_Name":"Ambient Conditions 2","PGN_Description":"AMB2","first_bit":16,"SPN":4490,"SPN_Name":"Specific Humidity","SPN_Description":"Specific humidity of the ambient intake air.","bit_length":16,"scaling":0.01,"offset":0,"unit":"g/kg","SLOT_ID":285},"4491":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":0,"SPN":4491,"SPN_Name":"Joystick 4 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4492":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":2,"SPN":4492,"SPN_Name":"Joystick 4 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4493":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":4,"SPN":4493,"SPN_Name":"Joystick 4 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4494":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":6,"SPN":4494,"SPN_Name":"Joystick 4 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4495":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":16,"SPN":4495,"SPN_Name":"Joystick 4 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4496":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":18,"SPN":4496,"SPN_Name":"Joystick 4 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4497":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":20,"SPN":4497,"SPN_Name":"Joystick 4 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4498":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":22,"SPN":4498,"SPN_Name":"Joystick 4 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4499":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":36,"SPN":4499,"SPN_Name":"Joystick 4 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4500":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":38,"SPN":4500,"SPN_Name":"Joystick 4 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4501":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":40,"SPN":4501,"SPN_Name":"Joystick 4 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4502":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":42,"SPN":4502,"SPN_Name":"Joystick 4 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4503":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":44,"SPN":4503,"SPN_Name":"Joystick 4 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4504":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":46,"SPN":4504,"SPN_Name":"Joystick 4 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4505":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":48,"SPN":4505,"SPN_Name":"Joystick 4 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4506":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":50,"SPN":4506,"SPN_Name":"Joystick 4 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4507":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":52,"SPN":4507,"SPN_Name":"Joystick 4 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4508":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":54,"SPN":4508,"SPN_Name":"Joystick 4 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4509":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":56,"SPN":4509,"SPN_Name":"Joystick 4 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4510":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":58,"SPN":4510,"SPN_Name":"Joystick 4 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4511":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":60,"SPN":4511,"SPN_Name":"Joystick 4 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4512":{"PGN":64816,"PGN_Name":"Basic Joystick Message 4","PGN_Description":"BJM4","first_bit":62,"SPN":4512,"SPN_Name":"Joystick 4 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4513":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":0,"SPN":4513,"SPN_Name":"Joystick 4 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4514":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":2,"SPN":4514,"SPN_Name":"Joystick 4 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4515":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":4,"SPN":4515,"SPN_Name":"Joystick 4 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4516":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":6,"SPN":4516,"SPN_Name":"Joystick 4 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4517":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":16,"SPN":4517,"SPN_Name":"Joystick 4 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4518":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":18,"SPN":4518,"SPN_Name":"Joystick 4 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4519":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":20,"SPN":4519,"SPN_Name":"Joystick 4 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4520":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":22,"SPN":4520,"SPN_Name":"Joystick 4 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4521":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":32,"SPN":4521,"SPN_Name":"Joystick 4 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4522":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":34,"SPN":4522,"SPN_Name":"Joystick 4 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4523":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":36,"SPN":4523,"SPN_Name":"Joystick 4 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4524":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":38,"SPN":4524,"SPN_Name":"Joystick 4 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4525":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":50,"SPN":4525,"SPN_Name":"Joystick 4 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4526":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":52,"SPN":4526,"SPN_Name":"Joystick 4 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4527":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":54,"SPN":4527,"SPN_Name":"Joystick 4 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4528":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":0,"SPN":4528,"SPN_Name":"Joystick 5 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4529":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":2,"SPN":4529,"SPN_Name":"Joystick 5 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4530":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":4,"SPN":4530,"SPN_Name":"Joystick 5 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4531":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":6,"SPN":4531,"SPN_Name":"Joystick 5 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4532":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":16,"SPN":4532,"SPN_Name":"Joystick 5 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4533":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":18,"SPN":4533,"SPN_Name":"Joystick 5 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4534":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":20,"SPN":4534,"SPN_Name":"Joystick 5 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4535":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":22,"SPN":4535,"SPN_Name":"Joystick 5 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4536":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":36,"SPN":4536,"SPN_Name":"Joystick 5 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4537":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":38,"SPN":4537,"SPN_Name":"Joystick 5 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4538":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":40,"SPN":4538,"SPN_Name":"Joystick 5 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4539":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":42,"SPN":4539,"SPN_Name":"Joystick 5 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4540":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":44,"SPN":4540,"SPN_Name":"Joystick 5 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4541":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":46,"SPN":4541,"SPN_Name":"Joystick 5 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4542":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":48,"SPN":4542,"SPN_Name":"Joystick 5 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4543":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":50,"SPN":4543,"SPN_Name":"Joystick 5 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4544":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":52,"SPN":4544,"SPN_Name":"Joystick 5 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4545":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":54,"SPN":4545,"SPN_Name":"Joystick 5 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4546":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":56,"SPN":4546,"SPN_Name":"Joystick 5 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4547":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":58,"SPN":4547,"SPN_Name":"Joystick 5 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4548":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":60,"SPN":4548,"SPN_Name":"Joystick 5 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4549":{"PGN":64814,"PGN_Name":"Basic Joystick Message 5","PGN_Description":"BJM5","first_bit":62,"SPN":4549,"SPN_Name":"Joystick 5 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4550":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":0,"SPN":4550,"SPN_Name":"Joystick 5 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4551":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":2,"SPN":4551,"SPN_Name":"Joystick 5 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4552":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":4,"SPN":4552,"SPN_Name":"Joystick 5 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4553":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":6,"SPN":4553,"SPN_Name":"Joystick 5 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4554":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":16,"SPN":4554,"SPN_Name":"Joystick 5 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4555":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":18,"SPN":4555,"SPN_Name":"Joystick 5 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4556":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":20,"SPN":4556,"SPN_Name":"Joystick 5 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4557":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":22,"SPN":4557,"SPN_Name":"Joystick 5 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4558":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":32,"SPN":4558,"SPN_Name":"Joystick 5 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4559":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":34,"SPN":4559,"SPN_Name":"Joystick 5 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4560":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":36,"SPN":4560,"SPN_Name":"Joystick 5 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4561":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":38,"SPN":4561,"SPN_Name":"Joystick 5 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4562":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":50,"SPN":4562,"SPN_Name":"Joystick 5 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4563":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":52,"SPN":4563,"SPN_Name":"Joystick 5 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4564":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":54,"SPN":4564,"SPN_Name":"Joystick 5 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4565":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":0,"SPN":4565,"SPN_Name":"Joystick 6 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4566":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":2,"SPN":4566,"SPN_Name":"Joystick 6 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4567":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":4,"SPN":4567,"SPN_Name":"Joystick 6 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4568":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":6,"SPN":4568,"SPN_Name":"Joystick 6 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4569":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":16,"SPN":4569,"SPN_Name":"Joystick 6 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4570":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":18,"SPN":4570,"SPN_Name":"Joystick 6 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4571":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":20,"SPN":4571,"SPN_Name":"Joystick 6 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4572":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":22,"SPN":4572,"SPN_Name":"Joystick 6 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4573":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":36,"SPN":4573,"SPN_Name":"Joystick 6 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4574":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":38,"SPN":4574,"SPN_Name":"Joystick 6 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4575":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":40,"SPN":4575,"SPN_Name":"Joystick 6 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4576":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":42,"SPN":4576,"SPN_Name":"Joystick 6 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4577":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":44,"SPN":4577,"SPN_Name":"Joystick 6 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4578":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":46,"SPN":4578,"SPN_Name":"Joystick 6 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4579":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":48,"SPN":4579,"SPN_Name":"Joystick 6 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4580":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":50,"SPN":4580,"SPN_Name":"Joystick 6 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4581":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":52,"SPN":4581,"SPN_Name":"Joystick 6 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4582":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":54,"SPN":4582,"SPN_Name":"Joystick 6 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4583":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":56,"SPN":4583,"SPN_Name":"Joystick 6 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4584":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":58,"SPN":4584,"SPN_Name":"Joystick 6 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4585":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":60,"SPN":4585,"SPN_Name":"Joystick 6 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4586":{"PGN":64812,"PGN_Name":"Basic Joystick Message 6","PGN_Description":"BJM6","first_bit":62,"SPN":4586,"SPN_Name":"Joystick 6 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4587":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":0,"SPN":4587,"SPN_Name":"Joystick 6 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4588":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":2,"SPN":4588,"SPN_Name":"Joystick 6 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4589":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":4,"SPN":4589,"SPN_Name":"Joystick 6 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4590":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":6,"SPN":4590,"SPN_Name":"Joystick 6 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4591":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":16,"SPN":4591,"SPN_Name":"Joystick 6 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4592":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":18,"SPN":4592,"SPN_Name":"Joystick 6 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4593":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":20,"SPN":4593,"SPN_Name":"Joystick 6 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4594":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":22,"SPN":4594,"SPN_Name":"Joystick 6 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4595":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":32,"SPN":4595,"SPN_Name":"Joystick 6 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4596":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":34,"SPN":4596,"SPN_Name":"Joystick 6 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4597":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":36,"SPN":4597,"SPN_Name":"Joystick 6 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4598":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":38,"SPN":4598,"SPN_Name":"Joystick 6 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4599":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":50,"SPN":4599,"SPN_Name":"Joystick 6 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4600":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":52,"SPN":4600,"SPN_Name":"Joystick 6 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4601":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":54,"SPN":4601,"SPN_Name":"Joystick 6 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4602":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":0,"SPN":4602,"SPN_Name":"Joystick 7 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4603":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":2,"SPN":4603,"SPN_Name":"Joystick 7 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4604":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":4,"SPN":4604,"SPN_Name":"Joystick 7 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4605":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":6,"SPN":4605,"SPN_Name":"Joystick 7 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4606":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":16,"SPN":4606,"SPN_Name":"Joystick 7 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4607":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":18,"SPN":4607,"SPN_Name":"Joystick 7 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4608":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":20,"SPN":4608,"SPN_Name":"Joystick 7 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4609":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":22,"SPN":4609,"SPN_Name":"Joystick 7 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4610":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":36,"SPN":4610,"SPN_Name":"Joystick 7 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4611":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":38,"SPN":4611,"SPN_Name":"Joystick 7 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4612":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":40,"SPN":4612,"SPN_Name":"Joystick 7 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4613":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":42,"SPN":4613,"SPN_Name":"Joystick 7 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4614":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":44,"SPN":4614,"SPN_Name":"Joystick 7 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4615":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":46,"SPN":4615,"SPN_Name":"Joystick 7 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4616":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":48,"SPN":4616,"SPN_Name":"Joystick 7 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4617":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":50,"SPN":4617,"SPN_Name":"Joystick 7 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4618":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":52,"SPN":4618,"SPN_Name":"Joystick 7 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4619":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":54,"SPN":4619,"SPN_Name":"Joystick 7 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4620":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":56,"SPN":4620,"SPN_Name":"Joystick 7 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4621":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":58,"SPN":4621,"SPN_Name":"Joystick 7 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4622":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":60,"SPN":4622,"SPN_Name":"Joystick 7 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4623":{"PGN":64810,"PGN_Name":"Basic Joystick Message 7","PGN_Description":"BJM7","first_bit":62,"SPN":4623,"SPN_Name":"Joystick 7 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4624":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":0,"SPN":4624,"SPN_Name":"Joystick 7 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4625":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":2,"SPN":4625,"SPN_Name":"Joystick 7 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4626":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":4,"SPN":4626,"SPN_Name":"Joystick 7 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4627":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":6,"SPN":4627,"SPN_Name":"Joystick 7 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4628":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":16,"SPN":4628,"SPN_Name":"Joystick 7 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4629":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":18,"SPN":4629,"SPN_Name":"Joystick 7 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4630":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":20,"SPN":4630,"SPN_Name":"Joystick 7 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4631":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":22,"SPN":4631,"SPN_Name":"Joystick 7 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4632":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":32,"SPN":4632,"SPN_Name":"Joystick 7 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4633":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":34,"SPN":4633,"SPN_Name":"Joystick 7 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4634":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":36,"SPN":4634,"SPN_Name":"Joystick 7 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4635":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":38,"SPN":4635,"SPN_Name":"Joystick 7 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4636":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":50,"SPN":4636,"SPN_Name":"Joystick 7 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4637":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":52,"SPN":4637,"SPN_Name":"Joystick 7 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4638":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":54,"SPN":4638,"SPN_Name":"Joystick 7 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4639":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":0,"SPN":4639,"SPN_Name":"Joystick 8 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4640":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":2,"SPN":4640,"SPN_Name":"Joystick 8 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4641":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":4,"SPN":4641,"SPN_Name":"Joystick 8 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4642":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":6,"SPN":4642,"SPN_Name":"Joystick 8 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4643":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":16,"SPN":4643,"SPN_Name":"Joystick 8 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4644":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":18,"SPN":4644,"SPN_Name":"Joystick 8 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4645":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":20,"SPN":4645,"SPN_Name":"Joystick 8 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4646":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":22,"SPN":4646,"SPN_Name":"Joystick 8 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4647":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":36,"SPN":4647,"SPN_Name":"Joystick 8 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4648":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":38,"SPN":4648,"SPN_Name":"Joystick 8 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4649":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":40,"SPN":4649,"SPN_Name":"Joystick 8 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4650":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":42,"SPN":4650,"SPN_Name":"Joystick 8 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4651":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":44,"SPN":4651,"SPN_Name":"Joystick 8 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4652":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":46,"SPN":4652,"SPN_Name":"Joystick 8 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4653":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":48,"SPN":4653,"SPN_Name":"Joystick 8 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4654":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":50,"SPN":4654,"SPN_Name":"Joystick 8 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4655":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":52,"SPN":4655,"SPN_Name":"Joystick 8 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4656":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":54,"SPN":4656,"SPN_Name":"Joystick 8 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4657":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":56,"SPN":4657,"SPN_Name":"Joystick 8 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4658":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":58,"SPN":4658,"SPN_Name":"Joystick 8 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4659":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":60,"SPN":4659,"SPN_Name":"Joystick 8 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4660":{"PGN":64808,"PGN_Name":"Basic Joystick Message 8","PGN_Description":"BJM8","first_bit":62,"SPN":4660,"SPN_Name":"Joystick 8 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4661":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":0,"SPN":4661,"SPN_Name":"Joystick 8 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4662":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":2,"SPN":4662,"SPN_Name":"Joystick 8 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4663":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":4,"SPN":4663,"SPN_Name":"Joystick 8 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4664":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":6,"SPN":4664,"SPN_Name":"Joystick 8 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4665":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":16,"SPN":4665,"SPN_Name":"Joystick 8 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4666":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":18,"SPN":4666,"SPN_Name":"Joystick 8 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4667":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":20,"SPN":4667,"SPN_Name":"Joystick 8 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4668":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":22,"SPN":4668,"SPN_Name":"Joystick 8 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4669":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":32,"SPN":4669,"SPN_Name":"Joystick 8 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4670":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":34,"SPN":4670,"SPN_Name":"Joystick 8 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4671":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":36,"SPN":4671,"SPN_Name":"Joystick 8 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4672":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":38,"SPN":4672,"SPN_Name":"Joystick 8 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4673":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":50,"SPN":4673,"SPN_Name":"Joystick 8 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4674":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":52,"SPN":4674,"SPN_Name":"Joystick 8 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4675":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":54,"SPN":4675,"SPN_Name":"Joystick 8 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4676":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":0,"SPN":4676,"SPN_Name":"Joystick 9 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4677":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":2,"SPN":4677,"SPN_Name":"Joystick 9 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4678":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":4,"SPN":4678,"SPN_Name":"Joystick 9 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4679":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":6,"SPN":4679,"SPN_Name":"Joystick 9 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4680":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":16,"SPN":4680,"SPN_Name":"Joystick 9 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4681":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":18,"SPN":4681,"SPN_Name":"Joystick 9 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4682":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":20,"SPN":4682,"SPN_Name":"Joystick 9 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4683":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":22,"SPN":4683,"SPN_Name":"Joystick 9 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4684":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":36,"SPN":4684,"SPN_Name":"Joystick 9 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4685":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":38,"SPN":4685,"SPN_Name":"Joystick 9 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4686":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":40,"SPN":4686,"SPN_Name":"Joystick 9 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4687":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":42,"SPN":4687,"SPN_Name":"Joystick 9 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4688":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":44,"SPN":4688,"SPN_Name":"Joystick 9 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4689":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":46,"SPN":4689,"SPN_Name":"Joystick 9 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4690":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":48,"SPN":4690,"SPN_Name":"Joystick 9 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4691":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":50,"SPN":4691,"SPN_Name":"Joystick 9 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4692":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":52,"SPN":4692,"SPN_Name":"Joystick 9 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4693":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":54,"SPN":4693,"SPN_Name":"Joystick 9 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4694":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":56,"SPN":4694,"SPN_Name":"Joystick 9 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4695":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":58,"SPN":4695,"SPN_Name":"Joystick 9 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4696":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":60,"SPN":4696,"SPN_Name":"Joystick 9 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4697":{"PGN":64806,"PGN_Name":"Basic Joystick Message 9","PGN_Description":"BJM9","first_bit":62,"SPN":4697,"SPN_Name":"Joystick 9 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4698":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":0,"SPN":4698,"SPN_Name":"Joystick 9 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4699":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":2,"SPN":4699,"SPN_Name":"Joystick 9 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4700":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":4,"SPN":4700,"SPN_Name":"Joystick 9 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4701":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":6,"SPN":4701,"SPN_Name":"Joystick 9 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4702":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":16,"SPN":4702,"SPN_Name":"Joystick 9 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4703":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":18,"SPN":4703,"SPN_Name":"Joystick 9 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4704":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":20,"SPN":4704,"SPN_Name":"Joystick 9 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4705":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":22,"SPN":4705,"SPN_Name":"Joystick 9 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4706":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":32,"SPN":4706,"SPN_Name":"Joystick 9 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4707":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":34,"SPN":4707,"SPN_Name":"Joystick 9 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4708":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":36,"SPN":4708,"SPN_Name":"Joystick 9 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4709":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":38,"SPN":4709,"SPN_Name":"Joystick 9 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4710":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":50,"SPN":4710,"SPN_Name":"Joystick 9 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4711":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":52,"SPN":4711,"SPN_Name":"Joystick 9 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4712":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":54,"SPN":4712,"SPN_Name":"Joystick 9 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4713":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":0,"SPN":4713,"SPN_Name":"Joystick 10 X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4714":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":2,"SPN":4714,"SPN_Name":"Joystick 10 X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4715":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":4,"SPN":4715,"SPN_Name":"Joystick 10 X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4716":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":6,"SPN":4716,"SPN_Name":"Joystick 10 X-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4717":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":16,"SPN":4717,"SPN_Name":"Joystick 10 Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4718":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":18,"SPN":4718,"SPN_Name":"Joystick 10 Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4719":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":20,"SPN":4719,"SPN_Name":"Joystick 10 Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4720":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":22,"SPN":4720,"SPN_Name":"Joystick 10 Y-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4721":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":36,"SPN":4721,"SPN_Name":"Joystick 10 Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4722":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":38,"SPN":4722,"SPN_Name":"Joystick 10 X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4723":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":40,"SPN":4723,"SPN_Name":"Joystick 10 Button 4 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4724":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":42,"SPN":4724,"SPN_Name":"Joystick 10 Button 3 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4725":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":44,"SPN":4725,"SPN_Name":"Joystick 10 Button 2 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4726":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":46,"SPN":4726,"SPN_Name":"Joystick 10 Button 1 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4727":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":48,"SPN":4727,"SPN_Name":"Joystick 10 Button 8 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4728":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":50,"SPN":4728,"SPN_Name":"Joystick 10 Button 7 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4729":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":52,"SPN":4729,"SPN_Name":"Joystick 10 Button 6 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4730":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":54,"SPN":4730,"SPN_Name":"Joystick 10 Button 5 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4731":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":56,"SPN":4731,"SPN_Name":"Joystick 10 Button 12 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4732":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":58,"SPN":4732,"SPN_Name":"Joystick 10 Button 11 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4733":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":60,"SPN":4733,"SPN_Name":"Joystick 10 Button 10 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4734":{"PGN":64804,"PGN_Name":"Basic Joystick Message 10","PGN_Description":"BJM10","first_bit":62,"SPN":4734,"SPN_Name":"Joystick 10 Button 9 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\r\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4735":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":0,"SPN":4735,"SPN_Name":"Joystick 10 Grip X-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4736":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":2,"SPN":4736,"SPN_Name":"Joystick 10 Grip X-Axis Lever Left Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4737":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":4,"SPN":4737,"SPN_Name":"Joystick 10 Grip X-Axis Lever Right Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4738":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":6,"SPN":4738,"SPN_Name":"Joystick 10 Grip X-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4739":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":16,"SPN":4739,"SPN_Name":"Joystick 10 Grip Y-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick grip position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4740":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":18,"SPN":4740,"SPN_Name":"Joystick 10 Grip Y-Axis Lever Back Negative Position Status","SPN_Description":"Reports when the current joystick grip position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4741":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":20,"SPN":4741,"SPN_Name":"Joystick 10 Grip Y-Axis Lever Forward Positive Position Status","SPN_Description":"Reports when the current joystick grip position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4742":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":22,"SPN":4742,"SPN_Name":"Joystick 10 Grip Y-Axis Position","SPN_Description":"The position of the joystick grip in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4743":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":32,"SPN":4743,"SPN_Name":"Joystick 10 Theta-Axis Neutral Position Status","SPN_Description":"Reports when the current joystick position is in the neutral position for that axis of travel.  The neutral position measurement must be determined from some mechanism other than the axis position measurement device.  \\r\\n\\r\\n00 Not in Neutral Position\\r\\n01 In Neutral Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4744":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":34,"SPN":4744,"SPN_Name":"Joystick 10 Theta-Axis Counter Clockwise Negative Position Status","SPN_Description":"Reports when the current joystick position is on the negative travel side (back, left, counterclockwise, down) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on negative side of Neutral\\r\\n01 On negative side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4745":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":36,"SPN":4745,"SPN_Name":"Joystick 10 Theta-Axis Clockwise Positive Position Status","SPN_Description":"Reports when the current joystick position is on the positive travel side (forward, right, clockwise, up) relative to the neutral position for that axis of travel. \\r\\n\\r\\n00 Not on Positive side of Neutral\\r\\n01 On positive side of Neutral\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4746":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":38,"SPN":4746,"SPN_Name":"Joystick 10 Theta-Axis Position","SPN_Description":"The position of the joystick in the relative motion of travel from the neutral position.  Position value of 0 is Neutral and position value 1000 (100%) is the end of linear zone.  Value of 1022 indicates an error has occurred.","bit_length":10,"scaling":0.1,"offset":0,"unit":"%","SLOT_ID":205},"4747":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":50,"SPN":4747,"SPN_Name":"Joystick 10 Theta-Axis Detent Position Status","SPN_Description":"Reports when the current joystick position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4748":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":52,"SPN":4748,"SPN_Name":"Joystick 10 Grip Y-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4749":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":54,"SPN":4749,"SPN_Name":"Joystick 10 Grip X-Axis Detent Position Status","SPN_Description":"Reports when the current joystick grip position is in the detent position for that axis of travel.\\r\\n\\r\\n00 Not in the Detent Position\\r\\n01 In the Detent Position\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4750":{"PGN":64879,"PGN_Name":"Electronic Engine Controller 8","PGN_Description":"EEC8","first_bit":16,"SPN":4750,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Cooler Intake Temperature","SPN_Description":"Exhaust Gas Recirculation (EGR) Temperature measured at the EGR cooler intake.  See SPN 412 for Engine EGR temperature which is typically measured at the EGR cooler outlet.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4751":{"PGN":64879,"PGN_Name":"Electronic Engine Controller 8","PGN_Description":"EEC8","first_bit":32,"SPN":4751,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Cooler Intake Absolute Pressure","SPN_Description":"Exhaust gas recirculation absolute pressure is measured at the EGR cooler intake. See SPN 3358 for EGR pressure measured at the EGR cooler outlet before the valve.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"4752":{"PGN":64879,"PGN_Name":"Electronic Engine Controller 8","PGN_Description":"EEC8","first_bit":48,"SPN":4752,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Cooler Efficiency","SPN_Description":"Exhaust Gas Recirculation cooler efficiency is an indication of the cooler\u2019s ability to reduce the temperature of the exhaust gas that is being recirculated back to the intake. 0% = no reduction in temperature, 100% = maximum cooling.  The EGR cooler efficiency is calculated as (EGR cooler intake temperature minus EGR gas temperature) divided by (EGR cooler intake temperature minus engine coolant temperature).","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"4753":{"PGN":64802,"PGN_Name":"Aftertreatment 1 Gas Oxidation Catalyst","PGN_Description":"A1GOC","first_bit":0,"SPN":4753,"SPN_Name":"Aftertreatment 1 Gas Oxidation Catalyst Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the gas oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4754":{"PGN":64802,"PGN_Name":"Aftertreatment 1 Gas Oxidation Catalyst","PGN_Description":"A1GOC","first_bit":16,"SPN":4754,"SPN_Name":"Aftertreatment 1 Gas Oxidation Catalyst Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the gas oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4755":{"PGN":64802,"PGN_Name":"Aftertreatment 1 Gas Oxidation Catalyst","PGN_Description":"A1GOC","first_bit":32,"SPN":4755,"SPN_Name":"Aftertreatment 1 Gas Oxidation Catalyst Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of the gas oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4756":{"PGN":64802,"PGN_Name":"Aftertreatment 1 Gas Oxidation Catalyst","PGN_Description":"A1GOC","first_bit":48,"SPN":4756,"SPN_Name":"Aftertreatment 1 Gas Oxidation Catalyst Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4757":{"PGN":64802,"PGN_Name":"Aftertreatment 1 Gas Oxidation Catalyst","PGN_Description":"A1GOC","first_bit":53,"SPN":4757,"SPN_Name":"Aftertreatment 1 Gas Oxidation Catalyst Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst outlet temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4758":{"PGN":64802,"PGN_Name":"Aftertreatment 1 Gas Oxidation Catalyst","PGN_Description":"A1GOC","first_bit":58,"SPN":4758,"SPN_Name":"Aftertreatment 1 Gas Oxidation Catalyst Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4759":{"PGN":64801,"PGN_Name":"Aftertreatment 2 Gas Oxidation Catalyst","PGN_Description":"A2GOC","first_bit":0,"SPN":4759,"SPN_Name":"Aftertreatment 2 Gas Oxidation Catalyst Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the gas oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4760":{"PGN":64801,"PGN_Name":"Aftertreatment 2 Gas Oxidation Catalyst","PGN_Description":"A2GOC","first_bit":16,"SPN":4760,"SPN_Name":"Aftertreatment 2 Gas Oxidation Catalyst Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the gas oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4761":{"PGN":64801,"PGN_Name":"Aftertreatment 2 Gas Oxidation Catalyst","PGN_Description":"A2GOC","first_bit":32,"SPN":4761,"SPN_Name":"Aftertreatment 2 Gas Oxidation Catalyst Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of the gas oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4762":{"PGN":64801,"PGN_Name":"Aftertreatment 2 Gas Oxidation Catalyst","PGN_Description":"A2GOC","first_bit":48,"SPN":4762,"SPN_Name":"Aftertreatment 2 Gas Oxidation Catalyst Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst intake gas temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4763":{"PGN":64801,"PGN_Name":"Aftertreatment 2 Gas Oxidation Catalyst","PGN_Description":"A2GOC","first_bit":53,"SPN":4763,"SPN_Name":"Aftertreatment 2 Gas Oxidation Catalyst Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst outlet gas temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4764":{"PGN":64801,"PGN_Name":"Aftertreatment 2 Gas Oxidation Catalyst","PGN_Description":"A2GOC","first_bit":58,"SPN":4764,"SPN_Name":"Aftertreatment 2 Gas Oxidation Catalyst Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the gas oxidation catalyst differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4765":{"PGN":64800,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 1","PGN_Description":"A1DOC1","first_bit":0,"SPN":4765,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the diesel oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4766":{"PGN":64800,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 1","PGN_Description":"A1DOC1","first_bit":16,"SPN":4766,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the diesel oxidation catalyst exhaust in exhaust bank 1.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4767":{"PGN":64800,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 1","PGN_Description":"A1DOC1","first_bit":32,"SPN":4767,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of a diesel oxidation catalyst in exhaust bank 1.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4768":{"PGN":64800,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 1","PGN_Description":"A1DOC1","first_bit":48,"SPN":4768,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4769":{"PGN":64800,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 1","PGN_Description":"A1DOC1","first_bit":53,"SPN":4769,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst outlet gas temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4770":{"PGN":64800,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 1","PGN_Description":"A1DOC1","first_bit":58,"SPN":4770,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4771":{"PGN":64799,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 1","PGN_Description":"A2DOC1","first_bit":0,"SPN":4771,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the diesel oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4772":{"PGN":64799,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 1","PGN_Description":"A2DOC1","first_bit":16,"SPN":4772,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the diesel oxidation catalyst exhaust in exhaust bank 2.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4773":{"PGN":64799,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 1","PGN_Description":"A2DOC1","first_bit":32,"SPN":4773,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Differential Pressure","SPN_Description":"Exhaust differential pressure measured between the intake and exhaust of a diesel oxidation catalyst in exhaust bank 2.  This parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"4774":{"PGN":64799,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 1","PGN_Description":"A2DOC1","first_bit":48,"SPN":4774,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Intake Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst intake temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4775":{"PGN":64799,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 1","PGN_Description":"A2DOC1","first_bit":53,"SPN":4775,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Outlet Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst outlet gas temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by gaseous fuel like natural gas or propane.  A separate parameter has been defined for diesel fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4776":{"PGN":64799,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 1","PGN_Description":"A2DOC1","first_bit":58,"SPN":4776,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Differential Pressure Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the diesel oxidation catalyst differential pressure sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4777":{"PGN":64798,"PGN_Name":"Aftertreatment Differential Temperature 1 ","PGN_Description":"ATDT1","first_bit":0,"SPN":4777,"SPN_Name":"Aftertreatment 1 Gas Oxidation Catalyst Differential Temperature","SPN_Description":"The differential engine combustion byproducts gas temperature measured between the intake and outlet of the gas oxidation catalyst for exhaust bank 1.  This parameter should be used with engine fueled by gaseous fuel like natural gas or propane.  Diesel engines should not use this parameter.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4778":{"PGN":64798,"PGN_Name":"Aftertreatment Differential Temperature 1 ","PGN_Description":"ATDT1","first_bit":16,"SPN":4778,"SPN_Name":"Aftertreatment 2 Gas Oxidation Catalyst Differential Temperature","SPN_Description":"The differential engine combustion byproducts gas temperature measured between the intake and outlet of the gas oxidation catalyst for exhaust bank 2.  This parameter should be used with engine fueled by gaseous fuel like natural gas or propane.  Diesel engines should not use this parameter.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4779":{"PGN":64797,"PGN_Name":"Aftertreatment Differential Temperature 2 ","PGN_Description":"ATDT2","first_bit":0,"SPN":4779,"SPN_Name":"Aftertreatment 1 Three Way Catalyst Differential Temperature","SPN_Description":"The differential engine combustion byproducts gas temperature measured between the intake and outlet of the three way catalyst for exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4780":{"PGN":64797,"PGN_Name":"Aftertreatment Differential Temperature 2 ","PGN_Description":"ATDT2","first_bit":16,"SPN":4780,"SPN_Name":"Aftertreatment 2 Three Way Catalyst Differential Temperature","SPN_Description":"The differential engine combustion byproducts gas temperature measured between the intake and outlet of the three way catalyst for exhaust bank 2.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4781":{"PGN":64796,"PGN_Name":"Diesel Particulate Filter 1 Soot","PGN_Description":"DPF1S","first_bit":0,"SPN":4781,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Mass","SPN_Description":"Soot mass in diesel particulate filter 1.","bit_length":8,"scaling":4,"offset":0,"unit":"g","SLOT_ID":286},"4782":{"PGN":64796,"PGN_Name":"Diesel Particulate Filter 1 Soot","PGN_Description":"DPF1S","first_bit":8,"SPN":4782,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Density","SPN_Description":"Soot density in diesel particulate filter 1.","bit_length":8,"scaling":0.08,"offset":0,"unit":"g/L","SLOT_ID":287},"4783":{"PGN":64796,"PGN_Name":"Diesel Particulate Filter 1 Soot","PGN_Description":"DPF1S","first_bit":16,"SPN":4783,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Mean Soot Signal","SPN_Description":"Mean output signal level from diesel particulate filter 1 soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"4784":{"PGN":64796,"PGN_Name":"Diesel Particulate Filter 1 Soot","PGN_Description":"DPF1S","first_bit":32,"SPN":4784,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Median Soot Signal","SPN_Description":"Median output signal level from diesel particulate filter 1 soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"4785":{"PGN":64796,"PGN_Name":"Diesel Particulate Filter 1 Soot","PGN_Description":"DPF1S","first_bit":48,"SPN":4785,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the soot sensor signal by the manufacturer\u2019s sensor control software in diesel particulate filter 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4786":{"PGN":64795,"PGN_Name":"Diesel Particulate Filter 2 Soot","PGN_Description":"DPF2S","first_bit":0,"SPN":4786,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Mass","SPN_Description":"Soot mass in diesel particulate filter 2.","bit_length":8,"scaling":4,"offset":0,"unit":"g","SLOT_ID":286},"4787":{"PGN":64795,"PGN_Name":"Diesel Particulate Filter 2 Soot","PGN_Description":"DPF2S","first_bit":8,"SPN":4787,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Density","SPN_Description":"Soot density in diesel particulate filter 2.","bit_length":8,"scaling":0.08,"offset":0,"unit":"g/L","SLOT_ID":287},"4788":{"PGN":64795,"PGN_Name":"Diesel Particulate Filter 2 Soot","PGN_Description":"DPF2S","first_bit":16,"SPN":4788,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Mean Soot Signal","SPN_Description":"Mean output signal level from diesel particulate filter 2 soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"4789":{"PGN":64795,"PGN_Name":"Diesel Particulate Filter 2 Soot","PGN_Description":"DPF2S","first_bit":32,"SPN":4789,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Median Soot Signal","SPN_Description":"Median output signal level from diesel particulate filter 2 soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"4790":{"PGN":64795,"PGN_Name":"Diesel Particulate Filter 2 Soot","PGN_Description":"DPF2S","first_bit":48,"SPN":4790,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the soot sensor signal by the manufacturer\u2019s sensor control software in diesel particulate filter 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"4809":{"PGN":64794,"PGN_Name":"Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Information","PGN_Description":"AT1WUDOC","first_bit":0,"SPN":4809,"SPN_Name":"Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Intake Temperature","SPN_Description":"This is the temperature measured at the intake of the warm up oxidation catalytic converter in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4810":{"PGN":64794,"PGN_Name":"Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Information","PGN_Description":"AT1WUDOC","first_bit":16,"SPN":4810,"SPN_Name":"Aftertreatment 1 Warm Up Diesel Oxidation Catalyst Outlet Temperature","SPN_Description":"This is the temperature measured at the outlet of the warm up oxidation catalytic converter in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"4816":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":6,"SPN":4816,"SPN_Name":"Transmission Torque Converter Lockup Transition in Process","SPN_Description":"State signal indicating whether or not the transmission torque converter lock up clutch is transitioning between being applied and being released.  The broadcast value should be set to 01 as soon as an apply or release of the lockup clutch is initiated, and then set to 00 once the given transition is complete.  This parameter is a companion to SPN 573 Transmission Torque Converter Lockup Engaged.\\r\\n\\r\\n00 - Transition is not in process\\r\\n01 - Transition is in process\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4817":{"PGN":64976,"PGN_Name":"Intake/Exhaust Conditions 2","PGN_Description":"IC2","first_bit":40,"SPN":4817,"SPN_Name":"Engine Intake Manifold 1 Absolute Pressure (High Resolution)","SPN_Description":"The absolute pressure measurement of the air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.  This SPN is a high resolution measurement.  See SPN 3563 if high resolution is not needed.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"4818":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":0,"SPN":4818,"SPN_Name":"Driver Airbag Ignitor Loop 1st Stage - Resistance","SPN_Description":"Resistance of Driver Airbag Ignitor Loop 1st Stage.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4819":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":16,"SPN":4819,"SPN_Name":"Passenger Airbag Ignitor Loop 1st Stage - Resistance","SPN_Description":"Resistance of Passenger Airbag Ignitor Loop 1st Stage.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4820":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":32,"SPN":4820,"SPN_Name":"Driver Airbag Ignitor Loop 2nd Stage - Resistance","SPN_Description":"Resistance of Driver Airbag Ignitor Loop 2nd Stage.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4821":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":48,"SPN":4821,"SPN_Name":"Passenger Airbag Ignitor Loop 2nd Stage - Resistance","SPN_Description":"Resistance of Passenger Airbag Ignitor Loop 2nd Stage.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4822":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":64,"SPN":4822,"SPN_Name":"Driver Belt Tensioner Ignitior Loop - Resistance","SPN_Description":"Resistance of Driver Belt Tensioner Ignitor Loop 1st Stage.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4823":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":80,"SPN":4823,"SPN_Name":"Passenger Belt Tensioner Ignitor Loop - Resistance","SPN_Description":"Resistance of Passenger Belt Tensioner Ignitor Loop 1st Stage.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4824":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":96,"SPN":4824,"SPN_Name":"Side Bag Ignitor Loop 1 - Left - Resistance","SPN_Description":"Resistance of Side Bag Ignitor Loop 1 - Left.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4825":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":112,"SPN":4825,"SPN_Name":"Side Bag Ignitor Loop 2 - Left - Resistance","SPN_Description":"Resistance of Side Bag Ignitor Loop 2 - Left.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4826":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":128,"SPN":4826,"SPN_Name":"Side Bag Ignitor Loop 1 - Right - Resistance","SPN_Description":"Resistance of Side Bag Ignitor Loop 1 - Right.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4827":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":144,"SPN":4827,"SPN_Name":"Side Bag Ignitor Loop 2 - Right - Resistance","SPN_Description":"Resistance of Side Bag Ignitor Loop 2 - Right.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4828":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":160,"SPN":4828,"SPN_Name":"Special Ignitor Loop 1 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 1.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4829":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":176,"SPN":4829,"SPN_Name":"Special Ignitor Loop 2 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 2.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4830":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":192,"SPN":4830,"SPN_Name":"Special Ignitor Loop 3 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 3.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4831":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":208,"SPN":4831,"SPN_Name":"Special Ignitor Loop 4 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 4.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4832":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":224,"SPN":4832,"SPN_Name":"Special Ignitor Loop 5 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 5.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4833":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":240,"SPN":4833,"SPN_Name":"Special Ignitor Loop 6 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 6.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4834":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":256,"SPN":4834,"SPN_Name":"Special Ignitor Loop 7 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 7.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4835":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":272,"SPN":4835,"SPN_Name":"Special Ignitor Loop 8 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 8.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4836":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":288,"SPN":4836,"SPN_Name":"Special Ignitor Loop 9 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 9.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4837":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":304,"SPN":4837,"SPN_Name":"Special Ignitor Loop 10 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 10.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4838":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":320,"SPN":4838,"SPN_Name":"Special Ignitor Loop 11 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 11.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4839":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":336,"SPN":4839,"SPN_Name":"Special Ignitor Loop 12 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 12.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4840":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":352,"SPN":4840,"SPN_Name":"Special Ignitor Loop 13 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 13.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4841":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":368,"SPN":4841,"SPN_Name":"Special Ignitor Loop 14 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 14.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4842":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":384,"SPN":4842,"SPN_Name":"Special Ignitor Loop 15 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 15.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4843":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":400,"SPN":4843,"SPN_Name":"Special Ignitor Loop 16 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 16.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4844":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":416,"SPN":4844,"SPN_Name":"Special Ignitor Loop 17 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 17.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4845":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":432,"SPN":4845,"SPN_Name":"Special Ignitor Loop 18 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 18.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4846":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":448,"SPN":4846,"SPN_Name":"Special Ignitor Loop 19 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 19.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4847":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":464,"SPN":4847,"SPN_Name":"Special Ignitor Loop 20 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 20.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4848":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":480,"SPN":4848,"SPN_Name":"Special Ignitor Loop 21 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 21.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4849":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":496,"SPN":4849,"SPN_Name":"Special Ignitor Loop 22 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 22.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4850":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":512,"SPN":4850,"SPN_Name":"Special Ignitor Loop 23 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 23.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4851":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":528,"SPN":4851,"SPN_Name":"Special Ignitor Loop 24 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 24.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4852":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":544,"SPN":4852,"SPN_Name":"Special Ignitor Loop 25 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 25.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4853":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":560,"SPN":4853,"SPN_Name":"Special Ignitor Loop 26 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 26.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4854":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":576,"SPN":4854,"SPN_Name":"Special Ignitor Loop 27 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 27.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4855":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":592,"SPN":4855,"SPN_Name":"Special Ignitor Loop 28 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 28.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4856":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":608,"SPN":4856,"SPN_Name":"Special Ignitor Loop 29 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 29.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4857":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":624,"SPN":4857,"SPN_Name":"Special Ignitor Loop 30 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 30.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4858":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":640,"SPN":4858,"SPN_Name":"Special Ignitor Loop 31 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 31.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4859":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":656,"SPN":4859,"SPN_Name":"Special Ignitor Loop 32 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 32.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4860":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":672,"SPN":4860,"SPN_Name":"Special Ignitor Loop 33 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 33.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4861":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":688,"SPN":4861,"SPN_Name":"Special Ignitor Loop 34 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 34.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4862":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":704,"SPN":4862,"SPN_Name":"Special Ignitor Loop 35 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 35.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4863":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":720,"SPN":4863,"SPN_Name":"Special Ignitor Loop 36 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 36.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4864":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":736,"SPN":4864,"SPN_Name":"Special Ignitor Loop 37 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 37.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4865":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":752,"SPN":4865,"SPN_Name":"Special Ignitor Loop 38 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 38.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4866":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":768,"SPN":4866,"SPN_Name":"Special Ignitor Loop 39 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 39.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4867":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":784,"SPN":4867,"SPN_Name":"Special Ignitor Loop 40 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 40.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4868":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":800,"SPN":4868,"SPN_Name":"Special Ignitor Loop 41 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 41.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4869":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":816,"SPN":4869,"SPN_Name":"Special Ignitor Loop 42 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 42.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4870":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":832,"SPN":4870,"SPN_Name":"Special Ignitor Loop 43 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 43.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4871":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":848,"SPN":4871,"SPN_Name":"Special Ignitor Loop 44 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 44.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4872":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":864,"SPN":4872,"SPN_Name":"Special Ignitor Loop 45 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 45.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4873":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":880,"SPN":4873,"SPN_Name":"Special Ignitor Loop 46 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 46.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4874":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":896,"SPN":4874,"SPN_Name":"Special Ignitor Loop 47 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 47.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4875":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":912,"SPN":4875,"SPN_Name":"Special Ignitor Loop 48 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 48.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4876":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":928,"SPN":4876,"SPN_Name":"Special Ignitor Loop 49 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 49.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4877":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":944,"SPN":4877,"SPN_Name":"Special Ignitor Loop 50 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 50.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4878":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":960,"SPN":4878,"SPN_Name":"Special Ignitor Loop 51 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 51.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4879":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":976,"SPN":4879,"SPN_Name":"Special Ignitor Loop 52 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 52.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4880":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":992,"SPN":4880,"SPN_Name":"Special Ignitor Loop 53 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 53.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4881":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1008,"SPN":4881,"SPN_Name":"Special Ignitor Loop 54 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 54.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4882":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1024,"SPN":4882,"SPN_Name":"Special Ignitor Loop 55 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 55.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4883":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1040,"SPN":4883,"SPN_Name":"Special Ignitor Loop 56 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 56.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4884":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1056,"SPN":4884,"SPN_Name":"Special Ignitor Loop 57 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 57.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4885":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1072,"SPN":4885,"SPN_Name":"Special Ignitor Loop 58 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 58.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4886":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1088,"SPN":4886,"SPN_Name":"Special Ignitor Loop 59 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 59.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4887":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1104,"SPN":4887,"SPN_Name":"Special Ignitor Loop 60 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 60.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4888":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1120,"SPN":4888,"SPN_Name":"Special Ignitor Loop 61 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 61.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4889":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1136,"SPN":4889,"SPN_Name":"Special Ignitor Loop 62 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 62.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4890":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1152,"SPN":4890,"SPN_Name":"Special Ignitor Loop 63 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 63.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4891":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1168,"SPN":4891,"SPN_Name":"Special Ignitor Loop 64 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 64.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4892":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1184,"SPN":4892,"SPN_Name":"Special Ignitor Loop 65 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 65.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4893":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1200,"SPN":4893,"SPN_Name":"Special Ignitor Loop 66 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 66.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4894":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1216,"SPN":4894,"SPN_Name":"Special Ignitor Loop 67 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 67.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4895":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1232,"SPN":4895,"SPN_Name":"Special Ignitor Loop 68 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 68.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4896":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1248,"SPN":4896,"SPN_Name":"Special Ignitor Loop 69 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 69.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4897":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1264,"SPN":4897,"SPN_Name":"Special Ignitor Loop 70 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 70.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4898":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1280,"SPN":4898,"SPN_Name":"Special Ignitor Loop 71 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 71.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4899":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1296,"SPN":4899,"SPN_Name":"Special Ignitor Loop 72 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 72.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4900":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1312,"SPN":4900,"SPN_Name":"Special Ignitor Loop 73 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 73.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4901":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1328,"SPN":4901,"SPN_Name":"Special Ignitor Loop 74 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 74.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4902":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1344,"SPN":4902,"SPN_Name":"Special Ignitor Loop 75 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 75.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4903":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1360,"SPN":4903,"SPN_Name":"Special Ignitor Loop 76 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 76.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4904":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1376,"SPN":4904,"SPN_Name":"Special Ignitor Loop 77 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 77.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4905":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1392,"SPN":4905,"SPN_Name":"Special Ignitor Loop 78 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 78.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4906":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1408,"SPN":4906,"SPN_Name":"Special Ignitor Loop 79 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 79.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4907":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1424,"SPN":4907,"SPN_Name":"Special Ignitor Loop 80 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 80.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4908":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1440,"SPN":4908,"SPN_Name":"Special Ignitor Loop 81 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 81.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4909":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1456,"SPN":4909,"SPN_Name":"Special Ignitor Loop 82 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 82.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4910":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1472,"SPN":4910,"SPN_Name":"Special Ignitor Loop 83 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 83.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4911":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1488,"SPN":4911,"SPN_Name":"Special Ignitor Loop 84 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 84.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4912":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1504,"SPN":4912,"SPN_Name":"Special Ignitor Loop 85 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 85.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4913":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1520,"SPN":4913,"SPN_Name":"Special Ignitor Loop 86 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 86.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4914":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1536,"SPN":4914,"SPN_Name":"Special Ignitor Loop 87 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 87.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4915":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1552,"SPN":4915,"SPN_Name":"Special Ignitor Loop 88 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 88.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4916":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1568,"SPN":4916,"SPN_Name":"Special Ignitor Loop 89 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 89.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4917":{"PGN":64793,"PGN_Name":"Ignitor Loop Information","PGN_Description":"ILI","first_bit":1584,"SPN":4917,"SPN_Name":"Special Ignitor Loop 90 - Resistance","SPN_Description":"Resistance of Special Ignitor Loop 90.   Since there are many different vehicle types (e.g. truck, bus, firetruck or ambulance), the ignitor loop configuration has a wide variation. ","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"4918":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":0,"SPN":4918,"SPN_Name":"Frontal Collision Sensor 1 - Type","SPN_Description":"Type of Frontal Collision Sensor 1.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4919":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":4,"SPN":4919,"SPN_Name":"Frontal Collision Sensor 2 - Type","SPN_Description":"Type of Frontal Collision Sensor 2.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4920":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":8,"SPN":4920,"SPN_Name":"Frontal Collision Sensor 3 - Type","SPN_Description":"Type of Frontal Collision Sensor 3.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4921":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":12,"SPN":4921,"SPN_Name":"Frontal Collision Sensor 4 - Type","SPN_Description":"Type of Frontal Collision Sensor 4.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4922":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":16,"SPN":4922,"SPN_Name":"Side Collision Sensor Front Left - Type","SPN_Description":"Type of Side Collision Sensor Front - Left.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4923":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":20,"SPN":4923,"SPN_Name":"Side Collision Sensor Mid Front Left - Type","SPN_Description":"Type of Side Collision Sensor Mid Front - Left.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4924":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":24,"SPN":4924,"SPN_Name":"Side Collision Sensor Mid Rear Left - Type","SPN_Description":"Type of Side Collision Sensor Mid Rear - Left.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4925":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":28,"SPN":4925,"SPN_Name":"Side Collision Sensor Rear Left - Type","SPN_Description":"Type of Side Collision Sensor Rear - Left.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4926":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":32,"SPN":4926,"SPN_Name":"Side Collision Sensor Front Right - Type","SPN_Description":"Type of Side Collision Sensor Front - Right.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4927":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":36,"SPN":4927,"SPN_Name":"Side Collision Sensor Mid Front Right - Type","SPN_Description":"Type of Side Collision Sensor Mid Front - Right.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4928":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":40,"SPN":4928,"SPN_Name":"Side Collision Sensor Mid Rear Right - Type","SPN_Description":"Type of Side Collision Sensor Mid Rear - Right.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4929":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":44,"SPN":4929,"SPN_Name":"Side Collision Sensor Rear Right - Type","SPN_Description":"Type of Side Collision Sensor Rear - Right.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4930":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":48,"SPN":4930,"SPN_Name":"Rear Collision Sensor 1 - Type","SPN_Description":"Type of Rear Collision Sensor 1.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4931":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":52,"SPN":4931,"SPN_Name":"Rear Collision Sensor 2 - Type","SPN_Description":"Type of Rear Collision Sensor 2.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4932":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":56,"SPN":4932,"SPN_Name":"Rear Collision Sensor 3 - Type","SPN_Description":"Type of Rear Collision Sensor 3.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4933":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":60,"SPN":4933,"SPN_Name":"Rear Collision Sensor 4 - Type","SPN_Description":"Type of Rear Collision Sensor 4.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4934":{"PGN":64792,"PGN_Name":"Collision Sensor Information","PGN_Description":"CSI","first_bit":64,"SPN":4934,"SPN_Name":"Rollover Sensor - Type","SPN_Description":"Type of Rollover Sensor.\\r\\n\\r\\n0000 = acceleration sensor\\r\\n0001 = pressure sensor\\r\\n0010 = rollrate sensor\\r\\n0011 = sonic sensor\\r\\n0100 = fiber-optic sensor\\r\\n0101 = radar sensor\\r\\n0110 = lidar sensor\\r\\n0111 = optical sensor\\r\\n1000-1101 =  Reserved\\r\\n1110 = Error - Type of sensor cannot be determined (unknown sensor)\\r\\n1111 = not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4952":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":0,"SPN":4952,"SPN_Name":"Driver Beltlock Status","SPN_Description":"State of switch used to determine if Driver Beltlock is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4953":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":2,"SPN":4953,"SPN_Name":"Passenger Beltlock Status","SPN_Description":"State of switch used to determine if Passenger Beltlock is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4954":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":4,"SPN":4954,"SPN_Name":"Beltlock 3 Status","SPN_Description":"State of switch used to determine if Beltlock 3 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4955":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":6,"SPN":4955,"SPN_Name":"Beltlock 4 Status","SPN_Description":"State of switch used to determine if Beltlock 4 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4956":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":8,"SPN":4956,"SPN_Name":"Beltlock 5 Status","SPN_Description":"State of switch used to determine if Beltlock 5 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4957":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":10,"SPN":4957,"SPN_Name":"Beltlock 6 Status","SPN_Description":"State of switch used to determine if Beltlock 6 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4958":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":12,"SPN":4958,"SPN_Name":"Beltlock 7 Status","SPN_Description":"State of switch used to determine if Beltlock 7 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4959":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":14,"SPN":4959,"SPN_Name":"Beltlock 8 Status","SPN_Description":"State of switch used to determine if Beltlock 8 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4960":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":16,"SPN":4960,"SPN_Name":"Beltlock 9 Status","SPN_Description":"State of switch used to determine if Beltlock 9 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4961":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":18,"SPN":4961,"SPN_Name":"Beltlock 10 Status","SPN_Description":"State of switch used to determine if Beltlock 10 is buckled.\\r\\n\\r\\n00 = unlocked\\r\\n01 = locked\\r\\n10 = Error - Beltlock state cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4962":{"PGN":64791,"PGN_Name":"Beltlock and Airbag Deactivation Switch Information","PGN_Description":"BDS","first_bit":20,"SPN":4962,"SPN_Name":"Passenger Airbag Deactivation Switch Status","SPN_Description":"State of switch used to deactivate Passenger Airbag manually.\\r\\n\\r\\n00 = passenger airbag activated\\r\\n01 = passenger airbag deactivated\\r\\n10 = Error - State of deactivation switch cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4963":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":0,"SPN":4963,"SPN_Name":"Driver Occupant Classification System Status","SPN_Description":"State of Occupant Classification System for driver.\\r\\n\\r\\n000 = empty\\r\\n001 = child\\r\\n010 = small adult\\r\\n011 = adult\\r\\n100 = large adult\\r\\n101 = reserved\\r\\n110 = Error - Classification of occupant cannot be determined\\r\\n111 = not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4964":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":3,"SPN":4964,"SPN_Name":"Passenger Occupant Classification System Status","SPN_Description":"State of Occupant Classification System for passenger.\\r\\n\\r\\n000 = empty\\r\\n001 = child\\r\\n010 = small adult\\r\\n011 = adult\\r\\n100 = large adult\\r\\n101 = Error - Classification of occupant cannot be determined\\r\\n110 = reserved\\r\\n111 = not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"4965":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":8,"SPN":4965,"SPN_Name":"Occupant Classification System 3 Status","SPN_Description":"State of Occupant Classification System for seat position 3.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4966":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":10,"SPN":4966,"SPN_Name":"Occupant Classification System 4 Status","SPN_Description":"State of Occupant Classification System for seat position 4.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4967":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":12,"SPN":4967,"SPN_Name":"Occupant Classification System 5 Status","SPN_Description":"State of Occupant Classification System for seat position 5.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4968":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":14,"SPN":4968,"SPN_Name":"Occupant Classification System 6 Status","SPN_Description":"State of Occupant Classification System for seat position 6.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4969":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":16,"SPN":4969,"SPN_Name":"Occupant Classification System 7 Status","SPN_Description":"State of Occupant Classification System for seat position 7.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4970":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":18,"SPN":4970,"SPN_Name":"Occupant Classification System 8 Status","SPN_Description":"State of Occupant Classification System for seat position 8.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4971":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":20,"SPN":4971,"SPN_Name":"Occupant Classification System 9 Status","SPN_Description":"State of Occupant Classification System for seat position 9.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4972":{"PGN":64790,"PGN_Name":"Occupant Classification System Information","PGN_Description":"OCSI","first_bit":22,"SPN":4972,"SPN_Name":"Occupant Classification System 10 Status","SPN_Description":"State of Occupant Classification System for seat position 10.\\r\\n\\r\\n00 = empty\\r\\n01 = occupied\\r\\n10 = Error - Classification cannot be determined\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4973":{"PGN":61483,"PGN_Name":"Crash Notification","PGN_Description":"CN","first_bit":0,"SPN":4973,"SPN_Name":"Crash Type","SPN_Description":"Type of crash event. \\r\\n\\r\\n00001 = frontal crash\\r\\n00010 = rear crash\\r\\n00100 = side crash (left)\\r\\n01000 = side crash (right)\\r\\n10000 = rollover\\r\\n\\r\\nIt is possible to combine different Crash Types. (e.g. frontal and side crash (left) = 00101)","bit_length":5,"scaling":5,"offset":0,"unit":"bit-mapped","SLOT_ID":292},"4974":{"PGN":61483,"PGN_Name":"Crash Notification","PGN_Description":"CN","first_bit":56,"SPN":4974,"SPN_Name":"Crash Counter","SPN_Description":"The Crash Counter prevents other ECUs from reacting to a faulty transmission of the Crash Notification PGN and serves as a safety mechanism. The Crash Counter becomes incremented by 1 for every sent message, starting with \\"0\\". (0 follows 15)","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"4975":{"PGN":61483,"PGN_Name":"Crash Notification","PGN_Description":"CN","first_bit":60,"SPN":4975,"SPN_Name":"Crash Checksum","SPN_Description":"The Crash Checksum is used to verify the signal path from the airbag ECU to other devices in case of a crash.\\r\\n\\r\\nThe 4 bit checksum is the sum of the high nibble and the low nibble of the sum of the identifier, the first 7 data bytes and the 4 bit message counter. It is calculated as follows:\\r\\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\\r\\n\\r\\nChecksum = ((Checksum >> 4) + Checksum) & 0x0F","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"4976":{"PGN":61481,"PGN_Name":"Slope Sensor Information 2","PGN_Description":"SSI2","first_bit":0,"SPN":4976,"SPN_Name":"Pitch Angle (Extended Range)","SPN_Description":"The angle between the vehicle x-axis and the ground plane (i.e. rotation about the vehicle Y-axis).  The pitch angle for an angle of ascent is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 3318 for an alternate range and resolution.","bit_length":24,"scaling":0.000030517578125,"offset":-250,"unit":"deg","SLOT_ID":294},"4977":{"PGN":61481,"PGN_Name":"Slope Sensor Information 2","PGN_Description":"SSI2","first_bit":24,"SPN":4977,"SPN_Name":"Roll Angle (Extended Range)","SPN_Description":"The angle between the vehicle y-axis and the ground plane (i.e. rotation about the X-axis).  The roll angle for a roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  See SPN 3319 for an alternate range and resolution.","bit_length":24,"scaling":0.000030517578125,"offset":-250,"unit":"deg","SLOT_ID":294},"4978":{"PGN":61481,"PGN_Name":"Slope Sensor Information 2","PGN_Description":"SSI2","first_bit":48,"SPN":4978,"SPN_Name":"Pitch Angle Compensation (Extended Range)","SPN_Description":"Compensated mode for the pitch measurement.  Compensation is the use of multiple sensors together to enhance the output of the pitch measurement.\\r\\n\\r\\n00 = On\\r\\n01 = Off\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4979":{"PGN":61481,"PGN_Name":"Slope Sensor Information 2","PGN_Description":"SSI2","first_bit":50,"SPN":4979,"SPN_Name":"Pitch Angle Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for pitch angle measurement.\\r\\n\\r\\n00 = Pitch angle fully functional. Data is within sensor specification.\\r\\n01 = Pitch angle degraded. Data is suspect due to environmental conditions.\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4980":{"PGN":61481,"PGN_Name":"Slope Sensor Information 2","PGN_Description":"SSI2","first_bit":52,"SPN":4980,"SPN_Name":"Roll Angle Compensation (Extended Range)","SPN_Description":"Compensated mode for the roll angle measurement.  Compensation is the use of multiple sensors together to enhance the output of the roll angle measurement.\\r\\n\\r\\n00 = On\\r\\n01 = Off\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4981":{"PGN":61481,"PGN_Name":"Slope Sensor Information 2","PGN_Description":"SSI2","first_bit":54,"SPN":4981,"SPN_Name":"Roll Angle Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for roll angle measurement.\\r\\n\\r\\n00 = Roll angle fully functional. Data is within sensor specification.\\r\\n01 = Roll angle degraded. Data is suspect due to environmental conditions.\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4982":{"PGN":61481,"PGN_Name":"Slope Sensor Information 2","PGN_Description":"SSI2","first_bit":56,"SPN":4982,"SPN_Name":"Roll and Pitch Measurement Latency (Extended Range)","SPN_Description":"Time between start of sensor processing and CAN transmission","bit_length":8,"scaling":0.5,"offset":0,"unit":"ms","SLOT_ID":241},"4983":{"PGN":61482,"PGN_Name":"Angular Rate Information","PGN_Description":"ARI","first_bit":0,"SPN":4983,"SPN_Name":"Pitch Rate (Extended Range)","SPN_Description":"Pitch rate is the rate-of-change of the pitch angle over time, where the pitch angle vector is in the direction of travel of the vehicle. The pitch rate for increasing ascent over time is reported with a positive value. This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 3322 for an alternate range and resolution.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg/s","SLOT_ID":288},"4984":{"PGN":61482,"PGN_Name":"Angular Rate Information","PGN_Description":"ARI","first_bit":16,"SPN":4984,"SPN_Name":"Roll Rate (Extended Range)","SPN_Description":"Roll rate is the rate-of-change of the roll angle over time.  The roll rate for increasing roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg/s","SLOT_ID":288},"4985":{"PGN":61482,"PGN_Name":"Angular Rate Information","PGN_Description":"ARI","first_bit":32,"SPN":4985,"SPN_Name":"Yaw Rate (Extended Range)","SPN_Description":"Yaw rate is the rate-of-change of the yaw angle over time.  A positive yaw rate signal results when the object turns clockwise.  This parameter is defined according to a Z-Down axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Down Axis System has positive X directed forward, positive Y to the right, and positive Z directed down.  See SPN 1808 for Yaw Rate with an alternate range and resolution using a Z-Up Axis System.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg/s","SLOT_ID":288},"4986":{"PGN":61482,"PGN_Name":"Angular Rate Information","PGN_Description":"ARI","first_bit":48,"SPN":4986,"SPN_Name":"Pitch Rate Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for pitch rate measurement.\\r\\n\\r\\n00 = Pitch rate fully functional. Data is within sensor specification.\\r\\n01 = Pitch rate degraded. Data is suspect due to environmental conditions.\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4987":{"PGN":61482,"PGN_Name":"Angular Rate Information","PGN_Description":"ARI","first_bit":50,"SPN":4987,"SPN_Name":"Roll Rate Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for roll rate measurement.\\r\\n\\r\\n00 = Roll rate fully functional. Data is within sensor specification.\\r\\n01 = Roll rate degraded. Data is suspect due to environmental conditions.\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4988":{"PGN":61482,"PGN_Name":"Angular Rate Information","PGN_Description":"ARI","first_bit":52,"SPN":4988,"SPN_Name":"Yaw Rate Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for yaw angle measurement.\\r\\n\\r\\n00 = Yaw rate fully functional. Data is within sensor specification.\\r\\n01 = Yaw rate degraded. Data is suspect due to environmental conditions.\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4989":{"PGN":61482,"PGN_Name":"Angular Rate Information","PGN_Description":"ARI","first_bit":56,"SPN":4989,"SPN_Name":"Angular Rate Measurement Latency","SPN_Description":"The estimated measurement latency of the measurement.\\r\\n\\r\\nNOTE: This is only the sensor latency and does not include any additional latencies that might exist because of the CAN Bus or overall system implementation. Latency is the time from sensor readings to the queuing of the message data for CAN transmission.","bit_length":8,"scaling":0.5,"offset":0,"unit":"ms","SLOT_ID":241},"4990":{"PGN":64789,"PGN_Name":"Battery Charger 1","PGN_Description":"BCH1","first_bit":0,"SPN":4990,"SPN_Name":"Battery Charger 1 State","SPN_Description":"A state of the battery charger connected to the main battery.  \\r\\n\\r\\n0 - Idling. The power line or the battery is disconnected from the charger.\\r\\n1 - Charging the battery.\\r\\n2 - Stand-by or maintaining the battery charge.\\r\\n3 to 12 - Reserved\\r\\n13 - Battery failure. An error condition due to the battery state (high temperature, etc.)\\r\\n14 - Charger failure. An error condition due to the charger state.\\r\\n15 - Not available.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4991":{"PGN":64789,"PGN_Name":"Battery Charger 1","PGN_Description":"BCH1","first_bit":4,"SPN":4991,"SPN_Name":"Battery Charger 1 Power Line State","SPN_Description":"A state of the battery charger connection to the power line for the charger connected to the main battery.\\r\\n\\r\\n0 - Disconnected. The power line is disconnected from the charger.\\r\\n1 - Connected. The power line is connected to the charger.\\r\\n2 - Error\\r\\n3 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4992":{"PGN":64789,"PGN_Name":"Battery Charger 1","PGN_Description":"BCH1","first_bit":8,"SPN":4992,"SPN_Name":"Battery Charger 1 Output Voltage","SPN_Description":"Output voltage measured on the battery terminals of the battery charger connected to the main battery.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"4993":{"PGN":64789,"PGN_Name":"Battery Charger 1","PGN_Description":"BCH1","first_bit":24,"SPN":4993,"SPN_Name":"Battery Charger 1 Output Current","SPN_Description":"Output current of the battery charger connected to the main battery. If positive, this parameter shows the charging current of the battery charger connected to the main battery.  Otherwise, if the charger hardware permits, this parameter represents the current consumed by the battery charger ECU from the main battery.","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"4994":{"PGN":64788,"PGN_Name":"Battery Charger 2","PGN_Description":"BCH2","first_bit":0,"SPN":4994,"SPN_Name":"Battery Charger 2 State","SPN_Description":"A state of the offline battery charger connected to the auxiliary battery. \\r\\n\\r\\n0 - Idling. The power line or the battery is disconnected from the charger.\\r\\n1 - Charging the battery.\\r\\n2 - Stand-by or maintaining the battery charge.\\r\\n3 to 12 - Reserved\\r\\n13 - Battery failure. An error condition due to the battery state (high temperature, etc.)\\r\\n14 - Charger failure. An error condition due to the charger state.\\r\\n15 - Not available.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"4995":{"PGN":64788,"PGN_Name":"Battery Charger 2","PGN_Description":"BCH2","first_bit":4,"SPN":4995,"SPN_Name":"Battery Charger 2 Power Line State","SPN_Description":"A state of the battery charger connection to the power line for the charger connected to the auxiliary battery.\\r\\n\\r\\n0 - Disconnected. The power line is disconnected from the charger.\\r\\n1 - Connected. The power line is connected to the charger.\\r\\n2 - Error\\r\\n3 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"4996":{"PGN":64788,"PGN_Name":"Battery Charger 2","PGN_Description":"BCH2","first_bit":8,"SPN":4996,"SPN_Name":"Battery Charger 2 Output Voltage","SPN_Description":"Output voltage measured on the battery terminals of the offline battery charger connected to the auxiliary battery.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"4997":{"PGN":64788,"PGN_Name":"Battery Charger 2","PGN_Description":"BCH2","first_bit":24,"SPN":4997,"SPN_Name":"Battery Charger 2 Output Current","SPN_Description":"Output current of the battery charger connected to the main battery. If positive, this parameter shows the charging current of the battery charger connected to the main battery.  Otherwise, if the charger hardware permits, this parameter represents the current consumed by the battery charger ECU from the main battery.","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"4998":{"PGN":64787,"PGN_Name":"Magnet System Configuration Information","PGN_Description":"MSCI","first_bit":0,"SPN":4998,"SPN_Name":"Magnet Boost Time","SPN_Description":"The duration of time after the activation of the magnet circuit that a relatively high current is sent to the magnet for material pick up operations. This time is called boost time. After the boost time expires, a lower operation current is sent to the magnet to hold the material.","bit_length":8,"scaling":0.25,"offset":0,"unit":"s","SLOT_ID":63},"4999":{"PGN":64787,"PGN_Name":"Magnet System Configuration Information","PGN_Description":"MSCI","first_bit":8,"SPN":4999,"SPN_Name":"Magnet Rated Power","SPN_Description":"The rated power that the magnet can accept during material holding operations.  Note that the magnet may experience more power over short intervals, such as during initial activation of the magnet circuit to pick up material.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"5000":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":0,"SPN":5000,"SPN_Name":"Generator Overheat Status","SPN_Description":"The Status of Generator being Overheated.\\r\\n\\r\\n00 = Not Overheat\\r\\n01 = Overheat\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5001":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":2,"SPN":5001,"SPN_Name":"Genset System Output Voltage Range Status","SPN_Description":"Status of generator voltage in or out of desired operating range.\\r\\n\\r\\n00 = Out of Range \\r\\n01 = In Range\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5002":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":8,"SPN":5002,"SPN_Name":"Reverse Current Range Setting","SPN_Description":"The operator setting for the Reverse Current. The setting defines the maximum reverse current. The actual current limits are specific to the application.\\r\\n\\r\\n00000 = 1\\r\\n00001 = 2\\r\\n00010 = 3\\r\\n00011 = 4\\r\\n00100 = 5\\r\\n00101 = 6\\r\\n00110 = 7\\r\\n00111 = 8\\r\\n01000 = 9\\r\\n01001 = 10\\r\\n01010 =11\\r\\n01011 =12\\r\\n01100 = 13\\r\\n01101 = 14\\r\\n01110 = 15\\r\\n01111 = 16\\r\\n10000-11101 = Not used\\r\\n11110 = Error\\r\\n11111 = Not Available","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"5003":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":4,"SPN":5003,"SPN_Name":"Grapple/Magnet Selection Switch","SPN_Description":"This is a switch that can be used to select either the Grapple or Magnet function of the material handler machine.\\r\\n\\r\\n00 = Grapple Selected\\r\\n01 = Magnet Selected\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5004":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":6,"SPN":5004,"SPN_Name":"Genset Softstart Active Status","SPN_Description":"The Genset Softstart Active Status refers to the status of the genset softstart relay. The moment the Genset System is started, this relay is activated. As a result, the hydraulic power is hold on for a short period of time, and this relay will be turned off once the genset hydraulic power become stable.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5005":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":16,"SPN":5005,"SPN_Name":"Genset Enable Active Status","SPN_Description":"Status of the Genset Enable Relay that enables or disables the Genset.\\r\\n\\r\\n00 = Not Enabled\\r\\n01 = Enabled\\r\\n10 = Error\\r\\n11 = Not Avaialble","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5006":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":18,"SPN":5006,"SPN_Name":"Voltage Monitor Active Status","SPN_Description":"Status of Voltage Monitor Relay. When it is activated, the Generator Voltage Monitor is connected to the generator output line so that the generator output voltage range could be monitored.\\r\\n\\r\\n00 = Monitor is Off\\r\\n01 = Monitor is On\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5007":{"PGN":64786,"PGN_Name":"Magnet Status Information 1","PGN_Description":"MSI1","first_bit":20,"SPN":5007,"SPN_Name":"Generator Duty Cycle Exceeded Status","SPN_Description":"The status of the duty cycle of the generator usage, indicating if the generator has been on for too much time within a defined time window.  The duty cycle is the ratio of the time the generator is on and the time the generator is off within a time window.\\r\\n\\r\\n00 = Duty Cycle Not Exceed\\r\\n01 = Duty Cycle Exceed\\r\\n10 = Error\\r\\n11 = Not Avaiable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5008":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":0,"SPN":5008,"SPN_Name":"Magnet Forward Current","SPN_Description":"The forward current being supplied by the generator to the electric magnet to create a magnet field to lift material.","bit_length":16,"scaling":1,"offset":0,"unit":"A","SLOT_ID":146},"5009":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":16,"SPN":5009,"SPN_Name":"Magnet Reverse Current","SPN_Description":"A reverse current being supplied to the electric magnet to reduce the forward current generated magnet field as quick as possible so that the magnet can release material as fast as possible.","bit_length":8,"scaling":1,"offset":0,"unit":"A","SLOT_ID":41},"5010":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":24,"SPN":5010,"SPN_Name":"Material Lift Switch","SPN_Description":"This is a switch that can be used to enable the lift functionality of the Material Handler machine. When it is activated, the magnet is energized to pick up material.\\r\\n\\r\\n00 = Don\'t Lift\\r\\n01 = Lift\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5011":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":26,"SPN":5011,"SPN_Name":"Material Drop Switch","SPN_Description":"This is a switch that can be used to enable the drop functionality of the Material Handler machine.\\r\\n\\r\\n00 = Don\'t Drop\\r\\n01 = Drop\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5012":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":28,"SPN":5012,"SPN_Name":"Generator Current Boost Active Status","SPN_Description":"Status of generator current boost relay that can boost the generator output current for picking-up material operations. When this relay is \\"on\\", the generator is generating the maximum current for the material handler machine to pick-up material. When the relay is off, the genetator is generating normal current for the material handler machine to hold material.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5013":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":30,"SPN":5013,"SPN_Name":"Material Lift Active Status","SPN_Description":"The status of Material Lift Relay. When it is on, the generator generates forward direction current so that the material handler machine can pick up material.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5014":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":32,"SPN":5014,"SPN_Name":"Material Drop Active Status","SPN_Description":"The status of Material Drop Relay. When it is on, the generator generates reverse direction current so that the material handler machine can release material.\\r\\n\\r\\n00 = Off\\r\\n01 = On\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5015":{"PGN":61442,"PGN_Name":"Electronic Transmission Controller 1","PGN_Description":"ETC1","first_bit":36,"SPN":5015,"SPN_Name":"Momentary Engine Maximum Power Enable","SPN_Description":"Momentarily Requesting highest torque map from the engine control\\r\\n\\r\\n00 not requesting maximum power available\\r\\n01 momentarily requesting maximum power available\\r\\n10 fault\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5019":{"PGN":64961,"PGN_Name":"Engine Fluid Level/Pressure 3","PGN_Description":"EFL/P3","first_bit":40,"SPN":5019,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Outlet Pressure","SPN_Description":"EGR outlet pressure is measured immediately after the EGR valve.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5020":{"PGN":64870,"PGN_Name":"Engine Temperature 4","PGN_Description":"ET4","first_bit":40,"SPN":5020,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Mixer Intake Temperature","SPN_Description":"The temperature of the EGR gas entering the intake mixer, measured after the intake throttle when provided.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5021":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":42,"SPN":5021,"SPN_Name":"Momentary Engine Maximum Power Enable Feedback","SPN_Description":"Momentarily requesting Engine Maximum Power Enable - feature support feedback\\r\\n\\r\\n00 disabled\\r\\n01 supported \\r\\n10 reserved\\r\\n11 don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5022":{"PGN":65135,"PGN_Name":"Adaptive Cruise Control 1","PGN_Description":"ACC1","first_bit":54,"SPN":5022,"SPN_Name":"Forward Collision Warning","SPN_Description":"This parameter indicates if a collision is imminent and strong driver reaction either by braking hard or by an avoidance maneuver are imperative to prevent a collision.  \\r\\n\\r\\n00 No warning\\r\\n01 Collision is imminent\\r\\n10 Error indicator\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5023":{"PGN":65105,"PGN_Name":"Adaptive Cruise Control, Operator Input","PGN_Description":"ACC2","first_bit":0,"SPN":5023,"SPN_Name":"ACC usage demand","SPN_Description":"This parameter indicates the drivers demand to activate or deactivate ACC keeping distance control.\\r\\n\\r\\n00 driver demand for not using ACC distance keeping control\\r\\n01 driver demand for using ACC distance keeping control\\r\\n10 reserved\\r\\n11 don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5024":{"PGN":64785,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT1IGC1","first_bit":0,"SPN":5024,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor Heater Ratio","SPN_Description":"Heater ratio to determine temperature at sensor tip.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"5025":{"PGN":64785,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT1IGC1","first_bit":16,"SPN":5025,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor New part deviation NOx Gain","SPN_Description":"New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":295},"5026":{"PGN":64785,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT1IGC1","first_bit":32,"SPN":5026,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor New part deviation NOx Offset","SPN_Description":"New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":1,"offset":-125,"unit":"ppm","SLOT_ID":296},"5027":{"PGN":64784,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT1IGC2","first_bit":0,"SPN":5027,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor O2 Pressure Correction","SPN_Description":"Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5028":{"PGN":64784,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT1IGC2","first_bit":8,"SPN":5028,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor NOx Pressure Correction","SPN_Description":"Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5029":{"PGN":64784,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT1IGC2","first_bit":16,"SPN":5029,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor NO2 Correction","SPN_Description":"Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5030":{"PGN":64784,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT1IGC2","first_bit":24,"SPN":5030,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor NH3 Correction","SPN_Description":"Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5031":{"PGN":64783,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT1OGC1","first_bit":0,"SPN":5031,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor Heater Ratio","SPN_Description":"Heater ratio to determine temperature at sensor tip.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"5032":{"PGN":64783,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT1OGC1","first_bit":16,"SPN":5032,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor New part deviation NOx Gain","SPN_Description":"New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":295},"5033":{"PGN":64783,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT1OGC1","first_bit":32,"SPN":5033,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor New part deviation NOx Offset","SPN_Description":"New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":1,"offset":-125,"unit":"ppm","SLOT_ID":296},"5034":{"PGN":64782,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT1OGC2","first_bit":0,"SPN":5034,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor O2 Pressure Correction","SPN_Description":"Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5035":{"PGN":64782,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT1OGC2","first_bit":8,"SPN":5035,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor NOx Pressure Correction","SPN_Description":"Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5036":{"PGN":64782,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT1OGC2","first_bit":16,"SPN":5036,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor NO2 Correction","SPN_Description":"Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5037":{"PGN":64782,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT1OGC2","first_bit":24,"SPN":5037,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor NH3 Correction","SPN_Description":"Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5038":{"PGN":64781,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT2IGC1","first_bit":0,"SPN":5038,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor Heater Ratio","SPN_Description":"Heater ratio to determine temperature at sensor tip.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"5039":{"PGN":64781,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT2IGC1","first_bit":16,"SPN":5039,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor New part deviation NOx Gain","SPN_Description":"New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":295},"5040":{"PGN":64781,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT2IGC1","first_bit":32,"SPN":5040,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor New part deviation NOx Offset","SPN_Description":"New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":1,"offset":-125,"unit":"ppm","SLOT_ID":296},"5041":{"PGN":64780,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT2IGC2","first_bit":0,"SPN":5041,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor O2 Pressure Correction","SPN_Description":"Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5042":{"PGN":64780,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT2IGC2","first_bit":8,"SPN":5042,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor NOx Pressure Correction","SPN_Description":"Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5043":{"PGN":64780,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT2IGC2","first_bit":16,"SPN":5043,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor NO2 Correction","SPN_Description":"Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5044":{"PGN":64780,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT2IGC2","first_bit":24,"SPN":5044,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor NH3 Correction","SPN_Description":"Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5045":{"PGN":64779,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT2OGC1","first_bit":0,"SPN":5045,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor Heater Ratio","SPN_Description":"Heater ratio to determine temperature at sensor tip.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"5046":{"PGN":64779,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT2OGC1","first_bit":16,"SPN":5046,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor New part deviation NOx Gain","SPN_Description":"New part deviation NOx_Gain to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":16,"scaling":0.1,"offset":-100,"unit":"%","SLOT_ID":295},"5047":{"PGN":64779,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT2OGC1","first_bit":32,"SPN":5047,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor New part deviation NOx Offset","SPN_Description":"New part deviation NOx_Offset to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":1,"offset":-125,"unit":"ppm","SLOT_ID":296},"5048":{"PGN":64778,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT2OGC2","first_bit":0,"SPN":5048,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor O2 Pressure Correction","SPN_Description":"Correction of pressure Lambda-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5049":{"PGN":64778,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT2OGC2","first_bit":8,"SPN":5049,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor NOx Pressure Correction","SPN_Description":"Correction of pressure NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%/bar","SLOT_ID":298},"5050":{"PGN":64778,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT2OGC2","first_bit":16,"SPN":5050,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor NO2 Correction","SPN_Description":"Correction of NO2 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5051":{"PGN":64778,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT2OGC2","first_bit":24,"SPN":5051,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor NH3 Correction","SPN_Description":"Correction of NH3 at the NOx-signal to correct (recalculate) sensor signal on the Engine ECU side.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5052":{"PGN":61452,"PGN_Name":"Electronic Transmission Controller #8","PGN_Description":"ETC8","first_bit":16,"SPN":5052,"SPN_Name":"Transmission Clutch/Converter Input Speed","SPN_Description":"Rotational velocity of the input to a transmission\'s master clutch or torque converter. In most cases the rotational velocity will be the same as engine flywheel speed unless there is an intermediate device, such as a power divider, between the engine and the clutch/converter.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"5053":{"PGN":64777,"PGN_Name":"High Resolution Fuel Consumption (Liquid)","PGN_Description":"HRLFC","first_bit":0,"SPN":5053,"SPN_Name":"Engine Trip Fuel (High Resolution)","SPN_Description":"Fuel consumed during all or part of a journey.   High resolution used for calculations and fleet management systems.  See SPN 182 for alternate resolution.","bit_length":32,"scaling":0.001,"offset":0,"unit":"l","SLOT_ID":300},"5054":{"PGN":64777,"PGN_Name":"High Resolution Fuel Consumption (Liquid)","PGN_Description":"HRLFC","first_bit":32,"SPN":5054,"SPN_Name":"Engine Total Fuel Used (High Resolution)","SPN_Description":"Accumulated amount of fuel used during vehicle operation.  High resolution used for calculations and fleet management systems.  See SPN 250 for alternate resolution.","bit_length":32,"scaling":0.001,"offset":0,"unit":"l","SLOT_ID":300},"5055":{"PGN":64776,"PGN_Name":"Engine oil message","PGN_Description":"EOM","first_bit":0,"SPN":5055,"SPN_Name":"Engine Oil Viscosity","SPN_Description":"Dynamic viscosity of the engine oil","bit_length":16,"scaling":0.015625,"offset":0,"unit":"Cp","SLOT_ID":301},"5056":{"PGN":64776,"PGN_Name":"Engine oil message","PGN_Description":"EOM","first_bit":16,"SPN":5056,"SPN_Name":"Engine Oil Density","SPN_Description":"Density of the engine oil","bit_length":16,"scaling":0.00003052,"offset":0,"unit":"g/cc","SLOT_ID":302},"5057":{"PGN":38912,"PGN_Name":"Noise Control 1","PGN_Description":"NC1","first_bit":0,"SPN":5057,"SPN_Name":"Cab Noise Control Command","SPN_Description":"Command signal to change the state of the Cab Noise Control System to on-line or off-line\\r\\n\\r\\n00 - Take Cab Noise Control System Off Line\\r\\n01 - Bring Cab Noise Control System On Line\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Not Commanded","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5058":{"PGN":38912,"PGN_Name":"Noise Control 1","PGN_Description":"NC1","first_bit":2,"SPN":5058,"SPN_Name":"Cab Noise Control Tuning Command","SPN_Description":"Command values for the Tuning State of the Cab Noise Control System.  The Tuning State allows the Cab Noise Control System to adjust certain system characteristics (e.g. to account for microphone or speaker degradation over time). \\r\\n\\r\\n000 - Activate Manual Tuning, Wait for Save and Exit Commands\\r\\n001 - Activate Automatic Tuning, Wait for Save and Exit Commands\\r\\n010 - Activate Automatic Tuning State, Saving Parameters, Exit on Completion\\r\\n011 - Remain In Tuning, Save Current Parameters\\r\\n100 - Exit Tuning, Not Saving Parameters\\r\\n101 - Exit Tuning, Saving Parameters\\r\\n110 - Reserved\\r\\n111 - Don\'t Care, NOT Commanded","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5059":{"PGN":38656,"PGN_Name":"Noise Control Status","PGN_Description":"NCS","first_bit":0,"SPN":5059,"SPN_Name":"Cab Noise Control Status","SPN_Description":"This parameter returns the current status of the Cab Noise Control system.\\r\\n\\r\\n00 - Cab Noise Control System ON-Line\\r\\n01 - Cab Noise Control System OFF-Line\\r\\n10 - Error Indicator\\r\\n11 - Not Available/Not Requested","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5060":{"PGN":38656,"PGN_Name":"Noise Control Status","PGN_Description":"NCS","first_bit":2,"SPN":5060,"SPN_Name":"Cab Noise Control Tuning Status","SPN_Description":"This parameter returns the current status of tuning function of the Cab Noise Control system.    When the tuning state is active, the Cab Noise Control System adjusts certain system characteristics (e.g. to account for sensor and/or transducer degradation over time). This adjustment may be automatic or under manual control.\\r\\n\\r\\n0000 \u2013 Manual Tuning Mode\\r\\n0001 \u2013 Manual Tuning Mode \u2013 Command Complete\\r\\n0010 \u2013 Manual Tuning Mode \u2013 Saving Data\\r\\n0011 \u2013 Reserved\\r\\n0100 \u2013 Reserved \\r\\n0101 \u2013 Reserved\\r\\n0110 \u2013 Reserved\\r\\n0111 \u2013 Manual Tuning Denied \u2013 Requires Security Verification\\r\\n1000 \u2013 Automatic Tuning Mode\\r\\n1001 \u2013 Automatic Tuning Mode \u2013 Command Complete\\r\\n1010 \u2013 Automatic Tuning Mode \u2013 Saving Data\\r\\n1011 \u2013 Reserved \\r\\n1100 \u2013 Reserved\\r\\n1101 \u2013 Reserved\\r\\n1110 \u2013 Tuning Mode \u2013 Error\\r\\n1111 \u2013 Not Available/Not Tuning/Not Requested","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5077":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":0,"SPN":5077,"SPN_Name":"Engine Protect Lamp Command","SPN_Description":"Command signal directly controlling the Engine Protect Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available\\r\\n\\r\\nNote:  SPN 987 should be used for reporting diagnostics of the Engine Protect Lamp.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5078":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":2,"SPN":5078,"SPN_Name":"Engine Amber Warning Lamp Command","SPN_Description":"Command signal directly controlling the Engine Amber Warning Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available\\r\\n\\r\\nNote:  SPN 624 should be used for reporting diagnostics of the Engine Amber Warning Lamp.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5079":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":4,"SPN":5079,"SPN_Name":"Engine Red Stop Lamp Command","SPN_Description":"Command signal directly controlling the Engine Red Stop Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available\\r\\n\\r\\nNote:  SPN 623 should be used for reporting diagnostics of the Engine Red Stop Lamp.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5080":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":6,"SPN":5080,"SPN_Name":"OBD Malfunction Indicator Lamp Command","SPN_Description":"Command signal directly controlling the OBD Malfunction Indicator Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available\\r\\n\\r\\nNote:  SPN 1213 should be used for reporting diagnostics of the OBD Malfunction Indicator Lamp.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5081":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":8,"SPN":5081,"SPN_Name":"Engine Brake Active Lamp Command","SPN_Description":"Command signal directly controlling the Engine Brake Active Lamp. This is used for engine based retarders.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5082":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":12,"SPN":5082,"SPN_Name":"Engine Oil Pressure Low Lamp Command","SPN_Description":"Command signal directly controlling the Engine Oil Pressure Low Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5083":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":14,"SPN":5083,"SPN_Name":"Engine Coolant Temperature High Lamp Command","SPN_Description":"Command signal directly controlling the Engine Coolant Temperature High Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5084":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":16,"SPN":5084,"SPN_Name":"Engine Coolant Level Low Lamp Command","SPN_Description":"Command signal directly controlling the Engine Coolant Level Low Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5085":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":18,"SPN":5085,"SPN_Name":"Engine Idle Management Active Lamp Command","SPN_Description":"Command signal directly controlling the Engine Idle Management Active Lamp\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available\\r\\n\\r\\nNote:  SPN 1661 should be used for reporting diagnostics of the Engine Idle Management Active Lamp.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5086":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":20,"SPN":5086,"SPN_Name":"Engine Air Filter Restriction Lamp Command","SPN_Description":"Command signal directly controlling the Engine Air Filter Restriction Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5087":{"PGN":64774,"PGN_Name":"Direct Lamp Control Command 2","PGN_Description":"DLCC2","first_bit":0,"SPN":5087,"SPN_Name":"Vehicle Battery Voltage Low Lamp Command","SPN_Description":"Command signal directly controlling the Vehicle Battery Voltage Low Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5088":{"PGN":64774,"PGN_Name":"Direct Lamp Control Command 2","PGN_Description":"DLCC2","first_bit":2,"SPN":5088,"SPN_Name":"Vehicle Fuel Level Low Lamp Command","SPN_Description":"Command signal directly controlling the Vehicle Fuel Level Low Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5089":{"PGN":64774,"PGN_Name":"Direct Lamp Control Command 2","PGN_Description":"DLCC2","first_bit":4,"SPN":5089,"SPN_Name":"Vehicle Air Pressure Low Lamp Command","SPN_Description":"Command signal directly controlling the Vehicle Air Pressure Low Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5090":{"PGN":64774,"PGN_Name":"Direct Lamp Control Command 2","PGN_Description":"DLCC2","first_bit":6,"SPN":5090,"SPN_Name":"Vehicle HVAC Recirculation Lamp Command","SPN_Description":"Command signal directly controlling the Vehicle HVAC Recirculation Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5091":{"PGN":64774,"PGN_Name":"Direct Lamp Control Command 2","PGN_Description":"DLCC2","first_bit":8,"SPN":5091,"SPN_Name":"Vehicle Battery Charging Lamp Command","SPN_Description":"Command signal directly controlling the Vehicle Battery Charging Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5093":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":0,"SPN":5093,"SPN_Name":"Engine Protect Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Protect Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5094":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":2,"SPN":5094,"SPN_Name":"Engine Amber Warning Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Amber Warning Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5095":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":4,"SPN":5095,"SPN_Name":"Engine Red Stop Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Red Stop Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5096":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":6,"SPN":5096,"SPN_Name":"OBD Malfunction Indicator Lamp Data","SPN_Description":"This parameter provides measured data from the OBD Malfunction Indicator Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5097":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":8,"SPN":5097,"SPN_Name":"Engine Brake Active Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Brake Active Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5098":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":10,"SPN":5098,"SPN_Name":"Compression Brake Enable Switch Indicator Lamp Data","SPN_Description":"This parameter provides measured data from the Compression Brake Enable Switch Indicator Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5099":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":12,"SPN":5099,"SPN_Name":"Engine Oil Pressure Low Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Oil Pressure Low Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5100":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":14,"SPN":5100,"SPN_Name":"Engine Coolant Temperature High Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Coolant Temperature High Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5101":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":16,"SPN":5101,"SPN_Name":"Engine Coolant Level Low Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Coolant Level Low Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5102":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":18,"SPN":5102,"SPN_Name":"Engine Idle Management Active Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Idle Management Active Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5103":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":20,"SPN":5103,"SPN_Name":"Engine Air Filter Restriction Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Air Filter Restriction Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5104":{"PGN":64772,"PGN_Name":"Direct Lamp Control Data 2","PGN_Description":"DLCD2","first_bit":0,"SPN":5104,"SPN_Name":"Vehicle Battery Voltage Low Lamp Data","SPN_Description":"This parameter provides measured data from the Vehicle Battery Voltage Low Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5105":{"PGN":64772,"PGN_Name":"Direct Lamp Control Data 2","PGN_Description":"DLCD2","first_bit":2,"SPN":5105,"SPN_Name":"Vehicle Fuel Level Low Lamp Data","SPN_Description":"This parameter provides measured data from the Vehicle Fuel Level Low Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5106":{"PGN":64772,"PGN_Name":"Direct Lamp Control Data 2","PGN_Description":"DLCD2","first_bit":4,"SPN":5106,"SPN_Name":"Vehicle Air Pressure Low Lamp Data","SPN_Description":"This parameter provides measured data from the Vehicle Air Pressure Low Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5107":{"PGN":64772,"PGN_Name":"Direct Lamp Control Data 2","PGN_Description":"DLCD2","first_bit":6,"SPN":5107,"SPN_Name":"Vehicle HVAC Recirculation Lamp Data","SPN_Description":"This parameter provides measured data from the Vehicle HVAC Recirculation Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5108":{"PGN":64772,"PGN_Name":"Direct Lamp Control Data 2","PGN_Description":"DLCD2","first_bit":8,"SPN":5108,"SPN_Name":"Vehicle Battery Charging Lamp Data","SPN_Description":"This parameter provides measured data from the Vehicle Battery Charging Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5125":{"PGN":64924,"PGN_Name":"Sensor Electrical Power #2","PGN_Description":"SEP2","first_bit":32,"SPN":5125,"SPN_Name":"Sensor supply voltage 7","SPN_Description":"Sensor ECU supply voltage 7","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"5126":{"PGN":64924,"PGN_Name":"Sensor Electrical Power #2","PGN_Description":"SEP2","first_bit":48,"SPN":5126,"SPN_Name":"Sensor supply voltage 8","SPN_Description":"Sensor ECU supply voltage 8","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"5137":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":16,"SPN":5137,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Heater Command","SPN_Description":"Command for the Aftertreatment 1 Diesel Exhaust Fluid Tank Heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  See SPN 3363 for the measured value of the Aftertreatment 1 Diesel Exhaust Fluid Tank Heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5138":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":16,"SPN":5138,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Heater Command","SPN_Description":"Command for the Aftertreatment 2 Diesel Exhaust Fluid Tank Heater.  A value of 0% means no heating applied, a value of 100% means full heating applied.  See SPN 4431 for the measured value of the Aftertreatment 2 Diesel Exhaust Fluid Tank Heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5141":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":0,"SPN":5141,"SPN_Name":"Low Voltage Disconnect Manual Disconnect State","SPN_Description":"State of the Manual Disconnect hardwired input to the LVD.  Manual Disconnect is used to override the LVD\'s normal activlty and dicconnect all of the LVD outputs.  Manual Disconnect is lower in priority than the Manual Connect hardwired input, but has priority over all LVD Set Operating Mode messages.\\r\\n\\r\\n00 - Input off\\r\\n01 - Input on\\r\\n10 - Error\\r\\n11 - Not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5142":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":2,"SPN":5142,"SPN_Name":"Low Voltage Disconnect Manual Connect State","SPN_Description":"State of the Manual Connect hardwired input to the LVD.  Manual Connect is used to override the LVD\'s normal activlty and connect all of the LVD outputs.  Manual Connect has priority over the Manual Dicsonnect hardwired input and all LVD Set Operating Mode messages.\\r\\n\\r\\n00 - Input off\\r\\n01 - Input on\\r\\n10 - Error\\r\\n11 - Not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5143":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":4,"SPN":5143,"SPN_Name":"Low Voltage Disconnect Current Operating Mode","SPN_Description":"Current operating mode of the LVD.  The current mode is dependent on the state of the Manual Disconnect/Connect hardwired inputs and on the most-recent received LVD Set Desired Operating Mode message.  The hardwired inputs have priority over the LVD Set Operating Mode message, and Connects have priority over Disconnects.\\r\\n\\r\\n0000 - Automatic\\r\\n0001-0011 - Reserved\\r\\n0100 - Manual Disconnect via J1939 request\\r\\n0101 - Manual Connect via J1939 request\\r\\n0110-0111 - Reserved\\r\\n1000 - Manual Disconnect via hardwired input\\r\\n1001 - Manual Connect via hardwired input\\r\\n1010-1110 - Reserved\\r\\n1111 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5144":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":8,"SPN":5144,"SPN_Name":"Low Voltage Disconnect Output #3 State","SPN_Description":"State of the Output #3 from the LVD.  Output #3 controls an external load or relay.  This external load could be independent of the main output, and may apply to an application specific circuit or zone.  If the LVD supports prioritization, this circuit will disconnect before Output #2 and reconnect after Output #2.\\r\\n\\r\\n0000 - Output off or disconnected\\r\\n0001 - Output on or connected\\r\\n0010 - Disconnect alarm expired, output off or disconnected\\r\\n0011 - Disconnect pending, alarm active\\r\\n0100 - Connect pending, alarm active\\r\\n0101-1101 - Reserved\\r\\n1110 - Output fault\\r\\n1111 - Not available or not installed","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5145":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":12,"SPN":5145,"SPN_Name":"Low Voltage Disconnect Output #2 State","SPN_Description":"State of the Output #2 from the LVD.  Output #2 controls an external load or relay.  This external load could be independent of the main output, and may apply to an application specific circuit or zone.  If the LVD supports prioritization, this circuit will disconnect before Output #1 and reconnect after Output #1.\\r\\n\\r\\n0000 - Output off or disconnected\\r\\n0001 - Output on or connected\\r\\n0010 - Disconnect alarm expired, output off or disconnected\\r\\n0011 - Disconnect pending, alarm active\\r\\n0100 - Connect pending, alarm active\\r\\n0101-1101 - Reserved\\r\\n1110 - Output fault\\r\\n1111 - Not available or not installed","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5146":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":16,"SPN":5146,"SPN_Name":"Low Voltage Disconnect Output #1 State","SPN_Description":"State of the Output #1 from the LVD.  Output #1 controls an external load or relay.  This external load could be independent of the main output, and may apply to an application specific circuit or zone.  If the LVD supports prioritization, this circuit will disconnect before the Vout output and reconnect after the Vout output.\\r\\n\\r\\n0000 - Output off or disconnected\\r\\n0001 - Output on or connected\\r\\n0010 - Disconnect alarm expired, output off or disconnected\\r\\n0011 - Disconnect pending, alarm active\\r\\n0100 - Connect pending, alarm active\\r\\n0101-1101 - Reserved\\r\\n1110 - Output fault\\r\\n1111 - Not available or not installed","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5147":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":20,"SPN":5147,"SPN_Name":"Low Voltage Disconnect Vout Output State","SPN_Description":"State of the Vout Output from the LVD.  Vout is the LVD\'s main internal, controllable, high-current output.  If the LVD supports prioritization, this circuit will be the last to disconnect and the first to reconnect.\\r\\n\\r\\n0000 - Output off or disconnected\\r\\n0001 - Output on or connected\\r\\n0010 - Disconnect alarm expired, output off or disconnected\\r\\n0011 - Disconnect pending, alarm active\\r\\n0100 - Connect pending, alarm active\\r\\n0101-1101 - Reserved\\r\\n1110 - Output fault\\r\\n1111 - Not available or not installed","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5148":{"PGN":64769,"PGN_Name":"Low Voltage Disconnect  Status","PGN_Description":"LVDS","first_bit":24,"SPN":5148,"SPN_Name":"Low Voltage Disconnect Temperature","SPN_Description":"Internal temperature of the LVD.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5149":{"PGN":38400,"PGN_Name":"Low Voltage Disconnect Set Operating Mode","PGN_Description":"LVDSOM","first_bit":0,"SPN":5149,"SPN_Name":"Low Voltage Disconnect Desired Operating Mode","SPN_Description":"Desired Operating Mode of the LVD.  Used to issue a J1939 request to the LVD to change modes.\\r\\n\\r\\n0000 - Automatic\\r\\n0001-0011 - Reserved\\r\\n0100 - Manual Disconnect\\r\\n0101 - Manual Connect\\r\\n0110-1110 - Reserved\\r\\n1111 - No change","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5245":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":37,"SPN":5245,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Tank Low Level Indicator","SPN_Description":"The desired illumination of the driver\'s warning indicator for diesel exhaust fluid (DEF) tank low level.\\r\\n\\r\\n000 - Off -  indicates adequate DEF level\\r\\n   e.g., for Euro VI this is used to indicate the driver warning system is non-active for diesel exhaust fluid level\\r\\n001 - On solid -  indicates low DEF level\\r\\n   e.g., for Euro VI this is used to indicate the driver warning system is initially activated for low diesel exhaust fluid level\\r\\n010 - reserved for SAE assignment\\r\\n011 - reserved for SAE assignment\\r\\n100 - On fast blink (1 Hz) indicates the DEF level is lower than the level indicated by the solid illumination (state 001)\\r\\n   e.g., for Euro VI this is used to indicate the second driver warning system detection threshold for diesel exhaust fluid level, where the visual alarm of the driver warning system is required to \\"escalate in intensity\\".\\r\\n101 - reserved for SAE assignment\\r\\n110 - reserved for SAE assignment\\r\\n111 - not available\\r\\n\\r\\nNote: SPN 5245 is similar to SPN 5825.  SPN 5245 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level information only, whereas SPN 5825 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level as well as specific emission control malfunction information.  Thus, SPN 5245 is a subset of SPN 5825, and if both are utilized, will match only under certain conditions.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5246":{"PGN":65110,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 1","PGN_Description":"AT1T1I1","first_bit":45,"SPN":5246,"SPN_Name":"Aftertreatment SCR Operator Inducement Severity","SPN_Description":"Severity status of the operator inducement system for anomalies with the SCR system, such as tampering, low DEF quality, and DEF tank level.  Higher numerical levels indicate more severe levels of inducement.  Level 1 is the least severe.\\r\\n\\r\\n000 - Driver Warning, Low-Level Inducement, and Severe Inducement Non-Active\\r\\n001 - Inducement Level 1 \u2026 EPA defined SCR Inducement - DEF Warning  ...................... FMI 15\\r\\n                                             \u2026Euro VI - Driver Warning System Active ................................... FMI 15\\r\\n                                             \u2026Off Highway (Tier4) - DEF Warning\u2026\u2026.................................... FMI 15\\r\\n010 - Inducement Level 2 \u2026 DEF Warning, second level (optional) ...................................... FMI 15\\r\\n                                             ... Euro VI - Low-Level Inducement Enabled ................................. FMI 15\\r\\n                                             \u2026Off Highway (Tier4) - DEF Warning, second level.................... FMI 15\\r\\n011 - Inducement Level 3 \u2026 EPA defined SCR Inducement - Engine Derate ..................... FMI 16\\r\\n                                             ... Euro VI - Low-Level Inducement Active .................................... FMI 16\\r\\n                                             \u2026Off Highway (Tier4) - Low-Level Inducement Active................. FMI 16\\r\\n100 - Inducement Level 4  ... Severe Inducement Pre-Trigger (optional) \u2026.\u2026\u2026.................. FMI 16\\r\\n                                             ... Euro VI - Severe Inducement Enabled ...................................... FMI 16\\r\\n                                             \u2026Off Highway (Tier4) - Severe Inducement Enabled.................. FMI 16\\r\\n101 - Inducement Level 5  ... EPA defined SCR Inducement - Severe Inducement \u2026........  FMI 0\\r\\n                                             ... Euro VI - Severe Inducement Active ......................................... FMI 0\\r\\n                                             \u2026Off Highway (Tier4) - Final Inducement Enabled...................... FMI 0\\r\\n110 - Temporary Override of Inducement  -  The SCR inducement has been temporarily interrupted.\\r\\n111 - Not Available / Not Supported\\r\\n\\r\\nWhen SPN 5246 is used in a DTC the recommended FMI usage is as shown.\\r\\n\\r\\nReference EPA CISD-09-04-REVISED SCR Guidance document for more information regarding EPA implementations.\\r\\n\\r\\nReference Euro VI implementing regulation Annex XIII, Appendix 5, section 3.1.(b), 3.1.(c), and 3.1.(d) for more information regarding Euro VI implementations.\\r\\n\\r\\nReference EU directive 97/68/EC amendment (2012/46/EU), EPA webinar nrci-scr-web-conf.2011-07-25, and JMLIT \\"Technical Guidelines for Urea Selective Catalytic Reduction System\\" Kokujikan 132-3, Feb.16, 2012 for Off Highway (Tier4) implementations.\\r\\n\\r\\nJMLIT - Japan Ministry Of Land, Infrastructure, Transport and Tourism\\r\\n\\r\\nNote: SPN 5246 is similar to SPN 5826.  SPN 5246 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR system only, whereas SPN 5826 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR and EGR systems.  Thus, SPN 5246 is a subset of SPN 5826, and if both are utilized, will match only under certain conditions.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5252":{"PGN":64768,"PGN_Name":"Engine Fluid Level/Pressure 10","PGN_Description":"EFL/P10","first_bit":0,"SPN":5252,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Differential Pressure","SPN_Description":"Differential Pressure across the Exhaust Gas Recirculation 2 (EGR2) system.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"5253":{"PGN":64768,"PGN_Name":"Engine Fluid Level/Pressure 10","PGN_Description":"EFL/P10","first_bit":16,"SPN":5253,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Intake Pressure","SPN_Description":"EGR2 intake gauge pressure is measured after EGR2 cooler and before EGR2 valve","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5254":{"PGN":64768,"PGN_Name":"Engine Fluid Level/Pressure 10","PGN_Description":"EFL/P10","first_bit":24,"SPN":5254,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Outlet Absolute Pressure","SPN_Description":"Absolute Pressure immediately after the EGR2 valve","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5255":{"PGN":64767,"PGN_Name":"Engine Temperature 5","PGN_Description":"ET5","first_bit":0,"SPN":5255,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Temperature ","SPN_Description":"Temperature of Recirculated Exhaust Gas of EGR2","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5256":{"PGN":64767,"PGN_Name":"Engine Temperature 5","PGN_Description":"ET5","first_bit":16,"SPN":5256,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Mixer Intake Temperature","SPN_Description":"The temperature of the EGR gas entering the intake of EGR2 system mixer.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5257":{"PGN":61450,"PGN_Name":"Engine Gas Flow Rate","PGN_Description":"EGF1","first_bit":32,"SPN":5257,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Mass Flow Rate","SPN_Description":"Flow rate of gas through the second EGR system. Flow rate of the exhaust gas being recirculated from the 2nd EGR system into combustion air.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kg/h","SLOT_ID":18},"5258":{"PGN":64766,"PGN_Name":"Electronic Engine Controller 10","PGN_Description":"EEC10","first_bit":0,"SPN":5258,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Cooler Intake Temperature","SPN_Description":"Exhaust Gas Recirculation 2 (EGR2) Temperature measured at EGR2 cooler intake. See SPN 5255 for Engine EGR2 temperature.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5259":{"PGN":64766,"PGN_Name":"Electronic Engine Controller 10","PGN_Description":"EEC10","first_bit":16,"SPN":5259,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Cooler Intake Gas Absolute Pressure","SPN_Description":"Exhaust Gas Recirculation 2 gas absolute pressure is measured at EGR2 cooler intake. See SPN 5253 for EGR2 pressure measured at the EGR2 cooler outlet before the valve.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"5260":{"PGN":64766,"PGN_Name":"Electronic Engine Controller 10","PGN_Description":"EEC10","first_bit":32,"SPN":5260,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Cooler Efficiency","SPN_Description":"Exhaust Gas Recirculation 2 cooler efficiency is an indication of the cooler\u2019s ability to reduce the temperature of the exhaust gas that is being recirculated back to the intake. 0% = no reduction in temperature, 100% = maximum cooling. The EGR 2 cooler efficiency is calculated as (EGR 2 cooler intake temperature minus EGR 2 gas temperature) divided by (EGR 2 cooler intake temperature minus engine coolant temperature).","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5261":{"PGN":64766,"PGN_Name":"Electronic Engine Controller 10","PGN_Description":"EEC10","first_bit":40,"SPN":5261,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Cooler Bypass Actuator Position","SPN_Description":"EGR2 Cooler Bypass Actuator position, where 0% = Fully Closed (no gas flowing through the bypass), and 100% = Fully Open..","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5262":{"PGN":64765,"PGN_Name":"Electronic Engine Controller 9","PGN_Description":"EEC9","first_bit":0,"SPN":5262,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Valve Position","SPN_Description":"Position of EGR2 valve expressed as a percentage of full travel. 0% means the valve is closed and no exhaust gas is flowing into the air stream. 100% means the valve is fully opened.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5263":{"PGN":64765,"PGN_Name":"Electronic Engine Controller 9","PGN_Description":"EEC9","first_bit":16,"SPN":5263,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Valve 2 Position","SPN_Description":"The position of the second exhaust gas recirculation valve of EGR 2 expressed as a percentage of full travel. 0% means the valve is closed and no exhaust gas is flowing into the air stream. 100% means the valve is fully opened.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5264":{"PGN":64762,"PGN_Name":"Electronic Engine Controller 11","PGN_Description":"EEC11","first_bit":0,"SPN":5264,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Valve 1 Control","SPN_Description":"Desired percentage of maximum Exhaust Gas Recirculation 2 (EGR2) valve opening. 0% means the valve is closed. 100% means maximum opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5265":{"PGN":64762,"PGN_Name":"Electronic Engine Controller 11","PGN_Description":"EEC11","first_bit":16,"SPN":5265,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Valve 2 Control","SPN_Description":"Desired percentage of maximum Exhaust Gas Recirculation 2 (EGR2) valve 2 opening. 0% means the valve is closed. 100% means maximum opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5266":{"PGN":64761,"PGN_Name":"Diesel Particulate Filter 1 Soot 2","PGN_Description":"DPF1S2","first_bit":0,"SPN":5266,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Signal Standard Deviation","SPN_Description":"Standard deviation of the soot measurement from diesel particulate filter 1 soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5267":{"PGN":64761,"PGN_Name":"Diesel Particulate Filter 1 Soot 2","PGN_Description":"DPF1S2","first_bit":16,"SPN":5267,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Signal Maximum","SPN_Description":"Maximum output signal level of the current soot measurement from diesel particulate filter 1 soot sensor.  This is a statistical value, not the maximum sensing capability of the sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5268":{"PGN":64761,"PGN_Name":"Diesel Particulate Filter 1 Soot 2","PGN_Description":"DPF1S2","first_bit":32,"SPN":5268,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Signal Minimum","SPN_Description":"Minimum output signal level of the current soot measurement from diesel particulate filter 1 soot sensor.  This is a statistical value, not the minimum sensing capability of the sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5269":{"PGN":64760,"PGN_Name":"Diesel Particulate Filter 2 Soot 2","PGN_Description":"DPF2S2","first_bit":0,"SPN":5269,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Signal Standard Deviation","SPN_Description":"Standard deviation of the soot measurement from diesel particulate filter 2 soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5270":{"PGN":64760,"PGN_Name":"Diesel Particulate Filter 2 Soot 2","PGN_Description":"DPF2S2","first_bit":16,"SPN":5270,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Signal Maximum","SPN_Description":"Maximum output signal level of the current soot measurement from diesel particulate filter 2 soot sensor.  This is a statistical value, not the maximum sensing capability of the sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5271":{"PGN":64760,"PGN_Name":"Diesel Particulate Filter 2 Soot 2","PGN_Description":"DPF2S2","first_bit":32,"SPN":5271,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Signal Minimum","SPN_Description":"Minimum output signal level of the current soot measurement from diesel particulate filter 2 soot sensor.  This is a statistical value, not the minimum sensing capability of the sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5274":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":58,"SPN":5274,"SPN_Name":"Prohibit Automatic Air Suspension Control","SPN_Description":"This parameter is an internal request to the air suspension control system to prohibit automatic air suspension control.  If the request is accepted,  response intended to be sent in  ASC1 (additional status requested in ASC1), there will be no automatic control either for height changes or axle load distribution changes, i.e. hold current pressures in all suspension devices.\\r\\n\\r\\nFor example, to prohibit automatic air suspension control when a wheelchair lift is in use.\\r\\n\\r\\n00 No request \\r\\n01 Request prohibit automatic air suspension control \\r\\n10 Error indicator \\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5275":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":24,"SPN":5275,"SPN_Name":"Parking Brake Actuator Fully Activated","SPN_Description":"Signal which indicates when the parking brake actuator is fully activated.  (see also SPN 70 and 619).\\r\\n\\r\\n00 - Parking Brake Actuator not fully activated\\r\\n01 - Parking Brake Actuator fully activated\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5276":{"PGN":64764,"PGN_Name":"Engine Manifold Actuator Control","PGN_Description":"EMAC","first_bit":0,"SPN":5276,"SPN_Name":"Engine Exhaust Manifold Bank 1 Flow Balance Valve Actuator Control","SPN_Description":"Commanded percentage of maximum Engine Exhaust Manifold Bank 1 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5277":{"PGN":64763,"PGN_Name":"Engine Manifold Actuator Position","PGN_Description":"EMAP","first_bit":0,"SPN":5277,"SPN_Name":"Engine Exhaust Manifold Bank 1 Flow Balance Valve Actuator Position","SPN_Description":"Actual percentage of maximum Engine Exhaust Manifold Bank 1 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5278":{"PGN":64764,"PGN_Name":"Engine Manifold Actuator Control","PGN_Description":"EMAC","first_bit":16,"SPN":5278,"SPN_Name":"Engine Exhaust Manifold Bank 2 Flow Balance Valve Actuator Control","SPN_Description":"Commanded percentage of maximum Engine Ehaust Manifold Bank 2 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5279":{"PGN":64763,"PGN_Name":"Engine Manifold Actuator Position","PGN_Description":"EMAP","first_bit":16,"SPN":5279,"SPN_Name":"Engine Exhaust Manifold Bank 2 Flow Balance Valve Actuator Position","SPN_Description":"Actual percentage of maximum Engine Manifold Bank 2 Balance valve opening. 0% means valve is closed. 100% means maximum valve opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5280":{"PGN":64759,"PGN_Name":"Charge Air Cooler 1 Precooler","PGN_Description":"CAC1P","first_bit":0,"SPN":5280,"SPN_Name":"Engine Charge Air Cooler 1 Precooler Intake Temperature","SPN_Description":"Temperature of the combustion air measured at the charge air cooler 1 precooler intake.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5281":{"PGN":64759,"PGN_Name":"Charge Air Cooler 1 Precooler","PGN_Description":"CAC1P","first_bit":16,"SPN":5281,"SPN_Name":"Engine Charge Air Cooler 1 Precooler Outlet Temperature","SPN_Description":"Temperature of the combustion air measured at the charge air cooler 1 precooler outlet.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5282":{"PGN":64759,"PGN_Name":"Charge Air Cooler 1 Precooler","PGN_Description":"CAC1P","first_bit":32,"SPN":5282,"SPN_Name":"Engine Charge Air Cooler 1 Precooler Efficiency","SPN_Description":"Engine charge air cooler 1 (CAC1) precooler efficiency is an indication of the precooler\u2019s ability to reduce the temperature of the combustion air that is being routed through the precooler. 0% = no reduction in temperature, 100% = maximum cooling. The CAC1 precooler efficiency is calculated as (CAC1 precooler Intake temperature minus CAC1 precooler outlet temperature) divided by (CAC1 precooler Intake temperature minus engine coolant temperature).  This calculation assumes that the precooler uses engine coolant as the cooling fluid.  ","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5283":{"PGN":64758,"PGN_Name":"Charge Air Cooler 1","PGN_Description":"CAC1","first_bit":0,"SPN":5283,"SPN_Name":"Engine Charge Air Cooler 1 Intake Temperature","SPN_Description":"Temperature of the combustion air measured at the CAC 1 Intake.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5284":{"PGN":64758,"PGN_Name":"Charge Air Cooler 1","PGN_Description":"CAC1","first_bit":16,"SPN":5284,"SPN_Name":"Engine Charge Air Cooler 1 Ambient Air Temperature","SPN_Description":"Temperature of the air surrounding charge air cooler 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5285":{"PGN":64758,"PGN_Name":"Charge Air Cooler 1","PGN_Description":"CAC1","first_bit":32,"SPN":5285,"SPN_Name":"Engine Charge Air Cooler 1 Efficiency","SPN_Description":"Engine charge air cooler 1(CAC1) efficiency is an indication of the CAC\u2019s ability to reduce the temperature of the combustion air that is being routed through the CAC1. 0% = no reduction in temperature, 100% = maximum cooling. The CAC1 efficiency is calculated as (CAC1 Intake temperature minus CAC1 outlet temperature) divided by (CAC1 Intake temperature minus CAC1 ambient air temperature).  This calculation assumes that the CAC uses a measured or estimated ambient air temperature as the cooling fluid temperature.  ","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5286":{"PGN":64757,"PGN_Name":"Charge Air Cooler 2 Precooler","PGN_Description":"CAC2P","first_bit":0,"SPN":5286,"SPN_Name":"Engine Charge Air Cooler 2 Precooler Intake Temperature","SPN_Description":"Temperature of the combustion air measured at the charge air cooler 2 precooler Intake.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5287":{"PGN":64757,"PGN_Name":"Charge Air Cooler 2 Precooler","PGN_Description":"CAC2P","first_bit":16,"SPN":5287,"SPN_Name":"Engine Charge Air Cooler 2 Precooler Outlet Temperature","SPN_Description":"Temperature of the combustion air measured at the charge air cooler 2 precooler outlet.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5288":{"PGN":64757,"PGN_Name":"Charge Air Cooler 2 Precooler","PGN_Description":"CAC2P","first_bit":32,"SPN":5288,"SPN_Name":"Engine Charge Air Cooler 2 Precooler Efficiency","SPN_Description":"Engine charge air cooler 2 (CAC2) precooler efficiency is an indication of the precooler\u2019s ability to reduce the temperature of the gas that is being routed through the precooler. 0% = no reduction in temperature, 100% = maximum cooling. The CAC2 precooler efficiency is calculated as (CAC2 precooler Intake temperature minus CAC2 precooler outlet temperature) divided by (CAC2 precooler Intake temperature minus engine coolant temperature).  This calculation assumes that the CAC2 precooler uses engine coolant as the cooling fluid.  ","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5289":{"PGN":64756,"PGN_Name":"Charge Air Cooler 2","PGN_Description":"CAC2","first_bit":0,"SPN":5289,"SPN_Name":"Engine Charge Air Cooler 2 Intake Temperature","SPN_Description":"Temperature of the combustion air measured at the charge air cooler 2 Intake.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5290":{"PGN":64756,"PGN_Name":"Charge Air Cooler 2","PGN_Description":"CAC2","first_bit":16,"SPN":5290,"SPN_Name":"Engine Charge Air Cooler 2 Outlet Temperature","SPN_Description":"Temperature of combustion air after it exits from the Charge Air Cooler 2 but before any mixing of recirculated exhaust gas.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5291":{"PGN":64756,"PGN_Name":"Charge Air Cooler 2","PGN_Description":"CAC2","first_bit":32,"SPN":5291,"SPN_Name":"Engine Charge Air Cooler 2 Ambient Air Temperature","SPN_Description":"Temperature of the air surrounding charge air cooler 2.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5292":{"PGN":64756,"PGN_Name":"Charge Air Cooler 2","PGN_Description":"CAC2","first_bit":48,"SPN":5292,"SPN_Name":"Engine Charge Air Cooler 2 Efficiency","SPN_Description":"Engine charge air cooler 2 (CAC2) is an indication of the CAC\u2019s ability to reduce the temperature of the combustion air that is being routed through the CAC. 0% = no reduction in temperature, 100% = maximum cooling. The CAC2 efficiency is calculated as (CAC2 Intake temperature minus CAC2 outlet temperature) divided by (CAC2 Intake temperature minus CAC2 ambient air temperature).  This calculation assumes that the CAC uses a measured or estimated ambient air temperature as the cooling fluid temperature.  ","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5293":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":54,"SPN":5293,"SPN_Name":"Allow Level Control During Braking Command","SPN_Description":"This parameter overides the inhibit of level control during braking.\\r\\n\\r\\n00 = Disallow level control during braking (normal operation)\\r\\n01 = Allow level control during braking\\r\\n10 = Reserved\\r\\n11 = Don\u2019t\' care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5294":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":52,"SPN":5294,"SPN_Name":"Allow Level Control During Braking Status","SPN_Description":"This parameter indicates if the function Allow Level Control During Braking is active. Functions is activated by SPN 5293.\\r\\n\\r\\n00 = Deactivated\\r\\n01 = Activated\\r\\n10 = Reserved\\r\\n11 = Don\u2019t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5295":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":56,"SPN":5295,"SPN_Name":"Speed Dependent Level Control Request","SPN_Description":"This parameter activates speed dependent level control in suspension system.\\r\\n\\r\\n00 = Deactivate\\r\\n01 = Activate\\r\\n10 = Reserved\\r\\n11 = Don\u2019t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5296":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":54,"SPN":5296,"SPN_Name":"Speed Dependant Level Control Status","SPN_Description":"This parameter indicates if the function Speed Dependant Level Control is active. The function is activated by SPN 5295.\\r\\n\\r\\n00 = Inactive\\r\\n01 = Active\\r\\n10 = Reserved\\r\\n11 = Don\u2019t\' care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5312":{"PGN":64916,"PGN_Name":"Electronic Engine Controller 7","PGN_Description":"EEC7","first_bit":48,"SPN":5312,"SPN_Name":"Engine Intake Manifold Commanded Pressure","SPN_Description":"Provides the commanded set point value for the engine intake manifold pressure.","bit_length":16,"scaling":0.125,"offset":0,"unit":"kPa","SLOT_ID":138},"5313":{"PGN":64765,"PGN_Name":"Electronic Engine Controller 9","PGN_Description":"EEC9","first_bit":32,"SPN":5313,"SPN_Name":"Commanded Engine Fuel Rail Pressure","SPN_Description":"Provides the commanded set point value for the engine fuel rail gage pressure","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"5314":{"PGN":64765,"PGN_Name":"Electronic Engine Controller 9","PGN_Description":"EEC9","first_bit":48,"SPN":5314,"SPN_Name":"Commanded Engine Fuel Injection Control Pressure","SPN_Description":"Provides the commanded set point value for the engine fuel injection control pressure.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"5315":{"PGN":64749,"PGN_Name":"Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Information","PGN_Description":"AT2WUDOC","first_bit":0,"SPN":5315,"SPN_Name":"Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Intake Temperature","SPN_Description":"Temperature of engine combustion byproducts entering the warm up Diesel Oxidation Catalyst in exhaust bank 2.  This diesel parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5316":{"PGN":64749,"PGN_Name":"Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Information","PGN_Description":"AT2WUDOC","first_bit":16,"SPN":5316,"SPN_Name":"Aftertreatment 2 Warm Up Diesel Oxidation Catalyst Outlet Temperature","SPN_Description":"Temperature of engine combustion byproducts leaving the warm up Diesel Oxidation Catalyst in exhaust bank 2.  This diesel parameter should be used with engines fueled by diesel fuel (not gaseous fuel like natural gas or propane).  A separate parameter has been defined for gas fueled engines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5323":{"PGN":64981,"PGN_Name":"Electronic Engine Controller 5","PGN_Description":"EEC5","first_bit":50,"SPN":5323,"SPN_Name":"Engine Fuel Control Mode","SPN_Description":"Indicates whether the Engine Fuel Control System is in open loop or closed loop.\\r\\n\\r\\n00     Open loop\\r\\n01     Closed loop\\r\\n10     SAE reserved\\r\\n11     Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5344":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":42,"SPN":5344,"SPN_Name":"Transmission Warning Indicator","SPN_Description":"Signal from transmission indicating that some aspect of its operation is not functioning correctly, and as a result, transmission operation may be altered or restricted.  The indicator is typically a lamp.  Distinctions in meaning between the continuous and flashing are left to the transmission manufacturer.\\r\\n\\r\\n00 - Transmission Warning Indicator is off\\r\\n01 - Transmission Warning Indicator is on continuously\\r\\n10 - Transmission Warning Indicator is flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5345":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":4,"SPN":5345,"SPN_Name":"Transmission Overheat Indicator","SPN_Description":"Signal from transmission indicating that its fluid temperature is above normal acceptable limits, and as a result, transmission operation may be altered or restricted.  The indicator is typically a lamp.  Distinctions in meaning between the continuous and flashing are left to the transmission manufacturer..\\r\\n\\r\\n00 - Transmission Overheat Indicator is off\\r\\n01 - Transmission Overheat Indicator is on continuously\\r\\n10 - Transmission Overheat Indicator is flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5346":{"PGN":65275,"PGN_Name":"Retarder fluids","PGN_Description":"RF","first_bit":16,"SPN":5346,"SPN_Name":"Driveline Retarder Overheat Indicator","SPN_Description":"Signal from the driveline retarder indicating that its fluid temperature is above normal acceptable limits, and as a result, retarder operation may be altered or restricted.  The indicator is typically a lamp.  Distinctions in meaning between the continuous and flashing are left to the transmission manufacturer.\\r\\n\\r\\n00 - Driveline Retarder Overheat Indicator is off\\r\\n01 - Driveline Retarder Overheat Indicator is on continuously\\r\\n10 - Driveline Retarder Overheat Indicator is flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5347":{"PGN":61485,"PGN_Name":"Acceleration Sensor","PGN_Description":"ACCS","first_bit":0,"SPN":5347,"SPN_Name":"Lateral Acceleration (Extended Range)","SPN_Description":"Indicates lateral acceleration of the vehicle (the component of vehicle acceleration vector along the Y-axis).  A positive lateral acceleration signal results when the vehicle is accelerated to the left.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.  See SPN 1809 for an alternate range and resolution.","bit_length":16,"scaling":0.01,"offset":-320,"unit":"m/s\xb2","SLOT_ID":303},"5348":{"PGN":61485,"PGN_Name":"Acceleration Sensor","PGN_Description":"ACCS","first_bit":16,"SPN":5348,"SPN_Name":"Longitudinal Acceleration (Extended Range)","SPN_Description":"Indicates longitudinal acceleration of the vehicle (the component of vehicle acceleration vector along the X-axis).  A positive longitudinal acceleration signal results when the vehicle speed increases in the forward direction.  Longitudinal acceleration is the same for both Z-Down and Z-Up axis systems, since both systems have positive X axis directed forward.  The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  See SPN 1810 for an alternate longitudinal acceleration.","bit_length":16,"scaling":0.01,"offset":-320,"unit":"m/s\xb2","SLOT_ID":303},"5349":{"PGN":61485,"PGN_Name":"Acceleration Sensor","PGN_Description":"ACCS","first_bit":32,"SPN":5349,"SPN_Name":"Vertical Acceleration (Extended Range)","SPN_Description":"Indicates vertical acceleration of the vehicle and the effect of gravity (the component of vehicle acceleration vector along the Z-axis).  A positive vertical acceleration signal of 1 gravity results when the vehicle is stationary on a horizontal surface.  This parameter is defined according to a Z-Up axis system and the sign of the value is in accordance to the right-hand rule, as specified in SAE J670.  As specified in SAE J670, a Z-Up Axis System has positive X directed forward, positive Y to the left, and positive Z directed up.","bit_length":16,"scaling":0.01,"offset":-320,"unit":"m/s\xb2","SLOT_ID":303},"5350":{"PGN":61485,"PGN_Name":"Acceleration Sensor","PGN_Description":"ACCS","first_bit":48,"SPN":5350,"SPN_Name":"Lateral Acceleration Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for lateral acceleration measurement.\\r\\n\\r\\n00 = lateral acceleration is fully functional.  Data is within sensor specification\\r\\n01 = lateral acceleration is degraded.  Data is suspect due to enviromental conditions\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5351":{"PGN":61485,"PGN_Name":"Acceleration Sensor","PGN_Description":"ACCS","first_bit":50,"SPN":5351,"SPN_Name":"Longitudinal Acceleration Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for longitudinal acceleration measurement.\\r\\n\\r\\n00 = longitudinal acceleration is fully functional.  Data is within sensor specification\\r\\n01 = longitudinal acceleration is degraded.  Data is suspect due to enviromental conditions\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5352":{"PGN":61485,"PGN_Name":"Acceleration Sensor","PGN_Description":"ACCS","first_bit":52,"SPN":5352,"SPN_Name":"Vertical Acceleration Figure of Merit (Extended Range)","SPN_Description":"Figure of merit for vertical acceleration measurement.\\r\\n\\r\\n00 = vertical acceleration is fully functional.  Data is within sensor specification\\r\\n01 = verticalacceleration is degraded.  Data is suspect due to enviromental conditions\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5353":{"PGN":61485,"PGN_Name":"Acceleration Sensor","PGN_Description":"ACCS","first_bit":54,"SPN":5353,"SPN_Name":"Support Variable Transmission Repetition Rate for Acceleration Sensor","SPN_Description":"Indicates which acceleration transmission rate are supported by the ECU in addition to the required 10 ms transmission rate.\\r\\n\\r\\n00 - Reserve for SAE assignment\\r\\n01 - Reserved for SAE assignment\\r\\n10 - 20 ms rate supported\\r\\n11 - ECU only supports standard transmission rate of 10 ms","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5366":{"PGN":64931,"PGN_Name":"Electronic Engine Controller 6","PGN_Description":"EEC6","first_bit":48,"SPN":5366,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Desired Position","SPN_Description":"The requested position of the Engine Turbocharger Compressor Bypass actuator by the engine ECU, where 0% represents bypass fully closed and 100% represents bypass fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5367":{"PGN":64931,"PGN_Name":"Electronic Engine Controller 6","PGN_Description":"EEC6","first_bit":56,"SPN":5367,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Compressor Bypass Actuator 1 by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5368":{"PGN":64931,"PGN_Name":"Electronic Engine Controller 6","PGN_Description":"EEC6","first_bit":61,"SPN":5368,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Temperature Status","SPN_Description":"Used to identify the status of the Engine Turbocharger Compresssor Bypass Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5369":{"PGN":64931,"PGN_Name":"Electronic Engine Controller 6","PGN_Description":"EEC6","first_bit":32,"SPN":5369,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 2 Command","SPN_Description":"The command to a compressor bypass actuator 2, normalized to percent, where 0% nominally represents fully closed and 100% represents fully open. Typically, the turbocharger compressor bypass actuator is used to keep the engine out of surge by metering compressed air (charge).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5370":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":40,"SPN":5370,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Desired Position","SPN_Description":"The Requested Valve position of the Turbocharger Wastegate Valve 1, commanded by the engine ECU. A value of 0% represents fully closed and a value of 100% represents fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5371":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":48,"SPN":5371,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Wastegate Actuator 1 by the manufacturers software.  When there is multiple failures, the most severe is transmitted\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5372":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":53,"SPN":5372,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Temperature Status","SPN_Description":"Used to identify the status of the Engine Turbocharger Wastegate Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5373":{"PGN":65174,"PGN_Name":"Turbocharger Wastegate","PGN_Description":"TCW","first_bit":56,"SPN":5373,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Desired Position","SPN_Description":"The Requested Valve position of the Turbocharger Wastegate Valve 2, commanded by the engine ECU. A value of 0% represents fully closed and a value of 100% represents fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5374":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":0,"SPN":5374,"SPN_Name":"Engine Desired Throttle Valve 1 Position ","SPN_Description":"The desired position of the Throttle valve 1 (SPN 51) that is regulating the fluid, usually air/fuel mixture to the engine as commanded by the Engine Control unit.  0% represents no supply and 100% is full supply.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5375":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":8,"SPN":5375,"SPN_Name":"Engine Throttle Valve 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine throttle valve 1 (SPN 51) by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5376":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":13,"SPN":5376,"SPN_Name":"Engine Throttle Valve 1 Temperature Status","SPN_Description":"Used to identify the status of the engine throttle valve 1 (SPN 51) drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5377":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":16,"SPN":5377,"SPN_Name":"Engine Desired Throttle Valve 2 Position","SPN_Description":"The desired position of the engine throttle valve 2 (SPN 3673) that is regulating the fluid, usually air/fuel mixture to the engine as commanded by the Engine Control Unit.  0% represents no supply and 100% is full supply.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5378":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":24,"SPN":5378,"SPN_Name":"Engine Throttle Valve 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine throttle valve 2 (SPN 3673) by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5379":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":29,"SPN":5379,"SPN_Name":"Engine Throttle Valve 2 Temperature status","SPN_Description":"Used to identify the status of the Engine throttle valve 2 (SPN 3673) drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5380":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":32,"SPN":5380,"SPN_Name":"Engine Fuel Valve 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Fuel Valve 1 by the manufacturers software. When there is multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5381":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":37,"SPN":5381,"SPN_Name":"Engine Fuel Valve 1 Temperature Status","SPN_Description":"Used to identify the status of the Engine Fuel valve 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5382":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":40,"SPN":5382,"SPN_Name":"Engine Fuel Valve 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Fuel Valve 2 by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5383":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":45,"SPN":5383,"SPN_Name":"Engine Fuel Valve 2 Temperature Status","SPN_Description":"Used to identify the status of the Engine Fuel valve 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5384":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":0,"SPN":5384,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Wastegate Actuator 2 by the manufacturers software. When there is multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5385":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":5,"SPN":5385,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Temperature Status","SPN_Description":"Used to identify the status of the Engine Turbocharger Wastegate Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5386":{"PGN":61486,"PGN_Name":"Engine Turbocharger Control","PGN_Description":"ETCC","first_bit":0,"SPN":5386,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Command","SPN_Description":"The command to a Turbocharger Wastegate actuator 1, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow).\\r\\n\\r\\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \\r\\n\\r\\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \\r\\n\\r\\nCalibration status from the actuator is received on SPN 5451.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5387":{"PGN":61486,"PGN_Name":"Engine Turbocharger Control","PGN_Description":"ETCC","first_bit":16,"SPN":5387,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Command","SPN_Description":"The command to a Turbocharger Wastegate actuator 2, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5388":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":0,"SPN":5388,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 2 Position","SPN_Description":"Measures the position of the turbocharger compressor bypass actuator 2, where 0% represents bypass fully closed and 100% represents bypass fully open. Typically, the compressor bypass is used to lower the compressor outlet pressure and/or intake manifold pressure during situations where too much boost is being generated by the turbocharger. Typically, a compressor bypass will be plumbed from the compressor outlet or intake manifold back to the compressor inlet, with the compressor bypass actuator and valve in place to regulate bypass flow.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5389":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":8,"SPN":5389,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 2 Desired Position","SPN_Description":"The desired position of the Engine Turbocharger Compressor Bypass actuator 2 by the engine ECU, where 0% represents bypass fully closed and 100% represents bypass fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5390":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":16,"SPN":5390,"SPN_Name":"Engine Turbocharger compressor Bypass Actuator 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Compressor Bypass Actuator 1 by the manufacturers software.  When there is multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5391":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":21,"SPN":5391,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 2 Temperature Status","SPN_Description":"Used to identify the status of the Engine Turbocharger Compresssor Bypass Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5398":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":56,"SPN":5398,"SPN_Name":"Estimated Pumping - Percent Torque","SPN_Description":"The calculated torque that indicates the estimated amount of torque loss due to the engine air handling system. The value transmitted in this parameter is included in SPN 514 (Nominal Friction - Percent Torque).  The data is transmitted as a percent of reference engine torque (see the engine configuration message, PGN 65251).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5399":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":44,"SPN":5399,"SPN_Name":"DPF Thermal Management Active","SPN_Description":"Indicates that the exhaust temperatures have been elevated for regeneration of the diesel particulate filter aftertreatment system or in preparation of regeneration of the diesel particulate aftertreatment system.\\r\\n\\n00 - DPF Thermal Management is not active\\r\\n01 - DPF Thermal Management is active\\r\\n10 - Reserved\\r\\n11 - Don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5400":{"PGN":61443,"PGN_Name":"Electronic Engine Controller 2","PGN_Description":"EEC2","first_bit":46,"SPN":5400,"SPN_Name":"SCR Thermal Management Active","SPN_Description":"Indicates that the exhaust temperatures have been elevated for regeneration of the SCR aftertreatment system or in preparation of regeneration of the SCR aftertreatment system.\\r\\n\\n00 - SCR Thermal Management is not active\\r\\n01 - SCR Thermal Management is active\\r\\n10 - Reserved\\r\\n11 - Don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5402":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":34,"SPN":5402,"SPN_Name":"Lift Relay Control","SPN_Description":"Command signal used to Engage and Disengage the Lift Relay controlling a Steady-State Magnet.\\r\\n\\n00 = Off, Disable Lift Relay Request \\r\\n01 = On, Enable Lift Relay Request\\r\\n10 = Reserved\\r\\n11 = Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5403":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":36,"SPN":5403,"SPN_Name":"Drop Relay Control","SPN_Description":"Command signal used to Engage and Disengage the Drop Relay controlling a Steady-State Magnet.\\r\\n\\n00 = Off, Disable Drop Relay Request\\r\\n01 = On, Enable Drop Relay Request\\r\\n10 = Reserved\\r\\n11 = Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5404":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":58,"SPN":5404,"SPN_Name":"PTO Shutdown has Shutdown Engine","SPN_Description":"Status signal which identifies whether or not the engine has been shutdown by the PTO shutdown system.\\r\\n\\n00 - No\\r\\n01 - Yes\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5405":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":36,"SPN":5405,"SPN_Name":"Set Elevation Sensor #1 Reference Elevation","SPN_Description":"Command from a display or other external device (i.e. remote switch) to the land leveling system controller instructing the controller to set the reference elvation based on data received from the corresponding land leveling sensor.\\r\\n\\n00 = Do not Set Reference Elevation\\r\\n01 = Set Reference Elevation\\r\\n10 = Reserved\\r\\n11 = Don\'t Care / Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5406":{"PGN":61453,"PGN_Name":"Land Leveling System Operational Information","PGN_Description":"LOI","first_bit":38,"SPN":5406,"SPN_Name":"Set Elevation Sensor #2 Reference Elevation","SPN_Description":"Command from a display or other external device (i.e. remote switch) to the land leveling system controller instructing the controller to set the reference elvation based on data received from the corresponding land leveling sensor.\\r\\n\\r\\n00 = Do not Set Reference Elevation\\r\\n01 = Set Reference Elevation\\r\\n10 = Reserved\\r\\n11 = Don\'t Care / Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5407":{"PGN":65138,"PGN_Name":"Laser Leveling System Blade Control","PGN_Description":"LBC","first_bit":24,"SPN":5407,"SPN_Name":"Blade Control Mode - Left","SPN_Description":"Indicate if the land leveling system\'s automatic control is active or inactive for the elevation sensor on the left side of the blade.  The \\"left\\" notation is applicable to grading machines such tractors and motor graders where \\"left\\" is the position of the elevation sensor as seen by the operator.\\r\\n\\nIf the left sensor is not installed, then the value communicated should be \\"1111\\".  For systems with a single elevation sensor, the system should be flexible enough to be configured in a manner which most accurately represents what is installed on the machine.\\r\\n\\nManual: Operator controls the position of the blade as normal\\r\\nAuto:  The grade control system is controlling the position of the blade without operator input\\r\\nInactive Auto: An operating condition exists which prevents the grade control system from allowing automatic controls to engage.  This would include conditions such as laser signal is not detected, but not faulty components.\\r\\nError:  A fault exists in the system.\\r\\n\\r\\n0000 = Manual\\r\\n0001 = Auto \\r\\n0010 = Inactive Auto\\r\\n0011-1101 = Reserved\\r\\n1110 = Error\\r\\n1111 = Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5408":{"PGN":65138,"PGN_Name":"Laser Leveling System Blade Control","PGN_Description":"LBC","first_bit":28,"SPN":5408,"SPN_Name":"Blade Control Mode - Right","SPN_Description":"Indicate if the land leveling system\'s automatic control is active or inactive for the elevation sensor on the right side of the blade.  The \\"left\\" notation is applicable to grading machines such tractors and motor graders where \\"right\\" is the position of the elevation sensor as seen by the operator.\\r\\n\\r\\nIf the right sensor is not installed, then the value communicated should be \\"1111\\".  For systems with a single elevation sensor, the system should be flexible enough to be configured in a manner which most accurately represents what is installed on the machine.\\r\\n\\nManual: Operator controls the position of the blade as normal\\r\\nAuto:  The grade control system is controlling the position of the blade without operator input\\r\\nInactive Auto: An operating condition exists which prevents the grade control system from allowing automatic controls to engage.  This would include conditions such as laser signal is not detected, but not faulty components.\\r\\nError:  A fault exists in the system.\\r\\n\\r\\n0000 = Manual\\r\\n0001 = Auto \\r\\n0010 = Inactive Auto\\r\\n0011-1101 = Reserved\\r\\n1110 = Error\\r\\n1111 = Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5409":{"PGN":65138,"PGN_Name":"Laser Leveling System Blade Control","PGN_Description":"LBC","first_bit":32,"SPN":5409,"SPN_Name":"Land Leveling System Enable Status","SPN_Description":"Communicate the enable/disable status of the Land Leveling System.\\r\\n\\n00 = Disabled\\r\\n01= Enabled\\r\\n10 = Error\\r\\n11 = Not available / Not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5410":{"PGN":64750,"PGN_Name":"Land Leveling System Reference Elevation Data","PGN_Description":"LLRE","first_bit":0,"SPN":5410,"SPN_Name":"Blade Elevation Deviation - Left","SPN_Description":"Indicate the blade\'s left elevation deviation with respect to the reference elevation.  Serves as an indication of how far the left end of the blade is above or below grade.  A positive number indicates that the blade is above the desired grade.  A negative value indicates the blade is below the desired grade.","bit_length":16,"scaling":1,"offset":-32000,"unit":"mm","SLOT_ID":235},"5411":{"PGN":64750,"PGN_Name":"Land Leveling System Reference Elevation Data","PGN_Description":"LLRE","first_bit":16,"SPN":5411,"SPN_Name":"Blade Elevation Deviation - Right","SPN_Description":"Indicate the blade\'s right elevation deviation with respect to the reference elevation.  Serves as an indication of how far the left end of the blade is above or below grade.  A positive number indicates that the blade is above the desired grade.  A negative value indicates the blade is below the desired grade.","bit_length":16,"scaling":1,"offset":-32000,"unit":"mm","SLOT_ID":235},"5412":{"PGN":64750,"PGN_Name":"Land Leveling System Reference Elevation Data","PGN_Description":"LLRE","first_bit":32,"SPN":5412,"SPN_Name":"Blade Reference Elevation Offset - Left","SPN_Description":"Indicates the blade\'s left elevation offset with respect to the reference elevation.  An offset of 0 m represents no offset from the reference elevation.  A positive number indicates that the offset elevation is above the original reference elevation.  A negative value indicates the offset elevation is below the original reference elevation.","bit_length":16,"scaling":1,"offset":-32000,"unit":"mm","SLOT_ID":235},"5413":{"PGN":64750,"PGN_Name":"Land Leveling System Reference Elevation Data","PGN_Description":"LLRE","first_bit":48,"SPN":5413,"SPN_Name":"Blade Reference Elevation Offset - Right","SPN_Description":"Indicates the blade\'s right elevation offset with respect to the reference elevation.  An offset of 0 m represents no offset from the reference elevation.  A positive number indicates that the offset elevation is above the original reference elevation.  A negative value indicates the offset elevation is below the original reference elevation.","bit_length":16,"scaling":1,"offset":-32000,"unit":"mm","SLOT_ID":235},"5414":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":24,"SPN":5414,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Quick Thaw Heater Command","SPN_Description":"The command for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 1 (exhaust bank 1).  See SPN 4372 for the measured heater percentage for the heater of this same tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5415":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":24,"SPN":5415,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Quick Thaw Heater Command","SPN_Description":"The command for the heater of the diesel exhaust fluid quick thaw tank for aftertreatment system 2 (exhaust bank 2).  See SPN 4438 for the measured heater percentage for the heater of this same tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5416":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":62,"SPN":5416,"SPN_Name":"Engine Wait To Start Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Wait To Start Lamp.  See SPN 1081 for the command.\\r\\n\\n00 - Lamp deactived (off)\\r\\n01 - Lamp actived (on)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5417":{"PGN":64752,"PGN_Name":"Engine Fuel/lube systems 2","PGN_Description":"EFS2","first_bit":0,"SPN":5417,"SPN_Name":"Engine Fuel Filter (Suction Side) Intake Absolute Pressure","SPN_Description":"Absolute pressure of fuel at the intake of the fuel filter (suction side) located between the fuel tank and the fuel supply pump.  See Figures SPN16_A & SPN16_B.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5422":{"PGN":64976,"PGN_Name":"Intake/Exhaust Conditions 2","PGN_Description":"IC2","first_bit":56,"SPN":5422,"SPN_Name":"Engine Intake Manifold 2 Absolute Pressure","SPN_Description":"The absolute pressure measurement of the air intake manifold for bank 2 or the second air intake manifold. If there are multiple air pressure sensors in the intake stream, this is the last one in flow direction before entering the combustion chamber.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5423":{"PGN":64869,"PGN_Name":"Aftertreatment 1 Fuel Control 2","PGN_Description":"AT1FC2","first_bit":16,"SPN":5423,"SPN_Name":"Aftertreatment 1 Fuel Pump Relay Control","SPN_Description":"Indicates how the device is controlling the aftertreatment 1 fuel pump relay.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5424":{"PGN":64869,"PGN_Name":"Aftertreatment 1 Fuel Control 2","PGN_Description":"AT1FC2","first_bit":18,"SPN":5424,"SPN_Name":"Aftertreatment 1 Fuel Flow Diverter Valve Control","SPN_Description":"Indicates how the device is controlling the aftertreatment 1 fuel flow diverter valve. When this valve is on it diverts fuel flow from the Aftertreatment 1 Regeneration Device.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5425":{"PGN":64869,"PGN_Name":"Aftertreatment 1 Fuel Control 2","PGN_Description":"AT1FC2","first_bit":24,"SPN":5425,"SPN_Name":"Aftertreatment 1 Fuel Pressure 2 Actuator Control","SPN_Description":"Indicates how the device is controlling the aftertreatment 1 fuel pressure 2 regulating control valve.   0% = fully closed, 100%=fully open.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5426":{"PGN":64836,"PGN_Name":"Aftertreatment 2 Fuel Control 2","PGN_Description":"AT2FC2","first_bit":16,"SPN":5426,"SPN_Name":"Aftertreatment 2 Fuel Pump Relay Control","SPN_Description":"Indicates how the device is controlling the aftertreatment 2 fuel pump relay.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5427":{"PGN":64836,"PGN_Name":"Aftertreatment 2 Fuel Control 2","PGN_Description":"AT2FC2","first_bit":18,"SPN":5427,"SPN_Name":"Aftertreatment 2 Fuel Flow Diverter Valve Control","SPN_Description":"Indicates how the device is controlling the aftertreatment 2 fuel flow diverter valve. When this valve is on it diverts fuel flow from the Aftertreatment 2 Regeneration Device.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5428":{"PGN":64836,"PGN_Name":"Aftertreatment 2 Fuel Control 2","PGN_Description":"AT2FC2","first_bit":24,"SPN":5428,"SPN_Name":"Aftertreatment 2 Fuel Pressure 2 Control","SPN_Description":"Indicates how the device is controlling the aftertreatment 2 fuel pressure 2 regulating control valve.   0% = fully closed, 100%=fully open.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5429":{"PGN":64768,"PGN_Name":"Engine Fluid Level/Pressure 10","PGN_Description":"EFL/P10","first_bit":40,"SPN":5429,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Intake Absolute Pressure","SPN_Description":"EGR intake absolute pressure measured before the EGR 2 valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5430":{"PGN":64751,"PGN_Name":"Engine Fluid Level/Pressure 11","PGN_Description":"EFL/P11","first_bit":0,"SPN":5430,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Intake Absolute Pressure","SPN_Description":"EGR intake absolute pressure measured before the EGR 1 valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5431":{"PGN":64751,"PGN_Name":"Engine Fluid Level/Pressure 11","PGN_Description":"EFL/P11","first_bit":16,"SPN":5431,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Outlet Absolute Pressure (High Resolution)","SPN_Description":"EGR outlet absolute pressure is measured after the EGR 1 valve. See SPN 5019 for 1 byte resolution.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5432":{"PGN":65114,"PGN_Name":"Air Suspension Control 1","PGN_Description":"ASC1","first_bit":60,"SPN":5432,"SPN_Name":"Memory level","SPN_Description":"Signal which indicates that the air suspension control has memory levels selected or stored.\\r\\n\\r\\nResponse to memory level request in ASC2 (byte 8.5). If the request was executed the respective status will be set. If the request was not executed \\"requested level not available\\" will be set in Suspension control refusal information (ASC1 byte 8.1). \\r\\n\\n0000: No memory level \\r\\n0001: Memory level 1 selected \\r\\n0010: Memory level 2 selected\\r\\n0011: Memory level 3 selected\\r\\n0100: Memory level 4 selected\\r\\n0101: Memory level 5 selected\\r\\n0110: reserved\\r\\n0111: reserved\\r\\n1000: reserved\\r\\n1001: Memory level  1 stored\\r\\n1010: Memory level  2 stored\\r\\n1011: Memory level  3 stored\\r\\n1100: Memory level  4 stored\\r\\n1101: Memory level  5 stored\\r\\n1110: Error indicator\\r\\n1111: not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5433":{"PGN":53760,"PGN_Name":"Air Suspension Control 2","PGN_Description":"ASC2","first_bit":60,"SPN":5433,"SPN_Name":"Memory level request","SPN_Description":"Signal which indicates that the air suspension control requests a memory level or a memory level shall be stored.\\r\\n\\r\\nThe storage of  the current memory level is requested by  \\"Store memory level x\\". The acknowledge is set in \\"memory level x stored\\" (ASC1 byte 8.5). A memory level demand is requested by \\"Memory level x request\\".  The acknowledge is set in \\"memory level x selected\\" (ASC1 byte 8.5)\\r\\n\\n0000: No memory level request\\r\\n0001: Memory level 1 request\\r\\n0010: Memory level 2 request\\r\\n0011: Memory level 3 request\\r\\n0100: Memory level 4 request\\r\\n0101: Memory level 5 request\\r\\n0110: reserved\\r\\n0111: reserved\\r\\n1000: reserved\\r\\n1001: Store Memory level  1\\r\\n1010: Store Memory level  2\\r\\n1011: Store Memory level  3\\r\\n1100: Store Memory level  4\\r\\n1101: Store Memory level  5\\r\\n1110: Reserved\\r\\n1111: Don\'t care","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5434":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":32,"SPN":5434,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Fill Valve Command","SPN_Description":"Commanded percentage of maximum Aftertreatment 1 Diesel Exhaust Fluid Tank Fill Valve opening. 100% means the fill valve is fully open providing maximum flow of diesel exhaust fluid into the diesel exhaust fluid tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5435":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":40,"SPN":5435,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump State","SPN_Description":"State of the aftertreatment 1 Diesel Exhaust Fluid dosing pump.  Indicates whether or not the pump is operational.\\r\\n\\r\\n00  pump operational\\r\\n01  pump error\\r\\n10  reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5436":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":48,"SPN":5436,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Drain Valve Command","SPN_Description":"Commanded percentage of maximum Aftertreatment 1 Diesel Exhaust Fluid Tank Drain Valve opening. 100% means the drain valve is fully open providing maximum flow of diesel exhaust fluid out of the diesel exhaust fluid tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5437":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":32,"SPN":5437,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Fill Valve Command","SPN_Description":"Commanded percentage of maximum Aftertreatment 2 Diesel Exhaust Fluid Tank Fill Valve opening. 100% means the fill valve is fully open providing maximum flow of diesel exhaust fluid into the diesel exhaust fluid tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5438":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":40,"SPN":5438,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump State","SPN_Description":"State of Aftertreatment 2 Diesel Exhaust Fluid dosing pump.\\r\\n\\n00  pump operational\\r\\n01  pump error\\r\\n10  reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5439":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":48,"SPN":5439,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Drain Valve Command","SPN_Description":"Commanded percentage of maximum Aftertreatment 2 Diesel Exhaust Fluid Tank Drain Valve opening. 100% means the the drain valve is fully open providing maximum flow of diesel exhaust fluid out of  the diesel exhaust fluid tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5444":{"PGN":64916,"PGN_Name":"Electronic Engine Controller 7","PGN_Description":"EEC7","first_bit":32,"SPN":5444,"SPN_Name":"Engine Crankcase Breather Oil Separator Speed","SPN_Description":"The speed of a rotating (centrifugal) crankcase oil separator.","bit_length":16,"scaling":1,"offset":0,"unit":"rpm","SLOT_ID":223},"5445":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":48,"SPN":5445,"SPN_Name":"Engine Throttle Valve 1 Operation Status","SPN_Description":"Used to identify the status of engine throttle valve 1 (SPN 51).\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 3464)\\r\\n0111 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error\\r\\n1111 \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5446":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":52,"SPN":5446,"SPN_Name":"Engine Throttle Valve 2 Operation Status","SPN_Description":"Used to identify the status of engine throttle valve 2 (SPN 3673).\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5447":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":56,"SPN":5447,"SPN_Name":"Engine Fuel Valve 1 Operation Status","SPN_Description":"Used to identify the status of Engine Fuel Valve 1.\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 Test Mode Active\\r\\n0111 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5448":{"PGN":64754,"PGN_Name":"Engine Fuel/Throttle Valve Information 1","PGN_Description":"EFTVI1","first_bit":60,"SPN":5448,"SPN_Name":"Engine Fuel Valve 2 Operation Status","SPN_Description":"Used to identify the status of Engine Fuel Valve 2.\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 Test Mode Active\\r\\n0111 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5449":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":24,"SPN":5449,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Operation Status","SPN_Description":"Used to identify the status of Engine Turbocharger Compressor Bypass Actuator 1.\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5450":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":28,"SPN":5450,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 2 Operation Status","SPN_Description":"Used to identify the status of Engine Turbocharger Compressor Bypass Actuator 2.\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5451":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":8,"SPN":5451,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Operation Status","SPN_Description":"Used to identify the status of Engine Turbocharger Wastegate Actuator 1.\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 5386)\\r\\n0111 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5452":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":12,"SPN":5452,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Operation Status","SPN_Description":"Used to identify the status of Engine Turbocharger Wastegate Actuator 2.\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 1101   Reserved for future assignment\\r\\n1110 \u2013 Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5454":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":256,"SPN":5454,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Average Time Between Active Regenerations","SPN_Description":"Indicates the average time since last reset between active regenerations, that have not been forced to occur by manual request, for Aftertreatment device 1.\\r\\n\\r\\nIf the manufacturer allows this parameter to be reset, this time is the average since last reset.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"5455":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":256,"SPN":5455,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Average Time Between Active Regenerations","SPN_Description":"Indicates the average time since last reset between active regenerations, that have not been forced to occur by manual request, for Aftertreatment device 2.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"5456":{"PGN":64869,"PGN_Name":"Aftertreatment 1 Fuel Control 2","PGN_Description":"AT1FC2","first_bit":40,"SPN":5456,"SPN_Name":"Aftertreatment 1 Hydrocarbon Doser Intake Fuel Temperature","SPN_Description":"Measured temperature of the intake fuel to the hydrocarbon dosing device.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5457":{"PGN":64981,"PGN_Name":"Electronic Engine Controller 5","PGN_Description":"EEC5","first_bit":52,"SPN":5457,"SPN_Name":"Engine Variable Geometry Turbocharger 1 Control Mode","SPN_Description":"Indicates if the variable geometry turbocharger control status is either open loop or closed loop.\\r\\n\\r\\n00 open loop\\r\\n01 closed loop\\r\\n10 SAE reserved\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5458":{"PGN":65203,"PGN_Name":"Fuel Information 1 (Liquid)","PGN_Description":"LFI1","first_bit":48,"SPN":5458,"SPN_Name":"Flexible Fuel Percentage","SPN_Description":"Measured signal that indicates the percentage of alcohol in the fuel currently being used.  0% means no alcohol in fuel, 100% means alcohol as fuel and nothing else.\\r\\n\\r\\nEXAMPLE: If a Bi-fuel vehicle has less than 10% ethanol in the gasoline/petrol, then the external test equipment shall display state 0x09 (See SPN 5837). In such a case, the system would be using gasoline/petrol (fuel) tables and OBD thresholds. SPN 5458 should either artificially display 0% or some number 10% or less if the system has such resolution. If the ethanol in the gasoline/petrol is above 10%, then the external test equipment shall display state 0x0B. SPN 5458 shall report the calculated ethanol/alcohol percentage.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5459":{"PGN":64748,"PGN_Name":"Aftertreatment 1 NOx Adsorber Information","PGN_Description":"AFT1NAI","first_bit":0,"SPN":5459,"SPN_Name":"Aftertreatment 1 NOx Adsorber Regeneration Status","SPN_Description":"Indicates whether the NOx adsorber regeneration in the first aftertreatment system is active or inactive.\\r\\n\\r\\n00  Inactive\\r\\n01  Active\\r\\n10  Error indicator\\r\\n11  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5460":{"PGN":64747,"PGN_Name":"Aftertreatment 2 NOx Adsorber Information","PGN_Description":"AFT2NAI","first_bit":0,"SPN":5460,"SPN_Name":"Aftertreatment 2 NOx Adsorber Regeneration Status","SPN_Description":"Indicates whether the NOx adsorber regeneration in the second aftertreatment system is active or inactive\\r\\n\\r\\n00  Inactive\\r\\n01  Active\\r\\n10  Error indicator\\r\\n11  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5461":{"PGN":64748,"PGN_Name":"Aftertreatment 1 NOx Adsorber Information","PGN_Description":"AFT1NAI","first_bit":2,"SPN":5461,"SPN_Name":"Aftertreatment 1 NOx Adsorber Desulfation Status","SPN_Description":"Indicates whether the NOx adsorber desulfation regeneration in the first aftertreatment system is active or inactive\\r\\n\\r\\n00  Inactive\\r\\n01  Active\\r\\n10  Error indicator\\r\\n11  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5462":{"PGN":64747,"PGN_Name":"Aftertreatment 2 NOx Adsorber Information","PGN_Description":"AFT2NAI","first_bit":2,"SPN":5462,"SPN_Name":"Aftertreatment 2 NOx Adsorber Desulfation Status","SPN_Description":"Indicates whether the NOx adsorber desulfation regeneration in the second aftertreatment system is active or inactive\\r\\n\\r\\n00  Inactive\\r\\n01  Active\\r\\n10  Error indicator\\r\\n11  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5463":{"PGN":64878,"PGN_Name":"Aftertreatment 1 SCR Service Information 1","PGN_Description":"A1SCRSI1","first_bit":40,"SPN":5463,"SPN_Name":"Aftertreatment SCR Operator Inducement Active Traveled Distance","SPN_Description":"The distance traveled while SCR inducement (SPN 5246 is equal to level 1 to 5) is active.  Distance is reset once inducement is no longer active for SCR (SPN 5246 = 0).\\r\\n\\r\\nEmission Control System Operator Inducement Severity, SPN 5826, may be active (is equal to level 1 to 5) due to an SCR condition specified by emissions regulations that is associated with SPN 5246.","bit_length":16,"scaling":1,"offset":0,"unit":"km","SLOT_ID":270},"5464":{"PGN":64695,"PGN_Name":"Hybrid System Status 2","PGN_Description":"HSS2","first_bit":0,"SPN":5464,"SPN_Name":"Hybrid Battery Pack Remaining Charge","SPN_Description":"Indicates the hybrid battery pack remaining charge. 0% means no charge remaining, 100% means full charge remaining.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5465":{"PGN":65214,"PGN_Name":"Electronic Engine Controller 4","PGN_Description":"EEC4","first_bit":34,"SPN":5465,"SPN_Name":"Engine Intake Manifold Pressure Control Mode","SPN_Description":"Indicates that the Boost Pressure Closed Loop Control status either open loop or closed loop.\\r\\n\\r\\n00  Open loop \\r\\n01  Closed loop \\r\\n10  SAE reserved\\r\\n11  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5466":{"PGN":64891,"PGN_Name":"Aftertreatment 1 Service 1","PGN_Description":"AT1S1","first_bit":48,"SPN":5466,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Load Regeneration Threshold","SPN_Description":"This parameter indicates the value that will first cause DPF regeneration in aftertreatment 1. There may be multiple parameters that cause DPF regeneration (e.g. Percent Soot Load, DPF delta pressure converted to normalized percentage, etc.).  If there are multiple inputs to this parameter that may cause active DPF regeneration, the highest value shall always be reported.\\r\\n\\r\\n100% is the level at which active diesel particulate filter regeneration should be triggered. 100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter. Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5467":{"PGN":64890,"PGN_Name":"Aftertreatment 2 Service 1","PGN_Description":"AT2S1","first_bit":48,"SPN":5467,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Load Regeneration Threshold","SPN_Description":"This parameter indicates the value that will first cause DPF regeneration in aftertreatment 2. There may be multiple parameters that cause DPF regeneration (e.g. Percent Soot Load, DPF delta pressure converted to normalized percentage, etc.).  If there are multiple inputs to this parameter that may cause active DPF regeneration, the highest value shall always be reported.\\r\\n\\r\\n100% is the level at which active diesel particulate filter regeneration should be triggered. 100% level is the active regeneration trigger level (and if conditions are not favorable for regeneration, soot loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated diesel particulate filter. Values of 25%, 50% and 75% will indicate the general level of soot prior to the 100% level where an active regeneration is needed.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5468":{"PGN":64776,"PGN_Name":"Engine oil message","PGN_Description":"EOM","first_bit":32,"SPN":5468,"SPN_Name":"Engine Oil Relative Dielectricity (High Resolution)","SPN_Description":"Engine oil relative dielectricity used to describe the engine oil quality.","bit_length":16,"scaling":0.0001220703125,"offset":0,"unit":null,"SLOT_ID":307},"5469":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":22,"SPN":5469,"SPN_Name":"Engine Fuel Filter Restricted Lamp Command","SPN_Description":"Command signal directly controlling the Engine Fuel Filter Restricted Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5470":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":22,"SPN":5470,"SPN_Name":"Engine Fuel Filter Restricted Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Fuel Filter Restricted Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5471":{"PGN":64743,"PGN_Name":"Engine Configuration 3","PGN_Description":"EC3","first_bit":0,"SPN":5471,"SPN_Name":"Engine Friction Percent Torque At Idle, Point 1","SPN_Description":"The static portion of the friction torque at speed point 1 (SPN 188) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping \u2013 Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5472":{"PGN":64743,"PGN_Name":"Engine Configuration 3","PGN_Description":"EC3","first_bit":8,"SPN":5472,"SPN_Name":"Engine Friction Percent Torque, Point 2","SPN_Description":"The static portion of the friction torque at speed point 2 (SPN 528) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping \u2013 Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5473":{"PGN":64743,"PGN_Name":"Engine Configuration 3","PGN_Description":"EC3","first_bit":16,"SPN":5473,"SPN_Name":"Engine Friction Percent Torque, Point 3","SPN_Description":"The static portion of the friction torque at speed point 3 (SPN 529) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping \u2013 Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5474":{"PGN":64743,"PGN_Name":"Engine Configuration 3","PGN_Description":"EC3","first_bit":24,"SPN":5474,"SPN_Name":"Engine Friction Percent Torque, Point 4","SPN_Description":"The static portion of the friction torque at speed point 4 (SPN 530) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping \u2013 Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5475":{"PGN":64743,"PGN_Name":"Engine Configuration 3","PGN_Description":"EC3","first_bit":32,"SPN":5475,"SPN_Name":"Engine Friction Percent Torque, Point 5","SPN_Description":"The static portion of the friction torque at speed point 5 (SPN 531) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping \u2013 Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5476":{"PGN":64743,"PGN_Name":"Engine Configuration 3","PGN_Description":"EC3","first_bit":40,"SPN":5476,"SPN_Name":"Engine Friction Percent Torque, Point 6","SPN_Description":"For engine configuration map modes 1 and 2, this is the static portion of the friction torque at speed point 6 (SPN 532) of the engine torque map.  For engine configuration map mode 3, this parameter is the static portion of the friction torque at the engine speed calculated by using Engine Gain (Kp) Of The Endspeed Governor (SPN 545) where torque is 0.  This parameter does not include Estimated Pumping \u2013 Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544)..","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5477":{"PGN":64743,"PGN_Name":"Engine Configuration 3","PGN_Description":"EC3","first_bit":48,"SPN":5477,"SPN_Name":"Engine Friction Percent Torque, Point 7","SPN_Description":"The static portion of the friction torque at speed point 7 (SPN 533) of the engine torque map in the engine configuration message.  This parameter does not include Estimated Pumping \u2013 Percent Torque (SPN 5398) and is expected to change with temperature.  The data is transmitted as a percent of the reference engine torque (SPN 544).","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"5480":{"PGN":64551,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 2","PGN_Description":"A1DEFI2","first_bit":0,"SPN":5480,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Controller 1 Temperature","SPN_Description":"Temperature of the diesel exhaust fluid at the aftertreatment 1 diesel exhaust fluid controller.\\r\\n\\r\\nFor controllers that have more exhaust emissions control functions than only diesel exhaust fluid control, see SPN 5486 - exhaust emission control ECU temperature or SPN 1136 - engine ECU temperature.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5490":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":38,"SPN":5490,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 5","SPN_Description":"Identifies the diesel exhaust fluid line heater 5 request for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 request for heater to be inactive \\r\\n01 request for heater to be active \\r\\n10 reserved for future assignment by SAE \\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5491":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":40,"SPN":5491,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 1","SPN_Description":"The Aftertreatment Diesel Exhaust Fluid Line Heater Relay 1 is used to energize one or more DEF line heaters.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5492":{"PGN":64745,"PGN_Name":"Armrest Switch Matrix Commands","PGN_Description":"ARMSWIMC","first_bit":2,"SPN":5492,"SPN_Name":"Armrest 1 Switch 2","SPN_Description":"Status of the second switch located in armrest 1.\\r\\n\\r\\n00: Off\\r\\n01: On\\r\\n10: Reserved\\r\\n11: Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5493":{"PGN":64745,"PGN_Name":"Armrest Switch Matrix Commands","PGN_Description":"ARMSWIMC","first_bit":4,"SPN":5493,"SPN_Name":"Armrest 2 Switch 1","SPN_Description":"Status of the first switch located in armrest 2.\\r\\n\\r\\n00: Off\\r\\n01: On\\r\\n10: Reserved\\r\\n11: Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5494":{"PGN":64745,"PGN_Name":"Armrest Switch Matrix Commands","PGN_Description":"ARMSWIMC","first_bit":6,"SPN":5494,"SPN_Name":"Armrest 2 Switch 2","SPN_Description":"Status of the second switch located in armrest 2.\\r\\n\\r\\n00: Off\\r\\n01: On\\r\\n10: Reserved\\r\\n11: Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5495":{"PGN":37888,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Sensor Calibration","PGN_Description":"AT1DPFSSC","first_bit":0,"SPN":5495,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Mean Calibration Offset","SPN_Description":"Calibration offset for the soot Mean for Aftertreatment 1 Diesel Particulate Filter soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5496":{"PGN":37888,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Sensor Calibration","PGN_Description":"AT1DPFSSC","first_bit":16,"SPN":5496,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Soot Standard Deviation Calibration Offset","SPN_Description":"Calibration offset for the soot standard deviation for Aftertreatment 1 Diesel Particulate Filter soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5497":{"PGN":38144,"PGN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Sensor Calibration","PGN_Description":"AT2DPFSSC","first_bit":0,"SPN":5497,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Mean Calibration Offset","SPN_Description":"Calibration offset for the soot Mean for Aftertreatment 2 Diesel Particulate Filter soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5498":{"PGN":38144,"PGN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Sensor Calibration","PGN_Description":"AT2DPFSSC","first_bit":16,"SPN":5498,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Soot Standard Deviation Calibration Offset","SPN_Description":"Calibration offset for the soot standard deviation for Aftertreatment 2 Diesel Particulate Filter soot sensor.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5499":{"PGN":64744,"PGN_Name":"Intake Valve Actuation Control","PGN_Description":"IVAC","first_bit":0,"SPN":5499,"SPN_Name":"Intake Valve Actuation System Oil Pressure 1 Solenoid Control","SPN_Description":"Indicates the current command to the solenoid that controls the intake valve actuation system oil pressure 1 valve. This valve opens or closes a connection from the intake valve actuation oil rail to tank.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5500":{"PGN":64744,"PGN_Name":"Intake Valve Actuation Control","PGN_Description":"IVAC","first_bit":2,"SPN":5500,"SPN_Name":"Intake Valve Actuation System Oil Pressure 2 Solenoid Control","SPN_Description":"Indicates the current command to the solenoid that controls the intake valve actuation system oil pressure 2 valve. This valve opens or closes a connection from the intake valve actuation oil rail to tank.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5501":{"PGN":64736,"PGN_Name":"Diesel Particulate Filter Control 2","PGN_Description":"DPFC2","first_bit":0,"SPN":5501,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Intake Temperature Set Point","SPN_Description":"Set point temperature for the particulate filter (DPF) regeneration at the intake to the DPF for Exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5502":{"PGN":64736,"PGN_Name":"Diesel Particulate Filter Control 2","PGN_Description":"DPFC2","first_bit":16,"SPN":5502,"SPN_Name":"Engine Unburned Fuel Percentage","SPN_Description":"The unburned amount of diesel fuel coming out of the engine. This fuel increases the temperature while oxidated in the DOC. Therefore, this amount of fuel also needs to be taken into account of the HCD temperature controller.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5503":{"PGN":64736,"PGN_Name":"Diesel Particulate Filter Control 2","PGN_Description":"DPFC2","first_bit":32,"SPN":5503,"SPN_Name":"Aftertreatment 1 Fuel Mass Rate","SPN_Description":"Mass rate of total fuel being delivered to aftertreatment 1 for DPF regeneration.","bit_length":16,"scaling":0.05,"offset":0,"unit":"g/min","SLOT_ID":317},"5504":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":56,"SPN":5504,"SPN_Name":"Hydrocarbon Doser Purging Enable","SPN_Description":"Purging enable of the Hydrocarbon Doser (HCD).\\r\\n\\r\\n00 Purging not enabled\\r\\n01 Purging enabled - less urgent\\r\\n10 Purging enabled - urgent\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5505":{"PGN":37376,"PGN_Name":"Aftertreatment 1 Hydrocarbon Doser Information 1","PGN_Description":"HCDI1","first_bit":0,"SPN":5505,"SPN_Name":"Requested Fuel Mass Rate","SPN_Description":"Requested fuel dosing quantity from hydrocarbon doser.","bit_length":16,"scaling":0.05,"offset":0,"unit":"g/min","SLOT_ID":317},"5506":{"PGN":37376,"PGN_Name":"Aftertreatment 1 Hydrocarbon Doser Information 1","PGN_Description":"HCDI1","first_bit":16,"SPN":5506,"SPN_Name":"HC Doser Status","SPN_Description":"Indicates whether the HC Doser/ HC Dosing system is enabled or is waiting for regeneration.\\r\\n\\r\\n000 HC doser disabled\\r\\n001 HC doser active\\r\\n010 SAE reserved\\r\\n011 HC doser enabled, waiting for regeneration\\r\\n100 SAE reserved\\r\\n101 SAE reserved\\r\\n110 Error\\r\\n111 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5507":{"PGN":37376,"PGN_Name":"Aftertreatment 1 Hydrocarbon Doser Information 1","PGN_Description":"HCDI1","first_bit":19,"SPN":5507,"SPN_Name":"HC Doser Injecting Status","SPN_Description":"Indicates whether the Hydrocarbon Doser (HCD) is presently injecting diesel fuel into the exhaust pipe.\\r\\n\\r\\n00 Injecting not active\\r\\n01 Injecting active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5508":{"PGN":37376,"PGN_Name":"Aftertreatment 1 Hydrocarbon Doser Information 1","PGN_Description":"HCDI1","first_bit":21,"SPN":5508,"SPN_Name":"Diagnostic Status of HC Doser","SPN_Description":"Indicates whether an error is active in the Hydrocarbon Doser (HCD) or whether the internal cyclic system test of the HCD is presently active.  \\r\\n\\r\\nThis is not intended to replace the DM8/DM30 - Test results requirement for OBD.\\r\\n\\r\\n\\r\\n000 System test has executed and passed or System test has not yet executed\\r\\n001 Internal system test is in process\\r\\n010 - 101  SAE reserved\\r\\n110 Error  --  System test has failed\\r\\n111 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5509":{"PGN":37376,"PGN_Name":"Aftertreatment 1 Hydrocarbon Doser Information 1","PGN_Description":"HCDI1","first_bit":24,"SPN":5509,"SPN_Name":"Hydrocarbon Doser Purging Required","SPN_Description":"Purging of the Hydrocarbon Doser (HCD) is required.  Request could come from the HCD system.\\r\\n\\r\\n00   Purging not required\\r\\n01   Purging required - less urgent\\r\\n10   Purging required - urgent\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5510":{"PGN":37120,"PGN_Name":"Vehicle/Chassis Lubrication System 1","PGN_Description":"VLS1","first_bit":0,"SPN":5510,"SPN_Name":"Lubrication Cycle Mode Lock Command","SPN_Description":"Command signal to lock or unlock the ability to change the lubrication cycle mode.  Locking the lubrication mode would prevent the changing of the lubrication cycle mode, perhaps by an operator.\\r\\n\\r\\n00 - Not Locked\\r\\n01 - Locked\\r\\n10 - Reserved\\r\\n11 - No action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5511":{"PGN":37120,"PGN_Name":"Vehicle/Chassis Lubrication System 1","PGN_Description":"VLS1","first_bit":2,"SPN":5511,"SPN_Name":"Lubrication Cycle Set Command","SPN_Description":"Command signal to change the lubrication cycle. It gives the operator or technician the ability to the change the frequency of lubrication.\\r\\n\\r\\n000 - Cycle mode # 1 (Lowest Lubrication Frequency)\\r\\n001 - Cycle mode # 2\\r\\n010 - Cycle mode # 3 (Highest Lubrication Frequency)\\r\\n011 to 110 - Reserved \\r\\n111 - No action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5512":{"PGN":37120,"PGN_Name":"Vehicle/Chassis Lubrication System 1","PGN_Description":"VLS1","first_bit":5,"SPN":5512,"SPN_Name":"Lubrication Operation Mode Set Command","SPN_Description":"Command signal to change lubrication system operational mode. The mode set command gives the operator and/or technician the ability to change the operational mode when diagnosing and servicing of the system is required.\\r\\n\\r\\nAutomatic is the normal operation mode of lubrication system. In this mode the operator has the privilege to change duty cycle mode, if the lubrication mode in not locked.\\r\\nIn manual service mode the service tool temporary takes control of the pump controller for service purposes.\\r\\n\\r\\nThe Test mode # x shall command the system to perform pre-defined greasing cycles in order to verify operation of the lubrication system.\\r\\n\\r\\n000 - Automatic Mode\\r\\n001 - Manual Service Mode\\r\\n010 - Test Mode # 1\\r\\n011 - Test Mode # 2\\r\\n100 - Test Mode # 3\\r\\n101-110 - Reserved\\r\\n111 - Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5513":{"PGN":37120,"PGN_Name":"Vehicle/Chassis Lubrication System 1","PGN_Description":"VLS1","first_bit":8,"SPN":5513,"SPN_Name":"Lubrication Pump Enable Command","SPN_Description":"Command signal to reset the lubrication pump.  It allows the operator and/or technician to reset the paused lubrication pump and clear lubrication system faults. This shall enable the lubrication system to resume its normal operation. \\r\\n\\r\\n00 - No action (Normal pump operation)\\r\\n01 - Reset pump operation  \\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5514":{"PGN":37120,"PGN_Name":"Vehicle/Chassis Lubrication System 1","PGN_Description":"VLS1","first_bit":10,"SPN":5514,"SPN_Name":"Lubrication Timing Cycle Command","SPN_Description":"Command signal to enable or pause the lubrication activation clock \\r\\n\\r\\n00 - Pause\\r\\n01 - Enable\\r\\n10 - Reserved \\r\\n11 - Take no action     \\r\\n\\r\\nNote:  In some vehicles or machines the lubrication is only required when the vehicle or machine is in certain state (such as when a certain gear is engaged, operator\'s armrest in place etc.). To prevent unwanted grease lubrication, a timing cycle clock is used. This clock is only ticked for the time the vehicle or machine is in the defined state. Starting or stopping of the clock is controlled using an external input.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5515":{"PGN":64742,"PGN_Name":"Vehicle/Chassis Lubrication System 2","PGN_Description":"VLS2","first_bit":0,"SPN":5515,"SPN_Name":"Lubrication Cycle Mode Lock Status","SPN_Description":"Reports status of the ability to change the lubrication cycle mode.  Locking the lubrication mode would prevent the changing of the lubrication cycle mode, perhaps by an operator\\r\\n\\r\\n00 - Not Locked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5516":{"PGN":64742,"PGN_Name":"Vehicle/Chassis Lubrication System 2","PGN_Description":"VLS2","first_bit":2,"SPN":5516,"SPN_Name":"Lubrication Cycle Mode Status","SPN_Description":"Reports the current lubrication cycle mode of the lubrication system\\r\\n\\r\\n000 - Cycle mode # 1 (Lowest Lubrication Frequency)\\r\\n001 - Cycle mode # 2\\r\\n010 - Cycle mode # 3 (Highest Lubrication Frequency)\\r\\n011 to 101 - Reserved \\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5517":{"PGN":64742,"PGN_Name":"Vehicle/Chassis Lubrication System 2","PGN_Description":"VLS2","first_bit":5,"SPN":5517,"SPN_Name":"Lubrication Operation Mode Status","SPN_Description":"Reports the current operational mode status of the lubrication system.\\r\\n  \\r\\nAutomatic is the normal operation mode of lubrication system. In this mode the operator has the privilege to change duty cycle mode, if the lubrication mode in not locked.\\r\\n\\r\\nIn manual service mode the service tool temporary takes control of the pump controller for service purposes.\\r\\n\\r\\nThe test mode # x shall command the system to perform pre-defined greasing cycles in order to verify operation of the lubrication system.\\r\\n\\r\\n\\r\\n000 - Automatic Mode\\r\\n001 - Manual Service Mode\\r\\n010 - Test Mode # 1\\r\\n011 - Test Mode # 2\\r\\n100 - Test Mode # 3\\r\\n101 - Reserved\\r\\n110 - Error\\r\\n111 - Not Available\\r\\n\\r\\nNote:  In general the lubrication system shall be operating in automatic mode but, it may also be changed into manual or test mode. These test and manual modes are used to perform service and diagnostic tests on the lubrication system. This SPN shall be used to report the current operating status of grease lubrication system.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5518":{"PGN":64742,"PGN_Name":"Vehicle/Chassis Lubrication System 2","PGN_Description":"VLS2","first_bit":8,"SPN":5518,"SPN_Name":"Lubrication Pump Enable Status","SPN_Description":"Reports the operational status of the lubrication system pump.  In the disabled state, the lubrication pump will not run a lubrication cycle.  In the enabled state, the lubrication system will perform normal operations.\\r\\n\\r\\n00 - Disabled\\r\\n01 - Enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5519":{"PGN":64742,"PGN_Name":"Vehicle/Chassis Lubrication System 2","PGN_Description":"VLS2","first_bit":10,"SPN":5519,"SPN_Name":"Lubrication Reservoir Level","SPN_Description":"Reports the status of the lubrication system reservior level.  The lubrication reservoir stores the grease for the lubrication system. The lubrication pump draws grease from this reservoir and pushes it into the vehicle/chassis joints\\r\\n\\r\\n00 - Reservoir Not Low\\r\\n01 - Reservoir Low\\r\\n10 - Error \\r\\n11 - Not available or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5520":{"PGN":64742,"PGN_Name":"Vehicle/Chassis Lubrication System 2","PGN_Description":"VLS2","first_bit":12,"SPN":5520,"SPN_Name":"Lubrication Timing Cycle Status","SPN_Description":"Reports the status of the lubrication activation clock.\\r\\n\\r\\n00 - Paused \\r\\n01 - Enabled\\r\\n10 - Error \\r\\n11 - Not available or not installed\\r\\n     \\r\\nNote:  In some vehicles or machines, lubrication is only required when the vehicle or machine is in certain state e. g. when a certain gear is engaged. To prevent unwanted grease lubrication, a timing cycle clock is used. This clock only ticks for the time the vehicle or machine is in that defined state. Starting or stopping of the clock is controlled using an external input. The status of this timing cycle clock shall be reported to the operator by using this SPN.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5532":{"PGN":53248,"PGN_Name":"Cab Illumination Message","PGN_Description":"CL","first_bit":8,"SPN":5532,"SPN_Name":"Switch Backlight Illumination Brightness Percent","SPN_Description":"Commanded switch backlight brightness level for all operator control switches.  This is separate from the cab display illumination Brightness Percent parameter.\\r\\n\\r\\nNote:  If a single device is used to control both the backlight brightness level of the cab display and switches, see SPN 1487.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5533":{"PGN":64741,"PGN_Name":"Hydraulic Oil Properties","PGN_Description":"HOP","first_bit":0,"SPN":5533,"SPN_Name":"Hydraulic Oil Dynamic Viscosity","SPN_Description":"Dynamic viscosity of hydraulic oil.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.","bit_length":16,"scaling":0.015625,"offset":0,"unit":"Cp","SLOT_ID":301},"5534":{"PGN":64741,"PGN_Name":"Hydraulic Oil Properties","PGN_Description":"HOP","first_bit":16,"SPN":5534,"SPN_Name":"Hydraulic Oil Density","SPN_Description":"Density of hydraulic oil.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.","bit_length":16,"scaling":0.00003052,"offset":0,"unit":"g/cc","SLOT_ID":302},"5535":{"PGN":64741,"PGN_Name":"Hydraulic Oil Properties","PGN_Description":"HOP","first_bit":32,"SPN":5535,"SPN_Name":"Hydraulic Oil Relative Dielectricity (High Resolution)","SPN_Description":"Hydraulic oil relative dielectricity used to describe the hydraulic oil quality.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.","bit_length":16,"scaling":0.0001220703125,"offset":0,"unit":null,"SLOT_ID":307},"5536":{"PGN":64741,"PGN_Name":"Hydraulic Oil Properties","PGN_Description":"HOP","first_bit":48,"SPN":5536,"SPN_Name":"Hydraulic Oil Temperature (High Resolution)","SPN_Description":"Hydraulic Oil Temperature.  This hydraulic fluid is for the entire hydraulics system of a piece of equipment.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5537":{"PGN":64740,"PGN_Name":"Engine Fuel Properties","PGN_Description":"EFP","first_bit":0,"SPN":5537,"SPN_Name":"Engine Fuel Dynamic Viscosity","SPN_Description":"Dynamic viscosity of engine fuel","bit_length":16,"scaling":0.015625,"offset":0,"unit":"Cp","SLOT_ID":301},"5538":{"PGN":64740,"PGN_Name":"Engine Fuel Properties","PGN_Description":"EFP","first_bit":16,"SPN":5538,"SPN_Name":"Engine Fuel Density","SPN_Description":"Density of engine fuel","bit_length":16,"scaling":0.00003052,"offset":0,"unit":"g/cc","SLOT_ID":302},"5539":{"PGN":64740,"PGN_Name":"Engine Fuel Properties","PGN_Description":"EFP","first_bit":32,"SPN":5539,"SPN_Name":"Engine Fuel Dielectricity (High Resolution)","SPN_Description":"Engine fuel relative dielectricity.","bit_length":16,"scaling":0.0001220703125,"offset":0,"unit":null,"SLOT_ID":307},"5540":{"PGN":64740,"PGN_Name":"Engine Fuel Properties","PGN_Description":"EFP","first_bit":48,"SPN":5540,"SPN_Name":"Engine Fuel 1 Temperature 1 (High Resolution)","SPN_Description":"Engine Fuel Temperature of the first fuel type. See also SPNs 174 or 3468 for alternate resolution.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5541":{"PGN":64739,"PGN_Name":"Engine Exhaust Brake Control","PGN_Description":"EBCC","first_bit":0,"SPN":5541,"SPN_Name":"Engine Turbocharger 1 Turbine Outlet Pressure","SPN_Description":"Gage pressure of the combustion by-products exiting the turbine side of the turbocharger 1.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5542":{"PGN":64739,"PGN_Name":"Engine Exhaust Brake Control","PGN_Description":"EBCC","first_bit":8,"SPN":5542,"SPN_Name":"Engine Turbocharger 1 Turbine Desired Outlet Pressure","SPN_Description":"The desired gage pressure of the combustion by-products exiting the turbine side of the turbocharger 1 at the current engine operating conditions.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5543":{"PGN":64739,"PGN_Name":"Engine Exhaust Brake Control","PGN_Description":"EBCC","first_bit":16,"SPN":5543,"SPN_Name":"Engine Exhaust Brake Actuator Command","SPN_Description":"The control command applied to the engine exhaust brake actuator, where 0% represents no braking and 100% represents full braking.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5544":{"PGN":64739,"PGN_Name":"Engine Exhaust Brake Control","PGN_Description":"EBCC","first_bit":24,"SPN":5544,"SPN_Name":"Engine Turbocharger 2 Turbine Outlet Pressure","SPN_Description":"Gage pressure of the combustion by-products exiting the turbine side of the turbocharger 2.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5545":{"PGN":64739,"PGN_Name":"Engine Exhaust Brake Control","PGN_Description":"EBCC","first_bit":32,"SPN":5545,"SPN_Name":"Engine Turbocharger 2 Turbine Desired Outlet Pressure","SPN_Description":"The desired gage pressure of the combustion by-products exiting the turbine side of the turbocharger 2 at the current engine operating conditions.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5546":{"PGN":64850,"PGN_Name":"Engine Coolant Control Valve Command","PGN_Description":"ECCVC","first_bit":24,"SPN":5546,"SPN_Name":"Engine Auxiliary Cooler Supply Valve 1 Actuator Command","SPN_Description":"The control command applied to the engine auxiliary cooler supply valve 1 actuator, where 0% represents closed and 100% represents open.\\r\\n\\r\\nSee SPN 4197 for primary engine thermostat valve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5547":{"PGN":64850,"PGN_Name":"Engine Coolant Control Valve Command","PGN_Description":"ECCVC","first_bit":32,"SPN":5547,"SPN_Name":"Engine Auxiliary Cooler Supply Valve 2 Actuator Command","SPN_Description":"The control command applied to the engine auxiliary cooler supply valve 2 actuator, where 0% represents closed and 100% represents open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5548":{"PGN":64966,"PGN_Name":"Cold Start Aids","PGN_Description":"CSA","first_bit":16,"SPN":5548,"SPN_Name":"Engine Cold Start Fuel Igniter Command","SPN_Description":"The engine cold start fuel igniter control command, normalized to %, where 0% represents fully off and 100% represents fully on.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5549":{"PGN":64966,"PGN_Name":"Cold Start Aids","PGN_Description":"CSA","first_bit":24,"SPN":5549,"SPN_Name":"Engine Cold Start Fuel Igniter Relay","SPN_Description":"The engine cold start fuel igniter relay control command.  This command controls the relay, not the igniter.\\r\\n\\r\\n00  Off\\r\\n01  On\\r\\n10  Reserved\\r\\n11  Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5550":{"PGN":64966,"PGN_Name":"Cold Start Aids","PGN_Description":"CSA","first_bit":26,"SPN":5550,"SPN_Name":"Engine Cold Start Fuel Igniter Relay Feedback","SPN_Description":"Feedback state of the engine cold start fuel igniter relay which indicates the status of the relay output.\\r\\n\\r\\n00  Off\\r\\n01  On\\r\\n10  Error\\r\\n11  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5551":{"PGN":61484,"PGN_Name":"Magnet Status Information 2","PGN_Description":"MSI2","first_bit":38,"SPN":5551,"SPN_Name":"Magnet Generator Control","SPN_Description":"Command signal used to Enable and Disable the Generator controlling a Magnet.\\r\\n\\r\\n00  Off, Disable Generator\\r\\n01  On, Enable Generator\\r\\n10  Reserved\\r\\n11  Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5552":{"PGN":36864,"PGN_Name":"Supplemental Fan Command","PGN_Description":"SFC","first_bit":0,"SPN":5552,"SPN_Name":"Supplemental Fan Enable Command","SPN_Description":"Enable/Disable command to Supplemental Fan.\\r\\n\\r\\n00  Disable \\r\\n01  Enable\\r\\n10  Reserved \\r\\n11  Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5553":{"PGN":36864,"PGN_Name":"Supplemental Fan Command","PGN_Description":"SFC","first_bit":2,"SPN":5553,"SPN_Name":"Supplemental Fan Direction Command","SPN_Description":"Direction command to the Supplemental Fan. Fan can be commanded to run forward or reverse.\\r\\n\\r\\n00   Forward\\r\\n01   Reverse\\r\\n10   Reserved\\r\\n11   Don\'t care/take no action (leave function as is)","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5554":{"PGN":36864,"PGN_Name":"Supplemental Fan Command","PGN_Description":"SFC","first_bit":8,"SPN":5554,"SPN_Name":"Supplemental Fan Speed Command","SPN_Description":"Speed command to Supplemental Fan.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"5555":{"PGN":36864,"PGN_Name":"Supplemental Fan Command","PGN_Description":"SFC","first_bit":24,"SPN":5555,"SPN_Name":"Supplemental Fan Power Hold","SPN_Description":"Command to allow the supplemental fan controller to remain alive independently of the electrical enable input to the fan. This allows the fan controller to remain alive after the key switch has disabled the electrical enable pin on the fan controller. For example, the fan can continue to run after a machine has been shutdown to provide cooling when the machine is no longer running\\r\\n\\r\\n00   Disable\\r\\n01   Enable\\r\\n10   Reserved\\r\\n11   Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5556":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":0,"SPN":5556,"SPN_Name":"Supplemental Fan Enable Status","SPN_Description":"Enable/Disable Status of Supplemental Fan.\\r\\n\\r\\n00   Disabled\\r\\n01   Enabled\\r\\n10   Error\\r\\n11   Not available/Not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5557":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":2,"SPN":5557,"SPN_Name":"Supplemental Fan Direction Status","SPN_Description":"Rotational Direction of Supplemental Fan. Fan could be spinning forward or reverse.\\r\\n\\r\\n00   Forward\\r\\n01   Reverse\\r\\n10   Error\\r\\n11   Not available/Not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5558":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":4,"SPN":5558,"SPN_Name":"Supplemental Fan Velocity Status","SPN_Description":"Status of the rotational velocity of Supplemental Fan. Used to indicate if the fan is spinning at the desired speed. If fan is not able to obtain the commanded speed, velocity error is indicated. If fan is unable to spin, the fan is in Fan Stall condition.\\r\\n\\r\\n0000   At Velocity (Fan OK)\\r\\n0001   Velocity Error  (unable to achieve commanded speed)\\r\\n0010   Fan Spin Up\\r\\n0011   Fan Spin Down\\r\\n0100   Fan Stall\\r\\n0101-1101   Reserved\\r\\n1110   Error\\r\\n1111   Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5559":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":8,"SPN":5559,"SPN_Name":"Supplemental Fan Controller Temperature Status","SPN_Description":"Internal Controller Temperature Status of Supplemental Fan.\\r\\n\\r\\n000   High most severe \\r\\n001   High Least severe \\r\\n010   In Range \\r\\n011   Low Least severe \\r\\n100   Low Most severe \\r\\n101   Not Defined \\r\\n110   Error \\r\\n111   Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5560":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":11,"SPN":5560,"SPN_Name":"Supplemental Fan Drive Status","SPN_Description":"The drive status of the Supplemental Fan. This status parameter indicates the overall health of the fan drive. It will indicate that the fan is working OK or if there is an internal fault such as open winding or internal short circuit.\\r\\n\\r\\n0000   Normal = \\"OK\\"\\r\\n0001   Alarm = Fully operational but needs service\\r\\n0010   Alarm High Severity = Functional but transient performance may be reduced\\r\\n0011   Derate Active = Torque output reduced due to environmental conditions\\r\\n0100   Controlled Shutdown Active = Driving to the default position \u2013 usually this means closed\\r\\n0101   Uncontrolled Shutdown Active = Actuator current is off so it is limp\\r\\n0110 - 1101   Reserved for future assignment = Not used\\r\\n1110   Error\\r\\n1111   Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5561":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":16,"SPN":5561,"SPN_Name":"Supplemental Fan Controller ECU Temperature","SPN_Description":"Measured temperature of Supplemental Fan Controller ECU.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5562":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":24,"SPN":5562,"SPN_Name":"Supplemental Fan Speed","SPN_Description":"Measured speed of supplemental fan.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"5563":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":40,"SPN":5563,"SPN_Name":"Supplemental Fan Current","SPN_Description":"Measured electrical current of supplemental fan drive.","bit_length":8,"scaling":1,"offset":-125,"unit":"A","SLOT_ID":40},"5564":{"PGN":64738,"PGN_Name":"Supplemental Fan Status","PGN_Description":"SFS","first_bit":48,"SPN":5564,"SPN_Name":"Supplemental Fan Power","SPN_Description":"Estimated Power output of Supplemental Fan","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"5565":{"PGN":36608,"PGN_Name":"Engine Configuration Commands","PGN_Description":"ECC","first_bit":0,"SPN":5565,"SPN_Name":"Coolant Level Engine Protection Shutdown Override Command","SPN_Description":"Overrides the engine protection shutdown functionality due to low coolant level.  \\r\\n\\r\\n00 - Disable engine protection shutdown override due to low coolant level\\r\\n01 - Enable engine protection shutdown override due to low coolant level\\r\\n10 - Reserved\\r\\n11 - Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5566":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":60,"SPN":5566,"SPN_Name":"Coolant Level Engine Protection Shutdown Status","SPN_Description":"Parameter which indicates the configuration of the coolant level engine protection shutdown.\\r\\n\\r\\n00 - Disabled - calibration does not allow engine protection due to low coolant level or the override is currently active\\r\\n01 - Enabled - calibration allows engine protection due to low coolant level and the override is currently not active\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5567":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":32,"SPN":5567,"SPN_Name":"Engine Speed Governor Gain Adjust","SPN_Description":"This parameter is used to adjust multiple gains at same time to attain engine stability across a broader range of applications.  \\r\\n\\r\\n-32128 is least responsive\\r\\n0 is normal\\r\\n+32127 is most responsive","bit_length":16,"scaling":1,"offset":-32128,"unit":"count","SLOT_ID":306},"5568":{"PGN":64915,"PGN_Name":"Generator Control 1","PGN_Description":"GC1","first_bit":48,"SPN":5568,"SPN_Name":"Engine Speed Governor Droop","SPN_Description":"This is the percent speed droop adjustment relative to rated speed setpoint. The Engine Speed Droop is equal to the following equation: \\r\\n\\r\\n100*[(Engine Speed at no load - Engine Speed at full rated load)/ (Engine Speed at full rated load)]. \\r\\n\\r\\nThe engine speed will slow down as load is added. Allows for inexpensive load sharing between multiple engines.","bit_length":8,"scaling":0.04,"offset":0,"unit":"%","SLOT_ID":308},"5569":{"PGN":64796,"PGN_Name":"Diesel Particulate Filter 1 Soot","PGN_Description":"DPF1S","first_bit":56,"SPN":5569,"SPN_Name":"Diesel Particulate Filter 1 Soot Sensor ECU Internal Temperature","SPN_Description":"Internal temperature of the diesel particulate filter 1 soot sensor ECU.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5570":{"PGN":64795,"PGN_Name":"Diesel Particulate Filter 2 Soot","PGN_Description":"DPF2S","first_bit":56,"SPN":5570,"SPN_Name":"Diesel Particulate Filter 2 Soot Sensor ECU Internal Temperature","SPN_Description":"Internal temperature of the diesel particulate filter 2 soot sensor ECU.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5578":{"PGN":64735,"PGN_Name":"Engine Fluid Level/Pressure 12","PGN_Description":"EFL/P12","first_bit":0,"SPN":5578,"SPN_Name":"Engine Fuel Delivery Absolute Pressure","SPN_Description":"Absolute pressure of fuel in system as delivered from supply pump to the injection pump.  See also SPN 94 for Fuel Delivery Pressure (Gage).","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"5579":{"PGN":64735,"PGN_Name":"Engine Fluid Level/Pressure 12","PGN_Description":"EFL/P12","first_bit":8,"SPN":5579,"SPN_Name":"Engine Filtered Fuel Delivery Pressure","SPN_Description":"Gage pressure of fuel in system as delivered from supply pump to the injection pump after the pressure side fuel filter.  See SPN 5580 for absolute pressure of fuel in system after the pressure side fuel filter.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"5580":{"PGN":64735,"PGN_Name":"Engine Fluid Level/Pressure 12","PGN_Description":"EFL/P12","first_bit":16,"SPN":5580,"SPN_Name":"Engine Filtered Fuel Delivery Absolute Pressure","SPN_Description":"Absolute pressure of fuel in system as delivered from supply pump to the injection pump after the pressure side fuel filter.  See SPN 5579 for gage pressure of fuel in system after the pressure side fuel filter.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"5581":{"PGN":64992,"PGN_Name":"Ambient Conditions 2","PGN_Description":"AMB2","first_bit":32,"SPN":5581,"SPN_Name":"Calculated Ambient Air Temperature","SPN_Description":"Calculated temperature of air surrounding vehicle.  Use SPN 171 for actual measured ambient air temperature.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5582":{"PGN":2304,"PGN_Name":"Static Roll Angle Sensor Information","PGN_Description":"SRASI","first_bit":0,"SPN":5582,"SPN_Name":"Static Roll Angle","SPN_Description":"The measured static roll angle between the vehicle y-axis and the ground plane about the X-axis.  The sign of the roll angle is determined in accordance to the right-hand rule about the X-axis, as specified in SAE J670.  Roll angle is the same for both Z-Down and Z-Up axis system, as specified in SAE J670, since both systems have positive X forward.","bit_length":8,"scaling":1,"offset":-125,"unit":"deg","SLOT_ID":11},"5583":{"PGN":2304,"PGN_Name":"Static Roll Angle Sensor Information","PGN_Description":"SRASI","first_bit":8,"SPN":5583,"SPN_Name":"Static Roll Angle Status","SPN_Description":"Status of the transmitted roll angle data.\\r\\n\\r\\n000 = Sensor Busy\\r\\n001 = Sensor OK\\r\\n010 = Sensor Defect\\r\\n011 = Sensor Reboots\\r\\n100 = Angle Data Invalid\\r\\n101 = Reserved\\r\\n110 = Error\\r\\n111 = Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5584":{"PGN":64735,"PGN_Name":"Engine Fluid Level/Pressure 12","PGN_Description":"EFL/P12","first_bit":24,"SPN":5584,"SPN_Name":"Engine Fuel Filter Degradation","SPN_Description":"The estimated percentage relative to the useful life of the engine fuel filter. \\r\\n\\r\\nThis is not a calculation of the physical restriction of the filter.  0% is typical of a new filter.  100% is typical of an end of life filter, the filter should be replaced.  The filter can operate past 100%.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"5589":{"PGN":64734,"PGN_Name":"Aftertreatment 1 Air Control 3","PGN_Description":"AT1AC3","first_bit":0,"SPN":5589,"SPN_Name":"Aftertreatment 1 Secondary Air Absolute Pressure","SPN_Description":"Absolute pressure of the secondary air for aftertreatment 1. Secondary air is air provided to the exhaust system (per SAE J2403).\\r\\n\\r\\nFor gage pressure, see SPN 3837.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5590":{"PGN":64733,"PGN_Name":"Aftertreatment 2 Air Control 3","PGN_Description":"AT2AC3","first_bit":0,"SPN":5590,"SPN_Name":"Aftertreatment 2 Secondary Air Absolute Pressure","SPN_Description":"Absolute pressure of the secondary air for aftertreatment 2. Secondary air is air provided to the exhaust system (per SAE J2403).\\r\\n\\r\\nFor gage pressure, see SPN 3838.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5603":{"PGN":2560,"PGN_Name":"Cruise Control / Vehicle Speed 2","PGN_Description":"CCVS2","first_bit":0,"SPN":5603,"SPN_Name":"Cruise Control Disable Command","SPN_Description":"This parameter is used to disable cruise control from a source other than the driver controlled switch if cruise control is active.  It is also used to inhibit cruise control from becoming active if it is not currently active.  If this parameter is used to disable cruise control, then cruise control will need to be re-initialized and the previous set speed will not be retained.  \\r\\n\\r\\nThis parameter has priority over Cruise Control Resume Command (SPN 5604).  See Figure PGN2560_A for an explanation of how this relates to other parameters.\\r\\n\\r\\nUse of this parameter is in addition to Cruise Control Enable Switch (SPN 596).  The Cruise Control Enable Switch set to OFF has priority over the Cruise Control Disable Command set to allowed.\\r\\n\\r\\nThis parameter is not the physical switch that enables cruise control.  See SPN 596 for the physical switch.\\r\\n\\r\\n00 - Cruise Control is allowed\\r\\n01 - Cruise Control is not allowed\\r\\n10 - Reserved\\r\\n11 - Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5604":{"PGN":2560,"PGN_Name":"Cruise Control / Vehicle Speed 2","PGN_Description":"CCVS2","first_bit":2,"SPN":5604,"SPN_Name":"Cruise Control Resume Command","SPN_Description":"This parameter is used to request the cruise control to resume operation from a source other than the driver controlled switch.  Implementers may wish to restrict the conditions in which cruise control will be resumed due to this parameter.  Possible restrictions include only honoring this request if it is received within a certain time period after cruise control has been disabled, a vehicle speed differential has been exceeded since cruise control has been cancelled, etc. \\r\\n\\r\\nThis request will only be honored if it is received from the same device as the one that sent the Cruise Control Pause Command (SPN 5605).\\r\\n\\r\\nCruise Control Disable Command (SPN 5603) and Cruise Control Pause Command (SPN 5605) both have a higher priority than this parameter.  See Figure PGN2560_A for an explanation of how this relates to other parameters. \\r\\n\\r\\nThis parameter is not the physical switch that is used to resume cruise control.  See SPN 601 for the physical switch.\\r\\n\\r\\n\\r\\n00 - Cruise Control Resume not Requested\\r\\n01 - Cruise Control Resume Requested\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5605":{"PGN":2560,"PGN_Name":"Cruise Control / Vehicle Speed 2","PGN_Description":"CCVS2","first_bit":4,"SPN":5605,"SPN_Name":"Cruise Control Pause Command","SPN_Description":"This parameter is used to temporarily disable cruise control from a source other than the driver controlled switch if cruise control is active.  If this parameter is used to disable cruise control, then cruise control will not need to be re-initialized and the previous set speed will be retained.  In order for the cruise control system to resume to the previous set speed, a valid command must be received.  Valid commands include (1) the Cruise Control Resume Switch (SPN 601), (2) the Cruise Control Set Switch (SPN 599), or (3) Cruise Control Resume Command (SPN 5604).\\r\\n\\r\\nThis parameter has priority over Cruise Control Resume Command (SPN 5604).  See Figure PGN2560_A for an explanation of how this relates to other parameters. \\r\\n\\r\\nThis parameter is not the physical switch that is used to pause cruise control.  See SPN 1633 for the physical switch.\\r\\n\\r\\nReceiving this parameter to disable cruise control has the same effect on cruise control as tapping the brake pedal.\\r\\n\\r\\n\\r\\n00 - Cruise Control is allowed\\r\\n01 - Cruise Control is not allowed\\r\\n10 - Reserved\\r\\n11 - Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5606":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":0,"SPN":5606,"SPN_Name":"Adaptive Cruise Control Readiness Status","SPN_Description":"This parameter is used to indicate an application\'s state of readiness for responding to commands from an adaptive cruise control system controller.\\r\\n\\r\\n00 - Off -- Cruise Control System is not configured to accept commands from an adaptive cruise controller\\r\\n01 - On -- Cruise Control System is configured to accept commands from an adaptive cruise controller.\\r\\n10 - Error Condition -- Prevents system from responding to adaptive cruise controller commands even though it is configured.\\r\\n11 - Not Available/Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5607":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":2,"SPN":5607,"SPN_Name":"Cruise Control System Command State","SPN_Description":"Indicates the current state of the cruise control system due to the Cruise Control System Commands, which include Cruise Control Disable Command (SPN 5603), Cruise Control Resume Command (SPN 5604), and Cruise Control Pause Command (SPN 5605).\\r\\n\\r\\n000 - No Cruise Control System Command\\r\\n001 - Cruise control has been disabled by Cruise Control Disable Command (SPN 5603)\\r\\n010 - Cruise control  has been disabled by Cruise Control Pause Command (SPN 5605)\\r\\n011 - Cruise control has been re-activated by Cruise Control Resume Command (SPN 5604) and Cruise Control States (SPN 527) is equal to Resume (100).  Cruise Control System Command State will be equal to 011 as long as Cruise Control States is equal to Resume.  Cruise Control System Command State will change to the appropriate value when Cruise Control States is no longer equal to Resume.\\r\\n100 - Cruise control device has received a Cruise Control Resume Command (SPN 5604), but there is no previous set speed.\\r\\n101 - 110 -- SAE Reserved\\r\\n111 - Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5608":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":8,"SPN":5608,"SPN_Name":"Source Address of Controlling Device for Disabling Cruise Control","SPN_Description":"The source address of the SAE J1939 device that is currently sending the Cruise Control Disable Command (SPN 5603).\\r\\n\\r\\nIf there are multiple devices sending Cruise Control Disable Command with a value of 01, then the value transmitted for this parameter will be the source address of the device that first began sending 01 for the command.  If the device that first sent 01 for Cruise Control Disable Command is no longer sending 01 for the command, then the value of the Source Address of Controlling Device for Disabling Cruise Control shall be set to the source address of a device that is still sending the Cruise Control Disable Command with a value of 01.\\r\\n\\r\\nSee Figure PGN2560_A for an explanation of how this relates to other parameters.\\r\\n\\r\\nThis parameter is supported by the device that has the capability to receive and process the Cruise Control Disable Command (SPN 5603).\\r\\n\\r\\n254 (0xFE) is used to indicate that the Source Address of Controlling Device for Disabling Cruise Control parameter is supported, but no device is currently inhibiting cruise control with the Cruise Control Disable Command (SPN 5603).","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"5609":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":16,"SPN":5609,"SPN_Name":"Source Address of Controlling Device for Pausing Cruise Control","SPN_Description":"The source address of the SAE J1939 device that is currently sending the Cruise Control Pause Command (SPN 5605).\\r\\n\\r\\nIf there are multiple devices sending Cruise Control Pause Command with a value of 01, then the value transmitted for this parameter will be the source address of the device that first began sending 01 for the command.  If the device that first sent 01 for Cruise Control Pause Command is no longer sending 01 for the command, then the value of the Source Address of Controlling Device for Pausing Cruise Control shall be set to the source address of a device that is still sending the Cruise Control Disable Command with a value of 01.\\r\\n\\r\\nThis parameter is supported by the device that has the capability to receive and process the Cruise Control Pause Command (SPN 5605).\\r\\n\\r\\n254 (0xFE) is used to indicate that the Source Address of Controlling Device for Pausing Cruise Control parameter is supported, but no device is currently inhibiting cruise control with the Cruise Control Pause Command (SPN 5605).","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"5624":{"PGN":65103,"PGN_Name":"Vehicle Dynamic Stability Control 1","PGN_Description":"VDC1","first_bit":16,"SPN":5624,"SPN_Name":"Trailer-VDC Active","SPN_Description":"The trailer-VDC (Vehicle Dynamic Control) is an electronic vehicle stability function within the (semi) trailer braking system. It acts to stabilize the (semi) trailer during dynamic maneuvers. VDC includes Roll Over Prevention (ROP) and/or Yaw Control (YC), However, the latter information is not individually available and the VDC active parameter will be set in both cases.\\r\\n\\r\\nThis parameter maps the 6.4.2.2.36 VDC active parameter of the ISO 11992_2 bus (trailer-bus) to the SAE J1939 (vehicle bus). This makes it possible to warn the driver if one of the trailers activate the brakes because of  an VDC function active in the trailer.\\r\\n\\r\\n00 - VDC passive, but installed\\r\\n01 - VDC active\\r\\n10 - Reserved\\r\\n11 - Not availble or not installed","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5625":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":16,"SPN":5625,"SPN_Name":"Engine Exhaust Bank 1 Pressure Regulator Position","SPN_Description":"The position of the Exhaust Pressure Regulator (EPR) in bank 1 expressed as a percentage of full travel.  One hundred percent means the regulator is fully closed, providing the maximum restriction to exhaust gas flow from the engine.  Zero percent means the regulator is fully open, providing the minimum available restriction.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5626":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":24,"SPN":5626,"SPN_Name":"Engine Exhaust Pressure Regulator Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Pressure Regulator (EPR) by the manufacturers software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5627":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":29,"SPN":5627,"SPN_Name":"Engine Exhaust Pressure Regulator Temperature Status","SPN_Description":"Used to identify the status of the Engine Exhaust Pressure Regulator (EPR) drive circuitry temperature. Temperature excursions may affect the torque output.\\r\\n\\r\\n000 \u2013 High most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range\\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5628":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":32,"SPN":5628,"SPN_Name":"Engine Exhaust Pressure Regulator Control Operation Status","SPN_Description":"Used to identify the status of Engine Exhaust Pressure Regulator.\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (actuator current is off so it is limp)\\r\\n0110 \u2013 1101 Reserved for future assignment\\r\\n1110 \u2013 Error\\r\\n1111 \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5629":{"PGN":64892,"PGN_Name":"Diesel Particulate Filter Control 1","PGN_Description":"DPFC1","first_bit":58,"SPN":5629,"SPN_Name":"Diesel Particulate Filter Active Regeneration Inhibited Due to Low Exhaust Pressure","SPN_Description":"Indicates the state of diesel particulate filter active regeneration inhibition due to low exhaust pressure.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the diesel particulate filter regeneration not being initiated or being exited prior to completion.  When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration.  The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5630":{"PGN":57344,"PGN_Name":"Cab Message 1","PGN_Description":"CM1","first_bit":32,"SPN":5630,"SPN_Name":"Park Brake Command","SPN_Description":"Request by a secondary device to command the Park Brake.  The Park Brake controller should treat this as a request and should apply the Park Brake as determined by the controller. \\r\\n\\r\\nFeedback of the park brake actuation may utilize SPN 70, SPN 619 or SPN 5275.\\r\\n\\r\\n00 - Park Brake apply not requested\\r\\n01 - Park Brake apply requested\\r\\n10 - SAE Reserved  \\r\\n11 - Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5631":{"PGN":64961,"PGN_Name":"Engine Fluid Level/Pressure 3","PGN_Description":"EFL/P3","first_bit":48,"SPN":5631,"SPN_Name":"Engine Throttle Valve 1 Differential Pressure","SPN_Description":"The differential pressure between the intake and outlet of the throttle valve 1 (SPN 51).  The differential pressure is measured from the intake with respect to the outlet of the throttle valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5632":{"PGN":64731,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 3","PGN_Description":"AT1DPF1S3","first_bit":0,"SPN":5632,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 1","SPN_Description":"First requested analysis frequency for the diesel particulate filter 1 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5633":{"PGN":64731,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 3","PGN_Description":"AT1DPF1S3","first_bit":16,"SPN":5633,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 2","SPN_Description":"Second requested analysis frequency for the diesel particulate filter 1 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5634":{"PGN":64731,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 3","PGN_Description":"AT1DPF1S3","first_bit":32,"SPN":5634,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 3","SPN_Description":"Third requested analysis frequency for the diesel particulate filter 1 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5635":{"PGN":64731,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 3","PGN_Description":"AT1DPF1S3","first_bit":48,"SPN":5635,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Request Frequency 4","SPN_Description":"Fourth requested analysis frequency for the diesel particulate filter 1 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5636":{"PGN":64730,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 4","PGN_Description":"AT1DPF1S4","first_bit":0,"SPN":5636,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 1","SPN_Description":"The analysis frequency associated with the frequency 1 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5632.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5637":{"PGN":64730,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 4","PGN_Description":"AT1DPF1S4","first_bit":16,"SPN":5637,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 1 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 1 for the diesel particulate filter 1 soot sensor.  See SPN 5632.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5638":{"PGN":64730,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 4","PGN_Description":"AT1DPF1S4","first_bit":32,"SPN":5638,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 2","SPN_Description":"The analysis frequency associated with the frequency 2 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5633.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5639":{"PGN":64730,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 4","PGN_Description":"AT1DPF1S4","first_bit":48,"SPN":5639,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 2 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 2 for the diesel particulate filter 1 soot sensor.  See SPN 5633.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5640":{"PGN":64729,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 5","PGN_Description":"AT1DPF1S5","first_bit":0,"SPN":5640,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 3","SPN_Description":"The analysis frequency associated with the frequency 3 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5634.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5641":{"PGN":64729,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 5","PGN_Description":"AT1DPF1S5","first_bit":16,"SPN":5641,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 3 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 3 for the diesel particulate filter 1 soot sensor.  See SPN 5634.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5642":{"PGN":64729,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 5","PGN_Description":"AT1DPF1S5","first_bit":32,"SPN":5642,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Analysis Frequency 4","SPN_Description":"The analysis frequency associated with the frequency 4 soot signal for the diesel particulate filter 1 soot sensor.  See SPN 5635.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5643":{"PGN":64729,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot 5","PGN_Description":"AT1DPF1S5","first_bit":48,"SPN":5643,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 1 Soot Sensor Frequency 4 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 4 for the diesel particulate filter 1 soot sensor.  See SPN 5635.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5644":{"PGN":64728,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 3","PGN_Description":"AT1DPF2S3","first_bit":0,"SPN":5644,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 1","SPN_Description":"First requested analysis frequency for the diesel particulate filter 2 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5645":{"PGN":64728,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 3","PGN_Description":"AT1DPF2S3","first_bit":16,"SPN":5645,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 2","SPN_Description":"Second requested analysis frequency for the diesel particulate filter 2 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5646":{"PGN":64728,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 3","PGN_Description":"AT1DPF2S3","first_bit":32,"SPN":5646,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 3","SPN_Description":"Third requested analysis frequency for the diesel particulate filter 2 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5647":{"PGN":64728,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 3","PGN_Description":"AT1DPF2S3","first_bit":48,"SPN":5647,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Request Frequency 4","SPN_Description":"Fourth requested analysis frequency for the diesel particulate filter 2 soot sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5648":{"PGN":64727,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 4","PGN_Description":"AT1DPF2S4","first_bit":0,"SPN":5648,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 1","SPN_Description":"The analysis frequency associated with the frequency 1 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5644.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5649":{"PGN":64727,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 4","PGN_Description":"AT1DPF2S4","first_bit":16,"SPN":5649,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 1 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 1 for the diesel particulate filter 2 soot sensor.  See SPN 5644.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5650":{"PGN":64727,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 4","PGN_Description":"AT1DPF2S4","first_bit":32,"SPN":5650,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 2","SPN_Description":"The analysis frequency associated with the frequency 2 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5645.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5651":{"PGN":64727,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 4","PGN_Description":"AT1DPF2S4","first_bit":48,"SPN":5651,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 2 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 2 for the diesel particulate filter 2 soot sensor.  See SPN 5645.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5652":{"PGN":64726,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 5","PGN_Description":"AT1DPF2S5","first_bit":0,"SPN":5652,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 3","SPN_Description":"The analysis frequency associated with the frequency 3 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5646.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5653":{"PGN":64726,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 5","PGN_Description":"AT1DPF2S5","first_bit":16,"SPN":5653,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 3 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 3 for the diesel particulate filter 2 soot sensor.  See SPN 5646.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5654":{"PGN":64726,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 5","PGN_Description":"AT1DPF2S5","first_bit":32,"SPN":5654,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Analysis Frequency 4","SPN_Description":"The analysis frequency associated with the frequency 4 soot signal for the diesel particulate filter 2 soot sensor.  See SPN 5647.","bit_length":16,"scaling":0.1,"offset":0,"unit":"MHz","SLOT_ID":320},"5655":{"PGN":64726,"PGN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot 5","PGN_Description":"AT1DPF2S5","first_bit":48,"SPN":5655,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter 2 Soot Sensor Frequency 4 Soot Signal","SPN_Description":"The soot signal attenuation measurement for analysis frequency 4 for the diesel particulate filter 2 soot sensor.  See SPN 5647.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5656":{"PGN":65275,"PGN_Name":"Retarder fluids","PGN_Description":"RF","first_bit":24,"SPN":5656,"SPN_Name":"Retarder Coolant Outlet Temperature","SPN_Description":"Temperature of liquid found in retarder cooling system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5675":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":2,"SPN":5675,"SPN_Name":"Operator Shift Prompt","SPN_Description":"Command to activate an indicator that advises the operator to shift to a different gear.  Typically this would be used as part of a fuel economy improvement or drivability aid.\\r\\n\\r\\n00 - indicator(s) inactive\\r\\n01 - upshift indicator active\\r\\n10 - downshift indicator active\\r\\n11 - don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5676":{"PGN":61487,"PGN_Name":"Advanced Emergency Braking System 1","PGN_Description":"AEBS1","first_bit":0,"SPN":5676,"SPN_Name":"Advanced emergency braking system state","SPN_Description":"Current operational state of advanced emergency braking system\\r\\n\\r\\n0000 - system is not ready (initialization not finished)\\r\\n0001 - system is temporarily not available (e.g. due to boundary conditions necessary for operation)\\r\\n0010 - system is deactivated by driver\\r\\n0011 - system is ready and activated (no warning and no braking active)\\r\\n0100 - driver overrides system\\r\\n0101 - collision warning active (e.g. acoustic signal, cruise control turned off, torque limitation)\\r\\n0110 - collision warning with braking (e.g. brake jerk or partial braking)\\r\\n0111 - emergency braking active\\r\\n1000 - system performance and/or sensitivity limited (no warning and no braking active)\\r\\n1001 - 1101 - reserved for future use\\r\\n1110 - error indication\\r\\n1111 - not available / not installed\\r\\n\\r\\nNote:  State 1000 - Example Use Case: Used when system performance is limited but still able to meet minimum legal obligations present at the time of introduction or when one of a fused sensor is faulted but the Emergency Braking functionality is still available.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5677":{"PGN":61487,"PGN_Name":"Advanced Emergency Braking System 1","PGN_Description":"AEBS1","first_bit":4,"SPN":5677,"SPN_Name":"Collision warning level","SPN_Description":"To implement different HMI (human machine interface) concepts, e.g. visual only, visual/audible, different warning tones etc., the AEBS provides different levels of collision warning.\\r\\n\\r\\n0000 - no warning\\r\\n0001 - warning level 1 - lowest\\r\\n0010 - warning level 2\\r\\n0011 - warning level 3\\r\\n0100 - warning level 4\\r\\n0101 - warning level 5\\r\\n0110 - warning level 6\\r\\n0111 - warning level 7 - highest\\r\\n1000\u20261110 - reserved\\r\\n1111 - don\u2019t care / take no action\\r\\n\\r\\nValues between 0001 (lowest warning level) and 0111 (highest warning level) are increasing.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5678":{"PGN":61487,"PGN_Name":"Advanced Emergency Braking System 1","PGN_Description":"AEBS1","first_bit":8,"SPN":5678,"SPN_Name":"Relevant object detected for advanced emergency braking system","SPN_Description":"Indication if the advanced emergency braking system (AEBS) is monitoring a relevant object\\r\\n\\r\\n000 - no relevant object monitored\\r\\n001 - relevant object is being monitored\\r\\n010 - relevant object is not being detected reliably\\r\\n011..101 - reserved\\r\\n110 - error indication\\r\\n111 - signal not available / not installed","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5679":{"PGN":61487,"PGN_Name":"Advanced Emergency Braking System 1","PGN_Description":"AEBS1","first_bit":11,"SPN":5679,"SPN_Name":"Bend off probability of relevant object","SPN_Description":"Probabilty if monitored relevant object might start a turning maneuver, which could clear the travelling path of the host vehicle.\\r\\n\\r\\n000 - no indication for a bend off maneuver of the relevant object\\r\\n001 - low probability for a bend off maneuver of the relevant object\\r\\n010 - medium probability for a bend off maneuver of the relevant object\\r\\n011 - high probability for a bend off maneuver of the relevant object\\r\\n100 - highest probability for a bend off maneuver of the relevant object\\r\\n101 - relevant object is already in a turning maneuver\\r\\n110 - error indication\\r\\n111 - signal not available / not installed","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5680":{"PGN":61487,"PGN_Name":"Advanced Emergency Braking System 1","PGN_Description":"AEBS1","first_bit":16,"SPN":5680,"SPN_Name":"Time to collision with relevant object","SPN_Description":"The time to collision is the duration after which the predicted travelling paths of host vehicle and relevant object lead to a distance of 0m between both.\\r\\n\\r\\nNote:  It is up to the system manufacturer to choose a suitable calculation method to predict the travelling paths of both host vehicle and relevant object.","bit_length":8,"scaling":0.05,"offset":0,"unit":"s","SLOT_ID":322},"5681":{"PGN":2816,"PGN_Name":"Advanced Emergency Braking System 2","PGN_Description":"AEBS2","first_bit":0,"SPN":5681,"SPN_Name":"Driver activation demand for Advanced Emergency Braking System","SPN_Description":"According to the Vienna world convention on road traffic the driver must be provided with means to deactivate an Advanced Emergency Braking System. This command is to be transmitted from the respective HMI unit to the AEBS unit.\\r\\n\\r\\n00 - the driver does not want the Advanced Emergency Braking System to warn or intervene at any time (deactivation of system)\\r\\n01 - the driver wants the Advanced Emergency Braking System to warn or intervene if necessary (no deactivation of system)\\r\\n10 - reserved\\r\\n11 - don\u2019t\' care / take no action\\r\\n\\r\\nNote:  The signal has to be transmitted permanently to the AEBS showing the state selected once by the driver.  Typically there is a deactivation push button present in the host vehicle for the driver to choose this state.\\r\\n\\r\\nExample: After ignition-on the signal is being transmitted as 01b (this will be the default state in Europe) all the time. As soon as the driver depresses the push button the signal\'s value has to change to 00b for the remaining ignition cycle as long as the driver does not depress the push button again.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5682":{"PGN":2816,"PGN_Name":"Advanced Emergency Braking System 2","PGN_Description":"AEBS2","first_bit":56,"SPN":5682,"SPN_Name":"AEBS2 message Counter","SPN_Description":"The message counter is increased with every transmitted AEBS2 message.  After reaching a value of 0xF the next value will be 0.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"5683":{"PGN":2816,"PGN_Name":"Advanced Emergency Braking System 2","PGN_Description":"AEBS2","first_bit":60,"SPN":5683,"SPN_Name":"AEBS2 message checksum","SPN_Description":"Used to check the message checksum of the transmitting (HMI) unit within the AEBS2 system.\\r\\n\\r\\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + (message counter & 0x0F) + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)\\r\\n\\r\\nMessage Checksum = ((Checksum >> 4) + Checksum) & 0x0F","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"5684":{"PGN":65109,"PGN_Name":"Gaseous Fuel Properties","PGN_Description":"GFD","first_bit":16,"SPN":5684,"SPN_Name":"Reference Engine Gas Mass Flow Rate","SPN_Description":"Configuration of the mass flow rate of gaseous fuel expected for 100% engine fuel valve control command.\\r\\n\\r\\nNote:  The actuator will request this parameter from the ECU in order to determine what mass fuel flow to associate with a command of 100% from the ECU.  This value does not change during operation.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kg/h","SLOT_ID":18},"5685":{"PGN":64992,"PGN_Name":"Ambient Conditions 2","PGN_Description":"AMB2","first_bit":48,"SPN":5685,"SPN_Name":"Barometric Absolute Pressure (High Resolution)","SPN_Description":"Barometric Absolute Pressure (High Resolution).  See SPN 108 if high resolution is not needed.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"5706":{"PGN":64725,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information","PGN_Description":"AT1P1I","first_bit":0,"SPN":5706,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump Heater","SPN_Description":"Percentage of heating applied to the aftertreatment 1 diesel exhaust fluid pump heater. A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid pump heater warms the diesel exhaust fluid in the diesel exhaust fluid pump. See SPN 5707 for the command for this pump heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5707":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":32,"SPN":5707,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump Heater Command","SPN_Description":"Command for the Aftertreatment 1 Diesel Exhaust Fluid Pump Heater. A value of 0% means no heating commanded, a value of 100% means full heating commanded. See SPN 5706 for the measured value of the Aftertreatment 1 Diesel Exhaust Fluid Heater.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5708":{"PGN":64768,"PGN_Name":"Engine Fluid Level/Pressure 10","PGN_Description":"EFL/P10","first_bit":56,"SPN":5708,"SPN_Name":"Engine Coolant Pressure 2","SPN_Description":"Gage pressure of liquid found in the engine coolant system - second instance.\\r\\n\\r\\nSee SPN 7313 for alternate range and resolution.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"5713":{"PGN":61455,"PGN_Name":"Aftertreatment 1 Outlet Gas 1","PGN_Description":"AT1OG1","first_bit":53,"SPN":5713,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor 1 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for NOx sensor ATO1 (Aftertreatment Outlet Bank 1)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATO1 Self Diagnosis active flag\\r\\n010 NOx Sensor ATO1 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATO1 Self Diagnosis aborted\\r\\n100 NOx Sensor ATO1 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5714":{"PGN":61454,"PGN_Name":"Aftertreatment 1 Intake Gas 1","PGN_Description":"AT1IG1","first_bit":53,"SPN":5714,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor 1 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for the NOx sensor ATI1 (Aftertreatment Intake Bank 1)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATI1 Self Diagnosis active flag\\r\\n010 NOx Sensor ATI1 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATI1 Self Diagnosis aborted\\r\\n100 NOx Sensor ATI1 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5715":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":53,"SPN":5715,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor 1 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for NOx sensor ATO2 (Aftertreatment Outlet Bank 2)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATO2 Self Diagnosis active flag\\r\\n010 NOx Sensor ATO2 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATO2 Self Diagnosis aborted\\r\\n100 NOx Sensor ATO2 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5716":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":53,"SPN":5716,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor 1 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for NOx sensor ATI2 (Aftertreatment Intake Bank 2)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATI2 Self Diagnosis active flag\\r\\n010 NOx Sensor ATI2 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATI2 Self Diagnosis aborted\\r\\n100 NOx Sensor ATI2 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5717":{"PGN":64782,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT1OGC2","first_bit":32,"SPN":5717,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor Self-diagnosis Final Result","SPN_Description":"Self-diagnosis result for NOx sensor ATO1 (Aftertreatment Outlet Bank 1) as a ratio of detected value to reference value defined by supplier.\\r\\n\\r\\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3226 may no longer be accurate as expected.\\r\\n\\r\\nThis parameter is valid while the diagnosis feedback status of SPN 5713 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":56},"5718":{"PGN":64784,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT1IGC2","first_bit":32,"SPN":5718,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor Self-diagnosis Final Result","SPN_Description":"Self-diagnosis result for NOx sensor ATI1 (Aftertreatment Intake Bank 1) as a ratio of detected value to reference value defined by supplier.\\r\\n\\r\\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3216 may no longer be accurate as expected.\\r\\n\\r\\nThis parameter is valid while the diagnosis feedback status of SPN 5714 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":56},"5719":{"PGN":64778,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT2OGC2","first_bit":32,"SPN":5719,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor Self-diagnosis Final Result","SPN_Description":"Self-diagnosis result for NOx sensor ATO2 (Aftertreatment Outlet Bank 2) as a ratio of detected value to reference value defined by supplier.\\r\\n\\r\\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3265 may no longer be accurate as expected.\\r\\n\\r\\nThis parameter is valid while the diagnosis feedback status of SPN 5715 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":56},"5720":{"PGN":64780,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT2IGC2","first_bit":32,"SPN":5720,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor Self-diagnosis Final Result","SPN_Description":"Self-diagnosis result for NOx sensor ATI2 (Aftertreatment Intake Bank 2) as a ratio of detected value to reference value defined by supplier.\\r\\n\\r\\nThis result is used to determine if the signal resulting from the self-diagnosis test (as represented as a ratio to a reference value) is within an acceptable range.  This will be determined by the receiver of the information and may differ depending on how the sensor is used and/or sensor application.  This may mean that SPN 3255 may no longer be accurate as expected.\\r\\n\\r\\nThis parameter is valid while the diagnosis feedback status of SPN 5716 = 010b (Diagnosis complete).  It is broadcast as 0xFF at other times.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":56},"5721":{"PGN":64783,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT1OGC1","first_bit":40,"SPN":5721,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor Operation Hours","SPN_Description":"Counted hours that the NOx-sensor was operated with status \\"dewpoint reached\\"","bit_length":16,"scaling":1,"offset":0,"unit":"h","SLOT_ID":324},"5722":{"PGN":64785,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT1IGC1","first_bit":40,"SPN":5722,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor Operation Hours","SPN_Description":"Counted hours that the NOx-sensor was operated with status \\"dewpoint reached\\"","bit_length":16,"scaling":1,"offset":0,"unit":"h","SLOT_ID":324},"5723":{"PGN":64779,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 1","PGN_Description":"AT2OGC1","first_bit":40,"SPN":5723,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor Operation Hours","SPN_Description":"Counted hours that the NOx-sensor was operated with status \\"dewpoint reached\\"","bit_length":16,"scaling":1,"offset":0,"unit":"h","SLOT_ID":324},"5724":{"PGN":64781,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 1","PGN_Description":"AT2IGC1","first_bit":40,"SPN":5724,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor Operation Hours","SPN_Description":"Counted hours that the NOx-sensor was operated with status \\"dewpoint reached\\"","bit_length":16,"scaling":1,"offset":0,"unit":"h","SLOT_ID":324},"5746":{"PGN":64725,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information","PGN_Description":"AT1P1I","first_bit":24,"SPN":5746,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 1 Heater Relay","SPN_Description":"The status of the relay that controls Aftertreatment 1 diesel exhaust fluid dosing Unit 1 Heater.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5749":{"PGN":64662,"PGN_Name":"Engine Information 2","PGN_Description":"EI2","first_bit":48,"SPN":5749,"SPN_Name":"Engine Exhaust Pressure 2","SPN_Description":"Gage pressure of the exhaust gasses as measured at the turbine intake of the turbocharger of exhaust bank 2. See SPN 1209 for exhaust bank 1.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"5750":{"PGN":61488,"PGN_Name":"Wireless Status","PGN_Description":"WS","first_bit":0,"SPN":5750,"SPN_Name":"Wireless Rolling Message Counter","SPN_Description":"A counter incremented with each instance of the Wireless Status message. The counter shall increment from 0 to 64255, rolling over to 0 on the next increment after 64255. The enables recipients of the Wireless Status message to detect problems with the wireless transceiver if counter fails to increment or the counter prematurely resets to 0.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"5751":{"PGN":61488,"PGN_Name":"Wireless Status","PGN_Description":"WS","first_bit":20,"SPN":5751,"SPN_Name":"Transmitter Command State","SPN_Description":"The command contained in the signal received by the wireless transceiver from an off-board transmitter.\\r\\n\\r\\n0000b - Stop\\r\\n0001b - Clear\\r\\n0010b - Field Test\\r\\n0011b - Transmitter Test\\r\\n0100b - Standby\\r\\n0101b to 1101b - Reserved\\r\\n1110b - Error\\r\\n1111b - Don\'t Care\\r\\n\\r\\n0000b - Stop - Received an RF messsage from a transmitter requesting a machine level \\"Stop.\\"\\r\\n0001b - Clear - Received an RF message from a transmitter clearing a machine level \\"Stop\\" request.\\r\\n0010b - Field Test - Used to request an acknowledgement of an RF signal from the onboard ECU, without adversely affecting the operation of the vehicle\\r\\n0011b - Transmitter Test - A transmitter test RF message was requested by a transmitter, used to diagnose transmitter behaviors\\r\\n0100b - Standby - No new Status message received at the time the message was communicated\\r\\n1110b - Error - Device Error","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5752":{"PGN":61488,"PGN_Name":"Wireless Status","PGN_Description":"WS","first_bit":24,"SPN":5752,"SPN_Name":"Transmitter ID 1","SPN_Description":"The ID of the off-board transmitter that sent the incoming message received by the wireless transceiver.","bit_length":24,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":325},"5753":{"PGN":61488,"PGN_Name":"Wireless Status","PGN_Description":"WS","first_bit":48,"SPN":5753,"SPN_Name":"Wireless Signal Strength 1","SPN_Description":"The absolute received signal strength of the signal received from the off-board transmitter. The signal strength is reported as a Received Signal Strength Indicator (RSSI) value calculated in dBm.","bit_length":8,"scaling":0.5,"offset":-125,"unit":"dBm","SLOT_ID":326},"5754":{"PGN":34816,"PGN_Name":"Radio Beacon Request","PGN_Description":"RBR","first_bit":0,"SPN":5754,"SPN_Name":"Unique Beacon Message Identifier Number","SPN_Description":"The number is used to identify a wireless message originating from a device on a particular machine. Within a beacon request message (see SPN 5755 [Radio Beacon Direction]), this number is included in the transmitted beacon signal. Within a beacon request acknowledge (see SPN 5755 [Radio Beacon Direction]), this number is the number from the received beacon signal.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"5755":{"PGN":34816,"PGN_Name":"Radio Beacon Request","PGN_Description":"RBR","first_bit":22,"SPN":5755,"SPN_Name":"Radio Beacon Direction","SPN_Description":"Indicates the function of a particular instance of the Radio Beacon Request message. The \'Beacon Request\' state indicates the message is sent to a wireless transceiver to request a transmit of the special beacon message. The \'Beacon Received Acknowledgement\' is sent from a wireless transceiver to report the reception of a special beacon message.\\r\\n\\r\\n00b - Beacon Request - Beacon request coming from an ECU\\r\\n01b - Beacon Received Acknowledgement - Acknowledgement from wireless device\\r\\n10b - Reserved\\r\\n11b - Don\'t Care\\r\\n\\r\\n00b - Beacon Request - An ECU requests that a beacon message be transmitted from a wireless device on a machine. This status will always originate from the ECU, and be sent to a wireless device. The message associated with this state will not have an associated transmitter ID, or signal strength.\\r\\n01b - Beacon Received Acknowledgement - Acknowledgement of a beacon transmission detected by an onboard wireless device. This status will always originate from the wireless device, and be sent to the ECU. The message associated with this state will have an associated transmitter ID and signal strength.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5756":{"PGN":34816,"PGN_Name":"Radio Beacon Request","PGN_Description":"RBR","first_bit":24,"SPN":5756,"SPN_Name":"Transmitter ID 2","SPN_Description":"The ID of the off-board transmitter that sent the incoming special beacon message received by the wireless transceiver.","bit_length":24,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":325},"5757":{"PGN":34816,"PGN_Name":"Radio Beacon Request","PGN_Description":"RBR","first_bit":48,"SPN":5757,"SPN_Name":"Wireless Signal Strength 2","SPN_Description":"The absolute received signal strength of the special beacon signal received from the off-board transmitter. The signal strength is reported as a Received Signal Strength Indicator (RSSI) value in dBm. This measurement method is identical to SPN 5753 [Wireless Signal Strength].","bit_length":8,"scaling":0.5,"offset":-125,"unit":"dBm","SLOT_ID":326},"5758":{"PGN":64716,"PGN_Name":"Electronic Engine Controller 12","PGN_Description":"EEC12","first_bit":0,"SPN":5758,"SPN_Name":"Aftertreatment 1 Intake 1 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 1 Intake 1 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 1 Intake 1 Gas Sensor.  Note that the ECU is external to the sensor.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the Aftertreatment 1 Intake 1 Gas Sensor\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5759":{"PGN":64716,"PGN_Name":"Electronic Engine Controller 12","PGN_Description":"EEC12","first_bit":2,"SPN":5759,"SPN_Name":"Aftertreatment 1 Outlet 1 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 1 Outlet 1 Gas Sensor driver output is being driven. On means the ECU is powering the Aftertreatment 1 Outlet 1 Gas Sensor. Note that the ECU is external to the sensor.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the Aftertreatment 1 Outlet 1 Gas Sensor\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5760":{"PGN":64716,"PGN_Name":"Electronic Engine Controller 12","PGN_Description":"EEC12","first_bit":4,"SPN":5760,"SPN_Name":"Aftertreatment 2 Intake 1 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 2 Intake 1 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Intake 1 Gas Sensor.  Note that the ECU is external to the sensor.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the Aftertreatment 2 Intake 1 Gas Sensor\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5761":{"PGN":64716,"PGN_Name":"Electronic Engine Controller 12","PGN_Description":"EEC12","first_bit":6,"SPN":5761,"SPN_Name":"Aftertreatment 2 Outlet 1 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 2 Outlet 1 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Outlet 1 Gas Sensor.  Note that the ECU is external to the sensor.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the Aftertreatment 2 Outlet 1 Gas Sensor\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5762":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":38,"SPN":5762,"SPN_Name":"Transmission Load Reduction Inhibit Request","SPN_Description":"Request signal to the transmission to inhibit activation of load reduction functions.\\r\\n\\r\\nAutomatic transmissions may incorporate functions designed to reduce engine load during certain operating conditions (vehicle standstill at bus stop, traffic stop, etc.) for improved fuel consumption. However, other vehicle systems may have an interest in regular (higher) engine load levels for comfort features or to assist with heat generation.  This signal requests that the transmission inhibit initiation of such load reduction functions or terminates their operation if they are already active. The transmission may choose to ignore this request during certain operating conditions as defined by the transmission manufacturer.\\r\\n\\r\\n00 = Allow or resume transmission load reduction functions\\r\\n01 = Inhibit or abort transmission load reduction functions\\r\\n10 = Reserved\\r\\n11 = Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5763":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":0,"SPN":5763,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 1 Actuator 1 by the manufacturer\u2019s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5764":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":5,"SPN":5764,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 1 Temperature Status","SPN_Description":"Used to identify the status of the Engine Exhaust Gas Recirculation 1 Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n \\r\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range \\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5765":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":8,"SPN":5765,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 1 Temperature","SPN_Description":"Temperature of the Engine Exhaust Gas Recirculation 1 Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5766":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":16,"SPN":5766,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 1 Desired Position","SPN_Description":"The requested position of the Engine Exhaust Gas Recirculation 1 Actuator 1 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5767":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":24,"SPN":5767,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 1 Actuator 2 by the manufacturer\u2019s software. When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5768":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":29,"SPN":5768,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 2 Temperature Status","SPN_Description":"Used to identify the status of the Engine Exhaust Gas Recirculation 1 Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n \\r\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range \\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5769":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":32,"SPN":5769,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 2 Temperature","SPN_Description":"Temperature of the Engine Exhaust Gas Recirculation 1 Actuator 2 drive circuitry.  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5770":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":40,"SPN":5770,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 2 Desired Position","SPN_Description":"The requested position of the Engine Exhaust Gas Recirculation 1 Actuator 2 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5771":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":48,"SPN":5771,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 1 Operation Status","SPN_Description":"Used to identify the status of Exhaust Gas Recirculation 1 Actuator 1\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (no torque is being applied from the actuator)\\r\\n0110 \u2013 1101 Reserved for future assignment\\r\\n1110 \u2013 Error\\r\\n1111 \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5772":{"PGN":64715,"PGN_Name":"Engine Exhaust Gas Recirculation 1 Actuator","PGN_Description":"EEGR1A","first_bit":52,"SPN":5772,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Actuator 2 Operation Status","SPN_Description":"Used to identify the status of Exhaust Gas Recirculation 1 Actuator 2\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (no torque is being applied from the actuator)\\r\\n0110 \u2013 1101 Reserved for future assignment\\r\\n1110 \u2013 Error\\r\\n1111 \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5773":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":0,"SPN":5773,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 2 Actuator 1 by the manufacturer\u2019s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5774":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":5,"SPN":5774,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 1 Temperature Status","SPN_Description":"Used to identify the status of the Engine Exhaust Gas Recirculation 2 Actuator 1 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n \\r\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range \\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5775":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":8,"SPN":5775,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 1 Temperature","SPN_Description":"Temperature of the Engine Exhaust Gas Recirculation 2 Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5776":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":16,"SPN":5776,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 1 Desired Position","SPN_Description":"The requested position of the Engine Exhaust Gas Recirculation 2 Actuator 1 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5777":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":24,"SPN":5777,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Exhaust Gas Recirculation 2 Actuator 2 by the manufacturer\u2019s software. When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5778":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":29,"SPN":5778,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 2 Temperature Status","SPN_Description":"Used to identify the status of the Engine Exhaust Gas Recirculation 2 Actuator 2 drive circuitry temperature.  Temperature excursions may affect the torque output.\\r\\n \\r\\n000 \u2013 High Most severe\\r\\n001 \u2013 High Least severe\\r\\n010 \u2013 In Range \\r\\n011 \u2013 Low Least severe\\r\\n100 \u2013 Low Most severe\\r\\n101 \u2013 Not Defined\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5779":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":32,"SPN":5779,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 2 Temperature","SPN_Description":"Temperature of the Engine Exhaust Gas Recirculation 2 Actuator 2 drive circuitry.  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5780":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":40,"SPN":5780,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 2 Desired Position","SPN_Description":"The requested position of the Engine Exhaust Gas Recirculation 2 Actuator 2 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5781":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":48,"SPN":5781,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 1 Operation Status","SPN_Description":"Used to identify the status of Exhaust Gas Recirculation 2 Actuator 1\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (no torque is being applied from the actuator)\\r\\n0110 \u2013 1101 Reserved for future assignment\\r\\n1110 \u2013 Error\\r\\n1111 \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5782":{"PGN":64714,"PGN_Name":"Engine Exhaust Gas Recirculation 2 Actuator","PGN_Description":"EEGR2A","first_bit":52,"SPN":5782,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Actuator 2 Operation Status","SPN_Description":"Used to identify the status of Exhaust Gas Recirculation 2 Actuator 2\\r\\n\\r\\n0000 \u2013 Normal\\r\\n0001 \u2013 Alarm (fully operational but needs service)\\r\\n0010 \u2013 Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 \u2013 Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 \u2013 Controlled Shutdown Active (driving to the default position \u2013 usually this means closed)\\r\\n0101 \u2013 Uncontrolled Shutdown Active (no torque is being applied from the actuator)\\r\\n0110 \u2013 1101 Reserved for future assignment\\r\\n1110 \u2013 Error\\r\\n1111 \u2013 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5783":{"PGN":64713,"PGN_Name":"Engine Fuel/Throttle Valve Information 2","PGN_Description":"EF/TVI2","first_bit":0,"SPN":5783,"SPN_Name":"Engine Throttle Valve 1 Temperature","SPN_Description":"Temperature of the engine throttle valve 1 drive circuitry (SPN 51).  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5784":{"PGN":64713,"PGN_Name":"Engine Fuel/Throttle Valve Information 2","PGN_Description":"EF/TVI2","first_bit":8,"SPN":5784,"SPN_Name":"Engine Throttle Valve 2 Temperature","SPN_Description":"Temperature of the engine throttle valve 2 drive circuitry (SPN 3673).  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5785":{"PGN":64713,"PGN_Name":"Engine Fuel/Throttle Valve Information 2","PGN_Description":"EF/TVI2","first_bit":16,"SPN":5785,"SPN_Name":"Engine Fuel Valve 1 Temperature","SPN_Description":"Temperature of the Engine Fuel Valve 1 drive circuitry. Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5786":{"PGN":64713,"PGN_Name":"Engine Fuel/Throttle Valve Information 2","PGN_Description":"EF/TVI2","first_bit":24,"SPN":5786,"SPN_Name":"Engine Fuel Valve 2 Temperature","SPN_Description":"Temperature of the Engine Fuel Valve 2 drive circuitry. Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5787":{"PGN":64713,"PGN_Name":"Engine Fuel/Throttle Valve Information 2","PGN_Description":"EF/TVI2","first_bit":32,"SPN":5787,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Temperature","SPN_Description":"Temperature of the Engine Turbocharger Wastegate Actuator 2 drive circuitry.  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5788":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":40,"SPN":5788,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Temperature","SPN_Description":"Temperature of the Engine Turbocharger Wastegate Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5789":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":48,"SPN":5789,"SPN_Name":"Engine Exhaust Pressure Actuator 1 Desired Position","SPN_Description":"The requested position of the Engine Exhaust Pressure Actuator 1 by the engine ECU, where 0% represents fully closed and 100% represents fully open.\\r\\n\\r\\nThis is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5790":{"PGN":64753,"PGN_Name":"Engine Turbocharger Wastegate Actuator and Exhaust Back Pressure Regulator Information","PGN_Description":"ETWAI","first_bit":56,"SPN":5790,"SPN_Name":"Engine Exhaust Pressure Actuator 1 Temperature","SPN_Description":"Temperature of the Engine Exhaust Pressure Actuator 1 drive circuitry.  Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5791":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":32,"SPN":5791,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Temperature","SPN_Description":"Temperature of the Engine Turbocharger Compressor Bypass Actuator 1 drive circuitry.    Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5792":{"PGN":64755,"PGN_Name":"Engine Turbocharger Compressor Bypass Information","PGN_Description":"ETCBI","first_bit":40,"SPN":5792,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 2 Temperature","SPN_Description":"Temperature of the Engine Turbocharger Compressor Bypass Actuator 2 drive circuitry.    Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5793":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":0,"SPN":5793,"SPN_Name":"Desired Engine Fueling State","SPN_Description":"Devices send this request to the engine controller to:\\r\\n\\r\\n(a) Shut off engine fueling, but remain prepared to re-start quickly by not shutting down the control system, or\\r\\n(b) Keep the engine running.\\r\\n\\r\\n00 Fueling not desired (shut off engine fueling)\\r\\n01 Fueling desired (keep engine running)\\r\\n10 Parameter supported, but no request\\r\\n11 Don\'t care / Take no action\\r\\n\\r\\nIf the engine controller receives this parameter from multiple sources, then \'01-Fueling desired\' shall have priority over \'00-Fueling not desired\'.\\r\\n\\r\\nIf this request can be honored by the receiving device as indicated by SPN 5795, then it shall be processed independently of other means to stop engine fueling (i.e., SPN 970 Engine Auxiliary Shutdown Switch or the Key switch). For example, if the engine is acting on SPN 5793 set to 01 (keep engine running) and the vehicle key switch is turned off, then the engine shall shut off.\\r\\n\\r\\nUse examples of this parameter include, but are not limited to:\\r\\n1. In applications or situations where the engine can be physically disconnected from the hybrid powertrain, a command of 00 could be used to request the engine to stop running, and as a result, stop rotating.\\r\\n2. In applications or situations where engine-driven accessories (power steering, etc.) must remain active while the engine is not running, a command of 00 could result in the engine no longer running even as it continues to be spun (motored) by the hybrid powertrain.\\r\\n3. In applications or situations where components want to keep the engine running, such as an aftertreatment system, a command of 01 could be used to prevent the engine from honoring requests from other devices using this parameter to shut off fueling.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5794":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":0,"SPN":5794,"SPN_Name":"Feedback Engine Fueling State","SPN_Description":"This parameter provides feedback to the network that SPN 5793 Desired Engine Fueling State was honored. SPN 5795 Engine Fueling Inhibit Allowed indicates the engine\u2019s current ability to honor requests via SPN 5793 Desired Engine Fueling State.\\r\\n\\r\\n00 = Fueling is or will be inhibited (SPN 5793 Desired Engine Fueling State = 00 from at least one network device and all other network devices have SPN 5793 Desired Engine Fueling State equal to something other than 01)\\r\\n01 = Engine will be kept running (SPN 5793 Desired Engine Fueling State = 01 from at least one network device)\\r\\n10 = No active request per SPN 5793 Desired Engine Fueling State or SPN 5795 Engine Fueling Inhibit Allowed = 00. When SPN 5795 = 00, then requests via SPN 5793 Desired Engine Fueling are ignored.\\r\\n11 = Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5795":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":2,"SPN":5795,"SPN_Name":"Engine Fueling Inhibit Allowed","SPN_Description":"This parameter is broadcast by the engine control system, and indicates to other devices on the network whether or not it will respond to requests to inhibit engine fueling via SPN 5793 Desired Engine Fueling State. With this information, devices that may wish to inhibit engine fueling at some time in the future can know whether or not their request will be honored before they issue a request.\\r\\n \\r\\nThis parameter does not reflect the state of the engine controller due to requests received in SPN 5793 Desired Engine Fueling State.\\r\\n\\r\\nThis parameter is intended to be used in conjunction with SPN 5793 Desired Engine Fueling State and SPN 5794 Feedback Engine Fueling State.\\r\\n\\r\\n00 = Engine currently will not stop fueling in response to SPN 5793 Desired Engine Fueling State\\r\\n01 = Engine will stop fueling in response to SPN 5793 Desired Engine Fueling State\\r\\n10 = SAE Reserved\\r\\n11 = Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5821":{"PGN":61489,"PGN_Name":"Wand Sensor","PGN_Description":"WAND","first_bit":0,"SPN":5821,"SPN_Name":"Wand Angle","SPN_Description":"A wand sensor measures the angle of deflection of a wand from its null position. This parameter reports the measured angle of a wand sensor.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"5822":{"PGN":61489,"PGN_Name":"Wand Sensor","PGN_Description":"WAND","first_bit":16,"SPN":5822,"SPN_Name":"Wand Sensor Figure of Merit","SPN_Description":"Figure of Merit sensor status for a wand sensor.\\r\\n\\r\\n00    Sensor fully functional\\r\\n01    Sensor degraded\\r\\n10    Sensor failed\\r\\n11    Sensor not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5823":{"PGN":61490,"PGN_Name":"Linear Displacement Sensor","PGN_Description":"LDISP","first_bit":0,"SPN":5823,"SPN_Name":"Measured Linear Displacement","SPN_Description":"Distance to target as measured by the Linear Displacement Sensor.","bit_length":16,"scaling":0.1,"offset":0,"unit":"mm","SLOT_ID":14},"5824":{"PGN":61490,"PGN_Name":"Linear Displacement Sensor","PGN_Description":"LDISP","first_bit":16,"SPN":5824,"SPN_Name":"Linear Displacement Sensor Sensor Figure of Merit","SPN_Description":"Figure of Merit sensor status of Linear Displacement Sensor.\\r\\n\\r\\n00    Sensor fully functional\\r\\n01    Sensor degraded\\r\\n10    Sensor failed\\r\\n11    Sensor not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5825":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":8,"SPN":5825,"SPN_Name":"Driver Warning System Indicator Status","SPN_Description":"The desired illumination of the Euro VI defined driver warning system indicator for relevant malfunctions and diesel exhaust fluid (reagent) tank low level.  Used for Euro VI implementations.  See Euro VI implementing regulation Annex XIII, Section 4 for usage requirements.\\r\\n\\r\\n000 - Off - Used when driver warning system is non-active - which, by requirement, means the low-level and severe inducement systems are also non-active\\r\\n001 - On \u2013 solid - Used when driver warning system is activated for any relevant malfunction\\r\\n010 - reserved for SAE assignment\\r\\n011 - reserved for SAE assignment\\r\\n100 - On \u2013 fast blink (1 Hz) - Used for the second driver warning system detection threshold for diesel exhaust fluid level, where the visual alarm of the driver warning system is required to \\"escalate in intensity\\"\\r\\n101 - reserved for SAE assignment\\r\\n110 - reserved for SAE assignment\\r\\n111 - not available\\r\\n\\nNote: SPN 5825 is similar to SPN 5245.  SPN 5825 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level and specific emission control malfunction information, whereas SPN 5245 is intended to be used in implementations where the warning indicator is used to convey diesel exhaust fluid tank low level information only.  Thus, SPN 5825 is a superset of SPN 5245, and if both are utilized, will match only under certain conditions.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5826":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":11,"SPN":5826,"SPN_Name":"Emission Control System Operator Inducement Severity","SPN_Description":"Severity status of the operator inducement system for anomalies with the emission control system, such as tampering, low diesel exhaust fluid (reagent) quality, diesel exhaust fluid (reagent) tank level, or EGR system errors.  Higher numerical levels indicate more severe levels of inducement.  Level 1 is the least severe.  Used for Euro VI and Tier 4 implementations.\\r\\n\\r\\n000 - Driver Warning, Low-Level Inducement, and Severe Inducement Non-Active\\r\\n001 - Inducement Level 1... Euro VI defined Driver Warning System Active ............................ FMI 15\\r\\n                                           \u2026 Off Highway (Tier4) - DEF Warning \u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026\u2026.. FMI 15\\r\\n010 - Inducement Level 2 ... Euro VI defined Low-Level Inducement Enabled ......................... FMI 15\\r\\n                                           \u2026 Off Highway (Tier4) - DEF Warning, second level .\u2026\u2026\u2026\u2026\u2026.. FMI 15\\r\\n011 - Inducement Level 3 ... Euro VI defined Low-Level Inducement Active ............................ FMI 16\\r\\n                                           \u2026 Off Highway (Tier4) - Low-Level Inducement Active \u2026\u2026..\u2026\u2026.. FMI 16\\r\\n100 - Inducement Level 4 ... Euro VI defined Severe Inducement Enabled .............................. FMI 16\\r\\n                                           \u2026 Off Highway (Tier4) - Severe Inducement Active \u2026\u2026.\u2026..\u2026\u2026.. FMI 16\\r\\n101 - Inducement Level 5 ... Euro VI defined Severe Inducement Active ................................. FMI 0\\r\\n                                           \u2026 Off Highway (Tier4) - Final Inducement Active \u2026\u2026.\u2026\u2026.\u2026\u2026.. FMI 0\\r\\n110 - Temporary Override of Inducement\\r\\n111 - Not Available / Not Supported\\r\\n\\r\\nWhen this SPN is used in a DTC the recommended FMI usage is as shown.\\r\\n\\r\\nReference Euro VI implementing regulation Annex XIII, Appendix 5, section 3.1.(b), 3.1.(c), and 3.1.(d) for details.\\r\\n\\r\\nReference EU directive 97/68/EC amendment (2012/46/EU), EPA webinar nrci-scr-web-conf.2011-07-25, and JMLIT \\"Technical Guidelines for Urea Selective Catalytic Reduction System\\" Kokujikan 132-3, Feb.16, 2012 for Off Highway (Tier4) implementations.\\r\\n\\r\\nNote: SPN 5826 is similar to SPN 5246.  SPN 5826 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR and EGR systems, whereas SPN 5246 is intended to be used to indicate the severity status of the operator inducement system for anomalies with the SCR system only.  Thus, SPN 5826 is a superset of SPN 5246, and if both are utilized, will match only under certain conditions.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"5827":{"PGN":64920,"PGN_Name":"Aftertreatment 1 Historical Information 1","PGN_Description":"AT1HI1","first_bit":288,"SPN":5827,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Average Distance Between Active Regenerations","SPN_Description":"Indicates the average distance since last reset between active regenerations, that have not been forced to occur by manual request, for aftertreatment device 1.\\r\\n\\r\\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"5828":{"PGN":64921,"PGN_Name":"Aftertreatment 2 Historical information 1","PGN_Description":"AT2HI1","first_bit":288,"SPN":5828,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Average Distance Between Active Regenerations","SPN_Description":"Indicates the average distance since last reset between active regenerations, that have not been forced to occur by manual request, for aftertreatment device 2.\\r\\n\\r\\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"5829":{"PGN":64962,"PGN_Name":"Electronic Engine Controller 14","PGN_Description":"EEC14","first_bit":0,"SPN":5829,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Valve 1 Position Error","SPN_Description":"The position error of the Exhaust Gas Recirculation 1 valve, determined as the actual position (SPN 27) minus the commanded position (SPN 2791).","bit_length":16,"scaling":0.004,"offset":-125,"unit":"%","SLOT_ID":264},"5830":{"PGN":64962,"PGN_Name":"Electronic Engine Controller 14","PGN_Description":"EEC14","first_bit":16,"SPN":5830,"SPN_Name":"Engine Exhaust Gas Recirculation 1 Valve 2 Position Error","SPN_Description":"The position error of the Exhaust Gas Recirculation 1 valve 2, determined as the actual position (SPN 3821) minus the commanded position (SPN 3822).","bit_length":16,"scaling":0.004,"offset":-125,"unit":"%","SLOT_ID":264},"5831":{"PGN":64762,"PGN_Name":"Electronic Engine Controller 11","PGN_Description":"EEC11","first_bit":32,"SPN":5831,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Valve 1 Position Error","SPN_Description":"The position error of the Exhaust Gas Recirculation 2 valve, determined as the actual position (SPN 5264) minus the commanded position (SPN 5262).","bit_length":16,"scaling":0.004,"offset":-125,"unit":"%","SLOT_ID":264},"5832":{"PGN":64762,"PGN_Name":"Electronic Engine Controller 11","PGN_Description":"EEC11","first_bit":48,"SPN":5832,"SPN_Name":"Engine Exhaust Gas Recirculation 2 Valve 2 Position Error","SPN_Description":"The position error of the Exhaust Gas Recirculation 2 valve 2, determined as the actual position (SPN 5265) minus the commanded position (SPN 5263).","bit_length":16,"scaling":0.004,"offset":-125,"unit":"%","SLOT_ID":264},"5833":{"PGN":64962,"PGN_Name":"Electronic Engine Controller 14","PGN_Description":"EEC14","first_bit":32,"SPN":5833,"SPN_Name":"Engine Fuel Mass Flow Rate","SPN_Description":"Mass of liquid fuel consumed by engine per unit of time.","bit_length":16,"scaling":0.005,"offset":0,"unit":"g/s","SLOT_ID":336},"5834":{"PGN":64736,"PGN_Name":"Diesel Particulate Filter Control 2","PGN_Description":"DPFC2","first_bit":48,"SPN":5834,"SPN_Name":"Aftertreatment 2 Fuel Mass Rate","SPN_Description":"Mass rate of total fuel being delivered to Atertreatment 2 for DPF regeneration.","bit_length":16,"scaling":0.05,"offset":0,"unit":"g/min","SLOT_ID":317},"5835":{"PGN":64720,"PGN_Name":"Engine Particulate Sensor Information","PGN_Description":"EPSI","first_bit":0,"SPN":5835,"SPN_Name":"Aftertreatment 1 Particulate Sensor","SPN_Description":"The particulate sensor measures the mass concentration of particulate matter in the exhaust downstream of the DPF in exhaust bank 1.","bit_length":16,"scaling":0.0125,"offset":0,"unit":"mg/m\xb3","SLOT_ID":337},"5836":{"PGN":64720,"PGN_Name":"Engine Particulate Sensor Information","PGN_Description":"EPSI","first_bit":16,"SPN":5836,"SPN_Name":"Aftertreatment 2 Particulate Sensor","SPN_Description":"The particulate sensor measures the mass concentration of particulate matter in the exhaust downstream of the DPF in exhaust bank 2.","bit_length":16,"scaling":0.0125,"offset":0,"unit":"mg/m\xb3","SLOT_ID":337},"5837":{"PGN":64962,"PGN_Name":"Electronic Engine Controller 14","PGN_Description":"EEC14","first_bit":48,"SPN":5837,"SPN_Name":"Fuel Type","SPN_Description":"Type of fuel currently being utilized by the vehicle\\r\\n\\r\\nData Byte - Scaling - External Display\\r\\n\\r\\n0x00 - Not available - NONE\\r\\n0x01 - Gasoline/petrol - GAS\\r\\n0x02 - Methanol - METH\\r\\n0x03 - Ethanol - ETH\\r\\n0x04 - Diesel - DSL\\r\\n0x05 - Liquefied Petroleum Gas (LPG) - LPG\\r\\n0x06 - Compressed Natural Gas (CNG) - CNG\\r\\n0x07 - Propane - PROP\\r\\n0x08 - Battery/electric - ELEC\\r\\n0x09 - Bi-fuel vehicle using gasoline - BI_GAS\\r\\n0x0A - Bi-fuel vehicle using methanol - BI_METH\\r\\n0x0B - Bi-fuel vehicle using ethanol - BI_ETH\\r\\n0x0C - Bi-fuel vehicle using LPG - BI_LPG\\r\\n0x0D - Bi-fuel vehicle using CNG - BI_CNG\\r\\n0x0E - Bi-fuel vehicle using propane - BI_PROP\\r\\n0x0F - Bi-fuel vehicle using battery - BI_ELEC  [Not to be used]\\r\\n0x10 - Bi-fuel vehicle using battery and combustion engine - BI_MIX  [Not to be used]\\r\\n0x11 - Hybrid vehicle using gasoline engine - HYB_GAS  [Not to be used]\\r\\n0x12 - Hybrid vehicle using gasoline engine on ethanol - HYB_ETH  [Not to be used]\\r\\n0x13 - Hybrid vehicle using diesel engine - HYB_DSL  [Not to be used]\\r\\n0x14 - Hybrid vehicle using battery - HYB_ELEC  [Not to be used]\\r\\n0x15 - Hybrid vehicle using battery and combustion engine - HYB_MIX  [Not to be used]\\r\\n0x16 - Hybrid vehicle in regeneration mode - HYB_REG  [Not to be used]\\r\\n0x17 - Natural Gas (NG) - NG\\r\\n0x18 - Bi-fuel vehicle using NG \u2013 BI_NG\\r\\n0x19 - Bi-fuel using diesel\\r\\n0x1A - Natural Gas (Compressed or Liquefied Natural Gas)\\r\\n0x1B - Dual Fuel \u2013 Diesel and CNG\\r\\n0x1C - Dual Fuel \u2013 Diesel and LNG\\r\\n0x1D - 0xFD   ISO/SAE reserved\\r\\n0xFE - Error\\r\\n0xFF - Not available (Parameter not supported)\\r\\n\\r\\nEXAMPLE: If a Bi-fuel vehicle has less than 10% ethanol in the gasoline/petrol, then the external test equipment shall display state 0x09. In such a case, the system would be using gasoline/petrol (fuel) tables and OBD thresholds. SPN 5458 should either artificially display 0% or some number 10% or less if the system has such resolution. If the ethanol in the gasoline/petrol is above 10%, then the external test equipment shall display state 0x0B. SPN 5458 shall report the calculated ethanol/alcohol percentage.\\r\\n\\r\\nNote: \\"Not available\\" (Data 0x00) shall be used for the following conditions where no fuel is being utilized:\\r\\n\\r\\n   \u2022 Ignition Key On/Engine Off, for example, for bi-fuel vehicles when the vehicle cannot identify which fuel is being used before engine start\\r\\n   \u2022 Vehicle using Start/Stop strategy with engine stopped.   If FUEL_TYP is utilized on a single fuel vehicle, it can continue to indicate the previously utilized fuel type while the engine is in Decel Fuel Cut Off (DFCO) mode. It is not required to indicate 0x00 while in DFCO.\\r\\n\\r\\nFor hybrid or battery vehicles the states 0x0F through 0x16 shall not be used. Parameters within the HSS and HSC1 messages may be used to communicate hybrid related mode status.\\r\\n\\r\\nRegarding fuel type 0x17 - Natural Gas - this applies to any type of natural gaseous fuel when the source (CNG, LPG, or other) is not relevant.\\r\\n\\r\\nRegarding fuel type 0x18 - Bi-fuel vehicle using NG; this applies to bi-fuel vehicles running Diesel and Natural Gas, where the source of the natural gaseous fuel is not relevant.\\r\\n\\r\\nSee SPN 6317 for the requested fuel type.","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"5847":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":26,"SPN":5847,"SPN_Name":"Emergency Braking Active","SPN_Description":"Signal which indicates an emergency braking situation (ref. ECE Regulation 13 paragraph 5.2.1.31) with high  deceleration values.  This signal can be used to activate the hazard lights (ref ECE Regulation 48 paragraph 6.23) to\\r\\nindicate other road users to the rear and front of the vehicle that a high retardation force has been applied to the vehicle relative to the prevailing road conditions.\\r\\n\\r\\n00  inactive\\r\\n01  active\\r\\n10  reserved\\r\\n11  not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5848":{"PGN":61491,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information 2","PGN_Description":"A1SCRAI2","first_bit":0,"SPN":5848,"SPN_Name":"Aftertreatment 1 SCR Intermediate NH3","SPN_Description":"The amount of NH3 in the exhaust aftertreatment system measured by a NH3 sensor at an intermediate point in the SCR system, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":-200,"unit":"ppm","SLOT_ID":348},"5849":{"PGN":61491,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information 2","PGN_Description":"A1SCRAI2","first_bit":16,"SPN":5849,"SPN_Name":"Aftertreatment 1 SCR Intermediate NH3 Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate NH3 sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5850":{"PGN":61491,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information 2","PGN_Description":"A1SCRAI2","first_bit":24,"SPN":5850,"SPN_Name":"Aftertreatment 1 SCR Intermediate NH3 Reading Stable","SPN_Description":"Indicates that the NH3 reading of the aftertreatment SCR intermediate NH3 sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 1.\\r\\n\\r\\n00 - Reading is not stable\\r\\n01 - Reading is stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5851":{"PGN":61491,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information 2","PGN_Description":"A1SCRAI2","first_bit":26,"SPN":5851,"SPN_Name":"Aftertreatment 1 SCR Intermediate NH3 Sensor Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment SCR intermediate NH3 sensor is within the manufacturer\u2019s specification in exhaust bank 1.\\r\\n\\r\\n00 - Power is not in range\\r\\n01 - Power is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5852":{"PGN":61491,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information 2","PGN_Description":"A1SCRAI2","first_bit":28,"SPN":5852,"SPN_Name":"Aftertreatment 1 SCR Intermediate NH3 Sensor at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment SCR intermediate NH3 sensor is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 1.\\r\\n\\r\\n00 - Heater element is not in range\\r\\n01 - Heater element is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5853":{"PGN":61491,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information 2","PGN_Description":"A1SCRAI2","first_bit":32,"SPN":5853,"SPN_Name":"Aftertreatment 1 SCR Intermediate NH3 Sensor Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the outlet NH3 exhaust sensor by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5854":{"PGN":61491,"PGN_Name":"Aftertreatment 1 SCR Ammonia Information 2","PGN_Description":"A1SCRAI2","first_bit":40,"SPN":5854,"SPN_Name":"Aftertreatment 1 SCR Intermediate NH3 Sensor Heater Control","SPN_Description":"Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1. \\r\\n\\r\\n00 - Automatic \\r\\n01 - Preheat 2 \\r\\n10 - Preheat 1 \\r\\n11 - Heater off or not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5855":{"PGN":61492,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information 2","PGN_Description":"A2SCRAI2","first_bit":0,"SPN":5855,"SPN_Name":"Aftertreatment 2 SCR Intermediate NH3","SPN_Description":"The amount of NH3 in the exhaust aftertreatment system measured by a NH3 sensor at an intermediate point in the SCR system, represented in NH3 molecule parts per million non-NH3 molecules in exhaust bank 2.","bit_length":16,"scaling":0.1,"offset":-200,"unit":"ppm","SLOT_ID":348},"5856":{"PGN":61492,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information 2","PGN_Description":"A2SCRAI2","first_bit":16,"SPN":5856,"SPN_Name":"Aftertreatment 2 SCR Intermediate NH3 Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate NH3 sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5857":{"PGN":61492,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information 2","PGN_Description":"A2SCRAI2","first_bit":24,"SPN":5857,"SPN_Name":"Aftertreatment 2 SCR Intermediate NH3 Reading Stable","SPN_Description":"Indicates that the NH3 reading of the aftertreatment SCR intermediate NH3 sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 2.\\r\\n\\r\\n00 - Reading is not stable\\r\\n01 - Reading is stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5858":{"PGN":61492,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information 2","PGN_Description":"A2SCRAI2","first_bit":26,"SPN":5858,"SPN_Name":"Aftertreatment 2 SCR Intermediate NH3 Sensor Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment SCR intermediate NH3 sensor is within the manufacturer\u2019s specification in exhaust bank 2.\\r\\n\\r\\n00 - Heater element is not in range\\r\\n01 - Heater element is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5859":{"PGN":61492,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information 2","PGN_Description":"A2SCRAI2","first_bit":28,"SPN":5859,"SPN_Name":"Aftertreatment 2 SCR Intermediate NH3 Sensor at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment SCR intermediate NH3 sensor is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 2.\\r\\n\\r\\n00 - Heater element is not in range\\r\\n01 - Heater element is in range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5860":{"PGN":61492,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information 2","PGN_Description":"A2SCRAI2","first_bit":32,"SPN":5860,"SPN_Name":"Aftertreatment 2 SCR Intermediate NH3 Sensor Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the SCR intermediate NH3 exhaust sensor by the manufacturer\u2019s sensor control software in exhaust bank 2. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5861":{"PGN":61492,"PGN_Name":"Aftertreatment 2 SCR Ammonia Information 2","PGN_Description":"A2SCRAI2","first_bit":40,"SPN":5861,"SPN_Name":"Aftertreatment 2 SCR Intermediate NH3 Sensor Heater Control","SPN_Description":"Indicates the heater status in the warm-up process. Upon receiving a power-up command, the NH3 sensor ramps up according to a manufacturer defined profile. The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\\r\\n \\r\\n00 - Automatic \\r\\n01 - Preheat 2 \\r\\n10 - Preheat 1 \\r\\n11 - Heater off or Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5862":{"PGN":64709,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Temperature 2","PGN_Description":"A1SCREGT2","first_bit":0,"SPN":5862,"SPN_Name":"Aftertreatment 1 SCR Intermediate Temperature","SPN_Description":"Temperature of engine combustion byproducts at an intermediate point in the SCR component in exhaust bank 1.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5863":{"PGN":64709,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Temperature 2","PGN_Description":"A1SCREGT2","first_bit":16,"SPN":5863,"SPN_Name":"Aftertreatment 1 SCR Intermediate Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5864":{"PGN":64708,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Temperature 2","PGN_Description":"A2SCREGT2","first_bit":0,"SPN":5864,"SPN_Name":"Aftertreatment 2 SCR Intermediate Temperature","SPN_Description":"Temperature of engine combustion byproducts at an intermediate point in the SCR component in exhaust bank 2.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5865":{"PGN":64708,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Temperature 2","PGN_Description":"A2SCREGT2","first_bit":16,"SPN":5865,"SPN_Name":"Aftertreatment 2 SCR Intermediate Temperature Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment SCR intermediate temperature sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"5866":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":4,"SPN":5866,"SPN_Name":"Engine Fueling Inhibit Prevented Reason","SPN_Description":"If Engine Fueling Inhibit Allowed (SPN 5795) indicates that the engine will inhibit fueling, then this parameter and Engine Fueling Inhibit Prevented Reason Extension (SPN 8145) will indicate the reason.\\r\\n\\r\\nIf SPN 8145 is state 13 or lower, then SPN 5866, if supported, shall be set to the same value. If SPN 8145 is state 14 or higher, then SPN 5866, if supported, shall be set to 14.\\r\\n\\r\\nIf more than one reason exists at the same time, then it is up to the manufacturer to decide which one to select.\\r\\n\\r\\n0 \u2013 Fueling inhibit allowed (SPN 5795 = 01)\\r\\n1 \u2013 Aftertreatment regeneration is active or preparing to be active\\r\\n2 \u2013 Oil Distribution in engine is incomplete\\r\\n3 \u2013 Engine is cold\\r\\n4 \u2013 Service Override\\r\\n5 \u2013 Aftertreatment system is cold\\r\\n6 \u2013 Aftertreatment Protection\\r\\n7 \u2013 Engine load too high\\r\\n8 \u2013 Engine protection. Use other engine protection enumerations in this parameter when applicable. If the method of engine protection is not defined in other states, then use this state.\\r\\n9 \u2013 Insufficient SLI battery charge\\r\\n10 \u2013 Maximum number of engine fueling inhibit requests (SPN 5793 = 0) temporary limit exceeded.  The temporary limit may be bounded by elapsed time, distance travelled, driving conditions, or something else that the manufacturer has specified.\\r\\n11 \u2013 Engine driven fan request\\r\\n12 \u2013 Low idle governor operation required\\r\\n13 \u2013 Vehicle speed is greater than zero\\r\\n14 \u2013 See Engine Fueling Inhibit Prevented Reason Extension (SPN 8145)\\r\\n15 \u2013 Not Supported","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5867":{"PGN":64707,"PGN_Name":"Fuel Information 4 (Gaseous)","PGN_Description":"GFI4","first_bit":0,"SPN":5867,"SPN_Name":"Supply Gas Methane Percentage","SPN_Description":"The percentage of methane in the gas supplied to the engine.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5872":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":0,"SPN":5872,"SPN_Name":"Hybrid System Warning Indicator","SPN_Description":"Signal from a hybrid system indicating that some aspect of its operation is not functioning correctly, and as a result, hybrid system operation may be altered or restricted. The indicator is typically a lamp. Distinctions in meaning between the continuous and flashing states are left to the hybrid system manufacturer.\\r\\n\\r\\n00 - Hybrid System Warning Indicator is off\\r\\n01 - Hybrid System Warning Indicator is on continuously\\r\\n10 - Hybrid System Warning Indicator is flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5873":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":2,"SPN":5873,"SPN_Name":"Hybrid System Overheat Indicator","SPN_Description":"Signal from a hybrid system indicating that at least one of its monitored temperatures is above normal acceptable limits, and as a result, hybrid system operation may be altered or restricted. The indicator is typically a lamp. Distinctions in meaning between the continuous and flashing states are left to the hybrid system manufacturer.\\r\\n\\r\\n00 - Hybrid System Temperature Indicator is off\\r\\n01 - Hybrid System Temperature Indicator is on continuously\\r\\n10 - Hybrid System Temperature Indicator is flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5874":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":4,"SPN":5874,"SPN_Name":"Hybrid System Stop Indicator","SPN_Description":"Signal from a hybrid system indicating that some aspect of its operation is not functioning correctly, and as a result, the vehicle must be stopped. The indicator is typically a lamp. Distinctions in meaning between the continuous and flashing states are left to the hybrid system manufacturer.\\r\\n\\r\\n00 - Hybrid System Stop Indicator is off\\r\\n01 - Hybrid System Stop Indicator is on continuously\\r\\n10 - Hybrid System Stop Indicator is flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5913":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":32,"SPN":5913,"SPN_Name":"Transmission Oil Temperature 2","SPN_Description":"Second instance of transmission lubricant temperature. This parameter may reflect the temperature of a second sump or oil supply. If only one instance of transmission lubricant temperature measurement exists, SPN 177 Transmission Oil Temperature 1 should be used.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5914":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":48,"SPN":5914,"SPN_Name":"Transmission Oil Level 2 High / Low","SPN_Description":"Second instance of a transmission oil level indicator. Conveys the current volume of transmission sump oil compared to recommended volume. Positive values indicate overfill. Zero means the transmission fluid is filled to the recommended level. If only a one instance of transmission oil level measurement exists, SPN 3027 Transmission Oil Level 1 High / Low should be used.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid fluid level measurement.","bit_length":8,"scaling":0.5,"offset":-62.5,"unit":"l","SLOT_ID":225},"5915":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":56,"SPN":5915,"SPN_Name":"Transmission Oil Level 2 Countdown Timer","SPN_Description":"Countdown timer for the second instance of a transmission oil level indicator. Once all vehicle conditions (such as vehicle stopped, etc) are met, some transmissions may require a \u2018settling time\u2019 to allow the fluid level to normalize. This parameter indicates how much of the required settling time remains. When time reaches 0, a valid oil level measurement value will be broadcast in SPN 5914 Transmission Oil Level 2 High / Low. If only a single oil level is measured, SPN 3028 Transmission Oil Level 1 Countdown Timer should be used.\\r\\n\\r\\n0000 less than 1 minute\\r\\n0001 One minute\\r\\n0010 Two minutes\\r\\n0011 Three minutes\\r\\n0100 Four minutes\\r\\n0101 Five minutes\\r\\n0110 Six minutes\\r\\n0111 Seven minutes\\r\\n1000 Eight minutes\\r\\n1001 Nine minutes\\r\\n1010 Ten minutes\\r\\n1011 Eleven minutes\\r\\n1100 Twelve minutes\\r\\n1101 Thirteen minutes\\r\\n1110 Error\\r\\n1111 Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5916":{"PGN":64917,"PGN_Name":"Transmission Fluids 2","PGN_Description":"TRF2","first_bit":60,"SPN":5916,"SPN_Name":"Transmission Oil Level 2 Measurement Status","SPN_Description":"Measurement status for the second instance of a transmission oil level indicator. Indicates if conditions are acceptable to obtain a valid transmission oil level measurement as conveyed in SPN 5914 Transmission Oil Level 2 High / Low. If conditions are not acceptable, this parameter conveys to the operator what prevents conditions from being acceptable. Only one condition can be conveyed in this parameter at any given point in time. If multiple conditions exist, it is not important which condition is actually broadcast, as the driver must \u2018correct\u2019 each and every condition as it is presented before a valid oil level reading can be made. If multiple conditions exist that prevent a valid reading, the sender should broadcast one of those conditions until it is corrected; then the next condition can be conveyed to the operator, and so on. If only a single oil level is measured, use SPN 3026 Transmission Oil Level 1 Measurement Status.\\r\\n\\r\\n0000 Conditions valid for transmission oil level measurement\\r\\n0001 Conditions not valid \u2013 Settling timer still counting down\\r\\n0010 Conditions not valid \u2013 Transmission in gear\\r\\n0011 Conditions not valid \u2013 Transmission fluid temperature too low\\r\\n0100 Conditions not valid \u2013 Transmission fluid temperature too high\\r\\n0101 Conditions not valid \u2013 Vehicle moving; output shaft speed too high\\r\\n0110 Conditions not valid \u2013 Vehicle not level\\r\\n0111 Conditions not valid \u2013 Engine speed too low\\r\\n1000 Conditions not valid \u2013 Engine speed too high\\r\\n1001 Conditions not valid \u2013 No request for reading\\r\\n1010 Not defined\\r\\n1011 Not defined\\r\\n1100 Not defined\\r\\n1101 Conditions not valid - Other\\r\\n1110 Error\\r\\n1111 Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5917":{"PGN":61584,"PGN_Name":"High Voltage Energy Storage 1 Data 1","PGN_Description":"HVES1D1","first_bit":0,"SPN":5917,"SPN_Name":"HVES1 Available Discharge Power","SPN_Description":"The rate at which the High Voltage Energy Storage 1 pack (or system) can currently provide energy for propulsion or other uses.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kW","SLOT_ID":346},"5918":{"PGN":61584,"PGN_Name":"High Voltage Energy Storage 1 Data 1","PGN_Description":"HVES1D1","first_bit":16,"SPN":5918,"SPN_Name":"HVES1 Available Charge Power","SPN_Description":"The rate at which the High Voltage Energy Storage 1 pack (or system) can currently receive energy from a regenerative or recharging system.","bit_length":16,"scaling":0.05,"offset":0,"unit":"kW","SLOT_ID":346},"5919":{"PGN":61584,"PGN_Name":"High Voltage Energy Storage 1 Data 1","PGN_Description":"HVES1D1","first_bit":32,"SPN":5919,"SPN_Name":"HVES1 Voltage Level","SPN_Description":"The voltage level of the High Voltage Energy Storage 1 pack (or system).  This parameter should be synchronized with SPN 5920 (HVES1 Current) such that a realized power value can be calculated.  If the HVES component physically contains the contactors which connect it to the vehicle high voltage system, then this voltage is measured before those contactors.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"5920":{"PGN":61584,"PGN_Name":"High Voltage Energy Storage 1 Data 1","PGN_Description":"HVES1D1","first_bit":48,"SPN":5920,"SPN_Name":"HVES1 Current","SPN_Description":"The current in or out of the High Voltage Energy Storage 1 pack (or system).  This parameter should be synchronized with SPN 5919 (HVES1 Voltage Level) such that a realized power value can be calculated.  This parameter is defined from the high voltage energy storage system\u2019s point of view.  A positive value represents current into (charging) the energy storage system.  A negative value represents current out of (discharging) the energy storage system.","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"5921":{"PGN":61585,"PGN_Name":"High Voltage Energy Storage 1 Data 2","PGN_Description":"HVES1D2","first_bit":0,"SPN":5921,"SPN_Name":"HVES1 Fast Update State of Charge","SPN_Description":"Indicates the High Voltage Energy Storage 1 pack (or system) state of charge.  0% means no charge remaining, 100% means the system is fully charged in terms of physical limits of the energy storage system.  Acceptable state of charge upper and lower boundaries for normal operation are defined in SPN 8118 (HVES1 Recommended Minimum State Of Charge) and SPN 8119 (HVES1 Recommended Maximum State Of Charge).  The update rate and resolution of this parameter are intended for control purposes within a hybrid control system; for a simple periodic value, SPN 5464 (Hybrid Battery Pack Remaining Charge) may be of use.","bit_length":16,"scaling":0.0015625,"offset":0,"unit":"%","SLOT_ID":345},"5922":{"PGN":61585,"PGN_Name":"High Voltage Energy Storage 1 Data 2","PGN_Description":"HVES1D2","first_bit":16,"SPN":5922,"SPN_Name":"HVES1 Highest Cell Voltage","SPN_Description":"The highest voltage level reported by any cell in the High Voltage Energy Storage 1 pack (or system).  If a single voltage sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured. See HVES1 Highest Cell Voltage Module Number (SPN 8236) and HVES1 Highest Cell Voltage Cell Number (SPN 8237) for cell location information.","bit_length":16,"scaling":0.001,"offset":0,"unit":"V","SLOT_ID":347},"5923":{"PGN":61585,"PGN_Name":"High Voltage Energy Storage 1 Data 2","PGN_Description":"HVES1D2","first_bit":32,"SPN":5923,"SPN_Name":"HVES1 Lowest Cell Voltage","SPN_Description":"The lowest voltage level reported by any cell in the High Voltage Energy Storage 1 pack (or system).   If a single voltage sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured.  See HVES1 Lowest Cell Voltage Module Number (SPN 8238) and HVES1 Lowest Cell Voltage Cell Number (SPN 8239) for cell location information.","bit_length":16,"scaling":0.001,"offset":0,"unit":"V","SLOT_ID":347},"5924":{"PGN":61585,"PGN_Name":"High Voltage Energy Storage 1 Data 2","PGN_Description":"HVES1D2","first_bit":48,"SPN":5924,"SPN_Name":"HVES1 Cell Voltage Differential Status","SPN_Description":"Indicates whether or not the differential between the highest and lowest cell voltages are within acceptable limits, according to the High Voltage Energy Storage 1 pack (or system).   The actual voltage differential can be calculated by subtracting SPN 5923 (HVES1 Lowest Cell Voltage) from SPN 5922 (HVES1 Highest Cell Voltage).\\r\\n\\r\\n0000 = Cell-to-cell voltage differential is within acceptable limits\\r\\n0001 = Cell-to-cell voltage differential exceeds acceptable limits but can be corrected via auto-balancing\\r\\n0010 = Cell-to-cell voltage differential exceeds acceptable limits to a point where external maintenance balancing is required to restore battery performance\\r\\n0011 = Cell-to-cell voltage differential exceeds acceptable limits to a point where external maintenance balancing cannot restore battery performance\\r\\n0100 = Cell-to-cell voltage differential exceeds acceptable limits; it is not known whether balancing can restore battery performance\\r\\n0101 - 1101 = Reserved\\r\\n1110 = Error\\r\\n1111 = Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5925":{"PGN":64776,"PGN_Name":"Engine oil message","PGN_Description":"EOM","first_bit":48,"SPN":5925,"SPN_Name":"Engine Oil Temperature 3","SPN_Description":"Temperature of the engine lubricant.\\r\\n\\r\\nNote:  If there is only one engine oil temperature measurement, SPN 175 should be used. \\r\\n\\r\\nSee also SPNs 175 and 1135 for additional engine oil temperature measurements.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5933":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":28,"SPN":5933,"SPN_Name":"Rear Steer Axle Group Weight Available","SPN_Description":"Indicates if a second (or rear) steer axle group weight is available.\\r\\n\\r\\n00 = Rear Steer axle group not present\\r\\n01 = Rear Steer axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable\\r\\n\\r\\nNote:  If there is only one steer axle, use SPN 4059.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5934":{"PGN":64875,"PGN_Name":"Available Axle Group Weights","PGN_Description":"AAGW","first_bit":30,"SPN":5934,"SPN_Name":"Rear Drive Axle Group Weight Available","SPN_Description":"Indicates if a second (or rear) drive axle group weight is available.\\r\\n\\r\\n00 = Rear drive axle group not present\\r\\n01 = Rear drive axle group present\\r\\n10 = Reserved\\r\\n11 = Not available / not applicable\\r\\n\\r\\nNote:  If there is only one drive axle, use SPN 4061.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5935":{"PGN":64874,"PGN_Name":"Axle Group Weight","PGN_Description":"AGW","first_bit":4,"SPN":5935,"SPN_Name":"Additional Axle Group Location","SPN_Description":"Location of the axle group, listed from front of the vehicle to rear.  If the value of SPN 4073 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\\r\\n\\r\\n0 = Reserved\\r\\n1 = Rear Steer axle group\\r\\n2 = Rear Drive axle group\\r\\n3-15 = Reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5936":{"PGN":64873,"PGN_Name":"Axle Group Calibration Weights","PGN_Description":"AGCW","first_bit":4,"SPN":5936,"SPN_Name":"Additional Axle Group Location","SPN_Description":"Location of the axle group, listed from front of the vehicle to rear.  If the value of SPN 4074 is 15, then this SPN is used to indicate the axle group referred to by this PGN. Otherwise, this SPN should be broadcast as 15.\\r\\n\\r\\n0 = Reserved\\r\\n1 = Rear Steer axle group\\r\\n2 = Rear Drive axle group\\r\\n3-15 = Reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"5937":{"PGN":64705,"PGN_Name":"Transmission Fluids 3","PGN_Description":"TRF3","first_bit":0,"SPN":5937,"SPN_Name":"Transmission Clutch 2 Pressure","SPN_Description":"Gage pressure of hydraulic actuation fluid of transmission second clutch in a dual clutch application.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"5938":{"PGN":64705,"PGN_Name":"Transmission Fluids 3","PGN_Description":"TRF3","first_bit":8,"SPN":5938,"SPN_Name":"Transmission Oil Transmission Cooler Outlet Temperature","SPN_Description":"Temperature of transmission lubricant after it exits from the transmission cooler.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"5941":{"PGN":64704,"PGN_Name":"Electronic Transmission Controller #11","PGN_Description":"ETC11","first_bit":24,"SPN":5941,"SPN_Name":"Transmission Shift Rail 4 Position","SPN_Description":"The current position of transmission shift rail identified as rail #4.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5942":{"PGN":64704,"PGN_Name":"Electronic Transmission Controller #11","PGN_Description":"ETC11","first_bit":32,"SPN":5942,"SPN_Name":"Transmission Shift Rail 5 Position","SPN_Description":"The current position of transmission shift rail identified as rail #5.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5943":{"PGN":64704,"PGN_Name":"Electronic Transmission Controller #11","PGN_Description":"ETC11","first_bit":40,"SPN":5943,"SPN_Name":"Transmission Shift Rail 6 Position","SPN_Description":"The current position of transmission shift rail identified as rail #6.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5944":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":0,"SPN":5944,"SPN_Name":"Transmission Clutch 1 Actuator Percent","SPN_Description":"The current modulated value for the transmission clutch 1 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5945":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":8,"SPN":5945,"SPN_Name":"Transmission Clutch 2 Actuator Percent","SPN_Description":"The current modulated value for the transmission clutch 2 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5946":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":16,"SPN":5946,"SPN_Name":"Transmission Hydraulic Pump Actuator 1 Percent","SPN_Description":"The current modulated value for the actuator that controls the transmission hydraulic pump, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5947":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":24,"SPN":5947,"SPN_Name":"Transmission Shift Actuator 1 Percent","SPN_Description":"The current modulated value for the transmission shift 1 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5948":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":32,"SPN":5948,"SPN_Name":"Transmission Shift Actuator 2 Percent","SPN_Description":"The current modulated value for the transmission shift 2 actuator, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"5949":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":40,"SPN":5949,"SPN_Name":"Transmission Clutch 1 Cooling Actuator Status","SPN_Description":"Identifies the status of the actuator that cools transmission clutch 1.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5950":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":42,"SPN":5950,"SPN_Name":"Transmission Clutch 2 Cooling Actuator Status","SPN_Description":"Identifies the status of the actuator that cools transmission clutch 2.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5951":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":44,"SPN":5951,"SPN_Name":"Transmission Shift Rail 1 Actuator Status","SPN_Description":"Identifies the status of the actuator that moves the transmission shift rail identified as rail #1.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5952":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":46,"SPN":5952,"SPN_Name":"Transmission Shift Rail 2 Actuator Status","SPN_Description":"Identifies the status of the actuator that moves the transmission shift rail identified as rail #2.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5953":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":48,"SPN":5953,"SPN_Name":"Transmission Shift Rail 3 Actuator Status","SPN_Description":"Identifies the status of the actuator that moves the transmission shift rail identified as rail #3.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5954":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":50,"SPN":5954,"SPN_Name":"Transmission Shift Rail 4 Actuator Status","SPN_Description":"Identifies the status of the actuator that moves the transmission shift rail identified as rail #4.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5955":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":52,"SPN":5955,"SPN_Name":"Transmission Shift Rail 5 Actuator Status","SPN_Description":"Identifies the status of the actuator that moves the transmission shift rail identified as rail #5.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5956":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":54,"SPN":5956,"SPN_Name":"Transmission Shift Rail 6 Actuator Status","SPN_Description":"Identifies the status of the actuator that moves the transmission shift rail identified as rail #6.\\r\\n\\r\\n00 = off\\r\\n01 = on\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5957":{"PGN":64702,"PGN_Name":"Electronic Transmission Controller #9","PGN_Description":"ETC9","first_bit":32,"SPN":5957,"SPN_Name":"Dual Clutch Transmission Selected Pre-selection Gear","SPN_Description":"The gear that the transmission will attempt to achieve during the current pre-selection event (shifting to a new gear on the non-engaged clutch of a dual clutch transmission (DCT)).","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"5958":{"PGN":64702,"PGN_Name":"Electronic Transmission Controller #9","PGN_Description":"ETC9","first_bit":40,"SPN":5958,"SPN_Name":"Dual Clutch Transmission Current Pre-selection Gear","SPN_Description":"The gear currently engaged on the non-engaged clutch of a dual clutch transmission (DCT) or the last gear engaged on the non-engaged clutch while the transmission is in the process of pre-selecting to the new or selected pre-selection gear on the non-engaged clutch. Transitions toward a destination gear will not be indicated. Once the selected pre-selected gear has been engaged then DCT Current Pre-Selection Gear (SPN 5958) will reflect that gear.","bit_length":8,"scaling":1,"offset":-125,"unit":"gear value","SLOT_ID":24},"5960":{"PGN":64702,"PGN_Name":"Electronic Transmission Controller #9","PGN_Description":"ETC9","first_bit":0,"SPN":5960,"SPN_Name":"Dual Clutch Transmission Input Shaft 1 Speed","SPN_Description":"Rotational velocity of the primary shaft transferring power through clutch 1 into the dual clutch transmission (DCT).","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"5961":{"PGN":64702,"PGN_Name":"Electronic Transmission Controller #9","PGN_Description":"ETC9","first_bit":16,"SPN":5961,"SPN_Name":"Dual Clutch Transmission Input Shaft 2 Speed","SPN_Description":"Rotational velocity of the primary shaft transferring power through clutch 2 into the dual clutch transmission (DCT).","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"5963":{"PGN":64701,"PGN_Name":"Aftertreatment 1 SCR Service Information 2","PGN_Description":"A1SCRSI2","first_bit":0,"SPN":5963,"SPN_Name":"Aftertreatment 1 Total Diesel Exhaust Fluid Used","SPN_Description":"Total amount of DEF used by aftertreatment device 1 over the lifetime of the device.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"5964":{"PGN":64700,"PGN_Name":"Aftertreatment 2 SCR Service Information 2","PGN_Description":"A2SCRSI2","first_bit":0,"SPN":5964,"SPN_Name":"Aftertreatment 2 Total Diesel Exhaust Fluid Used","SPN_Description":"Total amount of DEF used by aftertreatment device 2 over the lifetime of the device.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"5965":{"PGN":64699,"PGN_Name":"Aftertreatment 1 SCR Electronic Control Module Information","PGN_Description":"A1ECMI","first_bit":0,"SPN":5965,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Control Module 1 Relay Control","SPN_Description":"State signal which indicates when the DEF control module relay of aftertreatment 1 is being energized. On means the ECU is powering the Aftertreatment 1 DEF dosing unit relay. Note that the ECU is external to the relay. \\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the DEF dosing unit relay\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5966":{"PGN":64699,"PGN_Name":"Aftertreatment 1 SCR Electronic Control Module Information","PGN_Description":"A1ECMI","first_bit":2,"SPN":5966,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Control Module 1 Power Supply 1","SPN_Description":"State signal which indicates when the DEF control module power supply of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the DEF dosing unit power supply\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5967":{"PGN":64698,"PGN_Name":"Aftertreatment 2 SCR Electronic Control Module Information","PGN_Description":"A2ECMI","first_bit":0,"SPN":5967,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Control Module 1 Relay Control","SPN_Description":"State signal which indicates when the DEF control module 1 relay of aftertreatment 2 is being energized. On means the ECU is powering the Aftertreatment 2 DEF dosing unit relay. Note that the ECU is external to the relay. \\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the DEF dosing unit relay\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5968":{"PGN":64698,"PGN_Name":"Aftertreatment 2 SCR Electronic Control Module Information","PGN_Description":"A2ECMI","first_bit":2,"SPN":5968,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Control Module 1 Power Supply 1","SPN_Description":"State signal which indicates when the DEF control module 1 power supply of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module 1 power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the DEF dosing unit power supply\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5969":{"PGN":65031,"PGN_Name":"Exhaust Temperature","PGN_Description":"ET","first_bit":32,"SPN":5969,"SPN_Name":"Engine Exhaust Manifold Bank 2 Temperature 2","SPN_Description":"Temperature of combustion byproducts measured by a second sensor in engine bank 2 (right bank) exhaust manifold. This should be used for the sensor toward the rear of the engine on the bank 2 manifold.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5970":{"PGN":65031,"PGN_Name":"Exhaust Temperature","PGN_Description":"ET","first_bit":48,"SPN":5970,"SPN_Name":"Engine Exhaust Manifold Bank 1 Temperature 2","SPN_Description":"Temperature of combustion byproducts measured by a second sensor in engine bank 1 (left bank) exhaust manifold. This should be used for the sensor toward the rear of the engine on the bank 1 manifold.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"5973":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":32,"SPN":5973,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater Relay 1","SPN_Description":"The aftertreatment system 2 diesel exhaust fluid line heater relay 1 is used to energize one or more DEF line heaters.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5978":{"PGN":64697,"PGN_Name":"Aftertreatment 1 Service 2","PGN_Description":"AT1S2","first_bit":0,"SPN":5978,"SPN_Name":"Aftertreatment 1 Diesel Particulate Filter Time to Next Active Regeneration","SPN_Description":"Indicates the time to the next active regeneration event of diesel particulate filter 1.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"5979":{"PGN":64696,"PGN_Name":"Aftertreatment 2 Service 2","PGN_Description":"AT2S2","first_bit":0,"SPN":5979,"SPN_Name":"Aftertreatment 2 Diesel Particulate Filter Time to Next Active Regeneration","SPN_Description":"Indicates the time to the next active regeneration event of diesel particulate filter 2.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"5980":{"PGN":65245,"PGN_Name":"Turbocharger","PGN_Description":"TC","first_bit":32,"SPN":5980,"SPN_Name":"Engine Turbocharger Differential Speed","SPN_Description":"The difference between turbocharger speeds on engine systems with 2 or more turbochargers. If there are are more than 2 turbochargers, it will be the difference between the fastest and the slowest turbocharger speed.","bit_length":16,"scaling":4,"offset":0,"unit":"rpm","SLOT_ID":77},"5981":{"PGN":64694,"PGN_Name":"Vehicle Electrical Power 5","PGN_Description":"VEP5","first_bit":0,"SPN":5981,"SPN_Name":"SLI Battery Pack State of Charge","SPN_Description":"Indicates the remaining charge of the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery pack\'s current state of health.   See SPN 5464 for hybrid battery pack.\\r\\n\\r\\nThis parameter shall be used to report the capacity of the battery pack.  If the state of charge of individual batteries within the battery pack is desired, use SPNs 7903, 7911, 7919, & 7927.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"5982":{"PGN":64694,"PGN_Name":"Vehicle Electrical Power 5","PGN_Description":"VEP5","first_bit":16,"SPN":5982,"SPN_Name":"SLI Battery Pack Capacity","SPN_Description":"Original or rated total reserve capacity of the battery pack used for starting the engine, for lighting, and for ignition (SLI).\\r\\n\\r\\nThis parameter shall be used to report the capacity of the battery pack.  If the capacity of individual batteries within the battery pack is desired, use SPNs 7902, 7912, 7920, & 7928.","bit_length":16,"scaling":1,"offset":0,"unit":"Ah","SLOT_ID":351},"5983":{"PGN":64694,"PGN_Name":"Vehicle Electrical Power 5","PGN_Description":"VEP5","first_bit":32,"SPN":5983,"SPN_Name":"SLI Battery Pack Health","SPN_Description":"Capacity of the battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\\r\\n\\r\\nThis parameter shall be used to report the health of the battery pack.  If the health of individual batteries within the battery pack is desired, use SPNs 7905, 7913, 7921, & 7929.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"5984":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":0,"SPN":5984,"SPN_Name":"Switched Power Output #4 Command","SPN_Description":"Desired state of Switched Power Output #4. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5985":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":2,"SPN":5985,"SPN_Name":"Switched Power Output #3 Command","SPN_Description":"Desired state of Switched Power Output #3. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5986":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":4,"SPN":5986,"SPN_Name":"Switched Power Output #2 Command","SPN_Description":"Desired state of Switched Power Output #2. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5987":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":6,"SPN":5987,"SPN_Name":"Switched Power Output #1 Command","SPN_Description":"Desired state of Switched Power Output #1. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5988":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":8,"SPN":5988,"SPN_Name":"Switched Power Output #8 Command","SPN_Description":"Desired state of Switched Power Output #8. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5989":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":10,"SPN":5989,"SPN_Name":"Switched Power Output #7 Command","SPN_Description":"Desired state of Switched Power Output #7. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5990":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":12,"SPN":5990,"SPN_Name":"Switched Power Output #6 Command","SPN_Description":"Desired state of Switched Power Output #6. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5991":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":14,"SPN":5991,"SPN_Name":"Switched Power Output #5 Command","SPN_Description":"Desired state of Switched Power Output #5. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5992":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":16,"SPN":5992,"SPN_Name":"Switched Power Output #12 Command","SPN_Description":"Desired state of Switched Power Output #12. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5993":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":18,"SPN":5993,"SPN_Name":"Switched Power Output #11 Command","SPN_Description":"Desired state of Switched Power Output #11. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5994":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":20,"SPN":5994,"SPN_Name":"Switched Power Output #10 Command","SPN_Description":"Desired state of Switched Power Output #10. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5995":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":22,"SPN":5995,"SPN_Name":"Switched Power Output #9 Command","SPN_Description":"Desired state of Switched Power Output #9. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5996":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":24,"SPN":5996,"SPN_Name":"Switched Power Output #16 Command","SPN_Description":"Desired state of Switched Power Output #16. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5997":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":26,"SPN":5997,"SPN_Name":"Switched Power Output #15 Command","SPN_Description":"Desired state of Switched Power Output #15. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5998":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":28,"SPN":5998,"SPN_Name":"Switched Power Output #14 Command","SPN_Description":"Desired state of Switched Power Output #14. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"5999":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":30,"SPN":5999,"SPN_Name":"Switched Power Output #13 Command","SPN_Description":"Desired state of Switched Power Output #13. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6000":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":32,"SPN":6000,"SPN_Name":"Switched Power Output #20 Command","SPN_Description":"Desired state of Switched Power Output #20. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6001":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":34,"SPN":6001,"SPN_Name":"Switched Power Output #19 Command","SPN_Description":"Desired state of Switched Power Output #19. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6002":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":36,"SPN":6002,"SPN_Name":"Switched Power Output #18 Command","SPN_Description":"Desired state of Switched Power Output #18. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6003":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":38,"SPN":6003,"SPN_Name":"Switched Power Output #17 Command","SPN_Description":"Desired state of Switched Power Output #17. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6004":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":40,"SPN":6004,"SPN_Name":"Switched Power Output #24 Command","SPN_Description":"Desired state of Switched Power Output #24. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6005":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":42,"SPN":6005,"SPN_Name":"Switched Power Output #23 Command","SPN_Description":"Desired state of Switched Power Output #23. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6006":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":44,"SPN":6006,"SPN_Name":"Switched Power Output #22 Command","SPN_Description":"Desired state of Switched Power Output #22. Used to set the desired state.\\r\\n\\r\\n00 - Output off\\r\\n01 - Output on\\r\\n10 - Reserved\\r\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6007":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":46,"SPN":6007,"SPN_Name":"Switched Power Output #21 Command","SPN_Description":"Desired state of Switched Power Output #21. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6008":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":48,"SPN":6008,"SPN_Name":"Switched Power Output #28 Command","SPN_Description":"Desired state of Switched Power Output #28. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6009":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":50,"SPN":6009,"SPN_Name":"Switched Power Output #27 Command","SPN_Description":"Desired state of Switched Power Output #27. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6010":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":52,"SPN":6010,"SPN_Name":"Switched Power Output #26 Command","SPN_Description":"Desired state of Switched Power Output #26. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6011":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":54,"SPN":6011,"SPN_Name":"Switched Power Output #25 Command","SPN_Description":"Desired state of Switched Power Output #25. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6012":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":56,"SPN":6012,"SPN_Name":"Switched Power Output #32 Command","SPN_Description":"Desired state of Switched Power Output #32. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6013":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":58,"SPN":6013,"SPN_Name":"Switched Power Output #31 Command","SPN_Description":"Desired state of Switched Power Output #31. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6014":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":60,"SPN":6014,"SPN_Name":"Switched Power Output #30 Command","SPN_Description":"Desired state of Switched Power Output #30. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6015":{"PGN":34304,"PGN_Name":"Switched Power Outputs Command","PGN_Description":"SPOC","first_bit":62,"SPN":6015,"SPN_Name":"Switched Power Output #29 Command","SPN_Description":"Desired state of Switched Power Output #29. Used to set the desired state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6016":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":0,"SPN":6016,"SPN_Name":"Fused Output #4","SPN_Description":"State of Fused Output #4. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6017":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":2,"SPN":6017,"SPN_Name":"Fused Output #3","SPN_Description":"State of Fused Output #3. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6018":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":4,"SPN":6018,"SPN_Name":"Fused Output #2","SPN_Description":"State of Fused Output #2. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6019":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":6,"SPN":6019,"SPN_Name":"Fused Output #1","SPN_Description":"State of Fused Output #1. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6020":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":8,"SPN":6020,"SPN_Name":"Fused Output #8","SPN_Description":"State of Fused Output #8. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6021":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":10,"SPN":6021,"SPN_Name":"Fused Output #7","SPN_Description":"State of Fused Output #7. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6022":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":12,"SPN":6022,"SPN_Name":"Fused Output #6","SPN_Description":"State of Fused Output #6. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6023":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":14,"SPN":6023,"SPN_Name":"Fused Output #5","SPN_Description":"State of Fused Output #5. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6024":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":16,"SPN":6024,"SPN_Name":"Fused Output #12","SPN_Description":"State of Fused Output #12. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6025":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":18,"SPN":6025,"SPN_Name":"Fused Output #11","SPN_Description":"State of Fused Output #11. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6026":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":20,"SPN":6026,"SPN_Name":"Fused Output #10","SPN_Description":"State of Fused Output #10. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6027":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":22,"SPN":6027,"SPN_Name":"Fused Output #9","SPN_Description":"State of Fused Output #9. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6028":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":24,"SPN":6028,"SPN_Name":"Fused Output #16","SPN_Description":"State of Fused Output #16. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6029":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":26,"SPN":6029,"SPN_Name":"Fused Output #15","SPN_Description":"State of Fused Output #15. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6030":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":28,"SPN":6030,"SPN_Name":"Fused Output #14","SPN_Description":"State of Fused Output #14. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6031":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":30,"SPN":6031,"SPN_Name":"Fused Output #13","SPN_Description":"State of Fused Output #13. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6032":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":32,"SPN":6032,"SPN_Name":"Fused Output #20","SPN_Description":"State of Fused Output #20. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6033":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":34,"SPN":6033,"SPN_Name":"Fused Output #19","SPN_Description":"State of Fused Output #19. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6034":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":36,"SPN":6034,"SPN_Name":"Fused Output #18","SPN_Description":"State of Fused Output #18. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6035":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":38,"SPN":6035,"SPN_Name":"Fused Output #17","SPN_Description":"State of Fused Output #17. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6036":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":40,"SPN":6036,"SPN_Name":"Fused Output #24","SPN_Description":"State of Fused Output #24. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6037":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":42,"SPN":6037,"SPN_Name":"Fused Output #23","SPN_Description":"State of Fused Output #23. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6038":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":44,"SPN":6038,"SPN_Name":"Fused Output #22","SPN_Description":"State of Fused Output #22. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6039":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":46,"SPN":6039,"SPN_Name":"Fused Output #21","SPN_Description":"State of Fused Output #21. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6040":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":48,"SPN":6040,"SPN_Name":"Fused Output #28","SPN_Description":"State of Fused Output #28. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6041":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":50,"SPN":6041,"SPN_Name":"Fused Output #27","SPN_Description":"State of Fused Output #27. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6042":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":52,"SPN":6042,"SPN_Name":"Fused Output #26","SPN_Description":"State of Fused Output #26. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6043":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":54,"SPN":6043,"SPN_Name":"Fused Output #25","SPN_Description":"State of Fused Output #25. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6044":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":56,"SPN":6044,"SPN_Name":"Fused Output #32","SPN_Description":"State of Fused Output #32. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6045":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":58,"SPN":6045,"SPN_Name":"Fused Output #31","SPN_Description":"State of Fused Output #31. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6046":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":60,"SPN":6046,"SPN_Name":"Fused Output #30","SPN_Description":"State of Fused Output #30. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6047":{"PGN":64693,"PGN_Name":"Fused Power Output Status","PGN_Description":"FPOS","first_bit":62,"SPN":6047,"SPN_Name":"Fused Output #29","SPN_Description":"State of Fused Output #29. Used to indicate the output state.\\n\\n00 - Output not powered\\n01 - Output powered\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6048":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":0,"SPN":6048,"SPN_Name":"Switched Output #4","SPN_Description":"State of Switched Output #4. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6049":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":2,"SPN":6049,"SPN_Name":"Switched Output #3","SPN_Description":"State of Switched Output #3. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6050":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":4,"SPN":6050,"SPN_Name":"Switched Output #2","SPN_Description":"State of Switched Output #2. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6051":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":6,"SPN":6051,"SPN_Name":"Switched Output #1","SPN_Description":"State of Switched Output #1. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6052":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":8,"SPN":6052,"SPN_Name":"Switched Output #8","SPN_Description":"State of Switched Output #8. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6053":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":10,"SPN":6053,"SPN_Name":"Switched Output #7","SPN_Description":"State of Switched Output #7. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6054":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":12,"SPN":6054,"SPN_Name":"Switched Output #6","SPN_Description":"State of Switched Output #6. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6055":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":14,"SPN":6055,"SPN_Name":"Switched Output #5","SPN_Description":"State of Switched Output #5. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6056":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":16,"SPN":6056,"SPN_Name":"Switched Output #12","SPN_Description":"State of Switched Output #12. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6057":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":18,"SPN":6057,"SPN_Name":"Switched Output #11","SPN_Description":"State of Switched Output #11. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6058":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":20,"SPN":6058,"SPN_Name":"Switched Output #10","SPN_Description":"State of Switched Output #10. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6059":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":22,"SPN":6059,"SPN_Name":"Switched Output #9","SPN_Description":"State of Switched Output #9. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6060":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":24,"SPN":6060,"SPN_Name":"Switched Output #16","SPN_Description":"State of Switched Output #16. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6061":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":26,"SPN":6061,"SPN_Name":"Switched Output #15","SPN_Description":"State of Switched Output #15. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6062":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":28,"SPN":6062,"SPN_Name":"Switched Output #14","SPN_Description":"State of Switched Output #14. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6063":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":30,"SPN":6063,"SPN_Name":"Switched Output #13","SPN_Description":"State of Switched Output #13. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6064":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":32,"SPN":6064,"SPN_Name":"Switched Output #20","SPN_Description":"State of Switched Output #20. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6065":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":34,"SPN":6065,"SPN_Name":"Switched Output #19","SPN_Description":"State of Switched Output #19. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6066":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":36,"SPN":6066,"SPN_Name":"Switched Output #18","SPN_Description":"State of Switched Output #18. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6067":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":38,"SPN":6067,"SPN_Name":"Switched Output #17","SPN_Description":"State of Switched Output #17. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6068":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":40,"SPN":6068,"SPN_Name":"Switched Output #24","SPN_Description":"State of Switched Output #24. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6069":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":42,"SPN":6069,"SPN_Name":"Switched Output #23","SPN_Description":"State of Switched Output #23. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6070":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":44,"SPN":6070,"SPN_Name":"Switched Output #22","SPN_Description":"State of Switched Output #22. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6071":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":46,"SPN":6071,"SPN_Name":"Switched Output #21","SPN_Description":"State of Switched Output #21. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6072":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":48,"SPN":6072,"SPN_Name":"Switched Output #28","SPN_Description":"State of Switched Output #28. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6073":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":50,"SPN":6073,"SPN_Name":"Switched Output #27","SPN_Description":"State of Switched Output #27. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6074":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":52,"SPN":6074,"SPN_Name":"Switched Output #26","SPN_Description":"State of Switched Output #26. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6075":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":54,"SPN":6075,"SPN_Name":"Switched Output #25","SPN_Description":"State of Switched Output #25. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6076":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":56,"SPN":6076,"SPN_Name":"Switched Output #32","SPN_Description":"State of Switched Output #32. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6077":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":58,"SPN":6077,"SPN_Name":"Switched Output #31","SPN_Description":"State of Switched Output #31. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6078":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":60,"SPN":6078,"SPN_Name":"Switched Output #30","SPN_Description":"State of Switched Output #30. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6079":{"PGN":64692,"PGN_Name":"Switched Power Output Status","PGN_Description":"SPOS","first_bit":62,"SPN":6079,"SPN_Name":"Switched Output #29","SPN_Description":"State of Switched Output #29. Used to indicate the output state.\\n\\n00 - Output off\\n01 - Output on\\n10 - Reserved\\n11 - Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6080":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":0,"SPN":6080,"SPN_Name":"Fused Output #1 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #1.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6081":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":16,"SPN":6081,"SPN_Name":"Fused Output #2 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #2.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6082":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":32,"SPN":6082,"SPN_Name":"Fused Output #3 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #3.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6083":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":48,"SPN":6083,"SPN_Name":"Fused Output #4 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #4.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6084":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":64,"SPN":6084,"SPN_Name":"Fused Output #5 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #5.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6085":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":80,"SPN":6085,"SPN_Name":"Fused Output #6 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #6.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6086":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":96,"SPN":6086,"SPN_Name":"Fused Output #7 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #7.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6087":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":112,"SPN":6087,"SPN_Name":"Fused Output #8 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #8.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6088":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":128,"SPN":6088,"SPN_Name":"Fused Output #9 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #9.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6089":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":144,"SPN":6089,"SPN_Name":"Fused Output #10 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #10.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6090":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":160,"SPN":6090,"SPN_Name":"Fused Output #11 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #11.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6091":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":176,"SPN":6091,"SPN_Name":"Fused Output #12 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #12.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6092":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":192,"SPN":6092,"SPN_Name":"Fused Output #13 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #13.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6093":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":208,"SPN":6093,"SPN_Name":"Fused Output #14 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #14.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6094":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":224,"SPN":6094,"SPN_Name":"Fused Output #15 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #15.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6095":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":240,"SPN":6095,"SPN_Name":"Fused Output #16 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #16.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6096":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":256,"SPN":6096,"SPN_Name":"Fused Output #17 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #17.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6097":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":272,"SPN":6097,"SPN_Name":"Fused Output #18 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #18.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6098":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":288,"SPN":6098,"SPN_Name":"Fused Output #19 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #19.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6099":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":304,"SPN":6099,"SPN_Name":"Fused Output #20 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #20.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6100":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":320,"SPN":6100,"SPN_Name":"Fused Output #21 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #21.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6101":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":336,"SPN":6101,"SPN_Name":"Fused Output #22 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #22.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6102":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":352,"SPN":6102,"SPN_Name":"Fused Output #23 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #23.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6103":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":368,"SPN":6103,"SPN_Name":"Fused Output #24 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #24.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6104":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":384,"SPN":6104,"SPN_Name":"Fused Output #25 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #25.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6105":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":400,"SPN":6105,"SPN_Name":"Fused Output #26 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #26.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6106":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":416,"SPN":6106,"SPN_Name":"Fused Output #27 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #27.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6107":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":432,"SPN":6107,"SPN_Name":"Fused Output #28 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #28.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6108":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":448,"SPN":6108,"SPN_Name":"Fused Output #29 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #29.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6109":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":464,"SPN":6109,"SPN_Name":"Fused Output #30 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #30.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6110":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":480,"SPN":6110,"SPN_Name":"Fused Output #31 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #31.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6111":{"PGN":64691,"PGN_Name":"Fused Power Output Current","PGN_Description":"FPOC","first_bit":496,"SPN":6111,"SPN_Name":"Fused Output #32 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Fused Output #32.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6112":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":0,"SPN":6112,"SPN_Name":"Switched Output #1 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #1.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6113":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":16,"SPN":6113,"SPN_Name":"Switched Output #2 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #2.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6114":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":32,"SPN":6114,"SPN_Name":"Switched Output #3 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #3.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6115":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":48,"SPN":6115,"SPN_Name":"Switched Output #4 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #4.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6116":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":64,"SPN":6116,"SPN_Name":"Switched Output #5 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #5.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6117":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":80,"SPN":6117,"SPN_Name":"Switched Output #6 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #6.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6118":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":96,"SPN":6118,"SPN_Name":"Switched Output #7 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #7.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6119":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":112,"SPN":6119,"SPN_Name":"Switched Output #8 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #8.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6120":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":128,"SPN":6120,"SPN_Name":"Switched Output #9 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #9.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6121":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":144,"SPN":6121,"SPN_Name":"Switched Output #10 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #10.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6122":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":160,"SPN":6122,"SPN_Name":"Switched Output #11 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #11.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6123":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":176,"SPN":6123,"SPN_Name":"Switched Output #12 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #12.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6124":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":192,"SPN":6124,"SPN_Name":"Switched Output #13 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #13.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6125":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":208,"SPN":6125,"SPN_Name":"Switched Output #14 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #14.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6126":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":224,"SPN":6126,"SPN_Name":"Switched Output #15 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #15.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6127":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":240,"SPN":6127,"SPN_Name":"Switched Output #16 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #16.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6128":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":256,"SPN":6128,"SPN_Name":"Switched Output #17 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #17.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6129":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":272,"SPN":6129,"SPN_Name":"Switched Output #18 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #18.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6130":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":288,"SPN":6130,"SPN_Name":"Switched Output #19 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #19.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6131":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":304,"SPN":6131,"SPN_Name":"Switched Output #20 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #20.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6132":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":320,"SPN":6132,"SPN_Name":"Switched Output #21 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #21.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6133":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":336,"SPN":6133,"SPN_Name":"Switched Output #22 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #22.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6134":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":352,"SPN":6134,"SPN_Name":"Switched Output #23 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #23.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6135":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":368,"SPN":6135,"SPN_Name":"Switched Output #24 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #24.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6136":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":384,"SPN":6136,"SPN_Name":"Switched Output #25 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #25.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6137":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":400,"SPN":6137,"SPN_Name":"Switched Output #26 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #26.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6138":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":416,"SPN":6138,"SPN_Name":"Switched Output #27 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #27.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6139":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":432,"SPN":6139,"SPN_Name":"Switched Output #28 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #28.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6140":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":448,"SPN":6140,"SPN_Name":"Switched Output #29 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #29.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6141":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":464,"SPN":6141,"SPN_Name":"Switched Output #30 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #30.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6142":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":480,"SPN":6142,"SPN_Name":"Switched Output #31 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #31.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6143":{"PGN":64690,"PGN_Name":"Switched Power Output Current","PGN_Description":"SPOC1","first_bit":496,"SPN":6143,"SPN_Name":"Switched Output #32 Current","SPN_Description":"Measured electrical current flowing out of Power Distribution Module (PDM) Switched Output #32.","bit_length":16,"scaling":0.005,"offset":0,"unit":"A","SLOT_ID":352},"6201":{"PGN":61486,"PGN_Name":"Engine Turbocharger Control","PGN_Description":"ETCC","first_bit":48,"SPN":6201,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Command","SPN_Description":"The command to blow off actuator 1, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow). The purpose of Blow-off value is similar to that of Compressor bypass valve, however the blow-off valve releases the air at the high pressure compressor outlet to the low pressure turbine outlet.\\r\\n\\r\\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \\r\\n\\r\\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \\r\\n\\r\\nCalibration status from the actuator is received on SPN 6316.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"6202":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":24,"SPN":6202,"SPN_Name":"Engine Control Module 1 Ready for Use Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Control Module 1 Ready for Use Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6203":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":26,"SPN":6203,"SPN_Name":"Engine Control Module 2 Ready for Use Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Control Module 2 Ready for Use Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6204":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":28,"SPN":6204,"SPN_Name":"Engine Control Module 3 Ready for Use Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Control Module 3 Ready for Use Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6205":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":24,"SPN":6205,"SPN_Name":"Engine Control Module 1 Ready for Use Lamp Command","SPN_Description":"Command signal directly controlling the Engine Control Module 1 Ready for use Lamp. This lamp is used to indicate whether ECM 1 can control the operation of the engine. In case of a failure in ECM 1, lamp will be turned OFF.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6206":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":26,"SPN":6206,"SPN_Name":"Engine Control Module 2 Ready for Use Lamp Command","SPN_Description":"Command signal directly controlling the Engine Control Module 2 Ready for Use Lamp. This lamp is used to indicate whether ECM 2 can control the operation of the engine. In case of a failure in ECM 2, lamp will be turned OFF.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6207":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":28,"SPN":6207,"SPN_Name":"Engine Control Module 3 Ready for Use Lamp Command","SPN_Description":"Command signal directly controlling the Engine Control Module 3 Ready for Use Lamp. This lamp is used to indicate whether ECM 3 can control the operation of the engine. In case of a failure in ECM 3, lamp will be turned OFF.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6208":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":24,"SPN":6208,"SPN_Name":"AEBS readiness state","SPN_Description":"Advanced emergency braking systems (AEBS) will limit the engine torque via TSC1 during warning and braking phases. Therefore the engine controller gives a feedback to the AEBS if it is configured and able to obey these limitation commands.\\r\\n\\r\\n00 - Off -- engine is not configured to accept commands from an AEBS\\r\\n01 - On -- engine is configured to accept commands from an AEBS\\r\\n10 - Condition exists that prevents system from responding to AEBS commands even though it is configured\\r\\n11 - Not Available/Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6209":{"PGN":64870,"PGN_Name":"Engine Temperature 4","PGN_Description":"ET4","first_bit":56,"SPN":6209,"SPN_Name":"Engine Coolant Temperature 3","SPN_Description":"Third temperature of liquid found in the engine cooling system. See also SPNs 110, 4076 and 4193.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6214":{"PGN":64689,"PGN_Name":"Engine Ignition Control Module Status","PGN_Description":"ICMSTS","first_bit":0,"SPN":6214,"SPN_Name":"Engine Ignition Control Module 1 Temperature","SPN_Description":"Measured internal temperature of the Engine Ignition Control Module 1 circuitry.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6215":{"PGN":64689,"PGN_Name":"Engine Ignition Control Module Status","PGN_Description":"ICMSTS","first_bit":8,"SPN":6215,"SPN_Name":"Engine Ignition Control Module 2 Temperature","SPN_Description":"Measured internal temperature of the Engine Ignition Control Module 2 circuitry.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6216":{"PGN":64689,"PGN_Name":"Engine Ignition Control Module Status","PGN_Description":"ICMSTS","first_bit":16,"SPN":6216,"SPN_Name":"Engine Ignition Control Module 1 State","SPN_Description":"This parameter is used to indicate the current state of Engine Ignition Control Module 1.\\r\\n\\r\\n000 - Disabled (by user)\\r\\n001 - Shutdown (due to alarm)\\r\\n010 - Stalled (waiting for timing signals)\\r\\n011 - Firing Ignition in Test Mode\\r\\n100 - Firing Ignition in Normal Mode\\r\\n101 - Reserved\\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6217":{"PGN":64689,"PGN_Name":"Engine Ignition Control Module Status","PGN_Description":"ICMSTS","first_bit":19,"SPN":6217,"SPN_Name":"Engine Ignition Control Module 2 State","SPN_Description":"This parameter is used to indicate the current state of Engine Ignition Control Module 2.\\r\\n\\r\\n000 - Disabled (by user)\\r\\n001 - Shutdown (due to alarm)\\r\\n010 - Stalled (waiting for timing signals)\\r\\n011 - Firing Ignition in Test Mode\\r\\n100 - Firing Ignition in Normal Mode\\r\\n101 - Reserved\\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6218":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":20,"SPN":6218,"SPN_Name":"Engine Spark Plug Secondary Voltage Tracking Reset","SPN_Description":"Command signal used to reset the ignition controller average, maximum, and minimum level tracking of the spark plug secondary voltages and to reset the learned misfire rate.  Average secondary voltage tracking is reported in PGNs 64882 - 64887.  Minimum secondary voltage tracking is reported in PGNs 64682 - 64687.  Maximum secondary voltage tracking is reported in PGNs 64676 - 64681.  Misfire rates are reported in PGNs 64673 - 64675.\\r\\n\\r\\n00 Do not reset\\r\\n01 Reset\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6219":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":22,"SPN":6219,"SPN_Name":"Engine Ignition Control Maintenance Hours Reset","SPN_Description":"Used to reset the maintenance hour counter for an engine ignition control module.  The hours remaining until required maintenance is performed are reported in PGN 64688.\\r\\n\\r\\n00 Do not reset\\r\\n01 Reset\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6220":{"PGN":64688,"PGN_Name":"Engine Ignition Controller Maintenance Hours","PGN_Description":"EICMH","first_bit":0,"SPN":6220,"SPN_Name":"Engine Ignition Control Module 1 Time Remaining","SPN_Description":"This parameter reports the time remaining before maintenance should be performed on engine ignition control module instance 1.  Upon maintenance, the time is reset to its starting value using Reset PGN 56832, Ignition Control Maintenance Hours Reset, SPN 6219.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"6221":{"PGN":64688,"PGN_Name":"Engine Ignition Controller Maintenance Hours","PGN_Description":"EICMH","first_bit":32,"SPN":6221,"SPN_Name":"Engine Ignition Control Module 2 Time Remaining","SPN_Description":"This parameter reports the time remaining before maintenance should be performed on engine ignition control module instance 2.  Upon maintenance, the time is reset to its starting value using Reset PGN 56832, Ignition Control Maintenance Hours Reset, SPN 6219.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"6222":{"PGN":64687,"PGN_Name":"Engine Spark Minimum Voltage 1","PGN_Description":"ESVMIN1","first_bit":0,"SPN":6222,"SPN_Name":"Engine Spark Plug 1 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #1 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6223":{"PGN":64687,"PGN_Name":"Engine Spark Minimum Voltage 1","PGN_Description":"ESVMIN1","first_bit":16,"SPN":6223,"SPN_Name":"Engine Spark Plug 2 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #2 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6224":{"PGN":64687,"PGN_Name":"Engine Spark Minimum Voltage 1","PGN_Description":"ESVMIN1","first_bit":32,"SPN":6224,"SPN_Name":"Engine Spark Plug 3 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #3 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6225":{"PGN":64687,"PGN_Name":"Engine Spark Minimum Voltage 1","PGN_Description":"ESVMIN1","first_bit":48,"SPN":6225,"SPN_Name":"Engine Spark Plug 4 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #4 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6226":{"PGN":64686,"PGN_Name":"Engine Spark Minimum Voltage 2","PGN_Description":"ESVMIN2","first_bit":0,"SPN":6226,"SPN_Name":"Engine Spark Plug 5 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #5 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6227":{"PGN":64686,"PGN_Name":"Engine Spark Minimum Voltage 2","PGN_Description":"ESVMIN2","first_bit":16,"SPN":6227,"SPN_Name":"Engine Spark Plug 6 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #6 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6228":{"PGN":64686,"PGN_Name":"Engine Spark Minimum Voltage 2","PGN_Description":"ESVMIN2","first_bit":32,"SPN":6228,"SPN_Name":"Engine Spark Plug 7 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #7 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6229":{"PGN":64686,"PGN_Name":"Engine Spark Minimum Voltage 2","PGN_Description":"ESVMIN2","first_bit":48,"SPN":6229,"SPN_Name":"Engine Spark Plug 8 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #8 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6230":{"PGN":64685,"PGN_Name":"Engine Spark Minimum Voltage 3","PGN_Description":"ESVMIN3","first_bit":0,"SPN":6230,"SPN_Name":"Engine Spark Plug 9 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #9 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6231":{"PGN":64685,"PGN_Name":"Engine Spark Minimum Voltage 3","PGN_Description":"ESVMIN3","first_bit":16,"SPN":6231,"SPN_Name":"Engine Spark Plug 10 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #10 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6232":{"PGN":64685,"PGN_Name":"Engine Spark Minimum Voltage 3","PGN_Description":"ESVMIN3","first_bit":32,"SPN":6232,"SPN_Name":"Engine Spark Plug 11 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #11 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6233":{"PGN":64685,"PGN_Name":"Engine Spark Minimum Voltage 3","PGN_Description":"ESVMIN3","first_bit":48,"SPN":6233,"SPN_Name":"Engine Spark Plug 12 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #12 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6234":{"PGN":64684,"PGN_Name":"Engine Spark Minimum Voltage 4","PGN_Description":"ESVMIN4","first_bit":0,"SPN":6234,"SPN_Name":"Engine Spark Plug 13 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #13 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6235":{"PGN":64684,"PGN_Name":"Engine Spark Minimum Voltage 4","PGN_Description":"ESVMIN4","first_bit":16,"SPN":6235,"SPN_Name":"Engine Spark Plug 14 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #14 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6236":{"PGN":64684,"PGN_Name":"Engine Spark Minimum Voltage 4","PGN_Description":"ESVMIN4","first_bit":32,"SPN":6236,"SPN_Name":"Engine Spark Plug 15 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #15 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6237":{"PGN":64684,"PGN_Name":"Engine Spark Minimum Voltage 4","PGN_Description":"ESVMIN4","first_bit":48,"SPN":6237,"SPN_Name":"Engine Spark Plug 16 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #16 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6238":{"PGN":64683,"PGN_Name":"Engine Spark Minimum Voltage 5","PGN_Description":"ESVMIN5","first_bit":0,"SPN":6238,"SPN_Name":"Engine Spark Plug 17 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #17 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6239":{"PGN":64683,"PGN_Name":"Engine Spark Minimum Voltage 5","PGN_Description":"ESVMIN5","first_bit":16,"SPN":6239,"SPN_Name":"Engine Spark Plug 18 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #18 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6240":{"PGN":64683,"PGN_Name":"Engine Spark Minimum Voltage 5","PGN_Description":"ESVMIN5","first_bit":32,"SPN":6240,"SPN_Name":"Engine Spark Plug 19 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #19 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6241":{"PGN":64683,"PGN_Name":"Engine Spark Minimum Voltage 5","PGN_Description":"ESVMIN5","first_bit":48,"SPN":6241,"SPN_Name":"Engine Spark Plug 20 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #20 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6242":{"PGN":64682,"PGN_Name":"Engine Spark Minimum Voltage 6","PGN_Description":"ESVMIN6","first_bit":0,"SPN":6242,"SPN_Name":"Engine Spark Plug 21 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #21 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6243":{"PGN":64682,"PGN_Name":"Engine Spark Minimum Voltage 6","PGN_Description":"ESVMIN6","first_bit":16,"SPN":6243,"SPN_Name":"Engine Spark Plug 22 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #22 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6244":{"PGN":64682,"PGN_Name":"Engine Spark Minimum Voltage 6","PGN_Description":"ESVMIN6","first_bit":32,"SPN":6244,"SPN_Name":"Engine Spark Plug 23 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #23 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6245":{"PGN":64682,"PGN_Name":"Engine Spark Minimum Voltage 6","PGN_Description":"ESVMIN6","first_bit":48,"SPN":6245,"SPN_Name":"Engine Spark Plug 24 Minimum Voltage","SPN_Description":"The smallest measured spark voltage of all measured spark events on Cylinder #24 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6246":{"PGN":64681,"PGN_Name":"Engine Spark Maximum Voltage 1","PGN_Description":"ESVMAX1","first_bit":0,"SPN":6246,"SPN_Name":"Engine Spark Plug 1 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #1 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6247":{"PGN":64681,"PGN_Name":"Engine Spark Maximum Voltage 1","PGN_Description":"ESVMAX1","first_bit":16,"SPN":6247,"SPN_Name":"Engine Spark Plug 2 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #2 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6248":{"PGN":64681,"PGN_Name":"Engine Spark Maximum Voltage 1","PGN_Description":"ESVMAX1","first_bit":32,"SPN":6248,"SPN_Name":"Engine Spark Plug 3 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #3 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6249":{"PGN":64681,"PGN_Name":"Engine Spark Maximum Voltage 1","PGN_Description":"ESVMAX1","first_bit":48,"SPN":6249,"SPN_Name":"Engine Spark Plug 4 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #4 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6250":{"PGN":64680,"PGN_Name":"Engine Spark Maximum Voltage 2","PGN_Description":"ESVMAX2","first_bit":0,"SPN":6250,"SPN_Name":"Engine Spark Plug 5 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #5 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6251":{"PGN":64680,"PGN_Name":"Engine Spark Maximum Voltage 2","PGN_Description":"ESVMAX2","first_bit":16,"SPN":6251,"SPN_Name":"Engine Spark Plug 6 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #6 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6252":{"PGN":64680,"PGN_Name":"Engine Spark Maximum Voltage 2","PGN_Description":"ESVMAX2","first_bit":32,"SPN":6252,"SPN_Name":"Engine Spark Plug 7 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #7 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6253":{"PGN":64680,"PGN_Name":"Engine Spark Maximum Voltage 2","PGN_Description":"ESVMAX2","first_bit":48,"SPN":6253,"SPN_Name":"Engine Spark Plug 8 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #8 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6254":{"PGN":64679,"PGN_Name":"Engine Spark Maximum Voltage 3","PGN_Description":"ESVMAX3","first_bit":0,"SPN":6254,"SPN_Name":"Engine Spark Plug 9 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #9 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6255":{"PGN":64679,"PGN_Name":"Engine Spark Maximum Voltage 3","PGN_Description":"ESVMAX3","first_bit":16,"SPN":6255,"SPN_Name":"Engine Spark Plug 10 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #10 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6256":{"PGN":64679,"PGN_Name":"Engine Spark Maximum Voltage 3","PGN_Description":"ESVMAX3","first_bit":32,"SPN":6256,"SPN_Name":"Engine Spark Plug 11 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #11 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6257":{"PGN":64679,"PGN_Name":"Engine Spark Maximum Voltage 3","PGN_Description":"ESVMAX3","first_bit":48,"SPN":6257,"SPN_Name":"Engine Spark Plug 12 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #12 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6258":{"PGN":64678,"PGN_Name":"Engine Spark Maximum Voltage 4","PGN_Description":"ESVMAX4","first_bit":0,"SPN":6258,"SPN_Name":"Engine Spark Plug 13 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #13 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6259":{"PGN":64678,"PGN_Name":"Engine Spark Maximum Voltage 4","PGN_Description":"ESVMAX4","first_bit":16,"SPN":6259,"SPN_Name":"Engine Spark Plug 14 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #14 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6260":{"PGN":64678,"PGN_Name":"Engine Spark Maximum Voltage 4","PGN_Description":"ESVMAX4","first_bit":32,"SPN":6260,"SPN_Name":"Engine Spark Plug 15 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #15 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6261":{"PGN":64678,"PGN_Name":"Engine Spark Maximum Voltage 4","PGN_Description":"ESVMAX4","first_bit":48,"SPN":6261,"SPN_Name":"Engine Spark Plug 16 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #16 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6262":{"PGN":64677,"PGN_Name":"Engine Spark Maximum Voltage 5","PGN_Description":"ESVMAX5","first_bit":0,"SPN":6262,"SPN_Name":"Engine Spark Plug 17 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #17 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6263":{"PGN":64677,"PGN_Name":"Engine Spark Maximum Voltage 5","PGN_Description":"ESVMAX5","first_bit":16,"SPN":6263,"SPN_Name":"Engine Spark Plug 18 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #18 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6264":{"PGN":64677,"PGN_Name":"Engine Spark Maximum Voltage 5","PGN_Description":"ESVMAX5","first_bit":32,"SPN":6264,"SPN_Name":"Engine Spark Plug 19 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #19 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6265":{"PGN":64677,"PGN_Name":"Engine Spark Maximum Voltage 5","PGN_Description":"ESVMAX5","first_bit":48,"SPN":6265,"SPN_Name":"Engine Spark Plug 20 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #20 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6266":{"PGN":64676,"PGN_Name":"Engine Spark Maximum Voltage 6","PGN_Description":"ESVMAX6","first_bit":0,"SPN":6266,"SPN_Name":"Engine Spark Plug 21 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #21 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6267":{"PGN":64676,"PGN_Name":"Engine Spark Maximum Voltage 6","PGN_Description":"ESVMAX6","first_bit":16,"SPN":6267,"SPN_Name":"Engine Spark Plug 22 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #22 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6268":{"PGN":64676,"PGN_Name":"Engine Spark Maximum Voltage 6","PGN_Description":"ESVMAX6","first_bit":32,"SPN":6268,"SPN_Name":"Engine Spark Plug 23 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #23 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6269":{"PGN":64676,"PGN_Name":"Engine Spark Maximum Voltage 6","PGN_Description":"ESVMAX6","first_bit":48,"SPN":6269,"SPN_Name":"Engine Spark Plug 24 Maximum Voltage","SPN_Description":"The largest measured spark voltage of all measured spark events on Cylinder #24 since the last time this tracking data was reset.  It is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":16,"scaling":1,"offset":0,"unit":"V","SLOT_ID":145},"6270":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":0,"SPN":6270,"SPN_Name":"Engine Spark Plug 1 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #1. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #1 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6271":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":8,"SPN":6271,"SPN_Name":"Engine Spark Plug 2 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #2. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #2 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6272":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":16,"SPN":6272,"SPN_Name":"Engine Spark Plug 3 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #3. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #3 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6273":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":24,"SPN":6273,"SPN_Name":"Engine Spark Plug 4 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #4. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #4 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6274":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":32,"SPN":6274,"SPN_Name":"Engine Spark Plug 5 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #5. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #5 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6275":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":40,"SPN":6275,"SPN_Name":"Engine Spark Plug 6 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #6. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #6 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6276":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":48,"SPN":6276,"SPN_Name":"Engine Spark Plug 7 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #7. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #7 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6277":{"PGN":64675,"PGN_Name":"Engine Spark Misfire Rate 1","PGN_Description":"ESMR1","first_bit":56,"SPN":6277,"SPN_Name":"Engine Spark Plug 8 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #8. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #8 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6278":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":0,"SPN":6278,"SPN_Name":"Engine Spark Plug 9 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #9. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #9 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6279":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":8,"SPN":6279,"SPN_Name":"Engine Spark Plug 10 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #10. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #10 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6280":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":16,"SPN":6280,"SPN_Name":"Engine Spark Plug 11 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #11. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #11 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6281":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":24,"SPN":6281,"SPN_Name":"Engine Spark Plug 12 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #12. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #12 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6282":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":32,"SPN":6282,"SPN_Name":"Engine Spark Plug 13 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #13. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #13 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6283":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":40,"SPN":6283,"SPN_Name":"Engine Spark Plug 14 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #14. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #14 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6284":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":48,"SPN":6284,"SPN_Name":"Engine Spark Plug 15 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #15. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #15 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6285":{"PGN":64674,"PGN_Name":"Engine Spark Misfire Rate 2","PGN_Description":"ESMR2","first_bit":56,"SPN":6285,"SPN_Name":"Engine Spark Plug 16 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #16. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #16 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6286":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":0,"SPN":6286,"SPN_Name":"Engine Spark Plug 17 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #17. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #17 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6287":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":8,"SPN":6287,"SPN_Name":"Engine Spark Plug 18 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #18. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #18 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6288":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":16,"SPN":6288,"SPN_Name":"Engine Spark Plug 19 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #19. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #19 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6289":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":24,"SPN":6289,"SPN_Name":"Engine Spark Plug 20 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #20. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #20 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6290":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":32,"SPN":6290,"SPN_Name":"Engine Spark Plug 21 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #21. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #21 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6291":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":40,"SPN":6291,"SPN_Name":"Engine Spark Plug 22 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #22. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #22 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6292":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":48,"SPN":6292,"SPN_Name":"Engine Spark Plug 23 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #23. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #23 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6293":{"PGN":64673,"PGN_Name":"Engine Spark Misfire Rate 3","PGN_Description":"ESMR3","first_bit":56,"SPN":6293,"SPN_Name":"Engine Spark Plug 24 Misfire Rate","SPN_Description":"The spark misfire rate for Cylinder #24. The misfire rate is conveyed as the percentage of total cylinder spark misfires compared to the total number of ignition events on Cylinder #24 since the last time this tracking data was reset.  Any averaging associated with this rate is reset using Reset PGN 56832, Engine Spark Plug Secondary Voltage Tracking Reset SPN 6218.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6301":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":4,"SPN":6301,"SPN_Name":"Water in Fuel Indicator 2","SPN_Description":"A second indicator of the presense of water in the fuel.  See also SPN 97.\\r\\n\\r\\n00 - No\\r\\n01 - Yes\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6305":{"PGN":65198,"PGN_Name":"Air Supply Pressure","PGN_Description":"AIR1","first_bit":56,"SPN":6305,"SPN_Name":"Powertrain Circuit Air Supply Pressure","SPN_Description":"Supply pressure to carry the pressure information for the powertrain circuit. This circuit typically would feed powertrain components such as throttles, gearbox actuators and aftertreatment actuators for EGR and SCR systems.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"6306":{"PGN":64994,"PGN_Name":"Supply Pressure Demand","PGN_Description":"SPR","first_bit":48,"SPN":6306,"SPN_Name":"Powertrain Circuit Air Supply Pressure Request","SPN_Description":"Command signal to influence the air pressure in the powertrain circuit.  This parameter is the setpoint for the parameter SPN 6305.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"6307":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":8,"SPN":6307,"SPN_Name":"Source Address of Controlling Device for Fueling State","SPN_Description":"The J1939 source address of the device currently controlling the fueling state via SPN 5793.\\r\\n\\r\\n254 (0xFE) is used to indicate that the Source Address of Controlling Device for Fueling State parameter is supported, but no device is currently controlling the fueling state via SPN 5793.","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"6309":{"PGN":64699,"PGN_Name":"Aftertreatment 1 SCR Electronic Control Module Information","PGN_Description":"A1ECMI","first_bit":4,"SPN":6309,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Control Module 1 Power Supply 2","SPN_Description":"State signal which indicates when the DEF control module 1 power supply 2 of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module 1 power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the DEF dosing unit power supply\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6310":{"PGN":64698,"PGN_Name":"Aftertreatment 2 SCR Electronic Control Module Information","PGN_Description":"A2ECMI","first_bit":4,"SPN":6310,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Control Module 1 Power Supply 2","SPN_Description":"State signal which indicates when the DEF control module 1 power supply 2 of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module 1 power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the DEF dosing unit power supply\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6311":{"PGN":61495,"PGN_Name":"Engine Turbocharger Blowoff Actuator 1","PGN_Description":"ETBA1","first_bit":0,"SPN":6311,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Turbocharger Blowoff Actuator 1 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6312":{"PGN":61495,"PGN_Name":"Engine Turbocharger Blowoff Actuator 1","PGN_Description":"ETBA1","first_bit":5,"SPN":6312,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Temperature Status","SPN_Description":"Used to identify the status of the Engine Turbocharger Compresssor Blowoff Actuator 1 drive circuitry temperature. Temperature excursions may affect the torque output.\\r\\n\\r\\n000 - High Most severe\\r\\n001 - High Least severe\\r\\n010 - In Range\\r\\n011 - Low Least severe\\r\\n100 - Low Most severe\\r\\n101 - Not Defined\\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6313":{"PGN":61495,"PGN_Name":"Engine Turbocharger Blowoff Actuator 1","PGN_Description":"ETBA1","first_bit":8,"SPN":6313,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Temperature","SPN_Description":"Temperature of the Engine Turbocharger Compressor Bypass Actuator 1 drive circuitry. Temperature excursions may affect the torque output.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6314":{"PGN":61495,"PGN_Name":"Engine Turbocharger Blowoff Actuator 1","PGN_Description":"ETBA1","first_bit":16,"SPN":6314,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Desired Position","SPN_Description":"The requested position of the Engine Turbocharger Compressor Blowoff actuator by the engine ECU, where 0% represents bypass fully closed and 100% represents fully open.  This is the position that the device is attempting to achieve.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6315":{"PGN":61495,"PGN_Name":"Engine Turbocharger Blowoff Actuator 1","PGN_Description":"ETBA1","first_bit":24,"SPN":6315,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Position","SPN_Description":"Actual position of the turbocharger compressor blowoff actuator, where 0% represents fully closed and 100% represents fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6316":{"PGN":61495,"PGN_Name":"Engine Turbocharger Blowoff Actuator 1","PGN_Description":"ETBA1","first_bit":32,"SPN":6316,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Operation Status","SPN_Description":"Used to identify the status of Engine Turbocharger Compressor Blowoff Actuator 1.\\r\\n\\r\\n0000 - Normal\\r\\n0001 - Alarm (fully operational but needs service)\\r\\n0010 - Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 - Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 - Controlled Shutdown Active (driving to the default position - usually this means closed)\\r\\n0101 - Uncontrolled Shutdown Active (no torque is being applied from the actuator)\\r\\n0110 - Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 6201)\\r\\n0111 - 1101   Reserved for future assignment\\r\\n1110 - Error\\r\\n1111 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6317":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":8,"SPN":6317,"SPN_Name":"Requested Fuel Type","SPN_Description":"Engine controller receives this request from another control module to select the type of fuel to be used for engine operation.\\r\\n\\r\\n0x00 - Not available - NONE\\r\\n0x01 - Gasoline/petrol - GAS\\r\\n0x02 - Methanol - METH\\r\\n0x03 - Ethanol - ETH\\r\\n0x04 - Diesel - DSL\\r\\n0x05 - Liquefied Petroleum Gas (LPG) - LPG\\r\\n0x06 - Compressed Natural Gas (CNG) - CNG\\r\\n0x07 - Propane - PROP\\r\\n0x08 - 0x16 - Reserved for use in SPN 5837\\r\\n0x17 - Natural Gas (NG) - NG\\r\\n0x18 - Reserved for use in SPN 5837\\r\\n0x19 - 0xFD - SAE reserved\\r\\n0xFE - Reserved for use in SPN 5837\\r\\n0xFF - Not supported\\r\\n\\r\\nSee SPN 5837 for fuel type.","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"6319":{"PGN":64672,"PGN_Name":"Multi-fuel Engine Hours","PGN_Description":"MFEH","first_bit":0,"SPN":6319,"SPN_Name":"Engine Total Hours of Gaseous Fuel Operation","SPN_Description":"Accumulated time of operation of engine when gaseous fuel is used.  This parameter should be used only in multi-fuel engines.  See SPN 247 for single fuel engines and for total hours for multi-fuel engines.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"6320":{"PGN":64672,"PGN_Name":"Multi-fuel Engine Hours","PGN_Description":"MFEH","first_bit":32,"SPN":6320,"SPN_Name":"Engine Total Hours of Diesel Fuel Operation","SPN_Description":"Accumulated time of operation of engine when diesel fuel is used.  This parameter should be used only in multi-fuel engines.  See SPN 247 for single fuel engines and for total hours for multi-fuel engines.","bit_length":32,"scaling":0.05,"offset":0,"unit":"h","SLOT_ID":58},"6321":{"PGN":64671,"PGN_Name":"Dash Display 2","PGN_Description":"DD2","first_bit":0,"SPN":6321,"SPN_Name":"Engine Oil Filter Differential Pressure (Extended Range)","SPN_Description":"Change in engine oil differential pressure measured across the oil filter element. The differential pressure is the measured as the pressure at the filter intake with respect to the pressure at the filter outlet. This differential pressure measurement is used to assess the filter restriction as it accumulates solid or semisolid material on the filter element.\\r\\n\\r\\nThis SPN provides an extended range to the existing SPN 99 which can be used for an alternate range and scaling.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"kPa","SLOT_ID":52},"6330":{"PGN":61650,"PGN_Name":"Engine Electronic Controller 18","PGN_Description":"EEC18","first_bit":16,"SPN":6330,"SPN_Name":"Engine Intake Air Source Valve","SPN_Description":"Status of the actuator/valve in the airbox used to source engine intake air from either the engine compartment or external to the vehicle.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6333":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":24,"SPN":6333,"SPN_Name":"Engine Gas Substitution Fuel Percentage","SPN_Description":"Percentage of Gaseous fuel used. 0% means no Gaseous fuel used and 100% means completely gaseous fuel is used.\\r\\n\\r\\nGas substitution is the process for a dual fuel engine system of substituting gas, e.g. natural gas, for some fraction of the primary combustion fuel, e.g. diesel fuel, in the engine combustion.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6334":{"PGN":64670,"PGN_Name":"Engine Timing Actuator Position","PGN_Description":"ETAP","first_bit":8,"SPN":6334,"SPN_Name":"Engine Timing Actuator 1 Requested Position","SPN_Description":"The requested position of actuator 1 on the Engine Timing System, as determined by external system such as operator, monitoring, or protection system. Requested position is sent to the Control Module sending the command the Engine Timing System. Engine Timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\\r\\n\\r\\n000 - Position Not Requested\\r\\n001 - Diesel Mode Position\\r\\n010 - Diesel Part Load Position\\r\\n011 - Gas Mode Position\\r\\n100 - Diesel Part Load / Gas Mode Position\\r\\n101 - 110 - Reserved\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6335":{"PGN":64670,"PGN_Name":"Engine Timing Actuator Position","PGN_Description":"ETAP","first_bit":11,"SPN":6335,"SPN_Name":"Engine Timing Actuator 2 Requested Position","SPN_Description":"The requested position of actuator 2 on the Engine Timing System, as determined by external system such as operator, monitoring or protection system. Requested position is sent to the Control Module sending the command the Engine Timing System. Engine Timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\\r\\n\\r\\n000 - Position Not Requested\\r\\n001 - Diesel Mode Position\\r\\n010 - Diesel Part Load Position\\r\\n011 - Gas Mode Position\\r\\n100 - Diesel Part Load / Gas Mode Position\\r\\n101 - 110 - Reserved\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6336":{"PGN":64669,"PGN_Name":"Engine Timing Actuator Position Command","PGN_Description":"ETAPC","first_bit":0,"SPN":6336,"SPN_Name":"Engine Timing Actuator 1 Position Command","SPN_Description":"The commanded position of actuator 1 on the engine timing system by Engine Control Module.  The engine timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\\r\\n\\r\\n000 - Reserved\\r\\n001 - Diesel Mode Position\\r\\n010 - Diesel Part Load Position\\r\\n011 - Gas Mode Position\\r\\n100 - Diesel Part Load / Gas Mode Position\\r\\n101 - 110 - Reserved\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6337":{"PGN":64669,"PGN_Name":"Engine Timing Actuator Position Command","PGN_Description":"ETAPC","first_bit":3,"SPN":6337,"SPN_Name":"Engine Timing Actuator 2 Position Command","SPN_Description":"The commanded position of actuator 2 on the engine timing system by Engine Control Module.  The engine timing system has different timing positions and the timing positions may be used to determine intake and outlet valve timings.\\r\\n\\r\\n000 - Reserved\\r\\n001 - Diesel Mode Position\\r\\n010 - Diesel Part Load Position\\r\\n011 - Gas Mode Position\\r\\n100 - Diesel Part Load / Gas Mode Position\\r\\n101 - 110 - Reserved\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6338":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":0,"SPN":6338,"SPN_Name":"Joystick 1 Lamp 1 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 1\\r\\n\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6339":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":2,"SPN":6339,"SPN_Name":"Joystick 1 Lamp 2 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 2\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6340":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":4,"SPN":6340,"SPN_Name":"Joystick 1 Lamp 3 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 3\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6341":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":6,"SPN":6341,"SPN_Name":"Joystick 1 Lamp 4 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 4\\r\\n\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6342":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":8,"SPN":6342,"SPN_Name":"Joystick 1 Lamp 5 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 5\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6343":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":10,"SPN":6343,"SPN_Name":"Joystick 1 Lamp 6 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 6\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6344":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":12,"SPN":6344,"SPN_Name":"Joystick 1 Lamp 7 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 7\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6345":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":14,"SPN":6345,"SPN_Name":"Joystick 1 Lamp 8 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 8\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6346":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":16,"SPN":6346,"SPN_Name":"Joystick 1 Lamp 9 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 9\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6347":{"PGN":64668,"PGN_Name":"Joystick 1 Lamp Status","PGN_Description":"JS1LS","first_bit":18,"SPN":6347,"SPN_Name":"Joystick 1 Lamp 10 Status","SPN_Description":"Report the actual value of Joystick 1 Lamp 10\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6348":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":0,"SPN":6348,"SPN_Name":"Joystick 2 Lamp 1 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 1\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6349":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":2,"SPN":6349,"SPN_Name":"Joystick 2 Lamp 2 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 2\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6350":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":4,"SPN":6350,"SPN_Name":"Joystick 2 Lamp 3 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 3\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6351":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":6,"SPN":6351,"SPN_Name":"Joystick 2 Lamp 4 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 4\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6352":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":8,"SPN":6352,"SPN_Name":"Joystick 2 Lamp 5 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 5\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6353":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":10,"SPN":6353,"SPN_Name":"Joystick 2 Lamp 6 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 6\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6354":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":12,"SPN":6354,"SPN_Name":"Joystick 2 Lamp 7 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 7\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6355":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":14,"SPN":6355,"SPN_Name":"Joystick 2 Lamp 8 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 8\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6356":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":16,"SPN":6356,"SPN_Name":"Joystick 2 Lamp 9 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 9\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6357":{"PGN":64667,"PGN_Name":"Joystick 2 Lamp Status","PGN_Description":"JS2LS","first_bit":18,"SPN":6357,"SPN_Name":"Joystick 2 Lamp 10 Status","SPN_Description":"Report the actual value of Joystick 2 Lamp 10\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6358":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":0,"SPN":6358,"SPN_Name":"Joystick 3 Lamp 1 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 1\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6359":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":2,"SPN":6359,"SPN_Name":"Joystick 3 Lamp 2 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 2\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6360":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":4,"SPN":6360,"SPN_Name":"Joystick 3 Lamp 3 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 3\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6361":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":6,"SPN":6361,"SPN_Name":"Joystick 3 Lamp 4 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 4\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6362":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":8,"SPN":6362,"SPN_Name":"Joystick 3 Lamp 5 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 5\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6363":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":10,"SPN":6363,"SPN_Name":"Joystick 3 Lamp 6 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 6\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6364":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":12,"SPN":6364,"SPN_Name":"Joystick 3 Lamp 7 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 7\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6365":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":14,"SPN":6365,"SPN_Name":"Joystick 3 Lamp 8 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 8\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6366":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":16,"SPN":6366,"SPN_Name":"Joystick 3 Lamp 9 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 9\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6367":{"PGN":64666,"PGN_Name":"Joystick 3 Lamp Status","PGN_Description":"JS3LS","first_bit":18,"SPN":6367,"SPN_Name":"Joystick 3 Lamp 10 Status","SPN_Description":"Report the actual value of Joystick 3 Lamp 10\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Flashing\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6368":{"PGN":64665,"PGN_Name":"Assembly Unit Identification","PGN_Description":"AUI","first_bit":0,"SPN":6368,"SPN_Name":"Number of Assembly Unit Identification Fields","SPN_Description":"Number of Assembly Unit Identification designators represented in the Assembly Unit Identification parameter group.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"6370":{"PGN":64664,"PGN_Name":"Vehicle Speed Limiter","PGN_Description":"VSL","first_bit":0,"SPN":6370,"SPN_Name":"Soft Top Speed Limit Active","SPN_Description":"Indicates that the current Maximum Vehicle Speed Limit (SPN 74) has been temporarily increased to the Soft Top Speed Limit. Under certain conditions, the legal speed limit allowed by the Greenhouse Gas Regulations can be increased to a speed referred to as the \u201CSoft Top Speed Limit\u201D for a specified distance.\\r\\n\\r\\nSee SPNs 6372, 6373, & 6914 for an explanation of the relevant distance parameters.\\r\\n\\r\\n00 \u2013 Soft Top Speed Limit is Inactive\\r\\n01 \u2013 Soft Top Speed Limit is Active\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6371":{"PGN":64664,"PGN_Name":"Vehicle Speed Limiter","PGN_Description":"VSL","first_bit":2,"SPN":6371,"SPN_Name":"Soft Top Ratio Limit Exceeded","SPN_Description":"Greenhouse Gas Regulations limit the overall distance that Soft Top Speed can be used in relation to the total distance traveled. This parameter indicates the allowable ratio has been exceeded and Soft Top Speed is unavailable. It will become available again when enough distance has been traveled without using Soft Top Speed to bring the ratio back under the limit.\\r\\n\\r\\n00 \u2013 Soft top ratio limit has not been exceeded\\r\\n01 \u2013 Soft top ratio limit has been exceeded\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6372":{"PGN":64664,"PGN_Name":"Vehicle Speed Limiter","PGN_Description":"VSL","first_bit":8,"SPN":6372,"SPN_Name":"Soft Top Speed Limit Remaining Distance","SPN_Description":"Indicates the remaining distance that the vehicle can travel at the Soft Top Speed Limit within the larger reset window. The reset window may be distance (possibly indicated by SPN 6373), time, or something else as determined by the manufacturer.\\r\\n\\r\\nThis parameter will decrement while the Soft Top Speed Limit Active (SPN 6370) is 1. When the Soft Top Speed Limit Remaining Distance parameter reaches 0, the Soft Top Speed Limit cannot be activated.","bit_length":16,"scaling":1,"offset":0,"unit":"km","SLOT_ID":270},"6373":{"PGN":64664,"PGN_Name":"Vehicle Speed Limiter","PGN_Description":"VSL","first_bit":24,"SPN":6373,"SPN_Name":"Soft Top Speed Limit Reset Distance","SPN_Description":"This parameter will decrement as long as the vehicle is moving. When this parameter reaches 0, it will be reset to its maximum value and continue to decrement.","bit_length":16,"scaling":1,"offset":0,"unit":"km","SLOT_ID":270},"6374":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":16,"SPN":6374,"SPN_Name":"Steering Controller ECU Temperature","SPN_Description":"Temperature of the steering controller ECU","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"6375":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":0,"SPN":6375,"SPN_Name":"Steering Mode Switch","SPN_Description":"Switch used as an input to the electronic steering controller to determine the operator\'s requested steering mode\\r\\n\\r\\n000 - 2 Wheel Steer Mode\\r\\n001 - Circle Steer Mode\\r\\n011 - Crab Steer Mode\\r\\n100-101 - Reserved for future use\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6376":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":4,"SPN":6376,"SPN_Name":"Front Steering Axle Centered Status","SPN_Description":"The status of the front steering axle being centered. The axle is centered if the axle\'s centerline is parallel to the vehicle\'s X-axis, where the vehicle\'s X-axis is as defined in SAE J670\\r\\n\\r\\n00 - Front Axle Centered\\r\\n01 - Front Axle Not Centered\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6377":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":6,"SPN":6377,"SPN_Name":"Rear Steering Axle Centered Status","SPN_Description":"The status of the rear steering axle being centered. The axle is centered if the axle\'s centerline is parallel to the vehicle\'s X-axis, where the vehicle\'s X-axis is as defined in SAE J670\\r\\n\\r\\n00 - Rear Axle Centered\\r\\n01 - Rear Axle Not Centered\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6378":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":8,"SPN":6378,"SPN_Name":"2 Wheel Steer Actuator State","SPN_Description":"The current state of the actuator that control the 2 wheel steering mode\\r\\n\\r\\n00 - 2 Wheel Steer actuator inactive\\r\\n01 - 2 Wheel Steer actuator active\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6379":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":10,"SPN":6379,"SPN_Name":"4 Wheel Steer Actuator State","SPN_Description":"Signal which indicates the current state of the actuator that control the 4 wheel steering mode\\r\\n\\r\\n00 - 4 Wheel Steer actuator inactive\\r\\n01 - 4 Wheel Steer actuator active\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6380":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":12,"SPN":6380,"SPN_Name":"Circle Steer Mode Actuator State","SPN_Description":"Signal which indicates the current state of the actuator that control the circle steering mode\\r\\n\\r\\n00 - Circle Steer Mode actuator inactive\\r\\n01 - Circle Steer Mode actuator active\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6381":{"PGN":64663,"PGN_Name":"Electronic Steering Control 2","PGN_Description":"ESC2","first_bit":14,"SPN":6381,"SPN_Name":"Crab Steer Mode Actuator State","SPN_Description":"Signal which indicates the current state of the actuator that control the crab steering mode\\r\\n\\r\\n00 - Crab Steer Mode actuator inactive\\r\\n01 - Crab Steer Mode actuator active\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6384":{"PGN":64662,"PGN_Name":"Engine Information 2","PGN_Description":"EI2","first_bit":0,"SPN":6384,"SPN_Name":"Engine Exhaust Pressure 1 (Extended Range)","SPN_Description":"Gage pressure of the exhaust gasses as measured at the turbine intake of the turbocharger. This SPN to be used for inline engines or exhaust bank 1 of multiple bank engines.  \\r\\n\\r\\nSee SPN 1209 for alternate resolution.","bit_length":16,"scaling":0.125,"offset":0,"unit":"kPa","SLOT_ID":138},"6385":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":6,"SPN":6385,"SPN_Name":"Engine Starter Motor Relay Control","SPN_Description":"Command signal used to energize or de-energize the engine starter motor relay.\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Reserved for SAE assignment\\r\\n11 Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6386":{"PGN":61496,"PGN_Name":"Engine Torque / Fuel Request","PGN_Description":"ETFR","first_bit":0,"SPN":6386,"SPN_Name":"Engine Gas Substitution Fuel Percentage Command","SPN_Description":"Percentage of Gaseous fuel used, in terms of % mass of fuel. 0% means no Gaseous fuel used and 100 % means completely gaseous fuel is used.\\r\\n\\r\\nGas substitution is the process for a dual fuel engine system of substituting gas, e.g. natural gas, for some fraction of the primary combustion fuel, e.g. diesel fuel, in the engine combustion.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6387":{"PGN":61496,"PGN_Name":"Engine Torque / Fuel Request","PGN_Description":"ETFR","first_bit":8,"SPN":6387,"SPN_Name":"Engine Cylinder Gas Mass Flow Rate Command","SPN_Description":"Commanded Mass Flow rate of gaseous fuel delivered to the engine normalized per cylinder.","bit_length":16,"scaling":0.00006103515625,"offset":0,"unit":"kg/s","SLOT_ID":369},"6388":{"PGN":61496,"PGN_Name":"Engine Torque / Fuel Request","PGN_Description":"ETFR","first_bit":24,"SPN":6388,"SPN_Name":"Engine Cylinder Diesel Mass Flow Rate Command","SPN_Description":"Commanded Mass Flow rate of diesel fuel delivered to the engine normalized per cylinder.","bit_length":16,"scaling":0.00006103515625,"offset":0,"unit":"kg/s","SLOT_ID":369},"6389":{"PGN":61496,"PGN_Name":"Engine Torque / Fuel Request","PGN_Description":"ETFR","first_bit":40,"SPN":6389,"SPN_Name":"Engine Cylinder Torque","SPN_Description":"Calculated engine torque output per cylinder.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"6390":{"PGN":64661,"PGN_Name":"Engine Cylinder Pressure Monitor Status Information","PGN_Description":"ECPMSI","first_bit":0,"SPN":6390,"SPN_Name":"Engine Cylinder Pressure Monitor 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Cylinder Pressure Monitor 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6391":{"PGN":64661,"PGN_Name":"Engine Cylinder Pressure Monitor Status Information","PGN_Description":"ECPMSI","first_bit":8,"SPN":6391,"SPN_Name":"Engine Cylinder Pressure Monitor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the Engine Cylinder Pressure Monitor 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6392":{"PGN":61497,"PGN_Name":"Engine Air System Information","PGN_Description":"EASI","first_bit":0,"SPN":6392,"SPN_Name":"Engine Desired Air Fuel Ratio","SPN_Description":"Reports the desired Air Fuel ratio for the engine.\\r\\n\\r\\nAir Fuel Ratio specifies the amount of air required to completely burn one unit of fuel in the engine to meet the required engine performance and emission standards.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"6393":{"PGN":61497,"PGN_Name":"Engine Air System Information","PGN_Description":"EASI","first_bit":16,"SPN":6393,"SPN_Name":"Engine Fuel System 1 Total Intake Mass Air Flow Rate","SPN_Description":"Mass Flow rate of air entering the engine (or the first fuel system on a configuration with more than 1 fuel system). This also includes the amount of exhaust gas recirculated, if any.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"kg/s","SLOT_ID":372},"6394":{"PGN":64895,"PGN_Name":"Engine Configuration 2","PGN_Description":"EC2","first_bit":8,"SPN":6394,"SPN_Name":"Number of Combustion Cycles for Averaging","SPN_Description":"Defined number of combustion cycles used for calculating average parameters of combustion in each cylinder.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"6395":{"PGN":64895,"PGN_Name":"Engine Configuration 2","PGN_Description":"EC2","first_bit":16,"SPN":6395,"SPN_Name":"Engine Configuration Identification","SPN_Description":"Used to identify the hardware configuration of engine family. Each number will have a reference to set of parameters such as, but not limited to, number of cylinders, piston displacement, bore size and firing angles.","bit_length":16,"scaling":1,"offset":0,"unit":"ID","SLOT_ID":373},"6396":{"PGN":61498,"PGN_Name":"Engine Cylinder 1 Combustion Information","PGN_Description":"ECCI1","first_bit":0,"SPN":6396,"SPN_Name":"Engine Cylinder 1 Heat Release","SPN_Description":"The amount of heat produced during combustion in Engine cylinder 1. The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6397":{"PGN":61498,"PGN_Name":"Engine Cylinder 1 Combustion Information","PGN_Description":"ECCI1","first_bit":16,"SPN":6397,"SPN_Name":"Engine Cylinder 1 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 1 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6398":{"PGN":61498,"PGN_Name":"Engine Cylinder 1 Combustion Information","PGN_Description":"ECCI1","first_bit":32,"SPN":6398,"SPN_Name":"Engine Cylinder 1 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 1. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1352.  SPN 6398 is combined with other combustion information in PGN 61498, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6399":{"PGN":61498,"PGN_Name":"Engine Cylinder 1 Combustion Information","PGN_Description":"ECCI1","first_bit":40,"SPN":6399,"SPN_Name":"Engine Cylinder 1 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 1 pressure sensor. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6400":{"PGN":61499,"PGN_Name":"Engine Cylinder 2 Combustion Information","PGN_Description":"ECCI2","first_bit":0,"SPN":6400,"SPN_Name":"Engine Cylinder 2 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 2.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6401":{"PGN":61499,"PGN_Name":"Engine Cylinder 2 Combustion Information","PGN_Description":"ECCI2","first_bit":16,"SPN":6401,"SPN_Name":"Engine Cylinder 2 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 2 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6402":{"PGN":61499,"PGN_Name":"Engine Cylinder 2 Combustion Information","PGN_Description":"ECCI2","first_bit":32,"SPN":6402,"SPN_Name":"Engine Cylinder 2 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 2. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1353.  SPN 6402 is combined with other combustion information in PGN 61499, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6403":{"PGN":61499,"PGN_Name":"Engine Cylinder 2 Combustion Information","PGN_Description":"ECCI2","first_bit":40,"SPN":6403,"SPN_Name":"Engine Cylinder 2 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 2 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6404":{"PGN":61500,"PGN_Name":"Engine Cylinder 3 Combustion Information","PGN_Description":"ECCI3","first_bit":0,"SPN":6404,"SPN_Name":"Engine Cylinder 3 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 3.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6405":{"PGN":61500,"PGN_Name":"Engine Cylinder 3 Combustion Information","PGN_Description":"ECCI3","first_bit":16,"SPN":6405,"SPN_Name":"Engine Cylinder 3 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 3 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6406":{"PGN":61500,"PGN_Name":"Engine Cylinder 3 Combustion Information","PGN_Description":"ECCI3","first_bit":32,"SPN":6406,"SPN_Name":"Engine Cylinder 3 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 3. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1354.  SPN 6406 is combined with other combustion information in PGN 61500, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6407":{"PGN":61500,"PGN_Name":"Engine Cylinder 3 Combustion Information","PGN_Description":"ECCI3","first_bit":40,"SPN":6407,"SPN_Name":"Engine Cylinder 3 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 3 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6408":{"PGN":61501,"PGN_Name":"Engine Cylinder 4 Combustion Information","PGN_Description":"ECCI4","first_bit":0,"SPN":6408,"SPN_Name":"Engine Cylinder 4 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 4.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6409":{"PGN":61501,"PGN_Name":"Engine Cylinder 4 Combustion Information","PGN_Description":"ECCI4","first_bit":16,"SPN":6409,"SPN_Name":"Engine Cylinder 4 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 4 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6410":{"PGN":61501,"PGN_Name":"Engine Cylinder 4 Combustion Information","PGN_Description":"ECCI4","first_bit":32,"SPN":6410,"SPN_Name":"Engine Cylinder 4 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 4. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1355.  SPN 6410 is combined with other combustion information in PGN 61501, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6411":{"PGN":61501,"PGN_Name":"Engine Cylinder 4 Combustion Information","PGN_Description":"ECCI4","first_bit":40,"SPN":6411,"SPN_Name":"Engine Cylinder 4 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 4 pressure sensor. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6412":{"PGN":61502,"PGN_Name":"Engine Cylinder 5 Combustion Information","PGN_Description":"ECCI5","first_bit":0,"SPN":6412,"SPN_Name":"Engine Cylinder 5 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 5.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6413":{"PGN":61502,"PGN_Name":"Engine Cylinder 5 Combustion Information","PGN_Description":"ECCI5","first_bit":16,"SPN":6413,"SPN_Name":"Engine Cylinder 5 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 5 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6414":{"PGN":61502,"PGN_Name":"Engine Cylinder 5 Combustion Information","PGN_Description":"ECCI5","first_bit":32,"SPN":6414,"SPN_Name":"Engine Cylinder 5 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 6. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1356.  SPN 6414 is combined with other combustion information in PGN 61502, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6415":{"PGN":61502,"PGN_Name":"Engine Cylinder 5 Combustion Information","PGN_Description":"ECCI5","first_bit":40,"SPN":6415,"SPN_Name":"Engine Cylinder 5 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 5 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6416":{"PGN":61503,"PGN_Name":"Engine Cylinder 6 Combustion Information","PGN_Description":"ECCI6","first_bit":0,"SPN":6416,"SPN_Name":"Engine Cylinder 6 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 6.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6417":{"PGN":61503,"PGN_Name":"Engine Cylinder 6 Combustion Information","PGN_Description":"ECCI6","first_bit":16,"SPN":6417,"SPN_Name":"Engine Cylinder 6 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 6 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6418":{"PGN":61503,"PGN_Name":"Engine Cylinder 6 Combustion Information","PGN_Description":"ECCI6","first_bit":32,"SPN":6418,"SPN_Name":"Engine Cylinder 6 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 6. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1357.  SPN 6418 is combined with other combustion information in PGN 61503, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6419":{"PGN":61503,"PGN_Name":"Engine Cylinder 6 Combustion Information","PGN_Description":"ECCI6","first_bit":40,"SPN":6419,"SPN_Name":"Engine Cylinder 6 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 6 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6420":{"PGN":61504,"PGN_Name":"Engine Cylinder 7 Combustion Information","PGN_Description":"ECCI7","first_bit":0,"SPN":6420,"SPN_Name":"Engine Cylinder 7 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 7.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6421":{"PGN":61504,"PGN_Name":"Engine Cylinder 7 Combustion Information","PGN_Description":"ECCI7","first_bit":16,"SPN":6421,"SPN_Name":"Engine Cylinder 7 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 7 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6422":{"PGN":61504,"PGN_Name":"Engine Cylinder 7 Combustion Information","PGN_Description":"ECCI7","first_bit":32,"SPN":6422,"SPN_Name":"Engine Cylinder 7 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 7. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1358.  SPN 6422 is combined with other combustion information in PGN 61504, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6423":{"PGN":61504,"PGN_Name":"Engine Cylinder 7 Combustion Information","PGN_Description":"ECCI7","first_bit":40,"SPN":6423,"SPN_Name":"Engine Cylinder 7 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 7 pressure sensor. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6424":{"PGN":61505,"PGN_Name":"Engine Cylinder 8 Combustion Information","PGN_Description":"ECCI8","first_bit":0,"SPN":6424,"SPN_Name":"Engine Cylinder 8 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 8.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6425":{"PGN":61505,"PGN_Name":"Engine Cylinder 8 Combustion Information","PGN_Description":"ECCI8","first_bit":16,"SPN":6425,"SPN_Name":"Engine Cylinder 8 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 8 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6426":{"PGN":61505,"PGN_Name":"Engine Cylinder 8 Combustion Information","PGN_Description":"ECCI8","first_bit":32,"SPN":6426,"SPN_Name":"Engine Cylinder 8 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 8. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1359.  SPN 6426 is combined with other combustion information in PGN 61505, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6427":{"PGN":61505,"PGN_Name":"Engine Cylinder 8 Combustion Information","PGN_Description":"ECCI8","first_bit":40,"SPN":6427,"SPN_Name":"Engine Cylinder 8 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 8 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6428":{"PGN":61506,"PGN_Name":"Engine Cylinder 9 Combustion Information","PGN_Description":"ECCI9","first_bit":0,"SPN":6428,"SPN_Name":"Engine Cylinder 9 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 9.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6429":{"PGN":61506,"PGN_Name":"Engine Cylinder 9 Combustion Information","PGN_Description":"ECCI9","first_bit":16,"SPN":6429,"SPN_Name":"Engine Cylinder 9 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 9 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6430":{"PGN":61506,"PGN_Name":"Engine Cylinder 9 Combustion Information","PGN_Description":"ECCI9","first_bit":32,"SPN":6430,"SPN_Name":"Engine Cylinder 9 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 9. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1360.  SPN 6430 is combined with other combustion information in PGN 61506, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6431":{"PGN":61506,"PGN_Name":"Engine Cylinder 9 Combustion Information","PGN_Description":"ECCI9","first_bit":40,"SPN":6431,"SPN_Name":"Engine Cylinder 9 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 9 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6432":{"PGN":61507,"PGN_Name":"Engine Cylinder 10 Combustion Information","PGN_Description":"ECCI10","first_bit":0,"SPN":6432,"SPN_Name":"Engine Cylinder 10 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 10.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6433":{"PGN":61507,"PGN_Name":"Engine Cylinder 10 Combustion Information","PGN_Description":"ECCI10","first_bit":16,"SPN":6433,"SPN_Name":"Engine Cylinder 10 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 10 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6434":{"PGN":61507,"PGN_Name":"Engine Cylinder 10 Combustion Information","PGN_Description":"ECCI10","first_bit":32,"SPN":6434,"SPN_Name":"Engine Cylinder 10 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 10. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1361.  SPN 6434 is combined with other combustion information in PGN 61507, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6435":{"PGN":61507,"PGN_Name":"Engine Cylinder 10 Combustion Information","PGN_Description":"ECCI10","first_bit":40,"SPN":6435,"SPN_Name":"Engine Cylinder 10 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 10 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6436":{"PGN":61508,"PGN_Name":"Engine Cylinder 11 Combustion Information","PGN_Description":"ECCI11","first_bit":0,"SPN":6436,"SPN_Name":"Engine Cylinder 11 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 11.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6437":{"PGN":61508,"PGN_Name":"Engine Cylinder 11 Combustion Information","PGN_Description":"ECCI11","first_bit":16,"SPN":6437,"SPN_Name":"Engine Cylinder 11 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 11 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6438":{"PGN":61508,"PGN_Name":"Engine Cylinder 11 Combustion Information","PGN_Description":"ECCI11","first_bit":32,"SPN":6438,"SPN_Name":"Engine Cylinder 11 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 11. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1362.  SPN 6438 is combined with other combustion information in PGN 61508, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6439":{"PGN":61508,"PGN_Name":"Engine Cylinder 11 Combustion Information","PGN_Description":"ECCI11","first_bit":40,"SPN":6439,"SPN_Name":"Engine Cylinder 11 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 11 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6440":{"PGN":61509,"PGN_Name":"Engine Cylinder 12 Combustion Information","PGN_Description":"ECCI12","first_bit":0,"SPN":6440,"SPN_Name":"Engine Cylinder 12 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 12.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6441":{"PGN":61509,"PGN_Name":"Engine Cylinder 12 Combustion Information","PGN_Description":"ECCI12","first_bit":16,"SPN":6441,"SPN_Name":"Engine Cylinder 12 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 12 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6442":{"PGN":61509,"PGN_Name":"Engine Cylinder 12 Combustion Information","PGN_Description":"ECCI12","first_bit":32,"SPN":6442,"SPN_Name":"Engine Cylinder 12 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 12. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1363.  SPN 6442 is combined with other combustion information in PGN 61509, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6443":{"PGN":61509,"PGN_Name":"Engine Cylinder 12 Combustion Information","PGN_Description":"ECCI12","first_bit":40,"SPN":6443,"SPN_Name":"Engine Cylinder 12 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 12 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6444":{"PGN":61510,"PGN_Name":"Engine Cylinder 13 Combustion Information","PGN_Description":"ECCI13","first_bit":0,"SPN":6444,"SPN_Name":"Engine Cylinder 13 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 13.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6445":{"PGN":61510,"PGN_Name":"Engine Cylinder 13 Combustion Information","PGN_Description":"ECCI13","first_bit":16,"SPN":6445,"SPN_Name":"Engine Cylinder 13 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 13 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6446":{"PGN":61510,"PGN_Name":"Engine Cylinder 13 Combustion Information","PGN_Description":"ECCI13","first_bit":32,"SPN":6446,"SPN_Name":"Engine Cylinder 13 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 13. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1364.  SPN 6446 is combined with other combustion information in PGN 61510, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6447":{"PGN":61510,"PGN_Name":"Engine Cylinder 13 Combustion Information","PGN_Description":"ECCI13","first_bit":40,"SPN":6447,"SPN_Name":"Engine Cylinder 13 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 13 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6448":{"PGN":61511,"PGN_Name":"Engine Cylinder 14 Combustion Information","PGN_Description":"ECCI14","first_bit":0,"SPN":6448,"SPN_Name":"Engine Cylinder 14 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 14.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6449":{"PGN":61511,"PGN_Name":"Engine Cylinder 14 Combustion Information","PGN_Description":"ECCI14","first_bit":16,"SPN":6449,"SPN_Name":"Engine Cylinder 14 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 14 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6450":{"PGN":61511,"PGN_Name":"Engine Cylinder 14 Combustion Information","PGN_Description":"ECCI14","first_bit":32,"SPN":6450,"SPN_Name":"Engine Cylinder 14 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 14. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1365.  SPN 6450 is combined with other combustion information in PGN 61511, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6451":{"PGN":61511,"PGN_Name":"Engine Cylinder 14 Combustion Information","PGN_Description":"ECCI14","first_bit":40,"SPN":6451,"SPN_Name":"Engine Cylinder 14 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 14 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6452":{"PGN":61512,"PGN_Name":"Engine Cylinder 15 Combustion Information","PGN_Description":"ECCI15","first_bit":0,"SPN":6452,"SPN_Name":"Engine Cylinder 15 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 15.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6453":{"PGN":61512,"PGN_Name":"Engine Cylinder 15 Combustion Information","PGN_Description":"ECCI15","first_bit":16,"SPN":6453,"SPN_Name":"Engine Cylinder 15 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 15 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6454":{"PGN":61512,"PGN_Name":"Engine Cylinder 15 Combustion Information","PGN_Description":"ECCI15","first_bit":32,"SPN":6454,"SPN_Name":"Engine Cylinder 15 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 15. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1366.  SPN 6454 is combined with other combustion information in PGN 61512, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6455":{"PGN":61512,"PGN_Name":"Engine Cylinder 15 Combustion Information","PGN_Description":"ECCI15","first_bit":40,"SPN":6455,"SPN_Name":"Engine Cylinder 15 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 15 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6456":{"PGN":61513,"PGN_Name":"Engine Cylinder 16 Combustion Information","PGN_Description":"ECCI16","first_bit":0,"SPN":6456,"SPN_Name":"Engine Cylinder 16 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 16.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6457":{"PGN":61513,"PGN_Name":"Engine Cylinder 16 Combustion Information","PGN_Description":"ECCI16","first_bit":16,"SPN":6457,"SPN_Name":"Engine Cylinder 16 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 16 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6458":{"PGN":61513,"PGN_Name":"Engine Cylinder 16 Combustion Information","PGN_Description":"ECCI16","first_bit":32,"SPN":6458,"SPN_Name":"Engine Cylinder 16 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 16. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1367.  SPN 6458 is combined with other combustion information in PGN 61513, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6459":{"PGN":61513,"PGN_Name":"Engine Cylinder 16 Combustion Information","PGN_Description":"ECCI16","first_bit":40,"SPN":6459,"SPN_Name":"Engine Cylinder 16 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 16 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6460":{"PGN":61514,"PGN_Name":"Engine Cylinder 17 Combustion Information","PGN_Description":"ECCI17","first_bit":0,"SPN":6460,"SPN_Name":"Engine Cylinder 17 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 17.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6461":{"PGN":61514,"PGN_Name":"Engine Cylinder 17 Combustion Information","PGN_Description":"ECCI17","first_bit":16,"SPN":6461,"SPN_Name":"Engine Cylinder 17 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 17 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6462":{"PGN":61514,"PGN_Name":"Engine Cylinder 17 Combustion Information","PGN_Description":"ECCI17","first_bit":32,"SPN":6462,"SPN_Name":"Engine Cylinder 17 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 17. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1368.  SPN 6462 is combined with other combustion information in PGN 61514, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6463":{"PGN":61514,"PGN_Name":"Engine Cylinder 17 Combustion Information","PGN_Description":"ECCI17","first_bit":40,"SPN":6463,"SPN_Name":"Engine Cylinder 17 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 17 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6464":{"PGN":61515,"PGN_Name":"Engine Cylinder 18 Combustion Information","PGN_Description":"ECCI18","first_bit":0,"SPN":6464,"SPN_Name":"Engine Cylinder 18 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 18.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6465":{"PGN":61515,"PGN_Name":"Engine Cylinder 18 Combustion Information","PGN_Description":"ECCI18","first_bit":16,"SPN":6465,"SPN_Name":"Engine Cylinder 18 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 18 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6466":{"PGN":61515,"PGN_Name":"Engine Cylinder 18 Combustion Information","PGN_Description":"ECCI18","first_bit":32,"SPN":6466,"SPN_Name":"Engine Cylinder 18 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 18. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1369.  SPN 6466 is combined with other combustion information in PGN 61515, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6467":{"PGN":61515,"PGN_Name":"Engine Cylinder 18 Combustion Information","PGN_Description":"ECCI18","first_bit":40,"SPN":6467,"SPN_Name":"Engine Cylinder 18 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 18 pressure sensor. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6468":{"PGN":61516,"PGN_Name":"Engine Cylinder 19 Combustion Information","PGN_Description":"ECCI19","first_bit":0,"SPN":6468,"SPN_Name":"Engine Cylinder 19 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 19.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6469":{"PGN":61516,"PGN_Name":"Engine Cylinder 19 Combustion Information","PGN_Description":"ECCI19","first_bit":16,"SPN":6469,"SPN_Name":"Engine Cylinder 19 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 19 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6470":{"PGN":61516,"PGN_Name":"Engine Cylinder 19 Combustion Information","PGN_Description":"ECCI19","first_bit":32,"SPN":6470,"SPN_Name":"Engine Cylinder 19 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 19. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1370.  SPN 6470 is combined with other combustion information in PGN 61516, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6471":{"PGN":61516,"PGN_Name":"Engine Cylinder 19 Combustion Information","PGN_Description":"ECCI19","first_bit":40,"SPN":6471,"SPN_Name":"Engine Cylinder 19 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 19 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6472":{"PGN":61517,"PGN_Name":"Engine Cylinder 20 Combustion Information","PGN_Description":"ECCI20","first_bit":0,"SPN":6472,"SPN_Name":"Engine Cylinder 20 Heat Release","SPN_Description":"The amount of heat produced during combustion in engine cylinder 20.  The negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"kJ/l","SLOT_ID":366},"6473":{"PGN":61517,"PGN_Name":"Engine Cylinder 20 Combustion Information","PGN_Description":"ECCI20","first_bit":16,"SPN":6473,"SPN_Name":"Engine Cylinder 20 Peak Pressure","SPN_Description":"Peak pressure in engine cylinder 20 in combustion cycle.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"MPa","SLOT_ID":367},"6474":{"PGN":61517,"PGN_Name":"Engine Cylinder 20 Combustion Information","PGN_Description":"ECCI20","first_bit":32,"SPN":6474,"SPN_Name":"Engine Cylinder 20 Synchronous Knock Level","SPN_Description":"Used to indicate the level of knock for engine cylinder 20. The level of knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more knock until 100% indicates the most severe level of knock allowed or measurable for the engine.\\r\\n\\r\\nSimilar to SPN 1371.  SPN 6474 is combined with other combustion information in PGN 61517, so that the message is combustion synchronous.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6475":{"PGN":61517,"PGN_Name":"Engine Cylinder 20 Combustion Information","PGN_Description":"ECCI20","first_bit":40,"SPN":6475,"SPN_Name":"Engine Cylinder 20 Pressure Sensor Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the engine cylinder 20 pressure sensor.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"6476":{"PGN":64660,"PGN_Name":"Aftertreatment System Abuse Information","PGN_Description":"ASAI","first_bit":0,"SPN":6476,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Doser Cooldown Interrupt Count","SPN_Description":"Non-volatile record of the number of interrupted cooldown routines since the last clear event.  The counter shall be reset by PGN 56832 request.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"6477":{"PGN":64660,"PGN_Name":"Aftertreatment System Abuse Information","PGN_Description":"ASAI","first_bit":16,"SPN":6477,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Doser Purge Interrupt Count","SPN_Description":"Non-volatile record of the number of interrupted purge routines since the last clear event.  The counter shall be reset by PGN 56832 request.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"6478":{"PGN":64660,"PGN_Name":"Aftertreatment System Abuse Information","PGN_Description":"ASAI","first_bit":32,"SPN":6478,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Doser Cooldown Complete This Cycle","SPN_Description":"Indication of cooldown routine completion in the current power cycle.\\r\\n\\r\\n\\"Complete This Cycle\\" parameters are used to indicate to the engine controller that is powering the aftertreatment controller via relay that it is ok to remove power. \\r\\n\\r\\n00 - Not complete\\r\\n01 - Complete\\r\\n10 - Error\\r\\n11 - Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6479":{"PGN":64660,"PGN_Name":"Aftertreatment System Abuse Information","PGN_Description":"ASAI","first_bit":34,"SPN":6479,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Doser Cooldown Complete Last Cycle","SPN_Description":"Indication of cooldown routine completion in the previous power cycle.\\r\\n\\r\\n00 - Not complete\\r\\n01 - Complete\\r\\n10 - Error\\r\\n11 - Not Supported\\r\\n\\r\\nNote:  One purpose for tracking the status of the Diesel Exhaust Fluid doser purge on the previous cycle is related to diagnostics.  For instance, if the Diesel Exhaust Fluid dosing system determines thaw was unsuccessful or took\\r\\nlonger than expected and the purge was interrupted on the previous cycle, this may be the suspected root cause.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6480":{"PGN":64660,"PGN_Name":"Aftertreatment System Abuse Information","PGN_Description":"ASAI","first_bit":40,"SPN":6480,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Doser Purge Complete This Cycle","SPN_Description":"Indication of purge routine completion in the current power cycle.\\r\\n\\r\\n\\"Complete This Cycle\\" parameters are used to indicate to the engine controller that is powering the aftertreatment controller via relay that it is ok to remove power. \\r\\n\\r\\n00 - Not complete\\r\\n01 - Complete\\r\\n10 - Error\\r\\n11 - Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6481":{"PGN":64660,"PGN_Name":"Aftertreatment System Abuse Information","PGN_Description":"ASAI","first_bit":42,"SPN":6481,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Doser Purge Complete Last Cycle","SPN_Description":"Indication of purge routine completion in the previous power cycle\\r\\n\\r\\n00 - Not complete\\r\\n01 - Complete\\r\\n10 - Error\\r\\n11 - Not Supported\\r\\n\\r\\nNote:  One purpose for tracking the status of the Diesel Exhaust Fluid doser purge on the previous cycle is related to diagnostics.  For instance, if the Diesel Exhaust Fluid dosing system determines thaw was unsuccessful or took\\r\\nlonger than expected and the purge was interrupted on the previous cycle, this may be the suspected root cause.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6482":{"PGN":64660,"PGN_Name":"Aftertreatment System Abuse Information","PGN_Description":"ASAI","first_bit":48,"SPN":6482,"SPN_Name":"After-run Complete This Cycle","SPN_Description":"Indication of after-run routine completion in the current power cycle.\\r\\n\\r\\n\\"Complete This Cycle\\" parameters are used to indicate to the engine controller that is powering the aftertreatment controller via relay that it is ok to remove power. \\r\\n\\r\\n00 - Not complete\\r\\n01 - Complete\\r\\n10 - Error\\r\\n11 - Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6483":{"PGN":61518,"PGN_Name":"Engine Cylinder 1 Combustion Average Information","PGN_Description":"ECCAI1","first_bit":0,"SPN":6483,"SPN_Name":"Engine Cylinder 1 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 1.   Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6484":{"PGN":61518,"PGN_Name":"Engine Cylinder 1 Combustion Average Information","PGN_Description":"ECCAI1","first_bit":16,"SPN":6484,"SPN_Name":"Engine Cylinder 1 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 1 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6485":{"PGN":61518,"PGN_Name":"Engine Cylinder 1 Combustion Average Information","PGN_Description":"ECCAI1","first_bit":32,"SPN":6485,"SPN_Name":"Engine Cylinder 1 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 1 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6486":{"PGN":61518,"PGN_Name":"Engine Cylinder 1 Combustion Average Information","PGN_Description":"ECCAI1","first_bit":48,"SPN":6486,"SPN_Name":"Engine Cylinder 1 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 1 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6487":{"PGN":61519,"PGN_Name":"Engine Cylinder 2 Combustion Average Information","PGN_Description":"ECCAI2","first_bit":0,"SPN":6487,"SPN_Name":"Engine Cylinder 2 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 2.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6488":{"PGN":61519,"PGN_Name":"Engine Cylinder 2 Combustion Average Information","PGN_Description":"ECCAI2","first_bit":16,"SPN":6488,"SPN_Name":"Engine Cylinder 2 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 2 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6489":{"PGN":61519,"PGN_Name":"Engine Cylinder 2 Combustion Average Information","PGN_Description":"ECCAI2","first_bit":32,"SPN":6489,"SPN_Name":"Engine Cylinder 2 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 2 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6490":{"PGN":61519,"PGN_Name":"Engine Cylinder 2 Combustion Average Information","PGN_Description":"ECCAI2","first_bit":48,"SPN":6490,"SPN_Name":"Engine Cylinder 2 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 2 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6491":{"PGN":61520,"PGN_Name":"Engine Cylinder 3 Combustion Average Information","PGN_Description":"ECCAI3","first_bit":0,"SPN":6491,"SPN_Name":"Engine Cylinder 3 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 3.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6492":{"PGN":61520,"PGN_Name":"Engine Cylinder 3 Combustion Average Information","PGN_Description":"ECCAI3","first_bit":16,"SPN":6492,"SPN_Name":"Engine Cylinder 3 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 3 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6493":{"PGN":61520,"PGN_Name":"Engine Cylinder 3 Combustion Average Information","PGN_Description":"ECCAI3","first_bit":32,"SPN":6493,"SPN_Name":"Engine Cylinder 3 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 3 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6494":{"PGN":61520,"PGN_Name":"Engine Cylinder 3 Combustion Average Information","PGN_Description":"ECCAI3","first_bit":48,"SPN":6494,"SPN_Name":"Engine Cylinder 3 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 3 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6495":{"PGN":61521,"PGN_Name":"Engine Cylinder 4 Combustion Average Information","PGN_Description":"ECCAI4","first_bit":0,"SPN":6495,"SPN_Name":"Engine Cylinder 4 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 4.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6496":{"PGN":61521,"PGN_Name":"Engine Cylinder 4 Combustion Average Information","PGN_Description":"ECCAI4","first_bit":16,"SPN":6496,"SPN_Name":"Engine Cylinder 4 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 4 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6497":{"PGN":61521,"PGN_Name":"Engine Cylinder 4 Combustion Average Information","PGN_Description":"ECCAI4","first_bit":32,"SPN":6497,"SPN_Name":"Engine Cylinder 4 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 4 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6498":{"PGN":61521,"PGN_Name":"Engine Cylinder 4 Combustion Average Information","PGN_Description":"ECCAI4","first_bit":48,"SPN":6498,"SPN_Name":"Engine Cylinder 4 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 4 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6499":{"PGN":61522,"PGN_Name":"Engine Cylinder 5 Combustion Average Information","PGN_Description":"ECCAI5","first_bit":0,"SPN":6499,"SPN_Name":"Engine Cylinder 5 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 5.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6500":{"PGN":61522,"PGN_Name":"Engine Cylinder 5 Combustion Average Information","PGN_Description":"ECCAI5","first_bit":16,"SPN":6500,"SPN_Name":"Engine Cylinder 5 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 5 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6501":{"PGN":61522,"PGN_Name":"Engine Cylinder 5 Combustion Average Information","PGN_Description":"ECCAI5","first_bit":32,"SPN":6501,"SPN_Name":"Engine Cylinder 5 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 5 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6502":{"PGN":61522,"PGN_Name":"Engine Cylinder 5 Combustion Average Information","PGN_Description":"ECCAI5","first_bit":48,"SPN":6502,"SPN_Name":"Engine Cylinder 5 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 5 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6503":{"PGN":61523,"PGN_Name":"Engine Cylinder 6 Combustion Average Information","PGN_Description":"ECCAI6","first_bit":0,"SPN":6503,"SPN_Name":"Engine Cylinder 6 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 6.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6504":{"PGN":61523,"PGN_Name":"Engine Cylinder 6 Combustion Average Information","PGN_Description":"ECCAI6","first_bit":16,"SPN":6504,"SPN_Name":"Engine Cylinder 6 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 6 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6505":{"PGN":61523,"PGN_Name":"Engine Cylinder 6 Combustion Average Information","PGN_Description":"ECCAI6","first_bit":32,"SPN":6505,"SPN_Name":"Engine Cylinder 6 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 6 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6506":{"PGN":61523,"PGN_Name":"Engine Cylinder 6 Combustion Average Information","PGN_Description":"ECCAI6","first_bit":48,"SPN":6506,"SPN_Name":"Engine Cylinder 6 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 6 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6507":{"PGN":61524,"PGN_Name":"Engine Cylinder 7 Combustion Average Information","PGN_Description":"ECCAI7","first_bit":0,"SPN":6507,"SPN_Name":"Engine Cylinder 7 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 7.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6508":{"PGN":61524,"PGN_Name":"Engine Cylinder 7 Combustion Average Information","PGN_Description":"ECCAI7","first_bit":16,"SPN":6508,"SPN_Name":"Engine Cylinder 7 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 7 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6509":{"PGN":61524,"PGN_Name":"Engine Cylinder 7 Combustion Average Information","PGN_Description":"ECCAI7","first_bit":32,"SPN":6509,"SPN_Name":"Engine Cylinder 7 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 7 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6510":{"PGN":61524,"PGN_Name":"Engine Cylinder 7 Combustion Average Information","PGN_Description":"ECCAI7","first_bit":48,"SPN":6510,"SPN_Name":"Engine Cylinder 7 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 7 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6511":{"PGN":61525,"PGN_Name":"Engine Cylinder 8 Combustion Average Information","PGN_Description":"ECCAI8","first_bit":0,"SPN":6511,"SPN_Name":"Engine Cylinder 8 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 8.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6512":{"PGN":61525,"PGN_Name":"Engine Cylinder 8 Combustion Average Information","PGN_Description":"ECCAI8","first_bit":16,"SPN":6512,"SPN_Name":"Engine Cylinder 8 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 8 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6513":{"PGN":61525,"PGN_Name":"Engine Cylinder 8 Combustion Average Information","PGN_Description":"ECCAI8","first_bit":32,"SPN":6513,"SPN_Name":"Engine Cylinder 8 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 8 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6514":{"PGN":61525,"PGN_Name":"Engine Cylinder 8 Combustion Average Information","PGN_Description":"ECCAI8","first_bit":48,"SPN":6514,"SPN_Name":"Engine Cylinder 8 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 8 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6515":{"PGN":61526,"PGN_Name":"Engine Cylinder 9 Combustion Average Information","PGN_Description":"ECCAI9","first_bit":0,"SPN":6515,"SPN_Name":"Engine Cylinder 9 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 9.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6516":{"PGN":61526,"PGN_Name":"Engine Cylinder 9 Combustion Average Information","PGN_Description":"ECCAI9","first_bit":16,"SPN":6516,"SPN_Name":"Engine Cylinder 9 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 9 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6517":{"PGN":61526,"PGN_Name":"Engine Cylinder 9 Combustion Average Information","PGN_Description":"ECCAI9","first_bit":32,"SPN":6517,"SPN_Name":"Engine Cylinder 9 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 9 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6518":{"PGN":61526,"PGN_Name":"Engine Cylinder 9 Combustion Average Information","PGN_Description":"ECCAI9","first_bit":48,"SPN":6518,"SPN_Name":"Engine Cylinder 9 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 9 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6519":{"PGN":61527,"PGN_Name":"Engine Cylinder 10 Combustion Average Information","PGN_Description":"ECCAI10","first_bit":0,"SPN":6519,"SPN_Name":"Engine Cylinder 10 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 10.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6520":{"PGN":61527,"PGN_Name":"Engine Cylinder 10 Combustion Average Information","PGN_Description":"ECCAI10","first_bit":16,"SPN":6520,"SPN_Name":"Engine Cylinder 10 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 10 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6521":{"PGN":61527,"PGN_Name":"Engine Cylinder 10 Combustion Average Information","PGN_Description":"ECCAI10","first_bit":32,"SPN":6521,"SPN_Name":"Engine Cylinder 10 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 10 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6522":{"PGN":61527,"PGN_Name":"Engine Cylinder 10 Combustion Average Information","PGN_Description":"ECCAI10","first_bit":48,"SPN":6522,"SPN_Name":"Engine Cylinder 10 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 10 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6523":{"PGN":61528,"PGN_Name":"Engine Cylinder 11 Combustion Average Information","PGN_Description":"ECCAI11","first_bit":0,"SPN":6523,"SPN_Name":"Engine Cylinder 11 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 11.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6524":{"PGN":61528,"PGN_Name":"Engine Cylinder 11 Combustion Average Information","PGN_Description":"ECCAI11","first_bit":16,"SPN":6524,"SPN_Name":"Engine Cylinder 11 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 11 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6525":{"PGN":61528,"PGN_Name":"Engine Cylinder 11 Combustion Average Information","PGN_Description":"ECCAI11","first_bit":32,"SPN":6525,"SPN_Name":"Engine Cylinder 11 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 11 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6526":{"PGN":61528,"PGN_Name":"Engine Cylinder 11 Combustion Average Information","PGN_Description":"ECCAI11","first_bit":48,"SPN":6526,"SPN_Name":"Engine Cylinder 11 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 11 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6527":{"PGN":61529,"PGN_Name":"Engine Cylinder 12 Combustion Average Information","PGN_Description":"ECCAI12","first_bit":0,"SPN":6527,"SPN_Name":"Engine Cylinder 12 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 12.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6528":{"PGN":61529,"PGN_Name":"Engine Cylinder 12 Combustion Average Information","PGN_Description":"ECCAI12","first_bit":16,"SPN":6528,"SPN_Name":"Engine Cylinder 12 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 12 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6529":{"PGN":61529,"PGN_Name":"Engine Cylinder 12 Combustion Average Information","PGN_Description":"ECCAI12","first_bit":32,"SPN":6529,"SPN_Name":"Engine Cylinder 12 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 12 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6530":{"PGN":61529,"PGN_Name":"Engine Cylinder 12 Combustion Average Information","PGN_Description":"ECCAI12","first_bit":48,"SPN":6530,"SPN_Name":"Engine Cylinder 12 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 12 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6531":{"PGN":61530,"PGN_Name":"Engine Cylinder 13 Combustion Average Information","PGN_Description":"ECCAI13","first_bit":0,"SPN":6531,"SPN_Name":"Engine Cylinder 13 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 13.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6532":{"PGN":61530,"PGN_Name":"Engine Cylinder 13 Combustion Average Information","PGN_Description":"ECCAI13","first_bit":16,"SPN":6532,"SPN_Name":"Engine Cylinder 13 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 13 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6533":{"PGN":61530,"PGN_Name":"Engine Cylinder 13 Combustion Average Information","PGN_Description":"ECCAI13","first_bit":32,"SPN":6533,"SPN_Name":"Engine Cylinder 13 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 13 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6534":{"PGN":61530,"PGN_Name":"Engine Cylinder 13 Combustion Average Information","PGN_Description":"ECCAI13","first_bit":48,"SPN":6534,"SPN_Name":"Engine Cylinder 13 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 13 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6535":{"PGN":61531,"PGN_Name":"Engine Cylinder 14 Combustion Average Information","PGN_Description":"ECCAI14","first_bit":0,"SPN":6535,"SPN_Name":"Engine Cylinder 14 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 14.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6536":{"PGN":61531,"PGN_Name":"Engine Cylinder 14 Combustion Average Information","PGN_Description":"ECCAI14","first_bit":16,"SPN":6536,"SPN_Name":"Engine Cylinder 14 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 14 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6537":{"PGN":61531,"PGN_Name":"Engine Cylinder 14 Combustion Average Information","PGN_Description":"ECCAI14","first_bit":32,"SPN":6537,"SPN_Name":"Engine Cylinder 14 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 14 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6538":{"PGN":61531,"PGN_Name":"Engine Cylinder 14 Combustion Average Information","PGN_Description":"ECCAI14","first_bit":48,"SPN":6538,"SPN_Name":"Engine Cylinder 14 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 14 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6539":{"PGN":61532,"PGN_Name":"Engine Cylinder 15 Combustion Average Information","PGN_Description":"ECCAI15","first_bit":0,"SPN":6539,"SPN_Name":"Engine Cylinder 15 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 15.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6540":{"PGN":61532,"PGN_Name":"Engine Cylinder 15 Combustion Average Information","PGN_Description":"ECCAI15","first_bit":16,"SPN":6540,"SPN_Name":"Engine Cylinder 15 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 15 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6541":{"PGN":61532,"PGN_Name":"Engine Cylinder 15 Combustion Average Information","PGN_Description":"ECCAI15","first_bit":32,"SPN":6541,"SPN_Name":"Engine Cylinder 15 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 15 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6542":{"PGN":61532,"PGN_Name":"Engine Cylinder 15 Combustion Average Information","PGN_Description":"ECCAI15","first_bit":48,"SPN":6542,"SPN_Name":"Engine Cylinder 15 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 15 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6543":{"PGN":61533,"PGN_Name":"Engine Cylinder 16 Combustion Average Information","PGN_Description":"ECCAI16","first_bit":0,"SPN":6543,"SPN_Name":"Engine Cylinder 16 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 16.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6544":{"PGN":61533,"PGN_Name":"Engine Cylinder 16 Combustion Average Information","PGN_Description":"ECCAI16","first_bit":16,"SPN":6544,"SPN_Name":"Engine Cylinder 16 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 16 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6545":{"PGN":61533,"PGN_Name":"Engine Cylinder 16 Combustion Average Information","PGN_Description":"ECCAI16","first_bit":32,"SPN":6545,"SPN_Name":"Engine Cylinder 16 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 16 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6546":{"PGN":61533,"PGN_Name":"Engine Cylinder 16 Combustion Average Information","PGN_Description":"ECCAI16","first_bit":48,"SPN":6546,"SPN_Name":"Engine Cylinder 16 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 16 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6547":{"PGN":61534,"PGN_Name":"Engine Cylinder 17 Combustion Average Information","PGN_Description":"ECCAI17","first_bit":0,"SPN":6547,"SPN_Name":"Engine Cylinder 17 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 17.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6548":{"PGN":61534,"PGN_Name":"Engine Cylinder 17 Combustion Average Information","PGN_Description":"ECCAI17","first_bit":16,"SPN":6548,"SPN_Name":"Engine Cylinder 17 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 17 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6549":{"PGN":61534,"PGN_Name":"Engine Cylinder 17 Combustion Average Information","PGN_Description":"ECCAI17","first_bit":32,"SPN":6549,"SPN_Name":"Engine Cylinder 17 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 17 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6550":{"PGN":61534,"PGN_Name":"Engine Cylinder 17 Combustion Average Information","PGN_Description":"ECCAI17","first_bit":48,"SPN":6550,"SPN_Name":"Engine Cylinder 17 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 17 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6551":{"PGN":61535,"PGN_Name":"Engine Cylinder 18 Combustion Average Information","PGN_Description":"ECCAI18","first_bit":0,"SPN":6551,"SPN_Name":"Engine Cylinder 18 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 18.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6552":{"PGN":61535,"PGN_Name":"Engine Cylinder 18 Combustion Average Information","PGN_Description":"ECCAI18","first_bit":16,"SPN":6552,"SPN_Name":"Engine Cylinder 18 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 18 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6553":{"PGN":61535,"PGN_Name":"Engine Cylinder 18 Combustion Average Information","PGN_Description":"ECCAI18","first_bit":32,"SPN":6553,"SPN_Name":"Engine Cylinder 18 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 18 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6554":{"PGN":61535,"PGN_Name":"Engine Cylinder 18 Combustion Average Information","PGN_Description":"ECCAI18","first_bit":48,"SPN":6554,"SPN_Name":"Engine Cylinder 18 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 18 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6555":{"PGN":61536,"PGN_Name":"Engine Cylinder 19 Combustion Average Information","PGN_Description":"ECCAI19","first_bit":0,"SPN":6555,"SPN_Name":"Engine Cylinder 19 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 19.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6556":{"PGN":61536,"PGN_Name":"Engine Cylinder 19 Combustion Average Information","PGN_Description":"ECCAI19","first_bit":16,"SPN":6556,"SPN_Name":"Engine Cylinder 19 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 19 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6557":{"PGN":61536,"PGN_Name":"Engine Cylinder 19 Combustion Average Information","PGN_Description":"ECCAI19","first_bit":32,"SPN":6557,"SPN_Name":"Engine Cylinder 19 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 19 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6558":{"PGN":61536,"PGN_Name":"Engine Cylinder 19 Combustion Average Information","PGN_Description":"ECCAI19","first_bit":48,"SPN":6558,"SPN_Name":"Engine Cylinder 19 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 19 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6559":{"PGN":61537,"PGN_Name":"Engine Cylinder 20 Combustion Average Information","PGN_Description":"ECCAI20","first_bit":0,"SPN":6559,"SPN_Name":"Engine Cylinder 20 Indicated Mean Effective Pressure","SPN_Description":"Average cylinder pressure calculated over defined number of combustion cycles for engine cylinder 20.  Negative range is to cover thermodynamic behavior during misfire.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6560":{"PGN":61537,"PGN_Name":"Engine Cylinder 20 Combustion Average Information","PGN_Description":"ECCAI20","first_bit":16,"SPN":6560,"SPN_Name":"Engine Cylinder 20 Average Start of Combustion Timing","SPN_Description":"Average start of combustion timing calculated over defined number of combustion cycles for engine cylinder 20 with reference to the crank angle.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6561":{"PGN":61537,"PGN_Name":"Engine Cylinder 20 Combustion Average Information","PGN_Description":"ECCAI20","first_bit":32,"SPN":6561,"SPN_Name":"Engine Cylinder 20 Average Center of Combustion Timing","SPN_Description":"Average timing calculated over defined number of combustion cycles for the center of combustion in engine cylinder 20 with reference to the crank angle.  Center of Combustion is used to indicate the combustion efficiency.  When the combustion happens after the TDC (Top Dead Center) of this cylinder, the timing is referred in terms of positive angle and if combustion happens before TDC, the timing is referred in terms of negative angle.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"deg","SLOT_ID":365},"6562":{"PGN":61537,"PGN_Name":"Engine Cylinder 20 Combustion Average Information","PGN_Description":"ECCAI20","first_bit":48,"SPN":6562,"SPN_Name":"Engine Cylinder 20 Average Combustion Duration","SPN_Description":"Average duration of combustion calculated over defined number of combustion cycles for engine cylinder 20 with reference to the crank angle.  Combustion duration is the difference between end of combustion and start of combustion expressed, in this case, in terms of crank angle.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"6563":{"PGN":64701,"PGN_Name":"Aftertreatment 1 SCR Service Information 2","PGN_Description":"A1SCRSI2","first_bit":32,"SPN":6563,"SPN_Name":"Aftertreatment Trip Diesel Exhaust Fluid","SPN_Description":"DEF consumed during all or part of a journey.","bit_length":32,"scaling":0.05,"offset":0,"unit":"l","SLOT_ID":376},"6566":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":48,"SPN":6566,"SPN_Name":"Transmission Air Supply Pressure Indicator","SPN_Description":"Indicates whether transmission air supply is sufficient\\r\\n\\r\\n000   Normal Pressure Range - The transmission supply air pressure is within the normal operational range.\\r\\n001   Low pressure - The transmission supply air pressure is within a range that may reduce the transmission\u2019s  performance.\\r\\n010   Very low pressure - The transmission supply air pressure is below a range that will reduce the transmission\u2019s performance.\\r\\n011   No pressure - The transmission supply air pressure is below a range that will stop the transmission from functioning.\\r\\n100   Over pressure - The transmission supply air pressure is above a range that may reduce the transmission\u2019s performance.\\r\\n101   Not defined\\r\\n110   Error indicator\\r\\n111   Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6567":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":44,"SPN":6567,"SPN_Name":"Transmission Mode 9 Indicator","SPN_Description":"Indicates that the transmission is operating under transmission mode 9 (SPN 6569) as commanded via the TC2 message (PGN 3328). The definition of the transmission mode is left to the discretion of the transmission manufacturer. \\r\\n\\r\\n00 Transmission Mode 9 not active\\r\\n01 Transmission Mode 9 active\\r\\n10 Error indicator\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6568":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":46,"SPN":6568,"SPN_Name":"Transmission Mode 10 Indicator","SPN_Description":"Indicates that the transmission is operating under transmission mode 10 (SPN 6570) as commanded via the TC2 message (PGN 3328). The definition of the transmission mode is left to the discretion of the transmission manufacturer. \\r\\n\\r\\n00 Transmission Mode 10 not active\\r\\n01 Transmission Mode 10 active\\r\\n10 Error indicator\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6569":{"PGN":3328,"PGN_Name":"Transmission Control 2","PGN_Description":"TC2","first_bit":0,"SPN":6569,"SPN_Name":"Transmission Mode 9","SPN_Description":"Indicates whether transmission mode 9 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 6567. \\r\\n\\r\\n00 Disable\\r\\n01 Enable\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6570":{"PGN":3328,"PGN_Name":"Transmission Control 2","PGN_Description":"TC2","first_bit":2,"SPN":6570,"SPN_Name":"Transmission Mode 10","SPN_Description":"Indicates whether transmission mode 10 is enabled. Modes are manufacturer specific and are not necessarily mutually exclusive. See also SPN 6568. \\r\\n\\r\\n00 Disable\\r\\n01 Enable\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6571":{"PGN":64659,"PGN_Name":"Gaseous Fuel Pressure 2","PGN_Description":"GFP2","first_bit":0,"SPN":6571,"SPN_Name":"Engine Main Chamber Fuel Absolute Pressure","SPN_Description":"Absolute pressure of the gaseous fuel for the main chamber of the cylinder. This parameter is intended for applications, which use a pre and main chamber fuel systems, which report the pressure of more than one type of fuel.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6572":{"PGN":64659,"PGN_Name":"Gaseous Fuel Pressure 2","PGN_Description":"GFP2","first_bit":16,"SPN":6572,"SPN_Name":"Engine Main Chamber Fuel Desired Absolute Pressure","SPN_Description":"Desired absolute pressure of the gaseous fuel for the main chamber of the cylinder. This parameter is intended for applications with pre and main chamber fuel systems, which report the pressure of more than one type of fuel.Engine","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6573":{"PGN":64659,"PGN_Name":"Gaseous Fuel Pressure 2","PGN_Description":"GFP2","first_bit":32,"SPN":6573,"SPN_Name":"Engine Prechamber Fuel Absolute Pressure","SPN_Description":"Absolute pressure of the gaseous fuel for the separate cylinder pre-chamber rail. This parameter is intended for applications, which use a pre and main chamber fuel systems, which report the pressure of more than one type of fuel.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6574":{"PGN":64659,"PGN_Name":"Gaseous Fuel Pressure 2","PGN_Description":"GFP2","first_bit":48,"SPN":6574,"SPN_Name":"Engine Prechamber Fuel Desired Absolute Pressure","SPN_Description":"Desired absolute pressure of the gaseous fuel in the separate cylinder pre-chamber rail. This parameter is intended for applications with pre and main chamber fuel systems, which report the pressure of more than one type of fuel.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6575":{"PGN":64658,"PGN_Name":"Air Fuel Ratio","PGN_Description":"AFR","first_bit":0,"SPN":6575,"SPN_Name":"Engine Main Chamber Air Fuel Ratio","SPN_Description":"Actual air to fuel ratio of the charge entering the cylinder main chamber.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"6576":{"PGN":64658,"PGN_Name":"Air Fuel Ratio","PGN_Description":"AFR","first_bit":16,"SPN":6576,"SPN_Name":"Engine Main Chamber Desired Air Fuel Ratio","SPN_Description":"Desired air to fuel ratio of the charge entering the cylinder main chamber.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"6577":{"PGN":64658,"PGN_Name":"Air Fuel Ratio","PGN_Description":"AFR","first_bit":32,"SPN":6577,"SPN_Name":"Engine Prechamber Air Fuel Ratio","SPN_Description":"Actual air to fuel ratio of the charge entering the cylinder prechamber.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"6578":{"PGN":64658,"PGN_Name":"Air Fuel Ratio","PGN_Description":"AFR","first_bit":48,"SPN":6578,"SPN_Name":"Engine Prechamber Desired Air Fuel Ratio","SPN_Description":"Desired air to fuel ratio of the charge entering the cylinder prechamber.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"6579":{"PGN":64657,"PGN_Name":"Engine Exhaust NOx","PGN_Description":"EEN","first_bit":0,"SPN":6579,"SPN_Name":"Engine Exhaust NOx","SPN_Description":"Calculated NOx concentration for the total engine exhaust, prior to any aftertreatment of the exhaust.  This parameter is primarily intended for engines that have separate NOx sensors in separate exhaust manifolds, but the engine does not have an NOx sensor in an exhaust line after combining the exhaust from the separate manifolds.  This parameter represents the Nox concentration that would be measured by an NOx sensor in an exhaust line after combining the exhaust from the separate manifolds. \\r\\n\\r\\nNote:  The individual NOx measurements for the separate exhaust manifolds are reported using the aftertreatment intake NOx parameters, such as SPN 3216 and SPN 3255. This SPN should not be used with engines with only one NOx sensor; instead, engines with only one NOx sensor should use SPN 3216.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"6580":{"PGN":64657,"PGN_Name":"Engine Exhaust NOx","PGN_Description":"EEN","first_bit":16,"SPN":6580,"SPN_Name":"Engine Exhaust Desired NOx","SPN_Description":"Desired NOx concentration in the engine exhaust, prior to any aftertreatment of the exhaust.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"6582":{"PGN":64703,"PGN_Name":"Electronic Transmission Controller #10","PGN_Description":"ETC10","first_bit":56,"SPN":6582,"SPN_Name":"Transmission Hydraulic Pump Actuator 2 Percent","SPN_Description":"The current modulated value for actuator 2 that controls the transmission hydraulic pump, where 0% = no hydraulic pressure and 100% = full hydraulic pressure.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6583":{"PGN":61538,"PGN_Name":"Electronic Transmission Controller #12","PGN_Description":"ETC12","first_bit":0,"SPN":6583,"SPN_Name":"Transmission Hydrostatic Loop 1 Pressure","SPN_Description":"Oil pressure in the transmission hydrostatic loop #1 between the pump and motor.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"6584":{"PGN":61538,"PGN_Name":"Electronic Transmission Controller #12","PGN_Description":"ETC12","first_bit":16,"SPN":6584,"SPN_Name":"Transmission Hydrostatic Loop 2 Pressure","SPN_Description":"Oil pressure in the transmission hydrostatic loop #2 between the pump and motor.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"6585":{"PGN":61538,"PGN_Name":"Electronic Transmission Controller #12","PGN_Description":"ETC12","first_bit":32,"SPN":6585,"SPN_Name":"Transmission Directional Output Shaft Speed","SPN_Description":"The rotational velocity and direction of the output shaft. Positive values are used for forward vehicle motion, negative values for reverse vehicle motion.\\r\\n\\r\\nSPN 191 should be used when direction is not used.","bit_length":16,"scaling":1,"offset":-32127,"unit":"rpm","SLOT_ID":378},"6586":{"PGN":64831,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Pressures","PGN_Description":"A1SCREGP","first_bit":24,"SPN":6586,"SPN_Name":"Aftertreatment 1 SCR Intake Pressure","SPN_Description":"The gage pressure at the intake of the selective catalytic reduction system of Aftertreatment 1.","bit_length":16,"scaling":0.1,"offset":-3212.7,"unit":"kPa","SLOT_ID":355},"6587":{"PGN":64825,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Pressures","PGN_Description":"A2SCREGP","first_bit":24,"SPN":6587,"SPN_Name":"Aftertreatment 2 SCR Intake Pressure","SPN_Description":"The gage pressure at the intake of the selective catalytic reduction system of Aftertreatment 2.","bit_length":16,"scaling":0.1,"offset":-3212.7,"unit":"kPa","SLOT_ID":355},"6589":{"PGN":64656,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 1","PGN_Description":"EFIMRPI1","first_bit":0,"SPN":6589,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 1 Pressure 1","SPN_Description":"The pressure of fuel measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.\\r\\n\\r\\nNote:  This is for the rail pressure from the 1st rail pressure sensor.  This may be different than SPN 157 when used in multiple rail pressure sensor configurations.   In an application with only one rail pressure sensor, SPN 157 will be used.  However, in an application with multiple rail pressure sensors, SPN 157 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 1.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"6590":{"PGN":64656,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 1","PGN_Description":"EFIMRPI1","first_bit":16,"SPN":6590,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 1 Pressure 2","SPN_Description":"The pressure of fuel measured by the second rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.\\r\\n \\r\\nNote:  This is for the rail pressure from the 2nd rail pressure sensor.  This may be different than SPN 157 when used in multiple rail pressure sensor configurations.  In an application with multiple rail pressure sensors, SPN 157 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 1.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"6591":{"PGN":64656,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 1","PGN_Description":"EFIMRPI1","first_bit":32,"SPN":6591,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 2 Pressure 1","SPN_Description":"The pressure of fuel measured by first rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.\\r\\n\\r\\nNote:  This is for the rail pressure from the 1st rail pressure sensor.  This may be different than SPN 1349 when used in multiple rail pressure sensor configurations.   In an application with only one rail pressure sensor, SPN 1349 will be used.  However, in an application with multiple rail pressure sensors, SPN 1349 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 2.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"6592":{"PGN":64656,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 1","PGN_Description":"EFIMRPI1","first_bit":48,"SPN":6592,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 2 Pressure 2","SPN_Description":"The pressure of fuel measured by second rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake. \\r\\n\\r\\nNote:  This is for the rail pressure from the 2nd rail pressure sensor.  This may be different than SPN 1349 when used in multiple rail pressure sensor configurations.  In an application with multiple rail pressure sensors, SPN 1349 data will be arbitrated from rail pressure sensors 1 and 2 in metering rail 2.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"6593":{"PGN":61476,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 1","PGN_Description":"A1SCRDSR1","first_bit":40,"SPN":6593,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Dosing Requested Quantity (High Range)","SPN_Description":"Requested dosing quantity of diesel exhaust fluid. This SPN is a high range measurement. See SPN 4348 if high range is not needed.","bit_length":16,"scaling":0.05,"offset":0,"unit":"g/min","SLOT_ID":317},"6594":{"PGN":61479,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 1","PGN_Description":"A2SCRDSR1","first_bit":40,"SPN":6594,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Dosing Requested Quantity (High Range)","SPN_Description":"Requested dosing quantity of diesel exhaust fluid. This SPN is a high range measurement. See SPN 4401 if high range is not needed.","bit_length":16,"scaling":0.05,"offset":0,"unit":"g/min","SLOT_ID":317},"6595":{"PGN":61475,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 1","PGN_Description":"A1SCRDSI1","first_bit":48,"SPN":6595,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Actual Dosing Quantity (High Range)","SPN_Description":"Actual dosing quantity of diesel exhaust fluid. See SPN 4331 if high range measurement is not needed.","bit_length":16,"scaling":0.05,"offset":0,"unit":"g/min","SLOT_ID":317},"6596":{"PGN":61478,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 1","PGN_Description":"A2SCRDSI1","first_bit":48,"SPN":6596,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Actual Dosing Quantity (High Range)","SPN_Description":"Actual dosing quantity of diesel exhaust fluid. See SPN 4384 if high range measurement is not needed.","bit_length":16,"scaling":0.05,"offset":0,"unit":"g/min","SLOT_ID":317},"6610":{"PGN":64655,"PGN_Name":"Alternate Fuel 3","PGN_Description":"AF3","first_bit":16,"SPN":6610,"SPN_Name":"Engine Fuel Vaporizer 1 Discharge Temperature","SPN_Description":"The temperature of the fuel in its gaseous state at the outlet of the first fuel vaporizer","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6642":{"PGN":64671,"PGN_Name":"Dash Display 2","PGN_Description":"DD2","first_bit":16,"SPN":6642,"SPN_Name":"Engine Fuel 2 Tank 1 Level","SPN_Description":"Fuel level in tank 1 containing the second fuel type.\\r\\n.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6643":{"PGN":64671,"PGN_Name":"Dash Display 2","PGN_Description":"DD2","first_bit":24,"SPN":6643,"SPN_Name":"Engine Fuel 2 Tank 2 Level","SPN_Description":"Fuel level in tank 2 containing the second fuel type.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6644":{"PGN":64671,"PGN_Name":"Dash Display 2","PGN_Description":"DD2","first_bit":32,"SPN":6644,"SPN_Name":"Engine Fuel 2 Tank 3 Level","SPN_Description":"Fuel level in tank 3 containing the second fuel type.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6645":{"PGN":64671,"PGN_Name":"Dash Display 2","PGN_Description":"DD2","first_bit":40,"SPN":6645,"SPN_Name":"Engine Fuel 2 Tank 4 Level","SPN_Description":"Fuel level in tank 4 containing the second fuel type.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6646":{"PGN":64655,"PGN_Name":"Alternate Fuel 3","PGN_Description":"AF3","first_bit":0,"SPN":6646,"SPN_Name":"Engine Gaseous Fuel Supply Pressure 1 (Extended Range)","SPN_Description":"Pressure of gaseous fuel supply to fuel metering device in systems where the pressure range defined for SPN 159 is not sufficient.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"MPa","SLOT_ID":51},"6649":{"PGN":65194,"PGN_Name":"Alternate Fuel 2","PGN_Description":"AF2","first_bit":40,"SPN":6649,"SPN_Name":"Gaseous Fuel Injection Pulse Correction Factor","SPN_Description":"A correction to the gaseous fuel injection pulse (expressed in msec) represented as a percentage.  100% means no correction, higher values indicate increased pulse time, lower values indicate decreased pulse time.","bit_length":16,"scaling":0.0078125,"offset":-251,"unit":"%","SLOT_ID":256},"6650":{"PGN":64713,"PGN_Name":"Engine Fuel/Throttle Valve Information 2","PGN_Description":"EF/TVI2","first_bit":48,"SPN":6650,"SPN_Name":"Engine Throttle Valve 1 Position 2","SPN_Description":"The position of the valve used to regulate the supply of a fluid, usually air or fuel/air mixture, to an engine. This position is measured by a second sensor.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6656":{"PGN":61539,"PGN_Name":"Fuel Information 5 (Gaseous)","PGN_Description":"GFI5","first_bit":0,"SPN":6656,"SPN_Name":"Engine Gaseous Fuel Valve Nominal Duration Command","SPN_Description":"Amount of time the gaseous fuel valves are activated.  It\'s a nominal value used for all the gaseous fuel valves in the engine.\\r\\n\\r\\nNote: Please see SPNs 6658 - 6677 for duration command for each gaseous fuel valves","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6657":{"PGN":61539,"PGN_Name":"Fuel Information 5 (Gaseous)","PGN_Description":"GFI5","first_bit":16,"SPN":6657,"SPN_Name":"Engine Gaseous Fuel Valve Nominal Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of each cylinder, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valves are activated to open.  It\'s a nominal value used for all the gaseous fuel valves in the engine.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nNote: Please see SPNs 6678 - 6697 for Start of injection command for each gaseous fuel valves","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6658":{"PGN":61540,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 1","PGN_Description":"EGFVDC1","first_bit":0,"SPN":6658,"SPN_Name":"Engine Gaseous Fuel Valve 1 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 1 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6659":{"PGN":61540,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 1","PGN_Description":"EGFVDC1","first_bit":16,"SPN":6659,"SPN_Name":"Engine Gaseous Fuel Valve 2 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 2 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6660":{"PGN":61540,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 1","PGN_Description":"EGFVDC1","first_bit":32,"SPN":6660,"SPN_Name":"Engine Gaseous Fuel Valve 3 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 3 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6661":{"PGN":61540,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 1","PGN_Description":"EGFVDC1","first_bit":48,"SPN":6661,"SPN_Name":"Engine Gaseous Fuel Valve 4 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 4 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6662":{"PGN":61541,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 2","PGN_Description":"EGFVDC2","first_bit":0,"SPN":6662,"SPN_Name":"Engine Gaseous Fuel Valve 5 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 5 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6663":{"PGN":61541,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 2","PGN_Description":"EGFVDC2","first_bit":16,"SPN":6663,"SPN_Name":"Engine Gaseous Fuel Valve 6 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 6 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6664":{"PGN":61541,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 2","PGN_Description":"EGFVDC2","first_bit":32,"SPN":6664,"SPN_Name":"Engine Gaseous Fuel Valve 7 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 7 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6665":{"PGN":61541,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 2","PGN_Description":"EGFVDC2","first_bit":48,"SPN":6665,"SPN_Name":"Engine Gaseous Fuel Valve 8 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 8 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6666":{"PGN":61542,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 3","PGN_Description":"EGFVDC3","first_bit":0,"SPN":6666,"SPN_Name":"Engine Gaseous Fuel Valve 9 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 9 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6667":{"PGN":61542,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 3","PGN_Description":"EGFVDC3","first_bit":16,"SPN":6667,"SPN_Name":"Engine Gaseous Fuel Valve 10 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 10 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6668":{"PGN":61542,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 3","PGN_Description":"EGFVDC3","first_bit":32,"SPN":6668,"SPN_Name":"Engine Gaseous Fuel Valve 11 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 11 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6669":{"PGN":61542,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 3","PGN_Description":"EGFVDC3","first_bit":48,"SPN":6669,"SPN_Name":"Engine Gaseous Fuel Valve 12 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 12 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6670":{"PGN":61543,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 4","PGN_Description":"EGFVDC4","first_bit":0,"SPN":6670,"SPN_Name":"Engine Gaseous Fuel Valve 13 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 13 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6671":{"PGN":61543,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 4","PGN_Description":"EGFVDC4","first_bit":16,"SPN":6671,"SPN_Name":"Engine Gaseous Fuel Valve 14 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 14 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6672":{"PGN":61543,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 4","PGN_Description":"EGFVDC4","first_bit":32,"SPN":6672,"SPN_Name":"Engine Gaseous Fuel Valve 15 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 15 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6673":{"PGN":61543,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 4","PGN_Description":"EGFVDC4","first_bit":48,"SPN":6673,"SPN_Name":"Engine Gaseous Fuel Valve 16 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 16 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6674":{"PGN":61544,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 5","PGN_Description":"EGFVDC5","first_bit":0,"SPN":6674,"SPN_Name":"Engine Gaseous Fuel Valve 17 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 17 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6675":{"PGN":61544,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 5","PGN_Description":"EGFVDC5","first_bit":16,"SPN":6675,"SPN_Name":"Engine Gaseous Fuel Valve 18 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 18 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6676":{"PGN":61544,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 5","PGN_Description":"EGFVDC5","first_bit":32,"SPN":6676,"SPN_Name":"Engine Gaseous Fuel Valve 19 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 19 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6677":{"PGN":61544,"PGN_Name":"Engine Gaseous Fuel Valve Duration Command 5","PGN_Description":"EGFVDC5","first_bit":48,"SPN":6677,"SPN_Name":"Engine Gaseous Fuel Valve 20 Duration Command","SPN_Description":"Amount of time the gaseous fuel valve 20 is activated.","bit_length":16,"scaling":2,"offset":0,"unit":"\xb5s","SLOT_ID":380},"6678":{"PGN":61545,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 1","PGN_Description":"EGFVSOAC1","first_bit":0,"SPN":6678,"SPN_Name":"Engine Gaseous Fuel Valve 1 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 1, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 1 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1413 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6679":{"PGN":61545,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 1","PGN_Description":"EGFVSOAC1","first_bit":16,"SPN":6679,"SPN_Name":"Engine Gaseous Fuel Valve 2 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 2, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 2 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1414 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6680":{"PGN":61545,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 1","PGN_Description":"EGFVSOAC1","first_bit":32,"SPN":6680,"SPN_Name":"Engine Gaseous Fuel Valve 3 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 3, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 3 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1415 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6681":{"PGN":61545,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 1","PGN_Description":"EGFVSOAC1","first_bit":48,"SPN":6681,"SPN_Name":"Engine Gaseous Fuel Valve 4 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 4, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 4 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1416 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6682":{"PGN":61546,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 2","PGN_Description":"EGFVSOAC2","first_bit":0,"SPN":6682,"SPN_Name":"Engine Gaseous Fuel Valve 5 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 5, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 5 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1417 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6683":{"PGN":61546,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 2","PGN_Description":"EGFVSOAC2","first_bit":16,"SPN":6683,"SPN_Name":"Engine Gaseous Fuel Valve 6 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 6, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 6 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1418 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6684":{"PGN":61546,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 2","PGN_Description":"EGFVSOAC2","first_bit":32,"SPN":6684,"SPN_Name":"Engine Gaseous Fuel Valve 7 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 7, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 7 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1419 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6685":{"PGN":61546,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 2","PGN_Description":"EGFVSOAC2","first_bit":48,"SPN":6685,"SPN_Name":"Engine Gaseous Fuel Valve 8 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 8, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 8 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1420 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6686":{"PGN":61547,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 3","PGN_Description":"EGFVSOAC3","first_bit":0,"SPN":6686,"SPN_Name":"Engine Gaseous Fuel Valve 9 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 9, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 9 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1421 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6687":{"PGN":61547,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 3","PGN_Description":"EGFVSOAC3","first_bit":16,"SPN":6687,"SPN_Name":"Engine Gaseous Fuel Valve 10 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 10, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 10 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1422 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6688":{"PGN":61547,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 3","PGN_Description":"EGFVSOAC3","first_bit":32,"SPN":6688,"SPN_Name":"Engine Gaseous Fuel Valve 11 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 11, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 11 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1423 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6689":{"PGN":61547,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 3","PGN_Description":"EGFVSOAC3","first_bit":48,"SPN":6689,"SPN_Name":"Engine Gaseous Fuel Valve 12 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 12, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 12 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1424 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6690":{"PGN":61548,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 4","PGN_Description":"EGFVSOAC4","first_bit":0,"SPN":6690,"SPN_Name":"Engine Gaseous Fuel Valve 13 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 13, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 13 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1425 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6691":{"PGN":61548,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 4","PGN_Description":"EGFVSOAC4","first_bit":16,"SPN":6691,"SPN_Name":"Engine Gaseous Fuel Valve 14 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 14, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 14 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1426 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6692":{"PGN":61548,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 4","PGN_Description":"EGFVSOAC4","first_bit":32,"SPN":6692,"SPN_Name":"Engine Gaseous Fuel Valve 15 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 15, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 15 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1427 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6693":{"PGN":61548,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 4","PGN_Description":"EGFVSOAC4","first_bit":48,"SPN":6693,"SPN_Name":"Engine Gaseous Fuel Valve 16 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 16, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 16 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1428 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6694":{"PGN":61549,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 5","PGN_Description":"EGFVSOAC5","first_bit":0,"SPN":6694,"SPN_Name":"Engine Gaseous Fuel Valve 17 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 17, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 17 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1429 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6695":{"PGN":61549,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 5","PGN_Description":"EGFVSOAC5","first_bit":16,"SPN":6695,"SPN_Name":"Engine Gaseous Fuel Valve 18 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 18, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 18 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1420 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6696":{"PGN":61549,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 5","PGN_Description":"EGFVSOAC5","first_bit":32,"SPN":6696,"SPN_Name":"Engine Gaseous Fuel Valve 19 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 19, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 19 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1431 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6697":{"PGN":61549,"PGN_Name":"Engine Gaseous Fuel Valve Start of Actuation Command 5","PGN_Description":"EGFVSOAC5","first_bit":48,"SPN":6697,"SPN_Name":"Engine Gaseous Fuel Valve 20 Start of Actuation Command","SPN_Description":"The angle, relative to the TDC of cylinder 20, with 0 being the TDC before the power stroke commences, at the which gaseous fuel valve 20 is activated to open.\\r\\n\\r\\nTimings after TDC are referred with positive values and timings before TDC are referred with negative values.\\r\\n\\r\\nThis is the timing for the secondary fuel injector.  See SPN 1432 for the primary fuel injector timing.","bit_length":16,"scaling":0.0078125,"offset":-400,"unit":"deg","SLOT_ID":379},"6702":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":22,"SPN":6702,"SPN_Name":"Fire Apparatus Okay To Pump Interlock","SPN_Description":"The measured state of the Okay To Pump interlock of the fire apparatus.\\r\\n\\r\\n00 Okay to Pump Interlock Inactive\\r\\n01 Okay to Pump Interlock Active\\r\\n10 Error\\r\\n11 Not Available\\r\\n\\r\\nNote: \\"Okay to Pump\\" is incorporated into the NFPA 1901 Standard for Fire Appartus.  It is a required indicator.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6703":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":60,"SPN":6703,"SPN_Name":"Hydraulic Pressure Governor Increase Switch","SPN_Description":"Switch that commands hydraulic pressure governor to increase engine rpm resulting in expected increase of hydraulic discharge pressure.\\r\\n\\r\\n00 Increase Switch Inactive\\r\\n01 Increase Switch Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6704":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":58,"SPN":6704,"SPN_Name":"Hydraulic Pressure Governor Decrease Switch","SPN_Description":"Switch that commands hydraulic pressure governor to decrease engine rpm resulting in expected decrease of hydraulic discharge pressure.\\r\\n\\r\\n00 Decrease Switch Inactive\\r\\n01 Decrease Switch Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6705":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":56,"SPN":6705,"SPN_Name":"Hydraulic Pressure Governor Idle Switch","SPN_Description":"Switch that commands hydraulic pressure governor to decrease engine rpm to its idle position.\\r\\n\\r\\n00 Idle Switch Inactive\\r\\n01 Idle Switch Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6706":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":62,"SPN":6706,"SPN_Name":"Hydraulic Pressure Governor Preset Switch","SPN_Description":"Switch that commands hydraulic pressure governor to increase or decrease engine rpm to achieve a predefined discharge pressure.\\r\\n\\r\\n00 Preset Switch Inactive\\r\\n01 Preset Switch Active\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6707":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":24,"SPN":6707,"SPN_Name":"Hydraulic Intake Pressure","SPN_Description":"Hydraulic pressure measured at the intake of the hydraulic pump.","bit_length":16,"scaling":0.0001220703125,"offset":-1,"unit":"MPa","SLOT_ID":364},"6708":{"PGN":61448,"PGN_Name":"Hydraulic Pressure Governor Info","PGN_Description":"HPG","first_bit":40,"SPN":6708,"SPN_Name":"Hydraulic Discharge Pressure Set Point","SPN_Description":"Hydraulic pressure governing system discharge pressure set point.","bit_length":16,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":106},"6709":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":30,"SPN":6709,"SPN_Name":"Engine Speed High Lamp Command","SPN_Description":"Command signal directly controlling the Engine Speed High Warning lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6710":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":32,"SPN":6710,"SPN_Name":"Engine Speed Very High Lamp Command","SPN_Description":"Command signal directly controlling the Engine Speed Very High Warning lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6711":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":30,"SPN":6711,"SPN_Name":"Engine Speed High Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Speed High Warning Lamp.\\r\\n\\r\\n00 - Lamp Deactivated (Off)\\r\\n01 - Lamp Activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6712":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":32,"SPN":6712,"SPN_Name":"Engine Speed Very High Lamp Data","SPN_Description":"This parameter provides measured data from the Engine Speed Very High Warning Lamp.\\r\\n\\r\\n00 - Lamp Deactivated (Off)\\r\\n01 - Lamp Activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6715":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":16,"SPN":6715,"SPN_Name":"Engine Gaseous Fuel Supply Desired Pressure","SPN_Description":"Desired gage pressure of gaseous fuel supply to the engine.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"6716":{"PGN":64752,"PGN_Name":"Engine Fuel/lube systems 2","PGN_Description":"EFS2","first_bit":8,"SPN":6716,"SPN_Name":"Engine Fuel Filter (Suction Side) Degradation","SPN_Description":"The estimated percentage relative to the useful life of the engine fuel filter on the suction side which is located betwee the fuel tank and the fuel supply pump.\\r\\n\\r\\nNote:  This is not a calculation of the physical restriction of the filter. 0% is typical of a new filter. 100% is typical of an end of life filter, the filter should be replaced. The filter can operate past 100%.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6719":{"PGN":61550,"PGN_Name":"Fuel Pump Actuator Control Command","PGN_Description":"FPAC","first_bit":0,"SPN":6719,"SPN_Name":"Engine Fuel Injection Pump 1 Fuel Control Valve Command","SPN_Description":"The control command to fuel control valve in fuel pump 1, normalized to percent, where 0% represents fully closed and 100% represents fully open.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"6720":{"PGN":61550,"PGN_Name":"Fuel Pump Actuator Control Command","PGN_Description":"FPAC","first_bit":16,"SPN":6720,"SPN_Name":"Engine Fuel Injection Pump 2 Fuel Control Valve Command","SPN_Description":"The control command to fuel control valve in fuel pump 2, normalized to percent, where 0% represents fully closed and 100% represents fully open.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"6730":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":0,"SPN":6730,"SPN_Name":"Engine Fan 2 Requested Percent Speed","SPN_Description":"Fan speed of the second fan in the system as a ratio of the actual fan drive (current speed) to the fully engaged fan drive (maximum fan speed). A two state fan (off/on) will use 0% and 100% respectively.  A three state fan (off/intermediate/on) will use 0%, 50% and 100% respectively. A variable speed fan will use 0% to 100%. Multiple fan systems will use 0 to 100% to indicate the percent cooling capacity being provided. Feedback to this request is provided using the Estimated Percent Fan 2 Speed (see SPN 1550).\\r\\n\\r\\nNote that the intermediate fan speed of a three state fan will vary with different fan drives, therefore 50% is being used to indicate that the intermediate speed is required from the fan drive. Typically, the first fan in a system will be the fan closest to the radiator. The second fan will be located farthest from the radiator.\\r\\n\\r\\nSPN 986 shall be used for systems that have only one fan.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6731":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":62,"SPN":6731,"SPN_Name":"Joystick 1 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6732":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":60,"SPN":6732,"SPN_Name":"Joystick 1 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6733":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":58,"SPN":6733,"SPN_Name":"Joystick 1 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6734":{"PGN":64983,"PGN_Name":"Extended Joystick Message 1","PGN_Description":"EJM1","first_bit":56,"SPN":6734,"SPN_Name":"Joystick 1 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6735":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":62,"SPN":6735,"SPN_Name":"Joystick 2 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6736":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":60,"SPN":6736,"SPN_Name":"Joystick 2 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6737":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":58,"SPN":6737,"SPN_Name":"Joystick 2 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6738":{"PGN":64985,"PGN_Name":"Extended Joystick Message 2","PGN_Description":"EJM2","first_bit":56,"SPN":6738,"SPN_Name":"Joystick 2 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6739":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":62,"SPN":6739,"SPN_Name":"Joystick 3 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6740":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":60,"SPN":6740,"SPN_Name":"Joystick 3 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6741":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":58,"SPN":6741,"SPN_Name":"Joystick 3 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6742":{"PGN":64987,"PGN_Name":"Extended Joystick Message 3","PGN_Description":"EJM3","first_bit":56,"SPN":6742,"SPN_Name":"Joystick 3 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6743":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":62,"SPN":6743,"SPN_Name":"Joystick 4 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6744":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":60,"SPN":6744,"SPN_Name":"Joystick 4 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6745":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":58,"SPN":6745,"SPN_Name":"Joystick 4 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6746":{"PGN":64815,"PGN_Name":"Extended Joystick Message 4","PGN_Description":"EJM4","first_bit":56,"SPN":6746,"SPN_Name":"Joystick 4 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6747":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":62,"SPN":6747,"SPN_Name":"Joystick 5 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6748":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":60,"SPN":6748,"SPN_Name":"Joystick 5 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6749":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":58,"SPN":6749,"SPN_Name":"Joystick 5 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6750":{"PGN":64813,"PGN_Name":"Extended Joystick Message 5","PGN_Description":"EJM5","first_bit":56,"SPN":6750,"SPN_Name":"Joystick 5 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6751":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":62,"SPN":6751,"SPN_Name":"Joystick 6 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6752":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":60,"SPN":6752,"SPN_Name":"Joystick 6 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6753":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":58,"SPN":6753,"SPN_Name":"Joystick 6 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6754":{"PGN":64811,"PGN_Name":"Extended Joystick Message 6","PGN_Description":"EJM6","first_bit":56,"SPN":6754,"SPN_Name":"Joystick 6 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6755":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":62,"SPN":6755,"SPN_Name":"Joystick 7 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6756":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":60,"SPN":6756,"SPN_Name":"Joystick 7 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6757":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":58,"SPN":6757,"SPN_Name":"Joystick 7 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6758":{"PGN":64809,"PGN_Name":"Extended Joystick Message 7","PGN_Description":"EJM7","first_bit":56,"SPN":6758,"SPN_Name":"Joystick 7 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6759":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":62,"SPN":6759,"SPN_Name":"Joystick 8 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6760":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":60,"SPN":6760,"SPN_Name":"Joystick 8 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6761":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":58,"SPN":6761,"SPN_Name":"Joystick 8 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6762":{"PGN":64807,"PGN_Name":"Extended Joystick Message 8","PGN_Description":"EJM8","first_bit":56,"SPN":6762,"SPN_Name":"Joystick 8 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6763":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":62,"SPN":6763,"SPN_Name":"Joystick 9 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6764":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":60,"SPN":6764,"SPN_Name":"Joystick 9 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6765":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":58,"SPN":6765,"SPN_Name":"Joystick 9 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6766":{"PGN":64805,"PGN_Name":"Extended Joystick Message 9","PGN_Description":"EJM9","first_bit":56,"SPN":6766,"SPN_Name":"Joystick 9 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6767":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":62,"SPN":6767,"SPN_Name":"Joystick 10 Button 13 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6768":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":60,"SPN":6768,"SPN_Name":"Joystick 10 Button 14 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6769":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":58,"SPN":6769,"SPN_Name":"Joystick 10 Button 15 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6770":{"PGN":64803,"PGN_Name":"Extended Joystick Message 10","PGN_Description":"EJM10","first_bit":56,"SPN":6770,"SPN_Name":"Joystick 10 Button 16 Pressed Status","SPN_Description":"Reports when the joystick button has been pressed.\\r\\n\\n00 Button not pressed\\r\\n01 Button pressed\\r\\n10 Error Indicator\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6771":{"PGN":64652,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 1","PGN_Description":"AFT1PSI1","first_bit":0,"SPN":6771,"SPN_Name":"Aftertreatment 1 Particulate Sensor Resistance","SPN_Description":"This sensor is located in the exhaust stream somewhere after the DPF, but not necessarily immediately after the DPF.  It provides a resistance value that can be used to determine particulate matter in the exhaust stream. The value in this parameter is compensated to be the resistance at 200 degC.","bit_length":16,"scaling":1,"offset":0,"unit":"kohm","SLOT_ID":383},"6772":{"PGN":64652,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 1","PGN_Description":"AFT1PSI1","first_bit":16,"SPN":6772,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater State","SPN_Description":"The states of the particulate sensor heater.  The heater will change states from 11 to 10, 10 to 01, and 01 to 00 in a typical heating event.\\r\\n\\r\\n00 - Heater is in closed loop control\\r\\n01 - Heater is being held at a specified level\\r\\n10 - Heater is in ramp up mode\\r\\n11 - Heater is off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6773":{"PGN":64652,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 1","PGN_Description":"AFT1PSI1","first_bit":18,"SPN":6773,"SPN_Name":"Aftertreatment 1 Particulate Sensor Regeneration Status","SPN_Description":"The status of the most recent attempt of this power cycle to activate the particulate sensor regeneration process. This will not be updated until the regeneration is no longer active, as indicated by SPN 6774.\\r\\n\\r\\nPower cycle refers to the time that power has currently been applied to the ECU controlling the particulate sensor.\\r\\n\\r\\n00 -  Regeneration has not completed during this power cycle\\r\\n01 -  Regeneration was successful\\r\\n10 -  Regeneration failed\\r\\n11 -  Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6774":{"PGN":64652,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 1","PGN_Description":"AFT1PSI1","first_bit":20,"SPN":6774,"SPN_Name":"Aftertreatment 1 Particulate Sensor Regeneration State","SPN_Description":"Indicates if the particulate sensor regeneration is currently active, and if so, the reason for the regeneration.\\r\\n\\r\\n0000 - Regeneration is not active\\r\\n0001 - Regneration is active and has been initiated by request via SPN 6783\\r\\n0010 - Regeneration is active and has been initiated because of sensor conditions\\r\\n0011 - Regeneration is active and has been initiated due to time based conditions\\r\\n0100 to 1110 - SAE Reserved\\r\\n1111 - Not Available\\r\\n\\r\\nWhen the regeneration is no longer active, SPN 6773 will be updated to reflect the status of the regeneration.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6775":{"PGN":64652,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 1","PGN_Description":"AFT1PSI1","first_bit":24,"SPN":6775,"SPN_Name":"Aftertreatment 1 Particulate Sensor Active Accumulation Time","SPN_Description":"This is the amount of time since the last successful regeneration completed.  The sensor has been accumulating particulate matter since that time.","bit_length":16,"scaling":6,"offset":0,"unit":"s","SLOT_ID":384},"6776":{"PGN":64652,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 1","PGN_Description":"AFT1PSI1","first_bit":40,"SPN":6776,"SPN_Name":"Aftertreatment 1 Particulate Sensor Time Between Regenerations","SPN_Description":"This is the time between the last two successful regenerations of the particulate sensor for the current power cycle. This parameter reflects the time when the engine was running, not a duration based on a real time clock. If two successful particulate sensor regenerations have not ever occurred on this sensor during this power cycle, then this value shall be 0.","bit_length":16,"scaling":6,"offset":0,"unit":"s","SLOT_ID":384},"6777":{"PGN":64651,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 2","PGN_Description":"AFT1PSI2","first_bit":0,"SPN":6777,"SPN_Name":"Aftertreatment 1 Particulate Sensor Detection Status","SPN_Description":"Detection status of the particulate sensor\\r\\n\\r\\n0000 \u2013 Initialization for particulate matter detection\\r\\n0001 \u2013 Waiting for dew point (see SPN 6784)\\r\\n0010 \u2013 Particulate matter detection\\r\\n0011 \u2013 Heater is active for particulate sensor regeneration\\r\\n0100 \u2013 Cooling after particulate sensor regeneration\\r\\n0101 \u2013 Heater diagnostics test\\r\\n0110 \u2013 Relearning particulate sensor resistance after particulate sensor regeneration\\r\\n0111 \u2013 Sensor regeneration did not complete due to system parameters out of range (e.g., exhaust temperature out of range). Regeneration will restart once the values of the appropriate system parameters are conducive to regeneration.\\r\\n1000 \u2013 Halt particulate matter detection. An irrecoverable fault likely occurred. Will remain in this state until a manual fault clear or a new power cycle has started.\\r\\n1001 to 1110 \u2013 SAE Reserved\\r\\n1111 \u2013 Not supported\\r\\n\\r\\nPower Cycle refers to the time that power has currently been applied to the ECU controlling the particulate sensor.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6778":{"PGN":64651,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 2","PGN_Description":"AFT1PSI2","first_bit":4,"SPN":6778,"SPN_Name":"Aftertreatment 1 Particulate Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 1 particulate sensor has power applied to it. Note that this is referring to the power supplied to the sensor, not the power supplied to the controller connected to the sensor.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6779":{"PGN":64651,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 2","PGN_Description":"AFT1PSI2","first_bit":8,"SPN":6779,"SPN_Name":"Aftertreatment 1 Particulate Sensor Regeneration Failed Count","SPN_Description":"This is the number of times that the particulate sensor regeneration process has been attempted but failed to complete this power cycle.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"6780":{"PGN":64651,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 2","PGN_Description":"AFT1PSI2","first_bit":16,"SPN":6780,"SPN_Name":"Aftertreatment 1 Particulate Sensor Temperature","SPN_Description":"Temperature of the particulate sensor.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"6781":{"PGN":64651,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 2","PGN_Description":"AFT1PSI2","first_bit":32,"SPN":6781,"SPN_Name":"Aftertreatment 1 Particulate Sensor Maximum Resistance","SPN_Description":"This is the maximum resistance that the particulate sensor can measure.","bit_length":8,"scaling":250,"offset":0,"unit":"kohm","SLOT_ID":385},"6782":{"PGN":33792,"PGN_Name":"Aftertreatment 1 Particulate Sensor Control","PGN_Description":"AFT1PSC","first_bit":0,"SPN":6782,"SPN_Name":"Aftertreatment 1 Particulate Sensor Shutdown Request","SPN_Description":"Aftertreatment 1 particulate sensor shutdown request.\\r\\n\\r\\n00 - Shutdown request not active\\r\\n01 - Shutdown request active\\r\\n10 - SAE reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6783":{"PGN":33792,"PGN_Name":"Aftertreatment 1 Particulate Sensor Control","PGN_Description":"AFT1PSC","first_bit":2,"SPN":6783,"SPN_Name":"Aftertreatment 1 Particulate Sensor Regeneration Request","SPN_Description":"Another ECU would send this to request that the particulate sensor perform a regeneration of the sensor.  A request would be considered active when this parameter transitions from 00 to 01.\\r\\n\\r\\n00 - Regeneration not requested\\r\\n01 - Regeneration requested\\r\\n10 - SAE reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6784":{"PGN":33792,"PGN_Name":"Aftertreatment 1 Particulate Sensor Control","PGN_Description":"AFT1PSC","first_bit":4,"SPN":6784,"SPN_Name":"Aftertreatment 1 Particulate Sensor Dewpoint","SPN_Description":"Indicates that the temperature near the particulate sensor has exceeded the dew point.\\r\\n\\r\\n00 - Dewpoint has not been reached\\r\\n01 - Dewpoint has been reached\\r\\n10 - SAE reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6785":{"PGN":33792,"PGN_Name":"Aftertreatment 1 Particulate Sensor Control","PGN_Description":"AFT1PSC","first_bit":8,"SPN":6785,"SPN_Name":"Aftertreatment 1 Particulate Sensor Exhaust Temperature","SPN_Description":"This is the temperature in the exhaust stream that is closest to the particulate sensor. This could be a calculated value or read from another sensor. The ECU transmitting this message to the particulate sensor controller will be aware of the temperature sensor that is closest to the particulate sensor, whereas the particulate sensor may not be aware of the location.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"6787":{"PGN":64557,"PGN_Name":"Alternate Fuel 5","PGN_Description":"AF5","first_bit":0,"SPN":6787,"SPN_Name":"LNG Tank 1 Vapor Pressure","SPN_Description":"Gage pressure of the vapor in the first tank in a multi-tank system (or unique tank if single-tank system).","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6788":{"PGN":64557,"PGN_Name":"Alternate Fuel 5","PGN_Description":"AF5","first_bit":16,"SPN":6788,"SPN_Name":"LNG Tank 2 Vapor Pressure","SPN_Description":"Gage pressure of the vapor in the second tank in a multi-tank system.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6791":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":16,"SPN":6791,"SPN_Name":"Engine Dual Fuel Mode","SPN_Description":"Actual dual fuel mode, off or on.\\r\\n\\r\\n00 = Actual dual fuel mode off\\r\\n01 = Actual dual fuel mode on\\r\\n10 = Reserved\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6792":{"PGN":61496,"PGN_Name":"Engine Torque / Fuel Request","PGN_Description":"ETFR","first_bit":56,"SPN":6792,"SPN_Name":"Engine Dual Fuel Mode Command","SPN_Description":"Request to enable dual fuel mode.\\r\\n\\r\\n00 = De-activate dual fuel mode\\r\\n01 = Activate dual fuel mode\\r\\n10 = Reserved\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6793":{"PGN":64601,"PGN_Name":"Engine Load Sharing Information","PGN_Description":"ELS","first_bit":0,"SPN":6793,"SPN_Name":"Engine Unload Status","SPN_Description":"This signal indicates the status of an external request to unload the engine, such as the external unload request switch.\\r\\n\\r\\n00 - Not Requested\\r\\n01 - Requested\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6794":{"PGN":64601,"PGN_Name":"Engine Load Sharing Information","PGN_Description":"ELS","first_bit":2,"SPN":6794,"SPN_Name":"Engine Load Share Status","SPN_Description":"This signal indicates that the status of an engine load sharing feature.\\r\\n\\r\\n0000 - Offline\\r\\n0001 - Master\\r\\n0010 - Slave\\r\\n0011 - Loading\\r\\n0100 - Unloading\\r\\n0101 -1101 - Reserved\\r\\n1110 - Error\\r\\n1111 - Unavailable","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6796":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":32,"SPN":6796,"SPN_Name":"Engine Torque Curve Selection Command","SPN_Description":"This parameter will allow selection of a torque curve that is higher than the base curve.\\r\\n\\r\\n0 - Indicates that this parameter is not presently requesting a different torque curve be used\\r\\n1 - Indicates that Torque Curve 1 is selected\\r\\n2 - Indicates that Torque Curve 2 is selected\\r\\n3 to 13 - Indicates that Torque Curve 3 through 13 is selected\\r\\n14 - SAE reserved\\r\\n15 - Not supported","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6797":{"PGN":64831,"PGN_Name":"Aftertreatment 1 SCR Exhaust Gas Pressures","PGN_Description":"A1SCREGP","first_bit":40,"SPN":6797,"SPN_Name":"Aftertreatment 1 SCR Intake Absolute Pressure","SPN_Description":"Used to read the pressure at the catalyst intake of the selective catalytic reduction system of aftertreatment 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6798":{"PGN":64825,"PGN_Name":"Aftertreatment 2 SCR Exhaust Gas Pressures","PGN_Description":"A2SCREGP","first_bit":40,"SPN":6798,"SPN_Name":"Aftertreatment 2 SCR Intake Absolute Pressure","SPN_Description":"Used to read the pressure at the catalyst intake of the selective catalytic reduction system of aftertreatment 2.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6802":{"PGN":64514,"PGN_Name":"SCR System Information","PGN_Description":"SCRSI","first_bit":40,"SPN":6802,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Dosing System Frozen","SPN_Description":"All or part of the diesel exhaust fluid system (DEF tank, DEF supply lines, DEF pump, and DEF doser, etc.) in bank 1 is frozen.\\r\\n\\r\\nIn situations where it is desired to report the DEF system frozen as a faulted condition, FMI 31 can be used with this SPN in diagnostic messages. A value of 01 for this parameter does not necessarily mean that a faulted condition exists. But if this SPN is included in a DTC to report a faulted condition, such as the system is frozen and can\'t be thawed, then this parameter would be expected to be 01.\\r\\n\\r\\n00 \u2013 DEF system is not frozen\\r\\n01 \u2013 DEF system is frozen\\r\\n10 \u2013 Error\\r\\n11 \u2013 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6803":{"PGN":64514,"PGN_Name":"SCR System Information","PGN_Description":"SCRSI","first_bit":42,"SPN":6803,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Dosing System Frozen","SPN_Description":"All or part of the diesel exhaust fluid system (DEF tank, DEF supply lines, DEF pump, and DEF doser, etc.) in bank 2 is frozen.\\r\\n\\r\\nIn situations where it is desired to report the DEF system frozen as a faulted condition, FMI 31 can be used with this SPN in diagnostic messages. A value of 01 for this parameter does not necessarily mean that a faulted condition exists. But if this SPN is included in a DTC to report a faulted condition, such as the system is frozen and can\'t be thawed, then this parameter would be expected to be 01.\\r\\n\\r\\n00 \u2013 DEF system is not frozen\\r\\n01 \u2013 DEF system is frozen\\r\\n10 \u2013 Error\\r\\n11 \u2013 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6807":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":48,"SPN":6807,"SPN_Name":"Engine Desired Torque Request","SPN_Description":"This is the torque that the ECM desires to provide. It is a request made from the ECM to an external system. A valid value within the operating range indicates the engine is requesting an external controller to change the operation of the system so the engine can achieve a specific torque. This will most likely be accomplished by managing the load to the engine, but it is not limited to this method. A value of 0xFB indicates that the parameter is supported but there is no specific torque being requested by the engine.\\r\\n\\r\\nThis parameter is in indicated torque as a percent of the reference engine torque. See PGN 65251 for the engine configuration message. Any change in torque as a result of this parameter would be reflected in SPN 513.\\r\\n\\r\\nIn the event that an ECM transmits a valid value within the operating range for this parameter and a non-zero value for SPN 3644 at the same time, then the receiving controller should honor SPN 3644 and ignore this parameter.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"6808":{"PGN":65261,"PGN_Name":"Cruise Control/Vehicle Speed Setup","PGN_Description":"CCSS","first_bit":24,"SPN":6808,"SPN_Name":"Maximum Vehicle Speed Limit (High Resolution)","SPN_Description":"Maximum vehicle velocity allowed. See SPN 74 for an alternate resolution.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"6809":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":32,"SPN":6809,"SPN_Name":"Cruise Control Set Speed (High Resolution)","SPN_Description":"Value of set (chosen) velocity of velocity control system. See SPN 86 for an alternate resolution.\\r\\n\\r\\nIf an algorithm that can modify the cruise control set point exists in the system, such as Predictive Cruise Control or Adaptive Cruise Control, then Cruise Control Set Speed (SPN 6809) will not include the speed adjustment made by that algorithm. For the parameter that includes the adjustment, see Cruise Control Speed (SPN 7319) for the final speed used by the cruise control algorithm.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"6810":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":6,"SPN":6810,"SPN_Name":"Hybrid System OBD Related DTC Status","SPN_Description":"Signal from hybrid system indicating the status of OBD related DTCs\\r\\n\\r\\n00 - Hybrid System does not have an active OBD related DTC\\r\\n01 - Hybrid System has an active OBD related DTC\\r\\n10 - SAE Reserved\\r\\n11 - Not available\\r\\n\\r\\nSee \\"SPN 6810\\" in the supporting documentation tab for a description of the \\"Concept of Operation\\".","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6811":{"PGN":64600,"PGN_Name":"Turbocharger Information 7","PGN_Description":"TCI7","first_bit":0,"SPN":6811,"SPN_Name":"Engine Turbocharger 2 Lube Oil Pressure","SPN_Description":"Gage pressure of oil in the lubrication system for the 2nd turbocharger.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6812":{"PGN":64600,"PGN_Name":"Turbocharger Information 7","PGN_Description":"TCI7","first_bit":8,"SPN":6812,"SPN_Name":"Engine Turbocharger 3 Lube Oil Pressure","SPN_Description":"Gage pressure of oil in the lubrication system for the 3rd turbocharger.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6813":{"PGN":64600,"PGN_Name":"Turbocharger Information 7","PGN_Description":"TCI7","first_bit":16,"SPN":6813,"SPN_Name":"Engine Turbocharger 4 Lube Oil Pressure","SPN_Description":"Gage pressure of oil in the lubrication system for the 4th turbocharger.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6814":{"PGN":65277,"PGN_Name":"Alternate Fuel 1","PGN_Description":"AF1","first_bit":24,"SPN":6814,"SPN_Name":"Engine Gaseous Fuel Vent Pressure","SPN_Description":"Gaseous fuel pressure through a vent pipe.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"6815":{"PGN":64655,"PGN_Name":"Alternate Fuel 3","PGN_Description":"AF3","first_bit":24,"SPN":6815,"SPN_Name":"Gaseous Fuel Accumulator Temperature","SPN_Description":"Gaseous fuel temperature at the outlet of the Gas Filter.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6816":{"PGN":64735,"PGN_Name":"Engine Fluid Level/Pressure 12","PGN_Description":"EFL/P12","first_bit":32,"SPN":6816,"SPN_Name":"Engine Fuel Return Pressure","SPN_Description":"Used to read fuel (or gas) pressure passing through the return line.","bit_length":8,"scaling":1.64,"offset":-7,"unit":"kPa","SLOT_ID":246},"6817":{"PGN":64599,"PGN_Name":"SCR Operator Inducement Information 1","PGN_Description":"SCROII1","first_bit":0,"SPN":6817,"SPN_Name":"Diesel Exhaust Fluid Tank 1 Empty Time","SPN_Description":"Indicates the time the Diesel Exhaust Fluid Tank 1 Level is indicated as empty. This will accumulate over the life of the product and will never be reset.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6818":{"PGN":64599,"PGN_Name":"SCR Operator Inducement Information 1","PGN_Description":"SCROII1","first_bit":32,"SPN":6818,"SPN_Name":"Diesel Exhaust Fluid Quality Malfunction Time","SPN_Description":"Indicates the amount of time an error has been active due to detection of low Diesel Exhaust Fluid Quality. This will accumulate over the life of the product and will never be reset.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6819":{"PGN":64598,"PGN_Name":"SCR Operator Inducement Information 2","PGN_Description":"SCROII2","first_bit":0,"SPN":6819,"SPN_Name":"Aftertreatment SCR Malfunction Time","SPN_Description":"Indicates the amount of time an error condition has been active due to a malfunction in the Aftertreatment SCR system.\\r\\n\\r\\nThe source of the malfunction condition could be a component failure, detection of tampering, or other reason that prevents normal operation. This will accumulate over the life of the product and will never be reset.\\r\\n\\r\\nAlthough frozen DEF may prevent the Aftertreatment SCR system from operating normally, frozen DEF is not considered a malfunction for the purpose of this parameter. Refer to SPN 7938 for DEF frozen time.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6820":{"PGN":53248,"PGN_Name":"Cab Illumination Message","PGN_Description":"CL","first_bit":16,"SPN":6820,"SPN_Name":"Switch Indication Illumination Brightness Percent","SPN_Description":"Commanded switch indication illumination brightness level for all operator control switches. This is separate from the cab display illumination Brightness Percent parameter.\\r\\n\\r\\nNote: If a single device is used to control both the indication brightness level of the cab display and switches, see SPN 1487.  For switch backlight control, see SPN 5532.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6821":{"PGN":65133,"PGN_Name":"Heater Information","PGN_Description":"HTR","first_bit":40,"SPN":6821,"SPN_Name":"ADR Compliant Heater Installation","SPN_Description":"Indicates that the heater is installed in an ADR compliant vehicle.   \\r\\n\\r\\n00 -  Heater installation is not ADR compliant\\r\\n01 -  Heater installation is ADR compliant\\r\\n10 -  Error\\r\\n11 -  Not Available\\r\\n\\r\\nNote:  ADR is a European agreement concerning the international carriage of dangerous goods. developed by UN-ECE.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6829":{"PGN":33792,"PGN_Name":"Aftertreatment 1 Particulate Sensor Control","PGN_Description":"AFT1PSC","first_bit":24,"SPN":6829,"SPN_Name":"Aftertreatment 1 Particulate Sensor Exhaust Velocity","SPN_Description":"Velocity of the exhaust gas near the particulate sensor.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"6830":{"PGN":65180,"PGN_Name":"Main Bearing Temperature 3","PGN_Description":"MBT3","first_bit":48,"SPN":6830,"SPN_Name":"Engine Main Bearing 12 Temperature","SPN_Description":"Temperature of the main bearing which supports the crankshaft of the engine.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"6831":{"PGN":65246,"PGN_Name":"Engine Air Start Pressure","PGN_Description":"AIR2","first_bit":8,"SPN":6831,"SPN_Name":"Engine Air Start Pressure (Extended Range)","SPN_Description":"Gage pressure of air in an engine starting system that utilizes compressed air to provide the force required to rotate the crankshaft.\\r\\n\\r\\nSee SPN 82 for higher resolution.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa","SLOT_ID":49},"6832":{"PGN":65246,"PGN_Name":"Engine Air Start Pressure","PGN_Description":"AIR2","first_bit":16,"SPN":6832,"SPN_Name":"Engine Air Stop Pressure","SPN_Description":"Gage pressure of air in an engine stopping system that utilizes compressed air to provide the force required to stop the crankshaft. Engine stopping air is typically used for emergency engine stopping.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6833":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":2,"SPN":6833,"SPN_Name":"Engine Gaseous Fuel Usage Inhibited","SPN_Description":"Used to request that the engine should not be allowed to use gaseous fuel for engine cylinder combustion. This state is relevant for dual fuel systems and would be used when conditions are detected that make it unsafe or not appropriate to use gaseous fuel at that time.\\r\\n\\r\\n00 - Gaseous Fuel Usage Not Inhibited\\r\\n01 - Gaseous Fuel Usage Inhibited\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6834":{"PGN":64595,"PGN_Name":"Engine Gaseous Leakage Information","PGN_Description":"EGLI","first_bit":0,"SPN":6834,"SPN_Name":"Gaseous Fuel Leakage 1 Concentration","SPN_Description":"Percentage of detected gaseous fuel leak compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit. 0% means no detected gaseous fuel in measurement point. The measurement point is typically in the engine crankcase.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6835":{"PGN":64595,"PGN_Name":"Engine Gaseous Leakage Information","PGN_Description":"EGLI","first_bit":8,"SPN":6835,"SPN_Name":"Gaseous Fuel Leakage 2 Concentration","SPN_Description":"Percentage of detected gaseous fuel leak compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit. 0% means no detected gaseous fuel in measurement point. The second  measurement point is either another location in the engine crankcase or a separate leak detection point outside the engine.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6836":{"PGN":64595,"PGN_Name":"Engine Gaseous Leakage Information","PGN_Description":"EGLI","first_bit":16,"SPN":6836,"SPN_Name":"Gaseous Fuel Leakage 3 Concentration","SPN_Description":"Percentage of detected gaseous fuel leak compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit. 0% means no detected gaseous fuel in measurement point. The third measurement point is in a separate leak detection point outside the engine.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6837":{"PGN":64595,"PGN_Name":"Engine Gaseous Leakage Information","PGN_Description":"EGLI","first_bit":24,"SPN":6837,"SPN_Name":"Gas Leakage Detection 1 Pressure","SPN_Description":"Pressure measured in gas leakage detection point 1. Measured media is of the gas, meaning it could be air, inert gas, fuel air mixture or charge air mixture, depending on the failure mode detected. The measurement point is typically in the engine crankcase.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6838":{"PGN":64595,"PGN_Name":"Engine Gaseous Leakage Information","PGN_Description":"EGLI","first_bit":32,"SPN":6838,"SPN_Name":"Gas Leakage Detection 2 Pressure","SPN_Description":"Pressure measured in gas leakage detection point 2. Measured media is of the gas, meaning it could be air, inert gas, fuel air mixture or charge air mixture, depending on the failure mode detected. The second measurement point is either another location in the engine crankcase or a separate leak detection point outside the engine.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6839":{"PGN":64595,"PGN_Name":"Engine Gaseous Leakage Information","PGN_Description":"EGLI","first_bit":40,"SPN":6839,"SPN_Name":"Gas Leakage Detection 3 Pressure","SPN_Description":"Pressure measured in gas leakage detection point 3. Measured media is of the gas, meaning it could be air, inert gas, fuel air mixture or charge air mixture, depending on the failure mode detected. The third measurement point is in a separate leak detection point outside the engine.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6840":{"PGN":64594,"PGN_Name":"Bin Weight and Lift Count","PGN_Description":"BWLN","first_bit":8,"SPN":6840,"SPN_Name":"Bin Lift Count","SPN_Description":"Increments with each lift, whether or not net bin weight changes.  The count rolls over at data range limit.\\r\\n\\r\\nThe count can be reset using SPN 6898 in PGN 56832.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"6841":{"PGN":64594,"PGN_Name":"Bin Weight and Lift Count","PGN_Description":"BWLN","first_bit":24,"SPN":6841,"SPN_Name":"Net Bin Weight","SPN_Description":"Mass of bin contents at most recent unload","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"6842":{"PGN":64594,"PGN_Name":"Bin Weight and Lift Count","PGN_Description":"BWLN","first_bit":4,"SPN":6842,"SPN_Name":"Bin Weighing Error Status","SPN_Description":"Bin weighing error status\\r\\n\\r\\n0 = No error\\r\\n1 = Bad lift cycle\\r\\n2 = Weighing error: bin lifted, not emptied\\r\\n3 = Weighing error: empty bin lifted, emptied\\r\\n4 - 14 = Reserved\\r\\n15 = Not available / not applicable","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6843":{"PGN":64593,"PGN_Name":"Air Suspension Control 7","PGN_Description":"ASC7","first_bit":0,"SPN":6843,"SPN_Name":"Lift Axle 1 Status","SPN_Description":"Indicates the status of a tag axle 1.  Numbering of lift/tag axles starts at front axle.  SPN 1743 may be used if less detail is acceptable.\\r\\n\\r\\n000 - Down (tag axle is laden)\\r\\n001 - Unloading (load is being transferred from the tag axle)\\r\\n010 - Lifting (tag axle is moving up)\\r\\n011 - Up (tag axle is up and stationary)\\r\\n100 - Lowering (tag axle is moving down)\\r\\n101 - Loading (load is being transferred to the tag axle)\\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6844":{"PGN":64593,"PGN_Name":"Air Suspension Control 7","PGN_Description":"ASC7","first_bit":3,"SPN":6844,"SPN_Name":"Lift Axle 2 Status","SPN_Description":"Indicates the status of a tag axle 2.  Numbering of lift/tag axles starts at front axle.  SPN 1822 may be used if less detail is acceptable.\\r\\n\\r\\n000 - Down (tag axle is laden)\\r\\n001 - Unloading (load is being transferred from the tag axle)\\r\\n010 - Lifting (tag axle is moving up)\\r\\n011 - Up (tag axle is up and stationary)\\r\\n100 - Lowering (tag axle is moving down)\\r\\n101 - Loading (load is being transferred to the tag axle)\\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6845":{"PGN":64594,"PGN_Name":"Bin Weight and Lift Count","PGN_Description":"BWLN","first_bit":0,"SPN":6845,"SPN_Name":"Bin Instance","SPN_Description":"Gives the instance of the bin on the vehicle whose parameters are transmitted in the remainder of the PGN, with the first or only bin as instance 1.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"6846":{"PGN":64671,"PGN_Name":"Dash Display 2","PGN_Description":"DD2","first_bit":48,"SPN":6846,"SPN_Name":"Display Remain Powered","SPN_Description":"Indicates the ECU needs the display (i.e. monitor device) to continue to remain powered after ignition key off. An ECU would use this when the ECU needs the display to remain powered after key off so the ECU can communicate to the operator while the ECU is performing certain activities after key off, such as an aftertreatment regeneration.\\r\\n\\r\\nFunctionally, the display would remain powered after key off if it receives the \'Remain Powered\' status prior to the key off event and would continue to remain powered after key off while it continues to receive this parameter with the \'Remain Powered\' status or it stops receiving this parameter from the ECU.\\r\\n\\r\\nThe \'Remain Powered\' state indicates the ECU needs the monitor to remain powered after key off.\\r\\nThe \'OK to Shutoff\' state indicates the ECU does not need the monitor to stay powered after key off.\\r\\n\\r\\n00 = OK to Shutoff\\r\\n01 = Remain Powered\\r\\n10 = Reserved\\r\\n11 = Don\'t care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6847":{"PGN":64592,"PGN_Name":"Payload System Status","PGN_Description":"PLSS","first_bit":0,"SPN":6847,"SPN_Name":"Haul Cycle Count","SPN_Description":"A counter incremented by 1 with each instance of a new haul cycle, defined as a dump to dump cycle. The counter shall increment from 0 to 64255, rolling over to 0 on the next increment after 64255.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"6848":{"PGN":64592,"PGN_Name":"Payload System Status","PGN_Description":"PLSS","first_bit":16,"SPN":6848,"SPN_Name":"Haul Mode Status","SPN_Description":"The current operating state of the haul cycle.\\r\\n\\r\\n0000 - Not in Haul Mode\\r\\n0001 - Loading -- Payload is being added to the machine\\r\\n0010 - Approaching Loaded -- Machine is near its maximum capacity\\r\\n0011 - Loaded -- Loading operation has been completed\\r\\n0100 - Unloading -- Payload is being removed from the machine\\r\\n0101 - Unloaded -- Machine is empty\\r\\n0111 to 1011 - Reserved for Future Assignment by SAE\\r\\n1110 - Error\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6849":{"PGN":64592,"PGN_Name":"Payload System Status","PGN_Description":"PLSS","first_bit":24,"SPN":6849,"SPN_Name":"Delivered Payload Weight","SPN_Description":"The delivered payload mass during the last haul cycle. This is the amount of material moved and delivered by a machine is a key work cycle parameter.\\r\\n\\r\\nDelivered payload weight is defined as the last loaded weight less the carry back weight (material left in the machine after unloading).","bit_length":24,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":122},"6850":{"PGN":64592,"PGN_Name":"Payload System Status","PGN_Description":"PLSS","first_bit":48,"SPN":6850,"SPN_Name":"Delivered Payload Confidence","SPN_Description":"The level of confidence of the delivered payload weight measurement. Higher confidence values indicate greater probability the delivered payload weight is the actual weight and providing feedback on the potential for improving system accuracy.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6851":{"PGN":64996,"PGN_Name":"Equipment Performance Data","PGN_Description":"EPD","first_bit":8,"SPN":6851,"SPN_Name":"Payload Weight","SPN_Description":"The current payload weight carried by the machine.","bit_length":24,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":122},"6852":{"PGN":64996,"PGN_Name":"Equipment Performance Data","PGN_Description":"EPD","first_bit":32,"SPN":6852,"SPN_Name":"Payload Weight Confidence","SPN_Description":"The level of confidence of the real time payload weight measurement (SPN 6851). Higher confidence values indicate greater probability the real time payload weight is the actual weight and providing feedback on the potential for improving system accuracy.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6853":{"PGN":64996,"PGN_Name":"Equipment Performance Data","PGN_Description":"EPD","first_bit":40,"SPN":6853,"SPN_Name":"Payload Carry Back Weight","SPN_Description":"The payload weight left on the machine after the last payload dump event.","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"6854":{"PGN":64996,"PGN_Name":"Equipment Performance Data","PGN_Description":"EPD","first_bit":56,"SPN":6854,"SPN_Name":"Payload Capacity Percentage","SPN_Description":"The current equipment payload plus the weight of any after-factory modifications reported as a percentage of the equipment\'s maximum payload capacity. The equipment\'s maximum payload capacity is the maximum capacity of the equipment before the added weight of any after-factory modifications.\\r\\n\\r\\nThis differs from Payload Percentage (SPN 2600) as SPN 2600 is the current equipment payload reported as a percentage of the rated payload limit (i.e. payload reduced for added weight of any after-factory modification).\\r\\n\\r\\n0% = factory clean unloaded weight, 100% = fully loaded.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"6855":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":0,"SPN":6855,"SPN_Name":"Payload Weight Sensor 1 Status","SPN_Description":"Status of the payload system sensor 1 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6856":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":2,"SPN":6856,"SPN_Name":"Payload Weight Sensor 2 Status","SPN_Description":"Status of the payload system sensor 2 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6857":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":4,"SPN":6857,"SPN_Name":"Payload Weight Sensor 3 Status","SPN_Description":"Status of the payload system sensor 3 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6858":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":6,"SPN":6858,"SPN_Name":"Payload Weight Sensor 4 Status","SPN_Description":"Status of the payload system sensor 4 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6859":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":8,"SPN":6859,"SPN_Name":"Payload Weight Sensor 5 Status","SPN_Description":"Status of the payload system sensor 5 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6860":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":10,"SPN":6860,"SPN_Name":"Payload Weight Sensor 6 Status","SPN_Description":"Status of the payload system sensor 6 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6861":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":12,"SPN":6861,"SPN_Name":"Payload Weight Sensor 7 Status","SPN_Description":"Status of the payload system sensor 7 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6862":{"PGN":64591,"PGN_Name":"Payload Weight Sensor Information","PGN_Description":"PWSI","first_bit":14,"SPN":6862,"SPN_Name":"Payload Weight Sensor 8 Status","SPN_Description":"Status of the payload system sensor 8 measurement.\\r\\n\\r\\n00 = Sensor fully functional\\r\\n01 = Sensor degraded\\r\\n10 = Error (Sensor failed)\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6871":{"PGN":33536,"PGN_Name":"Payload Calibration Information Command","PGN_Description":"PCIC","first_bit":0,"SPN":6871,"SPN_Name":"Payload Calibration Set Point Command","SPN_Description":"Specifies the current payload point being calibrated. The data specified in the \'Payload Calibration Commanded Weight\' SPN (SPN 6872) or \'Payload Correction Factor Command\' SPN (SPN 6873) shall be used for calibrating this specified payload point. When used with the \'Payload Calibration Commanded Weight\' SPN (SPN 6872), it is possible to calibrate multiple points of the Payload Measurement system by loading the machine with up to 10 known calibration loads. When used with the Payload Correction Factor Command\' SPN (SPN 6873), it is possible to adjust the calibrations for multiple points of the Payload Measurement system by specifying the system gain.\\r\\n\\r\\nMultipoint calibration of the Payload Measurement system is perfomed by loading the machine with up to 10 known calibration loads. For each calibration load the Payload Calibration Information Command PGN is sent with Payload Calibration Set Point Command SPN identifying the calibration point and the Payload Calibration Commanded Weight SPN holding the value of the load.\\r\\n\\r\\nZero Point is used for empty which also sets the empty tare offset. End point identifies the last point.\\r\\n\\r\\n0000 = Zero Point\\r\\n0001 = Calibration Reference Point 1\\r\\n0010 = Calibration Reference Point 2\\r\\n0011 = Calibration Reference Point 3\\r\\n0100 = Calibration Reference Point 4\\r\\n0101 = Calibration Reference Point 5\\r\\n0110 = Calibration Reference Point 6\\r\\n0111 = Calibration Reference Point 7\\r\\n1000 = Calibration Reference Point 8\\r\\n1001 = Calibration Reference Point 9\\r\\n1010 = End Point\\r\\n1011 = Correction Point\\r\\n1100 = Reset Calibration\\r\\n1101 = Reserved\\r\\n1110 = Error\\r\\n1111 = Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6872":{"PGN":33536,"PGN_Name":"Payload Calibration Information Command","PGN_Description":"PCIC","first_bit":8,"SPN":6872,"SPN_Name":"Payload Calibration Commanded Weight","SPN_Description":"The true known mass of real load weight applicable for the calibration point specified in SPN 6871 and used for calibrating Payload system.\\r\\n\\r\\nMultipoint calibration of the Payload Measurement system is perfomed by loading the machine with up to 10 known calibration loads. For each calibration load the Payload Calibration Information Command PGN is sent with Payload Calibration Set Point Command SPN identifying the calibration point and the Payload Calibration Commanded Weight SPN holding the value of the load.","bit_length":16,"scaling":2,"offset":0,"unit":"kg","SLOT_ID":28},"6873":{"PGN":33536,"PGN_Name":"Payload Calibration Information Command","PGN_Description":"PCIC","first_bit":24,"SPN":6873,"SPN_Name":"Payload Correction Factor Command","SPN_Description":"The payload correction factor is used to fine tune the sensor gain value.\\r\\n\\r\\nCorrection factor calibration of the Payload Measurement system is performed through a Payload Calibration Set Point SPN value of Correction Point and the Payload Correction Factor SPN value set to modify the current gain of the system by the required amount in %.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"6874":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":8,"SPN":6874,"SPN_Name":"Performance Bias Selection","SPN_Description":"Indicates the operating bias toward performance of the power source.\\r\\n\\r\\n0% Functionality is biased toward fuel economy as much as possible.\\r\\n50% Functionality is biased toward neither fuel economy or performance.\\r\\n100% Functionality is biased toward performance as much as possible.\\r\\n\\r\\nFor values between 0% and 50%, functionality is biased toward fuel economy, with values closer to 0% indicating more bias toward fuel economy.\\r\\n\\r\\nFor values between 50% and 100%, functionality is biased toward performance, with values closer to 100% indicating more bias toward performance.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"6875":{"PGN":64590,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 3","PGN_Description":"A1SCRDSI3","first_bit":0,"SPN":6875,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser Pressure","SPN_Description":"The SCR dosing diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 1 (exhaust bank 1). This is the gage equivalent to SPN 4334.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6876":{"PGN":64589,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 3","PGN_Description":"A2SCRDSI3","first_bit":0,"SPN":6876,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Doser Pressure","SPN_Description":"The SCR dosing diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 2 (exhaust bank 2). This is the gage equivalent to SPN 4387.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"6877":{"PGN":64588,"PGN_Name":"SCR Operator Inducement Information 3","PGN_Description":"SCROII3","first_bit":0,"SPN":6877,"SPN_Name":"SCR Operator Inducement Override Enable","SPN_Description":"Indicates if an operator inducement derate is allowed to be overridden.\\r\\n\\r\\nNote: Inducement override is only allowed under certain conditions approved by EPA/ARB.\\r\\n\\r\\n00 Override not allowed\\r\\n01 Override allowed\\r\\n10 SAE Reserved\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6878":{"PGN":64588,"PGN_Name":"SCR Operator Inducement Information 3","PGN_Description":"SCROII3","first_bit":8,"SPN":6878,"SPN_Name":"SCR Operator Inducement Override Time Remaining","SPN_Description":"This parameter is used to indicate the time remaining during an operator inducement override event.  See also SPN 7344 for an alternate SLOT.\\r\\n\\r\\nWhen an operator inducement is not active, this parameter indicates the maximum time that an operator inducement may be overridden.  When an operator inducement is active this parameter indicates the remaining time that the currently\\r\\nactive operator inducement may be overridden.\\r\\n\\r\\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.","bit_length":16,"scaling":1,"offset":0,"unit":"s","SLOT_ID":64},"6879":{"PGN":64588,"PGN_Name":"SCR Operator Inducement Information 3","PGN_Description":"SCROII3","first_bit":24,"SPN":6879,"SPN_Name":"Number of SCR Operator Inducement Override Events Remaining","SPN_Description":"During an operator inducement event, the operator may be able to override the inducement multiple times. This parameter indicates the remaining number of times that the currently active inducement can be overridden during an operator inducement event. When this number has decremented to 0, then the operator can no longer override the current operator inducement event. \\r\\n\\r\\nThis value will reset to the maximum number of allowed overrides once the inducement event is no longer active.\\r\\n\\r\\nThis parameter shall never increment when an operator inducement is active.\\r\\n\\r\\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"6880":{"PGN":64588,"PGN_Name":"SCR Operator Inducement Information 3","PGN_Description":"SCROII3","first_bit":32,"SPN":6880,"SPN_Name":"Total Number of SCR Operator Inducement Override Events","SPN_Description":"Indicates total number of operator inducement override events activated throughout the lifetime of engine operation.\\r\\n\\r\\nThis number will remain at the maximum value once it is reached.\\r\\n\\r\\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"6881":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":16,"SPN":6881,"SPN_Name":"SCR Operator Inducement Override Switch","SPN_Description":"The position of the operator inducement override switch. This switch function allows the operator to override an operator inducement derate.\\r\\n\\r\\nSee EU Commission directive 2012/46/EU. Appendix 1 Section 5.5 for more information.\\r\\n\\r\\n00 Off\\r\\n01 On\\r\\n10 Error\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6884":{"PGN":64914,"PGN_Name":"Engine Operating Information","PGN_Description":"EOI","first_bit":46,"SPN":6884,"SPN_Name":"Engine Cold Ambient Elevated Idle Status","SPN_Description":"Indicates that the engine is elevating the idle speed due to cold strategies.\\r\\n\\r\\n00 No Idle Elevation Active - standard idle speed\\r\\n01 Idle Elevation Active\\r\\n10 Reserved for SAE assignment\\r\\n11 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6885":{"PGN":61709,"PGN_Name":"Fuel Information 6 (Gaseous)","PGN_Description":"GFI6","first_bit":0,"SPN":6885,"SPN_Name":"Engine Fuel Valve 2 Differential Pressure","SPN_Description":"The differential pressure between the intake and the outlet of the second gaseous fuel valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"6893":{"PGN":64587,"PGN_Name":"Electronic Engine Controller 17","PGN_Description":"EEC17","first_bit":0,"SPN":6893,"SPN_Name":"PEMS Engine Fuel Mass Flow Rate","SPN_Description":"PEMS Engine Fuel Mass Flow Rate shall indicate the amount of fuel consumed by the engine per unit of time (does not include fuel injected directly into the aftertreatment system, but does include fuel injected into the engine cylinders for the purpose of being used in the aftertreatment system), in grams per second.\\r\\n\\r\\nPEMS Engine Fuel Mass Flow Rate shall be calculated as the sum of the fuel consumed over the last one second prior to the time when PEMS Engine Fuel Mass Flow Rate is updated.\\r\\n\\r\\nNOTE: PEMS Engine Fuel Mass Flow Rate shall indicate zero g/s when the engine is not running.","bit_length":16,"scaling":0.02,"offset":0,"unit":"g/s","SLOT_ID":396},"6894":{"PGN":64587,"PGN_Name":"Electronic Engine Controller 17","PGN_Description":"EEC17","first_bit":16,"SPN":6894,"SPN_Name":"Vehicle Fuel Rate","SPN_Description":"Vehicle Fuel Rate shall indicate the amount of fuel consumed by the engine and fuel injected directly into the aftertreatment system per unit of time, in grams per second.\\r\\n\\r\\nVehicle Fuel Rate shall be calculated as the sum of the fuel consumed over the last 1 second prior to the time when Vehicle Fuel Rate is updated.\\r\\n\\r\\nNOTE: Vehicle Fuel Rate shall indicate zero g/s when the engine is not running.","bit_length":16,"scaling":0.02,"offset":0,"unit":"g/s","SLOT_ID":396},"6895":{"PGN":64587,"PGN_Name":"Electronic Engine Controller 17","PGN_Description":"EEC17","first_bit":32,"SPN":6895,"SPN_Name":"Engine Exhaust Flow Rate","SPN_Description":"Engine Exhaust Flow Rate shall indicate the measured/calculated exhaust gas mass flow upstream of the aftertreatment system.\\r\\n\\r\\nEngine Exhaust Flow Rate shall be calculated as the average exhaust flow rate over the last 1000 milliseconds prior to the time when Engine Exhaust Flow Rate is updated, multiplied by 3600 in order to convert the units from seconds to hours.\\r\\n\\r\\nNOTE: Engine Exhaust Flow Rate shall indicate zero kg/h when the engine is not running.\\r\\n\\r\\nSee SPN 7852 for alternative range.","bit_length":16,"scaling":0.2,"offset":0,"unit":"kg/h","SLOT_ID":397},"6896":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":32,"SPN":6896,"SPN_Name":"Engine Fueling Inhibit Request Count","SPN_Description":"A signal issued by the engine control system indicating the number of devices from which the engine control system has received a \u201Cfueling not desired\u201D request. Requests included in this count are either from an external device via SPN 5793 Desired Engine Fueling State equal to \u201C00 \u2013 Fueling not desired\u201D or from internal logic within the engine control system acting similar to an external request.\\r\\n\\r\\nMultiple engine internal requests are counted as a single device (the engine control system itself). Internal requests reflected in this parameter are limited to those with the intent of temporarily suspending engine operation.\\r\\n\\r\\nPermanent shutdown intent, for example from the key switch or engine protection logic, is not reflected in this signal. Operating states where the engine control system suspends fueling without the intent for temporary shutdown (i.e. motoring above minimum idle speed) are also not reflected in this signal.\\r\\n\\r\\n0 to 10    Number of active fueling inhibit requests\\r\\n11            More than 10 active fueling inhibit requests\\r\\n12 to 14  SAE Reserved\\r\\n15            Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6897":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":36,"SPN":6897,"SPN_Name":"Engine Fueling Desired Request Count","SPN_Description":"A signal issued by the engine control system indicating the number of devices from which the engine control system has received a \u201Cfueling desired\u201D request. Requests included in this count are either from an external device via SPN 5793 Desired Engine Fueling State equal to \u201C01 \u2013 Fueling desired\u201D or from internal logic within the engine control system acting similar to an external request.\\r\\n\\r\\nMultiple engine internal requests are counted as a single device (the engine control system itself). Internal requests reflected in this parameter are limited to those with the intent of preventing temporary suspension of engine operation.\\r\\n\\r\\nEngine internal \u201Cfueling desired\u201D requests that lead to the engine broadcasting SPN 5795  Engine Fueling Inhibit Allowed equal to \u201C00 - Engine currently will not stop fueling in response to SPN 5793 Desired Engine Fueling State\u201D, with reason given in SPN 5866 Engine Fueling Inhibit Prevented Reason and/or SPN 8145 Engine Fueling Inhibit Prevented Reason Extension are not reflected in this parameter.\\r\\n\\r\\n0 to 10             Number of active fueling desired requests\\r\\n11                    More than 10 active fueling desired requests\\r\\n12 to 14          SAE Reserved\\r\\n15                    Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"6898":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":24,"SPN":6898,"SPN_Name":"Bin Lift Count Reset","SPN_Description":"Used to reset the bin lift count as reported in PGN 64594.\\r\\n\\r\\n00 Do not reset\\r\\n01 Reset\\r\\n10 Reserved\\r\\n11 Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6899":{"PGN":64775,"PGN_Name":"Direct Lamp Control Command 1","PGN_Description":"DLCC1","first_bit":34,"SPN":6899,"SPN_Name":"Vehicle Acceleration Rate Limit Lamp Command","SPN_Description":"Command signal directly controlling the Vehicle Acceleration Rate Limit Lamp.\\r\\n\\r\\n00 - Lamp Off\\r\\n01 - Lamp On\\r\\n10 - Reserved\\r\\n11 - Not available\\r\\n\\r\\nNOTE: SPN 2979 is the original parameter used to provide vehicle acceleration rate limit status.  This parameter is intended for vehicle systems in which there is a lamp controller/arbitrator that requires direct lamp control (typically to an instrument cluster).  The effects of emission control limits, such as engine exhaust smoke control, are specifically excluded; they are not considered to be part of a function to limit vehicle acceleration.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6900":{"PGN":64773,"PGN_Name":"Direct Lamp Control Data 1","PGN_Description":"DLCD1","first_bit":34,"SPN":6900,"SPN_Name":"Vehicle Acceleration Rate Limit Lamp Data","SPN_Description":"This parameter provides measured data from the Vehicle Acceleration Rate Limit Lamp.\\r\\n\\r\\n00 - Lamp deactivated (Off)\\r\\n01 - Lamp activated (On)\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6914":{"PGN":64664,"PGN_Name":"Vehicle Speed Limiter","PGN_Description":"VSL","first_bit":40,"SPN":6914,"SPN_Name":"Soft Top Speed Limit Remaining Continuous Interval Distance","SPN_Description":"Indicates the remaining distance that the vehicle can continuously travel at the Soft Top Speed Limit.  This parameter will decrement while the Soft Top Speed Limit Active (SPN 6370) is 1 and will reset to its maximum allowed value when the Soft Top Speed Limit Active (SPN 6370) changes from inactive to active.","bit_length":16,"scaling":1,"offset":0,"unit":"km","SLOT_ID":270},"6915":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":0,"SPN":6915,"SPN_Name":"SCR System Cleaning Lamp Command","SPN_Description":"Command to control the SCR system cleaning lamp.\\r\\n\\r\\n000 Off\\r\\n001 On \u2013 solid\\r\\n010 reserved for SAE assignment \\r\\n011 reserved for SAE assignment\\r\\n100 On \u2013 fast blink (1 HZ)\\r\\n101 reserved for SAE assignment\\r\\n110 reserved for SAE assignment\\r\\n111 not available\\r\\n\\r\\nThis SPN would be \u201Coff\u201D when SCR system cleaning lamp is unlit.  The \\"on - solid\\" should indicate that the SCR system needs to be cleaned at the lowest level of urgency and that operator intervention is required.  The flashing state indicates a more severe condition requiring SCR system cleaning.  \\r\\n\\r\\nThis SPN shall not be used to convey information regarding operator switch feedback from SPNs 3695 and 3696.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6916":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":10,"SPN":6916,"SPN_Name":"SCR System Cleaning Status","SPN_Description":"Indicates the state of SCR system cleaning.  This is an aggregate of bank 1 and bank 2.  It is a system status and not individual bank status.\\r\\n\\r\\n00 not active\\r\\n01 active\\r\\n10 SCR system cleaning is needed - automatically initiated SCR system cleaning imminent\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6917":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":16,"SPN":6917,"SPN_Name":"SCR System Cleaning Inhibited Status","SPN_Description":"Indicates the state of SCR system cleaning inhibition.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning or will exit SCR system cleaning.\\r\\n\\r\\nIf the reason for inhibiting is not covered by SPNs 6918 thru 6932, a request for a status parameter should be submitted to the SAE Truck and Bus J1939 Request Processing Group to have the reason added.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6918":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":18,"SPN":6918,"SPN_Name":"SCR System Cleaning Inhibited Due to Inhibit Switch","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the SCR system cleaning Inhibit Switch.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6919":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":20,"SPN":6919,"SPN_Name":"SCR System Cleaning Inhibited Due to Clutch Disengaged","SPN_Description":"Indicates the state of SCR system cleaning event inhibition due to the clutch being disengaged.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6920":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":22,"SPN":6920,"SPN_Name":"SCR System Cleaning Inhibited Due to Service Brake Active","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the service brake being active.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6921":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":24,"SPN":6921,"SPN_Name":"SCR System Cleaning Inhibited Due to PTO Active","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the PTO being active.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6922":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":26,"SPN":6922,"SPN_Name":"SCR System Cleaning Inhibited Due to Accelerator Pedal Off Idle","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the accelerator pedal being off idle.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6923":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":28,"SPN":6923,"SPN_Name":"SCR System Cleaning Inhibited Due to Out of Neutral","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the accelerator pedal being out of neutral.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6924":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":30,"SPN":6924,"SPN_Name":"SCR System Cleaning Inhibited Due to Vehicle Speed Above Allowed Speed","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the vehicle speed being above an allowed limit.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6925":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":32,"SPN":6925,"SPN_Name":"SCR System Cleaning Inhibited Due to Parking Brake Not Set","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the parking brake being not set.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6926":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":34,"SPN":6926,"SPN_Name":"SCR System Cleaning Inhibited Due to Low Exhaust Temperature","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the exhaust temperature being too low.  This implies that the SCR system is too cold for cleaning.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6927":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":36,"SPN":6927,"SPN_Name":"SCR System Cleaning Inhibited Due to System Fault Active","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to a system fault being active.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6928":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":38,"SPN":6928,"SPN_Name":"SCR System Cleaning Inhibited Due to System Timeout","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to a system timeout.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6929":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":40,"SPN":6929,"SPN_Name":"SCR System Cleaning Inhibited Due to Temporary System Lockout","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to a temporary system lockout.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6930":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":42,"SPN":6930,"SPN_Name":"SCR System Cleaning Inhibited Due to Permanent System Lockout","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to a permanent system lockout.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6931":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":44,"SPN":6931,"SPN_Name":"SCR System Cleaning Inhibited Due to Engine Not Warmed Up","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the engine not being warmed up.\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6932":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":46,"SPN":6932,"SPN_Name":"SCR System Cleaning Inhibited Due to Vehicle Speed Below Allowed Speed","SPN_Description":"Indicates the state of SCR system cleaning inhibition due to the vehicle speed being less than the allowed vehicle speed.\\r\\r\\n\\r\\n00 not inhibited\\r\\n01 inhibited\\r\\n10 reserved for SAE assignment\\r\\n11 not available\\r\\n\\r\\nThis SPN indicates the reason for the SCR system cleaning event not being initiated or being exited prior to completion.  When this state becomes active, the system will not initiate an SCR system cleaning event or it will exit an SCR system cleaning event.  The state provides information that may be provided to the driver/service technician as to why the SCR system cleaning event did not initiate or was exited.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6933":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":48,"SPN":6933,"SPN_Name":"SCR System Cleaning Automatic Initiation Configuration","SPN_Description":"Indicates the configuration of SCR system cleaning automatic initiation.\\r\\n\\r\\n00 not enabled\\r\\n01 enabled\\r\\n10 reserved for SAE assignment\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6934":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":53,"SPN":6934,"SPN_Name":"SCR System Cleaning Forced Status","SPN_Description":"Indicates the forced execution status of SCR system cleaning.\\r\\n\\r\\n000 Not Active\\r\\n001 Active \u2013 Forced by Switch (See SPN 3696)\\r\\n010 Active \u2013 Forced by Service Tool \\r\\n011 Reserved for SAE Assignment\\r\\n100 Reserved for SAE Assignment\\r\\n101 Reserved for SAE Assignment\\r\\n110 Reserved for SAE Assignment\\r\\n111 not available\\r\\n\\r\\nThis SPN indicates the forced execution status of SCR system cleaning.  The SPN would be \u201CNot Active\u201D when the execution of SCR system cleaning has not been forced.  Either of the states \u201CActive \u2013 Forced by Switch\u201D and \u201CActive \u2013 Forced by Service Tool\u201D will be active when execution of SCR system cleaning is forced, providing feedback as to which entity forced the execution of SCR system cleaning.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"6935":{"PGN":64585,"PGN_Name":"Aftertreatment 1 Historical Information 2","PGN_Description":"AT1HI2","first_bit":0,"SPN":6935,"SPN_Name":"Aftertreatment 1 SCR System Total Cleaning Time","SPN_Description":"Total amount of time that a cleaning event has been active in the SCR system in bank 1 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6936":{"PGN":64585,"PGN_Name":"Aftertreatment 1 Historical Information 2","PGN_Description":"AT1HI2","first_bit":32,"SPN":6936,"SPN_Name":"Aftertreatment 1 SCR System Total Number of System Cleaning Events","SPN_Description":"Total number of cleaning events that have occurred on the SCR system in bank 1 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"6937":{"PGN":64585,"PGN_Name":"Aftertreatment 1 Historical Information 2","PGN_Description":"AT1HI2","first_bit":64,"SPN":6937,"SPN_Name":"Aftertreatment 1 SCR System Total Number of System Cleaning Inhibit Requests","SPN_Description":"Total number of cleaning inhibit requests on the SCR system in bank 1 by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"6938":{"PGN":64585,"PGN_Name":"Aftertreatment 1 Historical Information 2","PGN_Description":"AT1HI2","first_bit":96,"SPN":6938,"SPN_Name":"Aftertreatment 1 SCR System Total Number of System Cleaning Manual Requests","SPN_Description":"Total number of manual cleaning requests on the SCR system in bank 1 by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"6939":{"PGN":64585,"PGN_Name":"Aftertreatment 1 Historical Information 2","PGN_Description":"AT1HI2","first_bit":128,"SPN":6939,"SPN_Name":"Aftertreatment 1 SCR System Average Time Between System Cleaning Events","SPN_Description":"Indicates the average time since last reset between cleaning events for the SCR system in bank 1.\\r\\n \\r\\nIf the manufacturer allows this parameter to be reset, this time is the average since last reset.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6940":{"PGN":64585,"PGN_Name":"Aftertreatment 1 Historical Information 2","PGN_Description":"AT1HI2","first_bit":160,"SPN":6940,"SPN_Name":"Aftertreatment 1 SCR System Average Distance Between System Cleaning Events","SPN_Description":"Indicates the average distance since last reset between cleaning events for the SCR system in bank 1.\\r\\n\\r\\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"6941":{"PGN":64697,"PGN_Name":"Aftertreatment 1 Service 2","PGN_Description":"AT1S2","first_bit":32,"SPN":6941,"SPN_Name":"Aftertreatment 1 SCR System Time Since Last System Cleaning Event","SPN_Description":"Indicates the time since the last cleaning event of the SCR system in bank 1.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6942":{"PGN":64584,"PGN_Name":"Aftertreatment 2 Historical Information 2","PGN_Description":"AT2HI2","first_bit":0,"SPN":6942,"SPN_Name":"Aftertreatment 2 SCR System Total System Cleaning Time","SPN_Description":"Total amount of time that a cleaning event has been active in the SCR system in bank 2 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6943":{"PGN":64584,"PGN_Name":"Aftertreatment 2 Historical Information 2","PGN_Description":"AT2HI2","first_bit":32,"SPN":6943,"SPN_Name":"Aftertreatment 2 SCR System Total Number of System Cleaning Events","SPN_Description":"Total number of cleaning events that have occurred on the SCR system in bank 2 over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"6944":{"PGN":64584,"PGN_Name":"Aftertreatment 2 Historical Information 2","PGN_Description":"AT2HI2","first_bit":64,"SPN":6944,"SPN_Name":"Aftertreatment 2 SCR System Total Number of System Cleaning Inhibit Requests","SPN_Description":"Total number of cleaning inhibit requests on the SCR system in bank 2 by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"6945":{"PGN":64584,"PGN_Name":"Aftertreatment 2 Historical Information 2","PGN_Description":"AT2HI2","first_bit":96,"SPN":6945,"SPN_Name":"Aftertreatment 2 SCR System Total Number of System Cleaning Manual Requests","SPN_Description":"Total number of manual cleaning requests on the SCR system in bank 2 by the operator over the lifetime of the device.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"6946":{"PGN":64584,"PGN_Name":"Aftertreatment 2 Historical Information 2","PGN_Description":"AT2HI2","first_bit":128,"SPN":6946,"SPN_Name":"Aftertreatment 2 SCR System Average Time Between System Cleaning Events","SPN_Description":"Indicates the average time since last reset between cleaning events for the SCR system in bank 2.\\r\\n\\r\\nIf the manufacturer allows this parameter to be reset, this time is the average since last reset.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6947":{"PGN":64584,"PGN_Name":"Aftertreatment 2 Historical Information 2","PGN_Description":"AT2HI2","first_bit":160,"SPN":6947,"SPN_Name":"Aftertreatment 2 SCR System Average Distance Between System Cleaning Events","SPN_Description":"Indicates the average distance since last reset between cleaning events for the SCR system in bank 2.\\r\\n\\r\\nIf the manufacturer allows this parameter to be reset, this distance is the average since last reset.","bit_length":32,"scaling":0.125,"offset":0,"unit":"km","SLOT_ID":36},"6948":{"PGN":64696,"PGN_Name":"Aftertreatment 2 Service 2","PGN_Description":"AT2S2","first_bit":32,"SPN":6948,"SPN_Name":"Aftertreatment 2 SCR System Time Since Last System Cleaning Event","SPN_Description":"Indicates the time since the last cleaning event of the SCR system in bank 2.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"6949":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":0,"SPN":6949,"SPN_Name":"Number of Axles on the Vehicle","SPN_Description":"The number of axles monitored for tire parameters. A maximum of 12 axles is defined.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6950":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":8,"SPN":6950,"SPN_Name":"Number of Tires on the Vehicle","SPN_Description":"The total number of tires monitored for tire parameters. A maximum of 250 tires is defined.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"6951":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":16,"SPN":6951,"SPN_Name":"Axle 1 Monitored Tire Count","SPN_Description":"The number of tires on Axle 1 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6952":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":20,"SPN":6952,"SPN_Name":"Axle 2 Monitored Tire Count","SPN_Description":"The number of tires on Axle 2 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6953":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":24,"SPN":6953,"SPN_Name":"Axle 3 Monitored Tire Count","SPN_Description":"The number of tires on Axle 3 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6954":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":28,"SPN":6954,"SPN_Name":"Axle 4 Monitored Tire Count","SPN_Description":"The number of tires on Axle 4 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6955":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":32,"SPN":6955,"SPN_Name":"Axle 5 Monitored Tire Count","SPN_Description":"The number of tires on Axle 5 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6956":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":36,"SPN":6956,"SPN_Name":"Axle 6 Monitored Tire Count","SPN_Description":"The number of tires on Axle 6 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6957":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":40,"SPN":6957,"SPN_Name":"Axle 7 Monitored Tire Count","SPN_Description":"The number of tires on Axle 7 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6958":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":44,"SPN":6958,"SPN_Name":"Axle 8 Monitored Tire Count","SPN_Description":"The number of tires on Axle 8 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6959":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":48,"SPN":6959,"SPN_Name":"Axle 9 Monitored Tire Count","SPN_Description":"The number of tires on Axle 9 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6960":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":52,"SPN":6960,"SPN_Name":"Axle 10 Monitored Tire Count","SPN_Description":"The number of tires on Axle 10 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6961":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":56,"SPN":6961,"SPN_Name":"Axle 11 Monitored Tire Count","SPN_Description":"The number of tires on Axle 11 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6962":{"PGN":64583,"PGN_Name":"Monitored Tire Information","PGN_Description":"MTI","first_bit":60,"SPN":6962,"SPN_Name":"Axle 12 Monitored Tire Count","SPN_Description":"The number of tires on Axle 12 which are monitored by the tire monitor controller. The axle number increments from front to rear of the vehicle when facing the vehicle in the forward vehicle travel orientation. If the axle is not monitored by the tire monitor controller, then \u2018Not Available\u2019 value (0xF) should be reported.","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":395},"6973":{"PGN":33280,"PGN_Name":"Tire Configuration Command Information","PGN_Description":"TCCI","first_bit":0,"SPN":6973,"SPN_Name":"Tire Location","SPN_Description":"The location of monitored tire on the vehicle.\\r\\n\\r\\nThe high order 4 bits indicate the vehicle axle position of the tire, counting front to back on the vehicle, with the value 0 representing the front axle on the vehicle. If the upper 4 bits have a value of 0 to 13 it implies axle position, however 14 (0xE) would mean use these settings (other SPNs in tire configuration command information) for all axles.\\r\\n\\r\\nThe low order 4 bits indicate the position of the tire along the axle, counting left to right when facing in the direction of normal vehicle travel (forward), with the value 0 representing the left most tire position on the axle. If the lower 4 bits have a value of 0 to 13 it implies tire position along the axle, however 14 (0xE) would mean use these settings (other SPNs in tire configuration command information) for all tires on the specified axle.\\r\\n \\r\\nThe value 0xEE indicates configure all tires identically on all axles.\\r\\n\\r\\nThe value 0xFF indicates unavailable.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire 1 location of 0x00 indicates Tire 1 is the left front tire. Tire 1 Location of 0x23 indicates Tire 1 is on the 3rd axle, 4th tire from the left.","bit_length":8,"scaling":8,"offset":0,"unit":"bit-mapped","SLOT_ID":275},"6974":{"PGN":33280,"PGN_Name":"Tire Configuration Command Information","PGN_Description":"TCCI","first_bit":8,"SPN":6974,"SPN_Name":"Cold Inflation Pressure Setting","SPN_Description":"Configurable value of the cold inflation pressure of the tire. Cold inflation pressure is the default/reference inflation pressure suggested by the manufacturer for a specific tire.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"6975":{"PGN":33280,"PGN_Name":"Tire Configuration Command Information","PGN_Description":"TCCI","first_bit":24,"SPN":6975,"SPN_Name":"Under Pressure Percentage Threshold Setting","SPN_Description":"Configurable percent deviation from the set cold inflation pressure, for the under tire pressure alert.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6976":{"PGN":33280,"PGN_Name":"Tire Configuration Command Information","PGN_Description":"TCCI","first_bit":32,"SPN":6976,"SPN_Name":"Extreme Under Pressure Percentage Threshold Setting","SPN_Description":"Configurable percent deviation from the set cold inflation pressure, for the extreme under tire pressure alert.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6977":{"PGN":33280,"PGN_Name":"Tire Configuration Command Information","PGN_Description":"TCCI","first_bit":40,"SPN":6977,"SPN_Name":"Over Pressure Percentage Threshold Setting","SPN_Description":"Configurable percentage deviation from the set cold inflation pressure, for the over tire pressure alert.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6978":{"PGN":33280,"PGN_Name":"Tire Configuration Command Information","PGN_Description":"TCCI","first_bit":48,"SPN":6978,"SPN_Name":"Over Temperature Setting","SPN_Description":"Configurable constant temperature above which an over temperature alert will trigger.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6979":{"PGN":64579,"PGN_Name":"Tire Configuration Status Information","PGN_Description":"TCSI","first_bit":0,"SPN":6979,"SPN_Name":"Tire Location","SPN_Description":"The location of monitored tire on the vehicle.\\r\\n\\r\\nThe high order 4 bits indicate the vehicle axle position of the tire sensor, counting front to back on the vehicle, with the value 0 representing the front axle on the vehicle.\\r\\n\\r\\nThe low order 4 bits indicate the position of the tire sensor along the axle, counting left to right when facing in the direction of normal vehicle travel (forward), with the value 0 representing the left most tire sensor position on the axle.\\r\\n\\r\\nThe value 0xFF indicates not available.\\r\\n\\r\\nIt is recommended that output devices add 1 to the position number (range 1 to 15, not 0 to 14) for use by drivers and service technicians.\\r\\n\\r\\nExamples: Tire Sensor 1 location of 0x00 indicates Tire Sensor 1 is the left front tire sensor. Tire 1 Sensor Location of 0x23 indicates Tire Sensor 1 is on the 3rd axle, 4th tire from the left.","bit_length":8,"scaling":8,"offset":0,"unit":"bit-mapped","SLOT_ID":275},"6980":{"PGN":64579,"PGN_Name":"Tire Configuration Status Information","PGN_Description":"TCSI","first_bit":8,"SPN":6980,"SPN_Name":"Cold Inflation Pressure","SPN_Description":"The cold inflation pressure of the tire. Cold inflation pressure is the default/reference inflation pressure suggested by the manufacturer for a specific tire.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"6981":{"PGN":64579,"PGN_Name":"Tire Configuration Status Information","PGN_Description":"TCSI","first_bit":24,"SPN":6981,"SPN_Name":"Under Pressure Percentage Threshold","SPN_Description":"The percentage deviation from the set cold inflation pressure, for the under tire pressure alert.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6982":{"PGN":64579,"PGN_Name":"Tire Configuration Status Information","PGN_Description":"TCSI","first_bit":32,"SPN":6982,"SPN_Name":"Extreme Under Pressure Percentage Threshold","SPN_Description":"The percentage deviation from the set cold inflation pressure, for the extreme under tire pressure alert.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6983":{"PGN":64579,"PGN_Name":"Tire Configuration Status Information","PGN_Description":"TCSI","first_bit":40,"SPN":6983,"SPN_Name":"Over Pressure Percentage Threshold","SPN_Description":"The percentage deviation from the set cold inflation pressure, for the over tire pressure alert.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"6984":{"PGN":64579,"PGN_Name":"Tire Configuration Status Information","PGN_Description":"TCSI","first_bit":48,"SPN":6984,"SPN_Name":"Over Temperature","SPN_Description":"The temperature above which the over temperature alert will trigger.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"6985":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":26,"SPN":6985,"SPN_Name":"Tire Configuration Information","SPN_Description":"Command signal used to initiate change in the tire configuration of the vehicle system. On receipt of this reset, necessary changes will be made in the tire configuration command information.\\r\\n\\r\\n00 \u2013 Take No Action\\r\\n01 \u2013 Reset\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Not Applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6986":{"PGN":56832,"PGN_Name":"Reset","PGN_Description":"RESET","first_bit":28,"SPN":6986,"SPN_Name":"Tire Sensor Information","SPN_Description":"Command signal used to initiate change in the tire sensor identification information.\\r\\n\\r\\n00 Take no action\\r\\n01 Reset\\r\\n10 Reserved\\r\\n11 Not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6987":{"PGN":64578,"PGN_Name":"Tire Condition Message 2","PGN_Description":"TIRE2","first_bit":0,"SPN":6987,"SPN_Name":"Tire Location","SPN_Description":"Identifies which tire is associated with the parametric data in PGN 64578. Refer to SPN 929 for further details and examples. The low order 4 bits represent a position number, counting left to right when facing in the direction of normal vehicle travel (forward). The high order 4 bits represent a position number, counting front to back on the vehicle. The value 0xFF indicates not available.","bit_length":8,"scaling":8,"offset":0,"unit":"bit-mapped","SLOT_ID":275},"6988":{"PGN":64578,"PGN_Name":"Tire Condition Message 2","PGN_Description":"TIRE2","first_bit":8,"SPN":6988,"SPN_Name":"Tire Pressure (Extended Range)","SPN_Description":"Pressure at which air is contained in cavity formed by tire and rim. See SPN 241 for alternate tire pressure with a lower range and coarser resolution.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"6989":{"PGN":64578,"PGN_Name":"Tire Condition Message 2","PGN_Description":"TIRE2","first_bit":24,"SPN":6989,"SPN_Name":"Required Tire Pressure","SPN_Description":"The required tire pressure at which air is contained in cavity formed by tire and rim.\\r\\n\\r\\nThis pressure of the tire is compensated to meet the specific physical environmental conditions (temperature) of the vehicle.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"6990":{"PGN":65268,"PGN_Name":"Tire Condition Message 1","PGN_Description":"TIRE1","first_bit":38,"SPN":6990,"SPN_Name":"Extended Tire Pressure Support","SPN_Description":"Defines the choice of using the tire pressure (PGN 65268) or Extended Tire Pressure (PGN 64578). The state value \'01\' indicates the extended tire pressure SPN is used for the pressure data. Any other value indicates the extended tire pressure SPN is not being used.\\r\\n\\r\\n00 - Not Using Extended Tire Pressure\\r\\n01 - Using Extended Tire Pressure\\r\\n10 - Error\\r\\n11 - Not Available/Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6991":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":0,"SPN":6991,"SPN_Name":"Number of Engine Cylinders to Exclude from Combustion","SPN_Description":"Request to the engine ECU for the number of cylinders to exclude from combustion (cut-out or skip) for a given instance in time.  The engine ECU can decide on the cylinders to exclude from combustion.  One of the use cases would be sending this parameter at low engine loads.  If this parameter is set to 3 for a 6 cylinder engine, the receiving engine ECM would know the request is to exclude 3 of the 6 cylinders.\\r\\n\\r\\nIf the sending node is to specify the cylinders to exclude from combustion, use SPN 6992-7015 Engine Cylinder xx Exclude from Combustion Request.  Otherwise, those SPNs can be set to (0b11 - Do not care status).  Alternatively, the application can choose to ignore updating this SPN (0xFF to be sent), if specific cylinders are requested to be cut out.\\r\\n\\r\\nShould there be a discrepency between SPNs 6991 and the group of SPNs 6992-7015, the recepient will determine which has priority.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"6992":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":8,"SPN":6992,"SPN_Name":"Engine Cylinder 1 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 1 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6993":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":10,"SPN":6993,"SPN_Name":"Engine Cylinder 2 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 2 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6994":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":12,"SPN":6994,"SPN_Name":"Engine Cylinder 3 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 3 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6995":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":14,"SPN":6995,"SPN_Name":"Engine Cylinder 4 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 4 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6996":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":16,"SPN":6996,"SPN_Name":"Engine Cylinder 5 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 5 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6997":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":18,"SPN":6997,"SPN_Name":"Engine Cylinder 6 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 6 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6998":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":20,"SPN":6998,"SPN_Name":"Engine Cylinder 7 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 7 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"6999":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":22,"SPN":6999,"SPN_Name":"Engine Cylinder 8 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 8 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7000":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":24,"SPN":7000,"SPN_Name":"Engine Cylinder 9 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 9 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7001":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":26,"SPN":7001,"SPN_Name":"Engine Cylinder 10 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 10 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7002":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":28,"SPN":7002,"SPN_Name":"Engine Cylinder 11 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 11 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7003":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":30,"SPN":7003,"SPN_Name":"Engine Cylinder 12 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 12 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7004":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":32,"SPN":7004,"SPN_Name":"Engine Cylinder 13 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 13 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7005":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":34,"SPN":7005,"SPN_Name":"Engine Cylinder 14 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 14 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7006":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":36,"SPN":7006,"SPN_Name":"Engine Cylinder 15 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 15 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7007":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":38,"SPN":7007,"SPN_Name":"Engine Cylinder 16 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 16 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7008":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":40,"SPN":7008,"SPN_Name":"Engine Cylinder 17 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 17 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7009":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":42,"SPN":7009,"SPN_Name":"Engine Cylinder 18 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 18 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7010":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":44,"SPN":7010,"SPN_Name":"Engine Cylinder 19 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 19 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7011":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":46,"SPN":7011,"SPN_Name":"Engine Cylinder 20 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 20 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7012":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":48,"SPN":7012,"SPN_Name":"Engine Cylinder 21 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 21 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7013":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":50,"SPN":7013,"SPN_Name":"Engine Cylinder 22 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 22 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7014":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":52,"SPN":7014,"SPN_Name":"Engine Cylinder 23 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 23 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7015":{"PGN":61648,"PGN_Name":"Engine Cylinder Combustion Request","PGN_Description":"ECCR","first_bit":54,"SPN":7015,"SPN_Name":"Engine Cylinder 24 Exclude from Combustion Request","SPN_Description":"Request to the engine ECU to exclude (skip or cut-out) cylinder 24 from combustion.\\r\\n\\r\\n00 Exclude from Combustion\\r\\n01 Include for Combustion\\r\\n10 Reserved\\r\\n11 Not available/Do not care","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7016":{"PGN":64576,"PGN_Name":"Engine Hydraulic Fuel 2 Pump Status","PGN_Description":"EHF2PC","first_bit":0,"SPN":7016,"SPN_Name":"Engine Fuel 2 Pump Hydraulic Flow Control Valve","SPN_Description":"Position of hydraulic pump flow control valve opening; 0% = fully closed, 100% = fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7017":{"PGN":64576,"PGN_Name":"Engine Hydraulic Fuel 2 Pump Status","PGN_Description":"EHF2PC","first_bit":8,"SPN":7017,"SPN_Name":"Engine Fuel 2 Pump Hydraulic Swash Plate Angle","SPN_Description":"Position of hydraulic swash plate angle within hydraulic pump.  0% represents the lowest possible flow, 100% represents the maximum flow.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7018":{"PGN":64576,"PGN_Name":"Engine Hydraulic Fuel 2 Pump Status","PGN_Description":"EHF2PC","first_bit":16,"SPN":7018,"SPN_Name":"Engine Fuel 2 Pump Hydraulic Directional Valve","SPN_Description":"Position of hydraulic directional valve to control application of hydraulic oil flow.  0% is no flow to the appliance; 100% is full flow to the appliance.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7019":{"PGN":64576,"PGN_Name":"Engine Hydraulic Fuel 2 Pump Status","PGN_Description":"EHF2PC","first_bit":24,"SPN":7019,"SPN_Name":"Engine Fuel 2 Pump Hydraulic Pressure","SPN_Description":"Hydraulic pressure in the lines of the hydraulically driven fuel 2 pump.","bit_length":16,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":106},"7020":{"PGN":65277,"PGN_Name":"Alternate Fuel 1","PGN_Description":"AF1","first_bit":40,"SPN":7020,"SPN_Name":"LNG Vaporizer Coolant Outlet Temperature","SPN_Description":"Temperature of coolant at outlet of liquified natural gas vaporizer. This parameter is also used to determine if coolant has reached freezing temperature.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7021":{"PGN":64577,"PGN_Name":"Alternate Fuel 4","PGN_Description":"AF4","first_bit":0,"SPN":7021,"SPN_Name":"Engine Fuel 2 Injector Metering Rail 1 Pressure","SPN_Description":"The pressure of fuel 2 measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":106},"7022":{"PGN":64577,"PGN_Name":"Alternate Fuel 4","PGN_Description":"AF4","first_bit":16,"SPN":7022,"SPN_Name":"Engine Fuel 2 Injector Metering Rail 2 Pressure","SPN_Description":"The pressure of fuel 2 measured by first rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":106},"7023":{"PGN":64577,"PGN_Name":"Alternate Fuel 4","PGN_Description":"AF4","first_bit":32,"SPN":7023,"SPN_Name":"Engine Fuel 2 Injector Metering Rail 1 Temperature","SPN_Description":"The temperature of fuel 2 measured by first rail temperature sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7024":{"PGN":64577,"PGN_Name":"Alternate Fuel 4","PGN_Description":"AF4","first_bit":40,"SPN":7024,"SPN_Name":"Engine Fuel 2 Injector Metering Rail 2 Temperature","SPN_Description":"The temperature of fuel 2 measured by first rail temperature sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7025":{"PGN":64575,"PGN_Name":"Engine Turbocharger Control 2","PGN_Description":"ETCC2","first_bit":0,"SPN":7025,"SPN_Name":"Engine Staged Turbocharger Solenoid Status","SPN_Description":"Current state of the staged turbocharger solenoid, normalized to percent, 0% represents not actuated and 100% represents fully actuated.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7033":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":18,"SPN":7033,"SPN_Name":"Heat Exchanger Debris Purge Inhibit Switch","SPN_Description":"Indicates the state of a switch available to the operator that will inhibit the system from purging the debris from the heat exchanger.\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   error\\r\\n11   not available\\r\\n\\r\\nThis SPN would be \u201Cnot active\u201D when purging the debris from the heat exchanger is allowed to occur (purging the debris from the heat exchanger is not inhibited).\\r\\n\\r\\nThe ECU shall inhibit purging the debris from the heat exchanging when SPN 7033 is in the ON state.\\r\\n\\r\\nPurging the debris from the heat exchanger shall be activated by SPN 7034 when it is in the ON state and SPN 7033 is in the OFF state.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7034":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":20,"SPN":7034,"SPN_Name":"Heat Exchanger Debris Purge Force Switch","SPN_Description":"Indicates the state of a switch available to the operator that forces the system to purge the debris from the heat exchanger.\\r\\n\\r\\n00   not active\\r\\n01   active\\r\\n10   error\\r\\n11   not available\\r\\n\\r\\nThis SPN would be \u201Cnot active\u201D when purging the debris from the heat exchanger is requested by another algorithm, such as a time based purge (purging the debris from the heat exchanger is not being forced by the operator).\\r\\n\\r\\nThe ECU shall inhibit purging the debris from the heat exchanging when SPN 7033 is in the ON state.\\r\\n\\r\\nPurging the debris from the heat exchanger shall be activated by SPN 7034 when it is in the ON state and SPN 7033 is in the OFF state.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7035":{"PGN":64574,"PGN_Name":"Heat Exchanger Debris Purge Information","PGN_Description":"HEDPI","first_bit":0,"SPN":7035,"SPN_Name":"Heat Exchanger Debris Purge Status","SPN_Description":"Indicates whether the system is currently purging debris from the heat exchanger.\\r\\n\\r\\n00    Inactive\\r\\n01    Active\\r\\n10    SAE reserved\\r\\n11    Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7036":{"PGN":64574,"PGN_Name":"Heat Exchanger Debris Purge Information","PGN_Description":"HEDPI","first_bit":2,"SPN":7036,"SPN_Name":"Heat Exchanger Debris Purge Approaching","SPN_Description":"Status signal which indicates that purging the debris from the heat exchanger is imminent.\\r\\n\\r\\n00     Not approaching\\r\\n01     Approaching\\r\\n10     SAE reserved\\r\\n11     Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7037":{"PGN":7168,"PGN_Name":"Transmission Control 3","PGN_Description":"TC3","first_bit":0,"SPN":7037,"SPN_Name":"Transmission Override Control Mode","SPN_Description":"The override control mode defines the type of control mode used to control transmission operation.\\r\\n\\r\\n00 = Override disabled - Disable any existing control commanded by the source of this command.\\r\\n01 = Speed control - Control speed to the included \u201Cdesired speed\u201D value.\\r\\n10 = Torque control - Control torque to the included \u201Cdesired torque\u201D value.\\r\\n11 = Speed/torque limit control - Limit speed and/or torque based on the included limit values.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7038":{"PGN":7168,"PGN_Name":"Transmission Control 3","PGN_Description":"TC3","first_bit":2,"SPN":7038,"SPN_Name":"Transmission Override Control Mode Priority","SPN_Description":"This field is used as an input to the transmission to determine the priority of the Override Control Mode received in the Torque/Speed Control message.  The default is 11 (Low priority).  It is not required to use the same priority during the entire override function. \\r\\n\\r\\nThe four priority levels defined are:\\r\\n\\r\\n00 = Highest priority\\r\\n01 = High priority\\r\\n10 = Medium priority\\r\\n11 = Low priority\\r\\n\\r\\n00b - Highest Priority = Used for situations that require immediate action by the receiving device in order to provide safe vehicle operation. This level of priority should only be used in safety critical conditions.\\r\\n01b - High Priority = Used for control situations that require prompt action in order to provide safe vehicle operation.\\r\\n10b - Medium Priority = Used for powertrain control operations which are related to assuring that the vehicle is in a stable operating condition.\\r\\n11b - Low Priority = Used to indicate that the associated command desires powertrain control but is needed for function which may be overridden by other devices.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7039":{"PGN":7168,"PGN_Name":"Transmission Control 3","PGN_Description":"TC3","first_bit":8,"SPN":7039,"SPN_Name":"Transmission Requested Output Shaft Speed","SPN_Description":"Used to request output shaft speed of the transmission which has a output through a driveline to the wheels of a machine/vehicle.","bit_length":16,"scaling":0.25,"offset":-8031.75,"unit":"rpm","SLOT_ID":398},"7040":{"PGN":7168,"PGN_Name":"Transmission Control 3","PGN_Description":"TC3","first_bit":24,"SPN":7040,"SPN_Name":"Transmission Requested Torque / Torque Limit","SPN_Description":"Requested transmission output torque measured as a percentage of Transmission Reference Torque (SPN 7778). This is the output torque at which the transmission is expected to operate if the torque control mode is active or the output torque which the transmission shall not exceed if the torque limit mode is active.\\r\\n\\r\\nNote:  0% to 125% for (positive) powered torque requests, -125% to 0% for (negative) retarding torque requests.  Does not define rotational direction.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"7041":{"PGN":7168,"PGN_Name":"Transmission Control 3","PGN_Description":"TC3","first_bit":4,"SPN":7041,"SPN_Name":"Message Counter","SPN_Description":"The message counter is used to detect situations where the transmitting ECU malfunction repeats the same frame all the time.  The receiver of the information may use the counter parameter to detect this situation.  \\r\\n\\r\\nNote:  The initial value of the 4 bit message counter for the first message during a driving cycle is arbitrary. In every following message the counter is incremented by 1  (0 follows 15).","bit_length":4,"scaling":1,"offset":0,"unit":"count","SLOT_ID":220},"7042":{"PGN":7168,"PGN_Name":"Transmission Control 3","PGN_Description":"TC3","first_bit":56,"SPN":7042,"SPN_Name":"Message Checksum","SPN_Description":"The message checksum is used to verify the signal path from the transmitting device to the receiving device.\\r\\n \\r\\nThe message checksum is calculated using the first 7 data bytes, the message counter and the bytes of the message identifier. It is calculated as follows:\\r\\n\\r\\nMessage Checksum =  ((Byte 1 + Byte 2 + Byte 3 + Byte 4 + Byte 5 + Byte 6 + Byte 7 + Message ID low order byte + Message ID mid low byte + Message ID mid high byte + Message ID high order byte) & 0xFF)\\r\\n\\r\\nWhere\\r\\n  \\tMessage ID low order byte = Source Address from 29-bit header\\r\\n  \\tMessage ID mid low byte = PDU Specific (PS) from 29-bit header\\r\\n  \\tMessage ID mid high byte = PDU Format (PF) from 29-bit header\\r\\n  \\tMessage ID high order byte = 6 bits of \'0\' followed by EDP and DP bits from 29-bit header","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"7043":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":0,"SPN":7043,"SPN_Name":"Engine End Bearing 1 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 1 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7044":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":8,"SPN":7044,"SPN_Name":"Engine End Bearing 2 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 2 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7045":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":16,"SPN":7045,"SPN_Name":"Engine End Bearing 3 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 3 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7046":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":24,"SPN":7046,"SPN_Name":"Engine End Bearing 4 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 4 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7047":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":32,"SPN":7047,"SPN_Name":"Engine End Bearing 5 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 5 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7048":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":40,"SPN":7048,"SPN_Name":"Engine End Bearing 6 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 6 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7049":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":48,"SPN":7049,"SPN_Name":"Engine End Bearing 7 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 7 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7050":{"PGN":64573,"PGN_Name":"Engine End Bearing Temperature 1","PGN_Description":"EEBT1","first_bit":56,"SPN":7050,"SPN_Name":"Engine End Bearing 8 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 8 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7051":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":0,"SPN":7051,"SPN_Name":"Engine End Bearing 9 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 9 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7052":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":8,"SPN":7052,"SPN_Name":"Engine End Bearing 10 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 10 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7053":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":16,"SPN":7053,"SPN_Name":"Engine End Bearing 11 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 11 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7054":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":24,"SPN":7054,"SPN_Name":"Engine End Bearing 12 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 12 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7055":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":32,"SPN":7055,"SPN_Name":"Engine End Bearing 13 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 13 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7056":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":40,"SPN":7056,"SPN_Name":"Engine End Bearing 14 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 14 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7057":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":48,"SPN":7057,"SPN_Name":"Engine End Bearing 15 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 15 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7058":{"PGN":64572,"PGN_Name":"Engine End Bearing Temperature 2","PGN_Description":"EEBT2","first_bit":56,"SPN":7058,"SPN_Name":"Engine End Bearing 16 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 16 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7059":{"PGN":64571,"PGN_Name":"Engine End Bearing Temperature 3","PGN_Description":"EEBT3","first_bit":0,"SPN":7059,"SPN_Name":"Engine End Bearing 17 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 17 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7060":{"PGN":64571,"PGN_Name":"Engine End Bearing Temperature 3","PGN_Description":"EEBT3","first_bit":8,"SPN":7060,"SPN_Name":"Engine End Bearing 18 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 18 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7061":{"PGN":64571,"PGN_Name":"Engine End Bearing Temperature 3","PGN_Description":"EEBT3","first_bit":16,"SPN":7061,"SPN_Name":"Engine End Bearing 19 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 19 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7062":{"PGN":64571,"PGN_Name":"Engine End Bearing Temperature 3","PGN_Description":"EEBT3","first_bit":24,"SPN":7062,"SPN_Name":"Engine End Bearing 20 Temperature","SPN_Description":"Temperature of end bearing of the connecting rod for cylinder 20 on the engine","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7063":{"PGN":64570,"PGN_Name":"Gaseous Fuel Supply Pressure 1","PGN_Description":"GFSP1","first_bit":0,"SPN":7063,"SPN_Name":"Engine Gaseous Fuel Supply Pressure 2","SPN_Description":"Second gage pressure measurement of gaseous fuel supply to fuel metering device. If only one sensor is used for gas supply pressure measurement, use SPN 159 instead.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"7064":{"PGN":64570,"PGN_Name":"Gaseous Fuel Supply Pressure 1","PGN_Description":"GFSP1","first_bit":16,"SPN":7064,"SPN_Name":"Engine Gaseous Fuel Supply Unit Intake Pressure","SPN_Description":"Pressure of gaseous fuel supply measured at the intake of gaseous fuel supply unit. Gaseous fuel valve unit contains block and bleed valves to regulate the flow of gaseous fuel from the plant to engine.\\r\\n\\r\\nGas Supply Unit Intake Pressure","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"7065":{"PGN":64570,"PGN_Name":"Gaseous Fuel Supply Pressure 1","PGN_Description":"GFSP1","first_bit":32,"SPN":7065,"SPN_Name":"Engine Gaseous Fuel Supply Shutoff Valve 1 Intake Pressure","SPN_Description":"Pressure of gaseous fuel supply measured at shutoff valve 1 in gaseous fuel supply unit. Shutoff valves are used to regulate gaseous fuel supply to engine.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"7066":{"PGN":64570,"PGN_Name":"Gaseous Fuel Supply Pressure 1","PGN_Description":"GFSP1","first_bit":48,"SPN":7066,"SPN_Name":"Engine Gaseous Fuel Supply Shutoff Valve 2 Intake Pressure","SPN_Description":"Pressure of gaseous fuel supply measured at shutoff valve 2 in gaseous fuel supply unit. Shutoff valves are used to regulate gaseous fuel supply to engine.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"7067":{"PGN":64569,"PGN_Name":"Gaseous Fuel Supply Pressure 2","PGN_Description":"GFSP2","first_bit":0,"SPN":7067,"SPN_Name":"Plant Gaseous Fuel Supply Outlet Pressure","SPN_Description":"Pressure of the gaseous fuel supplied from the plant room for one or more engines.  Based on the application, plant room will contain fuel tank for gas, vaporizer and heater and cooler compartments.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"7068":{"PGN":64569,"PGN_Name":"Gaseous Fuel Supply Pressure 2","PGN_Description":"GFSP2","first_bit":16,"SPN":7068,"SPN_Name":"Plant Inert Gas Supply Outlet Pressure","SPN_Description":"Pressure of the purge gas supplied to the engine. Inert gas is used to remove gaseous fuel build-up in the engines and in the fuel supply lines when gaseous fuel is not in operation.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kPa","SLOT_ID":50},"7069":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":42,"SPN":7069,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 2","SPN_Description":"The Aftertreatment Diesel Exhaust Fluid Line Heater Relay 2 is used to energize one or more DEF line heaters.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7070":{"PGN":64651,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 2","PGN_Description":"AFT1PSI2","first_bit":40,"SPN":7070,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater Resistance","SPN_Description":"The resistance of the particulate sensor heater.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm","SLOT_ID":290},"7071":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":0,"SPN":7071,"SPN_Name":"Engine Oil Mist 1 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 1 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit, whereas 0% means no detected oil mist in the air. This measurement is typically taken in crankcase compartment. Note. For a V engine, 2 cylinders may share a compartment. Compartment 1 is referred to the one closer to flywheel of the engine.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7072":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":8,"SPN":7072,"SPN_Name":"Engine Oil Mist 2 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 2 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7073":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":16,"SPN":7073,"SPN_Name":"Engine Oil Mist 3 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 3 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7074":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":24,"SPN":7074,"SPN_Name":"Engine Oil Mist 4 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 4 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7075":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":32,"SPN":7075,"SPN_Name":"Engine Oil Mist 5 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 5 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7076":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":40,"SPN":7076,"SPN_Name":"Engine Oil Mist 6 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 6 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7077":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":48,"SPN":7077,"SPN_Name":"Engine Oil Mist 7 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 7 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7078":{"PGN":64568,"PGN_Name":"Engine Oil Mist Detection Information 1","PGN_Description":"EOMDI1","first_bit":56,"SPN":7078,"SPN_Name":"Engine Oil Mist 8 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 8 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7079":{"PGN":64567,"PGN_Name":"Engine Oil Mist Detection Information 2","PGN_Description":"EOMDI2","first_bit":0,"SPN":7079,"SPN_Name":"Engine Oil Mist 9 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 9 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7080":{"PGN":64567,"PGN_Name":"Engine Oil Mist Detection Information 2","PGN_Description":"EOMDI2","first_bit":8,"SPN":7080,"SPN_Name":"Engine Oil Mist 10 Concentration","SPN_Description":"Percentage of detected oil mist in compartment 10 compared to the lower explosion limit (LEL). 100% means the measured value is on the lower explosion limit,whereas 0% means no detected oil mist in the air.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7081":{"PGN":64566,"PGN_Name":"Gaseous Fuel Supply Valve Information","PGN_Description":"GFSVI","first_bit":0,"SPN":7081,"SPN_Name":"Engine Gaseous Fuel Supply Shutoff Valve 1 Position","SPN_Description":"Position of shutoff valve 1, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7082":{"PGN":64566,"PGN_Name":"Gaseous Fuel Supply Valve Information","PGN_Description":"GFSVI","first_bit":8,"SPN":7082,"SPN_Name":"Engine Gaseous Fuel Supply Shutoff Valve 2 Position","SPN_Description":"Position of shutoff valve 2, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7083":{"PGN":64566,"PGN_Name":"Gaseous Fuel Supply Valve Information","PGN_Description":"GFSVI","first_bit":16,"SPN":7083,"SPN_Name":"Engine Gaseous Fuel Supply Bleed Valve 1 Position","SPN_Description":"Position of bleed valve 1, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7084":{"PGN":64566,"PGN_Name":"Gaseous Fuel Supply Valve Information","PGN_Description":"GFSVI","first_bit":24,"SPN":7084,"SPN_Name":"Engine Gaseous Fuel Supply Bleed Valve 2 Position","SPN_Description":"Position of bleed valve 2, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7085":{"PGN":64566,"PGN_Name":"Gaseous Fuel Supply Valve Information","PGN_Description":"GFSVI","first_bit":32,"SPN":7085,"SPN_Name":"Engine Gaseous Fuel Supply Bleed Valve 3 Position","SPN_Description":"Position of bleed valve 3, which is used to control the flow of gaseous fuel through the fuel supply unit. 0% represents valve fully closed and 100% represents valve fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7086":{"PGN":64565,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump 1 Information","PGN_Description":"AT2P1I","first_bit":0,"SPN":7086,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump Heater","SPN_Description":"Percentage of heating applied to the aftertreatment 2 diesel exhaust fluid pump heater.  A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid pump heater warms the diesel exhaust fluid in the diesel exhaust fluid pump.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7087":{"PGN":61479,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 1","PGN_Description":"A2SCRDSR1","first_bit":56,"SPN":7087,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump Heater Command","SPN_Description":"Command for the Aftertreatment 2 Diesel Exhaust Fluid Pump Heater.  A value of 0% means no heating commanded, a value of 100% means full heating commanded.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7088":{"PGN":61649,"PGN_Name":"Engine Cylinder Head Bypass Actuator 1","PGN_Description":"ECBA1","first_bit":0,"SPN":7088,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Cylinder Head Bypass Actuator 1 by the manufacturer\'s software. When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine intake when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7089":{"PGN":61649,"PGN_Name":"Engine Cylinder Head Bypass Actuator 1","PGN_Description":"ECBA1","first_bit":5,"SPN":7089,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Temperature Status","SPN_Description":"Identifies the status of the Engine Cylinder Head Bypass Blowoff Actuator 1 drive circuitry temperature. Temperature excursions may affect the torque output.\\r\\n\\r\\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.\\r\\n\\r\\n000 - High Most severe\\r\\n001 - High Least severe\\r\\n010 - In Range\\r\\n011 - Low Least severe\\r\\n100 - Low Most severe\\r\\n101 - Not Defined\\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7090":{"PGN":61649,"PGN_Name":"Engine Cylinder Head Bypass Actuator 1","PGN_Description":"ECBA1","first_bit":8,"SPN":7090,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Temperature","SPN_Description":"Temperature of the Engine Cylinder Head Bypass Actuator 1 drive circuitry. Temperature excursions may affect the torque output.\\r\\n\\r\\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7091":{"PGN":61649,"PGN_Name":"Engine Cylinder Head Bypass Actuator 1","PGN_Description":"ECBA1","first_bit":16,"SPN":7091,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Desired Position","SPN_Description":"Requested position of Engine Cylinder Head Bypass actuator by engine ECM, where 0% represents bypass fully closed and 100% represents fully open. This is the position that the device is attempting to achieve.\\r\\n\\r\\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7092":{"PGN":61649,"PGN_Name":"Engine Cylinder Head Bypass Actuator 1","PGN_Description":"ECBA1","first_bit":24,"SPN":7092,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Position","SPN_Description":"Actual position of Engine Cylinder Head Bypass actuator, where 0% represents fully closed and 100% represents fully open.\\r\\n\\r\\nCylinder Head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7093":{"PGN":61649,"PGN_Name":"Engine Cylinder Head Bypass Actuator 1","PGN_Description":"ECBA1","first_bit":32,"SPN":7093,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Operation Status","SPN_Description":"Identifies the status of Engine Cylinder Head Bypass Actuator 1.\\r\\n\\r\\nCylinder head bypass valve is used to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.\\r\\n\\r\\n0000 - Normal\\r\\n0001 - Alarm (fully operational but needs service)\\r\\n0010 - Alarm High Severity (functional but transient performance may be reduced)\\r\\n0011 - Derate Active (torque output reduced due to environmental conditions)\\r\\n0100 - Controlled Shutdown Active (driving to the default position - usually this means closed)\\r\\n0101 - Uncontrolled Shutdown Active (no torque is being applied from the actuator)\\r\\n0110 - Calibration in Progress (must be broadcast at least once per calibration process defined in SPN 3464)\\r\\n0111 - 1101   Reserved for future assignment\\r\\n1110 - Error\\r\\n1111 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7094":{"PGN":61650,"PGN_Name":"Engine Electronic Controller 18","PGN_Description":"EEC18","first_bit":0,"SPN":7094,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Command","SPN_Description":"Command to cylinder head bypass actuator 1, normalized to percent, where 0% nominally represents fully closed (No Flow) and 100% represents fully open (Max Flow). The purpose of the cylinder bypass valve is to release the air at the high pressure compressor outlet into turbocharger turbine inlet when intake pressure exceeds exhaust pressure at lower engine speeds and thereby controlling compressure surge.\\r\\n\\r\\n0xFB00 - 0xFB64 is sent to calibrate to a specific position.  The LSB specifies the position with a resolution of 1%/bit  (eg, 0xFB32 is sent to calibrate the actuator to 50%).  \\r\\n\\r\\n0xFBFF is sent to calibrate the actuator using its own algorithm.  \\r\\n\\r\\nCalibration status from the actuator is received on SPN 7093.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7095":{"PGN":64598,"PGN_Name":"SCR Operator Inducement Information 2","PGN_Description":"SCROII2","first_bit":32,"SPN":7095,"SPN_Name":"SCR Operator Inducement Total Time","SPN_Description":"Indicates the time that operator inducement has been active. This will accumulate over the life of the product and will never be reset.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"7096":{"PGN":64564,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 2","PGN_Description":"EFIMRPI2","first_bit":0,"SPN":7096,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 1 Pressure 1 (Extended Range)","SPN_Description":"The pressure of fuel measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"7097":{"PGN":64564,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 2","PGN_Description":"EFIMRPI2","first_bit":16,"SPN":7097,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 1 Pressure 2 (Extended Range)","SPN_Description":"The pressure of fuel measured by the second rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"7098":{"PGN":64564,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 2","PGN_Description":"EFIMRPI2","first_bit":32,"SPN":7098,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 2 Pressure 1 (Extended Range)","SPN_Description":"The pressure of fuel measured by first rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"7099":{"PGN":64564,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 2","PGN_Description":"EFIMRPI2","first_bit":48,"SPN":7099,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 2 Pressure 2 (Extended Range)","SPN_Description":"The pressure of fuel measured by second rail pressure sensor in the metering rail 2 as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"7100":{"PGN":64563,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 3","PGN_Description":"EFIMRPI3","first_bit":0,"SPN":7100,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 1 Desired Pressure","SPN_Description":"The desired pressure of fuel in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"7101":{"PGN":64563,"PGN_Name":"Engine Fuel Injector Metering Rail Pressure Information 3","PGN_Description":"EFIMRPI3","first_bit":16,"SPN":7101,"SPN_Name":"Engine Fuel 1 Injector Metering Rail 2 Desired Pressure","SPN_Description":"The desired pressure of fuel in metering rail 2 as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"7104":{"PGN":65130,"PGN_Name":"Engine Fuel/Lube Systems","PGN_Description":"EFS","first_bit":56,"SPN":7104,"SPN_Name":"Engine Fuel Supply Pump Intake Pressure","SPN_Description":"Gage pressure of fuel at the fuel supply pump intake.  See Figures SPN16_A & SPN16_B.\\r\\n\\r\\nSee also SPN 1381.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"7107":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":44,"SPN":7107,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump","SPN_Description":"State of the aftertreatment 1 Diesel Exhaust Fluid dosing pump.  Indicates if the pump is currently active (pumping).  \\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nThe aftertreatment 1 Diesel Exhaust Fluid dosing pump is a device that delivers a pressurized DEF to the DEF injector. This can be mixed with or without pressurized air.\\r\\n\\r\\nNote:  SPN 5435 provides operational status of the pump.\\r\\n\\r\\nSee also SPN 3361 - Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit\\r\\n\\r\\nOn a system that does not have an electrically driven valve on the injector, \'DEF Dosing Unit\' is the only SPN needed as the pump is directly metering DEF into the exhaust stream. On a DEF system that has an electrically driven injector, the injector is actually metering the dosing quantity and the pump is just supplying pressure to the injector.  In the second case, the \\"DEF dosing unit\\" SPN would be used for the electrically driven injector and the \\"DEF Pump\\" SPN would be used for the pump supplying pressure to the injector.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7108":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":44,"SPN":7108,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump","SPN_Description":"State of the Aftertreatment 2 Diesel Exhaust Fluid dosing pump.  Indicates if the pump is currently active (pumping).  \\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nThe Aftertreatment 2 Diesel Exhaust Fluid dosing pump is a device that delivers a pressurized DEF to the DEF injector. This can be mixed with or without pressurized air.\\r\\n\\r\\nNote:  SPN 5438 provides operational status of the pump.\\r\\n\\r\\nSee also SPN 4451 - Aftertreatment 2 Diesel Exhaust Fluid Dosing Unit 1\\r\\n\\r\\nOn a system that does not have an electrically driven valve on the injector, \'DEF Dosing Unit\' is the only SPN needed as the pump is directly metering DEF into the exhaust stream. On a DEF system that has an electrically driven injector, the injector is actually metering the dosing quantity and the pump is just supplying pressure to the injector.  In the second case, the \\"DEF dosing unit\\" SPN would be used for the electrically driven injector and the \\"DEF Pump\\" SPN would be used for the pump supplying pressure to the injector.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7313":{"PGN":65172,"PGN_Name":"Engine Auxiliary Coolant","PGN_Description":"EAC","first_bit":32,"SPN":7313,"SPN_Name":"Engine Coolant Pressure 2 (Extended Range)","SPN_Description":"Gage pressure of liquid found in engine coolant system - second instance.\\r\\n\\r\\nSee also SPN 5708 for alternate range and resolution.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"7314":{"PGN":64713,"PGN_Name":"Engine Fuel/Throttle Valve Information 2","PGN_Description":"EF/TVI2","first_bit":40,"SPN":7314,"SPN_Name":"Engine Fuel Rack Fuel Supply Temperature","SPN_Description":"Temperature of fuel in the engine fuel rack.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7315":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":8,"SPN":7315,"SPN_Name":"Propulsion System Active","SPN_Description":"Indicates when the hybrid system is ready to provide or is actively providing propulsion as defined in ARB regulation 13CCR1971.1, which includes the amendments up to the Board hearing date of August 2012. This parameter is called out by the 1971.1 regulation in several areas including, but not limited to: the ignition cycle counter [1971.1 paragraphs (d)(5.5.2)(B) and (d)(5.5.2)(C)], permanent fault code erasure  [(d)(2.3.1)(C)(ii)b.3.v], and denominator incrementing [(d)(4.3.2)(J)(i)] requirements. For example, \\"for hybrid vehicles, \'ignition cycle\' means a driving cycle that begins when the propulsion system active definition is met for at least two seconds plus or minus one second, and ends when the propulsion system active definition is no longer met.\u201D\\r\\n\\r\\nNOTE: The parameter name contains the word \u201Cactive\u201D so that it matches the naming in the ARB regulation. However, this parameter not only indicates that the hybrid system is actively aiding or retarding vehicle motion (i.e., generating any positive or negative torque on the driveline); it also shall be asserted when the hybrid system is ready to participate in such activities if vehicle conditions or operator input warrant. Therefore, this parameter is asserted when the vehicle is ready to provide propulsion (e.g., vehicle is ready to be driven, ready to be shifted from \u201Cpark\u201D to \u201Cdrive\u201D) and doesn\u2019t change state again until the system is neither ready to provide, nor actively providing, propulsion.\\r\\n\\r\\nThis parameter is required for hybrid vehicles because there is a difference between a conventional vehicle, where powertrain readiness is equivalent to \u201CEngine Running\u201D, and a hybrid vehicle, where the engine may or may not be running and yet the vehicle could move. However, if the engine is running (engine speed is nonzero), this parameter shall be set to 1. If the engine speed is zero, then this parameter shall be set based on the hybrid system operating state. For heavy duty vehicles, the hybrid system needs to inform the OBD related components of its propulsion active or readiness state to allow the components to perform OBD related functions.\\r\\n\\r\\nPropulsion System Active cannot be used as an indication of propulsion availability as it is required to indicate \u201Cactive\u201D whenever the engine is running.  This is regardless of the hybrid system\u2019s ability to provide propulsion power.  See SPN 8267 for an indication of hybrid system propulsion availability.\\r\\r\\n\\r\\nThis message is intended to be used by the Hybrid System Controller to communicate to other OBD related components (e.g engine) the status of the overall hybrid system. It should not be sent by individual hybrid system components (e.g. batteries, inverters, etc.)\\r\\n\\r\\n00 - Propulsion System is not ready to move vehicle if commanded by operator\\r\\n01 - Propulsion System is ready to move, or is moving the vehicle as commanded by operator\\r\\n10 - SAE Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7316":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":0,"SPN":7316,"SPN_Name":"Predictive Cruise Control Set Speed Offset","SPN_Description":"The amount by which the actual set point used by the cruise control algorithm should be changed as determined by external factors (e.g., anticipated road grade).\\r\\n\\r\\nIf SPN 7317 indicates Enabled (0001b) and if the cruise control algorithm determines that the offset will be honored, then the value in SPN 7316 will be added to the Cruise Control Set Speed indicated by SPN 86 (also SPN 6809). This sum will be the present set point used by the cruise control algorithm.\\r\\n\\r\\nIf the cruise control algorithm determines that the offset will not be honored, then the cruise control set point is the value in SPN 86 (and SPN 6809).\\r\\n\\r\\nSPN 86 and SPN 6809 both reflect the selected cruise control set speed; they do not include the offset in SPN 7316. See Cruise Control Speed (SPN 7319) for a parameter that will include the offset in SPN 7316.","bit_length":16,"scaling":0.00390625,"offset":-125,"unit":"km/h","SLOT_ID":399},"7317":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":16,"SPN":7317,"SPN_Name":"Predictive Cruise Control State","SPN_Description":"Indicates the state of the PCC controller.\\r\\n\\r\\nIf this parameter is 0001, the cruise control set point may be modified by the Predictive Cruise Control Set Speed Offset (SPN 7316) . For states other than 0001, the value in Predictive Cruise Control Set Speed Offset (SPN 7316) shall be ignored.\\r\\n\\r\\nPredictive Cruise Control Set Speed Offset Status (SPN 7318) will indicate of the cruise control algorithm has adjusted its set point by the value specified in Predictive Cruise Control Set Speed Offset (SPN 7316).\\r\\n\\r\\nIn the event that more than one reason for not being functional (0010 to 1000) is active at the same time, it is up to the manufacturer to decide which reason is reported. It is expected that 0111 (inhibited by driver) would have priority over the other states that indicate non-functional.\\r\\n\\r\\n0000 Disabled\\r\\n0001 Enabled\\r\\n0010 Enabled, but not functional due to vehicle position not available\\r\\n0011 Enabled, but not functional due to map position not available\\r\\n0100 Enabled, but not functional due to road grade info not available\\r\\n0101 Enabled, but not functional due to predicted path not available\\r\\n0110 Enabled, but not functional due to vehicle speed below speed threshold\\r\\n0111 Enabled, but not functional due to inhibited by driver\\r\\n1000 Enabled, but not functional due to self test\\r\\n1001 to 1101 SAE Reserved\\r\\n1110 Error\\r\\n1111 Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7318":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":5,"SPN":7318,"SPN_Name":"Predictive Cruise Control Set Speed Offset Status","SPN_Description":"This parameter indicates if the cruise control algorithm is currently adding the value in Predictive Cruise Control Set Speed Offset (SPN 7316) to the Cruise Control Set Speed (SPN 86 or SPN 6809) for its set point. The final set point will be reported in Cruise Control Speed (SPN 7319).\\r\\n\\r\\n00 Cruise Control Speed (SPN 7319) does not include Predictive Cruise Control Set Speed Offset (SPN 7316)\\r\\n01 Cruise Control Speed (SPN 7319) includes Predictive Cruise Control Set Speed Offset (SPN 7316)\\r\\n10 SAE Reserved\\r\\n11 Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7319":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":48,"SPN":7319,"SPN_Name":"Cruise Control Speed","SPN_Description":"This parameter is the vehicle speed that the cruise control algorithm is currently using as its cruise control set point.\\r\\n\\r\\nCruise Control Speed (SPN 7319) will include the effects of other algorithms, such as Predictive Cruise Control, Adaptive Cruise Control, etc., that may adjust the cruise control speed from the Cruise Control Set Speed (SPNs 86 and 6809). If there are no other algorithms currently adjusting the cruise control set speed, then Cruise Control Speed (SPN 7319) will be the same value as Cruise Control Set Speed (SPN 6809).","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"7321":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":0,"SPN":7321,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor heater high side driver by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n \\r\\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Heater High Side Driver Diagnostic Status (SPN 7322) is equal to 000b, 010b or 011b.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"7322":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":5,"SPN":7322,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater High Side Driver Diagnostic Status","SPN_Description":"The value of this parameter is not retained when power is removed from the particulate sensor.\\r\\n\\r\\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) for result.\\r\\n\\r\\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) is not valid at the present time.\\r\\n\\r\\n010 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) for the most recent result.\\r\\n\\r\\n011 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) for the most recent result.\\r\\n\\r\\n100 to 110 \u2013 SAE Reserved\\r\\n\\r\\n111 \u2013 Not Available. Aftertreatment 1 Particulate Sensor Heater High Side Driver Preliminary FMI (SPN 7321) is not valid.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7323":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":8,"SPN":7323,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor heater high side driver by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n \\r\\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Heater Low Side Driver Diagnostic Status (SPN 7324) is equal to 000b, 010b or 011b.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"7324":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":13,"SPN":7324,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater Low Side Driver Diagnostic Status","SPN_Description":"The value of this parameter is not retained when power is removed from the particulate sensor.\\r\\n\\r\\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) for result.\\r\\n\\r\\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) is not valid at the present time. \\r\\n\\r\\n010 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) for the most recent result.\\r\\n\\r\\n011 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) for the most recent result.\\r\\n\\r\\n100 to 110 \u2013 SAE Reserved\\r\\n\\r\\n111 \u2013 Not Available. Aftertreatment 1 Particulate Sensor Heater Low Side Driver Preliminary FMI (SPN 7323) is not valid.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7325":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":16,"SPN":7325,"SPN_Name":"Aftertreatment 1 Particulate Sensor Input Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor input by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported. \\r\\n\\r\\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Input Diagnostic Status (SPN 7326) is equal to 000b, 010b or 011b.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"7326":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":21,"SPN":7326,"SPN_Name":"Aftertreatment 1 Particulate Sensor Input Diagnostic Status","SPN_Description":"The value of this parameter is not retained when power is removed from the particulate sensor.\\r\\n\\r\\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) for result.\\r\\n\\r\\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) is not valid at the present time.\\r\\n\\r\\n010 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) for the most recent result.\\r\\n\\r\\n011 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) for the most recent result.\\r\\n\\r\\n100 to 110 \u2013 SAE Reserved\\r\\n\\r\\n111 \u2013 Not Available. Aftertreatment 1 Particulate Sensor Input Preliminary FMI (SPN 7325) is not valid.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7327":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":24,"SPN":7327,"SPN_Name":"Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor power supply by the manufacturer\u2019s sensor control software in exhaust bank 1. In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Power Supply Diagnostic Status (SPN 7328) is equal to 000b, 010b or 011b.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"7328":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":29,"SPN":7328,"SPN_Name":"Aftertreatment 1 Particulate Sensor Power Supply Diagnostic Status","SPN_Description":"The value of this parameter is not retained when power is removed from the particulate sensor.\\r\\n\\r\\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) for result.\\r\\n\\r\\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) is not valid at the present time.\\r\\n\\r\\n010 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) for the most recent result.\\r\\n\\r\\n011 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) for the most recent result.\\r\\n\\r\\n100 to 110 \u2013 SAE Reserved\\r\\n\\r\\n111 \u2013 Not Available. Aftertreatment 1 Particulate Sensor Power Supply Preliminary FMI (SPN 7327) is not valid.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7329":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":32,"SPN":7329,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment particulate sensor heater power supply by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nThis parameter is only valid if Aftertreatment 1 Particulate Sensor Heater Power Supply Diagnostic Status (SPN 7330) is equal to 000b, 010b or 011b.","bit_length":5,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":90},"7330":{"PGN":64562,"PGN_Name":"Aftertreatment 1 Particulate Sensor Information 3","PGN_Description":"AFT1PSI3","first_bit":37,"SPN":7330,"SPN_Name":"Aftertreatment 1 Particulate Sensor Heater Power Supply Diagnostic Status","SPN_Description":"The value of this parameter is not retained when power is removed from the particulate sensor.\\r\\n\\r\\n000 - Tests monitored continuously. There are no enable or pause conditions. See Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) for result. \\r\\n\\r\\n001 - Tests supported but not completed this power cycle. Enable or pause conditions have not been satisfied, which has prevented tests from executing. When tests have completed, this parameter shall change to 010. Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) is not valid at the present time.\\r\\n\\r\\n010 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 010, then this parameter shall change to 011. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) for the most recent result.\\r\\n\\r\\n011 \u2013 Enable or pause conditions have allowed tests to execute this power cycle. If tests are executed while this parameter is 011, then this parameter shall change to 010. To assure that recipients of this parameter detect this state change, this parameter shall be set to this value for at least 3 consecutive broadcasts. See Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) for the most recent result.\\r\\n\\r\\n100 to 110 \u2013 SAE Reserved\\r\\n\\r\\n111 \u2013 Not Available. Aftertreatment 1 Particulate Sensor Heater Power Supply Preliminary FMI (SPN 7329) is not valid.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7331":{"PGN":33024,"PGN_Name":"Aftertreatment System Control","PGN_Description":"AFTSC","first_bit":0,"SPN":7331,"SPN_Name":"Aftertreatment Thermal Management Inhibit Request","SPN_Description":"Provides state of inhibit request for Aftertreatment thermal management from external system.\\r\\n\\r\\nAftertreatment Thermal Management indicates that the exhaust temperatures have been controlled for expected functioning of the aftertreatment system - This is not just limited to temperature increase for regeneration of DPF or SCR.\\r\\nInhibit request is active when temperature change in aftertreatment system leads to deviation in the normal functioning of the external system and external system requests thermal management to be suspended for some duration.\\r\\n\\r\\nStatus of SPN 7332 indicates whether the inhibit request is accepted.\\r\\n\\r\\n00   Do not inhibit\\r\\n01   Inhibit\\r\\n10   Reserved for SAE assignment\\r\\n11   Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7332":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":0,"SPN":7332,"SPN_Name":"Aftertreatment Thermal Management Status","SPN_Description":"Indicates whether Aftertreatment Thermal Management process is active.\\r\\n\\r\\nAftertreatment Thermal Management indicates that the exhaust temperatures have been controlled for the normal functioning of the aftertreatment system - This is not just limited to temperature increase for regeneration of DPF or SCR.\\r\\n\\r\\n\'00\' - Not Active State may also be due to inhibit request in SPN 7331.\\r\\n\\r\\n00   Not active\\r\\n01   Active\\r\\n10   Reserved for SAE assignment\\r\\n11   Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7333":{"PGN":64587,"PGN_Name":"Electronic Engine Controller 17","PGN_Description":"EEC17","first_bit":48,"SPN":7333,"SPN_Name":"Cylinder Fuel Rate","SPN_Description":"Cylinder fuel rate shall indicate the amount of fuel injected into the cylinder for combustion during the most recent intake stroke of the engine.\\r\\n\\r\\nNOTE: Cylinder fuel rate shall indicate zero mg/stroke when the engine is not running.","bit_length":16,"scaling":0.03125,"offset":0,"unit":"mg/stroke","SLOT_ID":400},"7341":{"PGN":64560,"PGN_Name":"SCR Operator Inducement Information 4","PGN_Description":"SCROII4","first_bit":0,"SPN":7341,"SPN_Name":"SCR Operator Inducement Emergency Override Total Reset Occurrences","SPN_Description":"The total number of times the feature, which allows the operator to override the inducement strategies (as described in SPN 6880) during emergencies, such as hurricanes, has been reset.\\r\\n\\r\\nThis counter can not be reset.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"7342":{"PGN":64560,"PGN_Name":"SCR Operator Inducement Information 4","PGN_Description":"SCROII4","first_bit":16,"SPN":7342,"SPN_Name":"SCR Operator Inducement Override Mode","SPN_Description":"Indicates the functional mode of SCR operator inducement override.\\r\\n\\r\\n000          Not Available\\r\\n001          Available - Not Active\\r\\n010          Active\\r\\n011          Active Extended\\r\\n100          Expired\\r\\n101-110  Not Defined\\r\\n111          Not Available\\r\\n\\r\\nNote:  This is SPN is intended for special emergency situations, such as natural disasters. Check legal implications before using this SPN.","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7343":{"PGN":64560,"PGN_Name":"SCR Operator Inducement Information 4","PGN_Description":"SCROII4","first_bit":19,"SPN":7343,"SPN_Name":"SCR Operator Inducement Override Renewal Required","SPN_Description":"Indicates the required operator inducement override renewal state.\\r\\n\\r\\n00 = Not Required\\r\\n01 = Required\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7344":{"PGN":64560,"PGN_Name":"SCR Operator Inducement Information 4","PGN_Description":"SCROII4","first_bit":24,"SPN":7344,"SPN_Name":"SCR Operator Inducement Override Time Remaining (Extended Range)","SPN_Description":"Used to indicate the time remaining during an operator inducement override event.  When an operator inducement is active this parameter indicates the remaining time that the currently active operator inducement may be overridden.\\r\\n\\r\\nSee also SPN 6878 for an alternate SLOT.","bit_length":16,"scaling":1,"offset":0,"unit":"min","SLOT_ID":238},"7346":{"PGN":64923,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 1","PGN_Description":"A1DEFI1","first_bit":48,"SPN":7346,"SPN_Name":"Diesel Exhaust Fluid Speed of Sound","SPN_Description":"The speed of sound in the fluid that is in the diesel exhaust fluid tank.","bit_length":16,"scaling":0.1,"offset":0,"unit":"m/s","SLOT_ID":401},"7347":{"PGN":64559,"PGN_Name":"Fire Suppression Agent Status","PGN_Description":"FSAS","first_bit":0,"SPN":7347,"SPN_Name":"Fire Suppression Water Tank Level","SPN_Description":"Liquid level of the fire apparatus water tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7348":{"PGN":64559,"PGN_Name":"Fire Suppression Agent Status","PGN_Description":"FSAS","first_bit":8,"SPN":7348,"SPN_Name":"Fire Suppression Class-A Foam Tank Level","SPN_Description":"Liquid level of the Class-A foam agent tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7349":{"PGN":64559,"PGN_Name":"Fire Suppression Agent Status","PGN_Description":"FSAS","first_bit":16,"SPN":7349,"SPN_Name":"Fire Suppression Class-B Foam Tank Level","SPN_Description":"Liquid level of the Class-B foam agent tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7350":{"PGN":64559,"PGN_Name":"Fire Suppression Agent Status","PGN_Description":"FSAS","first_bit":24,"SPN":7350,"SPN_Name":"Fire Suppression Compressed Air Foam System Air Pressure","SPN_Description":"Compressed Air Foam System (CAFS) air compressor pressure.","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"7351":{"PGN":64782,"PGN_Name":"Aftertreatment 1 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT1OGC2","first_bit":40,"SPN":7351,"SPN_Name":"Aftertreatment 1 Outlet Corrected NOx","SPN_Description":"The corrected outlet NOx value for aftertreatment 1 shall include all learned adaptions and offsets that are used to adjust the raw signal.\\r\\n\\r\\n2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3226.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7352":{"PGN":64778,"PGN_Name":"Aftertreatment 2 Outlet Gas NOx Sensor Correction Data 2","PGN_Description":"AT2OGC2","first_bit":40,"SPN":7352,"SPN_Name":"Aftertreatment 2 Outlet Corrected NOx","SPN_Description":"The corrected outlet NOx value  for aftertreatment 2 shall include all learned adaptions and offsets that are used to adjust the raw signal.\\r\\n\\r\\n2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3265.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7353":{"PGN":64784,"PGN_Name":"Aftertreatment 1 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT1IGC2","first_bit":40,"SPN":7353,"SPN_Name":"Aftertreatment 1 SCR Intake Corrected NOx","SPN_Description":"The corrected intake Selective Catalytic Reduction NOx value for aftertreatment 1 shall include all learned adaptions and offsets that are used to adjust the raw signal.\\r\\n\\r\\n2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3216.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7354":{"PGN":64780,"PGN_Name":"Aftertreatment 2 Intake Gas NOx Sensor Correction Data 2","PGN_Description":"AT2IGC2","first_bit":40,"SPN":7354,"SPN_Name":"Aftertreatment 2 SCR Intake Corrected NOx","SPN_Description":"The corrected intake Selective Catalytic Reduction NOx value for aftertreatment 2 shall include all learned adaptions and offsets that are used to adjust the raw signal.\\r\\n\\r\\n2016 MY and later engines with NOx sensors may be required to output a \u2018corrected\u2019 NOx sensor signal in addition to the raw NOx sensor signal out using SPN 3255.\\r\\n\\r\\nA value of 0xFB00 shall be provided when ambient or engine operating conditions do not permit the sensor to operate in data collection mode.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7355":{"PGN":7424,"PGN_Name":"Engine Ignition Controller","PGN_Description":"EIC","first_bit":0,"SPN":7355,"SPN_Name":"Engine Timing Advance","SPN_Description":"Ignition timing as a command to the ignition control module.  Positive values command an increasingly advanced timing from TDC. The same timing applies to all cylinders. Use SPN 7356 - SPN 7379 for cylinder specific timing offsets from this timing.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"7356":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":0,"SPN":7356,"SPN_Name":"Engine Cylinder 1 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 1 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7357":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":8,"SPN":7357,"SPN_Name":"Engine Cylinder 2 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 2 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7358":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":16,"SPN":7358,"SPN_Name":"Engine Cylinder 3 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 3 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7359":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":24,"SPN":7359,"SPN_Name":"Engine Cylinder 4 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 4 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7360":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":32,"SPN":7360,"SPN_Name":"Engine Cylinder 5 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 5 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7361":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":40,"SPN":7361,"SPN_Name":"Engine Cylinder 6 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 6 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7362":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":48,"SPN":7362,"SPN_Name":"Engine Cylinder 7 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 7 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7363":{"PGN":61669,"PGN_Name":"Engine Ignition Timing Offset 1","PGN_Description":"ITO1","first_bit":56,"SPN":7363,"SPN_Name":"Engine Cylinder 8 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 8 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7364":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":0,"SPN":7364,"SPN_Name":"Engine Cylinder 9 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 9 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7365":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":8,"SPN":7365,"SPN_Name":"Engine Cylinder 10 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 10 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7366":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":16,"SPN":7366,"SPN_Name":"Engine Cylinder 11 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 11 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7367":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":24,"SPN":7367,"SPN_Name":"Engine Cylinder 12 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 12 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7368":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":32,"SPN":7368,"SPN_Name":"Engine Cylinder 13 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 13 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7369":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":40,"SPN":7369,"SPN_Name":"Engine Cylinder 14 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 14 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7370":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":48,"SPN":7370,"SPN_Name":"Engine Cylinder 15 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 15 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7371":{"PGN":61670,"PGN_Name":"Engine Ignition Timing Offset 2","PGN_Description":"ITO2","first_bit":56,"SPN":7371,"SPN_Name":"Engine Cylinder 16 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 16 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7372":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":0,"SPN":7372,"SPN_Name":"Engine Cylinder 17 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 17 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7373":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":8,"SPN":7373,"SPN_Name":"Engine Cylinder 18 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 18 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7374":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":16,"SPN":7374,"SPN_Name":"Engine Cylinder 19 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 19 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7375":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":24,"SPN":7375,"SPN_Name":"Engine Cylinder 20 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 20 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7376":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":32,"SPN":7376,"SPN_Name":"Engine Cylinder 21 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 21 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7377":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":40,"SPN":7377,"SPN_Name":"Engine Cylinder 22 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 22 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7378":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":48,"SPN":7378,"SPN_Name":"Engine Cylinder 23 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 23 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7379":{"PGN":61671,"PGN_Name":"Engine Ignition Timing Offset 3","PGN_Description":"ITO3","first_bit":56,"SPN":7379,"SPN_Name":"Engine Cylinder 24 Ignition Timing Offset","SPN_Description":"The ignition timing offset for Cylinder 24 from the engine timing advance (SPN 7355) as a command to the ignition control module. Positive values command an increasingly advanced timing.","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7380":{"PGN":64558,"PGN_Name":"Engine Turbocharger Control 3","PGN_Description":"ETCC3","first_bit":0,"SPN":7380,"SPN_Name":"Engine Turbocharger Compressor Blowoff Actuator 1 Motor Current Disable","SPN_Description":"Command to disable power to motor in the actuator to prevent unnecessary load on the component.\\r\\n\\r\\n00 - Do Not Disable\\r\\n01 - Disable\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7381":{"PGN":64558,"PGN_Name":"Engine Turbocharger Control 3","PGN_Description":"ETCC3","first_bit":2,"SPN":7381,"SPN_Name":"Engine Turbocharger Wastegate Actuator 1 Motor Current Disable","SPN_Description":"Command to disable power to motor in the actuator to prevent unnecessary load on the component.\\r\\n\\r\\n00 - Do Not Disable\\r\\n01 - Disable\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7382":{"PGN":64558,"PGN_Name":"Engine Turbocharger Control 3","PGN_Description":"ETCC3","first_bit":4,"SPN":7382,"SPN_Name":"Engine Cylinder Head Bypass Actuator 1 Motor Current Disable","SPN_Description":"Command to disable power to motor in the actuator to prevent unnecessary load on the component.\\r\\n\\r\\n00 - Do Not Disable\\r\\n01 - Disable\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7383":{"PGN":64558,"PGN_Name":"Engine Turbocharger Control 3","PGN_Description":"ETCC3","first_bit":6,"SPN":7383,"SPN_Name":"Engine Throttle Valve 1 Motor Current Disable","SPN_Description":"Command to disable power to motor in the actuator to prevent unnecessary load on the component.\\r\\n\\r\\n00 - Do Not Disable\\r\\n01 - Disable\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7393":{"PGN":64720,"PGN_Name":"Engine Particulate Sensor Information","PGN_Description":"EPSI","first_bit":32,"SPN":7393,"SPN_Name":"Aftertreatment 1 Particulate Sensor Current","SPN_Description":"Raw aftertreatment 1 PM sensor electrical current reading.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"\xb5A","SLOT_ID":403},"7394":{"PGN":64962,"PGN_Name":"Electronic Engine Controller 14","PGN_Description":"EEC14","first_bit":56,"SPN":7394,"SPN_Name":"Engine Fuel Isolation Control","SPN_Description":"Control setting for fuel isolation. In a single injector dual fuel system when using just diesel fuel, diesel must not be allowed to migrate into the gaseous fuel system. When the fuel isolation valve is closed the engine uses dual fuel by allowing the mechanical regulator controls the gaseous fuel to a pressure lower than the diesel fuel. When the fuel isolation valve is open the mechanical regulator does not see diesel fuel pressure so the gaseous fuel is off which prevents diesel fuel from migrating to the gaseous fuel system.\\r\\n\\r\\n00 = Gaseous Fuel Migration is Prevented\\r\\n01 = Gaseous Fuel is Used\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7395":{"PGN":64752,"PGN_Name":"Engine Fuel/lube systems 2","PGN_Description":"EFS2","first_bit":24,"SPN":7395,"SPN_Name":"Fuel Tank Transfer Pump Pressure","SPN_Description":"Gage pressure of the fuel in the system as delivered by the transfer pump.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"7396":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":0,"SPN":7396,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 1 Left","SPN_Description":"Brake caliper lining clearance for left brake on tractor axle 1.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7397":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":2,"SPN":7397,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 1 Right","SPN_Description":"Brake caliper lining clearance for right brake on tractor axle 1.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7398":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":4,"SPN":7398,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 2 Left","SPN_Description":"Brake caliper lining clearance for left brake on tractor axle 2.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7399":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":6,"SPN":7399,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 2 Right","SPN_Description":"Brake caliper lining clearance for right brake on tractor axle 2.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7400":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":8,"SPN":7400,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 3 Left","SPN_Description":"Brake caliper lining clearance for left brake on tractor axle 3.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7401":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":10,"SPN":7401,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 3 Right","SPN_Description":"Brake caliper lining clearance for right brake on tractor axle 3.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7402":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":12,"SPN":7402,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 4 Left","SPN_Description":"Brake caliper lining clearance for left brake on tractor axle 4.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7403":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":14,"SPN":7403,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 4 Right","SPN_Description":"Brake caliper lining clearance for right brake on tractor axle 4.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7404":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":16,"SPN":7404,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 5 Left","SPN_Description":"Brake caliper lining clearance for left brake on tractor axle 5.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7405":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":18,"SPN":7405,"SPN_Name":"Tractor Brake Caliper Lining Clearance Axle 5 Right","SPN_Description":"Brake caliper lining clearance for right brake on tractor axle 5.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7406":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":20,"SPN":7406,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 1 Left","SPN_Description":"Brake caliper lining clearance for left brake on trailer axle 1.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7407":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":22,"SPN":7407,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 1 Right","SPN_Description":"Brake caliper lining clearance for right brake on trailer axle 1.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7408":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":24,"SPN":7408,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 2 Left","SPN_Description":"Brake caliper lining clearance for left brake on trailer axle 2.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7409":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":26,"SPN":7409,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 2 Right","SPN_Description":"Brake caliper lining clearance for right brake on trailer axle 2.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7410":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":28,"SPN":7410,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 3 Left","SPN_Description":"Brake caliper lining clearance for left brake on trailer axle 3.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7411":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":30,"SPN":7411,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 3 Right","SPN_Description":"Brake caliper lining clearance for right brake on trailer axle 3.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7412":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":32,"SPN":7412,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 4 Left","SPN_Description":"Brake caliper lining clearance for left brake on trailer axle 4.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7413":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":34,"SPN":7413,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 4 Right","SPN_Description":"Brake caliper lining clearance for right brake on trailer axle 4.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7414":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":36,"SPN":7414,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 5 Left","SPN_Description":"Brake caliper lining clearance for left brake on trailer axle 5.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7415":{"PGN":64556,"PGN_Name":"Brake Caliper Lining Clearance","PGN_Description":"BCLC","first_bit":38,"SPN":7415,"SPN_Name":"Trailer Brake Caliper Lining Clearance Axle 5 Right","SPN_Description":"Brake caliper lining clearance for right brake on trailer axle 5.\\r\\n\\r\\n00 - Caliper lining clearance is adequate\\r\\n01 - Caliper lining clearance is low\\r\\n10 - Error\\r\\n11 - Not available / not applicable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7416":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":42,"SPN":7416,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump Power Relay","SPN_Description":"The state of the aftertreatment 1 diesel exhaust fluid pump power relay.\\r\\n\\r\\n00 not active - no power is being applied to the relay\\r\\n01 active - power is being applied to the relay\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7417":{"PGN":64699,"PGN_Name":"Aftertreatment 1 SCR Electronic Control Module Information","PGN_Description":"A1ECMI","first_bit":6,"SPN":7417,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Control Module Circuit Breaker","SPN_Description":"The status of the circuit breaker that is used to power the diesel exhaust control module.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7418":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":10,"SPN":7418,"SPN_Name":"Hybrid System Engine Assist Status","SPN_Description":"Provides the engine an indication of when the hybrid system is not mechanically assisting rotation (i.e. not motoring) the engine. When this parameter is in state 00, the engine can perform operations while free of potential hybrid system assistance.\\r\\n\\r\\nWhen this parameter is in state 01, the hybrid system may or may not mechanically assist engine rotation. While this parameter is in state 01, the engine should not perform operations that need to be free from hybrid system assistance.\\r\\n\\r\\n00 \u2013 Hybrid system is not mechanically assisting engine rotation\\r\\n01 \u2013 Hybrid system may or may not mechanically assist engine rotation\\r\\n10 \u2013 Error\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7420":{"PGN":64555,"PGN_Name":"Cruise Control / Vehicle Speed 4","PGN_Description":"CCVS4","first_bit":0,"SPN":7420,"SPN_Name":"Applied Vehicle Speed Limit (High Resolution)","SPN_Description":"The vehicle speed limit in effect.\\r\\n\\r\\nSee SPN 2595 for alternate resolution.\\r\\n\\r\\nNote:  If a maximum vehicle speed limit is not selected, then the first byte of this parameter will be equal to 0xFB.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"7421":{"PGN":64849,"PGN_Name":"Aftercooler Coolant Control Valve Command","PGN_Description":"ACCVC","first_bit":24,"SPN":7421,"SPN_Name":"Engine Charge Air Cooler Bypass Valve 1 Command","SPN_Description":"Desired percentage of charge air cooler Bypass Valve 1 opening. 0% means no air is bypassed. 100% means full bypass capacity.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7422":{"PGN":64849,"PGN_Name":"Aftercooler Coolant Control Valve Command","PGN_Description":"ACCVC","first_bit":40,"SPN":7422,"SPN_Name":"Engine Charge Air Cooler Bypass Valve 2 Command","SPN_Description":"Desired percentage of charge air cooler Bypass Valve 2 opening. 0% means no air is bypassed. 100% means full bypass capacity.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7425":{"PGN":64554,"PGN_Name":"Operator Inducement Information","PGN_Description":"OII","first_bit":0,"SPN":7425,"SPN_Name":"Operator Inducement Torque Derate Level 1","SPN_Description":"This is the first torque derate that will be applied to the engine operation due to operator inducement.  The torque derate indicated in this parameter will be active when the value in Operator Inducement Time to Torque Derate Level 1 (SPN 7426) has decremented to 0.\\r\\n\\r\\nThis parameter is a percentage of how much the engine\u2019s capabilities will be reduced as indicated by the Advertised Engine Torque Curve. 0% represents no torque derate and 100% represents a full torque derate. This parameter will be set to 0% when no operator inducement is active. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000.\\r\\n\\r\\nThis parameter is expected to be less than Operator Inducement Torque Derate Level 2 (SPN 7427) if a second level of derate exists.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7426":{"PGN":64554,"PGN_Name":"Operator Inducement Information","PGN_Description":"OII","first_bit":8,"SPN":7426,"SPN_Name":"Operator Inducement Time to Torque Derate Level 1","SPN_Description":"This parameter provides the time until Operator Inducement Torque Derate Level 1 (SPN 7425) is activated.\\r\\n\\r\\nWhen operator inducement is not active, this parameter will be set to 0xFB00. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000. If SPN 7426 has decremented to 0, it will remain at 0 until the condition that caused it to decrement has been corrected.\\r\\n\\r\\nWhen operator inducement is active and there are two levels of torque derate, then Operator Inducement Time to Torque Derate Level 1 (SPN 7426) is expected to be smaller than Operator Inducement Time to Torque Derate Level 2 (SPN 7428) unless both SPN 7426 and SPN 7428 are equal to 0.\\r\\n\\r\\nSee SPN 7719 for the time until final inducement action.\\r\\n\\r\\nIf the operator inducement has been temporarily overridden, then this parameter will pause and not decrement until the override is removed. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 110 - Temporary Override of Inducement.","bit_length":16,"scaling":1,"offset":0,"unit":"min","SLOT_ID":238},"7427":{"PGN":64554,"PGN_Name":"Operator Inducement Information","PGN_Description":"OII","first_bit":24,"SPN":7427,"SPN_Name":"Operator Inducement Torque Derate Level 2","SPN_Description":"This is the second torque derate that will be applied to the engine operation due to operator inducement. The torque derate level indicated in this parameter will be applied when the value in Operator Inducement Time to Torque Derate Level 2 (SPN 7428) has decremented to 0.\\r\\n\\r\\nThis parameter is a percentage of how much the engine\u2019s capabilities will be reduced as indicated by the Advertised Engine Torque Curve. 0% represents no torque derate and 100% represents a full torque derate. This parameter will be set to 0% when no operator inducement is active. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000.\\r\\n\\r\\nThis parameter is expected to be a greater than Operator Inducement Torque Derate Level 1 (SPN 7425) unless a second level of derate does not exist, in which case Operator Inducement Torque Derate Level 2 (SPN 7427) will be 0.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7428":{"PGN":64554,"PGN_Name":"Operator Inducement Information","PGN_Description":"OII","first_bit":32,"SPN":7428,"SPN_Name":"Operator Inducement Time to Torque Derate Level 2","SPN_Description":"This parameter provides the time until Operator Inducement Torque Derate Level 2 (SPN 7427) is activated.\\r\\n\\r\\nWhen operator inducement is not active or if a second level of derate does not exist, then this parameter will be set to 0xFB00. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000. If SPN 7428 has decremented to 0, it will remain at 0 until the condition that caused it to decrement has been corrected.\\r\\n\\r\\nThis parameter is expected to be a greater than Operator Inducement Time to Torque Derate Level 1 (SPN 7426) if the current inducement event will impose a second torque derate level.\\r\\n\\r\\nSee SPN 7719 for the time until final inducement action.\\r\\n\\r\\nIf the operator inducement has been temporarily overridden, then this parameter will pause and not decrement until the override is removed. or systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 110 - Temporary Override of Inducement.","bit_length":16,"scaling":1,"offset":0,"unit":"min","SLOT_ID":238},"7429":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":20,"SPN":7429,"SPN_Name":"Vehicle Speed Control Override Request","SPN_Description":"Speed control override requested. Indicates that the minimum restriction of speed is desired, for instance when travelling downhill towards an impending uphill grade. This is not a request to inhibit engine brakes (or other speed limiting device) but to delay activation or use the highest speed tolerance within limits set for vehicle speed.\\r\\n\\r\\n00 = No speed control override requested\\r\\n01 = Speed control override requested\\r\\n10 = Reserved\\r\\n11 = Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7430":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":44,"SPN":7430,"SPN_Name":"Predictive Cruise Control Driveline Disengage Inhibit Request","SPN_Description":"Request to temporarily inhibit a fuel saving feature that would normally open the driveline. Under certain conditions and with knowledge of the terrain, inhibiting this feature may improve fuel economy.\\r\\n\\r\\nSPN 683 Disengage Driveline Request has priority over this parameter. However, the sender of SPN 683 should consider this parameter and not request driveline disengagement if it is for fuel economy purposes.\\r\\n\\r\\n00 - No Inhibit Request\\r\\n01 - Driveline Disengage Inhibit Request\\r\\n10 - Reserved\\r\\n11 - Don\'t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7431":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":22,"SPN":7431,"SPN_Name":"Predictive Cruise Control Event in Range","SPN_Description":"Indicates that an event, such as a grade, is detected within the range of the predictive cruise control (PCC) look-ahead distance.\\r\\n\\r\\n00 - No PCC event in range\\r\\n01 - PCC event in range\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nNote:  Intended to be sent regardless of whether or not PCC is active. Can be used to indicate an upcoming event or a missed opportunity.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7432":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":24,"SPN":7432,"SPN_Name":"Predictive Cruise Control Present Grade","SPN_Description":"Road grade at present vehicle position. Positive numbers indicate uphill grade, negative are downhill for present vehicle direction of travel. For grades beyond the limits of the parameter, the limit value shall be reported.","bit_length":8,"scaling":0.125,"offset":-16,"unit":"%","SLOT_ID":404},"7433":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":32,"SPN":7433,"SPN_Name":"Predictive Cruise Control Next Grade","SPN_Description":"Road grade at next predictive cruise control (PCC) event. Positive numbers indicate uphill grade, negative are downhill for vehicle direction of travel. For grades beyond the limits of the parameter, the limit value shall be reported.","bit_length":8,"scaling":0.125,"offset":-16,"unit":"%","SLOT_ID":404},"7434":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":40,"SPN":7434,"SPN_Name":"Predictive Cruise Control Speed Event Indicator","SPN_Description":"Indicates to the operator that a predictive cruise control (PCC) speed event is active. Typically, this will correspond to a Predictive Cruise Control Set Speed Offset (SPN 7316) request to increase or decrease vehicle speed from the nominal cruise set point.\\r\\n\\r\\n00 - No speed event is active\\r\\n01 - Increased speed event is active\\r\\n10 - Decreased speed event is active\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7435":{"PGN":61651,"PGN_Name":"Predictive Cruise Control 1","PGN_Description":"PCC1","first_bit":42,"SPN":7435,"SPN_Name":"Vehicle Speed Control Override Event Indicator","SPN_Description":"Indicates to the operator that a Speed Control override event is active.  \\"Speed Control\\" refers to retarders or methods of automatically limiting vehicle speed, for instance on downhill grades.  An active event indicates that vehicle speed may exceed the nominal set point for speed control.  Typically, this will correspond to a Vehicle Speed Control Override Request (SPN 7429).\\r\\n\\r\\n00 - Speed Control event is not active\\r\\n01 - Speed Control event is active\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7436":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":22,"SPN":7436,"SPN_Name":"Predictive Cruise Control Enable Switch","SPN_Description":"Indicates whether predictive cruise control (PCC) is enabled. When not enabled, the predictive cruise control does not calculate a speed offset or identify predictive cruise events, and the predictive cruise control state (SPN 7317) shall not be \\"enabled\\".\\r\\n\\r\\n00 - Predictive cruise control is not enabled\\r\\n01 - Predictive cruise control is enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7437":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":24,"SPN":7437,"SPN_Name":"Predictive Cruise Control Deactivation Request","SPN_Description":"Indicates that the operator has requested to deactivate the predictive cruise control (PCC) function.\\r\\n\\r\\nIf enabled, the PCC device may still provide notification of events in range, road grade, and other information. But if requested to be deactivated by this parameter, the predictive cruise device shall set its state (SPN 7317) to \\"Enabled, but not functional due to inhibited by driver\\".\\r\\n\\r\\n00 - Predictive cruise control is not requested to be deactived\\r\\n01 - Predictive cruise control is requested to be deactived\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7438":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":32,"SPN":7438,"SPN_Name":"Predictive Cruise Control Maximum Positive Offset","SPN_Description":"Maximum speed increase that the predictive cruise control (PCC) is allowed to request. This may be adjusted by the operator (either directly or indirectly) to tailor the performance of the PCC system.\\r\\n\\r\\nThis parameter is used in conjunction with maximum negative offset (SPN 7439) and cruise set speed (SPN 86 or SPN 6809) to define the operating range of the PCC system.","bit_length":8,"scaling":0.125,"offset":0,"unit":"km/h","SLOT_ID":405},"7439":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":40,"SPN":7439,"SPN_Name":"Predictive Cruise Control Maximum Negative Offset","SPN_Description":"Maximum speed decrease that the predictive cruise control (PCC) is allowed to request. This may be adjusted by the operator (either directly or indirectly) to tailor the performance of the PCC system.\\r\\n\\r\\nThis parameter is used in conjunction with maximum positive offset (SPN 7438) and cruise set speed (SPN 86 or SPN 6809) to define the operating range of the PCC system.","bit_length":8,"scaling":0.125,"offset":-31.25,"unit":"km/h","SLOT_ID":406},"7440":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":2,"SPN":7440,"SPN_Name":"Aftertreatment Active Regeneration Inhibited Due to Low Exhaust Pressure","SPN_Description":"The state of aftertreatment active regeneration inhibition due to low exhaust pressure.\\r\\n\\r\\nAftertreatment Regeneration is a process of increasing the temperature at the exhaust and thereby removing the deposits on aftertreatment components such as DPF or SCR Catalyst and increasing their efficiency.\\r\\n\\r\\nThis SPN indicates the reason for the regeneration not being initiated or being exited prior to completion. When this state becomes active the system will not initiate an active regeneration or will exit an active regeneration. The state provides information that may be provided to the driver/service technician as to why the regeneration did not initiate or was exited.\\r\\n\\r\\n00 Not Inhibited\\r\\n01 Inhibited\\r\\n10 Reserved for SAE assignment\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7441":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":8,"SPN":7441,"SPN_Name":"Aftertreatment Ambient Air Temperature","SPN_Description":"Temperature of ambient air near the aftertreatment components such as DEF tank and DEF lines.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7442":{"PGN":64566,"PGN_Name":"Gaseous Fuel Supply Valve Information","PGN_Description":"GFSVI","first_bit":40,"SPN":7442,"SPN_Name":"Inert Gas Supply Valve Position","SPN_Description":"Position of inert gas supply valve used to control the flow of inert gas into the engine to purge the system.\\r\\n\\r\\n0% represents valve fully closed and 100% represents valve fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7448":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":12,"SPN":7448,"SPN_Name":"Hybrid System Service Indicator","SPN_Description":"Signal from the hybrid system indicating that the hybrid system or one of its components requires servicing (e.g. oil change, coolant change).\\r\\n\\r\\n00 - Hybrid Service Indicator is off\\r\\n01 - Hybrid Service Indicator is on continously\\r\\n10 - Hybrid Service Indicator is flashing\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7449":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":14,"SPN":7449,"SPN_Name":"Hybrid System Motor Overspeed Indicator","SPN_Description":"Signal from the hybrid system indicating that the hybrid system motor is exceeding maximum speed limit.\\r\\n\\r\\n00 - Hybrid System Motor Overspeed Indicator is off\\r\\n01 - Hybrid System Motor Overspeed Indicator is on continously\\r\\n10 - Hybrid System Motor Overspeed Indicator is flashing\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7450":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":16,"SPN":7450,"SPN_Name":"Hybrid System Motor Overspeed Audible Alarm","SPN_Description":"Signal from the hybrid system indicating that the overspeed audible alarm should be activated.\\r\\n\\r\\n00 - Motor Overspeed Audible Alarm is off\\r\\n01 - Motor Overspeed Audible Alarm is on\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7451":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":18,"SPN":7451,"SPN_Name":"Hybrid System Electric Alternator Indicator","SPN_Description":"Signal from the hybrid system indicating that the electric alternator is failed or needs servicing.  The alternator Indicator (e.g. dash lamp) is to be activated.\\r\\n\\r\\n00 - Alternator Indicator is off\\r\\n01 - Alternator Indicator is on\\r\\n10 - Alternator Indicator is flashing\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7452":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":20,"SPN":7452,"SPN_Name":"Hybrid System Regenerative Braking Indicator","SPN_Description":"Signal from the hybrid system indicating when regenerative braking is active.\\r\\n\\r\\n00 - Regenerative braking is inactive\\r\\n01 - Regenerative braking is active\\r\\n10 - Regenerative braking is disabled or faulted \\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7453":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":22,"SPN":7453,"SPN_Name":"Hybrid System Initialization Indicator","SPN_Description":"Signal from the hybrid system that indicates when it is initialized and ready to start the engine or other power source (e.g. fuel cell). The intent is that this would drive an indicator for the vehicle operator. If the operator attempts to start the engine or power source while this indicator is active, it may not start. When indicator is not active, the hybrid initialization is complete and the engine may start.\\r\\n\\r\\n00 - Hybrid System Initialization Indicator is not active\\r\\n01 - Hybrid System Initialization Indicator is active\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7454":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":24,"SPN":7454,"SPN_Name":"Hybrid System High Voltage Exposure Indicator","SPN_Description":"This signal indicates the condition and state of the hybrid system high voltage exposure detection system (e.g. High\\r\\nVoltage Interlock Loop [HVIL]). The high voltage exposure detection system is used to detect situations on a hybrid\\r\\nvehicle where personnel or property may be exposed to high voltage.\\r\\n\\r\\nThe Error state indicates that the detection system may not be operational, and exposure status cannot be determined. For example, the detection system may not be operational due to electrical issues detected within its circuitry (e.g. short to battery, short to ground) or it has been intentionally disabled.\\r\\n\\r\\n00 \u2013 System is operational and intact; no potential high voltage exposure has been detected\\r\\n01 \u2013 System is operational and has detected a compromise; potential high voltage exposure exists\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7455":{"PGN":64529,"PGN_Name":"Total Gaseous Fuel Information","PGN_Description":"TGFI","first_bit":0,"SPN":7455,"SPN_Name":"Engine Total Gaseous Fuel Volume Used","SPN_Description":"Accumulated volume of engine gaseous fuel used during vehicle operation, in standard cubic meters.\\r\\n\\r\\nSee SPN 1040 for alternate units.","bit_length":32,"scaling":0.5,"offset":0,"unit":"m\xb3","SLOT_ID":413},"7456":{"PGN":64529,"PGN_Name":"Total Gaseous Fuel Information","PGN_Description":"TGFI","first_bit":32,"SPN":7456,"SPN_Name":"Engine Total Gaseous Idle Fuel Volume Used","SPN_Description":"Accumulated volume of engine gaseous fuel used during vehicle operation under idle conditions, in standard cubic meters.","bit_length":32,"scaling":0.5,"offset":0,"unit":"m\xb3","SLOT_ID":413},"7459":{"PGN":64590,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 3","PGN_Description":"A1SCRDSI3","first_bit":8,"SPN":7459,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser 2 Absolute Pressure","SPN_Description":"The SCR doser 2 diesel exhaust fluid absolute pressure (measured closest to dosing valve) for aftertreatment system 1 (exhaust bank 1).","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"7460":{"PGN":64590,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 3","PGN_Description":"A1SCRDSI3","first_bit":16,"SPN":7460,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser 2 Temperature","SPN_Description":"The temperature (measured closest to dosing valve) of the second DEF dosing unit for aftertreatment system 1 (exhaust bank 1).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7461":{"PGN":64725,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information","PGN_Description":"AT1P1I","first_bit":8,"SPN":7461,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump 2 Motor Speed","SPN_Description":"Rotational speed of the motor driving the second pump for the diesel exhaust fluid used in aftertreatment system 1 (exhaust bank 1).","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7464":{"PGN":64589,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 3","PGN_Description":"A2SCRDSI3","first_bit":8,"SPN":7464,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Doser 2 Absolute Pressure","SPN_Description":"The SCR doser 2 diesel exhaust fluid absolute pressure (measured closest to dosing valve) for aftertreatment system 2 (exhaust bank 2).","bit_length":8,"scaling":8,"offset":0,"unit":"kPa","SLOT_ID":2},"7465":{"PGN":64589,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 3","PGN_Description":"A2SCRDSI3","first_bit":16,"SPN":7465,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Doser 2 Temperature","SPN_Description":"The temperature (measured closest to doser valve) of the second DEF doser unit for aftertreatment system 2 (exhaust bank 2).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7466":{"PGN":64565,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump 1 Information","PGN_Description":"AT2P1I","first_bit":8,"SPN":7466,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump 2 Motor Speed","SPN_Description":"Rotational speed of the motor driving the second pump for the diesel exhaust fluid used in aftertreatment system 2 (exhaust bank 2).","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7468":{"PGN":64751,"PGN_Name":"Engine Fluid Level/Pressure 11","PGN_Description":"EFL/P11","first_bit":32,"SPN":7468,"SPN_Name":"Engine Oil Pressure (High Resolution/Extended Range)","SPN_Description":"Gage pressure of oil in engine lubrication system as provided by oil pump. See SPN 100 for alternate resolution.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"7469":{"PGN":64751,"PGN_Name":"Engine Fluid Level/Pressure 11","PGN_Description":"EFL/P11","first_bit":48,"SPN":7469,"SPN_Name":"Engine Fuel Delivery Pressure (High Resolution/Extended Range)","SPN_Description":"Gage pressure of fuel in system as delivered from supply pump to the injection pump. See SPN 94 for alternate resolution.\\r\\n\\r\\nSee also SPN 5578 for Engine Fuel Delivery Absolute Pressure.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"7470":{"PGN":64662,"PGN_Name":"Engine Information 2","PGN_Description":"EI2","first_bit":16,"SPN":7470,"SPN_Name":"Engine Oil Filter Intake Pressure (High Resolution/Extended Range)","SPN_Description":"Gage pressure of the engine oil before the oil reaches the oil filter. See SPN 1208 for alternate resolution.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"7471":{"PGN":65276,"PGN_Name":"Dash Display 1","PGN_Description":"DD1","first_bit":56,"SPN":7471,"SPN_Name":"Engine Oil Filter Differential Pressure (Extended Range)","SPN_Description":"Change in engine oil pressure, measured across the filter, due to the filter and any accumulation of solid or semisolid material on or in the filter. See SPN 99 for alternate resolution.","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"7472":{"PGN":64735,"PGN_Name":"Engine Fluid Level/Pressure 12","PGN_Description":"EFL/P12","first_bit":56,"SPN":7472,"SPN_Name":"Engine Fuel Supply Pump Intake Absolute Pressure (Extended Range)","SPN_Description":"Absolute pressure of fuel at the fuel supply pump intake. See Figures SPN16_A & SPN16_B. See SPN 1381 for alternate resolution.\\r\\n\\r\\nEngine Fuel Supply Pump Intake Absolute Pressure (Extended Range)","bit_length":8,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":1},"7473":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":8,"SPN":7473,"SPN_Name":"Driver Alertness Warning","SPN_Description":"Indicates when a distracted driving condition is detected. This signal can be used independent of the technology and ECU used to estimate the distracted driver condition.\\r\\n\\r\\n000 = No distracted driving condition detected\\r\\n001 = Level 1 - Mild distraction or extended driving condition detected\\r\\n010 = Level 2 - Degradation in driving behavior detected\\r\\n011 = Level 3 - Driver alertness warning\\r\\n100-110 = Reserved\\r\\n111 = Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7474":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":8,"SPN":7474,"SPN_Name":"Driver Alertness Level","SPN_Description":"Indicates the alertness level of the driver measured by the driver alertness warning system. 100 % means driver is fully attentive. This signal can be used independent of the technology and ECU used to estimate the driver alertness condition.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7475":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":16,"SPN":7475,"SPN_Name":"Driver Alertness Warning System State","SPN_Description":"Indicates the various system state in the driver alertness warning system. This signal can be used independent of the technology and ECU used to estimate the driver alertness condition.\\r\\n\\r\\n000 = System installed but disabled\\r\\n001 = Initializing\\r\\n010 = System temporarily not available\\r\\n011 = System available\\r\\n100 = System monitoring driver behavior\\r\\n101-110 = Reserved\\r\\n111 = Not Available / Not Installed","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7476":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":0,"SPN":7476,"SPN_Name":"Left Distance to Lane Mark from Vehicle\'s Middle","SPN_Description":"Distance between middle of the vehicle front and the inner/right edge of the nearest lane mark on the left side as measured from the Forward Lane Imager. The value represents the lane width at camera position. Measured values greater than 5 m results in value 251.\\r\\n\\r\\nNote that the middle of the vehicle is used instead of the position of the optical sensor and this sensor is responsible to add an offset when it is not positioned at the middle of the vehicle (set as a parameter to this sensor for information hiding).\\r\\n\\r\\nParameter specific values for this parameter are as follows:\\r\\n\\r\\n251 = not in range\\r\\n252 = not reliable\\r\\n253 = reserved / not used\\r\\n254 = error\\r\\n255 = not available or not installed","bit_length":8,"scaling":0.02,"offset":0,"unit":"m","SLOT_ID":407},"7477":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":8,"SPN":7477,"SPN_Name":"Right Distance to Lane Mark from Vehicle\'s Middle","SPN_Description":"Distance between middle of the vehicle front and the inner/left edge of the nearest lane mark on the right side as measured from the Forward Lane Imager. The value represents the lane width at camera position. Measured values greater than 5 m results in value 251.\\r\\n\\r\\nNote that the middle of the vehicle is used instead of the position of the optical sensor and this sensor is responsible to add an offset when it is not positioned at the middle of the vehicle (set as a parameter to this sensor for information hiding).\\r\\n\\r\\nParameter specific values for this parameter are as follows:\\r\\n\\r\\n251 = not in range\\r\\n252 = not reliable\\r\\n253 = reserved / not used\\r\\n254 = error\\r\\n255 = not available or not installed","bit_length":8,"scaling":0.02,"offset":0,"unit":"m","SLOT_ID":407},"7478":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":16,"SPN":7478,"SPN_Name":"Road Curvature Based on Lane Marks","SPN_Description":"The road curvature parameter is based on lane marks as measured by the FLI.  It is the mean value of the road curvature of the lane marks on the left and right side of the lane. In case one of the lane mark is not recognized anymore, the value is set to the value of other side. The SPN represents the road curvature computed at the camera position.\\r\\n\\r\\nPositive values are used for left curves.  Curvature is the inverst of the radius and is zero for straight roads.\\r\\n\\r\\nParameter specific values for this parameter are as follows:\\r\\n\\r\\nFB01 (64256dec) =  not in range\\r\\nFB02 (64257dec) =  not reliable\\r\\nFB03-FBFF (64258 - 64511dec) = reserved for parameter specific indicator\\r\\nFC00-FDFF (64512 - 65023dec) = reserved range for future indicator bits\\r\\nFExx (65024 - 65279dec) = error indicator\\r\\nFFxx (65280 - 65535dec) = not available or not installed","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"1/km","SLOT_ID":96},"7479":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":32,"SPN":7479,"SPN_Name":"Lane Departure Angle Left","SPN_Description":"Angle between left lane mark and vehicle driving direction. The angle is positive while vehicle is moving towards the lane marks, and negative if not. Measured values outside the limits are represented by signal value 251.\\r\\n\\r\\nParameter specific values for this parameter are as follows:\\r\\n\\r\\n251 = not in range\\r\\n252 = not reliable\\r\\n253 = reserved / not used\\r\\n254 = error\\r\\n255 = not available or not installed","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7480":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":40,"SPN":7480,"SPN_Name":"Lane Departure Angle Right","SPN_Description":"Angle between right lane mark and vehicle driving direction. The angle is positive while vehicle is moving towards the lane marks, and negative if not. Measured values outside the limits are represented by signal value 251.\\r\\n\\r\\nParameter specific values for this parameter are as follows:\\r\\n\\r\\n251 = not in range\\r\\n252 = not reliable\\r\\n253 = reserved / not used\\r\\n254 = error\\r\\n255 = not available or not installed","bit_length":8,"scaling":0.1,"offset":-12.5,"unit":"deg","SLOT_ID":244},"7481":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":48,"SPN":7481,"SPN_Name":"Lane Mark Quality on the Left Side","SPN_Description":"The quality of the nearest lane mark on the left side of the vehicle.\\r\\n\\r\\n000 = no lane marks detected\\r\\n001 = low reliablity of detected lane marks\\r\\n010 = good reliablity of detected lane marks\\r\\n011 = perfect recognition of lane marks\\r\\n100 - 101 = reserved for future use\\r\\n110 = error\\r\\n111 = not available or not installed","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7482":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":51,"SPN":7482,"SPN_Name":"Lane Mark Quality on the Right Side","SPN_Description":"The quality of the nearest lane mark on the right side of the vehicle.\\r\\n\\r\\n000 = no lane marks detected\\r\\n001 = low reliablity of detected lane marks\\r\\n010 = good reliablity of detected lane marks\\r\\n011 = perfect recognition of lane marks\\r\\n100 - 101 = reserved for future use\\r\\n110 = error\\r\\n111 = not available or not installed","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7495":{"PGN":64555,"PGN_Name":"Cruise Control / Vehicle Speed 4","PGN_Description":"CCVS4","first_bit":16,"SPN":7495,"SPN_Name":"Cruise Control Adjusted Maximum Speed","SPN_Description":"Present maximum vehicle velocity at which cruise can be set. This parameter is expected to change during run-time due to functionality that could influence the behavior of the cruise control algorithm. This functionality may include, but is not limited to, a different maximum cruise speed that is dependent on driving conditions, driver performance, etc.\\r\\n\\r\\nIf this parameter is supported, then it has priority over SPN 87. Without any adjustments, SPN 87 and this parameter will be the same value. SPN 87 is not expected to change, and if an adjustment is made to reward the driver or penalize the driver, then SPN 87 would not reflect that adjustment. This parameter will reflect that adjustment.","bit_length":16,"scaling":0.00390625,"offset":0,"unit":"km/h","SLOT_ID":71},"7496":{"PGN":65218,"PGN_Name":"Electronic Retarder Controller 2","PGN_Description":"ERC2","first_bit":8,"SPN":7496,"SPN_Name":"Cruise Control Retarder Active Speed Offset","SPN_Description":"The additional speed above the operator selected cruise control set speed at which the retarder will activate when cruise control is active.","bit_length":16,"scaling":0.00390625,"offset":-125,"unit":"km/h","SLOT_ID":399},"7497":{"PGN":64694,"PGN_Name":"Vehicle Electrical Power 5","PGN_Description":"VEP5","first_bit":40,"SPN":7497,"SPN_Name":"SLI Cranking Predicted Minimum Battery Voltage","SPN_Description":"Prediction of the minimum battery voltage used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\\r\\n\\r\\nThis parameter shall be used to report the predicted minimum cranking voltage of the battery pack.  If the predicted minimum cranking voltage of individual batteries within the battery pack is desired, use SPNs 7906, 7914, 7922, & 7930.","bit_length":8,"scaling":0.2,"offset":0,"unit":"V","SLOT_ID":409},"7498":{"PGN":65106,"PGN_Name":"Vehicle Electrical Power 3","PGN_Description":"VEP3","first_bit":32,"SPN":7498,"SPN_Name":"SLI Battery 2 Net Current","SPN_Description":"Net flow of electrical current into/out of the second battery or second set of batteries used for starting the engine, for lighting, and for ignition (SLI).","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"7502":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":4,"SPN":7502,"SPN_Name":"Aftertreatment Engine Speed Increase request","SPN_Description":"Indicates whether the aftertreatment desires engine speed control in order to increase the engine speed. This is meant to notify the operator that the aftertreatment is requesting an increase in engine speed for thermal purposes.\\r\\n\\r\\nThe operator is expected to utilize the engine speed increase allowed switch SPN 7579 in response to this request.\\r\\n\\r\\n00 = No Request\\r\\n01 = Aftertreatment Engine Speed Control Desired\\r\\n10 = Urgent Aftertreatment Engine Speed Control Desired\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7503":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":6,"SPN":7503,"SPN_Name":"Aftertreatment Engine Load Request","SPN_Description":"Indicates whether the aftertreatment desires engine load to be applied. This is meant to notify the operator that the aftertreatment is requesting engine load for thermal purposes.\\r\\n\\r\\nThe operator is expected to add load to the engine to satisfy this request.\\r\\n\\r\\n00 = No Request\\r\\n01 = Aftertreatment Engine Load Desired\\r\\n10 = Urgent Aftertreatment Engine Load Desired\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7504":{"PGN":64878,"PGN_Name":"Aftertreatment 1 SCR Service Information 1","PGN_Description":"A1SCRSI1","first_bit":56,"SPN":7504,"SPN_Name":"Aftertreatment 1 SCR System Sulfation Level","SPN_Description":"Indicates the sulfur level in the SCR system for aftertreatment 1.\\r\\n.\\r\\n100% level could be the regeneration trigger level (and if conditions are not favorable for regeneration, sulfation loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated SCR system. Values of 25%, 50% and 75% will indicate the general level of sulfur prior to the 100% level where regeneration could be needed.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7513":{"PGN":64577,"PGN_Name":"Alternate Fuel 4","PGN_Description":"AF4","first_bit":48,"SPN":7513,"SPN_Name":"Engine Fuel 2 Injector Metering Rail 1 Pressure 2","SPN_Description":"The second pressure of fuel 2 measured by first rail pressure sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":16,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":106},"7514":{"PGN":64557,"PGN_Name":"Alternate Fuel 5","PGN_Description":"AF5","first_bit":32,"SPN":7514,"SPN_Name":"Engine Fuel 2 Injector Metering Rail 1 Temperature 2","SPN_Description":"The second temperature of fuel 2 measured by first rail temperature sensor in the primary, or first, metering rail as delivered from the supply pump to the injector metering intake.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7515":{"PGN":33024,"PGN_Name":"Aftertreatment System Control","PGN_Description":"AFTSC","first_bit":2,"SPN":7515,"SPN_Name":"Request to Permit DEF Hydraulic Stiffness Check","SPN_Description":"A request to permit the DEF hydraulic stiffness check. The request continues to be broadcast until the stiffness check is finished or the corresponding permission status indicates an error.\\r\\n\\r\\n00 = no request\\r\\n01 = request to permit DEF hydraulic stiffness check or stiffness check is running\\r\\n10 = reserved\\r\\n11 = don\'t care\\r\\n\\r\\nThe DEF hydraulic stiffness check is implemented in order to check for malfunctions and wear (damage) of the DEF dosing system and may be required by OBD legislation.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7516":{"PGN":33024,"PGN_Name":"Aftertreatment System Control","PGN_Description":"AFTSC","first_bit":4,"SPN":7516,"SPN_Name":"Request to Permit DEF Dosing Test Injection","SPN_Description":"A request to permit the DEF dosing test injection. The request continues to be broadcast until the test injection is finished or the corresponding permission status indicates an error.\\r\\n\\r\\n000 = no request\\r\\n001 = request to permit DEF Dosing Test Injection or test injection is running\\r\\n010 = urgent request to permit DEF Dosing Test Injection or test injection is running\\r\\n011-110 = reserved\\r\\n111 = don\'t care","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7517":{"PGN":61476,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 1","PGN_Description":"A1SCRDSR1","first_bit":20,"SPN":7517,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Hydraulic Stiffness Check Permission Status","SPN_Description":"After a request to permit the DEF hydraulic stiffness check has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 1.\\r\\n\\r\\n00 = not allowed\\r\\n01 = DEF hydraulic stiffness check allowed\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7518":{"PGN":61476,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 1","PGN_Description":"A1SCRDSR1","first_bit":22,"SPN":7518,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Dosing Test Injection Permission Status","SPN_Description":"After a request to permit the DEF dosing test injection has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 1.\\r\\n\\r\\n00 = not allowed\\r\\n01 = DEF dosing test injection allowed\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7519":{"PGN":61479,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 1","PGN_Description":"A2SCRDSR1","first_bit":20,"SPN":7519,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Hydraulic Stiffness Check Permission Status","SPN_Description":"After a request to permit the DEF hydraulic stiffness check has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 2.\\r\\n\\r\\n00 = not allowed\\r\\n01 = DEF hydraulic stiffness check allowed\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7520":{"PGN":61479,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 1","PGN_Description":"A2SCRDSR1","first_bit":22,"SPN":7520,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Dosing Test Injection Permission Status","SPN_Description":"After a request to permit the DEF dosing test injection has been indicated, this permission status is expected by the DEF control unit for aftertreatment system 2.\\r\\n\\r\\n00 = not allowed\\r\\n01 = DEF dosing test injection allowed\\r\\n10 = error\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7521":{"PGN":64699,"PGN_Name":"Aftertreatment 1 SCR Electronic Control Module Information","PGN_Description":"A1ECMI","first_bit":8,"SPN":7521,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Control Module 2 Relay Control","SPN_Description":"State signal which indicates when the DEF control module 2 relay of aftertreatment 1 is being energized. On means the ECU is powering the Aftertreatment 1 DEF dosing unit relay. Note that the ECU is external to the relay.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the DEF dosing unit relay\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7522":{"PGN":64699,"PGN_Name":"Aftertreatment 1 SCR Electronic Control Module Information","PGN_Description":"A1ECMI","first_bit":10,"SPN":7522,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Control Module 2 Power Supply 1","SPN_Description":"State signal which indicates when the DEF control module 2 power supply of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the DEF dosing unit power supply\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7523":{"PGN":64699,"PGN_Name":"Aftertreatment 1 SCR Electronic Control Module Information","PGN_Description":"A1ECMI","first_bit":12,"SPN":7523,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Control Module 2 Power Supply 2","SPN_Description":"State signal which indicates when the DEF control module 2 power supply 2 of aftertreatment 1 is being driven. On means the ECU is powering the aftertreatment 1 DEF control module power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the DEF dosing unit power supply\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7524":{"PGN":61475,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 1","PGN_Description":"A1SCRDSI1","first_bit":20,"SPN":7524,"SPN_Name":"Aftertreatment 1 SCR System 2 State","SPN_Description":"Actual state of SCR system 2\\r\\n\\r\\n0000 = Dormant (sleep mode)\\r\\n0001 = Preparing dosing readiness (wake up; prepare to operate; wait for start)\\r\\n0010 = Normal dosing operation\\r\\n0011 = System error pending\\r\\n0100 = Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\\r\\n0101 = Protect mode against heat (pressure buildup)\\r\\n0110 = Protect mode against cold (defreeze)\\r\\n0111 = Shutoff (wait for after-run)\\r\\n1000 = Diagnosis (after-run)\\r\\n1001 = Service test mode, dosing allowed\\r\\n1010 = Service test mode, dosing not allowed\\r\\n1011 = Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed.)\\r\\n1100    Priming (Pressure Buildup)\\r\\n1101    Reserved for future assignment by SAE\\r\\n1110 = Error\\r\\n1111 = Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7525":{"PGN":61478,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 1","PGN_Description":"A2SCRDSI1","first_bit":20,"SPN":7525,"SPN_Name":"Aftertreatment 2 SCR System 2 State","SPN_Description":"Actual state of SCR system 2\\r\\n\\r\\n0000 = Dormant (sleep mode)\\r\\n0001 = Preparing dosing readiness (wake up; prepare to operate; wait for start)\\r\\n0010 = Normal dosing operation\\r\\n0011 = System error pending\\r\\n0100 = Purging (SCR dosing system is removing residual DEF from system prior to shutdown)\\r\\n0101 = Protect mode against heat (pressure buildup)\\r\\n0110 = Protect mode against cold (defreeze)\\r\\n0111 = Shutoff (wait for after-run)\\r\\n1000 = Diagnosis (after-run)\\r\\n1001 = Service test mode, dosing allowed\\r\\n1010 = Service test mode, dosing not allowed\\r\\n1011 = Ok to Power Down (SCR dosing system has complete housekeeping and power may safely be removed.)\\r\\n1100    Priming (Pressure Buildup)\\r\\n1101    Reserved for future assignment by SAE\\r\\n1110 = Error\\r\\n1111 = Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7526":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":34,"SPN":7526,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater Relay 2","SPN_Description":"The aftertreatment system 2 diesel exhaust fluid line heater relay 2 is used to energize one or more DEF line heaters.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7527":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":36,"SPN":7527,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater Relay 3","SPN_Description":"The aftertreatment system 2 diesel exhaust fluid line heater relay 3 is used to energize one or more DEF line heaters.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7528":{"PGN":64551,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Information 2","PGN_Description":"A1DEFI2","first_bit":8,"SPN":7528,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Controller 2 Temperature","SPN_Description":"Temperature of the diesel exhaust fluid at the aftertreatment 1 diesel exhaust fluid controller 2.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7529":{"PGN":64550,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 2","PGN_Description":"A2DEFI2","first_bit":0,"SPN":7529,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Controller Temperature","SPN_Description":"Temperature of the diesel exhaust fluid at the aftertreatment 2 diesel exhaust fluid controller.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7530":{"PGN":64549,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 2","PGN_Description":"AT1T1I2","first_bit":0,"SPN":7530,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Volume 2","SPN_Description":"Second measurement of the ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid storage container for aftertreatment system 1 (exhaust bank 1).  0% is empty and 100% is full.  See SPN 1761 and SPN 3517 for alternate measurements.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7531":{"PGN":64548,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 2","PGN_Description":"AT2T1I2","first_bit":0,"SPN":7531,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Volume 2","SPN_Description":"Second measurement of the ratio of volume of diesel exhaust fluid to the total volume of the diesel exhaust fluid storage container for aftertreatment system 2 (exhaust bank 2).  0% is empty and 100% is full.  See SPN 4426 and SPN 4428 for alternate measurements.\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7532":{"PGN":64698,"PGN_Name":"Aftertreatment 2 SCR Electronic Control Module Information","PGN_Description":"A2ECMI","first_bit":8,"SPN":7532,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Control Module 2 Relay Control","SPN_Description":"State signal which indicates when the DEF control module 2 relay of aftertreatment 2 is being energized. On means the ECU is powering the Aftertreatment 2 DEF dosing unit relay. Note that the ECU is external to the relay.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the DEF dosing unit relay\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7533":{"PGN":64698,"PGN_Name":"Aftertreatment 2 SCR Electronic Control Module Information","PGN_Description":"A2ECMI","first_bit":10,"SPN":7533,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Control Module 2 Power Supply 1","SPN_Description":"State signal which indicates when the DEF control module 2 power supply of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the DEF dosing unit relay\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7534":{"PGN":64698,"PGN_Name":"Aftertreatment 2 SCR Electronic Control Module Information","PGN_Description":"A2ECMI","first_bit":12,"SPN":7534,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Control Module 2 Power Supply 2","SPN_Description":"State signal which indicates when the DEF control module 2 power supply 2 of aftertreatment 2 is being driven. On means the ECU is powering the aftertreatment 2 DEF control module power supply. Note that the control module is external to the ECU.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the DEF dosing unit relay\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7535":{"PGN":64550,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Information 2","PGN_Description":"A2DEFI2","first_bit":8,"SPN":7535,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Controller 2 Temperature","SPN_Description":"Temperature of the diesel exhaust fluid at the aftertreatment 2 diesel exhaust fluid controller 2.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7536":{"PGN":64828,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Supply Information","PGN_Description":"A1DEFSI","first_bit":56,"SPN":7536,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Dosing Unit 2 Diverter Valve","SPN_Description":"Command to the valve which determines whether the diesel exhaust fluid on dosing unit 2 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7537":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":56,"SPN":7537,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Dosing Unit 2 Diverter Valve","SPN_Description":"Command to the valve which determines whether the diesel exhaust fluid of dosing unit 2 is delivered to the injector or is routed back to the diesel exhaust fluid tank. Zero directs all diesel exhaust fluid flow to the injector, 100% sends all diesel exhaust fluid back to the tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7540":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":44,"SPN":7540,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater Relay 3","SPN_Description":"The aftertreatment diesel exhaust fluid line heater relay 3 is used to energize one or more DEF line heaters.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7548":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":0,"SPN":7548,"SPN_Name":"Hybrid System Protection Override Switch","SPN_Description":"Indicates the Protection Override switch position.  This switch allows the operator to override hybrid system protection features and failure modes allowing hybrid system to continue to operate if possible.\\r\\n\\r\\n00 = Not Active\\r\\n01 = Active\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7549":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":2,"SPN":7549,"SPN_Name":"Hybrid System Propulsion Coolant Level Switch","SPN_Description":"Indicates the coolant level switch position in the hybrid system propulsion (e.g. electric motor, generator) cooling system.\\r\\n\\r\\n00 = Coolant Level is not sufficient\\r\\n01 = Coolant Level is sufficient\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7550":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":4,"SPN":7550,"SPN_Name":"Hybrid System Power Electronics Coolant Level Switch","SPN_Description":"Indicates the coolant level switch position in the hybrid system power electronics (e.g. Inverters, DC/DC converters) cooling system.\\r\\n\\r\\n00 = Coolant Level is not sufficient\\r\\n01 = Coolant Level is sufficient\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7551":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":6,"SPN":7551,"SPN_Name":"Hybrid System Off-Board Charger Connection Status","SPN_Description":"Indicates the off-board plug-in charger connection status.  One of the uses of this signal is to protect against vehicle motion while a charger is plugged in.\\r\\n\\n00 = Off-board charger is not connected\\r\\n01 = Off-board charger is connected\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7552":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":8,"SPN":7552,"SPN_Name":"Hybrid System Regenerative Braking Disable Switch","SPN_Description":"Indicates the regenerative braking disable switch position.  This switch gives the operator the ability to disable all regenerative braking from all inputs (e.g. such as during slippery road conditions).\\r\\n\\r\\n00 = Regenerative Braking Disable Switch is off.  Regenerative braking is allowed.\\r\\n01 = Regenerative Braking  Disable Switch is on.  Regenerative braking is not allowed.\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7553":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":10,"SPN":7553,"SPN_Name":"Hybrid System Brake Pedal Regenerative Braking Disable Switch","SPN_Description":"Indicates the brake pedal regenerative braking disable switch position.  This switch allows the operator to disable regenerative braking (e.g. such as during slippery road conditions) that is controlled by brake pedal application.   Regenerative braking is still allowed if requested by other inputs (e.g. coasting regenerative braking level selector (SPN 7556)).\\r\\n  \\r\\n00 = Brake pedal regenerative braking disable switch is off.  When this switch is off, regenerative braking may be activated by brake pedal application.\\r\\n01 = Brake pedal regenerative braking disable switch is on.  When this switch is on, regenerative braking shall not be activated by brake pedal application.\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7554":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":12,"SPN":7554,"SPN_Name":"Hybrid System Propulsion Disable Switch","SPN_Description":"When the operator enables this switch, the propulsion aspect of hybrid system operation will be disabled.  However, hybrid powered accessories may be on and the engine may still run.  Regenerative braking is allowed unless disabled by SPN 7552 (Hybrid System Regenerative Braking Disable Switch) or SPN 7559 (Hybrid System Regenerative Braking Disable Request).  Engine starting by the hybrid system is allowed.  Movement of the vehicle by the hybrid system is not allowed.  \\r\\n\\r\\nThis feature may allow technicians to test the engine independent of hybrid system propulsion (e.g. control engine fueling using the accelerator pedal without Hybrid System assistance).   Another use may be to operate a parallel hybrid system in a conventional engine/transmission mode.  \\r\\n\\r\\nNote: This parameter is not related to SPN 7315 (Propulsion System Active).\\r\\n  \\r\\n00 \u2013 Off; hybrid propulsion is allowed.  \\r\\n01 \u2013 On; hybrid propulsion is not allowed. \\r\\n10 \u2013 Error\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7555":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":14,"SPN":7555,"SPN_Name":"Hybrid System Shutdown Switch","SPN_Description":"When the operator enables this switch, all hybrid system functionality is disabled including propulsion, regenerative braking, and hybrid powered accessories.  For electric hybrids, the hybrid system shall be placed in an electrically off state where high voltage is isolated to energy storage devices only (e.g. open contactors, discharge capacitive energy).  One use of this switch is as an emergency stop capability.\\r\\n   \\r\\nNote: Engine operation is still allowed.  \\r\\n\\r\\n00 \u2013 Off; hybrid system may operate normally.\\r\\n01 \u2013 On; hybrid system functionality is not allowed.\\r\\n10 \u2013 Error\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7556":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":16,"SPN":7556,"SPN_Name":"Hybrid System Coasting Regenerative Braking Level Selector","SPN_Description":"Indicates the coasting regenerative braking level selector position.  Coasting regenerative braking occurs when neither the accelerator nor the brake pedal are depressed.\\r\\n\\n\\nThe coasting regenerative braking level is the position of the driver\u2019s selector, that may be expressed as percent and determined by the ratio of current position to the maximum possible position. The physical device may be a lever, rotary dial, combination of switches, or other device that the driver can use to select the type or amount of coasting regenerative braking needed.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7557":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":0,"SPN":7557,"SPN_Name":"Hybrid System Protection Override Request","SPN_Description":"Indicates the hybrid system protection override request state.  This request allows overriding of hybrid system protection \\r\\nfeatures and failure modes allowing hybrid systems to continue to operate, if possible. This is not the physical switch that performs the protection override.\\r\\n\\r\\nSee SPN 7548 for the signal for the physical switch.\\r\\n\\r\\n00 = Not active\\r\\n01 = Active\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7558":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":2,"SPN":7558,"SPN_Name":"Hybrid System Propulsion Disable Request","SPN_Description":"Indicates the Hybrid System Disable Request state.  The signal gives network controllers the ability to disable the propulsion aspect of hybrid system operation when this request is on.  However, hybrid powered accessories may be on and the engine may still run.  Regenerative braking is allowed unless disabled by SPN 7552 (Hybrid System Regenerative Braking Disable Switch) or SPN 7559 (Hybrid System Regenerative Braking Disable Request).  Engine starting by the hybrid system is allowed.  Movement of the vehicle by the hybrid system is not allowed.  This is not the physical switch that performs the hybrid system propulsion disable.  See SPN 7554 for the physical switch.\\r\\n\\r\\nThis feature may allow technicians to test the engine independent of hybrid system propulsion (e.g. control engine fueling using the accelerator pedal without Hybrid System assistance).   Another use may be to operate a parallel hybrid system in a conventional engine/transmission mode.  \\r\\n\\r\\nNote: This parameter is not related to SPN 7315 (Propulsion System Active).\\r\\n  \\r\\n00 \u2013 Off; hybrid propulsion is allowed  \\r\\n01 \u2013 On; hybrid propulsion is not allowed\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Don\'t Care / Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7559":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":4,"SPN":7559,"SPN_Name":"Hybrid System Regenerative Braking Disable Request","SPN_Description":"Indicates the hybrid system regenerative braking disable request state.  This signal gives network controllers the ability to disable all regenerative braking.  This is not the operator controlled switch that performs regenerative braking disable (See SPN 7552).\\r\\n\\r\\n00 = Regenerative braking disable request is not active.  Regenerative braking is allowed.\\r\\n01 = Regenerative braking disable request is active.  Regenerative braking is not allowed.\\r\\n10 = Reserved\\r\\n11 = Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7560":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":6,"SPN":7560,"SPN_Name":"Hybrid System Shutdown Command","SPN_Description":"Indicates the Hybrid System Shutdown Request state.  The signal gives network controllers the ability to disable all hybrid system functionality including propulsion, regenerative braking, and hybrid powered accessories.  For electric hybrids, the hybrid system shall be placed in an electrically off state where high voltage is isolated to energy storage devices only (e.g. open contactors, discharge capacitive energy).  One use of this request is as an emergency stop capability.\\r\\n \\r\\nNote: Engine operation is still allowed.  \\r\\n\\r\\nThis is not the physical switch that performs the hybrid system propulsion disable.  See SPN 7555 for the physical switch.  \\r\\n\\r\\n00 \u2013 Off; hybrid system may operate normally\\r\\n01 \u2013 On; hybrid system functionality is not allowed\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Don\'t Care / Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7561":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":46,"SPN":7561,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 5","SPN_Description":"The diesel exhaust fluid line heater 5 request for aftertreatment system 1 (exhaust bank 1).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7562":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":48,"SPN":7562,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 6","SPN_Description":"The diesel exhaust fluid line heater 6 request for aftertreatment system 1 (exhaust bank 1).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7563":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":50,"SPN":7563,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 7","SPN_Description":"The diesel exhaust fluid line heater 7 request for aftertreatment system 1 (exhaust bank 1).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7564":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":52,"SPN":7564,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 8","SPN_Description":"The diesel exhaust fluid line heater 8 request for aftertreatment system 1 (exhaust bank 1).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7565":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":54,"SPN":7565,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 9","SPN_Description":"The diesel exhaust fluid line heater 9 request for aftertreatment system 1 (exhaust bank 1).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7566":{"PGN":64832,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 2","PGN_Description":"A1SCRDSR2","first_bit":56,"SPN":7566,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Line Heater 10","SPN_Description":"The diesel exhaust fluid line heater 10 request for aftertreatment system 1 (exhaust bank 1).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7567":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":40,"SPN":7567,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 6","SPN_Description":"The diesel exhaust fluid line heater 6 request for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7568":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":42,"SPN":7568,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 7","SPN_Description":"The diesel exhaust fluid line heater 7 request for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7569":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":44,"SPN":7569,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 8","SPN_Description":"The diesel exhaust fluid line heater 8 request for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7570":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":46,"SPN":7570,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 9","SPN_Description":"The diesel exhaust fluid line heater 9 request for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7571":{"PGN":64826,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 2","PGN_Description":"A2SCRDSR2","first_bit":48,"SPN":7571,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Line Heater 10","SPN_Description":"The diesel exhaust fluid line heater 10 request for aftertreatment system 2 (exhaust bank 2).\\r\\n\\r\\n00 = request for heater to be inactive\\r\\n01 = request for heater to be active\\r\\n10 = reserved for future assignment by SAE\\r\\n11 = not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7572":{"PGN":64549,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 2","PGN_Description":"AT1T1I2","first_bit":8,"SPN":7572,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Temperature 2","SPN_Description":"The second temperature of aftertreatment 1 diesel exhaust fluid in the storage tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7573":{"PGN":64549,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank 1 Information 2","PGN_Description":"AT1T1I2","first_bit":16,"SPN":7573,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Tank Heater 2","SPN_Description":"Percentage of heating applied to the second diesel exhaust fluid tank heater on aftertreatment 1. A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7574":{"PGN":64548,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 2","PGN_Description":"AT2T1I2","first_bit":8,"SPN":7574,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Temperature 2","SPN_Description":"The second temperature of aftertreatment 2 diesel exhaust fluid in the storage tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7575":{"PGN":64548,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank 1 Information 2","PGN_Description":"AT2T1I2","first_bit":16,"SPN":7575,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Tank Heater 2","SPN_Description":"Percentage of heating applied to the second diesel exhaust fluid tank heater on aftertreatment 2. A value of 0% means no heating applied, a value of 100% means full heating applied. The diesel exhaust fluid tank heater warms the diesel exhaust fluid in the diesel exhaust fluid tank.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7579":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":28,"SPN":7579,"SPN_Name":"Elevated Engine Speed Allowed Switch","SPN_Description":"Indicates the state of a switch to indicate the control system is permitted to automatically elevate the engine speed as needed for strategies such as cold mode, aftertreatment regeneration, etc. This is not a direct command to increase the engine speed but rather an acknowledgement by the operator that the speed could be increased automatically, such as in response to an indication to the operator from SPN 7502. However, SPN 7502 is not the only method that could request this behavior. Therefore, SPN 7502 is not required in order to use this SPN.\\r\\n\\r\\n00 Not allowed to elevate engine speed\\r\\n01 Allowed to elevate engine speed\\r\\n10 Error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7580":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":30,"SPN":7580,"SPN_Name":"Aftertreatment Regeneration Engine Speed Allowed Switch","SPN_Description":"If this parameter is 01, then the aftertreatment control system is permitted to perform an aftertreatment regeneration, but the aftertreatment control system is not allowed to take control of the engine speed for the purposes of regeneration. A regeneration will be allowed if the engine speed is high enough due to normal operating conditions, but will not command a regeneration.\\r\\n\\r\\nIf this parameter is 00, then an aftertreatment regeneration is not allowed even if engine speed is high\\r\\nenough for a regeneration.\\r\\n\\r\\n00 Aftertreatment regeneration is not allowed when engine speed exceeds regeneration threshold\\r\\n01 Aftertreatment regeneration is allowed when engine speed exceeds regeneration threshold\\r\\n10 Error\\r\\n11 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7581":{"PGN":65277,"PGN_Name":"Alternate Fuel 1","PGN_Description":"AF1","first_bit":48,"SPN":7581,"SPN_Name":"Engine Gaseous Fuel Pressure Regulator Intake Pressure","SPN_Description":"The pressure of the fuel at the intake of the pressure regulator.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"7587":{"PGN":33280,"PGN_Name":"Tire Configuration Command Information","PGN_Description":"TCCI","first_bit":56,"SPN":7587,"SPN_Name":"Tire Sensor Enable Setting","SPN_Description":"Command signal used to enable/disable the tire sensor. On receipt of this command, the tire sensor may either be enabled or disabled.\\r\\n\\r\\n00 Off / Isolate / Disable\\r\\n01 On / Enable\\r\\n10 Reserved / Not Defined\\r\\n11 Don\u2019t Care / Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7588":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":24,"SPN":7588,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Heater Circuit Breaker","SPN_Description":"The status of the circuit breaker that is used to heat the diesel exhaust fluid.\\r\\n\\r\\n00 off\\r\\n01 on\\r\\n10 error\\r\\n11 not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7589":{"PGN":7680,"PGN_Name":"Alternator Control","PGN_Description":"ALTC","first_bit":0,"SPN":7589,"SPN_Name":"Alternator Setpoint Voltage Command","SPN_Description":"Setpoint voltage command to alternator. The setpoint voltage is the point that is regulated by the alternator. This may or may not be the output of the alternator.","bit_length":16,"scaling":0.001,"offset":0,"unit":"V","SLOT_ID":347},"7590":{"PGN":7680,"PGN_Name":"Alternator Control","PGN_Description":"ALTC","first_bit":16,"SPN":7590,"SPN_Name":"Alternator Excitation Maximum Current Limit","SPN_Description":"Command sent to alternator to set the maximum excitation current of the alternator.","bit_length":8,"scaling":0.25,"offset":0,"unit":"A","SLOT_ID":410},"7591":{"PGN":7680,"PGN_Name":"Alternator Control","PGN_Description":"ALTC","first_bit":24,"SPN":7591,"SPN_Name":"Alternator Torque Ramp Time Command","SPN_Description":"Sets the torque ramp rate in which the alternator can respond to a change in electrical load. 100% represents the reference engine torque (SPN 544). \\r\\n\\r\\nThis value will be applied if the alternator speed is less than Alternator Torque Ramp Maximum Speed Command (SPN 7592). This value is not applied if the alternator speed is greater than Alternator Torque Ramp Maximum Speed Command.","bit_length":8,"scaling":0.1,"offset":0,"unit":"s","SLOT_ID":59},"7592":{"PGN":7680,"PGN_Name":"Alternator Control","PGN_Description":"ALTC","first_bit":32,"SPN":7592,"SPN_Name":"Alternator Torque Ramp Maximum Speed Command","SPN_Description":"The Alternator Torque Ramp Time Command (SPN 7591) is applied if the alternator speed is less than Alternator Torque Ramp Maximum Speed Command (SPN 7592). If the alternator speed is greater than Alternator Torque Ramp Maximum Speed Command, then the alternator\'s default ramp setting is applied.","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"7593":{"PGN":61672,"PGN_Name":"Engine Throttle / Fuel Actuator Control Command 2","PGN_Description":"TFAC2","first_bit":32,"SPN":7593,"SPN_Name":"Engine Fuel Actuator 3 Control Command","SPN_Description":"The control command to fuel actuator 3, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position.  Left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7594":{"PGN":61672,"PGN_Name":"Engine Throttle / Fuel Actuator Control Command 2","PGN_Description":"TFAC2","first_bit":48,"SPN":7594,"SPN_Name":"Engine Fuel Actuator 4 Control Command","SPN_Description":"The control command to fuel actuator 4, normalized to percent, where 0% represents fully closed and 100% represents fully open.  Typically, this fuel actuator is used to regulate low pressure natural gas flow rate, mixing into the air flow, which together then come into the engine. Using the standard convention for determining the position.  Left/front is #1 (SPN 633), left/rear is #2 (SPN 1244), right/front is #3 (SPN 7593) and right/rear is #4 (SPN 7594).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7595":{"PGN":64735,"PGN_Name":"Engine Fluid Level/Pressure 12","PGN_Description":"EFL/P12","first_bit":40,"SPN":7595,"SPN_Name":"Engine Throttle Valve 2 Differential Pressure","SPN_Description":"The differential pressure between the intake and outlet of the throttle valve 2 (SPN 3673). The differential pressure is measured from the intake with respect to the outlet of the throttle valve.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"7596":{"PGN":64737,"PGN_Name":"Fuel Economy 2 (Liquid)","PGN_Description":"LFE2","first_bit":32,"SPN":7596,"SPN_Name":"Engine Diesel Fuel Demand Rate","SPN_Description":"Amount of diesel fuel that would be consumed by an engine per unit of time if it were not substituting gaseous fuel.  This parameter is the sum of SPN 183 and the amount of diesel fuel that is being displaced by gaseous fuel.  If the engine is not actually substituting gaseous fuel, then this parameter will be the same as SPN 183.","bit_length":16,"scaling":0.05,"offset":0,"unit":"l/h","SLOT_ID":42},"7597":{"PGN":64547,"PGN_Name":"Fuel Consumption (Liquid) 2","PGN_Description":"LFC2","first_bit":0,"SPN":7597,"SPN_Name":"Engine Total Diesel Fuel Demand","SPN_Description":"Accumulated amount of liquid fuel that would have been used during engine operation, including actual diesel fuel used and the diesel fuel that was displaced by gaseous fuel.\\r\\n\\r\\nThis is the cumulative value of SPN 7596.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"7606":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":32,"SPN":7606,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Tank Volume","SPN_Description":"The derived diesel exhaust fluid tank volume in applications with multiple level sensors in a single tank. The SPN data will be derived from all level sensors in the tank.\\r\\n\\r\\nNote: This SPN can be derived from any of the aftertreatment tank level sensors including SPN 1761, SPN 7530, SPN 4426 or SPN 7531.\\r\\n\\r\\n0 % = Empty\\r\\n100% = Full\\r\\n\\r\\nParameter Specific Indicator:\\r\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7607":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":40,"SPN":7607,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Tank Temperature","SPN_Description":"The derived diesel exhaust fluid tank temperature in applications with multiple temperature sensors in a single tank. The SPN data will be derived from all temperature sensors in the tank.\\r\\n\\r\\nNote: This SPN can be derived from any of the aftertreatment tank temperature sensors including SPN 3031, SPN 7572, SPN 4427 or SPN 7574.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7608":{"PGN":64546,"PGN_Name":"Electronic Engine Controller 19","PGN_Description":"EEC19","first_bit":0,"SPN":7608,"SPN_Name":"Total Engine Energy","SPN_Description":"The total amount of energy delivered by the engine. It is accumulated over the life of the engine.","bit_length":32,"scaling":1,"offset":0,"unit":"kWh","SLOT_ID":150},"7609":{"PGN":61498,"PGN_Name":"Engine Cylinder 1 Combustion Information","PGN_Description":"ECCI1","first_bit":48,"SPN":7609,"SPN_Name":"Engine Cylinder 1 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 1. This knock occurs at frequencies below the typical knock level reported on SPNs 1352 & 6398. The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1352 (and 6398).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7610":{"PGN":61499,"PGN_Name":"Engine Cylinder 2 Combustion Information","PGN_Description":"ECCI2","first_bit":48,"SPN":7610,"SPN_Name":"Engine Cylinder 2 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 2. This knock occurs at frequencies below the typical knock level reported on SPNs 1353 & 6402.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1353 (and 6402).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7611":{"PGN":61500,"PGN_Name":"Engine Cylinder 3 Combustion Information","PGN_Description":"ECCI3","first_bit":48,"SPN":7611,"SPN_Name":"Engine Cylinder 3 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 3. This knock occurs at frequencies below the typical knock level reported on SPNs 1354 & 6406.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1354 (and 6406).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7612":{"PGN":61501,"PGN_Name":"Engine Cylinder 4 Combustion Information","PGN_Description":"ECCI4","first_bit":48,"SPN":7612,"SPN_Name":"Engine Cylinder 4 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 4. This knock occurs at frequencies below the typical knock level reported on SPNs 1355 & 6410.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1355 (and 6410).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7613":{"PGN":61502,"PGN_Name":"Engine Cylinder 5 Combustion Information","PGN_Description":"ECCI5","first_bit":48,"SPN":7613,"SPN_Name":"Engine Cylinder 5 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 5. This knock occurs at frequencies below the typical knock level reported on SPNs 1356 & 6414.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1356 (and 6414).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7614":{"PGN":61503,"PGN_Name":"Engine Cylinder 6 Combustion Information","PGN_Description":"ECCI6","first_bit":48,"SPN":7614,"SPN_Name":"Engine Cylinder 6 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 6. This knock occurs at frequencies below the typical knock level reported on SPNs 1357 & 6418.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1357 (and 6418).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7615":{"PGN":61504,"PGN_Name":"Engine Cylinder 7 Combustion Information","PGN_Description":"ECCI7","first_bit":48,"SPN":7615,"SPN_Name":"Engine Cylinder 7 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 7. This knock occurs at frequencies below the typical knock level reported on SPNs 1358 & 6422.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1358 (and 6422).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7616":{"PGN":61505,"PGN_Name":"Engine Cylinder 8 Combustion Information","PGN_Description":"ECCI8","first_bit":48,"SPN":7616,"SPN_Name":"Engine Cylinder 8 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 8. This knock occurs at frequencies below the typical knock level reported on SPNs 1359 & 6426.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1359 (and 6426).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7617":{"PGN":61506,"PGN_Name":"Engine Cylinder 9 Combustion Information","PGN_Description":"ECCI9","first_bit":48,"SPN":7617,"SPN_Name":"Engine Cylinder 9 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 9. This knock occurs at frequencies below the typical knock level reported on SPNs 1360 & 6430.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1360 (and 6430).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7618":{"PGN":61507,"PGN_Name":"Engine Cylinder 10 Combustion Information","PGN_Description":"ECCI10","first_bit":48,"SPN":7618,"SPN_Name":"Engine Cylinder 10 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 10. This knock occurs at frequencies below the typical knock level reported on SPNs 1361 & 6434.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1361 (and 6434).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7619":{"PGN":61508,"PGN_Name":"Engine Cylinder 11 Combustion Information","PGN_Description":"ECCI11","first_bit":48,"SPN":7619,"SPN_Name":"Engine Cylinder 11 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 11. This knock occurs at frequencies below the typical knock level reported on SPNs 1362 & 6438.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1362 (and 6438).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7620":{"PGN":61509,"PGN_Name":"Engine Cylinder 12 Combustion Information","PGN_Description":"ECCI12","first_bit":48,"SPN":7620,"SPN_Name":"Engine Cylinder 12 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 12. This knock occurs at frequencies below the typical knock level reported on SPNs 1363 & 6442.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1363 (and 6442).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7621":{"PGN":61510,"PGN_Name":"Engine Cylinder 13 Combustion Information","PGN_Description":"ECCI13","first_bit":48,"SPN":7621,"SPN_Name":"Engine Cylinder 13 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 13. This knock occurs at frequencies below the typical knock level reported on SPNs 1364 & 6446.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1364 (and 6446).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7622":{"PGN":61511,"PGN_Name":"Engine Cylinder 14 Combustion Information","PGN_Description":"ECCI14","first_bit":48,"SPN":7622,"SPN_Name":"Engine Cylinder 14 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 14. This knock occurs at frequencies below the typical knock level reported on SPNs 1365 & 6450.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1365 (and 6450).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7623":{"PGN":61512,"PGN_Name":"Engine Cylinder 15 Combustion Information","PGN_Description":"ECCI15","first_bit":48,"SPN":7623,"SPN_Name":"Engine Cylinder 15 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 15. This knock occurs at frequencies below the typical knock level reported on SPNs 1366 & 6454.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1366 (and 6454).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7624":{"PGN":61513,"PGN_Name":"Engine Cylinder 16 Combustion Information","PGN_Description":"ECCI16","first_bit":48,"SPN":7624,"SPN_Name":"Engine Cylinder 16 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 16. This knock occurs at frequencies below the typical knock level reported on SPNs 1367 & 6458.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1367 (and 6458).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7625":{"PGN":61514,"PGN_Name":"Engine Cylinder 17 Combustion Information","PGN_Description":"ECCI17","first_bit":48,"SPN":7625,"SPN_Name":"Engine Cylinder 17 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 17. This knock occurs at frequencies below the typical knock level reported on SPNs 1368 & 6462.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1368 (and 6462).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7626":{"PGN":61515,"PGN_Name":"Engine Cylinder 18 Combustion Information","PGN_Description":"ECCI18","first_bit":48,"SPN":7626,"SPN_Name":"Engine Cylinder 18 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 18. This knock occurs at frequencies below the typical knock level reported on SPNs 1369 & 6466.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1369 (and 6466).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7627":{"PGN":61516,"PGN_Name":"Engine Cylinder 19 Combustion Information","PGN_Description":"ECCI19","first_bit":48,"SPN":7627,"SPN_Name":"Engine Cylinder 19 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 19. This knock occurs at frequencies below the typical knock level reported on SPNs 1370 & 6470.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1370 (and 6470).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7628":{"PGN":61517,"PGN_Name":"Engine Cylinder 20 Combustion Information","PGN_Description":"ECCI20","first_bit":48,"SPN":7628,"SPN_Name":"Engine Cylinder 20 Low Frequency Knock Level","SPN_Description":"Indicates the level of low frequency knock for engine cylinder 20. This knock occurs at frequencies below the typical knock level reported on SPNs 1371 & 6474.  The level of low frequency knock is reported using a relative scale where 0% is least level of knock, and increasing levels indicate more low frequency knock until 100% indicates the most severe level of low frequency knock allowed or measurable for the engine. If only one knock level is supported per cylinder, use SPN(s) 1371 (and 6474).","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7629":{"PGN":61498,"PGN_Name":"Engine Cylinder 1 Combustion Information","PGN_Description":"ECCI1","first_bit":56,"SPN":7629,"SPN_Name":"Engine Cylinder 1 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 1 during the combustion cycle.\\r\\n","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7630":{"PGN":61499,"PGN_Name":"Engine Cylinder 2 Combustion Information","PGN_Description":"ECCI2","first_bit":56,"SPN":7630,"SPN_Name":"Engine Cylinder 2 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 2 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7631":{"PGN":61500,"PGN_Name":"Engine Cylinder 3 Combustion Information","PGN_Description":"ECCI3","first_bit":56,"SPN":7631,"SPN_Name":"Engine Cylinder 3 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 3 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7632":{"PGN":61501,"PGN_Name":"Engine Cylinder 4 Combustion Information","PGN_Description":"ECCI4","first_bit":56,"SPN":7632,"SPN_Name":"Engine Cylinder 4 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 4 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7633":{"PGN":61502,"PGN_Name":"Engine Cylinder 5 Combustion Information","PGN_Description":"ECCI5","first_bit":56,"SPN":7633,"SPN_Name":"Engine Cylinder 5 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 5 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7634":{"PGN":61503,"PGN_Name":"Engine Cylinder 6 Combustion Information","PGN_Description":"ECCI6","first_bit":56,"SPN":7634,"SPN_Name":"Engine Cylinder 6 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 6 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7635":{"PGN":61504,"PGN_Name":"Engine Cylinder 7 Combustion Information","PGN_Description":"ECCI7","first_bit":56,"SPN":7635,"SPN_Name":"Engine Cylinder 7 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 7 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7636":{"PGN":61505,"PGN_Name":"Engine Cylinder 8 Combustion Information","PGN_Description":"ECCI8","first_bit":56,"SPN":7636,"SPN_Name":"Engine Cylinder 8 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 8 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7637":{"PGN":61506,"PGN_Name":"Engine Cylinder 9 Combustion Information","PGN_Description":"ECCI9","first_bit":56,"SPN":7637,"SPN_Name":"Engine Cylinder 9 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 9 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7638":{"PGN":61507,"PGN_Name":"Engine Cylinder 10 Combustion Information","PGN_Description":"ECCI10","first_bit":56,"SPN":7638,"SPN_Name":"Engine Cylinder 10 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 10 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7639":{"PGN":61508,"PGN_Name":"Engine Cylinder 11 Combustion Information","PGN_Description":"ECCI11","first_bit":56,"SPN":7639,"SPN_Name":"Engine Cylinder 11 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 11 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7640":{"PGN":61509,"PGN_Name":"Engine Cylinder 12 Combustion Information","PGN_Description":"ECCI12","first_bit":56,"SPN":7640,"SPN_Name":"Engine Cylinder 12 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 12 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7641":{"PGN":61510,"PGN_Name":"Engine Cylinder 13 Combustion Information","PGN_Description":"ECCI13","first_bit":56,"SPN":7641,"SPN_Name":"Engine Cylinder 13 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 13 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7642":{"PGN":61511,"PGN_Name":"Engine Cylinder 14 Combustion Information","PGN_Description":"ECCI14","first_bit":56,"SPN":7642,"SPN_Name":"Engine Cylinder 14 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 14 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7643":{"PGN":61512,"PGN_Name":"Engine Cylinder 15 Combustion Information","PGN_Description":"ECCI15","first_bit":56,"SPN":7643,"SPN_Name":"Engine Cylinder 15 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 15 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7644":{"PGN":61513,"PGN_Name":"Engine Cylinder 16 Combustion Information","PGN_Description":"ECCI16","first_bit":56,"SPN":7644,"SPN_Name":"Engine Cylinder 16 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 16 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7645":{"PGN":61514,"PGN_Name":"Engine Cylinder 17 Combustion Information","PGN_Description":"ECCI17","first_bit":56,"SPN":7645,"SPN_Name":"Engine Cylinder 17 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 17 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7646":{"PGN":61515,"PGN_Name":"Engine Cylinder 18 Combustion Information","PGN_Description":"ECCI18","first_bit":56,"SPN":7646,"SPN_Name":"Engine Cylinder 18 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 18 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7647":{"PGN":61516,"PGN_Name":"Engine Cylinder 19 Combustion Information","PGN_Description":"ECCI19","first_bit":56,"SPN":7647,"SPN_Name":"Engine Cylinder 19 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 19 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7648":{"PGN":61517,"PGN_Name":"Engine Cylinder 20 Combustion Information","PGN_Description":"ECCI20","first_bit":56,"SPN":7648,"SPN_Name":"Engine Cylinder 20 Maximum Pressure Increase Rate","SPN_Description":"The maximum slope, in degrees of crank angle, of the pressure increase in engine cylinder 20 during the combustion cycle.","bit_length":8,"scaling":16,"offset":0,"unit":"kPa/deg crank angle","SLOT_ID":411},"7649":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":0,"SPN":7649,"SPN_Name":"Aftertreatment 1 SCR Intake NOx 2","SPN_Description":"The second measurement of the amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by a NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1 Dosing Unit 1.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7650":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":16,"SPN":7650,"SPN_Name":"Aftertreatment 1 Intake Percent Oxygen 2","SPN_Description":"The second measurement of the actual oxidation factor (Percent Oxygen) of the gas within the exhaust stream. For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion. For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor. This value is measured by a sensor at the aftertreatment intake in exhaust bank 1.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"7651":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":32,"SPN":7651,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 2 Power In Range","SPN_Description":"Indicates that the second measurement of power supplied to the aftertreatment intake gas sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 1.  This parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7652":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":34,"SPN":7652,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 2 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment intake gas second sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 1.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7653":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":36,"SPN":7653,"SPN_Name":"Aftertreatment 1 SCR Intake NOx 2 Reading Stable","SPN_Description":"Indicates that the NOx reading of the aftertreatment intake NOx second sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7654":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":38,"SPN":7654,"SPN_Name":"Aftertreatment 1 Intake Wide-Range Percent Oxygen 2 Reading Stable","SPN_Description":"Indicates that the second measurement of the percent oxygen reading of the aftertreatment intake gas sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7655":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":40,"SPN":7655,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 2 Heater Preliminary FMI","SPN_Description":"Used to identify the second applicable J1939-73 FMI detected in the heater of the intake exhaust gas sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7656":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":45,"SPN":7656,"SPN_Name":"Aftertreatment 1 Intake Gas Sensor 2 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the second gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7657":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":48,"SPN":7657,"SPN_Name":"Aftertreatment 1 SCR Intake NOx Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx second sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.   In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7658":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":53,"SPN":7658,"SPN_Name":"Aftertreatment 1 Intake NOx Sensor 2 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for the second NOx sensor ATI1 (Aftertreatment Intake Bank 1)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATI1 Self Diagnosis active flag\\r\\n010 NOx Sensor ATI1 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATI1 Self Diagnosis aborted\\r\\n100 NOx Sensor ATI1 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7659":{"PGN":61673,"PGN_Name":"Aftertreatment 1 Intake Gas 3","PGN_Description":"AT1IG3","first_bit":56,"SPN":7659,"SPN_Name":"Aftertreatment 1 Intake Oxygen Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the second applicable J1939-73 FMI detected in the aftertreatment intake oxygen sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.   In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7660":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":0,"SPN":7660,"SPN_Name":"Aftertreatment 1 Outlet NOx 2","SPN_Description":"The second measurement of the amount of combined NO and NO2 in the exhaust exiting the aftertreatment system measured by a NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 1.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7661":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":16,"SPN":7661,"SPN_Name":"Aftertreatment 1 Outlet Percent Oxygen 2","SPN_Description":"The second measurement of the actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by a sensor at the aftertreatment outlet in exhaust bank 1.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"7662":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":32,"SPN":7662,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 2 Power In Range","SPN_Description":"Indicates that the second measurement of power supplied to the aftertreatment outlet gas sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 1. This parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7663":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":34,"SPN":7663,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 2 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment outlet gas second sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 1.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7664":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":36,"SPN":7664,"SPN_Name":"Aftertreatment 1 Outlet NOx 2 Reading Stable","SPN_Description":"Indicates that the NOx reading of the aftertreatment outlet NOx second sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7665":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":38,"SPN":7665,"SPN_Name":"Aftertreatment 1 Outlet Wide-Range Percent Oxygen 2 Reading Stable","SPN_Description":"Indicates that the percent oxygen reading of the aftertreatment outlet gas second sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 1.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7666":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":40,"SPN":7666,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 2 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas second sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 1.    In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7667":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":45,"SPN":7667,"SPN_Name":"Aftertreatment 1 Outlet Gas Sensor 2 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas second sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 1.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7668":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":48,"SPN":7668,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx second sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7669":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":53,"SPN":7669,"SPN_Name":"Aftertreatment 1 Outlet NOx Sensor 2 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for NOx second sensor ATO1 (Aftertreatment Outlet Bank 1)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATO1 Self Diagnosis active flag\\r\\n010 NOx Sensor ATO1 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATO1 Self Diagnosis aborted\\r\\n100 NOx Sensor ATO1 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7670":{"PGN":61674,"PGN_Name":"Aftertreatment 1 Outlet Gas 3","PGN_Description":"AT1OG3","first_bit":56,"SPN":7670,"SPN_Name":"Aftertreatment 1 Outlet Oxygen Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen second sensor by the manufacturer\u2019s sensor control software in exhaust bank 1.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7671":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":0,"SPN":7671,"SPN_Name":"Aftertreatment 2 SCR Intake NOx 2","SPN_Description":"The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by the second NOx sensor at the aftertreatment intake, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7672":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":16,"SPN":7672,"SPN_Name":"Aftertreatment 2 Intake Percent Oxygen 2","SPN_Description":"The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by the second sensor at the aftertreatment intake in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"7673":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":32,"SPN":7673,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 2 Power In Range","SPN_Description":"Indicates that the power supplied to the aftertreatment intake gas second sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\nThis parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7674":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":34,"SPN":7674,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 2 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment intake gas second sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7675":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":36,"SPN":7675,"SPN_Name":"Aftertreatment 2 SCR Intake NOx 2 Reading Stable","SPN_Description":" Indicates that the NOx reading of the aftertreatment intake NOx second sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7676":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":38,"SPN":7676,"SPN_Name":"Aftertreatment 2 Intake Wide-Range Percent Oxygen 2 Reading Stable","SPN_Description":"Indicates that the percent oxygen reading of the aftertreatment intake gas second sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7677":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":40,"SPN":7677,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 2 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the intake exhaust gas second sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7678":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":45,"SPN":7678,"SPN_Name":"Aftertreatment 2 Intake Gas Sensor 2 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the second gas sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7679":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":48,"SPN":7679,"SPN_Name":"Aftertreatment 2 SCR Intake NOx Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake NOx second sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7680":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":53,"SPN":7680,"SPN_Name":"Aftertreatment 2 Intake NOx Sensor 2 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for NOx second sensor ATI2 (Aftertreatment Intake Bank 2)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATI2 Self Diagnosis active flag\\r\\n010 NOx Sensor ATI2 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATI2 Self Diagnosis aborted\\r\\n100 NOx Sensor ATI2 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7681":{"PGN":61675,"PGN_Name":"Aftertreatment 2 Intake Gas Sensor 2","PGN_Description":"AT2IGS2","first_bit":56,"SPN":7681,"SPN_Name":"Aftertreatment 2 Intake Oxygen Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment intake oxygen second sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7682":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":0,"SPN":7682,"SPN_Name":"Aftertreatment 2 Outlet NOx 2","SPN_Description":"The amount of combined NO and NO2 in the exhaust entering the aftertreatment system measured by the second NOx sensor at the aftertreatment outlet, represented in NOx molecule parts per million non-NOx molecules in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.","bit_length":16,"scaling":0.05,"offset":-200,"unit":"ppm","SLOT_ID":236},"7683":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":16,"SPN":7683,"SPN_Name":"Aftertreatment 2 Outlet Percent Oxygen 2","SPN_Description":"The actual oxidation factor (percent oxygen) of the gas within the exhaust stream.  For positive values, the parameter represents the percent oxygen in excess of the amount required for stoichiometric combustion.  For negative values, the parameter is proportional to the amount of oxygen being pumped by the sensor.  This value is measured by the second sensor at the aftertreatment outlet in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\nA value of -12% (0x0000) indicates rich, a value of 21% (0xFAFF) indicates lean.  These data points could optionally be used with switching O2 sensors to indicate those states as alternatives to broadcasting the threshold %O2 values. Diagnostic Tools could change display to use the text \\"Rich\\" or \\"Lean\\" in place of the implied %O2 values which would also be acceptable for display.","bit_length":16,"scaling":0.000514,"offset":-12,"unit":"%","SLOT_ID":237},"7684":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":32,"SPN":7684,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 2 Power In Range","SPN_Description":" Indicates that the power supplied to the aftertreatment outlet gas second sensor, either NOx or O2, is within the manufacturer\u2019s specification in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\nThis parameter reports the status as reported by the sensor.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7685":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":34,"SPN":7685,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 2 at Temperature","SPN_Description":"Indicates that the heater element of the aftertreatment outlet gas second sensor, either NOx or O2, is within the manufacturer\u2019s specified range for accurate measurements in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not in range\\r\\n01 - In range\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7686":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":36,"SPN":7686,"SPN_Name":"Aftertreatment 2 Outlet NOx  2 Reading Stable","SPN_Description":"Indicates that the NOx reading of the aftertreatment outlet NOx second sensor is stable as determined by the manufacturer\u2019s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7687":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":38,"SPN":7687,"SPN_Name":"Aftertreatment 2 Outlet Wide-Range Percent Oxygen 2 Reading Stable","SPN_Description":"Indicates that the percent oxygen reading of the aftertreatment outlet gas second sensor, either NOx or O2, is stable as determined by the manufacturer\'s control software in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Not stable\\r\\n01 - Stable\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7688":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":40,"SPN":7688,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 2 Heater Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the heater of the outlet exhaust gas second sensor, either NOx or O2, by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7689":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":45,"SPN":7689,"SPN_Name":"Aftertreatment 2 Outlet Gas Sensor 2 Heater Control","SPN_Description":"Indicates the heater status in the warm-up process.  Upon receiving a power-up command, the gas second sensor ramps up according to a manufacturer defined profile.  The Preheat 1, Preheat 2, and Automatic messages are regions within this profile in exhaust bank 2.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948, and 65247.\\r\\n\\r\\n00 - Automatic\\r\\n01 - Preheat 2\\r\\n10 - Preheat 1\\r\\n11 - Heater off","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7690":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":48,"SPN":7690,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet NOx second sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948 and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7691":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":53,"SPN":7691,"SPN_Name":"Aftertreatment 2 Outlet NOx Sensor 2 Self-diagnosis Status","SPN_Description":"Self-diagnosis result status for second NOx sensor ATO2 (Aftertreatment Outlet Bank 2)\\r\\n\\r\\n000 Diagnosis not active\\r\\n001 NOx Sensor ATO2 Self Diagnosis active flag\\r\\n010 NOx Sensor ATO2 Self Diagnosis Result Complete\\r\\n011 NOx Sensor ATO2 Self Diagnosis aborted\\r\\n100 NOx Sensor ATO2 Self Diagnosis not possible\\r\\n101 - 110 Reserved\\r\\n111 Not Supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7692":{"PGN":61676,"PGN_Name":"Aftertreatment 2 Outlet Gas Sensor 2","PGN_Description":"AT2OGS2","first_bit":56,"SPN":7692,"SPN_Name":"Aftertreatment 2 Outlet Oxygen Sensor 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in the aftertreatment outlet oxygen second sensor by the manufacturer\u2019s sensor control software in exhaust bank 2.  In the case of multiple failures the most severe is communicated.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nFor a single exhaust bank system, refer to parameters in PGNs 61454, 61455, 64946, 64947, 64948 and 65247.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7694":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":48,"SPN":7694,"SPN_Name":"Transmission Auto-Neutral (Manual Return) Enable Switch","SPN_Description":"This enable switch is for optional use with interfaces using SPN 7695 [Transmission Auto-Neutral (Manual Return) Request] or another vehicle input configured for Auto-Neutral (Manual Return) functionality. When supported by the vehicle system and transmission manufacturer, this switch allows the operator to prohibit the transmission from responding to temporary Auto-Neutral requests made via SPN 7695 or another designated Auto-Neutral (Manual Return) input.\\r\\n\\r\\n00 = Off; transmission will not respond to Auto-Neutral (Manual Return) requests made via SPN 7695 or other\\r\\ndesignated input.\\r\\n01 = On; transmission may respond to Auto-Neutral (Manual Return) requests made via SPN 7695 or other\\r\\ndesignated input.\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7695":{"PGN":256,"PGN_Name":"Transmission Control 1","PGN_Description":"TC1","first_bit":48,"SPN":7695,"SPN_Name":"Transmission Auto-Neutral (Manual Return) Request","SPN_Description":"This parameter conveys a vehicle system desire to override the operator\u2019s current shift selector request (e.g. Drive, Reverse) and shift the transmission into Neutral. \u201CManual Return\u201D indicates this parameter has the ability to initiate a transmission shift to Neutral, but it does not provide any capability for the transmission to automatically return to range after Neutral is achieved, or after the request is revoked. See parameter SPN 7696 for transmission status and response to this request.\\r\\n\\r\\nEntry Criteria:\\r\\nThe transmission shall only respond to this Auto-Neutral request when the shift selector is in a Non-Neutral position. If the vehicle system and transmission both support SPN 7694 [Transmission Auto-Neutral (Manual Return) Enable Switch], the transmission shall only respond to this Auto-Neutral request when SPN 7694 = 01b. When the transmission receives SPN 7695 = 01b, and all other transmission manufacturer-specific criteria are satisfied (e.g. vehicle is stopped), the transmission shall shift to Neutral.\\r\\n\\r\\nExit Criteria:\\r\\nTo exit from the resulting Auto-Neutral state, the vehicle operator must provide shift selector input (i.e. the \u201CManual Return\u201D) before the vehicle can be driven. The exact shift selector input or sequence required to exit the Auto-Neutral state may be transmission manufacturer specific. In applications where transmission range selection is accomplished through a mechanical linkage, the shift selector will need to be physically moved in order to exit the Auto-Neutral state.\\r\\n\\r\\nThe transmission may opt to honor the shift selector input only when this parameter is set to the 00b state, or it may opt to do so for any/all other states. If the shift selector input is honored for states other than 00b, this parameter must return to 00b before the transmission will honor another request to the Auto-Neutral state.\\r\\n\\r\\nNote: SPN 683 [Disengage Driveline Request] differs from this parameter in that SPN 683 provides a method to \u201Csimply disengage the driveline, e.g., to prevent engine drag torque from causing high wheel slip on slippery surfaces.\u201D SPN 7695 puts the driveline in a Neutral state such that other vehicle activities (e.g. PTO operation) can occur. SPN 7696 provides explicit feedback that Neutral has or has not been achieved in response to SPN 7695.\\r\\n\\r\\n00 = No request to shift to Auto-Neutral state\\r\\n01 = Request to shift to Auto-Neutral state\\r\\n10 = Reserved\\r\\n11 = Don\u2019t Care / Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7696":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":51,"SPN":7696,"SPN_Name":"Transmission Auto-Neutral (Manual Return) State","SPN_Description":"Indicates the transmission response to a Neutral request from SPN 7695 [Transmission Auto-Neutral (Manual Return) Request] or other vehicle input configured for Auto-Neutral (Manual Return) functionality. The applicability of the states and state transitions depend on transmission manufacturer options and implementation (e.g. function entry and exit criteria) of the Auto-Neutral (Manual Return) function.\\r\\n\\r\\nNote: While SPN 523 ETC2 Transmission Current Gear can be used to determine if the transmission has attained a Neutral state; SPN 7696 indicates if that Neutral state resulted from SPN 7695 or another input configured for this functionality.\\r\\n\\r\\n000 = No request received; conditions are such that an Auto-Neutral request would be honored.\\r\\n001 = No request received; conditions are such that an Auto-Neutral request would NOT be honored.\\r\\n010 = Auto-Neutral request received; shift to Auto-Neutral state is pending.\\r\\n011 = Auto-Neutral request received; shift to Auto-Neutral state has been achieved.\\r\\n100 = Auto-Neutral request received; shift to Auto-Neutral state is inhibited.\\r\\n101 = Reserved\\r\\n110 = Error\\r\\n111 = Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7699":{"PGN":64537,"PGN_Name":"Payload System Totals 1","PGN_Description":"PLST1","first_bit":0,"SPN":7699,"SPN_Name":"Total Delivered Payload Weight","SPN_Description":"The accumulated delivered payload mass over the life of the product.\\r\\n\\r\\nThis should be a monotonically increasing number that sums delivered payload weights (SPN 6849) If transactions are supported (Payload Delivery Transaction Status, SPN 7702) then total delivered payload weight may not be incremented until the transaction is complete in order to account for cancelled or otherwise incomplete transactions.\\r\\n\\r\\nIf transactions are not supported, then every delivered payload can be accumulated as the haul cycle completes.","bit_length":32,"scaling":100,"offset":0,"unit":"kg","SLOT_ID":412},"7700":{"PGN":64537,"PGN_Name":"Payload System Totals 1","PGN_Description":"PLST1","first_bit":32,"SPN":7700,"SPN_Name":"Total Haul Cycle Count","SPN_Description":"The total accumulated number of haul cycles over the life of the product.\\r\\n\\r\\nThis should be a monotonically increasing number that sums Haul Cycle Count (SPN 6847). If transactions are supported via Payload Delivery Transaction Status (SPN 7702) then total haul cycle count may not be incremented until the transaction is complete in order to account for cancelled or otherwise incomplete transactions.\\r\\n\\r\\nIf transactions are not supported, then every haul cycle count can be accumulated as the haul cycle completes.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"7701":{"PGN":64536,"PGN_Name":"Payload System Totals 2","PGN_Description":"PLST2","first_bit":0,"SPN":7701,"SPN_Name":"Total Payload Transaction Count","SPN_Description":"The accumulated number of completed payload delivery transactions over the life of the product.\\r\\n\\r\\nIf transaction status monitoring is supported via Payload Delivery Transaction Status (SPN 7702) then total payload transaction count may increment when the transaction status transitions from \\"Transaction In Progress\\" to \\"Transaction Complete\\".\\r\\n\\r\\nIf transaction status monitoring is not supported then total payload transaction count may be determined by an application specific means.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"7702":{"PGN":64592,"PGN_Name":"Payload System Status","PGN_Description":"PLSS","first_bit":20,"SPN":7702,"SPN_Name":"Payload Delivery Transaction Status","SPN_Description":"The current state of the payload delivery transaction.\\r\\n\\r\\nWhen a transaction is in progress, a receiving node may monitor Haul Cycle Count (SPN 6847) and Delivered Payload Weight (SPN 6849) in order to track the progress of a transaction, where the haul cycle count represents the number of haul cycles within the transaction and delivered payload weight represents the payload weight delivered within the transaction.\\r\\n\\r\\nEach transaction can be comprised of one-to-many haul cycles. Certain equipment may require multiple haul cycles in order to complete a payload transaction. Haul Cycle Count (SPN 6847) and the corresponding Delivered Payload Weight (SPN 6849) may be used in order to determine the number of haul cycles and amount of delivered payload for the active transaction.\\r\\n\\r\\nIf transaction status monitoring is available, when the status transitions from \\"Transaction In Progress\\" to \\"Transaction Complete\\", the Total Payload Transaction Count (SPN 7701) may increment, accompanied by an increment to the Total Haul Cycle Count (SPN 7700) by the amount represented by Haul Cycle Count (SPN 6847) and and increment to the Total Delivered Payload Weight (SPN 7699) by the amount represented by Delivered Payload Weight (SPN 6849).\\r\\n\\r\\n0000 - Transaction Not In Progress\\r\\n0001 - Transaction In Progress\\r\\n0010 - Transaction Complete\\r\\n0011 to 1011 - Reserved for Future Assignment by SAE\\r\\n1110 - Error\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7703":{"PGN":64535,"PGN_Name":"Payload Temperature 1","PGN_Description":"PLT1","first_bit":0,"SPN":7703,"SPN_Name":"Payload Temperature 1","SPN_Description":"Temperature of payload at measurement point 1.\\r\\n\\r\\nMeasurement position is manufacturer or regulation specific.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7704":{"PGN":64535,"PGN_Name":"Payload Temperature 1","PGN_Description":"PLT1","first_bit":16,"SPN":7704,"SPN_Name":"Payload Temperature 2","SPN_Description":"Temperature of payload at measurement point 2.\\r\\n\\r\\nMeasurement position is manufacturer or regulation specific.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7705":{"PGN":64535,"PGN_Name":"Payload Temperature 1","PGN_Description":"PLT1","first_bit":32,"SPN":7705,"SPN_Name":"Payload Temperature 3","SPN_Description":"Temperature of payload at measurement point 3.\\r\\n\\r\\nMeasurement position is manufacturer or regulation specific.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7706":{"PGN":64535,"PGN_Name":"Payload Temperature 1","PGN_Description":"PLT1","first_bit":48,"SPN":7706,"SPN_Name":"Payload Temperature 4","SPN_Description":"Temperature of payload at measurement point 4.\\r\\n\\r\\nMeasurement position is manufacturer or regulation specific.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7707":{"PGN":64534,"PGN_Name":"Payload Temperature 2","PGN_Description":"PLT2","first_bit":0,"SPN":7707,"SPN_Name":"Payload Temperature 5","SPN_Description":"Temperature of payload at measurement point 5.\\r\\n\\r\\nMeasurement position is manufacturer or regulation specific.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7708":{"PGN":64558,"PGN_Name":"Engine Turbocharger Control 3","PGN_Description":"ETCC3","first_bit":8,"SPN":7708,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 1 Motor Current Disable","SPN_Description":"Command to disable power to motor in bypass actuator 1 to prevent unnecessary load on the component.\\r\\n\\r\\n00 - Do Not Disable\\r\\n01 - Disable\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7709":{"PGN":64558,"PGN_Name":"Engine Turbocharger Control 3","PGN_Description":"ETCC3","first_bit":10,"SPN":7709,"SPN_Name":"Engine Turbocharger Compressor Bypass Actuator 2 Motor Current Disable","SPN_Description":"Command to disable power to motor in bypass actuator 2 to prevent unnecessary load on the component.\\r\\n\\r\\n00 - Do Not Disable\\r\\n01 - Disable\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7710":{"PGN":64558,"PGN_Name":"Engine Turbocharger Control 3","PGN_Description":"ETCC3","first_bit":12,"SPN":7710,"SPN_Name":"Engine Turbocharger Wastegate Actuator 2 Motor Current Disable","SPN_Description":"Command to disable power to motor in wastegate actuator 2 to prevent unnecessary load on the component.\\r\\n\\r\\n00 - Do Not Disable\\r\\n01 - Disable\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7711":{"PGN":64980,"PGN_Name":"Cab Message 3","PGN_Description":"CM3","first_bit":12,"SPN":7711,"SPN_Name":"Vehicle Trailer Status","SPN_Description":"Indicates a trailer is connected to the towing mechanism.  This is not intended to indicate that the trailer is latched.\\r\\n\\r\\n00 - Trailer is not detected\\r\\n01 - Trailer is detected\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7712":{"PGN":64533,"PGN_Name":"Vehicle Electrical Power 6","PGN_Description":"VEP6","first_bit":0,"SPN":7712,"SPN_Name":"Battery Potential / Power Input 3","SPN_Description":"This parameter measures the third source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery. This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"7713":{"PGN":64533,"PGN_Name":"Vehicle Electrical Power 6","PGN_Description":"VEP6","first_bit":16,"SPN":7713,"SPN_Name":"Battery Potential / Power Input 4","SPN_Description":"This parameter measures the fourth source of battery potential as measured at the input of the ECU/actuator etc. coming from one or more batteries, irrespective of the distance between the component and the battery. This SPN is also used when ECUs are interconnected in a series configuration, where the source of power is coming directly or indirectly from the same battery/batteries.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"7714":{"PGN":64533,"PGN_Name":"Vehicle Electrical Power 6","PGN_Description":"VEP6","first_bit":32,"SPN":7714,"SPN_Name":"SLI Battery 3 Net Current","SPN_Description":"Net flow of electrical current into/out of the third battery or third set of batteries used for starting the engine, for lighting, and for ignition (SLI).","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"7715":{"PGN":64533,"PGN_Name":"Vehicle Electrical Power 6","PGN_Description":"VEP6","first_bit":48,"SPN":7715,"SPN_Name":"SLI Battery 4 Net Current","SPN_Description":"Net flow of electrical current into/out of the fourth battery or fourth set of batteries used for starting the engine, for lighting, and for ignition (SLI).","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"7716":{"PGN":61446,"PGN_Name":"Electronic Axle Controller 1","PGN_Description":"EAC1","first_bit":22,"SPN":7716,"SPN_Name":"Differential Lock State - Rear Axle 3","SPN_Description":"State used which indicates the condition of the rear axle 3 differential lock. The differential locks are located as defined in figure SPN 564_A.\\r\\n\\r\\n00 - Differential lock disengaged\\r\\n01 - Differential lock engaged\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7719":{"PGN":64554,"PGN_Name":"Operator Inducement Information","PGN_Description":"OII","first_bit":48,"SPN":7719,"SPN_Name":"Operator Inducement Time to Final Inducement Action","SPN_Description":"Indicates the time until the inducement strategy enforces the final level of engine emissions operator inducement. The final level of inducement can include derating the engine, shutting down the engine, or restricting the engine to low idle.\\r\\n\\r\\nWhen operator inducement is not active, this parameter will be set to 0xFB00. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 000. If SPN 7719 has decremented to 0, it will remain at 0 until the condition that caused it to decrement has been corrected.\\r\\n\\r\\nSee also SPNs 7425 and 7428 for other levels of inducement.\\r\\n\\r\\nIf the operator inducement has been temporarily overridden, then this parameter will pause and not decrement until the override is removed. For systems where SPN 5246 or SPN 5826 are supported, operator inducement is active if at least one of SPN 5246 or SPN 5826 is not equal to 110 - Temporary Override of Inducement.","bit_length":16,"scaling":1,"offset":0,"unit":"min","SLOT_ID":238},"7720":{"PGN":64662,"PGN_Name":"Engine Information 2","PGN_Description":"EI2","first_bit":32,"SPN":7720,"SPN_Name":"Engine Common Rail Oil Pressure","SPN_Description":"Gage pressure of oil in common rail\'s lubrication system as provided by oil pump.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"7721":{"PGN":64662,"PGN_Name":"Engine Information 2","PGN_Description":"EI2","first_bit":40,"SPN":7721,"SPN_Name":"Engine Common Rail Oil Absolute Pressure","SPN_Description":"Absolute pressure of oil in common rail\'s lubrication system as provided by oil pump.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"7723":{"PGN":64531,"PGN_Name":"Door Latch Status","PGN_Description":"DLS","first_bit":0,"SPN":7723,"SPN_Name":"Left Front Cab Door Latch Position","SPN_Description":"Status of the left front cab door latch (driver door for left-hand steer vehicles). Door latches may have 3 positions indicating fully open, 1st detent or \\"ajar\\", and 2nd detent or fully closed.\\r\\n\\r\\n000 = Door Latch Open\\r\\n001 = Door Latch Fully Closed/Latched\\r\\n010 = Door Latch Ajar\\r\\n011 = Reserved\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Error\\r\\n111 = Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7724":{"PGN":64531,"PGN_Name":"Door Latch Status","PGN_Description":"DLS","first_bit":8,"SPN":7724,"SPN_Name":"Right Front Cab Door Latch Position","SPN_Description":"Status of the right front cab door latch (passenger door for left-hand steer vehicles). Door latches may have 3 positions indicating fully open, 1st detent or \\"ajar\\", and 2nd detent or fully closed.\\r\\n\\r\\n000 = Door Latch Open\\r\\n001 = Door Latch Fully Closed/Latched\\r\\n010 = Door Latch Ajar\\r\\n011 = Reserved\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Error\\r\\n111 = Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7725":{"PGN":64531,"PGN_Name":"Door Latch Status","PGN_Description":"DLS","first_bit":16,"SPN":7725,"SPN_Name":"Left Rear Cab Door Latch Position","SPN_Description":"Status of the left rear cab door latch. Door latches may have 3 positions indicating fully open, 1st detent or \\"ajar\\", and 2nd detent or fully closed.\\r\\n\\r\\n000 = Door Latch Open\\r\\n001 = Door Latch Fully Closed/Latched\\r\\n010 = Door Latch Ajar\\r\\n011 = Reserved\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Error\\r\\n111 = Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7726":{"PGN":64531,"PGN_Name":"Door Latch Status","PGN_Description":"DLS","first_bit":24,"SPN":7726,"SPN_Name":"Right Rear Cab Door Latch Position","SPN_Description":"Status of the right rear cab door latch. Door latches may have 3 positions indicating fully open, 1st detent or \\"ajar\\", and 2nd detent or fully closed.\\r\\n\\r\\n000 = Door Latch Open\\r\\n001 = Door Latch Fully Closed/Latched\\r\\n010 = Door Latch Ajar\\r\\n011 = Reserved\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Error\\r\\n111 = Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7727":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":0,"SPN":7727,"SPN_Name":"Cab Doors Lock Actuation Command","SPN_Description":"Commands cab door latch state change: lock or unlock.\\r\\n\\r\\n000 = Unlock left front cab door latch (driver door on LH steer vehicles)\\r\\n001 = Unlock right front cab door latch (front passenger door for LH steer vehicles)\\r\\n010 = Unlock left rear cab door latch\\r\\n011 = Unlock right rear cab door latch\\r\\n100 = Unlock all cab door latches\\r\\n101 = Lock all cab door latches\\r\\n110 = Reserved\\r\\n111 = Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7728":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":8,"SPN":7728,"SPN_Name":"Remote Cab Door Lock Request","SPN_Description":"Request to the cab door lock controller from Remote Keyless Entry or or other external device to lock or unlock doors.\\r\\n\\r\\nThis parameter is different from Cab Doors Lock Actuation Command (SPN 7727) because this is a request to actuate door locks. Based on security or interlocks, a controller can decide to command the latches with the Actuation Command Message.\\r\\n\\r\\n000 = Request unlock left front cab door latch (driver door on LH steer vehicles)\\r\\n001 = Request unlock right front cab door latch (front passenger door for LH steer vehicles)\\r\\n010 = Request unlock left rear cab door latch\\r\\n011 = Request unlock right rear cab door latch\\r\\n100 = Request unlock all cab door latches\\r\\n101 = Request lock all cab door latches\\r\\n110 = Reserved\\r\\n111 = Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7729":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":16,"SPN":7729,"SPN_Name":"Left Front Window Position Command","SPN_Description":"Commands position change of left front window (driver door window on left-hand steer vehicles).\\r\\n\\r\\n000 = Window move up\\r\\n001 = Window move down\\r\\n010 = Window auto up\\r\\n011 = Window auto down\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Reserved\\r\\n111 = Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7730":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":19,"SPN":7730,"SPN_Name":"Right Front Window Position Command","SPN_Description":"Commands position change of right front window (passenger door window on left-hand steer vehicles).\\r\\n\\r\\n000 = Window move up\\r\\n001 = Window move down\\r\\n010 = Window auto up\\r\\n011 = Window auto down\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Reserved\\r\\n111 = Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7731":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":24,"SPN":7731,"SPN_Name":"Left Rear Window Position Command","SPN_Description":"Commands position change of left rear window.\\r\\n\\r\\n000 = Window move up\\r\\n001 = Window move down\\r\\n010 = Window auto up\\r\\n011 = Window auto down\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Reserved\\r\\n111 = Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7732":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":27,"SPN":7732,"SPN_Name":"Right Rear Window Position Command","SPN_Description":"Commands position change of the right rear window.\\r\\n\\r\\n000 = Window move up\\r\\n001 = Window move down\\r\\n010 = Window auto up\\r\\n011 = Window auto down\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Reserved\\r\\n111 = Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7733":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":32,"SPN":7733,"SPN_Name":"Mirror Left 1 Horizontal Command","SPN_Description":"Commands horizontal position change of the primary mirror on the left side (driver side for left-hand steer vehicles).\\r\\n\\r\\n00 = Move left\\r\\n01 = Move right\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7734":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":34,"SPN":7734,"SPN_Name":"Mirror Left 1 Vertical Command","SPN_Description":"Commands vertical position change of the primary mirror on the left side (driver side for left-hand steer vehicles).\\r\\n\\r\\n00 = Move up\\r\\n01 = Move down\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7735":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":36,"SPN":7735,"SPN_Name":"Mirror Right 1 Horizontal Command","SPN_Description":"Commands horizontal position change of the primary mirror on the right side (passenger side for lefthand steer vehicles).\\r\\n\\r\\n00 = Move left\\r\\n01 = Move right\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7736":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":38,"SPN":7736,"SPN_Name":"Mirror Right 1 Vertical Command","SPN_Description":"Commands vertical position change of the primary mirror on the right side (passenger side for lefthand steer vehicles).\\r\\n\\r\\n00 = Move up\\r\\n01 = Move down\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7737":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":40,"SPN":7737,"SPN_Name":"Mirror Left 2 Horizontal Command","SPN_Description":"Commands horizontal position change of the second mirror on the left side (driver side for left-hand steer vehicles).\\r\\n\\r\\n00 = Move left\\r\\n01 = Move right\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7738":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":42,"SPN":7738,"SPN_Name":"Mirror Left 2 Vertical Command","SPN_Description":"Commands vertical position change of the second mirror on the left side (driver side for left-hand steer vehicles). \\r\\n\\r\\n00 = Move up\\r\\n01 = Move down\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7739":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":44,"SPN":7739,"SPN_Name":"Mirror Right 2 Horizontal Command","SPN_Description":"Commands horizontal position change of the second mirror on the right side (passenger side for lefthand steer vehicles).\\r\\n\\r\\n00 = Move left\\r\\n01 = Move right\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7740":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":46,"SPN":7740,"SPN_Name":"Mirror Right 2 Vertical Command","SPN_Description":"Commands vertical position change of the second mirror on the right side (passenger side for lefthand steer vehicles).\\r\\n\\r\\n00 = Move up\\r\\n01 = Move down\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7741":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":48,"SPN":7741,"SPN_Name":"Mirror Left 1 Heat Command","SPN_Description":"Command to activate heater for primary mirror on the left side (driver side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \\"on\\" state upon receipt of the command, stay on while the command is \\"take no action\\" and turn off upon receipt of the \\"off\\" command.\\r\\n\\r\\n00 = Mirror heat off\\r\\n01 = Mirror heat on\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7742":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":50,"SPN":7742,"SPN_Name":"Mirror Right 1 Heat Command","SPN_Description":"Command to activate heater for primary mirror on the right side (passenger side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \\"on\\" state upon receipt of the command, stay on while the command is \\"take no action\\" and turn off upon receipt of the \\"off\\" command.\\r\\n\\r\\n00 = Mirror heat off\\r\\n01 = Mirror heat on\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7743":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":52,"SPN":7743,"SPN_Name":"Mirror Left 2 Heat Command","SPN_Description":"Command to activate heater for second mirror on the left side (driver side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \\"on\\" state upon receipt of the command, stay on while the command is \\"take no action\\" and turn off upon receipt of the \\"off\\" command.\\r\\n\\r\\n00 = Mirror heat off\\r\\n01 = Mirror heat on\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7744":{"PGN":64530,"PGN_Name":"Cab Door Control","PGN_Description":"CDC","first_bit":54,"SPN":7744,"SPN_Name":"Mirror Right 2 Heat Command","SPN_Description":"Command to activate heater for second mirror on the right side (passenger side for left-hand steer vehicle).  Mirror heat may be expected to latch in the \\"on\\" state upon receipt of the command, stay on while the command is \\"take no action\\" and turn off upon receipt of the \\"off\\" command.\\r\\n\\r\\n00 = Mirror heat off\\r\\n01 = Mirror heat on\\r\\n10 = Reserved\\r\\n11 = Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7745":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":0,"SPN":7745,"SPN_Name":"Engine Start Request","SPN_Description":"Indicates the sender\u2019s desire to start the engine. The engine start arbitrator latches this signal and, if possible, completes the engine start regardless of a change of state of this signal. Use Engine Start Abort Request (SPN 7747) to un-latch the start request and cancel an engine start that is in progress.\\r\\n\\r\\nThe sender of this signal may increase the broadcast rate temporarily to once every 20 ms during an active request. It may also monitor Engine Start Request Latch Status (SPN 7754) from the arbitrator to determine when the request is latched. Once latched the sender may return to sending 00 \u2013 Start not requested.\\r\\n\\r\\n00 = Start not requested\\r\\n01 = Start requested, operator type\\r\\n10 = Start requested, automatic type\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7746":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":2,"SPN":7746,"SPN_Name":"Engine Start Consent","SPN_Description":"Indicates the sender\u2019s consent to start the engine for different start types. An operator-requested engine start is a start that is initiated directly by the operator (i.e. via the key switch). An automatic engine start is one that is initiated by a vehicle system without direct operator interaction (i.e. as part of engine off at stop operation, etc).\\r\\n\\r\\nThis parameter has no error state. In case of an error condition (for example, a switch input state cannot be determined) the consenter is forced to choose one of the valid consent states. The \u201Cnot available\u201D state is not to be used to indicate an error condition.\\r\\n\\r\\nUse Engine Start Abort Request (SPN 7747) to cancel an engine start that is in progress. An Engine Start Consent value of \u201CNo Consent\u201D does not abort an ongoing start as the consent signal can only prevent a start before it is initiated.\\r\\n\\r\\n000 = No consent\\r\\n001 = Consent to operator-requested start only\\r\\n010 = Consent to automatic start only\\r\\n011 = Consent to both, operator-requested and automatic start\\r\\n100-110 = Reserved\\r\\n111 = Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7747":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":8,"SPN":7747,"SPN_Name":"Engine Start Abort Request","SPN_Description":"Indicates the sender\u2019s desire to abort an engine start. This signal is used by requesters and consenters to request that the arbitrator cancel an engine start that is in progress.\\r\\n\\r\\nThe sender of this signal may increase the broadcast rate temporarily to once every 20 ms during an active request. It may monitor Engine Start Request Latch Status (SPN 7754) from the arbitrator to determine when the request is un-latched. Once un-latched the sender can return to sending 00 \u2013 Abort not requested.\\r\\n\\r\\n00 = Abort not requested\\r\\n01 = Abort requested\\r\\n10 = Reserved\\r\\n11 = Don\u2019t care / Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7748":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":10,"SPN":7748,"SPN_Name":"Engine Starter 1 Feedback","SPN_Description":"Feedback of the current state of first engine starter. This signal is intended to be used by the arbitrator as feedback to its command signal (SPN 7753).\\r\\n\\r\\nAdditional details regarding the starter state may be available in SPN 1675.\\r\\n\\r\\n000 = Starter not commanded\\r\\n001 = Starter command latched, starter active\\r\\n010 = Starter command unlatched, start completed (returns to 0 \u2013 Starter not commanded after 1000 ms)\\r\\n011 = Starter command unlatched, start abort command received from arbitrator (returns to 0 \u2013 Starter not commanded after 1000 ms)\\r\\n100 = Starter command unlatched, start aborted by starter controller (returns to 0 \u2013 Starter not commanded after 1000 ms).\\r\\n101-110 = Reserved\\r\\n111 = Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7749":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":13,"SPN":7749,"SPN_Name":"Engine Starter 2 Feedback","SPN_Description":"Feedback of the current state of second engine starter. This signal is intended to be used by the arbitrator as feedback to its command signal (SPN 7753).\\r\\n\\r\\nAdditional details regarding the starter state may be available in SPN 1675.\\r\\n\\r\\n000 = Starter not commanded\\r\\n001 = Starter command latched, starter active\\r\\n010 = Starter command unlatched, start completed (returns to 0 \u2013 Starter not commanded after 1000 ms)\\r\\n011 = Starter command unlatched, start abort command received from arbitrator (returns to 0 \u2013 Starter not commanded after 1000 ms)\\r\\n100 = Starter command unlatched, start aborted by starter controller (returns to 0 \u2013 Starter not commanded after 1000 ms).\\r\\n101-110 = Reserved\\r\\n111 = Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7750":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":52,"SPN":7750,"SPN_Name":"Engine Start Control Message Counter","SPN_Description":"Message counter to allow detection of data integrity issues. The counter is incremented every time a device sends out the Engine Start Control message. When the counter has reached a value of 15 it starts over at 0 for the next message cycle. Receiving devices shall treat the message content as invalid when two consecutive messages from the same source address contain non-sequential counter values.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7751":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":56,"SPN":7751,"SPN_Name":"Engine Start Control Checksum","SPN_Description":"Checksum to allow detection of data integrity issues. The receiving node shall calculate the checksum and compare its calculated value with the received checksum. In case of a mismatch the message shall be discarded.\\r\\n\\r\\nThe message checksum is calculated using the first 7 data bytes, including the message counter, and the bytes of the message identifier. It is calculated as follows:\\r\\n\\r\\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"7752":{"PGN":61685,"PGN_Name":"Engine Start Arbitrator","PGN_Description":"ENGSA","first_bit":0,"SPN":7752,"SPN_Name":"Engine Start Control Message Rate","SPN_Description":"This signal is sent by the arbitrator to control the rate at which other participants send the Engine Start Control Message (ENGSC). The arbitrator sets this signal to the slower rate after the first engine start attempt after initial power-up is completed (either successful or not). After the initial start attempt the arbitrator returns to the faster rate from the time it latches another start request to the time this request is completed (successful or not).\\r\\n\\r\\nSenders of the ENGSC message shall broadcast at a rate of once every 20 ms when this signal is not available from the arbitrator, for example during initial system initialization. When this signal is available, senders shall follow the rate instructed by the arbitrator unless the sending device has a need to broadcast at the 20 ms rate, which it may do.\\r\\n\\r\\n00 = Once every 20 ms\\r\\n01 = Once every 250 ms or on change but no faster than 20 ms\\r\\n10 = Reserved\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7753":{"PGN":61685,"PGN_Name":"Engine Start Arbitrator","PGN_Description":"ENGSA","first_bit":2,"SPN":7753,"SPN_Name":"Engine Starter Command","SPN_Description":"Command from the arbitrator to the engine starter controller(s).\\r\\n\\r\\nThe arbitrator takes input from consenters and requesters to initiate an engine start. This signal is used by the arbitrator to command the first or second starter instance.\\r\\n\\r\\nStarter controllers shall be configured to act as either starter controller 1 or starter controller 2. This assignment is the responsibility of the system integrator.\\r\\n\\r\\nEach starter controller shall crank the engine only when this signal is active for that starter instance. The starter controller shall latch the start request signal and crank the engine until the starter controller has determined that either:\\r\\n\\r\\n  a) The engine is running \\r\\n  b) The starter command from the arbitrator indicates \u201C3 \u2013 Command withdrawn \u2013 abort engine start\u201D\\r\\n  c) The starter controller has determined that an engine start is not possible due to other considerations (i.e. electrical, thermal, mechanical, etc).\\r\\n\\r\\nThe arbitrator shall send \u201C3 \u2013 Command withdrawn \u2013 abort engine start\u201D to cancel a start that is already in progress. \u201C0 \u2013 Command not active\u201D does not cancel an engine start that has already begun.\\r\\n\\r\\nBoth starter instances operate on the same engine.\\r\\n\\r\\n000 = Command not active\\r\\n001 = Command active for starter 1\\r\\n010 = Command active for starter 2\\r\\n011 = Command withdrawn \u2013 abort engine start\\r\\n100-110 = Reserved\\r\\n111 = Don\u2019t care / Take no action","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7754":{"PGN":61685,"PGN_Name":"Engine Start Arbitrator","PGN_Description":"ENGSA","first_bit":8,"SPN":7754,"SPN_Name":"Engine Start Request Latch Status","SPN_Description":"Indicates the arbitrator\u2019s latch status for engine start requests. All \u201Cunlatched\u201D states shall transition to state \u201C0 \u2013 Start Request not received\u201D after 1000 ms unless a different state becomes more appropriate in the meantime. While this time may appear long, it is intended to bridge the time it may take a receiving controller to recover from a reset due to a temporary drop of voltage during the crank event.\\r\\n\\r\\n0000 = Start request not received - waiting for start request\\r\\n0001 = Start request latched \u2013 waiting for consent (the arbitrator will wait for a manufacturer-defined amount of time before timing out)\\r\\n0010 = Start request latched \u2013 consent confirmed, starter commanded\\r\\n0011 = Start request unlatched \u2013 start completed\\r\\n0100 = Start request unlatched \u2013 consent not established within allowed time\\r\\n0101 = Start request unlatched \u2013 start aborted due to abort request\\r\\n0110 = Start request unlatched \u2013 start could not be completed because the starter command was not successful\\r\\n0111-1110 = Reserved\\r\\n1111 = Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7755":{"PGN":61685,"PGN_Name":"Engine Start Arbitrator","PGN_Description":"ENGSA","first_bit":48,"SPN":7755,"SPN_Name":"Operator Engine Start Consent Summary","SPN_Description":"Arbitrator\u2019s summary of the consent statuses of all devices which the arbitrator considers for operator start requests. The purpose of this parameter is for requesters to determine if an operator start request would be honored at the current time.\\r\\n\\r\\n00 = No consent \u2013 At least one participating device does not consent\\r\\n01 = Consent \u2013 All participating devices consent\\r\\n10 = Error \u2013 Consent signal from at least one required consenter is missing\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7756":{"PGN":61685,"PGN_Name":"Engine Start Arbitrator","PGN_Description":"ENGSA","first_bit":50,"SPN":7756,"SPN_Name":"Automatic Engine Start Consent Summary","SPN_Description":"Arbitrator\u2019s summary of the consent statuses of all devices which the arbitrator considers for automatic start requests. The purpose of this parameter is for requesters to determine if an automatic start request would be honored at the current time.\\r\\n\\r\\n00 = No consent \u2013 At least one participating device does not consent\\r\\n01 = Consent \u2013 All participating devices consent\\r\\n10 = Error \u2013 Consent signal from at least one required consenter is missing\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7757":{"PGN":61685,"PGN_Name":"Engine Start Arbitrator","PGN_Description":"ENGSA","first_bit":52,"SPN":7757,"SPN_Name":"Engine Start Arbitrator Message Counter","SPN_Description":"Message counter to allow detection of data integrity issues. The counter is incremented every time a device sends out the Engine Start Control message. When the counter has reached a value of 15 it starts over at 0 for the next message cycle. Receiving devices shall treat the message content as invalid when two consecutive messages from the same source address contain non-sequential counter values.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7758":{"PGN":61685,"PGN_Name":"Engine Start Arbitrator","PGN_Description":"ENGSA","first_bit":56,"SPN":7758,"SPN_Name":"Engine Start Arbitrator Checksum","SPN_Description":"Checksum to allow detection of data integrity issues. The receiving node shall calculate the checksum and compare its calculated value with the received checksum. In case of a mismatch the message shall be discarded.\\r\\n\\r\\nThe message checksum is calculated using the first 7 data bytes, including the message counter, and the bytes of the message identifier. It is calculated as follows:\\r\\n\\r\\nChecksum = (Byte1 + Byte2 + Byte3 + Byte4 + Byte5 + Byte6 + Byte7 + message ID low byte + message ID mid low byte + message ID mid high byte + message ID high byte)","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"7759":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":26,"SPN":7759,"SPN_Name":"Engine Stop-Start Disable Command","SPN_Description":"Engine Stop-Start Disable Command indicates the desire to disable the engine stop-start functionality during propulsion modes. For momentary switches, this parameter does not indicate the state of the switch contacts, but the operator desired state. \\r\\n\\r\\nIf defueling requests (SPN 5793) are used, this command is not intended to disable all defueling requests to the engine, but only those related to engine stop-start during vehicle propulsion modes.  For example, defueling due to idle shutdown features or non-propulsion hybrid modes would not be disabled due to this parameter.\\r\\n\\r\\nAn example of where this command would be used is on an emergency response vehicle that may want to disable engine stop-start while responding to an emergency.\\r\\n\\r\\n00 - Automatic engine stop-start may be allowed\\r\\n01 - Automatic engine stop-start shall be disabled\\r\\n10 - Reserved\\r\\n11 - Don\u2019t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7760":{"PGN":32256,"PGN_Name":"Engine Speed Ramp Rate Boundary Request","PGN_Description":"ESRRBR","first_bit":0,"SPN":7760,"SPN_Name":"Requested Engine Speed Acceleration Rate Limit","SPN_Description":"This parameter is intended to be received by a device sending speed commands to an engine (e.g. TSC1 or proprietary command). The sending device should issue speed commands such that this acceleration rate is not exceeded.\\r\\n\\r\\nA value of 0xFB00 indicates no request for an acceleration rate limit.\\r\\n\\r\\nFor Example: If acceleration rate limit is 50 RPM/sec, the actual speed acceleration cannot be numerically greater than 50.","bit_length":16,"scaling":1,"offset":0,"unit":"rpm/s","SLOT_ID":414},"7761":{"PGN":32256,"PGN_Name":"Engine Speed Ramp Rate Boundary Request","PGN_Description":"ESRRBR","first_bit":16,"SPN":7761,"SPN_Name":"Requested Engine Speed Deceleration Rate Limit","SPN_Description":"This parameter is intended to be received by a device sending speed commands to an engine (e.g. TSC1 or proprietary command). The sending device should issue speed commands such that this deceleration rate is not exceeded.\\r\\n\\r\\nA value of 0xFB00 indicates no request for a deceleration rate limit.\\r\\n\\r\\nFor Example: If deceleration rate limit is 50 RPM/sec, the actual speed deceleration cannot be numerically greater than 50.","bit_length":16,"scaling":1,"offset":0,"unit":"rpm/s","SLOT_ID":414},"7770":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":0,"SPN":7770,"SPN_Name":"Engine Valve Control Module 1 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 1 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 1 is the first module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7771":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":8,"SPN":7771,"SPN_Name":"Engine Valve Control Module 2 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 2 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 2 is the second module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7772":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":16,"SPN":7772,"SPN_Name":"Engine Valve Control Module 3 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 3 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 3 is the third module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7773":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":24,"SPN":7773,"SPN_Name":"Engine Valve Control Module 4 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 4 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 4 is the fourth module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7774":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":32,"SPN":7774,"SPN_Name":"Engine Valve Control Module 5 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 5 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 5 is the fifth module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7775":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":40,"SPN":7775,"SPN_Name":"Engine Valve Control Module 6 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 6 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 6 is the sixth module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7776":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":48,"SPN":7776,"SPN_Name":"Engine Valve Control Module 7 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 7 by the manufacturer\'s software. When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 7 is the seventh module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7777":{"PGN":61689,"PGN_Name":"Engine Valve Controller","PGN_Description":"EVC","first_bit":56,"SPN":7777,"SPN_Name":"Engine Valve Control Module 8 Preliminary FMI","SPN_Description":"Used to identify the applicable J1939-73 FMI detected in Engine Valve Control Module 8 by the manufacturer\'s software.  When there are multiple failures, the most severe is transmitted.\\r\\n\\r\\nA value of 31 is sent to indicate that no failure has been detected or this parameter is not supported.\\r\\n\\r\\nEngine Valve Control Module 8 is the eighth module used to control the valves on the engine.","bit_length":5,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":215},"7778":{"PGN":65099,"PGN_Name":"Transmission Configuration 2","PGN_Description":"TCFG2","first_bit":16,"SPN":7778,"SPN_Name":"Transmission Reference Torque","SPN_Description":"This parameter is the 100% reference value for all defined transmission output torque parameters.  For a given vehicle application, it is only defined once and doesn\'t change.","bit_length":16,"scaling":1,"offset":0,"unit":"Nm","SLOT_ID":70},"7779":{"PGN":61690,"PGN_Name":"Electronic Transmission Controller 13","PGN_Description":"ETC13","first_bit":0,"SPN":7779,"SPN_Name":"Maximum Forward Transmission Output Shaft Speed","SPN_Description":"Maximum transmission output shaft speed that can be achieved in the forward direction, based on current operating conditions.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"7780":{"PGN":61690,"PGN_Name":"Electronic Transmission Controller 13","PGN_Description":"ETC13","first_bit":16,"SPN":7780,"SPN_Name":"Maximum Reverse Transmission Output Shaft Speed","SPN_Description":"Maximum transmission output shaft speed that can be achieved in the reverse direction, based on current operating conditions.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"7781":{"PGN":64528,"PGN_Name":"Ambient Conditions 3","PGN_Description":"AMB3","first_bit":0,"SPN":7781,"SPN_Name":"Barometric Absolute Pressure 2","SPN_Description":"Second absolute air pressure measurement of the atmosphere.\\r\\n\\r\\nSee SPN 108 or SPN 5685 as the primary barometric pressure measurement.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"7783":{"PGN":61691,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 3","PGN_Description":"A1SCRDSR3","first_bit":0,"SPN":7783,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Requested Quantity of Integrator (High Resolution)","SPN_Description":"Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit. See SPN 4350 for alternate resolution.","bit_length":16,"scaling":0.001,"offset":0,"unit":"g","SLOT_ID":415},"7784":{"PGN":61692,"PGN_Name":"Aftertreatment 2 SCR Dosing System Requests 3","PGN_Description":"A2SCRDSR3","first_bit":0,"SPN":7784,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Requested Quantity of Integrator (High Resolution)","SPN_Description":"Represents the command for the diesel exhaust fluid quantity integrator in the dosing control unit. See SPN 4403 for alternate resolution.","bit_length":16,"scaling":0.001,"offset":0,"unit":"g","SLOT_ID":415},"7785":{"PGN":65169,"PGN_Name":"Fuel Leakage","PGN_Description":"FL","first_bit":8,"SPN":7785,"SPN_Name":"Engine Fluid Bund Level","SPN_Description":"Ratio of the volume of engine fluid within the bund containment frame to the maximum capacity of the bund containment frame. The bund containment frame is used to contain engine fluid leaks including, but not limited to, engine fuel tank leaks.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7786":{"PGN":61693,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 4","PGN_Description":"A1SCRDSI4","first_bit":0,"SPN":7786,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Actual Quantity of Integrator (High Resolution)","SPN_Description":"The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 1 (exhaust bank 1).  See SPN 4333 for alternate resolution.","bit_length":16,"scaling":0.001,"offset":0,"unit":"g","SLOT_ID":415},"7787":{"PGN":61694,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 4","PGN_Description":"A2SCRDSI4","first_bit":0,"SPN":7787,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Actual Quantity of Integrator (High Resolution)","SPN_Description":"The SCR requested diesel exhaust fluid integrator total quantity for aftertreatment system 2 (exhaust bank 2).  See SPN 4386 for alternate resolution.","bit_length":16,"scaling":0.001,"offset":0,"unit":"g","SLOT_ID":415},"7788":{"PGN":61677,"PGN_Name":"Engine Start Control","PGN_Description":"ENGSC","first_bit":5,"SPN":7788,"SPN_Name":"Transmission Shift Selector Requested Vehicle Direction","SPN_Description":"This parameter indicates the direction selected by the operator via the active transmission shift selector.\\r\\n\\r\\nSome regulations (e.g., Federal Motor Vehicle Safety Standards 102) require specific Engine Stop-Start behavior based on operator selected direction. This parameter provides the necessary direction information for this purpose. Neutral or range commands made by other vehicle functions (e.g., automatic neutral functions) will not be reflected in this parameter.\\r\\n\\r\\nFor selectors that use momentary contacts, this parameter would not reflect the current state of the physical contacts, but rather the direction that the operator has selected. Where applicable, it conveys the transmission\u2019s de-bounced interpretation of the selector inputs.\\r\\n\\r\\n000 = No direction selected \u2013 Park\\r\\n001 = No direction selected \u2013 Neutral\\r\\n010 = Forward direction selected\\r\\n011 = Reverse direction selected\\r\\n100-101 = 4 SAE Reserved\\r\\n110 = Error\\r\\n111 = Not supported","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7789":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":32,"SPN":7789,"SPN_Name":"Engine Fueling Desired Reason","SPN_Description":"This parameter conveys the reason a device wants the engine running.\\r\\n\\r\\nThis SPN is intended to be used in conjunction with Desired Engine Fueling State (SPN 5793). When a device sends Desired Engine Fueling State = \u201CFueling Desired\u201D either alone or in combination with Engine Start Request = \u201CStart requested, automatic type\u201D, then SPN 7789 may be used to convey a reason for why the device desires the engine to run.\\r\\n\\r\\nIf more than one reason exists at the same time, the reason with highest importance (as defined by the device sending this parameter) is indicated.\\r\\n\\r\\n0 = Desired Engine Fueling State (SPN 5793) from this device does not equal 01\\r\\n1 = Lubrication distribution in device is incomplete\\r\\n2 = Engine exhaust is needed as a heat source (i.e. regeneration)\\r\\n3 = Engine coolant is needed as a heat source\\r\\n4 = Engine is needed for cooling system operation\\r\\n5 = Engine is needed for charging the SLI batteries\\r\\n6 = Engine is needed for charging the hybrid stored energy source\\r\\n7 = Device protection (no fault condition present) is active\\r\\n8 = Device preparation for engine shutdown is in progress\\r\\n9 = Service Override is active\\r\\n10 = Device has detected one or more fault conditions\\r\\n11 = Engine is needed for engine driven accessory operation\\r\\n12 = Engine is needed for PTO operation\\r\\n13 = Engine is needed for DEF dosing system operation\\r\\n14 = Engine is needed for DEF dosing system component protection\\r\\n15 = Engine is needed for DEF dosing system diagnosis\\r\\n16 = Engine is needed for the Diesel Particulate Filter diagnosis\\r\\n17 to 249 = SAE Reserved (for future reasons)\\r\\n250 = Engine operation is needed to perform normal device functions not specifically listed\\r\\n251 to 254 = SAE Reserved\\r\\n255 = Not supported","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"7790":{"PGN":61695,"PGN_Name":"Secondary or Front Hitch Roll and Pitch","PGN_Description":"SHRP","first_bit":0,"SPN":7790,"SPN_Name":"Front Hitch Roll Angle","SPN_Description":"Measured roll angle of the front three-point hitch expressed in degrees from horizontal alignment with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7791":{"PGN":61695,"PGN_Name":"Secondary or Front Hitch Roll and Pitch","PGN_Description":"SHRP","first_bit":21,"SPN":7791,"SPN_Name":"Front Hitch Roll Limit State","SPN_Description":"Used to report the Tractor ECU\'s present limit status associated with the front hitch roll commands.\\r\\n\\r\\n000 = Not limited\\r\\n001 = Operator limited/controlled (request cannot be implemented)\\r\\n010 = Limited High (only lower command values result in a change)\\r\\n011 = Limited Low (only higher command values result in a change)\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Non recoverable fault\\r\\n111 = Not available (parameter not supported)","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7792":{"PGN":61695,"PGN_Name":"Secondary or Front Hitch Roll and Pitch","PGN_Description":"SHRP","first_bit":24,"SPN":7792,"SPN_Name":"Front Hitch Roll Exit/Reason Code","SPN_Description":"Used to indicate why the front hitch cannot accept remote roll commands or has most recently stopped accepting remote commands.\\r\\n\\r\\n000000 = No reason/all clear\\r\\n000001 = Required level of operator presence/awareness not detected\\r\\n000010 = Implement released control of function\\r\\n000011 = Operator override of function\\r\\n000100 = Operator control not in valid position\\r\\n000101 = Remote command timeout\\r\\n000110 = Remote command out of range/invalid\\r\\n000111 = Function not calibrated\\r\\n001000 = Operator control fault\\r\\n001001 = Function fault\\r\\n001010 to 010011 = Reserved\\r\\n010100 = Hydraulic oil level too low\\r\\n010101 = Hitch locked out\\r\\n010110 to 110000 = Reserved\\r\\n110001 to 111101 = Manufacturer specific\\r\\n111110 = Error\\r\\n111111 = Not available (parameter not supported)","bit_length":6,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":91},"7793":{"PGN":61695,"PGN_Name":"Secondary or Front Hitch Roll and Pitch","PGN_Description":"SHRP","first_bit":32,"SPN":7793,"SPN_Name":"Front Hitch Pitch Angle","SPN_Description":"Measured pitch angle of the front three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7794":{"PGN":61695,"PGN_Name":"Secondary or Front Hitch Roll and Pitch","PGN_Description":"SHRP","first_bit":53,"SPN":7794,"SPN_Name":"Front Hitch Pitch Limit State","SPN_Description":"Used to report the Tractor ECU\'s present limit status associated with the front hitch pitch commands.\\r\\n\\r\\n000 = Not limited\\r\\n001 = Operator limited/controlled (request cannot be implemented)\\r\\n010 = Limited High (only lower command values result in a change)\\r\\n011 = Limited Low (only higher command values result in a change)\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Non recoverable fault\\r\\n111 = Not available (parameter not supported)","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7795":{"PGN":61695,"PGN_Name":"Secondary or Front Hitch Roll and Pitch","PGN_Description":"SHRP","first_bit":56,"SPN":7795,"SPN_Name":"Front Hitch Pitch Exit/Reason Code","SPN_Description":"Used to indicate why the front hitch cannot accept remote pitch commands or has most recently stopped accepting remote commands.\\r\\n\\r\\n000000 = No reason/all clear\\r\\n000001 = Required level of operator presence/awareness not detected\\r\\n000010 = Implement released control of function\\r\\n000011 = Operator override of function\\r\\n000100 = Operator control not in valid position\\r\\n000101 = Remote command timeout\\r\\n000110 = Remote command out of range/invalid\\r\\n000111 = Function not calibrated\\r\\n001000 = Operator control fault\\r\\n001001 = Function fault\\r\\n001010 to 010011 = Reserved\\r\\n010100 = Hydraulic oil level too low\\r\\n010101 = Hitch locked out\\r\\n010110 to 110000 = Reserved\\r\\n110001 to 111101 = Manufacturer specific\\r\\n111110 = Error\\r\\n111111 = Not available (parameter not supported)","bit_length":6,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":91},"7796":{"PGN":61696,"PGN_Name":"Secondary or Front Hitch Roll and Pitch Command","PGN_Description":"SHRPC","first_bit":0,"SPN":7796,"SPN_Name":"Front Hitch Roll Command","SPN_Description":"Command for setting the roll angle of the front three-point hitch expressed in degrees with 0 being horizontally aligned with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7797":{"PGN":61696,"PGN_Name":"Secondary or Front Hitch Roll and Pitch Command","PGN_Description":"SHRPC","first_bit":16,"SPN":7797,"SPN_Name":"Front Hitch Roll Sensitivity Command","SPN_Description":"Command for setting the sensitivity of the front hitch roll control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7798":{"PGN":61696,"PGN_Name":"Secondary or Front Hitch Roll and Pitch Command","PGN_Description":"SHRPC","first_bit":24,"SPN":7798,"SPN_Name":"Front Hitch Pitch Command","SPN_Description":"Command for setting the pitch angle of the front three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7799":{"PGN":61696,"PGN_Name":"Secondary or Front Hitch Roll and Pitch Command","PGN_Description":"SHRPC","first_bit":40,"SPN":7799,"SPN_Name":"Front Hitch Pitch Sensitivity Command","SPN_Description":"Command for setting the sensitivity of the front hitch pitch control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7800":{"PGN":64527,"PGN_Name":"Secondary or Front Hitch Roll and Pitch Sensitivity","PGN_Description":"SHRPS","first_bit":0,"SPN":7800,"SPN_Name":"Front Hitch Roll Sensitivity","SPN_Description":"The current sensitivity of the front hitch roll control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7801":{"PGN":64527,"PGN_Name":"Secondary or Front Hitch Roll and Pitch Sensitivity","PGN_Description":"SHRPS","first_bit":8,"SPN":7801,"SPN_Name":"Front Hitch Pitch Sensitivity","SPN_Description":"The current sensitivity of the front hitch pitch control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7802":{"PGN":61697,"PGN_Name":"Primary or Rear Hitch Roll and Pitch","PGN_Description":"PHRP","first_bit":0,"SPN":7802,"SPN_Name":"Rear Hitch Roll Angle","SPN_Description":"Measured roll angle of the rear three-point hitch expressed in degrees from horizontal alignment with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7803":{"PGN":61697,"PGN_Name":"Primary or Rear Hitch Roll and Pitch","PGN_Description":"PHRP","first_bit":21,"SPN":7803,"SPN_Name":"Rear Hitch Roll Limit State","SPN_Description":"Used to report the Tractor ECU\'s present limit status associated with the rear hitch roll commands.\\r\\n\\r\\n000 = Not limited\\r\\n001 = Operator limited/controlled (request cannot be implemented)\\r\\n010 = Limited High (only lower command values result in a change)\\r\\n011 = Limited Low (only higher command values result in a change)\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Non recoverable fault\\r\\n111 = Not available (parameter not supported)","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7804":{"PGN":61697,"PGN_Name":"Primary or Rear Hitch Roll and Pitch","PGN_Description":"PHRP","first_bit":24,"SPN":7804,"SPN_Name":"Rear Hitch Roll Exit/Reason Code","SPN_Description":"Used to indicate why the rear hitch cannot accept remote roll commands or has most recently stopped accepting remote commands.\\r\\n\\r\\n000000 = No reason/all clear\\r\\n000001 = Required level of operator presence/awareness not detected\\r\\n000010 = Implement released control of function\\r\\n000011 = Operator override of function\\r\\n000100 = Operator control not in valid position\\r\\n000101 = Remote command timeout\\r\\n000110 = Remote command out of range/invalid\\r\\n000111 = Function not calibrated\\r\\n001000 = Operator control fault\\r\\n001001 = Function fault\\r\\n001010 to 010011 = Reserved\\r\\n010100 = Hydraulic oil level too low\\r\\n010101 = Hitch locked out\\r\\n010110 to 110000 = Reserved\\r\\n110001 to 111101 = Manufacturer specific\\r\\n111110 = Error\\r\\n111111 = Not available (parameter not supported)","bit_length":6,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":91},"7805":{"PGN":61697,"PGN_Name":"Primary or Rear Hitch Roll and Pitch","PGN_Description":"PHRP","first_bit":32,"SPN":7805,"SPN_Name":"Rear Hitch Pitch Angle","SPN_Description":"Measured pitch angle of the rear three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7806":{"PGN":61697,"PGN_Name":"Primary or Rear Hitch Roll and Pitch","PGN_Description":"PHRP","first_bit":53,"SPN":7806,"SPN_Name":"Rear Hitch Pitch Limit State","SPN_Description":"Used to report the Tractor ECU\'s present limit status associated with the rear hitch pitch commands.\\r\\n\\r\\n000 = Not limited\\r\\n001 = Operator limited/controlled (request cannot be implemented)\\r\\n010 = Limited High (only lower command values result in a change)\\r\\n011 = Limited Low (only higher command values result in a change)\\r\\n100 = Reserved\\r\\n101 = Reserved\\r\\n110 = Non recoverable fault\\r\\n111 = Not available (parameter not supported)","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7807":{"PGN":61697,"PGN_Name":"Primary or Rear Hitch Roll and Pitch","PGN_Description":"PHRP","first_bit":56,"SPN":7807,"SPN_Name":"Rear Hitch Pitch Exit/Reason Code","SPN_Description":"Used to indicate why the rear hitch cannot accept remote pitch commands or has most recently stopped accepting remote commands.\\r\\n\\r\\n000000 = No reason/all clear\\r\\n000001 = Required level of operator presence/awareness not detected\\r\\n000010 = Implement released control of function\\r\\n000011 = Operator override of function\\r\\n000100 = Operator control not in valid position\\r\\n000101 = Remote command timeout\\r\\n000110 = Remote command out of range/invalid\\r\\n000111 = Function not calibrated\\r\\n001000 = Operator control fault\\r\\n001001 = Function fault\\r\\n001010 to 010011 = Reserved\\r\\n010100 = Hydraulic oil level too low\\r\\n010101 = Hitch locked out\\r\\n010110 to 110000 = Reserved\\r\\n110001 to 111101 = Manufacturer specific\\r\\n111110 = Error\\r\\n111111 = Not available (parameter not supported)","bit_length":6,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":91},"7808":{"PGN":61698,"PGN_Name":"Primary or Rear Hitch Roll and Pitch Command","PGN_Description":"PHRPC","first_bit":0,"SPN":7808,"SPN_Name":"Rear Hitch Roll Command","SPN_Description":"Command for setting the roll angle of the rear three-point hitch expressed in degrees with 0 being horizontally aligned with the rear axle of the tractor. Facing the direction of travel, an anti-clockwise rotation would be indicated by a negative number and a clockwise rotation would be indicated by a positive number.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7809":{"PGN":61698,"PGN_Name":"Primary or Rear Hitch Roll and Pitch Command","PGN_Description":"PHRPC","first_bit":16,"SPN":7809,"SPN_Name":"Rear Hitch Roll Sensitivity Command","SPN_Description":"Command for setting the sensitivity of the rear hitch roll control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7810":{"PGN":61698,"PGN_Name":"Primary or Rear Hitch Roll and Pitch Command","PGN_Description":"PHRPC","first_bit":24,"SPN":7810,"SPN_Name":"Rear Hitch Pitch Command","SPN_Description":"Command for setting the pitch angle of the rear three-point hitch expressed in degrees from vertical alignment of the upper and lower attachment points. Positive is in the anti-clockwise direction when viewed from the left-hand side of the tractor.","bit_length":16,"scaling":0.002,"offset":-64,"unit":"deg","SLOT_ID":242},"7811":{"PGN":61698,"PGN_Name":"Primary or Rear Hitch Roll and Pitch Command","PGN_Description":"PHRPC","first_bit":40,"SPN":7811,"SPN_Name":"Rear Hitch Pitch Sensitivity Command","SPN_Description":"Command for setting the sensitivity of the rear hitch pitch control expressed as a percentage of the maximum gain. 0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7812":{"PGN":64526,"PGN_Name":"Primary or Rear Hitch Roll and Pitch Sensitivity","PGN_Description":"PHRPS","first_bit":0,"SPN":7812,"SPN_Name":"Rear Hitch Roll Sensitivity","SPN_Description":"The current sensitivity of the rear hitch roll control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7813":{"PGN":64526,"PGN_Name":"Primary or Rear Hitch Roll and Pitch Sensitivity","PGN_Description":"PHRPS","first_bit":8,"SPN":7813,"SPN_Name":"Rear Hitch Pitch Sensitivity","SPN_Description":"The current sensitivity of the rear hitch pitch control expressed as a percentage of the maximum gain.  0% indicates minimal gain in the control loop; 100%, the maximum gain. Values near zero may result in no reaction by the control loop.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7825":{"PGN":64525,"PGN_Name":"Fire Pump Statistics 1","PGN_Description":"FPS1","first_bit":0,"SPN":7825,"SPN_Name":"Fire Pump Operation Time","SPN_Description":"Accumulated time that the fire pump is enaged.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"7826":{"PGN":64525,"PGN_Name":"Fire Pump Statistics 1","PGN_Description":"FPS1","first_bit":32,"SPN":7826,"SPN_Name":"Fire Pump Engagement Cycles","SPN_Description":"Accumulated number of times the fire pump has been engaged.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"7827":{"PGN":65099,"PGN_Name":"Transmission Configuration 2","PGN_Description":"TCFG2","first_bit":32,"SPN":7827,"SPN_Name":"Transmission Communications Failure Idle Torque Limit","SPN_Description":"This parameter is provided to the engine from the transmission as an idle governor torque limit to be invoked by the engine in the event that CAN communication with the transmission is lost.\\r\\n\\r\\nThe data is transmitted in indicated torque as a percent of reference engine torque (see the engine configuration message, PGN 65251). The percent torque value will not be less than zero and it includes the torque developed in the cylinders required to overcome friction.\\r\\n\\r\\nPlease note that the \u201CTransmission Communications Failure Idle Torque Limit\u201D only applies to the engine\u2019s idle governor. It does not alter the engine\'s torque map. Full accelerator torque and other similar torque requests are still allowed to access the full torque map.\\r\\n\\r\\nIt is recommended that engines use reception of the ETC#1 message as a transmission \u201Cheartbeat\u201D.  In the event that the ETC#1 message is not received in a time period of 5 times its\u2019 broadcast rate (5 x 10 ms = 50 ms), the engine should invoke the last received idle torque limit in the current ignition cycle, holding the engine idle torque to less than or equal to the value of the \u201CTransmission Failure Mode Idle Torque Limit\u201D parameter. The engine may release the limit when transmission-to-engine communication is re-established.\\r\\n\\r\\nA value of 0xFB indicates that no \u201CTransmission Communications Failure Idle Torque Limit\u201D is currently desired, but the transmission supports the parameter. A value of 0xFF indicates that the \u201CTransmission Communications Failure Idle Torque Limit\u201D is not supported by the transmission.\\r\\n\\r\\nIt is expected that the engine will include that last received \u201CTransmission Communications Failure Idle Torque Limit\u201D in the engine configuration PGN-65251 as parameter SPN 7828 \u201CEngine Default Idle Torque Limit\u201D.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"7828":{"PGN":65251,"PGN_Name":"Engine Configuration 1","PGN_Description":"EC1","first_bit":312,"SPN":7828,"SPN_Name":"Engine Default Idle Torque Limit","SPN_Description":"Companion parameter to \u201CTransmission Communications Failure Idle Torque Limit\u201D (SPN 7827).  This \u201Cecho\u201D parameter provides confirmation to the transmission that the engine has received and will invoke the requested SPN 7827 \u201CTransmission Communications Failure Idle Torque Limit\u201D in the event that CAN communication is lost between the two devices.\\r\\n\\r\\nThe data is transmitted in indicated torque as a percent of reference engine torque (see the engine configuration message, PGN 65251). The percent torque value will not be less than zero and it includes the torque developed in the cylinders required to overcome friction.\\r\\n\\r\\nPlease note that the \u201CEngine Default Idle Torque Limit\u201D only applies to the Engine\u2019s idle governor. It does not alter the engine\'s torque map. Full accelerator torque and other similar torque requests are still allowed to access the full torque map.\\r\\n\\r\\nIt is recommended that engines use reception of the ETC#1 message as a transmission \u201Cheartbeat\u201D. In the event that the ETC#1 message is not received in a time period of 5 times its\u2019 broadcast rate (5 x 10 ms = 50 ms), the engine should invoke the last received idle torque limit in the current ignition cycle, holding the engine idle torque to less than or equal to the value of the \u201CTransmission Communications Failure Idle Torque Limit\u201D parameter. The engine may release the limit when transmission-to-engine communication is re-established.\\r\\n\\r\\nIf the engine supports this protection logic, the \u201CEngine Default Idle Torque Limit\u201D parameter should be set equal to the \u201CTransmission Communications Failure Idle Torque Limit\u201D parameter last received in the Transmission Configuration 2 message (PGN 65099). Otherwise, an \u201CEngine Default Idle Torque Limit\u201D value of 0xFB indicates that no \u201CTransmission Communications Failure Idle Torque Limit\u201D has been received or set in this ignition cycle. If the engine does not support this logic, an \u201CEngine Default Idle Torque Limit\u201D value of 0xFF should be set.","bit_length":8,"scaling":1,"offset":-125,"unit":"%","SLOT_ID":45},"7829":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":40,"SPN":7829,"SPN_Name":"Transmission Idle Governor Fueling Inhibit","SPN_Description":"This parameter is a command provided to the Engine Control Module (ECM) from the Transmission Control Module (TCM) to inhibit idle governor fueling in the unlikely event that transmission has detected a failure preventing driveline disengagement. This parameter is not intended for engine stop-start functionality or other normal (non-failure mode) operation.\\r\\n\\r\\nPlease note that the \u201CTransmission Idle Governor Fueling Inhibit\u201D only applies to the Engine\u2019s idle governor. It does not alter the engine\'s torque map. Full accelerator pedal torque and other similar torque requests are still allowed to access the full torque map when the \\"Transmission Idle Governor Fueling Inhibit\\" is active.\\r\\n \\r\\n00 - \u201CTransmission Idle Governor Fueling Inhibit\u201D is not currently desired.\\r\\n01 - Transmission is currently commanding the Engine to inhibit idle governor fueling.\\r\\n10 - Reserved for future SAE use.\\r\\n11 - Don\'t care/take no action.\\r\\n\\r\\nIt is expected that the engine will include the \u201CTransmission Idle Governor Fueling Inhibit Support\u201D in the EC2 PGN 64895 as parameter SPN 7830.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7830":{"PGN":64895,"PGN_Name":"Engine Configuration 2","PGN_Description":"EC2","first_bit":32,"SPN":7830,"SPN_Name":"Transmission Idle Governor Fueling Inhibit Support","SPN_Description":"Companion parameter to \u201CTransmission Idle Governor Fueling Inhibit\u201D (SPN 7829). This \u201Cconfiguration\u201D parameter provides confirmation to the Transmission that the engine supports the \u201CTransmission Idle Governor Fueling Inhibit\u201D feature.\\r\\n\\r\\n00 - Indicates that the engine does not support the \u201CTransmission Idle Governor Fueling Inhibit\u201D feature\\r\\n01 - Indicates that the engine will respond to a \u201CTransmission Idle Governor Fueling Inhibit\u201D command from the Transmission, should it be received\\r\\n10 - Reserved for future SAE use\\r\\n11 - Not supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7831":{"PGN":61699,"PGN_Name":"Generator Trip Energy","PGN_Description":"GTRACE","first_bit":0,"SPN":7831,"SPN_Name":"Generator Trip kW Hours Export","SPN_Description":"The total kilowatt-hours that have been exported by the generator since the last reset of the trip kWh meter.\\r\\n\\r\\nThis value will be reset by the user at will.","bit_length":32,"scaling":1,"offset":0,"unit":"kWh","SLOT_ID":150},"7832":{"PGN":61699,"PGN_Name":"Generator Trip Energy","PGN_Description":"GTRACE","first_bit":32,"SPN":7832,"SPN_Name":"Generator Trip kVAr Hours Export","SPN_Description":"The trip AC reactive energy exported by the generstor since the last reset of the trip kVArh meter.\\r\\n\\r\\nThis value will be reset by the user at will.","bit_length":32,"scaling":1,"offset":0,"unit":"kVArh","SLOT_ID":257},"7833":{"PGN":64524,"PGN_Name":"Evaporative Systems","PGN_Description":"EVAP","first_bit":0,"SPN":7833,"SPN_Name":"Canister Vent Valve","SPN_Description":"The state of the canister vent value used to allow fresh air into the charcoal vapor canister.\\r\\n\\r\\n00 - Vent Valve is Closed\\r\\n01 - Vent Valve is Open\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7834":{"PGN":64524,"PGN_Name":"Evaporative Systems","PGN_Description":"EVAP","first_bit":8,"SPN":7834,"SPN_Name":"Canister Purge Valve Command","SPN_Description":"The commanded positon of the canister purge valve used to allow fuel vapors from the charcoal canister into the intake manifold.\\r\\n\\r\\nA value of 0 % indicates fully closed, a value of 100 % indicates fully open.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7835":{"PGN":64524,"PGN_Name":"Evaporative Systems","PGN_Description":"EVAP","first_bit":16,"SPN":7835,"SPN_Name":"Gasoline Fuel Tank Pressure","SPN_Description":"The gage pressure of the vapor in the gasoline fuel tank.","bit_length":16,"scaling":0.1,"offset":-3212.7,"unit":"kPa","SLOT_ID":355},"7836":{"PGN":64732,"PGN_Name":"Cruise Control / Vehicle Speed 3","PGN_Description":"CCVS3","first_bit":26,"SPN":7836,"SPN_Name":"Cruise Control Driver Cancellation Status","SPN_Description":"State signal which indicates that the cruise control is cancelled by driver action.  Driver actions could include switch off, brake pedal activation, clutch pedal actuation, cancel switch, or other reasons determined by the cruise control application.\\r\\n\\r\\nThis parameter will be set to 01b if Cruise Control States (SPN 527) goes to 00b (Off/disabled) due to a driver action\\r\\n\\r\\nThis parameter will be set to 00b if Cruise Control States (SPN 527) leaves the state 00b (Off/disabled) OR if there are conditions, not initiated by the driver, that also cancelled cruise control. E.g. low vehicle speed.\\r\\n\\r\\nInitial state of Cruise control cancelled by driver action after ignition on is 00b.\\r\\n\\r\\n00 - Driver action has not cancelled cruise control\\r\\n01 - Cruise control cancelled by driver action\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7837":{"PGN":64523,"PGN_Name":"Electronic Engine Controller 20","PGN_Description":"EEC20","first_bit":0,"SPN":7837,"SPN_Name":"Estimated Engine Parasitic Losses - Percent Torque (High Resolution)","SPN_Description":"Indicates the estimated amount of torque loss due to engine parasitics, such as cooling fan, air compressor, air conditioning, etc. It is expressed as a percent of Engine Reference Torque.   \\r\\n \\r\\nIf there are multiple devices on a network that provide this parameter, then users of this data shall add each of these values to determine the total torque loss due to engine parasitics.  Devices that provide this parameter shall use the value of Engine Reference Torque transmitted by the engine during the current key cycle to determine the percent torque loss as seen by the engine. \\r\\n\\r\\nSee SPN 2978 for alternate resolution.   If both SPN 2978 and SPN 7837 are supported by a single source address, consumers of the parasitic data should only use one of these values.\\r\\n\\r\\nNote:  Refer to section 5.2.1 in SAE J1939-71.","bit_length":16,"scaling":0.0015625,"offset":0,"unit":"%","SLOT_ID":345},"7840":{"PGN":64913,"PGN_Name":"AC Switching Device Status","PGN_Description":"ACS","first_bit":11,"SPN":7840,"SPN_Name":"Engine Speed Governor Mode","SPN_Description":"Indicates the engine speed governor operating mode.\\r\\n\\r\\n00 - Isochronous Mode\\r\\n01 - Droop Mode\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7841":{"PGN":64913,"PGN_Name":"AC Switching Device Status","PGN_Description":"ACS","first_bit":13,"SPN":7841,"SPN_Name":"Bus Tie Breaker 1","SPN_Description":"The measured state of first tie breaker on the electrical power bus.\\r\\n\\r\\n000 - Open\\r\\n001 - Closed\\r\\n010 - Locked Out\\r\\n011 - Transitioning to Open state\\r\\n100 - Transitioning to Closed state\\r\\n101 - Available for SAE assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7842":{"PGN":64913,"PGN_Name":"AC Switching Device Status","PGN_Description":"ACS","first_bit":16,"SPN":7842,"SPN_Name":"Bus Tie Breaker 2","SPN_Description":"The measured state of second tie breaker on the electrical power bus.\\r\\n\\r\\n000 - Open\\r\\n001 - Closed\\r\\n010 - Locked Out\\r\\n011 - Transitioning to Open state\\r\\n100 - Transitioning to Closed state\\r\\n101 - Available for SAE assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7843":{"PGN":64913,"PGN_Name":"AC Switching Device Status","PGN_Description":"ACS","first_bit":19,"SPN":7843,"SPN_Name":"Engine Load Group","SPN_Description":"The engine load group for the reporting engine. An Engine Load Group is a set of engines tied together for sharing the electrical power bus load. Load Group assignments are manufacturer specific.","bit_length":5,"scaling":1,"offset":0,"unit":"count","SLOT_ID":232},"7844":{"PGN":3072,"PGN_Name":"Electronic Engine Controller 16","PGN_Description":"EEC16","first_bit":10,"SPN":7844,"SPN_Name":"Engine Clutch Engage Request Status","SPN_Description":"Indicates if the engine has an external request to establish its operating conditions to be appropriate for engagement of the transmission or gearbox.\\r\\n\\r\\n00 - Engine does not have an external request\\r\\n01 - Engine has an external request\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7845":{"PGN":64988,"PGN_Name":"Marine Control Information","PGN_Description":"MCI","first_bit":8,"SPN":7845,"SPN_Name":"Engine Marine Operating Mode Status","SPN_Description":"The operating mode of the engine for marine functions.\\r\\n\\r\\n000 - Maintenance Mode\\r\\n001 - Electrical Power Generation (EPG) mode\\r\\n010 - Propulsion Constant Speed Mode\\r\\n011 - Propulsion Variable Speed Mode\\r\\n100 to 101 - Reserved\\r\\n110 - Error\\r\\n111 - Not available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"7846":{"PGN":61700,"PGN_Name":"Engine Speed Sensor Information 2","PGN_Description":"ESSI2","first_bit":0,"SPN":7846,"SPN_Name":"Engine Speed 4","SPN_Description":"The engine speed as measured by speed sensor 4.\\r\\n\\r\\nNotes: This is for the engine speed from the 4th engine speed sensor. This may be different than SPN 190 when used in multiple engine speed sensor configurations. In an application with multiple engine speed sensors, SPN 190 data can be derived from any of the speed sensors.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7847":{"PGN":3072,"PGN_Name":"Electronic Engine Controller 16","PGN_Description":"EEC16","first_bit":8,"SPN":7847,"SPN_Name":"Ready For Clutch Engagement Status","SPN_Description":"Indicates the engine operating conditions are appropriate for engagement of the transmission or gearbox clutch.\\r\\n\\r\\n00 - Engine Not Ready For Clutch Engagement\\r\\n01 - Engine is Ready For Clutch Engagement\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7848":{"PGN":64586,"PGN_Name":"SCR System Cleaning","PGN_Description":"SCRSC","first_bit":60,"SPN":7848,"SPN_Name":"Aftertreatment 1 SCR System Conditions Not Met for Active Cleaning","SPN_Description":"Indicates that SCR System 1 is not able to begin or continue an active cleaning event at the current engine operating conditions.\\r\\n\\r\\n00 - SCR System Cleaning not Inhibited\\r\\n01 - SCR System Cleaning Inhibited\\r\\n10 - Reserved for SAE Assignment\\r\\n11 - Not available\\r\\n\\r\\nThis SPN would indicate that the SCR system (bank 1) is not able to begin or continue an active cleaning event due to current engine operating conditions.\\r\\n\\r\\nThe conditions on these SPNs are exclusive to the conditions in the PGN 64586.\\r\\n\\r\\nExamples of these other conditions are:\\r\\n  - Engine Speed/Load Conditions not met\\r\\n  - Engine is a working mode scenario\\r\\n\\r\\nSPN 6917 should be set to inhibited when SPN 7848 goes to inhibited status.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7849":{"PGN":64823,"PGN_Name":"Aftertreatment 2 SCR Service Information 1","PGN_Description":"A2SCRSI1","first_bit":40,"SPN":7849,"SPN_Name":"Aftertreatment 2 SCR System Sulfation Level","SPN_Description":"Indicates the sulfur level in the SCR system for aftertreatment 2.\\r\\n\\r\\n100% level could be the regeneration trigger level (and if conditions are not favorable for regeneration, sulfation loading can continue beyond 100%). During normal operation and regeneration a value 0% will indicate a fully regenerated SCR system. Values of 25%, 50% and 75% will indicate the general level of sulfur prior to the 100% level where regeneration could be needed.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7850":{"PGN":64528,"PGN_Name":"Ambient Conditions 3","PGN_Description":"AMB3","first_bit":16,"SPN":7850,"SPN_Name":"Engine Intake 2 Air Temperature","SPN_Description":"Temperature of air entering through a second vehicle air induction system.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7851":{"PGN":33024,"PGN_Name":"Aftertreatment System Control","PGN_Description":"AFTSC","first_bit":8,"SPN":7851,"SPN_Name":"Aftertreatment System Enable Status","SPN_Description":"Indicates that the aftertreatment system is enabled or disabled.  Enabled indicates the system will dose at regular intervals.\\r\\n\\r\\n00 - Aftertreatment System is Disabled\\r\\n01 - Aftertreatment System is Enabled\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nNote:  In some marine applications it may be desireable to enable or disable the aftretreatment system.  To disable the system the user will need to get a migratory exemption from EPA 1042.915.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7852":{"PGN":64546,"PGN_Name":"Electronic Engine Controller 19","PGN_Description":"EEC19","first_bit":32,"SPN":7852,"SPN_Name":"Engine Exhaust Flow Rate (Extended Range)","SPN_Description":"Engine Exhaust Flow Rate shall indicate the measured/calculated exhaust gas mass flow upstream of the aftertreatment system.\\r\\n\\r\\nSee SPN 6895 for alternative range.","bit_length":32,"scaling":0.001,"offset":0,"unit":"kg/h","SLOT_ID":419},"7853":{"PGN":64993,"PGN_Name":"Cab A/C Climate System Information","PGN_Description":"CACI","first_bit":8,"SPN":7853,"SPN_Name":"Air Conditioner Compressor Status","SPN_Description":"Signal which indicates if the Air Conditioner compressor is on or off.\\r\\n\\r\\n00 - Air Conditioner Compressor is OFF\\r\\n01 - Air Conditioner Compressor is ON\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7855":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":48,"SPN":7855,"SPN_Name":"Engine Fueling Not Desired Reason","SPN_Description":"This parameter conveys the reason a device wants the engine to inhibit fuelling.\\r\\n \\r\\nThis SPN is intended to be used in conjunction with Desired Engine Fueling State (SPN 5793). When a device sends Desired Engine Fueling State = \u201CFueling Not Desired\u201D, this SPN may be used to convey a reason for why the device desires the engine inhibit fuelling\\r\\n\\r\\nIf more than one reason exists at the same time, the reason with highest importance (as defined by the device sending this parameter) is indicated. \\r\\n \\r\\n0 = Desired Engine Fueling State (SPN 5793) from this device does not equal 00 \\r\\n1 = Idle Shutdown Timer has expired\\r\\n2 = External power source has been connected (shore power)\\r\\n3 = Body builder - unspecified reason\\r\\n4 = Engine Stop-Start\\r\\n5 to 249 = SAE Reserved (for future reasons)\\r\\n250 = Fueling is not desired due to unspecified reason\\r\\n251 to 254 = SAE reserved\\r\\n255 = Not supported","bit_length":8,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":93},"7888":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":8,"SPN":7888,"SPN_Name":"Operator Vehicle Mode Request ","SPN_Description":"Operator Vehicle Mode Request is the operator intended vehicle mode.  This parameter can be from only one source on the vehicle.  In the case of a Diesel-Electric Hybrid, the source of this parameter may be a vehicle controller that monitors the operator interface for commands.\\r\\n\\r\\nOff is entered following key off.\\r\\n\\r\\nLow Voltage Accessory mode is when low voltage accessories may be powered from the SLI battery.  The Stored Energy Source is disconnected.   No propulsion is available in this mode.  In this mode, gear selector requests to exit neutral or park are not honored.\\r\\n\\r\\nStored Energy Source Active mode is when both the low voltage accessories and the Stored Energy Source are online.  No propulsion is allowed.  In this mode, gear selector requests to exit neutral or park are not honored.  In a Diesel-Electric hybrid, the high voltage accessories will be available in this mode.\\r\\n\\r\\nPropulsion Active mode is when both the low voltage accessories and the Stored Energy Source are online.  Propulsion is allowed.   In this mode, gear selector requests may be honored.  In a Diesel-Electric hybrid, the high voltage accessories will be available in this mode.\\r\\n\\r\\n0 - Off\\r\\n1 - Low Voltage Accessory\\r\\n2 - Stored Energy Source Active\\r\\n3 - Propulsion Active\\r\\n4 to13 - Reserved\\r\\n14 - Error\\r\\n15 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7889":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":12,"SPN":7889,"SPN_Name":"Hybrid Propulsion Mode Request ","SPN_Description":"Hybrid Propulsion Mode Request is the operator intended propulsion mode.  This parameter can be from only one source on the vehicle.  Response to this request can be found in the Hybrid Propulsion Mode Status (SPN 7896) and Hybrid Propulsion Mode Transition Status (SPN 7897) parameters.  In the case of a Diesel-Electric Hybrid, the source of this parameter may be a vehicle controller that monitors the operator interface for commands.  Vehicle Performance may be reduced using Performance Bias Selection (SPN 6874) in any of these modes.\\r\\n\\r\\nStored Energy Source Sustaining: In this mode, normal hybrid operation is desired.  This state is characterized by the Stored Energy Source being online.   In a Diesel-Electric hybrid, this operating mode is characterized as HVES charge sustaining where the energy for the vehicle is supplied by the combination of engine and HVES.  The Stored Energy Source Set Point Request (SPN 7892) may be used to set an operating charge level for the HVES.  Engine stop-start is available in this mode unless specifically disabled, however, engine off is still considered charge sustaining while operating in Engine stop-start.\\r\\n\\r\\nStored Energy Source Increasing: In this mode the Stored Energy Source is online and the system is requested to increase the stored energy level to the Stored Energy Source Set Point Request (SPN 7892).   Progress towards the set point can be monitored using the Stored Energy Source Level (SPN 7895) parameter.   When the set point is achieved, the system will hold the set point.  The rate at which energy is increased is set based on the Stored Energy Charge/Discharge Rate Request (SPN 7891).  In a Diesel-Electric Hybrid, this mode would be characterized by the HVES being charged by an onboard engine (fuel cell etc.) or external source.   This may be used to pre-condition the HVES in anticipation of a hybrid Stored Energy Source Only mode of operation.\\r\\n\\r\\n \\nStore Energy Source Depleting: In this mode the Stored Energy Source is online.  This state prioritizes use of the Stored Energy Source with the intent to reduce the energy stored.  The requested Stored Energy Source Set Point Request (SPN 7892) may be used.   Progress towards the set point can be monitor using the Stored Energy Source Level (SPN 7895).   When the set point is achieved, the system will attempt to hold the set point.  In a Diesel-Electric hybrid, this mode would be characterized by the HVES being discharged in general.  The engine may be operational.\\r\\n\\r\\nStored Energy Source Offline: In this mode the Stored Energy Source is offline and is not used as a source of propulsion and/or accessory power.  In a Diesel-Electric hybrid, this mode would be characterized by engine (fuel cell, etc.) only operation.\\r\\n\\r\\nStored Energy Source Only: In this mode the Stored Energy Source is online and is the only source of propulsion and/or accessory power.  In a Diesel-Electric hybrid, this mode is characterized as \u201CHVES only\u201D operation.  The engine is not operational.\\r\\n\\r\\n0 - No mode requested\\r\\n1 - Stored Energy Source Sustaining\\r\\n2 - Stored Energy Source Increasing\\r\\n3 - Stored Energy Source Depleting\\r\\n4 - Stored Energy Source Offline\\r\\n5 - Stored Energy Source Only\\r\\n6 to 13 - Reserved\\r\\n14 - Error\\r\\n15 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7890":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":16,"SPN":7890,"SPN_Name":"External Energy Source Connection Demand ","SPN_Description":"External Energy Source Connection Demand indicates how the hybrid system should engage with the external energy source that is temporarily connected to the vehicle.\\r\\n\\r\\nThis parameter allows for two external energy source connections.  Propulsion may or may not be allowed as defined by the Operator Vehicle Mode Request (SPN 7888).  The state of the engine (fuel cell etc.) is dictated by the Hybrid Propulsion Mode Request (SPN 7889).  This parameter can be from only one source.  In the case of a Diesel-Electric Hybrid, the source of this parameter may be a vehicle controller or the connected charger.   Status of the connection can be found in the External Energy Source Connection Status (SPN 7898) parameter.\\r\\n\\r\\nPerform Connection Verification is requested to connect and ensure a proper connection between an external energy source and the onboard stored energy source.  If the connection is not verified, the External Energy Source Connection Status (SPN 7898) will indicate state 1 Connection \u2013 Error (Verification failed).\\r\\n\\r\\nEnergy Source and Drain:  An external source of power is connected to the vehicle that may be used to assist the onboard systems in managing the Stored Energy Source level (SPN 7895) to the Stored Energy Source Set Point Request (SPN 7892).  In a Diesel-Electric hybrid, this type of External Energy Source may be energy depleting or increasing from an HVES point of view depending on the operation of the vehicle and controls.  This option may be used in the case of a trolley bus where energy can be sourced from, or drain to, the utility grid.\\r\\n\\r\\nEnergy Source: An external source of power is connected to increase stored energy.  In the case of a plug-in hybrid or electric vehicle, this could be the Electric Vehicle Supply Equipment (EVSE) as defined in SAE J1772.  It is intended to increase the state of charge of the HVES.\\r\\n\\r\\nEnergy Drain: An external power drain is connected that decreases stored energy.  In the case of a plug-in hybrid, this device will reduce the HVES state of charge.  This device may also be used to drain a capacitor-based stored energy source prior to maintenance.\\r\\n\\r\\nDisconnect Request: The external energy device is requesting the hybrid system to disconnect due to a normal shutdown or failure mode.\\r\\n\\r\\n0 - No Connection\\r\\n1 - Perform Connection 1 Verification\\r\\n2 - Energy Drain or Source Connection 1\\r\\n3 - Energy Source Connection 1\\r\\n4 - Energy Drain Connection 1\\r\\n5 - Perform Connection 2 Verification\\r\\n6 - Energy Drain or Source Connection 2\\r\\n7 - Energy Source Connection 2\\r\\n8 - Energy Drain Connection 2\\r\\n9 to 13 - Reserved\\r\\n14 - Disconnect Request\\r\\n15 - No Request/Take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7891":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":24,"SPN":7891,"SPN_Name":"Stored Energy Source Charge/Discharge Rate Request","SPN_Description":"Stored Energy Source Charge/Discharge Rate Request is used to control the rate at which the stored energy is changed in Energy Increasing or Energy Depleting modes.\\r\\n\\r\\nA value of 0xFB indicates a request for the default charge/discharge rate.  In a Diesel-Electric Hybrid, it is the percentage of the maximum charging rate allowed by the system.  The system will control the charging rate to its maximum allowed when at 100%.  This parameter provides the ability to charge the HVES at different rates.  If there are multiple sources of this parameter the greatest charge/discharge rate is used.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7892":{"PGN":32768,"PGN_Name":"Hybrid System Control 1","PGN_Description":"HSC1","first_bit":32,"SPN":7892,"SPN_Name":"Stored Energy Source Set Point Request ","SPN_Description":"Stored Energy Source Set Point Request is used to set the percentage that the Stored Energy Source should be managed to by the system.\\r\\n\\r\\nA value of 0xFB indicates a request for the default set point.  In the case of a Diesel-Electric Hybrid, the percentage (0-100%) is the percentage of HVES capacity available for use. This is a percentage of the useable HVES capacity (i.e., not the actual capacity, or State of Charge).  If there are multiple sources of this parameter the level closest to 100% is used.  Stored Energy Source Level (SPN 7895) provides a status of the actual level versus this set point.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7893":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":26,"SPN":7893,"SPN_Name":"Stored Energy Source Only Mode Allowed","SPN_Description":"Stored Energy Source Only Mode Allowed is sent by the Hybrid System controller to indicate when Stored Energy Source Only Mode is available for use and/or allowed to be used.\\r\\n\\r\\nIn a Diesel-Electric Hybrid, Stored Energy Source Only mode is characterized as \u201CHVES only\u201D operation.  The engine is not operational.  This parameter may be set to 00b when operating conditions such as high vehicle speeds, low HVES state of charge, or degraded HVES would inhibit use of this mode.\\r\\n\\r\\n00 - Mode NOT allowed\\r\\n01 - Mode allowed\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7894":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":28,"SPN":7894,"SPN_Name":"Stored Energy Source Increasing Mode Allowed ","SPN_Description":"Stored Energy Source Increasing Mode Allowed is sent by the Hybrid System controller to indicate when the Stored Energy Source Increasing Mode is available for use and/or allowed to be used.\\r\\n\\r\\nIn a Diesel-Electric hybrid, this parameter may be set to 00b when operating conditions such as high vehicle speeds, high HVES state of charge, or degraded HVES would inhibit use of this mode.\\r\\n\\r\\n00 - Mode NOT allowed\\r\\n01 - Mode allowed\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7895":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":32,"SPN":7895,"SPN_Name":"Stored Energy Source Level","SPN_Description":"Stored Energy Source Level is sent by the Hybrid System controller to indicate the current operating stored energy source capacity.\\r\\n\\r\\nIn a Diesel-Electric Hybrid, this is the current percentage of the HVES useable capacity.  When the state of charge is below the minimum HVES useable capacity, this parameter shall be set to 0 percent.  When the state of charge of the HVES is above the maximum HVES useable capacity, this parameter shall be set to 100%.  When charging the HVES, this parameter may be used to determine the progress towards the Stored Energy Source Set Point Request (SPN 7892). This parameter may also be used as a \u201Cfuel level\u201D indicator for the vehicle operator.\\r\\n\\r\\nFor example, a HVES manufacturer may define the HVES useable capacity to be between a notional 30% to 70% state of charge (SOC).  In this example, the 0% stored energy level would be the equivalent of 30% or lower SOC and the 100% stored energy source level would be the equivalent of 70% or higher SOC.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"7896":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":40,"SPN":7896,"SPN_Name":"Hybrid Propulsion Mode Status ","SPN_Description":"Hybrid Propulsion Mode Status is the current Hybrid System Controller propulsion mode.  This parameter would typically echo the Hybrid Propulsion Mode Request (SPN 7889) assuming the request was honored and the Hybrid System controller successfully transitioned to the requested mode.  See Hybrid Propulsion Mode Request (SPN 7889) for the detailed state definitions.  This parameter will also communicate a change in mode status that occurred due to exceeding operational limits for a mode as reported in Hybrid Propulsion Mode Transition Status (SPN 7897).\\r\\n\\r\\n0 - No mode requested\\r\\n1 - Stored Energy Source Sustaining\\r\\n2 - Stored Energy Source Increasing\\r\\n3 - Stored Energy Source Depleting\\r\\n4 - Stored Energy Source Offline\\r\\n5 - Stored Energy Source Only\\r\\n6 to 13 - Reserved\\r\\n14 - Error\\r\\n15 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7897":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":44,"SPN":7897,"SPN_Name":"Hybrid Propulsion Mode Transition Status ","SPN_Description":"Hybrid Propulsion Mode Transition Status is sent by the Hybrid System controller to indicate the reason for a mode transition occurring or being denied.  This parameter provides confirmation of any mode transition requested via the Hybrid Propulsion Mode Request (SPN 7889) parameter, or conveys why the transition has been denied.\\r\\n\\n0 - No transition requested\\r\\n1 - Transition requested and in process\\r\\n2 - Requested mode denied \u2013 Requested mode not available\\r\\n3 - Requested mode denied \u2013 Vehicle Speed unacceptable for requested mode\\r\\n4 - Requested mode denied \u2013 HVES State of Charge unacceptable for requested mode\\r\\n5 - Requested mode denied \u2013 Temporary limit exceeded. The temporary limit may be bounded by elapsed time, distance travelled, driving conditions, or something else that the manufacturer has specified.\\r\\n6 - Requested mode denied \u2013 HVES temporary limit threshold exceeded for one or more HVES\\r\\n7 to 12 -  Reserved\\r\\n13 - Requested mode denied- reason not specified\\r\\n14 - Error\\r\\n15 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7898":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":48,"SPN":7898,"SPN_Name":"External Energy Source Connection Status ","SPN_Description":"External Energy Source Connection Status provides feedback to the External Energy Source Connection Demand (SPN 7890).  This parameter allows for status of two external energy source connections.  See External Energy Source Connection Demand (SPN 7890) for the detailed state definitions.  In the case of a Diesel-Electric Hybrid, this parameter is sent by the hybrid system or Power System manager.\\r\\n\\r\\n\\n0 - No Connection\\r\\n1 - Connection 1 \u2013 Error (Verification failed)\\r\\n2 - Connection 1 \u2013 Verification in Process\\r\\n3 - Connection 1 \u2013 Energy Source and Drain\\r\\n4 - Connection 1 \u2013 Energy Source\\r\\n5 - Connection 1 \u2013 Energy Drain\\r\\n6 - Connection 2 \u2013 Error (Verification failed)\\r\\n7 - Connection 2 \u2013 Verification in Process\\r\\n8 - Connection 2 \u2013 Energy Source and Drain\\r\\n9 - Connection 2 \u2013 Energy Source\\r\\n10 - Connection 2 \u2013 Energy Drain\\r\\n11 to 13 - Reserved\\r\\n14 - Error\\r\\n15 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7899":{"PGN":64561,"PGN_Name":"Aftertreatment System Information 1","PGN_Description":"ASI1","first_bit":26,"SPN":7899,"SPN_Name":"Diesel Exhaust Fluid Quality Malfunction Evaluation Period Active","SPN_Description":"This parameter is used to notify the operator that a DEF Quality and DEF Level evaluation period, also known as a judgement period, is currently active.\\r\\n\\r\\nThe judgement period is required by the Japanese Ministry of Land, Interior, and Transport (JMLIT) when an indirect method is used to judge the quality of the DEF in the DEF tank. The judgement period would be activated only after the operator has filled the DEF to a level as specified in the Japanese legislation. See \\"Technical Guideline for Urea Selective Catalytic Reduction System\\" (JMLIT Kokijikan No. 91 of August 26, 2008).\\r\\n\\r\\n00 - Not active\\r\\n01 - Active\\r\\n10 - SAE reserved\\r\\n11 - Not supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7900":{"PGN":64522,"PGN_Name":"Vehicle Electrical Power 7","PGN_Description":"VEP7","first_bit":0,"SPN":7900,"SPN_Name":"SLI Battery Pack 1 Battery 1 Net Current","SPN_Description":"Net flow of electrical current into/out of the first battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"7901":{"PGN":64522,"PGN_Name":"Vehicle Electrical Power 7","PGN_Description":"VEP7","first_bit":16,"SPN":7901,"SPN_Name":"SLI Battery Pack 1 Battery 1 Temperature","SPN_Description":"Temperature of the first battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7902":{"PGN":64522,"PGN_Name":"Vehicle Electrical Power 7","PGN_Description":"VEP7","first_bit":24,"SPN":7902,"SPN_Name":"SLI Battery Pack 1 Battery 1 Voltage","SPN_Description":"Voltage of the first battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"7903":{"PGN":64521,"PGN_Name":"Vehicle Electrical Power 8","PGN_Description":"VEP8","first_bit":0,"SPN":7903,"SPN_Name":"SLI Battery Pack 1 Battery 1 State of Charge","SPN_Description":"Indicates the remaining charge of the first battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery\'s current state of health.\\r\\n\\r\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7904":{"PGN":64521,"PGN_Name":"Vehicle Electrical Power 8","PGN_Description":"VEP8","first_bit":16,"SPN":7904,"SPN_Name":"SLI Battery Pack 1 Battery 1 Capacity","SPN_Description":"Original or rated total reserve capacity of the first battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).","bit_length":16,"scaling":1,"offset":0,"unit":"Ah","SLOT_ID":351},"7905":{"PGN":64521,"PGN_Name":"Vehicle Electrical Power 8","PGN_Description":"VEP8","first_bit":32,"SPN":7905,"SPN_Name":"SLI Battery Pack 1 Battery 1 Health","SPN_Description":"Capacity of the first battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7906":{"PGN":64521,"PGN_Name":"Vehicle Electrical Power 8","PGN_Description":"VEP8","first_bit":40,"SPN":7906,"SPN_Name":"SLI Battery Pack 1 Battery 1 Predicted Minimum Cranking Voltage","SPN_Description":"Prediction of the minimum battery voltage of the first battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.2,"offset":0,"unit":"V","SLOT_ID":409},"7907":{"PGN":64521,"PGN_Name":"Vehicle Electrical Power 8","PGN_Description":"VEP8","first_bit":48,"SPN":7907,"SPN_Name":"SLI Battery Pack 1 Sensor 1 Initialization Status","SPN_Description":"The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor\'s progress through the initialization process.\\r\\n\\r\\n0:                          Initialization process has not started. \\r\\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \\r\\n10:                        Initialization process is complete. \\r\\n  \\r\\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor\'s initialization process may be restarted once the sensor is reconnected to the battery. \\r\\n\\r\\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\\r\\n  \\r\\nNote:  SPNs SPNs 7903, 7905, or 7906 may be equal to 0xFB while this parameter is less than 10.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7908":{"PGN":64520,"PGN_Name":"Vehicle Electrical Power 9","PGN_Description":"VEP9","first_bit":0,"SPN":7908,"SPN_Name":"SLI Battery Pack 1 Battery 2 Net Current","SPN_Description":"Net flow of electrical current into/out of the second battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"7909":{"PGN":64520,"PGN_Name":"Vehicle Electrical Power 9","PGN_Description":"VEP9","first_bit":16,"SPN":7909,"SPN_Name":"SLI Battery Pack 1 Battery 2 Temperature","SPN_Description":"Temperature of the second battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7910":{"PGN":64520,"PGN_Name":"Vehicle Electrical Power 9","PGN_Description":"VEP9","first_bit":24,"SPN":7910,"SPN_Name":"SLI Battery Pack 1 Battery 2 Voltage","SPN_Description":"Voltage of the second battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"7911":{"PGN":64519,"PGN_Name":"Vehicle Electrical Power 10","PGN_Description":"VEP10","first_bit":0,"SPN":7911,"SPN_Name":"SLI Battery Pack 1 Battery 2 State of Charge","SPN_Description":"Indicates the remaining charge of the second battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery\'s current state of health.\\r\\n\\n\\nParameter Specific Indicator:\\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7912":{"PGN":64519,"PGN_Name":"Vehicle Electrical Power 10","PGN_Description":"VEP10","first_bit":16,"SPN":7912,"SPN_Name":"SLI Battery Pack 1 Battery 2 Capacity","SPN_Description":"Original or rated total reserve capacity of the second battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).","bit_length":16,"scaling":1,"offset":0,"unit":"Ah","SLOT_ID":351},"7913":{"PGN":64519,"PGN_Name":"Vehicle Electrical Power 10","PGN_Description":"VEP10","first_bit":32,"SPN":7913,"SPN_Name":"SLI Battery Pack 1 Battery 2 Health","SPN_Description":"Capacity of the second battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7914":{"PGN":64519,"PGN_Name":"Vehicle Electrical Power 10","PGN_Description":"VEP10","first_bit":40,"SPN":7914,"SPN_Name":"SLI Battery Pack 1 Battery 2 Predicted Minimum Cranking Voltage","SPN_Description":"Prediction of the minimum battery voltage of the second battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.2,"offset":0,"unit":"V","SLOT_ID":409},"7915":{"PGN":64519,"PGN_Name":"Vehicle Electrical Power 10","PGN_Description":"VEP10","first_bit":48,"SPN":7915,"SPN_Name":"SLI Battery Pack 1 Sensor 2 Initialization Status","SPN_Description":"The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor\'s progress through the initialization process.\\r\\n\\r\\n0:                          Initialization process has not started. \\r\\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \\r\\n10:                        Initialization process is complete. \\r\\n  \\r\\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor\'s initialization process may be restarted once the sensor is reconnected to the battery. \\r\\n\\r\\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\\r\\n  \\r\\nNote:  SPNs 7911, 7913, or 7914 may be equal to 0xFB while this parameter is less than 10.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7916":{"PGN":64518,"PGN_Name":"Vehicle Electrical Power 11","PGN_Description":"VEP11","first_bit":0,"SPN":7916,"SPN_Name":"SLI Battery Pack 1 Battery 3 Net Current","SPN_Description":"Net flow of electrical current into/out of the third battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"7917":{"PGN":64518,"PGN_Name":"Vehicle Electrical Power 11","PGN_Description":"VEP11","first_bit":16,"SPN":7917,"SPN_Name":"SLI Battery Pack 1 Battery 3 Temperature","SPN_Description":"Temperature of the third battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7918":{"PGN":64518,"PGN_Name":"Vehicle Electrical Power 11","PGN_Description":"VEP11","first_bit":24,"SPN":7918,"SPN_Name":"SLI Battery Pack 1 Battery 3 Voltage","SPN_Description":"Voltage of the third battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"7919":{"PGN":64517,"PGN_Name":"Vehicle Electrical Power 12","PGN_Description":"VEP12","first_bit":0,"SPN":7919,"SPN_Name":"SLI Battery Pack 1 Battery 3 State of Charge","SPN_Description":"Indicates the remaining charge of the third battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery\'s current state of health.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7920":{"PGN":64517,"PGN_Name":"Vehicle Electrical Power 12","PGN_Description":"VEP12","first_bit":16,"SPN":7920,"SPN_Name":"SLI Battery Pack 1 Battery 3 Capacity","SPN_Description":"Original or rated total reserve capacity of the third battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).","bit_length":16,"scaling":1,"offset":0,"unit":"Ah","SLOT_ID":351},"7921":{"PGN":64517,"PGN_Name":"Vehicle Electrical Power 12","PGN_Description":"VEP12","first_bit":32,"SPN":7921,"SPN_Name":"SLI Battery Pack 1 Battery 3 Health","SPN_Description":"Capacity of the third battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7922":{"PGN":64517,"PGN_Name":"Vehicle Electrical Power 12","PGN_Description":"VEP12","first_bit":40,"SPN":7922,"SPN_Name":"SLI Battery Pack 1 Battery 3 Predicted Minimum Cranking Voltage","SPN_Description":"Prediction of the minimum battery voltage of the third battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.2,"offset":0,"unit":"V","SLOT_ID":409},"7923":{"PGN":64517,"PGN_Name":"Vehicle Electrical Power 12","PGN_Description":"VEP12","first_bit":48,"SPN":7923,"SPN_Name":"SLI Battery Pack 1 Sensor 3 Initialization Status","SPN_Description":"The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor\'s progress through the initialization process.\\r\\n\\r\\n0:                          Initialization process has not started. \\r\\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \\r\\n10:                        Initialization process is complete. \\r\\n  \\r\\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor\'s initialization process may be restarted once the sensor is reconnected to the battery. \\r\\n\\r\\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\\r\\n  \\r\\nNote:  SPNs 7919, 7921, or 7922 may be equal to 0xFB while this parameter is less than 10.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7924":{"PGN":64516,"PGN_Name":"Vehicle Electrical Power 13","PGN_Description":"VEP13","first_bit":0,"SPN":7924,"SPN_Name":"SLI Battery Pack 1 Battery 4 Net Current","SPN_Description":"Net flow of electrical current into/out of the fourth battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). ","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"7925":{"PGN":64516,"PGN_Name":"Vehicle Electrical Power 13","PGN_Description":"VEP13","first_bit":16,"SPN":7925,"SPN_Name":"SLI Battery Pack 1 Battery 4 Temperature","SPN_Description":"Temperature of the fourth battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"7926":{"PGN":64516,"PGN_Name":"Vehicle Electrical Power 13","PGN_Description":"VEP13","first_bit":24,"SPN":7926,"SPN_Name":"SLI Battery Pack 1 Battery 4 Voltage","SPN_Description":"Voltage of the fourth battery in the first set of batteries (battery pack) used for starting the engine, for lighting, and for ignition (SLI). \\n\\nThe relation to physical location is determined by the equipment manufacturer.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"7927":{"PGN":64515,"PGN_Name":"Vehicle Electrical Power 14","PGN_Description":"VEP14","first_bit":0,"SPN":7927,"SPN_Name":"SLI Battery Pack 1 Battery 4 State of Charge","SPN_Description":"Indicates the remaining charge of the fourth battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means no charge remaining, 100% means full capacity at the battery\'s current state of health.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"7928":{"PGN":64515,"PGN_Name":"Vehicle Electrical Power 14","PGN_Description":"VEP14","first_bit":16,"SPN":7928,"SPN_Name":"SLI Battery Pack 1 Battery 4 Capacity","SPN_Description":"Original or rated total reserve capacity of the fourth battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI).","bit_length":16,"scaling":1,"offset":0,"unit":"Ah","SLOT_ID":351},"7929":{"PGN":64515,"PGN_Name":"Vehicle Electrical Power 14","PGN_Description":"VEP14","first_bit":32,"SPN":7929,"SPN_Name":"SLI Battery Pack 1 Battery 4 Health","SPN_Description":"Capacity of the fourth battery in the first battery pack relative to its original specification for the battery pack used for starting the engine, for lighting, and for ignition (SLI). 0% means battery pack is not capable of holding any charge, 100% means battery pack is capable of holding its original full capacity.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7930":{"PGN":64515,"PGN_Name":"Vehicle Electrical Power 14","PGN_Description":"VEP14","first_bit":40,"SPN":7930,"SPN_Name":"SLI Battery Pack 1 Battery 4 Predicted Minimum Cranking Voltage","SPN_Description":"Prediction of the minimum battery voltage of the fourth battery in the first battery pack used for starting the engine, for lighting, and for ignition (SLI) during a crank event, under present battery conditions.\\r\\n\\n\\nParameter Specific Indicator: \\nA value of 0xFB indicates conditions are not acceptable for a valid measurement.","bit_length":8,"scaling":0.2,"offset":0,"unit":"V","SLOT_ID":409},"7931":{"PGN":64515,"PGN_Name":"Vehicle Electrical Power 14","PGN_Description":"VEP14","first_bit":48,"SPN":7931,"SPN_Name":"SLI Battery Pack 1 Sensor 4 Initialization Status","SPN_Description":"The battery sensor may go through an initialization process when it is first connected to a battery.  This parameter reports the battery sensor\'s progress through the initialization process.\\r\\n\\r\\n0:                          Initialization process has not started. \\r\\n1 through 9:        Initialization process is in progress.  1 represents the beginning of the process and 9 represents the initialization process is almost complete.  \\r\\n10:                        Initialization process is complete. \\r\\n  \\r\\nThe initialization process is determined by the manufacturer.  This parameter is never expected to change to a lower value as long as the sensor remains connected to the battery.  If the sensor is disconnected from the battery, then the battery sensor\'s initialization process may be restarted once the sensor is reconnected to the battery. \\r\\n\\r\\nManufacturers may not support all 11 steps.  For example, one manufacturer may support 0, 1, & 10.  Another may support 0, 2, 6, 10.\\r\\n  \\r\\nNote:  SPNs 7927, 7929, or 7930 may be equal to 0xFB while this parameter is less than 10.","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7934":{"PGN":64514,"PGN_Name":"SCR System Information","PGN_Description":"SCRSI","first_bit":32,"SPN":7934,"SPN_Name":"Aftertreatment 1 SCR System Hydrocarbon","SPN_Description":"The ratio of the mass of hydrocarbon present in the aftertreatment system compared to the maximum allowable mass of hydrocarbon for the aftertreatment system. 100% represents the maximum percentage of hydrocarbon loading that can safely be handled by the aftertreatment system, but hydrocarbon loading can continue beyond 100%.","bit_length":8,"scaling":1,"offset":0,"unit":"%","SLOT_ID":46},"7938":{"PGN":64514,"PGN_Name":"SCR System Information","PGN_Description":"SCRSI","first_bit":0,"SPN":7938,"SPN_Name":"Diesel Exhaust Fluid Frozen Time","SPN_Description":"Indicates the amount of time the diesel exhaust fluid is frozen while key switch is on. This will accumulate over the life of the product, and will never be reset.\\r\\n\\r\\nThis parameter is not for engine applications that are capable of being derated.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"7939":{"PGN":61701,"PGN_Name":"Hydraulic Pressure Displacement","PGN_Description":"HPD","first_bit":0,"SPN":7939,"SPN_Name":"Hydraulic Line Pressure","SPN_Description":"The pressure of the hydraulic fluid, measured in the hydraulic line.","bit_length":16,"scaling":1,"offset":0,"unit":"kPa","SLOT_ID":377},"7940":{"PGN":61701,"PGN_Name":"Hydraulic Pressure Displacement","PGN_Description":"HPD","first_bit":16,"SPN":7940,"SPN_Name":"Mechanical Movement Angle","SPN_Description":"The angle of rotation of the mechanical component.\\r\\n\\r\\nThe increase and decrease of the value (i.e. rotation about the X-axis) is in accordance to the right-hand rule, as specified in SAE J670, with the positive X axis directed inward along the center line of the rotating shaft of the sensor.  \\r\\nThe angle value increases when the sensor shaft is rotated clockwise (as observed facing the rotating shaft toward the sensor) and the angle value decreases when the sensor shaft is rotated counterclockwise. The reported angle will wrap around if the sensor is capable of making more than a single rotation.  When rotating clockwise the angle will go from 359.99 to 0.00, and when rotating counterclockwise the angle will go from 0.00 to 359.99.\\r\\n\\r\\nThe 0 degree position is relative to the mounting of the sensor in the system and may require calibration to associate the raw angle to the specific system context.","bit_length":16,"scaling":0.0078125,"offset":0,"unit":"deg","SLOT_ID":9},"7941":{"PGN":61441,"PGN_Name":"Electronic Brake Controller 1","PGN_Description":"EBC1","first_bit":56,"SPN":7941,"SPN_Name":"Railroad Mode Switch","SPN_Description":"Switch signal which indicates the position of the Railroad mode switch.\\r\\n\\r\\n00 - Railroad mode switch passive (City/Highway mode)\\r\\n01 - Railroad mode switch active (Railroad mode)\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nNote:  This switch signal to be used to inform the ABS/ASR ECU or other ECUs that the vehicle is operating in a railroad mode vs. a normal driving mode. Railroad mode is when a vehicle (i.e. vocational truck) has deployed the railroad gear such that the vehicle can be driven on a railroad track. This switch signal may originate from an operator switch, or within the railroad operation system installed on the vehicle.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7942":{"PGN":64964,"PGN_Name":"Electronic Brake Controller 5","PGN_Description":"EBC5","first_bit":28,"SPN":7942,"SPN_Name":"Railroad Mode","SPN_Description":"Signal which indicates the current state of the Railroad Mode / Function.\\r\\n\\r\\n00 - Inactive (Driving mode: Steer Axle on ground)\\r\\n01 - Active (Railroad mode: Steer Axle lifted off ground)\\r\\n10 - Error\\r\\n11 - Not available\\r\\n\\r\\nNote: This status signal may be used to indicate which mode the ECU (e.g., ASR/ABS) is operating (railroad mode vs. a normal driving mode). Railroad mode is when a vehicle (i.e. vocational truck) has deployed the railroad gear such that the vehicle can be driven on a railroad track.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7943":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":0,"SPN":7943,"SPN_Name":"Electrified Accessory Motor Enable Command","SPN_Description":"Enable and direction command to this electrified Accessory Motor.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7944":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":2,"SPN":7944,"SPN_Name":"Electrified Accessory Motor Power Hold","SPN_Description":"Command to allow this Electrified Accessory Motor to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7945":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":8,"SPN":7945,"SPN_Name":"Electrified Accessory Motor Speed Command","SPN_Description":"Speed command to this Electrified Accessory Motor.  Note: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.\\r\\n\\r\\nIf both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7946":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":24,"SPN":7946,"SPN_Name":"Electrified Accessory Motor Percent Speed Command","SPN_Description":"Speed command to this Electrified Accessory Motor in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.\\r\\n\\r\\nIf both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7947":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":0,"SPN":7947,"SPN_Name":"Electrified Accessory Motor Enable Status","SPN_Description":"Enable and direction status of this Electrified Accessory Motor system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7948":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":2,"SPN":7948,"SPN_Name":"Electrified Accessory Motor Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of this Electrified Accessory Motor system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Electrified Accessory Motor Service Indicator (SPN 7953) and Electrified Accessory Motor Operating Status (SPN 7954) may be used to determine functional status of this Electrified Accessory motor system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7949":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":6,"SPN":7949,"SPN_Name":"Electrified Accessory Motor Controller Command Status","SPN_Description":"Indicates the source of the speed command to this Electrified Accessory Motor system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Electrified Accessory Motor Speed Command (SPN 7945) or Electrified Accessory Motor Percent Speed Command (SPN 7946).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7950":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":8,"SPN":7950,"SPN_Name":"Electrified Accessory Motor Speed","SPN_Description":"Speed of this Electrified Accessory Motor. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7951":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":24,"SPN":7951,"SPN_Name":"Electrified Accessory Motor Medium Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7952":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":40,"SPN":7952,"SPN_Name":"Electrified Accessory Motor Power","SPN_Description":"Calculated electrical power consumed by this Electrified Accessory Motor.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"7953":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":56,"SPN":7953,"SPN_Name":"Electrified Accessory Motor Service Indicator","SPN_Description":"Indicates that service is required for this Electrified Accessory Motor system or component.  An active indication may convey a need for component replacement or periodic service.  The Electrified Accessory Motor Controller Status Reason Code (SPN 7948) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7954":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":58,"SPN":7954,"SPN_Name":"Electrified Accessory Motor Operating Status","SPN_Description":"Indicates the operating status of this Electrified Accessory Motor system or component.  This parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow of the medium (e.g. coolant, oil, air, etc.) can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.\\r\\n\\r\\nThe Electrified Accessory Motor Controller Status Reason Code (SPN 7949) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7967":{"PGN":31488,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Command","PGN_Description":"EAPECPC","first_bit":0,"SPN":7967,"SPN_Name":"Power Electronics Coolant Pump Enable Command","SPN_Description":"Enable and direction command to the Power Electonics Coolant Pump.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7968":{"PGN":31488,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Command","PGN_Description":"EAPECPC","first_bit":2,"SPN":7968,"SPN_Name":"Power Electronics Coolant Pump Power Hold","SPN_Description":"Command to allow the Power Electronics Coolant Pump to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7969":{"PGN":31488,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Command","PGN_Description":"EAPECPC","first_bit":8,"SPN":7969,"SPN_Name":"Power Electronics Coolant Pump Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Pump.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7970":{"PGN":31488,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Command","PGN_Description":"EAPECPC","first_bit":24,"SPN":7970,"SPN_Name":"Power Electronics Coolant Pump Percent Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Pump in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7971":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":0,"SPN":7971,"SPN_Name":"Power Electronics Coolant Pump Enable Status","SPN_Description":"Enable and direction status of the Power Electronics Coolant Pump system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7972":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":2,"SPN":7972,"SPN_Name":"Power Electronics Coolant Pump Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Power Electronics Coolant Pump system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Pump Service Indicator (SPN 7977) and Power Electronics Coolant Pump Operating Status (SPN 7978) may be used to determine functional status of the Power Electronics Coolant Pump system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7973":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":6,"SPN":7973,"SPN_Name":"Power Electronics Coolant Pump Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Power Electronics Coolant Pump system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Power Electronics Coolant Pump Speed Command (SPN 7969) or Power Electronics Coolant Pump Percent Speed Command (SPN 7970).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7974":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":8,"SPN":7974,"SPN_Name":"Power Electronics Coolant Pump Motor Speed","SPN_Description":"Motor Speed of the Power Electronics Coolant Pump. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7975":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":24,"SPN":7975,"SPN_Name":"Power Electronics Coolant Pump Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7976":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":40,"SPN":7976,"SPN_Name":"Power Electronics Coolant Pump Power","SPN_Description":"Calculated electrical power consumed by the Power Electronics Coolant Pump.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"7977":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":56,"SPN":7977,"SPN_Name":"Power Electronics Coolant Pump Service Indicator","SPN_Description":"Indicates that service is required for the Power Electronics Coolant Pump system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Pump Controller Status Reason Code (SPN 7972) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7978":{"PGN":64511,"PGN_Name":"Electrified Accessory Power Electronics Coolant Pump Status","PGN_Description":"EAPECPS","first_bit":58,"SPN":7978,"SPN_Name":"Power Electronics Coolant Pump Operating Status","SPN_Description":"Indicates the operating status of the Power Electronics Coolant Pump system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Pump Controller Status Reason Code (SPN 7972) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7979":{"PGN":31232,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Command","PGN_Description":"EAPMCPC","first_bit":0,"SPN":7979,"SPN_Name":"Propulsion Motor Coolant Pump Enable Command","SPN_Description":"Enable and direction command to the Propulsion Motor Coolant Pump.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7980":{"PGN":31232,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Command","PGN_Description":"EAPMCPC","first_bit":2,"SPN":7980,"SPN_Name":"Propulsion Motor Coolant Pump Power Hold","SPN_Description":"Command to allow the Propulsion Motor Coolant Pump to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7981":{"PGN":31232,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Command","PGN_Description":"EAPMCPC","first_bit":8,"SPN":7981,"SPN_Name":"Propulsion Motor Coolant Pump Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Pump. \\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7982":{"PGN":31232,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Command","PGN_Description":"EAPMCPC","first_bit":24,"SPN":7982,"SPN_Name":"Propulsion Motor Coolant Pump Percent Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Pump in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7983":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":0,"SPN":7983,"SPN_Name":"Propulsion Motor Coolant Pump Enable Status","SPN_Description":"Enable and direction status of the Propulsion Motor Coolant Pump system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7984":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":2,"SPN":7984,"SPN_Name":"Propulsion Motor Coolant Pump Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Propulsion Motor Coolant Pump system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Pump Service Indicator (SPN 7989) and Propulsion Motor Coolant Pump Operating Status (SPN 7990) may be used to determine functional status of the Propulsion Motor Coolant Pump system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7985":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":6,"SPN":7985,"SPN_Name":"Propulsion Motor Coolant Pump Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Propulsion Motor Coolant Pump system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Propulsion Motor Coolant Pump Speed Command (SPN 7981) or Propulsion Motor Coolant Pump Percent Speed Command (SPN 7982).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7986":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":8,"SPN":7986,"SPN_Name":"Propulsion Motor Coolant Pump Motor Speed","SPN_Description":"Motor Speed of the Propulsion Motor Coolant Pump. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7987":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":24,"SPN":7987,"SPN_Name":"Propulsion Motor Coolant Pump Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"7988":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":40,"SPN":7988,"SPN_Name":"Propulsion Motor Coolant Pump Power","SPN_Description":"Calculated electrical power consumed by the Propulsion Motor Coolant Pump.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"7989":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":56,"SPN":7989,"SPN_Name":"Propulsion Motor Coolant Pump Service Indicator","SPN_Description":"Indicates that service is required for the Propulsion Motor Coolant Pump system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Pump Controller Status Reason Code (SPN 7984) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7990":{"PGN":64510,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Pump Status","PGN_Description":"EAPMCPS","first_bit":58,"SPN":7990,"SPN_Name":"Propulsion Motor Coolant Pump Operating Status","SPN_Description":"Indicates the operating status of the Propulsion Motor Coolant Pump system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Pump Controller Status Reason Code (SPN 7984) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7991":{"PGN":30976,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Command","PGN_Description":"EAPMOPC","first_bit":0,"SPN":7991,"SPN_Name":"Propulsion Motor Oil Pump Enable Command","SPN_Description":"Enable and direction command to the Propulsion Motor Oil Pump.\\r\\n\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7992":{"PGN":30976,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Command","PGN_Description":"EAPMOPC","first_bit":2,"SPN":7992,"SPN_Name":"Propulsion Motor Oil Pump Power Hold","SPN_Description":"Command to allow the Propulsion Motor Oil Pump to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7993":{"PGN":30976,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Command","PGN_Description":"EAPMOPC","first_bit":8,"SPN":7993,"SPN_Name":"Propulsion Motor Oil Pump Speed Command","SPN_Description":"Speed command to the Propulsion Motor Oil Pump. \\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7994":{"PGN":30976,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Command","PGN_Description":"EAPMOPC","first_bit":24,"SPN":7994,"SPN_Name":"Propulsion Motor Oil Pump Percent Speed Command","SPN_Description":"Speed command to the Propulsion Motor Oil Pump in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"7995":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":0,"SPN":7995,"SPN_Name":"Propulsion Motor Oil Pump Enable Status","SPN_Description":"Enable and direction status of the Propulsion Motor Oil Pump system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7996":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":2,"SPN":7996,"SPN_Name":"Propulsion Motor Oil Pump Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Propulsion Motor Oil Pump system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Oil Pump Service Indicator (SPN 8001) and Propulsion Motor Oil Pump Operating Status (SPN 8002) may be used to determine functional status of the Propulsion Motor Oil Pump system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"7997":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":6,"SPN":7997,"SPN_Name":"Propulsion Motor Oil Pump Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Propulsion Motor Oil Pump system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Propulsion Motor Oil Pump Speed Command (SPN 7993) or Propulsion Motor Oil Pump Percent Speed Command (SPN 7994). \\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"7998":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":8,"SPN":7998,"SPN_Name":"Propulsion Motor Oil Pump Motor Speed","SPN_Description":"Motor Speed of the Propulsion Motor Oil Pump. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"7999":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":24,"SPN":7999,"SPN_Name":"Propulsion Motor Oil Pump Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8000":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":40,"SPN":8000,"SPN_Name":"Propulsion Motor Oil Pump Power","SPN_Description":"Calculated electrical power consumed by the Propulsion Motor Oil Pump.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8001":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":56,"SPN":8001,"SPN_Name":"Propulsion Motor Oil Pump Service Indicator","SPN_Description":"Indicates that service is required for the Propulsion Motor Oil Pump system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Oil Pump Controller Status Reason Code (SPN 7996) may provide additional detail as to the nature of the system status.\\r\\n\\n\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8002":{"PGN":64509,"PGN_Name":"Electrified Accessory Propulsion Motor Oil Pump Status","PGN_Description":"EAPMOPS","first_bit":58,"SPN":8002,"SPN_Name":"Propulsion Motor Oil Pump Operating Status","SPN_Description":"Indicates the operating status of the Propulsion Motor Oil Pump system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Oil Pump Controller Status Reason Code (SPN 7996) may provide additional detail as to the nature of the system status.\\r\\n\\n\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8003":{"PGN":30720,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Command","PGN_Description":"EAPECF1C","first_bit":0,"SPN":8003,"SPN_Name":"Power Electronics Coolant Fan 1 Enable Command","SPN_Description":"Enable and direction command to the Power Electonics Coolant Fan 1.\\r\\n\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8004":{"PGN":30720,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Command","PGN_Description":"EAPECF1C","first_bit":2,"SPN":8004,"SPN_Name":"Power Electronics Coolant Fan 1 Power Hold","SPN_Description":"Command to allow the Power Electronics Coolant Fan 1 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8005":{"PGN":30720,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Command","PGN_Description":"EAPECF1C","first_bit":8,"SPN":8005,"SPN_Name":"Power Electronics Coolant Fan 1 Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Fan 1.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8006":{"PGN":30720,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Command","PGN_Description":"EAPECF1C","first_bit":24,"SPN":8006,"SPN_Name":"Power Electronics Coolant Fan 1 Percent Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Fan 1 in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"8007":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":0,"SPN":8007,"SPN_Name":"Power Electronics Coolant Fan 1 Enable Status","SPN_Description":"Enable and direction status of the Power Electronics Coolant Fan 1 system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8008":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":2,"SPN":8008,"SPN_Name":"Power Electronics Coolant Fan 1 Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Power Electronics Coolant Fan 1 system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Fan 1 Service Indicator (SPN 8013) and Power Electronics Coolant Fan 1 Operating Status (SPN 8014) may be used to determine functional status of the Power Electronics Coolant Fan 1 system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8009":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":6,"SPN":8009,"SPN_Name":"Power Electronics Coolant Fan 1 Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Power Electronics Coolant Fan 1 system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Power Electronics Coolant Fan 1 Speed Command (SPN 8005) or Power Electronics Coolant Fan 1 Percent Speed Command (SPN 8006).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8010":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":8,"SPN":8010,"SPN_Name":"Power Electronics Coolant Fan 1 Motor Speed","SPN_Description":"Motor Speed of the Power Electronics Coolant Fan 1. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8011":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":24,"SPN":8011,"SPN_Name":"Power Electronics Coolant Fan 1 Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 1.  For example, this may be the temperature of the fluid flowing through the Fan 1, or some other temperature relating to the Fan 1 or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8012":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":40,"SPN":8012,"SPN_Name":"Power Electronics Coolant Fan 1 Power","SPN_Description":"Calculated electrical power consumed by the Power Electronics Coolant Fan 1.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8013":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":56,"SPN":8013,"SPN_Name":"Power Electronics Coolant Fan 1 Service Indicator","SPN_Description":"Indicates that service is required for the Power Electronics Coolant Fan 1 system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Fan 1 Controller Status Reason Code (SPN 8008) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8014":{"PGN":64508,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 1 Status","PGN_Description":"EAPECF1S","first_bit":58,"SPN":8014,"SPN_Name":"Power Electronics Coolant Fan 1 Operating Status","SPN_Description":"Indicates the operating status of the Power Electronics Coolant Fan 1 system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Fan 1 Controller Status Reason Code (SPN 8008) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8015":{"PGN":30464,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Command","PGN_Description":"EAPECF2C","first_bit":0,"SPN":8015,"SPN_Name":"Power Electronics Coolant Fan 2 Enable Command","SPN_Description":"Enable and direction command to the Power Electonics Coolant Fan 2.\\r\\n\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8016":{"PGN":30464,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Command","PGN_Description":"EAPECF2C","first_bit":2,"SPN":8016,"SPN_Name":"Power Electronics Coolant Fan 2 Power Hold","SPN_Description":"Command to allow the Power Electronics Coolant Fan 2 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8017":{"PGN":30464,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Command","PGN_Description":"EAPECF2C","first_bit":8,"SPN":8017,"SPN_Name":"Power Electronics Coolant Fan 2 Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Fan 2.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8018":{"PGN":30464,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Command","PGN_Description":"EAPECF2C","first_bit":24,"SPN":8018,"SPN_Name":"Power Electronics Coolant Fan 2 Percent Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Fan 2 in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"8019":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":0,"SPN":8019,"SPN_Name":"Power Electronics Coolant Fan 2 Enable Status","SPN_Description":"Enable and direction status of the Power Electronics Coolant Fan 2 system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8020":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":2,"SPN":8020,"SPN_Name":"Power Electronics Coolant Fan 2 Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Power Electronics Coolant Fan 2 system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Fan 2 Service Indicator (SPN 8025) and Power Electronics Coolant Fan 2 Operating Status (SPN 8026) may be used to determine functional status of the Power Electronics Coolant Fan 2 system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8021":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":6,"SPN":8021,"SPN_Name":"Power Electronics Coolant Fan 2 Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Power Electronics Coolant Fan 2 system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Power Electronics Coolant Fan 2 Speed Command (SPN 8017) or Power Electronics Coolant Fan 2 Percent Speed Command (SPN 8018).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8022":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":8,"SPN":8022,"SPN_Name":"Power Electronics Coolant Fan 2 Motor Speed","SPN_Description":"Motor Speed of the Power Electronics Coolant Fan 2. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8023":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":24,"SPN":8023,"SPN_Name":"Power Electronics Coolant Fan 2 Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 2.  For example, this may be the temperature of the fluid flowing through the Fan 2, or some other temperature relating to the Fan 2 or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8024":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":40,"SPN":8024,"SPN_Name":"Power Electronics Coolant Fan 2 Power","SPN_Description":"Calculated electrical power consumed by the Power Electronics Coolant Fan 2.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8025":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":56,"SPN":8025,"SPN_Name":"Power Electronics Coolant Fan 2 Service Indicator","SPN_Description":"Indicates that service is required for the Power Electronics Coolant Fan 2 system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Fan 2 Controller Status Reason Code (SPN 8020) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8026":{"PGN":64507,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 2 Status","PGN_Description":"EAPECF2S","first_bit":58,"SPN":8026,"SPN_Name":"Power Electronics Coolant Fan 2 Operating Status","SPN_Description":"Indicates the operating status of the Power Electronics Coolant Fan 2 system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Fan 2 Controller Status Reason Code (SPN 8020) may provide additional detail as to the nature of the system status.\\r\\n\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8027":{"PGN":30208,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Command","PGN_Description":"EAPECF3C","first_bit":0,"SPN":8027,"SPN_Name":"Power Electronics Coolant Fan 3 Enable Command","SPN_Description":"Enable and direction command to the Power Electonics Coolant Fan 3.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8028":{"PGN":30208,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Command","PGN_Description":"EAPECF3C","first_bit":2,"SPN":8028,"SPN_Name":"Power Electronics Coolant Fan 3 Power Hold","SPN_Description":"Command to allow the Power Electronics Coolant Fan 3 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8029":{"PGN":30208,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Command","PGN_Description":"EAPECF3C","first_bit":8,"SPN":8029,"SPN_Name":"Power Electronics Coolant Fan 3 Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Fan 3.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8030":{"PGN":30208,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Command","PGN_Description":"EAPECF3C","first_bit":24,"SPN":8030,"SPN_Name":"Power Electronics Coolant Fan 3 Percent Speed Command","SPN_Description":"Speed command to the Power Electronics Coolant Fan 3 in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"8031":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":0,"SPN":8031,"SPN_Name":"Power Electronics Coolant Fan 3 Enable Status","SPN_Description":"Enable and direction status of the Power Electronics Coolant Fan 3 system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8032":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":2,"SPN":8032,"SPN_Name":"Power Electronics Coolant Fan 3 Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Power Electronics Coolant Fan 3 system or component.  If a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Power Electronics Coolant Fan 3 Service Indicator (SPN 8037) and Power Electronics Coolant Fan 3 Operating Status (SPN 8038) may be used to determine functional status of the Power Electronics Coolant Fan 3 system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8033":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":6,"SPN":8033,"SPN_Name":"Power Electronics Coolant Fan 3 Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Power Electronics Coolant Fan 3 system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Power Electronics Coolant Fan 3 Speed Command (SPN 8029) or Power Electronics Coolant Fan 3 Percent Speed Command (SPN 8030).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8034":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":8,"SPN":8034,"SPN_Name":"Power Electronics Coolant Fan 3 Motor Speed","SPN_Description":"Motor Speed of the Power Electronics Coolant Fan 3. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8035":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":24,"SPN":8035,"SPN_Name":"Power Electronics Coolant Fan 3 Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 3.  For example, this may be the temperature of the fluid flowing through the Fan 3, or some other temperature relating to the Fan 3 or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8036":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":40,"SPN":8036,"SPN_Name":"Power Electronics Coolant Fan 3 Power","SPN_Description":"Calculated electrical power consumed by the Power Electronics Coolant Fan 3.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8037":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":56,"SPN":8037,"SPN_Name":"Power Electronics Coolant Fan 3 Service Indicator","SPN_Description":"Indicates that service is required for the Power Electronics Coolant Fan 3 system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Power Electronics Coolant Fan 3 Controller Status Reason Code (SPN 8032) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8038":{"PGN":64506,"PGN_Name":"Electrified Accessory Power Electronics Coolant Fan 3 Status","PGN_Description":"EAPECF3S","first_bit":58,"SPN":8038,"SPN_Name":"Power Electronics Coolant Fan 3 Operating Status","SPN_Description":"Indicates the operating status of the Power Electronics Coolant Fan 3 system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Power Electronics Coolant Fan 3 Controller Status Reason Code (SPN 8032) may provide additional detail as to the nature of the system status.\\r\\n\\n\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8039":{"PGN":29952,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Command","PGN_Description":"EAPMCF1C","first_bit":0,"SPN":8039,"SPN_Name":"Propulsion Motor Coolant Fan 1 Enable Command","SPN_Description":"Enable and direction command to the Propulsion Motor Coolant Fan 1.\\r\\n\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8040":{"PGN":29952,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Command","PGN_Description":"EAPMCF1C","first_bit":2,"SPN":8040,"SPN_Name":"Propulsion Motor Coolant Fan 1 Power Hold","SPN_Description":"Command to allow the Propulsion Motor Coolant Fan 1 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8041":{"PGN":29952,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Command","PGN_Description":"EAPMCF1C","first_bit":8,"SPN":8041,"SPN_Name":"Propulsion Motor Coolant Fan 1 Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Fan 1.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8042":{"PGN":29952,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Command","PGN_Description":"EAPMCF1C","first_bit":24,"SPN":8042,"SPN_Name":"Propulsion Motor Coolant Fan 1 Percent Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Fan 1 in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"8043":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":0,"SPN":8043,"SPN_Name":"Propulsion Motor Coolant Fan 1 Enable Status","SPN_Description":"Enable and direction status of the Propulsion Motor Coolant Fan 1 system or component.\\r\\n\\n\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8044":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":2,"SPN":8044,"SPN_Name":"Propulsion Motor Coolant Fan 1 Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Propulsion Motor Coolant Fan 1 system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Fan 1 Service Indicator (SPN 8049) and Propulsion Motor Coolant Fan 1 Operating Status (SPN 8050) may be used to determine functional status of the Propulsion Motor Coolant Fan 1 system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8045":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":6,"SPN":8045,"SPN_Name":"Propulsion Motor Coolant Fan 1 Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Propulsion Motor Coolant Fan 1 system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Propulsion Motor Coolant Fan 1 Speed Command (SPN 8041) or Propulsion Motor Coolant Fan 1 Percent Speed Command (SPN 8042).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8046":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":8,"SPN":8046,"SPN_Name":"Propulsion Motor Coolant Fan 1 Motor Speed","SPN_Description":"Motor Speed of the Propulsion Motor Coolant Fan 1. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8047":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":24,"SPN":8047,"SPN_Name":"Propulsion Motor Coolant Fan 1 Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 1.  For example, this may be the temperature of the fluid flowing through the Fan 1, or some other temperature relating to the Fan 1 or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8048":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":40,"SPN":8048,"SPN_Name":"Propulsion Motor Coolant Fan 1 Power","SPN_Description":"Calculated electrical power consumed by the Propulsion Motor Coolant Fan 1.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8049":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":56,"SPN":8049,"SPN_Name":"Propulsion Motor Coolant Fan 1 Service Indicator","SPN_Description":"Indicates that service is required for the Propulsion Motor Coolant Fan 1 system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Fan 1 Controller Status Reason Code (SPN 8044) may provide additional detail as to the nature of the system status.\\r\\n\\n\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8050":{"PGN":64505,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 1 Status","PGN_Description":"EAPMCF1S","first_bit":58,"SPN":8050,"SPN_Name":"Propulsion Motor Coolant Fan 1 Operating Status","SPN_Description":"Indicates the operating status of the Propulsion Motor Coolant Fan 1 system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Fan 1 Controller Status Reason Code (SPN 8044) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8051":{"PGN":29696,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Command","PGN_Description":"EAPMCF2C","first_bit":0,"SPN":8051,"SPN_Name":"Propulsion Motor Coolant Fan 2 Enable Command","SPN_Description":"Enable and direction command to the Power Motor Coolant Fan 2.\\r\\n\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8052":{"PGN":29696,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Command","PGN_Description":"EAPMCF2C","first_bit":2,"SPN":8052,"SPN_Name":"Propulsion Motor Coolant Fan 2 Power Hold","SPN_Description":"Command to allow the Propulsion Motor Coolant Fan 2 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8053":{"PGN":29696,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Command","PGN_Description":"EAPMCF2C","first_bit":8,"SPN":8053,"SPN_Name":"Propulsion Motor Coolant Fan 2 Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Fan 2.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8054":{"PGN":29696,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Command","PGN_Description":"EAPMCF2C","first_bit":24,"SPN":8054,"SPN_Name":"Propulsion Motor Coolant Fan 2 Percent Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Fan 2 in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"8055":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":0,"SPN":8055,"SPN_Name":"Propulsion Motor Coolant Fan 2 Enable Status","SPN_Description":"Enable and direction status of the Propulsion Motor Coolant Fan 2 system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8056":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":2,"SPN":8056,"SPN_Name":"Propulsion Motor Coolant Fan 2 Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Propulsion Motor Coolant Fan 2 system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Fan 2 Service Indicator (SPN 8061) and Propulsion Motor Coolant Fan 2 Operating Status (SPN 8062) may be used to determine functional status of the Propulsion Motor Coolant Fan 2 system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8057":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":6,"SPN":8057,"SPN_Name":"Propulsion Motor Coolant Fan 2 Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Propulsion Motor Coolant Fan 2 system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Propulsion Motor Coolant Fan 2 Speed Command (SPN 8053) or Propulsion Motor Coolant Fan 2 Percent Speed Command (SPN 8054).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8058":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":8,"SPN":8058,"SPN_Name":"Propulsion Motor Coolant Fan 2 Motor Speed","SPN_Description":"Motor Speed of the Propulsion Motor Coolant Fan 2. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8059":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":24,"SPN":8059,"SPN_Name":"Propulsion Motor Coolant Fan 2 Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 2.  For example, this may be the temperature of the fluid flowing through the Fan 2, or some other temperature relating to the Fan 2 or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8060":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":40,"SPN":8060,"SPN_Name":"Propulsion Motor Coolant Fan 2 Power","SPN_Description":"Calculated electrical power consumed by the Propulsion Motor Coolant Fan 2.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8061":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":56,"SPN":8061,"SPN_Name":"Propulsion Motor Coolant Fan 2 Service Indicator","SPN_Description":"Indicates that service is required for the Propulsion Motor Coolant Fan 2 system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Fan 2 Controller Status Reason Code (SPN 8056) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8062":{"PGN":64504,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 2 Status","PGN_Description":"EAPMCF2S","first_bit":58,"SPN":8062,"SPN_Name":"Propulsion Motor Coolant Fan 2 Operating Status","SPN_Description":"Indicates the operating status of the Propulsion Motor Coolant Fan 2 system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Fan 2 Controller Status Reason Code (SPN 8056) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8063":{"PGN":29440,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Command","PGN_Description":"EAPMCF3C","first_bit":0,"SPN":8063,"SPN_Name":"Propulsion Motor Coolant Fan 3 Enable Command","SPN_Description":"Enable and direction command to the Power Motor Coolant Fan 3.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On Normal/Default Direction\\r\\n10 - Accessory Motor On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8064":{"PGN":29440,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Command","PGN_Description":"EAPMCF3C","first_bit":2,"SPN":8064,"SPN_Name":"Propulsion Motor Coolant Fan 3 Power Hold","SPN_Description":"Command to allow the Propulsion Motor Coolant Fan 3 to remain alive independently of the electrical enable input to the Accessory Motor.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8065":{"PGN":29440,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Command","PGN_Description":"EAPMCF3C","first_bit":8,"SPN":8065,"SPN_Name":"Propulsion Motor Coolant Fan 3 Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Fan 3.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8066":{"PGN":29440,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Command","PGN_Description":"EAPMCF3C","first_bit":24,"SPN":8066,"SPN_Name":"Propulsion Motor Coolant Fan 3 Percent Speed Command","SPN_Description":"Speed command to the Propulsion Motor Coolant Fan 3 in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.5,"offset":0,"unit":"%","SLOT_ID":299},"8067":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":0,"SPN":8067,"SPN_Name":"Propulsion Motor Coolant Fan 3 Enable Status","SPN_Description":"Enable and direction status of the Propulsion Motor Coolant Fan 3 system or component.\\r\\n\\r\\n00 - Accessory Motor Off\\r\\n01 - Accessory Motor On - Normal, Forward, or Default Direction\\r\\n10 - Accessory Motor On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8068":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":2,"SPN":8068,"SPN_Name":"Propulsion Motor Coolant Fan 3 Controller Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of the Propulsion Motor Coolant Fan 3 system or component.\\r\\n\\r\\nIf a detailed reason code is not used by the supporting application, or this reason code is Not Available, the Propulsion Motor Coolant Fan 3 Service Indicator (SPN 8073) and Propulsion Motor Coolant Fan 3 Operating Status (SPN 8074) may be used to determine functional status of the Propulsion Motor Coolant Fan 3 system or component.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Speed limited due to torque limit\\r\\n1000 - Speed limited due to over-temperature protection\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8069":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":6,"SPN":8069,"SPN_Name":"Propulsion Motor Coolant Fan 3 Controller Command Status","SPN_Description":"Indicates the source of the speed command to the Propulsion Motor Coolant Fan 3 system or component.\\r\\n\\r\\n00b is communicated when the controller is self-controlled  (e.g. based on a temperature sensor).\\r\\n01b is communicated when responding to the Propulsion Motor Coolant Fan 3 Speed Command (SPN 8065) or Propulsion Motor Coolant Fan 3 Percent Speed Command (SPN 8066).\\r\\n10b is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8070":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":8,"SPN":8070,"SPN_Name":"Propulsion Motor Coolant Fan 3 Motor Speed","SPN_Description":"Motor Speed of the Propulsion Motor Coolant Fan 3. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8071":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":24,"SPN":8071,"SPN_Name":"Propulsion Motor Coolant Fan 3 Control Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (by another controller) control of the Fan 3.  For example, this may be the temperature of the fluid flowing through the Fan 3, or some other temperature relating to the Fan 3 or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8072":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":40,"SPN":8072,"SPN_Name":"Propulsion Motor Coolant Fan 3 Power","SPN_Description":"Calculated electrical power consumed by the Propulsion Motor Coolant Fan 3.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8073":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":56,"SPN":8073,"SPN_Name":"Propulsion Motor Coolant Fan 3 Service Indicator","SPN_Description":"Indicates that service is required for the Propulsion Motor Coolant Fan 3 system or component.\\r\\n\\r\\nAn active indication may convey a need for component replacement or periodic service.  The Propulsion Motor Coolant Fan 3 Controller Status Reason Code (SPN 8068) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8074":{"PGN":64503,"PGN_Name":"Electrified Accessory Propulsion Motor Coolant Fan 3 Status","PGN_Description":"EAPMCF3S","first_bit":58,"SPN":8074,"SPN_Name":"Propulsion Motor Coolant Fan 3 Operating Status","SPN_Description":"Indicates the operating status of the Propulsion Motor Coolant Fan 3 system or component.\\r\\n\\r\\nThis parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow, of the coolant can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.  The Propulsion Motor Coolant Fan 3 Controller Status Reason Code (SPN 8068) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8075":{"PGN":61586,"PGN_Name":"High Voltage Energy Storage 1 Data 3","PGN_Description":"HVES1D3","first_bit":0,"SPN":8075,"SPN_Name":"HVES1 Highest Cell Temperature","SPN_Description":"The highest temperature level reported by any cell in the High Voltage Energy Storage 1 pack (or system).  If a single temperature sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured.   See HVES1 Highest Cell Temperature Module Number (SPN 8241) and HVES1 Highest Cell Temperature Cell Number (SPN 8242) for cell location information.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8076":{"PGN":61586,"PGN_Name":"High Voltage Energy Storage 1 Data 3","PGN_Description":"HVES1D3","first_bit":16,"SPN":8076,"SPN_Name":"HVES1 Lowest Cell Temperature ","SPN_Description":"The lowest temperature level reported by any cell in the High Voltage Energy Storage 1 pack (or system).  If a single temperature sensor covers more than one cell, the value in this parameter is for the smallest group of cells measured.  See HVES1 Lowest Cell Temperature Module Number (SPN 8243) and HVES1 Lowest Cell Temperature Cell Number (SPN 8244) for cell location information.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8077":{"PGN":61586,"PGN_Name":"High Voltage Energy Storage 1 Data 3","PGN_Description":"HVES1D3","first_bit":32,"SPN":8077,"SPN_Name":"HVES1 Average Cell Temperature","SPN_Description":"The average temperature level of all cells in the High Voltage Energy Storage 1 pack (or system).","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8078":{"PGN":61586,"PGN_Name":"High Voltage Energy Storage 1 Data 3","PGN_Description":"HVES1D3","first_bit":48,"SPN":8078,"SPN_Name":"HVES1 Cell Temperature Differential Status","SPN_Description":"Indicates whether or not the differential between the highest and lowest cell temperatures are within acceptable limits per the High Voltage Energy Storage 1 pack (or system).   The actual temperature differential can be calculated by subtracting SPN 8076 (HVES1 Lowest Cell Temperature) from SPN 8075 (HVES1 Highest Cell Temperature).\\r\\n\\r\\n00 = Cell-to-cell temperature differential is within acceptable limits\\r\\n01 = Cell-to-cell temperature differential exceeds acceptable limits\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8079":{"PGN":61587,"PGN_Name":"High Voltage Energy Storage 1 Data 4","PGN_Description":"HVES1D4","first_bit":0,"SPN":8079,"SPN_Name":"HVES1 Discharge Capacity","SPN_Description":"The amount of stored electrical charge in the High Voltage Energy Storage 1 pack (or system) that is available for use by the hybrid system, i.e. \u201Chow full is the tank\u201D.  See HVES1 Discharge Energy Capacity (SPN 8205) for kilowatt-hours (kWh).","bit_length":16,"scaling":0.01,"offset":0,"unit":"Ah","SLOT_ID":342},"8080":{"PGN":61587,"PGN_Name":"High Voltage Energy Storage 1 Data 4","PGN_Description":"HVES1D4","first_bit":16,"SPN":8080,"SPN_Name":"HVES1 Charge Capacity","SPN_Description":"The amount of unused electrical charge storage in the High Voltage Energy Storage 1 pack (or system) that is available to be filled by charging, i.e. \u201Chow much empty space is remaining in the tank\u201D.  See HVES1 Charge Energy Capacity (SPN 8206) for kilowatt-hours (kWh).","bit_length":16,"scaling":0.01,"offset":0,"unit":"Ah","SLOT_ID":342},"8081":{"PGN":61587,"PGN_Name":"High Voltage Energy Storage 1 Data 4","PGN_Description":"HVES1D4","first_bit":32,"SPN":8081,"SPN_Name":"HVES1 Cell Balancing Count","SPN_Description":"The number of cells that are currently being balanced in the High Voltage Energy Storage 1 pack (or system).","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"8082":{"PGN":61588,"PGN_Name":"High Voltage Energy Storage 1 Data 5","PGN_Description":"HVES1D5","first_bit":0,"SPN":8082,"SPN_Name":"HVES1 Discharge Current Limit","SPN_Description":"The maximum permissible current flow out of the High Voltage Energy Storage 1 pack (or system).  This parameter is defined from the high voltage energy storage system\'s point of view.\\r\\n\\r\\nA negative value represents current flowing out of the energy storage system (discharging the system); as such, the current limit value must be between -1600 and 0 Volts.","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"8083":{"PGN":61588,"PGN_Name":"High Voltage Energy Storage 1 Data 5","PGN_Description":"HVES1D5","first_bit":16,"SPN":8083,"SPN_Name":"HVES1 Charge Current Limit","SPN_Description":"The maximum permissible current flow into the High Voltage Energy Storage 1 pack (or system).  This parameter is defined from the high voltage energy storage system\'s point of view.\\r\\n\\r\\nA positive value represents current flowing into the energy storage system (charging the system); as such current limit value must be between 0 and +1612.75 Volts.","bit_length":16,"scaling":0.05,"offset":-1600,"unit":"A","SLOT_ID":104},"8084":{"PGN":61588,"PGN_Name":"High Voltage Energy Storage 1 Data 5","PGN_Description":"HVES1D5","first_bit":32,"SPN":8084,"SPN_Name":"HVES1 Minimum Cell State of Charge","SPN_Description":"Indicates the state of charge of the lowest-charged cell in the High Voltage Energy Storage 1 pack (or system).  0% means no charge remaining, 100% means the cell is fully charged.   If a single state of charge value covers more than one cell, the value in this parameter is for the smallest group of cells measured.   See HVES1 Lowest Cell State of Charge Module Number (SPN 8247) and HVES1 Lowest Cell State of Charge Cell Number (SPN 8248) for cell location information.","bit_length":16,"scaling":0.0015625,"offset":0,"unit":"%","SLOT_ID":345},"8085":{"PGN":61588,"PGN_Name":"High Voltage Energy Storage 1 Data 5","PGN_Description":"HVES1D5","first_bit":48,"SPN":8085,"SPN_Name":"HVES1 Maximum Cell State of Charge","SPN_Description":"Indicates the state of charge of the highest-charged cell in the High Voltage Energy Storage 1 pack (or system).  0% means no charge remaining, 100% means the cell is fully charged.  If a single state of charge value covers more than one cell, the value in this parameter is for the smallest group of cells measured.  See HVES1 Highest Cell State of Charge Module Number (SPN 8245) and HVES1 Highest Cell State of Charge Cell Number (SPN 8246) for cell location information.","bit_length":16,"scaling":0.0015625,"offset":0,"unit":"%","SLOT_ID":345},"8086":{"PGN":61589,"PGN_Name":"High Voltage Energy Storage 1 Data 6","PGN_Description":"HVES1D6","first_bit":0,"SPN":8086,"SPN_Name":"HVES1 Bus Voltage","SPN_Description":"The voltage level of the high voltage bus, as measured by the High Voltage Energy Storage 1 pack (or system) on the bus side (not the battery side) of its contactors.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8087":{"PGN":61589,"PGN_Name":"High Voltage Energy Storage 1 Data 6","PGN_Description":"HVES1D6","first_bit":16,"SPN":8087,"SPN_Name":"HVES1 Ignition Voltage","SPN_Description":"The voltage level at the ignition input of the High Voltage Energy Storage 1 pack (or system) controller.","bit_length":16,"scaling":0.01,"offset":0,"unit":"V","SLOT_ID":221},"8088":{"PGN":61589,"PGN_Name":"High Voltage Energy Storage 1 Data 6","PGN_Description":"HVES1D6","first_bit":32,"SPN":8088,"SPN_Name":"HVES1 Intake Coolant Temperature","SPN_Description":"The temperature of liquid coolant as it enters the High Voltage Energy Storage 1 pack (or system).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8089":{"PGN":61589,"PGN_Name":"High Voltage Energy Storage 1 Data 6","PGN_Description":"HVES1D6","first_bit":40,"SPN":8089,"SPN_Name":"HVES1 Outlet Coolant Temperature","SPN_Description":"The temperature of liquid coolant as it exits the High Voltage Energy Storage 1 pack (or system).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8090":{"PGN":61600,"PGN_Name":"High Voltage Energy Storage 1 Data 7","PGN_Description":"HVES1D7","first_bit":48,"SPN":8090,"SPN_Name":"HVES1 Maximum Charge Voltage Limit","SPN_Description":"The maximum voltage level not to be exceeded while charging the High Voltage Energy Storage 1 pack (or system).  If this parameter is not supported, the maximum charge voltage should be limited to SPN 8117 (HVES1 Recommended Maximum Operating Voltage).","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8091":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":0,"SPN":8091,"SPN_Name":"HVES1 High-Voltage Bus (Positive) Contactor State","SPN_Description":"Position of the High Voltage Energy Storage 1 pack (or system) positive side bus contactor.  When this contactor is closed, the positive side of HVES1 is connected to the positive side of the high-voltage bus.  In systems where all contactors are controlled as a single unit (i.e. all contactors can only be either all open or all closed), this parameter may be used to convey the overall contactor status.\\r\\n\\r\\n00 = Contactor Open\\r\\n01 = Contactor Closed\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8092":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":2,"SPN":8092,"SPN_Name":"HVES1 High-Voltage Bus (Negative) Contactor State","SPN_Description":"Position of the High Voltage Energy Storage 1 pack (or system) negative side bus contactor.  When this contactor is closed, the negative side of HVES1 is connected to the negative side of the high-voltage bus.  If a system controls the positive, negative, and center contactors as a single unit (i.e. all contactors can only be either all open or all closed), then SPN 8091 (HVES1 High-Voltage Bus (Positive) Contactor State) should be used to convey overall contactor status.\\r\\n\\r\\n00 = Contactor Open\\r\\n01 = Contactor Closed\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8093":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":4,"SPN":8093,"SPN_Name":"HVES1 High-Voltage Bus Disconnect Forewarning","SPN_Description":"Indicates that the High Voltage Energy Storage 1 pack (or system) is about to disconnect from the high voltage bus due to unacceptable conditions.\\r\\n\\r\\n0000 = Disconnect not pending\\r\\n0001 = Disconnect imminent due to battery pack voltage approaching minimum acceptable level\\r\\n0010 = Disconnect imminent due to battery pack voltage approaching maximum acceptable level\\r\\n0011 = Disconnect imminent due to module voltage approaching minimum acceptable level\\r\\n0100 = Disconnect imminent due to module voltage approaching maximum acceptable level\\r\\n0101 = Disconnect imminent due to cell voltage approaching minimum acceptable level\\r\\n0110 = Disconnect imminent due to cell voltage approaching maximum acceptable level\\r\\n0111 = Disconnect imminent due to battery pack current approaching maximum acceptable level\\r\\n1000 - 1100 = Reserved\\r\\n1101 = Disconnect imminent - no reason given\\r\\n1110 = Error\\r\\n1111 = Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8094":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":8,"SPN":8094,"SPN_Name":"HVES1 High-Voltage Bus Pre-Charge Relay State","SPN_Description":"Position of the high-voltage bus contactor pre-charge relay.  When this relay is closed, the High Voltage Energy Storage 1 pack (or system) is bringing the high-voltage bus up to its operating level.\\r\\n\\r\\n00 = Relay Open\\r\\n01 = Relay Closed\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8095":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":10,"SPN":8095,"SPN_Name":"HVES1 Center of Pack Contactor State","SPN_Description":"Position of the center high-voltage contactor.  When this contactor is closed, the positive half of the High Voltage Energy Storage 1 pack (or system) is connected to the negative half.  If a system controls the positive, negative, and center contactors as a single unit (i.e. all contactors can only be either all open or all closed), then SPN 8091 (HVES1 High-Voltage Bus (Positive) Contactor State) should be used.\\r\\n\\r\\n00 = Contactor Open\\r\\n01 = Contactor Closed\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8096":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":12,"SPN":8096,"SPN_Name":"HVES1 High-Voltage Bus Active Isolation Test Status","SPN_Description":"Status of the high-voltage bus electrical active isolation test as performed by the High Voltage Energy Storage 1 pack (or system).\\r\\n\\r\\n0000 = No test requested / No test in process\\r\\n0001 = Test requested but not yet in process\\r\\n0010 = Test in process\\r\\n0011 = Test complete; isolation acceptable\\r\\n0100 = Test complete; isolation marginal\\r\\n0101 = Test complete; isolation fault\\r\\n0110 - 1101 = Reserved\\r\\n1110 = Error\\r\\n1111 = Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8097":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":16,"SPN":8097,"SPN_Name":"HVES1 High-Voltage Bus Passive Isolation Test Status","SPN_Description":"Status of the high-voltage bus electrical passive isolation test as performed by the High Voltage Energy Storage 1 pack (or system).\\r\\n\\r\\n0000 = No test requested / No test in process\\r\\n0001 = Test requested but not yet in process\\r\\n0010 = Test in process\\r\\n0011 = Test complete; isolation acceptable\\r\\n0100 = Test complete; isolation marginal\\r\\n0101 = Test complete; isolation fault\\r\\n0110 - 1101 = Reserved\\r\\n1110 = Error\\r\\n1111 = Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8098":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":20,"SPN":8098,"SPN_Name":"HVES1 HVIL Status","SPN_Description":"Status of the High Voltage Interlock Loop from the viewpoint of the High Voltage Energy Storage 1 pack (or system).\\r\\n\\r\\n00 = HVIL Closed\\r\\n01 = HVIL Open\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8099":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":22,"SPN":8099,"SPN_Name":"HVES1 Inertia Switch Status","SPN_Description":"Switch indicating that an impact has been sensed by the High Voltage Energy Storage 1 pack (or system).   The impact indication may require action by another controller, or by the HVES1 control module itself.  For example, a controller may elect to take HVES1 off-line to reduce an electrocution hazard during or after a vehicle crash.\\r\\n\\r\\n00 = No impact sensed\\r\\n01 = Impact sensed\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8100":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":24,"SPN":8100,"SPN_Name":"HVES1 State of Charge Status","SPN_Description":"Status of the High Voltage Energy Storage 1 pack (or system) State of Charge (SOC).  Note:  A given HVES controller may not support all of the states.\\r\\n\\r\\n0000 = SOC level is acceptable.\\r\\n0001 = SOC is approaching its recommended lower limit\\r\\n0010 = SOC is at its recommended lower limit\\r\\n0011 = SOC is below its recommended lower limit\\r\\n0100 = SOC is approaching its recommended upper limit\\r\\n0101 = SOC is at its recommended upper limit\\r\\n0110 = SOC is above its recommended upper limit\\r\\n0111 - 1101 = Reserved\\r\\n1110 = Error\\r\\n1111 = Not  Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8101":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":28,"SPN":8101,"SPN_Name":"HVES1 Cell Balance Status","SPN_Description":"Indicates whether or not the cells in the High Voltage Energy Storage 1 pack (or system) are balanced.\\r\\n\\r\\n00 = Cells are balanced\\r\\n01 = Cells are unbalanced\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8102":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":30,"SPN":8102,"SPN_Name":"HVES1 Cell Balancing Active","SPN_Description":"Indicates whether or not the cells in the High Voltage Energy Storage 1 pack (or system) are currently being balanced.\\r\\n\\r\\n00 = Cell balancing is not active\\r\\n01 = Cell balancing is active\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8103":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":0,"SPN":8103,"SPN_Name":"HVES1 Discharge Power Limit Due to State of Charge","SPN_Description":"Indicates whether or not HVES1 discharge power is being limited due to state of charge.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8104":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":2,"SPN":8104,"SPN_Name":"HVES1 Discharge Power Limit Due to Battery Temperature","SPN_Description":"Indicates whether or not HVES1 discharge power is being limited due to battery temperature.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8105":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":4,"SPN":8105,"SPN_Name":"HVES1 Discharge Power Limit Due to Battery Diagnostic Condition","SPN_Description":"Indicates whether or not HVES1 discharge power is being limited due to a battery diagnostic condition.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8106":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":6,"SPN":8106,"SPN_Name":"HVES1 Discharge Power Limit Due to Battery or Cell Voltage","SPN_Description":"Indicates whether or not HVES1 discharge power is being limited due to a battery or cell voltage level.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8107":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":8,"SPN":8107,"SPN_Name":"HVES1 Discharge Power Limit Due to Battery Current","SPN_Description":"Indicates whether or not HVES1 discharge power is being limited due to battery current.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8108":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":10,"SPN":8108,"SPN_Name":"HVES1 Discharge Power Limit Due to an Undefined Cause","SPN_Description":"Indicates whether or not HVES1 discharge power is being limited due to an undefined cause.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8109":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":32,"SPN":8109,"SPN_Name":"HVES1 Charge Power Limit Due to State of Charge","SPN_Description":"Indicates whether or not HVES1 charge power is being limited due to state of charge.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8110":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":34,"SPN":8110,"SPN_Name":"HVES1 Charge Power Limit Due to Battery Temperature","SPN_Description":"Indicates whether or not HVES1 charge power is being limited due to battery temperature.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8111":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":36,"SPN":8111,"SPN_Name":"HVES1 Charge Power Limit Due to Battery Diagnostic Condition","SPN_Description":"Indicates whether or not HVES1 charge power is being limited due to a battery diagnostic condition.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8112":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":38,"SPN":8112,"SPN_Name":"HVES1 Charge Power Limit Due to Battery or Cell Voltage","SPN_Description":"Indicates whether or not HVES1 charge power is being limited due to a battery or cell voltage level.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8113":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":40,"SPN":8113,"SPN_Name":"HVES1 Charge Power Limit Due to Battery Current","SPN_Description":"Indicates whether or not HVES1 charge power is being limited due to battery current.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8114":{"PGN":61494,"PGN_Name":"High Voltage Energy Storage 1 Status 2","PGN_Description":"HVES1S2","first_bit":42,"SPN":8114,"SPN_Name":"HVES1 Charge Power Limit Due to an Undefined Cause","SPN_Description":"Indicates whether or not HVES1 charge power is being limited due to an undefined cause.\\r\\n\\r\\n00 = No power limit for this reason\\r\\n01 = Power limited for this reason\\r\\n10 = Error\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8115":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":0,"SPN":8115,"SPN_Name":"HVES1 Nominal Voltage","SPN_Description":"Per the HVES manufacturer, this is the nominal operating voltage of the High Voltage Energy Storage 1 pack (or system), e.g. \u201C300V\u201D or \u201C600V\u201D.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8116":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":16,"SPN":8116,"SPN_Name":"HVES1 Recommended Minimum Operating Voltage","SPN_Description":"Per the HVES manufacturer, this is the minimum recommended voltage level for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may compromise HVES life.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8117":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":32,"SPN":8117,"SPN_Name":"HVES1 Recommended Maximum Operating Voltage","SPN_Description":"Per the HVES manufacturer, this is the maximum recommended voltage level for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may compromise HVES life.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8118":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":48,"SPN":8118,"SPN_Name":"HVES1 Recommended Minimum State Of Charge","SPN_Description":"Per the HVES manufacturer, this is the recommended minimum state of charge for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may compromise HVES life.","bit_length":16,"scaling":0.0015625,"offset":0,"unit":"%","SLOT_ID":345},"8119":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":64,"SPN":8119,"SPN_Name":"HVES1 Recommended Maximum State Of Charge ","SPN_Description":"Per the HVES manufacturer, this is the recommended maximum state of charge for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may compromise HVES life.","bit_length":16,"scaling":0.0015625,"offset":0,"unit":"%","SLOT_ID":345},"8120":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":80,"SPN":8120,"SPN_Name":"HVES1 Recommended Maximum Operating Temperature","SPN_Description":"Per the HVES manufacturer, this is the recommended maximum temperature for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may damage HVES hardware, or compromise HVES life.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8121":{"PGN":64606,"PGN_Name":"High Voltage Energy Storage 1 History","PGN_Description":"HVES1HIST","first_bit":0,"SPN":8121,"SPN_Name":"HVES1 State of Health","SPN_Description":"This signal represents the expected remaining \\"Life\\" of the High Voltage Energy Storage 1 pack (or system), in percent.  This value should begin at 100%, and end at 0% when \u201Cno\u201D energy is able to be put in or taken out.  \u201CNo\u201D could be absolute zero, or it could be some rated value of the pack.\\r\\n\\r\\nThe pack supplier can develop their own algorithm to calculate this parameter, but in general it is a reverse Amp Hour Counter, reflecting the expected Amp Hours of energy throughput remaining in the Hybrid Battery.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"8122":{"PGN":64606,"PGN_Name":"High Voltage Energy Storage 1 History","PGN_Description":"HVES1HIST","first_bit":8,"SPN":8122,"SPN_Name":"HVES1 Contactor Open Under Load Count","SPN_Description":"This signal represents the number of times the contactors inside the High Voltage Energy Storage 1 pack (or system) have opened while current is flowing through them.  The current level (that determines if an opening event will be counted) shall be defined by the HVES manufacturer, but in general should be a current level at which the contactor life may be reduced if repeated cycles occur.","bit_length":16,"scaling":1,"offset":0,"unit":"count","SLOT_ID":12},"8123":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":0,"SPN":8123,"SPN_Name":"HVES1 High-Voltage Bus Connect Command","SPN_Description":"Command to connect the High Voltage Energy Storage 1 pack (or system) to the high-voltage bus.  The emergency contactor closure request may be used in situations where one or more faults in the hybrid powertrain prevent normal operation, but the vehicle operator desires operation due to a perceived emergency situation.  Receivers of this command should always support state 10b (Emergency contactor closure request), even if the criteria for closing the contactor are the same as used in response to state 01b.\\r\\n\\r\\n00 = Open Contactor; Disconnect HVES from high-voltage bus\\r\\n01 = Close Contactor; Connect HVES to high-voltage bus\\r\\n10 = Emergency contactor closure request\\r\\n11 = Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8124":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":2,"SPN":8124,"SPN_Name":"HVES1 Power-Down Command","SPN_Description":"Command to shut down the High Voltage Energy Storage 1 pack (or system).  A normal power-down may involve steps that take some period of time (tests, writing of data, etc.).  However, an emergency power-down should shut down the storage system as quickly as possible, such as in the event of a vehicle accident.   Receivers of this command should always support state 10b (Execute emergency power-down), even if the actual power-down process is the same as that used during a \\"normal\\" power-down.\\r\\n\\r\\n00 = Power-down not requested\\r\\n01 = Execute normal power-down\\r\\n10 = Execute emergency power-down\\r\\n11 = Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8125":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":4,"SPN":8125,"SPN_Name":"HVES1 High-Voltage Bus Active Isolation Test Command","SPN_Description":"Command for the High Voltage Energy Storage 1 pack (or system) to perform an active electrical isolation test on the high voltage bus.\\r\\n\\r\\nAn active isolation test might use a generated signal (e.g. an injected AC signal) and then monitor changes in the measurements of the isolated circuits.\\r\\n\\r\\n00 = Active Isolation Test not requested\\r\\n01 = Active Isolation Test request\\r\\n10 = Reserved\\r\\n11 = Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8126":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":6,"SPN":8126,"SPN_Name":"HVES1 High-Voltage Bus Passive Isolation Test Command","SPN_Description":"Command for the High Voltage Energy Storage 1 pack (or system) to perform a passive electrical isolation test on the high voltage bus.\\r\\n\\r\\nA passive isolation test uses additional circuitry (e.g. a high impedance network) to monitor the delta between the high voltage connections (e.g. positive and negative buses).  \\r\\n\\r\\n00 = Passive Isolation Test not requested\\r\\n01 = Passive Isolation Test request\\r\\n10 = Reserved\\r\\n11 = Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8127":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":8,"SPN":8127,"SPN_Name":"HVES1 Cell Balancing Command","SPN_Description":"Command for the High Voltage Energy Storage 1 pack (or system) to perform cell balancing.\\r\\n\\r\\n00 = Cell Balancing not requested\\r\\n01 = Cell Balancing requested\\r\\n10 = Reserved\\r\\n11 = Don\'t care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8128":{"PGN":64502,"PGN_Name":"Vehicle Position 2","PGN_Description":"VP2","first_bit":0,"SPN":8128,"SPN_Name":"Total Number of Satellites in View","SPN_Description":"Indicates the number of satellites in view of the positioning and locating system receiver.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8129":{"PGN":64502,"PGN_Name":"Vehicle Position 2","PGN_Description":"VP2","first_bit":8,"SPN":8129,"SPN_Name":"Horizontal Dilution of Precision","SPN_Description":"Provides the dilution of precision in the horizontal (X-Y plane axis) direction as calculated by the positioning and locating system receiver. The dilution of precision factor is calculated from the observed positions of the observed satellites (at least 4 must be tracked for this data to be valid) and the measured position of the receiver. Lower values mean more accurate position data.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":31},"8130":{"PGN":64502,"PGN_Name":"Vehicle Position 2","PGN_Description":"VP2","first_bit":16,"SPN":8130,"SPN_Name":"Vertical Dilution of Precision","SPN_Description":"Provides the dilution of precision in the vertical (Z axis) direction as calculated by the positioning and locating system receiver. The dilution of precision factor is calculated from the observed positions of the observed satellites (at least 4 must be tracked for this data to be valid) and the measured position of the receiver. Lower values mean more accurate positioning information.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":31},"8131":{"PGN":64502,"PGN_Name":"Vehicle Position 2","PGN_Description":"VP2","first_bit":24,"SPN":8131,"SPN_Name":"Position Dilution of Precision","SPN_Description":"Provides the dilution of precision for the overall position (X-Y-Z coordinate system) as calculated by the positioning and locating system receiver. The dilution of precision factor is calculated from the observed satellites (at least 4 must be tracked for this data to be valid) and the measured position of the receiver. Lower values mean more accurate positioning information.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":31},"8132":{"PGN":64502,"PGN_Name":"Vehicle Position 2","PGN_Description":"VP2","first_bit":32,"SPN":8132,"SPN_Name":"Time Dilution of Precision","SPN_Description":"Provides the estimated receiver clock error as calculated by the positioning and locating system receiver from the satellites\u2019 clock data. The dilution of precision factor is calculated from the observed satellites (at least 4 must be tracked for this data to be valid). Lower values mean that the positioning and locating system\u2019s receiver will provide a more accurate position calculation.","bit_length":8,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":31},"8133":{"PGN":43264,"PGN_Name":"Forward Lane Image Command","PGN_Description":"FLIC","first_bit":8,"SPN":8133,"SPN_Name":"Current Region","SPN_Description":"Command sent to forward imager which specifies the operator\u2019s desired region to assist with object recognition.\\r\\n\\r\\nMessage shall use the 2-character string country codes in ISO 3166-1 alpha-2.\\r\\n\\r\\nTypical examples from ISO 3166-1 alpha-2 are:\\r\\n\\r\\nFrance: FR\\r\\nUnited States: US\\r\\nGermany: DE\\r\\n\\r\\nNote: \\r\\n\\r\\n2 ASCII space characters (0x2020) indicate the region is not detected/selected\\r\\n0xFFFF - Not available","bit_length":16,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":131},"8134":{"PGN":43264,"PGN_Name":"Forward Lane Image Command","PGN_Description":"FLIC","first_bit":24,"SPN":8134,"SPN_Name":"Current Sub-Region","SPN_Description":"Command sent to all Forward Imager which specifies the operator\u2019s desired sub-region to assist with object recognition.\\r\\n\\r\\nThis signal will be dependent on Current Region and shall use the 3-character string subdivision codes in ISO 3166-2 standard.\\r\\n\\r\\nTypical examples from ISO 3166-2 are:\\r\\n  CA - California\\r\\n  NY - New York\\r\\n  BY - Bavaria\\r\\n  13 - Tokyo\\r\\n\\r\\nNote: \\r\\n\\r\\n3 ASCII space characters (0x202020) indicate the sub-region is not detected/selected\\r\\n0xFFFFFF Not available","bit_length":24,"scaling":1,"offset":0,"unit":"ASCII","SLOT_ID":421},"8135":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":16,"SPN":8135,"SPN_Name":"Right Side Lane Departure Optical Warning Command","SPN_Description":"Indicates that the forward lane imaging system is commanding an optical warning for the lane departure on the right side of the vehicle.\\r\\n\\r\\nUsed for driving optical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\\r\\n\\r\\n00 - No optical warning on the right side\\r\\n01 - Active optical warning on the right side\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8136":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":18,"SPN":8136,"SPN_Name":"Left Side Lane Departure Optical Warning Command","SPN_Description":"Indicates that the forward lane imaging system is commanding an optical warning for the lane departure on the left side of the vehicle.\\r\\n\\r\\nUsed for driving optical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\\r\\n\\r\\n00 - No optical warning on the left side\\r\\n01 - Active optical warning on the left side\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8137":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":20,"SPN":8137,"SPN_Name":"Right Side Lane Departure Acoustical Warning Command","SPN_Description":"Indicates that the forward lane imaging system is commanding an acoustical warning for the lane departure on the right side of the vehicle.\\r\\n\\r\\nUsed for driving acoustical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\\r\\n\\r\\n00 - No acoustical warning on the right side\\r\\n01 - Active acoustical warning on the right side\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8138":{"PGN":61447,"PGN_Name":"Forward Lane Image 1","PGN_Description":"FLI1","first_bit":22,"SPN":8138,"SPN_Name":"Left Side Lane Departure Acoustical Warning Command","SPN_Description":"Indicates that the forward lane imaging system is commanding an acoustical warning for the lane departure on the left side of the vehicle.\\r\\n\\r\\nUsed for driving acoustical alert devices with minimal internal logic (ie. Those that do not support SPNs 1700 and 1701).\\r\\n\\r\\n00 - No acoustical warning on the left side\\r\\n01 - Active acoustical warning on the left side\\r\\n10 - Reserved\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8139":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":24,"SPN":8139,"SPN_Name":"Left Wheel Lane Departure Distance","SPN_Description":"The measured distance of departure of the left wheel on the left side of the lane, as measured from the left edge of the left tire to the right edge of the current lane\'s left marker.\\r\\n\\r\\nA distance of 0 indicates the left edge of the left tire is aligned with the right edge of the lane\'s left marker.\\r\\nPositive distance values indicate the left tire has departed the left side of the lane by the reported distance.\\r\\nNegative distance values indicate the left tire is within the lane at the reported distance from the lane\'s left edge.\\r\\nMeasured values greater than 125 cm results in value 251.\\r\\n\\r\\n251 Greater than 125 cm / Not in range\\r\\n252 Lane marker not reliable\\r\\n253 Reserved\\r\\n254 Error\\r\\n255 Not available","bit_length":8,"scaling":1,"offset":-125,"unit":"cm","SLOT_ID":420},"8140":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":32,"SPN":8140,"SPN_Name":"Right Wheel Lane Departure Distance","SPN_Description":"The measured distance of departure of the right wheel on the right side of the lane, as measured from the right edge of the right tire to the left edge of the current lane\'s right marker.\\r\\n\\r\\nA distance of 0 indicates the right edge of the right tire is aligned with the left edge of the lane\'s right marker.\\r\\nPositive distance values indicate the right tire is within the lane at the reported distance from the lane\'s right edge.\\r\\nNegative distance values indicate the right tire has departed the right side of the lane by the reported distance.\\r\\nMeasured values greater than 125 cm results in value 251.\\r\\n\\r\\n251 = not in range\\r\\n252 = not reliable\\r\\n253 = reserved / not used\\r\\n254 = error\\r\\n255 = not available or not installed","bit_length":8,"scaling":1,"offset":-125,"unit":"cm","SLOT_ID":420},"8141":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":48,"SPN":8141,"SPN_Name":"Lane Departure Warning System State","SPN_Description":"Indicates the status of Lane Departure Warning system.\\r\\n\\r\\n0000 - System is not ready (initialization not finished)\\r\\n0001 - System is temporarily not available (not all activation conditions fulfulled)\\r\\n0010 - System is deactivated by driver\\r\\n0011 - System is ready (no warnings active)\\r\\n0100 - Active warning suppressed by operator behavior (e.g. turn signal)\\r\\n0101 - System is warning lane departure\\r\\n0110 to 1101 - Reserved\\r\\n1110 - Error\\r\\n1111 - Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8142":{"PGN":65115,"PGN_Name":"Forward Lane Image 2","PGN_Description":"FLI2","first_bit":52,"SPN":8142,"SPN_Name":"Forward Lane Imager Status","SPN_Description":"Indicates the status of the Forward Looking Imager.\\r\\n\\r\\n0000 -  Imager fully operational\\r\\n0001 -  Imager warming up / initializing\\r\\n0010 -  Imager partially blocked / partially blind\\r\\n0011 -  Imager fully blocked / fully blind\\r\\n0100 -  Imager misaligned\\r\\n0101 to 1101 -  Reserved\\r\\n1110 -  Error\\r\\n1111 -  Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8143":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":56,"SPN":8143,"SPN_Name":"Right Lane Marker Type","SPN_Description":"Indicates the type of lane marker detected by the Forward Lane Imager on the right side. \\r\\n\\r\\n0000 -  Processing or not identified\\r\\n0001 -  Solid\\r\\n0010 -  Road edge\\r\\n0011 -  Dashed\\r\\n0100 -  Double lane marker\\r\\n0101 -  Raised lane marker (e.g. Bott\'s dots)\\r\\n0110 to 1101 -  Reserved\\r\\n1110 -  Error\\r\\n1111 -  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8144":{"PGN":64553,"PGN_Name":"Forward Lane Image 3","PGN_Description":"FLI3","first_bit":60,"SPN":8144,"SPN_Name":"Left Lane Marker Type","SPN_Description":"Indicates the type of lane marker detected by the Forward Lane Imager on the left side. \\r\\n\\r\\n0000 -  Processing or not identified\\r\\n0001 -  Solid\\r\\n0010 -  Road edge\\r\\n0011 -  Dashed\\r\\n0100 -  Double lane marker\\r\\n0101 -  Raised lane marker (e.g. Bott\'s dots)\\r\\n0110 to 1101 -  Reserved\\r\\n1110 -  Error\\r\\n1111 -  Not available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8145":{"PGN":64712,"PGN_Name":"Electronic Engine Controller 13","PGN_Description":"EEC13","first_bit":18,"SPN":8145,"SPN_Name":"Engine Fueling Inhibit Prevented Reason Extension","SPN_Description":"If Engine Fueling Inhibit Allowed (SPN 5795) indicates that the engine will inhibit fueling, then this parameter indicate the reason.  If more than one reason exists at the same time, then it is up to the manufacturer to decide which one\\r\\nto select.\\r\\n\\r\\nSee SPN 5866 for an earlier version of this parameter. If this parameter and SPN 5866 are not in agreement, then this parameter shall be considered the primary reason.\\r\\n\\r\\n0 \u2013 Fueling inhibit allowed (SPN 5795 = 01)\\r\\n1 \u2013 Aftertreatment regeneration is active or preparing to be active\\r\\n2 \u2013 Oil Distribution in engine is incomplete\\r\\n3 \u2013 Engine is cold\\r\\n4 \u2013 Service Override\\r\\n5 \u2013 Aftertreatment system is cold\\r\\n6 \u2013 Aftertreatment Protection\\r\\n7 \u2013 Engine load too high\\r\\n8 \u2013 Engine protection. Use other engine protection enumerations in this parameter when applicable. If the method of engine protection is not defined in other states, then use this state.\\r\\n9 \u2013 Insufficient SLI battery charge\\r\\n10 \u2013 Maximum number of engine fueling inhibit requests (SPN 5793 = 0) temporary limit exceeded. The temporary limit may be bounded by elapsed time, distance travelled, driving conditions, or something else that the manufacturer has specified.\\r\\n11 \u2013 Engine driven fan request\\r\\n12 \u2013 Low idle governor operation required\\r\\n13 \u2013 Vehicle speed is greater than zero\\r\\n14 \u2013 Service brake pedal is not depressed\\r\\n15 \u2013 Parking brake is not applied\\r\\n16 \u2013 Transmission is in Reverse\\r\\n17 \u2013 Clutch pedal is not depressed\\r\\n18 \u2013 PTO is active\\r\\r\\n19 \u2013 Stability/Slip Control event is active\\r\\r\\n20 \u2013 Stability/Slip Control system has a fault\\r\\r\\n21 \u2013 Interlock is active (e.g., door interlock, hood interlock, etc.)\\r\\r\\n22 to 62 \u2013 SAE Reserved\\r\\n63 \u2013 Not Supported","bit_length":6,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":91},"8146":{"PGN":64716,"PGN_Name":"Electronic Engine Controller 12","PGN_Description":"EEC12","first_bit":8,"SPN":8146,"SPN_Name":"Aftertreatment 1 Intake 2 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 1 Intake 2 Gas Sensor driver output is being driven.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the Aftertreatment 1 Intake 2 Gas Sensor\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8147":{"PGN":64716,"PGN_Name":"Electronic Engine Controller 12","PGN_Description":"EEC12","first_bit":10,"SPN":8147,"SPN_Name":"Aftertreatment 1 Outlet 2 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 1 Outlet 2 Gas Sensor driver output is being driven.\\r\\n\\r\\n00 - Off\\r\\n01 - On: The ECU is powering the Aftertreatment 1 Outlet 2 Gas Sensor\\r\\n10 - Error\\r\\n11 - Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8148":{"PGN":34048,"PGN_Name":"Cab Message 2","PGN_Description":"CM2","first_bit":50,"SPN":8148,"SPN_Name":"Aftertreatment System Enable Command","SPN_Description":"Request to enable Aftertreatment system.\\r\\n\\r\\n00 = De-activate Aftertreatment System\\r\\n01 = Activate Aftertreatment System\\r\\n10 = Reserved\\r\\n11 = Don\'t care/Take no Action\\r\\n\\r\\nNote: In some marine applications it may be desireable to enable or disable the aftretreatment system.  SPN 7851  indicates the status of the aftertreatment system.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8149":{"PGN":33024,"PGN_Name":"Aftertreatment System Control","PGN_Description":"AFTSC","first_bit":10,"SPN":8149,"SPN_Name":"Aftertreatment Diesel Exhaust Fluid Doser Ready Status","SPN_Description":"Indicates the aftertreatment systems operating conditions are appropriate for dosing.\\r\\n\\r\\nNote: Operating conditions may include but not limited to Diesel Exhaust Fluid tank level and Diesel Exhaust Fluid tank temperature are within the operating threshold.\\r\\n\\r\\n00 = Aftertreatment Not Ready to Dose\\r\\n01 = Aftertreatment Ready to Dose\\r\\n10 = Error\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8150":{"PGN":64963,"PGN_Name":"Electronic Engine Controller 15","PGN_Description":"EEC15","first_bit":32,"SPN":8150,"SPN_Name":"Engine Exhaust Gas Restriction Valve Control","SPN_Description":"Desired percentage of maximum Exhaust Gas Restriction opening for valve. 0% means valve is closed. 100% means maximum valve opening (full gas flow).","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"8151":{"PGN":61650,"PGN_Name":"Engine Electronic Controller 18","PGN_Description":"EEC18","first_bit":32,"SPN":8151,"SPN_Name":"Engine Exhaust Gas Restriction Valve Position","SPN_Description":"The position of the exhaust gas restriction valve expressed as a percentage of full travel. 0% means the valve is closed and no exhaust gas is flowing into the intake air stream. 100% means the valve is fully opened.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"8152":{"PGN":64590,"PGN_Name":"Aftertreatment 1 SCR Dosing System Information 3","PGN_Description":"A1SCRDSI3","first_bit":24,"SPN":8152,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser 2 Pressure","SPN_Description":"The SCR doser 2 diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 1 (exhaust bank 1). This is the gage equivalent to SPN 7459 .","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"8153":{"PGN":64589,"PGN_Name":"Aftertreatment 2 SCR Dosing System Information 3","PGN_Description":"A2SCRDSI3","first_bit":24,"SPN":8153,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Doser 2 Pressure","SPN_Description":"The SCR doser 2 diesel exhaust fluid gage pressure (measured closest to dosing valve) for aftertreatment system 2 (exhaust bank ). This is the gage equivalent to SPN 7464 .","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"8154":{"PGN":61702,"PGN_Name":"Well Stimulation Pump System 1","PGN_Description":"WSP1","first_bit":0,"SPN":8154,"SPN_Name":"Well Stimulation Pump Suction Pressure","SPN_Description":"The pressure on the suction side of the well stimulation pump.","bit_length":16,"scaling":0.1,"offset":-3212.7,"unit":"kPa","SLOT_ID":355},"8155":{"PGN":61702,"PGN_Name":"Well Stimulation Pump System 1","PGN_Description":"WSP1","first_bit":16,"SPN":8155,"SPN_Name":"Well Stimulation Pump Discharge Pressure","SPN_Description":"The pressure on the discharge side of the well stimulation pump.","bit_length":16,"scaling":5,"offset":0,"unit":"kPa","SLOT_ID":130},"8156":{"PGN":61703,"PGN_Name":"Well Stimulation Pump System 2","PGN_Description":"WSP2","first_bit":0,"SPN":8156,"SPN_Name":"Well Stimulation Pump Gear Box Oil Pressure","SPN_Description":"The oil pressure measured in the well stimulation pump gear box.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8157":{"PGN":61703,"PGN_Name":"Well Stimulation Pump System 2","PGN_Description":"WSP2","first_bit":16,"SPN":8157,"SPN_Name":"Well Stimulation Pump Gear Box Oil Temperature","SPN_Description":"Temperature of the oil in the well stimulation pump gear box.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8158":{"PGN":61703,"PGN_Name":"Well Stimulation Pump System 2","PGN_Description":"WSP2","first_bit":24,"SPN":8158,"SPN_Name":"Well Stimulation Pump Speed","SPN_Description":"The operating speed of the well stimulation pump.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"8159":{"PGN":65252,"PGN_Name":"Shutdown","PGN_Description":"SHUTDN","first_bit":62,"SPN":8159,"SPN_Name":"Engine Oil Pressure Switch","SPN_Description":"Measured engine oil pressure with respect to the pre-set threshold.\\r\\n\\r\\n00 = OK (Engine Oil Pressure Above Min Threshold)\\r\\n01 = Not OK (Engine Oil Pressure Below Min Threshold)\\r\\n10 = Error (Switch State Cannot Be Determined)\\r\\n11 = Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8160":{"PGN":64501,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 2","PGN_Description":"A1DOC2","first_bit":0,"SPN":8160,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Intake Pressure","SPN_Description":"Aftertreatment 1 Diesel Oxidation Catalyst absolute pressure measured at the DOC intake in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8161":{"PGN":64501,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 2","PGN_Description":"A1DOC2","first_bit":16,"SPN":8161,"SPN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst Outlet Pressure","SPN_Description":"Aftertreatment 1 Diesel Oxidation Catalyst absolute pressure measured at the DOC outlet in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8162":{"PGN":64501,"PGN_Name":"Aftertreatment 1 Diesel Oxidation Catalyst 2","PGN_Description":"A1DOC2","first_bit":32,"SPN":8162,"SPN_Name":"Aftertreatment 1 DOC Intake to DPF Outlet Delta Pressure","SPN_Description":"Aftertreatment 1 Diesel Oxidation Catalyst intake to Diesel Particulate Filter outlet differential pressure in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8163":{"PGN":64500,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 2","PGN_Description":"A2DOC2","first_bit":0,"SPN":8163,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Intake Pressure","SPN_Description":"Aftertreatment 2 Diesel Oxidation Catalyst absolute pressure measured at the DOC intake in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8164":{"PGN":64500,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 2","PGN_Description":"A2DOC2","first_bit":16,"SPN":8164,"SPN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst Outlet Pressure","SPN_Description":"Aftertreatment 2 Diesel Oxidation Catalyst absolute pressure measured at the DOC outlet in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8165":{"PGN":64500,"PGN_Name":"Aftertreatment 2 Diesel Oxidation Catalyst 2","PGN_Description":"A2DOC2","first_bit":32,"SPN":8165,"SPN_Name":"Aftertreatment 2 DOC Intake to DPF Outlet Delta Pressure","SPN_Description":"Aftertreatment 2 Diesel Oxidation Catalyst intake to Diesel Particulate Filter outlet differential pressure in exhaust bank 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8166":{"PGN":64499,"PGN_Name":"Cruise Control / Vehicle Speed 5","PGN_Description":"CCVS5","first_bit":0,"SPN":8166,"SPN_Name":"Directional Vehicle Speed","SPN_Description":"The velocity and direction of the vehicle. Positive values are used for forward vehicle motion, negative values for reverse vehicle motion.  This SPN is intended for control purposes where vehicle direction is required.  It is not intended to replace SPN 84.","bit_length":16,"scaling":0.0078125,"offset":-250,"unit":"km/h","SLOT_ID":72},"8167":{"PGN":64491,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 1 & 2","PGN_Description":"ODMCF1_2","first_bit":0,"SPN":8167,"SPN_Name":"Oil Debris Monitor Ferrous Bins 1 and 2 Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Ferrous bins 1 and 2. Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8168":{"PGN":64491,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 1 & 2","PGN_Description":"ODMCF1_2","first_bit":8,"SPN":8168,"SPN_Name":"Oil Debris Monitor Ferrous Bin 1 Count","SPN_Description":"Total number of particles detected in Ferrous bin 1. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8169":{"PGN":64491,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 1 & 2","PGN_Description":"ODMCF1_2","first_bit":32,"SPN":8169,"SPN_Name":"Oil Debris Monitor Ferrous Bin 2 Count","SPN_Description":"Total number of particles detected in Ferrous bin 2. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8170":{"PGN":64492,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 3 & 4","PGN_Description":"ODMCF3_4","first_bit":0,"SPN":8170,"SPN_Name":"Oil Debris Monitor Ferrous Bins 3 and 4 Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Ferrous bins 3 and 4. Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8171":{"PGN":64492,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 3 & 4","PGN_Description":"ODMCF3_4","first_bit":8,"SPN":8171,"SPN_Name":"Oil Debris Monitor Ferrous Bin 3 Count","SPN_Description":"Total number of particles detected in Ferrous bin 3. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8172":{"PGN":64492,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 3 & 4","PGN_Description":"ODMCF3_4","first_bit":32,"SPN":8172,"SPN_Name":"Oil Debris Monitor Ferrous Bin 4 Count","SPN_Description":"Total number of particles detected in Ferrous bin 4. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8173":{"PGN":64493,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 5 & 6","PGN_Description":"ODMCF5_6","first_bit":0,"SPN":8173,"SPN_Name":"Oil Debris Monitor Ferrous Bins 5 and 6 Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Ferrous bins 5 and 6. Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8174":{"PGN":64493,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 5 & 6","PGN_Description":"ODMCF5_6","first_bit":8,"SPN":8174,"SPN_Name":"Oil Debris Monitor Ferrous Bin 5 Count","SPN_Description":"Total number of particles detected in Ferrous bin 5. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8175":{"PGN":64493,"PGN_Name":"Oil Debris Monitor Counts Ferrous Bins 5 & 6","PGN_Description":"ODMCF5_6","first_bit":32,"SPN":8175,"SPN_Name":"Oil Debris Monitor Ferrous Bin 6 Count","SPN_Description":"Total number of particles detected in Ferrous bin 6. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8176":{"PGN":64494,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 1 & 2","PGN_Description":"ODMCNF1_2","first_bit":0,"SPN":8176,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bins 1 and 2 Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Non-Ferrous bins 1 and 2.  Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8177":{"PGN":64494,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 1 & 2","PGN_Description":"ODMCNF1_2","first_bit":8,"SPN":8177,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 1 Count","SPN_Description":"Total number of particles detected in Non-Ferrous bin 1. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8178":{"PGN":64494,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 1 & 2","PGN_Description":"ODMCNF1_2","first_bit":32,"SPN":8178,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 2 Count","SPN_Description":"Total number of particles detected in Non-Ferrous bin 2. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8179":{"PGN":64495,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 3 & 4","PGN_Description":"ODMCNF3_4","first_bit":0,"SPN":8179,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bins 3 and 4 Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Non-Ferrous bins 3 and 4. Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8180":{"PGN":64495,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 3 & 4","PGN_Description":"ODMCNF3_4","first_bit":8,"SPN":8180,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 3 Count","SPN_Description":"Total number of particles detected in Non-Ferrous bin 3. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8181":{"PGN":64495,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 3 & 4","PGN_Description":"ODMCNF3_4","first_bit":32,"SPN":8181,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 4 Count","SPN_Description":"Total number of particles detected in Non-Ferrous bin 4. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8182":{"PGN":64496,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 5 & 6","PGN_Description":"ODMCNF5_6","first_bit":0,"SPN":8182,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bins 5 and 6 Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being reported for Non-Ferrous bins 5 and 6. Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8183":{"PGN":64496,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 5 & 6","PGN_Description":"ODMCNF5_6","first_bit":8,"SPN":8183,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 5 Count","SPN_Description":"Total number of particles detected in Non-Ferrous bin 5. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8184":{"PGN":64496,"PGN_Name":"Oil Debris Monitor Counts Non-Ferrous Bins 5 & 6","PGN_Description":"ODMCNF5_6","first_bit":32,"SPN":8184,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 6 Count","SPN_Description":"Total number of particles detected in Non-Ferrous bin 6. Bin sizes are application specific.","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8185":{"PGN":64497,"PGN_Name":"Oil Debris Monitoring System Status","PGN_Description":"ODMSS","first_bit":0,"SPN":8185,"SPN_Name":"Oil Debris Monitor Status Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being reported. Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8186":{"PGN":64497,"PGN_Name":"Oil Debris Monitoring System Status","PGN_Description":"ODMSS","first_bit":8,"SPN":8186,"SPN_Name":"Oil Debris Monitor Total number of Sensors","SPN_Description":"Total number of Oil Debris Monitoring (ODM) sensors configured for this application.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8187":{"PGN":64497,"PGN_Name":"Oil Debris Monitoring System Status","PGN_Description":"ODMSS","first_bit":16,"SPN":8187,"SPN_Name":"Oil Debris Monitor Environment Status","SPN_Description":"Status of the electrical and mechanical environment surrounding the Oil Debris Monitor (ODM) Sensor.\\r\\n\\r\\n00 = Acceptable environment\\r\\n01 = Excessive noise in signal\\r\\n10 = Reserved\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8188":{"PGN":64497,"PGN_Name":"Oil Debris Monitoring System Status","PGN_Description":"ODMSS","first_bit":18,"SPN":8188,"SPN_Name":"Oil Debris Monitor Sensing Element Status","SPN_Description":"Status of the Oil Debris Monitor (ODM) sensing element.\\r\\n\\r\\n00 = Sensing element OK\\r\\n01 = Fault with sensing element\\r\\n10 = Reserved\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8189":{"PGN":64497,"PGN_Name":"Oil Debris Monitoring System Status","PGN_Description":"ODMSS","first_bit":20,"SPN":8189,"SPN_Name":"Oil Debris Monitor Signal Processing Electronics Status","SPN_Description":"Status of the Oil Debris Monitor (ODM) signal processing electronics.\\r\\n\\r\\n00 = Electronics functioning normally\\r\\n01 = Fault in electronics\\r\\n10 = Reserved\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8190":{"PGN":64497,"PGN_Name":"Oil Debris Monitoring System Status","PGN_Description":"ODMSS","first_bit":22,"SPN":8190,"SPN_Name":"Oil Debris Monitor Electronics Temperature Status","SPN_Description":"Temperature indicator for the Oil Debris Monitor (ODM) Electronics.\\r\\n\\r\\n00 = Acceptable temperature\\r\\n01 = Temperature is outside of limits\\r\\n10 = Reserved\\r\\n11 = Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8191":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":0,"SPN":8191,"SPN_Name":"Oil Debris Monitor Configuration Identification Number","SPN_Description":"Identification number of the Oil Debris Monitoring (ODM) sensor being configured. Identification numbers are application specific.","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8192":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":8,"SPN":8192,"SPN_Name":"Oil Debris Monitor Ferrous Bin 1 Count Command","SPN_Description":"New starting value for total count of particles detected in Ferrous bin 1.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8193":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":32,"SPN":8193,"SPN_Name":"Oil Debris Monitor Ferrous Bin 2 Count Command","SPN_Description":"New starting value for total count of particles detected in Ferrous bin 2.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8194":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":56,"SPN":8194,"SPN_Name":"Oil Debris Monitor Ferrous Bin 3 Count Command","SPN_Description":"New starting value for total count of particles detected in Ferrous bin 3.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8195":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":80,"SPN":8195,"SPN_Name":"Oil Debris Monitor Ferrous Bin 4 Count Command","SPN_Description":"New starting value for total count of particles detected in Ferrous bin 4.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8196":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":104,"SPN":8196,"SPN_Name":"Oil Debris Monitor Ferrous Bin 5 Count Command","SPN_Description":"New starting value for total count of particles detected in Ferrous bin 5.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8197":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":128,"SPN":8197,"SPN_Name":"Oil Debris Monitor Ferrous Bin 6 Count Command","SPN_Description":"New starting value for total count of particles detected in Ferrous bin 6.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8198":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":152,"SPN":8198,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 1 Count Command","SPN_Description":"New starting value for total count of particles detected in Non-Ferrous bin 1.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8199":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":176,"SPN":8199,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 2 Count Command","SPN_Description":"New starting value for total count of particles detected in Non-Ferrous bin 2.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8200":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":200,"SPN":8200,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 3 Count Command","SPN_Description":"New starting value for total count of particles detected in Non-Ferrous bin 3.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8201":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":224,"SPN":8201,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 4 Count Command","SPN_Description":"New starting value for total count of particles detected in Non-Ferrous bin 4.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8202":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":248,"SPN":8202,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 5 Count Command","SPN_Description":"New starting value for total count of particles detected in Non-Ferrous bin 5.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8203":{"PGN":29184,"PGN_Name":"Oil Debris Monitor Configuration Command","PGN_Description":"ODMCC","first_bit":272,"SPN":8203,"SPN_Name":"Oil Debris Monitor Non-Ferrous Bin 6 Count Command","SPN_Description":"New starting value for total count of particles detected in Non-Ferrous bin 6.\\r\\n\\r\\nNOTE: The value 0xFFFFFF indicates \\"Do Not Change\\" (i.e. the current count value of the Oil Debris Monitor for this bin will not be modified).","bit_length":24,"scaling":1,"offset":0,"unit":"count","SLOT_ID":422},"8204":{"PGN":61589,"PGN_Name":"High Voltage Energy Storage 1 Data 6","PGN_Description":"HVES1D6","first_bit":48,"SPN":8204,"SPN_Name":"HVES1 Electronics Temperature","SPN_Description":"The temperature of the electronics or control modules in the High Voltage Energy Storage 1 pack (or system).  If there are mulitple temperature sensors then this parameter would be set to the maximum sensor reading.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8205":{"PGN":61600,"PGN_Name":"High Voltage Energy Storage 1 Data 7","PGN_Description":"HVES1D7","first_bit":0,"SPN":8205,"SPN_Name":"HVES1 Discharge Energy Capacity","SPN_Description":"The amount of stored electrical energy in High Voltage Energy Storage 1 pack (or system) that is available for use by the hybrid system, i.e. \u201Chow full is the tank\u201D.  See HVES1 Discharge Capacity (SPN 8079) for Ampere-hours (Ah).","bit_length":24,"scaling":0.001,"offset":0,"unit":"kWh","SLOT_ID":418},"8206":{"PGN":61600,"PGN_Name":"High Voltage Energy Storage 1 Data 7","PGN_Description":"HVES1D7","first_bit":24,"SPN":8206,"SPN_Name":"HVES1 Charge Energy Capacity","SPN_Description":"The amount of unused electrical energy storage available to be filled by charging High Voltage Energy Storage 1 pack (or system), i.e. \u201Chow much empty space is remaining in the tank\u201D.  See HVES1 Charge Capacity (SPN 8080) for Ampere-hours (Ah).","bit_length":24,"scaling":0.001,"offset":0,"unit":"kWh","SLOT_ID":418},"8207":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":32,"SPN":8207,"SPN_Name":"HVES1 Internal Charger Status","SPN_Description":"Indicates that the charger in the HVES1 is on.  External chargers may use the External Energy Source Connection Status (SPN 7898) and related SPNs.\\r\\n\\r\\n00 - Charging off\\r\\n01 - Charging on\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8208":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":96,"SPN":8208,"SPN_Name":"HVES1 Recommended Minimum Operating Temperature","SPN_Description":"Per the HVES manufacturer, this is the recommended minimum temperature for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may damage HVES hardware, or compromise HVES life.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8209":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":112,"SPN":8209,"SPN_Name":"HVES1 Cell Maximum Voltage Limit","SPN_Description":"Per the HVES manufacturer, this is the maximum cell voltage for High Voltage Energy Storage 1 pack (or system) operation.  Operating above this value may damage HVES hardware, or compromise HVES life.","bit_length":8,"scaling":0.02044,"offset":0,"unit":"V","SLOT_ID":423},"8210":{"PGN":64605,"PGN_Name":"High Voltage Energy Storage 1 Configuration","PGN_Description":"HVES1CFG","first_bit":120,"SPN":8210,"SPN_Name":"HVES1 Cell Minimum Voltage Limit","SPN_Description":"Per the HVES manufacturer, this is the minimum cell voltage for High Voltage Energy Storage 1 pack (or system) operation.  Operating below this value may damage HVES hardware, or compromise HVES life.","bit_length":8,"scaling":0.02044,"offset":0,"unit":"V","SLOT_ID":423},"8211":{"PGN":64606,"PGN_Name":"High Voltage Energy Storage 1 History","PGN_Description":"HVES1HIST","first_bit":24,"SPN":8211,"SPN_Name":"HVES1 Total Energy Throughput","SPN_Description":"The total energy throughput which has flowed through High Voltage Energy Storage 1 pack (or system).  This parameter is the sum of the absolute values of the Energy into and out of HVES1.  \\n","bit_length":32,"scaling":100,"offset":0,"unit":"Watt-hour","SLOT_ID":424},"8212":{"PGN":64606,"PGN_Name":"High Voltage Energy Storage 1 History","PGN_Description":"HVES1HIST","first_bit":56,"SPN":8212,"SPN_Name":"HVES1 Total Accumulated Charge","SPN_Description":"The total accumulated amp hours which have flowed through High Voltage Energy Storage 1 pack (or system).  This parameter is the sum of the absolute values of the Ampere hours into and out of HVES1.  \\n","bit_length":32,"scaling":100,"offset":0,"unit":"Ah","SLOT_ID":343},"8213":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":10,"SPN":8213,"SPN_Name":"HVES1 Enable Internal Charger Command","SPN_Description":"When the HVES has an internal charger this parameter will enable it.   External chargers may use the External Energy Source Connection Demand (SPN 7890) and related SPNs.\\r\\n\\r\\n00 Disable charging\\r\\n01 Enable charging\\r\\n10 Reserved\\r\\n11 Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8214":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":0,"SPN":8214,"SPN_Name":"HVES1 Module 1 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 1.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8215":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":2,"SPN":8215,"SPN_Name":"HVES1 Module 2 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 2.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8216":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":4,"SPN":8216,"SPN_Name":"HVES1 Module 3 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 3.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8217":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":6,"SPN":8217,"SPN_Name":"HVES1 Module 4 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 4.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8218":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":8,"SPN":8218,"SPN_Name":"HVES1 Module 5 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 5.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8219":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":10,"SPN":8219,"SPN_Name":"HVES1 Module 6 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 6.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8220":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":12,"SPN":8220,"SPN_Name":"HVES1 Module 7 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 7.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8221":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":14,"SPN":8221,"SPN_Name":"HVES1 Module 8 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 8.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8222":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":16,"SPN":8222,"SPN_Name":"HVES1 Module 9 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 9.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8223":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":18,"SPN":8223,"SPN_Name":"HVES1 Module 10 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 10.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8224":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":20,"SPN":8224,"SPN_Name":"HVES1 Module 11 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 11.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8225":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":22,"SPN":8225,"SPN_Name":"HVES1 Module 12 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 12.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8226":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":24,"SPN":8226,"SPN_Name":"HVES1 Module 13 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 13.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8227":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":26,"SPN":8227,"SPN_Name":"HVES1 Module 14 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 14.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8228":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":28,"SPN":8228,"SPN_Name":"HVES1 Module 15 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 15.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8229":{"PGN":61704,"PGN_Name":"High Voltage Energy Storage 1 Module Status 1","PGN_Description":"HVES1MS1","first_bit":30,"SPN":8229,"SPN_Name":"HVES1 Module 16 Operational Status","SPN_Description":"Operational Status of the High Voltage Energy Storage 1 Module 16.  Not Operational is used when the module is initializing or not able to function (e.g. internal module level monitors have failed).  Operational indicates that the module is fully functional.  Error is used when the module status is not known (e.g. no communication established between HVES1 controller and the module, power lost, etc.)\\r\\n\\r\\n00 - Not Operational\\r\\n01 - Operational\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8230":{"PGN":61705,"PGN_Name":"High Voltage Energy Storage 1 Thermal Management System Status 1","PGN_Description":"HVES1TS1","first_bit":0,"SPN":8230,"SPN_Name":"HVES1 Thermal Management System SLI Input Power","SPN_Description":"In multiple HVES configurations, this is the low-voltage power consumed by the HVES1 Thermal Management System (TMS).   If there is only one HVES, or a single TMS for all HVES, then this represents the total low-voltage power consumed.  ","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8231":{"PGN":61705,"PGN_Name":"High Voltage Energy Storage 1 Thermal Management System Status 1","PGN_Description":"HVES1TS1","first_bit":16,"SPN":8231,"SPN_Name":"HVES1 Thermal Management System High-Voltage Input Power","SPN_Description":"In multiple HVES configurations, this is the high-voltage power consumed by the HVES1 Thermal Management System (TMS).   If there is only one HVES, or a single TMS for all HVES, then this represents the total high voltage power consumed.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8232":{"PGN":61705,"PGN_Name":"High Voltage Energy Storage 1 Thermal Management System Status 1","PGN_Description":"HVES1TS1","first_bit":32,"SPN":8232,"SPN_Name":"HVES1 Thermal Management System Compressor Speed","SPN_Description":"When the High Voltage Energy Storage 1 Thermal Management System is equipped with an active cooling system (e.g. air conditioner), this is the Compressor Speed.","bit_length":8,"scaling":32,"offset":0,"unit":"rpm","SLOT_ID":97},"8233":{"PGN":61705,"PGN_Name":"High Voltage Energy Storage 1 Thermal Management System Status 1","PGN_Description":"HVES1TS1","first_bit":40,"SPN":8233,"SPN_Name":"HVES1 Thermal Management System Relative Humidty","SPN_Description":"When the High Voltage Energy Storage 1 Thermal Management System is equipped with a relative humidity sensor, this is the  measured Relative Humidity.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"8234":{"PGN":61705,"PGN_Name":"High Voltage Energy Storage 1 Thermal Management System Status 1","PGN_Description":"HVES1TS1","first_bit":48,"SPN":8234,"SPN_Name":"HVES1 Thermal Management System Heater Status","SPN_Description":"This is the state of the High Voltage Energy Storage 1 heater\\r\\n\\r\\n00 - Heater Off\\r\\n01 - Heater On\\r\\n10 - Error \\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8235":{"PGN":61705,"PGN_Name":"High Voltage Energy Storage 1 Thermal Management System Status 1","PGN_Description":"HVES1TS1","first_bit":52,"SPN":8235,"SPN_Name":"HVES1 Thermal Management System Mode","SPN_Description":"Indicates the operating mode of the Thermal Management System.  The heat transfer medium may be (e.g. liquid or air).  The cooling system may be fans, liquid coolant, or a combination of mediums.  The system may include an air and/or liquid conditioning system with active Cooling, Heating, and/or Drying capabilities.  \\r\\n\\r\\n0000 = Off\\r\\n0001 = Circulating\\r\\n0010 = Cooling\\r\\n0011 = Heating\\r\\n0100 = Drying\\r\\n0101 - 1101 = Reserved\\r\\n1110 = Faulted\\r\\n1111 = Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8236":{"PGN":61706,"PGN_Name":"High Voltage Energy Storage 1 Data 8","PGN_Description":"HVES1D8","first_bit":0,"SPN":8236,"SPN_Name":"HVES1 Highest Cell Voltage Module Number ","SPN_Description":"Identifies the location of the module containing the HVES1 Highest Cell Voltage (SPN 5922).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8237":{"PGN":61706,"PGN_Name":"High Voltage Energy Storage 1 Data 8","PGN_Description":"HVES1D8","first_bit":8,"SPN":8237,"SPN_Name":"HVES1 Highest Cell Voltage Cell Number ","SPN_Description":"Identifies the location of HVES1 Highest Cell Voltage (SPN 5922) within the HVES1 Highest Cell Voltage Module Number (SPN 8236).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8238":{"PGN":61706,"PGN_Name":"High Voltage Energy Storage 1 Data 8","PGN_Description":"HVES1D8","first_bit":16,"SPN":8238,"SPN_Name":"HVES1 Lowest Cell Voltage Module Number ","SPN_Description":"Identifies the location of the module containing the HVES1 Lowest Cell Voltage (SPN 5923).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8239":{"PGN":61706,"PGN_Name":"High Voltage Energy Storage 1 Data 8","PGN_Description":"HVES1D8","first_bit":24,"SPN":8239,"SPN_Name":"HVES1 Lowest Cell Voltage Cell Number ","SPN_Description":"Identifies the location of the HVES1 Lowest Cell Voltage (SPN 5923) within the HVES1 Lowest Cell Voltage Module Number (SPN 8238).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8240":{"PGN":61706,"PGN_Name":"High Voltage Energy Storage 1 Data 8","PGN_Description":"HVES1D8","first_bit":32,"SPN":8240,"SPN_Name":"HVES1 Average Cell Voltage","SPN_Description":"The average cell voltage in the High Voltage Energy Storage 1 pack (or system).","bit_length":16,"scaling":0.001,"offset":0,"unit":"V","SLOT_ID":347},"8241":{"PGN":61707,"PGN_Name":"High Voltage Energy Storage 1 Data 9","PGN_Description":"HVES1D9","first_bit":0,"SPN":8241,"SPN_Name":"HVES1 Highest Cell Temperature Module Number ","SPN_Description":"Identifies the location of the module containing the HVES1 Highest Cell Temperature (SPN 8075).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8242":{"PGN":61707,"PGN_Name":"High Voltage Energy Storage 1 Data 9","PGN_Description":"HVES1D9","first_bit":8,"SPN":8242,"SPN_Name":"HVES1 Highest Cell Temperature Cell Number ","SPN_Description":"Identifies the location of the HVES1 Highest Cell Temperature (SPN 8075) within the HVES1 Highest Cell Temperature Module Number (SPN 8241).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8243":{"PGN":61707,"PGN_Name":"High Voltage Energy Storage 1 Data 9","PGN_Description":"HVES1D9","first_bit":16,"SPN":8243,"SPN_Name":"HVES1 Lowest Cell Temperature Module Number ","SPN_Description":"Identifies the location of the module containing the HVES1 Lowest Cell Temperature (SPN 8076).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8244":{"PGN":61707,"PGN_Name":"High Voltage Energy Storage 1 Data 9","PGN_Description":"HVES1D9","first_bit":24,"SPN":8244,"SPN_Name":"HVES1 Lowest Cell Temperature Cell Number ","SPN_Description":"Identifies the location of the HVES1 Lowest Cell Temperature (SPN 8076) within the HVES1 Lowest Cell Temperature Module Number (SPN 8243).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8245":{"PGN":61708,"PGN_Name":"High Voltage Energy Storage 1 Data 10","PGN_Description":"HVES1D10","first_bit":0,"SPN":8245,"SPN_Name":"HVES1 Highest Cell State of Charge Module Number ","SPN_Description":"Identifies the location of the module containing the HVES1 Highest Cell State of Charge (SPN 8085).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8246":{"PGN":61708,"PGN_Name":"High Voltage Energy Storage 1 Data 10","PGN_Description":"HVES1D10","first_bit":8,"SPN":8246,"SPN_Name":"HVES1 Highest Cell State of Charge Cell Number ","SPN_Description":"Identifies the location of the HVES1 Highest Cell State of Charge (SPN 8085) within the HVES1 Highest Cell State of Charge Module Number (SPN 8245).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8247":{"PGN":61708,"PGN_Name":"High Voltage Energy Storage 1 Data 10","PGN_Description":"HVES1D10","first_bit":16,"SPN":8247,"SPN_Name":"HVES1 Lowest Cell State of Charge Module Number ","SPN_Description":"Identifies the location of the module containing the HVES1 Lowest Cell State of Charge (SPN 8084).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8248":{"PGN":61708,"PGN_Name":"High Voltage Energy Storage 1 Data 10","PGN_Description":"HVES1D10","first_bit":24,"SPN":8248,"SPN_Name":"HVES1 Lowest Cell State of Charge Cell Number ","SPN_Description":"Identifies the location of the HVES1 Lowest Cell State of Charge (SPN 8084) within the HVES1 Lowest Cell State of Charge Module Number (SPN 8247).","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":129},"8267":{"PGN":64706,"PGN_Name":"Hybrid System Status 1","PGN_Description":"HSS1","first_bit":52,"SPN":8267,"SPN_Name":"Hybrid System Propulsion Disable Status","SPN_Description":"Indicates if the hybrid system is in a state where propulsion is not available. This may be due to Hybrid System Propulsion Disable Request (SPN 7558), Hybrid System Propulsion Disable Switch (SPN 7554), or Hybrid System Off-Board Charger Connection Status (SPN 7551) being active. It may also be due to other internal hybrid reasons for propulsion being disabled (e.g. charging, pre-charge not complete, warm-up modes).\\r\\n\\r\\n00 = Propulsion not disabled\\r\\n01 = Propulsion is disabled\\r\\n10 = Error\\r\\n11 = Not Available\\r\\n\\r\\nNote: Propulsion System Active (SPN 7315) should not be used as an indication of propulsion being disabled as it is required to indicate that the propulsion system is active whenever the engine is running regardless of the state of the hybrid systems ability to provide propulsion power.","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8268":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":0,"SPN":8268,"SPN_Name":"DHCP Status","SPN_Description":"DHCP Client Status. This parameter is intended to provide feedback on the status of obtaining an IP address. When no physical link is available and DHCP is enabled, an Error response is appropriate.\\r\\n\\r\\n0000 - Not Configured (static IP)\\r\\n0001 - Obtaining IP\\r\\n0010 - IP Leased\\r\\n0011 - Contacting DHCP Server\\r\\n0100 - SAE Reserved\\r\\n0101 - SAE Reserved\\r\\n0110 - SAE Reserved\\r\\n0111 - SAE Reserved\\r\\n1000 - SAE Reserved\\r\\n1001 - SAE Reserved\\r\\n1010 - SAE Reserved\\r\\n1011 - SAE Reserved\\r\\n1100 - SAE Reserved\\r\\n1101 - SAE Reserved\\r\\n1110 - Error\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8269":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":4,"SPN":8269,"SPN_Name":"Ethernet Link Status","SPN_Description":"Ethernet Link Status. When there is no physical connection, the status shall report 00. \\r\\n\\r\\n00 - Ethernet Link Down\\r\\n01 - Ethernet Link Up\\r\\n10 - Error\\r\\n11 - Not Supported","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8270":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":8,"SPN":8270,"SPN_Name":"IPv4 Address Octet 1","SPN_Description":"This value is the first of 4 octets in the ECU\'s assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8270.SPN 8271.SPN 8272.SPN 8273","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8271":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":16,"SPN":8271,"SPN_Name":"IPv4 Address Octet 2","SPN_Description":"This value is the second of 4 octets in the ECU\'s assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8270.SPN 8271.SPN 8272.SPN 8273","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8272":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":24,"SPN":8272,"SPN_Name":"IPv4 Address Octet 3","SPN_Description":"This value is the third of 4 octets in the ECU\'s assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8270.SPN 8271.SPN 8272.SPN 8273","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8273":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":32,"SPN":8273,"SPN_Name":"IPv4 Address Octet 4","SPN_Description":"This value is the fourth of 4 octets in the ECU\'s assigned Internet Protocol (IP) address. The address is separated into 4 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the IP address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8270.SPN 8271.SPN 8272.SPN 8273","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8274":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":40,"SPN":8274,"SPN_Name":"Subnet Mask Octet 1","SPN_Description":"This value is the first of 4 octets in the ECU\'s configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8274.SPN 8275.SPN 8276.SPN 8277","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8275":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":48,"SPN":8275,"SPN_Name":"Subnet Mask Octet 2","SPN_Description":"This value is the second of 4 octets in the ECU\'s configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8274.SPN 8275.SPN 8276.SPN 8277","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8276":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":56,"SPN":8276,"SPN_Name":"Subnet Mask Octet 3","SPN_Description":"This value is the third of 4 octets in the ECU\'s configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8274.SPN 8275.SPN 8276.SPN 8277","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8277":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":64,"SPN":8277,"SPN_Name":"Subnet Mask Octet 4","SPN_Description":"This value is the fourth of 4 octets in the ECU\'s configured Subnet mask. The subnet mask is separated into 4 bytes, 1 per octet of the mask. Byte 1 is the first octet of the mask. Byte 2 is the second and so forth. If the Subnet mask is not configured, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8274.SPN 8275.SPN 8276.SPN 8277","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8278":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":72,"SPN":8278,"SPN_Name":"Default Gateway Octet 1","SPN_Description":"This value is the first of 4 octets in the ECU\'s configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8278.SPN 8279.SPN 8280.SPN 8281","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8279":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":80,"SPN":8279,"SPN_Name":"Default Gateway Octet 2","SPN_Description":"This value is the second of 4 octets in the ECU\'s configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8278.SPN 8279.SPN 8280.SPN 8281","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8280":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":88,"SPN":8280,"SPN_Name":"Default Gateway Octet 3","SPN_Description":"This value is the third of 4 octets in the ECU\'s configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8278.SPN 8279.SPN 8280.SPN 8281","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8281":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":96,"SPN":8281,"SPN_Name":"Default Gateway Octet 4","SPN_Description":"This value is the fourth of 4 octets in the ECU\'s configured or assigned Default Gateway IP address.  The Default Gateway IP address is separated into 4 bytes, 1 per octet of the address Byte 1 is the first octet of the address Byte 2 is the second and so forth. If the Default Gateway IP address is not configured or assigned, the byte positions shall be filled with 0xFF.\\r\\n\\r\\nExample:\\r\\nOctet1.Octet2.Octet3.Octet4\\r\\nByte1.Byte2.Byte3.Byte4\\r\\nSPN 8278.SPN 8279.SPN 8280.SPN 8281","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8282":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":104,"SPN":8282,"SPN_Name":"MAC Address Octet 1","SPN_Description":"This value is the first of 6 octets in the ECU\'s assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\\r\\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\\r\\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8283":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":112,"SPN":8283,"SPN_Name":"MAC Address Octet 2","SPN_Description":"This value is the second of 6 octets in the ECU\'s assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\\r\\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\\r\\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8284":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":120,"SPN":8284,"SPN_Name":"MAC Address Octet 3","SPN_Description":"This value is the third of 6 octets in the ECU\'s assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\\r\\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\\r\\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8285":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":128,"SPN":8285,"SPN_Name":"MAC Address Octet 4","SPN_Description":"This value is the fourth of 6 octets in the ECU\'s assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\\r\\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\\r\\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8286":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":136,"SPN":8286,"SPN_Name":"MAC Address Octet 5","SPN_Description":"This value is the fifth of 6 octets in the ECU\'s assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\\r\\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\\r\\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8287":{"PGN":64490,"PGN_Name":"Ethernet 1 Connection Information 1","PGN_Description":"E1NET1","first_bit":144,"SPN":8287,"SPN_Name":"MAC Address Octet 6","SPN_Description":"This value is the sixth of 6 octets in the ECU\'s assigned MAC address. The address is separated into 6 bytes, 1 per octet of the address. Byte 1 is the first octet of the address. Byte 2 is the second and so forth. If the MAC address is not configured or not assigned, the byte positions shall be filled with FF.\\r\\n\\r\\nExample:\\r\\nOctet1:Octet2:Octet3:Octet4:Octet5:Octet6\\r\\nByte1:Byte2:Byte3:Byte4:Byte5:Byte6\\r\\nSPN 8282:SPN 8283:SPN 8284:SPN 8285:SPN 8286:SPN 8287","bit_length":8,"scaling":1,"offset":0,"unit":"count","SLOT_ID":133},"8291":{"PGN":65098,"PGN_Name":"Electronic Transmission Controller 7","PGN_Description":"ETC7","first_bit":54,"SPN":8291,"SPN_Name":"Transmission Manual Mode Indicator","SPN_Description":"This parameter indicates if the operator has selected a Manual Mode of the transmission. When a Manual Mode is active, the operator has directly and intentionally restricted the available transmission ranges for the given vehicle direction. A Manual Mode may require direct operator input before any shifts are initiated (e.g. \u201CUpshift\u201D or \u201CDownshift\u201D inputs), or may just prevent the transmission from achieving its maximum range in that direction (e.g. via selection of \u201CLow\u201D or another range below the maximum). When not in Manual Mode, the transmission always selects the optimum range for current operating conditions, and initiates any shifts as needed.\\r\\n\\r\\nManual Modes are typically associated with forward ranges. However, Manual Modes may also be available in applications where the transmission supports multiple reverse ranges.\\r\\n\\r\\nManual Mode should not be indicated when the transmission is in Park or Neutral, nor when another vehicle function (e.g. engine braking, adaptive cruise control) modifies the shift schedule or available transmission ranges.\\r\\n\\r\\n00 \u2013 Transmission is not in a Manual Mode\\r\\n01 \u2013 Transmission is in a Manual Mode\\r\\n10 \u2013 Reserved\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8292":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":32,"SPN":8292,"SPN_Name":"Electrified Accessory Motor Instance 1","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8293":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":33,"SPN":8293,"SPN_Name":"Electrified Accessory Motor Instance 2","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8294":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":34,"SPN":8294,"SPN_Name":"Electrified Accessory Motor Instance 3","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8295":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":35,"SPN":8295,"SPN_Name":"Electrified Accessory Motor Instance 4","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8296":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":36,"SPN":8296,"SPN_Name":"Electrified Accessory Motor Instance 5","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8297":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":37,"SPN":8297,"SPN_Name":"Electrified Accessory Motor Instance 6","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8298":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":38,"SPN":8298,"SPN_Name":"Electrified Accessory Motor Instance 7","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8299":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":39,"SPN":8299,"SPN_Name":"Electrified Accessory Motor Instance 8","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8300":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":40,"SPN":8300,"SPN_Name":"Electrified Accessory Motor Instance 9","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8301":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":41,"SPN":8301,"SPN_Name":"Electrified Accessory Motor Instance 10","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8302":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":42,"SPN":8302,"SPN_Name":"Electrified Accessory Motor Instance 11","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8303":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":43,"SPN":8303,"SPN_Name":"Electrified Accessory Motor Instance 12","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8304":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":44,"SPN":8304,"SPN_Name":"Electrified Accessory Motor Instance 13","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8305":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":45,"SPN":8305,"SPN_Name":"Electrified Accessory Motor Instance 14","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8306":{"PGN":32000,"PGN_Name":"Electrified Accessory Motor Command","PGN_Description":"EAMC","first_bit":46,"SPN":8306,"SPN_Name":"Electrified Accessory Motor Instance 15","SPN_Description":"Indicates the electrified accessory instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Accessory Motor Instance\\r\\n1 - No Command applied to this Accessory Motor Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8308":{"PGN":64513,"PGN_Name":"Electrified Accessory Motor Status","PGN_Description":"EAMS","first_bit":60,"SPN":8308,"SPN_Name":"Electrified Accessory Motor Instance","SPN_Description":"Indicates the electrified accessory instance that is providing status.\\r\\n\\r\\n0000 - Instance 1\\r\\n0001 - Instance 2\\r\\n0010 - Instance 3\\r\\n0011 - Instance 4\\r\\n0100 - Instance 5\\r\\n0101 - Instance 6\\r\\n0110 - Instance 7\\r\\n0111 - Instance 8\\r\\n1000 - Instance 9\\r\\n1001 - Instance 10\\r\\n1010 - Instance 11\\r\\n1011 - Instance 12\\r\\n1100 - Instance 13\\r\\n1101 - Instance 14\\r\\n1110 - Instance 15\\r\\n1111 - Not available / Instance not specified","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8310":{"PGN":61497,"PGN_Name":"Engine Air System Information","PGN_Description":"EASI","first_bit":32,"SPN":8310,"SPN_Name":"Engine Fuel System 2 Total Intake Mass Air Flow Rate","SPN_Description":"Mass Flow rate of air entering the second fuel system of the engine. This also includes the amount of exhaust gas recirculated, if any.","bit_length":16,"scaling":0.0009765625,"offset":0,"unit":"kg/s","SLOT_ID":372},"8312":{"PGN":61710,"PGN_Name":"Dump Truck Body Information","PGN_Description":"DTBI1","first_bit":0,"SPN":8312,"SPN_Name":"Dump Body Roll Angle","SPN_Description":"The angle between the dump body y-axis and the ground plane (i.e. rotation about the X-axis). The roll angle for a roll to the right is reported with a positive value. Roll angle is the same for both Z-Down and Z-Up axis systems, since both systems have positive X-axis directed forward. The sign of the value is in accordance to the right-hand rule, as specified in SAE J670.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"8313":{"PGN":61710,"PGN_Name":"Dump Truck Body Information","PGN_Description":"DTBI1","first_bit":16,"SPN":8313,"SPN_Name":"Dump Body Raise Angle","SPN_Description":"The angular position of the dump body referenced to the vehicle chassis. 0 degrees represents the body in its resting position.","bit_length":16,"scaling":0.0078125,"offset":-200,"unit":"deg","SLOT_ID":8},"8314":{"PGN":61710,"PGN_Name":"Dump Truck Body Information","PGN_Description":"DTBI1","first_bit":32,"SPN":8314,"SPN_Name":"Dump Body Raise Position Relative to Recommended Maximum","SPN_Description":"The angular position of the dump body expressed as a percentage of the maximum recommended body raised position. 100% represents the maximum default raised position of the dump body and is measured related to level ground.\\r\\n\\r\\nNote:  Depending on the machine orientation it may be possible to raise body above recommended maximum position, equally it may not be possible to reach maximum recommended position.","bit_length":16,"scaling":0.005,"offset":-150,"unit":"%","SLOT_ID":430},"8315":{"PGN":61710,"PGN_Name":"Dump Truck Body Information","PGN_Description":"DTBI1","first_bit":48,"SPN":8315,"SPN_Name":"Dump Body Ejector Blade Position","SPN_Description":"The dump body ejector blade is used to push material out of the dump body of a dump truck. 0% represents the fully retracted position and 100% represents the fully extended position.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"8326":{"PGN":64488,"PGN_Name":"Aftertreatment System Information 2","PGN_Description":"ASI2","first_bit":0,"SPN":8326,"SPN_Name":"Aftertreatment Total Diesel Exhaust Fluid Used","SPN_Description":"Total amount of DEF used by aftertreatment device 1 and aftertreatment device 2 over the lifetime of the system.\\r\\n\\r\\nSee SPNs 5963 and 5964 for individual device accumulation.","bit_length":32,"scaling":0.5,"offset":0,"unit":"l","SLOT_ID":75},"8327":{"PGN":64487,"PGN_Name":"SCR Operator Inducement Information 5","PGN_Description":"SCROII5","first_bit":0,"SPN":8327,"SPN_Name":"Aftertreatment 1 SCR Intake High Temperature Time","SPN_Description":"Indicates the time the aftertreatment 1 SCR intake temperature is above a manufacturer specified threshold. This is the temperature of engine combustion byproducts entering the SCR in exhaust bank 1. This will accumulate over the life of the product and will never be reset.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"8328":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":0,"SPN":8328,"SPN_Name":"API 1 Output 1 Device Maximum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output. The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8329":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":8,"SPN":8329,"SPN_Name":"API 1 Output 1 Device Minimum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8330":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":16,"SPN":8330,"SPN_Name":"API 1 Output 1 Device Rated Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8331":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":24,"SPN":8331,"SPN_Name":"API 1 Output 1 Device Rated Voltage","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8332":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":32,"SPN":8332,"SPN_Name":"API 1 Output 1 Device Frequency Rate of Change Limit","SPN_Description":"Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output.   (Note: Increasing and decreasing rates can be controlled by the same signal)  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Hz/s","SLOT_ID":426},"8333":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":40,"SPN":8333,"SPN_Name":"API 1 Output 1 Frequency Command","SPN_Description":"Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8334":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":48,"SPN":8334,"SPN_Name":"API 1 Output 1 Device 1 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8335":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":51,"SPN":8335,"SPN_Name":"API 1 Output 1 Device 2 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8336":{"PGN":61654,"PGN_Name":"API 1 Output 1 Energy Consumer Command","PGN_Description":"API1_O1_CMD","first_bit":54,"SPN":8336,"SPN_Name":"API 1 Output 1 Enable Command","SPN_Description":"Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\n00 - Turn API Output Off\\r\\n01 - Turn API Output On\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8337":{"PGN":61655,"PGN_Name":"API 1 Output 1 Energy Consumer Feedback","PGN_Description":"API1_O1_FDBK","first_bit":0,"SPN":8337,"SPN_Name":"API 1 Output 1 Frequency Feedback","SPN_Description":"Present operating frequency of this Accessory Power Inverter output.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8338":{"PGN":61655,"PGN_Name":"API 1 Output 1 Energy Consumer Feedback","PGN_Description":"API1_O1_FDBK","first_bit":8,"SPN":8338,"SPN_Name":"API 1 Output 1 Voltage Feedback","SPN_Description":"Present operating voltage of this Accessory Power Inverter output.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8339":{"PGN":61655,"PGN_Name":"API 1 Output 1 Energy Consumer Feedback","PGN_Description":"API1_O1_FDBK","first_bit":16,"SPN":8339,"SPN_Name":"API 1 Output 1 Power Feedback","SPN_Description":"Present operating power of this Accessory Power Inverter output.","bit_length":8,"scaling":0.1,"offset":0,"unit":"kW","SLOT_ID":428},"8340":{"PGN":61655,"PGN_Name":"API 1 Output 1 Energy Consumer Feedback","PGN_Description":"API1_O1_FDBK","first_bit":48,"SPN":8340,"SPN_Name":"API 1 Output 1 Status Feedback","SPN_Description":"Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\\r\\n\\r\\n000 - Output Off\\r\\n001 - Output On\\r\\n010 - Output Faulted On\\r\\n011 - Output Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8341":{"PGN":61655,"PGN_Name":"API 1 Output 1 Energy Consumer Feedback","PGN_Description":"API1_O1_FDBK","first_bit":51,"SPN":8341,"SPN_Name":"API 1 Output 1 Loadshed Request","SPN_Description":"Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\\r\\n\\r\\n00 - No Loadshed Requested\\r\\n01 - Loadshed Requested\\r\\n10 - Loadshed Requested, Shutdown Imminent\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8342":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":0,"SPN":8342,"SPN_Name":"API 1 Output 2 Device Maximum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output. The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8343":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":8,"SPN":8343,"SPN_Name":"API 1 Output 2 Device Minimum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8344":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":16,"SPN":8344,"SPN_Name":"API 1 Output 2 Device Rated Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8345":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":24,"SPN":8345,"SPN_Name":"API 1 Output 2 Device Rated Voltage","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8346":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":32,"SPN":8346,"SPN_Name":"API 1 Output 2 Device Frequency Rate of Change Limit","SPN_Description":"Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output. (Note: Increasing and decreasing rates can be controlled by the same signal).  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Hz/s","SLOT_ID":426},"8347":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":40,"SPN":8347,"SPN_Name":"API 1 Output 2 Frequency Command","SPN_Description":"Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8348":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":48,"SPN":8348,"SPN_Name":"API 1 Output 2 Device 1 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8349":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":51,"SPN":8349,"SPN_Name":"API 1 Output 2 Device 2 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8350":{"PGN":61658,"PGN_Name":"API 1 Output 2 Energy Consumer Command","PGN_Description":"API1_O2_CMD","first_bit":54,"SPN":8350,"SPN_Name":"API 1 Output 2 Enable Command","SPN_Description":"Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\n00 - Turn API Output Off\\r\\n01 - Turn API Output On\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8351":{"PGN":61659,"PGN_Name":"API 1 Output 2 Energy Consumer Feedback","PGN_Description":"API1_O2_FDBK","first_bit":0,"SPN":8351,"SPN_Name":"API 1 Output 2 Frequency Feedback","SPN_Description":"Present operating frequency of this Accessory Power Inverter output.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8352":{"PGN":61659,"PGN_Name":"API 1 Output 2 Energy Consumer Feedback","PGN_Description":"API1_O2_FDBK","first_bit":8,"SPN":8352,"SPN_Name":"API 1 Output 2 Voltage Feedback","SPN_Description":"Present operating voltage of this Accessory Power Inverter output.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8353":{"PGN":61659,"PGN_Name":"API 1 Output 2 Energy Consumer Feedback","PGN_Description":"API1_O2_FDBK","first_bit":16,"SPN":8353,"SPN_Name":"API 1 Output 2 Power Feedback","SPN_Description":"Present operating power of this Accessory Power Inverter output.","bit_length":8,"scaling":0.1,"offset":0,"unit":"kW","SLOT_ID":428},"8354":{"PGN":61659,"PGN_Name":"API 1 Output 2 Energy Consumer Feedback","PGN_Description":"API1_O2_FDBK","first_bit":48,"SPN":8354,"SPN_Name":"API 1 Output 2 Status Feedback","SPN_Description":"Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\\r\\n\\r\\n000 - Output Off\\r\\n001 - Output On\\r\\n010 - Output Faulted On\\r\\n011 - Output Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8355":{"PGN":61659,"PGN_Name":"API 1 Output 2 Energy Consumer Feedback","PGN_Description":"API1_O2_FDBK","first_bit":51,"SPN":8355,"SPN_Name":"API 1 Output 2 Loadshed Request","SPN_Description":"Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\\r\\n\\r\\n00 - No Loadshed Requested\\r\\n01 - Loadshed Requested\\r\\n10 - Loadshed Requested, Shutdown Imminent\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8356":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":0,"SPN":8356,"SPN_Name":"API 1 Output 3 Device Maximum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output. The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8357":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":8,"SPN":8357,"SPN_Name":"API 1 Output 3 Device Minimum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8358":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":16,"SPN":8358,"SPN_Name":"API 1 Output 3 Device Rated Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8359":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":24,"SPN":8359,"SPN_Name":"API 1 Output 3 Device Rated Voltage","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8360":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":32,"SPN":8360,"SPN_Name":"API 1 Output 3 Device Frequency Rate of Change Limit","SPN_Description":"Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output. (Note: Increasing and decreasing rates can be controlled by the same signal). The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Hz/s","SLOT_ID":426},"8361":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":40,"SPN":8361,"SPN_Name":"API 1 Output 3 Frequency Command","SPN_Description":"Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8362":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":48,"SPN":8362,"SPN_Name":"API 1 Output 3 Device 1 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8363":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":51,"SPN":8363,"SPN_Name":"API 1 Output 3 Device 2 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8364":{"PGN":61662,"PGN_Name":"API 1 Output 3 Energy Consumer Command","PGN_Description":"API1_O3_CMD","first_bit":54,"SPN":8364,"SPN_Name":"API 1 Output 3 Enable Command","SPN_Description":"Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\n00 - Turn API Output Off\\r\\n01 - Turn API Output On\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8365":{"PGN":61663,"PGN_Name":"API 1 Output 3 Energy Consumer Feedback","PGN_Description":"API1_O3_FDBK","first_bit":0,"SPN":8365,"SPN_Name":"API 1 Output 3 Frequency Feedback","SPN_Description":"Present operating frequency of this Accessory Power Inverter output.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8366":{"PGN":61663,"PGN_Name":"API 1 Output 3 Energy Consumer Feedback","PGN_Description":"API1_O3_FDBK","first_bit":8,"SPN":8366,"SPN_Name":"API 1 Output 3 Voltage Feedback","SPN_Description":"Present operating voltage of this Accessory Power Inverter output.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8367":{"PGN":61663,"PGN_Name":"API 1 Output 3 Energy Consumer Feedback","PGN_Description":"API1_O3_FDBK","first_bit":16,"SPN":8367,"SPN_Name":"API 1 Output 3 Power Feedback","SPN_Description":"Present operating power of this Accessory Power Inverter output.","bit_length":8,"scaling":0.1,"offset":0,"unit":"kW","SLOT_ID":428},"8368":{"PGN":61663,"PGN_Name":"API 1 Output 3 Energy Consumer Feedback","PGN_Description":"API1_O3_FDBK","first_bit":48,"SPN":8368,"SPN_Name":"API 1 Output 3 Status Feedback","SPN_Description":"Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\\r\\n\\n000 - Output Off\\r\\n001 - Output On\\r\\n010 - Output Faulted On\\r\\n011 - Output Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8369":{"PGN":61663,"PGN_Name":"API 1 Output 3 Energy Consumer Feedback","PGN_Description":"API1_O3_FDBK","first_bit":51,"SPN":8369,"SPN_Name":"API 1 Output 3 Loadshed Request","SPN_Description":"Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested  state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\\r\\n\\r\\n00 - No Loadshed Requested\\r\\n01 - Loadshed Requested\\r\\n10 - Loadshed Requested, Shutdown Imminent\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8370":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":0,"SPN":8370,"SPN_Name":"API 1 Output 4 Device Maximum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the maximum frequency of the devices(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8371":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":8,"SPN":8371,"SPN_Name":"API 1 Output 4 Device Minimum Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the minimum frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8372":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":16,"SPN":8372,"SPN_Name":"API 1 Output 4 Device Rated Frequency","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated frequency of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8373":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":24,"SPN":8373,"SPN_Name":"API 1 Output 4 Device Rated Voltage","SPN_Description":"Signal to the Accessory Power Inverter indicating the rated voltage of the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8374":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":32,"SPN":8374,"SPN_Name":"API 1 Output 4 Device Frequency Rate of Change Limit","SPN_Description":"Signal to the Accessory Power Inverter indicating the frequency rate of change limit of the device(s) attached to the inverter output.  (Note: Increasing and decreasing rates can be controlled by the same signal).  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":2,"offset":0,"unit":"Hz/s","SLOT_ID":426},"8375":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":40,"SPN":8375,"SPN_Name":"API 1 Output 4 Frequency Command","SPN_Description":"Command to the Accessory Power Inverter indicating the Inverter frequency desired for the device(s) attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8376":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":48,"SPN":8376,"SPN_Name":"API 1 Output 4 Device 1 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 1 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8377":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":51,"SPN":8377,"SPN_Name":"API 1 Output 4 Device 2 Status","SPN_Description":"Signal to the Accessory Power Inverter indicating the state of device 2 attached to the inverter output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\nThe Faulted Off state will be communicated when the device has a fault due to an overload condition or other fault resulting in a shutdown.  The Faulted On state will be communicated when the device has a fault that has resulted in an operational state that is running but no longer controllable.  The Error state is used when the operational state of the device is unknown.\\r\\n\\r\\n000 - On\\r\\n001 - Off\\r\\n010 - Faulted On\\r\\n011 - Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8378":{"PGN":61666,"PGN_Name":"API 1 Output 4 Energy Consumer Command","PGN_Description":"API1_O4_CMD","first_bit":54,"SPN":8378,"SPN_Name":"API 1 Output 4 Enable Command","SPN_Description":"Command to the Accessory Power Inverter to enable this output.  The Accessory Power Inverter may have multiple outputs in addition to this one; the other outputs are controlled by using other Command and Feedback PGNs.  Each output may control multiple devices (e.g. electric motors) if they all operate at the same frequency.\\r\\n\\r\\n00 - Turn API Output Off\\r\\n01 - Turn API Output On\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8379":{"PGN":61667,"PGN_Name":"API 1 Output 4 Energy Consumer Feedback","PGN_Description":"API1_O4_FDBK","first_bit":0,"SPN":8379,"SPN_Name":"API 1 Output 4 Frequency Feedback","SPN_Description":"Present operating frequency of this Accessory Power Inverter output.","bit_length":8,"scaling":1,"offset":0,"unit":"Hz","SLOT_ID":425},"8380":{"PGN":61667,"PGN_Name":"API 1 Output 4 Energy Consumer Feedback","PGN_Description":"API1_O4_FDBK","first_bit":8,"SPN":8380,"SPN_Name":"API 1 Output 4 Voltage Feedback","SPN_Description":"Present operating voltage of this Accessory Power Inverter output.","bit_length":8,"scaling":2,"offset":0,"unit":"Vrms","SLOT_ID":427},"8381":{"PGN":61667,"PGN_Name":"API 1 Output 4 Energy Consumer Feedback","PGN_Description":"API1_O4_FDBK","first_bit":16,"SPN":8381,"SPN_Name":"API 1 Output 4 Power Feedback","SPN_Description":"Present operating power of this Accessory Power Inverter output.","bit_length":8,"scaling":0.1,"offset":0,"unit":"kW","SLOT_ID":428},"8382":{"PGN":61667,"PGN_Name":"API 1 Output 4 Energy Consumer Feedback","PGN_Description":"API1_O4_FDBK","first_bit":48,"SPN":8382,"SPN_Name":"API 1 Output 4 Status Feedback","SPN_Description":"Operating Status of this Accessory Power Inverter output. The Inverter Output Faulted state will be communicated when the inverter output has shutdown due to an overload condition or other fault.\\r\\n\\r\\n000 - Output Off\\r\\n001 - Output On\\r\\n010 - Output Faulted On\\r\\n011 - Output Faulted Off\\r\\n100 - Reserved for SAE Assignment\\r\\n101 - Reserved for SAE Assignment\\r\\n110 - Error\\r\\n111 - Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8383":{"PGN":61667,"PGN_Name":"API 1 Output 4 Energy Consumer Feedback","PGN_Description":"API1_O4_FDBK","first_bit":51,"SPN":8383,"SPN_Name":"API 1 Output 4 Loadshed Request","SPN_Description":"Loadshed Request from this Accessory Power Inverter output.  The Loadshed Requested state is an indication that the inverter output powering this device has a malfunction and is in a limit condition and if the load of the output is not reduced, the inverter will take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed needs have not been met and the output will be shutdown in a limited amount of time.\\r\\n\\r\\n00 - No Loadshed Requested\\r\\n01 - Loadshed Requested\\r\\n10 - Loadshed Requested, Shutdown Imminent\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8384":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":0,"SPN":8384,"SPN_Name":"HVES Fan Enable Command","SPN_Description":"Enable and direction command to this HVES fan.\\r\\n\\r\\n00 - Fan Off\\r\\n01 - Fan On Normal/Default Direction\\r\\n10 - Fan On Reverse Direction\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8385":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":2,"SPN":8385,"SPN_Name":"HVES Fan Power Hold","SPN_Description":"Command to allow this HVES fan to remain alive independently of the electrical enable input to the fan.  For example, this could allow continued device operation after the keyswitch has turned off.\\r\\n\\r\\n00 - Power Hold Disabled\\r\\n01 - Power Hold Enabled\\r\\n10 - Reserved\\r\\n11 - Don\'t Care/Take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8386":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":8,"SPN":8386,"SPN_Name":"HVES Fan Speed Command","SPN_Description":"Speed command to this HVES fan.\\r\\n\\r\\nNote: Both Speed Command and Percent Speed Command (SPN 8387) cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8387":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":24,"SPN":8387,"SPN_Name":"HVES Fan Percent Speed Command","SPN_Description":"Speed command to this HVES fan in percentage of maximum speed.\\r\\n\\r\\nNote: Both Speed Command (SPN 8386) and Percent Speed Command cannot be used at the same time.  Always set the unused speed command to Not Available.  If both commands are set to Not Available, a preprogrammed default speed will be used.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"8388":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":32,"SPN":8388,"SPN_Name":"HVES Fan Instance 1","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8389":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":33,"SPN":8389,"SPN_Name":"HVES Fan Instance 2","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8390":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":34,"SPN":8390,"SPN_Name":"HVES Fan Instance 3","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8391":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":35,"SPN":8391,"SPN_Name":"HVES Fan Instance 4","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8392":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":36,"SPN":8392,"SPN_Name":"HVES Fan Instance 5","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8393":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":37,"SPN":8393,"SPN_Name":"HVES Fan Instance 6","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8394":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":38,"SPN":8394,"SPN_Name":"HVES Fan Instance 7","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8395":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":39,"SPN":8395,"SPN_Name":"HVES Fan Instance 8","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8396":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":40,"SPN":8396,"SPN_Name":"HVES Fan Instance 9","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8397":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":41,"SPN":8397,"SPN_Name":"HVES Fan Instance 10","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8398":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":42,"SPN":8398,"SPN_Name":"HVES Fan Instance 11","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8399":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":43,"SPN":8399,"SPN_Name":"HVES Fan Instance 12","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8400":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":44,"SPN":8400,"SPN_Name":"HVES Fan Instance 13","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8401":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":45,"SPN":8401,"SPN_Name":"HVES Fan Instance 14","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8402":{"PGN":64486,"PGN_Name":"High Voltage Energy Storage Fan Commands","PGN_Description":"HVESFC","first_bit":46,"SPN":8402,"SPN_Name":"HVES Fan Instance 15","SPN_Description":"Indicates the HVES Fan Instance that is being commanded.  Multiple instances can be controlled with the same command PGN by setting each unique instance parameter to 0x0.\\r\\n\\r\\n0 - Command applied to this Fan Instance\\r\\n1 - No Command applied to this Fan Instance","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8403":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":0,"SPN":8403,"SPN_Name":"HVES Fan Enable Status","SPN_Description":"Enable and direction status of this HVES fan.\\r\\n\\r\\n00 - Fan Off\\r\\n01 - Fan On - Normal, Forward, or Default Direction\\r\\n10 - Fan On - Reverse Direction\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8404":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":2,"SPN":8404,"SPN_Name":"HVES Fan Status Reason Code","SPN_Description":"Provides the reason code describing the unique failure of this HVES fan.  If a detailed reason code is not used by the supporting application, or this reason code is Not Available, the HVES Fan Service Indicator (SPN 8409) and HVES fan Operating Status (SPN 8410) may be used to determine functional status of this HVES fan.\\r\\n\\r\\n0000 - Normal Operation\\r\\n0001 - Unable to Start\\r\\n0010 - Over-Voltage Protection Shutdown\\r\\n0011 - Under-Voltage Protection Shutdown\\r\\n0100 - Over-Temperature Protection Shutdown\\r\\n0101 - Speed Limited due to current (i.e. amperage) protection limit\\r\\n0110 - Speed limited due to maximum system design capability (e.g.  PWM control limit or physical limit of system)\\r\\n0111 - Reserved\\r\\n1000 - Reserved\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Reserved\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8405":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":6,"SPN":8405,"SPN_Name":"HVES Fan Command Status","SPN_Description":"Indicates the source of the speed command to this HVES fan.\\r\\n\\r\\n00 is communicated when the fan is self-controlled (e.g. based on a temperature sensor).  01 is communicated when responding to the HVES Fan Speed Command (SPN 8386) or HVES Fan Percent Speed Command (SPN 8487).  10 is communicated when neither an internal nor external command is provided (e.g. failed temperature sensor or loss of the command message).\\r\\n\\r\\n00 - Internal Command\\r\\n01 - External Command\\r\\n10 - Default Command\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8406":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":8,"SPN":8406,"SPN_Name":"HVES Fan Speed","SPN_Description":"Speed of this HVES fan. ","bit_length":16,"scaling":0.5,"offset":0,"unit":"rpm","SLOT_ID":78},"8407":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":24,"SPN":8407,"SPN_Name":"HVES Fan Medium Temperature","SPN_Description":"A temperature measured and reported by the device.  It may be used for direct or remote (e.g. by another controller) control of the pump.  For example, this may be the temperature of the fluid flowing through the pump, or some other temperature relating to the pump or controller. ","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8408":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":40,"SPN":8408,"SPN_Name":"HVES Fan Power","SPN_Description":"Calculated electrical power consumed by this HVES fan.","bit_length":16,"scaling":0.5,"offset":0,"unit":"W","SLOT_ID":305},"8409":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":56,"SPN":8409,"SPN_Name":"HVES Fan Service Indicator","SPN_Description":"Indicates that service is required for this HVES fan.  An active indication may convey a need for component replacement or periodic service.  The HVES Fan Status Reason Code (SPN 8404) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Service Not Required\\r\\n01 - Service Required\\r\\n10 - Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8410":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":58,"SPN":8410,"SPN_Name":"HVES Fan Operating Status","SPN_Description":"Indicates the operating status of this HVES fan.  This parameter is used to inform other devices that this system or component is no longer performing to its operational capacity and that reduced, or no flow of the medium (e.g. coolant, oil, air, etc.) can be expected.   Derated or Not Operable condition may require other vehicle systems to modify their operation.\\r\\n\\r\\nThe HVES Fan Status Reason Code (SPN 8404) may provide additional detail as to the nature of the system status.\\r\\n\\r\\n00 - Normal Operation\\r\\n01 - Derated Operation\\r\\n10 - Not Operable\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8411":{"PGN":64485,"PGN_Name":"High Voltage Energy Storage Fan Status","PGN_Description":"HVESFS","first_bit":60,"SPN":8411,"SPN_Name":"HVES Fan Instance","SPN_Description":"Indicates the instance of the HVES fan that is providing status in systems controlled by a master ECU.\\r\\n\\r\\n0000 - Instance 1\\r\\n0001 - Instance 2\\r\\n0010 - Instance 3\\r\\n0011 - Instance 4\\r\\n0100 - Instance 5\\r\\n0101 - Instance 6\\r\\n0110 - Instance 7\\r\\n0111 - Instance 8\\r\\n1000 - Instance 9\\r\\n1001 - Instance 10\\r\\n1010 - Instance 11\\r\\n1011 - Instance 12\\r\\n1100 - Instance 13\\r\\n1101 - Instance 14\\r\\n1110 - Instance 15\\r\\n1111 - Not available / Instance not specified","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8412":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":12,"SPN":8412,"SPN_Name":"HVES1 Operation Consent","SPN_Description":"This parameter provides an indication to the HVES1 pack (or system) that an external device is ready for HVES1 to proceed with normal operation.  In applications which support this parameter, the HVES1 (or system) may only proceed with normal operation if consent is given.  The HVES1 operation that is allowed based on this consent is manufacturer dependent.\\r\\n\\r\\n00 - Consent revoked; system component does not consent to HVES1 operation\\r\\n01 - Consent given; system component consents to HVES1 operation\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8413":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":40,"SPN":8413,"SPN_Name":"HVES1 High-Voltage Bus Connection Status","SPN_Description":"This parameter provides high level feedback on the HVES1 pack (or system) high voltage bus connection.  For specific contactor information, see HVES1 High-Voltage Bus (Positive) Contactor State (SPN 8091), HVES1 High-Voltage Bus (Negative) Contactor State (SPN 8092), HVES1 Center of Pack Contactor State (SPN 8095), and HVES1 High-Voltage Bus Pre-Charge Relay State (SPN 8094).\\r\\n\\r\\n0000 - Disconnected.  One or more contactors are open.  State may result from the HVES1 High-Voltage Bus Connect Command (SPN 8123) or due to a limit being exceeded.\\r\\n\\r\\n0001 - Connected.  All contactors are closed and the precharge relay is open.  Typically results from the HVES1 High-Voltage Bus Connect Command (SPN 8123).\\r\\n\\r\\n0010 - Connection in Process.  May be rapidly transitioned through depending on HVES design, but indicates that the precharge relay is closed and/or one or more contactors may also be closed or in the process of being closed.\\r\\n\\r\\n0011 - Disconnection in Process.   May be rapidly transitioned through depending on HVES design, but indicates that HVES1 is in the process of disconnecting itself from the high voltage bus.\\r\\n\\r\\n0100 - Disconnected; Precharge Failed.  Indicates that the pre-charge function status cannot be determined or did not complete (e.g. Relay failure, insufficient HVES voltage, etc.).\\r\\n\\r\\n0101 - Reserved\\r\\n0110 - Reserved\\r\\n0111 - Reserved\\r\\n1000 - Reserved\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Error\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8414":{"PGN":61590,"PGN_Name":"High Voltage Energy Storage 1 Status 1","PGN_Description":"HVES1S1","first_bit":44,"SPN":8414,"SPN_Name":"HVES1 Operational Status","SPN_Description":"Provides feedback on where the HVES1 pack (or system) is in its operating spectrum, and includes feedback in response to the Operation Consent [i.e. HVES1 Operation Consent (SPN 8412)] and Power Down Command [i.e. HVES1 Power Down Command (SPN 8124)] parameters.\\r\\n\\r\\n0000 - Initialization in process.  The HVES controller is powering up.  This process may include both internal HVES controller checks, as well as system checks being run by the HVES controller.\\r\\n\\r\\n0001 - Initialization Complete, awaiting Operation Consent.  HVES controller is ready from its perspective, but requires one or more positive Operation Consent indications before becoming fully operational.  Some applications may not support this state.\\r\\n\\r\\n0010 - Operational.\\r\\n\\r\\n0011 - Normal Power-Down in Process.  This state is a response to Power Down Command state 01.\\r\\n\\r\\n0100 - Emergency Power-Down In Process.  This state is a response to Power Down Command state 10.\\r\\n\\r\\n0101 - Disabled by external command.  The HVES is in a non-operational state due to a Power Down Command, or the result of Operation Consent being revoked.\\r\\n\\r\\n0110 - Disabled by internal decision of HVES controller (e.g. malfunction, protection)\\r\\n\\r\\n0111 - Reserved\\r\\n1000 - Reserved\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1110 - Error\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8415":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":0,"SPN":8415,"SPN_Name":"Driver Side Fuel Receptacle 1 Cover Status","SPN_Description":"Indicates if the cover for the first fuel receptacle on the driver side is attached or detached.\\r\\n\\r\\n00 - Receptacle cover is detached\\r\\n01 - Receptacle cover is attached\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8416":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":2,"SPN":8416,"SPN_Name":"Driver Side Fuel Receptacle 2 Cover Status","SPN_Description":"Indicates if the cover for the second fuel receptacle on the driver side is attached or detached.\\r\\n\\r\\n00 - Receptacle cover is detached\\r\\n01 - Receptacle cover is attached\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8417":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":4,"SPN":8417,"SPN_Name":"Passenger Side Fuel Receptacle 1 Cover Status","SPN_Description":"Indicates if the cover for the first fuel receptacle on the passenger side is attached or detached.\\r\\n\\r\\n00 - Receptacle cover is detached\\r\\n01 - Receptacle cover is attached\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8418":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":6,"SPN":8418,"SPN_Name":"Passenger Side Fuel Receptacle 2 Cover Status","SPN_Description":"Indicates if the cover for the second fuel receptacle on the passenger side is attached or detached.\\r\\n\\r\\n00 - Receptacle cover is detached\\r\\n01 - Receptacle cover is attached\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8419":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":8,"SPN":8419,"SPN_Name":"Front Fuel Receptacle Cover Status","SPN_Description":"Indicates if the cover for the fuel receptacle at the front of the vehicle is attached or detached.\\r\\n\\r\\n00 - Receptacle cover is detached\\r\\n01 - Receptacle cover is attached\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8420":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":16,"SPN":8420,"SPN_Name":"Fuel Storage Compartment 1 Temperature 1","SPN_Description":"The ambient temperature in the first fuel storage compartment.  If there is more than 1 sensor, then this is the first sensor. Note that this is not the temperature of the fuel in the fuel tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8421":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":24,"SPN":8421,"SPN_Name":"Fuel Storage Compartment 1 Temperature 2","SPN_Description":"The ambient temperature as measured by the second temperature sensor in the first fuel storage compartment. Note that this is not the temperature of the fuel in the fuel tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8422":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":32,"SPN":8422,"SPN_Name":"Fuel Storage Compartment 2 Temperature 1","SPN_Description":"The ambient temperature in the second fuel storage compartment.  If there is more than 1 sensor, then this is the first sensor. Note that this is not the temperature of the fuel in the fuel tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8423":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":40,"SPN":8423,"SPN_Name":"Fuel Storage Compartment 2 Temperature 2","SPN_Description":"The ambient temperature as measured by the second temperature sensor in the second fuel storage compartment. Note that this is not the temperature of the fuel in the fuel tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8424":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":48,"SPN":8424,"SPN_Name":"Fuel Storage Compartment 3 Temperature 1","SPN_Description":"The ambient temperature in the third fuel storage compartment.  If there is more than 1 sensor, then this is the first sensor. Note that this is not the temperature of the fuel in the fuel tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8425":{"PGN":64484,"PGN_Name":"Fuel Information 7 (Gaseous)","PGN_Description":"GFI7","first_bit":56,"SPN":8425,"SPN_Name":"Fuel Storage Compartment 3 Temperature 2","SPN_Description":"The ambient temperature as measured by the second temperature sensor in the third fuel storage compartment. Note that this is not the temperature of the fuel in the fuel tank.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8428":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":16,"SPN":8428,"SPN_Name":"Fuel Supply Estimated Remaining Distance","SPN_Description":"Estimated remaining distance based on existing fuel supply.","bit_length":16,"scaling":1,"offset":0,"unit":"km","SLOT_ID":270},"8429":{"PGN":61470,"PGN_Name":"Generator Control 2","PGN_Description":"GC2","first_bit":16,"SPN":8429,"SPN_Name":"Engine Self-Induced Derate Inhibit","SPN_Description":"Parameter to indicate if the genset control system allows the Engine Control Module to impose its own induced derate.\\r\\n\\r\\n00 - Engine is allowed to impose a self-induced derate\\r\\n01 - Engine is inhibited from imposing a self-induced derate\\r\\n10 - SAE Reserved\\r\\n11 - Don\'t care / take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8430":{"PGN":61470,"PGN_Name":"Generator Control 2","PGN_Description":"GC2","first_bit":24,"SPN":8430,"SPN_Name":"Engine Load Setpoint Request","SPN_Description":"Setpoint request (in kW) sent to the engine by a genset control system.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"8431":{"PGN":61708,"PGN_Name":"High Voltage Energy Storage 1 Data 10","PGN_Description":"HVES1D10","first_bit":32,"SPN":8431,"SPN_Name":"HVES1 High-Voltage Bus Active Isolation Test Results","SPN_Description":"The isolation resistance expressed in Ohms per Volt that resulted from the High-Voltage Bus Active Isolation Test.\\r\\n\\r\\nSee HVES1 High-Voltage Bus Active Isolation Test Status (SPN 8096) for test status and HVES1 High-Voltage Bus Active Isolation Test Command (SPN 8125) for the command to run the test.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm/V","SLOT_ID":429},"8432":{"PGN":61708,"PGN_Name":"High Voltage Energy Storage 1 Data 10","PGN_Description":"HVES1D10","first_bit":48,"SPN":8432,"SPN_Name":"HVES1 High-Voltage Bus Passive Isolation Test Results","SPN_Description":"The isolation resistance expressed in Ohms per Volt that resulted from the High-Voltage Bus Passive Isolation Test.\\r\\n\\r\\nSee HVES1 High-Voltage Bus Passive Isolation Test Status (SPN 8097) for test status and HVES1 High-Voltage Bus Active Isolation Test Command (SPN 8126) for the command to run the test.","bit_length":16,"scaling":0.1,"offset":0,"unit":"ohm/V","SLOT_ID":429},"8433":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":14,"SPN":8433,"SPN_Name":"HVES1 High-Voltage Bus High Side Resistor Connect Request","SPN_Description":"This parameter is used to request connection of the HVES1 High-Voltage bus high side resistor in order to perform an isolation test.  See also HVES1 High-Voltage Bus Low Side Resistor Connect Request (SPN 8434).\\r\\n\\r\\n00 - Connection not Requested\\r\\n01 - Connection Requested\\r\\n10 - Reserved\\r\\n11 - Don\u2019t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8434":{"PGN":6912,"PGN_Name":"High Voltage Energy Storage 1 Control 1","PGN_Description":"HVES1C1","first_bit":16,"SPN":8434,"SPN_Name":"HVES1 High-Voltage Bus Low Side Resistor Connect Request","SPN_Description":"This parameter is used to request connection of the HVES1 High-Voltage bus low side resistor in order to perform an isolation test.  See also HVES1 High-Voltage Bus High Side Resistor Connect Request (SPN 8433).\\r\\n\\r\\n00 - Connection not Requested\\r\\n01 - Connection Requested\\r\\n10 - Reserved\\r\\n11 - Don\u2019t care/take no action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8435":{"PGN":61711,"PGN_Name":"Engine Operating Information 2","PGN_Description":"EOI2","first_bit":0,"SPN":8435,"SPN_Name":"Engine Self-Induced Derate Load","SPN_Description":"The self-induced derate load that the Engine Control Module is trying to achieve.  A value of 0% means there is no active derate.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"8436":{"PGN":61711,"PGN_Name":"Engine Operating Information 2","PGN_Description":"EOI2","first_bit":16,"SPN":8436,"SPN_Name":"Engine Power Derate Request","SPN_Description":"Derate request made from the engine control system to an external system, where the engine is requesting an external device to reduce the load being applied. A zero value indicates no derate, while any other value indicates the amount of load (in kW) to be reduced.\\r\\n\\r\\nSee also SPN 3644 for a Derate Request in percent.","bit_length":16,"scaling":0.5,"offset":0,"unit":"kW","SLOT_ID":55},"8438":{"PGN":2560,"PGN_Name":"Cruise Control / Vehicle Speed 2","PGN_Description":"CCVS2","first_bit":8,"SPN":8438,"SPN_Name":"Idle Speed Request","SPN_Description":"Requested idle speed. Allows an operator or ECU to modify the engine idle setpoint within a range supported by the engine. Requests above or below the supported range should result in a speed at the limit of the supported range. Should be 0 when the idle control state (SPN 8439) is not active. A value of 0xFB indicates the desired speed is pre-programmed in the engine. This setting impacts Point 1 on the Engine Configuration.\\r\\n\\r\\nIntended for the vehicle controller to modify engine idle speed to match vehicle operating conditions and modes (cab temperature, air supply, battery state, operator selection, etc.)","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"8439":{"PGN":2560,"PGN_Name":"Cruise Control / Vehicle Speed 2","PGN_Description":"CCVS2","first_bit":24,"SPN":8439,"SPN_Name":"Idle Control Enable State","SPN_Description":"Indicates whether enabling conditions (switch position, park brake, transmission neutral status, etc.) have been met for an idle speed request. Similar to a cruise control enable switch, this parameter does not activate the request, but may be used to provide indication of availability. This parameter does not inhibit or apply to Engine Operator Primary Intermediate Speed Select (SPN 2880).\\r\\n\\r\\n00 - Conditions are not met for idle speed request\\r\\n01 - Conditions for idle speed request have been met\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8440":{"PGN":2560,"PGN_Name":"Cruise Control / Vehicle Speed 2","PGN_Description":"CCVS2","first_bit":26,"SPN":8440,"SPN_Name":"Idle Control Request Activation","SPN_Description":"Indicates whether the idle speed request (SPN 8438) should be honored. This parameter does not inhibit or apply to Engine Operator Primary Intermediate Speed Select (SPN 2880).\\r\\n\\r\\n00 - Idle speed request is not active\\r\\n01 - Idle speed request is active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8441":{"PGN":64555,"PGN_Name":"Cruise Control / Vehicle Speed 4","PGN_Description":"CCVS4","first_bit":32,"SPN":8441,"SPN_Name":"Engine External Idle Request  Feedback","SPN_Description":"Indicates that the engine is altering the idle speed due to a request from an external source. \\r\\n\\r\\n00 - No Idle Alteration Active - standard idle speed\\r\\n01 - Idle Alteration Active\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8442":{"PGN":61691,"PGN_Name":"Aftertreatment 1 SCR Dosing System Requests 3","PGN_Description":"A1SCRDSR3","first_bit":16,"SPN":8442,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Doser Valve 1 Command","SPN_Description":"Command (in percent) sent to the diesel exhaust fluid (DEF) injector to control the amount of DEF being injected into the aftreatment exhaust stream.\\r\\n\\r\\n0% closes the valve; 100% fully opens the valve.","bit_length":16,"scaling":0.0025,"offset":0,"unit":"%","SLOT_ID":30},"8443":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":0,"SPN":8443,"SPN_Name":"Engine Alternator Winding 7 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8444":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":8,"SPN":8444,"SPN_Name":"Engine Alternator Winding 8 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8445":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":16,"SPN":8445,"SPN_Name":"Engine Alternator Winding 9 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8446":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":24,"SPN":8446,"SPN_Name":"Engine Alternator Winding 10 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8447":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":32,"SPN":8447,"SPN_Name":"Engine Alternator Winding 11 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8448":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":40,"SPN":8448,"SPN_Name":"Engine Alternator Winding 12 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8449":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":48,"SPN":8449,"SPN_Name":"Alternator Air Cooler Air Intake Temperature","SPN_Description":"Temperature of air entering the air cooler in an alternator","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8450":{"PGN":64483,"PGN_Name":"Alternator Temperature 2","PGN_Description":"AT2","first_bit":56,"SPN":8450,"SPN_Name":"Alternator Air Cooler Air Outlet Temperature","SPN_Description":"Temperature of air after it exits from the air cooler in an alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8451":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":0,"SPN":8451,"SPN_Name":"Power Rectifier Diode 1 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8452":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":8,"SPN":8452,"SPN_Name":"Power Rectifier Diode 2 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8453":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":16,"SPN":8453,"SPN_Name":"Power Rectifier Diode 3 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8454":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":24,"SPN":8454,"SPN_Name":"Power Rectifier Diode 4 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8455":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":32,"SPN":8455,"SPN_Name":"Power Rectifier Diode 5 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8456":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":40,"SPN":8456,"SPN_Name":"Power Rectifier Diode 6 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8457":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":48,"SPN":8457,"SPN_Name":"Power Rectifier Diode 7 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8458":{"PGN":64482,"PGN_Name":"Diode Temperature 1","PGN_Description":"DT1","first_bit":56,"SPN":8458,"SPN_Name":"Power Rectifier Diode 8 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8459":{"PGN":64481,"PGN_Name":"Diode Temperature 2","PGN_Description":"DT2","first_bit":0,"SPN":8459,"SPN_Name":"Power Rectifier Diode 9 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8460":{"PGN":64481,"PGN_Name":"Diode Temperature 2","PGN_Description":"DT2","first_bit":8,"SPN":8460,"SPN_Name":"Power Rectifier Diode 10 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8461":{"PGN":64481,"PGN_Name":"Diode Temperature 2","PGN_Description":"DT2","first_bit":16,"SPN":8461,"SPN_Name":"Power Rectifier Diode 11 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8462":{"PGN":64481,"PGN_Name":"Diode Temperature 2","PGN_Description":"DT2","first_bit":24,"SPN":8462,"SPN_Name":"Power Rectifier Diode 12 Temperature","SPN_Description":"Temperature of this diode used in power rectifier.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8463":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":40,"SPN":8463,"SPN_Name":"Engine Alternator Winding 4 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8464":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":48,"SPN":8464,"SPN_Name":"Engine Alternator Winding 5 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8465":{"PGN":65191,"PGN_Name":"Alternator Temperature 1","PGN_Description":"AT1","first_bit":56,"SPN":8465,"SPN_Name":"Engine Alternator Winding 6 Temperature","SPN_Description":"Temperature of this winding inside the alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8466":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":0,"SPN":8466,"SPN_Name":"Alternator Oil Cooler Oil Intake Temperature","SPN_Description":"Temperature of lubricant as it enters the oil cooler of an alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8467":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":8,"SPN":8467,"SPN_Name":"Alternator Oil Cooler Oil Outlet Temperature","SPN_Description":"Temperature of lubricant after it exits the oil cooler of an alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8468":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":16,"SPN":8468,"SPN_Name":"Alternator Oil Cooler Coolant Intake Temperature","SPN_Description":"Temperature of liquid as it enters the oil cooler of an alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8469":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":24,"SPN":8469,"SPN_Name":"Alternator Oil Cooler Coolant Outlet Temperature","SPN_Description":"Temperature of liquid after it exits the oil cooler of an alternator.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8470":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":40,"SPN":8470,"SPN_Name":"Alternator Aftercooler Coolant Pump Outlet Temperature","SPN_Description":"Temperature of liquid at the aftercooler coolant pump outlet.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8471":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":48,"SPN":8471,"SPN_Name":"Alternator Aftercooler Coolant Outlet Temperature","SPN_Description":"Temperature of liquid at the aftercooler outlet.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8472":{"PGN":64480,"PGN_Name":"Aftercooler and Oil Cooler Fluids 1","PGN_Description":"ACOCF1","first_bit":56,"SPN":8472,"SPN_Name":"Alternator Aftercooler Coolant Pump Outlet Pressure","SPN_Description":"Pressure of liquid at the aftercooler pump outlet","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"8473":{"PGN":65172,"PGN_Name":"Engine Auxiliary Coolant","PGN_Description":"EAC","first_bit":40,"SPN":8473,"SPN_Name":"Engine Coolant Pump Coolant Outlet Pressure","SPN_Description":"Engine coolant pressure at the coolant pump outlet.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"8474":{"PGN":64725,"PGN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump 1 Information","PGN_Description":"AT1P1I","first_bit":26,"SPN":8474,"SPN_Name":"Aftertreatment 1 Diesel Exhaust Fluid Pump Power Supply","SPN_Description":"State signal which indicates when the aftertreatment 1 Diesel Exhaust Fluid (DEF) pump power output is being driven.  On means the ECU is powering the aftertreatment 1 DEF pump power output.  Note that the ECU is external to the DEF pump.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the aftertreatment 1 DEF pump power output\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8475":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":24,"SPN":8475,"SPN_Name":"Power Electronics Coolant Fill Switch","SPN_Description":"Indicates the coolant fill switch position for the power electronics cooling system.  This switch is used to enable the pump for filling the cooling system.  When the switch is in the On state, the pump is to be running.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8476":{"PGN":65238,"PGN_Name":"Hybrid System Inputs 1","PGN_Description":"HSI1","first_bit":26,"SPN":8476,"SPN_Name":"Propulsion Motor Coolant Fill Switch","SPN_Description":"Indicates the coolant fill switch position for the propulsion motor cooling system.  This switch is used to enable the pump for filling the cooling system.  When the switch is in the On state, the pump is to be running.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8477":{"PGN":64479,"PGN_Name":"Intake/Exhaust Conditions 3","PGN_Description":"IC3","first_bit":0,"SPN":8477,"SPN_Name":"Engine Mixer 1 Intake Pressure","SPN_Description":"The pressure at the intake of the air and fuel mixer.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8481":{"PGN":64819,"PGN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Supply Information","PGN_Description":"A2DEFSI","first_bit":42,"SPN":8481,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Pump Power Relay","SPN_Description":"The state of the aftertreatment 2 diesel exhaust fluid pump power relay.\\r\\n\\r\\n00 - Not active - No power is being applied to the relay\\r\\n01 - Active - Power is being applied to the relay\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8483":{"PGN":64698,"PGN_Name":"Aftertreatment 2 SCR Electronic Control Module Information","PGN_Description":"A2ECMI","first_bit":6,"SPN":8483,"SPN_Name":"Aftertreatment 2 Diesel Exhaust Fluid Control Module Circuit Breaker","SPN_Description":"The status of the circuit breaker that is used to power the Diesel Exhaust Fluid control module.\\r\\n\\r\\n00 - Off\\r\\n01 - On\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8484":{"PGN":61712,"PGN_Name":"Brakes 2","PGN_Description":"B2","first_bit":0,"SPN":8484,"SPN_Name":"Demanded Brake Application Pressure","SPN_Description":"Gage pressure of the compressed air or fluid in the vehicle braking system that is used to apply brake shoes (or pads) against the brake drums (or discs). This is the brake application pressure demanded by the vehicle operator and / or another vehicle system.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8485":{"PGN":61456,"PGN_Name":"Aftertreatment 2 Intake Gas 1","PGN_Description":"AT2IG1","first_bit":61,"SPN":8485,"SPN_Name":"Aftertreatment 2 Intake 2 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 2 Intake 2 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Intake 2 Gas Sensor.  Note that the ECU is external to the sensor.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the Aftertreatment 2 Intake 2 Gas Sensor\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8486":{"PGN":61457,"PGN_Name":"Aftertreatment 2 Outlet Gas 1","PGN_Description":"AT2OG1","first_bit":61,"SPN":8486,"SPN_Name":"Aftertreatment 2 Outlet 2 Gas Sensor Power Supply","SPN_Description":"State signal which indicates when the Aftertreatment 2 Outlet 2 Gas Sensor driver output is being driven.  On means the ECU is powering the Aftertreatment 2 Outlet 2 Gas Sensor.  Note that the ECU is external to the sensor.\\r\\n\\r\\n00 \u2013 Off\\r\\n01 \u2013 On: The ECU is powering the Aftertreatment 2 Outlet 2 Gas Sensor\\r\\n10 \u2013 Error\\r\\n11 \u2013 Unavailable","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8487":{"PGN":64478,"PGN_Name":"Engine Temperature 6","PGN_Description":"ET6","first_bit":0,"SPN":8487,"SPN_Name":"Engine Charge Air Cooler Intake Coolant Temperature","SPN_Description":"Temperature of the fluid in the low temperature circuit measured at the fluid intake of the charge air cooler.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8488":{"PGN":64478,"PGN_Name":"Engine Temperature 6","PGN_Description":"ET6","first_bit":16,"SPN":8488,"SPN_Name":"Engine Charge Air Cooler Outlet Coolant Temperature","SPN_Description":"Temperature of the fluid in the low temperature circuit measured at the fluid outlet of the charge air cooler.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8489":{"PGN":64478,"PGN_Name":"Engine Temperature 6","PGN_Description":"ET6","first_bit":32,"SPN":8489,"SPN_Name":"Engine Intake Coolant Temperature","SPN_Description":"Temperature of the coolant at the intake of the engine block.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8494":{"PGN":61713,"PGN_Name":"Gaseous Fuel Pressure 3","PGN_Description":"GFP3","first_bit":0,"SPN":8494,"SPN_Name":"Engine Fuel Valve 1 Differential Pressure (High Resolution)","SPN_Description":"The differential pressure between the intake and the outlet of the first or only gaseous fuel valve.\\r\\n\\r\\nSee SPN 1391 for alternate range and resolution.","bit_length":16,"scaling":0.0078125,"offset":-100,"unit":"kPa","SLOT_ID":431},"8495":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":0,"SPN":8495,"SPN_Name":"Lock Status of Door 11","SPN_Description":"Lock status of bus door 11\\r\\n\\r\\n00 - Unlocked \\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8496":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":2,"SPN":8496,"SPN_Name":"Open Status of Door 11","SPN_Description":"Open status of bus door 11\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8497":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":4,"SPN":8497,"SPN_Name":"Enable Status of Door 11","SPN_Description":"Enable status of bus door 11.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8498":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":6,"SPN":8498,"SPN_Name":"Lock Status of Door 12","SPN_Description":"Lock status of bus door 12\\r\\n\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8499":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":8,"SPN":8499,"SPN_Name":"Open Status of Door 12","SPN_Description":"Open status of bus door 12\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8500":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":10,"SPN":8500,"SPN_Name":"Enable Status of Door 12","SPN_Description":"Enable status of bus door 12.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8501":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":12,"SPN":8501,"SPN_Name":"Lock Status of Door 13","SPN_Description":"Lock status of bus door 13\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8502":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":14,"SPN":8502,"SPN_Name":"Open Status of Door 13","SPN_Description":"Open status of bus door 13\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8503":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":16,"SPN":8503,"SPN_Name":"Enable Status of Door 13","SPN_Description":"Enable status of bus door 13.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8504":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":18,"SPN":8504,"SPN_Name":"Lock Status of Door 14","SPN_Description":"Lock status of bus door 14\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8505":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":20,"SPN":8505,"SPN_Name":"Open Status of Door 14","SPN_Description":"Open status of bus door 14\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8506":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":22,"SPN":8506,"SPN_Name":"Enable Status of Door 14","SPN_Description":"Enable status of bus door 14.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8507":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":24,"SPN":8507,"SPN_Name":"Lock Status of Door 15","SPN_Description":"Lock status of bus door 15\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8508":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":26,"SPN":8508,"SPN_Name":"Open Status of Door 15","SPN_Description":"Open status of bus door 15\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8509":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":28,"SPN":8509,"SPN_Name":"Enable Status of Door 15","SPN_Description":"Enable status of bus door 15.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8510":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":30,"SPN":8510,"SPN_Name":"Lock Status of Door 16","SPN_Description":"Lock status of bus door 16\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8511":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":32,"SPN":8511,"SPN_Name":"Open Status of Door 16","SPN_Description":"Open status of bus door 16\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8512":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":34,"SPN":8512,"SPN_Name":"Enable Status of Door 16","SPN_Description":"Enable status of bus door 16.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8513":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":36,"SPN":8513,"SPN_Name":"Lock Status of Door 17","SPN_Description":"Lock status of bus door 17\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8514":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":38,"SPN":8514,"SPN_Name":"Open Status of Door 17","SPN_Description":"Open status of bus door 17\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8515":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":40,"SPN":8515,"SPN_Name":"Enable Status of Door 17","SPN_Description":"Enable status of bus door 17.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8516":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":42,"SPN":8516,"SPN_Name":"Lock Status of Door 18","SPN_Description":"Lock status of bus door 18\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8517":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":44,"SPN":8517,"SPN_Name":"Open Status of Door 18","SPN_Description":"Open status of bus door 18\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8518":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":46,"SPN":8518,"SPN_Name":"Enable Status of Door 18","SPN_Description":"Enable status of bus door 18.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8519":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":48,"SPN":8519,"SPN_Name":"Lock Status of Door 19","SPN_Description":"Lock status of bus door 19\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8520":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":50,"SPN":8520,"SPN_Name":"Open Status of Door 19","SPN_Description":"Open status of bus door 19\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8521":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":52,"SPN":8521,"SPN_Name":"Enable Status of Door 19","SPN_Description":"Enable status of bus door 19.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8522":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":54,"SPN":8522,"SPN_Name":"Lock Status of Door 20","SPN_Description":"Lock status of bus door 20\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8523":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":56,"SPN":8523,"SPN_Name":"Open Status of Door 20","SPN_Description":"Open status of bus door 20\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8524":{"PGN":64477,"PGN_Name":"Door Control 3","PGN_Description":"DC3","first_bit":58,"SPN":8524,"SPN_Name":"Enable Status of Door 20","SPN_Description":"Enable status of bus door 20.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8525":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":0,"SPN":8525,"SPN_Name":"Lock Status of Door 21","SPN_Description":"Lock status of bus door 21\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8526":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":2,"SPN":8526,"SPN_Name":"Open Status of Door 21","SPN_Description":"Open status of bus door 21\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8527":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":4,"SPN":8527,"SPN_Name":"Enable Status of Door 21","SPN_Description":"Enable status of bus door 21.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8528":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":6,"SPN":8528,"SPN_Name":"Lock Status of Door 22","SPN_Description":"Lock status of bus door 22\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8529":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":8,"SPN":8529,"SPN_Name":"Open Status of Door 22","SPN_Description":"Open status of bus door 22\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8530":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":10,"SPN":8530,"SPN_Name":"Enable Status of Door 22","SPN_Description":"Enable status of bus door 22.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8531":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":12,"SPN":8531,"SPN_Name":"Lock Status of Door 23","SPN_Description":"Lock status of bus door 23\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8532":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":14,"SPN":8532,"SPN_Name":"Open Status of Door 23","SPN_Description":"Open status of bus door 23\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8533":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":16,"SPN":8533,"SPN_Name":"Enable Status of Door 23","SPN_Description":"Enable status of bus door 23.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8534":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":18,"SPN":8534,"SPN_Name":"Lock Status of Door 24","SPN_Description":"Lock status of bus door 24\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8535":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":20,"SPN":8535,"SPN_Name":"Open Status of Door 24","SPN_Description":"Open status of bus door 24\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8536":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":22,"SPN":8536,"SPN_Name":"Enable Status of Door 24","SPN_Description":"Enable status of bus door 24.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8537":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":24,"SPN":8537,"SPN_Name":"Lock Status of Door 25","SPN_Description":"Lock status of bus door 25\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8538":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":26,"SPN":8538,"SPN_Name":"Open Status of Door 25","SPN_Description":"Open status of bus door 25\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8539":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":28,"SPN":8539,"SPN_Name":"Enable Status of Door 25","SPN_Description":"Enable status of bus door 25.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8540":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":30,"SPN":8540,"SPN_Name":"Lock Status of Door 26","SPN_Description":"Lock status of bus door 26\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8541":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":32,"SPN":8541,"SPN_Name":"Open Status of Door 26","SPN_Description":"Open status of bus door 26\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8542":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":34,"SPN":8542,"SPN_Name":"Enable Status of Door 26","SPN_Description":"Enable status of bus door 26.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8543":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":36,"SPN":8543,"SPN_Name":"Lock Status of Door 27","SPN_Description":"Lock status of bus door 27\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8544":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":38,"SPN":8544,"SPN_Name":"Open Status of Door 27","SPN_Description":"Open status of bus door 27\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8545":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":40,"SPN":8545,"SPN_Name":"Enable Status of Door 27","SPN_Description":"Enable status of bus door 27.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8546":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":42,"SPN":8546,"SPN_Name":"Lock Status of Door 28","SPN_Description":"Lock status of bus door 28\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8547":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":44,"SPN":8547,"SPN_Name":"Open Status of Door 28","SPN_Description":"Open status of bus door 28\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8548":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":46,"SPN":8548,"SPN_Name":"Enable Status of Door 28","SPN_Description":"Enable status of bus door 28.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8549":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":48,"SPN":8549,"SPN_Name":"Lock Status of Door 29","SPN_Description":"Lock status of bus door 29\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8550":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":50,"SPN":8550,"SPN_Name":"Open Status of Door 29","SPN_Description":"Open status of bus door 29\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8551":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":52,"SPN":8551,"SPN_Name":"Enable Status of Door 29","SPN_Description":"Enable status of bus door 29.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8552":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":54,"SPN":8552,"SPN_Name":"Lock Status of Door 30","SPN_Description":"Lock status of bus door 30\\r\\n\\n00 - Unlocked\\r\\n01 - Locked\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8553":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":56,"SPN":8553,"SPN_Name":"Open Status of Door 30","SPN_Description":"Open status of bus door 30\\r\\n\\r\\n00 - Door closed\\r\\n01 - Door opened\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8554":{"PGN":64476,"PGN_Name":"Door Control 4","PGN_Description":"DC4","first_bit":58,"SPN":8554,"SPN_Name":"Enable Status of Door 30","SPN_Description":"Enable status of bus door 30.  Enabled means the bus doors are able to be automatically opened or closed.\\r\\n\\r\\n00 - Door disabled\\r\\n01 - Door enabled\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8558":{"PGN":64695,"PGN_Name":"Hybrid System Status 2","PGN_Description":"HSS2","first_bit":16,"SPN":8558,"SPN_Name":"Hybrid System Engine Stop-Start Remaining Percentage","SPN_Description":"Indicates the remaining percentage of engine stop-start operation allowed by the hybrid system.\\r\\n\\r\\nThe calculation of the percentage is manufacturer specific.  It is an operational limitation, not a functional one, meaning the hybrid system could provide additional stop-start as there is no failure, but it is operationally restricted at this point in time to protect the long term life of the hybrid components supporting stop-start operation (e.g. Hybrid  Battery).  100% means that the maximum stop-start operation is available.  0% means no stop-start operation is available.\\r\\n\\r\\nPossible uses of this parameter may include optimizing when engine stop should occur (e.g. stopping engine at a longer stop versus a short stop light).","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"8560":{"PGN":61714,"PGN_Name":"DC/DC Converter Control ","PGN_Description":"DCDCC","first_bit":0,"SPN":8560,"SPN_Name":"DC/DC Operational Command","SPN_Description":"Command to enable or disable operation.\\r\\n \\r\\n0000 - Disable - in this mode all high voltage switching is disabled\\r\\n0001 - Operate in standby mode; system is waiting for command to enter buck or boost mode\\r\\n0010 - Operate in buck mode; energy flows from high voltage side to low side\\r\\n0011 - Operate in boost mode; energy flows from low voltage side to high side\\r\\n0100 - Reserved\\r\\n0101 - Reserved\\r\\n0110 - Reserved\\r\\n0111 - Reserved\\r\\n1000 - Reserved\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Reserved\\r\\n1111 - Don\'t care/ Take No Action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8561":{"PGN":61714,"PGN_Name":"DC/DC Converter Control ","PGN_Description":"DCDCC","first_bit":8,"SPN":8561,"SPN_Name":"DC/DC Low Side Voltage Buck Setpoint","SPN_Description":"The set point for regulating the low side voltage during buck mode.","bit_length":16,"scaling":0.01,"offset":0,"unit":"V","SLOT_ID":221},"8562":{"PGN":61714,"PGN_Name":"DC/DC Converter Control ","PGN_Description":"DCDCC","first_bit":24,"SPN":8562,"SPN_Name":"DC/DC High Side Voltage Boost Setpoint","SPN_Description":"The set point for regulating the high side voltage during boost mode.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8563":{"PGN":64474,"PGN_Name":"DC/DC Converter High Side Limits ","PGN_Description":"DCDCHL","first_bit":0,"SPN":8563,"SPN_Name":"DC/DC High Side Voltage Minimum Limit","SPN_Description":"The minimum high side voltage allowed.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8564":{"PGN":64474,"PGN_Name":"DC/DC Converter High Side Limits ","PGN_Description":"DCDCHL","first_bit":16,"SPN":8564,"SPN_Name":"DC/DC High Side Voltage Maximum Limit","SPN_Description":"The maximum high side voltage allowed.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8565":{"PGN":64474,"PGN_Name":"DC/DC Converter High Side Limits ","PGN_Description":"DCDCHL","first_bit":32,"SPN":8565,"SPN_Name":"DC/DC High Side Current Maximum Limit","SPN_Description":"The maximum high side current allowed in or out of the DC/DC Converter.","bit_length":16,"scaling":0.05,"offset":0,"unit":"A","SLOT_ID":250},"8566":{"PGN":64473,"PGN_Name":"DC/DC Converter Low Side Limits ","PGN_Description":"DCDCLL","first_bit":0,"SPN":8566,"SPN_Name":"DC/DC Low Side Voltage Minimum Limit","SPN_Description":"The minimum low side voltage allowed.","bit_length":16,"scaling":0.01,"offset":0,"unit":"V","SLOT_ID":221},"8567":{"PGN":64473,"PGN_Name":"DC/DC Converter Low Side Limits ","PGN_Description":"DCDCLL","first_bit":16,"SPN":8567,"SPN_Name":"DC/DC Low Side Voltage Maximum Limit","SPN_Description":"The maximum low side voltage allowed.","bit_length":16,"scaling":0.01,"offset":0,"unit":"V","SLOT_ID":221},"8568":{"PGN":64473,"PGN_Name":"DC/DC Converter Low Side Limits ","PGN_Description":"DCDCLL","first_bit":32,"SPN":8568,"SPN_Name":"DC/DC Low Side Current Maximum Limit","SPN_Description":"The maximum low side current allowed in or out of the DC/DC Converter.","bit_length":16,"scaling":0.05,"offset":0,"unit":"A","SLOT_ID":250},"8569":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":0,"SPN":8569,"SPN_Name":"DC/DC Operational Status","SPN_Description":"Operating state of the DC/DC Converter\\r\\n\\r\\r\\n0000 - Disabled \\r\\n0001 - Initialization in process.  The device is powering up.  This process may include both internal checks, as well as system checks being run by the DC/DC Converter.\\r\\n0010 - Operational - Standby\\r\\n0011 - Operational - Buck mode\\r\\n0100 - Operational - Boost mode\\r\\n0101 - Normal power down in process  \\r\\n0110 - Disabled due to malfunction or protection\\r\\n0111 - Reserved\\r\\n1000 - Reserved\\r\\n1001 - Reserved\\r\\n1010 - Reserved\\r\\n1011 - Reserved\\r\\n1100 - Reserved\\r\\n1101 - Manufacturer assignable state (only applicable if none of the above apply)\\r\\n1110 - Error\\r\\n1111 - Not Available","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8570":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":4,"SPN":8570,"SPN_Name":"DC/DC HVIL Status","SPN_Description":"High Voltage Interlock Loop (HVIL) state of the DC/DC Converter.\\r\\n\\r\\n00 - HVIL Closed\\r\\n01 - HVIL Open\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8571":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":6,"SPN":8571,"SPN_Name":"DC/DC Loadshed Request","SPN_Description":"The loadshed request is a request to the controlling device to reduce the DC/DC Converter loads.  The Loadshed Requested state is an indication that this DC/DC Converter has a malfunction or is in a limit condition and if the load of the output is not reduced, the DC/DC Converter may take steps to protect itself.  The Loadshed Requested, Shutdown Imminent state is an indication that the loadshed request has not been met and the output may be shutdown in a limited amount of time.\\r\\r\\n\\r\\n00 - No Loadshed Requested\\r\\n01 - Loadshed Requested\\r\\n10 - Loadshed Requested, Shutdown Imminent\\r\\r\\n11 - Don\'t Care/Take No Action","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8572":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":8,"SPN":8572,"SPN_Name":"DC/DC Power Limit due to High Side Current","SPN_Description":"Indicates whether or not output power is being limited due to high side current (see SPN 8588) approaching or exceeding the maximum limit (see SPN 8565).\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8573":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":10,"SPN":8573,"SPN_Name":"DC/DC Power Limit due to Low Side Current","SPN_Description":"Indicates whether or not output power is being limited due to Low side current (see SPN 8586) approaching or exceeding the maximum limit (see SPN 8568).\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8574":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":12,"SPN":8574,"SPN_Name":"DC/DC Power Limit due to High Side Voltage Minimum","SPN_Description":"Indicates whether or not output power is being limited due to High side voltage (see SPN 8587) approaching or falling below the minimum limit (see SPN 8563).\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8575":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":14,"SPN":8575,"SPN_Name":"DC/DC Power Limit due to High Side Voltage Maximum","SPN_Description":"Indicates whether or not output power is being limited due to High side voltage (see SPN 8587) approaching or exceeding the maximum limit (see SPN 8564).\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8576":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":16,"SPN":8576,"SPN_Name":"DC/DC Power Limit due to Low Side Voltage Minimum","SPN_Description":"Indicates whether or not output power is being limited due to Low side voltage (see SPN 8585) approaching or falling below the minimum limit (see SPN 8566).\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8577":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":18,"SPN":8577,"SPN_Name":"DC/DC Power Limit due to Low Side Voltage Maximum","SPN_Description":"Indicates whether or not output power is being limited due to Low side voltage (see SPN 8585) approaching or exceeding the maximum limit (see SPN 8567).\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8578":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":20,"SPN":8578,"SPN_Name":"DC/DC Power Limit due to Controller Temperature","SPN_Description":"Indicates whether or not output power is being limited due to Converter Temperature (see SPN 8592) approaching or exceeding the maximum limit.\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8579":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":22,"SPN":8579,"SPN_Name":"DC/DC Power Limit due to Electronic Filter Temperature","SPN_Description":"Indicates whether or not output power is being limited due to Output Electronic Filter Temperature (see SPN 8693) approaching or exceeding the maximum limit.\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8580":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":24,"SPN":8580,"SPN_Name":"DC/DC Power Limit due to Power Electronics Temperature","SPN_Description":"Indicates whether or not output power is being limited due to Power Electronics Temperature (see SPN 8594) approaching or exceeding the maximum limit.\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8581":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":26,"SPN":8581,"SPN_Name":"DC/DC Power Limit due to SLI Battery Terminal Voltage","SPN_Description":"Indicates whether or not output power is being limited due to the SLI battery terminal voltage (see SPN 8589) approaching or exceeding limits.\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8582":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":30,"SPN":8582,"SPN_Name":"DC/DC Power Limit due to SLI Battery Terminal Temperature","SPN_Description":"Indicates whether or not output power is being limited due to the SLI battery terminal temperature (see SPN 8591) approaching or exceeding limits.\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8583":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":28,"SPN":8583,"SPN_Name":"DC/DC Power Limit due to SLI Battery Terminal Current","SPN_Description":"Indicates whether or not output power is being limited due to the SLI battery terminal current (see SPN 8590) approaching or exceeding limits.\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8584":{"PGN":61715,"PGN_Name":"DC/DC Converter Operating Status ","PGN_Description":"DCDCOS","first_bit":32,"SPN":8584,"SPN_Name":"DC/DC Power Limit due to Undefined Reason","SPN_Description":"Indicates whether or not output power is being limited due to an undefined reason.\\r\\n\\r\\n00 - No power limit for this reason\\r\\n01 - Power limited for this reason\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8585":{"PGN":61716,"PGN_Name":"DC/DC Converter Status 1","PGN_Description":"DCDCS1","first_bit":0,"SPN":8585,"SPN_Name":"DC/DC Low Side Voltage","SPN_Description":"Indicates the measured SLI battery or low side voltage measured at the point of control inside the DC/DC Converter.","bit_length":16,"scaling":0.01,"offset":0,"unit":"V","SLOT_ID":221},"8586":{"PGN":61716,"PGN_Name":"DC/DC Converter Status 1","PGN_Description":"DCDCS1","first_bit":16,"SPN":8586,"SPN_Name":"DC/DC Low Side Current","SPN_Description":"Indicates the measured SLI battery or low side current measured at the point of control inside the DC/DC Converter.  The current is positive if the converter is charging the SLI battery from the hybrid battery.","bit_length":16,"scaling":0.1,"offset":-3212.7,"unit":"A","SLOT_ID":436},"8587":{"PGN":61716,"PGN_Name":"DC/DC Converter Status 1","PGN_Description":"DCDCS1","first_bit":32,"SPN":8587,"SPN_Name":"DC/DC High Side Voltage","SPN_Description":"Indicates the measured HVES or high side voltage measured at the point of control inside the DC/DC Converter.","bit_length":16,"scaling":0.05,"offset":0,"unit":"V","SLOT_ID":80},"8588":{"PGN":61716,"PGN_Name":"DC/DC Converter Status 1","PGN_Description":"DCDCS1","first_bit":48,"SPN":8588,"SPN_Name":"DC/DC High Side Current","SPN_Description":"Indicates the measured HVES or high side current measured at the point of control inside the DC/DC Converter.  The current is negative if the converter is charging the SLI battery from the hybrid battery.","bit_length":16,"scaling":0.1,"offset":-3212.7,"unit":"A","SLOT_ID":436},"8589":{"PGN":61717,"PGN_Name":"DC/DC Converter SLI Battery Status","PGN_Description":"DCDCSBS","first_bit":0,"SPN":8589,"SPN_Name":"DC/DC SLI Battery Terminal Voltage ","SPN_Description":"Parameter indicating the voltage of the SLI battery as measured at the SLI battery terminals.  ","bit_length":16,"scaling":0.01,"offset":0,"unit":"V","SLOT_ID":221},"8590":{"PGN":61717,"PGN_Name":"DC/DC Converter SLI Battery Status","PGN_Description":"DCDCSBS","first_bit":16,"SPN":8590,"SPN_Name":"DC/DC SLI Battery Terminal Current","SPN_Description":"Parameter indicating the current of the SLI battery as measured at the SLI battery terminals.  \\nThe current is positive if the SLI battery or low side voltage source is being charged from the hybrid battery.","bit_length":16,"scaling":0.1,"offset":-3212.7,"unit":"A","SLOT_ID":436},"8591":{"PGN":61717,"PGN_Name":"DC/DC Converter SLI Battery Status","PGN_Description":"DCDCSBS","first_bit":32,"SPN":8591,"SPN_Name":"DC/DC SLI Battery Terminal Temperature","SPN_Description":"Parameter indicating the temperature of the SLI battery as measured at the SLI battery.  ","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8592":{"PGN":64472,"PGN_Name":"DC/DC Converter Status 3","PGN_Description":"DCDCS3","first_bit":0,"SPN":8592,"SPN_Name":"DC/DC Converter Temperature","SPN_Description":"Parameter indicating the temperature of the DC/DC Converter (e.g, controller, circuit board, enclosure).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8593":{"PGN":64472,"PGN_Name":"DC/DC Converter Status 3","PGN_Description":"DCDCS3","first_bit":8,"SPN":8593,"SPN_Name":"DC/DC Converter Electronic Filter Temperature","SPN_Description":"Parameter indicating the temperature of the electronic components that make up the DC/DC Converter filter.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8594":{"PGN":64472,"PGN_Name":"DC/DC Converter Status 3","PGN_Description":"DCDCS3","first_bit":16,"SPN":8594,"SPN_Name":"DC/DC Power Electronics Temperature","SPN_Description":"Parameter indicating the temperature of the DC/DC Converter power electronics components (e.g, switch or heatsink).","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8595":{"PGN":28928,"PGN_Name":"Configurable Transmit PGNs Command","PGN_Description":"CTPC","first_bit":0,"SPN":8595,"SPN_Name":"Transmit PGNs Commanded Port","SPN_Description":"Identifies the ECU communication port of the target Configurable ECU for this instance of PGN 28928.  The identification of each ECU communication port is ECU specific.  The correlation of ECU communication port to a physical network connection is also ECU specific.  Users of this message need to work with the manufacturer of each target Configurable ECU to understand the communication port assignment for each ECU physical port.\\r\\n\\r\\n0000 \u2013 Current port (Indicates the ECU communication port through which PGN 28928 is received)\\r\\n0001 \u2013 Port 1\\r\\n0010 \u2013 Port 2\\r\\n0011 \u2013 Port 3\\r\\n0100 \u2013 Port 4\\r\\n0101 \u2013 Port 5\\r\\n0110 \u2013 Port 6\\r\\n0111 \u2013 Port 7\\r\\n1000 \u2013 Port 8\\r\\n1001 \u2013 Port 9\\r\\n1010 \u2013 Port 10\\r\\n1011 \u2013 SAE Reserved\\r\\n1100 \u2013 SAE Reserved\\r\\n1101 \u2013 SAE Reserved\\r\\n1110 \u2013 SAE Reserved\\r\\n1111 \u2013 SAE Reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8596":{"PGN":28928,"PGN_Name":"Configurable Transmit PGNs Command","PGN_Description":"CTPC","first_bit":4,"SPN":8596,"SPN_Name":"Transmit PGNs Transaction Mode","SPN_Description":"Identifies the command or action being commanded to the target Configurable ECU of this instance of PGN 28928.\\r\\n\\r\\n0000 \u2013 Request Port Transmit Status \u2013 Identifies the message as a request for the list of configurable transmit PGNs on port the identified in SPN 8595 and their current transmit status.  All bits in SPN 8597 and SPN 8598 shall be set to 1 by the sender and will be ignored by the receiver.\\r\\n\\r\\n0001 \u2013 Configure Port Transmit State - Identifies the message as a request to configure the transmit behaviors of one or more PGNs on port identified in SPN 8595.  SPN 8597 and SPN 8598 are used to specify the PGN and the desired transmit capability of each PGN.  The sender of this message only needs to include PGNs that are to have their transmit capability changed.  PGNs that are not to have their transmit capability changed do not need to be included in this message.\\r\\n\\r\\n0010 \u2013 Cancel Pending Changes \u2013 Identifies the message as a request to cancel all pending PGN transmit changes for any PGNs on port identified in SPN 8595.   All pending changes shall be cleared and no changes will be made.  All bits in SPN 8597 and SPN 8598 shall be set to 1 by the sender and will be ignored by the receiver.\\r\\n\\r\\n0011 \u2013 Global Revert to Default \u2013  Identifies the message as a request to reset the transmit behaviors of all PGNs on the port identified in SPN 8595 to their default settings.    All bits in SPN 8597 and SPN 8598 shall be set to 1 by the sender and will be ignored by the receiver.\\r\\n\\r\\n0100 \u2013  Partial Revert to Default \u2013  Identifies the message as a request to reset the transmit behaviors to their default settings for the specified list of PGNs on the port identified in SPN 8595.   SPN 8598 for these Configurable Transmit PGNs shall be set to 1 and ignored by the receiver.\\r\\n  \\r\\n1011 \u2013 SAE Reserved\\r\\n0101 \u2013 SAE Reserved\\r\\n0110 \u2013 SAE Reserved\\r\\n0111 \u2013 SAE Reserved\\r\\n1000 \u2013 SAE Reserved\\r\\n1001 \u2013 SAE Reserved\\r\\n1010 \u2013 SAE Reserved\\r\\n1011 \u2013 SAE Reserved\\r\\n1100 \u2013 SAE Reserved\\r\\n1101 \u2013 SAE Reserved\\r\\n1110 \u2013 SAE Reserved\\r\\n1111 \u2013 SAE Reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8597":{"PGN":28928,"PGN_Name":"Configurable Transmit PGNs Command","PGN_Description":"CTPC","first_bit":16,"SPN":8597,"SPN_Name":"Commanded Transmit PGN","SPN_Description":"Identifies the PGN to be acted on by the associated SPN 8598.","bit_length":24,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":116},"8598":{"PGN":28928,"PGN_Name":"Configurable Transmit PGNs Command","PGN_Description":"CTPC","first_bit":40,"SPN":8598,"SPN_Name":"Commanded Transmit PGN Requested State","SPN_Description":"Identifies the transmit enable state being commanded for the specified PGN on the port identified in SPN 8595.  This parameter is only valid when SPN 8596 is set to \u2018Configure Port Transmit State\u2019 (1).  For transaction modes where this parameter is not applicable, this parameter shall be set to 1.\\r\\n\\r\\n00 \u2013 PGN shall be disabled for transmit\\r\\n01 \u2013 PGN shall be enabled for transmit\\r\\n10 \u2013 SAE Reserved\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8599":{"PGN":64471,"PGN_Name":"Configurable Transmit PGNs Status","PGN_Description":"CTPS","first_bit":0,"SPN":8599,"SPN_Name":"Transmit PGNs Port","SPN_Description":"Identifies the ECU communications port of the responding Configurable ECU that is in context for this instance of PGN 64471.  If changes are accepted by the Configurable ECU, then this is the port affected.  The identification of each ECU communication port is ECU specific.  The correlation of ECU communication port to a physical network connection is ECU specific.  Users of this message need to work with the manufacturer of the transmitting Configurable ECU to understand the port assignment for each physical port.  Port numbering must be the same between this parameter and SPN 8595 in PGN 28928.\\r\\n\\r\\n0000 \u2013 Current port (Indicates the ECU communication port through which PGN 64471 is transmitted)\\r\\n0001 \u2013 Port 1\\r\\n0010 \u2013 Port 2\\r\\n0011 \u2013 Port 3\\r\\n0100 \u2013 Port 4\\r\\n0101 \u2013 Port 5\\r\\n0110 \u2013 Port 6\\r\\n0111 \u2013 Port 7\\r\\n1000 \u2013 Port 8\\r\\n1001 \u2013 Port 9\\r\\n1010 \u2013 Port 10\\r\\n1011 \u2013 SAE Reserved\\r\\n1100 \u2013 SAE Reserved\\r\\n1101 \u2013 SAE Reserved\\r\\n1110 \u2013 SAE Reserved\\r\\n1111 \u2013 SAE Reserved","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8600":{"PGN":64471,"PGN_Name":"Configurable Transmit PGNs Status","PGN_Description":"CTPS","first_bit":4,"SPN":8600,"SPN_Name":"Transmit PGNs Port Pending Changes Status","SPN_Description":"Indicates if there are any pending transmit changes for the specified ECU communication port. \\r\\n\\r\\n0 \u2013 No pending changes to the transmit status for any supported PGNs for the port identified in SPN 8599.\\r\\n1 \u2013 Transmit changes are pending for one or more supported PGNs on the port identified in SPN 8599.","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8601":{"PGN":64471,"PGN_Name":"Configurable Transmit PGNs Status","PGN_Description":"CTPS","first_bit":5,"SPN":8601,"SPN_Name":"Transmit PGNs Port Command Status","SPN_Description":"Indicates the overall success in performing the commanded transaction in PGN 28928.  \\r\\n\\r\\n000 \u2013 Positive Acknowledgment \u2013 PGN 28928 commanded transaction was processed without issue.\\r\\n001 \u2013 \\tNegative Acknowledgment \u2013 PGN 28928 command was received but one or more transactions were rejected.\\r\\n010 \u2013 No Configurable PGNs exist for the port identified in  SPN 8599.\\r\\n011 \u2013 SAE Reserved\\r\\n100 \u2013 SAE Reserved\\r\\n101 \u2013 SAE Reserved\\r\\n110 \u2013 SAE Reserved\\r\\n111 \u2013 Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8602":{"PGN":64471,"PGN_Name":"Configurable Transmit PGNs Status","PGN_Description":"CTPS","first_bit":16,"SPN":8602,"SPN_Name":"Configurable Transmit PGN","SPN_Description":"Identifies the PGN for which the associated SPNs 8603, 8604, & 8605 apply.","bit_length":24,"scaling":1,"offset":0,"unit":"binary","SLOT_ID":116},"8603":{"PGN":64471,"PGN_Name":"Configurable Transmit PGNs Status","PGN_Description":"CTPS","first_bit":40,"SPN":8603,"SPN_Name":"Configurable Transmit PGN Current Transmit Status","SPN_Description":"Indicates the current transmit status of the associated PGN on the port identified in SPN 8599.\\r\\n\\r\\n00 \u2013 PGN is currently configured for transmit on the port identified in SPN 8599.\\r\\n01 \u2013 PGN is not currently configured for transmit on the port identified in SPN 8599.\\r\\n10 \u2013 The PGN transmit capability cannot be modified.\\r\\n11 \u2013 Not Available","bit_length":1,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":86},"8604":{"PGN":64471,"PGN_Name":"Configurable Transmit PGNs Status","PGN_Description":"CTPS","first_bit":42,"SPN":8604,"SPN_Name":"Configurable Transmit PGN Pending Change Status","SPN_Description":"Indicates if there is a pending change to the transmit capability of the associated PGN on the port identified in SPN 8599.\\r\\n\\r\\n00 \u2013 Pending transmit change to disable for the port identified in SPN 8599.\\r\\n01 \u2013 Pending transmit change to enable for the port identified in SPN 8599.\\r\\n10 \u2013 No pending transmit change for the port identified in SPN 8599.\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8605":{"PGN":64471,"PGN_Name":"Configurable Transmit PGNs Status","PGN_Description":"CTPS","first_bit":44,"SPN":8605,"SPN_Name":"Configurable Transmit PGN Modified Status","SPN_Description":"Indicates if able to honor the transmit status change request issued in the triggering PGN 28928 message for the associated PGN on the port identified in SPN 8595.  This parameter is reported as \'0\' only if the received PGN 28928 requested a transmit behavior change to this PGN and the change could not be honored.\\r\\n\\r\\n00 \u2013 PGN\u2019s transmit status could not be modified\\r\\n01 \u2013 PGN\u2019s transmit status was not requested to be modified\\r\\n10 \u2013 PGN\u2019s transmit status could be modified as requested\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8607":{"PGN":64479,"PGN_Name":"Intake/Exhaust Conditions 3","PGN_Description":"IC3","first_bit":16,"SPN":8607,"SPN_Name":"Engine Mixer 2 Intake Pressure","SPN_Description":"The pressure at the intake of the second air and fuel mixer.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8608":{"PGN":64971,"PGN_Name":"Off-Highway Engine Control Selection","PGN_Description":"OHECS","first_bit":36,"SPN":8608,"SPN_Name":"Engine Operating Mode Command","SPN_Description":"Command signal identifying the desired preconfigured engine operating mode. In some off-highway applications it may be desirable to have multiple preconfigured operating modes available for selection by the operator. Examples would be an economy mode, a ploughing mode or a PTO mode.\\r\\n\\r\\n0000 - Not presently requesting a specific Engine Operating Mode be used\\r\\n0001 - Engine Operating Mode 1 is requested\\r\\n0010 - Engine Operating Mode 2 is requested\\r\\n0011 - Engine Operating Mode 3 is requested\\r\\n0100 - Engine Operating Mode 4 is requested\\r\\n0101 - Engine Operating Mode 5 is requested\\r\\n0110 - Engine Operating Mode 6 is requested\\r\\n0111 - Engine Operating Mode 7 is requested\\r\\n1000 - Engine Operating Mode 8 is requested\\r\\n1001 - Engine Operating Mode 9 is requested\\r\\n1010 - Engine Operating Mode 10 is requested\\r\\n1011 - Engine Operating Mode 11 is requested\\r\\n1100 - Engine Operating Mode 12 is requested\\r\\n1101 - Engine Operating Mode 13 is requested\\r\\n1110 - SAE Reserved\\r\\n1111 - Not available / Take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89},"8611":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":14,"SPN":8611,"SPN_Name":"Water In Charge Air Duct After Charge Air Cooler Indicator","SPN_Description":"Signal which indicates the presence of water in charge air duct after charge air cooler.\\r\\n\\r\\n00 - No\\r\\n01 - Yes\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8612":{"PGN":65279,"PGN_Name":"Operator indicators","PGN_Description":"OI","first_bit":6,"SPN":8612,"SPN_Name":"Engine Overloaded Indicator","SPN_Description":"Signal which indicates that the engine is overloaded.\\r\\n\\r\\n00 - No\\r\\n01 - Yes\\r\\n10 - Error\\r\\n11 - Not available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8613":{"PGN":61690,"PGN_Name":"Electronic Transmission Controller 13","PGN_Description":"ETC13","first_bit":32,"SPN":8613,"SPN_Name":"Source Address of Active or Pending Transmission Requested Gear","SPN_Description":"This parameter indicates the source address of the device whose SPN 525 [Transmission Requested Gear] request is currently being acted upon by the transmission. If transmission response to a device\u2019s SPN 525 request is pending, that device\u2019s source address should be reflected here, even though the pending request may or may not be achieved immediately due to operating conditions. If the transmission does not intend to honor a device\u2019s SPN 525 request, this parameter should not reflect that device\u2019s source address.\\r\\n\\r\\nThis parameter is applicable to specific (e.g. \u201C4\u2019) SPN 525 requests, relative (e.g. \u201CDownshift One Gear\u201D) SPN 525  requests, and other parameter specific indicators defined in SPN 525. For example, if a device has requested the transmission to \u201Cdownshift one gear\u201D, and that shift is pending or the downshift target gear is being actively maintained, this parameter should reflect that device\u2019s source address.\\r\\n\\r\\nWhen there is no active SPN 525 request or the transmission does not intend to honor a device\u2019s SPN 525 request, this parameter may be the source address of the ECU transmitting the message [e.g. SA 03 \u2013 Transmission #1]. For example, this value would be appropriate in an application that has a mechanical shift selector mechanism, and there are currently no active SPN 525 requests to modify the range being specified via the shift linkage. Note that in vehicles with a J1939-based shift selector, this parameter will most often indicate the source address of the active shift selector [e.g. SA 05 \u2013 Primary Shift Console].","bit_length":8,"scaling":1,"offset":0,"unit":"SA","SLOT_ID":35},"8614":{"PGN":34560,"PGN_Name":"Engine State Requests","PGN_Description":"ESR","first_bit":42,"SPN":8614,"SPN_Name":"Engine Shutdown Command","SPN_Description":"Command to shut down the engine. If this parameter is received as 01, then the engine should behave as if the key switch was turned off. An example of how this parameter could be used is an ECU would send 01 for this parameter if the operator depressed a start/stop pushbutton switch to shut down the engine.\\r\\n\\r\\nThis parameter is different from Desired Engine Fueling State (SPN 5793), which is typically associated with automatic engine stop-start functionality that operates during a drive cycle. SPN 8614 would override such functionality, just like turning off the vehicle key switch.\\r\\n\\r\\nThis parameter is also different from Engine Auxiliary Shutdown Switch (SPN 970), which is typically associated with secondary or remote shutdown methods, such as might be used in emergency situations. It is possible that applications would use SPN <NEW> as the primary way of shutting down the engine and use SPN 970 as an alternative way of shutting down the engine.\\r\\n\\r\\n00 - No command to shut down the engine\\r\\n01 - Shut down the engine\\r\\n10 - SAE Reserved\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8619":{"PGN":64470,"PGN_Name":"Electronic Engine Controller 21","PGN_Description":"EEC21","first_bit":0,"SPN":8619,"SPN_Name":"Engine Exhaust Manifold Pressure 1","SPN_Description":"Absolute pressure of the exhaust gasses as measured at the engine exhaust manifold, location 1.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8620":{"PGN":64470,"PGN_Name":"Electronic Engine Controller 21","PGN_Description":"EEC21","first_bit":16,"SPN":8620,"SPN_Name":"Engine Exhaust Manifold Pressure 2","SPN_Description":"Absolute pressure of the exhaust gasses as measured at the engine exhaust manifold, location 2.","bit_length":16,"scaling":0.1,"offset":0,"unit":"kPa","SLOT_ID":85},"8622":{"PGN":65214,"PGN_Name":"Electronic Engine Controller 4","PGN_Description":"EEC4","first_bit":48,"SPN":8622,"SPN_Name":"Engine Prelube Oil Low Pressure Threshold","SPN_Description":"The minimum value that the engine oil pressure (SPN 100 and SPN 7468) must exceed in order to start the engine.\\r\\n\\r\\nThis parameter is intended for applications that have an external means of lubricating the engine before starting the engine.","bit_length":8,"scaling":4,"offset":0,"unit":"kPa","SLOT_ID":47},"8629":{"PGN":64585,"PGN_Name":"Aftertreatment 1 Historical Information 2","PGN_Description":"AT1HI2","first_bit":192,"SPN":8629,"SPN_Name":"Total Aftertreatment Operating Hours","SPN_Description":"Accumulated time of operation of aftertreatment system.  Operating hours are accumulated only when there is air flowing thru the aftertreatment system.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"8630":{"PGN":64523,"PGN_Name":"Electronic Engine Controller 20","PGN_Description":"EEC20","first_bit":16,"SPN":8630,"SPN_Name":"Actual Maximum Available Engine - Percent Fuel","SPN_Description":"The percent of torque limited fuel relative to the engine standard torque fuel.  The torque limited fuel in the Actual Maximum Available Engine - Percent Fuel shall take into consideration all engine torque derates (e.g. fault / event derates, various temperature derates, altitude derates, etc.) that are active in the system and number of known inactive cylinders. This does not take into account the air fuel ratio control (AFC) as it is a smoke limiting device that will naturally increase above the torque limits as the boost increases with engine load.\\r\\n\\r\\nIf there are no active torque derates, this parameter will be transmitted at 100%.","bit_length":8,"scaling":0.4,"offset":0,"unit":"%","SLOT_ID":44},"8635":{"PGN":64469,"PGN_Name":"Aftercooler and Oil Cooler Fluids 2","PGN_Description":"ACOCF2","first_bit":0,"SPN":8635,"SPN_Name":"Alternator Bearing Header Intake Pressure","SPN_Description":"Pressure of the lube oil at the intake of alternator bearing header.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"8636":{"PGN":64469,"PGN_Name":"Aftercooler and Oil Cooler Fluids 2","PGN_Description":"ACOCF2","first_bit":8,"SPN":8636,"SPN_Name":"Alternator Oil Cooler Discharge Pump Pressure","SPN_Description":"Pressure of the lube oil at the alternator oil cooler discharge pump.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"8637":{"PGN":64469,"PGN_Name":"Aftercooler and Oil Cooler Fluids 2","PGN_Description":"ACOCF2","first_bit":16,"SPN":8637,"SPN_Name":"Engine Oil Cooler Discharge Pump Pressure","SPN_Description":"Pressure of the lube oil at engine oil cooler discharge pump.","bit_length":8,"scaling":2,"offset":0,"unit":"kPa","SLOT_ID":53},"8638":{"PGN":64469,"PGN_Name":"Aftercooler and Oil Cooler Fluids 2","PGN_Description":"ACOCF2","first_bit":24,"SPN":8638,"SPN_Name":"Engine Oil Cooler Intake Temperature","SPN_Description":"Temperature of lube oil at engine cooler intake.","bit_length":8,"scaling":1,"offset":-40,"unit":"\xb0C","SLOT_ID":67},"8639":{"PGN":65264,"PGN_Name":"Power Takeoff Information","PGN_Description":"PTO","first_bit":62,"SPN":8639,"SPN_Name":"Engine PTO Governor Disable Switch","SPN_Description":"Customer or body builder installed switch to prevent operation of engine in PTO mode.\\r\\n\\r\\n00 - Off (PTO mode allowed)\\r\\n01 - On (PTO mode is not allowed)\\r\\n10 - Error\\r\\n11 - Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8648":{"PGN":61718,"PGN_Name":"Well Stimulation Pump System 3","PGN_Description":"WSP3","first_bit":0,"SPN":8648,"SPN_Name":"Well Stimulation Pump Rod Load","SPN_Description":"The load on the plungers of the well stimulation pump.","bit_length":16,"scaling":5,"offset":0,"unit":"kN","SLOT_ID":433},"8649":{"PGN":61718,"PGN_Name":"Well Stimulation Pump System 3","PGN_Description":"WSP3","first_bit":16,"SPN":8649,"SPN_Name":"Well Stimulation Pump Cavitation Status","SPN_Description":"Indicates the level of cavitation detected on the well stimulation pump.\\r\\n\\r\\n000 \u2013 No Cavitation\\r\\n001 \u2013 Low\\r\\n010 \u2013 Medium\\r\\n011 \u2013 High\\r\\n100 \u2013 Reserved\\r\\n101 \u2013 Reserved\\r\\n110 \u2013 Error\\r\\n111 \u2013 Not Available","bit_length":3,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":88},"8650":{"PGN":61718,"PGN_Name":"Well Stimulation Pump System 3","PGN_Description":"WSP3","first_bit":24,"SPN":8650,"SPN_Name":"Well Stimulation Pump Flow Rate","SPN_Description":"The amount of fluid that is being pumped by the well stimulation pump.","bit_length":16,"scaling":0.5,"offset":0,"unit":"l/min","SLOT_ID":434},"8651":{"PGN":61718,"PGN_Name":"Well Stimulation Pump System 3","PGN_Description":"WSP3","first_bit":20,"SPN":8651,"SPN_Name":"Well Stimulation Pump Fluid End Valve Leak","SPN_Description":"Indicates the leakage detected in the well stimulation pump fluid end.\\r\\n\\r\\n00 \u2013 No Leak Detected\\r\\n01 \u2013 Leak Detected\\r\\n10 \u2013 Error\\r\\n11 \u2013 Not Available","bit_length":2,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":87},"8652":{"PGN":64468,"PGN_Name":"Well Stimulation Pump System Configuration","PGN_Description":"WSPC","first_bit":0,"SPN":8652,"SPN_Name":"Well Stimulation Pump Plunger Diameter","SPN_Description":"The diameter of the well stimulation pump plungers","bit_length":16,"scaling":1,"offset":0,"unit":"mm","SLOT_ID":231},"8653":{"PGN":64468,"PGN_Name":"Well Stimulation Pump System Configuration","PGN_Description":"WSPC","first_bit":16,"SPN":8653,"SPN_Name":"Well Stimulation Pump Stroke Length","SPN_Description":"The stroke length of the plunger in a well stimulation pump.","bit_length":16,"scaling":1,"offset":0,"unit":"mm","SLOT_ID":231},"8654":{"PGN":64468,"PGN_Name":"Well Stimulation Pump System Configuration","PGN_Description":"WSPC","first_bit":32,"SPN":8654,"SPN_Name":"Well Stimulation Pump Gear Ratio","SPN_Description":"Actual ratio of input shaft speed to output shaft speed.","bit_length":16,"scaling":1,"offset":0,"unit":"Ratio","SLOT_ID":32},"8655":{"PGN":64468,"PGN_Name":"Well Stimulation Pump System Configuration","PGN_Description":"WSPC","first_bit":48,"SPN":8655,"SPN_Name":"Well Stimulation Pump Rated Speed","SPN_Description":"The rated speed of the well stimulation pump.","bit_length":16,"scaling":0.125,"offset":0,"unit":"rpm","SLOT_ID":76},"8656":{"PGN":64467,"PGN_Name":"Well Stimulation Pump System Lifetime Totals","PGN_Description":"WSPT","first_bit":0,"SPN":8656,"SPN_Name":"Well Stimulation Pump Fluid End Working Hours","SPN_Description":"The accumulated time of operation of the fluid end of the pump while under operating conditions.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"8657":{"PGN":64467,"PGN_Name":"Well Stimulation Pump System Lifetime Totals","PGN_Description":"WSPT","first_bit":32,"SPN":8657,"SPN_Name":"Well Stimulation Pump Power End Working Hours","SPN_Description":"The accumulated time of operation of the power end of the pump while under operating conditions.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"8658":{"PGN":64467,"PGN_Name":"Well Stimulation Pump System Lifetime Totals","PGN_Description":"WSPT","first_bit":64,"SPN":8658,"SPN_Name":"Well Stimulation Pump Working Hours","SPN_Description":"The accumulated amount of time the Well Stimulation Pump has spent working.","bit_length":32,"scaling":1,"offset":0,"unit":"s","SLOT_ID":6},"8659":{"PGN":64467,"PGN_Name":"Well Stimulation Pump System Lifetime Totals","PGN_Description":"WSPT","first_bit":96,"SPN":8659,"SPN_Name":"Well Stimulation Pump Cycle Count","SPN_Description":"The total number of cycles on the well stimulation pump. A cycle is defined as a working stage from start to finish.","bit_length":32,"scaling":1,"offset":0,"unit":"count","SLOT_ID":340},"8660":{"PGN":64466,"PGN_Name":"Pump Oil Message","PGN_Description":"POM","first_bit":0,"SPN":8660,"SPN_Name":"Well Stimulation Pump Oil Viscosity","SPN_Description":"Dynamic viscosity of the well stimulation pump oil.","bit_length":16,"scaling":0.015625,"offset":0,"unit":"Cp","SLOT_ID":301},"8661":{"PGN":64466,"PGN_Name":"Pump Oil Message","PGN_Description":"POM","first_bit":16,"SPN":8661,"SPN_Name":"Well Stimulation Pump Oil Density","SPN_Description":"Density of the well stimulation pump oil.","bit_length":16,"scaling":0.00003052,"offset":0,"unit":"g/cc","SLOT_ID":302},"8662":{"PGN":64466,"PGN_Name":"Pump Oil Message","PGN_Description":"POM","first_bit":32,"SPN":8662,"SPN_Name":"Well Stimulation Pump Oil Relative Dielectricity","SPN_Description":"Well stimulation pump oil relative dielectricity used to describe the well stimulation pump oil quality.","bit_length":16,"scaling":0.0001220703125,"offset":0,"unit":null,"SLOT_ID":307},"8663":{"PGN":64466,"PGN_Name":"Pump Oil Message","PGN_Description":"POM","first_bit":48,"SPN":8663,"SPN_Name":"Well Stimulation Pump Oil Temperature","SPN_Description":"Temperature of the well stimulation pump lubricant.","bit_length":16,"scaling":0.03125,"offset":-273,"unit":"\xb0C","SLOT_ID":68},"8664":{"PGN":64967,"PGN_Name":"Off-Highway Engine Control Selection States","PGN_Description":"OHCSS","first_bit":36,"SPN":8664,"SPN_Name":"Engine Operating Mode Selection","SPN_Description":"Identifies the current engine operating mode. In some off-highway applications it may be desirable to have multiple preconfigured operating modes available for selection by the operator. Examples would be an economy mode, a plowing mode or a PTO mode. \\r\\n\\r\\n0000 - Engine not operating in a specific Engine Operating Mode\\r\\n0001 - Engine Operating Mode 1 is selected\\r\\n0010 - Engine Operating Mode 2 is selected\\r\\n0011 - Engine Operating Mode 3 is selected\\r\\n0100 - Engine Operating Mode 4 is selected\\r\\n0101 - Engine Operating Mode 5 is selected\\r\\n0110 - Engine Operating Mode 6 is selected\\r\\n0111 - Engine Operating Mode 7 is selected\\r\\n1000 - Engine Operating Mode 8 is selected\\r\\n1001 - Engine Operating Mode 9 is selected\\r\\n1010 - Engine Operating Mode 10 is selected\\r\\n1011 - Engine Operating Mode 11 is selected\\r\\n1100 - Engine Operating Mode 12 is selected\\r\\n1101 - Engine Operating Mode 13 is selected\\r\\n1110 - Error\\r\\n1111 - Not available / Take no action","bit_length":4,"scaling":1,"offset":0,"unit":"bit","SLOT_ID":89}}');

},{}],"5zTZ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class DM1FaultsConstants {
    constructor(){
        this.listFMIname = [
            "Above Normal Range, Most Severe Level",
            "Below Normal Range, Most Severe Level",
            "Erratic, Intermittent or Incorrect (rationality)",
            "Voltage Above Normal or Shorted High",
            "Voltage Below Normal, or Shorted to Ground",
            "Current Below Normal, or Open Circuit",
            "Current Above Normal, or Grounded Circuit",
            "Mechanical System not Responding or Out of Adjustment",
            "Abnormal Frequency or Pulse Width or Period",
            "Abnormal Update Rate",
            "Abnormal Rate of Change",
            "Failure Code not Identifiable",
            "Bad Intelligent Device or Component",
            "Out of Calibration",
            "Special Instructions",
            "Above Normal Range : Least Severe Level",
            "Above Normal Range: Moderately Severe Level",
            "Below Normal Range: Least Severe Level",
            "Below Normal Range: Moderately Severe Level",
            "Received Network Data in Error: (Multiplexed Data)",
            "Data Drifted High (rationality high)",
            "Data Drifted Low (rationality low)",
            "reserved (22)",
            "reserved (23)",
            "reserved (24)",
            "reserved (25)",
            "reserved (26)",
            "reserved (27)",
            "reserved (28)",
            "reserved (29)",
            "reserved (30)",
            "Condition Exists"
        ];
        this.listSourceAddress = [
            "Engine #1",
            "Engine #2",
            "Turbocharger",
            "Transmission #1",
            "Transmission #2",
            "Shift Console - Primary",
            "Shift Console - Secondary",
            "Power TakeOff - (Main or Rear)",
            "Axle - Steering",
            "Axle - Drive #1",
            "Axle - Drive #2",
            "Brakes - System Controller",
            "Brakes - Steer Axle",
            "Brakes - Drive axle #1",
            "Brakes - Drive Axle #2",
            "Retarder - Engine",
            "Retarder - Driveline",
            "Cruise Control",
            "Fuel System",
            "Steering Controller",
            "Suspension - Steer Axle",
            "Suspension - Drive Axle #1",
            "Suspension - Drive Axle #2",
            "Instrument Cluster #1",
            "Trip Recorder",
            "Passenger-Operator Climate Control #1",
            "Alternator/Electrical Charging System",
            "Aerodynamic Control",
            "Vehicle Navigation",
            "Vehicle Security",
            "Electrical System",
            "Starter System",
            "Tractor-Trailer Bridge #1",
            "Body Controller",
            "Auxiliary Valve Control or Engine Air System Valve Control",
            "Hitch Control",
            "Power TakeOff (Front or Secondary)",
            "Off Vehicle Gateway",
            "Virtual Terminal (in cab)",
            "Management Computer #1",
            "Cab Display #1",
            "Retarder, Exhaust, Engine #1",
            "Headway Controller",
            "On-Board Diagnostic Unit",
            "Retarder, Exhaust, Engine #2",
            "Endurance Braking System",
            "Hydraulic Pump Controller",
            "Suspension - System Controller #1",
            "Pneumatic - System Controller",
            "Cab Controller - Primary",
            "Cab Controller - Secondary",
            "Tire Pressure Controller",
            "Ignition Control Module #1",
            "Ignition Control Module #2",
            "Seat Control #1",
            "Lighting - Operator Controls",
            "Rear Axle Steering Controller #1",
            "Water Pump Controller",
            "Passenger-Operator Climate Control #2",
            "Transmission Display - Primary",
            "Transmission Display - Secondary",
            "Exhaust Emission Controller",
            "Vehicle Dynamic Stability Controller",
            "Oil Sensor",
            "Suspension - System Controller #2",
            "Information System Controller #1",
            "Ramp Control",
            "Clutch/Converter Unit",
            "Auxiliary Heater #1",
            "Auxiliary Heater #2",
            "Engine Valve Controller",
            "Chassis Controller #1",
            "Chassis Controller #2",
            "Propulsion Battery Charger",
            "Communications Unit, Cellular",
            "Communications Unit, Satellite",
            "Communications Unit, Radio",
            "Steering Column Unit",
            "Fan Drive Controller",
            "Seat Control #2",
            "Parking brake controller",
            "Aftertreatment #1 system gas intake",
            "Aftertreatment #1 system gas outlet",
            "Safety Restraint System",
            "Cab Display #2",
            "Diesel Particulate Filter Controller",
            "Aftertreatment #2 system gas intake",
            "Aftertreatment #2 system gas outlet",
            "Safety Restraint System #2",
            "Atmospheric Sensor",
            "Powertrain Control Module",
            "Power Systems Manager",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Manufacturer Reserved SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "Unknown SA",
            "File Server / Printer",
            "Off Board Diagnostic-Service Tool #1",
            "Off Board Diagnostic-Service Tool #2",
            "On-Board Data Logger",
            "Reserved for Experimental Use",
            "Reserved for OEM",
            "Null Address",
            "GLOBAL (All-Any Node)"
        ];
    }
}
exports.default = DM1FaultsConstants;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kzvBX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _alertsTableHeader = require("./AlertsTableHeader");
var _alertsTableHeaderDefault = parcelHelpers.interopDefault(_alertsTableHeader);
var _dmAlertsTableHeader = require("./DmAlertsTableHeader");
var _dmAlertsTableHeaderDefault = parcelHelpers.interopDefault(_dmAlertsTableHeader);
var _alertsTableBody = require("./AlertsTableBody");
var _alertsTableBodyDefault = parcelHelpers.interopDefault(_alertsTableBody);
var _dmAlertsTableBody = require("./DmAlertsTableBody");
var _dmAlertsTableBodyDefault = parcelHelpers.interopDefault(_dmAlertsTableBody);
var _noDataIndication = require("../NoDataIndication");
function AlertAndDmTable(props) {
    const { assetView, data, dataLoading, handleRuleLinkClick, includeChildren, orgIdFilter, selectedStatus, tab, toggleClearAlertModalClick } = props;
    const renderTableBody = (0, _react.useMemo)(()=>!dataLoading && data?.length, [
        data?.length,
        dataLoading
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "d-none d-lg-block table-responsive-lg w-100 mx-lg-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    className: "table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: {
                                alerts: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertsTableHeaderDefault.default), {
                                    ...props
                                }),
                                dm1: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dmAlertsTableHeaderDefault.default), {
                                    ...props
                                })
                            }[tab]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            children: renderTableBody ? ({
                                alerts: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertsTableBodyDefault.default), {
                                    assetView: assetView,
                                    data: data,
                                    handleRuleLinkClick: handleRuleLinkClick,
                                    includeChildren: includeChildren,
                                    orgIdFilter: orgIdFilter,
                                    selectedStatus: selectedStatus,
                                    toggleClearAlertModalClick: toggleClearAlertModalClick
                                }),
                                dm1: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dmAlertsTableBodyDefault.default), {
                                    assetView: assetView,
                                    data: data
                                })
                            })[tab] : null
                        })
                    ]
                })
            }),
            (()=>{
                switch(true){
                    case dataLoading:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "h-75 w-100 d-flex align-items-center justify-content-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {})
                        });
                    case !data?.length:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "h-75 w-100 d-flex flex-column align-items-center justify-content-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faBellSlash),
                                    className: "text-brand-primary mb-3",
                                    size: "5x"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                    className: "text-brand-primary",
                                    children: [
                                        "No recent ",
                                        tab === "alerts" ? "alerts" : "DM1 faults",
                                        "!"
                                    ]
                                })
                            ]
                        });
                    default:
                        return null;
                }
            })()
        ]
    });
}
AlertAndDmTable.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    }),
    assetView: (0, _propTypesDefault.default).bool,
    children: (0, _propTypesDefault.default).bool,
    currentOrg: (0, _propTypesDefault.default).object,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    dataLoading: (0, _propTypesDefault.default).bool,
    handleAssetSelected: (0, _propTypesDefault.default).func,
    handleDmFilterSelected: (0, _propTypesDefault.default).func,
    handleOrgSelected: (0, _propTypesDefault.default).func,
    handleRuleLinkClick: (0, _propTypesDefault.default).func,
    handleRuleSelected: (0, _propTypesDefault.default).func,
    handleSortClick: (0, _propTypesDefault.default).func,
    handleStatusSelected: (0, _propTypesDefault.default).func,
    includeChildren: (0, _propTypesDefault.default).bool,
    orgIdFilter: (0, _propTypesDefault.default).string,
    selectedStatus: (0, _propTypesDefault.default).oneOf([
        "positive",
        "negative",
        "all"
    ]),
    setDmExport: (0, _propTypesDefault.default).func,
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "TriggeredAt",
            "DetectedAt"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "ASC",
            "DESC"
        ])
    }),
    tab: (0, _propTypesDefault.default).oneOf([
        "alerts",
        "dm1"
    ]),
    toggleClearAlertModalClick: (0, _propTypesDefault.default).func
};
exports.default = /*#__PURE__*/ (0, _react.memo)(AlertAndDmTable);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./AlertsTableHeader":"hWIg9","./DmAlertsTableHeader":"cl16h","./AlertsTableBody":"0tJ32","./DmAlertsTableBody":"acZMN","../NoDataIndication":"clGpp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hWIg9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _searchByNameDropdown = require("./SearchByNameDropdown");
var _searchByNameDropdownDefault = parcelHelpers.interopDefault(_searchByNameDropdown);
var _searchByOrgDropdown = require("./SearchByOrgDropdown");
var _searchByOrgDropdownDefault = parcelHelpers.interopDefault(_searchByOrgDropdown);
var _sortByDateButton = require("./SortByDateButton");
var _sortByDateButtonDefault = parcelHelpers.interopDefault(_sortByDateButton);
var _statusSelectDropdown = require("./StatusSelectDropdown");
var _statusSelectDropdownDefault = parcelHelpers.interopDefault(_statusSelectDropdown);
function AlertsTableHeader({ asset, assetView, handleAssetSelected, handleEcosystemToggle, handleOrgSelected, handleRuleSelected, handleSortClick, handleStatusSelected, includeChildren, orgIdFilter, selectedStatus, sort }) {
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    const orgID = (0, _react.useMemo)(()=>assetView ? asset?.orgID : orgIdFilter || currentOrg?._id, [
        assetView,
        asset?.orgID,
        currentOrg?._id,
        orgIdFilter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "col-status sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusSelectDropdownDefault.default), {
                    selectedStatus: selectedStatus,
                    handleStatusSelected: handleStatusSelected
                })
            }),
            assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 w-25 sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByNameDropdownDefault.default), {
                    handleAssetSelected: handleAssetSelected,
                    includeChildren: includeChildren,
                    orgID: orgID,
                    orgIdFilter: orgIdFilter,
                    resource: "Asset"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 w-25 sticky-top bg-white col-rule-name border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByNameDropdownDefault.default), {
                    assetView: assetView,
                    handleRuleSelected: handleRuleSelected,
                    includeChildren: includeChildren,
                    orgID: orgID,
                    orgIdFilter: orgIdFilter,
                    resource: "Rule"
                })
            }),
            assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 w-25 sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByOrgDropdownDefault.default), {
                    handleEcosystemToggle: handleEcosystemToggle,
                    handleOrgSelected: handleOrgSelected,
                    includeChildren: includeChildren,
                    orgID: orgID,
                    orgIdFilter: orgIdFilter
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "col-date text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sortByDateButtonDefault.default), {
                    displayText: "Detected At",
                    sort: sort,
                    handleSortClick: handleSortClick
                })
            }),
            selectedStatus === "positive" ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "col-date text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sortByDateButtonDefault.default), {
                    displayText: "Resolved",
                    sort: sort,
                    handleSortClick: handleSortClick
                })
            }),
            [
                "Conditions",
                "Location"
            ].map((h)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                    scope: "col",
                    className: `text-left text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0 col-${h.toLowerCase()}`,
                    children: h
                }, h))
        ]
    });
}
AlertsTableHeader.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    }),
    assetView: (0, _propTypesDefault.default).bool,
    handleAssetSelected: (0, _propTypesDefault.default).func,
    handleEcosystemToggle: (0, _propTypesDefault.default).func,
    handleOrgSelected: (0, _propTypesDefault.default).func,
    handleRuleSelected: (0, _propTypesDefault.default).func,
    handleSortClick: (0, _propTypesDefault.default).func,
    handleStatusSelected: (0, _propTypesDefault.default).func,
    includeChildren: (0, _propTypesDefault.default).bool,
    orgIdFilter: (0, _propTypesDefault.default).string,
    selectedStatus: (0, _propTypesDefault.default).oneOf([
        "positive",
        "negative",
        "all"
    ]),
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "TriggeredAt",
            "DetectedAt"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "ASC",
            "DESC"
        ])
    }),
    tab: (0, _propTypesDefault.default).oneOf([
        "alerts",
        "dm1"
    ])
};
exports.default = /*#__PURE__*/ (0, _react.memo)(AlertsTableHeader);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","../../Context/CurrentOrgContext":"jQXcJ","./SearchByNameDropdown":"dFb3a","./SearchByOrgDropdown":"h1xko","./SortByDateButton":"iJ4WN","./StatusSelectDropdown":"8UkgS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFb3a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchByNameDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _reactSelect = require("react-select");
var _debouncePromise = require("debounce-promise");
var _debouncePromiseDefault = parcelHelpers.interopDefault(_debouncePromise);
var _axios = require("axios");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _ruleService = require("../../Services/RuleService");
var _ruleServiceDefault = parcelHelpers.interopDefault(_ruleService);
const DropdownIndicator = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).DropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            icon: (0, _freeSolidSvgIcons.faCaretDown),
            className: "text-muted",
            size: "xs"
        })
    });
function SearchByNameDropdown({ assetView, handleAssetSelected, handleRuleSelected, includeChildren, mobileView, orgID, orgIdFilter, resource }) {
    const [error, setError] = (0, _react.useState)("");
    const [requestLoading, setRequestLoading] = (0, _react.useState)(false);
    const orgIdToUse = (0, _react.useMemo)(()=>assetView ? orgID : orgIdFilter || orgID, [
        assetView,
        orgID,
        orgIdFilter
    ]);
    const service = (0, _react.useMemo)(()=>resource === "Asset" ? new (0, _assetServiceDefault.default)() : new (0, _ruleServiceDefault.default)(), [
        resource
    ]);
    let source = (0, _axios.CancelToken).source();
    const fetchAssets = async (q)=>{
        try {
            setRequestLoading(true);
            setError("");
            const params = {
                children: includeChildren ?? false,
                limit: 50,
                order: "ASC",
                orgID: orgIdToUse,
                q,
                sort: "nickname"
            };
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const { data } = await service.searchAssets(params, source.token);
            setRequestLoading(false);
            return data.map(({ _id, nickname, orgID: gatewayOrgID })=>({
                    label: nickname,
                    orgIdFilter: gatewayOrgID,
                    value: _id
                }));
        } catch (err) {
            setRequestLoading(false);
            if ((0, _axios.isCancel)(err)) return;
            const message = err.response?.data?.message ?? err.message;
            setError(message);
        }
    };
    const fetchRules = async (q)=>{
        try {
            setRequestLoading(true);
            setError("");
            const params = {
                children: includeChildren ?? false,
                orgID: orgIdToUse,
                orgIdFilter: orgIdToUse,
                limit: 50,
                searchByName: q
            };
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const { Rules } = await service.fetchPaginatedRules(params, source.token);
            setRequestLoading(false);
            return Array.isArray(Rules) ? Rules.map(({ Id, Name })=>{
                return {
                    value: Id,
                    label: Name
                };
            }) : [];
        } catch (err) {
            setRequestLoading(false);
            if ((0, _axios.isCancel)(err)) return;
            const message = err.response?.data?.message ?? err.message;
            setError(message);
        }
    };
    const optionalBorder = mobileView ? {
        borderColor: "#dee2e6 !important"
    } : {
        border: "none"
    };
    const mobileControlStyles = mobileView ? {
        height: "30px",
        minHeight: "30px"
    } : {};
    const mobileValueContainerStyles = mobileView ? {
        height: "30px",
        minHeight: "30px",
        position: "static",
        lineHeight: "0.75rem"
    } : {};
    const mobileIndicatorContainerStyles = mobileView ? {
        paddingTop: "0.25rem",
        paddingRight: "0.4rem"
    } : {};
    const selectStyles = {
        placeholder: (base)=>({
                ...base,
                fontWeight: mobileView ? "lighter" : "normal",
                fontSize: "0.75rem",
                color: "var(--text-gray)"
            }),
        control: (base)=>({
                ...base,
                ...optionalBorder,
                ...mobileControlStyles,
                outline: "none",
                boxShadow: "none"
            }),
        indicatorSeparator: (base)=>({
                ...base,
                visibility: "hidden"
            }),
        dropdownIndicator: (base)=>({
                ...base,
                ...mobileIndicatorContainerStyles
            }),
        valueContainer: (base)=>({
                ...base,
                ...mobileValueContainerStyles
            }),
        input: (base)=>({
                ...base,
                ...mobileValueContainerStyles
            })
    };
    const placeholder = mobileView ? "Search for an asset" : resource;
    const mobileComponents = mobileView ? {
        DropdownIndicator
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
        components: {
            ...mobileComponents
        },
        isClearable: true,
        isLoading: requestLoading,
        loadOptions: (0, _debouncePromiseDefault.default)(resource === "Asset" ? fetchAssets : fetchRules, 1000),
        noOptionsMessage: ()=>`Search by ${resource} name...`,
        onChange: (selected)=>resource === "Asset" ? handleAssetSelected(selected, mobileView) : handleRuleSelected(selected, mobileView),
        placeholder: error || placeholder,
        styles: selectStyles
    });
}
SearchByNameDropdown.propTypes = {
    assetView: (0, _propTypesDefault.default).bool,
    handleAssetSelected: (0, _propTypesDefault.default).func,
    handleRuleSelected: (0, _propTypesDefault.default).func,
    includeChildren: (0, _propTypesDefault.default).bool,
    mobileView: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    orgIdFilter: (0, _propTypesDefault.default).string,
    resource: (0, _propTypesDefault.default).oneOf([
        "Asset",
        "Rule"
    ])
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-select/async":"iHFh7","react-select":"j36cq","debounce-promise":"fqOKC","axios":"ffpgq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Services/AssetService":"fL096","../../Services/RuleService":"iS4KH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iS4KH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _authService = require("./AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class RuleService {
    auth = new (0, _authServiceDefault.default)();
    api = new (0, _requestsDefault.default)();
    buildRuleCountForOrgRequest(orgID, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/metrics/rules",
            method: "get",
            params: {
                orgID,
                orgIdFilter: orgID
            },
            cancelToken
        };
    }
    async fetchRuleCountForOrg(orgID = this.auth.getCurrentOrgID(), cancelToken) {
        const { data = {} } = await this.api.request(this.buildRuleCountForOrgRequest(orgID, cancelToken));
        return data;
    }
    buildTemplateRulesRequest(templateID, orgID = this.auth.getCurrentOrgID(), cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/metrics/rules",
            method: "get",
            params: {
                orgID,
                type: "template",
                sourceIdFilter: templateID
            },
            cancelToken
        };
    }
    async getTemplateRules(templateID, orgID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildTemplateRulesRequest(templateID, orgID, cancelToken));
        return data;
    }
    buildRulesMetricsRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/metrics/rules",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchRulesMetrics(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildRulesMetricsRequest(params, cancelToken));
        return data;
    }
    buildPaginatedRulesRequest(params, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/rules",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchPaginatedRules(params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildPaginatedRulesRequest(params, cancelToken));
        return data;
    }
    buildCreateRuleRequest(params, data, cancelToken) {
        return {
            service: "rules",
            endpoint: "/v1/rules",
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async createRule(params, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildCreateRuleRequest(params, body, cancelToken));
        return data;
    }
    buildUpdateRuleRequest(ruleID, params, data, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/rules/${ruleID}`,
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async updateRule(ruleID, params, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildUpdateRuleRequest(ruleID, params, body, cancelToken));
        return data;
    }
    buildDeleteRuleRequest(ruleID, params, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/rules/${ruleID}`,
            method: "delete",
            params,
            cancelToken
        };
    }
    async deleteRule(ruleID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteRuleRequest(ruleID, params, cancelToken));
        return data;
    }
    buildFetchRuleRequest(ruleID, params, cancelToken) {
        return {
            service: "rules",
            endpoint: `/v1/rules/${ruleID}`,
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchRule(ruleID, params, cancelToken) {
        const { data = {} } = await this.api.request(this.buildFetchRuleRequest(ruleID, params, cancelToken));
        return data;
    }
}
exports.default = RuleService;

},{"./AuthService":"8Bjjn","../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h1xko":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
const DropdownIndicator = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).DropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            icon: (0, _freeSolidSvgIcons.faCaretDown),
            className: "text-muted",
            size: "xs"
        })
    });
const Menu = (props)=>{
    const { selectProps: { handleEcosystemToggle, includeChildren, mobileView } } = props;
    const handleToggle = (0, _react.useCallback)(()=>{
        handleEcosystemToggle(mobileView);
    }, [
        handleEcosystemToggle,
        mobileView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactSelect.components).Menu, {
        ...props,
        children: [
            props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                className: "mb-0 mt-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.FormGroup), {
                    check: true,
                    className: "p-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Label), {
                        check: true,
                        className: "d-flex align-items-center",
                        htmlFor: "ecosystem-checkbox",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                                checked: includeChildren,
                                className: "eight-tenth-text m-0 position-static",
                                id: "ecosystem-checkbox",
                                onChange: handleToggle,
                                style: {
                                    cursor: "pointer"
                                },
                                type: "checkbox"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "ml-1",
                                children: "Show Ecosystem Events"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Menu.propTypes = {
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node)
    ]),
    selectProps: (0, _propTypesDefault.default).shape({
        handleEcosystemToggle: (0, _propTypesDefault.default).func,
        includeChildren: (0, _propTypesDefault.default).bool,
        mobileView: (0, _propTypesDefault.default).bool
    })
};
exports.default = /*#__PURE__*/ (0, _react.memo)(SearchByOrgDropdown);
function SearchByOrgDropdown({ handleEcosystemToggle, handleOrgSelected, includeChildren, mobileView, orgID, orgIdFilter }) {
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const conditionalMaxMenuHeight = (0, _react.useMemo)(()=>mobileView ? {
            maxMenuHeight: 200
        } : {}, [
        mobileView
    ]), desktopComponents = (0, _react.useMemo)(()=>mobileView ? {} : {
            Menu
        }, [
        mobileView
    ]), mobileComponents = (0, _react.useMemo)(()=>mobileView ? {
            DropdownIndicator
        } : {}, [
        mobileView
    ]), mobileControlStyles = (0, _react.useMemo)(()=>mobileView ? {
            height: "30px",
            minHeight: "30px"
        } : {}, [
        mobileView
    ]), mobileIndicatorContainerStyles = (0, _react.useMemo)(()=>mobileView ? {
            paddingTop: "0.25rem",
            paddingRight: "0.4rem"
        } : {}, [
        mobileView
    ]), mobileValueContainerStyles = (0, _react.useMemo)(()=>mobileView ? {
            height: "30px",
            minHeight: "30px",
            position: "static",
            lineHeight: "0.75rem"
        } : {}, [
        mobileView
    ]), optionalBorder = (0, _react.useMemo)(()=>mobileView ? {
            borderColor: "#dee2e6 !important"
        } : {
            border: "none"
        }, [
        mobileView
    ]), options = (0, _react.useMemo)(()=>Object.entries(orgsMap).map(([id, org])=>({
                label: org.name,
                value: id
            })).sort((a, b)=>a?.label?.localeCompare?.(b?.label)), [
        orgsMap
    ]), selectStyles = (0, _react.useMemo)(()=>({
            control: (base)=>({
                    ...base,
                    ...optionalBorder,
                    ...mobileControlStyles,
                    outline: "none",
                    boxShadow: "none"
                }),
            dropdownIndicator: (base)=>({
                    ...base,
                    ...mobileIndicatorContainerStyles
                }),
            indicatorSeparator: (base)=>({
                    ...base,
                    visibility: "hidden"
                }),
            input: (base)=>({
                    ...base,
                    ...mobileValueContainerStyles
                }),
            placeholder: (base)=>({
                    ...base,
                    fontWeight: mobileView ? "lighter" : "normal",
                    fontSize: "0.75rem",
                    color: "var(--text-gray)"
                }),
            valueContainer: (base)=>({
                    ...base,
                    ...mobileValueContainerStyles
                })
        }), [
        mobileControlStyles,
        mobileIndicatorContainerStyles,
        mobileValueContainerStyles,
        mobileView,
        optionalBorder
    ]), value = (0, _react.useMemo)(()=>options.find(({ value })=>value === (orgIdFilter || orgID)), [
        options,
        orgID,
        orgIdFilter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
        ...conditionalMaxMenuHeight,
        components: {
            ...desktopComponents,
            ...mobileComponents
        },
        handleEcosystemToggle: handleEcosystemToggle,
        includeChildren: includeChildren,
        isClearable: true,
        mobileView: mobileView,
        noOptionsMessage: ()=>`Search by organization name...`,
        onChange: (selected)=>handleOrgSelected(selected, mobileView),
        options: options,
        placeholder: "Search by Organization",
        styles: selectStyles,
        value: value
    });
}
SearchByOrgDropdown.propTypes = {
    handleEcosystemToggle: (0, _propTypesDefault.default).func,
    handleOrgSelected: (0, _propTypesDefault.default).func,
    includeChildren: (0, _propTypesDefault.default).bool,
    mobileView: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    orgIdFilter: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-select":"j36cq","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Context/OrgsMapContext":"asozp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJ4WN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const DISPLAY_MAP = new Map([
    [
        "Detected At",
        "DetectedAt"
    ],
    [
        "Resolved",
        "TriggeredAt"
    ]
]);
function SortByDateButton({ displayText, sort, handleSortClick }) {
    const isActiveSort = DISPLAY_MAP.get(displayText) === sort.by;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: "btn btn-link text-decoration-none three-quarter-text text-text-light-gray d-flex align-items-center justify-content-between p-0 w-100",
        onClick: ()=>handleSortClick(DISPLAY_MAP.get(displayText)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: displayText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: [
                    [
                        (0, _freeSolidSvgIcons.faLongArrowAltUp),
                        "ASC"
                    ],
                    [
                        (0, _freeSolidSvgIcons.faLongArrowAltDown),
                        "DESC"
                    ]
                ].map(([icon, sortDir])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: icon,
                        className: isActiveSort && sort.direction === sortDir ? "text-text-light-gray font-weight-normal" : "text-icon-link-gray font-weight-light",
                        style: {
                            margin: "0 0.1rem"
                        }
                    }, sortDir))
            })
        ]
    });
}
SortByDateButton.propTypes = {
    displayText: (0, _propTypesDefault.default).oneOf([
        "Detected At",
        "Duration",
        "Resolved"
    ]),
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "TriggeredAt",
            "DetectedAt"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "ASC",
            "DESC"
        ])
    }),
    handleSortClick: (0, _propTypesDefault.default).func
};
SortByDateButton.defaultProps = {
    sort: {}
};
exports.default = /*#__PURE__*/ (0, _react.memo)(SortByDateButton);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UkgS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StatusSelectDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
const { className, styles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "534273760",
        children: "div.jsx-534273760{min-width:unset;}"
    }),
    className: "jsx-534273760"
};
const STATUS_OPTIONS = [
    {
        display: "Active",
        status: "positive"
    },
    {
        display: "Inactive",
        status: "negative"
    },
    {
        display: "All",
        status: "all"
    }
];
const DISPLAY_MAP = new Map([
    [
        "positive",
        "Active"
    ],
    [
        "negative",
        "Inactive"
    ],
    [
        "all",
        "All"
    ]
]);
function StatusSelectDropdown({ selectedStatus, handleStatusSelected, mobileView }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.UncontrolledDropdown), {
        className: mobileView ? "border rounded" : "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownToggle), {
                caret: true,
                className: `text-decoration-none text-text-light-gray d-flex align-items-center justify-content-between ${mobileView ? "p-1 w-100" : "p-0"}`,
                color: "link",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-capitalize three-quarter-text",
                    children: DISPLAY_MAP.get(selectedStatus)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.DropdownMenu), {
                className: `${className} rounded-lg ${mobileView ? "w-100" : ""}`,
                children: [
                    STATUS_OPTIONS.map(({ status, display })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.DropdownItem), {
                            className: "three-quarter-text px-3",
                            onClick: ()=>handleStatusSelected(status, mobileView),
                            children: display
                        }, status)),
                    styles
                ]
            })
        ]
    });
}
StatusSelectDropdown.propTypes = {
    selectedStatus: (0, _propTypesDefault.default).oneOf(STATUS_OPTIONS.map(({ status })=>status)),
    handleStatusSelected: (0, _propTypesDefault.default).func,
    mobileView: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cl16h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _dm1Service = require("../../Services/DM1Service");
var _dm1ServiceDefault = parcelHelpers.interopDefault(_dm1Service);
var _dm1FaultsConstants = require("../../Lib/DM1FaultsConstants");
var _dm1FaultsConstantsDefault = parcelHelpers.interopDefault(_dm1FaultsConstants);
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _dmAlertsFiltersDropdown = require("./DmAlertsFiltersDropdown");
var _dmAlertsFiltersDropdownDefault = parcelHelpers.interopDefault(_dmAlertsFiltersDropdown);
var _searchByNameDropdown = require("./SearchByNameDropdown");
var _searchByNameDropdownDefault = parcelHelpers.interopDefault(_searchByNameDropdown);
var _searchByOrgDropdown = require("./SearchByOrgDropdown");
var _searchByOrgDropdownDefault = parcelHelpers.interopDefault(_searchByOrgDropdown);
var _sortByDateButton = require("./SortByDateButton");
var _sortByDateButtonDefault = parcelHelpers.interopDefault(_sortByDateButton);
var _statusSelectDropdown = require("./StatusSelectDropdown");
var _statusSelectDropdownDefault = parcelHelpers.interopDefault(_statusSelectDropdown);
const { listSourceAddress } = new (0, _dm1FaultsConstantsDefault.default)();
const initState = {
    SPN: [],
    FMI: [],
    Source: []
};
const FILTER_HEADERS = [
    {
        displayText: "SPN",
        filter: "spn"
    },
    {
        displayText: "FMI",
        filter: "fmi"
    },
    {
        displayText: "Source",
        filter: "sa"
    },
    {
        displayText: "CAN",
        filter: "canbus"
    }
];
function DmAlertsTableHeader(props) {
    const { asset: { _id: gatewayIdFilter, orgID: assetOrgID } = {}, assetView, engineAppView, handleAssetSelected, handleDmFilterSelected, handleEcosystemToggle, handleOrgSelected, handleSortClick, handleStatusSelected, includeChildren, orgIdFilter, selectedStatus, setError, sort } = props;
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    const orgID = (0, _react.useMemo)(()=>assetView ? assetOrgID : orgIdFilter || currentOrg?._id, [
        assetView,
        assetOrgID,
        currentOrg?._id,
        orgIdFilter
    ]), source = (0, _react.useMemo)(()=>(0, _axios.CancelToken).source(), []), service = (0, _react.useMemo)(()=>new (0, _dm1ServiceDefault.default)(), []), metricsRequestParams = (0, _react.useMemo)(()=>{
        const conditionalParam = gatewayIdFilter ? {
            gatewayIdFilter
        } : {};
        return {
            orgID,
            orgIdFilter: orgID,
            ...conditionalParam
        };
    }, [
        gatewayIdFilter,
        orgID
    ]);
    const [filters, setFilters] = (0, _react.useState)(initState);
    const formatOptions = (0, _react.useCallback)((option)=>({
            value: option,
            label: option
        }), []);
    const formatSourceOptions = (0, _react.useCallback)((value)=>({
            value,
            label: listSourceAddress[value] || "Unknown SA"
        }), []);
    const fetchDm1Filters = (0, _react.useCallback)(async ()=>{
        try {
            const { Canbus: canbus = [], SourceAddress: sa = [], FMI: fmi = [], SPN: spn = [] } = await service.getDM1Filters(metricsRequestParams, source.token);
            const filters = {
                spn: Array.from(spn).sort((a, b)=>a - b).map(formatOptions),
                fmi: Array.from(fmi).sort((a, b)=>a - b).map(formatOptions),
                sa: Array.from(sa).sort((a, b)=>a - b).map(formatSourceOptions),
                canbus: Array.from(canbus).sort((a, b)=>a - b).map(formatOptions)
            };
            setFilters(filters);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            setError(error);
        }
    }, [
        formatOptions,
        formatSourceOptions,
        metricsRequestParams,
        service,
        setError,
        source.token
    ]);
    (0, _react.useEffect)(()=>{
        switch(true){
            case assetView:
                if (!assetOrgID) return;
                fetchDm1Filters();
                break;
            default:
                if (!currentOrg?._id) return;
                fetchDm1Filters();
                break;
        }
    }, [
        assetView,
        currentOrg?._id,
        assetOrgID,
        fetchDm1Filters
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusSelectDropdownDefault.default), {
                    selectedStatus: selectedStatus,
                    handleStatusSelected: handleStatusSelected
                })
            }),
            assetView || engineAppView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByNameDropdownDefault.default), {
                    orgID: currentOrg._id,
                    resource: "Asset",
                    handleAssetSelected: handleAssetSelected
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0",
                children: "Name"
            }),
            assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text px-0 pb-1 w-25 sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByOrgDropdownDefault.default), {
                    handleEcosystemToggle: handleEcosystemToggle,
                    handleOrgSelected: handleOrgSelected,
                    includeChildren: includeChildren,
                    orgID: orgID,
                    orgIdFilter: orgIdFilter
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text text-center sticky-top bg-white border-top-0",
                children: "LAMP"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "col-date text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sortByDateButtonDefault.default), {
                    displayText: "Detected At",
                    sort: sort,
                    handleSortClick: handleSortClick
                })
            }),
            FILTER_HEADERS.map(({ displayText, filter })=>{
                const filterRef = {
                    [`${filter}FilterRef`]: props[`${filter}FilterRef`]
                };
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                    scope: "col",
                    className: "text-text-light-gray font-weight-normal three-quarter-text px-0 pb-0 sticky-top bg-white border-top-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dmAlertsFiltersDropdownDefault.default), {
                        displayText: displayText,
                        filter: filter,
                        options: filters[filter] || [],
                        handleOptionSelect: handleDmFilterSelected,
                        ...filterRef
                    })
                }, filter);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: `text-text-light-gray font-weight-normal ${engineAppView ? "text-center " : ""}three-quarter-text sticky-top bg-white border-top-0`,
                children: "Occurrences"
            }),
            engineAppView ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "text-text-light-gray font-weight-normal three-quarter-text text-center sticky-top bg-white border-top-0",
                children: "Snapshots"
            }) : null
        ]
    });
}
DmAlertsTableHeader.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    }),
    assetView: (0, _propTypesDefault.default).bool,
    engineAppView: (0, _propTypesDefault.default).bool,
    fmiFilterRef: (0, _propTypesDefault.default).object,
    handleAssetSelected: (0, _propTypesDefault.default).func,
    handleDmFilterSelected: (0, _propTypesDefault.default).func,
    handleEcosystemToggle: (0, _propTypesDefault.default).func,
    handleOrgSelected: (0, _propTypesDefault.default).func,
    handleSortClick: (0, _propTypesDefault.default).func,
    handleStatusSelected: (0, _propTypesDefault.default).func,
    includeChildren: (0, _propTypesDefault.default).bool,
    orgIdFilter: (0, _propTypesDefault.default).string,
    saFilterRef: (0, _propTypesDefault.default).object,
    selectedStatus: (0, _propTypesDefault.default).oneOf([
        "positive",
        "negative",
        "all"
    ]),
    setDmExport: (0, _propTypesDefault.default).func,
    setError: (0, _propTypesDefault.default).func,
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "TriggeredAt",
            "DetectedAt"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "ASC",
            "DESC"
        ])
    }),
    spnFilterRef: (0, _propTypesDefault.default).object,
    tab: (0, _propTypesDefault.default).oneOf([
        "alerts",
        "dm1"
    ])
};
DmAlertsTableHeader.defaultProps = {
    data: [],
    asset: {}
};
exports.default = /*#__PURE__*/ (0, _react.memo)(DmAlertsTableHeader);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/DM1Service":"72XwI","../../Lib/DM1FaultsConstants":"5zTZ5","../../Context/CurrentOrgContext":"jQXcJ","./DmAlertsFiltersDropdown":"buBVI","./SearchByNameDropdown":"dFb3a","./SearchByOrgDropdown":"h1xko","./SortByDateButton":"iJ4WN","./StatusSelectDropdown":"8UkgS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buBVI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
const selectStyles = {
    placeholder: (base)=>({
            ...base,
            fontWeight: "normal",
            color: "var(--text-gray)"
        }),
    control: (base)=>({
            ...base,
            border: "none",
            boxShadow: "none",
            flexWrap: "nowrap"
        }),
    indicatorSeparator: (base)=>({
            ...base,
            visibility: "hidden"
        }),
    dropdownIndicator: (base)=>({
            ...base,
            padding: "8px 0px"
        }),
    clearIndicator: (base)=>({
            ...base,
            padding: "8px 0px"
        })
};
function DmAlertsFiltersDropdown(props) {
    const { displayText, filter, options, handleOptionSelect } = props;
    const conditionalStyles = filter === "sa" ? {
        menu: (base)=>({
                ...base,
                width: "150%"
            })
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
        isClearable: true,
        onChange: (value)=>handleOptionSelect(value, filter),
        options: options,
        placeholder: displayText,
        ref: props[`${filter}FilterRef`],
        styles: {
            ...selectStyles,
            ...conditionalStyles
        }
    });
}
DmAlertsFiltersDropdown.propTypes = {
    displayText: (0, _propTypesDefault.default).oneOf([
        "SPN",
        "FMI",
        "Source",
        "CAN",
        "Occurrences"
    ]),
    filter: (0, _propTypesDefault.default).oneOf([
        "spn",
        "fmi",
        "sa",
        "canbus",
        "oc"
    ]),
    options: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        value: (0, _propTypesDefault.default).number,
        label: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ])
    })),
    handleOptionSelect: (0, _propTypesDefault.default).func
};
DmAlertsFiltersDropdown.defaultProps = {
    options: []
};
exports.default = /*#__PURE__*/ (0, _react.memo)(DmAlertsFiltersDropdown);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-select":"j36cq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0tJ32":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _formatDistanceToNow = require("date-fns/formatDistanceToNow");
var _formatDistanceToNowDefault = parcelHelpers.interopDefault(_formatDistanceToNow);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _conditionsDropdown = require("./ConditionsDropdown");
var _conditionsDropdownDefault = parcelHelpers.interopDefault(_conditionsDropdown);
var _rbac = require("../../Constants/RBAC");
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
const { className: tooltipClass, styles: tooltipStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "603641600",
        children: "div.jsx-603641600{z-index:1021;}"
    }),
    className: "jsx-603641600"
};
const ALERT_STATUS_CLASS_MAP = new Map([
    [
        "positive",
        "text-alert-orange"
    ],
    [
        "negative",
        "text-third-gray"
    ]
]);
function truncateGps(number) {
    return Number.isInteger(number) ? number : Number.parseFloat(number).toFixed(2);
}
function AlertsTableBody({ assetView, data, handleRuleLinkClick, selectedStatus, toggleClearAlertModalClick }) {
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    return data.map((alert)=>{
        const { AlertData: { signals } = {}, Id, DetectedAt, GatewayId, GatewayName, GpsData: { Lat, Long }, OrgId, RuleId, RuleName, Transition, TriggeredAt } = alert;
        const showResolved = TriggeredAt && Transition === "negative";
        const showClearButton = Transition === "positive" && selectedStatus === "positive";
        const detectedAtDate = new Date(DetectedAt);
        const detectedAtDisplay = (0, _isValidDefault.default)(detectedAtDate) ? (0, _formatDefault.default)(detectedAtDate, "MMM d Y - h:mmaaa") : null;
        const durationDisplay = (0, _isValidDefault.default)(detectedAtDate) && Transition === "positive" ? `(${(0, _formatDistanceToNowDefault.default)(detectedAtDate, {
            includeSeconds: true
        })})` : null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: `d-flex ${showClearButton ? "justify-content-around" : ""} align-content-center`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faCircle),
                                size: "sm",
                                className: `${ALERT_STATUS_CLASS_MAP.get(Transition)} ${showClearButton ? "" : "ml-3"} mt-1 mx-1`
                            }),
                            showClearButton ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                no: (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        "data-tip": data,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn btn-sm btn-outline-secondary px-3 py-0 rounded mx-auto",
                                                disabled: true,
                                                children: "Clear"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                className: tooltipClass
                                            }),
                                            tooltipStyles
                                        ]
                                    }),
                                orgID: OrgId,
                                perform: (0, _rbac.ALERTS_CLEAR),
                                resource: (0, _rbac.CORE),
                                yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn btn-sm btn-outline-secondary px-3 py-0 rounded mx-auto",
                                        onClick: ()=>toggleClearAlertModalClick(alert),
                                        children: "Clear"
                                    })
                            }) : null
                        ]
                    })
                }),
                assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                    no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            className: "align-middle",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-link p-0 three-quarter-text text-truncate",
                                disabled: true,
                                children: GatewayName
                            })
                        }),
                    orgID: OrgId,
                    perform: (0, _rbac.CORE_READ),
                    resource: (0, _rbac.CORE),
                    yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            className: "align-middle",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: "three-quarter-text text-truncate",
                                replace: true,
                                to: {
                                    pathname: `/asset/${GatewayId}`,
                                    search: "?tab=dashboard"
                                },
                                children: GatewayName
                            })
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-link px-0 text-decoration-none three-quarter-text",
                                disabled: true,
                                onClick: ()=>null,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: ALERT_STATUS_CLASS_MAP.get(Transition),
                                    children: RuleName
                                })
                            }),
                        orgID: OrgId,
                        perform: (0, _rbac.ASSET_MODEL_READ),
                        resource: (0, _rbac.ASSET_MODEL),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-link px-0 text-decoration-none three-quarter-text",
                                onClick: ()=>handleRuleLinkClick(GatewayId, RuleId),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: ALERT_STATUS_CLASS_MAP.get(Transition),
                                    children: RuleName
                                })
                            })
                    })
                }),
                assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle three-quarter-text",
                    children: orgsMap?.[OrgId]?.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                    className: "three-quarter-text align-middle",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "mb-0 text-nowrap",
                            children: detectedAtDisplay
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mb-0",
                            children: durationDisplay
                        })
                    ]
                }),
                selectedStatus === "positive" ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "three-quarter-text align-middle",
                    children: showResolved ? (0, _momentDefault.default)(TriggeredAt).format("MMM D Y - h:mma") : null
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "pl-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionsDropdownDefault.default), {
                        signals: signals
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle",
                    children: Lat && Long ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                        className: "three-quarter-text text-nowrap",
                        href: `https://www.google.com/maps/dir/?api=1&destination=${Lat},${Long}`,
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: [
                            truncateGps(Lat),
                            ", ",
                            truncateGps(Long)
                        ]
                    }) : "--"
                })
            ]
        }, Id);
    });
}
AlertsTableBody.propTypes = {
    assetView: (0, _propTypesDefault.default).bool,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        AlertData: (0, _propTypesDefault.default).shape({
            description: (0, _propTypes.oneOfType)([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
            ]),
            signals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                name: (0, _propTypesDefault.default).string,
                signalID: (0, _propTypesDefault.default).string,
                threshold: (0, _propTypes.oneOfType)([
                    (0, _propTypesDefault.default).number,
                    (0, _propTypesDefault.default).string
                ]),
                type: (0, _propTypesDefault.default).string,
                value: (0, _propTypesDefault.default).number
            }))
        }),
        CreatedAt: (0, _propTypesDefault.default).string,
        DetectedAt: (0, _propTypesDefault.default).string,
        GatewayId: (0, _propTypesDefault.default).string,
        GatewayName: (0, _propTypesDefault.default).string,
        GpsData: (0, _propTypesDefault.default).shape({
            Lat: (0, _propTypesDefault.default).number,
            Long: (0, _propTypesDefault.default).number
        }),
        Id: (0, _propTypesDefault.default).string,
        OrgId: (0, _propTypesDefault.default).string,
        RuleId: (0, _propTypesDefault.default).string,
        RuleName: (0, _propTypesDefault.default).string,
        Severity: (0, _propTypesDefault.default).string,
        Transition: (0, _propTypesDefault.default).oneOf([
            "positive",
            "negative"
        ]),
        TriggeredAt: (0, _propTypesDefault.default).string,
        Type: (0, _propTypesDefault.default).oneOf([
            "rule"
        ]),
        UpdatedAt: (0, _propTypesDefault.default).string
    })),
    handleRuleLinkClick: (0, _propTypesDefault.default).func,
    selectedStatus: (0, _propTypesDefault.default).string,
    toggleClearAlertModalClick: (0, _propTypesDefault.default).func
};
AlertsTableBody.defaultProps = {
    data: []
};
exports.default = /*#__PURE__*/ (0, _react.memo)(AlertsTableBody);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","date-fns/format":"520Dk","date-fns/formatDistanceToNow":"dEX18","date-fns/isValid":"l72u5","moment":"1e4qG","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-tooltip":"4ejwp","./ConditionsDropdown":"k9cna","../../Constants/RBAC":"ieo1E","../../Context/OrgsMapContext":"asozp","../../RBAC/Can":"l4l8D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k9cna":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _conditionColumn = require("./ConditionColumn");
var _conditionColumnDefault = parcelHelpers.interopDefault(_conditionColumn);
function truncateValue(value) {
    return Number.isInteger(value) ? value : Number(value).toFixed(2);
}
function ConditionsDropdown({ signals = [] }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dropdown pl-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                id: "conditionsDropdown",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "true",
                className: "jsx-640193902 btn btn-link p-0 dropdown-toggle text-decoration-none text-text-light-gray d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-640193902",
                        children: signals.length
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                        id: "640193902",
                        children: ".dropdown-toggle.jsx-640193902:hover{color:var(--brand-primary) !important;}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dropdown-menu dropdown-menu-right rounded-lg px-3 py-3 container-fluid",
                "aria-labelledby": "conditionsDropdown",
                style: {
                    width: "30rem"
                },
                children: Array.isArray(signals) && signals.length ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-2938304672 three-quarter-text text-muted",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "jsx-2938304672 row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-2938304672 col-5",
                                    children: "Signal"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-2938304672 col-4 px-2",
                                    children: "Condition"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-2938304672 col-3",
                                    children: "Value"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                            className: "jsx-2938304672 my-2"
                        }),
                        signals.map(({ name, signalID, type, threshold, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "jsx-2938304672 row mb-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-2938304672 col-5 text-break",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-2938304672 col-4 px-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionColumnDefault.default), {
                                            threshold: threshold,
                                            type: type
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-2938304672 col-3 text-alert-orange",
                                        children: truncateValue(value)
                                    })
                                ]
                            }, signalID)),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                            id: "2938304672",
                            children: "p.jsx-2938304672{margin-bottom:0;}"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-danger",
                    children: "Alert condition data not available"
                })
            })
        ]
    });
}
ConditionsDropdown.propTypes = {
    signals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        name: (0, _propTypesDefault.default).string,
        signalID: (0, _propTypesDefault.default).string,
        threshold: (0, _propTypes.oneOfType)([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ]),
        type: (0, _propTypesDefault.default).string,
        value: (0, _propTypesDefault.default).number
    }))
};
ConditionsDropdown.defaultProps = {
    signals: []
};
exports.default = /*#__PURE__*/ (0, _react.memo)(ConditionsDropdown);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","./ConditionColumn":"f40Je","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f40Je":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _ruleUtils = require("../../Lib/RuleUtils");
var _ruleUtilsDefault = parcelHelpers.interopDefault(_ruleUtils);
const ConditionColumn = ({ type, threshold })=>{
    const ruleUtils = new (0, _ruleUtilsDefault.default)();
    const CONDITIONS_ICON_MAP = new Map([
        [
            "lessThan",
            (0, _freeSolidSvgIcons.faLessThan)
        ],
        [
            "greaterThan",
            (0, _freeSolidSvgIcons.faGreaterThan)
        ],
        [
            "equalTo",
            (0, _freeSolidSvgIcons.faEquals)
        ],
        [
            "notEqualTo",
            (0, _freeSolidSvgIcons.faNotEqual)
        ]
    ]);
    switch(type){
        case "outsideOf":
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "three-quarter-text text-muted overflow-hidden py-1",
                style: {
                    maxHeight: "2.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-dark font-weight-bold",
                        children: `${threshold[0]} `
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        className: "text-brand-primary",
                        icon: (0, _freeSolidSvgIcons.faArrowLeft)
                    }),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        className: "text-brand-primary",
                        icon: (0, _freeSolidSvgIcons.faArrowRight)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-dark font-weight-bold",
                        children: ` ${threshold[1]}`
                    })
                ]
            });
        case "between":
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "three-quarter-text text-muted overflow-hidden py-1",
                style: {
                    maxHeight: "2.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-dark font-weight-bold",
                        children: `${threshold[0]} `
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        className: "text-brand-primary",
                        icon: (0, _freeSolidSvgIcons.faArrowRight)
                    }),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        className: "text-brand-primary",
                        icon: (0, _freeSolidSvgIcons.faArrowLeft)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-dark font-weight-bold",
                        children: ` ${threshold[1]}`
                    })
                ]
            });
        case "contains":
        case "startsWith":
        case "endsWith":
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "three-quarter-text text-muted overflow-hidden py-1",
                style: {
                    maxHeight: "2.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-brand-primary font-weight-medium",
                        children: ruleUtils.ruleTypeDisplayMap.get(type)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-dark font-weight-bold",
                        children: ` ${threshold}`
                    })
                ]
            });
        case "":
            return null;
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "three-quarter-text text-muted overflow-hidden py-1",
                style: {
                    maxHeight: "2.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        className: "text-brand-primary",
                        icon: CONDITIONS_ICON_MAP.get(type)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-dark font-weight-bold",
                        children: ` ${threshold}`
                    })
                ]
            });
    }
};
ConditionColumn.propTypes = {
    type: (0, _propTypesDefault.default).string,
    threshold: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ])
};
ConditionColumn.defaultProps = {
    type: "",
    threshold: []
};
exports.default = ConditionColumn; // imported by ConditionsDropdown.js and MobileDetailsModal.js

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Lib/RuleUtils":"9Tnix","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"acZMN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _formatDistanceToNow = require("date-fns/formatDistanceToNow");
var _formatDistanceToNowDefault = parcelHelpers.interopDefault(_formatDistanceToNow);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _rbac = require("../../Constants/RBAC");
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _dm1FaultsConstants = require("../../Lib/DM1FaultsConstants");
var _dm1FaultsConstantsDefault = parcelHelpers.interopDefault(_dm1FaultsConstants);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _j1939DictionaryJson = require("../../Static/j1939Dictionary.json");
var _j1939DictionaryJsonDefault = parcelHelpers.interopDefault(_j1939DictionaryJson);
exports.default = /*#__PURE__*/ (0, _react.memo)(DmAlertsTableBody);
const DM_CONSTANTS = new (0, _dm1FaultsConstantsDefault.default)();
const ALERT_STATUS_CLASS_MAP = new Map([
    [
        "positive",
        "text-active-dm"
    ],
    [
        "negative",
        "text-third-gray"
    ]
]);
const LAMPS_ICON_MAP = new Map([
    [
        "AWL",
        SquareIcon
    ],
    [
        "MIL:PL",
        TriangleIcon
    ],
    [
        "RSL",
        CircleIcon
    ]
]);
function getDisplayName(SPN, FMI) {
    const spnName = (0, _j1939DictionaryJsonDefault.default)[SPN] ? (0, _j1939DictionaryJsonDefault.default)[SPN].SPN_Name : SPN;
    return `${spnName} - ${DM_CONSTANTS.listFMIname[FMI]}`;
}
function getSourceDisplayName(SourceAddress) {
    return DM_CONSTANTS.listSourceAddress[SourceAddress] || "Unknown SA";
}
function DmAlertsTableBody({ data, assetView }) {
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    return data.map((dm)=>{
        const { AWL, Canbus, FMI, GatewayId, GatewayName, Id, MIL, OC, OrgId, PL, RSL, SourceAddress, SPN, Transition, TriggeredAt } = dm;
        const triggeredAtDate = new Date(TriggeredAt);
        const detectedAtDisplay = (0, _isValidDefault.default)(triggeredAtDate) ? (0, _formatDefault.default)(triggeredAtDate, "MMM d Y - h:mmaaa") : null;
        const durationDisplay = (0, _isValidDefault.default)(triggeredAtDate) && Transition === "positive" ? `(${(0, _formatDistanceToNowDefault.default)(triggeredAtDate, {
            includeSeconds: true
        })})` : null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCircle),
                        size: "sm",
                        className: `${ALERT_STATUS_CLASS_MAP.get(Transition)} ml-3`
                    })
                }),
                assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "btn btn-link p-0 three-quarter-text",
                                disabled: true,
                                children: GatewayName
                            }),
                        orgID: OrgId,
                        perform: (0, _rbac.CORE_READ),
                        resource: (0, _rbac.CORE),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: {
                                    pathname: `/asset/${GatewayId}`,
                                    search: "?tab=dashboard"
                                },
                                replace: true,
                                className: "three-quarter-text",
                                children: GatewayName
                            })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "three-quarter-text align-middle",
                    children: getDisplayName(SPN, FMI)
                }),
                assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle three-quarter-text",
                    children: orgsMap?.[OrgId]?.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "align-middle text-center",
                    children: [
                        [
                            [
                                AWL
                            ],
                            "AWL"
                        ],
                        [
                            [
                                MIL,
                                PL
                            ],
                            "MIL:PL"
                        ],
                        [
                            [
                                RSL
                            ],
                            "RSL"
                        ]
                    ].map(([lamps, iconKey], i)=>{
                        if (!lamps.includes(1)) return null;
                        let tooltip;
                        if (lamps.length === 1) tooltip = `Active ${iconKey}`;
                        else {
                            const lampNames = iconKey.split(":");
                            tooltip = lamps.reduce((str, lamp, index)=>{
                                if (lamp !== 0) return str;
                                return `${str} ${lampNames[index]}`;
                            }, "Active");
                        }
                        const Icon = LAMPS_ICON_MAP.get(iconKey);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            "data-for": `${Id}-${i}`,
                            "data-tip": tooltip,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                    arrowColor: "#fff",
                                    className: "bg-white shadow rounded-lg text-dark three-quarter-text",
                                    id: `${Id}-${i}`,
                                    multiline: true
                                })
                            ]
                        }, `${Id}-${i}`);
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                    className: "three-quarter-text align-middle",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mb-0",
                            children: detectedAtDisplay
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mb-0",
                            children: durationDisplay
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "three-quarter-text align-middle",
                    children: SPN
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "three-quarter-text align-middle",
                    children: FMI
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "three-quarter-text align-middle",
                    children: getSourceDisplayName(SourceAddress)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "three-quarter-text align-middle text-center",
                    children: Canbus
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: "three-quarter-text align-middle text-center",
                    children: OC
                })
            ]
        }, Id);
    });
}
DmAlertsTableBody.propTypes = {
    assetView: (0, _propTypesDefault.default).bool,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        AWL: (0, _propTypesDefault.default).number,
        Canbus: (0, _propTypesDefault.default).number,
        CreatedAt: (0, _propTypesDefault.default).string,
        DetectedAt: (0, _propTypesDefault.default).string,
        FMI: (0, _propTypesDefault.default).number,
        GatewayId: (0, _propTypesDefault.default).string,
        GatewayName: (0, _propTypesDefault.default).string,
        Id: (0, _propTypesDefault.default).string,
        MIL: (0, _propTypesDefault.default).number,
        OC: (0, _propTypesDefault.default).number,
        OrgId: (0, _propTypesDefault.default).string,
        PL: (0, _propTypesDefault.default).number,
        RSL: (0, _propTypesDefault.default).number,
        SPN: (0, _propTypesDefault.default).number,
        SourceAddress: (0, _propTypesDefault.default).number,
        Transition: (0, _propTypesDefault.default).string,
        TriggeredAt: (0, _propTypesDefault.default).string,
        UpdatedAt: (0, _propTypesDefault.default).string
    }))
};
DmAlertsTableBody.defaultProps = {
    data: []
};
function CircleIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        className: "text-active-dm my-1",
        icon: (0, _freeSolidSvgIcons.faExclamationCircle)
    });
}
function SquareIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "fa-layers fa-fw my-1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                className: "text-alert-orange",
                icon: (0, _freeSolidSvgIcons.faSquare)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                color: "white",
                icon: (0, _freeSolidSvgIcons.faExclamation),
                transform: "shrink-6"
            })
        ]
    });
}
function TriangleIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        className: "text-warning-yellow my-1",
        icon: (0, _freeSolidSvgIcons.faExclamationTriangle)
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","date-fns/format":"520Dk","date-fns/formatDistanceToNow":"dEX18","date-fns/isValid":"l72u5","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-tooltip":"4ejwp","../../Constants/RBAC":"ieo1E","../../Context/OrgsMapContext":"asozp","../../Lib/DM1FaultsConstants":"5zTZ5","../../RBAC/Can":"l4l8D","../../Static/j1939Dictionary.json":"3xmN5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2U5oi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AlertCard);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _formatDistanceToNow = require("date-fns/formatDistanceToNow");
var _formatDistanceToNowDefault = parcelHelpers.interopDefault(_formatDistanceToNow);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _rbac = require("../../Constants/RBAC");
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _dm1FaultsConstants = require("../../Lib/DM1FaultsConstants");
var _dm1FaultsConstantsDefault = parcelHelpers.interopDefault(_dm1FaultsConstants);
var _j1939DictionaryJson = require("../../Static/j1939Dictionary.json");
var _j1939DictionaryJsonDefault = parcelHelpers.interopDefault(_j1939DictionaryJson);
var _mobileDetailsModal = require("./MobileDetailsModal");
var _mobileDetailsModalDefault = parcelHelpers.interopDefault(_mobileDetailsModal);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
const { className: tooltipClass, styles: tooltipStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "603641600",
        children: "div.jsx-603641600{z-index:1021;}"
    }),
    className: "jsx-603641600"
};
const DM_CONSTANTS = new (0, _dm1FaultsConstantsDefault.default)();
const ICON_DISPLAY_MAP = new Map([
    [
        "alerts:positive",
        {
            icon: (0, _freeSolidSvgIcons.faBell),
            color: "alert-orange"
        }
    ],
    [
        "alerts:negative",
        {
            icon: (0, _freeRegularSvgIcons.faBell),
            color: "icon-link-gray"
        }
    ],
    [
        "dm1:positive",
        {
            icon: (0, _freeSolidSvgIcons.faExclamationTriangle),
            color: "active-dm"
        }
    ],
    [
        "dm1:negative",
        {
            icon: (0, _freeSolidSvgIcons.faExclamationTriangle),
            color: "icon-link-gray"
        }
    ]
]);
const LAMPS_ICON_MAP = new Map([
    [
        "AWL",
        SquareIcon
    ],
    [
        "MIL:PL",
        TriangleIcon
    ],
    [
        "RSL",
        CircleIcon
    ]
]);
function getDm1DisplayName(SPN, FMI) {
    const spnName = (0, _j1939DictionaryJsonDefault.default)[SPN] ? (0, _j1939DictionaryJsonDefault.default)[SPN].SPN_Name : SPN;
    return `${spnName} - ${DM_CONSTANTS.listFMIname[FMI]}`;
}
function AlertCard({ alert, tab, assetView, engineAppView, handleRuleLinkClick, toggleClearAlertModalClick }) {
    const { AWL, DetectedAt, FMI, GatewayId, GatewayName, GpsData: { Lat, Long } = {}, Id, MIL, OrgId, PL, RSL, RuleId, RuleName, SPN, Transition, TriggeredAt } = alert;
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const [showModal, toggleModal] = (0, _react.useState)(false);
    const { icon, color } = ICON_DISPLAY_MAP.get(`${tab}:${Transition}`) || {};
    const border = Transition === "positive" ? `border border-${color}` : "border-0";
    const title = tab === "alerts" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
        no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "btn btn-link p-0 text-decoration-none",
                disabled: true,
                onClick: ()=>null,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: `text-${color}`,
                    children: RuleName
                })
            }),
        orgID: OrgId,
        perform: (0, _rbac.ASSET_MODEL_READ),
        resource: (0, _rbac.ASSET_MODEL),
        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "btn btn-link p-0 text-decoration-none",
                onClick: ()=>handleRuleLinkClick(GatewayId, RuleId),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: `text-${color}`,
                    children: RuleName
                })
            })
    }) : getDm1DisplayName(SPN, FMI);
    const displayTime = (0, _react.useMemo)(()=>{
        switch(tab){
            case "alerts":
                {
                    const detectedAtDate = new Date(DetectedAt);
                    return (0, _isValidDefault.default)(detectedAtDate) ? (0, _formatDefault.default)(detectedAtDate, "MMM d Y - h:mmaaa") : null;
                }
            case "dm1":
                {
                    const triggeredAtDate = new Date(TriggeredAt);
                    return (0, _isValidDefault.default)(triggeredAtDate) ? (0, _formatDefault.default)(triggeredAtDate, "MMM d Y - h:mmaaa") : null;
                }
            default:
                return null;
        }
    }, [
        DetectedAt,
        tab,
        TriggeredAt
    ]);
    const durationDisplay = (0, _react.useMemo)(()=>{
        switch(tab){
            case "alerts":
                {
                    const detectedAtDate = new Date(DetectedAt);
                    return (0, _isValidDefault.default)(detectedAtDate) && Transition === "positive" ? `(${(0, _formatDistanceToNowDefault.default)(detectedAtDate, {
                        includeSeconds: true
                    })})` : null;
                }
            case "dm1":
                {
                    const triggeredAtDate = new Date(TriggeredAt);
                    return (0, _isValidDefault.default)(triggeredAtDate) && Transition === "positive" ? `(${(0, _formatDistanceToNowDefault.default)(triggeredAtDate, {
                        includeSeconds: true
                    })})` : null;
                }
            default:
                return null;
        }
    }, [
        DetectedAt,
        tab,
        Transition,
        TriggeredAt
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3242506513 " + `card mb-3 d-lg-none ${border}${assetView || engineAppView ? "" : " row"}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-3242506513 row no-gutters",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-3242506513 col-2 d-flex flex-column align-items-center justify-content-center",
                        children: tab === "alerts" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: icon,
                            className: `text-${color}`,
                            size: "lg"
                        }) : [
                            [
                                [
                                    AWL
                                ],
                                "AWL"
                            ],
                            [
                                [
                                    MIL,
                                    PL
                                ],
                                "MIL:PL"
                            ],
                            [
                                [
                                    RSL
                                ],
                                "RSL"
                            ]
                        ].map(([lamps, iconKey], i)=>{
                            if (!lamps.includes(1)) return null;
                            let tooltip;
                            if (lamps.length === 1) tooltip = `Active ${iconKey}`;
                            else {
                                const lampNames = iconKey.split(":");
                                tooltip = lamps.reduce((str, lamp, index)=>{
                                    if (lamp !== 0) return str;
                                    return `${str} ${lampNames[index]}`;
                                }, "Active");
                            }
                            const Icon = LAMPS_ICON_MAP.get(iconKey);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                "data-for": `${Id}-${i}`,
                                "data-tip": tooltip,
                                className: "jsx-3242506513",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                                        className: "jsx-3242506513"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                        arrowColor: "#fff",
                                        className: "bg-white shadow rounded-lg text-dark three-quarter-text",
                                        id: `${Id}-${i}`,
                                        multiline: true
                                    })
                                ]
                            }, `${Id}-${i}`);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-3242506513 col-10",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-3242506513 card-body py-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-3242506513 " + `card-title mb-0 text-${color} text-truncate`,
                                    children: title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-3242506513 card-text text-text-light-gray three-quarter-text mb-2",
                                    children: displayTime
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "jsx-3242506513 card-text text-text-light-gray three-quarter-text mb-2",
                                    children: durationDisplay
                                }),
                                assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "jsx-3242506513 card-text text-text-light-gray three-quarter-text mb-2",
                                    children: [
                                        "on",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-3242506513 ml-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                                no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        disabled: true,
                                                        className: "jsx-3242506513 btn btn-link p-0 nine-tenth-text",
                                                        children: GatewayName
                                                    }),
                                                orgID: OrgId,
                                                perform: (0, _rbac.CORE_READ),
                                                resource: (0, _rbac.CORE),
                                                yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                        to: {
                                                            pathname: `/asset/${GatewayId}`,
                                                            search: "?tab=dashboard"
                                                        },
                                                        replace: true,
                                                        className: "nine-tenth-text",
                                                        children: GatewayName
                                                    })
                                            })
                                        })
                                    ]
                                }),
                                assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "jsx-3242506513 card-text text-text-light-gray three-quarter-text mb-3",
                                    children: [
                                        "in",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-3242506513 ml-2 nine-tenth-text text-dark",
                                            children: orgsMap?.[OrgId]?.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-3242506513 " + `d-flex align-items-center ${getContentClassName(tab, Transition)}`,
                                    children: [
                                        tab === "alerts" && Transition === "positive" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                            no: (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    "data-tip": data,
                                                    className: "jsx-3242506513",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            disabled: true,
                                                            className: "jsx-3242506513 btn btn-outline-text-light-gray py-1 px-3 rounded-pill",
                                                            children: "Clear"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                            className: tooltipClass
                                                        }),
                                                        tooltipStyles
                                                    ]
                                                }),
                                            orgID: OrgId,
                                            perform: (0, _rbac.ALERTS_CLEAR),
                                            resource: (0, _rbac.CORE),
                                            yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>toggleClearAlertModalClick(alert),
                                                    className: "jsx-3242506513 btn btn-outline-text-light-gray py-1 px-3 rounded-pill",
                                                    children: "Clear"
                                                })
                                        }) : null,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>toggleModal(!showModal),
                                            className: "jsx-3242506513 btn btn-outline-text-light-gray py-1 px-3 rounded-pill mx-1",
                                            children: "Details"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: `https://www.google.com/maps/dir/?api=1&destination=${Lat},${Long}`,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "jsx-3242506513 " + ` ${tab === "dm1" ? "d-none" : ""}`,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "jsx-3242506513 btn btn-outline-text-light-gray py-1 px-3 rounded-pill mx-1",
                                                children: "Location"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileDetailsModalDefault.default), {
                alert: alert,
                assetView: assetView,
                handleRuleLinkClick: handleRuleLinkClick,
                isOpen: showModal,
                tab: tab,
                toggleModal: toggleModal
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3242506513",
                children: ".card.jsx-3242506513{border-width:medium !important;}.btn-outline-text-light-gray.jsx-3242506513{font-size:0.65rem;}"
            })
        ]
    });
}
AlertCard.propTypes = {
    alert: (0, _propTypesDefault.default).shape({
        AlertData: (0, _propTypesDefault.default).shape({
            description: (0, _propTypes.oneOfType)([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
            ]),
            signals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                name: (0, _propTypesDefault.default).string,
                signalID: (0, _propTypesDefault.default).string,
                threshold: (0, _propTypes.oneOfType)([
                    (0, _propTypesDefault.default).number,
                    (0, _propTypesDefault.default).string
                ]),
                type: (0, _propTypesDefault.default).string,
                value: (0, _propTypesDefault.default).number
            }))
        }),
        AWL: (0, _propTypesDefault.default).number,
        Canbus: (0, _propTypesDefault.default).number,
        CreatedAt: (0, _propTypesDefault.default).string,
        DetectedAt: (0, _propTypesDefault.default).string,
        FMI: (0, _propTypesDefault.default).number,
        GatewayId: (0, _propTypesDefault.default).string,
        GatewayName: (0, _propTypesDefault.default).string,
        GpsData: (0, _propTypesDefault.default).shape({
            Lat: (0, _propTypesDefault.default).number,
            Long: (0, _propTypesDefault.default).number
        }),
        Id: (0, _propTypesDefault.default).string,
        MIL: (0, _propTypesDefault.default).number,
        OC: (0, _propTypesDefault.default).number,
        OrgId: (0, _propTypesDefault.default).string,
        PL: (0, _propTypesDefault.default).number,
        RSL: (0, _propTypesDefault.default).number,
        RuleId: (0, _propTypesDefault.default).string,
        RuleName: (0, _propTypesDefault.default).string,
        Severity: (0, _propTypesDefault.default).string,
        SourceAddress: (0, _propTypesDefault.default).number,
        SPN: (0, _propTypesDefault.default).number,
        Transition: (0, _propTypesDefault.default).oneOf([
            "positive",
            "negative"
        ]),
        TriggeredAt: (0, _propTypesDefault.default).string,
        Type: (0, _propTypesDefault.default).oneOf([
            "rule"
        ]),
        UpdatedAt: (0, _propTypesDefault.default).string
    }),
    assetView: (0, _propTypesDefault.default).bool,
    engineAppView: (0, _propTypesDefault.default).bool,
    handleRuleLinkClick: (0, _propTypesDefault.default).func,
    tab: (0, _propTypesDefault.default).oneOf([
        "alerts",
        "dm1"
    ]),
    toggleClearAlertModalClick: (0, _propTypesDefault.default).func
};
AlertCard.defaultProps = {
    alert: {
        Transition: "positive"
    },
    tab: "alerts"
};
function getContentClassName(tab, Transition) {
    switch(true){
        case tab === "dm1":
            return "justify-content-end";
        case tab === "alerts" && Transition === "positive":
            return "justify-content-around";
        default:
            return "justify-content-start";
    }
}
function CircleIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        className: "text-active-dm my-1",
        icon: (0, _freeSolidSvgIcons.faExclamationCircle),
        size: "lg"
    });
}
function SquareIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "fa-layers fa-fw my-1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                className: "text-alert-orange",
                icon: (0, _freeSolidSvgIcons.faSquare),
                size: "lg"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                color: "white",
                icon: (0, _freeSolidSvgIcons.faExclamation),
                transform: "shrink-6"
            })
        ]
    });
}
function TriangleIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        className: "text-warning-yellow my-1",
        icon: (0, _freeSolidSvgIcons.faExclamationTriangle),
        size: "lg"
    });
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","date-fns/format":"520Dk","date-fns/formatDistanceToNow":"dEX18","date-fns/isValid":"l72u5","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@fortawesome/free-regular-svg-icons":"4Efas","react-tooltip":"4ejwp","../../Constants/RBAC":"ieo1E","../../Context/OrgsMapContext":"asozp","../../Lib/DM1FaultsConstants":"5zTZ5","../../Static/j1939Dictionary.json":"3xmN5","./MobileDetailsModal":"44FfA","../../RBAC/Can":"l4l8D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Efas":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "far", ()=>icons);
parcelHelpers.export(exports, "prefix", ()=>prefix);
parcelHelpers.export(exports, "faTrashCan", ()=>faTrashCan);
parcelHelpers.export(exports, "faTrashAlt", ()=>faTrashAlt);
parcelHelpers.export(exports, "faMessage", ()=>faMessage);
parcelHelpers.export(exports, "faCommentAlt", ()=>faCommentAlt);
parcelHelpers.export(exports, "faFileLines", ()=>faFileLines);
parcelHelpers.export(exports, "faFileAlt", ()=>faFileAlt);
parcelHelpers.export(exports, "faFileText", ()=>faFileText);
parcelHelpers.export(exports, "faCalendarDays", ()=>faCalendarDays);
parcelHelpers.export(exports, "faCalendarAlt", ()=>faCalendarAlt);
parcelHelpers.export(exports, "faHandPointRight", ()=>faHandPointRight);
parcelHelpers.export(exports, "faFaceSmileBeam", ()=>faFaceSmileBeam);
parcelHelpers.export(exports, "faSmileBeam", ()=>faSmileBeam);
parcelHelpers.export(exports, "faFaceGrinStars", ()=>faFaceGrinStars);
parcelHelpers.export(exports, "faGrinStars", ()=>faGrinStars);
parcelHelpers.export(exports, "faAddressBook", ()=>faAddressBook);
parcelHelpers.export(exports, "faContactBook", ()=>faContactBook);
parcelHelpers.export(exports, "faComments", ()=>faComments);
parcelHelpers.export(exports, "faPaste", ()=>faPaste);
parcelHelpers.export(exports, "faFileClipboard", ()=>faFileClipboard);
parcelHelpers.export(exports, "faFaceGrinTongueSquint", ()=>faFaceGrinTongueSquint);
parcelHelpers.export(exports, "faGrinTongueSquint", ()=>faGrinTongueSquint);
parcelHelpers.export(exports, "faFaceFlushed", ()=>faFaceFlushed);
parcelHelpers.export(exports, "faFlushed", ()=>faFlushed);
parcelHelpers.export(exports, "faSquareCaretRight", ()=>faSquareCaretRight);
parcelHelpers.export(exports, "faCaretSquareRight", ()=>faCaretSquareRight);
parcelHelpers.export(exports, "faSquareMinus", ()=>faSquareMinus);
parcelHelpers.export(exports, "faMinusSquare", ()=>faMinusSquare);
parcelHelpers.export(exports, "faCompass", ()=>faCompass);
parcelHelpers.export(exports, "faSquareCaretDown", ()=>faSquareCaretDown);
parcelHelpers.export(exports, "faCaretSquareDown", ()=>faCaretSquareDown);
parcelHelpers.export(exports, "faFaceKissBeam", ()=>faFaceKissBeam);
parcelHelpers.export(exports, "faKissBeam", ()=>faKissBeam);
parcelHelpers.export(exports, "faLightbulb", ()=>faLightbulb);
parcelHelpers.export(exports, "faFlag", ()=>faFlag);
parcelHelpers.export(exports, "faSquareCheck", ()=>faSquareCheck);
parcelHelpers.export(exports, "faCheckSquare", ()=>faCheckSquare);
parcelHelpers.export(exports, "faCircleDot", ()=>faCircleDot);
parcelHelpers.export(exports, "faDotCircle", ()=>faDotCircle);
parcelHelpers.export(exports, "faFaceDizzy", ()=>faFaceDizzy);
parcelHelpers.export(exports, "faDizzy", ()=>faDizzy);
parcelHelpers.export(exports, "faFutbol", ()=>faFutbol);
parcelHelpers.export(exports, "faFutbolBall", ()=>faFutbolBall);
parcelHelpers.export(exports, "faSoccerBall", ()=>faSoccerBall);
parcelHelpers.export(exports, "faPenToSquare", ()=>faPenToSquare);
parcelHelpers.export(exports, "faEdit", ()=>faEdit);
parcelHelpers.export(exports, "faHourglassHalf", ()=>faHourglassHalf);
parcelHelpers.export(exports, "faHourglass2", ()=>faHourglass2);
parcelHelpers.export(exports, "faEyeSlash", ()=>faEyeSlash);
parcelHelpers.export(exports, "faHand", ()=>faHand);
parcelHelpers.export(exports, "faHandPaper", ()=>faHandPaper);
parcelHelpers.export(exports, "faHandSpock", ()=>faHandSpock);
parcelHelpers.export(exports, "faFaceKiss", ()=>faFaceKiss);
parcelHelpers.export(exports, "faKiss", ()=>faKiss);
parcelHelpers.export(exports, "faFaceGrinTongue", ()=>faFaceGrinTongue);
parcelHelpers.export(exports, "faGrinTongue", ()=>faGrinTongue);
parcelHelpers.export(exports, "faChessBishop", ()=>faChessBishop);
parcelHelpers.export(exports, "faFaceGrinWink", ()=>faFaceGrinWink);
parcelHelpers.export(exports, "faGrinWink", ()=>faGrinWink);
parcelHelpers.export(exports, "faFaceGrinWide", ()=>faFaceGrinWide);
parcelHelpers.export(exports, "faGrinAlt", ()=>faGrinAlt);
parcelHelpers.export(exports, "faFaceFrownOpen", ()=>faFaceFrownOpen);
parcelHelpers.export(exports, "faFrownOpen", ()=>faFrownOpen);
parcelHelpers.export(exports, "faHandPointUp", ()=>faHandPointUp);
parcelHelpers.export(exports, "faBookmark", ()=>faBookmark);
parcelHelpers.export(exports, "faHandPointDown", ()=>faHandPointDown);
parcelHelpers.export(exports, "faFolder", ()=>faFolder);
parcelHelpers.export(exports, "faFolderBlank", ()=>faFolderBlank);
parcelHelpers.export(exports, "faUser", ()=>faUser);
parcelHelpers.export(exports, "faSquareCaretLeft", ()=>faSquareCaretLeft);
parcelHelpers.export(exports, "faCaretSquareLeft", ()=>faCaretSquareLeft);
parcelHelpers.export(exports, "faStar", ()=>faStar);
parcelHelpers.export(exports, "faChessKnight", ()=>faChessKnight);
parcelHelpers.export(exports, "faFaceLaughSquint", ()=>faFaceLaughSquint);
parcelHelpers.export(exports, "faLaughSquint", ()=>faLaughSquint);
parcelHelpers.export(exports, "faFaceLaugh", ()=>faFaceLaugh);
parcelHelpers.export(exports, "faLaugh", ()=>faLaugh);
parcelHelpers.export(exports, "faFolderOpen", ()=>faFolderOpen);
parcelHelpers.export(exports, "faClipboard", ()=>faClipboard);
parcelHelpers.export(exports, "faChessQueen", ()=>faChessQueen);
parcelHelpers.export(exports, "faHandBackFist", ()=>faHandBackFist);
parcelHelpers.export(exports, "faHandRock", ()=>faHandRock);
parcelHelpers.export(exports, "faSquareCaretUp", ()=>faSquareCaretUp);
parcelHelpers.export(exports, "faCaretSquareUp", ()=>faCaretSquareUp);
parcelHelpers.export(exports, "faChartBar", ()=>faChartBar);
parcelHelpers.export(exports, "faBarChart", ()=>faBarChart);
parcelHelpers.export(exports, "faWindowRestore", ()=>faWindowRestore);
parcelHelpers.export(exports, "faSquarePlus", ()=>faSquarePlus);
parcelHelpers.export(exports, "faPlusSquare", ()=>faPlusSquare);
parcelHelpers.export(exports, "faImage", ()=>faImage);
parcelHelpers.export(exports, "faFolderClosed", ()=>faFolderClosed);
parcelHelpers.export(exports, "faLemon", ()=>faLemon);
parcelHelpers.export(exports, "faHandshake", ()=>faHandshake);
parcelHelpers.export(exports, "faGem", ()=>faGem);
parcelHelpers.export(exports, "faCirclePlay", ()=>faCirclePlay);
parcelHelpers.export(exports, "faPlayCircle", ()=>faPlayCircle);
parcelHelpers.export(exports, "faCircleCheck", ()=>faCircleCheck);
parcelHelpers.export(exports, "faCheckCircle", ()=>faCheckCircle);
parcelHelpers.export(exports, "faCircleStop", ()=>faCircleStop);
parcelHelpers.export(exports, "faStopCircle", ()=>faStopCircle);
parcelHelpers.export(exports, "faIdBadge", ()=>faIdBadge);
parcelHelpers.export(exports, "faFaceLaughBeam", ()=>faFaceLaughBeam);
parcelHelpers.export(exports, "faLaughBeam", ()=>faLaughBeam);
parcelHelpers.export(exports, "faRegistered", ()=>faRegistered);
parcelHelpers.export(exports, "faAddressCard", ()=>faAddressCard);
parcelHelpers.export(exports, "faContactCard", ()=>faContactCard);
parcelHelpers.export(exports, "faVcard", ()=>faVcard);
parcelHelpers.export(exports, "faFaceTired", ()=>faFaceTired);
parcelHelpers.export(exports, "faTired", ()=>faTired);
parcelHelpers.export(exports, "faFontAwesome", ()=>faFontAwesome);
parcelHelpers.export(exports, "faFontAwesomeFlag", ()=>faFontAwesomeFlag);
parcelHelpers.export(exports, "faFontAwesomeLogoFull", ()=>faFontAwesomeLogoFull);
parcelHelpers.export(exports, "faFaceSmileWink", ()=>faFaceSmileWink);
parcelHelpers.export(exports, "faSmileWink", ()=>faSmileWink);
parcelHelpers.export(exports, "faFileWord", ()=>faFileWord);
parcelHelpers.export(exports, "faFilePowerpoint", ()=>faFilePowerpoint);
parcelHelpers.export(exports, "faEnvelopeOpen", ()=>faEnvelopeOpen);
parcelHelpers.export(exports, "faFileZipper", ()=>faFileZipper);
parcelHelpers.export(exports, "faFileArchive", ()=>faFileArchive);
parcelHelpers.export(exports, "faSquare", ()=>faSquare);
parcelHelpers.export(exports, "faSnowflake", ()=>faSnowflake);
parcelHelpers.export(exports, "faNewspaper", ()=>faNewspaper);
parcelHelpers.export(exports, "faFaceKissWinkHeart", ()=>faFaceKissWinkHeart);
parcelHelpers.export(exports, "faKissWinkHeart", ()=>faKissWinkHeart);
parcelHelpers.export(exports, "faStarHalfStroke", ()=>faStarHalfStroke);
parcelHelpers.export(exports, "faStarHalfAlt", ()=>faStarHalfAlt);
parcelHelpers.export(exports, "faFileExcel", ()=>faFileExcel);
parcelHelpers.export(exports, "faFaceGrinBeam", ()=>faFaceGrinBeam);
parcelHelpers.export(exports, "faGrinBeam", ()=>faGrinBeam);
parcelHelpers.export(exports, "faObjectUngroup", ()=>faObjectUngroup);
parcelHelpers.export(exports, "faCircleRight", ()=>faCircleRight);
parcelHelpers.export(exports, "faArrowAltCircleRight", ()=>faArrowAltCircleRight);
parcelHelpers.export(exports, "faFaceRollingEyes", ()=>faFaceRollingEyes);
parcelHelpers.export(exports, "faMehRollingEyes", ()=>faMehRollingEyes);
parcelHelpers.export(exports, "faObjectGroup", ()=>faObjectGroup);
parcelHelpers.export(exports, "faHeart", ()=>faHeart);
parcelHelpers.export(exports, "faFaceSurprise", ()=>faFaceSurprise);
parcelHelpers.export(exports, "faSurprise", ()=>faSurprise);
parcelHelpers.export(exports, "faCirclePause", ()=>faCirclePause);
parcelHelpers.export(exports, "faPauseCircle", ()=>faPauseCircle);
parcelHelpers.export(exports, "faCircle", ()=>faCircle);
parcelHelpers.export(exports, "faCircleUp", ()=>faCircleUp);
parcelHelpers.export(exports, "faArrowAltCircleUp", ()=>faArrowAltCircleUp);
parcelHelpers.export(exports, "faFileAudio", ()=>faFileAudio);
parcelHelpers.export(exports, "faFileImage", ()=>faFileImage);
parcelHelpers.export(exports, "faCircleQuestion", ()=>faCircleQuestion);
parcelHelpers.export(exports, "faQuestionCircle", ()=>faQuestionCircle);
parcelHelpers.export(exports, "faFaceMehBlank", ()=>faFaceMehBlank);
parcelHelpers.export(exports, "faMehBlank", ()=>faMehBlank);
parcelHelpers.export(exports, "faEye", ()=>faEye);
parcelHelpers.export(exports, "faFaceSadCry", ()=>faFaceSadCry);
parcelHelpers.export(exports, "faSadCry", ()=>faSadCry);
parcelHelpers.export(exports, "faFileCode", ()=>faFileCode);
parcelHelpers.export(exports, "faWindowMaximize", ()=>faWindowMaximize);
parcelHelpers.export(exports, "faFaceFrown", ()=>faFaceFrown);
parcelHelpers.export(exports, "faFrown", ()=>faFrown);
parcelHelpers.export(exports, "faFloppyDisk", ()=>faFloppyDisk);
parcelHelpers.export(exports, "faSave", ()=>faSave);
parcelHelpers.export(exports, "faCommentDots", ()=>faCommentDots);
parcelHelpers.export(exports, "faCommenting", ()=>faCommenting);
parcelHelpers.export(exports, "faFaceGrinSquint", ()=>faFaceGrinSquint);
parcelHelpers.export(exports, "faGrinSquint", ()=>faGrinSquint);
parcelHelpers.export(exports, "faHandPointer", ()=>faHandPointer);
parcelHelpers.export(exports, "faHandScissors", ()=>faHandScissors);
parcelHelpers.export(exports, "faFaceGrinTears", ()=>faFaceGrinTears);
parcelHelpers.export(exports, "faGrinTears", ()=>faGrinTears);
parcelHelpers.export(exports, "faCalendarXmark", ()=>faCalendarXmark);
parcelHelpers.export(exports, "faCalendarTimes", ()=>faCalendarTimes);
parcelHelpers.export(exports, "faFileVideo", ()=>faFileVideo);
parcelHelpers.export(exports, "faFilePdf", ()=>faFilePdf);
parcelHelpers.export(exports, "faComment", ()=>faComment);
parcelHelpers.export(exports, "faEnvelope", ()=>faEnvelope);
parcelHelpers.export(exports, "faHourglass", ()=>faHourglass);
parcelHelpers.export(exports, "faHourglassEmpty", ()=>faHourglassEmpty);
parcelHelpers.export(exports, "faCalendarCheck", ()=>faCalendarCheck);
parcelHelpers.export(exports, "faHardDrive", ()=>faHardDrive);
parcelHelpers.export(exports, "faHdd", ()=>faHdd);
parcelHelpers.export(exports, "faFaceGrinSquintTears", ()=>faFaceGrinSquintTears);
parcelHelpers.export(exports, "faGrinSquintTears", ()=>faGrinSquintTears);
parcelHelpers.export(exports, "faRectangleList", ()=>faRectangleList);
parcelHelpers.export(exports, "faListAlt", ()=>faListAlt);
parcelHelpers.export(exports, "faCalendarPlus", ()=>faCalendarPlus);
parcelHelpers.export(exports, "faCircleLeft", ()=>faCircleLeft);
parcelHelpers.export(exports, "faArrowAltCircleLeft", ()=>faArrowAltCircleLeft);
parcelHelpers.export(exports, "faMoneyBill1", ()=>faMoneyBill1);
parcelHelpers.export(exports, "faMoneyBillAlt", ()=>faMoneyBillAlt);
parcelHelpers.export(exports, "faClock", ()=>faClock);
parcelHelpers.export(exports, "faClockFour", ()=>faClockFour);
parcelHelpers.export(exports, "faKeyboard", ()=>faKeyboard);
parcelHelpers.export(exports, "faClosedCaptioning", ()=>faClosedCaptioning);
parcelHelpers.export(exports, "faImages", ()=>faImages);
parcelHelpers.export(exports, "faFaceGrin", ()=>faFaceGrin);
parcelHelpers.export(exports, "faGrin", ()=>faGrin);
parcelHelpers.export(exports, "faFaceMeh", ()=>faFaceMeh);
parcelHelpers.export(exports, "faMeh", ()=>faMeh);
parcelHelpers.export(exports, "faIdCard", ()=>faIdCard);
parcelHelpers.export(exports, "faDriversLicense", ()=>faDriversLicense);
parcelHelpers.export(exports, "faSun", ()=>faSun);
parcelHelpers.export(exports, "faFaceLaughWink", ()=>faFaceLaughWink);
parcelHelpers.export(exports, "faLaughWink", ()=>faLaughWink);
parcelHelpers.export(exports, "faCircleDown", ()=>faCircleDown);
parcelHelpers.export(exports, "faArrowAltCircleDown", ()=>faArrowAltCircleDown);
parcelHelpers.export(exports, "faThumbsDown", ()=>faThumbsDown);
parcelHelpers.export(exports, "faChessPawn", ()=>faChessPawn);
parcelHelpers.export(exports, "faCreditCard", ()=>faCreditCard);
parcelHelpers.export(exports, "faCreditCardAlt", ()=>faCreditCardAlt);
parcelHelpers.export(exports, "faBell", ()=>faBell);
parcelHelpers.export(exports, "faFile", ()=>faFile);
parcelHelpers.export(exports, "faHospital", ()=>faHospital);
parcelHelpers.export(exports, "faHospitalAlt", ()=>faHospitalAlt);
parcelHelpers.export(exports, "faHospitalWide", ()=>faHospitalWide);
parcelHelpers.export(exports, "faChessRook", ()=>faChessRook);
parcelHelpers.export(exports, "faStarHalf", ()=>faStarHalf);
parcelHelpers.export(exports, "faChessKing", ()=>faChessKing);
parcelHelpers.export(exports, "faCircleUser", ()=>faCircleUser);
parcelHelpers.export(exports, "faUserCircle", ()=>faUserCircle);
parcelHelpers.export(exports, "faCopy", ()=>faCopy);
parcelHelpers.export(exports, "faShareFromSquare", ()=>faShareFromSquare);
parcelHelpers.export(exports, "faShareSquare", ()=>faShareSquare);
parcelHelpers.export(exports, "faCopyright", ()=>faCopyright);
parcelHelpers.export(exports, "faMap", ()=>faMap);
parcelHelpers.export(exports, "faBellSlash", ()=>faBellSlash);
parcelHelpers.export(exports, "faHandLizard", ()=>faHandLizard);
parcelHelpers.export(exports, "faFaceSmile", ()=>faFaceSmile);
parcelHelpers.export(exports, "faSmile", ()=>faSmile);
parcelHelpers.export(exports, "faHandPeace", ()=>faHandPeace);
parcelHelpers.export(exports, "faFaceGrinHearts", ()=>faFaceGrinHearts);
parcelHelpers.export(exports, "faGrinHearts", ()=>faGrinHearts);
parcelHelpers.export(exports, "faBuilding", ()=>faBuilding);
parcelHelpers.export(exports, "faFaceGrinBeamSweat", ()=>faFaceGrinBeamSweat);
parcelHelpers.export(exports, "faGrinBeamSweat", ()=>faGrinBeamSweat);
parcelHelpers.export(exports, "faMoon", ()=>faMoon);
parcelHelpers.export(exports, "faCalendar", ()=>faCalendar);
parcelHelpers.export(exports, "faFaceGrinTongueWink", ()=>faFaceGrinTongueWink);
parcelHelpers.export(exports, "faGrinTongueWink", ()=>faGrinTongueWink);
parcelHelpers.export(exports, "faClone", ()=>faClone);
parcelHelpers.export(exports, "faFaceAngry", ()=>faFaceAngry);
parcelHelpers.export(exports, "faAngry", ()=>faAngry);
parcelHelpers.export(exports, "faRectangleXmark", ()=>faRectangleXmark);
parcelHelpers.export(exports, "faRectangleTimes", ()=>faRectangleTimes);
parcelHelpers.export(exports, "faTimesRectangle", ()=>faTimesRectangle);
parcelHelpers.export(exports, "faWindowClose", ()=>faWindowClose);
parcelHelpers.export(exports, "faPaperPlane", ()=>faPaperPlane);
parcelHelpers.export(exports, "faLifeRing", ()=>faLifeRing);
parcelHelpers.export(exports, "faFaceGrimace", ()=>faFaceGrimace);
parcelHelpers.export(exports, "faGrimace", ()=>faGrimace);
parcelHelpers.export(exports, "faCalendarMinus", ()=>faCalendarMinus);
parcelHelpers.export(exports, "faCircleXmark", ()=>faCircleXmark);
parcelHelpers.export(exports, "faTimesCircle", ()=>faTimesCircle);
parcelHelpers.export(exports, "faXmarkCircle", ()=>faXmarkCircle);
parcelHelpers.export(exports, "faThumbsUp", ()=>faThumbsUp);
parcelHelpers.export(exports, "faWindowMinimize", ()=>faWindowMinimize);
parcelHelpers.export(exports, "faSquareFull", ()=>faSquareFull);
parcelHelpers.export(exports, "faNoteSticky", ()=>faNoteSticky);
parcelHelpers.export(exports, "faStickyNote", ()=>faStickyNote);
parcelHelpers.export(exports, "faFaceSadTear", ()=>faFaceSadTear);
parcelHelpers.export(exports, "faSadTear", ()=>faSadTear);
parcelHelpers.export(exports, "faHandPointLeft", ()=>faHandPointLeft);
var prefix = "far";
var faTrashCan = {
    prefix: "far",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var faTrashAlt = faTrashCan;
var faMessage = {
    prefix: "far",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"
    ]
};
var faCommentAlt = faMessage;
var faFileLines = {
    prefix: "far",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
    ]
};
var faFileAlt = faFileLines;
var faFileText = faFileLines;
var faCalendarDays = {
    prefix: "far",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"
    ]
};
var faCalendarAlt = faCalendarDays;
var faHandPointRight = {
    prefix: "far",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"
    ]
};
var faFaceSmileBeam = {
    prefix: "far",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faSmileBeam = faFaceSmileBeam;
var faFaceGrinStars = {
    prefix: "far",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
    ]
};
var faGrinStars = faFaceGrinStars;
var faAddressBook = {
    prefix: "far",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var faContactBook = faAddressBook;
var faComments = {
    prefix: "far",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
    ]
};
var faPaste = {
    prefix: "far",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M104.6 48H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64h96V400H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H80c0 17.7 14.3 32 32 32h72.4C202 108.4 227.6 96 256 96h62c-7.1-27.6-32.2-48-62-48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464H256c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16l140.1 0L464 243.9V448c0 8.8-7.2 16-16 16zM256 512H448c35.3 0 64-28.7 64-64V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64z"
    ]
};
var faFileClipboard = faPaste;
var faFaceGrinTongueSquint = {
    prefix: "far",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V392.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var faGrinTongueSquint = faFaceGrinTongueSquint;
var faFaceFlushed = {
    prefix: "far",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"
    ]
};
var faFlushed = faFaceFlushed;
var faSquareCaretRight = {
    prefix: "far",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var faCaretSquareRight = faSquareCaretRight;
var faSquareMinus = {
    prefix: "far",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faMinusSquare = faSquareMinus;
var faCompass = {
    prefix: "far",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faSquareCaretDown = {
    prefix: "far",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var faCaretSquareDown = faSquareCaretDown;
var faFaceKissBeam = {
    prefix: "far",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faKissBeam = faFaceKissBeam;
var faLightbulb = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"
    ]
};
var faFlag = {
    prefix: "far",
    iconName: "flag",
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V64 350.5 400v88c0 13.3 10.7 24 24 24s24-10.7 24-24V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8V334.7l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z"
    ]
};
var faSquareCheck = {
    prefix: "far",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var faCheckSquare = faSquareCheck;
var faCircleDot = {
    prefix: "far",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var faDotCircle = faCircleDot;
var faFaceDizzy = {
    prefix: "far",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var faDizzy = faFaceDizzy;
var faFutbol = {
    prefix: "far",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M435.4 361.3l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.1zM256 48l.9 0h-1.8l.9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.7 2-4 2.9l4-2.9zm75.2-226.6l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var faFutbolBall = faFutbol;
var faSoccerBall = faFutbol;
var faPenToSquare = {
    prefix: "far",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"
    ]
};
var faEdit = faPenToSquare;
var faHourglassHalf = {
    prefix: "far",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5H284.2c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67V48H80V67c0 22.1 7 43.4 19.8 61H284.2z"
    ]
};
var faHourglass2 = faHourglassHalf;
var faEyeSlash = {
    prefix: "far",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z"
    ]
};
var faHand = {
    prefix: "far",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5V160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1c0 0 0-.1 0-.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16V95.9c0 0 0 .1 0 .1V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16v55.9c0 0 0 .1 0 .1v80c0 13.3 10.7 24 24 24s24-10.7 24-24V160.1c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16V332.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z"
    ]
};
var faHandPaper = faHand;
var faHandSpock = {
    prefix: "far",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512c-11.2 0-22.5 0-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8c11.2 0 22.5 0 33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
    ]
};
var faFaceKiss = {
    prefix: "far",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faKiss = faFaceKiss;
var faFaceGrinTongue = {
    prefix: "far",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V363.6c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var faGrinTongue = faFaceGrinTongue;
var faChessBishop = {
    prefix: "far",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352H96V325c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3v27h48V338.7c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24H160 104zM52.7 464l16.6-32H250.8l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H279.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
    ]
};
var faFaceGrinWink = {
    prefix: "far",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var faGrinWink = faFaceGrinWink;
var faFaceGrinWide = {
    prefix: "far",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var faGrinAlt = faFaceGrinWide;
var faFaceFrownOpen = {
    prefix: "far",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faFrownOpen = faFaceFrownOpen;
var faHandPointUp = {
    prefix: "far",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M64 64V241.6c5.2-1 10.5-1.6 16-1.6H96V208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0v24c0 66.3 53.7 120 120 120h48c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H120 80zM0 320s0 0 0 0c0-18 6-34.6 16-48V64C16 28.7 44.7 0 80 0s64 28.7 64 64v82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64v64 24c0 92.8-75.2 168-168 168H168C75.2 512 0 436.8 0 344V320zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 16c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM160 240c5.5 0 10.9 .7 16 2v-2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h16zm64 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16V256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v24z"
    ]
};
var faBookmark = {
    prefix: "far",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z"
    ]
};
var faHandPointDown = {
    prefix: "far",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"
    ]
};
var faFolder = {
    prefix: "far",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"
    ]
};
var faFolderBlank = faFolder;
var faUser = {
    prefix: "far",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"
    ]
};
var faSquareCaretLeft = {
    prefix: "far",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var faCaretSquareLeft = faSquareCaretLeft;
var faStar = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
    ]
};
var faChessKnight = {
    prefix: "far",
    iconName: "chess-knight",
    icon: [
        448,
        512,
        [
            9822
        ],
        "f441",
        "M226.6 48H117.3l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1H66.8c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0H226.6C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352H341.3l24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464H379.3l-16.6-32H85.2zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H56.8C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384h297c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
    ]
};
var faFaceLaughSquint = {
    prefix: "far",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var faLaughSquint = faFaceLaughSquint;
var faFaceLaugh = {
    prefix: "far",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faLaugh = faFaceLaugh;
var faFolderOpen = {
    prefix: "far",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"
    ]
};
var faClipboard = {
    prefix: "far",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var faChessQueen = {
    prefix: "far",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352H153l-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432H378.8l16.6 32H116.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H407.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
var faHandBackFist = {
    prefix: "far",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16V264c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V370.2c38-20.1 64-60.1 64-106.2V160c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64v64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6v12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V359.9c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4V224.6c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V142.3 128 64z"
    ]
};
var faHandRock = faHandBackFist;
var faSquareCaretUp = {
    prefix: "far",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var faCaretSquareUp = faSquareCaretUp;
var faChartBar = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faBarChart = faChartBar;
var faWindowRestore = {
    prefix: "far",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 48H208c-17.7 0-32 14.3-32 32V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V336h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256H48V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"
    ]
};
var faSquarePlus = {
    prefix: "far",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var faPlusSquare = faSquarePlus;
var faImage = {
    prefix: "far",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var faFolderClosed = {
    prefix: "far",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H289.9L247 53.1C233.5 39.6 215.2 32 196.1 32H64zM48 96c0-8.8 7.2-16 16-16H196.1c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7H448c8.8 0 16 7.2 16 16v32H48V96zm0 144H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V240z"
    ]
};
var faLemon = {
    prefix: "far",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
    ]
};
var faHandshake = {
    prefix: "far",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176H96V304c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128H544h40 40c8.8 0 16 7.2 16 16V352c0 17.7-14.3 32-32 32H576c-11.8 0-22.2-6.4-27.7-16H463.4c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16H56 96h19.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9 .2 13.2 .6zM544 320V176H496c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var faGem = {
    prefix: "far",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
    ]
};
var faCirclePlay = {
    prefix: "far",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z"
    ]
};
var faPlayCircle = faCirclePlay;
var faCircleCheck = {
    prefix: "far",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
    ]
};
var faCheckCircle = faCircleCheck;
var faCircleStop = {
    prefix: "far",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var faStopCircle = faCircleStop;
var faIdBadge = {
    prefix: "far",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M256 48V64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var faFaceLaughBeam = {
    prefix: "far",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faLaughBeam = faFaceLaughBeam;
var faRegistered = {
    prefix: "far",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80H184c-13.3 0-24 10.7-24 24zm48 88V176h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H208z"
    ]
};
var faAddressCard = {
    prefix: "far",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
    ]
};
var faContactCard = faAddressCard;
var faVcard = faAddressCard;
var faFaceTired = {
    prefix: "far",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var faTired = faFaceTired;
var faFontAwesome = {
    prefix: "far",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V124.2l12.5-2.4c16.7-3.2 31.5-8.5 44.2-13.1l0 0 0 0c3.7-1.3 7.1-2.6 10.4-3.7c15.2-5.2 30.4-9.1 51.2-9.1c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c32.4 0 53.7-6.8 90.5-19.6V342.9l-9.5 3.3c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-16.8 0-31 2-43.9 5c-12.9 3-20.9 16-17.9 28.9s16 20.9 28.9 17.9c9.6-2.2 20.1-3.7 32.9-3.7c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c34.4 0 56.4-7.7 97.8-22.2c7.5-2.6 15.5-5.4 24.4-8.5l16.2-5.5V360 72 38.4L416.2 49.3c-9.7 3.3-18.2 6.3-25.7 8.9c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-27.8 0-48.5 5.5-66.6 11.6c-4.9 1.7-9.3 3.3-13.6 4.8c-11.9 4.3-22 7.9-34.7 10.3L48 75.4V56z"
    ]
};
var faFontAwesomeFlag = faFontAwesome;
var faFontAwesomeLogoFull = faFontAwesome;
var faFaceSmileWink = {
    prefix: "far",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var faSmileWink = faFaceSmileWink;
var faFileWord = {
    prefix: "far",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
    ]
};
var faFilePowerpoint = {
    prefix: "far",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24V336v56c0 13.3 10.7 24 24 24s24-10.7 24-24V360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
    ]
};
var faEnvelopeOpen = {
    prefix: "far",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1V200.5c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
    ]
};
var faFileZipper = {
    prefix: "far",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16h48v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm48 112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H136.6c-14.5 0-27.2 9.7-30.9 23.8zM128 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var faFileArchive = faFileZipper;
var faSquare = {
    prefix: "far",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var faSnowflake = {
    prefix: "far",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4V137.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24z"
    ]
};
var faNewspaper = {
    prefix: "far",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M168 80c-13.3 0-24 10.7-24 24V408c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112C0 98.7 10.7 88 24 88s24 10.7 24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72H440c39.8 0 72 32.2 72 72V408c0 39.8-32.2 72-72 72H72zM176 136c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V136zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var faFaceKissWinkHeart = {
    prefix: "far",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var faKissWinkHeart = faFaceKissWinkHeart;
var faStarHalfStroke = {
    prefix: "far",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"
    ]
};
var faStarHalfAlt = faStarHalfStroke;
var faFileExcel = {
    prefix: "far",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
    ]
};
var faFaceGrinBeam = {
    prefix: "far",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var faGrinBeam = faFaceGrinBeam;
var faObjectUngroup = {
    prefix: "far",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5c0-.1 0-.1 0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3V228.7C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H324.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V123.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H123.3C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3V228.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V123.3c16-6.5 28.9-19.3 35.3-35.3H324.7zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40h45.4c6.5 16 19.3 28.9 35.3 35.3V388.7c-16 6.5-28.9 19.3-35.3 35.3H315.3c-6.5-16-19.3-28.9-35.3-35.3V352H232v36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H516.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V283.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H448v16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm301.5 13c-7.5-1.3-13.2-7.9-13.2-15.8c0-8.8 7.2-16 16-16c7.9 0 14.5 5.7 15.8 13.2l0 .1c.1 .9 .2 1.8 .2 2.7c0 8.8-7.2 16-16 16c-.9 0-1.9-.1-2.8-.2z"
    ]
};
var faCircleRight = {
    prefix: "far",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3V208H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96v57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8L294.6 135.1z"
    ]
};
var faArrowAltCircleRight = faCircleRight;
var faFaceRollingEyes = {
    prefix: "far",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var faMehRollingEyes = faFaceRollingEyes;
var faObjectGroup = {
    prefix: "far",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16H460.2c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8V396.2c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16H115.8c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8V115.8zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zm2.7 64c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var faHeart = {
    prefix: "far",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
    ]
};
var faFaceSurprise = {
    prefix: "far",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var faSurprise = faFaceSurprise;
var faCirclePause = {
    prefix: "far",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var faPauseCircle = faCirclePause;
var faCircle = {
    prefix: "far",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    ]
};
var faCircleUp = {
    prefix: "far",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"
    ]
};
var faArrowAltCircleUp = faCircleUp;
var faFileAudio = {
    prefix: "far",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 272V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376H112c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h17.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
    ]
};
var faFileImage = {
    prefix: "far",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2h48 32 40 72c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
    ]
};
var faCircleQuestion = {
    prefix: "far",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faQuestionCircle = faCircleQuestion;
var faFaceMehBlank = {
    prefix: "far",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faMehBlank = faFaceMehBlank;
var faEye = {
    prefix: "far",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
    ]
};
var faFaceSadCry = {
    prefix: "far",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M400 406.1V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V440.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V406.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48V320c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var faSadCry = faFaceSadCry;
var faFileCode = {
    prefix: "far",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
    ]
};
var faWindowMaximize = {
    prefix: "far",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M.3 89.5C.1 91.6 0 93.8 0 96V224 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224 96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224H464l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"
    ]
};
var faFaceFrown = {
    prefix: "far",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faFrown = faFaceFrown;
var faFloppyDisk = {
    prefix: "far",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var faSave = faFloppyDisk;
var faCommentDots = {
    prefix: "far",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faCommenting = faCommentDots;
var faFaceGrinSquint = {
    prefix: "far",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var faGrinSquint = faFaceGrinSquint;
var faHandPointer = {
    prefix: "far",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16V200c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16V392c0 39.8-32.2 72-72 72H272 212.3h-.9c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V320 64zM176 0c-35.3 0-64 28.7-64 64V261.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2h.9H272h56c66.3 0 120-53.7 120-120V288l0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var faHandScissors = {
    prefix: "far",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"
    ]
};
var faFaceGrinTears = {
    prefix: "far",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"
    ]
};
var faGrinTears = faFaceGrinTears;
var faCalendarXmark = {
    prefix: "far",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var faCalendarTimes = faCalendarXmark;
var faFileVideo = {
    prefix: "far",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"
    ]
};
var faFilePdf = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [
        512,
        512,
        [],
        "f1c1",
        "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
    ]
};
var faComment = {
    prefix: "far",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"
    ]
};
var faEnvelope = {
    prefix: "far",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var faHourglass = {
    prefix: "far",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V67c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445v19H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V445c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM192 289.9l81.5 81.5C293 391 304 417.4 304 445v19H80V445c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67V48H304V67c0 27.6-11 54-30.5 73.5L192 222.1z"
    ]
};
var faHourglassEmpty = faHourglass;
var faCalendarCheck = {
    prefix: "far",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var faHardDrive = {
    prefix: "far",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M64 80c-8.8 0-16 7.2-16 16V258c5.1-1.3 10.5-2 16-2H448c5.5 0 10.9 .7 16 2V96c0-8.8-7.2-16-16-16H64zM48 320v96c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var faHdd = faHardDrive;
var faFaceGrinSquintTears = {
    prefix: "far",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"
    ]
};
var faGrinSquintTears = faFaceGrinSquintTears;
var faRectangleList = {
    prefix: "far",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var faListAlt = faRectangleList;
var faCalendarPlus = {
    prefix: "far",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192zm176 40c-13.3 0-24 10.7-24 24v48H152c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V352h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V256c0-13.3-10.7-24-24-24z"
    ]
};
var faCircleLeft = {
    prefix: "far",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H256V150.3c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"
    ]
};
var faArrowAltCircleLeft = faCircleLeft;
var faMoneyBill1 = {
    prefix: "far",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"
    ]
};
var faMoneyBillAlt = faMoneyBill1;
var faClock = {
    prefix: "far",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var faClockFour = faClock;
var faKeyboard = {
    prefix: "far",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 320H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16z"
    ]
};
var faClosedCaptioning = {
    prefix: "far",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var faImages = {
    prefix: "far",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var faFaceGrin = {
    prefix: "far",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faGrin = faFaceGrin;
var faFaceMeh = {
    prefix: "far",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var faMeh = faFaceMeh;
var faIdCard = {
    prefix: "far",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M528 160V416c0 8.8-7.2 16-16 16H320c0-44.2-35.8-80-80-80H176c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V160H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
    ]
};
var faDriversLicense = faIdCard;
var faSun = {
    prefix: "far",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var faFaceLaughWink = {
    prefix: "far",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
    ]
};
var faLaughWink = faFaceLaughWink;
var faCircleDown = {
    prefix: "far",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H304V160c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32v96H150.3C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"
    ]
};
var faArrowAltCircleDown = faCircleDown;
var faThumbsDown = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"
    ]
};
var faChessPawn = {
    prefix: "far",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120H243.4l10.7 80H205.7L195 272H160 125l-10.7 80H65.9l10.7-80H64c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464H267.3l-16.6-32H69.2L52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h201z"
    ]
};
var faCreditCard = {
    prefix: "far",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
    ]
};
var faCreditCardAlt = faCreditCard;
var faBell = {
    prefix: "far",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112v25.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V208c0-61.9 50.1-112 112-112zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var faFile = {
    prefix: "far",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
    ]
};
var faHospital = {
    prefix: "far",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M232 0c-39.8 0-72 32.2-72 72v8H72C32.2 80 0 112.2 0 152V440c0 39.8 32.2 72 72 72h.2 .2 .2 .2 .2H73h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H75h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H77h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H79h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H82h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H85h.2 .2 .2 .2H86h.2 .2 .2 .2H87h.2 .2 .2 .2H88h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H98h.2 .2 .2 .2H99h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2v0H456h8v0H568c39.8 0 72-32.2 72-72V152c0-39.8-32.2-72-72-72H480V72c0-39.8-32.2-72-72-72H232zM480 128h88c13.3 0 24 10.7 24 24v40H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v48H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56V440c0 13.3-10.7 24-24 24H480V336 128zM72 128h88V464h-.1-.2-.2-.2H159h-.2-.2-.2H158h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H154h-.2-.2-.2H153h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H150h-.2-.2-.2H149h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H146h-.2-.2-.2H145h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H142h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H139h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H136h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H133h-.2-.2-.2-.2-.2-.2-.2-.2H131h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H128h-.2-.2-.2-.2-.2-.2-.2-.2H126h-.2-.2-.2-.2-.2-.2-.2-.2H124h-.2-.2-.2-.2-.2-.2-.2-.2H122h-.2-.2-.2-.2-.2-.2-.2-.2H120h-.2-.2-.2-.2-.2-.2-.2-.2H118h-.2-.2-.2-.2-.2-.2-.2-.2H116h-.2-.2-.2-.2-.2-.2-.2-.2H114h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H111h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H108h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H105h-.2-.2-.2-.2H104h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H100h-.2-.2-.2-.2H99h-.2-.2-.2-.2H98h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H88h-.2-.2-.2-.2H87h-.2-.2-.2-.2H86h-.2-.2-.2-.2H85h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H82h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H79h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H77h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H75h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H73h-.2-.2-.2-.2-.2H72c-13.2 0-24-10.7-24-24V336h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V240h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V152c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24V336 464H368V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H208V72zm88 24v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H344V96c0-8.8-7.2-16-16-16H312c-8.8 0-16 7.2-16 16z"
    ]
};
var faHospitalAlt = faHospital;
var faHospitalWide = faHospital;
var faChessRook = {
    prefix: "far",
    iconName: "chess-rook",
    icon: [
        448,
        512,
        [
            9820
        ],
        "f447",
        "M80 80V192c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352H85.2l9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192V72c0-22.1 17.9-40 40-40H376c22.1 0 40 17.9 40 40V192c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85H314.5l-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4V80H304v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H80zm4.7 384H363.3l-16.6-32H101.2L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H72.8C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384h265zM208 288c-8.8 0-16-7.2-16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H208z"
    ]
};
var faStarHalf = {
    prefix: "far",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4V128.4z"
    ]
};
var faChessKing = {
    prefix: "far",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V56H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v40H59.6C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352h52.3L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6H224 388.4c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352h52.3l54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H248V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V24zM101.2 432H346.8l16.6 32H84.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3H91.5c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512H375.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
    ]
};
var faCircleUser = {
    prefix: "far",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
    ]
};
var faUserCircle = faCircleUser;
var faCopy = {
    prefix: "far",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"
    ]
};
var faShareFromSquare = {
    prefix: "far",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
    ]
};
var faShareSquare = faShareFromSquare;
var faCopyright = {
    prefix: "far",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
    ]
};
var faMap = {
    prefix: "far",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"
    ]
};
var faBellSlash = {
    prefix: "far",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM224 150.3C243.6 117.7 279.3 96 320 96c61.9 0 112 50.1 112 112v25.4c0 32.7 6.4 64.8 18.7 94.5L224 150.3zM406.2 416l-60.9-48H168.3c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6H406.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var faHandLizard = {
    prefix: "far",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H288c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V413.3L281.1 384H136c-39.8 0-72-32.2-72-72s32.2-72 72-72H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H72c-39.8 0-72-32.2-72-72S32.2 64 72 64H281.6c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V316.1c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9H72z"
    ]
};
var faFaceSmile = {
    prefix: "far",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faSmile = faFaceSmile;
var faHandPeace = {
    prefix: "far",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V272 256 224c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192v48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2h-7.4l-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240H144c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120H232c-66.3 0-120-53.7-120-120l0-24 0 0c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16z"
    ]
};
var faFaceGrinHearts = {
    prefix: "far",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var faGrinHearts = faFaceGrinHearts;
var faBuilding = {
    prefix: "far",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"
    ]
};
var faFaceGrinBeamSweat = {
    prefix: "far",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var faGrinBeamSweat = faFaceGrinBeamSweat;
var faMoon = {
    prefix: "far",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"
    ]
};
var faCalendar = {
    prefix: "far",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"
    ]
};
var faFaceGrinTongueWink = {
    prefix: "far",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4V363.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
    ]
};
var faGrinTongueWink = faFaceGrinTongueWink;
var faClone = {
    prefix: "far",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"
    ]
};
var faFaceAngry = {
    prefix: "far",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var faAngry = faFaceAngry;
var faRectangleXmark = {
    prefix: "far",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var faRectangleTimes = faRectangleXmark;
var faTimesRectangle = faRectangleXmark;
var faWindowClose = faRectangleXmark;
var faPaperPlane = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"
    ]
};
var faLifeRing = {
    prefix: "far",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var faFaceGrimace = {
    prefix: "far",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var faGrimace = faFaceGrimace;
var faCalendarMinus = {
    prefix: "far",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM296 352H152c-13.3 0-24-10.7-24-24s10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var faCircleXmark = {
    prefix: "far",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var faTimesCircle = faCircleXmark;
var faXmarkCircle = faCircleXmark;
var faThumbsUp = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"
    ]
};
var faWindowMinimize = {
    prefix: "far",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var faSquareFull = {
    prefix: "far",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M464 48V464H48V48H464zM48 0H0V48 464v48H48 464h48V464 48 0H464 48z"
    ]
};
var faNoteSticky = {
    prefix: "far",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H288V352c0-17.7 14.3-32 32-32h80V96c0-8.8-7.2-16-16-16H64zM288 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320v5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"
    ]
};
var faStickyNote = faNoteSticky;
var faFaceSadTear = {
    prefix: "far",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var faSadTear = faFaceSadTear;
var faHandPointLeft = {
    prefix: "far",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"
    ]
};
var icons = {
    faTrashCan: faTrashCan,
    faTrashAlt: faTrashAlt,
    faMessage: faMessage,
    faCommentAlt: faCommentAlt,
    faFileLines: faFileLines,
    faFileAlt: faFileAlt,
    faFileText: faFileText,
    faCalendarDays: faCalendarDays,
    faCalendarAlt: faCalendarAlt,
    faHandPointRight: faHandPointRight,
    faFaceSmileBeam: faFaceSmileBeam,
    faSmileBeam: faSmileBeam,
    faFaceGrinStars: faFaceGrinStars,
    faGrinStars: faGrinStars,
    faAddressBook: faAddressBook,
    faContactBook: faContactBook,
    faComments: faComments,
    faPaste: faPaste,
    faFileClipboard: faFileClipboard,
    faFaceGrinTongueSquint: faFaceGrinTongueSquint,
    faGrinTongueSquint: faGrinTongueSquint,
    faFaceFlushed: faFaceFlushed,
    faFlushed: faFlushed,
    faSquareCaretRight: faSquareCaretRight,
    faCaretSquareRight: faCaretSquareRight,
    faSquareMinus: faSquareMinus,
    faMinusSquare: faMinusSquare,
    faCompass: faCompass,
    faSquareCaretDown: faSquareCaretDown,
    faCaretSquareDown: faCaretSquareDown,
    faFaceKissBeam: faFaceKissBeam,
    faKissBeam: faKissBeam,
    faLightbulb: faLightbulb,
    faFlag: faFlag,
    faSquareCheck: faSquareCheck,
    faCheckSquare: faCheckSquare,
    faCircleDot: faCircleDot,
    faDotCircle: faDotCircle,
    faFaceDizzy: faFaceDizzy,
    faDizzy: faDizzy,
    faFutbol: faFutbol,
    faFutbolBall: faFutbolBall,
    faSoccerBall: faSoccerBall,
    faPenToSquare: faPenToSquare,
    faEdit: faEdit,
    faHourglassHalf: faHourglassHalf,
    faHourglass2: faHourglass2,
    faEyeSlash: faEyeSlash,
    faHand: faHand,
    faHandPaper: faHandPaper,
    faHandSpock: faHandSpock,
    faFaceKiss: faFaceKiss,
    faKiss: faKiss,
    faFaceGrinTongue: faFaceGrinTongue,
    faGrinTongue: faGrinTongue,
    faChessBishop: faChessBishop,
    faFaceGrinWink: faFaceGrinWink,
    faGrinWink: faGrinWink,
    faFaceGrinWide: faFaceGrinWide,
    faGrinAlt: faGrinAlt,
    faFaceFrownOpen: faFaceFrownOpen,
    faFrownOpen: faFrownOpen,
    faHandPointUp: faHandPointUp,
    faBookmark: faBookmark,
    faHandPointDown: faHandPointDown,
    faFolder: faFolder,
    faFolderBlank: faFolderBlank,
    faUser: faUser,
    faSquareCaretLeft: faSquareCaretLeft,
    faCaretSquareLeft: faCaretSquareLeft,
    faStar: faStar,
    faChessKnight: faChessKnight,
    faFaceLaughSquint: faFaceLaughSquint,
    faLaughSquint: faLaughSquint,
    faFaceLaugh: faFaceLaugh,
    faLaugh: faLaugh,
    faFolderOpen: faFolderOpen,
    faClipboard: faClipboard,
    faChessQueen: faChessQueen,
    faHandBackFist: faHandBackFist,
    faHandRock: faHandRock,
    faSquareCaretUp: faSquareCaretUp,
    faCaretSquareUp: faCaretSquareUp,
    faChartBar: faChartBar,
    faBarChart: faBarChart,
    faWindowRestore: faWindowRestore,
    faSquarePlus: faSquarePlus,
    faPlusSquare: faPlusSquare,
    faImage: faImage,
    faFolderClosed: faFolderClosed,
    faLemon: faLemon,
    faHandshake: faHandshake,
    faGem: faGem,
    faCirclePlay: faCirclePlay,
    faPlayCircle: faPlayCircle,
    faCircleCheck: faCircleCheck,
    faCheckCircle: faCheckCircle,
    faCircleStop: faCircleStop,
    faStopCircle: faStopCircle,
    faIdBadge: faIdBadge,
    faFaceLaughBeam: faFaceLaughBeam,
    faLaughBeam: faLaughBeam,
    faRegistered: faRegistered,
    faAddressCard: faAddressCard,
    faContactCard: faContactCard,
    faVcard: faVcard,
    faFaceTired: faFaceTired,
    faTired: faTired,
    faFontAwesome: faFontAwesome,
    faFontAwesomeFlag: faFontAwesomeFlag,
    faFontAwesomeLogoFull: faFontAwesomeLogoFull,
    faFaceSmileWink: faFaceSmileWink,
    faSmileWink: faSmileWink,
    faFileWord: faFileWord,
    faFilePowerpoint: faFilePowerpoint,
    faEnvelopeOpen: faEnvelopeOpen,
    faFileZipper: faFileZipper,
    faFileArchive: faFileArchive,
    faSquare: faSquare,
    faSnowflake: faSnowflake,
    faNewspaper: faNewspaper,
    faFaceKissWinkHeart: faFaceKissWinkHeart,
    faKissWinkHeart: faKissWinkHeart,
    faStarHalfStroke: faStarHalfStroke,
    faStarHalfAlt: faStarHalfAlt,
    faFileExcel: faFileExcel,
    faFaceGrinBeam: faFaceGrinBeam,
    faGrinBeam: faGrinBeam,
    faObjectUngroup: faObjectUngroup,
    faCircleRight: faCircleRight,
    faArrowAltCircleRight: faArrowAltCircleRight,
    faFaceRollingEyes: faFaceRollingEyes,
    faMehRollingEyes: faMehRollingEyes,
    faObjectGroup: faObjectGroup,
    faHeart: faHeart,
    faFaceSurprise: faFaceSurprise,
    faSurprise: faSurprise,
    faCirclePause: faCirclePause,
    faPauseCircle: faPauseCircle,
    faCircle: faCircle,
    faCircleUp: faCircleUp,
    faArrowAltCircleUp: faArrowAltCircleUp,
    faFileAudio: faFileAudio,
    faFileImage: faFileImage,
    faCircleQuestion: faCircleQuestion,
    faQuestionCircle: faQuestionCircle,
    faFaceMehBlank: faFaceMehBlank,
    faMehBlank: faMehBlank,
    faEye: faEye,
    faFaceSadCry: faFaceSadCry,
    faSadCry: faSadCry,
    faFileCode: faFileCode,
    faWindowMaximize: faWindowMaximize,
    faFaceFrown: faFaceFrown,
    faFrown: faFrown,
    faFloppyDisk: faFloppyDisk,
    faSave: faSave,
    faCommentDots: faCommentDots,
    faCommenting: faCommenting,
    faFaceGrinSquint: faFaceGrinSquint,
    faGrinSquint: faGrinSquint,
    faHandPointer: faHandPointer,
    faHandScissors: faHandScissors,
    faFaceGrinTears: faFaceGrinTears,
    faGrinTears: faGrinTears,
    faCalendarXmark: faCalendarXmark,
    faCalendarTimes: faCalendarTimes,
    faFileVideo: faFileVideo,
    faFilePdf: faFilePdf,
    faComment: faComment,
    faEnvelope: faEnvelope,
    faHourglass: faHourglass,
    faHourglassEmpty: faHourglassEmpty,
    faCalendarCheck: faCalendarCheck,
    faHardDrive: faHardDrive,
    faHdd: faHdd,
    faFaceGrinSquintTears: faFaceGrinSquintTears,
    faGrinSquintTears: faGrinSquintTears,
    faRectangleList: faRectangleList,
    faListAlt: faListAlt,
    faCalendarPlus: faCalendarPlus,
    faCircleLeft: faCircleLeft,
    faArrowAltCircleLeft: faArrowAltCircleLeft,
    faMoneyBill1: faMoneyBill1,
    faMoneyBillAlt: faMoneyBillAlt,
    faClock: faClock,
    faClockFour: faClockFour,
    faKeyboard: faKeyboard,
    faClosedCaptioning: faClosedCaptioning,
    faImages: faImages,
    faFaceGrin: faFaceGrin,
    faGrin: faGrin,
    faFaceMeh: faFaceMeh,
    faMeh: faMeh,
    faIdCard: faIdCard,
    faDriversLicense: faDriversLicense,
    faSun: faSun,
    faFaceLaughWink: faFaceLaughWink,
    faLaughWink: faLaughWink,
    faCircleDown: faCircleDown,
    faArrowAltCircleDown: faArrowAltCircleDown,
    faThumbsDown: faThumbsDown,
    faChessPawn: faChessPawn,
    faCreditCard: faCreditCard,
    faCreditCardAlt: faCreditCardAlt,
    faBell: faBell,
    faFile: faFile,
    faHospital: faHospital,
    faHospitalAlt: faHospitalAlt,
    faHospitalWide: faHospitalWide,
    faChessRook: faChessRook,
    faStarHalf: faStarHalf,
    faChessKing: faChessKing,
    faCircleUser: faCircleUser,
    faUserCircle: faUserCircle,
    faCopy: faCopy,
    faShareFromSquare: faShareFromSquare,
    faShareSquare: faShareSquare,
    faCopyright: faCopyright,
    faMap: faMap,
    faBellSlash: faBellSlash,
    faHandLizard: faHandLizard,
    faFaceSmile: faFaceSmile,
    faSmile: faSmile,
    faHandPeace: faHandPeace,
    faFaceGrinHearts: faFaceGrinHearts,
    faGrinHearts: faGrinHearts,
    faBuilding: faBuilding,
    faFaceGrinBeamSweat: faFaceGrinBeamSweat,
    faGrinBeamSweat: faGrinBeamSweat,
    faMoon: faMoon,
    faCalendar: faCalendar,
    faFaceGrinTongueWink: faFaceGrinTongueWink,
    faGrinTongueWink: faGrinTongueWink,
    faClone: faClone,
    faFaceAngry: faFaceAngry,
    faAngry: faAngry,
    faRectangleXmark: faRectangleXmark,
    faRectangleTimes: faRectangleTimes,
    faTimesRectangle: faTimesRectangle,
    faWindowClose: faWindowClose,
    faPaperPlane: faPaperPlane,
    faLifeRing: faLifeRing,
    faFaceGrimace: faFaceGrimace,
    faGrimace: faGrimace,
    faCalendarMinus: faCalendarMinus,
    faCircleXmark: faCircleXmark,
    faTimesCircle: faTimesCircle,
    faXmarkCircle: faXmarkCircle,
    faThumbsUp: faThumbsUp,
    faWindowMinimize: faWindowMinimize,
    faSquareFull: faSquareFull,
    faNoteSticky: faNoteSticky,
    faStickyNote: faStickyNote,
    faFaceSadTear: faFaceSadTear,
    faSadTear: faSadTear,
    faHandPointLeft: faHandPointLeft
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44FfA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MobileDetailsModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactstrap = require("reactstrap");
var _rbac = require("../../Constants/RBAC");
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _dm1FaultsConstants = require("../../Lib/DM1FaultsConstants");
var _dm1FaultsConstantsDefault = parcelHelpers.interopDefault(_dm1FaultsConstants);
var _j1939DictionaryJson = require("../../Static/j1939Dictionary.json");
var _j1939DictionaryJsonDefault = parcelHelpers.interopDefault(_j1939DictionaryJson);
var _conditionColumn = require("./ConditionColumn");
var _conditionColumnDefault = parcelHelpers.interopDefault(_conditionColumn);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
const DM_CONSTANTS = new (0, _dm1FaultsConstantsDefault.default)();
const ICON_DISPLAY_MAP = new Map([
    [
        "alerts:positive",
        "text-alert-orange"
    ],
    [
        "alerts:negative",
        "text-icon-link-gray"
    ],
    [
        "dm1:positive",
        "text-active-dm"
    ],
    [
        "dm1:negative",
        "text-icon-link-gray"
    ]
]);
function getDm1DisplayName(SPN, FMI) {
    const spnName = (0, _j1939DictionaryJsonDefault.default)[SPN] ? (0, _j1939DictionaryJsonDefault.default)[SPN].SPN_Name : SPN;
    return `${spnName} - ${DM_CONSTANTS.listFMIname[FMI]}`;
}
function getSourceDisplayName(SourceAddress) {
    return DM_CONSTANTS.listSourceAddress[SourceAddress] || "Unknown SA";
}
function truncateValue(value) {
    return Number.isInteger(value) ? value : Number(value).toFixed(2);
}
const AlertSignals = ({ AlertData })=>{
    if (!Array.isArray(AlertData.signals)) return;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "container-fluid three-quarter-text",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "row flex-no-wrap mb-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col",
                        children: "Signal"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col",
                        children: "Condition"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "col",
                        children: "Value"
                    })
                ]
            }),
            AlertData.signals.map(({ name, signalID, type, threshold, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "row flex-nowrap my-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col",
                            children: name
                        }),
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditionColumnDefault.default), {
                                threshold: threshold,
                                type: type
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "col text-alert-orange",
                            children: truncateValue(value)
                        })
                    ]
                }, `${signalID}:${value}`))
        ]
    });
};
AlertSignals.propTypes = {
    AlertData: (0, _propTypesDefault.default).shape({
        description: (0, _propTypes.oneOfType)([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
        ]),
        signals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            name: (0, _propTypesDefault.default).string,
            signalID: (0, _propTypesDefault.default).string,
            threshold: (0, _propTypes.oneOfType)([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).string
            ]),
            type: (0, _propTypesDefault.default).string,
            value: (0, _propTypesDefault.default).number
        }))
    })
};
const Dm1Details = ({ SPN, FMI, SourceAddress, TriggeredAt, OC })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "my-4 nine-tenth-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-muted mb-2",
                        children: "Detected At"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: (0, _momentDefault.default)(TriggeredAt).format("MMM Do - h:mma")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "my-4 nine-tenth-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-muted mb-2",
                        children: "SPN"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: SPN
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "my-4 nine-tenth-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-muted mb-2",
                        children: "FMI"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: FMI
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "my-4 nine-tenth-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-muted mb-2",
                        children: "Source"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: getSourceDisplayName(SourceAddress)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "my-4 nine-tenth-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-muted mb-2",
                        children: "Occurrences"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: OC
                    })
                ]
            })
        ]
    });
Dm1Details.propTypes = {
    FMI: (0, _propTypesDefault.default).number,
    SPN: (0, _propTypesDefault.default).number,
    OC: (0, _propTypesDefault.default).number,
    SourceAddress: (0, _propTypesDefault.default).number,
    TriggeredAt: (0, _propTypesDefault.default).string
};
function MobileDetailsModal({ isOpen, toggleModal, alert, tab, handleRuleLinkClick, assetView }) {
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const isRuleAlert = tab === "alerts";
    const { Transition, GatewayId, GatewayName, SPN, FMI, OrgId, RuleId, RuleName, AlertData } = alert;
    const TEXT_COLOR = ICON_DISPLAY_MAP.get(`${tab}:${Transition}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        className: "m-0 h-100 mh-100",
        contentClassName: "h-100 mh-100 w-100 border-0 rounded-0",
        scrollable: true,
        toggle: ()=>toggleModal(!isOpen),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-0 pb-0",
                toggle: ()=>toggleModal(!isOpen)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "pt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        className: `mt-3 mb-4 ${TEXT_COLOR}`,
                        children: `${isRuleAlert ? "Alert" : "DM1 Fault"} Details`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-muted mb-2",
                                children: "Name"
                            }),
                            isRuleAlert ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn btn-link p-0 text-decoration-none",
                                        disabled: true,
                                        onClick: ()=>null,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: TEXT_COLOR,
                                            children: RuleName
                                        })
                                    }),
                                orgID: OrgId,
                                perform: (0, _rbac.ASSET_MODEL_READ),
                                resource: (0, _rbac.ASSET_MODEL),
                                yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>handleRuleLinkClick(GatewayId, RuleId),
                                        className: "btn btn-link p-0 text-decoration-none",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: TEXT_COLOR,
                                            children: RuleName
                                        })
                                    })
                            }) : getDm1DisplayName(SPN, FMI)
                        ]
                    }),
                    assetView ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-muted mb-2",
                                children: "Asset"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn btn-link p-0",
                                        disabled: true,
                                        children: GatewayName
                                    }),
                                orgID: OrgId,
                                perform: (0, _rbac.CORE_READ),
                                resource: (0, _rbac.CORE),
                                yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: {
                                            pathname: `/asset/${GatewayId}`,
                                            search: "?tab=dashboard"
                                        },
                                        replace: true,
                                        children: GatewayName
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-muted mb-2",
                                children: "Organization"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-dark",
                                children: orgsMap?.[OrgId]?.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-muted mb-2",
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: TEXT_COLOR,
                                children: Transition === "positive" ? "Active" : "Inactive"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                        className: "my-4"
                    }),
                    isRuleAlert ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertSignals, {
                        AlertData: AlertData
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Dm1Details, {
                        ...alert
                    })
                ]
            })
        ]
    });
}
MobileDetailsModal.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    tab: (0, _propTypesDefault.default).oneOf([
        "alerts",
        "dm1"
    ]),
    alert: (0, _propTypesDefault.default).shape({
        AlertData: (0, _propTypesDefault.default).shape({
            description: (0, _propTypes.oneOfType)([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
            ]),
            signals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                name: (0, _propTypesDefault.default).string,
                signalID: (0, _propTypesDefault.default).string,
                threshold: (0, _propTypes.oneOfType)([
                    (0, _propTypesDefault.default).number,
                    (0, _propTypesDefault.default).string
                ]),
                type: (0, _propTypesDefault.default).string,
                value: (0, _propTypesDefault.default).number
            }))
        }),
        Canbus: (0, _propTypesDefault.default).number,
        CreatedAt: (0, _propTypesDefault.default).string,
        DetectedAt: (0, _propTypesDefault.default).string,
        FMI: (0, _propTypesDefault.default).number,
        GatewayId: (0, _propTypesDefault.default).string,
        GatewayName: (0, _propTypesDefault.default).string,
        GpsData: (0, _propTypesDefault.default).shape({
            Lat: (0, _propTypesDefault.default).number,
            Long: (0, _propTypesDefault.default).number
        }),
        Id: (0, _propTypesDefault.default).string,
        OC: (0, _propTypesDefault.default).number,
        OrgId: (0, _propTypesDefault.default).string,
        RuleId: (0, _propTypesDefault.default).string,
        RuleName: (0, _propTypesDefault.default).string,
        Severity: (0, _propTypesDefault.default).string,
        SourceAddress: (0, _propTypesDefault.default).number,
        SPN: (0, _propTypesDefault.default).number,
        Transition: (0, _propTypesDefault.default).oneOf([
            "positive",
            "negative"
        ]),
        TriggeredAt: (0, _propTypesDefault.default).string,
        Type: (0, _propTypesDefault.default).oneOf([
            "rule"
        ]),
        UpdatedAt: (0, _propTypesDefault.default).string
    }),
    handleRuleLinkClick: (0, _propTypesDefault.default).func,
    assetView: (0, _propTypesDefault.default).bool
};
MobileDetailsModal.defaultProps = {
    alert: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","moment":"1e4qG","reactstrap":"kjd7g","../../Constants/RBAC":"ieo1E","../../Context/OrgsMapContext":"asozp","../../Lib/DM1FaultsConstants":"5zTZ5","../../Static/j1939Dictionary.json":"3xmN5","./ConditionColumn":"f40Je","../../RBAC/Can":"l4l8D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFZ4N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MobileFiltersModal);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _searchByOrgDropdown = require("./SearchByOrgDropdown");
var _searchByOrgDropdownDefault = parcelHelpers.interopDefault(_searchByOrgDropdown);
var _statusSelectDropdown = require("./StatusSelectDropdown");
var _statusSelectDropdownDefault = parcelHelpers.interopDefault(_statusSelectDropdown);
var _searchByNameDropdown = require("./SearchByNameDropdown");
var _searchByNameDropdownDefault = parcelHelpers.interopDefault(_searchByNameDropdown);
const { className, styles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1935516619",
        children: ".modal-dialog.jsx-1935516619{margin-top:75px;}"
    }),
    className: "jsx-1935516619"
};
function MobileFiltersModal(props) {
    const { asset, assetView, handleAssetSelected, handleEcosystemToggle, handleOrgSelected, handleRuleSelected, handleStatusSelected, includeChildren, isOpen, orgIdFilter, selectedStatus, tab, toggleModal } = props;
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {}, { primary_alert } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const handleToggle = (0, _react.useCallback)(()=>{
        handleEcosystemToggle(true);
    }, [
        handleEcosystemToggle
    ]), orgID = (0, _react.useMemo)(()=>assetView ? asset?.orgID : orgIdFilter || currentOrg?._id, [
        assetView,
        asset?.orgID,
        currentOrg?._id,
        orgIdFilter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        className: className,
        backdropClassName: "bg-transparent",
        toggle: ()=>toggleModal(!isOpen),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-muted mb-3",
                        children: "Filters"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-weight-lighter nine-tenth-text text-muted",
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusSelectDropdownDefault.default), {
                                selectedStatus: selectedStatus,
                                handleStatusSelected: handleStatusSelected,
                                mobileView: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: assetView ? "d-none" : "mb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-weight-lighter nine-tenth-text text-muted",
                                children: "Asset"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByNameDropdownDefault.default), {
                                orgID: orgID,
                                resource: "Asset",
                                handleAssetSelected: handleAssetSelected,
                                mobileView: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: tab === "dm1" ? "d-none" : "",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-weight-lighter nine-tenth-text text-muted",
                                children: "Rule"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByNameDropdownDefault.default), {
                                orgID: orgID,
                                resource: "Rule",
                                handleRuleSelected: handleRuleSelected,
                                mobileView: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: assetView ? "d-none" : "mt-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "font-weight-lighter nine-tenth-text text-muted",
                                children: "Organization"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchByOrgDropdownDefault.default), {
                                handleEcosystemToggle: handleEcosystemToggle,
                                handleOrgSelected: handleOrgSelected,
                                includeChildren: includeChildren,
                                mobileView: true,
                                orgID: orgID,
                                orgIdFilter: orgIdFilter
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: assetView ? "d-none" : "mt-2 d-flex align-items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                checked: includeChildren ?? false,
                                checkedIcon: false,
                                height: 15,
                                id: "ecosystem-toggle",
                                onChange: handleToggle,
                                onColor: primary_alert,
                                uncheckedIcon: false,
                                width: 30
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 ml-2 three-quarter-text modal-inputlabel-text",
                                children: "Show Ecosystem Events"
                            })
                        ]
                    })
                ]
            }),
            styles
        ]
    });
}
MobileFiltersModal.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    assetView: (0, _propTypesDefault.default).bool,
    handleAssetSelected: (0, _propTypesDefault.default).func,
    handleEcosystemToggle: (0, _propTypesDefault.default).func,
    handleOrgSelected: (0, _propTypesDefault.default).func,
    handleRuleSelected: (0, _propTypesDefault.default).func,
    handleStatusSelected: (0, _propTypesDefault.default).func,
    includeChildren: (0, _propTypesDefault.default).bool,
    isOpen: (0, _propTypesDefault.default).bool,
    orgIdFilter: (0, _propTypesDefault.default).string,
    selectedStatus: (0, _propTypesDefault.default).oneOf([
        "all",
        "positive",
        "negative"
    ]),
    tab: (0, _propTypesDefault.default).oneOf([
        "alerts",
        "dm1"
    ]),
    toggleModal: (0, _propTypesDefault.default).func
};
MobileFiltersModal.defaultProps = {
    asset: {},
    currentOrg: {}
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","prop-types":"bnNSm","react":"9njXz","reactstrap":"kjd7g","react-switch":"7hX7V","../../Context/BrandingContext":"bKKTd","../../Context/CurrentOrgContext":"jQXcJ","./SearchByOrgDropdown":"h1xko","./StatusSelectDropdown":"8UkgS","./SearchByNameDropdown":"dFb3a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ico1g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const propTypes = {
    clearRequestPending: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    isOpen: (0, _propTypesDefault.default).bool,
    handleClearAlertClick: (0, _propTypesDefault.default).func,
    provisionName: (0, _propTypesDefault.default).string,
    toggleModal: (0, _propTypesDefault.default).func
};
const defaultProps = {
    clearRequestPending: null,
    error: "",
    isOpen: null,
    handleClearAlertClick: ()=>{},
    provisionName: "",
    toggleModal: ()=>{}
};
const ClearAlertModal = ({ clearRequestPending, isOpen, toggleModal, error, handleClearAlertClick })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        centered: true,
        contentClassName: "rounded-lg",
        isOpen: isOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: toggleModal,
                className: "border-bottom-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "jsx-346040102 font-weight-normal",
                    children: "Clear Alert?"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "d-flex flex-column pt-0 font-weight-light description-text text-muted",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-346040102",
                        children: "Once cleared, this alert will return back to an inactive state until it is triggered again."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-346040102 pb-4",
                        children: "Are you sure?"
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-346040102 text-danger",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "justify-content-between justify-content-md-end border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-346040102 btn btn-sm btn-outline-secondary ml-md-4 px-4 py-0 nine-tenth-text",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleClearAlertClick,
                        className: "jsx-346040102 btn modal-button-submit px-3 py-0 nine-tenth-text text-nowrap",
                        children: clearRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            size: "lg",
                            className: "m-1"
                        }) : "Clear Alert"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "346040102",
                children: ".description-text.jsx-346040102{font-size:0.75rem;}@media (min-width:768px){.description-text.jsx-346040102{font-size:1rem;}}"
            })
        ]
    });
};
ClearAlertModal.propTypes = propTypes;
ClearAlertModal.defaultProps = defaultProps;
exports.default = /*#__PURE__*/ (0, _react.memo)(ClearAlertModal);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asYLH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetDM1FaultsContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _assetDM1FaultsDisplay = require("./AssetDM1FaultsDisplay");
var _assetDM1FaultsDisplayDefault = parcelHelpers.interopDefault(_assetDM1FaultsDisplay);
var _alertAndDmRequestHelper = require("../../Lib/AlertAndDmRequestHelper");
var _alertAndDmRequestHelperDefault = parcelHelpers.interopDefault(_alertAndDmRequestHelper);
const SORT_DIRECTIONS = [
    "ASC",
    "DESC"
];
const limit = 20;
const initState = {
    dataLoading: true,
    selectedStatus: "positive",
    ruleIdFilter: null,
    sort: "TriggeredAt",
    order: "DESC",
    page: 1,
    dataCount: 0,
    error: "",
    spnFilter: null,
    fmiFilter: null,
    saFilter: null,
    canbusFilter: null
};
const refreshState = {
    dataLoading: true,
    page: 1,
    dataCount: 0,
    data: []
};
function AssetDM1FaultsContainer(props) {
    const { asset: { _id: assetID, orgID } } = props;
    const [state, updateState] = (0, _react.useState)(initState);
    const [error, setError] = (0, _react.useState)("");
    const spnFilterRef = (0, _react.useRef)(null);
    const fmiFilterRef = (0, _react.useRef)(null);
    const saFilterRef = (0, _react.useRef)(null);
    const canbusFilterRef = (0, _react.useRef)(null);
    const [showMobileFilters, toggleMobileFilters] = (0, _react.useState)(false);
    let source = (0, _axios.CancelToken).source();
    const handleSortClick = (nextSortBy)=>{
        const { sort } = state;
        switch(true){
            case nextSortBy === sort:
                {
                    const [order] = SORT_DIRECTIONS.filter((d)=>d !== state.order);
                    updateAlertsState({
                        page: 1,
                        order
                    });
                    break;
                }
            default:
                updateAlertsState({
                    page: 1,
                    sort: nextSortBy,
                    order: "DESC"
                });
        }
    };
    const setSelectedStatus = (selectedStatus, mobileView)=>{
        if (selectedStatus === state.selectedStatus) return;
        updateState({
            ...state,
            ...refreshState,
            selectedStatus
        });
        mobileView && toggleMobileFilters(false);
    };
    const setPage = (page)=>{
        if (page === state.page) return;
        updateAlertsState({
            page
        });
    };
    const setDmFilter = (value, filter)=>{
        if (value) updateState({
            ...state,
            ...refreshState,
            [`${filter}Filter`]: value.value
        });
        else updateState({
            ...state,
            ...refreshState,
            [`${filter}Filter`]: null
        });
    };
    const fetchAlertMetrics = async ()=>{
        try {
            const request = new (0, _alertAndDmRequestHelperDefault.default)({
                ...state,
                orgID,
                gatewayIdFilter: assetID
            });
            const { Count } = await request.fetchDM1Metrics(source.token);
            return Count || 0;
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) setError(err.response?.data?.message ?? err.message);
            return 0;
        }
    };
    const fetchDM1s = async ({ page, sort, order } = {})=>{
        try {
            const request = new (0, _alertAndDmRequestHelperDefault.default)({
                ...state,
                orgID,
                orgIdFilter: orgID,
                limit,
                gatewayIdFilter: assetID,
                page: page || state.page,
                sort: sort || state.sort,
                order: order || state.order
            });
            const DmAlerts = await request.fetchDM1s(source.token);
            return DmAlerts || [];
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) setError(err.response?.data?.message ?? err.message);
            return [];
        }
    };
    const updateCountAndAlertsState = async ()=>{
        try {
            const [dataCount, data] = await Promise.all([
                fetchAlertMetrics(),
                fetchDM1s()
            ]);
            updateState({
                ...state,
                dataCount,
                data,
                dataLoading: false
            });
        } catch (err) {
            setError(err.message);
            updateState({
                ...state,
                dataLoading: false
            });
        }
    };
    const updateAlertsState = async (params)=>{
        try {
            const data = await fetchDM1s(params);
            updateState({
                ...state,
                data,
                ...params,
                dataLoading: false
            });
        } catch (err) {
            setError(err.message);
            updateState({
                ...state,
                dataLoading: false
            });
        }
    };
    (0, _react.useEffect)(()=>{
        if (!assetID) return;
        source = (0, _axios.CancelToken).source();
        updateCountAndAlertsState();
    }, [
        assetID,
        state.selectedStatus,
        state.saFilter,
        state.fmiFilter,
        state.spnFilter,
        state.canbusFilter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetDM1FaultsDisplayDefault.default), {
        ...state,
        ...props,
        tab: "dm1",
        handleStatusSelected: setSelectedStatus,
        handleDmFilterSelected: setDmFilter,
        sort: {
            by: state.sort,
            direction: state.order
        },
        handleSortClick: handleSortClick,
        pages: Math.ceil(state.dataCount / limit),
        handlePageChange: setPage,
        spnFilterRef: spnFilterRef,
        fmiFilterRef: fmiFilterRef,
        saFilterRef: saFilterRef,
        canbusFilterRef: canbusFilterRef,
        error: error,
        setError: setError,
        showMobileFilters: showMobileFilters,
        toggleMobileFilters: toggleMobileFilters
    });
}
AssetDM1FaultsContainer.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    currentUser: (0, _propTypesDefault.default).object,
    currentOrg: (0, _propTypesDefault.default).object,
    orgsMap: (0, _propTypesDefault.default).object,
    width: (0, _propTypesDefault.default).number
};
AssetDM1FaultsContainer.defaultProps = {
    currentUser: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","./AssetDM1FaultsDisplay":"e6EUU","../../Lib/AlertAndDmRequestHelper":"kBVH9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e6EUU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetDM1FaultsDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _activeAlertsBanner = require("../Events/ActiveAlertsBanner");
var _activeAlertsBannerDefault = parcelHelpers.interopDefault(_activeAlertsBanner);
var _alertAndDmTable = require("../Events/AlertAndDmTable");
var _alertAndDmTableDefault = parcelHelpers.interopDefault(_alertAndDmTable);
var _alertCard = require("../Events/AlertCard");
var _alertCardDefault = parcelHelpers.interopDefault(_alertCard);
var _mobileFiltersModal = require("../Events/MobileFiltersModal");
var _mobileFiltersModalDefault = parcelHelpers.interopDefault(_mobileFiltersModal);
var _paginationFooter = require("../PaginationFooter");
var _paginationFooterDefault = parcelHelpers.interopDefault(_paginationFooter);
var _zIndex = require("../../Styles/Z-INDEX");
function AssetDM1FaultsDisplay(props) {
    const { asset, tab, data, dataLoading, page, pages, handlePageChange, toggleMobileFilters, showMobileFilters, error } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "d-lg-none btn btn-link p-0 text-decoration-none shadow-none position-absolute",
                onClick: ()=>toggleMobileFilters(!showMobileFilters),
                style: {
                    right: "0.5rem",
                    top: "-5.7rem",
                    zIndex: (0, _zIndex.STICKY_OVERRIDE)
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    className: "text-brand-primary",
                    icon: (0, _freeSolidSvgIcons.faSlidersH),
                    size: "lg"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2528245249 outer-dm1-component-wrapper position-absolute container-fluid h-100 pt-3 pt-lg-0 rounded-lg d-flex flex-column",
                children: [
                    asset.orgID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activeAlertsBannerDefault.default), {
                        ...props,
                        assetView: true,
                        orgID: asset.orgID,
                        gatewayIdFilter: asset._id
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2528245249 d-none d-lg-flex row flex-fill",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertAndDmTableDefault.default), {
                            ...props,
                            assetView: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2528245249 d-lg-none row flex-fill position-relative",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-2528245249 position-absolute h-100 w-100 overflow-auto",
                            children: data.map((a)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertCardDefault.default), {
                                    alert: a,
                                    tab: tab,
                                    assetView: true
                                }, a.Id))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2528245249 row justify-content-end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-2528245249 col-12 text-danger three-quarter-text text-right",
                            children: error
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2528245249 py-1 py-lg-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationFooterDefault.default), {
                            handlePageChange: handlePageChange,
                            page: page,
                            pages: pages,
                            rowsLength: data?.length,
                            rowsLoading: dataLoading
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileFiltersModalDefault.default), {
                        isOpen: showMobileFilters,
                        toggleModal: toggleMobileFilters,
                        assetView: true,
                        ...props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                        id: "2528245249",
                        children: "@media (min-width:992px){.outer-dm1-component-wrapper.jsx-2528245249{background-color:white;}.table-container.jsx-2528245249{height:calc(100% - 7rem);overflow-y:scroll;}}"
                    })
                ]
            })
        ]
    });
}
AssetDM1FaultsDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    dataLoading: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    fmiFilterRef: (0, _propTypesDefault.default).object,
    handleDmFilterSelected: (0, _propTypesDefault.default).func,
    handlePageChange: (0, _propTypesDefault.default).func,
    handleSortClick: (0, _propTypesDefault.default).func,
    handleStatusSelected: (0, _propTypesDefault.default).func,
    page: (0, _propTypesDefault.default).number,
    pages: (0, _propTypesDefault.default).number,
    saFilterRef: (0, _propTypesDefault.default).object,
    selectedStatus: (0, _propTypesDefault.default).oneOf([
        "positive",
        "negative",
        "all"
    ]),
    setError: (0, _propTypesDefault.default).func,
    showMobileFilters: (0, _propTypesDefault.default).bool,
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "TriggeredAt",
            "DetectedAt"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "ASC",
            "DESC"
        ])
    }),
    spnFilterRef: (0, _propTypesDefault.default).object,
    tab: (0, _propTypesDefault.default).oneOf([
        "dm1"
    ]),
    toggleMobileFilters: (0, _propTypesDefault.default).func
};
AssetDM1FaultsDisplay.defaultProps = {
    asset: {},
    data: []
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../Events/ActiveAlertsBanner":"bcX8h","../Events/AlertAndDmTable":"kzvBX","../Events/AlertCard":"2U5oi","../Events/MobileFiltersModal":"eFZ4N","../PaginationFooter":"kV15Q","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bhv9t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetSubscriptionsContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _currentOrgContext = require("../../Context/CurrentOrgContext");
var _currentOrgContextDefault = parcelHelpers.interopDefault(_currentOrgContext);
var _currentUserContext = require("../../Context/CurrentUserContext");
var _currentUserContextDefault = parcelHelpers.interopDefault(_currentUserContext);
var _gatewayReminderInstanceService = require("../../Services/GatewayReminderInstanceService");
var _gatewayReminderInstanceServiceDefault = parcelHelpers.interopDefault(_gatewayReminderInstanceService);
var _ruleService = require("../../Services/RuleService");
var _ruleServiceDefault = parcelHelpers.interopDefault(_ruleService);
var _subscriptionService = require("../../Services/SubscriptionService");
var _subscriptionServiceDefault = parcelHelpers.interopDefault(_subscriptionService);
var _assetSubscriptionsDisplay = require("./AssetSubscriptionsDisplay");
var _assetSubscriptionsDisplayDefault = parcelHelpers.interopDefault(_assetSubscriptionsDisplay);
const limit = 100;
const initState = {
    maintenanceState: {
        count: 0,
        instances: []
    },
    ruleState: {
        Count: 0,
        Rules: []
    },
    selectedUser: {},
    showSubscribeNonPlatformUserModal: false,
    subscriptionPending: true,
    subscriptions: new Map()
};
function AssetSubscriptionsContainer(props) {
    const { asset: { _id: gatewayIdFilter, orgID, gtemplate, gtemplateID: sourceIdFilter }, handleSubscriptionAlert } = props;
    const currentOrg = (0, _react.useContext)((0, _currentOrgContextDefault.default)) || {};
    const currentUser = (0, _react.useContext)((0, _currentUserContextDefault.default)) || {};
    const [state, updateState] = (0, _react.useState)(initState);
    const [error, setError] = (0, _react.useState)("");
    const currentUserRef = (0, _react.useRef)(null);
    const reminderInstanceService = (0, _react.useMemo)(()=>new (0, _gatewayReminderInstanceServiceDefault.default)(), []), ruleService = (0, _react.useMemo)(()=>new (0, _ruleServiceDefault.default)(), []), subscriptionService = (0, _react.useMemo)(()=>new (0, _subscriptionServiceDefault.default)(), []);
    const source = (0, _axios.CancelToken).source();
    const commonMaintenanceParams = (0, _react.useMemo)(()=>({
            gateway_id: gatewayIdFilter,
            limit
        }), [
        gatewayIdFilter
    ]), commonRulesParams = (0, _react.useMemo)(()=>({
            orgID,
            orgIdFilter: gtemplate?.orgID ?? orgID
        }), [
        gtemplate?.orgID,
        orgID
    ]), commonSubscriptionsParams = (0, _react.useMemo)(()=>({
            orgID,
            orgIdFilter: orgID
        }), [
        orgID
    ]);
    const maintenanceReminderIdSet = (0, _react.useMemo)(()=>new Set(state.maintenanceState.instances?.map((instance)=>instance?.GtemplateReminder?._id)), [
        state.maintenanceState.instances
    ]);
    const fetchAllReminderInstances = async ()=>{
        try {
            const params = {
                ...commonMaintenanceParams,
                page: 1
            };
            const { count, data } = await reminderInstanceService.getPaginatedGatewayReminderInstances(params, source.token);
            if (data.length <= count) return {
                count,
                instances: data
            };
            const additionalRequests = Math.ceil(count / limit) - 1;
            const requestsArray = new Array(additionalRequests).fill(null).map((_, i)=>reminderInstanceService.fetchAssets({
                    ...commonMaintenanceParams,
                    page: i + 2
                }, source.token));
            const responses = await Promise.all(requestsArray);
            const additionalData = responses.reduce((flatData, { data })=>{
                flatData.push(...data);
                return flatData;
            }, []);
            return {
                count,
                instances: data.concat(additionalData)
            };
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            return {
                count: 0,
                instances: []
            };
        }
    };
    const fetchAllTemplateRules = async ()=>{
        try {
            const rulesParams = {
                ...commonRulesParams,
                sourceIdFilter
            };
            const { Count } = await ruleService.fetchRulesMetrics(rulesParams, source.token);
            if (!Count) return {
                Count: 0,
                Rules: []
            };
            const rulesRequestCount = Math.ceil(Count / limit);
            const rulesRequests = new Array(rulesRequestCount).fill(1).map((x, i)=>{
                return ruleService.fetchPaginatedRules({
                    ...rulesParams,
                    limit,
                    page: i + 1
                }, source.token);
            });
            const responses = await Promise.all(rulesRequests);
            const Rules = responses.reduce((allRules, { Rules: subSet })=>{
                if (!Array.isArray(subSet)) return allRules;
                allRules.push(...subSet);
                return allRules;
            }, []);
            return {
                Count,
                Rules
            };
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            return {
                Count: 0,
                Rules: []
            };
        }
    };
    const fetchAllOrgSubs = async ()=>{
        try {
            const users = currentOrg?.Users.some(({ _id })=>_id === currentUser?._id) ? currentOrg.Users : currentOrg?.Users?.concat?.(currentUser);
            const subsCommonParams = {
                ...commonSubscriptionsParams,
                gatewayIdFilter
            };
            const { Count } = await subscriptionService.fetchUserSubscriptionsToAssetMetrics({
                params: subsCommonParams,
                cancelToken: source.token
            });
            if (!Count) return new Map(users?.map?.(({ _id })=>[
                    _id,
                    []
                ]));
            const reqCount = Math.ceil(Count / limit), reqProms = new Array(reqCount).fill(null).map((_, i)=>subscriptionService.fetchUserSubscriptionsToAsset({
                    params: {
                        ...subsCommonParams,
                        limit,
                        page: i + 1
                    },
                    cancelToken: source.token
                }).then(({ Subscriptions })=>Subscriptions)), Subscriptions = (await Promise.all(reqProms)).flat();
            const subsMaps = Subscriptions.reduce((acc, sub)=>{
                const subString = `${sub.RuleId}:${sub.Notification}:${sub.Id}`;
                if ((0, _staticUUIDs.isValidNotNilUuid)(sub?.UserId)) {
                    const existingUserSubs = acc.platformSubs.get(sub.UserId) || [];
                    acc.platformSubs.set(sub.UserId, [
                        ...existingUserSubs,
                        subString
                    ]);
                    return acc;
                }
                const existingSubs = acc.nonPlatformSubs.get(sub.Destination) || [];
                acc.nonPlatformSubs.set(sub.Destination, [
                    ...existingSubs,
                    subString
                ]);
                return acc;
            }, {
                nonPlatformSubs: new Map(),
                platformSubs: new Map()
            });
            const subs = users?.map?.(({ _id } = {})=>{
                return [
                    _id,
                    subsMaps.platformSubs.get(_id) || []
                ];
            }) ?? [];
            return new Map([
                ...subs,
                ...subsMaps.nonPlatformSubs
            ]);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            return new Map();
        }
    };
    const handleAddSubscription = async (subString)=>{
        try {
            const [RuleId, Notification] = subString.split(":"), { _id: UserId, Destination } = state.selectedUser, isPlatformSub = (0, _staticUUIDs.isValidNotNilUuid)(UserId), conditionalData = isPlatformSub ? {
                UserId
            } : {
                Destination
            }, Trigger = RuleId === "*" ? "dm1" : maintenanceReminderIdSet.has(RuleId) ? "maintenance" : "rule", data = {
                ...conditionalData,
                RuleId,
                Notification,
                GatewayId: gatewayIdFilter,
                Trigger
            }, params = {
                orgID
            };
            const { Id } = await subscriptionService.postSubscription({
                params,
                data,
                cancelToken: source.token
            });
            const subCopy = new Map(state.subscriptions);
            const existingSubs = subCopy.get(isPlatformSub ? UserId : Destination) || [];
            const update = [
                ...existingSubs,
                `${subString}:${Id}`
            ];
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false,
                    subscriptions: subCopy.set(isPlatformSub ? UserId : Destination, update)
                }));
            handleSubscriptionAlert("Added");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false
                }));
        }
    };
    const handleRemoveSubscription = async (subString)=>{
        try {
            const { _id: UserId, Destination } = state.selectedUser;
            const isPlatformSub = (0, _staticUUIDs.isValidNotNilUuid)(UserId);
            const selectedUserSubs = state.subscriptions.get(isPlatformSub ? UserId : Destination) || [];
            const sub = selectedUserSubs.find((s)=>s.includes(subString));
            const [, , subscriptionId] = sub.split(":");
            const params = {
                orgID
            };
            await subscriptionService.deleteSubscription({
                subscriptionId,
                params,
                cancelToken: source.token
            });
            const subCopy = new Map(state.subscriptions);
            const update = subCopy.get(isPlatformSub ? UserId : Destination).filter((s)=>!s.includes(subString));
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false,
                    subscriptions: subCopy.set(isPlatformSub ? UserId : Destination, update)
                }));
            handleSubscriptionAlert("Removed");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false
                }));
        }
    };
    const handleSubscriptionClick = (subString)=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: true
                }));
            const userSubs = state.subscriptions.get(state.selectedUser?._id || state.selectedUser?.Destination) || [];
            const subExists = userSubs.some((s)=>s.includes(subString));
            subExists ? handleRemoveSubscription(subString) : handleAddSubscription(subString);
        } catch (err) {
            setError(err.response?.data?.message ?? err.message);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false
                }));
        }
    };
    const fetchSelectedUserSubscriptions = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: true
                }));
            const { _id: userIdFilter, Destination: destinationFilter } = state.selectedUser;
            const conditionalParam = userIdFilter ? {
                userIdFilter
            } : {
                destinationFilter
            };
            const commonParams = {
                ...conditionalParam,
                gatewayIdFilter,
                orgID,
                orgIdFilter: orgID
            };
            const { Count } = await subscriptionService.fetchUserSubscriptionsToAssetMetrics({
                params: commonParams,
                cancelToken: source.token
            });
            if (!Count) return updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false,
                    subscriptions: new Map(state.subscriptions).set(userIdFilter || destinationFilter, [])
                }));
            const reqCount = Math.ceil(Count / limit), reqProms = new Array(reqCount).fill(null).map((_, i)=>subscriptionService.fetchUserSubscriptionsToAsset({
                    params: {
                        ...commonParams,
                        limit,
                        page: i + 1
                    },
                    cancelToken: source.token
                }).then(({ Subscriptions })=>Subscriptions)), Subscriptions = (await Promise.all(reqProms)).flat();
            const subs = Subscriptions.map((s)=>`${s.RuleId}:${s.Notification}:${s.Id}`);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false,
                    subscriptions: new Map(state.subscriptions).set(userIdFilter || destinationFilter, subs)
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false
                }));
        }
    };
    const handleBatchClick = async (Notification, SourceType)=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: true
                }));
            const params = {
                orgID
            };
            const { _id: UserId, Destination } = state.selectedUser;
            const isPlatformSub = (0, _staticUUIDs.isValidNotNilUuid)(UserId);
            const conditionalData = isPlatformSub ? {
                UserId
            } : {
                Destination
            };
            const data = {
                ...conditionalData,
                Notification,
                SourceId: gatewayIdFilter,
                SourceType
            };
            const cancelToken = source.token;
            const userSubs = state.subscriptions.get(isPlatformSub ? UserId : Destination) || [];
            const isUnsubscribe = userSubs.some((s)=>{
                const [ruleid, notification] = s.split(":");
                switch(true){
                    case ruleid === "*":
                        return false;
                    case SourceType === "gateway":
                        return !maintenanceReminderIdSet.has(ruleid) && notification === Notification;
                    case SourceType === "maintenance-gateway":
                        return maintenanceReminderIdSet.has(ruleid) && notification === Notification;
                    default:
                        return false;
                }
            });
            const serviceMethod = isUnsubscribe ? "unsubscribeAll" : "subscribeAll";
            await subscriptionService[serviceMethod]({
                params,
                data,
                cancelToken
            });
            fetchSelectedUserSubscriptions();
            handleSubscriptionAlert(isUnsubscribe ? "Removed" : "Added");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false
                }));
        }
    };
    const handleNonPlatformSubAdded = async (destinations)=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: true
                }));
            const commonParams = {
                gatewayIdFilter,
                orgID
            };
            const subRequests = destinations.map(async (d)=>{
                const params = {
                    ...commonParams,
                    destinationFilter: d
                };
                const { Count } = await subscriptionService.fetchUserSubscriptionsToAssetMetrics({
                    params,
                    cancelToken: source.token
                });
                if (!Count) return [
                    d,
                    []
                ];
                const { Subscriptions } = await subscriptionService.fetchUserSubscriptionsToAsset({
                    params: {
                        ...params,
                        limit: Count
                    },
                    cancelToken: source.token
                });
                const subs = Subscriptions.map((s)=>`${s.RuleId}:${s.Notification}:${s.Id}`);
                return [
                    d,
                    subs
                ];
            });
            const update = await Promise.all(subRequests);
            updateState((prevState)=>({
                    ...prevState,
                    showSubscribeNonPlatformUserModal: false,
                    subscriptionPending: false,
                    subscriptions: new Map([
                        ...update,
                        ...state.subscriptions
                    ])
                }));
            handleSubscriptionAlert("Added");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false
                }));
        }
    };
    const handleNonPlatformSubRemove = async (Destination)=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: Destination
                }));
            const subscriptions = new Map(state.subscriptions);
            const cancelToken = source.token;
            const data = {
                Destination,
                Notification: Destination.includes("@") ? "email" : "sms",
                SourceId: gatewayIdFilter,
                SourceType: "gateway"
            };
            const params = {
                orgID
            };
            const unsubFromRules = subscriptionService.unsubscribeAll({
                cancelToken,
                data,
                params
            });
            const userSubs = subscriptions.get(Destination) || [];
            const dmSub = userSubs.find((s)=>s.startsWith("*")) || "";
            const [, , subscriptionId] = dmSub.split(":");
            const unsubFromDM = subscriptionId ? subscriptionService.deleteSubscription({
                cancelToken,
                params,
                subscriptionId
            }) : Promise.resolve();
            await Promise.all([
                unsubFromDM,
                unsubFromRules
            ]);
            subscriptions.delete(Destination);
            const removingSelectedUser = state.selectedUser?.Destination === Destination;
            const conditionalSelectedUser = removingSelectedUser ? {
                selectedUser: currentUser
            } : {};
            updateState((prevState)=>({
                    ...prevState,
                    ...conditionalSelectedUser,
                    subscriptionPending: false,
                    subscriptions
                }));
            if (removingSelectedUser && currentUserRef?.current) currentUserRef.current.scrollIntoView();
            handleSubscriptionAlert("Removed");
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            updateState((prevState)=>({
                    ...prevState,
                    subscriptionPending: false
                }));
        }
    };
    const setSelectedUser = (selectedUser)=>{
        updateState((prevState)=>({
                ...prevState,
                selectedUser
            }));
    };
    const toggleNonPlatformSubscriptionModal = ()=>{
        updateState((prevState)=>({
                ...prevState,
                showSubscribeNonPlatformUserModal: !state.showSubscribeNonPlatformUserModal
            }));
    };
    const fetchAllInstancesRulesAndSubs = async ()=>{
        const [maintenanceState, ruleState, subscriptions] = await Promise.all([
            fetchAllReminderInstances(),
            fetchAllTemplateRules(),
            fetchAllOrgSubs()
        ]);
        updateState((prevState)=>({
                ...prevState,
                maintenanceState,
                ruleState,
                subscriptionPending: false,
                subscriptions
            }));
    };
    (0, _react.useEffect)(()=>{
        if (!sourceIdFilter) return;
        fetchAllInstancesRulesAndSubs();
    }, [
        sourceIdFilter
    ]);
    (0, _react.useEffect)(()=>{
        const { _id, firstName, lastName, phoneNumber, settings } = currentUser;
        if (!_id) return;
        setSelectedUser({
            _id,
            firstName,
            lastName,
            phoneNumber,
            settings
        });
        return source.cancel;
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetSubscriptionsDisplayDefault.default), {
        ...props,
        ...state,
        currentOrg: currentOrg,
        currentUser: currentUser,
        currentUserRef: currentUserRef,
        error: error,
        handleBatchClick: handleBatchClick,
        handleNonPlatformSubAdded: handleNonPlatformSubAdded,
        handleNonPlatformSubRemove: handleNonPlatformSubRemove,
        handleSubscriptionClick: handleSubscriptionClick,
        setSelectedUser: setSelectedUser,
        templateID: sourceIdFilter,
        toggleNonPlatformSubscriptionModal: toggleNonPlatformSubscriptionModal
    });
}
AssetSubscriptionsContainer.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        gtemplate: (0, _propTypesDefault.default).object,
        gtemplateID: (0, _propTypesDefault.default).string
    }),
    handleNonPlatformSubAdded: (0, _propTypesDefault.default).func,
    handleSubscriptionAlert: (0, _propTypesDefault.default).func
};
AssetSubscriptionsContainer.defaultProps = {
    asset: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Constants/StaticUUIDs":"cpjYY","../../Context/CurrentOrgContext":"jQXcJ","../../Context/CurrentUserContext":"4sVVe","../../Services/GatewayReminderInstanceService":"WwEop","../../Services/RuleService":"iS4KH","../../Services/SubscriptionService":"9ZnlZ","./AssetSubscriptionsDisplay":"5MPfS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZnlZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class SubscriptionService {
    api = new (0, _requestsDefault.default)();
    buildUserSubscriptionsToAssetMetricsRequest({ params, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/metrics/subscriptions",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchUserSubscriptionsToAssetMetrics(params) {
        const { data = {} } = await this.api.request(this.buildUserSubscriptionsToAssetMetricsRequest(params));
        return data;
    }
    buildUserSubscriptionsToAssetRequest({ params, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/subscriptions",
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchUserSubscriptionsToAsset(params) {
        const { data = {} } = await this.api.request(this.buildUserSubscriptionsToAssetRequest(params));
        return data;
    }
    buildPostSubscriptionRequest({ params, data, cancelToken }) {
        const subId = data.Id ? `/${data.Id}` : "";
        return {
            service: "rules",
            endpoint: `/v1/subscriptions${subId}`,
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async postSubscription(params) {
        const { data } = await this.api.request(this.buildPostSubscriptionRequest(params));
        return data;
    }
    buildDeleteSubscriptionRequest({ subscriptionId, params, cancelToken }) {
        return {
            service: "rules",
            endpoint: `/v1/subscriptions/${subscriptionId}`,
            method: "delete",
            params,
            cancelToken
        };
    }
    async deleteSubscription(params) {
        const { data } = await this.api.request(this.buildDeleteSubscriptionRequest(params));
        return data;
    }
    buildSubscribeAllRequest({ params, data, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/batch/subscribe-all",
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async subscribeAll(params) {
        const { data } = await this.api.request(this.buildSubscribeAllRequest(params));
        return data;
    }
    buildUnsubscribeAllRequest({ params, data, cancelToken }) {
        return {
            service: "rules",
            endpoint: "/v1/batch/unsubscribe-all",
            method: "post",
            params,
            data,
            cancelToken
        };
    }
    async unsubscribeAll(params) {
        const { data } = await this.api.request(this.buildUnsubscribeAllRequest(params));
        return data;
    }
}
exports.default = SubscriptionService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5MPfS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetSubscriptionsDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _reactRouterDom = require("react-router-dom");
var _uuid = require("uuid");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _assetModel = require("../../Constants/AssetModel");
var _rbac = require("../../Constants/RBAC");
var _widthContext = require("../../Context/WidthContext");
var _accessTools = require("../../RBAC/AccessTools");
var _nonPlatformUserSubscriptionModal = require("./NonPlatformUserSubscriptionModal");
var _nonPlatformUserSubscriptionModalDefault = parcelHelpers.interopDefault(_nonPlatformUserSubscriptionModal);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _rule = require("../../Constants/Rule");
function filterUsers(search = "", u, currentOrgUsersMap) {
    if (!search.length) return true;
    const isPlatformUser = (0, _uuid.validate)(u);
    if (!isPlatformUser) return u.toLowerCase().includes(search.toLowerCase());
    const { firstName, lastName } = currentOrgUsersMap.get(u) || {};
    let firstNameMatch;
    let lastNameMatch;
    if (firstName) firstNameMatch = firstName.toLowerCase().includes(search.toLowerCase());
    if (lastName) lastNameMatch = lastName.toLowerCase().includes(search.toLowerCase());
    return !!firstNameMatch || !!lastNameMatch;
}
function parseUserNotificationPreferences(selectedUser, currentUser) {
    if (!selectedUser?._id) {
        const isEmailSub = selectedUser?.Destination?.includes?.("@");
        return {
            emailIsDisabled: !isEmailSub,
            smsIsDisabled: isEmailSub
        };
    }
    const preferences = {
        emailIsDisabled: false,
        smsIsDisabled: !selectedUser.phoneNumber
    };
    if (selectedUser?._id === currentUser?._id) return preferences;
    const { email, sms } = selectedUser?.settings?.notifications ?? {};
    if (email === false) preferences.emailIsDisabled = true;
    if (sms === true) preferences.smsIsDisabled = false;
    return preferences;
}
const initSubsTypeDisplayState = {
    showDmSubs: false,
    showMaintenanceSubs: false,
    showRuleSubs: false
};
function AssetSubscriptionsDisplay(props) {
    const { asset, currentOrg: { Users = [] } = {}, currentUser, currentUserRef, error, handleNonPlatformSubAdded, handleNonPlatformSubRemove, handleSubscriptionClick, handleBatchClick, maintenanceState: { count, instances } = {}, ruleState: { Count, Rules }, selectedUser, setSelectedUser, showSubscribeNonPlatformUserModal, subscriptions, subscriptionPending, templateID, toggleNonPlatformSubscriptionModal } = props;
    const width = (0, _react.useContext)((0, _widthContext.Width));
    const [search, updateSearch] = (0, _react.useState)(""), [subsTypeDisplayState, dispatchSubsTypesDisplayState] = (0, _react.useReducer)(displayToggleReducer, initSubsTypeDisplayState);
    const { emailIsDisabled, smsIsDisabled } = parseUserNotificationPreferences(selectedUser, currentUser);
    const currentOrgUsersMap = (0, _react.useMemo)(()=>{
        return new Map(Users.map((u)=>[
                u._id,
                u
            ]));
    }, [
        Users
    ]);
    const handleUserSelect = (u, isPlatformUser)=>{
        if (!isPlatformUser) return setSelectedUser({
            Destination: u
        });
        const { _id, firstName, lastName, phoneNumber, settings } = currentOrgUsersMap.get(u) || {};
        setSelectedUser({
            _id,
            firstName,
            lastName,
            phoneNumber,
            settings
        });
    };
    const formatNameForList = (u, isPlatformUser)=>{
        if (!isPlatformUser) return u;
        const { firstName = "", lastName = "" } = currentOrgUsersMap.get(u) || {};
        return `${firstName} ${lastName}`;
    };
    const showEmailSubs = selectedUser?._id || selectedUser?.Destination?.includes?.("@");
    const showSmsSubs = selectedUser?._id || !selectedUser?.Destination?.includes?.("@");
    const hasDmEmailSub = (0, _react.useMemo)(()=>{
        const { _id, Destination } = selectedUser || {};
        if (!_id && !Destination) return false;
        const subs = subscriptions.get(_id || Destination) || [];
        return subs.some((s)=>s.includes("*:email"));
    }, [
        selectedUser,
        subscriptions
    ]);
    const hasDmSmsSub = (0, _react.useMemo)(()=>{
        const { _id, Destination } = selectedUser || {};
        if (!_id && !Destination) return false;
        const subs = subscriptions.get(_id || Destination) || [];
        return subs.some((s)=>s.includes("*:sms"));
    }, [
        selectedUser,
        subscriptions
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _styleDefault.default).dynamic([
            [
                "2007003848",
                [
                    width < 768 ? "auto" : "fixed"
                ]
            ]
        ]) + " " + "position-absolute overflow-auto h-100 w-100 d-flex flex-column bg-white p-1 p-md-3 p-lg-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "2007003848",
                        [
                            width < 768 ? "auto" : "fixed"
                        ]
                    ]
                ]) + " " + "d-flex align-items-center mb-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2007003848",
                                [
                                    width < 768 ? "auto" : "fixed"
                                ]
                            ]
                        ]) + " " + "mb-md-0",
                        children: "Subscriptions"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2007003848",
                                [
                                    width < 768 ? "auto" : "fixed"
                                ]
                            ]
                        ]) + " " + "mb-md-0 mx-md-2 three-quarter-text text-danger",
                        children: error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                        no: ()=>null,
                        orgID: asset?.orgID,
                        perform: (0, _rbac.NON_PLATFORM_USER_SUBSCRIPTION),
                        resource: (0, _rbac.USER),
                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: toggleNonPlatformSubscriptionModal,
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2007003848",
                                        [
                                            width < 768 ? "auto" : "fixed"
                                        ]
                                    ]
                                ]) + " " + "btn modal-button-primary py-0 px-1 px-md-3 ml-auto three-quarter-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "d-none d-md-inline",
                                        children: "Subscribe "
                                    }),
                                    "Non-platform User"
                                ]
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "2007003848",
                        [
                            width < 768 ? "auto" : "fixed"
                        ]
                    ]
                ]) + " " + "d-block three-quarter-text mb-1 mb-md-3",
                children: "Set your subscription preferences for every asset this trigger affects. You can subscribe other users to this Rule if you have access. Manage your subscriptions in your settings."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "2007003848",
                        [
                            width < 768 ? "auto" : "fixed"
                        ]
                    ]
                ]) + " " + "inner-subscriptions-wrapper flex-grow-1 rounded-lg border border-icon-link-gray",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2007003848",
                                [
                                    width < 768 ? "auto" : "fixed"
                                ]
                            ]
                        ]) + " " + "users-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2007003848",
                                        [
                                            width < 768 ? "auto" : "fixed"
                                        ]
                                    ]
                                ]) + " " + "mb-0 p-2 pl-md-3 bg-background-gray",
                                children: "Users"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2007003848",
                                        [
                                            width < 768 ? "auto" : "fixed"
                                        ]
                                    ]
                                ]) + " " + "p-1 p-md-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "input-group mb-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: (0, _styleDefault.default).dynamic([
                                                [
                                                    "2007003848",
                                                    [
                                                        width < 768 ? "auto" : "fixed"
                                                    ]
                                                ]
                                            ]) + " " + "input-group-prepend",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    id: "searchUsers",
                                                    className: (0, _styleDefault.default).dynamic([
                                                        [
                                                            "2007003848",
                                                            [
                                                                width < 768 ? "auto" : "fixed"
                                                            ]
                                                        ]
                                                    ]) + " " + "input-group-text bg-transparent border-0",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        className: "text-text-light-gray",
                                                        icon: (0, _freeSolidSvgIcons.faSearch)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    "aria-label": "user name search",
                                                    "aria-describedby": "searchUsers",
                                                    placeholder: "Find users",
                                                    onChange: (e)=>updateSearch(e.target.value),
                                                    className: (0, _styleDefault.default).dynamic([
                                                        [
                                                            "2007003848",
                                                            [
                                                                width < 768 ? "auto" : "fixed"
                                                            ]
                                                        ]
                                                    ]) + " " + "form-control border-0"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>setSelectedUser({
                                                _id: currentUser?._id,
                                                firstName: currentUser?.firstName,
                                                lastName: currentUser?.lastName,
                                                phoneNumber: currentUser?.phoneNumber,
                                                settings: currentUser?.settings
                                            }),
                                        ref: currentUserRef,
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + `btn btn-link text-decoration-none w-100 text-left rounded ${currentUser?._id === selectedUser._id ? "modal-button-primary" : "text-dark"}`,
                                        children: currentUser?._id ? `${currentUser?.firstName || ""} ${currentUser?.lastName || ""} (you)` : ""
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ])
                                    }),
                                    subscriptions.size && (0, _accessTools.hasWriteAccessToResource)(asset?.orgID, (0, _rbac.USER)) ? [
                                        ...subscriptions.keys()
                                    ].filter((u)=>{
                                        if (u === currentUser?._id) return false;
                                        return filterUsers(search, u, currentOrgUsersMap);
                                    }).map((u)=>{
                                        const isPlatformUser = (0, _uuid.validate)(u);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: (0, _styleDefault.default).dynamic([
                                                [
                                                    "2007003848",
                                                    [
                                                        width < 768 ? "auto" : "fixed"
                                                    ]
                                                ]
                                            ]) + " " + `d-flex align-items-stretch w-100 rounded ${[
                                                selectedUser?._id,
                                                selectedUser?.Destination
                                            ].includes(u) ? "modal-button-primary" : "text-dark"} three-quarter-text`,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                    onClick: ()=>handleUserSelect(u, isPlatformUser),
                                                    className: (0, _styleDefault.default).dynamic([
                                                        [
                                                            "2007003848",
                                                            [
                                                                width < 768 ? "auto" : "fixed"
                                                            ]
                                                        ]
                                                    ]) + " " + "btn btn-link text-decoration-none text-left text-reset flex-fill",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + "mb-0",
                                                            children: formatNameForList(u, isPlatformUser)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + ((isPlatformUser ? "d-none" : u === selectedUser?.Destination ? "text-white" : "text-text-light-gray") || ""),
                                                            children: "non-elevat user"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    disabled: subscriptionPending,
                                                    onClick: ()=>handleNonPlatformSubRemove(u),
                                                    className: (0, _styleDefault.default).dynamic([
                                                        [
                                                            "2007003848",
                                                            [
                                                                width < 768 ? "auto" : "fixed"
                                                            ]
                                                        ]
                                                    ]) + " " + ((isPlatformUser ? "d-none" : "btn btn-link d-flex align-items-center justify-content-center text-reset") || ""),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                        icon: subscriptionPending === u ? (0, _freeSolidSvgIcons.faCircleNotch) : (0, _freeSolidSvgIcons.faTimes),
                                                        spin: subscriptionPending === u
                                                    })
                                                })
                                            ]
                                        }, u);
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "2007003848",
                                [
                                    width < 768 ? "auto" : "fixed"
                                ]
                            ]
                        ]) + " " + "rule-dm1-maintenance-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2007003848",
                                        [
                                            width < 768 ? "auto" : "fixed"
                                        ]
                                    ]
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "bg-background-gray p-2 pl-md-3 d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>dispatchSubsTypesDisplayState({
                                                        type: "dm1"
                                                    }),
                                                style: {
                                                    lineHeight: 1
                                                },
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]) + " " + "btn btn-link p-0 mr-3 text-dark",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: subsTypeDisplayState.showDmSubs ? (0, _freeSolidSvgIcons.faChevronUp) : (0, _freeSolidSvgIcons.faChevronDown)
                                                })
                                            }),
                                            "DM1 Faults"
                                        ]
                                    }),
                                    selectedUser?._id && (emailIsDisabled || smsIsDisabled) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "text-warning three-quarter-text ml-md-3",
                                        children: `User has a preference set not to receive ${emailIsDisabled && smsIsDisabled ? "email or SMS notifications" : emailIsDisabled ? "email notifications" : smsIsDisabled ? "SMS notifications or has not added a phone number" : ""}.`
                                    }) : null,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + ((subsTypeDisplayState.showDmSubs ? "d-flex" : "d-none") || ""),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]) + " " + ((showEmailSubs ? "d-flex flex-column align-items-center p-4 ml-1" : "d-none") || ""),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "2007003848",
                                                                [
                                                                    width < 768 ? "auto" : "fixed"
                                                                ]
                                                            ]
                                                        ]),
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        onClick: ()=>handleSubscriptionClick("*:email"),
                                                        disabled: subscriptionPending || emailIsDisabled,
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "2007003848",
                                                                [
                                                                    width < 768 ? "auto" : "fixed"
                                                                ]
                                                            ]
                                                        ]) + " " + `btn btn-link ${hasDmEmailSub ? "text-brand-primary-alert" : "text-background-gray"}`,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                            icon: hasDmEmailSub ? (0, _freeSolidSvgIcons.faBell) : (0, _freeSolidSvgIcons.faBellSlash)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]) + " " + ((showSmsSubs ? "d-flex flex-column align-items-center p-4 ml-1" : "d-none") || ""),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "2007003848",
                                                                [
                                                                    width < 768 ? "auto" : "fixed"
                                                                ]
                                                            ]
                                                        ]),
                                                        children: "SMS"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        onClick: ()=>handleSubscriptionClick("*:sms"),
                                                        disabled: subscriptionPending || smsIsDisabled,
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "2007003848",
                                                                [
                                                                    width < 768 ? "auto" : "fixed"
                                                                ]
                                                            ]
                                                        ]) + " " + `btn btn-link ${hasDmSmsSub ? "text-brand-primary-alert" : "text-background-gray"}`,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                            icon: hasDmSmsSub ? (0, _freeSolidSvgIcons.faBell) : (0, _freeSolidSvgIcons.faBellSlash)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2007003848",
                                        [
                                            width < 768 ? "auto" : "fixed"
                                        ]
                                    ]
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "bg-background-gray p-2 pl-md-3 d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>dispatchSubsTypesDisplayState({
                                                        type: "rule"
                                                    }),
                                                style: {
                                                    lineHeight: 1
                                                },
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]) + " " + "btn btn-link p-0 mr-3 text-dark",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: subsTypeDisplayState.showRuleSubs ? (0, _freeSolidSvgIcons.faChevronUp) : (0, _freeSolidSvgIcons.faChevronDown)
                                                })
                                            }),
                                            "Rules",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]) + " " + "ml-3",
                                                children: Count
                                            })
                                        ]
                                    }),
                                    selectedUser?._id && (emailIsDisabled || smsIsDisabled) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "text-warning three-quarter-text ml-md-3",
                                        children: `User has a preference set not to receive ${emailIsDisabled && smsIsDisabled ? "email or SMS notifications" : emailIsDisabled ? "email notifications" : smsIsDisabled ? "SMS notifications or has not added a phone number" : ""}.`
                                    }) : null,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + ((subsTypeDisplayState.showRuleSubs ? "table table-borderless" : "d-none") || ""),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                    className: (0, _styleDefault.default).dynamic([
                                                        [
                                                            "2007003848",
                                                            [
                                                                width < 768 ? "auto" : "fixed"
                                                            ]
                                                        ]
                                                    ]),
                                                    children: [
                                                        showEmailSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "col",
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + "col-notification text-center",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                disabled: emailIsDisabled || subscriptionPending,
                                                                onClick: ()=>handleBatchClick("email", "gateway"),
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "btn btn-sm btn-outline-icon-link-gray bg-white text-muted rounded-lg",
                                                                children: "Email"
                                                            })
                                                        }) : null,
                                                        showSmsSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "col",
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + "col-notification text-center",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                disabled: smsIsDisabled || subscriptionPending,
                                                                onClick: ()=>handleBatchClick("sms", "gateway"),
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "btn btn-sm btn-outline-icon-link-gray bg-white text-muted rounded-lg",
                                                                children: "SMS"
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "col",
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + "col-asset-name"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]),
                                                children: Rules?.map(({ Id, Name = "", Type })=>{
                                                    const hasRuleEmailSub = ()=>{
                                                        const { _id, Destination } = selectedUser || {};
                                                        if (!_id && !Destination) return false;
                                                        const subs = subscriptions.get(_id || Destination) || [];
                                                        return subs.some((s)=>s.includes(`${Id}:email`));
                                                    };
                                                    const hasRuleSmsSub = ()=>{
                                                        const { _id, Destination } = selectedUser || {};
                                                        if (!_id && !Destination) return false;
                                                        const subs = subscriptions.get(_id || Destination) || [];
                                                        return subs.some((s)=>s.includes(`${Id}:sms`));
                                                    };
                                                    const isWeatherRule = Type === (0, _rule.TEMPLATE_WEATHER_TYPE);
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "2007003848",
                                                                [
                                                                    width < 768 ? "auto" : "fixed"
                                                                ]
                                                            ]
                                                        ]),
                                                        children: [
                                                            showEmailSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "text-center",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    "data-for": `${Id}:email`,
                                                                    "data-tip": true,
                                                                    "data-tip-disable": false,
                                                                    className: (0, _styleDefault.default).dynamic([
                                                                        [
                                                                            "2007003848",
                                                                            [
                                                                                width < 768 ? "auto" : "fixed"
                                                                            ]
                                                                        ]
                                                                    ]),
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                        onClick: ()=>handleSubscriptionClick(`${Id}:email`),
                                                                        disabled: subscriptionPending || emailIsDisabled || isWeatherRule,
                                                                        className: (0, _styleDefault.default).dynamic([
                                                                            [
                                                                                "2007003848",
                                                                                [
                                                                                    width < 768 ? "auto" : "fixed"
                                                                                ]
                                                                            ]
                                                                        ]) + " " + `btn btn-link p-0 ${hasRuleEmailSub() ? "text-brand-primary-alert" : "text-background-gray"}`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                                icon: hasRuleEmailSub() ? (0, _freeSolidSvgIcons.faBell) : (0, _freeSolidSvgIcons.faBellSlash)
                                                                            }),
                                                                            isWeatherRule ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                                                                                id: `${Id}:email`,
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: (0, _styleDefault.default).dynamic([
                                                                                        [
                                                                                            "2007003848",
                                                                                            [
                                                                                                width < 768 ? "auto" : "fixed"
                                                                                            ]
                                                                                        ]
                                                                                    ]),
                                                                                    children: "Email notifications not supported for Weather Alerts"
                                                                                })
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                })
                                                            }) : null,
                                                            showSmsSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                "data-tip": smsIsDisabled ? "This user has a preference set to not receive SMS notifications" : "",
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "text-center",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    onClick: ()=>handleSubscriptionClick(`${Id}:sms`),
                                                                    disabled: subscriptionPending || smsIsDisabled,
                                                                    className: (0, _styleDefault.default).dynamic([
                                                                        [
                                                                            "2007003848",
                                                                            [
                                                                                width < 768 ? "auto" : "fixed"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + `btn btn-link p-0 ${hasRuleSmsSub() ? "text-brand-primary-alert" : "text-background-gray"}`,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                        icon: hasRuleSmsSub() ? (0, _freeSolidSvgIcons.faBell) : (0, _freeSolidSvgIcons.faBellSlash)
                                                                    })
                                                                })
                                                            }) : null,
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]),
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                                                    no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            disabled: true,
                                                                            className: (0, _styleDefault.default).dynamic([
                                                                                [
                                                                                    "2007003848",
                                                                                    [
                                                                                        width < 768 ? "auto" : "fixed"
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "btn btn-link p-0",
                                                                            children: Name
                                                                        }),
                                                                    orgID: asset?.orgID,
                                                                    perform: (0, _rbac.ASSET_MODEL_READ),
                                                                    resource: (0, _rbac.ASSET_MODEL),
                                                                    yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                                            to: {
                                                                                pathname: `/asset-model/${templateID}`,
                                                                                search: `?tab=editRule&RuleId=${Id}`
                                                                            },
                                                                            replace: true,
                                                                            children: Name
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }, Id);
                                                }) ?? null
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "2007003848",
                                        [
                                            width < 768 ? "auto" : "fixed"
                                        ]
                                    ]
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "bg-background-gray p-2 pl-md-3 d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>dispatchSubsTypesDisplayState({
                                                        type: "maintenance"
                                                    }),
                                                style: {
                                                    lineHeight: 1
                                                },
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]) + " " + "btn btn-link p-0 mr-3 text-dark",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: subsTypeDisplayState.showMaintenanceSubs ? (0, _freeSolidSvgIcons.faChevronUp) : (0, _freeSolidSvgIcons.faChevronDown)
                                                })
                                            }),
                                            "Maintenance",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]) + " " + "ml-3",
                                                children: count
                                            })
                                        ]
                                    }),
                                    selectedUser?._id && (emailIsDisabled || smsIsDisabled) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + "text-warning three-quarter-text ml-md-3",
                                        children: `User has a preference set not to receive ${emailIsDisabled && smsIsDisabled ? "email or SMS notifications" : emailIsDisabled ? "email notifications" : smsIsDisabled ? "SMS notifications or has not added a phone number" : ""}.`
                                    }) : null,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                        className: (0, _styleDefault.default).dynamic([
                                            [
                                                "2007003848",
                                                [
                                                    width < 768 ? "auto" : "fixed"
                                                ]
                                            ]
                                        ]) + " " + ((subsTypeDisplayState.showMaintenanceSubs ? "table table-borderless" : "d-none") || ""),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                    className: (0, _styleDefault.default).dynamic([
                                                        [
                                                            "2007003848",
                                                            [
                                                                width < 768 ? "auto" : "fixed"
                                                            ]
                                                        ]
                                                    ]),
                                                    children: [
                                                        showEmailSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "col",
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + "col-notification text-center",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                disabled: emailIsDisabled || subscriptionPending,
                                                                onClick: ()=>handleBatchClick("email", "maintenance-gateway"),
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "btn btn-sm btn-outline-icon-link-gray bg-white text-muted rounded-lg",
                                                                children: "Email"
                                                            })
                                                        }) : null,
                                                        showSmsSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "col",
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + "col-notification text-center",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                disabled: smsIsDisabled || subscriptionPending,
                                                                onClick: ()=>handleBatchClick("sms", "maintenance-gateway"),
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "btn btn-sm btn-outline-icon-link-gray bg-white text-muted rounded-lg",
                                                                children: "SMS"
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "col",
                                                            className: (0, _styleDefault.default).dynamic([
                                                                [
                                                                    "2007003848",
                                                                    [
                                                                        width < 768 ? "auto" : "fixed"
                                                                    ]
                                                                ]
                                                            ]) + " " + "col-asset-name"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "2007003848",
                                                        [
                                                            width < 768 ? "auto" : "fixed"
                                                        ]
                                                    ]
                                                ]),
                                                children: instances?.map(({ _id: instance_id, GtemplateReminder: { _id: reminder_id, name } = {} })=>{
                                                    const hasRuleEmailSub = ()=>{
                                                        const { _id, Destination } = selectedUser || {};
                                                        if (!_id && !Destination) return false;
                                                        const subs = subscriptions.get(_id || Destination) || [];
                                                        return subs.some((s)=>s.includes(`${reminder_id}:email`));
                                                    };
                                                    const hasRuleSmsSub = ()=>{
                                                        const { _id, Destination } = selectedUser || {};
                                                        if (!_id && !Destination) return false;
                                                        const subs = subscriptions.get(_id || Destination) || [];
                                                        return subs.some((s)=>s.includes(`${reminder_id}:sms`));
                                                    };
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "2007003848",
                                                                [
                                                                    width < 768 ? "auto" : "fixed"
                                                                ]
                                                            ]
                                                        ]),
                                                        children: [
                                                            showEmailSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "text-center",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    onClick: ()=>handleSubscriptionClick(`${reminder_id}:email`),
                                                                    disabled: subscriptionPending || emailIsDisabled,
                                                                    className: (0, _styleDefault.default).dynamic([
                                                                        [
                                                                            "2007003848",
                                                                            [
                                                                                width < 768 ? "auto" : "fixed"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + `btn btn-link p-0 ${hasRuleEmailSub() ? "text-brand-primary-alert" : "text-background-gray"}`,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                        icon: hasRuleEmailSub() ? (0, _freeSolidSvgIcons.faBell) : (0, _freeSolidSvgIcons.faBellSlash)
                                                                    })
                                                                })
                                                            }) : null,
                                                            showSmsSubs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                "data-tip": smsIsDisabled ? "This user has a preference set to not receive SMS notifications" : "",
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]) + " " + "text-center",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    onClick: ()=>handleSubscriptionClick(`${reminder_id}:sms`),
                                                                    disabled: subscriptionPending || smsIsDisabled,
                                                                    className: (0, _styleDefault.default).dynamic([
                                                                        [
                                                                            "2007003848",
                                                                            [
                                                                                width < 768 ? "auto" : "fixed"
                                                                            ]
                                                                        ]
                                                                    ]) + " " + `btn btn-link p-0 ${hasRuleSmsSub() ? "text-brand-primary-alert" : "text-background-gray"}`,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                        icon: hasRuleSmsSub() ? (0, _freeSolidSvgIcons.faBell) : (0, _freeSolidSvgIcons.faBellSlash)
                                                                    })
                                                                })
                                                            }) : null,
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                className: (0, _styleDefault.default).dynamic([
                                                                    [
                                                                        "2007003848",
                                                                        [
                                                                            width < 768 ? "auto" : "fixed"
                                                                        ]
                                                                    ]
                                                                ]),
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                                                    no: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            disabled: true,
                                                                            className: (0, _styleDefault.default).dynamic([
                                                                                [
                                                                                    "2007003848",
                                                                                    [
                                                                                        width < 768 ? "auto" : "fixed"
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "btn btn-link p-0",
                                                                            children: name
                                                                        }),
                                                                    orgID: asset?.orgID,
                                                                    perform: (0, _rbac.ASSET_MODEL_READ),
                                                                    resource: (0, _rbac.ASSET_MODEL),
                                                                    yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                                            to: {
                                                                                pathname: `/asset-model/${templateID}`,
                                                                                search: `?${(0, _queryStringDefault.default).stringify({
                                                                                    reminder_id,
                                                                                    tab: (0, _assetModel.EDIT_REMINDER)
                                                                                })}`
                                                                            },
                                                                            replace: true,
                                                                            children: name
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }, instance_id);
                                                }) ?? null
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showSubscribeNonPlatformUserModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nonPlatformUserSubscriptionModalDefault.default), {
                allowEmail: true,
                asset: asset,
                handleNonPlatformSubAdded: handleNonPlatformSubAdded,
                isOpen: showSubscribeNonPlatformUserModal,
                toggleModal: toggleNonPlatformSubscriptionModal
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2007003848",
                dynamic: [
                    width < 768 ? "auto" : "fixed"
                ],
                children: `.table.__jsx-style-dynamic-selector{table-layout:${width < 768 ? "auto" : "fixed"};}.col-notification.__jsx-style-dynamic-selector{width:10%;}.col-asset-name.__jsx-style-dynamic-selector{width:80%;}@media (min-width:768px){.inner-subscriptions-wrapper.__jsx-style-dynamic-selector{height:100%;overflow:hidden;display:grid;grid-template-columns:1fr 3fr;grid-template-rows:auto;grid-template-areas:'users rule-dm1-maintenance';}.users-container.__jsx-style-dynamic-selector{min-height:100%;overflow:auto;border-right:1px solid var(--icon-link-gray);grid-area:users;}.rule-dm1-maintenance-wrapper.__jsx-style-dynamic-selector{grid-area:rule-dm1-maintenance;min-height:100%;overflow:auto;}}`
            })
        ]
    });
}
AssetSubscriptionsDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    currentOrg: (0, _propTypesDefault.default).shape({
        Users: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            firstName: (0, _propTypesDefault.default).string,
            lastName: (0, _propTypesDefault.default).string,
            settings: (0, _propTypesDefault.default).shape({
                notifications: (0, _propTypesDefault.default).shape({
                    sms: (0, _propTypesDefault.default).bool,
                    email: (0, _propTypesDefault.default).bool
                })
            })
        }))
    }),
    currentUser: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        firstName: (0, _propTypesDefault.default).string,
        lastName: (0, _propTypesDefault.default).string,
        phoneNumber: (0, _propTypesDefault.default).string,
        settings: (0, _propTypesDefault.default).object
    }),
    currentUserRef: (0, _propTypesDefault.default).object,
    error: (0, _propTypesDefault.default).string,
    handleNonPlatformSubAdded: (0, _propTypesDefault.default).func,
    handleNonPlatformSubRemove: (0, _propTypesDefault.default).func,
    handleSubscriptionClick: (0, _propTypesDefault.default).func,
    handleBatchClick: (0, _propTypesDefault.default).func,
    Id: (0, _propTypesDefault.default).string,
    maintenanceState: (0, _propTypesDefault.default).shape({
        count: (0, _propTypesDefault.default).number,
        instances: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            gateway_id: (0, _propTypesDefault.default).string,
            GtemplateReminder: (0, _propTypesDefault.default).shape({
                _id: (0, _propTypesDefault.default).string,
                name: (0, _propTypesDefault.default).string
            })
        }))
    }),
    OrgId: (0, _propTypesDefault.default).string,
    ruleState: (0, _propTypesDefault.default).shape({
        Count: (0, _propTypesDefault.default).number,
        Rules: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            nickname: (0, _propTypesDefault.default).string
        }))
    }),
    selectedUser: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        Destination: (0, _propTypesDefault.default).string,
        firstName: (0, _propTypesDefault.default).string,
        lastName: (0, _propTypesDefault.default).string,
        phoneNumber: (0, _propTypesDefault.default).string,
        settings: (0, _propTypesDefault.default).shape({
            notifications: (0, _propTypesDefault.default).shape({
                sms: (0, _propTypesDefault.default).bool,
                email: (0, _propTypesDefault.default).bool
            })
        })
    }),
    setSelectedUser: (0, _propTypesDefault.default).func,
    showSubscribeNonPlatformUserModal: (0, _propTypesDefault.default).bool,
    subscriptions: (0, _propTypesDefault.default).object,
    subscriptionPending: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    template: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string
    }),
    templateID: (0, _propTypesDefault.default).string,
    toggleNonPlatformSubscriptionModal: (0, _propTypesDefault.default).func
};
AssetSubscriptionsDisplay.defaultProps = {
    selectedUser: {},
    ruleState: {
        Count: 0,
        Rules: []
    },
    subscriptions: new Map()
};
function displayToggleReducer(state, action) {
    switch(action.type){
        case "dm1":
            return {
                ...state,
                showDmSubs: !state.showDmSubs
            };
        case "maintenance":
            return {
                ...state,
                showMaintenanceSubs: !state.showMaintenanceSubs
            };
        case "rule":
            return {
                ...state,
                showRuleSubs: !state.showRuleSubs
            };
        default:
            return state;
    }
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","react-tooltip":"4ejwp","prop-types":"bnNSm","query-string":"h6dFx","react-router-dom":"3uzXR","uuid":"hIyym","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/AssetModel":"3MTkG","../../Constants/RBAC":"ieo1E","../../Context/WidthContext":"5c6Dv","../../RBAC/AccessTools":"j912a","./NonPlatformUserSubscriptionModal":"5DLgV","../../RBAC/Can":"l4l8D","../../Constants/Rule":"2HV6i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3MTkG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASSETS", ()=>ASSETS);
parcelHelpers.export(exports, "COMMANDS", ()=>COMMANDS);
parcelHelpers.export(exports, "CREATE_REMINDER", ()=>CREATE_REMINDER);
parcelHelpers.export(exports, "CREATE_RULE", ()=>CREATE_RULE);
parcelHelpers.export(exports, "CREATE_WEATHER_RULE", ()=>CREATE_WEATHER_RULE);
parcelHelpers.export(exports, "DETAILS", ()=>DETAILS);
parcelHelpers.export(exports, "EDIT_REMINDER", ()=>EDIT_REMINDER);
parcelHelpers.export(exports, "EDIT_RULE", ()=>EDIT_RULE);
parcelHelpers.export(exports, "OUTPUT_SIGNALS", ()=>OUTPUT_SIGNALS);
parcelHelpers.export(exports, "RULES", ()=>RULES);
parcelHelpers.export(exports, "SIGNALS", ()=>SIGNALS);
parcelHelpers.export(exports, "TRANSFORMS", ()=>TRANSFORMS);
parcelHelpers.export(exports, "DM1", ()=>DM1);
parcelHelpers.export(exports, "MAINTENANCE", ()=>MAINTENANCE);
parcelHelpers.export(exports, "ASSET_MODEL_TABS", ()=>ASSET_MODEL_TABS);
parcelHelpers.export(exports, "NAV_TABS", ()=>NAV_TABS);
parcelHelpers.export(exports, "REMINDER_TABS", ()=>REMINDER_TABS);
parcelHelpers.export(exports, "RULE_TABS", ()=>RULE_TABS);
const ASSETS = "assets";
const COMMANDS = "commands";
const CREATE_REMINDER = "createReminder";
const CREATE_RULE = "createRule";
const CREATE_WEATHER_RULE = "createWeatherRule";
const DETAILS = "details";
const EDIT_REMINDER = "editReminder";
const EDIT_RULE = "editRule";
const OUTPUT_SIGNALS = "outputSignals";
const RULES = "rules";
const SIGNALS = "signals";
const TRANSFORMS = "transforms";
const DM1 = "dm1";
const MAINTENANCE = "maintenance";
const ASSET_MODEL_TABS = [
    ASSETS,
    COMMANDS,
    CREATE_REMINDER,
    CREATE_RULE,
    CREATE_WEATHER_RULE,
    DETAILS,
    EDIT_REMINDER,
    EDIT_RULE,
    MAINTENANCE,
    OUTPUT_SIGNALS,
    RULES,
    SIGNALS,
    TRANSFORMS,
    DM1
];
const NAV_TABS = [
    SIGNALS,
    OUTPUT_SIGNALS,
    DETAILS,
    RULES,
    ASSETS,
    COMMANDS,
    TRANSFORMS,
    DM1,
    MAINTENANCE
];
const REMINDER_TABS = [
    CREATE_REMINDER,
    EDIT_REMINDER
];
const RULE_TABS = [
    CREATE_RULE,
    CREATE_WEATHER_RULE,
    EDIT_RULE
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5DLgV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _axios = require("axios");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactPhoneInput2 = require("react-phone-input-2");
var _reactPhoneInput2Default = parcelHelpers.interopDefault(_reactPhoneInput2);
var _bootstrapCss = require("react-phone-input-2/lib/bootstrap.css");
var _subscriptionService = require("../../Services/SubscriptionService");
var _subscriptionServiceDefault = parcelHelpers.interopDefault(_subscriptionService);
exports.default = /*#__PURE__*/ (0, _react.memo)(NonPlatformUserSubscriptionModal);
const initState = {
    email: "",
    error: "",
    sms: "",
    subsRequestPending: false
};
function NonPlatformUserSubscriptionModal({ asset, handleNonPlatformSubAdded, isOpen, toggleModal }) {
    const [state, updateState] = (0, _react.useState)(initState);
    const source = (0, _axios.CancelToken).source();
    const subService = (0, _react.useMemo)(()=>new (0, _subscriptionServiceDefault.default)(), []);
    const generateRequests = (Notification, Destination)=>{
        const commonParams = {
            cancelToken: source.token,
            params: {
                orgID: asset.orgID
            }
        };
        const dm1RequestParams = {
            ...commonParams,
            data: {
                Destination,
                GatewayId: asset._id,
                Notification,
                RuleId: "*",
                Trigger: "dm1"
            }
        }, rulesRequestParams = {
            ...commonParams,
            data: {
                Destination,
                Notification,
                SourceId: asset._id,
                SourceType: "gateway",
                Trigger: "rule"
            }
        }, maintenanceRequestParams = {
            ...commonParams,
            data: {
                Destination,
                Notification,
                SourceId: asset._id,
                SourceType: "gateway",
                Trigger: "maintenance"
            }
        };
        return [
            subService.postSubscription(dm1RequestParams),
            subService.subscribeAll(rulesRequestParams),
            subService.subscribeAll(maintenanceRequestParams)
        ];
    };
    const handlePropUpdate = ({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const handleSmsUpdate = (phoneNumber)=>{
        const sms = phoneNumber.replace(/\D/g, "");
        updateState((prevState)=>({
                ...prevState,
                sms
            }));
    };
    const validateInput = (email, sms)=>{
        let error = "";
        updateState((prevState)=>({
                ...prevState,
                error
            }));
        const smsPattern = /^\d{11}$/;
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!email.length && !sms.length) error = "Email and sms fields are both empty.";
        if (sms.length && !smsPattern.test(sms)) error = "Sms number is invalid. ";
        if (email.length && !emailPattern.test(email)) error += "Email address is invalid.";
        if (error) throw new Error(error);
    };
    const handleSubSave = async ()=>{
        try {
            const { email, sms } = state;
            validateInput(email, sms);
            updateState((prevState)=>({
                    ...prevState,
                    subsRequestPending: true
                }));
            const { destinations, requests } = [
                email,
                sms
            ].reduce((acc, destination, i)=>{
                if (!destination.length) return acc;
                switch(i){
                    case 0:
                        {
                            acc.destinations.push(destination);
                            const emailRequests = generateRequests("email", destination);
                            acc.requests.push(...emailRequests);
                            break;
                        }
                    case 1:
                        {
                            acc.destinations.push(`+${destination}`);
                            const smsRequests = generateRequests("sms", `+${destination}`);
                            acc.requests.push(...smsRequests);
                            break;
                        }
                }
                return acc;
            }, {
                destinations: [],
                requests: []
            });
            await Promise.all(requests);
            window.setTimeout(()=>handleNonPlatformSubAdded(destinations), 5000);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    subsRequestPending: false
                }));
        }
    };
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdrop: state.subsRequestPending ? "static" : true,
        centered: true,
        isOpen: isOpen,
        scrollable: false,
        toggle: !state.subsRequestPending ? toggleModal : ()=>null,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: !state.subsRequestPending ? toggleModal : ()=>null,
                children: [
                    "Subscribe ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-907359250 d-none d-md-inline",
                        children: "Non-Platform "
                    }),
                    "User"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid pt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-907359250 col-12 modal-supplemental-text",
                            children: "When notifications need to go to emails or sms for users without an account you can add them here and subscribe to DM1 Errors and Rules"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-907359250 form-group col-12 col-md-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "email",
                                    className: "jsx-907359250 modal-inputlabel-text",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    name: "email",
                                    onChange: handlePropUpdate,
                                    placeholder: "some@email.com",
                                    readOnly: state.subsRequestPending,
                                    type: "text",
                                    value: state.email,
                                    className: "jsx-907359250 form-control rounded"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-907359250 form-group col-12 col-md-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "sms",
                                    className: "jsx-907359250 modal-inputlabel-text",
                                    children: "Phone Number"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactPhoneInput2Default.default), {
                                    country: "us",
                                    enableSearch: true,
                                    inputClass: "w-100 py-0 rounded modal-placeholder-text",
                                    name: "sms",
                                    onChange: handleSmsUpdate,
                                    readOnly: state.subsRequestPending,
                                    value: state.sms
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row justify-content-end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-907359250 " + ((state.error ? "col-12 text-right text-danger three-quarter-text mb-0" : "d-none") || ""),
                            children: state.error
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-907359250 row justify-content-end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-907359250 " + ((state.subsRequestPending ? "col-12 text-right modal-supplemental-text mb-0" : "d-none") || ""),
                            children: "This request may take several seconds to complete. Please do not refresh your browser."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: state.subsRequestPending,
                        onClick: toggleModal,
                        className: "jsx-907359250 btn btn-outline-secondary text-muted bg-white shadow-none py-0 px-3 three-quarters-text",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: state.subsRequestPending,
                        onClick: handleSubSave,
                        className: "jsx-907359250 btn modal-button-submit py-0 px-5 three-quarters-text",
                        children: state.subsRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Add"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "907359250",
                children: ".btn.jsx-907359250:focus{outline:none;}"
            })
        ]
    });
}
NonPlatformUserSubscriptionModal.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    }),
    handleNonPlatformSubAdded: (0, _propTypesDefault.default).func,
    isMaintenance: (0, _propTypesDefault.default).bool,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","axios":"ffpgq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-phone-input-2":"4y4CR","react-phone-input-2/lib/bootstrap.css":"c2vor","../../Services/SubscriptionService":"9ZnlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4y4CR":[function(require,module,exports) {
module.exports = function(e) {
    var t = {};
    function r(n) {
        if (t[n]) return t[n].exports;
        var a = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, r.t = function(e, t) {
        if (1 & t && (e = r(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var a in e)r.d(n, a, (function(t) {
            return e[t];
        }).bind(null, a));
        return n;
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 9);
}([
    function(e, t) {
        e.exports = require("35b441856cb52ead");
    },
    function(e, t, r) {
        var n;
        /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !function() {
            "use strict";
            var r = {}.hasOwnProperty;
            function a() {
                for(var e = [], t = 0; t < arguments.length; t++){
                    var n = arguments[t];
                    if (n) {
                        var o = typeof n;
                        if ("string" === o || "number" === o) e.push(n);
                        else if (Array.isArray(n) && n.length) {
                            var i = a.apply(null, n);
                            i && e.push(i);
                        } else if ("object" === o) for(var u in n)r.call(n, u) && n[u] && e.push(u);
                    }
                }
                return e.join(" ");
            }
            e.exports ? (a.default = a, e.exports = a) : void 0 === (n = (function() {
                return a;
            }).apply(t, [])) || (e.exports = n);
        }();
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t && t && t.Object === Object && t, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = s.Symbol, d = f ? f.prototype : void 0, p = d ? d.toString : void 0;
            function h(e) {
                if ("string" == typeof e) return e;
                if (y(e)) return p ? p.call(e) : "";
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function y(e) {
                return "symbol" == typeof e || function(e) {
                    return !!e && "object" == typeof e;
                }(e) && "[object Symbol]" == l.call(e);
            }
            function b(e) {
                return e ? (e = function(e) {
                    if ("number" == typeof e) return e;
                    if (y(e)) return NaN;
                    if (m(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = m(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(r, "");
                    var u = a.test(e);
                    return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
                }(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
            }
            e.exports = function(e, t, r) {
                var n, a, o, i;
                return e = null == (n = e) ? "" : h(n), a = function(e) {
                    var t = b(e), r = t % 1;
                    return t == t ? r ? t - r : t : 0;
                }(r), o = 0, i = e.length, a == a && (void 0 !== i && (a = a <= i ? a : i), void 0 !== o && (a = a >= o ? a : o)), r = a, t = h(t), e.slice(r, r + t.length) == t;
            };
        }).call(this, r(3));
    },
    function(e, t) {
        var r;
        r = function() {
            return this;
        }();
        try {
            r = r || new Function("return this")();
        } catch (e) {
            "object" == typeof window && (r = window);
        }
        e.exports = r;
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\[object .+?Constructor\]$/, n = "object" == typeof t && t && t.Object === Object && t, a = "object" == typeof self && self && self.Object === Object && self, o = n || a || Function("return this")();
            var i, u = Array.prototype, c = Function.prototype, s = Object.prototype, l = o["__core-js_shared__"], f = (i = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "")) ? "Symbol(src)_1." + i : "", d = c.toString, p = s.hasOwnProperty, h = s.toString, m = RegExp("^" + d.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), y = u.splice, b = x(o, "Map"), g = x(Object, "create");
            function v(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function C(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function _(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function w(e, t) {
                for(var r, n, a = e.length; a--;)if ((r = e[a][0]) === (n = t) || r != r && n != n) return a;
                return -1;
            }
            function S(e) {
                var t;
                return !(!O(e) || (t = e, f && f in t)) && ((function(e) {
                    var t = O(e) ? h.call(e) : "";
                    return "[object Function]" == t || "[object GeneratorFunction]" == t;
                })(e) || function(e) {
                    var t = !1;
                    if (null != e && "function" != typeof e.toString) try {
                        t = !!(e + "");
                    } catch (e) {}
                    return t;
                }(e) ? m : r).test(function(e) {
                    if (null != e) {
                        try {
                            return d.call(e);
                        } catch (e) {}
                        try {
                            return e + "";
                        } catch (e) {}
                    }
                    return "";
                }(e));
            }
            function j(e, t) {
                var r, n, a = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
            }
            function x(e, t) {
                var r = function(e, t) {
                    return null == e ? void 0 : e[t];
                }(e, t);
                return S(r) ? r : void 0;
            }
            function N(e, t) {
                if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                var r = function() {
                    var n = arguments, a = t ? t.apply(this, n) : n[0], o = r.cache;
                    if (o.has(a)) return o.get(a);
                    var i = e.apply(this, n);
                    return r.cache = o.set(a, i), i;
                };
                return r.cache = new (N.Cache || _), r;
            }
            function O(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            v.prototype.clear = function() {
                this.__data__ = g ? g(null) : {};
            }, v.prototype.delete = function(e) {
                return this.has(e) && delete this.__data__[e];
            }, v.prototype.get = function(e) {
                var t = this.__data__;
                if (g) {
                    var r = t[e];
                    return "__lodash_hash_undefined__" === r ? void 0 : r;
                }
                return p.call(t, e) ? t[e] : void 0;
            }, v.prototype.has = function(e) {
                var t = this.__data__;
                return g ? void 0 !== t[e] : p.call(t, e);
            }, v.prototype.set = function(e, t) {
                return this.__data__[e] = g && void 0 === t ? "__lodash_hash_undefined__" : t, this;
            }, C.prototype.clear = function() {
                this.__data__ = [];
            }, C.prototype.delete = function(e) {
                var t = this.__data__, r = w(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : y.call(t, r, 1), !0);
            }, C.prototype.get = function(e) {
                var t = this.__data__, r = w(t, e);
                return r < 0 ? void 0 : t[r][1];
            }, C.prototype.has = function(e) {
                return w(this.__data__, e) > -1;
            }, C.prototype.set = function(e, t) {
                var r = this.__data__, n = w(r, e);
                return n < 0 ? r.push([
                    e,
                    t
                ]) : r[n][1] = t, this;
            }, _.prototype.clear = function() {
                this.__data__ = {
                    hash: new v,
                    map: new (b || C),
                    string: new v
                };
            }, _.prototype.delete = function(e) {
                return j(this, e).delete(e);
            }, _.prototype.get = function(e) {
                return j(this, e).get(e);
            }, _.prototype.has = function(e) {
                return j(this, e).has(e);
            }, _.prototype.set = function(e, t) {
                return j(this, e).set(e, t), this;
            }, N.Cache = _, e.exports = N;
        }).call(this, r(3));
    },
    function(e, t, r) {
        (function(t) {
            var r = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, i = parseInt, u = "object" == typeof t && t && t.Object === Object && t, c = "object" == typeof self && self && self.Object === Object && self, s = u || c || Function("return this")(), l = Object.prototype.toString, f = Math.max, d = Math.min, p = function() {
                return s.Date.now();
            };
            function h(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function m(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == l.call(e);
                }(e)) return NaN;
                if (h(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = h(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(r, "");
                var u = a.test(e);
                return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var n, a, o, i, u, c, s = 0, l = !1, y = !1, b = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function g(t) {
                    var r = n, o = a;
                    return n = a = void 0, s = t, i = e.apply(o, r);
                }
                function v(e) {
                    return s = e, u = setTimeout(_, t), l ? g(e) : i;
                }
                function C(e) {
                    var r = e - c;
                    return void 0 === c || r >= t || r < 0 || y && e - s >= o;
                }
                function _() {
                    var e = p();
                    if (C(e)) return w(e);
                    u = setTimeout(_, function(e) {
                        var r = t - (e - c);
                        return y ? d(r, o - (e - s)) : r;
                    }(e));
                }
                function w(e) {
                    return u = void 0, b && n ? g(e) : (n = a = void 0, i);
                }
                function S() {
                    var e = p(), r = C(e);
                    if (n = arguments, a = this, c = e, r) {
                        if (void 0 === u) return v(c);
                        if (y) return u = setTimeout(_, t), g(c);
                    }
                    return void 0 === u && (u = setTimeout(_, t)), i;
                }
                return t = m(t) || 0, h(r) && (l = !!r.leading, o = (y = "maxWait" in r) ? f(m(r.maxWait) || 0, t) : o, b = "trailing" in r ? !!r.trailing : b), S.cancel = function() {
                    void 0 !== u && clearTimeout(u), s = 0, n = c = a = u = void 0;
                }, S.flush = function() {
                    return void 0 === u ? i : w(p());
                }, S;
            };
        }).call(this, r(3));
    },
    function(e, t, r) {
        (function(e, r) {
            var n = "[object Arguments]", a = "[object Map]", o = "[object Object]", i = "[object Set]", u = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/, s = /^\./, l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, f = /\\(\\)?/g, d = /^\[object .+?Constructor\]$/, p = /^(?:0|[1-9]\d*)$/, h = {};
            h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h[n] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h["[object Function]"] = h[a] = h["[object Number]"] = h[o] = h["[object RegExp]"] = h[i] = h["[object String]"] = h["[object WeakMap]"] = !1;
            var m = "object" == typeof e && e && e.Object === Object && e, y = "object" == typeof self && self && self.Object === Object && self, b = m || y || Function("return this")(), g = t && !t.nodeType && t, v = g && "object" == typeof r && r && !r.nodeType && r, C = v && v.exports === g && m.process, _ = function() {
                try {
                    return C && C.binding("util");
                } catch (e) {}
            }(), w = _ && _.isTypedArray;
            function S(e, t, r, n) {
                var a = -1, o = e ? e.length : 0;
                for(n && o && (r = e[++a]); ++a < o;)r = t(r, e[a], a, e);
                return r;
            }
            function j(e, t) {
                for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                return !1;
            }
            function x(e, t, r, n, a) {
                return a(e, function(e, a, o) {
                    r = n ? (n = !1, e) : t(r, e, a, o);
                }), r;
            }
            function N(e) {
                var t = !1;
                if (null != e && "function" != typeof e.toString) try {
                    t = !!(e + "");
                } catch (e) {}
                return t;
            }
            function O(e) {
                var t = -1, r = Array(e.size);
                return e.forEach(function(e, n) {
                    r[++t] = [
                        n,
                        e
                    ];
                }), r;
            }
            function k(e) {
                var t = -1, r = Array(e.size);
                return e.forEach(function(e) {
                    r[++t] = e;
                }), r;
            }
            var E, T, I, A = Array.prototype, D = Function.prototype, P = Object.prototype, F = b["__core-js_shared__"], M = (E = /[^.]+$/.exec(F && F.keys && F.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", R = D.toString, L = P.hasOwnProperty, z = P.toString, B = RegExp("^" + R.call(L).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), G = b.Symbol, $ = b.Uint8Array, V = P.propertyIsEnumerable, K = A.splice, U = (T = Object.keys, I = Object, function(e) {
                return T(I(e));
            }), q = Ne(b, "DataView"), H = Ne(b, "Map"), W = Ne(b, "Promise"), J = Ne(b, "Set"), Z = Ne(b, "WeakMap"), Q = Ne(Object, "create"), Y = Pe(q), X = Pe(H), ee = Pe(W), te = Pe(J), re = Pe(Z), ne = G ? G.prototype : void 0, ae = ne ? ne.valueOf : void 0, oe = ne ? ne.toString : void 0;
            function ie(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function ue(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function ce(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function se(e) {
                var t = -1, r = e ? e.length : 0;
                for(this.__data__ = new ce; ++t < r;)this.add(e[t]);
            }
            function le(e) {
                this.__data__ = new ue(e);
            }
            function fe(e, t) {
                var r = Le(e) || Re(e) ? function(e, t) {
                    for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                    return n;
                }(e.length, String) : [], n = r.length, a = !!n;
                for(var o in e)!t && !L.call(e, o) || a && ("length" == o || ke(o, n)) || r.push(o);
                return r;
            }
            function de(e, t) {
                for(var r = e.length; r--;)if (Me(e[r][0], t)) return r;
                return -1;
            }
            ie.prototype.clear = function() {
                this.__data__ = Q ? Q(null) : {};
            }, ie.prototype.delete = function(e) {
                return this.has(e) && delete this.__data__[e];
            }, ie.prototype.get = function(e) {
                var t = this.__data__;
                if (Q) {
                    var r = t[e];
                    return "__lodash_hash_undefined__" === r ? void 0 : r;
                }
                return L.call(t, e) ? t[e] : void 0;
            }, ie.prototype.has = function(e) {
                var t = this.__data__;
                return Q ? void 0 !== t[e] : L.call(t, e);
            }, ie.prototype.set = function(e, t) {
                return this.__data__[e] = Q && void 0 === t ? "__lodash_hash_undefined__" : t, this;
            }, ue.prototype.clear = function() {
                this.__data__ = [];
            }, ue.prototype.delete = function(e) {
                var t = this.__data__, r = de(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : K.call(t, r, 1), !0);
            }, ue.prototype.get = function(e) {
                var t = this.__data__, r = de(t, e);
                return r < 0 ? void 0 : t[r][1];
            }, ue.prototype.has = function(e) {
                return de(this.__data__, e) > -1;
            }, ue.prototype.set = function(e, t) {
                var r = this.__data__, n = de(r, e);
                return n < 0 ? r.push([
                    e,
                    t
                ]) : r[n][1] = t, this;
            }, ce.prototype.clear = function() {
                this.__data__ = {
                    hash: new ie,
                    map: new (H || ue),
                    string: new ie
                };
            }, ce.prototype.delete = function(e) {
                return xe(this, e).delete(e);
            }, ce.prototype.get = function(e) {
                return xe(this, e).get(e);
            }, ce.prototype.has = function(e) {
                return xe(this, e).has(e);
            }, ce.prototype.set = function(e, t) {
                return xe(this, e).set(e, t), this;
            }, se.prototype.add = se.prototype.push = function(e) {
                return this.__data__.set(e, "__lodash_hash_undefined__"), this;
            }, se.prototype.has = function(e) {
                return this.__data__.has(e);
            }, le.prototype.clear = function() {
                this.__data__ = new ue;
            }, le.prototype.delete = function(e) {
                return this.__data__.delete(e);
            }, le.prototype.get = function(e) {
                return this.__data__.get(e);
            }, le.prototype.has = function(e) {
                return this.__data__.has(e);
            }, le.prototype.set = function(e, t) {
                var r = this.__data__;
                if (r instanceof ue) {
                    var n = r.__data__;
                    if (!H || n.length < 199) return n.push([
                        e,
                        t
                    ]), this;
                    r = this.__data__ = new ce(n);
                }
                return r.set(e, t), this;
            };
            var pe, he, me = (pe = function(e, t) {
                return e && ye(e, t, qe);
            }, function(e, t) {
                if (null == e) return e;
                if (!ze(e)) return pe(e, t);
                for(var r = e.length, n = he ? r : -1, a = Object(e); (he ? n-- : ++n < r) && !1 !== t(a[n], n, a););
                return e;
            }), ye = function(e) {
                return function(t, r, n) {
                    for(var a = -1, o = Object(t), i = n(t), u = i.length; u--;){
                        var c = i[e ? u : ++a];
                        if (!1 === r(o[c], c, o)) break;
                    }
                    return t;
                };
            }();
            function be(e, t) {
                for(var r = 0, n = (t = Ee(t, e) ? [
                    t
                ] : Se(t)).length; null != e && r < n;)e = e[De(t[r++])];
                return r && r == n ? e : void 0;
            }
            function ge(e, t) {
                return null != e && t in Object(e);
            }
            function ve(e, t, r, u, c) {
                return e === t || (null == e || null == t || !$e(e) && !Ve(t) ? e != e && t != t : function(e, t, r, u, c, s) {
                    var l = Le(e), f = Le(t), d = "[object Array]", p = "[object Array]";
                    l || (d = (d = Oe(e)) == n ? o : d);
                    f || (p = (p = Oe(t)) == n ? o : p);
                    var h = d == o && !N(e), m = p == o && !N(t), y = d == p;
                    if (y && !h) return s || (s = new le), l || Ue(e) ? je(e, t, r, u, c, s) : function(e, t, r, n, o, u, c) {
                        switch(r){
                            case "[object DataView]":
                                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                e = e.buffer, t = t.buffer;
                            case "[object ArrayBuffer]":
                                return !(e.byteLength != t.byteLength || !n(new $(e), new $(t)));
                            case "[object Boolean]":
                            case "[object Date]":
                            case "[object Number]":
                                return Me(+e, +t);
                            case "[object Error]":
                                return e.name == t.name && e.message == t.message;
                            case "[object RegExp]":
                            case "[object String]":
                                return e == t + "";
                            case a:
                                var s = O;
                            case i:
                                var l = 2 & u;
                                if (s || (s = k), e.size != t.size && !l) return !1;
                                var f = c.get(e);
                                if (f) return f == t;
                                u |= 1, c.set(e, t);
                                var d = je(s(e), s(t), n, o, u, c);
                                return c.delete(e), d;
                            case "[object Symbol]":
                                if (ae) return ae.call(e) == ae.call(t);
                        }
                        return !1;
                    }(e, t, d, r, u, c, s);
                    if (!(2 & c)) {
                        var b = h && L.call(e, "__wrapped__"), g = m && L.call(t, "__wrapped__");
                        if (b || g) {
                            var v = b ? e.value() : e, C = g ? t.value() : t;
                            return s || (s = new le), r(v, C, u, c, s);
                        }
                    }
                    if (!y) return !1;
                    return s || (s = new le), function(e, t, r, n, a, o) {
                        var i = 2 & a, u = qe(e), c = u.length, s = qe(t).length;
                        if (c != s && !i) return !1;
                        var l = c;
                        for(; l--;){
                            var f = u[l];
                            if (!(i ? f in t : L.call(t, f))) return !1;
                        }
                        var d = o.get(e);
                        if (d && o.get(t)) return d == t;
                        var p = !0;
                        o.set(e, t), o.set(t, e);
                        var h = i;
                        for(; ++l < c;){
                            f = u[l];
                            var m = e[f], y = t[f];
                            if (n) var b = i ? n(y, m, f, t, e, o) : n(m, y, f, e, t, o);
                            if (!(void 0 === b ? m === y || r(m, y, n, a, o) : b)) {
                                p = !1;
                                break;
                            }
                            h || (h = "constructor" == f);
                        }
                        if (p && !h) {
                            var g = e.constructor, v = t.constructor;
                            g == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof v && v instanceof v || (p = !1);
                        }
                        return o.delete(e), o.delete(t), p;
                    }(e, t, r, u, c, s);
                }(e, t, ve, r, u, c));
            }
            function Ce(e) {
                return !(!$e(e) || function(e) {
                    return !!M && M in e;
                }(e)) && (Be(e) || N(e) ? B : d).test(Pe(e));
            }
            function _e(e) {
                var t, r;
                return "function" == typeof e ? e : null == e ? He : "object" == typeof e ? Le(e) ? function(e, t) {
                    if (Ee(e) && Te(t)) return Ie(De(e), t);
                    return function(r) {
                        var n = function(e, t, r) {
                            var n = null == e ? void 0 : be(e, t);
                            return void 0 === n ? r : n;
                        }(r, e);
                        return void 0 === n && n === t ? function(e, t) {
                            return null != e && function(e, t, r) {
                                t = Ee(t, e) ? [
                                    t
                                ] : Se(t);
                                var n, a = -1, o = t.length;
                                for(; ++a < o;){
                                    var i = De(t[a]);
                                    if (!(n = null != e && r(e, i))) break;
                                    e = e[i];
                                }
                                if (n) return n;
                                return !!(o = e ? e.length : 0) && Ge(o) && ke(i, o) && (Le(e) || Re(e));
                            }(e, t, ge);
                        }(r, e) : ve(t, n, void 0, 3);
                    };
                }(e[0], e[1]) : function(e) {
                    var t = function(e) {
                        var t = qe(e), r = t.length;
                        for(; r--;){
                            var n = t[r], a = e[n];
                            t[r] = [
                                n,
                                a,
                                Te(a)
                            ];
                        }
                        return t;
                    }(e);
                    if (1 == t.length && t[0][2]) return Ie(t[0][0], t[0][1]);
                    return function(r) {
                        return r === e || function(e, t, r, n) {
                            var a = r.length, o = a, i = !n;
                            if (null == e) return !o;
                            for(e = Object(e); a--;){
                                var u = r[a];
                                if (i && u[2] ? u[1] !== e[u[0]] : !(u[0] in e)) return !1;
                            }
                            for(; ++a < o;){
                                var c = (u = r[a])[0], s = e[c], l = u[1];
                                if (i && u[2]) {
                                    if (void 0 === s && !(c in e)) return !1;
                                } else {
                                    var f = new le;
                                    if (n) var d = n(s, l, c, e, t, f);
                                    if (!(void 0 === d ? ve(l, s, n, 3, f) : d)) return !1;
                                }
                            }
                            return !0;
                        }(r, e, t);
                    };
                }(e) : Ee(t = e) ? (r = De(t), function(e) {
                    return null == e ? void 0 : e[r];
                }) : function(e) {
                    return function(t) {
                        return be(t, e);
                    };
                }(t);
            }
            function we(e) {
                if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || P, t !== n) return U(e);
                var t, r, n, a = [];
                for(var o in Object(e))L.call(e, o) && "constructor" != o && a.push(o);
                return a;
            }
            function Se(e) {
                return Le(e) ? e : Ae(e);
            }
            function je(e, t, r, n, a, o) {
                var i = 2 & a, u = e.length, c = t.length;
                if (u != c && !(i && c > u)) return !1;
                var s = o.get(e);
                if (s && o.get(t)) return s == t;
                var l = -1, f = !0, d = 1 & a ? new se : void 0;
                for(o.set(e, t), o.set(t, e); ++l < u;){
                    var p = e[l], h = t[l];
                    if (n) var m = i ? n(h, p, l, t, e, o) : n(p, h, l, e, t, o);
                    if (void 0 !== m) {
                        if (m) continue;
                        f = !1;
                        break;
                    }
                    if (d) {
                        if (!j(t, function(e, t) {
                            if (!d.has(t) && (p === e || r(p, e, n, a, o))) return d.add(t);
                        })) {
                            f = !1;
                            break;
                        }
                    } else if (p !== h && !r(p, h, n, a, o)) {
                        f = !1;
                        break;
                    }
                }
                return o.delete(e), o.delete(t), f;
            }
            function xe(e, t) {
                var r, n, a = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
            }
            function Ne(e, t) {
                var r = function(e, t) {
                    return null == e ? void 0 : e[t];
                }(e, t);
                return Ce(r) ? r : void 0;
            }
            var Oe = function(e) {
                return z.call(e);
            };
            function ke(e, t) {
                return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || p.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function Ee(e, t) {
                if (Le(e)) return !1;
                var r = typeof e;
                return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Ke(e)) || c.test(e) || !u.test(e) || null != t && e in Object(t);
            }
            function Te(e) {
                return e == e && !$e(e);
            }
            function Ie(e, t) {
                return function(r) {
                    return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                };
            }
            (q && "[object DataView]" != Oe(new q(new ArrayBuffer(1))) || H && Oe(new H) != a || W && "[object Promise]" != Oe(W.resolve()) || J && Oe(new J) != i || Z && "[object WeakMap]" != Oe(new Z)) && (Oe = function(e) {
                var t = z.call(e), r = t == o ? e.constructor : void 0, n = r ? Pe(r) : void 0;
                if (n) switch(n){
                    case Y:
                        return "[object DataView]";
                    case X:
                        return a;
                    case ee:
                        return "[object Promise]";
                    case te:
                        return i;
                    case re:
                        return "[object WeakMap]";
                }
                return t;
            });
            var Ae = Fe(function(e) {
                var t;
                e = null == (t = e) ? "" : function(e) {
                    if ("string" == typeof e) return e;
                    if (Ke(e)) return oe ? oe.call(e) : "";
                    var t = e + "";
                    return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                }(t);
                var r = [];
                return s.test(e) && r.push(""), e.replace(l, function(e, t, n, a) {
                    r.push(n ? a.replace(f, "$1") : t || e);
                }), r;
            });
            function De(e) {
                if ("string" == typeof e || Ke(e)) return e;
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function Pe(e) {
                if (null != e) {
                    try {
                        return R.call(e);
                    } catch (e) {}
                    try {
                        return e + "";
                    } catch (e) {}
                }
                return "";
            }
            function Fe(e, t) {
                if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                var r = function() {
                    var n = arguments, a = t ? t.apply(this, n) : n[0], o = r.cache;
                    if (o.has(a)) return o.get(a);
                    var i = e.apply(this, n);
                    return r.cache = o.set(a, i), i;
                };
                return r.cache = new (Fe.Cache || ce), r;
            }
            function Me(e, t) {
                return e === t || e != e && t != t;
            }
            function Re(e) {
                return function(e) {
                    return Ve(e) && ze(e);
                }(e) && L.call(e, "callee") && (!V.call(e, "callee") || z.call(e) == n);
            }
            Fe.Cache = ce;
            var Le = Array.isArray;
            function ze(e) {
                return null != e && Ge(e.length) && !Be(e);
            }
            function Be(e) {
                var t = $e(e) ? z.call(e) : "";
                return "[object Function]" == t || "[object GeneratorFunction]" == t;
            }
            function Ge(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
            }
            function $e(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function Ve(e) {
                return !!e && "object" == typeof e;
            }
            function Ke(e) {
                return "symbol" == typeof e || Ve(e) && "[object Symbol]" == z.call(e);
            }
            var Ue = w ? function(e) {
                return function(t) {
                    return e(t);
                };
            }(w) : function(e) {
                return Ve(e) && Ge(e.length) && !!h[z.call(e)];
            };
            function qe(e) {
                return ze(e) ? fe(e) : we(e);
            }
            function He(e) {
                return e;
            }
            r.exports = function(e, t, r) {
                var n = Le(e) ? S : x, a = arguments.length < 3;
                return n(e, _e(t), r, a, me);
            };
        }).call(this, r(3), r(7)(e));
    },
    function(e, t) {
        e.exports = function(e) {
            return e.webpackPolyfill || (e.deprecate = function() {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
                enumerable: !0,
                get: function() {
                    return e.l;
                }
            }), Object.defineProperty(e, "id", {
                enumerable: !0,
                get: function() {
                    return e.i;
                }
            }), e.webpackPolyfill = 1), e;
        };
    },
    function(e, t) {
        String.prototype.padEnd || (String.prototype.padEnd = function(e, t) {
            return e >>= 0, t = String(void 0 !== t ? t : " "), this.length > e ? String(this) : ((e -= this.length) > t.length && (t += t.repeat(e / t.length)), String(this) + t.slice(0, e));
        });
    },
    function(e, t, r) {
        "use strict";
        function n(e, t, r) {
            return t in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function a(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }
        function o(e) {
            return function(e) {
                if (Array.isArray(e)) {
                    for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                    return r;
                }
            }(e) || a(e) || function() {
                throw new TypeError("Invalid attempt to spread non-iterable instance");
            }();
        }
        function i(e) {
            if (Array.isArray(e)) return e;
        }
        function u() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
        function c(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function s(e, t) {
            for(var r = 0; r < t.length; r++){
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        function l(e) {
            return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function f(e) {
            return (f = "function" == typeof Symbol && "symbol" === l(Symbol.iterator) ? function(e) {
                return l(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : l(e);
            })(e);
        }
        function d(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function p(e) {
            return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function h(e, t) {
            return (h = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        r.r(t);
        var m = r(0), y = r.n(m), b = r(5), g = r.n(b), v = r(4), C = r.n(v), _ = r(6), w = r.n(_), S = r(2), j = r.n(S), x = r(1), N = r.n(x);
        r(8);
        function O(e, t) {
            return i(e) || function(e, t) {
                var r = [], n = !0, a = !1, o = void 0;
                try {
                    for(var i, u = e[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                } catch (e) {
                    a = !0, o = e;
                } finally{
                    try {
                        n || null == u.return || u.return();
                    } finally{
                        if (a) throw o;
                    }
                }
                return r;
            }(e, t) || u();
        }
        var k = [
            [
                "Afghanistan",
                [
                    "asia"
                ],
                "af",
                "93"
            ],
            [
                "Albania",
                [
                    "europe"
                ],
                "al",
                "355"
            ],
            [
                "Algeria",
                [
                    "africa",
                    "north-africa"
                ],
                "dz",
                "213"
            ],
            [
                "Andorra",
                [
                    "europe"
                ],
                "ad",
                "376"
            ],
            [
                "Angola",
                [
                    "africa"
                ],
                "ao",
                "244"
            ],
            [
                "Antigua and Barbuda",
                [
                    "america",
                    "carribean"
                ],
                "ag",
                "1268"
            ],
            [
                "Argentina",
                [
                    "america",
                    "south-america"
                ],
                "ar",
                "54",
                "(..) ........",
                0,
                [
                    "11",
                    "221",
                    "223",
                    "261",
                    "264",
                    "2652",
                    "280",
                    "2905",
                    "291",
                    "2920",
                    "2966",
                    "299",
                    "341",
                    "342",
                    "343",
                    "351",
                    "376",
                    "379",
                    "381",
                    "3833",
                    "385",
                    "387",
                    "388"
                ]
            ],
            [
                "Armenia",
                [
                    "asia",
                    "ex-ussr"
                ],
                "am",
                "374",
                ".. ......"
            ],
            [
                "Aruba",
                [
                    "america",
                    "carribean"
                ],
                "aw",
                "297"
            ],
            [
                "Australia",
                [
                    "oceania"
                ],
                "au",
                "61",
                "(..) .... ....",
                0,
                [
                    "2",
                    "3",
                    "4",
                    "7",
                    "8",
                    "02",
                    "03",
                    "04",
                    "07",
                    "08"
                ]
            ],
            [
                "Austria",
                [
                    "europe",
                    "eu-union"
                ],
                "at",
                "43"
            ],
            [
                "Azerbaijan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "az",
                "994",
                "(..) ... .. .."
            ],
            [
                "Bahamas",
                [
                    "america",
                    "carribean"
                ],
                "bs",
                "1242"
            ],
            [
                "Bahrain",
                [
                    "middle-east"
                ],
                "bh",
                "973"
            ],
            [
                "Bangladesh",
                [
                    "asia"
                ],
                "bd",
                "880"
            ],
            [
                "Barbados",
                [
                    "america",
                    "carribean"
                ],
                "bb",
                "1246"
            ],
            [
                "Belarus",
                [
                    "europe",
                    "ex-ussr"
                ],
                "by",
                "375",
                "(..) ... .. .."
            ],
            [
                "Belgium",
                [
                    "europe",
                    "eu-union"
                ],
                "be",
                "32",
                "... .. .. .."
            ],
            [
                "Belize",
                [
                    "america",
                    "central-america"
                ],
                "bz",
                "501"
            ],
            [
                "Benin",
                [
                    "africa"
                ],
                "bj",
                "229"
            ],
            [
                "Bhutan",
                [
                    "asia"
                ],
                "bt",
                "975"
            ],
            [
                "Bolivia",
                [
                    "america",
                    "south-america"
                ],
                "bo",
                "591"
            ],
            [
                "Bosnia and Herzegovina",
                [
                    "europe",
                    "ex-yugos"
                ],
                "ba",
                "387"
            ],
            [
                "Botswana",
                [
                    "africa"
                ],
                "bw",
                "267"
            ],
            [
                "Brazil",
                [
                    "america",
                    "south-america"
                ],
                "br",
                "55",
                "(..) ........."
            ],
            [
                "British Indian Ocean Territory",
                [
                    "asia"
                ],
                "io",
                "246"
            ],
            [
                "Brunei",
                [
                    "asia"
                ],
                "bn",
                "673"
            ],
            [
                "Bulgaria",
                [
                    "europe",
                    "eu-union"
                ],
                "bg",
                "359"
            ],
            [
                "Burkina Faso",
                [
                    "africa"
                ],
                "bf",
                "226"
            ],
            [
                "Burundi",
                [
                    "africa"
                ],
                "bi",
                "257"
            ],
            [
                "Cambodia",
                [
                    "asia"
                ],
                "kh",
                "855"
            ],
            [
                "Cameroon",
                [
                    "africa"
                ],
                "cm",
                "237"
            ],
            [
                "Canada",
                [
                    "america",
                    "north-america"
                ],
                "ca",
                "1",
                "(...) ...-....",
                1,
                [
                    "204",
                    "226",
                    "236",
                    "249",
                    "250",
                    "289",
                    "306",
                    "343",
                    "365",
                    "387",
                    "403",
                    "416",
                    "418",
                    "431",
                    "437",
                    "438",
                    "450",
                    "506",
                    "514",
                    "519",
                    "548",
                    "579",
                    "581",
                    "587",
                    "604",
                    "613",
                    "639",
                    "647",
                    "672",
                    "705",
                    "709",
                    "742",
                    "778",
                    "780",
                    "782",
                    "807",
                    "819",
                    "825",
                    "867",
                    "873",
                    "902",
                    "905"
                ]
            ],
            [
                "Cape Verde",
                [
                    "africa"
                ],
                "cv",
                "238"
            ],
            [
                "Caribbean Netherlands",
                [
                    "america",
                    "carribean"
                ],
                "bq",
                "599",
                "",
                1
            ],
            [
                "Central African Republic",
                [
                    "africa"
                ],
                "cf",
                "236"
            ],
            [
                "Chad",
                [
                    "africa"
                ],
                "td",
                "235"
            ],
            [
                "Chile",
                [
                    "america",
                    "south-america"
                ],
                "cl",
                "56"
            ],
            [
                "China",
                [
                    "asia"
                ],
                "cn",
                "86",
                "..-........."
            ],
            [
                "Colombia",
                [
                    "america",
                    "south-america"
                ],
                "co",
                "57",
                "... ... ...."
            ],
            [
                "Comoros",
                [
                    "africa"
                ],
                "km",
                "269"
            ],
            [
                "Congo",
                [
                    "africa"
                ],
                "cd",
                "243"
            ],
            [
                "Congo",
                [
                    "africa"
                ],
                "cg",
                "242"
            ],
            [
                "Costa Rica",
                [
                    "america",
                    "central-america"
                ],
                "cr",
                "506",
                "....-...."
            ],
            [
                "C\xf4te d\u2019Ivoire",
                [
                    "africa"
                ],
                "ci",
                "225",
                ".. .. .. .."
            ],
            [
                "Croatia",
                [
                    "europe",
                    "eu-union",
                    "ex-yugos"
                ],
                "hr",
                "385"
            ],
            [
                "Cuba",
                [
                    "america",
                    "carribean"
                ],
                "cu",
                "53"
            ],
            [
                "Cura\xe7ao",
                [
                    "america",
                    "carribean"
                ],
                "cw",
                "599",
                "",
                0
            ],
            [
                "Cyprus",
                [
                    "europe",
                    "eu-union"
                ],
                "cy",
                "357",
                ".. ......"
            ],
            [
                "Czech Republic",
                [
                    "europe",
                    "eu-union"
                ],
                "cz",
                "420",
                "... ... ..."
            ],
            [
                "Denmark",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "dk",
                "45",
                ".. .. .. .."
            ],
            [
                "Djibouti",
                [
                    "africa"
                ],
                "dj",
                "253"
            ],
            [
                "Dominica",
                [
                    "america",
                    "carribean"
                ],
                "dm",
                "1767"
            ],
            [
                "Dominican Republic",
                [
                    "america",
                    "carribean"
                ],
                "do",
                "1",
                "",
                2,
                [
                    "809",
                    "829",
                    "849"
                ]
            ],
            [
                "Ecuador",
                [
                    "america",
                    "south-america"
                ],
                "ec",
                "593"
            ],
            [
                "Egypt",
                [
                    "africa",
                    "north-africa"
                ],
                "eg",
                "20"
            ],
            [
                "El Salvador",
                [
                    "america",
                    "central-america"
                ],
                "sv",
                "503",
                "....-...."
            ],
            [
                "Equatorial Guinea",
                [
                    "africa"
                ],
                "gq",
                "240"
            ],
            [
                "Eritrea",
                [
                    "africa"
                ],
                "er",
                "291"
            ],
            [
                "Estonia",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "ee",
                "372",
                ".... ......"
            ],
            [
                "Ethiopia",
                [
                    "africa"
                ],
                "et",
                "251"
            ],
            [
                "Fiji",
                [
                    "oceania"
                ],
                "fj",
                "679"
            ],
            [
                "Finland",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "fi",
                "358",
                ".. ... .. .."
            ],
            [
                "France",
                [
                    "europe",
                    "eu-union"
                ],
                "fr",
                "33",
                ". .. .. .. .."
            ],
            [
                "French Guiana",
                [
                    "america",
                    "south-america"
                ],
                "gf",
                "594"
            ],
            [
                "French Polynesia",
                [
                    "oceania"
                ],
                "pf",
                "689"
            ],
            [
                "Gabon",
                [
                    "africa"
                ],
                "ga",
                "241"
            ],
            [
                "Gambia",
                [
                    "africa"
                ],
                "gm",
                "220"
            ],
            [
                "Georgia",
                [
                    "asia",
                    "ex-ussr"
                ],
                "ge",
                "995"
            ],
            [
                "Germany",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "de",
                "49",
                ".... ........"
            ],
            [
                "Ghana",
                [
                    "africa"
                ],
                "gh",
                "233"
            ],
            [
                "Greece",
                [
                    "europe",
                    "eu-union"
                ],
                "gr",
                "30"
            ],
            [
                "Grenada",
                [
                    "america",
                    "carribean"
                ],
                "gd",
                "1473"
            ],
            [
                "Guadeloupe",
                [
                    "america",
                    "carribean"
                ],
                "gp",
                "590",
                "",
                0
            ],
            [
                "Guam",
                [
                    "oceania"
                ],
                "gu",
                "1671"
            ],
            [
                "Guatemala",
                [
                    "america",
                    "central-america"
                ],
                "gt",
                "502",
                "....-...."
            ],
            [
                "Guinea",
                [
                    "africa"
                ],
                "gn",
                "224"
            ],
            [
                "Guinea-Bissau",
                [
                    "africa"
                ],
                "gw",
                "245"
            ],
            [
                "Guyana",
                [
                    "america",
                    "south-america"
                ],
                "gy",
                "592"
            ],
            [
                "Haiti",
                [
                    "america",
                    "carribean"
                ],
                "ht",
                "509",
                "....-...."
            ],
            [
                "Honduras",
                [
                    "america",
                    "central-america"
                ],
                "hn",
                "504"
            ],
            [
                "Hong Kong",
                [
                    "asia"
                ],
                "hk",
                "852",
                ".... ...."
            ],
            [
                "Hungary",
                [
                    "europe",
                    "eu-union"
                ],
                "hu",
                "36"
            ],
            [
                "Iceland",
                [
                    "europe"
                ],
                "is",
                "354",
                "... ...."
            ],
            [
                "India",
                [
                    "asia"
                ],
                "in",
                "91",
                ".....-....."
            ],
            [
                "Indonesia",
                [
                    "asia"
                ],
                "id",
                "62"
            ],
            [
                "Iran",
                [
                    "middle-east"
                ],
                "ir",
                "98",
                "... ... ...."
            ],
            [
                "Iraq",
                [
                    "middle-east"
                ],
                "iq",
                "964"
            ],
            [
                "Ireland",
                [
                    "europe",
                    "eu-union"
                ],
                "ie",
                "353",
                ".. ......."
            ],
            [
                "Israel",
                [
                    "middle-east"
                ],
                "il",
                "972",
                "... ... ...."
            ],
            [
                "Italy",
                [
                    "europe",
                    "eu-union"
                ],
                "it",
                "39",
                "... .......",
                0
            ],
            [
                "Jamaica",
                [
                    "america",
                    "carribean"
                ],
                "jm",
                "1876"
            ],
            [
                "Japan",
                [
                    "asia"
                ],
                "jp",
                "81",
                ".. .... ...."
            ],
            [
                "Jordan",
                [
                    "middle-east"
                ],
                "jo",
                "962"
            ],
            [
                "Kazakhstan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "kz",
                "7",
                "... ...-..-..",
                1,
                [
                    "310",
                    "311",
                    "312",
                    "313",
                    "315",
                    "318",
                    "321",
                    "324",
                    "325",
                    "326",
                    "327",
                    "336",
                    "7172",
                    "73622"
                ]
            ],
            [
                "Kenya",
                [
                    "africa"
                ],
                "ke",
                "254"
            ],
            [
                "Kiribati",
                [
                    "oceania"
                ],
                "ki",
                "686"
            ],
            [
                "Kosovo",
                [
                    "europe",
                    "ex-yugos"
                ],
                "xk",
                "383"
            ],
            [
                "Kuwait",
                [
                    "middle-east"
                ],
                "kw",
                "965"
            ],
            [
                "Kyrgyzstan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "kg",
                "996",
                "... ... ..."
            ],
            [
                "Laos",
                [
                    "asia"
                ],
                "la",
                "856"
            ],
            [
                "Latvia",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "lv",
                "371",
                ".. ... ..."
            ],
            [
                "Lebanon",
                [
                    "middle-east"
                ],
                "lb",
                "961"
            ],
            [
                "Lesotho",
                [
                    "africa"
                ],
                "ls",
                "266"
            ],
            [
                "Liberia",
                [
                    "africa"
                ],
                "lr",
                "231"
            ],
            [
                "Libya",
                [
                    "africa",
                    "north-africa"
                ],
                "ly",
                "218"
            ],
            [
                "Liechtenstein",
                [
                    "europe"
                ],
                "li",
                "423"
            ],
            [
                "Lithuania",
                [
                    "europe",
                    "eu-union",
                    "ex-ussr",
                    "baltic"
                ],
                "lt",
                "370"
            ],
            [
                "Luxembourg",
                [
                    "europe",
                    "eu-union"
                ],
                "lu",
                "352"
            ],
            [
                "Macau",
                [
                    "asia"
                ],
                "mo",
                "853"
            ],
            [
                "Macedonia",
                [
                    "europe",
                    "ex-yugos"
                ],
                "mk",
                "389"
            ],
            [
                "Madagascar",
                [
                    "africa"
                ],
                "mg",
                "261"
            ],
            [
                "Malawi",
                [
                    "africa"
                ],
                "mw",
                "265"
            ],
            [
                "Malaysia",
                [
                    "asia"
                ],
                "my",
                "60",
                "..-....-...."
            ],
            [
                "Maldives",
                [
                    "asia"
                ],
                "mv",
                "960"
            ],
            [
                "Mali",
                [
                    "africa"
                ],
                "ml",
                "223"
            ],
            [
                "Malta",
                [
                    "europe",
                    "eu-union"
                ],
                "mt",
                "356"
            ],
            [
                "Marshall Islands",
                [
                    "oceania"
                ],
                "mh",
                "692"
            ],
            [
                "Martinique",
                [
                    "america",
                    "carribean"
                ],
                "mq",
                "596"
            ],
            [
                "Mauritania",
                [
                    "africa"
                ],
                "mr",
                "222"
            ],
            [
                "Mauritius",
                [
                    "africa"
                ],
                "mu",
                "230"
            ],
            [
                "Mexico",
                [
                    "america",
                    "central-america"
                ],
                "mx",
                "52",
                "... ... ....",
                0,
                [
                    "55",
                    "81",
                    "33",
                    "656",
                    "664",
                    "998",
                    "774",
                    "229"
                ]
            ],
            [
                "Micronesia",
                [
                    "oceania"
                ],
                "fm",
                "691"
            ],
            [
                "Moldova",
                [
                    "europe"
                ],
                "md",
                "373",
                "(..) ..-..-.."
            ],
            [
                "Monaco",
                [
                    "europe"
                ],
                "mc",
                "377"
            ],
            [
                "Mongolia",
                [
                    "asia"
                ],
                "mn",
                "976"
            ],
            [
                "Montenegro",
                [
                    "europe",
                    "ex-yugos"
                ],
                "me",
                "382"
            ],
            [
                "Morocco",
                [
                    "africa",
                    "north-africa"
                ],
                "ma",
                "212"
            ],
            [
                "Mozambique",
                [
                    "africa"
                ],
                "mz",
                "258"
            ],
            [
                "Myanmar",
                [
                    "asia"
                ],
                "mm",
                "95"
            ],
            [
                "Namibia",
                [
                    "africa"
                ],
                "na",
                "264"
            ],
            [
                "Nauru",
                [
                    "africa"
                ],
                "nr",
                "674"
            ],
            [
                "Nepal",
                [
                    "asia"
                ],
                "np",
                "977"
            ],
            [
                "Netherlands",
                [
                    "europe",
                    "eu-union"
                ],
                "nl",
                "31",
                ".. ........"
            ],
            [
                "New Caledonia",
                [
                    "oceania"
                ],
                "nc",
                "687"
            ],
            [
                "New Zealand",
                [
                    "oceania"
                ],
                "nz",
                "64",
                "...-...-...."
            ],
            [
                "Nicaragua",
                [
                    "america",
                    "central-america"
                ],
                "ni",
                "505"
            ],
            [
                "Niger",
                [
                    "africa"
                ],
                "ne",
                "227"
            ],
            [
                "Nigeria",
                [
                    "africa"
                ],
                "ng",
                "234"
            ],
            [
                "North Korea",
                [
                    "asia"
                ],
                "kp",
                "850"
            ],
            [
                "Norway",
                [
                    "europe",
                    "baltic"
                ],
                "no",
                "47",
                "... .. ..."
            ],
            [
                "Oman",
                [
                    "middle-east"
                ],
                "om",
                "968"
            ],
            [
                "Pakistan",
                [
                    "asia"
                ],
                "pk",
                "92",
                "...-......."
            ],
            [
                "Palau",
                [
                    "oceania"
                ],
                "pw",
                "680"
            ],
            [
                "Palestine",
                [
                    "middle-east"
                ],
                "ps",
                "970"
            ],
            [
                "Panama",
                [
                    "america",
                    "central-america"
                ],
                "pa",
                "507"
            ],
            [
                "Papua New Guinea",
                [
                    "oceania"
                ],
                "pg",
                "675"
            ],
            [
                "Paraguay",
                [
                    "america",
                    "south-america"
                ],
                "py",
                "595"
            ],
            [
                "Peru",
                [
                    "america",
                    "south-america"
                ],
                "pe",
                "51"
            ],
            [
                "Philippines",
                [
                    "asia"
                ],
                "ph",
                "63",
                ".... ......."
            ],
            [
                "Poland",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "pl",
                "48",
                "...-...-..."
            ],
            [
                "Portugal",
                [
                    "europe",
                    "eu-union"
                ],
                "pt",
                "351"
            ],
            [
                "Puerto Rico",
                [
                    "america",
                    "carribean"
                ],
                "pr",
                "1",
                "",
                3,
                [
                    "787",
                    "939"
                ]
            ],
            [
                "Qatar",
                [
                    "middle-east"
                ],
                "qa",
                "974"
            ],
            [
                "R\xe9union",
                [
                    "africa"
                ],
                "re",
                "262"
            ],
            [
                "Romania",
                [
                    "europe",
                    "eu-union"
                ],
                "ro",
                "40"
            ],
            [
                "Russia",
                [
                    "europe",
                    "asia",
                    "ex-ussr",
                    "baltic"
                ],
                "ru",
                "7",
                "(...) ...-..-..",
                0
            ],
            [
                "Rwanda",
                [
                    "africa"
                ],
                "rw",
                "250"
            ],
            [
                "Saint Kitts and Nevis",
                [
                    "america",
                    "carribean"
                ],
                "kn",
                "1869"
            ],
            [
                "Saint Lucia",
                [
                    "america",
                    "carribean"
                ],
                "lc",
                "1758"
            ],
            [
                "Saint Vincent and the Grenadines",
                [
                    "america",
                    "carribean"
                ],
                "vc",
                "1784"
            ],
            [
                "Samoa",
                [
                    "oceania"
                ],
                "ws",
                "685"
            ],
            [
                "San Marino",
                [
                    "europe"
                ],
                "sm",
                "378"
            ],
            [
                "S\xe3o Tom\xe9 and Pr\xedncipe",
                [
                    "africa"
                ],
                "st",
                "239"
            ],
            [
                "Saudi Arabia",
                [
                    "middle-east"
                ],
                "sa",
                "966"
            ],
            [
                "Senegal",
                [
                    "africa"
                ],
                "sn",
                "221"
            ],
            [
                "Serbia",
                [
                    "europe",
                    "ex-yugos"
                ],
                "rs",
                "381"
            ],
            [
                "Seychelles",
                [
                    "africa"
                ],
                "sc",
                "248"
            ],
            [
                "Sierra Leone",
                [
                    "africa"
                ],
                "sl",
                "232"
            ],
            [
                "Singapore",
                [
                    "asia"
                ],
                "sg",
                "65",
                "....-...."
            ],
            [
                "Slovakia",
                [
                    "europe",
                    "eu-union"
                ],
                "sk",
                "421"
            ],
            [
                "Slovenia",
                [
                    "europe",
                    "eu-union",
                    "ex-yugos"
                ],
                "si",
                "386"
            ],
            [
                "Solomon Islands",
                [
                    "oceania"
                ],
                "sb",
                "677"
            ],
            [
                "Somalia",
                [
                    "africa"
                ],
                "so",
                "252"
            ],
            [
                "South Africa",
                [
                    "africa"
                ],
                "za",
                "27"
            ],
            [
                "South Korea",
                [
                    "asia"
                ],
                "kr",
                "82",
                "... .... ...."
            ],
            [
                "South Sudan",
                [
                    "africa",
                    "north-africa"
                ],
                "ss",
                "211"
            ],
            [
                "Spain",
                [
                    "europe",
                    "eu-union"
                ],
                "es",
                "34",
                "... ... ..."
            ],
            [
                "Sri Lanka",
                [
                    "asia"
                ],
                "lk",
                "94"
            ],
            [
                "Sudan",
                [
                    "africa"
                ],
                "sd",
                "249"
            ],
            [
                "Suriname",
                [
                    "america",
                    "south-america"
                ],
                "sr",
                "597"
            ],
            [
                "Swaziland",
                [
                    "africa"
                ],
                "sz",
                "268"
            ],
            [
                "Sweden",
                [
                    "europe",
                    "eu-union",
                    "baltic"
                ],
                "se",
                "46",
                "(...) ...-..."
            ],
            [
                "Switzerland",
                [
                    "europe"
                ],
                "ch",
                "41",
                ".. ... .. .."
            ],
            [
                "Syria",
                [
                    "middle-east"
                ],
                "sy",
                "963"
            ],
            [
                "Taiwan",
                [
                    "asia"
                ],
                "tw",
                "886"
            ],
            [
                "Tajikistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "tj",
                "992"
            ],
            [
                "Tanzania",
                [
                    "africa"
                ],
                "tz",
                "255"
            ],
            [
                "Thailand",
                [
                    "asia"
                ],
                "th",
                "66"
            ],
            [
                "Timor-Leste",
                [
                    "asia"
                ],
                "tl",
                "670"
            ],
            [
                "Togo",
                [
                    "africa"
                ],
                "tg",
                "228"
            ],
            [
                "Tonga",
                [
                    "oceania"
                ],
                "to",
                "676"
            ],
            [
                "Trinidad and Tobago",
                [
                    "america",
                    "carribean"
                ],
                "tt",
                "1868"
            ],
            [
                "Tunisia",
                [
                    "africa",
                    "north-africa"
                ],
                "tn",
                "216"
            ],
            [
                "Turkey",
                [
                    "europe"
                ],
                "tr",
                "90",
                "... ... .. .."
            ],
            [
                "Turkmenistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "tm",
                "993"
            ],
            [
                "Tuvalu",
                [
                    "asia"
                ],
                "tv",
                "688"
            ],
            [
                "Uganda",
                [
                    "africa"
                ],
                "ug",
                "256"
            ],
            [
                "Ukraine",
                [
                    "europe",
                    "ex-ussr"
                ],
                "ua",
                "380",
                "(..) ... .. .."
            ],
            [
                "United Arab Emirates",
                [
                    "middle-east"
                ],
                "ae",
                "971"
            ],
            [
                "United Kingdom",
                [
                    "europe",
                    "eu-union"
                ],
                "gb",
                "44",
                ".... ......"
            ],
            [
                "United States",
                [
                    "america",
                    "north-america"
                ],
                "us",
                "1",
                "(...) ...-....",
                0,
                [
                    "907",
                    "205",
                    "251",
                    "256",
                    "334",
                    "479",
                    "501",
                    "870",
                    "480",
                    "520",
                    "602",
                    "623",
                    "928",
                    "209",
                    "213",
                    "310",
                    "323",
                    "408",
                    "415",
                    "510",
                    "530",
                    "559",
                    "562",
                    "619",
                    "626",
                    "650",
                    "661",
                    "707",
                    "714",
                    "760",
                    "805",
                    "818",
                    "831",
                    "858",
                    "909",
                    "916",
                    "925",
                    "949",
                    "951",
                    "303",
                    "719",
                    "970",
                    "203",
                    "860",
                    "202",
                    "302",
                    "239",
                    "305",
                    "321",
                    "352",
                    "386",
                    "407",
                    "561",
                    "727",
                    "772",
                    "813",
                    "850",
                    "863",
                    "904",
                    "941",
                    "954",
                    "229",
                    "404",
                    "478",
                    "706",
                    "770",
                    "912",
                    "808",
                    "319",
                    "515",
                    "563",
                    "641",
                    "712",
                    "208",
                    "217",
                    "309",
                    "312",
                    "618",
                    "630",
                    "708",
                    "773",
                    "815",
                    "847",
                    "219",
                    "260",
                    "317",
                    "574",
                    "765",
                    "812",
                    "316",
                    "620",
                    "785",
                    "913",
                    "270",
                    "502",
                    "606",
                    "859",
                    "225",
                    "318",
                    "337",
                    "504",
                    "985",
                    "413",
                    "508",
                    "617",
                    "781",
                    "978",
                    "301",
                    "410",
                    "207",
                    "231",
                    "248",
                    "269",
                    "313",
                    "517",
                    "586",
                    "616",
                    "734",
                    "810",
                    "906",
                    "989",
                    "218",
                    "320",
                    "507",
                    "612",
                    "651",
                    "763",
                    "952",
                    "314",
                    "417",
                    "573",
                    "636",
                    "660",
                    "816",
                    "228",
                    "601",
                    "662",
                    "406",
                    "252",
                    "336",
                    "704",
                    "828",
                    "910",
                    "919",
                    "701",
                    "308",
                    "402",
                    "603",
                    "201",
                    "609",
                    "732",
                    "856",
                    "908",
                    "973",
                    "505",
                    "575",
                    "702",
                    "775",
                    "212",
                    "315",
                    "516",
                    "518",
                    "585",
                    "607",
                    "631",
                    "716",
                    "718",
                    "845",
                    "914",
                    "216",
                    "330",
                    "419",
                    "440",
                    "513",
                    "614",
                    "740",
                    "937",
                    "405",
                    "580",
                    "918",
                    "503",
                    "541",
                    "215",
                    "412",
                    "570",
                    "610",
                    "717",
                    "724",
                    "814",
                    "401",
                    "803",
                    "843",
                    "864",
                    "605",
                    "423",
                    "615",
                    "731",
                    "865",
                    "901",
                    "931",
                    "210",
                    "214",
                    "254",
                    "281",
                    "325",
                    "361",
                    "409",
                    "432",
                    "512",
                    "713",
                    "806",
                    "817",
                    "830",
                    "903",
                    "915",
                    "936",
                    "940",
                    "956",
                    "972",
                    "979",
                    "435",
                    "801",
                    "276",
                    "434",
                    "540",
                    "703",
                    "757",
                    "804",
                    "802",
                    "206",
                    "253",
                    "360",
                    "425",
                    "509",
                    "262",
                    "414",
                    "608",
                    "715",
                    "920",
                    "304",
                    "307"
                ]
            ],
            [
                "Uruguay",
                [
                    "america",
                    "south-america"
                ],
                "uy",
                "598"
            ],
            [
                "Uzbekistan",
                [
                    "asia",
                    "ex-ussr"
                ],
                "uz",
                "998",
                ".. ... .. .."
            ],
            [
                "Vanuatu",
                [
                    "oceania"
                ],
                "vu",
                "678"
            ],
            [
                "Vatican City",
                [
                    "europe"
                ],
                "va",
                "39",
                ".. .... ....",
                1
            ],
            [
                "Venezuela",
                [
                    "america",
                    "south-america"
                ],
                "ve",
                "58"
            ],
            [
                "Vietnam",
                [
                    "asia"
                ],
                "vn",
                "84"
            ],
            [
                "Yemen",
                [
                    "middle-east"
                ],
                "ye",
                "967"
            ],
            [
                "Zambia",
                [
                    "africa"
                ],
                "zm",
                "260"
            ],
            [
                "Zimbabwe",
                [
                    "africa"
                ],
                "zw",
                "263"
            ]
        ], E = [
            [
                "American Samoa",
                [
                    "oceania"
                ],
                "as",
                "1684"
            ],
            [
                "Anguilla",
                [
                    "america",
                    "carribean"
                ],
                "ai",
                "1264"
            ],
            [
                "Bermuda",
                [
                    "america",
                    "north-america"
                ],
                "bm",
                "1441"
            ],
            [
                "British Virgin Islands",
                [
                    "america",
                    "carribean"
                ],
                "vg",
                "1284"
            ],
            [
                "Cayman Islands",
                [
                    "america",
                    "carribean"
                ],
                "ky",
                "1345"
            ],
            [
                "Cook Islands",
                [
                    "oceania"
                ],
                "ck",
                "682"
            ],
            [
                "Falkland Islands",
                [
                    "america",
                    "south-america"
                ],
                "fk",
                "500"
            ],
            [
                "Faroe Islands",
                [
                    "europe"
                ],
                "fo",
                "298"
            ],
            [
                "Gibraltar",
                [
                    "europe"
                ],
                "gi",
                "350"
            ],
            [
                "Greenland",
                [
                    "america"
                ],
                "gl",
                "299"
            ],
            [
                "Jersey",
                [
                    "europe",
                    "eu-union"
                ],
                "je",
                "44",
                ".... ......"
            ],
            [
                "Montserrat",
                [
                    "america",
                    "carribean"
                ],
                "ms",
                "1664"
            ],
            [
                "Niue",
                [
                    "asia"
                ],
                "nu",
                "683"
            ],
            [
                "Norfolk Island",
                [
                    "oceania"
                ],
                "nf",
                "672"
            ],
            [
                "Northern Mariana Islands",
                [
                    "oceania"
                ],
                "mp",
                "1670"
            ],
            [
                "Saint Barth\xe9lemy",
                [
                    "america",
                    "carribean"
                ],
                "bl",
                "590",
                "",
                1
            ],
            [
                "Saint Helena",
                [
                    "africa"
                ],
                "sh",
                "290"
            ],
            [
                "Saint Martin",
                [
                    "america",
                    "carribean"
                ],
                "mf",
                "590",
                "",
                2
            ],
            [
                "Saint Pierre and Miquelon",
                [
                    "america",
                    "north-america"
                ],
                "pm",
                "508"
            ],
            [
                "Sint Maarten",
                [
                    "america",
                    "carribean"
                ],
                "sx",
                "1721"
            ],
            [
                "Tokelau",
                [
                    "oceania"
                ],
                "tk",
                "690"
            ],
            [
                "Turks and Caicos Islands",
                [
                    "america",
                    "carribean"
                ],
                "tc",
                "1649"
            ],
            [
                "U.S. Virgin Islands",
                [
                    "america",
                    "carribean"
                ],
                "vi",
                "1340"
            ],
            [
                "Wallis and Futuna",
                [
                    "oceania"
                ],
                "wf",
                "681"
            ]
        ];
        function T(e, t, r, n, a) {
            return !r || a ? e + "".padEnd(t.length, ".") + " " + n : e + "".padEnd(t.length, ".") + " " + r;
        }
        function I(e, t, r, a, i) {
            var u, c, s = [];
            return c = !0 === t, [
                (u = []).concat.apply(u, o(e.map(function(e) {
                    var o = {
                        name: e[0],
                        regions: e[1],
                        iso2: e[2],
                        countryCode: e[3],
                        dialCode: e[3],
                        format: T(r, e[3], e[4], a, i),
                        priority: e[5] || 0
                    }, u = [];
                    return e[6] && e[6].map(function(t) {
                        var r = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {}, a = Object.keys(r);
                                "function" == typeof Object.getOwnPropertySymbols && (a = a.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
                                    return Object.getOwnPropertyDescriptor(r, e).enumerable;
                                }))), a.forEach(function(t) {
                                    n(e, t, r[t]);
                                });
                            }
                            return e;
                        }({}, o);
                        r.dialCode = e[3] + t, r.isAreaCode = !0, r.areaCodeLength = t.length, u.push(r);
                    }), u.length > 0 ? (o.mainCode = !0, c || "Array" === t.constructor.name && t.includes(e[2]) ? (o.hasAreaCodes = !0, [
                        o
                    ].concat(u)) : (s = s.concat(u), [
                        o
                    ])) : [
                        o
                    ];
                }))),
                s
            ];
        }
        function A(e, t, r, n) {
            if (null !== r) {
                var a = Object.keys(r), o = Object.values(r);
                a.forEach(function(r, a) {
                    if (n) return e.push([
                        r,
                        o[a]
                    ]);
                    var i = e.findIndex(function(e) {
                        return e[0] === r;
                    });
                    if (-1 === i) {
                        var u = [
                            r
                        ];
                        u[t] = o[a], e.push(u);
                    } else e[i][t] = o[a];
                });
            }
        }
        function D(e, t) {
            return 0 === t.length ? e : e.map(function(e) {
                var r = t.findIndex(function(t) {
                    return t[0] === e[2];
                });
                if (-1 === r) return e;
                var n = t[r];
                return n[1] && (e[4] = n[1]), n[3] && (e[5] = n[3]), n[2] && (e[6] = n[2]), e;
            });
        }
        var P = function e(t, r, n, a, i, u, s, l, f, d, p, h, m, y) {
            c(this, e), this.filterRegions = function(e, t) {
                if ("string" == typeof e) {
                    var r = e;
                    return t.filter(function(e) {
                        return e.regions.some(function(e) {
                            return e === r;
                        });
                    });
                }
                return t.filter(function(t) {
                    return e.map(function(e) {
                        return t.regions.some(function(t) {
                            return t === e;
                        });
                    }).some(function(e) {
                        return e;
                    });
                });
            }, this.sortTerritories = function(e, t) {
                var r = [].concat(o(e), o(t));
                return r.sort(function(e, t) {
                    return e.name < t.name ? -1 : e.name > t.name ? 1 : 0;
                }), r;
            }, this.getFilteredCountryList = function(e, t, r) {
                return 0 === e.length ? t : r ? e.map(function(e) {
                    var r = t.find(function(t) {
                        return t.iso2 === e;
                    });
                    if (r) return r;
                }).filter(function(e) {
                    return e;
                }) : t.filter(function(t) {
                    return e.some(function(e) {
                        return e === t.iso2;
                    });
                });
            }, this.localizeCountries = function(e, t, r) {
                for(var n = 0; n < e.length; n++)void 0 !== t[e[n].iso2] ? e[n].localName = t[e[n].iso2] : void 0 !== t[e[n].name] && (e[n].localName = t[e[n].name]);
                return r || e.sort(function(e, t) {
                    return e.localName < t.localName ? -1 : e.localName > t.localName ? 1 : 0;
                }), e;
            }, this.getCustomAreas = function(e, t) {
                for(var r = [], n = 0; n < t.length; n++){
                    var a = JSON.parse(JSON.stringify(e));
                    a.dialCode += t[n], r.push(a);
                }
                return r;
            }, this.excludeCountries = function(e, t) {
                return 0 === t.length ? e : e.filter(function(e) {
                    return !t.includes(e.iso2);
                });
            };
            var b = function(e, t, r) {
                var n = [];
                return A(n, 1, e, !0), A(n, 3, t), A(n, 2, r), n;
            }(l, f, d), g = D(JSON.parse(JSON.stringify(k)), b), v = D(JSON.parse(JSON.stringify(E)), b), C = O(I(g, t, h, m, y), 2), _ = C[0], w = C[1];
            if (r) {
                var S = O(I(v, t, h, m, y), 2), j = S[0];
                S[1];
                _ = this.sortTerritories(j, _);
            }
            n && (_ = this.filterRegions(n, _)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(a, _, s.includes("onlyCountries")), u), p, s.includes("onlyCountries")), this.preferredCountries = 0 === i.length ? [] : this.localizeCountries(this.getFilteredCountryList(i, _, s.includes("preferredCountries")), p, s.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(a, w), u);
        }, F = function(e) {
            function t(e) {
                var r;
                c(this, t), (r = function(e, t) {
                    return !t || "object" !== f(t) && "function" != typeof t ? d(e) : t;
                }(this, p(t).call(this, e))).getProbableCandidate = C()(function(e) {
                    return e && 0 !== e.length ? r.state.onlyCountries.filter(function(t) {
                        return j()(t.name.toLowerCase(), e.toLowerCase());
                    }, d(d(r)))[0] : null;
                }), r.guessSelectedCountry = C()(function(e, t, n, a) {
                    var o;
                    if (!1 === r.props.enableAreaCodes && (a.some(function(t) {
                        if (j()(e, t.dialCode)) return n.some(function(e) {
                            if (t.iso2 === e.iso2 && e.mainCode) return o = e, !0;
                        }), !0;
                    }), o)) return o;
                    var i = n.find(function(e) {
                        return e.iso2 == t;
                    });
                    if ("" === e.trim()) return i;
                    var u = n.reduce(function(t, r) {
                        if (j()(e, r.dialCode)) {
                            if (r.dialCode.length > t.dialCode.length) return r;
                            if (r.dialCode.length === t.dialCode.length && r.priority < t.priority) return r;
                        }
                        return t;
                    }, {
                        dialCode: "",
                        priority: 10001
                    }, d(d(r)));
                    return u.name ? u : i;
                }), r.updateCountry = function(e) {
                    var t, n = r.state.onlyCountries;
                    (t = e.indexOf(0) >= "0" && e.indexOf(0) <= "9" ? n.find(function(t) {
                        return t.dialCode == +e;
                    }) : n.find(function(t) {
                        return t.iso2 == e;
                    })) && t.dialCode && r.setState({
                        selectedCountry: t,
                        formattedNumber: r.props.disableCountryCode ? "" : r.formatNumber(t.dialCode, t)
                    });
                }, r.scrollTo = function(e, t) {
                    if (e) {
                        var n = r.dropdownRef;
                        if (n && document.body) {
                            var a = n.offsetHeight, o = n.getBoundingClientRect().top + document.body.scrollTop, i = o + a, u = e, c = u.getBoundingClientRect(), s = u.offsetHeight, l = c.top + document.body.scrollTop, f = l + s, d = l - o + n.scrollTop, p = a / 2 - s / 2;
                            if (r.props.enableSearch ? l < o + 32 : l < o) t && (d -= p), n.scrollTop = d;
                            else if (f > i) {
                                t && (d += p);
                                var h = a - s;
                                n.scrollTop = d - h;
                            }
                        }
                    }
                }, r.scrollToTop = function() {
                    var e = r.dropdownRef;
                    e && document.body && (e.scrollTop = 0);
                }, r.formatNumber = function(e, t) {
                    if (!t) return e;
                    var n, o = t.format, c = r.props, s = c.disableCountryCode, l = c.enableAreaCodeStretch, f = c.enableLongNumbers, d = c.autoFormat;
                    if (s ? ((n = o.split(" ")).shift(), n = n.join(" ")) : l && t.isAreaCode ? ((n = o.split(" "))[1] = n[1].replace(/\.+/, "".padEnd(t.areaCodeLength, ".")), n = n.join(" ")) : n = o, !e || 0 === e.length) return s ? "" : r.props.prefix;
                    if (e && e.length < 2 || !n || !d) return s ? e : r.props.prefix + e;
                    var p, h = w()(n, function(e, t) {
                        if (0 === e.remainingText.length) return e;
                        if ("." !== t) return {
                            formattedText: e.formattedText + t,
                            remainingText: e.remainingText
                        };
                        var r, n = i(r = e.remainingText) || a(r) || u(), o = n[0], c = n.slice(1);
                        return {
                            formattedText: e.formattedText + o,
                            remainingText: c
                        };
                    }, {
                        formattedText: "",
                        remainingText: e.split("")
                    });
                    return (p = f ? h.formattedText + h.remainingText.join("") : h.formattedText).includes("(") && !p.includes(")") && (p += ")"), p;
                }, r.cursorToEnd = function() {
                    var e = r.numberInputRef;
                    if (document.activeElement === e) {
                        e.focus();
                        var t = e.value.length;
                        ")" === e.value.charAt(t - 1) && (t -= 1), e.setSelectionRange(t, t);
                    }
                }, r.getElement = function(e) {
                    return r["flag_no_".concat(e)];
                }, r.getCountryData = function() {
                    return r.state.selectedCountry ? {
                        name: r.state.selectedCountry.name || "",
                        dialCode: r.state.selectedCountry.dialCode || "",
                        countryCode: r.state.selectedCountry.iso2 || "",
                        format: r.state.selectedCountry.format || ""
                    } : {};
                }, r.handleFlagDropdownClick = function(e) {
                    if (e.preventDefault(), r.state.showDropdown || !r.props.disabled) {
                        var t = r.state, n = t.preferredCountries, a = t.onlyCountries, o = t.selectedCountry, i = r.concatPreferredCountries(n, a).findIndex(function(e) {
                            return e.dialCode === o.dialCode && e.iso2 === o.iso2;
                        });
                        r.setState({
                            showDropdown: !r.state.showDropdown,
                            highlightCountryIndex: i
                        }, function() {
                            r.state.showDropdown && r.scrollTo(r.getElement(r.state.highlightCountryIndex));
                        });
                    }
                }, r.handleInput = function(e) {
                    var t = e.target.value, n = r.props, a = n.prefix, o = n.onChange, i = r.props.disableCountryCode ? "" : a, u = r.state.selectedCountry, c = r.state.freezeSelection;
                    if (!r.props.countryCodeEditable) {
                        var s = a + (u.hasAreaCodes ? r.state.onlyCountries.find(function(e) {
                            return e.iso2 === u.iso2 && e.mainCode;
                        }).dialCode : u.dialCode);
                        if (t.slice(0, s.length) !== s) return;
                    }
                    if (t === a) return o && o("", r.getCountryData(), e, ""), r.setState({
                        formattedNumber: ""
                    });
                    if (t.replace(/\D/g, "").length > 15) {
                        if (!1 === r.props.enableLongNumbers) return;
                        if ("number" == typeof r.props.enableLongNumbers && t.replace(/\D/g, "").length > r.props.enableLongNumbers) return;
                    }
                    if (t !== r.state.formattedNumber) {
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var l = r.props.country, f = r.state, d = f.onlyCountries, p = f.selectedCountry, h = f.hiddenAreaCodes;
                        if (o && e.persist(), t.length > 0) {
                            var m = t.replace(/\D/g, "");
                            (!r.state.freezeSelection || p && p.dialCode.length > m.length) && (u = r.props.disableCountryGuess ? p : r.guessSelectedCountry(m.substring(0, 6), l, d, h) || p, c = !1), i = r.formatNumber(m, u), u = u.dialCode ? u : p;
                        }
                        var y = e.target.selectionStart, b = e.target.selectionStart, g = r.state.formattedNumber, v = i.length - g.length;
                        r.setState({
                            formattedNumber: i,
                            freezeSelection: c,
                            selectedCountry: u
                        }, function() {
                            v > 0 && (b -= v), ")" == i.charAt(i.length - 1) ? r.numberInputRef.setSelectionRange(i.length - 1, i.length - 1) : b > 0 && g.length >= i.length ? r.numberInputRef.setSelectionRange(b, b) : y < g.length && r.numberInputRef.setSelectionRange(y, y), o && o(i.replace(/[^0-9]+/g, ""), r.getCountryData(), e, i);
                        });
                    }
                }, r.handleInputClick = function(e) {
                    r.setState({
                        showDropdown: !1
                    }), r.props.onClick && r.props.onClick(e, r.getCountryData());
                }, r.handleDoubleClick = function(e) {
                    var t = e.target.value.length;
                    e.target.setSelectionRange(0, t);
                }, r.handleFlagItemClick = function(e, t) {
                    var n = r.state.selectedCountry, a = r.state.onlyCountries.find(function(t) {
                        return t == e;
                    });
                    if (a) {
                        var o = r.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), i = o.length > 1 ? o.replace(n.dialCode, a.dialCode) : a.dialCode, u = r.formatNumber(i.replace(/\D/g, ""), a);
                        r.setState({
                            showDropdown: !1,
                            selectedCountry: a,
                            freezeSelection: !0,
                            formattedNumber: u,
                            searchValue: ""
                        }, function() {
                            r.cursorToEnd(), r.props.onChange && r.props.onChange(u.replace(/[^0-9]+/g, ""), r.getCountryData(), t, u);
                        });
                    }
                }, r.handleInputFocus = function(e) {
                    r.numberInputRef && r.numberInputRef.value === r.props.prefix && r.state.selectedCountry && !r.props.disableCountryCode && r.setState({
                        formattedNumber: r.props.prefix + r.state.selectedCountry.dialCode
                    }, function() {
                        r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
                    }), r.setState({
                        placeholder: ""
                    }), r.props.onFocus && r.props.onFocus(e, r.getCountryData()), r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
                }, r.handleInputBlur = function(e) {
                    e.target.value || r.setState({
                        placeholder: r.props.placeholder
                    }), r.props.onBlur && r.props.onBlur(e, r.getCountryData());
                }, r.handleInputCopy = function(e) {
                    if (r.props.copyNumbersOnly) {
                        var t = window.getSelection().toString().replace(/[^0-9]+/g, "");
                        e.clipboardData.setData("text/plain", t), e.preventDefault();
                    }
                }, r.getHighlightCountryIndex = function(e) {
                    var t = r.state.highlightCountryIndex + e;
                    return t < 0 || t >= r.state.onlyCountries.length + r.state.preferredCountries.length ? t - e : r.props.enableSearch && t > r.getSearchFilteredCountries().length ? 0 : t;
                }, r.searchCountry = function() {
                    var e = r.getProbableCandidate(r.state.queryString) || r.state.onlyCountries[0], t = r.state.onlyCountries.findIndex(function(t) {
                        return t == e;
                    }) + r.state.preferredCountries.length;
                    r.scrollTo(r.getElement(t), !0), r.setState({
                        queryString: "",
                        highlightCountryIndex: t
                    });
                }, r.handleKeydown = function(e) {
                    var t = r.props.keys, n = e.target.className;
                    if (n.includes("selected-flag") && e.which === t.ENTER && !r.state.showDropdown) return r.handleFlagDropdownClick(e);
                    if (n.includes("form-control") && (e.which === t.ENTER || e.which === t.ESC)) return e.target.blur();
                    if (r.state.showDropdown && !r.props.disabled && (!n.includes("search-box") || e.which === t.UP || e.which === t.DOWN || e.which === t.ENTER || e.which === t.ESC && "" === e.target.value)) {
                        e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                        var a = function(e) {
                            r.setState({
                                highlightCountryIndex: r.getHighlightCountryIndex(e)
                            }, function() {
                                r.scrollTo(r.getElement(r.state.highlightCountryIndex), !0);
                            });
                        };
                        switch(e.which){
                            case t.DOWN:
                                a(1);
                                break;
                            case t.UP:
                                a(-1);
                                break;
                            case t.ENTER:
                                r.props.enableSearch ? r.handleFlagItemClick(r.getSearchFilteredCountries()[r.state.highlightCountryIndex] || r.getSearchFilteredCountries()[0], e) : r.handleFlagItemClick([].concat(o(r.state.preferredCountries), o(r.state.onlyCountries))[r.state.highlightCountryIndex], e);
                                break;
                            case t.ESC:
                            case t.TAB:
                                r.setState({
                                    showDropdown: !1
                                }, r.cursorToEnd);
                                break;
                            default:
                                (e.which >= t.A && e.which <= t.Z || e.which === t.SPACE) && r.setState({
                                    queryString: r.state.queryString + String.fromCharCode(e.which)
                                }, r.state.debouncedQueryStingSearcher);
                        }
                    }
                }, r.handleInputKeyDown = function(e) {
                    var t = r.props, n = t.keys, a = t.onEnterKeyPress, o = t.onKeyDown;
                    e.which === n.ENTER && a && a(e), o && o(e);
                }, r.handleClickOutside = function(e) {
                    r.dropdownRef && !r.dropdownContainerRef.contains(e.target) && r.state.showDropdown && r.setState({
                        showDropdown: !1
                    });
                }, r.handleSearchChange = function(e) {
                    var t = e.currentTarget.value, n = r.state, a = n.preferredCountries, o = n.selectedCountry, i = 0;
                    if ("" === t && o) {
                        var u = r.state.onlyCountries;
                        i = r.concatPreferredCountries(a, u).findIndex(function(e) {
                            return e == o;
                        }), setTimeout(function() {
                            return r.scrollTo(r.getElement(i));
                        }, 100);
                    }
                    r.setState({
                        searchValue: t,
                        highlightCountryIndex: i
                    });
                }, r.concatPreferredCountries = function(e, t) {
                    return e.length > 0 ? o(new Set(e.concat(t))) : t;
                }, r.getDropdownCountryName = function(e) {
                    return e.localName || e.name;
                }, r.getSearchFilteredCountries = function() {
                    var e = r.state, t = e.preferredCountries, n = e.onlyCountries, a = e.searchValue, i = r.props.enableSearch, u = r.concatPreferredCountries(t, n), c = a.trim().toLowerCase().replace("+", "");
                    if (i && c) {
                        if (/^\d+$/.test(c)) return u.filter(function(e) {
                            var t = e.dialCode;
                            return [
                                "".concat(t)
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        });
                        var s = u.filter(function(e) {
                            var t = e.iso2;
                            return [
                                "".concat(t)
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        }), l = u.filter(function(e) {
                            var t = e.name, r = e.localName;
                            e.iso2;
                            return [
                                "".concat(t),
                                "".concat(r || "")
                            ].some(function(e) {
                                return e.toLowerCase().includes(c);
                            });
                        });
                        return r.scrollToTop(), o(new Set([].concat(s, l)));
                    }
                    return u;
                }, r.getCountryDropdownList = function() {
                    var e = r.state, t = e.preferredCountries, a = e.highlightCountryIndex, o = e.showDropdown, i = e.searchValue, u = r.props, c = u.disableDropdown, s = u.prefix, l = r.props, f = l.enableSearch, d = l.searchNotFound, p = l.disableSearchIcon, h = l.searchClass, m = l.searchStyle, b = l.searchPlaceholder, g = l.autocompleteSearch, v = r.getSearchFilteredCountries().map(function(e, t) {
                        var n = a === t, o = N()({
                            country: !0,
                            preferred: "us" === e.iso2 || "gb" === e.iso2,
                            active: "us" === e.iso2,
                            highlight: n
                        }), i = "flag ".concat(e.iso2);
                        return y.a.createElement("li", Object.assign({
                            ref: function(e) {
                                return r["flag_no_".concat(t)] = e;
                            },
                            key: "flag_no_".concat(t),
                            "data-flag-key": "flag_no_".concat(t),
                            className: o,
                            "data-dial-code": "1",
                            tabIndex: c ? "-1" : "0",
                            "data-country-code": e.iso2,
                            onClick: function(t) {
                                return r.handleFlagItemClick(e, t);
                            },
                            role: "option"
                        }, n ? {
                            "aria-selected": !0
                        } : {}), y.a.createElement("div", {
                            className: i
                        }), y.a.createElement("span", {
                            className: "country-name"
                        }, r.getDropdownCountryName(e)), y.a.createElement("span", {
                            className: "dial-code"
                        }, e.format ? r.formatNumber(e.dialCode, e) : s + e.dialCode));
                    }), C = y.a.createElement("li", {
                        key: "dashes",
                        className: "divider"
                    });
                    t.length > 0 && (!f || f && !i.trim()) && v.splice(t.length, 0, C);
                    var _ = N()(n({
                        "country-list": !0,
                        hide: !o
                    }, r.props.dropdownClass, !0));
                    return y.a.createElement("ul", {
                        ref: function(e) {
                            return !f && e && e.focus(), r.dropdownRef = e;
                        },
                        className: _,
                        style: r.props.dropdownStyle,
                        role: "listbox",
                        tabIndex: "0"
                    }, f && y.a.createElement("li", {
                        className: N()(n({
                            search: !0
                        }, h, h))
                    }, !p && y.a.createElement("span", {
                        className: N()(n({
                            "search-emoji": !0
                        }, "".concat(h, "-emoji"), h)),
                        role: "img",
                        "aria-label": "Magnifying glass"
                    }, "\uD83D\uDD0E"), y.a.createElement("input", {
                        className: N()(n({
                            "search-box": !0
                        }, "".concat(h, "-box"), h)),
                        style: m,
                        type: "search",
                        placeholder: b,
                        autoFocus: !0,
                        autoComplete: g ? "on" : "off",
                        value: i,
                        onChange: r.handleSearchChange
                    })), v.length > 0 ? v : y.a.createElement("li", {
                        className: "no-entries-message"
                    }, y.a.createElement("span", null, d)));
                };
                var s, l = new P(e.enableAreaCodes, e.enableTerritories, e.regions, e.onlyCountries, e.preferredCountries, e.excludeCountries, e.preserveOrder, e.masks, e.priority, e.areaCodes, e.localization, e.prefix, e.defaultMask, e.alwaysDefaultMask), h = l.onlyCountries, m = l.preferredCountries, b = l.hiddenAreaCodes, v = e.value ? e.value.replace(/\D/g, "") : "";
                s = e.disableInitialCountryGuess ? 0 : v.length > 1 ? r.guessSelectedCountry(v.substring(0, 6), e.country, h, b) || 0 : e.country && h.find(function(t) {
                    return t.iso2 == e.country;
                }) || 0;
                var _, S = v.length < 2 && s && !j()(v, s.dialCode) ? s.dialCode : "";
                _ = "" === v && 0 === s ? "" : r.formatNumber((e.disableCountryCode ? "" : S) + v, s.name ? s : void 0);
                var x = h.findIndex(function(e) {
                    return e == s;
                });
                return r.state = {
                    showDropdown: e.showDropdown,
                    formattedNumber: _,
                    onlyCountries: h,
                    preferredCountries: m,
                    hiddenAreaCodes: b,
                    selectedCountry: s,
                    highlightCountryIndex: x,
                    queryString: "",
                    freezeSelection: !1,
                    debouncedQueryStingSearcher: g()(r.searchCountry, 250),
                    searchValue: ""
                }, r;
            }
            var r, l, m;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && h(e, t);
            }(t, e), r = t, l = [
                {
                    key: "componentDidMount",
                    value: function() {
                        document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function(e, t, r) {
                        e.country !== this.props.country ? this.updateCountry(this.props.country) : e.value !== this.props.value && this.updateFormattedNumber(this.props.value);
                    }
                },
                {
                    key: "updateFormattedNumber",
                    value: function(e) {
                        if (null === e) return this.setState({
                            selectedCountry: 0,
                            formattedNumber: ""
                        });
                        var t = this.state, r = t.onlyCountries, n = t.selectedCountry, a = t.hiddenAreaCodes, o = this.props, i = o.country, u = o.prefix;
                        if ("" === e) return this.setState({
                            selectedCountry: n,
                            formattedNumber: ""
                        });
                        var c, s, l = e.replace(/\D/g, "");
                        if (n && j()(e, u + n.dialCode)) s = this.formatNumber(l, n), this.setState({
                            formattedNumber: s
                        });
                        else {
                            var f = (c = this.props.disableCountryGuess ? n : this.guessSelectedCountry(l.substring(0, 6), i, r, a) || n) && j()(l, u + c.dialCode) ? c.dialCode : "";
                            s = this.formatNumber((this.props.disableCountryCode ? "" : f) + l, c || void 0), this.setState({
                                selectedCountry: c,
                                formattedNumber: s
                            });
                        }
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e, t, r, a = this, o = this.state, i = o.onlyCountries, u = o.selectedCountry, c = o.showDropdown, s = o.formattedNumber, l = o.hiddenAreaCodes, f = this.props, d = f.disableDropdown, p = f.renderStringAsFlag, h = f.isValid, m = f.defaultErrorMessage, b = f.specialLabel;
                        if ("boolean" == typeof h) t = h;
                        else {
                            var g = h(s.replace(/\D/g, ""), u, i, l);
                            "boolean" == typeof g ? !1 === (t = g) && (r = m) : (t = !1, r = g);
                        }
                        var v = N()((n(e = {}, this.props.containerClass, !0), n(e, "react-tel-input", !0), e)), C = N()({
                            arrow: !0,
                            up: c
                        }), _ = N()(n({
                            "form-control": !0,
                            "invalid-number": !t,
                            open: c
                        }, this.props.inputClass, !0)), w = N()({
                            "selected-flag": !0,
                            open: c
                        }), S = N()(n({
                            "flag-dropdown": !0,
                            "invalid-number": !t,
                            open: c
                        }, this.props.buttonClass, !0)), j = "flag ".concat(u && u.iso2);
                        return y.a.createElement("div", {
                            className: "".concat(v, " ").concat(this.props.className),
                            style: this.props.style || this.props.containerStyle,
                            onKeyDown: this.handleKeydown
                        }, b && y.a.createElement("div", {
                            className: "special-label"
                        }, b), r && y.a.createElement("div", {
                            className: "invalid-number-message"
                        }, r), y.a.createElement("input", Object.assign({
                            className: _,
                            style: this.props.inputStyle,
                            onChange: this.handleInput,
                            onClick: this.handleInputClick,
                            onDoubleClick: this.handleDoubleClick,
                            onFocus: this.handleInputFocus,
                            onBlur: this.handleInputBlur,
                            onCopy: this.handleInputCopy,
                            value: s,
                            onKeyDown: this.handleInputKeyDown,
                            placeholder: this.props.placeholder,
                            disabled: this.props.disabled,
                            type: "tel"
                        }, this.props.inputProps, {
                            ref: function(e) {
                                a.numberInputRef = e, "function" == typeof a.props.inputProps.ref ? a.props.inputProps.ref(e) : "object" == typeof a.props.inputProps.ref && (a.props.inputProps.ref.current = e);
                            }
                        })), y.a.createElement("div", {
                            className: S,
                            style: this.props.buttonStyle,
                            ref: function(e) {
                                return a.dropdownContainerRef = e;
                            }
                        }, p ? y.a.createElement("div", {
                            className: w
                        }, p) : y.a.createElement("div", {
                            onClick: d ? void 0 : this.handleFlagDropdownClick,
                            className: w,
                            title: u ? "".concat(u.localName || u.name, ": + ").concat(u.dialCode) : "",
                            tabIndex: d ? "-1" : "0",
                            role: "button",
                            "aria-haspopup": "listbox",
                            "aria-expanded": !!c || void 0
                        }, y.a.createElement("div", {
                            className: j
                        }, !d && y.a.createElement("div", {
                            className: C
                        }))), c && this.getCountryDropdownList()));
                    }
                }
            ], s(r.prototype, l), m && s(r, m), t;
        }(y.a.Component);
        F.defaultProps = {
            country: "",
            value: "",
            onlyCountries: [],
            preferredCountries: [],
            excludeCountries: [],
            placeholder: "1 (702) 123-4567",
            searchPlaceholder: "search",
            searchNotFound: "No entries to show",
            flagsImagePath: "./flags.png",
            disabled: !1,
            containerStyle: {},
            inputStyle: {},
            buttonStyle: {},
            dropdownStyle: {},
            searchStyle: {},
            containerClass: "",
            inputClass: "",
            buttonClass: "",
            dropdownClass: "",
            searchClass: "",
            className: "",
            autoFormat: !0,
            enableAreaCodes: !1,
            enableTerritories: !1,
            disableCountryCode: !1,
            disableDropdown: !1,
            enableLongNumbers: !1,
            countryCodeEditable: !0,
            enableSearch: !1,
            disableSearchIcon: !1,
            disableInitialCountryGuess: !1,
            disableCountryGuess: !1,
            regions: "",
            inputProps: {},
            localization: {},
            masks: null,
            priority: null,
            areaCodes: null,
            preserveOrder: [],
            defaultMask: "... ... ... ... ..",
            alwaysDefaultMask: !1,
            prefix: "+",
            copyNumbersOnly: !0,
            renderStringAsFlag: "",
            autocompleteSearch: !1,
            jumpCursorToEnd: !0,
            enableAreaCodeStretch: !1,
            enableClickOutside: !0,
            showDropdown: !1,
            isValid: !0,
            defaultErrorMessage: "",
            specialLabel: "Phone",
            onEnterKeyPress: null,
            keys: {
                UP: 38,
                DOWN: 40,
                RIGHT: 39,
                LEFT: 37,
                ENTER: 13,
                ESC: 27,
                PLUS: 43,
                A: 65,
                Z: 90,
                SPACE: 32,
                TAB: 9
            }
        };
        t.default = F;
    }
]);

},{"35b441856cb52ead":"9njXz"}],"c2vor":[function() {},{}],"9mWBa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _commandService = require("../../Services/CommandService");
var _commandServiceDefault = parcelHelpers.interopDefault(_commandService);
var _assetCommandHistoryDisplay = require("./AssetCommandHistoryDisplay");
var _assetCommandHistoryDisplayDefault = parcelHelpers.interopDefault(_assetCommandHistoryDisplay);
const SORT_DIRECTIONS = [
    "asc",
    "desc"
];
const limit = 20;
let searchTimeout;
const initState = {
    dataLoading: true,
    sort: "Date",
    order: "desc",
    jobName: "",
    status: "",
    page: 1,
    dataCount: 0,
    data: [],
    error: ""
};
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetCommandHistoryContainer);
function AssetCommandHistoryContainer(props) {
    const { asset: { remote }, commandExecuted, toggleCommandExecuted } = props;
    const { assetID } = (0, _reactRouterDom.useParams)();
    const [state, updateState] = (0, _react.useState)(initState);
    const [showMobileFilters, toggleMobileFilters] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)("");
    let source = (0, _axios.CancelToken).source();
    const commandService = new (0, _commandServiceDefault.default)();
    const handleSortClick = ()=>{
        const [order] = SORT_DIRECTIONS.filter((d)=>d !== state.order);
        updateCommandHistoryState({
            page: 1,
            order
        });
    };
    const setPage = (page)=>{
        if (page === state.page) return;
        updateCommandHistoryState({
            page
        });
    };
    const handleStatusSelect = (status)=>{
        if (status === state.status) return;
        updateCommandHistoryState({
            page: 1,
            status
        });
    };
    const handleSearch = ({ target: { value: jobName } = {} } = {})=>{
        updateState({
            ...state,
            dataLoading: true,
            jobName
        });
        window.clearTimeout(searchTimeout);
        searchTimeout = window.setTimeout(()=>{
            updateCommandHistoryState({
                jobName,
                page: 1
            });
        }, 1000);
    };
    const updateCommandHistoryState = async (params)=>{
        try {
            const { jobs: data = [], count: dataCount = 0 } = await fetchCommandHistory(params);
            updateState({
                ...state,
                data,
                dataCount,
                ...params,
                dataLoading: false
            });
        } catch (err) {
            setError(err.message);
            updateState({
                ...state,
                dataLoading: false
            });
        }
    };
    const fetchCommandHistory = async ({ page = state.page, order = state.order, jobName = state.jobName, status = state.status } = {})=>{
        try {
            updateState({
                ...state,
                dataLoading: true
            });
            const params = {
                page,
                limit,
                order,
                jobName,
                status
            };
            const commandHistory = await commandService.fetchPaginatedCommandHistory(assetID, params, source.token);
            return commandHistory || {};
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) {
                setError(err.response?.data?.message ?? err.message);
                updateState({
                    ...state,
                    dataLoading: false
                });
            }
            return {};
        }
    };
    const _componentCleanup = ()=>{
        source.cancel();
        window.clearTimeout(searchTimeout);
    };
    (0, _react.useEffect)(()=>{
        if (!assetID) return;
        source = (0, _axios.CancelToken).source();
        updateCommandHistoryState();
        if (commandExecuted) toggleCommandExecuted();
        return _componentCleanup;
    }, [
        assetID,
        commandExecuted
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetCommandHistoryDisplayDefault.default), {
        ...props,
        ...state,
        tab: "commandHistory",
        handlePageChange: setPage,
        error: error,
        setError: setError,
        sort: {
            by: "Date",
            direction: state.order
        },
        handleSortClick: handleSortClick,
        handleStatusSelect: handleStatusSelect,
        handleSearch: handleSearch,
        dataLoading: state.dataLoading,
        pages: Math.ceil(state.dataCount / limit),
        remote: remote,
        showMobileFilters: showMobileFilters,
        toggleMobileFilters: toggleMobileFilters
    });
}
AssetCommandHistoryContainer.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        remote: (0, _propTypesDefault.default).bool
    }),
    commandExecuted: (0, _propTypesDefault.default).bool,
    toggleCommandExecuted: (0, _propTypesDefault.default).func
};
AssetCommandHistoryContainer.defaultProps = {
    asset: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","../../Services/CommandService":"2UWSi","./AssetCommandHistoryDisplay":"3bfnB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2UWSi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class CommandService {
    api = new (0, _requestsDefault.default)();
    buildAddCommandRequest(templateID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/command`,
            method: "post",
            data,
            cancelToken
        };
    }
    async addCommand(templateID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildAddCommandRequest(templateID, body, cancelToken));
        return data;
    }
    buildEditCommandRequest(templateID, commandID, data, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/command/${commandID}`,
            method: "put",
            data,
            cancelToken
        };
    }
    async editCommand(templateID, commandID, body, cancelToken) {
        const { data = {} } = await this.api.request(this.buildEditCommandRequest(templateID, commandID, body, cancelToken));
        return data;
    }
    buildDeleteCommandRequest(templateID, commandID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/command/${commandID}`,
            method: "delete",
            cancelToken
        };
    }
    async deleteCommand(templateID, commandID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildDeleteCommandRequest(templateID, commandID, cancelToken));
        return data;
    }
    buildGetCommandRequest(templateID, commandID, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/v2/template/${templateID}/command/${commandID}`,
            method: "get",
            cancelToken
        };
    }
    async getCommand(templateID, commandID, cancelToken) {
        const { data = {} } = await this.api.request(this.buildGetCommandRequest(templateID, commandID, cancelToken));
        return data;
    }
    buildCommandHistoryRequest(gatewayID, params, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${gatewayID}/job/history`,
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchPaginatedCommandHistory(gatewayID, params, cancelToken) {
        const { data } = await this.api.request(this.buildCommandHistoryRequest(gatewayID, params, cancelToken));
        return data;
    }
}
exports.default = CommandService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3bfnB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetCommandHistoryDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _commandHistoryTable = require("./CommandHistoryTable");
var _commandHistoryTableDefault = parcelHelpers.interopDefault(_commandHistoryTable);
var _jobMobileCard = require("./JobMobileCard");
var _jobMobileCardDefault = parcelHelpers.interopDefault(_jobMobileCard);
var _mobileFiltersModal = require("../MobileFiltersModal");
var _mobileFiltersModalDefault = parcelHelpers.interopDefault(_mobileFiltersModal);
var _noDataIndication = require("../NoDataIndication");
var _paginationFooter = require("../PaginationFooter");
var _paginationFooterDefault = parcelHelpers.interopDefault(_paginationFooter);
var _zIndex = require("../../Styles/Z-INDEX");
function AssetCommandHistoryDisplay(props) {
    const { data, dataLoading, page, pages, handlePageChange, showMobileFilters, toggleMobileFilters, jobName, handleSearch, remote, error } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "d-lg-none btn btn-link p-0 position-absolute shadow-none text-decoration-none",
                onClick: ()=>toggleMobileFilters(!showMobileFilters),
                style: {
                    right: "0.5rem",
                    top: "-5.7rem",
                    zIndex: (0, _zIndex.STICKY_OVERRIDE)
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    className: "text-brand-primary",
                    icon: (0, _freeSolidSvgIcons.faSlidersH),
                    size: "lg"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2157105280 position-absolute overflow-auto container-fluid h-100 bg-white rounded-lg mt-3 mt-lg-0 d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2157105280 d-none d-md-flex row flex-grow-1 overflow-auto command-history-table-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandHistoryTableDefault.default), {
                            ...props
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2157105280 d-md-none row no-gutters flex-grow-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2157105280 col-12 d-flex align-items-center py-3 sticky-top bg-white",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "jsx-2157105280 font-weight-bolder mr-3",
                                        children: "Command and Control Log"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faWifi),
                                        className: "text-brand-primary"
                                    })
                                ]
                            }),
                            (()=>{
                                switch(true){
                                    case dataLoading:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-2157105280 h-75 w-100 d-flex align-items-center justify-content-center",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {})
                                        });
                                    case !remote:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "jsx-2157105280 h-75 w-100 d-flex flex-column align-items-center justify-content-center",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faWifi),
                                                    className: "text-brand-primary mb-3",
                                                    size: "5x"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "jsx-2157105280 text-brand-primary",
                                                    children: "This asset is not remote enabled"
                                                })
                                            ]
                                        });
                                    case !data.length:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "jsx-2157105280 h-75 w-100 d-flex flex-column align-items-center justify-content-center",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faWifi),
                                                    className: "text-brand-primary mb-3",
                                                    size: "5x"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                    className: "jsx-2157105280 text-brand-primary",
                                                    children: "No commands have been fired on this asset!"
                                                })
                                            ]
                                        });
                                    default:
                                        return data.map((job)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jobMobileCardDefault.default), {
                                                job: job
                                            }, job._id));
                                }
                            })()
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2157105280 row justify-content-end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-2157105280 col-12 text-danger three-quarter-text text-right",
                            children: error
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2157105280 py-1 py-lg-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationFooterDefault.default), {
                            handlePageChange: handlePageChange,
                            page: page,
                            pages: pages,
                            rowsLength: data?.length,
                            rowsLoading: dataLoading
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileFiltersModalDefault.default), {
                        isOpen: showMobileFilters,
                        toggleModal: toggleMobileFilters,
                        searchTerm: jobName,
                        handleSearch: handleSearch,
                        resource: "job"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                        id: "2157105280",
                        children: "@media (min-width:992px){.command-history-table-container.jsx-2157105280{max-height:calc(100% - 3rem);}}"
                    })
                ]
            })
        ]
    });
}
AssetCommandHistoryDisplay.propTypes = {
    tab: (0, _propTypesDefault.default).string,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    page: (0, _propTypesDefault.default).number,
    pages: (0, _propTypesDefault.default).number,
    handlePageChange: (0, _propTypesDefault.default).func,
    error: (0, _propTypesDefault.default).string,
    dataLoading: (0, _propTypesDefault.default).bool,
    remote: (0, _propTypesDefault.default).bool,
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "Date"
        ]),
        order: (0, _propTypesDefault.default).oneOf([
            "asc",
            "desc"
        ])
    }),
    handleSortClick: (0, _propTypesDefault.default).func,
    toggleMobileFilters: (0, _propTypesDefault.default).func,
    showMobileFilters: (0, _propTypesDefault.default).bool,
    jobName: (0, _propTypesDefault.default).string,
    handleSearch: (0, _propTypesDefault.default).func
};
AssetCommandHistoryDisplay.defaultProps = {
    data: [],
    sort: {}
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./CommandHistoryTable":"li4UP","./JobMobileCard":"5WmNB","../MobileFiltersModal":"4GPPq","../NoDataIndication":"clGpp","../PaginationFooter":"kV15Q","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"li4UP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _commandHistoryBody = require("./CommandHistoryBody");
var _commandHistoryBodyDefault = parcelHelpers.interopDefault(_commandHistoryBody);
var _commandHistoryHeader = require("./CommandHistoryHeader");
var _commandHistoryHeaderDefault = parcelHelpers.interopDefault(_commandHistoryHeader);
var _noDataIndication = require("../NoDataIndication");
function CommandHistoryTable(props) {
    const { data, dataLoading, sort, handleSortClick, status, handleStatusSelect, jobName, handleSearch, remote } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `d-none d-md-block w-100 px-lg-4 ${!dataLoading && data.length ? "h-100" : ""}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    className: "jsx-3774372879 table",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            className: "jsx-3774372879",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandHistoryHeaderDefault.default), {
                                sort: sort,
                                handleSortClick: handleSortClick,
                                status: status,
                                handleStatusSelect: handleStatusSelect,
                                jobName: jobName,
                                handleSearch: handleSearch
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            className: "jsx-3774372879 " + ((dataLoading || !data.length ? "d-none" : "") || ""),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandHistoryBodyDefault.default), {
                                data: data
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                            id: "3774372879",
                            children: ".table.jsx-3774372879{table-layout:fixed;}"
                        })
                    ]
                })
            }),
            (()=>{
                switch(true){
                    case dataLoading:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "h-75 w-100 d-flex align-items-center justify-content-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.Loading), {})
                        });
                    case !remote:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "h-75 w-100 d-flex flex-column align-items-center justify-content-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faWifi),
                                    className: "text-brand-primary mb-3",
                                    size: "5x"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-brand-primary",
                                    children: "This asset is not remote enabled"
                                })
                            ]
                        });
                    case !data.length:
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "h-75 w-100 d-flex flex-column align-items-center justify-content-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faWifi),
                                    className: "text-brand-primary mb-3",
                                    size: "5x"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                    className: "text-brand-primary",
                                    children: "No commands have been fired on this asset!"
                                })
                            ]
                        });
                    default:
                        return null;
                }
            })()
        ]
    });
}
CommandHistoryTable.propTypes = {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        commandId: (0, _propTypesDefault.default).string,
        createdAt: (0, _propTypesDefault.default).string,
        email: (0, _propTypesDefault.default).string,
        gatewayId: (0, _propTypesDefault.default).string,
        jobCommand: (0, _propTypesDefault.default).string,
        jobMessage: (0, _propTypesDefault.default).string,
        jobName: (0, _propTypesDefault.default).string,
        status: (0, _propTypesDefault.default).oneOf([
            "COMPLETED",
            "FAILED",
            "MESSAGE_SENT",
            "RUNNING",
            "PENDING"
        ]),
        templateId: (0, _propTypesDefault.default).string,
        updatedAt: (0, _propTypesDefault.default).string
    })),
    dataLoading: (0, _propTypesDefault.default).bool,
    sort: (0, _propTypesDefault.default).object,
    handleSortClick: (0, _propTypesDefault.default).func,
    remote: (0, _propTypesDefault.default).bool,
    status: (0, _propTypesDefault.default).oneOf([
        "",
        "COMPLETED",
        "FAILED",
        "MESSAGE_SENT",
        "RUNNING",
        "PENDING"
    ]),
    handleStatusSelect: (0, _propTypesDefault.default).func,
    jobName: (0, _propTypesDefault.default).string,
    handleSearch: (0, _propTypesDefault.default).func
};
CommandHistoryTable.defaultProps = {
    data: [],
    dataLoading: true,
    sort: {}
};
exports.default = /*#__PURE__*/ (0, _react.memo)(CommandHistoryTable);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./CommandHistoryBody":"7ewev","./CommandHistoryHeader":"4Nw13","../NoDataIndication":"clGpp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ewev":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const JOB_STATUS_CLASS_MAP = new Map([
    [
        "COMPLETED",
        {
            text: "alert-confirmation",
            background: "rgba(116, 209, 125, 0.24)"
        }
    ],
    [
        "FAILED",
        {
            text: "active-dm",
            background: "rgba(222, 71, 58, 0.24)"
        }
    ],
    [
        "MESSAGE_SENT",
        {
            text: "in-progress-yellow",
            background: "rgba(196, 146, 33, 0.24)"
        }
    ],
    [
        "RUNNING",
        {
            text: "in-progress-yellow"
        }
    ],
    [
        "PENDING",
        {
            text: "text-dark"
        }
    ]
]);
const STATUS_DISPLAY_MAP = new Map([
    [
        "COMPLETED",
        "Complete"
    ],
    [
        "FAILED",
        "Failed"
    ],
    [
        "MESSAGE_SENT",
        "Message Sent"
    ],
    [
        "RUNNING",
        "Running"
    ],
    [
        "PENDING",
        "Pending"
    ]
]);
function CommandHistoryBody({ data }) {
    return data.map((job)=>{
        const { jobName, jobMessage, _id, updatedAt, email, status } = job;
        const { text, background } = JOB_STATUS_CLASS_MAP.get(status) || {};
        const pillHasBackground = [
            "COMPLETED",
            "FAILED",
            "MESSAGE_SENT"
        ].includes(status);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
            className: (0, _styleDefault.default).dynamic([
                [
                    "1250002814",
                    [
                        pillHasBackground ? background : ""
                    ]
                ]
            ]),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "1250002814",
                            [
                                pillHasBackground ? background : ""
                            ]
                        ]
                    ]) + " " + "align-middle",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1250002814",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + `command-status-pill rounded-pill text-${text} ${pillHasBackground ? "" : `border border-${text} bg-transparent`} three-quarter-text d-inline py-1 px-3`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faCircle),
                                className: "mr-2",
                                size: "xs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1250002814",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]),
                                children: STATUS_DISPLAY_MAP.get(status)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "1250002814",
                            [
                                pillHasBackground ? background : ""
                            ]
                        ]
                    ]) + " " + "align-middle three-quarter-text",
                    children: jobName
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "1250002814",
                            [
                                pillHasBackground ? background : ""
                            ]
                        ]
                    ]) + " " + "three-quarter-text align-middle",
                    children: (()=>{
                        switch(status){
                            case "PENDING":
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faArrowCircleRight),
                                    className: "text-text-dark",
                                    size: "lg"
                                });
                            case "RUNNING":
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                    className: "text-in-progress-yellow",
                                    size: "lg"
                                });
                            case "MESSAGE_SENT":
                            case "COMPLETED":
                            case "FAILED":
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "1250002814",
                                            [
                                                pillHasBackground ? background : ""
                                            ]
                                        ]
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: (0, _styleDefault.default).dynamic([
                                                [
                                                    "1250002814",
                                                    [
                                                        pillHasBackground ? background : ""
                                                    ]
                                                ]
                                            ]) + " " + `font-weight-bolder ${status === "COMPLETED" ? "text-text-dark" : `text-${text}`}`,
                                            children: `${(0, _momentDefault.default)(updatedAt).toNow(true)} ago`
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: (0, _styleDefault.default).dynamic([
                                                [
                                                    "1250002814",
                                                    [
                                                        pillHasBackground ? background : ""
                                                    ]
                                                ]
                                            ]) + " " + `ml-2 ${status === "COMPLETED" ? "text-text-light-gray" : `text-${text}`}`,
                                            children: (0, _momentDefault.default)(updatedAt).format("MMM Do - h:mma")
                                        })
                                    ]
                                });
                            default:
                                return null;
                        }
                    })()
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "1250002814",
                            [
                                pillHasBackground ? background : ""
                            ]
                        ]
                    ]) + " " + "align-middle three-quarter-text",
                    children: email
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "1250002814",
                            [
                                pillHasBackground ? background : ""
                            ]
                        ]
                    ]) + " " + "align-middle three-quarter-text",
                    children: (()=>{
                        switch(status){
                            case "COMPLETED":
                                return jobMessage || "success";
                            case "FAILED":
                                return jobMessage || "failed";
                            case "PENDING":
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faArrowCircleRight),
                                    className: "text-text-dark",
                                    size: "lg"
                                });
                            case "MESSAGE_SENT":
                                return jobMessage || "message sent";
                            case "RUNNING":
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                    className: "text-in-progress-yellow",
                                    size: "lg"
                                });
                            default:
                                return null;
                        }
                    })()
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                    id: "1250002814",
                    dynamic: [
                        pillHasBackground ? background : ""
                    ],
                    children: `.command-status-pill.__jsx-style-dynamic-selector{background-color:${pillHasBackground ? background : ""};}`
                })
            ]
        }, _id);
    });
}
CommandHistoryBody.propTypes = {
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        commandId: (0, _propTypesDefault.default).string,
        createdAt: (0, _propTypesDefault.default).string,
        email: (0, _propTypesDefault.default).string,
        gatewayId: (0, _propTypesDefault.default).string,
        jobCommand: (0, _propTypesDefault.default).string,
        jobMessage: (0, _propTypesDefault.default).string,
        jobName: (0, _propTypesDefault.default).string,
        status: (0, _propTypesDefault.default).oneOf([
            "COMPLETED",
            "FAILED",
            "MESSAGE_SENT",
            "RUNNING",
            "PENDING"
        ]),
        templateId: (0, _propTypesDefault.default).string,
        updatedAt: (0, _propTypesDefault.default).string
    }))
};
CommandHistoryBody.defaultProps = {
    data: []
};
exports.default = /*#__PURE__*/ (0, _react.memo)(CommandHistoryBody);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Nw13":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _commandStatusSelectDropdown = require("./CommandStatusSelectDropdown");
var _commandStatusSelectDropdownDefault = parcelHelpers.interopDefault(_commandStatusSelectDropdown);
function CommandHistoryHeader({ sort, handleSortClick, status, handleStatusSelect, jobName, handleSearch }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
        className: "jsx-306476521",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "jsx-306476521 col-status align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandStatusSelectDropdownDefault.default), {
                    selectedStatus: status,
                    handleStatusSelect: handleStatusSelect
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "jsx-306476521 col-main align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-306476521 input-group w-100",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-306476521 input-group-prepend",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-306476521 input-group-text text-brand-primary bg-transparent border-0 px-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faWifi),
                                    size: "sm"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            placeholder: "Command Name",
                            "aria-label": "commandNameSearch",
                            value: jobName,
                            onChange: handleSearch,
                            className: "jsx-306476521 form-control bg-transparent border-0 three-quarter-text"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-306476521 input-group-append",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-306476521 input-group-text bg-transparent border-0 pr-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    className: "text-text-light-gray",
                                    icon: (0, _freeSolidSvgIcons.faSearch),
                                    size: "sm"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "jsx-306476521 col-main align-middle pb-0 col-date text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    onClick: ()=>handleSortClick(),
                    className: "jsx-306476521 btn btn-link text-decoration-none three-quarter-text text-text-light-gray d-flex align-items-center justify-content-between p-0 w-100",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "jsx-306476521",
                            children: sort.by
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-306476521",
                            children: [
                                [
                                    (0, _freeSolidSvgIcons.faLongArrowAltUp),
                                    "asc"
                                ],
                                [
                                    (0, _freeSolidSvgIcons.faLongArrowAltDown),
                                    "desc"
                                ]
                            ].map(([icon, sortDir])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: icon,
                                    className: sort.direction === sortDir ? "text-text-light-gray font-weight-normal" : "text-icon-link-gray font-weight-light",
                                    style: {
                                        margin: "0 0.1rem"
                                    }
                                }, sortDir))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "jsx-306476521 col-main align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0",
                children: "Fired By"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                scope: "col",
                className: "jsx-306476521 col-main align-middle pb-0 text-text-light-gray font-weight-normal three-quarter-text sticky-top bg-white border-0",
                children: "Response"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "306476521",
                children: ".col-status.jsx-306476521{width:16%;}.col-main.jsx-306476521{width:21%;}"
            })
        ]
    });
}
CommandHistoryHeader.propTypes = {
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "Date"
        ]),
        direction: (0, _propTypesDefault.default).oneOf([
            "asc",
            "desc"
        ])
    }),
    handleSortClick: (0, _propTypesDefault.default).func,
    status: (0, _propTypesDefault.default).oneOf([
        "",
        "COMPLETED",
        "FAILED",
        "MESSAGE_SENT",
        "RUNNING",
        "PENDING"
    ]),
    handleStatusSelect: (0, _propTypesDefault.default).func,
    jobName: (0, _propTypesDefault.default).string,
    handleSearch: (0, _propTypesDefault.default).func
};
CommandHistoryHeader.defaultProps = {
    sort: {}
};
exports.default = /*#__PURE__*/ (0, _react.memo)(CommandHistoryHeader);

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./CommandStatusSelectDropdown":"hYoTg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYoTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CommandStatusSelectDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _bootstrapBundleMinJs = require("bootstrap/dist/js/bootstrap.bundle.min.js");
const STATUS_OPTIONS = [
    {
        display: "Complete",
        status: "COMPLETED",
        textClass: "alert-confirmation"
    },
    {
        display: "Failed",
        status: "FAILED",
        textClass: "active-dm"
    },
    {
        display: "Message Sent",
        status: "MESSAGE_SENT",
        textClass: "warning-yellow"
    },
    {
        display: "Running",
        status: "RUNNING",
        textClass: "warning-yellow"
    },
    {
        display: "Pending",
        status: "PENDING",
        textClass: "text-dark"
    }
];
const DISPLAY_MAP = new Map([
    [
        "COMPLETED",
        "Complete"
    ],
    [
        "FAILED",
        "Failed"
    ],
    [
        "MESSAGE_SENT",
        "Message Sent"
    ],
    [
        "RUNNING",
        "Running"
    ],
    [
        "PENDING",
        "Pending"
    ]
]);
function CommandStatusSelectDropdown({ selectedStatus, handleStatusSelect, mobileView }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-4175979735 " + `dropdown ${mobileView ? "border rounded" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                id: "statusSelectMenuButton",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                className: "jsx-4175979735 " + `btn btn-link dropdown-toggle text-decoration-none text-text-light-gray d-flex align-items-center justify-content-between ${mobileView ? "p-1 w-100" : "p-0"}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "jsx-4175979735 text-capitalize three-quarter-text",
                    children: DISPLAY_MAP.get(selectedStatus) || "Status"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                "aria-labelledby": "statusSelectMenuButton",
                style: {
                    minWidth: "unset"
                },
                className: "jsx-4175979735 " + `dropdown-menu rounded-lg ${mobileView ? "w-100" : ""}`,
                children: [
                    STATUS_OPTIONS.filter(({ status })=>status !== selectedStatus).map(({ status, display, textClass })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>handleStatusSelect(status, mobileView),
                            className: "jsx-4175979735 " + `dropdown-item px-3 text-decoration-none three-quarter-text text-${textClass}`,
                            children: display
                        }, status)),
                    selectedStatus ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>handleStatusSelect("", mobileView),
                        className: "jsx-4175979735 " + `dropdown-item px-3 pt-3 text-decoration-none three-quarter-text text-dark`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faTimes),
                                size: "xs",
                                className: "mr-2"
                            }),
                            "View All"
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "4175979735",
                children: ".dropdown-toggle.jsx-4175979735::after{margin-left:4rem;}.dropdown-item.jsx-4175979735{outline:none;}.dropdown-item.jsx-4175979735:hover{background:transparent;}"
            })
        ]
    });
}
CommandStatusSelectDropdown.propTypes = {
    selectedStatus: (0, _propTypesDefault.default).oneOf(STATUS_OPTIONS.map(({ status })=>status).concat("")),
    handleStatusSelect: (0, _propTypesDefault.default).func,
    mobileView: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","bootstrap/dist/js/bootstrap.bundle.min.js":"l1snf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l1snf":[function(require,module,exports) {
/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var global = arguments[3];
!function(t, e) {
    e(exports, require("4967ad770d25ef1c"));
}(this, function(t, e) {
    "use strict";
    function n(t) {
        return t && "object" == typeof t && "default" in t ? t : {
            default: t
        };
    }
    var i = n(e);
    function o(t, e) {
        for(var n = 0; n < e.length; n++){
            var i = e[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
        }
    }
    function r(t, e, n) {
        return e && o(t.prototype, e), n && o(t, n), Object.defineProperty(t, "prototype", {
            writable: !1
        }), t;
    }
    function a() {
        return a = Object.assign ? Object.assign.bind() : function(t) {
            for(var e = 1; e < arguments.length; e++){
                var n = arguments[e];
                for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
            }
            return t;
        }, a.apply(this, arguments);
    }
    function s(t, e) {
        return s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t;
        }, s(t, e);
    }
    var l = "transitionend";
    var u = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function(t) {
            do t += ~~(1e6 * Math.random());
            while (document.getElementById(t));
            return t;
        },
        getSelectorFromElement: function(t) {
            var e = t.getAttribute("data-target");
            if (!e || "#" === e) {
                var n = t.getAttribute("href");
                e = n && "#" !== n ? n.trim() : "";
            }
            try {
                return document.querySelector(e) ? e : null;
            } catch (t) {
                return null;
            }
        },
        getTransitionDurationFromElement: function(t) {
            if (!t) return 0;
            var e = i.default(t).css("transition-duration"), n = i.default(t).css("transition-delay"), o = parseFloat(e), r = parseFloat(n);
            return o || r ? (e = e.split(",")[0], n = n.split(",")[0], 1e3 * (parseFloat(e) + parseFloat(n))) : 0;
        },
        reflow: function(t) {
            return t.offsetHeight;
        },
        triggerTransitionEnd: function(t) {
            i.default(t).trigger(l);
        },
        supportsTransitionEnd: function() {
            return Boolean(l);
        },
        isElement: function(t) {
            return (t[0] || t).nodeType;
        },
        typeCheckConfig: function(t, e, n) {
            for(var i in n)if (Object.prototype.hasOwnProperty.call(n, i)) {
                var o = n[i], r = e[i], a = r && u.isElement(r) ? "element" : null === (s = r) || "undefined" == typeof s ? "" + s : ({}).toString.call(s).match(/\s([a-z]+)/i)[1].toLowerCase();
                if (!new RegExp(o).test(a)) throw new Error(t.toUpperCase() + ': Option "' + i + '" provided type "' + a + '" but expected type "' + o + '".');
            }
            var s;
        },
        findShadowRoot: function(t) {
            if (!document.documentElement.attachShadow) return null;
            if ("function" == typeof t.getRootNode) {
                var e = t.getRootNode();
                return e instanceof ShadowRoot ? e : null;
            }
            return t instanceof ShadowRoot ? t : t.parentNode ? u.findShadowRoot(t.parentNode) : null;
        },
        jQueryDetection: function() {
            if ("undefined" == typeof i.default) throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var t = i.default.fn.jquery.split(" ")[0].split(".");
            if (t[0] < 2 && t[1] < 9 || 1 === t[0] && 9 === t[1] && t[2] < 1 || t[0] >= 4) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
    };
    u.jQueryDetection(), i.default.fn.emulateTransitionEnd = function(t) {
        var e = this, n = !1;
        return i.default(this).one(u.TRANSITION_END, function() {
            n = !0;
        }), setTimeout(function() {
            n || u.triggerTransitionEnd(e);
        }, t), this;
    }, i.default.event.special[u.TRANSITION_END] = {
        bindType: l,
        delegateType: l,
        handle: function(t) {
            if (i.default(t.target).is(this)) return t.handleObj.handler.apply(this, arguments);
        }
    };
    var f = "bs.alert", d = i.default.fn.alert, c = function() {
        function t(t) {
            this._element = t;
        }
        var e = t.prototype;
        return e.close = function(t) {
            var e = this._element;
            t && (e = this._getRootElement(t)), this._triggerCloseEvent(e).isDefaultPrevented() || this._removeElement(e);
        }, e.dispose = function() {
            i.default.removeData(this._element, f), this._element = null;
        }, e._getRootElement = function(t) {
            var e = u.getSelectorFromElement(t), n = !1;
            return e && (n = document.querySelector(e)), n || (n = i.default(t).closest(".alert")[0]), n;
        }, e._triggerCloseEvent = function(t) {
            var e = i.default.Event("close.bs.alert");
            return i.default(t).trigger(e), e;
        }, e._removeElement = function(t) {
            var e = this;
            if (i.default(t).removeClass("show"), i.default(t).hasClass("fade")) {
                var n = u.getTransitionDurationFromElement(t);
                i.default(t).one(u.TRANSITION_END, function(n) {
                    return e._destroyElement(t, n);
                }).emulateTransitionEnd(n);
            } else this._destroyElement(t);
        }, e._destroyElement = function(t) {
            i.default(t).detach().trigger("closed.bs.alert").remove();
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(f);
                o || (o = new t(this), n.data(f, o)), "close" === e && o[e](this);
            });
        }, t._handleDismiss = function(t) {
            return function(e) {
                e && e.preventDefault(), t.close(this);
            };
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.alert.data-api", '[data-dismiss="alert"]', c._handleDismiss(new c)), i.default.fn.alert = c._jQueryInterface, i.default.fn.alert.Constructor = c, i.default.fn.alert.noConflict = function() {
        return i.default.fn.alert = d, c._jQueryInterface;
    };
    var h = "bs.button", p = i.default.fn.button, m = "active", g = '[data-toggle^="button"]', _ = 'input:not([type="hidden"])', v = ".btn", b = function() {
        function t(t) {
            this._element = t, this.shouldAvoidTriggerChange = !1;
        }
        var e = t.prototype;
        return e.toggle = function() {
            var t = !0, e = !0, n = i.default(this._element).closest('[data-toggle="buttons"]')[0];
            if (n) {
                var o = this._element.querySelector(_);
                if (o) {
                    if ("radio" === o.type) {
                        if (o.checked && this._element.classList.contains(m)) t = !1;
                        else {
                            var r = n.querySelector(".active");
                            r && i.default(r).removeClass(m);
                        }
                    }
                    t && ("checkbox" !== o.type && "radio" !== o.type || (o.checked = !this._element.classList.contains(m)), this.shouldAvoidTriggerChange || i.default(o).trigger("change")), o.focus(), e = !1;
                }
            }
            this._element.hasAttribute("disabled") || this._element.classList.contains("disabled") || (e && this._element.setAttribute("aria-pressed", !this._element.classList.contains(m)), t && i.default(this._element).toggleClass(m));
        }, e.dispose = function() {
            i.default.removeData(this._element, h), this._element = null;
        }, t._jQueryInterface = function(e, n) {
            return this.each(function() {
                var o = i.default(this), r = o.data(h);
                r || (r = new t(this), o.data(h, r)), r.shouldAvoidTriggerChange = n, "toggle" === e && r[e]();
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.button.data-api", g, function(t) {
        var e = t.target, n = e;
        if (i.default(e).hasClass("btn") || (e = i.default(e).closest(v)[0]), !e || e.hasAttribute("disabled") || e.classList.contains("disabled")) t.preventDefault();
        else {
            var o = e.querySelector(_);
            if (o && (o.hasAttribute("disabled") || o.classList.contains("disabled"))) return void t.preventDefault();
            "INPUT" !== n.tagName && "LABEL" === e.tagName || b._jQueryInterface.call(i.default(e), "toggle", "INPUT" === n.tagName);
        }
    }).on("focus.bs.button.data-api blur.bs.button.data-api", g, function(t) {
        var e = i.default(t.target).closest(v)[0];
        i.default(e).toggleClass("focus", /^focus(in)?$/.test(t.type));
    }), i.default(window).on("load.bs.button.data-api", function() {
        for(var t = [].slice.call(document.querySelectorAll('[data-toggle="buttons"] .btn')), e = 0, n = t.length; e < n; e++){
            var i = t[e], o = i.querySelector(_);
            o.checked || o.hasAttribute("checked") ? i.classList.add(m) : i.classList.remove(m);
        }
        for(var r = 0, a = (t = [].slice.call(document.querySelectorAll('[data-toggle="button"]'))).length; r < a; r++){
            var s = t[r];
            "true" === s.getAttribute("aria-pressed") ? s.classList.add(m) : s.classList.remove(m);
        }
    }), i.default.fn.button = b._jQueryInterface, i.default.fn.button.Constructor = b, i.default.fn.button.noConflict = function() {
        return i.default.fn.button = p, b._jQueryInterface;
    };
    var y = "carousel", E = "bs.carousel", w = i.default.fn[y], T = "active", C = "next", S = "prev", N = "slid.bs.carousel", D = ".active.carousel-item", A = {
        interval: 5e3,
        keyboard: !0,
        slide: !1,
        pause: "hover",
        wrap: !0,
        touch: !0
    }, k = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean"
    }, I = {
        TOUCH: "touch",
        PEN: "pen"
    }, O = function() {
        function t(t, e) {
            this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, this._isSliding = !1, this.touchTimeout = null, this.touchStartX = 0, this.touchDeltaX = 0, this._config = this._getConfig(e), this._element = t, this._indicatorsElement = this._element.querySelector(".carousel-indicators"), this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0, this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent), this._addEventListeners();
        }
        var e = t.prototype;
        return e.next = function() {
            this._isSliding || this._slide(C);
        }, e.nextWhenVisible = function() {
            var t = i.default(this._element);
            !document.hidden && t.is(":visible") && "hidden" !== t.css("visibility") && this.next();
        }, e.prev = function() {
            this._isSliding || this._slide(S);
        }, e.pause = function(t) {
            t || (this._isPaused = !0), this._element.querySelector(".carousel-item-next, .carousel-item-prev") && (u.triggerTransitionEnd(this._element), this.cycle(!0)), clearInterval(this._interval), this._interval = null;
        }, e.cycle = function(t) {
            t || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), this._config.interval && !this._isPaused && (this._updateInterval(), this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval));
        }, e.to = function(t) {
            var e = this;
            this._activeElement = this._element.querySelector(D);
            var n = this._getItemIndex(this._activeElement);
            if (!(t > this._items.length - 1 || t < 0)) {
                if (this._isSliding) i.default(this._element).one(N, function() {
                    return e.to(t);
                });
                else {
                    if (n === t) return this.pause(), void this.cycle();
                    var o = t > n ? C : S;
                    this._slide(o, this._items[t]);
                }
            }
        }, e.dispose = function() {
            i.default(this._element).off(".bs.carousel"), i.default.removeData(this._element, E), this._items = null, this._config = null, this._element = null, this._interval = null, this._isPaused = null, this._isSliding = null, this._activeElement = null, this._indicatorsElement = null;
        }, e._getConfig = function(t) {
            return t = a({}, A, t), u.typeCheckConfig(y, t, k), t;
        }, e._handleSwipe = function() {
            var t = Math.abs(this.touchDeltaX);
            if (!(t <= 40)) {
                var e = t / this.touchDeltaX;
                this.touchDeltaX = 0, e > 0 && this.prev(), e < 0 && this.next();
            }
        }, e._addEventListeners = function() {
            var t = this;
            this._config.keyboard && i.default(this._element).on("keydown.bs.carousel", function(e) {
                return t._keydown(e);
            }), "hover" === this._config.pause && i.default(this._element).on("mouseenter.bs.carousel", function(e) {
                return t.pause(e);
            }).on("mouseleave.bs.carousel", function(e) {
                return t.cycle(e);
            }), this._config.touch && this._addTouchEventListeners();
        }, e._addTouchEventListeners = function() {
            var t = this;
            if (this._touchSupported) {
                var e = function(e) {
                    t._pointerEvent && I[e.originalEvent.pointerType.toUpperCase()] ? t.touchStartX = e.originalEvent.clientX : t._pointerEvent || (t.touchStartX = e.originalEvent.touches[0].clientX);
                }, n = function(e) {
                    t._pointerEvent && I[e.originalEvent.pointerType.toUpperCase()] && (t.touchDeltaX = e.originalEvent.clientX - t.touchStartX), t._handleSwipe(), "hover" === t._config.pause && (t.pause(), t.touchTimeout && clearTimeout(t.touchTimeout), t.touchTimeout = setTimeout(function(e) {
                        return t.cycle(e);
                    }, 500 + t._config.interval));
                };
                i.default(this._element.querySelectorAll(".carousel-item img")).on("dragstart.bs.carousel", function(t) {
                    return t.preventDefault();
                }), this._pointerEvent ? (i.default(this._element).on("pointerdown.bs.carousel", function(t) {
                    return e(t);
                }), i.default(this._element).on("pointerup.bs.carousel", function(t) {
                    return n(t);
                }), this._element.classList.add("pointer-event")) : (i.default(this._element).on("touchstart.bs.carousel", function(t) {
                    return e(t);
                }), i.default(this._element).on("touchmove.bs.carousel", function(e) {
                    return function(e) {
                        t.touchDeltaX = e.originalEvent.touches && e.originalEvent.touches.length > 1 ? 0 : e.originalEvent.touches[0].clientX - t.touchStartX;
                    }(e);
                }), i.default(this._element).on("touchend.bs.carousel", function(t) {
                    return n(t);
                }));
            }
        }, e._keydown = function(t) {
            if (!/input|textarea/i.test(t.target.tagName)) switch(t.which){
                case 37:
                    t.preventDefault(), this.prev();
                    break;
                case 39:
                    t.preventDefault(), this.next();
            }
        }, e._getItemIndex = function(t) {
            return this._items = t && t.parentNode ? [].slice.call(t.parentNode.querySelectorAll(".carousel-item")) : [], this._items.indexOf(t);
        }, e._getItemByDirection = function(t, e) {
            var n = t === C, i = t === S, o = this._getItemIndex(e), r = this._items.length - 1;
            if ((i && 0 === o || n && o === r) && !this._config.wrap) return e;
            var a = (o + (t === S ? -1 : 1)) % this._items.length;
            return -1 === a ? this._items[this._items.length - 1] : this._items[a];
        }, e._triggerSlideEvent = function(t, e) {
            var n = this._getItemIndex(t), o = this._getItemIndex(this._element.querySelector(D)), r = i.default.Event("slide.bs.carousel", {
                relatedTarget: t,
                direction: e,
                from: o,
                to: n
            });
            return i.default(this._element).trigger(r), r;
        }, e._setActiveIndicatorElement = function(t) {
            if (this._indicatorsElement) {
                var e = [].slice.call(this._indicatorsElement.querySelectorAll(".active"));
                i.default(e).removeClass(T);
                var n = this._indicatorsElement.children[this._getItemIndex(t)];
                n && i.default(n).addClass(T);
            }
        }, e._updateInterval = function() {
            var t = this._activeElement || this._element.querySelector(D);
            if (t) {
                var e = parseInt(t.getAttribute("data-interval"), 10);
                e ? (this._config.defaultInterval = this._config.defaultInterval || this._config.interval, this._config.interval = e) : this._config.interval = this._config.defaultInterval || this._config.interval;
            }
        }, e._slide = function(t, e) {
            var n, o, r, a = this, s = this._element.querySelector(D), l = this._getItemIndex(s), f = e || s && this._getItemByDirection(t, s), d = this._getItemIndex(f), c = Boolean(this._interval);
            if (t === C ? (n = "carousel-item-left", o = "carousel-item-next", r = "left") : (n = "carousel-item-right", o = "carousel-item-prev", r = "right"), f && i.default(f).hasClass(T)) this._isSliding = !1;
            else if (!this._triggerSlideEvent(f, r).isDefaultPrevented() && s && f) {
                this._isSliding = !0, c && this.pause(), this._setActiveIndicatorElement(f), this._activeElement = f;
                var h = i.default.Event(N, {
                    relatedTarget: f,
                    direction: r,
                    from: l,
                    to: d
                });
                if (i.default(this._element).hasClass("slide")) {
                    i.default(f).addClass(o), u.reflow(f), i.default(s).addClass(n), i.default(f).addClass(n);
                    var p = u.getTransitionDurationFromElement(s);
                    i.default(s).one(u.TRANSITION_END, function() {
                        i.default(f).removeClass(n + " " + o).addClass(T), i.default(s).removeClass("active " + o + " " + n), a._isSliding = !1, setTimeout(function() {
                            return i.default(a._element).trigger(h);
                        }, 0);
                    }).emulateTransitionEnd(p);
                } else i.default(s).removeClass(T), i.default(f).addClass(T), this._isSliding = !1, i.default(this._element).trigger(h);
                c && this.cycle();
            }
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this).data(E), o = a({}, A, i.default(this).data());
                "object" == typeof e && (o = a({}, o, e));
                var r = "string" == typeof e ? e : o.slide;
                if (n || (n = new t(this, o), i.default(this).data(E, n)), "number" == typeof e) n.to(e);
                else if ("string" == typeof r) {
                    if ("undefined" == typeof n[r]) throw new TypeError('No method named "' + r + '"');
                    n[r]();
                } else o.interval && o.ride && (n.pause(), n.cycle());
            });
        }, t._dataApiClickHandler = function(e) {
            var n = u.getSelectorFromElement(this);
            if (n) {
                var o = i.default(n)[0];
                if (o && i.default(o).hasClass("carousel")) {
                    var r = a({}, i.default(o).data(), i.default(this).data()), s = this.getAttribute("data-slide-to");
                    s && (r.interval = !1), t._jQueryInterface.call(i.default(o), r), s && i.default(o).data(E).to(s), e.preventDefault();
                }
            }
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return A;
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.carousel.data-api", "[data-slide], [data-slide-to]", O._dataApiClickHandler), i.default(window).on("load.bs.carousel.data-api", function() {
        for(var t = [].slice.call(document.querySelectorAll('[data-ride="carousel"]')), e = 0, n = t.length; e < n; e++){
            var o = i.default(t[e]);
            O._jQueryInterface.call(o, o.data());
        }
    }), i.default.fn[y] = O._jQueryInterface, i.default.fn[y].Constructor = O, i.default.fn[y].noConflict = function() {
        return i.default.fn[y] = w, O._jQueryInterface;
    };
    var x = "collapse", j = "bs.collapse", L = i.default.fn[x], P = "show", F = "collapse", R = "collapsing", B = "collapsed", H = "width", M = '[data-toggle="collapse"]', q = {
        toggle: !0,
        parent: ""
    }, Q = {
        toggle: "boolean",
        parent: "(string|element)"
    }, W = function() {
        function t(t, e) {
            this._isTransitioning = !1, this._element = t, this._config = this._getConfig(e), this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + t.id + '"],[data-toggle="collapse"][data-target="#' + t.id + '"]'));
            for(var n = [].slice.call(document.querySelectorAll(M)), i = 0, o = n.length; i < o; i++){
                var r = n[i], a = u.getSelectorFromElement(r), s = [].slice.call(document.querySelectorAll(a)).filter(function(e) {
                    return e === t;
                });
                null !== a && s.length > 0 && (this._selector = a, this._triggerArray.push(r));
            }
            this._parent = this._config.parent ? this._getParent() : null, this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray), this._config.toggle && this.toggle();
        }
        var e = t.prototype;
        return e.toggle = function() {
            i.default(this._element).hasClass(P) ? this.hide() : this.show();
        }, e.show = function() {
            var e, n, o = this;
            if (!(this._isTransitioning || i.default(this._element).hasClass(P) || (this._parent && 0 === (e = [].slice.call(this._parent.querySelectorAll(".show, .collapsing")).filter(function(t) {
                return "string" == typeof o._config.parent ? t.getAttribute("data-parent") === o._config.parent : t.classList.contains(F);
            })).length && (e = null), e && (n = i.default(e).not(this._selector).data(j)) && n._isTransitioning))) {
                var r = i.default.Event("show.bs.collapse");
                if (i.default(this._element).trigger(r), !r.isDefaultPrevented()) {
                    e && (t._jQueryInterface.call(i.default(e).not(this._selector), "hide"), n || i.default(e).data(j, null));
                    var a = this._getDimension();
                    i.default(this._element).removeClass(F).addClass(R), this._element.style[a] = 0, this._triggerArray.length && i.default(this._triggerArray).removeClass(B).attr("aria-expanded", !0), this.setTransitioning(!0);
                    var s = "scroll" + (a[0].toUpperCase() + a.slice(1)), l = u.getTransitionDurationFromElement(this._element);
                    i.default(this._element).one(u.TRANSITION_END, function() {
                        i.default(o._element).removeClass(R).addClass("collapse show"), o._element.style[a] = "", o.setTransitioning(!1), i.default(o._element).trigger("shown.bs.collapse");
                    }).emulateTransitionEnd(l), this._element.style[a] = this._element[s] + "px";
                }
            }
        }, e.hide = function() {
            var t = this;
            if (!this._isTransitioning && i.default(this._element).hasClass(P)) {
                var e = i.default.Event("hide.bs.collapse");
                if (i.default(this._element).trigger(e), !e.isDefaultPrevented()) {
                    var n = this._getDimension();
                    this._element.style[n] = this._element.getBoundingClientRect()[n] + "px", u.reflow(this._element), i.default(this._element).addClass(R).removeClass("collapse show");
                    var o = this._triggerArray.length;
                    if (o > 0) for(var r = 0; r < o; r++){
                        var a = this._triggerArray[r], s = u.getSelectorFromElement(a);
                        null !== s && (i.default([].slice.call(document.querySelectorAll(s))).hasClass(P) || i.default(a).addClass(B).attr("aria-expanded", !1));
                    }
                    this.setTransitioning(!0), this._element.style[n] = "";
                    var l = u.getTransitionDurationFromElement(this._element);
                    i.default(this._element).one(u.TRANSITION_END, function() {
                        t.setTransitioning(!1), i.default(t._element).removeClass(R).addClass(F).trigger("hidden.bs.collapse");
                    }).emulateTransitionEnd(l);
                }
            }
        }, e.setTransitioning = function(t) {
            this._isTransitioning = t;
        }, e.dispose = function() {
            i.default.removeData(this._element, j), this._config = null, this._parent = null, this._element = null, this._triggerArray = null, this._isTransitioning = null;
        }, e._getConfig = function(t) {
            return (t = a({}, q, t)).toggle = Boolean(t.toggle), u.typeCheckConfig(x, t, Q), t;
        }, e._getDimension = function() {
            return i.default(this._element).hasClass(H) ? H : "height";
        }, e._getParent = function() {
            var e, n = this;
            u.isElement(this._config.parent) ? (e = this._config.parent, "undefined" != typeof this._config.parent.jquery && (e = this._config.parent[0])) : e = document.querySelector(this._config.parent);
            var o = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]', r = [].slice.call(e.querySelectorAll(o));
            return i.default(r).each(function(e, i) {
                n._addAriaAndCollapsedClass(t._getTargetFromElement(i), [
                    i
                ]);
            }), e;
        }, e._addAriaAndCollapsedClass = function(t, e) {
            var n = i.default(t).hasClass(P);
            e.length && i.default(e).toggleClass(B, !n).attr("aria-expanded", n);
        }, t._getTargetFromElement = function(t) {
            var e = u.getSelectorFromElement(t);
            return e ? document.querySelector(e) : null;
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(j), r = a({}, q, n.data(), "object" == typeof e && e ? e : {});
                if (!o && r.toggle && "string" == typeof e && /show|hide/.test(e) && (r.toggle = !1), o || (o = new t(this, r), n.data(j, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return q;
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.collapse.data-api", M, function(t) {
        "A" === t.currentTarget.tagName && t.preventDefault();
        var e = i.default(this), n = u.getSelectorFromElement(this), o = [].slice.call(document.querySelectorAll(n));
        i.default(o).each(function() {
            var t = i.default(this), n = t.data(j) ? "toggle" : e.data();
            W._jQueryInterface.call(t, n);
        });
    }), i.default.fn[x] = W._jQueryInterface, i.default.fn[x].Constructor = W, i.default.fn[x].noConflict = function() {
        return i.default.fn[x] = L, W._jQueryInterface;
    };
    var U = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator, V = function() {
        for(var t = [
            "Edge",
            "Trident",
            "Firefox"
        ], e = 0; e < t.length; e += 1)if (U && navigator.userAgent.indexOf(t[e]) >= 0) return 1;
        return 0;
    }(), Y = U && window.Promise ? function(t) {
        var e = !1;
        return function() {
            e || (e = !0, window.Promise.resolve().then(function() {
                e = !1, t();
            }));
        };
    } : function(t) {
        var e = !1;
        return function() {
            e || (e = !0, setTimeout(function() {
                e = !1, t();
            }, V));
        };
    };
    function z(t) {
        return t && "[object Function]" === ({}).toString.call(t);
    }
    function K(t, e) {
        if (1 !== t.nodeType) return [];
        var n = t.ownerDocument.defaultView.getComputedStyle(t, null);
        return e ? n[e] : n;
    }
    function X(t) {
        return "HTML" === t.nodeName ? t : t.parentNode || t.host;
    }
    function G(t) {
        if (!t) return document.body;
        switch(t.nodeName){
            case "HTML":
            case "BODY":
                return t.ownerDocument.body;
            case "#document":
                return t.body;
        }
        var e = K(t), n = e.overflow, i = e.overflowX, o = e.overflowY;
        return /(auto|scroll|overlay)/.test(n + o + i) ? t : G(X(t));
    }
    function $(t) {
        return t && t.referenceNode ? t.referenceNode : t;
    }
    var J = U && !(!window.MSInputMethodContext || !document.documentMode), Z = U && /MSIE 10/.test(navigator.userAgent);
    function tt(t) {
        return 11 === t ? J : 10 === t ? Z : J || Z;
    }
    function et(t) {
        if (!t) return document.documentElement;
        for(var e = tt(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling;)n = (t = t.nextElementSibling).offsetParent;
        var i = n && n.nodeName;
        return i && "BODY" !== i && "HTML" !== i ? -1 !== [
            "TH",
            "TD",
            "TABLE"
        ].indexOf(n.nodeName) && "static" === K(n, "position") ? et(n) : n : t ? t.ownerDocument.documentElement : document.documentElement;
    }
    function nt(t) {
        return null !== t.parentNode ? nt(t.parentNode) : t;
    }
    function it(t, e) {
        if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;
        var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, i = n ? t : e, o = n ? e : t, r = document.createRange();
        r.setStart(i, 0), r.setEnd(o, 0);
        var a, s, l = r.commonAncestorContainer;
        if (t !== l && e !== l || i.contains(o)) return "BODY" === (s = (a = l).nodeName) || "HTML" !== s && et(a.firstElementChild) !== a ? et(l) : l;
        var u = nt(t);
        return u.host ? it(u.host, e) : it(t, nt(e).host);
    }
    function ot(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top", n = "top" === e ? "scrollTop" : "scrollLeft", i = t.nodeName;
        if ("BODY" === i || "HTML" === i) {
            var o = t.ownerDocument.documentElement, r = t.ownerDocument.scrollingElement || o;
            return r[n];
        }
        return t[n];
    }
    function rt(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = ot(e, "top"), o = ot(e, "left"), r = n ? -1 : 1;
        return t.top += i * r, t.bottom += i * r, t.left += o * r, t.right += o * r, t;
    }
    function at(t, e) {
        var n = "x" === e ? "Left" : "Top", i = "Left" === n ? "Right" : "Bottom";
        return parseFloat(t["border" + n + "Width"]) + parseFloat(t["border" + i + "Width"]);
    }
    function st(t, e, n, i) {
        return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], tt(10) ? parseInt(n["offset" + t]) + parseInt(i["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(i["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0);
    }
    function lt(t) {
        var e = t.body, n = t.documentElement, i = tt(10) && getComputedStyle(n);
        return {
            height: st("Height", e, n, i),
            width: st("Width", e, n, i)
        };
    }
    var ut = function(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }, ft = function() {
        function t(t, e) {
            for(var n = 0; n < e.length; n++){
                var i = e[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
            }
        }
        return function(e, n, i) {
            return n && t(e.prototype, n), i && t(e, i), e;
        };
    }(), dt = function(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = n, t;
    }, ct = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var n = arguments[e];
            for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
        return t;
    };
    function ht(t) {
        return ct({}, t, {
            right: t.left + t.width,
            bottom: t.top + t.height
        });
    }
    function pt(t) {
        var e = {};
        try {
            if (tt(10)) {
                e = t.getBoundingClientRect();
                var n = ot(t, "top"), i = ot(t, "left");
                e.top += n, e.left += i, e.bottom += n, e.right += i;
            } else e = t.getBoundingClientRect();
        } catch (t) {}
        var o = {
            left: e.left,
            top: e.top,
            width: e.right - e.left,
            height: e.bottom - e.top
        }, r = "HTML" === t.nodeName ? lt(t.ownerDocument) : {}, a = r.width || t.clientWidth || o.width, s = r.height || t.clientHeight || o.height, l = t.offsetWidth - a, u = t.offsetHeight - s;
        if (l || u) {
            var f = K(t);
            l -= at(f, "x"), u -= at(f, "y"), o.width -= l, o.height -= u;
        }
        return ht(o);
    }
    function mt(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = tt(10), o = "HTML" === e.nodeName, r = pt(t), a = pt(e), s = G(t), l = K(e), u = parseFloat(l.borderTopWidth), f = parseFloat(l.borderLeftWidth);
        n && o && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0));
        var d = ht({
            top: r.top - a.top - u,
            left: r.left - a.left - f,
            width: r.width,
            height: r.height
        });
        if (d.marginTop = 0, d.marginLeft = 0, !i && o) {
            var c = parseFloat(l.marginTop), h = parseFloat(l.marginLeft);
            d.top -= u - c, d.bottom -= u - c, d.left -= f - h, d.right -= f - h, d.marginTop = c, d.marginLeft = h;
        }
        return (i && !n ? e.contains(s) : e === s && "BODY" !== s.nodeName) && (d = rt(d, e)), d;
    }
    function gt(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = t.ownerDocument.documentElement, i = mt(t, n), o = Math.max(n.clientWidth, window.innerWidth || 0), r = Math.max(n.clientHeight, window.innerHeight || 0), a = e ? 0 : ot(n), s = e ? 0 : ot(n, "left"), l = {
            top: a - i.top + i.marginTop,
            left: s - i.left + i.marginLeft,
            width: o,
            height: r
        };
        return ht(l);
    }
    function _t(t) {
        var e = t.nodeName;
        if ("BODY" === e || "HTML" === e) return !1;
        if ("fixed" === K(t, "position")) return !0;
        var n = X(t);
        return !!n && _t(n);
    }
    function vt(t) {
        if (!t || !t.parentElement || tt()) return document.documentElement;
        for(var e = t.parentElement; e && "none" === K(e, "transform");)e = e.parentElement;
        return e || document.documentElement;
    }
    function bt(t, e, n, i) {
        var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], r = {
            top: 0,
            left: 0
        }, a = o ? vt(t) : it(t, $(e));
        if ("viewport" === i) r = gt(a, o);
        else {
            var s = void 0;
            "scrollParent" === i ? "BODY" === (s = G(X(e))).nodeName && (s = t.ownerDocument.documentElement) : s = "window" === i ? t.ownerDocument.documentElement : i;
            var l = mt(s, a, o);
            if ("HTML" !== s.nodeName || _t(a)) r = l;
            else {
                var u = lt(t.ownerDocument), f = u.height, d = u.width;
                r.top += l.top - l.marginTop, r.bottom = f + l.top, r.left += l.left - l.marginLeft, r.right = d + l.left;
            }
        }
        var c = "number" == typeof (n = n || 0);
        return r.left += c ? n : n.left || 0, r.top += c ? n : n.top || 0, r.right -= c ? n : n.right || 0, r.bottom -= c ? n : n.bottom || 0, r;
    }
    function yt(t) {
        return t.width * t.height;
    }
    function Et(t, e, n, i, o) {
        var r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === t.indexOf("auto")) return t;
        var a = bt(n, i, r, o), s = {
            top: {
                width: a.width,
                height: e.top - a.top
            },
            right: {
                width: a.right - e.right,
                height: a.height
            },
            bottom: {
                width: a.width,
                height: a.bottom - e.bottom
            },
            left: {
                width: e.left - a.left,
                height: a.height
            }
        }, l = Object.keys(s).map(function(t) {
            return ct({
                key: t
            }, s[t], {
                area: yt(s[t])
            });
        }).sort(function(t, e) {
            return e.area - t.area;
        }), u = l.filter(function(t) {
            var e = t.width, i = t.height;
            return e >= n.clientWidth && i >= n.clientHeight;
        }), f = u.length > 0 ? u[0].key : l[0].key, d = t.split("-")[1];
        return f + (d ? "-" + d : "");
    }
    function wt(t, e, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, o = i ? vt(e) : it(e, $(n));
        return mt(n, o, i);
    }
    function Tt(t) {
        var e = t.ownerDocument.defaultView.getComputedStyle(t), n = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0), i = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);
        return {
            width: t.offsetWidth + i,
            height: t.offsetHeight + n
        };
    }
    function Ct(t) {
        var e = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };
        return t.replace(/left|right|bottom|top/g, function(t) {
            return e[t];
        });
    }
    function St(t, e, n) {
        n = n.split("-")[0];
        var i = Tt(t), o = {
            width: i.width,
            height: i.height
        }, r = -1 !== [
            "right",
            "left"
        ].indexOf(n), a = r ? "top" : "left", s = r ? "left" : "top", l = r ? "height" : "width", u = r ? "width" : "height";
        return o[a] = e[a] + e[l] / 2 - i[l] / 2, o[s] = n === s ? e[s] - i[u] : e[Ct(s)], o;
    }
    function Nt(t, e) {
        return Array.prototype.find ? t.find(e) : t.filter(e)[0];
    }
    function Dt(t, e, n) {
        return (void 0 === n ? t : t.slice(0, function(t, e, n) {
            if (Array.prototype.findIndex) return t.findIndex(function(t) {
                return t.name === n;
            });
            var i = Nt(t, function(t) {
                return t.name === n;
            });
            return t.indexOf(i);
        }(t, 0, n))).forEach(function(t) {
            t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var n = t.function || t.fn;
            t.enabled && z(n) && (e.offsets.popper = ht(e.offsets.popper), e.offsets.reference = ht(e.offsets.reference), e = n(e, t));
        }), e;
    }
    function At() {
        if (!this.state.isDestroyed) {
            var t = {
                instance: this,
                styles: {},
                arrowStyles: {},
                attributes: {},
                flipped: !1,
                offsets: {}
            };
            t.offsets.reference = wt(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = Et(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = St(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = Dt(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
        }
    }
    function kt(t, e) {
        return t.some(function(t) {
            var n = t.name;
            return t.enabled && n === e;
        });
    }
    function It(t) {
        for(var e = [
            !1,
            "ms",
            "Webkit",
            "Moz",
            "O"
        ], n = t.charAt(0).toUpperCase() + t.slice(1), i = 0; i < e.length; i++){
            var o = e[i], r = o ? "" + o + n : t;
            if ("undefined" != typeof document.body.style[r]) return r;
        }
        return null;
    }
    function Ot() {
        return this.state.isDestroyed = !0, kt(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[It("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
    }
    function xt(t) {
        var e = t.ownerDocument;
        return e ? e.defaultView : window;
    }
    function jt(t, e, n, i) {
        var o = "BODY" === t.nodeName, r = o ? t.ownerDocument.defaultView : t;
        r.addEventListener(e, n, {
            passive: !0
        }), o || jt(G(r.parentNode), e, n, i), i.push(r);
    }
    function Lt(t, e, n, i) {
        n.updateBound = i, xt(t).addEventListener("resize", n.updateBound, {
            passive: !0
        });
        var o = G(t);
        return jt(o, "scroll", n.updateBound, n.scrollParents), n.scrollElement = o, n.eventsEnabled = !0, n;
    }
    function Pt() {
        this.state.eventsEnabled || (this.state = Lt(this.reference, this.options, this.state, this.scheduleUpdate));
    }
    function Ft() {
        var t, e;
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (t = this.reference, e = this.state, xt(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(t) {
            t.removeEventListener("scroll", e.updateBound);
        }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e));
    }
    function Rt(t) {
        return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
    }
    function Bt(t, e) {
        Object.keys(e).forEach(function(n) {
            var i = "";
            -1 !== [
                "width",
                "height",
                "top",
                "right",
                "bottom",
                "left"
            ].indexOf(n) && Rt(e[n]) && (i = "px"), t.style[n] = e[n] + i;
        });
    }
    var Ht = U && /Firefox/i.test(navigator.userAgent);
    function Mt(t, e, n) {
        var i = Nt(t, function(t) {
            return t.name === e;
        }), o = !!i && t.some(function(t) {
            return t.name === n && t.enabled && t.order < i.order;
        });
        if (!o) {
            var r = "`" + e + "`", a = "`" + n + "`";
            console.warn(a + " modifier is required by " + r + " modifier in order to work, be sure to include it before " + r + "!");
        }
        return o;
    }
    var qt = [
        "auto-start",
        "auto",
        "auto-end",
        "top-start",
        "top",
        "top-end",
        "right-start",
        "right",
        "right-end",
        "bottom-end",
        "bottom",
        "bottom-start",
        "left-end",
        "left",
        "left-start"
    ], Qt = qt.slice(3);
    function Wt(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = Qt.indexOf(t), i = Qt.slice(n + 1).concat(Qt.slice(0, n));
        return e ? i.reverse() : i;
    }
    var Ut = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function() {},
        onUpdate: function() {},
        modifiers: {
            shift: {
                order: 100,
                enabled: !0,
                fn: function(t) {
                    var e = t.placement, n = e.split("-")[0], i = e.split("-")[1];
                    if (i) {
                        var o = t.offsets, r = o.reference, a = o.popper, s = -1 !== [
                            "bottom",
                            "top"
                        ].indexOf(n), l = s ? "left" : "top", u = s ? "width" : "height", f = {
                            start: dt({}, l, r[l]),
                            end: dt({}, l, r[l] + r[u] - a[u])
                        };
                        t.offsets.popper = ct({}, a, f[i]);
                    }
                    return t;
                }
            },
            offset: {
                order: 200,
                enabled: !0,
                fn: function(t, e) {
                    var n, i = e.offset, o = t.placement, r = t.offsets, a = r.popper, s = r.reference, l = o.split("-")[0];
                    return n = Rt(+i) ? [
                        +i,
                        0
                    ] : function(t, e, n, i) {
                        var o = [
                            0,
                            0
                        ], r = -1 !== [
                            "right",
                            "left"
                        ].indexOf(i), a = t.split(/(\+|\-)/).map(function(t) {
                            return t.trim();
                        }), s = a.indexOf(Nt(a, function(t) {
                            return -1 !== t.search(/,|\s/);
                        }));
                        a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
                        var l = /\s*,\s*|\s+/, u = -1 !== s ? [
                            a.slice(0, s).concat([
                                a[s].split(l)[0]
                            ]),
                            [
                                a[s].split(l)[1]
                            ].concat(a.slice(s + 1))
                        ] : [
                            a
                        ];
                        return u = u.map(function(t, i) {
                            var o = (1 === i ? !r : r) ? "height" : "width", a = !1;
                            return t.reduce(function(t, e) {
                                return "" === t[t.length - 1] && -1 !== [
                                    "+",
                                    "-"
                                ].indexOf(e) ? (t[t.length - 1] = e, a = !0, t) : a ? (t[t.length - 1] += e, a = !1, t) : t.concat(e);
                            }, []).map(function(t) {
                                return function(t, e, n, i) {
                                    var o = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), r = +o[1], a = o[2];
                                    return r ? 0 === a.indexOf("%") ? ht("%p" === a ? n : i)[e] / 100 * r : "vh" === a || "vw" === a ? ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * r : r : t;
                                }(t, o, e, n);
                            });
                        }), u.forEach(function(t, e) {
                            t.forEach(function(n, i) {
                                Rt(n) && (o[e] += n * ("-" === t[i - 1] ? -1 : 1));
                            });
                        }), o;
                    }(i, a, s, l), "left" === l ? (a.top += n[0], a.left -= n[1]) : "right" === l ? (a.top += n[0], a.left += n[1]) : "top" === l ? (a.left += n[0], a.top -= n[1]) : "bottom" === l && (a.left += n[0], a.top += n[1]), t.popper = a, t;
                },
                offset: 0
            },
            preventOverflow: {
                order: 300,
                enabled: !0,
                fn: function(t, e) {
                    var n = e.boundariesElement || et(t.instance.popper);
                    t.instance.reference === n && (n = et(n));
                    var i = It("transform"), o = t.instance.popper.style, r = o.top, a = o.left, s = o[i];
                    o.top = "", o.left = "", o[i] = "";
                    var l = bt(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);
                    o.top = r, o.left = a, o[i] = s, e.boundaries = l;
                    var u = e.priority, f = t.offsets.popper, d = {
                        primary: function(t) {
                            var n = f[t];
                            return f[t] < l[t] && !e.escapeWithReference && (n = Math.max(f[t], l[t])), dt({}, t, n);
                        },
                        secondary: function(t) {
                            var n = "right" === t ? "left" : "top", i = f[n];
                            return f[t] > l[t] && !e.escapeWithReference && (i = Math.min(f[n], l[t] - ("right" === t ? f.width : f.height))), dt({}, n, i);
                        }
                    };
                    return u.forEach(function(t) {
                        var e = -1 !== [
                            "left",
                            "top"
                        ].indexOf(t) ? "primary" : "secondary";
                        f = ct({}, f, d[e](t));
                    }), t.offsets.popper = f, t;
                },
                priority: [
                    "left",
                    "right",
                    "top",
                    "bottom"
                ],
                padding: 5,
                boundariesElement: "scrollParent"
            },
            keepTogether: {
                order: 400,
                enabled: !0,
                fn: function(t) {
                    var e = t.offsets, n = e.popper, i = e.reference, o = t.placement.split("-")[0], r = Math.floor, a = -1 !== [
                        "top",
                        "bottom"
                    ].indexOf(o), s = a ? "right" : "bottom", l = a ? "left" : "top", u = a ? "width" : "height";
                    return n[s] < r(i[l]) && (t.offsets.popper[l] = r(i[l]) - n[u]), n[l] > r(i[s]) && (t.offsets.popper[l] = r(i[s])), t;
                }
            },
            arrow: {
                order: 500,
                enabled: !0,
                fn: function(t, e) {
                    var n;
                    if (!Mt(t.instance.modifiers, "arrow", "keepTogether")) return t;
                    var i = e.element;
                    if ("string" == typeof i) {
                        if (!(i = t.instance.popper.querySelector(i))) return t;
                    } else if (!t.instance.popper.contains(i)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
                    var o = t.placement.split("-")[0], r = t.offsets, a = r.popper, s = r.reference, l = -1 !== [
                        "left",
                        "right"
                    ].indexOf(o), u = l ? "height" : "width", f = l ? "Top" : "Left", d = f.toLowerCase(), c = l ? "left" : "top", h = l ? "bottom" : "right", p = Tt(i)[u];
                    s[h] - p < a[d] && (t.offsets.popper[d] -= a[d] - (s[h] - p)), s[d] + p > a[h] && (t.offsets.popper[d] += s[d] + p - a[h]), t.offsets.popper = ht(t.offsets.popper);
                    var m = s[d] + s[u] / 2 - p / 2, g = K(t.instance.popper), _ = parseFloat(g["margin" + f]), v = parseFloat(g["border" + f + "Width"]), b = m - t.offsets.popper[d] - _ - v;
                    return b = Math.max(Math.min(a[u] - p, b), 0), t.arrowElement = i, t.offsets.arrow = (dt(n = {}, d, Math.round(b)), dt(n, c, ""), n), t;
                },
                element: "[x-arrow]"
            },
            flip: {
                order: 600,
                enabled: !0,
                fn: function(t, e) {
                    if (kt(t.instance.modifiers, "inner")) return t;
                    if (t.flipped && t.placement === t.originalPlacement) return t;
                    var n = bt(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed), i = t.placement.split("-")[0], o = Ct(i), r = t.placement.split("-")[1] || "", a = [];
                    switch(e.behavior){
                        case "flip":
                            a = [
                                i,
                                o
                            ];
                            break;
                        case "clockwise":
                            a = Wt(i);
                            break;
                        case "counterclockwise":
                            a = Wt(i, !0);
                            break;
                        default:
                            a = e.behavior;
                    }
                    return a.forEach(function(s, l) {
                        if (i !== s || a.length === l + 1) return t;
                        i = t.placement.split("-")[0], o = Ct(i);
                        var u = t.offsets.popper, f = t.offsets.reference, d = Math.floor, c = "left" === i && d(u.right) > d(f.left) || "right" === i && d(u.left) < d(f.right) || "top" === i && d(u.bottom) > d(f.top) || "bottom" === i && d(u.top) < d(f.bottom), h = d(u.left) < d(n.left), p = d(u.right) > d(n.right), m = d(u.top) < d(n.top), g = d(u.bottom) > d(n.bottom), _ = "left" === i && h || "right" === i && p || "top" === i && m || "bottom" === i && g, v = -1 !== [
                            "top",
                            "bottom"
                        ].indexOf(i), b = !!e.flipVariations && (v && "start" === r && h || v && "end" === r && p || !v && "start" === r && m || !v && "end" === r && g), y = !!e.flipVariationsByContent && (v && "start" === r && p || v && "end" === r && h || !v && "start" === r && g || !v && "end" === r && m), E = b || y;
                        (c || _ || E) && (t.flipped = !0, (c || _) && (i = a[l + 1]), E && (r = function(t) {
                            return "end" === t ? "start" : "start" === t ? "end" : t;
                        }(r)), t.placement = i + (r ? "-" + r : ""), t.offsets.popper = ct({}, t.offsets.popper, St(t.instance.popper, t.offsets.reference, t.placement)), t = Dt(t.instance.modifiers, t, "flip"));
                    }), t;
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport",
                flipVariations: !1,
                flipVariationsByContent: !1
            },
            inner: {
                order: 700,
                enabled: !1,
                fn: function(t) {
                    var e = t.placement, n = e.split("-")[0], i = t.offsets, o = i.popper, r = i.reference, a = -1 !== [
                        "left",
                        "right"
                    ].indexOf(n), s = -1 === [
                        "top",
                        "left"
                    ].indexOf(n);
                    return o[a ? "left" : "top"] = r[n] - (s ? o[a ? "width" : "height"] : 0), t.placement = Ct(e), t.offsets.popper = ht(o), t;
                }
            },
            hide: {
                order: 800,
                enabled: !0,
                fn: function(t) {
                    if (!Mt(t.instance.modifiers, "hide", "preventOverflow")) return t;
                    var e = t.offsets.reference, n = Nt(t.instance.modifiers, function(t) {
                        return "preventOverflow" === t.name;
                    }).boundaries;
                    if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
                        if (!0 === t.hide) return t;
                        t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
                    } else {
                        if (!1 === t.hide) return t;
                        t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
                    }
                    return t;
                }
            },
            computeStyle: {
                order: 850,
                enabled: !0,
                fn: function(t, e) {
                    var n = e.x, i = e.y, o = t.offsets.popper, r = Nt(t.instance.modifiers, function(t) {
                        return "applyStyle" === t.name;
                    }).gpuAcceleration;
                    void 0 !== r && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                    var a, s, l = void 0 !== r ? r : e.gpuAcceleration, u = et(t.instance.popper), f = pt(u), d = {
                        position: o.position
                    }, c = function(t, e) {
                        var n = t.offsets, i = n.popper, o = n.reference, r = Math.round, a = Math.floor, s = function(t) {
                            return t;
                        }, l = r(o.width), u = r(i.width), f = -1 !== [
                            "left",
                            "right"
                        ].indexOf(t.placement), d = -1 !== t.placement.indexOf("-"), c = e ? f || d || l % 2 == u % 2 ? r : a : s, h = e ? r : s;
                        return {
                            left: c(l % 2 == 1 && u % 2 == 1 && !d && e ? i.left - 1 : i.left),
                            top: h(i.top),
                            bottom: h(i.bottom),
                            right: c(i.right)
                        };
                    }(t, window.devicePixelRatio < 2 || !Ht), h = "bottom" === n ? "top" : "bottom", p = "right" === i ? "left" : "right", m = It("transform");
                    if (s = "bottom" === h ? "HTML" === u.nodeName ? -u.clientHeight + c.bottom : -f.height + c.bottom : c.top, a = "right" === p ? "HTML" === u.nodeName ? -u.clientWidth + c.right : -f.width + c.right : c.left, l && m) d[m] = "translate3d(" + a + "px, " + s + "px, 0)", d[h] = 0, d[p] = 0, d.willChange = "transform";
                    else {
                        var g = "bottom" === h ? -1 : 1, _ = "right" === p ? -1 : 1;
                        d[h] = s * g, d[p] = a * _, d.willChange = h + ", " + p;
                    }
                    var v = {
                        "x-placement": t.placement
                    };
                    return t.attributes = ct({}, v, t.attributes), t.styles = ct({}, d, t.styles), t.arrowStyles = ct({}, t.offsets.arrow, t.arrowStyles), t;
                },
                gpuAcceleration: !0,
                x: "bottom",
                y: "right"
            },
            applyStyle: {
                order: 900,
                enabled: !0,
                fn: function(t) {
                    var e, n;
                    return Bt(t.instance.popper, t.styles), e = t.instance.popper, n = t.attributes, Object.keys(n).forEach(function(t) {
                        !1 !== n[t] ? e.setAttribute(t, n[t]) : e.removeAttribute(t);
                    }), t.arrowElement && Object.keys(t.arrowStyles).length && Bt(t.arrowElement, t.arrowStyles), t;
                },
                onLoad: function(t, e, n, i, o) {
                    var r = wt(o, e, t, n.positionFixed), a = Et(n.placement, r, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                    return e.setAttribute("x-placement", a), Bt(e, {
                        position: n.positionFixed ? "fixed" : "absolute"
                    }), n;
                },
                gpuAcceleration: void 0
            }
        }
    }, Vt = function() {
        function t(e, n) {
            var i = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            ut(this, t), this.scheduleUpdate = function() {
                return requestAnimationFrame(i.update);
            }, this.update = Y(this.update.bind(this)), this.options = ct({}, t.Defaults, o), this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
            }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(ct({}, t.Defaults.modifiers, o.modifiers)).forEach(function(e) {
                i.options.modifiers[e] = ct({}, t.Defaults.modifiers[e] || {}, o.modifiers ? o.modifiers[e] : {});
            }), this.modifiers = Object.keys(this.options.modifiers).map(function(t) {
                return ct({
                    name: t
                }, i.options.modifiers[t]);
            }).sort(function(t, e) {
                return t.order - e.order;
            }), this.modifiers.forEach(function(t) {
                t.enabled && z(t.onLoad) && t.onLoad(i.reference, i.popper, i.options, t, i.state);
            }), this.update();
            var r = this.options.eventsEnabled;
            r && this.enableEventListeners(), this.state.eventsEnabled = r;
        }
        return ft(t, [
            {
                key: "update",
                value: function() {
                    return At.call(this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    return Ot.call(this);
                }
            },
            {
                key: "enableEventListeners",
                value: function() {
                    return Pt.call(this);
                }
            },
            {
                key: "disableEventListeners",
                value: function() {
                    return Ft.call(this);
                }
            }
        ]), t;
    }();
    Vt.Utils = ("undefined" != typeof window ? window : global).PopperUtils, Vt.placements = qt, Vt.Defaults = Ut;
    var Yt = Vt, zt = "dropdown", Kt = "bs.dropdown", Xt = i.default.fn[zt], Gt = new RegExp("38|40|27"), $t = "disabled", Jt = "show", Zt = "dropdown-menu-right", te = "hide.bs.dropdown", ee = "hidden.bs.dropdown", ne = "click.bs.dropdown.data-api", ie = "keydown.bs.dropdown.data-api", oe = '[data-toggle="dropdown"]', re = ".dropdown-menu", ae = {
        offset: 0,
        flip: !0,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    }, se = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    }, le = function() {
        function t(t, e) {
            this._element = t, this._popper = null, this._config = this._getConfig(e), this._menu = this._getMenuElement(), this._inNavbar = this._detectNavbar(), this._addEventListeners();
        }
        var e = t.prototype;
        return e.toggle = function() {
            if (!this._element.disabled && !i.default(this._element).hasClass($t)) {
                var e = i.default(this._menu).hasClass(Jt);
                t._clearMenus(), e || this.show(!0);
            }
        }, e.show = function(e) {
            if (void 0 === e && (e = !1), !(this._element.disabled || i.default(this._element).hasClass($t) || i.default(this._menu).hasClass(Jt))) {
                var n = {
                    relatedTarget: this._element
                }, o = i.default.Event("show.bs.dropdown", n), r = t._getParentFromElement(this._element);
                if (i.default(r).trigger(o), !o.isDefaultPrevented()) {
                    if (!this._inNavbar && e) {
                        if ("undefined" == typeof Yt) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                        var a = this._element;
                        "parent" === this._config.reference ? a = r : u.isElement(this._config.reference) && (a = this._config.reference, "undefined" != typeof this._config.reference.jquery && (a = this._config.reference[0])), "scrollParent" !== this._config.boundary && i.default(r).addClass("position-static"), this._popper = new Yt(a, this._menu, this._getPopperConfig());
                    }
                    "ontouchstart" in document.documentElement && 0 === i.default(r).closest(".navbar-nav").length && i.default(document.body).children().on("mouseover", null, i.default.noop), this._element.focus(), this._element.setAttribute("aria-expanded", !0), i.default(this._menu).toggleClass(Jt), i.default(r).toggleClass(Jt).trigger(i.default.Event("shown.bs.dropdown", n));
                }
            }
        }, e.hide = function() {
            if (!this._element.disabled && !i.default(this._element).hasClass($t) && i.default(this._menu).hasClass(Jt)) {
                var e = {
                    relatedTarget: this._element
                }, n = i.default.Event(te, e), o = t._getParentFromElement(this._element);
                i.default(o).trigger(n), n.isDefaultPrevented() || (this._popper && this._popper.destroy(), i.default(this._menu).toggleClass(Jt), i.default(o).toggleClass(Jt).trigger(i.default.Event(ee, e)));
            }
        }, e.dispose = function() {
            i.default.removeData(this._element, Kt), i.default(this._element).off(".bs.dropdown"), this._element = null, this._menu = null, null !== this._popper && (this._popper.destroy(), this._popper = null);
        }, e.update = function() {
            this._inNavbar = this._detectNavbar(), null !== this._popper && this._popper.scheduleUpdate();
        }, e._addEventListeners = function() {
            var t = this;
            i.default(this._element).on("click.bs.dropdown", function(e) {
                e.preventDefault(), e.stopPropagation(), t.toggle();
            });
        }, e._getConfig = function(t) {
            return t = a({}, this.constructor.Default, i.default(this._element).data(), t), u.typeCheckConfig(zt, t, this.constructor.DefaultType), t;
        }, e._getMenuElement = function() {
            if (!this._menu) {
                var e = t._getParentFromElement(this._element);
                e && (this._menu = e.querySelector(re));
            }
            return this._menu;
        }, e._getPlacement = function() {
            var t = i.default(this._element.parentNode), e = "bottom-start";
            return t.hasClass("dropup") ? e = i.default(this._menu).hasClass(Zt) ? "top-end" : "top-start" : t.hasClass("dropright") ? e = "right-start" : t.hasClass("dropleft") ? e = "left-start" : i.default(this._menu).hasClass(Zt) && (e = "bottom-end"), e;
        }, e._detectNavbar = function() {
            return i.default(this._element).closest(".navbar").length > 0;
        }, e._getOffset = function() {
            var t = this, e = {};
            return "function" == typeof this._config.offset ? e.fn = function(e) {
                return e.offsets = a({}, e.offsets, t._config.offset(e.offsets, t._element)), e;
            } : e.offset = this._config.offset, e;
        }, e._getPopperConfig = function() {
            var t = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            };
            return "static" === this._config.display && (t.modifiers.applyStyle = {
                enabled: !1
            }), a({}, t, this._config.popperConfig);
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this).data(Kt);
                if (n || (n = new t(this, "object" == typeof e ? e : null), i.default(this).data(Kt, n)), "string" == typeof e) {
                    if ("undefined" == typeof n[e]) throw new TypeError('No method named "' + e + '"');
                    n[e]();
                }
            });
        }, t._clearMenus = function(e) {
            if (!e || 3 !== e.which && ("keyup" !== e.type || 9 === e.which)) for(var n = [].slice.call(document.querySelectorAll(oe)), o = 0, r = n.length; o < r; o++){
                var a = t._getParentFromElement(n[o]), s = i.default(n[o]).data(Kt), l = {
                    relatedTarget: n[o]
                };
                if (e && "click" === e.type && (l.clickEvent = e), s) {
                    var u = s._menu;
                    if (i.default(a).hasClass(Jt) && !(e && ("click" === e.type && /input|textarea/i.test(e.target.tagName) || "keyup" === e.type && 9 === e.which) && i.default.contains(a, e.target))) {
                        var f = i.default.Event(te, l);
                        i.default(a).trigger(f), f.isDefaultPrevented() || ("ontouchstart" in document.documentElement && i.default(document.body).children().off("mouseover", null, i.default.noop), n[o].setAttribute("aria-expanded", "false"), s._popper && s._popper.destroy(), i.default(u).removeClass(Jt), i.default(a).removeClass(Jt).trigger(i.default.Event(ee, l)));
                    }
                }
            }
        }, t._getParentFromElement = function(t) {
            var e, n = u.getSelectorFromElement(t);
            return n && (e = document.querySelector(n)), e || t.parentNode;
        }, t._dataApiKeydownHandler = function(e) {
            if (!(/input|textarea/i.test(e.target.tagName) ? 32 === e.which || 27 !== e.which && (40 !== e.which && 38 !== e.which || i.default(e.target).closest(re).length) : !Gt.test(e.which)) && !this.disabled && !i.default(this).hasClass($t)) {
                var n = t._getParentFromElement(this), o = i.default(n).hasClass(Jt);
                if (o || 27 !== e.which) {
                    if (e.preventDefault(), e.stopPropagation(), !o || 27 === e.which || 32 === e.which) return 27 === e.which && i.default(n.querySelector(oe)).trigger("focus"), void i.default(this).trigger("click");
                    var r = [].slice.call(n.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)")).filter(function(t) {
                        return i.default(t).is(":visible");
                    });
                    if (0 !== r.length) {
                        var a = r.indexOf(e.target);
                        38 === e.which && a > 0 && a--, 40 === e.which && a < r.length - 1 && a++, a < 0 && (a = 0), r[a].focus();
                    }
                }
            }
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return ae;
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return se;
                }
            }
        ]), t;
    }();
    i.default(document).on(ie, oe, le._dataApiKeydownHandler).on(ie, re, le._dataApiKeydownHandler).on(ne + " keyup.bs.dropdown.data-api", le._clearMenus).on(ne, oe, function(t) {
        t.preventDefault(), t.stopPropagation(), le._jQueryInterface.call(i.default(this), "toggle");
    }).on(ne, ".dropdown form", function(t) {
        t.stopPropagation();
    }), i.default.fn[zt] = le._jQueryInterface, i.default.fn[zt].Constructor = le, i.default.fn[zt].noConflict = function() {
        return i.default.fn[zt] = Xt, le._jQueryInterface;
    };
    var ue = "bs.modal", fe = i.default.fn.modal, de = "modal-open", ce = "fade", he = "show", pe = "modal-static", me = "hidden.bs.modal", ge = "show.bs.modal", _e = "focusin.bs.modal", ve = "resize.bs.modal", be = "click.dismiss.bs.modal", ye = "keydown.dismiss.bs.modal", Ee = "mousedown.dismiss.bs.modal", we = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Te = {
        backdrop: !0,
        keyboard: !0,
        focus: !0,
        show: !0
    }, Ce = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    }, Se = function() {
        function t(t, e) {
            this._config = this._getConfig(e), this._element = t, this._dialog = t.querySelector(".modal-dialog"), this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, this._isTransitioning = !1, this._scrollbarWidth = 0;
        }
        var e = t.prototype;
        return e.toggle = function(t) {
            return this._isShown ? this.hide() : this.show(t);
        }, e.show = function(t) {
            var e = this;
            if (!this._isShown && !this._isTransitioning) {
                var n = i.default.Event(ge, {
                    relatedTarget: t
                });
                i.default(this._element).trigger(n), n.isDefaultPrevented() || (this._isShown = !0, i.default(this._element).hasClass(ce) && (this._isTransitioning = !0), this._checkScrollbar(), this._setScrollbar(), this._adjustDialog(), this._setEscapeEvent(), this._setResizeEvent(), i.default(this._element).on(be, '[data-dismiss="modal"]', function(t) {
                    return e.hide(t);
                }), i.default(this._dialog).on(Ee, function() {
                    i.default(e._element).one("mouseup.dismiss.bs.modal", function(t) {
                        i.default(t.target).is(e._element) && (e._ignoreBackdropClick = !0);
                    });
                }), this._showBackdrop(function() {
                    return e._showElement(t);
                }));
            }
        }, e.hide = function(t) {
            var e = this;
            if (t && t.preventDefault(), this._isShown && !this._isTransitioning) {
                var n = i.default.Event("hide.bs.modal");
                if (i.default(this._element).trigger(n), this._isShown && !n.isDefaultPrevented()) {
                    this._isShown = !1;
                    var o = i.default(this._element).hasClass(ce);
                    if (o && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), i.default(document).off(_e), i.default(this._element).removeClass(he), i.default(this._element).off(be), i.default(this._dialog).off(Ee), o) {
                        var r = u.getTransitionDurationFromElement(this._element);
                        i.default(this._element).one(u.TRANSITION_END, function(t) {
                            return e._hideModal(t);
                        }).emulateTransitionEnd(r);
                    } else this._hideModal();
                }
            }
        }, e.dispose = function() {
            [
                window,
                this._element,
                this._dialog
            ].forEach(function(t) {
                return i.default(t).off(".bs.modal");
            }), i.default(document).off(_e), i.default.removeData(this._element, ue), this._config = null, this._element = null, this._dialog = null, this._backdrop = null, this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, this._isTransitioning = null, this._scrollbarWidth = null;
        }, e.handleUpdate = function() {
            this._adjustDialog();
        }, e._getConfig = function(t) {
            return t = a({}, Te, t), u.typeCheckConfig("modal", t, Ce), t;
        }, e._triggerBackdropTransition = function() {
            var t = this, e = i.default.Event("hidePrevented.bs.modal");
            if (i.default(this._element).trigger(e), !e.isDefaultPrevented()) {
                var n = this._element.scrollHeight > document.documentElement.clientHeight;
                n || (this._element.style.overflowY = "hidden"), this._element.classList.add(pe);
                var o = u.getTransitionDurationFromElement(this._dialog);
                i.default(this._element).off(u.TRANSITION_END), i.default(this._element).one(u.TRANSITION_END, function() {
                    t._element.classList.remove(pe), n || i.default(t._element).one(u.TRANSITION_END, function() {
                        t._element.style.overflowY = "";
                    }).emulateTransitionEnd(t._element, o);
                }).emulateTransitionEnd(o), this._element.focus();
            }
        }, e._showElement = function(t) {
            var e = this, n = i.default(this._element).hasClass(ce), o = this._dialog ? this._dialog.querySelector(".modal-body") : null;
            this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), i.default(this._dialog).hasClass("modal-dialog-scrollable") && o ? o.scrollTop = 0 : this._element.scrollTop = 0, n && u.reflow(this._element), i.default(this._element).addClass(he), this._config.focus && this._enforceFocus();
            var r = i.default.Event("shown.bs.modal", {
                relatedTarget: t
            }), a = function() {
                e._config.focus && e._element.focus(), e._isTransitioning = !1, i.default(e._element).trigger(r);
            };
            if (n) {
                var s = u.getTransitionDurationFromElement(this._dialog);
                i.default(this._dialog).one(u.TRANSITION_END, a).emulateTransitionEnd(s);
            } else a();
        }, e._enforceFocus = function() {
            var t = this;
            i.default(document).off(_e).on(_e, function(e) {
                document !== e.target && t._element !== e.target && 0 === i.default(t._element).has(e.target).length && t._element.focus();
            });
        }, e._setEscapeEvent = function() {
            var t = this;
            this._isShown ? i.default(this._element).on(ye, function(e) {
                t._config.keyboard && 27 === e.which ? (e.preventDefault(), t.hide()) : t._config.keyboard || 27 !== e.which || t._triggerBackdropTransition();
            }) : this._isShown || i.default(this._element).off(ye);
        }, e._setResizeEvent = function() {
            var t = this;
            this._isShown ? i.default(window).on(ve, function(e) {
                return t.handleUpdate(e);
            }) : i.default(window).off(ve);
        }, e._hideModal = function() {
            var t = this;
            this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._showBackdrop(function() {
                i.default(document.body).removeClass(de), t._resetAdjustments(), t._resetScrollbar(), i.default(t._element).trigger(me);
            });
        }, e._removeBackdrop = function() {
            this._backdrop && (i.default(this._backdrop).remove(), this._backdrop = null);
        }, e._showBackdrop = function(t) {
            var e = this, n = i.default(this._element).hasClass(ce) ? ce : "";
            if (this._isShown && this._config.backdrop) {
                if (this._backdrop = document.createElement("div"), this._backdrop.className = "modal-backdrop", n && this._backdrop.classList.add(n), i.default(this._backdrop).appendTo(document.body), i.default(this._element).on(be, function(t) {
                    e._ignoreBackdropClick ? e._ignoreBackdropClick = !1 : t.target === t.currentTarget && ("static" === e._config.backdrop ? e._triggerBackdropTransition() : e.hide());
                }), n && u.reflow(this._backdrop), i.default(this._backdrop).addClass(he), !t) return;
                if (!n) return void t();
                var o = u.getTransitionDurationFromElement(this._backdrop);
                i.default(this._backdrop).one(u.TRANSITION_END, t).emulateTransitionEnd(o);
            } else if (!this._isShown && this._backdrop) {
                i.default(this._backdrop).removeClass(he);
                var r = function() {
                    e._removeBackdrop(), t && t();
                };
                if (i.default(this._element).hasClass(ce)) {
                    var a = u.getTransitionDurationFromElement(this._backdrop);
                    i.default(this._backdrop).one(u.TRANSITION_END, r).emulateTransitionEnd(a);
                } else r();
            } else t && t();
        }, e._adjustDialog = function() {
            var t = this._element.scrollHeight > document.documentElement.clientHeight;
            !this._isBodyOverflowing && t && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), this._isBodyOverflowing && !t && (this._element.style.paddingRight = this._scrollbarWidth + "px");
        }, e._resetAdjustments = function() {
            this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
        }, e._checkScrollbar = function() {
            var t = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(t.left + t.right) < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth();
        }, e._setScrollbar = function() {
            var t = this;
            if (this._isBodyOverflowing) {
                var e = [].slice.call(document.querySelectorAll(we)), n = [].slice.call(document.querySelectorAll(".sticky-top"));
                i.default(e).each(function(e, n) {
                    var o = n.style.paddingRight, r = i.default(n).css("padding-right");
                    i.default(n).data("padding-right", o).css("padding-right", parseFloat(r) + t._scrollbarWidth + "px");
                }), i.default(n).each(function(e, n) {
                    var o = n.style.marginRight, r = i.default(n).css("margin-right");
                    i.default(n).data("margin-right", o).css("margin-right", parseFloat(r) - t._scrollbarWidth + "px");
                });
                var o = document.body.style.paddingRight, r = i.default(document.body).css("padding-right");
                i.default(document.body).data("padding-right", o).css("padding-right", parseFloat(r) + this._scrollbarWidth + "px");
            }
            i.default(document.body).addClass(de);
        }, e._resetScrollbar = function() {
            var t = [].slice.call(document.querySelectorAll(we));
            i.default(t).each(function(t, e) {
                var n = i.default(e).data("padding-right");
                i.default(e).removeData("padding-right"), e.style.paddingRight = n || "";
            });
            var e = [].slice.call(document.querySelectorAll(".sticky-top"));
            i.default(e).each(function(t, e) {
                var n = i.default(e).data("margin-right");
                "undefined" != typeof n && i.default(e).css("margin-right", n).removeData("margin-right");
            });
            var n = i.default(document.body).data("padding-right");
            i.default(document.body).removeData("padding-right"), document.body.style.paddingRight = n || "";
        }, e._getScrollbarWidth = function() {
            var t = document.createElement("div");
            t.className = "modal-scrollbar-measure", document.body.appendChild(t);
            var e = t.getBoundingClientRect().width - t.clientWidth;
            return document.body.removeChild(t), e;
        }, t._jQueryInterface = function(e, n) {
            return this.each(function() {
                var o = i.default(this).data(ue), r = a({}, Te, i.default(this).data(), "object" == typeof e && e ? e : {});
                if (o || (o = new t(this, r), i.default(this).data(ue, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e](n);
                } else r.show && o.show(n);
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return Te;
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(t) {
        var e, n = this, o = u.getSelectorFromElement(this);
        o && (e = document.querySelector(o));
        var r = i.default(e).data(ue) ? "toggle" : a({}, i.default(e).data(), i.default(this).data());
        "A" !== this.tagName && "AREA" !== this.tagName || t.preventDefault();
        var s = i.default(e).one(ge, function(t) {
            t.isDefaultPrevented() || s.one(me, function() {
                i.default(n).is(":visible") && n.focus();
            });
        });
        Se._jQueryInterface.call(i.default(e), r, this);
    }), i.default.fn.modal = Se._jQueryInterface, i.default.fn.modal.Constructor = Se, i.default.fn.modal.noConflict = function() {
        return i.default.fn.modal = fe, Se._jQueryInterface;
    };
    var Ne = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ], De = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i, Ae = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function ke(t, e, n) {
        if (0 === t.length) return t;
        if (n && "function" == typeof n) return n(t);
        for(var i = (new window.DOMParser).parseFromString(t, "text/html"), o = Object.keys(e), r = [].slice.call(i.body.querySelectorAll("*")), a = function(t, n) {
            var i = r[t], a = i.nodeName.toLowerCase();
            if (-1 === o.indexOf(i.nodeName.toLowerCase())) return i.parentNode.removeChild(i), "continue";
            var s = [].slice.call(i.attributes), l = [].concat(e["*"] || [], e[a] || []);
            s.forEach(function(t) {
                (function(t, e) {
                    var n = t.nodeName.toLowerCase();
                    if (-1 !== e.indexOf(n)) return -1 === Ne.indexOf(n) || Boolean(De.test(t.nodeValue) || Ae.test(t.nodeValue));
                    for(var i = e.filter(function(t) {
                        return t instanceof RegExp;
                    }), o = 0, r = i.length; o < r; o++)if (i[o].test(n)) return !0;
                    return !1;
                })(t, l) || i.removeAttribute(t.nodeName);
            });
        }, s = 0, l = r.length; s < l; s++)a(s);
        return i.body.innerHTML;
    }
    var Ie = "tooltip", Oe = "bs.tooltip", xe = i.default.fn.tooltip, je = new RegExp("(^|\\s)bs-tooltip\\S+", "g"), Le = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ], Pe = "fade", Fe = "show", Re = "show", Be = "out", He = "hover", Me = "focus", qe = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left"
    }, Qe = {
        animation: !0,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        selector: !1,
        placement: "top",
        offset: 0,
        container: !1,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        customClass: "",
        sanitize: !0,
        sanitizeFn: null,
        whiteList: {
            "*": [
                "class",
                "dir",
                "id",
                "lang",
                "role",
                /^aria-[\w-]*$/i
            ],
            a: [
                "target",
                "href",
                "title",
                "rel"
            ],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: [
                "src",
                "srcset",
                "alt",
                "title",
                "width",
                "height"
            ],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        },
        popperConfig: null
    }, We = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        customClass: "(string|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)"
    }, Ue = {
        HIDE: "hide.bs.tooltip",
        HIDDEN: "hidden.bs.tooltip",
        SHOW: "show.bs.tooltip",
        SHOWN: "shown.bs.tooltip",
        INSERTED: "inserted.bs.tooltip",
        CLICK: "click.bs.tooltip",
        FOCUSIN: "focusin.bs.tooltip",
        FOCUSOUT: "focusout.bs.tooltip",
        MOUSEENTER: "mouseenter.bs.tooltip",
        MOUSELEAVE: "mouseleave.bs.tooltip"
    }, Ve = function() {
        function t(t, e) {
            if ("undefined" == typeof Yt) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
            this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, this._popper = null, this.element = t, this.config = this._getConfig(e), this.tip = null, this._setListeners();
        }
        var e = t.prototype;
        return e.enable = function() {
            this._isEnabled = !0;
        }, e.disable = function() {
            this._isEnabled = !1;
        }, e.toggleEnabled = function() {
            this._isEnabled = !this._isEnabled;
        }, e.toggle = function(t) {
            if (this._isEnabled) {
                if (t) {
                    var e = this.constructor.DATA_KEY, n = i.default(t.currentTarget).data(e);
                    n || (n = new this.constructor(t.currentTarget, this._getDelegateConfig()), i.default(t.currentTarget).data(e, n)), n._activeTrigger.click = !n._activeTrigger.click, n._isWithActiveTrigger() ? n._enter(null, n) : n._leave(null, n);
                } else {
                    if (i.default(this.getTipElement()).hasClass(Fe)) return void this._leave(null, this);
                    this._enter(null, this);
                }
            }
        }, e.dispose = function() {
            clearTimeout(this._timeout), i.default.removeData(this.element, this.constructor.DATA_KEY), i.default(this.element).off(this.constructor.EVENT_KEY), i.default(this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler), this.tip && i.default(this.tip).remove(), this._isEnabled = null, this._timeout = null, this._hoverState = null, this._activeTrigger = null, this._popper && this._popper.destroy(), this._popper = null, this.element = null, this.config = null, this.tip = null;
        }, e.show = function() {
            var t = this;
            if ("none" === i.default(this.element).css("display")) throw new Error("Please use show on visible elements");
            var e = i.default.Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                i.default(this.element).trigger(e);
                var n = u.findShadowRoot(this.element), o = i.default.contains(null !== n ? n : this.element.ownerDocument.documentElement, this.element);
                if (e.isDefaultPrevented() || !o) return;
                var r = this.getTipElement(), a = u.getUID(this.constructor.NAME);
                r.setAttribute("id", a), this.element.setAttribute("aria-describedby", a), this.setContent(), this.config.animation && i.default(r).addClass(Pe);
                var s = "function" == typeof this.config.placement ? this.config.placement.call(this, r, this.element) : this.config.placement, l = this._getAttachment(s);
                this.addAttachmentClass(l);
                var f = this._getContainer();
                i.default(r).data(this.constructor.DATA_KEY, this), i.default.contains(this.element.ownerDocument.documentElement, this.tip) || i.default(r).appendTo(f), i.default(this.element).trigger(this.constructor.Event.INSERTED), this._popper = new Yt(this.element, r, this._getPopperConfig(l)), i.default(r).addClass(Fe), i.default(r).addClass(this.config.customClass), "ontouchstart" in document.documentElement && i.default(document.body).children().on("mouseover", null, i.default.noop);
                var d = function() {
                    t.config.animation && t._fixTransition();
                    var e = t._hoverState;
                    t._hoverState = null, i.default(t.element).trigger(t.constructor.Event.SHOWN), e === Be && t._leave(null, t);
                };
                if (i.default(this.tip).hasClass(Pe)) {
                    var c = u.getTransitionDurationFromElement(this.tip);
                    i.default(this.tip).one(u.TRANSITION_END, d).emulateTransitionEnd(c);
                } else d();
            }
        }, e.hide = function(t) {
            var e = this, n = this.getTipElement(), o = i.default.Event(this.constructor.Event.HIDE), r = function() {
                e._hoverState !== Re && n.parentNode && n.parentNode.removeChild(n), e._cleanTipClass(), e.element.removeAttribute("aria-describedby"), i.default(e.element).trigger(e.constructor.Event.HIDDEN), null !== e._popper && e._popper.destroy(), t && t();
            };
            if (i.default(this.element).trigger(o), !o.isDefaultPrevented()) {
                if (i.default(n).removeClass(Fe), "ontouchstart" in document.documentElement && i.default(document.body).children().off("mouseover", null, i.default.noop), this._activeTrigger.click = !1, this._activeTrigger.focus = !1, this._activeTrigger.hover = !1, i.default(this.tip).hasClass(Pe)) {
                    var a = u.getTransitionDurationFromElement(n);
                    i.default(n).one(u.TRANSITION_END, r).emulateTransitionEnd(a);
                } else r();
                this._hoverState = "";
            }
        }, e.update = function() {
            null !== this._popper && this._popper.scheduleUpdate();
        }, e.isWithContent = function() {
            return Boolean(this.getTitle());
        }, e.addAttachmentClass = function(t) {
            i.default(this.getTipElement()).addClass("bs-tooltip-" + t);
        }, e.getTipElement = function() {
            return this.tip = this.tip || i.default(this.config.template)[0], this.tip;
        }, e.setContent = function() {
            var t = this.getTipElement();
            this.setElementContent(i.default(t.querySelectorAll(".tooltip-inner")), this.getTitle()), i.default(t).removeClass("fade show");
        }, e.setElementContent = function(t, e) {
            "object" != typeof e || !e.nodeType && !e.jquery ? this.config.html ? (this.config.sanitize && (e = ke(e, this.config.whiteList, this.config.sanitizeFn)), t.html(e)) : t.text(e) : this.config.html ? i.default(e).parent().is(t) || t.empty().append(e) : t.text(i.default(e).text());
        }, e.getTitle = function() {
            var t = this.element.getAttribute("data-original-title");
            return t || (t = "function" == typeof this.config.title ? this.config.title.call(this.element) : this.config.title), t;
        }, e._getPopperConfig = function(t) {
            var e = this;
            return a({}, {
                placement: t,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: ".arrow"
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function(t) {
                    t.originalPlacement !== t.placement && e._handlePopperPlacementChange(t);
                },
                onUpdate: function(t) {
                    return e._handlePopperPlacementChange(t);
                }
            }, this.config.popperConfig);
        }, e._getOffset = function() {
            var t = this, e = {};
            return "function" == typeof this.config.offset ? e.fn = function(e) {
                return e.offsets = a({}, e.offsets, t.config.offset(e.offsets, t.element)), e;
            } : e.offset = this.config.offset, e;
        }, e._getContainer = function() {
            return !1 === this.config.container ? document.body : u.isElement(this.config.container) ? i.default(this.config.container) : i.default(document).find(this.config.container);
        }, e._getAttachment = function(t) {
            return qe[t.toUpperCase()];
        }, e._setListeners = function() {
            var t = this;
            this.config.trigger.split(" ").forEach(function(e) {
                if ("click" === e) i.default(t.element).on(t.constructor.Event.CLICK, t.config.selector, function(e) {
                    return t.toggle(e);
                });
                else if ("manual" !== e) {
                    var n = e === He ? t.constructor.Event.MOUSEENTER : t.constructor.Event.FOCUSIN, o = e === He ? t.constructor.Event.MOUSELEAVE : t.constructor.Event.FOCUSOUT;
                    i.default(t.element).on(n, t.config.selector, function(e) {
                        return t._enter(e);
                    }).on(o, t.config.selector, function(e) {
                        return t._leave(e);
                    });
                }
            }), this._hideModalHandler = function() {
                t.element && t.hide();
            }, i.default(this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler), this.config.selector ? this.config = a({}, this.config, {
                trigger: "manual",
                selector: ""
            }) : this._fixTitle();
        }, e._fixTitle = function() {
            var t = typeof this.element.getAttribute("data-original-title");
            (this.element.getAttribute("title") || "string" !== t) && (this.element.setAttribute("data-original-title", this.element.getAttribute("title") || ""), this.element.setAttribute("title", ""));
        }, e._enter = function(t, e) {
            var n = this.constructor.DATA_KEY;
            (e = e || i.default(t.currentTarget).data(n)) || (e = new this.constructor(t.currentTarget, this._getDelegateConfig()), i.default(t.currentTarget).data(n, e)), t && (e._activeTrigger["focusin" === t.type ? Me : He] = !0), i.default(e.getTipElement()).hasClass(Fe) || e._hoverState === Re ? e._hoverState = Re : (clearTimeout(e._timeout), e._hoverState = Re, e.config.delay && e.config.delay.show ? e._timeout = setTimeout(function() {
                e._hoverState === Re && e.show();
            }, e.config.delay.show) : e.show());
        }, e._leave = function(t, e) {
            var n = this.constructor.DATA_KEY;
            (e = e || i.default(t.currentTarget).data(n)) || (e = new this.constructor(t.currentTarget, this._getDelegateConfig()), i.default(t.currentTarget).data(n, e)), t && (e._activeTrigger["focusout" === t.type ? Me : He] = !1), e._isWithActiveTrigger() || (clearTimeout(e._timeout), e._hoverState = Be, e.config.delay && e.config.delay.hide ? e._timeout = setTimeout(function() {
                e._hoverState === Be && e.hide();
            }, e.config.delay.hide) : e.hide());
        }, e._isWithActiveTrigger = function() {
            for(var t in this._activeTrigger)if (this._activeTrigger[t]) return !0;
            return !1;
        }, e._getConfig = function(t) {
            var e = i.default(this.element).data();
            return Object.keys(e).forEach(function(t) {
                -1 !== Le.indexOf(t) && delete e[t];
            }), "number" == typeof (t = a({}, this.constructor.Default, e, "object" == typeof t && t ? t : {})).delay && (t.delay = {
                show: t.delay,
                hide: t.delay
            }), "number" == typeof t.title && (t.title = t.title.toString()), "number" == typeof t.content && (t.content = t.content.toString()), u.typeCheckConfig(Ie, t, this.constructor.DefaultType), t.sanitize && (t.template = ke(t.template, t.whiteList, t.sanitizeFn)), t;
        }, e._getDelegateConfig = function() {
            var t = {};
            if (this.config) for(var e in this.config)this.constructor.Default[e] !== this.config[e] && (t[e] = this.config[e]);
            return t;
        }, e._cleanTipClass = function() {
            var t = i.default(this.getTipElement()), e = t.attr("class").match(je);
            null !== e && e.length && t.removeClass(e.join(""));
        }, e._handlePopperPlacementChange = function(t) {
            this.tip = t.instance.popper, this._cleanTipClass(), this.addAttachmentClass(this._getAttachment(t.placement));
        }, e._fixTransition = function() {
            var t = this.getTipElement(), e = this.config.animation;
            null === t.getAttribute("x-placement") && (i.default(t).removeClass(Pe), this.config.animation = !1, this.hide(), this.show(), this.config.animation = e);
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(Oe), r = "object" == typeof e && e;
                if ((o || !/dispose|hide/.test(e)) && (o || (o = new t(this, r), n.data(Oe, o)), "string" == typeof e)) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return Qe;
                }
            },
            {
                key: "NAME",
                get: function() {
                    return Ie;
                }
            },
            {
                key: "DATA_KEY",
                get: function() {
                    return Oe;
                }
            },
            {
                key: "Event",
                get: function() {
                    return Ue;
                }
            },
            {
                key: "EVENT_KEY",
                get: function() {
                    return ".bs.tooltip";
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return We;
                }
            }
        ]), t;
    }();
    i.default.fn.tooltip = Ve._jQueryInterface, i.default.fn.tooltip.Constructor = Ve, i.default.fn.tooltip.noConflict = function() {
        return i.default.fn.tooltip = xe, Ve._jQueryInterface;
    };
    var Ye = "bs.popover", ze = i.default.fn.popover, Ke = new RegExp("(^|\\s)bs-popover\\S+", "g"), Xe = a({}, Ve.Default, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    }), Ge = a({}, Ve.DefaultType, {
        content: "(string|element|function)"
    }), $e = {
        HIDE: "hide.bs.popover",
        HIDDEN: "hidden.bs.popover",
        SHOW: "show.bs.popover",
        SHOWN: "shown.bs.popover",
        INSERTED: "inserted.bs.popover",
        CLICK: "click.bs.popover",
        FOCUSIN: "focusin.bs.popover",
        FOCUSOUT: "focusout.bs.popover",
        MOUSEENTER: "mouseenter.bs.popover",
        MOUSELEAVE: "mouseleave.bs.popover"
    }, Je = function(t) {
        var e, n;
        function o() {
            return t.apply(this, arguments) || this;
        }
        n = t, (e = o).prototype = Object.create(n.prototype), e.prototype.constructor = e, s(e, n);
        var a = o.prototype;
        return a.isWithContent = function() {
            return this.getTitle() || this._getContent();
        }, a.addAttachmentClass = function(t) {
            i.default(this.getTipElement()).addClass("bs-popover-" + t);
        }, a.getTipElement = function() {
            return this.tip = this.tip || i.default(this.config.template)[0], this.tip;
        }, a.setContent = function() {
            var t = i.default(this.getTipElement());
            this.setElementContent(t.find(".popover-header"), this.getTitle());
            var e = this._getContent();
            "function" == typeof e && (e = e.call(this.element)), this.setElementContent(t.find(".popover-body"), e), t.removeClass("fade show");
        }, a._getContent = function() {
            return this.element.getAttribute("data-content") || this.config.content;
        }, a._cleanTipClass = function() {
            var t = i.default(this.getTipElement()), e = t.attr("class").match(Ke);
            null !== e && e.length > 0 && t.removeClass(e.join(""));
        }, o._jQueryInterface = function(t) {
            return this.each(function() {
                var e = i.default(this).data(Ye), n = "object" == typeof t ? t : null;
                if ((e || !/dispose|hide/.test(t)) && (e || (e = new o(this, n), i.default(this).data(Ye, e)), "string" == typeof t)) {
                    if ("undefined" == typeof e[t]) throw new TypeError('No method named "' + t + '"');
                    e[t]();
                }
            });
        }, r(o, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return Xe;
                }
            },
            {
                key: "NAME",
                get: function() {
                    return "popover";
                }
            },
            {
                key: "DATA_KEY",
                get: function() {
                    return Ye;
                }
            },
            {
                key: "Event",
                get: function() {
                    return $e;
                }
            },
            {
                key: "EVENT_KEY",
                get: function() {
                    return ".bs.popover";
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return Ge;
                }
            }
        ]), o;
    }(Ve);
    i.default.fn.popover = Je._jQueryInterface, i.default.fn.popover.Constructor = Je, i.default.fn.popover.noConflict = function() {
        return i.default.fn.popover = ze, Je._jQueryInterface;
    };
    var Ze = "scrollspy", tn = "bs.scrollspy", en = i.default.fn[Ze], nn = "active", on = "position", rn = ".nav, .list-group", an = {
        offset: 10,
        method: "auto",
        target: ""
    }, sn = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    }, ln = function() {
        function t(t, e) {
            var n = this;
            this._element = t, this._scrollElement = "BODY" === t.tagName ? window : t, this._config = this._getConfig(e), this._selector = this._config.target + " .nav-link," + this._config.target + " .list-group-item," + this._config.target + " .dropdown-item", this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, i.default(this._scrollElement).on("scroll.bs.scrollspy", function(t) {
                return n._process(t);
            }), this.refresh(), this._process();
        }
        var e = t.prototype;
        return e.refresh = function() {
            var t = this, e = this._scrollElement === this._scrollElement.window ? "offset" : on, n = "auto" === this._config.method ? e : this._config.method, o = n === on ? this._getScrollTop() : 0;
            this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight(), [].slice.call(document.querySelectorAll(this._selector)).map(function(t) {
                var e, r = u.getSelectorFromElement(t);
                if (r && (e = document.querySelector(r)), e) {
                    var a = e.getBoundingClientRect();
                    if (a.width || a.height) return [
                        i.default(e)[n]().top + o,
                        r
                    ];
                }
                return null;
            }).filter(Boolean).sort(function(t, e) {
                return t[0] - e[0];
            }).forEach(function(e) {
                t._offsets.push(e[0]), t._targets.push(e[1]);
            });
        }, e.dispose = function() {
            i.default.removeData(this._element, tn), i.default(this._scrollElement).off(".bs.scrollspy"), this._element = null, this._scrollElement = null, this._config = null, this._selector = null, this._offsets = null, this._targets = null, this._activeTarget = null, this._scrollHeight = null;
        }, e._getConfig = function(t) {
            if ("string" != typeof (t = a({}, an, "object" == typeof t && t ? t : {})).target && u.isElement(t.target)) {
                var e = i.default(t.target).attr("id");
                e || (e = u.getUID(Ze), i.default(t.target).attr("id", e)), t.target = "#" + e;
            }
            return u.typeCheckConfig(Ze, t, sn), t;
        }, e._getScrollTop = function() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        }, e._getScrollHeight = function() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        }, e._getOffsetHeight = function() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        }, e._process = function() {
            var t = this._getScrollTop() + this._config.offset, e = this._getScrollHeight(), n = this._config.offset + e - this._getOffsetHeight();
            if (this._scrollHeight !== e && this.refresh(), t >= n) {
                var i = this._targets[this._targets.length - 1];
                this._activeTarget !== i && this._activate(i);
            } else {
                if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0) return this._activeTarget = null, void this._clear();
                for(var o = this._offsets.length; o--;)this._activeTarget !== this._targets[o] && t >= this._offsets[o] && ("undefined" == typeof this._offsets[o + 1] || t < this._offsets[o + 1]) && this._activate(this._targets[o]);
            }
        }, e._activate = function(t) {
            this._activeTarget = t, this._clear();
            var e = this._selector.split(",").map(function(e) {
                return e + '[data-target="' + t + '"],' + e + '[href="' + t + '"]';
            }), n = i.default([].slice.call(document.querySelectorAll(e.join(","))));
            n.hasClass("dropdown-item") ? (n.closest(".dropdown").find(".dropdown-toggle").addClass(nn), n.addClass(nn)) : (n.addClass(nn), n.parents(rn).prev(".nav-link, .list-group-item").addClass(nn), n.parents(rn).prev(".nav-item").children(".nav-link").addClass(nn)), i.default(this._scrollElement).trigger("activate.bs.scrollspy", {
                relatedTarget: t
            });
        }, e._clear = function() {
            [].slice.call(document.querySelectorAll(this._selector)).filter(function(t) {
                return t.classList.contains(nn);
            }).forEach(function(t) {
                return t.classList.remove(nn);
            });
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this).data(tn);
                if (n || (n = new t(this, "object" == typeof e && e), i.default(this).data(tn, n)), "string" == typeof e) {
                    if ("undefined" == typeof n[e]) throw new TypeError('No method named "' + e + '"');
                    n[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "Default",
                get: function() {
                    return an;
                }
            }
        ]), t;
    }();
    i.default(window).on("load.bs.scrollspy.data-api", function() {
        for(var t = [].slice.call(document.querySelectorAll('[data-spy="scroll"]')), e = t.length; e--;){
            var n = i.default(t[e]);
            ln._jQueryInterface.call(n, n.data());
        }
    }), i.default.fn[Ze] = ln._jQueryInterface, i.default.fn[Ze].Constructor = ln, i.default.fn[Ze].noConflict = function() {
        return i.default.fn[Ze] = en, ln._jQueryInterface;
    };
    var un = "bs.tab", fn = i.default.fn.tab, dn = "active", cn = "fade", hn = "show", pn = ".active", mn = "> li > .active", gn = function() {
        function t(t) {
            this._element = t;
        }
        var e = t.prototype;
        return e.show = function() {
            var t = this;
            if (!(this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && i.default(this._element).hasClass(dn) || i.default(this._element).hasClass("disabled") || this._element.hasAttribute("disabled"))) {
                var e, n, o = i.default(this._element).closest(".nav, .list-group")[0], r = u.getSelectorFromElement(this._element);
                if (o) {
                    var a = "UL" === o.nodeName || "OL" === o.nodeName ? mn : pn;
                    n = (n = i.default.makeArray(i.default(o).find(a)))[n.length - 1];
                }
                var s = i.default.Event("hide.bs.tab", {
                    relatedTarget: this._element
                }), l = i.default.Event("show.bs.tab", {
                    relatedTarget: n
                });
                if (n && i.default(n).trigger(s), i.default(this._element).trigger(l), !l.isDefaultPrevented() && !s.isDefaultPrevented()) {
                    r && (e = document.querySelector(r)), this._activate(this._element, o);
                    var f = function() {
                        var e = i.default.Event("hidden.bs.tab", {
                            relatedTarget: t._element
                        }), o = i.default.Event("shown.bs.tab", {
                            relatedTarget: n
                        });
                        i.default(n).trigger(e), i.default(t._element).trigger(o);
                    };
                    e ? this._activate(e, e.parentNode, f) : f();
                }
            }
        }, e.dispose = function() {
            i.default.removeData(this._element, un), this._element = null;
        }, e._activate = function(t, e, n) {
            var o = this, r = (!e || "UL" !== e.nodeName && "OL" !== e.nodeName ? i.default(e).children(pn) : i.default(e).find(mn))[0], a = n && r && i.default(r).hasClass(cn), s = function() {
                return o._transitionComplete(t, r, n);
            };
            if (r && a) {
                var l = u.getTransitionDurationFromElement(r);
                i.default(r).removeClass(hn).one(u.TRANSITION_END, s).emulateTransitionEnd(l);
            } else s();
        }, e._transitionComplete = function(t, e, n) {
            if (e) {
                i.default(e).removeClass(dn);
                var o = i.default(e.parentNode).find("> .dropdown-menu .active")[0];
                o && i.default(o).removeClass(dn), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !1);
            }
            i.default(t).addClass(dn), "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !0), u.reflow(t), t.classList.contains(cn) && t.classList.add(hn);
            var r = t.parentNode;
            if (r && "LI" === r.nodeName && (r = r.parentNode), r && i.default(r).hasClass("dropdown-menu")) {
                var a = i.default(t).closest(".dropdown")[0];
                if (a) {
                    var s = [].slice.call(a.querySelectorAll(".dropdown-toggle"));
                    i.default(s).addClass(dn);
                }
                t.setAttribute("aria-expanded", !0);
            }
            n && n();
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(un);
                if (o || (o = new t(this), n.data(un, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e]();
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            }
        ]), t;
    }();
    i.default(document).on("click.bs.tab.data-api", '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]', function(t) {
        t.preventDefault(), gn._jQueryInterface.call(i.default(this), "show");
    }), i.default.fn.tab = gn._jQueryInterface, i.default.fn.tab.Constructor = gn, i.default.fn.tab.noConflict = function() {
        return i.default.fn.tab = fn, gn._jQueryInterface;
    };
    var _n = "bs.toast", vn = i.default.fn.toast, bn = "hide", yn = "show", En = "showing", wn = "click.dismiss.bs.toast", Tn = {
        animation: !0,
        autohide: !0,
        delay: 500
    }, Cn = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    }, Sn = function() {
        function t(t, e) {
            this._element = t, this._config = this._getConfig(e), this._timeout = null, this._setListeners();
        }
        var e = t.prototype;
        return e.show = function() {
            var t = this, e = i.default.Event("show.bs.toast");
            if (i.default(this._element).trigger(e), !e.isDefaultPrevented()) {
                this._clearTimeout(), this._config.animation && this._element.classList.add("fade");
                var n = function() {
                    t._element.classList.remove(En), t._element.classList.add(yn), i.default(t._element).trigger("shown.bs.toast"), t._config.autohide && (t._timeout = setTimeout(function() {
                        t.hide();
                    }, t._config.delay));
                };
                if (this._element.classList.remove(bn), u.reflow(this._element), this._element.classList.add(En), this._config.animation) {
                    var o = u.getTransitionDurationFromElement(this._element);
                    i.default(this._element).one(u.TRANSITION_END, n).emulateTransitionEnd(o);
                } else n();
            }
        }, e.hide = function() {
            if (this._element.classList.contains(yn)) {
                var t = i.default.Event("hide.bs.toast");
                i.default(this._element).trigger(t), t.isDefaultPrevented() || this._close();
            }
        }, e.dispose = function() {
            this._clearTimeout(), this._element.classList.contains(yn) && this._element.classList.remove(yn), i.default(this._element).off(wn), i.default.removeData(this._element, _n), this._element = null, this._config = null;
        }, e._getConfig = function(t) {
            return t = a({}, Tn, i.default(this._element).data(), "object" == typeof t && t ? t : {}), u.typeCheckConfig("toast", t, this.constructor.DefaultType), t;
        }, e._setListeners = function() {
            var t = this;
            i.default(this._element).on(wn, '[data-dismiss="toast"]', function() {
                return t.hide();
            });
        }, e._close = function() {
            var t = this, e = function() {
                t._element.classList.add(bn), i.default(t._element).trigger("hidden.bs.toast");
            };
            if (this._element.classList.remove(yn), this._config.animation) {
                var n = u.getTransitionDurationFromElement(this._element);
                i.default(this._element).one(u.TRANSITION_END, e).emulateTransitionEnd(n);
            } else e();
        }, e._clearTimeout = function() {
            clearTimeout(this._timeout), this._timeout = null;
        }, t._jQueryInterface = function(e) {
            return this.each(function() {
                var n = i.default(this), o = n.data(_n);
                if (o || (o = new t(this, "object" == typeof e && e), n.data(_n, o)), "string" == typeof e) {
                    if ("undefined" == typeof o[e]) throw new TypeError('No method named "' + e + '"');
                    o[e](this);
                }
            });
        }, r(t, null, [
            {
                key: "VERSION",
                get: function() {
                    return "4.6.2";
                }
            },
            {
                key: "DefaultType",
                get: function() {
                    return Cn;
                }
            },
            {
                key: "Default",
                get: function() {
                    return Tn;
                }
            }
        ]), t;
    }();
    i.default.fn.toast = Sn._jQueryInterface, i.default.fn.toast.Constructor = Sn, i.default.fn.toast.noConflict = function() {
        return i.default.fn.toast = vn, Sn._jQueryInterface;
    }, t.Alert = c, t.Button = b, t.Carousel = O, t.Collapse = W, t.Dropdown = le, t.Modal = Se, t.Popover = Je, t.Scrollspy = ln, t.Tab = gn, t.Toast = Sn, t.Tooltip = Ve, t.Util = u, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});

},{"4967ad770d25ef1c":"2Z9Ua"}],"2Z9Ua":[function(require,module,exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : this, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

},{}],"5WmNB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>JobMobileCard);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _jobMobileDetailsModal = require("./JobMobileDetailsModal");
var _jobMobileDetailsModalDefault = parcelHelpers.interopDefault(_jobMobileDetailsModal);
const STATUS_DISPLAY_MAP = new Map([
    [
        "COMPLETED",
        {
            text: "Complete",
            icon: (0, _freeSolidSvgIcons.faCircle),
            colorClass: "alert-confirmation"
        }
    ],
    [
        "FAILED",
        {
            text: "Failed",
            icon: (0, _freeSolidSvgIcons.faCircle),
            colorClass: "active-dm"
        }
    ],
    [
        "MESSAGE_SENT",
        {
            text: "Message Sent",
            icon: (0, _freeSolidSvgIcons.faCircleNotch),
            colorClass: "in-progress-yellow"
        }
    ],
    [
        "RUNNING",
        {
            text: "Running",
            icon: (0, _freeSolidSvgIcons.faCircleNotch),
            colorClass: "in-progress-yellow"
        }
    ],
    [
        "PENDING",
        {
            text: "Pending",
            icon: (0, _freeSolidSvgIcons.faArrowCircleRight),
            colorClass: "text-dark"
        }
    ]
]);
function JobMobileCard({ job }) {
    const [showDetailsModal, toggleDetailsModal] = (0, _react.useState)(false);
    const { text, icon, colorClass } = STATUS_DISPLAY_MAP.get(job?.status) || {};
    const border = job?.status === "PENDING" ? "border-background-gray" : `border-${colorClass}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3681915750 " + `card col-12 mb-3 d-md-none border ${border}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-3681915750 card-body",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h6", {
                        className: "jsx-3681915750 text-gray",
                        children: job?.jobName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-3681915750 " + `d-flex align-items-center three-quarter-text text-${colorClass}`,
                        children: [
                            icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: icon,
                                size: "xs"
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-3681915750 ml-2",
                                children: text
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-3681915750 mt-3 d-flex align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>toggleDetailsModal(!showDetailsModal),
                            className: "jsx-3681915750 btn btn-outline-third-gray rounded-pill three-quarter-text px-5 py-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-3681915750 text-text-gray",
                                children: "Details"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jobMobileDetailsModalDefault.default), {
                isOpen: showDetailsModal,
                toggleModal: toggleDetailsModal,
                job: job
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3681915750",
                children: ".card.jsx-3681915750{border-width:medium !important;}"
            })
        ]
    });
}
JobMobileCard.propTypes = {
    job: (0, _propTypesDefault.default).shape({
        commandId: (0, _propTypesDefault.default).string,
        createdAt: (0, _propTypesDefault.default).string,
        email: (0, _propTypesDefault.default).string,
        gatewayId: (0, _propTypesDefault.default).string,
        jobCommand: (0, _propTypesDefault.default).string,
        jobMessage: (0, _propTypesDefault.default).string,
        jobName: (0, _propTypesDefault.default).string,
        status: (0, _propTypesDefault.default).oneOf([
            "COMPLETED",
            "FAILED",
            "MESSAGE_SENT",
            "RUNNING",
            "PENDING"
        ]),
        templateId: (0, _propTypesDefault.default).string,
        updatedAt: (0, _propTypesDefault.default).string
    })
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./JobMobileDetailsModal":"1bEvt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bEvt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>JobMobileDetailsModal);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const JOB_STATUS_CLASS_MAP = new Map([
    [
        "COMPLETED",
        {
            text: "alert-confirmation",
            background: "rgba(116, 209, 125, 0.24)"
        }
    ],
    [
        "FAILED",
        {
            text: "active-dm",
            background: "rgba(222, 71, 58, 0.24)"
        }
    ],
    [
        "MESSAGE_SENT",
        {
            text: "in-progress-yellow",
            background: "rgba(196, 146, 33, 0.24)"
        }
    ],
    [
        "RUNNING",
        {
            text: "in-progress-yellow"
        }
    ],
    [
        "PENDING",
        {
            text: "text-dark"
        }
    ]
]);
const STATUS_DISPLAY_MAP = new Map([
    [
        "COMPLETED",
        "Complete"
    ],
    [
        "FAILED",
        "Failed"
    ],
    [
        "MESSAGE_SENT",
        "Message Sent"
    ],
    [
        "RUNNING",
        "Running"
    ],
    [
        "PENDING",
        "Pending"
    ]
]);
function JobMobileDetailsModal({ job, isOpen, toggleModal }) {
    const { jobName, jobMessage, jobCommand, updatedAt, email, status } = job;
    const { text, background } = JOB_STATUS_CLASS_MAP.get(status) || {};
    const pillHasBackground = [
        "COMPLETED",
        "FAILED",
        "MESSAGE_SENT"
    ].includes(status);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        contentClassName: "h-100 mh-100 w-100 border-0 rounded-0",
        className: "m-0 h-100 mh-100",
        scrollable: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + "font-weight-bolder mt-3 mb-4",
                        children: "Command Details"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "mb-2 text-text-dark",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "text-gray",
                                children: jobName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + `my-4 command-status-pill rounded-pill text-${text} ${pillHasBackground ? "" : `border border-${text} bg-transparent`} three-quarter-text d-inline py-1 px-3`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faCircle),
                                className: "mr-2",
                                size: "xs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]),
                                children: STATUS_DISPLAY_MAP.get(status)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "mb-2 text-text-dark",
                                children: "Date"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]),
                                children: (()=>{
                                    switch(status){
                                        case "PENDING":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faArrowCircleRight),
                                                className: "text-text-dark",
                                                size: "lg"
                                            });
                                        case "RUNNING":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                className: "text-in-progress-yellow",
                                                size: "lg"
                                            });
                                        case "MESSAGE_SENT":
                                        case "COMPLETED":
                                        case "FAILED":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "1245537639",
                                                        [
                                                            pillHasBackground ? background : ""
                                                        ]
                                                    ]
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "1245537639",
                                                                [
                                                                    pillHasBackground ? background : ""
                                                                ]
                                                            ]
                                                        ]) + " " + `font-weight-bolder ${status === "COMPLETED" ? "text-text-dark" : `text-${text}`}`,
                                                        children: `${(0, _momentDefault.default)(updatedAt).toNow(true)} ago`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: (0, _styleDefault.default).dynamic([
                                                            [
                                                                "1245537639",
                                                                [
                                                                    pillHasBackground ? background : ""
                                                                ]
                                                            ]
                                                        ]) + " " + `ml-2 ${status === "COMPLETED" ? "text-text-light-gray" : `text-${text}`}`,
                                                        children: (0, _momentDefault.default)(updatedAt).format("MMM Do - h:mma")
                                                    })
                                                ]
                                            });
                                        default:
                                            return null;
                                    }
                                })()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "mb-2 text-text-dark",
                                children: "Fired by"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "text-text-light-gray",
                                children: email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + "my-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "mb-2 text-text-dark",
                                children: "Command"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "text-text-light-gray",
                                children: jobCommand
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + "mt-4 nine-tenth-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]) + " " + "mb-2 text-text-dark",
                                children: "Response"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _styleDefault.default).dynamic([
                                    [
                                        "1245537639",
                                        [
                                            pillHasBackground ? background : ""
                                        ]
                                    ]
                                ]),
                                children: (()=>{
                                    switch(status){
                                        case "COMPLETED":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "1245537639",
                                                        [
                                                            pillHasBackground ? background : ""
                                                        ]
                                                    ]
                                                ]) + " " + "text-text-light-gray",
                                                children: jobMessage || "success"
                                            });
                                        case "FAILED":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "1245537639",
                                                        [
                                                            pillHasBackground ? background : ""
                                                        ]
                                                    ]
                                                ]) + " " + "text-text-light-gray",
                                                children: jobMessage || "failed"
                                            });
                                        case "PENDING":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faArrowCircleRight),
                                                className: "text-text-dark",
                                                size: "lg"
                                            });
                                        case "MESSAGE_SENT":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: (0, _styleDefault.default).dynamic([
                                                    [
                                                        "1245537639",
                                                        [
                                                            pillHasBackground ? background : ""
                                                        ]
                                                    ]
                                                ]) + " " + "text-text-light-gray",
                                                children: jobMessage || "message sent"
                                            });
                                        case "RUNNING":
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                className: "text-in-progress-yellow",
                                                size: "lg"
                                            });
                                        default:
                                            return null;
                                    }
                                })()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: ()=>toggleModal(!isOpen),
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "1245537639",
                            [
                                pillHasBackground ? background : ""
                            ]
                        ]
                    ]) + " " + "btn btn-outline-text-light-gray py-1 px-4 three-quarter-text",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _styleDefault.default).dynamic([
                            [
                                "1245537639",
                                [
                                    pillHasBackground ? background : ""
                                ]
                            ]
                        ]) + " " + "text-text-gray",
                        children: "Close"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1245537639",
                dynamic: [
                    pillHasBackground ? background : ""
                ],
                children: `.command-status-pill.__jsx-style-dynamic-selector{background-color:${pillHasBackground ? background : ""};}`
            })
        ]
    });
}
JobMobileDetailsModal.propTypes = {
    job: (0, _propTypesDefault.default).shape({
        commandId: (0, _propTypesDefault.default).string,
        createdAt: (0, _propTypesDefault.default).string,
        email: (0, _propTypesDefault.default).string,
        gatewayId: (0, _propTypesDefault.default).string,
        jobCommand: (0, _propTypesDefault.default).string,
        jobMessage: (0, _propTypesDefault.default).string,
        jobName: (0, _propTypesDefault.default).string,
        status: (0, _propTypesDefault.default).oneOf([
            "COMPLETED",
            "FAILED",
            "MESSAGE_SENT",
            "RUNNING",
            "PENDING"
        ]),
        templateId: (0, _propTypesDefault.default).string,
        updatedAt: (0, _propTypesDefault.default).string
    }),
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};
JobMobileDetailsModal.defaultProps = {
    job: {}
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","moment":"1e4qG","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GPPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MobileRulesFiltersModal);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const { className, styles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1935516619",
        children: ".modal-dialog.jsx-1935516619{margin-top:75px;}"
    }),
    className: "jsx-1935516619"
};
function MobileRulesFiltersModal(props) {
    const { isOpen, toggleModal, searchTerm, handleSearch, resource } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        toggle: ()=>toggleModal(!isOpen),
        className: className,
        backdropClassName: "bg-transparent",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "input-group input-group-sm",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "input-group-prepend",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "input-group-text",
                                id: "searchByNameIcon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn btn-link p-0 text-reset",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: "text-text-light-gray",
                                        icon: (0, _freeSolidSvgIcons.faSearch),
                                        size: "sm"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            value: searchTerm,
                            onChange: handleSearch,
                            className: "form-control",
                            "aria-label": `Search by ${resource} Name`,
                            "aria-describedby": "searchByNameIcon",
                            placeholder: `search by ${resource} name`
                        })
                    ]
                })
            }),
            styles
        ]
    });
}
MobileRulesFiltersModal.propTypes = {
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    searchTerm: (0, _propTypesDefault.default).string,
    handleSearch: (0, _propTypesDefault.default).func,
    resource: (0, _propTypesDefault.default).oneOf([
        "rule",
        "job",
        "asset"
    ])
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jhZsi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetValidationErrorsContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _validationErrorsService = require("../../Services/ValidationErrorsService");
var _validationErrorsServiceDefault = parcelHelpers.interopDefault(_validationErrorsService);
var _assetValidationErrorsDisplay = require("./AssetValidationErrorsDisplay");
var _assetValidationErrorsDisplayDefault = parcelHelpers.interopDefault(_assetValidationErrorsDisplay);
const initState = {
    dataLoading: true,
    data: [],
    error: ""
};
function AssetValidationErrorsContainer(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const [error, setError] = (0, _react.useState)("");
    const { asset: { _id: assetID = "" } = {} } = props;
    let source = (0, _axios.CancelToken).source();
    const validationErrorsService = new (0, _validationErrorsServiceDefault.default)();
    const updateValidationErrorsState = async ()=>{
        try {
            updateState({
                ...state,
                dataLoading: true
            });
            const { errors: data = [] } = await validationErrorsService.fetchValidationErrors(assetID, {}, source.token);
            updateState({
                ...state,
                data,
                dataLoading: false
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            setError(err.response?.data?.message ?? err.message);
            updateState({
                ...state,
                dataLoading: false
            });
        }
    };
    (0, _react.useEffect)(()=>{
        if (!assetID) return;
        source = (0, _axios.CancelToken).source();
        updateValidationErrorsState();
        return source.cancel;
    }, [
        assetID
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetValidationErrorsDisplayDefault.default), {
        ...props,
        ...state,
        tab: "validationErrors",
        error: error,
        setError: setError,
        dataLoading: state.dataLoading
    });
}
AssetValidationErrorsContainer.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string
    })
};
AssetValidationErrorsContainer.defaultProps = {
    asset: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/ValidationErrorsService":"3kcSl","./AssetValidationErrorsDisplay":"gNPAr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kcSl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class ValidationErrorsService {
    api = new (0, _requestsDefault.default)();
    buildValidationErrorsRequest(gatewayID, params, cancelToken) {
        return {
            service: "gateway",
            endpoint: `/gateway/${gatewayID}/error`,
            method: "get",
            params,
            cancelToken
        };
    }
    async fetchValidationErrors(gatewayID, params, cancelToken) {
        const { data } = await this.api.request(this.buildValidationErrorsRequest(gatewayID, params, cancelToken));
        return data;
    }
}
exports.default = ValidationErrorsService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gNPAr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetValidationErrorsDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function AssetValidationErrorsDisplay(props) {
    const { data, dataLoading } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "position-absolute h-100 w-100 bg-white rounded-lg px-3 py-2 d-flex flex-column",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "h-100 w-100 overflow-auto",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            className: "sticky-top bg-white",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "border-top-0",
                                    children: "Timestamp"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "border-top-0",
                                    children: "Message"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        className: dataLoading || !data.length ? "d-none" : "",
                        children: data.map((e)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: new Date(e.timestamp).toISOString()
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        children: e.message
                                    })
                                ]
                            }, e.timestamp);
                        })
                    })
                ]
            })
        })
    });
}
AssetValidationErrorsDisplay.propTypes = {
    tab: (0, _propTypesDefault.default).string,
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    error: (0, _propTypesDefault.default).string,
    dataLoading: (0, _propTypesDefault.default).bool,
    sort: (0, _propTypesDefault.default).shape({
        by: (0, _propTypesDefault.default).oneOf([
            "Timestamp"
        ]),
        order: (0, _propTypesDefault.default).oneOf([
            "asc",
            "desc"
        ])
    })
};
AssetValidationErrorsDisplay.defaultProps = {
    data: [],
    sort: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"njLMH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _assetV2MaintenanceTabDisplay = require("./AssetV2MaintenanceTabDisplay");
var _assetV2MaintenanceTabDisplayDefault = parcelHelpers.interopDefault(_assetV2MaintenanceTabDisplay);
var _gatewayReminderInstances = require("../../Constants/GatewayReminderInstances");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _useDebounce = require("../../Hooks/useDebounce");
var _useDebounceDefault = parcelHelpers.interopDefault(_useDebounce);
var _gatewayReminderInstance = require("../../Lib/GatewayReminderInstance");
var _gtemplate = require("../../Lib/Gtemplate");
var _gatewayReminderInstanceService = require("../../Services/GatewayReminderInstanceService");
var _gatewayReminderInstanceServiceDefault = parcelHelpers.interopDefault(_gatewayReminderInstanceService);
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetV2MaintenanceTabContainer);
const initState = {
    checkedInstances: new Map(),
    count: 0,
    due: 0,
    dueInstances: new Map(),
    error: "",
    gateway_id: "",
    gateway_reminder_instance_id: "",
    instances: [],
    instancesLoading: true,
    page: 1,
    reminder_name: "",
    showCompleteMaintenanceModal: false,
    showMobileFilters: false,
    showUpdateServiceValuesModal: false,
    upcoming: 0,
    upcomingInstances: new Map()
}, limit = 20;
function AssetV2MaintenanceTabContainer(props) {
    const { _id: gateway_id, gtemplate, shadow } = props.asset, api = (0, _react.useMemo)(()=>new (0, _gatewayReminderInstanceServiceDefault.default)(), []), [state, updateState] = (0, _react.useState)(initState), pages = (0, _react.useMemo)(()=>Math.ceil(state.count / limit), [
        state.count
    ]), debouncedReminderName = (0, _useDebounceDefault.default)(state.reminder_name, 1000), signalUnitMap = (0, _gtemplate.generateSignalUnitMap)(gtemplate);
    const shadowValueBySignalIdMap = (0, _react.useMemo)(()=>shadow?.signalCollections?.reduce?.((map, col)=>{
            if (!Array.isArray(col?.signals) || !col?.signals?.length) return map;
            return col.signals.reduce((acc, s)=>acc.set(s._id, s.value), map);
        }, new Map()) ?? new Map(), [
        shadow
    ]);
    const instanceShadowValueMap = (0, _react.useMemo)(()=>{
        const now = Date.now();
        return state.instances?.reduce?.((map, instance)=>{
            switch(instance.GtemplateReminder.type){
                case 0, _gtemplateReminder.ALL_TYPE:
                    {
                        const calendarProps = (0, _gatewayReminderInstance.generateCalendarTypeProps)(instance, now);
                        const signalProps = (0, _gatewayReminderInstance.generateSignalTypeProps)(instance, shadowValueBySignalIdMap);
                        return map.set(instance._id, {
                            ...calendarProps,
                            ...signalProps
                        });
                    }
                case 0, _gtemplateReminder.CALENDAR_TYPE:
                    return map.set(instance._id, (0, _gatewayReminderInstance.generateCalendarTypeProps)(instance, now));
                case 0, _gtemplateReminder.SIGNAL_TYPE:
                    return map.set(instance._id, (0, _gatewayReminderInstance.generateSignalTypeProps)(instance, shadowValueBySignalIdMap));
                default:
                    break;
            }
            return map;
        }, new Map()) ?? new Map();
    }, [
        shadowValueBySignalIdMap,
        state.instances
    ]);
    const handleClearFiltersClick = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                reminder_name: ""
            }));
    }, []);
    const handleCompleteMaintenanceSuccess = async ()=>{
        try {
            props.showCompleteMaintenanceSuccessAlert();
            updateState(initState);
            const params = {
                gateway_id,
                limit,
                page: state.page,
                reminder_name: debouncedReminderName
            };
            const { count, data, due, page, upcoming } = await api.getPaginatedGatewayReminderInstances(params);
            const dueAndUpcomingInstances = data.reduce((acc, instance)=>{
                if (!instance?.MaintenanceNotifications?.length) return acc;
                switch(instance?.MaintenanceNotifications?.[0]?.status){
                    case 0, _gatewayReminderInstances.DUE:
                        acc.dueInstances.set(instance._id, instance);
                        return acc;
                    case 0, _gatewayReminderInstances.UPCOMING:
                        acc.upcomingInstances.set(instance._id, instance);
                        return acc;
                    default:
                        return acc;
                }
            }, {
                dueInstances: new Map(),
                upcomingInstances: new Map()
            });
            updateState((prevState)=>({
                    ...prevState,
                    ...dueAndUpcomingInstances,
                    count,
                    due,
                    instances: data,
                    instancesLoading: false,
                    page,
                    upcoming
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    instancesLoading: false
                }));
        }
    };
    const handleUpdateServiceValuesSuccess = async ()=>{
        try {
            props.showUpdateMaintenanceServiceValuesSuccessAlert();
            updateState(initState);
            const params = {
                gateway_id,
                limit,
                page: state.page,
                reminder_name: debouncedReminderName
            };
            const { count, data, due, page, upcoming } = await api.getPaginatedGatewayReminderInstances(params);
            const dueAndUpcomingInstances = data.reduce((acc, instance)=>{
                if (!instance?.MaintenanceNotifications?.length) return acc;
                switch(instance?.MaintenanceNotifications?.[0]?.status){
                    case 0, _gatewayReminderInstances.DUE:
                        acc.dueInstances.set(instance._id, instance);
                        return acc;
                    case 0, _gatewayReminderInstances.UPCOMING:
                        acc.upcomingInstances.set(instance._id, instance);
                        return acc;
                    default:
                        return acc;
                }
            }, {
                dueInstances: new Map(),
                upcomingInstances: new Map()
            });
            updateState((prevState)=>({
                    ...prevState,
                    ...dueAndUpcomingInstances,
                    count,
                    due,
                    instances: data,
                    instancesLoading: false,
                    page,
                    upcoming
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    instancesLoading: false
                }));
        }
    };
    const handleInstanceChecked = (0, _react.useCallback)(([id, instance])=>{
        updateState((prevState)=>{
            const checkedInstances = new Map(prevState.checkedInstances);
            if (checkedInstances.has(id)) checkedInstances.delete(id);
            else checkedInstances.set(id, instance);
            return {
                ...prevState,
                checkedInstances
            };
        });
    }, []);
    const handlePageChange = (0, _react.useCallback)((page)=>{
        if (page === state.page) return;
        updateState((prevState)=>({
                ...prevState,
                page
            }));
    }, [
        state.page
    ]);
    const handleSelectAllInstances = (0, _react.useCallback)(()=>{
        updateState((prevState)=>{
            const allChecked = prevState.checkedInstances.size === prevState.instances.length;
            const checkedInstances = allChecked ? new Map() : new Map(prevState.instances.map((instance)=>[
                    instance._id,
                    instance
                ]));
            return {
                ...prevState,
                checkedInstances
            };
        });
    }, []);
    const handleStatePropUpdate = (0, _react.useCallback)(({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    }, []);
    const toggleCompleteMaintenanceModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showCompleteMaintenanceModal: !prevState.showCompleteMaintenanceModal
            }));
    }, []), toggleHistoryModal = (0, _react.useCallback)(({ gateway_id = "", gateway_reminder_instance_id = "" } = {})=>{
        updateState((prevState)=>({
                ...prevState,
                gateway_id,
                gateway_reminder_instance_id
            }));
    }, []), toggleMobileFilters = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showMobileFilters: !prevState.showMobileFilters
            }));
    }, []), toggleUpdateServiceValuesModal = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                showUpdateServiceValuesModal: !prevState.showUpdateServiceValuesModal
            }));
    }, []);
    (0, _react.useEffect)(()=>{
        updateState((prevState)=>({
                ...prevState,
                instances: [],
                instancesLoading: true
            }));
        const source = (0, _axios.CancelToken).source();
        async function fetchGatewayInstances() {
            try {
                const params = {
                    gateway_id,
                    limit,
                    page: state.page,
                    reminder_name: debouncedReminderName
                };
                const { count, data, due, page, upcoming } = await api.getPaginatedGatewayReminderInstances(params);
                const dueAndUpcomingInstances = data.reduce((acc, instance)=>{
                    if (!instance?.MaintenanceNotifications?.length) return acc;
                    switch(instance?.MaintenanceNotifications?.[0]?.status){
                        case 0, _gatewayReminderInstances.DUE:
                            acc.dueInstances.set(instance._id, instance);
                            return acc;
                        case 0, _gatewayReminderInstances.UPCOMING:
                            acc.upcomingInstances.set(instance._id, instance);
                            return acc;
                        default:
                            return acc;
                    }
                }, {
                    dueInstances: new Map(),
                    upcomingInstances: new Map()
                });
                updateState((prevState)=>({
                        ...prevState,
                        ...dueAndUpcomingInstances,
                        count,
                        due,
                        instances: data,
                        instancesLoading: false,
                        page,
                        showMobileFilters: false,
                        upcoming
                    }));
            } catch (err) {
                if ((0, _axios.isCancel)(err)) return;
                const error = err.response?.data?.message ?? err.message;
                updateState((prevState)=>({
                        ...prevState,
                        error,
                        instancesLoading: false,
                        showMobileFilters: false
                    }));
            }
        }
        fetchGatewayInstances();
        return ()=>{
            source.cancel();
        };
    }, [
        api,
        debouncedReminderName,
        gateway_id,
        state.page
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetV2MaintenanceTabDisplayDefault.default), {
        ...state,
        assetNickname: props.asset?.nickname,
        handleClearFiltersClick: handleClearFiltersClick,
        handleCompleteMaintenanceSuccess: handleCompleteMaintenanceSuccess,
        handleInstanceChecked: handleInstanceChecked,
        handlePageChange: handlePageChange,
        handleSelectAllInstances: handleSelectAllInstances,
        handleStatePropUpdate: handleStatePropUpdate,
        handleUpdateServiceValuesSuccess: handleUpdateServiceValuesSuccess,
        instanceShadowValueMap: instanceShadowValueMap,
        orgID: props.asset?.orgID,
        pages: pages,
        shadowValueBySignalIdMap: shadowValueBySignalIdMap,
        signalUnitMap: signalUnitMap,
        toggleCompleteMaintenanceModal: toggleCompleteMaintenanceModal,
        toggleHistoryModal: toggleHistoryModal,
        toggleMobileFilters: toggleMobileFilters,
        toggleUpdateServiceValuesModal: toggleUpdateServiceValuesModal
    });
}
AssetV2MaintenanceTabContainer.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplate: (0, _propTypesDefault.default).shape({
            sharedGtemplate: (0, _propTypesDefault.default).object
        }),
        nickname: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        shadow: (0, _propTypesDefault.default).shape({
            signalCollections: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                _id: (0, _propTypesDefault.default).string,
                signals: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
                    _id: (0, _propTypesDefault.default).string,
                    value: (0, _propTypesDefault.default).oneOfType([
                        (0, _propTypesDefault.default).number,
                        (0, _propTypesDefault.default).string
                    ])
                }))
            }))
        })
    }),
    showCompleteMaintenanceSuccessAlert: (0, _propTypesDefault.default).func,
    showUpdateMaintenanceServiceValuesSuccessAlert: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","./AssetV2MaintenanceTabDisplay":"aYdOo","../../Constants/GatewayReminderInstances":"cmyGT","../../Constants/GtemplateReminder":"kNNU0","../../Hooks/useDebounce":"1CzYf","../../Lib/GatewayReminderInstance":"gE5HX","../../Lib/Gtemplate":"eIfbT","../../Services/GatewayReminderInstanceService":"WwEop","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aYdOo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _assetV2MaintenanceMobileFiltersModal = require("./AssetV2MaintenanceMobileFiltersModal");
var _assetV2MaintenanceMobileFiltersModalDefault = parcelHelpers.interopDefault(_assetV2MaintenanceMobileFiltersModal);
var _completeMaintenanceModal = require("./CompleteMaintenanceModal");
var _completeMaintenanceModalDefault = parcelHelpers.interopDefault(_completeMaintenanceModal);
var _gatewayInstanceMaintenanceTable = require("./GatewayInstanceMaintenanceTable");
var _gatewayInstanceMaintenanceTableDefault = parcelHelpers.interopDefault(_gatewayInstanceMaintenanceTable);
var _gatewayInstanceMobileMaintenanceCard = require("./GatewayInstanceMobileMaintenanceCard");
var _gatewayInstanceMobileMaintenanceCardDefault = parcelHelpers.interopDefault(_gatewayInstanceMobileMaintenanceCard);
var _updateMaintenanceServiceValuesModal = require("./UpdateMaintenanceServiceValuesModal");
var _updateMaintenanceServiceValuesModalDefault = parcelHelpers.interopDefault(_updateMaintenanceServiceValuesModal);
var _viewMaintenanceHistoryModal = require("./ViewMaintenanceHistoryModal");
var _viewMaintenanceHistoryModalDefault = parcelHelpers.interopDefault(_viewMaintenanceHistoryModal);
var _loadingCircle = require("../LoadingCircle");
var _loadingCircleDefault = parcelHelpers.interopDefault(_loadingCircle);
var _noDataIndication = require("../NoDataIndication");
var _paginationFooter = require("../PaginationFooter");
var _paginationFooterDefault = parcelHelpers.interopDefault(_paginationFooter);
var _gatewayReminderInstances = require("../../Constants/GatewayReminderInstances");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _rbac = require("../../Constants/RBAC");
var _widthContext = require("../../Context/WidthContext");
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _zIndex = require("../../Styles/Z-INDEX");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetV2MaintenanceTabDisplay);
function AssetV2MaintenanceTabDisplay(props) {
    const { assetID } = (0, _reactRouterDom.useParams)(), showEmptyState = (0, _react.useMemo)(()=>!props.instances.length && !props.error && !props.reminder_name, [
        props.error,
        props.instances.length,
        props.reminder_name
    ]), showHistoryModal = (0, _react.useMemo)(()=>!!props.gateway_id || !!props.gateway_reminder_instance_id, [
        props.gateway_id,
        props.gateway_reminder_instance_id
    ]), width = (0, _react.useContext)((0, _widthContext.Width));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "d-lg-none btn btn-link p-0 shadow-none text-decoration-none position-absolute",
                onClick: props.toggleMobileFilters,
                style: {
                    right: "0.5rem",
                    top: "-5.7rem",
                    zIndex: (0, _zIndex.STICKY_OVERRIDE)
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    className: "text-brand-primary",
                    icon: (0, _freeSolidSvgIcons.faSlidersH),
                    size: "lg"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "position-absolute overflow-auto h-100 w-100 bg-white rounded-lg d-flex flex-column p-2 p-lg-3 px-lg-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center justify-content-between justify-content-lg-start",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "d-flex flex-lg-column align-items-center align-items-lg-start",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                        className: "text-danger mb-0 mb-lg-3",
                                        children: props.instancesLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faMinus)
                                        }) : props.due
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-muted nine-tenth-text mb-0 mb-lg-3 ml-3 ml-lg-0",
                                        children: "Reminder Overdue"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "d-flex flex-lg-column ml-lg-4 align-items-center align-items-lg-start",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                        className: "text-warning mb-0 mb-lg-3",
                                        children: props.instancesLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faMinus)
                                        }) : props.upcoming
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-muted nine-tenth-text mb-0 mb-lg-3 ml-3 ml-lg-0",
                                        children: "Reminder Upcoming"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-fill d-flex flex-column",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "w-100 d-flex align-items-center justify-content-between justify-content-lg-start my-2 my-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                        no: ()=>null,
                                        orgID: props.orgID,
                                        perform: (0, _rbac.MAINTENANCE_LOG_CREATE),
                                        resource: (0, _rbac.MAINTENANCE),
                                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn modal-button-primary three-quarter-text",
                                                disabled: props.instancesLoading || !props.checkedInstances?.size,
                                                onClick: props.toggleCompleteMaintenanceModal,
                                                children: "Complete Maintenance"
                                            })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn btn-outline-secondary three-quarter-text ml-lg-5",
                                        disabled: props.instancesLoading,
                                        onClick: ()=>props.toggleHistoryModal({
                                                gateway_id: assetID
                                            }),
                                        children: "View History"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                        no: ()=>null,
                                        orgID: props.orgID,
                                        perform: (0, _rbac.MAINTENANCE_MANAGE),
                                        resource: (0, _rbac.MAINTENANCE),
                                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn modal-button-primary three-quarter-text ml-auto",
                                                disabled: props.instancesLoading || !props.checkedInstances?.size,
                                                onClick: props.toggleUpdateServiceValuesModal,
                                                children: "Update Service Values"
                                            })
                                    })
                                ]
                            }),
                            props.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "w-100 mb-0 nine-tenth-text text-danger",
                                children: props.error
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-fill mt-2 position-relative",
                                children: (()=>{
                                    switch(true){
                                        case props.instancesLoading:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircleDefault.default), {
                                                size: "4x"
                                            });
                                        case !props.instances.length && props.error:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.NoItemsFound), {
                                                text: "There was an error fetching your data. Please contact an administrator if the problem persists."
                                            });
                                        case showEmptyState:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.NoItemsFound), {
                                                text: "No reminders for this asset."
                                            });
                                        default:
                                            return width > 991 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "position-absolute h-100 w-100 overflow-auto",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gatewayInstanceMaintenanceTableDefault.default), {
                                                    ...props
                                                })
                                            }) : props.instances?.map((instance, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "d-lg-none m-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gatewayInstanceMobileMaintenanceCardDefault.default), {
                                                        ...props,
                                                        instance: instance
                                                    })
                                                }, `${instance._id}-${i}`));
                                    }
                                })()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationFooterDefault.default), {
                        handlePageChange: props.handlePageChange,
                        page: props.page,
                        pages: props.pages,
                        rowsLength: props.instances?.length ?? 0,
                        rowsLoading: props.instancesLoading
                    }),
                    showHistoryModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _viewMaintenanceHistoryModalDefault.default), {
                        assetNickname: props.assetNickname,
                        gateway_id: props.gateway_id,
                        gateway_reminder_instance_id: props.gateway_reminder_instance_id,
                        isOpen: showHistoryModal,
                        signalUnitMap: props.signalUnitMap,
                        toggleModal: props.toggleHistoryModal
                    }) : null,
                    props.showCompleteMaintenanceModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completeMaintenanceModalDefault.default), {
                        checkedInstances: props.checkedInstances,
                        handleCompleteMaintenanceSuccess: props.handleCompleteMaintenanceSuccess,
                        instanceShadowValueMap: props.instanceShadowValueMap,
                        isOpen: props.showCompleteMaintenanceModal,
                        signalUnitMap: props.signalUnitMap,
                        toggleModal: props.toggleCompleteMaintenanceModal
                    }) : null,
                    props.showUpdateServiceValuesModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateMaintenanceServiceValuesModalDefault.default), {
                        checkedInstances: props.checkedInstances,
                        handleUpdateServiceValuesSuccess: props.handleUpdateServiceValuesSuccess,
                        instanceShadowValueMap: props.instanceShadowValueMap,
                        isOpen: props.showUpdateServiceValuesModal,
                        signalUnitMap: props.signalUnitMap,
                        toggleModal: props.toggleUpdateServiceValuesModal
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetV2MaintenanceMobileFiltersModalDefault.default), {
                        ...props,
                        isOpen: props.showMobileFilters,
                        toggleModal: ()=>props.toggleMobileFilters()
                    })
                ]
            })
        ]
    });
}
AssetV2MaintenanceTabDisplay.propTypes = {
    assetNickname: (0, _propTypesDefault.default).string,
    checkedInstances: (0, _propTypesDefault.default).object,
    count: (0, _propTypesDefault.default).number,
    due: (0, _propTypesDefault.default).number,
    error: (0, _propTypesDefault.default).string,
    gateway_id: (0, _propTypesDefault.default).string,
    gateway_reminder_instance_id: (0, _propTypesDefault.default).string,
    handleClearFiltersClick: (0, _propTypesDefault.default).func,
    handleCompleteMaintenanceSuccess: (0, _propTypesDefault.default).func,
    handlePageChange: (0, _propTypesDefault.default).func,
    handleStatePropUpdate: (0, _propTypesDefault.default).func,
    handleUpdateServiceValuesSuccess: (0, _propTypesDefault.default).func,
    instances: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        GtemplateReminder: (0, _propTypesDefault.default).shape({
            attachment: (0, _propTypesDefault.default).string,
            message: (0, _propTypesDefault.default).string,
            name: (0, _propTypesDefault.default).string,
            trigger_conditions: (0, _propTypesDefault.default).shape({
                calendar_trigger: (0, _propTypesDefault.default).shape({
                    interval: (0, _propTypesDefault.default).string,
                    margin: (0, _propTypesDefault.default).string
                }),
                signal_trigger: (0, _propTypesDefault.default).shape({
                    interval: (0, _propTypesDefault.default).number,
                    margin: (0, _propTypesDefault.default).number
                })
            }),
            type: (0, _propTypesDefault.default).oneOf((0, _gtemplateReminder.GTEMPLATE_REMINDER_TYPES))
        }),
        MaintenanceNotifications: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            maintenance_completed: (0, _propTypesDefault.default).bool,
            signal_value: (0, _propTypesDefault.default).string,
            status: (0, _propTypesDefault.default).oneOf((0, _gatewayReminderInstances.MAINTENANCE_NOTIFICATION_STATUSES)),
            MaintenanceHistoryLog: (0, _propTypesDefault.default).shape({
                contact_info: (0, _propTypesDefault.default).string,
                message: (0, _propTypesDefault.default).string,
                service_date: (0, _propTypesDefault.default).string,
                signal_value_when_serviced: (0, _propTypesDefault.default).string,
                user_id: (0, _propTypesDefault.default).string
            })
        })),
        next_signal_value_due: (0, _propTypesDefault.default).string,
        next_time_due: (0, _propTypesDefault.default).string
    })),
    instanceShadowValueMap: (0, _propTypesDefault.default).object,
    instancesLoading: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    page: (0, _propTypesDefault.default).number,
    pages: (0, _propTypesDefault.default).number,
    reminder_name: (0, _propTypesDefault.default).string,
    showCompleteMaintenanceModal: (0, _propTypesDefault.default).bool,
    showHistoryModal: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    showMobileFilters: (0, _propTypesDefault.default).bool,
    showUpdateServiceValuesModal: (0, _propTypesDefault.default).bool,
    signalUnitMap: (0, _propTypesDefault.default).object,
    toggleCompleteMaintenanceModal: (0, _propTypesDefault.default).func,
    toggleHistoryModal: (0, _propTypesDefault.default).func,
    toggleMobileFilters: (0, _propTypesDefault.default).func,
    toggleUpdateServiceValuesModal: (0, _propTypesDefault.default).func,
    upcoming: (0, _propTypesDefault.default).number
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./AssetV2MaintenanceMobileFiltersModal":"11WB0","./CompleteMaintenanceModal":"8CakJ","./GatewayInstanceMaintenanceTable":"kyije","./GatewayInstanceMobileMaintenanceCard":"ebHBz","./UpdateMaintenanceServiceValuesModal":"eNR8Z","./ViewMaintenanceHistoryModal":"ijeAC","../LoadingCircle":"aIADA","../NoDataIndication":"clGpp","../PaginationFooter":"kV15Q","../../Constants/GatewayReminderInstances":"cmyGT","../../Constants/GtemplateReminder":"kNNU0","../../Constants/RBAC":"ieo1E","../../Context/WidthContext":"5c6Dv","../../RBAC/Can":"l4l8D","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"11WB0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetV2MaintenanceMobileFiltersModal);
const { className, styles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1935516619",
        children: ".modal-dialog.jsx-1935516619{margin-top:75px;}"
    }),
    className: "jsx-1935516619"
};
function AssetV2MaintenanceMobileFiltersModal(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdropClassName: "bg-transparent",
        className: className,
        isOpen: props.isOpen,
        scrollable: true,
        toggle: props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: props.toggleModal,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "jsx-3715354688 mb-0 font-weight-normal nine-tenth-text",
                    children: "Filters"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.InputGroup), {
                    className: "mt-2",
                    size: "sm",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Input), {
                            className: "form-control text-text-light-gray border-right-0 nine-tenth-text",
                            disabled: props.dataLoading,
                            name: "reminder_name",
                            onChange: props.handleStatePropUpdate,
                            placeholder: "Filter by Reminder Name",
                            type: "text",
                            value: props.reminder_name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.InputGroupAddon), {
                            addonType: "append",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.InputGroupText), {
                                className: "input-group-text border-left-0 bg-white",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    className: "text-text-light-gray",
                                    icon: (0, _freeSolidSvgIcons.faSearch),
                                    size: "xs"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "align-items-center justify-content-center border-top-0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: props.handleClearFiltersClick,
                    className: "jsx-3715354688 btn btn-block btn-outline-third-gray text-text-gray bg-white py-0",
                    children: "Clear Filters"
                })
            }),
            styles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3715354688",
                children: ".btn.jsx-3715354688:focus{outline:none !important;}"
            })
        ]
    });
}
AssetV2MaintenanceMobileFiltersModal.propTypes = {
    handleClearFiltersClick: (0, _propTypesDefault.default).func,
    dataLoading: (0, _propTypesDefault.default).func,
    handleStatePropUpdate: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    reminder_name: (0, _propTypesDefault.default).string,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","prop-types":"bnNSm","react":"9njXz","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kyije":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _progressBars = require("../ProgressBars");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _gatewayReminderInstance = require("../../Lib/GatewayReminderInstance");
exports.default = /*#__PURE__*/ (0, _react.memo)(GatewayInstanceMaintenanceTable);
function GatewayInstanceMaintenanceTable(props) {
    const allInstancesChecked = (0, _react.useMemo)(()=>props.checkedInstances?.size === props.instances?.length, [
        props.checkedInstances?.size,
        props.instances?.length
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
        className: "d-none d-lg-table table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    className: "text-left nine-tenth-text",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "sticky-top bg-white border-0 pl-0 align-middle text-left",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "form-check",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    checked: allInstancesChecked,
                                    className: "form-check-input mt-n2",
                                    onChange: props.handleSelectAllInstances,
                                    type: "checkbox"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "sticky-top bg-white border-0 align-middle",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "input-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        className: "form-control border-0 pl-0 text-muted nine-tenth-text",
                                        disabled: props.instancesLoading,
                                        name: "reminder_name",
                                        onChange: props.handleStatePropUpdate,
                                        placeholder: "Reminder",
                                        type: "text",
                                        value: props.reminder_name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "input-group-append",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "input-group-text border-0 bg-white",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                className: "text-muted",
                                                icon: (0, _freeSolidSvgIcons.faSearch),
                                                size: "xs"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "sticky-top bg-white border-0 align-middle text-center text-text-light-gray font-weight-normal text-nowrap",
                            children: "Date Triggered"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "sticky-top bg-white border-0 align-middle text-center text-text-light-gray font-weight-normal text-nowrap",
                            children: "Last Service Date"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "sticky-top bg-white border-0 align-middle text-center text-text-light-gray font-weight-normal text-nowrap",
                            children: "Last Service Done By"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "sticky-top bg-white border-0"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                            className: "sticky-top bg-white border-0"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                children: props.instances?.map?.((instance)=>{
                    const dateTriggered = (0, _gatewayReminderInstance.getDateTriggered)(instance), { contact_info, last_service_date } = (0, _gatewayReminderInstance.getServiceDetails)(instance), { display_precision, unit } = props.signalUnitMap.get(instance.GtemplateReminder?.signal_id) || {}, { calendar_end, calendar_percentage, calendar_progress, calendar_text, calendar_upcoming, signal_current, signal_end, signal_margin, signal_percentage, signal_progress, signal_text } = props.instanceShadowValueMap.get(instance._id), isCompletedOneTimeReminder = !instance.GtemplateReminder?.recurring && !!instance.MaintenanceHistoryLogs?.length, [{ signal_value_when_serviced } = {}] = instance.MaintenanceHistoryLogs ?? [];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                className: "align-middle pl-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "form-check",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        checked: props.checkedInstances.has(instance._id),
                                        className: "form-check-input mt-n2",
                                        disabled: isCompletedOneTimeReminder,
                                        onChange: ()=>props.handleInstanceChecked([
                                                instance._id,
                                                instance
                                            ]),
                                        type: "checkbox"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                className: "align-middle",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "d-flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "mb-0 nine-tenth-text text-muted",
                                            children: instance.GtemplateReminder.name
                                        }),
                                        (()=>{
                                            switch(instance.GtemplateReminder.type){
                                                case 0, _gtemplateReminder.ALL_TYPE:
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mt-2 mb-1",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                                    calendar_end: calendar_end,
                                                                    calendar_percentage: calendar_percentage,
                                                                    calendar_upcoming: calendar_upcoming,
                                                                    instance: instance,
                                                                    isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                                    progress_color: calendar_progress,
                                                                    text: calendar_text
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "mt-1",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                                    display_precision: display_precision,
                                                                    instance: instance,
                                                                    isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                                    progress_color: signal_progress,
                                                                    signal_current: signal_current,
                                                                    signal_end: signal_end,
                                                                    signal_margin: signal_margin,
                                                                    signal_percentage: signal_percentage,
                                                                    signal_value_when_serviced: signal_value_when_serviced,
                                                                    text: signal_text,
                                                                    unit: unit
                                                                })
                                                            })
                                                        ]
                                                    });
                                                case 0, _gtemplateReminder.CALENDAR_TYPE:
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                        calendar_end: calendar_end,
                                                        calendar_percentage: calendar_percentage,
                                                        calendar_upcoming: calendar_upcoming,
                                                        instance: instance,
                                                        isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                        progress_color: calendar_progress,
                                                        text: calendar_text
                                                    });
                                                case 0, _gtemplateReminder.SIGNAL_TYPE:
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                        instance: instance,
                                                        isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                        progress_color: signal_progress,
                                                        signal_current: signal_current,
                                                        signal_end: signal_end,
                                                        signal_margin: signal_margin,
                                                        signal_percentage: signal_percentage,
                                                        signal_value_when_serviced: signal_value_when_serviced,
                                                        text: signal_text,
                                                        unit: unit
                                                    });
                                                default:
                                                    return null;
                                            }
                                        })()
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                className: "align-middle text-center text-muted text-text-light-gray three-quarter-text",
                                children: dateTriggered
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                className: "align-middle text-center text-muted text-text-light-gray three-quarter-text",
                                children: last_service_date
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                className: "align-middle text-center text-muted text-text-light-gray three-quarter-text",
                                children: contact_info
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                className: "align-middle text-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn btn-sm btn-outline-secondary rounded-lg",
                                    onClick: ()=>props.toggleHistoryModal({
                                            gateway_reminder_instance_id: instance?._id
                                        }),
                                    children: "View History"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                className: "align-middle text-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    className: "btn btn-link p-0",
                                    href: instance.GtemplateReminder?.attachment,
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faFilePdf),
                                        size: "lg"
                                    })
                                })
                            })
                        ]
                    }, instance._id);
                }) ?? null
            })
        ]
    });
}
GatewayInstanceMaintenanceTable.propTypes = {
    checkedInstances: (0, _propTypesDefault.default).object,
    handleInstanceChecked: (0, _propTypesDefault.default).func,
    handleSelectAllInstances: (0, _propTypesDefault.default).func,
    handleStatePropUpdate: (0, _propTypesDefault.default).func,
    instances: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    instanceShadowValueMap: (0, _propTypesDefault.default).object,
    instancesLoading: (0, _propTypesDefault.default).bool,
    reminder_name: (0, _propTypesDefault.default).string,
    signalUnitMap: (0, _propTypesDefault.default).object,
    toggleHistoryModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../ProgressBars":"bRUqk","../../Constants/GtemplateReminder":"kNNU0","../../Lib/GatewayReminderInstance":"gE5HX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ebHBz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GatewayInstanceMobileMaintenanceCard);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _progressBars = require("../ProgressBars");
var _gatewayReminderInstances = require("../../Constants/GatewayReminderInstances");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _gatewayInstanceMobileMaintenanceCardDetails = require("./GatewayInstanceMobileMaintenanceCardDetails");
var _gatewayInstanceMobileMaintenanceCardDetailsDefault = parcelHelpers.interopDefault(_gatewayInstanceMobileMaintenanceCardDetails);
function GatewayInstanceMobileMaintenanceCard(props) {
    const { checkedInstances, handleInstanceChecked, instance } = props, isCompletedOneTimeReminder = (0, _react.useMemo)(()=>!instance.GtemplateReminder?.recurring && !!instance.MaintenanceHistoryLogs?.length, [
        instance.GtemplateReminder?.recurring,
        instance.MaintenanceHistoryLogs?.length
    ]), clickHandler = (0, _react.useCallback)(()=>{
        if (isCompletedOneTimeReminder) return;
        handleInstanceChecked([
            instance?._id,
            instance
        ]);
    }, [
        handleInstanceChecked,
        instance,
        isCompletedOneTimeReminder
    ]), isChecked = (0, _react.useMemo)(()=>checkedInstances.has(instance._id), [
        checkedInstances,
        instance
    ]), [showCardDetails, toggleCardDetails] = (0, _react.useState)(false);
    const { display_precision, unit } = props.signalUnitMap.get(instance.GtemplateReminder?.signal_id) || {}, { calendar_end, calendar_percentage, calendar_progress, calendar_text, calendar_upcoming, signal_current, signal_end, signal_margin, signal_percentage, signal_progress, signal_text } = props.instanceShadowValueMap.get(instance._id), [{ signal_value_when_serviced } = {}] = instance.MaintenanceHistoryLogs ?? [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
        className: `rounded-lg p-2 ${isChecked ? "border border-brand-primary-alert" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardBody), {
                className: "p-0 d-flex flex-nowrap align-items-center text-muted",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        "aria-disabled": isCompletedOneTimeReminder,
                        onClick: clickHandler,
                        onKeyPress: clickHandler,
                        role: "button",
                        tabIndex: 0,
                        className: "jsx-1201814412 flex-fill",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1201814412 d-flex align-items-center py-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: "text-brand-primary",
                                        icon: isChecked ? (0, _freeSolidSvgIcons.faCheck) : (0, _freeSolidSvgIcons.faTools),
                                        size: "1x"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-1201814412 font-weight-bolder flex-wrap mb-0 ml-2",
                                        children: instance?.GtemplateReminder?.name ?? ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "jsx-1201814412 my-2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1201814412 d-flex flex-column",
                                children: (()=>{
                                    switch(instance.GtemplateReminder.type){
                                        case 0, _gtemplateReminder.ALL_TYPE:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "jsx-1201814412 mt-2 mb-1",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                            calendar_end: calendar_end,
                                                            calendar_percentage: calendar_percentage,
                                                            calendar_upcoming: calendar_upcoming,
                                                            instance: instance,
                                                            isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                            progress_color: calendar_progress,
                                                            text: calendar_text
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "jsx-1201814412 mt-1",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                            display_precision: display_precision,
                                                            instance: instance,
                                                            isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                            progress_color: signal_progress,
                                                            signal_current: signal_current,
                                                            signal_end: signal_end,
                                                            signal_margin: signal_margin,
                                                            signal_percentage: signal_percentage,
                                                            signal_value_when_serviced: signal_value_when_serviced,
                                                            text: signal_text,
                                                            unit: unit
                                                        })
                                                    })
                                                ]
                                            });
                                        case 0, _gtemplateReminder.CALENDAR_TYPE:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                calendar_end: calendar_end,
                                                calendar_percentage: calendar_percentage,
                                                calendar_upcoming: calendar_upcoming,
                                                instance: instance,
                                                isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                progress_color: calendar_progress,
                                                text: calendar_text
                                            });
                                        case 0, _gtemplateReminder.SIGNAL_TYPE:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                instance: instance,
                                                isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                progress_color: signal_progress,
                                                signal_current: signal_current,
                                                signal_end: signal_end,
                                                signal_margin: signal_margin,
                                                signal_percentage: signal_percentage,
                                                signal_value_when_serviced: signal_value_when_serviced,
                                                text: signal_text,
                                                unit: unit
                                            });
                                        default:
                                            return null;
                                    }
                                })()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1201814412 ml-2 d-flex align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>toggleCardDetails(!showCardDetails),
                            className: "jsx-1201814412 btn btn-link p-0 text-decoration-none shadow-none",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                className: "text-muted",
                                icon: (0, _freeSolidSvgIcons.faChevronRight),
                                size: "lg"
                            })
                        })
                    })
                ]
            }),
            showCardDetails ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gatewayInstanceMobileMaintenanceCardDetailsDefault.default), {
                ...props,
                isOpen: showCardDetails,
                toggleModal: ()=>toggleCardDetails(!showCardDetails)
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3710208751",
                children: "div.jsx-1201814412:active,div.jsx-1201814412:focus{outline:0;border:none;-moz-outline-style:none;}"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "478603274",
                children: ".border-brand-primary-alert{border-width:medium !important;}"
            })
        ]
    });
}
GatewayInstanceMobileMaintenanceCard.propTypes = {
    checkedInstances: (0, _propTypesDefault.default).object,
    handleInstanceChecked: (0, _propTypesDefault.default).func,
    instance: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        GtemplateReminder: (0, _propTypesDefault.default).shape({
            attachment: (0, _propTypesDefault.default).string,
            message: (0, _propTypesDefault.default).string,
            name: (0, _propTypesDefault.default).string,
            recurring: (0, _propTypesDefault.default).bool,
            signal_id: (0, _propTypesDefault.default).string,
            trigger_conditions: (0, _propTypesDefault.default).shape({
                calendar_trigger: (0, _propTypesDefault.default).shape({
                    interval: (0, _propTypesDefault.default).string,
                    margin: (0, _propTypesDefault.default).string
                }),
                signal_trigger: (0, _propTypesDefault.default).shape({
                    interval: (0, _propTypesDefault.default).number,
                    margin: (0, _propTypesDefault.default).number
                })
            }),
            type: (0, _propTypesDefault.default).oneOf((0, _gtemplateReminder.GTEMPLATE_REMINDER_TYPES))
        }),
        MaintenanceHistoryLogs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        MaintenanceNotifications: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            maintenance_completed: (0, _propTypesDefault.default).bool,
            signal_value: (0, _propTypesDefault.default).string,
            status: (0, _propTypesDefault.default).oneOf((0, _gatewayReminderInstances.MAINTENANCE_NOTIFICATION_STATUSES)),
            MaintenanceHistoryLog: (0, _propTypesDefault.default).shape({
                contact_info: (0, _propTypesDefault.default).string,
                message: (0, _propTypesDefault.default).string,
                service_date: (0, _propTypesDefault.default).string,
                signal_value_when_serviced: (0, _propTypesDefault.default).string,
                user_id: (0, _propTypesDefault.default).string
            })
        })),
        next_signal_value_due: (0, _propTypesDefault.default).string,
        next_time_due: (0, _propTypesDefault.default).string
    }),
    instanceShadowValueMap: (0, _propTypesDefault.default).object,
    signalUnitMap: (0, _propTypesDefault.default).object
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../ProgressBars":"bRUqk","../../Constants/GatewayReminderInstances":"cmyGT","../../Constants/GtemplateReminder":"kNNU0","./GatewayInstanceMobileMaintenanceCardDetails":"5UGWB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UGWB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _progressBars = require("../ProgressBars");
var _gatewayReminderInstances = require("../../Constants/GatewayReminderInstances");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _gatewayReminderInstance = require("../../Lib/GatewayReminderInstance");
exports.default = /*#__PURE__*/ (0, _react.memo)(GatewayInstanceMobileMaintenanceCardDetails);
function GatewayInstanceMobileMaintenanceCardDetails(props) {
    const { instance, toggleHistoryModal } = props, showHistoryClickHandler = (0, _react.useCallback)(()=>{
        toggleHistoryModal?.({
            gateway_reminder_instance_id: instance?._id
        });
    }, [
        instance?._id,
        toggleHistoryModal
    ]), dateTriggered = (0, _gatewayReminderInstance.getDateTriggered)(instance), { contact_info, last_service_date } = (0, _gatewayReminderInstance.getServiceDetails)(instance), { display_precision, unit } = props.signalUnitMap.get(instance.GtemplateReminder?.signal_id) || {}, { calendar_end, calendar_percentage, calendar_progress, calendar_text, calendar_upcoming, signal_current, signal_end, signal_margin, signal_percentage, signal_progress, signal_text } = props.instanceShadowValueMap.get(instance._id), isCompletedOneTimeReminder = (0, _react.useMemo)(()=>!instance.GtemplateReminder?.recurring && !!instance.MaintenanceHistoryLogs?.length, [
        instance.GtemplateReminder?.recurring,
        instance.MaintenanceHistoryLogs?.length
    ]), [{ signal_value_when_serviced } = {}] = instance.MaintenanceHistoryLogs ?? [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: props.isOpen,
        scrollable: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: ()=>props.toggleModal(!props.isOpen),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "font-weight-normal",
                    children: "Details"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "d-flex flex-column text-muted align-items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-third-gray font-weight-light three-quarter-text mb-2",
                                children: "Reminder Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-muted font-weight-bolder mb-0",
                                children: instance?.GtemplateReminder?.name ?? ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "w-100 d-flex flex-column mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-third-gray font-weight-light three-quarter-text mb-2",
                                children: "Status"
                            }),
                            (()=>{
                                switch(instance.GtemplateReminder.type){
                                    case 0, _gtemplateReminder.ALL_TYPE:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "mt-2 mb-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                        calendar_end: calendar_end,
                                                        calendar_percentage: calendar_percentage,
                                                        calendar_upcoming: calendar_upcoming,
                                                        instance: instance,
                                                        isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                        progress_color: calendar_progress,
                                                        text: calendar_text
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "mt-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                        display_precision: display_precision,
                                                        instance: instance,
                                                        isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                                        progress_color: signal_progress,
                                                        signal_current: signal_current,
                                                        signal_end: signal_end,
                                                        signal_margin: signal_margin,
                                                        signal_percentage: signal_percentage,
                                                        signal_value_when_serviced: signal_value_when_serviced,
                                                        text: signal_text,
                                                        unit: unit
                                                    })
                                                })
                                            ]
                                        });
                                    case 0, _gtemplateReminder.CALENDAR_TYPE:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                            calendar_end: calendar_end,
                                            calendar_percentage: calendar_percentage,
                                            calendar_upcoming: calendar_upcoming,
                                            instance: instance,
                                            isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                            progress_color: calendar_progress,
                                            text: calendar_text
                                        });
                                    case 0, _gtemplateReminder.SIGNAL_TYPE:
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                            instance: instance,
                                            isCompletedOneTimeReminder: isCompletedOneTimeReminder,
                                            progress_color: signal_progress,
                                            signal_current: signal_current,
                                            signal_end: signal_end,
                                            signal_margin: signal_margin,
                                            signal_percentage: signal_percentage,
                                            signal_value_when_serviced: signal_value_when_serviced,
                                            text: signal_text,
                                            unit: unit
                                        });
                                    default:
                                        return null;
                                }
                            })()
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-third-gray font-weight-light three-quarter-text mb-2",
                                children: "Date Triggered"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-muted font-weight-bolder mb-0",
                                children: dateTriggered
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-third-gray font-weight-light three-quarter-text mb-2",
                                children: "Last Service Date"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-muted font-weight-bolder mb-0",
                                children: last_service_date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "w-100 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-third-gray font-weight-light three-quarter-text mb-2",
                                children: "Last Service Done By"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-muted font-weight-bolder mb-0",
                                children: contact_info
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-100 mb-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "btn btn-block btn-outline-secondary",
                            onClick: showHistoryClickHandler,
                            children: "View History"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-100 mb-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                            className: "btn btn-block modal-button-primary",
                            href: instance.GtemplateReminder?.attachment,
                            rel: "noopener noreferrer",
                            target: "_blank",
                            children: [
                                "View Attachment",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    className: "ml-3",
                                    icon: (0, _freeSolidSvgIcons.faFilePdf),
                                    size: "lg"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
GatewayInstanceMobileMaintenanceCardDetails.propTypes = {
    instance: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        GtemplateReminder: (0, _propTypesDefault.default).shape({
            attachment: (0, _propTypesDefault.default).string,
            message: (0, _propTypesDefault.default).string,
            name: (0, _propTypesDefault.default).string,
            recurring: (0, _propTypesDefault.default).bool,
            signal_id: (0, _propTypesDefault.default).string,
            trigger_conditions: (0, _propTypesDefault.default).shape({
                calendar_trigger: (0, _propTypesDefault.default).shape({
                    interval: (0, _propTypesDefault.default).string,
                    margin: (0, _propTypesDefault.default).string
                }),
                signal_trigger: (0, _propTypesDefault.default).shape({
                    interval: (0, _propTypesDefault.default).number,
                    margin: (0, _propTypesDefault.default).number
                })
            }),
            type: (0, _propTypesDefault.default).oneOf((0, _gtemplateReminder.GTEMPLATE_REMINDER_TYPES))
        }),
        MaintenanceHistoryLogs: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        MaintenanceNotifications: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            _id: (0, _propTypesDefault.default).string,
            maintenance_completed: (0, _propTypesDefault.default).bool,
            signal_value: (0, _propTypesDefault.default).string,
            status: (0, _propTypesDefault.default).oneOf((0, _gatewayReminderInstances.MAINTENANCE_NOTIFICATION_STATUSES)),
            MaintenanceHistoryLog: (0, _propTypesDefault.default).shape({
                contact_info: (0, _propTypesDefault.default).string,
                message: (0, _propTypesDefault.default).string,
                service_date: (0, _propTypesDefault.default).string,
                signal_value_when_serviced: (0, _propTypesDefault.default).string,
                user_id: (0, _propTypesDefault.default).string
            })
        })),
        next_signal_value_due: (0, _propTypesDefault.default).string,
        next_time_due: (0, _propTypesDefault.default).string
    }),
    instanceShadowValueMap: (0, _propTypesDefault.default).object,
    isOpen: (0, _propTypesDefault.default).bool,
    signalUnitMap: (0, _propTypesDefault.default).object,
    showHistoryModal: (0, _propTypesDefault.default).string,
    toggleHistoryModal: (0, _propTypesDefault.default).func,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../ModalLayout":"2RoDj","../ProgressBars":"bRUqk","../../Constants/GatewayReminderInstances":"cmyGT","../../Constants/GtemplateReminder":"kNNU0","../../Lib/GatewayReminderInstance":"gE5HX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNR8Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactstrap = require("reactstrap");
var _reactRouterDom = require("react-router-dom");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _progressBars = require("../ProgressBars");
var _gtemplateReminder = require("../../Constants/GtemplateReminder");
var _gatewayReminderInstanceService = require("../../Services/GatewayReminderInstanceService");
var _gatewayReminderInstanceServiceDefault = parcelHelpers.interopDefault(_gatewayReminderInstanceService);
var _signalUtils = require("../../Lib/SignalUtils");
exports.default = /*#__PURE__*/ (0, _react.memo)(UpdateMaintenanceServiceValuesModal);
const initState = {
    error: "",
    updateInfoMap: new Map(),
    requestPending: false
};
function UpdateMaintenanceServiceValuesModal(props) {
    const service = (0, _react.useMemo)(()=>new (0, _gatewayReminderInstanceServiceDefault.default)(), []), { assetID } = (0, _reactRouterDom.useParams)(), [state, updateState] = (0, _react.useState)(()=>{
        const updateInfoMap = Array.from(props.checkedInstances?.keys?.() ?? []).reduce((map, gateway_reminder_instance_id)=>{
            const { calendar_end, calendar_upcoming_epoch, signal_end } = props.instanceShadowValueMap?.get(gateway_reminder_instance_id) || {};
            return map.set(gateway_reminder_instance_id, {
                next_signal_value_due: signal_end,
                next_time_due: calendar_end,
                next_time_upcoming: calendar_upcoming_epoch
            });
        }, new Map());
        return {
            ...initState,
            updateInfoMap
        };
    });
    let source;
    const handleUpdateServiceValuesClick = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    requestPending: true
                }));
            source = (0, _axios.CancelToken).source();
            const body = Array.from(state.updateInfoMap ?? new Map()).map(([gateway_reminder_instance_id, updates])=>({
                    gateway_reminder_instance_id,
                    ...updates,
                    next_time_due: updates.next_time_due ? new Date(updates.next_time_due).toISOString() : null,
                    next_time_upcoming: updates.next_time_upcoming ? new Date(updates.next_time_upcoming).toISOString() : null
                }));
            await service.updateGatewayReminderInstances(assetID, body, source.token);
            props.handleUpdateServiceValuesSuccess();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    };
    const handleStatePropUpdate = ({ target: { name, value } })=>{
        const [prop, instance_id] = name.split(":");
        updateState((prevState)=>{
            const instanceInfo = prevState.updateInfoMap.get(instance_id);
            const updateInfoMap = prevState.updateInfoMap.set(instance_id, {
                ...instanceInfo,
                [prop]: value
            });
            return {
                ...prevState,
                updateInfoMap
            };
        });
    };
    (0, _react.useEffect)(()=>source?.cancel, [
        source
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: props.isOpen,
        scrollable: true,
        size: "xl",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0 modal-title-text",
                toggle: props.toggleModal,
                children: [
                    "Update Reminder Service Values",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "text-muted nine-tenth-text ml-3",
                        children: [
                            props.checkedInstances?.size ?? 0,
                            " selected"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid pb-0",
                children: [
                    state.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "row sticky-top bg-white",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "col-12 text-center text-danger nine-tenth-text",
                            children: state.error
                        })
                    }) : null,
                    Array.from(state.updateInfoMap ?? new Map()).map(([instance_id, updates])=>{
                        const instance = props.checkedInstances?.get?.(instance_id), { display_precision, unit } = props.signalUnitMap?.get(instance.GtemplateReminder?.signal_id) || {}, { calendar_end, calendar_percentage, calendar_progress, calendar_text, calendar_upcoming, signal_current, signal_end, signal_margin, signal_percentage, signal_progress, signal_text } = props.instanceShadowValueMap?.get(instance_id) || {}, showCalendarInputs = [
                            (0, _gtemplateReminder.ALL_TYPE),
                            (0, _gtemplateReminder.CALENDAR_TYPE)
                        ].includes(instance.GtemplateReminder.type), showSignalInput = [
                            (0, _gtemplateReminder.ALL_TYPE),
                            (0, _gtemplateReminder.SIGNAL_TYPE)
                        ].includes(instance.GtemplateReminder.type);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "row justify-content-center mb-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Card), {
                                className: "col-11",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.CardHeader), {
                                        className: "bg-white",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "mb-0 font-weight-bolder text-muted",
                                                children: instance?.GtemplateReminder?.name ?? ""
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "w-75",
                                                children: (()=>{
                                                    switch(instance.GtemplateReminder.type){
                                                        case 0, _gtemplateReminder.ALL_TYPE:
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "mt-2 mb-1",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                                            calendar_end: calendar_end,
                                                                            calendar_percentage: calendar_percentage,
                                                                            calendar_upcoming: calendar_upcoming,
                                                                            instance: instance,
                                                                            progress_color: calendar_progress,
                                                                            text: calendar_text
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "mt-1",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                                            display_precision: display_precision,
                                                                            instance: instance,
                                                                            progress_color: signal_progress,
                                                                            signal_current: signal_current,
                                                                            signal_end: signal_end,
                                                                            signal_margin: signal_margin,
                                                                            signal_percentage: signal_percentage,
                                                                            text: signal_text,
                                                                            unit: unit
                                                                        })
                                                                    })
                                                                ]
                                                            });
                                                        case 0, _gtemplateReminder.CALENDAR_TYPE:
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceCalendarType), {
                                                                calendar_end: calendar_end,
                                                                calendar_percentage: calendar_percentage,
                                                                calendar_upcoming: calendar_upcoming,
                                                                instance: instance,
                                                                progress_color: calendar_progress,
                                                                text: calendar_text
                                                            });
                                                        case 0, _gtemplateReminder.SIGNAL_TYPE:
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBars.ReminderInstanceSignalType), {
                                                                instance: instance,
                                                                progress_color: signal_progress,
                                                                signal_current: signal_current,
                                                                signal_end: signal_end,
                                                                signal_margin: signal_margin,
                                                                signal_percentage: signal_percentage,
                                                                text: signal_text,
                                                                unit: unit
                                                            });
                                                        default:
                                                            return null;
                                                    }
                                                })()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.CardBody), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "d-flex align-items-center justify-content-between",
                                            children: [
                                                showSignalInput ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "d-flex align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "mb-0 text-muted three-quarter-text text-nowrap mr-2",
                                                            children: "Next Signal Value Due at:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            className: "form-control form-control-sm rounded-lg d-inline",
                                                            name: `next_signal_value_due:${instance_id}`,
                                                            onChange: handleStatePropUpdate,
                                                            type: "number",
                                                            value: (0, _signalUtils.truncateValueFromString)(updates.next_signal_value_due)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "mb-0 ml-2 text-muted three-quarter-text text-nowrap",
                                                            children: unit
                                                        })
                                                    ]
                                                }) : null,
                                                showCalendarInputs ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.FormGroup), {
                                                            row: true,
                                                            className: "align-items-center mb-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                                    className: "mb-0 text-muted three-quarter-text text-nowrap mr-2",
                                                                    children: "Next Time Upcoming:"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                                    autoComplete: "off",
                                                                    className: "form-control form-control-sm",
                                                                    dateFormat: [
                                                                        "MMM do, y"
                                                                    ],
                                                                    onChange: (selected)=>handleStatePropUpdate({
                                                                            target: {
                                                                                name: `next_time_upcoming:${instance_id}`,
                                                                                value: selected
                                                                            }
                                                                        }),
                                                                    selected: new Date(updates.next_time_upcoming),
                                                                    showMonthDropdown: true,
                                                                    showYearDropdown: true,
                                                                    withPortal: true
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.FormGroup), {
                                                            row: true,
                                                            className: "align-items-center mb-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Label), {
                                                                    className: "mb-0 text-muted three-quarter-text text-nowrap mr-2",
                                                                    children: "Next Time Due:"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                                    autoComplete: "off",
                                                                    className: "form-control form-control-sm",
                                                                    dateFormat: [
                                                                        "MMM do, y"
                                                                    ],
                                                                    onChange: (selected)=>handleStatePropUpdate({
                                                                            target: {
                                                                                name: `next_time_due:${instance_id}`,
                                                                                value: selected
                                                                            }
                                                                        }),
                                                                    selected: new Date(updates.next_time_due),
                                                                    showMonthDropdown: true,
                                                                    showYearDropdown: true,
                                                                    withPortal: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, instance_id);
                    }) ?? null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "border-top-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "px-4 py-0 nine-tenth-text",
                        color: "outline-secondary",
                        disabled: state.requestPending,
                        onClick: props.toggleModal,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "px-4 py-0 nine-tenth-text",
                        color: "success",
                        disabled: state.requestPending,
                        onClick: handleUpdateServiceValuesClick,
                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Update Values"
                    })
                ]
            })
        ]
    });
}
UpdateMaintenanceServiceValuesModal.propTypes = {
    checkedInstances: (0, _propTypesDefault.default).object,
    handleUpdateServiceValuesSuccess: (0, _propTypesDefault.default).func,
    instanceShadowValueMap: (0, _propTypesDefault.default).object,
    isOpen: (0, _propTypesDefault.default).bool,
    signalUnitMap: (0, _propTypesDefault.default).object,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-datepicker":"cGh5X","reactstrap":"kjd7g","react-router-dom":"3uzXR","../ModalLayout":"2RoDj","../ProgressBars":"bRUqk","../../Constants/GtemplateReminder":"kNNU0","../../Services/GatewayReminderInstanceService":"WwEop","../../Lib/SignalUtils":"eTEQK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ijeAC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _reactstrap = require("reactstrap");
var _loadingCircle = require("../LoadingCircle");
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _paginationFooter = require("../PaginationFooter");
var _paginationFooterDefault = parcelHelpers.interopDefault(_paginationFooter);
var _maintenanceLogsService = require("../../Services/MaintenanceLogsService");
var _maintenanceLogsServiceDefault = parcelHelpers.interopDefault(_maintenanceLogsService);
exports.default = /*#__PURE__*/ (0, _react.memo)(ViewMaintenanceModal);
const initState = {
    count: 0,
    csvDownloadPending: false,
    error: "",
    logs: [],
    logsLoading: true,
    page: 1
}, limit = 20;
function ViewMaintenanceModal(props) {
    const { assetNickname, gateway_id, gateway_reminder_instance_id, toggleModal } = props, handleToggleModalClick = (0, _react.useCallback)(()=>{
        toggleModal();
    }, [
        toggleModal
    ]), service = (0, _react.useMemo)(()=>new (0, _maintenanceLogsServiceDefault.default)(), []), [state, updateState] = (0, _react.useState)(initState), pages = (0, _react.useMemo)(()=>Math.ceil(state.count / limit), [
        state.count
    ]);
    const handleCsvDownload = (0, _react.useCallback)(async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    csvDownloadPending: true
                }));
            const params = gateway_id ? {
                gateway_id
            } : gateway_reminder_instance_id ? {
                gateway_reminder_instance_id
            } : {};
            const csv = await service.downloadMaintenanceLogsCsv(params);
            const blob = new Blob([
                csv
            ], {
                type: "text/csv"
            }), formattedDate = (0, _formatDefault.default)(new Date(), "y-MM-dd_HH:mm:ss"), filename = `Maintenance_Logs-${assetNickname}-${formattedDate}.csv`, link = document.createElement("a"), url = URL.createObjectURL(blob);
            link.download = filename;
            link.href = url;
            link.style = "display: none";
            document.body.appendChild(link);
            link.click();
            window.setTimeout(()=>{
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                updateState((prevState)=>({
                        ...prevState,
                        csvDownloadPending: false
                    }));
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    csvDownloadPending: false
                }));
        }
    }, [
        assetNickname,
        gateway_id,
        gateway_reminder_instance_id,
        service
    ]);
    const handlePageChange = (0, _react.useCallback)((selected)=>{
        updateState((prevState)=>selected + 1 === prevState.page ? prevState : {
                ...prevState,
                logsLoading: true,
                logs: [],
                page: selected + 1
            });
    }, []);
    (0, _react.useEffect)(()=>{
        const source = (0, _axios.CancelToken).source();
        async function fetchMaintenanceLogs() {
            try {
                const filterParam = gateway_id ? {
                    gateway_id
                } : gateway_reminder_instance_id ? {
                    gateway_reminder_instance_id
                } : {};
                const params = {
                    ...filterParam,
                    limit,
                    page: state.page
                };
                const { count, data, page } = await service.getMaintenanceLogs(params, source.token);
                updateState((prevState)=>({
                        ...prevState,
                        count,
                        page,
                        logs: data,
                        logsLoading: false
                    }));
            } catch (err) {
                if ((0, _axios.isCancel)(err)) return;
                const error = err.response?.data?.message ?? err.message;
                updateState((prevState)=>({
                        ...prevState,
                        error,
                        logsLoading: false
                    }));
            }
        }
        fetchMaintenanceLogs();
        return source.cancel;
    }, [
        gateway_id,
        gateway_reminder_instance_id,
        service,
        state.page
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        centered: true,
        isOpen: props.isOpen,
        scrollable: true,
        size: "xl",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0",
                toggle: handleToggleModalClick,
                children: [
                    "View Maintenance History",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                        className: "ml-md-3 rounded-lg",
                        color: "outline-secondary",
                        disabled: state.csvDownloadPending,
                        onClick: handleCsvDownload,
                        size: "sm",
                        children: state.csvDownloadPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                            size: "sm"
                        }) : "Download Maintenance History"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid pt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "row sticky-top pt-3 bg-white",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "col-3 mb-0 nine-tenth-text text-muted text-center",
                                children: "Maintenance Reminder"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "col-3 mb-0 nine-tenth-text text-muted text-center",
                                children: "Date Triggered"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "col-3 mb-0 nine-tenth-text text-muted text-center",
                                children: "Service Date"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "col-3 mb-0 nine-tenth-text text-muted text-center",
                                children: "Service Done By"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                    className: "mt-2",
                                    style: {
                                        borderTopWidth: "2px"
                                    }
                                })
                            })
                        ]
                    }),
                    state.logsLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "h-100 w-100 d-flex align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingCircle.BrandPrimarySpinningCircle), {
                            size: "3x"
                        })
                    }) : state.logs.map((log)=>{
                        const { unit } = props.signalUnitMap.get(log.GatewayReminderInstance?.GtemplateReminder?.signal_id) || {};
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "col-3 mb-0 nine-tenth-text text-center text-break",
                                            children: log.GatewayReminderInstance?.GtemplateReminder?.name
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "col-3 d-flex flex-column align-items-center",
                                            children: log.MaintenanceNotification ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "mb-0 text-center text-muted three-quarter-text",
                                                        children: (0, _formatDefault.default)(new Date(log.MaintenanceNotification.updatedAt), "LLLL do, y")
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "mb-0 text-center text-success three-quarter-text",
                                                        children: [
                                                            "Triggered at",
                                                            " ",
                                                            log.MaintenanceNotification.signal_value,
                                                            " ",
                                                            unit ? `Total ${unit}` : ""
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "mb-0 text-center text-muted three-quarter-text",
                                                children: "n/a"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "col-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "mb-0 text-center text-muted three-quarter-text",
                                                    children: (0, _formatDefault.default)(new Date(log.service_date), "LLLL do, y")
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    className: "mb-0 text-center text-success three-quarter-text",
                                                    children: [
                                                        "Serviced at ",
                                                        log.signal_value_when_serviced,
                                                        " ",
                                                        unit ? `Total ${unit}` : ""
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "col-3 mb-0 nine-tenth-text text-center text-muted text-break",
                                            children: log.contact_info
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                    })
                                })
                            ]
                        }, log._id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "border-top-0 justify-content-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationFooterDefault.default), {
                    handlePageChange: handlePageChange,
                    page: state.page,
                    pages: pages,
                    rowsLength: state.logs?.length ?? 0,
                    rowsLoading: state.logsLoading
                })
            })
        ]
    });
}
ViewMaintenanceModal.propTypes = {
    assetNickname: (0, _propTypesDefault.default).string,
    gateway_id: (0, _propTypesDefault.default).string,
    gateway_reminder_instance_id: (0, _propTypesDefault.default).string,
    isOpen: (0, _propTypesDefault.default).bool,
    signalUnitMap: (0, _propTypesDefault.default).object,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","date-fns/format":"520Dk","reactstrap":"kjd7g","../LoadingCircle":"aIADA","../ModalLayout":"2RoDj","../PaginationFooter":"kV15Q","../../Services/MaintenanceLogsService":"7RlqL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1CzYf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDebounce);
var _react = require("react");
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eIfbT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateSignalUnitMap", ()=>generateSignalUnitMap);
function generateSignalUnitMap(gtemplate) {
    if (!Array.isArray(gtemplate?.datapoints) || !gtemplate?.datapoints?.length) return new Map();
    return gtemplate.datapoints.reduce((map, sc)=>{
        if (!Array.isArray(sc?.values) || !sc?.values?.length) return map;
        return sc.values.reduce((acc, signal)=>{
            const { _id, display_precision = 2, transforms, unit } = signal || {};
            if (!Array.isArray(transforms) || !transforms?.length) return acc.set(_id, {
                display_precision,
                unit
            });
            const [{ uom = unit }] = transforms;
            return acc.set(_id, {
                display_precision,
                unit: uom
            });
        }, map);
    }, new Map());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9MxoK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteAssetModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _deleteAssetModalDisplay = require("./DeleteAssetModalDisplay");
var _deleteAssetModalDisplayDefault = parcelHelpers.interopDefault(_deleteAssetModalDisplay);
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
const initState = {
    deleteRequestPending: false,
    error: ""
};
function DeleteAssetModal(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const assetService = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []);
    let source = (0, _axios.CancelToken).source();
    const handleDeleteAsset = async ()=>{
        if (state.deleteRequestPending) return;
        updateState((prevState)=>({
                ...prevState,
                deleteRequestPending: true
            }));
        source = (0, _axios.CancelToken).source();
        try {
            const { _id, nickname } = props.assetToDelete;
            await assetService.deleteAsset(_id, source.token);
            props.handleSubtractAsset(_id, `${nickname || "Asset"} has been deleted`, true);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            updateState({
                deleteRequestPending: false,
                error: err.response?.data?.message ?? err.message
            });
        }
    };
    (0, _react.useEffect)(()=>{
        return source.cancel;
    }, [
        source.cancel
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteAssetModalDisplayDefault.default), {
        ...props,
        ...state,
        handleDeleteAsset: handleDeleteAsset
    });
}
DeleteAssetModal.propTypes = {
    assetToDelete: (0, _propTypesDefault.default).object,
    handleSubtractAsset: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","./DeleteAssetModalDisplay":"cTLNJ","../../Services/AssetService":"fL096","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTLNJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteAssetModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _assetAssociations = require("../../Constants/AssetAssociations");
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
function DeleteAssetModalDisplay(props) {
    const { deleteRequestPending, isOpen, toggleModal, handleDeleteAsset, assetToDelete = {}, error } = props;
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const orgBillingEnabled = (0, _react.useMemo)(()=>orgsMap?.[assetToDelete?.orgID]?.features?.billing?.enabled, [
        assetToDelete?.orgID,
        orgsMap
    ]);
    const assetHasActiveSubscription = (0, _react.useMemo)(()=>assetToDelete?.assetAssociation?.subscription_status === (0, _assetAssociations.ACTIVE), [
        assetToDelete?.assetAssociation?.subscription_status
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        desktopHeight: "auto",
        isOpen: isOpen,
        toggleModal: ()=>toggleModal(),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-0",
                toggle: ()=>toggleModal(),
                children: "Delete Asset"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid",
                children: [
                    (()=>{
                        switch(true){
                            case orgBillingEnabled && assetHasActiveSubscription:
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-2643976316 row justify-content-center",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2643976316 col-12 col-md-10 text-left",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    className: "jsx-2643976316 text-muted",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "jsx-2643976316 font-weight-medium text-text-dark",
                                                            children: [
                                                                assetToDelete.nickname || "This asset",
                                                                " "
                                                            ]
                                                        }),
                                                        "has an active subscription. Deleting this asset will permanently remove it from your company's inventory, and all data associated with it will be lost. Cancellation fees may apply to deleting an asset with an active subscription."
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-2643976316 row justify-content-center",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2643976316 col-12 col-md-10 text-left",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "jsx-2643976316 text-muted",
                                                    children: "If you'd like to get the data from the asset first; close this dialogue, go to the asset dashboard and download the data from each smart tile as CSVs."
                                                })
                                            })
                                        })
                                    ]
                                });
                            default:
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-2643976316 row justify-content-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2643976316 col-12 col-md-10 text-left",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "jsx-2643976316 text-muted",
                                            children: [
                                                "Are you sure that you want to delete",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "jsx-2643976316 font-weight-medium text-text-dark",
                                                    children: [
                                                        " ",
                                                        assetToDelete?.nickname ?? "this Asset"
                                                    ]
                                                }),
                                                "?"
                                            ]
                                        })
                                    })
                                });
                        }
                    })(),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2643976316 row col-12 col-md-10 text-right text-danger",
                        children: error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                        className: "border-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleDeleteAsset,
                                className: "jsx-2643976316 btn btn-danger py-0 px-4 mr-4",
                                children: deleteRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                    size: "lg",
                                    spin: true
                                }) : "Yes, Delete Asset"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>toggleModal(),
                                className: "jsx-2643976316 btn btn-outline-secondary py-0 px-4",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2643976316",
                children: ".btn.jsx-2643976316{font-size:0.9rem;}"
            })
        ]
    });
}
DeleteAssetModalDisplay.propTypes = {
    assetToDelete: (0, _propTypesDefault.default).shape({
        assetAssociation: (0, _propTypesDefault.default).shape({
            subscription_status: (0, _propTypesDefault.default).string
        }),
        orgID: (0, _propTypesDefault.default).string
    }),
    deleteRequestPending: (0, _propTypesDefault.default).bool,
    handleDeleteAsset: (0, _propTypesDefault.default).func,
    error: (0, _propTypesDefault.default).string,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/AssetAssociations":"buFwx","../../Context/OrgsMapContext":"asozp","../ModalLayout":"2RoDj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"buFwx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACTIVE", ()=>ACTIVE);
const ACTIVE = "ACTIVE";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJk2B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _editAssetModalDisplay = require("./EditAssetModalDisplay");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _accessTools = require("../../RBAC/AccessTools");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _vendors = require("../../Constants/Vendors");
var _fileOverrides = require("../../Lib/FileOverrides");
var _rbac = require("../../Constants/RBAC");
exports.default = /*#__PURE__*/ (0, _react.memo)(EditAssetModal);
const initState = {
    availableTemplates: [],
    error: "",
    templatesLoading: true,
    updateRequestPending: false,
    viewing: "basics"
};
function EditAssetModal(props) {
    const { asset: { _id: assetID, gtemplateID, nickname, orgID, remote, settings: currentSettings, vendor } = {}, isOpen, refreshAsset, updateAsset, toggle } = props;
    const [state, updateState] = (0, _react.useState)(()=>{
        const asset = parseAssetProps(props);
        const commandAndControl = props.asset.remote ?? false;
        const links = parseAssetLinks(props);
        const selectedTimezone = props.asset.autoTz ? "" : props.asset.timezone;
        const timezone = props.asset.autoTz ? "auto" : props.asset.timezone;
        return {
            ...initState,
            asset,
            commandAndControl,
            links,
            selectedTimezone,
            timezone,
            ...loadFileOverrides(props)
        };
    });
    const source = (0, _react.useMemo)(()=>(0, _axios.CancelToken).source(), []);
    const assetService = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []);
    const templateService = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    const fetchAvailableAssetModels = (0, _react.useCallback)(async ()=>{
        const limit = 100;
        const sort = "name";
        const order = "asc";
        let selectedTemplate;
        try {
            const { count, data } = await templateService.fetchPaginatedTemplates(1, orgID, limit, sort, order, undefined, vendor, source.token);
            const availableTemplates = transformTemplateData(data);
            if (count <= data.length) {
                if (gtemplateID) selectedTemplate = availableTemplates.find(({ value })=>value === gtemplateID);
                return updateState((prevState)=>({
                        ...prevState,
                        availableTemplates,
                        selectedTemplate,
                        templatesLoading: false
                    }));
            }
            const additionalData = await templateService.handleAdditionalTemplateRequests({
                cancelToken: source.token,
                count,
                limit,
                order,
                orgID,
                sort,
                vendor
            });
            const additionalTemplates = additionalData.map(({ data })=>transformTemplateData(data));
            const allTemplates = availableTemplates.concat(...additionalTemplates);
            if (gtemplateID) selectedTemplate = allTemplates.find(({ value })=>value === gtemplateID);
            updateState((prevState)=>({
                    ...prevState,
                    availableTemplates: allTemplates,
                    selectedTemplate,
                    templatesLoading: false
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error
                }));
        }
    }, [
        gtemplateID,
        orgID,
        source.token,
        templateService,
        vendor
    ]);
    const handleCCToggle = (0, _react.useCallback)(()=>{
        updateState((prevState)=>({
                ...prevState,
                commandAndControl: !prevState.commandAndControl
            }));
    }, []);
    const handlePropUpdate = (0, _react.useCallback)(({ target: { name, value } })=>{
        updateState((prevState)=>{
            const asset = {
                ...prevState.asset,
                [name]: value
            };
            return {
                ...prevState,
                asset,
                change: true,
                error: ""
            };
        });
    }, []);
    const handlePropUpdateSimple = (0, _react.useCallback)(({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    }, []);
    const handleTemplateSelect = (0, _react.useCallback)((selectedTemplate)=>{
        updateState((prevState)=>({
                ...prevState,
                selectedTemplate
            }));
    }, []);
    const handleTimezoneSelected = (0, _react.useCallback)((selectedTimezone)=>{
        updateState((prevState)=>({
                ...prevState,
                selectedTimezone,
                timezone: selectedTimezone.value
            }));
    }, []);
    const handleTimezoneToggle = (0, _react.useCallback)((nextState)=>{
        updateState((prevState)=>{
            const timezone = nextState ? "auto" : "";
            return {
                ...prevState,
                selectedTimezone: {},
                timezone
            };
        });
    }, []);
    const submitUpdate = async (e)=>{
        e.preventDefault();
        updateState((prevState)=>({
                ...prevState,
                updateRequestPending: true
            }));
        try {
            validateAssetUpdates(state.asset, vendor);
            const { commandAndControl, links, selectedTemplate } = state;
            const autoTz = state.timezone === "auto";
            const timezone = autoTz ? undefined : state.timezone;
            const settings = {
                ...getFileOverrideSettingsToSave(state, currentSettings || {})
            };
            const asset = {
                ...state.asset,
                references: {
                    links
                },
                timezone,
                autoTz,
                settings
            };
            if ((0, _accessTools.hasWriteAccessToResource)(orgID, (0, _rbac.REMOTE)) && commandAndControl !== remote) await assetService.updateAssetRemote(assetID, commandAndControl, source.token);
            const update = await assetService.updateAssetDetails(assetID, asset, source.token);
            if (selectedTemplate?.value && gtemplateID !== selectedTemplate.value) {
                await templateService.assignTemplate(assetID, selectedTemplate.value, {}, source.token);
                return refreshAsset(false);
            }
            updateState((prevState)=>({
                    ...prevState,
                    asset: parseAssetProps({
                        asset: {
                            ...update,
                            autoTz,
                            timezone
                        }
                    }),
                    updateRequestPending: false
                }));
            updateAsset(update);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    updateRequestPending: false
                }));
        }
    };
    const toggleView = (0, _react.useCallback)((viewing)=>{
        if (state.viewing === viewing) return;
        updateState((prevState)=>({
                ...prevState,
                viewing
            }));
    }, [
        state.viewing
    ]);
    (0, _react.useEffect)(()=>{
        if ((0, _accessTools.hasReadAccessToResource)(orgID, (0, _rbac.ASSET_MODEL))) fetchAvailableAssetModels();
        return source.cancel;
    }, [
        fetchAvailableAssetModels,
        orgID,
        source.cancel
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editAssetModalDisplay.EditAssetModalDisplay), {
        ...state,
        currentTemplateID: gtemplateID,
        handleCCToggle: handleCCToggle,
        handlePropUpdate: handlePropUpdate,
        handlePropUpdateSimple: handlePropUpdateSimple,
        handleTemplateSelect: handleTemplateSelect,
        handleTimezoneSelected: handleTimezoneSelected,
        handleTimezoneToggle: handleTimezoneToggle,
        isOpen: isOpen,
        startingNickname: nickname,
        submitUpdate: submitUpdate,
        toggle: toggle,
        toggleView: toggleView,
        vendor: vendor
    });
}
EditAssetModal.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    isOpen: (0, _propTypesDefault.default).bool,
    refreshAsset: (0, _propTypesDefault.default).func,
    toggle: (0, _propTypesDefault.default).func,
    updateAsset: (0, _propTypesDefault.default).func
};
EditAssetModal.defaultProps = {
    asset: {
        nickname: "",
        references: {}
    }
};
function getFileOverrideSettingsToSave(state, existingSettings) {
    const { stwWiFiControl, stwWiFiEnabled, WiFissid, WiFipassword } = state;
    let file_overrides = (0, _fileOverrides.removeFileOverridesByTag)(existingSettings.file_overrides, (0, _fileOverrides.tags).nm_wifi);
    if (!stwWiFiControl) return {
        file_overrides
    };
    if (stwWiFiEnabled) file_overrides = file_overrides.concat((0, _fileOverrides.getNetworkManagerWifiEnabled)({
        stwWiFiControl,
        stwWiFiEnabled,
        WiFissid,
        WiFipassword
    }));
    else file_overrides = file_overrides.concat((0, _fileOverrides.getNetworkManagerWifiDisabled)());
    return {
        file_overrides
    };
}
function parseAssetProps({ asset }) {
    const { _id = "", mac = "", nickname = "", orgID = "", tags = "", vendor = "" } = asset;
    return {
        _id,
        mac,
        nickname,
        orgID,
        tags,
        vendor
    };
}
function parseAssetLinks({ asset }) {
    const { references = {} } = asset;
    return Array.isArray(references.links) ? references.links : [
        {
            name: "",
            url: ""
        },
        {
            name: "",
            url: ""
        },
        {
            name: "",
            url: ""
        }
    ];
}
function loadFileOverrides(props) {
    let output = {};
    const { file_overrides = [] } = props.asset?.settings || {}; // todo - change to gateway.settings and save/load stuff
    const stw_wifi = (0, _fileOverrides.getParamsByFileType)(file_overrides, (0, _fileOverrides.file_types).wifi_nmconnection_file);
    if (stw_wifi === undefined || stw_wifi.stwWiFiControl === undefined) {
        output.stwWiFiControl = false;
        output.stwWiFiEnabled = false;
        output.WiFissid = "";
        output.WiFipassword = "";
    } else output = {
        ...stw_wifi
    };
    return output;
}
const provisionModelUuidSet = new Set([
    (0, _staticUUIDs.PROVISIONING_MODEL_ID),
    (0, _staticUUIDs.XIRGO_PROVISIONING_MODEL_ID),
    (0, _staticUUIDs.XIRGO_V2_PROVISIONING_MODEL_ID)
]);
function transformTemplateData(templates) {
    if (!Array.isArray(templates)) return [];
    return templates.filter((t)=>!provisionModelUuidSet.has(t._id)).map(({ _id: value, name: label } = {})=>({
            label,
            value
        }));
}
function validateAssetUpdates({ nickname = "", mac = "" } = {}, vendor) {
    const serialNumberRegex = new RegExp(/^\d+$/); // will return false for empty string or if the string includes anything but integers
    switch(true){
        case !nickname:
        case nickname?.includes("#"):
            throw new Error("Asset must have a name (# not allowed)");
        case !mac:
            throw new Error("Asset must be given a serial number");
        case ![
            "1",
            (0, _vendors.EPEC_6200_VENDOR_ID),
            (0, _vendors.ACTIA_ACU6_VENDOR_ID)
        ].includes(vendor) && !serialNumberRegex.test(mac):
            throw new Error("Serial number can only include digits 0-9");
        case vendor === (0, _vendors.EPEC_6200_VENDOR_ID) && !mac.startsWith("epec-"):
            throw new Error('epec serial numbers should start with "epec-" followed by the serial');
        case vendor === (0, _vendors.ACTIA_ACU6_VENDOR_ID) && !mac.startsWith("acu6-"):
            throw new Error('acu6 serial numbers should start with "acu6-" followed by the serial');
        case vendor === "1" && !isValidHex(mac):
            throw new Error("EID should be six hex bytes delimited by colons");
    }
}
function isValidHex(h) {
    if (typeof h !== "string") return false;
    const hexBytesArr = h.split(":");
    if (!hexBytesArr.length) return false;
    return hexBytesArr.every((hb)=>{
        const hex = Number.parseInt(hb, 16);
        return hex.toString(16).padStart(2, "0") === hb.toLowerCase();
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","./EditAssetModalDisplay":"2zCAf","../../Services/AssetService":"fL096","../../Services/TemplateService":"hGdvK","../../RBAC/AccessTools":"j912a","../../Constants/StaticUUIDs":"cpjYY","../../Constants/Vendors":"jVaXW","../../Lib/FileOverrides":"eICKy","../../Constants/RBAC":"ieo1E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2zCAf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditAssetModalDisplay", ()=>EditAssetModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _assetBasicInfo = require("./AssetBasicInfo");
var _assetBasicInfoDefault = parcelHelpers.interopDefault(_assetBasicInfo);
var _assetAdvancedInfo = require("./AssetAdvancedInfo");
var _assetTagContainer = require("./AssetTagContainer");
var _assetTagContainerDefault = parcelHelpers.interopDefault(_assetTagContainer);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _updateTagsContext = require("../../Context/UpdateTagsContext");
const EditAssetModalDisplay = ({ asset, availableTemplates, commandAndControl, currentTemplateID, error, handleCCToggle, handlePropUpdate, handlePropUpdateSimple, handleTemplateSelect, handleTimezoneSelected, handleTimezoneToggle, isOpen, selectedTemplate, selectedTimezone, submitUpdate, templatesLoading, timezone, toggle, toggleView, updateRequestPending, stwWiFiControl, stwWiFiEnabled, WiFissid, WiFipassword, vendor, viewing })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        desktopHeight: "50vh",
        isOpen: isOpen,
        toggleModal: toggle,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: toggle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "jsx-3700451873 font-weight-medium text-text-dark",
                    children: "Edit Asset"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "py-0 row align-items-stretch",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-3700451873 d-none d-lg-block col-lg-3 bg-background-gray pt-3 pl-2 modal-side-nav-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-3700451873 mb-3",
                                children: [
                                    viewing === "basics" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-3700451873 page-indicator position-absolute"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>toggleView("basics"),
                                        className: "jsx-3700451873 " + `btn btn-link view-link text-nowrap p-0 w-100 font-weight-medium-2 text-left side-nav text-decoration-none ${viewing === "basics" && "text-muted"}`,
                                        children: "Basics"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-3700451873 mb-3",
                                children: [
                                    viewing === "advanced" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-3700451873 page-indicator position-absolute"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>toggleView("advanced"),
                                        className: "jsx-3700451873 " + `btn btn-link view-link text-nowrap p-0 w-100 font-weight-medium-2 text-left side-nav text-decoration-none ${viewing === "advanced" && "text-muted"}`,
                                        children: "Advanced"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-3700451873 mb-3",
                                children: [
                                    viewing === "tag" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-3700451873 page-indicator position-absolute"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>toggleView("tag"),
                                        className: "jsx-3700451873 " + `btn btn-link view-link text-nowrap p-0 w-100 font-weight-medium-2 text-left side-nav text-decoration-none ${viewing === "tag" && "text-muted"}`,
                                        children: "Tags"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-3700451873 col-12 col-lg-9 bg-white p-3 p-lg-4 modal-main-content-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateTagsContext.UpdateTagsConsumer), {
                                children: (updateTags)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetTagContainerDefault.default), {
                                        visibility: viewing === "tag" ? "" : "d-none",
                                        asset: asset,
                                        updateTags: updateTags
                                    })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                onSubmit: submitUpdate,
                                className: "jsx-3700451873 " + `h-100 d-${viewing === "tag" ? "none" : "flex"} flex-column`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetBasicInfoDefault.default), {
                                        availableTemplates: availableTemplates,
                                        commandAndControl: commandAndControl,
                                        currentTemplateID: currentTemplateID,
                                        customTag: "Custom tag",
                                        handleCCToggle: handleCCToggle,
                                        handlePropUpdate: handlePropUpdate,
                                        handleTemplateSelect: handleTemplateSelect,
                                        handleTimezoneSelected: handleTimezoneSelected,
                                        handleTimezoneToggle: handleTimezoneToggle,
                                        nickname: asset.nickname,
                                        orgID: asset.orgID,
                                        selectedTemplate: selectedTemplate,
                                        selectedTimezone: selectedTimezone,
                                        templatesLoading: templatesLoading,
                                        timezone: timezone,
                                        vendor: vendor,
                                        visibility: viewing === "basics" ? "" : "d-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetAdvancedInfo.AssetAdvancedInfo), {
                                        handlePropUpdateSimple: handlePropUpdateSimple,
                                        stwWiFiControl: stwWiFiControl,
                                        stwWiFiEnabled: stwWiFiEnabled,
                                        WiFipassword: WiFipassword,
                                        WiFissid: WiFissid,
                                        vendor: vendor,
                                        visibility: viewing === "advanced" ? "" : "d-none"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "jsx-3700451873 mb-0 text-right three-quarter-text text-danger",
                                        children: error
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-3700451873 " + `flex-grow-0 d-${viewing === "tag" ? "none" : "flex"} align-items-center justify-content-between justify-content-lg-end`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: toggle,
                                                className: "jsx-3700451873 btn btn-outline-secondary py-0",
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "submit",
                                                className: "jsx-3700451873 btn modal-button-submit py-0 ml-lg-3",
                                                children: updateRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                    spin: true,
                                                    size: "lg"
                                                }) : "Save"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "d-lg-none align-items-center justify-content-around px-0 py-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>toggleView("basics"),
                        className: "jsx-3700451873 btn btn-link p-0 d-flex flex-column align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "jsx-3700451873 fa-layers fa-fw",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: `${viewing === "basics" ? "text-brand-primary" : "text-secondary-gray"}`,
                                        icon: (0, _freeSolidSvgIcons.faCircle),
                                        size: "lg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: "text-white",
                                        icon: (0, _freeSolidSvgIcons.faInfo)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-3700451873 " + `text-nowrap ${viewing === "basics" ? "text-brand-primary" : "text-icon-link-gray"} mt-1 three-quarter-text`,
                                children: "Basics"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>toggleView("advanced"),
                        className: "jsx-3700451873 btn btn-link p-0 d-flex flex-column align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "jsx-3700451873 fa-layers fa-fw",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: `${viewing === "advanced" ? "text-brand-primary" : "text-secondary-gray"}`,
                                        icon: (0, _freeSolidSvgIcons.faCircle),
                                        size: "lg"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faCog),
                                        color: "white"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-3700451873 " + `text-nowrap ${viewing === "advanced" ? "text-brand-primary" : "text-icon-link-gray"} mt-1 three-quarter-text`,
                                children: "Advanced"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>toggleView("tag"),
                        className: "jsx-3700451873 btn btn-link p-0 d-flex flex-column align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-3700451873 fa-layers fa-fw",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    className: `${viewing === "tag" ? "text-brand-primary" : "text-secondary-gray"}`,
                                    icon: (0, _freeSolidSvgIcons.faTag)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-3700451873 " + `text-nowrap ${viewing === "tag" ? "text-brand-primary" : "text-icon-link-gray"}
             mt-1 three-quarter-text`,
                                children: "Tags"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3700451873",
                children: ".page-indicator.jsx-3700451873{background-color:var(--brand-primary);color:var(--brand-primary);height:25px;left:0;width:5px;}.view-link.jsx-3700451873{color:var(--icon-link-gray);font-size:0.5rem;}.view-link.jsx-3700451873:hover{color:var(--text-muted);}.mobile-link-text.jsx-3700451873{font-size:0.75rem;font-weight:400;}@media (min-width:768px){.modal-main-content-container.jsx-3700451873{border-bottom-right-radius:1rem;}.modal-side-nav-container.jsx-3700451873{border-bottom-left-radius:1rem;}.view-link.jsx-3700451873{font-size:1rem;margin-left:0.25rem;}}@media (min-width:992px){.view-link.jsx-3700451873{margin-left:0.5rem;}}"
            })
        ]
    });
};
EditAssetModalDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    availableTemplates: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    commandAndControl: (0, _propTypesDefault.default).bool,
    currentTemplateID: (0, _propTypesDefault.default).string,
    error: (0, _propTypesDefault.default).string,
    handleCCToggle: (0, _propTypesDefault.default).func,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handlePropUpdateSimple: (0, _propTypesDefault.default).func,
    handleTemplateSelect: (0, _propTypesDefault.default).func,
    handleTimezoneSelected: (0, _propTypesDefault.default).func,
    handleTimezoneToggle: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    selectedTemplate: (0, _propTypesDefault.default).object,
    selectedTimezone: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    startingNickname: (0, _propTypesDefault.default).string,
    submitUpdate: (0, _propTypesDefault.default).func,
    templatesLoading: (0, _propTypesDefault.default).bool,
    timezone: (0, _propTypesDefault.default).string,
    toggle: (0, _propTypesDefault.default).func,
    toggleView: (0, _propTypesDefault.default).func,
    updateRequestPending: (0, _propTypesDefault.default).bool,
    stwWiFiControl: (0, _propTypesDefault.default).bool,
    stwWiFiEnabled: (0, _propTypesDefault.default).bool,
    WiFissid: (0, _propTypesDefault.default).string,
    WiFipassword: (0, _propTypesDefault.default).string,
    vendor: (0, _propTypesDefault.default).string,
    viewing: (0, _propTypesDefault.default).string
};
EditAssetModalDisplay.defaultProps = {
    asset: {}
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./AssetBasicInfo":"NSWRW","./AssetAdvancedInfo":"2dJFH","./AssetTagContainer":"hfw25","../ModalLayout":"2RoDj","../../Context/UpdateTagsContext":"jhC9G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"NSWRW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _reactTimezoneSelect = require("react-timezone-select");
var _reactTimezoneSelectDefault = parcelHelpers.interopDefault(_reactTimezoneSelect);
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _editAssetCCDisplay = require("./EditAssetCCDisplay");
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _rbac = require("../../Constants/RBAC");
exports.default = /*#__PURE__*/ (0, _react.memo)(AssetBasicInfo);
function AssetBasicInfo({ availableTemplates, commandAndControl, currentTemplateID, handleCCToggle, handlePropUpdate, handleTemplateSelect, handleTimezoneSelected, handleTimezoneToggle, nickname, orgID, selectedTemplate, selectedTimezone, templatesLoading, timezone, vendor, visibility }) {
    const { primary_alert } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const templateChanged = selectedTemplate?.value && selectedTemplate.value !== currentTemplateID;
    const currentIsProvisionModel = (0, _react.useMemo)(()=>{
        return (0, _staticUUIDs.PROVISION_MODEL_ID_SET).has(currentTemplateID);
    }, [
        currentTemplateID
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-343219397 " + `${visibility} flex-grow-1 text-muted`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-343219397 form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "nickname",
                        className: "jsx-343219397",
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        name: "nickname",
                        type: "text",
                        value: nickname || "",
                        onChange: handlePropUpdate,
                        className: "jsx-343219397 form-control"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-343219397 d-flex align-items-center mb-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                        checked: timezone === "auto",
                        checkedIcon: false,
                        height: 15,
                        onChange: handleTimezoneToggle,
                        onColor: primary_alert,
                        uncheckedIcon: false,
                        width: 30
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-343219397 mb-0 ml-3 modal-supplemental-text",
                        children: "Set Timezone Based On GPS"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-343219397 mb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTimezoneSelectDefault.default), {
                    isClearable: false,
                    isDisabled: timezone === "auto",
                    name: "timezone",
                    onChange: handleTimezoneSelected,
                    placeholder: "Select Timezone",
                    value: selectedTimezone
                })
            }),
            [
                "1"
            ].includes(vendor) ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                orgID: orgID,
                perform: (0, _rbac.ASSET_COMMANDS_UPDATE),
                resource: (0, _rbac.REMOTE),
                yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-343219397 form-group",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editAssetCCDisplay.EditAssetCCDisplay), {
                            commandAndControl: commandAndControl,
                            handleCCToggle: handleCCToggle
                        })
                    })
            }),
            currentIsProvisionModel ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                orgID: orgID,
                perform: (0, _rbac.ASSET_MODEL_READ),
                resource: (0, _rbac.ASSET_MODEL),
                yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-343219397 form-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "assetModel",
                                className: "jsx-343219397",
                                children: "Asset Model"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                id: "assetModelHelp",
                                className: "jsx-343219397 form-text three-quarter-text mb-3 mt-0",
                                children: "Changing the Asset Model will change the collections and signals that this asset uses and how the data is interpreted. The dashboard will default to the new Asset Model's layout."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                "aria-describedby": "assetModelHelp",
                                "aria-labelledby": "assetModelWarning",
                                isDisabled: templatesLoading,
                                isLoading: templatesLoading,
                                isSearchable: true,
                                maxMenuHeight: 175,
                                name: "assetModel",
                                onChange: handleTemplateSelect,
                                options: availableTemplates,
                                value: selectedTemplate
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                id: "assetModelWarning",
                                style: {
                                    height: "20px"
                                },
                                className: "jsx-343219397 mt-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-343219397 " + ((templateChanged ? "form-text three-quarter-text text-warning mt-0" : "d-none") || ""),
                                    children: "You've changed the Asset Model. Asset Model data will be inherited which affects the dashboard, details, alerts, and DM1 Faults."
                                })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "343219397",
                children: ".form-control.jsx-343219397:focus{box-shadow:none;}input.jsx-343219397{color:var(--black-text);}input.jsx-343219397::-webkit-input-placeholder{color:var(--icon-link-gray);font-size:0.9rem;}input.jsx-343219397::-moz-placeholder{color:var(--icon-link-gray);font-size:0.9rem;}input.jsx-343219397:-ms-input-placeholder{color:var(--icon-link-gray);font-size:0.9rem;}input.jsx-343219397::placeholder{color:var(--icon-link-gray);font-size:0.9rem;}"
            })
        ]
    });
}
AssetBasicInfo.propTypes = {
    visibility: (0, _propTypesDefault.default).string,
    nickname: (0, _propTypesDefault.default).string,
    orgID: (0, _propTypesDefault.default).string,
    customTag: (0, _propTypesDefault.default).string,
    handlePropUpdate: (0, _propTypesDefault.default).func,
    availableTemplates: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    templatesLoading: (0, _propTypesDefault.default).bool,
    selectedTemplate: (0, _propTypesDefault.default).object,
    handleTemplateSelect: (0, _propTypesDefault.default).func,
    handleTimezoneSelected: (0, _propTypesDefault.default).func,
    handleTimezoneToggle: (0, _propTypesDefault.default).func,
    currentTemplateID: (0, _propTypesDefault.default).string,
    commandAndControl: (0, _propTypesDefault.default).bool,
    handleCCToggle: (0, _propTypesDefault.default).func,
    selectedTimezone: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    timezone: (0, _propTypesDefault.default).string,
    vendor: (0, _propTypesDefault.default).string
};
AssetBasicInfo.defaultProps = {
    handleTimezoneToggle: ()=>null
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-select":"j36cq","react-switch":"7hX7V","react-timezone-select":"k1XlP","../../Context/BrandingContext":"bKKTd","./EditAssetCCDisplay":"g3CCE","../../RBAC/Can":"l4l8D","../../Constants/StaticUUIDs":"cpjYY","../../Constants/RBAC":"ieo1E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1XlP":[function(require,module,exports) {
// src/index.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allTimezones", ()=>timezone_list_default);
parcelHelpers.export(exports, "default", ()=>src_default);
var _react = require("react");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _spacetime = require("spacetime");
var _spacetimeDefault = parcelHelpers.interopDefault(_spacetime);
var _timezoneSoft = require("timezone-soft");
var _timezoneSoftDefault = parcelHelpers.interopDefault(_timezoneSoft);
// src/timezone-list.ts
var allTimezones = {
    "Pacific/Midway": "Midway Island, Samoa",
    "Pacific/Honolulu": "Hawaii",
    "America/Juneau": "Alaska",
    "America/Boise": "Mountain Time",
    "America/Dawson": "Dawson, Yukon",
    "America/Chihuahua": "Chihuahua, La Paz, Mazatlan",
    "America/Phoenix": "Arizona",
    "America/Chicago": "Central Time",
    "America/Regina": "Saskatchewan",
    "America/Mexico_City": "Guadalajara, Mexico City, Monterrey",
    "America/Belize": "Central America",
    "America/Detroit": "Eastern Time",
    "America/Bogota": "Bogota, Lima, Quito",
    "America/Caracas": "Caracas, La Paz",
    "America/Santiago": "Santiago",
    "America/St_Johns": "Newfoundland and Labrador",
    "America/Sao_Paulo": "Brasilia",
    "America/Tijuana": "Tijuana",
    "America/Montevideo": "Montevideo",
    "America/Argentina/Buenos_Aires": "Buenos Aires, Georgetown",
    "America/Godthab": "Greenland",
    "America/Los_Angeles": "Pacific Time",
    "Atlantic/Azores": "Azores",
    "Atlantic/Cape_Verde": "Cape Verde Islands",
    GMT: "UTC",
    "Europe/London": "Edinburgh, London",
    "Europe/Dublin": "Dublin",
    "Europe/Lisbon": "Lisbon",
    "Africa/Casablanca": "Casablanca, Monrovia",
    "Atlantic/Canary": "Canary Islands",
    "Europe/Belgrade": "Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "Europe/Sarajevo": "Sarajevo, Skopje, Warsaw, Zagreb",
    "Europe/Brussels": "Brussels, Copenhagen, Madrid, Paris",
    "Europe/Amsterdam": "Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "Africa/Algiers": "West Central Africa",
    "Europe/Bucharest": "Bucharest",
    "Africa/Cairo": "Cairo",
    "Europe/Helsinki": "Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "Europe/Athens": "Athens, Minsk",
    "Asia/Jerusalem": "Jerusalem",
    "Africa/Harare": "Harare, Pretoria",
    "Europe/Moscow": "Istanbul, Moscow, St. Petersburg, Volgograd",
    "Asia/Kuwait": "Kuwait, Riyadh",
    "Africa/Nairobi": "Nairobi",
    "Asia/Baghdad": "Baghdad",
    "Asia/Tehran": "Tehran",
    "Asia/Dubai": "Abu Dhabi, Muscat",
    "Asia/Baku": "Baku, Tbilisi, Yerevan",
    "Asia/Kabul": "Kabul",
    "Asia/Yekaterinburg": "Ekaterinburg",
    "Asia/Karachi": "Islamabad, Karachi, Tashkent",
    "Asia/Kolkata": "Chennai, Kolkata, Mumbai, New Delhi",
    "Asia/Kathmandu": "Kathmandu",
    "Asia/Dhaka": "Astana, Dhaka",
    "Asia/Colombo": "Sri Jayawardenepura",
    "Asia/Almaty": "Almaty, Novosibirsk",
    "Asia/Rangoon": "Yangon Rangoon",
    "Asia/Bangkok": "Bangkok, Hanoi, Jakarta",
    "Asia/Krasnoyarsk": "Krasnoyarsk",
    "Asia/Shanghai": "Beijing, Chongqing, Hong Kong SAR, Urumqi",
    "Asia/Kuala_Lumpur": "Kuala Lumpur, Singapore",
    "Asia/Taipei": "Taipei",
    "Australia/Perth": "Perth",
    "Asia/Irkutsk": "Irkutsk, Ulaanbaatar",
    "Asia/Seoul": "Seoul",
    "Asia/Tokyo": "Osaka, Sapporo, Tokyo",
    "Asia/Yakutsk": "Yakutsk",
    "Australia/Darwin": "Darwin",
    "Australia/Adelaide": "Adelaide",
    "Australia/Sydney": "Canberra, Melbourne, Sydney",
    "Australia/Brisbane": "Brisbane",
    "Australia/Hobart": "Hobart",
    "Asia/Vladivostok": "Vladivostok",
    "Pacific/Guam": "Guam, Port Moresby",
    "Asia/Magadan": "Magadan, Solomon Islands, New Caledonia",
    "Asia/Kamchatka": "Kamchatka, Marshall Islands",
    "Pacific/Fiji": "Fiji Islands",
    "Pacific/Auckland": "Auckland, Wellington",
    "Pacific/Tongatapu": "Nuku'alofa"
};
var timezone_list_default = allTimezones;
// src/index.tsx
var TimezoneSelect = ({ value, onBlur, onChange, labelStyle = "original", timezones, maxAbbrLength = 4, ...props })=>{
    if (!timezones) timezones = timezone_list_default;
    const getOptions = _react.useMemo(()=>{
        return Object.entries(timezones).reduce((selectOptions, zone)=>{
            try {
                const now = (0, _spacetimeDefault.default).now(zone[0]);
                const tz = now.timezone();
                const tzStrings = (0, _timezoneSoftDefault.default)(zone[0]);
                let label = "";
                let abbr = now.isDST() ? tzStrings[0].daylight.abbr : tzStrings[0].standard.abbr;
                let altName = now.isDST() ? tzStrings[0].daylight.name : tzStrings[0].standard.name;
                const min = tz.current.offset * 60;
                const hr = `${min / 60 ^ 0}:` + (min % 60 === 0 ? "00" : Math.abs(min % 60));
                const prefix = `(GMT${hr.includes("-") ? hr : `+${hr}`}) ${zone[1]}`;
                switch(labelStyle){
                    case "original":
                        label = prefix;
                        break;
                    case "altName":
                        label = `${prefix} ${altName?.length ? `(${altName})` : ""}`;
                        break;
                    case "abbrev":
                        label = `${prefix} (${abbr.substring(0, maxAbbrLength)})`;
                        break;
                    default:
                        label = `${prefix}`;
                }
                selectOptions.push({
                    value: tz.name,
                    label,
                    offset: tz.current.offset,
                    abbrev: abbr,
                    altName
                });
                return selectOptions;
            } catch  {
                return selectOptions;
            }
        }, []).sort((a, b)=>a.offset - b.offset);
    }, [
        labelStyle,
        timezones
    ]);
    const handleChange = (tz)=>{
        onChange && onChange(tz);
    };
    const findFuzzyTz = (zone)=>{
        let currentTime = (0, _spacetimeDefault.default).now("GMT");
        try {
            currentTime = (0, _spacetimeDefault.default).now(zone);
        } catch (err) {
            return;
        }
        return getOptions.filter((tz)=>tz.offset === currentTime.timezone().current.offset).map((tz)=>{
            let score = 0;
            if (currentTime.timezones[tz.value.toLowerCase()] && !!currentTime.timezones[tz.value.toLowerCase()].dst === currentTime.timezone().hasDst) {
                if (tz.value.toLowerCase().indexOf(currentTime.tz.substring(currentTime.tz.indexOf("/") + 1)) !== -1) score += 8;
                if (tz.label.toLowerCase().indexOf(currentTime.tz.substring(currentTime.tz.indexOf("/") + 1)) !== -1) score += 4;
                if (tz.value.toLowerCase().indexOf(currentTime.tz.substring(0, currentTime.tz.indexOf("/")))) score += 2;
                score += 1;
            } else if (tz.value === "GMT") score += 1;
            return {
                tz,
                score
            };
        }).sort((a, b)=>b.score - a.score).map(({ tz })=>tz)[0];
    };
    const parseTimezone = (zone)=>{
        if (typeof zone === "object" && zone.value && zone.label) return zone;
        if (typeof zone === "string") return getOptions.find((tz)=>tz.value === zone) || zone.indexOf("/") !== -1 && findFuzzyTz(zone);
        else if (zone.value && !zone.label) return getOptions.find((tz)=>tz.value === zone.value);
    };
    return /* @__PURE__ */ _react.createElement((0, _reactSelectDefault.default), {
        value: parseTimezone(value),
        onChange: handleChange,
        options: getOptions,
        onBlur,
        ...props
    });
};
var src_default = TimezoneSelect;

},{"react":"9njXz","react-select":"j36cq","spacetime":"lj2Pi","timezone-soft":"7NEXe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lj2Pi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _spacetimeJs = require("./spacetime.js");
var _spacetimeJsDefault = parcelHelpers.interopDefault(_spacetimeJs);
var _whereItsJs = require("./whereIts.js");
var _whereItsJsDefault = parcelHelpers.interopDefault(_whereItsJs);
var _versionJs = require("./_version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
const main = (input, tz, options)=>new (0, _spacetimeJsDefault.default)(input, tz, options);
// set all properties of a given 'today' object
const setToday = function(s) {
    let today = s._today || {};
    Object.keys(today).forEach((k)=>{
        s = s[k](today[k]);
    });
    return s;
};
//some helper functions on the main method
main.now = (tz, options)=>{
    let s = new (0, _spacetimeJsDefault.default)(new Date().getTime(), tz, options);
    s = setToday(s);
    return s;
};
main.today = (tz, options)=>{
    let s = new (0, _spacetimeJsDefault.default)(new Date().getTime(), tz, options);
    s = setToday(s);
    return s.startOf("day");
};
main.tomorrow = (tz, options)=>{
    let s = new (0, _spacetimeJsDefault.default)(new Date().getTime(), tz, options);
    s = setToday(s);
    return s.add(1, "day").startOf("day");
};
main.yesterday = (tz, options)=>{
    let s = new (0, _spacetimeJsDefault.default)(new Date().getTime(), tz, options);
    s = setToday(s);
    return s.subtract(1, "day").startOf("day");
};
main.extend = function(obj = {}) {
    Object.keys(obj).forEach((k)=>{
        (0, _spacetimeJsDefault.default).prototype[k] = obj[k];
    });
    return this;
};
main.timezones = function() {
    let s = new (0, _spacetimeJsDefault.default)();
    return s.timezones;
};
main.max = function(tz, options) {
    let s = new (0, _spacetimeJsDefault.default)(null, tz, options);
    s.epoch = 8640000000000000;
    return s;
};
main.min = function(tz, options) {
    let s = new (0, _spacetimeJsDefault.default)(null, tz, options);
    s.epoch = -8640000000000000;
    return s;
};
//find tz by time
main.whereIts = (0, _whereItsJsDefault.default);
main.version = (0, _versionJsDefault.default);
//aliases:
main.plugin = main.extend;
exports.default = main;

},{"./spacetime.js":"fZpA2","./whereIts.js":"iJzec","./_version.js":"1qoR9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fZpA2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _quickJs = require("./timezone/quick.js");
var _quickJsDefault = parcelHelpers.interopDefault(_quickJs);
var _findJs = require("./timezone/find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _indexJs = require("./input/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _methodsJs = require("./methods.js");
var _methodsJsDefault = parcelHelpers.interopDefault(_methodsJs);
var _unpackJs = require("../zonefile/unpack.js");
var _unpackJsDefault = parcelHelpers.interopDefault(_unpackJs);
var _indexJs1 = require("./methods/query/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _addJs = require("./methods/add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _sameJs = require("./methods/same.js");
var _sameJsDefault = parcelHelpers.interopDefault(_sameJs);
var _compareJs = require("./methods/compare.js");
var _compareJsDefault = parcelHelpers.interopDefault(_compareJs);
var _i18NJs = require("./methods/i18n.js");
var _i18NJsDefault = parcelHelpers.interopDefault(_i18NJs);
let timezones = (0, _unpackJsDefault.default);
// fake timezone-support, for fakers (es5 class)
const SpaceTime = function(input, tz, options = {}) {
    // the holy moment
    this.epoch = null;
    // the shift for the given timezone
    this.tz = (0, _findJsDefault.default)(tz, timezones);
    // whether to output warnings to console
    this.silent = typeof options.silent !== "undefined" ? options.silent : true;
    // favour british interpretation of 02/02/2018, etc
    this.british = options.dmy || options.british;
    // does the week start on sunday, or monday:
    this._weekStart = 1 // default to monday
    ;
    if (options.weekStart !== undefined) this._weekStart = options.weekStart;
    // the reference today date object, (for testing)
    this._today = {};
    if (options.today !== undefined) this._today = options.today;
    // dunno if this is a good idea, or not
    // Object.defineProperty(this, 'parsers', {
    //   enumerable: false,
    //   writable: true,
    //   value: parsers
    // })
    // add getter/setters
    Object.defineProperty(this, "d", {
        // return a js date object
        get: function() {
            let offset = (0, _quickJsDefault.default)(this);
            // every computer is somewhere- get this computer's built-in offset
            let bias = new Date(this.epoch).getTimezoneOffset() || 0;
            // movement
            let shift = bias + offset * 60 //in minutes
            ;
            shift = shift * 60000 //in ms
            ;
            // remove this computer's offset
            let epoch = this.epoch + shift;
            let d = new Date(epoch);
            return d;
        }
    });
    // add this data on the object, to allow adding new timezones
    Object.defineProperty(this, "timezones", {
        get: ()=>timezones,
        set: (obj)=>{
            timezones = obj;
            return obj;
        }
    });
    // parse the various formats
    let tmp = (0, _indexJsDefault.default)(this, input);
    this.epoch = tmp.epoch;
};
// (add instance methods to prototype)
Object.keys((0, _methodsJsDefault.default)).forEach((k)=>{
    SpaceTime.prototype[k] = (0, _methodsJsDefault.default)[k];
});
// ¯\_(ツ)_/¯
SpaceTime.prototype.clone = function() {
    return new SpaceTime(this.epoch, this.tz, {
        silent: this.silent,
        weekStart: this._weekStart,
        today: this._today,
        parsers: this.parsers
    });
};
/**
 * @deprecated use toNativeDate()
 * @returns native date object at the same epoch
 */ SpaceTime.prototype.toLocalDate = function() {
    return this.toNativeDate();
};
/**
 * @returns native date object at the same epoch
 */ SpaceTime.prototype.toNativeDate = function() {
    return new Date(this.epoch);
};
// append more methods
(0, _indexJsDefault1.default)(SpaceTime);
(0, _addJsDefault.default)(SpaceTime);
(0, _sameJsDefault.default)(SpaceTime);
(0, _compareJsDefault.default)(SpaceTime);
(0, _i18NJsDefault.default)(SpaceTime);
exports.default = SpaceTime;

},{"./timezone/quick.js":"fMWvj","./timezone/find.js":"dtXkU","./input/index.js":"9vnjn","./methods.js":"4nh7t","../zonefile/unpack.js":"gOOys","./methods/query/index.js":"7Uo4Q","./methods/add.js":"ad1Wb","./methods/same.js":"l6fFq","./methods/compare.js":"kYGBp","./methods/i18n.js":"1dCRq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMWvj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _summerTimeJs = require("./summerTime.js");
var _summerTimeJsDefault = parcelHelpers.interopDefault(_summerTimeJs);
// this method avoids having to do a full dst-calculation on every operation
// it reproduces some things in ./index.js, but speeds up spacetime considerably
const quickOffset = (s)=>{
    let zones = s.timezones;
    let obj = zones[s.tz];
    if (obj === undefined) {
        console.warn("Warning: couldn't find timezone " + s.tz);
        return 0;
    }
    if (obj.dst === undefined) return obj.offset;
    //get our two possible offsets
    let jul = obj.offset;
    let dec = obj.offset + 1 // assume it's the same for now
    ;
    if (obj.hem === "n") dec = jul - 1;
    let split = obj.dst.split("->");
    let inSummer = (0, _summerTimeJsDefault.default)(s.epoch, split[0], split[1], jul, dec);
    if (inSummer === true) return jul;
    return dec;
};
exports.default = quickOffset;

},{"./summerTime.js":"jCZVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCZVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const MSEC_IN_HOUR = 3600000;
//convert our local date syntax a javascript UTC date
const toUtc = (dstChange, offset, year)=>{
    const [month, rest] = dstChange.split("/");
    const [day, hour] = rest.split(":");
    return Date.UTC(year, month - 1, day, hour) - offset * MSEC_IN_HOUR;
};
// compare epoch with dst change events (in utc)
const inSummerTime = (epoch, start, end, summerOffset, winterOffset)=>{
    const year = new Date(epoch).getUTCFullYear();
    const startUtc = toUtc(start, winterOffset, year);
    const endUtc = toUtc(end, summerOffset, year);
    // simple number comparison now
    return epoch >= startUtc && epoch < endUtc;
};
exports.default = inSummerTime;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dtXkU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unpackJs = require("../../zonefile/unpack.js");
var _unpackJsDefault = parcelHelpers.interopDefault(_unpackJs);
var _guessTzJs = require("./guessTz.js");
var _guessTzJsDefault = parcelHelpers.interopDefault(_guessTzJs);
var _parseOffsetJs = require("./parseOffset.js");
var _parseOffsetJsDefault = parcelHelpers.interopDefault(_parseOffsetJs);
let local = (0, _guessTzJsDefault.default)();
//add all the city names by themselves
const cities = Object.keys((0, _unpackJsDefault.default)).reduce((h, k)=>{
    let city = k.split("/")[1] || "";
    city = city.replace(/_/g, " ");
    h[city] = k;
    return h;
}, {});
//try to match these against iana form
const normalize = (tz)=>{
    tz = tz.replace(/ time/g, "");
    tz = tz.replace(/ (standard|daylight|summer)/g, "");
    tz = tz.replace(/\b(east|west|north|south)ern/g, "$1");
    tz = tz.replace(/\b(africa|america|australia)n/g, "$1");
    tz = tz.replace(/\beuropean/g, "europe");
    tz = tz.replace(/\islands/g, "island");
    return tz;
};
// try our best to reconcile the timzone to this given string
const lookupTz = (str, zones)=>{
    if (!str) {
        // guard if Intl response is unsupported (#397)
        if (!zones.hasOwnProperty(local)) {
            console.warn(`Unrecognized IANA id '${local}'. Setting fallback tz to UTC.`);
            local = "utc";
        }
        return local;
    }
    if (typeof str !== "string") console.error("Timezone must be a string - recieved: '", str, "'\n");
    let tz = str.trim();
    // let split = str.split('/')
    //support long timezones like 'America/Argentina/Rio_Gallegos'
    // if (split.length > 2 && zones.hasOwnProperty(tz) === false) {
    //   tz = split[0] + '/' + split[1]
    // }
    tz = tz.toLowerCase();
    if (zones.hasOwnProperty(tz) === true) return tz;
    //lookup more loosely..
    tz = normalize(tz);
    if (zones.hasOwnProperty(tz) === true) return tz;
    //try city-names
    if (cities.hasOwnProperty(tz) === true) return cities[tz];
    // //try to parse '-5h'
    if (/[0-9]/.test(tz) === true) {
        let id = (0, _parseOffsetJsDefault.default)(tz);
        if (id) return id;
    }
    throw new Error("Spacetime: Cannot find timezone named: '" + str + "'. Please enter an IANA timezone id.");
};
exports.default = lookupTz;

},{"../../zonefile/unpack.js":"gOOys","./guessTz.js":"3ZXzJ","./parseOffset.js":"3jXaB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gOOys":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buildJs = require("./_build.js");
var _buildJsDefault = parcelHelpers.interopDefault(_buildJs);
var _prefixesJs = require("./_prefixes.js");
var _prefixesJsDefault = parcelHelpers.interopDefault(_prefixesJs);
let all = {};
Object.keys((0, _buildJsDefault.default)).forEach((k)=>{
    let split = k.split("|");
    let obj = {
        offset: Number(split[0]),
        hem: split[1]
    };
    if (split[2]) obj.dst = split[2];
    let names = (0, _buildJsDefault.default)[k].split(",");
    names.forEach((str)=>{
        str = str.replace(/(^[0-9]+)\//, (before, num)=>{
            num = Number(num);
            return (0, _prefixesJsDefault.default)[num] + "/";
        });
        all[str] = obj;
    });
});
all.utc = {
    offset: 0,
    hem: "n" //default to northern hemisphere - (sorry!)
};
//add etc/gmt+n
for(let i = -14; i <= 14; i += 0.5){
    let num = i;
    if (num > 0) num = "+" + num;
    let name = "etc/gmt" + num;
    all[name] = {
        offset: i * -1,
        hem: "n" //(sorry)
    };
    name = "utc/gmt" + num //this one too, why not.
    ;
    all[name] = {
        offset: i * -1,
        hem: "n"
    };
}
exports.default = all;

},{"./_build.js":"dlQMp","./_prefixes.js":"5k1gK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dlQMp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    "9|s": "2/dili,2/jayapura",
    "9|n": "2/chita,2/khandyga,2/pyongyang,2/seoul,2/tokyo,2/yakutsk,11/palau,japan,rok",
    "9.5|s|04/07:03->10/06:02": "4/adelaide,4/broken_hill,4/south,4/yancowinna",
    "9.5|s": "4/darwin,4/north",
    "8|s|03/13:01->10/02:00": "12/casey",
    "8|s": "2/kuala_lumpur,2/makassar,2/singapore,4/perth,2/ujung_pandang,4/west,singapore",
    "8|n": "2/brunei,2/choibalsan,2/hong_kong,2/irkutsk,2/kuching,2/macau,2/manila,2/shanghai,2/taipei,2/ulaanbaatar,2/chongqing,2/chungking,2/harbin,2/macao,2/ulan_bator,hongkong,prc,roc",
    "8.75|s": "4/eucla",
    "7|s": "12/davis,2/jakarta,9/christmas",
    "7|n": "2/bangkok,2/barnaul,2/hovd,2/krasnoyarsk,2/novokuznetsk,2/novosibirsk,2/phnom_penh,2/pontianak,2/ho_chi_minh,2/tomsk,2/vientiane,2/saigon",
    "6|s": "12/vostok",
    "6|n": "2/almaty,2/bishkek,2/dhaka,2/omsk,2/qyzylorda,2/qostanay,2/thimphu,2/urumqi,9/chagos,2/dacca,2/kashgar,2/thimbu",
    "6.5|n": "2/yangon,9/cocos,2/rangoon",
    "5|s": "12/mawson,9/kerguelen",
    "5|n": "2/aqtau,2/aqtobe,2/ashgabat,2/atyrau,2/dushanbe,2/karachi,2/oral,2/samarkand,2/tashkent,2/yekaterinburg,9/maldives,2/ashkhabad",
    "5.75|n": "2/kathmandu,2/katmandu",
    "5.5|n": "2/kolkata,2/colombo,2/calcutta",
    "4|s": "9/reunion",
    "4|n": "2/baku,2/dubai,2/muscat,2/tbilisi,2/yerevan,8/astrakhan,8/samara,8/saratov,8/ulyanovsk,8/volgograd,9/mahe,9/mauritius,2/volgograd",
    "4.5|n": "2/kabul",
    "3|s": "12/syowa,9/antananarivo",
    "3|n|04/28:00->10/26:24": "0/cairo,egypt",
    "3|n|03/31:03->10/27:04": "2/famagusta,2/nicosia,8/athens,8/bucharest,8/helsinki,8/mariehamn,8/riga,8/sofia,8/tallinn,8/uzhgorod,8/vilnius,8/zaporozhye,8/nicosia,eet",
    "3|n|03/31:02->10/27:03": "8/chisinau,8/tiraspol",
    "3|n|03/31:00->10/26:24": "2/beirut",
    "3|n|03/31:00->10/25:01": "2/gaza,2/hebron",
    "3|n|03/29:02->10/27:02": "2/jerusalem,2/tel_aviv,israel",
    "3|n|03/26:03->10/29:04": "8/kyiv,8/kiev",
    "3|n": "0/addis_ababa,0/asmara,0/asmera,0/dar_es_salaam,0/djibouti,0/juba,0/kampala,0/mogadishu,0/nairobi,2/aden,2/amman,2/baghdad,2/bahrain,2/damascus,2/kuwait,2/qatar,2/riyadh,8/istanbul,8/kirov,8/minsk,8/moscow,8/simferopol,9/comoro,9/mayotte,2/istanbul,turkey,w-su",
    "3.5|n": "2/tehran,iran",
    "2|s|03/31:02->10/27:02": "12/troll",
    "2|s": "0/gaborone,0/harare,0/johannesburg,0/lubumbashi,0/lusaka,0/maputo,0/maseru,0/mbabane",
    "2|n|03/31:02->10/27:03": "0/ceuta,arctic/longyearbyen,8/amsterdam,8/andorra,8/belgrade,8/berlin,8/bratislava,8/brussels,8/budapest,8/busingen,8/copenhagen,8/gibraltar,8/ljubljana,8/luxembourg,8/madrid,8/malta,8/monaco,8/oslo,8/paris,8/podgorica,8/prague,8/rome,8/san_marino,8/sarajevo,8/skopje,8/stockholm,8/tirane,8/vaduz,8/vatican,8/vienna,8/warsaw,8/zagreb,8/zurich,3/jan_mayen,poland,cet,met",
    "2|n": "0/blantyre,0/bujumbura,0/khartoum,0/kigali,0/tripoli,8/kaliningrad,libya",
    "1|s": "0/brazzaville,0/kinshasa,0/luanda,0/windhoek",
    "1|n|03/31:01->10/27:02": "3/canary,3/faroe,3/madeira,8/dublin,8/guernsey,8/isle_of_man,8/jersey,8/lisbon,8/london,3/faeroe,eire,8/belfast,gb-eire,gb,portugal,wet",
    "1|n": "0/algiers,0/bangui,0/douala,0/lagos,0/libreville,0/malabo,0/ndjamena,0/niamey,0/porto-novo,0/tunis",
    "14|n": "11/kiritimati",
    "13|s": "11/apia,11/tongatapu",
    "13|n": "11/enderbury,11/kanton,11/fakaofo",
    "12|s|04/07:03->09/29:02": "12/mcmurdo,11/auckland,12/south_pole,nz",
    "12|s": "11/fiji",
    "12|n": "2/anadyr,2/kamchatka,2/srednekolymsk,11/funafuti,11/kwajalein,11/majuro,11/nauru,11/tarawa,11/wake,11/wallis,kwajalein",
    "12.75|s|04/07:03->04/07:02": "11/chatham,nz-chat",
    "11|s|04/07:03->10/06:02": "12/macquarie",
    "11|s": "11/bougainville",
    "11|n": "2/magadan,2/sakhalin,11/efate,11/guadalcanal,11/kosrae,11/noumea,11/pohnpei,11/ponape",
    "11.5|n|04/07:03->10/06:02": "11/norfolk",
    "10|s|04/07:03->10/06:02": "4/currie,4/hobart,4/melbourne,4/sydney,4/act,4/canberra,4/nsw,4/tasmania,4/victoria",
    "10|s": "12/dumontdurville,4/brisbane,4/lindeman,11/port_moresby,4/queensland",
    "10|n": "2/ust-nera,2/vladivostok,11/guam,11/saipan,11/chuuk,11/truk,11/yap",
    "10.5|s|04/07:01->10/06:02": "4/lord_howe,4/lhi",
    "0|s|03/10:03->04/14:02": "0/casablanca,0/el_aaiun",
    "0|n|03/31:00->10/27:01": "1/scoresbysund,3/azores",
    "0|n": "0/abidjan,0/accra,0/bamako,0/banjul,0/bissau,0/conakry,0/dakar,0/freetown,0/lome,0/monrovia,0/nouakchott,0/ouagadougou,0/sao_tome,1/danmarkshavn,3/reykjavik,3/st_helena,13/gmt,13/utc,0/timbuktu,13/greenwich,13/uct,13/universal,13/zulu,gmt-0,gmt+0,gmt0,greenwich,iceland,uct,universal,utc,zulu,13/unknown,factory",
    "-9|n|03/10:02->11/03:02": "1/adak,1/atka,us/aleutian",
    "-9|n": "11/gambier",
    "-9.5|n": "11/marquesas",
    "-8|n|03/10:02->11/03:02": "1/anchorage,1/juneau,1/nome,1/sitka,1/yakutat,us/alaska",
    "-8|n": "1/metlakatla,11/pitcairn",
    "-7|n|03/10:02->11/03:02": "1/los_angeles,1/santa_isabel,1/tijuana,1/vancouver,1/ensenada,6/pacific,10/bajanorte,us/pacific-new,us/pacific",
    "-7|n": "1/creston,1/dawson,1/dawson_creek,1/fort_nelson,1/hermosillo,1/mazatlan,1/phoenix,1/whitehorse,6/yukon,10/bajasur,us/arizona,mst",
    "-6|s|04/06:22->09/07:22": "11/easter,7/easterisland",
    "-6|n|04/07:02->10/27:02": "1/merida",
    "-6|n|03/12:02->11/05:02": "1/ciudad_juarez",
    "-6|n|03/10:02->11/03:02": "1/boise,1/cambridge_bay,1/denver,1/edmonton,1/inuvik,1/north_dakota,1/ojinaga,1/yellowknife,1/shiprock,6/mountain,navajo,us/mountain",
    "-6|n": "1/bahia_banderas,1/belize,1/chihuahua,1/costa_rica,1/el_salvador,1/guatemala,1/managua,1/mexico_city,1/monterrey,1/regina,1/swift_current,1/tegucigalpa,11/galapagos,6/east-saskatchewan,6/saskatchewan,10/general",
    "-5|s": "1/lima,1/rio_branco,1/porto_acre,5/acre",
    "-5|n|03/10:02->11/03:02": "1/chicago,1/matamoros,1/menominee,1/rainy_river,1/rankin_inlet,1/resolute,1/winnipeg,1/indiana/knox,1/indiana/tell_city,1/north_dakota/beulah,1/north_dakota/center,1/north_dakota/new_salem,1/knox_in,6/central,us/central,us/indiana-starke",
    "-5|n": "1/bogota,1/cancun,1/cayman,1/coral_harbour,1/eirunepe,1/guayaquil,1/jamaica,1/panama,1/atikokan,jamaica,est",
    "-4|s|04/06:24->09/08:00": "1/santiago,7/continental",
    "-4|s|03/23:24->10/06:00": "1/asuncion",
    "-4|s": "1/campo_grande,1/cuiaba,1/la_paz,1/manaus,5/west",
    "-4|n|03/10:02->11/03:02": "1/detroit,1/grand_turk,1/indiana,1/indianapolis,1/iqaluit,1/kentucky,1/louisville,1/montreal,1/nassau,1/new_york,1/nipigon,1/pangnirtung,1/port-au-prince,1/thunder_bay,1/toronto,1/indiana/marengo,1/indiana/petersburg,1/indiana/vevay,1/indiana/vincennes,1/indiana/winamac,1/kentucky/monticello,1/fort_wayne,1/indiana/indianapolis,1/kentucky/louisville,6/eastern,us/east-indiana,us/eastern,us/michigan",
    "-4|n|03/10:00->11/03:01": "1/havana,cuba",
    "-4|n": "1/anguilla,1/antigua,1/aruba,1/barbados,1/blanc-sablon,1/boa_vista,1/caracas,1/curacao,1/dominica,1/grenada,1/guadeloupe,1/guyana,1/kralendijk,1/lower_princes,1/marigot,1/martinique,1/montserrat,1/port_of_spain,1/porto_velho,1/puerto_rico,1/santo_domingo,1/st_barthelemy,1/st_kitts,1/st_lucia,1/st_thomas,1/st_vincent,1/tortola,1/virgin",
    "-3|s": "1/argentina,1/buenos_aires,1/catamarca,1/cordoba,1/fortaleza,1/jujuy,1/mendoza,1/montevideo,1/punta_arenas,1/sao_paulo,12/palmer,12/rothera,3/stanley,1/argentina/la_rioja,1/argentina/rio_gallegos,1/argentina/salta,1/argentina/san_juan,1/argentina/san_luis,1/argentina/tucuman,1/argentina/ushuaia,1/argentina/comodrivadavia,1/argentina/buenos_aires,1/argentina/catamarca,1/argentina/cordoba,1/argentina/jujuy,1/argentina/mendoza,1/argentina/rosario,1/rosario,5/east",
    "-3|n|03/10:02->11/03:02": "1/glace_bay,1/goose_bay,1/halifax,1/moncton,1/thule,3/bermuda,6/atlantic",
    "-3|n": "1/araguaina,1/bahia,1/belem,1/cayenne,1/maceio,1/paramaribo,1/recife,1/santarem",
    "-2|n|03/30:22->10/26:23": "1/nuuk,1/godthab",
    "-2|n|03/10:02->11/03:02": "1/miquelon",
    "-2|n": "1/noronha,3/south_georgia,5/denoronha",
    "-2.5|n|03/10:02->11/03:02": "1/st_johns,6/newfoundland",
    "-1|n": "3/cape_verde",
    "-11|n": "11/midway,11/niue,11/pago_pago,11/samoa,us/samoa",
    "-10|n": "11/honolulu,11/johnston,11/rarotonga,11/tahiti,us/hawaii,hst"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5k1gK":[function(require,module,exports) {
//prefixes for iana names..
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "africa",
    "america",
    "asia",
    "atlantic",
    "australia",
    "brazil",
    "canada",
    "chile",
    "europe",
    "indian",
    "mexico",
    "pacific",
    "antarctica",
    "etc"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ZXzJ":[function(require,module,exports) {
//find the implicit iana code for this machine.
//safely query the Intl object
//based on - https://bitbucket.org/pellepim/jstimezonedetect/src
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const fallbackTZ = "utc" //
;
//this Intl object is not supported often, yet
const safeIntl = ()=>{
    if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") return null;
    let format = Intl.DateTimeFormat();
    if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") return null;
    let timezone = format.resolvedOptions().timeZone;
    if (!timezone) return null;
    return timezone.toLowerCase();
};
const guessTz = ()=>{
    let timezone = safeIntl();
    if (timezone === null) return fallbackTZ;
    return timezone;
};
//do it once per computer
exports.default = guessTz;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jXaB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const isOffset = /(\-?[0-9]+)h(rs)?/i;
const isNumber = /(\-?[0-9]+)/;
const utcOffset = /utc([\-+]?[0-9]+)/i;
const gmtOffset = /gmt([\-+]?[0-9]+)/i;
const toIana = function(num) {
    num = Number(num);
    if (num >= -13 && num <= 13) {
        num = num * -1 //it's opposite!
        ;
        num = (num > 0 ? "+" : "") + num //add plus sign
        ;
        return "etc/gmt" + num;
    }
    return null;
};
const parseOffset = function(tz) {
    // '+5hrs'
    let m = tz.match(isOffset);
    if (m !== null) return toIana(m[1]);
    // 'utc+5'
    m = tz.match(utcOffset);
    if (m !== null) return toIana(m[1]);
    // 'GMT-5' (not opposite)
    m = tz.match(gmtOffset);
    if (m !== null) {
        let num = Number(m[1]) * -1;
        return toIana(num);
    }
    // '+5'
    m = tz.match(isNumber);
    if (m !== null) return toIana(m[1]);
    return null;
};
exports.default = parseOffset;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9vnjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../fns.js");
var _helpersJs = require("./helpers.js");
var _helpersJsDefault = parcelHelpers.interopDefault(_helpersJs);
var _namedDatesJs = require("./named-dates.js");
var _namedDatesJsDefault = parcelHelpers.interopDefault(_namedDatesJs);
var _normalizeJs = require("./normalize.js");
var _normalizeJsDefault = parcelHelpers.interopDefault(_normalizeJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
const { parseArray, parseObject, parseNumber } = (0, _helpersJsDefault.default);
//we have to actually parse these inputs ourselves
//  -  can't use built-in js parser ;(
//=========================================
// ISO Date	  "2015-03-25"
// Short Date	"03/25/2015" or "2015/03/25"
// Long Date	"Mar 25 2015" or "25 Mar 2015"
// Full Date	"Wednesday March 25 2015"
//=========================================
const defaults = {
    year: new Date().getFullYear(),
    month: 0,
    date: 1
};
//find the epoch from different input styles
const parseInput = (s, input)=>{
    let today = s._today || defaults;
    //if we've been given a epoch number, it's easy
    if (typeof input === "number") return parseNumber(s, input);
    //set tmp time
    s.epoch = Date.now();
    // overwrite tmp time with 'today' value, if exists
    if (s._today && (0, _fnsJs.isObject)(s._today) && Object.keys(s._today).length > 0) {
        let res = parseObject(s, today, defaults);
        if (res.isValid()) s.epoch = res.epoch;
    }
    // null input means 'now'
    if (input === null || input === undefined || input === "") return s //k, we're good.
    ;
    //support input of Date() object
    if ((0, _fnsJs.isDate)(input) === true) {
        s.epoch = input.getTime();
        return s;
    }
    //support [2016, 03, 01] format
    if ((0, _fnsJs.isArray)(input) === true) {
        s = parseArray(s, input, today);
        return s;
    }
    //support {year:2016, month:3} format
    if ((0, _fnsJs.isObject)(input) === true) {
        //support spacetime object as input
        if (input.epoch) {
            s.epoch = input.epoch;
            s.tz = input.tz;
            return s;
        }
        s = parseObject(s, input, today);
        return s;
    }
    //input as a string..
    if (typeof input !== "string") return s;
    //little cleanup..
    input = (0, _normalizeJsDefault.default)(input);
    //try some known-words, like 'now'
    if ((0, _namedDatesJsDefault.default).hasOwnProperty(input) === true) {
        s = (0, _namedDatesJsDefault.default)[input](s);
        return s;
    }
    //try each text-parse template, use the first good result
    return (0, _parseJsDefault.default)(s, input);
};
exports.default = parseInput;

},{"../fns.js":"dnKgs","./helpers.js":"fICsI","./named-dates.js":"5wlIM","./normalize.js":"sDQAv","./parse.js":"4m33H","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnKgs":[function(require,module,exports) {
//git:blame @JuliasCaesar https://www.timeanddate.com/date/leapyear.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLeapYear", ()=>isLeapYear);
// unsurprisingly-nasty `typeof date` call
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "zeroPad", ()=>zeroPad);
parcelHelpers.export(exports, "titleCase", ()=>titleCase);
parcelHelpers.export(exports, "ordinal", ()=>ordinal);
//strip 'st' off '1st'..
parcelHelpers.export(exports, "toCardinal", ()=>toCardinal);
//used mostly for cleanup of unit names, like 'months'
parcelHelpers.export(exports, "normalize", ()=>normalize);
parcelHelpers.export(exports, "getEpoch", ()=>getEpoch);
//make sure this input is a spacetime obj
parcelHelpers.export(exports, "beADate", ()=>beADate);
parcelHelpers.export(exports, "formatTimezone", ()=>formatTimezone);
function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function isDate(d) {
    return Object.prototype.toString.call(d) === "[object Date]" && !isNaN(d.valueOf());
}
function isArray(input) {
    return Object.prototype.toString.call(input) === "[object Array]";
}
function isObject(input) {
    return Object.prototype.toString.call(input) === "[object Object]";
}
function isBoolean(input) {
    return Object.prototype.toString.call(input) === "[object Boolean]";
}
function zeroPad(str, len = 2) {
    let pad = "0";
    str = str + "";
    return str.length >= len ? str : new Array(len - str.length + 1).join(pad) + str;
}
function titleCase(str) {
    if (!str) return "";
    return str[0].toUpperCase() + str.substr(1);
}
function ordinal(i) {
    let j = i % 10;
    let k = i % 100;
    if (j === 1 && k !== 11) return i + "st";
    if (j === 2 && k !== 12) return i + "nd";
    if (j === 3 && k !== 13) return i + "rd";
    return i + "th";
}
function toCardinal(str) {
    str = String(str);
    str = str.replace(/([0-9])(st|nd|rd|th)$/i, "$1");
    return parseInt(str, 10);
}
function normalize(str = "") {
    str = str.toLowerCase().trim();
    str = str.replace(/ies$/, "y") //'centuries'
    ;
    str = str.replace(/s$/, "");
    str = str.replace(/-/g, "");
    if (str === "day" || str === "days") return "date";
    if (str === "min" || str === "mins") return "minute";
    return str;
}
function getEpoch(tmp) {
    //support epoch
    if (typeof tmp === "number") return tmp;
    //suport date objects
    if (isDate(tmp)) return tmp.getTime();
    if (tmp.epoch) return tmp.epoch;
    return null;
}
function beADate(d, s) {
    if (isObject(d) === false) return s.clone().set(d);
    return d;
}
function formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "+" : "-";
    const absOffset = Math.abs(offset);
    const hours = zeroPad(parseInt("" + absOffset, 10));
    const minutes = zeroPad(absOffset % 1 * 60);
    return `${sign}${hours}${delimiter}${minutes}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fICsI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const defaults = {
    year: new Date().getFullYear(),
    month: 0,
    date: 1
};
//support [2016, 03, 01] format
const parseArray = (s, arr, today)=>{
    if (arr.length === 0) return s;
    let order = [
        "year",
        "month",
        "date",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    for(let i = 0; i < order.length; i++){
        let num = arr[i] || today[order[i]] || defaults[order[i]] || 0;
        s = s[order[i]](num);
    }
    return s;
};
//support {year:2016, month:3} format
const parseObject = (s, obj, today)=>{
    // if obj is empty, do nothing
    if (Object.keys(obj).length === 0) return s;
    obj = Object.assign({}, defaults, today, obj);
    let keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        let unit = keys[i];
        //make sure we have this method
        if (s[unit] === undefined || typeof s[unit] !== "function") continue;
        //make sure the value is a number
        if (obj[unit] === null || obj[unit] === undefined || obj[unit] === "") continue;
        let num = obj[unit] || today[unit] || defaults[unit] || 0;
        s = s[unit](num);
    }
    return s;
};
// this may seem like an arbitrary number, but it's 'within jan 1970'
// this is only really ambiguous until 2054 or so
const parseNumber = function(s, input) {
    const minimumEpoch = 2500000000;
    // if the given epoch is really small, they've probably given seconds and not milliseconds
    // anything below this number is likely (but not necessarily) a mistaken input.
    if (input > 0 && input < minimumEpoch && s.silent === false) {
        console.warn("  - Warning: You are setting the date to January 1970.");
        console.warn("       -   did input seconds instead of milliseconds?");
    }
    s.epoch = input;
    return s;
};
exports.default = {
    parseArray,
    parseObject,
    parseNumber
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5wlIM":[function(require,module,exports) {
// pull in 'today' data for the baseline moment
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const getNow = function(s) {
    s.epoch = Date.now();
    Object.keys(s._today || {}).forEach((k)=>{
        if (typeof s[k] === "function") s = s[k](s._today[k]);
    });
    return s;
};
const dates = {
    now: (s)=>{
        return getNow(s);
    },
    today: (s)=>{
        return getNow(s);
    },
    tonight: (s)=>{
        s = getNow(s);
        s = s.hour(18) //6pm
        ;
        return s;
    },
    tomorrow: (s)=>{
        s = getNow(s);
        s = s.add(1, "day");
        s = s.startOf("day");
        return s;
    },
    yesterday: (s)=>{
        s = getNow(s);
        s = s.subtract(1, "day");
        s = s.startOf("day");
        return s;
    },
    christmas: (s)=>{
        let year = getNow(s).year();
        s = s.set([
            year,
            11,
            25,
            18,
            0,
            0
        ]) // Dec 25
        ;
        return s;
    },
    "new years": (s)=>{
        let year = getNow(s).year();
        s = s.set([
            year,
            11,
            31,
            18,
            0,
            0
        ]) // Dec 31
        ;
        return s;
    }
};
dates["new years eve"] = dates["new years"];
exports.default = dates;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"sDQAv":[function(require,module,exports) {
//little cleanup..
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const normalize = function(str) {
    // remove all day-names
    str = str.replace(/\b(mon|tues?|wed|wednes|thur?s?|fri|sat|satur|sun)(day)?\b/i, "");
    //remove ordinal ending
    str = str.replace(/([0-9])(th|rd|st|nd)/, "$1");
    str = str.replace(/,/g, "");
    str = str.replace(/ +/g, " ").trim();
    return str;
};
exports.default = normalize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4m33H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./formats/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
const parseString = function(s, input, givenTz) {
    // let parsers = s.parsers || []
    //try each text-parse template, use the first good result
    for(let i = 0; i < (0, _indexJsDefault.default).length; i++){
        let m = input.match((0, _indexJsDefault.default)[i].reg);
        if (m) {
            // console.log(parsers[i].reg)
            let res = (0, _indexJsDefault.default)[i].parse(s, m, givenTz);
            if (res !== null && res.isValid()) return res;
        }
    }
    if (s.silent === false) console.warn("Warning: couldn't parse date-string: '" + input + "'");
    s.epoch = null;
    return s;
};
exports.default = parseString;

},{"./formats/index.js":"eDoUP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eDoUP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _01YmdJs = require("./01-ymd.js");
var _01YmdJsDefault = parcelHelpers.interopDefault(_01YmdJs);
var _02MdyJs = require("./02-mdy.js");
var _02MdyJsDefault = parcelHelpers.interopDefault(_02MdyJs);
var _03DmyJs = require("./03-dmy.js");
var _03DmyJsDefault = parcelHelpers.interopDefault(_03DmyJs);
var _04MiscJs = require("./04-misc.js");
var _04MiscJsDefault = parcelHelpers.interopDefault(_04MiscJs);
exports.default = [].concat((0, _01YmdJsDefault.default), (0, _02MdyJsDefault.default), (0, _03DmyJsDefault.default), (0, _04MiscJsDefault.default));

},{"./01-ymd.js":"jjtBI","./02-mdy.js":"aXhbx","./03-dmy.js":"VS8zf","./04-misc.js":"kVRV6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jjtBI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _walkJs = require("../../methods/set/walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
var _fnsJs = require("../../fns.js");
var _parsersJs = require("./_parsers.js");
exports.default = [
    // =====
    //  y-m-d
    // =====
    //iso-this 1998-05-30T22:00:00:000Z, iso-that 2017-04-03T08:00:00-0700
    {
        reg: /^(\-?0?0?[0-9]{3,4})-([0-9]{1,2})-([0-9]{1,2})[T| ]([0-9.:]+)(Z|[0-9\-\+:]+)?$/i,
        parse: (s, m)=>{
            let obj = {
                year: m[1],
                month: parseInt(m[2], 10) - 1,
                date: m[3]
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _parsersJs.parseOffset)(s, m[5]);
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, m[4]);
            return s;
        }
    },
    //short-iso "2015-03-25" or "2015/03/25" or "2015/03/25 12:26:14 PM"
    {
        reg: /^([0-9]{4})[\-\/\. ]([0-9]{1,2})[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,
        parse: (s, m)=>{
            let obj = {
                year: m[1],
                month: parseInt(m[2], 10) - 1,
                date: parseInt(m[3], 10)
            };
            if (obj.month >= 12) {
                //support yyyy/dd/mm (weird, but ok)
                obj.date = parseInt(m[2], 10);
                obj.month = parseInt(m[3], 10) - 1;
            }
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, m[4]);
            return s;
        }
    },
    //text-month "2015-feb-25"
    {
        reg: /^([0-9]{4})[\-\/\. ]([a-z]+)[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,
        parse: (s, m)=>{
            let obj = {
                year: (0, _parsersJs.parseYear)(m[1], s._today),
                month: (0, _parsersJs.parseMonth)(m[2]),
                date: (0, _fnsJs.toCardinal)(m[3] || "")
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, m[4]);
            return s;
        }
    }
];

},{"../../methods/set/walk.js":"h4k56","../../fns.js":"dnKgs","./_parsers.js":"h4bUX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4k56":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _millisecondsJs = require("../../data/milliseconds.js");
var _millisecondsJsDefault = parcelHelpers.interopDefault(_millisecondsJs);
//basically, step-forward/backward until js Date object says we're there.
const walk = (s, n, fn, unit, previous)=>{
    let current = s.d[fn]();
    if (current === n) return; //already there
    let startUnit = previous === null ? null : s.d[previous]();
    let original = s.epoch;
    //try to get it as close as we can
    let diff = n - current;
    s.epoch += (0, _millisecondsJsDefault.default)[unit] * diff;
    //DST edge-case: if we are going many days, be a little conservative
    // console.log(unit, diff)
    if (unit === "day") // s.epoch -= ms.minute
    //but don't push it over a month
    {
        if (Math.abs(diff) > 28 && n < 28) s.epoch += (0, _millisecondsJsDefault.default).hour;
    }
    // 1st time: oops, did we change previous unit? revert it.
    if (previous !== null && startUnit !== s.d[previous]()) // console.warn('spacetime warning: missed setting ' + unit)
    s.epoch = original;
    //repair it if we've gone too far or something
    //(go by half-steps, just in case)
    const halfStep = (0, _millisecondsJsDefault.default)[unit] / 2;
    while(s.d[fn]() < n)s.epoch += halfStep;
    while(s.d[fn]() > n)s.epoch -= halfStep;
    // 2nd time: did we change previous unit? revert it.
    if (previous !== null && startUnit !== s.d[previous]()) // console.warn('spacetime warning: missed setting ' + unit)
    s.epoch = original;
};
//find the desired date by a increment/check while loop
const units = {
    year: {
        valid: (n)=>n > -4000 && n < 4000,
        walkTo: (s, n)=>walk(s, n, "getFullYear", "year", null)
    },
    month: {
        valid: (n)=>n >= 0 && n <= 11,
        walkTo: (s, n)=>{
            let d = s.d;
            let current = d.getMonth();
            let original = s.epoch;
            let startUnit = d.getFullYear();
            if (current === n) return;
            //try to get it as close as we can..
            let diff = n - current;
            s.epoch += (0, _millisecondsJsDefault.default).day * (diff * 28 //special case
            );
            //oops, did we change the year? revert it.
            if (startUnit !== s.d.getFullYear()) s.epoch = original;
            //increment by day
            while(s.d.getMonth() < n)s.epoch += (0, _millisecondsJsDefault.default).day;
            while(s.d.getMonth() > n)s.epoch -= (0, _millisecondsJsDefault.default).day;
        }
    },
    date: {
        valid: (n)=>n > 0 && n <= 31,
        walkTo: (s, n)=>walk(s, n, "getDate", "day", "getMonth")
    },
    hour: {
        valid: (n)=>n >= 0 && n < 24,
        walkTo: (s, n)=>walk(s, n, "getHours", "hour", "getDate")
    },
    minute: {
        valid: (n)=>n >= 0 && n < 60,
        walkTo: (s, n)=>walk(s, n, "getMinutes", "minute", "getHours")
    },
    second: {
        valid: (n)=>n >= 0 && n < 60,
        walkTo: (s, n)=>{
            //do this one directly
            s.epoch = s.seconds(n).epoch;
        }
    },
    millisecond: {
        valid: (n)=>n >= 0 && n < 1000,
        walkTo: (s, n)=>{
            //do this one directly
            s.epoch = s.milliseconds(n).epoch;
        }
    }
};
const walkTo = (s, wants)=>{
    let keys = Object.keys(units);
    let old = s.clone();
    for(let i = 0; i < keys.length; i++){
        let k = keys[i];
        let n = wants[k];
        if (n === undefined) n = old[k]();
        if (typeof n === "string") n = parseInt(n, 10);
        //make-sure it's valid
        if (!units[k].valid(n)) {
            s.epoch = null;
            if (s.silent === false) console.warn("invalid " + k + ": " + n);
            return;
        }
        units[k].walkTo(s, n);
    }
    return;
};
exports.default = walkTo;

},{"../../data/milliseconds.js":"59wJe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59wJe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let o = {
    millisecond: 1
};
o.second = 1000;
o.minute = 60000;
o.hour = 3.6e6 // dst is supported post-hoc
;
o.day = 8.64e7 //
;
o.date = o.day;
o.month = 2548800000 //(average)
;
o.week = 6.048e8;
o.year = 3.154e10 // leap-years are supported post-hoc
;
//add plurals
Object.keys(o).forEach((k)=>{
    o[k + "s"] = o[k];
});
exports.default = o;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4bUX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseOffset", ()=>(0, _parseOffsetJsDefault.default));
parcelHelpers.export(exports, "parseTime", ()=>(0, _parseTimeJsDefault.default));
parcelHelpers.export(exports, "parseYear", ()=>parseYear);
parcelHelpers.export(exports, "parseMonth", ()=>parseMonth);
parcelHelpers.export(exports, "validate", ()=>validate);
var _monthLengthsJs = require("../../data/monthLengths.js");
var _monthLengthsJsDefault = parcelHelpers.interopDefault(_monthLengthsJs);
var _fnsJs = require("../../fns.js");
var _monthsJs = require("../../data/months.js");
var _parseOffsetJs = require("./parseOffset.js");
var _parseOffsetJsDefault = parcelHelpers.interopDefault(_parseOffsetJs);
var _parseTimeJs = require("./parseTime.js");
var _parseTimeJsDefault = parcelHelpers.interopDefault(_parseTimeJs);
let months = (0, _monthsJs.mapping)();
//given a month, return whether day number exists in it
const validate = (obj)=>{
    //invalid values
    if ((0, _monthLengthsJsDefault.default).hasOwnProperty(obj.month) !== true) return false;
    //support leap-year in february
    if (obj.month === 1) {
        if ((0, _fnsJs.isLeapYear)(obj.year) && obj.date <= 29) return true;
        else return obj.date <= 28;
    }
    //is this date too-big for this month?
    let max = (0, _monthLengthsJsDefault.default)[obj.month] || 0;
    if (obj.date <= max) return true;
    return false;
};
const parseYear = (str = "", today)=>{
    str = str.trim();
    // parse '86 shorthand
    if (/^'[0-9][0-9]$/.test(str) === true) {
        let num = Number(str.replace(/'/, ""));
        if (num > 50) return 1900 + num;
        return 2000 + num;
    }
    let year = parseInt(str, 10);
    // use a given year from options.today
    if (!year && today) year = today.year;
    // fallback to this year
    year = year || new Date().getFullYear();
    return year;
};
const parseMonth = function(str) {
    str = str.toLowerCase().trim();
    if (str === "sept") return months.sep;
    return months[str];
};

},{"../../data/monthLengths.js":"j3jMR","../../fns.js":"dnKgs","../../data/months.js":"c9Fjq","./parseOffset.js":"9KsBw","./parseTime.js":"96QE8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j3jMR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const monthLengths = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31 // December - 31 days
];
exports.default = monthLengths // 28 - feb
 // 30 - april, june, sept, nov
 // 31 - jan, march, may, july, aug, oct, dec
;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9Fjq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "short", ()=>short);
parcelHelpers.export(exports, "long", ()=>long);
parcelHelpers.export(exports, "mapping", ()=>mapping);
parcelHelpers.export(exports, "set", ()=>set);
let shortMonths = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec"
];
let longMonths = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function buildMapping() {
    const obj = {
        sep: 8 //support this format
    };
    for(let i = 0; i < shortMonths.length; i++)obj[shortMonths[i]] = i;
    for(let i = 0; i < longMonths.length; i++)obj[longMonths[i]] = i;
    return obj;
}
function short() {
    return shortMonths;
}
function long() {
    return longMonths;
}
function mapping() {
    return buildMapping();
}
function set(i18n) {
    shortMonths = i18n.short || shortMonths;
    longMonths = i18n.long || longMonths;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9KsBw":[function(require,module,exports) {
//pull-apart ISO offsets, like "+0100"
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const parseOffset = (s, offset)=>{
    if (!offset) return s;
    // according to ISO8601, tz could be hh:mm, hhmm or hh
    // so need few more steps before the calculation.
    let num = 0;
    // for (+-)hh:mm
    if (/^[\+-]?[0-9]{2}:[0-9]{2}$/.test(offset)) {
        //support "+01:00"
        if (/:00/.test(offset) === true) offset = offset.replace(/:00/, "");
        //support "+01:30"
        if (/:30/.test(offset) === true) offset = offset.replace(/:30/, ".5");
    }
    // for (+-)hhmm
    if (/^[\+-]?[0-9]{4}$/.test(offset)) offset = offset.replace(/30$/, ".5");
    num = parseFloat(offset);
    //divide by 100 or 10 - , "+0100", "+01"
    if (Math.abs(num) > 100) num = num / 100;
    //this is a fancy-move
    if (num === 0 || offset === "Z" || offset === "z") {
        s.tz = "etc/gmt";
        return s;
    }
    //okay, try to match it to a utc timezone
    //remember - this is opposite! a -5 offset maps to Etc/GMT+5  ¯\_(:/)_/¯
    //https://askubuntu.com/questions/519550/why-is-the-8-timezone-called-gmt-8-in-the-filesystem
    num *= -1;
    if (num >= 0) num = "+" + num;
    let tz = "etc/gmt" + num;
    let zones = s.timezones;
    if (zones[tz]) // log a warning if we're over-writing a given timezone?
    // console.log('changing timezone to: ' + tz)
    s.tz = tz;
    return s;
};
exports.default = parseOffset;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96QE8":[function(require,module,exports) {
// truncate any sub-millisecond values
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const parseMs = function(str = "") {
    str = String(str);
    //js does not support sub-millisecond values 
    // so truncate these - 2021-11-02T19:55:30.087772
    if (str.length > 3) str = str.substr(0, 3);
    else if (str.length === 1) // assume ms are zero-padded on the left
    // but maybe not on the right.
    // turn '.10' into '.100'
    str = str + "00";
    else if (str.length === 2) str = str + "0";
    return Number(str) || 0;
};
const parseTime = (s, str = "")=>{
    // remove all whitespace
    str = str.replace(/^\s+/, "").toLowerCase();
    //formal time format - 04:30.23
    let arr = str.match(/([0-9]{1,2}):([0-9]{1,2}):?([0-9]{1,2})?[:\.]?([0-9]{1,4})?/);
    if (arr !== null) {
        //validate it a little
        let h = Number(arr[1]);
        if (h < 0 || h > 24) return s.startOf("day");
        let m = Number(arr[2]) //don't accept '5:3pm'
        ;
        if (arr[2].length < 2 || m < 0 || m > 59) return s.startOf("day");
        s = s.hour(h);
        s = s.minute(m);
        s = s.seconds(arr[3] || 0);
        s = s.millisecond(parseMs(arr[4]));
        //parse-out am/pm
        let ampm = str.match(/[\b0-9] ?(am|pm)\b/);
        if (ampm !== null && ampm[1]) s = s.ampm(ampm[1]);
        return s;
    }
    //try an informal form - 5pm (no minutes)
    arr = str.match(/([0-9]+) ?(am|pm)/);
    if (arr !== null && arr[1]) {
        let h = Number(arr[1]);
        //validate it a little..
        if (h > 12 || h < 1) return s.startOf("day");
        s = s.hour(arr[1] || 0);
        s = s.ampm(arr[2]);
        s = s.startOf("hour");
        return s;
    }
    //no time info found, use start-of-day
    s = s.startOf("day");
    return s;
};
exports.default = parseTime;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXhbx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _walkJs = require("../../methods/set/walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
var _fnsJs = require("../../fns.js");
var _parsersJs = require("./_parsers.js");
exports.default = [
    // =====
    //  m-d-y
    // =====
    //mm/dd/yyyy - uk/canada "6/28/2019, 12:26:14 PM"
    {
        reg: /^([0-9]{1,2})[\-\/.]([0-9]{1,2})[\-\/.]?([0-9]{4})?( [0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i,
        parse: (s, arr)=>{
            let month = parseInt(arr[1], 10) - 1;
            let date = parseInt(arr[2], 10);
            //support dd/mm/yyy
            if (s.british || month >= 12) {
                date = parseInt(arr[1], 10);
                month = parseInt(arr[2], 10) - 1;
            }
            let obj = {
                date,
                month,
                year: (0, _parsersJs.parseYear)(arr[3], s._today) || new Date().getFullYear()
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, arr[4]);
            return s;
        }
    },
    //alt short format - "feb-25-2015"
    {
        reg: /^([a-z]+)[\-\/\. ]([0-9]{1,2})[\-\/\. ]?([0-9]{4}|'[0-9]{2})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,
        parse: (s, arr)=>{
            let obj = {
                year: (0, _parsersJs.parseYear)(arr[3], s._today),
                month: (0, _parsersJs.parseMonth)(arr[1]),
                date: (0, _fnsJs.toCardinal)(arr[2] || "")
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, arr[4]);
            return s;
        }
    },
    //Long "Mar 25 2015"
    //February 22, 2017 15:30:00
    {
        reg: /^([a-z]+) ([0-9]{1,2})( [0-9]{4})?( ([0-9:]+( ?am| ?pm| ?gmt)?))?$/i,
        parse: (s, arr)=>{
            let obj = {
                year: (0, _parsersJs.parseYear)(arr[3], s._today),
                month: (0, _parsersJs.parseMonth)(arr[1]),
                date: (0, _fnsJs.toCardinal)(arr[2] || "")
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, arr[4]);
            return s;
        }
    },
    // 'Sun Mar 14 15:09:48 +0000 2021'
    {
        reg: /^([a-z]+) ([0-9]{1,2})( [0-9:]+)?( \+[0-9]{4})?( [0-9]{4})?$/i,
        parse: (s, arr)=>{
            let obj = {
                year: (0, _parsersJs.parseYear)(arr[5], s._today),
                month: (0, _parsersJs.parseMonth)(arr[1]),
                date: (0, _fnsJs.toCardinal)(arr[2] || "")
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, arr[3]);
            return s;
        }
    }
];

},{"../../methods/set/walk.js":"h4k56","../../fns.js":"dnKgs","./_parsers.js":"h4bUX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"VS8zf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _walkJs = require("../../methods/set/walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
var _fnsJs = require("../../fns.js");
var _parsersJs = require("./_parsers.js");
exports.default = [
    // =====
    //  d-m-y
    // =====
    //common british format - "25-feb-2015"
    {
        reg: /^([0-9]{1,2})[\-\/]([a-z]+)[\-\/]?([0-9]{4})?$/i,
        parse: (s, m)=>{
            let obj = {
                year: (0, _parsersJs.parseYear)(m[3], s._today),
                month: (0, _parsersJs.parseMonth)(m[2]),
                date: (0, _fnsJs.toCardinal)(m[1] || "")
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, m[4]);
            return s;
        }
    },
    // "25 Mar 2015"
    {
        reg: /^([0-9]{1,2})( [a-z]+)( [0-9]{4}| '[0-9]{2})? ?([0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i,
        parse: (s, m)=>{
            let obj = {
                year: (0, _parsersJs.parseYear)(m[3], s._today),
                month: (0, _parsersJs.parseMonth)(m[2]),
                date: (0, _fnsJs.toCardinal)(m[1])
            };
            if (!obj.month || (0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, m[4]);
            return s;
        }
    },
    // 01-jan-2020
    {
        reg: /^([0-9]{1,2})[\. -/]([a-z]+)[\. -/]([0-9]{4})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,
        parse: (s, m)=>{
            let obj = {
                date: Number(m[1]),
                month: (0, _parsersJs.parseMonth)(m[2]),
                year: Number(m[3])
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = s.startOf("day");
            s = (0, _parsersJs.parseTime)(s, m[4]);
            return s;
        }
    }
];

},{"../../methods/set/walk.js":"h4k56","../../fns.js":"dnKgs","./_parsers.js":"h4bUX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kVRV6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _walkJs = require("../../methods/set/walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
var _parsersJs = require("./_parsers.js");
exports.default = [
    // =====
    // no dates
    // =====
    // '2012-06' month-only
    {
        reg: /^([0-9]{4})[\-\/]([0-9]{2})$/i,
        parse: (s, m)=>{
            let obj = {
                year: m[1],
                month: parseInt(m[2], 10) - 1,
                date: 1
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, m[4]);
            return s;
        }
    },
    //February 2017 (implied date)
    {
        reg: /^([a-z]+) ([0-9]{4})$/i,
        parse: (s, arr)=>{
            let obj = {
                year: (0, _parsersJs.parseYear)(arr[2], s._today),
                month: (0, _parsersJs.parseMonth)(arr[1]),
                date: s._today.date || 1
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s, arr[4]);
            return s;
        }
    },
    {
        // 'q2 2002'
        reg: /^(q[0-9])( of)?( [0-9]{4})?/i,
        parse: (s, arr)=>{
            let quarter = arr[1] || "";
            s = s.quarter(quarter);
            let year = arr[3] || "";
            if (year) {
                year = year.trim();
                s = s.year(year);
            }
            return s;
        }
    },
    {
        // 'summer 2002'
        reg: /^(spring|summer|winter|fall|autumn)( of)?( [0-9]{4})?/i,
        parse: (s, arr)=>{
            let season = arr[1] || "";
            s = s.season(season);
            let year = arr[3] || "";
            if (year) {
                year = year.trim();
                s = s.year(year);
            }
            return s;
        }
    },
    {
        // '200bc'
        reg: /^[0-9,]+ ?b\.?c\.?$/i,
        parse: (s, arr)=>{
            let str = arr[0] || "";
            //make year-negative
            str = str.replace(/^([0-9,]+) ?b\.?c\.?$/i, "-$1");
            let d = new Date();
            let obj = {
                year: parseInt(str.trim(), 10),
                month: d.getMonth(),
                date: d.getDate()
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s);
            return s;
        }
    },
    {
        // '200ad'
        reg: /^[0-9,]+ ?(a\.?d\.?|c\.?e\.?)$/i,
        parse: (s, arr)=>{
            let str = arr[0] || "";
            //remove commas
            str = str.replace(/,/g, "");
            let d = new Date();
            let obj = {
                year: parseInt(str.trim(), 10),
                month: d.getMonth(),
                date: d.getDate()
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s);
            return s;
        }
    },
    {
        // '1992'
        reg: /^[0-9]{4}( ?a\.?d\.?)?$/i,
        parse: (s, arr)=>{
            let today = s._today;
            // using today's date, but a new month is awkward.
            if (today.month && !today.date) today.date = 1;
            let d = new Date();
            let obj = {
                year: (0, _parsersJs.parseYear)(arr[0], today),
                month: today.month || d.getMonth(),
                date: today.date || d.getDate()
            };
            if ((0, _parsersJs.validate)(obj) === false) {
                s.epoch = null;
                return s;
            }
            (0, _walkJsDefault.default)(s, obj);
            s = (0, _parsersJs.parseTime)(s);
            return s;
        }
    }
];

},{"../../methods/set/walk.js":"h4k56","./_parsers.js":"h4bUX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4nh7t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./methods/format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _unixFmtJs = require("./methods/format/unixFmt.js");
var _unixFmtJsDefault = parcelHelpers.interopDefault(_unixFmtJs);
var _progressJs = require("./methods/progress.js");
var _progressJsDefault = parcelHelpers.interopDefault(_progressJs);
var _nearestJs = require("./methods/nearest.js");
var _nearestJsDefault = parcelHelpers.interopDefault(_nearestJs);
var _indexJs1 = require("./methods/diff/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./methods/since/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _startOfJs = require("./methods/startOf.js");
var _everyJs = require("./methods/every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _indexJs3 = require("./timezone/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _findJs = require("./timezone/find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _indexJs4 = require("./input/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _fnsJs = require("./fns.js");
var _daysJs = require("./data/days.js");
const units = [
    "century",
    "decade",
    "year",
    "month",
    "date",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
//the spacetime instance methods (also, the API)
const methods = {
    set: function(input, tz) {
        let s = this.clone();
        s = (0, _indexJsDefault4.default)(s, input, null);
        if (tz) this.tz = (0, _findJsDefault.default)(tz);
        return s;
    },
    timezone: function() {
        return (0, _indexJsDefault3.default)(this);
    },
    isDST: function() {
        return (0, _indexJsDefault3.default)(this).current.isDST;
    },
    hasDST: function() {
        return (0, _indexJsDefault3.default)(this).hasDst;
    },
    offset: function() {
        return (0, _indexJsDefault3.default)(this).current.offset * 60;
    },
    hemisphere: function() {
        return (0, _indexJsDefault3.default)(this).hemisphere;
    },
    format: function(fmt) {
        return (0, _indexJsDefault.default)(this, fmt);
    },
    unixFmt: function(fmt) {
        return (0, _unixFmtJsDefault.default)(this, fmt);
    },
    startOf: function(unit) {
        return (0, _startOfJs.startOf)(this, unit);
    },
    endOf: function(unit) {
        return (0, _startOfJs.endOf)(this, unit);
    },
    leapYear: function() {
        let year = this.year();
        return (0, _fnsJs.isLeapYear)(year);
    },
    progress: function(unit) {
        return (0, _progressJsDefault.default)(this, unit);
    },
    nearest: function(unit) {
        return (0, _nearestJsDefault.default)(this, unit);
    },
    diff: function(d, unit) {
        return (0, _indexJsDefault1.default)(this, d, unit);
    },
    since: function(d) {
        if (!d) d = this.clone().set();
        return (0, _indexJsDefault2.default)(this, d);
    },
    next: function(unit) {
        let s = this.add(1, unit);
        return s.startOf(unit);
    },
    //the start of the previous year/week/century
    last: function(unit) {
        let s = this.subtract(1, unit);
        return s.startOf(unit);
    },
    isValid: function() {
        //null/undefined epochs
        if (!this.epoch && this.epoch !== 0) return false;
        return !isNaN(this.d.getTime());
    },
    //travel to this timezone
    goto: function(tz) {
        let s = this.clone();
        s.tz = (0, _findJsDefault.default)(tz, s.timezones) //science!
        ;
        return s;
    },
    //get each week/month/day between a -> b
    every: function(unit, to) {
        // allow swapping these params:
        if (typeof unit === "object" && typeof to === "string") {
            let tmp = to;
            to = unit;
            unit = tmp;
        }
        return (0, _everyJsDefault.default)(this, unit, to);
    },
    isAwake: function() {
        let hour = this.hour();
        //10pm -> 8am
        if (hour < 8 || hour > 22) return false;
        return true;
    },
    isAsleep: function() {
        return !this.isAwake();
    },
    daysInMonth: function() {
        switch(this.month()){
            case 0:
                return 31;
            case 1:
                return this.leapYear() ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            case 11:
                return 31;
            default:
                throw new Error("Invalid Month state.");
        }
    },
    //pretty-printing
    log: function() {
        console.log("");
        console.log((0, _indexJsDefault.default)(this, "nice-short"));
        return this;
    },
    logYear: function() {
        console.log("");
        console.log((0, _indexJsDefault.default)(this, "full-short"));
        return this;
    },
    json: function() {
        return units.reduce((h, unit)=>{
            h[unit] = this[unit]();
            return h;
        }, {});
    },
    debug: function() {
        let tz = this.timezone();
        let date = this.format("MM") + " " + this.format("date-ordinal") + " " + this.year();
        date += "\n     - " + this.format("time");
        console.log("\n\n", date + "\n     - " + tz.name + " (" + tz.current.offset + ")");
        return this;
    },
    //alias of 'since' but opposite - like moment.js
    from: function(d) {
        d = this.clone().set(d);
        return d.since(this);
    },
    fromNow: function() {
        let d = this.clone().set(Date.now());
        return d.since(this);
    },
    weekStart: function(input) {
        //accept a number directly
        if (typeof input === "number") {
            this._weekStart = input;
            return this;
        }
        if (typeof input === "string") {
            // accept 'wednesday'
            input = input.toLowerCase().trim();
            let num = (0, _daysJs.short)().indexOf(input);
            if (num === -1) num = (0, _daysJs.long)().indexOf(input);
            if (num === -1) num = 1 //go back to default
            ;
            this._weekStart = num;
        } else console.warn("Spacetime Error: Cannot understand .weekStart() input:", input);
        return this;
    }
};
// aliases
methods.inDST = methods.isDST;
methods.round = methods.nearest;
methods.each = methods.every;
exports.default = methods;

},{"./methods/format/index.js":"kYsbT","./methods/format/unixFmt.js":"dm2E5","./methods/progress.js":"47geH","./methods/nearest.js":"1F453","./methods/diff/index.js":"gt8Cx","./methods/since/index.js":"bDZEV","./methods/startOf.js":"gIGAb","./methods/every.js":"3udCy","./timezone/index.js":"lGhSS","./timezone/find.js":"dtXkU","./input/index.js":"9vnjn","./fns.js":"dnKgs","./data/days.js":"kecYW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYsbT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../../fns.js");
var _monthsJs = require("../../data/months.js");
var _daysJs = require("../../data/days.js");
var _caseFormatJs = require("../../data/caseFormat.js");
var _offsetJs = require("./_offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
const applyCaseFormat = (str)=>{
    if ((0, _caseFormatJs.useTitleCase)()) return (0, _fnsJs.titleCase)(str);
    return str;
};
// iso-year padding
const padYear = (num)=>{
    if (num >= 0) return (0, _fnsJs.zeroPad)(num, 4);
    else {
        num = Math.abs(num);
        return "-" + (0, _fnsJs.zeroPad)(num, 4);
    }
};
const format = {
    day: (s)=>applyCaseFormat(s.dayName()),
    "day-short": (s)=>applyCaseFormat((0, _daysJs.short)()[s.day()]),
    "day-number": (s)=>s.day(),
    "day-ordinal": (s)=>(0, _fnsJs.ordinal)(s.day()),
    "day-pad": (s)=>(0, _fnsJs.zeroPad)(s.day()),
    date: (s)=>s.date(),
    "date-ordinal": (s)=>(0, _fnsJs.ordinal)(s.date()),
    "date-pad": (s)=>(0, _fnsJs.zeroPad)(s.date()),
    month: (s)=>applyCaseFormat(s.monthName()),
    "month-short": (s)=>applyCaseFormat((0, _monthsJs.short)()[s.month()]),
    "month-number": (s)=>s.month(),
    "month-ordinal": (s)=>(0, _fnsJs.ordinal)(s.month()),
    "month-pad": (s)=>(0, _fnsJs.zeroPad)(s.month()),
    "iso-month": (s)=>(0, _fnsJs.zeroPad)(s.month() + 1),
    year: (s)=>{
        let year = s.year();
        if (year > 0) return year;
        year = Math.abs(year);
        return year + " BC";
    },
    "year-short": (s)=>{
        let year = s.year();
        if (year > 0) return `'${String(s.year()).substr(2, 4)}`;
        year = Math.abs(year);
        return year + " BC";
    },
    "iso-year": (s)=>{
        let year = s.year();
        let isNegative = year < 0;
        let str = (0, _fnsJs.zeroPad)(Math.abs(year), 4) //0-padded
        ;
        if (isNegative) {
            //negative years are for some reason 6-digits ('-00008')
            str = (0, _fnsJs.zeroPad)(str, 6);
            str = "-" + str;
        }
        return str;
    },
    time: (s)=>s.time(),
    "time-24": (s)=>`${s.hour24()}:${(0, _fnsJs.zeroPad)(s.minute())}`,
    hour: (s)=>s.hour12(),
    "hour-pad": (s)=>(0, _fnsJs.zeroPad)(s.hour12()),
    "hour-24": (s)=>s.hour24(),
    "hour-24-pad": (s)=>(0, _fnsJs.zeroPad)(s.hour24()),
    minute: (s)=>s.minute(),
    "minute-pad": (s)=>(0, _fnsJs.zeroPad)(s.minute()),
    second: (s)=>s.second(),
    "second-pad": (s)=>(0, _fnsJs.zeroPad)(s.second()),
    millisecond: (s)=>s.millisecond(),
    "millisecond-pad": (s)=>(0, _fnsJs.zeroPad)(s.millisecond(), 3),
    ampm: (s)=>s.ampm(),
    AMPM: (s)=>s.ampm().toUpperCase(),
    quarter: (s)=>"Q" + s.quarter(),
    season: (s)=>s.season(),
    era: (s)=>s.era(),
    json: (s)=>s.json(),
    timezone: (s)=>s.timezone().name,
    offset: (s)=>(0, _offsetJsDefault.default)(s),
    numeric: (s)=>`${s.year()}/${(0, _fnsJs.zeroPad)(s.month() + 1)}/${(0, _fnsJs.zeroPad)(s.date())}`,
    "numeric-us": (s)=>`${(0, _fnsJs.zeroPad)(s.month() + 1)}/${(0, _fnsJs.zeroPad)(s.date())}/${s.year()}`,
    "numeric-uk": (s)=>`${(0, _fnsJs.zeroPad)(s.date())}/${(0, _fnsJs.zeroPad)(s.month() + 1)}/${s.year()}`,
    "mm/dd": (s)=>`${(0, _fnsJs.zeroPad)(s.month() + 1)}/${(0, _fnsJs.zeroPad)(s.date())}`,
    // ... https://en.wikipedia.org/wiki/ISO_8601 ;(((
    iso: (s)=>{
        let year = s.format("iso-year");
        let month = (0, _fnsJs.zeroPad)(s.month() + 1) //1-based months
        ;
        let date = (0, _fnsJs.zeroPad)(s.date());
        let hour = (0, _fnsJs.zeroPad)(s.h24());
        let minute = (0, _fnsJs.zeroPad)(s.minute());
        let second = (0, _fnsJs.zeroPad)(s.second());
        let ms = (0, _fnsJs.zeroPad)(s.millisecond(), 3);
        let offset = (0, _offsetJsDefault.default)(s);
        return `${year}-${month}-${date}T${hour}:${minute}:${second}.${ms}${offset}` //2018-03-09T08:50:00.000-05:00
        ;
    },
    "iso-short": (s)=>{
        let month = (0, _fnsJs.zeroPad)(s.month() + 1) //1-based months
        ;
        let date = (0, _fnsJs.zeroPad)(s.date());
        let year = padYear(s.year());
        return `${year}-${month}-${date}` //2017-02-15
        ;
    },
    "iso-utc": (s)=>{
        return new Date(s.epoch).toISOString() //2017-03-08T19:45:28.367Z
        ;
    },
    //i made these up
    nice: (s)=>`${(0, _monthsJs.short)()[s.month()]} ${(0, _fnsJs.ordinal)(s.date())}, ${s.time()}`,
    "nice-24": (s)=>`${(0, _monthsJs.short)()[s.month()]} ${(0, _fnsJs.ordinal)(s.date())}, ${s.hour24()}:${(0, _fnsJs.zeroPad)(s.minute())}`,
    "nice-year": (s)=>`${(0, _monthsJs.short)()[s.month()]} ${(0, _fnsJs.ordinal)(s.date())}, ${s.year()}`,
    "nice-day": (s)=>`${(0, _daysJs.short)()[s.day()]} ${applyCaseFormat((0, _monthsJs.short)()[s.month()])} ${(0, _fnsJs.ordinal)(s.date())}`,
    "nice-full": (s)=>`${s.dayName()} ${applyCaseFormat(s.monthName())} ${(0, _fnsJs.ordinal)(s.date())}, ${s.time()}`,
    "nice-full-24": (s)=>`${s.dayName()} ${applyCaseFormat(s.monthName())} ${(0, _fnsJs.ordinal)(s.date())}, ${s.hour24()}:${(0, _fnsJs.zeroPad)(s.minute())}`
};
//aliases
const aliases = {
    "day-name": "day",
    "month-name": "month",
    "iso 8601": "iso",
    "time-h24": "time-24",
    "time-12": "time",
    "time-h12": "time",
    tz: "timezone",
    "day-num": "day-number",
    "month-num": "month-number",
    "month-iso": "iso-month",
    "year-iso": "iso-year",
    "nice-short": "nice",
    "nice-short-24": "nice-24",
    mdy: "numeric-us",
    dmy: "numeric-uk",
    ymd: "numeric",
    "yyyy/mm/dd": "numeric",
    "mm/dd/yyyy": "numeric-us",
    "dd/mm/yyyy": "numeric-us",
    "little-endian": "numeric-uk",
    "big-endian": "numeric",
    "day-nice": "nice-day"
};
Object.keys(aliases).forEach((k)=>format[k] = format[aliases[k]]);
const printFormat = (s, str = "")=>{
    //don't print anything if it's an invalid date
    if (s.isValid() !== true) return "";
    //support .format('month')
    if (format.hasOwnProperty(str)) {
        let out = format[str](s) || "";
        if (str !== "json") {
            out = String(out);
            if (str.toLowerCase() !== "ampm") out = applyCaseFormat(out);
        }
        return out;
    }
    //support '{hour}:{minute}' notation
    if (str.indexOf("{") !== -1) {
        let sections = /\{(.+?)\}/g;
        str = str.replace(sections, (_, fmt)=>{
            fmt = fmt.toLowerCase().trim();
            if (format.hasOwnProperty(fmt)) {
                let out = String(format[fmt](s));
                if (fmt.toLowerCase() !== "ampm") return applyCaseFormat(out);
                return out;
            }
            return "";
        });
        return str;
    }
    return s.format("iso-short");
};
exports.default = printFormat;

},{"../../fns.js":"dnKgs","../../data/months.js":"c9Fjq","../../data/days.js":"kecYW","../../data/caseFormat.js":"8VoCd","./_offset.js":"2teJ1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kecYW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "short", ()=>short);
parcelHelpers.export(exports, "long", ()=>long);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "aliases", ()=>aliases);
let shortDays = [
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat"
];
let longDays = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
];
function short() {
    return shortDays;
}
function long() {
    return longDays;
}
function set(i18n) {
    shortDays = i18n.short || shortDays;
    longDays = i18n.long || longDays;
}
const aliases = {
    mo: 1,
    tu: 2,
    we: 3,
    th: 4,
    fr: 5,
    sa: 6,
    su: 7,
    tues: 2,
    weds: 3,
    wedn: 3,
    thur: 4,
    thurs: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8VoCd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTitleCase", ()=>useTitleCase);
parcelHelpers.export(exports, "set", ()=>set);
let titleCaseEnabled = true;
function useTitleCase() {
    return titleCaseEnabled;
}
function set(val) {
    titleCaseEnabled = val;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2teJ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../../fns.js");
// create the timezone offset part of an iso timestamp
// it's kind of nuts how involved this is
// "+01:00", "+0100", or simply "+01"
const isoOffset = (s)=>{
    let offset = s.timezone().current.offset;
    return !offset ? "Z" : (0, _fnsJs.formatTimezone)(offset, ":");
};
exports.default = isoOffset;

},{"../../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dm2E5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../../fns.js");
//parse this insane unix-time-templating thing, from the 19th century
//http://unicode.org/reports/tr35/tr35-25.html#Date_Format_Patterns
//time-symbols we support
const mapping = {
    G: (s)=>s.era(),
    GG: (s)=>s.era(),
    GGG: (s)=>s.era(),
    GGGG: (s)=>s.era() === "AD" ? "Anno Domini" : "Before Christ",
    //year
    y: (s)=>s.year(),
    yy: (s)=>{
        //last two chars
        return (0, _fnsJs.zeroPad)(Number(String(s.year()).substr(2, 4)));
    },
    yyy: (s)=>s.year(),
    yyyy: (s)=>s.year(),
    yyyyy: (s)=>"0" + s.year(),
    // u: (s) => {},//extended non-gregorian years
    //quarter
    Q: (s)=>s.quarter(),
    QQ: (s)=>s.quarter(),
    QQQ: (s)=>s.quarter(),
    QQQQ: (s)=>s.quarter(),
    //month
    M: (s)=>s.month() + 1,
    MM: (s)=>(0, _fnsJs.zeroPad)(s.month() + 1),
    MMM: (s)=>s.format("month-short"),
    MMMM: (s)=>s.format("month"),
    //week
    w: (s)=>s.week(),
    ww: (s)=>(0, _fnsJs.zeroPad)(s.week()),
    //week of month
    // W: (s) => s.week(),
    //date of month
    d: (s)=>s.date(),
    dd: (s)=>(0, _fnsJs.zeroPad)(s.date()),
    //date of year
    D: (s)=>s.dayOfYear(),
    DD: (s)=>(0, _fnsJs.zeroPad)(s.dayOfYear()),
    DDD: (s)=>(0, _fnsJs.zeroPad)(s.dayOfYear(), 3),
    // F: (s) => {},//date of week in month
    // g: (s) => {},//modified julian day
    //day
    E: (s)=>s.format("day-short"),
    EE: (s)=>s.format("day-short"),
    EEE: (s)=>s.format("day-short"),
    EEEE: (s)=>s.format("day"),
    EEEEE: (s)=>s.format("day")[0],
    e: (s)=>s.day(),
    ee: (s)=>s.day(),
    eee: (s)=>s.format("day-short"),
    eeee: (s)=>s.format("day"),
    eeeee: (s)=>s.format("day")[0],
    //am/pm
    a: (s)=>s.ampm().toUpperCase(),
    aa: (s)=>s.ampm().toUpperCase(),
    aaa: (s)=>s.ampm().toUpperCase(),
    aaaa: (s)=>s.ampm().toUpperCase(),
    //hour
    h: (s)=>s.h12(),
    hh: (s)=>(0, _fnsJs.zeroPad)(s.h12()),
    H: (s)=>s.hour(),
    HH: (s)=>(0, _fnsJs.zeroPad)(s.hour()),
    // j: (s) => {},//weird hour format
    m: (s)=>s.minute(),
    mm: (s)=>(0, _fnsJs.zeroPad)(s.minute()),
    s: (s)=>s.second(),
    ss: (s)=>(0, _fnsJs.zeroPad)(s.second()),
    //milliseconds
    SSS: (s)=>(0, _fnsJs.zeroPad)(s.millisecond(), 3),
    //milliseconds in the day
    A: (s)=>s.epoch - s.startOf("day").epoch,
    //timezone
    z: (s)=>s.timezone().name,
    zz: (s)=>s.timezone().name,
    zzz: (s)=>s.timezone().name,
    zzzz: (s)=>s.timezone().name,
    Z: (s)=>(0, _fnsJs.formatTimezone)(s.timezone().current.offset),
    ZZ: (s)=>(0, _fnsJs.formatTimezone)(s.timezone().current.offset),
    ZZZ: (s)=>(0, _fnsJs.formatTimezone)(s.timezone().current.offset),
    ZZZZ: (s)=>(0, _fnsJs.formatTimezone)(s.timezone().current.offset, ":")
};
const addAlias = (char, to, n)=>{
    let name = char;
    let toName = to;
    for(let i = 0; i < n; i += 1){
        mapping[name] = mapping[toName];
        name += char;
        toName += to;
    }
};
addAlias("q", "Q", 4);
addAlias("L", "M", 4);
addAlias("Y", "y", 4);
addAlias("c", "e", 4);
addAlias("k", "H", 2);
addAlias("K", "h", 2);
addAlias("S", "s", 2);
addAlias("v", "z", 4);
addAlias("V", "Z", 4);
// support unix-style escaping with ' character
const escapeChars = function(arr) {
    for(let i = 0; i < arr.length; i += 1){
        if (arr[i] === `'`) // greedy-search for next apostrophe
        for(let o = i + 1; o < arr.length; o += 1){
            if (arr[o]) arr[i] += arr[o];
            if (arr[o] === `'`) {
                arr[o] = null;
                break;
            }
            arr[o] = null;
        }
    }
    return arr.filter((ch)=>ch);
};
//combine consecutive chars, like 'yyyy' as one.
const combineRepeated = function(arr) {
    for(let i = 0; i < arr.length; i += 1){
        let c = arr[i];
        // greedy-forward
        for(let o = i + 1; o < arr.length; o += 1){
            if (arr[o] === c) {
                arr[i] += arr[o];
                arr[o] = null;
            } else break;
        }
    }
    // '' means one apostrophe
    arr = arr.filter((ch)=>ch);
    arr = arr.map((str)=>{
        if (str === `''`) str = `'`;
        return str;
    });
    return arr;
};
const unixFmt = (s, str)=>{
    let arr = str.split("");
    // support character escaping
    arr = escapeChars(arr);
    //combine 'yyyy' as string.
    arr = combineRepeated(arr);
    return arr.reduce((txt, c)=>{
        if (mapping[c] !== undefined) txt += mapping[c](s) || "";
        else {
            // 'unescape'
            if (/^'.{1,}'$/.test(c)) c = c.replace(/'/g, "");
            txt += c;
        }
        return txt;
    }, "");
};
exports.default = unixFmt;

},{"../../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"47geH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../fns.js");
const units = [
    "year",
    "season",
    "quarter",
    "month",
    "week",
    "day",
    "quarterHour",
    "hour",
    "minute"
];
const doUnit = function(s, k) {
    let start = s.clone().startOf(k);
    let end = s.clone().endOf(k);
    let duration = end.epoch - start.epoch;
    let percent = (s.epoch - start.epoch) / duration;
    return parseFloat(percent.toFixed(2));
};
//how far it is along, from 0-1
const progress = (s, unit)=>{
    if (unit) {
        unit = (0, _fnsJs.normalize)(unit);
        return doUnit(s, unit);
    }
    let obj = {};
    units.forEach((k)=>{
        obj[k] = doUnit(s, k);
    });
    return obj;
};
exports.default = progress;

},{"../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1F453":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../fns.js");
//round to either current, or +1 of this unit
const nearest = (s, unit)=>{
    //how far have we gone?
    let prog = s.progress();
    unit = (0, _fnsJs.normalize)(unit);
    //fix camel-case for this one
    if (unit === "quarterhour") unit = "quarterHour";
    if (prog[unit] !== undefined) {
        // go forward one?
        if (prog[unit] > 0.5) s = s.add(1, unit);
        // go to start
        s = s.startOf(unit);
    } else if (s.silent === false) console.warn("no known unit '" + unit + "'");
    return s;
};
exports.default = nearest;

},{"../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gt8Cx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../../fns.js");
var _waterfallJs = require("./waterfall.js");
var _waterfallJsDefault = parcelHelpers.interopDefault(_waterfallJs);
const reverseDiff = function(obj) {
    Object.keys(obj).forEach((k)=>{
        obj[k] *= -1;
    });
    return obj;
};
// this method counts a total # of each unit, between a, b.
// '1 month' means 28 days in february
// '1 year' means 366 days in a leap year
const main = function(a, b, unit) {
    b = (0, _fnsJs.beADate)(b, a);
    //reverse values, if necessary
    let reversed = false;
    if (a.isAfter(b)) {
        let tmp = a;
        a = b;
        b = tmp;
        reversed = true;
    }
    //compute them all (i know!)
    let obj = (0, _waterfallJsDefault.default)(a, b);
    if (reversed) obj = reverseDiff(obj);
    //return just the requested unit
    if (unit) {
        //make sure it's plural-form
        unit = (0, _fnsJs.normalize)(unit);
        if (/s$/.test(unit) !== true) unit += "s";
        if (unit === "dates") unit = "days";
        return obj[unit];
    }
    return obj;
};
exports.default = main;

},{"../../fns.js":"dnKgs","./waterfall.js":"aZqcn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZqcn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _oneJs = require("./one.js");
var _oneJsDefault = parcelHelpers.interopDefault(_oneJs);
// don't do anything too fancy here.
// 2020 - 2019 may be 1 year, or 0 years
// - '1 year difference' means 366 days during a leap year
const fastYear = (a, b)=>{
    let years = b.year() - a.year();
    // should we decrement it by 1?
    a = a.year(b.year());
    if (a.isAfter(b)) years -= 1;
    return years;
};
// use a waterfall-method for computing a diff of any 'pre-knowable' units
// compute years, then compute months, etc..
// ... then ms-math for any very-small units
const diff = function(a, b) {
    // an hour is always the same # of milliseconds
    // so these units can be 'pre-calculated'
    let msDiff = b.epoch - a.epoch;
    let obj = {
        milliseconds: msDiff,
        seconds: parseInt(msDiff / 1000, 10)
    };
    obj.minutes = parseInt(obj.seconds / 60, 10);
    obj.hours = parseInt(obj.minutes / 60, 10);
    //do the year
    let tmp = a.clone();
    obj.years = fastYear(tmp, b);
    tmp = a.add(obj.years, "year");
    //there's always 12 months in a year...
    obj.months = obj.years * 12;
    tmp = a.add(obj.months, "month");
    obj.months += (0, _oneJsDefault.default)(tmp, b, "month");
    // there's always 4 quarters in a year...
    obj.quarters = obj.years * 4;
    obj.quarters += parseInt(obj.months % 12 / 3, 10);
    // there's always atleast 52 weeks in a year..
    // (month * 4) isn't as close
    obj.weeks = obj.years * 52;
    tmp = a.add(obj.weeks, "week");
    obj.weeks += (0, _oneJsDefault.default)(tmp, b, "week");
    // there's always atleast 7 days in a week
    obj.days = obj.weeks * 7;
    tmp = a.add(obj.days, "day");
    obj.days += (0, _oneJsDefault.default)(tmp, b, "day");
    return obj;
};
exports.default = diff;

},{"./one.js":"2gfrf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2gfrf":[function(require,module,exports) {
//increment until dates are the same
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const climb = (a, b, unit)=>{
    let i = 0;
    a = a.clone();
    while(a.isBefore(b)){
        //do proper, expensive increment to catch all-the-tricks
        a = a.add(1, unit);
        i += 1;
    }
    //oops, we went too-far..
    if (a.isAfter(b, unit)) i -= 1;
    return i;
};
// do a thurough +=1 on the unit, until they match
// for speed-reasons, only used on day, month, week.
const diffOne = (a, b, unit)=>{
    if (a.isBefore(b)) return climb(a, b, unit);
    else return climb(b, a, unit) * -1 //reverse it
    ;
};
exports.default = diffOne;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bDZEV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../../fns.js");
var _isoJs = require("./_iso.js");
var _isoJsDefault = parcelHelpers.interopDefault(_isoJs);
var _getDiffJs = require("./getDiff.js");
var _getDiffJsDefault = parcelHelpers.interopDefault(_getDiffJs);
var _softenJs = require("./soften.js");
var _softenJsDefault = parcelHelpers.interopDefault(_softenJs);
var _distanceJs = require("../../data/distance.js");
//by spencermountain + Shaun Grady
//create the human-readable diff between the two dates
const since = (start, end)=>{
    end = (0, _fnsJs.beADate)(end, start);
    const diff = (0, _getDiffJsDefault.default)(start, end);
    const isNow = Object.keys(diff).every((u)=>!diff[u]);
    if (isNow === true) return {
        diff,
        rounded: (0, _distanceJs.nowString)(),
        qualified: (0, _distanceJs.nowString)(),
        precise: (0, _distanceJs.nowString)(),
        abbreviated: [],
        iso: "P0Y0M0DT0H0M0S",
        direction: (0, _distanceJs.presentString)()
    };
    let precise;
    let direction = (0, _distanceJs.futureString)();
    let { rounded, qualified, englishValues, abbreviated } = (0, _softenJsDefault.default)(diff);
    //make them into a string
    precise = englishValues.splice(0, 2).join(", ");
    //handle before/after logic
    if (start.isAfter(end) === true) {
        rounded = (0, _distanceJs.pastDistanceString)(rounded);
        qualified = (0, _distanceJs.pastDistanceString)(qualified);
        precise = (0, _distanceJs.pastDistanceString)(precise);
        direction = (0, _distanceJs.pastString)();
    } else {
        rounded = (0, _distanceJs.futureDistanceString)(rounded);
        qualified = (0, _distanceJs.futureDistanceString)(qualified);
        precise = (0, _distanceJs.futureDistanceString)(precise);
    }
    // https://en.wikipedia.org/wiki/ISO_8601#Durations
    // P[n]Y[n]M[n]DT[n]H[n]M[n]S 
    let iso = (0, _isoJsDefault.default)(diff);
    return {
        diff,
        rounded,
        qualified,
        precise,
        abbreviated,
        iso,
        direction
    };
};
exports.default = since;

},{"../../fns.js":"dnKgs","./_iso.js":"7d78P","./getDiff.js":"fcLzL","./soften.js":"hqsUN","../../data/distance.js":"laYXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7d78P":[function(require,module,exports) {
/*
ISO 8601 duration format
// https://en.wikipedia.org/wiki/ISO_8601#Durations
"P3Y6M4DT12H30M5S"
P the start of the duration representation.
Y the number of years.
M the number of months.
W the number of weeks.
D the number of days.
T of the representation.
H the number of hours.
M the number of minutes.
S the number of seconds.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const fmt = (n)=>Math.abs(n) || 0;
const toISO = function(diff) {
    let iso = "P";
    iso += fmt(diff.years) + "Y";
    iso += fmt(diff.months) + "M";
    iso += fmt(diff.days) + "DT";
    iso += fmt(diff.hours) + "H";
    iso += fmt(diff.minutes) + "M";
    iso += fmt(diff.seconds) + "S";
    return iso;
};
exports.default = toISO;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fcLzL":[function(require,module,exports) {
//get number of hours/minutes... between the two dates
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getDiff(a, b) {
    const isBefore = a.isBefore(b);
    const later = isBefore ? b : a;
    let earlier = isBefore ? a : b;
    earlier = earlier.clone();
    const diff = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    Object.keys(diff).forEach((unit)=>{
        if (earlier.isSame(later, unit)) return;
        let max = earlier.diff(later, unit);
        earlier = earlier.add(max, unit);
        diff[unit] = max;
    });
    //reverse it, if necessary
    if (isBefore) Object.keys(diff).forEach((u)=>{
        if (diff[u] !== 0) diff[u] *= -1;
    });
    return diff;
}
exports.default = getDiff;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hqsUN":[function(require,module,exports) {
//our conceptual 'break-points' for each unit
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unitsJs = require("../../data/units.js");
var _distanceJs = require("../../data/distance.js");
const qualifiers = {
    months: {
        almost: 10,
        over: 4
    },
    days: {
        almost: 25,
        over: 10
    },
    hours: {
        almost: 20,
        over: 8
    },
    minutes: {
        almost: 50,
        over: 20
    },
    seconds: {
        almost: 50,
        over: 20
    }
};
// Expects a plural unit arg
function pluralize(value, unit) {
    if (value === 1) return value + " " + (0, _unitsJs.unitsString)(unit.slice(0, -1));
    return value + " " + (0, _unitsJs.unitsString)(unit);
}
const toSoft = function(diff) {
    let rounded = null;
    let qualified = null;
    let abbreviated = [];
    let englishValues = [];
    //go through each value and create its text-representation
    Object.keys(diff).forEach((unit, i, units)=>{
        const value = Math.abs(diff[unit]);
        if (value === 0) return;
        abbreviated.push(value + unit[0]);
        const englishValue = pluralize(value, unit);
        englishValues.push(englishValue);
        if (!rounded) {
            rounded = qualified = englishValue;
            if (i > 4) return;
            //is it a 'almost' something, etc?
            const nextUnit = units[i + 1];
            const nextValue = Math.abs(diff[nextUnit]);
            if (nextValue > qualifiers[nextUnit].almost) {
                rounded = pluralize(value + 1, unit);
                qualified = (0, _distanceJs.almostString)() + " " + rounded;
            } else if (nextValue > qualifiers[nextUnit].over) qualified = (0, _distanceJs.overString)() + " " + englishValue;
        }
    });
    return {
        qualified,
        rounded,
        abbreviated,
        englishValues
    };
};
exports.default = toSoft;

},{"../../data/units.js":"k8UqO","../../data/distance.js":"laYXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8UqO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unitsString", ()=>unitsString);
parcelHelpers.export(exports, "set", ()=>set);
let units = {
    second: "second",
    seconds: "seconds",
    minute: "minute",
    minutes: "minutes",
    hour: "hour",
    hours: "hours",
    day: "day",
    days: "days",
    month: "month",
    months: "months",
    year: "year",
    years: "years"
};
function unitsString(unit) {
    return units[unit] || "";
}
function set(i18n = {}) {
    units = {
        second: i18n.second || units.second,
        seconds: i18n.seconds || units.seconds,
        minute: i18n.minute || units.minute,
        minutes: i18n.minutes || units.minutes,
        hour: i18n.hour || units.hour,
        hours: i18n.hours || units.hours,
        day: i18n.day || units.day,
        days: i18n.days || units.days,
        month: i18n.month || units.month,
        months: i18n.months || units.months,
        year: i18n.year || units.year,
        years: i18n.years || units.years
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"laYXz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pastDistanceString", ()=>pastDistanceString);
parcelHelpers.export(exports, "futureDistanceString", ()=>futureDistanceString);
parcelHelpers.export(exports, "pastString", ()=>pastString);
parcelHelpers.export(exports, "futureString", ()=>futureString);
parcelHelpers.export(exports, "presentString", ()=>presentString);
parcelHelpers.export(exports, "nowString", ()=>nowString);
parcelHelpers.export(exports, "almostString", ()=>almostString);
parcelHelpers.export(exports, "overString", ()=>overString);
parcelHelpers.export(exports, "set", ()=>set);
let past = "past";
let future = "future";
let present = "present";
let now = "now";
let almost = "almost";
let over = "over";
let pastDistance = (value)=>`${value} ago`;
let futureDistance = (value)=>`in ${value}`;
function pastDistanceString(value) {
    return pastDistance(value);
}
function futureDistanceString(value) {
    return futureDistance(value);
}
function pastString() {
    return past;
}
function futureString() {
    return future;
}
function presentString() {
    return present;
}
function nowString() {
    return now;
}
function almostString() {
    return almost;
}
function overString() {
    return over;
}
function set(i18n) {
    pastDistance = i18n.pastDistance || pastDistance;
    futureDistance = i18n.futureDistance || futureDistance;
    past = i18n.past || past;
    future = i18n.future || future;
    present = i18n.present || present;
    now = i18n.now || now;
    almost = i18n.almost || almost;
    over = i18n.over || over;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIGAb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startOf", ()=>startOf);
parcelHelpers.export(exports, "endOf", ()=>endOf);
var _seasonsJs = require("../data/seasons.js");
var _seasonsJsDefault = parcelHelpers.interopDefault(_seasonsJs);
var _quartersJs = require("../data/quarters.js");
var _quartersJsDefault = parcelHelpers.interopDefault(_quartersJs);
var _walkJs = require("./set/walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
var _fnsJs = require("../fns.js");
const units = {
    second: (s)=>{
        (0, _walkJsDefault.default)(s, {
            millisecond: 0
        });
        return s;
    },
    minute: (s)=>{
        (0, _walkJsDefault.default)(s, {
            second: 0,
            millisecond: 0
        });
        return s;
    },
    quarterhour: (s)=>{
        let minute = s.minutes();
        if (minute >= 45) s = s.minutes(45);
        else if (minute >= 30) s = s.minutes(30);
        else if (minute >= 15) s = s.minutes(15);
        else s = s.minutes(0);
        (0, _walkJsDefault.default)(s, {
            second: 0,
            millisecond: 0
        });
        return s;
    },
    hour: (s)=>{
        (0, _walkJsDefault.default)(s, {
            minute: 0,
            second: 0,
            millisecond: 0
        });
        return s;
    },
    day: (s)=>{
        (0, _walkJsDefault.default)(s, {
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        });
        return s;
    },
    week: (s)=>{
        let original = s.clone();
        s = s.day(s._weekStart) //monday
        ;
        if (s.isAfter(original)) s = s.subtract(1, "week");
        (0, _walkJsDefault.default)(s, {
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        });
        return s;
    },
    month: (s)=>{
        (0, _walkJsDefault.default)(s, {
            date: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        });
        return s;
    },
    quarter: (s)=>{
        let q = s.quarter();
        if ((0, _quartersJsDefault.default)[q]) (0, _walkJsDefault.default)(s, {
            month: (0, _quartersJsDefault.default)[q][0],
            date: (0, _quartersJsDefault.default)[q][1],
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        });
        return s;
    },
    season: (s)=>{
        let current = s.season();
        let hem = "north";
        if (s.hemisphere() === "South") hem = "south";
        for(let i = 0; i < (0, _seasonsJsDefault.default)[hem].length; i++)if ((0, _seasonsJsDefault.default)[hem][i][0] === current) {
            //winter goes between years
            let year = s.year();
            if (current === "winter" && s.month() < 3) year -= 1;
            (0, _walkJsDefault.default)(s, {
                year,
                month: (0, _seasonsJsDefault.default)[hem][i][1],
                date: (0, _seasonsJsDefault.default)[hem][i][2],
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            });
            return s;
        }
        return s;
    },
    year: (s)=>{
        (0, _walkJsDefault.default)(s, {
            month: 0,
            date: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        });
        return s;
    },
    decade: (s)=>{
        s = s.startOf("year");
        let year = s.year();
        let decade = parseInt(year / 10, 10) * 10;
        s = s.year(decade);
        return s;
    },
    century: (s)=>{
        s = s.startOf("year");
        let year = s.year();
        // near 0AD goes '-1 | +1'
        let decade = parseInt(year / 100, 10) * 100;
        s = s.year(decade);
        return s;
    }
};
units.date = units.day;
const startOf = (a, unit)=>{
    let s = a.clone();
    unit = (0, _fnsJs.normalize)(unit);
    if (units[unit]) return units[unit](s);
    if (unit === "summer" || unit === "winter") {
        s = s.season(unit);
        return units.season(s);
    }
    return s;
};
//piggy-backs off startOf
const endOf = (a, unit)=>{
    let s = a.clone();
    unit = (0, _fnsJs.normalize)(unit);
    if (units[unit]) {
        // go to beginning, go to next one, step back 1ms
        s = units[unit](s) // startof
        ;
        s = s.add(1, unit);
        s = s.subtract(1, "millisecond");
        return s;
    }
    return s;
};

},{"../data/seasons.js":"5PrYe","../data/quarters.js":"1R9Is","./set/walk.js":"h4k56","../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PrYe":[function(require,module,exports) {
//https://www.timeanddate.com/calendar/aboutseasons.html
// Spring - from March 1 to May 31;
// Summer - from June 1 to August 31;
// Fall (autumn) - from September 1 to November 30; and,
// Winter - from December 1 to February 28 (February 29 in a leap year).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const north = [
    [
        "spring",
        2,
        1
    ],
    [
        "summer",
        5,
        1
    ],
    [
        "fall",
        8,
        1
    ],
    [
        "autumn",
        8,
        1
    ],
    [
        "winter",
        11,
        1
    ] //dec 1
];
const south = [
    [
        "fall",
        2,
        1
    ],
    [
        "autumn",
        2,
        1
    ],
    [
        "winter",
        5,
        1
    ],
    [
        "spring",
        8,
        1
    ],
    [
        "summer",
        11,
        1
    ] //dec 1
];
exports.default = {
    north,
    south
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1R9Is":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    null,
    [
        0,
        1
    ],
    [
        3,
        1
    ],
    [
        6,
        1
    ],
    [
        9,
        1
    ] //oct 1
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3udCy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../fns.js");
var _daysJs = require("../data/days.js");
//is it 'wednesday'?
const isDay = function(unit) {
    if ((0, _daysJs.short)().find((s)=>s === unit)) return true;
    if ((0, _daysJs.long)().find((s)=>s === unit)) return true;
    return false;
};
// return a list of the weeks/months/days between a -> b
// returns spacetime objects in the timezone of the input
const every = function(start, unit, end) {
    if (!unit || !end) return [];
    //cleanup unit param
    unit = (0, _fnsJs.normalize)(unit);
    //cleanup to param
    end = start.clone().set(end);
    //swap them, if they're backwards
    if (start.isAfter(end)) {
        let tmp = start;
        start = end;
        end = tmp;
    }
    //support 'every wednesday'
    let d = start.clone();
    if (isDay(unit)) {
        d = d.next(unit);
        unit = "week";
    } else {
        let first = d.startOf(unit);
        if (first.isBefore(start)) d = d.next(unit);
    }
    //okay, actually start doing it
    let result = [];
    while(d.isBefore(end)){
        result.push(d);
        d = d.add(1, unit);
    }
    return result;
};
exports.default = every;

},{"../fns.js":"dnKgs","../data/days.js":"kecYW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lGhSS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _summerTimeJs = require("./summerTime.js");
var _summerTimeJsDefault = parcelHelpers.interopDefault(_summerTimeJs);
const parseDst = (dst)=>{
    if (!dst) return [];
    return dst.split("->");
};
//iana codes are case-sensitive, technically
const titleCase = (str)=>{
    str = str[0].toUpperCase() + str.substr(1);
    str = str.replace(/[\/_-]([a-z])/gi, (s)=>{
        return s.toUpperCase();
    });
    str = str.replace(/_(of|es)_/i, (s)=>s.toLowerCase());
    str = str.replace(/\/gmt/i, "/GMT");
    str = str.replace(/\/Dumontdurville$/i, "/DumontDUrville");
    str = str.replace(/\/Mcmurdo$/i, "/McMurdo");
    str = str.replace(/\/Port-au-prince$/i, "/Port-au-Prince");
    return str;
};
//get metadata about this timezone
const timezone = (s)=>{
    let zones = s.timezones;
    let tz = s.tz;
    if (zones.hasOwnProperty(tz) === false) tz = (0, _findJsDefault.default)(s.tz, zones);
    if (tz === null) {
        if (s.silent === false) console.warn("Warn: could not find given or local timezone - '" + s.tz + "'");
        return {
            current: {
                epochShift: 0
            }
        };
    }
    let found = zones[tz];
    let result = {
        name: titleCase(tz),
        hasDst: Boolean(found.dst),
        default_offset: found.offset,
        //do north-hemisphere version as default (sorry!)
        hemisphere: found.hem === "s" ? "South" : "North",
        current: {}
    };
    if (result.hasDst) {
        let arr = parseDst(found.dst);
        result.change = {
            start: arr[0],
            back: arr[1]
        };
    }
    //find the offsets for summer/winter times
    //(these variable names are north-centric)
    let summer = found.offset // (july)
    ;
    let winter = summer // (january) assume it's the same for now
    ;
    if (result.hasDst === true) {
        if (result.hemisphere === "North") winter = summer - 1;
        else //southern hemisphere
        winter = found.offset + 1;
    }
    //find out which offset to use right now
    //use 'summer' time july-time
    if (result.hasDst === false) {
        result.current.offset = summer;
        result.current.isDST = false;
    } else if ((0, _summerTimeJsDefault.default)(s.epoch, result.change.start, result.change.back, summer, winter) === true) {
        result.current.offset = summer;
        result.current.isDST = result.hemisphere === "North" //dst 'on' in winter in north
        ;
    } else {
        //use 'winter' january-time
        result.current.offset = winter;
        result.current.isDST = result.hemisphere === "South" //dst 'on' in summer in south
        ;
    }
    return result;
};
exports.default = timezone;

},{"./find.js":"dtXkU","./summerTime.js":"jCZVr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Uo4Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _01TimeJs = require("./01-time.js");
var _01TimeJsDefault = parcelHelpers.interopDefault(_01TimeJs);
var _02DateJs = require("./02-date.js");
var _02DateJsDefault = parcelHelpers.interopDefault(_02DateJs);
var _03YearJs = require("./03-year.js");
var _03YearJsDefault = parcelHelpers.interopDefault(_03YearJs);
const methods = Object.assign({}, (0, _01TimeJsDefault.default), (0, _02DateJsDefault.default), (0, _03YearJsDefault.default));
//aliases
methods.milliseconds = methods.millisecond;
methods.seconds = methods.second;
methods.minutes = methods.minute;
methods.hours = methods.hour;
methods.hour24 = methods.hour;
methods.h12 = methods.hour12;
methods.h24 = methods.hour24;
methods.days = methods.day;
const addMethods = (Space)=>{
    //hook the methods into prototype
    Object.keys(methods).forEach((k)=>{
        Space.prototype[k] = methods[k];
    });
};
exports.default = addMethods;

},{"./01-time.js":"hmY2z","./02-date.js":"ewoEJ","./03-year.js":"e0z9A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmY2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setJs = require("../set/set.js");
var _ampmJs = require("../../data/ampm.js");
var _fnsJs = require("../../fns.js");
const methods = {
    millisecond: function(num) {
        if (num !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.milliseconds)(s, num);
            return s;
        }
        return this.d.getMilliseconds();
    },
    second: function(num, goFwd) {
        if (num !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.seconds)(s, num, goFwd);
            return s;
        }
        return this.d.getSeconds();
    },
    minute: function(num, goFwd) {
        if (num !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.minutes)(s, num, goFwd);
            return s;
        }
        return this.d.getMinutes();
    },
    hour: function(num, goFwd) {
        let d = this.d;
        if (num !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.hours)(s, num, goFwd);
            return s;
        }
        return d.getHours();
    },
    //'3:30' is 3.5
    hourFloat: function(num, goFwd) {
        if (num !== undefined) {
            let s = this.clone();
            let minute = num % 1;
            minute = minute * 60;
            let hour = parseInt(num, 10);
            s.epoch = (0, _setJs.hours)(s, hour, goFwd);
            s.epoch = (0, _setJs.minutes)(s, minute, goFwd);
            return s;
        }
        let d = this.d;
        let hour = d.getHours();
        let minute = d.getMinutes();
        minute = minute / 60;
        return hour + minute;
    },
    // hour in 12h format
    hour12: function(str, goFwd) {
        let d = this.d;
        if (str !== undefined) {
            let s = this.clone();
            str = "" + str;
            let m = str.match(/^([0-9]+)(am|pm)$/);
            if (m) {
                let hour = parseInt(m[1], 10);
                if (m[2] === "pm") hour += 12;
                s.epoch = (0, _setJs.hours)(s, hour, goFwd);
            }
            return s;
        }
        //get the hour
        let hour12 = d.getHours();
        if (hour12 > 12) hour12 = hour12 - 12;
        if (hour12 === 0) hour12 = 12;
        return hour12;
    },
    //some ambiguity here with 12/24h
    time: function(str, goFwd) {
        if (str !== undefined) {
            let s = this.clone();
            str = str.toLowerCase().trim();
            s.epoch = (0, _setJs.time)(s, str, goFwd);
            return s;
        }
        return `${this.h12()}:${(0, _fnsJs.zeroPad)(this.minute())}${this.ampm()}`;
    },
    // either 'am' or 'pm'
    ampm: function(input, goFwd) {
        // let which = 'am'
        let which = (0, _ampmJs.am)();
        let hour = this.hour();
        if (hour >= 12) // which = 'pm'
        which = (0, _ampmJs.pm)();
        if (typeof input !== "string") return which;
        //okay, we're doing a setter
        let s = this.clone();
        input = input.toLowerCase().trim();
        //ampm should never change the day
        // - so use `.hour(n)` instead of `.minus(12,'hour')`
        if (hour >= 12 && input === "am") {
            //noon is 12pm
            hour -= 12;
            return s.hour(hour, goFwd);
        }
        if (hour < 12 && input === "pm") {
            hour += 12;
            return s.hour(hour, goFwd);
        }
        return s;
    },
    //some hard-coded times of day, like 'noon'
    dayTime: function(str, goFwd) {
        if (str !== undefined) {
            const times = {
                morning: "7:00",
                breakfast: "7:00",
                noon: "12:00",
                lunch: "12:00",
                afternoon: "14:00",
                evening: "18:00",
                dinner: "18:00",
                night: "23:00",
                midnight: "00:00"
            };
            let s = this.clone();
            str = str || "";
            str = str.toLowerCase();
            if (times.hasOwnProperty(str) === true) s = s.time(times[str], goFwd);
            return s;
        }
        let h = this.hour();
        if (h < 6) return "night";
        if (h < 12) //until noon
        return "morning";
        if (h < 17) //until 5pm
        return "afternoon";
        if (h < 22) //until 10pm
        return "evening";
        return "night";
    },
    //parse a proper iso string
    iso: function(num) {
        if (num !== undefined) return this.set(num);
        return this.format("iso");
    }
};
exports.default = methods;

},{"../set/set.js":"a1rLP","../../data/ampm.js":"6wyex","../../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a1rLP":[function(require,module,exports) {
// javascript setX methods like setDate() can't be used because of the local bias
//these methods wrap around them.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
parcelHelpers.export(exports, "seconds", ()=>seconds);
parcelHelpers.export(exports, "minutes", ()=>minutes);
parcelHelpers.export(exports, "hours", ()=>hours);
parcelHelpers.export(exports, "time", ()=>time);
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "month", ()=>month);
parcelHelpers.export(exports, "year", ()=>year);
parcelHelpers.export(exports, "week", ()=>week);
parcelHelpers.export(exports, "dayOfYear", ()=>dayOfYear);
var _millisecondsJs = require("../../data/milliseconds.js");
var _millisecondsJsDefault = parcelHelpers.interopDefault(_millisecondsJs);
var _monthsJs = require("../../data/months.js");
var _monthLengthsJs = require("../../data/monthLengths.js");
var _monthLengthsJsDefault = parcelHelpers.interopDefault(_monthLengthsJs);
var _walkJs = require("./walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
var _fnsJs = require("../../fns.js");
const validate = (n)=>{
    //handle number as a string
    if (typeof n === "string") n = parseInt(n, 10);
    return n;
};
const order = [
    "year",
    "month",
    "date",
    "hour",
    "minute",
    "second",
    "millisecond"
];
//reduce hostile micro-changes when moving dates by millisecond
const confirm = (s, tmp, unit)=>{
    let n = order.indexOf(unit);
    let arr = order.slice(n, order.length);
    for(let i = 0; i < arr.length; i++){
        let want = tmp[arr[i]]();
        s[arr[i]](want);
    }
    return s;
};
// allow specifying setter direction
const fwdBkwd = function(s, old, goFwd, unit) {
    if (goFwd === true && s.isBefore(old)) s = s.add(1, unit);
    else if (goFwd === false && s.isAfter(old)) s = s.minus(1, unit);
    return s;
};
const milliseconds = function(s, n) {
    n = validate(n);
    let current = s.millisecond();
    let diff = current - n //milliseconds to shift by
    ;
    return s.epoch - diff;
};
const seconds = function(s, n, goFwd) {
    n = validate(n);
    let old = s.clone();
    let diff = s.second() - n;
    let shift = diff * (0, _millisecondsJsDefault.default).second;
    s.epoch = s.epoch - shift;
    s = fwdBkwd(s, old, goFwd, "minute") // specify direction
    ;
    return s.epoch;
};
const minutes = function(s, n, goFwd) {
    n = validate(n);
    let old = s.clone();
    let diff = s.minute() - n;
    let shift = diff * (0, _millisecondsJsDefault.default).minute;
    s.epoch -= shift;
    confirm(s, old, "second");
    s = fwdBkwd(s, old, goFwd, "hour") // specify direction
    ;
    return s.epoch;
};
const hours = function(s, n, goFwd) {
    n = validate(n);
    if (n >= 24) n = 24;
    else if (n < 0) n = 0;
    let old = s.clone();
    let diff = s.hour() - n;
    let shift = diff * (0, _millisecondsJsDefault.default).hour;
    s.epoch -= shift;
    // oops, did we change the day?
    if (s.date() !== old.date()) {
        s = old.clone();
        if (diff > 1) diff -= 1;
        if (diff < 1) diff += 1;
        shift = diff * (0, _millisecondsJsDefault.default).hour;
        s.epoch -= shift;
    }
    (0, _walkJsDefault.default)(s, {
        hour: n
    });
    confirm(s, old, "minute");
    s = fwdBkwd(s, old, goFwd, "day") // specify direction
    ;
    return s.epoch;
};
const time = function(s, str, goFwd) {
    let m = str.match(/([0-9]{1,2})[:h]([0-9]{1,2})(:[0-9]{1,2})? ?(am|pm)?/);
    if (!m) {
        //fallback to support just '2am'
        m = str.match(/([0-9]{1,2}) ?(am|pm)/);
        if (!m) return s.epoch;
        m.splice(2, 0, "0") //add implicit 0 minutes
        ;
        m.splice(3, 0, "") //add implicit seconds
        ;
    }
    let h24 = false;
    let hour = parseInt(m[1], 10);
    let minute = parseInt(m[2], 10);
    if (minute >= 60) minute = 59;
    if (hour > 12) h24 = true;
    //make the hour into proper 24h time
    if (h24 === false) {
        if (m[4] === "am" && hour === 12) //12am is midnight
        hour = 0;
        if (m[4] === "pm" && hour < 12) //12pm is noon
        hour += 12;
    }
    // handle seconds
    m[3] = m[3] || "";
    m[3] = m[3].replace(/:/, "");
    let sec = parseInt(m[3], 10) || 0;
    let old = s.clone();
    s = s.hour(hour);
    s = s.minute(minute);
    s = s.second(sec);
    s = s.millisecond(0);
    s = fwdBkwd(s, old, goFwd, "day") // specify direction
    ;
    return s.epoch;
};
const date = function(s, n, goFwd) {
    n = validate(n);
    //avoid setting february 31st
    if (n > 28) {
        let month = s.month();
        let max = (0, _monthLengthsJsDefault.default)[month];
        // support leap day in february
        if (month === 1 && n === 29 && (0, _fnsJs.isLeapYear)(s.year())) max = 29;
        if (n > max) n = max;
    }
    //avoid setting < 0
    if (n <= 0) n = 1;
    let old = s.clone();
    (0, _walkJsDefault.default)(s, {
        date: n
    });
    s = fwdBkwd(s, old, goFwd, "month") // specify direction
    ;
    return s.epoch;
};
const month = function(s, n, goFwd) {
    if (typeof n === "string") {
        if (n === "sept") n = "sep";
        n = (0, _monthsJs.mapping)()[n.toLowerCase()];
    }
    n = validate(n);
    //don't go past december
    if (n >= 12) n = 11;
    if (n <= 0) n = 0;
    let d = s.date();
    //there's no 30th of february, etc.
    if (d > (0, _monthLengthsJsDefault.default)[n]) //make it as close as we can..
    d = (0, _monthLengthsJsDefault.default)[n];
    let old = s.clone();
    (0, _walkJsDefault.default)(s, {
        month: n,
        d
    });
    s = fwdBkwd(s, old, goFwd, "year") // specify direction
    ;
    return s.epoch;
};
const year = function(s, n) {
    // support '97
    if (typeof n === "string" && /^'[0-9]{2}$/.test(n)) {
        n = n.replace(/'/, "").trim();
        n = Number(n);
        // '89 is 1989
        if (n > 30) //change this in 10y
        n = 1900 + n;
        else // '12 is 2012
        n = 2000 + n;
    }
    n = validate(n);
    (0, _walkJsDefault.default)(s, {
        year: n
    });
    return s.epoch;
};
const week = function(s, n, goFwd) {
    let old = s.clone();
    n = validate(n);
    s = s.month(0);
    s = s.date(1);
    s = s.day("monday");
    //first week starts first Thurs in Jan
    // so mon dec 28th is 1st week
    // so mon dec 29th is not the week
    if (s.monthName() === "december" && s.date() >= 28) s = s.add(1, "week");
    n -= 1 //1-based
    ;
    s = s.add(n, "weeks");
    s = fwdBkwd(s, old, goFwd, "year") // specify direction
    ;
    return s.epoch;
};
const dayOfYear = function(s, n, goFwd) {
    n = validate(n);
    let old = s.clone();
    n -= 1 //days are 1-based
    ;
    if (n <= 0) n = 0;
    else if (n >= 365) {
        if ((0, _fnsJs.isLeapYear)(s.year())) n = 365;
        else n = 364;
    }
    s = s.startOf("year");
    s = s.add(n, "day");
    confirm(s, old, "hour");
    s = fwdBkwd(s, old, goFwd, "year") // specify direction
    ;
    return s.epoch;
};

},{"../../data/milliseconds.js":"59wJe","../../data/months.js":"c9Fjq","../../data/monthLengths.js":"j3jMR","./walk.js":"h4k56","../../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6wyex":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "am", ()=>am);
parcelHelpers.export(exports, "pm", ()=>pm);
parcelHelpers.export(exports, "set", ()=>set);
let morning = "am";
let evening = "pm";
function am() {
    return morning;
}
function pm() {
    return evening;
}
function set(i18n) {
    morning = i18n.am || morning;
    evening = i18n.pm || evening;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewoEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setJs = require("../set/set.js");
var _daysJs = require("../../data/days.js");
var _walkJs = require("../set/walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
const methods = {
    // # day in the month
    date: function(num, goFwd) {
        if (num !== undefined) {
            let s = this.clone();
            num = parseInt(num, 10);
            if (num) s.epoch = (0, _setJs.date)(s, num, goFwd);
            return s;
        }
        return this.d.getDate();
    },
    //like 'wednesday' (hard!)
    day: function(input, goFwd) {
        if (input === undefined) return this.d.getDay();
        let original = this.clone();
        let want = input;
        // accept 'wednesday'
        if (typeof input === "string") {
            input = input.toLowerCase();
            if ((0, _daysJs.aliases).hasOwnProperty(input)) want = (0, _daysJs.aliases)[input];
            else {
                want = (0, _daysJs.short)().indexOf(input);
                if (want === -1) want = (0, _daysJs.long)().indexOf(input);
            }
        }
        //move approx
        let day = this.d.getDay();
        let diff = day - want;
        if (goFwd === true && diff > 0) diff = diff - 7;
        if (goFwd === false && diff < 0) diff = diff + 7;
        let s = this.subtract(diff, "days");
        //tighten it back up
        (0, _walkJsDefault.default)(s, {
            hour: original.hour(),
            minute: original.minute(),
            second: original.second()
        });
        return s;
    },
    //these are helpful name-wrappers
    dayName: function(input, goFwd) {
        if (input === undefined) return (0, _daysJs.long)()[this.day()];
        let s = this.clone();
        s = s.day(input, goFwd);
        return s;
    }
};
exports.default = methods;

},{"../set/set.js":"a1rLP","../../data/days.js":"kecYW","../set/walk.js":"h4k56","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e0z9A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setJs = require("../set/set.js");
var _monthsJs = require("../../data/months.js");
var _quartersJs = require("../../data/quarters.js");
var _quartersJsDefault = parcelHelpers.interopDefault(_quartersJs);
var _seasonsJs = require("../../data/seasons.js");
var _seasonsJsDefault = parcelHelpers.interopDefault(_seasonsJs);
var _millisecondsJs = require("../../data/milliseconds.js");
var _millisecondsJsDefault = parcelHelpers.interopDefault(_millisecondsJs);
const clearMinutes = (s)=>{
    s = s.minute(0);
    s = s.second(0);
    s = s.millisecond(1);
    return s;
};
const methods = {
    // day 0-366
    dayOfYear: function(num, goFwd) {
        if (num !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.dayOfYear)(s, num, goFwd);
            return s;
        }
        //days since newyears - jan 1st is 1, jan 2nd is 2...
        let sum = 0;
        let month = this.d.getMonth();
        let tmp;
        //count the num days in each month
        for(let i = 1; i <= month; i++){
            tmp = new Date();
            tmp.setDate(1);
            tmp.setFullYear(this.d.getFullYear()) //the year matters, because leap-years
            ;
            tmp.setHours(1);
            tmp.setMinutes(1);
            tmp.setMonth(i);
            tmp.setHours(-2) //the last day of the month
            ;
            sum += tmp.getDate();
        }
        return sum + this.d.getDate();
    },
    //since the start of the year
    week: function(num, goFwd) {
        // week-setter
        if (num !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.week)(this, num, goFwd);
            s = clearMinutes(s);
            return s;
        }
        //find-out which week it is
        let tmp = this.clone();
        tmp = tmp.month(0);
        tmp = tmp.date(1);
        tmp = clearMinutes(tmp);
        tmp = tmp.day("monday");
        //don't go into last-year
        if (tmp.month() === 11 && tmp.date() >= 25) tmp = tmp.add(1, "week");
        // is first monday the 1st?
        let toAdd = 1;
        if (tmp.date() === 1) toAdd = 0;
        tmp = tmp.minus(1, "second");
        const thisOne = this.epoch;
        //if the week technically hasn't started yet
        if (tmp.epoch > thisOne) return 1;
        //speed it up, if we can
        let i = 0;
        let skipWeeks = this.month() * 4;
        // console.log(ms.week+ " "+ skipWeeks);
        tmp.epoch += (0, _millisecondsJsDefault.default).week * skipWeeks;
        i += skipWeeks;
        for(; i <= 52; i++){
            if (tmp.epoch > thisOne) return i + toAdd;
            tmp = tmp.add(1, "week");
        }
        return 52;
    },
    //either name or number
    month: function(input, goFwd) {
        if (input !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.month)(s, input, goFwd);
            return s;
        }
        return this.d.getMonth();
    },
    //'january'
    monthName: function(input, goFwd) {
        if (input !== undefined) {
            let s = this.clone();
            s = s.month(input, goFwd);
            return s;
        }
        return (0, _monthsJs.long)()[this.month()];
    },
    //q1, q2, q3, q4
    quarter: function(num, goFwd) {
        if (num !== undefined) {
            if (typeof num === "string") {
                num = num.replace(/^q/i, "");
                num = parseInt(num, 10);
            }
            if ((0, _quartersJsDefault.default)[num]) {
                let s = this.clone();
                let month = (0, _quartersJsDefault.default)[num][0];
                s = s.month(month, goFwd);
                s = s.date(1, goFwd);
                s = s.startOf("day");
                return s;
            }
        }
        let month = this.d.getMonth();
        for(let i = 1; i < (0, _quartersJsDefault.default).length; i++){
            if (month < (0, _quartersJsDefault.default)[i][0]) return i - 1;
        }
        return 4;
    },
    //spring, summer, winter, fall
    season: function(input, goFwd) {
        let hem = "north";
        if (this.hemisphere() === "South") hem = "south";
        if (input !== undefined) {
            let s = this.clone();
            for(let i = 0; i < (0, _seasonsJsDefault.default)[hem].length; i++)if (input === (0, _seasonsJsDefault.default)[hem][i][0]) {
                s = s.month((0, _seasonsJsDefault.default)[hem][i][1], goFwd);
                s = s.date(1);
                s = s.startOf("day");
            }
            return s;
        }
        let month = this.d.getMonth();
        for(let i = 0; i < (0, _seasonsJsDefault.default)[hem].length - 1; i++){
            if (month >= (0, _seasonsJsDefault.default)[hem][i][1] && month < (0, _seasonsJsDefault.default)[hem][i + 1][1]) return (0, _seasonsJsDefault.default)[hem][i][0];
        }
        return hem === "north" ? "winter" : "summer";
    },
    //the year number
    year: function(num) {
        if (num !== undefined) {
            let s = this.clone();
            s.epoch = (0, _setJs.year)(s, num);
            return s;
        }
        return this.d.getFullYear();
    },
    //bc/ad years
    era: function(str) {
        if (str !== undefined) {
            let s = this.clone();
            str = str.toLowerCase();
            //TODO: there is no year-0AD i think. may have off-by-1 error here
            let year = s.d.getFullYear();
            //make '1992' into 1992bc..
            if (str === "bc" && year > 0) s.epoch = (0, _setJs.year)(s, year * -1);
            //make '1992bc' into '1992'
            if (str === "ad" && year < 0) s.epoch = (0, _setJs.year)(s, year * -1);
            return s;
        }
        if (this.d.getFullYear() < 0) return "BC";
        return "AD";
    },
    // 2019 -> 2010
    decade: function(input) {
        if (input !== undefined) {
            input = String(input);
            input = input.replace(/([0-9])'?s$/, "$1") //1950's
            ;
            input = input.replace(/([0-9])(th|rd|st|nd)/, "$1") //fix ordinals
            ;
            if (!input) {
                console.warn("Spacetime: Invalid decade input");
                return this;
            }
            // assume 20th century?? for '70s'.
            if (input.length === 2 && /[0-9][0-9]/.test(input)) input = "19" + input;
            let year = Number(input);
            if (isNaN(year)) return this;
            // round it down to the decade
            year = Math.floor(year / 10) * 10;
            return this.year(year) //.startOf('decade')
            ;
        }
        return this.startOf("decade").year();
    },
    // 1950 -> 19+1
    century: function(input) {
        if (input !== undefined) {
            if (typeof input === "string") {
                input = input.replace(/([0-9])(th|rd|st|nd)/, "$1") //fix ordinals
                ;
                input = input.replace(/([0-9]+) ?(b\.?c\.?|a\.?d\.?)/i, (a, b, c)=>{
                    if (c.match(/b\.?c\.?/i)) b = "-" + b;
                    return b;
                });
                input = input.replace(/c$/, "") //20thC
                ;
            }
            let year = Number(input);
            if (isNaN(input)) {
                console.warn("Spacetime: Invalid century input");
                return this;
            }
            // there is no century 0
            if (year === 0) year = 1;
            if (year >= 0) year = (year - 1) * 100;
            else year = (year + 1) * 100;
            return this.year(year);
        }
        // century getter
        let num = this.startOf("century").year();
        num = Math.floor(num / 100);
        if (num < 0) return num - 1;
        return num + 1;
    },
    // 2019 -> 2+1
    millenium: function(input) {
        if (input !== undefined) {
            if (typeof input === "string") {
                input = input.replace(/([0-9])(th|rd|st|nd)/, "$1") //fix ordinals
                ;
                input = Number(input);
                if (isNaN(input)) {
                    console.warn("Spacetime: Invalid millenium input");
                    return this;
                }
            }
            if (input > 0) input -= 1;
            let year = input * 1000;
            // there is no year 0
            if (year === 0) year = 1;
            return this.year(year);
        }
        // get the current millenium
        let num = Math.floor(this.year() / 1000);
        if (num >= 0) num += 1;
        return num;
    }
};
exports.default = methods;

},{"../set/set.js":"a1rLP","../../data/months.js":"c9Fjq","../../data/quarters.js":"1R9Is","../../data/seasons.js":"5PrYe","../../data/milliseconds.js":"59wJe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ad1Wb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _walkJs = require("./set/walk.js");
var _walkJsDefault = parcelHelpers.interopDefault(_walkJs);
var _millisecondsJs = require("../data/milliseconds.js");
var _millisecondsJsDefault = parcelHelpers.interopDefault(_millisecondsJs);
var _monthLengthsJs = require("../data/monthLengths.js");
var _monthLengthsJsDefault = parcelHelpers.interopDefault(_monthLengthsJs);
var _modelJs = require("./set/_model.js");
var _fnsJs = require("../fns.js");
// this logic is a bit of a mess,
// but briefly:
// millisecond-math, and some post-processing covers most-things
// we 'model' the calendar here only a little bit
// and that usually works-out...
const order = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "date",
    "month"
];
let keep = {
    second: order.slice(0, 1),
    minute: order.slice(0, 2),
    quarterhour: order.slice(0, 2),
    hour: order.slice(0, 3),
    date: order.slice(0, 4),
    month: order.slice(0, 4),
    quarter: order.slice(0, 4),
    season: order.slice(0, 4),
    year: order,
    decade: order,
    century: order
};
keep.week = keep.hour;
keep.season = keep.date;
keep.quarter = keep.date;
// Units need to be dst adjuested
const dstAwareUnits = {
    year: true,
    quarter: true,
    season: true,
    month: true,
    week: true,
    date: true
};
const keepDate = {
    month: true,
    quarter: true,
    season: true,
    year: true
};
const addMethods = (SpaceTime)=>{
    SpaceTime.prototype.add = function(num, unit) {
        let s = this.clone();
        if (!unit || num === 0) return s //don't bother
        ;
        let old = this.clone();
        unit = (0, _fnsJs.normalize)(unit);
        if (unit === "millisecond") {
            s.epoch += num;
            return s;
        }
        // support 'fortnight' alias
        if (unit === "fortnight") {
            num *= 2;
            unit = "week";
        }
        //move forward by the estimated milliseconds (rough)
        if ((0, _millisecondsJsDefault.default)[unit]) s.epoch += (0, _millisecondsJsDefault.default)[unit] * num;
        else if (unit === "week" || unit === "weekend") s.epoch += (0, _millisecondsJsDefault.default).day * (num * 7);
        else if (unit === "quarter" || unit === "season") s.epoch += (0, _millisecondsJsDefault.default).month * (num * 3);
        else if (unit === "quarterhour") s.epoch += (0, _millisecondsJsDefault.default).minute * 15 * num;
        //now ensure our milliseconds/etc are in-line
        let want = {};
        if (keep[unit]) keep[unit].forEach((u)=>{
            want[u] = old[u]();
        });
        if (dstAwareUnits[unit]) {
            const diff = old.timezone().current.offset - s.timezone().current.offset;
            s.epoch += diff * 3600000;
        }
        //ensure month/year has ticked-over
        if (unit === "month") {
            want.month = old.month() + num;
            //month is the one unit we 'model' directly
            want = (0, _modelJs.months)(want, old);
        }
        //support coercing a week, too
        if (unit === "week") {
            let sum = old.date() + num * 7;
            if (sum <= 28 && sum > 1) want.date = sum;
        }
        if (unit === "weekend" && s.dayName() !== "saturday") s = s.day("saturday", true) //ensure it's saturday
        ;
        else if (unit === "date") {
            if (num < 0) want = (0, _modelJs.daysBack)(want, old, num);
            else {
                //specify a naive date number, if it's easy to do...
                let sum = old.date() + num;
                // ok, model this one too
                want = (0, _modelJs.days)(want, old, sum);
            }
            //manually punt it if we haven't moved at all..
            if (num !== 0 && old.isSame(s, "day")) want.date = old.date() + num;
        } else if (unit === "quarter") {
            want.month = old.month() + num * 3;
            want.year = old.year();
            // handle rollover
            if (want.month < 0) {
                let years = Math.floor(want.month / 12);
                let remainder = want.month + Math.abs(years) * 12;
                want.month = remainder;
                want.year += years;
            } else if (want.month >= 12) {
                let years = Math.floor(want.month / 12);
                want.month = want.month % 12;
                want.year += years;
            }
            want.date = old.date();
        } else if (unit === "year") {
            let wantYear = old.year() + num;
            let haveYear = s.year();
            if (haveYear < wantYear) {
                let toAdd = Math.floor(num / 4) || 1 //approx num of leap-days
                ;
                s.epoch += Math.abs((0, _millisecondsJsDefault.default).day * toAdd);
            } else if (haveYear > wantYear) {
                let toAdd = Math.floor(num / 4) || 1 //approx num of leap-days
                ;
                s.epoch += (0, _millisecondsJsDefault.default).day * toAdd;
            }
        } else if (unit === "decade") want.year = s.year() + 10;
        else if (unit === "century") want.year = s.year() + 100;
        //keep current date, unless the month doesn't have it.
        if (keepDate[unit]) {
            let max = (0, _monthLengthsJsDefault.default)[want.month];
            want.date = old.date();
            if (want.date > max) want.date = max;
        }
        if (Object.keys(want).length > 1) (0, _walkJsDefault.default)(s, want);
        return s;
    };
    //subtract is only add *-1
    SpaceTime.prototype.subtract = function(num, unit) {
        let s = this.clone();
        return s.add(num * -1, unit);
    };
    //add aliases
    SpaceTime.prototype.minus = SpaceTime.prototype.subtract;
    SpaceTime.prototype.plus = SpaceTime.prototype.add;
};
exports.default = addMethods;

},{"./set/walk.js":"h4k56","../data/milliseconds.js":"59wJe","../data/monthLengths.js":"j3jMR","./set/_model.js":"1ZCEE","../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ZCEE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", ()=>months);
parcelHelpers.export(exports, "days", ()=>days);
parcelHelpers.export(exports, "daysBack", ()=>daysBack);
var _monthLengthsJs = require("../../data/monthLengths.js");
var _monthLengthsJsDefault = parcelHelpers.interopDefault(_monthLengthsJs);
var _fnsJs = require("../../fns.js");
const getMonthLength = function(month, year) {
    if (month === 1 && (0, _fnsJs.isLeapYear)(year)) return 29;
    return (0, _monthLengthsJsDefault.default)[month];
};
//month is the one thing we 'model/compute'
//- because ms-shifting can be off by enough
const rollMonth = (want, old)=>{
    //increment year
    if (want.month > 0) {
        let years = parseInt(want.month / 12, 10);
        want.year = old.year() + years;
        want.month = want.month % 12;
    } else if (want.month < 0) {
        let m = Math.abs(want.month);
        let years = parseInt(m / 12, 10);
        if (m % 12 !== 0) years += 1;
        want.year = old.year() - years;
        //ignore extras
        want.month = want.month % 12;
        want.month = want.month + 12;
        if (want.month === 12) want.month = 0;
    }
    return want;
};
// briefly support day=-2 (this does not need to be perfect.)
const rollDaysDown = (want, old, sum)=>{
    want.year = old.year();
    want.month = old.month();
    let date = old.date();
    want.date = date - Math.abs(sum);
    while(want.date < 1){
        want.month -= 1;
        if (want.month < 0) {
            want.month = 11;
            want.year -= 1;
        }
        let max = getMonthLength(want.month, want.year);
        want.date += max;
    }
    return want;
};
// briefly support day=33 (this does not need to be perfect.)
const rollDaysUp = (want, old, sum)=>{
    let year = old.year();
    let month = old.month();
    let max = getMonthLength(month, year);
    while(sum > max){
        sum -= max;
        month += 1;
        if (month >= 12) {
            month -= 12;
            year += 1;
        }
        max = getMonthLength(month, year);
    }
    want.month = month;
    want.date = sum;
    return want;
};
const months = rollMonth;
const days = rollDaysUp;
const daysBack = rollDaysDown;

},{"../../data/monthLengths.js":"j3jMR","../../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6fFq":[function(require,module,exports) {
//make a string, for easy comparison between dates
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const print = {
    millisecond: (s)=>{
        return s.epoch;
    },
    second: (s)=>{
        return [
            s.year(),
            s.month(),
            s.date(),
            s.hour(),
            s.minute(),
            s.second()
        ].join("-");
    },
    minute: (s)=>{
        return [
            s.year(),
            s.month(),
            s.date(),
            s.hour(),
            s.minute()
        ].join("-");
    },
    hour: (s)=>{
        return [
            s.year(),
            s.month(),
            s.date(),
            s.hour()
        ].join("-");
    },
    day: (s)=>{
        return [
            s.year(),
            s.month(),
            s.date()
        ].join("-");
    },
    week: (s)=>{
        return [
            s.year(),
            s.week()
        ].join("-");
    },
    month: (s)=>{
        return [
            s.year(),
            s.month()
        ].join("-");
    },
    quarter: (s)=>{
        return [
            s.year(),
            s.quarter()
        ].join("-");
    },
    year: (s)=>{
        return s.year();
    }
};
print.date = print.day;
const addMethods = (SpaceTime)=>{
    SpaceTime.prototype.isSame = function(b, unit, tzAware = true) {
        let a = this;
        if (!unit) return null;
        // support swapped params
        if (typeof b === "string" && typeof unit === "object") {
            let tmp = b;
            b = unit;
            unit = tmp;
        }
        if (typeof b === "string" || typeof b === "number") b = new SpaceTime(b, this.timezone.name);
        //support 'seconds' aswell as 'second'
        unit = unit.replace(/s$/, "");
        // make them the same timezone for proper comparison
        if (tzAware === true && a.tz !== b.tz) {
            b = b.clone();
            b.tz = a.tz;
        }
        if (print[unit]) return print[unit](a) === print[unit](b);
        return null;
    };
};
exports.default = addMethods;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYGBp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../fns.js");
const addMethods = (SpaceTime)=>{
    const methods = {
        isAfter: function(d) {
            d = (0, _fnsJs.beADate)(d, this);
            let epoch = (0, _fnsJs.getEpoch)(d);
            if (epoch === null) return null;
            return this.epoch > epoch;
        },
        isBefore: function(d) {
            d = (0, _fnsJs.beADate)(d, this);
            let epoch = (0, _fnsJs.getEpoch)(d);
            if (epoch === null) return null;
            return this.epoch < epoch;
        },
        isEqual: function(d) {
            d = (0, _fnsJs.beADate)(d, this);
            let epoch = (0, _fnsJs.getEpoch)(d);
            if (epoch === null) return null;
            return this.epoch === epoch;
        },
        isBetween: function(start, end, isInclusive = false) {
            start = (0, _fnsJs.beADate)(start, this);
            end = (0, _fnsJs.beADate)(end, this);
            let startEpoch = (0, _fnsJs.getEpoch)(start);
            if (startEpoch === null) return null;
            let endEpoch = (0, _fnsJs.getEpoch)(end);
            if (endEpoch === null) return null;
            if (isInclusive) return this.isBetween(start, end) || this.isEqual(start) || this.isEqual(end);
            return startEpoch < this.epoch && this.epoch < endEpoch;
        }
    };
    //hook them into proto
    Object.keys(methods).forEach((k)=>{
        SpaceTime.prototype[k] = methods[k];
    });
};
exports.default = addMethods;

},{"../fns.js":"dnKgs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dCRq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fnsJs = require("../fns.js");
var _daysJs = require("../data/days.js");
var _monthsJs = require("../data/months.js");
var _caseFormatJs = require("../data/caseFormat.js");
var _ampmJs = require("../data/ampm.js");
var _distanceJs = require("../data/distance.js");
var _unitsJs = require("../data/units.js");
const addMethods = (SpaceTime)=>{
    const methods = {
        i18n: function(data) {
            //change the day names
            if ((0, _fnsJs.isObject)(data.days)) (0, _daysJs.set)(data.days);
            //change the month names
            if ((0, _fnsJs.isObject)(data.months)) (0, _monthsJs.set)(data.months);
            //change the display style of the month / day names
            if ((0, _fnsJs.isBoolean)(data.useTitleCase)) (0, _caseFormatJs.set)(data.useTitleCase);
            //change am and pm strings
            if ((0, _fnsJs.isObject)(data.ampm)) (0, _ampmJs.set)(data.ampm);
            //change distance strings
            if ((0, _fnsJs.isObject)(data.distance)) (0, _distanceJs.set)(data.distance);
            //change units strings
            if ((0, _fnsJs.isObject)(data.units)) (0, _unitsJs.set)(data.units);
            return this;
        }
    };
    //hook them into proto
    Object.keys(methods).forEach((k)=>{
        SpaceTime.prototype[k] = methods[k];
    });
};
exports.default = addMethods;

},{"../fns.js":"dnKgs","../data/days.js":"kecYW","../data/months.js":"c9Fjq","../data/caseFormat.js":"8VoCd","../data/ampm.js":"6wyex","../data/distance.js":"laYXz","../data/units.js":"k8UqO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJzec":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _spacetimeJs = require("./spacetime.js");
var _spacetimeJsDefault = parcelHelpers.interopDefault(_spacetimeJs);
// const timezones = require('../data');
const whereIts = (a, b)=>{
    let start = new (0, _spacetimeJsDefault.default)(null);
    let end = new (0, _spacetimeJsDefault.default)(null);
    start = start.time(a);
    //if b is undefined, use as 'within one hour'
    if (b) end = end.time(b);
    else end = start.add(59, "minutes");
    let startHour = start.hour();
    let endHour = end.hour();
    let tzs = Object.keys(start.timezones).filter((tz)=>{
        if (tz.indexOf("/") === -1) return false;
        let m = new (0, _spacetimeJsDefault.default)(null, tz);
        let hour = m.hour();
        //do 'calendar-compare' not real-time-compare
        if (hour >= startHour && hour <= endHour) {
            //test minutes too, if applicable
            if (hour === startHour && m.minute() < start.minute()) return false;
            if (hour === endHour && m.minute() > end.minute()) return false;
            return true;
        }
        return false;
    });
    return tzs;
};
exports.default = whereIts;

},{"./spacetime.js":"fZpA2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qoR9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = "7.5.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NEXe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// export { find, display, version }
parcelHelpers.export(exports, "default", ()=>soft);
const BASE = 36;
const seq = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const cache = seq.split("").reduce(function(h, c, i) {
    h[c] = i;
    return h;
}, {});
// 0, 1, 2, ..., A, B, C, ..., 00, 01, ... AA, AB, AC, ..., AAA, AAB, ...
const toAlphaCode = function(n) {
    if (seq[n] !== undefined) return seq[n];
    let places = 1;
    let range = BASE;
    let s = "";
    for(; n >= range; n -= range, places++, range *= BASE);
    while(places--){
        const d = n % BASE;
        s = String.fromCharCode((d < 10 ? 48 : 55) + d) + s;
        n = (n - d) / BASE;
    }
    return s;
};
const fromAlphaCode = function(s) {
    if (cache[s] !== undefined) return cache[s];
    let n = 0;
    let places = 1;
    let range = BASE;
    let pow = 1;
    for(; places < s.length; n += range, places++, range *= BASE);
    for(let i = s.length - 1; i >= 0; i--, pow *= BASE){
        let d = s.charCodeAt(i) - 48;
        if (d > 10) d -= 7;
        n += d * pow;
    }
    return n;
};
var encoding = {
    toAlphaCode,
    fromAlphaCode
};
const symbols = function(t) {
    //... process these lines
    const reSymbol = new RegExp("([0-9A-Z]+):([0-9A-Z]+)");
    for(let i = 0; i < t.nodes.length; i++){
        const m = reSymbol.exec(t.nodes[i]);
        if (!m) {
            t.symCount = i;
            break;
        }
        t.syms[encoding.fromAlphaCode(m[1])] = encoding.fromAlphaCode(m[2]);
    }
    //remove from main node list
    t.nodes = t.nodes.slice(t.symCount, t.nodes.length);
};
var parseSymbols = symbols;
// References are either absolute (symbol) or relative (1 - based)
const indexFromRef = function(trie, ref, index) {
    const dnode = encoding.fromAlphaCode(ref);
    if (dnode < trie.symCount) return trie.syms[dnode];
    return index + dnode + 1 - trie.symCount;
};
const toArray = function(trie) {
    const all = [];
    const crawl = (index, pref)=>{
        let node = trie.nodes[index];
        if (node[0] === "!") {
            all.push(pref);
            node = node.slice(1); //ok, we tried. remove it.
        }
        const matches = node.split(/([A-Z0-9,]+)/g);
        for(let i = 0; i < matches.length; i += 2){
            const str = matches[i];
            const ref = matches[i + 1];
            if (!str) continue;
            const have = pref + str;
            //branch's end
            if (ref === "," || ref === undefined) {
                all.push(have);
                continue;
            }
            const newIndex = indexFromRef(trie, ref, index);
            crawl(newIndex, have);
        }
    };
    crawl(0, "");
    return all;
};
//PackedTrie - Trie traversal of the Trie packed-string representation.
const unpack$2 = function(str) {
    const trie = {
        nodes: str.split(";"),
        syms: [],
        symCount: 0
    };
    //process symbols, if they have them
    if (str.match(":")) parseSymbols(trie);
    return toArray(trie);
};
var traverse = unpack$2;
const unpack = function(str) {
    if (!str) return {};
    //turn the weird string into a key-value object again
    const obj = str.split("|").reduce((h, s)=>{
        const arr = s.split("\xa6");
        h[arr[0]] = arr[1];
        return h;
    }, {});
    const all = {};
    Object.keys(obj).forEach(function(cat) {
        const arr = traverse(obj[cat]);
        //special case, for botched-boolean
        if (cat === "true") cat = true;
        for(let i = 0; i < arr.length; i++){
            const k = arr[i];
            if (all.hasOwnProperty(k) === true) {
                if (Array.isArray(all[k]) === false) all[k] = [
                    all[k],
                    cat
                ];
                else all[k].push(cat);
            } else all[k] = cat;
        }
    });
    return all;
};
var unpack$1 = unpack;
// these are the folk heuristics that timezones use to set their dst change dates
// for example, the US changes:
// the second Sunday of March -> first Sunday of November
// http://www.webexhibits.org/daylightsaving/g.html
let patterns = {
    usa: "2nd-sun-mar-2h|1st-sun-nov-2h",
    // mexico
    mex: "1st-sun-apr-2h|last-sun-oct-2h",
    // European Union zone
    eu0: "last-sun-mar-0h|last-sun-oct-1h",
    eu1: "last-sun-mar-1h|last-sun-oct-2h",
    eu2: "last-sun-mar-2h|last-sun-oct-3h",
    eu3: "last-sun-mar-3h|last-sun-oct-4h",
    //greenland
    green: "last-sat-mar-22h|last-sat-oct-23h",
    // australia
    aus: "1st-sun-apr-3h|1st-sun-oct-2h",
    //lord howe australia
    lhow: "1st-sun-apr-2h|1st-sun-oct-2h",
    // new zealand
    chat: "1st-sun-apr-3h|last-sun-sep-2h",
    // new Zealand, antarctica 
    nz: "1st-sun-apr-3h|last-sun-sep-2h",
    // casey - antarctica
    ant: "2nd-sun-mar-0h|1st-sun-oct-0h",
    // troll - antarctica
    troll: "3rd-sun-mar-1h|last-sun-oct-3h",
    //jordan
    jord: "last-fri-feb-0h|last-fri-oct-1h",
    // lebanon
    leb: "last-sun-mar-0h|last-sun-oct-0h",
    // syria
    syr: "last-fri-mar-0h|last-fri-oct-0h",
    //israel
    // Start: Last Friday before April 2 -> The Sunday between Rosh Hashana and Yom Kippur
    isr: "last-fri-mar-2h|last-sun-oct-2h",
    //palestine
    pal: "last-sun-mar-0h|last-fri-oct-1h",
    // el aaiun
    //this one seems to be on arabic calendar?
    saha: "last-sun-mar-3h|1st-sun-may-2h",
    // paraguay
    par: "last-sun-mar-0h|1st-sun-oct-0h",
    //cuba
    cuba: "2nd-sun-mar-0h|1st-sun-nov-1h",
    //chile
    chile: "1st-sun-apr-0h|1st-sun-sep-0h",
    //easter island
    east: "1st-sat-apr-22h|1st-sat-sep-22h",
    //fiji
    fiji: "3rd-sun-jan-3h|2nd-sun-nov-2h"
};
var dstPatterns = patterns;
var pcked = {
    "Africa": {
        "Abidjan": [
            "true\xa6a5bouake,coordinated universal4daloa,g1san ped0utc,yamoussouk0zulu;ro;h0mt,reenwich mean2;!a0;!na; ti3;b4frica0tlantic/st_helena;!/0;accra,ba1conakry,dakar,freetown,lo0nouakchott,ouagadougou,timbuktu;me;mako,njul;idjan,obo",
            "Greenwich Mean",
            "n"
        ],
        "Algiers": [
            "true\xa6a8b6c3dz2or5s1t0;ebessa,iaret;etif,idi bel abbes;!a;e0hlef,onstantine;ntral europe0t;an;a0iskra,lida,oumerdas;b ezzouar,tna;frica,lg0nnaba;eria,iers",
            "Central European",
            "n"
        ],
        "Bissau": [
            "true\xa6africa,b2coordinated universal1g0utc,zulu;mt,nb,reenwich mean0uinea b1w; time;issau",
            "Greenwich Mean",
            "n"
        ],
        "Cairo": [
            "true\xa6a6bani suwayf,c5damanhur,e2giza,halw8i1kafr ad dawwar,luxor,new c5port said,qina,s0tanta,zagazig;hibin al kawm,ohag,uez;dku,smail8;astern europe5et,g0;!y0;!pt;airo;frica,l2s0;w0yut;an; 1exandr0;ia;fayyum,m0;a0inya;hallah al kubra,nsurah",
            "Eastern European",
            "n"
        ],
        "Casablanca": [
            "true\xa6aCcasablanDfBkenitAm6oujda angad,rabat,sa4t1we0;stern europe2t;angier,e0;ma7tou0;an;fi,le0;! al jadida;a1ekn4o0;hammedia,rocco;!r0;!rakesh;ra;es;fri0gadir,l hoceima;ca",
            "Morocco Standard",
            "n",
            "saha"
        ],
        "Ceuta": [
            "true\xa6africa,brussels,c0europe central,madrid,paris,romance;e0openhagen;ntral european,t,uta0;!melilla",
            "Central European",
            "n",
            "eu2"
        ],
        "El_Aaiun": [
            "true\xa6afri3casablan3e2laayoune,morocco,we0;stern 0t;european,sahara;h,l_aaiun,sh;ca",
            "Morocco Standard",
            "n",
            "saha"
        ],
        "Johannesburg": [
            "true\xa6africaIbEcAd9east londBharare,johannesHk7newcastDp6r5s3tembisa,uitenhage,v2w1za0;!f;elkom,itbank;anderbijlpark,ereeniging;ast,o0prings;uth africa,weto;andBichards bay,oodepoort;aarl,ietermaritzAort elizabeth,retoria;lerk0ruger0;sdorp;iepsloot,urb5;a1enturi0;on;pe town,rletonvil0;le;enoni,loemfontein,o1rakp0;an;ks0tshabelo;burg;! southern,/m0;aseru,babane",
            "South Africa",
            "s"
        ],
        "Juba": [
            "true\xa6a3c2juba,s0winejok;outh sudan,s0;!d;at,entral a0;frica",
            "Central Africa",
            "n"
        ],
        "Khartoum": [
            "true\xa6a7c6el 5k3ny4omdurm2port sud2s0wad medani;d0inga,ud1;!n;an;ass0hartoum,osti;ala;dae3fasher,obeid;at,entral af1;d damaz1f0l qadarif;rica;in",
            "Central Africa",
            "n"
        ],
        "Lagos": [
            "true\xa6aVbTcReQgPiLjKkaIlGmDnnewi,oAport harcourt,s9u7w0zar8; c3a2est0; 0ern3;a3c1;rBst,t;entral0; a0;frica;gep,muah0yo;ia;a7hagamu,okoto;kDn1w0yo;er3o;do,itsha;a0in5ubi;idugu0kurdi;ri;agos,ek0;ki;du0no,tsi0;na;imeLos;badan,jebu ode,k1l0seHwo;a orangun,eDor7;eHi8ot ekp0;ene;ombe,usau;bute ikorodu,fon alaaye,nugu;alabar,d,hakwama,o0;d,ngo;auchi,en0;in;b8do7frica1ku0tani;re;! western,/0;b2douala,kinsha1l0malabo,niamey,porto-novo;ibre2uanda;sa;angui,razza0;ville; ekiti;a,eoku1u0;ja;ta",
            "West Africa",
            "n"
        ],
        "Maputo": [
            "true\xa6africa7beiCc6ma4na2quelimaAwindhoek,z0;imbabwe,w0;!e;ca2m0;ibia,pu1;puto,to0;la;at,entral africa,himoio;! central,/0;b2gaboro1hara4kigali,lu0;bumbashi,saka;ne;lanty1ujumbu0;ra;re",
            "Central Africa",
            "s"
        ],
        "Monrovia": [
            "true\xa6africa,coordinated universal3g2l0monrov1utc,zulu;br,iber0r;ia;mt,reenwich mean0; time",
            "Greenwich Mean",
            "n"
        ],
        "Nairobi": [
            "true\xa6africa8e4indian/2kisumu,m1na0thika,yt;irobi,kuru;a1ombasa,yt;antananarivo,comoro,ma0;yotte; 2a0ldoret;st0t; 0ern 0;africa;! eastern,/0;a1d0kampala,mogadishu;ar_es_salaam,jibouti;ddis_ababa,sm0;a0e0;ra",
            "East Africa",
            "n"
        ],
        "Ndjamena": [
            "true\xa6africaAchad,n8t7w0; c3a2est0; 0ern3;a3c1;st,t;entral0; a0;frica;cd,d;'d0d0;jamena;! western",
            "West Africa",
            "n"
        ],
        "Sao_Tome": [
            "true\xa6africa,coordinated universal5g4s0utc,zulu;ao1t0;!p; 0_0;to2;mt,reenwich mean0; ti0;me",
            "Greenwich Mean",
            "n"
        ],
        "Tripoli": [
            "true\xa6a4benghazi,e3l1misrat5t0zawi2;arhuna,ripoli;by,ib0y;ya;astern european,et;frica,l khums,z zawiy0;ah",
            "Eastern European",
            "n"
        ],
        "Tunis": [
            "true\xa6africa,ce3sfax,t0;n,un0;!is0;!ia;ntral european,t",
            "Central European",
            "n"
        ],
        "Windhoek": [
            "true\xa6africa3c2na0windhoek;!m0;!ibia;at,entral africa;! central",
            "Central Africa",
            "s"
        ]
    },
    "America": {
        "Adak": [
            "true\xa6a1h0nwt,us/aleutian;awaii s3dt,st;dak,leutian0merica/atka;! 0;islands,s0;tandard time",
            "Aleutian Standard",
            "n",
            "usa"
        ],
        "Anchorage": [
            "true\xa6a0us/alaska;h6k5laska0merica,nchorage;! 1n0;! s1;s0t1;tandard t0;ime;dt,st,t;dt,st",
            "Alaska",
            "n",
            "usa"
        ],
        "Araguaina": [
            "true\xa6araguaina,br1e0palmas,tocantins; south america s4ast south america;a0t;silia0zil;! 0;s0t1;tandard t0;ime",
            "Brasilia",
            "n"
        ],
        "Argentina/Buenos_Aires": [
            "true\xa6a0buenos 4;merica/2r0;!g0;!e2;arge1buenos_0;aires;ntina",
            "Argentina",
            "s"
        ],
        "Argentina/Catamarca": [
            "true\xa6a0c2;merica/0rgentina;argentina/comodrivadavia,c0;atamarca",
            "Argentina",
            "s"
        ],
        "Argentina/Cordoba": [
            "true\xa6a0c2;merica/0rgentina;c0rosario;ordoba",
            "Argentina",
            "s"
        ],
        "Argentina/Jujuy": [
            "true\xa6a0j1;merica/j0rgentina;ujuy",
            "Argentina",
            "s"
        ],
        "Argentina/La_Rioja": [
            "true\xa6ar1b0city of b0la rioja;uenos aires;gentina0st,t;! 0;standard t0t0;ime",
            "Argentina",
            "s"
        ],
        "Argentina/Mendoza": [
            "true\xa6a0m1;merica/m0rgentina;endoza",
            "Argentina",
            "s"
        ],
        "Argentina/Rio_Gallegos": [
            "true\xa6ar1b0city of b0rio_gallegos;uenos aires;gentina0st,t;! 0;standard t0t0;ime",
            "Argentina",
            "s"
        ],
        "Argentina/Salta": [
            "true\xa6ar1b0city of b0salta;uenos aires;gentina0st,t;! 0;standard t0t0;ime",
            "Argentina",
            "s"
        ],
        "Argentina/San_Juan": [
            "true\xa6ar1b0city of b0san juan;uenos aires;gentina0st,t;! time",
            "Argentina",
            "s"
        ],
        "Argentina/San_Luis": [
            "true\xa6ar1b0city of b0san luis;uenos aires;gentina0st,t;! time",
            "Argentina",
            "s"
        ],
        "Argentina/Tucuman": [
            "true\xa6ar1b0city of b0tucuman;uenos aires;gentina0st,t;! time",
            "Argentina",
            "s"
        ],
        "Argentina/Ushuaia": [
            "true\xa6ar1b0city of b0ushuaia;uenos aires;gentina0st,t;! time",
            "Argentina",
            "s"
        ],
        "Asuncion": [
            "true\xa6asuncion,c3p0san lorenzo;araguay1ry,y0;!st,t;! time;apiata,iudad del este",
            "Paraguay",
            "s",
            "par"
        ],
        "Bahia": [
            "true\xa6b2camacari,e1feira de santa0itabu0salvador,vitoria da conquista;na; south america s5ast south america;ahia,r0;a0t;silia0zil;! 0;s0t1;tandard t0;ime",
            "Brasilia",
            "n"
        ],
        "Bahia_Banderas": [
            "true\xa6bah7c2guadalajara,m0;exico0onterrey;! city;entral 0st;mexic0standard 2;an,o0;! 0;time;ia_0\xeda de 0;banderas",
            "Central Mexico",
            "n",
            "mex"
        ],
        "Barbados": [
            "true\xa6a1b0;arbados,b,rb;st,tlantic standard time",
            "Atlantic",
            "n"
        ],
        "Belem": [
            "true\xa6ananindeua,b2e1macapa,par0;auapebas,\xe1 east amap\xe1; south america s5ast south america;elem,r0;a0t;silia0zil;! 0;s0t1;tandard t0;ime",
            "Brasilia",
            "n"
        ],
        "Belize": [
            "true\xa6b1c0;entral standard time,st;elize,lz,z",
            "Central",
            "n"
        ],
        "Boa_Vista": [
            "true\xa6am3boa vista,c0roraima;entral brazil0uiaba;!ian0;! s3;azon0t;! 0;s0t1;tandard t0;ime",
            "Amazon",
            "n"
        ],
        "Bogota": [
            "true\xa6armenGbBc7dosquebradas,floridablanca,i6m5neiva,p3s1v0;alledupar,illavicencio;anta marCincelejo,o0;acha,ledad;a0erei9opayan;lmi8sto;anizales,edellin,onterA;bague,taguei;a2o0ucu6;!l0st,t;!omb6;li,rtagena;arran3ello,ogo2u0;caramanga,enaventu0;ra;ta;cabermeja,quilla;ia",
            "Colombia",
            "n"
        ],
        "Boise": [
            "true\xa6america4boise,idaho,m0;ountain0pt,st,t;! 0;id,standard t0t0;ime;! mountain",
            "Mountain",
            "n",
            "usa"
        ],
        "Cambridge_Bay": [
            "true\xa6america4cambridge bay,m0;ddt,ountain0st,t;! 0;standard t0t0;ime;! mountain",
            "Mountain",
            "n",
            "usa"
        ],
        "Campo_Grande": [
            "true\xa6am0brazil,campo grande,mato grosso do sul;azon standard time,t",
            "Amazon",
            "s"
        ],
        "Cancun": [
            "true\xa6cancun,e0mexico,quintana roo;astern standard time,st",
            "Eastern",
            "n"
        ],
        "Caracas": [
            "true\xa6alto barinKbarJcDguaBm8p7san6turmeFv0;alencia,e0;!n0t;!ezuela0;! 0n;standard t0t0;ime; cristobal,ta teresa del tuy;eta4uerto la cruz;a0ucumpiz;raca0turin;ibo,y;ren8ti0;re;a4iudad 2o1u0;a,m2;ro;bolivar,guay0;ana;bim1rac1;in0quisimeto,uta;as",
            "Venezuela",
            "n"
        ],
        "Cayenne": [
            "true\xa6cayenne,french guiana3g0;f1u0;f,iana;!t;! time",
            "French Guiana",
            "n"
        ],
        "Chicago": [
            "true\xa6aWbTcRdQfort worth,gPhOiMk00lJmCn8o7plano,s4t2us1wi0;chiGsconsW;/02a;ex0ulsa;!as;a0hreveport,ou4t 1;int 0n antonio;louGpaul;klahoXmaha,verland park;ashLe1or0;th dako7;braska,w 0;orleans,south me6;adisMe5i1o0;biHntgomery;lwaukee,nne1ss0;issippi,ouri;apol6so0;ta;mph4;aredo,i0ouisiana,ubb1;ncoln,ttle r0;ock;llino0owa,rving;is;oustAunts5;arland,rand prairie;allAes moines;dt,entral0hicago,orpus christi,st,t;! time;aton rouge,rowns0;vil0;le;laba8m5r1ust0;in;k1lingt0;on;ans0;as;arillo,erica0;! 0;central;ma",
            "Central",
            "n",
            "usa"
        ],
        "Chihuahua": [
            "true\xa6chihuahua,h5la paz,m0;azatlan,exic1ountain 0;mexico,standard time (mexico);an pacific1o0;! pacific;! time;ep0np0p0;mx",
            "Mexican Pacific",
            "n",
            "mex"
        ],
        "Costa_Rica": [
            "true\xa6c0sjmt;entral standard time,osta rica,r0st;!i",
            "Central",
            "n"
        ],
        "Cuiaba": [
            "true\xa6am0brazil,cuiaba,mato grosso,varzea grande;azon standard time,t",
            "Amazon",
            "s"
        ],
        "Danmarkshavn": [
            "true\xa6coordinated universal2d1g0utc,zulu;mt,reenwich mean1;anmarkshavn,enmark; time",
            "Greenwich Mean",
            "n"
        ],
        "Dawson": [
            "true\xa6canada,dawson,m2y0;d0pt,wt;dt,t;ountain standard time,st",
            "Mountain",
            "n"
        ],
        "Dawson_Creek": [
            "true\xa6canada,dawson creek,m1p0;pt,wt;ountain standard time,st,t",
            "Mountain",
            "n"
        ],
        "Denver": [
            "true\xa6a5colorado springs,denver,el paso,m1navajo,salt lake,us0;/6a;dt,ountain0st,t;! 0;standard t0t0;ime;lbuquerque,merica0urora;! 0/shiprock;mountain",
            "Mountain",
            "n",
            "usa"
        ],
        "Detroit": [
            "true\xa6america4detroit,e0grand rapids,us/michigan;astern0pt,st,t,wt;! 0;mi,standard t0t0;ime;! eastern",
            "Eastern",
            "n",
            "usa"
        ],
        "Edmonton": [
            "true\xa6a6ca4edmonton,m0;ountain0st,t;! 0;standard t0t0;ime;lgary,nada0;!/1;lberta,merica 0;mountain",
            "Mountain",
            "n",
            "usa"
        ],
        "Eirunepe": [
            "true\xa6a0brazil,eirunepe;c0mazonas west;re0t;! 0;standard t0t0;ime",
            "Acre",
            "n"
        ],
        "El_Salvador": [
            "true\xa6c2el1s0;an0lv,oyapango,v; salvador;entral standard time,st",
            "Central",
            "n"
        ],
        "Fort_Nelson": [
            "true\xa6british columbia,canada,fort nelson,m0;ountain standard time,st,t",
            "Mountain",
            "n"
        ],
        "Fortaleza": [
            "true\xa6br5ca4e3fortaleza,imperatriz,j2m0natal,sao luis,teresina;a0ossoro;picernpb,racanau;oao pessoa,uazeiro do norte; south america s5ast south america;mpina grande,ucaia;a0t;silia0zil;! 0;s0t1;tandard t0;ime",
            "Brasilia",
            "s"
        ],
        "Glace_Bay": [
            "true\xa6a1ca0glace_bay;nada,pe breton;st,t0;!lantic0;! 0;standard t0t0;ime",
            "Atlantic",
            "n",
            "usa"
        ],
        "Goose_Bay": [
            "true\xa6a0canada,goose_bay,labrador,npt;st,t0;!lantic0;! 0;standard t0t0;ime",
            "Atlantic",
            "n",
            "usa"
        ],
        "Grand_Turk": [
            "true\xa6america eastern,e2grand turk,kmt,t0;c0urks and caicos;!a;astern0st,t;! 0;standard t0t0;ime",
            "Eastern",
            "n",
            "usa"
        ],
        "Guatemala": [
            "true\xa6c2g0mixco,villa nueva;t0uatemala;!m;entral standard time,st",
            "Central",
            "n"
        ],
        "Guayaquil": [
            "true\xa6cuenca,ec2guayaquil,ma1q0santo domingo de los colorados;mt,uito;chala,nta;!t,u0;!ador0;! 0;mainland,time",
            "Ecuador",
            "n"
        ],
        "Guyana": [
            "true\xa6g0;eorgetown,uy1y0;!t;!ana0;! time",
            "Guyana",
            "n"
        ],
        "Halifax": [
            "true\xa6a4ca2halifax,n1p0;ei,rince edward island;ew brunswick,ova scotia;!nada0;!/atlantic;dt,st,t0;!lantic0;! 0;ns,standard t0t0;ime",
            "Atlantic",
            "n",
            "usa"
        ],
        "Havana": [
            "true\xa6arroyo naranjo,bBc3diez de octubre,guantanDh1las tunas,pinar del rio,sant0;a clara,iago de cuba;avana,cu,e0n0olguin;cu;amaguey,i5u0;!b0;!a0;! 0;standard t0t0;ime;e0udad camilo cie0;nfueg1;ay1oyer0;os;amo",
            "Cuba",
            "n",
            "cuba"
        ],
        "Hermosillo": [
            "true\xa6ciudad obregon,h1mexic0nogales,sonora;an pacific standard time,o;ermosillo,npmx",
            "Mexican Pacific",
            "n"
        ],
        "Indiana/Indianapolis": [
            "true\xa6america2crawford,dadukmn,eastern in,i4p0star1us/east-indiana;erry,i0ulaski;ke;!/0;fort_wayne,i0;ndiana0;!polis",
            "Eastern",
            "n",
            "usa"
        ],
        "Indiana/Knox": [
            "true\xa6america1c0indiana,knox,us/indiana-starke;entral standard time,st;!/knox_in",
            "Central",
            "n",
            "usa"
        ],
        "Indiana/Marengo": [
            "true\xa6america,e0indiana,marengo;astern standard time,st",
            "Eastern",
            "n",
            "usa"
        ],
        "Indiana/Petersburg": [
            "true\xa6america,e0indiana,petersburg;astern standard time,st",
            "Eastern",
            "n",
            "usa"
        ],
        "Indiana/Tell_City": [
            "true\xa6america,c0indiana,tell_city;entral standard time,st",
            "Central",
            "n",
            "usa"
        ],
        "Indiana/Vevay": [
            "true\xa6america,e0indiana,vevay;astern standard time,st",
            "Eastern",
            "n",
            "usa"
        ],
        "Indiana/Vincennes": [
            "true\xa6america,e0indiana,vincennes;astern standard time,st",
            "Eastern",
            "n",
            "usa"
        ],
        "Indiana/Winamac": [
            "true\xa6america,e0indiana,winamac;astern standard time,st",
            "Eastern",
            "n",
            "usa"
        ],
        "Inuvik": [
            "true\xa6america mountain,canada,inuvik,m0pddt;ountain0st,t;! 0;standard t0t0;ime",
            "Mountain",
            "n",
            "usa"
        ],
        "Iqaluit": [
            "true\xa6america eastern,canada,e0iqaluit;astern0ddt,st,t;! 0;standard t0t0;ime",
            "Eastern",
            "n",
            "usa"
        ],
        "Jamaica": [
            "true\xa6e3j1k0new k0;ingston;am0m;!aica;astern standard time,st",
            "Eastern",
            "n"
        ],
        "Juneau": [
            "true\xa6a0juneau;k5laska0merica;! 1n0;! s1;juneau area,s0t1;tandard t0;ime;st,t",
            "Alaska",
            "n",
            "usa"
        ],
        "Kentucky/Louisville": [
            "true\xa6america0eastern 4k3l2wayne;!/0;k1l0;ouisville;entuc0;ky",
            "Eastern",
            "n",
            "usa"
        ],
        "Kentucky/Monticello": [
            "true\xa6america,e0kentucky,monticello;astern standard time,st",
            "Eastern",
            "n",
            "usa"
        ],
        "La_Paz": [
            "true\xa6bo1cochabamba,la paz,oruro,s0;anta cruz de la sierra,ucre;!l0t;!ivia0;! time",
            "Bolivia",
            "s"
        ],
        "Lima": [
            "true\xa6arequiDc9huancCi8juliaca,lima,p2sant1t0;acna,rujillo;a anita   los ficus,iago de sur8;e0iura,ucallA;!r0t;!u0;! 0;standard t0t0;ime;ca,quitos;allao,hi1us0;co;cl0mbote;ayo;pa",
            "Peru",
            "s"
        ],
        "Los_Angeles": [
            "true\xa6a05ba03c00fWgarden grove,hTirviSlMmoJnIoFp9r8s1tacoma,us0washington state;/06a;a1eattle,f,p0tocktTunrise manor;okaPringH;cramenHn0; 1ta 0;aTclariV;bernardiRdiego,fran0jo4;!cisco;ancho cucamonga,ePiver7;a0dt,ort7st,t;cific1radi0;se;! 0;standard t0t0;ime;ak1cean0regFxnard;side;land;evada,orth las8;des1reno0; valley;to;a3o0;ng6s0; 0_0;angeles;!s0; vegas;ne;enders1untington0; beach;on;onta2re0;mont,s0;no;na;ali1hula vis0;ta;!f1;ja calif0kersfield;ornia;merica0naheim;! 0;pacific",
            "Pacific",
            "n",
            "usa"
        ],
        "Maceio": [
            "true\xa6a6br1e0maceio; south america s3ast south america;asilia0t;! 0;s0t1;tandard t0;ime;lagoassergipe,racaju",
            "Brasilia",
            "n"
        ],
        "Managua": [
            "true\xa6c3man2ni0;!c0;!ar0;agua;entral standard time,st",
            "Central",
            "n"
        ],
        "Manaus": [
            "true\xa6am4brazil3c0manaus;entral brazil0uiaba;!ian0;! s5;!/we2;azon0t;! 1as ea0;st;s0t1;tandard t0;ime",
            "Amazon",
            "s"
        ],
        "Martinique": [
            "true\xa6a3f1m0;a1q,tq;fmt,ort de france,rench ma0;rtinique;st,tlantic standard time",
            "Atlantic",
            "n"
        ],
        "Matamoros": [
            "true\xa6america central,c2heroica ma1m0nuevo laredo,reynosa;a0exico;tamoros;entral0st,t;! 0;standard t0t0;ime",
            "Central",
            "n",
            "usa"
        ],
        "Mazatlan": [
            "true\xa6cAh8l7m0tep4;azatlAexic1ountain 0;mexico,standard time (mexico);an pacific 2o0;! pacif0/bajasur;ic;standard t0t0;ime;a paz,os mochis;np0p0;mx;hihuahua,uliac0;an",
            "Mexican Pacific",
            "n",
            "mex"
        ],
        "Menominee": [
            "true\xa6america4c0menominee,wisconsin;entral0st,t;! 0;standard t0t0;ime;! central",
            "Central",
            "n",
            "usa"
        ],
        "Merida": [
            "true\xa6c3guadalajara,m0;e0onterrey;rida,xico0;! city;ampeche4entral 0st;mexic0standard 2;an,o0;! 0;time;!yucat\xe1n",
            "Central Mexico",
            "n",
            "mex"
        ],
        "Metlakatla": [
            "true\xa6a0metlakatla;k5laska0merica;! 1n0;! s1;annette island,s0t1;tandard t0;ime;st,t",
            "Alaska",
            "n",
            "usa"
        ],
        "Mexico_City": [
            "true\xa6a0Lb0JcYduran0Cecatepec de morel0AguThSiQjalis0Nleon de los alda06mInHoGpEqDs9t4uruap04v2x1yucat04za0;catec0Cpop03;alapa de enriqu0Pi0Lochimil0L;e0illahermosa;nustiano carranza,racruz;a3e7la1o0uxt03;luUna02;huac,l0quepaque,xca01;nepant00pW;bas0Emaulip04pachuZ;an0oledad de graciano sanch0H; luis potosi,t0;a maria chimal0iago de q1;huQ;ueretaG;achuca de soIoza rica de7ue0;bSrto vallar04;axaJjo de agua;aucalpan07icolas romeCuevo le06;agdalena contrerUex4i2o0x;nterrey,rel0;ia,os;choHguel0; h5;!ico0;! 0/general,_0;city;rap5xtapalu9zta0;cUpalapa;idalJ;a1erre0stavo adolfo made0;ro;dalajara,naj0;ua0;to;ampeche,eFhiCiudad Ao3st,u0wt;au1ernava0;ca;htemoc,titlan izcalli;a4l2yo0;ac0;an;i0onia del valle;ma;cEhui0tzacoalc2;la;lopez mate0nezahualcoyotl;os;ap1lpancin0;go;as;laya,ntral 0;mexic0standard 2;an,o0;! 0;time;enito6uenavis0;ta;capulco3guascalientes,lvaro obreg2zcapotz0;al0;co;on; de0; juar0;ez",
            "Central Mexico",
            "n",
            "mex"
        ],
        "Miquelon": [
            "true\xa6hBmAp8s0;aint pierre2pm,t pierre 0;& miquelon 0a5;s2t3;! 0;a2s0;tandard t0;ime;nd1;ierre0m; m0;iquelon;npm,pm",
            "St. Pierre & Miquelon",
            "n",
            "usa"
        ],
        "Moncton": [
            "true\xa6a0canada,hepm,moncton,new brunswick;st,t0;!lantic0;! 0;standard t0t0;ime",
            "Atlantic",
            "n",
            "usa"
        ],
        "Monterrey": [
            "true\xa6c8g6m3sa1t0victoria de durango;ampico,orreon;ltillo,n0; nicolas de los garza,ta catarina;exico1on0;clova,terrey;! city;omez palacio,uadal0;ajara,upe;entral 1iudad 0st;apodaca,general escobedo,madero,victoria;mexic0standard 2;an,o0;! 0;time",
            "Central Mexico",
            "n",
            "mex"
        ],
        "Montevideo": [
            "true\xa6montevideo5u0;r1y0;!st,t;uguay0y;! 0;s1t2;! s0;tandard t0;ime",
            "Uruguay",
            "s"
        ],
        "New_York": [
            "true\xa6a0Rb0Oc0Hd0Ge0Bf07g05hialeah,i02j00kZlexingtonYmUnMoKpIquHrDsAt7u5v3w0yonkers;ashington1est 0inston salem,orcD;raEvirgin04;! dc;ermont,irginia0;! beach;nited states,s0;!/0Ma;a0enne1he bronx,oleD;llaha0mpa;ssee;outh 1t0; petersburg,aten3;bo0CcC;a2hode1ichmo06och0;ester; is03;lei2;eens,intana roo;ennsylvanNhiladelphNittsbur0rovidence;gh;hio,rlan0;do;ew3or1y0;!c;folk,th c0;aroliE; 1_yo0a0port news;rk;hampshiXje8york0;! staT;a1eads,i0;ami,chig1;ine,nhatt0ryMssachusetts;an;! fayetO;entucky,nox9;acks2e0;rsey;ndia1r0;on5;na;eorg0reensboro;ia;ayette1l0ort lauderda2;!orida;vil0;le;ast0dt,st,t; flatbush,ern0;! 0;standard t0t0;ime;elawa9urham;ape coral,h3incinnati,leve1o0;lumbus,nnecticut;la0;nd;a0esapeake;rlot0ttanooga;te;altimo1o0rooklyn,uffalo;st4;re;kr2merica0tlanta;! 0;eastern;on",
            "Eastern",
            "n",
            "usa"
        ],
        "Nipigon": [
            "true\xa6america eastern,canada,e0nipigon;astern0st,t;! 0;standard t0t0;ime",
            "Eastern",
            "n",
            "usa"
        ],
        "Nome": [
            "true\xa6a0no5;k5laska0merica;! 1n0;! s1;s0ti1west;tandard ti0;me;st,t",
            "Alaska",
            "n",
            "usa"
        ],
        "Noronha": [
            "true\xa6atlantic islands,brazil3f0n4;ernando de noronha 0nt;standard t0t0;ime;!/den0;oronha",
            "Fernando de Noronha",
            "n"
        ],
        "North_Dakota/Beulah": [
            "true\xa6america,beulah,c0north dakota;entral standard time,st",
            "Central",
            "n",
            "usa"
        ],
        "North_Dakota/Center": [
            "true\xa6america,c1merc0north dakota,oliv0;er;ent0st;er,ral standard time",
            "Central",
            "n",
            "usa"
        ],
        "North_Dakota/New_Salem": [
            "true\xa6america,c1n0;ew_salem,orth dakota;entral standard time,st",
            "Central",
            "n",
            "usa"
        ],
        "Nuuk": [
            "true\xa6america3g1nuuk,wg0;st,t;l,r0;eenland,l;!/godthab",
            "West Greenland",
            "n",
            "green"
        ],
        "Ojinaga": [
            "true\xa6america5c4m0ojinaga;ountain0st,t;! 0;standard t0t0;ime;hihuahua,iudad juarez;! mountain",
            "Mountain",
            "n",
            "usa"
        ],
        "Panama": [
            "true\xa6a3coral h,e2pa0san miguelito;!n0;!ama;astern standard time,st;merica/0t2;at1c0;aym1oral_harbour;ikok0;an",
            "Eastern",
            "n"
        ],
        "Pangnirtung": [
            "true\xa6a4baffin island,canada,e0nunavit,pangnirtung;astern0st,t;! 0;standard t0t0;ime;ddt,merica eastern",
            "Eastern",
            "n",
            "usa"
        ],
        "Paramaribo": [
            "true\xa6paramaribo,s0;r2ur0;!iname0;! time;!t",
            "Suriname",
            "n"
        ],
        "Phoenix": [
            "true\xa6aAc8g6idaho,m4n3phoenix,s2t1u0wyoming;s/arAtah;empe,ucsC;cottsd4inaloa,onora;ayarit,ew mexico;aryv2esa,o0st,t,wt;nta6untain standard time;ilbert,lend0;ale;h0olorado;andler,ihuahua;merica2r0;izo0;na;!/crest0;on",
            "Mountain",
            "n"
        ],
        "Port-au-Prince": [
            "true\xa6america eastern,cAe6h4p0;etionville,ort0; 0-au-1;au 0de paix;prince;aiti,t0;!i;astern0st,t;! 0;standard t0t0;ime;arrefour,roix des bouquets",
            "Eastern",
            "n",
            "usa"
        ],
        "Porto_Velho": [
            "true\xa6am5brazil,c2porto0rond\xf4nia; 0_0;velho;entral brazil0uiaba;!ian0;! s3;azon0t;! 0;s0t1;tandard t0;ime",
            "Amazon",
            "n"
        ],
        "Puerto_Rico": [
            "true\xa6a2bayam9p0;r0uerto rico;!i;merica0st,tlantic standard time;!/0;a5blanc-sabl4curacao,dominica,g3kralendijk,lower_princes,m2port_of_spa1st_0torto7virg1;barthelemy,kitts,lucia,thomas,vincent;in;arigot,ontserrat;renada,uadeloupe;on;n0ruba;guil0tigua;la",
            "Atlantic",
            "n"
        ],
        "Punta_Arenas": [
            "true\xa6c0punta arenas,region of magallanes;hile0lt;! standard time",
            "Chile",
            "s"
        ],
        "Rainy_River": [
            "true\xa6america4c0ft frances,rainy river;entral0st,t;! 0;standard t0t0;ime;! central",
            "Central",
            "n",
            "usa"
        ],
        "Rankin_Inlet": [
            "true\xa6america4c0rankin inlet;ddt,entral0st,t;! 0;standard t0t0;ime;! central",
            "Central",
            "n",
            "usa"
        ],
        "Recife": [
            "true\xa6aAbr4caruaru,e3jaboatao2olinda,p0;aulista,e0;rnambuco,trolina;! dos guararapes; south america s4ast south a6;a0t;silia0zil;! 0;s0t1;tandard t0;ime;merica",
            "Brasilia",
            "n"
        ],
        "Regina": [
            "true\xa6c2regina,s0;askat0k;c2oon;anada0entral standard time,st;!/saskatc0;hewan",
            "Central",
            "n"
        ],
        "Resolute": [
            "true\xa6america4c0resolute;entral0st,t;! 0;standard t0t0;ime;! central",
            "Central",
            "n",
            "usa"
        ],
        "Rio_Branco": [
            "true\xa6a1brazil0rio branco;!/1;c1merica/porto_0;acre;re0t;! 0;standard t0t0;ime",
            "Acre",
            "s"
        ],
        "Santarem": [
            "true\xa6br1e0par\xe1 west,santarem; south america s4ast south america;a0t;silia0zil;! 0;s0t1;tandard t0;ime",
            "Brasilia",
            "n"
        ],
        "Santiago": [
            "true\xa6aAc4iquique,la pintana,puente alto,rancagua,san3t1v0;alparaiso,ina del mar;alca0emuco;!huano; bernardo,tiago;h1l0oncepcion;!st,t;ile0l;! 0/continental;standard t0t0;ime;ntofagasta,rica",
            "Chile",
            "s",
            "chile"
        ],
        "Santo_Domingo": [
            "true\xa6a8bella vista,do6la romana,s0;an0dmt; pedro de macoris,t0;iago de los caballeros,o domingo0;! 0;e0oe0;ste;!m0;!inican republic;st,tlantic standard time",
            "Atlantic",
            "n"
        ],
        "Sao_Paulo": [
            "true\xa6a16b0Tc0Md0Je0Hf0Fg0Ahortol09i05j02l01mXnVosasco,pLriFs4ta3uber2v0;i0olta redon1A;amao,la velha,tor16;a0Ml06;boao da ser00uba10;a2e1oroNu0;maLzano;rXte lago0L;nt4o 0;bernardo do campo,carl03jo0leopolLpaulo,vicE;ao de meriti,se0;! do0; rio p8s camp00;a 1o0; andDs;barbara d'oes0Pluz0Tmar0T;beirao 3o0;! 0;cla0de janei0g6ver7;ro;das nev07p0;reto;asso fun8e7iraci6lanalti0Oo4r0;aia g1esidente prud0;en0G;ran0;de;nta grossa,rto aleg0;re;caW;lotYtro0F;do;iteroi,ov0;aJo hamburgo;a1o0;gi das cruzSntes clarD;ri0ua;l07n6;imei2ondri08;acarei,oinville,u0;iz de fo0ndi9;ra;ndaia2patin1ta0;bor6pevi,quaquece1;ga;tuG;andY;o3ravat2uaru0;ja,lh0;os;ai;iSvernador valadarC;loria5oz do0ran2; iguacu; south america sHast south ameri0mbu;ca;i0uque de caxi8;adema,vi0;noN;a1o0uriti2;ntagem,tK;choeiro de itapemirDmp1no3rapicui0scavel,xias do sul;ba;in1os dos goytacaz0;es;as;aBe7lumenau,r0;!a0st,t;!silia1zil0;!/east;! 0;s0t1;tandard t0;ime;l1t0;im;ford roxo,o horizon0;te;rueri,uru;lvora4merica3na2parecida de goi0;an0;ia;polis;na;da",
            "Brasilia",
            "s"
        ],
        "Scoresbysund": [
            "true\xa6e3greenland2h0ittoqqortoormiit,scoresbysund;e0neg;eg,g;! eastern;ast greenland1g0;st,t;! 0;standard t0t0;ime",
            "East Greenland",
            "n",
            "eu0"
        ],
        "Sitka": [
            "true\xa6a0sitka;k6laska0merica;! 1n0;! st2;s0t2;itka area,t0;andard t0;ime;st,t",
            "Alaska",
            "n",
            "usa"
        ],
        "St_Johns": [
            "true\xa6canada7h5n0st johns;d3ewfoundland0st,t;! 0;labrador,standard t0t0;ime;dt,t;e0n0tn;tn;!/newfoundland",
            "Newfoundland",
            "n",
            "usa"
        ],
        "Swift_Current": [
            "true\xa6c1s0;askatchewan,wift current;anada,entral standard time,st",
            "Central",
            "n"
        ],
        "Tegucigalpa": [
            "true\xa6c2h0san pedro sula,tegucigalpa;n0onduras;!d;entral standard time,st",
            "Central",
            "n"
        ],
        "Thule": [
            "true\xa6a0pituffik,thule;st,t0;!lantic0;! 0;standard t0t0;ime",
            "Atlantic",
            "n",
            "usa"
        ],
        "Thunder_Bay": [
            "true\xa6canada,e0thunder bay;astern0st,t;! time",
            "Eastern",
            "n",
            "usa"
        ],
        "Tijuana": [
            "true\xa6america8baja california,eAh6mexic4p0tijuana;acific0st,t;! 0;standard t0t0;ime;ali,o0;!/bajanorte;e0n0;nomx; pacific,/0;e0santa_isabel;nsenada",
            "Pacific",
            "n",
            "usa"
        ],
        "Toronto": [
            "true\xa6americaGbEcaBe7gatineIhamilFkitchener,l4m3nepe2o0quebec,richmond hill,toronto,vaugh2windsor;n5sh0tt0;awa;an;arkham,ississauga,oF;avFon0;don on0gueuil;tario;astern0st,t;! 0;standard t0t0;ime;!n0;!ada0;!/7;arrie,ramp0;ton; 4/0;mo1nass0;au;ntre0;al;eastern",
            "Eastern",
            "n",
            "usa"
        ],
        "Vancouver": [
            "true\xa6america 9b7ca5ladn4okanagan,p1surrey,v0yukon;ancouv3ictor7;acific0st,t;! 0;bc,standard time;er;!nada0;!/2;ritish columb0urnaby;ia;pacific",
            "Pacific",
            "n",
            "usa"
        ],
        "Whitehorse": [
            "true\xa6canada1m0whitehorse,yst;ountain standard time,st;!/yukon",
            "Mountain",
            "n"
        ],
        "Winnipeg": [
            "true\xa6america 7c2m1w0;est m0innipeg;anitoba;anada3entral0st,t;! 0;standard t0t0;ime;!/0;central",
            "Central",
            "n",
            "usa"
        ],
        "Yakutat": [
            "true\xa6a0y4;k6laska0merica;! 1n0;! s2;s1t2y0;akutat;tandard t0;ime;st,t",
            "Alaska",
            "n",
            "usa"
        ],
        "Yellowknife": [
            "true\xa6america mountain,canada,m0yellowknife;ountain0st,t;! 0;standard t0t0;ime",
            "Mountain",
            "n",
            "usa"
        ]
    },
    "Antarctica": {
        "Casey": [
            "true\xa6antarctica,cas0;ey,t",
            "Casey",
            "s",
            "ant"
        ],
        "Davis": [
            "true\xa6a1dav0;is,t;ntarctica,q,ta",
            "Davis",
            "s"
        ],
        "Macquarie": [
            "true\xa6a2canberra,eastern australia6m0sydney;acquarie0elbourne;! island;e4ntarctica,us0; east0tralia eastern;!ern0;! standard0; time;st,t",
            "Eastern Australia",
            "s",
            "aus"
        ],
        "Mawson": [
            "true\xa6antarctica,maw0;son,t",
            "Mawson",
            "s"
        ],
        "Rothera": [
            "true\xa6a1b0city of b0rothera;uenos aires;ntarctica1r0;gentina,st,t;!/palmer",
            "Argentina",
            "s"
        ],
        "Troll": [
            "true\xa6antarctica,g2troll0;! 0;research station,t1;mt,reenwich mean t0;ime",
            "Troll",
            "s",
            "troll"
        ],
        "Vostok": [
            "true\xa6antarctica,vost0;!ok",
            "Vostok",
            "s"
        ]
    },
    "Asia": {
        "Almaty": [
            "true\xa6a6central asia,east kazakhstan time,k2nur sultan,p1s0taraz,ust kamenogorsk;emey,hymkent;avlodar,etropavl;a0z;ragandy,z0;!akhstan0;! eastern;lm1s0;ia,tana;a0t; ata,ty",
            "East Kazakhstan",
            "n"
        ],
        "Amman": [
            "true\xa6a2eet,irbid,jo0russeifa,wadi as sir,zarqa;!r0;!d1;mm0sia;an",
            "Eastern European",
            "n",
            "jord"
        ],
        "Anadyr": [
            "true\xa6a0petropavlovsk kamchatsky;na0sia;dyr0t;! time",
            "Anadyr",
            "n"
        ],
        "Aqtau": [
            "true\xa6a1kazakhstan western,mangghysta\u016B/mankis3tashkent,west 0;asia,kazakhstan5;lm2q1s0;hgabat,ia;tau;a0t; ata,-ata0; time",
            "West Kazakhstan",
            "n"
        ],
        "Aqtobe": [
            "true\xa6a1kazakhstan western,tashkent,west 0;asia,kazakhstan5;kto5lm2qt1s0;hgabat,ia;o3\xf63;a0t; ata,-ata0; time;be",
            "West Kazakhstan",
            "n"
        ],
        "Ashgabat": [
            "true\xa6as4t0;km,m2urkmen0;a4istan0;! time;!st,t;hga1ia0;!/ashkhabad;bat",
            "Turkmenistan",
            "n"
        ],
        "Atyrau": [
            "true\xa6a1gur'yev,kazakhstan western,tashkent,west 0;asia,kazakhstan6;lm3s2t0;irau,yra0;u,\u016B;hgabat,ia;a0t; ata,-ata0; time",
            "West Kazakhstan",
            "n"
        ],
        "Baghdad": [
            "true\xa6a6ba5dihok,erbil,i3k2mosul,na1r0;amadi,iyadh;jaf,sirC;arbala,irkuk,uwait;q,r0;aq,q;ghdad,sr9;bu ghurayb,d diw6l 5rab1s0; sulaym5ia,t;!i0;a0c;!n0;! time;amar2basrah al qadim2falluj2hill2kut,mawsil al jadid2;an0;iy0;ah",
            "Arabian",
            "n"
        ],
        "Baku": [
            "true\xa6a0baku,ganja,lankaran,sumqayit;sia,z0;!e0t;!rbaijan0;! time",
            "Azerbaijan",
            "n"
        ],
        "Bangkok": [
            "true\xa6asiaAbangkok,ch7h5i3jakarta,mueang nontha8na2pak kret,s0udon thani;amut prakan,e0i racha,outh east0; asia;khon ratchasima,m di9;ct,ndochina0;! time;a0ue;iphong,noi,t y2;iang m1on 0;buri;ai;!/0;phnom_pe0vientiane;nh",
            "Indochina",
            "n"
        ],
        "Barnaul": [
            "true\xa6a3b2kra0north a3;snoyarsk0t;! time;arnaul,iysk;sia",
            "Krasnoyarsk",
            "n"
        ],
        "Beirut": [
            "true\xa6asia,bei3e2l0ra's bay3;b0ebanon;!n;astern european time,et,urope eastern;rut",
            "Eastern European",
            "n",
            "leb"
        ],
        "Bishkek": [
            "true\xa6asia,bishkek,k0osh;g2yrgy0;stan,zstan0;! time;!t,z",
            "Kyrgyzstan",
            "n"
        ],
        "Brunei": [
            "true\xa6asia,b0;dt,n2r0;n,unei0;! darussalam time;!t",
            "Brunei Darussalam",
            "n"
        ],
        "Chita": [
            "true\xa6asia,chita,yak0;t,utsk0;! time",
            "Yakutsk",
            "n"
        ],
        "Choibalsan": [
            "true\xa6as2choibalsan,dornods\xfckhbaatar,mongol2ula0;anbaatar0t;! time;ia",
            "Ulaanbaatar",
            "n"
        ],
        "Colombo": [
            "true\xa6as6c4dehiwala mount lavin6i2kolkata,lk1m0new delhi,sri lanka;oratuwa,umb4;!a;ndia0st;! time,n;henn0olombo;ai;ia",
            "India",
            "n"
        ],
        "Damascus": [
            "true\xa6a4d3eet,h2latak5sy0;!r0;!ia;am3oms;amascus,eir ez zor;leppo,r raqq1s0;ia;ah",
            "Eastern European",
            "n",
            "syr"
        ],
        "Dhaka": [
            "true\xa6asiaGbDcBd9jess8khul7mymensingh,na4pa3ra2s1t0;angail,ungi;aid8hib4ylhet;jshahi,ng7;b3ltan,r naogaon;gar5r0t3;ayan0singdi;ganj;na;ore;haka,inaj0;pur;hattogram,o0;milla,x's bazar;a0d,gd,ogra,st;gerhat,ngladesh0rishal;! time;!/dacca",
            "Bangladesh",
            "n"
        ],
        "Dili": [
            "true\xa6asia,dili,east timor1tl0;!s,t;! time",
            "East Timor",
            "s"
        ],
        "Dubai": [
            "true\xa6a5dubai,g3mus1om0ras al khaim2sharj2;!an,n;aff0c5;ah;st,ulf0;! time;bu dhabi,jm2rabi2sia0;!/musc0;at;an",
            "Gulf",
            "n"
        ],
        "Dushanbe": [
            "true\xa6asia,dushanbe,t0;ajikistan1j0;!k,t;! time",
            "Tajikistan",
            "n"
        ],
        "Famagusta": [
            "true\xa6asia,e0famagusta,northern cyprus;astern european time,et,urope eastern",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Gaza": [
            "true\xa6asia,eet,gaza2p0;alestine,s0;!e;! strip",
            "Eastern European",
            "n",
            "pal"
        ],
        "Hebron": [
            "true\xa6asia,e0hebron,west bank;ast jerusalem,et",
            "Eastern European",
            "n",
            "pal"
        ],
        "Ho_Chi_Minh": [
            "true\xa6asia7bien hoa,can tho,da 5ho3nha tr6qui nh8rach gia,sa dec,thi xa phu my,v0;ietnam1n0ung tau;!m;! south; chi 0_chi_0;minh;lat,n0;ang;!/saig0;on",
            "Indochina",
            "n"
        ],
        "Hong_Kong": [
            "true\xa6asia,h0kowloon,tsuen wan;k3ong0; kong1_k0k0;ong;! time;!g,st,t",
            "Hong Kong",
            "n"
        ],
        "Hovd": [
            "true\xa6as4bayan-\xf6lgiigovi-altaihovduvszavkhan,hov2west0; 0ern 0;mongol2;d0t;! time;ia",
            "Hovd",
            "n"
        ],
        "Irkutsk": [
            "true\xa6a2brat3irk0north asia east,ulan ude;t,utsk0;! time;ngar0sia;sk",
            "Irkutsk",
            "n"
        ],
        "Jakarta": [
            "true\xa6aZbTcRdepQiNjKkediri,lJmGpArengasdengklQs4t2w0yogyakM;est0ib; indoneXern indonesia time;a0egal;n4sikmal3;ema4itubondo,outh tan3u0;kabumi,medaSra0;b0kF;aya;ge0;raO;a4e1robolinggo,urw0;akAokerto;ka1ma0rcut;laKtangsiantar;long2nbaru;daIl3mulaIruI;a1ed0;an;diun,laF;embaE;a0ember;k0mbi,vasumatra;arta;d1ndonesia0;! western;!n;ok;i0urug;ampea,bino5leungsir,mahi,putat,rebon;a1e0injai,ogor;kasi,ngkulu;nd0tam;a0u1; aceh,r lampu0;ng;sia",
            "Western Indonesia",
            "s"
        ],
        "Jayapura": [
            "true\xa6a2east1indonesia eastern,jayapura,m0new guinea,wit;alukus,oluccas; indones1ern indonesia time;mbon,s0;ia",
            "Eastern Indonesia",
            "s"
        ],
        "Jerusalem": [
            "true\xa6as7beersheba,haifa,i2j0petah tiqwa,rishon leziyyon,tel 9west je1;e0mt;rusalem;d3l,s0;r0t;!ael0;! time;dt,t;hdod,ia0;!/tel_0;aviv",
            "Israel",
            "n",
            "isr"
        ],
        "Kabul": [
            "true\xa6a1herat,jalalabad,ka0mazar e sharif;bul,ndahar;f0sia;!g0t;!hanistan0;! time",
            "Afghanistan",
            "n"
        ],
        "Kamchatka": [
            "true\xa6a2kamchatka,pet0;ropavlovsk0t; kamchatsky,-kamchatski time;nadyr,sia",
            "Petropavlovsk-Kamchatski",
            "n"
        ],
        "Karachi": [
            "true\xa6asia,bLchiniKdera ghaziIfaisalHgujraGhyderHislamHjhang sadr,kElaDm8nawabshah,okaBp4quetta,ra3s0;a1h0ialkJukkN;ahkIekhupu9;ddiqEhiwal,rgodha;him yarEwalpindi;ak1eshawar,k0;!t;!istan0;! time;a3i1u0;lt9zaffar7;ngo0rpur khas;ra;lir cantonment,rd6;hore,rkana;a0otli;moke,rachi,s8;n5t;abad; kh0;an;ot;a1himber,ure0;wala;hawalp0ttagram;ur",
            "Pakistan",
            "n"
        ],
        "Kathmandu": [
            "true\xa6asia3biratnagar,kath4n1p0;atan,okhara;epal,p0;!l,t;!/kat0;mandu",
            "Nepal",
            "n"
        ],
        "Khandyga": [
            "true\xa6asia,khandyga,yak0;t,utsk0;! time",
            "Yakutsk",
            "n"
        ],
        "Kolkata": [
            "true\xa60:3D;1:3L;2:2D;3:3M;4:3J;a35b2Dc24d1We1Uf1Sg1Fh1Ci18j13k0Pl0Km0Cn05odis3KpVquthbull3DrNsFt9u8v5warang2Myamun1P;a6el1Ui5;jayawa2Vsakha0HzianagC;doda2Orana11;daip0jja23lhasn1ttar pradesh;a8eXh7iru5umk0;chirap0Mnelve2p5vottiy0;a39p0;ane,iruvananthapur0Noothuku2Yriss0;mb5njo1X;ar0L;aBecunder4h9i8lst,o7r1Fu5;jan37r5;at,endr1C;l2Znip2N;k3liguKngrau2rJ;ahj1Zi5ri2Oya0L;mo1Mvaji07;har1Xlem,mbh24ng2t04ug0Y;a6e0Eoh5;iItak;ebare2i9j7m5nc1Gtl0Aurke37;ag5g5p0;und08;a5kot;hmund26sth2A;ch0p0;a9imp8roddat0u5;ducher23n5rn17;a5e;sa;ri;li,n7rbha6t5;ia2Vna;ni;chku2Ti5;ha2Gp21;a7e6izam4o5;i1Vwrang2B;l0Sw del0Y;di2Kg7i0Ejaf2Fn5re2Oshik,vi mumb15;ded,g5;i,loi j1V;ercoil,p0;a8eerut,irz25o7u5yso0Y;lugu,mb10rwa1Izaffar5;n1p0;nghyr,rad4;chili7d6harasht1Fleg07n5thu1Fu;ga0Iip0;hya,ur0V;patnG;a7u5;cknow,dhia5;na;l bahadur5t0; n1;aDhaBo8u5;kat6lt5rno1P;a2i;pal2;l5rWta,zhikode;h1Nka1Kl5;am;nd5ragp0;wa;kina13l8marOnp0r5shmir,tih3;i6na5ol ba18;l,tV;mn1;lakuric03y11;a6han5odNunagadh;si;b0Rip0l6m5;mu,n1shedp0;andh3gGna;chalkaranji,mph0In5st;!d5;!ia5o00;! time,n;a6is3ospet,u5;b2g2;o0Hp0ridw3;aChazi4o9reater noi0Mu6wali5y04;or;jar0OlbarQnt0rg6wa5;ha12;aon;rak6sa5;ba;hp0;juw8n5ya;dh6g5;an1;in1;aka;ar5iroz4;id4rukh4;l5taw0M;loF;aAe8h6indigul,ombOurg5;!ap0;anb0Uul5;ia;hra dun,l5was;hi;rbhan5vange8;ga;a09h8o5uttack;ch6imbato5;re;in;a6enn5;ai;nd5pL;a5i0C;!nn1;aNeKhBi9or7rahm04u5;landshahr,rh5;anp0;iv2;li;d3har sharif,jZkan07l5;asp0imoC;aAi7op6u5;baneshw3sav5;al;l6wan5;di,i;ai,wa6;g6ratp0tpa5vn1yand3;ra;alp0;l5ngaluru;gaum,la5;ry;hAli,r6thin5;da;a6ddham5eilly;an;n1s5;at;a6rai5;gh;ramp0;gQhmLizawl,jmKkoRlHmDnantCrrBs6urang4va5;di;ans8ia5;!/ca5;lcut5;ta;ol;ah;ap0;arnath,batt0r5;ava5its3o9;ti;ur;appuz6i5lah4w3;garh;ha;er;adn1ed4;ab5;ad;ag3;ar;arta5ra;la",
            "India",
            "n"
        ],
        "Krasnoyarsk": [
            "true\xa6a2kra0north a2;snoyarsk0t;! time;sia",
            "Krasnoyarsk",
            "n"
        ],
        "Kuala_Lumpur": [
            "true\xa6aHbukit mertajGgeorge town,ipoh,johor bahFk8m4petali3s0taipiE;e1hah alFu0;ba1ngai petani;paBremb7;ng jaya;ala1y0;!s,t;cca,ysia0;! time;ampung baru suba5la5ota bha6ua0;la1nt0;an; 0_l1;l0terengganu;umpur;ng;ru;am;lor setar,sia",
            "Malaysia",
            "s"
        ],
        "Kuching": [
            "true\xa6asia,k4m2s0tawau;a0ibu;bahsarawak,ndakan;alaysia0iri,yt;! time;ota kinabalu,uching",
            "Malaysia",
            "n"
        ],
        "Macau": [
            "true\xa6asia6beiji5c2hong ko5m0urumqi;ac0o;!au;h0st;ina0ongqi1;! time;ng;!/macao",
            "China",
            "n"
        ],
        "Magadan": [
            "true\xa6asia,mag0;adan0t;! time",
            "Magadan",
            "n"
        ],
        "Makassar": [
            "true\xa6asiaBba8c5denpa4indonesia central,k3l2ma1palu,s0wita;amarinda,ulawesi;kas2nado,taram;abuan bajo,oa jan7;endari,up8;sar;e0ity of bal3;lebesbalinusa,ntral indonesia0;! time;l0njarmasin;ikpap0;an;!/ujung_pand0;ang",
            "Central Indonesia",
            "s"
        ],
        "Manila": [
            "true\xa6a04bWcRdaPgeneral santOiMlJmCnaBoAp4quezIsan1ta0zamboanga;clobZguig,rlac,ytE; 1t0;a ro2ol;fernando,jose del monte,pab02;a3h1uerto prince0;sa;!ilippine0l,st,t; time,s;gadiRnalanoy,s0;ay,ig;longapo,rmoc;ga,votQ;a0eycauayN;balacat,gugpo poblaci4kati,l3n0;da1ila,silingLtamp0;ay;luyong,ue;ingDol6;on;a1egaspi,i0ucena;bertad,pa;pu lapu,s p4;l0mus;igCoiI;os;smar0v5;inB;a0ebu,otabato;b1gayan de oro,in5l0;amba,ooc6;anatu5uy0;ao;a4inan2u0;d0tu2;ta;!gon0;an;co1guio,tang0;as;lod,or;n0sia;geles,tipo0;lo",
            "Philippine",
            "n"
        ],
        "Nicosia": [
            "true\xa6a5cy3e0n2;astern european time,et,urope0; eastern,/n0;ico2;!p0;!rus;sia",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Novokuznetsk": [
            "true\xa6a5k2no0prokop'yev1;rth a4vokuznet0;sk;emerovo,ra0;snoyarsk0t;! time;sia",
            "Krasnoyarsk",
            "n"
        ],
        "Novosibirsk": [
            "true\xa6as3no0siber3;rth central as2v0;osibirsk0t;! time;ia",
            "Novosibirsk",
            "n"
        ],
        "Omsk": [
            "true\xa6asia,oms0;k0t;! time",
            "Omsk",
            "n"
        ],
        "Oral": [
            "true\xa6a2kazakhstan western,oral,tashkent,west 0;asia,kazakhstan0;! 4;lm1s0;hgabat,ia;a0t; ata,-ata 0;time",
            "West Kazakhstan",
            "n"
        ],
        "Pontianak": [
            "true\xa6asia,b2indonesia western,pontianak,tanjung pinang,w0;est0ib; b0ern indonesia time;orneo",
            "Western Indonesia",
            "n"
        ],
        "Pyongyang": [
            "true\xa6asia,chongjin,h7k4n3p2s0won8;ariw0eoul,inuiAunch'0;on;rk,yongya7;amp'o,orth korea;a1orea0p,st;!n time;eso3nggye;a1ungnam,ye0;san;e1mhu0;ng;ju",
            "Korean",
            "n"
        ],
        "Qatar": [
            "true\xa6a2doha,kuwait,qa0riyadh;!t0;!ar;r2s0;ia0t;!/bahrain; rayyan,ab0;!i0;a0c;!n0;! time",
            "Arabian",
            "n"
        ],
        "Qostanay": [
            "true\xa6a2central asia,east kazakhstan time,k0qo1;azakhstan eastern,o0;stanay;lmt,s0;ia,tana",
            "East Kazakhstan",
            "n"
        ],
        "Qyzylorda": [
            "true\xa6a4k1qy2tashkent,west 0;asia,kazakhstan7;azakhstan western,y0zyl-1;zyl0;orda;lm1s0;hgabat,ia;a0t; ata,-ata0; time",
            "West Kazakhstan",
            "n"
        ],
        "Riyadh": [
            "true\xa6a9burayd8dammam,ha7jedd8k6me5najran,riyadh,s4ta3y0;anbu,e0;!m0;!en;'if,buk;ultan3yot;cca,dina;hamis mush6uw6;'il,far al batin;ah;bha,l 8ntarctica/syowa,rab4s0;ia0t;!/0;aden,kuw0;ait;!i0;a0c;!n0;! time;hufuf,jubayl,kharj,mubarraz",
            "Arabian",
            "n"
        ],
        "Sakhalin": [
            "true\xa6asia,sak0yuzhno sakhalinsk;halin0t;! 0;island,time",
            "Sakhalin",
            "n"
        ],
        "Samarkand": [
            "true\xa6asia,bukhara,nukus,qarshi,samarkand,uz0;bekistan0t;! 0;time,west",
            "Uzbekistan",
            "n"
        ],
        "Seoul": [
            "true\xa6aPbuMchHdaeGgChwaseoRiBjeAk7m6pohaFrok,s2u1wonJy0;aCeosu;ijeongbuQlsL;e1outh korea,u0;nEwH;joAo0;ngnamMul;asGokpo;imhae,or0r,st,wangmyo7;!ea0;!n time;ju,on8;cCksBn6;angneu2oyaEu1wa0;ng5;mi,ns8riD;ng;gu,je4;angw3eon2in1un0;che2;ju;an,gju7;on;c1s0;an;heon3;n0sia;san1ya0;ng0; si",
            "Korean",
            "n"
        ],
        "Shanghai": [
            "true\xa60:3J;1:36;2:34;3:37;4:3D;a3Cb31c2Nd2He30f2Cg26h1Qji1Ek1Bl0Ym0Wn0Tordos,p0Pq0Lrizh10s08t01u3FwSxLyEz5;aoCh6i5ouc3unyi;bo,go0;a7en6ouk2u5; c3h31maWzh2;g2Vj1Izh2;b1Vng5o3E;jiakou5zh2;! shi xuanhua qu;ya0z27;an9i7u5;ci,e18n5;c3fu;b4c9n5ya0;cZgk2;c3g5ji,t2Q;j17qu1sh16zh2;i6uc5;ha0;a6n5uyi0;di,gt2Lh1Gi0pu,t2Lx13ya0;m17n5;!g5ni0t0Eya0;t1ya0;aBe9u5;h6so0w1Cx5zh2;i,ue;a5u;i,n;i0Hn5;sh1zh2;fang5nxi1;di1;a8i6ong5;chuans0XhDli02sh1;an5eli0;j4sh10;i6ng5;gu,sh1;an,hec1Wyu1zh2;anmi0hAi8u5;i5zh2;h5zh2;ua;c5pi0;hu1;a7en6i5uangya14;jiaz15qi,y1;gli,ya0zh0G;n6o5s0I;gu1xi0;g5t2;h1Pqiu,rKyu;i5uan1J;aFn5o14qih1Y;g5huangdH;dGh1L;an0Ting7rc,u5;ti1yang5;! H;ding0QxZ;an5eijYingbo;ch5ji0ni0to0ya0;a0o0;entoug2ianRuda5;njU;aEi8u5;anc3o6qi5;ao;he,ya0;a7jPn5upansh02;fTxia 5yi;chengguanI;n0Do5;c3y5;a0u1;i0Wn5ohek2;g5zh2;fa0;ai6un5;mi0sh1;fe0yu1;'1aAe9l4n6u5xi;jCt0U;an,c3g5i0zh2;de5li0zh2;zhE;ya0;musi,n8o5xi0;j6z5;uo;ia0;g5shG;m7xi;aGeCkt,oBu5;a6i0Dlan ergi,m5n1;en;i7ng5y4;ga0s5;hi;'1b9n1;hhot,ng ko0;bi,f7ga0ng5ze;sh5ya0;ui;ei;i7n5rb4;d1g5;u,zh2;c3k2l0F;a9u5;an6i5li;l4ya0zh2;g5k2;do0yu1zh2;nsu,opi0;en7o6u5;ji1shQx4zh2;sh1;d2g5;hua0;a6eNong5;gu1hR;d6lian5ndo0qi0to0;!g;o5uk2;nghN;angHh5n,st,t;aAen7i5n,oZuG;fe0na5;! time;g5zh2;d5zho0;e,u;ng6o5;ya0zh2;ch7de,sh6zh5;i,ou;a,u;un;zh2;a9e5;i6n5;gbu,xi;'1h5ji0;ai;i7o5yan nur;di0t2;ou;c3sh1y4;an;he0;nDsia5;!/5;ch8harb4kashg6u5;rumqi;ar;in;o5ungki0;ng5;qi0;da,qi0sh5ya0;an,un;ng",
            "China",
            "n"
        ],
        "Singapore": [
            "true\xa6asia,kuala lumpur,s0woodlands;g0ingapore;!p,t",
            "Singapore",
            "s"
        ],
        "Srednekolymsk": [
            "true\xa6asia,chokurdakh,sre0;dnekolymsk,t",
            "Srednekolymsk",
            "n"
        ],
        "Taipei": [
            "true\xa6asia,banqiao,cst,h7k5roc,t0;a1w0;!n;i0oyu1;ch2n0pei,w0;an;aohsi0eel0;ung;sinchu,ualien",
            "Taipei",
            "n"
        ],
        "Tashkent": [
            "true\xa6a3namangan,qo`q4tashkent,uz0;!b0t;!ekistan0;! east;ndij0sia;on",
            "Uzbekistan",
            "n"
        ],
        "Tbilisi": [
            "true\xa6asia,ge1kuta0tbil0;isi;!o0t;!rgia0;!n",
            "Georgia",
            "n"
        ],
        "Tehran": [
            "true\xa6aQbMgorgWhamViKkCmaBn8orumiy7pasragad branch,q4rasht,s2t1varam6yazd,za0;hedVnjV;abHehrU;a0hirRirjT;bzevar,nandEri,v3;a0om;rchak,zv0;in;eh;a0eyshabur;jaf0zar0;ab4;layer,shh3;a4erman3ho0;meyni sDrram0wy;ab0sC;ad;!shah;h1r0;aj;riz;r0sfahB;!an,dt,n,st;a2irjand,o0uk9;jnu0ruje0;rd;b3ndar abbas;b4hv3m2r1sia,zads0;hahr;ak,dabil;ol;az;ad0;an",
            "Iran",
            "n"
        ],
        "Thimphu": [
            "true\xa6asia2b0thimphu;hutan,t0;!n;!/thimbu",
            "Bhutan",
            "n"
        ],
        "Tokyo": [
            "true\xa60:11;1:1A;2:10;a18ch16fu0Zgifu14h0Oi0Ij0FkZmTnMoKsFt9u8waka05y3;a6o3;k3no;kaic1Co3;ha2su0;maKo;ji,tsun0F;aka7o3sukuba;k5makom05y3;a2o3;hOna0ta;oro03us0Qyo;m0Jrazu0sa1tsu1;a5end00hi4o0u3;i10zu0;monose1zuo0;ita2k3ppoLsebo;ai,u06;dawa05i0Wka3sa0t0E;ya2za1;a6eyaga0Qi3umazu;i4shi3; tokyo0Inomiya ha2;ga0R;g3ha,ra0G;a3oX;no,o0sa1;a5i3orio0;na3to,yaza1;mirinkOto;chiDeb4tsu3;do,m8ya2;as0J;aBi9o7u3y6;mam5r4shi3;ro;ashi1e,ume;oto;be,c0Dfu,ri3shigaK;ya2;shiwa3takyushu;da;gosVkogawacho honmKmirenjaku,na8s5wa3;g3sa1;oe,uc07;hi01u3;g3kabe;ai;zaY;ap4dt,oetJp3st;!n;an;bara1chi4ta3wa1zu3;mi;ha5n3;omi3;ya;ra;a8i3oncho;meBr4t3;acR;a4os3;a1hi2;kaNtsu0;chi5kodate,mam3;at3;su;nohe,o3;ji;ji8ku3;i6o0s3ya2;hi2;ma;ka; sD;!sa7;i3ofu;ba,g6;geoshimo,k7mag5njo,omori,s3tsugi;ahika3ia;wa;asa1;ki;as4i3;ta;hi",
            "Japan",
            "n"
        ],
        "Tomsk": [
            "true\xa6asia,oms0tomsk;k,t",
            "Omsk",
            "n"
        ],
        "Ulaanbaatar": [
            "true\xa6asia3m1ula0;anbaatar,n 3t;n0ongolia;!g;!/ulan_0;bator",
            "Ulaanbaatar",
            "n"
        ],
        "Ust-Nera": [
            "true\xa6asia,ust-nera,vla0;divostok,t",
            "Vladivostok",
            "n"
        ],
        "Vladivostok": [
            "true\xa6asia,k1vla0;divostok,t;habarovsk0omsomolsk on amur;! vtoroy",
            "Vladivostok",
            "n"
        ],
        "Yakutsk": [
            "true\xa6asia,blagoveshchen1yak0;t,ut0;sk",
            "Yakutsk",
            "n"
        ],
        "Yangon": [
            "true\xa6asia4b3kyain seikgyi township,m0nay pyi taw,pathein,sittwe,yang5;a1eiktila,m0onywa;!r,t;ndalay,wlamyine;ago,urma;!/rango0;on",
            "Myanmar",
            "n"
        ],
        "Yekaterinburg": [
            "true\xa6asia,chelyabin7eka5k4magnitogor7nizhn3or2perm,s1tyumen,ufa,yek0zlatoust;a4t;terlitamak,urgut;e3sk;evartov3y tagil;amensk ural'skiy,urgan;teri0;nburg;sk",
            "Yekaterinburg",
            "n"
        ],
        "Yerevan": [
            "true\xa6a0caucasus,yerevan;m2rm0s1;!en0;ia;!t",
            "Armenia",
            "n"
        ]
    },
    "Atlantic": {
        "Azores": [
            "true\xa6a0hmt;tlantic,zo0;res,st,t",
            "Azores",
            "n",
            "eu0"
        ],
        "Bermuda": [
            "true\xa6a2b0;ermuda,m0;!u;st,t0;!lantic",
            "Atlantic",
            "n",
            "usa"
        ],
        "Canary": [
            "true\xa6atlantic,canary1europe western,las palmas de gran canaria,santa cruz de tenerife,we0;stern european,t;! islands",
            "Western European",
            "n",
            "eu1"
        ],
        "Cape_Verde": [
            "true\xa6atlantic,c0;a1pv,v0;!t;bo verde0pe verde;! is",
            "Cape Verde",
            "n"
        ],
        "Faroe": [
            "true\xa6atlantic2f0;aroe0o,ro;! islands;!/faeroe",
            "Western European",
            "n",
            "eu1"
        ],
        "Madeira": [
            "true\xa6atlantic,europe western,madeira1we0;stern european,t;! islands",
            "Western European",
            "n",
            "eu1"
        ],
        "Reykjavik": [
            "true\xa6atlantic,coordinated universal3g2i0reykjavik,utc,zulu;celand,s0;!l;mt,reenwich mean0; time",
            "Greenwich Mean",
            "n"
        ],
        "South_Georgia": [
            "true\xa6atlantic,gs1s0;gs,outh georgia;!t",
            "South Georgia",
            "n"
        ],
        "Stanley": [
            "true\xa6atlantic,f0stanley;alkland1k0lk;!st,t;! island0;!s",
            "Falkland Islands",
            "s"
        ]
    },
    "Australia": {
        "Adelaide": [
            "true\xa6a2cen0south 1; 0tral 0;australia;c2delaide,ustralia0;! 0/south,n 0;central;dt,st,t",
            "Central Australia",
            "s",
            "aus"
        ],
        "Brisbane": [
            "true\xa6a1brisbane0gold coast,logan,q4townsville;! time;e3ustralia0;!/q1n east0;!ern;ueensland;dt,st",
            "Brisbane",
            "s"
        ],
        "Broken_Hill": [
            "true\xa6a1broken_hill,cen0y3; australia standard time,tral australia;c2delaide,ustralia0;! central,/y0;ancowinna;st,t",
            "Central Australia",
            "s",
            "aus"
        ],
        "Darwin": [
            "true\xa6a0darwin,northern territory;cst,ustralia0;!/north,n central",
            "Australian Central",
            "s"
        ],
        "Eucla": [
            "true\xa6a0cw4eucla;cw4us0; central w1tralia0;!n central western;!e0;st;dt,st,t",
            "Australian Central Western",
            "s"
        ],
        "Hobart": [
            "true\xa6a0canberra,eastern austral5hobart,king island,melbourne,sydney,t4;e8us0; east5tralia0;! 3/0n 3;currie,t0;asman0;ia;easte1;!e0;rn;st,t",
            "Eastern Australia",
            "s",
            "aus"
        ],
        "Lindeman": [
            "true\xa6a0brisbane time,lindeman,whitsunday islands;est,ustralia0;!n eastern",
            "Brisbane",
            "s"
        ],
        "Lord_Howe": [
            "true\xa6australia3l0;h1ord howe0;! island;dt,st,t;!/lhi",
            "Lord Howe",
            "s",
            "lhow"
        ],
        "Melbourne": [
            "true\xa6a0canberra,eastern austral4geelong,melbourne,sydney,v3;e7us0; east4tralia0;! 2/v0n 2;ictor0;ia;easte1;!e0;rn;st,t",
            "Eastern Australia",
            "s",
            "aus"
        ],
        "Perth": [
            "true\xa6a4perth,w0; 2est0; 1ern australia0;! time;australia;ustralia1w0;dt,st,t;! weste1/west,n west0;!e0;rn",
            "Western Australia",
            "s"
        ],
        "Sydney": [
            "true\xa6a0c5eastern australia time,melbourne,new south wales,sydney,wollongong;e8u0;!s0;! east4tralia0;! 2/0n 2;act,c0nsw;anberra;easte1;!e0;rn;st,t",
            "Eastern Australia",
            "s",
            "aus"
        ]
    },
    "Etc": {
        "GMT": [
            "true\xa6coordinated universal3etc2g0utc,zulu;mt,reenwich0;! mean1;!/greenwich; time",
            "Greenwich Mean",
            "n"
        ],
        "UTC": [
            "true\xa6coordinated universal7etc2g1u0z4;ct,n5tc;mt,reenwich mean5;!/0;u1z0;ulu;ct,n0;iversal; time",
            "Greenwich Mean",
            "n"
        ]
    },
    "Europe": {
        "Amsterdam": [
            "true\xa6a9brussels,c6e4groning7madrid,n2paris,ro1t0utrecht;he hague,ilburg;mance,t9;etherlands,l0;!d;indhov2urope0;! central;e1openhag0;en;ntral european,st,t;lmere stad,m0;s0t;terdam",
            "Central European",
            "n",
            "eu2"
        ],
        "Andorra": [
            "true\xa6a3brussels,c1europe0madrid,paris,romance;! central;e0openhagen;ntral european,st,t;d,nd0;!orra",
            "Central European",
            "n",
            "eu2"
        ],
        "Astrakhan": [
            "true\xa6astrakh1europe,m0russi1st petersburg,volgograd time;oscow,sk;an",
            "Moscow",
            "n"
        ],
        "Athens": [
            "true\xa6athens,e1gr0thessaloniki;!c,eece;astern european,et,urope0;! eastern",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Belgrade": [
            "true\xa6b9c7europe3madrid,n2p1romance,s0;i,lovenia,vn;aris,risti4;is,ovi sad;! central,/0;ljublja1podgorica,s0zagreb;arajevo,kopje;na;e0openhagen;ntral european,st,t;elgrade,russels",
            "Central European",
            "n",
            "eu2"
        ],
        "Brussels": [
            "true\xa6antwerp6b3c1europe0gent,liege,madrid,paris,romance;! central;e0harleroi,openhag4;ntral european,st,t;e0mt,russels;!l0;!gium;en",
            "Central European",
            "n",
            "eu2"
        ],
        "Bucharest": [
            "true\xa6b5c4e2gala1iasi,oradea,ploies1ro0timisoara;!mania,u;ti;astern european,et,urope0;! eastern;luj napoca,onstanta,raiova;ra0ucharest;ila,sov",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Budapest": [
            "true\xa6b6c3debrec4europe2hu0madrid,paris,romance;!n0;!gary;! central;e1openhag0;en;ntral european,st,t;russels,udapest",
            "Central European",
            "n",
            "eu2"
        ],
        "Busingen": [
            "true\xa6b5c3de2europe1germa0madrid,paris,romance,saxo0;ny;! central,/berlin;!u;e0openhag3;ntral european,st,t;avaria,r0using1;em0ussels;en",
            "Central European",
            "n",
            "eu2"
        ],
        "Chisinau": [
            "true\xa6chisinau,e2m0;d0oldova;!a;astern european,et,urope0;! eastern,/tiraspol",
            "Eastern European",
            "n",
            "eu2"
        ],
        "Copenhagen": [
            "true\xa6arhus,brussels,c2d1europe0madrid,paris,romance;! central;enmark,k,nk;e0mt,openhagen;ntral european,st,t",
            "Central European",
            "n",
            "eu2"
        ],
        "Dublin": [
            "true\xa6ace,british8cork,d7e6g5i3l0tse,waterford;i0ond1;merick,sb0;on;e,r0st;eland,l;alway,mt,reenwich mean2;dinburgh,ire,urope;mt,ublin; time",
            "Irish",
            "n",
            "eu1"
        ],
        "Gibraltar": [
            "true\xa6b5c3europe2gi0madrid,paris,romance;!b0;!raltar;! central;e0openhagen;ntral european,st,t;dst,russels,st",
            "Central European",
            "n",
            "eu2"
        ],
        "Helsinki": [
            "true\xa6e3fi1helsinki,t0vantaa;ampere,urku;!n0;!land;astern european,et,spoo,urope0;! eastern,/mariehamn",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Istanbul": [
            "true\xa6aYbScQdOeKgJiHkFmBosmAs4t1u0v07zeytinburnu;eskuedWmr9;arsus,r1ur0;!kZ;!abzon,t;a3i1ultan0;beyJgazi;sIv0;as,erek;msun,n0;cakteBliurfa;aniye;a1er0uratpaH;kezefendi,sin;l0niF;atQte6;a0irikkale,onPutahP;hramanmaras,rabaglGyseS;sJzmi0;r,t;aziantep,ebze;lazig,rzurum,s1uro0;pe;en0kiC;l8yurt;eniz0iyarbakB;li;ankaEor0;lu,um;a1ur0;sa;gcil2hcelievl1likes5sak4t0;ikent,mB;er;ar;d7n4rnavutko3sia/is2ta0;seh0;ir;tanbul;ey;kara,ta0;k0l0;ya;a1iyam0;an;na,paza0;ri",
            "Turkey",
            "n"
        ],
        "Kaliningrad": [
            "true\xa6e0kaliningrad;astern european,et,urope",
            "Eastern European",
            "n"
        ],
        "Kiev": [
            "true\xa6bila tserkLcherIdGeDhorlCivano frankivHk8l7m5odessa,poltaLriv4sumy,ternopil,u2vinnyts1z0;aporizhzh0hytomyr;ya;a,kr0;!ai0;ne;a0ykolayE;ki5riu8;ut9vC;amyanske,h1iev,r0yB;emenchuk,opyv1yvyy rih;ark9erson,mel0;nytskyy;ivka;astern european,et,urope0;! eastern,/simfero0;pol;nipro,onet0;sk;kasy,ni0;h0vtsi;iv;va",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Kirov": [
            "true\xa6europe,kirov,m0russian,st petersburg,volgograd time;oscow,sk",
            "Moscow",
            "n"
        ],
        "Lisbon": [
            "true\xa6amadora,europe5lisbon,p2we0;st0t;! europe,ern european;ort0rt,t;o,ugal0;! mainland;! western",
            "Western European",
            "n",
            "eu1"
        ],
        "London": [
            "true\xa6a0Ob0Ac07d03eXgThRiOj00kingston upon hull,lJmHnBoxSp9reading,s1w0yF;arwick0Aig00olverha7;heffield,o3t2u1w0;an4iH;ffolk,nderland,rr0IsYttL;afNoke on tre0C;meZuth0;a1end on 0;sea;mptG;ly0orts0restF;mouth;ew4o0;r0ttinghamT;th0wC; y0amptonR;orkV;castle upon tyne,port;ancheQi0;dlan4lton keynes;ancaRdn,e2i1o0ut5;nd4;ncolnPsb3verW;e0icesterJ;ds;psw1slingt0;on;ich;ampJert0;fordI;b2l1mt0reenwich mean M;! standard L;asgow,oucesterF;!-eF;dinburgh,s4urope0;!/0;belNguernsMisle_of_m1j0;ersL;an;sex;erby2o1u0;blin,dlH;rset;!sh5;a1ity of westmin0oventry,rawlE;ster;mbridge1rdiff;eAir9lack7r2st,uckingham0;sh0;ire;adford,e3i0;st4tish0;! 0;time;nt;po0;ol;kenhead,mingham;l1xl0;ey;fast;berdeen,rchway",
            "British",
            "n",
            "eu1"
        ],
        "Luxembourg": [
            "true\xa6brussels,c3europe2lu0madrid,paris,romance;!x0;!embourg;! central;e0openhagen;ntral european,st,t",
            "Central European",
            "n",
            "eu2"
        ],
        "Madrid": [
            "true\xa6aRbOcJeGfuenDgCjerez de la frontera,lBm8ovieFp6romance,s1terrassa,v0wemt,zaragoza;alladol9igo;a1evilla,pain0;! mainland;badell,n0; sebastiHt0; marti,ander,s montjuic;a0uente de vallecas;lma,mpIris;a0ostolLurcK;dr0laga;id;atiJeganI;asteiz/vitorGijon,ran1;carral el par1labr0;ada;do;ixample,lche,s1urope0;! centr2;!p;a3e1iudad line0openhagen;al;ntral europe0st,t;an;rabanchel,stello de la pla7;a0ilbao,russels,urgos;da0rce0sque;lo4; coru3l0;cala de henar1icante,mer0;ia;es;na",
            "Central European",
            "n",
            "eu2"
        ],
        "Malta": [
            "true\xa6brussels,c3europe2m0paris,romance;a0lt,t;drid,lta;! central;e0openhagen;ntral european,st,t",
            "Central European",
            "n",
            "eu2"
        ],
        "Minsk": [
            "true\xa6b4europe,h3m1russian,st petersburg,v0;iteb4olgograd time;ahily0in3osc0sk;ow;omyel,rodna;abruy0elarus,lr,rest,y;sk",
            "Moscow",
            "n"
        ],
        "Monaco": [
            "true\xa6brussels,c3europe2m0paris,romance;adrid,c0onaco;!o;! central;e0openhagen;ntral european,st,t",
            "Central European",
            "n",
            "eu2"
        ],
        "Moscow": [
            "true\xa6ar0Db0Ac07dzerzh06europe,fet,grozn05ivano04kYlipet0FmRnNorel,pKrFs8t6v2w-su,y0zelenograd;a0oshkar oW;roslavl,sene02;asyl'evsky ostrIelikiMladi2o0ykhino zhulebT;l0ronezh;gograd Pogda;kavkaz,m08;a0uQver;ganrog,mbD;a4ever3hakhty,molen06ochi,t0yktyvkR; 4a0;ryy osk0vrop0;ol;nSodvT;int 0rX;petersburg;ostov na donu,u1y0;azLbP;!s0;!sia0;!n;e1odolUsk0;ov;nza,trozavodS;a2izhn0ovorossiyR;ekamQi0;y novM;berezhnyye chelny,l'chik;a3dst,oscow1s0urmJ;d,k;! 0;time;khachka1r'0;ino;la;a2himki,ostroma,rasno0urG;d0gvargeisky;ar;l1z0;an;ininsk5uga;vo;yy;in8;entraln1he0;boksary,repovets;iy;el1ry0;an3;gorod;khangel'1mav0;ir;sk",
            "Moscow",
            "n"
        ],
        "Oslo": [
            "true\xa6a6b5c3europe2madrid,oslo,paris,romance,s0;j0valbard and jan 6;!m;! central;e0openhag4;ntral european,st,t;erg2russels;rctic/longyearby1tlantic/jan_0;may0;en",
            "Central European",
            "n",
            "eu2"
        ],
        "Paris": [
            "true\xa6bIcFeuropeEfrBl9m7n5paris,r3s0toulouH;aint 1t0; 0rasbourg;etienne;e0oman9;ims,nn1;ant0i7ormandy;es;a0et,ontpellier;drid,rsei1;e havre,i0yon;lle;!a0;!n0;ce;! central;e0openhagen;ntral european,rgy pontoi0st,t;se;ordeaux,russels",
            "Central European",
            "n",
            "eu2"
        ],
        "Prague": [
            "true\xa6br6c4europe2madrid,ostr3p1romance,s0;k,lovakia,vk;aris,mt,rague;! central,/bratisl0;ava;e0openhagen;ntral european,st,t;no,ussels",
            "Central European",
            "n",
            "eu2"
        ],
        "Riga": [
            "true\xa6e2kalt,l0riga;atvia,st,v0;!a;ast2e1urope0;! eastern;st,t; europe,ern european",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Rome": [
            "true\xa6bIcEeuropeCfloreBgenoa,mAnaples,p7r5sicily,t3v0;a0eroK;!t0;!ican city;aran4rieste,u0;rin,scany;mt,om0;a4e;a1ra0;to;dova,lermo,ris;adrid,essiAil6;nce;! central,/0;san_marino,vatic3;atan5e1o0;penhagen,rsica;ntral europe0st,t;an;ari,olog2r0;esc0ussels;ia;na",
            "Central European",
            "n",
            "eu2"
        ],
        "Samara": [
            "true\xa6europe,izhevsk,s0togliatti on the volga;am0yzran;ara,t",
            "Samara",
            "n"
        ],
        "Saratov": [
            "true\xa6balakovo,europe,izhevsk,sa0;m0ratov;ara,t",
            "Samara",
            "n"
        ],
        "Sofia": [
            "true\xa6b2e0imt,plovdiv,sof4varna;astern european,et,urope0;! eastern;g2u0;lgar0rgas;ia;!r",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Stockholm": [
            "true\xa6brussels,c5europe4goeteborg,ma3paris,romance,s0;e1tockholm,we0;!d4;!t;drid,lmoe;! central;e1openhag0;en;ntral european,st,t",
            "Central European",
            "n",
            "eu2"
        ],
        "Tallinn": [
            "true\xa6e0tallinn;astern european,e2st1urope0;! eastern;!onia;!t",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Tirane": [
            "true\xa6al4brussels,c2europe1madrid,paris,romance,tiran0;a,e;! central;e0openhagen;ntral european,st,t;!b0;!ania",
            "Central European",
            "n",
            "eu2"
        ],
        "Ulyanovsk": [
            "true\xa6europe,m0russian,st petersburg,ulyanovsk,volgograd 2;oscow0sk;! 0;time",
            "Moscow",
            "n"
        ],
        "Uzhgorod": [
            "true\xa6e0ruthenia,uzhgorod;astern european,et,urope0;! eastern",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Vienna": [
            "true\xa6a4brussels,c1donaustadt,europe0favorit2graz,linz,madrid,paris,romance,vienna;! central;e1openhag0;en;ntral european,st,t;t,u0;stria,t",
            "Central European",
            "n",
            "eu2"
        ],
        "Vilnius": [
            "true\xa6e3k2l0vilnius;ithuania,t0;!u;aunas,laipeda;astern european,et,urope0;! eastern",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Volgograd": [
            "true\xa6europe,m2russian,st petersburg,vol0;gograd0t,zhskiy;! time;oscow,sk",
            "Moscow",
            "n"
        ],
        "Warsaw": [
            "true\xa6bKcHeuropeGgCkAl8m7p4r3s2torun,w0zabrze;ars0rocl0;aw;osnowiec,zczec6;adIomanA;aris,l,o0raga poludnie;l0znD;!and;adrid,okot3;odz,ubl0;in;ato2iel3rak0;ow;d2li0;wi0;ce;ansk,ynia;! central;e0openhagen,zestochowa;ntral europe0st,t;an;i2russels,y0;dgoszcz,t0;om;alystok,elsko biala",
            "Central European",
            "n",
            "eu2"
        ],
        "Zaporozhye": [
            "true\xa6e3luhansk2sevastopol,zapor0;izhia lugansk,ozh0;'ye,ye;! east;astern european,et,urope0;! eastern",
            "Eastern European",
            "n",
            "eu3"
        ],
        "Zurich": [
            "true\xa6brussels,c4europe2geneve,li0madrid,paris,romance,swiss time,zurich;!e0;!chtenstein;! central,/0;busin1vaduz;e1openha0;gen;ntral european,st,t",
            "Central European",
            "n",
            "eu2"
        ]
    },
    "Indian": {
        "Chagos": [
            "true\xa6british indian ocean territory,c4i0;ndian1o0;!t;! 0;c0ocean;hagos",
            "Indian Ocean",
            "n"
        ],
        "Christmas": [
            "true\xa6c0indian;hristmas1x0;!r,t;! island",
            "Christmas Island",
            "s"
        ],
        "Cocos": [
            "true\xa6c0indian;c2ocos0;! island0;!s;!k,t",
            "Cocos Islands",
            "n"
        ],
        "Kerguelen": [
            "true\xa6a5french southern2indian,kerguelen1tf0;!t;!st paul4;! 0;& antarctic time,and antarctic0;! lands;msterdam0tf; island",
            "French Southern & Antarctic",
            "s"
        ],
        "Mahe": [
            "true\xa6indian,mahe,s0;c0eychelles,yc;!t",
            "Seychelles",
            "n"
        ],
        "Maldives": [
            "true\xa6indian,m0;aldives,dv,v0;!t",
            "Maldives",
            "n"
        ],
        "Mauritius": [
            "true\xa6indian,m0port louis;auritius,u0;!s,t",
            "Mauritius",
            "n"
        ],
        "Reunion": [
            "true\xa6indian,r0;e0\xe9u1;t,u0;nion",
            "R\xe9union",
            "s"
        ]
    },
    "Pacific": {
        "Apia": [
            "true\xa6apia,pacific,s2w0;est s1s0;!m,t;amoa",
            "West Samoa",
            "s"
        ],
        "Auckland": [
            "true\xa6a2christchurch,manukau,n0pacific,wellington;ew zea2orth shore,z0;!dt,l,mt,st,t;ntarctica/1uck0;land;mcmurdo,south_pole",
            "New Zealand",
            "s",
            "nz"
        ],
        "Bougainville": [
            "true\xa6bougainville,guinea2p0;a0gt;cific,pua new guinea;!n",
            "Papua New Guinea",
            "s"
        ],
        "Chatham": [
            "true\xa6cha0nz-chat,pacific;dt,st,t0;!ham0;! 0;islands,time",
            "Chatham",
            "s",
            "chat"
        ],
        "Chuuk": [
            "true\xa6chu2pacific0;!/0;truk,y2;t,uk0;!/truky0;ap",
            "Chuuk",
            "n"
        ],
        "Easter": [
            "true\xa6chile/easter4e0pacific;as0mt;st,t0;!er0;! 0;island",
            "Easter Island",
            "s",
            "east"
        ],
        "Efate": [
            "true\xa6efate,pacific,v0;anuatu,u0;!t",
            "Vanuatu",
            "n"
        ],
        "Fakaofo": [
            "true\xa6fakaofo,pacific,t0;k0okelau;!l,t",
            "Tokelau",
            "n"
        ],
        "Fiji": [
            "true\xa6f0pacific;iji,j0;!i,st,t",
            "Fiji",
            "s",
            "fiji"
        ],
        "Funafuti": [
            "true\xa6funafuti,pacific,t0;uv1v0;!t;!alu",
            "Tuvalu",
            "n"
        ],
        "Galapagos": [
            "true\xa6co1gal0pacific;apagos,t,\xe1pagos islands;lombia,st,t",
            "Colombia",
            "n"
        ],
        "Gambier": [
            "true\xa6gam0pacific;bier0t;! islands",
            "Gambier",
            "n"
        ],
        "Guadalcanal": [
            "true\xa6guadalcanal,pacific,s0;b1lb,olomon0;! islands;!t",
            "Solomon Islands",
            "n"
        ],
        "Guam": [
            "true\xa6ch5guam,m4northern mariana islands,p2west0; 0ern 0;pacific;acific0ort moresby;!/saipan;np,p;amorro,st",
            "Chamorro",
            "n"
        ],
        "Honolulu": [
            "true\xa6aleutian4h1pacific0us/hawaii;!/johnston;a0onolulu,st;dt,st,t,waii0;! aleutian;! islands",
            "Hawaii-Aleutian",
            "n"
        ],
        "Kanton": [
            "true\xa6kanton,p0;acific1ho0;enix islands,t;!/enderbury",
            "Phoenix Islands",
            "n"
        ],
        "Kiritimati": [
            "true\xa6ki1lin0pacific;e islands,t;!r0;!i0;bati,timati0;! island",
            "Line Islands",
            "n"
        ],
        "Kosrae": [
            "true\xa6kos0pacific;rae,t",
            "Kosrae",
            "n"
        ],
        "Kwajalein": [
            "true\xa6kwajalein,m0pacific;arshall islands,ht",
            "Marshall Islands",
            "n"
        ],
        "Majuro": [
            "true\xa6m0pacific;a1h0;!l,t;juro,rshall islands",
            "Marshall Islands",
            "n"
        ],
        "Marquesas": [
            "true\xa6mar0pacific;quesas0t;! islands",
            "Marquesas",
            "n"
        ],
        "Nauru": [
            "true\xa6n0pacific;auru,r0;!t,u",
            "Nauru",
            "n"
        ],
        "Niue": [
            "true\xa6n0pacific;iu1u0;!t;!e",
            "Niue",
            "n"
        ],
        "Norfolk": [
            "true\xa6n0pacific;f1orfolk0;! island;!dt,k,t",
            "Norfolk Island",
            "n",
            "aus"
        ],
        "Noumea": [
            "true\xa6n0pacific;c0ew caledonia,oumea;!l,t",
            "New Caledonia",
            "n"
        ],
        "Pago_Pago": [
            "true\xa6m5pa1s0us/sa4;a3st;cific0go_pago;!/0;m1sa0;moa;idway",
            "Samoa",
            "n"
        ],
        "Palau": [
            "true\xa6p0;a1lw,w0;!t;cific,lau",
            "Palau",
            "n"
        ],
        "Pitcairn": [
            "true\xa6p0;acific,cn,itcairn,n,st",
            "Pitcairn",
            "n"
        ],
        "Pohnpei": [
            "true\xa6french polynesia,p0;acific1f,o0yf;hnpei0nt;!/ponape",
            "Ponape",
            "n"
        ],
        "Port_Moresby": [
            "true\xa6antarctica/dumontd6dumont-d'6guinea5p0;a3g2ng,ort0; 0_0;moresby;!t;cific,pua new guinea;!n;urville",
            "Papua New Guinea",
            "s"
        ],
        "Rarotonga": [
            "true\xa6c0pacific,rarotonga;k2o0;k,ok0;! islands;!t",
            "Cook Islands",
            "n"
        ],
        "Tahiti": [
            "true\xa6pacific,society islands,tah0;iti,t",
            "Tahiti",
            "n"
        ],
        "Tarawa": [
            "true\xa6gil0pacific,tarawa;bert islands,t",
            "Gilbert Islands",
            "n"
        ],
        "Tongatapu": [
            "true\xa6nuku'alofa,pacific,to0;!n0t;!ga0;!tapu",
            "Tonga",
            "s"
        ],
        "Wake": [
            "true\xa6pacific,u2wak0;e0t;! island;m0s minor outlying islands;!i",
            "Wake Island",
            "n"
        ],
        "Wallis": [
            "true\xa6pacific,w0;allis1f0lf;!t;! 0;&0and0; futuna",
            "Wallis & Futuna",
            "n"
        ]
    }
};
// strings that don't pack properly
var misc = {
    "gmt+0": [
        "Etc/GMT"
    ],
    "gmt-0": [
        "Etc/GMT"
    ],
    gmt0: [
        "Etc/GMT"
    ],
    "etc/gmt+0": [
        "Etc/GMT"
    ],
    "etc/gmt-0": [
        "Etc/GMT"
    ],
    "etc/gmt0": [
        "Etc/GMT"
    ],
    "msk+00": [
        "Europe/Moscow"
    ],
    "msk-01 - kaliningrad": [
        "Europe/Kaliningrad"
    ],
    "msk+00 - moscow area": [
        "Europe/Moscow"
    ],
    "msk+00 - crimea": [
        "Europe/Kiev"
    ],
    "msk+00 - volgograd": [
        "Europe/Volgograd"
    ],
    "msk+00 - kirov": [
        "Europe/Kirov"
    ],
    "msk+01 - astrakhan": [
        "Europe/Astrakhan"
    ],
    "msk+01 - saratov": [
        "Europe/Saratov"
    ],
    "msk+01 - ulyanovsk": [
        "Europe/Ulyanovsk"
    ],
    "msk+01 - samaraudmurtia": [
        "Europe/Samara"
    ],
    "msk+02 - urals": [
        "Asia/Yekaterinburg"
    ],
    "msk+03": [
        "Asia/Omsk"
    ],
    "msk+04 - novosibirsk": [
        "Asia/Novosibirsk"
    ],
    "msk+04 - altai": [
        "Asia/Barnaul"
    ],
    "msk+04": [
        "Asia/Tomsk"
    ],
    "msk+04 - kemerovo": [
        "Asia/Novokuznetsk"
    ],
    "msk+04 - krasnoyarsk area": [
        "Asia/Krasnoyarsk"
    ],
    "msk+05 - irkutskburyatia": [
        "Asia/Irkutsk"
    ],
    "msk+06 - zabaykalsky": [
        "Asia/Chita"
    ],
    "msk+06 - lena river": [
        "Asia/Yakutsk"
    ],
    "msk+06 - tomponskyust-maysky": [
        "Asia/Khandyga"
    ],
    "msk+07 - amur river": [
        "Asia/Vladivostok"
    ],
    "msk+07 - oymyakonsky": [
        "Asia/Ust-Nera"
    ],
    "msk+08 - magadan": [
        "Asia/Magadan"
    ],
    "msk+08 - sakhalin island": [
        "Asia/Sakhalin"
    ],
    "msk+08 - sakha (e) north kuril is": [
        "Asia/Srednekolymsk"
    ],
    "msk+09": [
        "Asia/Kamchatka"
    ],
    "msk+09 - bering sea": [
        "Asia/Anadyr"
    ],
    "russia time zone 11": [
        "Asia/Anadyr"
    ],
    "russia time zone 10": [
        "Asia/Srednekolymsk"
    ],
    "russia time zone 3": [
        "Europe/Samara"
    ],
    "coordinated universal time-09": [
        "Pacific/Gambier"
    ],
    "utc-09": [
        "Pacific/Gambier"
    ],
    "coordinated universal time-08": [
        "Pacific/Pitcairn"
    ]
};
const addEtc = function(zones) {
    for(let i = 0; i <= 14; i += 1){
        zones[`Etc/GMT-${i}`] = {
            offset: i,
            meta: `gmt-${i}`,
            hem: "n" //sorry
        };
        zones[`Etc/GMT+${i}`] = {
            offset: i * -1,
            meta: `gmt+${i}`,
            hem: "n" //sorry
        };
    }
};
var addUTC = addEtc;
// unpack our lexicon of words
let zones = {};
let lexicon = Object.assign({}, misc);
Object.keys(pcked).forEach((top)=>{
    Object.keys(pcked[top]).forEach((name)=>{
        let [words, meta, hem, dst] = pcked[top][name];
        let id = `${top}/${name}`;
        zones[id] = {
            meta,
            hem
        };
        let keys = Object.keys(unpack$1(words));
        keys.forEach((k)=>{
            lexicon[k] = lexicon[k] || [];
            lexicon[k].push(id);
            // use iana aliases
            if (k.match(/\//)) {
                let arr = k.split(/\//);
                let last = arr[arr.length - 1].toLowerCase();
                lexicon[last] = lexicon[last] || [];
                lexicon[last].push(id);
            }
        });
        zones[id].wordCount = keys.length;
        if (dst) zones[id].dst = dstPatterns[dst].split(/\|/);
    });
});
addUTC(zones);
const unique = function(arr) {
    let obj = {};
    for(let i = 0; i < arr.length; i += 1)obj[arr[i]] = true;
    return Object.keys(obj);
};
// sort by num of aliases
Object.keys(lexicon).forEach((k)=>{
    if (lexicon[k].length > 1) {
        lexicon[k] = unique(lexicon[k]);
        lexicon[k] = lexicon[k].sort((a, b)=>{
            if (zones[a].wordCount > zones[b].wordCount) return -1;
            else if (zones[a].wordCount < zones[b].wordCount) return 1;
            return 0;
        });
    }
});
// console.log(zones['Etc/GMT+4'])
//try to match these against iana form
const one = (str)=>{
    str = str.toLowerCase();
    str = str.replace(/^in /g, "");
    str = str.replace(/ time/g, "");
    str = str.replace(/ (standard|daylight|summer)/g, "");
    str = str.replace(/ - .*/g, ""); //`Eastern Time - US & Canada`
    str = str.replace(/, .*/g, ""); //`mumbai, india`
    str = str.replace(/\./g, ""); //st. petersberg
    return str.trim();
};
//some more aggressive transformations
const two = function(str) {
    str = str.replace(/\b(east|west|north|south)ern/g, "$1");
    str = str.replace(/\b(africa|america|australia)n/g, "$1");
    str = str.replace(/\beuropean/g, "europe");
    str = str.replace(/\islands/g, "island");
    str = str.replace(/.*\//g, "");
    return str.trim();
};
// even-more agressive
const three = function(str) {
    str = str.replace(/\(.*\)/, ""); //anything in brackets
    str = str.replace(/  +/g, " "); //extra spaces
    return str.trim();
};
var normalize = {
    one,
    two,
    three
};
const isOffset = /^([-+]?[0-9]+)h(r?s)?$/i;
const isNumber = /^([-+]?[0-9]+)$/;
const utcOffset = /utc([\-+]?[0-9]+)$/i;
const gmtOffset = /gmt([\-+]?[0-9]+)$/i;
const toIana = function(num) {
    num = Number(num);
    if (num > -13 && num < 13) {
        num = num * -1; //it's opposite!
        num = (num > 0 ? "+" : "") + num; //add plus sign
        return "Etc/GMT" + num;
    }
    return null;
};
const parseOffset = function(tz) {
    // '+5hrs'
    let m = tz.match(isOffset);
    if (m !== null) return toIana(m[1]);
    // 'utc+5'
    m = tz.match(utcOffset);
    if (m !== null) return toIana(m[1]);
    // 'GMT-5' (not opposite)
    m = tz.match(gmtOffset);
    if (m !== null) {
        let num = Number(m[1]) * -1;
        return toIana(num);
    }
    // '+5'
    m = tz.match(isNumber);
    if (m !== null) return toIana(m[1]);
    return null;
};
var parseOffset$1 = parseOffset;
// match some text to an iana code
const find = function(str) {
    // perfect id match
    if (zones.hasOwnProperty(str)) return str;
    // lookup known word
    if (lexicon.hasOwnProperty(str)) return lexicon[str];
    // -8hrs
    if (/[0-9]/.test(str)) {
        let etc = parseOffset$1(str);
        if (etc) return [
            etc
        ];
    }
    // try a sequence of normalization steps
    str = normalize.one(str);
    if (lexicon.hasOwnProperty(str)) return lexicon[str];
    str = normalize.two(str);
    if (lexicon.hasOwnProperty(str)) return lexicon[str];
    str = normalize.three(str);
    if (lexicon.hasOwnProperty(str)) return lexicon[str];
    return null;
};
var find$1 = find;
var metas = {
    "India": {
        "std": [
            "IST",
            5.5
        ],
        "long": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"
    },
    "China": {
        "std": [
            "CST",
            8
        ],
        "long": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi"
    },
    "Central European": {
        "std": [
            "CET",
            1
        ],
        "dst": [
            "CEST",
            2,
            "Central European Summer Time"
        ],
        "long": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris"
    },
    "Atlantic": {
        "dupe": true,
        "std": [
            "AST",
            -4
        ],
        "dst": [
            "ADT",
            -3
        ],
        "long": "(UTC-04:00) Atlantic Time (Canada)"
    },
    "Greenwich Mean": {
        "std": [
            "GMT",
            0
        ],
        "long": "(UTC) Coordinated Universal Time"
    },
    "Eastern European": {
        "std": [
            "EET",
            2
        ],
        "dst": [
            "EEST",
            3,
            "Eastern European Summer Time"
        ]
    },
    "Central": {
        "dupe": true,
        "std": [
            "CST",
            -6
        ],
        "dst": [
            "CDT",
            -5
        ],
        "long": "(UTC-06:00) Central Time (US & Canada)"
    },
    "Eastern": {
        "std": [
            "EST",
            -5
        ],
        "dst": [
            "EDT",
            -4
        ],
        "long": "(UTC-05:00) Eastern Time (US & Canada)"
    },
    "Argentina": {
        "std": [
            "ART",
            -3
        ],
        "long": "(UTC-03:00) City of Buenos Aires"
    },
    "East Africa": {
        "std": [
            "EAT",
            3
        ],
        "long": "(UTC+03:00) Nairobi"
    },
    "West Africa": {
        "std": [
            "WAT",
            1
        ],
        "long": "(UTC+01:00) West Central Africa"
    },
    "Moscow": {
        "std": [
            "MSK",
            3
        ],
        "long": "(UTC+03:00) Moscow, St. Petersburg"
    },
    "Brasilia": {
        "std": [
            "BRT",
            -3
        ],
        "long": "(UTC-03:00) Brasilia"
    },
    "Mountain": {
        "std": [
            "MST",
            -7
        ],
        "dst": [
            "MDT",
            -6
        ],
        "long": "(UTC-07:00) Mountain Time (US & Canada)"
    },
    "Central Africa": {
        "std": [
            "CAT",
            2
        ],
        "long": "(UTC+02:00) Windhoek"
    },
    "Arabian": {
        "std": [
            "AST",
            3
        ],
        "long": "(UTC+03:00) Kuwait, Riyadh"
    },
    "Alaska": {
        "std": [
            "AKST",
            -9
        ],
        "dst": [
            "AKDT",
            -8
        ],
        "long": "(UTC-09:00) Alaska"
    },
    "British": {
        "std": [
            "GMT",
            0
        ],
        "dst": [
            "BST",
            1,
            "British Summer Time"
        ],
        "long": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London"
    },
    "Irish": {
        "std": [
            "GMT",
            0
        ],
        "dst": [
            "IST",
            1,
            "Irish Standard Time"
        ]
    },
    "West Kazakhstan": {
        "std": [
            "ALMT",
            5
        ],
        "long": "(UTC+05:00) Ashgabat, Tashkent"
    },
    "Eastern Australia": {
        "std": [
            "AEST",
            10
        ],
        "dst": [
            "AEDT",
            11,
            "Australian Eastern Daylight Time"
        ],
        "long": "(UTC+10:00) Canberra, Melbourne, Sydney"
    },
    "Western European": {
        "std": [
            "WET",
            0
        ],
        "dst": [
            "WEST",
            1,
            "Western European Summer Time"
        ]
    },
    "Indochina": {
        "std": [
            "ICT",
            7
        ],
        "long": "(UTC+07:00) Bangkok, Hanoi, Jakarta"
    },
    "Central Mexico": {
        "long": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
        "std": [
            "CST",
            -6
        ],
        "dst": [
            "CDT",
            -5,
            "Central Daylight Time"
        ]
    },
    "South Africa": {
        "std": [
            "SAST",
            2
        ],
        "long": "(UTC+02:00) Harare, Pretoria"
    },
    "Krasnoyarsk": {
        "std": [
            "KRAT",
            7
        ],
        "long": "(UTC+07:00) Krasnoyarsk"
    },
    "Yakutsk": {
        "std": [
            "YAKT",
            9
        ],
        "long": "(UTC+09:00) Yakutsk"
    },
    "Pacific": {
        "std": [
            "PST",
            -8
        ],
        "dst": [
            "PDT",
            -7
        ],
        "long": "(UTC-08:00) Pacific Time (US & Canada)"
    },
    "Amazon": {
        "std": [
            "AMT",
            -4
        ],
        "long": "(UTC-04:00) Cuiaba"
    },
    "Morocco Standard": {
        "offset": 1,
        "long": "(UTC+00:00) Casablanca",
        "std": [
            "WET",
            1
        ],
        "dst": [
            "WEST",
            0,
            "Western European Summer Time"
        ]
    },
    "Gulf": {
        "std": [
            "GST",
            4
        ],
        "long": "(UTC+04:00) Abu Dhabi, Muscat"
    },
    "Samara": {
        "std": [
            "SAMT",
            4
        ],
        "long": "(UTC+04:00) Izhevsk, Samara"
    },
    "Uzbekistan": {
        "std": [
            "UZT",
            5
        ]
    },
    "East Kazakhstan": {
        "std": [
            "ALMT",
            6
        ],
        "long": "(UTC+06:00) Astana"
    },
    "Omsk": {
        "std": [
            "OMST",
            6
        ],
        "long": "(UTC+06:00) Omsk"
    },
    "Western Indonesia": {
        "std": [
            "WIB",
            7
        ]
    },
    "Ulaanbaatar": {
        "std": [
            "ULAT",
            8
        ],
        "long": "(UTC+08:00) Ulaanbaatar"
    },
    "Malaysia": {
        "std": [
            "MYT",
            8
        ]
    },
    "Korean": {
        "std": [
            "KST",
            9
        ],
        "long": "(UTC+09:00) Seoul"
    },
    "Central Australia": {
        "std": [
            "ACST",
            9.5
        ],
        "dst": [
            "ACDT",
            10.5,
            "Australian Central Daylight Time"
        ],
        "long": "(UTC+09:30) Adelaide"
    },
    "Brisbane": {
        "dupe": true,
        "std": [
            "AEST",
            10
        ]
    },
    "Vladivostok": {
        "std": [
            "VLAT",
            10
        ],
        "long": "(UTC+10:00) Vladivostok"
    },
    "Chamorro": {
        "std": [
            "ChST",
            10
        ],
        "long": "(UTC+10:00) Guam, Port Moresby"
    },
    "Papua New Guinea": {
        "std": [
            "PGT",
            11
        ]
    },
    "New Zealand": {
        "std": [
            "NZST",
            12
        ],
        "dst": [
            "NZDT",
            13
        ],
        "long": "(UTC+12:00) Auckland, Wellington"
    },
    "Marshall Islands": {
        "std": [
            "MHT",
            12
        ]
    },
    "Samoa": {
        "std": [
            "SST",
            -11
        ],
        "long": "(UTC+13:00) Samoa"
    },
    "Hawaii-Aleutian": {
        "std": [
            "HAST",
            -9
        ],
        "dst": [
            "HADT",
            -8
        ],
        "long": "(UTC-09:00) Aleutian Islands"
    },
    "Mexican Pacific": {
        "std": [
            "HNPMX",
            -7
        ],
        "dst": [
            "HEPMX",
            -6
        ],
        "long": "(UTC-07:00) Chihuahua, La Paz, Mazatlan"
    },
    "Colombia": {
        "std": [
            "COT",
            -5
        ]
    },
    "Acre": {
        "std": [
            "ACT",
            -5
        ]
    },
    "Chile": {
        "dupe": true,
        "std": [
            "CLT",
            -3
        ],
        "dst": [
            "CLST",
            -4,
            "Chile Summer Time"
        ]
    },
    "Troll": {
        "dupe": true,
        "std": [
            "GMT",
            0
        ]
    },
    "East Greenland": {
        "std": [
            "HNEG",
            0
        ],
        "dst": [
            "HEEG",
            1,
            "East Greenland Summer Time"
        ]
    },
    "Israel": {
        "std": [
            "IST",
            2
        ],
        "dst": [
            "IDT",
            3
        ],
        "long": "(UTC+02:00) Jerusalem"
    },
    "Syowa": {
        "std": [
            "SYOT",
            3
        ]
    },
    "Turkey": {
        "std": [
            "TRT",
            3
        ],
        "long": "(UTC+03:00) Istanbul"
    },
    "Iran": {
        "std": [
            "IRST",
            3.5
        ],
        "dst": [
            "IRDT",
            4.5
        ],
        "long": "(UTC+03:30) Tehran"
    },
    "Azerbaijan": {
        "std": [
            "AZT",
            4
        ],
        "long": "(UTC+04:00) Baku"
    },
    "Georgia": {
        "std": [
            "GET",
            4
        ],
        "long": "(UTC+04:00) Tbilisi"
    },
    "Armenia": {
        "std": [
            "AMT",
            4
        ],
        "long": "(UTC+04:00) Yerevan"
    },
    "Seychelles": {
        "std": [
            "SCT",
            4
        ]
    },
    "Mauritius": {
        "std": [
            "MUT",
            4
        ],
        "long": "(UTC+04:00) Port Louis"
    },
    "R\xe9union": {
        "std": [
            "RET",
            4
        ]
    },
    "Afghanistan": {
        "std": [
            "AFT",
            4.5
        ],
        "long": "(UTC+04:30) Kabul"
    },
    "Mawson": {
        "std": [
            "MAWT",
            5
        ]
    },
    "Turkmenistan": {
        "std": [
            "TMT",
            5
        ]
    },
    "Tajikistan": {
        "std": [
            "TJT",
            5
        ]
    },
    "Pakistan": {
        "std": [
            "PKT",
            5
        ],
        "long": "(UTC+05:00) Islamabad, Karachi"
    },
    "Yekaterinburg": {
        "std": [
            "YEKT",
            5
        ],
        "long": "(UTC+05:00) Ekaterinburg"
    },
    "French Southern & Antarctic": {
        "std": [
            "TFT",
            5
        ]
    },
    "Maldives": {
        "std": [
            "MVT",
            5
        ]
    },
    "Nepal": {
        "std": [
            "NPT",
            5.75
        ],
        "long": "(UTC+05:45) Kathmandu"
    },
    "Vostok": {
        "std": [
            "MSK+4",
            6
        ]
    },
    "Kyrgyzstan": {
        "std": [
            "KGT",
            6
        ]
    },
    "Bangladesh": {
        "std": [
            "BST",
            6
        ],
        "long": "(UTC+06:00) Dhaka"
    },
    "Bhutan": {
        "std": [
            "BT",
            6
        ]
    },
    "Indian Ocean": {
        "std": [
            "IOT",
            6
        ]
    },
    "Myanmar": {
        "std": [
            "MMT",
            6.5
        ],
        "long": "(UTC+06:30) Yangon (Rangoon)"
    },
    "Cocos Islands": {
        "std": [
            "CCT",
            6.5
        ]
    },
    "Davis": {
        "std": [
            "DAVT",
            7
        ]
    },
    "Hovd": {
        "std": [
            "HOVT",
            7
        ],
        "long": "(UTC+07:00) Hovd"
    },
    "Novosibirsk": {
        "std": [
            "NOVT",
            7
        ],
        "long": "(UTC+07:00) Novosibirsk"
    },
    "Christmas Island": {
        "std": [
            "CXT",
            7
        ]
    },
    "Brunei Darussalam": {
        "std": [
            "BNT",
            8
        ]
    },
    "Hong Kong": {
        "std": [
            "HKT",
            8
        ]
    },
    "Irkutsk": {
        "std": [
            "IRKT",
            8
        ],
        "long": "(UTC+08:00) Irkutsk"
    },
    "Central Indonesia": {
        "std": [
            "WITA",
            8
        ]
    },
    "Philippine": {
        "std": [
            "PHST",
            8
        ]
    },
    "Singapore": {
        "std": [
            "SGT",
            8
        ],
        "long": "(UTC+08:00) Kuala Lumpur, Singapore"
    },
    "Taipei": {
        "std": [
            "CST",
            8
        ],
        "long": "(UTC+08:00) Taipei"
    },
    "Western Australia": {
        "std": [
            "AWST",
            8
        ],
        "long": "(UTC+08:00) Perth"
    },
    "Australian Central Western": {
        "std": [
            "ACWST",
            8.75
        ],
        "long": "(UTC+08:45) Eucla"
    },
    "East Timor": {
        "std": [
            "TLT",
            9
        ]
    },
    "Eastern Indonesia": {
        "std": [
            "WIT",
            9
        ]
    },
    "Japan": {
        "std": [
            "JST",
            9
        ],
        "long": "(UTC+09:00) Osaka, Sapporo, Tokyo"
    },
    "Palau": {
        "std": [
            "PWT",
            9
        ]
    },
    "Australian Central": {
        "dupe": true,
        "std": [
            "ACST",
            9.5
        ]
    },
    "Dumont-d\u2019Urville": {
        "std": [
            "CLST",
            10
        ]
    },
    "Chuuk": {
        "std": [
            "CHUT",
            10
        ]
    },
    "Lord Howe": {
        "std": [
            "LHST",
            10.5
        ],
        "dst": [
            "LHDT",
            11.5
        ],
        "long": "(UTC+10:30) Lord Howe Island"
    },
    "Casey": {
        "std": [
            "CAST",
            11
        ],
        "dst": [
            "CAST",
            8,
            "Casey Summer Time"
        ]
    },
    "Magadan": {
        "std": [
            "MAGT",
            11
        ],
        "long": "(UTC+11:00) Magadan"
    },
    "Sakhalin": {
        "std": [
            "SAKT",
            11
        ],
        "long": "(UTC+11:00) Sakhalin"
    },
    "Srednekolymsk": {
        "std": [
            "SRET",
            11
        ],
        "long": "(UTC+11:00) Chokurdakh"
    },
    "Vanuatu": {
        "std": [
            "VUT",
            11
        ]
    },
    "Solomon Islands": {
        "std": [
            "SBT",
            11
        ]
    },
    "Kosrae": {
        "std": [
            "KOST",
            11
        ]
    },
    "New Caledonia": {
        "std": [
            "NCT",
            11
        ]
    },
    "Ponape": {
        "std": [
            "PONT",
            11
        ]
    },
    "Anadyr": {
        "std": [
            "ANAT",
            12
        ],
        "long": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky"
    },
    "Petropavlovsk-Kamchatski": {
        "std": [
            "PETT",
            12
        ],
        "long": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky"
    },
    "Fiji": {
        "std": [
            "FJT",
            12
        ],
        "dst": [
            "FJT",
            13,
            "Fiji Summer Time"
        ],
        "long": "(UTC+12:00) Fiji"
    },
    "Tuvalu": {
        "std": [
            "TVT",
            12
        ]
    },
    "Nauru": {
        "std": [
            "NRT",
            12
        ]
    },
    "Norfolk Island": {
        "std": [
            "NFT",
            12
        ],
        "dst": [
            "NFDT",
            11
        ],
        "long": "(UTC+11:00) Norfolk Island"
    },
    "Gilbert Islands": {
        "std": [
            "GILT",
            12
        ]
    },
    "Wake Island": {
        "std": [
            "WAKT",
            12
        ]
    },
    "Wallis & Futuna": {
        "std": [
            "WFT",
            12
        ]
    },
    "Chatham": {
        "std": [
            "CHAST",
            12.75
        ],
        "dst": [
            "CHADT",
            13.75
        ],
        "long": "(UTC+12:45) Chatham Islands"
    },
    "West Samoa": {
        "std": [
            "WST",
            13
        ],
        "dst": [
            "WST",
            14,
            "West Samoa Summer Time"
        ]
    },
    "Phoenix Islands": {
        "std": [
            "PHOT",
            13
        ]
    },
    "Tokelau": {
        "std": [
            "TKT",
            13
        ]
    },
    "Tonga": {
        "std": [
            "TOT",
            13
        ],
        "long": "(UTC+13:00) Nuku'alofa"
    },
    "Line Islands": {
        "std": [
            "LINT",
            14
        ],
        "long": "(UTC+14:00) Kiritimati Island"
    },
    "Niue": {
        "std": [
            "NUT",
            -11
        ]
    },
    "Cook Islands": {
        "std": [
            "CKT",
            -10
        ]
    },
    "Tahiti": {
        "std": [
            "TAHT",
            -10
        ]
    },
    "Marquesas": {
        "std": [
            "MART",
            -9.5
        ],
        "long": "(UTC-09:30) Marquesas Islands"
    },
    "Aleutian Standard": {
        "iso": "(UTC-10:00) Aleutian Islands",
        "std": [
            "HST",
            -10
        ],
        "dst": [
            "HDT",
            -9,
            "Hawaii Daylight Time"
        ]
    },
    "Gambier": {
        "std": [
            "GAMT",
            -9
        ],
        "long": "(UTC-09:00) Coordinated Universal Time-09"
    },
    "Pitcairn": {
        "std": [
            "PST",
            -8
        ],
        "long": "(UTC-08:00) Coordinated Universal Time-08"
    },
    "Northwest Mexico": {
        "std": [
            "HNNOMX",
            -6
        ],
        "dst": [
            "HENOMX",
            -5
        ],
        "long": "(UTC-08:00) Baja California"
    },
    "Easter Island": {
        "std": [
            "EAST",
            -6
        ],
        "dst": [
            "EASST",
            -5,
            "Easter Island Summer Time"
        ],
        "long": "(UTC-06:00) Easter Island"
    },
    "Ecuador": {
        "std": [
            "ECT",
            -5
        ]
    },
    "Cuba": {
        "std": [
            "HNCU",
            -5
        ],
        "dst": [
            "HECU",
            -4
        ],
        "long": "(UTC-05:00) Havana"
    },
    "Peru": {
        "std": [
            "PET",
            -5
        ]
    },
    "Paraguay": {
        "std": [
            "PYT",
            -4
        ],
        "dst": [
            "PYST",
            -3,
            "Paraguay Summer Time"
        ],
        "long": "(UTC-04:00) Asuncion"
    },
    "Venezuela": {
        "std": [
            "VET",
            -4
        ],
        "long": "(UTC-04:00) Caracas"
    },
    "Guyana": {
        "std": [
            "GYT",
            -4
        ]
    },
    "Bolivia": {
        "std": [
            "BOT",
            -4
        ]
    },
    "Newfoundland": {
        "std": [
            "HNTN",
            -3.5
        ],
        "dst": [
            "HETN",
            -2.5
        ],
        "long": "(UTC-03:30) Newfoundland"
    },
    "French Guiana": {
        "std": [
            "GFT",
            -3
        ]
    },
    "West Greenland": {
        "std": [
            "WGT",
            -3
        ],
        "dst": [
            "WGST",
            -2,
            "West Greenland Summer Time"
        ],
        "long": "(UTC-03:00) Greenland"
    },
    "St. Pierre & Miquelon": {
        "std": [
            "HNPM",
            -3
        ],
        "dst": [
            "HEPM",
            -2
        ],
        "long": "(UTC-03:00) Saint Pierre and Miquelon"
    },
    "Uruguay": {
        "std": [
            "UYT",
            -3
        ],
        "long": "(UTC-03:00) Montevideo"
    },
    "Suriname": {
        "std": [
            "SRT",
            -3
        ]
    },
    "Falkland Islands": {
        "std": [
            "FKST",
            -3
        ]
    },
    "Fernando de Noronha": {
        "std": [
            "FNT",
            -2
        ]
    },
    "South Georgia": {
        "std": [
            "GST",
            -2
        ]
    },
    "Azores": {
        "std": [
            "AZOT",
            -1
        ],
        "dst": [
            "AZOST",
            0,
            "Azores Summer Time"
        ],
        "long": "(UTC-01:00) Azores"
    },
    "Cape Verde": {
        "std": [
            "CVT",
            -1
        ],
        "long": "(UTC-01:00) Cabo Verde Is."
    }
};
// const metas = require('../../data/05-metazones')
// import offsets from './offsets.js'
for(let i = 0; i <= 14; i += 1){
    metas[`gmt-${i}`] = {
        name: `Etc/GMT-${i}`,
        std: [
            `GMT-${i}`,
            i
        ],
        long: `(UTC-${i}:00) Coordinated Universal Time`
    };
    metas[`gmt+${i}`] = {
        name: `Etc/GMT+${i}`,
        std: [
            `GMT+${i}`,
            -i
        ],
        long: `(UTC+${i}:00) Coordinated Universal Time`
    };
}
const display = function(id) {
    if (!id) return null;
    if (!zones[id]) {
        console.error(`missing id ${id}`);
        return null;
    }
    let metaName = zones[id].meta;
    if (!metas[metaName]) console.error(`missing tz-meta ${metaName}`);
    let meta = metas[metaName] || {};
    let dst = null;
    if (zones[id].dst && meta.dst) {
        let [abbr, offset, name] = meta.dst;
        name = name || `${metaName} Daylight Time`;
        let [start, end] = zones[id].dst || [];
        dst = {
            abbr,
            offset,
            name,
            start,
            end
        };
    }
    let [abbr, offset] = meta.std;
    let name = meta.name || `${metaName} Time`;
    let long = meta.long || `(UTC+${offset}:00) ${name}`;
    return {
        name: name,
        iana: id,
        standard: {
            abbr,
            offset,
            name: meta.name || `${metaName} Standard Time`
        },
        daylight: dst || null,
        long: long
    };
};
var display$1 = display;
var version = "1.5.1";
const soft = function(str) {
    let ids = find$1(str) || [];
    if (typeof ids === "string") ids = [
        ids
    ];
    ids = ids.map((id)=>display$1(id));
    return ids;
};
soft.prototype.version = version;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g3CCE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditAssetCCDisplay", ()=>EditAssetCCDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
const EditAssetCCDisplay = ({ commandAndControl, handleCCToggle })=>{
    const { primary_alert } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const { commandControlIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-492060206 p-0 mt-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        className: "jsx-492060206",
                        children: [
                            "Command and Control",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-492060206",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: commandControlIcon,
                                    alt: "command-and-control-icon",
                                    className: "jsx-492060206 command-and-control-icon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-492060206 w-100 d-flex mt-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-492060206 flex-grow-1 d-flex align-items-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                    onChange: handleCCToggle,
                                    checked: commandAndControl,
                                    checkedIcon: false,
                                    uncheckedIcon: false,
                                    height: 10,
                                    width: 20,
                                    onColor: primary_alert
                                }),
                                commandAndControl === true ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-492060206 font-weight-light text-muted ml-2 small",
                                    children: "Sending remote commands enabled"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-492060206 font-weight-light text-muted ml-2 small",
                                    children: "Sending remote commands disabled"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "492060206",
                children: ".command-and-control-icon.jsx-492060206{max-height:20px;margin-right:5px;margin-bottom:5px;}"
            })
        ]
    });
};
EditAssetCCDisplay.propTypes = {
    commandAndControl: (0, _propTypesDefault.default).bool,
    handleCCToggle: (0, _propTypesDefault.default).func
};
EditAssetCCDisplay.defaultProps = {
    commandAndControl: false,
    handleCCToggle: ()=>{}
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-switch":"7hX7V","../../Context/BrandingContext":"bKKTd","../../Context/IconsContext":"lzIpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2dJFH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssetAdvancedInfo", ()=>AssetAdvancedInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
const AssetAdvancedInfo = ({ stwWiFiControl, stwWiFiEnabled, WiFissid, WiFipassword, handlePropUpdateSimple, visibility, vendor })=>{
    const { primary_alert } = (0, _react.useContext)((0, _brandingContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3208245227 " + `${visibility} flex-grow-1 row text-muted`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3208245227 col-12",
                children: vendor === "1" ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-3208245227 form-group form-control-sm text-muted mb-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                    onChange: (e)=>handlePropUpdateSimple({
                                            target: {
                                                name: "stwWiFiControl",
                                                value: e
                                            }
                                        }),
                                    checked: stwWiFiControl,
                                    checkedIcon: false,
                                    uncheckedIcon: false,
                                    height: 15,
                                    width: 30,
                                    onColor: primary_alert,
                                    id: "stwWiFiControl-toggle"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "stwWiFiControl-toggle",
                                    className: "jsx-3208245227 text-muted ml-2",
                                    children: "Enable STW Wi-Fi Control"
                                })
                            ]
                        }),
                        stwWiFiControl ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-3208245227 form-group form-control-sm text-muted mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                            onChange: (e)=>handlePropUpdateSimple({
                                                    target: {
                                                        name: "stwWiFiEnabled",
                                                        value: e
                                                    }
                                                }),
                                            checked: stwWiFiEnabled,
                                            checkedIcon: false,
                                            uncheckedIcon: false,
                                            height: 15,
                                            width: 30,
                                            onColor: primary_alert,
                                            id: "stwWiFiEnabled-toggle"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "stwWiFiEnabled-toggle",
                                            className: "jsx-3208245227 text-muted ml-2",
                                            children: "STW Wi-Fi On/Off"
                                        })
                                    ]
                                }),
                                stwWiFiEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "jsx-3208245227 form-group text-muted",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    htmlFor: "WiFissid",
                                                    className: "jsx-3208245227 three-quarter-text",
                                                    children: "Wi-Fi Access Point SSID"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    name: "WiFissid",
                                                    type: "text",
                                                    onChange: handlePropUpdateSimple,
                                                    value: WiFissid,
                                                    className: "jsx-3208245227 " + `form-control form-control-sm`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "jsx-3208245227 form-group text-muted",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    htmlFor: "WiFipassword",
                                                    className: "jsx-3208245227 three-quarter-text",
                                                    children: "Wi-Fi Password"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    name: "WiFipassword",
                                                    type: "text",
                                                    onChange: handlePropUpdateSimple,
                                                    value: WiFipassword,
                                                    className: "jsx-3208245227 " + `form-control form-control-sm`
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3208245227",
                children: ".form-control.jsx-3208245227:focus{box-shadow:none;}input.jsx-3208245227{color:var(--black-text);}input.jsx-3208245227::-webkit-input-placeholder{color:var(--icon-link-gray);font-size:0.9rem;}input.jsx-3208245227::-moz-placeholder{color:var(--icon-link-gray);font-size:0.9rem;}input.jsx-3208245227:-ms-input-placeholder{color:var(--icon-link-gray);font-size:0.9rem;}input.jsx-3208245227::placeholder{color:var(--icon-link-gray);font-size:0.9rem;}.template-select.jsx-3208245227{margin-bottom:10rem;}"
            })
        ]
    });
};
AssetAdvancedInfo.propTypes = {
    stwWiFiControl: (0, _propTypesDefault.default).bool,
    stwWiFiEnabled: (0, _propTypesDefault.default).bool,
    WiFissid: (0, _propTypesDefault.default).string,
    WiFipassword: (0, _propTypesDefault.default).string,
    handlePropUpdateSimple: (0, _propTypesDefault.default).func,
    visibility: (0, _propTypesDefault.default).string,
    vendor: (0, _propTypesDefault.default).string
};
AssetAdvancedInfo.defaultProps = {
    handleTimezoneToggle: ()=>null
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-switch":"7hX7V","../../Context/BrandingContext":"bKKTd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfw25":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _tagService = require("../../Services/TagService");
var _tagServiceDefault = parcelHelpers.interopDefault(_tagService);
var _assetTagDisplay = require("./AssetTagDisplay");
var _assetTagDisplayDefault = parcelHelpers.interopDefault(_assetTagDisplay);
class AssetTagContainer extends (0, _react.Component) {
    static propTypes = {
        updateTags: (0, _propTypesDefault.default).func,
        asset: (0, _propTypesDefault.default).object,
        visibility: (0, _propTypesDefault.default).string
    };
    static defaultProps = {
        asset: {}
    };
    state = {
        createTagRequestPending: false,
        nameSuggestions: [
            {
                value: "",
                label: ""
            }
        ],
        deleteTagRequestPending: "",
        dropdownLoading: false,
        tags: [],
        error: "",
        tagName: {},
        tagValue: ""
    };
    tagService = new (0, _tagServiceDefault.default)();
    source = (0, _axios.CancelToken).source();
    componentDidMount() {
        if (this.props.asset.tags) this.setState({
            tags: this.props.asset.tags
        });
    }
    componentWillUnmount() {
        this.source.cancel();
    }
    handleSubmit = async (e)=>{
        e.preventDefault();
        if (this.state.tags.length >= 20) return;
        this.setState({
            createTagRequestPending: true
        });
        try {
            const newTag = await this.tagService.createNewTag(this.props.asset._id, this.props.asset.orgID, {
                name: this.state.tagName.label,
                value: this.state.tagValue
            }, this.source.token);
            const tags = [
                ...this.state.tags,
                newTag
            ];
            this.setState({
                tags,
                createTagRequestPending: false
            });
            this.props.updateTags && this.props.updateTags(tags);
            this.setState({
                tagName: {},
                tagValue: "",
                nameSuggestions: [
                    {
                        value: "",
                        label: ""
                    }
                ]
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            this.setState({
                error,
                createTagRequestPending: false
            });
        }
    };
    handleDelete = async (tagID)=>{
        this.setState({
            deleteTagRequestPending: tagID
        });
        try {
            await this.tagService.deleteTag(this.props.asset._id, tagID, this.props.asset.orgID, this.source.token);
            const tags = this.state.tags.filter(({ _id })=>_id !== tagID);
            this.setState({
                tags,
                deleteTagRequestPending: ""
            });
            this.props.updateTags(tags);
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            this.setState({
                error,
                deleteTagRequestPending: ""
            });
        }
    };
    suggestNames = async (nameSearch)=>{
        this.setState({
            dropdownLoading: true
        });
        try {
            const response = await this.tagService.getTagNames(this.props.asset.orgID, nameSearch, this.source.token);
            const currentTags = response.map(({ name })=>name);
            const nameSuggestions = Array.from(new Set(currentTags)).map((label)=>({
                    label
                }));
            this.setState({
                nameSuggestions,
                dropdownLoading: false
            });
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            this.setState({
                error,
                dropdownLoading: false
            });
        }
    };
    handleChange = (e)=>{
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    };
    handleNameInput = (input)=>{
        if (this.timeout) window.clearTimeout(this.timeout);
        if (input.length < 2) return;
        this.timeout = setTimeout(()=>{
            this.suggestNames(input);
        }, 500);
    };
    handleNameSelect = (tagName = {})=>{
        this.setState({
            tagName
        });
    };
    handleBlur = (e)=>{
        const { value } = e.target;
        if (!value.length) return;
        this.setState({
            tagName: {
                label: value,
                value
            }
        });
    };
    render() {
        const { createTagRequestPending, dropdownLoading, nameSuggestions, deleteTagRequestPending, tagName, tagValue, tags } = this.state;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetTagDisplayDefault.default), {
            visibility: this.props.visibility,
            tags: tags,
            handleChange: this.handleChange,
            handleSubmit: this.handleSubmit,
            handleDelete: this.handleDelete,
            createTagRequestPending: createTagRequestPending,
            dropdownLoading: dropdownLoading,
            nameSuggestions: nameSuggestions,
            handleNameSelect: this.handleNameSelect,
            handleNameInput: this.handleNameInput,
            handleBlur: this.handleBlur,
            deleteTagRequestPending: deleteTagRequestPending,
            tagName: tagName,
            tagValue: tagValue
        });
    }
}
exports.default = AssetTagContainer;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/TagService":"6HtCg","./AssetTagDisplay":"4XKZ4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XKZ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssetTagDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _assetTag = require("./AssetTag");
var _assetTagDefault = parcelHelpers.interopDefault(_assetTag);
var _trackerClasses = require("../../Constants/TrackerClasses");
const selectStyles = {
    dropdownIndicator: ()=>({
            display: "none"
        }),
    indicatorSeparator: ()=>({
            display: "none"
        })
};
function AssetTagDisplay(props) {
    const { createTagRequestPending, nameSuggestions, deleteTagRequestPending, dropdownLoading, tagName, tagValue, handleSubmit, handleDelete, handleChange, handleNameInput, handleNameSelect, handleBlur, visibility, tags } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-458136558 " + (visibility || ""),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-458136558 " + `d-flex justify-content-center inner-modal-container mh-75`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-458136558 row",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-458136558 col-12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                                onSubmit: handleSubmit,
                                className: "jsx-458136558",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-458136558 row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-458136558 col-12 col-sm-5 d-flex",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "jsx-458136558 form-group w-100",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        name: "tagName",
                                                        htmlFor: "tag-name-input",
                                                        className: "jsx-458136558 text-muted form-labels modal-inputlabel-text",
                                                        children: "Tag Name (i.e. Location)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
                                                        styles: selectStyles,
                                                        className: "align-baseline w-100",
                                                        name: "tagName",
                                                        value: tagName,
                                                        id: "tag-name-input",
                                                        options: nameSuggestions,
                                                        onInputChange: handleNameInput,
                                                        onChange: handleNameSelect,
                                                        isLoading: dropdownLoading,
                                                        onBlur: handleBlur,
                                                        placeholder: null,
                                                        isClearable: true,
                                                        isSearchable: true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-458136558 col-12 col-sm-5 d-flex",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "jsx-458136558 form-group w-100",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        name: "tagValue",
                                                        htmlFor: "tag-value-input",
                                                        className: "jsx-458136558 text-muted form-labels modal-inputlabel-text",
                                                        children: "Tag Value (i.e. Seattle)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        name: "tagValue",
                                                        value: tagValue,
                                                        type: "text",
                                                        id: "tag-value-input",
                                                        "aria-describedby": "nameHelpBlock",
                                                        onChange: handleChange,
                                                        className: "jsx-458136558 form-control align-baseline"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-458136558 col-12 col-sm-2 d-flex align-items-center",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                name: "addButton",
                                                type: "submit",
                                                disabled: tags.length >= 20 || createTagRequestPending,
                                                className: "jsx-458136558 " + `btn modal-button-submit align-baseline text-nowrap ${0, _trackerClasses.TAG_CREATE_EVENT}`,
                                                children: createTagRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                    spin: true,
                                                    size: "lg"
                                                }) : "+"
                                            })
                                        })
                                    ]
                                })
                            }),
                            tags.length >= 20 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-458136558 text-info three-quarter-text mt-3 mt-md-0",
                                children: "You've reached the maximum number of tags allowed per asset"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "jsx-458136558 text-muted three-quarter-text mt-3 mt-md-0",
                                children: "Add up to 20 tags for every asset"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-458136558 col-12 bg-background-gray px-0 w-100 overflow-auto tag-display-box",
                                children: tags.map((tag)=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "jsx-458136558",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assetTagDefault.default), {
                                            tagName: tag.name,
                                            tagValue: tag.value,
                                            tagID: tag._id,
                                            deleteTagRequestPending: deleteTagRequestPending,
                                            handleDelete: handleDelete,
                                            hideDeleteButton: false
                                        })
                                    }, tag._id);
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "458136558",
                children: ".tag-display-box.jsx-458136558{border-radius:6px;min-height:200px;}"
            })
        ]
    });
}
AssetTagDisplay.propTypes = {
    handleChange: (0, _propTypesDefault.default).func,
    handleDelete: (0, _propTypesDefault.default).func,
    handleNameInput: (0, _propTypesDefault.default).func,
    handleBlur: (0, _propTypesDefault.default).func,
    handleSubmit: (0, _propTypesDefault.default).func,
    handleNameSelect: (0, _propTypesDefault.default).func,
    nameSuggestions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    visibility: (0, _propTypesDefault.default).string,
    tags: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    createTagRequestPending: (0, _propTypesDefault.default).bool,
    deleteTagRequestPending: (0, _propTypesDefault.default).string,
    dropdownLoading: (0, _propTypesDefault.default).bool,
    tagName: (0, _propTypesDefault.default).shape({
        label: (0, _propTypesDefault.default).string,
        value: (0, _propTypesDefault.default).string
    }),
    tagValue: (0, _propTypesDefault.default).string
};
AssetTagDisplay.defaultProps = {
    tags: []
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-select/creatable":"hUPxg","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","./AssetTag":"jTrGQ","../../Constants/TrackerClasses":"1AdWb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hUPxg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreatable", ()=>(0, _useCreatableD97Ef2C9EsmJs.u));
parcelHelpers.export(exports, "default", ()=>CreatableSelect$1);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _select49A62830EsmJs = require("../../dist/Select-49a62830.esm.js");
var _useStateManager7E1E8489EsmJs = require("../../dist/useStateManager-7e1e8489.esm.js");
var _useCreatableD97Ef2C9EsmJs = require("../../dist/useCreatable-d97ef2c9.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _indexA301F526EsmJs = require("../../dist/index-a301f526.esm.js");
var _react1 = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _memoizeOne = require("memoize-one");
var CreatableSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var creatableProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    var selectProps = (0, _useCreatableD97Ef2C9EsmJs.u)(creatableProps);
    return /*#__PURE__*/ _react.createElement((0, _select49A62830EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../../dist/Select-49a62830.esm.js":"dKKB5","../../dist/useStateManager-7e1e8489.esm.js":"DxpkG","../../dist/useCreatable-d97ef2c9.esm.js":"41KcV","@babel/runtime/helpers/objectSpread2":"TY7Mr","@babel/runtime/helpers/classCallCheck":"6C9u8","@babel/runtime/helpers/createClass":"g9J5L","@babel/runtime/helpers/inherits":"43peb","@babel/runtime/helpers/createSuper":"ayUOk","@babel/runtime/helpers/toConsumableArray":"c2UGM","../../dist/index-a301f526.esm.js":"gYAEP","@emotion/react":"2WHWE","@babel/runtime/helpers/slicedToArray":"cSV7V","@babel/runtime/helpers/objectWithoutProperties":"5xa1i","@babel/runtime/helpers/typeof":"979to","@babel/runtime/helpers/taggedTemplateLiteral":"cpSDa","@babel/runtime/helpers/defineProperty":"hjdoh","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","memoize-one":"jucOx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"41KcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useCreatable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _select49A62830EsmJs = require("./Select-49a62830.esm.js");
var _excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return 'Create "'.concat(inputValue, '"');
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function useCreatable(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, _select49A62830EsmJs.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, _select49A62830EsmJs.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, _react.useMemo)(function() {
        return isValidNewOption(inputValue, (0, _indexA301F526EsmJs.H)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, _react.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [
            newOption
        ].concat((0, _toConsumableArrayDefault.default)(propsOptions)) : [].concat((0, _toConsumableArrayDefault.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, _react.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== "select-option") return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: "create-option",
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, _indexA301F526EsmJs.D)(isMulti, [].concat((0, _toConsumableArrayDefault.default)((0, _indexA301F526EsmJs.H)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/toConsumableArray":"iT0h5","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","react":"9njXz","./index-a301f526.esm.js":"gYAEP","./Select-49a62830.esm.js":"dKKB5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eICKy":[function(require,module,exports) {
// functions to manage files for the linux gateways that we override in order to control things like wifi, I/O configuration, etc.
// file override settings go in gateway.settings (per-gateway) or in the template.gtemplate.settings (per-template)
// used to search through and delete old settings when saving
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tags", ()=>tags);
parcelHelpers.export(exports, "file_types", ()=>file_types);
parcelHelpers.export(exports, "getNetworkManagerWifiEnabled", ()=>getNetworkManagerWifiEnabled);
parcelHelpers.export(exports, "getNetworkManagerWifiDisabled", ()=>getNetworkManagerWifiDisabled);
parcelHelpers.export(exports, "getStwWakeFileEnabled", ()=>getStwWakeFileEnabled);
parcelHelpers.export(exports, "getStwWakeFileDisabled", ()=>getStwWakeFileDisabled);
parcelHelpers.export(exports, "getStwCANsettings", ()=>getStwCANsettings);
// give these either template.gtemplate.settings.file_overrides or gateway.settings.file_overrides
// removes any settings found with a matching tag so we can redo them when a user saves new settings
parcelHelpers.export(exports, "removeFileOverridesByTag", ()=>removeFileOverridesByTag);
// loads existing params from settings so we can present them to the user on open
parcelHelpers.export(exports, "getParamsByFileType", ()=>getParamsByFileType);
var Buffer = require("febd09f0ed57e94f").Buffer;
const tags = {
    nm_wifi: "nm_wifi",
    stw_wake: "stw_wake",
    stw_can: "stw_can"
};
const file_types = {
    wifi_nmconnection_enable_file: "wifi_nmconnection_enable_file",
    wifi_nmconnection_file: "wifi_nmconnection_file",
    stw_wake_file: "stw_wake_file",
    stw_can_file: "stw_can_file"
};
const wifiStwEnableFilePath = "/etc/wlan.conf";
const wifiClientFilePath = "/etc/NetworkManager/system-connections/wificlient.nmconnection";
function getNetworkManagerWifiEnabled(params) {
    return [
        {
            ui: {
                file_type: file_types.wifi_nmconnection_enable_file,
                tag: tags.nm_wifi
            },
            path: wifiStwEnableFilePath,
            permissions: "644",
            contents: Buffer.from(`# /etc/wlan.conf
#
# ----------------------------------------------------------------
# Configuration file for the wireless local area network interface
# ----------------------------------------------------------------

# Enable or disable wlan interface
# WLAN_ENABLE=ON --> activate, else deactivate
# Default: WLAN_ENABLE=OFF
WLAN_ENABLE=ON`).toString("base64")
        },
        {
            ui: {
                file_type: file_types.wifi_nmconnection_file,
                tag: tags.nm_wifi,
                params: {
                    stwWiFiControl: true,
                    stwWiFiEnabled: true,
                    WiFissid: params.WiFissid,
                    WiFipassword: params.WiFipassword
                }
            },
            path: wifiClientFilePath,
            permissions: "600",
            contents: Buffer.from(`[connection]
id=wificlient
uuid=689ed0a4-8e00-4f99-b90d-635b4e628791
type=wifi
interface-name=wlan0
permissions=

[wifi]
band=bg
mac-address-blacklist=
mode=infrastructure
ssid=${params.WiFissid}

[wifi-security]
key-mgmt=wpa-psk
psk=${params.WiFipassword}

[ipv4]
# this puts it below cell and ethernet at 100
route-metric=50 
dns-search=
method=auto

[ipv6]
addr-gen-mode=stable-privacy
dns-search=
method=auto

[proxy]`).toString("base64")
        }
    ];
}
function getNetworkManagerWifiDisabled() {
    return [
        {
            ui: {
                file_type: file_types.wifi_nmconnection_enable_file,
                tag: tags.nm_wifi,
                params: {
                    stwWiFiControl: true,
                    // we're still controlling wifi, we just have it disabled. we need this state to turn off wifi on gateways that previously had it on
                    stwWiFiEnabled: false
                }
            },
            path: wifiStwEnableFilePath,
            permissions: "644",
            contents: Buffer.from(`# /etc/wlan.conf
#
# ----------------------------------------------------------------
# Configuration file for the wireless local area network interface
# ----------------------------------------------------------------

# Enable or disable wlan interface
# WLAN_ENABLE=ON --> activate, else deactivate
# Default: WLAN_ENABLE=OFF
WLAN_ENABLE=OFF`).toString("base64")
        },
        {
            ui: {
                file_type: file_types.wifi_nmconnection_file,
                tag: tags.nm_wifi
            },
            path: wifiClientFilePath,
            permissions: "600",
            contents: Buffer.from(`#disabled`).toString("base64")
        }
    ];
}
const stwWakeFilePath = "/etc/wakeup.conf";
function getStwWakeFileEnabled(params) {
    return [
        {
            ui: {
                file_type: file_types.stw_wake_file,
                tag: tags.stw_wake,
                params: {
                    stwWakeControl: true,
                    stwWakeEnabled: true,
                    stwWakeInterval_s: params.stwWakeInterval_s,
                    stwWakeRunTime_s: params.stwWakeRunTime_s
                }
            },
            path: stwWakeFilePath,
            permissions: "644",
            contents: Buffer.from(`# /etc/wakeup.conf
#
# -----------------------------------------
# wakeup settings
# -----------------------------------------

# Ignition
# --------
# Run time in seconds after shutdown (ignition off).
# Set the default value here or wakeup-reason depending on:
# Ignition wakeup time in second, default is 0.
SD_RUN_TIME_IGN=0

# Motion
# ------
# Activate motion wakeup with "ON", else deactivate
# Default: MOTION_WAKEUP=OFF
MOTION_WAKEUP=OFF

# Run time in seconds after motion wakeup.
# Default: SD_RUN_TIME_MOT=300
SD_RUN_TIME_MOT=300

# RTC
# ---
# Activate rtc wakeup with "after_sec", else deactivate
# Enable wakeup after seconds with "after_sec" or
# Enable date + time wakeup with "tomorrow_at".
# Default: RTC_WAKEUP=OFF
RTC_WAKEUP=after_sec

# In combination with "tomorrow_at": RTC_WAKEUP_TIME hold the value in hh[:mm[:ss]].
# In combination with "after_sec": RTC_WAKEUP_TIME holds the value in seconds.
# Note:
# The wakeup time will be rounded up to a full minute: So if RTC_WAKEUP="after_sec"
# and RTC_WAKEUP_TIME is set to 1, it means that the system will wake up
# after 1 second or at least after 59 seconds.
# Default: RTC_WAKEUP_TIME=300
RTC_WAKEUP_TIME=${params.stwWakeInterval_s}

# Run time in seconds after rtc wakeup.
# Default: SD_RUN_TIME_RTC=300
SD_RUN_TIME_RTC=${params.stwWakeRunTime_s}
`).toString("base64")
        }
    ];
}
function getStwWakeFileDisabled() {
    return [
        {
            ui: {
                file_type: file_types.stw_wake_file,
                tag: tags.stw_wake,
                params: {
                    stwWakeControl: true,
                    // we're still controlling wake, we just have it disabled. we need this state to turn off wake on gateways that previously had it on
                    stwWakeEnabled: false
                }
            },
            path: stwWakeFilePath,
            permissions: "644",
            contents: Buffer.from(`# /etc/wakeup.conf
#
# -----------------------------------------
# wakeup settings
# -----------------------------------------

# Ignition
# --------
# Run time in seconds after shutdown (ignition off).
# Set the default value here or wakeup-reason depending on:
# Ignition wakeup time in second, default is 0.
SD_RUN_TIME_IGN=0

# Motion
# ------
# Activate motion wakeup with "ON", else deactivate
# Default: MOTION_WAKEUP=OFF
MOTION_WAKEUP=OFF

# Run time in seconds after motion wakeup.
# Default: SD_RUN_TIME_MOT=300
SD_RUN_TIME_MOT=300

# RTC
# ---
# Activate rtc wakeup with "after_sec", else deactivate
# Enable wakeup after seconds with "after_sec" or
# Enable date + time wakeup with "tomorrow_at".
# Default: RTC_WAKEUP=OFF
RTC_WAKEUP=OFF

# In combination with "tomorrow_at": RTC_WAKEUP_TIME hold the value in hh[:mm[:ss]].
# In combination with "after_sec": RTC_WAKEUP_TIME holds the value in seconds.
# Note:
# The wakeup time will be rounded up to a full minute: So if RTC_WAKEUP="after_sec"
# and RTC_WAKEUP_TIME is set to 1, it means that the system will wake up
# after 1 second or at least after 59 seconds.
# Default: RTC_WAKEUP_TIME=300
RTC_WAKEUP_TIME=86400

# Run time in seconds after rtc wakeup.
# Default: SD_RUN_TIME_RTC=300
SD_RUN_TIME_RTC=300
`).toString("base64")
        }
    ];
}
function getStwCANsettings(params) {
    // UI options for CAN are "125k", "250k", "500k", "1M"
    // can values in this file look like "250000" (250k) or "500000" (500k)
    // the UI selector already translates between them with BITRATE_OPTIONS[]
    // the newest stw BSP (late 2023) uses two files depending on the model: /etc/.can.conf.imx_silent and /etc/.can.conf.imx_silent_xmc_silent
    // BUT we should be able to just write out to the symlink /etc/can.conf and have that write to the actual file
    // this has the advantage of possibly working on older images too
    // if these are missing, set them, the file controls all four
    if (!params.bitrateCan0Val) params.bitrateCan0Val = "250000";
    if (!params.bitrateCan1Val) params.bitrateCan1Val = "250000";
    if (!params.bitrateCan2Val) params.bitrateCan2Val = "250000";
    if (!params.bitrateCan3Val) params.bitrateCan3Val = "250000";
    return [
        {
            ui: {
                file_type: file_types.stw_can_file,
                tag: tags.stw_can,
                params
            },
            path: "/etc/can.conf",
            permissions: "644",
            // rw,r,r
            contents: Buffer.from(`# /etc/can.conf (set by elevat logger file overrides)
#
# -----------------------------------------------------------------------------
# Configuration file for the CAN interfaces
# -----------------------------------------------------------------------------

# CAN 0 ON activate, else deactivate
CAN0_ENABLE=ON
# Baud rate for CAN0. Assign one or multiple baud rates, or activate auto
# baud rate detection, see section below.
CAN0_BAUDRATE=${params.bitrateCan0Val}
# Length of the tx queue CAN0
# Default: 1000
#CAN0_TXQUEUELENGTH=1000
# CAN 0 Silent mode.
# ON active, else deactivate
CAN0_SILENT=OFF

# CAN 1 ON activate, else deactivate
CAN1_ENABLE=ON
# Baud rate for CAN1. Assign one or multiple baud rates, or activate auto
# baud rate detection, see section below.
CAN1_BAUDRATE=${params.bitrateCan1Val}
# Length of the tx queue CAN1
# Default: 1000
#CAN1_TXQUEUELENGTH=1000
# CAN 1 Silent mode.
# ON active, else deactivate
CAN1_SILENT=OFF

# CAN 2 ON activate, else deactivate
CAN2_ENABLE=ON
# Baud rate for CAN2. Assign one or multiple baud rates, or activate auto
# baud rate detection, see section below.
CAN2_BAUDRATE=${params.bitrateCan2Val}
# Length of the tx queue CAN2
# Default: 1000
#CAN2_TXQUEUELENGTH=1000
# CAN 2 Silent mode.
# ON active, else deactivate
CAN2_SILENT=OFF

# CAN 3 ON activate, else deactivate
CAN3_ENABLE=ON
# Baud rate for CAN3. Assign one or multiple baud rates, or activate auto
# baud rate detection, see section below.
CAN3_BAUDRATE=${params.bitrateCan3Val}
# Length of the tx queue CAN3
# Default: 1000
#CAN3_TXQUEUELENGTH=1000
# CAN 3 Silent mode.
# ON active, else deactivate
CAN3_SILENT=OFF

# -----------------------------------------------------------------------------
# End of configuration
# -----------------------------------------------------------------------------

# Most of the above described configuration settings are not very complex and
# do not need further explanation. The only exception is the CANx_BAUDRATE
# variable. This variable offers multiple option with different functionalities:
#
# * Assign one fixed baud rate that will be initialized, there are no checks
#   performed that will tests of any messages can be received with this baud
#   rate. Therefore, the initialization process will pass independent of the
#   traffic on the bus. This process is very fast.
#     e.g. CAN0_BAUDRATE=250000
#
# * Assign multiple baud rates that will be tested at every boot. The CAN
#   interface will only be initialized if the baud rate can be verified by
#   receiving real CAN messages. The testing is performed in SILENT mode.
#   This process can take several seconds until the correct baud rate is
#   determined.
#     e.g. CAN0_BAUDRATE="125000 250000 500000"
#
# * Activate auto baud rate feature. The CAN interface will be tested with
#   multiple baud rates. CAN will only be initialized if the baud rate can be
#   verified by receiving real CAN messages. In that case the detected baud
#   rate overwrites the CANx_BAUDRATE variable in this file. The testing is
#   performed in SILENT mode. This process can take several seconds until the
#   correct baud rate is determined. All system starts after that will be as
#   fast as the fixed baud rate option.
#     e.g. CAN0_BAUDRATE=auto
#
#   NOTE: The detection is performed in SILENT mode. That requires two other
#         active participants on the respective CAN bus for it to work.
`).toString("base64")
        }
    ];
}
function removeFileOverridesByTag(file_overrides, tag) {
    if (!file_overrides?.length) return [];
    return file_overrides.filter((override)=>!override?.ui?.tag || override?.ui?.tag !== tag);
}
function getParamsByFileType(file_overrides, file_type) {
    if (!Array.isArray(file_overrides)) return {};
    const override = file_overrides.find((override)=>{
        return override?.ui?.file_type === file_type;
    });
    return override?.ui?.params || {};
}

},{"febd09f0ed57e94f":"dB11O","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jbIPF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _executeCommandModalDisplay = require("./ExecuteCommandModalDisplay");
var _executeCommandModalDisplayDefault = parcelHelpers.interopDefault(_executeCommandModalDisplay);
class ExecuteCommandModalContainer extends (0, _react.Component) {
    static propTypes = {
        asset: (0, _propTypesDefault.default).object,
        toggleModal: (0, _propTypesDefault.default).func,
        toggleCommandExecuted: (0, _propTypesDefault.default).func
    };
    static defaultProps = {
        asset: {
            gtemplate: {
                name: ""
            }
        }
    };
    state = {
        asset: this.parseAssetProps(),
        commands: [],
        error: "",
        executeRequestPending: false,
        jobParameter: "",
        selectedCommand: {},
        selectedButton: ""
    };
    assetService = new (0, _assetServiceDefault.default)();
    source = (0, _axios.CancelToken).source();
    componentWillUnmount() {
        this.source.cancel();
    }
    parseAssetProps() {
        const { asset } = this.props;
        const _id = asset?._id ?? "";
        const orgID = asset?.orgID ?? "";
        const nickname = asset?.nickname ?? "";
        const gtemplate = asset?.gtemplate ?? "";
        const commands = gtemplate?.commands ?? [];
        const gtemplateID = asset?.gtemplateID ?? "";
        return {
            _id,
            gtemplateID,
            orgID,
            nickname,
            gtemplate,
            commands
        };
    }
    handleExecuteCommandConfirm = async (e)=>{
        e.preventDefault();
        this.setState({
            executeRequestPending: true
        });
        try {
            const { asset: { _id: assetID }, jobParameter, selectedCommand } = this.state;
            const body = jobParameter ? {
                jobParameters: [
                    jobParameter
                ]
            } : {};
            await this.assetService.executeAssetCommand(assetID, {
                commandID: selectedCommand._id
            }, body, this.source.token);
            this.props.toggleCommandExecuted();
            this.setState({
                executeRequestPending: false,
                jobParameter: "",
                selectedButton: "",
                selectedCommand: {}
            });
        } catch (err) {
            if (!(0, _axios.isCancel)(err)) {
                const error = err.response?.data?.message ?? err.message;
                this.setState({
                    error,
                    executeRequestPending: false,
                    jobParameter: "",
                    selectedButton: "",
                    selectedCommand: {}
                });
            }
        }
        this.props.toggleModal();
    };
    handleExecuteCommand = ()=>{
        const { asset } = this.state;
        this.setState({
            commands: asset.commands,
            selectedButton: this.state.selectedCommand._id
        });
    };
    handleCancelCommand = ()=>{
        this.setState({
            selectedButton: ""
        });
    };
    onCommandButtonClick = (selectedCommand)=>{
        if (this.state.selectedCommand._id === selectedCommand._id) this.setState({
            selectedCommand: {},
            selectedButton: ""
        });
        else this.setState({
            selectedCommand,
            jobParameter: ""
        });
    };
    handleJobParameterInput = ({ target: { value: jobParameter } })=>{
        this.setState({
            jobParameter
        });
    };
    render() {
        const { asset: { nickname, commands, gtemplateID }, error, executeRequestPending, jobParameter, selectedButton, selectedCommand } = this.state;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _executeCommandModalDisplayDefault.default), {
            ...this.props,
            commands: commands,
            error: error,
            executeRequestPending: executeRequestPending,
            gtemplateID: gtemplateID,
            handleCancelCommand: this.handleCancelCommand,
            handleExecuteCommand: this.handleExecuteCommand,
            handleExecuteCommandConfirm: this.handleExecuteCommandConfirm,
            handleJobParameterInput: this.handleJobParameterInput,
            handlePropUpdate: this.handlePropUpdate,
            jobParameter: jobParameter,
            nickname: nickname,
            onCommandButtonClick: this.onCommandButtonClick,
            selectedButton: selectedButton,
            selectedCommand: selectedCommand
        });
    }
}
exports.default = ExecuteCommandModalContainer;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/AssetService":"fL096","./ExecuteCommandModalDisplay":"3ET62","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ET62":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExecuteCommandModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactRouterDom = require("react-router-dom");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _noDataIndication = require("../NoDataIndication");
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3338366606",
        children: "@media (max-width:767px){.modal-dialog.jsx-3338366606{height:100%;width:100%;max-height:100%;max-width:100%;margin:0;}}"
    }),
    className: "jsx-3338366606"
};
const { className: contentClass, styles: contentStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "134709570",
        children: "@media (max-width:767px){.modal-content.jsx-134709570{height:100%;}}@media (min-width:768px){.modal-content.jsx-134709570{border-radius:1rem;}}"
    }),
    className: "jsx-134709570"
};
const { className: modalBodyClass, styles: modalBodyStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "4152922273",
        children: ".modal-body.jsx-4152922273{padding:1rem;}@media (min-width:768px){.modal-body.jsx-4152922273{padding:1rem 2rem;padding-bottom:0;}}"
    }),
    className: "jsx-4152922273"
};
const { className: commandButtonClass, styles: commandButtonStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "576448009",
        children: "button.jsx-576448009{color:var(--text-gray);background-color:transparent;box-shadow:1px 1px 2px 1px rgba(0,0,0,0.15);-webkit-transition:box-shadow 0.3s ease-in-out;transition:box-shadow 0.3s ease-in-out;}button.jsx-576448009:hover{color:var(--text-gray);border:1px solid var(--brand-primary);background-color:transparent;box-shadow:1px 1px 2px 1px rgba(0,0,0,0.3);}"
    }),
    className: "jsx-576448009"
};
const HeaderContainer = ({ nickname, toggleModal })=>{
    const { commandControlIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: toggleModal,
                className: "jsx-2303827814 btn btn-link position-absolute close-modal-x text-muted bg-transparent text-decoration-none",
                children: "\u2A09"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2303827814 d-flex flex-row bd-highlight",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h5", {
                    className: "jsx-2303827814 bd-highlight",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "jsx-2303827814",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: commandControlIcon,
                                alt: "command-and-control-icon",
                                className: "jsx-2303827814 command-and-control-icon bd-highlight"
                            })
                        }),
                        "Execute Command",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "jsx-2303827814 font-weight-light text-muted small ml-1",
                            children: [
                                "on ",
                                nickname
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2303827814",
                children: ".close-modal-x.jsx-2303827814{right:3px;top:3px;outline:none;cursor:pointer;}.command-and-control-icon.jsx-2303827814{max-height:40px;margin-right:5px;margin-bottom:5px;}"
            })
        ]
    });
};
HeaderContainer.propTypes = {
    nickname: (0, _propTypesDefault.default).string,
    toggleModal: (0, _propTypesDefault.default).func
};
const CommandsContainer = ({ commands, error, handleJobParameterInput, jobParameter, onCommandButtonClick, selectedButton, selectedCommand })=>{
    const buttonDisabled = (commandID)=>{
        return selectedButton.length && selectedCommand._id && selectedButton !== commandID ? true : false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2835927512 command-container mb-2 w-100",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ButtonGroup), {
                        vertical: true,
                        className: "w-100",
                        children: commands.map((command)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "jsx-2835927512 command-button-container p-1 w-100",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Button), {
                                        outline: true,
                                        color: command._id === selectedCommand._id ? "info" : "light",
                                        block: true,
                                        className: `d-flex btn ${commandButtonClass} justify-content-between`,
                                        onClick: ()=>command._id ? onCommandButtonClick(command) : null,
                                        disabled: buttonDisabled(command._id),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "jsx-2835927512 text-capitalize",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "radio",
                                                    checked: command._id === selectedCommand._id,
                                                    className: "jsx-2835927512 radio-circle mr-3 align-top"
                                                }),
                                                command.name
                                            ]
                                        })
                                    }, command._id)
                                })
                            });
                        })
                    }),
                    Array.isArray(selectedCommand.parameters) && selectedCommand.parameters.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                        className: "jsx-2835927512 form-inline pt-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-2835927512 form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "jobParameter",
                                    className: "jsx-2835927512 pr-2",
                                    children: "Parameter:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "jobParameter",
                                    name: "jobParameter",
                                    onChange: handleJobParameterInput,
                                    type: "text",
                                    value: jobParameter,
                                    disabled: selectedButton.length > 0,
                                    className: "jsx-2835927512 form-control form-control-sm"
                                })
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2835927512 row justify-content-center text-danger",
                        children: error
                    })
                ]
            }),
            commandButtonStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2835927512",
                children: ".radio-circle.jsx-2835927512{-webkit-appearance:none;width:20px;height:20px;border:1px solid var(--brand-primary-alert);border-radius:50%;outline:none;}.radio-circle.jsx-2835927512:hover{box-shadow:0 0 5px 0px var(--brand-primary-alert);}.radio-circle.jsx-2835927512:before{content:'';display:block;width:100%;height:100%;border-radius:50%;}.radio-circle.jsx-2835927512:checked.jsx-2835927512:before{background:var(--brand-primary-alert);}.command-container.jsx-2835927512{height:60%;overflow-y:initial;overflow:-moz-scrollbars-none;-ms-overflow-style:none;}.command-container.jsx-2835927512::-webkit-scrollbar{width:0 !important;}.command-button-container.jsx-2835927512{height:50px;}@media (min-height:568px) and (max-height:768px){.command-button-container.jsx-2835927512{height:60px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}}@media (max-height:568px){.command-container.jsx-2835927512{height:55%;}}"
            })
        ]
    });
};
CommandsContainer.propTypes = {
    commands: (0, _propTypesDefault.default).array,
    error: (0, _propTypesDefault.default).string,
    handleJobParameterInput: (0, _propTypesDefault.default).func,
    jobParameter: (0, _propTypesDefault.default).string,
    onCommandButtonClick: (0, _propTypesDefault.default).func,
    selectedButton: (0, _propTypesDefault.default).string,
    selectedCommand: (0, _propTypesDefault.default).object
};
const CreateCommandButton = ({ gtemplateID })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: {
                pathname: `/asset-model/${gtemplateID}`,
                search: "?tab=commands"
            },
            replace: true,
            className: "m-auto text-center",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                className: "btn modal-button-submit py-0 px-3 three-quarter-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faPlus),
                        className: "d-inline-block mr-2 font-weight-bold"
                    }),
                    "Create Command"
                ]
            })
        })
    });
};
CreateCommandButton.propTypes = {
    gtemplateID: (0, _propTypesDefault.default).string
};
const InitialFooter = ({ commands, handleExecuteCommand, jobParameter, selectedCommand, toggleModal })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3411679055 footer-button-container d-flex justify-content-end mb-0 position-absolute",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: toggleModal,
                className: "jsx-3411679055 btn btn-outline-secondary col-sm-2 mr-3",
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                onClick: selectedCommand._id ? handleExecuteCommand : null,
                disabled: !commands.length || Array.isArray(selectedCommand.parameters) && selectedCommand.parameters.length && !jobParameter.length,
                className: "jsx-3411679055 btn modal-button-submit col-sm-2",
                children: "Execute"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3411679055",
                children: ".footer-button-container.jsx-3411679055{width:100%;bottom:30px;right:50px;}@media (max-height:768px){.footer-button-container.jsx-3411679055{width:90%;bottom:20px;right:20px;}}"
            })
        ]
    });
};
InitialFooter.propTypes = {
    commands: (0, _propTypesDefault.default).array,
    handleExecuteCommand: (0, _propTypesDefault.default).func,
    jobParameter: (0, _propTypesDefault.default).string,
    selectedCommand: (0, _propTypesDefault.default).object,
    toggleModal: (0, _propTypesDefault.default).func
};
const ConfirmFooter = ({ executeRequestPending, handleCancelCommand, handleExecuteCommandConfirm })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "jsx-2889397085 text-left description-font-size w-100 align-bottom",
                children: [
                    "Are you sure you want to send this Command to this Asset? Please ensure this is the Command you want to send.",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {
                        className: "jsx-2889397085"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "jsx-2889397085 font-weight-bold",
                        children: "Warning: You can't undo this action."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2889397085 footer-button-container d-flex justify-content-end mb-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleCancelCommand,
                        className: "jsx-2889397085 btn btn-outline-secondary col-sm-2 mr-3",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        onClick: handleExecuteCommandConfirm,
                        className: "jsx-2889397085 " + `btn bg-alert-orange text-white col-sm-4`,
                        children: executeRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true,
                            size: "lg"
                        }) : "Yes, Execute Command"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2889397085",
                children: ".description-font-size.jsx-2889397085{font-size:1rem;}.footer-button-container.jsx-2889397085{width:100%;position:absolute;bottom:30px;right:50px;}@media (min-height:568px) and (max-height:768px){.footer-button-container.jsx-2889397085{width:90%;bottom:20px;right:20px;}}@media (max-height:568px){.description-font-size.jsx-2889397085{font-size:0.75rem;}}"
            })
        ]
    });
};
ConfirmFooter.propTypes = {
    executeRequestPending: (0, _propTypesDefault.default).bool,
    handleCancelCommand: (0, _propTypesDefault.default).func,
    handleExecuteCommandConfirm: (0, _propTypesDefault.default).func
};
function ExecuteCommandModalDisplay({ commands, error, executeRequestPending, gtemplateID, handleCancelCommand, handleExecuteCommand, handleExecuteCommandConfirm, handleJobParameterInput, isOpen, jobParameter, nickname, onCommandButtonClick, selectedButton, selectedCommand, toggleModal }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        toggle: toggleModal,
        size: "lg",
        centered: true,
        className: `${modalClass}`,
        contentClassName: contentClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                className: `${modalBodyClass} h-50 pb-0 three-quarter-text`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-2235239628 container-fluid",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeaderContainer, {
                            nickname: nickname,
                            toggleModal: toggleModal
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-2235239628 chrome-commands-container",
                            children: commands.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CommandsContainer, {
                                commands: commands,
                                error: error,
                                handleJobParameterInput: handleJobParameterInput,
                                jobParameter: jobParameter,
                                onCommandButtonClick: onCommandButtonClick,
                                selectedButton: selectedButton,
                                selectedCommand: selectedCommand
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2235239628 row align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noDataIndication.NoItemsExist), {
                                        text: "No commands found on the Asset Model",
                                        altMessage: nickname
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CreateCommandButton, {
                                        gtemplateID: gtemplateID
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-2235239628 chrome-footer-container",
                            children: selectedButton.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmFooter, {
                                handleCancelCommand: handleCancelCommand,
                                handleExecuteCommandConfirm: handleExecuteCommandConfirm,
                                executeRequestPending: executeRequestPending
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(InitialFooter, {
                                commands: commands,
                                handleCancelCommand: handleCancelCommand,
                                handleExecuteCommand: handleExecuteCommand,
                                jobParameter: jobParameter,
                                selectedCommand: selectedCommand,
                                toggleModal: toggleModal
                            })
                        })
                    ]
                })
            }),
            modalStyles,
            contentStyles,
            modalBodyStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2235239628",
                children: ".chrome-commands-container.jsx-2235239628{overflow-y:auto;max-height:500px;}.chrome-commands-container.jsx-2235239628::-webkit-scrollbar{width:0 !important;}.chrome-footer-container.jsx-2235239628{margin-bottom:100px;}"
            })
        ]
    });
}
ExecuteCommandModalDisplay.propTypes = {
    commands: (0, _propTypesDefault.default).array,
    error: (0, _propTypesDefault.default).string,
    executeRequestPending: (0, _propTypesDefault.default).bool,
    gtemplateID: (0, _propTypesDefault.default).string,
    handleCancelCommand: (0, _propTypesDefault.default).func,
    handleExecuteCommand: (0, _propTypesDefault.default).func,
    handleExecuteCommandConfirm: (0, _propTypesDefault.default).func,
    handleJobParameterInput: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    jobParameter: (0, _propTypesDefault.default).string,
    nickname: (0, _propTypesDefault.default).string,
    onCommandButtonClick: (0, _propTypesDefault.default).func,
    toggleModal: (0, _propTypesDefault.default).func,
    selectedButton: (0, _propTypesDefault.default).string,
    selectedCommand: (0, _propTypesDefault.default).object
};
ExecuteCommandModalDisplay.defaultProps = {
    nickname: "Unnamed Asset",
    selectedButton: "",
    selectedCommand: {},
    commands: []
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","react-router-dom":"3uzXR","@fortawesome/free-solid-svg-icons":"k3TAw","@fortawesome/react-fontawesome":"32SD5","../../Context/IconsContext":"lzIpe","../NoDataIndication":"clGpp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RAmr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
exports.default = /*#__PURE__*/ (0, _react.memo)(GatewaySwapModal);
const initState = {
    error: "",
    provisionID: "",
    serialNumber: "",
    requestPending: false,
    swapInProgress: false
};
function GatewaySwapModal(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const { signalIconWhite } = (0, _react.useContext)((0, _iconsContextDefault.default));
    const service = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []);
    const source = (0, _axios.CancelToken).source();
    const handleExitAfterSwap = ()=>{
        if (!state.swapInProgress) return;
        const assetUpdate = {
            mac: state.serialNumber,
            provision: {
                _id: state.provisionID
            }
        };
        props.handleGatewaySwap(assetUpdate);
    };
    const swapGateway = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    requestPending: true
                }));
            const body = [
                {
                    autoTz: props.asset.autoTz,
                    gatewayName: props.asset.nickname,
                    gatewayId: props.asset._id,
                    remote: props.asset.remote,
                    serialNumber: state.serialNumber,
                    templateID: props.asset.gtemplateID,
                    timezone: props.asset.timezone,
                    type: "gateway_swap",
                    vendor: props.asset.vendor
                }
            ];
            const { results: [{ _id: provisionID }] } = await service.ProvisionAssetBulk(body, props.asset.orgID);
            updateState((prevState)=>({
                    ...prevState,
                    provisionID,
                    requestPending: false,
                    swapInProgress: true
                }));
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    };
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdrop: !state.swapInProgress || "static",
        centered: true,
        isOpen: props.isOpen,
        toggle: ()=>{
            state.swapInProgress ? ()=>null : props.toggleModal();
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-bottom-0 pb-0",
                toggle: ()=>{
                    state.swapInProgress ? ()=>null : props.toggleModal();
                },
                children: "Swap Gateway"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "py-0",
                children: [
                    state.swapInProgress ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "container-fluid my-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "row align-items-stretch justify-content-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-5 d-flex flex-column align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rounded text-dodger-blue bg-gradient-first-blue px-4",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: signalIconWhite,
                                                alt: "signal_icon",
                                                style: {
                                                    height: "70px"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-muted mt-3 mb-0 font-weight-normal",
                                            children: "Next Step"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-muted mt-0 font-weight-normal",
                                            children: "Turn on Gateway"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "col-1 d-flex align-items-center justify-content-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: "text-light-gray-3",
                                        icon: (0, _freeSolidSvgIcons.faLongArrowAltRight),
                                        size: "3x"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-5 d-flex flex-column align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: "text-icon-link-gray",
                                            icon: (0, _freeSolidSvgIcons.faCheckCircle),
                                            size: "4x",
                                            style: {
                                                height: "70px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "nine-tenth-text text-third-gray mt-4",
                                            children: "Gateway Swapped"
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "modal-supplemental-text three-quarter-text",
                                children: "Swap a new gateway for this machine by adding the new gateway's serial number."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group mr-4 mb-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "modal-inputlabel-text font-weight-bold",
                                        htmlFor: "serialNumber",
                                        children: "New Gateway Serial Number"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        className: "form-control form-control-sm rounded-lg",
                                        disabled: state.requestPending || state.swapInProgress,
                                        name: "serialNumber",
                                        onChange: ({ target: { value: serialNumber } })=>updateState((prevState)=>({
                                                    ...prevState,
                                                    serialNumber
                                                })),
                                        type: "text",
                                        value: state.serialNumber
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "mb-0 text-right three-quarter-text text-danger",
                        children: state.error
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: "border-top-0 pt-0",
                children: state.swapInProgress ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn btn-outline-secondary px-3 px-lg-4 py-0 nine-tenth-text",
                    onClick: handleExitAfterSwap,
                    children: "Close"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "btn btn-outline-secondary px-3 px-lg-4 py-0 nine-tenth-text",
                            onClick: props.toggleModal,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "btn modal-button-submit nine-tenth-text px-2 px-lg-4 py-0 ml-3",
                            onClick: swapGateway,
                            disabled: state.requestPending,
                            children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                spin: true,
                                size: "lg"
                            }) : "Swap"
                        })
                    ]
                })
            })
        ]
    });
}
GatewaySwapModal.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    handleGatewaySwap: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Services/AssetService":"fL096","../../Context/IconsContext":"lzIpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"v80Rq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _asset = require("../../Constants/Asset");
const { className: heightClass, styles: heightStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2051320809",
        children: "div.jsx-2051320809{height:calc(100% - 60px);}"
    }),
    className: "jsx-2051320809"
};
exports.default = /*#__PURE__*/ (0, _react.memo)(MobileTabLinksModal);
function MobileTabLinksModal({ assetFormat, handleTabChange, isOpen, tab, toggleModal }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: isOpen,
        toggle: toggleModal,
        size: "sm",
        backdropClassName: heightClass,
        modalClassName: heightClass,
        className: "h-100 my-0 pb-2 d-flex flex-column justify-content-end",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                children: [
                    [
                        (0, _asset.DM1_FAULTS),
                        (0, _freeSolidSvgIcons.faExclamationTriangle),
                        "DM1 Faults"
                    ],
                    [
                        (0, _asset.COMMAND_HISTORY),
                        (0, _freeSolidSvgIcons.faWifi),
                        "Command History"
                    ],
                    [
                        (0, _asset.SUBSCRIPTIONS),
                        (0, _freeSolidSvgIcons.faEnvelopeOpenText),
                        "Subscriptions"
                    ],
                    [
                        (0, _asset.VALIDATION_ERRORS),
                        (0, _freeSolidSvgIcons.faTimes),
                        "Errors"
                    ]
                ].filter(([tabName])=>{
                    if (assetFormat !== "json" && tabName === (0, _asset.VALIDATION_ERRORS)) return false;
                    return true;
                }).map(([tabName, icon, displayText])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `btn btn-link w-100 d-flex align-items-center ${tab === tabName ? "text-brand-primary" : "text-icon-link-gray"}`,
                        onClick: ()=>handleTabChange(tabName),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "w-25 text-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: icon,
                                    size: "lg"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: displayText
                            })
                        ]
                    }, tabName))
            }),
            heightStyles
        ]
    });
}
MobileTabLinksModal.propTypes = {
    assetFormat: (0, _propTypesDefault.default).oneOf([
        "json",
        "protobuf"
    ]),
    handleTabChange: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    tab: (0, _propTypesDefault.default).oneOf((0, _asset.ASSET_TABS)),
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/Asset":"1OiRg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byFgU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _vendors = require("../../Constants/Vendors");
var _moveAssetModalDisplay = require("./MoveAssetModalDisplay");
var _moveAssetModalDisplayDefault = parcelHelpers.interopDefault(_moveAssetModalDisplay);
exports.default = /*#__PURE__*/ (0, _react.memo)(MoveAssetModal);
function MoveAssetModal(props) {
    const [state, updateState] = (0, _react.useState)(()=>{
        const modelType = [
            (0, _staticUUIDs.DF_PROVISIONING_MODEL_ID),
            (0, _staticUUIDs.PROVISIONING_MODEL_ID),
            (0, _staticUUIDs.XIRGO_PROVISIONING_MODEL_ID),
            (0, _staticUUIDs.XIRGO_V2_PROVISIONING_MODEL_ID)
        ].includes(props.selectedAsset?.gtemplateID) ? "keepProvision" : props.selectedAsset?.vendor === (0, _vendors.XIRGO_V2_VENDOR_ID) ? "selectModel" : "cloneModel";
        return {
            error: "",
            modelType,
            moveRequestPending: false,
            orgNameSearch: "",
            orgTemplateOptions: [],
            orgTemplatesLoading: true,
            selectedOrgID: "",
            viewing: "select"
        };
    });
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const source = (0, _axios.CancelToken).source();
    const templateService = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    const handleOrgNameSearch = ({ target: { value } })=>{
        updateState({
            ...state,
            orgNameSearch: value
        });
    };
    const handleBackClick = ()=>{
        updateState({
            ...state,
            viewing: "select",
            selectedOrgID: ""
        });
    };
    const handleOrgSelect = (id)=>{
        const update = state.selectedOrgID.includes(id) ? "" : id;
        updateState({
            ...state,
            selectedOrgID: update
        });
    };
    const handleMoveButtonClick = ()=>{
        updateState({
            ...state,
            viewing: "confirm"
        });
    };
    const handleModelTypeSelect = ({ target: { name, value } })=>{
        updateState({
            ...state,
            [name]: value,
            selectedModel: null
        });
    };
    const handleModelSelect = (selectedModel)=>{
        updateState({
            ...state,
            selectedModel
        });
    };
    const handleMoveOrg = async ()=>{
        updateState({
            ...state,
            moveRequestPending: true
        });
        try {
            const { currentOrg: { gatewayCount = 0 }, handleAssetWasMoved, handleSubtractAsset, selectedAsset: { _id: assetID, gtemplateID, nickname, vendor }, toggleModal, updateCurrentOrg } = props;
            const { modelType, selectedModel, selectedOrgID: newOrg } = state;
            const { path = "" } = orgsMap[newOrg] ?? {};
            const validSharedGtemplate = path.includes(state.sharedGtemplate?.orgID);
            if (![
                (0, _staticUUIDs.DF_PROVISIONING_MODEL_ID),
                (0, _staticUUIDs.PROVISIONING_MODEL_ID),
                (0, _staticUUIDs.XIRGO_PROVISIONING_MODEL_ID),
                (0, _staticUUIDs.XIRGO_V2_PROVISIONING_MODEL_ID)
            ].includes(gtemplateID) && !selectedModel?.value && modelType !== "keepShared") throw new Error("A model must be selected for the Asset");
            if (validSharedGtemplate && modelType !== "keepShared" && !selectedModel?.value) throw new Error("New model must be selected if not keeping Shared Model");
            if (modelType === "cloneModal" && vendor === (0, _vendors.XIRGO_V2_VENDOR_ID)) throw new Error("EZ+ model clone not supported");
            const selectedModelID = validSharedGtemplate && modelType === "keepShared" ? {
                selectedModelID: gtemplateID
            } : selectedModel ? {
                selectedModelID: selectedModel.value
            } : {};
            const body = {
                newOrg,
                ...selectedModelID,
                cloneSharedTemplate: modelType === "cloneModel"
            };
            const updatedAsset = await new (0, _assetServiceDefault.default)().moveAssetToNewOrg(assetID, body);
            const successMessage = `${nickname || "Asset"} has been moved to ${orgsMap[newOrg].name}`;
            if (handleSubtractAsset) {
                handleSubtractAsset(assetID, successMessage);
                toggleModal();
            } else {
                updateCurrentOrg({
                    gatewayCount: gatewayCount - 1
                });
                handleAssetWasMoved(updatedAsset);
            }
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState({
                ...state,
                error,
                moveRequestPending: false
            });
        }
    };
    const fetchInitData = async ()=>{
        try {
            const { orgID, vendor: assetVendor } = props.selectedAsset || {};
            const limit = 100;
            const order = "asc";
            const page = 1;
            const sort = "name";
            const vendor = assetVendor === (0, _vendors.XIRGO_V1_VENDOR_ID) ? (0, _vendors.XIRGO_V1_VENDOR_ID) : assetVendor === (0, _vendors.XIRGO_V2_VENDOR_ID) ? (0, _vendors.XIRGO_V2_VENDOR_ID) : assetVendor === "danfoss" ? "1" : "elevat";
            const [{ count, data }, { sharedGtemplate }] = await Promise.all([
                templateService.fetchPaginatedTemplates(page, orgID, limit, sort, order, undefined, vendor, source.token),
                templateService.fetchTemplate(props.selectedAsset?.gtemplateID, source.token)
            ]);
            const availableTemplates = (0, _moveAssetModalDisplay.transformTemplateData)(data);
            if (count <= data.length) updateState((prevState)=>({
                    ...prevState,
                    modelType: sharedGtemplate ? "keepShared" : state.modelType,
                    orgTemplatesLoading: false,
                    orgTemplateOptions: availableTemplates,
                    sharedGtemplate
                }));
            else {
                const additionalData = await templateService.handleAdditionalTemplateRequests({
                    cancelToken: source.token,
                    count,
                    limit,
                    order,
                    orgID,
                    sort,
                    vendor
                });
                const addtionalTemplateOptions = (0, _moveAssetModalDisplay.transformTemplateData)(additionalData);
                updateState((prevState)=>({
                        ...prevState,
                        modelType: sharedGtemplate ? "keepShared" : state.modelType,
                        orgTemplatesLoading: false,
                        orgTemplateOptions: availableTemplates.concat(...addtionalTemplateOptions),
                        sharedGtemplate
                    }));
            }
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    orgTemplatesLoading: false
                }));
        }
    };
    (0, _react.useEffect)(()=>{
        fetchInitData();
        return source.cancel;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveAssetModalDisplayDefault.default), {
        ...props,
        ...state,
        handleBackClick: handleBackClick,
        handleModelSelect: handleModelSelect,
        handleModelTypeSelect: handleModelTypeSelect,
        handleMoveButtonClick: handleMoveButtonClick,
        handleMoveOrg: handleMoveOrg,
        handleOrgSelect: handleOrgSelect,
        handleOrgNameSearch: handleOrgNameSearch,
        orgsMap: orgsMap
    });
}
MoveAssetModal.propTypes = {
    currentOrg: (0, _propTypesDefault.default).object,
    handleAssetWasMoved: (0, _propTypesDefault.default).func,
    handleSubtractAsset: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    selectedAsset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplateID: (0, _propTypesDefault.default).string,
        nickname: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        vendor: (0, _propTypesDefault.default).string
    }),
    toggleModal: (0, _propTypesDefault.default).func,
    updateCurrentOrg: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Services/AssetService":"fL096","../../Services/TemplateService":"hGdvK","../../Context/OrgsMapContext":"asozp","../../Constants/StaticUUIDs":"cpjYY","../../Constants/Vendors":"jVaXW","./MoveAssetModalDisplay":"4Ptzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Ptzu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformTemplateData", ()=>transformTemplateData);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactImage = require("react-image");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _modalLayout = require("../ModalLayout");
var _modalLayoutDefault = parcelHelpers.interopDefault(_modalLayout);
var _selectStyles = require("../../Styles/SelectStyles");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _vendors = require("../../Constants/Vendors");
exports.default = /*#__PURE__*/ (0, _react.memo)(MoveAssetModalDisplay);
function MoveAssetModalDisplay(props) {
    const { error, handleOrgNameSearch, handleMoveButtonClick, handleBackClick, handleModelSelect, handleModelTypeSelect, handleMoveOrg, handleOrgSelect, isOpen, moveRequestPending, orgNameSearch, orgsMap, orgTemplateOptions, orgTemplatesLoading, selectedAsset, selectedOrgID, sharedGtemplate, toggleModal, viewing } = props;
    const restrictedVendors = [
        "1",
        (0, _vendors.XIRGO_V1_VENDOR_ID)
    ];
    const orgRows = (0, _react.useMemo)(()=>{
        return Object.entries(orgsMap).filter(([id, { features, name: name1 = "" }])=>{
            if (id === selectedAsset.orgID) return false;
            if (restrictedVendors.includes(selectedAsset.vendor) && !features?.vendors?.includes?.(selectedAsset.vendor)) return false;
            if (!orgNameSearch) return true;
            return name1.toLowerCase().includes(orgNameSearch.toLowerCase());
        }).map(([id, { name: name1, logo }])=>({
                id,
                name: name1,
                logo
            })).sort(({ name: a }, { name: b })=>a.localeCompare(b));
    }, [
        orgNameSearch
    ]);
    const hasProvisioningModel = [
        (0, _staticUUIDs.DF_PROVISIONING_MODEL_ID),
        (0, _staticUUIDs.PROVISIONING_MODEL_ID),
        (0, _staticUUIDs.XIRGO_PROVISIONING_MODEL_ID),
        (0, _staticUUIDs.XIRGO_V2_PROVISIONING_MODEL_ID)
    ].includes(selectedAsset.gtemplateID);
    const submitIsDisabled = (0, _react.useMemo)(()=>{
        switch(true){
            case props.modelType === "keepShared":
            case hasProvisioningModel && props.modelType === "keepProvision":
                return false;
            case hasProvisioningModel && props.modelType !== "keepProvision" && !props.selectedModel:
                return true;
            case !hasProvisioningModel && !props.selectedModel:
                return true;
            default:
                return false;
        }
    }, [
        hasProvisioningModel,
        props.modelType,
        props.selectedModel
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalLayoutDefault.default), {
        isOpen: isOpen,
        scrollable: viewing !== "select",
        toggle: ()=>toggleModal(),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                className: "border-0",
                toggle: ()=>toggleModal(),
                children: viewing === "select" ? "Sub Organizations" : "Others may lose access"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1805806540 " + ((viewing === "select" ? "input-group" : "d-none") || ""),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                name: name,
                                value: orgNameSearch,
                                onChange: handleOrgNameSearch,
                                placeholder: "Filter by name",
                                "aria-label": "Search by organization name",
                                "aria-describedby": "spyglass-icon",
                                className: "jsx-1805806540 form-control border-right-0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1805806540 input-group-append",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    id: "spyglass-icon",
                                    className: "jsx-1805806540 input-group-text bg-white border-left-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: "text-text-light-gray",
                                        icon: (0, _freeSolidSvgIcons.faSearch)
                                    })
                                })
                            })
                        ]
                    }),
                    viewing === "select" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrgsList, {
                        handleOrgSelect: handleOrgSelect,
                        orgRows: orgRows,
                        selectedOrgID: selectedOrgID
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmAndModelSelect, {
                        handleModelSelect: handleModelSelect,
                        handleModelTypeSelect: handleModelTypeSelect,
                        modelType: props.modelType,
                        orgsMap: orgsMap,
                        orgTemplateOptions: orgTemplateOptions,
                        orgTemplatesLoading: orgTemplatesLoading,
                        selectedAsset: selectedAsset,
                        selectedModel: props.selectedModel,
                        selectedOrgID: selectedOrgID,
                        sharedGtemplate: sharedGtemplate
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "jsx-1805806540 " + `mb-0 ${error ? "text-danger text-right" : "d-none"}`,
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalFooter), {
                className: `border-0 ${viewing === "select" ? "" : "justify-content-between"}`,
                children: viewing === "select" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    style: {
                        width: "7rem"
                    },
                    onClick: handleMoveButtonClick,
                    disabled: orgTemplatesLoading || !selectedOrgID.length,
                    className: "jsx-1805806540 btn modal-button-secondary p-0 mr-3 nine-tenth-text",
                    children: "Move Here"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleBackClick,
                            className: "jsx-1805806540 btn btn-outline-secondary p-0 px-3 nine-tenth-text",
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "jsx-1805806540",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    disabled: submitIsDisabled,
                                    onClick: handleMoveOrg,
                                    className: "jsx-1805806540 btn modal-button-submit p-0 mr-2 px-3 nine-tenth-text",
                                    children: moveRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                        size: "xs"
                                    }) : "Ok"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>toggleModal(),
                                    className: "jsx-1805806540 btn btn-outline-secondary p-0 px-3 nine-tenth-text shadow-none",
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1805806540",
                children: ".btn.jsx-1805806540{outline:none !important;}"
            })
        ]
    });
}
MoveAssetModalDisplay.propTypes = {
    error: (0, _propTypesDefault.default).string,
    handleBackClick: (0, _propTypesDefault.default).func,
    handleModelSelect: (0, _propTypesDefault.default).func,
    handleModelTypeSelect: (0, _propTypesDefault.default).func,
    handleMoveButtonClick: (0, _propTypesDefault.default).func,
    handleMoveOrg: (0, _propTypesDefault.default).func,
    handleOrgNameSearch: (0, _propTypesDefault.default).func,
    handleOrgSelect: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    modelType: (0, _propTypesDefault.default).oneOf([
        "keepProvision",
        "keepShared",
        "cloneModel",
        "selectModel"
    ]),
    moveRequestPending: (0, _propTypesDefault.default).bool,
    orgsMap: (0, _propTypesDefault.default).object,
    orgNameSearch: (0, _propTypesDefault.default).string,
    orgTemplatesLoading: (0, _propTypesDefault.default).bool,
    orgTemplateOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    selectedAsset: (0, _propTypesDefault.default).object,
    selectedModel: (0, _propTypesDefault.default).object,
    selectedOrgID: (0, _propTypesDefault.default).string,
    sharedGtemplate: (0, _propTypesDefault.default).shape({
        orgID: (0, _propTypesDefault.default).string
    }),
    toggleModal: (0, _propTypesDefault.default).func,
    viewing: (0, _propTypesDefault.default).string
};
MoveAssetModalDisplay.defaultProps = {
    selectedAsset: {
        orgID: ""
    },
    orgsMap: {
        "": {
            name: ""
        }
    },
    selectedOrgID: ""
};
function OrgsList({ handleOrgSelect, orgRows, selectedOrgID }) {
    const fallback = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        icon: (0, _freeSolidSvgIcons.faWarehouse)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex-fill position-relative",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "jsx-3941876703 position-absolute h-100 w-100 container-fluid overflow-auto",
            children: [
                orgRows.map(({ id, name: name1, logo })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        role: "option",
                        "aria-selected": selectedOrgID === id,
                        tabIndex: "0",
                        onClick: ()=>handleOrgSelect(id),
                        onKeyUp: ()=>handleOrgSelect(id),
                        className: "jsx-3941876703 " + `row org-container-row ${selectedOrgID === id && "modal-button-primary"}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-3941876703 col-3 d-flex align-items-center justify-content-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactImage.Img), {
                                    src: logo,
                                    loader: fallback,
                                    unloader: fallback,
                                    className: "img-fluid",
                                    alt: "logo",
                                    style: {
                                        maxHeight: "2rem"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-3941876703 col-9 h-100 pl-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-3941876703 org-name-text d-block text-truncate",
                                    children: name1
                                })
                            })
                        ]
                    }, id)),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                    id: "3941876703",
                    children: ".org-container-row.jsx-3941876703{height:2.5rem;outline:none;-webkit-transition:all 0.15s ease 0s;transition:all 0.15s ease 0s;}.org-conatiner-row.jsx-3941876703:focus{outline:none;}.org-name-text.jsx-3941876703{line-height:40px;}"
                })
            ]
        })
    });
}
OrgsList.propTypes = {
    handleOrgSelect: (0, _propTypesDefault.default).func,
    orgRows: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    selectedOrgID: (0, _propTypesDefault.default).string
};
function ConfirmAndModelSelect({ handleModelSelect, handleModelTypeSelect, modelType, orgsMap, orgTemplateOptions, orgTemplatesLoading, selectedAsset, selectedModel, selectedOrgID, sharedGtemplate }) {
    const { path = "" } = orgsMap[selectedOrgID] ?? {};
    const validSharedGtemplate = path.includes(sharedGtemplate?.orgID);
    const [targetOrgModels, updateTargetOrgModels] = (0, _react.useState)({
        loading: !validSharedGtemplate,
        options: []
    });
    const source = (0, _axios.CancelToken).source();
    const templateService = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    const hasProvisioningModel = [
        (0, _staticUUIDs.DF_PROVISIONING_MODEL_ID),
        (0, _staticUUIDs.PROVISIONING_MODEL_ID),
        (0, _staticUUIDs.XIRGO_PROVISIONING_MODEL_ID),
        (0, _staticUUIDs.XIRGO_V2_PROVISIONING_MODEL_ID)
    ].includes(selectedAsset.gtemplateID);
    const selectLoading = modelType === "cloneModel" ? orgTemplatesLoading : targetOrgModels.loading;
    const selectOptions = modelType === "cloneModel" ? orgTemplateOptions : targetOrgModels.options;
    const fetchTargetOrgModels = async ()=>{
        const limit = 100;
        const order = "asc";
        const page = 1;
        const sort = "name";
        const vendor = selectedAsset.vendor === (0, _vendors.XIRGO_V1_VENDOR_ID) ? (0, _vendors.XIRGO_V1_VENDOR_ID) : selectedAsset.vendor === (0, _vendors.XIRGO_V2_VENDOR_ID) ? (0, _vendors.XIRGO_V2_VENDOR_ID) : selectedAsset.vendor === "danfoss" ? "1" : "elevat";
        try {
            const { count, data } = await templateService.fetchPaginatedTemplates(page, selectedOrgID, limit, sort, order, undefined, vendor, source.token);
            const availableTemplates = transformTemplateData(data);
            if (count <= data.length) updateTargetOrgModels({
                loading: false,
                options: availableTemplates
            });
            else {
                const additionalData = await templateService.handleAdditionalTemplateRequests({
                    cancelToken: source.token,
                    count,
                    limit,
                    order,
                    orgID: selectedOrgID,
                    sort,
                    vendor
                });
                const addtionalTemplateOptions = transformTemplateData(additionalData);
                updateTargetOrgModels({
                    loading: false,
                    options: availableTemplates.concat(...addtionalTemplateOptions)
                });
            }
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            updateTargetOrgModels({
                ...targetOrgModels,
                loading: false
            });
        }
    };
    (0, _react.useEffect)(()=>{
        if ([
            "cloneModel",
            "keepShared"
        ].includes(modelType)) return;
        fetchTargetOrgModels();
        return source.cancel;
    }, [
        modelType,
        selectedOrgID
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-2850852829 container-fluid text-text-light-gray",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2850852829 row mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "jsx-2850852829 confirmation-text col-12 mb-0",
                    children: [
                        "Moving",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            className: "jsx-2850852829 text-gray",
                            children: ` ${selectedAsset.nickname} ` || " this asset "
                        }),
                        "to",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            className: "jsx-2850852829 text-gray",
                            children: ` ${orgsMap[selectedOrgID].name} ` || " "
                        }),
                        "will make it visible to everyone in this organization. They will see this asset has been moved into their asset inventory, and be able to view its info. In order to receive data from this asset, a new template will have to be set."
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2850852829 row mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "jsx-2850852829 confirmation-text col-12 mb-0",
                    children: [
                        "Users in",
                        ` ${orgsMap[selectedAsset.orgID].name} ` || " ",
                        "will no longer be able to see the asset. It will be moved from",
                        ` ${orgsMap[selectedAsset.orgID].name}'s ` || " ",
                        "inventory to",
                        ` ${orgsMap[selectedOrgID].name}'s ` || " ",
                        "asset inventory."
                    ]
                })
            }),
            hasProvisioningModel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-2850852829 row mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "jsx-2850852829 mb-0 col-12 col-md-8 col-lg-6 text-text-light-gray three-quarter-text",
                    children: "This asset is currently assigned the Provisioning Model. It can be moved as is or you can choose to select a new Model below."
                })
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2850852829 " + `row ${hasProvisioningModel ? "mt-2" : "mt-4"}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-2850852829 col-12 mb-0 font-weight-bolder",
                            children: "Asset Model"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2850852829 row mt-2",
                        children: [
                            [
                                "keepProvision",
                                "Keep Provisioning Model"
                            ],
                            [
                                "cloneModel",
                                "Clone a Model from this Organization"
                            ],
                            [
                                "selectModel",
                                "Select a Model from the target Organization"
                            ],
                            [
                                "keepShared",
                                "Keep the assigned Shared Model"
                            ]
                        ].map(([type, displayText])=>{
                            switch(true){
                                case type === "cloneModel" && selectedAsset.vendor === (0, _vendors.XIRGO_V2_VENDOR_ID):
                                    return null;
                                case ![
                                    "keepProvision",
                                    "keepShared"
                                ].includes(type):
                                case type === "keepProvision" && hasProvisioningModel:
                                case type === "keepShared" && validSharedGtemplate:
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2850852829 col-12",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "jsx-2850852829 form-check",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    checked: modelType === type,
                                                    name: "modelType",
                                                    onChange: handleModelTypeSelect,
                                                    type: "radio",
                                                    value: type,
                                                    className: "jsx-2850852829 form-check-input"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "jsx-2850852829 form-check-label",
                                                    children: displayText
                                                })
                                            ]
                                        })
                                    }, type);
                                default:
                                    return null;
                            }
                        })
                    }),
                    modelType === "keepShared" ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2850852829 row mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "jsx-2850852829 col-12 col-md-8 col-lg-6",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                isLoading: selectLoading,
                                isSearchable: true,
                                maxMenuHeight: 150,
                                onChange: handleModelSelect,
                                options: selectOptions,
                                placeholder: "Select an Asset Model",
                                styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                value: selectedModel
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2850852829",
                children: ".confirmation-text.jsx-2850852829{font-size:0.75rem;}@media (min-width:768px){.confirmation-text.jsx-2850852829{font-size:1rem;}}"
            })
        ]
    });
}
ConfirmAndModelSelect.propTypes = {
    handleModelSelect: (0, _propTypesDefault.default).func,
    handleModelTypeSelect: (0, _propTypesDefault.default).func,
    modelType: (0, _propTypesDefault.default).oneOf([
        "keepProvision",
        "keepShared",
        "cloneModel",
        "selectModel"
    ]),
    orgsMap: (0, _propTypesDefault.default).object,
    orgTemplateOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    orgTemplatesLoading: (0, _propTypesDefault.default).bool,
    selectedAsset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        gtemplateID: (0, _propTypesDefault.default).string,
        nickname: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        vendor: (0, _propTypesDefault.default).oneOf([
            "1",
            "elevat",
            (0, _vendors.XIRGO_V1_VENDOR_ID),
            (0, _vendors.XIRGO_V2_VENDOR_ID)
        ])
    }),
    selectedModel: (0, _propTypesDefault.default).object,
    selectedOrgID: (0, _propTypesDefault.default).string,
    sharedGtemplate: (0, _propTypesDefault.default).shape({
        orgID: (0, _propTypesDefault.default).string
    })
};
ConfirmAndModelSelect.defaultProps = {
    selectedAsset: {}
};
function transformTemplateData(templates) {
    if (!Array.isArray(templates)) return [];
    const availableTemplates = templates.filter(({ _id })=>{
        return ![
            (0, _staticUUIDs.DF_PROVISIONING_MODEL_ID),
            (0, _staticUUIDs.PROVISIONING_MODEL_ID),
            (0, _staticUUIDs.XIRGO_PROVISIONING_MODEL_ID),
            (0, _staticUUIDs.XIRGO_V2_PROVISIONING_MODEL_ID)
        ].includes(_id);
    }).map(({ _id: value, name: label } = {})=>{
        return {
            label,
            value
        };
    });
    return availableTemplates;
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-image":"d5uD5","react-select":"j36cq","../../Services/TemplateService":"hGdvK","../ModalLayout":"2RoDj","../../Styles/SelectStyles":"1LnYJ","../../Constants/StaticUUIDs":"cpjYY","../../Constants/Vendors":"jVaXW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4EqvY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _vendors = require("../../Constants/Vendors");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _zipFile = require("../../Lib/ZipFile");
var _zipFileDefault = parcelHelpers.interopDefault(_zipFile);
var _newCertificateModalDisplay = require("./NewCertificateModalDisplay");
var _newCertificateModalDisplayDefault = parcelHelpers.interopDefault(_newCertificateModalDisplay);
class NewCertificateModalContainer extends (0, _react.Component) {
    state = {
        viewing: "create",
        certificate: null,
        error: null,
        certRequestPending: false,
        downloadPending: false
    };
    assetService = new (0, _assetServiceDefault.default)();
    source = (0, _axios.CancelToken).source();
    componentWillUnmount() {
        this.source.cancel();
    }
    generateCertificate = async ()=>{
        this.setState({
            certRequestPending: true
        });
        try {
            const { asset: { _id: assetID, vendor, mac, nickname, orgID, gtemplateID }, handleXirgoCertUpdated } = this.props;
            switch(vendor){
                case 0, _vendors.XIRGO_V1_VENDOR_ID:
                case 0, _vendors.XIRGO_V2_VENDOR_ID:
                    await this.assetService.generateCertificate(assetID, this.source.token);
                    handleXirgoCertUpdated();
                    break;
                case "elevat":
                    await this.assetService.ProvisionAssetBulk([
                        {
                            gatewayName: nickname,
                            serialNumber: mac,
                            type: "rekey",
                            templateID: gtemplateID,
                            gatewayId: assetID
                        }
                    ], orgID);
                    this.setState({
                        viewing: "confirm"
                    }); // show the confirm view with a message to emphasize that the asset is now in the provisioning queue
                    break;
                default:
                    {
                        // I guess for danfoss? proceed with the download which is a 2nd stage in the dialog
                        const certificate = await this.assetService.generateCertificate(assetID, this.source.token);
                        this.setState({
                            certificate,
                            viewing: "confirm"
                        });
                    }
                    break;
            }
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.reponse?.data?.message ?? err.message;
            this.setState({
                error,
                certRequestPending: false
            });
        }
    };
    handleDownloadAndClose = async ()=>{
        this.setState({
            downloadPending: true
        });
        try {
            const downloadParams = {
                ...this.state.certificate,
                gateway: this.props.asset
            };
            const certZip = new (0, _zipFileDefault.default)(downloadParams).createFileNames().queueZipFiles();
            await certZip.generateZipFile();
            certZip.downloadZipFile();
            this.props.toggleModal();
        } catch (err) {
            this.setState({
                error: err.message,
                downloadPending: false
            });
        }
    };
    toggleView = ()=>{
        this.setState({
            viewing: "create"
        });
    };
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newCertificateModalDisplayDefault.default), {
            ...this.props,
            ...this.state,
            toggleView: this.toggleView,
            generateCertificate: this.generateCertificate,
            handleDownloadAndClose: this.handleDownloadAndClose
        });
    }
}
exports.default = NewCertificateModalContainer;
NewCertificateModalContainer.propTypes = {
    asset: (0, _propTypesDefault.default).object,
    handleXirgoCertUpdated: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};
NewCertificateModalContainer.defaultProps = {
    asset: {}
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","../../Constants/Vendors":"jVaXW","../../Services/AssetService":"fL096","../../Lib/ZipFile":"kFZvn","./NewCertificateModalDisplay":"XNHq3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kFZvn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jszip = require("jszip");
var _jszipDefault = parcelHelpers.interopDefault(_jszip);
var _fileSaver = require("file-saver");
class ZipFile {
    constructor(params){
        this.zip = new (0, _jszipDefault.default)();
        this.assetID = params.gateway._id;
        this.certificate = params.certificate;
        this.privateKey = params.privateKey;
    }
    createFileNames() {
        this.certificateFile = `${this.assetID}.crt`;
        this.privateKeyFile = `${this.assetID}.key`;
        this.downloadFileName = `${this.assetID}-certificate.zip`;
        return this;
    }
    queueZipFiles() {
        this.zip.file(this.certificateFile, this.certificate);
        this.zip.file(this.privateKeyFile, this.privateKey);
        return this;
    }
    async generateZipFile() {
        this.zipFileBlob = await this.zip.generateAsync({
            type: "blob"
        });
        return this;
    }
    downloadZipFile = ()=>{
        (0, _fileSaver.saveAs)(this.zipFileBlob, this.downloadFileName);
    };
}
exports.default = ZipFile;

},{"jszip":"eGCrE","file-saver":"2pL8c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGCrE":[function(require,module,exports) {
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ var Buffer = require("f7295d6075386111").Buffer;
var global = arguments[3];
var process = require("cf30dbb97a1d82ba");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\x00\x00",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\x00", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\x00", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\x00\x00\x00\x00" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\x00\x00\x00\x00" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof Buffer,
                    newBufferFrom: function(e, t) {
                        if (Buffer.from && Buffer.from !== Uint8Array.from) return Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if (Buffer.alloc) return Buffer.alloc(e);
                        var t = new Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                process.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

},{"f7295d6075386111":"dB11O","cf30dbb97a1d82ba":"5jT8D"}],"2pL8c":[function(require,module,exports) {
var global = arguments[3];
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(this, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof global && global.global === global ? global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

},{}],"XNHq3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NewCertificateModalDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _vendors = require("../../Constants/Vendors");
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3995685333",
        children: "@media (max-width:991px){.modal-dialog.jsx-3995685333{height:100%;width:100%;max-height:100%;max-width:100%;margin:0;}}"
    }),
    className: "jsx-3995685333"
};
const { className: contentClass, styles: contentStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1903519680",
        children: "@media (max-width:767px){.modal-content.jsx-1903519680{display:grid;grid-template-rows:auto 60px;}}@media (max-width:991px){.modal-content.jsx-1903519680{height:100%;}}@media (min-width:992px){.modal-content.jsx-1903519680{border-radius:1rem;}}"
    }),
    className: "jsx-1903519680"
};
const { className: modalBodyClass, styles: modalBodyStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "4053495144",
        children: ".modal-body.jsx-4053495144{overflow:auto;}"
    }),
    className: "jsx-4053495144"
};
function NewCertificateModalDisplay(props) {
    const { asset: { vendor }, certRequestPending, error, generateCertificate, handleDownloadAndClose, isOpen, toggleModal, toggleView, viewing } = props;
    const { certificateIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdrop: certRequestPending ? "static" : true,
        centered: true,
        className: modalClass,
        contentClassName: contentClass,
        isOpen: isOpen,
        size: "md",
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: `${modalBodyClass} container-fluid`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: certRequestPending,
                        onClick: toggleModal,
                        className: "jsx-1164618600 btn btn-link position-absolute close-modal-x text-muted",
                        children: "\u2A09"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1164618600 row justify content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: certificateIcon,
                            alt: "certificate icon",
                            style: {
                                maxHeight: "60px"
                            },
                            className: "jsx-1164618600 img-fluid mx-auto"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1164618600 row justify-content-center mt-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            className: "jsx-1164618600 modal-title text-text-dark",
                            children: "New Certificate"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1164618600 row justify-content-center mt-5 mb-5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: generateCertificate,
                                className: "jsx-1164618600 " + ((viewing === "create" ? "btn modal-button-submit" : "d-none") || ""),
                                children: certRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                    className: "mx-5",
                                    spin: true
                                }) : "Generate New Certificate"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faCheckCircle),
                                size: "3x",
                                className: viewing === "confirm" ? "text-success" : "d-none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1164618600 row mx-3 justify-content-md-center justify-content-lg-start",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-1164618600 " + ((viewing === "create" && ![
                                    "elevat"
                                ].includes(vendor) ? "text-muted three-quarter-text" : "d-none") || ""),
                                children: "Generating a new certificate will make the existing certificate invalid."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-1164618600 " + ((viewing === "confirm" && ![
                                    "elevat"
                                ].includes(vendor) ? "text-muted three-quarter-text" : "d-none") || ""),
                                children: "A new certificate has been generated for this gateway. If there was a problem, click back to generate another certificate."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "jsx-1164618600 " + ((viewing === "confirm" && [
                                    "elevat"
                                ].includes(vendor) ? "text-muted three-quarter-text" : "d-none") || ""),
                                children: "A provisioning queue entry has been created to re-key this gateway. Please reboot the gateway so it sees the new key. The operation can be cancelled through the provisioning queue."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1164618600 row mt-1 mx-3 justify-content-md-center justify-content-lg-start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "jsx-1164618600 " + ((viewing === "create" && [
                                "elevat"
                            ].includes(vendor) ? "text-muted three-quarter-text" : "d-none") || ""),
                            children: "This gateway will be put into the provisioning queue. The certificate will be downloaded when the gateway next connects. The provisioning queue entry can be deleted to undo the new key action."
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1164618600 row mt-1 mx-3 justify-content-md-center justify-content-lg-start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "jsx-1164618600 " + ((certRequestPending && [
                                (0, _vendors.XIRGO_V1_VENDOR_ID),
                                (0, _vendors.XIRGO_V2_VENDOR_ID)
                            ].includes(vendor) ? "text-danger three-quarter-text" : "d-none") || ""),
                            children: "This operation may take 10-20 seconds to complete. Please do not refresh your browser or naviagate away from this page until it completes."
                        })
                    }),
                    error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1164618600 row m-3 justify-content-md-center justify-content-lg-start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "jsx-1164618600 text-danger",
                            children: error
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                className: "justify-content-start border-top-0 mt-lg-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: certRequestPending,
                        onClick: toggleModal,
                        className: "jsx-1164618600 " + ((viewing === "create" ? "btn btn-outline-secondary px-4 py-0 three-quarter-text" : "d-none") || ""),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleView,
                        className: "jsx-1164618600 " + ((viewing === "confirm" ? "btn btn-outline-secondary px-4 py-0 three-quarter-text" : "d-none") || ""),
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleDownloadAndClose,
                        className: "jsx-1164618600 " + ((viewing === "confirm" && ![
                            "elevat"
                        ].includes(vendor) ? "btn modal-button-submit ml-auto px-4 py-0 three-quarter-text" : "d-none") || ""),
                        children: "Download & Close"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: toggleModal,
                        className: "jsx-1164618600 " + ((viewing === "confirm" && [
                            "elevat"
                        ].includes(vendor) ? "btn modal-button-submit ml-auto px-4 py-0 three-quarter-text" : "d-none") || ""),
                        children: "Close"
                    })
                ]
            }),
            modalStyles,
            contentStyles,
            modalBodyStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1164618600",
                children: ".close-modal-x.jsx-1164618600{right:3px;top:3px;font-size:1rem;background-color:transparent;-webkit-text-decoration:none;text-decoration:none;outline:none;cursor:pointer;}"
            })
        ]
    });
}
NewCertificateModalDisplay.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        vendor: (0, _propTypesDefault.default).oneOf([
            "elevat",
            "1",
            (0, _vendors.XIRGO_V1_VENDOR_ID),
            (0, _vendors.XIRGO_V2_VENDOR_ID)
        ])
    }),
    certRequestPending: (0, _propTypesDefault.default).bool,
    error: (0, _propTypesDefault.default).string,
    generateCertificate: (0, _propTypesDefault.default).func,
    handleDownloadAndClose: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func,
    toggleView: (0, _propTypesDefault.default).func,
    viewing: (0, _propTypesDefault.default).string
};
NewCertificateModalDisplay.defaultProps = {
    asset: {}
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/Vendors":"jVaXW","../../Context/IconsContext":"lzIpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pplv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _addDays = require("date-fns/addDays");
var _addDaysDefault = parcelHelpers.interopDefault(_addDays);
var _isBefore = require("date-fns/isBefore");
var _isBeforeDefault = parcelHelpers.interopDefault(_isBefore);
var _isSameDay = require("date-fns/isSameDay");
var _isSameDayDefault = parcelHelpers.interopDefault(_isSameDay);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _isWithinInterval = require("date-fns/isWithinInterval");
var _isWithinIntervalDefault = parcelHelpers.interopDefault(_isWithinInterval);
var _subDays = require("date-fns/subDays");
var _subDaysDefault = parcelHelpers.interopDefault(_subDays);
var _reactstrap = require("reactstrap");
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _utilizationService = require("../../Services/UtilizationService");
var _utilizationServiceDefault = parcelHelpers.interopDefault(_utilizationService);
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
exports.default = /*#__PURE__*/ (0, _react.memo)(RerunOutputSignalsModal);
const initState = {
    endDate: null,
    error: "",
    requestPending: false,
    startDate: null
};
const maxDays = 30;
const today = new Date();
function RerunOutputSignalsModal(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const { assetID } = (0, _reactRouterDom.useParams)();
    const source = (0, _axios.CancelToken).source();
    const utilService = (0, _react.useMemo)(()=>new (0, _utilizationServiceDefault.default)(), []);
    const maxDateEnd = (0, _react.useMemo)(()=>{
        if (!(0, _isValidDefault.default)(state.startDate)) return today;
        const startPlusMax = (0, _addDaysDefault.default)(state.startDate, maxDays);
        return (0, _isBeforeDefault.default)(startPlusMax, today) ? startPlusMax : today;
    }, [
        state.startDate
    ]);
    const maxDateStart = (0, _react.useMemo)(()=>(0, _subDaysDefault.default)(state.endDate || today, 1), [
        state.endDate
    ]);
    const minDateEnd = (0, _react.useMemo)(()=>(0, _isValidDefault.default)(state.startDate) ? (0, _addDaysDefault.default)(state.startDate, 1) : undefined, [
        state.startDate
    ]);
    const minDateStart = (0, _react.useMemo)(()=>(0, _isValidDefault.default)(state.endDate) ? (0, _subDaysDefault.default)(state.endDate, maxDays) : undefined, [
        state.endDate
    ]);
    const handleEndDateSelect = (0, _react.useCallback)((endDate)=>{
        updateState((prevState)=>({
                ...prevState,
                endDate,
                error: ""
            }));
    }, []);
    const handleStartDateSelect = (0, _react.useCallback)((startDate)=>{
        updateState((prevState)=>({
                ...prevState,
                startDate,
                error: ""
            }));
    }, []);
    const handleRun = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    requestPending: true
                }));
            const { startDate, endDate } = validateDays(state);
            const params = {
                endDate,
                rulesProcessor: false,
                startDate
            };
            await utilService.runGatewayOutputSignals(assetID, params, source.token);
            props.handleOutputSignalRerunSuccess();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    };
    const submitDisabled = (0, _react.useMemo)(()=>state.requestPending || !(0, _isValidDefault.default)(state.endDate) || !(0, _isValidDefault.default)(state.startDate), [
        state.endDate,
        state.requestPending,
        state.startDate
    ]);
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        backdrop: state.requestPending ? "static" : true,
        centered: true,
        contentClassName: "rounded-lg",
        isOpen: props.isOpen,
        size: "lg",
        toggle: state.requestPending ? ()=>null : props.toggleModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: state.requestPending ? ()=>null : props.toggleModal,
                children: "Rerun Calculated Signals"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
                className: "container-fluid py-md-5 nine-tenth-text",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-558999149 row align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-558999149 col col-md-5 d-flex align-items-center justify-content-end",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-558999149 form-group d-flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "startDate",
                                            className: "jsx-558999149",
                                            children: "Start Date"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            autoComplete: "off",
                                            endDate: state.endDate,
                                            isClearable: !!state.startDate,
                                            maxDate: maxDateStart,
                                            minDate: minDateStart,
                                            name: "startDate",
                                            onChange: handleStartDateSelect,
                                            openToDate: maxDateStart,
                                            placeholderText: "From",
                                            selected: state.startDate,
                                            selectsStart: true,
                                            startDate: state.startDate
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-558999149 d-none d-md-block col-md-2 text-center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faMinus),
                                    size: "lg"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-558999149 col col-md-5 d-flex align-items-center justify-content-start",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-558999149 form-group d-flex flex-column",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "endDate",
                                            className: "jsx-558999149",
                                            children: "End Date"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            autoComplete: "off",
                                            endDate: state.endDate,
                                            isClearable: !!state.endDate,
                                            maxDate: maxDateEnd,
                                            minDate: minDateEnd,
                                            name: "endDate",
                                            onChange: handleEndDateSelect,
                                            openToDate: maxDateEnd,
                                            placeholderText: "To",
                                            selected: state.endDate,
                                            selectsEnd: true,
                                            startDate: state.startDate
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-558999149 row justify-content-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "jsx-558999149 mb-0 col-12 col-md-11 text-danger text-right",
                            children: state.error
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: state.requestPending,
                        onClick: props.toggleModal,
                        className: "jsx-558999149 btn btn-outline-secondary py-0 px-3 mr-3",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: submitDisabled,
                        onClick: handleRun,
                        className: "jsx-558999149 btn modal-button-submit py-0 px-4",
                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                            spin: true
                        }) : "Run"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "558999149",
                children: ".btn.jsx-558999149{font-size:0.75rem;}"
            })
        ]
    });
}
RerunOutputSignalsModal.propTypes = {
    handleOutputSignalRerunSuccess: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};
function validateDays({ endDate, startDate }) {
    if ((0, _isSameDayDefault.default)(startDate, endDate)) throw new Error("Start and End Date cannot be the same day");
    const validInterval = (0, _isWithinIntervalDefault.default)(endDate, {
        end: (0, _addDaysDefault.default)(startDate, maxDays),
        start: startDate
    });
    if (!validInterval) throw new Error("Maximum of 30 days allowed. Please adjust Start or End Date");
    return {
        endDate: endDate.toISOString(),
        startDate: startDate.toISOString()
    };
}

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","axios":"ffpgq","date-fns/addDays":"fK40q","date-fns/isBefore":"joMzA","date-fns/isSameDay":"i4e28","date-fns/isValid":"l72u5","date-fns/isWithinInterval":"6Kjfz","date-fns/subDays":"0Vpj8","reactstrap":"kjd7g","react-datepicker":"cGh5X","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Services/UtilizationService":"8TazX","react-datepicker/dist/react-datepicker.css":"chsuV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TazX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requests = require("../Lib/Requests");
var _requestsDefault = parcelHelpers.interopDefault(_requests);
class UtilizationService {
    api = new (0, _requestsDefault.default)();
    buildRunGatewayOutputSignalsRequest(gatewayID, params, cancelToken) {
        return {
            cancelToken,
            endpoint: `/v1/utilization/gateway/${gatewayID}`,
            method: "post",
            params,
            service: "utilization"
        };
    }
    runGatewayOutputSignals(gatewayID, params, cancelToken) {
        return this.api.request(this.buildRunGatewayOutputSignalsRequest(gatewayID, params, cancelToken));
    }
}
exports.default = UtilizationService;

},{"../Lib/Requests":"j1WJQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"hqoZs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _axios = require("axios");
var _reactstrap = require("reactstrap");
var _async = require("react-select/async");
var _asyncDefault = parcelHelpers.interopDefault(_async);
var _debouncePromise = require("debounce-promise");
var _debouncePromiseDefault = parcelHelpers.interopDefault(_debouncePromise);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _staticUUIDs = require("../../Constants/StaticUUIDs");
var _assetService = require("../../Services/AssetService");
var _assetServiceDefault = parcelHelpers.interopDefault(_assetService);
var _templateService = require("../../Services/TemplateService");
var _templateServiceDefault = parcelHelpers.interopDefault(_templateService);
var _selectStyles = require("../../Styles/SelectStyles");
exports.default = /*#__PURE__*/ (0, _react.memo)(ValidateAssetModal);
const initState = {
    error: "",
    requestPending: false,
    searchPending: true
};
function ValidateAssetModal(props) {
    const [state, updateState] = (0, _react.useState)(initState);
    const assetService = (0, _react.useMemo)(()=>new (0, _assetServiceDefault.default)(), []);
    const templateService = (0, _react.useMemo)(()=>new (0, _templateServiceDefault.default)(), []);
    let source = (0, _axios.CancelToken).source();
    const fetchModels = async (search = "")=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    searchPending: true
                }));
            source.cancel();
            source = (0, _axios.CancelToken).source();
            const { data } = await templateService.fetchPaginatedTemplates(1, props.asset?.orgID, 50, "name", "asc", search, props.asset?.vendor, source.token);
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    searchPending: false
                }));
            return data.filter(({ _id })=>!(0, _staticUUIDs.PROVISION_MODEL_ID_SET).has(_id)).map(({ _id, name })=>({
                    label: name,
                    value: _id
                }));
        } catch (err) {
            if (0, _axios.isCancel) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    searchPending: false
                }));
            return [];
        }
    };
    const handleModelSelected = (selectedModel)=>{
        updateState((prevState)=>({
                ...prevState,
                error: "",
                selectedModel
            }));
    };
    const handleStartClick = async ()=>{
        try {
            updateState((prevState)=>({
                    ...prevState,
                    error: "",
                    requestPending: true
                }));
            await assetService.validateAsset(props.asset?._id, state.selectedModel?.value, source.token);
            props.handleValidateAssetSuccess();
        } catch (err) {
            if ((0, _axios.isCancel)(err)) return;
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    requestPending: false
                }));
        }
    };
    (0, _react.useEffect)(()=>source.cancel, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.Modal), {
        centered: true,
        isOpen: props.isOpen,
        scrollable: true,
        size: "lg",
        toggle: props.toggleModal,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.ModalBody), {
            className: "container-fluid py-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row align-items-center justify-content-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        className: "col-12 col-md-10 modal-title-text",
                        children: "Validate Asset"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row align-items-center justify-content-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "col-12 col-md-10 modal-supplemental-text text-center text-md-left",
                        children: "Validate the Asset against a User created Asset Model without activating a subscription. This validation process is temporary and will automatically set it back to the Provisioning Model after 4 hours."
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row align-items-center justify-content-center mt-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "col-12 col-md-10 form-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "modal-inputlabel-text",
                                htmlFor: "assetModel",
                                children: "Asset Model"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "d-flex",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _asyncDefault.default), {
                                        cacheOptions: true,
                                        captureMenuScroll: false,
                                        defaultOptions: true,
                                        className: "flex-grow-1",
                                        isClearable: true,
                                        isDisabled: state.requestPending,
                                        isLoading: state.searchPending,
                                        isSearchable: true,
                                        loadingMessage: ()=>"Searching Asset Models...",
                                        loadOptions: (0, _debouncePromiseDefault.default)(fetchModels, 1000),
                                        maxMenuHeight: 250,
                                        menuShouldScrollIntoView: true,
                                        name: "assetModel",
                                        noOptionsMessage: ({ inputValue })=>`No models match: ${inputValue}`,
                                        onChange: handleModelSelected,
                                        placeholder: "Select an Asset Model",
                                        styles: (0, _selectStyles.BASIC_SELECT_STYLES),
                                        value: state.selectedModel
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "btn btn-sm modal-button-submit ml-3 px-md-4 nine-tenth-text",
                                        disabled: state.requestPending || !state.selectedModel?.value,
                                        onClick: handleStartClick,
                                        children: state.requestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                            spin: true
                                        }) : "Start"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "row align-items-end justify-content-end",
                    style: {
                        height: "250px"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "col-12 col-md-10 text-right three-quarter-text text-danger",
                        children: state.error
                    })
                })
            ]
        })
    });
}
ValidateAssetModal.propTypes = {
    asset: (0, _propTypesDefault.default).shape({
        _id: (0, _propTypesDefault.default).string,
        orgID: (0, _propTypesDefault.default).string,
        vendor: (0, _propTypesDefault.default).string
    }),
    handleValidateAssetSuccess: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    toggleModal: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","axios":"ffpgq","reactstrap":"kjd7g","react-select/async":"iHFh7","debounce-promise":"fqOKC","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/StaticUUIDs":"cpjYY","../../Services/AssetService":"fL096","../../Services/TemplateService":"hGdvK","../../Styles/SelectStyles":"1LnYJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asi9N":[function(require,module,exports) {
module.exports = Promise.all([
    require("5c04475dac2e5c53")(require("16a58bbade0c6958").resolve("1KR3J")),
    require("68ce32b8c7a0a8a6")(require("16a58bbade0c6958").resolve("bifwG")),
    require("5c04475dac2e5c53")(require("16a58bbade0c6958").resolve("9lHm7"))
]).then(()=>module.bundle.root("4nGXa"));

},{"5c04475dac2e5c53":"9wKyf","16a58bbade0c6958":"gSiLw","68ce32b8c7a0a8a6":"4NBCd"}],"9wKyf":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"e8xyU"}],"e8xyU":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"4NBCd":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e8xyU"}],"dNhmt":[function(require,module,exports) {
module.exports = require("2637c85776a31f85")(require("ebe798387bf0e876").resolve("61VTa")).then(()=>module.bundle.root("2nJJZ"));

},{"2637c85776a31f85":"9wKyf","ebe798387bf0e876":"gSiLw"}],"7wvZW":[function(require,module,exports) {
module.exports = Promise.all([
    require("f09bb09071124f67")(require("192d2d5d6904b3ce").resolve("goaI4")),
    require("f09bb09071124f67")(require("192d2d5d6904b3ce").resolve("6q5oh")),
    require("f09bb09071124f67")(require("192d2d5d6904b3ce").resolve("1wB3e"))
]).then(()=>module.bundle.root("i6x8j"));

},{"f09bb09071124f67":"9wKyf","192d2d5d6904b3ce":"gSiLw"}],"bAPlJ":[function(require,module,exports) {
module.exports = Promise.all([
    require("1cad5bc29e33ce86")(require("e390971f5272f2d8").resolve("goaI4")),
    require("1cad5bc29e33ce86")(require("e390971f5272f2d8").resolve("6q5oh")),
    require("1cad5bc29e33ce86")(require("e390971f5272f2d8").resolve("i9L63"))
]).then(()=>module.bundle.root("9PySL"));

},{"1cad5bc29e33ce86":"9wKyf","e390971f5272f2d8":"gSiLw"}],"70dmO":[function(require,module,exports) {
module.exports = require("f3e4defb3fd81875")(require("dcdbd414ad4fa381").resolve("b3qpy")).then(()=>module.bundle.root("7ICkQ"));

},{"f3e4defb3fd81875":"9wKyf","dcdbd414ad4fa381":"gSiLw"}],"lSzq7":[function(require,module,exports) {
module.exports = Promise.all([
    require("c343781ab0dd1889")(require("163f11e40c50229").resolve("goaI4")),
    require("c343781ab0dd1889")(require("163f11e40c50229").resolve("f9UfM"))
]).then(()=>module.bundle.root("fa6z4"));

},{"c343781ab0dd1889":"9wKyf","163f11e40c50229":"gSiLw"}],"kXOSG":[function(require,module,exports) {
module.exports = Promise.all([
    require("f0cb273121881580")(require("3f5d21b998b5ba24").resolve("1FALr")),
    require("f0cb273121881580")(require("3f5d21b998b5ba24").resolve("eXfMO"))
]).then(()=>module.bundle.root("dsD6N"));

},{"f0cb273121881580":"9wKyf","3f5d21b998b5ba24":"gSiLw"}],"uPgny":[function(require,module,exports) {
module.exports = Promise.all([
    require("9dce9efa79b528c3")(require("15d2031e4fc058f0").resolve("e1CxH")),
    require("9dce9efa79b528c3")(require("15d2031e4fc058f0").resolve("iYuT9"))
]).then(()=>module.bundle.root("91Qns"));

},{"9dce9efa79b528c3":"9wKyf","15d2031e4fc058f0":"gSiLw"}],"eYU2k":[function(require,module,exports) {
module.exports = require("dff288ae862db793")(require("2eec1b82d5ef940c").resolve("krlPL")).then(()=>module.bundle.root("4Itrk"));

},{"dff288ae862db793":"9wKyf","2eec1b82d5ef940c":"gSiLw"}],"lN2rM":[function(require,module,exports) {
module.exports = require("5f1a2765362c60f7")(require("268b90aa2c619cb4").resolve("7ill1")).then(()=>module.bundle.root("4BnRF"));

},{"5f1a2765362c60f7":"9wKyf","268b90aa2c619cb4":"gSiLw"}],"a5vyp":[function(require,module,exports) {
module.exports = require("39764a12d529f969")(require("c1fa34f1467049c5").resolve("5oCeX")).then(()=>module.bundle.root("eg3z5"));

},{"39764a12d529f969":"9wKyf","c1fa34f1467049c5":"gSiLw"}],"bQcdR":[function(require,module,exports) {
module.exports = Promise.all([
    require("bc5ce4227c6b7847")(require("b4b468f7ce2c6132").resolve("e1CxH")),
    require("bc5ce4227c6b7847")(require("b4b468f7ce2c6132").resolve("f7Gyb"))
]).then(()=>module.bundle.root("xKD2u"));

},{"bc5ce4227c6b7847":"9wKyf","b4b468f7ce2c6132":"gSiLw"}],"gNZTL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFound", ()=>NotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _withAuth = require("../Components/withAuth");
var _withAuthDefault = parcelHelpers.interopDefault(_withAuth);
var _routes = require("../Constants/Routes");
var _iconsContext = require("../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
var _constants = require("../Styles/constants");
function NotFound(props) {
    const { history } = props;
    const { errorPageIcon } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Container), {
        fluid: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _styleDefault.default).dynamic([
                    [
                        "2731765609",
                        [
                            (0, _constants.MOBILE_MAIN_HEIGHT),
                            (0, _constants.MAIN_HEIGHT)
                        ]
                    ]
                ]) + " " + "not-found-container row bg-background-gray ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: (0, _styleDefault.default).dynamic([
                        [
                            "2731765609",
                            [
                                (0, _constants.MOBILE_MAIN_HEIGHT),
                                (0, _constants.MAIN_HEIGHT)
                            ]
                        ]
                    ]) + " " + "not-found-inner-container bg-white m-2 m-md-4 d-flex flex-column justify-content-center align-items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: errorPageIcon,
                            alt: "Page Not Found",
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "2731765609",
                                    [
                                        (0, _constants.MOBILE_MAIN_HEIGHT),
                                        (0, _constants.MAIN_HEIGHT)
                                    ]
                                ]
                            ]) + " " + "not-found-icon my-n5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "2731765609",
                                    [
                                        (0, _constants.MOBILE_MAIN_HEIGHT),
                                        (0, _constants.MAIN_HEIGHT)
                                    ]
                                ]
                            ]) + " " + "text-gray text-center mt-n5",
                            children: `we can't seem to find the page you're looking for`
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _styleDefault.default).dynamic([
                                [
                                    "2731765609",
                                    [
                                        (0, _constants.MOBILE_MAIN_HEIGHT),
                                        (0, _constants.MAIN_HEIGHT)
                                    ]
                                ]
                            ]) + " " + "button-container d-flex justify-content-around mt-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>{
                                        history.push((0, _routes.MAP));
                                    },
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "2731765609",
                                            [
                                                (0, _constants.MOBILE_MAIN_HEIGHT),
                                                (0, _constants.MAIN_HEIGHT)
                                            ]
                                        ]
                                    ]) + " " + "btn modal-button-primary px-md-5",
                                    children: "go home"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>{
                                        history.goBack();
                                    },
                                    className: (0, _styleDefault.default).dynamic([
                                        [
                                            "2731765609",
                                            [
                                                (0, _constants.MOBILE_MAIN_HEIGHT),
                                                (0, _constants.MAIN_HEIGHT)
                                            ]
                                        ]
                                    ]) + " " + "btn btn-outline-secondary text-gray ml-4 px-md-5 back-button",
                                    children: "back"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2731765609",
                dynamic: [
                    (0, _constants.MOBILE_MAIN_HEIGHT),
                    (0, _constants.MAIN_HEIGHT)
                ],
                children: `.not-found-container.__jsx-style-dynamic-selector{height:${(0, _constants.MOBILE_MAIN_HEIGHT)};}.not-found-inner-container.__jsx-style-dynamic-selector{width:calc(100% - 1rem);border-radius:0.5rem;}.not-found-icon.__jsx-style-dynamic-selector{-webkit-transform:scale(0.3);-ms-transform:scale(0.3);transform:scale(0.3);}.button-container.__jsx-style-dynamic-selector{width:100%;}.text-gray.__jsx-style-dynamic-selector{color:var(--text-light-gray);}.back-button.__jsx-style-dynamic-selector:hover{color:white;}@media (min-width:768px){.not-found-inner-container.__jsx-style-dynamic-selector{width:calc(100% - 3rem);}.not-found-icon.__jsx-style-dynamic-selector{-webkit-transform:scale(0.5);-ms-transform:scale(0.5);transform:scale(0.5);}.button-container.__jsx-style-dynamic-selector{width:30%;}}@media (min-width:992px){.not-found-container.__jsx-style-dynamic-selector{height:${(0, _constants.MAIN_HEIGHT)};}}`
            })
        ]
    });
}
exports.default = (0, _withAuthDefault.default)(NotFound);
NotFound.propTypes = {
    history: (0, _propTypesDefault.default).object,
    width: (0, _propTypesDefault.default).number
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","../Components/withAuth":"5591i","../Constants/Routes":"3Lt5k","../Context/IconsContext":"lzIpe","../Styles/constants":"gIVbf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8uEx":[function(require,module,exports) {
module.exports = Promise.all([
    require("4210cbe7506278e9")(require("bdb09c401ca1a37e").resolve("bRUTa")),
    require("4210cbe7506278e9")(require("bdb09c401ca1a37e").resolve("1FALr")),
    require("4210cbe7506278e9")(require("bdb09c401ca1a37e").resolve("1KR3J")),
    require("7da991ef809ea83b")(require("bdb09c401ca1a37e").resolve("lD7Sw")),
    require("7da991ef809ea83b")(require("bdb09c401ca1a37e").resolve("bifwG")),
    require("4210cbe7506278e9")(require("bdb09c401ca1a37e").resolve("bwQ00"))
]).then(()=>module.bundle.root("26mT3"));

},{"4210cbe7506278e9":"9wKyf","bdb09c401ca1a37e":"gSiLw","7da991ef809ea83b":"4NBCd"}],"cYj99":[function(require,module,exports) {
module.exports = require("c1fe71c20a041301")(require("f45d973d09bf4fc8").resolve("5Julu")).then(()=>module.bundle.root("7gcqT"));

},{"c1fe71c20a041301":"9wKyf","f45d973d09bf4fc8":"gSiLw"}],"cRmIF":[function(require,module,exports) {
module.exports = require("1ccbd4880dcb63f8")(require("4280c8f00ac81e85").resolve("LhgSH")).then(()=>module.bundle.root("jAstr"));

},{"1ccbd4880dcb63f8":"9wKyf","4280c8f00ac81e85":"gSiLw"}],"6nSzI":[function(require,module,exports) {
module.exports = Promise.all([
    require("bd3700513c969ebb")(require("71364fae014fc3a5").resolve("bRUTa")),
    require("7f508189802f0b1a")(require("71364fae014fc3a5").resolve("bifwG")),
    require("bd3700513c969ebb")(require("71364fae014fc3a5").resolve("5HoNl"))
]).then(()=>module.bundle.root("dolSw"));

},{"bd3700513c969ebb":"9wKyf","71364fae014fc3a5":"gSiLw","7f508189802f0b1a":"4NBCd"}],"3dwjU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _reactImage = require("react-image");
var _exitSubOrgContext = require("../../Context/ExitSubOrgContext");
var _orgsMapContext = require("../../Context/OrgsMapContext");
var _orgsMapContextDefault = parcelHelpers.interopDefault(_orgsMapContext);
var _toggleSidebarContext = require("../../Context/ToggleSidebarContext");
var _toggleSidebarContextDefault = parcelHelpers.interopDefault(_toggleSidebarContext);
var _authService = require("../../Services/AuthService");
var _authServiceDefault = parcelHelpers.interopDefault(_authService);
var _can = require("../../RBAC/Can");
var _canDefault = parcelHelpers.interopDefault(_can);
var _editOrgModal = require("./EditOrgModal");
var _editOrgModalDefault = parcelHelpers.interopDefault(_editOrgModal);
var _imageErrorBoundary = require("../ImageErrorBoundary");
var _imageErrorBoundaryDefault = parcelHelpers.interopDefault(_imageErrorBoundary);
var _inventoryResources = require("../../Constants/InventoryResources");
var _rbac = require("../../Constants/RBAC");
var _zIndex = require("../../Styles/Z-INDEX");
exports.default = /*#__PURE__*/ (0, _react.forwardRef)(InventorySidebar);
const { className: pageLinks, styles: linkStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "1480394601",
        children: "a.jsx-1480394601{color:var(--icon-link-gray);}a.jsx-1480394601:hover{color:var(--text-muted);}"
    }),
    className: "jsx-1480394601"
};
const { className: tooltipClass, styles: tooltipStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "815359974",
        children: `div.jsx-815359974{z-index:${(0, _zIndex.STICKY_OVERRIDE)};}`
    }),
    className: "jsx-815359974"
};
const initState = {
    assetCount: 0,
    editOrgModalOpen: false,
    error: "",
    exitOrgModalOpen: false,
    subOrgAssetCount: 0
};
function InventorySidebar(props, ref) {
    const [state, updateState] = (0, _react.useState)(initState);
    const exitSubOrg = (0, _react.useContext)((0, _exitSubOrgContext.ExitSubOrgContext));
    const orgsMap = (0, _react.useContext)((0, _orgsMapContextDefault.default));
    const toggleSidebarCollapsed = (0, _react.useContext)((0, _toggleSidebarContextDefault.default));
    const auth = (0, _react.useMemo)(()=>new (0, _authServiceDefault.default)(), []);
    const desktopView = props.width >= 992;
    const rootOrgID = auth.getUserRootOrgID();
    const userCount = props.currentOrg?.Users?.length ?? 0;
    const closeEditModal = ()=>{
        updateState((prevState)=>({
                ...prevState,
                editOrgModalOpen: false
            }));
    };
    const exitOrg = ()=>{
        if (auth.getUserRootOrgID() === props.currentOrg?._id) return;
        const { path = "" } = props.currentOrg || {};
        const pathArray = path.split(".");
        const targetOrgID = pathArray[pathArray.length - 2];
        const { name = "" } = orgsMap?.[targetOrgID] || {};
        exitSubOrg(targetOrgID, name);
    };
    const loadCurrentOrgInfo = ()=>{
        if (props.currentOrg?.childOrgGatewayCount === state.subOrgAssetCount && props.currentOrg?.gatewayCount === state.assetCount) return;
        updateState((prevState)=>({
                ...prevState,
                assetCount: props.currentOrg?.gatewayCount,
                subOrgAssetCount: props.currentOrg?.childOrgGatewayCount
            }));
    };
    const toggleEditModal = ()=>{
        updateState((prevState)=>({
                ...prevState,
                editOrgModalOpen: !prevState.editOrgModalOpen
            }));
    };
    const updateAssetCount = (action)=>{
        updateState((prevState)=>({
                ...prevState,
                assetCount: action === "add" ? prevState.assetCount + 1 : prevState.assetCount - 1
            }));
    };
    (0, _react.useEffect)(()=>{
        if (!props?.currentOrg?.childOrgGatewayCount && !props?.currentOrg?.gatewayCount) return;
        loadCurrentOrgInfo();
    }, [
        props?.currentOrg?.childOrgGatewayCount,
        props?.currentOrg?.gatewayCount
    ]);
    (0, _react.useImperativeHandle)(ref, ()=>({
            updateAssetCount
        }));
    function Fallback() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            className: `mx-0 ${props.sidebarCollapsed ? "d-block d-lg-none" : ""} mx-lg-auto`,
            color: "var(--brand-primary)",
            icon: (0, _freeSolidSvgIcons.faBuilding),
            size: "3x"
        });
    }
    function OrgLogoImage() {
        const { src } = (0, _reactImage.useImage)({
            srcList: props.currentOrg?.logo
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            alt: "organization logo",
            className: `img-fluid mx-lg-auto d-inline-block ${props.sidebarCollapsed && "d-block d-lg-none"} ${desktopView ? "mx-0 " : "ml-4"}`,
            src: src,
            style: {
                maxHeight: "3rem",
                maxWidth: "12rem"
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-1774700608 w-100 h-100 position-absolute",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-1774700608 org-details-wrapper py-3 px-3 pb-lg-3 h-100 w-100 container d-flex flex-column align-self-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1774700608 mb-3 row justify-content-center pl-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageErrorBoundaryDefault.default), {
                                color: "var(--brand-primary)",
                                icon: (0, _freeSolidSvgIcons.faBuilding),
                                iconClassName: `mx-0 ${props.sidebarCollapsed ? "d-block d-lg-none" : ""} mx-lg-auto`,
                                iconSize: "3x",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Fallback, {
                                        className: "jsx-1774700608"
                                    }),
                                    children: props.currentOrg?._id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrgLogoImage, {
                                        className: "jsx-1774700608"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Fallback, {
                                        className: "jsx-1774700608"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                style: {
                                    width: "50px"
                                },
                                onClick: toggleSidebarCollapsed,
                                className: "jsx-1774700608 btn shadow-none mt-2 d-inline-block d-lg-none",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    color: "var(--brand-primary)",
                                    icon: props.sidebarCollapsed ? (0, _freeSolidSvgIcons.faChevronDown) : (0, _freeSolidSvgIcons.faChevronUp),
                                    size: "lg"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-1774700608 " + `org-name-container row ${props.sidebarCollapsed && "d-flex d-lg-none"}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            className: "jsx-1774700608 mx-auto mb-2 mt-md-0 font-weight-light text-center",
                            children: props.currentOrg?.name || ""
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-1774700608 " + `
            ${props.sidebarCollapsed ? "d-none" : "d-flex flex-column"} ${desktopView ? "flex-grow-1" : ""}
            `,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1774700608 row text-center mt-0 mt-lg-2 mb-0 mb-lg-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
                                        no: (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                "data-tip": data,
                                                className: "jsx-1774700608 col-4 col-md-5 offset-1 text-center",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    disabled: true,
                                                    className: "jsx-1774700608 btn btn-sm btn-outline-secondary",
                                                    children: "Edit"
                                                })
                                            }),
                                        orgID: props.currentOrg?._id,
                                        perform: (0, _rbac.ORGANIZATION_UPDATE),
                                        resource: (0, _rbac.ORGANIZATION),
                                        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "jsx-1774700608 col-4 col-md-5 offset-1 text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        onClick: toggleEditModal,
                                                        disabled: !props.currentOrg?._id,
                                                        className: "jsx-1774700608 btn btn-sm btn-outline-secondary",
                                                        children: "Edit"
                                                    }),
                                                    state.editOrgModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editOrgModalDefault.default), {
                                                        closeModal: closeEditModal,
                                                        isOpen: state.editOrgModalOpen,
                                                        org: props.currentOrg,
                                                        toggleModal: toggleEditModal,
                                                        updateOrg: props.updateOrg
                                                    })
                                                ]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-1774700608 col-4 col-md-5 offset-2 offset-md-0 text-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            disabled: rootOrgID === props.currentOrg?._id,
                                            onClick: exitOrg,
                                            className: "jsx-1774700608 btn btn-sm btn-outline-secondary",
                                            children: "Exit Org"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1774700608 divide-border d-none d-lg-block"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1774700608 row text-nowrap text-center mt-2 mb-0 mb-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-1774700608 col-4 col-md-5 offset-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "jsx-1774700608",
                                                children: "Assets"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                className: "jsx-1774700608 font-weight-normal",
                                                children: state.assetCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-1774700608 col-4 col-md-5 offset-2 offset-md-0",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "jsx-1774700608",
                                                children: "Sub Org Assets"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                className: "jsx-1774700608 font-weight-normal",
                                                children: state.subOrgAssetCount
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-1774700608 row text-nowrap text-center mb-0 mb-lg-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-1774700608 col-4 col-md-5 offset-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "jsx-1774700608",
                                                children: "Sub Orgs"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                className: "jsx-1774700608 font-weight-normal",
                                                children: props.currentOrg?.childOrgCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-1774700608 col-4 col-md-5 offset-2 offset-md-0",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "jsx-1774700608",
                                                children: "Users"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                className: "jsx-1774700608 font-weight-normal",
                                                children: userCount
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1774700608 divide-border d-none d-lg-block"
                            }),
                            !props.rules ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1774700608 d-none d-lg-block mx-lg-n3 pt-2 flex-grow-1 outer-inventory-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "jsx-1774700608 inner-inventory-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResourceNavLink, {
                                            displayText: "Assets",
                                            isSelected: props.selected === (0, _inventoryResources.ASSETS),
                                            orgID: props.currentOrg?._id,
                                            pageLink: `/organization/${(0, _inventoryResources.ASSETS)}`,
                                            perform: (0, _rbac.CORE_READ),
                                            resource: (0, _rbac.CORE)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResourceNavLink, {
                                            displayText: "Asset Models",
                                            isSelected: props.selected === (0, _inventoryResources.ASSET_MODELS),
                                            orgID: props.currentOrg?._id,
                                            pageLink: `/organization/${(0, _inventoryResources.ASSET_MODELS)}`,
                                            perform: (0, _rbac.ASSET_MODEL_READ),
                                            resource: (0, _rbac.ASSET_MODEL)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResourceNavLink, {
                                            displayText: "Geofences",
                                            isSelected: props.selected === (0, _inventoryResources.GEOFENCES),
                                            orgID: props.currentOrg?._id,
                                            pageLink: `/organization/${(0, _inventoryResources.GEOFENCES)}`,
                                            perform: (0, _rbac.GEOFENCE_READ),
                                            resource: (0, _rbac.GEOFENCE)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResourceNavLink, {
                                            displayText: "Sub-Orgs",
                                            isSelected: props.selected === (0, _inventoryResources.SUB_ORGS),
                                            orgID: props.currentOrg?._id,
                                            pageLink: `/organization/${(0, _inventoryResources.SUB_ORGS)}`,
                                            perform: (0, _rbac.ORGANIZATION_READ),
                                            resource: (0, _rbac.ORGANIZATION)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResourceNavLink, {
                                            displayText: "Users",
                                            isSelected: props.selected === (0, _inventoryResources.USERS),
                                            orgID: props.currentOrg?._id,
                                            pageLink: `/organization/${(0, _inventoryResources.USERS)}`,
                                            perform: (0, _rbac.USER_READ),
                                            resource: (0, _rbac.USER)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ResourceNavLink, {
                                            displayText: "User Profiles",
                                            isSelected: props.selected === (0, _inventoryResources.USER_PROFILES),
                                            orgID: props.currentOrg?._id,
                                            pageLink: `/organization/${(0, _inventoryResources.USER_PROFILES)}`,
                                            perform: (0, _rbac.USER_PROFILE_READ),
                                            resource: (0, _rbac.USER_PERMISSION)
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1774700608 flex-grow-1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-1774700608 d-flex justify-content-center align-items-center mt-lg-0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "jsx-1774700608 text-elevat-blue",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "jsx-1774700608 nine-tenth-text",
                                            children: "powered by"
                                        }),
                                        " elev\u0101t"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                className: tooltipClass
            }),
            linkStyles,
            tooltipStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "1774700608",
                children: "p.jsx-1774700608{font-size:0.8rem;margin-bottom:0rem;color:var(--muted-gray);}.btn.jsx-1774700608,.btn-outline-secondary.jsx-1774700608{cursor:pointer;width:80px;padding:0;}@media (min-width:768px){.page-indicator.jsx-1774700608{height:30px;width:5px;left:0;background-color:var(--brand-primary);}.org-info.jsx-1774700608{margin-top:2 rem;}}@media (min-width:992px){.outer-inventory-container.jsx-1774700608{position:relative;height:auto;}.inner-inventory-container.jsx-1774700608{position:absolute;height:100%;width:100%;overflow:auto;}}"
            })
        ]
    });
}
InventorySidebar.propTypes = {
    currentOrg: (0, _propTypesDefault.default).object,
    rules: (0, _propTypesDefault.default).bool,
    selected: (0, _propTypesDefault.default).string,
    sidebarCollapsed: (0, _propTypesDefault.default).bool,
    updateOrg: (0, _propTypesDefault.default).func,
    width: (0, _propTypesDefault.default).number
};
function ResourceNavLink(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canDefault.default), {
        no: ()=>null,
        orgID: props.orgID,
        perform: props.perform,
        resource: props.resource,
        yes: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2481288750 mt-3 mb-3",
                children: [
                    props.isSelected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2481288750 page-indicator position-absolute"
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: props.pageLink,
                        className: props.isSelected ? "text-muted text-decoration-none ml-lg-5" : `text-decoration-none ${pageLinks} ml-lg-5`,
                        children: props.displayText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                        id: "2481288750",
                        children: "@media (min-width:768px){.page-indicator.jsx-2481288750{height:30px;width:5px;left:0;background-color:var(--brand-primary);}}"
                    })
                ]
            })
    });
}
ResourceNavLink.propTypes = {
    displayText: (0, _propTypesDefault.default).string,
    isSelected: (0, _propTypesDefault.default).bool,
    orgID: (0, _propTypesDefault.default).string,
    pageLink: (0, _propTypesDefault.default).string,
    perform: (0, _propTypesDefault.default).string,
    resource: (0, _propTypesDefault.default).string
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-router-dom":"3uzXR","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","react-tooltip":"4ejwp","react-image":"d5uD5","../../Context/ExitSubOrgContext":"cUD9x","../../Context/OrgsMapContext":"asozp","../../Context/ToggleSidebarContext":"g92ON","../../Services/AuthService":"8Bjjn","../../RBAC/Can":"l4l8D","./EditOrgModal":"aCmoj","../ImageErrorBoundary":"ed3Vy","../../Constants/InventoryResources":"5NOrc","../../Constants/RBAC":"ieo1E","../../Styles/Z-INDEX":"CxzKK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUD9x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExitSubOrgContext", ()=>ExitSubOrgContext);
parcelHelpers.export(exports, "ExitSubOrgProvider", ()=>ExitSubOrgProvider);
parcelHelpers.export(exports, "ExitSubOrgConsumer", ()=>ExitSubOrgConsumer);
var _react = require("react");
const ExitSubOrgContext = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const ExitSubOrgProvider = ExitSubOrgContext.Provider;
const ExitSubOrgConsumer = ExitSubOrgContext.Consumer;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g92ON":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleSidebarContextProvider", ()=>ToggleSidebarContextProvider);
parcelHelpers.export(exports, "ToggleSidebarContextConsumer", ()=>ToggleSidebarContextConsumer);
var _react = require("react");
const ToggleSidebarContext = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const ToggleSidebarContextProvider = ToggleSidebarContext.Provider;
const ToggleSidebarContextConsumer = ToggleSidebarContext.Consumer;
exports.default = ToggleSidebarContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCmoj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _rbac = require("../../Constants/RBAC");
var _accessTools = require("../../RBAC/AccessTools");
var _accountService = require("../../Services/AccountService");
var _accountServiceDefault = parcelHelpers.interopDefault(_accountService);
var _fileHelpers = require("../../Lib/FileHelpers");
var _orgBilling = require("./OrgBilling");
var _orgBillingDefault = parcelHelpers.interopDefault(_orgBilling);
var _orgBranding = require("./OrgBranding");
var _orgBrandingDefault = parcelHelpers.interopDefault(_orgBranding);
var _orgContactInfo = require("./OrgContactInfo");
var _orgContactInfoDefault = parcelHelpers.interopDefault(_orgContactInfo);
var _orgFeatures = require("./OrgFeatures");
var _orgFeaturesDefault = parcelHelpers.interopDefault(_orgFeatures);
exports.default = /*#__PURE__*/ (0, _react.memo)(EditOrgModal);
const LOGO_ERROR_MSG = "Error. Unknown file type.";
const { className: modalClass, styles: modalStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3995685333",
        children: "@media (max-width:991px){.modal-dialog.jsx-3995685333{height:100%;width:100%;max-height:100%;max-width:100%;margin:0;}}"
    }),
    className: "jsx-3995685333"
};
const { className: contentClass, styles: contentStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "3315043947",
        children: "@media (max-width:767px){.modal-content.jsx-3315043947{display:grid;grid-template-rows:60px auto 60px;}}@media (max-width:991px){.modal-content.jsx-3315043947{height:100%;}}"
    }),
    className: "jsx-3315043947"
};
const { className: modalBodyClass, styles: modalBodyStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2109908522",
        children: ".modal-body.jsx-2109908522{padding:0;overflow:auto;}@media (min-width:768px){.modal-body.jsx-2109908522{border-bottom-left-radius:1rem;border-bottom-right-radius:1rem;}}"
    }),
    className: "jsx-2109908522"
};
const initState = {
    error: "",
    org: {},
    updateRequestPending: false,
    viewing: "details"
};
function EditOrgModal(props) {
    const [state, updateState] = (0, _react.useState)(()=>{
        const propsToInclude = [
            "account_id",
            "account_type",
            "city",
            "logo",
            "name",
            "phoneNumber",
            "settings",
            "street1",
            "street2",
            "state",
            "subscription_terms",
            "zip"
        ];
        const org = Object.entries(props?.org ?? {}).reduce((acc, [key, prop])=>{
            if (!prop || !propsToInclude.includes(key)) return acc;
            acc[key] = prop;
            return acc;
        }, {});
        const { billing: { enabled = false } = {}, csvExport: { signals } = {}, cumminsenabled = false, maintenance_v1: { enabled: maintenance_v1 = false } = {}, maintenance_v2: { enabled: maintenance_v2 = false } = {}, parts = false, remote = false } = props.org?.features || {};
        return {
            ...initState,
            billingEnabled: enabled,
            csvExport: !!signals,
            cumminsenabled,
            maintenance_v1,
            maintenance_v2,
            org,
            parts,
            remote
        };
    });
    const hasBilling = (0, _react.useMemo)(()=>props.currentOrg?.features?.billing?.enabled ?? false, [
        props.currentOrg?.features?.billing?.enabled
    ]), hasCsvReports = (0, _react.useMemo)(()=>!!props.currentOrg?.features?.csvExport?.signals, [
        props.currentOrg?.features?.csvExport?.signals
    ]), hasCumminsenabled = (0, _react.useMemo)(()=>props.currentOrg?.features?.cumminsenabled ?? false, [
        props.currentOrg?.features?.cumminsenabled
    ]), hasMaintenanceV1 = (0, _react.useMemo)(()=>props.currentOrg?.features?.maintenance_v1?.enabled ?? false, [
        props.currentOrg?.features?.maintenance_v1?.enabled
    ]), hasMaintenanceV2 = (0, _react.useMemo)(()=>props.currentOrg?.features?.maintenance_v2?.enabled ?? false, [
        props.currentOrg?.features?.maintenance_v2?.enabled
    ]), hasParts = (0, _react.useMemo)(()=>props.currentOrg?.features?.parts ?? false, [
        props.currentOrg?.features?.parts
    ]), hasRemote = (0, _react.useMemo)(()=>props.currentOrg?.features?.remote ?? false, [
        props.currentOrg?.features?.remote
    ]);
    const featuresAvailable = (0, _react.useMemo)(()=>{
        return hasBilling || hasCsvReports || hasMaintenanceV1 || hasMaintenanceV2 || hasParts || hasRemote;
    }, [
        hasBilling,
        hasCsvReports,
        hasMaintenanceV1,
        hasMaintenanceV2,
        hasParts,
        hasRemote
    ]);
    const accountService = (0, _react.useMemo)(()=>new (0, _accountServiceDefault.default)(), []);
    const handleFeaturesUpdate = ({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const handlePhoneNumberUpdate = ({ target: { name, value } })=>{
        const rawNumber = value.replace(/\D/g, "");
        updateState((prevState)=>({
                ...prevState,
                org: {
                    ...prevState.org,
                    [name]: rawNumber
                }
            }));
    };
    const handlePropUpdate = ({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                org: {
                    ...prevState.org,
                    [name]: value
                }
            }));
    };
    const handleSettingsUpdate = ({ target: { name, value } })=>{
        updateState((prevState)=>({
                ...prevState,
                org: {
                    ...prevState.org,
                    settings: {
                        ...prevState.org?.settings || {},
                        [name]: value
                    }
                }
            }));
    };
    const onDrop = ([file])=>{
        try {
            const handleError = ()=>updateState((prevState)=>({
                        ...prevState,
                        error: LOGO_ERROR_MSG
                    }));
            const handleSuccess = (logo)=>{
                updateState((prevState)=>({
                        ...prevState,
                        error: "",
                        org: {
                            ...state.org,
                            logo
                        }
                    }));
            };
            (0, _fileHelpers.handleImageFileConversion)(file, handleError, handleSuccess);
        } catch (error) {
            updateState((prevState)=>({
                    ...prevState,
                    error: LOGO_ERROR_MSG
                }));
        }
    };
    const submitUpdate = async (e)=>{
        e.preventDefault();
        try {
            updateState((prevState)=>({
                    ...prevState,
                    updateRequestPending: true
                }));
            const apps = !state.cumminsenabled ? props.org.features.apps?.filter((a)=>a !== "engineanalysis") || [] // if not cumminsenabled, make sure engineanalysis is not in apps
             : !Array.isArray(props.org.features.apps) // if enabling for the first time then apps may not be defined if org does not have waterpump app either
             ? [
                "engineanalysis"
            ] : !props.org.features.apps.includes("engineanalysis") // if enabling and apps already exists, first check if it already has engineanalysis to avoid duplicates
             ? props.org.features.apps.concat("engineanalysis") : props.org.features.apps;
            const billing = props.org.features.billing ? {
                billing: props.org.features.billing
            } : !hasBilling ? {} : state.billingEnabled ? {
                billing: {
                    enabled: true
                }
            } : {};
            const csvExport = props.org.features?.csvExport?.signals && state.csvExport ? props.org.features.csvExport : !props.org.features?.csvExport?.signals && state.csvExport ? props.currentOrg.features?.csvExport : {};
            const maintenance_v1 = {
                enabled: state.maintenance_v1
            }, maintenance_v2 = {
                enabled: state.maintenance_v2
            };
            const reqBody = {
                ...state.org,
                features: {
                    ...props.org.features,
                    apps,
                    ...billing,
                    csvExport,
                    cumminsenabled: state.cumminsenabled,
                    maintenance_v1,
                    maintenance_v2,
                    parts: state.parts,
                    remote: state.remote
                }
            };
            const update = await accountService.updateOrgDetails(props.org._id, reqBody);
            if (props.isSubOrgEdit) return props.handleSubOrgEdit(update);
            props.updateOrg(update);
            props.closeModal();
        } catch (err) {
            const error = err.response?.data?.message ?? err.message;
            updateState((prevState)=>({
                    ...prevState,
                    error,
                    updateRequestPending: false
                }));
        }
    };
    const toggleView = (viewing)=>{
        if (state.viewing === viewing) return;
        updateState((prevState)=>({
                ...prevState,
                viewing
            }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactstrap.Modal), {
        isOpen: props.isOpen,
        toggle: props.toggleModal,
        centered: true,
        size: "lg",
        className: modalClass,
        contentClassName: contentClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalHeader), {
                toggle: props.toggleModal,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "jsx-2163660362 font-weight-light text-text-light-gray",
                    children: "Organization Settings"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactstrap.ModalBody), {
                className: modalBodyClass,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "jsx-2163660362 container-fluid",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "jsx-2163660362 row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2163660362 d-none d-md-block col-3 bg-background-gray pt-3 pl-2 modal-side-nav-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2163660362 mb-3",
                                        children: [
                                            state.viewing === "details" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2163660362 page-indicator position-absolute"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>toggleView("details"),
                                                className: "jsx-2163660362 " + `btn btn-link view-link text-nowrap p-0 w-100 font-weight-medium-2 text-left text-decoration-none ${state.viewing === "details" && "text-muted"}`,
                                                children: "Org Details"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2163660362 mb-3",
                                        children: [
                                            state.viewing === "branding" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2163660362 page-indicator position-absolute"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>toggleView("branding"),
                                                className: "jsx-2163660362 " + `btn btn-link view-link text-nowrap p-0 w-100 font-weight-medium-2 text-left text-decoration-none ${state.viewing === "branding" && "text-muted"}`,
                                                children: "Branding"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2163660362 mb-3",
                                        children: [
                                            state.viewing === "billing" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2163660362 page-indicator position-absolute"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>toggleView("billing"),
                                                className: "jsx-2163660362 " + `btn btn-link view-link text-nowrap p-0 w-100 font-weight-medium-2 text-left text-decoration-none ${state.viewing === "billing" && "text-muted"}`,
                                                children: "Billing Info"
                                            })
                                        ]
                                    }),
                                    props.isSubOrgEdit && (0, _accessTools.hasWriteAccessToResource)(state.org?._id, (0, _rbac.ORGANIZATION)) && featuresAvailable ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "jsx-2163660362 mb-3",
                                        children: [
                                            state.viewing === "features" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "jsx-2163660362 page-indicator position-absolute"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>toggleView("features"),
                                                className: "jsx-2163660362 " + `btn btn-link view-link text-nowrap p-0 w-100 font-weight-medium-2 text-left text-decoration-none ${state.viewing === "features" && "text-muted"}`,
                                                children: "Features"
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2163660362 col-12 col-md-9 bg-white container edit-org-content-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                    onSubmit: submitUpdate,
                                    className: "jsx-2163660362",
                                    children: [
                                        (()=>{
                                            switch(state.viewing){
                                                case "details":
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orgContactInfoDefault.default), {
                                                        org: state.org,
                                                        handlePropUpdate: handlePropUpdate,
                                                        handleSettingsUpdate: handleSettingsUpdate,
                                                        handlePhoneNumberUpdate: handlePhoneNumberUpdate
                                                    });
                                                case "branding":
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orgBrandingDefault.default), {
                                                        org: state.org,
                                                        onDrop: onDrop
                                                    });
                                                case "billing":
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orgBillingDefault.default), {
                                                        handlePropUpdate: handlePropUpdate,
                                                        org: state.org
                                                    });
                                                case "features":
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orgFeaturesDefault.default), {
                                                        billingEnabled: state.billingEnabled,
                                                        csvExport: state.csvExport,
                                                        cumminsenabled: state.cumminsenabled,
                                                        handleFeaturesUpdate: handleFeaturesUpdate,
                                                        hasBilling: hasBilling,
                                                        hasCsvReports: hasCsvReports,
                                                        hasCumminsenabled: hasCumminsenabled,
                                                        hasMaintenanceV1: hasMaintenanceV1,
                                                        hasMaintenanceV2: hasMaintenanceV1,
                                                        hasParts: hasParts,
                                                        hasRemote: hasRemote,
                                                        maintenance_v1: state.maintenance_v1,
                                                        maintenance_v2: state.maintenance_v2,
                                                        orgHasBillingEnabled: props.org?.features?.billing?.enabled,
                                                        parts: state.parts,
                                                        remote: state.remote
                                                    });
                                                default:
                                                    return null;
                                            }
                                        })(),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "jsx-2163660362 row form-buttons-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "jsx-2163660362 col",
                                                children: [
                                                    state.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "jsx-2163660362 float-left text-danger col-12 col-md-6",
                                                        children: state.error
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "submit",
                                                        className: "jsx-2163660362 btn btn-sm modal-button-submit p-0 float-right save-button",
                                                        children: state.updateRequestPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                            icon: (0, _freeSolidSvgIcons.faCircleNotch),
                                                            spin: true,
                                                            size: "lg"
                                                        }) : "Save"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        onClick: props.toggleModal,
                                                        className: "jsx-2163660362 btn btn-small btn-outline-secondary p-0 float-right cancel-button",
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2163660362 d-flex align-items-center justify-content-around d-md-none d-lg-none d-xl-none w-100 bg-white border-top",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>toggleView("details"),
                        className: "jsx-2163660362 btn btn-link d-flex flex-column align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2163660362",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "jsx-2163660362 fa-layers fa-fw",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: `text-${state.viewing === "details" ? "text-brand-primary" : "secondary-gray"}`,
                                            icon: (0, _freeSolidSvgIcons.faCircle),
                                            size: "lg"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faInfo),
                                            color: "white"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2163660362 mt-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-2163660362 " + `mobile-link-text text-nowrap ${state.viewing === "details" ? "text-brand-primary" : "text-icon-link-gray"}`,
                                    children: "Basics"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>toggleView("branding"),
                        className: "jsx-2163660362 btn btn-link d-flex flex-column align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2163660362",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-2163660362 fa-layers fa-fw",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        className: `${state.viewing === "branding" ? "text-brand-primary" : "text-secondary-gray"}`,
                                        icon: (0, _freeSolidSvgIcons.faTag)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2163660362 mt-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-2163660362 " + `mobile-link-text text-nowrap ${state.viewing === "branding" ? "text-brand-primary" : "text-icon-link-gray"}
              `,
                                    children: "Branding"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>toggleView("billing"),
                        className: "jsx-2163660362 btn btn-link d-flex flex-column align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2163660362",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "jsx-2163660362 fa-layers fa-fw",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            className: `text-${state.viewing === "billing" ? "text-brand-primary" : "text-secondary-gray"}`,
                                            icon: (0, _freeSolidSvgIcons.faFileInvoice),
                                            size: "lg"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faInfo),
                                            color: "white"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "jsx-2163660362 mt-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "jsx-2163660362 " + `mobile-link-text text-nowrap ${state.viewing === "billing" ? "text-brand-primary" : "text-icon-link-gray"}`,
                                    children: "Billing"
                                })
                            })
                        ]
                    })
                ]
            }),
            modalBodyStyles,
            modalStyles,
            contentStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2163660362",
                children: ".btn-link.jsx-2163660362{-webkit-text-decoration:none;text-decoration:none;}.page-indicator.jsx-2163660362{left:0;height:20px;width:5px;background-color:var(--brand-primary);color:var(--brand-primary);}.view-link.jsx-2163660362{font-size:0.5rem;color:var(--icon-link-gray);}.view-link.jsx-2163660362:hover{color:var(--text-muted);}.edit-org-content-container.jsx-2163660362{padding:1rem;}.btn.jsx-2163660362{width:80px;}.cancel-button.jsx-2163660362{margin-right:0.5rem;}.mobile-link-text.jsx-2163660362{font-size:0.75rem;font-weight:400;}.form-buttons-container.jsx-2163660362{margin-top:1rem;}side-nav.jsx-2163660362{color:var(--icon-link-gray);}side-nav.jsx-2163660362:hover{color:var(--text-muted);}@media (min-width:768px){.modal-side-nav-container.jsx-2163660362{height:calc(100% - 64px);}.page-indicator.jsx-2163660362{left:0;height:20px;width:5px;background-color:var(--brand-primary);color:var(--brand-primary);}.view-link.jsx-2163660362{font-size:1rem;margin-left:0.25rem;}.edit-org-content-container.jsx-2163660362{padding:2rem;}.btn.jsx-2163660362{width:100px;}.cancel-button.jsx-2163660362{margin-right:2rem;}.form-buttons-container.jsx-2163660362{margin-top:30rem;}}@media (min-width:992px){.modal-side-nav-container.jsx-2163660362{height:auto;}.view-link.jsx-2163660362{font-size:1rem;margin-left:0.5rem;}.form-buttons-container.jsx-2163660362{margin-top:1rem;}}"
            })
        ]
    });
}
EditOrgModal.propTypes = {
    closeModal: (0, _propTypesDefault.default).func,
    currentOrg: (0, _propTypesDefault.default).object,
    handleSubOrgEdit: (0, _propTypesDefault.default).func,
    isOpen: (0, _propTypesDefault.default).bool,
    isSubOrgEdit: (0, _propTypesDefault.default).bool,
    org: (0, _propTypesDefault.default).object,
    toggleModal: (0, _propTypesDefault.default).func,
    updateOrg: (0, _propTypesDefault.default).func
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","reactstrap":"kjd7g","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"k3TAw","../../Constants/RBAC":"ieo1E","../../RBAC/AccessTools":"j912a","../../Services/AccountService":"3PgTR","../../Lib/FileHelpers":"5Iydq","./OrgBilling":"b0bAF","./OrgBranding":"l6F2z","./OrgContactInfo":"4Esac","./OrgFeatures":"8ostm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0bAF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
exports.default = /*#__PURE__*/ (0, _react.memo)(OrgBilling);
const accountOptions = [
    "Dealer",
    "OEM",
    "Operator",
    "Partner"
].map((value)=>({
        label: value,
        value
    }));
const termsOptions = [
    "Pilot",
    "1 Year",
    "2 Year",
    "3 Year"
].map((value)=>({
        label: value,
        value
    }));
function OrgBilling(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "row",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "col-12 form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "account_id",
                        className: "modal-inputlabel-text",
                        children: "Custom Organization or Account ID"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: "form-control form-control-sm modal-placeholder-text",
                        name: "account_id",
                        onChange: props.handlePropUpdate,
                        type: "text",
                        value: props.org?.account_id
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "col-12 form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "subscription_terms",
                        className: "modal-inputlabel-text",
                        children: "Subscription Type"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        classNamePrefix: "select-control",
                        isSearchable: true,
                        maxMenuHeight: 125,
                        name: "subscription_terms",
                        onChange: (selected)=>props.handlePropUpdate({
                                target: {
                                    name: "subscription_terms",
                                    value: selected?.value ?? ""
                                }
                            }),
                        options: termsOptions,
                        placeholder: "Select a Subscription Type",
                        value: termsOptions.find(({ value })=>value === props.org?.subscription_terms)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "col-12 form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "account_type",
                        className: "modal-inputlabel-text",
                        children: "Organization Type"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        classNamePrefix: "select-control",
                        isSearchable: true,
                        maxMenuHeight: 125,
                        name: "account_type",
                        onChange: (selected)=>props.handlePropUpdate({
                                target: {
                                    name: "account_type",
                                    value: selected?.value ?? ""
                                }
                            }),
                        options: accountOptions,
                        placeholder: "Select an Organization Type",
                        value: accountOptions.find(({ value })=>value === props.org?.account_type)
                    })
                ]
            })
        ]
    });
}
OrgBilling.propTypes = {
    handlePropUpdate: (0, _propTypesDefault.default).func,
    org: (0, _propTypesDefault.default).object
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-select":"j36cq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6F2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OrgBranding);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDropzone = require("react-dropzone");
var _reactDropzoneDefault = parcelHelpers.interopDefault(_reactDropzone);
const { className: dropzoneClass, styles: dropzoneStyles } = {
    styles: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
        id: "2713073602",
        children: "div.jsx-2713073602{position:relative;width:100%;height:120px;border-width:3px;border-color:var(--brand-primary);border-style:dashed;border-radius:5px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;color:var(--muted-gray);}div.jsx-2713073602:focus{outline:none;}@media (min-width:768px){div.jsx-2713073602{height:200px;}}"
    }),
    className: "jsx-2713073602"
};
function OrgBranding(props) {
    const { org, onDrop } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "jsx-2524285700 form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2524285700 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "logo",
                            className: "jsx-2524285700",
                            children: "Company Logo"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "jsx-2524285700 row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                marginTop: "0.60rem"
                            },
                            className: "jsx-2524285700 col-12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "jsx-2524285700 row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2524285700 logo-preview col-12 col-md-4 d-flex align-items-center justify-content-start justify-content-md-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: org.logo,
                                            alt: "organization logo",
                                            className: "jsx-2524285700 img-fluid mh-100"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "jsx-2524285700 col-12 col-md-8",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDropzoneDefault.default), {
                                            accept: {
                                                "image/*": []
                                            },
                                            multiple: false,
                                            onDrop: onDrop,
                                            children: ({ getRootProps, getInputProps })=>{
                                                const inputProps = getInputProps();
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    ...getRootProps(),
                                                    className: "jsx-2524285700 " + (dropzoneClass || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            ...inputProps,
                                                            className: "jsx-2524285700 " + (inputProps && inputProps.className != null && inputProps.className || "")
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "jsx-2524285700",
                                                            children: "Drop files here or click to upload."
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            dropzoneStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "2524285700",
                children: ".input-group-text.jsx-2524285700{padding:0;}.logo-preview.jsx-2524285700{width:90%;height:auto;margin-top:1rem;margin-bottom:2rem;}@media (min-width:768px){.logo-preview.jsx-2524285700{height:auto;margin-top:0;margin-bottom:0;}}"
            })
        ]
    });
}
OrgBranding.propTypes = {
    org: (0, _propTypesDefault.default).object,
    onDrop: (0, _propTypesDefault.default).func
};
OrgBranding.defaultProps = {
    org: {
        settings: {}
    }
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","react-dropzone":"9kTqj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Esac":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OrgContactInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _style = require("styled-jsx/style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function OrgContactInfo(props) {
    const { handlePropUpdate, handleSettingsUpdate, handlePhoneNumberUpdate, org } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "jsx-3807502067 row",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-1",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "name",
                            className: "jsx-3807502067",
                            children: "Organization Name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "name",
                            type: "text",
                            value: org.name || "",
                            onChange: handlePropUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "street1",
                            className: "jsx-3807502067",
                            children: "Street Address"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "street1",
                            type: "text",
                            value: org.street1 || "",
                            onChange: handlePropUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "street2",
                            className: "jsx-3807502067",
                            children: "Suite/PO Box"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "street2",
                            type: "text",
                            value: org.street2 || "",
                            onChange: handlePropUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "city",
                            className: "jsx-3807502067",
                            children: "City"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "city",
                            type: "text",
                            value: org.city || "",
                            onChange: handlePropUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "state",
                            className: "jsx-3807502067",
                            children: "State/Province"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "state",
                            type: "text",
                            value: org.state || "",
                            onChange: handlePropUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "zip",
                            className: "jsx-3807502067",
                            children: "Zip Code/Postal Code"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "zip",
                            type: "text",
                            value: org.zip || "",
                            onChange: handlePropUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-7",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "email",
                            className: "jsx-3807502067",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "email",
                            type: "email",
                            value: org.settings?.email || "",
                            onChange: handleSettingsUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "jsx-3807502067 col-12 col-md-6 order-md-8",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "jsx-3807502067 form-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "phoneNumber",
                            className: "jsx-3807502067",
                            children: "Phone Number"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            name: "phoneNumber",
                            type: "text",
                            value: org.phoneNumber || "",
                            onChange: handlePhoneNumberUpdate,
                            className: "jsx-3807502067 form-control"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styleDefault.default), {
                id: "3807502067",
                children: ".form-control.jsx-3807502067:focus{box-shadow:none;}"
            })
        ]
    });
}
OrgContactInfo.propTypes = {
    handlePropUpdate: (0, _propTypesDefault.default).func,
    handleSettingsUpdate: (0, _propTypesDefault.default).func,
    handlePhoneNumberUpdate: (0, _propTypesDefault.default).func,
    org: (0, _propTypesDefault.default).object
};
OrgContactInfo.defaultProps = {
    org: {
        settings: {}
    }
};

},{"react/jsx-runtime":"1dlk8","styled-jsx/style":"6lVCJ","react":"9njXz","prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ostm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSwitch = require("react-switch");
var _reactSwitchDefault = parcelHelpers.interopDefault(_reactSwitch);
var _brandingContext = require("../../Context/BrandingContext");
var _brandingContextDefault = parcelHelpers.interopDefault(_brandingContext);
var _iconsContext = require("../../Context/IconsContext");
var _iconsContextDefault = parcelHelpers.interopDefault(_iconsContext);
exports.default = /*#__PURE__*/ (0, _react.memo)(OrgFeatures);
function OrgFeatures(props) {
    const { primary_alert } = (0, _react.useContext)((0, _brandingContextDefault.default));
    const { cumminsIconBlack } = (0, _react.useContext)((0, _iconsContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "col-12",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "features",
                        className: "modal-inputlabel-text",
                        children: "Features Available"
                    }),
                    !props.orgHasBillingEnabled && props.hasBilling ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                onChange: (e)=>props.handleFeaturesUpdate({
                                        target: {
                                            name: "billingEnabled",
                                            value: e
                                        }
                                    }),
                                checked: props.billingEnabled,
                                checkedIcon: false,
                                uncheckedIcon: false,
                                height: 15,
                                width: 30,
                                onColor: primary_alert,
                                id: "billingEnabled-toggle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 ml-4 modal-inputlabel-text",
                                children: "Billing and Subscriptions"
                            })
                        ]
                    }) : null,
                    props.hasRemote ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                onChange: (e)=>props.handleFeaturesUpdate({
                                        target: {
                                            name: "remote",
                                            value: e
                                        }
                                    }),
                                checked: props.remote,
                                checkedIcon: false,
                                uncheckedIcon: false,
                                height: 15,
                                width: 30,
                                onColor: primary_alert,
                                id: "remote-toggle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 ml-4 modal-inputlabel-text",
                                children: "Command and Control"
                            })
                        ]
                    }) : null,
                    props.hasCumminsenabled ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                onChange: (e)=>props.handleFeaturesUpdate({
                                        target: {
                                            name: "cumminsenabled",
                                            value: e
                                        }
                                    }),
                                checked: props.cumminsenabled,
                                checkedIcon: false,
                                uncheckedIcon: false,
                                height: 15,
                                width: 30,
                                onColor: primary_alert,
                                id: "cumminsenabled-toggle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "ml-4 d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        alt: "cummins logo",
                                        height: 20,
                                        src: cumminsIconBlack,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "mb-0 ml-1 modal-inputlabel-text",
                                        children: "Connected Diagnostics"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    props.hasCsvReports ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                onChange: (e)=>props.handleFeaturesUpdate({
                                        target: {
                                            name: "csvExport",
                                            value: e
                                        }
                                    }),
                                checked: props.csvExport,
                                checkedIcon: false,
                                uncheckedIcon: false,
                                height: 15,
                                width: 30,
                                onColor: primary_alert,
                                id: "csvExport-toggle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 ml-4 modal-inputlabel-text",
                                children: "Fleet CSV Exports"
                            })
                        ]
                    }) : null,
                    props.hasMaintenanceV1 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                onChange: (e)=>props.handleFeaturesUpdate({
                                        target: {
                                            name: "maintenance_v1",
                                            value: e
                                        }
                                    }),
                                checked: props.maintenance_v1,
                                checkedIcon: false,
                                uncheckedIcon: false,
                                height: 15,
                                width: 30,
                                onColor: primary_alert,
                                id: "maintenance-v1-toggle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 ml-4 modal-inputlabel-text",
                                children: "Maintenance v1"
                            })
                        ]
                    }) : null,
                    props.hasMaintenanceV1 && props.hasParts ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center mb-2 ml-5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                onChange: (e)=>props.handleFeaturesUpdate({
                                        target: {
                                            name: "parts",
                                            value: e
                                        }
                                    }),
                                checked: props.parts,
                                checkedIcon: false,
                                uncheckedIcon: false,
                                height: 15,
                                width: 30,
                                onColor: primary_alert,
                                id: "parts-toggle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 ml-4 modal-inputlabel-text",
                                children: "Maintenance Parts"
                            })
                        ]
                    }) : null,
                    props.hasMaintenanceV2 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "d-flex align-items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSwitchDefault.default), {
                                onChange: (e)=>props.handleFeaturesUpdate({
                                        target: {
                                            name: "maintenance_v2",
                                            value: e
                                        }
                                    }),
                                checked: props.maintenance_v2,
                                checkedIcon: false,
                                uncheckedIcon: false,
                                height: 15,
                                width: 30,
                                onColor: primary_alert,
                                id: "maintenance-v2-toggle"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mb-0 ml-4 modal-inputlabel-text",
                                children: "Maintenance v2"
                            })
                        ]
                    }) : null
                ]
            })
        })
    });
}
OrgFeatures.propTypes = {
    billingEnabled: (0, _propTypesDefault.default).bool,
    csvExport: (0, _propTypesDefault.default).bool,
    cumminsenabled: (0, _propTypesDefault.default).bool,
    handleFeaturesUpdate: (0, _propTypesDefault.default).func,
    hasBilling: (0, _propTypesDefault.default).bool,
    hasCsvReports: (0, _propTypesDefault.default).bool,
    hasCumminsenabled: (0, _propTypesDefault.default).bool,
    hasMaintenanceV1: (0, _propTypesDefault.default).bool,
    hasMaintenanceV2: (0, _propTypesDefault.default).bool,
    hasParts: (0, _propTypesDefault.default).bool,
    hasRemote: (0, _propTypesDefault.default).bool,
    maintenance_v1: (0, _propTypesDefault.default).bool,
    maintenance_v2: (0, _propTypesDefault.default).bool,
    orgHasBillingEnabled: (0, _propTypesDefault.default).bool,
    parts: (0, _propTypesDefault.default).bool,
    remote: (0, _propTypesDefault.default).bool
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","react-switch":"7hX7V","../../Context/BrandingContext":"bKKTd","../../Context/IconsContext":"lzIpe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ed3Vy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
class ImageErrorBoundary extends (0, _react.Component) {
    static propTypes = {
        children: (0, _propTypesDefault.default).node,
        color: (0, _propTypesDefault.default).string,
        icon: (0, _propTypesDefault.default).object,
        iconClassName: (0, _propTypesDefault.default).string,
        iconSize: (0, _propTypesDefault.default).string
    };
    state = {
        hasError: false
    };
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    render() {
        return this.state.hasError ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            className: this.props.iconClassName,
            color: this.props.color,
            icon: this.props.icon,
            size: this.props.iconSize
        }) : this.props.children;
    }
}
exports.default = ImageErrorBoundary;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@fortawesome/react-fontawesome":"32SD5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5NOrc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ASSETS", ()=>ASSETS);
parcelHelpers.export(exports, "ASSET_MODELS", ()=>ASSET_MODELS);
parcelHelpers.export(exports, "GEOFENCES", ()=>GEOFENCES);
parcelHelpers.export(exports, "SUB_ORGS", ()=>SUB_ORGS);
parcelHelpers.export(exports, "USERS", ()=>USERS);
parcelHelpers.export(exports, "USER_PROFILES", ()=>USER_PROFILES);
const ASSETS = "assets";
const ASSET_MODELS = "asset-models";
const GEOFENCES = "geofences";
const SUB_ORGS = "sub-orgs";
const USERS = "users";
const USER_PROFILES = "user-profiles";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c38es":[function(require,module,exports) {
module.exports = require("aef03ba21b072cbc")(require("e3edfa38b32049ae").resolve("e8Xsz")).then(()=>module.bundle.root("5iECb"));

},{"aef03ba21b072cbc":"9wKyf","e3edfa38b32049ae":"gSiLw"}],"i80mu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandleSubOrgDeleteContext", ()=>HandleSubOrgDeleteContext);
parcelHelpers.export(exports, "HandleSubOrgDeleteProvider", ()=>HandleSubOrgDeleteProvider);
parcelHelpers.export(exports, "HandleSubOrgDeleteConsumer", ()=>HandleSubOrgDeleteConsumer);
var _react = require("react");
const HandleSubOrgDeleteContext = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const HandleSubOrgDeleteProvider = HandleSubOrgDeleteContext.Provider;
const HandleSubOrgDeleteConsumer = HandleSubOrgDeleteContext.Consumer;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHIjM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PermissionsProvider", ()=>PermissionsProvider);
parcelHelpers.export(exports, "PermissionsConsumer", ()=>PermissionsConsumer);
var _react = require("react");
const PermissionsContext = /*#__PURE__*/ (0, _react.createContext)();
const PermissionsProvider = PermissionsContext.Provider;
const PermissionsConsumer = PermissionsContext.Consumer;
exports.default = PermissionsContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cXMv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResetGlobalStateContext", ()=>ResetGlobalStateContext);
parcelHelpers.export(exports, "ResetGlobalStateProvider", ()=>ResetGlobalStateProvider);
parcelHelpers.export(exports, "ResetGlobalStateConsumer", ()=>ResetGlobalStateConsumer);
var _react = require("react");
const ResetGlobalStateContext = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const ResetGlobalStateProvider = ResetGlobalStateContext.Provider;
const ResetGlobalStateConsumer = ResetGlobalStateContext.Consumer;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LeTfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateCurrentUserProvider", ()=>UpdateCurrentUserProvider);
parcelHelpers.export(exports, "UpdateCurrentUserConsumer", ()=>UpdateCurrentUserConsumer);
var _react = require("react");
const UpdateCurrentUserContext = /*#__PURE__*/ (0, _react.createContext)(()=>{});
const UpdateCurrentUserProvider = UpdateCurrentUserContext.Provider;
const UpdateCurrentUserConsumer = UpdateCurrentUserContext.Consumer;
exports.default = UpdateCurrentUserContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8DVeH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserProvider", ()=>UserProvider);
parcelHelpers.export(exports, "UserConsumer", ()=>UserConsumer);
var _react = require("react");
const UserContext = /*#__PURE__*/ (0, _react.createContext)({
    _id: "",
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    rootOrgID: "",
    locale: "",
    Orgs: [
        {
            _id: "",
            name: "",
            path: "",
            logo: "",
            OrgUser: {},
            settings: {
                headerColor: "",
                termsAndConditions: {
                    _id: "",
                    template: "",
                    version: ""
                }
            }
        }
    ]
});
const UserProvider = UserContext.Provider;
const UserConsumer = UserContext.Consumer;
exports.default = UserContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b8beP":[function(require,module,exports) {
module.exports = require("ff03d0885747bdb8").getBundleURL("cqLDD") + "alarm.b8bf4864.png";

},{"ff03d0885747bdb8":"a2ypy"}],"chbnG":[function(require,module,exports) {
module.exports = require("d0583d068fc72eae").getBundleURL("cqLDD") + "new_alert_header_desktop.7a5b8b0f.svg";

},{"d0583d068fc72eae":"a2ypy"}],"kt4EW":[function(require,module,exports) {
module.exports = require("b28870aaf85ee725").getBundleURL("cqLDD") + "new_alert_header.4113bee8.svg";

},{"b28870aaf85ee725":"a2ypy"}],"btpve":[function(require,module,exports) {
module.exports = require("699eac9629b4e7b1").getBundleURL("cqLDD") + "AssetIconRed.3c550fa7.png";

},{"699eac9629b4e7b1":"a2ypy"}],"3zu8Y":[function(require,module,exports) {
module.exports = require("78f069ca7756cbd8").getBundleURL("cqLDD") + "Asset_Icon_White.26535641.png";

},{"78f069ca7756cbd8":"a2ypy"}],"giZVQ":[function(require,module,exports) {
module.exports = require("5169bb7b7f0dfb20").getBundleURL("cqLDD") + "AssetModel_Icon.7c414484.png";

},{"5169bb7b7f0dfb20":"a2ypy"}],"gq0Wu":[function(require,module,exports) {
module.exports = require("8593c41e21129020").getBundleURL("cqLDD") + "AssetModel_Icon_White.fe1a31e4.png";

},{"8593c41e21129020":"a2ypy"}],"kcfSA":[function(require,module,exports) {
module.exports = require("443ac2fe99dfe4c9").getBundleURL("cqLDD") + "Profile_Icon.9c7ddfcc.png";

},{"443ac2fe99dfe4c9":"a2ypy"}],"fIi51":[function(require,module,exports) {
module.exports = require("40afe47a11c5bb70").getBundleURL("cqLDD") + "Certificate_Icon.75a29e01.png";

},{"40afe47a11c5bb70":"a2ypy"}],"5xpAz":[function(require,module,exports) {
module.exports = require("f4c44f27de858462").getBundleURL("cqLDD") + "Chart_Icon.219abf0d.png";

},{"f4c44f27de858462":"a2ypy"}],"aMouh":[function(require,module,exports) {
module.exports = require("17adc8aeaba03406").getBundleURL("cqLDD") + "CommandControl_Icon.35b84d6a.png";

},{"17adc8aeaba03406":"a2ypy"}],"gA93y":[function(require,module,exports) {
module.exports = require("c992f02b62d64a95").getBundleURL("cqLDD") + "Conditions_Icon.b8a991c9.png";

},{"c992f02b62d64a95":"a2ypy"}],"bYsT4":[function(require,module,exports) {
module.exports = require("fdeb77f9098f0d6b").getBundleURL("cqLDD") + "cummins_banner_desktop.84d2639b.svg";

},{"fdeb77f9098f0d6b":"a2ypy"}],"2k9GL":[function(require,module,exports) {
module.exports = require("3943eace0d0f5947").getBundleURL("cqLDD") + "cummins_banner_mobile.ad2f2e43.svg";

},{"3943eace0d0f5947":"a2ypy"}],"kGXJp":[function(require,module,exports) {
module.exports = require("d77b4bb5a0f39398").getBundleURL("cqLDD") + "cummins_logo_black.997e665a.png";

},{"d77b4bb5a0f39398":"a2ypy"}],"e2hbR":[function(require,module,exports) {
module.exports = require("2dd8b02b2709a586").getBundleURL("cqLDD") + "cummins_logo_white.cf7c2eb0.png";

},{"2dd8b02b2709a586":"a2ypy"}],"65l6N":[function(require,module,exports) {
module.exports = require("1c0e09a71bd936d").getBundleURL("cqLDD") + "Icon_EmptyState.daceaa00.svg";

},{"1c0e09a71bd936d":"a2ypy"}],"k5dC7":[function(require,module,exports) {
module.exports = require("d4b60f5b770f26bd").getBundleURL("cqLDD") + "car-engine.acc5e126.svg";

},{"d4b60f5b770f26bd":"a2ypy"}],"aWTS6":[function(require,module,exports) {
module.exports = require("a2525dca60c40728").getBundleURL("cqLDD") + "404_Icon.27444c3a.png";

},{"a2525dca60c40728":"a2ypy"}],"2VqkB":[function(require,module,exports) {
module.exports = require("94cee38575b7add8").getBundleURL("cqLDD") + "Events_Icon_White.d7e3821a.png";

},{"94cee38575b7add8":"a2ypy"}],"jS8L6":[function(require,module,exports) {
module.exports = require("9bd1252f6415468d").getBundleURL("cqLDD") + "FleetOverview_Icon.ea886e8f.png";

},{"9bd1252f6415468d":"a2ypy"}],"iihRO":[function(require,module,exports) {
module.exports = require("e8c52149a5106383").getBundleURL("cqLDD") + "GeofencingBlue_Icon.f3c793d5.png";

},{"e8c52149a5106383":"a2ypy"}],"lA2rM":[function(require,module,exports) {
module.exports = require("6ad172ec8ee1de99").getBundleURL("cqLDD") + "GeofencingWhite_Icon.ca5f6fd2.png";

},{"6ad172ec8ee1de99":"a2ypy"}],"6sQbK":[function(require,module,exports) {
module.exports = require("a336468442083b2").getBundleURL("cqLDD") + "group.950c679b.png";

},{"a336468442083b2":"a2ypy"}],"6Baon":[function(require,module,exports) {
module.exports = require("7486a5fc44ef2934").getBundleURL("cqLDD") + "MaintenanceSchedule_EmptyIcon.c5ed855a.png";

},{"7486a5fc44ef2934":"a2ypy"}],"krJx6":[function(require,module,exports) {
module.exports = require("3c84c40ef7afb5bf").getBundleURL("cqLDD") + "MaintenanceSchedule_Icon_White.4e0792ff.png";

},{"3c84c40ef7afb5bf":"a2ypy"}],"gcu4R":[function(require,module,exports) {
module.exports = require("4e6d1ea860340c18").getBundleURL("cqLDD") + "small.31b16c60.png";

},{"4e6d1ea860340c18":"a2ypy"}],"d11iF":[function(require,module,exports) {
module.exports = require("4a099c796879774d").getBundleURL("cqLDD") + "missing.fa8f3600.png";

},{"4a099c796879774d":"a2ypy"}],"imG8w":[function(require,module,exports) {
module.exports = require("d3a4262997c69d3f").getBundleURL("cqLDD") + "Modbus_Icon.b588ed78.png";

},{"d3a4262997c69d3f":"a2ypy"}],"fb9TB":[function(require,module,exports) {
module.exports = require("d113f5c5d449a69").getBundleURL("cqLDD") + "offline.d474c3f3.png";

},{"d113f5c5d449a69":"a2ypy"}],"c1css":[function(require,module,exports) {
module.exports = require("58963fe8f61e6129").getBundleURL("cqLDD") + "default.e12aade0.png";

},{"58963fe8f61e6129":"a2ypy"}],"eR8Lo":[function(require,module,exports) {
module.exports = require("4c0f98e9978fad83").getBundleURL("cqLDD") + "Organization_Icon.e48ae46e.png";

},{"4c0f98e9978fad83":"a2ypy"}],"icguo":[function(require,module,exports) {
module.exports = require("929d71823c6b9953").getBundleURL("cqLDD") + "Organization_Icon_White.9d593d8a.png";

},{"929d71823c6b9953":"a2ypy"}],"eoIMD":[function(require,module,exports) {
module.exports = require("9b57fd29c5b9f89c").getBundleURL("cqLDD") + "PartsBlue_Icon.d48ec815.png";

},{"9b57fd29c5b9f89c":"a2ypy"}],"dhkXR":[function(require,module,exports) {
module.exports = require("30b2cf8b43527fdc").getBundleURL("cqLDD") + "PartsGrey_Icon.dd48ffa0.png";

},{"30b2cf8b43527fdc":"a2ypy"}],"7XIwm":[function(require,module,exports) {
module.exports = require("dc4100cd0c752d25").getBundleURL("cqLDD") + "primary_link.3f99d943.png";

},{"dc4100cd0c752d25":"a2ypy"}],"2w1dR":[function(require,module,exports) {
module.exports = require("4da304ffb86d611c").getBundleURL("cqLDD") + "AssetProvisioningIcon.8b615f9a.png";

},{"4da304ffb86d611c":"a2ypy"}],"6a8pG":[function(require,module,exports) {
module.exports = require("74db111b9d307298").getBundleURL("cqLDD") + "AssetProvisioningIcon_White.4841ef01.png";

},{"74db111b9d307298":"a2ypy"}],"40L5P":[function(require,module,exports) {
module.exports = require("132fec0ac5c42e41").getBundleURL("cqLDD") + "pump-icon.8fccb34f.png";

},{"132fec0ac5c42e41":"a2ypy"}],"fN24t":[function(require,module,exports) {
module.exports = require("c605b9ea51a4b415").getBundleURL("cqLDD") + "Reminder_Icon.220c0325.png";

},{"c605b9ea51a4b415":"a2ypy"}],"8jp9H":[function(require,module,exports) {
module.exports = require("590293a545c528d5").getBundleURL("cqLDD") + "Reporting_Icon.b5f11b40.png";

},{"590293a545c528d5":"a2ypy"}],"3Imuy":[function(require,module,exports) {
module.exports = require("b60e6fd464134c7b").getBundleURL("cqLDD") + "Search_Icon.90759a1e.png";

},{"b60e6fd464134c7b":"a2ypy"}],"4F5bQ":[function(require,module,exports) {
module.exports = require("817b00d0bf2dca9d").getBundleURL("cqLDD") + "Search_Icon_Large.8ae59eef.png";

},{"817b00d0bf2dca9d":"a2ypy"}],"8dr9N":[function(require,module,exports) {
module.exports = require("4c44f559d11b737").getBundleURL("cqLDD") + "datapoint.1fc0b841.png";

},{"4c44f559d11b737":"a2ypy"}],"1LC3N":[function(require,module,exports) {
module.exports = require("4e5a680646376ed2").getBundleURL("cqLDD") + "Signal_Icon_White.eeeebd55.png";

},{"4e5a680646376ed2":"a2ypy"}],"cwdod":[function(require,module,exports) {
module.exports = require("941b9e542c75f35d").getBundleURL("cqLDD") + "Users_Icon.f4973156.png";

},{"941b9e542c75f35d":"a2ypy"}],"i5eGq":[function(require,module,exports) {
module.exports = require("4b0e9d95c5023b7").getBundleURL("cqLDD") + "Users_Icon_White.4c57cf44.png";

},{"4b0e9d95c5023b7":"a2ypy"}],"ahTto":[function(require,module,exports) {
module.exports = require("c255270c46d4115d").getBundleURL("cqLDD") + "widget-icon.610492aa.png";

},{"c255270c46d4115d":"a2ypy"}],"1ZvQt":[function() {},{}],"1NSLy":[function() {},{}],"chsuV":[function() {},{}],"lP6kO":[function(require,module,exports) {
module.exports = require("710418872c156656")(require("689c136ab3dd82bd").resolve("eznnj"));

},{"710418872c156656":"4NBCd","689c136ab3dd82bd":"gSiLw"}],"Gf03C":[function(require,module,exports) {
module.exports = require("65b8be3b2e844279")(require("d9bfff99336655cb").resolve("3oWye"));

},{"65b8be3b2e844279":"4NBCd","d9bfff99336655cb":"gSiLw"}],"ibQl8":[function(require,module,exports) {
module.exports = require("fb9f56bca13baafd")(require("d47c1791fceba3c").resolve("lrJpX"));

},{"fb9f56bca13baafd":"4NBCd","d47c1791fceba3c":"gSiLw"}],"jxRrK":[function(require,module,exports) {
module.exports = require("ca7c20b0d9d36fee")(require("3f0a2997ba582ac9").resolve("fb41D"));

},{"ca7c20b0d9d36fee":"4NBCd","3f0a2997ba582ac9":"gSiLw"}],"5UihQ":[function(require,module,exports) {
module.exports = require("2a58c883ecc7150d")(require("acd37c097bd0fa6f").resolve("4J6r3"));

},{"2a58c883ecc7150d":"4NBCd","acd37c097bd0fa6f":"gSiLw"}],"jRKwH":[function(require,module,exports) {
module.exports = require("14e22ef57c22acdf")(require("5af13f479fefab21").resolve("1PCPG"));

},{"14e22ef57c22acdf":"4NBCd","5af13f479fefab21":"gSiLw"}],"1B2hk":[function(require,module,exports) {
module.exports = require("7f269a0b405b80c7")(require("e1c6cd365b2ad71f").resolve("9Fh0I"));

},{"7f269a0b405b80c7":"4NBCd","e1c6cd365b2ad71f":"gSiLw"}]},["3jPRK"], "3jPRK", "parcelRequire287b")

//# sourceMappingURL=index.53bfcfd6.js.map
